export class Appconstant {
  CHARITY_BUTTON: Array<{ buttonLabel: string; routingUrl: string }> = [
    {
      buttonLabel: "SPECTRUM",
      routingUrl: "/charity/spectrum-child-development-research-center",
    },
    { buttonLabel: "FREE DIALYSIS", routingUrl: "/charity/free-dialysis" },
    { buttonLabel: "HEART TO HEART", routingUrl: "/charity/heart-to-heart" },
    {
      buttonLabel: "FREE CIVIL SERVICE COACHING",
      routingUrl: "/charity/free-civil-service-coaching",
    },
    {
      buttonLabel: "SAPLING FOR A NEW BORN BABY",
      routingUrl: "/charity/sapling-for-new-born-baby",
    },
    {
      buttonLabel: "EDUCATION SCHOLARSHIP UNDER NIU",
      routingUrl: "/charity/education-scholarship-under-niu",
    },
    {
      buttonLabel: "FREE HEARING AID",
      routingUrl: "/charity/free-hearing-aid",
    },
    {
      buttonLabel: "FREE MEDICINE FOR HIV PATIENTS",
      routingUrl: "/charity/free-medicine-for-hiv-patients",
    },
    {
      buttonLabel: "NUTRIENTS FOOD FOR CANCER PATIENTS",
      routingUrl: "/charity/Nutritious-food-for-cancer-patients",
    },
    { buttonLabel: "HARITHAKAM", routingUrl: "/charity/harithakam" },
    { buttonLabel: "T.I.G.E.R", routingUrl: "/charity/Tiger" },
    { buttonLabel: "SAHYADRI", routingUrl: "/charity/shayadri" },
    {
      buttonLabel: "FREE MEDICAL CAMPS",
      routingUrl: "/charity/free-medical-camps",
    },
    { buttonLabel: "PADANOLSAVAM", routingUrl: "/charity/padanolsavam" },
    { buttonLabel: "NANO CLINIC", routingUrl: "/charity/nano-clinic" },
    { buttonLabel: "NIMS ANNAPOORNA", routingUrl: "/charity/annapoorna" },
    {
      buttonLabel: "NEYYANTINKARA PENSION SCHEME",
      routingUrl:
        "/charity/Neyyattinkara-Pension-Plan-Free-pension-for-Differently-abled-children",
    },
    {
      buttonLabel: "YOUTH RED CROSS",
      routingUrl: "/charity/youth-red-cross",
    },
    {
      buttonLabel: "NIMS KHADI MOVEMENT",
      routingUrl: "/charity/nims-khadi-movement",
    },
  ];
  MEDIA_BUTTON: Array<{ buttonLabel: string }> = [
    { buttonLabel: "World Heart Day Celebrations" },
    { buttonLabel: "Run for Health programme" },
    { buttonLabel: "Wishes for a Corruption free INDIA by 2016 " },
    { buttonLabel: "Childrens Day Celebration " },
    { buttonLabel: "See all" },
  ];
  EVENT_BUTTON: Array<{ buttonLabel: string; routingUrl: string }> = [
    { buttonLabel: "PAST EVENTS", routingUrl: "/events/past-events" },
    { buttonLabel: "UPCOMING EVENTS", routingUrl: "/events/up-coming-events" },
  ];
  CONTACTUS_BUTTON: Array<{ buttonLabel: string; routingUrl: string }> = [
    {
      buttonLabel: "NIMS HOSPITAL",
      routingUrl: "/contact-us/https://www.nimshospital.com/",
    },
    {
      buttonLabel: "NOORUL ISLAM UNIVERSITY",
      routingUrl: "https://www.nimshospital.com/",
    },
  ];
  SERVICES_BUTTON: Array<{ buttonLabel: string }> = [
    { buttonLabel: "Contact us" },
    { buttonLabel: "Nims hospital" },
    { buttonLabel: "NICS" },
  ];
  DASHBORD_GALLERY: Array<{ src: string; caption: string; thumb: string }> = [
    {
      src: "assets/img/homegal/16.jpg",
      caption: "",
      thumb: "assets/img/homegal/16.jpg",
    },
    {
      src: "assets/img/Pastevents/178.jpg",
      caption:
        " Camp was inaugurated by Sri Sivankutty (Education Minister). Felicitated by Sri C K Hareendran (MLA,Parassala), Dr Asher Ennis Nayagam (Cardiovascular & VATS Surgeon, Nims Medicity).",
      thumb: "assets/img/Pastevents/09-11-2021.png",
    },
    {
      src: "assets/img/homegal/13.jpeg",
      caption:
        "ബാലികസദനത്തിന് NIMS Medicity നൽകിയ ധനസഹായം ഹിന്ദു ഐക്യ വേദി ജില്ലാ പ്രസിഡന്റ് Advocate N.K.Retnakumar ബാലികസദനത്തിന്റെ അധ്യക്ഷനെ ഏല്പിക്കുന്ന ചടങ്ങ്.",
      thumb: "assets/img/homegal/13.jpeg",
    },

    {
      src: "assets/img/homegal/15.jpeg",
      caption:
        "Handing over financial support to the president of breezeland association  Mr Abdullah Sait for Omana and family residing in the same residents association.",
      thumb: "assets/img/homegal/15.jpeg",
    },
    {
      src: "assets/img/homegal/1.jpg",
      caption: "1",
      thumb: "assets/img/homegal/1.jpg",
    },
    {
      src: "assets/img/homegal/2.jpg",
      caption: "2",
      thumb: "assets/img/homegal/2.jpg",
    },
    {
      src: "assets/img/Pastevents/64.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയിൽ ലോക വൃക്ക ദിനം ആചരിച്ചു.മെഡിക്കൽ ക്യാമ്പ് കലാ കൗമുദി അസിസ്റ്റന്റ് എഡിറ്റർ ശ്രീമതി വത്സാ മണി ഉദ്‌ഘാടനം ചെയ്തു.നിംസ് മെഡിസിറ്റി മാനേജിങ് ഡയറക്ടർ ശ്രി എം എസ് ഫൈസൽ ഖാൻ അധ്യക്ഷം വഹിച്ച യോഗത്തിൽ Dr. മഞ്ജു തമ്പി, ചീഫ് നേഫ്റോളജിസ്റ്റ്, Dr. ലക്ഷ്മി എസ് നായർ, Consultant-ക്ലിനിക്കൽ ജനറ്റിക്സ്, ശ്രി നൗഷാദ് അലി, ശ്രി ശിവകുമാർ രാജ്, Dr. കെ. എ സജു തുടങ്ങിയവർ സംബന്ധിച്ചു.",
      thumb: "assets/img/Pastevents/178.jpg",
    },
    {
      src: "assets/img/homegal/4.jpg",
      caption: "4",
      thumb: "assets/img/homegal/4.jpg",
    },
    {
      src: "assets/img/homegal/5.jpg",
      caption: "5",
      thumb: "assets/img/homegal/5.jpg",
    },
    {
      src: "assets/img/homegal/6.jpeg",
      caption:
        "Nims spectrum Distribute free Hearing Aid on Dec 3rd, World Hearing Day",
      thumb: "assets/img/homegal/6.jpeg",
    },
    {
      src: "assets/img/homegal/7.jpg",
      caption: "7",
      thumb: "assets/img/homegal/7.jpg",
    },
    {
      src: "assets/img/homegal/8.jpg",
      caption: "8",
      thumb: "assets/img/homegal/8.jpg",
    },
    {
      src: "assets/img/homegal/9.JPG",
      caption: "9",
      thumb: "assets/img/homegal/9.JPG",
    },
    {
      src: "assets/img/homegal/10.JPG",
      caption: "10",
      thumb: "assets/img/homegal/10.JPG",
    },
    {
      src: "assets/img/homegal/11.jpg",
      caption: "11",
      thumb: "assets/img/homegal/11.jpg",
    },
    {
      src: "assets/img/homegal/12.jpg",
      caption: "12",
      thumb: "assets/img/homegal/12.jpg",
    },
  ];

  YRC_GALLERY: Array<{ src: string; caption: string; thumb: string }> = [
    {
      src: "assets/img/yrc/yrc programme/173-1/1.jpeg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/173-1/1.jpeg",
    },
    {
      src: "assets/img/yrc/yrc programme/173-1/2.jpeg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/173-1/2.jpeg",
    },
    {
      src: "assets/img/yrc/yrc programme/173-1/3.jpeg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/173-1/3.jpeg",
    },
    {
      src: "assets/img/yrc/yrc programme/173-1/4.jpeg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/173-1/4.jpeg",
    },
    {
      src: "assets/img/yrc/yrc programme/173-1/5.jpeg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/173-1/5.jpeg",
    },
    {
      src: "assets/img/yrc/yrc programme/173-1/6.jpeg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/173-1/6.jpeg",
    },
    {
      src: "assets/img/yrc/yrc programme/173-1/7.jpeg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/173-1/7.jpeg",
    },
    {
      src: "assets/img/yrc/yrc programme/173-1/8.jpeg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/173-1/8.jpeg",
    },
    {
      src: "assets/img/yrc/yrc programme/173-1/9.jpeg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/173-1/9.jpeg",
    },
    {
      src: "assets/img/yrc/yrc programme/173-1/10.jpeg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/173-1/10.jpeg",
    },
    {
      src: "assets/img/yrc/yrc programme/173-1/11.jpeg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/173-1/11.jpeg",
    },
    {
      src: "assets/img/yrc/yrc programme/173-1/12.jpeg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/173-1/12.jpeg",
    },
    {
      src: "assets/img/yrc/yrc programme/133/1.jpeg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/133/1.jpeg",
    },
    {
      src: "assets/img/yrc/yrc programme/133/2.jpeg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/133/2.jpeg",
    },
    {
      src: "assets/img/yrc/yrc programme/133/3.jpeg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/133/3.jpeg",
    },
    {
      src: "assets/img/yrc/yrc programme/133/4.jpeg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/133/4.jpeg",
    },
    {
      src: "assets/img/yrc/yrc programme/132/1.jpeg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/132/1.jpeg",
    },
    {
      src: "assets/img/yrc/yrc programme/132/2.jpeg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/132/2.jpeg",
    },
    {
      src: "assets/img/yrc/yrc programme/132/3.jpeg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/132/3.jpeg",
    },
    {
      src: "assets/img/yrc/yrc programme/132/4.jpeg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/132/4.jpeg",
    },
    {
      src: "assets/img/yrc/yrc programme/112/1.jpeg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/112/1.jpeg",
    },
    {
      src: "assets/img/yrc/yrc programme/112/2.jpeg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/112/2.jpeg",
    },
    {
      src: "assets/img/yrc/yrc programme/112/3.jpeg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/112/3.jpeg",
    },
    {
      src: "assets/img/yrc/yrc programme/112/4.jpeg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/112/4.jpeg",
    },
    {
      src: "assets/img/yrc/yrc programme/82/1.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/82/1.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/82/2.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/82/2.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/82/3.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/82/3.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/82/4.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/82/4.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/82/5.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/82/5.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/82/6.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/82/6.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/82/7.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/82/7.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/82/8.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/82/8.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/82/9.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/82/9.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/82/10.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/82/10.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/80/1.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/80/1.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/80/2.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/80/2.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/80/3.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/80/3.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/80/4.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/80/4.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/80/5.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/80/5.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/80/6.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/80/6.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/80/7.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/80/7.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/80/8.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/80/8.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/80/9.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/80/9.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/80/10.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/80/10.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/69/1.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/69/1.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/69/2.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/69/2.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/69/3.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/69/3.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/69/4.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/69/4.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/68/1.jpeg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/68/1.jpeg",
    },
    {
      src: "assets/img/yrc/yrc programme/68/2.jpeg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/68/2.jpeg",
    },
    {
      src: "assets/img/yrc/yrc programme/67/1.jpeg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/67/1.jpeg",
    },
    {
      src: "assets/img/yrc/yrc programme/67/2.jpeg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/67/2.jpeg",
    },
    {
      src: "assets/img/yrc/yrc programme/66/1.jpeg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/66/1.jpeg",
    },
    {
      src: "assets/img/yrc/yrc programme/66/1.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/66/1.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/65/1.jpeg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/65/1.jpeg",
    },
    {
      src: "assets/img/yrc/yrc programme/65/2.jpeg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/65/2.jpeg",
    },
    {
      src: "assets/img/yrc/yrc programme/65/3.jpeg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/65/3.jpeg",
    },

    {
      src: "assets/img/yrc/yrc programme/58/1.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/58/1.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/58/2.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/58/2.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/51/1.jpeg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/51/1.jpeg",
    },
    {
      src: "assets/img/yrc/yrc programme/51/2.jpeg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/51/2.jpeg",
    },
    {
      src: "assets/img/yrc/yrc programme/47/1.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/47/1.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/47/2.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/47/2.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/47/3.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/47/3.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/47/4.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/47/4.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/47/5.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/47/5.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/47/6.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/47/6.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/47/7.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/47/7.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/47/8.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/47/8.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/47/9.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/47/9.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/47/10.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/47/10.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/47/11.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/47/11.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/47/12.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/47/12.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/47/13.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/47/13.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/47/14.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/47/14.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/47/15.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/47/15.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/47/16.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/47/16.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/47/17.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/47/17.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/47/18.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/47/18.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/47/19.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/47/19.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/47/20.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/47/20.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/47/21.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/47/21.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/45/1.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/45/1.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/45/2.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/45/2.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/45/3.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/45/3.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/45/4.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/45/4.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/45/5.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/45/5.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/45/6.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/45/6.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/45/7.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/45/7.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/45/8.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/45/8.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/45/9.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/45/9.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/45/10.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/45/10.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/45/11.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/45/11.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/45/12.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/45/12.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/45/13.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/45/13.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/45/14.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/45/14.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/45/15.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/45/15.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/45/16.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/45/16.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/45/17.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/45/17.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/45/18.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/45/18.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/45/19.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/45/19.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/45/20.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/45/20.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/45/21.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/45/21.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/43/1.jpeg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/43/1.jpeg",
    },
    {
      src: "assets/img/yrc/yrc programme/43/2.jpeg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/43/2.jpeg",
    },

    {
      src: "assets/img/yrc/yrc programme/43/3.jpeg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/43/3.jpeg",
    },

    {
      src: "assets/img/yrc/yrc programme/43/4.jpeg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/43/4.jpeg",
    },
    {
      src: "assets/img/yrc/yrc programme/42/1.jpeg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/42/1.jpeg",
    },
    {
      src: "assets/img/yrc/yrc programme/42/2.jpeg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/42/2.jpeg",
    },
    {
      src: "assets/img/yrc/yrc programme/42/3.jpeg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/42/3.jpeg",
    },
    {
      src: "assets/img/yrc/yrc programme/41/1.jpeg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/41/1.jpeg",
    },
    {
      src: "assets/img/yrc/yrc programme/41/2.jpeg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/41/2.jpeg",
    },

    {
      src: "assets/img/yrc/yrc programme/41/3.jpeg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/41/3.jpeg",
    },

    {
      src: "assets/img/yrc/yrc programme/41/4.jpeg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/41/4.jpeg",
    },
    {
      src: "assets/img/yrc/yrc programme/40/1.jpeg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/40/1.jpeg",
    },
    {
      src: "assets/img/yrc/yrc programme/40/2.jpeg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/40/2.jpeg",
    },

    {
      src: "assets/img/yrc/yrc programme/40/3.jpeg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/40/3.jpeg",
    },

    {
      src: "assets/img/yrc/yrc programme/40/4.jpeg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/40/4.jpeg",
    },
    {
      src: "assets/img/yrc/yrc programme/39/1.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/39/1.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/39/2.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/39/2.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/39/3.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/39/3.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/39/4.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/39/4.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/39/5.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/39/5.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/39/6.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/39/6.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/39/7.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/39/7.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/39/8.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/39/8.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/39/9.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/39/9.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/35/1.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/35/1.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/35/2.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/35/2.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/35/3.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/35/3.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/35/4.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/35/4.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/35/5.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/35/5.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/35/6.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/35/6.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/35/7.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/35/7.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/35/8.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/35/8.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/35/9.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/35/9.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/35/10.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/35/10.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/35/11.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/35/11.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/35/12.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/35/12.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/35/13.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/35/13.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/35/14.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/35/14.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/35/15.jpeg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/35/15.jpeg",
    },
    {
      src: "assets/img/yrc/yrc programme/33/1.jpeg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/33/1.jpeg",
    },
    {
      src: "assets/img/yrc/yrc programme/33/2.jpeg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/33/2.jpeg",
    },
    {
      src: "assets/img/yrc/yrc programme/32/1.jpeg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/32/1.jpeg",
    },
    {
      src: "assets/img/yrc/yrc programme/32/2.jpeg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/32/2.jpeg",
    },
    {
      src: "assets/img/yrc/yrc programme/32/3.jpeg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/32/3.jpeg",
    },
    {
      src: "assets/img/yrc/yrc programme/31/1.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/31/1.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/31/2.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/31/2.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/31/3.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/31/3.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/31/4.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/31/4.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/31/5.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/31/5.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/31/6.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/31/6.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/31/7.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/31/7.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/31/8.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/31/8.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/31/9.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/31/9.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/31/10.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/31/10.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/31/11.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/31/11.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/31/12.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/31/12.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/31/13.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/31/13.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/31/14.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/31/14.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/31/15.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/31/15.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/31/16.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/31/16.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/31/17.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/31/17.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/31/18.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/31/18.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/30/1.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/30/1.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/30/2.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/30/2.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/30/3.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/30/3.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/30/4.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/30/4.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/30/5.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/30/5.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/30/6.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/30/6.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/30/7.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/30/7.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/30/8.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/30/8.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/29/1.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/29/1.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/29/2.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/29/2.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/29/3.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/29/3.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/29/4.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/29/4.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/29/5.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/29/5.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/29/6.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/29/6.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/29/7.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/29/7.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/29/8.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/29/8.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/29/9.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/29/9.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/29/10.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/29/10.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/29/11.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/29/11.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/29/12.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/29/12.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/29/13.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/29/13.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/29/14.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/29/14.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/29/15.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/29/15.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/29/16.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/29/16.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/29/17.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/29/17.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/29/18.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/29/18.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/29/19.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/29/19.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/29/20.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/29/20.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/29/21.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/29/21.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/29/22.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/29/22.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/29/23.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/29/23.jpg",
    },

    {
      src: "assets/img/yrc/yrc programme/29/24.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/29/24.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/29/25.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/29/25.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/25/1.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/25/1.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/25/2.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/25/2.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/25/3.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/25/3.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/25/4.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/25/4.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/25/5.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/25/5.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/25/6.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/25/6.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/25/7.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/25/7.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/25/8.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/25/8.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/25/9.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/25/9.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/25/10.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/25/10.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/25/11.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/25/11.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/25/12.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/25/12.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/25/13.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/25/13.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/25/14.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/25/14.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/25/15.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/25/15.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/25/16.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/25/16.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/25/17.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/25/17.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/25/18.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/25/18.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/25/19.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/25/19.jpg",
    },

    {
      src: "assets/img/yrc/yrc programme/19/1.jpeg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/19/1.jpeg",
    },
    {
      src: "assets/img/yrc/yrc programme/19/2.jpeg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/19/2.jpeg",
    },
    {
      src: "assets/img/yrc/yrc programme/19/3.jpeg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/19/3.jpeg",
    },
    {
      src: "assets/img/yrc/yrc programme/19/4.jpeg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/19/4.jpeg",
    },
    {
      src: "assets/img/yrc/yrc programme/19/5.jpeg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/19/5.jpeg",
    },
    {
      src: "assets/img/yrc/yrc programme/19/6.jpeg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/19/6.jpeg",
    },
    {
      src: "assets/img/yrc/yrc programme/19/7.jpeg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/19/7.jpeg",
    },
    {
      src: "assets/img/yrc/yrc programme/19/8.jpeg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/19/8.jpeg",
    },
    {
      src: "assets/img/yrc/yrc programme/20/1.jpeg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/20/1.jpeg",
    },
    {
      src: "assets/img/yrc/yrc programme/20/2.jpeg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/20/2.jpeg",
    },
    {
      src: "assets/img/yrc/yrc programme/20/3.jpeg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/20/3.jpeg",
    },
    {
      src: "assets/img/yrc/yrc programme/20/4.jpeg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/20/4.jpeg",
    },
    {
      src: "assets/img/yrc/yrc programme/20/5.jpeg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/20/5.jpeg",
    },
    {
      src: "assets/img/yrc/yrc programme/20/6.jpeg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/20/6.jpeg",
    },
    {
      src: "assets/img/yrc/yrc programme/20/7.jpeg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/20/7.jpeg",
    },
    {
      src: "assets/img/yrc/yrc programme/20/8.jpeg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/20/8.jpeg",
    },
    {
      src: "assets/img/yrc/yrc programme/20/9.jpeg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/20/9.jpeg",
    },
    {
      src: "assets/img/yrc/yrc programme/20/10.jpeg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/20/10.jpeg",
    },
    {
      src: "assets/img/yrc/yrc programme/20/11.jpeg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/20/11.jpeg",
    },
    {
      src: "assets/img/yrc/yrc programme/20/12.jpeg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/20/12.jpeg",
    },
    {
      src: "assets/img/yrc/yrc programme/20/13.jpeg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/20/13.jpeg",
    },
    {
      src: "assets/img/yrc/yrc programme/20/14.jpeg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/20/14.jpeg",
    },
    {
      src: "assets/img/yrc/yrc programme/20/15.jpeg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/20/15.jpeg",
    },
    {
      src: "assets/img/yrc/yrc programme/20/16.jpeg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/20/16.jpeg",
    },
    {
      src: "assets/img/yrc/yrc programme/20/17.jpeg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/20/17.jpeg",
    },
    {
      src: "assets/img/yrc/yrc programme/20/18.jpeg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/20/18.jpeg",
    },
    {
      src: "assets/img/yrc/yrc programme/20/19.jpeg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/20/19.jpeg",
    },
    {
      src: "assets/img/yrc/yrc programme/20/20.jpeg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/20/20.jpeg",
    },
    {
      src: "assets/img/yrc/yrc programme/20/21.jpeg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/20/21.jpeg",
    },
    {
      src: "assets/img/yrc/yrc programme/20/22.jpeg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/20/22.jpeg",
    },
    {
      src: "assets/img/yrc/yrc programme/20/23.jpeg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/20/23.jpeg",
    },
    {
      src: "assets/img/yrc/yrc programme/20/24.jpeg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/20/24.jpeg",
    },
    {
      src: "assets/img/yrc/yrc programme/21/1.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/21/1.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/21/2.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/21/2.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/21/3.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/21/3.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/21/4.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/21/4.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/22/1.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/22/1.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/22/2.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/22/2.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/22/3.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/22/3.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/22/4.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/22/4.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/22/5.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/22/5.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/22/6.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/22/6.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/22/7.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/22/7.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/22/8.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/22/8.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/22/9.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/22/9.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/22/10.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/22/10.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/22/11.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/22/11.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/22/12.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/22/12.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/22/13.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/22/13.jpg",
    },

    {
      src: "assets/img/yrc/yrc programme/18/1.jpeg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/18/1.jpeg",
    },
    {
      src: "assets/img/yrc/yrc programme/18/2.jpeg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/18/2.jpeg",
    },
    {
      src: "assets/img/yrc/yrc programme/18/3.jpeg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/18/3.jpeg",
    },
    {
      src: "assets/img/yrc/yrc programme/18/4.jpeg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/18/4.jpeg",
    },
    {
      src: "assets/img/yrc/yrc programme/18/5.jpeg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/18/5.jpeg",
    },
    {
      src: "assets/img/yrc/yrc programme/17/1.jpeg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/17/1.jpeg",
    },
    {
      src: "assets/img/yrc/yrc programme/17/2.jpeg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/17/2.jpeg",
    },
    {
      src: "assets/img/yrc/yrc programme/16/1.jpeg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/16/1.jpeg",
    },
    {
      src: "assets/img/yrc/yrc programme/16/2.jpeg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/16/2.jpeg",
    },
    {
      src: "assets/img/yrc/yrc programme/16/3.jpeg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/16/3.jpeg",
    },
    {
      src: "assets/img/yrc/yrc programme/15/1.jpeg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/15/1.jpeg",
    },
    {
      src: "assets/img/yrc/yrc programme/15/2.jpeg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/15/2.jpeg",
    },
    {
      src: "assets/img/yrc/yrc programme/15/3.jpeg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/15/3.jpeg",
    },
    {
      src: "assets/img/yrc/yrc programme/15/4.jpeg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/15/4.jpeg",
    },
    {
      src: "assets/img/yrc/yrc programme/15/5.jpeg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/15/5.jpeg",
    },
    {
      src: "assets/img/yrc/yrc programme/15/6.jpeg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/15/6.jpeg",
    },
    {
      src: "assets/img/yrc/yrc programme/14/1.jpeg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/14/1.jpeg",
    },
    {
      src: "assets/img/yrc/yrc programme/13/1.jpeg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/13/1.jpeg",
    },
    {
      src: "assets/img/yrc/yrc programme/13/2.jpeg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/13/2.jpeg",
    },
    {
      src: "assets/img/yrc/yrc programme/13/3.jpeg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/13/3.jpeg",
    },
    {
      src: "assets/img/yrc/yrc programme/13/4.jpeg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/13/4.jpeg",
    },
    {
      src: "assets/img/yrc/yrc programme/13/5.jpeg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/13/5.jpeg",
    },
    {
      src: "assets/img/yrc/yrc programme/13/6.jpeg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/13/6.jpeg",
    },
    {
      src: "assets/img/yrc/yrc programme/13/7.jpeg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/13/7.jpeg",
    },
    {
      src: "assets/img/yrc/yrc programme/13/8.jpeg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/13/8.jpeg",
    },
    {
      src: "assets/img/yrc/yrc programme/13/9.jpeg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/13/9.jpeg",
    },
    {
      src: "assets/img/yrc/yrc programme/12/1.jpeg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/12/1.jpeg",
    },
    {
      src: "assets/img/yrc/yrc programme/12/2.jpeg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/12/2.jpeg",
    },
    {
      src: "assets/img/yrc/yrc programme/11/1.jpeg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/11/1.jpeg",
    },
    {
      src: "assets/img/yrc/yrc programme/11/2.jpeg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/11/2.jpeg",
    },
    {
      src: "assets/img/yrc/yrc programme/11/3.jpeg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/11/3.jpeg",
    },
    {
      src: "assets/img/yrc/yrc programme/11/4.jpeg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/11/4.jpeg",
    },
    {
      src: "assets/img/yrc/yrc programme/11/5.jpeg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/11/5.jpeg",
    },
    {
      src: "assets/img/yrc/yrc programme/11/6.jpeg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/11/6.jpeg",
    },
    {
      src: "assets/img/yrc/yrc programme/11/7.jpeg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/11/7.jpeg",
    },
    {
      src: "assets/img/yrc/yrc programme/11/8.jpeg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/11/8.jpeg",
    },
    {
      src: "assets/img/yrc/yrc programme/11/9.jpeg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/11/9.jpeg",
    },
    {
      src: "assets/img/yrc/yrc programme/10/1.jpeg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/10/1.jpeg",
    },
    {
      src: "assets/img/yrc/yrc programme/10/2.jpeg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/10/2.jpeg",
    },
    {
      src: "assets/img/yrc/yrc programme/10/3.jpeg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/10/3.jpeg",
    },
    {
      src: "assets/img/yrc/yrc programme/10/4.jpeg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/10/4.jpeg",
    },
    {
      src: "assets/img/yrc/yrc programme/8/1.jpeg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/8/1.jpeg",
    },
    {
      src: "assets/img/yrc/yrc programme/8/2.jpeg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/8/2.jpeg",
    },
    {
      src: "assets/img/yrc/yrc programme/8/3.jpeg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/8/3.jpeg",
    },
    {
      src: "assets/img/yrc/yrc programme/8/4.jpeg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/8/4.jpeg",
    },
    {
      src: "assets/img/yrc/yrc programme/8/5.jpeg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/8/5.jpeg",
    },
    {
      src: "assets/img/yrc/yrc programme/8/6.jpeg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/8/6.jpeg",
    },
    {
      src: "assets/img/yrc/yrc programme/7/1.jpeg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/7/1.jpeg",
    },
    {
      src: "assets/img/yrc/yrc programme/7/2.jpeg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/7/2.jpeg",
    },
    {
      src: "assets/img/yrc/yrc programme/1/1.jpeg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/1/1.jpeg",
    },
    {
      src: "assets/img/yrc/yrc programme/1/2.jpeg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/1/2.jpeg",
    },
    {
      src: "assets/img/yrc/yrc programme/1/3.jpeg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/1/3.jpeg",
    },
    {
      src: "assets/img/yrc/yrc programme/1/4.jpeg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/1/4.jpeg",
    },
    {
      src: "assets/img/yrc/yrc programme/1/5.jpeg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/1/5.jpeg",
    },
    {
      src: "assets/img/yrc/yrc programme/2/1.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/2/1.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/2/2.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/2/2.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/2/3.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/2/3.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/2/4.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/2/4.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/2/5.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/2/5.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/2/6.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/2/6.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/2/7.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/2/7.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/2/8.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/2/8.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/2/9.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/2/9.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/2/10.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/2/10.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/2/11.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/2/11.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/2/12.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/2/12.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/2/13.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/2/13.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/2/14.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/2/14.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/2/15.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/2/15.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/2/16.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/2/16.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/3/1.jpeg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/3/1.jpeg",
    },
    {
      src: "assets/img/yrc/yrc programme/3/2.jpeg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/3/2.jpeg",
    },
    {
      src: "assets/img/yrc/yrc programme/3/3.jpeg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/3/3.jpeg",
    },
    {
      src: "assets/img/yrc/yrc programme/3/4.jpeg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/3/4.jpeg",
    },
    {
      src: "assets/img/yrc/yrc programme/5/1.jpeg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/5/1.jpeg",
    },
    {
      src: "assets/img/yrc/yrc programme/5/2.jpeg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/5/2.jpeg",
    },
    {
      src: "assets/img/yrc/yrc programme/5/3.jpeg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/5/3.jpeg",
    },
    {
      src: "assets/img/yrc/yrc programme/4/2.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/4/2.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/4/3.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/4/3.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/4/4.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/4/4.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/4/5.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/4/5.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/4/6.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/4/6.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/4/7.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/4/7.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/4/8.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/4/8.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/4/9.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/4/9.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/4/10.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/4/10.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/4/11.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/4/11.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/4/12.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/4/12.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/4/13.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/4/13.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/4/14.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/4/14.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/4/15.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/4/15.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/4/16.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/4/16.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/4/17.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/4/17.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/4/18.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/4/18.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/4/19.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/4/19.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/4/20.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/4/20.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/4/21.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/4/21.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/4/22.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/4/22.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/4/23.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/4/23.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/4/24.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/4/24.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/4/25.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/4/25.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/4/26.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/4/26.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/4/27.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/4/27.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/4/28.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/4/28.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/4/29.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/4/29.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/4/30.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/4/30.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/4/31.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/4/31.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/4/32.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/4/32.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/4/33.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/4/33.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/4/34.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/4/34.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/4/35.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/4/35.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/4/36.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/4/36.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/4/37.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/4/37.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/4/38.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/4/38.jpg",
    },

    {
      src: "assets/img/yrc/yrc programme/9/1.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/9/1.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/9/2.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/9/2.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/9/4.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/9/4.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/9/5.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/9/5.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/9/6.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/9/6.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/9/7.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/9/7.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/9/8.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/9/8.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/9/9.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/9/9.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/9/10.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/9/10.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/9/11.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/9/11.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/9/12.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/9/12.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/9/13.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/9/13.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/9/14.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/9/14.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/9/15.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/9/15.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/9/16.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/9/16.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/9/17.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/9/17.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/9/18.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/9/18.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/6/1.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/6/1.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/6/2.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/6/2.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/6/3.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/6/3.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/6/4.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/6/4.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/6/1.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/6/1.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/6/2.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/6/2.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/6/3.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/6/3.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/6/2.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/6/2.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/6/3.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/6/3.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/6/4.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/6/4.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/6/5.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/6/5.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/6/6.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/6/6.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/6/7.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/6/7.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/6/8.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/6/8.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/6/9.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/6/9.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/6/10.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/6/10.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/6/11.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/6/11.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/6/12.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/6/12.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/6/13.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/6/13.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/6/14.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/6/14.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/6/15.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/6/15.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/6/16.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/6/16.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/6/17.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/6/17.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/6/18.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/6/18.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/6/19.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/6/19.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/6/20.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/6/20.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/6/21.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/6/21.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/6/22.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/6/22.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/6/23.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/6/23.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/6/24.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/6/24.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/6/25.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/6/25.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/6/26.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/6/26.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/6/27.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/6/27.jpg",
    },
    {
      src: "assets/img/yrc/yrc programme/6/28.jpg",
      caption: "",
      thumb: "assets/img/yrc/yrc programme/6/28.jpg",
    },

    {
      src: "assets/img/yrc/1.jpg",
      caption: "1",
      thumb: "assets/img/yrc/1.jpg",
    },
    {
      src: "assets/img/yrc/2.jpg",
      caption: "1",
      thumb: "assets/img/yrc/2.jpg",
    },
    {
      src: "assets/img/yrc/3.jpg",
      caption: "1",
      thumb: "assets/img/yrc/3.jpg",
    },
    {
      src: "assets/img/yrc/4.jpg",
      caption: "1",
      thumb: "assets/img/yrc/4.jpg",
    },
    {
      src: "assets/img/yrc/5.jpg",
      caption: "1",
      thumb: "assets/img/yrc/5.jpg",
    },
    {
      src: "assets/img/yrc/6.jpg",
      caption: "1",
      thumb: "assets/img/yrc/6.jpg",
    },
  ];

  SPECTRUM_GALLERY: Array<{ src: string; caption: string; thumb: string }> = [
    {
      src: "assets/img/spectrum/269.jpg",
      caption:
        "To motivate the celebration Dr. Caezar Ennis , Consultant in General Medicine gave his valuable  presence to inaugurate the function and distribute sweets in black color. Focusing on the theme the special education trainer Mrs.Princemol  planned  art and craft activity to get active participation of special kids .",
      thumb: "assets/img/spectrum/269.jpg",
    },
    {
      src: "assets/img/spectrum/270.jpg",
      caption:
        "To motivate the celebration Dr. Caezar Ennis , Consultant in General Medicine gave his valuable  presence to inaugurate the function and distribute sweets in black color. Focusing on the theme the special education trainer Mrs.Princemol  planned  art and craft activity to get active participation of special kids .",
      thumb: "assets/img/spectrum/270.jpg",
    },
    {
      src: "assets/img/spectrum/271.jpg",
      caption:
        "Black Colour day at NIMS Anne Sullivan Centre for Specially Abled Children. ",
      thumb: "assets/img/spectrum/271.jpg",
    },
    {
      src: "assets/img/spectrum/272.jpg",
      caption:
        "Black Colour day at NIMS Anne Sullivan Centre for Specially Abled Children. ",
      thumb: "assets/img/spectrum/272.jpg",
    },
    {
      src: "assets/img/spectrum/273.jpg",
      caption:
        "Black Colour day at NIMS Anne Sullivan Centre for Specially Abled Children. ",
      thumb: "assets/img/spectrum/273.jpg",
    },
    {
      src: "assets/img/spectrum/274.jpg",
      caption:
        "On 18 th January 2023, NIMS Anne Sullivan Centre for specially abled children celebrated Black colour day, with an objective to help the children with special needs to  identify the colour, develop their fine motor skills and build connections to things around them. ",
      thumb: "assets/img/spectrum/274.jpg",
    },
    {
      src: "assets/img/spectrum/275.jpg",
      caption:
        "On 18 th January 2023, NIMS Anne Sullivan Centre for specially abled children celebrated Black colour day, with an objective to help the children with special needs to  identify the colour, develop their fine motor skills and build connections to things around them. ",
      thumb: "assets/img/spectrum/275.jpg",
    },
    {
      src: "assets/img/spectrum/276.jpg",
      caption:
        "It was great to see our student’s participation and enjoyed doing the art and craft activity with great fun. Parents and trainers also dressed in different hues and tints of Black. Our Parents participated enthusiastically with our tiny tots to make learning fun. At the end of the day, the most overwhelming key to a child’s success is the positive involvement of parents.",
      thumb: "assets/img/spectrum/276.jpg",
    },

    {
      src: "assets/img/spectrum/261.jpg",
      caption:
        "പത്തനാപുരം ഗാന്ധി ഭവൻ സ്പെഷ്യൽ സ്കൂളിൽ പ്രവർത്തിക്കുന്ന നിംസ് സ്പെക്ട്രം ശിശു വികസന ഗവേഷണത്തിന്റെ ശാഖയിൽ അന്തേവാസികൾക്കും പൊതു ജനങ്ങൾക്കുമായി  ഒക്യുപേഷണൽ തെറാപ്പി, സ്പെഷ്യൽ എഡ്യൂക്കേഷൻ  , വിദഗ്ധ ഡോക്ടർമാരുടെ സേവനം ലഭ്യമാക്കി .",
      thumb: "assets/img/spectrum/261.jpg",
    },
    {
      src: "assets/img/spectrum/262.jpg",
      caption:
        "പത്തനാപുരം ഗാന്ധി ഭവൻ സ്പെഷ്യൽ സ്കൂളിൽ പ്രവർത്തിക്കുന്ന നിംസ് സ്പെക്ട്രം ശിശു വികസന ഗവേഷണത്തിന്റെ ശാഖയിൽ അന്തേവാസികൾക്കും പൊതു ജനങ്ങൾക്കുമായി  ഒക്യുപേഷണൽ തെറാപ്പി, സ്പെഷ്യൽ എഡ്യൂക്കേഷൻ  , വിദഗ്ധ ഡോക്ടർമാരുടെ സേവനം ലഭ്യമാക്കി .",
      thumb: "assets/img/spectrum/262.jpg",
    },
    {
      src: "assets/img/spectrum/263.jpg",
      caption:
        "പത്തനാപുരം ഗാന്ധി ഭവൻ സ്പെഷ്യൽ സ്കൂളിൽ പ്രവർത്തിക്കുന്ന നിംസ് സ്പെക്ട്രം ശിശു വികസന ഗവേഷണത്തിന്റെ ശാഖയിൽ അന്തേവാസികൾക്കും പൊതു ജനങ്ങൾക്കുമായി  ഒക്യുപേഷണൽ തെറാപ്പി, സ്പെഷ്യൽ എഡ്യൂക്കേഷൻ  , വിദഗ്ധ ഡോക്ടർമാരുടെ സേവനം ലഭ്യമാക്കി .",
      thumb: "assets/img/spectrum/263.jpg",
    },
    {
      src: "assets/img/spectrum/264.jpg",
      caption:
        "പത്തനാപുരം ഗാന്ധി ഭവൻ സ്പെഷ്യൽ സ്കൂളിൽ പ്രവർത്തിക്കുന്ന നിംസ് സ്പെക്ട്രം ശിശു വികസന ഗവേഷണത്തിന്റെ ശാഖയിൽ അന്തേവാസികൾക്കും പൊതു ജനങ്ങൾക്കുമായി  ഒക്യുപേഷണൽ തെറാപ്പി, സ്പെഷ്യൽ എഡ്യൂക്കേഷൻ  , വിദഗ്ധ ഡോക്ടർമാരുടെ സേവനം ലഭ്യമാക്കി .",
      thumb: "assets/img/spectrum/264.jpg",
    },
    {
      src: "assets/img/spectrum/265.jpg",
      caption:
        "പത്തനാപുരം ഗാന്ധി ഭവൻ സ്പെഷ്യൽ സ്കൂളിൽ പ്രവർത്തിക്കുന്ന നിംസ് സ്പെക്ട്രം ശിശു വികസന ഗവേഷണത്തിന്റെ ശാഖയിൽ അന്തേവാസികൾക്കും പൊതു ജനങ്ങൾക്കുമായി  ഒക്യുപേഷണൽ തെറാപ്പി, സ്പെഷ്യൽ എഡ്യൂക്കേഷൻ  , വിദഗ്ധ ഡോക്ടർമാരുടെ സേവനം ലഭ്യമാക്കി .",
      thumb: "assets/img/spectrum/265.jpg",
    },
    {
      src: "assets/img/spectrum/266.jpg",
      caption:
        "പത്തനാപുരം ഗാന്ധി ഭവൻ സ്പെഷ്യൽ സ്കൂളിൽ പ്രവർത്തിക്കുന്ന നിംസ് സ്പെക്ട്രം ശിശു വികസന ഗവേഷണത്തിന്റെ ശാഖയിൽ അന്തേവാസികൾക്കും പൊതു ജനങ്ങൾക്കുമായി  ഒക്യുപേഷണൽ തെറാപ്പി, സ്പെഷ്യൽ എഡ്യൂക്കേഷൻ  , വിദഗ്ധ ഡോക്ടർമാരുടെ സേവനം ലഭ്യമാക്കി .",
      thumb: "assets/img/spectrum/266.jpg",
    },
    {
      src: "assets/img/spectrum/267.jpg",
      caption:
        "പത്തനാപുരം ഗാന്ധി ഭവൻ സ്പെഷ്യൽ സ്കൂളിൽ പ്രവർത്തിക്കുന്ന നിംസ് സ്പെക്ട്രം ശിശു വികസന ഗവേഷണത്തിന്റെ ശാഖയിൽ അന്തേവാസികൾക്കും പൊതു ജനങ്ങൾക്കുമായി  ഒക്യുപേഷണൽ തെറാപ്പി, സ്പെഷ്യൽ എഡ്യൂക്കേഷൻ  , വിദഗ്ധ ഡോക്ടർമാരുടെ സേവനം ലഭ്യമാക്കി .",
      thumb: "assets/img/spectrum/267.jpg",
    },
    {
      src: "assets/img/spectrum/268.jpg",
      caption:
        "പത്തനാപുരം ഗാന്ധി ഭവൻ സ്പെഷ്യൽ സ്കൂളിൽ പ്രവർത്തിക്കുന്ന നിംസ് സ്പെക്ട്രം ശിശു വികസന ഗവേഷണത്തിന്റെ ശാഖയിൽ അന്തേവാസികൾക്കും പൊതു ജനങ്ങൾക്കുമായി  ഒക്യുപേഷണൽ തെറാപ്പി, സ്പെഷ്യൽ എഡ്യൂക്കേഷൻ  , വിദഗ്ധ ഡോക്ടർമാരുടെ സേവനം ലഭ്യമാക്കി .",
      thumb: "assets/img/spectrum/268.jpg",
    },
    {
      src: "assets/img/spectrum/244.jpg",
      caption:
        "ഓരോ മനുഷ്യരും വ്യത്യസ്തരാണ്. എല്ലാവർക്കും അവരവരുടേതായ ചില പ്രത്യേകതകൾ ഉണ്ട്. ശാരീരിക മാനസിക പരിമിതികൾ നേരിടുന്നവരെ കൂടെ നിർത്തേണ്ടത് നമ്മൾ ഓരോരുത്തരുടെയും കടമയാണ് . പരിമിതികളെ അതിജീവിച്ച് പ്രചോദനത്തിന്റെ മാതൃകകളാകുന്ന ഒരു കൂട്ടം മനുഷ്യർ, സമൂഹത്തിന്റെ മുഖ്യ ധാരയിലേക്ക് അവരെ കൂടി കൈപിടിച്ച് കൊണ്ട് വരാൻ നമുക്ക് അണി ചേരാം .",
      thumb: "assets/img/spectrum/244.jpg",
    },
    {
      src: "assets/img/spectrum/245.jpg",
      caption:
        "ഓരോ മനുഷ്യരും വ്യത്യസ്തരാണ്. എല്ലാവർക്കും അവരവരുടേതായ ചില പ്രത്യേകതകൾ ഉണ്ട്. ശാരീരിക മാനസിക പരിമിതികൾ നേരിടുന്നവരെ കൂടെ നിർത്തേണ്ടത് നമ്മൾ ഓരോരുത്തരുടെയും കടമയാണ് . പരിമിതികളെ അതിജീവിച്ച് പ്രചോദനത്തിന്റെ മാതൃകകളാകുന്ന ഒരു കൂട്ടം മനുഷ്യർ, സമൂഹത്തിന്റെ മുഖ്യ ധാരയിലേക്ക് അവരെ കൂടി കൈപിടിച്ച് കൊണ്ട് വരാൻ നമുക്ക് അണി ചേരാം .",
      thumb: "assets/img/spectrum/245.jpg",
    },
    {
      src: "assets/img/spectrum/246.jpg",
      caption:
        "ഓരോ മനുഷ്യരും വ്യത്യസ്തരാണ്. എല്ലാവർക്കും അവരവരുടേതായ ചില പ്രത്യേകതകൾ ഉണ്ട്. ശാരീരിക മാനസിക പരിമിതികൾ നേരിടുന്നവരെ കൂടെ നിർത്തേണ്ടത് നമ്മൾ ഓരോരുത്തരുടെയും കടമയാണ് . പരിമിതികളെ അതിജീവിച്ച് പ്രചോദനത്തിന്റെ മാതൃകകളാകുന്ന ഒരു കൂട്ടം മനുഷ്യർ, സമൂഹത്തിന്റെ മുഖ്യ ധാരയിലേക്ക് അവരെ കൂടി കൈപിടിച്ച് കൊണ്ട് വരാൻ നമുക്ക് അണി ചേരാം .",
      thumb: "assets/img/spectrum/246.jpg",
    },
    {
      src: "assets/img/spectrum/247.jpg",
      caption:
        "ഓരോ മനുഷ്യരും വ്യത്യസ്തരാണ്. എല്ലാവർക്കും അവരവരുടേതായ ചില പ്രത്യേകതകൾ ഉണ്ട്. ശാരീരിക മാനസിക പരിമിതികൾ നേരിടുന്നവരെ കൂടെ നിർത്തേണ്ടത് നമ്മൾ ഓരോരുത്തരുടെയും കടമയാണ് . പരിമിതികളെ അതിജീവിച്ച് പ്രചോദനത്തിന്റെ മാതൃകകളാകുന്ന ഒരു കൂട്ടം മനുഷ്യർ, സമൂഹത്തിന്റെ മുഖ്യ ധാരയിലേക്ക് അവരെ കൂടി കൈപിടിച്ച് കൊണ്ട് വരാൻ നമുക്ക് അണി ചേരാം .",
      thumb: "assets/img/spectrum/247.jpg",
    },
    {
      src: "assets/img/spectrum/248.jpg",
      caption:
        "പത്തനാപുരം ഗാന്ധിഭവനിലെ സ്പെഷ്യൽ സ്കൂളിലെ വിദ്യാർത്ഥികൾക്കായി വിവിധ കലാമത്സരങ്ങൾ ഗാന്ധിഭവനിൽ പ്രവർത്തിക്കുന്ന നിംസ് സ്പെക്ട്രം സംഘടിപ്പിച്ചു . പാട്ടും, മിമിക്രിയും , ഗ്രൂപ്പ് ഡാൻസ് , പ്രച്ഛന്നവേഷം തുടങ്ങിയവയിലൂടെ കുട്ടികൾ വളരെയധികം സന്തോഷത്തോടെ എല്ലാവരുടെയും ശ്രദ്ധയാകര്‍ഷിച്ചു.കുട്ടികളുടെ സർഗ്ഗാത്മകത , ആത്മ വിശ്വാസം , ആശയ വിനിമം , ഗ്രൂപ്പ് സ്കിൽസ് തുടങ്ങിയ കഴിവുകൾ വർദ്ധിപ്പിക്കുന്നതിനാണ് നൂറുൽ ഇസ്‌ലാം സർവ്വകലാശാലയിലെ ബി.എസ്. എൽ.പി. വിദ്യാർഥികൾ ഇത്തരത്തിലുളള കലാമത്സരങ്ങൾ സംഘടിപ്പിച്ചത്. സ്വതന്ത്ര സമര സേനാനികളുടെ വേഷം അണിഞ്ഞും സിനിമാ താരങ്ങളുടെ ശബ്ദം അനുകരിച്ചും കുട്ടികൾ കാണികളുടെ മനസ്സ് കീഴടക്കി.",
      thumb: "assets/img/spectrum/248.jpg",
    },
    {
      src: "assets/img/spectrum/249.jpg",
      caption:
        "പത്തനാപുരം ഗാന്ധിഭവനിലെ സ്പെഷ്യൽ സ്കൂളിലെ വിദ്യാർത്ഥികൾക്കായി വിവിധ കലാമത്സരങ്ങൾ ഗാന്ധിഭവനിൽ പ്രവർത്തിക്കുന്ന നിംസ് സ്പെക്ട്രം സംഘടിപ്പിച്ചു . പാട്ടും, മിമിക്രിയും , ഗ്രൂപ്പ് ഡാൻസ് , പ്രച്ഛന്നവേഷം തുടങ്ങിയവയിലൂടെ കുട്ടികൾ വളരെയധികം സന്തോഷത്തോടെ എല്ലാവരുടെയും ശ്രദ്ധയാകര്‍ഷിച്ചു.കുട്ടികളുടെ സർഗ്ഗാത്മകത , ആത്മ വിശ്വാസം , ആശയ വിനിമം , ഗ്രൂപ്പ് സ്കിൽസ് തുടങ്ങിയ കഴിവുകൾ വർദ്ധിപ്പിക്കുന്നതിനാണ് നൂറുൽ ഇസ്‌ലാം സർവ്വകലാശാലയിലെ ബി.എസ്. എൽ.പി. വിദ്യാർഥികൾ ഇത്തരത്തിലുളള കലാമത്സരങ്ങൾ സംഘടിപ്പിച്ചത്. സ്വതന്ത്ര സമര സേനാനികളുടെ വേഷം അണിഞ്ഞും സിനിമാ താരങ്ങളുടെ ശബ്ദം അനുകരിച്ചും കുട്ടികൾ കാണികളുടെ മനസ്സ് കീഴടക്കി.",
      thumb: "assets/img/spectrum/249.jpg",
    },
    {
      src: "assets/img/spectrum/250.jpg",
      caption:
        "പത്തനാപുരം ഗാന്ധിഭവനിലെ സ്പെഷ്യൽ സ്കൂളിലെ വിദ്യാർത്ഥികൾക്കായി വിവിധ കലാമത്സരങ്ങൾ ഗാന്ധിഭവനിൽ പ്രവർത്തിക്കുന്ന നിംസ് സ്പെക്ട്രം സംഘടിപ്പിച്ചു . പാട്ടും, മിമിക്രിയും , ഗ്രൂപ്പ് ഡാൻസ് , പ്രച്ഛന്നവേഷം തുടങ്ങിയവയിലൂടെ കുട്ടികൾ വളരെയധികം സന്തോഷത്തോടെ എല്ലാവരുടെയും ശ്രദ്ധയാകര്‍ഷിച്ചു.കുട്ടികളുടെ സർഗ്ഗാത്മകത , ആത്മ വിശ്വാസം , ആശയ വിനിമം , ഗ്രൂപ്പ് സ്കിൽസ് തുടങ്ങിയ കഴിവുകൾ വർദ്ധിപ്പിക്കുന്നതിനാണ് നൂറുൽ ഇസ്‌ലാം സർവ്വകലാശാലയിലെ ബി.എസ്. എൽ.പി. വിദ്യാർഥികൾ ഇത്തരത്തിലുളള കലാമത്സരങ്ങൾ സംഘടിപ്പിച്ചത്. സ്വതന്ത്ര സമര സേനാനികളുടെ വേഷം അണിഞ്ഞും സിനിമാ താരങ്ങളുടെ ശബ്ദം അനുകരിച്ചും കുട്ടികൾ കാണികളുടെ മനസ്സ് കീഴടക്കി.",
      thumb: "assets/img/spectrum/250.jpg",
    },
    {
      src: "assets/img/spectrum/251.jpg",
      caption:
        "പത്തനാപുരം ഗാന്ധിഭവനിലെ സ്പെഷ്യൽ സ്കൂളിലെ വിദ്യാർത്ഥികൾക്കായി വിവിധ കലാമത്സരങ്ങൾ ഗാന്ധിഭവനിൽ പ്രവർത്തിക്കുന്ന നിംസ് സ്പെക്ട്രം സംഘടിപ്പിച്ചു . പാട്ടും, മിമിക്രിയും , ഗ്രൂപ്പ് ഡാൻസ് , പ്രച്ഛന്നവേഷം തുടങ്ങിയവയിലൂടെ കുട്ടികൾ വളരെയധികം സന്തോഷത്തോടെ എല്ലാവരുടെയും ശ്രദ്ധയാകര്‍ഷിച്ചു.കുട്ടികളുടെ സർഗ്ഗാത്മകത , ആത്മ വിശ്വാസം , ആശയ വിനിമം , ഗ്രൂപ്പ് സ്കിൽസ് തുടങ്ങിയ കഴിവുകൾ വർദ്ധിപ്പിക്കുന്നതിനാണ് നൂറുൽ ഇസ്‌ലാം സർവ്വകലാശാലയിലെ ബി.എസ്. എൽ.പി. വിദ്യാർഥികൾ ഇത്തരത്തിലുളള കലാമത്സരങ്ങൾ സംഘടിപ്പിച്ചത്. സ്വതന്ത്ര സമര സേനാനികളുടെ വേഷം അണിഞ്ഞും സിനിമാ താരങ്ങളുടെ ശബ്ദം അനുകരിച്ചും കുട്ടികൾ കാണികളുടെ മനസ്സ് കീഴടക്കി.",
      thumb: "assets/img/spectrum/251.jpg",
    },
    {
      src: "assets/img/spectrum/252.jpg",
      caption:
        "പത്തനാപുരം ഗാന്ധിഭവനിലെ സ്പെഷ്യൽ സ്കൂളിലെ വിദ്യാർത്ഥികൾക്കായി വിവിധ കലാമത്സരങ്ങൾ ഗാന്ധിഭവനിൽ പ്രവർത്തിക്കുന്ന നിംസ് സ്പെക്ട്രം സംഘടിപ്പിച്ചു . പാട്ടും, മിമിക്രിയും , ഗ്രൂപ്പ് ഡാൻസ് , പ്രച്ഛന്നവേഷം തുടങ്ങിയവയിലൂടെ കുട്ടികൾ വളരെയധികം സന്തോഷത്തോടെ എല്ലാവരുടെയും ശ്രദ്ധയാകര്‍ഷിച്ചു.കുട്ടികളുടെ സർഗ്ഗാത്മകത , ആത്മ വിശ്വാസം , ആശയ വിനിമം , ഗ്രൂപ്പ് സ്കിൽസ് തുടങ്ങിയ കഴിവുകൾ വർദ്ധിപ്പിക്കുന്നതിനാണ് നൂറുൽ ഇസ്‌ലാം സർവ്വകലാശാലയിലെ ബി.എസ്. എൽ.പി. വിദ്യാർഥികൾ ഇത്തരത്തിലുളള കലാമത്സരങ്ങൾ സംഘടിപ്പിച്ചത്. സ്വതന്ത്ര സമര സേനാനികളുടെ വേഷം അണിഞ്ഞും സിനിമാ താരങ്ങളുടെ ശബ്ദം അനുകരിച്ചും കുട്ടികൾ കാണികളുടെ മനസ്സ് കീഴടക്കി.",
      thumb: "assets/img/spectrum/252.jpg",
    },
    {
      src: "assets/img/spectrum/253.jpg",
      caption:
        "പത്തനാപുരം ഗാന്ധിഭവനിലെ സ്പെഷ്യൽ സ്കൂളിലെ വിദ്യാർത്ഥികൾക്കായി വിവിധ കലാമത്സരങ്ങൾ ഗാന്ധിഭവനിൽ പ്രവർത്തിക്കുന്ന നിംസ് സ്പെക്ട്രം സംഘടിപ്പിച്ചു . പാട്ടും, മിമിക്രിയും , ഗ്രൂപ്പ് ഡാൻസ് , പ്രച്ഛന്നവേഷം തുടങ്ങിയവയിലൂടെ കുട്ടികൾ വളരെയധികം സന്തോഷത്തോടെ എല്ലാവരുടെയും ശ്രദ്ധയാകര്‍ഷിച്ചു.കുട്ടികളുടെ സർഗ്ഗാത്മകത , ആത്മ വിശ്വാസം , ആശയ വിനിമം , ഗ്രൂപ്പ് സ്കിൽസ് തുടങ്ങിയ കഴിവുകൾ വർദ്ധിപ്പിക്കുന്നതിനാണ് നൂറുൽ ഇസ്‌ലാം സർവ്വകലാശാലയിലെ ബി.എസ്. എൽ.പി. വിദ്യാർഥികൾ ഇത്തരത്തിലുളള കലാമത്സരങ്ങൾ സംഘടിപ്പിച്ചത്. സ്വതന്ത്ര സമര സേനാനികളുടെ വേഷം അണിഞ്ഞും സിനിമാ താരങ്ങളുടെ ശബ്ദം അനുകരിച്ചും കുട്ടികൾ കാണികളുടെ മനസ്സ് കീഴടക്കി.",
      thumb: "assets/img/spectrum/253.jpg",
    },
    {
      src: "assets/img/spectrum/254.jpg",
      caption:
        "പത്തനാപുരം ഗാന്ധിഭവനിലെ സ്പെഷ്യൽ സ്കൂളിലെ വിദ്യാർത്ഥികൾക്കായി വിവിധ കലാമത്സരങ്ങൾ ഗാന്ധിഭവനിൽ പ്രവർത്തിക്കുന്ന നിംസ് സ്പെക്ട്രം സംഘടിപ്പിച്ചു . പാട്ടും, മിമിക്രിയും , ഗ്രൂപ്പ് ഡാൻസ് , പ്രച്ഛന്നവേഷം തുടങ്ങിയവയിലൂടെ കുട്ടികൾ വളരെയധികം സന്തോഷത്തോടെ എല്ലാവരുടെയും ശ്രദ്ധയാകര്‍ഷിച്ചു.കുട്ടികളുടെ സർഗ്ഗാത്മകത , ആത്മ വിശ്വാസം , ആശയ വിനിമം , ഗ്രൂപ്പ് സ്കിൽസ് തുടങ്ങിയ കഴിവുകൾ വർദ്ധിപ്പിക്കുന്നതിനാണ് നൂറുൽ ഇസ്‌ലാം സർവ്വകലാശാലയിലെ ബി.എസ്. എൽ.പി. വിദ്യാർഥികൾ ഇത്തരത്തിലുളള കലാമത്സരങ്ങൾ സംഘടിപ്പിച്ചത്. സ്വതന്ത്ര സമര സേനാനികളുടെ വേഷം അണിഞ്ഞും സിനിമാ താരങ്ങളുടെ ശബ്ദം അനുകരിച്ചും കുട്ടികൾ കാണികളുടെ മനസ്സ് കീഴടക്കി.",
      thumb: "assets/img/spectrum/254.jpg",
    },
    {
      src: "assets/img/spectrum/255.jpg",
      caption:
        "പത്തനാപുരം ഗാന്ധിഭവനിലെ സ്പെഷ്യൽ സ്കൂളിലെ വിദ്യാർത്ഥികൾക്കായി വിവിധ കലാമത്സരങ്ങൾ ഗാന്ധിഭവനിൽ പ്രവർത്തിക്കുന്ന നിംസ് സ്പെക്ട്രം സംഘടിപ്പിച്ചു . പാട്ടും, മിമിക്രിയും , ഗ്രൂപ്പ് ഡാൻസ് , പ്രച്ഛന്നവേഷം തുടങ്ങിയവയിലൂടെ കുട്ടികൾ വളരെയധികം സന്തോഷത്തോടെ എല്ലാവരുടെയും ശ്രദ്ധയാകര്‍ഷിച്ചു.കുട്ടികളുടെ സർഗ്ഗാത്മകത , ആത്മ വിശ്വാസം , ആശയ വിനിമം , ഗ്രൂപ്പ് സ്കിൽസ് തുടങ്ങിയ കഴിവുകൾ വർദ്ധിപ്പിക്കുന്നതിനാണ് നൂറുൽ ഇസ്‌ലാം സർവ്വകലാശാലയിലെ ബി.എസ്. എൽ.പി. വിദ്യാർഥികൾ ഇത്തരത്തിലുളള കലാമത്സരങ്ങൾ സംഘടിപ്പിച്ചത്. സ്വതന്ത്ര സമര സേനാനികളുടെ വേഷം അണിഞ്ഞും സിനിമാ താരങ്ങളുടെ ശബ്ദം അനുകരിച്ചും കുട്ടികൾ കാണികളുടെ മനസ്സ് കീഴടക്കി.",
      thumb: "assets/img/spectrum/255.jpg",
    },
    {
      src: "assets/img/spectrum/256.jpg",
      caption:
        "പത്തനാപുരം ഗാന്ധിഭവനിലെ സ്പെഷ്യൽ സ്കൂളിലെ വിദ്യാർത്ഥികൾക്കായി വിവിധ കലാമത്സരങ്ങൾ ഗാന്ധിഭവനിൽ പ്രവർത്തിക്കുന്ന നിംസ് സ്പെക്ട്രം സംഘടിപ്പിച്ചു . പാട്ടും, മിമിക്രിയും , ഗ്രൂപ്പ് ഡാൻസ് , പ്രച്ഛന്നവേഷം തുടങ്ങിയവയിലൂടെ കുട്ടികൾ വളരെയധികം സന്തോഷത്തോടെ എല്ലാവരുടെയും ശ്രദ്ധയാകര്‍ഷിച്ചു.കുട്ടികളുടെ സർഗ്ഗാത്മകത , ആത്മ വിശ്വാസം , ആശയ വിനിമം , ഗ്രൂപ്പ് സ്കിൽസ് തുടങ്ങിയ കഴിവുകൾ വർദ്ധിപ്പിക്കുന്നതിനാണ് നൂറുൽ ഇസ്‌ലാം സർവ്വകലാശാലയിലെ ബി.എസ്. എൽ.പി. വിദ്യാർഥികൾ ഇത്തരത്തിലുളള കലാമത്സരങ്ങൾ സംഘടിപ്പിച്ചത്. സ്വതന്ത്ര സമര സേനാനികളുടെ വേഷം അണിഞ്ഞും സിനിമാ താരങ്ങളുടെ ശബ്ദം അനുകരിച്ചും കുട്ടികൾ കാണികളുടെ മനസ്സ് കീഴടക്കി.",
      thumb: "assets/img/spectrum/256.jpg",
    },
    {
      src: "assets/img/spectrum/257.jpg",
      caption:
        "പത്തനാപുരം ഗാന്ധിഭവനിലെ സ്പെഷ്യൽ സ്കൂളിലെ വിദ്യാർത്ഥികൾക്കായി വിവിധ കലാമത്സരങ്ങൾ ഗാന്ധിഭവനിൽ പ്രവർത്തിക്കുന്ന നിംസ് സ്പെക്ട്രം സംഘടിപ്പിച്ചു . പാട്ടും, മിമിക്രിയും , ഗ്രൂപ്പ് ഡാൻസ് , പ്രച്ഛന്നവേഷം തുടങ്ങിയവയിലൂടെ കുട്ടികൾ വളരെയധികം സന്തോഷത്തോടെ എല്ലാവരുടെയും ശ്രദ്ധയാകര്‍ഷിച്ചു.കുട്ടികളുടെ സർഗ്ഗാത്മകത , ആത്മ വിശ്വാസം , ആശയ വിനിമം , ഗ്രൂപ്പ് സ്കിൽസ് തുടങ്ങിയ കഴിവുകൾ വർദ്ധിപ്പിക്കുന്നതിനാണ് നൂറുൽ ഇസ്‌ലാം സർവ്വകലാശാലയിലെ ബി.എസ്. എൽ.പി. വിദ്യാർഥികൾ ഇത്തരത്തിലുളള കലാമത്സരങ്ങൾ സംഘടിപ്പിച്ചത്. സ്വതന്ത്ര സമര സേനാനികളുടെ വേഷം അണിഞ്ഞും സിനിമാ താരങ്ങളുടെ ശബ്ദം അനുകരിച്ചും കുട്ടികൾ കാണികളുടെ മനസ്സ് കീഴടക്കി.",
      thumb: "assets/img/spectrum/257.jpg",
    },
    {
      src: "assets/img/spectrum/258.jpg",
      caption:
        "പത്തനാപുരം ഗാന്ധിഭവനിലെ സ്പെഷ്യൽ സ്കൂളിലെ വിദ്യാർത്ഥികൾക്കായി വിവിധ കലാമത്സരങ്ങൾ ഗാന്ധിഭവനിൽ പ്രവർത്തിക്കുന്ന നിംസ് സ്പെക്ട്രം സംഘടിപ്പിച്ചു . പാട്ടും, മിമിക്രിയും , ഗ്രൂപ്പ് ഡാൻസ് , പ്രച്ഛന്നവേഷം തുടങ്ങിയവയിലൂടെ കുട്ടികൾ വളരെയധികം സന്തോഷത്തോടെ എല്ലാവരുടെയും ശ്രദ്ധയാകര്‍ഷിച്ചു.കുട്ടികളുടെ സർഗ്ഗാത്മകത , ആത്മ വിശ്വാസം , ആശയ വിനിമം , ഗ്രൂപ്പ് സ്കിൽസ് തുടങ്ങിയ കഴിവുകൾ വർദ്ധിപ്പിക്കുന്നതിനാണ് നൂറുൽ ഇസ്‌ലാം സർവ്വകലാശാലയിലെ ബി.എസ്. എൽ.പി. വിദ്യാർഥികൾ ഇത്തരത്തിലുളള കലാമത്സരങ്ങൾ സംഘടിപ്പിച്ചത്. സ്വതന്ത്ര സമര സേനാനികളുടെ വേഷം അണിഞ്ഞും സിനിമാ താരങ്ങളുടെ ശബ്ദം അനുകരിച്ചും കുട്ടികൾ കാണികളുടെ മനസ്സ് കീഴടക്കി.",
      thumb: "assets/img/spectrum/258.jpg",
    },
    {
      src: "assets/img/spectrum/259.jpg",
      caption:
        "പത്തനാപുരം ഗാന്ധിഭവനിലെ സ്പെഷ്യൽ സ്കൂളിലെ വിദ്യാർത്ഥികൾക്കായി വിവിധ കലാമത്സരങ്ങൾ ഗാന്ധിഭവനിൽ പ്രവർത്തിക്കുന്ന നിംസ് സ്പെക്ട്രം സംഘടിപ്പിച്ചു . പാട്ടും, മിമിക്രിയും , ഗ്രൂപ്പ് ഡാൻസ് , പ്രച്ഛന്നവേഷം തുടങ്ങിയവയിലൂടെ കുട്ടികൾ വളരെയധികം സന്തോഷത്തോടെ എല്ലാവരുടെയും ശ്രദ്ധയാകര്‍ഷിച്ചു.കുട്ടികളുടെ സർഗ്ഗാത്മകത , ആത്മ വിശ്വാസം , ആശയ വിനിമം , ഗ്രൂപ്പ് സ്കിൽസ് തുടങ്ങിയ കഴിവുകൾ വർദ്ധിപ്പിക്കുന്നതിനാണ് നൂറുൽ ഇസ്‌ലാം സർവ്വകലാശാലയിലെ ബി.എസ്. എൽ.പി. വിദ്യാർഥികൾ ഇത്തരത്തിലുളള കലാമത്സരങ്ങൾ സംഘടിപ്പിച്ചത്. സ്വതന്ത്ര സമര സേനാനികളുടെ വേഷം അണിഞ്ഞും സിനിമാ താരങ്ങളുടെ ശബ്ദം അനുകരിച്ചും കുട്ടികൾ കാണികളുടെ മനസ്സ് കീഴടക്കി.",
      thumb: "assets/img/spectrum/259.jpg",
    },
    {
      src: "assets/img/spectrum/260.jpg",
      caption:
        "പത്തനാപുരം ഗാന്ധിഭവനിലെ സ്പെഷ്യൽ സ്കൂളിലെ വിദ്യാർത്ഥികൾക്കായി വിവിധ കലാമത്സരങ്ങൾ ഗാന്ധിഭവനിൽ പ്രവർത്തിക്കുന്ന നിംസ് സ്പെക്ട്രം സംഘടിപ്പിച്ചു . പാട്ടും, മിമിക്രിയും , ഗ്രൂപ്പ് ഡാൻസ് , പ്രച്ഛന്നവേഷം തുടങ്ങിയവയിലൂടെ കുട്ടികൾ വളരെയധികം സന്തോഷത്തോടെ എല്ലാവരുടെയും ശ്രദ്ധയാകര്‍ഷിച്ചു.കുട്ടികളുടെ സർഗ്ഗാത്മകത , ആത്മ വിശ്വാസം , ആശയ വിനിമം , ഗ്രൂപ്പ് സ്കിൽസ് തുടങ്ങിയ കഴിവുകൾ വർദ്ധിപ്പിക്കുന്നതിനാണ് നൂറുൽ ഇസ്‌ലാം സർവ്വകലാശാലയിലെ ബി.എസ്. എൽ.പി. വിദ്യാർഥികൾ ഇത്തരത്തിലുളള കലാമത്സരങ്ങൾ സംഘടിപ്പിച്ചത്. സ്വതന്ത്ര സമര സേനാനികളുടെ വേഷം അണിഞ്ഞും സിനിമാ താരങ്ങളുടെ ശബ്ദം അനുകരിച്ചും കുട്ടികൾ കാണികളുടെ മനസ്സ് കീഴടക്കി.",
      thumb: "assets/img/spectrum/260.jpg",
    },

    {
      src: "assets/img/spectrum/239.jpg",
      caption:
        "നിംസ് സ്പെക്ട്രം  ശിശുദിനാഘോഷം…...  ഭാരതത്തിന്റെ പ്രഥമ പ്രധാനമന്ത്രി ജവഹർലാൽ നെഹ്റുവിന്റെ ജന്മദിന സ്മരണയിൽ കുഞ്ഞുമക്കളിൽ നന്മയുടെ വെളിച്ചം പകർന്ന് നൽകുന്ന ശിശുദിനം ആഘോഷമാക്കി നിംസ് സ്പെക്ട്രം ശിശു വികസന ഗവേഷണ കേന്ദ്രത്തിലെ കുട്ടികളും    രക്ഷാതാക്കളും .",
      thumb: "assets/img/spectrum/239.jpg",
    },
    {
      src: "assets/img/spectrum/240.jpg",
      caption:
        "നിംസ് സ്പെക്ട്രം  ശിശുദിനാഘോഷം…...  ഭാരതത്തിന്റെ പ്രഥമ പ്രധാനമന്ത്രി ജവഹർലാൽ നെഹ്റുവിന്റെ ജന്മദിന സ്മരണയിൽ കുഞ്ഞുമക്കളിൽ നന്മയുടെ വെളിച്ചം പകർന്ന് നൽകുന്ന ശിശുദിനം ആഘോഷമാക്കി നിംസ് സ്പെക്ട്രം ശിശു വികസന ഗവേഷണ കേന്ദ്രത്തിലെ കുട്ടികളും    രക്ഷാതാക്കളും .",
      thumb: "assets/img/Pastevents/240.jpg",
    },
    {
      src: "assets/img/spectrum/241.jpg",
      caption:
        "നിംസ് സ്പെക്ട്രം  ശിശുദിനാഘോഷം…...  ഭാരതത്തിന്റെ പ്രഥമ പ്രധാനമന്ത്രി ജവഹർലാൽ നെഹ്റുവിന്റെ ജന്മദിന സ്മരണയിൽ കുഞ്ഞുമക്കളിൽ നന്മയുടെ വെളിച്ചം പകർന്ന് നൽകുന്ന ശിശുദിനം ആഘോഷമാക്കി നിംസ് സ്പെക്ട്രം ശിശു വികസന ഗവേഷണ കേന്ദ്രത്തിലെ കുട്ടികളും    രക്ഷാതാക്കളും .",
      thumb: "assets/img/Pastevents/241.jpg",
    },
    {
      src: "assets/img/spectrum/242.jpg",
      caption:
        "നിംസ് സ്പെക്ട്രം  ശിശുദിനാഘോഷം…...  ഭാരതത്തിന്റെ പ്രഥമ പ്രധാനമന്ത്രി ജവഹർലാൽ നെഹ്റുവിന്റെ ജന്മദിന സ്മരണയിൽ കുഞ്ഞുമക്കളിൽ നന്മയുടെ വെളിച്ചം പകർന്ന് നൽകുന്ന ശിശുദിനം ആഘോഷമാക്കി നിംസ് സ്പെക്ട്രം ശിശു വികസന ഗവേഷണ കേന്ദ്രത്തിലെ കുട്ടികളും    രക്ഷാതാക്കളും .",
      thumb: "assets/img/Pastevents/242.jpg",
    },
    {
      src: "assets/img/spectrum/243.jpg",
      caption:
        "നിംസ് സ്പെക്ട്രം  ശിശുദിനാഘോഷം…...  ഭാരതത്തിന്റെ പ്രഥമ പ്രധാനമന്ത്രി ജവഹർലാൽ നെഹ്റുവിന്റെ ജന്മദിന സ്മരണയിൽ കുഞ്ഞുമക്കളിൽ നന്മയുടെ വെളിച്ചം പകർന്ന് നൽകുന്ന ശിശുദിനം ആഘോഷമാക്കി നിംസ് സ്പെക്ട്രം ശിശു വികസന ഗവേഷണ കേന്ദ്രത്തിലെ കുട്ടികളും    രക്ഷാതാക്കളും .",
      thumb: "assets/img/Pastevents/243.jpg",
    },

    {
      src: "assets/img/spectrum/231.jpg",
      caption:
        "പത്തനാപുരം ഗാന്ധിഭവനിൽ ആരംഭിച്ച നിംസ് സ്പെക്ട്രം ശിശു വികസന ഗവേഷണ  കേന്ദ്രത്തിൽ ക്ലിനിക്കൽ സൈക്കോളജി വിഭാഗത്തിന്റെ സേവനം ലഭ്യമാക്കി. നിംസ് സ്പെക്ട്രം  ശിശു വികസന ഗവേഷണ കേന്ദ്രത്തിലെ ക്ലിനിക്കൽ സൈക്കോളജിസ്റ്റ് ഡോ. വിമൽകുമാറിന്റെ നേതൃത്വത്തിൽ പഠന വൈകല്യങ്ങൾ , അകാരണമായ ഭീതി , സ്വാഭാവ വൈകല്യങ്ങൾ തുടങ്ങിയ കുട്ടികളുടെ പ്രശ്നങ്ങൾക്ക് വേണ്ടിയുള്ള  അസസ്സ്മെന്റും പരിശോധനകളും നടത്തി .കുട്ടികളുടെ ബുദ്ധിക്ഷമത പരിശോധനയും (ഐക്യു പരിശോധന) നടത്തി. നൂറുൽ ഇസ്‌ലാം സർവ്വകലാശാലയിലെ ഓഡിയോളജി ആൻഡ് സ്പീച്ച് ലാംഗ്വേജ് പത്തോളജി വിദ്യാർത്ഥികൾ കുട്ടികൾക്ക് സ്പീച്ച് തൊപ്പി , ശ്രവണ പരിശോധന , ഐക്യു പരിശോധന തുടങ്ങിയവ നൽകി.",
      thumb: "assets/img/spectrum/231.jpg",
    },
    {
      src: "assets/img/spectrum/232.jpg",
      caption:
        "പത്തനാപുരം ഗാന്ധിഭവനിൽ ആരംഭിച്ച നിംസ് സ്പെക്ട്രം ശിശു വികസന ഗവേഷണ  കേന്ദ്രത്തിൽ ക്ലിനിക്കൽ സൈക്കോളജി വിഭാഗത്തിന്റെ സേവനം ലഭ്യമാക്കി. നിംസ് സ്പെക്ട്രം  ശിശു വികസന ഗവേഷണ കേന്ദ്രത്തിലെ ക്ലിനിക്കൽ സൈക്കോളജിസ്റ്റ് ഡോ. വിമൽകുമാറിന്റെ നേതൃത്വത്തിൽ പഠന വൈകല്യങ്ങൾ , അകാരണമായ ഭീതി , സ്വാഭാവ വൈകല്യങ്ങൾ തുടങ്ങിയ കുട്ടികളുടെ പ്രശ്നങ്ങൾക്ക് വേണ്ടിയുള്ള  അസസ്സ്മെന്റും പരിശോധനകളും നടത്തി .കുട്ടികളുടെ ബുദ്ധിക്ഷമത പരിശോധനയും (ഐക്യു പരിശോധന) നടത്തി. നൂറുൽ ഇസ്‌ലാം സർവ്വകലാശാലയിലെ ഓഡിയോളജി ആൻഡ് സ്പീച്ച് ലാംഗ്വേജ് പത്തോളജി വിദ്യാർത്ഥികൾ കുട്ടികൾക്ക് സ്പീച്ച് തൊപ്പി , ശ്രവണ പരിശോധന , ഐക്യു പരിശോധന തുടങ്ങിയവ നൽകി.",
      thumb: "assets/img/spectrum/232.jpg",
    },
    {
      src: "assets/img/spectrum/233.jpg",
      caption:
        "പത്തനാപുരം ഗാന്ധിഭവനിൽ ആരംഭിച്ച നിംസ് സ്പെക്ട്രം ശിശു വികസന ഗവേഷണ  കേന്ദ്രത്തിൽ ക്ലിനിക്കൽ സൈക്കോളജി വിഭാഗത്തിന്റെ സേവനം ലഭ്യമാക്കി. നിംസ് സ്പെക്ട്രം  ശിശു വികസന ഗവേഷണ കേന്ദ്രത്തിലെ ക്ലിനിക്കൽ സൈക്കോളജിസ്റ്റ് ഡോ. വിമൽകുമാറിന്റെ നേതൃത്വത്തിൽ പഠന വൈകല്യങ്ങൾ , അകാരണമായ ഭീതി , സ്വാഭാവ വൈകല്യങ്ങൾ തുടങ്ങിയ കുട്ടികളുടെ പ്രശ്നങ്ങൾക്ക് വേണ്ടിയുള്ള  അസസ്സ്മെന്റും പരിശോധനകളും നടത്തി .കുട്ടികളുടെ ബുദ്ധിക്ഷമത പരിശോധനയും (ഐക്യു പരിശോധന) നടത്തി. നൂറുൽ ഇസ്‌ലാം സർവ്വകലാശാലയിലെ ഓഡിയോളജി ആൻഡ് സ്പീച്ച് ലാംഗ്വേജ് പത്തോളജി വിദ്യാർത്ഥികൾ കുട്ടികൾക്ക് സ്പീച്ച് തൊപ്പി , ശ്രവണ പരിശോധന , ഐക്യു പരിശോധന തുടങ്ങിയവ നൽകി.",
      thumb: "assets/img/spectrum/233.jpg",
    },
    {
      src: "assets/img/spectrum/234.jpg",
      caption:
        "പത്തനാപുരം ഗാന്ധിഭവനിൽ ആരംഭിച്ച നിംസ് സ്പെക്ട്രം ശിശു വികസന ഗവേഷണ  കേന്ദ്രത്തിൽ ക്ലിനിക്കൽ സൈക്കോളജി വിഭാഗത്തിന്റെ സേവനം ലഭ്യമാക്കി. നിംസ് സ്പെക്ട്രം  ശിശു വികസന ഗവേഷണ കേന്ദ്രത്തിലെ ക്ലിനിക്കൽ സൈക്കോളജിസ്റ്റ് ഡോ. വിമൽകുമാറിന്റെ നേതൃത്വത്തിൽ പഠന വൈകല്യങ്ങൾ , അകാരണമായ ഭീതി , സ്വാഭാവ വൈകല്യങ്ങൾ തുടങ്ങിയ കുട്ടികളുടെ പ്രശ്നങ്ങൾക്ക് വേണ്ടിയുള്ള  അസസ്സ്മെന്റും പരിശോധനകളും നടത്തി .കുട്ടികളുടെ ബുദ്ധിക്ഷമത പരിശോധനയും (ഐക്യു പരിശോധന) നടത്തി. നൂറുൽ ഇസ്‌ലാം സർവ്വകലാശാലയിലെ ഓഡിയോളജി ആൻഡ് സ്പീച്ച് ലാംഗ്വേജ് പത്തോളജി വിദ്യാർത്ഥികൾ കുട്ടികൾക്ക് സ്പീച്ച് തൊപ്പി , ശ്രവണ പരിശോധന , ഐക്യു പരിശോധന തുടങ്ങിയവ നൽകി.",
      thumb: "assets/img/spectrum/234.jpg",
    },
    {
      src: "assets/img/spectrum/235.jpg",
      caption:
        "പത്തനാപുരം ഗാന്ധിഭവനിൽ ആരംഭിച്ച നിംസ് സ്പെക്ട്രം ശിശു വികസന ഗവേഷണ  കേന്ദ്രത്തിൽ ക്ലിനിക്കൽ സൈക്കോളജി വിഭാഗത്തിന്റെ സേവനം ലഭ്യമാക്കി. നിംസ് സ്പെക്ട്രം  ശിശു വികസന ഗവേഷണ കേന്ദ്രത്തിലെ ക്ലിനിക്കൽ സൈക്കോളജിസ്റ്റ് ഡോ. വിമൽകുമാറിന്റെ നേതൃത്വത്തിൽ പഠന വൈകല്യങ്ങൾ , അകാരണമായ ഭീതി , സ്വാഭാവ വൈകല്യങ്ങൾ തുടങ്ങിയ കുട്ടികളുടെ പ്രശ്നങ്ങൾക്ക് വേണ്ടിയുള്ള  അസസ്സ്മെന്റും പരിശോധനകളും നടത്തി .കുട്ടികളുടെ ബുദ്ധിക്ഷമത പരിശോധനയും (ഐക്യു പരിശോധന) നടത്തി. നൂറുൽ ഇസ്‌ലാം സർവ്വകലാശാലയിലെ ഓഡിയോളജി ആൻഡ് സ്പീച്ച് ലാംഗ്വേജ് പത്തോളജി വിദ്യാർത്ഥികൾ കുട്ടികൾക്ക് സ്പീച്ച് തൊപ്പി , ശ്രവണ പരിശോധന , ഐക്യു പരിശോധന തുടങ്ങിയവ നൽകി.",
      thumb: "assets/img/spectrum/235.jpg",
    },
    {
      src: "assets/img/spectrum/236.jpg",
      caption:
        "പത്തനാപുരം ഗാന്ധിഭവനിൽ ആരംഭിച്ച നിംസ് സ്പെക്ട്രം ശിശു വികസന ഗവേഷണ  കേന്ദ്രത്തിൽ ക്ലിനിക്കൽ സൈക്കോളജി വിഭാഗത്തിന്റെ സേവനം ലഭ്യമാക്കി. നിംസ് സ്പെക്ട്രം  ശിശു വികസന ഗവേഷണ കേന്ദ്രത്തിലെ ക്ലിനിക്കൽ സൈക്കോളജിസ്റ്റ് ഡോ. വിമൽകുമാറിന്റെ നേതൃത്വത്തിൽ പഠന വൈകല്യങ്ങൾ , അകാരണമായ ഭീതി , സ്വാഭാവ വൈകല്യങ്ങൾ തുടങ്ങിയ കുട്ടികളുടെ പ്രശ്നങ്ങൾക്ക് വേണ്ടിയുള്ള  അസസ്സ്മെന്റും പരിശോധനകളും നടത്തി .കുട്ടികളുടെ ബുദ്ധിക്ഷമത പരിശോധനയും (ഐക്യു പരിശോധന) നടത്തി. നൂറുൽ ഇസ്‌ലാം സർവ്വകലാശാലയിലെ ഓഡിയോളജി ആൻഡ് സ്പീച്ച് ലാംഗ്വേജ് പത്തോളജി വിദ്യാർത്ഥികൾ കുട്ടികൾക്ക് സ്പീച്ച് തൊപ്പി , ശ്രവണ പരിശോധന , ഐക്യു പരിശോധന തുടങ്ങിയവ നൽകി.",
      thumb: "assets/img/spectrum/236.jpg",
    },
    {
      src: "assets/img/spectrum/237.jpg",
      caption:
        "പത്തനാപുരം ഗാന്ധിഭവനിൽ ആരംഭിച്ച നിംസ് സ്പെക്ട്രം ശിശു വികസന ഗവേഷണ  കേന്ദ്രത്തിൽ ക്ലിനിക്കൽ സൈക്കോളജി വിഭാഗത്തിന്റെ സേവനം ലഭ്യമാക്കി. നിംസ് സ്പെക്ട്രം  ശിശു വികസന ഗവേഷണ കേന്ദ്രത്തിലെ ക്ലിനിക്കൽ സൈക്കോളജിസ്റ്റ് ഡോ. വിമൽകുമാറിന്റെ നേതൃത്വത്തിൽ പഠന വൈകല്യങ്ങൾ , അകാരണമായ ഭീതി , സ്വാഭാവ വൈകല്യങ്ങൾ തുടങ്ങിയ കുട്ടികളുടെ പ്രശ്നങ്ങൾക്ക് വേണ്ടിയുള്ള  അസസ്സ്മെന്റും പരിശോധനകളും നടത്തി .കുട്ടികളുടെ ബുദ്ധിക്ഷമത പരിശോധനയും (ഐക്യു പരിശോധന) നടത്തി. നൂറുൽ ഇസ്‌ലാം സർവ്വകലാശാലയിലെ ഓഡിയോളജി ആൻഡ് സ്പീച്ച് ലാംഗ്വേജ് പത്തോളജി വിദ്യാർത്ഥികൾ കുട്ടികൾക്ക് സ്പീച്ച് തൊപ്പി , ശ്രവണ പരിശോധന , ഐക്യു പരിശോധന തുടങ്ങിയവ നൽകി.",
      thumb: "assets/img/spectrum/237.jpg",
    },
    {
      src: "assets/img/spectrum/238.jpg",
      caption:
        "പത്തനാപുരം ഗാന്ധിഭവനിൽ ആരംഭിച്ച നിംസ് സ്പെക്ട്രം ശിശു വികസന ഗവേഷണ  കേന്ദ്രത്തിൽ ക്ലിനിക്കൽ സൈക്കോളജി വിഭാഗത്തിന്റെ സേവനം ലഭ്യമാക്കി. നിംസ് സ്പെക്ട്രം  ശിശു വികസന ഗവേഷണ കേന്ദ്രത്തിലെ ക്ലിനിക്കൽ സൈക്കോളജിസ്റ്റ് ഡോ. വിമൽകുമാറിന്റെ നേതൃത്വത്തിൽ പഠന വൈകല്യങ്ങൾ , അകാരണമായ ഭീതി , സ്വാഭാവ വൈകല്യങ്ങൾ തുടങ്ങിയ കുട്ടികളുടെ പ്രശ്നങ്ങൾക്ക് വേണ്ടിയുള്ള  അസസ്സ്മെന്റും പരിശോധനകളും നടത്തി .കുട്ടികളുടെ ബുദ്ധിക്ഷമത പരിശോധനയും (ഐക്യു പരിശോധന) നടത്തി. നൂറുൽ ഇസ്‌ലാം സർവ്വകലാശാലയിലെ ഓഡിയോളജി ആൻഡ് സ്പീച്ച് ലാംഗ്വേജ് പത്തോളജി വിദ്യാർത്ഥികൾ കുട്ടികൾക്ക് സ്പീച്ച് തൊപ്പി , ശ്രവണ പരിശോധന , ഐക്യു പരിശോധന തുടങ്ങിയവ നൽകി.",
      thumb: "assets/img/spectrum/238.jpg",
    },
    {
      src: "assets/img/spectrum/201.jpg",
      caption:
        "A “Special Camp for the Differently Abled Children” between 3 and 15 years, was organized at NIMS MEDICITY on 6th February 2019 to explore their special abilities as well as their physical and medical difficulties and suggest appropriate follow-up trainings. The camp was led by Mrs J. Princemol, Trainer- Special Education, NIMS-Anne Sullivan Centre for  Specially Abled Children, NIMS Medicity, in which all related departments such as ENT, Orthopedics, pediatrics, psychiatry, physiatry, psychology, audiology & speech, speech therapy, child development therapy etc.  participated. The camp was inaugurated by Mr Pandalam Sudhakaran, Former Minister of Kerala in the gracious presence of  Padmashri P. Gopinathan Nair. Mr Pannyan Raveendran, former MP of Thriuvananthapuram presided and  Mr. M.S. Faizal Khan, Managing Director of NIMS Medicity delivered the introductory talk.  The Logo of NIMS-Anne Sullivan Centre for Specially Abled Children was released by Mr Pannyan Raveendran and the same was received by Mr. Karamana Jayan, BJP National Council Member, who was the guest of honor.",
      thumb: "assets/img/spectrum/201.jpg",
    },
    {
      src: "assets/img/spectrum/202.jpg",
      caption:
        "A “Special Camp for the Differently Abled Children” between 3 and 15 years, was organized at NIMS MEDICITY on 6th February 2019 to explore their special abilities as well as their physical and medical difficulties and suggest appropriate follow-up trainings. The camp was led by Mrs J. Princemol, Trainer- Special Education, NIMS-Anne Sullivan Centre for  Specially Abled Children, NIMS Medicity, in which all related departments such as ENT, Orthopedics, pediatrics, psychiatry, physiatry, psychology, audiology & speech, speech therapy, child development therapy etc.  participated. The camp was inaugurated by Mr Pandalam Sudhakaran, Former Minister of Kerala in the gracious presence of  Padmashri P. Gopinathan Nair. Mr Pannyan Raveendran, former MP of Thriuvananthapuram presided and  Mr. M.S. Faizal Khan, Managing Director of NIMS Medicity delivered the introductory talk.  The Logo of NIMS-Anne Sullivan Centre for Specially Abled Children was released by Mr Pannyan Raveendran and the same was received by Mr. Karamana Jayan, BJP National Council Member, who was the guest of honor.",
      thumb: "assets/img/spectrum/202.jpg",
    },
    {
      src: "assets/img/spectrum/203.jpg",
      caption:
        "A “Special Camp for the Differently Abled Children” between 3 and 15 years, was organized at NIMS MEDICITY on 6th February 2019 to explore their special abilities as well as their physical and medical difficulties and suggest appropriate follow-up trainings. The camp was led by Mrs J. Princemol, Trainer- Special Education, NIMS-Anne Sullivan Centre for  Specially Abled Children, NIMS Medicity, in which all related departments such as ENT, Orthopedics, pediatrics, psychiatry, physiatry, psychology, audiology & speech, speech therapy, child development therapy etc.  participated. The camp was inaugurated by Mr Pandalam Sudhakaran, Former Minister of Kerala in the gracious presence of  Padmashri P. Gopinathan Nair. Mr Pannyan Raveendran, former MP of Thriuvananthapuram presided and  Mr. M.S. Faizal Khan, Managing Director of NIMS Medicity delivered the introductory talk.  The Logo of NIMS-Anne Sullivan Centre for Specially Abled Children was released by Mr Pannyan Raveendran and the same was received by Mr. Karamana Jayan, BJP National Council Member, who was the guest of honor.",
      thumb: "assets/img/spectrum/203.jpg",
    },
    {
      src: "assets/img/spectrum/204.jpg",
      caption:
        "A “Special Camp for the Differently Abled Children” between 3 and 15 years, was organized at NIMS MEDICITY on 6th February 2019 to explore their special abilities as well as their physical and medical difficulties and suggest appropriate follow-up trainings. The camp was led by Mrs J. Princemol, Trainer- Special Education, NIMS-Anne Sullivan Centre for  Specially Abled Children, NIMS Medicity, in which all related departments such as ENT, Orthopedics, pediatrics, psychiatry, physiatry, psychology, audiology & speech, speech therapy, child development therapy etc.  participated. The camp was inaugurated by Mr Pandalam Sudhakaran, Former Minister of Kerala in the gracious presence of  Padmashri P. Gopinathan Nair. Mr Pannyan Raveendran, former MP of Thriuvananthapuram presided and  Mr. M.S. Faizal Khan, Managing Director of NIMS Medicity delivered the introductory talk.  The Logo of NIMS-Anne Sullivan Centre for Specially Abled Children was released by Mr Pannyan Raveendran and the same was received by Mr. Karamana Jayan, BJP National Council Member, who was the guest of honor.",
      thumb: "assets/img/spectrum/204.jpg",
    },
    {
      src: "assets/img/spectrum/205.jpg",
      caption:
        "A “Special Camp for the Differently Abled Children” between 3 and 15 years, was organized at NIMS MEDICITY on 6th February 2019 to explore their special abilities as well as their physical and medical difficulties and suggest appropriate follow-up trainings. The camp was led by Mrs J. Princemol, Trainer- Special Education, NIMS-Anne Sullivan Centre for  Specially Abled Children, NIMS Medicity, in which all related departments such as ENT, Orthopedics, pediatrics, psychiatry, physiatry, psychology, audiology & speech, speech therapy, child development therapy etc.  participated. The camp was inaugurated by Mr Pandalam Sudhakaran, Former Minister of Kerala in the gracious presence of  Padmashri P. Gopinathan Nair. Mr Pannyan Raveendran, former MP of Thriuvananthapuram presided and  Mr. M.S. Faizal Khan, Managing Director of NIMS Medicity delivered the introductory talk.  The Logo of NIMS-Anne Sullivan Centre for Specially Abled Children was released by Mr Pannyan Raveendran and the same was received by Mr. Karamana Jayan, BJP National Council Member, who was the guest of honor.",
      thumb: "assets/img/spectrum/205.jpg",
    },
    {
      src: "assets/img/spectrum/206.jpg",
      caption:
        "A “Special Camp for the Differently Abled Children” between 3 and 15 years, was organized at NIMS MEDICITY on 6th February 2019 to explore their special abilities as well as their physical and medical difficulties and suggest appropriate follow-up trainings. The camp was led by Mrs J. Princemol, Trainer- Special Education, NIMS-Anne Sullivan Centre for  Specially Abled Children, NIMS Medicity, in which all related departments such as ENT, Orthopedics, pediatrics, psychiatry, physiatry, psychology, audiology & speech, speech therapy, child development therapy etc.  participated. The camp was inaugurated by Mr Pandalam Sudhakaran, Former Minister of Kerala in the gracious presence of  Padmashri P. Gopinathan Nair. Mr Pannyan Raveendran, former MP of Thriuvananthapuram presided and  Mr. M.S. Faizal Khan, Managing Director of NIMS Medicity delivered the introductory talk.  The Logo of NIMS-Anne Sullivan Centre for Specially Abled Children was released by Mr Pannyan Raveendran and the same was received by Mr. Karamana Jayan, BJP National Council Member, who was the guest of honor.",
      thumb: "assets/img/spectrum/206.jpg",
    },
    {
      src: "assets/img/spectrum/207.jpg",
      caption:
        "A “Special Camp for the Differently Abled Children” between 3 and 15 years, was organized at NIMS MEDICITY on 6th February 2019 to explore their special abilities as well as their physical and medical difficulties and suggest appropriate follow-up trainings. The camp was led by Mrs J. Princemol, Trainer- Special Education, NIMS-Anne Sullivan Centre for  Specially Abled Children, NIMS Medicity, in which all related departments such as ENT, Orthopedics, pediatrics, psychiatry, physiatry, psychology, audiology & speech, speech therapy, child development therapy etc.  participated. The camp was inaugurated by Mr Pandalam Sudhakaran, Former Minister of Kerala in the gracious presence of  Padmashri P. Gopinathan Nair. Mr Pannyan Raveendran, former MP of Thriuvananthapuram presided and  Mr. M.S. Faizal Khan, Managing Director of NIMS Medicity delivered the introductory talk.  The Logo of NIMS-Anne Sullivan Centre for Specially Abled Children was released by Mr Pannyan Raveendran and the same was received by Mr. Karamana Jayan, BJP National Council Member, who was the guest of honor.",
      thumb: "assets/img/spectrum/207.jpg",
    },
    {
      src: "assets/img/spectrum/208.jpg",
      caption:
        "A “Special Camp for the Differently Abled Children” between 3 and 15 years, was organized at NIMS MEDICITY on 6th February 2019 to explore their special abilities as well as their physical and medical difficulties and suggest appropriate follow-up trainings. The camp was led by Mrs J. Princemol, Trainer- Special Education, NIMS-Anne Sullivan Centre for  Specially Abled Children, NIMS Medicity, in which all related departments such as ENT, Orthopedics, pediatrics, psychiatry, physiatry, psychology, audiology & speech, speech therapy, child development therapy etc.  participated. The camp was inaugurated by Mr Pandalam Sudhakaran, Former Minister of Kerala in the gracious presence of  Padmashri P. Gopinathan Nair. Mr Pannyan Raveendran, former MP of Thriuvananthapuram presided and  Mr. M.S. Faizal Khan, Managing Director of NIMS Medicity delivered the introductory talk.  The Logo of NIMS-Anne Sullivan Centre for Specially Abled Children was released by Mr Pannyan Raveendran and the same was received by Mr. Karamana Jayan, BJP National Council Member, who was the guest of honor.",
      thumb: "assets/img/spectrum/208.jpg",
    },
    {
      src: "assets/img/spectrum/209.jpg",
      caption:
        "A “Special Camp for the Differently Abled Children” between 3 and 15 years, was organized at NIMS MEDICITY on 6th February 2019 to explore their special abilities as well as their physical and medical difficulties and suggest appropriate follow-up trainings. The camp was led by Mrs J. Princemol, Trainer- Special Education, NIMS-Anne Sullivan Centre for  Specially Abled Children, NIMS Medicity, in which all related departments such as ENT, Orthopedics, pediatrics, psychiatry, physiatry, psychology, audiology & speech, speech therapy, child development therapy etc.  participated. The camp was inaugurated by Mr Pandalam Sudhakaran, Former Minister of Kerala in the gracious presence of  Padmashri P. Gopinathan Nair. Mr Pannyan Raveendran, former MP of Thriuvananthapuram presided and  Mr. M.S. Faizal Khan, Managing Director of NIMS Medicity delivered the introductory talk.  The Logo of NIMS-Anne Sullivan Centre for Specially Abled Children was released by Mr Pannyan Raveendran and the same was received by Mr. Karamana Jayan, BJP National Council Member, who was the guest of honor.",
      thumb: "assets/img/spectrum/209.jpg",
    },
    {
      src: "assets/img/spectrum/210.jpg",
      caption:
        "A “Special Camp for the Differently Abled Children” between 3 and 15 years, was organized at NIMS MEDICITY on 6th February 2019 to explore their special abilities as well as their physical and medical difficulties and suggest appropriate follow-up trainings. The camp was led by Mrs J. Princemol, Trainer- Special Education, NIMS-Anne Sullivan Centre for  Specially Abled Children, NIMS Medicity, in which all related departments such as ENT, Orthopedics, pediatrics, psychiatry, physiatry, psychology, audiology & speech, speech therapy, child development therapy etc.  participated. The camp was inaugurated by Mr Pandalam Sudhakaran, Former Minister of Kerala in the gracious presence of  Padmashri P. Gopinathan Nair. Mr Pannyan Raveendran, former MP of Thriuvananthapuram presided and  Mr. M.S. Faizal Khan, Managing Director of NIMS Medicity delivered the introductory talk.  The Logo of NIMS-Anne Sullivan Centre for Specially Abled Children was released by Mr Pannyan Raveendran and the same was received by Mr. Karamana Jayan, BJP National Council Member, who was the guest of honor.",
      thumb: "assets/img/spectrum/210.jpg",
    },
    {
      src: "assets/img/spectrum/211.jpg",
      caption:
        "A “Special Camp for the Differently Abled Children” between 3 and 15 years, was organized at NIMS MEDICITY on 6th February 2019 to explore their special abilities as well as their physical and medical difficulties and suggest appropriate follow-up trainings. The camp was led by Mrs J. Princemol, Trainer- Special Education, NIMS-Anne Sullivan Centre for  Specially Abled Children, NIMS Medicity, in which all related departments such as ENT, Orthopedics, pediatrics, psychiatry, physiatry, psychology, audiology & speech, speech therapy, child development therapy etc.  participated. The camp was inaugurated by Mr Pandalam Sudhakaran, Former Minister of Kerala in the gracious presence of  Padmashri P. Gopinathan Nair. Mr Pannyan Raveendran, former MP of Thriuvananthapuram presided and  Mr. M.S. Faizal Khan, Managing Director of NIMS Medicity delivered the introductory talk.  The Logo of NIMS-Anne Sullivan Centre for Specially Abled Children was released by Mr Pannyan Raveendran and the same was received by Mr. Karamana Jayan, BJP National Council Member, who was the guest of honor.",
      thumb: "assets/img/spectrum/211.jpg",
    },
    {
      src: "assets/img/spectrum/212.jpg",
      caption:
        "A “Special Camp for the Differently Abled Children” between 3 and 15 years, was organized at NIMS MEDICITY on 6th February 2019 to explore their special abilities as well as their physical and medical difficulties and suggest appropriate follow-up trainings. The camp was led by Mrs J. Princemol, Trainer- Special Education, NIMS-Anne Sullivan Centre for  Specially Abled Children, NIMS Medicity, in which all related departments such as ENT, Orthopedics, pediatrics, psychiatry, physiatry, psychology, audiology & speech, speech therapy, child development therapy etc.  participated. The camp was inaugurated by Mr Pandalam Sudhakaran, Former Minister of Kerala in the gracious presence of  Padmashri P. Gopinathan Nair. Mr Pannyan Raveendran, former MP of Thriuvananthapuram presided and  Mr. M.S. Faizal Khan, Managing Director of NIMS Medicity delivered the introductory talk.  The Logo of NIMS-Anne Sullivan Centre for Specially Abled Children was released by Mr Pannyan Raveendran and the same was received by Mr. Karamana Jayan, BJP National Council Member, who was the guest of honor.",
      thumb: "assets/img/spectrum/212.jpg",
    },
    {
      src: "assets/img/spectrum/213.jpg",
      caption:
        "A “Special Camp for the Differently Abled Children” between 3 and 15 years, was organized at NIMS MEDICITY on 6th February 2019 to explore their special abilities as well as their physical and medical difficulties and suggest appropriate follow-up trainings. The camp was led by Mrs J. Princemol, Trainer- Special Education, NIMS-Anne Sullivan Centre for  Specially Abled Children, NIMS Medicity, in which all related departments such as ENT, Orthopedics, pediatrics, psychiatry, physiatry, psychology, audiology & speech, speech therapy, child development therapy etc.  participated. The camp was inaugurated by Mr Pandalam Sudhakaran, Former Minister of Kerala in the gracious presence of  Padmashri P. Gopinathan Nair. Mr Pannyan Raveendran, former MP of Thriuvananthapuram presided and  Mr. M.S. Faizal Khan, Managing Director of NIMS Medicity delivered the introductory talk.  The Logo of NIMS-Anne Sullivan Centre for Specially Abled Children was released by Mr Pannyan Raveendran and the same was received by Mr. Karamana Jayan, BJP National Council Member, who was the guest of honor.",
      thumb: "assets/img/spectrum/213.jpg",
    },
    {
      src: "assets/img/spectrum/214.jpg",
      caption:
        "A “Special Camp for the Differently Abled Children” between 3 and 15 years, was organized at NIMS MEDICITY on 6th February 2019 to explore their special abilities as well as their physical and medical difficulties and suggest appropriate follow-up trainings. The camp was led by Mrs J. Princemol, Trainer- Special Education, NIMS-Anne Sullivan Centre for  Specially Abled Children, NIMS Medicity, in which all related departments such as ENT, Orthopedics, pediatrics, psychiatry, physiatry, psychology, audiology & speech, speech therapy, child development therapy etc.  participated. The camp was inaugurated by Mr Pandalam Sudhakaran, Former Minister of Kerala in the gracious presence of  Padmashri P. Gopinathan Nair. Mr Pannyan Raveendran, former MP of Thriuvananthapuram presided and  Mr. M.S. Faizal Khan, Managing Director of NIMS Medicity delivered the introductory talk.  The Logo of NIMS-Anne Sullivan Centre for Specially Abled Children was released by Mr Pannyan Raveendran and the same was received by Mr. Karamana Jayan, BJP National Council Member, who was the guest of honor.",
      thumb: "assets/img/spectrum/214.jpg",
    },
    {
      src: "assets/img/spectrum/215.jpg",
      caption:
        "A “Special Camp for the Differently Abled Children” between 3 and 15 years, was organized at NIMS MEDICITY on 6th February 2019 to explore their special abilities as well as their physical and medical difficulties and suggest appropriate follow-up trainings. The camp was led by Mrs J. Princemol, Trainer- Special Education, NIMS-Anne Sullivan Centre for  Specially Abled Children, NIMS Medicity, in which all related departments such as ENT, Orthopedics, pediatrics, psychiatry, physiatry, psychology, audiology & speech, speech therapy, child development therapy etc.  participated. The camp was inaugurated by Mr Pandalam Sudhakaran, Former Minister of Kerala in the gracious presence of  Padmashri P. Gopinathan Nair. Mr Pannyan Raveendran, former MP of Thriuvananthapuram presided and  Mr. M.S. Faizal Khan, Managing Director of NIMS Medicity delivered the introductory talk.  The Logo of NIMS-Anne Sullivan Centre for Specially Abled Children was released by Mr Pannyan Raveendran and the same was received by Mr. Karamana Jayan, BJP National Council Member, who was the guest of honor.",
      thumb: "assets/img/spectrum/215.jpg",
    },
    {
      src: "assets/img/spectrum/216.jpg",
      caption:
        "A “Special Camp for the Differently Abled Children” between 3 and 15 years, was organized at NIMS MEDICITY on 6th February 2019 to explore their special abilities as well as their physical and medical difficulties and suggest appropriate follow-up trainings. The camp was led by Mrs J. Princemol, Trainer- Special Education, NIMS-Anne Sullivan Centre for  Specially Abled Children, NIMS Medicity, in which all related departments such as ENT, Orthopedics, pediatrics, psychiatry, physiatry, psychology, audiology & speech, speech therapy, child development therapy etc.  participated. The camp was inaugurated by Mr Pandalam Sudhakaran, Former Minister of Kerala in the gracious presence of  Padmashri P. Gopinathan Nair. Mr Pannyan Raveendran, former MP of Thriuvananthapuram presided and  Mr. M.S. Faizal Khan, Managing Director of NIMS Medicity delivered the introductory talk.  The Logo of NIMS-Anne Sullivan Centre for Specially Abled Children was released by Mr Pannyan Raveendran and the same was received by Mr. Karamana Jayan, BJP National Council Member, who was the guest of honor.",
      thumb: "assets/img/spectrum/216.jpg",
    },
    {
      src: "assets/img/spectrum/217.jpg",
      caption:
        "A “Special Camp for the Differently Abled Children” between 3 and 15 years, was organized at NIMS MEDICITY on 6th February 2019 to explore their special abilities as well as their physical and medical difficulties and suggest appropriate follow-up trainings. The camp was led by Mrs J. Princemol, Trainer- Special Education, NIMS-Anne Sullivan Centre for  Specially Abled Children, NIMS Medicity, in which all related departments such as ENT, Orthopedics, pediatrics, psychiatry, physiatry, psychology, audiology & speech, speech therapy, child development therapy etc.  participated. The camp was inaugurated by Mr Pandalam Sudhakaran, Former Minister of Kerala in the gracious presence of  Padmashri P. Gopinathan Nair. Mr Pannyan Raveendran, former MP of Thriuvananthapuram presided and  Mr. M.S. Faizal Khan, Managing Director of NIMS Medicity delivered the introductory talk.  The Logo of NIMS-Anne Sullivan Centre for Specially Abled Children was released by Mr Pannyan Raveendran and the same was received by Mr. Karamana Jayan, BJP National Council Member, who was the guest of honor.",
      thumb: "assets/img/spectrum/217.jpg",
    },
    {
      src: "assets/img/spectrum/218.jpg",
      caption:
        "A “Special Camp for the Differently Abled Children” between 3 and 15 years, was organized at NIMS MEDICITY on 6th February 2019 to explore their special abilities as well as their physical and medical difficulties and suggest appropriate follow-up trainings. The camp was led by Mrs J. Princemol, Trainer- Special Education, NIMS-Anne Sullivan Centre for  Specially Abled Children, NIMS Medicity, in which all related departments such as ENT, Orthopedics, pediatrics, psychiatry, physiatry, psychology, audiology & speech, speech therapy, child development therapy etc.  participated. The camp was inaugurated by Mr Pandalam Sudhakaran, Former Minister of Kerala in the gracious presence of  Padmashri P. Gopinathan Nair. Mr Pannyan Raveendran, former MP of Thriuvananthapuram presided and  Mr. M.S. Faizal Khan, Managing Director of NIMS Medicity delivered the introductory talk.  The Logo of NIMS-Anne Sullivan Centre for Specially Abled Children was released by Mr Pannyan Raveendran and the same was received by Mr. Karamana Jayan, BJP National Council Member, who was the guest of honor.",
      thumb: "assets/img/spectrum/218.jpg",
    },
    {
      src: "assets/img/spectrum/219.jpg",
      caption:
        "A “Special Camp for the Differently Abled Children” between 3 and 15 years, was organized at NIMS MEDICITY on 6th February 2019 to explore their special abilities as well as their physical and medical difficulties and suggest appropriate follow-up trainings. The camp was led by Mrs J. Princemol, Trainer- Special Education, NIMS-Anne Sullivan Centre for  Specially Abled Children, NIMS Medicity, in which all related departments such as ENT, Orthopedics, pediatrics, psychiatry, physiatry, psychology, audiology & speech, speech therapy, child development therapy etc.  participated. The camp was inaugurated by Mr Pandalam Sudhakaran, Former Minister of Kerala in the gracious presence of  Padmashri P. Gopinathan Nair. Mr Pannyan Raveendran, former MP of Thriuvananthapuram presided and  Mr. M.S. Faizal Khan, Managing Director of NIMS Medicity delivered the introductory talk.  The Logo of NIMS-Anne Sullivan Centre for Specially Abled Children was released by Mr Pannyan Raveendran and the same was received by Mr. Karamana Jayan, BJP National Council Member, who was the guest of honor.",
      thumb: "assets/img/spectrum/219.jpg",
    },
    {
      src: "assets/img/spectrum/220.jpg",
      caption:
        "A “Special Camp for the Differently Abled Children” between 3 and 15 years, was organized at NIMS MEDICITY on 6th February 2019 to explore their special abilities as well as their physical and medical difficulties and suggest appropriate follow-up trainings. The camp was led by Mrs J. Princemol, Trainer- Special Education, NIMS-Anne Sullivan Centre for  Specially Abled Children, NIMS Medicity, in which all related departments such as ENT, Orthopedics, pediatrics, psychiatry, physiatry, psychology, audiology & speech, speech therapy, child development therapy etc.  participated. The camp was inaugurated by Mr Pandalam Sudhakaran, Former Minister of Kerala in the gracious presence of  Padmashri P. Gopinathan Nair. Mr Pannyan Raveendran, former MP of Thriuvananthapuram presided and  Mr. M.S. Faizal Khan, Managing Director of NIMS Medicity delivered the introductory talk.  The Logo of NIMS-Anne Sullivan Centre for Specially Abled Children was released by Mr Pannyan Raveendran and the same was received by Mr. Karamana Jayan, BJP National Council Member, who was the guest of honor.",
      thumb: "assets/img/spectrum/220.jpg",
    },
    {
      src: "assets/img/spectrum/221.jpg",
      caption:
        "A “Special Camp for the Differently Abled Children” between 3 and 15 years, was organized at NIMS MEDICITY on 6th February 2019 to explore their special abilities as well as their physical and medical difficulties and suggest appropriate follow-up trainings. The camp was led by Mrs J. Princemol, Trainer- Special Education, NIMS-Anne Sullivan Centre for  Specially Abled Children, NIMS Medicity, in which all related departments such as ENT, Orthopedics, pediatrics, psychiatry, physiatry, psychology, audiology & speech, speech therapy, child development therapy etc.  participated. The camp was inaugurated by Mr Pandalam Sudhakaran, Former Minister of Kerala in the gracious presence of  Padmashri P. Gopinathan Nair. Mr Pannyan Raveendran, former MP of Thriuvananthapuram presided and  Mr. M.S. Faizal Khan, Managing Director of NIMS Medicity delivered the introductory talk.  The Logo of NIMS-Anne Sullivan Centre for Specially Abled Children was released by Mr Pannyan Raveendran and the same was received by Mr. Karamana Jayan, BJP National Council Member, who was the guest of honor.",
      thumb: "assets/img/spectrum/221.jpg",
    },
    {
      src: "assets/img/spectrum/222.jpg",
      caption:
        "A “Special Camp for the Differently Abled Children” between 3 and 15 years, was organized at NIMS MEDICITY on 6th February 2019 to explore their special abilities as well as their physical and medical difficulties and suggest appropriate follow-up trainings. The camp was led by Mrs J. Princemol, Trainer- Special Education, NIMS-Anne Sullivan Centre for  Specially Abled Children, NIMS Medicity, in which all related departments such as ENT, Orthopedics, pediatrics, psychiatry, physiatry, psychology, audiology & speech, speech therapy, child development therapy etc.  participated. The camp was inaugurated by Mr Pandalam Sudhakaran, Former Minister of Kerala in the gracious presence of  Padmashri P. Gopinathan Nair. Mr Pannyan Raveendran, former MP of Thriuvananthapuram presided and  Mr. M.S. Faizal Khan, Managing Director of NIMS Medicity delivered the introductory talk.  The Logo of NIMS-Anne Sullivan Centre for Specially Abled Children was released by Mr Pannyan Raveendran and the same was received by Mr. Karamana Jayan, BJP National Council Member, who was the guest of honor.",
      thumb: "assets/img/spectrum/222.jpg",
    },
    {
      src: "assets/img/spectrum/223.jpg",
      caption:
        "A “Special Camp for the Differently Abled Children” between 3 and 15 years, was organized at NIMS MEDICITY on 6th February 2019 to explore their special abilities as well as their physical and medical difficulties and suggest appropriate follow-up trainings. The camp was led by Mrs J. Princemol, Trainer- Special Education, NIMS-Anne Sullivan Centre for  Specially Abled Children, NIMS Medicity, in which all related departments such as ENT, Orthopedics, pediatrics, psychiatry, physiatry, psychology, audiology & speech, speech therapy, child development therapy etc.  participated. The camp was inaugurated by Mr Pandalam Sudhakaran, Former Minister of Kerala in the gracious presence of  Padmashri P. Gopinathan Nair. Mr Pannyan Raveendran, former MP of Thriuvananthapuram presided and  Mr. M.S. Faizal Khan, Managing Director of NIMS Medicity delivered the introductory talk.  The Logo of NIMS-Anne Sullivan Centre for Specially Abled Children was released by Mr Pannyan Raveendran and the same was received by Mr. Karamana Jayan, BJP National Council Member, who was the guest of honor.",
      thumb: "assets/img/spectrum/223.jpg",
    },
    {
      src: "assets/img/spectrum/224.jpg",
      caption:
        "A “Special Camp for the Differently Abled Children” between 3 and 15 years, was organized at NIMS MEDICITY on 6th February 2019 to explore their special abilities as well as their physical and medical difficulties and suggest appropriate follow-up trainings. The camp was led by Mrs J. Princemol, Trainer- Special Education, NIMS-Anne Sullivan Centre for  Specially Abled Children, NIMS Medicity, in which all related departments such as ENT, Orthopedics, pediatrics, psychiatry, physiatry, psychology, audiology & speech, speech therapy, child development therapy etc.  participated. The camp was inaugurated by Mr Pandalam Sudhakaran, Former Minister of Kerala in the gracious presence of  Padmashri P. Gopinathan Nair. Mr Pannyan Raveendran, former MP of Thriuvananthapuram presided and  Mr. M.S. Faizal Khan, Managing Director of NIMS Medicity delivered the introductory talk.  The Logo of NIMS-Anne Sullivan Centre for Specially Abled Children was released by Mr Pannyan Raveendran and the same was received by Mr. Karamana Jayan, BJP National Council Member, who was the guest of honor.",
      thumb: "assets/img/spectrum/224.jpg",
    },
    {
      src: "assets/img/spectrum/225.jpg",
      caption:
        "A “Special Camp for the Differently Abled Children” between 3 and 15 years, was organized at NIMS MEDICITY on 6th February 2019 to explore their special abilities as well as their physical and medical difficulties and suggest appropriate follow-up trainings. The camp was led by Mrs J. Princemol, Trainer- Special Education, NIMS-Anne Sullivan Centre for  Specially Abled Children, NIMS Medicity, in which all related departments such as ENT, Orthopedics, pediatrics, psychiatry, physiatry, psychology, audiology & speech, speech therapy, child development therapy etc.  participated. The camp was inaugurated by Mr Pandalam Sudhakaran, Former Minister of Kerala in the gracious presence of  Padmashri P. Gopinathan Nair. Mr Pannyan Raveendran, former MP of Thriuvananthapuram presided and  Mr. M.S. Faizal Khan, Managing Director of NIMS Medicity delivered the introductory talk.  The Logo of NIMS-Anne Sullivan Centre for Specially Abled Children was released by Mr Pannyan Raveendran and the same was received by Mr. Karamana Jayan, BJP National Council Member, who was the guest of honor.",
      thumb: "assets/img/spectrum/225.jpg",
    },
    {
      src: "assets/img/spectrum/226.jpg",
      caption:
        "A “Special Camp for the Differently Abled Children” between 3 and 15 years, was organized at NIMS MEDICITY on 6th February 2019 to explore their special abilities as well as their physical and medical difficulties and suggest appropriate follow-up trainings. The camp was led by Mrs J. Princemol, Trainer- Special Education, NIMS-Anne Sullivan Centre for  Specially Abled Children, NIMS Medicity, in which all related departments such as ENT, Orthopedics, pediatrics, psychiatry, physiatry, psychology, audiology & speech, speech therapy, child development therapy etc.  participated. The camp was inaugurated by Mr Pandalam Sudhakaran, Former Minister of Kerala in the gracious presence of  Padmashri P. Gopinathan Nair. Mr Pannyan Raveendran, former MP of Thriuvananthapuram presided and  Mr. M.S. Faizal Khan, Managing Director of NIMS Medicity delivered the introductory talk.  The Logo of NIMS-Anne Sullivan Centre for Specially Abled Children was released by Mr Pannyan Raveendran and the same was received by Mr. Karamana Jayan, BJP National Council Member, who was the guest of honor.",
      thumb: "assets/img/spectrum/226.jpg",
    },
    {
      src: "assets/img/spectrum/227.jpg",
      caption:
        "A “Special Camp for the Differently Abled Children” between 3 and 15 years, was organized at NIMS MEDICITY on 6th February 2019 to explore their special abilities as well as their physical and medical difficulties and suggest appropriate follow-up trainings. The camp was led by Mrs J. Princemol, Trainer- Special Education, NIMS-Anne Sullivan Centre for  Specially Abled Children, NIMS Medicity, in which all related departments such as ENT, Orthopedics, pediatrics, psychiatry, physiatry, psychology, audiology & speech, speech therapy, child development therapy etc.  participated. The camp was inaugurated by Mr Pandalam Sudhakaran, Former Minister of Kerala in the gracious presence of  Padmashri P. Gopinathan Nair. Mr Pannyan Raveendran, former MP of Thriuvananthapuram presided and  Mr. M.S. Faizal Khan, Managing Director of NIMS Medicity delivered the introductory talk.  The Logo of NIMS-Anne Sullivan Centre for Specially Abled Children was released by Mr Pannyan Raveendran and the same was received by Mr. Karamana Jayan, BJP National Council Member, who was the guest of honor.",
      thumb: "assets/img/spectrum/227.jpg",
    },
    {
      src: "assets/img/spectrum/228.jpg",
      caption:
        "A “Special Camp for the Differently Abled Children” between 3 and 15 years, was organized at NIMS MEDICITY on 6th February 2019 to explore their special abilities as well as their physical and medical difficulties and suggest appropriate follow-up trainings. The camp was led by Mrs J. Princemol, Trainer- Special Education, NIMS-Anne Sullivan Centre for  Specially Abled Children, NIMS Medicity, in which all related departments such as ENT, Orthopedics, pediatrics, psychiatry, physiatry, psychology, audiology & speech, speech therapy, child development therapy etc.  participated. The camp was inaugurated by Mr Pandalam Sudhakaran, Former Minister of Kerala in the gracious presence of  Padmashri P. Gopinathan Nair. Mr Pannyan Raveendran, former MP of Thriuvananthapuram presided and  Mr. M.S. Faizal Khan, Managing Director of NIMS Medicity delivered the introductory talk.  The Logo of NIMS-Anne Sullivan Centre for Specially Abled Children was released by Mr Pannyan Raveendran and the same was received by Mr. Karamana Jayan, BJP National Council Member, who was the guest of honor.",
      thumb: "assets/img/spectrum/228.jpg",
    },
    {
      src: "assets/img/spectrum/229.jpg",
      caption:
        "A “Special Camp for the Differently Abled Children” between 3 and 15 years, was organized at NIMS MEDICITY on 6th February 2019 to explore their special abilities as well as their physical and medical difficulties and suggest appropriate follow-up trainings. The camp was led by Mrs J. Princemol, Trainer- Special Education, NIMS-Anne Sullivan Centre for  Specially Abled Children, NIMS Medicity, in which all related departments such as ENT, Orthopedics, pediatrics, psychiatry, physiatry, psychology, audiology & speech, speech therapy, child development therapy etc.  participated. The camp was inaugurated by Mr Pandalam Sudhakaran, Former Minister of Kerala in the gracious presence of  Padmashri P. Gopinathan Nair. Mr Pannyan Raveendran, former MP of Thriuvananthapuram presided and  Mr. M.S. Faizal Khan, Managing Director of NIMS Medicity delivered the introductory talk.  The Logo of NIMS-Anne Sullivan Centre for Specially Abled Children was released by Mr Pannyan Raveendran and the same was received by Mr. Karamana Jayan, BJP National Council Member, who was the guest of honor.",
      thumb: "assets/img/spectrum/229.jpg",
    },
    {
      src: "assets/img/spectrum/230.jpg",
      caption:
        "A “Special Camp for the Differently Abled Children” between 3 and 15 years, was organized at NIMS MEDICITY on 6th February 2019 to explore their special abilities as well as their physical and medical difficulties and suggest appropriate follow-up trainings. The camp was led by Mrs J. Princemol, Trainer- Special Education, NIMS-Anne Sullivan Centre for  Specially Abled Children, NIMS Medicity, in which all related departments such as ENT, Orthopedics, pediatrics, psychiatry, physiatry, psychology, audiology & speech, speech therapy, child development therapy etc.  participated. The camp was inaugurated by Mr Pandalam Sudhakaran, Former Minister of Kerala in the gracious presence of  Padmashri P. Gopinathan Nair. Mr Pannyan Raveendran, former MP of Thriuvananthapuram presided and  Mr. M.S. Faizal Khan, Managing Director of NIMS Medicity delivered the introductory talk.  The Logo of NIMS-Anne Sullivan Centre for Specially Abled Children was released by Mr Pannyan Raveendran and the same was received by Mr. Karamana Jayan, BJP National Council Member, who was the guest of honor.",
      thumb: "assets/img/spectrum/230.jpg",
    },

    {
      src: "assets/img/spectrum/197.jpg",
      caption:
        "NIMS Anne Sullivan Centre for Specially Abled Children has conducted multi-visual stimulation activities for the condition called “Hypovision sensory dysfunction”. This activity made our kids to access multi visual stimulation during the day and we found that all the students could give their attention and complete the task successfully.These interactions will help the child move forward day by day.",
      thumb: "assets/img/spectrum/197.jpg",
    },
    {
      src: "assets/img/spectrum/198.jpg",
      caption:
        "NIMS Anne Sullivan Centre for Specially Abled Children has conducted multi-visual stimulation activities for the condition called “Hypovision sensory dysfunction”. This activity made our kids to access multi visual stimulation during the day and we found that all the students could give their attention and complete the task successfully.These interactions will help the child move forward day by day.",
      thumb: "assets/img/spectrum/198.jpg",
    },
    {
      src: "assets/img/spectrum/199.jpg",
      caption:
        "NIMS Anne Sullivan Centre for Specially Abled Children has conducted multi-visual stimulation activities for the condition called “Hypovision sensory dysfunction”. This activity made our kids to access multi visual stimulation during the day and we found that all the students could give their attention and complete the task successfully.These interactions will help the child move forward day by day.",
      thumb: "assets/img/spectrum/199.jpg",
    },
    {
      src: "assets/img/spectrum/200.jpg",
      caption:
        "NIMS Anne Sullivan Centre for Specially Abled Children has conducted multi-visual stimulation activities for the condition called “Hypovision sensory dysfunction”. This activity made our kids to access multi visual stimulation during the day and we found that all the students could give their attention and complete the task successfully.These interactions will help the child move forward day by day.",
      thumb: "assets/img/spectrum/200.jpg",
    },
    {
      src: "assets/img/spectrum/157.jpg",
      caption:
        "നൂറുൽ ഇസ്‌ലാം സർവ്വകലാശാലയിലെ റീഹാബിലിറ്റേഷൻ കൗൺസിൽ ഓഫ് ഇന്ത്യയുടെ അംഗീകാരത്തോടെ പ്രവർത്തിക്കുന്ന ബാച്ചിലർ ഓഫ് ഓഡിയോളജി ആൻഡ് സ്പീച്ച് ലാംഗ്വേജ് പാത്തോളജി (ബി.എ. എസ് .എൽ.പി) വിദ്യാർത്ഥികൾ സ്പെഷ്യൽ സ്കൂൾ കുട്ടികൾക്ക് ശ്രവണ പരിശോധനകൾ , സംസാര വൈകല്യമുള്ളവർക്ക് സ്പീച്ച് തെറാപ്പി , വൈകാരികവും പെരുമാറ്റപരവുമായ വൈകല്യങ്ങൾ തുടങ്ങിയവയ്ക്കുള്ള തെറാപ്പി സേവനങ്ങൾ നൽകി.",
      thumb: "assets/img/spectrum/157.jpg",
    },
    {
      src: "assets/img/spectrum/158.jpg",
      caption:
        "കുട്ടികൾ മുതൽ വയോധികർ വരെ അന്തേവസിക്കുന്ന അശരണരുടെ അഭയകേന്ദ്രമായ പത്തനാപുരം ഗാന്ധിഭവനിലെ നിവാസികൾക്കും നാട്ടുകാർക്കും തികച്ചും സൗജന്യമാണ് പത്തനാപുരം ഗാന്ധിഭവനിലെ നിംസ് സ്പെക്ട്രത്തിന്റെ സേവനങ്ങൾ .",
      thumb: "assets/img/spectrum/158.jpg",
    },
    {
      src: "assets/img/spectrum/159.jpg",
      caption:
        "നൂറുൽ ഇസ്‌ലാം സർവ്വകലാശാലയിലെ റീഹാബിലിറ്റേഷൻ കൗൺസിൽ ഓഫ് ഇന്ത്യയുടെ അംഗീകാരത്തോടെ പ്രവർത്തിക്കുന്ന ബാച്ചിലർ ഓഫ് ഓഡിയോളജി ആൻഡ് സ്പീച്ച് ലാംഗ്വേജ് പാത്തോളജി (ബി.എ. എസ് .എൽ.പി) വിദ്യാർത്ഥികൾ സ്പെഷ്യൽ സ്കൂൾ കുട്ടികൾക്ക് ശ്രവണ പരിശോധനകൾ , സംസാര വൈകല്യമുള്ളവർക്ക് സ്പീച്ച് തെറാപ്പി , വൈകാരികവും പെരുമാറ്റപരവുമായ വൈകല്യങ്ങൾ തുടങ്ങിയവയ്ക്കുള്ള തെറാപ്പി സേവനങ്ങൾ നൽകി.",
      thumb: "assets/img/spectrum/159.jpg",
    },
    {
      src: "assets/img/spectrum/160.jpg",
      caption:
        "നൂറുൽ ഇസ്‌ലാം സർവ്വകലാശാലയിലെ റീഹാബിലിറ്റേഷൻ കൗൺസിൽ ഓഫ് ഇന്ത്യയുടെ അംഗീകാരത്തോടെ പ്രവർത്തിക്കുന്ന ബാച്ചിലർ ഓഫ് ഓഡിയോളജി ആൻഡ് സ്പീച്ച് ലാംഗ്വേജ് പാത്തോളജി (ബി.എ. എസ് .എൽ.പി) വിദ്യാർത്ഥികൾ സ്പെഷ്യൽ സ്കൂൾ കുട്ടികൾക്ക് ശ്രവണ പരിശോധനകൾ , സംസാര വൈകല്യമുള്ളവർക്ക് സ്പീച്ച് തെറാപ്പി , വൈകാരികവും പെരുമാറ്റപരവുമായ വൈകല്യങ്ങൾ തുടങ്ങിയവയ്ക്കുള്ള തെറാപ്പി സേവനങ്ങൾ നൽകി.",
      thumb: "assets/img/spectrum/160.jpg",
    },
    {
      src: "assets/img/spectrum/161.jpg",
      caption:
        "നൂറുൽ ഇസ്‌ലാം സർവ്വകലാശാലയിലെ റീഹാബിലിറ്റേഷൻ കൗൺസിൽ ഓഫ് ഇന്ത്യയുടെ അംഗീകാരത്തോടെ പ്രവർത്തിക്കുന്ന ബാച്ചിലർ ഓഫ് ഓഡിയോളജി ആൻഡ് സ്പീച്ച് ലാംഗ്വേജ് പാത്തോളജി (ബി.എ. എസ് .എൽ.പി) വിദ്യാർത്ഥികൾ സ്പെഷ്യൽ സ്കൂൾ കുട്ടികൾക്ക് ശ്രവണ പരിശോധനകൾ , സംസാര വൈകല്യമുള്ളവർക്ക് സ്പീച്ച് തെറാപ്പി , വൈകാരികവും പെരുമാറ്റപരവുമായ വൈകല്യങ്ങൾ തുടങ്ങിയവയ്ക്കുള്ള തെറാപ്പി സേവനങ്ങൾ നൽകി.",
      thumb: "assets/img/spectrum/161.jpg",
    },
    {
      src: "assets/img/spectrum/162.jpg",
      caption:
        "നൂറുൽ ഇസ്‌ലാം സർവ്വകലാശാലയിലെ റീഹാബിലിറ്റേഷൻ കൗൺസിൽ ഓഫ് ഇന്ത്യയുടെ അംഗീകാരത്തോടെ പ്രവർത്തിക്കുന്ന ബാച്ചിലർ ഓഫ് ഓഡിയോളജി ആൻഡ് സ്പീച്ച് ലാംഗ്വേജ് പാത്തോളജി (ബി.എ. എസ് .എൽ.പി) വിദ്യാർത്ഥികൾ സ്പെഷ്യൽ സ്കൂൾ കുട്ടികൾക്ക് ശ്രവണ പരിശോധനകൾ , സംസാര വൈകല്യമുള്ളവർക്ക് സ്പീച്ച് തെറാപ്പി , വൈകാരികവും പെരുമാറ്റപരവുമായ വൈകല്യങ്ങൾ തുടങ്ങിയവയ്ക്കുള്ള തെറാപ്പി സേവനങ്ങൾ നൽകി.",
      thumb: "assets/img/spectrum/162.jpg",
    },
    {
      src: "assets/img/spectrum/163.jpg",
      caption:
        "നൂറുൽ ഇസ്‌ലാം സർവ്വകലാശാലയിലെ റീഹാബിലിറ്റേഷൻ കൗൺസിൽ ഓഫ് ഇന്ത്യയുടെ അംഗീകാരത്തോടെ പ്രവർത്തിക്കുന്ന ബാച്ചിലർ ഓഫ് ഓഡിയോളജി ആൻഡ് സ്പീച്ച് ലാംഗ്വേജ് പാത്തോളജി (ബി.എ. എസ് .എൽ.പി) വിദ്യാർത്ഥികൾ സ്പെഷ്യൽ സ്കൂൾ കുട്ടികൾക്ക് ശ്രവണ പരിശോധനകൾ , സംസാര വൈകല്യമുള്ളവർക്ക് സ്പീച്ച് തെറാപ്പി , വൈകാരികവും പെരുമാറ്റപരവുമായ വൈകല്യങ്ങൾ തുടങ്ങിയവയ്ക്കുള്ള തെറാപ്പി സേവനങ്ങൾ നൽകി.",
      thumb: "assets/img/spectrum/163.jpg",
    },
    {
      src: "assets/img/spectrum/164.jpg",
      caption:
        "നൂറുൽ ഇസ്‌ലാം സർവ്വകലാശാലയിലെ റീഹാബിലിറ്റേഷൻ കൗൺസിൽ ഓഫ് ഇന്ത്യയുടെ അംഗീകാരത്തോടെ പ്രവർത്തിക്കുന്ന ബാച്ചിലർ ഓഫ് ഓഡിയോളജി ആൻഡ് സ്പീച്ച് ലാംഗ്വേജ് പാത്തോളജി (ബി.എ. എസ് .എൽ.പി) വിദ്യാർത്ഥികൾ സ്പെഷ്യൽ സ്കൂൾ കുട്ടികൾക്ക് ശ്രവണ പരിശോധനകൾ , സംസാര വൈകല്യമുള്ളവർക്ക് സ്പീച്ച് തെറാപ്പി , വൈകാരികവും പെരുമാറ്റപരവുമായ വൈകല്യങ്ങൾ തുടങ്ങിയവയ്ക്കുള്ള തെറാപ്പി സേവനങ്ങൾ നൽകി.",
      thumb: "assets/img/spectrum/164.jpg",
    },
    {
      src: "assets/img/spectrum/165.jpg",
      caption:
        "നിംസ് സ്പെക്ട്രത്തിലെ വിവിധ ഡിപ്പാർട്ട്മെന്റുകൾ സന്ദർശിച്ച അദ്ദേഹം സ്‌റ്റാഫുകളോടും കുഞ്ഞുങ്ങളുടെ മാതാപിതാക്കളോടും സംവദിച്ചു .സിനിമയിലെയും ജീവിതത്തിലേയും വിശേഷങ്ങൾ പങ്ക് വച്ചപ്പോൾ 'അനിയൻ ബാവ ചേട്ടൻ ബാവ ' സിനിമയിലെ 'അമ്മാവാ...' ഒരിക്കലും മറക്കാൻ പറ്റാത്ത ഒരു വിളിയിയാണ് എന്ന് അദ്ദേഹത്തോട് കുഞ്ഞുങ്ങളുടെ മാതാപിതാക്കൾ പറഞ്ഞു .",
      thumb: "assets/img/spectrum/165.jpg",
    },
    {
      src: "assets/img/spectrum/166.jpg",
      caption:
        "സിനിമയിലെയും ജീവിതത്തിലേയും വിശേഷങ്ങൾ പങ്ക് വച്ചപ്പോൾ 'അനിയൻ ബാവ ചേട്ടൻ ബാവ ' സിനിമയിലെ 'അമ്മാവാ...' ഒരിക്കലും മറക്കാൻ പറ്റാത്ത ഒരു വിളിയിയാണ് എന്ന് അദ്ദേഹത്തോട് കുഞ്ഞുങ്ങളുടെ മാതാപിതാക്കൾ പറഞ്ഞു .",
      thumb: "assets/img/spectrum/166.jpg",
    },
    {
      src: "assets/img/spectrum/167.jpg",
      caption:
        'കുഞ്ഞുങ്ങളുടെ ആരോഗ്യ പരിപാലനത്തിനായി നിംസ് സ്പെക്ട്രം ശിശു വികസന ഗവേഷണ കേന്ദ്രം തുടങ്ങുവാനുണ്ടായ പ്രചോദനത്തെ പറ്റി നിംസ് എം.ഡി ശ്രീ എം.എസ് ഫൈസൽ ഖാൻ സംസാരിച്ചു. തുടർന്ന് "നെയ്യാറ്റിൻകര പെൻഷൻ പ്ലാൻ " ഉൾപ്പടെയുള്ള നിംസിന്റെ സാമൂഹ്യ പ്രവർത്തനങ്ങളെ പറ്റി വിവരിച്ചു. കിടരോഗികളെ വീടുകളിൽ ചെന്ന് സൗജന്യമായി പരിചരിക്കുന്ന " നിംസ് യൂത്ത് റെഡ് ക്രോസ് " , ഡിസ്ചാർജ്ജ് കഴിഞ്ഞ് വീട്ടിൽ പോകുന്ന രോഗികൾക്ക് ഭഷ്യ കിറ്റ് നൽകുന്ന "നിംസ് അന്നപൂർണ്ണ " തുടങ്ങിയ പദ്ധതികൾ ശ്രീ. പ്രേംകുമാർ നേരിട്ട് കണ്ട് മനസ്സിലാക്കി.',
      thumb: "assets/img/spectrum/167.jpg",
    },
    {
      src: "assets/img/spectrum/168.jpg",
      caption:
        "മലയാള സിനിമയിലെ ജനപ്രിയ മുഖങ്ങളിലൊന്നായി മലയാളികളെ രസിപ്പിച്ച മികച്ച കലാകാരനും എഴുത്തുകാരനും സാമൂഹിക പ്രവർത്തകനും സംസ്ഥാന ചലചിത്ര അക്കാദമി വൈസ് ചെയർമാനുമായ ശ്രീ പ്രേംകുമാർ നിംസ് സ്പെക്ട്രം ശിശു വികസന ഗവേഷണ കേന്ദ്രം സന്ദർശിച്ചു. നിംസ് സ്പെക്ട്രം ഡയറക്ടറും മുൻ ആരോഗ്യ സർവ്വകലാശാല വൈസ് ചാൻസലറുമായ ഡോ. എം.കെ.സി നായർ നിംസ് സ്പെക്ട്രം ശിശു വികസന ഗവേഷണ കേന്ദ്രത്തിന്റെ പ്രവർത്തനങ്ങളെ പറ്റി അദ്ദേഹത്തോട് പറഞ്ഞു.  ",
      thumb: "assets/img/spectrum/168.jpg",
    },
    {
      src: "assets/img/spectrum/169.jpg",
      caption:
        "സംസ്ഥാന ചലച്ചിത്ര അക്കാദമി വൈസ് ചെയർമാൻ ശ്രീ പ്രേംകുമാർ നിംസ് സ്പെക്ട്രം സന്ദർശിച്ചു.",
      thumb: "assets/img/spectrum/169.jpg",
    },
    {
      src: "assets/img/spectrum/170.jpg",
      caption:
        "സംസ്ഥാന ചലച്ചിത്ര അക്കാദമി വൈസ് ചെയർമാൻ ശ്രീ പ്രേംകുമാർ നിംസ് സ്പെക്ട്രം സന്ദർശിച്ചു.",
      thumb: "assets/img/spectrum/170.jpg",
    },
    {
      src: "assets/img/spectrum/171.jpg",
      caption:
        "സംസ്ഥാന ചലച്ചിത്ര അക്കാദമി വൈസ് ചെയർമാൻ ശ്രീ പ്രേംകുമാർ നിംസ് സ്പെക്ട്രം സന്ദർശിച്ചു.",
      thumb: "assets/img/spectrum/171.jpg",
    },
    {
      src: "assets/img/spectrum/172.jpg",
      caption:
        "സംസ്ഥാന ചലച്ചിത്ര അക്കാദമി വൈസ് ചെയർമാൻ ശ്രീ പ്രേംകുമാർ നിംസ് സ്പെക്ട്രം സന്ദർശിച്ചു.",
      thumb: "assets/img/spectrum/172.jpg",
    },
    {
      src: "assets/img/spectrum/173.jpg",
      caption:
        "സംസ്ഥാന ചലച്ചിത്ര അക്കാദമി വൈസ് ചെയർമാൻ ശ്രീ പ്രേംകുമാർ നിംസ് സ്പെക്ട്രം സന്ദർശിച്ചു.",
      thumb: "assets/img/spectrum/173.jpg",
    },
    {
      src: "assets/img/spectrum/174.jpg",
      caption:
        "സംസ്ഥാന ചലച്ചിത്ര അക്കാദമി വൈസ് ചെയർമാൻ ശ്രീ പ്രേംകുമാർ നിംസ് സ്പെക്ട്രം സന്ദർശിച്ചു.",
      thumb: "assets/img/spectrum/174.jpg",
    },
    {
      src: "assets/img/spectrum/175.jpg",
      caption:
        "സംസ്ഥാന ചലച്ചിത്ര അക്കാദമി വൈസ് ചെയർമാൻ ശ്രീ പ്രേംകുമാർ നിംസ് സ്പെക്ട്രം സന്ദർശിച്ചു.",
      thumb: "assets/img/spectrum/175.jpg",
    },
    {
      src: "assets/img/spectrum/176.jpg",
      caption:
        "സംസ്ഥാന ചലച്ചിത്ര അക്കാദമി വൈസ് ചെയർമാൻ ശ്രീ പ്രേംകുമാർ നിംസ് സ്പെക്ട്രം സന്ദർശിച്ചു.",
      thumb: "assets/img/spectrum/176.jpg",
    },
    {
      src: "assets/img/spectrum/177.jpg",
      caption:
        "സംസ്ഥാന ചലച്ചിത്ര അക്കാദമി വൈസ് ചെയർമാൻ ശ്രീ പ്രേംകുമാർ നിംസ് സ്പെക്ട്രം സന്ദർശിച്ചു.",
      thumb: "assets/img/spectrum/177.jpg",
    },
    {
      src: "assets/img/spectrum/178.jpg",
      caption:
        "സംസ്ഥാന ചലച്ചിത്ര അക്കാദമി വൈസ് ചെയർമാൻ ശ്രീ പ്രേംകുമാർ നിംസ് സ്പെക്ട്രം സന്ദർശിച്ചു.",
      thumb: "assets/img/spectrum/178.jpg",
    },
    {
      src: "assets/img/spectrum/179.jpg",
      caption:
        "സംസ്ഥാന ചലച്ചിത്ര അക്കാദമി വൈസ് ചെയർമാൻ ശ്രീ പ്രേംകുമാർ നിംസ് സ്പെക്ട്രം സന്ദർശിച്ചു.",
      thumb: "assets/img/spectrum/179.jpg",
    },
    {
      src: "assets/img/spectrum/180.jpg",
      caption:
        "സംസ്ഥാന ചലച്ചിത്ര അക്കാദമി വൈസ് ചെയർമാൻ ശ്രീ പ്രേംകുമാർ നിംസ് സ്പെക്ട്രം സന്ദർശിച്ചു.",
      thumb: "assets/img/spectrum/180.jpg",
    },
    {
      src: "assets/img/spectrum/181.jpg",
      caption:
        "സംസ്ഥാന ചലച്ചിത്ര അക്കാദമി വൈസ് ചെയർമാൻ ശ്രീ പ്രേംകുമാർ നിംസ് സ്പെക്ട്രം സന്ദർശിച്ചു.",
      thumb: "assets/img/spectrum/181.jpg",
    },
    {
      src: "assets/img/spectrum/182.jpg",
      caption:
        "സംസ്ഥാന ചലച്ചിത്ര അക്കാദമി വൈസ് ചെയർമാൻ ശ്രീ പ്രേംകുമാർ നിംസ് സ്പെക്ട്രം സന്ദർശിച്ചു.",
      thumb: "assets/img/spectrum/182.jpg",
    },
    {
      src: "assets/img/spectrum/183.jpg",
      caption:
        "സംസ്ഥാന ചലച്ചിത്ര അക്കാദമി വൈസ് ചെയർമാൻ ശ്രീ പ്രേംകുമാർ നിംസ് സ്പെക്ട്രം സന്ദർശിച്ചു.",
      thumb: "assets/img/spectrum/183.jpg",
    },
    {
      src: "assets/img/spectrum/184.jpg",
      caption:
        "സംസ്ഥാന ചലച്ചിത്ര അക്കാദമി വൈസ് ചെയർമാൻ ശ്രീ പ്രേംകുമാർ നിംസ് സ്പെക്ട്രം സന്ദർശിച്ചു.",
      thumb: "assets/img/spectrum/184.jpg",
    },
    {
      src: "assets/img/spectrum/185.jpg",
      caption:
        "സന്തോഷകരമായ ഏതൊരു അവസരവും ചോക്ലേറ്റുകൾ ഇല്ലാതെ പൂർണ്ണമാകില്ല. കുഞ്ഞുങ്ങളുടെ ഇഷ്ട വിഭവങ്ങളിൽ മുൻപന്തിയിൽ നിൽകുന്നത് ചോക്ളേറ്റും മധുരപലഹാരങ്ങളുമാണ്. കുസൃതിയും കുഞ്ഞ്പിണക്കങ്ങളുമായി നിൽക്കുന്ന കുഞ്ഞുങ്ങളുടെ മുഖത്ത് പുഞ്ചിരിയുടെ പൂമൊട്ടുകൾ വിരിയിക്കാൻ മാതാപിതാക്കൾ പലപ്പോഴും ആശ്രയിക്കുന്നത് ചോക്ലേറ്റുകളെയാണ്.",
      thumb: "assets/img/spectrum/185.jpg",
    },
    {
      src: "assets/img/spectrum/186.jpg",
      caption:
        "ലോക ചോക്ലേറ്റ് ദിനമായ ഇന്ന് നിംസ് ആനി സള്ളിവൻ സെന്ററിലെ കുഞ്ഞുക്കൾക്ക് ചോക്ലേറ്റ് മധുരങ്ങൾ നൽകാൻ നിംസ് മെഡിസിറ്റി പീഡിയാട്രിഷൻ ഡോ. ഷെബിൻ എത്തി. കുഞ്ഞുങ്ങളുമായി സമയം ചിലവിട്ട അദ്ദേഹം അനിയന്ത്രിതമായ അളവിൽ മധുരം കഴിക്കുന്നത് പല്ലുകൾക്ക് ഹാനികരമാണ് എന്നും ഓർമ്മിപിച്ചു.",
      thumb: "assets/img/spectrum/186.jpg",
    },
    {
      src: "assets/img/spectrum/187.jpg",
      caption:
        "ലോക ചോക്ലേറ്റ് ദിനമായ ഇന്ന് നിംസ് ആനി സള്ളിവൻ സെന്ററിലെ കുഞ്ഞുക്കൾക്ക് ചോക്ലേറ്റ് മധുരങ്ങൾ നൽകാൻ നിംസ് മെഡിസിറ്റി പീഡിയാട്രിഷൻ ഡോ. ഷെബിൻ എത്തി. കുഞ്ഞുങ്ങളുമായി സമയം ചിലവിട്ട അദ്ദേഹം അനിയന്ത്രിതമായ അളവിൽ മധുരം കഴിക്കുന്നത് പല്ലുകൾക്ക് ഹാനികരമാണ് എന്നും ഓർമ്മിപിച്ചു.",
      thumb: "assets/img/spectrum/187.jpg",
    },
    {
      src: "assets/img/spectrum/188.jpg",
      caption:
        "ലോക ചോക്ലേറ്റ് ദിനമായ ഇന്ന് നിംസ് ആനി സള്ളിവൻ സെന്ററിലെ കുഞ്ഞുക്കൾക്ക് ചോക്ലേറ്റ് മധുരങ്ങൾ നൽകാൻ നിംസ് മെഡിസിറ്റി പീഡിയാട്രിഷൻ ഡോ. ഷെബിൻ എത്തി. കുഞ്ഞുങ്ങളുമായി സമയം ചിലവിട്ട അദ്ദേഹം അനിയന്ത്രിതമായ അളവിൽ മധുരം കഴിക്കുന്നത് പല്ലുകൾക്ക് ഹാനികരമാണ് എന്നും ഓർമ്മിപിച്ചു.",
      thumb: "assets/img/spectrum/188.jpg",
    },
    {
      src: "assets/img/spectrum/189.jpg",
      caption:
        "ലോക ചോക്ലേറ്റ് ദിനമായ ഇന്ന് നിംസ് ആനി സള്ളിവൻ സെന്ററിലെ കുഞ്ഞുക്കൾക്ക് ചോക്ലേറ്റ് മധുരങ്ങൾ നൽകാൻ നിംസ് മെഡിസിറ്റി പീഡിയാട്രിഷൻ ഡോ. ഷെബിൻ എത്തി. കുഞ്ഞുങ്ങളുമായി സമയം ചിലവിട്ട അദ്ദേഹം അനിയന്ത്രിതമായ അളവിൽ മധുരം കഴിക്കുന്നത് പല്ലുകൾക്ക് ഹാനികരമാണ് എന്നും ഓർമ്മിപിച്ചു.",
      thumb: "assets/img/spectrum/189.jpg",
    },
    {
      src: "assets/img/spectrum/190.jpg",
      caption:
        "ലോക ചോക്ലേറ്റ് ദിനമായ ഇന്ന് നിംസ് ആനി സള്ളിവൻ സെന്ററിലെ കുഞ്ഞുക്കൾക്ക് ചോക്ലേറ്റ് മധുരങ്ങൾ നൽകാൻ നിംസ് മെഡിസിറ്റി പീഡിയാട്രിഷൻ ഡോ. ഷെബിൻ എത്തി. കുഞ്ഞുങ്ങളുമായി സമയം ചിലവിട്ട അദ്ദേഹം അനിയന്ത്രിതമായ അളവിൽ മധുരം കഴിക്കുന്നത് പല്ലുകൾക്ക് ഹാനികരമാണ് എന്നും ഓർമ്മിപിച്ചു.",
      thumb: "assets/img/spectrum/190.jpg",
    },
    {
      src: "assets/img/spectrum/191.jpg",
      caption:
        "ഓണം 2022 : നിംസ് ആനി സള്ളിവൻ സെന്റർ ഫോർ സ്പെഷ്യലി ഏബ്ൾഡ് ചിൽഡ്രൻ .",
      thumb: "assets/img/spectrum/191.jpg",
    },
    {
      src: "assets/img/spectrum/192.jpg",
      caption:
        "ദേശീയ പോഷകാഹാര വാരാചരണത്തിന്റെ ഭാഗമായി നിംസ് മെഡിസിറ്റി ക്ലിനിക്കൽ ന്യൂട്രീഷൻ വിഭാഗം കുട്ടികൾക്ക് പായസം നൽകി . നിംസ് നഴ്സിംഗ് കോളേജിലെ വിദ്യാർഥികളും ആനി സള്ളിവനിലെ കുട്ടികളും ചേർന്നുളള തിരുവാതിരക്കളി ഓണാഘോഷത്തെ മനോഹരമാക്കി.",
      thumb: "assets/img/spectrum/192.jpg",
    },
    {
      src: "assets/img/spectrum/193.jpg",
      caption:
        "കിടപ്പ് രോഗികളുടെ വീടുകളിൽ പോയി ആരോഗ്യ പരിചരണം നൽകുന്ന നിംസ് യൂത്ത് റെഡ് ക്രോസ് ടീം അംഗങ്ങൾ കുട്ടികൾക്ക് കളിപ്പാട്ടങ്ങൾ സമ്മാനിച്ചു.",
      thumb: "assets/img/spectrum/193.jpg",
    },
    {
      src: "assets/img/spectrum/194.jpg",
      caption:
        "2022 ലെ ഓണം പൊന്നോണമാക്കി നിംസ് ആനി സള്ളിവൻ സെന്റർ ഫോർ സ്പെഷ്യലി ഏബ്ൾഡ് ചിൽഡ്രനിലെ കുട്ടികളും അമ്മമാരും . വർണ്ണ പൂക്കളവും തിരുവാതിരയും വടംവലിയും ഉറിയടിയും നിരവധി കലാപരിപാടികളുമായി ഈ വർഷത്തെ ഓണം ആഘോഷമാക്കി .",
      thumb: "assets/img/spectrum/194.jpg",
    },
    {
      src: "assets/img/spectrum/195.jpg",
      caption:
        "ഓണാഘോഷത്തിന്റെ എല്ലാ വശങ്ങളിലും കുട്ടികളുടെ സാന്നിധ്യം ഉറപ്പാക്കണമെന്നും പൂക്കൾ ഇറുത്തെടുക്കാനും മനോഹരമായ രീതിയിൽ പൂക്കളം തയ്യാറാക്കാനും കുട്ടികളെ പ്രോത്സാഹിപ്പിക്കണമെന്നും ഡോ.എം.കെ.സി നായർ അഭിപ്രായപെട്ടു. ",
      thumb: "assets/img/spectrum/195.jpg",
    },
    {
      src: "assets/img/spectrum/196.jpg",
      caption:
        "ഓണാഘോഷത്തിന്റെ എല്ലാ വശങ്ങളിലും കുട്ടികളുടെ സാന്നിധ്യം ഉറപ്പാക്കണമെന്നും പൂക്കൾ ഇറുത്തെടുക്കാനും മനോഹരമായ രീതിയിൽ പൂക്കളം തയ്യാറാക്കാനും കുട്ടികളെ പ്രോത്സാഹിപ്പിക്കണമെന്നും ഡോ.എം.കെ.സി നായർ അഭിപ്രായപെട്ടു. ",
      thumb: "assets/img/spectrum/196.jpg",
    },

    {
      src: "assets/img/spectrum/151.jpg",
      caption:
        "ലോക ഒക്യുപേഷണൽ തെറാപ്പി ദിനാചരണം… ഇന്ന് ഒക്ടോബർ  27, ലോക ഒക്പേഷണൽ തെറാപ്പി ദിനം. ദൈനം ദിന ജീവിതചര്യകൾ സ്വായം നിർവഹിക്കാൻ കഴിയാത്ത നിരവധി കുട്ടികളും മുതിർന്നവരും നമുക്ക് ചുറ്റുമുണ്ട് . അവരെ ശാസ്ത്രീയമായ പരിശീലനകൾ വഴി പ്രാപ്തരാക്കാൻ സഹായിക്കുന്നവരാണ് ഒക്യുപേഷണൽ തെറാപ്പിസ്റ്റ് .",
      thumb: "assets/img/spectrum/151.jpg",
    },
    {
      src: "assets/img/spectrum/152.jpg",
      caption:
        "ലോക ഒക്യുപേഷണൽ തെറാപ്പി ദിനാചരണത്തിന്റെ ഭാഗമായി നിംസ് സ്പെക്ട്രം ശിശു വികസന ഗവേഷണ കേന്ദ്രത്തിൽ അവബോധന ക്ലാസ്സും വിവിധ തെറാപ്പി രീതികളെ കുറിച്ചുള്ള പഠനവും പരിശീലനവും സംഘടിപ്പിച്ചു . ഒക്യുപേഷണൽ തെറാപ്പിയുടെ പ്രാധാന്യം , ഓട്ടിസം ബാധിച്ച കുട്ടികൾക്കുള്ള തെറാപ്പി , വീടുകളിൽ കുഞ്ഞുങ്ങളെ എന്തെല്ലാം പരിശീലിപ്പിക്കണം തുടങ്ങി നവജാത ശിശുക്കള്‍, വിദ്യാര്‍ത്ഥികള്‍, മുതിര്‍ന്നവര്‍, ഉദ്യോഗസ്ഥര്‍, തൊഴിലാളികള്‍, വയോജനങ്ങള്‍ എന്നിങ്ങനെ പ്രായഭേദമന്യേ എല്ലാവരിലെയും ആരോഗ്യപ്രശ്‌നങ്ങള്‍ക്ക് ഒക്യുപേഷണല്‍ തെറാപ്പിയുടെ പ്രാധാന്യത്തെ പറ്റി ക്ലാസിൽ ചർച്ച ചെയ്യപെട്ടു.",
      thumb: "assets/img/spectrum/152.jpg",
    },
    {
      src: "assets/img/spectrum/153.jpg",
      caption:
        "നിംസ് സ്പെക്ട്രം ഡയറക്ടറും മുൻ ആരോഗ്യ സർവ്വകലാശാല വൈസ് ചാൻസലറുമായ ഡോ.എം.കെ.സി നായർ നേതൃത്വം നൽകിയ ഒക്യുപേഷണൽ തെറാപ്പി ദിനാചരണ ദിനത്തിൽ നിംസ് സ്പെക്ട്രം ഒക്യുപേഷണൽ തെറാപ്പിസ്റ്റ് ശ്രീമതി മെറിൻ ഷീബ നിംസ് സ്പെക്ട്രം ഒക്യുപേഷണൽ തെറാപ്പി വിഭാഗത്തിൽ നൽകുന്ന നൂതന തെറാപ്പി രീതികളെ കുറിച്ച് സംസാരിച്ചു .",
      thumb: "assets/img/spectrum/153.jpg",
    },
    {
      src: "assets/img/spectrum/154.jpg",
      caption:
        "നമുക്ക് നിസ്സാരമായ കാര്യങ്ങൾ വളരെയധികം ബുദ്ധിമുട്ടുകളിലൂടെ നിർവഹിക്കുന്നവരും നമുക്കിടയിലുണ്ട്. പരസഹായമില്ലാതെ പല്ല് തേക്കാനും , തലമുടി ചീകാനും , ഷർട്ട് ഇടാനും, അതിലെ ബട്ടൻസ് പോലും തനിയെ ഇടാൻ കഴിയാത്ത ഭിന്നശേഷിക്കാരായ കുഞ്ഞുങ്ങൾ . സ്ട്രോക്ക് , പരാലിസിസ്സ് , അത്യാഹിതങ്ങൾ കാരണം ശരീരത്തിന്റെ ചലന ശേഷിയെ ബാധിച്ച് വീട്ട് ജോലികളും മറ്റും നിർവഹിക്കാൻ ബുദ്ധിമുട്ടുന്നവർ . ചലന ശേഷി കുറഞ്ഞവരെ അവരുടെ കഴിവുകൾ ഉപയോഗിച്ച് എങ്ങനെ സ്വതന്ത്രമായി ജീവിക്കാൻ പറ്റും എന്നതിന് വഴി കണ്ടെത്താൻ ഒക്യുപേഷണൽ തെറാപ്പി സേവനങ്ങൾ സഹായകമാകും .ഏത് പ്രതികൂല സാഹചര്യങ്ങളിലും ശാരീരിക, മാനസിക, വൈകാരിക വൈകല്യങ്ങളുള്ള വ്യക്തികളെ കാര്യക്ഷമയുള്ളവരാക്കി മാറ്റാന്‍ ഒക്യുപേഷണല്‍ തെറാപ്പിയിലൂടെ സാധിക്കും",
      thumb: "assets/img/spectrum/154.jpg",
    },
    {
      src: "assets/img/spectrum/155.jpg",
      caption:
        "നിംസ് സ്പെക്ട്രം ഡയറക്ടറും മുൻ ആരോഗ്യ സർവ്വകലാശാല വൈസ് ചാൻസലറുമായ ഡോ.എം.കെ.സി നായർ നേതൃത്വം നൽകിയ ഒക്യുപേഷണൽ തെറാപ്പി ദിനാചരണ ദിനത്തിൽ നിംസ് സ്പെക്ട്രം ഒക്യുപേഷണൽ തെറാപ്പിസ്റ്റ് ശ്രീമതി മെറിൻ ഷീബ നിംസ് സ്പെക്ട്രം ഒക്യുപേഷണൽ തെറാപ്പി വിഭാഗത്തിൽ നൽകുന്ന നൂതന തെറാപ്പി രീതികളെ കുറിച്ച് സംസാരിച്ചു .",
      thumb: "assets/img/spectrum/155.jpg",
    },
    {
      src: "assets/img/spectrum/156.jpg",
      caption: "",
      thumb: "assets/img/spectrum/156.jpg",
    },

    {
      src: "assets/img/spectrum/139.jpg",
      caption:
        "Family fun day for the  children of NIMS Anne Sullivan centre for specially abled children. In connection with World Autism Awareness day, NIMS MEDICITY arranged pleasure day out trip for the kids of NIMS Anne Sullivan centre for specially abled children today (04-04-2022).",
      thumb: "assets/img/spectrum/139.jpg",
    },
    {
      src: "assets/img/spectrum/147.jpg",
      caption:
        "The fun trip to Lulu Mall Trivandrum was flagged off by Sri.M.S.Faizal Khan , Managing Director , NIMS Medicity.",
      thumb: "assets/img/spectrum/147.jpg",
    },
    {
      src: "assets/img/spectrum/144.jpg",
      caption:
        "Thanks to the Students of NIMS COLLEGE OF NURSING who joined the fun by assisting the special kids  and providing great entertainment to the kids through various cultural events and cake cutting.",
      thumb: "assets/img/spectrum/144.jpg",
    },
    {
      src: "assets/img/spectrum/149.jpg",
      caption:
        "Thanks to the Students of NIMS COLLEGE OF NURSING who joined the fun by assisting the special kids  and providing great entertainment to the kids through various cultural events and cake cutting.",
      thumb: "assets/img/spectrum/149.jpg",
    },
    {
      src: "assets/img/spectrum/146.jpg",
      caption:
        "Thanks to the Students of NIMS COLLEGE OF NURSING who joined the fun by assisting the special kids  and providing great entertainment to the kids through various cultural events and cake cutting.Mrs. Princemol ,Trainer, Sensory integration & Special Education ,NIMS –Anne Sullivan centre for specially abled children organized the event. Mrs.Josephine, Vice Principal of NIMS Nursing college ,Mrs.Riyanka and Mrs. Aashmi actively assosiated for the successful conduct of the fun trip .",
      thumb: "assets/img/spectrum/146.jpg",
    },
    {
      src: "assets/img/spectrum/140.jpg",
      caption:
        "All the special kids enjoyed the colorful lighting, mild music, delicious snacks and varieties of play equipments at the play area of the mall. For a few of the kids,  this was their first experience.",
      thumb: "assets/img/spectrum/140.jpg",
    },
    {
      src: "assets/img/spectrum/141.jpg",
      caption:
        "All the special kids enjoyed the colorful lighting, mild music, delicious snacks and varieties of play equipments at the play area of the mall. For a few of the kids,  this was their first experience.",
      thumb: "assets/img/spectrum/141.jpg",
    },
    {
      src: "assets/img/spectrum/142.jpg",
      caption:
        "All the special kids enjoyed the colorful lighting, mild music, delicious snacks and varieties of play equipments at the play area of the mall. For a few of the kids,  this was their first experience.",
      thumb: "assets/img/spectrum/142.jpg",
    },
    {
      src: "assets/img/spectrum/143.jpg",
      caption:
        "All the special kids enjoyed the colorful lighting, mild music, delicious snacks and varieties of play equipments at the play area of the mall. For a few of the kids,  this was their first experience.",
      thumb: "assets/img/spectrum/143.jpg",
    },
    {
      src: "assets/img/spectrum/145.jpg",
      caption:
        "All the special kids enjoyed the colorful lighting, mild music, delicious snacks and varieties of play equipments at the play area of the mall. For a few of the kids,  this was their first experience.",
      thumb: "assets/img/spectrum/145.jpg",
    },
    {
      src: "assets/img/spectrum/148.jpg",
      caption:
        "All the special kids enjoyed the colorful lighting, mild music, delicious snacks and varieties of play equipments at the play area of the mall. For a few of the kids,  this was their first experience.",
      thumb: "assets/img/spectrum/148.jpg",
    },
    {
      src: "assets/img/spectrum/111.jpg",
      caption:
        "ഗാന്ധിഭവൻ സെക്രട്ടറി ശ്രീ സോമരാജ് സാറിന്റെ സാന്നിധ്യത്തിൽ നിംസ് മെഡിസിറ്റി മാനേജിങ് ഡയറക്ടർ ശ്രീ എം എസ് ഫൈസൽ ഖാൻ ഉത്ഘാടന കർമ്മം നിർവഹിച്ചു. പൂർണ്ണമായും നിംസ് മാനേജ്മെന്റിന്റെ മേൽനോട്ടത്തിൽ പ്രവർത്തനം ആരംഭിച്ച നിംസ് സ്‌പെക്ടറം ഗാന്ധിഭവൻ ഞങ്ങളുടെ തന്നെ മികച്ച ഡോക്ടർസിന്റെയും തെറാപ്പിസ്റ്റുകളുടെയും വിദ്യാർത്ഥികളുടെയും സേവനങ്ങളാൽ സദാ സജ്ജമായിരിക്കും.നിംസ് മെഡിസിറ്റിയുടെ ഭിന്നശേഷികുട്ടികൾക്കുവേണ്ടിയുള്ള നെയ്യാറ്റിൻകര പെൻഷൻ പദ്ധതി നിലവിൽ നെയ്യാറ്റിൻകരയിലെ അഞ്ചു പഞ്ചായത്തുകളിൽ നൽകിവരുന്നുണ്ട്.",
      thumb: "assets/img/spectrum/111.jpg",
    },
    {
      src: "assets/img/spectrum/112.jpg",
      caption:
        "ഗാന്ധിഭവൻ സെക്രട്ടറി ശ്രീ സോമരാജ് സാറിന്റെ സാന്നിധ്യത്തിൽ നിംസ് മെഡിസിറ്റി മാനേജിങ് ഡയറക്ടർ ശ്രീ എം എസ് ഫൈസൽ ഖാൻ ഉത്ഘാടന കർമ്മം നിർവഹിച്ചു. പൂർണ്ണമായും നിംസ് മാനേജ്മെന്റിന്റെ മേൽനോട്ടത്തിൽ പ്രവർത്തനം ആരംഭിച്ച നിംസ് സ്‌പെക്ടറം ഗാന്ധിഭവൻ ഞങ്ങളുടെ തന്നെ മികച്ച ഡോക്ടർസിന്റെയും തെറാപ്പിസ്റ്റുകളുടെയും വിദ്യാർത്ഥികളുടെയും സേവനങ്ങളാൽ സദാ സജ്ജമായിരിക്കും.നിംസ് മെഡിസിറ്റിയുടെ ഭിന്നശേഷികുട്ടികൾക്കുവേണ്ടിയുള്ള നെയ്യാറ്റിൻകര പെൻഷൻ പദ്ധതി നിലവിൽ നെയ്യാറ്റിൻകരയിലെ അഞ്ചു പഞ്ചായത്തുകളിൽ നൽകിവരുന്നുണ്ട്.",
      thumb: "assets/img/spectrum/112.jpg",
    },
    {
      src: "assets/img/spectrum/113.jpg",
      caption:
        "ഗാന്ധിഭവൻ സെക്രട്ടറി ശ്രീ സോമരാജ് സാറിന്റെ സാന്നിധ്യത്തിൽ നിംസ് മെഡിസിറ്റി മാനേജിങ് ഡയറക്ടർ ശ്രീ എം എസ് ഫൈസൽ ഖാൻ ഉത്ഘാടന കർമ്മം നിർവഹിച്ചു. പൂർണ്ണമായും നിംസ് മാനേജ്മെന്റിന്റെ മേൽനോട്ടത്തിൽ പ്രവർത്തനം ആരംഭിച്ച നിംസ് സ്‌പെക്ടറം ഗാന്ധിഭവൻ ഞങ്ങളുടെ തന്നെ മികച്ച ഡോക്ടർസിന്റെയും തെറാപ്പിസ്റ്റുകളുടെയും വിദ്യാർത്ഥികളുടെയും സേവനങ്ങളാൽ സദാ സജ്ജമായിരിക്കും.നിംസ് മെഡിസിറ്റിയുടെ ഭിന്നശേഷികുട്ടികൾക്കുവേണ്ടിയുള്ള നെയ്യാറ്റിൻകര പെൻഷൻ പദ്ധതി നിലവിൽ നെയ്യാറ്റിൻകരയിലെ അഞ്ചു പഞ്ചായത്തുകളിൽ നൽകിവരുന്നുണ്ട്.",
      thumb: "assets/img/spectrum/113.jpg",
    },
    {
      src: "assets/img/spectrum/114.jpg",
      caption:
        "ഗാന്ധിഭവൻ സെക്രട്ടറി ശ്രീ സോമരാജ് സാറിന്റെ സാന്നിധ്യത്തിൽ നിംസ് മെഡിസിറ്റി മാനേജിങ് ഡയറക്ടർ ശ്രീ എം എസ് ഫൈസൽ ഖാൻ ഉത്ഘാടന കർമ്മം നിർവഹിച്ചു. പൂർണ്ണമായും നിംസ് മാനേജ്മെന്റിന്റെ മേൽനോട്ടത്തിൽ പ്രവർത്തനം ആരംഭിച്ച നിംസ് സ്‌പെക്ടറം ഗാന്ധിഭവൻ ഞങ്ങളുടെ തന്നെ മികച്ച ഡോക്ടർസിന്റെയും തെറാപ്പിസ്റ്റുകളുടെയും വിദ്യാർത്ഥികളുടെയും സേവനങ്ങളാൽ സദാ സജ്ജമായിരിക്കും.നിംസ് മെഡിസിറ്റിയുടെ ഭിന്നശേഷികുട്ടികൾക്കുവേണ്ടിയുള്ള നെയ്യാറ്റിൻകര പെൻഷൻ പദ്ധതി നിലവിൽ നെയ്യാറ്റിൻകരയിലെ അഞ്ചു പഞ്ചായത്തുകളിൽ നൽകിവരുന്നുണ്ട്.",
      thumb: "assets/img/spectrum/114.jpg",
    },
    {
      src: "assets/img/spectrum/115.jpg",
      caption:
        "ഗാന്ധിഭവൻ സെക്രട്ടറി ശ്രീ സോമരാജ് സാറിന്റെ സാന്നിധ്യത്തിൽ നിംസ് മെഡിസിറ്റി മാനേജിങ് ഡയറക്ടർ ശ്രീ എം എസ് ഫൈസൽ ഖാൻ ഉത്ഘാടന കർമ്മം നിർവഹിച്ചു. പൂർണ്ണമായും നിംസ് മാനേജ്മെന്റിന്റെ മേൽനോട്ടത്തിൽ പ്രവർത്തനം ആരംഭിച്ച നിംസ് സ്‌പെക്ടറം ഗാന്ധിഭവൻ ഞങ്ങളുടെ തന്നെ മികച്ച ഡോക്ടർസിന്റെയും തെറാപ്പിസ്റ്റുകളുടെയും വിദ്യാർത്ഥികളുടെയും സേവനങ്ങളാൽ സദാ സജ്ജമായിരിക്കും.നിംസ് മെഡിസിറ്റിയുടെ ഭിന്നശേഷികുട്ടികൾക്കുവേണ്ടിയുള്ള നെയ്യാറ്റിൻകര പെൻഷൻ പദ്ധതി നിലവിൽ നെയ്യാറ്റിൻകരയിലെ അഞ്ചു പഞ്ചായത്തുകളിൽ നൽകിവരുന്നുണ്ട്.",
      thumb: "assets/img/spectrum/115.jpg",
    },
    {
      src: "assets/img/spectrum/116.jpg",
      caption:
        "ഗാന്ധിഭവൻ സെക്രട്ടറി ശ്രീ സോമരാജ് സാറിന്റെ സാന്നിധ്യത്തിൽ നിംസ് മെഡിസിറ്റി മാനേജിങ് ഡയറക്ടർ ശ്രീ എം എസ് ഫൈസൽ ഖാൻ ഉത്ഘാടന കർമ്മം നിർവഹിച്ചു. പൂർണ്ണമായും നിംസ് മാനേജ്മെന്റിന്റെ മേൽനോട്ടത്തിൽ പ്രവർത്തനം ആരംഭിച്ച നിംസ് സ്‌പെക്ടറം ഗാന്ധിഭവൻ ഞങ്ങളുടെ തന്നെ മികച്ച ഡോക്ടർസിന്റെയും തെറാപ്പിസ്റ്റുകളുടെയും വിദ്യാർത്ഥികളുടെയും സേവനങ്ങളാൽ സദാ സജ്ജമായിരിക്കും.നിംസ് മെഡിസിറ്റിയുടെ ഭിന്നശേഷികുട്ടികൾക്കുവേണ്ടിയുള്ള നെയ്യാറ്റിൻകര പെൻഷൻ പദ്ധതി നിലവിൽ നെയ്യാറ്റിൻകരയിലെ അഞ്ചു പഞ്ചായത്തുകളിൽ നൽകിവരുന്നുണ്ട്.",
      thumb: "assets/img/spectrum/116.jpg",
    },
    {
      src: "assets/img/spectrum/117.jpg",
      caption:
        "ഗാന്ധിഭവൻ സെക്രട്ടറി ശ്രീ സോമരാജ് സാറിന്റെ സാന്നിധ്യത്തിൽ നിംസ് മെഡിസിറ്റി മാനേജിങ് ഡയറക്ടർ ശ്രീ എം എസ് ഫൈസൽ ഖാൻ ഉത്ഘാടന കർമ്മം നിർവഹിച്ചു. പൂർണ്ണമായും നിംസ് മാനേജ്മെന്റിന്റെ മേൽനോട്ടത്തിൽ പ്രവർത്തനം ആരംഭിച്ച നിംസ് സ്‌പെക്ടറം ഗാന്ധിഭവൻ ഞങ്ങളുടെ തന്നെ മികച്ച ഡോക്ടർസിന്റെയും തെറാപ്പിസ്റ്റുകളുടെയും വിദ്യാർത്ഥികളുടെയും സേവനങ്ങളാൽ സദാ സജ്ജമായിരിക്കും.നിംസ് മെഡിസിറ്റിയുടെ ഭിന്നശേഷികുട്ടികൾക്കുവേണ്ടിയുള്ള നെയ്യാറ്റിൻകര പെൻഷൻ പദ്ധതി നിലവിൽ നെയ്യാറ്റിൻകരയിലെ അഞ്ചു പഞ്ചായത്തുകളിൽ നൽകിവരുന്നുണ്ട്.",
      thumb: "assets/img/spectrum/117.jpg",
    },
    {
      src: "assets/img/spectrum/118.jpg",
      caption:
        "ഗാന്ധിഭവൻ സെക്രട്ടറി ശ്രീ സോമരാജ് സാറിന്റെ സാന്നിധ്യത്തിൽ നിംസ് മെഡിസിറ്റി മാനേജിങ് ഡയറക്ടർ ശ്രീ എം എസ് ഫൈസൽ ഖാൻ ഉത്ഘാടന കർമ്മം നിർവഹിച്ചു. പൂർണ്ണമായും നിംസ് മാനേജ്മെന്റിന്റെ മേൽനോട്ടത്തിൽ പ്രവർത്തനം ആരംഭിച്ച നിംസ് സ്‌പെക്ടറം ഗാന്ധിഭവൻ ഞങ്ങളുടെ തന്നെ മികച്ച ഡോക്ടർസിന്റെയും തെറാപ്പിസ്റ്റുകളുടെയും വിദ്യാർത്ഥികളുടെയും സേവനങ്ങളാൽ സദാ സജ്ജമായിരിക്കും.നിംസ് മെഡിസിറ്റിയുടെ ഭിന്നശേഷികുട്ടികൾക്കുവേണ്ടിയുള്ള നെയ്യാറ്റിൻകര പെൻഷൻ പദ്ധതി നിലവിൽ നെയ്യാറ്റിൻകരയിലെ അഞ്ചു പഞ്ചായത്തുകളിൽ നൽകിവരുന്നുണ്ട്.",
      thumb: "assets/img/spectrum/118.jpg",
    },
    {
      src: "assets/img/spectrum/119.jpg",
      caption:
        "ഗാന്ധിഭവൻ സെക്രട്ടറി ശ്രീ സോമരാജ് സാറിന്റെ സാന്നിധ്യത്തിൽ നിംസ് മെഡിസിറ്റി മാനേജിങ് ഡയറക്ടർ ശ്രീ എം എസ് ഫൈസൽ ഖാൻ ഉത്ഘാടന കർമ്മം നിർവഹിച്ചു. പൂർണ്ണമായും നിംസ് മാനേജ്മെന്റിന്റെ മേൽനോട്ടത്തിൽ പ്രവർത്തനം ആരംഭിച്ച നിംസ് സ്‌പെക്ടറം ഗാന്ധിഭവൻ ഞങ്ങളുടെ തന്നെ മികച്ച ഡോക്ടർസിന്റെയും തെറാപ്പിസ്റ്റുകളുടെയും വിദ്യാർത്ഥികളുടെയും സേവനങ്ങളാൽ സദാ സജ്ജമായിരിക്കും.നിംസ് മെഡിസിറ്റിയുടെ ഭിന്നശേഷികുട്ടികൾക്കുവേണ്ടിയുള്ള നെയ്യാറ്റിൻകര പെൻഷൻ പദ്ധതി നിലവിൽ നെയ്യാറ്റിൻകരയിലെ അഞ്ചു പഞ്ചായത്തുകളിൽ നൽകിവരുന്നുണ്ട്.",
      thumb: "assets/img/spectrum/119.jpg",
    },
    {
      src: "assets/img/spectrum/120.jpg",
      caption:
        "ഗാന്ധിഭവൻ സെക്രട്ടറി ശ്രീ സോമരാജ് സാറിന്റെ സാന്നിധ്യത്തിൽ നിംസ് മെഡിസിറ്റി മാനേജിങ് ഡയറക്ടർ ശ്രീ എം എസ് ഫൈസൽ ഖാൻ ഉത്ഘാടന കർമ്മം നിർവഹിച്ചു. പൂർണ്ണമായും നിംസ് മാനേജ്മെന്റിന്റെ മേൽനോട്ടത്തിൽ പ്രവർത്തനം ആരംഭിച്ച നിംസ് സ്‌പെക്ടറം ഗാന്ധിഭവൻ ഞങ്ങളുടെ തന്നെ മികച്ച ഡോക്ടർസിന്റെയും തെറാപ്പിസ്റ്റുകളുടെയും വിദ്യാർത്ഥികളുടെയും സേവനങ്ങളാൽ സദാ സജ്ജമായിരിക്കും.നിംസ് മെഡിസിറ്റിയുടെ ഭിന്നശേഷികുട്ടികൾക്കുവേണ്ടിയുള്ള നെയ്യാറ്റിൻകര പെൻഷൻ പദ്ധതി നിലവിൽ നെയ്യാറ്റിൻകരയിലെ അഞ്ചു പഞ്ചായത്തുകളിൽ നൽകിവരുന്നുണ്ട്.",
      thumb: "assets/img/spectrum/120.jpg",
    },
    {
      src: "assets/img/spectrum/121.jpg",
      caption:
        "ഗാന്ധിഭവൻ സെക്രട്ടറി ശ്രീ സോമരാജ് സാറിന്റെ സാന്നിധ്യത്തിൽ നിംസ് മെഡിസിറ്റി മാനേജിങ് ഡയറക്ടർ ശ്രീ എം എസ് ഫൈസൽ ഖാൻ ഉത്ഘാടന കർമ്മം നിർവഹിച്ചു. പൂർണ്ണമായും നിംസ് മാനേജ്മെന്റിന്റെ മേൽനോട്ടത്തിൽ പ്രവർത്തനം ആരംഭിച്ച നിംസ് സ്‌പെക്ടറം ഗാന്ധിഭവൻ ഞങ്ങളുടെ തന്നെ മികച്ച ഡോക്ടർസിന്റെയും തെറാപ്പിസ്റ്റുകളുടെയും വിദ്യാർത്ഥികളുടെയും സേവനങ്ങളാൽ സദാ സജ്ജമായിരിക്കും.നിംസ് മെഡിസിറ്റിയുടെ ഭിന്നശേഷികുട്ടികൾക്കുവേണ്ടിയുള്ള നെയ്യാറ്റിൻകര പെൻഷൻ പദ്ധതി നിലവിൽ നെയ്യാറ്റിൻകരയിലെ അഞ്ചു പഞ്ചായത്തുകളിൽ നൽകിവരുന്നുണ്ട്.",
      thumb: "assets/img/spectrum/121.jpg",
    },
    {
      src: "assets/img/spectrum/122.jpg",
      caption:
        "ഗാന്ധിഭവൻ സെക്രട്ടറി ശ്രീ സോമരാജ് സാറിന്റെ സാന്നിധ്യത്തിൽ നിംസ് മെഡിസിറ്റി മാനേജിങ് ഡയറക്ടർ ശ്രീ എം എസ് ഫൈസൽ ഖാൻ ഉത്ഘാടന കർമ്മം നിർവഹിച്ചു. പൂർണ്ണമായും നിംസ് മാനേജ്മെന്റിന്റെ മേൽനോട്ടത്തിൽ പ്രവർത്തനം ആരംഭിച്ച നിംസ് സ്‌പെക്ടറം ഗാന്ധിഭവൻ ഞങ്ങളുടെ തന്നെ മികച്ച ഡോക്ടർസിന്റെയും തെറാപ്പിസ്റ്റുകളുടെയും വിദ്യാർത്ഥികളുടെയും സേവനങ്ങളാൽ സദാ സജ്ജമായിരിക്കും.നിംസ് മെഡിസിറ്റിയുടെ ഭിന്നശേഷികുട്ടികൾക്കുവേണ്ടിയുള്ള നെയ്യാറ്റിൻകര പെൻഷൻ പദ്ധതി നിലവിൽ നെയ്യാറ്റിൻകരയിലെ അഞ്ചു പഞ്ചായത്തുകളിൽ നൽകിവരുന്നുണ്ട്.",
      thumb: "assets/img/spectrum/122.jpg",
    },
    {
      src: "assets/img/spectrum/123.jpg",
      caption:
        "ഗാന്ധിഭവൻ സെക്രട്ടറി ശ്രീ സോമരാജ് സാറിന്റെ സാന്നിധ്യത്തിൽ നിംസ് മെഡിസിറ്റി മാനേജിങ് ഡയറക്ടർ ശ്രീ എം എസ് ഫൈസൽ ഖാൻ ഉത്ഘാടന കർമ്മം നിർവഹിച്ചു. പൂർണ്ണമായും നിംസ് മാനേജ്മെന്റിന്റെ മേൽനോട്ടത്തിൽ പ്രവർത്തനം ആരംഭിച്ച നിംസ് സ്‌പെക്ടറം ഗാന്ധിഭവൻ ഞങ്ങളുടെ തന്നെ മികച്ച ഡോക്ടർസിന്റെയും തെറാപ്പിസ്റ്റുകളുടെയും വിദ്യാർത്ഥികളുടെയും സേവനങ്ങളാൽ സദാ സജ്ജമായിരിക്കും.നിംസ് മെഡിസിറ്റിയുടെ ഭിന്നശേഷികുട്ടികൾക്കുവേണ്ടിയുള്ള നെയ്യാറ്റിൻകര പെൻഷൻ പദ്ധതി നിലവിൽ നെയ്യാറ്റിൻകരയിലെ അഞ്ചു പഞ്ചായത്തുകളിൽ നൽകിവരുന്നുണ്ട്.",
      thumb: "assets/img/spectrum/123.jpg",
    },
    {
      src: "assets/img/spectrum/124.jpg",
      caption:
        "ഗാന്ധിഭവൻ സെക്രട്ടറി ശ്രീ സോമരാജ് സാറിന്റെ സാന്നിധ്യത്തിൽ നിംസ് മെഡിസിറ്റി മാനേജിങ് ഡയറക്ടർ ശ്രീ എം എസ് ഫൈസൽ ഖാൻ ഉത്ഘാടന കർമ്മം നിർവഹിച്ചു. പൂർണ്ണമായും നിംസ് മാനേജ്മെന്റിന്റെ മേൽനോട്ടത്തിൽ പ്രവർത്തനം ആരംഭിച്ച നിംസ് സ്‌പെക്ടറം ഗാന്ധിഭവൻ ഞങ്ങളുടെ തന്നെ മികച്ച ഡോക്ടർസിന്റെയും തെറാപ്പിസ്റ്റുകളുടെയും വിദ്യാർത്ഥികളുടെയും സേവനങ്ങളാൽ സദാ സജ്ജമായിരിക്കും.നിംസ് മെഡിസിറ്റിയുടെ ഭിന്നശേഷികുട്ടികൾക്കുവേണ്ടിയുള്ള നെയ്യാറ്റിൻകര പെൻഷൻ പദ്ധതി നിലവിൽ നെയ്യാറ്റിൻകരയിലെ അഞ്ചു പഞ്ചായത്തുകളിൽ നൽകിവരുന്നുണ്ട്.",
      thumb: "assets/img/spectrum/124.jpg",
    },
    {
      src: "assets/img/spectrum/125.jpg",
      caption:
        "ഗാന്ധിഭവൻ സെക്രട്ടറി ശ്രീ സോമരാജ് സാറിന്റെ സാന്നിധ്യത്തിൽ നിംസ് മെഡിസിറ്റി മാനേജിങ് ഡയറക്ടർ ശ്രീ എം എസ് ഫൈസൽ ഖാൻ ഉത്ഘാടന കർമ്മം നിർവഹിച്ചു. പൂർണ്ണമായും നിംസ് മാനേജ്മെന്റിന്റെ മേൽനോട്ടത്തിൽ പ്രവർത്തനം ആരംഭിച്ച നിംസ് സ്‌പെക്ടറം ഗാന്ധിഭവൻ ഞങ്ങളുടെ തന്നെ മികച്ച ഡോക്ടർസിന്റെയും തെറാപ്പിസ്റ്റുകളുടെയും വിദ്യാർത്ഥികളുടെയും സേവനങ്ങളാൽ സദാ സജ്ജമായിരിക്കും.നിംസ് മെഡിസിറ്റിയുടെ ഭിന്നശേഷികുട്ടികൾക്കുവേണ്ടിയുള്ള നെയ്യാറ്റിൻകര പെൻഷൻ പദ്ധതി നിലവിൽ നെയ്യാറ്റിൻകരയിലെ അഞ്ചു പഞ്ചായത്തുകളിൽ നൽകിവരുന്നുണ്ട്.",
      thumb: "assets/img/spectrum/125.jpg",
    },
    {
      src: "assets/img/spectrum/126.jpg",
      caption:
        "നിംസ് സ്‌പെക്ടറം ശിശു വികസന ഗവേഷണ കേന്ദ്രം - അവരുടെ കഴിവുകൾക്കും ചിറകുകൾ മുളക്കട്ടെ എന്ന ആശയം മുൻനിർത്തി ഡിസംബർ 03, 2019 ൽ ആരംഭിച്ച പദ്ധതി ഇന്ന് വലിയ സന്തോഷങ്ങൾ പങ്കിട്ടു യാത്ര തുടരുന്നു. ചൈൽഡ് ഡെവലപ്പ്മെന്റ് തെറാപ്പി, ബിഹേവിയറൽ തെറാപ്പിയും സ്പെഷ്യൽ എഡ്യൂക്കേഷനും, ഓട്ടിസ്റ്റിക് ഫിസിയോതെറാപ്പി, ഫിസിയാട്രിക് മെഡിക്കൽ മാനേജ്മെന്റ്, ക്ലിനിക്കൽ സൈക്കോളജി, ഓട്ടിസ്റ്റിക് ഓർത്തോപീടിക്സ്, ഈ എൻ റ്റി, ഓഡിയോളജി സ്പീച്ച് തെറാപ്പി, ഒഫ്താൽമോളജി, ഹ്യൂമൻ ജനറ്റിക്സ്, ന്യൂട്രിഷൻ തുടങ്ങി ഒട്ടനവധി തെറാപ്പികൾ ഒരു കുടകീഴിൽ ലാഭേച്ചകളില്ലാതെ നൽകിവരുന്ന പദ്ധതി. വൈകല്യങ്ങളെ മറന്നു ജീവിതത്തിൽ തങ്ങളുടേതായ സ്ഥാനം കണ്ടെത്താനും അവരുടെ സ്വപ്‌നങ്ങൾ എത്തിപ്പിടിക്കുവാനും അവർക്കൊപ്പം ഞങ്ങളും യാത്ര തുടരുന്നു.",
      thumb: "assets/img/spectrum/126.jpg",
    },
    {
      src: "assets/img/spectrum/127.jpg",
      caption:
        "നിംസ് സ്‌പെക്ടറം ശിശു വികസന ഗവേഷണ കേന്ദ്രം - അവരുടെ കഴിവുകൾക്കും ചിറകുകൾ മുളക്കട്ടെ എന്ന ആശയം മുൻനിർത്തി ഡിസംബർ 03, 2019 ൽ ആരംഭിച്ച പദ്ധതി ഇന്ന് വലിയ സന്തോഷങ്ങൾ പങ്കിട്ടു യാത്ര തുടരുന്നു. ചൈൽഡ് ഡെവലപ്പ്മെന്റ് തെറാപ്പി, ബിഹേവിയറൽ തെറാപ്പിയും സ്പെഷ്യൽ എഡ്യൂക്കേഷനും, ഓട്ടിസ്റ്റിക് ഫിസിയോതെറാപ്പി, ഫിസിയാട്രിക് മെഡിക്കൽ മാനേജ്മെന്റ്, ക്ലിനിക്കൽ സൈക്കോളജി, ഓട്ടിസ്റ്റിക് ഓർത്തോപീടിക്സ്, ഈ എൻ റ്റി, ഓഡിയോളജി സ്പീച്ച് തെറാപ്പി, ഒഫ്താൽമോളജി, ഹ്യൂമൻ ജനറ്റിക്സ്, ന്യൂട്രിഷൻ തുടങ്ങി ഒട്ടനവധി തെറാപ്പികൾ ഒരു കുടകീഴിൽ ലാഭേച്ചകളില്ലാതെ നൽകിവരുന്ന പദ്ധതി. വൈകല്യങ്ങളെ മറന്നു ജീവിതത്തിൽ തങ്ങളുടേതായ സ്ഥാനം കണ്ടെത്താനും അവരുടെ സ്വപ്‌നങ്ങൾ എത്തിപ്പിടിക്കുവാനും അവർക്കൊപ്പം ഞങ്ങളും യാത്ര തുടരുന്നു.",
      thumb: "assets/img/spectrum/127.jpg",
    },
    {
      src: "assets/img/spectrum/128.jpg",
      caption:
        "നിംസ് സ്‌പെക്ടറം ശിശു വികസന ഗവേഷണ കേന്ദ്രം - അവരുടെ കഴിവുകൾക്കും ചിറകുകൾ മുളക്കട്ടെ എന്ന ആശയം മുൻനിർത്തി ഡിസംബർ 03, 2019 ൽ ആരംഭിച്ച പദ്ധതി ഇന്ന് വലിയ സന്തോഷങ്ങൾ പങ്കിട്ടു യാത്ര തുടരുന്നു. ചൈൽഡ് ഡെവലപ്പ്മെന്റ് തെറാപ്പി, ബിഹേവിയറൽ തെറാപ്പിയും സ്പെഷ്യൽ എഡ്യൂക്കേഷനും, ഓട്ടിസ്റ്റിക് ഫിസിയോതെറാപ്പി, ഫിസിയാട്രിക് മെഡിക്കൽ മാനേജ്മെന്റ്, ക്ലിനിക്കൽ സൈക്കോളജി, ഓട്ടിസ്റ്റിക് ഓർത്തോപീടിക്സ്, ഈ എൻ റ്റി, ഓഡിയോളജി സ്പീച്ച് തെറാപ്പി, ഒഫ്താൽമോളജി, ഹ്യൂമൻ ജനറ്റിക്സ്, ന്യൂട്രിഷൻ തുടങ്ങി ഒട്ടനവധി തെറാപ്പികൾ ഒരു കുടകീഴിൽ ലാഭേച്ചകളില്ലാതെ നൽകിവരുന്ന പദ്ധതി. വൈകല്യങ്ങളെ മറന്നു ജീവിതത്തിൽ തങ്ങളുടേതായ സ്ഥാനം കണ്ടെത്താനും അവരുടെ സ്വപ്‌നങ്ങൾ എത്തിപ്പിടിക്കുവാനും അവർക്കൊപ്പം ഞങ്ങളും യാത്ര തുടരുന്നു.",
      thumb: "assets/img/spectrum/128.jpg",
    },
    {
      src: "assets/img/spectrum/129.jpg",
      caption:
        "നിംസ് സ്‌പെക്ടറം ശിശു വികസന ഗവേഷണ കേന്ദ്രം - അവരുടെ കഴിവുകൾക്കും ചിറകുകൾ മുളക്കട്ടെ എന്ന ആശയം മുൻനിർത്തി ഡിസംബർ 03, 2019 ൽ ആരംഭിച്ച പദ്ധതി ഇന്ന് വലിയ സന്തോഷങ്ങൾ പങ്കിട്ടു യാത്ര തുടരുന്നു. ചൈൽഡ് ഡെവലപ്പ്മെന്റ് തെറാപ്പി, ബിഹേവിയറൽ തെറാപ്പിയും സ്പെഷ്യൽ എഡ്യൂക്കേഷനും, ഓട്ടിസ്റ്റിക് ഫിസിയോതെറാപ്പി, ഫിസിയാട്രിക് മെഡിക്കൽ മാനേജ്മെന്റ്, ക്ലിനിക്കൽ സൈക്കോളജി, ഓട്ടിസ്റ്റിക് ഓർത്തോപീടിക്സ്, ഈ എൻ റ്റി, ഓഡിയോളജി സ്പീച്ച് തെറാപ്പി, ഒഫ്താൽമോളജി, ഹ്യൂമൻ ജനറ്റിക്സ്, ന്യൂട്രിഷൻ തുടങ്ങി ഒട്ടനവധി തെറാപ്പികൾ ഒരു കുടകീഴിൽ ലാഭേച്ചകളില്ലാതെ നൽകിവരുന്ന പദ്ധതി. വൈകല്യങ്ങളെ മറന്നു ജീവിതത്തിൽ തങ്ങളുടേതായ സ്ഥാനം കണ്ടെത്താനും അവരുടെ സ്വപ്‌നങ്ങൾ എത്തിപ്പിടിക്കുവാനും അവർക്കൊപ്പം ഞങ്ങളും യാത്ര തുടരുന്നു.",
      thumb: "assets/img/spectrum/129.jpg",
    },
    {
      src: "assets/img/spectrum/130.jpg",
      caption:
        "നിംസ് സ്‌പെക്ടറം ശിശു വികസന ഗവേഷണ കേന്ദ്രം - അവരുടെ കഴിവുകൾക്കും ചിറകുകൾ മുളക്കട്ടെ എന്ന ആശയം മുൻനിർത്തി ഡിസംബർ 03, 2019 ൽ ആരംഭിച്ച പദ്ധതി ഇന്ന് വലിയ സന്തോഷങ്ങൾ പങ്കിട്ടു യാത്ര തുടരുന്നു. ചൈൽഡ് ഡെവലപ്പ്മെന്റ് തെറാപ്പി, ബിഹേവിയറൽ തെറാപ്പിയും സ്പെഷ്യൽ എഡ്യൂക്കേഷനും, ഓട്ടിസ്റ്റിക് ഫിസിയോതെറാപ്പി, ഫിസിയാട്രിക് മെഡിക്കൽ മാനേജ്മെന്റ്, ക്ലിനിക്കൽ സൈക്കോളജി, ഓട്ടിസ്റ്റിക് ഓർത്തോപീടിക്സ്, ഈ എൻ റ്റി, ഓഡിയോളജി സ്പീച്ച് തെറാപ്പി, ഒഫ്താൽമോളജി, ഹ്യൂമൻ ജനറ്റിക്സ്, ന്യൂട്രിഷൻ തുടങ്ങി ഒട്ടനവധി തെറാപ്പികൾ ഒരു കുടകീഴിൽ ലാഭേച്ചകളില്ലാതെ നൽകിവരുന്ന പദ്ധതി. വൈകല്യങ്ങളെ മറന്നു ജീവിതത്തിൽ തങ്ങളുടേതായ സ്ഥാനം കണ്ടെത്താനും അവരുടെ സ്വപ്‌നങ്ങൾ എത്തിപ്പിടിക്കുവാനും അവർക്കൊപ്പം ഞങ്ങളും യാത്ര തുടരുന്നു.",
      thumb: "assets/img/spectrum/130.jpg",
    },
    {
      src: "assets/img/spectrum/131.jpg",
      caption:
        "നിംസ് സ്‌പെക്ടറം ശിശു വികസന ഗവേഷണ കേന്ദ്രം - അവരുടെ കഴിവുകൾക്കും ചിറകുകൾ മുളക്കട്ടെ എന്ന ആശയം മുൻനിർത്തി ഡിസംബർ 03, 2019 ൽ ആരംഭിച്ച പദ്ധതി ഇന്ന് വലിയ സന്തോഷങ്ങൾ പങ്കിട്ടു യാത്ര തുടരുന്നു. ചൈൽഡ് ഡെവലപ്പ്മെന്റ് തെറാപ്പി, ബിഹേവിയറൽ തെറാപ്പിയും സ്പെഷ്യൽ എഡ്യൂക്കേഷനും, ഓട്ടിസ്റ്റിക് ഫിസിയോതെറാപ്പി, ഫിസിയാട്രിക് മെഡിക്കൽ മാനേജ്മെന്റ്, ക്ലിനിക്കൽ സൈക്കോളജി, ഓട്ടിസ്റ്റിക് ഓർത്തോപീടിക്സ്, ഈ എൻ റ്റി, ഓഡിയോളജി സ്പീച്ച് തെറാപ്പി, ഒഫ്താൽമോളജി, ഹ്യൂമൻ ജനറ്റിക്സ്, ന്യൂട്രിഷൻ തുടങ്ങി ഒട്ടനവധി തെറാപ്പികൾ ഒരു കുടകീഴിൽ ലാഭേച്ചകളില്ലാതെ നൽകിവരുന്ന പദ്ധതി. വൈകല്യങ്ങളെ മറന്നു ജീവിതത്തിൽ തങ്ങളുടേതായ സ്ഥാനം കണ്ടെത്താനും അവരുടെ സ്വപ്‌നങ്ങൾ എത്തിപ്പിടിക്കുവാനും അവർക്കൊപ്പം ഞങ്ങളും യാത്ര തുടരുന്നു.",
      thumb: "assets/img/spectrum/131.jpg",
    },
    {
      src: "assets/img/spectrum/132.jpg",
      caption:
        "നിംസ് സ്‌പെക്ടറം ശിശു വികസന ഗവേഷണ കേന്ദ്രം - അവരുടെ കഴിവുകൾക്കും ചിറകുകൾ മുളക്കട്ടെ എന്ന ആശയം മുൻനിർത്തി ഡിസംബർ 03, 2019 ൽ ആരംഭിച്ച പദ്ധതി ഇന്ന് വലിയ സന്തോഷങ്ങൾ പങ്കിട്ടു യാത്ര തുടരുന്നു. ചൈൽഡ് ഡെവലപ്പ്മെന്റ് തെറാപ്പി, ബിഹേവിയറൽ തെറാപ്പിയും സ്പെഷ്യൽ എഡ്യൂക്കേഷനും, ഓട്ടിസ്റ്റിക് ഫിസിയോതെറാപ്പി, ഫിസിയാട്രിക് മെഡിക്കൽ മാനേജ്മെന്റ്, ക്ലിനിക്കൽ സൈക്കോളജി, ഓട്ടിസ്റ്റിക് ഓർത്തോപീടിക്സ്, ഈ എൻ റ്റി, ഓഡിയോളജി സ്പീച്ച് തെറാപ്പി, ഒഫ്താൽമോളജി, ഹ്യൂമൻ ജനറ്റിക്സ്, ന്യൂട്രിഷൻ തുടങ്ങി ഒട്ടനവധി തെറാപ്പികൾ ഒരു കുടകീഴിൽ ലാഭേച്ചകളില്ലാതെ നൽകിവരുന്ന പദ്ധതി. വൈകല്യങ്ങളെ മറന്നു ജീവിതത്തിൽ തങ്ങളുടേതായ സ്ഥാനം കണ്ടെത്താനും അവരുടെ സ്വപ്‌നങ്ങൾ എത്തിപ്പിടിക്കുവാനും അവർക്കൊപ്പം ഞങ്ങളും യാത്ര തുടരുന്നു.",
      thumb: "assets/img/spectrum/132.jpg",
    },
    {
      src: "assets/img/spectrum/133.jpg",
      caption:
        "നിംസ് സ്‌പെക്ടറം ശിശു വികസന ഗവേഷണ കേന്ദ്രം - അവരുടെ കഴിവുകൾക്കും ചിറകുകൾ മുളക്കട്ടെ എന്ന ആശയം മുൻനിർത്തി ഡിസംബർ 03, 2019 ൽ ആരംഭിച്ച പദ്ധതി ഇന്ന് വലിയ സന്തോഷങ്ങൾ പങ്കിട്ടു യാത്ര തുടരുന്നു. ചൈൽഡ് ഡെവലപ്പ്മെന്റ് തെറാപ്പി, ബിഹേവിയറൽ തെറാപ്പിയും സ്പെഷ്യൽ എഡ്യൂക്കേഷനും, ഓട്ടിസ്റ്റിക് ഫിസിയോതെറാപ്പി, ഫിസിയാട്രിക് മെഡിക്കൽ മാനേജ്മെന്റ്, ക്ലിനിക്കൽ സൈക്കോളജി, ഓട്ടിസ്റ്റിക് ഓർത്തോപീടിക്സ്, ഈ എൻ റ്റി, ഓഡിയോളജി സ്പീച്ച് തെറാപ്പി, ഒഫ്താൽമോളജി, ഹ്യൂമൻ ജനറ്റിക്സ്, ന്യൂട്രിഷൻ തുടങ്ങി ഒട്ടനവധി തെറാപ്പികൾ ഒരു കുടകീഴിൽ ലാഭേച്ചകളില്ലാതെ നൽകിവരുന്ന പദ്ധതി. വൈകല്യങ്ങളെ മറന്നു ജീവിതത്തിൽ തങ്ങളുടേതായ സ്ഥാനം കണ്ടെത്താനും അവരുടെ സ്വപ്‌നങ്ങൾ എത്തിപ്പിടിക്കുവാനും അവർക്കൊപ്പം ഞങ്ങളും യാത്ര തുടരുന്നു.",
      thumb: "assets/img/spectrum/133.jpg",
    },
    {
      src: "assets/img/spectrum/134.jpg",
      caption:
        "നിംസ് സ്‌പെക്ടറം ശിശു വികസന ഗവേഷണ കേന്ദ്രം - അവരുടെ കഴിവുകൾക്കും ചിറകുകൾ മുളക്കട്ടെ എന്ന ആശയം മുൻനിർത്തി ഡിസംബർ 03, 2019 ൽ ആരംഭിച്ച പദ്ധതി ഇന്ന് വലിയ സന്തോഷങ്ങൾ പങ്കിട്ടു യാത്ര തുടരുന്നു. ചൈൽഡ് ഡെവലപ്പ്മെന്റ് തെറാപ്പി, ബിഹേവിയറൽ തെറാപ്പിയും സ്പെഷ്യൽ എഡ്യൂക്കേഷനും, ഓട്ടിസ്റ്റിക് ഫിസിയോതെറാപ്പി, ഫിസിയാട്രിക് മെഡിക്കൽ മാനേജ്മെന്റ്, ക്ലിനിക്കൽ സൈക്കോളജി, ഓട്ടിസ്റ്റിക് ഓർത്തോപീടിക്സ്, ഈ എൻ റ്റി, ഓഡിയോളജി സ്പീച്ച് തെറാപ്പി, ഒഫ്താൽമോളജി, ഹ്യൂമൻ ജനറ്റിക്സ്, ന്യൂട്രിഷൻ തുടങ്ങി ഒട്ടനവധി തെറാപ്പികൾ ഒരു കുടകീഴിൽ ലാഭേച്ചകളില്ലാതെ നൽകിവരുന്ന പദ്ധതി. വൈകല്യങ്ങളെ മറന്നു ജീവിതത്തിൽ തങ്ങളുടേതായ സ്ഥാനം കണ്ടെത്താനും അവരുടെ സ്വപ്‌നങ്ങൾ എത്തിപ്പിടിക്കുവാനും അവർക്കൊപ്പം ഞങ്ങളും യാത്ര തുടരുന്നു.",
      thumb: "assets/img/spectrum/134.jpg",
    },
    {
      src: "assets/img/spectrum/135.jpg",
      caption:
        "നിംസ് സ്‌പെക്ടറം ശിശു വികസന ഗവേഷണ കേന്ദ്രം - അവരുടെ കഴിവുകൾക്കും ചിറകുകൾ മുളക്കട്ടെ എന്ന ആശയം മുൻനിർത്തി ഡിസംബർ 03, 2019 ൽ ആരംഭിച്ച പദ്ധതി ഇന്ന് വലിയ സന്തോഷങ്ങൾ പങ്കിട്ടു യാത്ര തുടരുന്നു. ചൈൽഡ് ഡെവലപ്പ്മെന്റ് തെറാപ്പി, ബിഹേവിയറൽ തെറാപ്പിയും സ്പെഷ്യൽ എഡ്യൂക്കേഷനും, ഓട്ടിസ്റ്റിക് ഫിസിയോതെറാപ്പി, ഫിസിയാട്രിക് മെഡിക്കൽ മാനേജ്മെന്റ്, ക്ലിനിക്കൽ സൈക്കോളജി, ഓട്ടിസ്റ്റിക് ഓർത്തോപീടിക്സ്, ഈ എൻ റ്റി, ഓഡിയോളജി സ്പീച്ച് തെറാപ്പി, ഒഫ്താൽമോളജി, ഹ്യൂമൻ ജനറ്റിക്സ്, ന്യൂട്രിഷൻ തുടങ്ങി ഒട്ടനവധി തെറാപ്പികൾ ഒരു കുടകീഴിൽ ലാഭേച്ചകളില്ലാതെ നൽകിവരുന്ന പദ്ധതി. വൈകല്യങ്ങളെ മറന്നു ജീവിതത്തിൽ തങ്ങളുടേതായ സ്ഥാനം കണ്ടെത്താനും അവരുടെ സ്വപ്‌നങ്ങൾ എത്തിപ്പിടിക്കുവാനും അവർക്കൊപ്പം ഞങ്ങളും യാത്ര തുടരുന്നു.",
      thumb: "assets/img/spectrum/135.jpg",
    },
    {
      src: "assets/img/spectrum/136.jpg",
      caption:
        "നിംസ് സ്‌പെക്ടറം ശിശു വികസന ഗവേഷണ കേന്ദ്രം - അവരുടെ കഴിവുകൾക്കും ചിറകുകൾ മുളക്കട്ടെ എന്ന ആശയം മുൻനിർത്തി ഡിസംബർ 03, 2019 ൽ ആരംഭിച്ച പദ്ധതി ഇന്ന് വലിയ സന്തോഷങ്ങൾ പങ്കിട്ടു യാത്ര തുടരുന്നു. ചൈൽഡ് ഡെവലപ്പ്മെന്റ് തെറാപ്പി, ബിഹേവിയറൽ തെറാപ്പിയും സ്പെഷ്യൽ എഡ്യൂക്കേഷനും, ഓട്ടിസ്റ്റിക് ഫിസിയോതെറാപ്പി, ഫിസിയാട്രിക് മെഡിക്കൽ മാനേജ്മെന്റ്, ക്ലിനിക്കൽ സൈക്കോളജി, ഓട്ടിസ്റ്റിക് ഓർത്തോപീടിക്സ്, ഈ എൻ റ്റി, ഓഡിയോളജി സ്പീച്ച് തെറാപ്പി, ഒഫ്താൽമോളജി, ഹ്യൂമൻ ജനറ്റിക്സ്, ന്യൂട്രിഷൻ തുടങ്ങി ഒട്ടനവധി തെറാപ്പികൾ ഒരു കുടകീഴിൽ ലാഭേച്ചകളില്ലാതെ നൽകിവരുന്ന പദ്ധതി. വൈകല്യങ്ങളെ മറന്നു ജീവിതത്തിൽ തങ്ങളുടേതായ സ്ഥാനം കണ്ടെത്താനും അവരുടെ സ്വപ്‌നങ്ങൾ എത്തിപ്പിടിക്കുവാനും അവർക്കൊപ്പം ഞങ്ങളും യാത്ര തുടരുന്നു.",
      thumb: "assets/img/spectrum/136.jpg",
    },
    {
      src: "assets/img/spectrum/137.jpg",
      caption:
        "നിംസ് സ്‌പെക്ടറം ശിശു വികസന ഗവേഷണ കേന്ദ്രം - അവരുടെ കഴിവുകൾക്കും ചിറകുകൾ മുളക്കട്ടെ എന്ന ആശയം മുൻനിർത്തി ഡിസംബർ 03, 2019 ൽ ആരംഭിച്ച പദ്ധതി ഇന്ന് വലിയ സന്തോഷങ്ങൾ പങ്കിട്ടു യാത്ര തുടരുന്നു. ചൈൽഡ് ഡെവലപ്പ്മെന്റ് തെറാപ്പി, ബിഹേവിയറൽ തെറാപ്പിയും സ്പെഷ്യൽ എഡ്യൂക്കേഷനും, ഓട്ടിസ്റ്റിക് ഫിസിയോതെറാപ്പി, ഫിസിയാട്രിക് മെഡിക്കൽ മാനേജ്മെന്റ്, ക്ലിനിക്കൽ സൈക്കോളജി, ഓട്ടിസ്റ്റിക് ഓർത്തോപീടിക്സ്, ഈ എൻ റ്റി, ഓഡിയോളജി സ്പീച്ച് തെറാപ്പി, ഒഫ്താൽമോളജി, ഹ്യൂമൻ ജനറ്റിക്സ്, ന്യൂട്രിഷൻ തുടങ്ങി ഒട്ടനവധി തെറാപ്പികൾ ഒരു കുടകീഴിൽ ലാഭേച്ചകളില്ലാതെ നൽകിവരുന്ന പദ്ധതി. വൈകല്യങ്ങളെ മറന്നു ജീവിതത്തിൽ തങ്ങളുടേതായ സ്ഥാനം കണ്ടെത്താനും അവരുടെ സ്വപ്‌നങ്ങൾ എത്തിപ്പിടിക്കുവാനും അവർക്കൊപ്പം ഞങ്ങളും യാത്ര തുടരുന്നു.",
      thumb: "assets/img/spectrum/137.jpg",
    },
    {
      src: "assets/img/spectrum/138.jpg",
      caption:
        "നിംസ് സ്‌പെക്ടറം ശിശു വികസന ഗവേഷണ കേന്ദ്രം - അവരുടെ കഴിവുകൾക്കും ചിറകുകൾ മുളക്കട്ടെ എന്ന ആശയം മുൻനിർത്തി ഡിസംബർ 03, 2019 ൽ ആരംഭിച്ച പദ്ധതി ഇന്ന് വലിയ സന്തോഷങ്ങൾ പങ്കിട്ടു യാത്ര തുടരുന്നു. ചൈൽഡ് ഡെവലപ്പ്മെന്റ് തെറാപ്പി, ബിഹേവിയറൽ തെറാപ്പിയും സ്പെഷ്യൽ എഡ്യൂക്കേഷനും, ഓട്ടിസ്റ്റിക് ഫിസിയോതെറാപ്പി, ഫിസിയാട്രിക് മെഡിക്കൽ മാനേജ്മെന്റ്, ക്ലിനിക്കൽ സൈക്കോളജി, ഓട്ടിസ്റ്റിക് ഓർത്തോപീടിക്സ്, ഈ എൻ റ്റി, ഓഡിയോളജി സ്പീച്ച് തെറാപ്പി, ഒഫ്താൽമോളജി, ഹ്യൂമൻ ജനറ്റിക്സ്, ന്യൂട്രിഷൻ തുടങ്ങി ഒട്ടനവധി തെറാപ്പികൾ ഒരു കുടകീഴിൽ ലാഭേച്ചകളില്ലാതെ നൽകിവരുന്ന പദ്ധതി. വൈകല്യങ്ങളെ മറന്നു ജീവിതത്തിൽ തങ്ങളുടേതായ സ്ഥാനം കണ്ടെത്താനും അവരുടെ സ്വപ്‌നങ്ങൾ എത്തിപ്പിടിക്കുവാനും അവർക്കൊപ്പം ഞങ്ങളും യാത്ര തുടരുന്നു.",
      thumb: "assets/img/spectrum/138.jpg",
    },

    {
      src: "assets/img/spectrum/91.jpg",
      caption:
        "വിശ്വപ്രസിദ്ധ മജീഷ്യനും തിരുവനന്തപുരം മാജിക് പ്ലാനെറ്റ് സ്ഥാപകനുമായ ശ്രീ.ഗോപിനാഥ് മുതുകാട് ഇന്ന് (22.04.2022) നിംസ് സ്പെക്ട്രം സന്ദർശിക്കുകയുണ്ടായി . നിംസ് സ്പെക്ട്രത്തിലെ കുട്ടികളോടും രക്ഷിതാക്കളോടും സംവദിക്കുകയും ഒരു പാട് നേരം ചിലവഴിക്കുകയും ചെയ്തു.",
      thumb: "assets/img/spectrum/91.jpg",
    },
    {
      src: "assets/img/spectrum/92.jpg",
      caption:
        "ലോക ഭൗമദിനത്തിന്റെ ഭാഗമായി നിംസ് സ്പെക്ട്രത്തിലെ കുട്ടികൾക്ക് ഫല വൃക്ഷ തൈകൾ ശ്രീ.ഗോപിനാഥ് മുതുകാട് നൽകി. ",
      thumb: "assets/img/spectrum/92.jpg",
    },
    {
      src: "assets/img/spectrum/93.jpg",
      caption:
        "ലോക ഭൗമദിനത്തിന്റെ ഭാഗമായി നിംസ് സ്പെക്ട്രത്തിലെ കുട്ടികൾക്ക് ഫല വൃക്ഷ തൈകൾ ശ്രീ.ഗോപിനാഥ് മുതുകാട് നൽകി. ",
      thumb: "assets/img/spectrum/93.jpg",
    },
    {
      src: "assets/img/spectrum/94.jpg",
      caption:
        "ലോക ഭൗമദിനത്തിന്റെ ഭാഗമായി നിംസ് സ്പെക്ട്രത്തിലെ കുട്ടികൾക്ക് ഫല വൃക്ഷ തൈകൾ ശ്രീ.ഗോപിനാഥ് മുതുകാട് നൽകി. ",
      thumb: "assets/img/spectrum/94.jpg",
    },
    {
      src: "assets/img/spectrum/95.jpg",
      caption:
        "ലോക ഭൗമദിനത്തിന്റെ ഭാഗമായി നിംസ് സ്പെക്ട്രത്തിലെ കുട്ടികൾക്ക് ഫല വൃക്ഷ തൈകൾ ശ്രീ.ഗോപിനാഥ് മുതുകാട് നൽകി. ",
      thumb: "assets/img/spectrum/95.jpg",
    },
    {
      src: "assets/img/spectrum/96.jpg",
      caption:
        "നിംസ് സ്പെക്ട്രം ഡയറക്ടർ ഡോ.എം.കെ.സി നായർ അവർകൾക്ക് ഒപ്പം നിംസ് സ്പെക്ട്രത്തിലെ വിവിധ ഡിപാർട്ട്മെൻറ്റുകൾ അദ്ദേഹം സന്ദർശിക്കുകയും പ്രവർത്തനങ്ങൾ നോക്കി കാണുകയും ചെയ്തു . ഡിപാർട്ട്മെൻറ്റുകളുടെ പ്രവർത്തന രീതികളെ കുറിച്ച് ഡോ. എം.കെ.സി നായർ വിശദീകരിച്ചു . നിംസ് സ്പെക്ട്രത്തോടപ്പം അദ്ദേഹം നിംസ് ആനി സള്ളിവൻ സെൻറ്ററിലെ സെൻസറി വിഭാഗവും നിംസ് ഫിസിയോതെറാപ്പി ഡിപ്പാർട്ട്മെൻറ്റിലെ പീഡിയാട്രിക് ഫിസിയോ തെറാപ്പി വിഭാഗവും സന്ദർശിച്ചു. ",
      thumb: "assets/img/spectrum/96.jpg",
    },
    {
      src: "assets/img/spectrum/97.jpg",
      caption:
        "നിംസ് സ്പെക്ട്രം ഡയറക്ടർ ഡോ.എം.കെ.സി നായർ അവർകൾക്ക് ഒപ്പം നിംസ് സ്പെക്ട്രത്തിലെ വിവിധ ഡിപാർട്ട്മെൻറ്റുകൾ അദ്ദേഹം സന്ദർശിക്കുകയും പ്രവർത്തനങ്ങൾ നോക്കി കാണുകയും ചെയ്തു . ഡിപാർട്ട്മെൻറ്റുകളുടെ പ്രവർത്തന രീതികളെ കുറിച്ച് ഡോ. എം.കെ.സി നായർ വിശദീകരിച്ചു . നിംസ് സ്പെക്ട്രത്തോടപ്പം അദ്ദേഹം നിംസ് ആനി സള്ളിവൻ സെൻറ്ററിലെ സെൻസറി വിഭാഗവും നിംസ് ഫിസിയോതെറാപ്പി ഡിപ്പാർട്ട്മെൻറ്റിലെ പീഡിയാട്രിക് ഫിസിയോ തെറാപ്പി വിഭാഗവും സന്ദർശിച്ചു. ",
      thumb: "assets/img/spectrum/97.jpg",
    },
    {
      src: "assets/img/spectrum/98.jpg",
      caption:
        "നിംസ് സ്പെക്ട്രം ഡയറക്ടർ ഡോ.എം.കെ.സി നായർ അവർകൾക്ക് ഒപ്പം നിംസ് സ്പെക്ട്രത്തിലെ വിവിധ ഡിപാർട്ട്മെൻറ്റുകൾ അദ്ദേഹം സന്ദർശിക്കുകയും പ്രവർത്തനങ്ങൾ നോക്കി കാണുകയും ചെയ്തു . ഡിപാർട്ട്മെൻറ്റുകളുടെ പ്രവർത്തന രീതികളെ കുറിച്ച് ഡോ. എം.കെ.സി നായർ വിശദീകരിച്ചു . നിംസ് സ്പെക്ട്രത്തോടപ്പം അദ്ദേഹം നിംസ് ആനി സള്ളിവൻ സെൻറ്ററിലെ സെൻസറി വിഭാഗവും നിംസ് ഫിസിയോതെറാപ്പി ഡിപ്പാർട്ട്മെൻറ്റിലെ പീഡിയാട്രിക് ഫിസിയോ തെറാപ്പി വിഭാഗവും സന്ദർശിച്ചു. ",
      thumb: "assets/img/spectrum/98.jpg",
    },
    {
      src: "assets/img/spectrum/99.jpg",
      caption:
        "നിംസ് സ്പെക്ട്രം ഡയറക്ടർ ഡോ.എം.കെ.സി നായർ അവർകൾക്ക് ഒപ്പം നിംസ് സ്പെക്ട്രത്തിലെ വിവിധ ഡിപാർട്ട്മെൻറ്റുകൾ അദ്ദേഹം സന്ദർശിക്കുകയും പ്രവർത്തനങ്ങൾ നോക്കി കാണുകയും ചെയ്തു . ഡിപാർട്ട്മെൻറ്റുകളുടെ പ്രവർത്തന രീതികളെ കുറിച്ച് ഡോ. എം.കെ.സി നായർ വിശദീകരിച്ചു . നിംസ് സ്പെക്ട്രത്തോടപ്പം അദ്ദേഹം നിംസ് ആനി സള്ളിവൻ സെൻറ്ററിലെ സെൻസറി വിഭാഗവും നിംസ് ഫിസിയോതെറാപ്പി ഡിപ്പാർട്ട്മെൻറ്റിലെ പീഡിയാട്രിക് ഫിസിയോ തെറാപ്പി വിഭാഗവും സന്ദർശിച്ചു. ",
      thumb: "assets/img/spectrum/99.jpg",
    },
    {
      src: "assets/img/spectrum/100.jpg",
      caption:
        "നിംസ് സ്പെക്ട്രം ഡയറക്ടർ ഡോ.എം.കെ.സി നായർ അവർകൾക്ക് ഒപ്പം നിംസ് സ്പെക്ട്രത്തിലെ വിവിധ ഡിപാർട്ട്മെൻറ്റുകൾ അദ്ദേഹം സന്ദർശിക്കുകയും പ്രവർത്തനങ്ങൾ നോക്കി കാണുകയും ചെയ്തു . ഡിപാർട്ട്മെൻറ്റുകളുടെ പ്രവർത്തന രീതികളെ കുറിച്ച് ഡോ. എം.കെ.സി നായർ വിശദീകരിച്ചു . നിംസ് സ്പെക്ട്രത്തോടപ്പം അദ്ദേഹം നിംസ് ആനി സള്ളിവൻ സെൻറ്ററിലെ സെൻസറി വിഭാഗവും നിംസ് ഫിസിയോതെറാപ്പി ഡിപ്പാർട്ട്മെൻറ്റിലെ പീഡിയാട്രിക് ഫിസിയോ തെറാപ്പി വിഭാഗവും സന്ദർശിച്ചു. ",
      thumb: "assets/img/spectrum/100.jpg",
    },
    {
      src: "assets/img/spectrum/101.jpg",
      caption:
        "നിംസ് സ്പെക്ട്രം ഡയറക്ടർ ഡോ.എം.കെ.സി നായർ അവർകൾക്ക് ഒപ്പം നിംസ് സ്പെക്ട്രത്തിലെ വിവിധ ഡിപാർട്ട്മെൻറ്റുകൾ അദ്ദേഹം സന്ദർശിക്കുകയും പ്രവർത്തനങ്ങൾ നോക്കി കാണുകയും ചെയ്തു . ഡിപാർട്ട്മെൻറ്റുകളുടെ പ്രവർത്തന രീതികളെ കുറിച്ച് ഡോ. എം.കെ.സി നായർ വിശദീകരിച്ചു . നിംസ് സ്പെക്ട്രത്തോടപ്പം അദ്ദേഹം നിംസ് ആനി സള്ളിവൻ സെൻറ്ററിലെ സെൻസറി വിഭാഗവും നിംസ് ഫിസിയോതെറാപ്പി ഡിപ്പാർട്ട്മെൻറ്റിലെ പീഡിയാട്രിക് ഫിസിയോ തെറാപ്പി വിഭാഗവും സന്ദർശിച്ചു. ",
      thumb: "assets/img/spectrum/101.jpg",
    },
    {
      src: "assets/img/spectrum/102.jpg",
      caption:
        "നിംസ് സ്പെക്ട്രം ഡയറക്ടർ ഡോ.എം.കെ.സി നായർ അവർകൾക്ക് ഒപ്പം നിംസ് സ്പെക്ട്രത്തിലെ വിവിധ ഡിപാർട്ട്മെൻറ്റുകൾ അദ്ദേഹം സന്ദർശിക്കുകയും പ്രവർത്തനങ്ങൾ നോക്കി കാണുകയും ചെയ്തു . ഡിപാർട്ട്മെൻറ്റുകളുടെ പ്രവർത്തന രീതികളെ കുറിച്ച് ഡോ. എം.കെ.സി നായർ വിശദീകരിച്ചു . നിംസ് സ്പെക്ട്രത്തോടപ്പം അദ്ദേഹം നിംസ് ആനി സള്ളിവൻ സെൻറ്ററിലെ സെൻസറി വിഭാഗവും നിംസ് ഫിസിയോതെറാപ്പി ഡിപ്പാർട്ട്മെൻറ്റിലെ പീഡിയാട്രിക് ഫിസിയോ തെറാപ്പി വിഭാഗവും സന്ദർശിച്ചു. ",
      thumb: "assets/img/spectrum/102.jpg",
    },
    {
      src: "assets/img/spectrum/103.jpg",
      caption:
        "നിംസ് സ്പെക്ട്രം ഡയറക്ടർ ഡോ.എം.കെ.സി നായർ അവർകൾക്ക് ഒപ്പം നിംസ് സ്പെക്ട്രത്തിലെ വിവിധ ഡിപാർട്ട്മെൻറ്റുകൾ അദ്ദേഹം സന്ദർശിക്കുകയും പ്രവർത്തനങ്ങൾ നോക്കി കാണുകയും ചെയ്തു . ഡിപാർട്ട്മെൻറ്റുകളുടെ പ്രവർത്തന രീതികളെ കുറിച്ച് ഡോ. എം.കെ.സി നായർ വിശദീകരിച്ചു . നിംസ് സ്പെക്ട്രത്തോടപ്പം അദ്ദേഹം നിംസ് ആനി സള്ളിവൻ സെൻറ്ററിലെ സെൻസറി വിഭാഗവും നിംസ് ഫിസിയോതെറാപ്പി ഡിപ്പാർട്ട്മെൻറ്റിലെ പീഡിയാട്രിക് ഫിസിയോ തെറാപ്പി വിഭാഗവും സന്ദർശിച്ചു. ",
      thumb: "assets/img/spectrum/103.jpg",
    },
    {
      src: "assets/img/spectrum/104.jpg",
      caption:
        "നിംസ് സ്പെക്ട്രം ഡയറക്ടർ ഡോ.എം.കെ.സി നായർ അവർകൾക്ക് ഒപ്പം നിംസ് സ്പെക്ട്രത്തിലെ വിവിധ ഡിപാർട്ട്മെൻറ്റുകൾ അദ്ദേഹം സന്ദർശിക്കുകയും പ്രവർത്തനങ്ങൾ നോക്കി കാണുകയും ചെയ്തു . ഡിപാർട്ട്മെൻറ്റുകളുടെ പ്രവർത്തന രീതികളെ കുറിച്ച് ഡോ. എം.കെ.സി നായർ വിശദീകരിച്ചു . നിംസ് സ്പെക്ട്രത്തോടപ്പം അദ്ദേഹം നിംസ് ആനി സള്ളിവൻ സെൻറ്ററിലെ സെൻസറി വിഭാഗവും നിംസ് ഫിസിയോതെറാപ്പി ഡിപ്പാർട്ട്മെൻറ്റിലെ പീഡിയാട്രിക് ഫിസിയോ തെറാപ്പി വിഭാഗവും സന്ദർശിച്ചു. ",
      thumb: "assets/img/spectrum/104.jpg",
    },
    {
      src: "assets/img/spectrum/105.jpg",
      caption:
        "നിംസ് സ്പെക്ട്രം ഡയറക്ടർ ഡോ.എം.കെ.സി നായർ അവർകൾക്ക് ഒപ്പം നിംസ് സ്പെക്ട്രത്തിലെ വിവിധ ഡിപാർട്ട്മെൻറ്റുകൾ അദ്ദേഹം സന്ദർശിക്കുകയും പ്രവർത്തനങ്ങൾ നോക്കി കാണുകയും ചെയ്തു . ഡിപാർട്ട്മെൻറ്റുകളുടെ പ്രവർത്തന രീതികളെ കുറിച്ച് ഡോ. എം.കെ.സി നായർ വിശദീകരിച്ചു . നിംസ് സ്പെക്ട്രത്തോടപ്പം അദ്ദേഹം നിംസ് ആനി സള്ളിവൻ സെൻറ്ററിലെ സെൻസറി വിഭാഗവും നിംസ് ഫിസിയോതെറാപ്പി ഡിപ്പാർട്ട്മെൻറ്റിലെ പീഡിയാട്രിക് ഫിസിയോ തെറാപ്പി വിഭാഗവും സന്ദർശിച്ചു. ",
      thumb: "assets/img/spectrum/105.jpg",
    },
    {
      src: "assets/img/spectrum/106.jpg",
      caption:
        "നിംസ് സ്പെക്ട്രം ഡയറക്ടർ ഡോ.എം.കെ.സി നായർ അവർകൾക്ക് ഒപ്പം നിംസ് സ്പെക്ട്രത്തിലെ വിവിധ ഡിപാർട്ട്മെൻറ്റുകൾ അദ്ദേഹം സന്ദർശിക്കുകയും പ്രവർത്തനങ്ങൾ നോക്കി കാണുകയും ചെയ്തു . ഡിപാർട്ട്മെൻറ്റുകളുടെ പ്രവർത്തന രീതികളെ കുറിച്ച് ഡോ. എം.കെ.സി നായർ വിശദീകരിച്ചു . നിംസ് സ്പെക്ട്രത്തോടപ്പം അദ്ദേഹം നിംസ് ആനി സള്ളിവൻ സെൻറ്ററിലെ സെൻസറി വിഭാഗവും നിംസ് ഫിസിയോതെറാപ്പി ഡിപ്പാർട്ട്മെൻറ്റിലെ പീഡിയാട്രിക് ഫിസിയോ തെറാപ്പി വിഭാഗവും സന്ദർശിച്ചു. ",
      thumb: "assets/img/spectrum/106.jpg",
    },
    {
      src: "assets/img/spectrum/107.jpg",
      caption:
        "നിംസ് സ്പെക്ട്രം ഡയറക്ടർ ഡോ.എം.കെ.സി നായർ അവർകൾക്ക് ഒപ്പം നിംസ് സ്പെക്ട്രത്തിലെ വിവിധ ഡിപാർട്ട്മെൻറ്റുകൾ അദ്ദേഹം സന്ദർശിക്കുകയും പ്രവർത്തനങ്ങൾ നോക്കി കാണുകയും ചെയ്തു . ഡിപാർട്ട്മെൻറ്റുകളുടെ പ്രവർത്തന രീതികളെ കുറിച്ച് ഡോ. എം.കെ.സി നായർ വിശദീകരിച്ചു . നിംസ് സ്പെക്ട്രത്തോടപ്പം അദ്ദേഹം നിംസ് ആനി സള്ളിവൻ സെൻറ്ററിലെ സെൻസറി വിഭാഗവും നിംസ് ഫിസിയോതെറാപ്പി ഡിപ്പാർട്ട്മെൻറ്റിലെ പീഡിയാട്രിക് ഫിസിയോ തെറാപ്പി വിഭാഗവും സന്ദർശിച്ചു. ",
      thumb: "assets/img/spectrum/107.jpg",
    },
    {
      src: "assets/img/spectrum/108.jpg",
      caption:
        "നിംസ് സ്പെക്ട്രം ഡയറക്ടർ ഡോ.എം.കെ.സി നായർ അവർകൾക്ക് ഒപ്പം നിംസ് സ്പെക്ട്രത്തിലെ വിവിധ ഡിപാർട്ട്മെൻറ്റുകൾ അദ്ദേഹം സന്ദർശിക്കുകയും പ്രവർത്തനങ്ങൾ നോക്കി കാണുകയും ചെയ്തു . ഡിപാർട്ട്മെൻറ്റുകളുടെ പ്രവർത്തന രീതികളെ കുറിച്ച് ഡോ. എം.കെ.സി നായർ വിശദീകരിച്ചു . നിംസ് സ്പെക്ട്രത്തോടപ്പം അദ്ദേഹം നിംസ് ആനി സള്ളിവൻ സെൻറ്ററിലെ സെൻസറി വിഭാഗവും നിംസ് ഫിസിയോതെറാപ്പി ഡിപ്പാർട്ട്മെൻറ്റിലെ പീഡിയാട്രിക് ഫിസിയോ തെറാപ്പി വിഭാഗവും സന്ദർശിച്ചു. ",
      thumb: "assets/img/spectrum/108.jpg",
    },
    {
      src: "assets/img/spectrum/109.jpg",
      caption:
        "നിംസ് സ്പെക്ട്രം ഡയറക്ടർ ഡോ.എം.കെ.സി നായർ അവർകൾക്ക് ഒപ്പം നിംസ് സ്പെക്ട്രത്തിലെ വിവിധ ഡിപാർട്ട്മെൻറ്റുകൾ അദ്ദേഹം സന്ദർശിക്കുകയും പ്രവർത്തനങ്ങൾ നോക്കി കാണുകയും ചെയ്തു . ഡിപാർട്ട്മെൻറ്റുകളുടെ പ്രവർത്തന രീതികളെ കുറിച്ച് ഡോ. എം.കെ.സി നായർ വിശദീകരിച്ചു . നിംസ് സ്പെക്ട്രത്തോടപ്പം അദ്ദേഹം നിംസ് ആനി സള്ളിവൻ സെൻറ്ററിലെ സെൻസറി വിഭാഗവും നിംസ് ഫിസിയോതെറാപ്പി ഡിപ്പാർട്ട്മെൻറ്റിലെ പീഡിയാട്രിക് ഫിസിയോ തെറാപ്പി വിഭാഗവും സന്ദർശിച്ചു. ",
      thumb: "assets/img/spectrum/109.jpg",
    },
    {
      src: "assets/img/spectrum/110.jpg",
      caption:
        "നിംസ് സ്പെക്ട്രം ഡയറക്ടർ ഡോ.എം.കെ.സി നായർ അവർകൾക്ക് ഒപ്പം നിംസ് സ്പെക്ട്രത്തിലെ വിവിധ ഡിപാർട്ട്മെൻറ്റുകൾ അദ്ദേഹം സന്ദർശിക്കുകയും പ്രവർത്തനങ്ങൾ നോക്കി കാണുകയും ചെയ്തു . ഡിപാർട്ട്മെൻറ്റുകളുടെ പ്രവർത്തന രീതികളെ കുറിച്ച് ഡോ. എം.കെ.സി നായർ വിശദീകരിച്ചു . നിംസ് സ്പെക്ട്രത്തോടപ്പം അദ്ദേഹം നിംസ് ആനി സള്ളിവൻ സെൻറ്ററിലെ സെൻസറി വിഭാഗവും നിംസ് ഫിസിയോതെറാപ്പി ഡിപ്പാർട്ട്മെൻറ്റിലെ പീഡിയാട്രിക് ഫിസിയോ തെറാപ്പി വിഭാഗവും സന്ദർശിച്ചു. ",
      thumb: "assets/img/spectrum/110.jpg",
    },

    {
      src: "assets/img/spectrum/66.jpg",
      caption:
        "നിംസ് ആനി സള്ളിവൻ സെന്റർ ഫോർ സ്പെഷ്യലി ഏബ്ൾഡ് ചിൽഡ്രൻ മൂന്നാം വയസ്സിലേക്ക്.",
      thumb: "assets/img/spectrum/66.jpg",
    },
    {
      src: "assets/img/spectrum/67.jpg",
      caption:
        "നിംസ് സ്പെക്ട്രം ഡയറക്ടറും തിരുവനന്തപുരം ചൈൽഡ് ഡവലപ്മെന്റ് സെൻറ്റർ സ്ഥാപകനും മുൻ ആരോഗ്യ സർവ്വകലാശാല വൈസ് ചാൻസലറുമായ പ്രൊഫ. ഡോ.എം.കെ.സി നായർ സെന്ററിന്റെ പ്രവർത്തന രീതിയെ കുറിച്ച് സംസാരിച്ചു.",
      thumb: "assets/img/spectrum/67.jpg",
    },
    {
      src: "assets/img/spectrum/68.jpg",
      caption:
        "ആരോഗ്യ സ്റ്റാന്‍ഡിംഗ് കമ്മിറ്റി ചെയർമാൻ ശ്രീ. ജോസ് ഫ്രാങ്ക്ളിൻ വാർഷികാഘോഷത്തിന്റെ ഔദ്യോഗിക ഉദ്ഘാടനം നിർവഹിച്ചു. ഉദ്ഘാടന വേളയിൽ ഭിന്നശേഷിക്കാരെ പരിപാലിക്കുന്ന അദ്ധ്യാപകരുടെയും രക്ഷിതാക്കളെയും കഠിനപ്രയത്നത്തിന്റെ അനന്തരഫലമാണ് പല കുട്ടികളിലും കാണപ്പെടുന്ന സമാനതകളില്ലാത്ത മാറ്റമെന്ന് അദ്ദേഹം അഭിപ്രായപ്പെട്ടു. ചടങ്ങിൽ അദ്ധ്യക്ഷത വഹിച്ച നിംസ് എം.ഡി. ശ്രീ.എം.എസ് ഫൈസൽ ഖാൻ ഹെല്ലൻ കെല്ലറിന്റെ അദ്ധ്യാപികയും മാർഗ്ഗദർശിയുമായ ആനി സള്ളിവന്റെ ജീവിത കഥ വിവരിക്കുകയും അതാണ് ഈ സംരഭത്തിന് ആനി സള്ളിവൻ എന്ന് നാമകരണം ചെയ്യാൻ പ്രചോദനമായത് എന്ന് അദ്ദേഹം കൂട്ടി ചേർത്തു .",
      thumb: "assets/img/spectrum/68.jpg",
    },
    {
      src: "assets/img/spectrum/69.jpg",
      caption:
        "നിംസ് ആനി സള്ളിവൻ സെന്റർ ഫോർ സ്പെഷ്യലി ഏബ്ൾഡ് ചിൽഡ്രൻ മൂന്നാം വയസ്സിലേക്ക്.",
      thumb: "assets/img/spectrum/69.jpg",
    },
    {
      src: "assets/img/spectrum/70.jpg",
      caption:
        "നിംസ് ആനി സള്ളിവൻ സെന്റർ ഫോർ സ്പെഷ്യലി ഏബ്ൾഡ് ചിൽഡ്രൻ മൂന്നാം വയസ്സിലേക്ക്.",
      thumb: "assets/img/spectrum/70.jpg",
    },
    {
      src: "assets/img/spectrum/71.jpg",
      caption:
        "നിംസ് ആനി സള്ളിവൻ സെന്റർ ഫോർ സ്പെഷ്യലി ഏബ്ൾഡ് ചിൽഡ്രൻ മൂന്നാം വയസ്സിലേക്ക്.",
      thumb: "assets/img/spectrum/71.jpg",
    },
    {
      src: "assets/img/spectrum/72.jpg",
      caption:
        "നിംസ് ആനി സള്ളിവൻ സെന്റർ ഫോർ സ്പെഷ്യലി ഏബ്ൾഡ് ചിൽഡ്രൻ മൂന്നാം വയസ്സിലേക്ക്.",
      thumb: "assets/img/spectrum/72.jpg",
    },
    {
      src: "assets/img/spectrum/73.jpg",
      caption:
        "നിംസ് ആനി സള്ളിവൻ സെന്റർ ഫോർ സ്പെഷ്യലി ഏബ്ൾഡ് ചിൽഡ്രൻ മൂന്നാം വയസ്സിലേക്ക്.",
      thumb: "assets/img/spectrum/73.jpg",
    },
    {
      src: "assets/img/spectrum/74.jpg",
      caption:
        "നിംസ് ആനി സള്ളിവൻ സെന്റർ ഫോർ സ്പെഷ്യലി ഏബ്ൾഡ് ചിൽഡ്രൻ മൂന്നാം വയസ്സിലേക്ക്.",
      thumb: "assets/img/spectrum/74.jpg",
    },
    {
      src: "assets/img/spectrum/75.jpg",
      caption:
        "നിംസ് ആനി സള്ളിവൻ സെന്റർ ഫോർ സ്പെഷ്യലി ഏബ്ൾഡ് ചിൽഡ്രൻ മൂന്നാം വാർഷികത്തോട് അനുബന്ധിച്ച് കുട്ടികൾക്ക് മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ",
      thumb: "assets/img/spectrum/75.jpg",
    },
    {
      src: "assets/img/spectrum/76.jpg",
      caption:
        "നിംസ് ആനി സള്ളിവൻ സെന്റർ ഫോർ സ്പെഷ്യലി ഏബ്ൾഡ് ചിൽഡ്രൻ മൂന്നാം വയസ്സിലേക്ക്.",
      thumb: "assets/img/spectrum/76.jpg",
    },
    {
      src: "assets/img/spectrum/77.jpg",
      caption:
        "നിംസ് ആനി സള്ളിവൻ സെന്റർ ഫോർ സ്പെഷ്യലി ഏബ്ൾഡ് ചിൽഡ്രൻ മൂന്നാം വയസ്സിലേക്ക്.",
      thumb: "assets/img/spectrum/77.jpg",
    },
    {
      src: "assets/img/spectrum/78.jpg",
      caption:
        "നിംസ് ആനി സള്ളിവൻ സെന്റർ ഫോർ സ്പെഷ്യലി ഏബ്ൾഡ് ചിൽഡ്രൻ മൂന്നാം വയസ്സിലേക്ക്.",
      thumb: "assets/img/spectrum/78.jpg",
    },
    {
      src: "assets/img/spectrum/79.jpg",
      caption:
        "2019 മെയ് മാസം ആറാം തിയതി നൂറുൽ ഇസ്‌ലാം സർവ്വകലാശാല ചാൻസലറും നൂറുൽ ഇസ്‌ലാം എഡ്യൂക്കേഷണൽ ട്രസ്റ്റ് ചെയർമാനുമായ ഡോ.എ.പി. മജീദ് ഖാൻ ഉദ്ഘാടനം നിർവഹിച്ച നിംസ് ആനി സളളിവൻ സെന്റർ ഫോർ സ്പെഷ്യലി ഏബ്ൾഡ് ചിൽഡ്രൻ നൂറുകണക്കിന് കുട്ടികൾക്ക് നൈപുണ്യ വികസനത്തിന് വഴിയൊരുക്കി ജൈത്രയാത്ര തുടരുന്നു. ഇച്ഛാശക്തിക്ക് അതിജീവിക്കാനാകാത്ത പരിമിതികളില്ലെന്നു",
      thumb: "assets/img/spectrum/79.jpg",
    },
    {
      src: "assets/img/spectrum/80.jpg",
      caption:
        "2019 മെയ് മാസം ആറാം തിയതി നൂറുൽ ഇസ്‌ലാം സർവ്വകലാശാല ചാൻസലറും നൂറുൽ ഇസ്‌ലാം എഡ്യൂക്കേഷണൽ ട്രസ്റ്റ് ചെയർമാനുമായ ഡോ.എ.പി. മജീദ് ഖാൻ ഉദ്ഘാടനം നിർവഹിച്ച നിംസ് ആനി സളളിവൻ സെന്റർ ഫോർ സ്പെഷ്യലി ഏബ്ൾഡ് ചിൽഡ്രൻ നൂറുകണക്കിന് കുട്ടികൾക്ക് നൈപുണ്യ വികസനത്തിന് വഴിയൊരുക്കി ജൈത്രയാത്ര തുടരുന്നു. ഇച്ഛാശക്തിക്ക് അതിജീവിക്കാനാകാത്ത പരിമിതികളില്ലെന്നു",
      thumb: "assets/img/spectrum/80.jpg",
    },
    {
      src: "assets/img/spectrum/81.jpg",
      caption:
        "2019 മെയ് മാസം ആറാം തിയതി നൂറുൽ ഇസ്‌ലാം സർവ്വകലാശാല ചാൻസലറും നൂറുൽ ഇസ്‌ലാം എഡ്യൂക്കേഷണൽ ട്രസ്റ്റ് ചെയർമാനുമായ ഡോ.എ.പി. മജീദ് ഖാൻ ഉദ്ഘാടനം നിർവഹിച്ച നിംസ് ആനി സളളിവൻ സെന്റർ ഫോർ സ്പെഷ്യലി ഏബ്ൾഡ് ചിൽഡ്രൻ നൂറുകണക്കിന് കുട്ടികൾക്ക് നൈപുണ്യ വികസനത്തിന് വഴിയൊരുക്കി ജൈത്രയാത്ര തുടരുന്നു. ഇച്ഛാശക്തിക്ക് അതിജീവിക്കാനാകാത്ത പരിമിതികളില്ലെന്നു",
      thumb: "assets/img/spectrum/81.jpg",
    },
    {
      src: "assets/img/spectrum/82.jpg",
      caption:
        "2019 മെയ് മാസം ആറാം തിയതി നൂറുൽ ഇസ്‌ലാം സർവ്വകലാശാല ചാൻസലറും നൂറുൽ ഇസ്‌ലാം എഡ്യൂക്കേഷണൽ ട്രസ്റ്റ് ചെയർമാനുമായ ഡോ.എ.പി. മജീദ് ഖാൻ ഉദ്ഘാടനം നിർവഹിച്ച നിംസ് ആനി സളളിവൻ സെന്റർ ഫോർ സ്പെഷ്യലി ഏബ്ൾഡ് ചിൽഡ്രൻ നൂറുകണക്കിന് കുട്ടികൾക്ക് നൈപുണ്യ വികസനത്തിന് വഴിയൊരുക്കി ജൈത്രയാത്ര തുടരുന്നു. ഇച്ഛാശക്തിക്ക് അതിജീവിക്കാനാകാത്ത പരിമിതികളില്ലെന്നു",
      thumb: "assets/img/spectrum/82.jpg",
    },
    {
      src: "assets/img/spectrum/83.jpg",
      caption:
        "2019 മെയ് മാസം ആറാം തിയതി നൂറുൽ ഇസ്‌ലാം സർവ്വകലാശാല ചാൻസലറും നൂറുൽ ഇസ്‌ലാം എഡ്യൂക്കേഷണൽ ട്രസ്റ്റ് ചെയർമാനുമായ ഡോ.എ.പി. മജീദ് ഖാൻ ഉദ്ഘാടനം നിർവഹിച്ച നിംസ് ആനി സളളിവൻ സെന്റർ ഫോർ സ്പെഷ്യലി ഏബ്ൾഡ് ചിൽഡ്രൻ നൂറുകണക്കിന് കുട്ടികൾക്ക് നൈപുണ്യ വികസനത്തിന് വഴിയൊരുക്കി ജൈത്രയാത്ര തുടരുന്നു. ഇച്ഛാശക്തിക്ക് അതിജീവിക്കാനാകാത്ത പരിമിതികളില്ലെന്നു",
      thumb: "assets/img/spectrum/83.jpg",
    },
    {
      src: "assets/img/spectrum/84.jpg",
      caption:
        "2019 മെയ് മാസം ആറാം തിയതി നൂറുൽ ഇസ്‌ലാം സർവ്വകലാശാല ചാൻസലറും നൂറുൽ ഇസ്‌ലാം എഡ്യൂക്കേഷണൽ ട്രസ്റ്റ് ചെയർമാനുമായ ഡോ.എ.പി. മജീദ് ഖാൻ ഉദ്ഘാടനം നിർവഹിച്ച നിംസ് ആനി സളളിവൻ സെന്റർ ഫോർ സ്പെഷ്യലി ഏബ്ൾഡ് ചിൽഡ്രൻ നൂറുകണക്കിന് കുട്ടികൾക്ക് നൈപുണ്യ വികസനത്തിന് വഴിയൊരുക്കി ജൈത്രയാത്ര തുടരുന്നു. ഇച്ഛാശക്തിക്ക് അതിജീവിക്കാനാകാത്ത പരിമിതികളില്ലെന്നു",
      thumb: "assets/img/spectrum/84.jpg",
    },
    {
      src: "assets/img/spectrum/85.jpg",
      caption:
        "2019 മെയ് മാസം ആറാം തിയതി നൂറുൽ ഇസ്‌ലാം സർവ്വകലാശാല ചാൻസലറും നൂറുൽ ഇസ്‌ലാം എഡ്യൂക്കേഷണൽ ട്രസ്റ്റ് ചെയർമാനുമായ ഡോ.എ.പി. മജീദ് ഖാൻ ഉദ്ഘാടനം നിർവഹിച്ച നിംസ് ആനി സളളിവൻ സെന്റർ ഫോർ സ്പെഷ്യലി ഏബ്ൾഡ് ചിൽഡ്രൻ നൂറുകണക്കിന് കുട്ടികൾക്ക് നൈപുണ്യ വികസനത്തിന് വഴിയൊരുക്കി ജൈത്രയാത്ര തുടരുന്നു. ഇച്ഛാശക്തിക്ക് അതിജീവിക്കാനാകാത്ത പരിമിതികളില്ലെന്നു",
      thumb: "assets/img/spectrum/85.jpg",
    },
    {
      src: "assets/img/spectrum/86.jpg",
      caption:
        "ഹെല്ലൻ കെല്ലറിന്റെ ജീവിതത്തിലൂടെ തെളിയിച്ച് അറിവിന്റെ ഉന്നതിയിലെത്തിച്ച അവരുടെ അദ്ധ്യാപിക , ആനി സള്ളിവൻ. ഒരു നല്ല അധ്യാപികയ്ക്ക് എങ്ങനെയെല്ലാം ഒരു വ്യക്തിയില്‍ മാറ്റങ്ങള്‍ വരുത്താന്‍ കഴിയുമെന്നതിന്റെ ഉത്തമ ഉദാഹരണമാണ് ആനി സള്ളിവൻ . നിംസ് കോളേജ് ഓഫ് നഴ്സിങ്ങിലെ വിദ്യാർത്ഥികൾ ഹെല്ലൻ കെല്ലർ ആനി സള്ളിവൻ ജീവചരിത്രത്തിന്റെ ഹ്രസ്വ ദൃശ്യാവിഷ്കരണം നടത്തി.",
      thumb: "assets/img/spectrum/86.jpg",
    },
    {
      src: "assets/img/spectrum/87.jpg",
      caption:
        "നിംസ് കോളേജ് ഓഫ് നഴ്സിങ്ങിലെ വിദ്യാർത്ഥികൾ ഹെല്ലൻ കെല്ലർ ആനി സള്ളിവൻ ജീവചരിത്രത്തിന്റെ ഹ്രസ്വ ദൃശ്യാവിഷ്കരണം നടത്തി.",
      thumb: "assets/img/spectrum/87.jpg",
    },
    {
      src: "assets/img/spectrum/88.jpg",
      caption:
        "നിംസ് കോളേജ് ഓഫ് നഴ്സിങ്ങിലെ വിദ്യാർത്ഥികൾ ഹെല്ലൻ കെല്ലർ ആനി സള്ളിവൻ ജീവചരിത്രത്തിന്റെ ഹ്രസ്വ ദൃശ്യാവിഷ്കരണം നടത്തി.",
      thumb: "assets/img/spectrum/88.jpg",
    },
    {
      src: "assets/img/spectrum/89.jpg",
      caption:
        "നിംസ് കോളേജ് ഓഫ് നഴ്സിങ്ങിലെ വിദ്യാർത്ഥികൾ ഹെല്ലൻ കെല്ലർ ആനി സള്ളിവൻ ജീവചരിത്രത്തിന്റെ ഹ്രസ്വ ദൃശ്യാവിഷ്കരണം നടത്തി.",
      thumb: "assets/img/spectrum/89.jpg",
    },
    {
      src: "assets/img/spectrum/90.jpg",
      caption:
        "നിംസ് കോളേജ് ഓഫ് നഴ്സിങ്ങിലെ വിദ്യാർത്ഥികൾ ഹെല്ലൻ കെല്ലർ ആനി സള്ളിവൻ ജീവചരിത്രത്തിന്റെ ഹ്രസ്വ ദൃശ്യാവിഷ്കരണം നടത്തി.",
      thumb: "assets/img/spectrum/90.jpg",
    },

    {
      src: "assets/img/spectrum/51.jpg",
      caption:
        'അതിയന്നൂർ ബ്ലോക്കിലെ " നെയ്യാറ്റിൻകര പെൻഷൻ പ്ലാൻ " ഗുണഭോക്താക്കൾക്കുള്ള രണ്ടാംഘട്ട മെഡിക്കൽ ചെക്കപ്പ് ശനിയാഴ്ച (12.03.2022) നിംസ് മെഡിസിറ്റിയിൽ നടന്നു. രണ്ടാംഘട്ട മെഡിക്കൽ ചെക്കപ്പിന് എത്തിയ " നെയ്യാറ്റിൻകര പെൻഷൻ പ്ലാൻ " ഗുണഭോക്താക്കളെ നിംസ് മെഡിസിറ്റി എം.ഡി ശ്രീ.എം. എസ് ഫൈസൽ ഖാൻ നേരിൽ കാണുകയും സംവദിക്കുകയും ഫല വൃക്ഷത്തൈകളും മധുരവും നൽകി.',
      thumb: "assets/img/spectrum/51.jpg",
    },
    {
      src: "assets/img/spectrum/52.jpg",
      caption:
        "ഗുണഭോക്താക്കളെ നിംസ് മെഡിസിറ്റി എം.ഡി ശ്രീ.എം. എസ് ഫൈസൽ ഖാൻ നേരിൽ കാണുകയും സംവദിക്കുകയും ഫല വൃക്ഷത്തൈകളും മധുരവും നൽകി.",
      thumb: "assets/img/spectrum/52.jpg",
    },
    {
      src: "assets/img/spectrum/53.jpg",
      caption:
        "ഗുണഭോക്താക്കളെ നിംസ് മെഡിസിറ്റി എം.ഡി ശ്രീ.എം. എസ് ഫൈസൽ ഖാൻ നേരിൽ കാണുകയും സംവദിക്കുകയും ഫല വൃക്ഷത്തൈകളും മധുരവും നൽകി.",
      thumb: "assets/img/spectrum/53.jpg",
    },
    {
      src: "assets/img/spectrum/54.jpg",
      caption:
        "ഗുണഭോക്താക്കളെ നിംസ് മെഡിസിറ്റി എം.ഡി ശ്രീ.എം. എസ് ഫൈസൽ ഖാൻ നേരിൽ കാണുകയും സംവദിക്കുകയും ഫല വൃക്ഷത്തൈകളും മധുരവും നൽകി.",
      thumb: "assets/img/spectrum/54.jpg",
    },
    {
      src: "assets/img/spectrum/55.jpg",
      caption:
        "ഗുണഭോക്താക്കളെ നിംസ് മെഡിസിറ്റി എം.ഡി ശ്രീ.എം. എസ് ഫൈസൽ ഖാൻ നേരിൽ കാണുകയും സംവദിക്കുകയും ഫല വൃക്ഷത്തൈകളും മധുരവും നൽകി.",
      thumb: "assets/img/spectrum/55.jpg",
    },
    {
      src: "assets/img/spectrum/56.jpg",
      caption:
        "ഗുണഭോക്താക്കളെ നിംസ് മെഡിസിറ്റി എം.ഡി ശ്രീ.എം. എസ് ഫൈസൽ ഖാൻ നേരിൽ കാണുകയും സംവദിക്കുകയും ഫല വൃക്ഷത്തൈകളും മധുരവും നൽകി.",
      thumb: "assets/img/spectrum/56.jpg",
    },
    {
      src: "assets/img/spectrum/57.jpg",
      caption:
        "മെഡിക്കൽ ക്യാമ്പിന് നേതൃത്വം നൽകിയ നിംസ് സ്പെക്ട്രം ഡയറക്ടറും മുൻ ആരോഗ്യ സർവ്വകലാശാല വൈസ് ചാൻസലറുമായ ഡോ.എം.കെ.സി നായർ , തെറാപ്പികളും പരിശീലനങ്ങും കുട്ടികളുടെ വളർച്ചയിലുണ്ടാക്കുന്ന മാറ്റത്തെ കുറിച്ച് സംസാരിച്ചു.എ.പി.ജെ അബ്ദുൽ കലാം സ്റ്റഡി സെന്റർ ഡയറക്ടർ പൂവച്ചൽ സുധീർ ചടങ്ങിൽ ആശംസകൾ അറിയിച്ചു. നിംസ് മെഡിസിറ്റി അഡ്മിനിസ്ട്രേറ്റീവ് കോഡിനേറ്റർ ശ്രീ.ശിവകുമാർ എസ്. രാജ് , ജനറൽ മാനേജർ സജു കെ.എ, ക്വാളിറ്റി സിസ്റ്റം ഓഫിസർ ശ്രീ. സോനു എസ്.എസ് തുടങ്ങിയവർ സന്നിഹിതരായിരുന്നു.",
      thumb: "assets/img/spectrum/57.jpg",
    },
    {
      src: "assets/img/spectrum/58.jpg",
      caption:
        " ഇതര സാമ്പത്തിക സഹായങ്ങൾ സ്വീകരിക്കാതെ സ്വയംപര്യാപ്തമായി നിന്ന് കൊണ്ട് ഭിന്നശേഷി കുഞ്ഞുക്കൾക്ക് ആവശ്യമായ തെറാപ്പികൾ നൽകിയ ശേഷം ബില്ല് കൗണ്ടറിൽ അവർക്ക് നൽകുന്ന ബില്ലിൽ ഇഷ്ടമുള്ള പണം നൽകിയാൽ മതി എന്ന ഉപാധിയിൽ പ്രവർത്തിക്കുന്ന ആതുരാലയം ഇന്ത്യയിൽ നിംസ് സ്പെക്ട്രം മാത്രമേ കാണൂ എന്ന് അദ്ദേഹം അഭിപ്രായപെട്ടു.",
      thumb: "assets/img/spectrum/58.jpg",
    },
    {
      src: "assets/img/spectrum/59.jpg",
      caption:
        " ഇതര സാമ്പത്തിക സഹായങ്ങൾ സ്വീകരിക്കാതെ സ്വയംപര്യാപ്തമായി നിന്ന് കൊണ്ട് ഭിന്നശേഷി കുഞ്ഞുക്കൾക്ക് ആവശ്യമായ തെറാപ്പികൾ നൽകിയ ശേഷം ബില്ല് കൗണ്ടറിൽ അവർക്ക് നൽകുന്ന ബില്ലിൽ ഇഷ്ടമുള്ള പണം നൽകിയാൽ മതി എന്ന ഉപാധിയിൽ പ്രവർത്തിക്കുന്ന ആതുരാലയം ഇന്ത്യയിൽ നിംസ് സ്പെക്ട്രം മാത്രമേ കാണൂ എന്ന് അദ്ദേഹം അഭിപ്രായപെട്ടു.",
      thumb: "assets/img/spectrum/59.jpg",
    },
    {
      src: "assets/img/spectrum/60.jpg",
      caption:
        " ഇതര സാമ്പത്തിക സഹായങ്ങൾ സ്വീകരിക്കാതെ സ്വയംപര്യാപ്തമായി നിന്ന് കൊണ്ട് ഭിന്നശേഷി കുഞ്ഞുക്കൾക്ക് ആവശ്യമായ തെറാപ്പികൾ നൽകിയ ശേഷം ബില്ല് കൗണ്ടറിൽ അവർക്ക് നൽകുന്ന ബില്ലിൽ ഇഷ്ടമുള്ള പണം നൽകിയാൽ മതി എന്ന ഉപാധിയിൽ പ്രവർത്തിക്കുന്ന ആതുരാലയം ഇന്ത്യയിൽ നിംസ് സ്പെക്ട്രം മാത്രമേ കാണൂ എന്ന് അദ്ദേഹം അഭിപ്രായപെട്ടു.",
      thumb: "assets/img/spectrum/60.jpg",
    },
    {
      src: "assets/img/spectrum/61.jpg",
      caption:
        "വ്യക്തികളുടെയോ കേന്ദ്ര/സംസ്ഥാന സർക്കാർ ഗ്രാന്റോ , എയിഡോ മറ്റ് സാമ്പത്തിക സഹായങ്ങളോ സ്വീകരിക്കാതെ മാനേജ്മെന്റിന്റെയും സ്റ്റാഫുകളെയും സഹകരണത്തോട് കൂടി സമൂഹത്തിലെ ഭിന്നശേഷിക്കാരായ കുട്ടികളുടെ ഉന്നമനത്തിനായി ഒരു സംരംഭം നടത്താൻ കഴിയും എന്ന് നിംസ് സ്പെക്ട്രത്തിലൂടെ തെളിയിക്കാൻ കഴിഞ്ഞുവെന്നും, ആരോഗ്യ സംരക്ഷണത്തിൽ ഒരു കൈത്താങ്ങായി നിംസ് മെഡിസിറ്റി",
      thumb: "assets/img/spectrum/61.jpg",
    },
    {
      src: "assets/img/spectrum/62.jpg",
      caption:
        "വ്യക്തികളുടെയോ കേന്ദ്ര/സംസ്ഥാന സർക്കാർ ഗ്രാന്റോ , എയിഡോ മറ്റ് സാമ്പത്തിക സഹായങ്ങളോ സ്വീകരിക്കാതെ മാനേജ്മെന്റിന്റെയും സ്റ്റാഫുകളെയും സഹകരണത്തോട് കൂടി സമൂഹത്തിലെ ഭിന്നശേഷിക്കാരായ കുട്ടികളുടെ ഉന്നമനത്തിനായി ഒരു സംരംഭം നടത്താൻ കഴിയും എന്ന് നിംസ് സ്പെക്ട്രത്തിലൂടെ തെളിയിക്കാൻ കഴിഞ്ഞുവെന്നും, ആരോഗ്യ സംരക്ഷണത്തിൽ ഒരു കൈത്താങ്ങായി നിംസ് മെഡിസിറ്റി",
      thumb: "assets/img/spectrum/62.jpg",
    },
    {
      src: "assets/img/spectrum/63.jpg",
      caption:
        "വ്യക്തികളുടെയോ കേന്ദ്ര/സംസ്ഥാന സർക്കാർ ഗ്രാന്റോ , എയിഡോ മറ്റ് സാമ്പത്തിക സഹായങ്ങളോ സ്വീകരിക്കാതെ മാനേജ്മെന്റിന്റെയും സ്റ്റാഫുകളെയും സഹകരണത്തോട് കൂടി സമൂഹത്തിലെ ഭിന്നശേഷിക്കാരായ കുട്ടികളുടെ ഉന്നമനത്തിനായി ഒരു സംരംഭം നടത്താൻ കഴിയും എന്ന് നിംസ് സ്പെക്ട്രത്തിലൂടെ തെളിയിക്കാൻ കഴിഞ്ഞുവെന്നും, ആരോഗ്യ സംരക്ഷണത്തിൽ ഒരു കൈത്താങ്ങായി നിംസ് മെഡിസിറ്റി",
      thumb: "assets/img/spectrum/63.jpg",
    },
    {
      src: "assets/img/spectrum/64.jpg",
      caption:
        "ഗുണഭോക്താക്കളെ നിംസ് മെഡിസിറ്റി എം.ഡി ശ്രീ.എം. എസ് ഫൈസൽ ഖാൻ നേരിൽ കാണുകയും സംവദിക്കുകയും ഫല വൃക്ഷത്തൈകളും മധുരവും നൽകി",
      thumb: "assets/img/spectrum/64.jpg",
    },
    {
      src: "assets/img/spectrum/65.jpg",
      caption:
        "ഇതര സാമ്പത്തിക സഹായങ്ങൾ സ്വീകരിക്കാതെ സ്വയംപര്യാപ്തമായി നിന്ന് കൊണ്ട് ഭിന്നശേഷി കുഞ്ഞുക്കൾക്ക് ആവശ്യമായ തെറാപ്പികൾ നൽകിയ ശേഷം ബില്ല് കൗണ്ടറിൽ അവർക്ക് നൽകുന്ന ബില്ലിൽ ഇഷ്ടമുള്ള പണം നൽകിയാൽ മതി എന്ന ഉപാധിയിൽ പ്രവർത്തിക്കുന്ന ആതുരാലയം ഇന്ത്യയിൽ നിംസ് സ്പെക്ട്രം മാത്രമേ കാണൂ എന്ന് അദ്ദേഹം അഭിപ്രായപെട്ടു.",
      thumb: "assets/img/spectrum/65.jpg",
    },
    {
      src: "assets/img/spectrum/46.jpg",
      caption:
        "ഭിന്നശേഷി കുട്ടികളുടെ കുടുംബങ്ങൾക്കു നിംസ് മെഡിസിറ്റിയുടെ കോവിഡ് റിലീഫ് പെൻഷൻ പഞ്ചായത്തു പ്രതിനിധികൾക്കു കൈമാറുന്നു",
      thumb: "assets/img/spectrum/46.jpg",
    },
    {
      src: "assets/img/spectrum/47.jpg",
      caption:
        "ഭിന്നശേഷി കുട്ടികളുടെ കുടുംബങ്ങൾക്കു നിംസ് മെഡിസിറ്റിയുടെ കോവിഡ് റിലീഫ് പെൻഷൻ പഞ്ചായത്തു പ്രതിനിധികൾക്കു കൈമാറുന്നു",
      thumb: "assets/img/spectrum/47.jpg",
    },
    {
      src: "assets/img/spectrum/48.jpg",
      caption:
        "ഭിന്നശേഷി കുട്ടികളുടെ കുടുംബങ്ങൾക്കു നിംസ് മെഡിസിറ്റിയുടെ കോവിഡ് റിലീഫ് പെൻഷൻ പഞ്ചായത്തു പ്രതിനിധികൾക്കു കൈമാറുന്നു",
      thumb: "assets/img/spectrum/48.jpg",
    },
    {
      src: "assets/img/spectrum/49.jpg",
      caption:
        "ഭിന്നശേഷി കുട്ടികളുടെ കുടുംബങ്ങൾക്കു നിംസ് മെഡിസിറ്റിയുടെ കോവിഡ് റിലീഫ് പെൻഷൻ പഞ്ചായത്തു പ്രതിനിധികൾക്കു കൈമാറുന്നു",
      thumb: "assets/img/spectrum/49.jpg",
    },
    {
      src: "assets/img/spectrum/50.jpg",
      caption:
        "ഭിന്നശേഷി കുട്ടികളുടെ കുടുംബങ്ങൾക്കു നിംസ് മെഡിസിറ്റിയുടെ കോവിഡ് റിലീഫ് പെൻഷൻ പഞ്ചായത്തു പ്രതിനിധികൾക്കു കൈമാറുന്നു",
      thumb: "assets/img/spectrum/50.jpg",
    },
    {
      src: "assets/img/spectrum/32.jpg",
      caption:
        "പരിസ്ഥിതി ദിനത്തിൽ പരിസ്ഥിതി സംരക്ഷണത്തിന് പ്രാധാന്യം നല്കുന്ന പോലെ തന്നെ നമ്മുടെ സഹജീവികളെയും സംരക്ഷിക്കാനും സ്നേഹിക്കാനും നമ്മൾ ബാധ്യസ്ഥരാണ്. നിംസും PADS ഉം എക്കാലവും സംയുക്തമായി ചെയ്തു പോകുന്ന കാരുണ്യ പ്രവർത്തനങ്ങൾക്കു യാതൊരു മങ്ങലും കൂടാതെ ഇനിയും മുന്നോട്ടു തന്നെ ഉണ്ടാകും.. ഇന്ന് ഈ ലോക പരിസ്ഥിതി ദിനത്തോടനുബന്ധിച്ചു 100 ഓളം വരുന്ന ഭിന്നശേഷി കുട്ടികളുടെ കുടുംബങ്ങൾക്കു ഭക്ഷ്യ കിറ്റ് നൽകാൻ സാധിച്ചു",
      thumb: "assets/img/spectrum/32.jpg",
    },
    {
      src: "assets/img/spectrum/33.jpg",
      caption:
        "പരിസ്ഥിതി ദിനത്തിൽ പരിസ്ഥിതി സംരക്ഷണത്തിന് പ്രാധാന്യം നല്കുന്ന പോലെ തന്നെ നമ്മുടെ സഹജീവികളെയും സംരക്ഷിക്കാനും സ്നേഹിക്കാനും നമ്മൾ ബാധ്യസ്ഥരാണ്. നിംസും PADS ഉം എക്കാലവും സംയുക്തമായി ചെയ്തു പോകുന്ന കാരുണ്യ പ്രവർത്തനങ്ങൾക്കു യാതൊരു മങ്ങലും കൂടാതെ ഇനിയും മുന്നോട്ടു തന്നെ ഉണ്ടാകും.. ഇന്ന് ഈ ലോക പരിസ്ഥിതി ദിനത്തോടനുബന്ധിച്ചു 100 ഓളം വരുന്ന ഭിന്നശേഷി കുട്ടികളുടെ കുടുംബങ്ങൾക്കു ഭക്ഷ്യ കിറ്റ് നൽകാൻ സാധിച്ചു",
      thumb: "assets/img/spectrum/33.jpg",
    },
    {
      src: "assets/img/spectrum/34.jpg",
      caption:
        "പരിസ്ഥിതി ദിനത്തിൽ പരിസ്ഥിതി സംരക്ഷണത്തിന് പ്രാധാന്യം നല്കുന്ന പോലെ തന്നെ നമ്മുടെ സഹജീവികളെയും സംരക്ഷിക്കാനും സ്നേഹിക്കാനും നമ്മൾ ബാധ്യസ്ഥരാണ്. നിംസും PADS ഉം എക്കാലവും സംയുക്തമായി ചെയ്തു പോകുന്ന കാരുണ്യ പ്രവർത്തനങ്ങൾക്കു യാതൊരു മങ്ങലും കൂടാതെ ഇനിയും മുന്നോട്ടു തന്നെ ഉണ്ടാകും.. ഇന്ന് ഈ ലോക പരിസ്ഥിതി ദിനത്തോടനുബന്ധിച്ചു 100 ഓളം വരുന്ന ഭിന്നശേഷി കുട്ടികളുടെ കുടുംബങ്ങൾക്കു ഭക്ഷ്യ കിറ്റ് നൽകാൻ സാധിച്ചു",
      thumb: "assets/img/spectrum/34.jpg",
    },
    {
      src: "assets/img/spectrum/35.jpg",
      caption:
        "പരിസ്ഥിതി ദിനത്തിൽ പരിസ്ഥിതി സംരക്ഷണത്തിന് പ്രാധാന്യം നല്കുന്ന പോലെ തന്നെ നമ്മുടെ സഹജീവികളെയും സംരക്ഷിക്കാനും സ്നേഹിക്കാനും നമ്മൾ ബാധ്യസ്ഥരാണ്. നിംസും PADS ഉം എക്കാലവും സംയുക്തമായി ചെയ്തു പോകുന്ന കാരുണ്യ പ്രവർത്തനങ്ങൾക്കു യാതൊരു മങ്ങലും കൂടാതെ ഇനിയും മുന്നോട്ടു തന്നെ ഉണ്ടാകും.. ഇന്ന് ഈ ലോക പരിസ്ഥിതി ദിനത്തോടനുബന്ധിച്ചു 100 ഓളം വരുന്ന ഭിന്നശേഷി കുട്ടികളുടെ കുടുംബങ്ങൾക്കു ഭക്ഷ്യ കിറ്റ് നൽകാൻ സാധിച്ചു",
      thumb: "assets/img/spectrum/35.jpg",
    },
    {
      src: "assets/img/spectrum/36.jpg",
      caption:
        "പരിസ്ഥിതി ദിനത്തിൽ പരിസ്ഥിതി സംരക്ഷണത്തിന് പ്രാധാന്യം നല്കുന്ന പോലെ തന്നെ നമ്മുടെ സഹജീവികളെയും സംരക്ഷിക്കാനും സ്നേഹിക്കാനും നമ്മൾ ബാധ്യസ്ഥരാണ്. നിംസും PADS ഉം എക്കാലവും സംയുക്തമായി ചെയ്തു പോകുന്ന കാരുണ്യ പ്രവർത്തനങ്ങൾക്കു യാതൊരു മങ്ങലും കൂടാതെ ഇനിയും മുന്നോട്ടു തന്നെ ഉണ്ടാകും.. ഇന്ന് ഈ ലോക പരിസ്ഥിതി ദിനത്തോടനുബന്ധിച്ചു 100 ഓളം വരുന്ന ഭിന്നശേഷി കുട്ടികളുടെ കുടുംബങ്ങൾക്കു ഭക്ഷ്യ കിറ്റ് നൽകാൻ സാധിച്ചു",
      thumb: "assets/img/spectrum/36.jpg",
    },
    {
      src: "assets/img/spectrum/37.jpg",
      caption:
        "പരിസ്ഥിതി ദിനത്തിൽ പരിസ്ഥിതി സംരക്ഷണത്തിന് പ്രാധാന്യം നല്കുന്ന പോലെ തന്നെ നമ്മുടെ സഹജീവികളെയും സംരക്ഷിക്കാനും സ്നേഹിക്കാനും നമ്മൾ ബാധ്യസ്ഥരാണ്. നിംസും PADS ഉം എക്കാലവും സംയുക്തമായി ചെയ്തു പോകുന്ന കാരുണ്യ പ്രവർത്തനങ്ങൾക്കു യാതൊരു മങ്ങലും കൂടാതെ ഇനിയും മുന്നോട്ടു തന്നെ ഉണ്ടാകും.. ഇന്ന് ഈ ലോക പരിസ്ഥിതി ദിനത്തോടനുബന്ധിച്ചു 100 ഓളം വരുന്ന ഭിന്നശേഷി കുട്ടികളുടെ കുടുംബങ്ങൾക്കു ഭക്ഷ്യ കിറ്റ് നൽകാൻ സാധിച്ചു",
      thumb: "assets/img/spectrum/37.jpg",
    },
    {
      src: "assets/img/spectrum/38.jpg",
      caption:
        "പരിസ്ഥിതി ദിനത്തിൽ പരിസ്ഥിതി സംരക്ഷണത്തിന് പ്രാധാന്യം നല്കുന്ന പോലെ തന്നെ നമ്മുടെ സഹജീവികളെയും സംരക്ഷിക്കാനും സ്നേഹിക്കാനും നമ്മൾ ബാധ്യസ്ഥരാണ്. നിംസും PADS ഉം എക്കാലവും സംയുക്തമായി ചെയ്തു പോകുന്ന കാരുണ്യ പ്രവർത്തനങ്ങൾക്കു യാതൊരു മങ്ങലും കൂടാതെ ഇനിയും മുന്നോട്ടു തന്നെ ഉണ്ടാകും.. ഇന്ന് ഈ ലോക പരിസ്ഥിതി ദിനത്തോടനുബന്ധിച്ചു 100 ഓളം വരുന്ന ഭിന്നശേഷി കുട്ടികളുടെ കുടുംബങ്ങൾക്കു ഭക്ഷ്യ കിറ്റ് നൽകാൻ സാധിച്ചു",
      thumb: "assets/img/spectrum/38.jpg",
    },
    {
      src: "assets/img/spectrum/39.jpg",
      caption:
        "പരിസ്ഥിതി ദിനത്തിൽ പരിസ്ഥിതി സംരക്ഷണത്തിന് പ്രാധാന്യം നല്കുന്ന പോലെ തന്നെ നമ്മുടെ സഹജീവികളെയും സംരക്ഷിക്കാനും സ്നേഹിക്കാനും നമ്മൾ ബാധ്യസ്ഥരാണ്. നിംസും PADS ഉം എക്കാലവും സംയുക്തമായി ചെയ്തു പോകുന്ന കാരുണ്യ പ്രവർത്തനങ്ങൾക്കു യാതൊരു മങ്ങലും കൂടാതെ ഇനിയും മുന്നോട്ടു തന്നെ ഉണ്ടാകും.. ഇന്ന് ഈ ലോക പരിസ്ഥിതി ദിനത്തോടനുബന്ധിച്ചു 100 ഓളം വരുന്ന ഭിന്നശേഷി കുട്ടികളുടെ കുടുംബങ്ങൾക്കു ഭക്ഷ്യ കിറ്റ് നൽകാൻ സാധിച്ചു",
      thumb: "assets/img/spectrum/39.jpg",
    },
    {
      src: "assets/img/spectrum/40.jpg",
      caption:
        "പരിസ്ഥിതി ദിനത്തിൽ പരിസ്ഥിതി സംരക്ഷണത്തിന് പ്രാധാന്യം നല്കുന്ന പോലെ തന്നെ നമ്മുടെ സഹജീവികളെയും സംരക്ഷിക്കാനും സ്നേഹിക്കാനും നമ്മൾ ബാധ്യസ്ഥരാണ്. നിംസും PADS ഉം എക്കാലവും സംയുക്തമായി ചെയ്തു പോകുന്ന കാരുണ്യ പ്രവർത്തനങ്ങൾക്കു യാതൊരു മങ്ങലും കൂടാതെ ഇനിയും മുന്നോട്ടു തന്നെ ഉണ്ടാകും.. ഇന്ന് ഈ ലോക പരിസ്ഥിതി ദിനത്തോടനുബന്ധിച്ചു 100 ഓളം വരുന്ന ഭിന്നശേഷി കുട്ടികളുടെ കുടുംബങ്ങൾക്കു ഭക്ഷ്യ കിറ്റ് നൽകാൻ സാധിച്ചു",
      thumb: "assets/img/spectrum/40.jpg",
    },
    {
      src: "assets/img/spectrum/41.jpg",
      caption:
        "പരിസ്ഥിതി ദിനത്തിൽ പരിസ്ഥിതി സംരക്ഷണത്തിന് പ്രാധാന്യം നല്കുന്ന പോലെ തന്നെ നമ്മുടെ സഹജീവികളെയും സംരക്ഷിക്കാനും സ്നേഹിക്കാനും നമ്മൾ ബാധ്യസ്ഥരാണ്. നിംസും PADS ഉം എക്കാലവും സംയുക്തമായി ചെയ്തു പോകുന്ന കാരുണ്യ പ്രവർത്തനങ്ങൾക്കു യാതൊരു മങ്ങലും കൂടാതെ ഇനിയും മുന്നോട്ടു തന്നെ ഉണ്ടാകും.. ഇന്ന് ഈ ലോക പരിസ്ഥിതി ദിനത്തോടനുബന്ധിച്ചു 100 ഓളം വരുന്ന ഭിന്നശേഷി കുട്ടികളുടെ കുടുംബങ്ങൾക്കു ഭക്ഷ്യ കിറ്റ് നൽകാൻ സാധിച്ചു",
      thumb: "assets/img/spectrum/41.jpg",
    },
    {
      src: "assets/img/spectrum/42.jpg",
      caption:
        "പരിസ്ഥിതി ദിനത്തിൽ പരിസ്ഥിതി സംരക്ഷണത്തിന് പ്രാധാന്യം നല്കുന്ന പോലെ തന്നെ നമ്മുടെ സഹജീവികളെയും സംരക്ഷിക്കാനും സ്നേഹിക്കാനും നമ്മൾ ബാധ്യസ്ഥരാണ്. നിംസും PADS ഉം എക്കാലവും സംയുക്തമായി ചെയ്തു പോകുന്ന കാരുണ്യ പ്രവർത്തനങ്ങൾക്കു യാതൊരു മങ്ങലും കൂടാതെ ഇനിയും മുന്നോട്ടു തന്നെ ഉണ്ടാകും.. ഇന്ന് ഈ ലോക പരിസ്ഥിതി ദിനത്തോടനുബന്ധിച്ചു 100 ഓളം വരുന്ന ഭിന്നശേഷി കുട്ടികളുടെ കുടുംബങ്ങൾക്കു ഭക്ഷ്യ കിറ്റ് നൽകാൻ സാധിച്ചു",
      thumb: "assets/img/spectrum/42.jpg",
    },
    {
      src: "assets/img/spectrum/43.jpg",
      caption:
        "പരിസ്ഥിതി ദിനത്തിൽ പരിസ്ഥിതി സംരക്ഷണത്തിന് പ്രാധാന്യം നല്കുന്ന പോലെ തന്നെ നമ്മുടെ സഹജീവികളെയും സംരക്ഷിക്കാനും സ്നേഹിക്കാനും നമ്മൾ ബാധ്യസ്ഥരാണ്. നിംസും PADS ഉം എക്കാലവും സംയുക്തമായി ചെയ്തു പോകുന്ന കാരുണ്യ പ്രവർത്തനങ്ങൾക്കു യാതൊരു മങ്ങലും കൂടാതെ ഇനിയും മുന്നോട്ടു തന്നെ ഉണ്ടാകും.. ഇന്ന് ഈ ലോക പരിസ്ഥിതി ദിനത്തോടനുബന്ധിച്ചു 100 ഓളം വരുന്ന ഭിന്നശേഷി കുട്ടികളുടെ കുടുംബങ്ങൾക്കു ഭക്ഷ്യ കിറ്റ് നൽകാൻ സാധിച്ചു",
      thumb: "assets/img/spectrum/43.jpg",
    },
    {
      src: "assets/img/spectrum/44.jpg",
      caption:
        "പരിസ്ഥിതി ദിനത്തിൽ പരിസ്ഥിതി സംരക്ഷണത്തിന് പ്രാധാന്യം നല്കുന്ന പോലെ തന്നെ നമ്മുടെ സഹജീവികളെയും സംരക്ഷിക്കാനും സ്നേഹിക്കാനും നമ്മൾ ബാധ്യസ്ഥരാണ്. നിംസും PADS ഉം എക്കാലവും സംയുക്തമായി ചെയ്തു പോകുന്ന കാരുണ്യ പ്രവർത്തനങ്ങൾക്കു യാതൊരു മങ്ങലും കൂടാതെ ഇനിയും മുന്നോട്ടു തന്നെ ഉണ്ടാകും.. ഇന്ന് ഈ ലോക പരിസ്ഥിതി ദിനത്തോടനുബന്ധിച്ചു 100 ഓളം വരുന്ന ഭിന്നശേഷി കുട്ടികളുടെ കുടുംബങ്ങൾക്കു ഭക്ഷ്യ കിറ്റ് നൽകാൻ സാധിച്ചു",
      thumb: "assets/img/spectrum/44.jpg",
    },
    {
      src: "assets/img/spectrum/45.jpg",
      caption:
        "പരിസ്ഥിതി ദിനത്തിൽ പരിസ്ഥിതി സംരക്ഷണത്തിന് പ്രാധാന്യം നല്കുന്ന പോലെ തന്നെ നമ്മുടെ സഹജീവികളെയും സംരക്ഷിക്കാനും സ്നേഹിക്കാനും നമ്മൾ ബാധ്യസ്ഥരാണ്. നിംസും PADS ഉം എക്കാലവും സംയുക്തമായി ചെയ്തു പോകുന്ന കാരുണ്യ പ്രവർത്തനങ്ങൾക്കു യാതൊരു മങ്ങലും കൂടാതെ ഇനിയും മുന്നോട്ടു തന്നെ ഉണ്ടാകും.. ഇന്ന് ഈ ലോക പരിസ്ഥിതി ദിനത്തോടനുബന്ധിച്ചു 100 ഓളം വരുന്ന ഭിന്നശേഷി കുട്ടികളുടെ കുടുംബങ്ങൾക്കു ഭക്ഷ്യ കിറ്റ് നൽകാൻ സാധിച്ചു",
      thumb: "assets/img/spectrum/45.jpg",
    },
    {
      src: "assets/img/spectrum/1.jpg",
      caption: "1",
      thumb: "assets/img/spectrum/1.jpg",
    },
    {
      src: "assets/img/spectrum/2.jpg",
      caption: "2",
      thumb: "assets/img/spectrum/2.jpg",
    },
    {
      src: "assets/img/spectrum/3.jpg",
      caption: "3",
      thumb: "assets/img/spectrum/3.jpg",
    },
    {
      src: "assets/img/spectrum/4.jpg",
      caption: "4",
      thumb: "assets/img/spectrum/4.jpg",
    },
    {
      src: "assets/img/spectrum/5.jpg",
      caption: "5",
      thumb: "assets/img/spectrum/5.jpg",
    },
    {
      src: "assets/img/spectrum/6.jpg",
      caption: "6",
      thumb: "assets/img/spectrum/6.jpg",
    },
    {
      src: "assets/img/spectrum/7.jpg",
      caption: "7",
      thumb: "assets/img/spectrum/7.jpg",
    },
    {
      src: "assets/img/spectrum/8.jpg",
      caption: "8",
      thumb: "assets/img/spectrum/8.jpg",
    },
    {
      src: "assets/img/spectrum/9.jpg",
      caption: "9",
      thumb: "assets/img/spectrum/9.jpg",
    },
    // {src:'assets/img/spectrum/10.jpg',caption:'10',thumb:'assets/img/spectrum/10.jpg'},
    {
      src: "assets/img/spectrum/11.jpg",
      caption: "11",
      thumb: "assets/img/spectrum/11.jpg",
    },
    {
      src: "assets/img/spectrum/12.jpg",
      caption: "12",
      thumb: "assets/img/spectrum/12.jpg",
    },
    {
      src: "assets/img/spectrum/13.jpg",
      caption: "13",
      thumb: "assets/img/spectrum/13.jpg",
    },
    {
      src: "assets/img/spectrum/14.jpg",
      caption: "14",
      thumb: "assets/img/spectrum/14.jpg",
    },
    {
      src: "assets/img/spectrum/16.jpg",
      caption: "16",
      thumb: "assets/img/spectrum/16.jpg",
    },
    {
      src: "assets/img/spectrum/17.jpg",
      caption: "17",
      thumb: "assets/img/spectrum/17.jpg",
    },
    {
      src: "assets/img/spectrum/18.jpg",
      caption: "18",
      thumb: "assets/img/spectrum/18.jpg",
    },
    {
      src: "assets/img/spectrum/19.jpg",
      caption: "19",
      thumb: "assets/img/spectrum/19.jpg",
    },
    {
      src: "assets/img/spectrum/20.jpg",
      caption: "20",
      thumb: "assets/img/spectrum/20.jpg",
    },
    {
      src: "assets/img/spectrum/21.jpg",
      caption: "21",
      thumb: "assets/img/spectrum/21.jpg",
    },
    {
      src: "assets/img/spectrum/22.jpg",
      caption: "22",
      thumb: "assets/img/spectrum/22.jpg",
    },
    {
      src: "assets/img/spectrum/23.jpg",
      caption: "23",
      thumb: "assets/img/spectrum/23.jpg",
    },
    {
      src: "assets/img/spectrum/24.jpg",
      caption: "24",
      thumb: "assets/img/spectrum/24.jpg",
    },
    {
      src: "assets/img/spectrum/25.jpg",
      caption: "25",
      thumb: "assets/img/spectrum/25.jpg",
    },
    {
      src: "assets/img/spectrum/26.jpg",
      caption: "26",
      thumb: "assets/img/spectrum/26.jpg",
    },
    {
      src: "assets/img/spectrum/27.jpg",
      caption: "27",
      thumb: "assets/img/spectrum/27.jpg",
    },
    {
      src: "assets/img/spectrum/28.jpg",
      caption: "28",
      thumb: "assets/img/spectrum/28.jpg",
    },
    {
      src: "assets/img/spectrum/29.jpg",
      caption: "29",
      thumb: "assets/img/spectrum/29.jpg",
    },
    {
      src: "assets/img/spectrum/30.jpg",
      caption: "30",
      thumb: "assets/img/spectrum/30.jpg",
    },
    {
      src: "assets/img/spectrum/31.jpg",
      caption: "31",
      thumb: "assets/img/spectrum/31.jpg",
    },
  ];

  DIALYSIS_GALLERY: Array<{ src: string; caption: string; thumb: string }> = [
    {
      src: "assets/img/dialysis/30.jpg",
      caption:
        "On the eve of Ramadan, the staff of NIMS Medicity joined hands today (14-06-2018) to distribute grocery kits to the families of patients ( in and around Neyyattinkara) undergoing dialysis at NIMS Medicity. Mr. M.S. Faizal Khan Managing Director, NIMS Medicity,  distributed the relief kits in the presence of NIMS Staff and public.  Mr.Sivakumar Sivakumar administrative co-ordinator,Mr Saju Ayyappan Nair Kottayathumveedu General manager, Mr Refai Abdul Rahim, Mr. Shmnad Alavudeen, Mr Subin Salahudeen,Mr Arun Babu, Mr Bipin Nair and others coordinated the noble initiative.",
      thumb: "assets/img/dialysis/30.jpg",
    },
    {
      src: "assets/img/dialysis/31.jpg",
      caption:
        "On the eve of Ramadan, the staff of NIMS Medicity joined hands today (14-06-2018) to distribute grocery kits to the families of patients ( in and around Neyyattinkara) undergoing dialysis at NIMS Medicity. Mr. M.S. Faizal Khan Managing Director, NIMS Medicity,  distributed the relief kits in the presence of NIMS Staff and public.  Mr.Sivakumar Sivakumar administrative co-ordinator,Mr Saju Ayyappan Nair Kottayathumveedu General manager, Mr Refai Abdul Rahim, Mr. Shmnad Alavudeen, Mr Subin Salahudeen,Mr Arun Babu, Mr Bipin Nair and others coordinated the noble initiative.",
      thumb: "assets/img/dialysis/31.jpg",
    },
    {
      src: "assets/img/dialysis/32.jpg",
      caption:
        "On the eve of Ramadan, the staff of NIMS Medicity joined hands today (14-06-2018) to distribute grocery kits to the families of patients ( in and around Neyyattinkara) undergoing dialysis at NIMS Medicity. Mr. M.S. Faizal Khan Managing Director, NIMS Medicity,  distributed the relief kits in the presence of NIMS Staff and public.  Mr.Sivakumar Sivakumar administrative co-ordinator,Mr Saju Ayyappan Nair Kottayathumveedu General manager, Mr Refai Abdul Rahim, Mr. Shmnad Alavudeen, Mr Subin Salahudeen,Mr Arun Babu, Mr Bipin Nair and others coordinated the noble initiative.",
      thumb: "assets/img/dialysis/32.jpg",
    },
    {
      src: "assets/img/dialysis/33.jpg",
      caption:
        "On the eve of Ramadan, the staff of NIMS Medicity joined hands today (14-06-2018) to distribute grocery kits to the families of patients ( in and around Neyyattinkara) undergoing dialysis at NIMS Medicity. Mr. M.S. Faizal Khan Managing Director, NIMS Medicity,  distributed the relief kits in the presence of NIMS Staff and public.  Mr.Sivakumar Sivakumar administrative co-ordinator,Mr Saju Ayyappan Nair Kottayathumveedu General manager, Mr Refai Abdul Rahim, Mr. Shmnad Alavudeen, Mr Subin Salahudeen,Mr Arun Babu, Mr Bipin Nair and others coordinated the noble initiative.",
      thumb: "assets/img/dialysis/33.jpg",
    },
    {
      src: "assets/img/dialysis/34.jpg",
      caption:
        "On the eve of Ramadan, the staff of NIMS Medicity joined hands today (14-06-2018) to distribute grocery kits to the families of patients ( in and around Neyyattinkara) undergoing dialysis at NIMS Medicity. Mr. M.S. Faizal Khan Managing Director, NIMS Medicity,  distributed the relief kits in the presence of NIMS Staff and public.  Mr.Sivakumar Sivakumar administrative co-ordinator,Mr Saju Ayyappan Nair Kottayathumveedu General manager, Mr Refai Abdul Rahim, Mr. Shmnad Alavudeen, Mr Subin Salahudeen,Mr Arun Babu, Mr Bipin Nair and others coordinated the noble initiative.",
      thumb: "assets/img/dialysis/34.jpg",
    },
    {
      src: "assets/img/dialysis/35.jpg",
      caption:
        "On the eve of Ramadan, the staff of NIMS Medicity joined hands today (14-06-2018) to distribute grocery kits to the families of patients ( in and around Neyyattinkara) undergoing dialysis at NIMS Medicity. Mr. M.S. Faizal Khan Managing Director, NIMS Medicity,  distributed the relief kits in the presence of NIMS Staff and public.  Mr.Sivakumar Sivakumar administrative co-ordinator,Mr Saju Ayyappan Nair Kottayathumveedu General manager, Mr Refai Abdul Rahim, Mr. Shmnad Alavudeen, Mr Subin Salahudeen,Mr Arun Babu, Mr Bipin Nair and others coordinated the noble initiative.",
      thumb: "assets/img/dialysis/35.jpg",
    },
    {
      src: "assets/img/dialysis/36.jpg",
      caption:
        "On the eve of Ramadan, the staff of NIMS Medicity joined hands today (14-06-2018) to distribute grocery kits to the families of patients ( in and around Neyyattinkara) undergoing dialysis at NIMS Medicity. Mr. M.S. Faizal Khan Managing Director, NIMS Medicity,  distributed the relief kits in the presence of NIMS Staff and public.  Mr.Sivakumar Sivakumar administrative co-ordinator,Mr Saju Ayyappan Nair Kottayathumveedu General manager, Mr Refai Abdul Rahim, Mr. Shmnad Alavudeen, Mr Subin Salahudeen,Mr Arun Babu, Mr Bipin Nair and others coordinated the noble initiative.",
      thumb: "assets/img/dialysis/36.jpg",
    },
    {
      src: "assets/img/dialysis/37.jpg",
      caption:
        "On the eve of Ramadan, the staff of NIMS Medicity joined hands today (14-06-2018) to distribute grocery kits to the families of patients ( in and around Neyyattinkara) undergoing dialysis at NIMS Medicity. Mr. M.S. Faizal Khan Managing Director, NIMS Medicity,  distributed the relief kits in the presence of NIMS Staff and public.  Mr.Sivakumar Sivakumar administrative co-ordinator,Mr Saju Ayyappan Nair Kottayathumveedu General manager, Mr Refai Abdul Rahim, Mr. Shmnad Alavudeen, Mr Subin Salahudeen,Mr Arun Babu, Mr Bipin Nair and others coordinated the noble initiative.",
      thumb: "assets/img/dialysis/37.jpg",
    },
    {
      src: "assets/img/dialysis/38.jpg",
      caption:
        "On the eve of Ramadan, the staff of NIMS Medicity joined hands today (14-06-2018) to distribute grocery kits to the families of patients ( in and around Neyyattinkara) undergoing dialysis at NIMS Medicity. Mr. M.S. Faizal Khan Managing Director, NIMS Medicity,  distributed the relief kits in the presence of NIMS Staff and public.  Mr.Sivakumar Sivakumar administrative co-ordinator,Mr Saju Ayyappan Nair Kottayathumveedu General manager, Mr Refai Abdul Rahim, Mr. Shmnad Alavudeen, Mr Subin Salahudeen,Mr Arun Babu, Mr Bipin Nair and others coordinated the noble initiative.",
      thumb: "assets/img/dialysis/38.jpg",
    },
    {
      src: "assets/img/dialysis/39.jpg",
      caption:
        "On the eve of Ramadan, the staff of NIMS Medicity joined hands today (14-06-2018) to distribute grocery kits to the families of patients ( in and around Neyyattinkara) undergoing dialysis at NIMS Medicity. Mr. M.S. Faizal Khan Managing Director, NIMS Medicity,  distributed the relief kits in the presence of NIMS Staff and public.  Mr.Sivakumar Sivakumar administrative co-ordinator,Mr Saju Ayyappan Nair Kottayathumveedu General manager, Mr Refai Abdul Rahim, Mr. Shmnad Alavudeen, Mr Subin Salahudeen,Mr Arun Babu, Mr Bipin Nair and others coordinated the noble initiative.",
      thumb: "assets/img/dialysis/39.jpg",
    },
    {
      src: "assets/img/dialysis/40.jpg",
      caption:
        "On the eve of Ramadan, the staff of NIMS Medicity joined hands today (14-06-2018) to distribute grocery kits to the families of patients ( in and around Neyyattinkara) undergoing dialysis at NIMS Medicity. Mr. M.S. Faizal Khan Managing Director, NIMS Medicity,  distributed the relief kits in the presence of NIMS Staff and public.  Mr.Sivakumar Sivakumar administrative co-ordinator,Mr Saju Ayyappan Nair Kottayathumveedu General manager, Mr Refai Abdul Rahim, Mr. Shmnad Alavudeen, Mr Subin Salahudeen,Mr Arun Babu, Mr Bipin Nair and others coordinated the noble initiative.",
      thumb: "assets/img/dialysis/40.jpg",
    },
    {
      src: "assets/img/dialysis/41.jpg",
      caption:
        "On the eve of Ramadan, the staff of NIMS Medicity joined hands today (14-06-2018) to distribute grocery kits to the families of patients ( in and around Neyyattinkara) undergoing dialysis at NIMS Medicity. Mr. M.S. Faizal Khan Managing Director, NIMS Medicity,  distributed the relief kits in the presence of NIMS Staff and public.  Mr.Sivakumar Sivakumar administrative co-ordinator,Mr Saju Ayyappan Nair Kottayathumveedu General manager, Mr Refai Abdul Rahim, Mr. Shmnad Alavudeen, Mr Subin Salahudeen,Mr Arun Babu, Mr Bipin Nair and others coordinated the noble initiative.",
      thumb: "assets/img/dialysis/41.jpg",
    },
    {
      src: "assets/img/dialysis/42.jpg",
      caption:
        "On the eve of Ramadan, the staff of NIMS Medicity joined hands today (14-06-2018) to distribute grocery kits to the families of patients ( in and around Neyyattinkara) undergoing dialysis at NIMS Medicity. Mr. M.S. Faizal Khan Managing Director, NIMS Medicity,  distributed the relief kits in the presence of NIMS Staff and public.  Mr.Sivakumar Sivakumar administrative co-ordinator,Mr Saju Ayyappan Nair Kottayathumveedu General manager, Mr Refai Abdul Rahim, Mr. Shmnad Alavudeen, Mr Subin Salahudeen,Mr Arun Babu, Mr Bipin Nair and others coordinated the noble initiative.",
      thumb: "assets/img/dialysis/42.jpg",
    },
    {
      src: "assets/img/dialysis/43.jpg",
      caption:
        "On the eve of Ramadan, the staff of NIMS Medicity joined hands today (14-06-2018) to distribute grocery kits to the families of patients ( in and around Neyyattinkara) undergoing dialysis at NIMS Medicity. Mr. M.S. Faizal Khan Managing Director, NIMS Medicity,  distributed the relief kits in the presence of NIMS Staff and public.  Mr.Sivakumar Sivakumar administrative co-ordinator,Mr Saju Ayyappan Nair Kottayathumveedu General manager, Mr Refai Abdul Rahim, Mr. Shmnad Alavudeen, Mr Subin Salahudeen,Mr Arun Babu, Mr Bipin Nair and others coordinated the noble initiative.",
      thumb: "assets/img/dialysis/43.jpg",
    },
    {
      src: "assets/img/dialysis/44.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ രണ്ടാം ഡയാലിസിസ് യൂണിറ്റ് 4 ബെഡോട്കൂടി പ്രവർത്തനം ആരംഭിച്ചിരിച്ചുക്കുന്നു..ബഹുമാനപ്പെട്ട ചെയർമാൻ ശ്രീ മജീദ് ഖാൻ ഉത്ഘാടനം നിർവഹിച്ച ചടങ്ങിൽ മാനേജിങ് ഡയറക്ടർ ശ്രീ എം എസ് ഫൈസൽ ഖാൻ, നേഫ്റോളജി വിഭാഗം മേധാവി ശ്രീമതി dr മഞ്ജു തമ്പി, അഡ്മിനിസ്‌ട്രേറ്റീവ് കോർഡിനേറ്റർ ശ്രീ ശിവകുമാർ, ജനറൽ മാനേജർ ശ്രീ സജു മറ്റു നിംസിന്റെ സ്റ്റാഫ്‌ അംഗങ്ങൾ തുടങ്ങിയവർ സന്നിഹിതരായിരുന്നു...",
      thumb: "assets/img/dialysis/44.jpg",
    },
    {
      src: "assets/img/dialysis/45.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ രണ്ടാം ഡയാലിസിസ് യൂണിറ്റ് 4 ബെഡോട്കൂടി പ്രവർത്തനം ആരംഭിച്ചിരിച്ചുക്കുന്നു..ബഹുമാനപ്പെട്ട ചെയർമാൻ ശ്രീ മജീദ് ഖാൻ ഉത്ഘാടനം നിർവഹിച്ച ചടങ്ങിൽ മാനേജിങ് ഡയറക്ടർ ശ്രീ എം എസ് ഫൈസൽ ഖാൻ, നേഫ്റോളജി വിഭാഗം മേധാവി ശ്രീമതി dr മഞ്ജു തമ്പി, അഡ്മിനിസ്‌ട്രേറ്റീവ് കോർഡിനേറ്റർ ശ്രീ ശിവകുമാർ, ജനറൽ മാനേജർ ശ്രീ സജു മറ്റു നിംസിന്റെ സ്റ്റാഫ്‌ അംഗങ്ങൾ തുടങ്ങിയവർ സന്നിഹിതരായിരുന്നു...",
      thumb: "assets/img/dialysis/45.jpg",
    },
    {
      src: "assets/img/dialysis/46.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ രണ്ടാം ഡയാലിസിസ് യൂണിറ്റ് 4 ബെഡോട്കൂടി പ്രവർത്തനം ആരംഭിച്ചിരിച്ചുക്കുന്നു..ബഹുമാനപ്പെട്ട ചെയർമാൻ ശ്രീ മജീദ് ഖാൻ ഉത്ഘാടനം നിർവഹിച്ച ചടങ്ങിൽ മാനേജിങ് ഡയറക്ടർ ശ്രീ എം എസ് ഫൈസൽ ഖാൻ, നേഫ്റോളജി വിഭാഗം മേധാവി ശ്രീമതി dr മഞ്ജു തമ്പി, അഡ്മിനിസ്‌ട്രേറ്റീവ് കോർഡിനേറ്റർ ശ്രീ ശിവകുമാർ, ജനറൽ മാനേജർ ശ്രീ സജു മറ്റു നിംസിന്റെ സ്റ്റാഫ്‌ അംഗങ്ങൾ തുടങ്ങിയവർ സന്നിഹിതരായിരുന്നു...",
      thumb: "assets/img/dialysis/46.jpg",
    },
    {
      src: "assets/img/dialysis/47.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ രണ്ടാം ഡയാലിസിസ് യൂണിറ്റ് 4 ബെഡോട്കൂടി പ്രവർത്തനം ആരംഭിച്ചിരിച്ചുക്കുന്നു..ബഹുമാനപ്പെട്ട ചെയർമാൻ ശ്രീ മജീദ് ഖാൻ ഉത്ഘാടനം നിർവഹിച്ച ചടങ്ങിൽ മാനേജിങ് ഡയറക്ടർ ശ്രീ എം എസ് ഫൈസൽ ഖാൻ, നേഫ്റോളജി വിഭാഗം മേധാവി ശ്രീമതി dr മഞ്ജു തമ്പി, അഡ്മിനിസ്‌ട്രേറ്റീവ് കോർഡിനേറ്റർ ശ്രീ ശിവകുമാർ, ജനറൽ മാനേജർ ശ്രീ സജു മറ്റു നിംസിന്റെ സ്റ്റാഫ്‌ അംഗങ്ങൾ തുടങ്ങിയവർ സന്നിഹിതരായിരുന്നു...",
      thumb: "assets/img/dialysis/47.jpg",
    },
    {
      src: "assets/img/dialysis/48.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ രണ്ടാം ഡയാലിസിസ് യൂണിറ്റ് 4 ബെഡോട്കൂടി പ്രവർത്തനം ആരംഭിച്ചിരിച്ചുക്കുന്നു..ബഹുമാനപ്പെട്ട ചെയർമാൻ ശ്രീ മജീദ് ഖാൻ ഉത്ഘാടനം നിർവഹിച്ച ചടങ്ങിൽ മാനേജിങ് ഡയറക്ടർ ശ്രീ എം എസ് ഫൈസൽ ഖാൻ, നേഫ്റോളജി വിഭാഗം മേധാവി ശ്രീമതി dr മഞ്ജു തമ്പി, അഡ്മിനിസ്‌ട്രേറ്റീവ് കോർഡിനേറ്റർ ശ്രീ ശിവകുമാർ, ജനറൽ മാനേജർ ശ്രീ സജു മറ്റു നിംസിന്റെ സ്റ്റാഫ്‌ അംഗങ്ങൾ തുടങ്ങിയവർ സന്നിഹിതരായിരുന്നു...",
      thumb: "assets/img/dialysis/48.jpg",
    },
    {
      src: "assets/img/dialysis/49.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ രണ്ടാം ഡയാലിസിസ് യൂണിറ്റ് 4 ബെഡോട്കൂടി പ്രവർത്തനം ആരംഭിച്ചിരിച്ചുക്കുന്നു..ബഹുമാനപ്പെട്ട ചെയർമാൻ ശ്രീ മജീദ് ഖാൻ ഉത്ഘാടനം നിർവഹിച്ച ചടങ്ങിൽ മാനേജിങ് ഡയറക്ടർ ശ്രീ എം എസ് ഫൈസൽ ഖാൻ, നേഫ്റോളജി വിഭാഗം മേധാവി ശ്രീമതി dr മഞ്ജു തമ്പി, അഡ്മിനിസ്‌ട്രേറ്റീവ് കോർഡിനേറ്റർ ശ്രീ ശിവകുമാർ, ജനറൽ മാനേജർ ശ്രീ സജു മറ്റു നിംസിന്റെ സ്റ്റാഫ്‌ അംഗങ്ങൾ തുടങ്ങിയവർ സന്നിഹിതരായിരുന്നു...",
      thumb: "assets/img/dialysis/49.jpg",
    },
    {
      src: "assets/img/dialysis/50.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ രണ്ടാം ഡയാലിസിസ് യൂണിറ്റ് 4 ബെഡോട്കൂടി പ്രവർത്തനം ആരംഭിച്ചിരിച്ചുക്കുന്നു..ബഹുമാനപ്പെട്ട ചെയർമാൻ ശ്രീ മജീദ് ഖാൻ ഉത്ഘാടനം നിർവഹിച്ച ചടങ്ങിൽ മാനേജിങ് ഡയറക്ടർ ശ്രീ എം എസ് ഫൈസൽ ഖാൻ, നേഫ്റോളജി വിഭാഗം മേധാവി ശ്രീമതി dr മഞ്ജു തമ്പി, അഡ്മിനിസ്‌ട്രേറ്റീവ് കോർഡിനേറ്റർ ശ്രീ ശിവകുമാർ, ജനറൽ മാനേജർ ശ്രീ സജു മറ്റു നിംസിന്റെ സ്റ്റാഫ്‌ അംഗങ്ങൾ തുടങ്ങിയവർ സന്നിഹിതരായിരുന്നു...",
      thumb: "assets/img/dialysis/50.jpg",
    },
    {
      src: "assets/img/dialysis/51.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ രണ്ടാം ഡയാലിസിസ് യൂണിറ്റ് 4 ബെഡോട്കൂടി പ്രവർത്തനം ആരംഭിച്ചിരിച്ചുക്കുന്നു..ബഹുമാനപ്പെട്ട ചെയർമാൻ ശ്രീ മജീദ് ഖാൻ ഉത്ഘാടനം നിർവഹിച്ച ചടങ്ങിൽ മാനേജിങ് ഡയറക്ടർ ശ്രീ എം എസ് ഫൈസൽ ഖാൻ, നേഫ്റോളജി വിഭാഗം മേധാവി ശ്രീമതി dr മഞ്ജു തമ്പി, അഡ്മിനിസ്‌ട്രേറ്റീവ് കോർഡിനേറ്റർ ശ്രീ ശിവകുമാർ, ജനറൽ മാനേജർ ശ്രീ സജു മറ്റു നിംസിന്റെ സ്റ്റാഫ്‌ അംഗങ്ങൾ തുടങ്ങിയവർ സന്നിഹിതരായിരുന്നു...",
      thumb: "assets/img/dialysis/51.jpg",
    },
    {
      src: "assets/img/dialysis/52.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ രണ്ടാം ഡയാലിസിസ് യൂണിറ്റ് 4 ബെഡോട്കൂടി പ്രവർത്തനം ആരംഭിച്ചിരിച്ചുക്കുന്നു..ബഹുമാനപ്പെട്ട ചെയർമാൻ ശ്രീ മജീദ് ഖാൻ ഉത്ഘാടനം നിർവഹിച്ച ചടങ്ങിൽ മാനേജിങ് ഡയറക്ടർ ശ്രീ എം എസ് ഫൈസൽ ഖാൻ, നേഫ്റോളജി വിഭാഗം മേധാവി ശ്രീമതി dr മഞ്ജു തമ്പി, അഡ്മിനിസ്‌ട്രേറ്റീവ് കോർഡിനേറ്റർ ശ്രീ ശിവകുമാർ, ജനറൽ മാനേജർ ശ്രീ സജു മറ്റു നിംസിന്റെ സ്റ്റാഫ്‌ അംഗങ്ങൾ തുടങ്ങിയവർ സന്നിഹിതരായിരുന്നു...",
      thumb: "assets/img/dialysis/52.jpg",
    },
    {
      src: "assets/img/dialysis/53.jpg",
      caption:
        "നെയ്യാറ്റിൻകര നിംസ് മെഡിസിറ്റിയും ശ്രീ സത്യസായി ഓർഫനേജ് ട്രസ്റ്റും സംയുക്തമായി സായി കിരൺ - സൗജന്യ വൃക്ക മാറ്റിവയ്ക്കൽ ശസ്ത്രക്രിയ പദ്ധതിക്ക് ധാരണാ പത്രം ഒപ്പ് വച്ചു.",
      thumb: "assets/img/dialysis/53.jpg",
    },
    {
      src: "assets/img/dialysis/54.jpg",
      caption:
        "നെയ്യാറ്റിൻകര നിംസ് മെഡിസിറ്റിയും ശ്രീ സത്യസായി ഓർഫനേജ് ട്രസ്റ്റും സംയുക്തമായി സായി കിരൺ - സൗജന്യ വൃക്ക മാറ്റിവയ്ക്കൽ ശസ്ത്രക്രിയ പദ്ധതിക്ക് ധാരണാ പത്രം ഒപ്പ് വച്ചു.",
      thumb: "assets/img/dialysis/54.jpg",
    },
    {
      src: "assets/img/dialysis/55.jpg",
      caption:
        "നെയ്യാറ്റിൻകര നിംസ് മെഡിസിറ്റിയും ശ്രീ സത്യസായി ഓർഫനേജ് ട്രസ്റ്റും സംയുക്തമായി സായി കിരൺ - സൗജന്യ വൃക്ക മാറ്റിവയ്ക്കൽ ശസ്ത്രക്രിയ പദ്ധതിക്ക് ധാരണാ പത്രം ഒപ്പ് വച്ചു.",
      thumb: "assets/img/dialysis/55.jpg",
    },
    {
      src: "assets/img/dialysis/56.jpg",
      caption:
        "കഴിഞ്ഞ ഒരു വർഷത്തിനുള്ളിൽ തന്നെ 25 വൃക്ക മാറ്റിവയ്ക്കൽ ശസ്ത്രക്രിയ , കേരളത്തിലെ തന്നെ ഏറ്റവും കുറഞ്ഞ ചിലവിൽ (2.75 ലക്ഷം രൂപയ്ക്ക് ) വിജയകരമായി പൂർത്തീകരിക്കുവാൻ സാധിച്ചതിന്റെ നിറവിൽ നിൽക്കുന്ന നിംസ് മെഡിസിറ്റിയും സാമൂഹിക സേവന രംഗത്ത് അതിന്റേതായ വ്യക്തി മുദ്ര പതിപ്പിച്ച കേരളത്തിലെ തന്നെ ഏറ്റവും വലിയ എൻ.ജി. ഓ ആയ സത്യസായി ഓർഫനേജ് ട്രസ്റ്റുമാണ് സായി കിരൺ സൗജന്യ വൃക്ക മാറ്റിവയ്ക്കൽ ശസ്ത്രക്രിയ പദ്ധതിക്ക് കൈയ് കോർക്കുന്നത്.",
      thumb: "assets/img/dialysis/56.jpg",
    },
    {
      src: "assets/img/dialysis/57.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ സ്ഥാപകനും ചെയർമാനുമായ ശ്രീ ഡോ: എ.പി. മജീദ് ഖാനും സത്യസായി ഓർഫനേജ് ട്രസ്റ്റിന്റെ സ്ഥാപകനും എക്സിക്കൂട്ടിവ് ഡയറക്ടറുമായ ശ്രീ.കെ.ആനന്ദ് കുമാറുമാണ് ധാരണ പത്രത്തിൽ ഒപ്പ് വച്ചത് .നിംസ് മെഡിസിറ്റി മാനേജിങ് ഡയറക്ടർ ശ്രീ.എം.എസ് ഫൈസൽ ഖാൻ സന്നിഹിതനായിരുന്നു.",
      thumb: "assets/img/dialysis/57.jpg",
    },

    {
      src: "assets/img/dialysis/21.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ രണ്ടാം ഡയാലിസിസ് യൂണിറ്റ് 4 ബെഡോട്കൂടി പ്രവർത്തനം ആരംഭിച്ചിരിച്ചുക്കുന്നു.. ബഹുമാനപ്പെട്ട ചെയർമാൻ ശ്രീ മജീദ് ഖാൻ ഉത്ഘാടനം നിർവഹിച്ച ചടങ്ങിൽ മാനേജിങ് ഡയറക്ടർ ശ്രീ എം എസ് ഫൈസൽ ഖാൻ, നേഫ്റോളജി വിഭാഗം മേധാവി ശ്രീമതി dr മഞ്ജു തമ്പി, അഡ്മിനിസ്‌ട്രേറ്റീവ് കോർഡിനേറ്റർ ശ്രീ ശിവകുമാർ, ജനറൽ മാനേജർ ശ്രീ സജു മറ്റു നിംസിന്റെ സ്റ്റാഫ്‌ അംഗങ്ങൾ തുടങ്ങിയവർ സന്നിഹിതരായിരുന്നു...",
      thumb: "assets/img/dialysis/21.jpg",
    },
    {
      src: "assets/img/dialysis/22.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ രണ്ടാം ഡയാലിസിസ് യൂണിറ്റ് 4 ബെഡോട്കൂടി പ്രവർത്തനം ആരംഭിച്ചിരിച്ചുക്കുന്നു.. ബഹുമാനപ്പെട്ട ചെയർമാൻ ശ്രീ മജീദ് ഖാൻ ഉത്ഘാടനം നിർവഹിച്ച ചടങ്ങിൽ മാനേജിങ് ഡയറക്ടർ ശ്രീ എം എസ് ഫൈസൽ ഖാൻ, നേഫ്റോളജി വിഭാഗം മേധാവി ശ്രീമതി dr മഞ്ജു തമ്പി, അഡ്മിനിസ്‌ട്രേറ്റീവ് കോർഡിനേറ്റർ ശ്രീ ശിവകുമാർ, ജനറൽ മാനേജർ ശ്രീ സജു മറ്റു നിംസിന്റെ സ്റ്റാഫ്‌ അംഗങ്ങൾ തുടങ്ങിയവർ സന്നിഹിതരായിരുന്നു...",
      thumb: "assets/img/dialysis/22.jpg",
    },
    {
      src: "assets/img/dialysis/23.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ രണ്ടാം ഡയാലിസിസ് യൂണിറ്റ് 4 ബെഡോട്കൂടി പ്രവർത്തനം ആരംഭിച്ചിരിച്ചുക്കുന്നു.. ബഹുമാനപ്പെട്ട ചെയർമാൻ ശ്രീ മജീദ് ഖാൻ ഉത്ഘാടനം നിർവഹിച്ച ചടങ്ങിൽ മാനേജിങ് ഡയറക്ടർ ശ്രീ എം എസ് ഫൈസൽ ഖാൻ, നേഫ്റോളജി വിഭാഗം മേധാവി ശ്രീമതി dr മഞ്ജു തമ്പി, അഡ്മിനിസ്‌ട്രേറ്റീവ് കോർഡിനേറ്റർ ശ്രീ ശിവകുമാർ, ജനറൽ മാനേജർ ശ്രീ സജു മറ്റു നിംസിന്റെ സ്റ്റാഫ്‌ അംഗങ്ങൾ തുടങ്ങിയവർ സന്നിഹിതരായിരുന്നു...",
      thumb: "assets/img/dialysis/23.jpg",
    },
    {
      src: "assets/img/dialysis/24.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ രണ്ടാം ഡയാലിസിസ് യൂണിറ്റ് 4 ബെഡോട്കൂടി പ്രവർത്തനം ആരംഭിച്ചിരിച്ചുക്കുന്നു.. ബഹുമാനപ്പെട്ട ചെയർമാൻ ശ്രീ മജീദ് ഖാൻ ഉത്ഘാടനം നിർവഹിച്ച ചടങ്ങിൽ മാനേജിങ് ഡയറക്ടർ ശ്രീ എം എസ് ഫൈസൽ ഖാൻ, നേഫ്റോളജി വിഭാഗം മേധാവി ശ്രീമതി dr മഞ്ജു തമ്പി, അഡ്മിനിസ്‌ട്രേറ്റീവ് കോർഡിനേറ്റർ ശ്രീ ശിവകുമാർ, ജനറൽ മാനേജർ ശ്രീ സജു മറ്റു നിംസിന്റെ സ്റ്റാഫ്‌ അംഗങ്ങൾ തുടങ്ങിയവർ സന്നിഹിതരായിരുന്നു...",
      thumb: "assets/img/dialysis/24.jpg",
    },
    {
      src: "assets/img/dialysis/25.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ രണ്ടാം ഡയാലിസിസ് യൂണിറ്റ് 4 ബെഡോട്കൂടി പ്രവർത്തനം ആരംഭിച്ചിരിച്ചുക്കുന്നു.. ബഹുമാനപ്പെട്ട ചെയർമാൻ ശ്രീ മജീദ് ഖാൻ ഉത്ഘാടനം നിർവഹിച്ച ചടങ്ങിൽ മാനേജിങ് ഡയറക്ടർ ശ്രീ എം എസ് ഫൈസൽ ഖാൻ, നേഫ്റോളജി വിഭാഗം മേധാവി ശ്രീമതി dr മഞ്ജു തമ്പി, അഡ്മിനിസ്‌ട്രേറ്റീവ് കോർഡിനേറ്റർ ശ്രീ ശിവകുമാർ, ജനറൽ മാനേജർ ശ്രീ സജു മറ്റു നിംസിന്റെ സ്റ്റാഫ്‌ അംഗങ്ങൾ തുടങ്ങിയവർ സന്നിഹിതരായിരുന്നു...",
      thumb: "assets/img/dialysis/25.jpg",
    },
    {
      src: "assets/img/dialysis/26.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ രണ്ടാം ഡയാലിസിസ് യൂണിറ്റ് 4 ബെഡോട്കൂടി പ്രവർത്തനം ആരംഭിച്ചിരിച്ചുക്കുന്നു.. ബഹുമാനപ്പെട്ട ചെയർമാൻ ശ്രീ മജീദ് ഖാൻ ഉത്ഘാടനം നിർവഹിച്ച ചടങ്ങിൽ മാനേജിങ് ഡയറക്ടർ ശ്രീ എം എസ് ഫൈസൽ ഖാൻ, നേഫ്റോളജി വിഭാഗം മേധാവി ശ്രീമതി dr മഞ്ജു തമ്പി, അഡ്മിനിസ്‌ട്രേറ്റീവ് കോർഡിനേറ്റർ ശ്രീ ശിവകുമാർ, ജനറൽ മാനേജർ ശ്രീ സജു മറ്റു നിംസിന്റെ സ്റ്റാഫ്‌ അംഗങ്ങൾ തുടങ്ങിയവർ സന്നിഹിതരായിരുന്നു...",
      thumb: "assets/img/dialysis/26.jpg",
    },
    {
      src: "assets/img/dialysis/27.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ രണ്ടാം ഡയാലിസിസ് യൂണിറ്റ് 4 ബെഡോട്കൂടി പ്രവർത്തനം ആരംഭിച്ചിരിച്ചുക്കുന്നു.. ബഹുമാനപ്പെട്ട ചെയർമാൻ ശ്രീ മജീദ് ഖാൻ ഉത്ഘാടനം നിർവഹിച്ച ചടങ്ങിൽ മാനേജിങ് ഡയറക്ടർ ശ്രീ എം എസ് ഫൈസൽ ഖാൻ, നേഫ്റോളജി വിഭാഗം മേധാവി ശ്രീമതി dr മഞ്ജു തമ്പി, അഡ്മിനിസ്‌ട്രേറ്റീവ് കോർഡിനേറ്റർ ശ്രീ ശിവകുമാർ, ജനറൽ മാനേജർ ശ്രീ സജു മറ്റു നിംസിന്റെ സ്റ്റാഫ്‌ അംഗങ്ങൾ തുടങ്ങിയവർ സന്നിഹിതരായിരുന്നു...",
      thumb: "assets/img/dialysis/27.jpg",
    },
    {
      src: "assets/img/dialysis/28.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ രണ്ടാം ഡയാലിസിസ് യൂണിറ്റ് 4 ബെഡോട്കൂടി പ്രവർത്തനം ആരംഭിച്ചിരിച്ചുക്കുന്നു.. ബഹുമാനപ്പെട്ട ചെയർമാൻ ശ്രീ മജീദ് ഖാൻ ഉത്ഘാടനം നിർവഹിച്ച ചടങ്ങിൽ മാനേജിങ് ഡയറക്ടർ ശ്രീ എം എസ് ഫൈസൽ ഖാൻ, നേഫ്റോളജി വിഭാഗം മേധാവി ശ്രീമതി dr മഞ്ജു തമ്പി, അഡ്മിനിസ്‌ട്രേറ്റീവ് കോർഡിനേറ്റർ ശ്രീ ശിവകുമാർ, ജനറൽ മാനേജർ ശ്രീ സജു മറ്റു നിംസിന്റെ സ്റ്റാഫ്‌ അംഗങ്ങൾ തുടങ്ങിയവർ സന്നിഹിതരായിരുന്നു...",
      thumb: "assets/img/dialysis/28.jpg",
    },
    {
      src: "assets/img/dialysis/29.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ രണ്ടാം ഡയാലിസിസ് യൂണിറ്റ് 4 ബെഡോട്കൂടി പ്രവർത്തനം ആരംഭിച്ചിരിച്ചുക്കുന്നു.. ബഹുമാനപ്പെട്ട ചെയർമാൻ ശ്രീ മജീദ് ഖാൻ ഉത്ഘാടനം നിർവഹിച്ച ചടങ്ങിൽ മാനേജിങ് ഡയറക്ടർ ശ്രീ എം എസ് ഫൈസൽ ഖാൻ, നേഫ്റോളജി വിഭാഗം മേധാവി ശ്രീമതി dr മഞ്ജു തമ്പി, അഡ്മിനിസ്‌ട്രേറ്റീവ് കോർഡിനേറ്റർ ശ്രീ ശിവകുമാർ, ജനറൽ മാനേജർ ശ്രീ സജു മറ്റു നിംസിന്റെ സ്റ്റാഫ്‌ അംഗങ്ങൾ തുടങ്ങിയവർ സന്നിഹിതരായിരുന്നു...",
      thumb: "assets/img/dialysis/29.jpg",
    },

    {
      src: "assets/img/dialysis/1.jpg",
      caption: "1",
      thumb: "assets/img/dialysis/1.jpg",
    },
    {
      src: "assets/img/dialysis/2.jpeg",
      caption: "2",
      thumb: "assets/img/dialysis/2.jpeg",
    },
    {
      src: "assets/img/dialysis/3.jpeg",
      caption: "3",
      thumb: "assets/img/dialysis/3.jpeg",
    },
    {
      src: "assets/img/dialysis/4.jpeg",
      caption: "4",
      thumb: "assets/img/dialysis/4.jpeg",
    },
    {
      src: "assets/img/dialysis/5.jpeg",
      caption: "5",
      thumb: "assets/img/dialysis/5.jpeg",
    },
    {
      src: "assets/img/dialysis/6.jpeg",
      caption: "6",
      thumb: "assets/img/dialysis/6.jpeg",
    },
    {
      src: "assets/img/dialysis/7.jpeg",
      caption: "7",
      thumb: "assets/img/dialysis/7.jpeg",
    },
    {
      src: "assets/img/dialysis/8.jpeg",
      caption: "8",
      thumb: "assets/img/dialysis/8.jpeg",
    },
    {
      src: "assets/img/dialysis/9.jpg",
      caption: "9",
      thumb: "assets/img/dialysis/9.jpg",
    },
    {
      src: "assets/img/dialysis/10.jpg",
      caption: "10",
      thumb: "assets/img/dialysis/10.jpg",
    },
    {
      src: "assets/img/dialysis/11.jpg",
      caption: "11",
      thumb: "assets/img/dialysis/11.jpg",
    },
    {
      src: "assets/img/dialysis/12.jpg",
      caption: "12",
      thumb: "assets/img/dialysis/12.jpg",
    },
    {
      src: "assets/img/dialysis/13.jpg",
      caption: "13",
      thumb: "assets/img/dialysis/13.jpg",
    },
    {
      src: "assets/img/dialysis/14.jpg",
      caption: "14",
      thumb: "assets/img/dialysis/14.jpg",
    },
    {
      src: "assets/img/dialysis/15.jpg",
      caption: "15",
      thumb: "assets/img/dialysis/15.jpg",
    },
    {
      src: "assets/img/dialysis/16.jpg",
      caption: "16",
      thumb: "assets/img/dialysis/16.jpg",
    },
    // {src:'assets/img/dialysis/17.jpg',caption: '17',thumb:'assets/img/dialysis/17.jpg'},
    {
      src: "assets/img/dialysis/18.jpg",
      caption: "18",
      thumb: "assets/img/dialysis/18.jpg",
    },
    {
      src: "assets/img/dialysis/19.jpg",
      caption: "19",
      thumb: "assets/img/dialysis/19.jpg",
    },
    {
      src: "assets/img/dialysis/20.jpg",
      caption: "20",
      thumb: "assets/img/dialysis/20.jpg",
    },
  ];

  Heart2Heart_GALLERY: Array<{ src: string; caption: string; thumb: string }> =
    [
      {
        src: "assets/img/Pastevents/259.jpg",
        caption:
          "ലോക ഹൃദയദിനത്തോടനുബന്ധിച്ച് നിംസ്  ഹാർട്ട് ഫൗണ്ടേഷന്റെ ആഭിമുഖ്യത്തിൽ സൗജന്യ ഹൃദയാരോഗ്യമേള നിംസിൽ  വിദ്യാഭ്യാസ  വകുപ്പ് മന്ത്രി ശ്രി. വി. ശിവൻകുട്ടി  ഉദ്‌ഘാടനം ചെയ്തു.",
        thumb: "assets/img/Pastevents/259.jpg",
      },
      {
        src: "assets/img/Pastevents/264.jpg",
        caption:
          "ലോക ഹൃദയദിനത്തോടനുബന്ധിച്ച് നിംസ്  ഹാർട്ട് ഫൗണ്ടേഷന്റെ ആഭിമുഖ്യത്തിൽ സൗജന്യ ഹൃദയാരോഗ്യമേള നിംസിൽ  വിദ്യാഭ്യാസ  വകുപ്പ് മന്ത്രി ശ്രി. വി. ശിവൻകുട്ടി  ഉദ്‌ഘാടനം ചെയ്തു.",
        thumb: "assets/img/Pastevents/264.jpg",
      },
      {
        src: "assets/img/Pastevents/246.jpg",
        caption:
          "ആരോഗ്യ മേഖലയിൽ നൈതികതയും ജീവകാരുണ്യവും സംഗമിച്ച അപൂർവ്വം ആതുരാലയങ്ങളിലൊന്നാണ് നെയ്യാറ്റിൻകര നിംസ് മെഡിസിറ്റിയെന്ന് പി.കെ. ബഷീർ എം.എൽ.എ.പ്രസ്താവിച്ചു. നിംസിൽ ലോക  ഹൃദയ ദിനത്തോടനുബന്ധിച്ചു ദ്വിദിന സൗജന്യ ഹൃദ്രോഗ നിർണ്ണയ ക്യാമ്പ് ഉദ്ഘാടനം ചെയ്തു സംസാരിക്കുകയായിരുന്നു അദ്ദേഹം. ",
        thumb: "assets/img/Pastevents/246.jpg",
      },
      {
        src: "assets/img/Pastevents/245.jpg",
        caption: "",
        thumb: "assets/img/Pastevents/245.jpg",
      },
      {
        src: "assets/img/Heart to Heart/1.jpg",
        caption: "1",
        thumb: "assets/img/Heart to Heart/1.jpg",
      },
      {
        src: "assets/img/Heart to Heart/2.jpg",
        caption: "2",
        thumb: "assets/img/Heart to Heart/2.jpg",
      },
      // {src:'assets/img/Heart to Heart/3.jpg',caption: '3',thumb:'assets/img/Heart to Heart/3.jpg'},
      {
        src: "assets/img/Heart to Heart/4.jpg",
        caption: "4",
        thumb: "assets/img/Heart to Heart/4.jpg",
      },
      {
        src: "assets/img/Heart to Heart/5.jpg",
        caption: "5",
        thumb: "assets/img/Heart to Heart/5.jpg",
      },
      {
        src: "assets/img/Heart to Heart/6.jpg",
        caption: "6",
        thumb: "assets/img/Heart to Heart/6.jpg",
      },
      {
        src: "assets/img/Heart to Heart/7.jpg",
        caption: "7",
        thumb: "assets/img/Heart to Heart/7.jpg",
      },
      {
        src: "assets/img/Heart to Heart/8.jpg",
        caption: "8",
        thumb: "assets/img/Heart to Heart/8.jpg",
      },
      {
        src: "assets/img/Heart to Heart/9.jpg",
        caption: "9",
        thumb: "assets/img/Heart to Heart/9.jpg",
      },
      {
        src: "assets/img/Heart to Heart/10.jpg",
        caption: "10",
        thumb: "assets/img/Heart to Heart/10.jpg",
      },
      {
        src: "assets/img/Heart to Heart/11.jpg",
        caption: "11",
        thumb: "assets/img/Heart to Heart/11.jpg",
      },
      {
        src: "assets/img/Heart to Heart/12.jpg",
        caption: "12",
        thumb: "assets/img/Heart to Heart/12.jpg",
      },
      {
        src: "assets/img/Heart to Heart/13.jpg",
        caption: "13",
        thumb: "assets/img/Heart to Heart/13.jpg",
      },
      {
        src: "assets/img/Heart to Heart/14.jpg",
        caption: "14",
        thumb: "assets/img/Heart to Heart/14.jpg",
      },
      {
        src: "assets/img/Heart to Heart/15.jpg",
        caption: "15",
        thumb: "assets/img/Heart to Heart/15.jpg",
      },
      {
        src: "assets/img/Heart to Heart/16.jpg",
        caption: "16",
        thumb: "assets/img/Heart to Heart/16.jpg",
      },
      {
        src: "assets/img/Heart to Heart/17.jpg",
        caption: "17",
        thumb: "assets/img/Heart to Heart/17.jpg",
      },
      {
        src: "assets/img/Heart to Heart/18.jpg",
        caption: "18",
        thumb: "assets/img/Heart to Heart/18.jpg",
      },
      {
        src: "assets/img/Heart to Heart/19.jfif",
        caption: "19",
        thumb: "assets/img/Heart to Heart/19.jfif",
      },
    ];

  CIVIL_GALLERY: Array<{ src: string; caption: string; thumb: string }> = [
    {
      src: "assets/img/Civil/1.jpg",
      caption: "1",
      thumb: "assets/img/Civil/1.jpg",
    },
    {
      src: "assets/img/Civil/2.jpg",
      caption: "2",
      thumb: "assets/img/Civil/2.jpg",
    },
    {
      src: "assets/img/Civil/3.jpg",
      caption: "3",
      thumb: "assets/img/Civil/3.jpg",
    },
    // {src:'assets/img/Civil/4.jpg',caption: '4',thumb:'assets/img/Civil/4.jpg'},
    // {src:'assets/img/Civil/5.jpg',caption: '5',thumb:'assets/img/Civil/5.jpg'},
    {
      src: "assets/img/Civil/6.jpg",
      caption: "6",
      thumb: "assets/img/Civil/6.jpg",
    },
    {
      src: "assets/img/Civil/7.jpg",
      caption: "7",
      thumb: "assets/img/Civil/7.jpg",
    },
    {
      src: "assets/img/Civil/8.jpg",
      caption: "8",
      thumb: "assets/img/Civil/8.jpg",
    },
    {
      src: "assets/img/Civil/9.jpg",
      caption: "9",
      thumb: "assets/img/Civil/9.jpg",
    },
    {
      src: "assets/img/Civil/10.jpg",
      caption: "10",
      thumb: "assets/img/Civil/10.jpg",
    },
    {
      src: "assets/img/Civil/11.jpg",
      caption: "11",
      thumb: "assets/img/Civil/11.jpg",
    },
    {
      src: "assets/img/Civil/12.jpg",
      caption: "12",
      thumb: "assets/img/Civil/12.jpg",
    },
    // {src:'assets/img/Civil/13.jpg',caption:'13',thumb:'assets/img/Civil/13.jpg'},
    {
      src: "assets/img/Civil/14.jpg",
      caption: "14",
      thumb: "assets/img/Civil/14.jpg",
    },
    // {src:'assets/img/Civil/15.jpg',caption: '15',thumb:'assets/img/Civil/15.jpg'},
    {
      src: "assets/img/Civil/16.jpg",
      caption: "16",
      thumb: "assets/img/Civil/16.jpg",
    },
    //{src:'assets/img/Civil/17.jpg',caption: '17',thumb:'assets/img/Civil/17.jpg'},
    //{src:'assets/img/Civil/18.jpg',caption: '18',thumb:'assets/img/Civil/18.jpg'},
    //{src:'assets/img/Civil/19.jpg',caption: '19',thumb:'assets/img/Civil/19.jpg'},
    {
      src: "assets/img/Civil/20.jpg",
      caption: "20",
      thumb: "assets/img/Civil/20.jpg",
    },
    {
      src: "assets/img/Civil/21.jpg",
      caption: "21",
      thumb: "assets/img/Civil/21.jpg",
    },
    {
      src: "assets/img/Civil/22.jpg",
      caption: "22",
      thumb: "assets/img/Civil/22.jpg",
    },
    {
      src: "assets/img/Civil/23.jpg",
      caption: "23",
      thumb: "assets/img/Civil/23.jpg",
    },
    {
      src: "assets/img/Civil/24.jpg",
      caption: "24",
      thumb: "assets/img/Civil/24.jpg",
    },
    {
      src: "assets/img/Civil/25.jpg",
      caption: "25",
      thumb: "assets/img/Civil/25.jpg",
    },
    {
      src: "assets/img/Civil/26.jpg",
      caption: "26",
      thumb: "assets/img/Civil/26.jpg",
    },
    {
      src: "assets/img/Civil/27.jpg",
      caption: "27",
      thumb: "assets/img/Civil/27.jpg",
    },
    {
      src: "assets/img/Civil/28.jpg",
      caption: "28",
      thumb: "assets/img/Civil/28.jpg",
    },
    {
      src: "assets/img/Civil/29.jpg",
      caption: "29",
      thumb: "assets/img/Civil/29.jpg",
    },
    {
      src: "assets/img/Civil/30.jpg",
      caption: "30",
      thumb: "assets/img/Civil/30.jpg",
    },
    {
      src: "assets/img/Civil/31.jpg",
      caption: "31",
      thumb: "assets/img/Civil/31.jpg",
    },
    {
      src: "assets/img/Civil/32.jpg",
      caption: "32",
      thumb: "assets/img/Civil/32.jpg",
    },
    {
      src: "assets/img/Civil/33.jpg",
      caption: "33",
      thumb: "assets/img/Civil/33.jpg",
    },
    {
      src: "assets/img/Civil/34.jpg",
      caption: "34",
      thumb: "assets/img/Civil/34.jpg",
    },
    {
      src: "assets/img/Civil/36.jpg",
      caption: "36",
      thumb: "assets/img/Civil/36.jpg",
    },
    {
      src: "assets/img/Civil/37.jpg",
      caption: "37",
      thumb: "assets/img/Civil/37.jpg",
    },
    {
      src: "assets/img/Civil/38.png",
      caption: "38",
      thumb: "assets/img/Civil/38.png",
    },
    {
      src: "assets/img/Civil/39.jpg",
      caption: "39",
      thumb: "assets/img/Civil/39.jpg",
    },
    {
      src: "assets/img/Civil/40.jpg",
      caption: "40",
      thumb: "assets/img/Civil/40.jpg",
    },
    {
      src: "assets/img/Civil/41.jpg",
      caption: "41",
      thumb: "assets/img/Civil/41.jpg",
    },
    {
      src: "assets/img/Civil/42.jpg",
      caption: "42",
      thumb: "assets/img/Civil/42.jpg",
    },
    {
      src: "assets/img/Civil/43.jpg",
      caption: "43",
      thumb: "assets/img/Civil/43.jpg",
    },
    {
      src: "assets/img/Civil/44.jpg",
      caption: "44",
      thumb: "assets/img/Civil/44.jpg",
    },
    {
      src: "assets/img/Civil/45.jpg",
      caption: "45",
      thumb: "assets/img/Civil/45.jpg",
    },
    {
      src: "assets/img/Civil/46.jpg",
      caption: "46",
      thumb: "assets/img/Civil/46.jpg",
    },
    {
      src: "assets/img/Civil/47.jpg",
      caption: "47",
      thumb: "assets/img/Civil/47.jpg",
    },
    {
      src: "assets/img/Civil/48.jpg",
      caption: "48",
      thumb: "assets/img/Civil/48.jpg",
    },
    {
      src: "assets/img/Civil/49.jpg",
      caption: "49",
      thumb: "assets/img/Civil/49.jpg",
    },
    {
      src: "assets/img/Civil/50.jpg",
      caption: "50",
      thumb: "assets/img/Civil/50.jpg",
    },
    {
      src: "assets/img/Civil/51.jpg",
      caption: "51",
      thumb: "assets/img/Civil/51.jpg",
    },
    {
      src: "assets/img/Civil/52.jpg",
      caption: "52",
      thumb: "assets/img/Civil/52.jpg",
    },
    {
      src: "assets/img/Civil/53.jpg",
      caption: "53",
      thumb: "assets/img/Civil/53.jpg",
    },
    {
      src: "assets/img/Civil/54.jpg",
      caption: "54",
      thumb: "assets/img/Civil/54.jpg",
    },
    {
      src: "assets/img/Civil/55.jpg",
      caption: "55",
      thumb: "assets/img/Civil/55.jpg",
    },
    {
      src: "assets/img/Civil/56.jpg",
      caption: "56",
      thumb: "assets/img/Civil/56.jpg",
    },
    {
      src: "assets/img/Civil/57.jpg",
      caption: "57",
      thumb: "assets/img/Civil/57.jpg",
    },
    {
      src: "assets/img/Civil/58.jpg",
      caption: "58",
      thumb: "assets/img/Civil/58.jpg",
    },
  ];

  SAP_GALLERY: Array<{ src: string; caption: string; thumb: string }> = [
    {
      src: "assets/img/Sapling/219.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/219.jpeg",
    },
    {
      src: "assets/img/Sapling/220.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/220.jpeg",
    },
    {
      src: "assets/img/Sapling/221.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/221.jpeg",
    },
    {
      src: "assets/img/Sapling/222.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/222.jpeg",
    },
    {
      src: "assets/img/Sapling/223.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/223.jpeg",
    },
    {
      src: "assets/img/Sapling/224.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/224.jpeg",
    },
    {
      src: "assets/img/Sapling/225.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/225.jpeg",
    },
    {
      src: "assets/img/Sapling/226.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/226.jpeg",
    },
    {
      src: "assets/img/Sapling/227.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/227.jpeg",
    },
    {
      src: "assets/img/Sapling/228.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/228.jpeg",
    },
    {
      src: "assets/img/Sapling/229.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/229.jpeg",
    },
    {
      src: "assets/img/Sapling/230.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/230.jpeg",
    },
    {
      src: "assets/img/Sapling/231.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/231.jpeg",
    },
    {
      src: "assets/img/Sapling/232.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/232.jpeg",
    },
    {
      src: "assets/img/Sapling/233.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/233.jpeg",
    },
    {
      src: "assets/img/Sapling/234.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/234.jpeg",
    },
    {
      src: "assets/img/Sapling/235.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/235.jpeg",
    },
    {
      src: "assets/img/Sapling/215.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/215.jpeg",
    },
    {
      src: "assets/img/Sapling/216.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/216.jpeg",
    },
    {
      src: "assets/img/Sapling/217.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/217.jpeg",
    },
    {
      src: "assets/img/Sapling/218.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/218.jpeg",
    },
    {
      src: "assets/img/Sapling/198.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/198.jpeg",
    },
    {
      src: "assets/img/Sapling/199.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/199.jpeg",
    },
    {
      src: "assets/img/Sapling/200.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/200.jpeg",
    },
    {
      src: "assets/img/Sapling/201.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/201.jpeg",
    },
    {
      src: "assets/img/Sapling/202.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/202.jpeg",
    },
    {
      src: "assets/img/Sapling/203.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/203.jpeg",
    },
    {
      src: "assets/img/Sapling/204.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/204.jpeg",
    },
    {
      src: "assets/img/Sapling/205.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/205.jpeg",
    },
    {
      src: "assets/img/Sapling/206.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/206.jpeg",
    },
    {
      src: "assets/img/Sapling/207.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/207.jpeg",
    },
    {
      src: "assets/img/Sapling/208.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/208.jpeg",
    },
    {
      src: "assets/img/Sapling/209.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/209.jpeg",
    },
    {
      src: "assets/img/Sapling/210.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/210.jpeg",
    },
    {
      src: "assets/img/Sapling/211.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/211.jpeg",
    },
    {
      src: "assets/img/Sapling/212.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/212.jpeg",
    },
    {
      src: "assets/img/Sapling/213.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/213.jpeg",
    },
    {
      src: "assets/img/Sapling/214.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/214.jpeg",
    },
    {
      src: "assets/img/Sapling/194.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/194.jpeg",
    },
    {
      src: "assets/img/Sapling/195.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/195.jpeg",
    },
    {
      src: "assets/img/Sapling/196.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/196.jpeg",
    },
    {
      src: "assets/img/Sapling/197.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/197.jpeg",
    },
    {
      src: "assets/img/Sapling/192.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/192.jpeg",
    },
    {
      src: "assets/img/Sapling/193.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/193.jpeg",
    },
    {
      src: "assets/img/Sapling/184.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/184.jpeg",
    },
    {
      src: "assets/img/Sapling/185.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/185.jpeg",
    },
    {
      src: "assets/img/Sapling/186.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/186.jpeg",
    },
    {
      src: "assets/img/Sapling/187.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/187.jpeg",
    },
    {
      src: "assets/img/Sapling/188.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/188.jpeg",
    },
    {
      src: "assets/img/Sapling/189.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/189.jpeg",
    },
    {
      src: "assets/img/Sapling/190.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/190.jpeg",
    },
    {
      src: "assets/img/Sapling/191.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/191.jpeg",
    },
    {
      src: "assets/img/Sapling/182.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/182.jpeg",
    },
    {
      src: "assets/img/Sapling/183.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/183.jpeg",
    },
    {
      src: "assets/img/Sapling/164.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/164.jpeg",
    },
    {
      src: "assets/img/Sapling/165.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/165.jpeg",
    },
    {
      src: "assets/img/Sapling/166.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/166.jpeg",
    },
    {
      src: "assets/img/Sapling/167.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/167.jpeg",
    },
    {
      src: "assets/img/Sapling/168.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/168.jpeg",
    },
    {
      src: "assets/img/Sapling/169.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/169.jpeg",
    },
    {
      src: "assets/img/Sapling/170.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/170.jpeg",
    },
    {
      src: "assets/img/Sapling/171.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/171.jpeg",
    },
    {
      src: "assets/img/Sapling/172.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/172.jpeg",
    },
    {
      src: "assets/img/Sapling/173.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/173.jpeg",
    },
    {
      src: "assets/img/Sapling/174.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/174.jpeg",
    },
    {
      src: "assets/img/Sapling/175.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/175.jpeg",
    },

    {
      src: "assets/img/Sapling/176.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/176.jpeg",
    },
    {
      src: "assets/img/Sapling/177.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/177.jpeg",
    },
    {
      src: "assets/img/Sapling/178.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/178.jpeg",
    },
    {
      src: "assets/img/Sapling/179.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/179.jpeg",
    },
    {
      src: "assets/img/Sapling/180.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/180.jpeg",
    },
    {
      src: "assets/img/Sapling/181.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/181.jpeg",
    },
    {
      src: "assets/img/Sapling/154.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/154.jpeg",
    },
    {
      src: "assets/img/Sapling/155.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/155.jpeg",
    },
    {
      src: "assets/img/Sapling/156.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/156.jpeg",
    },
    {
      src: "assets/img/Sapling/157.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/157.jpeg",
    },
    {
      src: "assets/img/Sapling/158.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/158.jpeg",
    },
    {
      src: "assets/img/Sapling/159.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/159.jpeg",
    },
    {
      src: "assets/img/Sapling/160.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/160.jpeg",
    },
    {
      src: "assets/img/Sapling/161.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/161.jpeg",
    },
    {
      src: "assets/img/Sapling/162.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/162.jpeg",
    },
    {
      src: "assets/img/Sapling/163.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/163.jpeg",
    },
    {
      src: "assets/img/Sapling/152.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/152.jpeg",
    },
    {
      src: "assets/img/Sapling/153.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/153.jpeg",
    },
    {
      src: "assets/img/Sapling/149.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/149.jpeg",
    },
    {
      src: "assets/img/Sapling/150.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/150.jpeg",
    },
    {
      src: "assets/img/Sapling/151.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/151.jpeg",
    },
    {
      src: "assets/img/Sapling/146.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/146.jpeg",
    },
    {
      src: "assets/img/Sapling/147.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/147.jpeg",
    },
    {
      src: "assets/img/Sapling/148.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/148.jpeg",
    },
    {
      src: "assets/img/Sapling/144.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/144.jpeg",
    },
    {
      src: "assets/img/Sapling/145.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/145.jpeg",
    },
    {
      src: "assets/img/Sapling/142.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/142.jpeg",
    },
    {
      src: "assets/img/Sapling/143.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/143.jpeg",
    },
    {
      src: "assets/img/Sapling/136.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/136.jpeg",
    },
    {
      src: "assets/img/Sapling/137.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/137.jpeg",
    },
    {
      src: "assets/img/Sapling/138.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/138.jpeg",
    },
    {
      src: "assets/img/Sapling/139.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/139.jpeg",
    },
    {
      src: "assets/img/Sapling/140.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/140.jpeg",
    },
    {
      src: "assets/img/Sapling/141.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/141.jpeg",
    },
    {
      src: "assets/img/Sapling/135.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/135.jpeg",
    },
    {
      src: "assets/img/Sapling/133.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/133.jpeg",
    },
    {
      src: "assets/img/Sapling/134.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/134.jpeg",
    },
    {
      src: "assets/img/Sapling/15.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/15.jpeg",
    },
    {
      src: "assets/img/Sapling/16.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/16.jpeg",
    },
    {
      src: "assets/img/Sapling/17.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/17.jpeg",
    },
    {
      src: "assets/img/Sapling/18.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/18.jpeg",
    },
    {
      src: "assets/img/Sapling/19.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/19.jpeg",
    },
    {
      src: "assets/img/Sapling/20.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/20.jpeg",
    },
    {
      src: "assets/img/Sapling/21.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/21.jpeg",
    },
    {
      src: "assets/img/Sapling/22.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/22.jpeg",
    },
    {
      src: "assets/img/Sapling/23.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/23.jpeg",
    },
    {
      src: "assets/img/Sapling/24.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/24.jpeg",
    },
    {
      src: "assets/img/Sapling/25.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/25.jpeg",
    },
    {
      src: "assets/img/Sapling/26.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/26.jpeg",
    },
    {
      src: "assets/img/Sapling/27.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/27.jpeg",
    },
    {
      src: "assets/img/Sapling/28.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/28.jpeg",
    },
    {
      src: "assets/img/Sapling/29.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/29.jpeg",
    },
    {
      src: "assets/img/Sapling/30.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/30.jpeg",
    },
    {
      src: "assets/img/Sapling/31.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/31.jpeg",
    },
    {
      src: "assets/img/Sapling/32.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/32.jpeg",
    },
    {
      src: "assets/img/Sapling/33.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/33.jpeg",
    },
    {
      src: "assets/img/Sapling/34.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/34.jpeg",
    },
    {
      src: "assets/img/Sapling/35.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/35.jpeg",
    },
    {
      src: "assets/img/Sapling/36.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/36.jpeg",
    },
    {
      src: "assets/img/Sapling/37.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/37.jpeg",
    },
    {
      src: "assets/img/Sapling/38.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/38.jpeg",
    },
    {
      src: "assets/img/Sapling/39.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/39.jpeg",
    },
    {
      src: "assets/img/Sapling/40.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/40.jpeg",
    },
    {
      src: "assets/img/Sapling/41.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/41.jpeg",
    },
    {
      src: "assets/img/Sapling/42.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/42.jpeg",
    },
    {
      src: "assets/img/Sapling/43.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/43.jpeg",
    },
    {
      src: "assets/img/Sapling/44.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/44.jpeg",
    },
    {
      src: "assets/img/Sapling/45.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/45.jpeg",
    },
    {
      src: "assets/img/Sapling/46.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/46.jpeg",
    },
    {
      src: "assets/img/Sapling/47.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/47.jpeg",
    },
    {
      src: "assets/img/Sapling/48.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/48.jpeg",
    },
    {
      src: "assets/img/Sapling/49.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/49.jpeg",
    },
    {
      src: "assets/img/Sapling/50.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/50.jpeg",
    },
    {
      src: "assets/img/Sapling/51.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/51.jpeg",
    },
    {
      src: "assets/img/Sapling/52.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/52.jpeg",
    },
    {
      src: "assets/img/Sapling/53.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/53.jpeg",
    },
    {
      src: "assets/img/Sapling/54.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/54.jpeg",
    },
    {
      src: "assets/img/Sapling/55.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/55.jpeg",
    },
    {
      src: "assets/img/Sapling/56.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/56.jpeg",
    },
    {
      src: "assets/img/Sapling/57.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/57.jpeg",
    },
    {
      src: "assets/img/Sapling/58.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/58.jpeg",
    },
    {
      src: "assets/img/Sapling/59.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/59.jpeg",
    },
    {
      src: "assets/img/Sapling/60.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/60.jpeg",
    },
    {
      src: "assets/img/Sapling/61.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/61.jpeg",
    },
    {
      src: "assets/img/Sapling/62.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/62.jpeg",
    },
    {
      src: "assets/img/Sapling/63.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/63.jpeg",
    },
    {
      src: "assets/img/Sapling/64.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/64.jpeg",
    },
    {
      src: "assets/img/Sapling/65.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/65.jpeg",
    },
    {
      src: "assets/img/Sapling/66.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/66.jpeg",
    },
    {
      src: "assets/img/Sapling/67.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/67.jpeg",
    },
    {
      src: "assets/img/Sapling/68.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/68.jpeg",
    },
    {
      src: "assets/img/Sapling/69.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/69.jpeg",
    },
    {
      src: "assets/img/Sapling/70.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/70.jpeg",
    },
    {
      src: "assets/img/Sapling/71.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/71.jpeg",
    },
    {
      src: "assets/img/Sapling/72.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/72.jpeg",
    },
    {
      src: "assets/img/Sapling/73.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/73.jpeg",
    },
    {
      src: "assets/img/Sapling/74.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/74.jpeg",
    },
    {
      src: "assets/img/Sapling/75.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/75.jpeg",
    },
    {
      src: "assets/img/Sapling/76.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/76.jpeg",
    },
    {
      src: "assets/img/Sapling/77.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/77.jpeg",
    },
    {
      src: "assets/img/Sapling/78.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/78.jpeg",
    },
    {
      src: "assets/img/Sapling/79.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/79.jpeg",
    },
    {
      src: "assets/img/Sapling/80.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/80.jpeg",
    },
    {
      src: "assets/img/Sapling/81.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/81.jpeg",
    },
    {
      src: "assets/img/Sapling/82.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/82.jpeg",
    },
    {
      src: "assets/img/Sapling/83.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/83.jpeg",
    },
    {
      src: "assets/img/Sapling/84.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/84.jpeg",
    },
    {
      src: "assets/img/Sapling/85.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/85.jpeg",
    },
    {
      src: "assets/img/Sapling/86.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/86.jpeg",
    },
    {
      src: "assets/img/Sapling/87.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/87.jpeg",
    },
    {
      src: "assets/img/Sapling/88.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/88.jpeg",
    },
    {
      src: "assets/img/Sapling/89.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/89.jpeg",
    },
    {
      src: "assets/img/Sapling/90.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/90.jpeg",
    },
    {
      src: "assets/img/Sapling/91.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/91.jpeg",
    },
    {
      src: "assets/img/Sapling/92.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/92.jpeg",
    },
    {
      src: "assets/img/Sapling/93.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/93.jpeg",
    },
    {
      src: "assets/img/Sapling/94.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/94.jpeg",
    },
    {
      src: "assets/img/Sapling/95.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/95.jpeg",
    },
    {
      src: "assets/img/Sapling/96.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/96.jpeg",
    },
    {
      src: "assets/img/Sapling/97.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/97.jpeg",
    },
    {
      src: "assets/img/Sapling/98.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/98.jpeg",
    },
    {
      src: "assets/img/Sapling/99.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/99.jpeg",
    },
    {
      src: "assets/img/Sapling/100.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/100.jpeg",
    },
    {
      src: "assets/img/Sapling/101.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/101.jpeg",
    },
    {
      src: "assets/img/Sapling/102.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/102.jpeg",
    },
    {
      src: "assets/img/Sapling/103.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/103.jpeg",
    },
    {
      src: "assets/img/Sapling/104.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/104.jpeg",
    },
    {
      src: "assets/img/Sapling/105.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/105.jpeg",
    },
    {
      src: "assets/img/Sapling/106.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/106.jpeg",
    },
    {
      src: "assets/img/Sapling/107.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/107.jpeg",
    },
    {
      src: "assets/img/Sapling/108.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/108.jpeg",
    },
    {
      src: "assets/img/Sapling/109.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/109.jpeg",
    },
    {
      src: "assets/img/Sapling/110.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/110.jpeg",
    },
    {
      src: "assets/img/Sapling/111.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/111.jpeg",
    },
    {
      src: "assets/img/Sapling/112.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/112.jpeg",
    },
    {
      src: "assets/img/Sapling/113.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/113.jpeg",
    },
    {
      src: "assets/img/Sapling/114.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/114.jpeg",
    },
    {
      src: "assets/img/Sapling/115.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/115.jpeg",
    },
    {
      src: "assets/img/Sapling/116.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/116.jpeg",
    },
    {
      src: "assets/img/Sapling/117.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/117.jpeg",
    },
    {
      src: "assets/img/Sapling/118.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/118.jpeg",
    },
    {
      src: "assets/img/Sapling/119.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/119.jpeg",
    },
    {
      src: "assets/img/Sapling/120.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/120.jpeg",
    },
    {
      src: "assets/img/Sapling/121.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/121.jpeg",
    },
    {
      src: "assets/img/Sapling/122.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/122.jpeg",
    },
    {
      src: "assets/img/Sapling/123.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/123.jpeg",
    },
    {
      src: "assets/img/Sapling/124.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/124.jpeg",
    },
    {
      src: "assets/img/Sapling/125.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/125.jpeg",
    },
    {
      src: "assets/img/Sapling/126.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/126.jpeg",
    },
    {
      src: "assets/img/Sapling/127.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/127.jpeg",
    },
    {
      src: "assets/img/Sapling/128.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/128.jpeg",
    },
    {
      src: "assets/img/Sapling/129.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/129.jpeg",
    },
    {
      src: "assets/img/Sapling/130.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/130.jpeg",
    },
    {
      src: "assets/img/Sapling/131.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/131.jpeg",
    },
    {
      src: "assets/img/Sapling/132.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/132.jpeg",
    },

    {
      src: "assets/img/Sapling/14.jpg",
      caption:
        "Dr. Jhansi K. P, Senior Gynaecologist, NIMS Medicity presenting a plant sapling to Mrs. Haripriya.",
      thumb: "assets/img/Sapling/14.jpg",
    },
    {
      src: "assets/img/Sapling/12.jpg",
      caption:
        "'ഒരു കുഞ്ഞ് ഒരു മരം' എന്ന പദ്ധതിയിൽ ഒരു കുഞ്ഞു നിംസിൽ ജനിക്കുമ്പോൾ ഒരു മരം ഭൂമിക്ക് എന്ന പദ്ധതി ആവിഷ്കരിച്ച് വിജയകരമായി നടത്തിവരുന്നതിന്റെ ഭാഗമായി ഈ ഭൗമദിനത്തിൽ 2190 മത്തെ കുഞ്ഞിന് വൃക്ഷ തൈ പ്രശസ്ത മജീഷ്യനും സാമൂഹിക പ്രവർത്തകനുമായ ശ്രീ ഗോപിനാഥ് മുതുകാട് കൈമാറിയപ്പോൾ..",
      thumb: "assets/img/Sapling/12.jpg",
    },
    {
      src: "assets/img/Sapling/13.jpg",
      caption:
        "'ഒരു കുഞ്ഞ് ഒരു മരം' എന്ന പദ്ധതിയിൽ ഒരു കുഞ്ഞു നിംസിൽ ജനിക്കുമ്പോൾ ഒരു മരം ഭൂമിക്ക് എന്ന പദ്ധതി ആവിഷ്കരിച്ച് വിജയകരമായി നടത്തിവരുന്നതിന്റെ ഭാഗമായി ഈ ഭൗമദിനത്തിൽ 2190 മത്തെ കുഞ്ഞിന് വൃക്ഷ തൈ പ്രശസ്ത മജീഷ്യനും സാമൂഹിക പ്രവർത്തകനുമായ ശ്രീ ഗോപിനാഥ് മുതുകാട് കൈമാറിയപ്പോൾ..",
      thumb: "assets/img/Sapling/13.jpg",
    },
    {
      src: "assets/img/Sapling/1.jpg",
      caption: "1",
      thumb: "assets/img/Sapling/1.jpg",
    },
    {
      src: "assets/img/Sapling/2.jpg",
      caption: "2",
      thumb: "assets/img/Sapling/2.jpg",
    },
    {
      src: "assets/img/Sapling/3.JPG",
      caption: "3",
      thumb: "assets/img/Sapling/3.JPG",
    },
    {
      src: "assets/img/Sapling/4.JPG",
      caption: "4",
      thumb: "assets/img/Sapling/4.JPG",
    },
    {
      src: "assets/img/Sapling/5.JPG",
      caption: "5",
      thumb: "assets/img/Sapling/5.JPG",
    },
    {
      src: "assets/img/Sapling/6.JPG",
      caption: "6",
      thumb: "assets/img/Sapling/6.JPG",
    },
    {
      src: "assets/img/Sapling/7.JPG",
      caption: "7",
      thumb: "assets/img/Sapling/7.JPG",
    },
    {
      src: "assets/img/Sapling/8.JPG",
      caption: "8",
      thumb: "assets/img/Sapling/8.JPG",
    },
    {
      src: "assets/img/Sapling/9.jpg",
      caption: "9",
      thumb: "assets/img/Sapling/9.jpg",
    },
    {
      src: "assets/img/Sapling/10.jpg",
      caption: "10",
      thumb: "assets/img/Sapling/10.jpg",
    },
  ];

  EDU_GALLERY: Array<{ src: string; caption: string; thumb: string }> = [
    {
      src: "assets/img/edu/2.jpg",
      caption:
        "ശ്രീചിത്രാ ഹോമിലെ മിടുക്കരായ വിദ്യാർത്ഥികൾക്കാണ് നൂറുൽ ഇസ്ലാം സർവ്വകലാശാലയിൽ സൗജന്യ ഉന്നത വിദ്യാഭ്യാസം ഒരുക്കുന്നത്. ഐ.എസ്. ആർ. ഒ. ചെയർമാൻ ഡോ. എസ്. സോമനാഥ് സ്കോളർഷിപ്പ് പദ്ധതിയുടെ ഉത്ഘാടനം നിർവഹിച്ചു.  ബഹുമാനപ്പെട്ട വിദ്യാഭ്യാസ വകുപ്പുമന്ത്രി ശ്രീ.വി. ശിവൻകുട്ടി , ശ്രീ. ശ്രീകുമാരൻ തമ്പി , ശ്രീ. രാജീവ് ചന്ദ്രശേഖർ , ശ്രീ. ശശി തരൂർ , ശ്രീ. പന്ന്യൻ രവീന്ദ്രൻ , നിംസ് കോളേജ് ഓഫ് നഴ്സിംഗ് പ്രിൻസിപ്പൽ ശ്രീമതി. ജോസഫൈൻ വിനിത തുടങ്ങി രാഷ്ട്രീയ സാമൂഹ്യ സാംസ്കാരിക കലാ രംഗത്തെ പ്രമുഖർ ചടങ്ങിൽ സന്നിഹിതരായിരുന്നു. ",
      thumb: "assets/img/edu/2.jpg",
    },
    {
      src: "assets/img/edu/3.jpg",
      caption:
        "ശ്രീചിത്രാ ഹോമിലെ മിടുക്കരായ വിദ്യാർത്ഥികൾക്കാണ് നൂറുൽ ഇസ്ലാം സർവ്വകലാശാലയിൽ സൗജന്യ ഉന്നത വിദ്യാഭ്യാസം ഒരുക്കുന്നത്. ഐ.എസ്. ആർ. ഒ. ചെയർമാൻ ഡോ. എസ്. സോമനാഥ് സ്കോളർഷിപ്പ് പദ്ധതിയുടെ ഉത്ഘാടനം നിർവഹിച്ചു.  ബഹുമാനപ്പെട്ട വിദ്യാഭ്യാസ വകുപ്പുമന്ത്രി ശ്രീ.വി. ശിവൻകുട്ടി , ശ്രീ. ശ്രീകുമാരൻ തമ്പി , ശ്രീ. രാജീവ് ചന്ദ്രശേഖർ , ശ്രീ. ശശി തരൂർ , ശ്രീ. പന്ന്യൻ രവീന്ദ്രൻ , നിംസ് കോളേജ് ഓഫ് നഴ്സിംഗ് പ്രിൻസിപ്പൽ ശ്രീമതി. ജോസഫൈൻ വിനിത തുടങ്ങി രാഷ്ട്രീയ സാമൂഹ്യ സാംസ്കാരിക കലാ രംഗത്തെ പ്രമുഖർ ചടങ്ങിൽ സന്നിഹിതരായിരുന്നു. ",
      thumb: "assets/img/edu/3.jpg",
    },
    {
      src: "assets/img/edu/4.jpg",
      caption:
        "ശ്രീചിത്രാ ഹോമിലെ മിടുക്കരായ വിദ്യാർത്ഥികൾക്കാണ് നൂറുൽ ഇസ്ലാം സർവ്വകലാശാലയിൽ സൗജന്യ ഉന്നത വിദ്യാഭ്യാസം ഒരുക്കുന്നത്. ഐ.എസ്. ആർ. ഒ. ചെയർമാൻ ഡോ. എസ്. സോമനാഥ് സ്കോളർഷിപ്പ് പദ്ധതിയുടെ ഉത്ഘാടനം നിർവഹിച്ചു.  ബഹുമാനപ്പെട്ട വിദ്യാഭ്യാസ വകുപ്പുമന്ത്രി ശ്രീ.വി. ശിവൻകുട്ടി , ശ്രീ. ശ്രീകുമാരൻ തമ്പി , ശ്രീ. രാജീവ് ചന്ദ്രശേഖർ , ശ്രീ. ശശി തരൂർ , ശ്രീ. പന്ന്യൻ രവീന്ദ്രൻ , നിംസ് കോളേജ് ഓഫ് നഴ്സിംഗ് പ്രിൻസിപ്പൽ ശ്രീമതി. ജോസഫൈൻ വിനിത തുടങ്ങി രാഷ്ട്രീയ സാമൂഹ്യ സാംസ്കാരിക കലാ രംഗത്തെ പ്രമുഖർ ചടങ്ങിൽ സന്നിഹിതരായിരുന്നു. ",
      thumb: "assets/img/edu/4.jpg",
    },
    {
      src: "assets/img/edu/5.jpg",
      caption:
        "ശ്രീചിത്രാ ഹോമിലെ മിടുക്കരായ വിദ്യാർത്ഥികൾക്കാണ് നൂറുൽ ഇസ്ലാം സർവ്വകലാശാലയിൽ സൗജന്യ ഉന്നത വിദ്യാഭ്യാസം ഒരുക്കുന്നത്. ഐ.എസ്. ആർ. ഒ. ചെയർമാൻ ഡോ. എസ്. സോമനാഥ് സ്കോളർഷിപ്പ് പദ്ധതിയുടെ ഉത്ഘാടനം നിർവഹിച്ചു.  ബഹുമാനപ്പെട്ട വിദ്യാഭ്യാസ വകുപ്പുമന്ത്രി ശ്രീ.വി. ശിവൻകുട്ടി , ശ്രീ. ശ്രീകുമാരൻ തമ്പി , ശ്രീ. രാജീവ് ചന്ദ്രശേഖർ , ശ്രീ. ശശി തരൂർ , ശ്രീ. പന്ന്യൻ രവീന്ദ്രൻ , നിംസ് കോളേജ് ഓഫ് നഴ്സിംഗ് പ്രിൻസിപ്പൽ ശ്രീമതി. ജോസഫൈൻ വിനിത തുടങ്ങി രാഷ്ട്രീയ സാമൂഹ്യ സാംസ്കാരിക കലാ രംഗത്തെ പ്രമുഖർ ചടങ്ങിൽ സന്നിഹിതരായിരുന്നു. ",
      thumb: "assets/img/edu/5.jpg",
    },
    {
      src: "assets/img/edu/6.jpg",
      caption:
        "ശ്രീചിത്രാ ഹോമിലെ മിടുക്കരായ വിദ്യാർത്ഥികൾക്കാണ് നൂറുൽ ഇസ്ലാം സർവ്വകലാശാലയിൽ സൗജന്യ ഉന്നത വിദ്യാഭ്യാസം ഒരുക്കുന്നത്. ഐ.എസ്. ആർ. ഒ. ചെയർമാൻ ഡോ. എസ്. സോമനാഥ് സ്കോളർഷിപ്പ് പദ്ധതിയുടെ ഉത്ഘാടനം നിർവഹിച്ചു.  ബഹുമാനപ്പെട്ട വിദ്യാഭ്യാസ വകുപ്പുമന്ത്രി ശ്രീ.വി. ശിവൻകുട്ടി , ശ്രീ. ശ്രീകുമാരൻ തമ്പി , ശ്രീ. രാജീവ് ചന്ദ്രശേഖർ , ശ്രീ. ശശി തരൂർ , ശ്രീ. പന്ന്യൻ രവീന്ദ്രൻ , നിംസ് കോളേജ് ഓഫ് നഴ്സിംഗ് പ്രിൻസിപ്പൽ ശ്രീമതി. ജോസഫൈൻ വിനിത തുടങ്ങി രാഷ്ട്രീയ സാമൂഹ്യ സാംസ്കാരിക കലാ രംഗത്തെ പ്രമുഖർ ചടങ്ങിൽ സന്നിഹിതരായിരുന്നു. ",
      thumb: "assets/img/edu/6.jpg",
    },
    {
      src: "assets/img/edu/7.jpg",
      caption:
        "ശ്രീചിത്രാ ഹോമിലെ മിടുക്കരായ വിദ്യാർത്ഥികൾക്കാണ് നൂറുൽ ഇസ്ലാം സർവ്വകലാശാലയിൽ സൗജന്യ ഉന്നത വിദ്യാഭ്യാസം ഒരുക്കുന്നത്. ഐ.എസ്. ആർ. ഒ. ചെയർമാൻ ഡോ. എസ്. സോമനാഥ് സ്കോളർഷിപ്പ് പദ്ധതിയുടെ ഉത്ഘാടനം നിർവഹിച്ചു.  ബഹുമാനപ്പെട്ട വിദ്യാഭ്യാസ വകുപ്പുമന്ത്രി ശ്രീ.വി. ശിവൻകുട്ടി , ശ്രീ. ശ്രീകുമാരൻ തമ്പി , ശ്രീ. രാജീവ് ചന്ദ്രശേഖർ , ശ്രീ. ശശി തരൂർ , ശ്രീ. പന്ന്യൻ രവീന്ദ്രൻ , നിംസ് കോളേജ് ഓഫ് നഴ്സിംഗ് പ്രിൻസിപ്പൽ ശ്രീമതി. ജോസഫൈൻ വിനിത തുടങ്ങി രാഷ്ട്രീയ സാമൂഹ്യ സാംസ്കാരിക കലാ രംഗത്തെ പ്രമുഖർ ചടങ്ങിൽ സന്നിഹിതരായിരുന്നു. ",
      thumb: "assets/img/edu/7.jpg",
    },
    {
      src: "assets/img/edu/8.jpg",
      caption:
        "ശ്രീചിത്രാ ഹോമിലെ മിടുക്കരായ വിദ്യാർത്ഥികൾക്കാണ് നൂറുൽ ഇസ്ലാം സർവ്വകലാശാലയിൽ സൗജന്യ ഉന്നത വിദ്യാഭ്യാസം ഒരുക്കുന്നത്. ഐ.എസ്. ആർ. ഒ. ചെയർമാൻ ഡോ. എസ്. സോമനാഥ് സ്കോളർഷിപ്പ് പദ്ധതിയുടെ ഉത്ഘാടനം നിർവഹിച്ചു.  ബഹുമാനപ്പെട്ട വിദ്യാഭ്യാസ വകുപ്പുമന്ത്രി ശ്രീ.വി. ശിവൻകുട്ടി , ശ്രീ. ശ്രീകുമാരൻ തമ്പി , ശ്രീ. രാജീവ് ചന്ദ്രശേഖർ , ശ്രീ. ശശി തരൂർ , ശ്രീ. പന്ന്യൻ രവീന്ദ്രൻ , നിംസ് കോളേജ് ഓഫ് നഴ്സിംഗ് പ്രിൻസിപ്പൽ ശ്രീമതി. ജോസഫൈൻ വിനിത തുടങ്ങി രാഷ്ട്രീയ സാമൂഹ്യ സാംസ്കാരിക കലാ രംഗത്തെ പ്രമുഖർ ചടങ്ങിൽ സന്നിഹിതരായിരുന്നു. ",
      thumb: "assets/img/edu/8.jpg",
    },
    {
      src: "assets/img/padanolsavam/96.jpg",
      caption:
        "യൂത്ത് കോൺഗ്രസിന്റെ ആഭിമുഖ്യത്തിലുള്ള ടി.വി. ചലഞ്ച് പദ്ധതിക്ക് വേണ്ടി നെയ്യാറ്റിൻകര നിംസ് മെഡിസിറ്റി മാനേജിങ് ഡയറക്ടർ എം.എസ് ഫൈസൽ ഖാൻ ഡി.സി.സി. പ്രസിഡന്റ് നെയ്യാറ്റിൻകര സനലിനു ടെലിവിഷനുകൾ കൈമാറി. ഡി.സി.സി. സെക്രട്ടറി വിനോദ് സെൻ, ജോസ് ഫ്രാങ്ക്‌ളിൻ, യൂത്ത് കോൺഗ്രസ് മുൻ ജില്ലാ വൈസ് പ്രസിഡന്റ് ആർ.ഓ.അരുൺ, ആർ. വി. രതീഷ്, മാമ്പഴക്കൽ രാജശേഖരൻ നായർ, കോൺഗ്രസ് സേവാദൾ പ്രസിഡന്റ് ശിവപ്രസാദ്, കെ.എസ്.യു. ജിലാ സെക്രട്ടറി അജിൻ ദേവ്, പുന്നക്കാട് സജു, അഹമ്മദ് ഖാൻ, മോഹൻലാൽ, എബനൈസർ , ഐ.എസ് സന്തോഷ് സംബന്ധിച്ചു.",
      thumb: "assets/img/padanolsavam/96.jpg",
    },
    {
      src: "assets/img/padanolsavam/97.jpg",
      caption:
        "യൂത്ത് കോൺഗ്രസിന്റെ ആഭിമുഖ്യത്തിലുള്ള ടി.വി. ചലഞ്ച് പദ്ധതിക്ക് വേണ്ടി നെയ്യാറ്റിൻകര നിംസ് മെഡിസിറ്റി മാനേജിങ് ഡയറക്ടർ എം.എസ് ഫൈസൽ ഖാൻ ഡി.സി.സി. പ്രസിഡന്റ് നെയ്യാറ്റിൻകര സനലിനു ടെലിവിഷനുകൾ കൈമാറി. ഡി.സി.സി. സെക്രട്ടറി വിനോദ് സെൻ, ജോസ് ഫ്രാങ്ക്‌ളിൻ, യൂത്ത് കോൺഗ്രസ് മുൻ ജില്ലാ വൈസ് പ്രസിഡന്റ് ആർ.ഓ.അരുൺ, ആർ. വി. രതീഷ്, മാമ്പഴക്കൽ രാജശേഖരൻ നായർ, കോൺഗ്രസ് സേവാദൾ പ്രസിഡന്റ് ശിവപ്രസാദ്, കെ.എസ്.യു. ജിലാ സെക്രട്ടറി അജിൻ ദേവ്, പുന്നക്കാട് സജു, അഹമ്മദ് ഖാൻ, മോഹൻലാൽ, എബനൈസർ , ഐ.എസ് സന്തോഷ് സംബന്ധിച്ചു.",
      thumb: "assets/img/padanolsavam/97.jpg",
    },
    {
      src: "assets/img/padanolsavam/98.jpg",
      caption:
        "യൂത്ത് കോൺഗ്രസിന്റെ ആഭിമുഖ്യത്തിലുള്ള ടി.വി. ചലഞ്ച് പദ്ധതിക്ക് വേണ്ടി നെയ്യാറ്റിൻകര നിംസ് മെഡിസിറ്റി മാനേജിങ് ഡയറക്ടർ എം.എസ് ഫൈസൽ ഖാൻ ഡി.സി.സി. പ്രസിഡന്റ് നെയ്യാറ്റിൻകര സനലിനു ടെലിവിഷനുകൾ കൈമാറി. ഡി.സി.സി. സെക്രട്ടറി വിനോദ് സെൻ, ജോസ് ഫ്രാങ്ക്‌ളിൻ, യൂത്ത് കോൺഗ്രസ് മുൻ ജില്ലാ വൈസ് പ്രസിഡന്റ് ആർ.ഓ.അരുൺ, ആർ. വി. രതീഷ്, മാമ്പഴക്കൽ രാജശേഖരൻ നായർ, കോൺഗ്രസ് സേവാദൾ പ്രസിഡന്റ് ശിവപ്രസാദ്, കെ.എസ്.യു. ജിലാ സെക്രട്ടറി അജിൻ ദേവ്, പുന്നക്കാട് സജു, അഹമ്മദ് ഖാൻ, മോഹൻലാൽ, എബനൈസർ , ഐ.എസ് സന്തോഷ് സംബന്ധിച്ചു.",
      thumb: "assets/img/padanolsavam/98.jpg",
    },
    {
      src: "assets/img/padanolsavam/99.jpg",
      caption:
        "യൂത്ത് കോൺഗ്രസിന്റെ ആഭിമുഖ്യത്തിലുള്ള ടി.വി. ചലഞ്ച് പദ്ധതിക്ക് വേണ്ടി നെയ്യാറ്റിൻകര നിംസ് മെഡിസിറ്റി മാനേജിങ് ഡയറക്ടർ എം.എസ് ഫൈസൽ ഖാൻ ഡി.സി.സി. പ്രസിഡന്റ് നെയ്യാറ്റിൻകര സനലിനു ടെലിവിഷനുകൾ കൈമാറി. ഡി.സി.സി. സെക്രട്ടറി വിനോദ് സെൻ, ജോസ് ഫ്രാങ്ക്‌ളിൻ, യൂത്ത് കോൺഗ്രസ് മുൻ ജില്ലാ വൈസ് പ്രസിഡന്റ് ആർ.ഓ.അരുൺ, ആർ. വി. രതീഷ്, മാമ്പഴക്കൽ രാജശേഖരൻ നായർ, കോൺഗ്രസ് സേവാദൾ പ്രസിഡന്റ് ശിവപ്രസാദ്, കെ.എസ്.യു. ജിലാ സെക്രട്ടറി അജിൻ ദേവ്, പുന്നക്കാട് സജു, അഹമ്മദ് ഖാൻ, മോഹൻലാൽ, എബനൈസർ , ഐ.എസ് സന്തോഷ് സംബന്ധിച്ചു.",
      thumb: "assets/img/padanolsavam/99.jpg",
    },
    {
      src: "assets/img/padanolsavam/100.jpg",
      caption:
        " നെയ്യാറ്റിൻകര ഏരിയ ആട്ടോ ടാക്സി വർക്കേഴ്സ് യൂണിയൻ ( സി.ഐ.ടി.യു. )ന്റെ ആഭിമുഖ്യത്തിലുള്ള ടി.വി ചലഞ്ച് പദ്ധതിയിലേക്ക് നെയ്യാറ്റിൻകര നിംസ് മെഡിസിറ്റിയുടെ ഭാഗമായുള്ള ടെലിവിഷനുകൾ മാനേജിങ് ഡയറക്ടർ എം.എസ് ഫൈസൽ ഖാനിൽ നിന്നും യൂണിയൻ ഭാരവാഹികളായ ആറാലുംമൂട് ജാഫർ, കെ. മോഹൻ എന്നിവർ ഏറ്റുവാങ്ങി.",
      thumb: "assets/img/padanolsavam/100.jpg",
    },
    {
      src: "assets/img/padanolsavam/101.jpg",
      caption:
        " നെയ്യാറ്റിൻകര ഏരിയ ആട്ടോ ടാക്സി വർക്കേഴ്സ് യൂണിയൻ ( സി.ഐ.ടി.യു. )ന്റെ ആഭിമുഖ്യത്തിലുള്ള ടി.വി ചലഞ്ച് പദ്ധതിയിലേക്ക് നെയ്യാറ്റിൻകര നിംസ് മെഡിസിറ്റിയുടെ ഭാഗമായുള്ള ടെലിവിഷനുകൾ മാനേജിങ് ഡയറക്ടർ എം.എസ് ഫൈസൽ ഖാനിൽ നിന്നും യൂണിയൻ ഭാരവാഹികളായ ആറാലുംമൂട് ജാഫർ, കെ. മോഹൻ എന്നിവർ ഏറ്റുവാങ്ങി.",
      thumb: "assets/img/padanolsavam/101.jpg",
    },

    {
      src: "assets/img/home/niche-scholarship.jpg",
      caption: "",
      thumb: "assets/img/home/niche-scholarship.jpg",
    },
    {
      src: "assets/img/edu/1.jpeg",
      caption:
        "സൗജന്യ online പഠനസഹായ പദ്ധതിയുടെ ഭാഗമായി നിംസ് മെഡിസിറ്റി എം ടി ശ്രീ എം എസ് ഫൈസൽ ഖാൻ പട്ടം St മേരീസ്‌ സ്കൂളിലെ നിർധനരായ വിദ്യാർഥികൾക്കുള്ള മൊബൈൽ ഫോൺ സ്കൂൾ പ്രിൻസിപ്പൽ ശ്രീ ഫാദർ ജോൺ അവർകൾക്ക് നൽകുകയുണ്ടായി.പ്രസ്‌തുത ചടങ്ങിൽ ശ്രീ ഗുരുരെത്നം ജ്ഞാനതപസി (ശാന്തിഗിരി), സ്കൂൾ ഹെഡ് മാസ്റ്റർ ശ്രീ ബിജോയ്‌, PTA പ്രസിഡന്റ്‌ ശ്രീ ഷാജി കുരിയാത്തി തുടങ്ങിയവർ സന്നിഹിതരായിരുന്നു..",
      thumb: "assets/img/edu/1.jpeg",
    },
    {
      src: "assets/img/padanolsavam/1.jpg",
      caption: "1",
      thumb: "assets/img/padanolsavam/1.jpg",
    },
    {
      src: "assets/img/padanolsavam/2.jpg",
      caption: "2",
      thumb: "assets/img/padanolsavam/2.jpg",
    },
    {
      src: "assets/img/padanolsavam/3.jpg",
      caption: "3",
      thumb: "assets/img/padanolsavam/3.jpg",
    },
    {
      src: "assets/img/padanolsavam/5.jpg",
      caption: "5",
      thumb: "assets/img/padanolsavam/5.jpg",
    },
    {
      src: "assets/img/padanolsavam/6.jpg",
      caption: "6",
      thumb: "assets/img/padanolsavam/6.jpg",
    },
    {
      src: "assets/img/padanolsavam/8.jpg",
      caption: "8",
      thumb: "assets/img/padanolsavam/8.jpg",
    },
    {
      src: "assets/img/padanolsavam/9.jpg",
      caption: "9",
      thumb: "assets/img/padanolsavam/9.jpg",
    },
    {
      src: "assets/img/padanolsavam/11.jpg",
      caption: "11",
      thumb: "assets/img/padanolsavam/11.jpg",
    },
    {
      src: "assets/img/padanolsavam/12.jpg",
      caption: "12",
      thumb: "assets/img/padanolsavam/12.jpg",
    },
    {
      src: "assets/img/padanolsavam/13.jpg",
      caption: "13",
      thumb: "assets/img/padanolsavam/13.jpg",
    },
    {
      src: "assets/img/padanolsavam/14.jpg",
      caption: "14",
      thumb: "assets/img/padanolsavam/14.jpg",
    },
    {
      src: "assets/img/padanolsavam/15.jpg",
      caption: "15",
      thumb: "assets/img/padanolsavam/15.jpg",
    },
    {
      src: "assets/img/padanolsavam/16.jpg",
      caption: "16",
      thumb: "assets/img/padanolsavam/16.jpg",
    },
    {
      src: "assets/img/padanolsavam/17.jpg",
      caption: "17",
      thumb: "assets/img/padanolsavam/17.jpg",
    },
    {
      src: "assets/img/padanolsavam/18.jpg",
      caption: "18",
      thumb: "assets/img/padanolsavam/18.jpg",
    },
    {
      src: "assets/img/padanolsavam/19.jpg",
      caption: "19",
      thumb: "assets/img/padanolsavam/19.jpg",
    },
    {
      src: "assets/img/padanolsavam/20.jpg",
      caption: "20",
      thumb: "assets/img/padanolsavam/20.jpg",
    },
    {
      src: "assets/img/padanolsavam/21.jpg",
      caption: "21",
      thumb: "assets/img/padanolsavam/21.jpg",
    },
    {
      src: "assets/img/padanolsavam/22.jpg",
      caption: "22",
      thumb: "assets/img/padanolsavam/22.jpg",
    },
    {
      src: "assets/img/padanolsavam/23.jpg",
      caption: "23",
      thumb: "assets/img/padanolsavam/23.jpg",
    },
    {
      src: "assets/img/padanolsavam/24.jpg",
      caption: "24",
      thumb: "assets/img/padanolsavam/24.jpg",
    },
    {
      src: "assets/img/padanolsavam/25.jpg",
      caption: "25",
      thumb: "assets/img/padanolsavam/25.jpg",
    },
    {
      src: "assets/img/padanolsavam/26.jpg",
      caption: "26",
      thumb: "assets/img/padanolsavam/26.jpg",
    },
    {
      src: "assets/img/padanolsavam/27.jpg",
      caption: "27",
      thumb: "assets/img/padanolsavam/27.jpg",
    },
    {
      src: "assets/img/padanolsavam/28.jpg",
      caption: "28",
      thumb: "assets/img/padanolsavam/28.jpg",
    },
    {
      src: "assets/img/padanolsavam/29.jpg",
      caption: "29",
      thumb: "assets/img/padanolsavam/29.jpg",
    },
    {
      src: "assets/img/padanolsavam/30.jpg",
      caption: "30",
      thumb: "assets/img/padanolsavam/30.jpg",
    },
    {
      src: "assets/img/padanolsavam/31.jpg",
      caption: "31",
      thumb: "assets/img/padanolsavam/31.jpg",
    },
    {
      src: "assets/img/padanolsavam/32.jpg",
      caption: "32",
      thumb: "assets/img/padanolsavam/32.jpg",
    },
    {
      src: "assets/img/padanolsavam/33.jpg",
      caption: "33",
      thumb: "assets/img/padanolsavam/33.jpg",
    },
    {
      src: "assets/img/padanolsavam/34.jpg",
      caption: "34",
      thumb: "assets/img/padanolsavam/34.jpg",
    },
    {
      src: "assets/img/padanolsavam/35.jpg",
      caption: "35",
      thumb: "assets/img/padanolsavam/35.jpg",
    },
    {
      src: "assets/img/padanolsavam/36.jpg",
      caption: "36",
      thumb: "assets/img/padanolsavam/36.jpg",
    },
    {
      src: "assets/img/padanolsavam/37.jpg",
      caption: "37",
      thumb: "assets/img/padanolsavam/37.jpg",
    },
    {
      src: "assets/img/padanolsavam/38.jpg",
      caption: "38",
      thumb: "assets/img/padanolsavam/38.jpg",
    },
    {
      src: "assets/img/padanolsavam/39.jpg",
      caption: "39",
      thumb: "assets/img/padanolsavam/39.jpg",
    },
    {
      src: "assets/img/padanolsavam/40.jpg",
      caption: "40",
      thumb: "assets/img/padanolsavam/40.jpg",
    },
    {
      src: "assets/img/padanolsavam/41.jpg",
      caption: "41",
      thumb: "assets/img/padanolsavam/41.jpg",
    },
    {
      src: "assets/img/padanolsavam/42.jpg",
      caption: "42",
      thumb: "assets/img/padanolsavam/42.jpg",
    },
    {
      src: "assets/img/padanolsavam/43.jpg",
      caption: "43",
      thumb: "assets/img/padanolsavam/43.jpg",
    },
    {
      src: "assets/img/padanolsavam/44.jpg",
      caption: "44",
      thumb: "assets/img/padanolsavam/44.jpg",
    },
    {
      src: "assets/img/padanolsavam/45.jpg",
      caption: "45",
      thumb: "assets/img/padanolsavam/45.jpg",
    },
    {
      src: "assets/img/padanolsavam/46.jpg",
      caption: "46",
      thumb: "assets/img/padanolsavam/46.jpg",
    },
    {
      src: "assets/img/padanolsavam/47.jpg",
      caption: "47",
      thumb: "assets/img/padanolsavam/47.jpg",
    },
    {
      src: "assets/img/padanolsavam/48.jpg",
      caption: "48",
      thumb: "assets/img/padanolsavam/48.jpg",
    },
    {
      src: "assets/img/padanolsavam/49.jpg",
      caption: "49",
      thumb: "assets/img/padanolsavam/49.jpg",
    },
    {
      src: "assets/img/padanolsavam/50.jpg",
      caption: "50",
      thumb: "assets/img/padanolsavam/50.jpg",
    },
    {
      src: "assets/img/padanolsavam/51.jpg",
      caption: "51",
      thumb: "assets/img/padanolsavam/51.jpg",
    },
    {
      src: "assets/img/padanolsavam/52.jpg",
      caption: "52",
      thumb: "assets/img/padanolsavam/52.jpg",
    },
    {
      src: "assets/img/padanolsavam/53.jpg",
      caption: "53",
      thumb: "assets/img/padanolsavam/53.jpg",
    },
    {
      src: "assets/img/padanolsavam/54.jpg",
      caption: "54",
      thumb: "assets/img/padanolsavam/54.jpg",
    },
    {
      src: "assets/img/padanolsavam/55.jpg",
      caption: "55",
      thumb: "assets/img/padanolsavam/55.jpg",
    },
    {
      src: "assets/img/padanolsavam/56.jpg",
      caption: "56",
      thumb: "assets/img/padanolsavam/56.jpg",
    },
    {
      src: "assets/img/padanolsavam/57.jpg",
      caption: "57",
      thumb: "assets/img/padanolsavam/57.jpg",
    },
    {
      src: "assets/img/padanolsavam/58.jpg",
      caption: "58",
      thumb: "assets/img/padanolsavam/58.jpg",
    },
    {
      src: "assets/img/padanolsavam/59.jpg",
      caption: "59",
      thumb: "assets/img/padanolsavam/59.jpg",
    },
    {
      src: "assets/img/padanolsavam/60.jpg",
      caption: "60",
      thumb: "assets/img/padanolsavam/60.jpg",
    },
    {
      src: "assets/img/padanolsavam/61.jpg",
      caption: "61",
      thumb: "assets/img/padanolsavam/61.jpg",
    },
    {
      src: "assets/img/padanolsavam/62.jpg",
      caption: "62",
      thumb: "assets/img/padanolsavam/62.jpg",
    },
    {
      src: "assets/img/padanolsavam/63.jpg",
      caption: "63",
      thumb: "assets/img/padanolsavam/63.jpg",
    },
    {
      src: "assets/img/padanolsavam/64.jpg",
      caption: "64",
      thumb: "assets/img/padanolsavam/64.jpg",
    },
    {
      src: "assets/img/padanolsavam/65.jpg",
      caption: "65",
      thumb: "assets/img/padanolsavam/65.jpg",
    },
    {
      src: "assets/img/padanolsavam/66.jpg",
      caption: "66",
      thumb: "assets/img/padanolsavam/66.jpg",
    },
    {
      src: "assets/img/padanolsavam/67.jpg",
      caption: "67",
      thumb: "assets/img/padanolsavam/67.jpg",
    },
    {
      src: "assets/img/padanolsavam/68.jpg",
      caption: "68",
      thumb: "assets/img/padanolsavam/68.jpg",
    },
    {
      src: "assets/img/padanolsavam/69.jpg",
      caption: "69",
      thumb: "assets/img/padanolsavam/69.jpg",
    },
    {
      src: "assets/img/padanolsavam/70.jpg",
      caption: "70",
      thumb: "assets/img/padanolsavam/70.jpg",
    },
    {
      src: "assets/img/padanolsavam/71.jpg",
      caption: "71",
      thumb: "assets/img/padanolsavam/71.jpg",
    },
    {
      src: "assets/img/padanolsavam/72.jpg",
      caption: "72",
      thumb: "assets/img/padanolsavam/72.jpg",
    },
    {
      src: "assets/img/padanolsavam/73.jpg",
      caption: "73",
      thumb: "assets/img/padanolsavam/73.jpg",
    },
    {
      src: "assets/img/padanolsavam/74.jpg",
      caption: "74",
      thumb: "assets/img/padanolsavam/74.jpg",
    },
    {
      src: "assets/img/padanolsavam/75.jpg",
      caption: "75",
      thumb: "assets/img/padanolsavam/75.jpg",
    },
    {
      src: "assets/img/padanolsavam/76.jpg",
      caption: "76",
      thumb: "assets/img/padanolsavam/76.jpg",
    },
    {
      src: "assets/img/padanolsavam/77.jpg",
      caption: "77",
      thumb: "assets/img/padanolsavam/77.jpg",
    },
    {
      src: "assets/img/padanolsavam/78.jpg",
      caption: "78",
      thumb: "assets/img/padanolsavam/78.jpg",
    },
    {
      src: "assets/img/padanolsavam/79.jpg",
      caption: "79",
      thumb: "assets/img/padanolsavam/79.jpg",
    },
    {
      src: "assets/img/padanolsavam/80.jpg",
      caption: "80",
      thumb: "assets/img/padanolsavam/80.jpg",
    },
    {
      src: "assets/img/padanolsavam/81.jpg",
      caption: "81",
      thumb: "assets/img/padanolsavam/81.jpg",
    },
    {
      src: "assets/img/padanolsavam/82.jpg",
      caption: "82",
      thumb: "assets/img/padanolsavam/82.jpg",
    },
    {
      src: "assets/img/padanolsavam/83.jpg",
      caption: "83",
      thumb: "assets/img/padanolsavam/83.jpg",
    },
    {
      src: "assets/img/padanolsavam/84.jpg",
      caption: "84",
      thumb: "assets/img/padanolsavam/84.jpg",
    },
    {
      src: "assets/img/padanolsavam/85.jpg",
      caption: "85",
      thumb: "assets/img/padanolsavam/85.jpg",
    },
    {
      src: "assets/img/padanolsavam/86.jpg",
      caption: "86",
      thumb: "assets/img/padanolsavam/86.jpg",
    },
    {
      src: "assets/img/padanolsavam/87.jpg",
      caption: "87",
      thumb: "assets/img/padanolsavam/87.jpg",
    },
    {
      src: "assets/img/padanolsavam/88.jpg",
      caption: "88",
      thumb: "assets/img/padanolsavam/88.jpg",
    },
    {
      src: "assets/img/padanolsavam/89.jpg",
      caption: "89",
      thumb: "assets/img/padanolsavam/89.jpg",
    },
    {
      src: "assets/img/padanolsavam/90.jpg",
      caption: "90",
      thumb: "assets/img/padanolsavam/90.jpg",
    },
    {
      src: "assets/img/padanolsavam/91.jpg",
      caption: "91",
      thumb: "assets/img/padanolsavam/91.jpg",
    },
    {
      src: "assets/img/padanolsavam/92.jpg",
      caption: "92",
      thumb: "assets/img/padanolsavam/92.jpg",
    },
    {
      src: "assets/img/padanolsavam/93.jpg",
      caption: "93",
      thumb: "assets/img/padanolsavam/93.jpg",
    },
  ];

  AID_GALLERY: Array<{ src: string; caption: string; thumb: string }> = [
    {
      src: "assets/img/Hearing Aid/1.jpg",
      caption: "1",
      thumb: "assets/img/Hearing Aid/1.jpg",
    },
    {
      src: "assets/img/Hearing Aid/2.jpg",
      caption: "2",
      thumb: "assets/img/Hearing Aid/2.jpg",
    },
    {
      src: "assets/img/Hearing Aid/3.jpg",
      caption: "3",
      thumb: "assets/img/Hearing Aid/3.jpg",
    },
    {
      src: "assets/img/Hearing Aid/4.jpg",
      caption: "4",
      thumb: "assets/img/Hearing Aid/4.jpg",
    },
    {
      src: "assets/img/Hearing Aid/5.jpg",
      caption: "5",
      thumb: "assets/img/Hearing Aid/5.jpg",
    },
    {
      src: "assets/img/Hearing Aid/6.jpg",
      caption: "6",
      thumb: "assets/img/Hearing Aid/6.jpg",
    },
    {
      src: "assets/img/Hearing Aid/7.jpg",
      caption: "7",
      thumb: "assets/img/Hearing Aid/7.jpg",
    },
    {
      src: "assets/img/Hearing Aid/8.jpg",
      caption: "8",
      thumb: "assets/img/Hearing Aid/8.jpg",
    },
    {
      src: "assets/img/Hearing Aid/9.jpg",
      caption: "9",
      thumb: "assets/img/Hearing Aid/9.jpg",
    },
    {
      src: "assets/img/Hearing Aid/10.jpg",
      caption: "10",
      thumb: "assets/img/Hearing Aid/10.jpg",
    },
    {
      src: "assets/img/Hearing Aid/11.jpeg",
      caption:
        "Free Hearing Test on the March 03, The World Hearing Day At Happy Home",
      thumb: "assets/img/Hearing Aid/11.jpeg",
    },
    {
      src: "assets/img/Hearing Aid/12.jpeg",
      caption:
        "Free Hearing Test on the March 03, The World Hearing Day At Happy Home",
      thumb: "assets/img/Hearing Aid/12.jpeg",
    },
    {
      src: "assets/img/Hearing Aid/13.jpeg",
      caption:
        "Free Hearing Test on the March 03, The World Hearing Day At Happy Home",
      thumb: "assets/img/Hearing Aid/13.jpeg",
    },
    {
      src: "assets/img/Hearing Aid/14.jpeg",
      caption:
        "Free Hearing Test on the March 03, The World Hearing Day At Happy Home",
      thumb: "assets/img/Hearing Aid/14.jpeg",
    },
    {
      src: "assets/img/Hearing Aid/15.jpeg",
      caption:
        "Free Hearing Test on the March 03, The World Hearing Day At Happy Home",
      thumb: "assets/img/Hearing Aid/15.jpeg",
    },
  ];
  Annapoorna: Array<{ src: string; caption: string; thumb: string }> = [
    {
      src: "assets/img/dialysis/30.jpg",
      caption:
        "On the eve of Ramadan, the staff of NIMS Medicity joined hands today (14-06-2018) to distribute grocery kits to the families of patients ( in and around Neyyattinkara) undergoing dialysis at NIMS Medicity. Mr. M.S. Faizal Khan Managing Director, NIMS Medicity,  distributed the relief kits in the presence of NIMS Staff and public.  Mr.Sivakumar Sivakumar administrative co-ordinator,Mr Saju Ayyappan Nair Kottayathumveedu General manager, Mr Refai Abdul Rahim, Mr. Shmnad Alavudeen, Mr Subin Salahudeen,Mr Arun Babu, Mr Bipin Nair and others coordinated the noble initiative.",
      thumb: "assets/img/dialysis/30.jpg",
    },
    {
      src: "assets/img/dialysis/31.jpg",
      caption:
        "On the eve of Ramadan, the staff of NIMS Medicity joined hands today (14-06-2018) to distribute grocery kits to the families of patients ( in and around Neyyattinkara) undergoing dialysis at NIMS Medicity. Mr. M.S. Faizal Khan Managing Director, NIMS Medicity,  distributed the relief kits in the presence of NIMS Staff and public.  Mr.Sivakumar Sivakumar administrative co-ordinator,Mr Saju Ayyappan Nair Kottayathumveedu General manager, Mr Refai Abdul Rahim, Mr. Shmnad Alavudeen, Mr Subin Salahudeen,Mr Arun Babu, Mr Bipin Nair and others coordinated the noble initiative.",
      thumb: "assets/img/dialysis/31.jpg",
    },
    {
      src: "assets/img/dialysis/32.jpg",
      caption:
        "On the eve of Ramadan, the staff of NIMS Medicity joined hands today (14-06-2018) to distribute grocery kits to the families of patients ( in and around Neyyattinkara) undergoing dialysis at NIMS Medicity. Mr. M.S. Faizal Khan Managing Director, NIMS Medicity,  distributed the relief kits in the presence of NIMS Staff and public.  Mr.Sivakumar Sivakumar administrative co-ordinator,Mr Saju Ayyappan Nair Kottayathumveedu General manager, Mr Refai Abdul Rahim, Mr. Shmnad Alavudeen, Mr Subin Salahudeen,Mr Arun Babu, Mr Bipin Nair and others coordinated the noble initiative.",
      thumb: "assets/img/dialysis/32.jpg",
    },
    {
      src: "assets/img/dialysis/33.jpg",
      caption:
        "On the eve of Ramadan, the staff of NIMS Medicity joined hands today (14-06-2018) to distribute grocery kits to the families of patients ( in and around Neyyattinkara) undergoing dialysis at NIMS Medicity. Mr. M.S. Faizal Khan Managing Director, NIMS Medicity,  distributed the relief kits in the presence of NIMS Staff and public.  Mr.Sivakumar Sivakumar administrative co-ordinator,Mr Saju Ayyappan Nair Kottayathumveedu General manager, Mr Refai Abdul Rahim, Mr. Shmnad Alavudeen, Mr Subin Salahudeen,Mr Arun Babu, Mr Bipin Nair and others coordinated the noble initiative.",
      thumb: "assets/img/dialysis/33.jpg",
    },
    {
      src: "assets/img/dialysis/34.jpg",
      caption:
        "On the eve of Ramadan, the staff of NIMS Medicity joined hands today (14-06-2018) to distribute grocery kits to the families of patients ( in and around Neyyattinkara) undergoing dialysis at NIMS Medicity. Mr. M.S. Faizal Khan Managing Director, NIMS Medicity,  distributed the relief kits in the presence of NIMS Staff and public.  Mr.Sivakumar Sivakumar administrative co-ordinator,Mr Saju Ayyappan Nair Kottayathumveedu General manager, Mr Refai Abdul Rahim, Mr. Shmnad Alavudeen, Mr Subin Salahudeen,Mr Arun Babu, Mr Bipin Nair and others coordinated the noble initiative.",
      thumb: "assets/img/dialysis/34.jpg",
    },
    {
      src: "assets/img/dialysis/35.jpg",
      caption:
        "On the eve of Ramadan, the staff of NIMS Medicity joined hands today (14-06-2018) to distribute grocery kits to the families of patients ( in and around Neyyattinkara) undergoing dialysis at NIMS Medicity. Mr. M.S. Faizal Khan Managing Director, NIMS Medicity,  distributed the relief kits in the presence of NIMS Staff and public.  Mr.Sivakumar Sivakumar administrative co-ordinator,Mr Saju Ayyappan Nair Kottayathumveedu General manager, Mr Refai Abdul Rahim, Mr. Shmnad Alavudeen, Mr Subin Salahudeen,Mr Arun Babu, Mr Bipin Nair and others coordinated the noble initiative.",
      thumb: "assets/img/dialysis/35.jpg",
    },
    {
      src: "assets/img/dialysis/36.jpg",
      caption:
        "On the eve of Ramadan, the staff of NIMS Medicity joined hands today (14-06-2018) to distribute grocery kits to the families of patients ( in and around Neyyattinkara) undergoing dialysis at NIMS Medicity. Mr. M.S. Faizal Khan Managing Director, NIMS Medicity,  distributed the relief kits in the presence of NIMS Staff and public.  Mr.Sivakumar Sivakumar administrative co-ordinator,Mr Saju Ayyappan Nair Kottayathumveedu General manager, Mr Refai Abdul Rahim, Mr. Shmnad Alavudeen, Mr Subin Salahudeen,Mr Arun Babu, Mr Bipin Nair and others coordinated the noble initiative.",
      thumb: "assets/img/dialysis/36.jpg",
    },
    {
      src: "assets/img/dialysis/37.jpg",
      caption:
        "On the eve of Ramadan, the staff of NIMS Medicity joined hands today (14-06-2018) to distribute grocery kits to the families of patients ( in and around Neyyattinkara) undergoing dialysis at NIMS Medicity. Mr. M.S. Faizal Khan Managing Director, NIMS Medicity,  distributed the relief kits in the presence of NIMS Staff and public.  Mr.Sivakumar Sivakumar administrative co-ordinator,Mr Saju Ayyappan Nair Kottayathumveedu General manager, Mr Refai Abdul Rahim, Mr. Shmnad Alavudeen, Mr Subin Salahudeen,Mr Arun Babu, Mr Bipin Nair and others coordinated the noble initiative.",
      thumb: "assets/img/dialysis/37.jpg",
    },
    {
      src: "assets/img/dialysis/38.jpg",
      caption:
        "On the eve of Ramadan, the staff of NIMS Medicity joined hands today (14-06-2018) to distribute grocery kits to the families of patients ( in and around Neyyattinkara) undergoing dialysis at NIMS Medicity. Mr. M.S. Faizal Khan Managing Director, NIMS Medicity,  distributed the relief kits in the presence of NIMS Staff and public.  Mr.Sivakumar Sivakumar administrative co-ordinator,Mr Saju Ayyappan Nair Kottayathumveedu General manager, Mr Refai Abdul Rahim, Mr. Shmnad Alavudeen, Mr Subin Salahudeen,Mr Arun Babu, Mr Bipin Nair and others coordinated the noble initiative.",
      thumb: "assets/img/dialysis/38.jpg",
    },
    {
      src: "assets/img/dialysis/39.jpg",
      caption:
        "On the eve of Ramadan, the staff of NIMS Medicity joined hands today (14-06-2018) to distribute grocery kits to the families of patients ( in and around Neyyattinkara) undergoing dialysis at NIMS Medicity. Mr. M.S. Faizal Khan Managing Director, NIMS Medicity,  distributed the relief kits in the presence of NIMS Staff and public.  Mr.Sivakumar Sivakumar administrative co-ordinator,Mr Saju Ayyappan Nair Kottayathumveedu General manager, Mr Refai Abdul Rahim, Mr. Shmnad Alavudeen, Mr Subin Salahudeen,Mr Arun Babu, Mr Bipin Nair and others coordinated the noble initiative.",
      thumb: "assets/img/dialysis/39.jpg",
    },
    {
      src: "assets/img/dialysis/40.jpg",
      caption:
        "On the eve of Ramadan, the staff of NIMS Medicity joined hands today (14-06-2018) to distribute grocery kits to the families of patients ( in and around Neyyattinkara) undergoing dialysis at NIMS Medicity. Mr. M.S. Faizal Khan Managing Director, NIMS Medicity,  distributed the relief kits in the presence of NIMS Staff and public.  Mr.Sivakumar Sivakumar administrative co-ordinator,Mr Saju Ayyappan Nair Kottayathumveedu General manager, Mr Refai Abdul Rahim, Mr. Shmnad Alavudeen, Mr Subin Salahudeen,Mr Arun Babu, Mr Bipin Nair and others coordinated the noble initiative.",
      thumb: "assets/img/dialysis/40.jpg",
    },
    {
      src: "assets/img/dialysis/41.jpg",
      caption:
        "On the eve of Ramadan, the staff of NIMS Medicity joined hands today (14-06-2018) to distribute grocery kits to the families of patients ( in and around Neyyattinkara) undergoing dialysis at NIMS Medicity. Mr. M.S. Faizal Khan Managing Director, NIMS Medicity,  distributed the relief kits in the presence of NIMS Staff and public.  Mr.Sivakumar Sivakumar administrative co-ordinator,Mr Saju Ayyappan Nair Kottayathumveedu General manager, Mr Refai Abdul Rahim, Mr. Shmnad Alavudeen, Mr Subin Salahudeen,Mr Arun Babu, Mr Bipin Nair and others coordinated the noble initiative.",
      thumb: "assets/img/dialysis/41.jpg",
    },
    {
      src: "assets/img/dialysis/42.jpg",
      caption:
        "On the eve of Ramadan, the staff of NIMS Medicity joined hands today (14-06-2018) to distribute grocery kits to the families of patients ( in and around Neyyattinkara) undergoing dialysis at NIMS Medicity. Mr. M.S. Faizal Khan Managing Director, NIMS Medicity,  distributed the relief kits in the presence of NIMS Staff and public.  Mr.Sivakumar Sivakumar administrative co-ordinator,Mr Saju Ayyappan Nair Kottayathumveedu General manager, Mr Refai Abdul Rahim, Mr. Shmnad Alavudeen, Mr Subin Salahudeen,Mr Arun Babu, Mr Bipin Nair and others coordinated the noble initiative.",
      thumb: "assets/img/dialysis/42.jpg",
    },
    {
      src: "assets/img/dialysis/43.jpg",
      caption:
        "On the eve of Ramadan, the staff of NIMS Medicity joined hands today (14-06-2018) to distribute grocery kits to the families of patients ( in and around Neyyattinkara) undergoing dialysis at NIMS Medicity. Mr. M.S. Faizal Khan Managing Director, NIMS Medicity,  distributed the relief kits in the presence of NIMS Staff and public.  Mr.Sivakumar Sivakumar administrative co-ordinator,Mr Saju Ayyappan Nair Kottayathumveedu General manager, Mr Refai Abdul Rahim, Mr. Shmnad Alavudeen, Mr Subin Salahudeen,Mr Arun Babu, Mr Bipin Nair and others coordinated the noble initiative.",
      thumb: "assets/img/dialysis/43.jpg",
    },
    {
      src: "assets/img/annapoorna/8.jpeg",
      caption: "",
      thumb: "assets/img/annapoorna/8.jpeg",
    },
    {
      src: "assets/img/annapoorna/9.jpeg",
      caption: "",
      thumb: "assets/img/annapoorna/9.jpeg",
    },
    {
      src: "assets/img/annapoorna/10.jpeg",
      caption: "",
      thumb: "assets/img/annapoorna/10.jpeg",
    },
    {
      src: "assets/img/annapoorna/11.jpeg",
      caption: "",
      thumb: "assets/img/annapoorna/11.jpeg",
    },
    {
      src: "assets/img/annapoorna/12.jpeg",
      caption: "",
      thumb: "assets/img/annapoorna/12.jpeg",
    },
    {
      src: "assets/img/annapoorna/13.jpeg",
      caption: "",
      thumb: "assets/img/annapoorna/13.jpeg",
    },
    {
      src: "assets/img/annapoorna/14.jpeg",
      caption: "",
      thumb: "assets/img/annapoorna/14.jpeg",
    },
    {
      src: "assets/img/annapoorna/15.jpeg",
      caption: "",
      thumb: "assets/img/annapoorna/15.jpeg",
    },
    {
      src: "assets/img/annapoorna/16.jpeg",
      caption: "",
      thumb: "assets/img/annapoorna/16.jpeg",
    },
    {
      src: "assets/img/annapoorna/17.jpeg",
      caption: "",
      thumb: "assets/img/annapoorna/17.jpeg",
    },
    {
      src: "assets/img/annapoorna/18.jpeg",
      caption: "",
      thumb: "assets/img/annapoorna/18.jpeg",
    },
    {
      src: "assets/img/annapoorna/19.jpeg",
      caption: "",
      thumb: "assets/img/annapoorna/19.jpeg",
    },
    {
      src: "assets/img/annapoorna/20.jpeg",
      caption: "",
      thumb: "assets/img/annapoorna/20.jpeg",
    },
    {
      src: "assets/img/annapoorna/21.jpeg",
      caption: "",
      thumb: "assets/img/annapoorna/21.jpeg",
    },
    {
      src: "assets/img/annapoorna/22.jpeg",
      caption: "",
      thumb: "assets/img/annapoorna/22.jpeg",
    },
    {
      src: "assets/img/annapoorna/23.jpeg",
      caption: "",
      thumb: "assets/img/annapoorna/23.jpeg",
    },
    {
      src: "assets/img/annapoorna/24.jpeg",
      caption: "",
      thumb: "assets/img/annapoorna/24.jpeg",
    },
    {
      src: "assets/img/annapoorna/25.jpeg",
      caption: "",
      thumb: "assets/img/annapoorna/25.jpeg",
    },
    {
      src: "assets/img/annapoorna/26.jpeg",
      caption: "",
      thumb: "assets/img/annapoorna/26.jpeg",
    },
    {
      src: "assets/img/annapoorna/27.jpeg",
      caption: "",
      thumb: "assets/img/annapoorna/27.jpeg",
    },
    {
      src: "assets/img/annapoorna/28.jpeg",
      caption: "",
      thumb: "assets/img/annapoorna/28.jpeg",
    },
    {
      src: "assets/img/annapoorna/29.jpeg",
      caption: "",
      thumb: "assets/img/annapoorna/29.jpeg",
    },
    {
      src: "assets/img/annapoorna/30.jpeg",
      caption: "",
      thumb: "assets/img/annapoorna/30.jpeg",
    },
    {
      src: "assets/img/annapoorna/31.jpeg",
      caption: "",
      thumb: "assets/img/annapoorna/31.jpeg",
    },
    {
      src: "assets/img/annapoorna/32.jpeg",
      caption: "",
      thumb: "assets/img/annapoorna/32.jpeg",
    },
    {
      src: "assets/img/annapoorna/33.jpeg",
      caption: "",
      thumb: "assets/img/annapoorna/33.jpeg",
    },
    {
      src: "assets/img/annapoorna/34.jpeg",
      caption: "",
      thumb: "assets/img/annapoorna/34.jpeg",
    },
    {
      src: "assets/img/annapoorna/35.jpeg",
      caption: "",
      thumb: "assets/img/annapoorna/35.jpeg",
    },
    {
      src: "assets/img/annapoorna/36.jpeg",
      caption: "",
      thumb: "assets/img/annapoorna/36.jpeg",
    },
    {
      src: "assets/img/annapoorna/37.jpeg",
      caption: "",
      thumb: "assets/img/annapoorna/37.jpeg",
    },
    {
      src: "assets/img/annapoorna/38.jpeg",
      caption: "",
      thumb: "assets/img/annapoorna/38.jpeg",
    },
    {
      src: "assets/img/annapoorna/39.jpeg",
      caption: "",
      thumb: "assets/img/annapoorna/39.jpeg",
    },
    {
      src: "assets/img/annapoorna/40.jpeg",
      caption: "",
      thumb: "assets/img/annapoorna/40.jpeg",
    },
    {
      src: "assets/img/annapoorna/41.jpeg",
      caption: "",
      thumb: "assets/img/annapoorna/41.jpeg",
    },
    {
      src: "assets/img/annapoorna/42.jpeg",
      caption: "",
      thumb: "assets/img/annapoorna/42.jpeg",
    },
    {
      src: "assets/img/annapoorna/43.jpeg",
      caption: "",
      thumb: "assets/img/annapoorna/43.jpeg",
    },
    {
      src: "assets/img/annapoorna/44.jpeg",
      caption: "",
      thumb: "assets/img/annapoorna/44.jpeg",
    },
    {
      src: "assets/img/annapoorna/45.jpeg",
      caption: "",
      thumb: "assets/img/annapoorna/45.jpeg",
    },

    {
      src: "assets/img/annapoorna/1.jpg",
      caption:
        "ത്രിവേണി സപ്ലൈകോയും നിംസ് മെഡിസിറ്റിയും സംയുക്തപങ്കാളിത്തം വഹിക്കുന്ന പദ്ധതിയുടെ ഉദ്ഘാടനം നിംസ് മെഡിസിറ്റി മാനേജിങ് ഡയറക്ടർ ശ്രീ എം എസ് ഫൈസൽ ഖാനും gynecology വിഭാഗം മേധാവി ശ്രീമതി Dr ലക്ഷ്മി ബി ഉണ്ണിയും ചേർന്നു ഡിസ്ചാർജ് ആയ രോഗിക്ക് നൽകി തുടക്കം കുറിച്ചു. ജാഗ്രതയാണ് നമ്മുടെ ആയുധം, ജാഗ്രതയോടെ പൊരുതി മുന്നേറാൻ നിംസ് കുടുംബം നിങ്ങളോടൊപ്പം.",
      thumb: "assets/img/annapoorna/1.jpg",
    },
    {
      src: "assets/img/annapoorna/2.jpg",
      caption: "കോവിഡ് കാലവും ജാഗ്രതയും നിംസ് മെഡിസിറ്റിക്കൊപ്പം.",
      thumb: "assets/img/annapoorna/2.jpg",
    },
    {
      src: "assets/img/annapoorna/3.jpg",
      caption:
        "നമ്മൾ എല്ലാപേരും അതിജീവനത്തിന്റെ മാറ്റൊലികൾ തീർത്തു ഒരു മാറ്റത്തിനായി നാളെയുടെ നല്ല പ്രഭാതങ്ങളെ സ്വപ്നങ്ങൾ കാണാൻ തുടങ്ങിയിട്ടു നാളേറെയായി. കോവിഡ് മഹാമാരി ഉറഞ്ഞു തുള്ളുന്ന ഈ സാഹചര്യത്തിൽ നമ്മളാൽ കഴിയുന്ന രീതിയിൽ സാധാരണക്കാരെ സഹായിക്കാൻ നിംസ് കുടുംബം സദാ പ്രതിജ്ഞാബദ്ധരാണ്.സാധാരണകാർക്കും അതുപോലെ നിംസിന്റെ സഹായങ്ങൾ തേടിവരുന്നവർക്കും ഒരുപോലെ ഉപകാരപ്രദമാകും വിധം നിംസ് കുടുംബത്തിന്റെ ഭക്ഷ്യ സുരക്ഷാ പദ്ധതി ആവിഷ്കരിച്ചിരിക്കുന്നു....",
      thumb: "assets/img/annapoorna/3.jpg",
    },
    {
      src: "assets/img/annapoorna/4.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയിൽ നിന്നും ഡിസ്ചാർജ് ആയി പോകുന്നവർക്ക്‌ ഞങ്ങൾ ചികിത്സയിൽ നൽകി വരുന്ന ജാഗ്രതയും വിശ്വാസവും അതേപടി നിലനിർത്തുക എന്നതാണ് ഈ പദ്ധതികൊണ്ട് പ്രധാനമായി ഉദ്വേശിക്കുന്നത്. നിംസിൽ നൽകി വരുന്ന സാമ്പത്തിക സഹായങ്ങളെ അടിസ്ഥാനമാക്കി ഡിസ്ചാർജ് ആകുന്ന ഓരോ രോഗികൾക്കും ഞങ്ങൾ ഒരു കൂപ്പൺ നൽകിവരുന്നു.",
      thumb: "assets/img/annapoorna/4.jpg",
    },
    {
      src: "assets/img/annapoorna/6.jpg",
      caption:
        "പ്രിയപ്പെട്ടവർ ആശുപത്രി വാസം കഴിഞ്ഞു പോകുമ്പോൾ നിംസ് അങ്കണത്തിൽ തന്നെ ഉള്ള ത്രിവേണി സപ്ലൈക്കോ വാഹനത്തിൽ നിന്നും വരുന്ന ദിവസങ്ങളിൽ അവർക്കു വേണ്ടി വരുന്ന എല്ലാവിധ സാധനങ്ങളും അവരുടെ ഇഷ്ടാനുസരണം ഈ കൂപ്പൺ നൽകി വാങ്ങാൻ കഴിയും.. സുരക്ഷിതമായി വീടുകളിൽ എത്തുന്ന പ്രിയപ്പെട്ടവർ പോകുന്ന വഴിക്കോ വീട്ടിൽ എത്തിയിട്ടോ പിന്നെ സാധനങ്ങൾ വാങ്ങാൻ പുറത്തിറങ്ങേണ്ട സാഹചര്യം ഒഴിവാക്കുക എന്നതാണ് ഞങ്ങളുടെ ലക്ഷ്യം. കോവിഡ് മഹാമാരി രൂക്ഷമായ ഈ സാഹചര്യം നമ്മൾ ഓരോരുത്തരും ജാഗ്രതയോടെ മുന്നേറേണ്ടത് വളരെ അത്യാവശ്യമാണ്.",
      thumb: "assets/img/annapoorna/6.jpg",
    },
    {
      src: "assets/img/annapoorna/5.jpg",
      caption: "",
      thumb: "assets/img/annapoorna/5.jpg",
    },
    {
      src: "assets/img/annapoorna/7.jpg",
      caption: "",
      thumb: "assets/img/annapoorna/7.jpg",
    },
  ];
  Pension_Scheme: Array<{ src: string; caption: string; thumb: string }> = [
    {
      src: "assets/img/pensionscheme/296.jpg",
      caption: "നെയ്യാറ്റിൻകര പെൻഷൻ പ്ലാനിലെ കുട്ടികൾക്ക് അവരുടെ സ്പെഷ്യൽ ദിനങ്ങളെല്ലാം ആഘോഷമാണ്. 2025 മാർച്ച് 21 ലോക  ഡൗൺ സിൻഡ്രോം ദിനം വളരെ ഗംഭീരമായി നിംസ് സ്പെക്ട്രം ഹാളിൽ വച്ച് ആചരിക്കുകയുണ്ടായി. കുട്ടികൾക്ക് പാട്ടും നൃത്തവും ചെറു മത്സരങ്ങളും പ്രോത്സാഹന സമ്മാനവും നൽകി. ചടങ്ങിൽ മുഖ്യ അതിഥി യായ ശ്രീ. ജിമ്മി മാനുവൽ, ചെയർമാൻ, ഹീമോഫീലിയ ഫെഡറേഷൻ ഓഫ് ഇന്ത്യ,തിരുവനന്തപുരം ഭദ്രദീപം കൊളുത്തി ഉദ്ഘാടനം ചെയ്തു. ഉദ്ഘാടന പ്രസംഗത്തിൽ അദ്ദേഹം അഭിപ്രായപ്പെട്ടത് ഇങ്ങനെയാണ് 'നിരവധി ജീവകാരുണ്യ പ്രവർത്തനങ്ങൾ ചെയ്യുന്ന നിംസ് മെഡിസിറ്റി മാനേജിങ്ങ് ഡയറക്ടർ ശ്രീ. എം എസ് ഫൈസൽ ഖാൻ സാറിൻ്റെ ഏറെ മഹത്തരമായ സേവനമാണ് നെയ്യാറ്റിൻകര പെൻഷൻ പ്ലാനിലൂടെ ചെയ്യുന്ന നിരവധി സേവനങ്ങൾ '. ചടങ്ങിൻ്റ ഉദ്ദേശ ലക്ഷ്യങ്ങളെക്കുറിച്ച് ഫോർമർ ആരോഗ്യ സർവ്വകലാശാല വൈസ് ചാൻസലറും നിംസ് സ്പെക്ട്രം ഡയറക്ടറുമായ Prof(Dr) M.K.C Nair D.Sc, വ്യക്തമാക്കി. നിംസ് മെഡിസിറ്റി ജനറൽ മാനേജർ ഡോ. സജു. കെ.എ. മുഖ്യ പ്രഭാഷണം നടത്തി. വിമൻ ആൻ്റ്  ചൈൽഡ് ഡെവലപ്മെൻ്റ് ഡിപ്പാർട്ട്മെൻ്റിലെ ശ്രീ. ജോസഫ് രാജൻ, നിംസ് മെഡിസിറ്റി ചീഫ് കൺസൾട്ടന്റ് ഫിസിയോതെറാപ്പിസ്റ്റ്, ഡോ. ജിം ഗോപാലകൃഷ്ണൻ  തുടങ്ങിയവർ ആശംസയും നേർന്നു. ജനറ്റിക് ഡിപ്പാർട്ട്മെന്റ് ഡോ.  ലക്ഷ്മി പെൻഷൻ പ്ലാനിലെ അമ്മമാർക്ക് ബോധവൽക്കരണ ക്ലാസ് എടുക്കുകയും പെൻഷൻ പ്ലാനിലെ കുട്ടികൾക്ക് ജനറ്റിക് സിപ്പാർട്ട്മെൻ്റിൽ  സൗജന്യ ഒ.പി. കൺസൾട്ടേഷൻ തിങ്കളാഴ്ച മുതൽ ആരംഭിക്കും. നിംസ് ജറിയാട്രിക് കോർഡിനേറ്റർ ശ്രീമതി. രേണു. കെ.ആർ. പെൻഷൻ പ്ലാൻ വിശദീകരണം നടത്തി. നിംസ് സ്പക്ട്രം കോഡിനേറ്റർ ശ്രീ. റിഫായി അബ്ദുൾറഹിം , ചീഫ് ഡവലപ്മെൻ്റ് തെറാപ്പിസ്റ്റ് ശ്രീമതി സ്വപ്ന , ഡവലപ്മെൻ്റ് നഴ്സിങ്ങ് കൗൺസിലർ ശ്രീമതി അശ്വതി , നഴ്സിങ്ങ് , ദന്തൽ YRC സ്റ്റുഡൻസ്, നിംസ് ദന്തൽ കോളേജ് കോഡിനേറ്റർ ഡോ. അംബിക, ശ്രീമതി. ഷബ്ന  തുടങ്ങിയവരുടെ സജീവപങ്കാളിത്തമുണ്ടായിരുന്നു. ശ്രീ ബോബി, ഫോർമർ പ്രോജക്ട് കോ ഓർഡിനേറ്റർ പോളിയോ ഹോം , നന്ദി രേഖപ്പെടുത്തി.വിശിഷ്ടാതിഥികൾക്ക് നിംസ് മാനേജിങ്ങ് ഡയറക്ടർ ശ്രീ. എം. എസ് ഫൈസൽ ഖാൻ രചിച്ച 'യന്ത്രക്കസേര' എന്ന നോവൽ വായനക്കായി നൽകുകയുണ്ടായി.",
      thumb: "assets/img/pensionscheme/296.jpg",
    },
    {
      src: "assets/img/pensionscheme/297.jpg",
      caption: "നെയ്യാറ്റിൻകര പെൻഷൻ പ്ലാനിലെ കുട്ടികൾക്ക് അവരുടെ സ്പെഷ്യൽ ദിനങ്ങളെല്ലാം ആഘോഷമാണ്. 2025 മാർച്ച് 21 ലോക  ഡൗൺ സിൻഡ്രോം ദിനം വളരെ ഗംഭീരമായി നിംസ് സ്പെക്ട്രം ഹാളിൽ വച്ച് ആചരിക്കുകയുണ്ടായി. കുട്ടികൾക്ക് പാട്ടും നൃത്തവും ചെറു മത്സരങ്ങളും പ്രോത്സാഹന സമ്മാനവും നൽകി. ചടങ്ങിൽ മുഖ്യ അതിഥി യായ ശ്രീ. ജിമ്മി മാനുവൽ, ചെയർമാൻ, ഹീമോഫീലിയ ഫെഡറേഷൻ ഓഫ് ഇന്ത്യ,തിരുവനന്തപുരം ഭദ്രദീപം കൊളുത്തി ഉദ്ഘാടനം ചെയ്തു. ഉദ്ഘാടന പ്രസംഗത്തിൽ അദ്ദേഹം അഭിപ്രായപ്പെട്ടത് ഇങ്ങനെയാണ് 'നിരവധി ജീവകാരുണ്യ പ്രവർത്തനങ്ങൾ ചെയ്യുന്ന നിംസ് മെഡിസിറ്റി മാനേജിങ്ങ് ഡയറക്ടർ ശ്രീ. എം എസ് ഫൈസൽ ഖാൻ സാറിൻ്റെ ഏറെ മഹത്തരമായ സേവനമാണ് നെയ്യാറ്റിൻകര പെൻഷൻ പ്ലാനിലൂടെ ചെയ്യുന്ന നിരവധി സേവനങ്ങൾ '. ചടങ്ങിൻ്റ ഉദ്ദേശ ലക്ഷ്യങ്ങളെക്കുറിച്ച് ഫോർമർ ആരോഗ്യ സർവ്വകലാശാല വൈസ് ചാൻസലറും നിംസ് സ്പെക്ട്രം ഡയറക്ടറുമായ Prof(Dr) M.K.C Nair D.Sc, വ്യക്തമാക്കി. നിംസ് മെഡിസിറ്റി ജനറൽ മാനേജർ ഡോ. സജു. കെ.എ. മുഖ്യ പ്രഭാഷണം നടത്തി. വിമൻ ആൻ്റ്  ചൈൽഡ് ഡെവലപ്മെൻ്റ് ഡിപ്പാർട്ട്മെൻ്റിലെ ശ്രീ. ജോസഫ് രാജൻ, നിംസ് മെഡിസിറ്റി ചീഫ് കൺസൾട്ടന്റ് ഫിസിയോതെറാപ്പിസ്റ്റ്, ഡോ. ജിം ഗോപാലകൃഷ്ണൻ  തുടങ്ങിയവർ ആശംസയും നേർന്നു. ജനറ്റിക് ഡിപ്പാർട്ട്മെന്റ് ഡോ.  ലക്ഷ്മി പെൻഷൻ പ്ലാനിലെ അമ്മമാർക്ക് ബോധവൽക്കരണ ക്ലാസ് എടുക്കുകയും പെൻഷൻ പ്ലാനിലെ കുട്ടികൾക്ക് ജനറ്റിക് സിപ്പാർട്ട്മെൻ്റിൽ  സൗജന്യ ഒ.പി. കൺസൾട്ടേഷൻ തിങ്കളാഴ്ച മുതൽ ആരംഭിക്കും. നിംസ് ജറിയാട്രിക് കോർഡിനേറ്റർ ശ്രീമതി. രേണു. കെ.ആർ. പെൻഷൻ പ്ലാൻ വിശദീകരണം നടത്തി. നിംസ് സ്പക്ട്രം കോഡിനേറ്റർ ശ്രീ. റിഫായി അബ്ദുൾറഹിം , ചീഫ് ഡവലപ്മെൻ്റ് തെറാപ്പിസ്റ്റ് ശ്രീമതി സ്വപ്ന , ഡവലപ്മെൻ്റ് നഴ്സിങ്ങ് കൗൺസിലർ ശ്രീമതി അശ്വതി , നഴ്സിങ്ങ് , ദന്തൽ YRC സ്റ്റുഡൻസ്, നിംസ് ദന്തൽ കോളേജ് കോഡിനേറ്റർ ഡോ. അംബിക, ശ്രീമതി. ഷബ്ന  തുടങ്ങിയവരുടെ സജീവപങ്കാളിത്തമുണ്ടായിരുന്നു. ശ്രീ ബോബി, ഫോർമർ പ്രോജക്ട് കോ ഓർഡിനേറ്റർ പോളിയോ ഹോം , നന്ദി രേഖപ്പെടുത്തി.വിശിഷ്ടാതിഥികൾക്ക് നിംസ് മാനേജിങ്ങ് ഡയറക്ടർ ശ്രീ. എം. എസ് ഫൈസൽ ഖാൻ രചിച്ച 'യന്ത്രക്കസേര' എന്ന നോവൽ വായനക്കായി നൽകുകയുണ്ടായി.",
      thumb: "assets/img/pensionscheme/297.jpg",
    },
    {
      src: "assets/img/pensionscheme/298.jpg",
      caption: "നെയ്യാറ്റിൻകര പെൻഷൻ പ്ലാനിലെ കുട്ടികൾക്ക് അവരുടെ സ്പെഷ്യൽ ദിനങ്ങളെല്ലാം ആഘോഷമാണ്. 2025 മാർച്ച് 21 ലോക  ഡൗൺ സിൻഡ്രോം ദിനം വളരെ ഗംഭീരമായി നിംസ് സ്പെക്ട്രം ഹാളിൽ വച്ച് ആചരിക്കുകയുണ്ടായി. കുട്ടികൾക്ക് പാട്ടും നൃത്തവും ചെറു മത്സരങ്ങളും പ്രോത്സാഹന സമ്മാനവും നൽകി. ചടങ്ങിൽ മുഖ്യ അതിഥി യായ ശ്രീ. ജിമ്മി മാനുവൽ, ചെയർമാൻ, ഹീമോഫീലിയ ഫെഡറേഷൻ ഓഫ് ഇന്ത്യ,തിരുവനന്തപുരം ഭദ്രദീപം കൊളുത്തി ഉദ്ഘാടനം ചെയ്തു. ഉദ്ഘാടന പ്രസംഗത്തിൽ അദ്ദേഹം അഭിപ്രായപ്പെട്ടത് ഇങ്ങനെയാണ് 'നിരവധി ജീവകാരുണ്യ പ്രവർത്തനങ്ങൾ ചെയ്യുന്ന നിംസ് മെഡിസിറ്റി മാനേജിങ്ങ് ഡയറക്ടർ ശ്രീ. എം എസ് ഫൈസൽ ഖാൻ സാറിൻ്റെ ഏറെ മഹത്തരമായ സേവനമാണ് നെയ്യാറ്റിൻകര പെൻഷൻ പ്ലാനിലൂടെ ചെയ്യുന്ന നിരവധി സേവനങ്ങൾ '. ചടങ്ങിൻ്റ ഉദ്ദേശ ലക്ഷ്യങ്ങളെക്കുറിച്ച് ഫോർമർ ആരോഗ്യ സർവ്വകലാശാല വൈസ് ചാൻസലറും നിംസ് സ്പെക്ട്രം ഡയറക്ടറുമായ Prof(Dr) M.K.C Nair D.Sc, വ്യക്തമാക്കി. നിംസ് മെഡിസിറ്റി ജനറൽ മാനേജർ ഡോ. സജു. കെ.എ. മുഖ്യ പ്രഭാഷണം നടത്തി. വിമൻ ആൻ്റ്  ചൈൽഡ് ഡെവലപ്മെൻ്റ് ഡിപ്പാർട്ട്മെൻ്റിലെ ശ്രീ. ജോസഫ് രാജൻ, നിംസ് മെഡിസിറ്റി ചീഫ് കൺസൾട്ടന്റ് ഫിസിയോതെറാപ്പിസ്റ്റ്, ഡോ. ജിം ഗോപാലകൃഷ്ണൻ  തുടങ്ങിയവർ ആശംസയും നേർന്നു. ജനറ്റിക് ഡിപ്പാർട്ട്മെന്റ് ഡോ.  ലക്ഷ്മി പെൻഷൻ പ്ലാനിലെ അമ്മമാർക്ക് ബോധവൽക്കരണ ക്ലാസ് എടുക്കുകയും പെൻഷൻ പ്ലാനിലെ കുട്ടികൾക്ക് ജനറ്റിക് സിപ്പാർട്ട്മെൻ്റിൽ  സൗജന്യ ഒ.പി. കൺസൾട്ടേഷൻ തിങ്കളാഴ്ച മുതൽ ആരംഭിക്കും. നിംസ് ജറിയാട്രിക് കോർഡിനേറ്റർ ശ്രീമതി. രേണു. കെ.ആർ. പെൻഷൻ പ്ലാൻ വിശദീകരണം നടത്തി. നിംസ് സ്പക്ട്രം കോഡിനേറ്റർ ശ്രീ. റിഫായി അബ്ദുൾറഹിം , ചീഫ് ഡവലപ്മെൻ്റ് തെറാപ്പിസ്റ്റ് ശ്രീമതി സ്വപ്ന , ഡവലപ്മെൻ്റ് നഴ്സിങ്ങ് കൗൺസിലർ ശ്രീമതി അശ്വതി , നഴ്സിങ്ങ് , ദന്തൽ YRC സ്റ്റുഡൻസ്, നിംസ് ദന്തൽ കോളേജ് കോഡിനേറ്റർ ഡോ. അംബിക, ശ്രീമതി. ഷബ്ന  തുടങ്ങിയവരുടെ സജീവപങ്കാളിത്തമുണ്ടായിരുന്നു. ശ്രീ ബോബി, ഫോർമർ പ്രോജക്ട് കോ ഓർഡിനേറ്റർ പോളിയോ ഹോം , നന്ദി രേഖപ്പെടുത്തി.വിശിഷ്ടാതിഥികൾക്ക് നിംസ് മാനേജിങ്ങ് ഡയറക്ടർ ശ്രീ. എം. എസ് ഫൈസൽ ഖാൻ രചിച്ച 'യന്ത്രക്കസേര' എന്ന നോവൽ വായനക്കായി നൽകുകയുണ്ടായി.",
      thumb: "assets/img/pensionscheme/298.jpg",
    },
    {
      src: "assets/img/pensionscheme/299.jpg",
      caption: "നെയ്യാറ്റിൻകര പെൻഷൻ പ്ലാനിലെ കുട്ടികൾക്ക് അവരുടെ സ്പെഷ്യൽ ദിനങ്ങളെല്ലാം ആഘോഷമാണ്. 2025 മാർച്ച് 21 ലോക  ഡൗൺ സിൻഡ്രോം ദിനം വളരെ ഗംഭീരമായി നിംസ് സ്പെക്ട്രം ഹാളിൽ വച്ച് ആചരിക്കുകയുണ്ടായി. കുട്ടികൾക്ക് പാട്ടും നൃത്തവും ചെറു മത്സരങ്ങളും പ്രോത്സാഹന സമ്മാനവും നൽകി. ചടങ്ങിൽ മുഖ്യ അതിഥി യായ ശ്രീ. ജിമ്മി മാനുവൽ, ചെയർമാൻ, ഹീമോഫീലിയ ഫെഡറേഷൻ ഓഫ് ഇന്ത്യ,തിരുവനന്തപുരം ഭദ്രദീപം കൊളുത്തി ഉദ്ഘാടനം ചെയ്തു. ഉദ്ഘാടന പ്രസംഗത്തിൽ അദ്ദേഹം അഭിപ്രായപ്പെട്ടത് ഇങ്ങനെയാണ് 'നിരവധി ജീവകാരുണ്യ പ്രവർത്തനങ്ങൾ ചെയ്യുന്ന നിംസ് മെഡിസിറ്റി മാനേജിങ്ങ് ഡയറക്ടർ ശ്രീ. എം എസ് ഫൈസൽ ഖാൻ സാറിൻ്റെ ഏറെ മഹത്തരമായ സേവനമാണ് നെയ്യാറ്റിൻകര പെൻഷൻ പ്ലാനിലൂടെ ചെയ്യുന്ന നിരവധി സേവനങ്ങൾ '. ചടങ്ങിൻ്റ ഉദ്ദേശ ലക്ഷ്യങ്ങളെക്കുറിച്ച് ഫോർമർ ആരോഗ്യ സർവ്വകലാശാല വൈസ് ചാൻസലറും നിംസ് സ്പെക്ട്രം ഡയറക്ടറുമായ Prof(Dr) M.K.C Nair D.Sc, വ്യക്തമാക്കി. നിംസ് മെഡിസിറ്റി ജനറൽ മാനേജർ ഡോ. സജു. കെ.എ. മുഖ്യ പ്രഭാഷണം നടത്തി. വിമൻ ആൻ്റ്  ചൈൽഡ് ഡെവലപ്മെൻ്റ് ഡിപ്പാർട്ട്മെൻ്റിലെ ശ്രീ. ജോസഫ് രാജൻ, നിംസ് മെഡിസിറ്റി ചീഫ് കൺസൾട്ടന്റ് ഫിസിയോതെറാപ്പിസ്റ്റ്, ഡോ. ജിം ഗോപാലകൃഷ്ണൻ  തുടങ്ങിയവർ ആശംസയും നേർന്നു. ജനറ്റിക് ഡിപ്പാർട്ട്മെന്റ് ഡോ.  ലക്ഷ്മി പെൻഷൻ പ്ലാനിലെ അമ്മമാർക്ക് ബോധവൽക്കരണ ക്ലാസ് എടുക്കുകയും പെൻഷൻ പ്ലാനിലെ കുട്ടികൾക്ക് ജനറ്റിക് സിപ്പാർട്ട്മെൻ്റിൽ  സൗജന്യ ഒ.പി. കൺസൾട്ടേഷൻ തിങ്കളാഴ്ച മുതൽ ആരംഭിക്കും. നിംസ് ജറിയാട്രിക് കോർഡിനേറ്റർ ശ്രീമതി. രേണു. കെ.ആർ. പെൻഷൻ പ്ലാൻ വിശദീകരണം നടത്തി. നിംസ് സ്പക്ട്രം കോഡിനേറ്റർ ശ്രീ. റിഫായി അബ്ദുൾറഹിം , ചീഫ് ഡവലപ്മെൻ്റ് തെറാപ്പിസ്റ്റ് ശ്രീമതി സ്വപ്ന , ഡവലപ്മെൻ്റ് നഴ്സിങ്ങ് കൗൺസിലർ ശ്രീമതി അശ്വതി , നഴ്സിങ്ങ് , ദന്തൽ YRC സ്റ്റുഡൻസ്, നിംസ് ദന്തൽ കോളേജ് കോഡിനേറ്റർ ഡോ. അംബിക, ശ്രീമതി. ഷബ്ന  തുടങ്ങിയവരുടെ സജീവപങ്കാളിത്തമുണ്ടായിരുന്നു. ശ്രീ ബോബി, ഫോർമർ പ്രോജക്ട് കോ ഓർഡിനേറ്റർ പോളിയോ ഹോം , നന്ദി രേഖപ്പെടുത്തി.വിശിഷ്ടാതിഥികൾക്ക് നിംസ് മാനേജിങ്ങ് ഡയറക്ടർ ശ്രീ. എം. എസ് ഫൈസൽ ഖാൻ രചിച്ച 'യന്ത്രക്കസേര' എന്ന നോവൽ വായനക്കായി നൽകുകയുണ്ടായി.",
      thumb: "assets/img/pensionscheme/299.jpg",
    },
    {
      src: "assets/img/pensionscheme/300.jpg",
      caption: "നെയ്യാറ്റിൻകര പെൻഷൻ പ്ലാനിലെ കുട്ടികൾക്ക് അവരുടെ സ്പെഷ്യൽ ദിനങ്ങളെല്ലാം ആഘോഷമാണ്. 2025 മാർച്ച് 21 ലോക  ഡൗൺ സിൻഡ്രോം ദിനം വളരെ ഗംഭീരമായി നിംസ് സ്പെക്ട്രം ഹാളിൽ വച്ച് ആചരിക്കുകയുണ്ടായി. കുട്ടികൾക്ക് പാട്ടും നൃത്തവും ചെറു മത്സരങ്ങളും പ്രോത്സാഹന സമ്മാനവും നൽകി. ചടങ്ങിൽ മുഖ്യ അതിഥി യായ ശ്രീ. ജിമ്മി മാനുവൽ, ചെയർമാൻ, ഹീമോഫീലിയ ഫെഡറേഷൻ ഓഫ് ഇന്ത്യ,തിരുവനന്തപുരം ഭദ്രദീപം കൊളുത്തി ഉദ്ഘാടനം ചെയ്തു. ഉദ്ഘാടന പ്രസംഗത്തിൽ അദ്ദേഹം അഭിപ്രായപ്പെട്ടത് ഇങ്ങനെയാണ് 'നിരവധി ജീവകാരുണ്യ പ്രവർത്തനങ്ങൾ ചെയ്യുന്ന നിംസ് മെഡിസിറ്റി മാനേജിങ്ങ് ഡയറക്ടർ ശ്രീ. എം എസ് ഫൈസൽ ഖാൻ സാറിൻ്റെ ഏറെ മഹത്തരമായ സേവനമാണ് നെയ്യാറ്റിൻകര പെൻഷൻ പ്ലാനിലൂടെ ചെയ്യുന്ന നിരവധി സേവനങ്ങൾ '. ചടങ്ങിൻ്റ ഉദ്ദേശ ലക്ഷ്യങ്ങളെക്കുറിച്ച് ഫോർമർ ആരോഗ്യ സർവ്വകലാശാല വൈസ് ചാൻസലറും നിംസ് സ്പെക്ട്രം ഡയറക്ടറുമായ Prof(Dr) M.K.C Nair D.Sc, വ്യക്തമാക്കി. നിംസ് മെഡിസിറ്റി ജനറൽ മാനേജർ ഡോ. സജു. കെ.എ. മുഖ്യ പ്രഭാഷണം നടത്തി. വിമൻ ആൻ്റ്  ചൈൽഡ് ഡെവലപ്മെൻ്റ് ഡിപ്പാർട്ട്മെൻ്റിലെ ശ്രീ. ജോസഫ് രാജൻ, നിംസ് മെഡിസിറ്റി ചീഫ് കൺസൾട്ടന്റ് ഫിസിയോതെറാപ്പിസ്റ്റ്, ഡോ. ജിം ഗോപാലകൃഷ്ണൻ  തുടങ്ങിയവർ ആശംസയും നേർന്നു. ജനറ്റിക് ഡിപ്പാർട്ട്മെന്റ് ഡോ.  ലക്ഷ്മി പെൻഷൻ പ്ലാനിലെ അമ്മമാർക്ക് ബോധവൽക്കരണ ക്ലാസ് എടുക്കുകയും പെൻഷൻ പ്ലാനിലെ കുട്ടികൾക്ക് ജനറ്റിക് സിപ്പാർട്ട്മെൻ്റിൽ  സൗജന്യ ഒ.പി. കൺസൾട്ടേഷൻ തിങ്കളാഴ്ച മുതൽ ആരംഭിക്കും. നിംസ് ജറിയാട്രിക് കോർഡിനേറ്റർ ശ്രീമതി. രേണു. കെ.ആർ. പെൻഷൻ പ്ലാൻ വിശദീകരണം നടത്തി. നിംസ് സ്പക്ട്രം കോഡിനേറ്റർ ശ്രീ. റിഫായി അബ്ദുൾറഹിം , ചീഫ് ഡവലപ്മെൻ്റ് തെറാപ്പിസ്റ്റ് ശ്രീമതി സ്വപ്ന , ഡവലപ്മെൻ്റ് നഴ്സിങ്ങ് കൗൺസിലർ ശ്രീമതി അശ്വതി , നഴ്സിങ്ങ് , ദന്തൽ YRC സ്റ്റുഡൻസ്, നിംസ് ദന്തൽ കോളേജ് കോഡിനേറ്റർ ഡോ. അംബിക, ശ്രീമതി. ഷബ്ന  തുടങ്ങിയവരുടെ സജീവപങ്കാളിത്തമുണ്ടായിരുന്നു. ശ്രീ ബോബി, ഫോർമർ പ്രോജക്ട് കോ ഓർഡിനേറ്റർ പോളിയോ ഹോം , നന്ദി രേഖപ്പെടുത്തി.വിശിഷ്ടാതിഥികൾക്ക് നിംസ് മാനേജിങ്ങ് ഡയറക്ടർ ശ്രീ. എം. എസ് ഫൈസൽ ഖാൻ രചിച്ച 'യന്ത്രക്കസേര' എന്ന നോവൽ വായനക്കായി നൽകുകയുണ്ടായി.",
      thumb: "assets/img/pensionscheme/300.jpg",
    },
    {
      src: "assets/img/pensionscheme/301.jpg",
      caption: "നെയ്യാറ്റിൻകര പെൻഷൻ പ്ലാനിലെ കുട്ടികൾക്ക് അവരുടെ സ്പെഷ്യൽ ദിനങ്ങളെല്ലാം ആഘോഷമാണ്. 2025 മാർച്ച് 21 ലോക  ഡൗൺ സിൻഡ്രോം ദിനം വളരെ ഗംഭീരമായി നിംസ് സ്പെക്ട്രം ഹാളിൽ വച്ച് ആചരിക്കുകയുണ്ടായി. കുട്ടികൾക്ക് പാട്ടും നൃത്തവും ചെറു മത്സരങ്ങളും പ്രോത്സാഹന സമ്മാനവും നൽകി. ചടങ്ങിൽ മുഖ്യ അതിഥി യായ ശ്രീ. ജിമ്മി മാനുവൽ, ചെയർമാൻ, ഹീമോഫീലിയ ഫെഡറേഷൻ ഓഫ് ഇന്ത്യ,തിരുവനന്തപുരം ഭദ്രദീപം കൊളുത്തി ഉദ്ഘാടനം ചെയ്തു. ഉദ്ഘാടന പ്രസംഗത്തിൽ അദ്ദേഹം അഭിപ്രായപ്പെട്ടത് ഇങ്ങനെയാണ് 'നിരവധി ജീവകാരുണ്യ പ്രവർത്തനങ്ങൾ ചെയ്യുന്ന നിംസ് മെഡിസിറ്റി മാനേജിങ്ങ് ഡയറക്ടർ ശ്രീ. എം എസ് ഫൈസൽ ഖാൻ സാറിൻ്റെ ഏറെ മഹത്തരമായ സേവനമാണ് നെയ്യാറ്റിൻകര പെൻഷൻ പ്ലാനിലൂടെ ചെയ്യുന്ന നിരവധി സേവനങ്ങൾ '. ചടങ്ങിൻ്റ ഉദ്ദേശ ലക്ഷ്യങ്ങളെക്കുറിച്ച് ഫോർമർ ആരോഗ്യ സർവ്വകലാശാല വൈസ് ചാൻസലറും നിംസ് സ്പെക്ട്രം ഡയറക്ടറുമായ Prof(Dr) M.K.C Nair D.Sc, വ്യക്തമാക്കി. നിംസ് മെഡിസിറ്റി ജനറൽ മാനേജർ ഡോ. സജു. കെ.എ. മുഖ്യ പ്രഭാഷണം നടത്തി. വിമൻ ആൻ്റ്  ചൈൽഡ് ഡെവലപ്മെൻ്റ് ഡിപ്പാർട്ട്മെൻ്റിലെ ശ്രീ. ജോസഫ് രാജൻ, നിംസ് മെഡിസിറ്റി ചീഫ് കൺസൾട്ടന്റ് ഫിസിയോതെറാപ്പിസ്റ്റ്, ഡോ. ജിം ഗോപാലകൃഷ്ണൻ  തുടങ്ങിയവർ ആശംസയും നേർന്നു. ജനറ്റിക് ഡിപ്പാർട്ട്മെന്റ് ഡോ.  ലക്ഷ്മി പെൻഷൻ പ്ലാനിലെ അമ്മമാർക്ക് ബോധവൽക്കരണ ക്ലാസ് എടുക്കുകയും പെൻഷൻ പ്ലാനിലെ കുട്ടികൾക്ക് ജനറ്റിക് സിപ്പാർട്ട്മെൻ്റിൽ  സൗജന്യ ഒ.പി. കൺസൾട്ടേഷൻ തിങ്കളാഴ്ച മുതൽ ആരംഭിക്കും. നിംസ് ജറിയാട്രിക് കോർഡിനേറ്റർ ശ്രീമതി. രേണു. കെ.ആർ. പെൻഷൻ പ്ലാൻ വിശദീകരണം നടത്തി. നിംസ് സ്പക്ട്രം കോഡിനേറ്റർ ശ്രീ. റിഫായി അബ്ദുൾറഹിം , ചീഫ് ഡവലപ്മെൻ്റ് തെറാപ്പിസ്റ്റ് ശ്രീമതി സ്വപ്ന , ഡവലപ്മെൻ്റ് നഴ്സിങ്ങ് കൗൺസിലർ ശ്രീമതി അശ്വതി , നഴ്സിങ്ങ് , ദന്തൽ YRC സ്റ്റുഡൻസ്, നിംസ് ദന്തൽ കോളേജ് കോഡിനേറ്റർ ഡോ. അംബിക, ശ്രീമതി. ഷബ്ന  തുടങ്ങിയവരുടെ സജീവപങ്കാളിത്തമുണ്ടായിരുന്നു. ശ്രീ ബോബി, ഫോർമർ പ്രോജക്ട് കോ ഓർഡിനേറ്റർ പോളിയോ ഹോം , നന്ദി രേഖപ്പെടുത്തി.വിശിഷ്ടാതിഥികൾക്ക് നിംസ് മാനേജിങ്ങ് ഡയറക്ടർ ശ്രീ. എം. എസ് ഫൈസൽ ഖാൻ രചിച്ച 'യന്ത്രക്കസേര' എന്ന നോവൽ വായനക്കായി നൽകുകയുണ്ടായി.",
      thumb: "assets/img/pensionscheme/301.jpg",
    },
    {
      src: "assets/img/pensionscheme/302.jpg",
      caption: "നെയ്യാറ്റിൻകര പെൻഷൻ പ്ലാനിലെ കുട്ടികൾക്ക് അവരുടെ സ്പെഷ്യൽ ദിനങ്ങളെല്ലാം ആഘോഷമാണ്. 2025 മാർച്ച് 21 ലോക  ഡൗൺ സിൻഡ്രോം ദിനം വളരെ ഗംഭീരമായി നിംസ് സ്പെക്ട്രം ഹാളിൽ വച്ച് ആചരിക്കുകയുണ്ടായി. കുട്ടികൾക്ക് പാട്ടും നൃത്തവും ചെറു മത്സരങ്ങളും പ്രോത്സാഹന സമ്മാനവും നൽകി. ചടങ്ങിൽ മുഖ്യ അതിഥി യായ ശ്രീ. ജിമ്മി മാനുവൽ, ചെയർമാൻ, ഹീമോഫീലിയ ഫെഡറേഷൻ ഓഫ് ഇന്ത്യ,തിരുവനന്തപുരം ഭദ്രദീപം കൊളുത്തി ഉദ്ഘാടനം ചെയ്തു. ഉദ്ഘാടന പ്രസംഗത്തിൽ അദ്ദേഹം അഭിപ്രായപ്പെട്ടത് ഇങ്ങനെയാണ് 'നിരവധി ജീവകാരുണ്യ പ്രവർത്തനങ്ങൾ ചെയ്യുന്ന നിംസ് മെഡിസിറ്റി മാനേജിങ്ങ് ഡയറക്ടർ ശ്രീ. എം എസ് ഫൈസൽ ഖാൻ സാറിൻ്റെ ഏറെ മഹത്തരമായ സേവനമാണ് നെയ്യാറ്റിൻകര പെൻഷൻ പ്ലാനിലൂടെ ചെയ്യുന്ന നിരവധി സേവനങ്ങൾ '. ചടങ്ങിൻ്റ ഉദ്ദേശ ലക്ഷ്യങ്ങളെക്കുറിച്ച് ഫോർമർ ആരോഗ്യ സർവ്വകലാശാല വൈസ് ചാൻസലറും നിംസ് സ്പെക്ട്രം ഡയറക്ടറുമായ Prof(Dr) M.K.C Nair D.Sc, വ്യക്തമാക്കി. നിംസ് മെഡിസിറ്റി ജനറൽ മാനേജർ ഡോ. സജു. കെ.എ. മുഖ്യ പ്രഭാഷണം നടത്തി. വിമൻ ആൻ്റ്  ചൈൽഡ് ഡെവലപ്മെൻ്റ് ഡിപ്പാർട്ട്മെൻ്റിലെ ശ്രീ. ജോസഫ് രാജൻ, നിംസ് മെഡിസിറ്റി ചീഫ് കൺസൾട്ടന്റ് ഫിസിയോതെറാപ്പിസ്റ്റ്, ഡോ. ജിം ഗോപാലകൃഷ്ണൻ  തുടങ്ങിയവർ ആശംസയും നേർന്നു. ജനറ്റിക് ഡിപ്പാർട്ട്മെന്റ് ഡോ.  ലക്ഷ്മി പെൻഷൻ പ്ലാനിലെ അമ്മമാർക്ക് ബോധവൽക്കരണ ക്ലാസ് എടുക്കുകയും പെൻഷൻ പ്ലാനിലെ കുട്ടികൾക്ക് ജനറ്റിക് സിപ്പാർട്ട്മെൻ്റിൽ  സൗജന്യ ഒ.പി. കൺസൾട്ടേഷൻ തിങ്കളാഴ്ച മുതൽ ആരംഭിക്കും. നിംസ് ജറിയാട്രിക് കോർഡിനേറ്റർ ശ്രീമതി. രേണു. കെ.ആർ. പെൻഷൻ പ്ലാൻ വിശദീകരണം നടത്തി. നിംസ് സ്പക്ട്രം കോഡിനേറ്റർ ശ്രീ. റിഫായി അബ്ദുൾറഹിം , ചീഫ് ഡവലപ്മെൻ്റ് തെറാപ്പിസ്റ്റ് ശ്രീമതി സ്വപ്ന , ഡവലപ്മെൻ്റ് നഴ്സിങ്ങ് കൗൺസിലർ ശ്രീമതി അശ്വതി , നഴ്സിങ്ങ് , ദന്തൽ YRC സ്റ്റുഡൻസ്, നിംസ് ദന്തൽ കോളേജ് കോഡിനേറ്റർ ഡോ. അംബിക, ശ്രീമതി. ഷബ്ന  തുടങ്ങിയവരുടെ സജീവപങ്കാളിത്തമുണ്ടായിരുന്നു. ശ്രീ ബോബി, ഫോർമർ പ്രോജക്ട് കോ ഓർഡിനേറ്റർ പോളിയോ ഹോം , നന്ദി രേഖപ്പെടുത്തി.വിശിഷ്ടാതിഥികൾക്ക് നിംസ് മാനേജിങ്ങ് ഡയറക്ടർ ശ്രീ. എം. എസ് ഫൈസൽ ഖാൻ രചിച്ച 'യന്ത്രക്കസേര' എന്ന നോവൽ വായനക്കായി നൽകുകയുണ്ടായി.",
      thumb: "assets/img/pensionscheme/302.jpg",
    },
    {
      src: "assets/img/pensionscheme/303.jpg",
      caption: "നെയ്യാറ്റിൻകര പെൻഷൻ പ്ലാനിലെ കുട്ടികൾക്ക് അവരുടെ സ്പെഷ്യൽ ദിനങ്ങളെല്ലാം ആഘോഷമാണ്. 2025 മാർച്ച് 21 ലോക  ഡൗൺ സിൻഡ്രോം ദിനം വളരെ ഗംഭീരമായി നിംസ് സ്പെക്ട്രം ഹാളിൽ വച്ച് ആചരിക്കുകയുണ്ടായി. കുട്ടികൾക്ക് പാട്ടും നൃത്തവും ചെറു മത്സരങ്ങളും പ്രോത്സാഹന സമ്മാനവും നൽകി. ചടങ്ങിൽ മുഖ്യ അതിഥി യായ ശ്രീ. ജിമ്മി മാനുവൽ, ചെയർമാൻ, ഹീമോഫീലിയ ഫെഡറേഷൻ ഓഫ് ഇന്ത്യ,തിരുവനന്തപുരം ഭദ്രദീപം കൊളുത്തി ഉദ്ഘാടനം ചെയ്തു. ഉദ്ഘാടന പ്രസംഗത്തിൽ അദ്ദേഹം അഭിപ്രായപ്പെട്ടത് ഇങ്ങനെയാണ് 'നിരവധി ജീവകാരുണ്യ പ്രവർത്തനങ്ങൾ ചെയ്യുന്ന നിംസ് മെഡിസിറ്റി മാനേജിങ്ങ് ഡയറക്ടർ ശ്രീ. എം എസ് ഫൈസൽ ഖാൻ സാറിൻ്റെ ഏറെ മഹത്തരമായ സേവനമാണ് നെയ്യാറ്റിൻകര പെൻഷൻ പ്ലാനിലൂടെ ചെയ്യുന്ന നിരവധി സേവനങ്ങൾ '. ചടങ്ങിൻ്റ ഉദ്ദേശ ലക്ഷ്യങ്ങളെക്കുറിച്ച് ഫോർമർ ആരോഗ്യ സർവ്വകലാശാല വൈസ് ചാൻസലറും നിംസ് സ്പെക്ട്രം ഡയറക്ടറുമായ Prof(Dr) M.K.C Nair D.Sc, വ്യക്തമാക്കി. നിംസ് മെഡിസിറ്റി ജനറൽ മാനേജർ ഡോ. സജു. കെ.എ. മുഖ്യ പ്രഭാഷണം നടത്തി. വിമൻ ആൻ്റ്  ചൈൽഡ് ഡെവലപ്മെൻ്റ് ഡിപ്പാർട്ട്മെൻ്റിലെ ശ്രീ. ജോസഫ് രാജൻ, നിംസ് മെഡിസിറ്റി ചീഫ് കൺസൾട്ടന്റ് ഫിസിയോതെറാപ്പിസ്റ്റ്, ഡോ. ജിം ഗോപാലകൃഷ്ണൻ  തുടങ്ങിയവർ ആശംസയും നേർന്നു. ജനറ്റിക് ഡിപ്പാർട്ട്മെന്റ് ഡോ.  ലക്ഷ്മി പെൻഷൻ പ്ലാനിലെ അമ്മമാർക്ക് ബോധവൽക്കരണ ക്ലാസ് എടുക്കുകയും പെൻഷൻ പ്ലാനിലെ കുട്ടികൾക്ക് ജനറ്റിക് സിപ്പാർട്ട്മെൻ്റിൽ  സൗജന്യ ഒ.പി. കൺസൾട്ടേഷൻ തിങ്കളാഴ്ച മുതൽ ആരംഭിക്കും. നിംസ് ജറിയാട്രിക് കോർഡിനേറ്റർ ശ്രീമതി. രേണു. കെ.ആർ. പെൻഷൻ പ്ലാൻ വിശദീകരണം നടത്തി. നിംസ് സ്പക്ട്രം കോഡിനേറ്റർ ശ്രീ. റിഫായി അബ്ദുൾറഹിം , ചീഫ് ഡവലപ്മെൻ്റ് തെറാപ്പിസ്റ്റ് ശ്രീമതി സ്വപ്ന , ഡവലപ്മെൻ്റ് നഴ്സിങ്ങ് കൗൺസിലർ ശ്രീമതി അശ്വതി , നഴ്സിങ്ങ് , ദന്തൽ YRC സ്റ്റുഡൻസ്, നിംസ് ദന്തൽ കോളേജ് കോഡിനേറ്റർ ഡോ. അംബിക, ശ്രീമതി. ഷബ്ന  തുടങ്ങിയവരുടെ സജീവപങ്കാളിത്തമുണ്ടായിരുന്നു. ശ്രീ ബോബി, ഫോർമർ പ്രോജക്ട് കോ ഓർഡിനേറ്റർ പോളിയോ ഹോം , നന്ദി രേഖപ്പെടുത്തി.വിശിഷ്ടാതിഥികൾക്ക് നിംസ് മാനേജിങ്ങ് ഡയറക്ടർ ശ്രീ. എം. എസ് ഫൈസൽ ഖാൻ രചിച്ച 'യന്ത്രക്കസേര' എന്ന നോവൽ വായനക്കായി നൽകുകയുണ്ടായി.",
      thumb: "assets/img/pensionscheme/303.jpg",
    },
    {
      src: "assets/img/pensionscheme/304.jpg",
      caption: "നെയ്യാറ്റിൻകര പെൻഷൻ പ്ലാനിലെ കുട്ടികൾക്ക് അവരുടെ സ്പെഷ്യൽ ദിനങ്ങളെല്ലാം ആഘോഷമാണ്. 2025 മാർച്ച് 21 ലോക  ഡൗൺ സിൻഡ്രോം ദിനം വളരെ ഗംഭീരമായി നിംസ് സ്പെക്ട്രം ഹാളിൽ വച്ച് ആചരിക്കുകയുണ്ടായി. കുട്ടികൾക്ക് പാട്ടും നൃത്തവും ചെറു മത്സരങ്ങളും പ്രോത്സാഹന സമ്മാനവും നൽകി. ചടങ്ങിൽ മുഖ്യ അതിഥി യായ ശ്രീ. ജിമ്മി മാനുവൽ, ചെയർമാൻ, ഹീമോഫീലിയ ഫെഡറേഷൻ ഓഫ് ഇന്ത്യ,തിരുവനന്തപുരം ഭദ്രദീപം കൊളുത്തി ഉദ്ഘാടനം ചെയ്തു. ഉദ്ഘാടന പ്രസംഗത്തിൽ അദ്ദേഹം അഭിപ്രായപ്പെട്ടത് ഇങ്ങനെയാണ് 'നിരവധി ജീവകാരുണ്യ പ്രവർത്തനങ്ങൾ ചെയ്യുന്ന നിംസ് മെഡിസിറ്റി മാനേജിങ്ങ് ഡയറക്ടർ ശ്രീ. എം എസ് ഫൈസൽ ഖാൻ സാറിൻ്റെ ഏറെ മഹത്തരമായ സേവനമാണ് നെയ്യാറ്റിൻകര പെൻഷൻ പ്ലാനിലൂടെ ചെയ്യുന്ന നിരവധി സേവനങ്ങൾ '. ചടങ്ങിൻ്റ ഉദ്ദേശ ലക്ഷ്യങ്ങളെക്കുറിച്ച് ഫോർമർ ആരോഗ്യ സർവ്വകലാശാല വൈസ് ചാൻസലറും നിംസ് സ്പെക്ട്രം ഡയറക്ടറുമായ Prof(Dr) M.K.C Nair D.Sc, വ്യക്തമാക്കി. നിംസ് മെഡിസിറ്റി ജനറൽ മാനേജർ ഡോ. സജു. കെ.എ. മുഖ്യ പ്രഭാഷണം നടത്തി. വിമൻ ആൻ്റ്  ചൈൽഡ് ഡെവലപ്മെൻ്റ് ഡിപ്പാർട്ട്മെൻ്റിലെ ശ്രീ. ജോസഫ് രാജൻ, നിംസ് മെഡിസിറ്റി ചീഫ് കൺസൾട്ടന്റ് ഫിസിയോതെറാപ്പിസ്റ്റ്, ഡോ. ജിം ഗോപാലകൃഷ്ണൻ  തുടങ്ങിയവർ ആശംസയും നേർന്നു. ജനറ്റിക് ഡിപ്പാർട്ട്മെന്റ് ഡോ.  ലക്ഷ്മി പെൻഷൻ പ്ലാനിലെ അമ്മമാർക്ക് ബോധവൽക്കരണ ക്ലാസ് എടുക്കുകയും പെൻഷൻ പ്ലാനിലെ കുട്ടികൾക്ക് ജനറ്റിക് സിപ്പാർട്ട്മെൻ്റിൽ  സൗജന്യ ഒ.പി. കൺസൾട്ടേഷൻ തിങ്കളാഴ്ച മുതൽ ആരംഭിക്കും. നിംസ് ജറിയാട്രിക് കോർഡിനേറ്റർ ശ്രീമതി. രേണു. കെ.ആർ. പെൻഷൻ പ്ലാൻ വിശദീകരണം നടത്തി. നിംസ് സ്പക്ട്രം കോഡിനേറ്റർ ശ്രീ. റിഫായി അബ്ദുൾറഹിം , ചീഫ് ഡവലപ്മെൻ്റ് തെറാപ്പിസ്റ്റ് ശ്രീമതി സ്വപ്ന , ഡവലപ്മെൻ്റ് നഴ്സിങ്ങ് കൗൺസിലർ ശ്രീമതി അശ്വതി , നഴ്സിങ്ങ് , ദന്തൽ YRC സ്റ്റുഡൻസ്, നിംസ് ദന്തൽ കോളേജ് കോഡിനേറ്റർ ഡോ. അംബിക, ശ്രീമതി. ഷബ്ന  തുടങ്ങിയവരുടെ സജീവപങ്കാളിത്തമുണ്ടായിരുന്നു. ശ്രീ ബോബി, ഫോർമർ പ്രോജക്ട് കോ ഓർഡിനേറ്റർ പോളിയോ ഹോം , നന്ദി രേഖപ്പെടുത്തി.വിശിഷ്ടാതിഥികൾക്ക് നിംസ് മാനേജിങ്ങ് ഡയറക്ടർ ശ്രീ. എം. എസ് ഫൈസൽ ഖാൻ രചിച്ച 'യന്ത്രക്കസേര' എന്ന നോവൽ വായനക്കായി നൽകുകയുണ്ടായി.",
      thumb: "assets/img/pensionscheme/304.jpg",
    },
    {
      src: "assets/img/pensionscheme/305.jpg",
      caption: "നെയ്യാറ്റിൻകര പെൻഷൻ പ്ലാനിലെ കുട്ടികൾക്ക് അവരുടെ സ്പെഷ്യൽ ദിനങ്ങളെല്ലാം ആഘോഷമാണ്. 2025 മാർച്ച് 21 ലോക  ഡൗൺ സിൻഡ്രോം ദിനം വളരെ ഗംഭീരമായി നിംസ് സ്പെക്ട്രം ഹാളിൽ വച്ച് ആചരിക്കുകയുണ്ടായി. കുട്ടികൾക്ക് പാട്ടും നൃത്തവും ചെറു മത്സരങ്ങളും പ്രോത്സാഹന സമ്മാനവും നൽകി. ചടങ്ങിൽ മുഖ്യ അതിഥി യായ ശ്രീ. ജിമ്മി മാനുവൽ, ചെയർമാൻ, ഹീമോഫീലിയ ഫെഡറേഷൻ ഓഫ് ഇന്ത്യ,തിരുവനന്തപുരം ഭദ്രദീപം കൊളുത്തി ഉദ്ഘാടനം ചെയ്തു. ഉദ്ഘാടന പ്രസംഗത്തിൽ അദ്ദേഹം അഭിപ്രായപ്പെട്ടത് ഇങ്ങനെയാണ് 'നിരവധി ജീവകാരുണ്യ പ്രവർത്തനങ്ങൾ ചെയ്യുന്ന നിംസ് മെഡിസിറ്റി മാനേജിങ്ങ് ഡയറക്ടർ ശ്രീ. എം എസ് ഫൈസൽ ഖാൻ സാറിൻ്റെ ഏറെ മഹത്തരമായ സേവനമാണ് നെയ്യാറ്റിൻകര പെൻഷൻ പ്ലാനിലൂടെ ചെയ്യുന്ന നിരവധി സേവനങ്ങൾ '. ചടങ്ങിൻ്റ ഉദ്ദേശ ലക്ഷ്യങ്ങളെക്കുറിച്ച് ഫോർമർ ആരോഗ്യ സർവ്വകലാശാല വൈസ് ചാൻസലറും നിംസ് സ്പെക്ട്രം ഡയറക്ടറുമായ Prof(Dr) M.K.C Nair D.Sc, വ്യക്തമാക്കി. നിംസ് മെഡിസിറ്റി ജനറൽ മാനേജർ ഡോ. സജു. കെ.എ. മുഖ്യ പ്രഭാഷണം നടത്തി. വിമൻ ആൻ്റ്  ചൈൽഡ് ഡെവലപ്മെൻ്റ് ഡിപ്പാർട്ട്മെൻ്റിലെ ശ്രീ. ജോസഫ് രാജൻ, നിംസ് മെഡിസിറ്റി ചീഫ് കൺസൾട്ടന്റ് ഫിസിയോതെറാപ്പിസ്റ്റ്, ഡോ. ജിം ഗോപാലകൃഷ്ണൻ  തുടങ്ങിയവർ ആശംസയും നേർന്നു. ജനറ്റിക് ഡിപ്പാർട്ട്മെന്റ് ഡോ.  ലക്ഷ്മി പെൻഷൻ പ്ലാനിലെ അമ്മമാർക്ക് ബോധവൽക്കരണ ക്ലാസ് എടുക്കുകയും പെൻഷൻ പ്ലാനിലെ കുട്ടികൾക്ക് ജനറ്റിക് സിപ്പാർട്ട്മെൻ്റിൽ  സൗജന്യ ഒ.പി. കൺസൾട്ടേഷൻ തിങ്കളാഴ്ച മുതൽ ആരംഭിക്കും. നിംസ് ജറിയാട്രിക് കോർഡിനേറ്റർ ശ്രീമതി. രേണു. കെ.ആർ. പെൻഷൻ പ്ലാൻ വിശദീകരണം നടത്തി. നിംസ് സ്പക്ട്രം കോഡിനേറ്റർ ശ്രീ. റിഫായി അബ്ദുൾറഹിം , ചീഫ് ഡവലപ്മെൻ്റ് തെറാപ്പിസ്റ്റ് ശ്രീമതി സ്വപ്ന , ഡവലപ്മെൻ്റ് നഴ്സിങ്ങ് കൗൺസിലർ ശ്രീമതി അശ്വതി , നഴ്സിങ്ങ് , ദന്തൽ YRC സ്റ്റുഡൻസ്, നിംസ് ദന്തൽ കോളേജ് കോഡിനേറ്റർ ഡോ. അംബിക, ശ്രീമതി. ഷബ്ന  തുടങ്ങിയവരുടെ സജീവപങ്കാളിത്തമുണ്ടായിരുന്നു. ശ്രീ ബോബി, ഫോർമർ പ്രോജക്ട് കോ ഓർഡിനേറ്റർ പോളിയോ ഹോം , നന്ദി രേഖപ്പെടുത്തി.വിശിഷ്ടാതിഥികൾക്ക് നിംസ് മാനേജിങ്ങ് ഡയറക്ടർ ശ്രീ. എം. എസ് ഫൈസൽ ഖാൻ രചിച്ച 'യന്ത്രക്കസേര' എന്ന നോവൽ വായനക്കായി നൽകുകയുണ്ടായി.",
      thumb: "assets/img/pensionscheme/305.jpg",
    },
    {
      src: "assets/img/pensionscheme/306.jpg",
      caption: "നെയ്യാറ്റിൻകര പെൻഷൻ പ്ലാനിലെ കുട്ടികൾക്ക് അവരുടെ സ്പെഷ്യൽ ദിനങ്ങളെല്ലാം ആഘോഷമാണ്. 2025 മാർച്ച് 21 ലോക  ഡൗൺ സിൻഡ്രോം ദിനം വളരെ ഗംഭീരമായി നിംസ് സ്പെക്ട്രം ഹാളിൽ വച്ച് ആചരിക്കുകയുണ്ടായി. കുട്ടികൾക്ക് പാട്ടും നൃത്തവും ചെറു മത്സരങ്ങളും പ്രോത്സാഹന സമ്മാനവും നൽകി. ചടങ്ങിൽ മുഖ്യ അതിഥി യായ ശ്രീ. ജിമ്മി മാനുവൽ, ചെയർമാൻ, ഹീമോഫീലിയ ഫെഡറേഷൻ ഓഫ് ഇന്ത്യ,തിരുവനന്തപുരം ഭദ്രദീപം കൊളുത്തി ഉദ്ഘാടനം ചെയ്തു. ഉദ്ഘാടന പ്രസംഗത്തിൽ അദ്ദേഹം അഭിപ്രായപ്പെട്ടത് ഇങ്ങനെയാണ് 'നിരവധി ജീവകാരുണ്യ പ്രവർത്തനങ്ങൾ ചെയ്യുന്ന നിംസ് മെഡിസിറ്റി മാനേജിങ്ങ് ഡയറക്ടർ ശ്രീ. എം എസ് ഫൈസൽ ഖാൻ സാറിൻ്റെ ഏറെ മഹത്തരമായ സേവനമാണ് നെയ്യാറ്റിൻകര പെൻഷൻ പ്ലാനിലൂടെ ചെയ്യുന്ന നിരവധി സേവനങ്ങൾ '. ചടങ്ങിൻ്റ ഉദ്ദേശ ലക്ഷ്യങ്ങളെക്കുറിച്ച് ഫോർമർ ആരോഗ്യ സർവ്വകലാശാല വൈസ് ചാൻസലറും നിംസ് സ്പെക്ട്രം ഡയറക്ടറുമായ Prof(Dr) M.K.C Nair D.Sc, വ്യക്തമാക്കി. നിംസ് മെഡിസിറ്റി ജനറൽ മാനേജർ ഡോ. സജു. കെ.എ. മുഖ്യ പ്രഭാഷണം നടത്തി. വിമൻ ആൻ്റ്  ചൈൽഡ് ഡെവലപ്മെൻ്റ് ഡിപ്പാർട്ട്മെൻ്റിലെ ശ്രീ. ജോസഫ് രാജൻ, നിംസ് മെഡിസിറ്റി ചീഫ് കൺസൾട്ടന്റ് ഫിസിയോതെറാപ്പിസ്റ്റ്, ഡോ. ജിം ഗോപാലകൃഷ്ണൻ  തുടങ്ങിയവർ ആശംസയും നേർന്നു. ജനറ്റിക് ഡിപ്പാർട്ട്മെന്റ് ഡോ.  ലക്ഷ്മി പെൻഷൻ പ്ലാനിലെ അമ്മമാർക്ക് ബോധവൽക്കരണ ക്ലാസ് എടുക്കുകയും പെൻഷൻ പ്ലാനിലെ കുട്ടികൾക്ക് ജനറ്റിക് സിപ്പാർട്ട്മെൻ്റിൽ  സൗജന്യ ഒ.പി. കൺസൾട്ടേഷൻ തിങ്കളാഴ്ച മുതൽ ആരംഭിക്കും. നിംസ് ജറിയാട്രിക് കോർഡിനേറ്റർ ശ്രീമതി. രേണു. കെ.ആർ. പെൻഷൻ പ്ലാൻ വിശദീകരണം നടത്തി. നിംസ് സ്പക്ട്രം കോഡിനേറ്റർ ശ്രീ. റിഫായി അബ്ദുൾറഹിം , ചീഫ് ഡവലപ്മെൻ്റ് തെറാപ്പിസ്റ്റ് ശ്രീമതി സ്വപ്ന , ഡവലപ്മെൻ്റ് നഴ്സിങ്ങ് കൗൺസിലർ ശ്രീമതി അശ്വതി , നഴ്സിങ്ങ് , ദന്തൽ YRC സ്റ്റുഡൻസ്, നിംസ് ദന്തൽ കോളേജ് കോഡിനേറ്റർ ഡോ. അംബിക, ശ്രീമതി. ഷബ്ന  തുടങ്ങിയവരുടെ സജീവപങ്കാളിത്തമുണ്ടായിരുന്നു. ശ്രീ ബോബി, ഫോർമർ പ്രോജക്ട് കോ ഓർഡിനേറ്റർ പോളിയോ ഹോം , നന്ദി രേഖപ്പെടുത്തി.വിശിഷ്ടാതിഥികൾക്ക് നിംസ് മാനേജിങ്ങ് ഡയറക്ടർ ശ്രീ. എം. എസ് ഫൈസൽ ഖാൻ രചിച്ച 'യന്ത്രക്കസേര' എന്ന നോവൽ വായനക്കായി നൽകുകയുണ്ടായി.",
      thumb: "assets/img/pensionscheme/306.jpg",
    },
    {
      src: "assets/img/pensionscheme/307.jpg",
      caption: "നെയ്യാറ്റിൻകര പെൻഷൻ പ്ലാനിലെ കുട്ടികൾക്ക് അവരുടെ സ്പെഷ്യൽ ദിനങ്ങളെല്ലാം ആഘോഷമാണ്. 2025 മാർച്ച് 21 ലോക  ഡൗൺ സിൻഡ്രോം ദിനം വളരെ ഗംഭീരമായി നിംസ് സ്പെക്ട്രം ഹാളിൽ വച്ച് ആചരിക്കുകയുണ്ടായി. കുട്ടികൾക്ക് പാട്ടും നൃത്തവും ചെറു മത്സരങ്ങളും പ്രോത്സാഹന സമ്മാനവും നൽകി. ചടങ്ങിൽ മുഖ്യ അതിഥി യായ ശ്രീ. ജിമ്മി മാനുവൽ, ചെയർമാൻ, ഹീമോഫീലിയ ഫെഡറേഷൻ ഓഫ് ഇന്ത്യ,തിരുവനന്തപുരം ഭദ്രദീപം കൊളുത്തി ഉദ്ഘാടനം ചെയ്തു. ഉദ്ഘാടന പ്രസംഗത്തിൽ അദ്ദേഹം അഭിപ്രായപ്പെട്ടത് ഇങ്ങനെയാണ് 'നിരവധി ജീവകാരുണ്യ പ്രവർത്തനങ്ങൾ ചെയ്യുന്ന നിംസ് മെഡിസിറ്റി മാനേജിങ്ങ് ഡയറക്ടർ ശ്രീ. എം എസ് ഫൈസൽ ഖാൻ സാറിൻ്റെ ഏറെ മഹത്തരമായ സേവനമാണ് നെയ്യാറ്റിൻകര പെൻഷൻ പ്ലാനിലൂടെ ചെയ്യുന്ന നിരവധി സേവനങ്ങൾ '. ചടങ്ങിൻ്റ ഉദ്ദേശ ലക്ഷ്യങ്ങളെക്കുറിച്ച് ഫോർമർ ആരോഗ്യ സർവ്വകലാശാല വൈസ് ചാൻസലറും നിംസ് സ്പെക്ട്രം ഡയറക്ടറുമായ Prof(Dr) M.K.C Nair D.Sc, വ്യക്തമാക്കി. നിംസ് മെഡിസിറ്റി ജനറൽ മാനേജർ ഡോ. സജു. കെ.എ. മുഖ്യ പ്രഭാഷണം നടത്തി. വിമൻ ആൻ്റ്  ചൈൽഡ് ഡെവലപ്മെൻ്റ് ഡിപ്പാർട്ട്മെൻ്റിലെ ശ്രീ. ജോസഫ് രാജൻ, നിംസ് മെഡിസിറ്റി ചീഫ് കൺസൾട്ടന്റ് ഫിസിയോതെറാപ്പിസ്റ്റ്, ഡോ. ജിം ഗോപാലകൃഷ്ണൻ  തുടങ്ങിയവർ ആശംസയും നേർന്നു. ജനറ്റിക് ഡിപ്പാർട്ട്മെന്റ് ഡോ.  ലക്ഷ്മി പെൻഷൻ പ്ലാനിലെ അമ്മമാർക്ക് ബോധവൽക്കരണ ക്ലാസ് എടുക്കുകയും പെൻഷൻ പ്ലാനിലെ കുട്ടികൾക്ക് ജനറ്റിക് സിപ്പാർട്ട്മെൻ്റിൽ  സൗജന്യ ഒ.പി. കൺസൾട്ടേഷൻ തിങ്കളാഴ്ച മുതൽ ആരംഭിക്കും. നിംസ് ജറിയാട്രിക് കോർഡിനേറ്റർ ശ്രീമതി. രേണു. കെ.ആർ. പെൻഷൻ പ്ലാൻ വിശദീകരണം നടത്തി. നിംസ് സ്പക്ട്രം കോഡിനേറ്റർ ശ്രീ. റിഫായി അബ്ദുൾറഹിം , ചീഫ് ഡവലപ്മെൻ്റ് തെറാപ്പിസ്റ്റ് ശ്രീമതി സ്വപ്ന , ഡവലപ്മെൻ്റ് നഴ്സിങ്ങ് കൗൺസിലർ ശ്രീമതി അശ്വതി , നഴ്സിങ്ങ് , ദന്തൽ YRC സ്റ്റുഡൻസ്, നിംസ് ദന്തൽ കോളേജ് കോഡിനേറ്റർ ഡോ. അംബിക, ശ്രീമതി. ഷബ്ന  തുടങ്ങിയവരുടെ സജീവപങ്കാളിത്തമുണ്ടായിരുന്നു. ശ്രീ ബോബി, ഫോർമർ പ്രോജക്ട് കോ ഓർഡിനേറ്റർ പോളിയോ ഹോം , നന്ദി രേഖപ്പെടുത്തി.വിശിഷ്ടാതിഥികൾക്ക് നിംസ് മാനേജിങ്ങ് ഡയറക്ടർ ശ്രീ. എം. എസ് ഫൈസൽ ഖാൻ രചിച്ച 'യന്ത്രക്കസേര' എന്ന നോവൽ വായനക്കായി നൽകുകയുണ്ടായി.",
      thumb: "assets/img/pensionscheme/307.jpg",
    },
    {
      src: "assets/img/pensionscheme/308.jpg",
      caption: "നെയ്യാറ്റിൻകര പെൻഷൻ പ്ലാനിലെ കുട്ടികൾക്ക് അവരുടെ സ്പെഷ്യൽ ദിനങ്ങളെല്ലാം ആഘോഷമാണ്. 2025 മാർച്ച് 21 ലോക  ഡൗൺ സിൻഡ്രോം ദിനം വളരെ ഗംഭീരമായി നിംസ് സ്പെക്ട്രം ഹാളിൽ വച്ച് ആചരിക്കുകയുണ്ടായി. കുട്ടികൾക്ക് പാട്ടും നൃത്തവും ചെറു മത്സരങ്ങളും പ്രോത്സാഹന സമ്മാനവും നൽകി. ചടങ്ങിൽ മുഖ്യ അതിഥി യായ ശ്രീ. ജിമ്മി മാനുവൽ, ചെയർമാൻ, ഹീമോഫീലിയ ഫെഡറേഷൻ ഓഫ് ഇന്ത്യ,തിരുവനന്തപുരം ഭദ്രദീപം കൊളുത്തി ഉദ്ഘാടനം ചെയ്തു. ഉദ്ഘാടന പ്രസംഗത്തിൽ അദ്ദേഹം അഭിപ്രായപ്പെട്ടത് ഇങ്ങനെയാണ് 'നിരവധി ജീവകാരുണ്യ പ്രവർത്തനങ്ങൾ ചെയ്യുന്ന നിംസ് മെഡിസിറ്റി മാനേജിങ്ങ് ഡയറക്ടർ ശ്രീ. എം എസ് ഫൈസൽ ഖാൻ സാറിൻ്റെ ഏറെ മഹത്തരമായ സേവനമാണ് നെയ്യാറ്റിൻകര പെൻഷൻ പ്ലാനിലൂടെ ചെയ്യുന്ന നിരവധി സേവനങ്ങൾ '. ചടങ്ങിൻ്റ ഉദ്ദേശ ലക്ഷ്യങ്ങളെക്കുറിച്ച് ഫോർമർ ആരോഗ്യ സർവ്വകലാശാല വൈസ് ചാൻസലറും നിംസ് സ്പെക്ട്രം ഡയറക്ടറുമായ Prof(Dr) M.K.C Nair D.Sc, വ്യക്തമാക്കി. നിംസ് മെഡിസിറ്റി ജനറൽ മാനേജർ ഡോ. സജു. കെ.എ. മുഖ്യ പ്രഭാഷണം നടത്തി. വിമൻ ആൻ്റ്  ചൈൽഡ് ഡെവലപ്മെൻ്റ് ഡിപ്പാർട്ട്മെൻ്റിലെ ശ്രീ. ജോസഫ് രാജൻ, നിംസ് മെഡിസിറ്റി ചീഫ് കൺസൾട്ടന്റ് ഫിസിയോതെറാപ്പിസ്റ്റ്, ഡോ. ജിം ഗോപാലകൃഷ്ണൻ  തുടങ്ങിയവർ ആശംസയും നേർന്നു. ജനറ്റിക് ഡിപ്പാർട്ട്മെന്റ് ഡോ.  ലക്ഷ്മി പെൻഷൻ പ്ലാനിലെ അമ്മമാർക്ക് ബോധവൽക്കരണ ക്ലാസ് എടുക്കുകയും പെൻഷൻ പ്ലാനിലെ കുട്ടികൾക്ക് ജനറ്റിക് സിപ്പാർട്ട്മെൻ്റിൽ  സൗജന്യ ഒ.പി. കൺസൾട്ടേഷൻ തിങ്കളാഴ്ച മുതൽ ആരംഭിക്കും. നിംസ് ജറിയാട്രിക് കോർഡിനേറ്റർ ശ്രീമതി. രേണു. കെ.ആർ. പെൻഷൻ പ്ലാൻ വിശദീകരണം നടത്തി. നിംസ് സ്പക്ട്രം കോഡിനേറ്റർ ശ്രീ. റിഫായി അബ്ദുൾറഹിം , ചീഫ് ഡവലപ്മെൻ്റ് തെറാപ്പിസ്റ്റ് ശ്രീമതി സ്വപ്ന , ഡവലപ്മെൻ്റ് നഴ്സിങ്ങ് കൗൺസിലർ ശ്രീമതി അശ്വതി , നഴ്സിങ്ങ് , ദന്തൽ YRC സ്റ്റുഡൻസ്, നിംസ് ദന്തൽ കോളേജ് കോഡിനേറ്റർ ഡോ. അംബിക, ശ്രീമതി. ഷബ്ന  തുടങ്ങിയവരുടെ സജീവപങ്കാളിത്തമുണ്ടായിരുന്നു. ശ്രീ ബോബി, ഫോർമർ പ്രോജക്ട് കോ ഓർഡിനേറ്റർ പോളിയോ ഹോം , നന്ദി രേഖപ്പെടുത്തി.വിശിഷ്ടാതിഥികൾക്ക് നിംസ് മാനേജിങ്ങ് ഡയറക്ടർ ശ്രീ. എം. എസ് ഫൈസൽ ഖാൻ രചിച്ച 'യന്ത്രക്കസേര' എന്ന നോവൽ വായനക്കായി നൽകുകയുണ്ടായി.",
      thumb: "assets/img/pensionscheme/308.jpg",
    },
    {
      src: "assets/img/pensionscheme/309.jpg",
      caption: "നെയ്യാറ്റിൻകര പെൻഷൻ പ്ലാനിലെ കുട്ടികൾക്ക് അവരുടെ സ്പെഷ്യൽ ദിനങ്ങളെല്ലാം ആഘോഷമാണ്. 2025 മാർച്ച് 21 ലോക  ഡൗൺ സിൻഡ്രോം ദിനം വളരെ ഗംഭീരമായി നിംസ് സ്പെക്ട്രം ഹാളിൽ വച്ച് ആചരിക്കുകയുണ്ടായി. കുട്ടികൾക്ക് പാട്ടും നൃത്തവും ചെറു മത്സരങ്ങളും പ്രോത്സാഹന സമ്മാനവും നൽകി. ചടങ്ങിൽ മുഖ്യ അതിഥി യായ ശ്രീ. ജിമ്മി മാനുവൽ, ചെയർമാൻ, ഹീമോഫീലിയ ഫെഡറേഷൻ ഓഫ് ഇന്ത്യ,തിരുവനന്തപുരം ഭദ്രദീപം കൊളുത്തി ഉദ്ഘാടനം ചെയ്തു. ഉദ്ഘാടന പ്രസംഗത്തിൽ അദ്ദേഹം അഭിപ്രായപ്പെട്ടത് ഇങ്ങനെയാണ് 'നിരവധി ജീവകാരുണ്യ പ്രവർത്തനങ്ങൾ ചെയ്യുന്ന നിംസ് മെഡിസിറ്റി മാനേജിങ്ങ് ഡയറക്ടർ ശ്രീ. എം എസ് ഫൈസൽ ഖാൻ സാറിൻ്റെ ഏറെ മഹത്തരമായ സേവനമാണ് നെയ്യാറ്റിൻകര പെൻഷൻ പ്ലാനിലൂടെ ചെയ്യുന്ന നിരവധി സേവനങ്ങൾ '. ചടങ്ങിൻ്റ ഉദ്ദേശ ലക്ഷ്യങ്ങളെക്കുറിച്ച് ഫോർമർ ആരോഗ്യ സർവ്വകലാശാല വൈസ് ചാൻസലറും നിംസ് സ്പെക്ട്രം ഡയറക്ടറുമായ Prof(Dr) M.K.C Nair D.Sc, വ്യക്തമാക്കി. നിംസ് മെഡിസിറ്റി ജനറൽ മാനേജർ ഡോ. സജു. കെ.എ. മുഖ്യ പ്രഭാഷണം നടത്തി. വിമൻ ആൻ്റ്  ചൈൽഡ് ഡെവലപ്മെൻ്റ് ഡിപ്പാർട്ട്മെൻ്റിലെ ശ്രീ. ജോസഫ് രാജൻ, നിംസ് മെഡിസിറ്റി ചീഫ് കൺസൾട്ടന്റ് ഫിസിയോതെറാപ്പിസ്റ്റ്, ഡോ. ജിം ഗോപാലകൃഷ്ണൻ  തുടങ്ങിയവർ ആശംസയും നേർന്നു. ജനറ്റിക് ഡിപ്പാർട്ട്മെന്റ് ഡോ.  ലക്ഷ്മി പെൻഷൻ പ്ലാനിലെ അമ്മമാർക്ക് ബോധവൽക്കരണ ക്ലാസ് എടുക്കുകയും പെൻഷൻ പ്ലാനിലെ കുട്ടികൾക്ക് ജനറ്റിക് സിപ്പാർട്ട്മെൻ്റിൽ  സൗജന്യ ഒ.പി. കൺസൾട്ടേഷൻ തിങ്കളാഴ്ച മുതൽ ആരംഭിക്കും. നിംസ് ജറിയാട്രിക് കോർഡിനേറ്റർ ശ്രീമതി. രേണു. കെ.ആർ. പെൻഷൻ പ്ലാൻ വിശദീകരണം നടത്തി. നിംസ് സ്പക്ട്രം കോഡിനേറ്റർ ശ്രീ. റിഫായി അബ്ദുൾറഹിം , ചീഫ് ഡവലപ്മെൻ്റ് തെറാപ്പിസ്റ്റ് ശ്രീമതി സ്വപ്ന , ഡവലപ്മെൻ്റ് നഴ്സിങ്ങ് കൗൺസിലർ ശ്രീമതി അശ്വതി , നഴ്സിങ്ങ് , ദന്തൽ YRC സ്റ്റുഡൻസ്, നിംസ് ദന്തൽ കോളേജ് കോഡിനേറ്റർ ഡോ. അംബിക, ശ്രീമതി. ഷബ്ന  തുടങ്ങിയവരുടെ സജീവപങ്കാളിത്തമുണ്ടായിരുന്നു. ശ്രീ ബോബി, ഫോർമർ പ്രോജക്ട് കോ ഓർഡിനേറ്റർ പോളിയോ ഹോം , നന്ദി രേഖപ്പെടുത്തി.വിശിഷ്ടാതിഥികൾക്ക് നിംസ് മാനേജിങ്ങ് ഡയറക്ടർ ശ്രീ. എം. എസ് ഫൈസൽ ഖാൻ രചിച്ച 'യന്ത്രക്കസേര' എന്ന നോവൽ വായനക്കായി നൽകുകയുണ്ടായി.",
      thumb: "assets/img/pensionscheme/309.jpg",
    },
    {
      src: "assets/img/pensionscheme/310.jpg",
      caption: "നെയ്യാറ്റിൻകര പെൻഷൻ പ്ലാനിലെ കുട്ടികൾക്ക് അവരുടെ സ്പെഷ്യൽ ദിനങ്ങളെല്ലാം ആഘോഷമാണ്. 2025 മാർച്ച് 21 ലോക  ഡൗൺ സിൻഡ്രോം ദിനം വളരെ ഗംഭീരമായി നിംസ് സ്പെക്ട്രം ഹാളിൽ വച്ച് ആചരിക്കുകയുണ്ടായി. കുട്ടികൾക്ക് പാട്ടും നൃത്തവും ചെറു മത്സരങ്ങളും പ്രോത്സാഹന സമ്മാനവും നൽകി. ചടങ്ങിൽ മുഖ്യ അതിഥി യായ ശ്രീ. ജിമ്മി മാനുവൽ, ചെയർമാൻ, ഹീമോഫീലിയ ഫെഡറേഷൻ ഓഫ് ഇന്ത്യ,തിരുവനന്തപുരം ഭദ്രദീപം കൊളുത്തി ഉദ്ഘാടനം ചെയ്തു. ഉദ്ഘാടന പ്രസംഗത്തിൽ അദ്ദേഹം അഭിപ്രായപ്പെട്ടത് ഇങ്ങനെയാണ് 'നിരവധി ജീവകാരുണ്യ പ്രവർത്തനങ്ങൾ ചെയ്യുന്ന നിംസ് മെഡിസിറ്റി മാനേജിങ്ങ് ഡയറക്ടർ ശ്രീ. എം എസ് ഫൈസൽ ഖാൻ സാറിൻ്റെ ഏറെ മഹത്തരമായ സേവനമാണ് നെയ്യാറ്റിൻകര പെൻഷൻ പ്ലാനിലൂടെ ചെയ്യുന്ന നിരവധി സേവനങ്ങൾ '. ചടങ്ങിൻ്റ ഉദ്ദേശ ലക്ഷ്യങ്ങളെക്കുറിച്ച് ഫോർമർ ആരോഗ്യ സർവ്വകലാശാല വൈസ് ചാൻസലറും നിംസ് സ്പെക്ട്രം ഡയറക്ടറുമായ Prof(Dr) M.K.C Nair D.Sc, വ്യക്തമാക്കി. നിംസ് മെഡിസിറ്റി ജനറൽ മാനേജർ ഡോ. സജു. കെ.എ. മുഖ്യ പ്രഭാഷണം നടത്തി. വിമൻ ആൻ്റ്  ചൈൽഡ് ഡെവലപ്മെൻ്റ് ഡിപ്പാർട്ട്മെൻ്റിലെ ശ്രീ. ജോസഫ് രാജൻ, നിംസ് മെഡിസിറ്റി ചീഫ് കൺസൾട്ടന്റ് ഫിസിയോതെറാപ്പിസ്റ്റ്, ഡോ. ജിം ഗോപാലകൃഷ്ണൻ  തുടങ്ങിയവർ ആശംസയും നേർന്നു. ജനറ്റിക് ഡിപ്പാർട്ട്മെന്റ് ഡോ.  ലക്ഷ്മി പെൻഷൻ പ്ലാനിലെ അമ്മമാർക്ക് ബോധവൽക്കരണ ക്ലാസ് എടുക്കുകയും പെൻഷൻ പ്ലാനിലെ കുട്ടികൾക്ക് ജനറ്റിക് സിപ്പാർട്ട്മെൻ്റിൽ  സൗജന്യ ഒ.പി. കൺസൾട്ടേഷൻ തിങ്കളാഴ്ച മുതൽ ആരംഭിക്കും. നിംസ് ജറിയാട്രിക് കോർഡിനേറ്റർ ശ്രീമതി. രേണു. കെ.ആർ. പെൻഷൻ പ്ലാൻ വിശദീകരണം നടത്തി. നിംസ് സ്പക്ട്രം കോഡിനേറ്റർ ശ്രീ. റിഫായി അബ്ദുൾറഹിം , ചീഫ് ഡവലപ്മെൻ്റ് തെറാപ്പിസ്റ്റ് ശ്രീമതി സ്വപ്ന , ഡവലപ്മെൻ്റ് നഴ്സിങ്ങ് കൗൺസിലർ ശ്രീമതി അശ്വതി , നഴ്സിങ്ങ് , ദന്തൽ YRC സ്റ്റുഡൻസ്, നിംസ് ദന്തൽ കോളേജ് കോഡിനേറ്റർ ഡോ. അംബിക, ശ്രീമതി. ഷബ്ന  തുടങ്ങിയവരുടെ സജീവപങ്കാളിത്തമുണ്ടായിരുന്നു. ശ്രീ ബോബി, ഫോർമർ പ്രോജക്ട് കോ ഓർഡിനേറ്റർ പോളിയോ ഹോം , നന്ദി രേഖപ്പെടുത്തി.വിശിഷ്ടാതിഥികൾക്ക് നിംസ് മാനേജിങ്ങ് ഡയറക്ടർ ശ്രീ. എം. എസ് ഫൈസൽ ഖാൻ രചിച്ച 'യന്ത്രക്കസേര' എന്ന നോവൽ വായനക്കായി നൽകുകയുണ്ടായി.",
      thumb: "assets/img/pensionscheme/310.jpg",
    },
    {
      src: "assets/img/pensionscheme/311.jpg",
      caption: "നെയ്യാറ്റിൻകര പെൻഷൻ പ്ലാനിലെ കുട്ടികൾക്ക് അവരുടെ സ്പെഷ്യൽ ദിനങ്ങളെല്ലാം ആഘോഷമാണ്. 2025 മാർച്ച് 21 ലോക  ഡൗൺ സിൻഡ്രോം ദിനം വളരെ ഗംഭീരമായി നിംസ് സ്പെക്ട്രം ഹാളിൽ വച്ച് ആചരിക്കുകയുണ്ടായി. കുട്ടികൾക്ക് പാട്ടും നൃത്തവും ചെറു മത്സരങ്ങളും പ്രോത്സാഹന സമ്മാനവും നൽകി. ചടങ്ങിൽ മുഖ്യ അതിഥി യായ ശ്രീ. ജിമ്മി മാനുവൽ, ചെയർമാൻ, ഹീമോഫീലിയ ഫെഡറേഷൻ ഓഫ് ഇന്ത്യ,തിരുവനന്തപുരം ഭദ്രദീപം കൊളുത്തി ഉദ്ഘാടനം ചെയ്തു. ഉദ്ഘാടന പ്രസംഗത്തിൽ അദ്ദേഹം അഭിപ്രായപ്പെട്ടത് ഇങ്ങനെയാണ് 'നിരവധി ജീവകാരുണ്യ പ്രവർത്തനങ്ങൾ ചെയ്യുന്ന നിംസ് മെഡിസിറ്റി മാനേജിങ്ങ് ഡയറക്ടർ ശ്രീ. എം എസ് ഫൈസൽ ഖാൻ സാറിൻ്റെ ഏറെ മഹത്തരമായ സേവനമാണ് നെയ്യാറ്റിൻകര പെൻഷൻ പ്ലാനിലൂടെ ചെയ്യുന്ന നിരവധി സേവനങ്ങൾ '. ചടങ്ങിൻ്റ ഉദ്ദേശ ലക്ഷ്യങ്ങളെക്കുറിച്ച് ഫോർമർ ആരോഗ്യ സർവ്വകലാശാല വൈസ് ചാൻസലറും നിംസ് സ്പെക്ട്രം ഡയറക്ടറുമായ Prof(Dr) M.K.C Nair D.Sc, വ്യക്തമാക്കി. നിംസ് മെഡിസിറ്റി ജനറൽ മാനേജർ ഡോ. സജു. കെ.എ. മുഖ്യ പ്രഭാഷണം നടത്തി. വിമൻ ആൻ്റ്  ചൈൽഡ് ഡെവലപ്മെൻ്റ് ഡിപ്പാർട്ട്മെൻ്റിലെ ശ്രീ. ജോസഫ് രാജൻ, നിംസ് മെഡിസിറ്റി ചീഫ് കൺസൾട്ടന്റ് ഫിസിയോതെറാപ്പിസ്റ്റ്, ഡോ. ജിം ഗോപാലകൃഷ്ണൻ  തുടങ്ങിയവർ ആശംസയും നേർന്നു. ജനറ്റിക് ഡിപ്പാർട്ട്മെന്റ് ഡോ.  ലക്ഷ്മി പെൻഷൻ പ്ലാനിലെ അമ്മമാർക്ക് ബോധവൽക്കരണ ക്ലാസ് എടുക്കുകയും പെൻഷൻ പ്ലാനിലെ കുട്ടികൾക്ക് ജനറ്റിക് സിപ്പാർട്ട്മെൻ്റിൽ  സൗജന്യ ഒ.പി. കൺസൾട്ടേഷൻ തിങ്കളാഴ്ച മുതൽ ആരംഭിക്കും. നിംസ് ജറിയാട്രിക് കോർഡിനേറ്റർ ശ്രീമതി. രേണു. കെ.ആർ. പെൻഷൻ പ്ലാൻ വിശദീകരണം നടത്തി. നിംസ് സ്പക്ട്രം കോഡിനേറ്റർ ശ്രീ. റിഫായി അബ്ദുൾറഹിം , ചീഫ് ഡവലപ്മെൻ്റ് തെറാപ്പിസ്റ്റ് ശ്രീമതി സ്വപ്ന , ഡവലപ്മെൻ്റ് നഴ്സിങ്ങ് കൗൺസിലർ ശ്രീമതി അശ്വതി , നഴ്സിങ്ങ് , ദന്തൽ YRC സ്റ്റുഡൻസ്, നിംസ് ദന്തൽ കോളേജ് കോഡിനേറ്റർ ഡോ. അംബിക, ശ്രീമതി. ഷബ്ന  തുടങ്ങിയവരുടെ സജീവപങ്കാളിത്തമുണ്ടായിരുന്നു. ശ്രീ ബോബി, ഫോർമർ പ്രോജക്ട് കോ ഓർഡിനേറ്റർ പോളിയോ ഹോം , നന്ദി രേഖപ്പെടുത്തി.വിശിഷ്ടാതിഥികൾക്ക് നിംസ് മാനേജിങ്ങ് ഡയറക്ടർ ശ്രീ. എം. എസ് ഫൈസൽ ഖാൻ രചിച്ച 'യന്ത്രക്കസേര' എന്ന നോവൽ വായനക്കായി നൽകുകയുണ്ടായി.",
      thumb: "assets/img/pensionscheme/311.jpg",
    },
    {
      src: "assets/img/pensionscheme/312.jpg",
      caption: "നെയ്യാറ്റിൻകര പെൻഷൻ പ്ലാനിലെ കുട്ടികൾക്ക് അവരുടെ സ്പെഷ്യൽ ദിനങ്ങളെല്ലാം ആഘോഷമാണ്. 2025 മാർച്ച് 21 ലോക  ഡൗൺ സിൻഡ്രോം ദിനം വളരെ ഗംഭീരമായി നിംസ് സ്പെക്ട്രം ഹാളിൽ വച്ച് ആചരിക്കുകയുണ്ടായി. കുട്ടികൾക്ക് പാട്ടും നൃത്തവും ചെറു മത്സരങ്ങളും പ്രോത്സാഹന സമ്മാനവും നൽകി. ചടങ്ങിൽ മുഖ്യ അതിഥി യായ ശ്രീ. ജിമ്മി മാനുവൽ, ചെയർമാൻ, ഹീമോഫീലിയ ഫെഡറേഷൻ ഓഫ് ഇന്ത്യ,തിരുവനന്തപുരം ഭദ്രദീപം കൊളുത്തി ഉദ്ഘാടനം ചെയ്തു. ഉദ്ഘാടന പ്രസംഗത്തിൽ അദ്ദേഹം അഭിപ്രായപ്പെട്ടത് ഇങ്ങനെയാണ് 'നിരവധി ജീവകാരുണ്യ പ്രവർത്തനങ്ങൾ ചെയ്യുന്ന നിംസ് മെഡിസിറ്റി മാനേജിങ്ങ് ഡയറക്ടർ ശ്രീ. എം എസ് ഫൈസൽ ഖാൻ സാറിൻ്റെ ഏറെ മഹത്തരമായ സേവനമാണ് നെയ്യാറ്റിൻകര പെൻഷൻ പ്ലാനിലൂടെ ചെയ്യുന്ന നിരവധി സേവനങ്ങൾ '. ചടങ്ങിൻ്റ ഉദ്ദേശ ലക്ഷ്യങ്ങളെക്കുറിച്ച് ഫോർമർ ആരോഗ്യ സർവ്വകലാശാല വൈസ് ചാൻസലറും നിംസ് സ്പെക്ട്രം ഡയറക്ടറുമായ Prof(Dr) M.K.C Nair D.Sc, വ്യക്തമാക്കി. നിംസ് മെഡിസിറ്റി ജനറൽ മാനേജർ ഡോ. സജു. കെ.എ. മുഖ്യ പ്രഭാഷണം നടത്തി. വിമൻ ആൻ്റ്  ചൈൽഡ് ഡെവലപ്മെൻ്റ് ഡിപ്പാർട്ട്മെൻ്റിലെ ശ്രീ. ജോസഫ് രാജൻ, നിംസ് മെഡിസിറ്റി ചീഫ് കൺസൾട്ടന്റ് ഫിസിയോതെറാപ്പിസ്റ്റ്, ഡോ. ജിം ഗോപാലകൃഷ്ണൻ  തുടങ്ങിയവർ ആശംസയും നേർന്നു. ജനറ്റിക് ഡിപ്പാർട്ട്മെന്റ് ഡോ.  ലക്ഷ്മി പെൻഷൻ പ്ലാനിലെ അമ്മമാർക്ക് ബോധവൽക്കരണ ക്ലാസ് എടുക്കുകയും പെൻഷൻ പ്ലാനിലെ കുട്ടികൾക്ക് ജനറ്റിക് സിപ്പാർട്ട്മെൻ്റിൽ  സൗജന്യ ഒ.പി. കൺസൾട്ടേഷൻ തിങ്കളാഴ്ച മുതൽ ആരംഭിക്കും. നിംസ് ജറിയാട്രിക് കോർഡിനേറ്റർ ശ്രീമതി. രേണു. കെ.ആർ. പെൻഷൻ പ്ലാൻ വിശദീകരണം നടത്തി. നിംസ് സ്പക്ട്രം കോഡിനേറ്റർ ശ്രീ. റിഫായി അബ്ദുൾറഹിം , ചീഫ് ഡവലപ്മെൻ്റ് തെറാപ്പിസ്റ്റ് ശ്രീമതി സ്വപ്ന , ഡവലപ്മെൻ്റ് നഴ്സിങ്ങ് കൗൺസിലർ ശ്രീമതി അശ്വതി , നഴ്സിങ്ങ് , ദന്തൽ YRC സ്റ്റുഡൻസ്, നിംസ് ദന്തൽ കോളേജ് കോഡിനേറ്റർ ഡോ. അംബിക, ശ്രീമതി. ഷബ്ന  തുടങ്ങിയവരുടെ സജീവപങ്കാളിത്തമുണ്ടായിരുന്നു. ശ്രീ ബോബി, ഫോർമർ പ്രോജക്ട് കോ ഓർഡിനേറ്റർ പോളിയോ ഹോം , നന്ദി രേഖപ്പെടുത്തി.വിശിഷ്ടാതിഥികൾക്ക് നിംസ് മാനേജിങ്ങ് ഡയറക്ടർ ശ്രീ. എം. എസ് ഫൈസൽ ഖാൻ രചിച്ച 'യന്ത്രക്കസേര' എന്ന നോവൽ വായനക്കായി നൽകുകയുണ്ടായി.",
      thumb: "assets/img/pensionscheme/312.jpg",
    },
    {
      src: "assets/img/pensionscheme/313.jpg",
      caption: "നെയ്യാറ്റിൻകര പെൻഷൻ പ്ലാനിലെ കുട്ടികൾക്ക് അവരുടെ സ്പെഷ്യൽ ദിനങ്ങളെല്ലാം ആഘോഷമാണ്. 2025 മാർച്ച് 21 ലോക  ഡൗൺ സിൻഡ്രോം ദിനം വളരെ ഗംഭീരമായി നിംസ് സ്പെക്ട്രം ഹാളിൽ വച്ച് ആചരിക്കുകയുണ്ടായി. കുട്ടികൾക്ക് പാട്ടും നൃത്തവും ചെറു മത്സരങ്ങളും പ്രോത്സാഹന സമ്മാനവും നൽകി. ചടങ്ങിൽ മുഖ്യ അതിഥി യായ ശ്രീ. ജിമ്മി മാനുവൽ, ചെയർമാൻ, ഹീമോഫീലിയ ഫെഡറേഷൻ ഓഫ് ഇന്ത്യ,തിരുവനന്തപുരം ഭദ്രദീപം കൊളുത്തി ഉദ്ഘാടനം ചെയ്തു. ഉദ്ഘാടന പ്രസംഗത്തിൽ അദ്ദേഹം അഭിപ്രായപ്പെട്ടത് ഇങ്ങനെയാണ് 'നിരവധി ജീവകാരുണ്യ പ്രവർത്തനങ്ങൾ ചെയ്യുന്ന നിംസ് മെഡിസിറ്റി മാനേജിങ്ങ് ഡയറക്ടർ ശ്രീ. എം എസ് ഫൈസൽ ഖാൻ സാറിൻ്റെ ഏറെ മഹത്തരമായ സേവനമാണ് നെയ്യാറ്റിൻകര പെൻഷൻ പ്ലാനിലൂടെ ചെയ്യുന്ന നിരവധി സേവനങ്ങൾ '. ചടങ്ങിൻ്റ ഉദ്ദേശ ലക്ഷ്യങ്ങളെക്കുറിച്ച് ഫോർമർ ആരോഗ്യ സർവ്വകലാശാല വൈസ് ചാൻസലറും നിംസ് സ്പെക്ട്രം ഡയറക്ടറുമായ Prof(Dr) M.K.C Nair D.Sc, വ്യക്തമാക്കി. നിംസ് മെഡിസിറ്റി ജനറൽ മാനേജർ ഡോ. സജു. കെ.എ. മുഖ്യ പ്രഭാഷണം നടത്തി. വിമൻ ആൻ്റ്  ചൈൽഡ് ഡെവലപ്മെൻ്റ് ഡിപ്പാർട്ട്മെൻ്റിലെ ശ്രീ. ജോസഫ് രാജൻ, നിംസ് മെഡിസിറ്റി ചീഫ് കൺസൾട്ടന്റ് ഫിസിയോതെറാപ്പിസ്റ്റ്, ഡോ. ജിം ഗോപാലകൃഷ്ണൻ  തുടങ്ങിയവർ ആശംസയും നേർന്നു. ജനറ്റിക് ഡിപ്പാർട്ട്മെന്റ് ഡോ.  ലക്ഷ്മി പെൻഷൻ പ്ലാനിലെ അമ്മമാർക്ക് ബോധവൽക്കരണ ക്ലാസ് എടുക്കുകയും പെൻഷൻ പ്ലാനിലെ കുട്ടികൾക്ക് ജനറ്റിക് സിപ്പാർട്ട്മെൻ്റിൽ  സൗജന്യ ഒ.പി. കൺസൾട്ടേഷൻ തിങ്കളാഴ്ച മുതൽ ആരംഭിക്കും. നിംസ് ജറിയാട്രിക് കോർഡിനേറ്റർ ശ്രീമതി. രേണു. കെ.ആർ. പെൻഷൻ പ്ലാൻ വിശദീകരണം നടത്തി. നിംസ് സ്പക്ട്രം കോഡിനേറ്റർ ശ്രീ. റിഫായി അബ്ദുൾറഹിം , ചീഫ് ഡവലപ്മെൻ്റ് തെറാപ്പിസ്റ്റ് ശ്രീമതി സ്വപ്ന , ഡവലപ്മെൻ്റ് നഴ്സിങ്ങ് കൗൺസിലർ ശ്രീമതി അശ്വതി , നഴ്സിങ്ങ് , ദന്തൽ YRC സ്റ്റുഡൻസ്, നിംസ് ദന്തൽ കോളേജ് കോഡിനേറ്റർ ഡോ. അംബിക, ശ്രീമതി. ഷബ്ന  തുടങ്ങിയവരുടെ സജീവപങ്കാളിത്തമുണ്ടായിരുന്നു. ശ്രീ ബോബി, ഫോർമർ പ്രോജക്ട് കോ ഓർഡിനേറ്റർ പോളിയോ ഹോം , നന്ദി രേഖപ്പെടുത്തി.വിശിഷ്ടാതിഥികൾക്ക് നിംസ് മാനേജിങ്ങ് ഡയറക്ടർ ശ്രീ. എം. എസ് ഫൈസൽ ഖാൻ രചിച്ച 'യന്ത്രക്കസേര' എന്ന നോവൽ വായനക്കായി നൽകുകയുണ്ടായി.",
      thumb: "assets/img/pensionscheme/313.jpg",
    },
    {
      src: "assets/img/pensionscheme/314.jpg",
      caption: "നെയ്യാറ്റിൻകര പെൻഷൻ പ്ലാനിലെ കുട്ടികൾക്ക് അവരുടെ സ്പെഷ്യൽ ദിനങ്ങളെല്ലാം ആഘോഷമാണ്. 2025 മാർച്ച് 21 ലോക  ഡൗൺ സിൻഡ്രോം ദിനം വളരെ ഗംഭീരമായി നിംസ് സ്പെക്ട്രം ഹാളിൽ വച്ച് ആചരിക്കുകയുണ്ടായി. കുട്ടികൾക്ക് പാട്ടും നൃത്തവും ചെറു മത്സരങ്ങളും പ്രോത്സാഹന സമ്മാനവും നൽകി. ചടങ്ങിൽ മുഖ്യ അതിഥി യായ ശ്രീ. ജിമ്മി മാനുവൽ, ചെയർമാൻ, ഹീമോഫീലിയ ഫെഡറേഷൻ ഓഫ് ഇന്ത്യ,തിരുവനന്തപുരം ഭദ്രദീപം കൊളുത്തി ഉദ്ഘാടനം ചെയ്തു. ഉദ്ഘാടന പ്രസംഗത്തിൽ അദ്ദേഹം അഭിപ്രായപ്പെട്ടത് ഇങ്ങനെയാണ് 'നിരവധി ജീവകാരുണ്യ പ്രവർത്തനങ്ങൾ ചെയ്യുന്ന നിംസ് മെഡിസിറ്റി മാനേജിങ്ങ് ഡയറക്ടർ ശ്രീ. എം എസ് ഫൈസൽ ഖാൻ സാറിൻ്റെ ഏറെ മഹത്തരമായ സേവനമാണ് നെയ്യാറ്റിൻകര പെൻഷൻ പ്ലാനിലൂടെ ചെയ്യുന്ന നിരവധി സേവനങ്ങൾ '. ചടങ്ങിൻ്റ ഉദ്ദേശ ലക്ഷ്യങ്ങളെക്കുറിച്ച് ഫോർമർ ആരോഗ്യ സർവ്വകലാശാല വൈസ് ചാൻസലറും നിംസ് സ്പെക്ട്രം ഡയറക്ടറുമായ Prof(Dr) M.K.C Nair D.Sc, വ്യക്തമാക്കി. നിംസ് മെഡിസിറ്റി ജനറൽ മാനേജർ ഡോ. സജു. കെ.എ. മുഖ്യ പ്രഭാഷണം നടത്തി. വിമൻ ആൻ്റ്  ചൈൽഡ് ഡെവലപ്മെൻ്റ് ഡിപ്പാർട്ട്മെൻ്റിലെ ശ്രീ. ജോസഫ് രാജൻ, നിംസ് മെഡിസിറ്റി ചീഫ് കൺസൾട്ടന്റ് ഫിസിയോതെറാപ്പിസ്റ്റ്, ഡോ. ജിം ഗോപാലകൃഷ്ണൻ  തുടങ്ങിയവർ ആശംസയും നേർന്നു. ജനറ്റിക് ഡിപ്പാർട്ട്മെന്റ് ഡോ.  ലക്ഷ്മി പെൻഷൻ പ്ലാനിലെ അമ്മമാർക്ക് ബോധവൽക്കരണ ക്ലാസ് എടുക്കുകയും പെൻഷൻ പ്ലാനിലെ കുട്ടികൾക്ക് ജനറ്റിക് സിപ്പാർട്ട്മെൻ്റിൽ  സൗജന്യ ഒ.പി. കൺസൾട്ടേഷൻ തിങ്കളാഴ്ച മുതൽ ആരംഭിക്കും. നിംസ് ജറിയാട്രിക് കോർഡിനേറ്റർ ശ്രീമതി. രേണു. കെ.ആർ. പെൻഷൻ പ്ലാൻ വിശദീകരണം നടത്തി. നിംസ് സ്പക്ട്രം കോഡിനേറ്റർ ശ്രീ. റിഫായി അബ്ദുൾറഹിം , ചീഫ് ഡവലപ്മെൻ്റ് തെറാപ്പിസ്റ്റ് ശ്രീമതി സ്വപ്ന , ഡവലപ്മെൻ്റ് നഴ്സിങ്ങ് കൗൺസിലർ ശ്രീമതി അശ്വതി , നഴ്സിങ്ങ് , ദന്തൽ YRC സ്റ്റുഡൻസ്, നിംസ് ദന്തൽ കോളേജ് കോഡിനേറ്റർ ഡോ. അംബിക, ശ്രീമതി. ഷബ്ന  തുടങ്ങിയവരുടെ സജീവപങ്കാളിത്തമുണ്ടായിരുന്നു. ശ്രീ ബോബി, ഫോർമർ പ്രോജക്ട് കോ ഓർഡിനേറ്റർ പോളിയോ ഹോം , നന്ദി രേഖപ്പെടുത്തി.വിശിഷ്ടാതിഥികൾക്ക് നിംസ് മാനേജിങ്ങ് ഡയറക്ടർ ശ്രീ. എം. എസ് ഫൈസൽ ഖാൻ രചിച്ച 'യന്ത്രക്കസേര' എന്ന നോവൽ വായനക്കായി നൽകുകയുണ്ടായി.",
      thumb: "assets/img/pensionscheme/314.jpg",
    },
    {
      src: "assets/img/pensionscheme/283.jpg",
      caption: "നെയ്യാറ്റിൻകര പെൻഷൻ പ്ലാനിൻ്റെ ആഭിമുഖ്യത്തിൽ നിംസ് മെഡിസിറ്റിയും പെരുങ്കടവിള പഞ്ചായത്തും സയുക്തമായി നെയ്യാറ്റിൻകര പെൻഷൻ പ്ലാൻ ഗുണഭോക്താക്കൾക്കും സ്നേഹാലയ ബഡ് സ്കൂൾ കുട്ടികൾ, പെരുങ്കടവിള പഞ്ചായത്തിലെ ഭിന്നശേഷിക്കാർ, വയോജനങ്ങൾ , അഞ്ച് വയസ്സിൽ താഴെ പ്രായമുള്ള കുട്ടികൾ തുടങ്ങിയവർക്കായി മെഡിക്കൽ ക്യാമ്പും ബോധവൽക്കരണ പരിപാടികളും നടത്തി. പെരുങ്കടവിള പഞ്ചായത്ത് വൈസ് പ്രസിഡന്റ് ശ്രീമതി. ബിന്ദു അധ്യക്ഷത വഹിച്ചു. പഞ്ചായത്ത് പ്രസിഡന്റ് ശ്രീ. സുരേന്ദ്രൻ എസ് മെഡിക്കൽ ക്യാമ്പ് ഉദ്ഘാടനം ചെയ്ത് സംസാരിക്കുകയുണ്ടായി. \"നിംസ് മെഡിസിറ്റി എന്നത് ഒരു ജനകീയ സ്ഥാപനമാണ്. ഇത്രയധികം സൗജന്യ സേവനങ്ങൾ നിബന്ധനകളില്ലാതെ നൽകാൻ നിംസ് മെഡിസിറ്റി മാനേജിങ്ങ് ഡയറക്ടർ ശ്രീ. എം. എസ് ഫൈസൽ ഖാൻ സാറിനല്ലാതെ മറ്റാർക്കും സാധിക്കുകയില്ല.\"ഭിന്നശേഷിക്കാരായവർക്ക് വേണ്ടി പെൻഷൻ പദ്ധതി , വയോജന സംരക്ഷണം, കുഞ്ഞുങ്ങളുടെ ശാരീരിക ബൗദ്ധിക വികാസങ്ങളുടെ ഏറ്റക്കുറച്ചിലുകൾ മനസ്സിലാക്കി കാലതാമസം വരാതെ തെറാപ്പി സൗകര്യം, ഭിന്നശേഷിക്കാർക്ക് തൊഴിലവസരം നൽകുക തുടങ്ങിയവ ഉദ്ഘാടകൻ എടുത്ത് പറയുകയുണ്ടായി.നിംസ് ജറിയാട്രിക് കോർഡിനേറ്റർ ശ്രീമതി. രേണു കെ ആർ പെൻഷൻ പ്ലാൻ വിശദീകരണവും ആശംസയും നേർന്നു. ബഡ്സ്കൂൾ ടീച്ചർ ശ്രീമതി. സിമി ടീച്ചർ സ്വാഗതവും ആശംസിച്ചു. യൂത്ത് റെഡ്ക്രോസ് ടീമൻ്റെ സജീവപങ്കാളിത്തം ക്യാമ്പിനെ വിജയ കരമാക്കി തീർത്തു. ജനറൽ മെഡിസിൻ ഡോക്ടർ നീതുവിൻ്റെ നേതൃത്തിൽ ഓഫ്താൽമോളജി,ദന്തൽ, സ്പെക്ട്രം ഡവലപ്മെന്റ് തെറാപ്പിസ്റ്റ്മാരുടെ സേവനം, ഇ സി ജി, ബി പി , റാൻഡം ബ്ലഡ് ഷുഗർ തുടങ്ങിയ പരിശോധനകളും നടത്തി തുടർ ചികിൽസ ആവശ്യമായവർക്ക് വേണ്ട മാർഗ്ഗ നിർദ്ദേശങ്ങൾ നൽകുകയും ചെയ്തു.",
      thumb: "assets/img/pensionscheme/283.jpg",
    },
    {
      src: "assets/img/pensionscheme/284.jpg",
      caption: "നെയ്യാറ്റിൻകര പെൻഷൻ പ്ലാനിൻ്റെ ആഭിമുഖ്യത്തിൽ നിംസ് മെഡിസിറ്റിയും പെരുങ്കടവിള പഞ്ചായത്തും സയുക്തമായി നെയ്യാറ്റിൻകര പെൻഷൻ പ്ലാൻ ഗുണഭോക്താക്കൾക്കും സ്നേഹാലയ ബഡ് സ്കൂൾ കുട്ടികൾ, പെരുങ്കടവിള പഞ്ചായത്തിലെ ഭിന്നശേഷിക്കാർ, വയോജനങ്ങൾ , അഞ്ച് വയസ്സിൽ താഴെ പ്രായമുള്ള കുട്ടികൾ തുടങ്ങിയവർക്കായി മെഡിക്കൽ ക്യാമ്പും ബോധവൽക്കരണ പരിപാടികളും നടത്തി. പെരുങ്കടവിള പഞ്ചായത്ത് വൈസ് പ്രസിഡന്റ് ശ്രീമതി. ബിന്ദു അധ്യക്ഷത വഹിച്ചു. പഞ്ചായത്ത് പ്രസിഡന്റ് ശ്രീ. സുരേന്ദ്രൻ എസ് മെഡിക്കൽ ക്യാമ്പ് ഉദ്ഘാടനം ചെയ്ത് സംസാരിക്കുകയുണ്ടായി. \"നിംസ് മെഡിസിറ്റി എന്നത് ഒരു ജനകീയ സ്ഥാപനമാണ്. ഇത്രയധികം സൗജന്യ സേവനങ്ങൾ നിബന്ധനകളില്ലാതെ നൽകാൻ നിംസ് മെഡിസിറ്റി മാനേജിങ്ങ് ഡയറക്ടർ ശ്രീ. എം. എസ് ഫൈസൽ ഖാൻ സാറിനല്ലാതെ മറ്റാർക്കും സാധിക്കുകയില്ല.\"ഭിന്നശേഷിക്കാരായവർക്ക് വേണ്ടി പെൻഷൻ പദ്ധതി , വയോജന സംരക്ഷണം, കുഞ്ഞുങ്ങളുടെ ശാരീരിക ബൗദ്ധിക വികാസങ്ങളുടെ ഏറ്റക്കുറച്ചിലുകൾ മനസ്സിലാക്കി കാലതാമസം വരാതെ തെറാപ്പി സൗകര്യം, ഭിന്നശേഷിക്കാർക്ക് തൊഴിലവസരം നൽകുക തുടങ്ങിയവ ഉദ്ഘാടകൻ എടുത്ത് പറയുകയുണ്ടായി.നിംസ് ജറിയാട്രിക് കോർഡിനേറ്റർ ശ്രീമതി. രേണു കെ ആർ പെൻഷൻ പ്ലാൻ വിശദീകരണവും ആശംസയും നേർന്നു. ബഡ്സ്കൂൾ ടീച്ചർ ശ്രീമതി. സിമി ടീച്ചർ സ്വാഗതവും ആശംസിച്ചു. യൂത്ത് റെഡ്ക്രോസ് ടീമൻ്റെ സജീവപങ്കാളിത്തം ക്യാമ്പിനെ വിജയ കരമാക്കി തീർത്തു. ജനറൽ മെഡിസിൻ ഡോക്ടർ നീതുവിൻ്റെ നേതൃത്തിൽ ഓഫ്താൽമോളജി,ദന്തൽ, സ്പെക്ട്രം ഡവലപ്മെന്റ് തെറാപ്പിസ്റ്റ്മാരുടെ സേവനം, ഇ സി ജി, ബി പി , റാൻഡം ബ്ലഡ് ഷുഗർ തുടങ്ങിയ പരിശോധനകളും നടത്തി തുടർ ചികിൽസ ആവശ്യമായവർക്ക് വേണ്ട മാർഗ്ഗ നിർദ്ദേശങ്ങൾ നൽകുകയും ചെയ്തു.",
      thumb: "assets/img/pensionscheme/284.jpg",
    },
    {
      src: "assets/img/pensionscheme/285.jpg",
      caption: "നെയ്യാറ്റിൻകര പെൻഷൻ പ്ലാനിൻ്റെ ആഭിമുഖ്യത്തിൽ നിംസ് മെഡിസിറ്റിയും പെരുങ്കടവിള പഞ്ചായത്തും സയുക്തമായി നെയ്യാറ്റിൻകര പെൻഷൻ പ്ലാൻ ഗുണഭോക്താക്കൾക്കും സ്നേഹാലയ ബഡ് സ്കൂൾ കുട്ടികൾ, പെരുങ്കടവിള പഞ്ചായത്തിലെ ഭിന്നശേഷിക്കാർ, വയോജനങ്ങൾ , അഞ്ച് വയസ്സിൽ താഴെ പ്രായമുള്ള കുട്ടികൾ തുടങ്ങിയവർക്കായി മെഡിക്കൽ ക്യാമ്പും ബോധവൽക്കരണ പരിപാടികളും നടത്തി. പെരുങ്കടവിള പഞ്ചായത്ത് വൈസ് പ്രസിഡന്റ് ശ്രീമതി. ബിന്ദു അധ്യക്ഷത വഹിച്ചു. പഞ്ചായത്ത് പ്രസിഡന്റ് ശ്രീ. സുരേന്ദ്രൻ എസ് മെഡിക്കൽ ക്യാമ്പ് ഉദ്ഘാടനം ചെയ്ത് സംസാരിക്കുകയുണ്ടായി. \"നിംസ് മെഡിസിറ്റി എന്നത് ഒരു ജനകീയ സ്ഥാപനമാണ്. ഇത്രയധികം സൗജന്യ സേവനങ്ങൾ നിബന്ധനകളില്ലാതെ നൽകാൻ നിംസ് മെഡിസിറ്റി മാനേജിങ്ങ് ഡയറക്ടർ ശ്രീ. എം. എസ് ഫൈസൽ ഖാൻ സാറിനല്ലാതെ മറ്റാർക്കും സാധിക്കുകയില്ല.\"ഭിന്നശേഷിക്കാരായവർക്ക് വേണ്ടി പെൻഷൻ പദ്ധതി , വയോജന സംരക്ഷണം, കുഞ്ഞുങ്ങളുടെ ശാരീരിക ബൗദ്ധിക വികാസങ്ങളുടെ ഏറ്റക്കുറച്ചിലുകൾ മനസ്സിലാക്കി കാലതാമസം വരാതെ തെറാപ്പി സൗകര്യം, ഭിന്നശേഷിക്കാർക്ക് തൊഴിലവസരം നൽകുക തുടങ്ങിയവ ഉദ്ഘാടകൻ എടുത്ത് പറയുകയുണ്ടായി.നിംസ് ജറിയാട്രിക് കോർഡിനേറ്റർ ശ്രീമതി. രേണു കെ ആർ പെൻഷൻ പ്ലാൻ വിശദീകരണവും ആശംസയും നേർന്നു. ബഡ്സ്കൂൾ ടീച്ചർ ശ്രീമതി. സിമി ടീച്ചർ സ്വാഗതവും ആശംസിച്ചു. യൂത്ത് റെഡ്ക്രോസ് ടീമൻ്റെ സജീവപങ്കാളിത്തം ക്യാമ്പിനെ വിജയ കരമാക്കി തീർത്തു. ജനറൽ മെഡിസിൻ ഡോക്ടർ നീതുവിൻ്റെ നേതൃത്തിൽ ഓഫ്താൽമോളജി,ദന്തൽ, സ്പെക്ട്രം ഡവലപ്മെന്റ് തെറാപ്പിസ്റ്റ്മാരുടെ സേവനം, ഇ സി ജി, ബി പി , റാൻഡം ബ്ലഡ് ഷുഗർ തുടങ്ങിയ പരിശോധനകളും നടത്തി തുടർ ചികിൽസ ആവശ്യമായവർക്ക് വേണ്ട മാർഗ്ഗ നിർദ്ദേശങ്ങൾ നൽകുകയും ചെയ്തു.",
      thumb: "assets/img/pensionscheme/285.jpg",
    },
    {
      src: "assets/img/pensionscheme/286.jpg",
      caption: "നെയ്യാറ്റിൻകര പെൻഷൻ പ്ലാനിൻ്റെ ആഭിമുഖ്യത്തിൽ നിംസ് മെഡിസിറ്റിയും പെരുങ്കടവിള പഞ്ചായത്തും സയുക്തമായി നെയ്യാറ്റിൻകര പെൻഷൻ പ്ലാൻ ഗുണഭോക്താക്കൾക്കും സ്നേഹാലയ ബഡ് സ്കൂൾ കുട്ടികൾ, പെരുങ്കടവിള പഞ്ചായത്തിലെ ഭിന്നശേഷിക്കാർ, വയോജനങ്ങൾ , അഞ്ച് വയസ്സിൽ താഴെ പ്രായമുള്ള കുട്ടികൾ തുടങ്ങിയവർക്കായി മെഡിക്കൽ ക്യാമ്പും ബോധവൽക്കരണ പരിപാടികളും നടത്തി. പെരുങ്കടവിള പഞ്ചായത്ത് വൈസ് പ്രസിഡന്റ് ശ്രീമതി. ബിന്ദു അധ്യക്ഷത വഹിച്ചു. പഞ്ചായത്ത് പ്രസിഡന്റ് ശ്രീ. സുരേന്ദ്രൻ എസ് മെഡിക്കൽ ക്യാമ്പ് ഉദ്ഘാടനം ചെയ്ത് സംസാരിക്കുകയുണ്ടായി. \"നിംസ് മെഡിസിറ്റി എന്നത് ഒരു ജനകീയ സ്ഥാപനമാണ്. ഇത്രയധികം സൗജന്യ സേവനങ്ങൾ നിബന്ധനകളില്ലാതെ നൽകാൻ നിംസ് മെഡിസിറ്റി മാനേജിങ്ങ് ഡയറക്ടർ ശ്രീ. എം. എസ് ഫൈസൽ ഖാൻ സാറിനല്ലാതെ മറ്റാർക്കും സാധിക്കുകയില്ല.\"ഭിന്നശേഷിക്കാരായവർക്ക് വേണ്ടി പെൻഷൻ പദ്ധതി , വയോജന സംരക്ഷണം, കുഞ്ഞുങ്ങളുടെ ശാരീരിക ബൗദ്ധിക വികാസങ്ങളുടെ ഏറ്റക്കുറച്ചിലുകൾ മനസ്സിലാക്കി കാലതാമസം വരാതെ തെറാപ്പി സൗകര്യം, ഭിന്നശേഷിക്കാർക്ക് തൊഴിലവസരം നൽകുക തുടങ്ങിയവ ഉദ്ഘാടകൻ എടുത്ത് പറയുകയുണ്ടായി.നിംസ് ജറിയാട്രിക് കോർഡിനേറ്റർ ശ്രീമതി. രേണു കെ ആർ പെൻഷൻ പ്ലാൻ വിശദീകരണവും ആശംസയും നേർന്നു. ബഡ്സ്കൂൾ ടീച്ചർ ശ്രീമതി. സിമി ടീച്ചർ സ്വാഗതവും ആശംസിച്ചു. യൂത്ത് റെഡ്ക്രോസ് ടീമൻ്റെ സജീവപങ്കാളിത്തം ക്യാമ്പിനെ വിജയ കരമാക്കി തീർത്തു. ജനറൽ മെഡിസിൻ ഡോക്ടർ നീതുവിൻ്റെ നേതൃത്തിൽ ഓഫ്താൽമോളജി,ദന്തൽ, സ്പെക്ട്രം ഡവലപ്മെന്റ് തെറാപ്പിസ്റ്റ്മാരുടെ സേവനം, ഇ സി ജി, ബി പി , റാൻഡം ബ്ലഡ് ഷുഗർ തുടങ്ങിയ പരിശോധനകളും നടത്തി തുടർ ചികിൽസ ആവശ്യമായവർക്ക് വേണ്ട മാർഗ്ഗ നിർദ്ദേശങ്ങൾ നൽകുകയും ചെയ്തു.",
      thumb: "assets/img/pensionscheme/286.jpg",
    },
    {
      src: "assets/img/pensionscheme/287.jpg",
      caption: "നെയ്യാറ്റിൻകര പെൻഷൻ പ്ലാനിൻ്റെ ആഭിമുഖ്യത്തിൽ നിംസ് മെഡിസിറ്റിയും പെരുങ്കടവിള പഞ്ചായത്തും സയുക്തമായി നെയ്യാറ്റിൻകര പെൻഷൻ പ്ലാൻ ഗുണഭോക്താക്കൾക്കും സ്നേഹാലയ ബഡ് സ്കൂൾ കുട്ടികൾ, പെരുങ്കടവിള പഞ്ചായത്തിലെ ഭിന്നശേഷിക്കാർ, വയോജനങ്ങൾ , അഞ്ച് വയസ്സിൽ താഴെ പ്രായമുള്ള കുട്ടികൾ തുടങ്ങിയവർക്കായി മെഡിക്കൽ ക്യാമ്പും ബോധവൽക്കരണ പരിപാടികളും നടത്തി. പെരുങ്കടവിള പഞ്ചായത്ത് വൈസ് പ്രസിഡന്റ് ശ്രീമതി. ബിന്ദു അധ്യക്ഷത വഹിച്ചു. പഞ്ചായത്ത് പ്രസിഡന്റ് ശ്രീ. സുരേന്ദ്രൻ എസ് മെഡിക്കൽ ക്യാമ്പ് ഉദ്ഘാടനം ചെയ്ത് സംസാരിക്കുകയുണ്ടായി. \"നിംസ് മെഡിസിറ്റി എന്നത് ഒരു ജനകീയ സ്ഥാപനമാണ്. ഇത്രയധികം സൗജന്യ സേവനങ്ങൾ നിബന്ധനകളില്ലാതെ നൽകാൻ നിംസ് മെഡിസിറ്റി മാനേജിങ്ങ് ഡയറക്ടർ ശ്രീ. എം. എസ് ഫൈസൽ ഖാൻ സാറിനല്ലാതെ മറ്റാർക്കും സാധിക്കുകയില്ല.\"ഭിന്നശേഷിക്കാരായവർക്ക് വേണ്ടി പെൻഷൻ പദ്ധതി , വയോജന സംരക്ഷണം, കുഞ്ഞുങ്ങളുടെ ശാരീരിക ബൗദ്ധിക വികാസങ്ങളുടെ ഏറ്റക്കുറച്ചിലുകൾ മനസ്സിലാക്കി കാലതാമസം വരാതെ തെറാപ്പി സൗകര്യം, ഭിന്നശേഷിക്കാർക്ക് തൊഴിലവസരം നൽകുക തുടങ്ങിയവ ഉദ്ഘാടകൻ എടുത്ത് പറയുകയുണ്ടായി.നിംസ് ജറിയാട്രിക് കോർഡിനേറ്റർ ശ്രീമതി. രേണു കെ ആർ പെൻഷൻ പ്ലാൻ വിശദീകരണവും ആശംസയും നേർന്നു. ബഡ്സ്കൂൾ ടീച്ചർ ശ്രീമതി. സിമി ടീച്ചർ സ്വാഗതവും ആശംസിച്ചു. യൂത്ത് റെഡ്ക്രോസ് ടീമൻ്റെ സജീവപങ്കാളിത്തം ക്യാമ്പിനെ വിജയ കരമാക്കി തീർത്തു. ജനറൽ മെഡിസിൻ ഡോക്ടർ നീതുവിൻ്റെ നേതൃത്തിൽ ഓഫ്താൽമോളജി,ദന്തൽ, സ്പെക്ട്രം ഡവലപ്മെന്റ് തെറാപ്പിസ്റ്റ്മാരുടെ സേവനം, ഇ സി ജി, ബി പി , റാൻഡം ബ്ലഡ് ഷുഗർ തുടങ്ങിയ പരിശോധനകളും നടത്തി തുടർ ചികിൽസ ആവശ്യമായവർക്ക് വേണ്ട മാർഗ്ഗ നിർദ്ദേശങ്ങൾ നൽകുകയും ചെയ്തു.",
      thumb: "assets/img/pensionscheme/287.jpg",
    },
    {
      src: "assets/img/pensionscheme/288.jpg",
      caption: "നെയ്യാറ്റിൻകര പെൻഷൻ പ്ലാനിൻ്റെ ആഭിമുഖ്യത്തിൽ നിംസ് മെഡിസിറ്റിയും പെരുങ്കടവിള പഞ്ചായത്തും സയുക്തമായി നെയ്യാറ്റിൻകര പെൻഷൻ പ്ലാൻ ഗുണഭോക്താക്കൾക്കും സ്നേഹാലയ ബഡ് സ്കൂൾ കുട്ടികൾ, പെരുങ്കടവിള പഞ്ചായത്തിലെ ഭിന്നശേഷിക്കാർ, വയോജനങ്ങൾ , അഞ്ച് വയസ്സിൽ താഴെ പ്രായമുള്ള കുട്ടികൾ തുടങ്ങിയവർക്കായി മെഡിക്കൽ ക്യാമ്പും ബോധവൽക്കരണ പരിപാടികളും നടത്തി. പെരുങ്കടവിള പഞ്ചായത്ത് വൈസ് പ്രസിഡന്റ് ശ്രീമതി. ബിന്ദു അധ്യക്ഷത വഹിച്ചു. പഞ്ചായത്ത് പ്രസിഡന്റ് ശ്രീ. സുരേന്ദ്രൻ എസ് മെഡിക്കൽ ക്യാമ്പ് ഉദ്ഘാടനം ചെയ്ത് സംസാരിക്കുകയുണ്ടായി. \"നിംസ് മെഡിസിറ്റി എന്നത് ഒരു ജനകീയ സ്ഥാപനമാണ്. ഇത്രയധികം സൗജന്യ സേവനങ്ങൾ നിബന്ധനകളില്ലാതെ നൽകാൻ നിംസ് മെഡിസിറ്റി മാനേജിങ്ങ് ഡയറക്ടർ ശ്രീ. എം. എസ് ഫൈസൽ ഖാൻ സാറിനല്ലാതെ മറ്റാർക്കും സാധിക്കുകയില്ല.\"ഭിന്നശേഷിക്കാരായവർക്ക് വേണ്ടി പെൻഷൻ പദ്ധതി , വയോജന സംരക്ഷണം, കുഞ്ഞുങ്ങളുടെ ശാരീരിക ബൗദ്ധിക വികാസങ്ങളുടെ ഏറ്റക്കുറച്ചിലുകൾ മനസ്സിലാക്കി കാലതാമസം വരാതെ തെറാപ്പി സൗകര്യം, ഭിന്നശേഷിക്കാർക്ക് തൊഴിലവസരം നൽകുക തുടങ്ങിയവ ഉദ്ഘാടകൻ എടുത്ത് പറയുകയുണ്ടായി.നിംസ് ജറിയാട്രിക് കോർഡിനേറ്റർ ശ്രീമതി. രേണു കെ ആർ പെൻഷൻ പ്ലാൻ വിശദീകരണവും ആശംസയും നേർന്നു. ബഡ്സ്കൂൾ ടീച്ചർ ശ്രീമതി. സിമി ടീച്ചർ സ്വാഗതവും ആശംസിച്ചു. യൂത്ത് റെഡ്ക്രോസ് ടീമൻ്റെ സജീവപങ്കാളിത്തം ക്യാമ്പിനെ വിജയ കരമാക്കി തീർത്തു. ജനറൽ മെഡിസിൻ ഡോക്ടർ നീതുവിൻ്റെ നേതൃത്തിൽ ഓഫ്താൽമോളജി,ദന്തൽ, സ്പെക്ട്രം ഡവലപ്മെന്റ് തെറാപ്പിസ്റ്റ്മാരുടെ സേവനം, ഇ സി ജി, ബി പി , റാൻഡം ബ്ലഡ് ഷുഗർ തുടങ്ങിയ പരിശോധനകളും നടത്തി തുടർ ചികിൽസ ആവശ്യമായവർക്ക് വേണ്ട മാർഗ്ഗ നിർദ്ദേശങ്ങൾ നൽകുകയും ചെയ്തു.",
      thumb: "assets/img/pensionscheme/288.jpg",
    },
    {
      src: "assets/img/pensionscheme/289.jpg",
      caption: "നെയ്യാറ്റിൻകര പെൻഷൻ പ്ലാനിൻ്റെ ആഭിമുഖ്യത്തിൽ നിംസ് മെഡിസിറ്റിയും പെരുങ്കടവിള പഞ്ചായത്തും സയുക്തമായി നെയ്യാറ്റിൻകര പെൻഷൻ പ്ലാൻ ഗുണഭോക്താക്കൾക്കും സ്നേഹാലയ ബഡ് സ്കൂൾ കുട്ടികൾ, പെരുങ്കടവിള പഞ്ചായത്തിലെ ഭിന്നശേഷിക്കാർ, വയോജനങ്ങൾ , അഞ്ച് വയസ്സിൽ താഴെ പ്രായമുള്ള കുട്ടികൾ തുടങ്ങിയവർക്കായി മെഡിക്കൽ ക്യാമ്പും ബോധവൽക്കരണ പരിപാടികളും നടത്തി. പെരുങ്കടവിള പഞ്ചായത്ത് വൈസ് പ്രസിഡന്റ് ശ്രീമതി. ബിന്ദു അധ്യക്ഷത വഹിച്ചു. പഞ്ചായത്ത് പ്രസിഡന്റ് ശ്രീ. സുരേന്ദ്രൻ എസ് മെഡിക്കൽ ക്യാമ്പ് ഉദ്ഘാടനം ചെയ്ത് സംസാരിക്കുകയുണ്ടായി. \"നിംസ് മെഡിസിറ്റി എന്നത് ഒരു ജനകീയ സ്ഥാപനമാണ്. ഇത്രയധികം സൗജന്യ സേവനങ്ങൾ നിബന്ധനകളില്ലാതെ നൽകാൻ നിംസ് മെഡിസിറ്റി മാനേജിങ്ങ് ഡയറക്ടർ ശ്രീ. എം. എസ് ഫൈസൽ ഖാൻ സാറിനല്ലാതെ മറ്റാർക്കും സാധിക്കുകയില്ല.\"ഭിന്നശേഷിക്കാരായവർക്ക് വേണ്ടി പെൻഷൻ പദ്ധതി , വയോജന സംരക്ഷണം, കുഞ്ഞുങ്ങളുടെ ശാരീരിക ബൗദ്ധിക വികാസങ്ങളുടെ ഏറ്റക്കുറച്ചിലുകൾ മനസ്സിലാക്കി കാലതാമസം വരാതെ തെറാപ്പി സൗകര്യം, ഭിന്നശേഷിക്കാർക്ക് തൊഴിലവസരം നൽകുക തുടങ്ങിയവ ഉദ്ഘാടകൻ എടുത്ത് പറയുകയുണ്ടായി.നിംസ് ജറിയാട്രിക് കോർഡിനേറ്റർ ശ്രീമതി. രേണു കെ ആർ പെൻഷൻ പ്ലാൻ വിശദീകരണവും ആശംസയും നേർന്നു. ബഡ്സ്കൂൾ ടീച്ചർ ശ്രീമതി. സിമി ടീച്ചർ സ്വാഗതവും ആശംസിച്ചു. യൂത്ത് റെഡ്ക്രോസ് ടീമൻ്റെ സജീവപങ്കാളിത്തം ക്യാമ്പിനെ വിജയ കരമാക്കി തീർത്തു. ജനറൽ മെഡിസിൻ ഡോക്ടർ നീതുവിൻ്റെ നേതൃത്തിൽ ഓഫ്താൽമോളജി,ദന്തൽ, സ്പെക്ട്രം ഡവലപ്മെന്റ് തെറാപ്പിസ്റ്റ്മാരുടെ സേവനം, ഇ സി ജി, ബി പി , റാൻഡം ബ്ലഡ് ഷുഗർ തുടങ്ങിയ പരിശോധനകളും നടത്തി തുടർ ചികിൽസ ആവശ്യമായവർക്ക് വേണ്ട മാർഗ്ഗ നിർദ്ദേശങ്ങൾ നൽകുകയും ചെയ്തു.",
      thumb: "assets/img/pensionscheme/289.jpg",
    },
    {
      src: "assets/img/pensionscheme/290.jpg",
      caption: "നെയ്യാറ്റിൻകര പെൻഷൻ പ്ലാനിൻ്റെ ആഭിമുഖ്യത്തിൽ നിംസ് മെഡിസിറ്റിയും പെരുങ്കടവിള പഞ്ചായത്തും സയുക്തമായി നെയ്യാറ്റിൻകര പെൻഷൻ പ്ലാൻ ഗുണഭോക്താക്കൾക്കും സ്നേഹാലയ ബഡ് സ്കൂൾ കുട്ടികൾ, പെരുങ്കടവിള പഞ്ചായത്തിലെ ഭിന്നശേഷിക്കാർ, വയോജനങ്ങൾ , അഞ്ച് വയസ്സിൽ താഴെ പ്രായമുള്ള കുട്ടികൾ തുടങ്ങിയവർക്കായി മെഡിക്കൽ ക്യാമ്പും ബോധവൽക്കരണ പരിപാടികളും നടത്തി. പെരുങ്കടവിള പഞ്ചായത്ത് വൈസ് പ്രസിഡന്റ് ശ്രീമതി. ബിന്ദു അധ്യക്ഷത വഹിച്ചു. പഞ്ചായത്ത് പ്രസിഡന്റ് ശ്രീ. സുരേന്ദ്രൻ എസ് മെഡിക്കൽ ക്യാമ്പ് ഉദ്ഘാടനം ചെയ്ത് സംസാരിക്കുകയുണ്ടായി. \"നിംസ് മെഡിസിറ്റി എന്നത് ഒരു ജനകീയ സ്ഥാപനമാണ്. ഇത്രയധികം സൗജന്യ സേവനങ്ങൾ നിബന്ധനകളില്ലാതെ നൽകാൻ നിംസ് മെഡിസിറ്റി മാനേജിങ്ങ് ഡയറക്ടർ ശ്രീ. എം. എസ് ഫൈസൽ ഖാൻ സാറിനല്ലാതെ മറ്റാർക്കും സാധിക്കുകയില്ല.\"ഭിന്നശേഷിക്കാരായവർക്ക് വേണ്ടി പെൻഷൻ പദ്ധതി , വയോജന സംരക്ഷണം, കുഞ്ഞുങ്ങളുടെ ശാരീരിക ബൗദ്ധിക വികാസങ്ങളുടെ ഏറ്റക്കുറച്ചിലുകൾ മനസ്സിലാക്കി കാലതാമസം വരാതെ തെറാപ്പി സൗകര്യം, ഭിന്നശേഷിക്കാർക്ക് തൊഴിലവസരം നൽകുക തുടങ്ങിയവ ഉദ്ഘാടകൻ എടുത്ത് പറയുകയുണ്ടായി.നിംസ് ജറിയാട്രിക് കോർഡിനേറ്റർ ശ്രീമതി. രേണു കെ ആർ പെൻഷൻ പ്ലാൻ വിശദീകരണവും ആശംസയും നേർന്നു. ബഡ്സ്കൂൾ ടീച്ചർ ശ്രീമതി. സിമി ടീച്ചർ സ്വാഗതവും ആശംസിച്ചു. യൂത്ത് റെഡ്ക്രോസ് ടീമൻ്റെ സജീവപങ്കാളിത്തം ക്യാമ്പിനെ വിജയ കരമാക്കി തീർത്തു. ജനറൽ മെഡിസിൻ ഡോക്ടർ നീതുവിൻ്റെ നേതൃത്തിൽ ഓഫ്താൽമോളജി,ദന്തൽ, സ്പെക്ട്രം ഡവലപ്മെന്റ് തെറാപ്പിസ്റ്റ്മാരുടെ സേവനം, ഇ സി ജി, ബി പി , റാൻഡം ബ്ലഡ് ഷുഗർ തുടങ്ങിയ പരിശോധനകളും നടത്തി തുടർ ചികിൽസ ആവശ്യമായവർക്ക് വേണ്ട മാർഗ്ഗ നിർദ്ദേശങ്ങൾ നൽകുകയും ചെയ്തു.",
      thumb: "assets/img/pensionscheme/290.jpg",
    },
    {
      src: "assets/img/pensionscheme/291.jpg",
      caption: "നെയ്യാറ്റിൻകര പെൻഷൻ പ്ലാനിൻ്റെ ആഭിമുഖ്യത്തിൽ നിംസ് മെഡിസിറ്റിയും പെരുങ്കടവിള പഞ്ചായത്തും സയുക്തമായി നെയ്യാറ്റിൻകര പെൻഷൻ പ്ലാൻ ഗുണഭോക്താക്കൾക്കും സ്നേഹാലയ ബഡ് സ്കൂൾ കുട്ടികൾ, പെരുങ്കടവിള പഞ്ചായത്തിലെ ഭിന്നശേഷിക്കാർ, വയോജനങ്ങൾ , അഞ്ച് വയസ്സിൽ താഴെ പ്രായമുള്ള കുട്ടികൾ തുടങ്ങിയവർക്കായി മെഡിക്കൽ ക്യാമ്പും ബോധവൽക്കരണ പരിപാടികളും നടത്തി. പെരുങ്കടവിള പഞ്ചായത്ത് വൈസ് പ്രസിഡന്റ് ശ്രീമതി. ബിന്ദു അധ്യക്ഷത വഹിച്ചു. പഞ്ചായത്ത് പ്രസിഡന്റ് ശ്രീ. സുരേന്ദ്രൻ എസ് മെഡിക്കൽ ക്യാമ്പ് ഉദ്ഘാടനം ചെയ്ത് സംസാരിക്കുകയുണ്ടായി. \"നിംസ് മെഡിസിറ്റി എന്നത് ഒരു ജനകീയ സ്ഥാപനമാണ്. ഇത്രയധികം സൗജന്യ സേവനങ്ങൾ നിബന്ധനകളില്ലാതെ നൽകാൻ നിംസ് മെഡിസിറ്റി മാനേജിങ്ങ് ഡയറക്ടർ ശ്രീ. എം. എസ് ഫൈസൽ ഖാൻ സാറിനല്ലാതെ മറ്റാർക്കും സാധിക്കുകയില്ല.\"ഭിന്നശേഷിക്കാരായവർക്ക് വേണ്ടി പെൻഷൻ പദ്ധതി , വയോജന സംരക്ഷണം, കുഞ്ഞുങ്ങളുടെ ശാരീരിക ബൗദ്ധിക വികാസങ്ങളുടെ ഏറ്റക്കുറച്ചിലുകൾ മനസ്സിലാക്കി കാലതാമസം വരാതെ തെറാപ്പി സൗകര്യം, ഭിന്നശേഷിക്കാർക്ക് തൊഴിലവസരം നൽകുക തുടങ്ങിയവ ഉദ്ഘാടകൻ എടുത്ത് പറയുകയുണ്ടായി.നിംസ് ജറിയാട്രിക് കോർഡിനേറ്റർ ശ്രീമതി. രേണു കെ ആർ പെൻഷൻ പ്ലാൻ വിശദീകരണവും ആശംസയും നേർന്നു. ബഡ്സ്കൂൾ ടീച്ചർ ശ്രീമതി. സിമി ടീച്ചർ സ്വാഗതവും ആശംസിച്ചു. യൂത്ത് റെഡ്ക്രോസ് ടീമൻ്റെ സജീവപങ്കാളിത്തം ക്യാമ്പിനെ വിജയ കരമാക്കി തീർത്തു. ജനറൽ മെഡിസിൻ ഡോക്ടർ നീതുവിൻ്റെ നേതൃത്തിൽ ഓഫ്താൽമോളജി,ദന്തൽ, സ്പെക്ട്രം ഡവലപ്മെന്റ് തെറാപ്പിസ്റ്റ്മാരുടെ സേവനം, ഇ സി ജി, ബി പി , റാൻഡം ബ്ലഡ് ഷുഗർ തുടങ്ങിയ പരിശോധനകളും നടത്തി തുടർ ചികിൽസ ആവശ്യമായവർക്ക് വേണ്ട മാർഗ്ഗ നിർദ്ദേശങ്ങൾ നൽകുകയും ചെയ്തു.",
      thumb: "assets/img/pensionscheme/291.jpg",
    },
    {
      src: "assets/img/pensionscheme/292.jpg",
      caption: "നെയ്യാറ്റിൻകര പെൻഷൻ പ്ലാനിൻ്റെ ആഭിമുഖ്യത്തിൽ നിംസ് മെഡിസിറ്റിയും പെരുങ്കടവിള പഞ്ചായത്തും സയുക്തമായി നെയ്യാറ്റിൻകര പെൻഷൻ പ്ലാൻ ഗുണഭോക്താക്കൾക്കും സ്നേഹാലയ ബഡ് സ്കൂൾ കുട്ടികൾ, പെരുങ്കടവിള പഞ്ചായത്തിലെ ഭിന്നശേഷിക്കാർ, വയോജനങ്ങൾ , അഞ്ച് വയസ്സിൽ താഴെ പ്രായമുള്ള കുട്ടികൾ തുടങ്ങിയവർക്കായി മെഡിക്കൽ ക്യാമ്പും ബോധവൽക്കരണ പരിപാടികളും നടത്തി. പെരുങ്കടവിള പഞ്ചായത്ത് വൈസ് പ്രസിഡന്റ് ശ്രീമതി. ബിന്ദു അധ്യക്ഷത വഹിച്ചു. പഞ്ചായത്ത് പ്രസിഡന്റ് ശ്രീ. സുരേന്ദ്രൻ എസ് മെഡിക്കൽ ക്യാമ്പ് ഉദ്ഘാടനം ചെയ്ത് സംസാരിക്കുകയുണ്ടായി. \"നിംസ് മെഡിസിറ്റി എന്നത് ഒരു ജനകീയ സ്ഥാപനമാണ്. ഇത്രയധികം സൗജന്യ സേവനങ്ങൾ നിബന്ധനകളില്ലാതെ നൽകാൻ നിംസ് മെഡിസിറ്റി മാനേജിങ്ങ് ഡയറക്ടർ ശ്രീ. എം. എസ് ഫൈസൽ ഖാൻ സാറിനല്ലാതെ മറ്റാർക്കും സാധിക്കുകയില്ല.\"ഭിന്നശേഷിക്കാരായവർക്ക് വേണ്ടി പെൻഷൻ പദ്ധതി , വയോജന സംരക്ഷണം, കുഞ്ഞുങ്ങളുടെ ശാരീരിക ബൗദ്ധിക വികാസങ്ങളുടെ ഏറ്റക്കുറച്ചിലുകൾ മനസ്സിലാക്കി കാലതാമസം വരാതെ തെറാപ്പി സൗകര്യം, ഭിന്നശേഷിക്കാർക്ക് തൊഴിലവസരം നൽകുക തുടങ്ങിയവ ഉദ്ഘാടകൻ എടുത്ത് പറയുകയുണ്ടായി.നിംസ് ജറിയാട്രിക് കോർഡിനേറ്റർ ശ്രീമതി. രേണു കെ ആർ പെൻഷൻ പ്ലാൻ വിശദീകരണവും ആശംസയും നേർന്നു. ബഡ്സ്കൂൾ ടീച്ചർ ശ്രീമതി. സിമി ടീച്ചർ സ്വാഗതവും ആശംസിച്ചു. യൂത്ത് റെഡ്ക്രോസ് ടീമൻ്റെ സജീവപങ്കാളിത്തം ക്യാമ്പിനെ വിജയ കരമാക്കി തീർത്തു. ജനറൽ മെഡിസിൻ ഡോക്ടർ നീതുവിൻ്റെ നേതൃത്തിൽ ഓഫ്താൽമോളജി,ദന്തൽ, സ്പെക്ട്രം ഡവലപ്മെന്റ് തെറാപ്പിസ്റ്റ്മാരുടെ സേവനം, ഇ സി ജി, ബി പി , റാൻഡം ബ്ലഡ് ഷുഗർ തുടങ്ങിയ പരിശോധനകളും നടത്തി തുടർ ചികിൽസ ആവശ്യമായവർക്ക് വേണ്ട മാർഗ്ഗ നിർദ്ദേശങ്ങൾ നൽകുകയും ചെയ്തു.",
      thumb: "assets/img/pensionscheme/292.jpg",
    },
    {
      src: "assets/img/pensionscheme/293.jpg",
      caption: "നെയ്യാറ്റിൻകര പെൻഷൻ പ്ലാനിൻ്റെ ആഭിമുഖ്യത്തിൽ നിംസ് മെഡിസിറ്റിയും പെരുങ്കടവിള പഞ്ചായത്തും സയുക്തമായി നെയ്യാറ്റിൻകര പെൻഷൻ പ്ലാൻ ഗുണഭോക്താക്കൾക്കും സ്നേഹാലയ ബഡ് സ്കൂൾ കുട്ടികൾ, പെരുങ്കടവിള പഞ്ചായത്തിലെ ഭിന്നശേഷിക്കാർ, വയോജനങ്ങൾ , അഞ്ച് വയസ്സിൽ താഴെ പ്രായമുള്ള കുട്ടികൾ തുടങ്ങിയവർക്കായി മെഡിക്കൽ ക്യാമ്പും ബോധവൽക്കരണ പരിപാടികളും നടത്തി. പെരുങ്കടവിള പഞ്ചായത്ത് വൈസ് പ്രസിഡന്റ് ശ്രീമതി. ബിന്ദു അധ്യക്ഷത വഹിച്ചു. പഞ്ചായത്ത് പ്രസിഡന്റ് ശ്രീ. സുരേന്ദ്രൻ എസ് മെഡിക്കൽ ക്യാമ്പ് ഉദ്ഘാടനം ചെയ്ത് സംസാരിക്കുകയുണ്ടായി. \"നിംസ് മെഡിസിറ്റി എന്നത് ഒരു ജനകീയ സ്ഥാപനമാണ്. ഇത്രയധികം സൗജന്യ സേവനങ്ങൾ നിബന്ധനകളില്ലാതെ നൽകാൻ നിംസ് മെഡിസിറ്റി മാനേജിങ്ങ് ഡയറക്ടർ ശ്രീ. എം. എസ് ഫൈസൽ ഖാൻ സാറിനല്ലാതെ മറ്റാർക്കും സാധിക്കുകയില്ല.\"ഭിന്നശേഷിക്കാരായവർക്ക് വേണ്ടി പെൻഷൻ പദ്ധതി , വയോജന സംരക്ഷണം, കുഞ്ഞുങ്ങളുടെ ശാരീരിക ബൗദ്ധിക വികാസങ്ങളുടെ ഏറ്റക്കുറച്ചിലുകൾ മനസ്സിലാക്കി കാലതാമസം വരാതെ തെറാപ്പി സൗകര്യം, ഭിന്നശേഷിക്കാർക്ക് തൊഴിലവസരം നൽകുക തുടങ്ങിയവ ഉദ്ഘാടകൻ എടുത്ത് പറയുകയുണ്ടായി.നിംസ് ജറിയാട്രിക് കോർഡിനേറ്റർ ശ്രീമതി. രേണു കെ ആർ പെൻഷൻ പ്ലാൻ വിശദീകരണവും ആശംസയും നേർന്നു. ബഡ്സ്കൂൾ ടീച്ചർ ശ്രീമതി. സിമി ടീച്ചർ സ്വാഗതവും ആശംസിച്ചു. യൂത്ത് റെഡ്ക്രോസ് ടീമൻ്റെ സജീവപങ്കാളിത്തം ക്യാമ്പിനെ വിജയ കരമാക്കി തീർത്തു. ജനറൽ മെഡിസിൻ ഡോക്ടർ നീതുവിൻ്റെ നേതൃത്തിൽ ഓഫ്താൽമോളജി,ദന്തൽ, സ്പെക്ട്രം ഡവലപ്മെന്റ് തെറാപ്പിസ്റ്റ്മാരുടെ സേവനം, ഇ സി ജി, ബി പി , റാൻഡം ബ്ലഡ് ഷുഗർ തുടങ്ങിയ പരിശോധനകളും നടത്തി തുടർ ചികിൽസ ആവശ്യമായവർക്ക് വേണ്ട മാർഗ്ഗ നിർദ്ദേശങ്ങൾ നൽകുകയും ചെയ്തു.",
      thumb: "assets/img/pensionscheme/293.jpg",
    },
    {
      src: "assets/img/pensionscheme/294.jpg",
      caption: "നെയ്യാറ്റിൻകര പെൻഷൻ പ്ലാനിൻ്റെ ആഭിമുഖ്യത്തിൽ നിംസ് മെഡിസിറ്റിയും പെരുങ്കടവിള പഞ്ചായത്തും സയുക്തമായി നെയ്യാറ്റിൻകര പെൻഷൻ പ്ലാൻ ഗുണഭോക്താക്കൾക്കും സ്നേഹാലയ ബഡ് സ്കൂൾ കുട്ടികൾ, പെരുങ്കടവിള പഞ്ചായത്തിലെ ഭിന്നശേഷിക്കാർ, വയോജനങ്ങൾ , അഞ്ച് വയസ്സിൽ താഴെ പ്രായമുള്ള കുട്ടികൾ തുടങ്ങിയവർക്കായി മെഡിക്കൽ ക്യാമ്പും ബോധവൽക്കരണ പരിപാടികളും നടത്തി. പെരുങ്കടവിള പഞ്ചായത്ത് വൈസ് പ്രസിഡന്റ് ശ്രീമതി. ബിന്ദു അധ്യക്ഷത വഹിച്ചു. പഞ്ചായത്ത് പ്രസിഡന്റ് ശ്രീ. സുരേന്ദ്രൻ എസ് മെഡിക്കൽ ക്യാമ്പ് ഉദ്ഘാടനം ചെയ്ത് സംസാരിക്കുകയുണ്ടായി. \"നിംസ് മെഡിസിറ്റി എന്നത് ഒരു ജനകീയ സ്ഥാപനമാണ്. ഇത്രയധികം സൗജന്യ സേവനങ്ങൾ നിബന്ധനകളില്ലാതെ നൽകാൻ നിംസ് മെഡിസിറ്റി മാനേജിങ്ങ് ഡയറക്ടർ ശ്രീ. എം. എസ് ഫൈസൽ ഖാൻ സാറിനല്ലാതെ മറ്റാർക്കും സാധിക്കുകയില്ല.\"ഭിന്നശേഷിക്കാരായവർക്ക് വേണ്ടി പെൻഷൻ പദ്ധതി , വയോജന സംരക്ഷണം, കുഞ്ഞുങ്ങളുടെ ശാരീരിക ബൗദ്ധിക വികാസങ്ങളുടെ ഏറ്റക്കുറച്ചിലുകൾ മനസ്സിലാക്കി കാലതാമസം വരാതെ തെറാപ്പി സൗകര്യം, ഭിന്നശേഷിക്കാർക്ക് തൊഴിലവസരം നൽകുക തുടങ്ങിയവ ഉദ്ഘാടകൻ എടുത്ത് പറയുകയുണ്ടായി.നിംസ് ജറിയാട്രിക് കോർഡിനേറ്റർ ശ്രീമതി. രേണു കെ ആർ പെൻഷൻ പ്ലാൻ വിശദീകരണവും ആശംസയും നേർന്നു. ബഡ്സ്കൂൾ ടീച്ചർ ശ്രീമതി. സിമി ടീച്ചർ സ്വാഗതവും ആശംസിച്ചു. യൂത്ത് റെഡ്ക്രോസ് ടീമൻ്റെ സജീവപങ്കാളിത്തം ക്യാമ്പിനെ വിജയ കരമാക്കി തീർത്തു. ജനറൽ മെഡിസിൻ ഡോക്ടർ നീതുവിൻ്റെ നേതൃത്തിൽ ഓഫ്താൽമോളജി,ദന്തൽ, സ്പെക്ട്രം ഡവലപ്മെന്റ് തെറാപ്പിസ്റ്റ്മാരുടെ സേവനം, ഇ സി ജി, ബി പി , റാൻഡം ബ്ലഡ് ഷുഗർ തുടങ്ങിയ പരിശോധനകളും നടത്തി തുടർ ചികിൽസ ആവശ്യമായവർക്ക് വേണ്ട മാർഗ്ഗ നിർദ്ദേശങ്ങൾ നൽകുകയും ചെയ്തു.",
      thumb: "assets/img/pensionscheme/294.jpg",
    },
    {
      src: "assets/img/pensionscheme/295.jpg",
      caption: "നെയ്യാറ്റിൻകര പെൻഷൻ പ്ലാനിൻ്റെ ആഭിമുഖ്യത്തിൽ നിംസ് മെഡിസിറ്റിയും പെരുങ്കടവിള പഞ്ചായത്തും സയുക്തമായി നെയ്യാറ്റിൻകര പെൻഷൻ പ്ലാൻ ഗുണഭോക്താക്കൾക്കും സ്നേഹാലയ ബഡ് സ്കൂൾ കുട്ടികൾ, പെരുങ്കടവിള പഞ്ചായത്തിലെ ഭിന്നശേഷിക്കാർ, വയോജനങ്ങൾ , അഞ്ച് വയസ്സിൽ താഴെ പ്രായമുള്ള കുട്ടികൾ തുടങ്ങിയവർക്കായി മെഡിക്കൽ ക്യാമ്പും ബോധവൽക്കരണ പരിപാടികളും നടത്തി. പെരുങ്കടവിള പഞ്ചായത്ത് വൈസ് പ്രസിഡന്റ് ശ്രീമതി. ബിന്ദു അധ്യക്ഷത വഹിച്ചു. പഞ്ചായത്ത് പ്രസിഡന്റ് ശ്രീ. സുരേന്ദ്രൻ എസ് മെഡിക്കൽ ക്യാമ്പ് ഉദ്ഘാടനം ചെയ്ത് സംസാരിക്കുകയുണ്ടായി. \"നിംസ് മെഡിസിറ്റി എന്നത് ഒരു ജനകീയ സ്ഥാപനമാണ്. ഇത്രയധികം സൗജന്യ സേവനങ്ങൾ നിബന്ധനകളില്ലാതെ നൽകാൻ നിംസ് മെഡിസിറ്റി മാനേജിങ്ങ് ഡയറക്ടർ ശ്രീ. എം. എസ് ഫൈസൽ ഖാൻ സാറിനല്ലാതെ മറ്റാർക്കും സാധിക്കുകയില്ല.\"ഭിന്നശേഷിക്കാരായവർക്ക് വേണ്ടി പെൻഷൻ പദ്ധതി , വയോജന സംരക്ഷണം, കുഞ്ഞുങ്ങളുടെ ശാരീരിക ബൗദ്ധിക വികാസങ്ങളുടെ ഏറ്റക്കുറച്ചിലുകൾ മനസ്സിലാക്കി കാലതാമസം വരാതെ തെറാപ്പി സൗകര്യം, ഭിന്നശേഷിക്കാർക്ക് തൊഴിലവസരം നൽകുക തുടങ്ങിയവ ഉദ്ഘാടകൻ എടുത്ത് പറയുകയുണ്ടായി.നിംസ് ജറിയാട്രിക് കോർഡിനേറ്റർ ശ്രീമതി. രേണു കെ ആർ പെൻഷൻ പ്ലാൻ വിശദീകരണവും ആശംസയും നേർന്നു. ബഡ്സ്കൂൾ ടീച്ചർ ശ്രീമതി. സിമി ടീച്ചർ സ്വാഗതവും ആശംസിച്ചു. യൂത്ത് റെഡ്ക്രോസ് ടീമൻ്റെ സജീവപങ്കാളിത്തം ക്യാമ്പിനെ വിജയ കരമാക്കി തീർത്തു. ജനറൽ മെഡിസിൻ ഡോക്ടർ നീതുവിൻ്റെ നേതൃത്തിൽ ഓഫ്താൽമോളജി,ദന്തൽ, സ്പെക്ട്രം ഡവലപ്മെന്റ് തെറാപ്പിസ്റ്റ്മാരുടെ സേവനം, ഇ സി ജി, ബി പി , റാൻഡം ബ്ലഡ് ഷുഗർ തുടങ്ങിയ പരിശോധനകളും നടത്തി തുടർ ചികിൽസ ആവശ്യമായവർക്ക് വേണ്ട മാർഗ്ഗ നിർദ്ദേശങ്ങൾ നൽകുകയും ചെയ്തു.",
      thumb: "assets/img/pensionscheme/295.jpg",
    },
    {
      src: "assets/img/pensionscheme/282.jpg",
      caption: "തിരുവനന്തപുരം∙ നെയ്യാറ്റിൻകര പെൻഷൻ പ്ലാനിന്റെ മൂന്നാം വാർഷികാഘോഷവും എസ്എസ്എൽസി, ഹയർ സെക്കൻഡറി വിഭാഗങ്ങളിൽ ഉന്നത വിജയം കരസ്ഥമാക്കിയ നെയ്യാറ്റിൻകര പെൻഷൻ പ്ലാനിലെ വിദ്യാർഥികളെ അനുമോദിക്കുന്ന ചടങ്ങും&nbsp; സംഘടിപ്പിച്ചു. 21 വിദ്യാർഥികളാണ് അനുമോദനത്തിന് അർഹരായത്. ചെങ്കൽ പഞ്ചായത്തിലെ, ഹയർ സെക്കൻഡറിയിൽ ഉന്നത വിജയം കരസ്ഥമാക്കിയ അപർണ്ണ, മെഡിക്കൽ വിദ്യാഭ്യാസത്തിന് യോഗ്യത നേടി. അപർണയെ അനുമോദിക്കുന്നതിനോടൊപ്പം, തുടർ വിദ്യാഭ്യാസത്തിന് വേണ്ട സഹായം നിംസ് മെഡിസിറ്റി മാനേജിംഗ് ഡയറക്ടർ എം.എസ്.ഫൈസൽ ഖാൻ ഉറപ്പു നൽകി. വാർഷിക- അനുമോദന ചടങ്ങ് വട്ടിയൂർക്കാവ് എംഎൽഎ വി.കെ.പ്രശാന്ത് ഉദ്ഘാടനം ചെയ്തു. കന്യാകുമാരി നൂറിൽ ഇസ്‌ലാം സെന്റർ ഫോർ ഹയർ സ്റ്റഡീസ് യൂണിവേഴ്സിറ്റി,  പ്രൊ ചാൻസിലറും നിംസ് മെഡിസിറ്റി മനേജിങ് ഡയറക്ടറുമായ എം.എസ്.ഫൈസൽ ഖാൻ അധ്യക്ഷത വഹിച്ചു. തിരുവന്തപുരം അലൈഡ് ലേബർ സോഷ്യൽ വെൽഫയർ കോ-ഓപ്പറേറ്റീവ് സൊസൈറ്റിയുമായി നിംസ് കൈ കോർക്കുന്നതിന്റെ ഭാഗമായി വീൽ ചെയർ, ശ്രവണ സഹായി, ഹോസ്പിറ്റൽ ബെഡ് മുതലായവ ലോൺ വ്യവസ്ഥയിൽ പെൻഷൻ പ്ലാൻ അംഗങ്ങൾക്ക് നൽകും. ആ തുകയിൽ പകുതി നിംസ് വഹിക്കും. സൊസൈറ്റി പ്രസിഡൻ്റ് ആർ.എസ്.രാജേഷ് ചടങ്ങിൽ പങ്കെടുത്തു. ഡിസ്ട്രിക്ട് സോഷ്യൽ ജസ്റ്റിസ് ഡയറക്ടർ ദിനേശൻ, ഗോപിനാഥ് മുതുകാട്, നെയ്യാറ്റിൻകര ഡിവൈഎസ്പി എസ്.ഷാജി, കോട്ടുകാൽ പഞ്ചായത്ത് പ്രസിഡന്റ് ചന്ദ്രലേഖ, കല്ലിയൂർ പഞ്ചായത്ത് പ്രസിഡന്റ് സോമശേഖരൻ നായർ, നിംസ് സ്പെക്ട്രം സിഡിആർസി ഡയറക്ടർ ഡോ. എം.കെ.സി.നായർ, നെയ്യാറ്റിൻകര മുനിസിപ്പാലിറ്റി ആരോഗ്യ സ്റ്റാൻഡിങ്ങ് കമ്മിറ്റി ചെയർമാൻ ജോസ് ഫ്രാക്ളിൻ, നിംസ് ഡെന്റൽ&nbsp; കോളജ് പ്രിൻസിപ്പൽ ഡോ. മഞ്ജുഷ, നിംസ് കോളേജ് ഓഫ് നഴ്സിംഗ് പ്രിൻസിപ്പൽ പ്രൊ.ജോസ്ഫിൻ വിനിത, നിംസ് സ്കിൽ ട്രയിനിംഗ് മാനേജർ രാജശ്രീ, നിംസ് ഫിസിക്കൽ മെഡിസിൻ മേധാവി ഡോ.ജിം ഗോപാല കൃഷ്ണൻ, നിംസ് ജറിയാട്രിക് കോഡിനേറ്റർ കെ.ആർ.രേണു, തിരുവനന്തപുരം പോളിയോ ഹോം മുൻ പ്രോജക്ട് കോഡിനേറ്റർ ബോബി തുടങ്ങിയവർ പ്രസംഗിച്ചു.",
      thumb: "assets/img/pensionscheme/282.jpg",
    },
    {
      src: "assets/img/pensionscheme/281.jpg",
      caption: "ഭിന്നശേഷി കുട്ടികൾക്കായി നിംസ് മെഡിസിറ്റിയും നെയ്യാറ്റിൻകര സ്പെഷ്യൽ എംപ്ലോയ്മെന്റ് എക്സ്‌ചേഞ്ചും സംയുക്തമായി സംഘടിപ്പിച്ച ‌നെയ്യാറ്റിൻകര പെൻഷൻ പ്ലാൻ റജിസ്ട്രേഷൻ പൂർത്തിയാക്കി. നൂറുൽ ഇസ്‌ലാം കോളജ് ഓഫ് ഡെന്റൽ സയൻസിൽ നിംസ് മെഡിസിറ്റി ജനറൽ മാനേജർ ഡോ. കെ.എ. സജു അധ്യക്ഷനായ ചടങ്ങ് നെയ്യാറ്റിൻകര അതിരൂപത ബിഷപ്പ് ഡോ. വിൻസന്റ് സാമുവൽ ഭദ്രദീപം കൊളുത്തി ഉദ്ഘാടനം ചെയ്തു. നിംസ് മെഡിസിറ്റി മാനേജിങ് ഡയറക്ടർ എം.എസ്. ഫൈസൽ ഖാൻ നടപ്പിലാക്കിയതാണ് നെയ്യാറ്റിൻകര പെൻഷൻ പ്ലാൻ.റജിസ്ട്രേഷൻ കാർഡ് വിതരണ ഉദ്ഘാടനം നെയ്യാറ്റിൻകര എംഎൽഎ കെ.ആൻസലൻ നിർവഹിച്ചു. കേരള ആരോഗ്യ സർവകലാശാല മുൻ വൈസ് ചാൻസലറും നിംസ് സ്പെക്ട്രം ഡയറക്ടറുമായ ഡോ. എം.കെ.സി. നായർ ക്യാംപിന്റെ ഉദ്ദേശലക്ഷ്യങ്ങൾ വിശദീകരിച്ചു. നെയ്യാറ്റിൻകര മുനിസിപ്പാലിറ്റി ചെയർമാൻ പി.കെ.രാജ്മോഹൻ മുഖ്യപ്രഭാഷണം നടത്തി. മോൺസിങ്ങർ ക്രിസ്തുദാസ്, സ്പെഷ്യൽ എംപ്ലോയ്മെന്റ് എക്സ്ചേഞ്ച് ഓഫിസർ ത്രിഭുവനരാജ്, നിംസ് ജറിയാട്രിക് കോർഡിനേറ്റർ കെ.ആർ. രേണു,പോളിയോ ഹോം മുൻ പ്രോജക്ട് കോർഡിനേറ്റർ ബോബി എന്നിവർ പ്രസംഗിച്ചു.",
      thumb: "assets/img/pensionscheme/281.jpg",
    },
    {
      src: "assets/img/pensionscheme/273.jpg",
      caption: "നെയ്യാറ്റിൻകര പെൻഷൻ പ്ലാൻ ഗുണഭോക്താക്കളെ സ്വയം പ്രാപ്തരാക്കുക എന്നതിൻ്റെ ഭാഗമായി  പെൻഷൻ പ്ലാനിലെ കുട്ടികളും രക്ഷിതാക്കളും 13-4-24ന് നിംസ് അങ്കണത്തിൽ ഒത്തുചേരുകയും  സ്കിൽ ട്രെയിനിങ്ങ്, വിവിധ റിലാക്സേഷൻ ടെക്നിക്കുകൾ തുടങ്ങിയ പരിശീലനങ്ങൾ നൽകിക്കൊണ്ട് പെൻഷൻ പ്ലാൻ ഗുണഭോക്താക്കളുടെ  അവധിക്കാല ക്ലാസുകൾക്ക് തുടക്കമായി.  ആരോഗ്യ സർവകലാശാല ഫോർമർ വൈസ് ചാൻസലറും നിംസ് സ്പെക്ട്രം സി.ഡി.ആർ.സി ഡയറക്ടറുമായ ഡോ.എം.കെ.സി.നായർ ചടങ്ങ് ഉദ്ഘാടനം ചെയ്തു. ഡോ. എം.കെ സി സാറിൻ്റെ നേതൃത്വത്തിൽ നടത്തിയ സ്കിൽ ട്രെയിനിങ്ങ് പ്രോഗ്രാമിൽ ലയോള കോളേജ് എക്സ്റ്റൻഷൻ സർവീസ് സെന്ററിൽ നിന്നും ശ്രീ. ഷാൽ സോമൻ അവർകളും ടീം അംഗങ്ങളും ചേർന്ന് പ്രോഗാം വളരെ ഗംഭീരമാക്കി",
      thumb: "assets/img/pensionscheme/273.jpg",
    },
    {
      src: "assets/img/pensionscheme/274.jpg",
      caption: "നെയ്യാറ്റിൻകര പെൻഷൻ പ്ലാൻ ഗുണഭോക്താക്കളെ സ്വയം പ്രാപ്തരാക്കുക എന്നതിൻ്റെ ഭാഗമായി  പെൻഷൻ പ്ലാനിലെ കുട്ടികളും രക്ഷിതാക്കളും 13-4-24ന് നിംസ് അങ്കണത്തിൽ ഒത്തുചേരുകയും  സ്കിൽ ട്രെയിനിങ്ങ്, വിവിധ റിലാക്സേഷൻ ടെക്നിക്കുകൾ തുടങ്ങിയ പരിശീലനങ്ങൾ നൽകിക്കൊണ്ട് പെൻഷൻ പ്ലാൻ ഗുണഭോക്താക്കളുടെ  അവധിക്കാല ക്ലാസുകൾക്ക് തുടക്കമായി.  ആരോഗ്യ സർവകലാശാല ഫോർമർ വൈസ് ചാൻസലറും നിംസ് സ്പെക്ട്രം സി.ഡി.ആർ.സി ഡയറക്ടറുമായ ഡോ.എം.കെ.സി.നായർ ചടങ്ങ് ഉദ്ഘാടനം ചെയ്തു. ഡോ. എം.കെ സി സാറിൻ്റെ നേതൃത്വത്തിൽ നടത്തിയ സ്കിൽ ട്രെയിനിങ്ങ് പ്രോഗ്രാമിൽ ലയോള കോളേജ് എക്സ്റ്റൻഷൻ സർവീസ് സെന്ററിൽ നിന്നും ശ്രീ. ഷാൽ സോമൻ അവർകളും ടീം അംഗങ്ങളും ചേർന്ന് പ്രോഗാം വളരെ ഗംഭീരമാക്കി",
      thumb: "assets/img/pensionscheme/274.jpg",
    },
    {
      src: "assets/img/pensionscheme/275.jpg",
      caption: "നെയ്യാറ്റിൻകര പെൻഷൻ പ്ലാൻ ഗുണഭോക്താക്കളെ സ്വയം പ്രാപ്തരാക്കുക എന്നതിൻ്റെ ഭാഗമായി  പെൻഷൻ പ്ലാനിലെ കുട്ടികളും രക്ഷിതാക്കളും 13-4-24ന് നിംസ് അങ്കണത്തിൽ ഒത്തുചേരുകയും  സ്കിൽ ട്രെയിനിങ്ങ്, വിവിധ റിലാക്സേഷൻ ടെക്നിക്കുകൾ തുടങ്ങിയ പരിശീലനങ്ങൾ നൽകിക്കൊണ്ട് പെൻഷൻ പ്ലാൻ ഗുണഭോക്താക്കളുടെ  അവധിക്കാല ക്ലാസുകൾക്ക് തുടക്കമായി.  ആരോഗ്യ സർവകലാശാല ഫോർമർ വൈസ് ചാൻസലറും നിംസ് സ്പെക്ട്രം സി.ഡി.ആർ.സി ഡയറക്ടറുമായ ഡോ.എം.കെ.സി.നായർ ചടങ്ങ് ഉദ്ഘാടനം ചെയ്തു. ഡോ. എം.കെ സി സാറിൻ്റെ നേതൃത്വത്തിൽ നടത്തിയ സ്കിൽ ട്രെയിനിങ്ങ് പ്രോഗ്രാമിൽ ലയോള കോളേജ് എക്സ്റ്റൻഷൻ സർവീസ് സെന്ററിൽ നിന്നും ശ്രീ. ഷാൽ സോമൻ അവർകളും ടീം അംഗങ്ങളും ചേർന്ന് പ്രോഗാം വളരെ ഗംഭീരമാക്കി",
      thumb: "assets/img/pensionscheme/275.jpg",
    },
    {
      src: "assets/img/pensionscheme/276.jpg",
      caption: "നെയ്യാറ്റിൻകര പെൻഷൻ പ്ലാൻ ഗുണഭോക്താക്കളെ സ്വയം പ്രാപ്തരാക്കുക എന്നതിൻ്റെ ഭാഗമായി  പെൻഷൻ പ്ലാനിലെ കുട്ടികളും രക്ഷിതാക്കളും 13-4-24ന് നിംസ് അങ്കണത്തിൽ ഒത്തുചേരുകയും  സ്കിൽ ട്രെയിനിങ്ങ്, വിവിധ റിലാക്സേഷൻ ടെക്നിക്കുകൾ തുടങ്ങിയ പരിശീലനങ്ങൾ നൽകിക്കൊണ്ട് പെൻഷൻ പ്ലാൻ ഗുണഭോക്താക്കളുടെ  അവധിക്കാല ക്ലാസുകൾക്ക് തുടക്കമായി.  ആരോഗ്യ സർവകലാശാല ഫോർമർ വൈസ് ചാൻസലറും നിംസ് സ്പെക്ട്രം സി.ഡി.ആർ.സി ഡയറക്ടറുമായ ഡോ.എം.കെ.സി.നായർ ചടങ്ങ് ഉദ്ഘാടനം ചെയ്തു. ഡോ. എം.കെ സി സാറിൻ്റെ നേതൃത്വത്തിൽ നടത്തിയ സ്കിൽ ട്രെയിനിങ്ങ് പ്രോഗ്രാമിൽ ലയോള കോളേജ് എക്സ്റ്റൻഷൻ സർവീസ് സെന്ററിൽ നിന്നും ശ്രീ. ഷാൽ സോമൻ അവർകളും ടീം അംഗങ്ങളും ചേർന്ന് പ്രോഗാം വളരെ ഗംഭീരമാക്കി",
      thumb: "assets/img/pensionscheme/276.jpg",
    },
    {
      src: "assets/img/pensionscheme/277.jpg",
      caption: "നെയ്യാറ്റിൻകര പെൻഷൻ പ്ലാൻ ഗുണഭോക്താക്കളെ സ്വയം പ്രാപ്തരാക്കുക എന്നതിൻ്റെ ഭാഗമായി  പെൻഷൻ പ്ലാനിലെ കുട്ടികളും രക്ഷിതാക്കളും 13-4-24ന് നിംസ് അങ്കണത്തിൽ ഒത്തുചേരുകയും  സ്കിൽ ട്രെയിനിങ്ങ്, വിവിധ റിലാക്സേഷൻ ടെക്നിക്കുകൾ തുടങ്ങിയ പരിശീലനങ്ങൾ നൽകിക്കൊണ്ട് പെൻഷൻ പ്ലാൻ ഗുണഭോക്താക്കളുടെ  അവധിക്കാല ക്ലാസുകൾക്ക് തുടക്കമായി.  ആരോഗ്യ സർവകലാശാല ഫോർമർ വൈസ് ചാൻസലറും നിംസ് സ്പെക്ട്രം സി.ഡി.ആർ.സി ഡയറക്ടറുമായ ഡോ.എം.കെ.സി.നായർ ചടങ്ങ് ഉദ്ഘാടനം ചെയ്തു. ഡോ. എം.കെ സി സാറിൻ്റെ നേതൃത്വത്തിൽ നടത്തിയ സ്കിൽ ട്രെയിനിങ്ങ് പ്രോഗ്രാമിൽ ലയോള കോളേജ് എക്സ്റ്റൻഷൻ സർവീസ് സെന്ററിൽ നിന്നും ശ്രീ. ഷാൽ സോമൻ അവർകളും ടീം അംഗങ്ങളും ചേർന്ന് പ്രോഗാം വളരെ ഗംഭീരമാക്കി",
      thumb: "assets/img/pensionscheme/277.jpg",
    },
    {
      src: "assets/img/pensionscheme/278.jpg",
      caption: "നെയ്യാറ്റിൻകര പെൻഷൻ പ്ലാൻ ഗുണഭോക്താക്കളെ സ്വയം പ്രാപ്തരാക്കുക എന്നതിൻ്റെ ഭാഗമായി  പെൻഷൻ പ്ലാനിലെ കുട്ടികളും രക്ഷിതാക്കളും 13-4-24ന് നിംസ് അങ്കണത്തിൽ ഒത്തുചേരുകയും  സ്കിൽ ട്രെയിനിങ്ങ്, വിവിധ റിലാക്സേഷൻ ടെക്നിക്കുകൾ തുടങ്ങിയ പരിശീലനങ്ങൾ നൽകിക്കൊണ്ട് പെൻഷൻ പ്ലാൻ ഗുണഭോക്താക്കളുടെ  അവധിക്കാല ക്ലാസുകൾക്ക് തുടക്കമായി.  ആരോഗ്യ സർവകലാശാല ഫോർമർ വൈസ് ചാൻസലറും നിംസ് സ്പെക്ട്രം സി.ഡി.ആർ.സി ഡയറക്ടറുമായ ഡോ.എം.കെ.സി.നായർ ചടങ്ങ് ഉദ്ഘാടനം ചെയ്തു. ഡോ. എം.കെ സി സാറിൻ്റെ നേതൃത്വത്തിൽ നടത്തിയ സ്കിൽ ട്രെയിനിങ്ങ് പ്രോഗ്രാമിൽ ലയോള കോളേജ് എക്സ്റ്റൻഷൻ സർവീസ് സെന്ററിൽ നിന്നും ശ്രീ. ഷാൽ സോമൻ അവർകളും ടീം അംഗങ്ങളും ചേർന്ന് പ്രോഗാം വളരെ ഗംഭീരമാക്കി",
      thumb: "assets/img/pensionscheme/278.jpg",
    },
    {
      src: "assets/img/pensionscheme/279.jpg",
      caption: "നെയ്യാറ്റിൻകര പെൻഷൻ പ്ലാൻ ഗുണഭോക്താക്കളെ സ്വയം പ്രാപ്തരാക്കുക എന്നതിൻ്റെ ഭാഗമായി  പെൻഷൻ പ്ലാനിലെ കുട്ടികളും രക്ഷിതാക്കളും 13-4-24ന് നിംസ് അങ്കണത്തിൽ ഒത്തുചേരുകയും  സ്കിൽ ട്രെയിനിങ്ങ്, വിവിധ റിലാക്സേഷൻ ടെക്നിക്കുകൾ തുടങ്ങിയ പരിശീലനങ്ങൾ നൽകിക്കൊണ്ട് പെൻഷൻ പ്ലാൻ ഗുണഭോക്താക്കളുടെ  അവധിക്കാല ക്ലാസുകൾക്ക് തുടക്കമായി.  ആരോഗ്യ സർവകലാശാല ഫോർമർ വൈസ് ചാൻസലറും നിംസ് സ്പെക്ട്രം സി.ഡി.ആർ.സി ഡയറക്ടറുമായ ഡോ.എം.കെ.സി.നായർ ചടങ്ങ് ഉദ്ഘാടനം ചെയ്തു. ഡോ. എം.കെ സി സാറിൻ്റെ നേതൃത്വത്തിൽ നടത്തിയ സ്കിൽ ട്രെയിനിങ്ങ് പ്രോഗ്രാമിൽ ലയോള കോളേജ് എക്സ്റ്റൻഷൻ സർവീസ് സെന്ററിൽ നിന്നും ശ്രീ. ഷാൽ സോമൻ അവർകളും ടീം അംഗങ്ങളും ചേർന്ന് പ്രോഗാം വളരെ ഗംഭീരമാക്കി",
      thumb: "assets/img/pensionscheme/279.jpg",
    },
    {
      src: "assets/img/pensionscheme/280.jpg",
      caption: "നെയ്യാറ്റിൻകര പെൻഷൻ പ്ലാൻ ഗുണഭോക്താക്കളെ സ്വയം പ്രാപ്തരാക്കുക എന്നതിൻ്റെ ഭാഗമായി  പെൻഷൻ പ്ലാനിലെ കുട്ടികളും രക്ഷിതാക്കളും 13-4-24ന് നിംസ് അങ്കണത്തിൽ ഒത്തുചേരുകയും  സ്കിൽ ട്രെയിനിങ്ങ്, വിവിധ റിലാക്സേഷൻ ടെക്നിക്കുകൾ തുടങ്ങിയ പരിശീലനങ്ങൾ നൽകിക്കൊണ്ട് പെൻഷൻ പ്ലാൻ ഗുണഭോക്താക്കളുടെ  അവധിക്കാല ക്ലാസുകൾക്ക് തുടക്കമായി.  ആരോഗ്യ സർവകലാശാല ഫോർമർ വൈസ് ചാൻസലറും നിംസ് സ്പെക്ട്രം സി.ഡി.ആർ.സി ഡയറക്ടറുമായ ഡോ.എം.കെ.സി.നായർ ചടങ്ങ് ഉദ്ഘാടനം ചെയ്തു. ഡോ. എം.കെ സി സാറിൻ്റെ നേതൃത്വത്തിൽ നടത്തിയ സ്കിൽ ട്രെയിനിങ്ങ് പ്രോഗ്രാമിൽ ലയോള കോളേജ് എക്സ്റ്റൻഷൻ സർവീസ് സെന്ററിൽ നിന്നും ശ്രീ. ഷാൽ സോമൻ അവർകളും ടീം അംഗങ്ങളും ചേർന്ന് പ്രോഗാം വളരെ ഗംഭീരമാക്കി",
      thumb: "assets/img/pensionscheme/280.jpg",
    },
    {
      src: "assets/img/pensionscheme/251.jpg",
      caption: "നിംസ് മെഡിസിറ്റി മാനേജിങ്ങ് ഡയറക്ടർ ശ്രീ എം.എസ് ഫൈസൽ ഖാൻസാറിൻ്റെ ചാരിറ്റി പ്രവർത്തനങ്ങളിൽ മുഖ്യധാരയിലുള്ള നെയ്യാറ്റിൻകര പെൻഷൻ പ്ലാൻ ഗുണഭോക്താക്കളായ 14 വയസ്സിനു മുകളിൽ പ്രായമുള്ളകുട്ടികൾക്ക് വേണ്ടി കേന്ദ്ര ഗവൺമെൻ്റ് സ്ഥാപനമായ നാലാഞ്ചിറയിൽ പ്രവർത്തിക്കുന്ന വൊക്കേഷണൽ റീഹാബിലിറ്റേഷൻ സെൻ്ററിലേക്ക് Job oriented തുടർ വിദ്യാഭ്യാസത്തിനുള്ള രജിട്രേഷന് 20 -4-24 ന് തുടക്കമായി.   കേരള സംസ്ഥാന വികലാംഗ ക്ഷേമ കോർപ്പറേഷൻ മാനേജിങ്ങ് ഡയറക്ടർ ശ്രീ മൊയ്ദീൻകുട്ടി ഭദ്ര ദീപം തെളിയിച്ച് ഉദ്ഘാടനം നിർവഹിച്ചു. ശ്രീ.നിരീഷ്, ശ്രീ. ക്രിഷ്ണ പ്രസാദ്, ഇൻസ്ട്രക്ടർ വൊക്കേഷണൽ റിഹാബിലിറ്റേഷൻ സെൻ്റർ, രജിട്രേഷൻ നടപടികൾ  നിർവ്വഹിച്ച് ക്ലാസ് എടുത്തു. ",
      thumb: "assets/img/pensionscheme/251.jpg",
    },
    {
      src: "assets/img/pensionscheme/252.jpg",
      caption: "നിംസ് മെഡിസിറ്റി മാനേജിങ്ങ് ഡയറക്ടർ ശ്രീ എം.എസ് ഫൈസൽ ഖാൻസാറിൻ്റെ ചാരിറ്റി പ്രവർത്തനങ്ങളിൽ മുഖ്യധാരയിലുള്ള നെയ്യാറ്റിൻകര പെൻഷൻ പ്ലാൻ ഗുണഭോക്താക്കളായ 14 വയസ്സിനു മുകളിൽ പ്രായമുള്ളകുട്ടികൾക്ക് വേണ്ടി കേന്ദ്ര ഗവൺമെൻ്റ് സ്ഥാപനമായ നാലാഞ്ചിറയിൽ പ്രവർത്തിക്കുന്ന വൊക്കേഷണൽ റീഹാബിലിറ്റേഷൻ സെൻ്ററിലേക്ക് Job oriented തുടർ വിദ്യാഭ്യാസത്തിനുള്ള രജിട്രേഷന് 20 -4-24 ന് തുടക്കമായി.   കേരള സംസ്ഥാന വികലാംഗ ക്ഷേമ കോർപ്പറേഷൻ മാനേജിങ്ങ് ഡയറക്ടർ ശ്രീ മൊയ്ദീൻകുട്ടി ഭദ്ര ദീപം തെളിയിച്ച് ഉദ്ഘാടനം നിർവഹിച്ചു. ശ്രീ.നിരീഷ്, ശ്രീ. ക്രിഷ്ണ പ്രസാദ്, ഇൻസ്ട്രക്ടർ വൊക്കേഷണൽ റിഹാബിലിറ്റേഷൻ സെൻ്റർ, രജിട്രേഷൻ നടപടികൾ  നിർവ്വഹിച്ച് ക്ലാസ് എടുത്തു. ",
      thumb: "assets/img/pensionscheme/252.jpg",
    },
    {
      src: "assets/img/pensionscheme/253.jpg",
      caption: "നിംസ് മെഡിസിറ്റി മാനേജിങ്ങ് ഡയറക്ടർ ശ്രീ എം.എസ് ഫൈസൽ ഖാൻസാറിൻ്റെ ചാരിറ്റി പ്രവർത്തനങ്ങളിൽ മുഖ്യധാരയിലുള്ള നെയ്യാറ്റിൻകര പെൻഷൻ പ്ലാൻ ഗുണഭോക്താക്കളായ 14 വയസ്സിനു മുകളിൽ പ്രായമുള്ളകുട്ടികൾക്ക് വേണ്ടി കേന്ദ്ര ഗവൺമെൻ്റ് സ്ഥാപനമായ നാലാഞ്ചിറയിൽ പ്രവർത്തിക്കുന്ന വൊക്കേഷണൽ റീഹാബിലിറ്റേഷൻ സെൻ്ററിലേക്ക് Job oriented തുടർ വിദ്യാഭ്യാസത്തിനുള്ള രജിട്രേഷന് 20 -4-24 ന് തുടക്കമായി.   കേരള സംസ്ഥാന വികലാംഗ ക്ഷേമ കോർപ്പറേഷൻ മാനേജിങ്ങ് ഡയറക്ടർ ശ്രീ മൊയ്ദീൻകുട്ടി ഭദ്ര ദീപം തെളിയിച്ച് ഉദ്ഘാടനം നിർവഹിച്ചു. ശ്രീ.നിരീഷ്, ശ്രീ. ക്രിഷ്ണ പ്രസാദ്, ഇൻസ്ട്രക്ടർ വൊക്കേഷണൽ റിഹാബിലിറ്റേഷൻ സെൻ്റർ, രജിട്രേഷൻ നടപടികൾ  നിർവ്വഹിച്ച് ക്ലാസ് എടുത്തു. ",
      thumb: "assets/img/pensionscheme/253.jpg",
    },
    {
      src: "assets/img/pensionscheme/254.jpg",
      caption: "നിംസ് മെഡിസിറ്റി മാനേജിങ്ങ് ഡയറക്ടർ ശ്രീ എം.എസ് ഫൈസൽ ഖാൻസാറിൻ്റെ ചാരിറ്റി പ്രവർത്തനങ്ങളിൽ മുഖ്യധാരയിലുള്ള നെയ്യാറ്റിൻകര പെൻഷൻ പ്ലാൻ ഗുണഭോക്താക്കളായ 14 വയസ്സിനു മുകളിൽ പ്രായമുള്ളകുട്ടികൾക്ക് വേണ്ടി കേന്ദ്ര ഗവൺമെൻ്റ് സ്ഥാപനമായ നാലാഞ്ചിറയിൽ പ്രവർത്തിക്കുന്ന വൊക്കേഷണൽ റീഹാബിലിറ്റേഷൻ സെൻ്ററിലേക്ക് Job oriented തുടർ വിദ്യാഭ്യാസത്തിനുള്ള രജിട്രേഷന് 20 -4-24 ന് തുടക്കമായി.   കേരള സംസ്ഥാന വികലാംഗ ക്ഷേമ കോർപ്പറേഷൻ മാനേജിങ്ങ് ഡയറക്ടർ ശ്രീ മൊയ്ദീൻകുട്ടി ഭദ്ര ദീപം തെളിയിച്ച് ഉദ്ഘാടനം നിർവഹിച്ചു. ശ്രീ.നിരീഷ്, ശ്രീ. ക്രിഷ്ണ പ്രസാദ്, ഇൻസ്ട്രക്ടർ വൊക്കേഷണൽ റിഹാബിലിറ്റേഷൻ സെൻ്റർ, രജിട്രേഷൻ നടപടികൾ  നിർവ്വഹിച്ച് ക്ലാസ് എടുത്തു. ",
      thumb: "assets/img/pensionscheme/254.jpg",
    },
    {
      src: "assets/img/pensionscheme/255.jpg",
      caption: "നിംസ് മെഡിസിറ്റി മാനേജിങ്ങ് ഡയറക്ടർ ശ്രീ എം.എസ് ഫൈസൽ ഖാൻസാറിൻ്റെ ചാരിറ്റി പ്രവർത്തനങ്ങളിൽ മുഖ്യധാരയിലുള്ള നെയ്യാറ്റിൻകര പെൻഷൻ പ്ലാൻ ഗുണഭോക്താക്കളായ 14 വയസ്സിനു മുകളിൽ പ്രായമുള്ളകുട്ടികൾക്ക് വേണ്ടി കേന്ദ്ര ഗവൺമെൻ്റ് സ്ഥാപനമായ നാലാഞ്ചിറയിൽ പ്രവർത്തിക്കുന്ന വൊക്കേഷണൽ റീഹാബിലിറ്റേഷൻ സെൻ്ററിലേക്ക് Job oriented തുടർ വിദ്യാഭ്യാസത്തിനുള്ള രജിട്രേഷന് 20 -4-24 ന് തുടക്കമായി.   കേരള സംസ്ഥാന വികലാംഗ ക്ഷേമ കോർപ്പറേഷൻ മാനേജിങ്ങ് ഡയറക്ടർ ശ്രീ മൊയ്ദീൻകുട്ടി ഭദ്ര ദീപം തെളിയിച്ച് ഉദ്ഘാടനം നിർവഹിച്ചു. ശ്രീ.നിരീഷ്, ശ്രീ. ക്രിഷ്ണ പ്രസാദ്, ഇൻസ്ട്രക്ടർ വൊക്കേഷണൽ റിഹാബിലിറ്റേഷൻ സെൻ്റർ, രജിട്രേഷൻ നടപടികൾ  നിർവ്വഹിച്ച് ക്ലാസ് എടുത്തു. ",
      thumb: "assets/img/pensionscheme/255.jpg",
    },
    {
      src: "assets/img/pensionscheme/256.jpg",
      caption: "നിംസ് മെഡിസിറ്റി മാനേജിങ്ങ് ഡയറക്ടർ ശ്രീ എം.എസ് ഫൈസൽ ഖാൻസാറിൻ്റെ ചാരിറ്റി പ്രവർത്തനങ്ങളിൽ മുഖ്യധാരയിലുള്ള നെയ്യാറ്റിൻകര പെൻഷൻ പ്ലാൻ ഗുണഭോക്താക്കളായ 14 വയസ്സിനു മുകളിൽ പ്രായമുള്ളകുട്ടികൾക്ക് വേണ്ടി കേന്ദ്ര ഗവൺമെൻ്റ് സ്ഥാപനമായ നാലാഞ്ചിറയിൽ പ്രവർത്തിക്കുന്ന വൊക്കേഷണൽ റീഹാബിലിറ്റേഷൻ സെൻ്ററിലേക്ക് Job oriented തുടർ വിദ്യാഭ്യാസത്തിനുള്ള രജിട്രേഷന് 20 -4-24 ന് തുടക്കമായി.   കേരള സംസ്ഥാന വികലാംഗ ക്ഷേമ കോർപ്പറേഷൻ മാനേജിങ്ങ് ഡയറക്ടർ ശ്രീ മൊയ്ദീൻകുട്ടി ഭദ്ര ദീപം തെളിയിച്ച് ഉദ്ഘാടനം നിർവഹിച്ചു. ശ്രീ.നിരീഷ്, ശ്രീ. ക്രിഷ്ണ പ്രസാദ്, ഇൻസ്ട്രക്ടർ വൊക്കേഷണൽ റിഹാബിലിറ്റേഷൻ സെൻ്റർ, രജിട്രേഷൻ നടപടികൾ  നിർവ്വഹിച്ച് ക്ലാസ് എടുത്തു. ",
      thumb: "assets/img/pensionscheme/256.jpg",
    },
    {
      src: "assets/img/pensionscheme/257.jpg",
      caption: "നിംസ് മെഡിസിറ്റി മാനേജിങ്ങ് ഡയറക്ടർ ശ്രീ എം.എസ് ഫൈസൽ ഖാൻസാറിൻ്റെ ചാരിറ്റി പ്രവർത്തനങ്ങളിൽ മുഖ്യധാരയിലുള്ള നെയ്യാറ്റിൻകര പെൻഷൻ പ്ലാൻ ഗുണഭോക്താക്കളായ 14 വയസ്സിനു മുകളിൽ പ്രായമുള്ളകുട്ടികൾക്ക് വേണ്ടി കേന്ദ്ര ഗവൺമെൻ്റ് സ്ഥാപനമായ നാലാഞ്ചിറയിൽ പ്രവർത്തിക്കുന്ന വൊക്കേഷണൽ റീഹാബിലിറ്റേഷൻ സെൻ്ററിലേക്ക് Job oriented തുടർ വിദ്യാഭ്യാസത്തിനുള്ള രജിട്രേഷന് 20 -4-24 ന് തുടക്കമായി.   കേരള സംസ്ഥാന വികലാംഗ ക്ഷേമ കോർപ്പറേഷൻ മാനേജിങ്ങ് ഡയറക്ടർ ശ്രീ മൊയ്ദീൻകുട്ടി ഭദ്ര ദീപം തെളിയിച്ച് ഉദ്ഘാടനം നിർവഹിച്ചു. ശ്രീ.നിരീഷ്, ശ്രീ. ക്രിഷ്ണ പ്രസാദ്, ഇൻസ്ട്രക്ടർ വൊക്കേഷണൽ റിഹാബിലിറ്റേഷൻ സെൻ്റർ, രജിട്രേഷൻ നടപടികൾ  നിർവ്വഹിച്ച് ക്ലാസ് എടുത്തു. ",
      thumb: "assets/img/pensionscheme/257.jpg",
    },
    {
      src: "assets/img/pensionscheme/258.jpg",
      caption: "നിംസ് മെഡിസിറ്റി മാനേജിങ്ങ് ഡയറക്ടർ ശ്രീ എം.എസ് ഫൈസൽ ഖാൻസാറിൻ്റെ ചാരിറ്റി പ്രവർത്തനങ്ങളിൽ മുഖ്യധാരയിലുള്ള നെയ്യാറ്റിൻകര പെൻഷൻ പ്ലാൻ ഗുണഭോക്താക്കളായ 14 വയസ്സിനു മുകളിൽ പ്രായമുള്ളകുട്ടികൾക്ക് വേണ്ടി കേന്ദ്ര ഗവൺമെൻ്റ് സ്ഥാപനമായ നാലാഞ്ചിറയിൽ പ്രവർത്തിക്കുന്ന വൊക്കേഷണൽ റീഹാബിലിറ്റേഷൻ സെൻ്ററിലേക്ക് Job oriented തുടർ വിദ്യാഭ്യാസത്തിനുള്ള രജിട്രേഷന് 20 -4-24 ന് തുടക്കമായി.   കേരള സംസ്ഥാന വികലാംഗ ക്ഷേമ കോർപ്പറേഷൻ മാനേജിങ്ങ് ഡയറക്ടർ ശ്രീ മൊയ്ദീൻകുട്ടി ഭദ്ര ദീപം തെളിയിച്ച് ഉദ്ഘാടനം നിർവഹിച്ചു. ശ്രീ.നിരീഷ്, ശ്രീ. ക്രിഷ്ണ പ്രസാദ്, ഇൻസ്ട്രക്ടർ വൊക്കേഷണൽ റിഹാബിലിറ്റേഷൻ സെൻ്റർ, രജിട്രേഷൻ നടപടികൾ  നിർവ്വഹിച്ച് ക്ലാസ് എടുത്തു. ",
      thumb: "assets/img/pensionscheme/258.jpg",
    },
    {
      src: "assets/img/pensionscheme/259.jpg",
      caption: "നിംസ് മെഡിസിറ്റി മാനേജിങ്ങ് ഡയറക്ടർ ശ്രീ എം.എസ് ഫൈസൽ ഖാൻസാറിൻ്റെ ചാരിറ്റി പ്രവർത്തനങ്ങളിൽ മുഖ്യധാരയിലുള്ള നെയ്യാറ്റിൻകര പെൻഷൻ പ്ലാൻ ഗുണഭോക്താക്കളായ 14 വയസ്സിനു മുകളിൽ പ്രായമുള്ളകുട്ടികൾക്ക് വേണ്ടി കേന്ദ്ര ഗവൺമെൻ്റ് സ്ഥാപനമായ നാലാഞ്ചിറയിൽ പ്രവർത്തിക്കുന്ന വൊക്കേഷണൽ റീഹാബിലിറ്റേഷൻ സെൻ്ററിലേക്ക് Job oriented തുടർ വിദ്യാഭ്യാസത്തിനുള്ള രജിട്രേഷന് 20 -4-24 ന് തുടക്കമായി.   കേരള സംസ്ഥാന വികലാംഗ ക്ഷേമ കോർപ്പറേഷൻ മാനേജിങ്ങ് ഡയറക്ടർ ശ്രീ മൊയ്ദീൻകുട്ടി ഭദ്ര ദീപം തെളിയിച്ച് ഉദ്ഘാടനം നിർവഹിച്ചു. ശ്രീ.നിരീഷ്, ശ്രീ. ക്രിഷ്ണ പ്രസാദ്, ഇൻസ്ട്രക്ടർ വൊക്കേഷണൽ റിഹാബിലിറ്റേഷൻ സെൻ്റർ, രജിട്രേഷൻ നടപടികൾ  നിർവ്വഹിച്ച് ക്ലാസ് എടുത്തു. ",
      thumb: "assets/img/pensionscheme/259.jpg",
    },
    {
      src: "assets/img/pensionscheme/260.jpg",
      caption: "നിംസ് മെഡിസിറ്റി മാനേജിങ്ങ് ഡയറക്ടർ ശ്രീ എം.എസ് ഫൈസൽ ഖാൻസാറിൻ്റെ ചാരിറ്റി പ്രവർത്തനങ്ങളിൽ മുഖ്യധാരയിലുള്ള നെയ്യാറ്റിൻകര പെൻഷൻ പ്ലാൻ ഗുണഭോക്താക്കളായ 14 വയസ്സിനു മുകളിൽ പ്രായമുള്ളകുട്ടികൾക്ക് വേണ്ടി കേന്ദ്ര ഗവൺമെൻ്റ് സ്ഥാപനമായ നാലാഞ്ചിറയിൽ പ്രവർത്തിക്കുന്ന വൊക്കേഷണൽ റീഹാബിലിറ്റേഷൻ സെൻ്ററിലേക്ക് Job oriented തുടർ വിദ്യാഭ്യാസത്തിനുള്ള രജിട്രേഷന് 20 -4-24 ന് തുടക്കമായി.   കേരള സംസ്ഥാന വികലാംഗ ക്ഷേമ കോർപ്പറേഷൻ മാനേജിങ്ങ് ഡയറക്ടർ ശ്രീ മൊയ്ദീൻകുട്ടി ഭദ്ര ദീപം തെളിയിച്ച് ഉദ്ഘാടനം നിർവഹിച്ചു. ശ്രീ.നിരീഷ്, ശ്രീ. ക്രിഷ്ണ പ്രസാദ്, ഇൻസ്ട്രക്ടർ വൊക്കേഷണൽ റിഹാബിലിറ്റേഷൻ സെൻ്റർ, രജിട്രേഷൻ നടപടികൾ  നിർവ്വഹിച്ച് ക്ലാസ് എടുത്തു. ",
      thumb: "assets/img/pensionscheme/260.jpg",
    },
    {
      src: "assets/img/pensionscheme/261.jpg",
      caption: "നിംസ് മെഡിസിറ്റി മാനേജിങ്ങ് ഡയറക്ടർ ശ്രീ എം.എസ് ഫൈസൽ ഖാൻസാറിൻ്റെ ചാരിറ്റി പ്രവർത്തനങ്ങളിൽ മുഖ്യധാരയിലുള്ള നെയ്യാറ്റിൻകര പെൻഷൻ പ്ലാൻ ഗുണഭോക്താക്കളായ 14 വയസ്സിനു മുകളിൽ പ്രായമുള്ളകുട്ടികൾക്ക് വേണ്ടി കേന്ദ്ര ഗവൺമെൻ്റ് സ്ഥാപനമായ നാലാഞ്ചിറയിൽ പ്രവർത്തിക്കുന്ന വൊക്കേഷണൽ റീഹാബിലിറ്റേഷൻ സെൻ്ററിലേക്ക് Job oriented തുടർ വിദ്യാഭ്യാസത്തിനുള്ള രജിട്രേഷന് 20 -4-24 ന് തുടക്കമായി.   കേരള സംസ്ഥാന വികലാംഗ ക്ഷേമ കോർപ്പറേഷൻ മാനേജിങ്ങ് ഡയറക്ടർ ശ്രീ മൊയ്ദീൻകുട്ടി ഭദ്ര ദീപം തെളിയിച്ച് ഉദ്ഘാടനം നിർവഹിച്ചു. ശ്രീ.നിരീഷ്, ശ്രീ. ക്രിഷ്ണ പ്രസാദ്, ഇൻസ്ട്രക്ടർ വൊക്കേഷണൽ റിഹാബിലിറ്റേഷൻ സെൻ്റർ, രജിട്രേഷൻ നടപടികൾ  നിർവ്വഹിച്ച് ക്ലാസ് എടുത്തു. ",
      thumb: "assets/img/pensionscheme/261.jpg",
    },
    {
      src: "assets/img/pensionscheme/262.jpg",
      caption: "നിംസ് മെഡിസിറ്റി മാനേജിങ്ങ് ഡയറക്ടർ ശ്രീ എം.എസ് ഫൈസൽ ഖാൻസാറിൻ്റെ ചാരിറ്റി പ്രവർത്തനങ്ങളിൽ മുഖ്യധാരയിലുള്ള നെയ്യാറ്റിൻകര പെൻഷൻ പ്ലാൻ ഗുണഭോക്താക്കളായ 14 വയസ്സിനു മുകളിൽ പ്രായമുള്ളകുട്ടികൾക്ക് വേണ്ടി കേന്ദ്ര ഗവൺമെൻ്റ് സ്ഥാപനമായ നാലാഞ്ചിറയിൽ പ്രവർത്തിക്കുന്ന വൊക്കേഷണൽ റീഹാബിലിറ്റേഷൻ സെൻ്ററിലേക്ക് Job oriented തുടർ വിദ്യാഭ്യാസത്തിനുള്ള രജിട്രേഷന് 20 -4-24 ന് തുടക്കമായി.   കേരള സംസ്ഥാന വികലാംഗ ക്ഷേമ കോർപ്പറേഷൻ മാനേജിങ്ങ് ഡയറക്ടർ ശ്രീ മൊയ്ദീൻകുട്ടി ഭദ്ര ദീപം തെളിയിച്ച് ഉദ്ഘാടനം നിർവഹിച്ചു. ശ്രീ.നിരീഷ്, ശ്രീ. ക്രിഷ്ണ പ്രസാദ്, ഇൻസ്ട്രക്ടർ വൊക്കേഷണൽ റിഹാബിലിറ്റേഷൻ സെൻ്റർ, രജിട്രേഷൻ നടപടികൾ  നിർവ്വഹിച്ച് ക്ലാസ് എടുത്തു. ",
      thumb: "assets/img/pensionscheme/262.jpg",
    },
    {
      src: "assets/img/pensionscheme/263.jpg",
      caption: "നിംസ് മെഡിസിറ്റി മാനേജിങ്ങ് ഡയറക്ടർ ശ്രീ എം.എസ് ഫൈസൽ ഖാൻസാറിൻ്റെ ചാരിറ്റി പ്രവർത്തനങ്ങളിൽ മുഖ്യധാരയിലുള്ള നെയ്യാറ്റിൻകര പെൻഷൻ പ്ലാൻ ഗുണഭോക്താക്കളായ 14 വയസ്സിനു മുകളിൽ പ്രായമുള്ളകുട്ടികൾക്ക് വേണ്ടി കേന്ദ്ര ഗവൺമെൻ്റ് സ്ഥാപനമായ നാലാഞ്ചിറയിൽ പ്രവർത്തിക്കുന്ന വൊക്കേഷണൽ റീഹാബിലിറ്റേഷൻ സെൻ്ററിലേക്ക് Job oriented തുടർ വിദ്യാഭ്യാസത്തിനുള്ള രജിട്രേഷന് 20 -4-24 ന് തുടക്കമായി.   കേരള സംസ്ഥാന വികലാംഗ ക്ഷേമ കോർപ്പറേഷൻ മാനേജിങ്ങ് ഡയറക്ടർ ശ്രീ മൊയ്ദീൻകുട്ടി ഭദ്ര ദീപം തെളിയിച്ച് ഉദ്ഘാടനം നിർവഹിച്ചു. ശ്രീ.നിരീഷ്, ശ്രീ. ക്രിഷ്ണ പ്രസാദ്, ഇൻസ്ട്രക്ടർ വൊക്കേഷണൽ റിഹാബിലിറ്റേഷൻ സെൻ്റർ, രജിട്രേഷൻ നടപടികൾ  നിർവ്വഹിച്ച് ക്ലാസ് എടുത്തു. ",
      thumb: "assets/img/pensionscheme/263.jpg",
    },
    {
      src: "assets/img/pensionscheme/264.jpg",
      caption: "നിംസ് മെഡിസിറ്റി മാനേജിങ്ങ് ഡയറക്ടർ ശ്രീ എം.എസ് ഫൈസൽ ഖാൻസാറിൻ്റെ ചാരിറ്റി പ്രവർത്തനങ്ങളിൽ മുഖ്യധാരയിലുള്ള നെയ്യാറ്റിൻകര പെൻഷൻ പ്ലാൻ ഗുണഭോക്താക്കളായ 14 വയസ്സിനു മുകളിൽ പ്രായമുള്ളകുട്ടികൾക്ക് വേണ്ടി കേന്ദ്ര ഗവൺമെൻ്റ് സ്ഥാപനമായ നാലാഞ്ചിറയിൽ പ്രവർത്തിക്കുന്ന വൊക്കേഷണൽ റീഹാബിലിറ്റേഷൻ സെൻ്ററിലേക്ക് Job oriented തുടർ വിദ്യാഭ്യാസത്തിനുള്ള രജിട്രേഷന് 20 -4-24 ന് തുടക്കമായി.   കേരള സംസ്ഥാന വികലാംഗ ക്ഷേമ കോർപ്പറേഷൻ മാനേജിങ്ങ് ഡയറക്ടർ ശ്രീ മൊയ്ദീൻകുട്ടി ഭദ്ര ദീപം തെളിയിച്ച് ഉദ്ഘാടനം നിർവഹിച്ചു. ശ്രീ.നിരീഷ്, ശ്രീ. ക്രിഷ്ണ പ്രസാദ്, ഇൻസ്ട്രക്ടർ വൊക്കേഷണൽ റിഹാബിലിറ്റേഷൻ സെൻ്റർ, രജിട്രേഷൻ നടപടികൾ  നിർവ്വഹിച്ച് ക്ലാസ് എടുത്തു. ",
      thumb: "assets/img/pensionscheme/264.jpg",
    },
    {
      src: "assets/img/pensionscheme/265.jpg",
      caption: "നിംസ് മെഡിസിറ്റി മാനേജിങ്ങ് ഡയറക്ടർ ശ്രീ എം.എസ് ഫൈസൽ ഖാൻസാറിൻ്റെ ചാരിറ്റി പ്രവർത്തനങ്ങളിൽ മുഖ്യധാരയിലുള്ള നെയ്യാറ്റിൻകര പെൻഷൻ പ്ലാൻ ഗുണഭോക്താക്കളായ 14 വയസ്സിനു മുകളിൽ പ്രായമുള്ളകുട്ടികൾക്ക് വേണ്ടി കേന്ദ്ര ഗവൺമെൻ്റ് സ്ഥാപനമായ നാലാഞ്ചിറയിൽ പ്രവർത്തിക്കുന്ന വൊക്കേഷണൽ റീഹാബിലിറ്റേഷൻ സെൻ്ററിലേക്ക് Job oriented തുടർ വിദ്യാഭ്യാസത്തിനുള്ള രജിട്രേഷന് 20 -4-24 ന് തുടക്കമായി.   കേരള സംസ്ഥാന വികലാംഗ ക്ഷേമ കോർപ്പറേഷൻ മാനേജിങ്ങ് ഡയറക്ടർ ശ്രീ മൊയ്ദീൻകുട്ടി ഭദ്ര ദീപം തെളിയിച്ച് ഉദ്ഘാടനം നിർവഹിച്ചു. ശ്രീ.നിരീഷ്, ശ്രീ. ക്രിഷ്ണ പ്രസാദ്, ഇൻസ്ട്രക്ടർ വൊക്കേഷണൽ റിഹാബിലിറ്റേഷൻ സെൻ്റർ, രജിട്രേഷൻ നടപടികൾ  നിർവ്വഹിച്ച് ക്ലാസ് എടുത്തു. ",
      thumb: "assets/img/pensionscheme/265.jpg",
    },
    {
      src: "assets/img/pensionscheme/266.jpg",
      caption: "നിംസ് മെഡിസിറ്റി മാനേജിങ്ങ് ഡയറക്ടർ ശ്രീ എം.എസ് ഫൈസൽ ഖാൻസാറിൻ്റെ ചാരിറ്റി പ്രവർത്തനങ്ങളിൽ മുഖ്യധാരയിലുള്ള നെയ്യാറ്റിൻകര പെൻഷൻ പ്ലാൻ ഗുണഭോക്താക്കളായ 14 വയസ്സിനു മുകളിൽ പ്രായമുള്ളകുട്ടികൾക്ക് വേണ്ടി കേന്ദ്ര ഗവൺമെൻ്റ് സ്ഥാപനമായ നാലാഞ്ചിറയിൽ പ്രവർത്തിക്കുന്ന വൊക്കേഷണൽ റീഹാബിലിറ്റേഷൻ സെൻ്ററിലേക്ക് Job oriented തുടർ വിദ്യാഭ്യാസത്തിനുള്ള രജിട്രേഷന് 20 -4-24 ന് തുടക്കമായി.   കേരള സംസ്ഥാന വികലാംഗ ക്ഷേമ കോർപ്പറേഷൻ മാനേജിങ്ങ് ഡയറക്ടർ ശ്രീ മൊയ്ദീൻകുട്ടി ഭദ്ര ദീപം തെളിയിച്ച് ഉദ്ഘാടനം നിർവഹിച്ചു. ശ്രീ.നിരീഷ്, ശ്രീ. ക്രിഷ്ണ പ്രസാദ്, ഇൻസ്ട്രക്ടർ വൊക്കേഷണൽ റിഹാബിലിറ്റേഷൻ സെൻ്റർ, രജിട്രേഷൻ നടപടികൾ  നിർവ്വഹിച്ച് ക്ലാസ് എടുത്തു. ",
      thumb: "assets/img/pensionscheme/266.jpg",
    },
    {
      src: "assets/img/pensionscheme/267.jpg",
      caption: "നിംസ് മെഡിസിറ്റി മാനേജിങ്ങ് ഡയറക്ടർ ശ്രീ എം.എസ് ഫൈസൽ ഖാൻസാറിൻ്റെ ചാരിറ്റി പ്രവർത്തനങ്ങളിൽ മുഖ്യധാരയിലുള്ള നെയ്യാറ്റിൻകര പെൻഷൻ പ്ലാൻ ഗുണഭോക്താക്കളായ 14 വയസ്സിനു മുകളിൽ പ്രായമുള്ളകുട്ടികൾക്ക് വേണ്ടി കേന്ദ്ര ഗവൺമെൻ്റ് സ്ഥാപനമായ നാലാഞ്ചിറയിൽ പ്രവർത്തിക്കുന്ന വൊക്കേഷണൽ റീഹാബിലിറ്റേഷൻ സെൻ്ററിലേക്ക് Job oriented തുടർ വിദ്യാഭ്യാസത്തിനുള്ള രജിട്രേഷന് 20 -4-24 ന് തുടക്കമായി.   കേരള സംസ്ഥാന വികലാംഗ ക്ഷേമ കോർപ്പറേഷൻ മാനേജിങ്ങ് ഡയറക്ടർ ശ്രീ മൊയ്ദീൻകുട്ടി ഭദ്ര ദീപം തെളിയിച്ച് ഉദ്ഘാടനം നിർവഹിച്ചു. ശ്രീ.നിരീഷ്, ശ്രീ. ക്രിഷ്ണ പ്രസാദ്, ഇൻസ്ട്രക്ടർ വൊക്കേഷണൽ റിഹാബിലിറ്റേഷൻ സെൻ്റർ, രജിട്രേഷൻ നടപടികൾ  നിർവ്വഹിച്ച് ക്ലാസ് എടുത്തു. ",
      thumb: "assets/img/pensionscheme/267.jpg",
    },
    {
      src: "assets/img/pensionscheme/268.jpg",
      caption: "നിംസ് മെഡിസിറ്റി മാനേജിങ്ങ് ഡയറക്ടർ ശ്രീ എം.എസ് ഫൈസൽ ഖാൻസാറിൻ്റെ ചാരിറ്റി പ്രവർത്തനങ്ങളിൽ മുഖ്യധാരയിലുള്ള നെയ്യാറ്റിൻകര പെൻഷൻ പ്ലാൻ ഗുണഭോക്താക്കളായ 14 വയസ്സിനു മുകളിൽ പ്രായമുള്ളകുട്ടികൾക്ക് വേണ്ടി കേന്ദ്ര ഗവൺമെൻ്റ് സ്ഥാപനമായ നാലാഞ്ചിറയിൽ പ്രവർത്തിക്കുന്ന വൊക്കേഷണൽ റീഹാബിലിറ്റേഷൻ സെൻ്ററിലേക്ക് Job oriented തുടർ വിദ്യാഭ്യാസത്തിനുള്ള രജിട്രേഷന് 20 -4-24 ന് തുടക്കമായി.   കേരള സംസ്ഥാന വികലാംഗ ക്ഷേമ കോർപ്പറേഷൻ മാനേജിങ്ങ് ഡയറക്ടർ ശ്രീ മൊയ്ദീൻകുട്ടി ഭദ്ര ദീപം തെളിയിച്ച് ഉദ്ഘാടനം നിർവഹിച്ചു. ശ്രീ.നിരീഷ്, ശ്രീ. ക്രിഷ്ണ പ്രസാദ്, ഇൻസ്ട്രക്ടർ വൊക്കേഷണൽ റിഹാബിലിറ്റേഷൻ സെൻ്റർ, രജിട്രേഷൻ നടപടികൾ  നിർവ്വഹിച്ച് ക്ലാസ് എടുത്തു. ",
      thumb: "assets/img/pensionscheme/268.jpg",
    },
    {
      src: "assets/img/pensionscheme/269.jpg",
      caption: "നിംസ് മെഡിസിറ്റി മാനേജിങ്ങ് ഡയറക്ടർ ശ്രീ എം.എസ് ഫൈസൽ ഖാൻസാറിൻ്റെ ചാരിറ്റി പ്രവർത്തനങ്ങളിൽ മുഖ്യധാരയിലുള്ള നെയ്യാറ്റിൻകര പെൻഷൻ പ്ലാൻ ഗുണഭോക്താക്കളായ 14 വയസ്സിനു മുകളിൽ പ്രായമുള്ളകുട്ടികൾക്ക് വേണ്ടി കേന്ദ്ര ഗവൺമെൻ്റ് സ്ഥാപനമായ നാലാഞ്ചിറയിൽ പ്രവർത്തിക്കുന്ന വൊക്കേഷണൽ റീഹാബിലിറ്റേഷൻ സെൻ്ററിലേക്ക് Job oriented തുടർ വിദ്യാഭ്യാസത്തിനുള്ള രജിട്രേഷന് 20 -4-24 ന് തുടക്കമായി.   കേരള സംസ്ഥാന വികലാംഗ ക്ഷേമ കോർപ്പറേഷൻ മാനേജിങ്ങ് ഡയറക്ടർ ശ്രീ മൊയ്ദീൻകുട്ടി ഭദ്ര ദീപം തെളിയിച്ച് ഉദ്ഘാടനം നിർവഹിച്ചു. ശ്രീ.നിരീഷ്, ശ്രീ. ക്രിഷ്ണ പ്രസാദ്, ഇൻസ്ട്രക്ടർ വൊക്കേഷണൽ റിഹാബിലിറ്റേഷൻ സെൻ്റർ, രജിട്രേഷൻ നടപടികൾ  നിർവ്വഹിച്ച് ക്ലാസ് എടുത്തു. ",
      thumb: "assets/img/pensionscheme/269.jpg",
    },
    {
      src: "assets/img/pensionscheme/270.jpg",
      caption: "നിംസ് മെഡിസിറ്റി മാനേജിങ്ങ് ഡയറക്ടർ ശ്രീ എം.എസ് ഫൈസൽ ഖാൻസാറിൻ്റെ ചാരിറ്റി പ്രവർത്തനങ്ങളിൽ മുഖ്യധാരയിലുള്ള നെയ്യാറ്റിൻകര പെൻഷൻ പ്ലാൻ ഗുണഭോക്താക്കളായ 14 വയസ്സിനു മുകളിൽ പ്രായമുള്ളകുട്ടികൾക്ക് വേണ്ടി കേന്ദ്ര ഗവൺമെൻ്റ് സ്ഥാപനമായ നാലാഞ്ചിറയിൽ പ്രവർത്തിക്കുന്ന വൊക്കേഷണൽ റീഹാബിലിറ്റേഷൻ സെൻ്ററിലേക്ക് Job oriented തുടർ വിദ്യാഭ്യാസത്തിനുള്ള രജിട്രേഷന് 20 -4-24 ന് തുടക്കമായി.   കേരള സംസ്ഥാന വികലാംഗ ക്ഷേമ കോർപ്പറേഷൻ മാനേജിങ്ങ് ഡയറക്ടർ ശ്രീ മൊയ്ദീൻകുട്ടി ഭദ്ര ദീപം തെളിയിച്ച് ഉദ്ഘാടനം നിർവഹിച്ചു. ശ്രീ.നിരീഷ്, ശ്രീ. ക്രിഷ്ണ പ്രസാദ്, ഇൻസ്ട്രക്ടർ വൊക്കേഷണൽ റിഹാബിലിറ്റേഷൻ സെൻ്റർ, രജിട്രേഷൻ നടപടികൾ  നിർവ്വഹിച്ച് ക്ലാസ് എടുത്തു. ",
      thumb: "assets/img/pensionscheme/270.jpg",
    },
    {
      src: "assets/img/pensionscheme/271.jpg",
      caption: "നിംസ് മെഡിസിറ്റി മാനേജിങ്ങ് ഡയറക്ടർ ശ്രീ എം.എസ് ഫൈസൽ ഖാൻസാറിൻ്റെ ചാരിറ്റി പ്രവർത്തനങ്ങളിൽ മുഖ്യധാരയിലുള്ള നെയ്യാറ്റിൻകര പെൻഷൻ പ്ലാൻ ഗുണഭോക്താക്കളായ 14 വയസ്സിനു മുകളിൽ പ്രായമുള്ളകുട്ടികൾക്ക് വേണ്ടി കേന്ദ്ര ഗവൺമെൻ്റ് സ്ഥാപനമായ നാലാഞ്ചിറയിൽ പ്രവർത്തിക്കുന്ന വൊക്കേഷണൽ റീഹാബിലിറ്റേഷൻ സെൻ്ററിലേക്ക് Job oriented തുടർ വിദ്യാഭ്യാസത്തിനുള്ള രജിട്രേഷന് 20 -4-24 ന് തുടക്കമായി.   കേരള സംസ്ഥാന വികലാംഗ ക്ഷേമ കോർപ്പറേഷൻ മാനേജിങ്ങ് ഡയറക്ടർ ശ്രീ മൊയ്ദീൻകുട്ടി ഭദ്ര ദീപം തെളിയിച്ച് ഉദ്ഘാടനം നിർവഹിച്ചു. ശ്രീ.നിരീഷ്, ശ്രീ. ക്രിഷ്ണ പ്രസാദ്, ഇൻസ്ട്രക്ടർ വൊക്കേഷണൽ റിഹാബിലിറ്റേഷൻ സെൻ്റർ, രജിട്രേഷൻ നടപടികൾ  നിർവ്വഹിച്ച് ക്ലാസ് എടുത്തു. ",
      thumb: "assets/img/pensionscheme/271.jpg",
    },
    {
      src: "assets/img/pensionscheme/272.jpg",
      caption: "നിംസ് മെഡിസിറ്റി മാനേജിങ്ങ് ഡയറക്ടർ ശ്രീ എം.എസ് ഫൈസൽ ഖാൻസാറിൻ്റെ ചാരിറ്റി പ്രവർത്തനങ്ങളിൽ മുഖ്യധാരയിലുള്ള നെയ്യാറ്റിൻകര പെൻഷൻ പ്ലാൻ ഗുണഭോക്താക്കളായ 14 വയസ്സിനു മുകളിൽ പ്രായമുള്ളകുട്ടികൾക്ക് വേണ്ടി കേന്ദ്ര ഗവൺമെൻ്റ് സ്ഥാപനമായ നാലാഞ്ചിറയിൽ പ്രവർത്തിക്കുന്ന വൊക്കേഷണൽ റീഹാബിലിറ്റേഷൻ സെൻ്ററിലേക്ക് Job oriented തുടർ വിദ്യാഭ്യാസത്തിനുള്ള രജിട്രേഷന് 20 -4-24 ന് തുടക്കമായി.   കേരള സംസ്ഥാന വികലാംഗ ക്ഷേമ കോർപ്പറേഷൻ മാനേജിങ്ങ് ഡയറക്ടർ ശ്രീ മൊയ്ദീൻകുട്ടി ഭദ്ര ദീപം തെളിയിച്ച് ഉദ്ഘാടനം നിർവഹിച്ചു. ശ്രീ.നിരീഷ്, ശ്രീ. ക്രിഷ്ണ പ്രസാദ്, ഇൻസ്ട്രക്ടർ വൊക്കേഷണൽ റിഹാബിലിറ്റേഷൻ സെൻ്റർ, രജിട്രേഷൻ നടപടികൾ  നിർവ്വഹിച്ച് ക്ലാസ് എടുത്തു. ",
      thumb: "assets/img/pensionscheme/272.jpg",
    },
    {
      src: "assets/img/pensionscheme/203.jpg",
      caption: "",
      thumb: "assets/img/pensionscheme/203.jpg",
    },
    {
      src: "assets/img/pensionscheme/204.jpg",
      caption: "",
      thumb: "assets/img/pensionscheme/204.jpg",
    },
    {
      src: "assets/img/pensionscheme/205.jpg",
      caption: "",
      thumb: "assets/img/pensionscheme/205.jpg",
    },
    {
      src: "assets/img/pensionscheme/206.jpg",
      caption: "",
      thumb: "assets/img/pensionscheme/206.jpg",
    },
    {
      src: "assets/img/pensionscheme/207.jpg",
      caption: "",
      thumb: "assets/img/pensionscheme/207.jpg",
    },
    {
      src: "assets/img/pensionscheme/208.jpg",
      caption: "",
      thumb: "assets/img/pensionscheme/208.jpg",
    },
    {
      src: "assets/img/pensionscheme/209.jpg",
      caption: "",
      thumb: "assets/img/pensionscheme/209.jpg",
    },
    {
      src: "assets/img/pensionscheme/210.jpg",
      caption: "",
      thumb: "assets/img/pensionscheme/210.jpg",
    },
    {
      src: "assets/img/pensionscheme/211.jpg",
      caption: "",
      thumb: "assets/img/pensionscheme/211.jpg",
    },
    {
      src: "assets/img/pensionscheme/212.jpg",
      caption: "",
      thumb: "assets/img/pensionscheme/212.jpg",
    },
    {
      src: "assets/img/pensionscheme/213.jpg",
      caption: "",
      thumb: "assets/img/pensionscheme/213.jpg",
    },
    {
      src: "assets/img/pensionscheme/214.jpg",
      caption: "",
      thumb: "assets/img/pensionscheme/214.jpg",
    },
    {
      src: "assets/img/pensionscheme/215.jpg",
      caption: "",
      thumb: "assets/img/pensionscheme/215.jpg",
    },
    {
      src: "assets/img/pensionscheme/216.jpg",
      caption: "",
      thumb: "assets/img/pensionscheme/216.jpg",
    },
    {
      src: "assets/img/pensionscheme/217.jpg",
      caption: "",
      thumb: "assets/img/pensionscheme/217.jpg",
    },
    {
      src: "assets/img/pensionscheme/218.jpg",
      caption: "",
      thumb: "assets/img/pensionscheme/218.jpg",
    },
    {
      src: "assets/img/pensionscheme/219.jpg",
      caption: "",
      thumb: "assets/img/pensionscheme/219.jpg",
    },
    {
      src: "assets/img/pensionscheme/220.jpg",
      caption: "",
      thumb: "assets/img/pensionscheme/220.jpg",
    },
    {
      src: "assets/img/pensionscheme/221.jpg",
      caption: "",
      thumb: "assets/img/pensionscheme/221.jpg",
    },
    {
      src: "assets/img/pensionscheme/222.jpg",
      caption: "",
      thumb: "assets/img/pensionscheme/222.jpg",
    },
    {
      src: "assets/img/pensionscheme/223.jpg",
      caption: "",
      thumb: "assets/img/pensionscheme/223.jpg",
    },
    {
      src: "assets/img/pensionscheme/224.jpg",
      caption: "",
      thumb: "assets/img/pensionscheme/224.jpg",
    },
    {
      src: "assets/img/pensionscheme/225.jpg",
      caption: "",
      thumb: "assets/img/pensionscheme/225.jpg",
    },
    {
      src: "assets/img/pensionscheme/226.jpg",
      caption: "",
      thumb: "assets/img/pensionscheme/226.jpg",
    },
    {
      src: "assets/img/pensionscheme/227.jpg",
      caption: "",
      thumb: "assets/img/pensionscheme/227.jpg",
    },
    {
      src: "assets/img/pensionscheme/228.jpg",
      caption: "",
      thumb: "assets/img/pensionscheme/228.jpg",
    },
    {
      src: "assets/img/pensionscheme/229.jpg",
      caption: "",
      thumb: "assets/img/pensionscheme/229.jpg",
    },
    {
      src: "assets/img/pensionscheme/230.jpg",
      caption: "",
      thumb: "assets/img/pensionscheme/230.jpg",
    },
    {
      src: "assets/img/pensionscheme/231.jpg",
      caption: "",
      thumb: "assets/img/pensionscheme/231.jpg",
    },
    {
      src: "assets/img/pensionscheme/232.jpg",
      caption: "",
      thumb: "assets/img/pensionscheme/232.jpg",
    },
    {
      src: "assets/img/pensionscheme/233.jpg",
      caption: "",
      thumb: "assets/img/pensionscheme/233.jpg",
    },
    {
      src: "assets/img/pensionscheme/234.jpg",
      caption: "",
      thumb: "assets/img/pensionscheme/234.jpg",
    },
    {
      src: "assets/img/pensionscheme/235.jpg",
      caption: "",
      thumb: "assets/img/pensionscheme/235.jpg",
    },
    {
      src: "assets/img/pensionscheme/236.jpg",
      caption: "",
      thumb: "assets/img/pensionscheme/236.jpg",
    },
    {
      src: "assets/img/pensionscheme/237.jpg",
      caption: "",
      thumb: "assets/img/pensionscheme/237.jpg",
    },
    {
      src: "assets/img/pensionscheme/238.jpg",
      caption: "",
      thumb: "assets/img/pensionscheme/238.jpg",
    },
    {
      src: "assets/img/pensionscheme/239.jpg",
      caption: "",
      thumb: "assets/img/pensionscheme/239.jpg",
    },
    {
      src: "assets/img/pensionscheme/240.jpg",
      caption: "",
      thumb: "assets/img/pensionscheme/240.jpg",
    },
    {
      src: "assets/img/pensionscheme/241.jpg",
      caption: "",
      thumb: "assets/img/pensionscheme/241.jpg",
    },
    {
      src: "assets/img/pensionscheme/242.jpg",
      caption: "",
      thumb: "assets/img/pensionscheme/242.jpg",
    },
    {
      src: "assets/img/pensionscheme/243.jpg",
      caption: "",
      thumb: "assets/img/pensionscheme/243.jpg",
    },
    {
      src: "assets/img/pensionscheme/244.jpg",
      caption: "",
      thumb: "assets/img/pensionscheme/244.jpg",
    },
    {
      src: "assets/img/pensionscheme/245.jpg",
      caption: "",
      thumb: "assets/img/pensionscheme/245.jpg",
    },
    {
      src: "assets/img/pensionscheme/246.jpg",
      caption: "",
      thumb: "assets/img/pensionscheme/246.jpg",
    },
    {
      src: "assets/img/pensionscheme/247.jpg",
      caption: "",
      thumb: "assets/img/pensionscheme/247.jpg",
    },
    {
      src: "assets/img/pensionscheme/248.jpg",
      caption: "",
      thumb: "assets/img/pensionscheme/248.jpg",
    },
    {
      src: "assets/img/pensionscheme/249.jpg",
      caption: "",
      thumb: "assets/img/pensionscheme/249.jpg",
    },
    {
      src: "assets/img/pensionscheme/250.jpg",
      caption: "",
      thumb: "assets/img/pensionscheme/250.jpg",
    },

    {
      src: "assets/img/pensionscheme/190.jpg",
      caption: "",
      thumb: "assets/img/pensionscheme/190.jpg",
    },
    {
      src: "assets/img/pensionscheme/191.jpg",
      caption: "",
      thumb: "assets/img/pensionscheme/191.jpg",
    },
    {
      src: "assets/img/pensionscheme/192.jpg",
      caption: "",
      thumb: "assets/img/pensionscheme/192.jpg",
    },
    {
      src: "assets/img/pensionscheme/193.jpg",
      caption: "",
      thumb: "assets/img/pensionscheme/193.jpg",
    },
    {
      src: "assets/img/pensionscheme/194.jpg",
      caption: "",
      thumb: "assets/img/pensionscheme/194.jpg",
    },
    {
      src: "assets/img/pensionscheme/195.jpg",
      caption: "",
      thumb: "assets/img/pensionscheme/195.jpg",
    },
    {
      src: "assets/img/pensionscheme/196.jpg",
      caption: "",
      thumb: "assets/img/pensionscheme/196.jpg",
    },
    {
      src: "assets/img/pensionscheme/197.jpg",
      caption: "",
      thumb: "assets/img/pensionscheme/197.jpg",
    },
    {
      src: "assets/img/pensionscheme/198.jpg",
      caption: "",
      thumb: "assets/img/pensionscheme/198.jpg",
    },
    {
      src: "assets/img/pensionscheme/199.jpg",
      caption: "",
      thumb: "assets/img/pensionscheme/199.jpg",
    },
    {
      src: "assets/img/pensionscheme/200.jpg",
      caption: "",
      thumb: "assets/img/pensionscheme/200.jpg",
    },
    {
      src: "assets/img/pensionscheme/201.jpg",
      caption: "",
      thumb: "assets/img/pensionscheme/201.jpg",
    },
    {
      src: "assets/img/pensionscheme/202.jpg",
      caption: "",
      thumb: "assets/img/pensionscheme/202.jpg",
    },
    {
      src: "assets/img/pensionscheme/179.jpg",
      caption: "",
      thumb: "assets/img/pensionscheme/179.jpg",
    },
    {
      src: "assets/img/pensionscheme/180.jpg",
      caption: "",
      thumb: "assets/img/pensionscheme/180.jpg",
    },
    {
      src: "assets/img/pensionscheme/181.jpg",
      caption: "",
      thumb: "assets/img/pensionscheme/181.jpg",
    },
    {
      src: "assets/img/pensionscheme/182.jpg",
      caption: "",
      thumb: "assets/img/pensionscheme/182.jpg",
    },
    {
      src: "assets/img/pensionscheme/183.jpg",
      caption: "",
      thumb: "assets/img/pensionscheme/183.jpg",
    },
    {
      src: "assets/img/pensionscheme/184.jpg",
      caption: "",
      thumb: "assets/img/pensionscheme/184.jpg",
    },
    {
      src: "assets/img/pensionscheme/185.jpg",
      caption: "",
      thumb: "assets/img/pensionscheme/185.jpg",
    },
    {
      src: "assets/img/pensionscheme/186.jpg",
      caption: "",
      thumb: "assets/img/pensionscheme/186.jpg",
    },
    {
      src: "assets/img/pensionscheme/187.jpg",
      caption: "",
      thumb: "assets/img/pensionscheme/187.jpg",
    },
    {
      src: "assets/img/pensionscheme/188.jpg",
      caption: "",
      thumb: "assets/img/pensionscheme/188.jpg",
    },
    {
      src: "assets/img/pensionscheme/189.jpg",
      caption: "",
      thumb: "assets/img/pensionscheme/189.jpg",
    },
    {
      src: "assets/img/pensionscheme/176.jpg",
      caption:
        "നെയ്യാറ്റിൻകര പെൻഷൻ പ്ലാനിന്റെ സ്പെഷ്യൽ സ്കീമിൽ   നിംസ് യൂത്ത് റെഡ് ക്രോസ് ടീം നടത്തുന്ന സേവനങ്ങളുടെ ഗുണദോക്താവായ മുനിസിപ്പാലറ്റിയിലെ വഴിമുക്ക് വാർഡിലെ മാനസിക ശാരീരിക വെല്ലുവിളിയെ നേരിടുന്ന ശ്രീ ഷമീറിനെ ഉൾപ്പെടുത്തി നിംസ് മെഡിസിറ്റി മാനേജിങ്ങ് ഡയറക്ടർ ശ്രീ എം.എസ് ഫൈസൽ ഖാൻ പെൻഷൻ തുക ഷമീറിന്റെ മാതാവിന് കൈമാറുകയുണ്ടായി.",
      thumb: "assets/img/pensionscheme/176.jpg",
    },
    {
      src: "assets/img/pensionscheme/177.jpg",
      caption:
        "ജീവിതശൈലീ രോഗങ്ങളാലും മറ്റ് വാർദ്ധക്യ സഹജമായ അസുഖങ്ങളാലും ബുദ്ധിമുട്ട് അനുഭവിക്കുന്നവരും മാസത്തിൽ ഒരു തവണയെങ്കിലും ആശുപത്രി സന്ദർശനം നടത്തി റെഗുലർ പരിശോധന നടത്തി ചികിത്സ തേടാൻ സാധിക്കാത്തതും അശരണരും ശയ്യാവലംബരുമായ  വർക്ക് ഒരു കൈ താങ്ങായി നിംസ് മെഡിസിറ്റി യൂത്ത് റെഡ് ക്രോസ് വോളന്റിയേഴ്സിന്റെ മുന്നോട്ടുള്ള പ്രയാണത്തിൽ ഒപ്പം മുനിസിപ്പൽ ചെയർമാൻ ശ്രീ. രാജ്മോഹൻ, ആരോഗ്യ സ്റ്റാൻഡിങ്ങ് കമ്മറ്റി ചെയർ പേഴ്സൺ ശ്രീ ജോസ് ഫ്രാങ്ക്ളിൻ, വഴിമുക് വാർഡ് കൗൺസിലർ ഡോ സാദത്ത് സർ മുനിസിപാലിറ്റിയിലെ മറ്റ്  വാർഡ് കൗൺസിലർമാരും ആശാ വർക്കർമാരും സാമൂഹിക പ്രവർത്തകരും ചേർന്ന് മഹത്തരമാക്കികൊണ്ടിരിക്കുന്നു.",
      thumb: "assets/img/pensionscheme/177.jpg",
    },
    {
      src: "assets/img/pensionscheme/178.jpeg",
      caption:
        "ജീവിതശൈലീ രോഗങ്ങളാലും മറ്റ് വാർദ്ധക്യ സഹജമായ അസുഖങ്ങളാലും ബുദ്ധിമുട്ട് അനുഭവിക്കുന്നവരും മാസത്തിൽ ഒരു തവണയെങ്കിലും ആശുപത്രി സന്ദർശനം നടത്തി റെഗുലർ പരിശോധന നടത്തി ചികിത്സ തേടാൻ സാധിക്കാത്തതും അശരണരും ശയ്യാവലംബരുമായ  വർക്ക് ഒരു കൈ താങ്ങായി നിംസ് മെഡിസിറ്റി യൂത്ത് റെഡ് ക്രോസ് വോളന്റിയേഴ്സിന്റെ മുന്നോട്ടുള്ള പ്രയാണത്തിൽ ഒപ്പം മുനിസിപ്പൽ ചെയർമാൻ ശ്രീ. രാജ്മോഹൻ, ആരോഗ്യ സ്റ്റാൻഡിങ്ങ് കമ്മറ്റി ചെയർ പേഴ്സൺ ശ്രീ ജോസ് ഫ്രാങ്ക്ളിൻ, വഴിമുക് വാർഡ് കൗൺസിലർ ഡോ സാദത്ത് സർ മുനിസിപാലിറ്റിയിലെ മറ്റ്  വാർഡ് കൗൺസിലർമാരും ആശാ വർക്കർമാരും സാമൂഹിക പ്രവർത്തകരും ചേർന്ന് മഹത്തരമാക്കികൊണ്ടിരിക്കുന്നു.",
      thumb: "assets/img/pensionscheme/178.jpg",
    },

    {
      src: "assets/img/pensionscheme/146.jpg",
      caption:
        'നിംസ് മെഡിസിറ്റി നടത്തിവരുന്ന "നെയ്യാറ്റിൻകര പെൻഷൻ പ്ളാൻ ഗുണഭോക്താക്കളായ കുട്ടികൾക്ക്  തൊഴിൽ പരിശീലന പരിപാടി വിവിധ കലാപരിപാടികൾ അവതരിപ്പിച്ചും മൽസരങ്ങൾ നടത്തിക്കൊണ്ടും ആരംഭിച്ചിരിക്കുന്നു. നിംസ് മെഡിസിറ്റി ജനറൽ മാനേജർ ഡോ.കെ.എ. സജു സ്വാഗതം ആശംസിച്ചു . ജോയിന്റ് സയറക്ടർ ഓഫ് മെഡിക്കൽ എഡുക്കേഷൻ ഡോ. അനിത ബാലൻ ചടങ്ങ് ഉദ്ഘാടനം ചെയ്തു സംസാരിച്ചു. ഭിന്നശേഷി കുട്ടികൾക്കും കുടുംബത്തിനും താങ്ങായി മാറുകയാണ് ഇത്തരം പദ്ധതികളെന്നും ഇത്തരത്തിൽ മാതൃകാ പ്രവർത്തനം നടത്തുന്ന നിംസ് മെഡിസിറ്റി എംഡി, എം .എസ് .ഫൈസൽഖാൻ  സേവനത്തിന്റെ മാതൃകാ മുഖമായി മാറുകയാണെന്നും പറഞ്ഞു. ചടങ്ങിൽ  നിംസ് സ്പെക്ട്രം ഡയറക്ടറും മുൻ ആരോഗ്യ സർവ്വകലാശാല വൈസ് ചാൻസലറുമായ ഡോ.എം.കെ.സി നായർ മുഖ്യ  പ്രഭാഷണം നടത്തി. നെയ്യാറ്റിൻകര നിംസ് ഫിസിക്കൽ മെഡിസിൻ വിഭാഗം മേധാവി ഡോ.ജിം ഗോപാല കൃഷ്ണൻ കുട്ടികൾക്ക് ഫിസിയോ തെറാപ്പിയുടെ വിശദീകരണവും പരിശോധനയും നടത്തി.  പീടിയാട്രിക് നൂറോളജിസ്റ്റ് ഡോ. കുഞ്ഞുമുഹമ്മദ്, ജറിയാട്രിക് കോഡിനേറ്റർ കെ.ആർ രേണു. പോളിയോ ഹോം മുൻ പ്രോജക്ട് കോഡിനേറ്റർ  ബോബി ,  സ്പെഷ്യൽ എഡുകേറ്റർ ശ്രീ നോബിൾ മില്ലർ തുടങ്ങിയവർ ചടങ്ങിൽ ആശംസ അർപ്പിച്ചു. നിംസ്നഴ്സിങ് കോളേജ് വൈസ് പ്രിൻസിപ്പൽ ശ്രീമതി. ജോസ് ഫിൻ വിനിത കൃതജ്ഞത പറഞ്ഞു. സ്പെഷൽ എഡുകേറ്റർമാരായ ശ്രീമതി പ്രിൻസ് മോൾ , ശ്രീമതി സിമി,  സ്പെക്ട്രം കോഡിനേറ്റർ ശ്രീ അബ്ദുൾ റിഫായി,നിംസ് സ്പെക്ട്രം സീനിയർ തെറാപ്പിസ്റ്റ് ശ്രീമതി സ്വപ്ന, നഴ്സിംഗ് കൗസിലർ അശ്വതി . ഓക്കു പേഷൻ തെറാപ്പിസ്റ്റ് മെർലിൻ തുടങ്ങിയർ പദ്ധതി വിജയകരമാക്കുന്നതിന് സജീവപങ്കാളിത്തം വഹിച്ചു.',
      thumb: "assets/img/pensionscheme/146.jpg",
    },
    {
      src: "assets/img/pensionscheme/147.jpg",
      caption:
        'നിംസ് മെഡിസിറ്റി നടത്തിവരുന്ന "നെയ്യാറ്റിൻകര പെൻഷൻ പ്ളാൻ ഗുണഭോക്താക്കളായ കുട്ടികൾക്ക്  തൊഴിൽ പരിശീലന പരിപാടി വിവിധ കലാപരിപാടികൾ അവതരിപ്പിച്ചും മൽസരങ്ങൾ നടത്തിക്കൊണ്ടും ആരംഭിച്ചിരിക്കുന്നു. നിംസ് മെഡിസിറ്റി ജനറൽ മാനേജർ ഡോ.കെ.എ. സജു സ്വാഗതം ആശംസിച്ചു . ജോയിന്റ് സയറക്ടർ ഓഫ് മെഡിക്കൽ എഡുക്കേഷൻ ഡോ. അനിത ബാലൻ ചടങ്ങ് ഉദ്ഘാടനം ചെയ്തു സംസാരിച്ചു. ഭിന്നശേഷി കുട്ടികൾക്കും കുടുംബത്തിനും താങ്ങായി മാറുകയാണ് ഇത്തരം പദ്ധതികളെന്നും ഇത്തരത്തിൽ മാതൃകാ പ്രവർത്തനം നടത്തുന്ന നിംസ് മെഡിസിറ്റി എംഡി, എം .എസ് .ഫൈസൽഖാൻ  സേവനത്തിന്റെ മാതൃകാ മുഖമായി മാറുകയാണെന്നും പറഞ്ഞു. ചടങ്ങിൽ  നിംസ് സ്പെക്ട്രം ഡയറക്ടറും മുൻ ആരോഗ്യ സർവ്വകലാശാല വൈസ് ചാൻസലറുമായ ഡോ.എം.കെ.സി നായർ മുഖ്യ  പ്രഭാഷണം നടത്തി. നെയ്യാറ്റിൻകര നിംസ് ഫിസിക്കൽ മെഡിസിൻ വിഭാഗം മേധാവി ഡോ.ജിം ഗോപാല കൃഷ്ണൻ കുട്ടികൾക്ക് ഫിസിയോ തെറാപ്പിയുടെ വിശദീകരണവും പരിശോധനയും നടത്തി.  പീടിയാട്രിക് നൂറോളജിസ്റ്റ് ഡോ. കുഞ്ഞുമുഹമ്മദ്, ജറിയാട്രിക് കോഡിനേറ്റർ കെ.ആർ രേണു. പോളിയോ ഹോം മുൻ പ്രോജക്ട് കോഡിനേറ്റർ  ബോബി ,  സ്പെഷ്യൽ എഡുകേറ്റർ ശ്രീ നോബിൾ മില്ലർ തുടങ്ങിയവർ ചടങ്ങിൽ ആശംസ അർപ്പിച്ചു. നിംസ്നഴ്സിങ് കോളേജ് വൈസ് പ്രിൻസിപ്പൽ ശ്രീമതി. ജോസ് ഫിൻ വിനിത കൃതജ്ഞത പറഞ്ഞു. സ്പെഷൽ എഡുകേറ്റർമാരായ ശ്രീമതി പ്രിൻസ് മോൾ , ശ്രീമതി സിമി,  സ്പെക്ട്രം കോഡിനേറ്റർ ശ്രീ അബ്ദുൾ റിഫായി,നിംസ് സ്പെക്ട്രം സീനിയർ തെറാപ്പിസ്റ്റ് ശ്രീമതി സ്വപ്ന, നഴ്സിംഗ് കൗസിലർ അശ്വതി . ഓക്കു പേഷൻ തെറാപ്പിസ്റ്റ് മെർലിൻ തുടങ്ങിയർ പദ്ധതി വിജയകരമാക്കുന്നതിന് സജീവപങ്കാളിത്തം വഹിച്ചു.',
      thumb: "assets/img/pensionscheme/147.jpg",
    },
    {
      src: "assets/img/pensionscheme/148.jpg",
      caption:
        'നിംസ് മെഡിസിറ്റി നടത്തിവരുന്ന "നെയ്യാറ്റിൻകര പെൻഷൻ പ്ളാൻ ഗുണഭോക്താക്കളായ കുട്ടികൾക്ക്  തൊഴിൽ പരിശീലന പരിപാടി വിവിധ കലാപരിപാടികൾ അവതരിപ്പിച്ചും മൽസരങ്ങൾ നടത്തിക്കൊണ്ടും ആരംഭിച്ചിരിക്കുന്നു. നിംസ് മെഡിസിറ്റി ജനറൽ മാനേജർ ഡോ.കെ.എ. സജു സ്വാഗതം ആശംസിച്ചു . ജോയിന്റ് സയറക്ടർ ഓഫ് മെഡിക്കൽ എഡുക്കേഷൻ ഡോ. അനിത ബാലൻ ചടങ്ങ് ഉദ്ഘാടനം ചെയ്തു സംസാരിച്ചു. ഭിന്നശേഷി കുട്ടികൾക്കും കുടുംബത്തിനും താങ്ങായി മാറുകയാണ് ഇത്തരം പദ്ധതികളെന്നും ഇത്തരത്തിൽ മാതൃകാ പ്രവർത്തനം നടത്തുന്ന നിംസ് മെഡിസിറ്റി എംഡി, എം .എസ് .ഫൈസൽഖാൻ  സേവനത്തിന്റെ മാതൃകാ മുഖമായി മാറുകയാണെന്നും പറഞ്ഞു. ചടങ്ങിൽ  നിംസ് സ്പെക്ട്രം ഡയറക്ടറും മുൻ ആരോഗ്യ സർവ്വകലാശാല വൈസ് ചാൻസലറുമായ ഡോ.എം.കെ.സി നായർ മുഖ്യ  പ്രഭാഷണം നടത്തി. നെയ്യാറ്റിൻകര നിംസ് ഫിസിക്കൽ മെഡിസിൻ വിഭാഗം മേധാവി ഡോ.ജിം ഗോപാല കൃഷ്ണൻ കുട്ടികൾക്ക് ഫിസിയോ തെറാപ്പിയുടെ വിശദീകരണവും പരിശോധനയും നടത്തി.  പീടിയാട്രിക് നൂറോളജിസ്റ്റ് ഡോ. കുഞ്ഞുമുഹമ്മദ്, ജറിയാട്രിക് കോഡിനേറ്റർ കെ.ആർ രേണു. പോളിയോ ഹോം മുൻ പ്രോജക്ട് കോഡിനേറ്റർ  ബോബി ,  സ്പെഷ്യൽ എഡുകേറ്റർ ശ്രീ നോബിൾ മില്ലർ തുടങ്ങിയവർ ചടങ്ങിൽ ആശംസ അർപ്പിച്ചു. നിംസ്നഴ്സിങ് കോളേജ് വൈസ് പ്രിൻസിപ്പൽ ശ്രീമതി. ജോസ് ഫിൻ വിനിത കൃതജ്ഞത പറഞ്ഞു. സ്പെഷൽ എഡുകേറ്റർമാരായ ശ്രീമതി പ്രിൻസ് മോൾ , ശ്രീമതി സിമി,  സ്പെക്ട്രം കോഡിനേറ്റർ ശ്രീ അബ്ദുൾ റിഫായി,നിംസ് സ്പെക്ട്രം സീനിയർ തെറാപ്പിസ്റ്റ് ശ്രീമതി സ്വപ്ന, നഴ്സിംഗ് കൗസിലർ അശ്വതി . ഓക്കു പേഷൻ തെറാപ്പിസ്റ്റ് മെർലിൻ തുടങ്ങിയർ പദ്ധതി വിജയകരമാക്കുന്നതിന് സജീവപങ്കാളിത്തം വഹിച്ചു.',
      thumb: "assets/img/pensionscheme/148.jpg",
    },
    {
      src: "assets/img/pensionscheme/149.jpg",
      caption:
        'നിംസ് മെഡിസിറ്റി നടത്തിവരുന്ന "നെയ്യാറ്റിൻകര പെൻഷൻ പ്ളാൻ ഗുണഭോക്താക്കളായ കുട്ടികൾക്ക്  തൊഴിൽ പരിശീലന പരിപാടി വിവിധ കലാപരിപാടികൾ അവതരിപ്പിച്ചും മൽസരങ്ങൾ നടത്തിക്കൊണ്ടും ആരംഭിച്ചിരിക്കുന്നു. നിംസ് മെഡിസിറ്റി ജനറൽ മാനേജർ ഡോ.കെ.എ. സജു സ്വാഗതം ആശംസിച്ചു . ജോയിന്റ് സയറക്ടർ ഓഫ് മെഡിക്കൽ എഡുക്കേഷൻ ഡോ. അനിത ബാലൻ ചടങ്ങ് ഉദ്ഘാടനം ചെയ്തു സംസാരിച്ചു. ഭിന്നശേഷി കുട്ടികൾക്കും കുടുംബത്തിനും താങ്ങായി മാറുകയാണ് ഇത്തരം പദ്ധതികളെന്നും ഇത്തരത്തിൽ മാതൃകാ പ്രവർത്തനം നടത്തുന്ന നിംസ് മെഡിസിറ്റി എംഡി, എം .എസ് .ഫൈസൽഖാൻ  സേവനത്തിന്റെ മാതൃകാ മുഖമായി മാറുകയാണെന്നും പറഞ്ഞു. ചടങ്ങിൽ  നിംസ് സ്പെക്ട്രം ഡയറക്ടറും മുൻ ആരോഗ്യ സർവ്വകലാശാല വൈസ് ചാൻസലറുമായ ഡോ.എം.കെ.സി നായർ മുഖ്യ  പ്രഭാഷണം നടത്തി. നെയ്യാറ്റിൻകര നിംസ് ഫിസിക്കൽ മെഡിസിൻ വിഭാഗം മേധാവി ഡോ.ജിം ഗോപാല കൃഷ്ണൻ കുട്ടികൾക്ക് ഫിസിയോ തെറാപ്പിയുടെ വിശദീകരണവും പരിശോധനയും നടത്തി.  പീടിയാട്രിക് നൂറോളജിസ്റ്റ് ഡോ. കുഞ്ഞുമുഹമ്മദ്, ജറിയാട്രിക് കോഡിനേറ്റർ കെ.ആർ രേണു. പോളിയോ ഹോം മുൻ പ്രോജക്ട് കോഡിനേറ്റർ  ബോബി ,  സ്പെഷ്യൽ എഡുകേറ്റർ ശ്രീ നോബിൾ മില്ലർ തുടങ്ങിയവർ ചടങ്ങിൽ ആശംസ അർപ്പിച്ചു. നിംസ്നഴ്സിങ് കോളേജ് വൈസ് പ്രിൻസിപ്പൽ ശ്രീമതി. ജോസ് ഫിൻ വിനിത കൃതജ്ഞത പറഞ്ഞു. സ്പെഷൽ എഡുകേറ്റർമാരായ ശ്രീമതി പ്രിൻസ് മോൾ , ശ്രീമതി സിമി,  സ്പെക്ട്രം കോഡിനേറ്റർ ശ്രീ അബ്ദുൾ റിഫായി,നിംസ് സ്പെക്ട്രം സീനിയർ തെറാപ്പിസ്റ്റ് ശ്രീമതി സ്വപ്ന, നഴ്സിംഗ് കൗസിലർ അശ്വതി . ഓക്കു പേഷൻ തെറാപ്പിസ്റ്റ് മെർലിൻ തുടങ്ങിയർ പദ്ധതി വിജയകരമാക്കുന്നതിന് സജീവപങ്കാളിത്തം വഹിച്ചു.',
      thumb: "assets/img/pensionscheme/149.jpg",
    },
    {
      src: "assets/img/pensionscheme/150.jpg",
      caption:
        'നിംസ് മെഡിസിറ്റി നടത്തിവരുന്ന "നെയ്യാറ്റിൻകര പെൻഷൻ പ്ളാൻ ഗുണഭോക്താക്കളായ കുട്ടികൾക്ക്  തൊഴിൽ പരിശീലന പരിപാടി വിവിധ കലാപരിപാടികൾ അവതരിപ്പിച്ചും മൽസരങ്ങൾ നടത്തിക്കൊണ്ടും ആരംഭിച്ചിരിക്കുന്നു. നിംസ് മെഡിസിറ്റി ജനറൽ മാനേജർ ഡോ.കെ.എ. സജു സ്വാഗതം ആശംസിച്ചു . ജോയിന്റ് സയറക്ടർ ഓഫ് മെഡിക്കൽ എഡുക്കേഷൻ ഡോ. അനിത ബാലൻ ചടങ്ങ് ഉദ്ഘാടനം ചെയ്തു സംസാരിച്ചു. ഭിന്നശേഷി കുട്ടികൾക്കും കുടുംബത്തിനും താങ്ങായി മാറുകയാണ് ഇത്തരം പദ്ധതികളെന്നും ഇത്തരത്തിൽ മാതൃകാ പ്രവർത്തനം നടത്തുന്ന നിംസ് മെഡിസിറ്റി എംഡി, എം .എസ് .ഫൈസൽഖാൻ  സേവനത്തിന്റെ മാതൃകാ മുഖമായി മാറുകയാണെന്നും പറഞ്ഞു. ചടങ്ങിൽ  നിംസ് സ്പെക്ട്രം ഡയറക്ടറും മുൻ ആരോഗ്യ സർവ്വകലാശാല വൈസ് ചാൻസലറുമായ ഡോ.എം.കെ.സി നായർ മുഖ്യ  പ്രഭാഷണം നടത്തി. നെയ്യാറ്റിൻകര നിംസ് ഫിസിക്കൽ മെഡിസിൻ വിഭാഗം മേധാവി ഡോ.ജിം ഗോപാല കൃഷ്ണൻ കുട്ടികൾക്ക് ഫിസിയോ തെറാപ്പിയുടെ വിശദീകരണവും പരിശോധനയും നടത്തി.  പീടിയാട്രിക് നൂറോളജിസ്റ്റ് ഡോ. കുഞ്ഞുമുഹമ്മദ്, ജറിയാട്രിക് കോഡിനേറ്റർ കെ.ആർ രേണു. പോളിയോ ഹോം മുൻ പ്രോജക്ട് കോഡിനേറ്റർ  ബോബി ,  സ്പെഷ്യൽ എഡുകേറ്റർ ശ്രീ നോബിൾ മില്ലർ തുടങ്ങിയവർ ചടങ്ങിൽ ആശംസ അർപ്പിച്ചു. നിംസ്നഴ്സിങ് കോളേജ് വൈസ് പ്രിൻസിപ്പൽ ശ്രീമതി. ജോസ് ഫിൻ വിനിത കൃതജ്ഞത പറഞ്ഞു. സ്പെഷൽ എഡുകേറ്റർമാരായ ശ്രീമതി പ്രിൻസ് മോൾ , ശ്രീമതി സിമി,  സ്പെക്ട്രം കോഡിനേറ്റർ ശ്രീ അബ്ദുൾ റിഫായി,നിംസ് സ്പെക്ട്രം സീനിയർ തെറാപ്പിസ്റ്റ് ശ്രീമതി സ്വപ്ന, നഴ്സിംഗ് കൗസിലർ അശ്വതി . ഓക്കു പേഷൻ തെറാപ്പിസ്റ്റ് മെർലിൻ തുടങ്ങിയർ പദ്ധതി വിജയകരമാക്കുന്നതിന് സജീവപങ്കാളിത്തം വഹിച്ചു.',
      thumb: "assets/img/pensionscheme/150.jpg",
    },
    {
      src: "assets/img/pensionscheme/151.jpg",
      caption:
        'നിംസ് മെഡിസിറ്റി നടത്തിവരുന്ന "നെയ്യാറ്റിൻകര പെൻഷൻ പ്ളാൻ ഗുണഭോക്താക്കളായ കുട്ടികൾക്ക്  തൊഴിൽ പരിശീലന പരിപാടി വിവിധ കലാപരിപാടികൾ അവതരിപ്പിച്ചും മൽസരങ്ങൾ നടത്തിക്കൊണ്ടും ആരംഭിച്ചിരിക്കുന്നു. നിംസ് മെഡിസിറ്റി ജനറൽ മാനേജർ ഡോ.കെ.എ. സജു സ്വാഗതം ആശംസിച്ചു . ജോയിന്റ് സയറക്ടർ ഓഫ് മെഡിക്കൽ എഡുക്കേഷൻ ഡോ. അനിത ബാലൻ ചടങ്ങ് ഉദ്ഘാടനം ചെയ്തു സംസാരിച്ചു. ഭിന്നശേഷി കുട്ടികൾക്കും കുടുംബത്തിനും താങ്ങായി മാറുകയാണ് ഇത്തരം പദ്ധതികളെന്നും ഇത്തരത്തിൽ മാതൃകാ പ്രവർത്തനം നടത്തുന്ന നിംസ് മെഡിസിറ്റി എംഡി, എം .എസ് .ഫൈസൽഖാൻ  സേവനത്തിന്റെ മാതൃകാ മുഖമായി മാറുകയാണെന്നും പറഞ്ഞു. ചടങ്ങിൽ  നിംസ് സ്പെക്ട്രം ഡയറക്ടറും മുൻ ആരോഗ്യ സർവ്വകലാശാല വൈസ് ചാൻസലറുമായ ഡോ.എം.കെ.സി നായർ മുഖ്യ  പ്രഭാഷണം നടത്തി. നെയ്യാറ്റിൻകര നിംസ് ഫിസിക്കൽ മെഡിസിൻ വിഭാഗം മേധാവി ഡോ.ജിം ഗോപാല കൃഷ്ണൻ കുട്ടികൾക്ക് ഫിസിയോ തെറാപ്പിയുടെ വിശദീകരണവും പരിശോധനയും നടത്തി.  പീടിയാട്രിക് നൂറോളജിസ്റ്റ് ഡോ. കുഞ്ഞുമുഹമ്മദ്, ജറിയാട്രിക് കോഡിനേറ്റർ കെ.ആർ രേണു. പോളിയോ ഹോം മുൻ പ്രോജക്ട് കോഡിനേറ്റർ  ബോബി ,  സ്പെഷ്യൽ എഡുകേറ്റർ ശ്രീ നോബിൾ മില്ലർ തുടങ്ങിയവർ ചടങ്ങിൽ ആശംസ അർപ്പിച്ചു. നിംസ്നഴ്സിങ് കോളേജ് വൈസ് പ്രിൻസിപ്പൽ ശ്രീമതി. ജോസ് ഫിൻ വിനിത കൃതജ്ഞത പറഞ്ഞു. സ്പെഷൽ എഡുകേറ്റർമാരായ ശ്രീമതി പ്രിൻസ് മോൾ , ശ്രീമതി സിമി,  സ്പെക്ട്രം കോഡിനേറ്റർ ശ്രീ അബ്ദുൾ റിഫായി,നിംസ് സ്പെക്ട്രം സീനിയർ തെറാപ്പിസ്റ്റ് ശ്രീമതി സ്വപ്ന, നഴ്സിംഗ് കൗസിലർ അശ്വതി . ഓക്കു പേഷൻ തെറാപ്പിസ്റ്റ് മെർലിൻ തുടങ്ങിയർ പദ്ധതി വിജയകരമാക്കുന്നതിന് സജീവപങ്കാളിത്തം വഹിച്ചു.',
      thumb: "assets/img/pensionscheme/151.jpg",
    },
    {
      src: "assets/img/pensionscheme/152.jpg",
      caption:
        'നിംസ് മെഡിസിറ്റി നടത്തിവരുന്ന "നെയ്യാറ്റിൻകര പെൻഷൻ പ്ളാൻ ഗുണഭോക്താക്കളായ കുട്ടികൾക്ക്  തൊഴിൽ പരിശീലന പരിപാടി വിവിധ കലാപരിപാടികൾ അവതരിപ്പിച്ചും മൽസരങ്ങൾ നടത്തിക്കൊണ്ടും ആരംഭിച്ചിരിക്കുന്നു. നിംസ് മെഡിസിറ്റി ജനറൽ മാനേജർ ഡോ.കെ.എ. സജു സ്വാഗതം ആശംസിച്ചു . ജോയിന്റ് സയറക്ടർ ഓഫ് മെഡിക്കൽ എഡുക്കേഷൻ ഡോ. അനിത ബാലൻ ചടങ്ങ് ഉദ്ഘാടനം ചെയ്തു സംസാരിച്ചു. ഭിന്നശേഷി കുട്ടികൾക്കും കുടുംബത്തിനും താങ്ങായി മാറുകയാണ് ഇത്തരം പദ്ധതികളെന്നും ഇത്തരത്തിൽ മാതൃകാ പ്രവർത്തനം നടത്തുന്ന നിംസ് മെഡിസിറ്റി എംഡി, എം .എസ് .ഫൈസൽഖാൻ  സേവനത്തിന്റെ മാതൃകാ മുഖമായി മാറുകയാണെന്നും പറഞ്ഞു. ചടങ്ങിൽ  നിംസ് സ്പെക്ട്രം ഡയറക്ടറും മുൻ ആരോഗ്യ സർവ്വകലാശാല വൈസ് ചാൻസലറുമായ ഡോ.എം.കെ.സി നായർ മുഖ്യ  പ്രഭാഷണം നടത്തി. നെയ്യാറ്റിൻകര നിംസ് ഫിസിക്കൽ മെഡിസിൻ വിഭാഗം മേധാവി ഡോ.ജിം ഗോപാല കൃഷ്ണൻ കുട്ടികൾക്ക് ഫിസിയോ തെറാപ്പിയുടെ വിശദീകരണവും പരിശോധനയും നടത്തി.  പീടിയാട്രിക് നൂറോളജിസ്റ്റ് ഡോ. കുഞ്ഞുമുഹമ്മദ്, ജറിയാട്രിക് കോഡിനേറ്റർ കെ.ആർ രേണു. പോളിയോ ഹോം മുൻ പ്രോജക്ട് കോഡിനേറ്റർ  ബോബി ,  സ്പെഷ്യൽ എഡുകേറ്റർ ശ്രീ നോബിൾ മില്ലർ തുടങ്ങിയവർ ചടങ്ങിൽ ആശംസ അർപ്പിച്ചു. നിംസ്നഴ്സിങ് കോളേജ് വൈസ് പ്രിൻസിപ്പൽ ശ്രീമതി. ജോസ് ഫിൻ വിനിത കൃതജ്ഞത പറഞ്ഞു. സ്പെഷൽ എഡുകേറ്റർമാരായ ശ്രീമതി പ്രിൻസ് മോൾ , ശ്രീമതി സിമി,  സ്പെക്ട്രം കോഡിനേറ്റർ ശ്രീ അബ്ദുൾ റിഫായി,നിംസ് സ്പെക്ട്രം സീനിയർ തെറാപ്പിസ്റ്റ് ശ്രീമതി സ്വപ്ന, നഴ്സിംഗ് കൗസിലർ അശ്വതി . ഓക്കു പേഷൻ തെറാപ്പിസ്റ്റ് മെർലിൻ തുടങ്ങിയർ പദ്ധതി വിജയകരമാക്കുന്നതിന് സജീവപങ്കാളിത്തം വഹിച്ചു.',
      thumb: "assets/img/pensionscheme/152.jpg",
    },
    {
      src: "assets/img/pensionscheme/153.jpg",
      caption:
        'നിംസ് മെഡിസിറ്റി നടത്തിവരുന്ന "നെയ്യാറ്റിൻകര പെൻഷൻ പ്ളാൻ ഗുണഭോക്താക്കളായ കുട്ടികൾക്ക്  തൊഴിൽ പരിശീലന പരിപാടി വിവിധ കലാപരിപാടികൾ അവതരിപ്പിച്ചും മൽസരങ്ങൾ നടത്തിക്കൊണ്ടും ആരംഭിച്ചിരിക്കുന്നു. നിംസ് മെഡിസിറ്റി ജനറൽ മാനേജർ ഡോ.കെ.എ. സജു സ്വാഗതം ആശംസിച്ചു . ജോയിന്റ് സയറക്ടർ ഓഫ് മെഡിക്കൽ എഡുക്കേഷൻ ഡോ. അനിത ബാലൻ ചടങ്ങ് ഉദ്ഘാടനം ചെയ്തു സംസാരിച്ചു. ഭിന്നശേഷി കുട്ടികൾക്കും കുടുംബത്തിനും താങ്ങായി മാറുകയാണ് ഇത്തരം പദ്ധതികളെന്നും ഇത്തരത്തിൽ മാതൃകാ പ്രവർത്തനം നടത്തുന്ന നിംസ് മെഡിസിറ്റി എംഡി, എം .എസ് .ഫൈസൽഖാൻ  സേവനത്തിന്റെ മാതൃകാ മുഖമായി മാറുകയാണെന്നും പറഞ്ഞു. ചടങ്ങിൽ  നിംസ് സ്പെക്ട്രം ഡയറക്ടറും മുൻ ആരോഗ്യ സർവ്വകലാശാല വൈസ് ചാൻസലറുമായ ഡോ.എം.കെ.സി നായർ മുഖ്യ  പ്രഭാഷണം നടത്തി. നെയ്യാറ്റിൻകര നിംസ് ഫിസിക്കൽ മെഡിസിൻ വിഭാഗം മേധാവി ഡോ.ജിം ഗോപാല കൃഷ്ണൻ കുട്ടികൾക്ക് ഫിസിയോ തെറാപ്പിയുടെ വിശദീകരണവും പരിശോധനയും നടത്തി.  പീടിയാട്രിക് നൂറോളജിസ്റ്റ് ഡോ. കുഞ്ഞുമുഹമ്മദ്, ജറിയാട്രിക് കോഡിനേറ്റർ കെ.ആർ രേണു. പോളിയോ ഹോം മുൻ പ്രോജക്ട് കോഡിനേറ്റർ  ബോബി ,  സ്പെഷ്യൽ എഡുകേറ്റർ ശ്രീ നോബിൾ മില്ലർ തുടങ്ങിയവർ ചടങ്ങിൽ ആശംസ അർപ്പിച്ചു. നിംസ്നഴ്സിങ് കോളേജ് വൈസ് പ്രിൻസിപ്പൽ ശ്രീമതി. ജോസ് ഫിൻ വിനിത കൃതജ്ഞത പറഞ്ഞു. സ്പെഷൽ എഡുകേറ്റർമാരായ ശ്രീമതി പ്രിൻസ് മോൾ , ശ്രീമതി സിമി,  സ്പെക്ട്രം കോഡിനേറ്റർ ശ്രീ അബ്ദുൾ റിഫായി,നിംസ് സ്പെക്ട്രം സീനിയർ തെറാപ്പിസ്റ്റ് ശ്രീമതി സ്വപ്ന, നഴ്സിംഗ് കൗസിലർ അശ്വതി . ഓക്കു പേഷൻ തെറാപ്പിസ്റ്റ് മെർലിൻ തുടങ്ങിയർ പദ്ധതി വിജയകരമാക്കുന്നതിന് സജീവപങ്കാളിത്തം വഹിച്ചു.',
      thumb: "assets/img/pensionscheme/153.jpg",
    },
    {
      src: "assets/img/pensionscheme/154.jpg",
      caption:
        'നിംസ് മെഡിസിറ്റി നടത്തിവരുന്ന "നെയ്യാറ്റിൻകര പെൻഷൻ പ്ളാൻ ഗുണഭോക്താക്കളായ കുട്ടികൾക്ക്  തൊഴിൽ പരിശീലന പരിപാടി വിവിധ കലാപരിപാടികൾ അവതരിപ്പിച്ചും മൽസരങ്ങൾ നടത്തിക്കൊണ്ടും ആരംഭിച്ചിരിക്കുന്നു. നിംസ് മെഡിസിറ്റി ജനറൽ മാനേജർ ഡോ.കെ.എ. സജു സ്വാഗതം ആശംസിച്ചു . ജോയിന്റ് സയറക്ടർ ഓഫ് മെഡിക്കൽ എഡുക്കേഷൻ ഡോ. അനിത ബാലൻ ചടങ്ങ് ഉദ്ഘാടനം ചെയ്തു സംസാരിച്ചു. ഭിന്നശേഷി കുട്ടികൾക്കും കുടുംബത്തിനും താങ്ങായി മാറുകയാണ് ഇത്തരം പദ്ധതികളെന്നും ഇത്തരത്തിൽ മാതൃകാ പ്രവർത്തനം നടത്തുന്ന നിംസ് മെഡിസിറ്റി എംഡി, എം .എസ് .ഫൈസൽഖാൻ  സേവനത്തിന്റെ മാതൃകാ മുഖമായി മാറുകയാണെന്നും പറഞ്ഞു. ചടങ്ങിൽ  നിംസ് സ്പെക്ട്രം ഡയറക്ടറും മുൻ ആരോഗ്യ സർവ്വകലാശാല വൈസ് ചാൻസലറുമായ ഡോ.എം.കെ.സി നായർ മുഖ്യ  പ്രഭാഷണം നടത്തി. നെയ്യാറ്റിൻകര നിംസ് ഫിസിക്കൽ മെഡിസിൻ വിഭാഗം മേധാവി ഡോ.ജിം ഗോപാല കൃഷ്ണൻ കുട്ടികൾക്ക് ഫിസിയോ തെറാപ്പിയുടെ വിശദീകരണവും പരിശോധനയും നടത്തി.  പീടിയാട്രിക് നൂറോളജിസ്റ്റ് ഡോ. കുഞ്ഞുമുഹമ്മദ്, ജറിയാട്രിക് കോഡിനേറ്റർ കെ.ആർ രേണു. പോളിയോ ഹോം മുൻ പ്രോജക്ട് കോഡിനേറ്റർ  ബോബി ,  സ്പെഷ്യൽ എഡുകേറ്റർ ശ്രീ നോബിൾ മില്ലർ തുടങ്ങിയവർ ചടങ്ങിൽ ആശംസ അർപ്പിച്ചു. നിംസ്നഴ്സിങ് കോളേജ് വൈസ് പ്രിൻസിപ്പൽ ശ്രീമതി. ജോസ് ഫിൻ വിനിത കൃതജ്ഞത പറഞ്ഞു. സ്പെഷൽ എഡുകേറ്റർമാരായ ശ്രീമതി പ്രിൻസ് മോൾ , ശ്രീമതി സിമി,  സ്പെക്ട്രം കോഡിനേറ്റർ ശ്രീ അബ്ദുൾ റിഫായി,നിംസ് സ്പെക്ട്രം സീനിയർ തെറാപ്പിസ്റ്റ് ശ്രീമതി സ്വപ്ന, നഴ്സിംഗ് കൗസിലർ അശ്വതി . ഓക്കു പേഷൻ തെറാപ്പിസ്റ്റ് മെർലിൻ തുടങ്ങിയർ പദ്ധതി വിജയകരമാക്കുന്നതിന് സജീവപങ്കാളിത്തം വഹിച്ചു.',
      thumb: "assets/img/pensionscheme/154.jpg",
    },
    {
      src: "assets/img/pensionscheme/155.jpg",
      caption:
        'നിംസ് മെഡിസിറ്റി നടത്തിവരുന്ന "നെയ്യാറ്റിൻകര പെൻഷൻ പ്ളാൻ ഗുണഭോക്താക്കളായ കുട്ടികൾക്ക്  തൊഴിൽ പരിശീലന പരിപാടി വിവിധ കലാപരിപാടികൾ അവതരിപ്പിച്ചും മൽസരങ്ങൾ നടത്തിക്കൊണ്ടും ആരംഭിച്ചിരിക്കുന്നു. നിംസ് മെഡിസിറ്റി ജനറൽ മാനേജർ ഡോ.കെ.എ. സജു സ്വാഗതം ആശംസിച്ചു . ജോയിന്റ് സയറക്ടർ ഓഫ് മെഡിക്കൽ എഡുക്കേഷൻ ഡോ. അനിത ബാലൻ ചടങ്ങ് ഉദ്ഘാടനം ചെയ്തു സംസാരിച്ചു. ഭിന്നശേഷി കുട്ടികൾക്കും കുടുംബത്തിനും താങ്ങായി മാറുകയാണ് ഇത്തരം പദ്ധതികളെന്നും ഇത്തരത്തിൽ മാതൃകാ പ്രവർത്തനം നടത്തുന്ന നിംസ് മെഡിസിറ്റി എംഡി, എം .എസ് .ഫൈസൽഖാൻ  സേവനത്തിന്റെ മാതൃകാ മുഖമായി മാറുകയാണെന്നും പറഞ്ഞു. ചടങ്ങിൽ  നിംസ് സ്പെക്ട്രം ഡയറക്ടറും മുൻ ആരോഗ്യ സർവ്വകലാശാല വൈസ് ചാൻസലറുമായ ഡോ.എം.കെ.സി നായർ മുഖ്യ  പ്രഭാഷണം നടത്തി. നെയ്യാറ്റിൻകര നിംസ് ഫിസിക്കൽ മെഡിസിൻ വിഭാഗം മേധാവി ഡോ.ജിം ഗോപാല കൃഷ്ണൻ കുട്ടികൾക്ക് ഫിസിയോ തെറാപ്പിയുടെ വിശദീകരണവും പരിശോധനയും നടത്തി.  പീടിയാട്രിക് നൂറോളജിസ്റ്റ് ഡോ. കുഞ്ഞുമുഹമ്മദ്, ജറിയാട്രിക് കോഡിനേറ്റർ കെ.ആർ രേണു. പോളിയോ ഹോം മുൻ പ്രോജക്ട് കോഡിനേറ്റർ  ബോബി ,  സ്പെഷ്യൽ എഡുകേറ്റർ ശ്രീ നോബിൾ മില്ലർ തുടങ്ങിയവർ ചടങ്ങിൽ ആശംസ അർപ്പിച്ചു. നിംസ്നഴ്സിങ് കോളേജ് വൈസ് പ്രിൻസിപ്പൽ ശ്രീമതി. ജോസ് ഫിൻ വിനിത കൃതജ്ഞത പറഞ്ഞു. സ്പെഷൽ എഡുകേറ്റർമാരായ ശ്രീമതി പ്രിൻസ് മോൾ , ശ്രീമതി സിമി,  സ്പെക്ട്രം കോഡിനേറ്റർ ശ്രീ അബ്ദുൾ റിഫായി,നിംസ് സ്പെക്ട്രം സീനിയർ തെറാപ്പിസ്റ്റ് ശ്രീമതി സ്വപ്ന, നഴ്സിംഗ് കൗസിലർ അശ്വതി . ഓക്കു പേഷൻ തെറാപ്പിസ്റ്റ് മെർലിൻ തുടങ്ങിയർ പദ്ധതി വിജയകരമാക്കുന്നതിന് സജീവപങ്കാളിത്തം വഹിച്ചു.',
      thumb: "assets/img/pensionscheme/155.jpg",
    },
    {
      src: "assets/img/pensionscheme/156.jpg",
      caption:
        'നിംസ് മെഡിസിറ്റി നടത്തിവരുന്ന "നെയ്യാറ്റിൻകര പെൻഷൻ പ്ളാൻ ഗുണഭോക്താക്കളായ കുട്ടികൾക്ക്  തൊഴിൽ പരിശീലന പരിപാടി വിവിധ കലാപരിപാടികൾ അവതരിപ്പിച്ചും മൽസരങ്ങൾ നടത്തിക്കൊണ്ടും ആരംഭിച്ചിരിക്കുന്നു. നിംസ് മെഡിസിറ്റി ജനറൽ മാനേജർ ഡോ.കെ.എ. സജു സ്വാഗതം ആശംസിച്ചു . ജോയിന്റ് സയറക്ടർ ഓഫ് മെഡിക്കൽ എഡുക്കേഷൻ ഡോ. അനിത ബാലൻ ചടങ്ങ് ഉദ്ഘാടനം ചെയ്തു സംസാരിച്ചു. ഭിന്നശേഷി കുട്ടികൾക്കും കുടുംബത്തിനും താങ്ങായി മാറുകയാണ് ഇത്തരം പദ്ധതികളെന്നും ഇത്തരത്തിൽ മാതൃകാ പ്രവർത്തനം നടത്തുന്ന നിംസ് മെഡിസിറ്റി എംഡി, എം .എസ് .ഫൈസൽഖാൻ  സേവനത്തിന്റെ മാതൃകാ മുഖമായി മാറുകയാണെന്നും പറഞ്ഞു. ചടങ്ങിൽ  നിംസ് സ്പെക്ട്രം ഡയറക്ടറും മുൻ ആരോഗ്യ സർവ്വകലാശാല വൈസ് ചാൻസലറുമായ ഡോ.എം.കെ.സി നായർ മുഖ്യ  പ്രഭാഷണം നടത്തി. നെയ്യാറ്റിൻകര നിംസ് ഫിസിക്കൽ മെഡിസിൻ വിഭാഗം മേധാവി ഡോ.ജിം ഗോപാല കൃഷ്ണൻ കുട്ടികൾക്ക് ഫിസിയോ തെറാപ്പിയുടെ വിശദീകരണവും പരിശോധനയും നടത്തി.  പീടിയാട്രിക് നൂറോളജിസ്റ്റ് ഡോ. കുഞ്ഞുമുഹമ്മദ്, ജറിയാട്രിക് കോഡിനേറ്റർ കെ.ആർ രേണു. പോളിയോ ഹോം മുൻ പ്രോജക്ട് കോഡിനേറ്റർ  ബോബി ,  സ്പെഷ്യൽ എഡുകേറ്റർ ശ്രീ നോബിൾ മില്ലർ തുടങ്ങിയവർ ചടങ്ങിൽ ആശംസ അർപ്പിച്ചു. നിംസ്നഴ്സിങ് കോളേജ് വൈസ് പ്രിൻസിപ്പൽ ശ്രീമതി. ജോസ് ഫിൻ വിനിത കൃതജ്ഞത പറഞ്ഞു. സ്പെഷൽ എഡുകേറ്റർമാരായ ശ്രീമതി പ്രിൻസ് മോൾ , ശ്രീമതി സിമി,  സ്പെക്ട്രം കോഡിനേറ്റർ ശ്രീ അബ്ദുൾ റിഫായി,നിംസ് സ്പെക്ട്രം സീനിയർ തെറാപ്പിസ്റ്റ് ശ്രീമതി സ്വപ്ന, നഴ്സിംഗ് കൗസിലർ അശ്വതി . ഓക്കു പേഷൻ തെറാപ്പിസ്റ്റ് മെർലിൻ തുടങ്ങിയർ പദ്ധതി വിജയകരമാക്കുന്നതിന് സജീവപങ്കാളിത്തം വഹിച്ചു.',
      thumb: "assets/img/pensionscheme/156.jpg",
    },
    {
      src: "assets/img/pensionscheme/157.jpg",
      caption:
        'നിംസ് മെഡിസിറ്റി നടത്തിവരുന്ന "നെയ്യാറ്റിൻകര പെൻഷൻ പ്ളാൻ ഗുണഭോക്താക്കളായ കുട്ടികൾക്ക്  തൊഴിൽ പരിശീലന പരിപാടി വിവിധ കലാപരിപാടികൾ അവതരിപ്പിച്ചും മൽസരങ്ങൾ നടത്തിക്കൊണ്ടും ആരംഭിച്ചിരിക്കുന്നു. നിംസ് മെഡിസിറ്റി ജനറൽ മാനേജർ ഡോ.കെ.എ. സജു സ്വാഗതം ആശംസിച്ചു . ജോയിന്റ് സയറക്ടർ ഓഫ് മെഡിക്കൽ എഡുക്കേഷൻ ഡോ. അനിത ബാലൻ ചടങ്ങ് ഉദ്ഘാടനം ചെയ്തു സംസാരിച്ചു. ഭിന്നശേഷി കുട്ടികൾക്കും കുടുംബത്തിനും താങ്ങായി മാറുകയാണ് ഇത്തരം പദ്ധതികളെന്നും ഇത്തരത്തിൽ മാതൃകാ പ്രവർത്തനം നടത്തുന്ന നിംസ് മെഡിസിറ്റി എംഡി, എം .എസ് .ഫൈസൽഖാൻ  സേവനത്തിന്റെ മാതൃകാ മുഖമായി മാറുകയാണെന്നും പറഞ്ഞു. ചടങ്ങിൽ  നിംസ് സ്പെക്ട്രം ഡയറക്ടറും മുൻ ആരോഗ്യ സർവ്വകലാശാല വൈസ് ചാൻസലറുമായ ഡോ.എം.കെ.സി നായർ മുഖ്യ  പ്രഭാഷണം നടത്തി. നെയ്യാറ്റിൻകര നിംസ് ഫിസിക്കൽ മെഡിസിൻ വിഭാഗം മേധാവി ഡോ.ജിം ഗോപാല കൃഷ്ണൻ കുട്ടികൾക്ക് ഫിസിയോ തെറാപ്പിയുടെ വിശദീകരണവും പരിശോധനയും നടത്തി.  പീടിയാട്രിക് നൂറോളജിസ്റ്റ് ഡോ. കുഞ്ഞുമുഹമ്മദ്, ജറിയാട്രിക് കോഡിനേറ്റർ കെ.ആർ രേണു. പോളിയോ ഹോം മുൻ പ്രോജക്ട് കോഡിനേറ്റർ  ബോബി ,  സ്പെഷ്യൽ എഡുകേറ്റർ ശ്രീ നോബിൾ മില്ലർ തുടങ്ങിയവർ ചടങ്ങിൽ ആശംസ അർപ്പിച്ചു. നിംസ്നഴ്സിങ് കോളേജ് വൈസ് പ്രിൻസിപ്പൽ ശ്രീമതി. ജോസ് ഫിൻ വിനിത കൃതജ്ഞത പറഞ്ഞു. സ്പെഷൽ എഡുകേറ്റർമാരായ ശ്രീമതി പ്രിൻസ് മോൾ , ശ്രീമതി സിമി,  സ്പെക്ട്രം കോഡിനേറ്റർ ശ്രീ അബ്ദുൾ റിഫായി,നിംസ് സ്പെക്ട്രം സീനിയർ തെറാപ്പിസ്റ്റ് ശ്രീമതി സ്വപ്ന, നഴ്സിംഗ് കൗസിലർ അശ്വതി . ഓക്കു പേഷൻ തെറാപ്പിസ്റ്റ് മെർലിൻ തുടങ്ങിയർ പദ്ധതി വിജയകരമാക്കുന്നതിന് സജീവപങ്കാളിത്തം വഹിച്ചു.',
      thumb: "assets/img/pensionscheme/157.jpg",
    },
    {
      src: "assets/img/pensionscheme/158.jpg",
      caption:
        'നിംസ് മെഡിസിറ്റി നടത്തിവരുന്ന "നെയ്യാറ്റിൻകര പെൻഷൻ പ്ളാൻ ഗുണഭോക്താക്കളായ കുട്ടികൾക്ക്  തൊഴിൽ പരിശീലന പരിപാടി വിവിധ കലാപരിപാടികൾ അവതരിപ്പിച്ചും മൽസരങ്ങൾ നടത്തിക്കൊണ്ടും ആരംഭിച്ചിരിക്കുന്നു. നിംസ് മെഡിസിറ്റി ജനറൽ മാനേജർ ഡോ.കെ.എ. സജു സ്വാഗതം ആശംസിച്ചു . ജോയിന്റ് സയറക്ടർ ഓഫ് മെഡിക്കൽ എഡുക്കേഷൻ ഡോ. അനിത ബാലൻ ചടങ്ങ് ഉദ്ഘാടനം ചെയ്തു സംസാരിച്ചു. ഭിന്നശേഷി കുട്ടികൾക്കും കുടുംബത്തിനും താങ്ങായി മാറുകയാണ് ഇത്തരം പദ്ധതികളെന്നും ഇത്തരത്തിൽ മാതൃകാ പ്രവർത്തനം നടത്തുന്ന നിംസ് മെഡിസിറ്റി എംഡി, എം .എസ് .ഫൈസൽഖാൻ  സേവനത്തിന്റെ മാതൃകാ മുഖമായി മാറുകയാണെന്നും പറഞ്ഞു. ചടങ്ങിൽ  നിംസ് സ്പെക്ട്രം ഡയറക്ടറും മുൻ ആരോഗ്യ സർവ്വകലാശാല വൈസ് ചാൻസലറുമായ ഡോ.എം.കെ.സി നായർ മുഖ്യ  പ്രഭാഷണം നടത്തി. നെയ്യാറ്റിൻകര നിംസ് ഫിസിക്കൽ മെഡിസിൻ വിഭാഗം മേധാവി ഡോ.ജിം ഗോപാല കൃഷ്ണൻ കുട്ടികൾക്ക് ഫിസിയോ തെറാപ്പിയുടെ വിശദീകരണവും പരിശോധനയും നടത്തി.  പീടിയാട്രിക് നൂറോളജിസ്റ്റ് ഡോ. കുഞ്ഞുമുഹമ്മദ്, ജറിയാട്രിക് കോഡിനേറ്റർ കെ.ആർ രേണു. പോളിയോ ഹോം മുൻ പ്രോജക്ട് കോഡിനേറ്റർ  ബോബി ,  സ്പെഷ്യൽ എഡുകേറ്റർ ശ്രീ നോബിൾ മില്ലർ തുടങ്ങിയവർ ചടങ്ങിൽ ആശംസ അർപ്പിച്ചു. നിംസ്നഴ്സിങ് കോളേജ് വൈസ് പ്രിൻസിപ്പൽ ശ്രീമതി. ജോസ് ഫിൻ വിനിത കൃതജ്ഞത പറഞ്ഞു. സ്പെഷൽ എഡുകേറ്റർമാരായ ശ്രീമതി പ്രിൻസ് മോൾ , ശ്രീമതി സിമി,  സ്പെക്ട്രം കോഡിനേറ്റർ ശ്രീ അബ്ദുൾ റിഫായി,നിംസ് സ്പെക്ട്രം സീനിയർ തെറാപ്പിസ്റ്റ് ശ്രീമതി സ്വപ്ന, നഴ്സിംഗ് കൗസിലർ അശ്വതി . ഓക്കു പേഷൻ തെറാപ്പിസ്റ്റ് മെർലിൻ തുടങ്ങിയർ പദ്ധതി വിജയകരമാക്കുന്നതിന് സജീവപങ്കാളിത്തം വഹിച്ചു.',
      thumb: "assets/img/pensionscheme/158.jpg",
    },
    {
      src: "assets/img/pensionscheme/159.jpg",
      caption:
        'നിംസ് മെഡിസിറ്റി നടത്തിവരുന്ന "നെയ്യാറ്റിൻകര പെൻഷൻ പ്ളാൻ ഗുണഭോക്താക്കളായ കുട്ടികൾക്ക്  തൊഴിൽ പരിശീലന പരിപാടി വിവിധ കലാപരിപാടികൾ അവതരിപ്പിച്ചും മൽസരങ്ങൾ നടത്തിക്കൊണ്ടും ആരംഭിച്ചിരിക്കുന്നു. നിംസ് മെഡിസിറ്റി ജനറൽ മാനേജർ ഡോ.കെ.എ. സജു സ്വാഗതം ആശംസിച്ചു . ജോയിന്റ് സയറക്ടർ ഓഫ് മെഡിക്കൽ എഡുക്കേഷൻ ഡോ. അനിത ബാലൻ ചടങ്ങ് ഉദ്ഘാടനം ചെയ്തു സംസാരിച്ചു. ഭിന്നശേഷി കുട്ടികൾക്കും കുടുംബത്തിനും താങ്ങായി മാറുകയാണ് ഇത്തരം പദ്ധതികളെന്നും ഇത്തരത്തിൽ മാതൃകാ പ്രവർത്തനം നടത്തുന്ന നിംസ് മെഡിസിറ്റി എംഡി, എം .എസ് .ഫൈസൽഖാൻ  സേവനത്തിന്റെ മാതൃകാ മുഖമായി മാറുകയാണെന്നും പറഞ്ഞു. ചടങ്ങിൽ  നിംസ് സ്പെക്ട്രം ഡയറക്ടറും മുൻ ആരോഗ്യ സർവ്വകലാശാല വൈസ് ചാൻസലറുമായ ഡോ.എം.കെ.സി നായർ മുഖ്യ  പ്രഭാഷണം നടത്തി. നെയ്യാറ്റിൻകര നിംസ് ഫിസിക്കൽ മെഡിസിൻ വിഭാഗം മേധാവി ഡോ.ജിം ഗോപാല കൃഷ്ണൻ കുട്ടികൾക്ക് ഫിസിയോ തെറാപ്പിയുടെ വിശദീകരണവും പരിശോധനയും നടത്തി.  പീടിയാട്രിക് നൂറോളജിസ്റ്റ് ഡോ. കുഞ്ഞുമുഹമ്മദ്, ജറിയാട്രിക് കോഡിനേറ്റർ കെ.ആർ രേണു. പോളിയോ ഹോം മുൻ പ്രോജക്ട് കോഡിനേറ്റർ  ബോബി ,  സ്പെഷ്യൽ എഡുകേറ്റർ ശ്രീ നോബിൾ മില്ലർ തുടങ്ങിയവർ ചടങ്ങിൽ ആശംസ അർപ്പിച്ചു. നിംസ്നഴ്സിങ് കോളേജ് വൈസ് പ്രിൻസിപ്പൽ ശ്രീമതി. ജോസ് ഫിൻ വിനിത കൃതജ്ഞത പറഞ്ഞു. സ്പെഷൽ എഡുകേറ്റർമാരായ ശ്രീമതി പ്രിൻസ് മോൾ , ശ്രീമതി സിമി,  സ്പെക്ട്രം കോഡിനേറ്റർ ശ്രീ അബ്ദുൾ റിഫായി,നിംസ് സ്പെക്ട്രം സീനിയർ തെറാപ്പിസ്റ്റ് ശ്രീമതി സ്വപ്ന, നഴ്സിംഗ് കൗസിലർ അശ്വതി . ഓക്കു പേഷൻ തെറാപ്പിസ്റ്റ് മെർലിൻ തുടങ്ങിയർ പദ്ധതി വിജയകരമാക്കുന്നതിന് സജീവപങ്കാളിത്തം വഹിച്ചു.',
      thumb: "assets/img/pensionscheme/159.jpg",
    },
    {
      src: "assets/img/pensionscheme/160.jpg",
      caption:
        'നിംസ് മെഡിസിറ്റി നടത്തിവരുന്ന "നെയ്യാറ്റിൻകര പെൻഷൻ പ്ളാൻ ഗുണഭോക്താക്കളായ കുട്ടികൾക്ക്  തൊഴിൽ പരിശീലന പരിപാടി വിവിധ കലാപരിപാടികൾ അവതരിപ്പിച്ചും മൽസരങ്ങൾ നടത്തിക്കൊണ്ടും ആരംഭിച്ചിരിക്കുന്നു. നിംസ് മെഡിസിറ്റി ജനറൽ മാനേജർ ഡോ.കെ.എ. സജു സ്വാഗതം ആശംസിച്ചു . ജോയിന്റ് സയറക്ടർ ഓഫ് മെഡിക്കൽ എഡുക്കേഷൻ ഡോ. അനിത ബാലൻ ചടങ്ങ് ഉദ്ഘാടനം ചെയ്തു സംസാരിച്ചു. ഭിന്നശേഷി കുട്ടികൾക്കും കുടുംബത്തിനും താങ്ങായി മാറുകയാണ് ഇത്തരം പദ്ധതികളെന്നും ഇത്തരത്തിൽ മാതൃകാ പ്രവർത്തനം നടത്തുന്ന നിംസ് മെഡിസിറ്റി എംഡി, എം .എസ് .ഫൈസൽഖാൻ  സേവനത്തിന്റെ മാതൃകാ മുഖമായി മാറുകയാണെന്നും പറഞ്ഞു. ചടങ്ങിൽ  നിംസ് സ്പെക്ട്രം ഡയറക്ടറും മുൻ ആരോഗ്യ സർവ്വകലാശാല വൈസ് ചാൻസലറുമായ ഡോ.എം.കെ.സി നായർ മുഖ്യ  പ്രഭാഷണം നടത്തി. നെയ്യാറ്റിൻകര നിംസ് ഫിസിക്കൽ മെഡിസിൻ വിഭാഗം മേധാവി ഡോ.ജിം ഗോപാല കൃഷ്ണൻ കുട്ടികൾക്ക് ഫിസിയോ തെറാപ്പിയുടെ വിശദീകരണവും പരിശോധനയും നടത്തി.  പീടിയാട്രിക് നൂറോളജിസ്റ്റ് ഡോ. കുഞ്ഞുമുഹമ്മദ്, ജറിയാട്രിക് കോഡിനേറ്റർ കെ.ആർ രേണു. പോളിയോ ഹോം മുൻ പ്രോജക്ട് കോഡിനേറ്റർ  ബോബി ,  സ്പെഷ്യൽ എഡുകേറ്റർ ശ്രീ നോബിൾ മില്ലർ തുടങ്ങിയവർ ചടങ്ങിൽ ആശംസ അർപ്പിച്ചു. നിംസ്നഴ്സിങ് കോളേജ് വൈസ് പ്രിൻസിപ്പൽ ശ്രീമതി. ജോസ് ഫിൻ വിനിത കൃതജ്ഞത പറഞ്ഞു. സ്പെഷൽ എഡുകേറ്റർമാരായ ശ്രീമതി പ്രിൻസ് മോൾ , ശ്രീമതി സിമി,  സ്പെക്ട്രം കോഡിനേറ്റർ ശ്രീ അബ്ദുൾ റിഫായി,നിംസ് സ്പെക്ട്രം സീനിയർ തെറാപ്പിസ്റ്റ് ശ്രീമതി സ്വപ്ന, നഴ്സിംഗ് കൗസിലർ അശ്വതി . ഓക്കു പേഷൻ തെറാപ്പിസ്റ്റ് മെർലിൻ തുടങ്ങിയർ പദ്ധതി വിജയകരമാക്കുന്നതിന് സജീവപങ്കാളിത്തം വഹിച്ചു.',
      thumb: "assets/img/pensionscheme/160.jpg",
    },
    {
      src: "assets/img/pensionscheme/161.jpg",
      caption:
        'നിംസ് മെഡിസിറ്റി നടത്തിവരുന്ന "നെയ്യാറ്റിൻകര പെൻഷൻ പ്ളാൻ ഗുണഭോക്താക്കളായ കുട്ടികൾക്ക്  തൊഴിൽ പരിശീലന പരിപാടി വിവിധ കലാപരിപാടികൾ അവതരിപ്പിച്ചും മൽസരങ്ങൾ നടത്തിക്കൊണ്ടും ആരംഭിച്ചിരിക്കുന്നു. നിംസ് മെഡിസിറ്റി ജനറൽ മാനേജർ ഡോ.കെ.എ. സജു സ്വാഗതം ആശംസിച്ചു . ജോയിന്റ് സയറക്ടർ ഓഫ് മെഡിക്കൽ എഡുക്കേഷൻ ഡോ. അനിത ബാലൻ ചടങ്ങ് ഉദ്ഘാടനം ചെയ്തു സംസാരിച്ചു. ഭിന്നശേഷി കുട്ടികൾക്കും കുടുംബത്തിനും താങ്ങായി മാറുകയാണ് ഇത്തരം പദ്ധതികളെന്നും ഇത്തരത്തിൽ മാതൃകാ പ്രവർത്തനം നടത്തുന്ന നിംസ് മെഡിസിറ്റി എംഡി, എം .എസ് .ഫൈസൽഖാൻ  സേവനത്തിന്റെ മാതൃകാ മുഖമായി മാറുകയാണെന്നും പറഞ്ഞു. ചടങ്ങിൽ  നിംസ് സ്പെക്ട്രം ഡയറക്ടറും മുൻ ആരോഗ്യ സർവ്വകലാശാല വൈസ് ചാൻസലറുമായ ഡോ.എം.കെ.സി നായർ മുഖ്യ  പ്രഭാഷണം നടത്തി. നെയ്യാറ്റിൻകര നിംസ് ഫിസിക്കൽ മെഡിസിൻ വിഭാഗം മേധാവി ഡോ.ജിം ഗോപാല കൃഷ്ണൻ കുട്ടികൾക്ക് ഫിസിയോ തെറാപ്പിയുടെ വിശദീകരണവും പരിശോധനയും നടത്തി.  പീടിയാട്രിക് നൂറോളജിസ്റ്റ് ഡോ. കുഞ്ഞുമുഹമ്മദ്, ജറിയാട്രിക് കോഡിനേറ്റർ കെ.ആർ രേണു. പോളിയോ ഹോം മുൻ പ്രോജക്ട് കോഡിനേറ്റർ  ബോബി ,  സ്പെഷ്യൽ എഡുകേറ്റർ ശ്രീ നോബിൾ മില്ലർ തുടങ്ങിയവർ ചടങ്ങിൽ ആശംസ അർപ്പിച്ചു. നിംസ്നഴ്സിങ് കോളേജ് വൈസ് പ്രിൻസിപ്പൽ ശ്രീമതി. ജോസ് ഫിൻ വിനിത കൃതജ്ഞത പറഞ്ഞു. സ്പെഷൽ എഡുകേറ്റർമാരായ ശ്രീമതി പ്രിൻസ് മോൾ , ശ്രീമതി സിമി,  സ്പെക്ട്രം കോഡിനേറ്റർ ശ്രീ അബ്ദുൾ റിഫായി,നിംസ് സ്പെക്ട്രം സീനിയർ തെറാപ്പിസ്റ്റ് ശ്രീമതി സ്വപ്ന, നഴ്സിംഗ് കൗസിലർ അശ്വതി . ഓക്കു പേഷൻ തെറാപ്പിസ്റ്റ് മെർലിൻ തുടങ്ങിയർ പദ്ധതി വിജയകരമാക്കുന്നതിന് സജീവപങ്കാളിത്തം വഹിച്ചു.',
      thumb: "assets/img/pensionscheme/161.jpg",
    },
    {
      src: "assets/img/pensionscheme/162.jpg",
      caption:
        'നിംസ് മെഡിസിറ്റി നടത്തിവരുന്ന "നെയ്യാറ്റിൻകര പെൻഷൻ പ്ളാൻ ഗുണഭോക്താക്കളായ കുട്ടികൾക്ക്  തൊഴിൽ പരിശീലന പരിപാടി വിവിധ കലാപരിപാടികൾ അവതരിപ്പിച്ചും മൽസരങ്ങൾ നടത്തിക്കൊണ്ടും ആരംഭിച്ചിരിക്കുന്നു. നിംസ് മെഡിസിറ്റി ജനറൽ മാനേജർ ഡോ.കെ.എ. സജു സ്വാഗതം ആശംസിച്ചു . ജോയിന്റ് സയറക്ടർ ഓഫ് മെഡിക്കൽ എഡുക്കേഷൻ ഡോ. അനിത ബാലൻ ചടങ്ങ് ഉദ്ഘാടനം ചെയ്തു സംസാരിച്ചു. ഭിന്നശേഷി കുട്ടികൾക്കും കുടുംബത്തിനും താങ്ങായി മാറുകയാണ് ഇത്തരം പദ്ധതികളെന്നും ഇത്തരത്തിൽ മാതൃകാ പ്രവർത്തനം നടത്തുന്ന നിംസ് മെഡിസിറ്റി എംഡി, എം .എസ് .ഫൈസൽഖാൻ  സേവനത്തിന്റെ മാതൃകാ മുഖമായി മാറുകയാണെന്നും പറഞ്ഞു. ചടങ്ങിൽ  നിംസ് സ്പെക്ട്രം ഡയറക്ടറും മുൻ ആരോഗ്യ സർവ്വകലാശാല വൈസ് ചാൻസലറുമായ ഡോ.എം.കെ.സി നായർ മുഖ്യ  പ്രഭാഷണം നടത്തി. നെയ്യാറ്റിൻകര നിംസ് ഫിസിക്കൽ മെഡിസിൻ വിഭാഗം മേധാവി ഡോ.ജിം ഗോപാല കൃഷ്ണൻ കുട്ടികൾക്ക് ഫിസിയോ തെറാപ്പിയുടെ വിശദീകരണവും പരിശോധനയും നടത്തി.  പീടിയാട്രിക് നൂറോളജിസ്റ്റ് ഡോ. കുഞ്ഞുമുഹമ്മദ്, ജറിയാട്രിക് കോഡിനേറ്റർ കെ.ആർ രേണു. പോളിയോ ഹോം മുൻ പ്രോജക്ട് കോഡിനേറ്റർ  ബോബി ,  സ്പെഷ്യൽ എഡുകേറ്റർ ശ്രീ നോബിൾ മില്ലർ തുടങ്ങിയവർ ചടങ്ങിൽ ആശംസ അർപ്പിച്ചു. നിംസ്നഴ്സിങ് കോളേജ് വൈസ് പ്രിൻസിപ്പൽ ശ്രീമതി. ജോസ് ഫിൻ വിനിത കൃതജ്ഞത പറഞ്ഞു. സ്പെഷൽ എഡുകേറ്റർമാരായ ശ്രീമതി പ്രിൻസ് മോൾ , ശ്രീമതി സിമി,  സ്പെക്ട്രം കോഡിനേറ്റർ ശ്രീ അബ്ദുൾ റിഫായി,നിംസ് സ്പെക്ട്രം സീനിയർ തെറാപ്പിസ്റ്റ് ശ്രീമതി സ്വപ്ന, നഴ്സിംഗ് കൗസിലർ അശ്വതി . ഓക്കു പേഷൻ തെറാപ്പിസ്റ്റ് മെർലിൻ തുടങ്ങിയർ പദ്ധതി വിജയകരമാക്കുന്നതിന് സജീവപങ്കാളിത്തം വഹിച്ചു.',
      thumb: "assets/img/pensionscheme/162.jpg",
    },
    {
      src: "assets/img/pensionscheme/163.jpg",
      caption:
        'നിംസ് മെഡിസിറ്റി നടത്തിവരുന്ന "നെയ്യാറ്റിൻകര പെൻഷൻ പ്ളാൻ ഗുണഭോക്താക്കളായ കുട്ടികൾക്ക്  തൊഴിൽ പരിശീലന പരിപാടി വിവിധ കലാപരിപാടികൾ അവതരിപ്പിച്ചും മൽസരങ്ങൾ നടത്തിക്കൊണ്ടും ആരംഭിച്ചിരിക്കുന്നു. നിംസ് മെഡിസിറ്റി ജനറൽ മാനേജർ ഡോ.കെ.എ. സജു സ്വാഗതം ആശംസിച്ചു . ജോയിന്റ് സയറക്ടർ ഓഫ് മെഡിക്കൽ എഡുക്കേഷൻ ഡോ. അനിത ബാലൻ ചടങ്ങ് ഉദ്ഘാടനം ചെയ്തു സംസാരിച്ചു. ഭിന്നശേഷി കുട്ടികൾക്കും കുടുംബത്തിനും താങ്ങായി മാറുകയാണ് ഇത്തരം പദ്ധതികളെന്നും ഇത്തരത്തിൽ മാതൃകാ പ്രവർത്തനം നടത്തുന്ന നിംസ് മെഡിസിറ്റി എംഡി, എം .എസ് .ഫൈസൽഖാൻ  സേവനത്തിന്റെ മാതൃകാ മുഖമായി മാറുകയാണെന്നും പറഞ്ഞു. ചടങ്ങിൽ  നിംസ് സ്പെക്ട്രം ഡയറക്ടറും മുൻ ആരോഗ്യ സർവ്വകലാശാല വൈസ് ചാൻസലറുമായ ഡോ.എം.കെ.സി നായർ മുഖ്യ  പ്രഭാഷണം നടത്തി. നെയ്യാറ്റിൻകര നിംസ് ഫിസിക്കൽ മെഡിസിൻ വിഭാഗം മേധാവി ഡോ.ജിം ഗോപാല കൃഷ്ണൻ കുട്ടികൾക്ക് ഫിസിയോ തെറാപ്പിയുടെ വിശദീകരണവും പരിശോധനയും നടത്തി.  പീടിയാട്രിക് നൂറോളജിസ്റ്റ് ഡോ. കുഞ്ഞുമുഹമ്മദ്, ജറിയാട്രിക് കോഡിനേറ്റർ കെ.ആർ രേണു. പോളിയോ ഹോം മുൻ പ്രോജക്ട് കോഡിനേറ്റർ  ബോബി ,  സ്പെഷ്യൽ എഡുകേറ്റർ ശ്രീ നോബിൾ മില്ലർ തുടങ്ങിയവർ ചടങ്ങിൽ ആശംസ അർപ്പിച്ചു. നിംസ്നഴ്സിങ് കോളേജ് വൈസ് പ്രിൻസിപ്പൽ ശ്രീമതി. ജോസ് ഫിൻ വിനിത കൃതജ്ഞത പറഞ്ഞു. സ്പെഷൽ എഡുകേറ്റർമാരായ ശ്രീമതി പ്രിൻസ് മോൾ , ശ്രീമതി സിമി,  സ്പെക്ട്രം കോഡിനേറ്റർ ശ്രീ അബ്ദുൾ റിഫായി,നിംസ് സ്പെക്ട്രം സീനിയർ തെറാപ്പിസ്റ്റ് ശ്രീമതി സ്വപ്ന, നഴ്സിംഗ് കൗസിലർ അശ്വതി . ഓക്കു പേഷൻ തെറാപ്പിസ്റ്റ് മെർലിൻ തുടങ്ങിയർ പദ്ധതി വിജയകരമാക്കുന്നതിന് സജീവപങ്കാളിത്തം വഹിച്ചു.',
      thumb: "assets/img/pensionscheme/163.jpg",
    },
    {
      src: "assets/img/pensionscheme/164.jpg",
      caption:
        'നിംസ് മെഡിസിറ്റി നടത്തിവരുന്ന "നെയ്യാറ്റിൻകര പെൻഷൻ പ്ളാൻ ഗുണഭോക്താക്കളായ കുട്ടികൾക്ക്  തൊഴിൽ പരിശീലന പരിപാടി വിവിധ കലാപരിപാടികൾ അവതരിപ്പിച്ചും മൽസരങ്ങൾ നടത്തിക്കൊണ്ടും ആരംഭിച്ചിരിക്കുന്നു. നിംസ് മെഡിസിറ്റി ജനറൽ മാനേജർ ഡോ.കെ.എ. സജു സ്വാഗതം ആശംസിച്ചു . ജോയിന്റ് സയറക്ടർ ഓഫ് മെഡിക്കൽ എഡുക്കേഷൻ ഡോ. അനിത ബാലൻ ചടങ്ങ് ഉദ്ഘാടനം ചെയ്തു സംസാരിച്ചു. ഭിന്നശേഷി കുട്ടികൾക്കും കുടുംബത്തിനും താങ്ങായി മാറുകയാണ് ഇത്തരം പദ്ധതികളെന്നും ഇത്തരത്തിൽ മാതൃകാ പ്രവർത്തനം നടത്തുന്ന നിംസ് മെഡിസിറ്റി എംഡി, എം .എസ് .ഫൈസൽഖാൻ  സേവനത്തിന്റെ മാതൃകാ മുഖമായി മാറുകയാണെന്നും പറഞ്ഞു. ചടങ്ങിൽ  നിംസ് സ്പെക്ട്രം ഡയറക്ടറും മുൻ ആരോഗ്യ സർവ്വകലാശാല വൈസ് ചാൻസലറുമായ ഡോ.എം.കെ.സി നായർ മുഖ്യ  പ്രഭാഷണം നടത്തി. നെയ്യാറ്റിൻകര നിംസ് ഫിസിക്കൽ മെഡിസിൻ വിഭാഗം മേധാവി ഡോ.ജിം ഗോപാല കൃഷ്ണൻ കുട്ടികൾക്ക് ഫിസിയോ തെറാപ്പിയുടെ വിശദീകരണവും പരിശോധനയും നടത്തി.  പീടിയാട്രിക് നൂറോളജിസ്റ്റ് ഡോ. കുഞ്ഞുമുഹമ്മദ്, ജറിയാട്രിക് കോഡിനേറ്റർ കെ.ആർ രേണു. പോളിയോ ഹോം മുൻ പ്രോജക്ട് കോഡിനേറ്റർ  ബോബി ,  സ്പെഷ്യൽ എഡുകേറ്റർ ശ്രീ നോബിൾ മില്ലർ തുടങ്ങിയവർ ചടങ്ങിൽ ആശംസ അർപ്പിച്ചു. നിംസ്നഴ്സിങ് കോളേജ് വൈസ് പ്രിൻസിപ്പൽ ശ്രീമതി. ജോസ് ഫിൻ വിനിത കൃതജ്ഞത പറഞ്ഞു. സ്പെഷൽ എഡുകേറ്റർമാരായ ശ്രീമതി പ്രിൻസ് മോൾ , ശ്രീമതി സിമി,  സ്പെക്ട്രം കോഡിനേറ്റർ ശ്രീ അബ്ദുൾ റിഫായി,നിംസ് സ്പെക്ട്രം സീനിയർ തെറാപ്പിസ്റ്റ് ശ്രീമതി സ്വപ്ന, നഴ്സിംഗ് കൗസിലർ അശ്വതി . ഓക്കു പേഷൻ തെറാപ്പിസ്റ്റ് മെർലിൻ തുടങ്ങിയർ പദ്ധതി വിജയകരമാക്കുന്നതിന് സജീവപങ്കാളിത്തം വഹിച്ചു.',
      thumb: "assets/img/pensionscheme/164.jpg",
    },
    {
      src: "assets/img/pensionscheme/165.jpg",
      caption:
        'നിംസ് മെഡിസിറ്റി നടത്തിവരുന്ന "നെയ്യാറ്റിൻകര പെൻഷൻ പ്ളാൻ ഗുണഭോക്താക്കളായ കുട്ടികൾക്ക്  തൊഴിൽ പരിശീലന പരിപാടി വിവിധ കലാപരിപാടികൾ അവതരിപ്പിച്ചും മൽസരങ്ങൾ നടത്തിക്കൊണ്ടും ആരംഭിച്ചിരിക്കുന്നു. നിംസ് മെഡിസിറ്റി ജനറൽ മാനേജർ ഡോ.കെ.എ. സജു സ്വാഗതം ആശംസിച്ചു . ജോയിന്റ് സയറക്ടർ ഓഫ് മെഡിക്കൽ എഡുക്കേഷൻ ഡോ. അനിത ബാലൻ ചടങ്ങ് ഉദ്ഘാടനം ചെയ്തു സംസാരിച്ചു. ഭിന്നശേഷി കുട്ടികൾക്കും കുടുംബത്തിനും താങ്ങായി മാറുകയാണ് ഇത്തരം പദ്ധതികളെന്നും ഇത്തരത്തിൽ മാതൃകാ പ്രവർത്തനം നടത്തുന്ന നിംസ് മെഡിസിറ്റി എംഡി, എം .എസ് .ഫൈസൽഖാൻ  സേവനത്തിന്റെ മാതൃകാ മുഖമായി മാറുകയാണെന്നും പറഞ്ഞു. ചടങ്ങിൽ  നിംസ് സ്പെക്ട്രം ഡയറക്ടറും മുൻ ആരോഗ്യ സർവ്വകലാശാല വൈസ് ചാൻസലറുമായ ഡോ.എം.കെ.സി നായർ മുഖ്യ  പ്രഭാഷണം നടത്തി. നെയ്യാറ്റിൻകര നിംസ് ഫിസിക്കൽ മെഡിസിൻ വിഭാഗം മേധാവി ഡോ.ജിം ഗോപാല കൃഷ്ണൻ കുട്ടികൾക്ക് ഫിസിയോ തെറാപ്പിയുടെ വിശദീകരണവും പരിശോധനയും നടത്തി.  പീടിയാട്രിക് നൂറോളജിസ്റ്റ് ഡോ. കുഞ്ഞുമുഹമ്മദ്, ജറിയാട്രിക് കോഡിനേറ്റർ കെ.ആർ രേണു. പോളിയോ ഹോം മുൻ പ്രോജക്ട് കോഡിനേറ്റർ  ബോബി ,  സ്പെഷ്യൽ എഡുകേറ്റർ ശ്രീ നോബിൾ മില്ലർ തുടങ്ങിയവർ ചടങ്ങിൽ ആശംസ അർപ്പിച്ചു. നിംസ്നഴ്സിങ് കോളേജ് വൈസ് പ്രിൻസിപ്പൽ ശ്രീമതി. ജോസ് ഫിൻ വിനിത കൃതജ്ഞത പറഞ്ഞു. സ്പെഷൽ എഡുകേറ്റർമാരായ ശ്രീമതി പ്രിൻസ് മോൾ , ശ്രീമതി സിമി,  സ്പെക്ട്രം കോഡിനേറ്റർ ശ്രീ അബ്ദുൾ റിഫായി,നിംസ് സ്പെക്ട്രം സീനിയർ തെറാപ്പിസ്റ്റ് ശ്രീമതി സ്വപ്ന, നഴ്സിംഗ് കൗസിലർ അശ്വതി . ഓക്കു പേഷൻ തെറാപ്പിസ്റ്റ് മെർലിൻ തുടങ്ങിയർ പദ്ധതി വിജയകരമാക്കുന്നതിന് സജീവപങ്കാളിത്തം വഹിച്ചു.',
      thumb: "assets/img/pensionscheme/165.jpg",
    },
    {
      src: "assets/img/pensionscheme/166.jpg",
      caption:
        'നിംസ് മെഡിസിറ്റി നടത്തിവരുന്ന "നെയ്യാറ്റിൻകര പെൻഷൻ പ്ളാൻ ഗുണഭോക്താക്കളായ കുട്ടികൾക്ക്  തൊഴിൽ പരിശീലന പരിപാടി വിവിധ കലാപരിപാടികൾ അവതരിപ്പിച്ചും മൽസരങ്ങൾ നടത്തിക്കൊണ്ടും ആരംഭിച്ചിരിക്കുന്നു. നിംസ് മെഡിസിറ്റി ജനറൽ മാനേജർ ഡോ.കെ.എ. സജു സ്വാഗതം ആശംസിച്ചു . ജോയിന്റ് സയറക്ടർ ഓഫ് മെഡിക്കൽ എഡുക്കേഷൻ ഡോ. അനിത ബാലൻ ചടങ്ങ് ഉദ്ഘാടനം ചെയ്തു സംസാരിച്ചു. ഭിന്നശേഷി കുട്ടികൾക്കും കുടുംബത്തിനും താങ്ങായി മാറുകയാണ് ഇത്തരം പദ്ധതികളെന്നും ഇത്തരത്തിൽ മാതൃകാ പ്രവർത്തനം നടത്തുന്ന നിംസ് മെഡിസിറ്റി എംഡി, എം .എസ് .ഫൈസൽഖാൻ  സേവനത്തിന്റെ മാതൃകാ മുഖമായി മാറുകയാണെന്നും പറഞ്ഞു. ചടങ്ങിൽ  നിംസ് സ്പെക്ട്രം ഡയറക്ടറും മുൻ ആരോഗ്യ സർവ്വകലാശാല വൈസ് ചാൻസലറുമായ ഡോ.എം.കെ.സി നായർ മുഖ്യ  പ്രഭാഷണം നടത്തി. നെയ്യാറ്റിൻകര നിംസ് ഫിസിക്കൽ മെഡിസിൻ വിഭാഗം മേധാവി ഡോ.ജിം ഗോപാല കൃഷ്ണൻ കുട്ടികൾക്ക് ഫിസിയോ തെറാപ്പിയുടെ വിശദീകരണവും പരിശോധനയും നടത്തി.  പീടിയാട്രിക് നൂറോളജിസ്റ്റ് ഡോ. കുഞ്ഞുമുഹമ്മദ്, ജറിയാട്രിക് കോഡിനേറ്റർ കെ.ആർ രേണു. പോളിയോ ഹോം മുൻ പ്രോജക്ട് കോഡിനേറ്റർ  ബോബി ,  സ്പെഷ്യൽ എഡുകേറ്റർ ശ്രീ നോബിൾ മില്ലർ തുടങ്ങിയവർ ചടങ്ങിൽ ആശംസ അർപ്പിച്ചു. നിംസ്നഴ്സിങ് കോളേജ് വൈസ് പ്രിൻസിപ്പൽ ശ്രീമതി. ജോസ് ഫിൻ വിനിത കൃതജ്ഞത പറഞ്ഞു. സ്പെഷൽ എഡുകേറ്റർമാരായ ശ്രീമതി പ്രിൻസ് മോൾ , ശ്രീമതി സിമി,  സ്പെക്ട്രം കോഡിനേറ്റർ ശ്രീ അബ്ദുൾ റിഫായി,നിംസ് സ്പെക്ട്രം സീനിയർ തെറാപ്പിസ്റ്റ് ശ്രീമതി സ്വപ്ന, നഴ്സിംഗ് കൗസിലർ അശ്വതി . ഓക്കു പേഷൻ തെറാപ്പിസ്റ്റ് മെർലിൻ തുടങ്ങിയർ പദ്ധതി വിജയകരമാക്കുന്നതിന് സജീവപങ്കാളിത്തം വഹിച്ചു.',
      thumb: "assets/img/pensionscheme/166.jpg",
    },
    {
      src: "assets/img/pensionscheme/167.jpg",
      caption:
        'നിംസ് മെഡിസിറ്റി നടത്തിവരുന്ന "നെയ്യാറ്റിൻകര പെൻഷൻ പ്ളാൻ ഗുണഭോക്താക്കളായ കുട്ടികൾക്ക്  തൊഴിൽ പരിശീലന പരിപാടി വിവിധ കലാപരിപാടികൾ അവതരിപ്പിച്ചും മൽസരങ്ങൾ നടത്തിക്കൊണ്ടും ആരംഭിച്ചിരിക്കുന്നു. നിംസ് മെഡിസിറ്റി ജനറൽ മാനേജർ ഡോ.കെ.എ. സജു സ്വാഗതം ആശംസിച്ചു . ജോയിന്റ് സയറക്ടർ ഓഫ് മെഡിക്കൽ എഡുക്കേഷൻ ഡോ. അനിത ബാലൻ ചടങ്ങ് ഉദ്ഘാടനം ചെയ്തു സംസാരിച്ചു. ഭിന്നശേഷി കുട്ടികൾക്കും കുടുംബത്തിനും താങ്ങായി മാറുകയാണ് ഇത്തരം പദ്ധതികളെന്നും ഇത്തരത്തിൽ മാതൃകാ പ്രവർത്തനം നടത്തുന്ന നിംസ് മെഡിസിറ്റി എംഡി, എം .എസ് .ഫൈസൽഖാൻ  സേവനത്തിന്റെ മാതൃകാ മുഖമായി മാറുകയാണെന്നും പറഞ്ഞു. ചടങ്ങിൽ  നിംസ് സ്പെക്ട്രം ഡയറക്ടറും മുൻ ആരോഗ്യ സർവ്വകലാശാല വൈസ് ചാൻസലറുമായ ഡോ.എം.കെ.സി നായർ മുഖ്യ  പ്രഭാഷണം നടത്തി. നെയ്യാറ്റിൻകര നിംസ് ഫിസിക്കൽ മെഡിസിൻ വിഭാഗം മേധാവി ഡോ.ജിം ഗോപാല കൃഷ്ണൻ കുട്ടികൾക്ക് ഫിസിയോ തെറാപ്പിയുടെ വിശദീകരണവും പരിശോധനയും നടത്തി.  പീടിയാട്രിക് നൂറോളജിസ്റ്റ് ഡോ. കുഞ്ഞുമുഹമ്മദ്, ജറിയാട്രിക് കോഡിനേറ്റർ കെ.ആർ രേണു. പോളിയോ ഹോം മുൻ പ്രോജക്ട് കോഡിനേറ്റർ  ബോബി ,  സ്പെഷ്യൽ എഡുകേറ്റർ ശ്രീ നോബിൾ മില്ലർ തുടങ്ങിയവർ ചടങ്ങിൽ ആശംസ അർപ്പിച്ചു. നിംസ്നഴ്സിങ് കോളേജ് വൈസ് പ്രിൻസിപ്പൽ ശ്രീമതി. ജോസ് ഫിൻ വിനിത കൃതജ്ഞത പറഞ്ഞു. സ്പെഷൽ എഡുകേറ്റർമാരായ ശ്രീമതി പ്രിൻസ് മോൾ , ശ്രീമതി സിമി,  സ്പെക്ട്രം കോഡിനേറ്റർ ശ്രീ അബ്ദുൾ റിഫായി,നിംസ് സ്പെക്ട്രം സീനിയർ തെറാപ്പിസ്റ്റ് ശ്രീമതി സ്വപ്ന, നഴ്സിംഗ് കൗസിലർ അശ്വതി . ഓക്കു പേഷൻ തെറാപ്പിസ്റ്റ് മെർലിൻ തുടങ്ങിയർ പദ്ധതി വിജയകരമാക്കുന്നതിന് സജീവപങ്കാളിത്തം വഹിച്ചു.',
      thumb: "assets/img/pensionscheme/167.jpg",
    },
    {
      src: "assets/img/pensionscheme/168.jpg",
      caption:
        'നിംസ് മെഡിസിറ്റി നടത്തിവരുന്ന "നെയ്യാറ്റിൻകര പെൻഷൻ പ്ളാൻ ഗുണഭോക്താക്കളായ കുട്ടികൾക്ക്  തൊഴിൽ പരിശീലന പരിപാടി വിവിധ കലാപരിപാടികൾ അവതരിപ്പിച്ചും മൽസരങ്ങൾ നടത്തിക്കൊണ്ടും ആരംഭിച്ചിരിക്കുന്നു. നിംസ് മെഡിസിറ്റി ജനറൽ മാനേജർ ഡോ.കെ.എ. സജു സ്വാഗതം ആശംസിച്ചു . ജോയിന്റ് സയറക്ടർ ഓഫ് മെഡിക്കൽ എഡുക്കേഷൻ ഡോ. അനിത ബാലൻ ചടങ്ങ് ഉദ്ഘാടനം ചെയ്തു സംസാരിച്ചു. ഭിന്നശേഷി കുട്ടികൾക്കും കുടുംബത്തിനും താങ്ങായി മാറുകയാണ് ഇത്തരം പദ്ധതികളെന്നും ഇത്തരത്തിൽ മാതൃകാ പ്രവർത്തനം നടത്തുന്ന നിംസ് മെഡിസിറ്റി എംഡി, എം .എസ് .ഫൈസൽഖാൻ  സേവനത്തിന്റെ മാതൃകാ മുഖമായി മാറുകയാണെന്നും പറഞ്ഞു. ചടങ്ങിൽ  നിംസ് സ്പെക്ട്രം ഡയറക്ടറും മുൻ ആരോഗ്യ സർവ്വകലാശാല വൈസ് ചാൻസലറുമായ ഡോ.എം.കെ.സി നായർ മുഖ്യ  പ്രഭാഷണം നടത്തി. നെയ്യാറ്റിൻകര നിംസ് ഫിസിക്കൽ മെഡിസിൻ വിഭാഗം മേധാവി ഡോ.ജിം ഗോപാല കൃഷ്ണൻ കുട്ടികൾക്ക് ഫിസിയോ തെറാപ്പിയുടെ വിശദീകരണവും പരിശോധനയും നടത്തി.  പീടിയാട്രിക് നൂറോളജിസ്റ്റ് ഡോ. കുഞ്ഞുമുഹമ്മദ്, ജറിയാട്രിക് കോഡിനേറ്റർ കെ.ആർ രേണു. പോളിയോ ഹോം മുൻ പ്രോജക്ട് കോഡിനേറ്റർ  ബോബി ,  സ്പെഷ്യൽ എഡുകേറ്റർ ശ്രീ നോബിൾ മില്ലർ തുടങ്ങിയവർ ചടങ്ങിൽ ആശംസ അർപ്പിച്ചു. നിംസ്നഴ്സിങ് കോളേജ് വൈസ് പ്രിൻസിപ്പൽ ശ്രീമതി. ജോസ് ഫിൻ വിനിത കൃതജ്ഞത പറഞ്ഞു. സ്പെഷൽ എഡുകേറ്റർമാരായ ശ്രീമതി പ്രിൻസ് മോൾ , ശ്രീമതി സിമി,  സ്പെക്ട്രം കോഡിനേറ്റർ ശ്രീ അബ്ദുൾ റിഫായി,നിംസ് സ്പെക്ട്രം സീനിയർ തെറാപ്പിസ്റ്റ് ശ്രീമതി സ്വപ്ന, നഴ്സിംഗ് കൗസിലർ അശ്വതി . ഓക്കു പേഷൻ തെറാപ്പിസ്റ്റ് മെർലിൻ തുടങ്ങിയർ പദ്ധതി വിജയകരമാക്കുന്നതിന് സജീവപങ്കാളിത്തം വഹിച്ചു.',
      thumb: "assets/img/pensionscheme/168.jpg",
    },
    {
      src: "assets/img/pensionscheme/169.jpg",
      caption:
        'നിംസ് മെഡിസിറ്റി നടത്തിവരുന്ന "നെയ്യാറ്റിൻകര പെൻഷൻ പ്ളാൻ ഗുണഭോക്താക്കളായ കുട്ടികൾക്ക്  തൊഴിൽ പരിശീലന പരിപാടി വിവിധ കലാപരിപാടികൾ അവതരിപ്പിച്ചും മൽസരങ്ങൾ നടത്തിക്കൊണ്ടും ആരംഭിച്ചിരിക്കുന്നു. നിംസ് മെഡിസിറ്റി ജനറൽ മാനേജർ ഡോ.കെ.എ. സജു സ്വാഗതം ആശംസിച്ചു . ജോയിന്റ് സയറക്ടർ ഓഫ് മെഡിക്കൽ എഡുക്കേഷൻ ഡോ. അനിത ബാലൻ ചടങ്ങ് ഉദ്ഘാടനം ചെയ്തു സംസാരിച്ചു. ഭിന്നശേഷി കുട്ടികൾക്കും കുടുംബത്തിനും താങ്ങായി മാറുകയാണ് ഇത്തരം പദ്ധതികളെന്നും ഇത്തരത്തിൽ മാതൃകാ പ്രവർത്തനം നടത്തുന്ന നിംസ് മെഡിസിറ്റി എംഡി, എം .എസ് .ഫൈസൽഖാൻ  സേവനത്തിന്റെ മാതൃകാ മുഖമായി മാറുകയാണെന്നും പറഞ്ഞു. ചടങ്ങിൽ  നിംസ് സ്പെക്ട്രം ഡയറക്ടറും മുൻ ആരോഗ്യ സർവ്വകലാശാല വൈസ് ചാൻസലറുമായ ഡോ.എം.കെ.സി നായർ മുഖ്യ  പ്രഭാഷണം നടത്തി. നെയ്യാറ്റിൻകര നിംസ് ഫിസിക്കൽ മെഡിസിൻ വിഭാഗം മേധാവി ഡോ.ജിം ഗോപാല കൃഷ്ണൻ കുട്ടികൾക്ക് ഫിസിയോ തെറാപ്പിയുടെ വിശദീകരണവും പരിശോധനയും നടത്തി.  പീടിയാട്രിക് നൂറോളജിസ്റ്റ് ഡോ. കുഞ്ഞുമുഹമ്മദ്, ജറിയാട്രിക് കോഡിനേറ്റർ കെ.ആർ രേണു. പോളിയോ ഹോം മുൻ പ്രോജക്ട് കോഡിനേറ്റർ  ബോബി ,  സ്പെഷ്യൽ എഡുകേറ്റർ ശ്രീ നോബിൾ മില്ലർ തുടങ്ങിയവർ ചടങ്ങിൽ ആശംസ അർപ്പിച്ചു. നിംസ്നഴ്സിങ് കോളേജ് വൈസ് പ്രിൻസിപ്പൽ ശ്രീമതി. ജോസ് ഫിൻ വിനിത കൃതജ്ഞത പറഞ്ഞു. സ്പെഷൽ എഡുകേറ്റർമാരായ ശ്രീമതി പ്രിൻസ് മോൾ , ശ്രീമതി സിമി,  സ്പെക്ട്രം കോഡിനേറ്റർ ശ്രീ അബ്ദുൾ റിഫായി,നിംസ് സ്പെക്ട്രം സീനിയർ തെറാപ്പിസ്റ്റ് ശ്രീമതി സ്വപ്ന, നഴ്സിംഗ് കൗസിലർ അശ്വതി . ഓക്കു പേഷൻ തെറാപ്പിസ്റ്റ് മെർലിൻ തുടങ്ങിയർ പദ്ധതി വിജയകരമാക്കുന്നതിന് സജീവപങ്കാളിത്തം വഹിച്ചു.',
      thumb: "assets/img/pensionscheme/169.jpg",
    },
    {
      src: "assets/img/pensionscheme/170.jpg",
      caption:
        'നിംസ് മെഡിസിറ്റി നടത്തിവരുന്ന "നെയ്യാറ്റിൻകര പെൻഷൻ പ്ളാൻ ഗുണഭോക്താക്കളായ കുട്ടികൾക്ക്  തൊഴിൽ പരിശീലന പരിപാടി വിവിധ കലാപരിപാടികൾ അവതരിപ്പിച്ചും മൽസരങ്ങൾ നടത്തിക്കൊണ്ടും ആരംഭിച്ചിരിക്കുന്നു. നിംസ് മെഡിസിറ്റി ജനറൽ മാനേജർ ഡോ.കെ.എ. സജു സ്വാഗതം ആശംസിച്ചു . ജോയിന്റ് സയറക്ടർ ഓഫ് മെഡിക്കൽ എഡുക്കേഷൻ ഡോ. അനിത ബാലൻ ചടങ്ങ് ഉദ്ഘാടനം ചെയ്തു സംസാരിച്ചു. ഭിന്നശേഷി കുട്ടികൾക്കും കുടുംബത്തിനും താങ്ങായി മാറുകയാണ് ഇത്തരം പദ്ധതികളെന്നും ഇത്തരത്തിൽ മാതൃകാ പ്രവർത്തനം നടത്തുന്ന നിംസ് മെഡിസിറ്റി എംഡി, എം .എസ് .ഫൈസൽഖാൻ  സേവനത്തിന്റെ മാതൃകാ മുഖമായി മാറുകയാണെന്നും പറഞ്ഞു. ചടങ്ങിൽ  നിംസ് സ്പെക്ട്രം ഡയറക്ടറും മുൻ ആരോഗ്യ സർവ്വകലാശാല വൈസ് ചാൻസലറുമായ ഡോ.എം.കെ.സി നായർ മുഖ്യ  പ്രഭാഷണം നടത്തി. നെയ്യാറ്റിൻകര നിംസ് ഫിസിക്കൽ മെഡിസിൻ വിഭാഗം മേധാവി ഡോ.ജിം ഗോപാല കൃഷ്ണൻ കുട്ടികൾക്ക് ഫിസിയോ തെറാപ്പിയുടെ വിശദീകരണവും പരിശോധനയും നടത്തി.  പീടിയാട്രിക് നൂറോളജിസ്റ്റ് ഡോ. കുഞ്ഞുമുഹമ്മദ്, ജറിയാട്രിക് കോഡിനേറ്റർ കെ.ആർ രേണു. പോളിയോ ഹോം മുൻ പ്രോജക്ട് കോഡിനേറ്റർ  ബോബി ,  സ്പെഷ്യൽ എഡുകേറ്റർ ശ്രീ നോബിൾ മില്ലർ തുടങ്ങിയവർ ചടങ്ങിൽ ആശംസ അർപ്പിച്ചു. നിംസ്നഴ്സിങ് കോളേജ് വൈസ് പ്രിൻസിപ്പൽ ശ്രീമതി. ജോസ് ഫിൻ വിനിത കൃതജ്ഞത പറഞ്ഞു. സ്പെഷൽ എഡുകേറ്റർമാരായ ശ്രീമതി പ്രിൻസ് മോൾ , ശ്രീമതി സിമി,  സ്പെക്ട്രം കോഡിനേറ്റർ ശ്രീ അബ്ദുൾ റിഫായി,നിംസ് സ്പെക്ട്രം സീനിയർ തെറാപ്പിസ്റ്റ് ശ്രീമതി സ്വപ്ന, നഴ്സിംഗ് കൗസിലർ അശ്വതി . ഓക്കു പേഷൻ തെറാപ്പിസ്റ്റ് മെർലിൻ തുടങ്ങിയർ പദ്ധതി വിജയകരമാക്കുന്നതിന് സജീവപങ്കാളിത്തം വഹിച്ചു.',
      thumb: "assets/img/pensionscheme/170.jpg",
    },
    {
      src: "assets/img/pensionscheme/171.jpg",
      caption:
        'നിംസ് മെഡിസിറ്റി നടത്തിവരുന്ന "നെയ്യാറ്റിൻകര പെൻഷൻ പ്ളാൻ ഗുണഭോക്താക്കളായ കുട്ടികൾക്ക്  തൊഴിൽ പരിശീലന പരിപാടി വിവിധ കലാപരിപാടികൾ അവതരിപ്പിച്ചും മൽസരങ്ങൾ നടത്തിക്കൊണ്ടും ആരംഭിച്ചിരിക്കുന്നു. നിംസ് മെഡിസിറ്റി ജനറൽ മാനേജർ ഡോ.കെ.എ. സജു സ്വാഗതം ആശംസിച്ചു . ജോയിന്റ് സയറക്ടർ ഓഫ് മെഡിക്കൽ എഡുക്കേഷൻ ഡോ. അനിത ബാലൻ ചടങ്ങ് ഉദ്ഘാടനം ചെയ്തു സംസാരിച്ചു. ഭിന്നശേഷി കുട്ടികൾക്കും കുടുംബത്തിനും താങ്ങായി മാറുകയാണ് ഇത്തരം പദ്ധതികളെന്നും ഇത്തരത്തിൽ മാതൃകാ പ്രവർത്തനം നടത്തുന്ന നിംസ് മെഡിസിറ്റി എംഡി, എം .എസ് .ഫൈസൽഖാൻ  സേവനത്തിന്റെ മാതൃകാ മുഖമായി മാറുകയാണെന്നും പറഞ്ഞു. ചടങ്ങിൽ  നിംസ് സ്പെക്ട്രം ഡയറക്ടറും മുൻ ആരോഗ്യ സർവ്വകലാശാല വൈസ് ചാൻസലറുമായ ഡോ.എം.കെ.സി നായർ മുഖ്യ  പ്രഭാഷണം നടത്തി. നെയ്യാറ്റിൻകര നിംസ് ഫിസിക്കൽ മെഡിസിൻ വിഭാഗം മേധാവി ഡോ.ജിം ഗോപാല കൃഷ്ണൻ കുട്ടികൾക്ക് ഫിസിയോ തെറാപ്പിയുടെ വിശദീകരണവും പരിശോധനയും നടത്തി.  പീടിയാട്രിക് നൂറോളജിസ്റ്റ് ഡോ. കുഞ്ഞുമുഹമ്മദ്, ജറിയാട്രിക് കോഡിനേറ്റർ കെ.ആർ രേണു. പോളിയോ ഹോം മുൻ പ്രോജക്ട് കോഡിനേറ്റർ  ബോബി ,  സ്പെഷ്യൽ എഡുകേറ്റർ ശ്രീ നോബിൾ മില്ലർ തുടങ്ങിയവർ ചടങ്ങിൽ ആശംസ അർപ്പിച്ചു. നിംസ്നഴ്സിങ് കോളേജ് വൈസ് പ്രിൻസിപ്പൽ ശ്രീമതി. ജോസ് ഫിൻ വിനിത കൃതജ്ഞത പറഞ്ഞു. സ്പെഷൽ എഡുകേറ്റർമാരായ ശ്രീമതി പ്രിൻസ് മോൾ , ശ്രീമതി സിമി,  സ്പെക്ട്രം കോഡിനേറ്റർ ശ്രീ അബ്ദുൾ റിഫായി,നിംസ് സ്പെക്ട്രം സീനിയർ തെറാപ്പിസ്റ്റ് ശ്രീമതി സ്വപ്ന, നഴ്സിംഗ് കൗസിലർ അശ്വതി . ഓക്കു പേഷൻ തെറാപ്പിസ്റ്റ് മെർലിൻ തുടങ്ങിയർ പദ്ധതി വിജയകരമാക്കുന്നതിന് സജീവപങ്കാളിത്തം വഹിച്ചു.',
      thumb: "assets/img/pensionscheme/171.jpg",
    },
    {
      src: "assets/img/pensionscheme/172.jpg",
      caption:
        'നിംസ് മെഡിസിറ്റി നടത്തിവരുന്ന "നെയ്യാറ്റിൻകര പെൻഷൻ പ്ളാൻ ഗുണഭോക്താക്കളായ കുട്ടികൾക്ക്  തൊഴിൽ പരിശീലന പരിപാടി വിവിധ കലാപരിപാടികൾ അവതരിപ്പിച്ചും മൽസരങ്ങൾ നടത്തിക്കൊണ്ടും ആരംഭിച്ചിരിക്കുന്നു. നിംസ് മെഡിസിറ്റി ജനറൽ മാനേജർ ഡോ.കെ.എ. സജു സ്വാഗതം ആശംസിച്ചു . ജോയിന്റ് സയറക്ടർ ഓഫ് മെഡിക്കൽ എഡുക്കേഷൻ ഡോ. അനിത ബാലൻ ചടങ്ങ് ഉദ്ഘാടനം ചെയ്തു സംസാരിച്ചു. ഭിന്നശേഷി കുട്ടികൾക്കും കുടുംബത്തിനും താങ്ങായി മാറുകയാണ് ഇത്തരം പദ്ധതികളെന്നും ഇത്തരത്തിൽ മാതൃകാ പ്രവർത്തനം നടത്തുന്ന നിംസ് മെഡിസിറ്റി എംഡി, എം .എസ് .ഫൈസൽഖാൻ  സേവനത്തിന്റെ മാതൃകാ മുഖമായി മാറുകയാണെന്നും പറഞ്ഞു. ചടങ്ങിൽ  നിംസ് സ്പെക്ട്രം ഡയറക്ടറും മുൻ ആരോഗ്യ സർവ്വകലാശാല വൈസ് ചാൻസലറുമായ ഡോ.എം.കെ.സി നായർ മുഖ്യ  പ്രഭാഷണം നടത്തി. നെയ്യാറ്റിൻകര നിംസ് ഫിസിക്കൽ മെഡിസിൻ വിഭാഗം മേധാവി ഡോ.ജിം ഗോപാല കൃഷ്ണൻ കുട്ടികൾക്ക് ഫിസിയോ തെറാപ്പിയുടെ വിശദീകരണവും പരിശോധനയും നടത്തി.  പീടിയാട്രിക് നൂറോളജിസ്റ്റ് ഡോ. കുഞ്ഞുമുഹമ്മദ്, ജറിയാട്രിക് കോഡിനേറ്റർ കെ.ആർ രേണു. പോളിയോ ഹോം മുൻ പ്രോജക്ട് കോഡിനേറ്റർ  ബോബി ,  സ്പെഷ്യൽ എഡുകേറ്റർ ശ്രീ നോബിൾ മില്ലർ തുടങ്ങിയവർ ചടങ്ങിൽ ആശംസ അർപ്പിച്ചു. നിംസ്നഴ്സിങ് കോളേജ് വൈസ് പ്രിൻസിപ്പൽ ശ്രീമതി. ജോസ് ഫിൻ വിനിത കൃതജ്ഞത പറഞ്ഞു. സ്പെഷൽ എഡുകേറ്റർമാരായ ശ്രീമതി പ്രിൻസ് മോൾ , ശ്രീമതി സിമി,  സ്പെക്ട്രം കോഡിനേറ്റർ ശ്രീ അബ്ദുൾ റിഫായി,നിംസ് സ്പെക്ട്രം സീനിയർ തെറാപ്പിസ്റ്റ് ശ്രീമതി സ്വപ്ന, നഴ്സിംഗ് കൗസിലർ അശ്വതി . ഓക്കു പേഷൻ തെറാപ്പിസ്റ്റ് മെർലിൻ തുടങ്ങിയർ പദ്ധതി വിജയകരമാക്കുന്നതിന് സജീവപങ്കാളിത്തം വഹിച്ചു.',
      thumb: "assets/img/pensionscheme/172.jpg",
    },
    {
      src: "assets/img/pensionscheme/173.jpg",
      caption:
        'നിംസ് മെഡിസിറ്റി നടത്തിവരുന്ന "നെയ്യാറ്റിൻകര പെൻഷൻ പ്ളാൻ ഗുണഭോക്താക്കളായ കുട്ടികൾക്ക്  തൊഴിൽ പരിശീലന പരിപാടി വിവിധ കലാപരിപാടികൾ അവതരിപ്പിച്ചും മൽസരങ്ങൾ നടത്തിക്കൊണ്ടും ആരംഭിച്ചിരിക്കുന്നു. നിംസ് മെഡിസിറ്റി ജനറൽ മാനേജർ ഡോ.കെ.എ. സജു സ്വാഗതം ആശംസിച്ചു . ജോയിന്റ് സയറക്ടർ ഓഫ് മെഡിക്കൽ എഡുക്കേഷൻ ഡോ. അനിത ബാലൻ ചടങ്ങ് ഉദ്ഘാടനം ചെയ്തു സംസാരിച്ചു. ഭിന്നശേഷി കുട്ടികൾക്കും കുടുംബത്തിനും താങ്ങായി മാറുകയാണ് ഇത്തരം പദ്ധതികളെന്നും ഇത്തരത്തിൽ മാതൃകാ പ്രവർത്തനം നടത്തുന്ന നിംസ് മെഡിസിറ്റി എംഡി, എം .എസ് .ഫൈസൽഖാൻ  സേവനത്തിന്റെ മാതൃകാ മുഖമായി മാറുകയാണെന്നും പറഞ്ഞു. ചടങ്ങിൽ  നിംസ് സ്പെക്ട്രം ഡയറക്ടറും മുൻ ആരോഗ്യ സർവ്വകലാശാല വൈസ് ചാൻസലറുമായ ഡോ.എം.കെ.സി നായർ മുഖ്യ  പ്രഭാഷണം നടത്തി. നെയ്യാറ്റിൻകര നിംസ് ഫിസിക്കൽ മെഡിസിൻ വിഭാഗം മേധാവി ഡോ.ജിം ഗോപാല കൃഷ്ണൻ കുട്ടികൾക്ക് ഫിസിയോ തെറാപ്പിയുടെ വിശദീകരണവും പരിശോധനയും നടത്തി.  പീടിയാട്രിക് നൂറോളജിസ്റ്റ് ഡോ. കുഞ്ഞുമുഹമ്മദ്, ജറിയാട്രിക് കോഡിനേറ്റർ കെ.ആർ രേണു. പോളിയോ ഹോം മുൻ പ്രോജക്ട് കോഡിനേറ്റർ  ബോബി ,  സ്പെഷ്യൽ എഡുകേറ്റർ ശ്രീ നോബിൾ മില്ലർ തുടങ്ങിയവർ ചടങ്ങിൽ ആശംസ അർപ്പിച്ചു. നിംസ്നഴ്സിങ് കോളേജ് വൈസ് പ്രിൻസിപ്പൽ ശ്രീമതി. ജോസ് ഫിൻ വിനിത കൃതജ്ഞത പറഞ്ഞു. സ്പെഷൽ എഡുകേറ്റർമാരായ ശ്രീമതി പ്രിൻസ് മോൾ , ശ്രീമതി സിമി,  സ്പെക്ട്രം കോഡിനേറ്റർ ശ്രീ അബ്ദുൾ റിഫായി,നിംസ് സ്പെക്ട്രം സീനിയർ തെറാപ്പിസ്റ്റ് ശ്രീമതി സ്വപ്ന, നഴ്സിംഗ് കൗസിലർ അശ്വതി . ഓക്കു പേഷൻ തെറാപ്പിസ്റ്റ് മെർലിൻ തുടങ്ങിയർ പദ്ധതി വിജയകരമാക്കുന്നതിന് സജീവപങ്കാളിത്തം വഹിച്ചു.',
      thumb: "assets/img/pensionscheme/173.jpg",
    },
    {
      src: "assets/img/pensionscheme/174.jpg",
      caption:
        'നിംസ് മെഡിസിറ്റി നടത്തിവരുന്ന "നെയ്യാറ്റിൻകര പെൻഷൻ പ്ളാൻ ഗുണഭോക്താക്കളായ കുട്ടികൾക്ക്  തൊഴിൽ പരിശീലന പരിപാടി വിവിധ കലാപരിപാടികൾ അവതരിപ്പിച്ചും മൽസരങ്ങൾ നടത്തിക്കൊണ്ടും ആരംഭിച്ചിരിക്കുന്നു. നിംസ് മെഡിസിറ്റി ജനറൽ മാനേജർ ഡോ.കെ.എ. സജു സ്വാഗതം ആശംസിച്ചു . ജോയിന്റ് സയറക്ടർ ഓഫ് മെഡിക്കൽ എഡുക്കേഷൻ ഡോ. അനിത ബാലൻ ചടങ്ങ് ഉദ്ഘാടനം ചെയ്തു സംസാരിച്ചു. ഭിന്നശേഷി കുട്ടികൾക്കും കുടുംബത്തിനും താങ്ങായി മാറുകയാണ് ഇത്തരം പദ്ധതികളെന്നും ഇത്തരത്തിൽ മാതൃകാ പ്രവർത്തനം നടത്തുന്ന നിംസ് മെഡിസിറ്റി എംഡി, എം .എസ് .ഫൈസൽഖാൻ  സേവനത്തിന്റെ മാതൃകാ മുഖമായി മാറുകയാണെന്നും പറഞ്ഞു. ചടങ്ങിൽ  നിംസ് സ്പെക്ട്രം ഡയറക്ടറും മുൻ ആരോഗ്യ സർവ്വകലാശാല വൈസ് ചാൻസലറുമായ ഡോ.എം.കെ.സി നായർ മുഖ്യ  പ്രഭാഷണം നടത്തി. നെയ്യാറ്റിൻകര നിംസ് ഫിസിക്കൽ മെഡിസിൻ വിഭാഗം മേധാവി ഡോ.ജിം ഗോപാല കൃഷ്ണൻ കുട്ടികൾക്ക് ഫിസിയോ തെറാപ്പിയുടെ വിശദീകരണവും പരിശോധനയും നടത്തി.  പീടിയാട്രിക് നൂറോളജിസ്റ്റ് ഡോ. കുഞ്ഞുമുഹമ്മദ്, ജറിയാട്രിക് കോഡിനേറ്റർ കെ.ആർ രേണു. പോളിയോ ഹോം മുൻ പ്രോജക്ട് കോഡിനേറ്റർ  ബോബി ,  സ്പെഷ്യൽ എഡുകേറ്റർ ശ്രീ നോബിൾ മില്ലർ തുടങ്ങിയവർ ചടങ്ങിൽ ആശംസ അർപ്പിച്ചു. നിംസ്നഴ്സിങ് കോളേജ് വൈസ് പ്രിൻസിപ്പൽ ശ്രീമതി. ജോസ് ഫിൻ വിനിത കൃതജ്ഞത പറഞ്ഞു. സ്പെഷൽ എഡുകേറ്റർമാരായ ശ്രീമതി പ്രിൻസ് മോൾ , ശ്രീമതി സിമി,  സ്പെക്ട്രം കോഡിനേറ്റർ ശ്രീ അബ്ദുൾ റിഫായി,നിംസ് സ്പെക്ട്രം സീനിയർ തെറാപ്പിസ്റ്റ് ശ്രീമതി സ്വപ്ന, നഴ്സിംഗ് കൗസിലർ അശ്വതി . ഓക്കു പേഷൻ തെറാപ്പിസ്റ്റ് മെർലിൻ തുടങ്ങിയർ പദ്ധതി വിജയകരമാക്കുന്നതിന് സജീവപങ്കാളിത്തം വഹിച്ചു.',
      thumb: "assets/img/pensionscheme/174.jpg",
    },
    {
      src: "assets/img/pensionscheme/175.jpg",
      caption:
        'നിംസ് മെഡിസിറ്റി നടത്തിവരുന്ന "നെയ്യാറ്റിൻകര പെൻഷൻ പ്ളാൻ ഗുണഭോക്താക്കളായ കുട്ടികൾക്ക്  തൊഴിൽ പരിശീലന പരിപാടി വിവിധ കലാപരിപാടികൾ അവതരിപ്പിച്ചും മൽസരങ്ങൾ നടത്തിക്കൊണ്ടും ആരംഭിച്ചിരിക്കുന്നു. നിംസ് മെഡിസിറ്റി ജനറൽ മാനേജർ ഡോ.കെ.എ. സജു സ്വാഗതം ആശംസിച്ചു . ജോയിന്റ് സയറക്ടർ ഓഫ് മെഡിക്കൽ എഡുക്കേഷൻ ഡോ. അനിത ബാലൻ ചടങ്ങ് ഉദ്ഘാടനം ചെയ്തു സംസാരിച്ചു. ഭിന്നശേഷി കുട്ടികൾക്കും കുടുംബത്തിനും താങ്ങായി മാറുകയാണ് ഇത്തരം പദ്ധതികളെന്നും ഇത്തരത്തിൽ മാതൃകാ പ്രവർത്തനം നടത്തുന്ന നിംസ് മെഡിസിറ്റി എംഡി, എം .എസ് .ഫൈസൽഖാൻ  സേവനത്തിന്റെ മാതൃകാ മുഖമായി മാറുകയാണെന്നും പറഞ്ഞു. ചടങ്ങിൽ  നിംസ് സ്പെക്ട്രം ഡയറക്ടറും മുൻ ആരോഗ്യ സർവ്വകലാശാല വൈസ് ചാൻസലറുമായ ഡോ.എം.കെ.സി നായർ മുഖ്യ  പ്രഭാഷണം നടത്തി. നെയ്യാറ്റിൻകര നിംസ് ഫിസിക്കൽ മെഡിസിൻ വിഭാഗം മേധാവി ഡോ.ജിം ഗോപാല കൃഷ്ണൻ കുട്ടികൾക്ക് ഫിസിയോ തെറാപ്പിയുടെ വിശദീകരണവും പരിശോധനയും നടത്തി.  പീടിയാട്രിക് നൂറോളജിസ്റ്റ് ഡോ. കുഞ്ഞുമുഹമ്മദ്, ജറിയാട്രിക് കോഡിനേറ്റർ കെ.ആർ രേണു. പോളിയോ ഹോം മുൻ പ്രോജക്ട് കോഡിനേറ്റർ  ബോബി ,  സ്പെഷ്യൽ എഡുകേറ്റർ ശ്രീ നോബിൾ മില്ലർ തുടങ്ങിയവർ ചടങ്ങിൽ ആശംസ അർപ്പിച്ചു. നിംസ്നഴ്സിങ് കോളേജ് വൈസ് പ്രിൻസിപ്പൽ ശ്രീമതി. ജോസ് ഫിൻ വിനിത കൃതജ്ഞത പറഞ്ഞു. സ്പെഷൽ എഡുകേറ്റർമാരായ ശ്രീമതി പ്രിൻസ് മോൾ , ശ്രീമതി സിമി,  സ്പെക്ട്രം കോഡിനേറ്റർ ശ്രീ അബ്ദുൾ റിഫായി,നിംസ് സ്പെക്ട്രം സീനിയർ തെറാപ്പിസ്റ്റ് ശ്രീമതി സ്വപ്ന, നഴ്സിംഗ് കൗസിലർ അശ്വതി . ഓക്കു പേഷൻ തെറാപ്പിസ്റ്റ് മെർലിൻ തുടങ്ങിയർ പദ്ധതി വിജയകരമാക്കുന്നതിന് സജീവപങ്കാളിത്തം വഹിച്ചു.',
      thumb: "assets/img/pensionscheme/175.jpg",
    },
    {
      src: "assets/img/pensionscheme/128.jpg",
      caption:
        "നെയ്യാറ്റിൻകര പെൻഷൻ പദ്ധതിയിൽ അംഗങ്ങളായ നെയ്യാറ്റിൻകര മുൻസിപ്പാലിറ്റിയിലെ തന്നെ ആറ് പഞ്ചായത്തുകളിലെ നിർധനരായ ഭിന്നശേഷി വിദ്യാർഥികൾ , നിംസ് സെന്റർ ഫോർ സ്പെഷ്യലി ഏബിലിട് ഇലെ വിദ്യാർഥികൾ, നിംസ് ഓട്ടോസ്റ്റാൻഡ് തൊഴിലാളികൾ, ആറാലുംമൂട് ലോഡിങ് യൂണിയൻ തൊഴിലാകിൾ,500 ഓളം വരുന്ന നിർധനരായ മറ്റു പ്രിയപ്പെട്ടവർ,1600 ഓളം നിംസ് സ്റ്റാഫുകൾ ഡോക്ടർസ് തുടങ്ങി   3500 ഓളം വരുന്ന ഞങ്ങളുടെ പ്രിയപ്പെട്ടവർക്കു ഈ വർഷവും  ഓണകിറ്റ് നൽകാൻ കഴിഞ്ഞതിൽ നിംസ് കുടുംബം നിങ്ങൾ ഓരോരുത്തർക്കും നന്ദിയും സ്നേഹവും അറിയിച്ചുകൊള്ളുന്നു.പ്രസ്തുത ചടങ്ങിൽ പങ്കെടുത്തു ഞങ്ങളോടൊപ്പം എന്നും നിലകൊള്ളുന്ന ബഹുമാനപ്പെട്ട നെയ്യാറ്റിൻകര എം എൽ എ ശ്രീ കെ ആൻസലൻ, നെയ്യാറ്റിൻകര മുനിസിപ്പൽ ചെയർമാൻ ശ്രീ രാജ്‌മോഹൻ,ആരോഗ്യ സ്റ്റാൻഡിങ് കമ്മറ്റി ചെയർമാൻ ശ്രീ ജോസ് ഫ്രാങ്ക്‌ളിൻ, സിപിഎം ഏരിയ സെക്രട്ടറി ശ്രീ ശ്രീകുമാർ,ബാലരാമപുരം പഞ്ചായത്ത്  പ്രസിഡന്റ്‌ ശ്രീ മോഹൻ,കൗൺസിലർ ശ്രീ മഹേഷ്‌ കൂട്ടപ്പന, ശ്രീ മഞ്ചന്തല സുരേഷ് തുടങ്ങിയവർ സംബന്ധിച്ചു.ഈ അവസരത്തിൽ നിംസ് കുടുംബത്തിന്റെ തന്നെ ഒരു ഭാഗമായി മാറിക്കഴിഞ്ഞ കേരള സപ്ലൈക്കോ ത്രിവേണി ബസ് ജീവനക്കാർക്കും ഞങ്ങളുടെ നന്ദിയും സ്നേഹവും അറിയിച്ചുകൊള്ളുന്നു..",
      thumb: "assets/img/pensionscheme/128.jpg",
    },
    {
      src: "assets/img/pensionscheme/129.jpg",
      caption:
        "നെയ്യാറ്റിൻകര പെൻഷൻ പദ്ധതിയിൽ അംഗങ്ങളായ നെയ്യാറ്റിൻകര മുൻസിപ്പാലിറ്റിയിലെ തന്നെ ആറ് പഞ്ചായത്തുകളിലെ നിർധനരായ ഭിന്നശേഷി വിദ്യാർഥികൾ , നിംസ് സെന്റർ ഫോർ സ്പെഷ്യലി ഏബിലിട് ഇലെ വിദ്യാർഥികൾ, നിംസ് ഓട്ടോസ്റ്റാൻഡ് തൊഴിലാളികൾ, ആറാലുംമൂട് ലോഡിങ് യൂണിയൻ തൊഴിലാകിൾ,500 ഓളം വരുന്ന നിർധനരായ മറ്റു പ്രിയപ്പെട്ടവർ,1600 ഓളം നിംസ് സ്റ്റാഫുകൾ ഡോക്ടർസ് തുടങ്ങി   3500 ഓളം വരുന്ന ഞങ്ങളുടെ പ്രിയപ്പെട്ടവർക്കു ഈ വർഷവും  ഓണകിറ്റ് നൽകാൻ കഴിഞ്ഞതിൽ നിംസ് കുടുംബം നിങ്ങൾ ഓരോരുത്തർക്കും നന്ദിയും സ്നേഹവും അറിയിച്ചുകൊള്ളുന്നു.പ്രസ്തുത ചടങ്ങിൽ പങ്കെടുത്തു ഞങ്ങളോടൊപ്പം എന്നും നിലകൊള്ളുന്ന ബഹുമാനപ്പെട്ട നെയ്യാറ്റിൻകര എം എൽ എ ശ്രീ കെ ആൻസലൻ, നെയ്യാറ്റിൻകര മുനിസിപ്പൽ ചെയർമാൻ ശ്രീ രാജ്‌മോഹൻ,ആരോഗ്യ സ്റ്റാൻഡിങ് കമ്മറ്റി ചെയർമാൻ ശ്രീ ജോസ് ഫ്രാങ്ക്‌ളിൻ, സിപിഎം ഏരിയ സെക്രട്ടറി ശ്രീ ശ്രീകുമാർ,ബാലരാമപുരം പഞ്ചായത്ത്  പ്രസിഡന്റ്‌ ശ്രീ മോഹൻ,കൗൺസിലർ ശ്രീ മഹേഷ്‌ കൂട്ടപ്പന, ശ്രീ മഞ്ചന്തല സുരേഷ് തുടങ്ങിയവർ സംബന്ധിച്ചു.ഈ അവസരത്തിൽ നിംസ് കുടുംബത്തിന്റെ തന്നെ ഒരു ഭാഗമായി മാറിക്കഴിഞ്ഞ കേരള സപ്ലൈക്കോ ത്രിവേണി ബസ് ജീവനക്കാർക്കും ഞങ്ങളുടെ നന്ദിയും സ്നേഹവും അറിയിച്ചുകൊള്ളുന്നു..",
      thumb: "assets/img/pensionscheme/129.jpg",
    },
    {
      src: "assets/img/pensionscheme/130.jpg",
      caption:
        "നെയ്യാറ്റിൻകര പെൻഷൻ പദ്ധതിയിൽ അംഗങ്ങളായ നെയ്യാറ്റിൻകര മുൻസിപ്പാലിറ്റിയിലെ തന്നെ ആറ് പഞ്ചായത്തുകളിലെ നിർധനരായ ഭിന്നശേഷി വിദ്യാർഥികൾ , നിംസ് സെന്റർ ഫോർ സ്പെഷ്യലി ഏബിലിട് ഇലെ വിദ്യാർഥികൾ, നിംസ് ഓട്ടോസ്റ്റാൻഡ് തൊഴിലാളികൾ, ആറാലുംമൂട് ലോഡിങ് യൂണിയൻ തൊഴിലാകിൾ,500 ഓളം വരുന്ന നിർധനരായ മറ്റു പ്രിയപ്പെട്ടവർ,1600 ഓളം നിംസ് സ്റ്റാഫുകൾ ഡോക്ടർസ് തുടങ്ങി   3500 ഓളം വരുന്ന ഞങ്ങളുടെ പ്രിയപ്പെട്ടവർക്കു ഈ വർഷവും  ഓണകിറ്റ് നൽകാൻ കഴിഞ്ഞതിൽ നിംസ് കുടുംബം നിങ്ങൾ ഓരോരുത്തർക്കും നന്ദിയും സ്നേഹവും അറിയിച്ചുകൊള്ളുന്നു.പ്രസ്തുത ചടങ്ങിൽ പങ്കെടുത്തു ഞങ്ങളോടൊപ്പം എന്നും നിലകൊള്ളുന്ന ബഹുമാനപ്പെട്ട നെയ്യാറ്റിൻകര എം എൽ എ ശ്രീ കെ ആൻസലൻ, നെയ്യാറ്റിൻകര മുനിസിപ്പൽ ചെയർമാൻ ശ്രീ രാജ്‌മോഹൻ,ആരോഗ്യ സ്റ്റാൻഡിങ് കമ്മറ്റി ചെയർമാൻ ശ്രീ ജോസ് ഫ്രാങ്ക്‌ളിൻ, സിപിഎം ഏരിയ സെക്രട്ടറി ശ്രീ ശ്രീകുമാർ,ബാലരാമപുരം പഞ്ചായത്ത്  പ്രസിഡന്റ്‌ ശ്രീ മോഹൻ,കൗൺസിലർ ശ്രീ മഹേഷ്‌ കൂട്ടപ്പന, ശ്രീ മഞ്ചന്തല സുരേഷ് തുടങ്ങിയവർ സംബന്ധിച്ചു.ഈ അവസരത്തിൽ നിംസ് കുടുംബത്തിന്റെ തന്നെ ഒരു ഭാഗമായി മാറിക്കഴിഞ്ഞ കേരള സപ്ലൈക്കോ ത്രിവേണി ബസ് ജീവനക്കാർക്കും ഞങ്ങളുടെ നന്ദിയും സ്നേഹവും അറിയിച്ചുകൊള്ളുന്നു..",
      thumb: "assets/img/pensionscheme/130.jpg",
    },
    {
      src: "assets/img/pensionscheme/131.jpg",
      caption:
        "നെയ്യാറ്റിൻകര പെൻഷൻ പദ്ധതിയിൽ അംഗങ്ങളായ നെയ്യാറ്റിൻകര മുൻസിപ്പാലിറ്റിയിലെ തന്നെ ആറ് പഞ്ചായത്തുകളിലെ നിർധനരായ ഭിന്നശേഷി വിദ്യാർഥികൾ , നിംസ് സെന്റർ ഫോർ സ്പെഷ്യലി ഏബിലിട് ഇലെ വിദ്യാർഥികൾ, നിംസ് ഓട്ടോസ്റ്റാൻഡ് തൊഴിലാളികൾ, ആറാലുംമൂട് ലോഡിങ് യൂണിയൻ തൊഴിലാകിൾ,500 ഓളം വരുന്ന നിർധനരായ മറ്റു പ്രിയപ്പെട്ടവർ,1600 ഓളം നിംസ് സ്റ്റാഫുകൾ ഡോക്ടർസ് തുടങ്ങി   3500 ഓളം വരുന്ന ഞങ്ങളുടെ പ്രിയപ്പെട്ടവർക്കു ഈ വർഷവും  ഓണകിറ്റ് നൽകാൻ കഴിഞ്ഞതിൽ നിംസ് കുടുംബം നിങ്ങൾ ഓരോരുത്തർക്കും നന്ദിയും സ്നേഹവും അറിയിച്ചുകൊള്ളുന്നു.പ്രസ്തുത ചടങ്ങിൽ പങ്കെടുത്തു ഞങ്ങളോടൊപ്പം എന്നും നിലകൊള്ളുന്ന ബഹുമാനപ്പെട്ട നെയ്യാറ്റിൻകര എം എൽ എ ശ്രീ കെ ആൻസലൻ, നെയ്യാറ്റിൻകര മുനിസിപ്പൽ ചെയർമാൻ ശ്രീ രാജ്‌മോഹൻ,ആരോഗ്യ സ്റ്റാൻഡിങ് കമ്മറ്റി ചെയർമാൻ ശ്രീ ജോസ് ഫ്രാങ്ക്‌ളിൻ, സിപിഎം ഏരിയ സെക്രട്ടറി ശ്രീ ശ്രീകുമാർ,ബാലരാമപുരം പഞ്ചായത്ത്  പ്രസിഡന്റ്‌ ശ്രീ മോഹൻ,കൗൺസിലർ ശ്രീ മഹേഷ്‌ കൂട്ടപ്പന, ശ്രീ മഞ്ചന്തല സുരേഷ് തുടങ്ങിയവർ സംബന്ധിച്ചു.ഈ അവസരത്തിൽ നിംസ് കുടുംബത്തിന്റെ തന്നെ ഒരു ഭാഗമായി മാറിക്കഴിഞ്ഞ കേരള സപ്ലൈക്കോ ത്രിവേണി ബസ് ജീവനക്കാർക്കും ഞങ്ങളുടെ നന്ദിയും സ്നേഹവും അറിയിച്ചുകൊള്ളുന്നു..",
      thumb: "assets/img/pensionscheme/131.jpg",
    },
    {
      src: "assets/img/pensionscheme/132.jpg",
      caption:
        "നെയ്യാറ്റിൻകര പെൻഷൻ പദ്ധതിയിൽ അംഗങ്ങളായ നെയ്യാറ്റിൻകര മുൻസിപ്പാലിറ്റിയിലെ തന്നെ ആറ് പഞ്ചായത്തുകളിലെ നിർധനരായ ഭിന്നശേഷി വിദ്യാർഥികൾ , നിംസ് സെന്റർ ഫോർ സ്പെഷ്യലി ഏബിലിട് ഇലെ വിദ്യാർഥികൾ, നിംസ് ഓട്ടോസ്റ്റാൻഡ് തൊഴിലാളികൾ, ആറാലുംമൂട് ലോഡിങ് യൂണിയൻ തൊഴിലാകിൾ,500 ഓളം വരുന്ന നിർധനരായ മറ്റു പ്രിയപ്പെട്ടവർ,1600 ഓളം നിംസ് സ്റ്റാഫുകൾ ഡോക്ടർസ് തുടങ്ങി   3500 ഓളം വരുന്ന ഞങ്ങളുടെ പ്രിയപ്പെട്ടവർക്കു ഈ വർഷവും  ഓണകിറ്റ് നൽകാൻ കഴിഞ്ഞതിൽ നിംസ് കുടുംബം നിങ്ങൾ ഓരോരുത്തർക്കും നന്ദിയും സ്നേഹവും അറിയിച്ചുകൊള്ളുന്നു.പ്രസ്തുത ചടങ്ങിൽ പങ്കെടുത്തു ഞങ്ങളോടൊപ്പം എന്നും നിലകൊള്ളുന്ന ബഹുമാനപ്പെട്ട നെയ്യാറ്റിൻകര എം എൽ എ ശ്രീ കെ ആൻസലൻ, നെയ്യാറ്റിൻകര മുനിസിപ്പൽ ചെയർമാൻ ശ്രീ രാജ്‌മോഹൻ,ആരോഗ്യ സ്റ്റാൻഡിങ് കമ്മറ്റി ചെയർമാൻ ശ്രീ ജോസ് ഫ്രാങ്ക്‌ളിൻ, സിപിഎം ഏരിയ സെക്രട്ടറി ശ്രീ ശ്രീകുമാർ,ബാലരാമപുരം പഞ്ചായത്ത്  പ്രസിഡന്റ്‌ ശ്രീ മോഹൻ,കൗൺസിലർ ശ്രീ മഹേഷ്‌ കൂട്ടപ്പന, ശ്രീ മഞ്ചന്തല സുരേഷ് തുടങ്ങിയവർ സംബന്ധിച്ചു.ഈ അവസരത്തിൽ നിംസ് കുടുംബത്തിന്റെ തന്നെ ഒരു ഭാഗമായി മാറിക്കഴിഞ്ഞ കേരള സപ്ലൈക്കോ ത്രിവേണി ബസ് ജീവനക്കാർക്കും ഞങ്ങളുടെ നന്ദിയും സ്നേഹവും അറിയിച്ചുകൊള്ളുന്നു..",
      thumb: "assets/img/pensionscheme/132.jpg",
    },
    {
      src: "assets/img/pensionscheme/133.jpg",
      caption:
        "നെയ്യാറ്റിൻകര പെൻഷൻ പദ്ധതിയിൽ അംഗങ്ങളായ നെയ്യാറ്റിൻകര മുൻസിപ്പാലിറ്റിയിലെ തന്നെ ആറ് പഞ്ചായത്തുകളിലെ നിർധനരായ ഭിന്നശേഷി വിദ്യാർഥികൾ , നിംസ് സെന്റർ ഫോർ സ്പെഷ്യലി ഏബിലിട് ഇലെ വിദ്യാർഥികൾ, നിംസ് ഓട്ടോസ്റ്റാൻഡ് തൊഴിലാളികൾ, ആറാലുംമൂട് ലോഡിങ് യൂണിയൻ തൊഴിലാകിൾ,500 ഓളം വരുന്ന നിർധനരായ മറ്റു പ്രിയപ്പെട്ടവർ,1600 ഓളം നിംസ് സ്റ്റാഫുകൾ ഡോക്ടർസ് തുടങ്ങി   3500 ഓളം വരുന്ന ഞങ്ങളുടെ പ്രിയപ്പെട്ടവർക്കു ഈ വർഷവും  ഓണകിറ്റ് നൽകാൻ കഴിഞ്ഞതിൽ നിംസ് കുടുംബം നിങ്ങൾ ഓരോരുത്തർക്കും നന്ദിയും സ്നേഹവും അറിയിച്ചുകൊള്ളുന്നു.പ്രസ്തുത ചടങ്ങിൽ പങ്കെടുത്തു ഞങ്ങളോടൊപ്പം എന്നും നിലകൊള്ളുന്ന ബഹുമാനപ്പെട്ട നെയ്യാറ്റിൻകര എം എൽ എ ശ്രീ കെ ആൻസലൻ, നെയ്യാറ്റിൻകര മുനിസിപ്പൽ ചെയർമാൻ ശ്രീ രാജ്‌മോഹൻ,ആരോഗ്യ സ്റ്റാൻഡിങ് കമ്മറ്റി ചെയർമാൻ ശ്രീ ജോസ് ഫ്രാങ്ക്‌ളിൻ, സിപിഎം ഏരിയ സെക്രട്ടറി ശ്രീ ശ്രീകുമാർ,ബാലരാമപുരം പഞ്ചായത്ത്  പ്രസിഡന്റ്‌ ശ്രീ മോഹൻ,കൗൺസിലർ ശ്രീ മഹേഷ്‌ കൂട്ടപ്പന, ശ്രീ മഞ്ചന്തല സുരേഷ് തുടങ്ങിയവർ സംബന്ധിച്ചു.ഈ അവസരത്തിൽ നിംസ് കുടുംബത്തിന്റെ തന്നെ ഒരു ഭാഗമായി മാറിക്കഴിഞ്ഞ കേരള സപ്ലൈക്കോ ത്രിവേണി ബസ് ജീവനക്കാർക്കും ഞങ്ങളുടെ നന്ദിയും സ്നേഹവും അറിയിച്ചുകൊള്ളുന്നു..",
      thumb: "assets/img/pensionscheme/133.jpg",
    },
    {
      src: "assets/img/pensionscheme/134.jpg",
      caption:
        "നെയ്യാറ്റിൻകര പെൻഷൻ പദ്ധതിയിൽ അംഗങ്ങളായ നെയ്യാറ്റിൻകര മുൻസിപ്പാലിറ്റിയിലെ തന്നെ ആറ് പഞ്ചായത്തുകളിലെ നിർധനരായ ഭിന്നശേഷി വിദ്യാർഥികൾ , നിംസ് സെന്റർ ഫോർ സ്പെഷ്യലി ഏബിലിട് ഇലെ വിദ്യാർഥികൾ, നിംസ് ഓട്ടോസ്റ്റാൻഡ് തൊഴിലാളികൾ, ആറാലുംമൂട് ലോഡിങ് യൂണിയൻ തൊഴിലാകിൾ,500 ഓളം വരുന്ന നിർധനരായ മറ്റു പ്രിയപ്പെട്ടവർ,1600 ഓളം നിംസ് സ്റ്റാഫുകൾ ഡോക്ടർസ് തുടങ്ങി   3500 ഓളം വരുന്ന ഞങ്ങളുടെ പ്രിയപ്പെട്ടവർക്കു ഈ വർഷവും  ഓണകിറ്റ് നൽകാൻ കഴിഞ്ഞതിൽ നിംസ് കുടുംബം നിങ്ങൾ ഓരോരുത്തർക്കും നന്ദിയും സ്നേഹവും അറിയിച്ചുകൊള്ളുന്നു.പ്രസ്തുത ചടങ്ങിൽ പങ്കെടുത്തു ഞങ്ങളോടൊപ്പം എന്നും നിലകൊള്ളുന്ന ബഹുമാനപ്പെട്ട നെയ്യാറ്റിൻകര എം എൽ എ ശ്രീ കെ ആൻസലൻ, നെയ്യാറ്റിൻകര മുനിസിപ്പൽ ചെയർമാൻ ശ്രീ രാജ്‌മോഹൻ,ആരോഗ്യ സ്റ്റാൻഡിങ് കമ്മറ്റി ചെയർമാൻ ശ്രീ ജോസ് ഫ്രാങ്ക്‌ളിൻ, സിപിഎം ഏരിയ സെക്രട്ടറി ശ്രീ ശ്രീകുമാർ,ബാലരാമപുരം പഞ്ചായത്ത്  പ്രസിഡന്റ്‌ ശ്രീ മോഹൻ,കൗൺസിലർ ശ്രീ മഹേഷ്‌ കൂട്ടപ്പന, ശ്രീ മഞ്ചന്തല സുരേഷ് തുടങ്ങിയവർ സംബന്ധിച്ചു.ഈ അവസരത്തിൽ നിംസ് കുടുംബത്തിന്റെ തന്നെ ഒരു ഭാഗമായി മാറിക്കഴിഞ്ഞ കേരള സപ്ലൈക്കോ ത്രിവേണി ബസ് ജീവനക്കാർക്കും ഞങ്ങളുടെ നന്ദിയും സ്നേഹവും അറിയിച്ചുകൊള്ളുന്നു..",
      thumb: "assets/img/pensionscheme/134.jpg",
    },
    {
      src: "assets/img/pensionscheme/135.jpg",
      caption:
        "നെയ്യാറ്റിൻകര പെൻഷൻ പദ്ധതിയിൽ അംഗങ്ങളായ നെയ്യാറ്റിൻകര മുൻസിപ്പാലിറ്റിയിലെ തന്നെ ആറ് പഞ്ചായത്തുകളിലെ നിർധനരായ ഭിന്നശേഷി വിദ്യാർഥികൾ , നിംസ് സെന്റർ ഫോർ സ്പെഷ്യലി ഏബിലിട് ഇലെ വിദ്യാർഥികൾ, നിംസ് ഓട്ടോസ്റ്റാൻഡ് തൊഴിലാളികൾ, ആറാലുംമൂട് ലോഡിങ് യൂണിയൻ തൊഴിലാകിൾ,500 ഓളം വരുന്ന നിർധനരായ മറ്റു പ്രിയപ്പെട്ടവർ,1600 ഓളം നിംസ് സ്റ്റാഫുകൾ ഡോക്ടർസ് തുടങ്ങി   3500 ഓളം വരുന്ന ഞങ്ങളുടെ പ്രിയപ്പെട്ടവർക്കു ഈ വർഷവും  ഓണകിറ്റ് നൽകാൻ കഴിഞ്ഞതിൽ നിംസ് കുടുംബം നിങ്ങൾ ഓരോരുത്തർക്കും നന്ദിയും സ്നേഹവും അറിയിച്ചുകൊള്ളുന്നു.പ്രസ്തുത ചടങ്ങിൽ പങ്കെടുത്തു ഞങ്ങളോടൊപ്പം എന്നും നിലകൊള്ളുന്ന ബഹുമാനപ്പെട്ട നെയ്യാറ്റിൻകര എം എൽ എ ശ്രീ കെ ആൻസലൻ, നെയ്യാറ്റിൻകര മുനിസിപ്പൽ ചെയർമാൻ ശ്രീ രാജ്‌മോഹൻ,ആരോഗ്യ സ്റ്റാൻഡിങ് കമ്മറ്റി ചെയർമാൻ ശ്രീ ജോസ് ഫ്രാങ്ക്‌ളിൻ, സിപിഎം ഏരിയ സെക്രട്ടറി ശ്രീ ശ്രീകുമാർ,ബാലരാമപുരം പഞ്ചായത്ത്  പ്രസിഡന്റ്‌ ശ്രീ മോഹൻ,കൗൺസിലർ ശ്രീ മഹേഷ്‌ കൂട്ടപ്പന, ശ്രീ മഞ്ചന്തല സുരേഷ് തുടങ്ങിയവർ സംബന്ധിച്ചു.ഈ അവസരത്തിൽ നിംസ് കുടുംബത്തിന്റെ തന്നെ ഒരു ഭാഗമായി മാറിക്കഴിഞ്ഞ കേരള സപ്ലൈക്കോ ത്രിവേണി ബസ് ജീവനക്കാർക്കും ഞങ്ങളുടെ നന്ദിയും സ്നേഹവും അറിയിച്ചുകൊള്ളുന്നു..",
      thumb: "assets/img/pensionscheme/135.jpg",
    },
    {
      src: "assets/img/pensionscheme/136.jpg",
      caption:
        "നെയ്യാറ്റിൻകര പെൻഷൻ പദ്ധതിയിൽ അംഗങ്ങളായ നെയ്യാറ്റിൻകര മുൻസിപ്പാലിറ്റിയിലെ തന്നെ ആറ് പഞ്ചായത്തുകളിലെ നിർധനരായ ഭിന്നശേഷി വിദ്യാർഥികൾ , നിംസ് സെന്റർ ഫോർ സ്പെഷ്യലി ഏബിലിട് ഇലെ വിദ്യാർഥികൾ, നിംസ് ഓട്ടോസ്റ്റാൻഡ് തൊഴിലാളികൾ, ആറാലുംമൂട് ലോഡിങ് യൂണിയൻ തൊഴിലാകിൾ,500 ഓളം വരുന്ന നിർധനരായ മറ്റു പ്രിയപ്പെട്ടവർ,1600 ഓളം നിംസ് സ്റ്റാഫുകൾ ഡോക്ടർസ് തുടങ്ങി   3500 ഓളം വരുന്ന ഞങ്ങളുടെ പ്രിയപ്പെട്ടവർക്കു ഈ വർഷവും  ഓണകിറ്റ് നൽകാൻ കഴിഞ്ഞതിൽ നിംസ് കുടുംബം നിങ്ങൾ ഓരോരുത്തർക്കും നന്ദിയും സ്നേഹവും അറിയിച്ചുകൊള്ളുന്നു.പ്രസ്തുത ചടങ്ങിൽ പങ്കെടുത്തു ഞങ്ങളോടൊപ്പം എന്നും നിലകൊള്ളുന്ന ബഹുമാനപ്പെട്ട നെയ്യാറ്റിൻകര എം എൽ എ ശ്രീ കെ ആൻസലൻ, നെയ്യാറ്റിൻകര മുനിസിപ്പൽ ചെയർമാൻ ശ്രീ രാജ്‌മോഹൻ,ആരോഗ്യ സ്റ്റാൻഡിങ് കമ്മറ്റി ചെയർമാൻ ശ്രീ ജോസ് ഫ്രാങ്ക്‌ളിൻ, സിപിഎം ഏരിയ സെക്രട്ടറി ശ്രീ ശ്രീകുമാർ,ബാലരാമപുരം പഞ്ചായത്ത്  പ്രസിഡന്റ്‌ ശ്രീ മോഹൻ,കൗൺസിലർ ശ്രീ മഹേഷ്‌ കൂട്ടപ്പന, ശ്രീ മഞ്ചന്തല സുരേഷ് തുടങ്ങിയവർ സംബന്ധിച്ചു.ഈ അവസരത്തിൽ നിംസ് കുടുംബത്തിന്റെ തന്നെ ഒരു ഭാഗമായി മാറിക്കഴിഞ്ഞ കേരള സപ്ലൈക്കോ ത്രിവേണി ബസ് ജീവനക്കാർക്കും ഞങ്ങളുടെ നന്ദിയും സ്നേഹവും അറിയിച്ചുകൊള്ളുന്നു..",
      thumb: "assets/img/pensionscheme/136.jpg",
    },
    {
      src: "assets/img/pensionscheme/137.jpg",
      caption:
        "നെയ്യാറ്റിൻകര പെൻഷൻ പദ്ധതിയിൽ അംഗങ്ങളായ നെയ്യാറ്റിൻകര മുൻസിപ്പാലിറ്റിയിലെ തന്നെ ആറ് പഞ്ചായത്തുകളിലെ നിർധനരായ ഭിന്നശേഷി വിദ്യാർഥികൾ , നിംസ് സെന്റർ ഫോർ സ്പെഷ്യലി ഏബിലിട് ഇലെ വിദ്യാർഥികൾ, നിംസ് ഓട്ടോസ്റ്റാൻഡ് തൊഴിലാളികൾ, ആറാലുംമൂട് ലോഡിങ് യൂണിയൻ തൊഴിലാകിൾ,500 ഓളം വരുന്ന നിർധനരായ മറ്റു പ്രിയപ്പെട്ടവർ,1600 ഓളം നിംസ് സ്റ്റാഫുകൾ ഡോക്ടർസ് തുടങ്ങി   3500 ഓളം വരുന്ന ഞങ്ങളുടെ പ്രിയപ്പെട്ടവർക്കു ഈ വർഷവും  ഓണകിറ്റ് നൽകാൻ കഴിഞ്ഞതിൽ നിംസ് കുടുംബം നിങ്ങൾ ഓരോരുത്തർക്കും നന്ദിയും സ്നേഹവും അറിയിച്ചുകൊള്ളുന്നു.പ്രസ്തുത ചടങ്ങിൽ പങ്കെടുത്തു ഞങ്ങളോടൊപ്പം എന്നും നിലകൊള്ളുന്ന ബഹുമാനപ്പെട്ട നെയ്യാറ്റിൻകര എം എൽ എ ശ്രീ കെ ആൻസലൻ, നെയ്യാറ്റിൻകര മുനിസിപ്പൽ ചെയർമാൻ ശ്രീ രാജ്‌മോഹൻ,ആരോഗ്യ സ്റ്റാൻഡിങ് കമ്മറ്റി ചെയർമാൻ ശ്രീ ജോസ് ഫ്രാങ്ക്‌ളിൻ, സിപിഎം ഏരിയ സെക്രട്ടറി ശ്രീ ശ്രീകുമാർ,ബാലരാമപുരം പഞ്ചായത്ത്  പ്രസിഡന്റ്‌ ശ്രീ മോഹൻ,കൗൺസിലർ ശ്രീ മഹേഷ്‌ കൂട്ടപ്പന, ശ്രീ മഞ്ചന്തല സുരേഷ് തുടങ്ങിയവർ സംബന്ധിച്ചു.ഈ അവസരത്തിൽ നിംസ് കുടുംബത്തിന്റെ തന്നെ ഒരു ഭാഗമായി മാറിക്കഴിഞ്ഞ കേരള സപ്ലൈക്കോ ത്രിവേണി ബസ് ജീവനക്കാർക്കും ഞങ്ങളുടെ നന്ദിയും സ്നേഹവും അറിയിച്ചുകൊള്ളുന്നു..",
      thumb: "assets/img/pensionscheme/137.jpg",
    },
    {
      src: "assets/img/pensionscheme/138.jpg",
      caption:
        "നെയ്യാറ്റിൻകര പെൻഷൻ പദ്ധതിയിൽ അംഗങ്ങളായ നെയ്യാറ്റിൻകര മുൻസിപ്പാലിറ്റിയിലെ തന്നെ ആറ് പഞ്ചായത്തുകളിലെ നിർധനരായ ഭിന്നശേഷി വിദ്യാർഥികൾ , നിംസ് സെന്റർ ഫോർ സ്പെഷ്യലി ഏബിലിട് ഇലെ വിദ്യാർഥികൾ, നിംസ് ഓട്ടോസ്റ്റാൻഡ് തൊഴിലാളികൾ, ആറാലുംമൂട് ലോഡിങ് യൂണിയൻ തൊഴിലാകിൾ,500 ഓളം വരുന്ന നിർധനരായ മറ്റു പ്രിയപ്പെട്ടവർ,1600 ഓളം നിംസ് സ്റ്റാഫുകൾ ഡോക്ടർസ് തുടങ്ങി   3500 ഓളം വരുന്ന ഞങ്ങളുടെ പ്രിയപ്പെട്ടവർക്കു ഈ വർഷവും  ഓണകിറ്റ് നൽകാൻ കഴിഞ്ഞതിൽ നിംസ് കുടുംബം നിങ്ങൾ ഓരോരുത്തർക്കും നന്ദിയും സ്നേഹവും അറിയിച്ചുകൊള്ളുന്നു.പ്രസ്തുത ചടങ്ങിൽ പങ്കെടുത്തു ഞങ്ങളോടൊപ്പം എന്നും നിലകൊള്ളുന്ന ബഹുമാനപ്പെട്ട നെയ്യാറ്റിൻകര എം എൽ എ ശ്രീ കെ ആൻസലൻ, നെയ്യാറ്റിൻകര മുനിസിപ്പൽ ചെയർമാൻ ശ്രീ രാജ്‌മോഹൻ,ആരോഗ്യ സ്റ്റാൻഡിങ് കമ്മറ്റി ചെയർമാൻ ശ്രീ ജോസ് ഫ്രാങ്ക്‌ളിൻ, സിപിഎം ഏരിയ സെക്രട്ടറി ശ്രീ ശ്രീകുമാർ,ബാലരാമപുരം പഞ്ചായത്ത്  പ്രസിഡന്റ്‌ ശ്രീ മോഹൻ,കൗൺസിലർ ശ്രീ മഹേഷ്‌ കൂട്ടപ്പന, ശ്രീ മഞ്ചന്തല സുരേഷ് തുടങ്ങിയവർ സംബന്ധിച്ചു.ഈ അവസരത്തിൽ നിംസ് കുടുംബത്തിന്റെ തന്നെ ഒരു ഭാഗമായി മാറിക്കഴിഞ്ഞ കേരള സപ്ലൈക്കോ ത്രിവേണി ബസ് ജീവനക്കാർക്കും ഞങ്ങളുടെ നന്ദിയും സ്നേഹവും അറിയിച്ചുകൊള്ളുന്നു..",
      thumb: "assets/img/pensionscheme/138.jpg",
    },
    {
      src: "assets/img/pensionscheme/139.jpg",
      caption:
        "നെയ്യാറ്റിൻകര പെൻഷൻ പദ്ധതിയിൽ അംഗങ്ങളായ നെയ്യാറ്റിൻകര മുൻസിപ്പാലിറ്റിയിലെ തന്നെ ആറ് പഞ്ചായത്തുകളിലെ നിർധനരായ ഭിന്നശേഷി വിദ്യാർഥികൾ , നിംസ് സെന്റർ ഫോർ സ്പെഷ്യലി ഏബിലിട് ഇലെ വിദ്യാർഥികൾ, നിംസ് ഓട്ടോസ്റ്റാൻഡ് തൊഴിലാളികൾ, ആറാലുംമൂട് ലോഡിങ് യൂണിയൻ തൊഴിലാകിൾ,500 ഓളം വരുന്ന നിർധനരായ മറ്റു പ്രിയപ്പെട്ടവർ,1600 ഓളം നിംസ് സ്റ്റാഫുകൾ ഡോക്ടർസ് തുടങ്ങി   3500 ഓളം വരുന്ന ഞങ്ങളുടെ പ്രിയപ്പെട്ടവർക്കു ഈ വർഷവും  ഓണകിറ്റ് നൽകാൻ കഴിഞ്ഞതിൽ നിംസ് കുടുംബം നിങ്ങൾ ഓരോരുത്തർക്കും നന്ദിയും സ്നേഹവും അറിയിച്ചുകൊള്ളുന്നു.പ്രസ്തുത ചടങ്ങിൽ പങ്കെടുത്തു ഞങ്ങളോടൊപ്പം എന്നും നിലകൊള്ളുന്ന ബഹുമാനപ്പെട്ട നെയ്യാറ്റിൻകര എം എൽ എ ശ്രീ കെ ആൻസലൻ, നെയ്യാറ്റിൻകര മുനിസിപ്പൽ ചെയർമാൻ ശ്രീ രാജ്‌മോഹൻ,ആരോഗ്യ സ്റ്റാൻഡിങ് കമ്മറ്റി ചെയർമാൻ ശ്രീ ജോസ് ഫ്രാങ്ക്‌ളിൻ, സിപിഎം ഏരിയ സെക്രട്ടറി ശ്രീ ശ്രീകുമാർ,ബാലരാമപുരം പഞ്ചായത്ത്  പ്രസിഡന്റ്‌ ശ്രീ മോഹൻ,കൗൺസിലർ ശ്രീ മഹേഷ്‌ കൂട്ടപ്പന, ശ്രീ മഞ്ചന്തല സുരേഷ് തുടങ്ങിയവർ സംബന്ധിച്ചു.ഈ അവസരത്തിൽ നിംസ് കുടുംബത്തിന്റെ തന്നെ ഒരു ഭാഗമായി മാറിക്കഴിഞ്ഞ കേരള സപ്ലൈക്കോ ത്രിവേണി ബസ് ജീവനക്കാർക്കും ഞങ്ങളുടെ നന്ദിയും സ്നേഹവും അറിയിച്ചുകൊള്ളുന്നു..",
      thumb: "assets/img/pensionscheme/139.jpg",
    },
    {
      src: "assets/img/pensionscheme/140.jpg",
      caption:
        "നെയ്യാറ്റിൻകര പെൻഷൻ പദ്ധതിയിൽ അംഗങ്ങളായ നെയ്യാറ്റിൻകര മുൻസിപ്പാലിറ്റിയിലെ തന്നെ ആറ് പഞ്ചായത്തുകളിലെ നിർധനരായ ഭിന്നശേഷി വിദ്യാർഥികൾ , നിംസ് സെന്റർ ഫോർ സ്പെഷ്യലി ഏബിലിട് ഇലെ വിദ്യാർഥികൾ, നിംസ് ഓട്ടോസ്റ്റാൻഡ് തൊഴിലാളികൾ, ആറാലുംമൂട് ലോഡിങ് യൂണിയൻ തൊഴിലാകിൾ,500 ഓളം വരുന്ന നിർധനരായ മറ്റു പ്രിയപ്പെട്ടവർ,1600 ഓളം നിംസ് സ്റ്റാഫുകൾ ഡോക്ടർസ് തുടങ്ങി   3500 ഓളം വരുന്ന ഞങ്ങളുടെ പ്രിയപ്പെട്ടവർക്കു ഈ വർഷവും  ഓണകിറ്റ് നൽകാൻ കഴിഞ്ഞതിൽ നിംസ് കുടുംബം നിങ്ങൾ ഓരോരുത്തർക്കും നന്ദിയും സ്നേഹവും അറിയിച്ചുകൊള്ളുന്നു.പ്രസ്തുത ചടങ്ങിൽ പങ്കെടുത്തു ഞങ്ങളോടൊപ്പം എന്നും നിലകൊള്ളുന്ന ബഹുമാനപ്പെട്ട നെയ്യാറ്റിൻകര എം എൽ എ ശ്രീ കെ ആൻസലൻ, നെയ്യാറ്റിൻകര മുനിസിപ്പൽ ചെയർമാൻ ശ്രീ രാജ്‌മോഹൻ,ആരോഗ്യ സ്റ്റാൻഡിങ് കമ്മറ്റി ചെയർമാൻ ശ്രീ ജോസ് ഫ്രാങ്ക്‌ളിൻ, സിപിഎം ഏരിയ സെക്രട്ടറി ശ്രീ ശ്രീകുമാർ,ബാലരാമപുരം പഞ്ചായത്ത്  പ്രസിഡന്റ്‌ ശ്രീ മോഹൻ,കൗൺസിലർ ശ്രീ മഹേഷ്‌ കൂട്ടപ്പന, ശ്രീ മഞ്ചന്തല സുരേഷ് തുടങ്ങിയവർ സംബന്ധിച്ചു.ഈ അവസരത്തിൽ നിംസ് കുടുംബത്തിന്റെ തന്നെ ഒരു ഭാഗമായി മാറിക്കഴിഞ്ഞ കേരള സപ്ലൈക്കോ ത്രിവേണി ബസ് ജീവനക്കാർക്കും ഞങ്ങളുടെ നന്ദിയും സ്നേഹവും അറിയിച്ചുകൊള്ളുന്നു..",
      thumb: "assets/img/pensionscheme/140.jpg",
    },
    {
      src: "assets/img/pensionscheme/141.jpg",
      caption:
        "നെയ്യാറ്റിൻകര പെൻഷൻ പദ്ധതിയിൽ അംഗങ്ങളായ നെയ്യാറ്റിൻകര മുൻസിപ്പാലിറ്റിയിലെ തന്നെ ആറ് പഞ്ചായത്തുകളിലെ നിർധനരായ ഭിന്നശേഷി വിദ്യാർഥികൾ , നിംസ് സെന്റർ ഫോർ സ്പെഷ്യലി ഏബിലിട് ഇലെ വിദ്യാർഥികൾ, നിംസ് ഓട്ടോസ്റ്റാൻഡ് തൊഴിലാളികൾ, ആറാലുംമൂട് ലോഡിങ് യൂണിയൻ തൊഴിലാകിൾ,500 ഓളം വരുന്ന നിർധനരായ മറ്റു പ്രിയപ്പെട്ടവർ,1600 ഓളം നിംസ് സ്റ്റാഫുകൾ ഡോക്ടർസ് തുടങ്ങി   3500 ഓളം വരുന്ന ഞങ്ങളുടെ പ്രിയപ്പെട്ടവർക്കു ഈ വർഷവും  ഓണകിറ്റ് നൽകാൻ കഴിഞ്ഞതിൽ നിംസ് കുടുംബം നിങ്ങൾ ഓരോരുത്തർക്കും നന്ദിയും സ്നേഹവും അറിയിച്ചുകൊള്ളുന്നു.പ്രസ്തുത ചടങ്ങിൽ പങ്കെടുത്തു ഞങ്ങളോടൊപ്പം എന്നും നിലകൊള്ളുന്ന ബഹുമാനപ്പെട്ട നെയ്യാറ്റിൻകര എം എൽ എ ശ്രീ കെ ആൻസലൻ, നെയ്യാറ്റിൻകര മുനിസിപ്പൽ ചെയർമാൻ ശ്രീ രാജ്‌മോഹൻ,ആരോഗ്യ സ്റ്റാൻഡിങ് കമ്മറ്റി ചെയർമാൻ ശ്രീ ജോസ് ഫ്രാങ്ക്‌ളിൻ, സിപിഎം ഏരിയ സെക്രട്ടറി ശ്രീ ശ്രീകുമാർ,ബാലരാമപുരം പഞ്ചായത്ത്  പ്രസിഡന്റ്‌ ശ്രീ മോഹൻ,കൗൺസിലർ ശ്രീ മഹേഷ്‌ കൂട്ടപ്പന, ശ്രീ മഞ്ചന്തല സുരേഷ് തുടങ്ങിയവർ സംബന്ധിച്ചു.ഈ അവസരത്തിൽ നിംസ് കുടുംബത്തിന്റെ തന്നെ ഒരു ഭാഗമായി മാറിക്കഴിഞ്ഞ കേരള സപ്ലൈക്കോ ത്രിവേണി ബസ് ജീവനക്കാർക്കും ഞങ്ങളുടെ നന്ദിയും സ്നേഹവും അറിയിച്ചുകൊള്ളുന്നു..",
      thumb: "assets/img/pensionscheme/141.jpg",
    },
    {
      src: "assets/img/pensionscheme/142.jpg",
      caption:
        "നെയ്യാറ്റിൻകര പെൻഷൻ പദ്ധതിയിൽ അംഗങ്ങളായ നെയ്യാറ്റിൻകര മുൻസിപ്പാലിറ്റിയിലെ തന്നെ ആറ് പഞ്ചായത്തുകളിലെ നിർധനരായ ഭിന്നശേഷി വിദ്യാർഥികൾ , നിംസ് സെന്റർ ഫോർ സ്പെഷ്യലി ഏബിലിട് ഇലെ വിദ്യാർഥികൾ, നിംസ് ഓട്ടോസ്റ്റാൻഡ് തൊഴിലാളികൾ, ആറാലുംമൂട് ലോഡിങ് യൂണിയൻ തൊഴിലാകിൾ,500 ഓളം വരുന്ന നിർധനരായ മറ്റു പ്രിയപ്പെട്ടവർ,1600 ഓളം നിംസ് സ്റ്റാഫുകൾ ഡോക്ടർസ് തുടങ്ങി   3500 ഓളം വരുന്ന ഞങ്ങളുടെ പ്രിയപ്പെട്ടവർക്കു ഈ വർഷവും  ഓണകിറ്റ് നൽകാൻ കഴിഞ്ഞതിൽ നിംസ് കുടുംബം നിങ്ങൾ ഓരോരുത്തർക്കും നന്ദിയും സ്നേഹവും അറിയിച്ചുകൊള്ളുന്നു.പ്രസ്തുത ചടങ്ങിൽ പങ്കെടുത്തു ഞങ്ങളോടൊപ്പം എന്നും നിലകൊള്ളുന്ന ബഹുമാനപ്പെട്ട നെയ്യാറ്റിൻകര എം എൽ എ ശ്രീ കെ ആൻസലൻ, നെയ്യാറ്റിൻകര മുനിസിപ്പൽ ചെയർമാൻ ശ്രീ രാജ്‌മോഹൻ,ആരോഗ്യ സ്റ്റാൻഡിങ് കമ്മറ്റി ചെയർമാൻ ശ്രീ ജോസ് ഫ്രാങ്ക്‌ളിൻ, സിപിഎം ഏരിയ സെക്രട്ടറി ശ്രീ ശ്രീകുമാർ,ബാലരാമപുരം പഞ്ചായത്ത്  പ്രസിഡന്റ്‌ ശ്രീ മോഹൻ,കൗൺസിലർ ശ്രീ മഹേഷ്‌ കൂട്ടപ്പന, ശ്രീ മഞ്ചന്തല സുരേഷ് തുടങ്ങിയവർ സംബന്ധിച്ചു.ഈ അവസരത്തിൽ നിംസ് കുടുംബത്തിന്റെ തന്നെ ഒരു ഭാഗമായി മാറിക്കഴിഞ്ഞ കേരള സപ്ലൈക്കോ ത്രിവേണി ബസ് ജീവനക്കാർക്കും ഞങ്ങളുടെ നന്ദിയും സ്നേഹവും അറിയിച്ചുകൊള്ളുന്നു..",
      thumb: "assets/img/pensionscheme/142.jpg",
    },
    {
      src: "assets/img/pensionscheme/143.jpg",
      caption:
        "നെയ്യാറ്റിൻകര പെൻഷൻ പദ്ധതിയിൽ അംഗങ്ങളായ നെയ്യാറ്റിൻകര മുൻസിപ്പാലിറ്റിയിലെ തന്നെ ആറ് പഞ്ചായത്തുകളിലെ നിർധനരായ ഭിന്നശേഷി വിദ്യാർഥികൾ , നിംസ് സെന്റർ ഫോർ സ്പെഷ്യലി ഏബിലിട് ഇലെ വിദ്യാർഥികൾ, നിംസ് ഓട്ടോസ്റ്റാൻഡ് തൊഴിലാളികൾ, ആറാലുംമൂട് ലോഡിങ് യൂണിയൻ തൊഴിലാകിൾ,500 ഓളം വരുന്ന നിർധനരായ മറ്റു പ്രിയപ്പെട്ടവർ,1600 ഓളം നിംസ് സ്റ്റാഫുകൾ ഡോക്ടർസ് തുടങ്ങി   3500 ഓളം വരുന്ന ഞങ്ങളുടെ പ്രിയപ്പെട്ടവർക്കു ഈ വർഷവും  ഓണകിറ്റ് നൽകാൻ കഴിഞ്ഞതിൽ നിംസ് കുടുംബം നിങ്ങൾ ഓരോരുത്തർക്കും നന്ദിയും സ്നേഹവും അറിയിച്ചുകൊള്ളുന്നു.പ്രസ്തുത ചടങ്ങിൽ പങ്കെടുത്തു ഞങ്ങളോടൊപ്പം എന്നും നിലകൊള്ളുന്ന ബഹുമാനപ്പെട്ട നെയ്യാറ്റിൻകര എം എൽ എ ശ്രീ കെ ആൻസലൻ, നെയ്യാറ്റിൻകര മുനിസിപ്പൽ ചെയർമാൻ ശ്രീ രാജ്‌മോഹൻ,ആരോഗ്യ സ്റ്റാൻഡിങ് കമ്മറ്റി ചെയർമാൻ ശ്രീ ജോസ് ഫ്രാങ്ക്‌ളിൻ, സിപിഎം ഏരിയ സെക്രട്ടറി ശ്രീ ശ്രീകുമാർ,ബാലരാമപുരം പഞ്ചായത്ത്  പ്രസിഡന്റ്‌ ശ്രീ മോഹൻ,കൗൺസിലർ ശ്രീ മഹേഷ്‌ കൂട്ടപ്പന, ശ്രീ മഞ്ചന്തല സുരേഷ് തുടങ്ങിയവർ സംബന്ധിച്ചു.ഈ അവസരത്തിൽ നിംസ് കുടുംബത്തിന്റെ തന്നെ ഒരു ഭാഗമായി മാറിക്കഴിഞ്ഞ കേരള സപ്ലൈക്കോ ത്രിവേണി ബസ് ജീവനക്കാർക്കും ഞങ്ങളുടെ നന്ദിയും സ്നേഹവും അറിയിച്ചുകൊള്ളുന്നു..",
      thumb: "assets/img/pensionscheme/143.jpg",
    },
    {
      src: "assets/img/pensionscheme/144.jpg",
      caption:
        "നെയ്യാറ്റിൻകര പെൻഷൻ പദ്ധതിയിൽ അംഗങ്ങളായ നെയ്യാറ്റിൻകര മുൻസിപ്പാലിറ്റിയിലെ തന്നെ ആറ് പഞ്ചായത്തുകളിലെ നിർധനരായ ഭിന്നശേഷി വിദ്യാർഥികൾ , നിംസ് സെന്റർ ഫോർ സ്പെഷ്യലി ഏബിലിട് ഇലെ വിദ്യാർഥികൾ, നിംസ് ഓട്ടോസ്റ്റാൻഡ് തൊഴിലാളികൾ, ആറാലുംമൂട് ലോഡിങ് യൂണിയൻ തൊഴിലാകിൾ,500 ഓളം വരുന്ന നിർധനരായ മറ്റു പ്രിയപ്പെട്ടവർ,1600 ഓളം നിംസ് സ്റ്റാഫുകൾ ഡോക്ടർസ് തുടങ്ങി   3500 ഓളം വരുന്ന ഞങ്ങളുടെ പ്രിയപ്പെട്ടവർക്കു ഈ വർഷവും  ഓണകിറ്റ് നൽകാൻ കഴിഞ്ഞതിൽ നിംസ് കുടുംബം നിങ്ങൾ ഓരോരുത്തർക്കും നന്ദിയും സ്നേഹവും അറിയിച്ചുകൊള്ളുന്നു.പ്രസ്തുത ചടങ്ങിൽ പങ്കെടുത്തു ഞങ്ങളോടൊപ്പം എന്നും നിലകൊള്ളുന്ന ബഹുമാനപ്പെട്ട നെയ്യാറ്റിൻകര എം എൽ എ ശ്രീ കെ ആൻസലൻ, നെയ്യാറ്റിൻകര മുനിസിപ്പൽ ചെയർമാൻ ശ്രീ രാജ്‌മോഹൻ,ആരോഗ്യ സ്റ്റാൻഡിങ് കമ്മറ്റി ചെയർമാൻ ശ്രീ ജോസ് ഫ്രാങ്ക്‌ളിൻ, സിപിഎം ഏരിയ സെക്രട്ടറി ശ്രീ ശ്രീകുമാർ,ബാലരാമപുരം പഞ്ചായത്ത്  പ്രസിഡന്റ്‌ ശ്രീ മോഹൻ,കൗൺസിലർ ശ്രീ മഹേഷ്‌ കൂട്ടപ്പന, ശ്രീ മഞ്ചന്തല സുരേഷ് തുടങ്ങിയവർ സംബന്ധിച്ചു.ഈ അവസരത്തിൽ നിംസ് കുടുംബത്തിന്റെ തന്നെ ഒരു ഭാഗമായി മാറിക്കഴിഞ്ഞ കേരള സപ്ലൈക്കോ ത്രിവേണി ബസ് ജീവനക്കാർക്കും ഞങ്ങളുടെ നന്ദിയും സ്നേഹവും അറിയിച്ചുകൊള്ളുന്നു..",
      thumb: "assets/img/pensionscheme/144.jpg",
    },
    {
      src: "assets/img/pensionscheme/145.jpg",
      caption:
        "നെയ്യാറ്റിൻകര പെൻഷൻ പദ്ധതിയിൽ അംഗങ്ങളായ നെയ്യാറ്റിൻകര മുൻസിപ്പാലിറ്റിയിലെ തന്നെ ആറ് പഞ്ചായത്തുകളിലെ നിർധനരായ ഭിന്നശേഷി വിദ്യാർഥികൾ , നിംസ് സെന്റർ ഫോർ സ്പെഷ്യലി ഏബിലിട് ഇലെ വിദ്യാർഥികൾ, നിംസ് ഓട്ടോസ്റ്റാൻഡ് തൊഴിലാളികൾ, ആറാലുംമൂട് ലോഡിങ് യൂണിയൻ തൊഴിലാകിൾ,500 ഓളം വരുന്ന നിർധനരായ മറ്റു പ്രിയപ്പെട്ടവർ,1600 ഓളം നിംസ് സ്റ്റാഫുകൾ ഡോക്ടർസ് തുടങ്ങി   3500 ഓളം വരുന്ന ഞങ്ങളുടെ പ്രിയപ്പെട്ടവർക്കു ഈ വർഷവും  ഓണകിറ്റ് നൽകാൻ കഴിഞ്ഞതിൽ നിംസ് കുടുംബം നിങ്ങൾ ഓരോരുത്തർക്കും നന്ദിയും സ്നേഹവും അറിയിച്ചുകൊള്ളുന്നു.പ്രസ്തുത ചടങ്ങിൽ പങ്കെടുത്തു ഞങ്ങളോടൊപ്പം എന്നും നിലകൊള്ളുന്ന ബഹുമാനപ്പെട്ട നെയ്യാറ്റിൻകര എം എൽ എ ശ്രീ കെ ആൻസലൻ, നെയ്യാറ്റിൻകര മുനിസിപ്പൽ ചെയർമാൻ ശ്രീ രാജ്‌മോഹൻ,ആരോഗ്യ സ്റ്റാൻഡിങ് കമ്മറ്റി ചെയർമാൻ ശ്രീ ജോസ് ഫ്രാങ്ക്‌ളിൻ, സിപിഎം ഏരിയ സെക്രട്ടറി ശ്രീ ശ്രീകുമാർ,ബാലരാമപുരം പഞ്ചായത്ത്  പ്രസിഡന്റ്‌ ശ്രീ മോഹൻ,കൗൺസിലർ ശ്രീ മഹേഷ്‌ കൂട്ടപ്പന, ശ്രീ മഞ്ചന്തല സുരേഷ് തുടങ്ങിയവർ സംബന്ധിച്ചു.ഈ അവസരത്തിൽ നിംസ് കുടുംബത്തിന്റെ തന്നെ ഒരു ഭാഗമായി മാറിക്കഴിഞ്ഞ കേരള സപ്ലൈക്കോ ത്രിവേണി ബസ് ജീവനക്കാർക്കും ഞങ്ങളുടെ നന്ദിയും സ്നേഹവും അറിയിച്ചുകൊള്ളുന്നു..",
      thumb: "assets/img/pensionscheme/145.jpg",
    },
    {
      src: "assets/img/pensionscheme/106.jpeg",
      caption:
        "വേൾഡ് യൂത്ത് സ്കിൽ ദിനമായ ജൂലൈ 15 ന് നിംസ് മെഡിസിറ്റി നടത്തിവരുന്ന നെയ്യാറ്റിൻകര പെൻഷൻ പ്ളാൻ ഉപഭോക്താക്കളായ കുട്ടികൾക്കും അമ്മമാർക്കും തൊഴിൽ പരിശീലന പരിപാടി സംഘടിപ്പിച്ചു. നിംസ് മെഡിസിറ്റി ജനറൽ മാനേജർ ഡോ.കെ.എ. സജു അദ്ധ്യക്ഷത വഹിച്ച ചടങ്ങിൽ ചൈൽഡ് വെൽഫെയർ കമ്മിറ്റി  ചെയർപേഴ്സൺ  ഷാഹിന ബീഗം ഉദ്ഘാടനം ചെയ്തു സംസാരിച്ചു. ഭിന്നശേഷി കുട്ടികൾക്കും കുടുംബത്തിനും താങ്ങായി മാറുകയാണ് ഇത്തരം പദ്ധതികളെന്നും ഇത്തരത്തിൽ മാതൃകാ പ്രവർത്തനം നടത്തുന്ന നിംസ് മെഡിസിറ്റി എംഡി, എം .എസ് .ഫൈസൽ ഖാൻ  സേവനത്തിന്റെ മാതൃകാ മുഖമായി മാറുകയാണെന്നും ഉദ്ഘാടനം ചെയ്തു സംസാരിച്ചു. നിംസ് നെയ്യാറ്റിൻകര പെൻഷൻ പ്ളാൻ ചെയർ പേഴ്സൺ  രേണു.കെ.ആർ പദ്ധതി വിവരണവും സ്വാഗതവും ആശംസിച്ചു.  ഡിസ്ട്രിക്ട് സോഷ്യൽ വെൽഫയർ ഓഫീസർ  ഷൈനി മോൾ തൊഴിൽ പരിശീലനത്തിന്റെ പ്രവർത്തനോത്ഘാടനം നിർവ്വഹിച്ചു. കേരള സംസ്ഥാന വികലാംഗ കോർപ്പറേഷൻ ചെയർ പേഴ്സൺ ജയാ ഡാളി നെയ്യാറ്റിൻകര പെൻഷൻ പ്ലാനിന്റെ ഭാഗമായുള്ള അഡീഷണൽ  പെൻഷൻ വിതരണത്തിന്റെ ഉദ്ഘാടനം ചെയ്യുകയുണ്ടായി. ചടങ്ങിൽ  നിംസ് സ്പെക്ട്രം ഡയറക്ടറും മുൻ ആരോഗ്യ സർവ്വകലാശാല വൈസ് ചാൻസലറുമായ ഡോ.എം.കെ.സി നായർ മുഖ്യ  പ്രഭാഷണം നടത്തി. നെയ്യാറ്റിൻകര മുനിസിപ്പാലിറ്റി ആരോഗ്യ സ്റ്റാൻഡിംഗ് കമ്മറ്റി ചെയർമാൻ  ജോസ്ഫ്രാങ്കിളിൻ, മുനിസിപ്പാലിറ്റി കൗൺസിലർ  ഐശ്വര്യ, നിംസ് ഫിസിക്കൽ മെഡിസിൻ വിഭാഗം മേധാവി ഡോ.ജിം ഗോപാല കൃഷ്ണൻ, കോട്ടു കാൽ പഞ്ചായത്ത് പ്രസിഡന്റ്  ജറോം ദാസ് ,പി. ബോബി , ജയകുമാർ തുടങ്ങിയവർ ചടങ്ങിൽ ആശംസ അർപ്പിച്ചു സംസാരിച്ചു.",
      thumb: "assets/img/pensionscheme/106.jpeg",
    },
    {
      src: "assets/img/pensionscheme/107.jpeg",
      caption:
        "വേൾഡ് യൂത്ത് സ്കിൽ ദിനമായ ജൂലൈ 15 ന് നിംസ് മെഡിസിറ്റി നടത്തിവരുന്ന നെയ്യാറ്റിൻകര പെൻഷൻ പ്ളാൻ ഉപഭോക്താക്കളായ കുട്ടികൾക്കും അമ്മമാർക്കും തൊഴിൽ പരിശീലന പരിപാടി സംഘടിപ്പിച്ചു. നിംസ് മെഡിസിറ്റി ജനറൽ മാനേജർ ഡോ.കെ.എ. സജു അദ്ധ്യക്ഷത വഹിച്ച ചടങ്ങിൽ ചൈൽഡ് വെൽഫെയർ കമ്മിറ്റി  ചെയർപേഴ്സൺ  ഷാഹിന ബീഗം ഉദ്ഘാടനം ചെയ്തു സംസാരിച്ചു. ഭിന്നശേഷി കുട്ടികൾക്കും കുടുംബത്തിനും താങ്ങായി മാറുകയാണ് ഇത്തരം പദ്ധതികളെന്നും ഇത്തരത്തിൽ മാതൃകാ പ്രവർത്തനം നടത്തുന്ന നിംസ് മെഡിസിറ്റി എംഡി, എം .എസ് .ഫൈസൽ ഖാൻ  സേവനത്തിന്റെ മാതൃകാ മുഖമായി മാറുകയാണെന്നും ഉദ്ഘാടനം ചെയ്തു സംസാരിച്ചു. നിംസ് നെയ്യാറ്റിൻകര പെൻഷൻ പ്ളാൻ ചെയർ പേഴ്സൺ  രേണു.കെ.ആർ പദ്ധതി വിവരണവും സ്വാഗതവും ആശംസിച്ചു.  ഡിസ്ട്രിക്ട് സോഷ്യൽ വെൽഫയർ ഓഫീസർ  ഷൈനി മോൾ തൊഴിൽ പരിശീലനത്തിന്റെ പ്രവർത്തനോത്ഘാടനം നിർവ്വഹിച്ചു. കേരള സംസ്ഥാന വികലാംഗ കോർപ്പറേഷൻ ചെയർ പേഴ്സൺ ജയാ ഡാളി നെയ്യാറ്റിൻകര പെൻഷൻ പ്ലാനിന്റെ ഭാഗമായുള്ള അഡീഷണൽ  പെൻഷൻ വിതരണത്തിന്റെ ഉദ്ഘാടനം ചെയ്യുകയുണ്ടായി. ചടങ്ങിൽ  നിംസ് സ്പെക്ട്രം ഡയറക്ടറും മുൻ ആരോഗ്യ സർവ്വകലാശാല വൈസ് ചാൻസലറുമായ ഡോ.എം.കെ.സി നായർ മുഖ്യ  പ്രഭാഷണം നടത്തി. നെയ്യാറ്റിൻകര മുനിസിപ്പാലിറ്റി ആരോഗ്യ സ്റ്റാൻഡിംഗ് കമ്മറ്റി ചെയർമാൻ  ജോസ്ഫ്രാങ്കിളിൻ, മുനിസിപ്പാലിറ്റി കൗൺസിലർ  ഐശ്വര്യ, നിംസ് ഫിസിക്കൽ മെഡിസിൻ വിഭാഗം മേധാവി ഡോ.ജിം ഗോപാല കൃഷ്ണൻ, കോട്ടു കാൽ പഞ്ചായത്ത് പ്രസിഡന്റ്  ജറോം ദാസ് ,പി. ബോബി , ജയകുമാർ തുടങ്ങിയവർ ചടങ്ങിൽ ആശംസ അർപ്പിച്ചു സംസാരിച്ചു.",
      thumb: "assets/img/pensionscheme/107.jpeg",
    },
    {
      src: "assets/img/pensionscheme/108.jpeg",
      caption:
        "വേൾഡ് യൂത്ത് സ്കിൽ ദിനമായ ജൂലൈ 15 ന് നിംസ് മെഡിസിറ്റി നടത്തിവരുന്ന നെയ്യാറ്റിൻകര പെൻഷൻ പ്ളാൻ ഉപഭോക്താക്കളായ കുട്ടികൾക്കും അമ്മമാർക്കും തൊഴിൽ പരിശീലന പരിപാടി സംഘടിപ്പിച്ചു. നിംസ് മെഡിസിറ്റി ജനറൽ മാനേജർ ഡോ.കെ.എ. സജു അദ്ധ്യക്ഷത വഹിച്ച ചടങ്ങിൽ ചൈൽഡ് വെൽഫെയർ കമ്മിറ്റി  ചെയർപേഴ്സൺ  ഷാഹിന ബീഗം ഉദ്ഘാടനം ചെയ്തു സംസാരിച്ചു. ഭിന്നശേഷി കുട്ടികൾക്കും കുടുംബത്തിനും താങ്ങായി മാറുകയാണ് ഇത്തരം പദ്ധതികളെന്നും ഇത്തരത്തിൽ മാതൃകാ പ്രവർത്തനം നടത്തുന്ന നിംസ് മെഡിസിറ്റി എംഡി, എം .എസ് .ഫൈസൽ ഖാൻ  സേവനത്തിന്റെ മാതൃകാ മുഖമായി മാറുകയാണെന്നും ഉദ്ഘാടനം ചെയ്തു സംസാരിച്ചു. നിംസ് നെയ്യാറ്റിൻകര പെൻഷൻ പ്ളാൻ ചെയർ പേഴ്സൺ  രേണു.കെ.ആർ പദ്ധതി വിവരണവും സ്വാഗതവും ആശംസിച്ചു.  ഡിസ്ട്രിക്ട് സോഷ്യൽ വെൽഫയർ ഓഫീസർ  ഷൈനി മോൾ തൊഴിൽ പരിശീലനത്തിന്റെ പ്രവർത്തനോത്ഘാടനം നിർവ്വഹിച്ചു. കേരള സംസ്ഥാന വികലാംഗ കോർപ്പറേഷൻ ചെയർ പേഴ്സൺ ജയാ ഡാളി നെയ്യാറ്റിൻകര പെൻഷൻ പ്ലാനിന്റെ ഭാഗമായുള്ള അഡീഷണൽ  പെൻഷൻ വിതരണത്തിന്റെ ഉദ്ഘാടനം ചെയ്യുകയുണ്ടായി. ചടങ്ങിൽ  നിംസ് സ്പെക്ട്രം ഡയറക്ടറും മുൻ ആരോഗ്യ സർവ്വകലാശാല വൈസ് ചാൻസലറുമായ ഡോ.എം.കെ.സി നായർ മുഖ്യ  പ്രഭാഷണം നടത്തി. നെയ്യാറ്റിൻകര മുനിസിപ്പാലിറ്റി ആരോഗ്യ സ്റ്റാൻഡിംഗ് കമ്മറ്റി ചെയർമാൻ  ജോസ്ഫ്രാങ്കിളിൻ, മുനിസിപ്പാലിറ്റി കൗൺസിലർ  ഐശ്വര്യ, നിംസ് ഫിസിക്കൽ മെഡിസിൻ വിഭാഗം മേധാവി ഡോ.ജിം ഗോപാല കൃഷ്ണൻ, കോട്ടു കാൽ പഞ്ചായത്ത് പ്രസിഡന്റ്  ജറോം ദാസ് ,പി. ബോബി , ജയകുമാർ തുടങ്ങിയവർ ചടങ്ങിൽ ആശംസ അർപ്പിച്ചു സംസാരിച്ചു.",
      thumb: "assets/img/pensionscheme/108.jpeg",
    },
    {
      src: "assets/img/pensionscheme/109.jpeg",
      caption:
        "വേൾഡ് യൂത്ത് സ്കിൽ ദിനമായ ജൂലൈ 15 ന് നിംസ് മെഡിസിറ്റി നടത്തിവരുന്ന നെയ്യാറ്റിൻകര പെൻഷൻ പ്ളാൻ ഉപഭോക്താക്കളായ കുട്ടികൾക്കും അമ്മമാർക്കും തൊഴിൽ പരിശീലന പരിപാടി സംഘടിപ്പിച്ചു. നിംസ് മെഡിസിറ്റി ജനറൽ മാനേജർ ഡോ.കെ.എ. സജു അദ്ധ്യക്ഷത വഹിച്ച ചടങ്ങിൽ ചൈൽഡ് വെൽഫെയർ കമ്മിറ്റി  ചെയർപേഴ്സൺ  ഷാഹിന ബീഗം ഉദ്ഘാടനം ചെയ്തു സംസാരിച്ചു. ഭിന്നശേഷി കുട്ടികൾക്കും കുടുംബത്തിനും താങ്ങായി മാറുകയാണ് ഇത്തരം പദ്ധതികളെന്നും ഇത്തരത്തിൽ മാതൃകാ പ്രവർത്തനം നടത്തുന്ന നിംസ് മെഡിസിറ്റി എംഡി, എം .എസ് .ഫൈസൽ ഖാൻ  സേവനത്തിന്റെ മാതൃകാ മുഖമായി മാറുകയാണെന്നും ഉദ്ഘാടനം ചെയ്തു സംസാരിച്ചു. നിംസ് നെയ്യാറ്റിൻകര പെൻഷൻ പ്ളാൻ ചെയർ പേഴ്സൺ  രേണു.കെ.ആർ പദ്ധതി വിവരണവും സ്വാഗതവും ആശംസിച്ചു.  ഡിസ്ട്രിക്ട് സോഷ്യൽ വെൽഫയർ ഓഫീസർ  ഷൈനി മോൾ തൊഴിൽ പരിശീലനത്തിന്റെ പ്രവർത്തനോത്ഘാടനം നിർവ്വഹിച്ചു. കേരള സംസ്ഥാന വികലാംഗ കോർപ്പറേഷൻ ചെയർ പേഴ്സൺ ജയാ ഡാളി നെയ്യാറ്റിൻകര പെൻഷൻ പ്ലാനിന്റെ ഭാഗമായുള്ള അഡീഷണൽ  പെൻഷൻ വിതരണത്തിന്റെ ഉദ്ഘാടനം ചെയ്യുകയുണ്ടായി. ചടങ്ങിൽ  നിംസ് സ്പെക്ട്രം ഡയറക്ടറും മുൻ ആരോഗ്യ സർവ്വകലാശാല വൈസ് ചാൻസലറുമായ ഡോ.എം.കെ.സി നായർ മുഖ്യ  പ്രഭാഷണം നടത്തി. നെയ്യാറ്റിൻകര മുനിസിപ്പാലിറ്റി ആരോഗ്യ സ്റ്റാൻഡിംഗ് കമ്മറ്റി ചെയർമാൻ  ജോസ്ഫ്രാങ്കിളിൻ, മുനിസിപ്പാലിറ്റി കൗൺസിലർ  ഐശ്വര്യ, നിംസ് ഫിസിക്കൽ മെഡിസിൻ വിഭാഗം മേധാവി ഡോ.ജിം ഗോപാല കൃഷ്ണൻ, കോട്ടു കാൽ പഞ്ചായത്ത് പ്രസിഡന്റ്  ജറോം ദാസ് ,പി. ബോബി , ജയകുമാർ തുടങ്ങിയവർ ചടങ്ങിൽ ആശംസ അർപ്പിച്ചു സംസാരിച്ചു.",
      thumb: "assets/img/pensionscheme/109.jpeg",
    },
    {
      src: "assets/img/pensionscheme/110.jpeg",
      caption:
        "വേൾഡ് യൂത്ത് സ്കിൽ ദിനമായ ജൂലൈ 15 ന് നിംസ് മെഡിസിറ്റി നടത്തിവരുന്ന നെയ്യാറ്റിൻകര പെൻഷൻ പ്ളാൻ ഉപഭോക്താക്കളായ കുട്ടികൾക്കും അമ്മമാർക്കും തൊഴിൽ പരിശീലന പരിപാടി സംഘടിപ്പിച്ചു. നിംസ് മെഡിസിറ്റി ജനറൽ മാനേജർ ഡോ.കെ.എ. സജു അദ്ധ്യക്ഷത വഹിച്ച ചടങ്ങിൽ ചൈൽഡ് വെൽഫെയർ കമ്മിറ്റി  ചെയർപേഴ്സൺ  ഷാഹിന ബീഗം ഉദ്ഘാടനം ചെയ്തു സംസാരിച്ചു. ഭിന്നശേഷി കുട്ടികൾക്കും കുടുംബത്തിനും താങ്ങായി മാറുകയാണ് ഇത്തരം പദ്ധതികളെന്നും ഇത്തരത്തിൽ മാതൃകാ പ്രവർത്തനം നടത്തുന്ന നിംസ് മെഡിസിറ്റി എംഡി, എം .എസ് .ഫൈസൽ ഖാൻ  സേവനത്തിന്റെ മാതൃകാ മുഖമായി മാറുകയാണെന്നും ഉദ്ഘാടനം ചെയ്തു സംസാരിച്ചു. നിംസ് നെയ്യാറ്റിൻകര പെൻഷൻ പ്ളാൻ ചെയർ പേഴ്സൺ  രേണു.കെ.ആർ പദ്ധതി വിവരണവും സ്വാഗതവും ആശംസിച്ചു.  ഡിസ്ട്രിക്ട് സോഷ്യൽ വെൽഫയർ ഓഫീസർ  ഷൈനി മോൾ തൊഴിൽ പരിശീലനത്തിന്റെ പ്രവർത്തനോത്ഘാടനം നിർവ്വഹിച്ചു. കേരള സംസ്ഥാന വികലാംഗ കോർപ്പറേഷൻ ചെയർ പേഴ്സൺ ജയാ ഡാളി നെയ്യാറ്റിൻകര പെൻഷൻ പ്ലാനിന്റെ ഭാഗമായുള്ള അഡീഷണൽ  പെൻഷൻ വിതരണത്തിന്റെ ഉദ്ഘാടനം ചെയ്യുകയുണ്ടായി. ചടങ്ങിൽ  നിംസ് സ്പെക്ട്രം ഡയറക്ടറും മുൻ ആരോഗ്യ സർവ്വകലാശാല വൈസ് ചാൻസലറുമായ ഡോ.എം.കെ.സി നായർ മുഖ്യ  പ്രഭാഷണം നടത്തി. നെയ്യാറ്റിൻകര മുനിസിപ്പാലിറ്റി ആരോഗ്യ സ്റ്റാൻഡിംഗ് കമ്മറ്റി ചെയർമാൻ  ജോസ്ഫ്രാങ്കിളിൻ, മുനിസിപ്പാലിറ്റി കൗൺസിലർ  ഐശ്വര്യ, നിംസ് ഫിസിക്കൽ മെഡിസിൻ വിഭാഗം മേധാവി ഡോ.ജിം ഗോപാല കൃഷ്ണൻ, കോട്ടു കാൽ പഞ്ചായത്ത് പ്രസിഡന്റ്  ജറോം ദാസ് ,പി. ബോബി , ജയകുമാർ തുടങ്ങിയവർ ചടങ്ങിൽ ആശംസ അർപ്പിച്ചു സംസാരിച്ചു.",
      thumb: "assets/img/pensionscheme/110.jpeg",
    },
    {
      src: "assets/img/pensionscheme/111.jpeg",
      caption:
        "വേൾഡ് യൂത്ത് സ്കിൽ ദിനമായ ജൂലൈ 15 ന് നിംസ് മെഡിസിറ്റി നടത്തിവരുന്ന നെയ്യാറ്റിൻകര പെൻഷൻ പ്ളാൻ ഉപഭോക്താക്കളായ കുട്ടികൾക്കും അമ്മമാർക്കും തൊഴിൽ പരിശീലന പരിപാടി സംഘടിപ്പിച്ചു. നിംസ് മെഡിസിറ്റി ജനറൽ മാനേജർ ഡോ.കെ.എ. സജു അദ്ധ്യക്ഷത വഹിച്ച ചടങ്ങിൽ ചൈൽഡ് വെൽഫെയർ കമ്മിറ്റി  ചെയർപേഴ്സൺ  ഷാഹിന ബീഗം ഉദ്ഘാടനം ചെയ്തു സംസാരിച്ചു. ഭിന്നശേഷി കുട്ടികൾക്കും കുടുംബത്തിനും താങ്ങായി മാറുകയാണ് ഇത്തരം പദ്ധതികളെന്നും ഇത്തരത്തിൽ മാതൃകാ പ്രവർത്തനം നടത്തുന്ന നിംസ് മെഡിസിറ്റി എംഡി, എം .എസ് .ഫൈസൽ ഖാൻ  സേവനത്തിന്റെ മാതൃകാ മുഖമായി മാറുകയാണെന്നും ഉദ്ഘാടനം ചെയ്തു സംസാരിച്ചു. നിംസ് നെയ്യാറ്റിൻകര പെൻഷൻ പ്ളാൻ ചെയർ പേഴ്സൺ  രേണു.കെ.ആർ പദ്ധതി വിവരണവും സ്വാഗതവും ആശംസിച്ചു.  ഡിസ്ട്രിക്ട് സോഷ്യൽ വെൽഫയർ ഓഫീസർ  ഷൈനി മോൾ തൊഴിൽ പരിശീലനത്തിന്റെ പ്രവർത്തനോത്ഘാടനം നിർവ്വഹിച്ചു. കേരള സംസ്ഥാന വികലാംഗ കോർപ്പറേഷൻ ചെയർ പേഴ്സൺ ജയാ ഡാളി നെയ്യാറ്റിൻകര പെൻഷൻ പ്ലാനിന്റെ ഭാഗമായുള്ള അഡീഷണൽ  പെൻഷൻ വിതരണത്തിന്റെ ഉദ്ഘാടനം ചെയ്യുകയുണ്ടായി. ചടങ്ങിൽ  നിംസ് സ്പെക്ട്രം ഡയറക്ടറും മുൻ ആരോഗ്യ സർവ്വകലാശാല വൈസ് ചാൻസലറുമായ ഡോ.എം.കെ.സി നായർ മുഖ്യ  പ്രഭാഷണം നടത്തി. നെയ്യാറ്റിൻകര മുനിസിപ്പാലിറ്റി ആരോഗ്യ സ്റ്റാൻഡിംഗ് കമ്മറ്റി ചെയർമാൻ  ജോസ്ഫ്രാങ്കിളിൻ, മുനിസിപ്പാലിറ്റി കൗൺസിലർ  ഐശ്വര്യ, നിംസ് ഫിസിക്കൽ മെഡിസിൻ വിഭാഗം മേധാവി ഡോ.ജിം ഗോപാല കൃഷ്ണൻ, കോട്ടു കാൽ പഞ്ചായത്ത് പ്രസിഡന്റ്  ജറോം ദാസ് ,പി. ബോബി , ജയകുമാർ തുടങ്ങിയവർ ചടങ്ങിൽ ആശംസ അർപ്പിച്ചു സംസാരിച്ചു.",
      thumb: "assets/img/pensionscheme/111.jpeg",
    },
    {
      src: "assets/img/pensionscheme/112.jpeg",
      caption:
        "വേൾഡ് യൂത്ത് സ്കിൽ ദിനമായ ജൂലൈ 15 ന് നിംസ് മെഡിസിറ്റി നടത്തിവരുന്ന നെയ്യാറ്റിൻകര പെൻഷൻ പ്ളാൻ ഉപഭോക്താക്കളായ കുട്ടികൾക്കും അമ്മമാർക്കും തൊഴിൽ പരിശീലന പരിപാടി സംഘടിപ്പിച്ചു. നിംസ് മെഡിസിറ്റി ജനറൽ മാനേജർ ഡോ.കെ.എ. സജു അദ്ധ്യക്ഷത വഹിച്ച ചടങ്ങിൽ ചൈൽഡ് വെൽഫെയർ കമ്മിറ്റി  ചെയർപേഴ്സൺ  ഷാഹിന ബീഗം ഉദ്ഘാടനം ചെയ്തു സംസാരിച്ചു. ഭിന്നശേഷി കുട്ടികൾക്കും കുടുംബത്തിനും താങ്ങായി മാറുകയാണ് ഇത്തരം പദ്ധതികളെന്നും ഇത്തരത്തിൽ മാതൃകാ പ്രവർത്തനം നടത്തുന്ന നിംസ് മെഡിസിറ്റി എംഡി, എം .എസ് .ഫൈസൽ ഖാൻ  സേവനത്തിന്റെ മാതൃകാ മുഖമായി മാറുകയാണെന്നും ഉദ്ഘാടനം ചെയ്തു സംസാരിച്ചു. നിംസ് നെയ്യാറ്റിൻകര പെൻഷൻ പ്ളാൻ ചെയർ പേഴ്സൺ  രേണു.കെ.ആർ പദ്ധതി വിവരണവും സ്വാഗതവും ആശംസിച്ചു.  ഡിസ്ട്രിക്ട് സോഷ്യൽ വെൽഫയർ ഓഫീസർ  ഷൈനി മോൾ തൊഴിൽ പരിശീലനത്തിന്റെ പ്രവർത്തനോത്ഘാടനം നിർവ്വഹിച്ചു. കേരള സംസ്ഥാന വികലാംഗ കോർപ്പറേഷൻ ചെയർ പേഴ്സൺ ജയാ ഡാളി നെയ്യാറ്റിൻകര പെൻഷൻ പ്ലാനിന്റെ ഭാഗമായുള്ള അഡീഷണൽ  പെൻഷൻ വിതരണത്തിന്റെ ഉദ്ഘാടനം ചെയ്യുകയുണ്ടായി. ചടങ്ങിൽ  നിംസ് സ്പെക്ട്രം ഡയറക്ടറും മുൻ ആരോഗ്യ സർവ്വകലാശാല വൈസ് ചാൻസലറുമായ ഡോ.എം.കെ.സി നായർ മുഖ്യ  പ്രഭാഷണം നടത്തി. നെയ്യാറ്റിൻകര മുനിസിപ്പാലിറ്റി ആരോഗ്യ സ്റ്റാൻഡിംഗ് കമ്മറ്റി ചെയർമാൻ  ജോസ്ഫ്രാങ്കിളിൻ, മുനിസിപ്പാലിറ്റി കൗൺസിലർ  ഐശ്വര്യ, നിംസ് ഫിസിക്കൽ മെഡിസിൻ വിഭാഗം മേധാവി ഡോ.ജിം ഗോപാല കൃഷ്ണൻ, കോട്ടു കാൽ പഞ്ചായത്ത് പ്രസിഡന്റ്  ജറോം ദാസ് ,പി. ബോബി , ജയകുമാർ തുടങ്ങിയവർ ചടങ്ങിൽ ആശംസ അർപ്പിച്ചു സംസാരിച്ചു.",
      thumb: "assets/img/pensionscheme/112.jpeg",
    },
    {
      src: "assets/img/pensionscheme/113.jpeg",
      caption:
        "വേൾഡ് യൂത്ത് സ്കിൽ ദിനമായ ജൂലൈ 15 ന് നിംസ് മെഡിസിറ്റി നടത്തിവരുന്ന നെയ്യാറ്റിൻകര പെൻഷൻ പ്ളാൻ ഉപഭോക്താക്കളായ കുട്ടികൾക്കും അമ്മമാർക്കും തൊഴിൽ പരിശീലന പരിപാടി സംഘടിപ്പിച്ചു. നിംസ് മെഡിസിറ്റി ജനറൽ മാനേജർ ഡോ.കെ.എ. സജു അദ്ധ്യക്ഷത വഹിച്ച ചടങ്ങിൽ ചൈൽഡ് വെൽഫെയർ കമ്മിറ്റി  ചെയർപേഴ്സൺ  ഷാഹിന ബീഗം ഉദ്ഘാടനം ചെയ്തു സംസാരിച്ചു. ഭിന്നശേഷി കുട്ടികൾക്കും കുടുംബത്തിനും താങ്ങായി മാറുകയാണ് ഇത്തരം പദ്ധതികളെന്നും ഇത്തരത്തിൽ മാതൃകാ പ്രവർത്തനം നടത്തുന്ന നിംസ് മെഡിസിറ്റി എംഡി, എം .എസ് .ഫൈസൽ ഖാൻ  സേവനത്തിന്റെ മാതൃകാ മുഖമായി മാറുകയാണെന്നും ഉദ്ഘാടനം ചെയ്തു സംസാരിച്ചു. നിംസ് നെയ്യാറ്റിൻകര പെൻഷൻ പ്ളാൻ ചെയർ പേഴ്സൺ  രേണു.കെ.ആർ പദ്ധതി വിവരണവും സ്വാഗതവും ആശംസിച്ചു.  ഡിസ്ട്രിക്ട് സോഷ്യൽ വെൽഫയർ ഓഫീസർ  ഷൈനി മോൾ തൊഴിൽ പരിശീലനത്തിന്റെ പ്രവർത്തനോത്ഘാടനം നിർവ്വഹിച്ചു. കേരള സംസ്ഥാന വികലാംഗ കോർപ്പറേഷൻ ചെയർ പേഴ്സൺ ജയാ ഡാളി നെയ്യാറ്റിൻകര പെൻഷൻ പ്ലാനിന്റെ ഭാഗമായുള്ള അഡീഷണൽ  പെൻഷൻ വിതരണത്തിന്റെ ഉദ്ഘാടനം ചെയ്യുകയുണ്ടായി. ചടങ്ങിൽ  നിംസ് സ്പെക്ട്രം ഡയറക്ടറും മുൻ ആരോഗ്യ സർവ്വകലാശാല വൈസ് ചാൻസലറുമായ ഡോ.എം.കെ.സി നായർ മുഖ്യ  പ്രഭാഷണം നടത്തി. നെയ്യാറ്റിൻകര മുനിസിപ്പാലിറ്റി ആരോഗ്യ സ്റ്റാൻഡിംഗ് കമ്മറ്റി ചെയർമാൻ  ജോസ്ഫ്രാങ്കിളിൻ, മുനിസിപ്പാലിറ്റി കൗൺസിലർ  ഐശ്വര്യ, നിംസ് ഫിസിക്കൽ മെഡിസിൻ വിഭാഗം മേധാവി ഡോ.ജിം ഗോപാല കൃഷ്ണൻ, കോട്ടു കാൽ പഞ്ചായത്ത് പ്രസിഡന്റ്  ജറോം ദാസ് ,പി. ബോബി , ജയകുമാർ തുടങ്ങിയവർ ചടങ്ങിൽ ആശംസ അർപ്പിച്ചു സംസാരിച്ചു.",
      thumb: "assets/img/pensionscheme/113.jpeg",
    },
    {
      src: "assets/img/pensionscheme/114.jpeg",
      caption:
        "വേൾഡ് യൂത്ത് സ്കിൽ ദിനമായ ജൂലൈ 15 ന് നിംസ് മെഡിസിറ്റി നടത്തിവരുന്ന നെയ്യാറ്റിൻകര പെൻഷൻ പ്ളാൻ ഉപഭോക്താക്കളായ കുട്ടികൾക്കും അമ്മമാർക്കും തൊഴിൽ പരിശീലന പരിപാടി സംഘടിപ്പിച്ചു. നിംസ് മെഡിസിറ്റി ജനറൽ മാനേജർ ഡോ.കെ.എ. സജു അദ്ധ്യക്ഷത വഹിച്ച ചടങ്ങിൽ ചൈൽഡ് വെൽഫെയർ കമ്മിറ്റി  ചെയർപേഴ്സൺ  ഷാഹിന ബീഗം ഉദ്ഘാടനം ചെയ്തു സംസാരിച്ചു. ഭിന്നശേഷി കുട്ടികൾക്കും കുടുംബത്തിനും താങ്ങായി മാറുകയാണ് ഇത്തരം പദ്ധതികളെന്നും ഇത്തരത്തിൽ മാതൃകാ പ്രവർത്തനം നടത്തുന്ന നിംസ് മെഡിസിറ്റി എംഡി, എം .എസ് .ഫൈസൽ ഖാൻ  സേവനത്തിന്റെ മാതൃകാ മുഖമായി മാറുകയാണെന്നും ഉദ്ഘാടനം ചെയ്തു സംസാരിച്ചു. നിംസ് നെയ്യാറ്റിൻകര പെൻഷൻ പ്ളാൻ ചെയർ പേഴ്സൺ  രേണു.കെ.ആർ പദ്ധതി വിവരണവും സ്വാഗതവും ആശംസിച്ചു.  ഡിസ്ട്രിക്ട് സോഷ്യൽ വെൽഫയർ ഓഫീസർ  ഷൈനി മോൾ തൊഴിൽ പരിശീലനത്തിന്റെ പ്രവർത്തനോത്ഘാടനം നിർവ്വഹിച്ചു. കേരള സംസ്ഥാന വികലാംഗ കോർപ്പറേഷൻ ചെയർ പേഴ്സൺ ജയാ ഡാളി നെയ്യാറ്റിൻകര പെൻഷൻ പ്ലാനിന്റെ ഭാഗമായുള്ള അഡീഷണൽ  പെൻഷൻ വിതരണത്തിന്റെ ഉദ്ഘാടനം ചെയ്യുകയുണ്ടായി. ചടങ്ങിൽ  നിംസ് സ്പെക്ട്രം ഡയറക്ടറും മുൻ ആരോഗ്യ സർവ്വകലാശാല വൈസ് ചാൻസലറുമായ ഡോ.എം.കെ.സി നായർ മുഖ്യ  പ്രഭാഷണം നടത്തി. നെയ്യാറ്റിൻകര മുനിസിപ്പാലിറ്റി ആരോഗ്യ സ്റ്റാൻഡിംഗ് കമ്മറ്റി ചെയർമാൻ  ജോസ്ഫ്രാങ്കിളിൻ, മുനിസിപ്പാലിറ്റി കൗൺസിലർ  ഐശ്വര്യ, നിംസ് ഫിസിക്കൽ മെഡിസിൻ വിഭാഗം മേധാവി ഡോ.ജിം ഗോപാല കൃഷ്ണൻ, കോട്ടു കാൽ പഞ്ചായത്ത് പ്രസിഡന്റ്  ജറോം ദാസ് ,പി. ബോബി , ജയകുമാർ തുടങ്ങിയവർ ചടങ്ങിൽ ആശംസ അർപ്പിച്ചു സംസാരിച്ചു.",
      thumb: "assets/img/pensionscheme/114.jpeg",
    },
    {
      src: "assets/img/pensionscheme/115.jpeg",
      caption:
        "വേൾഡ് യൂത്ത് സ്കിൽ ദിനമായ ജൂലൈ 15 ന് നിംസ് മെഡിസിറ്റി നടത്തിവരുന്ന നെയ്യാറ്റിൻകര പെൻഷൻ പ്ളാൻ ഉപഭോക്താക്കളായ കുട്ടികൾക്കും അമ്മമാർക്കും തൊഴിൽ പരിശീലന പരിപാടി സംഘടിപ്പിച്ചു. നിംസ് മെഡിസിറ്റി ജനറൽ മാനേജർ ഡോ.കെ.എ. സജു അദ്ധ്യക്ഷത വഹിച്ച ചടങ്ങിൽ ചൈൽഡ് വെൽഫെയർ കമ്മിറ്റി  ചെയർപേഴ്സൺ  ഷാഹിന ബീഗം ഉദ്ഘാടനം ചെയ്തു സംസാരിച്ചു. ഭിന്നശേഷി കുട്ടികൾക്കും കുടുംബത്തിനും താങ്ങായി മാറുകയാണ് ഇത്തരം പദ്ധതികളെന്നും ഇത്തരത്തിൽ മാതൃകാ പ്രവർത്തനം നടത്തുന്ന നിംസ് മെഡിസിറ്റി എംഡി, എം .എസ് .ഫൈസൽ ഖാൻ  സേവനത്തിന്റെ മാതൃകാ മുഖമായി മാറുകയാണെന്നും ഉദ്ഘാടനം ചെയ്തു സംസാരിച്ചു. നിംസ് നെയ്യാറ്റിൻകര പെൻഷൻ പ്ളാൻ ചെയർ പേഴ്സൺ  രേണു.കെ.ആർ പദ്ധതി വിവരണവും സ്വാഗതവും ആശംസിച്ചു.  ഡിസ്ട്രിക്ട് സോഷ്യൽ വെൽഫയർ ഓഫീസർ  ഷൈനി മോൾ തൊഴിൽ പരിശീലനത്തിന്റെ പ്രവർത്തനോത്ഘാടനം നിർവ്വഹിച്ചു. കേരള സംസ്ഥാന വികലാംഗ കോർപ്പറേഷൻ ചെയർ പേഴ്സൺ ജയാ ഡാളി നെയ്യാറ്റിൻകര പെൻഷൻ പ്ലാനിന്റെ ഭാഗമായുള്ള അഡീഷണൽ  പെൻഷൻ വിതരണത്തിന്റെ ഉദ്ഘാടനം ചെയ്യുകയുണ്ടായി. ചടങ്ങിൽ  നിംസ് സ്പെക്ട്രം ഡയറക്ടറും മുൻ ആരോഗ്യ സർവ്വകലാശാല വൈസ് ചാൻസലറുമായ ഡോ.എം.കെ.സി നായർ മുഖ്യ  പ്രഭാഷണം നടത്തി. നെയ്യാറ്റിൻകര മുനിസിപ്പാലിറ്റി ആരോഗ്യ സ്റ്റാൻഡിംഗ് കമ്മറ്റി ചെയർമാൻ  ജോസ്ഫ്രാങ്കിളിൻ, മുനിസിപ്പാലിറ്റി കൗൺസിലർ  ഐശ്വര്യ, നിംസ് ഫിസിക്കൽ മെഡിസിൻ വിഭാഗം മേധാവി ഡോ.ജിം ഗോപാല കൃഷ്ണൻ, കോട്ടു കാൽ പഞ്ചായത്ത് പ്രസിഡന്റ്  ജറോം ദാസ് ,പി. ബോബി , ജയകുമാർ തുടങ്ങിയവർ ചടങ്ങിൽ ആശംസ അർപ്പിച്ചു സംസാരിച്ചു.",
      thumb: "assets/img/pensionscheme/115.jpeg",
    },
    {
      src: "assets/img/pensionscheme/116.jpeg",
      caption:
        "വേൾഡ് യൂത്ത് സ്കിൽ ദിനമായ ജൂലൈ 15 ന് നിംസ് മെഡിസിറ്റി നടത്തിവരുന്ന നെയ്യാറ്റിൻകര പെൻഷൻ പ്ളാൻ ഉപഭോക്താക്കളായ കുട്ടികൾക്കും അമ്മമാർക്കും തൊഴിൽ പരിശീലന പരിപാടി സംഘടിപ്പിച്ചു. നിംസ് മെഡിസിറ്റി ജനറൽ മാനേജർ ഡോ.കെ.എ. സജു അദ്ധ്യക്ഷത വഹിച്ച ചടങ്ങിൽ ചൈൽഡ് വെൽഫെയർ കമ്മിറ്റി  ചെയർപേഴ്സൺ  ഷാഹിന ബീഗം ഉദ്ഘാടനം ചെയ്തു സംസാരിച്ചു. ഭിന്നശേഷി കുട്ടികൾക്കും കുടുംബത്തിനും താങ്ങായി മാറുകയാണ് ഇത്തരം പദ്ധതികളെന്നും ഇത്തരത്തിൽ മാതൃകാ പ്രവർത്തനം നടത്തുന്ന നിംസ് മെഡിസിറ്റി എംഡി, എം .എസ് .ഫൈസൽ ഖാൻ  സേവനത്തിന്റെ മാതൃകാ മുഖമായി മാറുകയാണെന്നും ഉദ്ഘാടനം ചെയ്തു സംസാരിച്ചു. നിംസ് നെയ്യാറ്റിൻകര പെൻഷൻ പ്ളാൻ ചെയർ പേഴ്സൺ  രേണു.കെ.ആർ പദ്ധതി വിവരണവും സ്വാഗതവും ആശംസിച്ചു.  ഡിസ്ട്രിക്ട് സോഷ്യൽ വെൽഫയർ ഓഫീസർ  ഷൈനി മോൾ തൊഴിൽ പരിശീലനത്തിന്റെ പ്രവർത്തനോത്ഘാടനം നിർവ്വഹിച്ചു. കേരള സംസ്ഥാന വികലാംഗ കോർപ്പറേഷൻ ചെയർ പേഴ്സൺ ജയാ ഡാളി നെയ്യാറ്റിൻകര പെൻഷൻ പ്ലാനിന്റെ ഭാഗമായുള്ള അഡീഷണൽ  പെൻഷൻ വിതരണത്തിന്റെ ഉദ്ഘാടനം ചെയ്യുകയുണ്ടായി. ചടങ്ങിൽ  നിംസ് സ്പെക്ട്രം ഡയറക്ടറും മുൻ ആരോഗ്യ സർവ്വകലാശാല വൈസ് ചാൻസലറുമായ ഡോ.എം.കെ.സി നായർ മുഖ്യ  പ്രഭാഷണം നടത്തി. നെയ്യാറ്റിൻകര മുനിസിപ്പാലിറ്റി ആരോഗ്യ സ്റ്റാൻഡിംഗ് കമ്മറ്റി ചെയർമാൻ  ജോസ്ഫ്രാങ്കിളിൻ, മുനിസിപ്പാലിറ്റി കൗൺസിലർ  ഐശ്വര്യ, നിംസ് ഫിസിക്കൽ മെഡിസിൻ വിഭാഗം മേധാവി ഡോ.ജിം ഗോപാല കൃഷ്ണൻ, കോട്ടു കാൽ പഞ്ചായത്ത് പ്രസിഡന്റ്  ജറോം ദാസ് ,പി. ബോബി , ജയകുമാർ തുടങ്ങിയവർ ചടങ്ങിൽ ആശംസ അർപ്പിച്ചു സംസാരിച്ചു.",
      thumb: "assets/img/pensionscheme/116.jpeg",
    },
    {
      src: "assets/img/pensionscheme/117.jpeg",
      caption:
        "വേൾഡ് യൂത്ത് സ്കിൽ ദിനമായ ജൂലൈ 15 ന് നിംസ് മെഡിസിറ്റി നടത്തിവരുന്ന നെയ്യാറ്റിൻകര പെൻഷൻ പ്ളാൻ ഉപഭോക്താക്കളായ കുട്ടികൾക്കും അമ്മമാർക്കും തൊഴിൽ പരിശീലന പരിപാടി സംഘടിപ്പിച്ചു. നിംസ് മെഡിസിറ്റി ജനറൽ മാനേജർ ഡോ.കെ.എ. സജു അദ്ധ്യക്ഷത വഹിച്ച ചടങ്ങിൽ ചൈൽഡ് വെൽഫെയർ കമ്മിറ്റി  ചെയർപേഴ്സൺ  ഷാഹിന ബീഗം ഉദ്ഘാടനം ചെയ്തു സംസാരിച്ചു. ഭിന്നശേഷി കുട്ടികൾക്കും കുടുംബത്തിനും താങ്ങായി മാറുകയാണ് ഇത്തരം പദ്ധതികളെന്നും ഇത്തരത്തിൽ മാതൃകാ പ്രവർത്തനം നടത്തുന്ന നിംസ് മെഡിസിറ്റി എംഡി, എം .എസ് .ഫൈസൽ ഖാൻ  സേവനത്തിന്റെ മാതൃകാ മുഖമായി മാറുകയാണെന്നും ഉദ്ഘാടനം ചെയ്തു സംസാരിച്ചു. നിംസ് നെയ്യാറ്റിൻകര പെൻഷൻ പ്ളാൻ ചെയർ പേഴ്സൺ  രേണു.കെ.ആർ പദ്ധതി വിവരണവും സ്വാഗതവും ആശംസിച്ചു.  ഡിസ്ട്രിക്ട് സോഷ്യൽ വെൽഫയർ ഓഫീസർ  ഷൈനി മോൾ തൊഴിൽ പരിശീലനത്തിന്റെ പ്രവർത്തനോത്ഘാടനം നിർവ്വഹിച്ചു. കേരള സംസ്ഥാന വികലാംഗ കോർപ്പറേഷൻ ചെയർ പേഴ്സൺ ജയാ ഡാളി നെയ്യാറ്റിൻകര പെൻഷൻ പ്ലാനിന്റെ ഭാഗമായുള്ള അഡീഷണൽ  പെൻഷൻ വിതരണത്തിന്റെ ഉദ്ഘാടനം ചെയ്യുകയുണ്ടായി. ചടങ്ങിൽ  നിംസ് സ്പെക്ട്രം ഡയറക്ടറും മുൻ ആരോഗ്യ സർവ്വകലാശാല വൈസ് ചാൻസലറുമായ ഡോ.എം.കെ.സി നായർ മുഖ്യ  പ്രഭാഷണം നടത്തി. നെയ്യാറ്റിൻകര മുനിസിപ്പാലിറ്റി ആരോഗ്യ സ്റ്റാൻഡിംഗ് കമ്മറ്റി ചെയർമാൻ  ജോസ്ഫ്രാങ്കിളിൻ, മുനിസിപ്പാലിറ്റി കൗൺസിലർ  ഐശ്വര്യ, നിംസ് ഫിസിക്കൽ മെഡിസിൻ വിഭാഗം മേധാവി ഡോ.ജിം ഗോപാല കൃഷ്ണൻ, കോട്ടു കാൽ പഞ്ചായത്ത് പ്രസിഡന്റ്  ജറോം ദാസ് ,പി. ബോബി , ജയകുമാർ തുടങ്ങിയവർ ചടങ്ങിൽ ആശംസ അർപ്പിച്ചു സംസാരിച്ചു.",
      thumb: "assets/img/pensionscheme/117.jpeg",
    },
    {
      src: "assets/img/pensionscheme/118.jpeg",
      caption:
        "വേൾഡ് യൂത്ത് സ്കിൽ ദിനമായ ജൂലൈ 15 ന് നിംസ് മെഡിസിറ്റി നടത്തിവരുന്ന നെയ്യാറ്റിൻകര പെൻഷൻ പ്ളാൻ ഉപഭോക്താക്കളായ കുട്ടികൾക്കും അമ്മമാർക്കും തൊഴിൽ പരിശീലന പരിപാടി സംഘടിപ്പിച്ചു. നിംസ് മെഡിസിറ്റി ജനറൽ മാനേജർ ഡോ.കെ.എ. സജു അദ്ധ്യക്ഷത വഹിച്ച ചടങ്ങിൽ ചൈൽഡ് വെൽഫെയർ കമ്മിറ്റി  ചെയർപേഴ്സൺ  ഷാഹിന ബീഗം ഉദ്ഘാടനം ചെയ്തു സംസാരിച്ചു. ഭിന്നശേഷി കുട്ടികൾക്കും കുടുംബത്തിനും താങ്ങായി മാറുകയാണ് ഇത്തരം പദ്ധതികളെന്നും ഇത്തരത്തിൽ മാതൃകാ പ്രവർത്തനം നടത്തുന്ന നിംസ് മെഡിസിറ്റി എംഡി, എം .എസ് .ഫൈസൽ ഖാൻ  സേവനത്തിന്റെ മാതൃകാ മുഖമായി മാറുകയാണെന്നും ഉദ്ഘാടനം ചെയ്തു സംസാരിച്ചു. നിംസ് നെയ്യാറ്റിൻകര പെൻഷൻ പ്ളാൻ ചെയർ പേഴ്സൺ  രേണു.കെ.ആർ പദ്ധതി വിവരണവും സ്വാഗതവും ആശംസിച്ചു.  ഡിസ്ട്രിക്ട് സോഷ്യൽ വെൽഫയർ ഓഫീസർ  ഷൈനി മോൾ തൊഴിൽ പരിശീലനത്തിന്റെ പ്രവർത്തനോത്ഘാടനം നിർവ്വഹിച്ചു. കേരള സംസ്ഥാന വികലാംഗ കോർപ്പറേഷൻ ചെയർ പേഴ്സൺ ജയാ ഡാളി നെയ്യാറ്റിൻകര പെൻഷൻ പ്ലാനിന്റെ ഭാഗമായുള്ള അഡീഷണൽ  പെൻഷൻ വിതരണത്തിന്റെ ഉദ്ഘാടനം ചെയ്യുകയുണ്ടായി. ചടങ്ങിൽ  നിംസ് സ്പെക്ട്രം ഡയറക്ടറും മുൻ ആരോഗ്യ സർവ്വകലാശാല വൈസ് ചാൻസലറുമായ ഡോ.എം.കെ.സി നായർ മുഖ്യ  പ്രഭാഷണം നടത്തി. നെയ്യാറ്റിൻകര മുനിസിപ്പാലിറ്റി ആരോഗ്യ സ്റ്റാൻഡിംഗ് കമ്മറ്റി ചെയർമാൻ  ജോസ്ഫ്രാങ്കിളിൻ, മുനിസിപ്പാലിറ്റി കൗൺസിലർ  ഐശ്വര്യ, നിംസ് ഫിസിക്കൽ മെഡിസിൻ വിഭാഗം മേധാവി ഡോ.ജിം ഗോപാല കൃഷ്ണൻ, കോട്ടു കാൽ പഞ്ചായത്ത് പ്രസിഡന്റ്  ജറോം ദാസ് ,പി. ബോബി , ജയകുമാർ തുടങ്ങിയവർ ചടങ്ങിൽ ആശംസ അർപ്പിച്ചു സംസാരിച്ചു.",
      thumb: "assets/img/pensionscheme/118.jpeg",
    },
    {
      src: "assets/img/pensionscheme/119.jpeg",
      caption:
        "വേൾഡ് യൂത്ത് സ്കിൽ ദിനമായ ജൂലൈ 15 ന് നിംസ് മെഡിസിറ്റി നടത്തിവരുന്ന നെയ്യാറ്റിൻകര പെൻഷൻ പ്ളാൻ ഉപഭോക്താക്കളായ കുട്ടികൾക്കും അമ്മമാർക്കും തൊഴിൽ പരിശീലന പരിപാടി സംഘടിപ്പിച്ചു. നിംസ് മെഡിസിറ്റി ജനറൽ മാനേജർ ഡോ.കെ.എ. സജു അദ്ധ്യക്ഷത വഹിച്ച ചടങ്ങിൽ ചൈൽഡ് വെൽഫെയർ കമ്മിറ്റി  ചെയർപേഴ്സൺ  ഷാഹിന ബീഗം ഉദ്ഘാടനം ചെയ്തു സംസാരിച്ചു. ഭിന്നശേഷി കുട്ടികൾക്കും കുടുംബത്തിനും താങ്ങായി മാറുകയാണ് ഇത്തരം പദ്ധതികളെന്നും ഇത്തരത്തിൽ മാതൃകാ പ്രവർത്തനം നടത്തുന്ന നിംസ് മെഡിസിറ്റി എംഡി, എം .എസ് .ഫൈസൽ ഖാൻ  സേവനത്തിന്റെ മാതൃകാ മുഖമായി മാറുകയാണെന്നും ഉദ്ഘാടനം ചെയ്തു സംസാരിച്ചു. നിംസ് നെയ്യാറ്റിൻകര പെൻഷൻ പ്ളാൻ ചെയർ പേഴ്സൺ  രേണു.കെ.ആർ പദ്ധതി വിവരണവും സ്വാഗതവും ആശംസിച്ചു.  ഡിസ്ട്രിക്ട് സോഷ്യൽ വെൽഫയർ ഓഫീസർ  ഷൈനി മോൾ തൊഴിൽ പരിശീലനത്തിന്റെ പ്രവർത്തനോത്ഘാടനം നിർവ്വഹിച്ചു. കേരള സംസ്ഥാന വികലാംഗ കോർപ്പറേഷൻ ചെയർ പേഴ്സൺ ജയാ ഡാളി നെയ്യാറ്റിൻകര പെൻഷൻ പ്ലാനിന്റെ ഭാഗമായുള്ള അഡീഷണൽ  പെൻഷൻ വിതരണത്തിന്റെ ഉദ്ഘാടനം ചെയ്യുകയുണ്ടായി. ചടങ്ങിൽ  നിംസ് സ്പെക്ട്രം ഡയറക്ടറും മുൻ ആരോഗ്യ സർവ്വകലാശാല വൈസ് ചാൻസലറുമായ ഡോ.എം.കെ.സി നായർ മുഖ്യ  പ്രഭാഷണം നടത്തി. നെയ്യാറ്റിൻകര മുനിസിപ്പാലിറ്റി ആരോഗ്യ സ്റ്റാൻഡിംഗ് കമ്മറ്റി ചെയർമാൻ  ജോസ്ഫ്രാങ്കിളിൻ, മുനിസിപ്പാലിറ്റി കൗൺസിലർ  ഐശ്വര്യ, നിംസ് ഫിസിക്കൽ മെഡിസിൻ വിഭാഗം മേധാവി ഡോ.ജിം ഗോപാല കൃഷ്ണൻ, കോട്ടു കാൽ പഞ്ചായത്ത് പ്രസിഡന്റ്  ജറോം ദാസ് ,പി. ബോബി , ജയകുമാർ തുടങ്ങിയവർ ചടങ്ങിൽ ആശംസ അർപ്പിച്ചു സംസാരിച്ചു.",
      thumb: "assets/img/pensionscheme/119.jpeg",
    },
    {
      src: "assets/img/pensionscheme/120.jpeg",
      caption:
        "വേൾഡ് യൂത്ത് സ്കിൽ ദിനമായ ജൂലൈ 15 ന് നിംസ് മെഡിസിറ്റി നടത്തിവരുന്ന നെയ്യാറ്റിൻകര പെൻഷൻ പ്ളാൻ ഉപഭോക്താക്കളായ കുട്ടികൾക്കും അമ്മമാർക്കും തൊഴിൽ പരിശീലന പരിപാടി സംഘടിപ്പിച്ചു. നിംസ് മെഡിസിറ്റി ജനറൽ മാനേജർ ഡോ.കെ.എ. സജു അദ്ധ്യക്ഷത വഹിച്ച ചടങ്ങിൽ ചൈൽഡ് വെൽഫെയർ കമ്മിറ്റി  ചെയർപേഴ്സൺ  ഷാഹിന ബീഗം ഉദ്ഘാടനം ചെയ്തു സംസാരിച്ചു. ഭിന്നശേഷി കുട്ടികൾക്കും കുടുംബത്തിനും താങ്ങായി മാറുകയാണ് ഇത്തരം പദ്ധതികളെന്നും ഇത്തരത്തിൽ മാതൃകാ പ്രവർത്തനം നടത്തുന്ന നിംസ് മെഡിസിറ്റി എംഡി, എം .എസ് .ഫൈസൽ ഖാൻ  സേവനത്തിന്റെ മാതൃകാ മുഖമായി മാറുകയാണെന്നും ഉദ്ഘാടനം ചെയ്തു സംസാരിച്ചു. നിംസ് നെയ്യാറ്റിൻകര പെൻഷൻ പ്ളാൻ ചെയർ പേഴ്സൺ  രേണു.കെ.ആർ പദ്ധതി വിവരണവും സ്വാഗതവും ആശംസിച്ചു.  ഡിസ്ട്രിക്ട് സോഷ്യൽ വെൽഫയർ ഓഫീസർ  ഷൈനി മോൾ തൊഴിൽ പരിശീലനത്തിന്റെ പ്രവർത്തനോത്ഘാടനം നിർവ്വഹിച്ചു. കേരള സംസ്ഥാന വികലാംഗ കോർപ്പറേഷൻ ചെയർ പേഴ്സൺ ജയാ ഡാളി നെയ്യാറ്റിൻകര പെൻഷൻ പ്ലാനിന്റെ ഭാഗമായുള്ള അഡീഷണൽ  പെൻഷൻ വിതരണത്തിന്റെ ഉദ്ഘാടനം ചെയ്യുകയുണ്ടായി. ചടങ്ങിൽ  നിംസ് സ്പെക്ട്രം ഡയറക്ടറും മുൻ ആരോഗ്യ സർവ്വകലാശാല വൈസ് ചാൻസലറുമായ ഡോ.എം.കെ.സി നായർ മുഖ്യ  പ്രഭാഷണം നടത്തി. നെയ്യാറ്റിൻകര മുനിസിപ്പാലിറ്റി ആരോഗ്യ സ്റ്റാൻഡിംഗ് കമ്മറ്റി ചെയർമാൻ  ജോസ്ഫ്രാങ്കിളിൻ, മുനിസിപ്പാലിറ്റി കൗൺസിലർ  ഐശ്വര്യ, നിംസ് ഫിസിക്കൽ മെഡിസിൻ വിഭാഗം മേധാവി ഡോ.ജിം ഗോപാല കൃഷ്ണൻ, കോട്ടു കാൽ പഞ്ചായത്ത് പ്രസിഡന്റ്  ജറോം ദാസ് ,പി. ബോബി , ജയകുമാർ തുടങ്ങിയവർ ചടങ്ങിൽ ആശംസ അർപ്പിച്ചു സംസാരിച്ചു.",
      thumb: "assets/img/pensionscheme/120.jpeg",
    },
    {
      src: "assets/img/pensionscheme/121.jpeg",
      caption:
        "വേൾഡ് യൂത്ത് സ്കിൽ ദിനമായ ജൂലൈ 15 ന് നിംസ് മെഡിസിറ്റി നടത്തിവരുന്ന നെയ്യാറ്റിൻകര പെൻഷൻ പ്ളാൻ ഉപഭോക്താക്കളായ കുട്ടികൾക്കും അമ്മമാർക്കും തൊഴിൽ പരിശീലന പരിപാടി സംഘടിപ്പിച്ചു. നിംസ് മെഡിസിറ്റി ജനറൽ മാനേജർ ഡോ.കെ.എ. സജു അദ്ധ്യക്ഷത വഹിച്ച ചടങ്ങിൽ ചൈൽഡ് വെൽഫെയർ കമ്മിറ്റി  ചെയർപേഴ്സൺ  ഷാഹിന ബീഗം ഉദ്ഘാടനം ചെയ്തു സംസാരിച്ചു. ഭിന്നശേഷി കുട്ടികൾക്കും കുടുംബത്തിനും താങ്ങായി മാറുകയാണ് ഇത്തരം പദ്ധതികളെന്നും ഇത്തരത്തിൽ മാതൃകാ പ്രവർത്തനം നടത്തുന്ന നിംസ് മെഡിസിറ്റി എംഡി, എം .എസ് .ഫൈസൽ ഖാൻ  സേവനത്തിന്റെ മാതൃകാ മുഖമായി മാറുകയാണെന്നും ഉദ്ഘാടനം ചെയ്തു സംസാരിച്ചു. നിംസ് നെയ്യാറ്റിൻകര പെൻഷൻ പ്ളാൻ ചെയർ പേഴ്സൺ  രേണു.കെ.ആർ പദ്ധതി വിവരണവും സ്വാഗതവും ആശംസിച്ചു.  ഡിസ്ട്രിക്ട് സോഷ്യൽ വെൽഫയർ ഓഫീസർ  ഷൈനി മോൾ തൊഴിൽ പരിശീലനത്തിന്റെ പ്രവർത്തനോത്ഘാടനം നിർവ്വഹിച്ചു. കേരള സംസ്ഥാന വികലാംഗ കോർപ്പറേഷൻ ചെയർ പേഴ്സൺ ജയാ ഡാളി നെയ്യാറ്റിൻകര പെൻഷൻ പ്ലാനിന്റെ ഭാഗമായുള്ള അഡീഷണൽ  പെൻഷൻ വിതരണത്തിന്റെ ഉദ്ഘാടനം ചെയ്യുകയുണ്ടായി. ചടങ്ങിൽ  നിംസ് സ്പെക്ട്രം ഡയറക്ടറും മുൻ ആരോഗ്യ സർവ്വകലാശാല വൈസ് ചാൻസലറുമായ ഡോ.എം.കെ.സി നായർ മുഖ്യ  പ്രഭാഷണം നടത്തി. നെയ്യാറ്റിൻകര മുനിസിപ്പാലിറ്റി ആരോഗ്യ സ്റ്റാൻഡിംഗ് കമ്മറ്റി ചെയർമാൻ  ജോസ്ഫ്രാങ്കിളിൻ, മുനിസിപ്പാലിറ്റി കൗൺസിലർ  ഐശ്വര്യ, നിംസ് ഫിസിക്കൽ മെഡിസിൻ വിഭാഗം മേധാവി ഡോ.ജിം ഗോപാല കൃഷ്ണൻ, കോട്ടു കാൽ പഞ്ചായത്ത് പ്രസിഡന്റ്  ജറോം ദാസ് ,പി. ബോബി , ജയകുമാർ തുടങ്ങിയവർ ചടങ്ങിൽ ആശംസ അർപ്പിച്ചു സംസാരിച്ചു.",
      thumb: "assets/img/pensionscheme/121.jpeg",
    },
    {
      src: "assets/img/pensionscheme/122.jpeg",
      caption:
        "വേൾഡ് യൂത്ത് സ്കിൽ ദിനമായ ജൂലൈ 15 ന് നിംസ് മെഡിസിറ്റി നടത്തിവരുന്ന നെയ്യാറ്റിൻകര പെൻഷൻ പ്ളാൻ ഉപഭോക്താക്കളായ കുട്ടികൾക്കും അമ്മമാർക്കും തൊഴിൽ പരിശീലന പരിപാടി സംഘടിപ്പിച്ചു. നിംസ് മെഡിസിറ്റി ജനറൽ മാനേജർ ഡോ.കെ.എ. സജു അദ്ധ്യക്ഷത വഹിച്ച ചടങ്ങിൽ ചൈൽഡ് വെൽഫെയർ കമ്മിറ്റി  ചെയർപേഴ്സൺ  ഷാഹിന ബീഗം ഉദ്ഘാടനം ചെയ്തു സംസാരിച്ചു. ഭിന്നശേഷി കുട്ടികൾക്കും കുടുംബത്തിനും താങ്ങായി മാറുകയാണ് ഇത്തരം പദ്ധതികളെന്നും ഇത്തരത്തിൽ മാതൃകാ പ്രവർത്തനം നടത്തുന്ന നിംസ് മെഡിസിറ്റി എംഡി, എം .എസ് .ഫൈസൽ ഖാൻ  സേവനത്തിന്റെ മാതൃകാ മുഖമായി മാറുകയാണെന്നും ഉദ്ഘാടനം ചെയ്തു സംസാരിച്ചു. നിംസ് നെയ്യാറ്റിൻകര പെൻഷൻ പ്ളാൻ ചെയർ പേഴ്സൺ  രേണു.കെ.ആർ പദ്ധതി വിവരണവും സ്വാഗതവും ആശംസിച്ചു.  ഡിസ്ട്രിക്ട് സോഷ്യൽ വെൽഫയർ ഓഫീസർ  ഷൈനി മോൾ തൊഴിൽ പരിശീലനത്തിന്റെ പ്രവർത്തനോത്ഘാടനം നിർവ്വഹിച്ചു. കേരള സംസ്ഥാന വികലാംഗ കോർപ്പറേഷൻ ചെയർ പേഴ്സൺ ജയാ ഡാളി നെയ്യാറ്റിൻകര പെൻഷൻ പ്ലാനിന്റെ ഭാഗമായുള്ള അഡീഷണൽ  പെൻഷൻ വിതരണത്തിന്റെ ഉദ്ഘാടനം ചെയ്യുകയുണ്ടായി. ചടങ്ങിൽ  നിംസ് സ്പെക്ട്രം ഡയറക്ടറും മുൻ ആരോഗ്യ സർവ്വകലാശാല വൈസ് ചാൻസലറുമായ ഡോ.എം.കെ.സി നായർ മുഖ്യ  പ്രഭാഷണം നടത്തി. നെയ്യാറ്റിൻകര മുനിസിപ്പാലിറ്റി ആരോഗ്യ സ്റ്റാൻഡിംഗ് കമ്മറ്റി ചെയർമാൻ  ജോസ്ഫ്രാങ്കിളിൻ, മുനിസിപ്പാലിറ്റി കൗൺസിലർ  ഐശ്വര്യ, നിംസ് ഫിസിക്കൽ മെഡിസിൻ വിഭാഗം മേധാവി ഡോ.ജിം ഗോപാല കൃഷ്ണൻ, കോട്ടു കാൽ പഞ്ചായത്ത് പ്രസിഡന്റ്  ജറോം ദാസ് ,പി. ബോബി , ജയകുമാർ തുടങ്ങിയവർ ചടങ്ങിൽ ആശംസ അർപ്പിച്ചു സംസാരിച്ചു.",
      thumb: "assets/img/pensionscheme/122.jpeg",
    },
    {
      src: "assets/img/pensionscheme/123.jpeg",
      caption:
        "വേൾഡ് യൂത്ത് സ്കിൽ ദിനമായ ജൂലൈ 15 ന് നിംസ് മെഡിസിറ്റി നടത്തിവരുന്ന നെയ്യാറ്റിൻകര പെൻഷൻ പ്ളാൻ ഉപഭോക്താക്കളായ കുട്ടികൾക്കും അമ്മമാർക്കും തൊഴിൽ പരിശീലന പരിപാടി സംഘടിപ്പിച്ചു. നിംസ് മെഡിസിറ്റി ജനറൽ മാനേജർ ഡോ.കെ.എ. സജു അദ്ധ്യക്ഷത വഹിച്ച ചടങ്ങിൽ ചൈൽഡ് വെൽഫെയർ കമ്മിറ്റി  ചെയർപേഴ്സൺ  ഷാഹിന ബീഗം ഉദ്ഘാടനം ചെയ്തു സംസാരിച്ചു. ഭിന്നശേഷി കുട്ടികൾക്കും കുടുംബത്തിനും താങ്ങായി മാറുകയാണ് ഇത്തരം പദ്ധതികളെന്നും ഇത്തരത്തിൽ മാതൃകാ പ്രവർത്തനം നടത്തുന്ന നിംസ് മെഡിസിറ്റി എംഡി, എം .എസ് .ഫൈസൽ ഖാൻ  സേവനത്തിന്റെ മാതൃകാ മുഖമായി മാറുകയാണെന്നും ഉദ്ഘാടനം ചെയ്തു സംസാരിച്ചു. നിംസ് നെയ്യാറ്റിൻകര പെൻഷൻ പ്ളാൻ ചെയർ പേഴ്സൺ  രേണു.കെ.ആർ പദ്ധതി വിവരണവും സ്വാഗതവും ആശംസിച്ചു.  ഡിസ്ട്രിക്ട് സോഷ്യൽ വെൽഫയർ ഓഫീസർ  ഷൈനി മോൾ തൊഴിൽ പരിശീലനത്തിന്റെ പ്രവർത്തനോത്ഘാടനം നിർവ്വഹിച്ചു. കേരള സംസ്ഥാന വികലാംഗ കോർപ്പറേഷൻ ചെയർ പേഴ്സൺ ജയാ ഡാളി നെയ്യാറ്റിൻകര പെൻഷൻ പ്ലാനിന്റെ ഭാഗമായുള്ള അഡീഷണൽ  പെൻഷൻ വിതരണത്തിന്റെ ഉദ്ഘാടനം ചെയ്യുകയുണ്ടായി. ചടങ്ങിൽ  നിംസ് സ്പെക്ട്രം ഡയറക്ടറും മുൻ ആരോഗ്യ സർവ്വകലാശാല വൈസ് ചാൻസലറുമായ ഡോ.എം.കെ.സി നായർ മുഖ്യ  പ്രഭാഷണം നടത്തി. നെയ്യാറ്റിൻകര മുനിസിപ്പാലിറ്റി ആരോഗ്യ സ്റ്റാൻഡിംഗ് കമ്മറ്റി ചെയർമാൻ  ജോസ്ഫ്രാങ്കിളിൻ, മുനിസിപ്പാലിറ്റി കൗൺസിലർ  ഐശ്വര്യ, നിംസ് ഫിസിക്കൽ മെഡിസിൻ വിഭാഗം മേധാവി ഡോ.ജിം ഗോപാല കൃഷ്ണൻ, കോട്ടു കാൽ പഞ്ചായത്ത് പ്രസിഡന്റ്  ജറോം ദാസ് ,പി. ബോബി , ജയകുമാർ തുടങ്ങിയവർ ചടങ്ങിൽ ആശംസ അർപ്പിച്ചു സംസാരിച്ചു.",
      thumb: "assets/img/pensionscheme/123.jpeg",
    },
    {
      src: "assets/img/pensionscheme/124.jpeg",
      caption:
        "വേൾഡ് യൂത്ത് സ്കിൽ ദിനമായ ജൂലൈ 15 ന് നിംസ് മെഡിസിറ്റി നടത്തിവരുന്ന നെയ്യാറ്റിൻകര പെൻഷൻ പ്ളാൻ ഉപഭോക്താക്കളായ കുട്ടികൾക്കും അമ്മമാർക്കും തൊഴിൽ പരിശീലന പരിപാടി സംഘടിപ്പിച്ചു. നിംസ് മെഡിസിറ്റി ജനറൽ മാനേജർ ഡോ.കെ.എ. സജു അദ്ധ്യക്ഷത വഹിച്ച ചടങ്ങിൽ ചൈൽഡ് വെൽഫെയർ കമ്മിറ്റി  ചെയർപേഴ്സൺ  ഷാഹിന ബീഗം ഉദ്ഘാടനം ചെയ്തു സംസാരിച്ചു. ഭിന്നശേഷി കുട്ടികൾക്കും കുടുംബത്തിനും താങ്ങായി മാറുകയാണ് ഇത്തരം പദ്ധതികളെന്നും ഇത്തരത്തിൽ മാതൃകാ പ്രവർത്തനം നടത്തുന്ന നിംസ് മെഡിസിറ്റി എംഡി, എം .എസ് .ഫൈസൽ ഖാൻ  സേവനത്തിന്റെ മാതൃകാ മുഖമായി മാറുകയാണെന്നും ഉദ്ഘാടനം ചെയ്തു സംസാരിച്ചു. നിംസ് നെയ്യാറ്റിൻകര പെൻഷൻ പ്ളാൻ ചെയർ പേഴ്സൺ  രേണു.കെ.ആർ പദ്ധതി വിവരണവും സ്വാഗതവും ആശംസിച്ചു.  ഡിസ്ട്രിക്ട് സോഷ്യൽ വെൽഫയർ ഓഫീസർ  ഷൈനി മോൾ തൊഴിൽ പരിശീലനത്തിന്റെ പ്രവർത്തനോത്ഘാടനം നിർവ്വഹിച്ചു. കേരള സംസ്ഥാന വികലാംഗ കോർപ്പറേഷൻ ചെയർ പേഴ്സൺ ജയാ ഡാളി നെയ്യാറ്റിൻകര പെൻഷൻ പ്ലാനിന്റെ ഭാഗമായുള്ള അഡീഷണൽ  പെൻഷൻ വിതരണത്തിന്റെ ഉദ്ഘാടനം ചെയ്യുകയുണ്ടായി. ചടങ്ങിൽ  നിംസ് സ്പെക്ട്രം ഡയറക്ടറും മുൻ ആരോഗ്യ സർവ്വകലാശാല വൈസ് ചാൻസലറുമായ ഡോ.എം.കെ.സി നായർ മുഖ്യ  പ്രഭാഷണം നടത്തി. നെയ്യാറ്റിൻകര മുനിസിപ്പാലിറ്റി ആരോഗ്യ സ്റ്റാൻഡിംഗ് കമ്മറ്റി ചെയർമാൻ  ജോസ്ഫ്രാങ്കിളിൻ, മുനിസിപ്പാലിറ്റി കൗൺസിലർ  ഐശ്വര്യ, നിംസ് ഫിസിക്കൽ മെഡിസിൻ വിഭാഗം മേധാവി ഡോ.ജിം ഗോപാല കൃഷ്ണൻ, കോട്ടു കാൽ പഞ്ചായത്ത് പ്രസിഡന്റ്  ജറോം ദാസ് ,പി. ബോബി , ജയകുമാർ തുടങ്ങിയവർ ചടങ്ങിൽ ആശംസ അർപ്പിച്ചു സംസാരിച്ചു.",
      thumb: "assets/img/pensionscheme/124.jpeg",
    },
    {
      src: "assets/img/pensionscheme/125.jpeg",
      caption:
        "വേൾഡ് യൂത്ത് സ്കിൽ ദിനമായ ജൂലൈ 15 ന് നിംസ് മെഡിസിറ്റി നടത്തിവരുന്ന നെയ്യാറ്റിൻകര പെൻഷൻ പ്ളാൻ ഉപഭോക്താക്കളായ കുട്ടികൾക്കും അമ്മമാർക്കും തൊഴിൽ പരിശീലന പരിപാടി സംഘടിപ്പിച്ചു. നിംസ് മെഡിസിറ്റി ജനറൽ മാനേജർ ഡോ.കെ.എ. സജു അദ്ധ്യക്ഷത വഹിച്ച ചടങ്ങിൽ ചൈൽഡ് വെൽഫെയർ കമ്മിറ്റി  ചെയർപേഴ്സൺ  ഷാഹിന ബീഗം ഉദ്ഘാടനം ചെയ്തു സംസാരിച്ചു. ഭിന്നശേഷി കുട്ടികൾക്കും കുടുംബത്തിനും താങ്ങായി മാറുകയാണ് ഇത്തരം പദ്ധതികളെന്നും ഇത്തരത്തിൽ മാതൃകാ പ്രവർത്തനം നടത്തുന്ന നിംസ് മെഡിസിറ്റി എംഡി, എം .എസ് .ഫൈസൽ ഖാൻ  സേവനത്തിന്റെ മാതൃകാ മുഖമായി മാറുകയാണെന്നും ഉദ്ഘാടനം ചെയ്തു സംസാരിച്ചു. നിംസ് നെയ്യാറ്റിൻകര പെൻഷൻ പ്ളാൻ ചെയർ പേഴ്സൺ  രേണു.കെ.ആർ പദ്ധതി വിവരണവും സ്വാഗതവും ആശംസിച്ചു.  ഡിസ്ട്രിക്ട് സോഷ്യൽ വെൽഫയർ ഓഫീസർ  ഷൈനി മോൾ തൊഴിൽ പരിശീലനത്തിന്റെ പ്രവർത്തനോത്ഘാടനം നിർവ്വഹിച്ചു. കേരള സംസ്ഥാന വികലാംഗ കോർപ്പറേഷൻ ചെയർ പേഴ്സൺ ജയാ ഡാളി നെയ്യാറ്റിൻകര പെൻഷൻ പ്ലാനിന്റെ ഭാഗമായുള്ള അഡീഷണൽ  പെൻഷൻ വിതരണത്തിന്റെ ഉദ്ഘാടനം ചെയ്യുകയുണ്ടായി. ചടങ്ങിൽ  നിംസ് സ്പെക്ട്രം ഡയറക്ടറും മുൻ ആരോഗ്യ സർവ്വകലാശാല വൈസ് ചാൻസലറുമായ ഡോ.എം.കെ.സി നായർ മുഖ്യ  പ്രഭാഷണം നടത്തി. നെയ്യാറ്റിൻകര മുനിസിപ്പാലിറ്റി ആരോഗ്യ സ്റ്റാൻഡിംഗ് കമ്മറ്റി ചെയർമാൻ  ജോസ്ഫ്രാങ്കിളിൻ, മുനിസിപ്പാലിറ്റി കൗൺസിലർ  ഐശ്വര്യ, നിംസ് ഫിസിക്കൽ മെഡിസിൻ വിഭാഗം മേധാവി ഡോ.ജിം ഗോപാല കൃഷ്ണൻ, കോട്ടു കാൽ പഞ്ചായത്ത് പ്രസിഡന്റ്  ജറോം ദാസ് ,പി. ബോബി , ജയകുമാർ തുടങ്ങിയവർ ചടങ്ങിൽ ആശംസ അർപ്പിച്ചു സംസാരിച്ചു.",
      thumb: "assets/img/pensionscheme/125.jpeg",
    },
    {
      src: "assets/img/pensionscheme/87.jpeg",
      caption: "",
      thumb: "assets/img/pensionscheme/87.jpeg",
    },
    {
      src: "assets/img/pensionscheme/88.jpeg",
      caption: "",
      thumb: "assets/img/pensionscheme/88.jpeg",
    },
    {
      src: "assets/img/pensionscheme/89.jpeg",
      caption: "",
      thumb: "assets/img/pensionscheme/89.jpeg",
    },
    {
      src: "assets/img/pensionscheme/90.jpeg",
      caption: "",
      thumb: "assets/img/pensionscheme/90.jpeg",
    },
    {
      src: "assets/img/pensionscheme/91.jpeg",
      caption: "",
      thumb: "assets/img/pensionscheme/91.jpeg",
    },
    {
      src: "assets/img/pensionscheme/92.jpeg",
      caption: "",
      thumb: "assets/img/pensionscheme/92.jpeg",
    },
    {
      src: "assets/img/pensionscheme/93.jpeg",
      caption: "",
      thumb: "assets/img/pensionscheme/93.jpeg",
    },
    {
      src: "assets/img/pensionscheme/94.jpeg",
      caption: "",
      thumb: "assets/img/pensionscheme/94.jpeg",
    },
    {
      src: "assets/img/pensionscheme/95.jpeg",
      caption: "",
      thumb: "assets/img/pensionscheme/95.jpeg",
    },
    {
      src: "assets/img/pensionscheme/96.jpeg",
      caption: "",
      thumb: "assets/img/pensionscheme/96.jpeg",
    },
    {
      src: "assets/img/pensionscheme/97.jpeg",
      caption: "",
      thumb: "assets/img/pensionscheme/97.jpeg",
    },
    {
      src: "assets/img/pensionscheme/98.jpeg",
      caption: "",
      thumb: "assets/img/pensionscheme/98.jpeg",
    },
    {
      src: "assets/img/pensionscheme/99.jpeg",
      caption: "",
      thumb: "assets/img/pensionscheme/99.jpeg",
    },
    {
      src: "assets/img/pensionscheme/100.jpeg",
      caption: "",
      thumb: "assets/img/pensionscheme/100.jpeg",
    },
    {
      src: "assets/img/pensionscheme/101.jpeg",
      caption: "",
      thumb: "assets/img/pensionscheme/101.jpeg",
    },
    {
      src: "assets/img/pensionscheme/102.jpeg",
      caption: "",
      thumb: "assets/img/pensionscheme/102.jpeg",
    },
    {
      src: "assets/img/pensionscheme/103.jpeg",
      caption: "",
      thumb: "assets/img/pensionscheme/103.jpeg",
    },
    {
      src: "assets/img/pensionscheme/104.jpeg",
      caption: "",
      thumb: "assets/img/pensionscheme/104.jpeg",
    },
    {
      src: "assets/img/pensionscheme/105.jpeg",
      caption: "",
      thumb: "assets/img/pensionscheme/105.jpeg",
    },

    {
      src: "assets/img/pensionscheme/68.jpeg",
      caption: "",
      thumb: "assets/img/pensionscheme/68.jpeg",
    },
    {
      src: "assets/img/pensionscheme/69.jpeg",
      caption: "",
      thumb: "assets/img/pensionscheme/69.jpeg",
    },
    {
      src: "assets/img/pensionscheme/70.jpeg",
      caption: "",
      thumb: "assets/img/pensionscheme/70.jpeg",
    },
    {
      src: "assets/img/pensionscheme/71.jpeg",
      caption: "",
      thumb: "assets/img/pensionscheme/71.jpeg",
    },
    {
      src: "assets/img/pensionscheme/72.jpeg",
      caption: "",
      thumb: "assets/img/pensionscheme/72.jpeg",
    },
    {
      src: "assets/img/pensionscheme/73.jpeg",
      caption: "",
      thumb: "assets/img/pensionscheme/73.jpeg",
    },
    {
      src: "assets/img/pensionscheme/74.jpeg",
      caption: "",
      thumb: "assets/img/pensionscheme/74.jpeg",
    },
    {
      src: "assets/img/pensionscheme/75.jpeg",
      caption: "",
      thumb: "assets/img/pensionscheme/75.jpeg",
    },
    {
      src: "assets/img/pensionscheme/76.jpeg",
      caption: "",
      thumb: "assets/img/pensionscheme/76.jpeg",
    },
    {
      src: "assets/img/pensionscheme/77.jpeg",
      caption: "",
      thumb: "assets/img/pensionscheme/77.jpeg",
    },
    {
      src: "assets/img/pensionscheme/78.jpeg",
      caption: "",
      thumb: "assets/img/pensionscheme/78.jpeg",
    },
    {
      src: "assets/img/pensionscheme/79.jpeg",
      caption: "",
      thumb: "assets/img/pensionscheme/79.jpeg",
    },
    {
      src: "assets/img/pensionscheme/80.jpeg",
      caption: "",
      thumb: "assets/img/pensionscheme/80.jpeg",
    },
    {
      src: "assets/img/pensionscheme/81.jpeg",
      caption: "",
      thumb: "assets/img/pensionscheme/81.jpeg",
    },
    {
      src: "assets/img/pensionscheme/82.jpeg",
      caption: "",
      thumb: "assets/img/pensionscheme/82.jpeg",
    },
    {
      src: "assets/img/pensionscheme/83.jpeg",
      caption: "",
      thumb: "assets/img/pensionscheme/83.jpeg",
    },
    {
      src: "assets/img/pensionscheme/84.jpeg",
      caption: "",
      thumb: "assets/img/pensionscheme/84.jpeg",
    },
    {
      src: "assets/img/pensionscheme/85.jpeg",
      caption: "",
      thumb: "assets/img/pensionscheme/85.jpeg",
    },
    {
      src: "assets/img/pensionscheme/86.jpeg",
      caption: "",
      thumb: "assets/img/pensionscheme/86.jpeg",
    },
    {
      src: "assets/img/pensionscheme/43.jpeg",
      caption:
        "കോവിഡ് 19 ൻ്റെ സാഹചര്യത്തിൽ 18 വയസ്സിന് താഴെ പ്രായമുള്ള ഭിന്നശേഷിക്കാരായ കുട്ടികൾക്ക്‌ സമീകൃത ആഹാരം കൊടുക്കുന്നതിന്  വേണ്ടി 2021ൽ ആരംഭിച്ച പെൻഷൻ പ്ലാനിൽ  2023 ൽ കല്ലിയൂർ ഗ്രാമപഞ്ചായത്തിലെ ഭിന്നശേഷി വിഭാഗത്തിൽ പെട്ട 18 വയസ്സിന് താഴെ പ്രായമുള്ള 41 കുട്ടികൾക്കും കൂടെ പെൻഷനും  സൗജന്യ വൈദ്യപരിശോധനയും തുടർ ചികിൽസയും നൽകാൻ 28-01-2023 - ൽ ഊക്കോട് എൻ.എസ്സ് .എസ്സ് ഓഡിറ്റോറിയത്തിൽ വച്ച് നടന്ന ക്യാംപിൽ നിംസ് മെഡിസിറ്റി മാനേജിങ്ങ് ഡയറക്ടർ ശ്രീ.എം.എസ്. ഫൈസൽ ഖാൻ പ്രഖ്യാപിക്കുകയുണ്ടായി.  കല്ലിയൂർ പഞ്ചായത്ത് പ്രസിഡന്റ് ശ്രീ ചന്ദു കൃഷ്ണൻ , പ്രശസ്ത സിനിമാ സീരിയൽ താരം ശ്രീ കൃഷ്ണ കുമാർ , നിംസ് മെഡിസിറ്റി ജനറൽ മാനേജർ ഡോ. സജു .കെ.എ, നെയ്യാറ്റിൻകര പെൻഷൻ പ്ലാൻ ചെയർപേഴ്സൺ ശ്രീമതി രേണു കെ.ആർ മറ്റ് പഞ്ചായത്ത് അംഗങ്ങൾ തുടങ്ങിയവർ ചടങ്ങിൽ പങ്കെടുത്തു. തുടർന്ന് 2023 ഫെബ്രുവരി മുതൽ നിംസ് സ്പെക്ട്രത്തിൽ വച്ച് കല്ലിയൂർ പഞ്ചായത്തിലെ ഗുണഭോക്താക്കൾക്ക്  വേണ്ടി നിംസ് സ്പെക്ട്രം ഡയറക്ടർ ഡോ. എം കെ സി യുടെ നേതൃത്വത്തിൽ സൗജന്യ മെഡിക്കൽ ചെക്കപ്പ് നടത്തുകയും, നിംസ് മെഡിസിറ്റി മാനേജിങ്ങ് ഡയറക്ടർ ശ്രീ എം എസ് ഫൈസൽ ഖാൻ പെൻഷൻ വിതണോൽ ഘാടനവും നടത്തി. തുടർന്ന് കൽപ്പറ്റ എം എൽ എ . ടി. സിദ്ദിഖ്, നെയ്യാറ്റിൻകര വില്ലേജ് ഓഫീസർ  ശ്രീ. ദിലീപ് തുടങ്ങിയവർ ചടങ്ങിൽ പങ്കെടുത്തു.",
      thumb: "assets/img/pensionscheme/43.jpeg",
    },
    {
      src: "assets/img/pensionscheme/44.jpeg",
      caption:
        "കോവിഡ് 19 ൻ്റെ സാഹചര്യത്തിൽ 18 വയസ്സിന് താഴെ പ്രായമുള്ള ഭിന്നശേഷിക്കാരായ കുട്ടികൾക്ക്‌ സമീകൃത ആഹാരം കൊടുക്കുന്നതിന്  വേണ്ടി 2021ൽ ആരംഭിച്ച പെൻഷൻ പ്ലാനിൽ  2023 ൽ കല്ലിയൂർ ഗ്രാമപഞ്ചായത്തിലെ ഭിന്നശേഷി വിഭാഗത്തിൽ പെട്ട 18 വയസ്സിന് താഴെ പ്രായമുള്ള 41 കുട്ടികൾക്കും കൂടെ പെൻഷനും  സൗജന്യ വൈദ്യപരിശോധനയും തുടർ ചികിൽസയും നൽകാൻ 28-01-2023 - ൽ ഊക്കോട് എൻ.എസ്സ് .എസ്സ് ഓഡിറ്റോറിയത്തിൽ വച്ച് നടന്ന ക്യാംപിൽ നിംസ് മെഡിസിറ്റി മാനേജിങ്ങ് ഡയറക്ടർ ശ്രീ.എം.എസ്. ഫൈസൽ ഖാൻ പ്രഖ്യാപിക്കുകയുണ്ടായി.  കല്ലിയൂർ പഞ്ചായത്ത് പ്രസിഡന്റ് ശ്രീ ചന്ദു കൃഷ്ണൻ , പ്രശസ്ത സിനിമാ സീരിയൽ താരം ശ്രീ കൃഷ്ണ കുമാർ , നിംസ് മെഡിസിറ്റി ജനറൽ മാനേജർ ഡോ. സജു .കെ.എ, നെയ്യാറ്റിൻകര പെൻഷൻ പ്ലാൻ ചെയർപേഴ്സൺ ശ്രീമതി രേണു കെ.ആർ മറ്റ് പഞ്ചായത്ത് അംഗങ്ങൾ തുടങ്ങിയവർ ചടങ്ങിൽ പങ്കെടുത്തു. തുടർന്ന് 2023 ഫെബ്രുവരി മുതൽ നിംസ് സ്പെക്ട്രത്തിൽ വച്ച് കല്ലിയൂർ പഞ്ചായത്തിലെ ഗുണഭോക്താക്കൾക്ക്  വേണ്ടി നിംസ് സ്പെക്ട്രം ഡയറക്ടർ ഡോ. എം കെ സി യുടെ നേതൃത്വത്തിൽ സൗജന്യ മെഡിക്കൽ ചെക്കപ്പ് നടത്തുകയും, നിംസ് മെഡിസിറ്റി മാനേജിങ്ങ് ഡയറക്ടർ ശ്രീ എം എസ് ഫൈസൽ ഖാൻ പെൻഷൻ വിതണോൽ ഘാടനവും നടത്തി. തുടർന്ന് കൽപ്പറ്റ എം എൽ എ . ടി. സിദ്ദിഖ്, നെയ്യാറ്റിൻകര വില്ലേജ് ഓഫീസർ  ശ്രീ. ദിലീപ് തുടങ്ങിയവർ ചടങ്ങിൽ പങ്കെടുത്തു.",
      thumb: "assets/img/pensionscheme/44.jpeg",
    },
    {
      src: "assets/img/pensionscheme/45.jpeg",
      caption:
        "കോവിഡ് 19 ൻ്റെ സാഹചര്യത്തിൽ 18 വയസ്സിന് താഴെ പ്രായമുള്ള ഭിന്നശേഷിക്കാരായ കുട്ടികൾക്ക്‌ സമീകൃത ആഹാരം കൊടുക്കുന്നതിന്  വേണ്ടി 2021ൽ ആരംഭിച്ച പെൻഷൻ പ്ലാനിൽ  2023 ൽ കല്ലിയൂർ ഗ്രാമപഞ്ചായത്തിലെ ഭിന്നശേഷി വിഭാഗത്തിൽ പെട്ട 18 വയസ്സിന് താഴെ പ്രായമുള്ള 41 കുട്ടികൾക്കും കൂടെ പെൻഷനും  സൗജന്യ വൈദ്യപരിശോധനയും തുടർ ചികിൽസയും നൽകാൻ 28-01-2023 - ൽ ഊക്കോട് എൻ.എസ്സ് .എസ്സ് ഓഡിറ്റോറിയത്തിൽ വച്ച് നടന്ന ക്യാംപിൽ നിംസ് മെഡിസിറ്റി മാനേജിങ്ങ് ഡയറക്ടർ ശ്രീ.എം.എസ്. ഫൈസൽ ഖാൻ പ്രഖ്യാപിക്കുകയുണ്ടായി.  കല്ലിയൂർ പഞ്ചായത്ത് പ്രസിഡന്റ് ശ്രീ ചന്ദു കൃഷ്ണൻ , പ്രശസ്ത സിനിമാ സീരിയൽ താരം ശ്രീ കൃഷ്ണ കുമാർ , നിംസ് മെഡിസിറ്റി ജനറൽ മാനേജർ ഡോ. സജു .കെ.എ, നെയ്യാറ്റിൻകര പെൻഷൻ പ്ലാൻ ചെയർപേഴ്സൺ ശ്രീമതി രേണു കെ.ആർ മറ്റ് പഞ്ചായത്ത് അംഗങ്ങൾ തുടങ്ങിയവർ ചടങ്ങിൽ പങ്കെടുത്തു. തുടർന്ന് 2023 ഫെബ്രുവരി മുതൽ നിംസ് സ്പെക്ട്രത്തിൽ വച്ച് കല്ലിയൂർ പഞ്ചായത്തിലെ ഗുണഭോക്താക്കൾക്ക്  വേണ്ടി നിംസ് സ്പെക്ട്രം ഡയറക്ടർ ഡോ. എം കെ സി യുടെ നേതൃത്വത്തിൽ സൗജന്യ മെഡിക്കൽ ചെക്കപ്പ് നടത്തുകയും, നിംസ് മെഡിസിറ്റി മാനേജിങ്ങ് ഡയറക്ടർ ശ്രീ എം എസ് ഫൈസൽ ഖാൻ പെൻഷൻ വിതണോൽ ഘാടനവും നടത്തി. തുടർന്ന് കൽപ്പറ്റ എം എൽ എ . ടി. സിദ്ദിഖ്, നെയ്യാറ്റിൻകര വില്ലേജ് ഓഫീസർ  ശ്രീ. ദിലീപ് തുടങ്ങിയവർ ചടങ്ങിൽ പങ്കെടുത്തു.",
      thumb: "assets/img/pensionscheme/45.jpeg",
    },
    {
      src: "assets/img/pensionscheme/46.jpeg",
      caption:
        "കോവിഡ് 19 ൻ്റെ സാഹചര്യത്തിൽ 18 വയസ്സിന് താഴെ പ്രായമുള്ള ഭിന്നശേഷിക്കാരായ കുട്ടികൾക്ക്‌ സമീകൃത ആഹാരം കൊടുക്കുന്നതിന്  വേണ്ടി 2021ൽ ആരംഭിച്ച പെൻഷൻ പ്ലാനിൽ  2023 ൽ കല്ലിയൂർ ഗ്രാമപഞ്ചായത്തിലെ ഭിന്നശേഷി വിഭാഗത്തിൽ പെട്ട 18 വയസ്സിന് താഴെ പ്രായമുള്ള 41 കുട്ടികൾക്കും കൂടെ പെൻഷനും  സൗജന്യ വൈദ്യപരിശോധനയും തുടർ ചികിൽസയും നൽകാൻ 28-01-2023 - ൽ ഊക്കോട് എൻ.എസ്സ് .എസ്സ് ഓഡിറ്റോറിയത്തിൽ വച്ച് നടന്ന ക്യാംപിൽ നിംസ് മെഡിസിറ്റി മാനേജിങ്ങ് ഡയറക്ടർ ശ്രീ.എം.എസ്. ഫൈസൽ ഖാൻ പ്രഖ്യാപിക്കുകയുണ്ടായി.  കല്ലിയൂർ പഞ്ചായത്ത് പ്രസിഡന്റ് ശ്രീ ചന്ദു കൃഷ്ണൻ , പ്രശസ്ത സിനിമാ സീരിയൽ താരം ശ്രീ കൃഷ്ണ കുമാർ , നിംസ് മെഡിസിറ്റി ജനറൽ മാനേജർ ഡോ. സജു .കെ.എ, നെയ്യാറ്റിൻകര പെൻഷൻ പ്ലാൻ ചെയർപേഴ്സൺ ശ്രീമതി രേണു കെ.ആർ മറ്റ് പഞ്ചായത്ത് അംഗങ്ങൾ തുടങ്ങിയവർ ചടങ്ങിൽ പങ്കെടുത്തു. തുടർന്ന് 2023 ഫെബ്രുവരി മുതൽ നിംസ് സ്പെക്ട്രത്തിൽ വച്ച് കല്ലിയൂർ പഞ്ചായത്തിലെ ഗുണഭോക്താക്കൾക്ക്  വേണ്ടി നിംസ് സ്പെക്ട്രം ഡയറക്ടർ ഡോ. എം കെ സി യുടെ നേതൃത്വത്തിൽ സൗജന്യ മെഡിക്കൽ ചെക്കപ്പ് നടത്തുകയും, നിംസ് മെഡിസിറ്റി മാനേജിങ്ങ് ഡയറക്ടർ ശ്രീ എം എസ് ഫൈസൽ ഖാൻ പെൻഷൻ വിതണോൽ ഘാടനവും നടത്തി. തുടർന്ന് കൽപ്പറ്റ എം എൽ എ . ടി. സിദ്ദിഖ്, നെയ്യാറ്റിൻകര വില്ലേജ് ഓഫീസർ  ശ്രീ. ദിലീപ് തുടങ്ങിയവർ ചടങ്ങിൽ പങ്കെടുത്തു.",
      thumb: "assets/img/pensionscheme/46.jpeg",
    },
    {
      src: "assets/img/pensionscheme/47.jpeg",
      caption:
        "കോവിഡ് 19 ൻ്റെ സാഹചര്യത്തിൽ 18 വയസ്സിന് താഴെ പ്രായമുള്ള ഭിന്നശേഷിക്കാരായ കുട്ടികൾക്ക്‌ സമീകൃത ആഹാരം കൊടുക്കുന്നതിന്  വേണ്ടി 2021ൽ ആരംഭിച്ച പെൻഷൻ പ്ലാനിൽ  2023 ൽ കല്ലിയൂർ ഗ്രാമപഞ്ചായത്തിലെ ഭിന്നശേഷി വിഭാഗത്തിൽ പെട്ട 18 വയസ്സിന് താഴെ പ്രായമുള്ള 41 കുട്ടികൾക്കും കൂടെ പെൻഷനും  സൗജന്യ വൈദ്യപരിശോധനയും തുടർ ചികിൽസയും നൽകാൻ 28-01-2023 - ൽ ഊക്കോട് എൻ.എസ്സ് .എസ്സ് ഓഡിറ്റോറിയത്തിൽ വച്ച് നടന്ന ക്യാംപിൽ നിംസ് മെഡിസിറ്റി മാനേജിങ്ങ് ഡയറക്ടർ ശ്രീ.എം.എസ്. ഫൈസൽ ഖാൻ പ്രഖ്യാപിക്കുകയുണ്ടായി.  കല്ലിയൂർ പഞ്ചായത്ത് പ്രസിഡന്റ് ശ്രീ ചന്ദു കൃഷ്ണൻ , പ്രശസ്ത സിനിമാ സീരിയൽ താരം ശ്രീ കൃഷ്ണ കുമാർ , നിംസ് മെഡിസിറ്റി ജനറൽ മാനേജർ ഡോ. സജു .കെ.എ, നെയ്യാറ്റിൻകര പെൻഷൻ പ്ലാൻ ചെയർപേഴ്സൺ ശ്രീമതി രേണു കെ.ആർ മറ്റ് പഞ്ചായത്ത് അംഗങ്ങൾ തുടങ്ങിയവർ ചടങ്ങിൽ പങ്കെടുത്തു. തുടർന്ന് 2023 ഫെബ്രുവരി മുതൽ നിംസ് സ്പെക്ട്രത്തിൽ വച്ച് കല്ലിയൂർ പഞ്ചായത്തിലെ ഗുണഭോക്താക്കൾക്ക്  വേണ്ടി നിംസ് സ്പെക്ട്രം ഡയറക്ടർ ഡോ. എം കെ സി യുടെ നേതൃത്വത്തിൽ സൗജന്യ മെഡിക്കൽ ചെക്കപ്പ് നടത്തുകയും, നിംസ് മെഡിസിറ്റി മാനേജിങ്ങ് ഡയറക്ടർ ശ്രീ എം എസ് ഫൈസൽ ഖാൻ പെൻഷൻ വിതണോൽ ഘാടനവും നടത്തി. തുടർന്ന് കൽപ്പറ്റ എം എൽ എ . ടി. സിദ്ദിഖ്, നെയ്യാറ്റിൻകര വില്ലേജ് ഓഫീസർ  ശ്രീ. ദിലീപ് തുടങ്ങിയവർ ചടങ്ങിൽ പങ്കെടുത്തു.",
      thumb: "assets/img/pensionscheme/47.jpeg",
    },
    {
      src: "assets/img/pensionscheme/49.jpeg",
      caption:
        "കോവിഡ് 19 ൻ്റെ സാഹചര്യത്തിൽ 18 വയസ്സിന് താഴെ പ്രായമുള്ള ഭിന്നശേഷിക്കാരായ കുട്ടികൾക്ക്‌ സമീകൃത ആഹാരം കൊടുക്കുന്നതിന്  വേണ്ടി 2021ൽ ആരംഭിച്ച പെൻഷൻ പ്ലാനിൽ  2023 ൽ കല്ലിയൂർ ഗ്രാമപഞ്ചായത്തിലെ ഭിന്നശേഷി വിഭാഗത്തിൽ പെട്ട 18 വയസ്സിന് താഴെ പ്രായമുള്ള 41 കുട്ടികൾക്കും കൂടെ പെൻഷനും  സൗജന്യ വൈദ്യപരിശോധനയും തുടർ ചികിൽസയും നൽകാൻ 28-01-2023 - ൽ ഊക്കോട് എൻ.എസ്സ് .എസ്സ് ഓഡിറ്റോറിയത്തിൽ വച്ച് നടന്ന ക്യാംപിൽ നിംസ് മെഡിസിറ്റി മാനേജിങ്ങ് ഡയറക്ടർ ശ്രീ.എം.എസ്. ഫൈസൽ ഖാൻ പ്രഖ്യാപിക്കുകയുണ്ടായി.  കല്ലിയൂർ പഞ്ചായത്ത് പ്രസിഡന്റ് ശ്രീ ചന്ദു കൃഷ്ണൻ , പ്രശസ്ത സിനിമാ സീരിയൽ താരം ശ്രീ കൃഷ്ണ കുമാർ , നിംസ് മെഡിസിറ്റി ജനറൽ മാനേജർ ഡോ. സജു .കെ.എ, നെയ്യാറ്റിൻകര പെൻഷൻ പ്ലാൻ ചെയർപേഴ്സൺ ശ്രീമതി രേണു കെ.ആർ മറ്റ് പഞ്ചായത്ത് അംഗങ്ങൾ തുടങ്ങിയവർ ചടങ്ങിൽ പങ്കെടുത്തു. തുടർന്ന് 2023 ഫെബ്രുവരി മുതൽ നിംസ് സ്പെക്ട്രത്തിൽ വച്ച് കല്ലിയൂർ പഞ്ചായത്തിലെ ഗുണഭോക്താക്കൾക്ക്  വേണ്ടി നിംസ് സ്പെക്ട്രം ഡയറക്ടർ ഡോ. എം കെ സി യുടെ നേതൃത്വത്തിൽ സൗജന്യ മെഡിക്കൽ ചെക്കപ്പ് നടത്തുകയും, നിംസ് മെഡിസിറ്റി മാനേജിങ്ങ് ഡയറക്ടർ ശ്രീ എം എസ് ഫൈസൽ ഖാൻ പെൻഷൻ വിതണോൽ ഘാടനവും നടത്തി. തുടർന്ന് കൽപ്പറ്റ എം എൽ എ . ടി. സിദ്ദിഖ്, നെയ്യാറ്റിൻകര വില്ലേജ് ഓഫീസർ  ശ്രീ. ദിലീപ് തുടങ്ങിയവർ ചടങ്ങിൽ പങ്കെടുത്തു.",
      thumb: "assets/img/pensionscheme/49.jpeg",
    },
    {
      src: "assets/img/pensionscheme/48.jpeg",
      caption:
        "കോവിഡ് 19 ൻ്റെ സാഹചര്യത്തിൽ 18 വയസ്സിന് താഴെ പ്രായമുള്ള ഭിന്നശേഷിക്കാരായ കുട്ടികൾക്ക്‌ സമീകൃത ആഹാരം കൊടുക്കുന്നതിന്  വേണ്ടി 2021ൽ ആരംഭിച്ച പെൻഷൻ പ്ലാനിൽ  2023 ൽ കല്ലിയൂർ ഗ്രാമപഞ്ചായത്തിലെ ഭിന്നശേഷി വിഭാഗത്തിൽ പെട്ട 18 വയസ്സിന് താഴെ പ്രായമുള്ള 41 കുട്ടികൾക്കും കൂടെ പെൻഷനും  സൗജന്യ വൈദ്യപരിശോധനയും തുടർ ചികിൽസയും നൽകാൻ 28-01-2023 - ൽ ഊക്കോട് എൻ.എസ്സ് .എസ്സ് ഓഡിറ്റോറിയത്തിൽ വച്ച് നടന്ന ക്യാംപിൽ നിംസ് മെഡിസിറ്റി മാനേജിങ്ങ് ഡയറക്ടർ ശ്രീ.എം.എസ്. ഫൈസൽ ഖാൻ പ്രഖ്യാപിക്കുകയുണ്ടായി.  കല്ലിയൂർ പഞ്ചായത്ത് പ്രസിഡന്റ് ശ്രീ ചന്ദു കൃഷ്ണൻ , പ്രശസ്ത സിനിമാ സീരിയൽ താരം ശ്രീ കൃഷ്ണ കുമാർ , നിംസ് മെഡിസിറ്റി ജനറൽ മാനേജർ ഡോ. സജു .കെ.എ, നെയ്യാറ്റിൻകര പെൻഷൻ പ്ലാൻ ചെയർപേഴ്സൺ ശ്രീമതി രേണു കെ.ആർ മറ്റ് പഞ്ചായത്ത് അംഗങ്ങൾ തുടങ്ങിയവർ ചടങ്ങിൽ പങ്കെടുത്തു. തുടർന്ന് 2023 ഫെബ്രുവരി മുതൽ നിംസ് സ്പെക്ട്രത്തിൽ വച്ച് കല്ലിയൂർ പഞ്ചായത്തിലെ ഗുണഭോക്താക്കൾക്ക്  വേണ്ടി നിംസ് സ്പെക്ട്രം ഡയറക്ടർ ഡോ. എം കെ സി യുടെ നേതൃത്വത്തിൽ സൗജന്യ മെഡിക്കൽ ചെക്കപ്പ് നടത്തുകയും, നിംസ് മെഡിസിറ്റി മാനേജിങ്ങ് ഡയറക്ടർ ശ്രീ എം എസ് ഫൈസൽ ഖാൻ പെൻഷൻ വിതണോൽ ഘാടനവും നടത്തി. തുടർന്ന് കൽപ്പറ്റ എം എൽ എ . ടി. സിദ്ദിഖ്, നെയ്യാറ്റിൻകര വില്ലേജ് ഓഫീസർ  ശ്രീ. ദിലീപ് തുടങ്ങിയവർ ചടങ്ങിൽ പങ്കെടുത്തു.",
      thumb: "assets/img/pensionscheme/48.jpeg",
    },
    {
      src: "assets/img/pensionscheme/50.jpeg",
      caption:
        "കോവിഡ് 19 ൻ്റെ സാഹചര്യത്തിൽ 18 വയസ്സിന് താഴെ പ്രായമുള്ള ഭിന്നശേഷിക്കാരായ കുട്ടികൾക്ക്‌ സമീകൃത ആഹാരം കൊടുക്കുന്നതിന്  വേണ്ടി 2021ൽ ആരംഭിച്ച പെൻഷൻ പ്ലാനിൽ  2023 ൽ കല്ലിയൂർ ഗ്രാമപഞ്ചായത്തിലെ ഭിന്നശേഷി വിഭാഗത്തിൽ പെട്ട 18 വയസ്സിന് താഴെ പ്രായമുള്ള 41 കുട്ടികൾക്കും കൂടെ പെൻഷനും  സൗജന്യ വൈദ്യപരിശോധനയും തുടർ ചികിൽസയും നൽകാൻ 28-01-2023 - ൽ ഊക്കോട് എൻ.എസ്സ് .എസ്സ് ഓഡിറ്റോറിയത്തിൽ വച്ച് നടന്ന ക്യാംപിൽ നിംസ് മെഡിസിറ്റി മാനേജിങ്ങ് ഡയറക്ടർ ശ്രീ.എം.എസ്. ഫൈസൽ ഖാൻ പ്രഖ്യാപിക്കുകയുണ്ടായി.  കല്ലിയൂർ പഞ്ചായത്ത് പ്രസിഡന്റ് ശ്രീ ചന്ദു കൃഷ്ണൻ , പ്രശസ്ത സിനിമാ സീരിയൽ താരം ശ്രീ കൃഷ്ണ കുമാർ , നിംസ് മെഡിസിറ്റി ജനറൽ മാനേജർ ഡോ. സജു .കെ.എ, നെയ്യാറ്റിൻകര പെൻഷൻ പ്ലാൻ ചെയർപേഴ്സൺ ശ്രീമതി രേണു കെ.ആർ മറ്റ് പഞ്ചായത്ത് അംഗങ്ങൾ തുടങ്ങിയവർ ചടങ്ങിൽ പങ്കെടുത്തു. തുടർന്ന് 2023 ഫെബ്രുവരി മുതൽ നിംസ് സ്പെക്ട്രത്തിൽ വച്ച് കല്ലിയൂർ പഞ്ചായത്തിലെ ഗുണഭോക്താക്കൾക്ക്  വേണ്ടി നിംസ് സ്പെക്ട്രം ഡയറക്ടർ ഡോ. എം കെ സി യുടെ നേതൃത്വത്തിൽ സൗജന്യ മെഡിക്കൽ ചെക്കപ്പ് നടത്തുകയും, നിംസ് മെഡിസിറ്റി മാനേജിങ്ങ് ഡയറക്ടർ ശ്രീ എം എസ് ഫൈസൽ ഖാൻ പെൻഷൻ വിതണോൽ ഘാടനവും നടത്തി. തുടർന്ന് കൽപ്പറ്റ എം എൽ എ . ടി. സിദ്ദിഖ്, നെയ്യാറ്റിൻകര വില്ലേജ് ഓഫീസർ  ശ്രീ. ദിലീപ് തുടങ്ങിയവർ ചടങ്ങിൽ പങ്കെടുത്തു.",
      thumb: "assets/img/pensionscheme/50.jpeg",
    },
    {
      src: "assets/img/pensionscheme/51.jpeg",
      caption:
        "കോവിഡ് 19 ൻ്റെ സാഹചര്യത്തിൽ 18 വയസ്സിന് താഴെ പ്രായമുള്ള ഭിന്നശേഷിക്കാരായ കുട്ടികൾക്ക്‌ സമീകൃത ആഹാരം കൊടുക്കുന്നതിന്  വേണ്ടി 2021ൽ ആരംഭിച്ച പെൻഷൻ പ്ലാനിൽ  2023 ൽ കല്ലിയൂർ ഗ്രാമപഞ്ചായത്തിലെ ഭിന്നശേഷി വിഭാഗത്തിൽ പെട്ട 18 വയസ്സിന് താഴെ പ്രായമുള്ള 41 കുട്ടികൾക്കും കൂടെ പെൻഷനും  സൗജന്യ വൈദ്യപരിശോധനയും തുടർ ചികിൽസയും നൽകാൻ 28-01-2023 - ൽ ഊക്കോട് എൻ.എസ്സ് .എസ്സ് ഓഡിറ്റോറിയത്തിൽ വച്ച് നടന്ന ക്യാംപിൽ നിംസ് മെഡിസിറ്റി മാനേജിങ്ങ് ഡയറക്ടർ ശ്രീ.എം.എസ്. ഫൈസൽ ഖാൻ പ്രഖ്യാപിക്കുകയുണ്ടായി.  കല്ലിയൂർ പഞ്ചായത്ത് പ്രസിഡന്റ് ശ്രീ ചന്ദു കൃഷ്ണൻ , പ്രശസ്ത സിനിമാ സീരിയൽ താരം ശ്രീ കൃഷ്ണ കുമാർ , നിംസ് മെഡിസിറ്റി ജനറൽ മാനേജർ ഡോ. സജു .കെ.എ, നെയ്യാറ്റിൻകര പെൻഷൻ പ്ലാൻ ചെയർപേഴ്സൺ ശ്രീമതി രേണു കെ.ആർ മറ്റ് പഞ്ചായത്ത് അംഗങ്ങൾ തുടങ്ങിയവർ ചടങ്ങിൽ പങ്കെടുത്തു. തുടർന്ന് 2023 ഫെബ്രുവരി മുതൽ നിംസ് സ്പെക്ട്രത്തിൽ വച്ച് കല്ലിയൂർ പഞ്ചായത്തിലെ ഗുണഭോക്താക്കൾക്ക്  വേണ്ടി നിംസ് സ്പെക്ട്രം ഡയറക്ടർ ഡോ. എം കെ സി യുടെ നേതൃത്വത്തിൽ സൗജന്യ മെഡിക്കൽ ചെക്കപ്പ് നടത്തുകയും, നിംസ് മെഡിസിറ്റി മാനേജിങ്ങ് ഡയറക്ടർ ശ്രീ എം എസ് ഫൈസൽ ഖാൻ പെൻഷൻ വിതണോൽ ഘാടനവും നടത്തി. തുടർന്ന് കൽപ്പറ്റ എം എൽ എ . ടി. സിദ്ദിഖ്, നെയ്യാറ്റിൻകര വില്ലേജ് ഓഫീസർ  ശ്രീ. ദിലീപ് തുടങ്ങിയവർ ചടങ്ങിൽ പങ്കെടുത്തു.",
      thumb: "assets/img/pensionscheme/51.jpeg",
    },
    {
      src: "assets/img/pensionscheme/52.jpeg",
      caption:
        "കോവിഡ് 19 ൻ്റെ സാഹചര്യത്തിൽ 18 വയസ്സിന് താഴെ പ്രായമുള്ള ഭിന്നശേഷിക്കാരായ കുട്ടികൾക്ക്‌ സമീകൃത ആഹാരം കൊടുക്കുന്നതിന്  വേണ്ടി 2021ൽ ആരംഭിച്ച പെൻഷൻ പ്ലാനിൽ  2023 ൽ കല്ലിയൂർ ഗ്രാമപഞ്ചായത്തിലെ ഭിന്നശേഷി വിഭാഗത്തിൽ പെട്ട 18 വയസ്സിന് താഴെ പ്രായമുള്ള 41 കുട്ടികൾക്കും കൂടെ പെൻഷനും  സൗജന്യ വൈദ്യപരിശോധനയും തുടർ ചികിൽസയും നൽകാൻ 28-01-2023 - ൽ ഊക്കോട് എൻ.എസ്സ് .എസ്സ് ഓഡിറ്റോറിയത്തിൽ വച്ച് നടന്ന ക്യാംപിൽ നിംസ് മെഡിസിറ്റി മാനേജിങ്ങ് ഡയറക്ടർ ശ്രീ.എം.എസ്. ഫൈസൽ ഖാൻ പ്രഖ്യാപിക്കുകയുണ്ടായി.  കല്ലിയൂർ പഞ്ചായത്ത് പ്രസിഡന്റ് ശ്രീ ചന്ദു കൃഷ്ണൻ , പ്രശസ്ത സിനിമാ സീരിയൽ താരം ശ്രീ കൃഷ്ണ കുമാർ , നിംസ് മെഡിസിറ്റി ജനറൽ മാനേജർ ഡോ. സജു .കെ.എ, നെയ്യാറ്റിൻകര പെൻഷൻ പ്ലാൻ ചെയർപേഴ്സൺ ശ്രീമതി രേണു കെ.ആർ മറ്റ് പഞ്ചായത്ത് അംഗങ്ങൾ തുടങ്ങിയവർ ചടങ്ങിൽ പങ്കെടുത്തു. തുടർന്ന് 2023 ഫെബ്രുവരി മുതൽ നിംസ് സ്പെക്ട്രത്തിൽ വച്ച് കല്ലിയൂർ പഞ്ചായത്തിലെ ഗുണഭോക്താക്കൾക്ക്  വേണ്ടി നിംസ് സ്പെക്ട്രം ഡയറക്ടർ ഡോ. എം കെ സി യുടെ നേതൃത്വത്തിൽ സൗജന്യ മെഡിക്കൽ ചെക്കപ്പ് നടത്തുകയും, നിംസ് മെഡിസിറ്റി മാനേജിങ്ങ് ഡയറക്ടർ ശ്രീ എം എസ് ഫൈസൽ ഖാൻ പെൻഷൻ വിതണോൽ ഘാടനവും നടത്തി. തുടർന്ന് കൽപ്പറ്റ എം എൽ എ . ടി. സിദ്ദിഖ്, നെയ്യാറ്റിൻകര വില്ലേജ് ഓഫീസർ  ശ്രീ. ദിലീപ് തുടങ്ങിയവർ ചടങ്ങിൽ പങ്കെടുത്തു.",
      thumb: "assets/img/pensionscheme/52.jpeg",
    },
    {
      src: "assets/img/pensionscheme/53.jpeg",
      caption:
        "കോവിഡ് 19 ൻ്റെ സാഹചര്യത്തിൽ 18 വയസ്സിന് താഴെ പ്രായമുള്ള ഭിന്നശേഷിക്കാരായ കുട്ടികൾക്ക്‌ സമീകൃത ആഹാരം കൊടുക്കുന്നതിന്  വേണ്ടി 2021ൽ ആരംഭിച്ച പെൻഷൻ പ്ലാനിൽ  2023 ൽ കല്ലിയൂർ ഗ്രാമപഞ്ചായത്തിലെ ഭിന്നശേഷി വിഭാഗത്തിൽ പെട്ട 18 വയസ്സിന് താഴെ പ്രായമുള്ള 41 കുട്ടികൾക്കും കൂടെ പെൻഷനും  സൗജന്യ വൈദ്യപരിശോധനയും തുടർ ചികിൽസയും നൽകാൻ 28-01-2023 - ൽ ഊക്കോട് എൻ.എസ്സ് .എസ്സ് ഓഡിറ്റോറിയത്തിൽ വച്ച് നടന്ന ക്യാംപിൽ നിംസ് മെഡിസിറ്റി മാനേജിങ്ങ് ഡയറക്ടർ ശ്രീ.എം.എസ്. ഫൈസൽ ഖാൻ പ്രഖ്യാപിക്കുകയുണ്ടായി.  കല്ലിയൂർ പഞ്ചായത്ത് പ്രസിഡന്റ് ശ്രീ ചന്ദു കൃഷ്ണൻ , പ്രശസ്ത സിനിമാ സീരിയൽ താരം ശ്രീ കൃഷ്ണ കുമാർ , നിംസ് മെഡിസിറ്റി ജനറൽ മാനേജർ ഡോ. സജു .കെ.എ, നെയ്യാറ്റിൻകര പെൻഷൻ പ്ലാൻ ചെയർപേഴ്സൺ ശ്രീമതി രേണു കെ.ആർ മറ്റ് പഞ്ചായത്ത് അംഗങ്ങൾ തുടങ്ങിയവർ ചടങ്ങിൽ പങ്കെടുത്തു. തുടർന്ന് 2023 ഫെബ്രുവരി മുതൽ നിംസ് സ്പെക്ട്രത്തിൽ വച്ച് കല്ലിയൂർ പഞ്ചായത്തിലെ ഗുണഭോക്താക്കൾക്ക്  വേണ്ടി നിംസ് സ്പെക്ട്രം ഡയറക്ടർ ഡോ. എം കെ സി യുടെ നേതൃത്വത്തിൽ സൗജന്യ മെഡിക്കൽ ചെക്കപ്പ് നടത്തുകയും, നിംസ് മെഡിസിറ്റി മാനേജിങ്ങ് ഡയറക്ടർ ശ്രീ എം എസ് ഫൈസൽ ഖാൻ പെൻഷൻ വിതണോൽ ഘാടനവും നടത്തി. തുടർന്ന് കൽപ്പറ്റ എം എൽ എ . ടി. സിദ്ദിഖ്, നെയ്യാറ്റിൻകര വില്ലേജ് ഓഫീസർ  ശ്രീ. ദിലീപ് തുടങ്ങിയവർ ചടങ്ങിൽ പങ്കെടുത്തു.",
      thumb: "assets/img/pensionscheme/53.jpeg",
    },
    {
      src: "assets/img/pensionscheme/54.jpeg",
      caption:
        "കോവിഡ് 19 ൻ്റെ സാഹചര്യത്തിൽ 18 വയസ്സിന് താഴെ പ്രായമുള്ള ഭിന്നശേഷിക്കാരായ കുട്ടികൾക്ക്‌ സമീകൃത ആഹാരം കൊടുക്കുന്നതിന്  വേണ്ടി 2021ൽ ആരംഭിച്ച പെൻഷൻ പ്ലാനിൽ  2023 ൽ കല്ലിയൂർ ഗ്രാമപഞ്ചായത്തിലെ ഭിന്നശേഷി വിഭാഗത്തിൽ പെട്ട 18 വയസ്സിന് താഴെ പ്രായമുള്ള 41 കുട്ടികൾക്കും കൂടെ പെൻഷനും  സൗജന്യ വൈദ്യപരിശോധനയും തുടർ ചികിൽസയും നൽകാൻ 28-01-2023 - ൽ ഊക്കോട് എൻ.എസ്സ് .എസ്സ് ഓഡിറ്റോറിയത്തിൽ വച്ച് നടന്ന ക്യാംപിൽ നിംസ് മെഡിസിറ്റി മാനേജിങ്ങ് ഡയറക്ടർ ശ്രീ.എം.എസ്. ഫൈസൽ ഖാൻ പ്രഖ്യാപിക്കുകയുണ്ടായി.  കല്ലിയൂർ പഞ്ചായത്ത് പ്രസിഡന്റ് ശ്രീ ചന്ദു കൃഷ്ണൻ , പ്രശസ്ത സിനിമാ സീരിയൽ താരം ശ്രീ കൃഷ്ണ കുമാർ , നിംസ് മെഡിസിറ്റി ജനറൽ മാനേജർ ഡോ. സജു .കെ.എ, നെയ്യാറ്റിൻകര പെൻഷൻ പ്ലാൻ ചെയർപേഴ്സൺ ശ്രീമതി രേണു കെ.ആർ മറ്റ് പഞ്ചായത്ത് അംഗങ്ങൾ തുടങ്ങിയവർ ചടങ്ങിൽ പങ്കെടുത്തു. തുടർന്ന് 2023 ഫെബ്രുവരി മുതൽ നിംസ് സ്പെക്ട്രത്തിൽ വച്ച് കല്ലിയൂർ പഞ്ചായത്തിലെ ഗുണഭോക്താക്കൾക്ക്  വേണ്ടി നിംസ് സ്പെക്ട്രം ഡയറക്ടർ ഡോ. എം കെ സി യുടെ നേതൃത്വത്തിൽ സൗജന്യ മെഡിക്കൽ ചെക്കപ്പ് നടത്തുകയും, നിംസ് മെഡിസിറ്റി മാനേജിങ്ങ് ഡയറക്ടർ ശ്രീ എം എസ് ഫൈസൽ ഖാൻ പെൻഷൻ വിതണോൽ ഘാടനവും നടത്തി. തുടർന്ന് കൽപ്പറ്റ എം എൽ എ . ടി. സിദ്ദിഖ്, നെയ്യാറ്റിൻകര വില്ലേജ് ഓഫീസർ  ശ്രീ. ദിലീപ് തുടങ്ങിയവർ ചടങ്ങിൽ പങ്കെടുത്തു.",
      thumb: "assets/img/pensionscheme/54.jpeg",
    },
    {
      src: "assets/img/pensionscheme/55.jpeg",
      caption:
        "കോവിഡ് 19 ൻ്റെ സാഹചര്യത്തിൽ 18 വയസ്സിന് താഴെ പ്രായമുള്ള ഭിന്നശേഷിക്കാരായ കുട്ടികൾക്ക്‌ സമീകൃത ആഹാരം കൊടുക്കുന്നതിന്  വേണ്ടി 2021ൽ ആരംഭിച്ച പെൻഷൻ പ്ലാനിൽ  2023 ൽ കല്ലിയൂർ ഗ്രാമപഞ്ചായത്തിലെ ഭിന്നശേഷി വിഭാഗത്തിൽ പെട്ട 18 വയസ്സിന് താഴെ പ്രായമുള്ള 41 കുട്ടികൾക്കും കൂടെ പെൻഷനും  സൗജന്യ വൈദ്യപരിശോധനയും തുടർ ചികിൽസയും നൽകാൻ 28-01-2023 - ൽ ഊക്കോട് എൻ.എസ്സ് .എസ്സ് ഓഡിറ്റോറിയത്തിൽ വച്ച് നടന്ന ക്യാംപിൽ നിംസ് മെഡിസിറ്റി മാനേജിങ്ങ് ഡയറക്ടർ ശ്രീ.എം.എസ്. ഫൈസൽ ഖാൻ പ്രഖ്യാപിക്കുകയുണ്ടായി.  കല്ലിയൂർ പഞ്ചായത്ത് പ്രസിഡന്റ് ശ്രീ ചന്ദു കൃഷ്ണൻ , പ്രശസ്ത സിനിമാ സീരിയൽ താരം ശ്രീ കൃഷ്ണ കുമാർ , നിംസ് മെഡിസിറ്റി ജനറൽ മാനേജർ ഡോ. സജു .കെ.എ, നെയ്യാറ്റിൻകര പെൻഷൻ പ്ലാൻ ചെയർപേഴ്സൺ ശ്രീമതി രേണു കെ.ആർ മറ്റ് പഞ്ചായത്ത് അംഗങ്ങൾ തുടങ്ങിയവർ ചടങ്ങിൽ പങ്കെടുത്തു. തുടർന്ന് 2023 ഫെബ്രുവരി മുതൽ നിംസ് സ്പെക്ട്രത്തിൽ വച്ച് കല്ലിയൂർ പഞ്ചായത്തിലെ ഗുണഭോക്താക്കൾക്ക്  വേണ്ടി നിംസ് സ്പെക്ട്രം ഡയറക്ടർ ഡോ. എം കെ സി യുടെ നേതൃത്വത്തിൽ സൗജന്യ മെഡിക്കൽ ചെക്കപ്പ് നടത്തുകയും, നിംസ് മെഡിസിറ്റി മാനേജിങ്ങ് ഡയറക്ടർ ശ്രീ എം എസ് ഫൈസൽ ഖാൻ പെൻഷൻ വിതണോൽ ഘാടനവും നടത്തി. തുടർന്ന് കൽപ്പറ്റ എം എൽ എ . ടി. സിദ്ദിഖ്, നെയ്യാറ്റിൻകര വില്ലേജ് ഓഫീസർ  ശ്രീ. ദിലീപ് തുടങ്ങിയവർ ചടങ്ങിൽ പങ്കെടുത്തു.",
      thumb: "assets/img/pensionscheme/55.jpeg",
    },
    {
      src: "assets/img/pensionscheme/56.jpeg",
      caption:
        "കോവിഡ് 19 ൻ്റെ സാഹചര്യത്തിൽ 18 വയസ്സിന് താഴെ പ്രായമുള്ള ഭിന്നശേഷിക്കാരായ കുട്ടികൾക്ക്‌ സമീകൃത ആഹാരം കൊടുക്കുന്നതിന്  വേണ്ടി 2021ൽ ആരംഭിച്ച പെൻഷൻ പ്ലാനിൽ  2023 ൽ കല്ലിയൂർ ഗ്രാമപഞ്ചായത്തിലെ ഭിന്നശേഷി വിഭാഗത്തിൽ പെട്ട 18 വയസ്സിന് താഴെ പ്രായമുള്ള 41 കുട്ടികൾക്കും കൂടെ പെൻഷനും  സൗജന്യ വൈദ്യപരിശോധനയും തുടർ ചികിൽസയും നൽകാൻ 28-01-2023 - ൽ ഊക്കോട് എൻ.എസ്സ് .എസ്സ് ഓഡിറ്റോറിയത്തിൽ വച്ച് നടന്ന ക്യാംപിൽ നിംസ് മെഡിസിറ്റി മാനേജിങ്ങ് ഡയറക്ടർ ശ്രീ.എം.എസ്. ഫൈസൽ ഖാൻ പ്രഖ്യാപിക്കുകയുണ്ടായി.  കല്ലിയൂർ പഞ്ചായത്ത് പ്രസിഡന്റ് ശ്രീ ചന്ദു കൃഷ്ണൻ , പ്രശസ്ത സിനിമാ സീരിയൽ താരം ശ്രീ കൃഷ്ണ കുമാർ , നിംസ് മെഡിസിറ്റി ജനറൽ മാനേജർ ഡോ. സജു .കെ.എ, നെയ്യാറ്റിൻകര പെൻഷൻ പ്ലാൻ ചെയർപേഴ്സൺ ശ്രീമതി രേണു കെ.ആർ മറ്റ് പഞ്ചായത്ത് അംഗങ്ങൾ തുടങ്ങിയവർ ചടങ്ങിൽ പങ്കെടുത്തു. തുടർന്ന് 2023 ഫെബ്രുവരി മുതൽ നിംസ് സ്പെക്ട്രത്തിൽ വച്ച് കല്ലിയൂർ പഞ്ചായത്തിലെ ഗുണഭോക്താക്കൾക്ക്  വേണ്ടി നിംസ് സ്പെക്ട്രം ഡയറക്ടർ ഡോ. എം കെ സി യുടെ നേതൃത്വത്തിൽ സൗജന്യ മെഡിക്കൽ ചെക്കപ്പ് നടത്തുകയും, നിംസ് മെഡിസിറ്റി മാനേജിങ്ങ് ഡയറക്ടർ ശ്രീ എം എസ് ഫൈസൽ ഖാൻ പെൻഷൻ വിതണോൽ ഘാടനവും നടത്തി. തുടർന്ന് കൽപ്പറ്റ എം എൽ എ . ടി. സിദ്ദിഖ്, നെയ്യാറ്റിൻകര വില്ലേജ് ഓഫീസർ  ശ്രീ. ദിലീപ് തുടങ്ങിയവർ ചടങ്ങിൽ പങ്കെടുത്തു.",
      thumb: "assets/img/pensionscheme/56.jpeg",
    },
    {
      src: "assets/img/pensionscheme/57.jpeg",
      caption:
        "കോവിഡ് 19 ൻ്റെ സാഹചര്യത്തിൽ 18 വയസ്സിന് താഴെ പ്രായമുള്ള ഭിന്നശേഷിക്കാരായ കുട്ടികൾക്ക്‌ സമീകൃത ആഹാരം കൊടുക്കുന്നതിന്  വേണ്ടി 2021ൽ ആരംഭിച്ച പെൻഷൻ പ്ലാനിൽ  2023 ൽ കല്ലിയൂർ ഗ്രാമപഞ്ചായത്തിലെ ഭിന്നശേഷി വിഭാഗത്തിൽ പെട്ട 18 വയസ്സിന് താഴെ പ്രായമുള്ള 41 കുട്ടികൾക്കും കൂടെ പെൻഷനും  സൗജന്യ വൈദ്യപരിശോധനയും തുടർ ചികിൽസയും നൽകാൻ 28-01-2023 - ൽ ഊക്കോട് എൻ.എസ്സ് .എസ്സ് ഓഡിറ്റോറിയത്തിൽ വച്ച് നടന്ന ക്യാംപിൽ നിംസ് മെഡിസിറ്റി മാനേജിങ്ങ് ഡയറക്ടർ ശ്രീ.എം.എസ്. ഫൈസൽ ഖാൻ പ്രഖ്യാപിക്കുകയുണ്ടായി.  കല്ലിയൂർ പഞ്ചായത്ത് പ്രസിഡന്റ് ശ്രീ ചന്ദു കൃഷ്ണൻ , പ്രശസ്ത സിനിമാ സീരിയൽ താരം ശ്രീ കൃഷ്ണ കുമാർ , നിംസ് മെഡിസിറ്റി ജനറൽ മാനേജർ ഡോ. സജു .കെ.എ, നെയ്യാറ്റിൻകര പെൻഷൻ പ്ലാൻ ചെയർപേഴ്സൺ ശ്രീമതി രേണു കെ.ആർ മറ്റ് പഞ്ചായത്ത് അംഗങ്ങൾ തുടങ്ങിയവർ ചടങ്ങിൽ പങ്കെടുത്തു. തുടർന്ന് 2023 ഫെബ്രുവരി മുതൽ നിംസ് സ്പെക്ട്രത്തിൽ വച്ച് കല്ലിയൂർ പഞ്ചായത്തിലെ ഗുണഭോക്താക്കൾക്ക്  വേണ്ടി നിംസ് സ്പെക്ട്രം ഡയറക്ടർ ഡോ. എം കെ സി യുടെ നേതൃത്വത്തിൽ സൗജന്യ മെഡിക്കൽ ചെക്കപ്പ് നടത്തുകയും, നിംസ് മെഡിസിറ്റി മാനേജിങ്ങ് ഡയറക്ടർ ശ്രീ എം എസ് ഫൈസൽ ഖാൻ പെൻഷൻ വിതണോൽ ഘാടനവും നടത്തി. തുടർന്ന് കൽപ്പറ്റ എം എൽ എ . ടി. സിദ്ദിഖ്, നെയ്യാറ്റിൻകര വില്ലേജ് ഓഫീസർ  ശ്രീ. ദിലീപ് തുടങ്ങിയവർ ചടങ്ങിൽ പങ്കെടുത്തു.",
      thumb: "assets/img/pensionscheme/57.jpeg",
    },
    {
      src: "assets/img/pensionscheme/58.jpeg",
      caption:
        "കോവിഡ് 19 ൻ്റെ സാഹചര്യത്തിൽ 18 വയസ്സിന് താഴെ പ്രായമുള്ള ഭിന്നശേഷിക്കാരായ കുട്ടികൾക്ക്‌ സമീകൃത ആഹാരം കൊടുക്കുന്നതിന്  വേണ്ടി 2021ൽ ആരംഭിച്ച പെൻഷൻ പ്ലാനിൽ  2023 ൽ കല്ലിയൂർ ഗ്രാമപഞ്ചായത്തിലെ ഭിന്നശേഷി വിഭാഗത്തിൽ പെട്ട 18 വയസ്സിന് താഴെ പ്രായമുള്ള 41 കുട്ടികൾക്കും കൂടെ പെൻഷനും  സൗജന്യ വൈദ്യപരിശോധനയും തുടർ ചികിൽസയും നൽകാൻ 28-01-2023 - ൽ ഊക്കോട് എൻ.എസ്സ് .എസ്സ് ഓഡിറ്റോറിയത്തിൽ വച്ച് നടന്ന ക്യാംപിൽ നിംസ് മെഡിസിറ്റി മാനേജിങ്ങ് ഡയറക്ടർ ശ്രീ.എം.എസ്. ഫൈസൽ ഖാൻ പ്രഖ്യാപിക്കുകയുണ്ടായി.  കല്ലിയൂർ പഞ്ചായത്ത് പ്രസിഡന്റ് ശ്രീ ചന്ദു കൃഷ്ണൻ , പ്രശസ്ത സിനിമാ സീരിയൽ താരം ശ്രീ കൃഷ്ണ കുമാർ , നിംസ് മെഡിസിറ്റി ജനറൽ മാനേജർ ഡോ. സജു .കെ.എ, നെയ്യാറ്റിൻകര പെൻഷൻ പ്ലാൻ ചെയർപേഴ്സൺ ശ്രീമതി രേണു കെ.ആർ മറ്റ് പഞ്ചായത്ത് അംഗങ്ങൾ തുടങ്ങിയവർ ചടങ്ങിൽ പങ്കെടുത്തു. തുടർന്ന് 2023 ഫെബ്രുവരി മുതൽ നിംസ് സ്പെക്ട്രത്തിൽ വച്ച് കല്ലിയൂർ പഞ്ചായത്തിലെ ഗുണഭോക്താക്കൾക്ക്  വേണ്ടി നിംസ് സ്പെക്ട്രം ഡയറക്ടർ ഡോ. എം കെ സി യുടെ നേതൃത്വത്തിൽ സൗജന്യ മെഡിക്കൽ ചെക്കപ്പ് നടത്തുകയും, നിംസ് മെഡിസിറ്റി മാനേജിങ്ങ് ഡയറക്ടർ ശ്രീ എം എസ് ഫൈസൽ ഖാൻ പെൻഷൻ വിതണോൽ ഘാടനവും നടത്തി. തുടർന്ന് കൽപ്പറ്റ എം എൽ എ . ടി. സിദ്ദിഖ്, നെയ്യാറ്റിൻകര വില്ലേജ് ഓഫീസർ  ശ്രീ. ദിലീപ് തുടങ്ങിയവർ ചടങ്ങിൽ പങ്കെടുത്തു.",
      thumb: "assets/img/pensionscheme/58.jpeg",
    },
    {
      src: "assets/img/pensionscheme/59.jpeg",
      caption:
        "കോവിഡ് 19 ൻ്റെ സാഹചര്യത്തിൽ 18 വയസ്സിന് താഴെ പ്രായമുള്ള ഭിന്നശേഷിക്കാരായ കുട്ടികൾക്ക്‌ സമീകൃത ആഹാരം കൊടുക്കുന്നതിന്  വേണ്ടി 2021ൽ ആരംഭിച്ച പെൻഷൻ പ്ലാനിൽ  2023 ൽ കല്ലിയൂർ ഗ്രാമപഞ്ചായത്തിലെ ഭിന്നശേഷി വിഭാഗത്തിൽ പെട്ട 18 വയസ്സിന് താഴെ പ്രായമുള്ള 41 കുട്ടികൾക്കും കൂടെ പെൻഷനും  സൗജന്യ വൈദ്യപരിശോധനയും തുടർ ചികിൽസയും നൽകാൻ 28-01-2023 - ൽ ഊക്കോട് എൻ.എസ്സ് .എസ്സ് ഓഡിറ്റോറിയത്തിൽ വച്ച് നടന്ന ക്യാംപിൽ നിംസ് മെഡിസിറ്റി മാനേജിങ്ങ് ഡയറക്ടർ ശ്രീ.എം.എസ്. ഫൈസൽ ഖാൻ പ്രഖ്യാപിക്കുകയുണ്ടായി.  കല്ലിയൂർ പഞ്ചായത്ത് പ്രസിഡന്റ് ശ്രീ ചന്ദു കൃഷ്ണൻ , പ്രശസ്ത സിനിമാ സീരിയൽ താരം ശ്രീ കൃഷ്ണ കുമാർ , നിംസ് മെഡിസിറ്റി ജനറൽ മാനേജർ ഡോ. സജു .കെ.എ, നെയ്യാറ്റിൻകര പെൻഷൻ പ്ലാൻ ചെയർപേഴ്സൺ ശ്രീമതി രേണു കെ.ആർ മറ്റ് പഞ്ചായത്ത് അംഗങ്ങൾ തുടങ്ങിയവർ ചടങ്ങിൽ പങ്കെടുത്തു. തുടർന്ന് 2023 ഫെബ്രുവരി മുതൽ നിംസ് സ്പെക്ട്രത്തിൽ വച്ച് കല്ലിയൂർ പഞ്ചായത്തിലെ ഗുണഭോക്താക്കൾക്ക്  വേണ്ടി നിംസ് സ്പെക്ട്രം ഡയറക്ടർ ഡോ. എം കെ സി യുടെ നേതൃത്വത്തിൽ സൗജന്യ മെഡിക്കൽ ചെക്കപ്പ് നടത്തുകയും, നിംസ് മെഡിസിറ്റി മാനേജിങ്ങ് ഡയറക്ടർ ശ്രീ എം എസ് ഫൈസൽ ഖാൻ പെൻഷൻ വിതണോൽ ഘാടനവും നടത്തി. തുടർന്ന് കൽപ്പറ്റ എം എൽ എ . ടി. സിദ്ദിഖ്, നെയ്യാറ്റിൻകര വില്ലേജ് ഓഫീസർ  ശ്രീ. ദിലീപ് തുടങ്ങിയവർ ചടങ്ങിൽ പങ്കെടുത്തു.",
      thumb: "assets/img/pensionscheme/59.jpeg",
    },
    {
      src: "assets/img/pensionscheme/60.jpeg",
      caption:
        "കോവിഡ് 19 ൻ്റെ സാഹചര്യത്തിൽ 18 വയസ്സിന് താഴെ പ്രായമുള്ള ഭിന്നശേഷിക്കാരായ കുട്ടികൾക്ക്‌ സമീകൃത ആഹാരം കൊടുക്കുന്നതിന്  വേണ്ടി 2021ൽ ആരംഭിച്ച പെൻഷൻ പ്ലാനിൽ  2023 ൽ കല്ലിയൂർ ഗ്രാമപഞ്ചായത്തിലെ ഭിന്നശേഷി വിഭാഗത്തിൽ പെട്ട 18 വയസ്സിന് താഴെ പ്രായമുള്ള 41 കുട്ടികൾക്കും കൂടെ പെൻഷനും  സൗജന്യ വൈദ്യപരിശോധനയും തുടർ ചികിൽസയും നൽകാൻ 28-01-2023 - ൽ ഊക്കോട് എൻ.എസ്സ് .എസ്സ് ഓഡിറ്റോറിയത്തിൽ വച്ച് നടന്ന ക്യാംപിൽ നിംസ് മെഡിസിറ്റി മാനേജിങ്ങ് ഡയറക്ടർ ശ്രീ.എം.എസ്. ഫൈസൽ ഖാൻ പ്രഖ്യാപിക്കുകയുണ്ടായി.  കല്ലിയൂർ പഞ്ചായത്ത് പ്രസിഡന്റ് ശ്രീ ചന്ദു കൃഷ്ണൻ , പ്രശസ്ത സിനിമാ സീരിയൽ താരം ശ്രീ കൃഷ്ണ കുമാർ , നിംസ് മെഡിസിറ്റി ജനറൽ മാനേജർ ഡോ. സജു .കെ.എ, നെയ്യാറ്റിൻകര പെൻഷൻ പ്ലാൻ ചെയർപേഴ്സൺ ശ്രീമതി രേണു കെ.ആർ മറ്റ് പഞ്ചായത്ത് അംഗങ്ങൾ തുടങ്ങിയവർ ചടങ്ങിൽ പങ്കെടുത്തു. തുടർന്ന് 2023 ഫെബ്രുവരി മുതൽ നിംസ് സ്പെക്ട്രത്തിൽ വച്ച് കല്ലിയൂർ പഞ്ചായത്തിലെ ഗുണഭോക്താക്കൾക്ക്  വേണ്ടി നിംസ് സ്പെക്ട്രം ഡയറക്ടർ ഡോ. എം കെ സി യുടെ നേതൃത്വത്തിൽ സൗജന്യ മെഡിക്കൽ ചെക്കപ്പ് നടത്തുകയും, നിംസ് മെഡിസിറ്റി മാനേജിങ്ങ് ഡയറക്ടർ ശ്രീ എം എസ് ഫൈസൽ ഖാൻ പെൻഷൻ വിതണോൽ ഘാടനവും നടത്തി. തുടർന്ന് കൽപ്പറ്റ എം എൽ എ . ടി. സിദ്ദിഖ്, നെയ്യാറ്റിൻകര വില്ലേജ് ഓഫീസർ  ശ്രീ. ദിലീപ് തുടങ്ങിയവർ ചടങ്ങിൽ പങ്കെടുത്തു.",
      thumb: "assets/img/pensionscheme/60.jpeg",
    },
    {
      src: "assets/img/pensionscheme/61.jpeg",
      caption:
        "കോവിഡ് 19 ൻ്റെ സാഹചര്യത്തിൽ 18 വയസ്സിന് താഴെ പ്രായമുള്ള ഭിന്നശേഷിക്കാരായ കുട്ടികൾക്ക്‌ സമീകൃത ആഹാരം കൊടുക്കുന്നതിന്  വേണ്ടി 2021ൽ ആരംഭിച്ച പെൻഷൻ പ്ലാനിൽ  2023 ൽ കല്ലിയൂർ ഗ്രാമപഞ്ചായത്തിലെ ഭിന്നശേഷി വിഭാഗത്തിൽ പെട്ട 18 വയസ്സിന് താഴെ പ്രായമുള്ള 41 കുട്ടികൾക്കും കൂടെ പെൻഷനും  സൗജന്യ വൈദ്യപരിശോധനയും തുടർ ചികിൽസയും നൽകാൻ 28-01-2023 - ൽ ഊക്കോട് എൻ.എസ്സ് .എസ്സ് ഓഡിറ്റോറിയത്തിൽ വച്ച് നടന്ന ക്യാംപിൽ നിംസ് മെഡിസിറ്റി മാനേജിങ്ങ് ഡയറക്ടർ ശ്രീ.എം.എസ്. ഫൈസൽ ഖാൻ പ്രഖ്യാപിക്കുകയുണ്ടായി.  കല്ലിയൂർ പഞ്ചായത്ത് പ്രസിഡന്റ് ശ്രീ ചന്ദു കൃഷ്ണൻ , പ്രശസ്ത സിനിമാ സീരിയൽ താരം ശ്രീ കൃഷ്ണ കുമാർ , നിംസ് മെഡിസിറ്റി ജനറൽ മാനേജർ ഡോ. സജു .കെ.എ, നെയ്യാറ്റിൻകര പെൻഷൻ പ്ലാൻ ചെയർപേഴ്സൺ ശ്രീമതി രേണു കെ.ആർ മറ്റ് പഞ്ചായത്ത് അംഗങ്ങൾ തുടങ്ങിയവർ ചടങ്ങിൽ പങ്കെടുത്തു. തുടർന്ന് 2023 ഫെബ്രുവരി മുതൽ നിംസ് സ്പെക്ട്രത്തിൽ വച്ച് കല്ലിയൂർ പഞ്ചായത്തിലെ ഗുണഭോക്താക്കൾക്ക്  വേണ്ടി നിംസ് സ്പെക്ട്രം ഡയറക്ടർ ഡോ. എം കെ സി യുടെ നേതൃത്വത്തിൽ സൗജന്യ മെഡിക്കൽ ചെക്കപ്പ് നടത്തുകയും, നിംസ് മെഡിസിറ്റി മാനേജിങ്ങ് ഡയറക്ടർ ശ്രീ എം എസ് ഫൈസൽ ഖാൻ പെൻഷൻ വിതണോൽ ഘാടനവും നടത്തി. തുടർന്ന് കൽപ്പറ്റ എം എൽ എ . ടി. സിദ്ദിഖ്, നെയ്യാറ്റിൻകര വില്ലേജ് ഓഫീസർ  ശ്രീ. ദിലീപ് തുടങ്ങിയവർ ചടങ്ങിൽ പങ്കെടുത്തു.",
      thumb: "assets/img/pensionscheme/61.jpeg",
    },
    {
      src: "assets/img/pensionscheme/62.jpeg",
      caption:
        "കോവിഡ് 19 ൻ്റെ സാഹചര്യത്തിൽ 18 വയസ്സിന് താഴെ പ്രായമുള്ള ഭിന്നശേഷിക്കാരായ കുട്ടികൾക്ക്‌ സമീകൃത ആഹാരം കൊടുക്കുന്നതിന്  വേണ്ടി 2021ൽ ആരംഭിച്ച പെൻഷൻ പ്ലാനിൽ  2023 ൽ കല്ലിയൂർ ഗ്രാമപഞ്ചായത്തിലെ ഭിന്നശേഷി വിഭാഗത്തിൽ പെട്ട 18 വയസ്സിന് താഴെ പ്രായമുള്ള 41 കുട്ടികൾക്കും കൂടെ പെൻഷനും  സൗജന്യ വൈദ്യപരിശോധനയും തുടർ ചികിൽസയും നൽകാൻ 28-01-2023 - ൽ ഊക്കോട് എൻ.എസ്സ് .എസ്സ് ഓഡിറ്റോറിയത്തിൽ വച്ച് നടന്ന ക്യാംപിൽ നിംസ് മെഡിസിറ്റി മാനേജിങ്ങ് ഡയറക്ടർ ശ്രീ.എം.എസ്. ഫൈസൽ ഖാൻ പ്രഖ്യാപിക്കുകയുണ്ടായി.  കല്ലിയൂർ പഞ്ചായത്ത് പ്രസിഡന്റ് ശ്രീ ചന്ദു കൃഷ്ണൻ , പ്രശസ്ത സിനിമാ സീരിയൽ താരം ശ്രീ കൃഷ്ണ കുമാർ , നിംസ് മെഡിസിറ്റി ജനറൽ മാനേജർ ഡോ. സജു .കെ.എ, നെയ്യാറ്റിൻകര പെൻഷൻ പ്ലാൻ ചെയർപേഴ്സൺ ശ്രീമതി രേണു കെ.ആർ മറ്റ് പഞ്ചായത്ത് അംഗങ്ങൾ തുടങ്ങിയവർ ചടങ്ങിൽ പങ്കെടുത്തു. തുടർന്ന് 2023 ഫെബ്രുവരി മുതൽ നിംസ് സ്പെക്ട്രത്തിൽ വച്ച് കല്ലിയൂർ പഞ്ചായത്തിലെ ഗുണഭോക്താക്കൾക്ക്  വേണ്ടി നിംസ് സ്പെക്ട്രം ഡയറക്ടർ ഡോ. എം കെ സി യുടെ നേതൃത്വത്തിൽ സൗജന്യ മെഡിക്കൽ ചെക്കപ്പ് നടത്തുകയും, നിംസ് മെഡിസിറ്റി മാനേജിങ്ങ് ഡയറക്ടർ ശ്രീ എം എസ് ഫൈസൽ ഖാൻ പെൻഷൻ വിതണോൽ ഘാടനവും നടത്തി. തുടർന്ന് കൽപ്പറ്റ എം എൽ എ . ടി. സിദ്ദിഖ്, നെയ്യാറ്റിൻകര വില്ലേജ് ഓഫീസർ  ശ്രീ. ദിലീപ് തുടങ്ങിയവർ ചടങ്ങിൽ പങ്കെടുത്തു.",
      thumb: "assets/img/pensionscheme/62.jpeg",
    },
    {
      src: "assets/img/pensionscheme/63.jpeg",
      caption:
        "കോവിഡ് 19 ൻ്റെ സാഹചര്യത്തിൽ 18 വയസ്സിന് താഴെ പ്രായമുള്ള ഭിന്നശേഷിക്കാരായ കുട്ടികൾക്ക്‌ സമീകൃത ആഹാരം കൊടുക്കുന്നതിന്  വേണ്ടി 2021ൽ ആരംഭിച്ച പെൻഷൻ പ്ലാനിൽ  2023 ൽ കല്ലിയൂർ ഗ്രാമപഞ്ചായത്തിലെ ഭിന്നശേഷി വിഭാഗത്തിൽ പെട്ട 18 വയസ്സിന് താഴെ പ്രായമുള്ള 41 കുട്ടികൾക്കും കൂടെ പെൻഷനും  സൗജന്യ വൈദ്യപരിശോധനയും തുടർ ചികിൽസയും നൽകാൻ 28-01-2023 - ൽ ഊക്കോട് എൻ.എസ്സ് .എസ്സ് ഓഡിറ്റോറിയത്തിൽ വച്ച് നടന്ന ക്യാംപിൽ നിംസ് മെഡിസിറ്റി മാനേജിങ്ങ് ഡയറക്ടർ ശ്രീ.എം.എസ്. ഫൈസൽ ഖാൻ പ്രഖ്യാപിക്കുകയുണ്ടായി.  കല്ലിയൂർ പഞ്ചായത്ത് പ്രസിഡന്റ് ശ്രീ ചന്ദു കൃഷ്ണൻ , പ്രശസ്ത സിനിമാ സീരിയൽ താരം ശ്രീ കൃഷ്ണ കുമാർ , നിംസ് മെഡിസിറ്റി ജനറൽ മാനേജർ ഡോ. സജു .കെ.എ, നെയ്യാറ്റിൻകര പെൻഷൻ പ്ലാൻ ചെയർപേഴ്സൺ ശ്രീമതി രേണു കെ.ആർ മറ്റ് പഞ്ചായത്ത് അംഗങ്ങൾ തുടങ്ങിയവർ ചടങ്ങിൽ പങ്കെടുത്തു. തുടർന്ന് 2023 ഫെബ്രുവരി മുതൽ നിംസ് സ്പെക്ട്രത്തിൽ വച്ച് കല്ലിയൂർ പഞ്ചായത്തിലെ ഗുണഭോക്താക്കൾക്ക്  വേണ്ടി നിംസ് സ്പെക്ട്രം ഡയറക്ടർ ഡോ. എം കെ സി യുടെ നേതൃത്വത്തിൽ സൗജന്യ മെഡിക്കൽ ചെക്കപ്പ് നടത്തുകയും, നിംസ് മെഡിസിറ്റി മാനേജിങ്ങ് ഡയറക്ടർ ശ്രീ എം എസ് ഫൈസൽ ഖാൻ പെൻഷൻ വിതണോൽ ഘാടനവും നടത്തി. തുടർന്ന് കൽപ്പറ്റ എം എൽ എ . ടി. സിദ്ദിഖ്, നെയ്യാറ്റിൻകര വില്ലേജ് ഓഫീസർ  ശ്രീ. ദിലീപ് തുടങ്ങിയവർ ചടങ്ങിൽ പങ്കെടുത്തു.",
      thumb: "assets/img/pensionscheme/63.jpeg",
    },
    {
      src: "assets/img/pensionscheme/64.jpeg",
      caption:
        "കോവിഡ് 19 ൻ്റെ സാഹചര്യത്തിൽ 18 വയസ്സിന് താഴെ പ്രായമുള്ള ഭിന്നശേഷിക്കാരായ കുട്ടികൾക്ക്‌ സമീകൃത ആഹാരം കൊടുക്കുന്നതിന്  വേണ്ടി 2021ൽ ആരംഭിച്ച പെൻഷൻ പ്ലാനിൽ  2023 ൽ കല്ലിയൂർ ഗ്രാമപഞ്ചായത്തിലെ ഭിന്നശേഷി വിഭാഗത്തിൽ പെട്ട 18 വയസ്സിന് താഴെ പ്രായമുള്ള 41 കുട്ടികൾക്കും കൂടെ പെൻഷനും  സൗജന്യ വൈദ്യപരിശോധനയും തുടർ ചികിൽസയും നൽകാൻ 28-01-2023 - ൽ ഊക്കോട് എൻ.എസ്സ് .എസ്സ് ഓഡിറ്റോറിയത്തിൽ വച്ച് നടന്ന ക്യാംപിൽ നിംസ് മെഡിസിറ്റി മാനേജിങ്ങ് ഡയറക്ടർ ശ്രീ.എം.എസ്. ഫൈസൽ ഖാൻ പ്രഖ്യാപിക്കുകയുണ്ടായി.  കല്ലിയൂർ പഞ്ചായത്ത് പ്രസിഡന്റ് ശ്രീ ചന്ദു കൃഷ്ണൻ , പ്രശസ്ത സിനിമാ സീരിയൽ താരം ശ്രീ കൃഷ്ണ കുമാർ , നിംസ് മെഡിസിറ്റി ജനറൽ മാനേജർ ഡോ. സജു .കെ.എ, നെയ്യാറ്റിൻകര പെൻഷൻ പ്ലാൻ ചെയർപേഴ്സൺ ശ്രീമതി രേണു കെ.ആർ മറ്റ് പഞ്ചായത്ത് അംഗങ്ങൾ തുടങ്ങിയവർ ചടങ്ങിൽ പങ്കെടുത്തു. തുടർന്ന് 2023 ഫെബ്രുവരി മുതൽ നിംസ് സ്പെക്ട്രത്തിൽ വച്ച് കല്ലിയൂർ പഞ്ചായത്തിലെ ഗുണഭോക്താക്കൾക്ക്  വേണ്ടി നിംസ് സ്പെക്ട്രം ഡയറക്ടർ ഡോ. എം കെ സി യുടെ നേതൃത്വത്തിൽ സൗജന്യ മെഡിക്കൽ ചെക്കപ്പ് നടത്തുകയും, നിംസ് മെഡിസിറ്റി മാനേജിങ്ങ് ഡയറക്ടർ ശ്രീ എം എസ് ഫൈസൽ ഖാൻ പെൻഷൻ വിതണോൽ ഘാടനവും നടത്തി. തുടർന്ന് കൽപ്പറ്റ എം എൽ എ . ടി. സിദ്ദിഖ്, നെയ്യാറ്റിൻകര വില്ലേജ് ഓഫീസർ  ശ്രീ. ദിലീപ് തുടങ്ങിയവർ ചടങ്ങിൽ പങ്കെടുത്തു.",
      thumb: "assets/img/pensionscheme/64.jpeg",
    },
    {
      src: "assets/img/pensionscheme/65.jpeg",
      caption:
        "കോവിഡ് 19 ൻ്റെ സാഹചര്യത്തിൽ 18 വയസ്സിന് താഴെ പ്രായമുള്ള ഭിന്നശേഷിക്കാരായ കുട്ടികൾക്ക്‌ സമീകൃത ആഹാരം കൊടുക്കുന്നതിന്  വേണ്ടി 2021ൽ ആരംഭിച്ച പെൻഷൻ പ്ലാനിൽ  2023 ൽ കല്ലിയൂർ ഗ്രാമപഞ്ചായത്തിലെ ഭിന്നശേഷി വിഭാഗത്തിൽ പെട്ട 18 വയസ്സിന് താഴെ പ്രായമുള്ള 41 കുട്ടികൾക്കും കൂടെ പെൻഷനും  സൗജന്യ വൈദ്യപരിശോധനയും തുടർ ചികിൽസയും നൽകാൻ 28-01-2023 - ൽ ഊക്കോട് എൻ.എസ്സ് .എസ്സ് ഓഡിറ്റോറിയത്തിൽ വച്ച് നടന്ന ക്യാംപിൽ നിംസ് മെഡിസിറ്റി മാനേജിങ്ങ് ഡയറക്ടർ ശ്രീ.എം.എസ്. ഫൈസൽ ഖാൻ പ്രഖ്യാപിക്കുകയുണ്ടായി.  കല്ലിയൂർ പഞ്ചായത്ത് പ്രസിഡന്റ് ശ്രീ ചന്ദു കൃഷ്ണൻ , പ്രശസ്ത സിനിമാ സീരിയൽ താരം ശ്രീ കൃഷ്ണ കുമാർ , നിംസ് മെഡിസിറ്റി ജനറൽ മാനേജർ ഡോ. സജു .കെ.എ, നെയ്യാറ്റിൻകര പെൻഷൻ പ്ലാൻ ചെയർപേഴ്സൺ ശ്രീമതി രേണു കെ.ആർ മറ്റ് പഞ്ചായത്ത് അംഗങ്ങൾ തുടങ്ങിയവർ ചടങ്ങിൽ പങ്കെടുത്തു. തുടർന്ന് 2023 ഫെബ്രുവരി മുതൽ നിംസ് സ്പെക്ട്രത്തിൽ വച്ച് കല്ലിയൂർ പഞ്ചായത്തിലെ ഗുണഭോക്താക്കൾക്ക്  വേണ്ടി നിംസ് സ്പെക്ട്രം ഡയറക്ടർ ഡോ. എം കെ സി യുടെ നേതൃത്വത്തിൽ സൗജന്യ മെഡിക്കൽ ചെക്കപ്പ് നടത്തുകയും, നിംസ് മെഡിസിറ്റി മാനേജിങ്ങ് ഡയറക്ടർ ശ്രീ എം എസ് ഫൈസൽ ഖാൻ പെൻഷൻ വിതണോൽ ഘാടനവും നടത്തി. തുടർന്ന് കൽപ്പറ്റ എം എൽ എ . ടി. സിദ്ദിഖ്, നെയ്യാറ്റിൻകര വില്ലേജ് ഓഫീസർ  ശ്രീ. ദിലീപ് തുടങ്ങിയവർ ചടങ്ങിൽ പങ്കെടുത്തു.",
      thumb: "assets/img/pensionscheme/65.jpeg",
    },
    {
      src: "assets/img/pensionscheme/66.jpeg",
      caption:
        "കോവിഡ് 19 ൻ്റെ സാഹചര്യത്തിൽ 18 വയസ്സിന് താഴെ പ്രായമുള്ള ഭിന്നശേഷിക്കാരായ കുട്ടികൾക്ക്‌ സമീകൃത ആഹാരം കൊടുക്കുന്നതിന്  വേണ്ടി 2021ൽ ആരംഭിച്ച പെൻഷൻ പ്ലാനിൽ  2023 ൽ കല്ലിയൂർ ഗ്രാമപഞ്ചായത്തിലെ ഭിന്നശേഷി വിഭാഗത്തിൽ പെട്ട 18 വയസ്സിന് താഴെ പ്രായമുള്ള 41 കുട്ടികൾക്കും കൂടെ പെൻഷനും  സൗജന്യ വൈദ്യപരിശോധനയും തുടർ ചികിൽസയും നൽകാൻ 28-01-2023 - ൽ ഊക്കോട് എൻ.എസ്സ് .എസ്സ് ഓഡിറ്റോറിയത്തിൽ വച്ച് നടന്ന ക്യാംപിൽ നിംസ് മെഡിസിറ്റി മാനേജിങ്ങ് ഡയറക്ടർ ശ്രീ.എം.എസ്. ഫൈസൽ ഖാൻ പ്രഖ്യാപിക്കുകയുണ്ടായി.  കല്ലിയൂർ പഞ്ചായത്ത് പ്രസിഡന്റ് ശ്രീ ചന്ദു കൃഷ്ണൻ , പ്രശസ്ത സിനിമാ സീരിയൽ താരം ശ്രീ കൃഷ്ണ കുമാർ , നിംസ് മെഡിസിറ്റി ജനറൽ മാനേജർ ഡോ. സജു .കെ.എ, നെയ്യാറ്റിൻകര പെൻഷൻ പ്ലാൻ ചെയർപേഴ്സൺ ശ്രീമതി രേണു കെ.ആർ മറ്റ് പഞ്ചായത്ത് അംഗങ്ങൾ തുടങ്ങിയവർ ചടങ്ങിൽ പങ്കെടുത്തു. തുടർന്ന് 2023 ഫെബ്രുവരി മുതൽ നിംസ് സ്പെക്ട്രത്തിൽ വച്ച് കല്ലിയൂർ പഞ്ചായത്തിലെ ഗുണഭോക്താക്കൾക്ക്  വേണ്ടി നിംസ് സ്പെക്ട്രം ഡയറക്ടർ ഡോ. എം കെ സി യുടെ നേതൃത്വത്തിൽ സൗജന്യ മെഡിക്കൽ ചെക്കപ്പ് നടത്തുകയും, നിംസ് മെഡിസിറ്റി മാനേജിങ്ങ് ഡയറക്ടർ ശ്രീ എം എസ് ഫൈസൽ ഖാൻ പെൻഷൻ വിതണോൽ ഘാടനവും നടത്തി. തുടർന്ന് കൽപ്പറ്റ എം എൽ എ . ടി. സിദ്ദിഖ്, നെയ്യാറ്റിൻകര വില്ലേജ് ഓഫീസർ  ശ്രീ. ദിലീപ് തുടങ്ങിയവർ ചടങ്ങിൽ പങ്കെടുത്തു.",
      thumb: "assets/img/pensionscheme/66.jpeg",
    },
    {
      src: "assets/img/pensionscheme/67.jpeg",
      caption:
        "കോവിഡ് 19 ൻ്റെ സാഹചര്യത്തിൽ 18 വയസ്സിന് താഴെ പ്രായമുള്ള ഭിന്നശേഷിക്കാരായ കുട്ടികൾക്ക്‌ സമീകൃത ആഹാരം കൊടുക്കുന്നതിന്  വേണ്ടി 2021ൽ ആരംഭിച്ച പെൻഷൻ പ്ലാനിൽ  2023 ൽ കല്ലിയൂർ ഗ്രാമപഞ്ചായത്തിലെ ഭിന്നശേഷി വിഭാഗത്തിൽ പെട്ട 18 വയസ്സിന് താഴെ പ്രായമുള്ള 41 കുട്ടികൾക്കും കൂടെ പെൻഷനും  സൗജന്യ വൈദ്യപരിശോധനയും തുടർ ചികിൽസയും നൽകാൻ 28-01-2023 - ൽ ഊക്കോട് എൻ.എസ്സ് .എസ്സ് ഓഡിറ്റോറിയത്തിൽ വച്ച് നടന്ന ക്യാംപിൽ നിംസ് മെഡിസിറ്റി മാനേജിങ്ങ് ഡയറക്ടർ ശ്രീ.എം.എസ്. ഫൈസൽ ഖാൻ പ്രഖ്യാപിക്കുകയുണ്ടായി.  കല്ലിയൂർ പഞ്ചായത്ത് പ്രസിഡന്റ് ശ്രീ ചന്ദു കൃഷ്ണൻ , പ്രശസ്ത സിനിമാ സീരിയൽ താരം ശ്രീ കൃഷ്ണ കുമാർ , നിംസ് മെഡിസിറ്റി ജനറൽ മാനേജർ ഡോ. സജു .കെ.എ, നെയ്യാറ്റിൻകര പെൻഷൻ പ്ലാൻ ചെയർപേഴ്സൺ ശ്രീമതി രേണു കെ.ആർ മറ്റ് പഞ്ചായത്ത് അംഗങ്ങൾ തുടങ്ങിയവർ ചടങ്ങിൽ പങ്കെടുത്തു. തുടർന്ന് 2023 ഫെബ്രുവരി മുതൽ നിംസ് സ്പെക്ട്രത്തിൽ വച്ച് കല്ലിയൂർ പഞ്ചായത്തിലെ ഗുണഭോക്താക്കൾക്ക്  വേണ്ടി നിംസ് സ്പെക്ട്രം ഡയറക്ടർ ഡോ. എം കെ സി യുടെ നേതൃത്വത്തിൽ സൗജന്യ മെഡിക്കൽ ചെക്കപ്പ് നടത്തുകയും, നിംസ് മെഡിസിറ്റി മാനേജിങ്ങ് ഡയറക്ടർ ശ്രീ എം എസ് ഫൈസൽ ഖാൻ പെൻഷൻ വിതണോൽ ഘാടനവും നടത്തി. തുടർന്ന് കൽപ്പറ്റ എം എൽ എ . ടി. സിദ്ദിഖ്, നെയ്യാറ്റിൻകര വില്ലേജ് ഓഫീസർ  ശ്രീ. ദിലീപ് തുടങ്ങിയവർ ചടങ്ങിൽ പങ്കെടുത്തു.",
      thumb: "assets/img/pensionscheme/67.jpeg",
    },
    {
      src: "assets/img/pensionscheme/25.jpg",
      caption: "",
      thumb: "assets/img/pensionscheme/25.jpg",
    },
    {
      src: "assets/img/pensionscheme/26.jpg",
      caption: "",
      thumb: "assets/img/pensionscheme/26.jpg",
    },
    {
      src: "assets/img/pensionscheme/27.jpg",
      caption: "",
      thumb: "assets/img/pensionscheme/27.jpg",
    },
    {
      src: "assets/img/pensionscheme/28.jpg",
      caption: "",
      thumb: "assets/img/pensionscheme/28.jpg",
    },
    {
      src: "assets/img/pensionscheme/29.jpg",
      caption: "",
      thumb: "assets/img/pensionscheme/29.jpg",
    },
    {
      src: "assets/img/pensionscheme/30.jpg",
      caption: "",
      thumb: "assets/img/pensionscheme/30.jpg",
    },
    {
      src: "assets/img/pensionscheme/31.jpg",
      caption: "",
      thumb: "assets/img/pensionscheme/31.jpg",
    },
    {
      src: "assets/img/pensionscheme/32.jpg",
      caption: "",
      thumb: "assets/img/pensionscheme/32.jpg",
    },
    {
      src: "assets/img/pensionscheme/33.jpg",
      caption: "",
      thumb: "assets/img/pensionscheme/33.jpg",
    },
    {
      src: "assets/img/pensionscheme/34.jpg",
      caption: "",
      thumb: "assets/img/pensionscheme/34.jpg",
    },
    {
      src: "assets/img/pensionscheme/35.jpg",
      caption: "",
      thumb: "assets/img/pensionscheme/35.jpg",
    },
    {
      src: "assets/img/pensionscheme/36.jpg",
      caption: "",
      thumb: "assets/img/pensionscheme/36.jpg",
    },
    {
      src: "assets/img/pensionscheme/37.jpg",
      caption: "",
      thumb: "assets/img/pensionscheme/37.jpg",
    },
    {
      src: "assets/img/pensionscheme/38.jpg",
      caption: "",
      thumb: "assets/img/pensionscheme/38.jpg",
    },
    {
      src: "assets/img/pensionscheme/39.jpg",
      caption: "",
      thumb: "assets/img/pensionscheme/39.jpg",
    },
    {
      src: "assets/img/pensionscheme/40.jpg",
      caption: "",
      thumb: "assets/img/pensionscheme/40.jpg",
    },
    {
      src: "assets/img/pensionscheme/41.jpg",
      caption: "",
      thumb: "assets/img/pensionscheme/41.jpg",
    },
    {
      src: "assets/img/pensionscheme/42.jpg",
      caption: "",
      thumb: "assets/img/pensionscheme/42.jpg",
    },
    {
      src: "assets/img/pensionscheme/6.jpeg",
      caption: "",
      thumb: "assets/img/pensionscheme/6.jpeg",
    },
    {
      src: "assets/img/pensionscheme/7.jpeg",
      caption: "",
      thumb: "assets/img/pensionscheme/7.jpeg",
    },
    {
      src: "assets/img/pensionscheme/8.jpeg",
      caption: "",
      thumb: "assets/img/pensionscheme/8.jpeg",
    },
    {
      src: "assets/img/pensionscheme/9.jpeg",
      caption: "",
      thumb: "assets/img/pensionscheme/9.jpeg",
    },
    {
      src: "assets/img/pensionscheme/10.jpeg",
      caption: "",
      thumb: "assets/img/pensionscheme/10.jpeg",
    },
    {
      src: "assets/img/pensionscheme/11.jpeg",
      caption: "",
      thumb: "assets/img/pensionscheme/11.jpeg",
    },
    {
      src: "assets/img/pensionscheme/12.jpeg",
      caption: "",
      thumb: "assets/img/pensionscheme/12.jpeg",
    },
    {
      src: "assets/img/pensionscheme/13.jpeg",
      caption: "Counselling at Spectrum",
      thumb: "assets/img/pensionscheme/13.jpeg",
    },
    {
      src: "assets/img/pensionscheme/14.jpeg",
      caption: "",
      thumb: "assets/img/pensionscheme/14.jpeg",
    },
    {
      src: "assets/img/pensionscheme/15.jpeg",
      caption: "",
      thumb: "assets/img/pensionscheme/15.jpeg",
    },
    {
      src: "assets/img/pensionscheme/16.jpeg",
      caption: "Tab distribution for selected pension beneficiaries",
      thumb: "assets/img/pensionscheme/16.jpeg",
    },
    {
      src: "assets/img/pensionscheme/17.jpeg",
      caption: "",
      thumb: "assets/img/pensionscheme/17.jpeg",
    },
    {
      src: "assets/img/pensionscheme/18.jpeg",
      caption: "",
      thumb: "assets/img/pensionscheme/18.jpeg",
    },
    {
      src: "assets/img/pensionscheme/19.jpeg",
      caption: "",
      thumb: "assets/img/pensionscheme/19.jpeg",
    },
    {
      src: "assets/img/pensionscheme/20.jpeg",
      caption: "",
      thumb: "assets/img/pensionscheme/20.jpeg",
    },
    {
      src: "assets/img/pensionscheme/21.jpeg",
      caption: "",
      thumb: "assets/img/pensionscheme/21.jpeg",
    },
    {
      src: "assets/img/pensionscheme/22.jpeg",
      caption: "Medical Camp at Perumkadavila Panchayat",
      thumb: "assets/img/pensionscheme/22.jpeg",
    },
    {
      src: "assets/img/pensionscheme/23.jpeg",
      caption: "",
      thumb: "assets/img/pensionscheme/23.jpeg",
    },
    {
      src: "assets/img/pensionscheme/24.jpeg",
      caption: "Medical checkup at Spectrum",
      thumb: "assets/img/pensionscheme/24.jpeg",
    },

    {
      src: "assets/img/pensionscheme/1.jpg",
      caption:
        "ഭിന്നശേഷി കുട്ടികളുടെ കുടുംബങ്ങൾക്കു നിംസ് മെഡിസിറ്റിയുടെ കോവിഡ് റിലീഫ് പെൻഷൻ...",
      thumb: "assets/img/pensionscheme/1.jpg",
    },
    {
      src: "assets/img/pensionscheme/2.jpg",
      caption:
        "കോവിഡ് പശ്ചാത്തലം നിലനിൽക്കുന്ന സാഹചര്യത്തിൽ പലവിധ ബുദ്ധിമുട്ടുകൾ അനുഭവിക്കുന്നവർ നമുക്ക് ചുറ്റിലുമുണ്ട് അതിൽ എടുത്തുപറയേണ്ടവർ നമ്മുടെ പ്രിയപ്പെട്ട ഭിന്നശേഷി കുട്ടികളുള്ള കുടുംബങ്ങൾ ആണ്.അങ്ങനെയുള്ള കുടുംബങ്ങൾക്ക് ചെറിയൊരു സാമ്പത്തിക സഹായം എന്ന ആശയവുമായി മുന്നോട്ടു വന്നിരിക്കുകയാണ് നിംസ് മെഡിസിറ്റി മാനേജിങ് ഡയറക്ടർ ശ്രീ എം എസ് ഫൈസൽ ഖാൻ. കോവിഡ് റിലീഫ് പെൻഷൻ എന്ന ഈ പദ്ധതി കോവിഡ് പ്രതിസന്ധി കഴിയുന്നതുവരെ എല്ലാ മാസവും നിശ്ചിത തുക കുട്ടികളുടെ അമ്മമാർക്ക് കൈമാറും.",
      thumb: "assets/img/pensionscheme/2.jpg",
    },
    {
      src: "assets/img/pensionscheme/3.jpg",
      caption:
        "നെയ്യാറ്റിൻകര മുൻസിപ്പാലിറ്റിയിലെയും, അതിയന്നൂർ,കൊല്ലയിൽ, കോട്ടുകാൽ പഞ്ചായത്തുകളിലെയും, ബാലരാമപുരം ഡിവിഷനിലെയും 250 ഓളം വരുന്ന ഭിന്നശേഷികുട്ടികൾക്കാണ് കോവിഡ് എയ്ഡ് ധനസഹായം നൽകാൻ തീരുമാനിച്ചിരിക്കുന്നത് . പ്രസ്തുത പദ്ധതിയുടെ ആദ്യ ഗഡു 10/06/2021 രാവിലെ 11ന് ശ്രീ എം എസ് ഫൈസൽ ഖാൻ നെയ്യാറ്റിൻകര മുനിസിപ്പാലിറ്റി ചെയർമാൻ ശ്രീ രാജ്‌മോഹൻ അവർക്കൾക്കു കൈമാറി പദ്ധതിക്കു തുടക്കം കുറിച്ചു, തുടർന്ന് അതാതു പഞ്ചായത്തിലെ തുകകൾ പഞ്ചായത്തു പ്രതിനിധികൾക്കു കൈമാറുകയും ചെയ്തു.",
      thumb: "assets/img/pensionscheme/3.jpg",
    },
    {
      src: "assets/img/pensionscheme/4.jpg",
      caption:
        "പ്രസ്തുത ചടങ്ങിൽ നെയ്യാറ്റിൻകര മുൻസിപ്പാലിറ്റി ഹെൽത്ത്‌ സ്റ്റാൻഡിങ് കമ്മിറ്റി ചെയർമാൻ ശ്രീ ജോസ് ഫ്രാങ്ക്‌ളിൻ, വികസനകാര്യ സ്റ്റാൻഡിങ് കമ്മിറ്റി ചെയർമാൻ ശ്രീ k k ഷിബു,യൂത്ത് കോൺഗ്രസ് സംസ്ഥാന സെക്രട്ടറി adv ശ്രീ കോട്ടുകാൽ വിനോദ്, കൗൺസിലർ ശ്രീ സദത്ത് തുടങ്ങിയവർ സന്നിഹിതരായിരുന്നു.",
      thumb: "assets/img/pensionscheme/4.jpg",
    },
    {
      src: "assets/img/pensionscheme/5.jpg",
      caption:
        "ഈ ദുരിതകാലവും കടന്നുപോകും താങ്ങായി തണലായി നിങ്ങളുടെ സേവനത്തിനായി നിംസ് കുടുംബം എന്നും ഒപ്പം..",
      thumb: "assets/img/pensionscheme/5.jpg",
    },
  ];

  HARITHAKAM_GALLERY: Array<{ src: string; caption: string; thumb: string }> = [
    {src: "assets/img/Sapling/694.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/694.jpg",},
    {src: "assets/img/Sapling/695.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/695.jpg",},
    {src: "assets/img/Sapling/696.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/696.jpg",},
    {src: "assets/img/Sapling/697.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/697.jpg",},
    {src: "assets/img/Sapling/698.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/698.jpg",},
    {src: "assets/img/Sapling/699.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/699.jpg",},
    {src: "assets/img/Sapling/700.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/700.jpg",},
    {src: "assets/img/Sapling/701.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/701.jpg",},
    {src: "assets/img/Sapling/702.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/702.jpg",},
    {src: "assets/img/Sapling/703.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/703.jpg",},
    {src: "assets/img/Sapling/704.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/704.jpg",},
    {src: "assets/img/Sapling/705.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/705.jpg",},
    {src: "assets/img/Sapling/706.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/706.jpg",},
    {src: "assets/img/Sapling/707.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/707.jpg",},
    {src: "assets/img/Sapling/708.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/708.jpg",},
    {src: "assets/img/Sapling/709.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/709.jpg",},
    {src: "assets/img/Sapling/710.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/710.jpg",},
    {src: "assets/img/Sapling/711.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/711.jpg",},
    {src: "assets/img/Sapling/712.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/712.jpg",},
    {src: "assets/img/Sapling/713.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/713.jpg",},
    {src: "assets/img/Sapling/714.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/714.jpg",},
    {src: "assets/img/Sapling/715.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/715.jpg",},
    {src: "assets/img/Sapling/716.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/716.jpg",},
    {src: "assets/img/Sapling/717.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/717.jpg",},
    {src: "assets/img/Sapling/718.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/718.jpg",},
    {src: "assets/img/Sapling/719.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/719.jpg",},
    {src: "assets/img/Sapling/720.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/720.jpg",},
    {src: "assets/img/Sapling/721.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/721.jpg",},
    {src: "assets/img/Sapling/722.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/722.jpg",},
    {src: "assets/img/Sapling/723.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/723.jpg",},
    {src: "assets/img/Sapling/724.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/724.jpg",},
    {src: "assets/img/Sapling/725.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/725.jpg",},
    {src: "assets/img/Sapling/726.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/726.jpg",},
    {src: "assets/img/Sapling/727.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/727.jpg",},
    {src: "assets/img/Sapling/728.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/728.jpg",},
    {src: "assets/img/Sapling/729.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/729.jpg",},
    {src: "assets/img/Sapling/730.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/730.jpg",},
    {src: "assets/img/Sapling/731.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/731.jpg",},
    {src: "assets/img/Sapling/732.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/732.jpg",},
    {src: "assets/img/Sapling/733.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/733.jpg",},
    {src: "assets/img/Sapling/734.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/734.jpg",},
    {src: "assets/img/Sapling/685.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/685.jpg",},
    {src: "assets/img/Sapling/686.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/686.jpg",},
    {src: "assets/img/Sapling/687.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/687.jpg",},
    {src: "assets/img/Sapling/688.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/688.jpg",},
    {src: "assets/img/Sapling/689.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/689.jpg",},
    {src: "assets/img/Sapling/690.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/690.jpg",},
    {src: "assets/img/Sapling/691.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/691.jpg",},
    {src: "assets/img/Sapling/692.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/692.jpg",},
    {src: "assets/img/Sapling/693.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/693.jpg",},
    {src: "assets/img/Sapling/672.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/672.jpg",},
    {src: "assets/img/Sapling/673.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/673.jpg",},
    {src: "assets/img/Sapling/674.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/674.jpg",},
    {src: "assets/img/Sapling/675.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/675.jpg",},
    {src: "assets/img/Sapling/676.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/676.jpg",},
    {src: "assets/img/Sapling/677.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/677.jpg",},
    {src: "assets/img/Sapling/678.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/678.jpg",},
    {src: "assets/img/Sapling/679.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/679.jpg",},
    {src: "assets/img/Sapling/680.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/680.jpg",},
    {src: "assets/img/Sapling/681.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/681.jpg",},
    {src: "assets/img/Sapling/682.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/682.jpg",},
    {src: "assets/img/Sapling/683.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/683.jpg",},
    {src: "assets/img/Sapling/684.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/684.jpg",},
    {src: "assets/img/Sapling/658.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/658.jpg",},
    {src: "assets/img/Sapling/659.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/659.jpg",},
    {src: "assets/img/Sapling/660.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/660.jpg",},
    {src: "assets/img/Sapling/661.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/661.jpg",},
    {src: "assets/img/Sapling/662.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/662.jpg",},
    {src: "assets/img/Sapling/663.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/663.jpg",},
    {src: "assets/img/Sapling/664.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/664.jpg",},
    {src: "assets/img/Sapling/665.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/665.jpg",},
    {src: "assets/img/Sapling/666.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/666.jpg",},
    {src: "assets/img/Sapling/667.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/667.jpg",},
    {src: "assets/img/Sapling/668.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/668.jpg",},
    {src: "assets/img/Sapling/669.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/669.jpg",},
    {src: "assets/img/Sapling/670.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/670.jpg",},
    {src: "assets/img/Sapling/671.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/671.jpg",},
    {src: "assets/img/Sapling/647.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/647.jpg",},
    {src: "assets/img/Sapling/648.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/648.jpg",},
    {src: "assets/img/Sapling/649.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/649.jpg",},
    {src: "assets/img/Sapling/650.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/650.jpg",},
    {src: "assets/img/Sapling/651.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/651.jpg",},
    {src: "assets/img/Sapling/652.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/652.jpg",},
    {src: "assets/img/Sapling/653.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/653.jpg",},
    {src: "assets/img/Sapling/654.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/654.jpg",},
    {src: "assets/img/Sapling/655.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/655.jpg",},
    {src: "assets/img/Sapling/656.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/656.jpg",},
    {src: "assets/img/Sapling/657.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/657.jpg",},
    {src: "assets/img/Sapling/638.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/638.jpg",},
    {src: "assets/img/Sapling/639.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/639.jpg",},
    {src: "assets/img/Sapling/640.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/640.jpg",},
    {src: "assets/img/Sapling/641.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/641.jpg",},
    {src: "assets/img/Sapling/642.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/642.jpg",},
    {src: "assets/img/Sapling/643.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/643.jpg",},
    {src: "assets/img/Sapling/644.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/644.jpg",},
    {src: "assets/img/Sapling/645.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/645.jpg",},
    {src: "assets/img/Sapling/646.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/646.jpg",},
    {src: "assets/img/Sapling/619.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/619.jpg",},
    {src: "assets/img/Sapling/620.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/620.jpg",},
    {src: "assets/img/Sapling/621.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/621.jpg",},
    {src: "assets/img/Sapling/622.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/622.jpg",},
    {src: "assets/img/Sapling/623.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/623.jpg",},
    {src: "assets/img/Sapling/624.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/624.jpg",},
    {src: "assets/img/Sapling/625.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/625.jpg",},
    {src: "assets/img/Sapling/626.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/626.jpg",},
    {src: "assets/img/Sapling/627.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/627.jpg",},
    {src: "assets/img/Sapling/628.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/628.jpg",},
    {src: "assets/img/Sapling/629.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/629.jpg",},
    {src: "assets/img/Sapling/630.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/630.jpg",},
    {src: "assets/img/Sapling/631.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/631.jpg",},
    {src: "assets/img/Sapling/632.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/632.jpg",},
    {src: "assets/img/Sapling/633.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/633.jpg",},
    {src: "assets/img/Sapling/634.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/634.jpg",},
    {src: "assets/img/Sapling/635.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/635.jpg",},
    {src: "assets/img/Sapling/636.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/636.jpg",},
    {src: "assets/img/Sapling/637.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/637.jpg",},
    {src: "assets/img/Sapling/607.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/607.jpg",},
    {src: "assets/img/Sapling/608.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/608.jpg",},
    {src: "assets/img/Sapling/609.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/609.jpg",},
    {src: "assets/img/Sapling/610.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/610.jpg",},
    {src: "assets/img/Sapling/611.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/611.jpg",},
    {src: "assets/img/Sapling/612.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/612.jpg",},
    {src: "assets/img/Sapling/613.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/613.jpg",},
    {src: "assets/img/Sapling/614.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/614.jpg",},
    {src: "assets/img/Sapling/615.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/615.jpg",},
    {src: "assets/img/Sapling/616.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/616.jpg",},
    {src: "assets/img/Sapling/617.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/617.jpg",},
    {src: "assets/img/Sapling/618.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/618.jpg",},
    {src: "assets/img/Sapling/591.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/591.jpg",},
    {src: "assets/img/Sapling/592.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/592.jpg",},
    {src: "assets/img/Sapling/593.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/593.jpg",},
    {src: "assets/img/Sapling/594.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/594.jpg",},
    {src: "assets/img/Sapling/595.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/595.jpg",},
    {src: "assets/img/Sapling/596.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/596.jpg",},
    {src: "assets/img/Sapling/597.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/597.jpg",},
    {src: "assets/img/Sapling/598.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/598.jpg",},
    {src: "assets/img/Sapling/599.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/599.jpg",},
    {src: "assets/img/Sapling/600.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/600.jpg",},
    {src: "assets/img/Sapling/601.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/601.jpg",},
    {src: "assets/img/Sapling/602.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/602.jpg",},
    {src: "assets/img/Sapling/603.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/603.jpg",},
    {src: "assets/img/Sapling/604.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/604.jpg",},
    {src: "assets/img/Sapling/605.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/605.jpg",},
    {src: "assets/img/Sapling/606.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/606.jpg",},
    {src: "assets/img/Sapling/580.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/580.jpg",},
    {src: "assets/img/Sapling/581.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/581.jpg",},
    {src: "assets/img/Sapling/582.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/582.jpg",},
    {src: "assets/img/Sapling/583.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/583.jpg",},
    {src: "assets/img/Sapling/584.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/584.jpg",},
    {src: "assets/img/Sapling/585.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/585.jpg",},
    {src: "assets/img/Sapling/586.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/586.jpg",},
    {src: "assets/img/Sapling/587.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/587.jpg",},
    {src: "assets/img/Sapling/588.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/588.jpg",},
    {src: "assets/img/Sapling/589.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/589.jpg",},
    {src: "assets/img/Sapling/590.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/590.jpg",},
    {src: "assets/img/Sapling/575.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/575.jpg",},
    {src: "assets/img/Sapling/576.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/576.jpg",},
    {src: "assets/img/Sapling/577.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/577.jpg",},
    {src: "assets/img/Sapling/578.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/578.jpg",},
    {src: "assets/img/Sapling/579.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/579.jpg",},
    {src: "assets/img/Sapling/563.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/563.jpg",},
    {src: "assets/img/Sapling/564.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/564.jpg",},
    {src: "assets/img/Sapling/565.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/565.jpg",},
    {src: "assets/img/Sapling/566.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/566.jpg",},
    {src: "assets/img/Sapling/567.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/567.jpg",},
    {src: "assets/img/Sapling/568.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/568.jpg",},
    {src: "assets/img/Sapling/569.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/569.jpg",},
    {src: "assets/img/Sapling/570.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/570.jpg",},
    {src: "assets/img/Sapling/571.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/571.jpg",},
    {src: "assets/img/Sapling/572.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/572.jpg",},
    {src: "assets/img/Sapling/573.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/573.jpg",},
    {src: "assets/img/Sapling/574.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/574.jpg",},
    {src: "assets/img/Sapling/553.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/553.jpg",},
    {src: "assets/img/Sapling/554.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/554.jpg",},
    {src: "assets/img/Sapling/555.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/555.jpg",},
    {src: "assets/img/Sapling/556.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/556.jpg",},
    {src: "assets/img/Sapling/557.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/557.jpg",},
    {src: "assets/img/Sapling/558.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/558.jpg",},
    {src: "assets/img/Sapling/559.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/559.jpg",},
    {src: "assets/img/Sapling/560.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/560.jpg",},
    {src: "assets/img/Sapling/561.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/561.jpg",},
    {src: "assets/img/Sapling/562.jpg",caption: "ഭൂമിയ്ക്കൊരു പച്ചപ്പ്....   നിംസ് ഹരിതകം പദ്ധതി.....  നിംസിൽ ജനിക്കുന്ന ഓരോ കുട്ടികൾക്കും ഫലവൃക്ഷത്തൈകൾ നൽകുന്ന പദ്ധതി. നമ്മുടെ കുഞ്ഞോമ്മനകൾക്കൊപ്പം അവരും വളരട്ടെ ഭൂമിക്ക് തണലേകാൻ  ......  ഫലമേകാൻ ......",thumb: "assets/img/Sapling/562.jpg",},
    {src: "assets/img/Sapling/552.jpeg",caption: "B/O Lekshmi",thumb: "assets/img/Sapling/552.jpeg",},
    {src: "assets/img/Sapling/549.jpeg",caption: "B/O Nidhya",thumb: "assets/img/Sapling/549.jpeg",},
    {src: "assets/img/Sapling/550.jpeg",caption: "B/O sreeja",thumb: "assets/img/Sapling/550.jpeg",},
  {src: "assets/img/Sapling/551.jpeg",caption: "B/O Saliha",thumb: "assets/img/Sapling/551.jpeg",},
    {src: "assets/img/Sapling/547.jpeg",caption: "B/O Deepthy",thumb: "assets/img/Sapling/547.jpeg",},
    {src: "assets/img/Sapling/548.jpeg",caption: "B/O Sajitha",thumb: "assets/img/Sapling/548.jpeg",},
  {src: "assets/img/Sapling/546.jpeg",caption: "B/O Anu",thumb: "assets/img/Sapling/546.jpeg",},
  {src: "assets/img/Sapling/545.jpeg",caption: "B/O Sree Sekha",thumb: "assets/img/Sapling/545.jpeg",},
    {src: "assets/img/Sapling/544.jpeg",caption: "B/O Aarsha",thumb: "assets/img/Sapling/544.jpeg",},
    {src: "assets/img/Sapling/542.jpeg",caption: "B/O Viji Selvam",thumb: "assets/img/Sapling/542.jpeg",},
    {src: "assets/img/Sapling/543.jpeg",caption: "B/O Jeena",thumb: "assets/img/Sapling/543.jpeg",},
    {src: "assets/img/Sapling/539.jpeg",caption: "B/O Sheela",thumb: "assets/img/Sapling/539.jpeg",},
    {src: "assets/img/Sapling/540.jpeg",caption: "B/O Monisha",thumb: "assets/img/Sapling/540.jpeg",},
    {src: "assets/img/Sapling/541.jpeg",caption: "B/O Anagha",thumb: "assets/img/Sapling/541.jpeg",},
  {src: "assets/img/Sapling/538.jpeg",caption: "B/O Subasini",thumb: "assets/img/Sapling/538.jpeg",},
    {src: "assets/img/Sapling/533.jpeg",caption: "B/O Jenisha",thumb: "assets/img/Sapling/533.jpeg",},
    {src: "assets/img/Sapling/534.jpeg",caption: "B/O Sherin",thumb: "assets/img/Sapling/534.jpeg",},
    {src: "assets/img/Sapling/535.jpeg",caption: "B/O Reshma Mathew",thumb: "assets/img/Sapling/535.jpeg",},
    {src: "assets/img/Sapling/536.jpeg",caption: "B/O Sreedevi 2nd",thumb: "assets/img/Sapling/536.jpeg",},
    {src: "assets/img/Sapling/537.jpeg",caption: "B/O Sreedevi 1st",thumb: "assets/img/Sapling/537.jpeg",},
    {src: "assets/img/Sapling/530.jpeg",caption: " ",thumb: "assets/img/Sapling/530.jpeg",},
    {src: "assets/img/Sapling/531.jpeg",caption: " ",thumb: "assets/img/Sapling/531.jpeg",},
    {src: "assets/img/Sapling/532.jpeg",caption: "B/O Shabana Beegum",thumb: "assets/img/Sapling/532.jpeg",},
    {src: "assets/img/Sapling/527.jpeg",caption: "B/O Subina",thumb: "assets/img/Sapling/527.jpeg",},
    {src: "assets/img/Sapling/528.jpeg",caption: "B/O Sheblin",thumb: "assets/img/Sapling/528.jpeg",},
    {src: "assets/img/Sapling/529.jpeg",caption: "B/O Jini ",thumb: "assets/img/Sapling/529.jpeg",},
    {src: "assets/img/Sapling/524.jpeg",caption: "B/O Gopika",thumb: "assets/img/Sapling/524.jpeg",},
    {src: "assets/img/Sapling/525.jpeg",caption: "B/O Abhaya",thumb: "assets/img/Sapling/525.jpeg",},
    {src: "assets/img/Sapling/526.jpeg",caption: "B/O Panchami ",thumb: "assets/img/Sapling/526.jpeg",},
  {src: "assets/img/Sapling/521.jpeg",caption: "B/O Deepa",thumb: "assets/img/Sapling/521.jpeg",},
  {src: "assets/img/Sapling/522.jpeg",caption: "B/O Jeritta",thumb: "assets/img/Sapling/522.jpeg",},
  {src: "assets/img/Sapling/523.jpeg",caption: "B/O Sona",thumb: "assets/img/Sapling/523.jpeg",},
  {src: "assets/img/Sapling/519.jpeg",caption: "B/O Subitha",thumb: "assets/img/Sapling/519.jpeg",},
  {src: "assets/img/Sapling/520.jpeg",caption: "B/O Remya",thumb: "assets/img/Sapling/520.jpeg",},
    {src: "assets/img/Sapling/518.jpeg",caption: "B/O Anju",thumb: "assets/img/Sapling/518.jpeg",},
  {src: "assets/img/Sapling/517.jpeg",caption: "B/O Anupama",thumb: "assets/img/Sapling/517.jpeg",},
  {src: "assets/img/Sapling/516.jpeg",caption: "",thumb: "assets/img/Sapling/516.jpeg",},
    {src: "assets/img/Sapling/512.jpeg",caption: "B/O Geetha",thumb: "assets/img/Sapling/512.jpeg",},
    {src: "assets/img/Sapling/513.jpeg",caption: "",thumb: "assets/img/Sapling/513.jpeg",},
    {src: "assets/img/Sapling/514.jpeg",caption: "",thumb: "assets/img/Sapling/514.jpeg",},
    {src: "assets/img/Sapling/515.jpeg",caption: "",thumb: "assets/img/Sapling/515.jpeg",},
  {src: "assets/img/Sapling/511.jpeg",caption: "B/O Padmaveni",thumb: "assets/img/Sapling/511.jpeg",},
  {src: "assets/img/Sapling/510.jpeg",caption: "B/O Archana",thumb: "assets/img/Sapling/510.jpeg",},
  {src: "assets/img/Sapling/504.jpeg",caption: "B/O shilpa",thumb: "assets/img/Sapling/504.jpeg",},
  {src: "assets/img/Sapling/505.jpeg",caption: "B/O gopika",thumb: "assets/img/Sapling/505.jpeg",},
  {src: "assets/img/Sapling/506.jpeg",caption: "B/O Anusha",thumb: "assets/img/Sapling/506.jpeg",},
  {src: "assets/img/Sapling/507.jpeg",caption: "B/O Anisha bose",thumb: "assets/img/Sapling/507.jpeg",},
  {src: "assets/img/Sapling/508.jpeg",caption: "B/O Divya",thumb: "assets/img/Sapling/508.jpeg",},
  {src: "assets/img/Sapling/509.jpeg",caption: "B/O vidhya",thumb: "assets/img/Sapling/509.jpeg",},
  {src: "assets/img/Sapling/502.jpeg",caption: "B/O Aneesha",thumb: "assets/img/Sapling/502.jpeg",},
  {src: "assets/img/Sapling/503.jpeg",caption: "B/O Ashna",thumb: "assets/img/Sapling/503.jpeg",},
  {src: "assets/img/Sapling/500.jpeg",caption: "B/O Sandhya",thumb: "assets/img/Sapling/500.jpeg",},
  {src: "assets/img/Sapling/501.jpeg",caption: "B/O Beatilin",thumb: "assets/img/Sapling/501.jpeg",},
  {src: "assets/img/Sapling/499.jpeg",caption: "B/o Asha",thumb: "assets/img/Sapling/499.jpeg",},
  {src: "assets/img/Sapling/490.jpeg",caption: "B/o vaishnavi",thumb: "assets/img/Sapling/490.jpeg",},
  {src: "assets/img/Sapling/491.jpeg",caption: "B/O jiji",thumb: "assets/img/Sapling/491.jpeg",},
  {src: "assets/img/Sapling/492.jpeg",caption: "Baby of noufia",thumb: "assets/img/Sapling/492.jpeg",},
  {src: "assets/img/Sapling/493.jpeg",caption: "B/o Shreevidya",thumb: "assets/img/Sapling/493.jpeg",},
  {src: "assets/img/Sapling/494.jpeg",caption: "B/O Akhila",thumb: "assets/img/Sapling/494.jpeg",},
  {src: "assets/img/Sapling/495.jpeg",caption: "B/O Najmi",thumb: "assets/img/Sapling/495.jpeg",},
  {src: "assets/img/Sapling/496.jpeg",caption: "B/o Naura",thumb: "assets/img/Sapling/496.jpeg",},
  {src: "assets/img/Sapling/497.jpeg",caption: "B/o sherolin",thumb: "assets/img/Sapling/497.jpeg",},
  {src: "assets/img/Sapling/498.jpeg",caption: "B/o Asmin Jenifa",thumb: "assets/img/Sapling/498.jpeg",},
  {src: "assets/img/Sapling/489.jpeg",caption: "B/O madheeha",thumb: "assets/img/Sapling/489.jpeg",},
  {src: "assets/img/Sapling/485.jpeg",caption: "B/o fenisha",thumb: "assets/img/Sapling/485.jpeg",},
  {src: "assets/img/Sapling/486.jpeg",caption: "B/o Maria Davis",thumb: "assets/img/Sapling/486.jpeg",},
  {src: "assets/img/Sapling/487.jpeg",caption: "B/0 aneesha",thumb: "assets/img/Sapling/487.jpeg",},
  {src: "assets/img/Sapling/488.jpeg",caption: "B/o Arathy",thumb: "assets/img/Sapling/488.jpeg",},
    {src: "assets/img/Sapling/473.jpeg",caption: "B/o Aswani",thumb: "assets/img/Sapling/473.jpeg",},
    {src: "assets/img/Sapling/474.jpeg",caption: "B/o saranya",thumb: "assets/img/Sapling/474.jpeg",},
    {src: "assets/img/Sapling/475.jpeg",caption: "B/o Annie",thumb: "assets/img/Sapling/475.jpeg",},
    {src: "assets/img/Sapling/476.jpeg",caption: "B/o Aspenre Sheela",thumb: "assets/img/Sapling/476.jpeg",},
    {src: "assets/img/Sapling/477.jpeg",caption: "B/o anju",thumb: "assets/img/Sapling/477.jpeg",},
    {src: "assets/img/Sapling/478.jpeg",caption: "B/O sreeja",thumb: "assets/img/Sapling/478.jpeg",},
    {src: "assets/img/Sapling/479.jpeg",caption: "B/o Mary sruthy",thumb: "assets/img/Sapling/479.jpeg",},
    {src: "assets/img/Sapling/480.jpeg",caption: "B/o vidhya",thumb: "assets/img/Sapling/480.jpeg",},
    {src: "assets/img/Sapling/481.jpeg",caption: "B/o Hemalatha",thumb: "assets/img/Sapling/481.jpeg",},
    {src: "assets/img/Sapling/482.jpeg",caption: "B/o Asmi",thumb: "assets/img/Sapling/482.jpeg",},
    {src: "assets/img/Sapling/483.jpeg",caption: "B/o shimi",thumb: "assets/img/Sapling/483.jpeg",},
    {src: "assets/img/Sapling/484.jpeg",caption: "B/o Chadra simla",thumb: "assets/img/Sapling/484.jpeg",},
    {src: "assets/img/Sapling/439.jpeg",caption: "",thumb: "assets/img/Sapling/439.jpeg",},
    {src: "assets/img/Sapling/440.jpeg",caption: "",thumb: "assets/img/Sapling/440.jpeg",},
    {src: "assets/img/Sapling/441.jpeg",caption: "",thumb: "assets/img/Sapling/441.jpeg",},
    {src: "assets/img/Sapling/442.jpeg",caption: "",thumb: "assets/img/Sapling/442.jpeg",},
    {src: "assets/img/Sapling/443.jpeg",caption: "",thumb: "assets/img/Sapling/443.jpeg",},
    {src: "assets/img/Sapling/444.jpeg",caption: "",thumb: "assets/img/Sapling/444.jpeg",},
    {src: "assets/img/Sapling/445.jpeg",caption: "",thumb: "assets/img/Sapling/445.jpeg",},
    {src: "assets/img/Sapling/446.jpeg",caption: "",thumb: "assets/img/Sapling/446.jpeg",},
    {src: "assets/img/Sapling/447.jpeg",caption: "",thumb: "assets/img/Sapling/447.jpeg",},
    {src: "assets/img/Sapling/448.jpeg",caption: "",thumb: "assets/img/Sapling/448.jpeg",},
    {src: "assets/img/Sapling/449.jpeg",caption: "",thumb: "assets/img/Sapling/449.jpeg",},
    {src: "assets/img/Sapling/450.jpeg",caption: "",thumb: "assets/img/Sapling/450.jpeg",},
    {src: "assets/img/Sapling/451.jpeg",caption: "",thumb: "assets/img/Sapling/451.jpeg",},
    {src: "assets/img/Sapling/452.jpeg",caption: "",thumb: "assets/img/Sapling/452.jpeg",},
    {src: "assets/img/Sapling/453.jpeg",caption: "",thumb: "assets/img/Sapling/453.jpeg",},
    {src: "assets/img/Sapling/454.jpeg",caption: "",thumb: "assets/img/Sapling/454.jpeg",},
    {src: "assets/img/Sapling/455.jpeg",caption: "",thumb: "assets/img/Sapling/455.jpeg",},
    {src: "assets/img/Sapling/456.jpeg",caption: "",thumb: "assets/img/Sapling/456.jpeg",},
    {src: "assets/img/Sapling/457.jpeg",caption: "",thumb: "assets/img/Sapling/457.jpeg",},
    {src: "assets/img/Sapling/458.jpeg",caption: "",thumb: "assets/img/Sapling/458.jpeg",},
    {src: "assets/img/Sapling/459.jpeg",caption: "",thumb: "assets/img/Sapling/459.jpeg",},
    {src: "assets/img/Sapling/460.jpeg",caption: "",thumb: "assets/img/Sapling/460.jpeg",},
    {src: "assets/img/Sapling/461.jpeg",caption: "",thumb: "assets/img/Sapling/461.jpeg",},
    {src: "assets/img/Sapling/462.jpeg",caption: "",thumb: "assets/img/Sapling/462.jpeg",},
    {src: "assets/img/Sapling/463.jpeg",caption: "",thumb: "assets/img/Sapling/463.jpeg",},
    {src: "assets/img/Sapling/464.jpeg",caption: "",thumb: "assets/img/Sapling/464.jpeg",},
    {src: "assets/img/Sapling/465.jpeg",caption: "",thumb: "assets/img/Sapling/465.jpeg",},
    {src: "assets/img/Sapling/466.jpeg",caption: "",thumb: "assets/img/Sapling/466.jpeg",},
    {src: "assets/img/Sapling/467.jpeg",caption: "",thumb: "assets/img/Sapling/467.jpeg",},
    {src: "assets/img/Sapling/468.jpeg",caption: "",thumb: "assets/img/Sapling/468.jpeg",},
    {src: "assets/img/Sapling/469.jpeg",caption: "",thumb: "assets/img/Sapling/469.jpeg",},
    {src: "assets/img/Sapling/470.jpeg",caption: "",thumb: "assets/img/Sapling/470.jpeg",},
    {src: "assets/img/Sapling/471.jpeg",caption: "",thumb: "assets/img/Sapling/471.jpeg",},
    {src: "assets/img/Sapling/472.jpeg",caption: "",thumb: "assets/img/Sapling/472.jpeg",},
    {src: "assets/img/Sapling/396.jpeg",caption: "",thumb: "assets/img/Sapling/396.jpeg",},
{src: "assets/img/Sapling/397.jpeg",caption: "",thumb: "assets/img/Sapling/397.jpeg",},
{src: "assets/img/Sapling/398.jpeg",caption: "",thumb: "assets/img/Sapling/398.jpeg",},
{src: "assets/img/Sapling/399.jpeg",caption: "",thumb: "assets/img/Sapling/399.jpeg",},
{src: "assets/img/Sapling/400.jpeg",caption: "",thumb: "assets/img/Sapling/400.jpeg",},
{src: "assets/img/Sapling/401.jpeg",caption: "",thumb: "assets/img/Sapling/401.jpeg",},
{src: "assets/img/Sapling/402.jpeg",caption: "",thumb: "assets/img/Sapling/402.jpeg",},
{src: "assets/img/Sapling/403.jpeg",caption: "",thumb: "assets/img/Sapling/403.jpeg",},
{src: "assets/img/Sapling/404.jpeg",caption: "",thumb: "assets/img/Sapling/404.jpeg",},
{src: "assets/img/Sapling/405.jpeg",caption: "",thumb: "assets/img/Sapling/405.jpeg",},
{src: "assets/img/Sapling/406.jpeg",caption: "",thumb: "assets/img/Sapling/406.jpeg",},
{src: "assets/img/Sapling/407.jpeg",caption: "",thumb: "assets/img/Sapling/407.jpeg",},
{src: "assets/img/Sapling/408.jpeg",caption: "",thumb: "assets/img/Sapling/408.jpeg",},
{src: "assets/img/Sapling/409.jpeg",caption: "",thumb: "assets/img/Sapling/409.jpeg",},
{src: "assets/img/Sapling/410.jpeg",caption: "",thumb: "assets/img/Sapling/410.jpeg",},
{src: "assets/img/Sapling/411.jpeg",caption: "",thumb: "assets/img/Sapling/411.jpeg",},
{src: "assets/img/Sapling/412.jpeg",caption: "",thumb: "assets/img/Sapling/412.jpeg",},
{src: "assets/img/Sapling/413.jpeg",caption: "",thumb: "assets/img/Sapling/413.jpeg",},
{src: "assets/img/Sapling/414.jpeg",caption: "",thumb: "assets/img/Sapling/414.jpeg",},
{src: "assets/img/Sapling/415.jpeg",caption: "",thumb: "assets/img/Sapling/415.jpeg",},
{src: "assets/img/Sapling/416.jpeg",caption: "",thumb: "assets/img/Sapling/416.jpeg",},
{src: "assets/img/Sapling/417.jpeg",caption: "",thumb: "assets/img/Sapling/417.jpeg",},
{src: "assets/img/Sapling/418.jpeg",caption: "",thumb: "assets/img/Sapling/418.jpeg",},
{src: "assets/img/Sapling/419.jpeg",caption: "",thumb: "assets/img/Sapling/419.jpeg",},
{src: "assets/img/Sapling/420.jpeg",caption: "",thumb: "assets/img/Sapling/420.jpeg",},
{src: "assets/img/Sapling/421.jpeg",caption: "",thumb: "assets/img/Sapling/421.jpeg",},
{src: "assets/img/Sapling/422.jpeg",caption: "",thumb: "assets/img/Sapling/422.jpeg",},
{src: "assets/img/Sapling/423.jpeg",caption: "",thumb: "assets/img/Sapling/423.jpeg",},
{src: "assets/img/Sapling/424.jpeg",caption: "",thumb: "assets/img/Sapling/424.jpeg",},
{src: "assets/img/Sapling/425.jpeg",caption: "",thumb: "assets/img/Sapling/425.jpeg",},
{src: "assets/img/Sapling/426.jpeg",caption: "",thumb: "assets/img/Sapling/426.jpeg",},
{src: "assets/img/Sapling/427.jpeg",caption: "",thumb: "assets/img/Sapling/427.jpeg",},
{src: "assets/img/Sapling/428.jpeg",caption: "",thumb: "assets/img/Sapling/428.jpeg",},
{src: "assets/img/Sapling/429.jpeg",caption: "",thumb: "assets/img/Sapling/429.jpeg",},
{src: "assets/img/Sapling/430.jpeg",caption: "",thumb: "assets/img/Sapling/430.jpeg",},
{src: "assets/img/Sapling/431.jpeg",caption: "",thumb: "assets/img/Sapling/431.jpeg",},
{src: "assets/img/Sapling/432.jpeg",caption: "",thumb: "assets/img/Sapling/432.jpeg",},
{src: "assets/img/Sapling/433.jpeg",caption: "",thumb: "assets/img/Sapling/433.jpeg",},
{src: "assets/img/Sapling/434.jpeg",caption: "",thumb: "assets/img/Sapling/434.jpeg",},
{src: "assets/img/Sapling/435.jpeg",caption: "",thumb: "assets/img/Sapling/435.jpeg",},
{src: "assets/img/Sapling/436.jpeg",caption: "",thumb: "assets/img/Sapling/436.jpeg",},
{src: "assets/img/Sapling/437.jpeg",caption: "",thumb: "assets/img/Sapling/437.jpeg",},
{src: "assets/img/Sapling/438.jpeg",caption: "",thumb: "assets/img/Sapling/438.jpeg",},
{src: "assets/img/Sapling/358.jpeg",caption: "",thumb: "assets/img/Sapling/358.jpeg",},
{src: "assets/img/Sapling/359.jpeg",caption: "",thumb: "assets/img/Sapling/359.jpeg",},
{src: "assets/img/Sapling/360.jpeg",caption: "",thumb: "assets/img/Sapling/360.jpeg",},
{src: "assets/img/Sapling/361.jpeg",caption: "",thumb: "assets/img/Sapling/361.jpeg",},
{src: "assets/img/Sapling/362.jpeg",caption: "",thumb: "assets/img/Sapling/362.jpeg",},
{src: "assets/img/Sapling/363.jpeg",caption: "",thumb: "assets/img/Sapling/363.jpeg",},
{src: "assets/img/Sapling/364.jpeg",caption: "",thumb: "assets/img/Sapling/364.jpeg",},
{src: "assets/img/Sapling/365.jpeg",caption: "",thumb: "assets/img/Sapling/365.jpeg",},
{src: "assets/img/Sapling/366.jpeg",caption: "",thumb: "assets/img/Sapling/366.jpeg",},
{src: "assets/img/Sapling/367.jpeg",caption: "",thumb: "assets/img/Sapling/367.jpeg",},
{src: "assets/img/Sapling/368.jpeg",caption: "",thumb: "assets/img/Sapling/368.jpeg",},
{src: "assets/img/Sapling/369.jpeg",caption: "",thumb: "assets/img/Sapling/369.jpeg",},
{src: "assets/img/Sapling/370.jpeg",caption: "",thumb: "assets/img/Sapling/370.jpeg",},
{src: "assets/img/Sapling/371.jpeg",caption: "",thumb: "assets/img/Sapling/371.jpeg",},
{src: "assets/img/Sapling/372.jpeg",caption: "",thumb: "assets/img/Sapling/372.jpeg",},
{src: "assets/img/Sapling/373.jpeg",caption: "",thumb: "assets/img/Sapling/373.jpeg",},
{src: "assets/img/Sapling/374.jpeg",caption: "",thumb: "assets/img/Sapling/374.jpeg",},
{src: "assets/img/Sapling/375.jpeg",caption: "",thumb: "assets/img/Sapling/375.jpeg",},
{src: "assets/img/Sapling/376.jpeg",caption: "",thumb: "assets/img/Sapling/376.jpeg",},
{src: "assets/img/Sapling/377.jpeg",caption: "",thumb: "assets/img/Sapling/377.jpeg",},
{src: "assets/img/Sapling/378.jpeg",caption: "",thumb: "assets/img/Sapling/378.jpeg",},
{src: "assets/img/Sapling/379.jpeg",caption: "",thumb: "assets/img/Sapling/379.jpeg",},
{src: "assets/img/Sapling/380.jpeg",caption: "",thumb: "assets/img/Sapling/380.jpeg",},
{src: "assets/img/Sapling/381.jpeg",caption: "",thumb: "assets/img/Sapling/381.jpeg",},
{src: "assets/img/Sapling/382.jpeg",caption: "",thumb: "assets/img/Sapling/382.jpeg",},
{src: "assets/img/Sapling/383.jpeg",caption: "",thumb: "assets/img/Sapling/383.jpeg",},
{src: "assets/img/Sapling/384.jpeg",caption: "",thumb: "assets/img/Sapling/384.jpeg",},
{src: "assets/img/Sapling/385.jpeg",caption: "",thumb: "assets/img/Sapling/385.jpeg",},
{src: "assets/img/Sapling/386.jpeg",caption: "",thumb: "assets/img/Sapling/386.jpeg",},
{src: "assets/img/Sapling/387.jpeg",caption: "",thumb: "assets/img/Sapling/387.jpeg",},
{src: "assets/img/Sapling/388.jpeg",caption: "",thumb: "assets/img/Sapling/388.jpeg",},
{src: "assets/img/Sapling/389.jpeg",caption: "",thumb: "assets/img/Sapling/389.jpeg",},
{src: "assets/img/Sapling/390.jpeg",caption: "",thumb: "assets/img/Sapling/390.jpeg",},
{src: "assets/img/Sapling/391.jpeg",caption: "",thumb: "assets/img/Sapling/391.jpeg",},
{src: "assets/img/Sapling/392.jpeg",caption: "",thumb: "assets/img/Sapling/392.jpeg",},
{src: "assets/img/Sapling/393.jpeg",caption: "",thumb: "assets/img/Sapling/393.jpeg",},
{src: "assets/img/Sapling/394.jpeg",caption: "",thumb: "assets/img/Sapling/394.jpeg",},
{src: "assets/img/Sapling/395.jpeg",caption: "",thumb: "assets/img/Sapling/395.jpeg",},
{src: "assets/img/harithakam/154.jpeg",caption: "",thumb: "assets/img/harithakam/154.jpeg",},
{src: "assets/img/harithakam/155.jpeg",caption: "",thumb: "assets/img/harithakam/155.jpeg",},
{src: "assets/img/harithakam/156.jpeg",caption: "",thumb: "assets/img/harithakam/156.jpeg",},
{src: "assets/img/harithakam/157.jpeg",caption: "",thumb: "assets/img/harithakam/157.jpeg",},
{src: "assets/img/harithakam/158.jpeg",caption: "",thumb: "assets/img/harithakam/158.jpeg",},
    {src: "assets/img/Sapling/330.jpeg",caption: "",thumb: "assets/img/Sapling/330.jpeg",},
    {src: "assets/img/Sapling/331.jpeg",caption: "",thumb: "assets/img/Sapling/331.jpeg",},
    {src: "assets/img/Sapling/332.jpeg",caption: "",thumb: "assets/img/Sapling/332.jpeg",},
    {src: "assets/img/Sapling/333.jpeg",caption: "",thumb: "assets/img/Sapling/333.jpeg",},
    {src: "assets/img/Sapling/334.jpeg",caption: "",thumb: "assets/img/Sapling/334.jpeg",},
    {src: "assets/img/Sapling/335.jpeg",caption: "",thumb: "assets/img/Sapling/335.jpeg",},
    {src: "assets/img/Sapling/336.jpeg",caption: "",thumb: "assets/img/Sapling/336.jpeg",},
    {src: "assets/img/Sapling/337.jpeg",caption: "",thumb: "assets/img/Sapling/337.jpeg",},
    {src: "assets/img/Sapling/338.jpeg",caption: "",thumb: "assets/img/Sapling/338.jpeg",},
    {src: "assets/img/Sapling/339.jpeg",caption: "",thumb: "assets/img/Sapling/339.jpeg",},
    {src: "assets/img/Sapling/340.jpeg",caption: "",thumb: "assets/img/Sapling/340.jpeg",},
    {src: "assets/img/Sapling/341.jpeg",caption: "",thumb: "assets/img/Sapling/341.jpeg",},
    {src: "assets/img/Sapling/342.jpeg",caption: "",thumb: "assets/img/Sapling/342.jpeg",},
    {src: "assets/img/Sapling/343.jpeg",caption: "",thumb: "assets/img/Sapling/343.jpeg",},
    {src: "assets/img/Sapling/344.jpeg",caption: "",thumb: "assets/img/Sapling/344.jpeg",},
    {src: "assets/img/Sapling/345.jpeg",caption: "",thumb: "assets/img/Sapling/345.jpeg",},
    {src: "assets/img/Sapling/346.jpeg",caption: "",thumb: "assets/img/Sapling/346.jpeg",},
    {src: "assets/img/Sapling/347.jpeg",caption: "",thumb: "assets/img/Sapling/347.jpeg",},
    {src: "assets/img/Sapling/348.jpeg",caption: "",thumb: "assets/img/Sapling/348.jpeg",},
    {src: "assets/img/Sapling/349.jpeg",caption: "",thumb: "assets/img/Sapling/349.jpeg",},
    {src: "assets/img/Sapling/350.jpeg",caption: "",thumb: "assets/img/Sapling/350.jpeg",},
    {src: "assets/img/Sapling/351.jpeg",caption: "",thumb: "assets/img/Sapling/351.jpeg",},
    {src: "assets/img/Sapling/352.jpeg",caption: "",thumb: "assets/img/Sapling/352.jpeg",},
    {src: "assets/img/Sapling/353.jpeg",caption: "",thumb: "assets/img/Sapling/353.jpeg",},
    {src: "assets/img/Sapling/354.jpeg",caption: "",thumb: "assets/img/Sapling/354.jpeg",},
    {src: "assets/img/Sapling/355.jpeg",caption: "",thumb: "assets/img/Sapling/355.jpeg",},
    {src: "assets/img/Sapling/356.jpeg",caption: "",thumb: "assets/img/Sapling/356.jpeg",},
    {src: "assets/img/Sapling/357.jpeg",caption: "",thumb: "assets/img/Sapling/357.jpeg",},    
    {src: "assets/img/Sapling/285.jpeg",caption: "",thumb: "assets/img/Sapling/285.jpeg",},
{src: "assets/img/Sapling/286.jpeg",caption: "",thumb: "assets/img/Sapling/286.jpeg",},
{src: "assets/img/Sapling/287.jpeg",caption: "",thumb: "assets/img/Sapling/287.jpeg",},
{src: "assets/img/Sapling/288.jpeg",caption: "",thumb: "assets/img/Sapling/288.jpeg",},
{src: "assets/img/Sapling/289.jpeg",caption: "",thumb: "assets/img/Sapling/289.jpeg",},
{src: "assets/img/Sapling/290.jpeg",caption: "",thumb: "assets/img/Sapling/290.jpeg",},
{src: "assets/img/Sapling/291.jpeg",caption: "",thumb: "assets/img/Sapling/291.jpeg",},
{src: "assets/img/Sapling/292.jpeg",caption: "",thumb: "assets/img/Sapling/292.jpeg",},
{src: "assets/img/Sapling/293.jpeg",caption: "",thumb: "assets/img/Sapling/293.jpeg",},
{src: "assets/img/Sapling/294.jpeg",caption: "",thumb: "assets/img/Sapling/294.jpeg",},
{src: "assets/img/Sapling/295.jpeg",caption: "",thumb: "assets/img/Sapling/295.jpeg",},
{src: "assets/img/Sapling/296.jpeg",caption: "",thumb: "assets/img/Sapling/296.jpeg",},
{src: "assets/img/Sapling/297.jpeg",caption: "",thumb: "assets/img/Sapling/297.jpeg",},
{src: "assets/img/Sapling/298.jpeg",caption: "",thumb: "assets/img/Sapling/298.jpeg",},
{src: "assets/img/Sapling/299.jpeg",caption: "",thumb: "assets/img/Sapling/299.jpeg",},
{src: "assets/img/Sapling/300.jpeg",caption: "",thumb: "assets/img/Sapling/300.jpeg",},
{src: "assets/img/Sapling/301.jpeg",caption: "",thumb: "assets/img/Sapling/301.jpeg",},
{src: "assets/img/Sapling/302.jpeg",caption: "",thumb: "assets/img/Sapling/302.jpeg",},
{src: "assets/img/Sapling/303.jpeg",caption: "",thumb: "assets/img/Sapling/303.jpeg",},
{src: "assets/img/Sapling/304.jpeg",caption: "",thumb: "assets/img/Sapling/304.jpeg",},
{src: "assets/img/Sapling/305.jpeg",caption: "",thumb: "assets/img/Sapling/305.jpeg",},
{src: "assets/img/Sapling/306.jpeg",caption: "",thumb: "assets/img/Sapling/306.jpeg",},
{src: "assets/img/Sapling/307.jpeg",caption: "",thumb: "assets/img/Sapling/307.jpeg",},
{src: "assets/img/Sapling/308.jpeg",caption: "",thumb: "assets/img/Sapling/308.jpeg",},
{src: "assets/img/Sapling/309.jpeg",caption: "",thumb: "assets/img/Sapling/309.jpeg",},
{src: "assets/img/Sapling/310.jpeg",caption: "",thumb: "assets/img/Sapling/310.jpeg",},
{src: "assets/img/Sapling/311.jpeg",caption: "",thumb: "assets/img/Sapling/311.jpeg",},
{src: "assets/img/Sapling/312.jpeg",caption: "",thumb: "assets/img/Sapling/312.jpeg",},
{src: "assets/img/Sapling/313.jpeg",caption: "",thumb: "assets/img/Sapling/313.jpeg",},
{src: "assets/img/Sapling/314.jpeg",caption: "",thumb: "assets/img/Sapling/314.jpeg",},
{src: "assets/img/Sapling/315.jpeg",caption: "",thumb: "assets/img/Sapling/315.jpeg",},
{src: "assets/img/Sapling/316.jpeg",caption: "",thumb: "assets/img/Sapling/316.jpeg",},
{src: "assets/img/Sapling/317.jpeg",caption: "",thumb: "assets/img/Sapling/317.jpeg",},
{src: "assets/img/Sapling/318.jpeg",caption: "",thumb: "assets/img/Sapling/318.jpeg",},
{src: "assets/img/Sapling/319.jpeg",caption: "",thumb: "assets/img/Sapling/319.jpeg",},
{src: "assets/img/Sapling/320.jpeg",caption: "",thumb: "assets/img/Sapling/320.jpeg",},
{src: "assets/img/Sapling/321.jpeg",caption: "",thumb: "assets/img/Sapling/321.jpeg",},
{src: "assets/img/Sapling/322.jpeg",caption: "",thumb: "assets/img/Sapling/322.jpeg",},
{src: "assets/img/Sapling/323.jpeg",caption: "",thumb: "assets/img/Sapling/323.jpeg",},
{src: "assets/img/Sapling/324.jpeg",caption: "",thumb: "assets/img/Sapling/324.jpeg",},
{src: "assets/img/Sapling/325.jpeg",caption: "",thumb: "assets/img/Sapling/325.jpeg",},
{src: "assets/img/Sapling/326.jpeg",caption: "",thumb: "assets/img/Sapling/326.jpeg",},
{src: "assets/img/Sapling/327.jpeg",caption: "",thumb: "assets/img/Sapling/327.jpeg",},
{src: "assets/img/Sapling/328.jpeg",caption: "",thumb: "assets/img/Sapling/328.jpeg",},
{src: "assets/img/Sapling/329.jpeg",caption: "",thumb: "assets/img/Sapling/329.jpeg",},
{src: "assets/img/Sapling/330.jpeg",caption: "",thumb: "assets/img/Sapling/330.jpeg",},
    {
      src: "assets/img/harithakam/147.jpeg",
      caption: "",
      thumb: "assets/img/harithakam/147.jpeg",
    },
    {
      src: "assets/img/harithakam/148.jpeg",
      caption: "",
      thumb: "assets/img/harithakam/148.jpeg",
    },
    {
      src: "assets/img/harithakam/149.jpeg",
      caption: "",
      thumb: "assets/img/harithakam/149.jpeg",
    },
    {
      src: "assets/img/harithakam/150.jpeg",
      caption: "",
      thumb: "assets/img/harithakam/150.jpeg",
    },
    {
      src: "assets/img/harithakam/151.jpeg",
      caption: "",
      thumb: "assets/img/harithakam/151.jpeg",
    },
    {
      src: "assets/img/harithakam/152.jpeg",
      caption: "",
      thumb: "assets/img/harithakam/152.jpeg",
    },
    {
      src: "assets/img/harithakam/153.jpeg",
      caption: "",
      thumb: "assets/img/harithakam/153.jpeg",
    },
    {
      src: "assets/img/harithakam/154.jpeg",
      caption: "",
      thumb: "assets/img/harithakam/154.jpeg",
    },
    {
      src: "assets/img/harithakam/131.jpeg",
      caption: "",
      thumb: "assets/img/harithakam/131.jpeg",
    },
    {
      src: "assets/img/harithakam/132.jpeg",
      caption: "",
      thumb: "assets/img/harithakam/132.jpeg",
    },
    {
      src: "assets/img/harithakam/133.jpeg",
      caption: "",
      thumb: "assets/img/harithakam/133.jpeg",
    },
    {
      src: "assets/img/harithakam/134.jpeg",
      caption: "",
      thumb: "assets/img/harithakam/134.jpeg",
    },
    {
      src: "assets/img/harithakam/135.jpeg",
      caption: "",
      thumb: "assets/img/harithakam/135.jpeg",
    },
    {
      src: "assets/img/harithakam/136.jpeg",
      caption: "",
      thumb: "assets/img/harithakam/136.jpeg",
    },
    {
      src: "assets/img/harithakam/137.jpeg",
      caption: "",
      thumb: "assets/img/harithakam/137.jpeg",
    },
    {
      src: "assets/img/harithakam/138.jpeg",
      caption: "",
      thumb: "assets/img/harithakam/138.jpeg",
    },
    {
      src: "assets/img/harithakam/139.jpeg",
      caption: "",
      thumb: "assets/img/harithakam/139.jpeg",
    },
    {
      src: "assets/img/harithakam/140.jpeg",
      caption: "",
      thumb: "assets/img/harithakam/140.jpeg",
    },
    {
      src: "assets/img/harithakam/141.jpeg",
      caption: "",
      thumb: "assets/img/harithakam/141.jpeg",
    },
    {
      src: "assets/img/harithakam/142.jpeg",
      caption: "",
      thumb: "assets/img/harithakam/142.jpeg",
    },
    {
      src: "assets/img/harithakam/143.jpeg",
      caption: "",
      thumb: "assets/img/harithakam/143.jpeg",
    },
    {
      src: "assets/img/harithakam/144.jpeg",
      caption: "",
      thumb: "assets/img/harithakam/144.jpeg",
    },
    {
      src: "assets/img/harithakam/145.jpeg",
      caption: "",
      thumb: "assets/img/harithakam/145.jpeg",
    },
    {
      src: "assets/img/harithakam/146.jpeg",
      caption: "",
      thumb: "assets/img/harithakam/146.jpeg",
    },
    {
      src: "assets/img/harithakam/124.jpeg",
      caption: "നിംസ് മെഡിസിറ്റിയും പി.ടി.എം ഹയർ സെക്കൻഡറി സ്കൂൾ മരുതൂർക്കോണവും  വിഴിഞ്ഞം ലയൺസ് ക്ലബും സംയുക്തമായി ലോക പരിസ്ഥിതി ദിനാചരണം നടത്തി . നിംസ് ഹരിതകം പദ്ധതിയുടെ ഭാഗമായി സ്കൂൾ അങ്കണത്തിൽ ഫല വൃക്ഷത്തൈ നട്ടു . നിംസ് ഹരിതകം പദ്ധതി കോർഡിനേറ്റർ ശ്രീമതി ജെസ്സി ജോൺ ,   പി.ടി.എം ഹയർ സെക്കൻഡറി സ്കൂൾ മാനേജർ അഭിലാഷ് , ലയൺസ് ക്ലബ് വിഴിഞ്ഞം ഭാരവാഹികളായ ശ്രീ വിനോദ് കുമാർ ,ലയൺ രതീഷ് , ഡയറക്ടർ ബോർഡ് അംഗം ശ്രീ നന്ദു തുടങ്ങിയവർ സന്നിഹിതരായിരുന്നു",
      thumb: "assets/img/harithakam/124.jpeg",
    },
    {
      src: "assets/img/harithakam/125.jpeg",
      caption: "നിംസ് മെഡിസിറ്റിയും പി.ടി.എം ഹയർ സെക്കൻഡറി സ്കൂൾ മരുതൂർക്കോണവും  വിഴിഞ്ഞം ലയൺസ് ക്ലബും സംയുക്തമായി ലോക പരിസ്ഥിതി ദിനാചരണം നടത്തി . നിംസ് ഹരിതകം പദ്ധതിയുടെ ഭാഗമായി സ്കൂൾ അങ്കണത്തിൽ ഫല വൃക്ഷത്തൈ നട്ടു . നിംസ് ഹരിതകം പദ്ധതി കോർഡിനേറ്റർ ശ്രീമതി ജെസ്സി ജോൺ ,   പി.ടി.എം ഹയർ സെക്കൻഡറി സ്കൂൾ മാനേജർ അഭിലാഷ് , ലയൺസ് ക്ലബ് വിഴിഞ്ഞം ഭാരവാഹികളായ ശ്രീ വിനോദ് കുമാർ ,ലയൺ രതീഷ് , ഡയറക്ടർ ബോർഡ് അംഗം ശ്രീ നന്ദു തുടങ്ങിയവർ സന്നിഹിതരായിരുന്നു",
      thumb: "assets/img/harithakam/125.jpeg",
    },
    {
      src: "assets/img/harithakam/126.jpeg",
      caption: "നിംസ് മെഡിസിറ്റിയും പി.ടി.എം ഹയർ സെക്കൻഡറി സ്കൂൾ മരുതൂർക്കോണവും  വിഴിഞ്ഞം ലയൺസ് ക്ലബും സംയുക്തമായി ലോക പരിസ്ഥിതി ദിനാചരണം നടത്തി . നിംസ് ഹരിതകം പദ്ധതിയുടെ ഭാഗമായി സ്കൂൾ അങ്കണത്തിൽ ഫല വൃക്ഷത്തൈ നട്ടു . നിംസ് ഹരിതകം പദ്ധതി കോർഡിനേറ്റർ ശ്രീമതി ജെസ്സി ജോൺ ,   പി.ടി.എം ഹയർ സെക്കൻഡറി സ്കൂൾ മാനേജർ അഭിലാഷ് , ലയൺസ് ക്ലബ് വിഴിഞ്ഞം ഭാരവാഹികളായ ശ്രീ വിനോദ് കുമാർ ,ലയൺ രതീഷ് , ഡയറക്ടർ ബോർഡ് അംഗം ശ്രീ നന്ദു തുടങ്ങിയവർ സന്നിഹിതരായിരുന്നു",
      thumb: "assets/img/harithakam/126.jpeg",
    },
    {
      src: "assets/img/harithakam/127.jpeg",
      caption: "നിംസ് മെഡിസിറ്റിയും പി.ടി.എം ഹയർ സെക്കൻഡറി സ്കൂൾ മരുതൂർക്കോണവും  വിഴിഞ്ഞം ലയൺസ് ക്ലബും സംയുക്തമായി ലോക പരിസ്ഥിതി ദിനാചരണം നടത്തി . നിംസ് ഹരിതകം പദ്ധതിയുടെ ഭാഗമായി സ്കൂൾ അങ്കണത്തിൽ ഫല വൃക്ഷത്തൈ നട്ടു . നിംസ് ഹരിതകം പദ്ധതി കോർഡിനേറ്റർ ശ്രീമതി ജെസ്സി ജോൺ ,   പി.ടി.എം ഹയർ സെക്കൻഡറി സ്കൂൾ മാനേജർ അഭിലാഷ് , ലയൺസ് ക്ലബ് വിഴിഞ്ഞം ഭാരവാഹികളായ ശ്രീ വിനോദ് കുമാർ ,ലയൺ രതീഷ് , ഡയറക്ടർ ബോർഡ് അംഗം ശ്രീ നന്ദു തുടങ്ങിയവർ സന്നിഹിതരായിരുന്നു",
      thumb: "assets/img/harithakam/127.jpeg",
    },
    {
      src: "assets/img/harithakam/128.jpeg",
      caption: "നിംസ് മെഡിസിറ്റിയും പി.ടി.എം ഹയർ സെക്കൻഡറി സ്കൂൾ മരുതൂർക്കോണവും  വിഴിഞ്ഞം ലയൺസ് ക്ലബും സംയുക്തമായി ലോക പരിസ്ഥിതി ദിനാചരണം നടത്തി . നിംസ് ഹരിതകം പദ്ധതിയുടെ ഭാഗമായി സ്കൂൾ അങ്കണത്തിൽ ഫല വൃക്ഷത്തൈ നട്ടു . നിംസ് ഹരിതകം പദ്ധതി കോർഡിനേറ്റർ ശ്രീമതി ജെസ്സി ജോൺ ,   പി.ടി.എം ഹയർ സെക്കൻഡറി സ്കൂൾ മാനേജർ അഭിലാഷ് , ലയൺസ് ക്ലബ് വിഴിഞ്ഞം ഭാരവാഹികളായ ശ്രീ വിനോദ് കുമാർ ,ലയൺ രതീഷ് , ഡയറക്ടർ ബോർഡ് അംഗം ശ്രീ നന്ദു തുടങ്ങിയവർ സന്നിഹിതരായിരുന്നു",
      thumb: "assets/img/harithakam/128.jpeg",
    },
    {
      src: "assets/img/harithakam/129.jpeg",
      caption: "നിംസ് മെഡിസിറ്റിയും പി.ടി.എം ഹയർ സെക്കൻഡറി സ്കൂൾ മരുതൂർക്കോണവും  വിഴിഞ്ഞം ലയൺസ് ക്ലബും സംയുക്തമായി ലോക പരിസ്ഥിതി ദിനാചരണം നടത്തി . നിംസ് ഹരിതകം പദ്ധതിയുടെ ഭാഗമായി സ്കൂൾ അങ്കണത്തിൽ ഫല വൃക്ഷത്തൈ നട്ടു . നിംസ് ഹരിതകം പദ്ധതി കോർഡിനേറ്റർ ശ്രീമതി ജെസ്സി ജോൺ ,   പി.ടി.എം ഹയർ സെക്കൻഡറി സ്കൂൾ മാനേജർ അഭിലാഷ് , ലയൺസ് ക്ലബ് വിഴിഞ്ഞം ഭാരവാഹികളായ ശ്രീ വിനോദ് കുമാർ ,ലയൺ രതീഷ് , ഡയറക്ടർ ബോർഡ് അംഗം ശ്രീ നന്ദു തുടങ്ങിയവർ സന്നിഹിതരായിരുന്നു",
      thumb: "assets/img/harithakam/129.jpeg",
    },
    {
      src: "assets/img/harithakam/130.jpeg",
      caption: "നിംസ് മെഡിസിറ്റിയും പി.ടി.എം ഹയർ സെക്കൻഡറി സ്കൂൾ മരുതൂർക്കോണവും  വിഴിഞ്ഞം ലയൺസ് ക്ലബും സംയുക്തമായി ലോക പരിസ്ഥിതി ദിനാചരണം നടത്തി . നിംസ് ഹരിതകം പദ്ധതിയുടെ ഭാഗമായി സ്കൂൾ അങ്കണത്തിൽ ഫല വൃക്ഷത്തൈ നട്ടു . നിംസ് ഹരിതകം പദ്ധതി കോർഡിനേറ്റർ ശ്രീമതി ജെസ്സി ജോൺ ,   പി.ടി.എം ഹയർ സെക്കൻഡറി സ്കൂൾ മാനേജർ അഭിലാഷ് , ലയൺസ് ക്ലബ് വിഴിഞ്ഞം ഭാരവാഹികളായ ശ്രീ വിനോദ് കുമാർ ,ലയൺ രതീഷ് , ഡയറക്ടർ ബോർഡ് അംഗം ശ്രീ നന്ദു തുടങ്ങിയവർ സന്നിഹിതരായിരുന്നു",
      thumb: "assets/img/harithakam/130.jpeg",
    },
    {
      src: "assets/img/Sapling/261.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/261.jpeg",
    },
    {
      src: "assets/img/Sapling/262.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/262.jpeg",
    },
    {
      src: "assets/img/Sapling/263.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/263.jpeg",
    },
    {
      src: "assets/img/Sapling/264.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/264.jpeg",
    },
    {
      src: "assets/img/Sapling/265.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/265.jpeg",
    },
    {
      src: "assets/img/Sapling/266.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/266.jpeg",
    },
    {
      src: "assets/img/Sapling/267.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/267.jpeg",
    },
    {
      src: "assets/img/Sapling/268.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/268.jpeg",
    },
    {
      src: "assets/img/Sapling/269.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/269.jpeg",
    },
    {
      src: "assets/img/Sapling/270.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/270.jpeg",
    },
    {
      src: "assets/img/Sapling/271.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/271.jpeg",
    },
    {
      src: "assets/img/Sapling/272.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/272.jpeg",
    },
    {
      src: "assets/img/Sapling/273.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/273.jpeg",
    },
    {
      src: "assets/img/Sapling/274.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/274.jpeg",
    },
    {
      src: "assets/img/Sapling/275.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/275.jpeg",
    },
    {
      src: "assets/img/Sapling/276.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/276.jpeg",
    },
    {
      src: "assets/img/Sapling/277.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/277.jpeg",
    },
    {
      src: "assets/img/Sapling/278.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/278.jpeg",
    },
    {
      src: "assets/img/Sapling/279.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/279.jpeg",
    },
    {
      src: "assets/img/Sapling/280.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/280.jpeg",
    },
    {
      src: "assets/img/Sapling/281.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/281.jpeg",
    },
    {
      src: "assets/img/Sapling/282.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/282.jpeg",
    },
    {
      src: "assets/img/Sapling/283.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/283.jpeg",
    },
    {
      src: "assets/img/Sapling/284.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/284.jpeg",
    },
    {
      src: "assets/img/harithakam/120.jpg",
      caption: "ചേർത്തു നിർത്താം പ്രകൃതിയെ നല്ല നാളേക്ക് വേണ്ടി....... ലോകറെക്കോർഡുകളിൽ ഇടം നേടിയ ദക്ഷിണ കൈലാസം ചെങ്കൽ മഹേശ്വരം ശിവപാർവതി ക്ഷേത്രത്തിൽ നിംസ് ഹരിതം പദ്ധതി നടപ്പിലാക്കിയപ്പോൾ. നിംസ് എച്ച്.ആർ മാനേജർ ജെസ്സി മഹേശ്വരം ശിവപാർവതി ക്ഷേത്ര മഠാധിപതി സ്വാമി മഹേശ്വരാനന്ദ സരസ്വതിക്ക് വൃക്ഷ തൈ നൽകുന്നു.",
      thumb: "assets/img/harithakam/120.jpg",
    },
    {
      src: "assets/img/harithakam/121.jpg",
      caption: "ചേർത്തു നിർത്താം പ്രകൃതിയെ നല്ല നാളേക്ക് വേണ്ടി....... ലോകറെക്കോർഡുകളിൽ ഇടം നേടിയ ദക്ഷിണ കൈലാസം ചെങ്കൽ മഹേശ്വരം ശിവപാർവതി ക്ഷേത്രത്തിൽ നിംസ് ഹരിതം പദ്ധതി നടപ്പിലാക്കിയപ്പോൾ. നിംസ് എച്ച്.ആർ മാനേജർ ജെസ്സി മഹേശ്വരം ശിവപാർവതി ക്ഷേത്ര മഠാധിപതി സ്വാമി മഹേശ്വരാനന്ദ സരസ്വതിക്ക് വൃക്ഷ തൈ നൽകുന്നു.",
      thumb: "assets/img/harithakam/121.jpg",
    },
    {
      src: "assets/img/harithakam/122.jpg",
      caption: "ചേർത്തു നിർത്താം പ്രകൃതിയെ നല്ല നാളേക്ക് വേണ്ടി....... ലോകറെക്കോർഡുകളിൽ ഇടം നേടിയ ദക്ഷിണ കൈലാസം ചെങ്കൽ മഹേശ്വരം ശിവപാർവതി ക്ഷേത്രത്തിൽ നിംസ് ഹരിതം പദ്ധതി നടപ്പിലാക്കിയപ്പോൾ. നിംസ് എച്ച്.ആർ മാനേജർ ജെസ്സി മഹേശ്വരം ശിവപാർവതി ക്ഷേത്ര മഠാധിപതി സ്വാമി മഹേശ്വരാനന്ദ സരസ്വതിക്ക് വൃക്ഷ തൈ നൽകുന്നു.",
      thumb: "assets/img/harithakam/122.jpg",
    },
    {
      src: "assets/img/harithakam/123.jpg",
      caption: "ചേർത്തു നിർത്താം പ്രകൃതിയെ നല്ല നാളേക്ക് വേണ്ടി....... ലോകറെക്കോർഡുകളിൽ ഇടം നേടിയ ദക്ഷിണ കൈലാസം ചെങ്കൽ മഹേശ്വരം ശിവപാർവതി ക്ഷേത്രത്തിൽ നിംസ് ഹരിതം പദ്ധതി നടപ്പിലാക്കിയപ്പോൾ. നിംസ് എച്ച്.ആർ മാനേജർ ജെസ്സി മഹേശ്വരം ശിവപാർവതി ക്ഷേത്ര മഠാധിപതി സ്വാമി മഹേശ്വരാനന്ദ സരസ്വതിക്ക് വൃക്ഷ തൈ നൽകുന്നു.",
      thumb: "assets/img/harithakam/123.jpg",
    },
    {
      src: "assets/img/Sapling/247.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/247.jpeg",
    },
    {
      src: "assets/img/Sapling/248.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/248.jpeg",
    },
    {
      src: "assets/img/Sapling/249.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/249.jpeg",
    },
    {
      src: "assets/img/Sapling/250.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/250.jpeg",
    },
    {
      src: "assets/img/Sapling/251.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/251.jpeg",
    },
    {
      src: "assets/img/Sapling/252.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/252.jpeg",
    },
    {
      src: "assets/img/Sapling/253.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/253.jpeg",
    },
    {
      src: "assets/img/Sapling/254.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/254.jpeg",
    },
    {
      src: "assets/img/Sapling/255.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/255.jpeg",
    },
    {
      src: "assets/img/Sapling/256.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/256.jpeg",
    },
    {
      src: "assets/img/Sapling/257.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/257.jpeg",
    },
    {
      src: "assets/img/Sapling/258.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/258.jpeg",
    },
    {
      src: "assets/img/Sapling/259.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/259.jpeg",
    },
    {
      src: "assets/img/Sapling/260.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/260.jpeg",
    },
    {
      src: "assets/img/Sapling/242.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/242.jpeg",
    },
    {
      src: "assets/img/Sapling/243.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/243.jpeg",
    },
    {
      src: "assets/img/Sapling/244.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/244.jpeg",
    },
    {
      src: "assets/img/Sapling/245.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/245.jpeg",
    },
    {
      src: "assets/img/Sapling/246.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/246.jpeg",
    },
    {
      src: "assets/img/Sapling/241.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/241.jpeg",
    },
    {
      src: "assets/img/Sapling/240.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/240.jpeg",
    },
    {
      src: "assets/img/Sapling/236.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/236.jpeg",
    },
    {
      src: "assets/img/Sapling/237.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/237.jpeg",
    },
    {
      src: "assets/img/Sapling/238.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/238.jpeg",
    },
    {
      src: "assets/img/Sapling/239.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/239.jpeg",
    },
    {
      src: "assets/img/Sapling/219.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/219.jpeg",
    },
    {
      src: "assets/img/Sapling/220.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/220.jpeg",
    },
    {
      src: "assets/img/Sapling/221.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/221.jpeg",
    },
    {
      src: "assets/img/Sapling/222.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/222.jpeg",
    },
    {
      src: "assets/img/Sapling/223.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/223.jpeg",
    },
    {
      src: "assets/img/Sapling/224.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/224.jpeg",
    },
    {
      src: "assets/img/Sapling/225.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/225.jpeg",
    },
    {
      src: "assets/img/Sapling/226.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/226.jpeg",
    },
    {
      src: "assets/img/Sapling/227.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/227.jpeg",
    },
    {
      src: "assets/img/Sapling/228.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/228.jpeg",
    },
    {
      src: "assets/img/Sapling/229.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/229.jpeg",
    },
    {
      src: "assets/img/Sapling/230.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/230.jpeg",
    },
    {
      src: "assets/img/Sapling/231.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/231.jpeg",
    },
    {
      src: "assets/img/Sapling/232.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/232.jpeg",
    },
    {
      src: "assets/img/Sapling/233.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/233.jpeg",
    },
    {
      src: "assets/img/Sapling/234.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/234.jpeg",
    },
    {
      src: "assets/img/Sapling/235.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/235.jpeg",
    },
    {
      src: "assets/img/Sapling/215.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/215.jpeg",
    },
    {
      src: "assets/img/Sapling/216.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/216.jpeg",
    },
    {
      src: "assets/img/Sapling/217.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/217.jpeg",
    },
    {
      src: "assets/img/Sapling/218.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/218.jpeg",
    },
    {
      src: "assets/img/Sapling/198.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/198.jpeg",
    },
    {
      src: "assets/img/Sapling/199.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/199.jpeg",
    },
    {
      src: "assets/img/Sapling/200.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/200.jpeg",
    },
    {
      src: "assets/img/Sapling/201.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/201.jpeg",
    },
    {
      src: "assets/img/Sapling/202.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/202.jpeg",
    },
    {
      src: "assets/img/Sapling/203.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/203.jpeg",
    },
    {
      src: "assets/img/Sapling/204.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/204.jpeg",
    },
    {
      src: "assets/img/Sapling/205.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/205.jpeg",
    },
    {
      src: "assets/img/Sapling/206.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/206.jpeg",
    },
    {
      src: "assets/img/Sapling/207.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/207.jpeg",
    },
    {
      src: "assets/img/Sapling/208.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/208.jpeg",
    },
    {
      src: "assets/img/Sapling/209.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/209.jpeg",
    },
    {
      src: "assets/img/Sapling/210.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/210.jpeg",
    },
    {
      src: "assets/img/Sapling/211.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/211.jpeg",
    },
    {
      src: "assets/img/Sapling/212.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/212.jpeg",
    },
    {
      src: "assets/img/Sapling/213.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/213.jpeg",
    },
    {
      src: "assets/img/Sapling/214.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/214.jpeg",
    },
    {
      src: "assets/img/Sapling/194.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/194.jpeg",
    },
    {
      src: "assets/img/Sapling/195.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/195.jpeg",
    },
    {
      src: "assets/img/Sapling/196.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/196.jpeg",
    },
    {
      src: "assets/img/Sapling/197.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/197.jpeg",
    },
    {
      src: "assets/img/Sapling/192.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/192.jpeg",
    },
    {
      src: "assets/img/Sapling/193.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/193.jpeg",
    },
    {
      src: "assets/img/Sapling/184.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/184.jpeg",
    },
    {
      src: "assets/img/Sapling/185.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/185.jpeg",
    },
    {
      src: "assets/img/Sapling/186.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/186.jpeg",
    },
    {
      src: "assets/img/Sapling/187.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/187.jpeg",
    },
    {
      src: "assets/img/Sapling/188.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/188.jpeg",
    },
    {
      src: "assets/img/Sapling/189.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/189.jpeg",
    },
    {
      src: "assets/img/Sapling/190.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/190.jpeg",
    },
    {
      src: "assets/img/Sapling/191.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/191.jpeg",
    },
    {
      src: "assets/img/Sapling/182.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/182.jpeg",
    },
    {
      src: "assets/img/Sapling/183.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/183.jpeg",
    },
    {
      src: "assets/img/Sapling/164.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/164.jpeg",
    },
    {
      src: "assets/img/Sapling/165.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/165.jpeg",
    },
    {
      src: "assets/img/Sapling/166.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/166.jpeg",
    },
    {
      src: "assets/img/Sapling/167.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/167.jpeg",
    },
    {
      src: "assets/img/Sapling/168.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/168.jpeg",
    },
    {
      src: "assets/img/Sapling/169.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/169.jpeg",
    },
    {
      src: "assets/img/Sapling/170.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/170.jpeg",
    },
    {
      src: "assets/img/Sapling/171.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/171.jpeg",
    },
    {
      src: "assets/img/Sapling/172.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/172.jpeg",
    },
    {
      src: "assets/img/Sapling/173.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/173.jpeg",
    },
    {
      src: "assets/img/Sapling/174.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/174.jpeg",
    },
    {
      src: "assets/img/Sapling/175.jpeg",
      caption: "",
      thumb: "assets/img/Sapling/175.jpeg",
    },
    {
      src: "assets/img/harithakam/119.jpg",
      caption:
        "കാഞ്ഞിരംകുളം മൗണ്ട് കാർമലിൽ കരുതലോടെ നിംസിന്റെ ഹരിതകം പദ്ധതിയ്ക്ക് തുടക്കം  കുറിച്ചു. സ്കൂൾ സീനിയർ പ്രിൻസിപ്പൽ ലഹിത സുരേഷിന് നിംസ് എച്ച് ആർ മാനേജർ ജെസ്സി വൃക്ഷ തൈ കൈമാറുന്നു",
      thumb: "assets/img/harithakam/119.jpg",
    },
    {
      src: "assets/img/harithakam/118.jpeg",
      caption:
        "HARITHAKAM 2024-  Buds school for disabled students in vilapil panchath.",
      thumb: "assets/img/harithakam/118.jpeg",
    },
    {
      src: "assets/img/harithakam/116.jpeg",
      caption:
        "HARITHAKAM 2024-  Buds school for disabled students in vilapil panchath.",
      thumb: "assets/img/harithakam/116.jpeg",
    },
    {
      src: "assets/img/harithakam/117.jpeg",
      caption:
        "HARITHAKAM 2024-  Buds school for disabled students in vilapil panchath.",
      thumb: "assets/img/harithakam/117.jpeg",
    },
    {
      src: "assets/img/harithakam/113.jpeg",
      caption:
        "Love our nature with us To welcome the new year, the NIMS family begins by giving a new life to nature.  The 2024 HARITHAKAM project starts today in vilapil panchayath with the presence of President Mrs.Lilly,Vice President mr. Shaji and panchayat members Mrs. Bindhu, Mrs.florence sarojam, mrs,.sajitha (kavinpuram ward) mr. Aneesh (karode ward). NIMS family, Wishing everyone a very happy and healthy New Year.",
      thumb: "assets/img/harithakam/113.jpeg",
    },
    {
      src: "assets/img/harithakam/114.jpeg",
      caption:
        "Love our nature with us To welcome the new year, the NIMS family begins by giving a new life to nature.  The 2024 HARITHAKAM project starts today in vilapil panchayath with the presence of President Mrs.Lilly,Vice President mr. Shaji and panchayat members Mrs. Bindhu, Mrs.florence sarojam, mrs,.sajitha (kavinpuram ward) mr. Aneesh (karode ward). NIMS family, Wishing everyone a very happy and healthy New Year.",
      thumb: "assets/img/harithakam/114.jpeg",
    },
    {
      src: "assets/img/harithakam/115.jpeg",
      caption:
        "Love our nature with us To welcome the new year, the NIMS family begins by giving a new life to nature.  The 2024 HARITHAKAM project starts today in vilapil panchayath with the presence of President Mrs.Lilly,Vice President mr. Shaji and panchayat members Mrs. Bindhu, Mrs.florence sarojam, mrs,.sajitha (kavinpuram ward) mr. Aneesh (karode ward). NIMS family, Wishing everyone a very happy and healthy New Year.",
      thumb: "assets/img/harithakam/115.jpeg",
    },
    {
      src: "assets/img/harithakam/110.jpeg",
      caption:
        "നിംസ് ഹരിതകം പദ്ധതിയുടെ ഭാഗമായി നിംസ് മെഡിസിറ്റി അങ്കണത്തിൽ വൃക്ഷതൈ നട്ടുപിടിപ്പിച്ചു.ഒരു ലക്ഷം വൃക്ഷ തൈകൾ എന്ന ബ്രഹത്തായ ആശയം ഇന്നും ഞങ്ങൾ പിന്തുടർന്ന് പോകുന്നു.. നമ്മോടൊപ്പം നമ്മുടെ പ്രകൃതിയെയും സ്നേഹിക്കുക പുതുവർഷത്തെ വരവേൽക്കാൻ നിംസ് കുടുംബം ഒരു പുതു ജീവൻ പ്രകൃതിക്കു സമ്മാനിച്ചുകൊണ്ട് തുടക്കം കുറിക്കുന്നു. നിംസ് ജനറൽ മെഡിസിൻ ഡോ ശ്രീ ജിം ലിറ്റൺ നിംസ് കുടുംബത്തിന് വേണ്ടി വൃക്ഷ തൈ നട്ടുപിടിപ്പിച്ചു..ഏവർക്കും ആരോഗ്യപൂർണ്ണമായ പുതുവത്സാരാശംസകൾ നേരുന്നു.",
      thumb: "assets/img/harithakam/110.jpeg",
    },
    {
      src: "assets/img/harithakam/111.jpeg",
      caption:
        "നിംസ് ഹരിതകം പദ്ധതിയുടെ ഭാഗമായി നിംസ് മെഡിസിറ്റി അങ്കണത്തിൽ വൃക്ഷതൈ നട്ടുപിടിപ്പിച്ചു.ഒരു ലക്ഷം വൃക്ഷ തൈകൾ എന്ന ബ്രഹത്തായ ആശയം ഇന്നും ഞങ്ങൾ പിന്തുടർന്ന് പോകുന്നു.. നമ്മോടൊപ്പം നമ്മുടെ പ്രകൃതിയെയും സ്നേഹിക്കുക പുതുവർഷത്തെ വരവേൽക്കാൻ നിംസ് കുടുംബം ഒരു പുതു ജീവൻ പ്രകൃതിക്കു സമ്മാനിച്ചുകൊണ്ട് തുടക്കം കുറിക്കുന്നു. നിംസ് ജനറൽ മെഡിസിൻ ഡോ ശ്രീ ജിം ലിറ്റൺ നിംസ് കുടുംബത്തിന് വേണ്ടി വൃക്ഷ തൈ നട്ടുപിടിപ്പിച്ചു..ഏവർക്കും ആരോഗ്യപൂർണ്ണമായ പുതുവത്സാരാശംസകൾ നേരുന്നു.",
      thumb: "assets/img/harithakam/111.jpeg",
    },
    {
      src: "assets/img/harithakam/112.jpeg",
      caption:
        "നിംസ് ഹരിതകം പദ്ധതിയുടെ ഭാഗമായി നിംസ് മെഡിസിറ്റി അങ്കണത്തിൽ വൃക്ഷതൈ നട്ടുപിടിപ്പിച്ചു.ഒരു ലക്ഷം വൃക്ഷ തൈകൾ എന്ന ബ്രഹത്തായ ആശയം ഇന്നും ഞങ്ങൾ പിന്തുടർന്ന് പോകുന്നു.. നമ്മോടൊപ്പം നമ്മുടെ പ്രകൃതിയെയും സ്നേഹിക്കുക പുതുവർഷത്തെ വരവേൽക്കാൻ നിംസ് കുടുംബം ഒരു പുതു ജീവൻ പ്രകൃതിക്കു സമ്മാനിച്ചുകൊണ്ട് തുടക്കം കുറിക്കുന്നു. നിംസ് ജനറൽ മെഡിസിൻ ഡോ ശ്രീ ജിം ലിറ്റൺ നിംസ് കുടുംബത്തിന് വേണ്ടി വൃക്ഷ തൈ നട്ടുപിടിപ്പിച്ചു..ഏവർക്കും ആരോഗ്യപൂർണ്ണമായ പുതുവത്സാരാശംസകൾ നേരുന്നു.",
      thumb: "assets/img/harithakam/112.jpeg",
    },
    {
      src: "assets/img/harithakam/108.jpeg",
      caption: "",
      thumb: "assets/img/harithakam/108.jpeg",
    },
    {
      src: "assets/img/harithakam/109.jpeg",
      caption: "",
      thumb: "assets/img/harithakam/109.jpeg",
    },
    {
      src: "assets/img/harithakam/105.jpeg",
      caption: "",
      thumb: "assets/img/harithakam/105.jpeg",
    },
    {
      src: "assets/img/harithakam/106.jpeg",
      caption: "",
      thumb: "assets/img/harithakam/106.jpeg",
    },
    {
      src: "assets/img/harithakam/107.jpeg",
      caption: "",
      thumb: "assets/img/harithakam/107.jpeg",
    },
    {
      src: "assets/img/harithakam/98.jpg",
      caption:
        "ഖാദിയുടെ നൂറാം വാർഷികം പ്രമാണിച്ചു നിംസ് മെഡിസിറ്റിയിൽ കേന്ദ്ര വിദേശകാര്യ സഹമന്ത്രി ശ്രീ വി മുരളീധരൻ ഫലവൃക്ഷ തൈ നടുന്നു.. ഒരു ലക്ഷം ഫലവൃക്ഷതൈകൾ എന്ന നിംസ് ഹരിതകം പദ്ധതിയുടെ ഭാഗമായിട്ടാണ് വൃക്ഷതൈ നട്ടത്.....",
      thumb: "assets/img/harithakam/98.jpg",
    },
    {
      src: "assets/img/harithakam/99.jpg",
      caption:
        "ഖാദിയുടെ നൂറാം വാർഷികം പ്രമാണിച്ചു നിംസ് മെഡിസിറ്റിയിൽ കേന്ദ്ര വിദേശകാര്യ സഹമന്ത്രി ശ്രീ വി മുരളീധരൻ ഫലവൃക്ഷ തൈ നടുന്നു.. ഒരു ലക്ഷം ഫലവൃക്ഷതൈകൾ എന്ന നിംസ് ഹരിതകം പദ്ധതിയുടെ ഭാഗമായിട്ടാണ് വൃക്ഷതൈ നട്ടത്.....",
      thumb: "assets/img/harithakam/99.jpg",
    },
    {
      src: "assets/img/harithakam/100.jpg",
      caption:
        "ഖാദിയുടെ നൂറാം വാർഷികം പ്രമാണിച്ചു നിംസ് മെഡിസിറ്റിയിൽ കേന്ദ്ര വിദേശകാര്യ സഹമന്ത്രി ശ്രീ വി മുരളീധരൻ ഫലവൃക്ഷ തൈ നടുന്നു.. ഒരു ലക്ഷം ഫലവൃക്ഷതൈകൾ എന്ന നിംസ് ഹരിതകം പദ്ധതിയുടെ ഭാഗമായിട്ടാണ് വൃക്ഷതൈ നട്ടത്.....",
      thumb: "assets/img/harithakam/100.jpg",
    },
    {
      src: "assets/img/harithakam/101.jpg",
      caption:
        "ഖാദിയുടെ നൂറാം വാർഷികം പ്രമാണിച്ചു നിംസ് മെഡിസിറ്റിയിൽ കേന്ദ്ര വിദേശകാര്യ സഹമന്ത്രി ശ്രീ വി മുരളീധരൻ ഫലവൃക്ഷ തൈ നടുന്നു.. ഒരു ലക്ഷം ഫലവൃക്ഷതൈകൾ എന്ന നിംസ് ഹരിതകം പദ്ധതിയുടെ ഭാഗമായിട്ടാണ് വൃക്ഷതൈ നട്ടത്.....",
      thumb: "assets/img/harithakam/101.jpg",
    },
    {
      src: "assets/img/harithakam/102.jpg",
      caption:
        "ഖാദിയുടെ നൂറാം വാർഷികം പ്രമാണിച്ചു നിംസ് മെഡിസിറ്റിയിൽ കേന്ദ്ര വിദേശകാര്യ സഹമന്ത്രി ശ്രീ വി മുരളീധരൻ ഫലവൃക്ഷ തൈ നടുന്നു.. ഒരു ലക്ഷം ഫലവൃക്ഷതൈകൾ എന്ന നിംസ് ഹരിതകം പദ്ധതിയുടെ ഭാഗമായിട്ടാണ് വൃക്ഷതൈ നട്ടത്.....",
      thumb: "assets/img/harithakam/102.jpg",
    },
    {
      src: "assets/img/harithakam/103.jpg",
      caption:
        "ഖാദിയുടെ നൂറാം വാർഷികം പ്രമാണിച്ചു നിംസ് മെഡിസിറ്റിയിൽ കേന്ദ്ര വിദേശകാര്യ സഹമന്ത്രി ശ്രീ വി മുരളീധരൻ ഫലവൃക്ഷ തൈ നടുന്നു.. ഒരു ലക്ഷം ഫലവൃക്ഷതൈകൾ എന്ന നിംസ് ഹരിതകം പദ്ധതിയുടെ ഭാഗമായിട്ടാണ് വൃക്ഷതൈ നട്ടത്.....",
      thumb: "assets/img/harithakam/103.jpg",
    },
    {
      src: "assets/img/harithakam/104.jpg",
      caption:
        "ഖാദിയുടെ നൂറാം വാർഷികം പ്രമാണിച്ചു നിംസ് മെഡിസിറ്റിയിൽ കേന്ദ്ര വിദേശകാര്യ സഹമന്ത്രി ശ്രീ വി മുരളീധരൻ ഫലവൃക്ഷ തൈ നടുന്നു.. ഒരു ലക്ഷം ഫലവൃക്ഷതൈകൾ എന്ന നിംസ് ഹരിതകം പദ്ധതിയുടെ ഭാഗമായിട്ടാണ് വൃക്ഷതൈ നട്ടത്.....",
      thumb: "assets/img/harithakam/104.jpg",
    },
    {
      src: "assets/img/harithakam/93.jpg",
      caption:
        "NIMS Harithakam joined hands with Kerala Koumudhi in commemorating  the World environmental Day-2018 at Aruvippuram Shivagiri Sri Narayana Public School on 05-06-2018. Mr M.S Faizal Khan, Managing Director of NIMS Medicity distributed the tree saplings to the students of various schools in an around the District.  He also planted saplings in the bank of river Neyyar at Aruvippuram along with Swami Sandrananda, General Secretary of Varkkala Sivagiri Dharma Sangham,   Padma Shri P. Gopinathan Nair, Chairman of Gandhi Smarak Nidhi and students.",
      thumb: "assets/img/harithakam/93.jpg",
    },
    {
      src: "assets/img/harithakam/94.jpg",
      caption:
        "NIMS Harithakam joined hands with Kerala Koumudhi in commemorating  the World environmental Day-2018 at Aruvippuram Shivagiri Sri Narayana Public School on 05-06-2018. Mr M.S Faizal Khan, Managing Director of NIMS Medicity distributed the tree saplings to the students of various schools in an around the District.  He also planted saplings in the bank of river Neyyar at Aruvippuram along with Swami Sandrananda, General Secretary of Varkkala Sivagiri Dharma Sangham,   Padma Shri P. Gopinathan Nair, Chairman of Gandhi Smarak Nidhi and students.",
      thumb: "assets/img/harithakam/94.jpg",
    },
    {
      src: "assets/img/harithakam/95.jpg",
      caption:
        "NIMS Harithakam joined hands with Kerala Koumudhi in commemorating  the World environmental Day-2018 at Aruvippuram Shivagiri Sri Narayana Public School on 05-06-2018. Mr M.S Faizal Khan, Managing Director of NIMS Medicity distributed the tree saplings to the students of various schools in an around the District.  He also planted saplings in the bank of river Neyyar at Aruvippuram along with Swami Sandrananda, General Secretary of Varkkala Sivagiri Dharma Sangham,   Padma Shri P. Gopinathan Nair, Chairman of Gandhi Smarak Nidhi and students.",
      thumb: "assets/img/harithakam/95.jpg",
    },
    {
      src: "assets/img/harithakam/96.jpg",
      caption:
        "NIMS Harithakam joined hands with Kerala Koumudhi in commemorating  the World environmental Day-2018 at Aruvippuram Shivagiri Sri Narayana Public School on 05-06-2018. Mr M.S Faizal Khan, Managing Director of NIMS Medicity distributed the tree saplings to the students of various schools in an around the District.  He also planted saplings in the bank of river Neyyar at Aruvippuram along with Swami Sandrananda, General Secretary of Varkkala Sivagiri Dharma Sangham,   Padma Shri P. Gopinathan Nair, Chairman of Gandhi Smarak Nidhi and students.",
      thumb: "assets/img/harithakam/96.jpg",
    },
    {
      src: "assets/img/harithakam/97.jpg",
      caption:
        "NIMS Harithakam joined hands with Kerala Koumudhi in commemorating  the World environmental Day-2018 at Aruvippuram Shivagiri Sri Narayana Public School on 05-06-2018. Mr M.S Faizal Khan, Managing Director of NIMS Medicity distributed the tree saplings to the students of various schools in an around the District.  He also planted saplings in the bank of river Neyyar at Aruvippuram along with Swami Sandrananda, General Secretary of Varkkala Sivagiri Dharma Sangham,   Padma Shri P. Gopinathan Nair, Chairman of Gandhi Smarak Nidhi and students.",
      thumb: "assets/img/harithakam/97.jpg",
    },
    {
      src: "assets/img/harithakam/88.jpeg",
      caption: "",
      thumb: "assets/img/harithakam/88.jpeg",
    },
    {
      src: "assets/img/harithakam/89.jpeg",
      caption: "",
      thumb: "assets/img/harithakam/89.jpeg",
    },
    {
      src: "assets/img/harithakam/90.jpeg",
      caption: "",
      thumb: "assets/img/harithakam/90.jpeg",
    },
    {
      src: "assets/img/harithakam/91.jpeg",
      caption: "",
      thumb: "assets/img/harithakam/91.jpeg",
    },
    {
      src: "assets/img/harithakam/92.jpeg",
      caption: "",
      thumb: "assets/img/harithakam/92.jpeg",
    },
    {
      src: "assets/img/harithakam/79.jpg",
      caption:
        "On occasion of World Environmental Health Day (September 26th), NICDS YRC STUDENTS organized planting medicinal plants around our college campus and hostel. Programme was inaugurated  by Dr Sadique Hussain, Principal, NICDS. Various medicinal plants like neem, tulasi and pomegranate were planted by YRC STUDENTS.",
      thumb: "assets/img/harithakam/79.jpg",
    },
    {
      src: "assets/img/harithakam/80.jpg",
      caption:
        "On occasion of World Environmental Health Day (September 26th), NICDS YRC STUDENTS organized planting medicinal plants around our college campus and hostel. Programme was inaugurated  by Dr Sadique Hussain, Principal, NICDS. Various medicinal plants like neem, tulasi and pomegranate were planted by YRC STUDENTS.",
      thumb: "assets/img/harithakam/80.jpg",
    },
    {
      src: "assets/img/harithakam/81.jpg",
      caption:
        "On occasion of World Environmental Health Day (September 26th), NICDS YRC STUDENTS organized planting medicinal plants around our college campus and hostel. Programme was inaugurated  by Dr Sadique Hussain, Principal, NICDS. Various medicinal plants like neem, tulasi and pomegranate were planted by YRC STUDENTS.",
      thumb: "assets/img/harithakam/81.jpg",
    },
    {
      src: "assets/img/harithakam/82.jpg",
      caption:
        "On occasion of World Environmental Health Day (September 26th), NICDS YRC STUDENTS organized planting medicinal plants around our college campus and hostel. Programme was inaugurated  by Dr Sadique Hussain, Principal, NICDS. Various medicinal plants like neem, tulasi and pomegranate were planted by YRC STUDENTS.",
      thumb: "assets/img/harithakam/82.jpg",
    },
    {
      src: "assets/img/harithakam/83.jpg",
      caption:
        "On occasion of World Environmental Health Day (September 26th), NICDS YRC STUDENTS organized planting medicinal plants around our college campus and hostel. Programme was inaugurated  by Dr Sadique Hussain, Principal, NICDS. Various medicinal plants like neem, tulasi and pomegranate were planted by YRC STUDENTS.",
      thumb: "assets/img/harithakam/83.jpg",
    },
    {
      src: "assets/img/harithakam/84.jpg",
      caption:
        "On occasion of World Environmental Health Day (September 26th), NICDS YRC STUDENTS organized planting medicinal plants around our college campus and hostel. Programme was inaugurated  by Dr Sadique Hussain, Principal, NICDS. Various medicinal plants like neem, tulasi and pomegranate were planted by YRC STUDENTS.",
      thumb: "assets/img/harithakam/84.jpg",
    },
    {
      src: "assets/img/harithakam/85.jpg",
      caption:
        "On occasion of World Environmental Health Day (September 26th), NICDS YRC STUDENTS organized planting medicinal plants around our college campus and hostel. Programme was inaugurated  by Dr Sadique Hussain, Principal, NICDS. Various medicinal plants like neem, tulasi and pomegranate were planted by YRC STUDENTS.",
      thumb: "assets/img/harithakam/85.jpg",
    },
    {
      src: "assets/img/harithakam/86.jpg",
      caption:
        "On occasion of World Environmental Health Day (September 26th), NICDS YRC STUDENTS organized planting medicinal plants around our college campus and hostel. Programme was inaugurated  by Dr Sadique Hussain, Principal, NICDS. Various medicinal plants like neem, tulasi and pomegranate were planted by YRC STUDENTS.",
      thumb: "assets/img/harithakam/86.jpg",
    },
    {
      src: "assets/img/harithakam/87.jpg",
      caption:
        "On occasion of World Environmental Health Day (September 26th), NICDS YRC STUDENTS organized planting medicinal plants around our college campus and hostel. Programme was inaugurated  by Dr Sadique Hussain, Principal, NICDS. Various medicinal plants like neem, tulasi and pomegranate were planted by YRC STUDENTS.",
      thumb: "assets/img/harithakam/87.jpg",
    },

    {
      src: "assets/img/harithakam/58.jpg",
      caption:
        "ഇന്ന് ഭൗമദിനത്തോടനുബന്ധിച്ചു മുള്ളറവിള വാർഡിൽ കല്ലുപ്പാലം പ്രദേശത്ത് നെയ്യാറ്റിൻകര ആരോഗ്യ സ്റ്റാൻഡിങ് കമ്മിറ്റി ചെയർമാൻ ശ്രീ ജോസ് ഫ്രാങ്ക്‌ളിൻ വൃക്ഷതൈ നട്ട് ഉദ്ഘാടനം നിർവഹിച്ചു.",
      thumb: "assets/img/harithakam/58.jpg",
    },
    {
      src: "assets/img/harithakam/59.jpg",
      caption:
        "ഇന്ന് ഭൗമദിനത്തോടനുബന്ധിച്ചു മുള്ളറവിള വാർഡിൽ കല്ലുപ്പാലം പ്രദേശത്ത് നെയ്യാറ്റിൻകര ആരോഗ്യ സ്റ്റാൻഡിങ് കമ്മിറ്റി ചെയർമാൻ ശ്രീ ജോസ് ഫ്രാങ്ക്‌ളിൻ വൃക്ഷതൈ നട്ട് ഉദ്ഘാടനം നിർവഹിച്ചു.",
      thumb: "assets/img/harithakam/59.jpg",
    },
    {
      src: "assets/img/harithakam/60.jpg",
      caption:
        "ഇന്ന് ഭൗമദിനത്തോടനുബന്ധിച്ചു മുള്ളറവിള വാർഡിൽ കല്ലുപ്പാലം പ്രദേശത്ത് നെയ്യാറ്റിൻകര ആരോഗ്യ സ്റ്റാൻഡിങ് കമ്മിറ്റി ചെയർമാൻ ശ്രീ ജോസ് ഫ്രാങ്ക്‌ളിൻ വൃക്ഷതൈ നട്ട് ഉദ്ഘാടനം നിർവഹിച്ചു.",
      thumb: "assets/img/harithakam/60.jpg",
    },
    {
      src: "assets/img/harithakam/61.jpg",
      caption:
        "ഇന്ന് ഭൗമദിനത്തോടനുബന്ധിച്ചുളള ചടങ്ങിൽ അധ്യക്ഷത വഹിച്ച്‌ വാർഡ് കൗൺസിലർ ശ്രീമതി ഷീബ സജു , ശ്രീ സജു മുൻ കോൺസിലർ, നിംസ് ക്വാളിറ്റി ഓഫീസർ ശ്രീ സോനു, ചീഫ് PRO ശ്രീ അനൂപ്, HR മാനേജർ ശ്രീ അരുൺ, പ്രൊജക്റ്റ്‌ മാനേജർ ശ്രീ കിഷോർ, ഫെസിലിറ്റി മാനേജർ ശ്രീ ബിപിൻ, നിംസ് ഡെന്റൽ കോളേജ് സ്റ്റാഫ്‌ സുശാന്ത്, നിംസ് സപ്പോർട്ടിങ് സ്റ്റാഫുകൾ, നിംസ് ഡെന്റൽ കോളേജ് സ്റ്റുഡന്റസ് തുടങ്ങിയവർ പങ്കെടുത്തു.",
      thumb: "assets/img/harithakam/61.jpg",
    },
    {
      src: "assets/img/harithakam/62.jpg",
      caption:
        "ലോക ഭൗമ ദിനത്തോടനുബന്ധിച്ചു നിംസ് മെഡിസിറ്റിയുടെ ഹരിതകം പദ്ധതിയുടെ ഭാഗമായി നെയ്യാറ്റിൻകര നഗരസഭ ചെയർമാൻ ശ്രീ രാജ്‌മോഹൻ മുനിസിപ്പാലിറ്റി സ്റ്റേഡിയത്തിൽ ഫല വൃക്ഷ തൈ നട്ടുപിടിപ്പിച്ചു.",
      thumb: "assets/img/harithakam/62.jpg",
    },
    {
      src: "assets/img/harithakam/63.jpg",
      caption:
        "ലോക ഭൗമ ദിനത്തോടനുബന്ധിച്ചു നിംസ് മെഡിസിറ്റിയുടെ ഹരിതകം പദ്ധതിയുടെ ഭാഗമായി നെയ്യാറ്റിൻകര നഗരസഭ ചെയർമാൻ ശ്രീ രാജ്‌മോഹൻ മുനിസിപ്പാലിറ്റി സ്റ്റേഡിയത്തിൽ ഫല വൃക്ഷ തൈ നട്ടുപിടിപ്പിച്ചു.",
      thumb: "assets/img/harithakam/63.jpg",
    },
    {
      src: "assets/img/harithakam/64.jpg",
      caption:
        "ലോക ഭൗമ ദിനത്തോടനുബന്ധിച്ചു നിംസ് മെഡിസിറ്റിയുടെ ഹരിതകം പദ്ധതിയുടെ ഭാഗമായി നെയ്യാറ്റിൻകര നഗരസഭ ചെയർമാൻ ശ്രീ രാജ്‌മോഹൻ മുനിസിപ്പാലിറ്റി സ്റ്റേഡിയത്തിൽ ഫല വൃക്ഷ തൈ നട്ടുപിടിപ്പിച്ചു.",
      thumb: "assets/img/harithakam/64.jpg",
    },
    {
      src: "assets/img/harithakam/65.jpg",
      caption:
        "ലോക ഭൗമ ദിനത്തോടനുബന്ധിച്ചു നിംസ് മെഡിസിറ്റിയുടെ ഹരിതകം പദ്ധതിയുടെ ഭാഗമായി നെയ്യാറ്റിൻകര നഗരസഭ ചെയർമാൻ ശ്രീ രാജ്‌മോഹൻ മുനിസിപ്പാലിറ്റി സ്റ്റേഡിയത്തിൽ ഫല വൃക്ഷ തൈ നട്ടുപിടിപ്പിച്ചു.",
      thumb: "assets/img/harithakam/65.jpg",
    },
    {
      src: "assets/img/harithakam/66.jpg",
      caption:
        "ലോക ഭൗമ ദിനത്തോടനുബന്ധിച്ചു നിംസ് മെഡിസിറ്റിയുടെ ഹരിതകം പദ്ധതിയുടെ ഭാഗമായി നെയ്യാറ്റിൻകര നഗരസഭ ചെയർമാൻ ശ്രീ രാജ്‌മോഹൻ മുനിസിപ്പാലിറ്റി സ്റ്റേഡിയത്തിൽ ഫല വൃക്ഷ തൈ നട്ടുപിടിപ്പിച്ചു.",
      thumb: "assets/img/harithakam/66.jpg",
    },
    {
      src: "assets/img/harithakam/67.jpg",
      caption:
        "ലോക ഭൗമ ദിനത്തോടനുബന്ധിച്ചു നിംസ് മെഡിസിറ്റിയുടെ ഹരിതകം പദ്ധതിയുടെ ഭാഗമായി നെയ്യാറ്റിൻകര നഗരസഭ ചെയർമാൻ ശ്രീ രാജ്‌മോഹൻ മുനിസിപ്പാലിറ്റി സ്റ്റേഡിയത്തിൽ ഫല വൃക്ഷ തൈ നട്ടുപിടിപ്പിച്ചു.",
      thumb: "assets/img/harithakam/67.jpg",
    },
    {
      src: "assets/img/harithakam/68.jpg",
      caption:
        "ലോക ഭൗമ ദിനത്തോടനുബന്ധിച്ചു നിംസ് മെഡിസിറ്റിയുടെ ഹരിതകം പദ്ധതിയുടെ ഭാഗമായി നെയ്യാറ്റിൻകര നഗരസഭ ചെയർമാൻ ശ്രീ രാജ്‌മോഹൻ മുനിസിപ്പാലിറ്റി സ്റ്റേഡിയത്തിൽ ഫല വൃക്ഷ തൈ നട്ടുപിടിപ്പിച്ചു.",
      thumb: "assets/img/harithakam/68.jpg",
    },
    {
      src: "assets/img/harithakam/69.jpg",
      caption:
        "എക്സ്ട്രാ കരിക്കുലർ ആക്റ്റീവ്റ്റീസിലും മുൻകൈ എടുത്തു കഴിവുകൾ തെളിയിക്കുന്ന നിംസ് നഴ്സിംഗ് വിദ്യാർഥികൾ ഭൗമിക ദിനത്തോടനുബന്ധിച്ചു നിംസ് മെഡിസിറ്റിയിൽ ഗ്രീൻ എനർജി കോൺസർവേഷൻ അവാർനെസ്സ് പ്രോഗ്രാം നടത്തി ഇൻവെസ്റ്റ്‌ ഇൻ ഔർ പ്ലാനറ്റ് എന്ന ഇ വർഷത്തെ ഭൗമിക ദിന തീം ആസ്പദമാക്കിയായിരുന്നു പ്രോഗ്രാം...",
      thumb: "assets/img/harithakam/69.jpg",
    },
    {
      src: "assets/img/harithakam/70.jpg",
      caption:
        "എക്സ്ട്രാ കരിക്കുലർ ആക്റ്റീവ്റ്റീസിലും മുൻകൈ എടുത്തു കഴിവുകൾ തെളിയിക്കുന്ന നിംസ് നഴ്സിംഗ് വിദ്യാർഥികൾ ഭൗമിക ദിനത്തോടനുബന്ധിച്ചു നിംസ് മെഡിസിറ്റിയിൽ ഗ്രീൻ എനർജി കോൺസർവേഷൻ അവാർനെസ്സ് പ്രോഗ്രാം നടത്തി ഇൻവെസ്റ്റ്‌ ഇൻ ഔർ പ്ലാനറ്റ് എന്ന ഇ വർഷത്തെ ഭൗമിക ദിന തീം ആസ്പദമാക്കിയായിരുന്നു പ്രോഗ്രാം...",
      thumb: "assets/img/harithakam/70.jpg",
    },
    {
      src: "assets/img/harithakam/71.jpg",
      caption:
        "എക്സ്ട്രാ കരിക്കുലർ ആക്റ്റീവ്റ്റീസിലും മുൻകൈ എടുത്തു കഴിവുകൾ തെളിയിക്കുന്ന നിംസ് നഴ്സിംഗ് വിദ്യാർഥികൾ ഭൗമിക ദിനത്തോടനുബന്ധിച്ചു നിംസ് മെഡിസിറ്റിയിൽ ഗ്രീൻ എനർജി കോൺസർവേഷൻ അവാർനെസ്സ് പ്രോഗ്രാം നടത്തി ഇൻവെസ്റ്റ്‌ ഇൻ ഔർ പ്ലാനറ്റ് എന്ന ഇ വർഷത്തെ ഭൗമിക ദിന തീം ആസ്പദമാക്കിയായിരുന്നു പ്രോഗ്രാം...",
      thumb: "assets/img/harithakam/71.jpg",
    },
    {
      src: "assets/img/harithakam/72.jpg",
      caption:
        "എക്സ്ട്രാ കരിക്കുലർ ആക്റ്റീവ്റ്റീസിലും മുൻകൈ എടുത്തു കഴിവുകൾ തെളിയിക്കുന്ന നിംസ് നഴ്സിംഗ് വിദ്യാർഥികൾ ഭൗമിക ദിനത്തോടനുബന്ധിച്ചു നിംസ് മെഡിസിറ്റിയിൽ ഗ്രീൻ എനർജി കോൺസർവേഷൻ അവാർനെസ്സ് പ്രോഗ്രാം നടത്തി ഇൻവെസ്റ്റ്‌ ഇൻ ഔർ പ്ലാനറ്റ് എന്ന ഇ വർഷത്തെ ഭൗമിക ദിന തീം ആസ്പദമാക്കിയായിരുന്നു പ്രോഗ്രാം...",
      thumb: "assets/img/harithakam/72.jpg",
    },
    {
      src: "assets/img/harithakam/73.jpg",
      caption:
        "എക്സ്ട്രാ കരിക്കുലർ ആക്റ്റീവ്റ്റീസിലും മുൻകൈ എടുത്തു കഴിവുകൾ തെളിയിക്കുന്ന നിംസ് നഴ്സിംഗ് വിദ്യാർഥികൾ ഭൗമിക ദിനത്തോടനുബന്ധിച്ചു നിംസ് മെഡിസിറ്റിയിൽ ഗ്രീൻ എനർജി കോൺസർവേഷൻ അവാർനെസ്സ് പ്രോഗ്രാം നടത്തി ഇൻവെസ്റ്റ്‌ ഇൻ ഔർ പ്ലാനറ്റ് എന്ന ഇ വർഷത്തെ ഭൗമിക ദിന തീം ആസ്പദമാക്കിയായിരുന്നു പ്രോഗ്രാം...",
      thumb: "assets/img/harithakam/73.jpg",
    },
    {
      src: "assets/img/harithakam/74.jpg",
      caption:
        "എക്സ്ട്രാ കരിക്കുലർ ആക്റ്റീവ്റ്റീസിലും മുൻകൈ എടുത്തു കഴിവുകൾ തെളിയിക്കുന്ന നിംസ് നഴ്സിംഗ് വിദ്യാർഥികൾ ഭൗമിക ദിനത്തോടനുബന്ധിച്ചു നിംസ് മെഡിസിറ്റിയിൽ ഗ്രീൻ എനർജി കോൺസർവേഷൻ അവാർനെസ്സ് പ്രോഗ്രാം നടത്തി ഇൻവെസ്റ്റ്‌ ഇൻ ഔർ പ്ലാനറ്റ് എന്ന ഇ വർഷത്തെ ഭൗമിക ദിന തീം ആസ്പദമാക്കിയായിരുന്നു പ്രോഗ്രാം...",
      thumb: "assets/img/harithakam/74.jpg",
    },
    {
      src: "assets/img/harithakam/75.jpg",
      caption:
        "എക്സ്ട്രാ കരിക്കുലർ ആക്റ്റീവ്റ്റീസിലും മുൻകൈ എടുത്തു കഴിവുകൾ തെളിയിക്കുന്ന നിംസ് നഴ്സിംഗ് വിദ്യാർഥികൾ ഭൗമിക ദിനത്തോടനുബന്ധിച്ചു നിംസ് മെഡിസിറ്റിയിൽ ഗ്രീൻ എനർജി കോൺസർവേഷൻ അവാർനെസ്സ് പ്രോഗ്രാം നടത്തി ഇൻവെസ്റ്റ്‌ ഇൻ ഔർ പ്ലാനറ്റ് എന്ന ഇ വർഷത്തെ ഭൗമിക ദിന തീം ആസ്പദമാക്കിയായിരുന്നു പ്രോഗ്രാം...",
      thumb: "assets/img/harithakam/75.jpg",
    },
    {
      src: "assets/img/harithakam/76.jpg",
      caption:
        "എക്സ്ട്രാ കരിക്കുലർ ആക്റ്റീവ്റ്റീസിലും മുൻകൈ എടുത്തു കഴിവുകൾ തെളിയിക്കുന്ന നിംസ് നഴ്സിംഗ് വിദ്യാർഥികൾ ഭൗമിക ദിനത്തോടനുബന്ധിച്ചു നിംസ് മെഡിസിറ്റിയിൽ ഗ്രീൻ എനർജി കോൺസർവേഷൻ അവാർനെസ്സ് പ്രോഗ്രാം നടത്തി ഇൻവെസ്റ്റ്‌ ഇൻ ഔർ പ്ലാനറ്റ് എന്ന ഇ വർഷത്തെ ഭൗമിക ദിന തീം ആസ്പദമാക്കിയായിരുന്നു പ്രോഗ്രാം...",
      thumb: "assets/img/harithakam/76.jpg",
    },
    {
      src: "assets/img/harithakam/77.jpg",
      caption:
        "എക്സ്ട്രാ കരിക്കുലർ ആക്റ്റീവ്റ്റീസിലും മുൻകൈ എടുത്തു കഴിവുകൾ തെളിയിക്കുന്ന നിംസ് നഴ്സിംഗ് വിദ്യാർഥികൾ ഭൗമിക ദിനത്തോടനുബന്ധിച്ചു നിംസ് മെഡിസിറ്റിയിൽ ഗ്രീൻ എനർജി കോൺസർവേഷൻ അവാർനെസ്സ് പ്രോഗ്രാം നടത്തി ഇൻവെസ്റ്റ്‌ ഇൻ ഔർ പ്ലാനറ്റ് എന്ന ഇ വർഷത്തെ ഭൗമിക ദിന തീം ആസ്പദമാക്കിയായിരുന്നു പ്രോഗ്രാം...",
      thumb: "assets/img/harithakam/77.jpg",
    },
    {
      src: "assets/img/harithakam/78.jpg",
      caption:
        'ലോക ഭൗമദിനം 2022..."പ്രകൃതിയും തുടിക്കുന്ന ജീവനാണ്, അത് സംരക്ഷിക്കുക" ',
      thumb: "assets/img/harithakam/78.jpg",
    },

    {
      src: "assets/img/harithakam/53.jpg",
      caption:
        "ലോക ഭൗമ ദിനത്തോടനുബന്ധിച്ചു നിംസ് മെഡിസിറ്റിയുടെ ഹരിതകം പദ്ധതിയുടെ ഭാഗമായി നെയ്യാറ്റിൻകര നഗരസഭ ചെയർമാൻ ശ്രീ രാജ്‌മോഹൻ മുനിസിപ്പാലിറ്റി സ്റ്റേഡിയത്തിൽ ഫല വൃക്ഷ തൈ നട്ടുപിടിപ്പിച്ചു.",
      thumb: "assets/img/harithakam/53.jpg",
    },
    {
      src: "assets/img/harithakam/54.jpg",
      caption:
        "ലോക ഭൗമ ദിനത്തോടനുബന്ധിച്ചു നിംസ് മെഡിസിറ്റിയുടെ ഹരിതകം പദ്ധതിയുടെ ഭാഗമായി നെയ്യാറ്റിൻകര നഗരസഭ ചെയർമാൻ ശ്രീ രാജ്‌മോഹൻ മുനിസിപ്പാലിറ്റി സ്റ്റേഡിയത്തിൽ ഫല വൃക്ഷ തൈ നട്ടുപിടിപ്പിച്ചു.",
      thumb: "assets/img/harithakam/54.jpg",
    },
    {
      src: "assets/img/harithakam/55.jpg",
      caption:
        "ലോക ഭൗമ ദിനത്തോടനുബന്ധിച്ചു നിംസ് മെഡിസിറ്റിയുടെ ഹരിതകം പദ്ധതിയുടെ ഭാഗമായി നെയ്യാറ്റിൻകര നഗരസഭ ചെയർമാൻ ശ്രീ രാജ്‌മോഹൻ മുനിസിപ്പാലിറ്റി സ്റ്റേഡിയത്തിൽ ഫല വൃക്ഷ തൈ നട്ടുപിടിപ്പിച്ചു.",
      thumb: "assets/img/harithakam/55.jpg",
    },
    {
      src: "assets/img/harithakam/56.jpg",
      caption:
        "ലോക ഭൗമ ദിനത്തോടനുബന്ധിച്ചു നിംസ് മെഡിസിറ്റിയുടെ ഹരിതകം പദ്ധതിയുടെ ഭാഗമായി നെയ്യാറ്റിൻകര നഗരസഭ ചെയർമാൻ ശ്രീ രാജ്‌മോഹൻ മുനിസിപ്പാലിറ്റി സ്റ്റേഡിയത്തിൽ ഫല വൃക്ഷ തൈ നട്ടുപിടിപ്പിച്ചു.",
      thumb: "assets/img/harithakam/56.jpg",
    },
    {
      src: "assets/img/harithakam/57.jpg",
      caption:
        "ലോക ഭൗമ ദിനത്തോടനുബന്ധിച്ചു നിംസ് മെഡിസിറ്റിയുടെ ഹരിതകം പദ്ധതിയുടെ ഭാഗമായി നെയ്യാറ്റിൻകര നഗരസഭ ചെയർമാൻ ശ്രീ രാജ്‌മോഹൻ മുനിസിപ്പാലിറ്റി സ്റ്റേഡിയത്തിൽ ഫല വൃക്ഷ തൈ നട്ടുപിടിപ്പിച്ചു.",
      thumb: "assets/img/harithakam/57.jpg",
    },

    {
      src: "assets/img/harithakam/51.jpg",
      caption:
        "'ഒരു കുഞ്ഞ് ഒരു മരം' എന്ന പദ്ധതിയിൽ ഒരു കുഞ്ഞു നിംസിൽ ജനിക്കുമ്പോൾ ഒരു മരം ഭൂമിക്ക് എന്ന പദ്ധതി ആവിഷ്കരിച്ച് വിജയകരമായി നടത്തിവരുന്നതിന്റെ ഭാഗമായി ഈ ഭൗമദിനത്തിൽ 2190 മത്തെ കുഞ്ഞിന് വൃക്ഷ തൈ പ്രശസ്ത മജീഷ്യനും സാമൂഹിക പ്രവർത്തകനുമായ ശ്രീ ഗോപിനാഥ് മുതുകാട് കൈമാറിയപ്പോൾ..",
      thumb: "assets/img/harithakam/51.jpg",
    },
    {
      src: "assets/img/harithakam/52.jpg",
      caption:
        "'ഒരു കുഞ്ഞ് ഒരു മരം' എന്ന പദ്ധതിയിൽ ഒരു കുഞ്ഞു നിംസിൽ ജനിക്കുമ്പോൾ ഒരു മരം ഭൂമിക്ക് എന്ന പദ്ധതി ആവിഷ്കരിച്ച് വിജയകരമായി നടത്തിവരുന്നതിന്റെ ഭാഗമായി ഈ ഭൗമദിനത്തിൽ 2190 മത്തെ കുഞ്ഞിന് വൃക്ഷ തൈ പ്രശസ്ത മജീഷ്യനും സാമൂഹിക പ്രവർത്തകനുമായ ശ്രീ ഗോപിനാഥ് മുതുകാട് കൈമാറിയപ്പോൾ..",
      thumb: "assets/img/harithakam/52.jpg",
    },

    {
      src: "assets/img/harithakam/44.jpg",
      caption:
        "ഖാദിയുടെ നൂറാം വാർഷികം പ്രമാണിച്ചു നിംസ് മെഡിസിറ്റിയിൽ കേന്ദ്ര വിദേശകാര്യ സഹമന്ത്രി ശ്രീ വി മുരളീധരൻ ഫലവൃക്ഷ തൈ നടുന്നു..ഒരു ലക്ഷം ഫലവൃക്ഷതൈകൾ എന്ന നിംസ് ഹരിതകം പദ്ധതിയുടെ ഭാഗമായിട്ടാണ് വൃക്ഷതൈ നട്ടത്.....",
      thumb: "assets/img/harithakam/44.jpg",
    },
    {
      src: "assets/img/harithakam/45.jpg",
      caption:
        "ഖാദിയുടെ നൂറാം വാർഷികം പ്രമാണിച്ചു നിംസ് മെഡിസിറ്റിയിൽ കേന്ദ്ര വിദേശകാര്യ സഹമന്ത്രി ശ്രീ വി മുരളീധരൻ ഫലവൃക്ഷ തൈ നടുന്നു..ഒരു ലക്ഷം ഫലവൃക്ഷതൈകൾ എന്ന നിംസ് ഹരിതകം പദ്ധതിയുടെ ഭാഗമായിട്ടാണ് വൃക്ഷതൈ നട്ടത്.....",
      thumb: "assets/img/harithakam/45.jpg",
    },
    {
      src: "assets/img/harithakam/46.jpg",
      caption:
        "ഖാദിയുടെ നൂറാം വാർഷികം പ്രമാണിച്ചു നിംസ് മെഡിസിറ്റിയിൽ കേന്ദ്ര വിദേശകാര്യ സഹമന്ത്രി ശ്രീ വി മുരളീധരൻ ഫലവൃക്ഷ തൈ നടുന്നു..ഒരു ലക്ഷം ഫലവൃക്ഷതൈകൾ എന്ന നിംസ് ഹരിതകം പദ്ധതിയുടെ ഭാഗമായിട്ടാണ് വൃക്ഷതൈ നട്ടത്.....",
      thumb: "assets/img/harithakam/46.jpg",
    },
    {
      src: "assets/img/harithakam/47.jpg",
      caption:
        "ഖാദിയുടെ നൂറാം വാർഷികം പ്രമാണിച്ചു നിംസ് മെഡിസിറ്റിയിൽ കേന്ദ്ര വിദേശകാര്യ സഹമന്ത്രി ശ്രീ വി മുരളീധരൻ ഫലവൃക്ഷ തൈ നടുന്നു..ഒരു ലക്ഷം ഫലവൃക്ഷതൈകൾ എന്ന നിംസ് ഹരിതകം പദ്ധതിയുടെ ഭാഗമായിട്ടാണ് വൃക്ഷതൈ നട്ടത്.....",
      thumb: "assets/img/harithakam/47.jpg",
    },
    {
      src: "assets/img/harithakam/48.jpg",
      caption:
        "ഖാദിയുടെ നൂറാം വാർഷികം പ്രമാണിച്ചു നിംസ് മെഡിസിറ്റിയിൽ കേന്ദ്ര വിദേശകാര്യ സഹമന്ത്രി ശ്രീ വി മുരളീധരൻ ഫലവൃക്ഷ തൈ നടുന്നു..ഒരു ലക്ഷം ഫലവൃക്ഷതൈകൾ എന്ന നിംസ് ഹരിതകം പദ്ധതിയുടെ ഭാഗമായിട്ടാണ് വൃക്ഷതൈ നട്ടത്.....",
      thumb: "assets/img/harithakam/48.jpg",
    },
    {
      src: "assets/img/harithakam/49.jpg",
      caption:
        "ഖാദിയുടെ നൂറാം വാർഷികം പ്രമാണിച്ചു നിംസ് മെഡിസിറ്റിയിൽ കേന്ദ്ര വിദേശകാര്യ സഹമന്ത്രി ശ്രീ വി മുരളീധരൻ ഫലവൃക്ഷ തൈ നടുന്നു..ഒരു ലക്ഷം ഫലവൃക്ഷതൈകൾ എന്ന നിംസ് ഹരിതകം പദ്ധതിയുടെ ഭാഗമായിട്ടാണ് വൃക്ഷതൈ നട്ടത്.....",
      thumb: "assets/img/harithakam/49.jpg",
    },
    {
      src: "assets/img/harithakam/50.jpg",
      caption:
        "ഖാദിയുടെ നൂറാം വാർഷികം പ്രമാണിച്ചു നിംസ് മെഡിസിറ്റിയിൽ കേന്ദ്ര വിദേശകാര്യ സഹമന്ത്രി ശ്രീ വി മുരളീധരൻ ഫലവൃക്ഷ തൈ നടുന്നു..ഒരു ലക്ഷം ഫലവൃക്ഷതൈകൾ എന്ന നിംസ് ഹരിതകം പദ്ധതിയുടെ ഭാഗമായിട്ടാണ് വൃക്ഷതൈ നട്ടത്.....",
      thumb: "assets/img/harithakam/50.jpg",
    },
    {
      src: "assets/img/harithakam/43.jpg",
      caption: "",
      thumb: "assets/img/harithakam/43.jpg",
    },
    {
      src: "assets/img/harithakam/41.jpg",
      caption:
        "നിംസ് ഹരിതകം പദ്ധതിയുടെ ഭാഗമായി, നിംസ് മെഡിസിറ്റി ക്യാമ്പസിൽ പി കെ ബഷീർ MLA വൃക്ഷാതൈ നടുന്നു",
      thumb: "assets/img/harithakam/41.jpg",
    },
    {
      src: "assets/img/harithakam/42.jpg",
      caption:
        "നിംസ് ഹരിതകം പദ്ധതിയുടെ ഭാഗമായി, നിംസ് മെഡിസിറ്റി ക്യാമ്പസിൽ പി കെ ബഷീർ MLA വൃക്ഷാതൈ നടുന്നു",
      thumb: "assets/img/harithakam/42.jpg",
    },
    {
      src: "assets/img/harithakam/31.jpg",
      caption:
        "നിംസ് ഹരിതകം പദ്ധതിയുടെ ചില ഓർമ്മകൾ. ഞങ്ങൾ യാത്ര ആരംഭിച്ച YMCA ഹാൾ മുതൽ നിംസിന്റെ പ്രമുഖ വ്യെക്തിത്വങ്ങൾ ഞങ്ങൾക്ക് സമ്മാനിച്ച ജീവവായുവിന്റെ തിരിഞ്ഞുനോട്ടം..",
      thumb: "assets/img/harithakam/31.jpg",
    },
    {
      src: "assets/img/harithakam/32.jpg",
      caption:
        "നിംസ് ഹരിതകം പദ്ധതിയുടെ ചില ഓർമ്മകൾ. ഞങ്ങൾ യാത്ര ആരംഭിച്ച YMCA ഹാൾ മുതൽ നിംസിന്റെ പ്രമുഖ വ്യെക്തിത്വങ്ങൾ ഞങ്ങൾക്ക് സമ്മാനിച്ച ജീവവായുവിന്റെ തിരിഞ്ഞുനോട്ടം..",
      thumb: "assets/img/harithakam/32.jpg",
    },
    {
      src: "assets/img/harithakam/33.jpg",
      caption:
        "നിംസ് ഹരിതകം പദ്ധതിയുടെ ചില ഓർമ്മകൾ. ഞങ്ങൾ യാത്ര ആരംഭിച്ച YMCA ഹാൾ മുതൽ നിംസിന്റെ പ്രമുഖ വ്യെക്തിത്വങ്ങൾ ഞങ്ങൾക്ക് സമ്മാനിച്ച ജീവവായുവിന്റെ തിരിഞ്ഞുനോട്ടം..",
      thumb: "assets/img/harithakam/33.jpg",
    },
    {
      src: "assets/img/harithakam/34.jpg",
      caption:
        "നിംസ് ഹരിതകം പദ്ധതിയുടെ ചില ഓർമ്മകൾ. ഞങ്ങൾ യാത്ര ആരംഭിച്ച YMCA ഹാൾ മുതൽ നിംസിന്റെ പ്രമുഖ വ്യെക്തിത്വങ്ങൾ ഞങ്ങൾക്ക് സമ്മാനിച്ച ജീവവായുവിന്റെ തിരിഞ്ഞുനോട്ടം..",
      thumb: "assets/img/harithakam/34.jpg",
    },
    {
      src: "assets/img/harithakam/35.jpg",
      caption:
        "നിംസ് ഹരിതകം പദ്ധതിയുടെ ചില ഓർമ്മകൾ. ഞങ്ങൾ യാത്ര ആരംഭിച്ച YMCA ഹാൾ മുതൽ നിംസിന്റെ പ്രമുഖ വ്യെക്തിത്വങ്ങൾ ഞങ്ങൾക്ക് സമ്മാനിച്ച ജീവവായുവിന്റെ തിരിഞ്ഞുനോട്ടം..",
      thumb: "assets/img/harithakam/35.jpg",
    },
    {
      src: "assets/img/harithakam/30.jpg",
      caption:
        "നിംസ് ഹരിതകം പദ്ധതിയുടെ ചില ഓർമ്മകൾ. ഞങ്ങൾ യാത്ര ആരംഭിച്ച YMCA ഹാൾ മുതൽ നിംസിന്റെ പ്രമുഖ വ്യെക്തിത്വങ്ങൾ ഞങ്ങൾക്ക് സമ്മാനിച്ച ജീവവായുവിന്റെ തിരിഞ്ഞുനോട്ടം..",
      thumb: "assets/img/harithakam/30.jpg",
    },
    {
      src: "assets/img/harithakam/36.jpg",
      caption:
        "ലോക പരിസ്ഥിതി ദിനത്തോടനുബന്ധിച്ചു നിംസ് മെഡിസിറ്റിയും വിഴിഞ്ഞം ലയൺസ് ക്ലബ്ബും സംയുക്തമായി വിഴിഞ്ഞം ജനമൈത്രി പോലീസ് സ്റ്റേഷനിൽ വൃക്ഷാതൈകൾ നട്ടു പിടിപ്പിച്ചു.",
      thumb: "assets/img/harithakam/36.jpg",
    },
    {
      src: "assets/img/harithakam/37.jpg",
      caption:
        "ലോക പരിസ്ഥിതി ദിനത്തോടനുബന്ധിച്ചു നിംസ് മെഡിസിറ്റിയും വിഴിഞ്ഞം ലയൺസ് ക്ലബ്ബും സംയുക്തമായി വിഴിഞ്ഞം ജനമൈത്രി പോലീസ് സ്റ്റേഷനിൽ വൃക്ഷാതൈകൾ നട്ടു പിടിപ്പിച്ചു.",
      thumb: "assets/img/harithakam/37.jpg",
    },
    {
      src: "assets/img/harithakam/38.jpg",
      caption:
        "ലോക പരിസ്ഥിതി ദിനത്തോടനുബന്ധിച്ചു നിംസ് മെഡിസിറ്റിയും വിഴിഞ്ഞം ലയൺസ് ക്ലബ്ബും സംയുക്തമായി വിഴിഞ്ഞം ജനമൈത്രി പോലീസ് സ്റ്റേഷനിൽ വൃക്ഷാതൈകൾ നട്ടു പിടിപ്പിച്ചു.",
      thumb: "assets/img/harithakam/38.jpg",
    },
    {
      src: "assets/img/harithakam/39.jpg",
      caption:
        "ലോക പരിസ്ഥിതി ദിനത്തോടനുബന്ധിച്ചു നിംസ് മെഡിസിറ്റിയും വിഴിഞ്ഞം ലയൺസ് ക്ലബ്ബും സംയുക്തമായി വിഴിഞ്ഞം ജനമൈത്രി പോലീസ് സ്റ്റേഷനിൽ വൃക്ഷാതൈകൾ നട്ടു പിടിപ്പിച്ചു.",
      thumb: "assets/img/harithakam/39.jpg",
    },
    {
      src: "assets/img/harithakam/40.jpg",
      caption:
        "ലോക പരിസ്ഥിതി ദിനത്തോടനുബന്ധിച്ചു നിംസ് മെഡിസിറ്റിയും വിഴിഞ്ഞം ലയൺസ് ക്ലബ്ബും സംയുക്തമായി വിഴിഞ്ഞം ജനമൈത്രി പോലീസ് സ്റ്റേഷനിൽ വൃക്ഷാതൈകൾ നട്ടു പിടിപ്പിച്ചു.",
      thumb: "assets/img/harithakam/40.jpg",
    },
    {
      src: "assets/img/harithakam/24.jpg",
      caption:
        "നിംസ് ഹരിതകം പദ്ധതിയുടെ ചില ഓർമ്മകൾ. ഞങ്ങൾ യാത്ര ആരംഭിച്ച YMCA ഹാൾ മുതൽ നിംസിന്റെ പ്രമുഖ വ്യെക്തിത്വങ്ങൾ ഞങ്ങൾക്ക് സമ്മാനിച്ച ജീവവായുവിന്റെ തിരിഞ്ഞുനോട്ടം..",
      thumb: "assets/img/harithakam/24.jpg",
    },
    {
      src: "assets/img/harithakam/25.jpg",
      caption:
        "നിംസ് ഹരിതകം പദ്ധതിയുടെ ചില ഓർമ്മകൾ. ഞങ്ങൾ യാത്ര ആരംഭിച്ച YMCA ഹാൾ മുതൽ നിംസിന്റെ പ്രമുഖ വ്യെക്തിത്വങ്ങൾ ഞങ്ങൾക്ക് സമ്മാനിച്ച ജീവവായുവിന്റെ തിരിഞ്ഞുനോട്ടം..",
      thumb: "assets/img/harithakam/25.jpg",
    },
    {
      src: "assets/img/harithakam/26.jpg",
      caption:
        "നിംസ് ഹരിതകം പദ്ധതിയുടെ ചില ഓർമ്മകൾ. ഞങ്ങൾ യാത്ര ആരംഭിച്ച YMCA ഹാൾ മുതൽ നിംസിന്റെ പ്രമുഖ വ്യെക്തിത്വങ്ങൾ ഞങ്ങൾക്ക് സമ്മാനിച്ച ജീവവായുവിന്റെ തിരിഞ്ഞുനോട്ടം..",
      thumb: "assets/img/harithakam/26.jpg",
    },
    {
      src: "assets/img/harithakam/27.jpg",
      caption:
        "നിംസ് ഹരിതകം പദ്ധതിയുടെ ചില ഓർമ്മകൾ. ഞങ്ങൾ യാത്ര ആരംഭിച്ച YMCA ഹാൾ മുതൽ നിംസിന്റെ പ്രമുഖ വ്യെക്തിത്വങ്ങൾ ഞങ്ങൾക്ക് സമ്മാനിച്ച ജീവവായുവിന്റെ തിരിഞ്ഞുനോട്ടം..",
      thumb: "assets/img/harithakam/27.jpg",
    },
    {
      src: "assets/img/harithakam/28.jpg",
      caption:
        "നിംസ് ഹരിതകം പദ്ധതിയുടെ ചില ഓർമ്മകൾ. ഞങ്ങൾ യാത്ര ആരംഭിച്ച YMCA ഹാൾ മുതൽ നിംസിന്റെ പ്രമുഖ വ്യെക്തിത്വങ്ങൾ ഞങ്ങൾക്ക് സമ്മാനിച്ച ജീവവായുവിന്റെ തിരിഞ്ഞുനോട്ടം..",
      thumb: "assets/img/harithakam/28.jpg",
    },
    {
      src: "assets/img/harithakam/29.jpg",
      caption:
        "നിംസ് ഹരിതകം പദ്ധതിയുടെ ചില ഓർമ്മകൾ. ഞങ്ങൾ യാത്ര ആരംഭിച്ച YMCA ഹാൾ മുതൽ നിംസിന്റെ പ്രമുഖ വ്യെക്തിത്വങ്ങൾ ഞങ്ങൾക്ക് സമ്മാനിച്ച ജീവവായുവിന്റെ തിരിഞ്ഞുനോട്ടം..",
      thumb: "assets/img/harithakam/29.jpg",
    },
    {
      src: "assets/img/harithakam/1.jpg",
      caption: "1",
      thumb: "assets/img/harithakam/1.jpg",
    },
    {
      src: "assets/img/harithakam/2.jpg",
      caption: "2",
      thumb: "assets/img/harithakam/2.jpg",
    },
    {
      src: "assets/img/harithakam/3.jpg",
      caption: "3",
      thumb: "assets/img/harithakam/3.jpg",
    },
    {
      src: "assets/img/harithakam/4.jpg",
      caption: "4",
      thumb: "assets/img/harithakam/4.jpg",
    },
    {
      src: "assets/img/harithakam/5.jpg",
      caption: "5",
      thumb: "assets/img/harithakam/5.jpg",
    },
    {
      src: "assets/img/harithakam/6.jpg",
      caption: "6",
      thumb: "assets/img/harithakam/6.jpg",
    },
    {
      src: "assets/img/harithakam/7.jpg",
      caption: "7",
      thumb: "assets/img/harithakam/7.jpg",
    },
    {
      src: "assets/img/harithakam/8.jpg",
      caption: "8",
      thumb: "assets/img/harithakam/8.jpg",
    },
    {
      src: "assets/img/harithakam/9.jpg",
      caption: "9",
      thumb: "assets/img/harithakam/9.jpg",
    },
    {
      src: "assets/img/harithakam/10.jpg",
      caption: "10",
      thumb: "assets/img/harithakam/10.jpg",
    },
    {
      src: "assets/img/harithakam/11.jpg",
      caption: "11",
      thumb: "assets/img/harithakam/11.jpg",
    },
    {
      src: "assets/img/harithakam/12.jpg",
      caption: "12",
      thumb: "assets/img/harithakam/12.jpg",
    },
    {
      src: "assets/img/harithakam/13.jpg",
      caption: "13",
      thumb: "assets/img/harithakam/13.jpg",
    },
    {
      src: "assets/img/harithakam/14.jpg",
      caption: "14",
      thumb: "assets/img/harithakam/14.jpg",
    },
    {
      src: "assets/img/harithakam/15.jpg",
      caption: "15",
      thumb: "assets/img/harithakam/15.jpg",
    },
    {
      src: "assets/img/harithakam/16.jpg",
      caption: "16",
      thumb: "assets/img/harithakam/16.jpg",
    },
    {
      src: "assets/img/harithakam/17.jpg",
      caption: "17",
      thumb: "assets/img/harithakam/17.jpg",
    },
    {
      src: "assets/img/harithakam/18.jpg",
      caption: "18",
      thumb: "assets/img/harithakam/18.jpg",
    },
    {
      src: "assets/img/harithakam/19.jpg",
      caption: "19",
      thumb: "assets/img/harithakam/19.jpg",
    },
    {
      src: "assets/img/harithakam/20.jpg",
      caption: "20",
      thumb: "assets/img/harithakam/20.jpg",
    },
    {
      src: "assets/img/harithakam/21.jpg",
      caption: "21",
      thumb: "assets/img/harithakam/21.jpg",
    },
    {
      src: "assets/img/harithakam/22.jpg",
      caption: "22",
      thumb: "assets/img/harithakam/22.jpg",
    },
    {
      src: "assets/img/harithakam/23.jpg",
      caption: "23",
      thumb: "assets/img/harithakam/23.jpg",
    },
  ];

  TIGER_GALLERY: Array<{ src: string; caption: string; thumb: string }> = [
    {
      src: "assets/img/Tiger/1.jpg",
      caption: "1",
      thumb: "assets/img/Tiger/1.jpg",
    },
    {
      src: "assets/img/Tiger/2.jpg",
      caption: "2",
      thumb: "assets/img/Tiger/2.jpg",
    },
    {
      src: "assets/img/Tiger/3.jpg",
      caption: "3",
      thumb: "assets/img/Tiger/3.jpg",
    },
    {
      src: "assets/img/Tiger/4.jpg",
      caption: "4",
      thumb: "assets/img/Tiger/4.jpg",
    },
    {
      src: "assets/img/Tiger/5.jpg",
      caption: "5",
      thumb: "assets/img/Tiger/5.jpg",
    },
    {
      src: "assets/img/Tiger/6.jpg",
      caption: "6",
      thumb: "assets/img/Tiger/6.jpg",
    },
    {
      src: "assets/img/Tiger/7.jpg",
      caption: "7",
      thumb: "assets/img/Tiger/7.jpg",
    },
    {
      src: "assets/img/Tiger/8.jpg",
      caption: "8",
      thumb: "assets/img/Tiger/8.jpg",
    },
    //{src:'assets/img/Tiger/9.jpg',caption: '9',thumb: 'assets/img/Tiger/9.jpg'},
    {
      src: "assets/img/Tiger/10.jpg",
      caption: "10",
      thumb: "assets/img/Tiger/10.jpg",
    },
    {
      src: "assets/img/Tiger/11.jpg",
      caption: "11",
      thumb: "assets/img/Tiger/11.jpg",
    },
    {
      src: "assets/img/Tiger/12.JPG",
      caption: "12",
      thumb: "assets/img/Tiger/12.JPG",
    },
    {
      src: "assets/img/Tiger/13.JPG",
      caption: "13",
      thumb: "assets/img/Tiger/13.JPG",
    },
    {
      src: "assets/img/Tiger/14.JPG",
      caption: "14",
      thumb: "assets/img/Tiger/14.JPG",
    },
  ];

  SAHYADRI_GALLERY: Array<{ src: string; caption: string; thumb: string }> = [
    {
      src: "assets/img/Sahyadri/1.jpg",
      caption: "1",
      thumb: "assets/img/Sahyadri/1.jpg",
    },
    {
      src: "assets/img/Sahyadri/2.jpg",
      caption: "2",
      thumb: "assets/img/Sahyadri/2.jpg",
    },
    {
      src: "assets/img/Sahyadri/3.jpg",
      caption: "3",
      thumb: "assets/img/Sahyadri/3.jpg",
    },
    {
      src: "assets/img/Sahyadri/4.jpg",
      caption: "4",
      thumb: "assets/img/Sahyadri/4.jpg",
    },
    {
      src: "assets/img/Sahyadri/5.jpg",
      caption: "5",
      thumb: "assets/img/Sahyadri/5.jpg",
    },
    {
      src: "assets/img/Sahyadri/6.jpg",
      caption: "6",
      thumb: "assets/img/Sahyadri/6.jpg",
    },
    {
      src: "assets/img/Sahyadri/7.jpg",
      caption: "7",
      thumb: "assets/img/Sahyadri/7.jpg",
    },
    {
      src: "assets/img/Sahyadri/8.jpg",
      caption: "8",
      thumb: "assets/img/Sahyadri/8.jpg",
    },
    //{src:'assets/img/Sahyadri/9.jpg',caption: '9',thumb:'assets/img/Sahyadri/9.jpg'},
  ];

  CAMP_GALLERY: Array<{ src: string; caption: string; thumb: string }> = [
     {
      src: "assets/img/Pastevents/5474.jpg",
      caption:
        "സേവാശക്തി ഫൗണ്ടേഷനും,നിംസ് മെഡിസിറ്റിയും ഇരപ്പുകുഴി കൂട്ടായ്മയും സംയുക്തമായി സംഘടിപ്പിക്കുന്ന സൗജന്യ സൂപ്പർ സ്പെഷ്യാലിറ്റി മെഗാ മെഡിക്കൽ ക്യാമ്പ് തിരുവനന്തപുരം കുടപ്പനക്കുന്ന് തീർത്ഥ ഓഡിറ്റോറിയത്തിൽ വച്ച് പ്രമുഖ സിനിമ സീരിയൽ നടൻ ശ്രീ. ദിനേശ് പണിക്കർ ഉദ്ഘാടനം ചെയ്തു.",
      thumb: "assets/img/Pastevents/5474.jpg",
    },
    {
      src: "assets/img/Pastevents/5475.jpg",
      caption:
        "സേവാശക്തി ഫൗണ്ടേഷനും,നിംസ് മെഡിസിറ്റിയും ഇരപ്പുകുഴി കൂട്ടായ്മയും സംയുക്തമായി സംഘടിപ്പിക്കുന്ന സൗജന്യ സൂപ്പർ സ്പെഷ്യാലിറ്റി മെഗാ മെഡിക്കൽ ക്യാമ്പ് തിരുവനന്തപുരം കുടപ്പനക്കുന്ന് തീർത്ഥ ഓഡിറ്റോറിയത്തിൽ വച്ച് പ്രമുഖ സിനിമ സീരിയൽ നടൻ ശ്രീ. ദിനേശ് പണിക്കർ ഉദ്ഘാടനം ചെയ്തു.",
      thumb: "assets/img/Pastevents/5475.jpg",
    },
    {
      src: "assets/img/Pastevents/5476.jpg",
      caption:
        "സേവാശക്തി ഫൗണ്ടേഷനും,നിംസ് മെഡിസിറ്റിയും ഇരപ്പുകുഴി കൂട്ടായ്മയും സംയുക്തമായി സംഘടിപ്പിക്കുന്ന സൗജന്യ സൂപ്പർ സ്പെഷ്യാലിറ്റി മെഗാ മെഡിക്കൽ ക്യാമ്പ് തിരുവനന്തപുരം കുടപ്പനക്കുന്ന് തീർത്ഥ ഓഡിറ്റോറിയത്തിൽ വച്ച് പ്രമുഖ സിനിമ സീരിയൽ നടൻ ശ്രീ. ദിനേശ് പണിക്കർ ഉദ്ഘാടനം ചെയ്തു.",
      thumb: "assets/img/Pastevents/5476.jpg",
    },
    {
      src: "assets/img/Pastevents/5477.jpg",
      caption:
        "സേവാശക്തി ഫൗണ്ടേഷനും,നിംസ് മെഡിസിറ്റിയും ഇരപ്പുകുഴി കൂട്ടായ്മയും സംയുക്തമായി സംഘടിപ്പിക്കുന്ന സൗജന്യ സൂപ്പർ സ്പെഷ്യാലിറ്റി മെഗാ മെഡിക്കൽ ക്യാമ്പ് തിരുവനന്തപുരം കുടപ്പനക്കുന്ന് തീർത്ഥ ഓഡിറ്റോറിയത്തിൽ വച്ച് പ്രമുഖ സിനിമ സീരിയൽ നടൻ ശ്രീ. ദിനേശ് പണിക്കർ ഉദ്ഘാടനം ചെയ്തു.",
      thumb: "assets/img/Pastevents/5477.jpg",
    },
    {
      src: "assets/img/Pastevents/5478.jpg",
      caption:
        "സേവാശക്തി ഫൗണ്ടേഷനും,നിംസ് മെഡിസിറ്റിയും ഇരപ്പുകുഴി കൂട്ടായ്മയും സംയുക്തമായി സംഘടിപ്പിക്കുന്ന സൗജന്യ സൂപ്പർ സ്പെഷ്യാലിറ്റി മെഗാ മെഡിക്കൽ ക്യാമ്പ് തിരുവനന്തപുരം കുടപ്പനക്കുന്ന് തീർത്ഥ ഓഡിറ്റോറിയത്തിൽ വച്ച് പ്രമുഖ സിനിമ സീരിയൽ നടൻ ശ്രീ. ദിനേശ് പണിക്കർ ഉദ്ഘാടനം ചെയ്തു.",
      thumb: "assets/img/Pastevents/5478.jpg",
    },
    {
      src: "assets/img/Pastevents/5479.jpg",
      caption:
        "സേവാശക്തി ഫൗണ്ടേഷനും,നിംസ് മെഡിസിറ്റിയും ഇരപ്പുകുഴി കൂട്ടായ്മയും സംയുക്തമായി സംഘടിപ്പിക്കുന്ന സൗജന്യ സൂപ്പർ സ്പെഷ്യാലിറ്റി മെഗാ മെഡിക്കൽ ക്യാമ്പ് തിരുവനന്തപുരം കുടപ്പനക്കുന്ന് തീർത്ഥ ഓഡിറ്റോറിയത്തിൽ വച്ച് പ്രമുഖ സിനിമ സീരിയൽ നടൻ ശ്രീ. ദിനേശ് പണിക്കർ ഉദ്ഘാടനം ചെയ്തു.",
      thumb: "assets/img/Pastevents/5479.jpg",
    },
    {
      src: "assets/img/Pastevents/5480.jpg",
      caption:
        "സേവാശക്തി ഫൗണ്ടേഷനും,നിംസ് മെഡിസിറ്റിയും ഇരപ്പുകുഴി കൂട്ടായ്മയും സംയുക്തമായി സംഘടിപ്പിക്കുന്ന സൗജന്യ സൂപ്പർ സ്പെഷ്യാലിറ്റി മെഗാ മെഡിക്കൽ ക്യാമ്പ് തിരുവനന്തപുരം കുടപ്പനക്കുന്ന് തീർത്ഥ ഓഡിറ്റോറിയത്തിൽ വച്ച് പ്രമുഖ സിനിമ സീരിയൽ നടൻ ശ്രീ. ദിനേശ് പണിക്കർ ഉദ്ഘാടനം ചെയ്തു.",
      thumb: "assets/img/Pastevents/5480.jpg",
    },
    {
      src: "assets/img/Pastevents/5481.jpg",
      caption:
        "സേവാശക്തി ഫൗണ്ടേഷനും,നിംസ് മെഡിസിറ്റിയും ഇരപ്പുകുഴി കൂട്ടായ്മയും സംയുക്തമായി സംഘടിപ്പിക്കുന്ന സൗജന്യ സൂപ്പർ സ്പെഷ്യാലിറ്റി മെഗാ മെഡിക്കൽ ക്യാമ്പ് തിരുവനന്തപുരം കുടപ്പനക്കുന്ന് തീർത്ഥ ഓഡിറ്റോറിയത്തിൽ വച്ച് പ്രമുഖ സിനിമ സീരിയൽ നടൻ ശ്രീ. ദിനേശ് പണിക്കർ ഉദ്ഘാടനം ചെയ്തു.",
      thumb: "assets/img/Pastevents/5481.jpg",
    },
    {
      src: "assets/img/Pastevents/5482.jpg",
      caption:
        "സേവാശക്തി ഫൗണ്ടേഷനും,നിംസ് മെഡിസിറ്റിയും ഇരപ്പുകുഴി കൂട്ടായ്മയും സംയുക്തമായി സംഘടിപ്പിക്കുന്ന സൗജന്യ സൂപ്പർ സ്പെഷ്യാലിറ്റി മെഗാ മെഡിക്കൽ ക്യാമ്പ് തിരുവനന്തപുരം കുടപ്പനക്കുന്ന് തീർത്ഥ ഓഡിറ്റോറിയത്തിൽ വച്ച് പ്രമുഖ സിനിമ സീരിയൽ നടൻ ശ്രീ. ദിനേശ് പണിക്കർ ഉദ്ഘാടനം ചെയ്തു.",
      thumb: "assets/img/Pastevents/5482.jpg",
    },
    {
      src: "assets/img/Pastevents/5483.jpg",
      caption:
        "സേവാശക്തി ഫൗണ്ടേഷനും,നിംസ് മെഡിസിറ്റിയും ഇരപ്പുകുഴി കൂട്ടായ്മയും സംയുക്തമായി സംഘടിപ്പിക്കുന്ന സൗജന്യ സൂപ്പർ സ്പെഷ്യാലിറ്റി മെഗാ മെഡിക്കൽ ക്യാമ്പ് തിരുവനന്തപുരം കുടപ്പനക്കുന്ന് തീർത്ഥ ഓഡിറ്റോറിയത്തിൽ വച്ച് പ്രമുഖ സിനിമ സീരിയൽ നടൻ ശ്രീ. ദിനേശ് പണിക്കർ ഉദ്ഘാടനം ചെയ്തു.",
      thumb: "assets/img/Pastevents/5483.jpg",
    },
    {
      src: "assets/img/Pastevents/5484.jpg",
      caption:
        "സേവാശക്തി ഫൗണ്ടേഷനും,നിംസ് മെഡിസിറ്റിയും ഇരപ്പുകുഴി കൂട്ടായ്മയും സംയുക്തമായി സംഘടിപ്പിക്കുന്ന സൗജന്യ സൂപ്പർ സ്പെഷ്യാലിറ്റി മെഗാ മെഡിക്കൽ ക്യാമ്പ് തിരുവനന്തപുരം കുടപ്പനക്കുന്ന് തീർത്ഥ ഓഡിറ്റോറിയത്തിൽ വച്ച് പ്രമുഖ സിനിമ സീരിയൽ നടൻ ശ്രീ. ദിനേശ് പണിക്കർ ഉദ്ഘാടനം ചെയ്തു.",
      thumb: "assets/img/Pastevents/5484.jpg",
    },
    {
      src: "assets/img/Pastevents/5485.jpg",
      caption:
        "സേവാശക്തി ഫൗണ്ടേഷനും,നിംസ് മെഡിസിറ്റിയും ഇരപ്പുകുഴി കൂട്ടായ്മയും സംയുക്തമായി സംഘടിപ്പിക്കുന്ന സൗജന്യ സൂപ്പർ സ്പെഷ്യാലിറ്റി മെഗാ മെഡിക്കൽ ക്യാമ്പ് തിരുവനന്തപുരം കുടപ്പനക്കുന്ന് തീർത്ഥ ഓഡിറ്റോറിയത്തിൽ വച്ച് പ്രമുഖ സിനിമ സീരിയൽ നടൻ ശ്രീ. ദിനേശ് പണിക്കർ ഉദ്ഘാടനം ചെയ്തു.",
      thumb: "assets/img/Pastevents/5485.jpg",
    },
    {
      src: "assets/img/Pastevents/5486.jpg",
      caption:
        "സേവാശക്തി ഫൗണ്ടേഷനും,നിംസ് മെഡിസിറ്റിയും ഇരപ്പുകുഴി കൂട്ടായ്മയും സംയുക്തമായി സംഘടിപ്പിക്കുന്ന സൗജന്യ സൂപ്പർ സ്പെഷ്യാലിറ്റി മെഗാ മെഡിക്കൽ ക്യാമ്പ് തിരുവനന്തപുരം കുടപ്പനക്കുന്ന് തീർത്ഥ ഓഡിറ്റോറിയത്തിൽ വച്ച് പ്രമുഖ സിനിമ സീരിയൽ നടൻ ശ്രീ. ദിനേശ് പണിക്കർ ഉദ്ഘാടനം ചെയ്തു.",
      thumb: "assets/img/Pastevents/5486.jpg",
    },
    {
      src: "assets/img/Pastevents/5487.jpg",
      caption:
        "സേവാശക്തി ഫൗണ്ടേഷനും,നിംസ് മെഡിസിറ്റിയും ഇരപ്പുകുഴി കൂട്ടായ്മയും സംയുക്തമായി സംഘടിപ്പിക്കുന്ന സൗജന്യ സൂപ്പർ സ്പെഷ്യാലിറ്റി മെഗാ മെഡിക്കൽ ക്യാമ്പ് തിരുവനന്തപുരം കുടപ്പനക്കുന്ന് തീർത്ഥ ഓഡിറ്റോറിയത്തിൽ വച്ച് പ്രമുഖ സിനിമ സീരിയൽ നടൻ ശ്രീ. ദിനേശ് പണിക്കർ ഉദ്ഘാടനം ചെയ്തു.",
      thumb: "assets/img/Pastevents/5487.jpg",
    },
    {
      src: "assets/img/Pastevents/5488.jpg",
      caption:
        "സേവാശക്തി ഫൗണ്ടേഷനും,നിംസ് മെഡിസിറ്റിയും ഇരപ്പുകുഴി കൂട്ടായ്മയും സംയുക്തമായി സംഘടിപ്പിക്കുന്ന സൗജന്യ സൂപ്പർ സ്പെഷ്യാലിറ്റി മെഗാ മെഡിക്കൽ ക്യാമ്പ് തിരുവനന്തപുരം കുടപ്പനക്കുന്ന് തീർത്ഥ ഓഡിറ്റോറിയത്തിൽ വച്ച് പ്രമുഖ സിനിമ സീരിയൽ നടൻ ശ്രീ. ദിനേശ് പണിക്കർ ഉദ്ഘാടനം ചെയ്തു.",
      thumb: "assets/img/Pastevents/5488.jpg",
    },
    {
      src: "assets/img/Pastevents/5468.jpg",
      caption:
        "കരുമം ശ്രീ മഹാവിഷ്ണു ഗ്രാമസേവാ സമിതിയുടെയും, നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്താഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.നിംസ് മെഡിസിറ്റിയിലെ ജനറൽ മെഡിസിൻ, ദന്തൽ , ഒഫ്താൽമോളജി തുടങ്ങി വിഭാഗങ്ങളിലെ വിദഗ്ദ്ധരും ഇ സി ജി, രക്തസമ്മർദ്ദപരിശോധന, പ്രമേഹരോഗ നിർണയം തുടങ്ങീ പരിശോധനകളും ക്യാമ്പിൽ ലഭ്യമാക്കി",
      thumb: "assets/img/Pastevents/5468.jpg",
    },
    {
      src: "assets/img/Pastevents/5469.jpg",
      caption:
        "കരുമം ശ്രീ മഹാവിഷ്ണു ഗ്രാമസേവാ സമിതിയുടെയും, നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്താഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.നിംസ് മെഡിസിറ്റിയിലെ ജനറൽ മെഡിസിൻ, ദന്തൽ , ഒഫ്താൽമോളജി തുടങ്ങി വിഭാഗങ്ങളിലെ വിദഗ്ദ്ധരും ഇ സി ജി, രക്തസമ്മർദ്ദപരിശോധന, പ്രമേഹരോഗ നിർണയം തുടങ്ങീ പരിശോധനകളും ക്യാമ്പിൽ ലഭ്യമാക്കി",
      thumb: "assets/img/Pastevents/5469.jpg",
    },
    {
      src: "assets/img/Pastevents/5470.jpg",
      caption:
        "കരുമം ശ്രീ മഹാവിഷ്ണു ഗ്രാമസേവാ സമിതിയുടെയും, നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്താഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.നിംസ് മെഡിസിറ്റിയിലെ ജനറൽ മെഡിസിൻ, ദന്തൽ , ഒഫ്താൽമോളജി തുടങ്ങി വിഭാഗങ്ങളിലെ വിദഗ്ദ്ധരും ഇ സി ജി, രക്തസമ്മർദ്ദപരിശോധന, പ്രമേഹരോഗ നിർണയം തുടങ്ങീ പരിശോധനകളും ക്യാമ്പിൽ ലഭ്യമാക്കി",
      thumb: "assets/img/Pastevents/5470.jpg",
    },
    {
      src: "assets/img/Pastevents/5471.jpg",
      caption:
        "കരുമം ശ്രീ മഹാവിഷ്ണു ഗ്രാമസേവാ സമിതിയുടെയും, നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്താഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.നിംസ് മെഡിസിറ്റിയിലെ ജനറൽ മെഡിസിൻ, ദന്തൽ , ഒഫ്താൽമോളജി തുടങ്ങി വിഭാഗങ്ങളിലെ വിദഗ്ദ്ധരും ഇ സി ജി, രക്തസമ്മർദ്ദപരിശോധന, പ്രമേഹരോഗ നിർണയം തുടങ്ങീ പരിശോധനകളും ക്യാമ്പിൽ ലഭ്യമാക്കി",
      thumb: "assets/img/Pastevents/5471.jpg",
    },
    {
      src: "assets/img/Pastevents/5472.jpg",
      caption:
        "കരുമം ശ്രീ മഹാവിഷ്ണു ഗ്രാമസേവാ സമിതിയുടെയും, നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്താഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.നിംസ് മെഡിസിറ്റിയിലെ ജനറൽ മെഡിസിൻ, ദന്തൽ , ഒഫ്താൽമോളജി തുടങ്ങി വിഭാഗങ്ങളിലെ വിദഗ്ദ്ധരും ഇ സി ജി, രക്തസമ്മർദ്ദപരിശോധന, പ്രമേഹരോഗ നിർണയം തുടങ്ങീ പരിശോധനകളും ക്യാമ്പിൽ ലഭ്യമാക്കി",
      thumb: "assets/img/Pastevents/5472.jpg",
    },
    {
      src: "assets/img/Pastevents/5473.jpg",
      caption:
        "കരുമം ശ്രീ മഹാവിഷ്ണു ഗ്രാമസേവാ സമിതിയുടെയും, നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്താഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.നിംസ് മെഡിസിറ്റിയിലെ ജനറൽ മെഡിസിൻ, ദന്തൽ , ഒഫ്താൽമോളജി തുടങ്ങി വിഭാഗങ്ങളിലെ വിദഗ്ദ്ധരും ഇ സി ജി, രക്തസമ്മർദ്ദപരിശോധന, പ്രമേഹരോഗ നിർണയം തുടങ്ങീ പരിശോധനകളും ക്യാമ്പിൽ ലഭ്യമാക്കി",
      thumb: "assets/img/Pastevents/5473.jpg",
    },
    {
      src: "assets/img/Pastevents/5446.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയും ,നല്ലയണി ശ്രീ ധർമ ശാസ്താക്ഷേത്രയോഗം ട്രസ്റ്റിന്റെയും ആഭിമുഖ്യത്തിൽ സംയുക്തമായി സംഘടിപ്പിച്ച സൗജന്യ മെഡിക്കൽ ക്യാമ്പ്. നിംസ് മെഡിസിറ്റിയിലെ ജനറൽ മെഡിസിൻ, ദന്തൽ ,ഒഫ്താൽമോളജി തുടങ്ങി വിഭാഗങ്ങളിലെ വിദഗ്ദ്ധരും ഇ സി ജി, രക്തസമ്മർദ്ദo, പ്രമേഹരോഗ നിർണയം തുടങ്ങി പരിശോധനകളും ക്യാമ്പിൽ ലഭ്യമാക്കി.",
      thumb: "assets/img/Pastevents/5446.jpg",
    },
    {
      src: "assets/img/Pastevents/5447.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയും ,നല്ലയണി ശ്രീ ധർമ ശാസ്താക്ഷേത്രയോഗം ട്രസ്റ്റിന്റെയും ആഭിമുഖ്യത്തിൽ സംയുക്തമായി സംഘടിപ്പിച്ച സൗജന്യ മെഡിക്കൽ ക്യാമ്പ്. നിംസ് മെഡിസിറ്റിയിലെ ജനറൽ മെഡിസിൻ, ദന്തൽ ,ഒഫ്താൽമോളജി തുടങ്ങി വിഭാഗങ്ങളിലെ വിദഗ്ദ്ധരും ഇ സി ജി, രക്തസമ്മർദ്ദo, പ്രമേഹരോഗ നിർണയം തുടങ്ങി പരിശോധനകളും ക്യാമ്പിൽ ലഭ്യമാക്കി.",
      thumb: "assets/img/Pastevents/5447.jpg",
    },
    {
      src: "assets/img/Pastevents/5448.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയും ,നല്ലയണി ശ്രീ ധർമ ശാസ്താക്ഷേത്രയോഗം ട്രസ്റ്റിന്റെയും ആഭിമുഖ്യത്തിൽ സംയുക്തമായി സംഘടിപ്പിച്ച സൗജന്യ മെഡിക്കൽ ക്യാമ്പ്. നിംസ് മെഡിസിറ്റിയിലെ ജനറൽ മെഡിസിൻ, ദന്തൽ ,ഒഫ്താൽമോളജി തുടങ്ങി വിഭാഗങ്ങളിലെ വിദഗ്ദ്ധരും ഇ സി ജി, രക്തസമ്മർദ്ദo, പ്രമേഹരോഗ നിർണയം തുടങ്ങി പരിശോധനകളും ക്യാമ്പിൽ ലഭ്യമാക്കി.",
      thumb: "assets/img/Pastevents/5448.jpg",
    },
    {
      src: "assets/img/Pastevents/5449.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയും ,നല്ലയണി ശ്രീ ധർമ ശാസ്താക്ഷേത്രയോഗം ട്രസ്റ്റിന്റെയും ആഭിമുഖ്യത്തിൽ സംയുക്തമായി സംഘടിപ്പിച്ച സൗജന്യ മെഡിക്കൽ ക്യാമ്പ്. നിംസ് മെഡിസിറ്റിയിലെ ജനറൽ മെഡിസിൻ, ദന്തൽ ,ഒഫ്താൽമോളജി തുടങ്ങി വിഭാഗങ്ങളിലെ വിദഗ്ദ്ധരും ഇ സി ജി, രക്തസമ്മർദ്ദo, പ്രമേഹരോഗ നിർണയം തുടങ്ങി പരിശോധനകളും ക്യാമ്പിൽ ലഭ്യമാക്കി.",
      thumb: "assets/img/Pastevents/5449.jpg",
    },
    {
      src: "assets/img/Pastevents/5450.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയും ,നല്ലയണി ശ്രീ ധർമ ശാസ്താക്ഷേത്രയോഗം ട്രസ്റ്റിന്റെയും ആഭിമുഖ്യത്തിൽ സംയുക്തമായി സംഘടിപ്പിച്ച സൗജന്യ മെഡിക്കൽ ക്യാമ്പ്. നിംസ് മെഡിസിറ്റിയിലെ ജനറൽ മെഡിസിൻ, ദന്തൽ ,ഒഫ്താൽമോളജി തുടങ്ങി വിഭാഗങ്ങളിലെ വിദഗ്ദ്ധരും ഇ സി ജി, രക്തസമ്മർദ്ദo, പ്രമേഹരോഗ നിർണയം തുടങ്ങി പരിശോധനകളും ക്യാമ്പിൽ ലഭ്യമാക്കി.",
      thumb: "assets/img/Pastevents/5450.jpg",
    },
    {
      src: "assets/img/Pastevents/5451.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയും ,നല്ലയണി ശ്രീ ധർമ ശാസ്താക്ഷേത്രയോഗം ട്രസ്റ്റിന്റെയും ആഭിമുഖ്യത്തിൽ സംയുക്തമായി സംഘടിപ്പിച്ച സൗജന്യ മെഡിക്കൽ ക്യാമ്പ്. നിംസ് മെഡിസിറ്റിയിലെ ജനറൽ മെഡിസിൻ, ദന്തൽ ,ഒഫ്താൽമോളജി തുടങ്ങി വിഭാഗങ്ങളിലെ വിദഗ്ദ്ധരും ഇ സി ജി, രക്തസമ്മർദ്ദo, പ്രമേഹരോഗ നിർണയം തുടങ്ങി പരിശോധനകളും ക്യാമ്പിൽ ലഭ്യമാക്കി.",
      thumb: "assets/img/Pastevents/5451.jpg",
    },
    {
      src: "assets/img/Pastevents/5452.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയും ,നല്ലയണി ശ്രീ ധർമ ശാസ്താക്ഷേത്രയോഗം ട്രസ്റ്റിന്റെയും ആഭിമുഖ്യത്തിൽ സംയുക്തമായി സംഘടിപ്പിച്ച സൗജന്യ മെഡിക്കൽ ക്യാമ്പ്. നിംസ് മെഡിസിറ്റിയിലെ ജനറൽ മെഡിസിൻ, ദന്തൽ ,ഒഫ്താൽമോളജി തുടങ്ങി വിഭാഗങ്ങളിലെ വിദഗ്ദ്ധരും ഇ സി ജി, രക്തസമ്മർദ്ദo, പ്രമേഹരോഗ നിർണയം തുടങ്ങി പരിശോധനകളും ക്യാമ്പിൽ ലഭ്യമാക്കി.",
      thumb: "assets/img/Pastevents/5452.jpg",
    },
    {
      src: "assets/img/Pastevents/5453.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയും ,നല്ലയണി ശ്രീ ധർമ ശാസ്താക്ഷേത്രയോഗം ട്രസ്റ്റിന്റെയും ആഭിമുഖ്യത്തിൽ സംയുക്തമായി സംഘടിപ്പിച്ച സൗജന്യ മെഡിക്കൽ ക്യാമ്പ്. നിംസ് മെഡിസിറ്റിയിലെ ജനറൽ മെഡിസിൻ, ദന്തൽ ,ഒഫ്താൽമോളജി തുടങ്ങി വിഭാഗങ്ങളിലെ വിദഗ്ദ്ധരും ഇ സി ജി, രക്തസമ്മർദ്ദo, പ്രമേഹരോഗ നിർണയം തുടങ്ങി പരിശോധനകളും ക്യാമ്പിൽ ലഭ്യമാക്കി.",
      thumb: "assets/img/Pastevents/5453.jpg",
    },
    {
      src: "assets/img/Pastevents/5454.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയും ,നല്ലയണി ശ്രീ ധർമ ശാസ്താക്ഷേത്രയോഗം ട്രസ്റ്റിന്റെയും ആഭിമുഖ്യത്തിൽ സംയുക്തമായി സംഘടിപ്പിച്ച സൗജന്യ മെഡിക്കൽ ക്യാമ്പ്. നിംസ് മെഡിസിറ്റിയിലെ ജനറൽ മെഡിസിൻ, ദന്തൽ ,ഒഫ്താൽമോളജി തുടങ്ങി വിഭാഗങ്ങളിലെ വിദഗ്ദ്ധരും ഇ സി ജി, രക്തസമ്മർദ്ദo, പ്രമേഹരോഗ നിർണയം തുടങ്ങി പരിശോധനകളും ക്യാമ്പിൽ ലഭ്യമാക്കി.",
      thumb: "assets/img/Pastevents/5454.jpg",
    },
    {
      src: "assets/img/Pastevents/5455.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയും ,നല്ലയണി ശ്രീ ധർമ ശാസ്താക്ഷേത്രയോഗം ട്രസ്റ്റിന്റെയും ആഭിമുഖ്യത്തിൽ സംയുക്തമായി സംഘടിപ്പിച്ച സൗജന്യ മെഡിക്കൽ ക്യാമ്പ്. നിംസ് മെഡിസിറ്റിയിലെ ജനറൽ മെഡിസിൻ, ദന്തൽ ,ഒഫ്താൽമോളജി തുടങ്ങി വിഭാഗങ്ങളിലെ വിദഗ്ദ്ധരും ഇ സി ജി, രക്തസമ്മർദ്ദo, പ്രമേഹരോഗ നിർണയം തുടങ്ങി പരിശോധനകളും ക്യാമ്പിൽ ലഭ്യമാക്കി.",
      thumb: "assets/img/Pastevents/5455.jpg",
    },
    {
      src: "assets/img/Pastevents/5456.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയും ,നല്ലയണി ശ്രീ ധർമ ശാസ്താക്ഷേത്രയോഗം ട്രസ്റ്റിന്റെയും ആഭിമുഖ്യത്തിൽ സംയുക്തമായി സംഘടിപ്പിച്ച സൗജന്യ മെഡിക്കൽ ക്യാമ്പ്. നിംസ് മെഡിസിറ്റിയിലെ ജനറൽ മെഡിസിൻ, ദന്തൽ ,ഒഫ്താൽമോളജി തുടങ്ങി വിഭാഗങ്ങളിലെ വിദഗ്ദ്ധരും ഇ സി ജി, രക്തസമ്മർദ്ദo, പ്രമേഹരോഗ നിർണയം തുടങ്ങി പരിശോധനകളും ക്യാമ്പിൽ ലഭ്യമാക്കി.",
      thumb: "assets/img/Pastevents/5456.jpg",
    },
    {
      src: "assets/img/Pastevents/5457.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയും ,നല്ലയണി ശ്രീ ധർമ ശാസ്താക്ഷേത്രയോഗം ട്രസ്റ്റിന്റെയും ആഭിമുഖ്യത്തിൽ സംയുക്തമായി സംഘടിപ്പിച്ച സൗജന്യ മെഡിക്കൽ ക്യാമ്പ്. നിംസ് മെഡിസിറ്റിയിലെ ജനറൽ മെഡിസിൻ, ദന്തൽ ,ഒഫ്താൽമോളജി തുടങ്ങി വിഭാഗങ്ങളിലെ വിദഗ്ദ്ധരും ഇ സി ജി, രക്തസമ്മർദ്ദo, പ്രമേഹരോഗ നിർണയം തുടങ്ങി പരിശോധനകളും ക്യാമ്പിൽ ലഭ്യമാക്കി.",
      thumb: "assets/img/Pastevents/5457.jpg",
    },
    {
      src: "assets/img/Pastevents/5458.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയും ,നല്ലയണി ശ്രീ ധർമ ശാസ്താക്ഷേത്രയോഗം ട്രസ്റ്റിന്റെയും ആഭിമുഖ്യത്തിൽ സംയുക്തമായി സംഘടിപ്പിച്ച സൗജന്യ മെഡിക്കൽ ക്യാമ്പ്. നിംസ് മെഡിസിറ്റിയിലെ ജനറൽ മെഡിസിൻ, ദന്തൽ ,ഒഫ്താൽമോളജി തുടങ്ങി വിഭാഗങ്ങളിലെ വിദഗ്ദ്ധരും ഇ സി ജി, രക്തസമ്മർദ്ദo, പ്രമേഹരോഗ നിർണയം തുടങ്ങി പരിശോധനകളും ക്യാമ്പിൽ ലഭ്യമാക്കി.",
      thumb: "assets/img/Pastevents/5458.jpg",
    },
    {
      src: "assets/img/Pastevents/5459.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയും ,നല്ലയണി ശ്രീ ധർമ ശാസ്താക്ഷേത്രയോഗം ട്രസ്റ്റിന്റെയും ആഭിമുഖ്യത്തിൽ സംയുക്തമായി സംഘടിപ്പിച്ച സൗജന്യ മെഡിക്കൽ ക്യാമ്പ്. നിംസ് മെഡിസിറ്റിയിലെ ജനറൽ മെഡിസിൻ, ദന്തൽ ,ഒഫ്താൽമോളജി തുടങ്ങി വിഭാഗങ്ങളിലെ വിദഗ്ദ്ധരും ഇ സി ജി, രക്തസമ്മർദ്ദo, പ്രമേഹരോഗ നിർണയം തുടങ്ങി പരിശോധനകളും ക്യാമ്പിൽ ലഭ്യമാക്കി.",
      thumb: "assets/img/Pastevents/5459.jpg",
    },
    {
      src: "assets/img/Pastevents/5460.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയും ,നല്ലയണി ശ്രീ ധർമ ശാസ്താക്ഷേത്രയോഗം ട്രസ്റ്റിന്റെയും ആഭിമുഖ്യത്തിൽ സംയുക്തമായി സംഘടിപ്പിച്ച സൗജന്യ മെഡിക്കൽ ക്യാമ്പ്. നിംസ് മെഡിസിറ്റിയിലെ ജനറൽ മെഡിസിൻ, ദന്തൽ ,ഒഫ്താൽമോളജി തുടങ്ങി വിഭാഗങ്ങളിലെ വിദഗ്ദ്ധരും ഇ സി ജി, രക്തസമ്മർദ്ദo, പ്രമേഹരോഗ നിർണയം തുടങ്ങി പരിശോധനകളും ക്യാമ്പിൽ ലഭ്യമാക്കി.",
      thumb: "assets/img/Pastevents/5460.jpg",
    },
    {
      src: "assets/img/Pastevents/5461.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയും ,നല്ലയണി ശ്രീ ധർമ ശാസ്താക്ഷേത്രയോഗം ട്രസ്റ്റിന്റെയും ആഭിമുഖ്യത്തിൽ സംയുക്തമായി സംഘടിപ്പിച്ച സൗജന്യ മെഡിക്കൽ ക്യാമ്പ്. നിംസ് മെഡിസിറ്റിയിലെ ജനറൽ മെഡിസിൻ, ദന്തൽ ,ഒഫ്താൽമോളജി തുടങ്ങി വിഭാഗങ്ങളിലെ വിദഗ്ദ്ധരും ഇ സി ജി, രക്തസമ്മർദ്ദo, പ്രമേഹരോഗ നിർണയം തുടങ്ങി പരിശോധനകളും ക്യാമ്പിൽ ലഭ്യമാക്കി.",
      thumb: "assets/img/Pastevents/5461.jpg",
    },
    {
      src: "assets/img/Pastevents/5462.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയും ,നല്ലയണി ശ്രീ ധർമ ശാസ്താക്ഷേത്രയോഗം ട്രസ്റ്റിന്റെയും ആഭിമുഖ്യത്തിൽ സംയുക്തമായി സംഘടിപ്പിച്ച സൗജന്യ മെഡിക്കൽ ക്യാമ്പ്. നിംസ് മെഡിസിറ്റിയിലെ ജനറൽ മെഡിസിൻ, ദന്തൽ ,ഒഫ്താൽമോളജി തുടങ്ങി വിഭാഗങ്ങളിലെ വിദഗ്ദ്ധരും ഇ സി ജി, രക്തസമ്മർദ്ദo, പ്രമേഹരോഗ നിർണയം തുടങ്ങി പരിശോധനകളും ക്യാമ്പിൽ ലഭ്യമാക്കി.",
      thumb: "assets/img/Pastevents/5462.jpg",
    },
    {
      src: "assets/img/Pastevents/5463.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയും ,നല്ലയണി ശ്രീ ധർമ ശാസ്താക്ഷേത്രയോഗം ട്രസ്റ്റിന്റെയും ആഭിമുഖ്യത്തിൽ സംയുക്തമായി സംഘടിപ്പിച്ച സൗജന്യ മെഡിക്കൽ ക്യാമ്പ്. നിംസ് മെഡിസിറ്റിയിലെ ജനറൽ മെഡിസിൻ, ദന്തൽ ,ഒഫ്താൽമോളജി തുടങ്ങി വിഭാഗങ്ങളിലെ വിദഗ്ദ്ധരും ഇ സി ജി, രക്തസമ്മർദ്ദo, പ്രമേഹരോഗ നിർണയം തുടങ്ങി പരിശോധനകളും ക്യാമ്പിൽ ലഭ്യമാക്കി.",
      thumb: "assets/img/Pastevents/5463.jpg",
    },
    {
      src: "assets/img/Pastevents/5464.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയും ,നല്ലയണി ശ്രീ ധർമ ശാസ്താക്ഷേത്രയോഗം ട്രസ്റ്റിന്റെയും ആഭിമുഖ്യത്തിൽ സംയുക്തമായി സംഘടിപ്പിച്ച സൗജന്യ മെഡിക്കൽ ക്യാമ്പ്. നിംസ് മെഡിസിറ്റിയിലെ ജനറൽ മെഡിസിൻ, ദന്തൽ ,ഒഫ്താൽമോളജി തുടങ്ങി വിഭാഗങ്ങളിലെ വിദഗ്ദ്ധരും ഇ സി ജി, രക്തസമ്മർദ്ദo, പ്രമേഹരോഗ നിർണയം തുടങ്ങി പരിശോധനകളും ക്യാമ്പിൽ ലഭ്യമാക്കി.",
      thumb: "assets/img/Pastevents/5464.jpg",
    },
    {
      src: "assets/img/Pastevents/5465.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയും ,നല്ലയണി ശ്രീ ധർമ ശാസ്താക്ഷേത്രയോഗം ട്രസ്റ്റിന്റെയും ആഭിമുഖ്യത്തിൽ സംയുക്തമായി സംഘടിപ്പിച്ച സൗജന്യ മെഡിക്കൽ ക്യാമ്പ്. നിംസ് മെഡിസിറ്റിയിലെ ജനറൽ മെഡിസിൻ, ദന്തൽ ,ഒഫ്താൽമോളജി തുടങ്ങി വിഭാഗങ്ങളിലെ വിദഗ്ദ്ധരും ഇ സി ജി, രക്തസമ്മർദ്ദo, പ്രമേഹരോഗ നിർണയം തുടങ്ങി പരിശോധനകളും ക്യാമ്പിൽ ലഭ്യമാക്കി.",
      thumb: "assets/img/Pastevents/5465.jpg",
    },
    {
      src: "assets/img/Pastevents/5466.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയും ,നല്ലയണി ശ്രീ ധർമ ശാസ്താക്ഷേത്രയോഗം ട്രസ്റ്റിന്റെയും ആഭിമുഖ്യത്തിൽ സംയുക്തമായി സംഘടിപ്പിച്ച സൗജന്യ മെഡിക്കൽ ക്യാമ്പ്. നിംസ് മെഡിസിറ്റിയിലെ ജനറൽ മെഡിസിൻ, ദന്തൽ ,ഒഫ്താൽമോളജി തുടങ്ങി വിഭാഗങ്ങളിലെ വിദഗ്ദ്ധരും ഇ സി ജി, രക്തസമ്മർദ്ദo, പ്രമേഹരോഗ നിർണയം തുടങ്ങി പരിശോധനകളും ക്യാമ്പിൽ ലഭ്യമാക്കി.",
      thumb: "assets/img/Pastevents/5466.jpg",
    },
    {
      src: "assets/img/Pastevents/5467.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയും ,നല്ലയണി ശ്രീ ധർമ ശാസ്താക്ഷേത്രയോഗം ട്രസ്റ്റിന്റെയും ആഭിമുഖ്യത്തിൽ സംയുക്തമായി സംഘടിപ്പിച്ച സൗജന്യ മെഡിക്കൽ ക്യാമ്പ്. നിംസ് മെഡിസിറ്റിയിലെ ജനറൽ മെഡിസിൻ, ദന്തൽ ,ഒഫ്താൽമോളജി തുടങ്ങി വിഭാഗങ്ങളിലെ വിദഗ്ദ്ധരും ഇ സി ജി, രക്തസമ്മർദ്ദo, പ്രമേഹരോഗ നിർണയം തുടങ്ങി പരിശോധനകളും ക്യാമ്പിൽ ലഭ്യമാക്കി.",
      thumb: "assets/img/Pastevents/5467.jpg",
    },
    {
      src: "assets/img/Pastevents/5437.jpg",
      caption:
        "കുരിശുമല തീർത്ഥാടനത്തിന്റെ ഭാഗമായി സൗജന്യ മെഡിക്കൽ സഹായവും ആംബുലൻസ് സർവീസും എല്ലാ ദിവസവും രാത്രി 12 മണി വരെ തീർത്ഥാടകർക്ക് പ്രയോജനപ്പെടുത്താവുന്നതാണ്",
      thumb: "assets/img/Pastevents/5437.jpg",
    },
    {
      src: "assets/img/Pastevents/5438.jpg",
      caption:
        "കുരിശുമല തീർത്ഥാടനത്തിന്റെ ഭാഗമായി സൗജന്യ മെഡിക്കൽ സഹായവും ആംബുലൻസ് സർവീസും എല്ലാ ദിവസവും രാത്രി 12 മണി വരെ തീർത്ഥാടകർക്ക് പ്രയോജനപ്പെടുത്താവുന്നതാണ്",
      thumb: "assets/img/Pastevents/5438.jpg",
    },
    {
      src: "assets/img/Pastevents/5439.jpg",
      caption:
        "കുരിശുമല തീർത്ഥാടനത്തിന്റെ ഭാഗമായി സൗജന്യ മെഡിക്കൽ സഹായവും ആംബുലൻസ് സർവീസും എല്ലാ ദിവസവും രാത്രി 12 മണി വരെ തീർത്ഥാടകർക്ക് പ്രയോജനപ്പെടുത്താവുന്നതാണ്",
      thumb: "assets/img/Pastevents/5439.jpg",
    },
    {
      src: "assets/img/Pastevents/5440.jpg",
      caption:
        "കുരിശുമല തീർത്ഥാടനത്തിന്റെ ഭാഗമായി സൗജന്യ മെഡിക്കൽ സഹായവും ആംബുലൻസ് സർവീസും എല്ലാ ദിവസവും രാത്രി 12 മണി വരെ തീർത്ഥാടകർക്ക് പ്രയോജനപ്പെടുത്താവുന്നതാണ്",
      thumb: "assets/img/Pastevents/5440.jpg",
    },
    {
      src: "assets/img/Pastevents/5441.jpg",
      caption:
        "കുരിശുമല തീർത്ഥാടനത്തിന്റെ ഭാഗമായി സൗജന്യ മെഡിക്കൽ സഹായവും ആംബുലൻസ് സർവീസും എല്ലാ ദിവസവും രാത്രി 12 മണി വരെ തീർത്ഥാടകർക്ക് പ്രയോജനപ്പെടുത്താവുന്നതാണ്",
      thumb: "assets/img/Pastevents/5441.jpg",
    },
    {
      src: "assets/img/Pastevents/5442.jpg",
      caption:
        "കുരിശുമല തീർത്ഥാടനത്തിന്റെ ഭാഗമായി സൗജന്യ മെഡിക്കൽ സഹായവും ആംബുലൻസ് സർവീസും എല്ലാ ദിവസവും രാത്രി 12 മണി വരെ തീർത്ഥാടകർക്ക് പ്രയോജനപ്പെടുത്താവുന്നതാണ്",
      thumb: "assets/img/Pastevents/5442.jpg",
    },
    {
      src: "assets/img/Pastevents/5443.jpg",
      caption:
        "കുരിശുമല തീർത്ഥാടനത്തിന്റെ ഭാഗമായി സൗജന്യ മെഡിക്കൽ സഹായവും ആംബുലൻസ് സർവീസും എല്ലാ ദിവസവും രാത്രി 12 മണി വരെ തീർത്ഥാടകർക്ക് പ്രയോജനപ്പെടുത്താവുന്നതാണ്",
      thumb: "assets/img/Pastevents/5443.jpg",
    },
    {
      src: "assets/img/Pastevents/5444.jpg",
      caption:
        "കുരിശുമല തീർത്ഥാടനത്തിന്റെ ഭാഗമായി സൗജന്യ മെഡിക്കൽ സഹായവും ആംബുലൻസ് സർവീസും എല്ലാ ദിവസവും രാത്രി 12 മണി വരെ തീർത്ഥാടകർക്ക് പ്രയോജനപ്പെടുത്താവുന്നതാണ്",
      thumb: "assets/img/Pastevents/5444.jpg",
    },
    {
      src: "assets/img/Pastevents/5445.jpg",
      caption:
        "കുരിശുമല തീർത്ഥാടനത്തിന്റെ ഭാഗമായി സൗജന്യ മെഡിക്കൽ സഹായവും ആംബുലൻസ് സർവീസും എല്ലാ ദിവസവും രാത്രി 12 മണി വരെ തീർത്ഥാടകർക്ക് പ്രയോജനപ്പെടുത്താവുന്നതാണ്",
      thumb: "assets/img/Pastevents/5445.jpg",
    },
    {
      src: "assets/img/Pastevents/5419.jpg",
      caption:
        "മീഡിയ ഫുട്ബോൾ ലീഗ് 💖 തിരുവനന്തപുരം പ്രസ് ക്ലബിന്റെ ‌ ആഭിമുഖ്യത്തിൽ ചന്ദ്രശേഖരൻ നായർ സ്റ്റേഡിയത്തിൽ വച്ച് നിംസ് സംഘടിപ്പിച്ച വൈദ്യ സഹായ ക്യാമ്പ് ",
      thumb: "assets/img/Pastevents/5419.jpg",
    },
    {
      src: "assets/img/Pastevents/5420.jpg",
      caption:
        "മീഡിയ ഫുട്ബോൾ ലീഗ് 💖 തിരുവനന്തപുരം പ്രസ് ക്ലബിന്റെ ‌ ആഭിമുഖ്യത്തിൽ ചന്ദ്രശേഖരൻ നായർ സ്റ്റേഡിയത്തിൽ വച്ച് നിംസ് സംഘടിപ്പിച്ച വൈദ്യ സഹായ ക്യാമ്പ് ",
      thumb: "assets/img/Pastevents/5420.jpg",
    },
    {
      src: "assets/img/Pastevents/5421.jpg",
      caption:
        "മീഡിയ ഫുട്ബോൾ ലീഗ് 💖 തിരുവനന്തപുരം പ്രസ് ക്ലബിന്റെ ‌ ആഭിമുഖ്യത്തിൽ ചന്ദ്രശേഖരൻ നായർ സ്റ്റേഡിയത്തിൽ വച്ച് നിംസ് സംഘടിപ്പിച്ച വൈദ്യ സഹായ ക്യാമ്പ് ",
      thumb: "assets/img/Pastevents/5421.jpg",
    },
    {
      src: "assets/img/Pastevents/5422.jpg",
      caption:
        "മീഡിയ ഫുട്ബോൾ ലീഗ് 💖 തിരുവനന്തപുരം പ്രസ് ക്ലബിന്റെ ‌ ആഭിമുഖ്യത്തിൽ ചന്ദ്രശേഖരൻ നായർ സ്റ്റേഡിയത്തിൽ വച്ച് നിംസ് സംഘടിപ്പിച്ച വൈദ്യ സഹായ ക്യാമ്പ് ",
      thumb: "assets/img/Pastevents/5422.jpg",
    },
    {
      src: "assets/img/Pastevents/5423.jpg",
      caption:
        "മീഡിയ ഫുട്ബോൾ ലീഗ് 💖 തിരുവനന്തപുരം പ്രസ് ക്ലബിന്റെ ‌ ആഭിമുഖ്യത്തിൽ ചന്ദ്രശേഖരൻ നായർ സ്റ്റേഡിയത്തിൽ വച്ച് നിംസ് സംഘടിപ്പിച്ച വൈദ്യ സഹായ ക്യാമ്പ് ",
      thumb: "assets/img/Pastevents/5423.jpg",
    },
    {
      src: "assets/img/Pastevents/5424.jpg",
      caption:
        "മീഡിയ ഫുട്ബോൾ ലീഗ് 💖 തിരുവനന്തപുരം പ്രസ് ക്ലബിന്റെ ‌ ആഭിമുഖ്യത്തിൽ ചന്ദ്രശേഖരൻ നായർ സ്റ്റേഡിയത്തിൽ വച്ച് നിംസ് സംഘടിപ്പിച്ച വൈദ്യ സഹായ ക്യാമ്പ് ",
      thumb: "assets/img/Pastevents/5424.jpg",
    },
    {
      src: "assets/img/Pastevents/5425.jpg",
      caption:
        "മീഡിയ ഫുട്ബോൾ ലീഗ് 💖 തിരുവനന്തപുരം പ്രസ് ക്ലബിന്റെ ‌ ആഭിമുഖ്യത്തിൽ ചന്ദ്രശേഖരൻ നായർ സ്റ്റേഡിയത്തിൽ വച്ച് നിംസ് സംഘടിപ്പിച്ച വൈദ്യ സഹായ ക്യാമ്പ് ",
      thumb: "assets/img/Pastevents/5425.jpg",
    },
    {
      src: "assets/img/Pastevents/5426.jpg",
      caption:
        "മീഡിയ ഫുട്ബോൾ ലീഗ് 💖 തിരുവനന്തപുരം പ്രസ് ക്ലബിന്റെ ‌ ആഭിമുഖ്യത്തിൽ ചന്ദ്രശേഖരൻ നായർ സ്റ്റേഡിയത്തിൽ വച്ച് നിംസ് സംഘടിപ്പിച്ച വൈദ്യ സഹായ ക്യാമ്പ് ",
      thumb: "assets/img/Pastevents/5426.jpg",
    },
    {
      src: "assets/img/Pastevents/5427.jpg",
      caption:
        "മീഡിയ ഫുട്ബോൾ ലീഗ് 💖 തിരുവനന്തപുരം പ്രസ് ക്ലബിന്റെ ‌ ആഭിമുഖ്യത്തിൽ ചന്ദ്രശേഖരൻ നായർ സ്റ്റേഡിയത്തിൽ വച്ച് നിംസ് സംഘടിപ്പിച്ച വൈദ്യ സഹായ ക്യാമ്പ് ",
      thumb: "assets/img/Pastevents/5427.jpg",
    },
    {
      src: "assets/img/Pastevents/5428.jpg",
      caption:
        "മീഡിയ ഫുട്ബോൾ ലീഗ് 💖 തിരുവനന്തപുരം പ്രസ് ക്ലബിന്റെ ‌ ആഭിമുഖ്യത്തിൽ ചന്ദ്രശേഖരൻ നായർ സ്റ്റേഡിയത്തിൽ വച്ച് നിംസ് സംഘടിപ്പിച്ച വൈദ്യ സഹായ ക്യാമ്പ് ",
      thumb: "assets/img/Pastevents/5428.jpg",
    },
    {
      src: "assets/img/Pastevents/5429.jpg",
      caption:
        "മീഡിയ ഫുട്ബോൾ ലീഗ് 💖 തിരുവനന്തപുരം പ്രസ് ക്ലബിന്റെ ‌ ആഭിമുഖ്യത്തിൽ ചന്ദ്രശേഖരൻ നായർ സ്റ്റേഡിയത്തിൽ വച്ച് നിംസ് സംഘടിപ്പിച്ച വൈദ്യ സഹായ ക്യാമ്പ് ",
      thumb: "assets/img/Pastevents/5429.jpg",
    },
    {
      src: "assets/img/Pastevents/5430.jpg",
      caption:
        "മീഡിയ ഫുട്ബോൾ ലീഗ് 💖 തിരുവനന്തപുരം പ്രസ് ക്ലബിന്റെ ‌ ആഭിമുഖ്യത്തിൽ ചന്ദ്രശേഖരൻ നായർ സ്റ്റേഡിയത്തിൽ വച്ച് നിംസ് സംഘടിപ്പിച്ച വൈദ്യ സഹായ ക്യാമ്പ് ",
      thumb: "assets/img/Pastevents/5430.jpg",
    },
    {
      src: "assets/img/Pastevents/5431.jpg",
      caption:
        "മീഡിയ ഫുട്ബോൾ ലീഗ് 💖 തിരുവനന്തപുരം പ്രസ് ക്ലബിന്റെ ‌ ആഭിമുഖ്യത്തിൽ ചന്ദ്രശേഖരൻ നായർ സ്റ്റേഡിയത്തിൽ വച്ച് നിംസ് സംഘടിപ്പിച്ച വൈദ്യ സഹായ ക്യാമ്പ് ",
      thumb: "assets/img/Pastevents/5431.jpg",
    },
    {
      src: "assets/img/Pastevents/5432.jpg",
      caption:
        "മീഡിയ ഫുട്ബോൾ ലീഗ് 💖 തിരുവനന്തപുരം പ്രസ് ക്ലബിന്റെ ‌ ആഭിമുഖ്യത്തിൽ ചന്ദ്രശേഖരൻ നായർ സ്റ്റേഡിയത്തിൽ വച്ച് നിംസ് സംഘടിപ്പിച്ച വൈദ്യ സഹായ ക്യാമ്പ് ",
      thumb: "assets/img/Pastevents/5432.jpg",
    },
    {
      src: "assets/img/Pastevents/5433.jpg",
      caption:
        "മീഡിയ ഫുട്ബോൾ ലീഗ് 💖 തിരുവനന്തപുരം പ്രസ് ക്ലബിന്റെ ‌ ആഭിമുഖ്യത്തിൽ ചന്ദ്രശേഖരൻ നായർ സ്റ്റേഡിയത്തിൽ വച്ച് നിംസ് സംഘടിപ്പിച്ച വൈദ്യ സഹായ ക്യാമ്പ് ",
      thumb: "assets/img/Pastevents/5433.jpg",
    },
    {
      src: "assets/img/Pastevents/5434.jpg",
      caption:
        "മീഡിയ ഫുട്ബോൾ ലീഗ് 💖 തിരുവനന്തപുരം പ്രസ് ക്ലബിന്റെ ‌ ആഭിമുഖ്യത്തിൽ ചന്ദ്രശേഖരൻ നായർ സ്റ്റേഡിയത്തിൽ വച്ച് നിംസ് സംഘടിപ്പിച്ച വൈദ്യ സഹായ ക്യാമ്പ് ",
      thumb: "assets/img/Pastevents/5434.jpg",
    },
    {
      src: "assets/img/Pastevents/5435.jpg",
      caption:
        "മീഡിയ ഫുട്ബോൾ ലീഗ് 💖 തിരുവനന്തപുരം പ്രസ് ക്ലബിന്റെ ‌ ആഭിമുഖ്യത്തിൽ ചന്ദ്രശേഖരൻ നായർ സ്റ്റേഡിയത്തിൽ വച്ച് നിംസ് സംഘടിപ്പിച്ച വൈദ്യ സഹായ ക്യാമ്പ് ",
      thumb: "assets/img/Pastevents/5435.jpg",
    },
    {
      src: "assets/img/Pastevents/5436.jpg",
      caption:
        "മീഡിയ ഫുട്ബോൾ ലീഗ് 💖 തിരുവനന്തപുരം പ്രസ് ക്ലബിന്റെ ‌ ആഭിമുഖ്യത്തിൽ ചന്ദ്രശേഖരൻ നായർ സ്റ്റേഡിയത്തിൽ വച്ച് നിംസ് സംഘടിപ്പിച്ച വൈദ്യ സഹായ ക്യാമ്പ് ",
      thumb: "assets/img/Pastevents/5436.jpg",
    },
    {
      src: "assets/img/Pastevents/5409.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ സ്വർഗ്ഗാരോപിത മാതാ ഫൊറോന ദൈവാലയം, മരിയൻ തീർത്ഥാടന കേന്ദ്രം , വ്ളാത്താങ്കര  നിഡ്സ് യൂണിറ്റ് സംയുക്തമായി വ്ളാത്താങ്കര ദൈവാലയം അങ്കണത്തിൽ വച്ച് നടന്ന സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് .... ജനറൽ മെഡിസിൻ , ദന്തൽ, ഒഫ്താൽമോളജി, ഡിറ്റിഷ്യൻ തുടങ്ങി വിഭാഗങ്ങളിലെ വിദഗ്ദ്ധരും ഇ സി ജി, രക്തസമ്മർദ്ദപരിശോധന, പ്രമേഹരോഗ നിർണയം തുടങ്ങിയ സൗജന്യ സേവനങ്ങളും ക്യാമ്പിൽ ലഭ്യമാക്കിയിരുന്നു...",
      thumb: "assets/img/Pastevents/5409.jpg",
    },
    {
      src: "assets/img/Pastevents/5410.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ സ്വർഗ്ഗാരോപിത മാതാ ഫൊറോന ദൈവാലയം, മരിയൻ തീർത്ഥാടന കേന്ദ്രം , വ്ളാത്താങ്കര  നിഡ്സ് യൂണിറ്റ് സംയുക്തമായി വ്ളാത്താങ്കര ദൈവാലയം അങ്കണത്തിൽ വച്ച് നടന്ന സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് .... ജനറൽ മെഡിസിൻ , ദന്തൽ, ഒഫ്താൽമോളജി, ഡിറ്റിഷ്യൻ തുടങ്ങി വിഭാഗങ്ങളിലെ വിദഗ്ദ്ധരും ഇ സി ജി, രക്തസമ്മർദ്ദപരിശോധന, പ്രമേഹരോഗ നിർണയം തുടങ്ങിയ സൗജന്യ സേവനങ്ങളും ക്യാമ്പിൽ ലഭ്യമാക്കിയിരുന്നു...",
      thumb: "assets/img/Pastevents/5410.jpg",
    },
    {
      src: "assets/img/Pastevents/5411.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ സ്വർഗ്ഗാരോപിത മാതാ ഫൊറോന ദൈവാലയം, മരിയൻ തീർത്ഥാടന കേന്ദ്രം , വ്ളാത്താങ്കര  നിഡ്സ് യൂണിറ്റ് സംയുക്തമായി വ്ളാത്താങ്കര ദൈവാലയം അങ്കണത്തിൽ വച്ച് നടന്ന സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് .... ജനറൽ മെഡിസിൻ , ദന്തൽ, ഒഫ്താൽമോളജി, ഡിറ്റിഷ്യൻ തുടങ്ങി വിഭാഗങ്ങളിലെ വിദഗ്ദ്ധരും ഇ സി ജി, രക്തസമ്മർദ്ദപരിശോധന, പ്രമേഹരോഗ നിർണയം തുടങ്ങിയ സൗജന്യ സേവനങ്ങളും ക്യാമ്പിൽ ലഭ്യമാക്കിയിരുന്നു...",
      thumb: "assets/img/Pastevents/5411.jpg",
    },
    {
      src: "assets/img/Pastevents/5412.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ സ്വർഗ്ഗാരോപിത മാതാ ഫൊറോന ദൈവാലയം, മരിയൻ തീർത്ഥാടന കേന്ദ്രം , വ്ളാത്താങ്കര  നിഡ്സ് യൂണിറ്റ് സംയുക്തമായി വ്ളാത്താങ്കര ദൈവാലയം അങ്കണത്തിൽ വച്ച് നടന്ന സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് .... ജനറൽ മെഡിസിൻ , ദന്തൽ, ഒഫ്താൽമോളജി, ഡിറ്റിഷ്യൻ തുടങ്ങി വിഭാഗങ്ങളിലെ വിദഗ്ദ്ധരും ഇ സി ജി, രക്തസമ്മർദ്ദപരിശോധന, പ്രമേഹരോഗ നിർണയം തുടങ്ങിയ സൗജന്യ സേവനങ്ങളും ക്യാമ്പിൽ ലഭ്യമാക്കിയിരുന്നു...",
      thumb: "assets/img/Pastevents/5412.jpg",
    },
    {
      src: "assets/img/Pastevents/5413.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ സ്വർഗ്ഗാരോപിത മാതാ ഫൊറോന ദൈവാലയം, മരിയൻ തീർത്ഥാടന കേന്ദ്രം , വ്ളാത്താങ്കര  നിഡ്സ് യൂണിറ്റ് സംയുക്തമായി വ്ളാത്താങ്കര ദൈവാലയം അങ്കണത്തിൽ വച്ച് നടന്ന സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് .... ജനറൽ മെഡിസിൻ , ദന്തൽ, ഒഫ്താൽമോളജി, ഡിറ്റിഷ്യൻ തുടങ്ങി വിഭാഗങ്ങളിലെ വിദഗ്ദ്ധരും ഇ സി ജി, രക്തസമ്മർദ്ദപരിശോധന, പ്രമേഹരോഗ നിർണയം തുടങ്ങിയ സൗജന്യ സേവനങ്ങളും ക്യാമ്പിൽ ലഭ്യമാക്കിയിരുന്നു...",
      thumb: "assets/img/Pastevents/5413.jpg",
    },
    {
      src: "assets/img/Pastevents/5414.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ സ്വർഗ്ഗാരോപിത മാതാ ഫൊറോന ദൈവാലയം, മരിയൻ തീർത്ഥാടന കേന്ദ്രം , വ്ളാത്താങ്കര  നിഡ്സ് യൂണിറ്റ് സംയുക്തമായി വ്ളാത്താങ്കര ദൈവാലയം അങ്കണത്തിൽ വച്ച് നടന്ന സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് .... ജനറൽ മെഡിസിൻ , ദന്തൽ, ഒഫ്താൽമോളജി, ഡിറ്റിഷ്യൻ തുടങ്ങി വിഭാഗങ്ങളിലെ വിദഗ്ദ്ധരും ഇ സി ജി, രക്തസമ്മർദ്ദപരിശോധന, പ്രമേഹരോഗ നിർണയം തുടങ്ങിയ സൗജന്യ സേവനങ്ങളും ക്യാമ്പിൽ ലഭ്യമാക്കിയിരുന്നു...",
      thumb: "assets/img/Pastevents/5414.jpg",
    },
    {
      src: "assets/img/Pastevents/5415.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ സ്വർഗ്ഗാരോപിത മാതാ ഫൊറോന ദൈവാലയം, മരിയൻ തീർത്ഥാടന കേന്ദ്രം , വ്ളാത്താങ്കര  നിഡ്സ് യൂണിറ്റ് സംയുക്തമായി വ്ളാത്താങ്കര ദൈവാലയം അങ്കണത്തിൽ വച്ച് നടന്ന സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് .... ജനറൽ മെഡിസിൻ , ദന്തൽ, ഒഫ്താൽമോളജി, ഡിറ്റിഷ്യൻ തുടങ്ങി വിഭാഗങ്ങളിലെ വിദഗ്ദ്ധരും ഇ സി ജി, രക്തസമ്മർദ്ദപരിശോധന, പ്രമേഹരോഗ നിർണയം തുടങ്ങിയ സൗജന്യ സേവനങ്ങളും ക്യാമ്പിൽ ലഭ്യമാക്കിയിരുന്നു...",
      thumb: "assets/img/Pastevents/5415.jpg",
    },
    {
      src: "assets/img/Pastevents/5416.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ സ്വർഗ്ഗാരോപിത മാതാ ഫൊറോന ദൈവാലയം, മരിയൻ തീർത്ഥാടന കേന്ദ്രം , വ്ളാത്താങ്കര  നിഡ്സ് യൂണിറ്റ് സംയുക്തമായി വ്ളാത്താങ്കര ദൈവാലയം അങ്കണത്തിൽ വച്ച് നടന്ന സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് .... ജനറൽ മെഡിസിൻ , ദന്തൽ, ഒഫ്താൽമോളജി, ഡിറ്റിഷ്യൻ തുടങ്ങി വിഭാഗങ്ങളിലെ വിദഗ്ദ്ധരും ഇ സി ജി, രക്തസമ്മർദ്ദപരിശോധന, പ്രമേഹരോഗ നിർണയം തുടങ്ങിയ സൗജന്യ സേവനങ്ങളും ക്യാമ്പിൽ ലഭ്യമാക്കിയിരുന്നു...",
      thumb: "assets/img/Pastevents/5416.jpg",
    },
    {
      src: "assets/img/Pastevents/5417.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ സ്വർഗ്ഗാരോപിത മാതാ ഫൊറോന ദൈവാലയം, മരിയൻ തീർത്ഥാടന കേന്ദ്രം , വ്ളാത്താങ്കര  നിഡ്സ് യൂണിറ്റ് സംയുക്തമായി വ്ളാത്താങ്കര ദൈവാലയം അങ്കണത്തിൽ വച്ച് നടന്ന സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് .... ജനറൽ മെഡിസിൻ , ദന്തൽ, ഒഫ്താൽമോളജി, ഡിറ്റിഷ്യൻ തുടങ്ങി വിഭാഗങ്ങളിലെ വിദഗ്ദ്ധരും ഇ സി ജി, രക്തസമ്മർദ്ദപരിശോധന, പ്രമേഹരോഗ നിർണയം തുടങ്ങിയ സൗജന്യ സേവനങ്ങളും ക്യാമ്പിൽ ലഭ്യമാക്കിയിരുന്നു...",
      thumb: "assets/img/Pastevents/5417.jpg",
    },
    {
      src: "assets/img/Pastevents/5418.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ സ്വർഗ്ഗാരോപിത മാതാ ഫൊറോന ദൈവാലയം, മരിയൻ തീർത്ഥാടന കേന്ദ്രം , വ്ളാത്താങ്കര  നിഡ്സ് യൂണിറ്റ് സംയുക്തമായി വ്ളാത്താങ്കര ദൈവാലയം അങ്കണത്തിൽ വച്ച് നടന്ന സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് .... ജനറൽ മെഡിസിൻ , ദന്തൽ, ഒഫ്താൽമോളജി, ഡിറ്റിഷ്യൻ തുടങ്ങി വിഭാഗങ്ങളിലെ വിദഗ്ദ്ധരും ഇ സി ജി, രക്തസമ്മർദ്ദപരിശോധന, പ്രമേഹരോഗ നിർണയം തുടങ്ങിയ സൗജന്യ സേവനങ്ങളും ക്യാമ്പിൽ ലഭ്യമാക്കിയിരുന്നു...",
      thumb: "assets/img/Pastevents/5418.jpg",
    },
    {
      src: "assets/img/Pastevents/5404.jpg",
      caption:
        "അഞ്ചാമത്  നാഷണൽ യോഗാസന  സ്പോർട്സ് ചാമ്പ്യൻഷിപ്പിൽ നിംസ് വൈദ്യ സഹായ ക്യാമ്പ്.",
      thumb: "assets/img/Pastevents/5404.jpg",
    },
    {
      src: "assets/img/Pastevents/5405.jpg",
      caption:
        "അഞ്ചാമത്  നാഷണൽ യോഗാസന  സ്പോർട്സ് ചാമ്പ്യൻഷിപ്പിൽ നിംസ് വൈദ്യ സഹായ ക്യാമ്പ്.",
      thumb: "assets/img/Pastevents/5405.jpg",
    },
    {
      src: "assets/img/Pastevents/5406.jpg",
      caption:
        "അഞ്ചാമത്  നാഷണൽ യോഗാസന  സ്പോർട്സ് ചാമ്പ്യൻഷിപ്പിൽ നിംസ് വൈദ്യ സഹായ ക്യാമ്പ്.",
      thumb: "assets/img/Pastevents/5406.jpg",
    },
    {
      src: "assets/img/Pastevents/5407.jpg",
      caption:
        "അഞ്ചാമത്  നാഷണൽ യോഗാസന  സ്പോർട്സ് ചാമ്പ്യൻഷിപ്പിൽ നിംസ് വൈദ്യ സഹായ ക്യാമ്പ്.",
      thumb: "assets/img/Pastevents/5407.jpg",
    },
    {
      src: "assets/img/Pastevents/5408.jpg",
      caption:
        "അഞ്ചാമത്  നാഷണൽ യോഗാസന  സ്പോർട്സ് ചാമ്പ്യൻഷിപ്പിൽ നിംസ് വൈദ്യ സഹായ ക്യാമ്പ്.",
      thumb: "assets/img/Pastevents/5408.jpg",
    },
    {
      src: "assets/img/Pastevents/5397.jpg",
      caption:
        "ഉദയ പാലസ് കൺവെൻഷൻ സെന്ററിൽ വച്ചു ട്രിവാൻഡ്രം സെന്റർ ഫോർ പെർഫോമിംഗ്  ആർട്സ് സംഘടിപ്പിച്ച നൃത്താവിഷ്ക്കാര സന്ധ്യയിൽ  നിംസ് അടിയന്തിര വൈദ്യ സഹായ  ക്യാമ്പ്. ",
      thumb: "assets/img/Pastevents/5397.jpg",
    },
    {
      src: "assets/img/Pastevents/5398.jpg",
      caption:
        "ഉദയ പാലസ് കൺവെൻഷൻ സെന്ററിൽ വച്ചു ട്രിവാൻഡ്രം സെന്റർ ഫോർ പെർഫോമിംഗ്  ആർട്സ് സംഘടിപ്പിച്ച നൃത്താവിഷ്ക്കാര സന്ധ്യയിൽ  നിംസ് അടിയന്തിര വൈദ്യ സഹായ  ക്യാമ്പ്. ",
      thumb: "assets/img/Pastevents/5398.jpg",
    },
    {
      src: "assets/img/Pastevents/5399.jpg",
      caption:
        "ഉദയ പാലസ് കൺവെൻഷൻ സെന്ററിൽ വച്ചു ട്രിവാൻഡ്രം സെന്റർ ഫോർ പെർഫോമിംഗ്  ആർട്സ് സംഘടിപ്പിച്ച നൃത്താവിഷ്ക്കാര സന്ധ്യയിൽ  നിംസ് അടിയന്തിര വൈദ്യ സഹായ  ക്യാമ്പ്. ",
      thumb: "assets/img/Pastevents/5399.jpg",
    },
    {
      src: "assets/img/Pastevents/5400.jpg",
      caption:
        "ഉദയ പാലസ് കൺവെൻഷൻ സെന്ററിൽ വച്ചു ട്രിവാൻഡ്രം സെന്റർ ഫോർ പെർഫോമിംഗ്  ആർട്സ് സംഘടിപ്പിച്ച നൃത്താവിഷ്ക്കാര സന്ധ്യയിൽ  നിംസ് അടിയന്തിര വൈദ്യ സഹായ  ക്യാമ്പ്. ",
      thumb: "assets/img/Pastevents/5400.jpg",
    },
    {
      src: "assets/img/Pastevents/5401.jpg",
      caption:
        "ഉദയ പാലസ് കൺവെൻഷൻ സെന്ററിൽ വച്ചു ട്രിവാൻഡ്രം സെന്റർ ഫോർ പെർഫോമിംഗ്  ആർട്സ് സംഘടിപ്പിച്ച നൃത്താവിഷ്ക്കാര സന്ധ്യയിൽ  നിംസ് അടിയന്തിര വൈദ്യ സഹായ  ക്യാമ്പ്. ",
      thumb: "assets/img/Pastevents/5401.jpg",
    },
    {
      src: "assets/img/Pastevents/5402.jpg",
      caption:
        "ഉദയ പാലസ് കൺവെൻഷൻ സെന്ററിൽ വച്ചു ട്രിവാൻഡ്രം സെന്റർ ഫോർ പെർഫോമിംഗ്  ആർട്സ് സംഘടിപ്പിച്ച നൃത്താവിഷ്ക്കാര സന്ധ്യയിൽ  നിംസ് അടിയന്തിര വൈദ്യ സഹായ  ക്യാമ്പ്. ",
      thumb: "assets/img/Pastevents/5402.jpg",
    },
    {
      src: "assets/img/Pastevents/5403.jpg",
      caption:
        "ഉദയ പാലസ് കൺവെൻഷൻ സെന്ററിൽ വച്ചു ട്രിവാൻഡ്രം സെന്റർ ഫോർ പെർഫോമിംഗ്  ആർട്സ് സംഘടിപ്പിച്ച നൃത്താവിഷ്ക്കാര സന്ധ്യയിൽ  നിംസ് അടിയന്തിര വൈദ്യ സഹായ  ക്യാമ്പ്. ",
      thumb: "assets/img/Pastevents/5403.jpg",
    },
    {
      src: "assets/img/Pastevents/5380.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയും , സ്നേഹതീരം ഡേ കെയർ സെന്ററും  സംയുക്തമായി നടത്തിയ സൗജന്യ മെഡിക്കൽ ‌ക്യാമ്പ്.....",
      thumb: "assets/img/Pastevents/5380.jpg",
    },
    {
      src: "assets/img/Pastevents/5381.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയും , സ്നേഹതീരം ഡേ കെയർ സെന്ററും  സംയുക്തമായി നടത്തിയ സൗജന്യ മെഡിക്കൽ ‌ക്യാമ്പ്.....",
      thumb: "assets/img/Pastevents/5381.jpg",
    },
    {
      src: "assets/img/Pastevents/5382.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയും , സ്നേഹതീരം ഡേ കെയർ സെന്ററും  സംയുക്തമായി നടത്തിയ സൗജന്യ മെഡിക്കൽ ‌ക്യാമ്പ്.....",
      thumb: "assets/img/Pastevents/5382.jpg",
    },
    {
      src: "assets/img/Pastevents/5383.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയും , സ്നേഹതീരം ഡേ കെയർ സെന്ററും  സംയുക്തമായി നടത്തിയ സൗജന്യ മെഡിക്കൽ ‌ക്യാമ്പ്.....",
      thumb: "assets/img/Pastevents/5383.jpg",
    },
    {
      src: "assets/img/Pastevents/5384.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയും , സ്നേഹതീരം ഡേ കെയർ സെന്ററും  സംയുക്തമായി നടത്തിയ സൗജന്യ മെഡിക്കൽ ‌ക്യാമ്പ്.....",
      thumb: "assets/img/Pastevents/5384.jpg",
    },
    {
      src: "assets/img/Pastevents/5385.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയും , സ്നേഹതീരം ഡേ കെയർ സെന്ററും  സംയുക്തമായി നടത്തിയ സൗജന്യ മെഡിക്കൽ ‌ക്യാമ്പ്.....",
      thumb: "assets/img/Pastevents/5385.jpg",
    },
    {
      src: "assets/img/Pastevents/5386.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയും , സ്നേഹതീരം ഡേ കെയർ സെന്ററും  സംയുക്തമായി നടത്തിയ സൗജന്യ മെഡിക്കൽ ‌ക്യാമ്പ്.....",
      thumb: "assets/img/Pastevents/5386.jpg",
    },
    {
      src: "assets/img/Pastevents/5387.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയും , സ്നേഹതീരം ഡേ കെയർ സെന്ററും  സംയുക്തമായി നടത്തിയ സൗജന്യ മെഡിക്കൽ ‌ക്യാമ്പ്.....",
      thumb: "assets/img/Pastevents/5387.jpg",
    },
    {
      src: "assets/img/Pastevents/5388.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയും , സ്നേഹതീരം ഡേ കെയർ സെന്ററും  സംയുക്തമായി നടത്തിയ സൗജന്യ മെഡിക്കൽ ‌ക്യാമ്പ്.....",
      thumb: "assets/img/Pastevents/5388.jpg",
    },
    {
      src: "assets/img/Pastevents/5389.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയും , സ്നേഹതീരം ഡേ കെയർ സെന്ററും  സംയുക്തമായി നടത്തിയ സൗജന്യ മെഡിക്കൽ ‌ക്യാമ്പ്.....",
      thumb: "assets/img/Pastevents/5389.jpg",
    },
    {
      src: "assets/img/Pastevents/5390.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയും , സ്നേഹതീരം ഡേ കെയർ സെന്ററും  സംയുക്തമായി നടത്തിയ സൗജന്യ മെഡിക്കൽ ‌ക്യാമ്പ്.....",
      thumb: "assets/img/Pastevents/5390.jpg",
    },
    {
      src: "assets/img/Pastevents/5391.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയും , സ്നേഹതീരം ഡേ കെയർ സെന്ററും  സംയുക്തമായി നടത്തിയ സൗജന്യ മെഡിക്കൽ ‌ക്യാമ്പ്.....",
      thumb: "assets/img/Pastevents/5391.jpg",
    },
    {
      src: "assets/img/Pastevents/5392.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയും , സ്നേഹതീരം ഡേ കെയർ സെന്ററും  സംയുക്തമായി നടത്തിയ സൗജന്യ മെഡിക്കൽ ‌ക്യാമ്പ്.....",
      thumb: "assets/img/Pastevents/5392.jpg",
    },
    {
      src: "assets/img/Pastevents/5393.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയും , സ്നേഹതീരം ഡേ കെയർ സെന്ററും  സംയുക്തമായി നടത്തിയ സൗജന്യ മെഡിക്കൽ ‌ക്യാമ്പ്.....",
      thumb: "assets/img/Pastevents/5393.jpg",
    },
    {
      src: "assets/img/Pastevents/5394.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയും , സ്നേഹതീരം ഡേ കെയർ സെന്ററും  സംയുക്തമായി നടത്തിയ സൗജന്യ മെഡിക്കൽ ‌ക്യാമ്പ്.....",
      thumb: "assets/img/Pastevents/5394.jpg",
    },
    {
      src: "assets/img/Pastevents/5395.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയും , സ്നേഹതീരം ഡേ കെയർ സെന്ററും  സംയുക്തമായി നടത്തിയ സൗജന്യ മെഡിക്കൽ ‌ക്യാമ്പ്.....",
      thumb: "assets/img/Pastevents/5395.jpg",
    },
    {
      src: "assets/img/Pastevents/5396.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയും , സ്നേഹതീരം ഡേ കെയർ സെന്ററും  സംയുക്തമായി നടത്തിയ സൗജന്യ മെഡിക്കൽ ‌ക്യാമ്പ്.....",
      thumb: "assets/img/Pastevents/5396.jpg",
    },
    {
      src: "assets/img/Pastevents/5370.jpg",
      caption:
        "തിരുവനന്തപുരം കരുമം ശ്രീ ആയിരവല്ലി തമ്പുരാൻ ക്ഷേത്രം  തെയ്യം മഹോത്സവത്തോടനുബന്ധിച്ച് നിംസ്  മെഡിസിറ്റിയുടെയും നിംസ് മൈക്രോ ഹോസ്പിറ്റൽസിന്റെയും ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/5370.jpg",
    },
    {
      src: "assets/img/Pastevents/5371.jpg",
      caption:
        "തിരുവനന്തപുരം കരുമം ശ്രീ ആയിരവല്ലി തമ്പുരാൻ ക്ഷേത്രം  തെയ്യം മഹോത്സവത്തോടനുബന്ധിച്ച് നിംസ്  മെഡിസിറ്റിയുടെയും നിംസ് മൈക്രോ ഹോസ്പിറ്റൽസിന്റെയും ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/5371.jpg",
    },
    {
      src: "assets/img/Pastevents/5372.jpg",
      caption:
        "തിരുവനന്തപുരം കരുമം ശ്രീ ആയിരവല്ലി തമ്പുരാൻ ക്ഷേത്രം  തെയ്യം മഹോത്സവത്തോടനുബന്ധിച്ച് നിംസ്  മെഡിസിറ്റിയുടെയും നിംസ് മൈക്രോ ഹോസ്പിറ്റൽസിന്റെയും ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/5372.jpg",
    },
    {
      src: "assets/img/Pastevents/5373.jpg",
      caption:
        "തിരുവനന്തപുരം കരുമം ശ്രീ ആയിരവല്ലി തമ്പുരാൻ ക്ഷേത്രം  തെയ്യം മഹോത്സവത്തോടനുബന്ധിച്ച് നിംസ്  മെഡിസിറ്റിയുടെയും നിംസ് മൈക്രോ ഹോസ്പിറ്റൽസിന്റെയും ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/5373.jpg",
    },
    {
      src: "assets/img/Pastevents/5374.jpg",
      caption:
        "തിരുവനന്തപുരം കരുമം ശ്രീ ആയിരവല്ലി തമ്പുരാൻ ക്ഷേത്രം  തെയ്യം മഹോത്സവത്തോടനുബന്ധിച്ച് നിംസ്  മെഡിസിറ്റിയുടെയും നിംസ് മൈക്രോ ഹോസ്പിറ്റൽസിന്റെയും ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/5374.jpg",
    },
    {
      src: "assets/img/Pastevents/5375.jpg",
      caption:
        "തിരുവനന്തപുരം കരുമം ശ്രീ ആയിരവല്ലി തമ്പുരാൻ ക്ഷേത്രം  തെയ്യം മഹോത്സവത്തോടനുബന്ധിച്ച് നിംസ്  മെഡിസിറ്റിയുടെയും നിംസ് മൈക്രോ ഹോസ്പിറ്റൽസിന്റെയും ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/5375.jpg",
    },
    {
      src: "assets/img/Pastevents/5376.jpg",
      caption:
        "തിരുവനന്തപുരം കരുമം ശ്രീ ആയിരവല്ലി തമ്പുരാൻ ക്ഷേത്രം  തെയ്യം മഹോത്സവത്തോടനുബന്ധിച്ച് നിംസ്  മെഡിസിറ്റിയുടെയും നിംസ് മൈക്രോ ഹോസ്പിറ്റൽസിന്റെയും ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/5376.jpg",
    },
    {
      src: "assets/img/Pastevents/5377.jpg",
      caption:
        "തിരുവനന്തപുരം കരുമം ശ്രീ ആയിരവല്ലി തമ്പുരാൻ ക്ഷേത്രം  തെയ്യം മഹോത്സവത്തോടനുബന്ധിച്ച് നിംസ്  മെഡിസിറ്റിയുടെയും നിംസ് മൈക്രോ ഹോസ്പിറ്റൽസിന്റെയും ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/5377.jpg",
    },
    {
      src: "assets/img/Pastevents/5378.jpg",
      caption:
        "തിരുവനന്തപുരം കരുമം ശ്രീ ആയിരവല്ലി തമ്പുരാൻ ക്ഷേത്രം  തെയ്യം മഹോത്സവത്തോടനുബന്ധിച്ച് നിംസ്  മെഡിസിറ്റിയുടെയും നിംസ് മൈക്രോ ഹോസ്പിറ്റൽസിന്റെയും ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/5378.jpg",
    },
    {
      src: "assets/img/Pastevents/5379.jpg",
      caption:
        "തിരുവനന്തപുരം കരുമം ശ്രീ ആയിരവല്ലി തമ്പുരാൻ ക്ഷേത്രം  തെയ്യം മഹോത്സവത്തോടനുബന്ധിച്ച് നിംസ്  മെഡിസിറ്റിയുടെയും നിംസ് മൈക്രോ ഹോസ്പിറ്റൽസിന്റെയും ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/5379.jpg",
    },
    {
      src: "assets/img/Pastevents/5346.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയും അനന്തപുരി സോൾജിയേഴ്‌സ് വെൽഫെയർ & ചാരിറ്റി ഓർഗനൈസേഷനും സംയുക്തമായി നടത്തിയ സൗജന്യ മെഡിക്കൽ ‌ &  ബ്ലഡ്‌ ഡൊണേഷൻ  ക്യാമ്പ്",
      thumb: "assets/img/Pastevents/5346.jpg",
    },
    {
      src: "assets/img/Pastevents/5347.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയും അനന്തപുരി സോൾജിയേഴ്‌സ് വെൽഫെയർ & ചാരിറ്റി ഓർഗനൈസേഷനും സംയുക്തമായി നടത്തിയ സൗജന്യ മെഡിക്കൽ ‌ &  ബ്ലഡ്‌ ഡൊണേഷൻ  ക്യാമ്പ്",
      thumb: "assets/img/Pastevents/5347.jpg",
    },
    {
      src: "assets/img/Pastevents/5348.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയും അനന്തപുരി സോൾജിയേഴ്‌സ് വെൽഫെയർ & ചാരിറ്റി ഓർഗനൈസേഷനും സംയുക്തമായി നടത്തിയ സൗജന്യ മെഡിക്കൽ ‌ &  ബ്ലഡ്‌ ഡൊണേഷൻ  ക്യാമ്പ്",
      thumb: "assets/img/Pastevents/5348.jpg",
    },
    {
      src: "assets/img/Pastevents/5349.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയും അനന്തപുരി സോൾജിയേഴ്‌സ് വെൽഫെയർ & ചാരിറ്റി ഓർഗനൈസേഷനും സംയുക്തമായി നടത്തിയ സൗജന്യ മെഡിക്കൽ ‌ &  ബ്ലഡ്‌ ഡൊണേഷൻ  ക്യാമ്പ്",
      thumb: "assets/img/Pastevents/5349.jpg",
    },
    {
      src: "assets/img/Pastevents/5350.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയും അനന്തപുരി സോൾജിയേഴ്‌സ് വെൽഫെയർ & ചാരിറ്റി ഓർഗനൈസേഷനും സംയുക്തമായി നടത്തിയ സൗജന്യ മെഡിക്കൽ ‌ &  ബ്ലഡ്‌ ഡൊണേഷൻ  ക്യാമ്പ്",
      thumb: "assets/img/Pastevents/5350.jpg",
    },
    {
      src: "assets/img/Pastevents/5351.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയും അനന്തപുരി സോൾജിയേഴ്‌സ് വെൽഫെയർ & ചാരിറ്റി ഓർഗനൈസേഷനും സംയുക്തമായി നടത്തിയ സൗജന്യ മെഡിക്കൽ ‌ &  ബ്ലഡ്‌ ഡൊണേഷൻ  ക്യാമ്പ്",
      thumb: "assets/img/Pastevents/5351.jpg",
    },
    {
      src: "assets/img/Pastevents/5352.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയും അനന്തപുരി സോൾജിയേഴ്‌സ് വെൽഫെയർ & ചാരിറ്റി ഓർഗനൈസേഷനും സംയുക്തമായി നടത്തിയ സൗജന്യ മെഡിക്കൽ ‌ &  ബ്ലഡ്‌ ഡൊണേഷൻ  ക്യാമ്പ്",
      thumb: "assets/img/Pastevents/5352.jpg",
    },
    {
      src: "assets/img/Pastevents/5353.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയും അനന്തപുരി സോൾജിയേഴ്‌സ് വെൽഫെയർ & ചാരിറ്റി ഓർഗനൈസേഷനും സംയുക്തമായി നടത്തിയ സൗജന്യ മെഡിക്കൽ ‌ &  ബ്ലഡ്‌ ഡൊണേഷൻ  ക്യാമ്പ്",
      thumb: "assets/img/Pastevents/5353.jpg",
    },
    {
      src: "assets/img/Pastevents/5354.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയും അനന്തപുരി സോൾജിയേഴ്‌സ് വെൽഫെയർ & ചാരിറ്റി ഓർഗനൈസേഷനും സംയുക്തമായി നടത്തിയ സൗജന്യ മെഡിക്കൽ ‌ &  ബ്ലഡ്‌ ഡൊണേഷൻ  ക്യാമ്പ്",
      thumb: "assets/img/Pastevents/5354.jpg",
    },
    {
      src: "assets/img/Pastevents/5355.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയും അനന്തപുരി സോൾജിയേഴ്‌സ് വെൽഫെയർ & ചാരിറ്റി ഓർഗനൈസേഷനും സംയുക്തമായി നടത്തിയ സൗജന്യ മെഡിക്കൽ ‌ &  ബ്ലഡ്‌ ഡൊണേഷൻ  ക്യാമ്പ്",
      thumb: "assets/img/Pastevents/5355.jpg",
    },
    {
      src: "assets/img/Pastevents/5356.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയും അനന്തപുരി സോൾജിയേഴ്‌സ് വെൽഫെയർ & ചാരിറ്റി ഓർഗനൈസേഷനും സംയുക്തമായി നടത്തിയ സൗജന്യ മെഡിക്കൽ ‌ &  ബ്ലഡ്‌ ഡൊണേഷൻ  ക്യാമ്പ്",
      thumb: "assets/img/Pastevents/5356.jpg",
    },
    {
      src: "assets/img/Pastevents/5357.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയും അനന്തപുരി സോൾജിയേഴ്‌സ് വെൽഫെയർ & ചാരിറ്റി ഓർഗനൈസേഷനും സംയുക്തമായി നടത്തിയ സൗജന്യ മെഡിക്കൽ ‌ &  ബ്ലഡ്‌ ഡൊണേഷൻ  ക്യാമ്പ്",
      thumb: "assets/img/Pastevents/5357.jpg",
    },
    {
      src: "assets/img/Pastevents/5358.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയും അനന്തപുരി സോൾജിയേഴ്‌സ് വെൽഫെയർ & ചാരിറ്റി ഓർഗനൈസേഷനും സംയുക്തമായി നടത്തിയ സൗജന്യ മെഡിക്കൽ ‌ &  ബ്ലഡ്‌ ഡൊണേഷൻ  ക്യാമ്പ്",
      thumb: "assets/img/Pastevents/5358.jpg",
    },
    {
      src: "assets/img/Pastevents/5359.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയും അനന്തപുരി സോൾജിയേഴ്‌സ് വെൽഫെയർ & ചാരിറ്റി ഓർഗനൈസേഷനും സംയുക്തമായി നടത്തിയ സൗജന്യ മെഡിക്കൽ ‌ &  ബ്ലഡ്‌ ഡൊണേഷൻ  ക്യാമ്പ്",
      thumb: "assets/img/Pastevents/5359.jpg",
    },
    {
      src: "assets/img/Pastevents/5360.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയും അനന്തപുരി സോൾജിയേഴ്‌സ് വെൽഫെയർ & ചാരിറ്റി ഓർഗനൈസേഷനും സംയുക്തമായി നടത്തിയ സൗജന്യ മെഡിക്കൽ ‌ &  ബ്ലഡ്‌ ഡൊണേഷൻ  ക്യാമ്പ്",
      thumb: "assets/img/Pastevents/5360.jpg",
    },
    {
      src: "assets/img/Pastevents/5361.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയും അനന്തപുരി സോൾജിയേഴ്‌സ് വെൽഫെയർ & ചാരിറ്റി ഓർഗനൈസേഷനും സംയുക്തമായി നടത്തിയ സൗജന്യ മെഡിക്കൽ ‌ &  ബ്ലഡ്‌ ഡൊണേഷൻ  ക്യാമ്പ്",
      thumb: "assets/img/Pastevents/5361.jpg",
    },
    {
      src: "assets/img/Pastevents/5362.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയും അനന്തപുരി സോൾജിയേഴ്‌സ് വെൽഫെയർ & ചാരിറ്റി ഓർഗനൈസേഷനും സംയുക്തമായി നടത്തിയ സൗജന്യ മെഡിക്കൽ ‌ &  ബ്ലഡ്‌ ഡൊണേഷൻ  ക്യാമ്പ്",
      thumb: "assets/img/Pastevents/5362.jpg",
    },
    {
      src: "assets/img/Pastevents/5363.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയും അനന്തപുരി സോൾജിയേഴ്‌സ് വെൽഫെയർ & ചാരിറ്റി ഓർഗനൈസേഷനും സംയുക്തമായി നടത്തിയ സൗജന്യ മെഡിക്കൽ ‌ &  ബ്ലഡ്‌ ഡൊണേഷൻ  ക്യാമ്പ്",
      thumb: "assets/img/Pastevents/5363.jpg",
    },
    {
      src: "assets/img/Pastevents/5364.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയും അനന്തപുരി സോൾജിയേഴ്‌സ് വെൽഫെയർ & ചാരിറ്റി ഓർഗനൈസേഷനും സംയുക്തമായി നടത്തിയ സൗജന്യ മെഡിക്കൽ ‌ &  ബ്ലഡ്‌ ഡൊണേഷൻ  ക്യാമ്പ്",
      thumb: "assets/img/Pastevents/5364.jpg",
    },
    {
      src: "assets/img/Pastevents/5365.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയും അനന്തപുരി സോൾജിയേഴ്‌സ് വെൽഫെയർ & ചാരിറ്റി ഓർഗനൈസേഷനും സംയുക്തമായി നടത്തിയ സൗജന്യ മെഡിക്കൽ ‌ &  ബ്ലഡ്‌ ഡൊണേഷൻ  ക്യാമ്പ്",
      thumb: "assets/img/Pastevents/5365.jpg",
    },
    {
      src: "assets/img/Pastevents/5366.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയും അനന്തപുരി സോൾജിയേഴ്‌സ് വെൽഫെയർ & ചാരിറ്റി ഓർഗനൈസേഷനും സംയുക്തമായി നടത്തിയ സൗജന്യ മെഡിക്കൽ ‌ &  ബ്ലഡ്‌ ഡൊണേഷൻ  ക്യാമ്പ്",
      thumb: "assets/img/Pastevents/5366.jpg",
    },
    {
      src: "assets/img/Pastevents/5367.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയും അനന്തപുരി സോൾജിയേഴ്‌സ് വെൽഫെയർ & ചാരിറ്റി ഓർഗനൈസേഷനും സംയുക്തമായി നടത്തിയ സൗജന്യ മെഡിക്കൽ ‌ &  ബ്ലഡ്‌ ഡൊണേഷൻ  ക്യാമ്പ്",
      thumb: "assets/img/Pastevents/5367.jpg",
    },
    {
      src: "assets/img/Pastevents/5368.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയും അനന്തപുരി സോൾജിയേഴ്‌സ് വെൽഫെയർ & ചാരിറ്റി ഓർഗനൈസേഷനും സംയുക്തമായി നടത്തിയ സൗജന്യ മെഡിക്കൽ ‌ &  ബ്ലഡ്‌ ഡൊണേഷൻ  ക്യാമ്പ്",
      thumb: "assets/img/Pastevents/5368.jpg",
    },
    {
      src: "assets/img/Pastevents/5369.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയും അനന്തപുരി സോൾജിയേഴ്‌സ് വെൽഫെയർ & ചാരിറ്റി ഓർഗനൈസേഷനും സംയുക്തമായി നടത്തിയ സൗജന്യ മെഡിക്കൽ ‌ &  ബ്ലഡ്‌ ഡൊണേഷൻ  ക്യാമ്പ്",
      thumb: "assets/img/Pastevents/5369.jpg",
    },
    {
      src: "assets/img/Pastevents/5322.jpg",
      caption:
        "കാൻസർ സേഫ് കേരള രണ്ടാം ഘട്ടം പദ്ധതിയുടെ ഭാഗമായി കേരള സർക്കാർ \"ആരോഗ്യം-ആനന്ദം അകറ്റാം അർബുദം\" കാൻസർ പ്രതിരോധത്തിനായുള്ള സംസ്ഥാനതല ക്യാമ്പയിന്റെ ഭാഗമായി നിംസ് മെഡിസിറ്റി, സ്വസ്തി ഫൗണ്ടേഷൻ, സിറ്റിസൺസ് ഇന്ത്യ ഫൗണ്ടേഷൻ, തക്കല ആലയം ട്രസ്റ്റ് സംയുക്തമായി ആറ്റൂർ NVKS സീനിയർ സെക്കൻഡറി സ്കൂളിൽ വച്ച്  സൗജന്യ കാൻസർ നിർണ്ണയ മെഗാ ക്യാമ്പ് സംഘടിപ്പിച്ചു. NVKS ഗ്രൂപ്പ് ഓഫ് ഇൻസ്റ്റിറ്റ്യൂഷൻസ് സെക്രട്ടറി അഡ്വ. എസ് കൃഷ്ണകുമാർ ഉദ്ഘാടനം ചെയ്ത ക്യാമ്പിൽ നിംസ് മെഡിസിറ്റി മെഡിക്കൽ ഓൺകോളജിസ്റ്റ്  ഡോ.മിന്റു മാത്യു എബ്രഹാം,  ക്ലിനിക്കൽ ഓൺകോളജിസ്റ്റ് ഡോ.അഞ്ചു എസ് ചന്ദ്രബോസ്, എമർജൻസി ഡിപ്പാർട്ട്മെന്റ്  ഡോ. അഞ്ജന ആർ എന്നിവർ നേതൃത്വം നൽകി. ജനറൽ മെഡിസിൻ, ദന്തൽ, ഒഫ്താൽമോളജി തുടങ്ങി വിഭാഗങ്ങളിലെ വിദഗ്ധരുടെ സേവനവും ക്യാമ്പിൽ ലഭ്യമാക്കി.",
      thumb: "assets/img/Pastevents/5322.jpg",
    },
    {
      src: "assets/img/Pastevents/5323.jpg",
      caption:
        "കാൻസർ സേഫ് കേരള രണ്ടാം ഘട്ടം പദ്ധതിയുടെ ഭാഗമായി കേരള സർക്കാർ \"ആരോഗ്യം-ആനന്ദം അകറ്റാം അർബുദം\" കാൻസർ പ്രതിരോധത്തിനായുള്ള സംസ്ഥാനതല ക്യാമ്പയിന്റെ ഭാഗമായി നിംസ് മെഡിസിറ്റി, സ്വസ്തി ഫൗണ്ടേഷൻ, സിറ്റിസൺസ് ഇന്ത്യ ഫൗണ്ടേഷൻ, തക്കല ആലയം ട്രസ്റ്റ് സംയുക്തമായി ആറ്റൂർ NVKS സീനിയർ സെക്കൻഡറി സ്കൂളിൽ വച്ച്  സൗജന്യ കാൻസർ നിർണ്ണയ മെഗാ ക്യാമ്പ് സംഘടിപ്പിച്ചു. NVKS ഗ്രൂപ്പ് ഓഫ് ഇൻസ്റ്റിറ്റ്യൂഷൻസ് സെക്രട്ടറി അഡ്വ. എസ് കൃഷ്ണകുമാർ ഉദ്ഘാടനം ചെയ്ത ക്യാമ്പിൽ നിംസ് മെഡിസിറ്റി മെഡിക്കൽ ഓൺകോളജിസ്റ്റ്  ഡോ.മിന്റു മാത്യു എബ്രഹാം,  ക്ലിനിക്കൽ ഓൺകോളജിസ്റ്റ് ഡോ.അഞ്ചു എസ് ചന്ദ്രബോസ്, എമർജൻസി ഡിപ്പാർട്ട്മെന്റ്  ഡോ. അഞ്ജന ആർ എന്നിവർ നേതൃത്വം നൽകി. ജനറൽ മെഡിസിൻ, ദന്തൽ, ഒഫ്താൽമോളജി തുടങ്ങി വിഭാഗങ്ങളിലെ വിദഗ്ധരുടെ സേവനവും ക്യാമ്പിൽ ലഭ്യമാക്കി.",
      thumb: "assets/img/Pastevents/5323.jpg",
    },
    {
      src: "assets/img/Pastevents/5324.jpg",
      caption:
        "കാൻസർ സേഫ് കേരള രണ്ടാം ഘട്ടം പദ്ധതിയുടെ ഭാഗമായി കേരള സർക്കാർ \"ആരോഗ്യം-ആനന്ദം അകറ്റാം അർബുദം\" കാൻസർ പ്രതിരോധത്തിനായുള്ള സംസ്ഥാനതല ക്യാമ്പയിന്റെ ഭാഗമായി നിംസ് മെഡിസിറ്റി, സ്വസ്തി ഫൗണ്ടേഷൻ, സിറ്റിസൺസ് ഇന്ത്യ ഫൗണ്ടേഷൻ, തക്കല ആലയം ട്രസ്റ്റ് സംയുക്തമായി ആറ്റൂർ NVKS സീനിയർ സെക്കൻഡറി സ്കൂളിൽ വച്ച്  സൗജന്യ കാൻസർ നിർണ്ണയ മെഗാ ക്യാമ്പ് സംഘടിപ്പിച്ചു. NVKS ഗ്രൂപ്പ് ഓഫ് ഇൻസ്റ്റിറ്റ്യൂഷൻസ് സെക്രട്ടറി അഡ്വ. എസ് കൃഷ്ണകുമാർ ഉദ്ഘാടനം ചെയ്ത ക്യാമ്പിൽ നിംസ് മെഡിസിറ്റി മെഡിക്കൽ ഓൺകോളജിസ്റ്റ്  ഡോ.മിന്റു മാത്യു എബ്രഹാം,  ക്ലിനിക്കൽ ഓൺകോളജിസ്റ്റ് ഡോ.അഞ്ചു എസ് ചന്ദ്രബോസ്, എമർജൻസി ഡിപ്പാർട്ട്മെന്റ്  ഡോ. അഞ്ജന ആർ എന്നിവർ നേതൃത്വം നൽകി. ജനറൽ മെഡിസിൻ, ദന്തൽ, ഒഫ്താൽമോളജി തുടങ്ങി വിഭാഗങ്ങളിലെ വിദഗ്ധരുടെ സേവനവും ക്യാമ്പിൽ ലഭ്യമാക്കി.",
      thumb: "assets/img/Pastevents/5324.jpg",
    },
    {
      src: "assets/img/Pastevents/5325.jpg",
      caption:
        "കാൻസർ സേഫ് കേരള രണ്ടാം ഘട്ടം പദ്ധതിയുടെ ഭാഗമായി കേരള സർക്കാർ \"ആരോഗ്യം-ആനന്ദം അകറ്റാം അർബുദം\" കാൻസർ പ്രതിരോധത്തിനായുള്ള സംസ്ഥാനതല ക്യാമ്പയിന്റെ ഭാഗമായി നിംസ് മെഡിസിറ്റി, സ്വസ്തി ഫൗണ്ടേഷൻ, സിറ്റിസൺസ് ഇന്ത്യ ഫൗണ്ടേഷൻ, തക്കല ആലയം ട്രസ്റ്റ് സംയുക്തമായി ആറ്റൂർ NVKS സീനിയർ സെക്കൻഡറി സ്കൂളിൽ വച്ച്  സൗജന്യ കാൻസർ നിർണ്ണയ മെഗാ ക്യാമ്പ് സംഘടിപ്പിച്ചു. NVKS ഗ്രൂപ്പ് ഓഫ് ഇൻസ്റ്റിറ്റ്യൂഷൻസ് സെക്രട്ടറി അഡ്വ. എസ് കൃഷ്ണകുമാർ ഉദ്ഘാടനം ചെയ്ത ക്യാമ്പിൽ നിംസ് മെഡിസിറ്റി മെഡിക്കൽ ഓൺകോളജിസ്റ്റ്  ഡോ.മിന്റു മാത്യു എബ്രഹാം,  ക്ലിനിക്കൽ ഓൺകോളജിസ്റ്റ് ഡോ.അഞ്ചു എസ് ചന്ദ്രബോസ്, എമർജൻസി ഡിപ്പാർട്ട്മെന്റ്  ഡോ. അഞ്ജന ആർ എന്നിവർ നേതൃത്വം നൽകി. ജനറൽ മെഡിസിൻ, ദന്തൽ, ഒഫ്താൽമോളജി തുടങ്ങി വിഭാഗങ്ങളിലെ വിദഗ്ധരുടെ സേവനവും ക്യാമ്പിൽ ലഭ്യമാക്കി.",
      thumb: "assets/img/Pastevents/5325.jpg",
    },
    {
      src: "assets/img/Pastevents/5326.jpg",
      caption:
        "കാൻസർ സേഫ് കേരള രണ്ടാം ഘട്ടം പദ്ധതിയുടെ ഭാഗമായി കേരള സർക്കാർ \"ആരോഗ്യം-ആനന്ദം അകറ്റാം അർബുദം\" കാൻസർ പ്രതിരോധത്തിനായുള്ള സംസ്ഥാനതല ക്യാമ്പയിന്റെ ഭാഗമായി നിംസ് മെഡിസിറ്റി, സ്വസ്തി ഫൗണ്ടേഷൻ, സിറ്റിസൺസ് ഇന്ത്യ ഫൗണ്ടേഷൻ, തക്കല ആലയം ട്രസ്റ്റ് സംയുക്തമായി ആറ്റൂർ NVKS സീനിയർ സെക്കൻഡറി സ്കൂളിൽ വച്ച്  സൗജന്യ കാൻസർ നിർണ്ണയ മെഗാ ക്യാമ്പ് സംഘടിപ്പിച്ചു. NVKS ഗ്രൂപ്പ് ഓഫ് ഇൻസ്റ്റിറ്റ്യൂഷൻസ് സെക്രട്ടറി അഡ്വ. എസ് കൃഷ്ണകുമാർ ഉദ്ഘാടനം ചെയ്ത ക്യാമ്പിൽ നിംസ് മെഡിസിറ്റി മെഡിക്കൽ ഓൺകോളജിസ്റ്റ്  ഡോ.മിന്റു മാത്യു എബ്രഹാം,  ക്ലിനിക്കൽ ഓൺകോളജിസ്റ്റ് ഡോ.അഞ്ചു എസ് ചന്ദ്രബോസ്, എമർജൻസി ഡിപ്പാർട്ട്മെന്റ്  ഡോ. അഞ്ജന ആർ എന്നിവർ നേതൃത്വം നൽകി. ജനറൽ മെഡിസിൻ, ദന്തൽ, ഒഫ്താൽമോളജി തുടങ്ങി വിഭാഗങ്ങളിലെ വിദഗ്ധരുടെ സേവനവും ക്യാമ്പിൽ ലഭ്യമാക്കി.",
      thumb: "assets/img/Pastevents/5326.jpg",
    },
    {
      src: "assets/img/Pastevents/5327.jpg",
      caption:
        "കാൻസർ സേഫ് കേരള രണ്ടാം ഘട്ടം പദ്ധതിയുടെ ഭാഗമായി കേരള സർക്കാർ \"ആരോഗ്യം-ആനന്ദം അകറ്റാം അർബുദം\" കാൻസർ പ്രതിരോധത്തിനായുള്ള സംസ്ഥാനതല ക്യാമ്പയിന്റെ ഭാഗമായി നിംസ് മെഡിസിറ്റി, സ്വസ്തി ഫൗണ്ടേഷൻ, സിറ്റിസൺസ് ഇന്ത്യ ഫൗണ്ടേഷൻ, തക്കല ആലയം ട്രസ്റ്റ് സംയുക്തമായി ആറ്റൂർ NVKS സീനിയർ സെക്കൻഡറി സ്കൂളിൽ വച്ച്  സൗജന്യ കാൻസർ നിർണ്ണയ മെഗാ ക്യാമ്പ് സംഘടിപ്പിച്ചു. NVKS ഗ്രൂപ്പ് ഓഫ് ഇൻസ്റ്റിറ്റ്യൂഷൻസ് സെക്രട്ടറി അഡ്വ. എസ് കൃഷ്ണകുമാർ ഉദ്ഘാടനം ചെയ്ത ക്യാമ്പിൽ നിംസ് മെഡിസിറ്റി മെഡിക്കൽ ഓൺകോളജിസ്റ്റ്  ഡോ.മിന്റു മാത്യു എബ്രഹാം,  ക്ലിനിക്കൽ ഓൺകോളജിസ്റ്റ് ഡോ.അഞ്ചു എസ് ചന്ദ്രബോസ്, എമർജൻസി ഡിപ്പാർട്ട്മെന്റ്  ഡോ. അഞ്ജന ആർ എന്നിവർ നേതൃത്വം നൽകി. ജനറൽ മെഡിസിൻ, ദന്തൽ, ഒഫ്താൽമോളജി തുടങ്ങി വിഭാഗങ്ങളിലെ വിദഗ്ധരുടെ സേവനവും ക്യാമ്പിൽ ലഭ്യമാക്കി.",
      thumb: "assets/img/Pastevents/5327.jpg",
    },
    {
      src: "assets/img/Pastevents/5328.jpg",
      caption:
        "കാൻസർ സേഫ് കേരള രണ്ടാം ഘട്ടം പദ്ധതിയുടെ ഭാഗമായി കേരള സർക്കാർ \"ആരോഗ്യം-ആനന്ദം അകറ്റാം അർബുദം\" കാൻസർ പ്രതിരോധത്തിനായുള്ള സംസ്ഥാനതല ക്യാമ്പയിന്റെ ഭാഗമായി നിംസ് മെഡിസിറ്റി, സ്വസ്തി ഫൗണ്ടേഷൻ, സിറ്റിസൺസ് ഇന്ത്യ ഫൗണ്ടേഷൻ, തക്കല ആലയം ട്രസ്റ്റ് സംയുക്തമായി ആറ്റൂർ NVKS സീനിയർ സെക്കൻഡറി സ്കൂളിൽ വച്ച്  സൗജന്യ കാൻസർ നിർണ്ണയ മെഗാ ക്യാമ്പ് സംഘടിപ്പിച്ചു. NVKS ഗ്രൂപ്പ് ഓഫ് ഇൻസ്റ്റിറ്റ്യൂഷൻസ് സെക്രട്ടറി അഡ്വ. എസ് കൃഷ്ണകുമാർ ഉദ്ഘാടനം ചെയ്ത ക്യാമ്പിൽ നിംസ് മെഡിസിറ്റി മെഡിക്കൽ ഓൺകോളജിസ്റ്റ്  ഡോ.മിന്റു മാത്യു എബ്രഹാം,  ക്ലിനിക്കൽ ഓൺകോളജിസ്റ്റ് ഡോ.അഞ്ചു എസ് ചന്ദ്രബോസ്, എമർജൻസി ഡിപ്പാർട്ട്മെന്റ്  ഡോ. അഞ്ജന ആർ എന്നിവർ നേതൃത്വം നൽകി. ജനറൽ മെഡിസിൻ, ദന്തൽ, ഒഫ്താൽമോളജി തുടങ്ങി വിഭാഗങ്ങളിലെ വിദഗ്ധരുടെ സേവനവും ക്യാമ്പിൽ ലഭ്യമാക്കി.",
      thumb: "assets/img/Pastevents/5328.jpg",
    },
    {
      src: "assets/img/Pastevents/5329.jpg",
      caption:
        "കാൻസർ സേഫ് കേരള രണ്ടാം ഘട്ടം പദ്ധതിയുടെ ഭാഗമായി കേരള സർക്കാർ \"ആരോഗ്യം-ആനന്ദം അകറ്റാം അർബുദം\" കാൻസർ പ്രതിരോധത്തിനായുള്ള സംസ്ഥാനതല ക്യാമ്പയിന്റെ ഭാഗമായി നിംസ് മെഡിസിറ്റി, സ്വസ്തി ഫൗണ്ടേഷൻ, സിറ്റിസൺസ് ഇന്ത്യ ഫൗണ്ടേഷൻ, തക്കല ആലയം ട്രസ്റ്റ് സംയുക്തമായി ആറ്റൂർ NVKS സീനിയർ സെക്കൻഡറി സ്കൂളിൽ വച്ച്  സൗജന്യ കാൻസർ നിർണ്ണയ മെഗാ ക്യാമ്പ് സംഘടിപ്പിച്ചു. NVKS ഗ്രൂപ്പ് ഓഫ് ഇൻസ്റ്റിറ്റ്യൂഷൻസ് സെക്രട്ടറി അഡ്വ. എസ് കൃഷ്ണകുമാർ ഉദ്ഘാടനം ചെയ്ത ക്യാമ്പിൽ നിംസ് മെഡിസിറ്റി മെഡിക്കൽ ഓൺകോളജിസ്റ്റ്  ഡോ.മിന്റു മാത്യു എബ്രഹാം,  ക്ലിനിക്കൽ ഓൺകോളജിസ്റ്റ് ഡോ.അഞ്ചു എസ് ചന്ദ്രബോസ്, എമർജൻസി ഡിപ്പാർട്ട്മെന്റ്  ഡോ. അഞ്ജന ആർ എന്നിവർ നേതൃത്വം നൽകി. ജനറൽ മെഡിസിൻ, ദന്തൽ, ഒഫ്താൽമോളജി തുടങ്ങി വിഭാഗങ്ങളിലെ വിദഗ്ധരുടെ സേവനവും ക്യാമ്പിൽ ലഭ്യമാക്കി.",
      thumb: "assets/img/Pastevents/5329.jpg",
    },
    {
      src: "assets/img/Pastevents/5330.jpg",
      caption:
        "കാൻസർ സേഫ് കേരള രണ്ടാം ഘട്ടം പദ്ധതിയുടെ ഭാഗമായി കേരള സർക്കാർ \"ആരോഗ്യം-ആനന്ദം അകറ്റാം അർബുദം\" കാൻസർ പ്രതിരോധത്തിനായുള്ള സംസ്ഥാനതല ക്യാമ്പയിന്റെ ഭാഗമായി നിംസ് മെഡിസിറ്റി, സ്വസ്തി ഫൗണ്ടേഷൻ, സിറ്റിസൺസ് ഇന്ത്യ ഫൗണ്ടേഷൻ, തക്കല ആലയം ട്രസ്റ്റ് സംയുക്തമായി ആറ്റൂർ NVKS സീനിയർ സെക്കൻഡറി സ്കൂളിൽ വച്ച്  സൗജന്യ കാൻസർ നിർണ്ണയ മെഗാ ക്യാമ്പ് സംഘടിപ്പിച്ചു. NVKS ഗ്രൂപ്പ് ഓഫ് ഇൻസ്റ്റിറ്റ്യൂഷൻസ് സെക്രട്ടറി അഡ്വ. എസ് കൃഷ്ണകുമാർ ഉദ്ഘാടനം ചെയ്ത ക്യാമ്പിൽ നിംസ് മെഡിസിറ്റി മെഡിക്കൽ ഓൺകോളജിസ്റ്റ്  ഡോ.മിന്റു മാത്യു എബ്രഹാം,  ക്ലിനിക്കൽ ഓൺകോളജിസ്റ്റ് ഡോ.അഞ്ചു എസ് ചന്ദ്രബോസ്, എമർജൻസി ഡിപ്പാർട്ട്മെന്റ്  ഡോ. അഞ്ജന ആർ എന്നിവർ നേതൃത്വം നൽകി. ജനറൽ മെഡിസിൻ, ദന്തൽ, ഒഫ്താൽമോളജി തുടങ്ങി വിഭാഗങ്ങളിലെ വിദഗ്ധരുടെ സേവനവും ക്യാമ്പിൽ ലഭ്യമാക്കി.",
      thumb: "assets/img/Pastevents/5330.jpg",
    },
    {
      src: "assets/img/Pastevents/5331.jpg",
      caption:
        "കാൻസർ സേഫ് കേരള രണ്ടാം ഘട്ടം പദ്ധതിയുടെ ഭാഗമായി കേരള സർക്കാർ \"ആരോഗ്യം-ആനന്ദം അകറ്റാം അർബുദം\" കാൻസർ പ്രതിരോധത്തിനായുള്ള സംസ്ഥാനതല ക്യാമ്പയിന്റെ ഭാഗമായി നിംസ് മെഡിസിറ്റി, സ്വസ്തി ഫൗണ്ടേഷൻ, സിറ്റിസൺസ് ഇന്ത്യ ഫൗണ്ടേഷൻ, തക്കല ആലയം ട്രസ്റ്റ് സംയുക്തമായി ആറ്റൂർ NVKS സീനിയർ സെക്കൻഡറി സ്കൂളിൽ വച്ച്  സൗജന്യ കാൻസർ നിർണ്ണയ മെഗാ ക്യാമ്പ് സംഘടിപ്പിച്ചു. NVKS ഗ്രൂപ്പ് ഓഫ് ഇൻസ്റ്റിറ്റ്യൂഷൻസ് സെക്രട്ടറി അഡ്വ. എസ് കൃഷ്ണകുമാർ ഉദ്ഘാടനം ചെയ്ത ക്യാമ്പിൽ നിംസ് മെഡിസിറ്റി മെഡിക്കൽ ഓൺകോളജിസ്റ്റ്  ഡോ.മിന്റു മാത്യു എബ്രഹാം,  ക്ലിനിക്കൽ ഓൺകോളജിസ്റ്റ് ഡോ.അഞ്ചു എസ് ചന്ദ്രബോസ്, എമർജൻസി ഡിപ്പാർട്ട്മെന്റ്  ഡോ. അഞ്ജന ആർ എന്നിവർ നേതൃത്വം നൽകി. ജനറൽ മെഡിസിൻ, ദന്തൽ, ഒഫ്താൽമോളജി തുടങ്ങി വിഭാഗങ്ങളിലെ വിദഗ്ധരുടെ സേവനവും ക്യാമ്പിൽ ലഭ്യമാക്കി.",
      thumb: "assets/img/Pastevents/5331.jpg",
    },
    {
      src: "assets/img/Pastevents/5332.jpg",
      caption:
        "കാൻസർ സേഫ് കേരള രണ്ടാം ഘട്ടം പദ്ധതിയുടെ ഭാഗമായി കേരള സർക്കാർ \"ആരോഗ്യം-ആനന്ദം അകറ്റാം അർബുദം\" കാൻസർ പ്രതിരോധത്തിനായുള്ള സംസ്ഥാനതല ക്യാമ്പയിന്റെ ഭാഗമായി നിംസ് മെഡിസിറ്റി, സ്വസ്തി ഫൗണ്ടേഷൻ, സിറ്റിസൺസ് ഇന്ത്യ ഫൗണ്ടേഷൻ, തക്കല ആലയം ട്രസ്റ്റ് സംയുക്തമായി ആറ്റൂർ NVKS സീനിയർ സെക്കൻഡറി സ്കൂളിൽ വച്ച്  സൗജന്യ കാൻസർ നിർണ്ണയ മെഗാ ക്യാമ്പ് സംഘടിപ്പിച്ചു. NVKS ഗ്രൂപ്പ് ഓഫ് ഇൻസ്റ്റിറ്റ്യൂഷൻസ് സെക്രട്ടറി അഡ്വ. എസ് കൃഷ്ണകുമാർ ഉദ്ഘാടനം ചെയ്ത ക്യാമ്പിൽ നിംസ് മെഡിസിറ്റി മെഡിക്കൽ ഓൺകോളജിസ്റ്റ്  ഡോ.മിന്റു മാത്യു എബ്രഹാം,  ക്ലിനിക്കൽ ഓൺകോളജിസ്റ്റ് ഡോ.അഞ്ചു എസ് ചന്ദ്രബോസ്, എമർജൻസി ഡിപ്പാർട്ട്മെന്റ്  ഡോ. അഞ്ജന ആർ എന്നിവർ നേതൃത്വം നൽകി. ജനറൽ മെഡിസിൻ, ദന്തൽ, ഒഫ്താൽമോളജി തുടങ്ങി വിഭാഗങ്ങളിലെ വിദഗ്ധരുടെ സേവനവും ക്യാമ്പിൽ ലഭ്യമാക്കി.",
      thumb: "assets/img/Pastevents/5332.jpg",
    },
    {
      src: "assets/img/Pastevents/5333.jpg",
      caption:
        "കാൻസർ സേഫ് കേരള രണ്ടാം ഘട്ടം പദ്ധതിയുടെ ഭാഗമായി കേരള സർക്കാർ \"ആരോഗ്യം-ആനന്ദം അകറ്റാം അർബുദം\" കാൻസർ പ്രതിരോധത്തിനായുള്ള സംസ്ഥാനതല ക്യാമ്പയിന്റെ ഭാഗമായി നിംസ് മെഡിസിറ്റി, സ്വസ്തി ഫൗണ്ടേഷൻ, സിറ്റിസൺസ് ഇന്ത്യ ഫൗണ്ടേഷൻ, തക്കല ആലയം ട്രസ്റ്റ് സംയുക്തമായി ആറ്റൂർ NVKS സീനിയർ സെക്കൻഡറി സ്കൂളിൽ വച്ച്  സൗജന്യ കാൻസർ നിർണ്ണയ മെഗാ ക്യാമ്പ് സംഘടിപ്പിച്ചു. NVKS ഗ്രൂപ്പ് ഓഫ് ഇൻസ്റ്റിറ്റ്യൂഷൻസ് സെക്രട്ടറി അഡ്വ. എസ് കൃഷ്ണകുമാർ ഉദ്ഘാടനം ചെയ്ത ക്യാമ്പിൽ നിംസ് മെഡിസിറ്റി മെഡിക്കൽ ഓൺകോളജിസ്റ്റ്  ഡോ.മിന്റു മാത്യു എബ്രഹാം,  ക്ലിനിക്കൽ ഓൺകോളജിസ്റ്റ് ഡോ.അഞ്ചു എസ് ചന്ദ്രബോസ്, എമർജൻസി ഡിപ്പാർട്ട്മെന്റ്  ഡോ. അഞ്ജന ആർ എന്നിവർ നേതൃത്വം നൽകി. ജനറൽ മെഡിസിൻ, ദന്തൽ, ഒഫ്താൽമോളജി തുടങ്ങി വിഭാഗങ്ങളിലെ വിദഗ്ധരുടെ സേവനവും ക്യാമ്പിൽ ലഭ്യമാക്കി.",
      thumb: "assets/img/Pastevents/5333.jpg",
    },
    {
      src: "assets/img/Pastevents/5334.jpg",
      caption:
        "കാൻസർ സേഫ് കേരള രണ്ടാം ഘട്ടം പദ്ധതിയുടെ ഭാഗമായി കേരള സർക്കാർ \"ആരോഗ്യം-ആനന്ദം അകറ്റാം അർബുദം\" കാൻസർ പ്രതിരോധത്തിനായുള്ള സംസ്ഥാനതല ക്യാമ്പയിന്റെ ഭാഗമായി നിംസ് മെഡിസിറ്റി, സ്വസ്തി ഫൗണ്ടേഷൻ, സിറ്റിസൺസ് ഇന്ത്യ ഫൗണ്ടേഷൻ, തക്കല ആലയം ട്രസ്റ്റ് സംയുക്തമായി ആറ്റൂർ NVKS സീനിയർ സെക്കൻഡറി സ്കൂളിൽ വച്ച്  സൗജന്യ കാൻസർ നിർണ്ണയ മെഗാ ക്യാമ്പ് സംഘടിപ്പിച്ചു. NVKS ഗ്രൂപ്പ് ഓഫ് ഇൻസ്റ്റിറ്റ്യൂഷൻസ് സെക്രട്ടറി അഡ്വ. എസ് കൃഷ്ണകുമാർ ഉദ്ഘാടനം ചെയ്ത ക്യാമ്പിൽ നിംസ് മെഡിസിറ്റി മെഡിക്കൽ ഓൺകോളജിസ്റ്റ്  ഡോ.മിന്റു മാത്യു എബ്രഹാം,  ക്ലിനിക്കൽ ഓൺകോളജിസ്റ്റ് ഡോ.അഞ്ചു എസ് ചന്ദ്രബോസ്, എമർജൻസി ഡിപ്പാർട്ട്മെന്റ്  ഡോ. അഞ്ജന ആർ എന്നിവർ നേതൃത്വം നൽകി. ജനറൽ മെഡിസിൻ, ദന്തൽ, ഒഫ്താൽമോളജി തുടങ്ങി വിഭാഗങ്ങളിലെ വിദഗ്ധരുടെ സേവനവും ക്യാമ്പിൽ ലഭ്യമാക്കി.",
      thumb: "assets/img/Pastevents/5334.jpg",
    },
    {
      src: "assets/img/Pastevents/5335.jpg",
      caption:
        "കാൻസർ സേഫ് കേരള രണ്ടാം ഘട്ടം പദ്ധതിയുടെ ഭാഗമായി കേരള സർക്കാർ \"ആരോഗ്യം-ആനന്ദം അകറ്റാം അർബുദം\" കാൻസർ പ്രതിരോധത്തിനായുള്ള സംസ്ഥാനതല ക്യാമ്പയിന്റെ ഭാഗമായി നിംസ് മെഡിസിറ്റി, സ്വസ്തി ഫൗണ്ടേഷൻ, സിറ്റിസൺസ് ഇന്ത്യ ഫൗണ്ടേഷൻ, തക്കല ആലയം ട്രസ്റ്റ് സംയുക്തമായി ആറ്റൂർ NVKS സീനിയർ സെക്കൻഡറി സ്കൂളിൽ വച്ച്  സൗജന്യ കാൻസർ നിർണ്ണയ മെഗാ ക്യാമ്പ് സംഘടിപ്പിച്ചു. NVKS ഗ്രൂപ്പ് ഓഫ് ഇൻസ്റ്റിറ്റ്യൂഷൻസ് സെക്രട്ടറി അഡ്വ. എസ് കൃഷ്ണകുമാർ ഉദ്ഘാടനം ചെയ്ത ക്യാമ്പിൽ നിംസ് മെഡിസിറ്റി മെഡിക്കൽ ഓൺകോളജിസ്റ്റ്  ഡോ.മിന്റു മാത്യു എബ്രഹാം,  ക്ലിനിക്കൽ ഓൺകോളജിസ്റ്റ് ഡോ.അഞ്ചു എസ് ചന്ദ്രബോസ്, എമർജൻസി ഡിപ്പാർട്ട്മെന്റ്  ഡോ. അഞ്ജന ആർ എന്നിവർ നേതൃത്വം നൽകി. ജനറൽ മെഡിസിൻ, ദന്തൽ, ഒഫ്താൽമോളജി തുടങ്ങി വിഭാഗങ്ങളിലെ വിദഗ്ധരുടെ സേവനവും ക്യാമ്പിൽ ലഭ്യമാക്കി.",
      thumb: "assets/img/Pastevents/5335.jpg",
    },
    {
      src: "assets/img/Pastevents/5336.jpg",
      caption:
        "കാൻസർ സേഫ് കേരള രണ്ടാം ഘട്ടം പദ്ധതിയുടെ ഭാഗമായി കേരള സർക്കാർ \"ആരോഗ്യം-ആനന്ദം അകറ്റാം അർബുദം\" കാൻസർ പ്രതിരോധത്തിനായുള്ള സംസ്ഥാനതല ക്യാമ്പയിന്റെ ഭാഗമായി നിംസ് മെഡിസിറ്റി, സ്വസ്തി ഫൗണ്ടേഷൻ, സിറ്റിസൺസ് ഇന്ത്യ ഫൗണ്ടേഷൻ, തക്കല ആലയം ട്രസ്റ്റ് സംയുക്തമായി ആറ്റൂർ NVKS സീനിയർ സെക്കൻഡറി സ്കൂളിൽ വച്ച്  സൗജന്യ കാൻസർ നിർണ്ണയ മെഗാ ക്യാമ്പ് സംഘടിപ്പിച്ചു. NVKS ഗ്രൂപ്പ് ഓഫ് ഇൻസ്റ്റിറ്റ്യൂഷൻസ് സെക്രട്ടറി അഡ്വ. എസ് കൃഷ്ണകുമാർ ഉദ്ഘാടനം ചെയ്ത ക്യാമ്പിൽ നിംസ് മെഡിസിറ്റി മെഡിക്കൽ ഓൺകോളജിസ്റ്റ്  ഡോ.മിന്റു മാത്യു എബ്രഹാം,  ക്ലിനിക്കൽ ഓൺകോളജിസ്റ്റ് ഡോ.അഞ്ചു എസ് ചന്ദ്രബോസ്, എമർജൻസി ഡിപ്പാർട്ട്മെന്റ്  ഡോ. അഞ്ജന ആർ എന്നിവർ നേതൃത്വം നൽകി. ജനറൽ മെഡിസിൻ, ദന്തൽ, ഒഫ്താൽമോളജി തുടങ്ങി വിഭാഗങ്ങളിലെ വിദഗ്ധരുടെ സേവനവും ക്യാമ്പിൽ ലഭ്യമാക്കി.",
      thumb: "assets/img/Pastevents/5336.jpg",
    },
    {
      src: "assets/img/Pastevents/5337.jpg",
      caption:
        "കാൻസർ സേഫ് കേരള രണ്ടാം ഘട്ടം പദ്ധതിയുടെ ഭാഗമായി കേരള സർക്കാർ \"ആരോഗ്യം-ആനന്ദം അകറ്റാം അർബുദം\" കാൻസർ പ്രതിരോധത്തിനായുള്ള സംസ്ഥാനതല ക്യാമ്പയിന്റെ ഭാഗമായി നിംസ് മെഡിസിറ്റി, സ്വസ്തി ഫൗണ്ടേഷൻ, സിറ്റിസൺസ് ഇന്ത്യ ഫൗണ്ടേഷൻ, തക്കല ആലയം ട്രസ്റ്റ് സംയുക്തമായി ആറ്റൂർ NVKS സീനിയർ സെക്കൻഡറി സ്കൂളിൽ വച്ച്  സൗജന്യ കാൻസർ നിർണ്ണയ മെഗാ ക്യാമ്പ് സംഘടിപ്പിച്ചു. NVKS ഗ്രൂപ്പ് ഓഫ് ഇൻസ്റ്റിറ്റ്യൂഷൻസ് സെക്രട്ടറി അഡ്വ. എസ് കൃഷ്ണകുമാർ ഉദ്ഘാടനം ചെയ്ത ക്യാമ്പിൽ നിംസ് മെഡിസിറ്റി മെഡിക്കൽ ഓൺകോളജിസ്റ്റ്  ഡോ.മിന്റു മാത്യു എബ്രഹാം,  ക്ലിനിക്കൽ ഓൺകോളജിസ്റ്റ് ഡോ.അഞ്ചു എസ് ചന്ദ്രബോസ്, എമർജൻസി ഡിപ്പാർട്ട്മെന്റ്  ഡോ. അഞ്ജന ആർ എന്നിവർ നേതൃത്വം നൽകി. ജനറൽ മെഡിസിൻ, ദന്തൽ, ഒഫ്താൽമോളജി തുടങ്ങി വിഭാഗങ്ങളിലെ വിദഗ്ധരുടെ സേവനവും ക്യാമ്പിൽ ലഭ്യമാക്കി.",
      thumb: "assets/img/Pastevents/5337.jpg",
    },
    {
      src: "assets/img/Pastevents/5338.jpg",
      caption:
        "കാൻസർ സേഫ് കേരള രണ്ടാം ഘട്ടം പദ്ധതിയുടെ ഭാഗമായി കേരള സർക്കാർ \"ആരോഗ്യം-ആനന്ദം അകറ്റാം അർബുദം\" കാൻസർ പ്രതിരോധത്തിനായുള്ള സംസ്ഥാനതല ക്യാമ്പയിന്റെ ഭാഗമായി നിംസ് മെഡിസിറ്റി, സ്വസ്തി ഫൗണ്ടേഷൻ, സിറ്റിസൺസ് ഇന്ത്യ ഫൗണ്ടേഷൻ, തക്കല ആലയം ട്രസ്റ്റ് സംയുക്തമായി ആറ്റൂർ NVKS സീനിയർ സെക്കൻഡറി സ്കൂളിൽ വച്ച്  സൗജന്യ കാൻസർ നിർണ്ണയ മെഗാ ക്യാമ്പ് സംഘടിപ്പിച്ചു. NVKS ഗ്രൂപ്പ് ഓഫ് ഇൻസ്റ്റിറ്റ്യൂഷൻസ് സെക്രട്ടറി അഡ്വ. എസ് കൃഷ്ണകുമാർ ഉദ്ഘാടനം ചെയ്ത ക്യാമ്പിൽ നിംസ് മെഡിസിറ്റി മെഡിക്കൽ ഓൺകോളജിസ്റ്റ്  ഡോ.മിന്റു മാത്യു എബ്രഹാം,  ക്ലിനിക്കൽ ഓൺകോളജിസ്റ്റ് ഡോ.അഞ്ചു എസ് ചന്ദ്രബോസ്, എമർജൻസി ഡിപ്പാർട്ട്മെന്റ്  ഡോ. അഞ്ജന ആർ എന്നിവർ നേതൃത്വം നൽകി. ജനറൽ മെഡിസിൻ, ദന്തൽ, ഒഫ്താൽമോളജി തുടങ്ങി വിഭാഗങ്ങളിലെ വിദഗ്ധരുടെ സേവനവും ക്യാമ്പിൽ ലഭ്യമാക്കി.",
      thumb: "assets/img/Pastevents/5338.jpg",
    },
    {
      src: "assets/img/Pastevents/5339.jpg",
      caption:
        "കാൻസർ സേഫ് കേരള രണ്ടാം ഘട്ടം പദ്ധതിയുടെ ഭാഗമായി കേരള സർക്കാർ \"ആരോഗ്യം-ആനന്ദം അകറ്റാം അർബുദം\" കാൻസർ പ്രതിരോധത്തിനായുള്ള സംസ്ഥാനതല ക്യാമ്പയിന്റെ ഭാഗമായി നിംസ് മെഡിസിറ്റി, സ്വസ്തി ഫൗണ്ടേഷൻ, സിറ്റിസൺസ് ഇന്ത്യ ഫൗണ്ടേഷൻ, തക്കല ആലയം ട്രസ്റ്റ് സംയുക്തമായി ആറ്റൂർ NVKS സീനിയർ സെക്കൻഡറി സ്കൂളിൽ വച്ച്  സൗജന്യ കാൻസർ നിർണ്ണയ മെഗാ ക്യാമ്പ് സംഘടിപ്പിച്ചു. NVKS ഗ്രൂപ്പ് ഓഫ് ഇൻസ്റ്റിറ്റ്യൂഷൻസ് സെക്രട്ടറി അഡ്വ. എസ് കൃഷ്ണകുമാർ ഉദ്ഘാടനം ചെയ്ത ക്യാമ്പിൽ നിംസ് മെഡിസിറ്റി മെഡിക്കൽ ഓൺകോളജിസ്റ്റ്  ഡോ.മിന്റു മാത്യു എബ്രഹാം,  ക്ലിനിക്കൽ ഓൺകോളജിസ്റ്റ് ഡോ.അഞ്ചു എസ് ചന്ദ്രബോസ്, എമർജൻസി ഡിപ്പാർട്ട്മെന്റ്  ഡോ. അഞ്ജന ആർ എന്നിവർ നേതൃത്വം നൽകി. ജനറൽ മെഡിസിൻ, ദന്തൽ, ഒഫ്താൽമോളജി തുടങ്ങി വിഭാഗങ്ങളിലെ വിദഗ്ധരുടെ സേവനവും ക്യാമ്പിൽ ലഭ്യമാക്കി.",
      thumb: "assets/img/Pastevents/5339.jpg",
    },
    {
      src: "assets/img/Pastevents/5340.jpg",
      caption:
        "കാൻസർ സേഫ് കേരള രണ്ടാം ഘട്ടം പദ്ധതിയുടെ ഭാഗമായി കേരള സർക്കാർ \"ആരോഗ്യം-ആനന്ദം അകറ്റാം അർബുദം\" കാൻസർ പ്രതിരോധത്തിനായുള്ള സംസ്ഥാനതല ക്യാമ്പയിന്റെ ഭാഗമായി നിംസ് മെഡിസിറ്റി, സ്വസ്തി ഫൗണ്ടേഷൻ, സിറ്റിസൺസ് ഇന്ത്യ ഫൗണ്ടേഷൻ, തക്കല ആലയം ട്രസ്റ്റ് സംയുക്തമായി ആറ്റൂർ NVKS സീനിയർ സെക്കൻഡറി സ്കൂളിൽ വച്ച്  സൗജന്യ കാൻസർ നിർണ്ണയ മെഗാ ക്യാമ്പ് സംഘടിപ്പിച്ചു. NVKS ഗ്രൂപ്പ് ഓഫ് ഇൻസ്റ്റിറ്റ്യൂഷൻസ് സെക്രട്ടറി അഡ്വ. എസ് കൃഷ്ണകുമാർ ഉദ്ഘാടനം ചെയ്ത ക്യാമ്പിൽ നിംസ് മെഡിസിറ്റി മെഡിക്കൽ ഓൺകോളജിസ്റ്റ്  ഡോ.മിന്റു മാത്യു എബ്രഹാം,  ക്ലിനിക്കൽ ഓൺകോളജിസ്റ്റ് ഡോ.അഞ്ചു എസ് ചന്ദ്രബോസ്, എമർജൻസി ഡിപ്പാർട്ട്മെന്റ്  ഡോ. അഞ്ജന ആർ എന്നിവർ നേതൃത്വം നൽകി. ജനറൽ മെഡിസിൻ, ദന്തൽ, ഒഫ്താൽമോളജി തുടങ്ങി വിഭാഗങ്ങളിലെ വിദഗ്ധരുടെ സേവനവും ക്യാമ്പിൽ ലഭ്യമാക്കി.",
      thumb: "assets/img/Pastevents/5340.jpg",
    },
    {
      src: "assets/img/Pastevents/5341.jpg",
      caption:
        "കാൻസർ സേഫ് കേരള രണ്ടാം ഘട്ടം പദ്ധതിയുടെ ഭാഗമായി കേരള സർക്കാർ \"ആരോഗ്യം-ആനന്ദം അകറ്റാം അർബുദം\" കാൻസർ പ്രതിരോധത്തിനായുള്ള സംസ്ഥാനതല ക്യാമ്പയിന്റെ ഭാഗമായി നിംസ് മെഡിസിറ്റി, സ്വസ്തി ഫൗണ്ടേഷൻ, സിറ്റിസൺസ് ഇന്ത്യ ഫൗണ്ടേഷൻ, തക്കല ആലയം ട്രസ്റ്റ് സംയുക്തമായി ആറ്റൂർ NVKS സീനിയർ സെക്കൻഡറി സ്കൂളിൽ വച്ച്  സൗജന്യ കാൻസർ നിർണ്ണയ മെഗാ ക്യാമ്പ് സംഘടിപ്പിച്ചു. NVKS ഗ്രൂപ്പ് ഓഫ് ഇൻസ്റ്റിറ്റ്യൂഷൻസ് സെക്രട്ടറി അഡ്വ. എസ് കൃഷ്ണകുമാർ ഉദ്ഘാടനം ചെയ്ത ക്യാമ്പിൽ നിംസ് മെഡിസിറ്റി മെഡിക്കൽ ഓൺകോളജിസ്റ്റ്  ഡോ.മിന്റു മാത്യു എബ്രഹാം,  ക്ലിനിക്കൽ ഓൺകോളജിസ്റ്റ് ഡോ.അഞ്ചു എസ് ചന്ദ്രബോസ്, എമർജൻസി ഡിപ്പാർട്ട്മെന്റ്  ഡോ. അഞ്ജന ആർ എന്നിവർ നേതൃത്വം നൽകി. ജനറൽ മെഡിസിൻ, ദന്തൽ, ഒഫ്താൽമോളജി തുടങ്ങി വിഭാഗങ്ങളിലെ വിദഗ്ധരുടെ സേവനവും ക്യാമ്പിൽ ലഭ്യമാക്കി.",
      thumb: "assets/img/Pastevents/5341.jpg",
    },
    {
      src: "assets/img/Pastevents/5342.jpg",
      caption:
        "കാൻസർ സേഫ് കേരള രണ്ടാം ഘട്ടം പദ്ധതിയുടെ ഭാഗമായി കേരള സർക്കാർ \"ആരോഗ്യം-ആനന്ദം അകറ്റാം അർബുദം\" കാൻസർ പ്രതിരോധത്തിനായുള്ള സംസ്ഥാനതല ക്യാമ്പയിന്റെ ഭാഗമായി നിംസ് മെഡിസിറ്റി, സ്വസ്തി ഫൗണ്ടേഷൻ, സിറ്റിസൺസ് ഇന്ത്യ ഫൗണ്ടേഷൻ, തക്കല ആലയം ട്രസ്റ്റ് സംയുക്തമായി ആറ്റൂർ NVKS സീനിയർ സെക്കൻഡറി സ്കൂളിൽ വച്ച്  സൗജന്യ കാൻസർ നിർണ്ണയ മെഗാ ക്യാമ്പ് സംഘടിപ്പിച്ചു. NVKS ഗ്രൂപ്പ് ഓഫ് ഇൻസ്റ്റിറ്റ്യൂഷൻസ് സെക്രട്ടറി അഡ്വ. എസ് കൃഷ്ണകുമാർ ഉദ്ഘാടനം ചെയ്ത ക്യാമ്പിൽ നിംസ് മെഡിസിറ്റി മെഡിക്കൽ ഓൺകോളജിസ്റ്റ്  ഡോ.മിന്റു മാത്യു എബ്രഹാം,  ക്ലിനിക്കൽ ഓൺകോളജിസ്റ്റ് ഡോ.അഞ്ചു എസ് ചന്ദ്രബോസ്, എമർജൻസി ഡിപ്പാർട്ട്മെന്റ്  ഡോ. അഞ്ജന ആർ എന്നിവർ നേതൃത്വം നൽകി. ജനറൽ മെഡിസിൻ, ദന്തൽ, ഒഫ്താൽമോളജി തുടങ്ങി വിഭാഗങ്ങളിലെ വിദഗ്ധരുടെ സേവനവും ക്യാമ്പിൽ ലഭ്യമാക്കി.",
      thumb: "assets/img/Pastevents/5342.jpg",
    },
    {
      src: "assets/img/Pastevents/5343.jpg",
      caption:
        "കാൻസർ സേഫ് കേരള രണ്ടാം ഘട്ടം പദ്ധതിയുടെ ഭാഗമായി കേരള സർക്കാർ \"ആരോഗ്യം-ആനന്ദം അകറ്റാം അർബുദം\" കാൻസർ പ്രതിരോധത്തിനായുള്ള സംസ്ഥാനതല ക്യാമ്പയിന്റെ ഭാഗമായി നിംസ് മെഡിസിറ്റി, സ്വസ്തി ഫൗണ്ടേഷൻ, സിറ്റിസൺസ് ഇന്ത്യ ഫൗണ്ടേഷൻ, തക്കല ആലയം ട്രസ്റ്റ് സംയുക്തമായി ആറ്റൂർ NVKS സീനിയർ സെക്കൻഡറി സ്കൂളിൽ വച്ച്  സൗജന്യ കാൻസർ നിർണ്ണയ മെഗാ ക്യാമ്പ് സംഘടിപ്പിച്ചു. NVKS ഗ്രൂപ്പ് ഓഫ് ഇൻസ്റ്റിറ്റ്യൂഷൻസ് സെക്രട്ടറി അഡ്വ. എസ് കൃഷ്ണകുമാർ ഉദ്ഘാടനം ചെയ്ത ക്യാമ്പിൽ നിംസ് മെഡിസിറ്റി മെഡിക്കൽ ഓൺകോളജിസ്റ്റ്  ഡോ.മിന്റു മാത്യു എബ്രഹാം,  ക്ലിനിക്കൽ ഓൺകോളജിസ്റ്റ് ഡോ.അഞ്ചു എസ് ചന്ദ്രബോസ്, എമർജൻസി ഡിപ്പാർട്ട്മെന്റ്  ഡോ. അഞ്ജന ആർ എന്നിവർ നേതൃത്വം നൽകി. ജനറൽ മെഡിസിൻ, ദന്തൽ, ഒഫ്താൽമോളജി തുടങ്ങി വിഭാഗങ്ങളിലെ വിദഗ്ധരുടെ സേവനവും ക്യാമ്പിൽ ലഭ്യമാക്കി.",
      thumb: "assets/img/Pastevents/5343.jpg",
    },
    {
      src: "assets/img/Pastevents/5344.jpg",
      caption:
        "കാൻസർ സേഫ് കേരള രണ്ടാം ഘട്ടം പദ്ധതിയുടെ ഭാഗമായി കേരള സർക്കാർ \"ആരോഗ്യം-ആനന്ദം അകറ്റാം അർബുദം\" കാൻസർ പ്രതിരോധത്തിനായുള്ള സംസ്ഥാനതല ക്യാമ്പയിന്റെ ഭാഗമായി നിംസ് മെഡിസിറ്റി, സ്വസ്തി ഫൗണ്ടേഷൻ, സിറ്റിസൺസ് ഇന്ത്യ ഫൗണ്ടേഷൻ, തക്കല ആലയം ട്രസ്റ്റ് സംയുക്തമായി ആറ്റൂർ NVKS സീനിയർ സെക്കൻഡറി സ്കൂളിൽ വച്ച്  സൗജന്യ കാൻസർ നിർണ്ണയ മെഗാ ക്യാമ്പ് സംഘടിപ്പിച്ചു. NVKS ഗ്രൂപ്പ് ഓഫ് ഇൻസ്റ്റിറ്റ്യൂഷൻസ് സെക്രട്ടറി അഡ്വ. എസ് കൃഷ്ണകുമാർ ഉദ്ഘാടനം ചെയ്ത ക്യാമ്പിൽ നിംസ് മെഡിസിറ്റി മെഡിക്കൽ ഓൺകോളജിസ്റ്റ്  ഡോ.മിന്റു മാത്യു എബ്രഹാം,  ക്ലിനിക്കൽ ഓൺകോളജിസ്റ്റ് ഡോ.അഞ്ചു എസ് ചന്ദ്രബോസ്, എമർജൻസി ഡിപ്പാർട്ട്മെന്റ്  ഡോ. അഞ്ജന ആർ എന്നിവർ നേതൃത്വം നൽകി. ജനറൽ മെഡിസിൻ, ദന്തൽ, ഒഫ്താൽമോളജി തുടങ്ങി വിഭാഗങ്ങളിലെ വിദഗ്ധരുടെ സേവനവും ക്യാമ്പിൽ ലഭ്യമാക്കി.",
      thumb: "assets/img/Pastevents/5344.jpg",
    },
    {
      src: "assets/img/Pastevents/5345.jpg",
      caption:
        "കാൻസർ സേഫ് കേരള രണ്ടാം ഘട്ടം പദ്ധതിയുടെ ഭാഗമായി കേരള സർക്കാർ \"ആരോഗ്യം-ആനന്ദം അകറ്റാം അർബുദം\" കാൻസർ പ്രതിരോധത്തിനായുള്ള സംസ്ഥാനതല ക്യാമ്പയിന്റെ ഭാഗമായി നിംസ് മെഡിസിറ്റി, സ്വസ്തി ഫൗണ്ടേഷൻ, സിറ്റിസൺസ് ഇന്ത്യ ഫൗണ്ടേഷൻ, തക്കല ആലയം ട്രസ്റ്റ് സംയുക്തമായി ആറ്റൂർ NVKS സീനിയർ സെക്കൻഡറി സ്കൂളിൽ വച്ച്  സൗജന്യ കാൻസർ നിർണ്ണയ മെഗാ ക്യാമ്പ് സംഘടിപ്പിച്ചു. NVKS ഗ്രൂപ്പ് ഓഫ് ഇൻസ്റ്റിറ്റ്യൂഷൻസ് സെക്രട്ടറി അഡ്വ. എസ് കൃഷ്ണകുമാർ ഉദ്ഘാടനം ചെയ്ത ക്യാമ്പിൽ നിംസ് മെഡിസിറ്റി മെഡിക്കൽ ഓൺകോളജിസ്റ്റ്  ഡോ.മിന്റു മാത്യു എബ്രഹാം,  ക്ലിനിക്കൽ ഓൺകോളജിസ്റ്റ് ഡോ.അഞ്ചു എസ് ചന്ദ്രബോസ്, എമർജൻസി ഡിപ്പാർട്ട്മെന്റ്  ഡോ. അഞ്ജന ആർ എന്നിവർ നേതൃത്വം നൽകി. ജനറൽ മെഡിസിൻ, ദന്തൽ, ഒഫ്താൽമോളജി തുടങ്ങി വിഭാഗങ്ങളിലെ വിദഗ്ധരുടെ സേവനവും ക്യാമ്പിൽ ലഭ്യമാക്കി.",
      thumb: "assets/img/Pastevents/5345.jpg",
    },
    {
      src: "assets/img/Pastevents/5304.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയും വട്ടിയൂർക്കാവ് ശ്രീ  സത്യസായി ക്ഷേത്ര ട്രസ്റ്റും സംയുക്തമായി തൊലിക്കോട് , കുടമൻകോട് ക്ഷേത്രത്തിൽ നടത്തിയ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ്‌....",
      thumb: "assets/img/Pastevents/5304.jpg",
    },
    {
      src: "assets/img/Pastevents/5305.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയും വട്ടിയൂർക്കാവ് ശ്രീ  സത്യസായി ക്ഷേത്ര ട്രസ്റ്റും സംയുക്തമായി തൊലിക്കോട് , കുടമൻകോട് ക്ഷേത്രത്തിൽ നടത്തിയ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ്‌....",
      thumb: "assets/img/Pastevents/5305.jpg",
    },
    {
      src: "assets/img/Pastevents/5306.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയും വട്ടിയൂർക്കാവ് ശ്രീ  സത്യസായി ക്ഷേത്ര ട്രസ്റ്റും സംയുക്തമായി തൊലിക്കോട് , കുടമൻകോട് ക്ഷേത്രത്തിൽ നടത്തിയ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ്‌....",
      thumb: "assets/img/Pastevents/5306.jpg",
    },
    {
      src: "assets/img/Pastevents/5307.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയും വട്ടിയൂർക്കാവ് ശ്രീ  സത്യസായി ക്ഷേത്ര ട്രസ്റ്റും സംയുക്തമായി തൊലിക്കോട് , കുടമൻകോട് ക്ഷേത്രത്തിൽ നടത്തിയ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ്‌....",
      thumb: "assets/img/Pastevents/5307.jpg",
    },
    {
      src: "assets/img/Pastevents/5308.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയും വട്ടിയൂർക്കാവ് ശ്രീ  സത്യസായി ക്ഷേത്ര ട്രസ്റ്റും സംയുക്തമായി തൊലിക്കോട് , കുടമൻകോട് ക്ഷേത്രത്തിൽ നടത്തിയ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ്‌....",
      thumb: "assets/img/Pastevents/5308.jpg",
    },
    {
      src: "assets/img/Pastevents/5309.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയും വട്ടിയൂർക്കാവ് ശ്രീ  സത്യസായി ക്ഷേത്ര ട്രസ്റ്റും സംയുക്തമായി തൊലിക്കോട് , കുടമൻകോട് ക്ഷേത്രത്തിൽ നടത്തിയ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ്‌....",
      thumb: "assets/img/Pastevents/5309.jpg",
    },
    {
      src: "assets/img/Pastevents/5310.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയും വട്ടിയൂർക്കാവ് ശ്രീ  സത്യസായി ക്ഷേത്ര ട്രസ്റ്റും സംയുക്തമായി തൊലിക്കോട് , കുടമൻകോട് ക്ഷേത്രത്തിൽ നടത്തിയ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ്‌....",
      thumb: "assets/img/Pastevents/5310.jpg",
    },
    {
      src: "assets/img/Pastevents/5311.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയും വട്ടിയൂർക്കാവ് ശ്രീ  സത്യസായി ക്ഷേത്ര ട്രസ്റ്റും സംയുക്തമായി തൊലിക്കോട് , കുടമൻകോട് ക്ഷേത്രത്തിൽ നടത്തിയ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ്‌....",
      thumb: "assets/img/Pastevents/5311.jpg",
    },
    {
      src: "assets/img/Pastevents/5312.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയും വട്ടിയൂർക്കാവ് ശ്രീ  സത്യസായി ക്ഷേത്ര ട്രസ്റ്റും സംയുക്തമായി തൊലിക്കോട് , കുടമൻകോട് ക്ഷേത്രത്തിൽ നടത്തിയ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ്‌....",
      thumb: "assets/img/Pastevents/5312.jpg",
    },
    {
      src: "assets/img/Pastevents/5313.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയും വട്ടിയൂർക്കാവ് ശ്രീ  സത്യസായി ക്ഷേത്ര ട്രസ്റ്റും സംയുക്തമായി തൊലിക്കോട് , കുടമൻകോട് ക്ഷേത്രത്തിൽ നടത്തിയ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ്‌....",
      thumb: "assets/img/Pastevents/5313.jpg",
    },
    {
      src: "assets/img/Pastevents/5314.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയും വട്ടിയൂർക്കാവ് ശ്രീ  സത്യസായി ക്ഷേത്ര ട്രസ്റ്റും സംയുക്തമായി തൊലിക്കോട് , കുടമൻകോട് ക്ഷേത്രത്തിൽ നടത്തിയ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ്‌....",
      thumb: "assets/img/Pastevents/5314.jpg",
    },
    {
      src: "assets/img/Pastevents/5315.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയും വട്ടിയൂർക്കാവ് ശ്രീ  സത്യസായി ക്ഷേത്ര ട്രസ്റ്റും സംയുക്തമായി തൊലിക്കോട് , കുടമൻകോട് ക്ഷേത്രത്തിൽ നടത്തിയ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ്‌....",
      thumb: "assets/img/Pastevents/5315.jpg",
    },
    {
      src: "assets/img/Pastevents/5316.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയും വട്ടിയൂർക്കാവ് ശ്രീ  സത്യസായി ക്ഷേത്ര ട്രസ്റ്റും സംയുക്തമായി തൊലിക്കോട് , കുടമൻകോട് ക്ഷേത്രത്തിൽ നടത്തിയ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ്‌....",
      thumb: "assets/img/Pastevents/5316.jpg",
    },
    {
      src: "assets/img/Pastevents/5317.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയും വട്ടിയൂർക്കാവ് ശ്രീ  സത്യസായി ക്ഷേത്ര ട്രസ്റ്റും സംയുക്തമായി തൊലിക്കോട് , കുടമൻകോട് ക്ഷേത്രത്തിൽ നടത്തിയ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ്‌....",
      thumb: "assets/img/Pastevents/5317.jpg",
    },
    {
      src: "assets/img/Pastevents/5318.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയും വട്ടിയൂർക്കാവ് ശ്രീ  സത്യസായി ക്ഷേത്ര ട്രസ്റ്റും സംയുക്തമായി തൊലിക്കോട് , കുടമൻകോട് ക്ഷേത്രത്തിൽ നടത്തിയ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ്‌....",
      thumb: "assets/img/Pastevents/5318.jpg",
    },
    {
      src: "assets/img/Pastevents/5319.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയും വട്ടിയൂർക്കാവ് ശ്രീ  സത്യസായി ക്ഷേത്ര ട്രസ്റ്റും സംയുക്തമായി തൊലിക്കോട് , കുടമൻകോട് ക്ഷേത്രത്തിൽ നടത്തിയ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ്‌....",
      thumb: "assets/img/Pastevents/5319.jpg",
    },
    {
      src: "assets/img/Pastevents/5320.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയും വട്ടിയൂർക്കാവ് ശ്രീ  സത്യസായി ക്ഷേത്ര ട്രസ്റ്റും സംയുക്തമായി തൊലിക്കോട് , കുടമൻകോട് ക്ഷേത്രത്തിൽ നടത്തിയ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ്‌....",
      thumb: "assets/img/Pastevents/5320.jpg",
    },
    {
      src: "assets/img/Pastevents/5321.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയും വട്ടിയൂർക്കാവ് ശ്രീ  സത്യസായി ക്ഷേത്ര ട്രസ്റ്റും സംയുക്തമായി തൊലിക്കോട് , കുടമൻകോട് ക്ഷേത്രത്തിൽ നടത്തിയ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ്‌....",
      thumb: "assets/img/Pastevents/5321.jpg",
    },
    {
      src: "assets/img/Pastevents/5297.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ കപ്പിയാറ ശ്രീ ഭദ്രകാളി ക്ഷേത്രത്തിൽ വച്ച്  നടന്ന സൗജന്യ മെഡിക്കൽ ക്യാമ്പ്....ജനറൽ മെഡിസിൻ ,ദന്തൽ ,ഒഫ്താൽമോളജി, ഇ സി ജി, രക്തസമ്മർദ്ദപരിശോധന, പ്രമേഹരോഗ നിർണയം തുടങ്ങിയ സൗജന്യ സേവനങ്ങളും ക്യാമ്പിൽ ലഭ്യമാക്കിയിരുന്നു",
      thumb: "assets/img/Pastevents/5297.jpg",
    },
    {
      src: "assets/img/Pastevents/5298.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ കപ്പിയാറ ശ്രീ ഭദ്രകാളി ക്ഷേത്രത്തിൽ വച്ച്  നടന്ന സൗജന്യ മെഡിക്കൽ ക്യാമ്പ്....ജനറൽ മെഡിസിൻ ,ദന്തൽ ,ഒഫ്താൽമോളജി, ഇ സി ജി, രക്തസമ്മർദ്ദപരിശോധന, പ്രമേഹരോഗ നിർണയം തുടങ്ങിയ സൗജന്യ സേവനങ്ങളും ക്യാമ്പിൽ ലഭ്യമാക്കിയിരുന്നു",
      thumb: "assets/img/Pastevents/5298.jpg",
    },
    {
      src: "assets/img/Pastevents/5299.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ കപ്പിയാറ ശ്രീ ഭദ്രകാളി ക്ഷേത്രത്തിൽ വച്ച്  നടന്ന സൗജന്യ മെഡിക്കൽ ക്യാമ്പ്....ജനറൽ മെഡിസിൻ ,ദന്തൽ ,ഒഫ്താൽമോളജി, ഇ സി ജി, രക്തസമ്മർദ്ദപരിശോധന, പ്രമേഹരോഗ നിർണയം തുടങ്ങിയ സൗജന്യ സേവനങ്ങളും ക്യാമ്പിൽ ലഭ്യമാക്കിയിരുന്നു",
      thumb: "assets/img/Pastevents/5299.jpg",
    },
    {
      src: "assets/img/Pastevents/5300.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ കപ്പിയാറ ശ്രീ ഭദ്രകാളി ക്ഷേത്രത്തിൽ വച്ച്  നടന്ന സൗജന്യ മെഡിക്കൽ ക്യാമ്പ്....ജനറൽ മെഡിസിൻ ,ദന്തൽ ,ഒഫ്താൽമോളജി, ഇ സി ജി, രക്തസമ്മർദ്ദപരിശോധന, പ്രമേഹരോഗ നിർണയം തുടങ്ങിയ സൗജന്യ സേവനങ്ങളും ക്യാമ്പിൽ ലഭ്യമാക്കിയിരുന്നു",
      thumb: "assets/img/Pastevents/5300.jpg",
    },
    {
      src: "assets/img/Pastevents/5301.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ കപ്പിയാറ ശ്രീ ഭദ്രകാളി ക്ഷേത്രത്തിൽ വച്ച്  നടന്ന സൗജന്യ മെഡിക്കൽ ക്യാമ്പ്....ജനറൽ മെഡിസിൻ ,ദന്തൽ ,ഒഫ്താൽമോളജി, ഇ സി ജി, രക്തസമ്മർദ്ദപരിശോധന, പ്രമേഹരോഗ നിർണയം തുടങ്ങിയ സൗജന്യ സേവനങ്ങളും ക്യാമ്പിൽ ലഭ്യമാക്കിയിരുന്നു",
      thumb: "assets/img/Pastevents/5301.jpg",
    },
    {
      src: "assets/img/Pastevents/5302.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ കപ്പിയാറ ശ്രീ ഭദ്രകാളി ക്ഷേത്രത്തിൽ വച്ച്  നടന്ന സൗജന്യ മെഡിക്കൽ ക്യാമ്പ്....ജനറൽ മെഡിസിൻ ,ദന്തൽ ,ഒഫ്താൽമോളജി, ഇ സി ജി, രക്തസമ്മർദ്ദപരിശോധന, പ്രമേഹരോഗ നിർണയം തുടങ്ങിയ സൗജന്യ സേവനങ്ങളും ക്യാമ്പിൽ ലഭ്യമാക്കിയിരുന്നു",
      thumb: "assets/img/Pastevents/5302.jpg",
    },
    {
      src: "assets/img/Pastevents/5303.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ കപ്പിയാറ ശ്രീ ഭദ്രകാളി ക്ഷേത്രത്തിൽ വച്ച്  നടന്ന സൗജന്യ മെഡിക്കൽ ക്യാമ്പ്....ജനറൽ മെഡിസിൻ ,ദന്തൽ ,ഒഫ്താൽമോളജി, ഇ സി ജി, രക്തസമ്മർദ്ദപരിശോധന, പ്രമേഹരോഗ നിർണയം തുടങ്ങിയ സൗജന്യ സേവനങ്ങളും ക്യാമ്പിൽ ലഭ്യമാക്കിയിരുന്നു",
      thumb: "assets/img/Pastevents/5303.jpg",
    },
    {
      src: "assets/img/Pastevents/5290.jpg",
      caption:
        "വെള്ളറട നിംസ് ടെലി മെഡിസിൻ ക്ലിനിക്കിൽ വച്ച് നടന്ന  സൗജന്യ മെഡിക്കൽ ക്യാമ്പ്... നിംസ് മെഡിസിറ്റി ജനറൽ മെഡിസിൻ വിഭാഗം സീനിയർ കൺസൾട്ടന്റ്  ഡോ. സൂരജ് ശശിധരൻ നായർ ക്യാമ്പിന് നേതൃത്വം നൽകി",
      thumb: "assets/img/Pastevents/5290.jpg",
    },
    {
      src: "assets/img/Pastevents/5291.jpg",
      caption:
        "വെള്ളറട നിംസ് ടെലി മെഡിസിൻ ക്ലിനിക്കിൽ വച്ച് നടന്ന  സൗജന്യ മെഡിക്കൽ ക്യാമ്പ്... നിംസ് മെഡിസിറ്റി ജനറൽ മെഡിസിൻ വിഭാഗം സീനിയർ കൺസൾട്ടന്റ്  ഡോ. സൂരജ് ശശിധരൻ നായർ ക്യാമ്പിന് നേതൃത്വം നൽകി",
      thumb: "assets/img/Pastevents/5291.jpg",
    },
    {
      src: "assets/img/Pastevents/5292.jpg",
      caption:
        "വെള്ളറട നിംസ് ടെലി മെഡിസിൻ ക്ലിനിക്കിൽ വച്ച് നടന്ന  സൗജന്യ മെഡിക്കൽ ക്യാമ്പ്... നിംസ് മെഡിസിറ്റി ജനറൽ മെഡിസിൻ വിഭാഗം സീനിയർ കൺസൾട്ടന്റ്  ഡോ. സൂരജ് ശശിധരൻ നായർ ക്യാമ്പിന് നേതൃത്വം നൽകി",
      thumb: "assets/img/Pastevents/5292.jpg",
    },
    {
      src: "assets/img/Pastevents/5293.jpg",
      caption:
        "വെള്ളറട നിംസ് ടെലി മെഡിസിൻ ക്ലിനിക്കിൽ വച്ച് നടന്ന  സൗജന്യ മെഡിക്കൽ ക്യാമ്പ്... നിംസ് മെഡിസിറ്റി ജനറൽ മെഡിസിൻ വിഭാഗം സീനിയർ കൺസൾട്ടന്റ്  ഡോ. സൂരജ് ശശിധരൻ നായർ ക്യാമ്പിന് നേതൃത്വം നൽകി",
      thumb: "assets/img/Pastevents/5293.jpg",
    },
    {
      src: "assets/img/Pastevents/5294.jpg",
      caption:
        "വെള്ളറട നിംസ് ടെലി മെഡിസിൻ ക്ലിനിക്കിൽ വച്ച് നടന്ന  സൗജന്യ മെഡിക്കൽ ക്യാമ്പ്... നിംസ് മെഡിസിറ്റി ജനറൽ മെഡിസിൻ വിഭാഗം സീനിയർ കൺസൾട്ടന്റ്  ഡോ. സൂരജ് ശശിധരൻ നായർ ക്യാമ്പിന് നേതൃത്വം നൽകി",
      thumb: "assets/img/Pastevents/5294.jpg",
    },
    {
      src: "assets/img/Pastevents/5295.jpg",
      caption:
        "വെള്ളറട നിംസ് ടെലി മെഡിസിൻ ക്ലിനിക്കിൽ വച്ച് നടന്ന  സൗജന്യ മെഡിക്കൽ ക്യാമ്പ്... നിംസ് മെഡിസിറ്റി ജനറൽ മെഡിസിൻ വിഭാഗം സീനിയർ കൺസൾട്ടന്റ്  ഡോ. സൂരജ് ശശിധരൻ നായർ ക്യാമ്പിന് നേതൃത്വം നൽകി",
      thumb: "assets/img/Pastevents/5295.jpg",
    },
    {
      src: "assets/img/Pastevents/5296.jpg",
      caption:
        "വെള്ളറട നിംസ് ടെലി മെഡിസിൻ ക്ലിനിക്കിൽ വച്ച് നടന്ന  സൗജന്യ മെഡിക്കൽ ക്യാമ്പ്... നിംസ് മെഡിസിറ്റി ജനറൽ മെഡിസിൻ വിഭാഗം സീനിയർ കൺസൾട്ടന്റ്  ഡോ. സൂരജ് ശശിധരൻ നായർ ക്യാമ്പിന് നേതൃത്വം നൽകി",
      thumb: "assets/img/Pastevents/5296.jpg",
    },
    {
      src: "assets/img/Pastevents/5271.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ ഊരുട്ടുകല ശ്രീ ഭദ്രകാളി ദേവീ ക്ഷേത്രത്തിൽ സമൂഹ പൊങ്കാലയോടനുബന്ധിച്ച്  നടന്ന സൗജന്യ മെഡിക്കൽ ക്യാമ്പ്...",
      thumb: "assets/img/Pastevents/5271.jpg",
    },
    {
      src: "assets/img/Pastevents/5272.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ ഊരുട്ടുകല ശ്രീ ഭദ്രകാളി ദേവീ ക്ഷേത്രത്തിൽ സമൂഹ പൊങ്കാലയോടനുബന്ധിച്ച്  നടന്ന സൗജന്യ മെഡിക്കൽ ക്യാമ്പ്...",
      thumb: "assets/img/Pastevents/5272.jpg",
    },
    {
      src: "assets/img/Pastevents/5273.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ ഊരുട്ടുകല ശ്രീ ഭദ്രകാളി ദേവീ ക്ഷേത്രത്തിൽ സമൂഹ പൊങ്കാലയോടനുബന്ധിച്ച്  നടന്ന സൗജന്യ മെഡിക്കൽ ക്യാമ്പ്...",
      thumb: "assets/img/Pastevents/5273.jpg",
    },
    {
      src: "assets/img/Pastevents/5274.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ ഊരുട്ടുകല ശ്രീ ഭദ്രകാളി ദേവീ ക്ഷേത്രത്തിൽ സമൂഹ പൊങ്കാലയോടനുബന്ധിച്ച്  നടന്ന സൗജന്യ മെഡിക്കൽ ക്യാമ്പ്...",
      thumb: "assets/img/Pastevents/5274.jpg",
    },
    {
      src: "assets/img/Pastevents/5275.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ ഊരുട്ടുകല ശ്രീ ഭദ്രകാളി ദേവീ ക്ഷേത്രത്തിൽ സമൂഹ പൊങ്കാലയോടനുബന്ധിച്ച്  നടന്ന സൗജന്യ മെഡിക്കൽ ക്യാമ്പ്...",
      thumb: "assets/img/Pastevents/5275.jpg",
    },
    {
      src: "assets/img/Pastevents/5276.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ ഊരുട്ടുകല ശ്രീ ഭദ്രകാളി ദേവീ ക്ഷേത്രത്തിൽ സമൂഹ പൊങ്കാലയോടനുബന്ധിച്ച്  നടന്ന സൗജന്യ മെഡിക്കൽ ക്യാമ്പ്...",
      thumb: "assets/img/Pastevents/5276.jpg",
    },
    {
      src: "assets/img/Pastevents/5277.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ ഊരുട്ടുകല ശ്രീ ഭദ്രകാളി ദേവീ ക്ഷേത്രത്തിൽ സമൂഹ പൊങ്കാലയോടനുബന്ധിച്ച്  നടന്ന സൗജന്യ മെഡിക്കൽ ക്യാമ്പ്...",
      thumb: "assets/img/Pastevents/5277.jpg",
    },
    {
      src: "assets/img/Pastevents/5278.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ ഊരുട്ടുകല ശ്രീ ഭദ്രകാളി ദേവീ ക്ഷേത്രത്തിൽ സമൂഹ പൊങ്കാലയോടനുബന്ധിച്ച്  നടന്ന സൗജന്യ മെഡിക്കൽ ക്യാമ്പ്...",
      thumb: "assets/img/Pastevents/5278.jpg",
    },
    {
      src: "assets/img/Pastevents/5279.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ ഊരുട്ടുകല ശ്രീ ഭദ്രകാളി ദേവീ ക്ഷേത്രത്തിൽ സമൂഹ പൊങ്കാലയോടനുബന്ധിച്ച്  നടന്ന സൗജന്യ മെഡിക്കൽ ക്യാമ്പ്...",
      thumb: "assets/img/Pastevents/5279.jpg",
    },
    {
      src: "assets/img/Pastevents/5280.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ ഊരുട്ടുകല ശ്രീ ഭദ്രകാളി ദേവീ ക്ഷേത്രത്തിൽ സമൂഹ പൊങ്കാലയോടനുബന്ധിച്ച്  നടന്ന സൗജന്യ മെഡിക്കൽ ക്യാമ്പ്...",
      thumb: "assets/img/Pastevents/5280.jpg",
    },
    {
      src: "assets/img/Pastevents/5281.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ ഊരുട്ടുകല ശ്രീ ഭദ്രകാളി ദേവീ ക്ഷേത്രത്തിൽ സമൂഹ പൊങ്കാലയോടനുബന്ധിച്ച്  നടന്ന സൗജന്യ മെഡിക്കൽ ക്യാമ്പ്...",
      thumb: "assets/img/Pastevents/5281.jpg",
    },
    {
      src: "assets/img/Pastevents/5282.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ ഊരുട്ടുകല ശ്രീ ഭദ്രകാളി ദേവീ ക്ഷേത്രത്തിൽ സമൂഹ പൊങ്കാലയോടനുബന്ധിച്ച്  നടന്ന സൗജന്യ മെഡിക്കൽ ക്യാമ്പ്...",
      thumb: "assets/img/Pastevents/5282.jpg",
    },
    {
      src: "assets/img/Pastevents/5283.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ ഊരുട്ടുകല ശ്രീ ഭദ്രകാളി ദേവീ ക്ഷേത്രത്തിൽ സമൂഹ പൊങ്കാലയോടനുബന്ധിച്ച്  നടന്ന സൗജന്യ മെഡിക്കൽ ക്യാമ്പ്...",
      thumb: "assets/img/Pastevents/5283.jpg",
    },
    {
      src: "assets/img/Pastevents/5284.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ ഊരുട്ടുകല ശ്രീ ഭദ്രകാളി ദേവീ ക്ഷേത്രത്തിൽ സമൂഹ പൊങ്കാലയോടനുബന്ധിച്ച്  നടന്ന സൗജന്യ മെഡിക്കൽ ക്യാമ്പ്...",
      thumb: "assets/img/Pastevents/5284.jpg",
    },
    {
      src: "assets/img/Pastevents/5285.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ ഊരുട്ടുകല ശ്രീ ഭദ്രകാളി ദേവീ ക്ഷേത്രത്തിൽ സമൂഹ പൊങ്കാലയോടനുബന്ധിച്ച്  നടന്ന സൗജന്യ മെഡിക്കൽ ക്യാമ്പ്...",
      thumb: "assets/img/Pastevents/5285.jpg",
    },
    {
      src: "assets/img/Pastevents/5286.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ ഊരുട്ടുകല ശ്രീ ഭദ്രകാളി ദേവീ ക്ഷേത്രത്തിൽ സമൂഹ പൊങ്കാലയോടനുബന്ധിച്ച്  നടന്ന സൗജന്യ മെഡിക്കൽ ക്യാമ്പ്...",
      thumb: "assets/img/Pastevents/5286.jpg",
    },
    {
      src: "assets/img/Pastevents/5287.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ ഊരുട്ടുകല ശ്രീ ഭദ്രകാളി ദേവീ ക്ഷേത്രത്തിൽ സമൂഹ പൊങ്കാലയോടനുബന്ധിച്ച്  നടന്ന സൗജന്യ മെഡിക്കൽ ക്യാമ്പ്...",
      thumb: "assets/img/Pastevents/5287.jpg",
    },
    {
      src: "assets/img/Pastevents/5288.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ ഊരുട്ടുകല ശ്രീ ഭദ്രകാളി ദേവീ ക്ഷേത്രത്തിൽ സമൂഹ പൊങ്കാലയോടനുബന്ധിച്ച്  നടന്ന സൗജന്യ മെഡിക്കൽ ക്യാമ്പ്...",
      thumb: "assets/img/Pastevents/5288.jpg",
    },
    {
      src: "assets/img/Pastevents/5289.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ ഊരുട്ടുകല ശ്രീ ഭദ്രകാളി ദേവീ ക്ഷേത്രത്തിൽ സമൂഹ പൊങ്കാലയോടനുബന്ധിച്ച്  നടന്ന സൗജന്യ മെഡിക്കൽ ക്യാമ്പ്...",
      thumb: "assets/img/Pastevents/5289.jpg",
    },
    {
      src: "assets/img/Pastevents/5257.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയും, മഹാത്മാ സാംസ്‌കാരിക വേദിയും സംയുക്തമായി നടത്തിയ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ്...",
      thumb: "assets/img/Pastevents/5257.jpg",
    },
    {
      src: "assets/img/Pastevents/5258.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയും, മഹാത്മാ സാംസ്‌കാരിക വേദിയും സംയുക്തമായി നടത്തിയ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ്...",
      thumb: "assets/img/Pastevents/5258.jpg",
    },
    {
      src: "assets/img/Pastevents/5259.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയും, മഹാത്മാ സാംസ്‌കാരിക വേദിയും സംയുക്തമായി നടത്തിയ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ്...",
      thumb: "assets/img/Pastevents/5259.jpg",
    },
    {
      src: "assets/img/Pastevents/5260.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയും, മഹാത്മാ സാംസ്‌കാരിക വേദിയും സംയുക്തമായി നടത്തിയ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ്...",
      thumb: "assets/img/Pastevents/5260.jpg",
    },
    {
      src: "assets/img/Pastevents/5261.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയും, മഹാത്മാ സാംസ്‌കാരിക വേദിയും സംയുക്തമായി നടത്തിയ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ്...",
      thumb: "assets/img/Pastevents/5261.jpg",
    },
    {
      src: "assets/img/Pastevents/5262.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയും, മഹാത്മാ സാംസ്‌കാരിക വേദിയും സംയുക്തമായി നടത്തിയ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ്...",
      thumb: "assets/img/Pastevents/5262.jpg",
    },
    {
      src: "assets/img/Pastevents/5263.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയും, മഹാത്മാ സാംസ്‌കാരിക വേദിയും സംയുക്തമായി നടത്തിയ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ്...",
      thumb: "assets/img/Pastevents/5263.jpg",
    },
    {
      src: "assets/img/Pastevents/5264.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയും, മഹാത്മാ സാംസ്‌കാരിക വേദിയും സംയുക്തമായി നടത്തിയ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ്...",
      thumb: "assets/img/Pastevents/5264.jpg",
    },
    {
      src: "assets/img/Pastevents/5265.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയും, മഹാത്മാ സാംസ്‌കാരിക വേദിയും സംയുക്തമായി നടത്തിയ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ്...",
      thumb: "assets/img/Pastevents/5265.jpg",
    },
    {
      src: "assets/img/Pastevents/5266.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയും, മഹാത്മാ സാംസ്‌കാരിക വേദിയും സംയുക്തമായി നടത്തിയ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ്...",
      thumb: "assets/img/Pastevents/5266.jpg",
    },
    {
      src: "assets/img/Pastevents/5267.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയും, മഹാത്മാ സാംസ്‌കാരിക വേദിയും സംയുക്തമായി നടത്തിയ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ്...",
      thumb: "assets/img/Pastevents/5267.jpg",
    },
    {
      src: "assets/img/Pastevents/5268.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയും, മഹാത്മാ സാംസ്‌കാരിക വേദിയും സംയുക്തമായി നടത്തിയ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ്...",
      thumb: "assets/img/Pastevents/5268.jpg",
    },
    {
      src: "assets/img/Pastevents/5269.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയും, മഹാത്മാ സാംസ്‌കാരിക വേദിയും സംയുക്തമായി നടത്തിയ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ്...",
      thumb: "assets/img/Pastevents/5269.jpg",
    },
    {
      src: "assets/img/Pastevents/5270.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയും, മഹാത്മാ സാംസ്‌കാരിക വേദിയും സംയുക്തമായി നടത്തിയ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ്...",
      thumb: "assets/img/Pastevents/5270.jpg",
    },
    {
      src: "assets/img/Pastevents/5245.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയും, മഹാത്മാ സാംസ്‌കാരിക വേദിയും സംയുക്തമായി നടത്തിയ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ്...",
      thumb: "assets/img/Pastevents/5245.jpg",
    },
    {
      src: "assets/img/Pastevents/5246.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയും, മഹാത്മാ സാംസ്‌കാരിക വേദിയും സംയുക്തമായി നടത്തിയ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ്...",
      thumb: "assets/img/Pastevents/5246.jpg",
    },
    {
      src: "assets/img/Pastevents/5247.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയും, മഹാത്മാ സാംസ്‌കാരിക വേദിയും സംയുക്തമായി നടത്തിയ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ്...",
      thumb: "assets/img/Pastevents/5247.jpg",
    },
    {
      src: "assets/img/Pastevents/5248.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയും, മഹാത്മാ സാംസ്‌കാരിക വേദിയും സംയുക്തമായി നടത്തിയ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ്...",
      thumb: "assets/img/Pastevents/5248.jpg",
    },
    {
      src: "assets/img/Pastevents/5249.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയും, മഹാത്മാ സാംസ്‌കാരിക വേദിയും സംയുക്തമായി നടത്തിയ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ്...",
      thumb: "assets/img/Pastevents/5249.jpg",
    },
    {
      src: "assets/img/Pastevents/5250.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയും, മഹാത്മാ സാംസ്‌കാരിക വേദിയും സംയുക്തമായി നടത്തിയ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ്...",
      thumb: "assets/img/Pastevents/5250.jpg",
    },
    {
      src: "assets/img/Pastevents/5251.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയും, മഹാത്മാ സാംസ്‌കാരിക വേദിയും സംയുക്തമായി നടത്തിയ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ്...",
      thumb: "assets/img/Pastevents/5251.jpg",
    },
    {
      src: "assets/img/Pastevents/5252.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയും, മഹാത്മാ സാംസ്‌കാരിക വേദിയും സംയുക്തമായി നടത്തിയ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ്...",
      thumb: "assets/img/Pastevents/5252.jpg",
    },
    {
      src: "assets/img/Pastevents/5253.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയും, മഹാത്മാ സാംസ്‌കാരിക വേദിയും സംയുക്തമായി നടത്തിയ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ്...",
      thumb: "assets/img/Pastevents/5253.jpg",
    },
    {
      src: "assets/img/Pastevents/5254.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയും, മഹാത്മാ സാംസ്‌കാരിക വേദിയും സംയുക്തമായി നടത്തിയ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ്...",
      thumb: "assets/img/Pastevents/5254.jpg",
    },
    {
      src: "assets/img/Pastevents/5255.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയും, മഹാത്മാ സാംസ്‌കാരിക വേദിയും സംയുക്തമായി നടത്തിയ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ്...",
      thumb: "assets/img/Pastevents/5255.jpg",
    },
    {
      src: "assets/img/Pastevents/5256.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയും, മഹാത്മാ സാംസ്‌കാരിക വേദിയും സംയുക്തമായി നടത്തിയ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ്...",
      thumb: "assets/img/Pastevents/5256.jpg",
    },
    {
      src: "assets/img/Pastevents/5225.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ  നോർത്ത് ഏരിയ പിറയിൽ റസിഡൻസ് അസോസിയേഷൻ സംയുക്തമായി നടത്തിയ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ്. നിംസ് മെഡിസിറ്റി ജനറൽ മെഡിസിൻ വിഭാഗം  കൺസൾട്ടന്റ്  ഡോ. ഷഹബാസ് എം സൈലു , ഓങ്കോളജി വിഭാഗം  കൺസൾട്ടന്റ് ഡോ. അഞ്ചു എസ് ചന്ദ്രബോസ്, ജനറൽ മെഡിസിൻ വിഭാഗം സീനിയർ കൺസൾട്ടന്റ്  ഡോ. സൂരജ് ശശിധരൻ നായർ , ഡോ. ആവണി തുടങ്ങി വിദഗ്ദ്ധരായ ഡോക്ടർമാരുടെ സേവനം ക്യാമ്പിൽ ലഭ്യമാക്കിയിരുന്നു",
      thumb: "assets/img/Pastevents/5225.jpg",
    },
    {
      src: "assets/img/Pastevents/5226.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ  നോർത്ത് ഏരിയ പിറയിൽ റസിഡൻസ് അസോസിയേഷൻ സംയുക്തമായി നടത്തിയ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ്. നിംസ് മെഡിസിറ്റി ജനറൽ മെഡിസിൻ വിഭാഗം  കൺസൾട്ടന്റ്  ഡോ. ഷഹബാസ് എം സൈലു , ഓങ്കോളജി വിഭാഗം  കൺസൾട്ടന്റ് ഡോ. അഞ്ചു എസ് ചന്ദ്രബോസ്, ജനറൽ മെഡിസിൻ വിഭാഗം സീനിയർ കൺസൾട്ടന്റ്  ഡോ. സൂരജ് ശശിധരൻ നായർ , ഡോ. ആവണി തുടങ്ങി വിദഗ്ദ്ധരായ ഡോക്ടർമാരുടെ സേവനം ക്യാമ്പിൽ ലഭ്യമാക്കിയിരുന്നു",
      thumb: "assets/img/Pastevents/5226.jpg",
    },
    {
      src: "assets/img/Pastevents/5227.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ  നോർത്ത് ഏരിയ പിറയിൽ റസിഡൻസ് അസോസിയേഷൻ സംയുക്തമായി നടത്തിയ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ്. നിംസ് മെഡിസിറ്റി ജനറൽ മെഡിസിൻ വിഭാഗം  കൺസൾട്ടന്റ്  ഡോ. ഷഹബാസ് എം സൈലു , ഓങ്കോളജി വിഭാഗം  കൺസൾട്ടന്റ് ഡോ. അഞ്ചു എസ് ചന്ദ്രബോസ്, ജനറൽ മെഡിസിൻ വിഭാഗം സീനിയർ കൺസൾട്ടന്റ്  ഡോ. സൂരജ് ശശിധരൻ നായർ , ഡോ. ആവണി തുടങ്ങി വിദഗ്ദ്ധരായ ഡോക്ടർമാരുടെ സേവനം ക്യാമ്പിൽ ലഭ്യമാക്കിയിരുന്നു",
      thumb: "assets/img/Pastevents/5227.jpg",
    },
    {
      src: "assets/img/Pastevents/5228.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ  നോർത്ത് ഏരിയ പിറയിൽ റസിഡൻസ് അസോസിയേഷൻ സംയുക്തമായി നടത്തിയ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ്. നിംസ് മെഡിസിറ്റി ജനറൽ മെഡിസിൻ വിഭാഗം  കൺസൾട്ടന്റ്  ഡോ. ഷഹബാസ് എം സൈലു , ഓങ്കോളജി വിഭാഗം  കൺസൾട്ടന്റ് ഡോ. അഞ്ചു എസ് ചന്ദ്രബോസ്, ജനറൽ മെഡിസിൻ വിഭാഗം സീനിയർ കൺസൾട്ടന്റ്  ഡോ. സൂരജ് ശശിധരൻ നായർ , ഡോ. ആവണി തുടങ്ങി വിദഗ്ദ്ധരായ ഡോക്ടർമാരുടെ സേവനം ക്യാമ്പിൽ ലഭ്യമാക്കിയിരുന്നു",
      thumb: "assets/img/Pastevents/5228.jpg",
    },
    {
      src: "assets/img/Pastevents/5229.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ  നോർത്ത് ഏരിയ പിറയിൽ റസിഡൻസ് അസോസിയേഷൻ സംയുക്തമായി നടത്തിയ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ്. നിംസ് മെഡിസിറ്റി ജനറൽ മെഡിസിൻ വിഭാഗം  കൺസൾട്ടന്റ്  ഡോ. ഷഹബാസ് എം സൈലു , ഓങ്കോളജി വിഭാഗം  കൺസൾട്ടന്റ് ഡോ. അഞ്ചു എസ് ചന്ദ്രബോസ്, ജനറൽ മെഡിസിൻ വിഭാഗം സീനിയർ കൺസൾട്ടന്റ്  ഡോ. സൂരജ് ശശിധരൻ നായർ , ഡോ. ആവണി തുടങ്ങി വിദഗ്ദ്ധരായ ഡോക്ടർമാരുടെ സേവനം ക്യാമ്പിൽ ലഭ്യമാക്കിയിരുന്നു",
      thumb: "assets/img/Pastevents/5229.jpg",
    },
    {
      src: "assets/img/Pastevents/5230.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ  നോർത്ത് ഏരിയ പിറയിൽ റസിഡൻസ് അസോസിയേഷൻ സംയുക്തമായി നടത്തിയ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ്. നിംസ് മെഡിസിറ്റി ജനറൽ മെഡിസിൻ വിഭാഗം  കൺസൾട്ടന്റ്  ഡോ. ഷഹബാസ് എം സൈലു , ഓങ്കോളജി വിഭാഗം  കൺസൾട്ടന്റ് ഡോ. അഞ്ചു എസ് ചന്ദ്രബോസ്, ജനറൽ മെഡിസിൻ വിഭാഗം സീനിയർ കൺസൾട്ടന്റ്  ഡോ. സൂരജ് ശശിധരൻ നായർ , ഡോ. ആവണി തുടങ്ങി വിദഗ്ദ്ധരായ ഡോക്ടർമാരുടെ സേവനം ക്യാമ്പിൽ ലഭ്യമാക്കിയിരുന്നു",
      thumb: "assets/img/Pastevents/5230.jpg",
    },
    {
      src: "assets/img/Pastevents/5231.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ  നോർത്ത് ഏരിയ പിറയിൽ റസിഡൻസ് അസോസിയേഷൻ സംയുക്തമായി നടത്തിയ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ്. നിംസ് മെഡിസിറ്റി ജനറൽ മെഡിസിൻ വിഭാഗം  കൺസൾട്ടന്റ്  ഡോ. ഷഹബാസ് എം സൈലു , ഓങ്കോളജി വിഭാഗം  കൺസൾട്ടന്റ് ഡോ. അഞ്ചു എസ് ചന്ദ്രബോസ്, ജനറൽ മെഡിസിൻ വിഭാഗം സീനിയർ കൺസൾട്ടന്റ്  ഡോ. സൂരജ് ശശിധരൻ നായർ , ഡോ. ആവണി തുടങ്ങി വിദഗ്ദ്ധരായ ഡോക്ടർമാരുടെ സേവനം ക്യാമ്പിൽ ലഭ്യമാക്കിയിരുന്നു",
      thumb: "assets/img/Pastevents/5231.jpg",
    },
    {
      src: "assets/img/Pastevents/5232.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ  നോർത്ത് ഏരിയ പിറയിൽ റസിഡൻസ് അസോസിയേഷൻ സംയുക്തമായി നടത്തിയ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ്. നിംസ് മെഡിസിറ്റി ജനറൽ മെഡിസിൻ വിഭാഗം  കൺസൾട്ടന്റ്  ഡോ. ഷഹബാസ് എം സൈലു , ഓങ്കോളജി വിഭാഗം  കൺസൾട്ടന്റ് ഡോ. അഞ്ചു എസ് ചന്ദ്രബോസ്, ജനറൽ മെഡിസിൻ വിഭാഗം സീനിയർ കൺസൾട്ടന്റ്  ഡോ. സൂരജ് ശശിധരൻ നായർ , ഡോ. ആവണി തുടങ്ങി വിദഗ്ദ്ധരായ ഡോക്ടർമാരുടെ സേവനം ക്യാമ്പിൽ ലഭ്യമാക്കിയിരുന്നു",
      thumb: "assets/img/Pastevents/5232.jpg",
    },
    {
      src: "assets/img/Pastevents/5233.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ  നോർത്ത് ഏരിയ പിറയിൽ റസിഡൻസ് അസോസിയേഷൻ സംയുക്തമായി നടത്തിയ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ്. നിംസ് മെഡിസിറ്റി ജനറൽ മെഡിസിൻ വിഭാഗം  കൺസൾട്ടന്റ്  ഡോ. ഷഹബാസ് എം സൈലു , ഓങ്കോളജി വിഭാഗം  കൺസൾട്ടന്റ് ഡോ. അഞ്ചു എസ് ചന്ദ്രബോസ്, ജനറൽ മെഡിസിൻ വിഭാഗം സീനിയർ കൺസൾട്ടന്റ്  ഡോ. സൂരജ് ശശിധരൻ നായർ , ഡോ. ആവണി തുടങ്ങി വിദഗ്ദ്ധരായ ഡോക്ടർമാരുടെ സേവനം ക്യാമ്പിൽ ലഭ്യമാക്കിയിരുന്നു",
      thumb: "assets/img/Pastevents/5233.jpg",
    },
    {
      src: "assets/img/Pastevents/5234.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ  നോർത്ത് ഏരിയ പിറയിൽ റസിഡൻസ് അസോസിയേഷൻ സംയുക്തമായി നടത്തിയ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ്. നിംസ് മെഡിസിറ്റി ജനറൽ മെഡിസിൻ വിഭാഗം  കൺസൾട്ടന്റ്  ഡോ. ഷഹബാസ് എം സൈലു , ഓങ്കോളജി വിഭാഗം  കൺസൾട്ടന്റ് ഡോ. അഞ്ചു എസ് ചന്ദ്രബോസ്, ജനറൽ മെഡിസിൻ വിഭാഗം സീനിയർ കൺസൾട്ടന്റ്  ഡോ. സൂരജ് ശശിധരൻ നായർ , ഡോ. ആവണി തുടങ്ങി വിദഗ്ദ്ധരായ ഡോക്ടർമാരുടെ സേവനം ക്യാമ്പിൽ ലഭ്യമാക്കിയിരുന്നു",
      thumb: "assets/img/Pastevents/5234.jpg",
    },
    {
      src: "assets/img/Pastevents/5235.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ  നോർത്ത് ഏരിയ പിറയിൽ റസിഡൻസ് അസോസിയേഷൻ സംയുക്തമായി നടത്തിയ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ്. നിംസ് മെഡിസിറ്റി ജനറൽ മെഡിസിൻ വിഭാഗം  കൺസൾട്ടന്റ്  ഡോ. ഷഹബാസ് എം സൈലു , ഓങ്കോളജി വിഭാഗം  കൺസൾട്ടന്റ് ഡോ. അഞ്ചു എസ് ചന്ദ്രബോസ്, ജനറൽ മെഡിസിൻ വിഭാഗം സീനിയർ കൺസൾട്ടന്റ്  ഡോ. സൂരജ് ശശിധരൻ നായർ , ഡോ. ആവണി തുടങ്ങി വിദഗ്ദ്ധരായ ഡോക്ടർമാരുടെ സേവനം ക്യാമ്പിൽ ലഭ്യമാക്കിയിരുന്നു",
      thumb: "assets/img/Pastevents/5235.jpg",
    },
    {
      src: "assets/img/Pastevents/5236.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ  നോർത്ത് ഏരിയ പിറയിൽ റസിഡൻസ് അസോസിയേഷൻ സംയുക്തമായി നടത്തിയ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ്. നിംസ് മെഡിസിറ്റി ജനറൽ മെഡിസിൻ വിഭാഗം  കൺസൾട്ടന്റ്  ഡോ. ഷഹബാസ് എം സൈലു , ഓങ്കോളജി വിഭാഗം  കൺസൾട്ടന്റ് ഡോ. അഞ്ചു എസ് ചന്ദ്രബോസ്, ജനറൽ മെഡിസിൻ വിഭാഗം സീനിയർ കൺസൾട്ടന്റ്  ഡോ. സൂരജ് ശശിധരൻ നായർ , ഡോ. ആവണി തുടങ്ങി വിദഗ്ദ്ധരായ ഡോക്ടർമാരുടെ സേവനം ക്യാമ്പിൽ ലഭ്യമാക്കിയിരുന്നു",
      thumb: "assets/img/Pastevents/5236.jpg",
    },
    {
      src: "assets/img/Pastevents/5237.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ  നോർത്ത് ഏരിയ പിറയിൽ റസിഡൻസ് അസോസിയേഷൻ സംയുക്തമായി നടത്തിയ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ്. നിംസ് മെഡിസിറ്റി ജനറൽ മെഡിസിൻ വിഭാഗം  കൺസൾട്ടന്റ്  ഡോ. ഷഹബാസ് എം സൈലു , ഓങ്കോളജി വിഭാഗം  കൺസൾട്ടന്റ് ഡോ. അഞ്ചു എസ് ചന്ദ്രബോസ്, ജനറൽ മെഡിസിൻ വിഭാഗം സീനിയർ കൺസൾട്ടന്റ്  ഡോ. സൂരജ് ശശിധരൻ നായർ , ഡോ. ആവണി തുടങ്ങി വിദഗ്ദ്ധരായ ഡോക്ടർമാരുടെ സേവനം ക്യാമ്പിൽ ലഭ്യമാക്കിയിരുന്നു",
      thumb: "assets/img/Pastevents/5237.jpg",
    },
    {
      src: "assets/img/Pastevents/5238.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ  നോർത്ത് ഏരിയ പിറയിൽ റസിഡൻസ് അസോസിയേഷൻ സംയുക്തമായി നടത്തിയ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ്. നിംസ് മെഡിസിറ്റി ജനറൽ മെഡിസിൻ വിഭാഗം  കൺസൾട്ടന്റ്  ഡോ. ഷഹബാസ് എം സൈലു , ഓങ്കോളജി വിഭാഗം  കൺസൾട്ടന്റ് ഡോ. അഞ്ചു എസ് ചന്ദ്രബോസ്, ജനറൽ മെഡിസിൻ വിഭാഗം സീനിയർ കൺസൾട്ടന്റ്  ഡോ. സൂരജ് ശശിധരൻ നായർ , ഡോ. ആവണി തുടങ്ങി വിദഗ്ദ്ധരായ ഡോക്ടർമാരുടെ സേവനം ക്യാമ്പിൽ ലഭ്യമാക്കിയിരുന്നു",
      thumb: "assets/img/Pastevents/5238.jpg",
    },
    {
      src: "assets/img/Pastevents/5239.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ  നോർത്ത് ഏരിയ പിറയിൽ റസിഡൻസ് അസോസിയേഷൻ സംയുക്തമായി നടത്തിയ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ്. നിംസ് മെഡിസിറ്റി ജനറൽ മെഡിസിൻ വിഭാഗം  കൺസൾട്ടന്റ്  ഡോ. ഷഹബാസ് എം സൈലു , ഓങ്കോളജി വിഭാഗം  കൺസൾട്ടന്റ് ഡോ. അഞ്ചു എസ് ചന്ദ്രബോസ്, ജനറൽ മെഡിസിൻ വിഭാഗം സീനിയർ കൺസൾട്ടന്റ്  ഡോ. സൂരജ് ശശിധരൻ നായർ , ഡോ. ആവണി തുടങ്ങി വിദഗ്ദ്ധരായ ഡോക്ടർമാരുടെ സേവനം ക്യാമ്പിൽ ലഭ്യമാക്കിയിരുന്നു",
      thumb: "assets/img/Pastevents/5239.jpg",
    },
    {
      src: "assets/img/Pastevents/5240.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ  നോർത്ത് ഏരിയ പിറയിൽ റസിഡൻസ് അസോസിയേഷൻ സംയുക്തമായി നടത്തിയ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ്. നിംസ് മെഡിസിറ്റി ജനറൽ മെഡിസിൻ വിഭാഗം  കൺസൾട്ടന്റ്  ഡോ. ഷഹബാസ് എം സൈലു , ഓങ്കോളജി വിഭാഗം  കൺസൾട്ടന്റ് ഡോ. അഞ്ചു എസ് ചന്ദ്രബോസ്, ജനറൽ മെഡിസിൻ വിഭാഗം സീനിയർ കൺസൾട്ടന്റ്  ഡോ. സൂരജ് ശശിധരൻ നായർ , ഡോ. ആവണി തുടങ്ങി വിദഗ്ദ്ധരായ ഡോക്ടർമാരുടെ സേവനം ക്യാമ്പിൽ ലഭ്യമാക്കിയിരുന്നു",
      thumb: "assets/img/Pastevents/5240.jpg",
    },
    {
      src: "assets/img/Pastevents/5241.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ  നോർത്ത് ഏരിയ പിറയിൽ റസിഡൻസ് അസോസിയേഷൻ സംയുക്തമായി നടത്തിയ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ്. നിംസ് മെഡിസിറ്റി ജനറൽ മെഡിസിൻ വിഭാഗം  കൺസൾട്ടന്റ്  ഡോ. ഷഹബാസ് എം സൈലു , ഓങ്കോളജി വിഭാഗം  കൺസൾട്ടന്റ് ഡോ. അഞ്ചു എസ് ചന്ദ്രബോസ്, ജനറൽ മെഡിസിൻ വിഭാഗം സീനിയർ കൺസൾട്ടന്റ്  ഡോ. സൂരജ് ശശിധരൻ നായർ , ഡോ. ആവണി തുടങ്ങി വിദഗ്ദ്ധരായ ഡോക്ടർമാരുടെ സേവനം ക്യാമ്പിൽ ലഭ്യമാക്കിയിരുന്നു",
      thumb: "assets/img/Pastevents/5241.jpg",
    },
    {
      src: "assets/img/Pastevents/5242.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ  നോർത്ത് ഏരിയ പിറയിൽ റസിഡൻസ് അസോസിയേഷൻ സംയുക്തമായി നടത്തിയ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ്. നിംസ് മെഡിസിറ്റി ജനറൽ മെഡിസിൻ വിഭാഗം  കൺസൾട്ടന്റ്  ഡോ. ഷഹബാസ് എം സൈലു , ഓങ്കോളജി വിഭാഗം  കൺസൾട്ടന്റ് ഡോ. അഞ്ചു എസ് ചന്ദ്രബോസ്, ജനറൽ മെഡിസിൻ വിഭാഗം സീനിയർ കൺസൾട്ടന്റ്  ഡോ. സൂരജ് ശശിധരൻ നായർ , ഡോ. ആവണി തുടങ്ങി വിദഗ്ദ്ധരായ ഡോക്ടർമാരുടെ സേവനം ക്യാമ്പിൽ ലഭ്യമാക്കിയിരുന്നു",
      thumb: "assets/img/Pastevents/5242.jpg",
    },
    {
      src: "assets/img/Pastevents/5243.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ  നോർത്ത് ഏരിയ പിറയിൽ റസിഡൻസ് അസോസിയേഷൻ സംയുക്തമായി നടത്തിയ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ്. നിംസ് മെഡിസിറ്റി ജനറൽ മെഡിസിൻ വിഭാഗം  കൺസൾട്ടന്റ്  ഡോ. ഷഹബാസ് എം സൈലു , ഓങ്കോളജി വിഭാഗം  കൺസൾട്ടന്റ് ഡോ. അഞ്ചു എസ് ചന്ദ്രബോസ്, ജനറൽ മെഡിസിൻ വിഭാഗം സീനിയർ കൺസൾട്ടന്റ്  ഡോ. സൂരജ് ശശിധരൻ നായർ , ഡോ. ആവണി തുടങ്ങി വിദഗ്ദ്ധരായ ഡോക്ടർമാരുടെ സേവനം ക്യാമ്പിൽ ലഭ്യമാക്കിയിരുന്നു",
      thumb: "assets/img/Pastevents/5243.jpg",
    },
    {
      src: "assets/img/Pastevents/5244.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ  നോർത്ത് ഏരിയ പിറയിൽ റസിഡൻസ് അസോസിയേഷൻ സംയുക്തമായി നടത്തിയ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ്. നിംസ് മെഡിസിറ്റി ജനറൽ മെഡിസിൻ വിഭാഗം  കൺസൾട്ടന്റ്  ഡോ. ഷഹബാസ് എം സൈലു , ഓങ്കോളജി വിഭാഗം  കൺസൾട്ടന്റ് ഡോ. അഞ്ചു എസ് ചന്ദ്രബോസ്, ജനറൽ മെഡിസിൻ വിഭാഗം സീനിയർ കൺസൾട്ടന്റ്  ഡോ. സൂരജ് ശശിധരൻ നായർ , ഡോ. ആവണി തുടങ്ങി വിദഗ്ദ്ധരായ ഡോക്ടർമാരുടെ സേവനം ക്യാമ്പിൽ ലഭ്യമാക്കിയിരുന്നു",
      thumb: "assets/img/Pastevents/5244.jpg",
    },
    {
      src: "assets/img/Pastevents/5192.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ  കരമന മുസ്‌ലീം ജമാ അത്ത് പരിപാലന സമിതി സംഘടിപ്പിച്ച  സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റി ജനറൽ മെഡിസിൻ കൺസൾട്ടന്റ്  ഡോ. ഷഹബാസ് എം, സൈലു ,ഇ എൻ ടി  കൺസൾട്ടന്റ് ഡോ. സാനി ബിനുക്കുട്ടന്റെ നേതൃത്വത്തിൽ നടന്ന ക്യാമ്പിൽ പെരിഫറൽ ന്യൂറോപ്പതി,ഡയറ്ററി, ദന്തൽ , ഇ സി ജി, ലിപിഡ് പ്രൊഫൈൽ, തൈറോയിഡ്, ആർ. ബി. സി, എച്. ബി. എ വൺ. സി, യൂറിക് ആസിഡ്, രക്തസമ്മർദ്ദ പരിശോധന, പ്രമേഹരോഗ നിർണയം തുടങ്ങിയ സേവനങ്ങളും ലഭ്യമാക്കിയിരുന്നു...",
      thumb: "assets/img/Pastevents/5192.jpg",
    },
    {
      src: "assets/img/Pastevents/5193.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ  കരമന മുസ്‌ലീം ജമാ അത്ത് പരിപാലന സമിതി സംഘടിപ്പിച്ച  സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റി ജനറൽ മെഡിസിൻ കൺസൾട്ടന്റ്  ഡോ. ഷഹബാസ് എം, സൈലു ,ഇ എൻ ടി  കൺസൾട്ടന്റ് ഡോ. സാനി ബിനുക്കുട്ടന്റെ നേതൃത്വത്തിൽ നടന്ന ക്യാമ്പിൽ പെരിഫറൽ ന്യൂറോപ്പതി,ഡയറ്ററി, ദന്തൽ , ഇ സി ജി, ലിപിഡ് പ്രൊഫൈൽ, തൈറോയിഡ്, ആർ. ബി. സി, എച്. ബി. എ വൺ. സി, യൂറിക് ആസിഡ്, രക്തസമ്മർദ്ദ പരിശോധന, പ്രമേഹരോഗ നിർണയം തുടങ്ങിയ സേവനങ്ങളും ലഭ്യമാക്കിയിരുന്നു...",
      thumb: "assets/img/Pastevents/5193.jpg",
    },
    {
      src: "assets/img/Pastevents/5194.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ  കരമന മുസ്‌ലീം ജമാ അത്ത് പരിപാലന സമിതി സംഘടിപ്പിച്ച  സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റി ജനറൽ മെഡിസിൻ കൺസൾട്ടന്റ്  ഡോ. ഷഹബാസ് എം, സൈലു ,ഇ എൻ ടി  കൺസൾട്ടന്റ് ഡോ. സാനി ബിനുക്കുട്ടന്റെ നേതൃത്വത്തിൽ നടന്ന ക്യാമ്പിൽ പെരിഫറൽ ന്യൂറോപ്പതി,ഡയറ്ററി, ദന്തൽ , ഇ സി ജി, ലിപിഡ് പ്രൊഫൈൽ, തൈറോയിഡ്, ആർ. ബി. സി, എച്. ബി. എ വൺ. സി, യൂറിക് ആസിഡ്, രക്തസമ്മർദ്ദ പരിശോധന, പ്രമേഹരോഗ നിർണയം തുടങ്ങിയ സേവനങ്ങളും ലഭ്യമാക്കിയിരുന്നു...",
      thumb: "assets/img/Pastevents/5194.jpg",
    },
    {
      src: "assets/img/Pastevents/5195.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ  കരമന മുസ്‌ലീം ജമാ അത്ത് പരിപാലന സമിതി സംഘടിപ്പിച്ച  സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റി ജനറൽ മെഡിസിൻ കൺസൾട്ടന്റ്  ഡോ. ഷഹബാസ് എം, സൈലു ,ഇ എൻ ടി  കൺസൾട്ടന്റ് ഡോ. സാനി ബിനുക്കുട്ടന്റെ നേതൃത്വത്തിൽ നടന്ന ക്യാമ്പിൽ പെരിഫറൽ ന്യൂറോപ്പതി,ഡയറ്ററി, ദന്തൽ , ഇ സി ജി, ലിപിഡ് പ്രൊഫൈൽ, തൈറോയിഡ്, ആർ. ബി. സി, എച്. ബി. എ വൺ. സി, യൂറിക് ആസിഡ്, രക്തസമ്മർദ്ദ പരിശോധന, പ്രമേഹരോഗ നിർണയം തുടങ്ങിയ സേവനങ്ങളും ലഭ്യമാക്കിയിരുന്നു...",
      thumb: "assets/img/Pastevents/5195.jpg",
    },
    {
      src: "assets/img/Pastevents/5196.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ  കരമന മുസ്‌ലീം ജമാ അത്ത് പരിപാലന സമിതി സംഘടിപ്പിച്ച  സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റി ജനറൽ മെഡിസിൻ കൺസൾട്ടന്റ്  ഡോ. ഷഹബാസ് എം, സൈലു ,ഇ എൻ ടി  കൺസൾട്ടന്റ് ഡോ. സാനി ബിനുക്കുട്ടന്റെ നേതൃത്വത്തിൽ നടന്ന ക്യാമ്പിൽ പെരിഫറൽ ന്യൂറോപ്പതി,ഡയറ്ററി, ദന്തൽ , ഇ സി ജി, ലിപിഡ് പ്രൊഫൈൽ, തൈറോയിഡ്, ആർ. ബി. സി, എച്. ബി. എ വൺ. സി, യൂറിക് ആസിഡ്, രക്തസമ്മർദ്ദ പരിശോധന, പ്രമേഹരോഗ നിർണയം തുടങ്ങിയ സേവനങ്ങളും ലഭ്യമാക്കിയിരുന്നു...",
      thumb: "assets/img/Pastevents/5196.jpg",
    },
    {
      src: "assets/img/Pastevents/5197.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ  കരമന മുസ്‌ലീം ജമാ അത്ത് പരിപാലന സമിതി സംഘടിപ്പിച്ച  സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റി ജനറൽ മെഡിസിൻ കൺസൾട്ടന്റ്  ഡോ. ഷഹബാസ് എം, സൈലു ,ഇ എൻ ടി  കൺസൾട്ടന്റ് ഡോ. സാനി ബിനുക്കുട്ടന്റെ നേതൃത്വത്തിൽ നടന്ന ക്യാമ്പിൽ പെരിഫറൽ ന്യൂറോപ്പതി,ഡയറ്ററി, ദന്തൽ , ഇ സി ജി, ലിപിഡ് പ്രൊഫൈൽ, തൈറോയിഡ്, ആർ. ബി. സി, എച്. ബി. എ വൺ. സി, യൂറിക് ആസിഡ്, രക്തസമ്മർദ്ദ പരിശോധന, പ്രമേഹരോഗ നിർണയം തുടങ്ങിയ സേവനങ്ങളും ലഭ്യമാക്കിയിരുന്നു...",
      thumb: "assets/img/Pastevents/5197.jpg",
    },
    {
      src: "assets/img/Pastevents/5198.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ  കരമന മുസ്‌ലീം ജമാ അത്ത് പരിപാലന സമിതി സംഘടിപ്പിച്ച  സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റി ജനറൽ മെഡിസിൻ കൺസൾട്ടന്റ്  ഡോ. ഷഹബാസ് എം, സൈലു ,ഇ എൻ ടി  കൺസൾട്ടന്റ് ഡോ. സാനി ബിനുക്കുട്ടന്റെ നേതൃത്വത്തിൽ നടന്ന ക്യാമ്പിൽ പെരിഫറൽ ന്യൂറോപ്പതി,ഡയറ്ററി, ദന്തൽ , ഇ സി ജി, ലിപിഡ് പ്രൊഫൈൽ, തൈറോയിഡ്, ആർ. ബി. സി, എച്. ബി. എ വൺ. സി, യൂറിക് ആസിഡ്, രക്തസമ്മർദ്ദ പരിശോധന, പ്രമേഹരോഗ നിർണയം തുടങ്ങിയ സേവനങ്ങളും ലഭ്യമാക്കിയിരുന്നു...",
      thumb: "assets/img/Pastevents/5198.jpg",
    },
    {
      src: "assets/img/Pastevents/5199.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ  കരമന മുസ്‌ലീം ജമാ അത്ത് പരിപാലന സമിതി സംഘടിപ്പിച്ച  സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റി ജനറൽ മെഡിസിൻ കൺസൾട്ടന്റ്  ഡോ. ഷഹബാസ് എം, സൈലു ,ഇ എൻ ടി  കൺസൾട്ടന്റ് ഡോ. സാനി ബിനുക്കുട്ടന്റെ നേതൃത്വത്തിൽ നടന്ന ക്യാമ്പിൽ പെരിഫറൽ ന്യൂറോപ്പതി,ഡയറ്ററി, ദന്തൽ , ഇ സി ജി, ലിപിഡ് പ്രൊഫൈൽ, തൈറോയിഡ്, ആർ. ബി. സി, എച്. ബി. എ വൺ. സി, യൂറിക് ആസിഡ്, രക്തസമ്മർദ്ദ പരിശോധന, പ്രമേഹരോഗ നിർണയം തുടങ്ങിയ സേവനങ്ങളും ലഭ്യമാക്കിയിരുന്നു...",
      thumb: "assets/img/Pastevents/5199.jpg",
    },
    {
      src: "assets/img/Pastevents/5200.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ  കരമന മുസ്‌ലീം ജമാ അത്ത് പരിപാലന സമിതി സംഘടിപ്പിച്ച  സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റി ജനറൽ മെഡിസിൻ കൺസൾട്ടന്റ്  ഡോ. ഷഹബാസ് എം, സൈലു ,ഇ എൻ ടി  കൺസൾട്ടന്റ് ഡോ. സാനി ബിനുക്കുട്ടന്റെ നേതൃത്വത്തിൽ നടന്ന ക്യാമ്പിൽ പെരിഫറൽ ന്യൂറോപ്പതി,ഡയറ്ററി, ദന്തൽ , ഇ സി ജി, ലിപിഡ് പ്രൊഫൈൽ, തൈറോയിഡ്, ആർ. ബി. സി, എച്. ബി. എ വൺ. സി, യൂറിക് ആസിഡ്, രക്തസമ്മർദ്ദ പരിശോധന, പ്രമേഹരോഗ നിർണയം തുടങ്ങിയ സേവനങ്ങളും ലഭ്യമാക്കിയിരുന്നു...",
      thumb: "assets/img/Pastevents/5200.jpg",
    },
    {
      src: "assets/img/Pastevents/5201.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ  കരമന മുസ്‌ലീം ജമാ അത്ത് പരിപാലന സമിതി സംഘടിപ്പിച്ച  സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റി ജനറൽ മെഡിസിൻ കൺസൾട്ടന്റ്  ഡോ. ഷഹബാസ് എം, സൈലു ,ഇ എൻ ടി  കൺസൾട്ടന്റ് ഡോ. സാനി ബിനുക്കുട്ടന്റെ നേതൃത്വത്തിൽ നടന്ന ക്യാമ്പിൽ പെരിഫറൽ ന്യൂറോപ്പതി,ഡയറ്ററി, ദന്തൽ , ഇ സി ജി, ലിപിഡ് പ്രൊഫൈൽ, തൈറോയിഡ്, ആർ. ബി. സി, എച്. ബി. എ വൺ. സി, യൂറിക് ആസിഡ്, രക്തസമ്മർദ്ദ പരിശോധന, പ്രമേഹരോഗ നിർണയം തുടങ്ങിയ സേവനങ്ങളും ലഭ്യമാക്കിയിരുന്നു...",
      thumb: "assets/img/Pastevents/5201.jpg",
    },
    {
      src: "assets/img/Pastevents/5202.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ  കരമന മുസ്‌ലീം ജമാ അത്ത് പരിപാലന സമിതി സംഘടിപ്പിച്ച  സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റി ജനറൽ മെഡിസിൻ കൺസൾട്ടന്റ്  ഡോ. ഷഹബാസ് എം, സൈലു ,ഇ എൻ ടി  കൺസൾട്ടന്റ് ഡോ. സാനി ബിനുക്കുട്ടന്റെ നേതൃത്വത്തിൽ നടന്ന ക്യാമ്പിൽ പെരിഫറൽ ന്യൂറോപ്പതി,ഡയറ്ററി, ദന്തൽ , ഇ സി ജി, ലിപിഡ് പ്രൊഫൈൽ, തൈറോയിഡ്, ആർ. ബി. സി, എച്. ബി. എ വൺ. സി, യൂറിക് ആസിഡ്, രക്തസമ്മർദ്ദ പരിശോധന, പ്രമേഹരോഗ നിർണയം തുടങ്ങിയ സേവനങ്ങളും ലഭ്യമാക്കിയിരുന്നു...",
      thumb: "assets/img/Pastevents/5202.jpg",
    },
    {
      src: "assets/img/Pastevents/5203.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ  കരമന മുസ്‌ലീം ജമാ അത്ത് പരിപാലന സമിതി സംഘടിപ്പിച്ച  സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റി ജനറൽ മെഡിസിൻ കൺസൾട്ടന്റ്  ഡോ. ഷഹബാസ് എം, സൈലു ,ഇ എൻ ടി  കൺസൾട്ടന്റ് ഡോ. സാനി ബിനുക്കുട്ടന്റെ നേതൃത്വത്തിൽ നടന്ന ക്യാമ്പിൽ പെരിഫറൽ ന്യൂറോപ്പതി,ഡയറ്ററി, ദന്തൽ , ഇ സി ജി, ലിപിഡ് പ്രൊഫൈൽ, തൈറോയിഡ്, ആർ. ബി. സി, എച്. ബി. എ വൺ. സി, യൂറിക് ആസിഡ്, രക്തസമ്മർദ്ദ പരിശോധന, പ്രമേഹരോഗ നിർണയം തുടങ്ങിയ സേവനങ്ങളും ലഭ്യമാക്കിയിരുന്നു...",
      thumb: "assets/img/Pastevents/5203.jpg",
    },
    {
      src: "assets/img/Pastevents/5204.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ  കരമന മുസ്‌ലീം ജമാ അത്ത് പരിപാലന സമിതി സംഘടിപ്പിച്ച  സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റി ജനറൽ മെഡിസിൻ കൺസൾട്ടന്റ്  ഡോ. ഷഹബാസ് എം, സൈലു ,ഇ എൻ ടി  കൺസൾട്ടന്റ് ഡോ. സാനി ബിനുക്കുട്ടന്റെ നേതൃത്വത്തിൽ നടന്ന ക്യാമ്പിൽ പെരിഫറൽ ന്യൂറോപ്പതി,ഡയറ്ററി, ദന്തൽ , ഇ സി ജി, ലിപിഡ് പ്രൊഫൈൽ, തൈറോയിഡ്, ആർ. ബി. സി, എച്. ബി. എ വൺ. സി, യൂറിക് ആസിഡ്, രക്തസമ്മർദ്ദ പരിശോധന, പ്രമേഹരോഗ നിർണയം തുടങ്ങിയ സേവനങ്ങളും ലഭ്യമാക്കിയിരുന്നു...",
      thumb: "assets/img/Pastevents/5204.jpg",
    },
    {
      src: "assets/img/Pastevents/5205.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ  കരമന മുസ്‌ലീം ജമാ അത്ത് പരിപാലന സമിതി സംഘടിപ്പിച്ച  സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റി ജനറൽ മെഡിസിൻ കൺസൾട്ടന്റ്  ഡോ. ഷഹബാസ് എം, സൈലു ,ഇ എൻ ടി  കൺസൾട്ടന്റ് ഡോ. സാനി ബിനുക്കുട്ടന്റെ നേതൃത്വത്തിൽ നടന്ന ക്യാമ്പിൽ പെരിഫറൽ ന്യൂറോപ്പതി,ഡയറ്ററി, ദന്തൽ , ഇ സി ജി, ലിപിഡ് പ്രൊഫൈൽ, തൈറോയിഡ്, ആർ. ബി. സി, എച്. ബി. എ വൺ. സി, യൂറിക് ആസിഡ്, രക്തസമ്മർദ്ദ പരിശോധന, പ്രമേഹരോഗ നിർണയം തുടങ്ങിയ സേവനങ്ങളും ലഭ്യമാക്കിയിരുന്നു...",
      thumb: "assets/img/Pastevents/5205.jpg",
    },
    {
      src: "assets/img/Pastevents/5206.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ  കരമന മുസ്‌ലീം ജമാ അത്ത് പരിപാലന സമിതി സംഘടിപ്പിച്ച  സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റി ജനറൽ മെഡിസിൻ കൺസൾട്ടന്റ്  ഡോ. ഷഹബാസ് എം, സൈലു ,ഇ എൻ ടി  കൺസൾട്ടന്റ് ഡോ. സാനി ബിനുക്കുട്ടന്റെ നേതൃത്വത്തിൽ നടന്ന ക്യാമ്പിൽ പെരിഫറൽ ന്യൂറോപ്പതി,ഡയറ്ററി, ദന്തൽ , ഇ സി ജി, ലിപിഡ് പ്രൊഫൈൽ, തൈറോയിഡ്, ആർ. ബി. സി, എച്. ബി. എ വൺ. സി, യൂറിക് ആസിഡ്, രക്തസമ്മർദ്ദ പരിശോധന, പ്രമേഹരോഗ നിർണയം തുടങ്ങിയ സേവനങ്ങളും ലഭ്യമാക്കിയിരുന്നു...",
      thumb: "assets/img/Pastevents/5206.jpg",
    },
    {
      src: "assets/img/Pastevents/5207.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ  കരമന മുസ്‌ലീം ജമാ അത്ത് പരിപാലന സമിതി സംഘടിപ്പിച്ച  സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റി ജനറൽ മെഡിസിൻ കൺസൾട്ടന്റ്  ഡോ. ഷഹബാസ് എം, സൈലു ,ഇ എൻ ടി  കൺസൾട്ടന്റ് ഡോ. സാനി ബിനുക്കുട്ടന്റെ നേതൃത്വത്തിൽ നടന്ന ക്യാമ്പിൽ പെരിഫറൽ ന്യൂറോപ്പതി,ഡയറ്ററി, ദന്തൽ , ഇ സി ജി, ലിപിഡ് പ്രൊഫൈൽ, തൈറോയിഡ്, ആർ. ബി. സി, എച്. ബി. എ വൺ. സി, യൂറിക് ആസിഡ്, രക്തസമ്മർദ്ദ പരിശോധന, പ്രമേഹരോഗ നിർണയം തുടങ്ങിയ സേവനങ്ങളും ലഭ്യമാക്കിയിരുന്നു...",
      thumb: "assets/img/Pastevents/5207.jpg",
    },
    {
      src: "assets/img/Pastevents/5208.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ  കരമന മുസ്‌ലീം ജമാ അത്ത് പരിപാലന സമിതി സംഘടിപ്പിച്ച  സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റി ജനറൽ മെഡിസിൻ കൺസൾട്ടന്റ്  ഡോ. ഷഹബാസ് എം, സൈലു ,ഇ എൻ ടി  കൺസൾട്ടന്റ് ഡോ. സാനി ബിനുക്കുട്ടന്റെ നേതൃത്വത്തിൽ നടന്ന ക്യാമ്പിൽ പെരിഫറൽ ന്യൂറോപ്പതി,ഡയറ്ററി, ദന്തൽ , ഇ സി ജി, ലിപിഡ് പ്രൊഫൈൽ, തൈറോയിഡ്, ആർ. ബി. സി, എച്. ബി. എ വൺ. സി, യൂറിക് ആസിഡ്, രക്തസമ്മർദ്ദ പരിശോധന, പ്രമേഹരോഗ നിർണയം തുടങ്ങിയ സേവനങ്ങളും ലഭ്യമാക്കിയിരുന്നു...",
      thumb: "assets/img/Pastevents/5208.jpg",
    },
    {
      src: "assets/img/Pastevents/5209.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ  കരമന മുസ്‌ലീം ജമാ അത്ത് പരിപാലന സമിതി സംഘടിപ്പിച്ച  സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റി ജനറൽ മെഡിസിൻ കൺസൾട്ടന്റ്  ഡോ. ഷഹബാസ് എം, സൈലു ,ഇ എൻ ടി  കൺസൾട്ടന്റ് ഡോ. സാനി ബിനുക്കുട്ടന്റെ നേതൃത്വത്തിൽ നടന്ന ക്യാമ്പിൽ പെരിഫറൽ ന്യൂറോപ്പതി,ഡയറ്ററി, ദന്തൽ , ഇ സി ജി, ലിപിഡ് പ്രൊഫൈൽ, തൈറോയിഡ്, ആർ. ബി. സി, എച്. ബി. എ വൺ. സി, യൂറിക് ആസിഡ്, രക്തസമ്മർദ്ദ പരിശോധന, പ്രമേഹരോഗ നിർണയം തുടങ്ങിയ സേവനങ്ങളും ലഭ്യമാക്കിയിരുന്നു...",
      thumb: "assets/img/Pastevents/5209.jpg",
    },
    {
      src: "assets/img/Pastevents/5210.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ  കരമന മുസ്‌ലീം ജമാ അത്ത് പരിപാലന സമിതി സംഘടിപ്പിച്ച  സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റി ജനറൽ മെഡിസിൻ കൺസൾട്ടന്റ്  ഡോ. ഷഹബാസ് എം, സൈലു ,ഇ എൻ ടി  കൺസൾട്ടന്റ് ഡോ. സാനി ബിനുക്കുട്ടന്റെ നേതൃത്വത്തിൽ നടന്ന ക്യാമ്പിൽ പെരിഫറൽ ന്യൂറോപ്പതി,ഡയറ്ററി, ദന്തൽ , ഇ സി ജി, ലിപിഡ് പ്രൊഫൈൽ, തൈറോയിഡ്, ആർ. ബി. സി, എച്. ബി. എ വൺ. സി, യൂറിക് ആസിഡ്, രക്തസമ്മർദ്ദ പരിശോധന, പ്രമേഹരോഗ നിർണയം തുടങ്ങിയ സേവനങ്ങളും ലഭ്യമാക്കിയിരുന്നു...",
      thumb: "assets/img/Pastevents/5210.jpg",
    },
    {
      src: "assets/img/Pastevents/5211.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ  കരമന മുസ്‌ലീം ജമാ അത്ത് പരിപാലന സമിതി സംഘടിപ്പിച്ച  സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റി ജനറൽ മെഡിസിൻ കൺസൾട്ടന്റ്  ഡോ. ഷഹബാസ് എം, സൈലു ,ഇ എൻ ടി  കൺസൾട്ടന്റ് ഡോ. സാനി ബിനുക്കുട്ടന്റെ നേതൃത്വത്തിൽ നടന്ന ക്യാമ്പിൽ പെരിഫറൽ ന്യൂറോപ്പതി,ഡയറ്ററി, ദന്തൽ , ഇ സി ജി, ലിപിഡ് പ്രൊഫൈൽ, തൈറോയിഡ്, ആർ. ബി. സി, എച്. ബി. എ വൺ. സി, യൂറിക് ആസിഡ്, രക്തസമ്മർദ്ദ പരിശോധന, പ്രമേഹരോഗ നിർണയം തുടങ്ങിയ സേവനങ്ങളും ലഭ്യമാക്കിയിരുന്നു...",
      thumb: "assets/img/Pastevents/5211.jpg",
    },
    {
      src: "assets/img/Pastevents/5212.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ  കരമന മുസ്‌ലീം ജമാ അത്ത് പരിപാലന സമിതി സംഘടിപ്പിച്ച  സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റി ജനറൽ മെഡിസിൻ കൺസൾട്ടന്റ്  ഡോ. ഷഹബാസ് എം, സൈലു ,ഇ എൻ ടി  കൺസൾട്ടന്റ് ഡോ. സാനി ബിനുക്കുട്ടന്റെ നേതൃത്വത്തിൽ നടന്ന ക്യാമ്പിൽ പെരിഫറൽ ന്യൂറോപ്പതി,ഡയറ്ററി, ദന്തൽ , ഇ സി ജി, ലിപിഡ് പ്രൊഫൈൽ, തൈറോയിഡ്, ആർ. ബി. സി, എച്. ബി. എ വൺ. സി, യൂറിക് ആസിഡ്, രക്തസമ്മർദ്ദ പരിശോധന, പ്രമേഹരോഗ നിർണയം തുടങ്ങിയ സേവനങ്ങളും ലഭ്യമാക്കിയിരുന്നു...",
      thumb: "assets/img/Pastevents/5212.jpg",
    },
    {
      src: "assets/img/Pastevents/5213.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ  കരമന മുസ്‌ലീം ജമാ അത്ത് പരിപാലന സമിതി സംഘടിപ്പിച്ച  സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റി ജനറൽ മെഡിസിൻ കൺസൾട്ടന്റ്  ഡോ. ഷഹബാസ് എം, സൈലു ,ഇ എൻ ടി  കൺസൾട്ടന്റ് ഡോ. സാനി ബിനുക്കുട്ടന്റെ നേതൃത്വത്തിൽ നടന്ന ക്യാമ്പിൽ പെരിഫറൽ ന്യൂറോപ്പതി,ഡയറ്ററി, ദന്തൽ , ഇ സി ജി, ലിപിഡ് പ്രൊഫൈൽ, തൈറോയിഡ്, ആർ. ബി. സി, എച്. ബി. എ വൺ. സി, യൂറിക് ആസിഡ്, രക്തസമ്മർദ്ദ പരിശോധന, പ്രമേഹരോഗ നിർണയം തുടങ്ങിയ സേവനങ്ങളും ലഭ്യമാക്കിയിരുന്നു...",
      thumb: "assets/img/Pastevents/5213.jpg",
    },
    {
      src: "assets/img/Pastevents/5214.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ  കരമന മുസ്‌ലീം ജമാ അത്ത് പരിപാലന സമിതി സംഘടിപ്പിച്ച  സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റി ജനറൽ മെഡിസിൻ കൺസൾട്ടന്റ്  ഡോ. ഷഹബാസ് എം, സൈലു ,ഇ എൻ ടി  കൺസൾട്ടന്റ് ഡോ. സാനി ബിനുക്കുട്ടന്റെ നേതൃത്വത്തിൽ നടന്ന ക്യാമ്പിൽ പെരിഫറൽ ന്യൂറോപ്പതി,ഡയറ്ററി, ദന്തൽ , ഇ സി ജി, ലിപിഡ് പ്രൊഫൈൽ, തൈറോയിഡ്, ആർ. ബി. സി, എച്. ബി. എ വൺ. സി, യൂറിക് ആസിഡ്, രക്തസമ്മർദ്ദ പരിശോധന, പ്രമേഹരോഗ നിർണയം തുടങ്ങിയ സേവനങ്ങളും ലഭ്യമാക്കിയിരുന്നു...",
      thumb: "assets/img/Pastevents/5214.jpg",
    },
    {
      src: "assets/img/Pastevents/5215.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ  കരമന മുസ്‌ലീം ജമാ അത്ത് പരിപാലന സമിതി സംഘടിപ്പിച്ച  സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റി ജനറൽ മെഡിസിൻ കൺസൾട്ടന്റ്  ഡോ. ഷഹബാസ് എം, സൈലു ,ഇ എൻ ടി  കൺസൾട്ടന്റ് ഡോ. സാനി ബിനുക്കുട്ടന്റെ നേതൃത്വത്തിൽ നടന്ന ക്യാമ്പിൽ പെരിഫറൽ ന്യൂറോപ്പതി,ഡയറ്ററി, ദന്തൽ , ഇ സി ജി, ലിപിഡ് പ്രൊഫൈൽ, തൈറോയിഡ്, ആർ. ബി. സി, എച്. ബി. എ വൺ. സി, യൂറിക് ആസിഡ്, രക്തസമ്മർദ്ദ പരിശോധന, പ്രമേഹരോഗ നിർണയം തുടങ്ങിയ സേവനങ്ങളും ലഭ്യമാക്കിയിരുന്നു...",
      thumb: "assets/img/Pastevents/5215.jpg",
    },
    {
      src: "assets/img/Pastevents/5216.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ  കരമന മുസ്‌ലീം ജമാ അത്ത് പരിപാലന സമിതി സംഘടിപ്പിച്ച  സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റി ജനറൽ മെഡിസിൻ കൺസൾട്ടന്റ്  ഡോ. ഷഹബാസ് എം, സൈലു ,ഇ എൻ ടി  കൺസൾട്ടന്റ് ഡോ. സാനി ബിനുക്കുട്ടന്റെ നേതൃത്വത്തിൽ നടന്ന ക്യാമ്പിൽ പെരിഫറൽ ന്യൂറോപ്പതി,ഡയറ്ററി, ദന്തൽ , ഇ സി ജി, ലിപിഡ് പ്രൊഫൈൽ, തൈറോയിഡ്, ആർ. ബി. സി, എച്. ബി. എ വൺ. സി, യൂറിക് ആസിഡ്, രക്തസമ്മർദ്ദ പരിശോധന, പ്രമേഹരോഗ നിർണയം തുടങ്ങിയ സേവനങ്ങളും ലഭ്യമാക്കിയിരുന്നു...",
      thumb: "assets/img/Pastevents/5216.jpg",
    },
    {
      src: "assets/img/Pastevents/5217.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ  കരമന മുസ്‌ലീം ജമാ അത്ത് പരിപാലന സമിതി സംഘടിപ്പിച്ച  സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റി ജനറൽ മെഡിസിൻ കൺസൾട്ടന്റ്  ഡോ. ഷഹബാസ് എം, സൈലു ,ഇ എൻ ടി  കൺസൾട്ടന്റ് ഡോ. സാനി ബിനുക്കുട്ടന്റെ നേതൃത്വത്തിൽ നടന്ന ക്യാമ്പിൽ പെരിഫറൽ ന്യൂറോപ്പതി,ഡയറ്ററി, ദന്തൽ , ഇ സി ജി, ലിപിഡ് പ്രൊഫൈൽ, തൈറോയിഡ്, ആർ. ബി. സി, എച്. ബി. എ വൺ. സി, യൂറിക് ആസിഡ്, രക്തസമ്മർദ്ദ പരിശോധന, പ്രമേഹരോഗ നിർണയം തുടങ്ങിയ സേവനങ്ങളും ലഭ്യമാക്കിയിരുന്നു...",
      thumb: "assets/img/Pastevents/5217.jpg",
    },
    {
      src: "assets/img/Pastevents/5218.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ  കരമന മുസ്‌ലീം ജമാ അത്ത് പരിപാലന സമിതി സംഘടിപ്പിച്ച  സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റി ജനറൽ മെഡിസിൻ കൺസൾട്ടന്റ്  ഡോ. ഷഹബാസ് എം, സൈലു ,ഇ എൻ ടി  കൺസൾട്ടന്റ് ഡോ. സാനി ബിനുക്കുട്ടന്റെ നേതൃത്വത്തിൽ നടന്ന ക്യാമ്പിൽ പെരിഫറൽ ന്യൂറോപ്പതി,ഡയറ്ററി, ദന്തൽ , ഇ സി ജി, ലിപിഡ് പ്രൊഫൈൽ, തൈറോയിഡ്, ആർ. ബി. സി, എച്. ബി. എ വൺ. സി, യൂറിക് ആസിഡ്, രക്തസമ്മർദ്ദ പരിശോധന, പ്രമേഹരോഗ നിർണയം തുടങ്ങിയ സേവനങ്ങളും ലഭ്യമാക്കിയിരുന്നു...",
      thumb: "assets/img/Pastevents/5218.jpg",
    },
    {
      src: "assets/img/Pastevents/5219.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ  കരമന മുസ്‌ലീം ജമാ അത്ത് പരിപാലന സമിതി സംഘടിപ്പിച്ച  സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റി ജനറൽ മെഡിസിൻ കൺസൾട്ടന്റ്  ഡോ. ഷഹബാസ് എം, സൈലു ,ഇ എൻ ടി  കൺസൾട്ടന്റ് ഡോ. സാനി ബിനുക്കുട്ടന്റെ നേതൃത്വത്തിൽ നടന്ന ക്യാമ്പിൽ പെരിഫറൽ ന്യൂറോപ്പതി,ഡയറ്ററി, ദന്തൽ , ഇ സി ജി, ലിപിഡ് പ്രൊഫൈൽ, തൈറോയിഡ്, ആർ. ബി. സി, എച്. ബി. എ വൺ. സി, യൂറിക് ആസിഡ്, രക്തസമ്മർദ്ദ പരിശോധന, പ്രമേഹരോഗ നിർണയം തുടങ്ങിയ സേവനങ്ങളും ലഭ്യമാക്കിയിരുന്നു...",
      thumb: "assets/img/Pastevents/5219.jpg",
    },
    {
      src: "assets/img/Pastevents/5220.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ  കരമന മുസ്‌ലീം ജമാ അത്ത് പരിപാലന സമിതി സംഘടിപ്പിച്ച  സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റി ജനറൽ മെഡിസിൻ കൺസൾട്ടന്റ്  ഡോ. ഷഹബാസ് എം, സൈലു ,ഇ എൻ ടി  കൺസൾട്ടന്റ് ഡോ. സാനി ബിനുക്കുട്ടന്റെ നേതൃത്വത്തിൽ നടന്ന ക്യാമ്പിൽ പെരിഫറൽ ന്യൂറോപ്പതി,ഡയറ്ററി, ദന്തൽ , ഇ സി ജി, ലിപിഡ് പ്രൊഫൈൽ, തൈറോയിഡ്, ആർ. ബി. സി, എച്. ബി. എ വൺ. സി, യൂറിക് ആസിഡ്, രക്തസമ്മർദ്ദ പരിശോധന, പ്രമേഹരോഗ നിർണയം തുടങ്ങിയ സേവനങ്ങളും ലഭ്യമാക്കിയിരുന്നു...",
      thumb: "assets/img/Pastevents/5220.jpg",
    },
    {
      src: "assets/img/Pastevents/5221.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ  കരമന മുസ്‌ലീം ജമാ അത്ത് പരിപാലന സമിതി സംഘടിപ്പിച്ച  സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റി ജനറൽ മെഡിസിൻ കൺസൾട്ടന്റ്  ഡോ. ഷഹബാസ് എം, സൈലു ,ഇ എൻ ടി  കൺസൾട്ടന്റ് ഡോ. സാനി ബിനുക്കുട്ടന്റെ നേതൃത്വത്തിൽ നടന്ന ക്യാമ്പിൽ പെരിഫറൽ ന്യൂറോപ്പതി,ഡയറ്ററി, ദന്തൽ , ഇ സി ജി, ലിപിഡ് പ്രൊഫൈൽ, തൈറോയിഡ്, ആർ. ബി. സി, എച്. ബി. എ വൺ. സി, യൂറിക് ആസിഡ്, രക്തസമ്മർദ്ദ പരിശോധന, പ്രമേഹരോഗ നിർണയം തുടങ്ങിയ സേവനങ്ങളും ലഭ്യമാക്കിയിരുന്നു...",
      thumb: "assets/img/Pastevents/5221.jpg",
    },
    {
      src: "assets/img/Pastevents/5222.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ  കരമന മുസ്‌ലീം ജമാ അത്ത് പരിപാലന സമിതി സംഘടിപ്പിച്ച  സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റി ജനറൽ മെഡിസിൻ കൺസൾട്ടന്റ്  ഡോ. ഷഹബാസ് എം, സൈലു ,ഇ എൻ ടി  കൺസൾട്ടന്റ് ഡോ. സാനി ബിനുക്കുട്ടന്റെ നേതൃത്വത്തിൽ നടന്ന ക്യാമ്പിൽ പെരിഫറൽ ന്യൂറോപ്പതി,ഡയറ്ററി, ദന്തൽ , ഇ സി ജി, ലിപിഡ് പ്രൊഫൈൽ, തൈറോയിഡ്, ആർ. ബി. സി, എച്. ബി. എ വൺ. സി, യൂറിക് ആസിഡ്, രക്തസമ്മർദ്ദ പരിശോധന, പ്രമേഹരോഗ നിർണയം തുടങ്ങിയ സേവനങ്ങളും ലഭ്യമാക്കിയിരുന്നു...",
      thumb: "assets/img/Pastevents/5222.jpg",
    },
    {
      src: "assets/img/Pastevents/5223.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ  കരമന മുസ്‌ലീം ജമാ അത്ത് പരിപാലന സമിതി സംഘടിപ്പിച്ച  സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റി ജനറൽ മെഡിസിൻ കൺസൾട്ടന്റ്  ഡോ. ഷഹബാസ് എം, സൈലു ,ഇ എൻ ടി  കൺസൾട്ടന്റ് ഡോ. സാനി ബിനുക്കുട്ടന്റെ നേതൃത്വത്തിൽ നടന്ന ക്യാമ്പിൽ പെരിഫറൽ ന്യൂറോപ്പതി,ഡയറ്ററി, ദന്തൽ , ഇ സി ജി, ലിപിഡ് പ്രൊഫൈൽ, തൈറോയിഡ്, ആർ. ബി. സി, എച്. ബി. എ വൺ. സി, യൂറിക് ആസിഡ്, രക്തസമ്മർദ്ദ പരിശോധന, പ്രമേഹരോഗ നിർണയം തുടങ്ങിയ സേവനങ്ങളും ലഭ്യമാക്കിയിരുന്നു...",
      thumb: "assets/img/Pastevents/5223.jpg",
    },
    {
      src: "assets/img/Pastevents/5224.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ  കരമന മുസ്‌ലീം ജമാ അത്ത് പരിപാലന സമിതി സംഘടിപ്പിച്ച  സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റി ജനറൽ മെഡിസിൻ കൺസൾട്ടന്റ്  ഡോ. ഷഹബാസ് എം, സൈലു ,ഇ എൻ ടി  കൺസൾട്ടന്റ് ഡോ. സാനി ബിനുക്കുട്ടന്റെ നേതൃത്വത്തിൽ നടന്ന ക്യാമ്പിൽ പെരിഫറൽ ന്യൂറോപ്പതി,ഡയറ്ററി, ദന്തൽ , ഇ സി ജി, ലിപിഡ് പ്രൊഫൈൽ, തൈറോയിഡ്, ആർ. ബി. സി, എച്. ബി. എ വൺ. സി, യൂറിക് ആസിഡ്, രക്തസമ്മർദ്ദ പരിശോധന, പ്രമേഹരോഗ നിർണയം തുടങ്ങിയ സേവനങ്ങളും ലഭ്യമാക്കിയിരുന്നു...",
      thumb: "assets/img/Pastevents/5224.jpg",
    },
    {
      src: "assets/img/Pastevents/5166.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ അടിയന്തിര വൈദ്യ സഹായ  ക്യാമ്പ് സംഘടിപ്പിച്ചു ട്രിവാൻഡ്രം ടെന്നിസ് ക്ലബ് (TTC) ലെ ഇന്റർനാഷണൽ മാസ്റ്റേഴ്‌സ് ടെന്നിസ് ടൂർണമെന്റിലാണ് വൈദ്യ സഹായം ഒരുക്കിയിട്ടുള്ളത്. ആറുദിവസം നീണ്ടുനിൽക്കുന്ന മത്സരങ്ങളിൽ വിവിധ രാജ്യങ്ങളെയും ഇന്ത്യയുടെയും വിവിധ സംസ്ഥാനങ്ങളിലെയും  ഏകദേശം 150 കളിക്കാർ പുരുഷന്മാരുടെയും സ്ത്രീകളുടെയും വിവിധ വിഭാഗങ്ങളിൽ മത്സരിക്കുന്നു.",
      thumb: "assets/img/Pastevents/5166.jpg",
    },
    {
      src: "assets/img/Pastevents/5167.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ അടിയന്തിര വൈദ്യ സഹായ  ക്യാമ്പ് സംഘടിപ്പിച്ചു ട്രിവാൻഡ്രം ടെന്നിസ് ക്ലബ് (TTC) ലെ ഇന്റർനാഷണൽ മാസ്റ്റേഴ്‌സ് ടെന്നിസ് ടൂർണമെന്റിലാണ് വൈദ്യ സഹായം ഒരുക്കിയിട്ടുള്ളത്. ആറുദിവസം നീണ്ടുനിൽക്കുന്ന മത്സരങ്ങളിൽ വിവിധ രാജ്യങ്ങളെയും ഇന്ത്യയുടെയും വിവിധ സംസ്ഥാനങ്ങളിലെയും  ഏകദേശം 150 കളിക്കാർ പുരുഷന്മാരുടെയും സ്ത്രീകളുടെയും വിവിധ വിഭാഗങ്ങളിൽ മത്സരിക്കുന്നു.",
      thumb: "assets/img/Pastevents/5167.jpg",
    },
    {
      src: "assets/img/Pastevents/5168.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ അടിയന്തിര വൈദ്യ സഹായ  ക്യാമ്പ് സംഘടിപ്പിച്ചു ട്രിവാൻഡ്രം ടെന്നിസ് ക്ലബ് (TTC) ലെ ഇന്റർനാഷണൽ മാസ്റ്റേഴ്‌സ് ടെന്നിസ് ടൂർണമെന്റിലാണ് വൈദ്യ സഹായം ഒരുക്കിയിട്ടുള്ളത്. ആറുദിവസം നീണ്ടുനിൽക്കുന്ന മത്സരങ്ങളിൽ വിവിധ രാജ്യങ്ങളെയും ഇന്ത്യയുടെയും വിവിധ സംസ്ഥാനങ്ങളിലെയും  ഏകദേശം 150 കളിക്കാർ പുരുഷന്മാരുടെയും സ്ത്രീകളുടെയും വിവിധ വിഭാഗങ്ങളിൽ മത്സരിക്കുന്നു.",
      thumb: "assets/img/Pastevents/5168.jpg",
    },
    {
      src: "assets/img/Pastevents/5169.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ അടിയന്തിര വൈദ്യ സഹായ  ക്യാമ്പ് സംഘടിപ്പിച്ചു ട്രിവാൻഡ്രം ടെന്നിസ് ക്ലബ് (TTC) ലെ ഇന്റർനാഷണൽ മാസ്റ്റേഴ്‌സ് ടെന്നിസ് ടൂർണമെന്റിലാണ് വൈദ്യ സഹായം ഒരുക്കിയിട്ടുള്ളത്. ആറുദിവസം നീണ്ടുനിൽക്കുന്ന മത്സരങ്ങളിൽ വിവിധ രാജ്യങ്ങളെയും ഇന്ത്യയുടെയും വിവിധ സംസ്ഥാനങ്ങളിലെയും  ഏകദേശം 150 കളിക്കാർ പുരുഷന്മാരുടെയും സ്ത്രീകളുടെയും വിവിധ വിഭാഗങ്ങളിൽ മത്സരിക്കുന്നു.",
      thumb: "assets/img/Pastevents/5169.jpg",
    },
    {
      src: "assets/img/Pastevents/5170.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ അടിയന്തിര വൈദ്യ സഹായ  ക്യാമ്പ് സംഘടിപ്പിച്ചു ട്രിവാൻഡ്രം ടെന്നിസ് ക്ലബ് (TTC) ലെ ഇന്റർനാഷണൽ മാസ്റ്റേഴ്‌സ് ടെന്നിസ് ടൂർണമെന്റിലാണ് വൈദ്യ സഹായം ഒരുക്കിയിട്ടുള്ളത്. ആറുദിവസം നീണ്ടുനിൽക്കുന്ന മത്സരങ്ങളിൽ വിവിധ രാജ്യങ്ങളെയും ഇന്ത്യയുടെയും വിവിധ സംസ്ഥാനങ്ങളിലെയും  ഏകദേശം 150 കളിക്കാർ പുരുഷന്മാരുടെയും സ്ത്രീകളുടെയും വിവിധ വിഭാഗങ്ങളിൽ മത്സരിക്കുന്നു.",
      thumb: "assets/img/Pastevents/5170.jpg",
    },
    {
      src: "assets/img/Pastevents/5171.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ അടിയന്തിര വൈദ്യ സഹായ  ക്യാമ്പ് സംഘടിപ്പിച്ചു ട്രിവാൻഡ്രം ടെന്നിസ് ക്ലബ് (TTC) ലെ ഇന്റർനാഷണൽ മാസ്റ്റേഴ്‌സ് ടെന്നിസ് ടൂർണമെന്റിലാണ് വൈദ്യ സഹായം ഒരുക്കിയിട്ടുള്ളത്. ആറുദിവസം നീണ്ടുനിൽക്കുന്ന മത്സരങ്ങളിൽ വിവിധ രാജ്യങ്ങളെയും ഇന്ത്യയുടെയും വിവിധ സംസ്ഥാനങ്ങളിലെയും  ഏകദേശം 150 കളിക്കാർ പുരുഷന്മാരുടെയും സ്ത്രീകളുടെയും വിവിധ വിഭാഗങ്ങളിൽ മത്സരിക്കുന്നു.",
      thumb: "assets/img/Pastevents/5171.jpg",
    },
    {
      src: "assets/img/Pastevents/5172.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ അടിയന്തിര വൈദ്യ സഹായ  ക്യാമ്പ് സംഘടിപ്പിച്ചു ട്രിവാൻഡ്രം ടെന്നിസ് ക്ലബ് (TTC) ലെ ഇന്റർനാഷണൽ മാസ്റ്റേഴ്‌സ് ടെന്നിസ് ടൂർണമെന്റിലാണ് വൈദ്യ സഹായം ഒരുക്കിയിട്ടുള്ളത്. ആറുദിവസം നീണ്ടുനിൽക്കുന്ന മത്സരങ്ങളിൽ വിവിധ രാജ്യങ്ങളെയും ഇന്ത്യയുടെയും വിവിധ സംസ്ഥാനങ്ങളിലെയും  ഏകദേശം 150 കളിക്കാർ പുരുഷന്മാരുടെയും സ്ത്രീകളുടെയും വിവിധ വിഭാഗങ്ങളിൽ മത്സരിക്കുന്നു.",
      thumb: "assets/img/Pastevents/5172.jpg",
    },
    {
      src: "assets/img/Pastevents/5173.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ അടിയന്തിര വൈദ്യ സഹായ  ക്യാമ്പ് സംഘടിപ്പിച്ചു ട്രിവാൻഡ്രം ടെന്നിസ് ക്ലബ് (TTC) ലെ ഇന്റർനാഷണൽ മാസ്റ്റേഴ്‌സ് ടെന്നിസ് ടൂർണമെന്റിലാണ് വൈദ്യ സഹായം ഒരുക്കിയിട്ടുള്ളത്. ആറുദിവസം നീണ്ടുനിൽക്കുന്ന മത്സരങ്ങളിൽ വിവിധ രാജ്യങ്ങളെയും ഇന്ത്യയുടെയും വിവിധ സംസ്ഥാനങ്ങളിലെയും  ഏകദേശം 150 കളിക്കാർ പുരുഷന്മാരുടെയും സ്ത്രീകളുടെയും വിവിധ വിഭാഗങ്ങളിൽ മത്സരിക്കുന്നു.",
      thumb: "assets/img/Pastevents/5173.jpg",
    },
    {
      src: "assets/img/Pastevents/5174.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ അടിയന്തിര വൈദ്യ സഹായ  ക്യാമ്പ് സംഘടിപ്പിച്ചു ട്രിവാൻഡ്രം ടെന്നിസ് ക്ലബ് (TTC) ലെ ഇന്റർനാഷണൽ മാസ്റ്റേഴ്‌സ് ടെന്നിസ് ടൂർണമെന്റിലാണ് വൈദ്യ സഹായം ഒരുക്കിയിട്ടുള്ളത്. ആറുദിവസം നീണ്ടുനിൽക്കുന്ന മത്സരങ്ങളിൽ വിവിധ രാജ്യങ്ങളെയും ഇന്ത്യയുടെയും വിവിധ സംസ്ഥാനങ്ങളിലെയും  ഏകദേശം 150 കളിക്കാർ പുരുഷന്മാരുടെയും സ്ത്രീകളുടെയും വിവിധ വിഭാഗങ്ങളിൽ മത്സരിക്കുന്നു.",
      thumb: "assets/img/Pastevents/5174.jpg",
    },
    {
      src: "assets/img/Pastevents/5175.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ അടിയന്തിര വൈദ്യ സഹായ  ക്യാമ്പ് സംഘടിപ്പിച്ചു ട്രിവാൻഡ്രം ടെന്നിസ് ക്ലബ് (TTC) ലെ ഇന്റർനാഷണൽ മാസ്റ്റേഴ്‌സ് ടെന്നിസ് ടൂർണമെന്റിലാണ് വൈദ്യ സഹായം ഒരുക്കിയിട്ടുള്ളത്. ആറുദിവസം നീണ്ടുനിൽക്കുന്ന മത്സരങ്ങളിൽ വിവിധ രാജ്യങ്ങളെയും ഇന്ത്യയുടെയും വിവിധ സംസ്ഥാനങ്ങളിലെയും  ഏകദേശം 150 കളിക്കാർ പുരുഷന്മാരുടെയും സ്ത്രീകളുടെയും വിവിധ വിഭാഗങ്ങളിൽ മത്സരിക്കുന്നു.",
      thumb: "assets/img/Pastevents/5175.jpg",
    },
    {
      src: "assets/img/Pastevents/5176.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ അടിയന്തിര വൈദ്യ സഹായ  ക്യാമ്പ് സംഘടിപ്പിച്ചു ട്രിവാൻഡ്രം ടെന്നിസ് ക്ലബ് (TTC) ലെ ഇന്റർനാഷണൽ മാസ്റ്റേഴ്‌സ് ടെന്നിസ് ടൂർണമെന്റിലാണ് വൈദ്യ സഹായം ഒരുക്കിയിട്ടുള്ളത്. ആറുദിവസം നീണ്ടുനിൽക്കുന്ന മത്സരങ്ങളിൽ വിവിധ രാജ്യങ്ങളെയും ഇന്ത്യയുടെയും വിവിധ സംസ്ഥാനങ്ങളിലെയും  ഏകദേശം 150 കളിക്കാർ പുരുഷന്മാരുടെയും സ്ത്രീകളുടെയും വിവിധ വിഭാഗങ്ങളിൽ മത്സരിക്കുന്നു.",
      thumb: "assets/img/Pastevents/5176.jpg",
    },
    {
      src: "assets/img/Pastevents/5177.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ അടിയന്തിര വൈദ്യ സഹായ  ക്യാമ്പ് സംഘടിപ്പിച്ചു ട്രിവാൻഡ്രം ടെന്നിസ് ക്ലബ് (TTC) ലെ ഇന്റർനാഷണൽ മാസ്റ്റേഴ്‌സ് ടെന്നിസ് ടൂർണമെന്റിലാണ് വൈദ്യ സഹായം ഒരുക്കിയിട്ടുള്ളത്. ആറുദിവസം നീണ്ടുനിൽക്കുന്ന മത്സരങ്ങളിൽ വിവിധ രാജ്യങ്ങളെയും ഇന്ത്യയുടെയും വിവിധ സംസ്ഥാനങ്ങളിലെയും  ഏകദേശം 150 കളിക്കാർ പുരുഷന്മാരുടെയും സ്ത്രീകളുടെയും വിവിധ വിഭാഗങ്ങളിൽ മത്സരിക്കുന്നു.",
      thumb: "assets/img/Pastevents/5177.jpg",
    },
    {
      src: "assets/img/Pastevents/5178.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ അടിയന്തിര വൈദ്യ സഹായ  ക്യാമ്പ് സംഘടിപ്പിച്ചു ട്രിവാൻഡ്രം ടെന്നിസ് ക്ലബ് (TTC) ലെ ഇന്റർനാഷണൽ മാസ്റ്റേഴ്‌സ് ടെന്നിസ് ടൂർണമെന്റിലാണ് വൈദ്യ സഹായം ഒരുക്കിയിട്ടുള്ളത്. ആറുദിവസം നീണ്ടുനിൽക്കുന്ന മത്സരങ്ങളിൽ വിവിധ രാജ്യങ്ങളെയും ഇന്ത്യയുടെയും വിവിധ സംസ്ഥാനങ്ങളിലെയും  ഏകദേശം 150 കളിക്കാർ പുരുഷന്മാരുടെയും സ്ത്രീകളുടെയും വിവിധ വിഭാഗങ്ങളിൽ മത്സരിക്കുന്നു.",
      thumb: "assets/img/Pastevents/5178.jpg",
    },
    {
      src: "assets/img/Pastevents/5179.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ അടിയന്തിര വൈദ്യ സഹായ  ക്യാമ്പ് സംഘടിപ്പിച്ചു ട്രിവാൻഡ്രം ടെന്നിസ് ക്ലബ് (TTC) ലെ ഇന്റർനാഷണൽ മാസ്റ്റേഴ്‌സ് ടെന്നിസ് ടൂർണമെന്റിലാണ് വൈദ്യ സഹായം ഒരുക്കിയിട്ടുള്ളത്. ആറുദിവസം നീണ്ടുനിൽക്കുന്ന മത്സരങ്ങളിൽ വിവിധ രാജ്യങ്ങളെയും ഇന്ത്യയുടെയും വിവിധ സംസ്ഥാനങ്ങളിലെയും  ഏകദേശം 150 കളിക്കാർ പുരുഷന്മാരുടെയും സ്ത്രീകളുടെയും വിവിധ വിഭാഗങ്ങളിൽ മത്സരിക്കുന്നു.",
      thumb: "assets/img/Pastevents/5179.jpg",
    },
    {
      src: "assets/img/Pastevents/5180.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ അടിയന്തിര വൈദ്യ സഹായ  ക്യാമ്പ് സംഘടിപ്പിച്ചു ട്രിവാൻഡ്രം ടെന്നിസ് ക്ലബ് (TTC) ലെ ഇന്റർനാഷണൽ മാസ്റ്റേഴ്‌സ് ടെന്നിസ് ടൂർണമെന്റിലാണ് വൈദ്യ സഹായം ഒരുക്കിയിട്ടുള്ളത്. ആറുദിവസം നീണ്ടുനിൽക്കുന്ന മത്സരങ്ങളിൽ വിവിധ രാജ്യങ്ങളെയും ഇന്ത്യയുടെയും വിവിധ സംസ്ഥാനങ്ങളിലെയും  ഏകദേശം 150 കളിക്കാർ പുരുഷന്മാരുടെയും സ്ത്രീകളുടെയും വിവിധ വിഭാഗങ്ങളിൽ മത്സരിക്കുന്നു.",
      thumb: "assets/img/Pastevents/5180.jpg",
    },
    {
      src: "assets/img/Pastevents/5181.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ അടിയന്തിര വൈദ്യ സഹായ  ക്യാമ്പ് സംഘടിപ്പിച്ചു ട്രിവാൻഡ്രം ടെന്നിസ് ക്ലബ് (TTC) ലെ ഇന്റർനാഷണൽ മാസ്റ്റേഴ്‌സ് ടെന്നിസ് ടൂർണമെന്റിലാണ് വൈദ്യ സഹായം ഒരുക്കിയിട്ടുള്ളത്. ആറുദിവസം നീണ്ടുനിൽക്കുന്ന മത്സരങ്ങളിൽ വിവിധ രാജ്യങ്ങളെയും ഇന്ത്യയുടെയും വിവിധ സംസ്ഥാനങ്ങളിലെയും  ഏകദേശം 150 കളിക്കാർ പുരുഷന്മാരുടെയും സ്ത്രീകളുടെയും വിവിധ വിഭാഗങ്ങളിൽ മത്സരിക്കുന്നു.",
      thumb: "assets/img/Pastevents/5181.jpg",
    },
    {
      src: "assets/img/Pastevents/5182.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ അടിയന്തിര വൈദ്യ സഹായ  ക്യാമ്പ് സംഘടിപ്പിച്ചു ട്രിവാൻഡ്രം ടെന്നിസ് ക്ലബ് (TTC) ലെ ഇന്റർനാഷണൽ മാസ്റ്റേഴ്‌സ് ടെന്നിസ് ടൂർണമെന്റിലാണ് വൈദ്യ സഹായം ഒരുക്കിയിട്ടുള്ളത്. ആറുദിവസം നീണ്ടുനിൽക്കുന്ന മത്സരങ്ങളിൽ വിവിധ രാജ്യങ്ങളെയും ഇന്ത്യയുടെയും വിവിധ സംസ്ഥാനങ്ങളിലെയും  ഏകദേശം 150 കളിക്കാർ പുരുഷന്മാരുടെയും സ്ത്രീകളുടെയും വിവിധ വിഭാഗങ്ങളിൽ മത്സരിക്കുന്നു.",
      thumb: "assets/img/Pastevents/5182.jpg",
    },
    {
      src: "assets/img/Pastevents/5183.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ അടിയന്തിര വൈദ്യ സഹായ  ക്യാമ്പ് സംഘടിപ്പിച്ചു ട്രിവാൻഡ്രം ടെന്നിസ് ക്ലബ് (TTC) ലെ ഇന്റർനാഷണൽ മാസ്റ്റേഴ്‌സ് ടെന്നിസ് ടൂർണമെന്റിലാണ് വൈദ്യ സഹായം ഒരുക്കിയിട്ടുള്ളത്. ആറുദിവസം നീണ്ടുനിൽക്കുന്ന മത്സരങ്ങളിൽ വിവിധ രാജ്യങ്ങളെയും ഇന്ത്യയുടെയും വിവിധ സംസ്ഥാനങ്ങളിലെയും  ഏകദേശം 150 കളിക്കാർ പുരുഷന്മാരുടെയും സ്ത്രീകളുടെയും വിവിധ വിഭാഗങ്ങളിൽ മത്സരിക്കുന്നു.",
      thumb: "assets/img/Pastevents/5183.jpg",
    },
    {
      src: "assets/img/Pastevents/5184.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ അടിയന്തിര വൈദ്യ സഹായ  ക്യാമ്പ് സംഘടിപ്പിച്ചു ട്രിവാൻഡ്രം ടെന്നിസ് ക്ലബ് (TTC) ലെ ഇന്റർനാഷണൽ മാസ്റ്റേഴ്‌സ് ടെന്നിസ് ടൂർണമെന്റിലാണ് വൈദ്യ സഹായം ഒരുക്കിയിട്ടുള്ളത്. ആറുദിവസം നീണ്ടുനിൽക്കുന്ന മത്സരങ്ങളിൽ വിവിധ രാജ്യങ്ങളെയും ഇന്ത്യയുടെയും വിവിധ സംസ്ഥാനങ്ങളിലെയും  ഏകദേശം 150 കളിക്കാർ പുരുഷന്മാരുടെയും സ്ത്രീകളുടെയും വിവിധ വിഭാഗങ്ങളിൽ മത്സരിക്കുന്നു.",
      thumb: "assets/img/Pastevents/5184.jpg",
    },
    {
      src: "assets/img/Pastevents/5185.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ അടിയന്തിര വൈദ്യ സഹായ  ക്യാമ്പ് സംഘടിപ്പിച്ചു ട്രിവാൻഡ്രം ടെന്നിസ് ക്ലബ് (TTC) ലെ ഇന്റർനാഷണൽ മാസ്റ്റേഴ്‌സ് ടെന്നിസ് ടൂർണമെന്റിലാണ് വൈദ്യ സഹായം ഒരുക്കിയിട്ടുള്ളത്. ആറുദിവസം നീണ്ടുനിൽക്കുന്ന മത്സരങ്ങളിൽ വിവിധ രാജ്യങ്ങളെയും ഇന്ത്യയുടെയും വിവിധ സംസ്ഥാനങ്ങളിലെയും  ഏകദേശം 150 കളിക്കാർ പുരുഷന്മാരുടെയും സ്ത്രീകളുടെയും വിവിധ വിഭാഗങ്ങളിൽ മത്സരിക്കുന്നു.",
      thumb: "assets/img/Pastevents/5185.jpg",
    },
    {
      src: "assets/img/Pastevents/5186.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ അടിയന്തിര വൈദ്യ സഹായ  ക്യാമ്പ് സംഘടിപ്പിച്ചു ട്രിവാൻഡ്രം ടെന്നിസ് ക്ലബ് (TTC) ലെ ഇന്റർനാഷണൽ മാസ്റ്റേഴ്‌സ് ടെന്നിസ് ടൂർണമെന്റിലാണ് വൈദ്യ സഹായം ഒരുക്കിയിട്ടുള്ളത്. ആറുദിവസം നീണ്ടുനിൽക്കുന്ന മത്സരങ്ങളിൽ വിവിധ രാജ്യങ്ങളെയും ഇന്ത്യയുടെയും വിവിധ സംസ്ഥാനങ്ങളിലെയും  ഏകദേശം 150 കളിക്കാർ പുരുഷന്മാരുടെയും സ്ത്രീകളുടെയും വിവിധ വിഭാഗങ്ങളിൽ മത്സരിക്കുന്നു.",
      thumb: "assets/img/Pastevents/5186.jpg",
    },
    {
      src: "assets/img/Pastevents/5187.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ അടിയന്തിര വൈദ്യ സഹായ  ക്യാമ്പ് സംഘടിപ്പിച്ചു ട്രിവാൻഡ്രം ടെന്നിസ് ക്ലബ് (TTC) ലെ ഇന്റർനാഷണൽ മാസ്റ്റേഴ്‌സ് ടെന്നിസ് ടൂർണമെന്റിലാണ് വൈദ്യ സഹായം ഒരുക്കിയിട്ടുള്ളത്. ആറുദിവസം നീണ്ടുനിൽക്കുന്ന മത്സരങ്ങളിൽ വിവിധ രാജ്യങ്ങളെയും ഇന്ത്യയുടെയും വിവിധ സംസ്ഥാനങ്ങളിലെയും  ഏകദേശം 150 കളിക്കാർ പുരുഷന്മാരുടെയും സ്ത്രീകളുടെയും വിവിധ വിഭാഗങ്ങളിൽ മത്സരിക്കുന്നു.",
      thumb: "assets/img/Pastevents/5187.jpg",
    },
    {
      src: "assets/img/Pastevents/5188.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ അടിയന്തിര വൈദ്യ സഹായ  ക്യാമ്പ് സംഘടിപ്പിച്ചു ട്രിവാൻഡ്രം ടെന്നിസ് ക്ലബ് (TTC) ലെ ഇന്റർനാഷണൽ മാസ്റ്റേഴ്‌സ് ടെന്നിസ് ടൂർണമെന്റിലാണ് വൈദ്യ സഹായം ഒരുക്കിയിട്ടുള്ളത്. ആറുദിവസം നീണ്ടുനിൽക്കുന്ന മത്സരങ്ങളിൽ വിവിധ രാജ്യങ്ങളെയും ഇന്ത്യയുടെയും വിവിധ സംസ്ഥാനങ്ങളിലെയും  ഏകദേശം 150 കളിക്കാർ പുരുഷന്മാരുടെയും സ്ത്രീകളുടെയും വിവിധ വിഭാഗങ്ങളിൽ മത്സരിക്കുന്നു.",
      thumb: "assets/img/Pastevents/5188.jpg",
    },
    {
      src: "assets/img/Pastevents/5189.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ അടിയന്തിര വൈദ്യ സഹായ  ക്യാമ്പ് സംഘടിപ്പിച്ചു ട്രിവാൻഡ്രം ടെന്നിസ് ക്ലബ് (TTC) ലെ ഇന്റർനാഷണൽ മാസ്റ്റേഴ്‌സ് ടെന്നിസ് ടൂർണമെന്റിലാണ് വൈദ്യ സഹായം ഒരുക്കിയിട്ടുള്ളത്. ആറുദിവസം നീണ്ടുനിൽക്കുന്ന മത്സരങ്ങളിൽ വിവിധ രാജ്യങ്ങളെയും ഇന്ത്യയുടെയും വിവിധ സംസ്ഥാനങ്ങളിലെയും  ഏകദേശം 150 കളിക്കാർ പുരുഷന്മാരുടെയും സ്ത്രീകളുടെയും വിവിധ വിഭാഗങ്ങളിൽ മത്സരിക്കുന്നു.",
      thumb: "assets/img/Pastevents/5189.jpg",
    },
    {
      src: "assets/img/Pastevents/5190.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ അടിയന്തിര വൈദ്യ സഹായ  ക്യാമ്പ് സംഘടിപ്പിച്ചു ട്രിവാൻഡ്രം ടെന്നിസ് ക്ലബ് (TTC) ലെ ഇന്റർനാഷണൽ മാസ്റ്റേഴ്‌സ് ടെന്നിസ് ടൂർണമെന്റിലാണ് വൈദ്യ സഹായം ഒരുക്കിയിട്ടുള്ളത്. ആറുദിവസം നീണ്ടുനിൽക്കുന്ന മത്സരങ്ങളിൽ വിവിധ രാജ്യങ്ങളെയും ഇന്ത്യയുടെയും വിവിധ സംസ്ഥാനങ്ങളിലെയും  ഏകദേശം 150 കളിക്കാർ പുരുഷന്മാരുടെയും സ്ത്രീകളുടെയും വിവിധ വിഭാഗങ്ങളിൽ മത്സരിക്കുന്നു.",
      thumb: "assets/img/Pastevents/5190.jpg",
    },
    {
      src: "assets/img/Pastevents/5191.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ അടിയന്തിര വൈദ്യ സഹായ  ക്യാമ്പ് സംഘടിപ്പിച്ചു ട്രിവാൻഡ്രം ടെന്നിസ് ക്ലബ് (TTC) ലെ ഇന്റർനാഷണൽ മാസ്റ്റേഴ്‌സ് ടെന്നിസ് ടൂർണമെന്റിലാണ് വൈദ്യ സഹായം ഒരുക്കിയിട്ടുള്ളത്. ആറുദിവസം നീണ്ടുനിൽക്കുന്ന മത്സരങ്ങളിൽ വിവിധ രാജ്യങ്ങളെയും ഇന്ത്യയുടെയും വിവിധ സംസ്ഥാനങ്ങളിലെയും  ഏകദേശം 150 കളിക്കാർ പുരുഷന്മാരുടെയും സ്ത്രീകളുടെയും വിവിധ വിഭാഗങ്ങളിൽ മത്സരിക്കുന്നു.",
      thumb: "assets/img/Pastevents/5191.jpg",
    },
    {
      src: "assets/img/Pastevents/5142.jpg",
      caption:
        "നമ്മുടെ സംരക്ഷകരുടെ ആരോഗ്യം നമ്മുടെ കരുത്ത് ..... .. നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ ഫോർട്ട്‌ പോലീസ്  സ്റ്റേഷനിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു ജനറൽ മെഡിസിൻ , ദന്തൽ , ഇ സി ജി, ഒഫ്താൽമോളജി, രക്തസമ്മർദ്ദ പരിശോധന, പ്രമേഹരോഗനിർണയം തുടങ്ങിയ സൗജന്യ സേവനങ്ങളും ക്യാമ്പിൽ ലഭ്യമാക്കിയിരുന്നു ...",
      thumb: "assets/img/Pastevents/5142.jpg",
    },
    {
      src: "assets/img/Pastevents/5144.jpg",
      caption:
        "നമ്മുടെ സംരക്ഷകരുടെ ആരോഗ്യം നമ്മുടെ കരുത്ത് ..... .. നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ ഫോർട്ട്‌ പോലീസ്  സ്റ്റേഷനിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു ജനറൽ മെഡിസിൻ , ദന്തൽ , ഇ സി ജി, ഒഫ്താൽമോളജി, രക്തസമ്മർദ്ദ പരിശോധന, പ്രമേഹരോഗനിർണയം തുടങ്ങിയ സൗജന്യ സേവനങ്ങളും ക്യാമ്പിൽ ലഭ്യമാക്കിയിരുന്നു ...",
      thumb: "assets/img/Pastevents/5144.jpg",
    },
    {
      src: "assets/img/Pastevents/5143.jpg",
      caption:
        "നമ്മുടെ സംരക്ഷകരുടെ ആരോഗ്യം നമ്മുടെ കരുത്ത് ..... .. നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ ഫോർട്ട്‌ പോലീസ്  സ്റ്റേഷനിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു ജനറൽ മെഡിസിൻ , ദന്തൽ , ഇ സി ജി, ഒഫ്താൽമോളജി, രക്തസമ്മർദ്ദ പരിശോധന, പ്രമേഹരോഗനിർണയം തുടങ്ങിയ സൗജന്യ സേവനങ്ങളും ക്യാമ്പിൽ ലഭ്യമാക്കിയിരുന്നു ...",
      thumb: "assets/img/Pastevents/5143.jpg",
    },
    {
      src: "assets/img/Pastevents/5145.jpg",
      caption:
        "നമ്മുടെ സംരക്ഷകരുടെ ആരോഗ്യം നമ്മുടെ കരുത്ത് ..... .. നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ ഫോർട്ട്‌ പോലീസ്  സ്റ്റേഷനിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു ജനറൽ മെഡിസിൻ , ദന്തൽ , ഇ സി ജി, ഒഫ്താൽമോളജി, രക്തസമ്മർദ്ദ പരിശോധന, പ്രമേഹരോഗനിർണയം തുടങ്ങിയ സൗജന്യ സേവനങ്ങളും ക്യാമ്പിൽ ലഭ്യമാക്കിയിരുന്നു ...",
      thumb: "assets/img/Pastevents/5145.jpg",
    },
    {
      src: "assets/img/Pastevents/5146.jpg",
      caption:
        "നമ്മുടെ സംരക്ഷകരുടെ ആരോഗ്യം നമ്മുടെ കരുത്ത് ..... .. നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ ഫോർട്ട്‌ പോലീസ്  സ്റ്റേഷനിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു ജനറൽ മെഡിസിൻ , ദന്തൽ , ഇ സി ജി, ഒഫ്താൽമോളജി, രക്തസമ്മർദ്ദ പരിശോധന, പ്രമേഹരോഗനിർണയം തുടങ്ങിയ സൗജന്യ സേവനങ്ങളും ക്യാമ്പിൽ ലഭ്യമാക്കിയിരുന്നു ...",
      thumb: "assets/img/Pastevents/5146.jpg",
    },
    {
      src: "assets/img/Pastevents/5147.jpg",
      caption:
        "നമ്മുടെ സംരക്ഷകരുടെ ആരോഗ്യം നമ്മുടെ കരുത്ത് ..... .. നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ ഫോർട്ട്‌ പോലീസ്  സ്റ്റേഷനിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു ജനറൽ മെഡിസിൻ , ദന്തൽ , ഇ സി ജി, ഒഫ്താൽമോളജി, രക്തസമ്മർദ്ദ പരിശോധന, പ്രമേഹരോഗനിർണയം തുടങ്ങിയ സൗജന്യ സേവനങ്ങളും ക്യാമ്പിൽ ലഭ്യമാക്കിയിരുന്നു ...",
      thumb: "assets/img/Pastevents/5147.jpg",
    },
    {
      src: "assets/img/Pastevents/5148.jpg",
      caption:
        "നമ്മുടെ സംരക്ഷകരുടെ ആരോഗ്യം നമ്മുടെ കരുത്ത് ..... .. നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ ഫോർട്ട്‌ പോലീസ്  സ്റ്റേഷനിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു ജനറൽ മെഡിസിൻ , ദന്തൽ , ഇ സി ജി, ഒഫ്താൽമോളജി, രക്തസമ്മർദ്ദ പരിശോധന, പ്രമേഹരോഗനിർണയം തുടങ്ങിയ സൗജന്യ സേവനങ്ങളും ക്യാമ്പിൽ ലഭ്യമാക്കിയിരുന്നു ...",
      thumb: "assets/img/Pastevents/5148.jpg",
    },
    {
      src: "assets/img/Pastevents/5149.jpg",
      caption:
        "നമ്മുടെ സംരക്ഷകരുടെ ആരോഗ്യം നമ്മുടെ കരുത്ത് ..... .. നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ ഫോർട്ട്‌ പോലീസ്  സ്റ്റേഷനിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു ജനറൽ മെഡിസിൻ , ദന്തൽ , ഇ സി ജി, ഒഫ്താൽമോളജി, രക്തസമ്മർദ്ദ പരിശോധന, പ്രമേഹരോഗനിർണയം തുടങ്ങിയ സൗജന്യ സേവനങ്ങളും ക്യാമ്പിൽ ലഭ്യമാക്കിയിരുന്നു ...",
      thumb: "assets/img/Pastevents/5149.jpg",
    },
    {
      src: "assets/img/Pastevents/5150.jpg",
      caption:
        "നമ്മുടെ സംരക്ഷകരുടെ ആരോഗ്യം നമ്മുടെ കരുത്ത് ..... .. നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ ഫോർട്ട്‌ പോലീസ്  സ്റ്റേഷനിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു ജനറൽ മെഡിസിൻ , ദന്തൽ , ഇ സി ജി, ഒഫ്താൽമോളജി, രക്തസമ്മർദ്ദ പരിശോധന, പ്രമേഹരോഗനിർണയം തുടങ്ങിയ സൗജന്യ സേവനങ്ങളും ക്യാമ്പിൽ ലഭ്യമാക്കിയിരുന്നു ...",
      thumb: "assets/img/Pastevents/5150.jpg",
    },
    {
      src: "assets/img/Pastevents/5151.jpg",
      caption:
        "നമ്മുടെ സംരക്ഷകരുടെ ആരോഗ്യം നമ്മുടെ കരുത്ത് ..... .. നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ ഫോർട്ട്‌ പോലീസ്  സ്റ്റേഷനിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു ജനറൽ മെഡിസിൻ , ദന്തൽ , ഇ സി ജി, ഒഫ്താൽമോളജി, രക്തസമ്മർദ്ദ പരിശോധന, പ്രമേഹരോഗനിർണയം തുടങ്ങിയ സൗജന്യ സേവനങ്ങളും ക്യാമ്പിൽ ലഭ്യമാക്കിയിരുന്നു ...",
      thumb: "assets/img/Pastevents/5151.jpg",
    },
    {
      src: "assets/img/Pastevents/5152.jpg",
      caption:
        "നമ്മുടെ സംരക്ഷകരുടെ ആരോഗ്യം നമ്മുടെ കരുത്ത് ..... .. നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ ഫോർട്ട്‌ പോലീസ്  സ്റ്റേഷനിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു ജനറൽ മെഡിസിൻ , ദന്തൽ , ഇ സി ജി, ഒഫ്താൽമോളജി, രക്തസമ്മർദ്ദ പരിശോധന, പ്രമേഹരോഗനിർണയം തുടങ്ങിയ സൗജന്യ സേവനങ്ങളും ക്യാമ്പിൽ ലഭ്യമാക്കിയിരുന്നു ...",
      thumb: "assets/img/Pastevents/5152.jpg",
    },
    {
      src: "assets/img/Pastevents/5153.jpg",
      caption:
        "നമ്മുടെ സംരക്ഷകരുടെ ആരോഗ്യം നമ്മുടെ കരുത്ത് ..... .. നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ ഫോർട്ട്‌ പോലീസ്  സ്റ്റേഷനിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു ജനറൽ മെഡിസിൻ , ദന്തൽ , ഇ സി ജി, ഒഫ്താൽമോളജി, രക്തസമ്മർദ്ദ പരിശോധന, പ്രമേഹരോഗനിർണയം തുടങ്ങിയ സൗജന്യ സേവനങ്ങളും ക്യാമ്പിൽ ലഭ്യമാക്കിയിരുന്നു ...",
      thumb: "assets/img/Pastevents/5153.jpg",
    },
    {
      src: "assets/img/Pastevents/5154.jpg",
      caption:
        "നമ്മുടെ സംരക്ഷകരുടെ ആരോഗ്യം നമ്മുടെ കരുത്ത് ..... .. നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ ഫോർട്ട്‌ പോലീസ്  സ്റ്റേഷനിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു ജനറൽ മെഡിസിൻ , ദന്തൽ , ഇ സി ജി, ഒഫ്താൽമോളജി, രക്തസമ്മർദ്ദ പരിശോധന, പ്രമേഹരോഗനിർണയം തുടങ്ങിയ സൗജന്യ സേവനങ്ങളും ക്യാമ്പിൽ ലഭ്യമാക്കിയിരുന്നു ...",
      thumb: "assets/img/Pastevents/5154.jpg",
    },
    {
      src: "assets/img/Pastevents/5155.jpg",
      caption:
        "നമ്മുടെ സംരക്ഷകരുടെ ആരോഗ്യം നമ്മുടെ കരുത്ത് ..... .. നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ ഫോർട്ട്‌ പോലീസ്  സ്റ്റേഷനിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു ജനറൽ മെഡിസിൻ , ദന്തൽ , ഇ സി ജി, ഒഫ്താൽമോളജി, രക്തസമ്മർദ്ദ പരിശോധന, പ്രമേഹരോഗനിർണയം തുടങ്ങിയ സൗജന്യ സേവനങ്ങളും ക്യാമ്പിൽ ലഭ്യമാക്കിയിരുന്നു ...",
      thumb: "assets/img/Pastevents/5155.jpg",
    },
    {
      src: "assets/img/Pastevents/5156.jpg",
      caption:
        "നമ്മുടെ സംരക്ഷകരുടെ ആരോഗ്യം നമ്മുടെ കരുത്ത് ..... .. നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ ഫോർട്ട്‌ പോലീസ്  സ്റ്റേഷനിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു ജനറൽ മെഡിസിൻ , ദന്തൽ , ഇ സി ജി, ഒഫ്താൽമോളജി, രക്തസമ്മർദ്ദ പരിശോധന, പ്രമേഹരോഗനിർണയം തുടങ്ങിയ സൗജന്യ സേവനങ്ങളും ക്യാമ്പിൽ ലഭ്യമാക്കിയിരുന്നു ...",
      thumb: "assets/img/Pastevents/5156.jpg",
    },
    {
      src: "assets/img/Pastevents/5157.jpg",
      caption:
        "നമ്മുടെ സംരക്ഷകരുടെ ആരോഗ്യം നമ്മുടെ കരുത്ത് ..... .. നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ ഫോർട്ട്‌ പോലീസ്  സ്റ്റേഷനിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു ജനറൽ മെഡിസിൻ , ദന്തൽ , ഇ സി ജി, ഒഫ്താൽമോളജി, രക്തസമ്മർദ്ദ പരിശോധന, പ്രമേഹരോഗനിർണയം തുടങ്ങിയ സൗജന്യ സേവനങ്ങളും ക്യാമ്പിൽ ലഭ്യമാക്കിയിരുന്നു ...",
      thumb: "assets/img/Pastevents/5157.jpg",
    },
    {
      src: "assets/img/Pastevents/5158.jpg",
      caption:
        "നമ്മുടെ സംരക്ഷകരുടെ ആരോഗ്യം നമ്മുടെ കരുത്ത് ..... .. നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ ഫോർട്ട്‌ പോലീസ്  സ്റ്റേഷനിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു ജനറൽ മെഡിസിൻ , ദന്തൽ , ഇ സി ജി, ഒഫ്താൽമോളജി, രക്തസമ്മർദ്ദ പരിശോധന, പ്രമേഹരോഗനിർണയം തുടങ്ങിയ സൗജന്യ സേവനങ്ങളും ക്യാമ്പിൽ ലഭ്യമാക്കിയിരുന്നു ...",
      thumb: "assets/img/Pastevents/5158.jpg",
    },
    {
      src: "assets/img/Pastevents/5159.jpg",
      caption:
        "നമ്മുടെ സംരക്ഷകരുടെ ആരോഗ്യം നമ്മുടെ കരുത്ത് ..... .. നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ ഫോർട്ട്‌ പോലീസ്  സ്റ്റേഷനിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു ജനറൽ മെഡിസിൻ , ദന്തൽ , ഇ സി ജി, ഒഫ്താൽമോളജി, രക്തസമ്മർദ്ദ പരിശോധന, പ്രമേഹരോഗനിർണയം തുടങ്ങിയ സൗജന്യ സേവനങ്ങളും ക്യാമ്പിൽ ലഭ്യമാക്കിയിരുന്നു ...",
      thumb: "assets/img/Pastevents/5159.jpg",
    },
    {
      src: "assets/img/Pastevents/5160.jpg",
      caption:
        "നമ്മുടെ സംരക്ഷകരുടെ ആരോഗ്യം നമ്മുടെ കരുത്ത് ..... .. നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ ഫോർട്ട്‌ പോലീസ്  സ്റ്റേഷനിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു ജനറൽ മെഡിസിൻ , ദന്തൽ , ഇ സി ജി, ഒഫ്താൽമോളജി, രക്തസമ്മർദ്ദ പരിശോധന, പ്രമേഹരോഗനിർണയം തുടങ്ങിയ സൗജന്യ സേവനങ്ങളും ക്യാമ്പിൽ ലഭ്യമാക്കിയിരുന്നു ...",
      thumb: "assets/img/Pastevents/5160.jpg",
    },
    {
      src: "assets/img/Pastevents/5161.jpg",
      caption:
        "നമ്മുടെ സംരക്ഷകരുടെ ആരോഗ്യം നമ്മുടെ കരുത്ത് ..... .. നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ ഫോർട്ട്‌ പോലീസ്  സ്റ്റേഷനിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു ജനറൽ മെഡിസിൻ , ദന്തൽ , ഇ സി ജി, ഒഫ്താൽമോളജി, രക്തസമ്മർദ്ദ പരിശോധന, പ്രമേഹരോഗനിർണയം തുടങ്ങിയ സൗജന്യ സേവനങ്ങളും ക്യാമ്പിൽ ലഭ്യമാക്കിയിരുന്നു ...",
      thumb: "assets/img/Pastevents/5161.jpg",
    },
    {
      src: "assets/img/Pastevents/5162.jpg",
      caption:
        "നമ്മുടെ സംരക്ഷകരുടെ ആരോഗ്യം നമ്മുടെ കരുത്ത് ..... .. നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ ഫോർട്ട്‌ പോലീസ്  സ്റ്റേഷനിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു ജനറൽ മെഡിസിൻ , ദന്തൽ , ഇ സി ജി, ഒഫ്താൽമോളജി, രക്തസമ്മർദ്ദ പരിശോധന, പ്രമേഹരോഗനിർണയം തുടങ്ങിയ സൗജന്യ സേവനങ്ങളും ക്യാമ്പിൽ ലഭ്യമാക്കിയിരുന്നു ...",
      thumb: "assets/img/Pastevents/5162.jpg",
    },
    {
      src: "assets/img/Pastevents/5163.jpg",
      caption:
        "നമ്മുടെ സംരക്ഷകരുടെ ആരോഗ്യം നമ്മുടെ കരുത്ത് ..... .. നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ ഫോർട്ട്‌ പോലീസ്  സ്റ്റേഷനിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു ജനറൽ മെഡിസിൻ , ദന്തൽ , ഇ സി ജി, ഒഫ്താൽമോളജി, രക്തസമ്മർദ്ദ പരിശോധന, പ്രമേഹരോഗനിർണയം തുടങ്ങിയ സൗജന്യ സേവനങ്ങളും ക്യാമ്പിൽ ലഭ്യമാക്കിയിരുന്നു ...",
      thumb: "assets/img/Pastevents/5163.jpg",
    },
    {
      src: "assets/img/Pastevents/5164.jpg",
      caption:
        "നമ്മുടെ സംരക്ഷകരുടെ ആരോഗ്യം നമ്മുടെ കരുത്ത് ..... .. നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ ഫോർട്ട്‌ പോലീസ്  സ്റ്റേഷനിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു ജനറൽ മെഡിസിൻ , ദന്തൽ , ഇ സി ജി, ഒഫ്താൽമോളജി, രക്തസമ്മർദ്ദ പരിശോധന, പ്രമേഹരോഗനിർണയം തുടങ്ങിയ സൗജന്യ സേവനങ്ങളും ക്യാമ്പിൽ ലഭ്യമാക്കിയിരുന്നു ...",
      thumb: "assets/img/Pastevents/5164.jpg",
    },
    {
      src: "assets/img/Pastevents/5165.jpg",
      caption:
        "നമ്മുടെ സംരക്ഷകരുടെ ആരോഗ്യം നമ്മുടെ കരുത്ത് ..... .. നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ ഫോർട്ട്‌ പോലീസ്  സ്റ്റേഷനിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു ജനറൽ മെഡിസിൻ , ദന്തൽ , ഇ സി ജി, ഒഫ്താൽമോളജി, രക്തസമ്മർദ്ദ പരിശോധന, പ്രമേഹരോഗനിർണയം തുടങ്ങിയ സൗജന്യ സേവനങ്ങളും ക്യാമ്പിൽ ലഭ്യമാക്കിയിരുന്നു ...",
      thumb: "assets/img/Pastevents/5165.jpg",
    },
    {
      src: "assets/img/Pastevents/5128.jpg",
      caption:
        "ആഘോഷങ്ങൾക്ക് ആരവമുയർത്തി നിംസ് മെഡിസിറ്റി മലയടി ശ്രീധർമ ശാസ്താ ക്ഷേത്രത്തിൽ നടത്തിയ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ്... ജനറൽ മെഡിസിൻ ,ഇ സി ജി, രക്തസമ്മർദ്ദ പരിശോധന, പ്രമേഹരോഗ  നിർണയം തുടങ്ങിയ സൗജന്യ സേവനങ്ങളും ലഭ്യമായിരുന്നു...",
      thumb: "assets/img/Pastevents/5128.jpg",
    },
    {
      src: "assets/img/Pastevents/5129.jpg",
      caption:
        "ആഘോഷങ്ങൾക്ക് ആരവമുയർത്തി നിംസ് മെഡിസിറ്റി മലയടി ശ്രീധർമ ശാസ്താ ക്ഷേത്രത്തിൽ നടത്തിയ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ്... ജനറൽ മെഡിസിൻ ,ഇ സി ജി, രക്തസമ്മർദ്ദ പരിശോധന, പ്രമേഹരോഗ  നിർണയം തുടങ്ങിയ സൗജന്യ സേവനങ്ങളും ലഭ്യമായിരുന്നു...",
      thumb: "assets/img/Pastevents/5129.jpg",
    },
    {
      src: "assets/img/Pastevents/5130.jpg",
      caption:
        "ആഘോഷങ്ങൾക്ക് ആരവമുയർത്തി നിംസ് മെഡിസിറ്റി മലയടി ശ്രീധർമ ശാസ്താ ക്ഷേത്രത്തിൽ നടത്തിയ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ്... ജനറൽ മെഡിസിൻ ,ഇ സി ജി, രക്തസമ്മർദ്ദ പരിശോധന, പ്രമേഹരോഗ  നിർണയം തുടങ്ങിയ സൗജന്യ സേവനങ്ങളും ലഭ്യമായിരുന്നു...",
      thumb: "assets/img/Pastevents/5130.jpg",
    },
    {
      src: "assets/img/Pastevents/5131.jpg",
      caption:
        "ആഘോഷങ്ങൾക്ക് ആരവമുയർത്തി നിംസ് മെഡിസിറ്റി മലയടി ശ്രീധർമ ശാസ്താ ക്ഷേത്രത്തിൽ നടത്തിയ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ്... ജനറൽ മെഡിസിൻ ,ഇ സി ജി, രക്തസമ്മർദ്ദ പരിശോധന, പ്രമേഹരോഗ  നിർണയം തുടങ്ങിയ സൗജന്യ സേവനങ്ങളും ലഭ്യമായിരുന്നു...",
      thumb: "assets/img/Pastevents/5131.jpg",
    },
    {
      src: "assets/img/Pastevents/5132.jpg",
      caption:
        "ആഘോഷങ്ങൾക്ക് ആരവമുയർത്തി നിംസ് മെഡിസിറ്റി മലയടി ശ്രീധർമ ശാസ്താ ക്ഷേത്രത്തിൽ നടത്തിയ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ്... ജനറൽ മെഡിസിൻ ,ഇ സി ജി, രക്തസമ്മർദ്ദ പരിശോധന, പ്രമേഹരോഗ  നിർണയം തുടങ്ങിയ സൗജന്യ സേവനങ്ങളും ലഭ്യമായിരുന്നു...",
      thumb: "assets/img/Pastevents/5132.jpg",
    },
    {
      src: "assets/img/Pastevents/5133.jpg",
      caption:
        "ആഘോഷങ്ങൾക്ക് ആരവമുയർത്തി നിംസ് മെഡിസിറ്റി മലയടി ശ്രീധർമ ശാസ്താ ക്ഷേത്രത്തിൽ നടത്തിയ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ്... ജനറൽ മെഡിസിൻ ,ഇ സി ജി, രക്തസമ്മർദ്ദ പരിശോധന, പ്രമേഹരോഗ  നിർണയം തുടങ്ങിയ സൗജന്യ സേവനങ്ങളും ലഭ്യമായിരുന്നു...",
      thumb: "assets/img/Pastevents/5133.jpg",
    },
    {
      src: "assets/img/Pastevents/5134.jpg",
      caption:
        "ആഘോഷങ്ങൾക്ക് ആരവമുയർത്തി നിംസ് മെഡിസിറ്റി മലയടി ശ്രീധർമ ശാസ്താ ക്ഷേത്രത്തിൽ നടത്തിയ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ്... ജനറൽ മെഡിസിൻ ,ഇ സി ജി, രക്തസമ്മർദ്ദ പരിശോധന, പ്രമേഹരോഗ  നിർണയം തുടങ്ങിയ സൗജന്യ സേവനങ്ങളും ലഭ്യമായിരുന്നു...",
      thumb: "assets/img/Pastevents/5134.jpg",
    },
    {
      src: "assets/img/Pastevents/5135.jpg",
      caption:
        "ആഘോഷങ്ങൾക്ക് ആരവമുയർത്തി നിംസ് മെഡിസിറ്റി മലയടി ശ്രീധർമ ശാസ്താ ക്ഷേത്രത്തിൽ നടത്തിയ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ്... ജനറൽ മെഡിസിൻ ,ഇ സി ജി, രക്തസമ്മർദ്ദ പരിശോധന, പ്രമേഹരോഗ  നിർണയം തുടങ്ങിയ സൗജന്യ സേവനങ്ങളും ലഭ്യമായിരുന്നു...",
      thumb: "assets/img/Pastevents/5135.jpg",
    },
    {
      src: "assets/img/Pastevents/5136.jpg",
      caption:
        "ആഘോഷങ്ങൾക്ക് ആരവമുയർത്തി നിംസ് മെഡിസിറ്റി മലയടി ശ്രീധർമ ശാസ്താ ക്ഷേത്രത്തിൽ നടത്തിയ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ്... ജനറൽ മെഡിസിൻ ,ഇ സി ജി, രക്തസമ്മർദ്ദ പരിശോധന, പ്രമേഹരോഗ  നിർണയം തുടങ്ങിയ സൗജന്യ സേവനങ്ങളും ലഭ്യമായിരുന്നു...",
      thumb: "assets/img/Pastevents/5136.jpg",
    },
    {
      src: "assets/img/Pastevents/5137.jpg",
      caption:
        "ആഘോഷങ്ങൾക്ക് ആരവമുയർത്തി നിംസ് മെഡിസിറ്റി മലയടി ശ്രീധർമ ശാസ്താ ക്ഷേത്രത്തിൽ നടത്തിയ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ്... ജനറൽ മെഡിസിൻ ,ഇ സി ജി, രക്തസമ്മർദ്ദ പരിശോധന, പ്രമേഹരോഗ  നിർണയം തുടങ്ങിയ സൗജന്യ സേവനങ്ങളും ലഭ്യമായിരുന്നു...",
      thumb: "assets/img/Pastevents/5137.jpg",
    },
    {
      src: "assets/img/Pastevents/5138.jpg",
      caption:
        "ആഘോഷങ്ങൾക്ക് ആരവമുയർത്തി നിംസ് മെഡിസിറ്റി മലയടി ശ്രീധർമ ശാസ്താ ക്ഷേത്രത്തിൽ നടത്തിയ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ്... ജനറൽ മെഡിസിൻ ,ഇ സി ജി, രക്തസമ്മർദ്ദ പരിശോധന, പ്രമേഹരോഗ  നിർണയം തുടങ്ങിയ സൗജന്യ സേവനങ്ങളും ലഭ്യമായിരുന്നു...",
      thumb: "assets/img/Pastevents/5138.jpg",
    },
    {
      src: "assets/img/Pastevents/5139.jpg",
      caption:
        "ആഘോഷങ്ങൾക്ക് ആരവമുയർത്തി നിംസ് മെഡിസിറ്റി മലയടി ശ്രീധർമ ശാസ്താ ക്ഷേത്രത്തിൽ നടത്തിയ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ്... ജനറൽ മെഡിസിൻ ,ഇ സി ജി, രക്തസമ്മർദ്ദ പരിശോധന, പ്രമേഹരോഗ  നിർണയം തുടങ്ങിയ സൗജന്യ സേവനങ്ങളും ലഭ്യമായിരുന്നു...",
      thumb: "assets/img/Pastevents/5139.jpg",
    },
    {
      src: "assets/img/Pastevents/5140.jpg",
      caption:
        "ആഘോഷങ്ങൾക്ക് ആരവമുയർത്തി നിംസ് മെഡിസിറ്റി മലയടി ശ്രീധർമ ശാസ്താ ക്ഷേത്രത്തിൽ നടത്തിയ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ്... ജനറൽ മെഡിസിൻ ,ഇ സി ജി, രക്തസമ്മർദ്ദ പരിശോധന, പ്രമേഹരോഗ  നിർണയം തുടങ്ങിയ സൗജന്യ സേവനങ്ങളും ലഭ്യമായിരുന്നു...",
      thumb: "assets/img/Pastevents/5140.jpg",
    },
    {
      src: "assets/img/Pastevents/5141.jpg",
      caption:
        "ആഘോഷങ്ങൾക്ക് ആരവമുയർത്തി നിംസ് മെഡിസിറ്റി മലയടി ശ്രീധർമ ശാസ്താ ക്ഷേത്രത്തിൽ നടത്തിയ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ്... ജനറൽ മെഡിസിൻ ,ഇ സി ജി, രക്തസമ്മർദ്ദ പരിശോധന, പ്രമേഹരോഗ  നിർണയം തുടങ്ങിയ സൗജന്യ സേവനങ്ങളും ലഭ്യമായിരുന്നു...",
      thumb: "assets/img/Pastevents/5141.jpg",
    },
    {
      src: "assets/img/Pastevents/5093.jpg",
      caption:
        "ആരോഗ്യത്തിന്റെ പുഞ്ചിരി 😍 രജിസ്റ്റേർഡ് എൻജിനിയർസ് &  സൂപ്പർവൈസേഴ്സ് ഫെഡറേഷന്റെ നാലാം സ്റ്റേറ്റ് കോൺഫറൻസ് ലയൺസ് ക്ലബ്ബും, നിംസ് മെഡിസിറ്റിയും സംയുക്തമായി ജിമ്മി ജോർജ് സ്റ്റേഡിയത്തിൽ  നടത്തിയ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് ✨️",
      thumb: "assets/img/Pastevents/5093.jpg",
    },
    {
      src: "assets/img/Pastevents/5094.jpg",
      caption:
        "ആരോഗ്യത്തിന്റെ പുഞ്ചിരി 😍 രജിസ്റ്റേർഡ് എൻജിനിയർസ് &  സൂപ്പർവൈസേഴ്സ് ഫെഡറേഷന്റെ നാലാം സ്റ്റേറ്റ് കോൺഫറൻസ് ലയൺസ് ക്ലബ്ബും, നിംസ് മെഡിസിറ്റിയും സംയുക്തമായി ജിമ്മി ജോർജ് സ്റ്റേഡിയത്തിൽ  നടത്തിയ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് ✨️",
      thumb: "assets/img/Pastevents/5094.jpg",
    },
    {
      src: "assets/img/Pastevents/5095.jpg",
      caption:
        "ആരോഗ്യത്തിന്റെ പുഞ്ചിരി 😍 രജിസ്റ്റേർഡ് എൻജിനിയർസ് &  സൂപ്പർവൈസേഴ്സ് ഫെഡറേഷന്റെ നാലാം സ്റ്റേറ്റ് കോൺഫറൻസ് ലയൺസ് ക്ലബ്ബും, നിംസ് മെഡിസിറ്റിയും സംയുക്തമായി ജിമ്മി ജോർജ് സ്റ്റേഡിയത്തിൽ  നടത്തിയ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് ✨️",
      thumb: "assets/img/Pastevents/5095.jpg",
    },
    {
      src: "assets/img/Pastevents/5096.jpg",
      caption:
        "ആരോഗ്യത്തിന്റെ പുഞ്ചിരി 😍 രജിസ്റ്റേർഡ് എൻജിനിയർസ് &  സൂപ്പർവൈസേഴ്സ് ഫെഡറേഷന്റെ നാലാം സ്റ്റേറ്റ് കോൺഫറൻസ് ലയൺസ് ക്ലബ്ബും, നിംസ് മെഡിസിറ്റിയും സംയുക്തമായി ജിമ്മി ജോർജ് സ്റ്റേഡിയത്തിൽ  നടത്തിയ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് ✨️",
      thumb: "assets/img/Pastevents/5096.jpg",
    },
    {
      src: "assets/img/Pastevents/5097.jpg",
      caption:
        "ആരോഗ്യത്തിന്റെ പുഞ്ചിരി 😍 രജിസ്റ്റേർഡ് എൻജിനിയർസ് &  സൂപ്പർവൈസേഴ്സ് ഫെഡറേഷന്റെ നാലാം സ്റ്റേറ്റ് കോൺഫറൻസ് ലയൺസ് ക്ലബ്ബും, നിംസ് മെഡിസിറ്റിയും സംയുക്തമായി ജിമ്മി ജോർജ് സ്റ്റേഡിയത്തിൽ  നടത്തിയ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് ✨️",
      thumb: "assets/img/Pastevents/5097.jpg",
    },
    {
      src: "assets/img/Pastevents/5098.jpg",
      caption:
        "ആരോഗ്യത്തിന്റെ പുഞ്ചിരി 😍 രജിസ്റ്റേർഡ് എൻജിനിയർസ് &  സൂപ്പർവൈസേഴ്സ് ഫെഡറേഷന്റെ നാലാം സ്റ്റേറ്റ് കോൺഫറൻസ് ലയൺസ് ക്ലബ്ബും, നിംസ് മെഡിസിറ്റിയും സംയുക്തമായി ജിമ്മി ജോർജ് സ്റ്റേഡിയത്തിൽ  നടത്തിയ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് ✨️",
      thumb: "assets/img/Pastevents/5098.jpg",
    },
    {
      src: "assets/img/Pastevents/5099.jpg",
      caption:
        "ആരോഗ്യത്തിന്റെ പുഞ്ചിരി 😍 രജിസ്റ്റേർഡ് എൻജിനിയർസ് &  സൂപ്പർവൈസേഴ്സ് ഫെഡറേഷന്റെ നാലാം സ്റ്റേറ്റ് കോൺഫറൻസ് ലയൺസ് ക്ലബ്ബും, നിംസ് മെഡിസിറ്റിയും സംയുക്തമായി ജിമ്മി ജോർജ് സ്റ്റേഡിയത്തിൽ  നടത്തിയ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് ✨️",
      thumb: "assets/img/Pastevents/5099.jpg",
    },
    {
      src: "assets/img/Pastevents/5100.jpg",
      caption:
        "ആരോഗ്യത്തിന്റെ പുഞ്ചിരി 😍 രജിസ്റ്റേർഡ് എൻജിനിയർസ് &  സൂപ്പർവൈസേഴ്സ് ഫെഡറേഷന്റെ നാലാം സ്റ്റേറ്റ് കോൺഫറൻസ് ലയൺസ് ക്ലബ്ബും, നിംസ് മെഡിസിറ്റിയും സംയുക്തമായി ജിമ്മി ജോർജ് സ്റ്റേഡിയത്തിൽ  നടത്തിയ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് ✨️",
      thumb: "assets/img/Pastevents/5100.jpg",
    },
    {
      src: "assets/img/Pastevents/5101.jpg",
      caption:
        "ആരോഗ്യത്തിന്റെ പുഞ്ചിരി 😍 രജിസ്റ്റേർഡ് എൻജിനിയർസ് &  സൂപ്പർവൈസേഴ്സ് ഫെഡറേഷന്റെ നാലാം സ്റ്റേറ്റ് കോൺഫറൻസ് ലയൺസ് ക്ലബ്ബും, നിംസ് മെഡിസിറ്റിയും സംയുക്തമായി ജിമ്മി ജോർജ് സ്റ്റേഡിയത്തിൽ  നടത്തിയ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് ✨️",
      thumb: "assets/img/Pastevents/5101.jpg",
    },
    {
      src: "assets/img/Pastevents/5102.jpg",
      caption:
        "ആരോഗ്യത്തിന്റെ പുഞ്ചിരി 😍 രജിസ്റ്റേർഡ് എൻജിനിയർസ് &  സൂപ്പർവൈസേഴ്സ് ഫെഡറേഷന്റെ നാലാം സ്റ്റേറ്റ് കോൺഫറൻസ് ലയൺസ് ക്ലബ്ബും, നിംസ് മെഡിസിറ്റിയും സംയുക്തമായി ജിമ്മി ജോർജ് സ്റ്റേഡിയത്തിൽ  നടത്തിയ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് ✨️",
      thumb: "assets/img/Pastevents/5102.jpg",
    },
    {
      src: "assets/img/Pastevents/5103.jpg",
      caption:
        "ആരോഗ്യത്തിന്റെ പുഞ്ചിരി 😍 രജിസ്റ്റേർഡ് എൻജിനിയർസ് &  സൂപ്പർവൈസേഴ്സ് ഫെഡറേഷന്റെ നാലാം സ്റ്റേറ്റ് കോൺഫറൻസ് ലയൺസ് ക്ലബ്ബും, നിംസ് മെഡിസിറ്റിയും സംയുക്തമായി ജിമ്മി ജോർജ് സ്റ്റേഡിയത്തിൽ  നടത്തിയ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് ✨️",
      thumb: "assets/img/Pastevents/5103.jpg",
    },
    {
      src: "assets/img/Pastevents/5104.jpg",
      caption:
        "ആരോഗ്യത്തിന്റെ പുഞ്ചിരി 😍 രജിസ്റ്റേർഡ് എൻജിനിയർസ് &  സൂപ്പർവൈസേഴ്സ് ഫെഡറേഷന്റെ നാലാം സ്റ്റേറ്റ് കോൺഫറൻസ് ലയൺസ് ക്ലബ്ബും, നിംസ് മെഡിസിറ്റിയും സംയുക്തമായി ജിമ്മി ജോർജ് സ്റ്റേഡിയത്തിൽ  നടത്തിയ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് ✨️",
      thumb: "assets/img/Pastevents/5104.jpg",
    },
    {
      src: "assets/img/Pastevents/5105.jpg",
      caption:
        "ആരോഗ്യത്തിന്റെ പുഞ്ചിരി 😍 രജിസ്റ്റേർഡ് എൻജിനിയർസ് &  സൂപ്പർവൈസേഴ്സ് ഫെഡറേഷന്റെ നാലാം സ്റ്റേറ്റ് കോൺഫറൻസ് ലയൺസ് ക്ലബ്ബും, നിംസ് മെഡിസിറ്റിയും സംയുക്തമായി ജിമ്മി ജോർജ് സ്റ്റേഡിയത്തിൽ  നടത്തിയ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് ✨️",
      thumb: "assets/img/Pastevents/5105.jpg",
    },
    {
      src: "assets/img/Pastevents/5106.jpg",
      caption:
        "ആരോഗ്യത്തിന്റെ പുഞ്ചിരി 😍 രജിസ്റ്റേർഡ് എൻജിനിയർസ് &  സൂപ്പർവൈസേഴ്സ് ഫെഡറേഷന്റെ നാലാം സ്റ്റേറ്റ് കോൺഫറൻസ് ലയൺസ് ക്ലബ്ബും, നിംസ് മെഡിസിറ്റിയും സംയുക്തമായി ജിമ്മി ജോർജ് സ്റ്റേഡിയത്തിൽ  നടത്തിയ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് ✨️",
      thumb: "assets/img/Pastevents/5106.jpg",
    },
    {
      src: "assets/img/Pastevents/5107.jpg",
      caption:
        "ആരോഗ്യത്തിന്റെ പുഞ്ചിരി 😍 രജിസ്റ്റേർഡ് എൻജിനിയർസ് &  സൂപ്പർവൈസേഴ്സ് ഫെഡറേഷന്റെ നാലാം സ്റ്റേറ്റ് കോൺഫറൻസ് ലയൺസ് ക്ലബ്ബും, നിംസ് മെഡിസിറ്റിയും സംയുക്തമായി ജിമ്മി ജോർജ് സ്റ്റേഡിയത്തിൽ  നടത്തിയ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് ✨️",
      thumb: "assets/img/Pastevents/5107.jpg",
    },
    {
      src: "assets/img/Pastevents/5108.jpg",
      caption:
        "ആരോഗ്യത്തിന്റെ പുഞ്ചിരി 😍 രജിസ്റ്റേർഡ് എൻജിനിയർസ് &  സൂപ്പർവൈസേഴ്സ് ഫെഡറേഷന്റെ നാലാം സ്റ്റേറ്റ് കോൺഫറൻസ് ലയൺസ് ക്ലബ്ബും, നിംസ് മെഡിസിറ്റിയും സംയുക്തമായി ജിമ്മി ജോർജ് സ്റ്റേഡിയത്തിൽ  നടത്തിയ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് ✨️",
      thumb: "assets/img/Pastevents/5108.jpg",
    },
    {
      src: "assets/img/Pastevents/5109.jpg",
      caption:
        "ആരോഗ്യത്തിന്റെ പുഞ്ചിരി 😍 രജിസ്റ്റേർഡ് എൻജിനിയർസ് &  സൂപ്പർവൈസേഴ്സ് ഫെഡറേഷന്റെ നാലാം സ്റ്റേറ്റ് കോൺഫറൻസ് ലയൺസ് ക്ലബ്ബും, നിംസ് മെഡിസിറ്റിയും സംയുക്തമായി ജിമ്മി ജോർജ് സ്റ്റേഡിയത്തിൽ  നടത്തിയ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് ✨️",
      thumb: "assets/img/Pastevents/5109.jpg",
    },
    {
      src: "assets/img/Pastevents/5110.jpg",
      caption:
        "ആരോഗ്യത്തിന്റെ പുഞ്ചിരി 😍 രജിസ്റ്റേർഡ് എൻജിനിയർസ് &  സൂപ്പർവൈസേഴ്സ് ഫെഡറേഷന്റെ നാലാം സ്റ്റേറ്റ് കോൺഫറൻസ് ലയൺസ് ക്ലബ്ബും, നിംസ് മെഡിസിറ്റിയും സംയുക്തമായി ജിമ്മി ജോർജ് സ്റ്റേഡിയത്തിൽ  നടത്തിയ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് ✨️",
      thumb: "assets/img/Pastevents/5110.jpg",
    },
    {
      src: "assets/img/Pastevents/5111.jpg",
      caption:
        "ആരോഗ്യത്തിന്റെ പുഞ്ചിരി 😍 രജിസ്റ്റേർഡ് എൻജിനിയർസ് &  സൂപ്പർവൈസേഴ്സ് ഫെഡറേഷന്റെ നാലാം സ്റ്റേറ്റ് കോൺഫറൻസ് ലയൺസ് ക്ലബ്ബും, നിംസ് മെഡിസിറ്റിയും സംയുക്തമായി ജിമ്മി ജോർജ് സ്റ്റേഡിയത്തിൽ  നടത്തിയ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് ✨️",
      thumb: "assets/img/Pastevents/5111.jpg",
    },
    {
      src: "assets/img/Pastevents/5112.jpg",
      caption:
        "ആരോഗ്യത്തിന്റെ പുഞ്ചിരി 😍 രജിസ്റ്റേർഡ് എൻജിനിയർസ് &  സൂപ്പർവൈസേഴ്സ് ഫെഡറേഷന്റെ നാലാം സ്റ്റേറ്റ് കോൺഫറൻസ് ലയൺസ് ക്ലബ്ബും, നിംസ് മെഡിസിറ്റിയും സംയുക്തമായി ജിമ്മി ജോർജ് സ്റ്റേഡിയത്തിൽ  നടത്തിയ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് ✨️",
      thumb: "assets/img/Pastevents/5112.jpg",
    },
    {
      src: "assets/img/Pastevents/5113.jpg",
      caption:
        "ആരോഗ്യത്തിന്റെ പുഞ്ചിരി 😍 രജിസ്റ്റേർഡ് എൻജിനിയർസ് &  സൂപ്പർവൈസേഴ്സ് ഫെഡറേഷന്റെ നാലാം സ്റ്റേറ്റ് കോൺഫറൻസ് ലയൺസ് ക്ലബ്ബും, നിംസ് മെഡിസിറ്റിയും സംയുക്തമായി ജിമ്മി ജോർജ് സ്റ്റേഡിയത്തിൽ  നടത്തിയ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് ✨️",
      thumb: "assets/img/Pastevents/5113.jpg",
    },
    {
      src: "assets/img/Pastevents/5114.jpg",
      caption:
        "ആരോഗ്യത്തിന്റെ പുഞ്ചിരി 😍 രജിസ്റ്റേർഡ് എൻജിനിയർസ് &  സൂപ്പർവൈസേഴ്സ് ഫെഡറേഷന്റെ നാലാം സ്റ്റേറ്റ് കോൺഫറൻസ് ലയൺസ് ക്ലബ്ബും, നിംസ് മെഡിസിറ്റിയും സംയുക്തമായി ജിമ്മി ജോർജ് സ്റ്റേഡിയത്തിൽ  നടത്തിയ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് ✨️",
      thumb: "assets/img/Pastevents/5114.jpg",
    },
    {
      src: "assets/img/Pastevents/5115.jpg",
      caption:
        "ആരോഗ്യത്തിന്റെ പുഞ്ചിരി 😍 രജിസ്റ്റേർഡ് എൻജിനിയർസ് &  സൂപ്പർവൈസേഴ്സ് ഫെഡറേഷന്റെ നാലാം സ്റ്റേറ്റ് കോൺഫറൻസ് ലയൺസ് ക്ലബ്ബും, നിംസ് മെഡിസിറ്റിയും സംയുക്തമായി ജിമ്മി ജോർജ് സ്റ്റേഡിയത്തിൽ  നടത്തിയ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് ✨️",
      thumb: "assets/img/Pastevents/5115.jpg",
    },
    {
      src: "assets/img/Pastevents/5116.jpg",
      caption:
        "ആരോഗ്യത്തിന്റെ പുഞ്ചിരി 😍 രജിസ്റ്റേർഡ് എൻജിനിയർസ് &  സൂപ്പർവൈസേഴ്സ് ഫെഡറേഷന്റെ നാലാം സ്റ്റേറ്റ് കോൺഫറൻസ് ലയൺസ് ക്ലബ്ബും, നിംസ് മെഡിസിറ്റിയും സംയുക്തമായി ജിമ്മി ജോർജ് സ്റ്റേഡിയത്തിൽ  നടത്തിയ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് ✨️",
      thumb: "assets/img/Pastevents/5116.jpg",
    },
    {
      src: "assets/img/Pastevents/5117.jpg",
      caption:
        "ആരോഗ്യത്തിന്റെ പുഞ്ചിരി 😍 രജിസ്റ്റേർഡ് എൻജിനിയർസ് &  സൂപ്പർവൈസേഴ്സ് ഫെഡറേഷന്റെ നാലാം സ്റ്റേറ്റ് കോൺഫറൻസ് ലയൺസ് ക്ലബ്ബും, നിംസ് മെഡിസിറ്റിയും സംയുക്തമായി ജിമ്മി ജോർജ് സ്റ്റേഡിയത്തിൽ  നടത്തിയ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് ✨️",
      thumb: "assets/img/Pastevents/5117.jpg",
    },
    {
      src: "assets/img/Pastevents/5118.jpg",
      caption:
        "ആരോഗ്യത്തിന്റെ പുഞ്ചിരി 😍 രജിസ്റ്റേർഡ് എൻജിനിയർസ് &  സൂപ്പർവൈസേഴ്സ് ഫെഡറേഷന്റെ നാലാം സ്റ്റേറ്റ് കോൺഫറൻസ് ലയൺസ് ക്ലബ്ബും, നിംസ് മെഡിസിറ്റിയും സംയുക്തമായി ജിമ്മി ജോർജ് സ്റ്റേഡിയത്തിൽ  നടത്തിയ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് ✨️",
      thumb: "assets/img/Pastevents/5118.jpg",
    },
    {
      src: "assets/img/Pastevents/5119.jpg",
      caption:
        "ആരോഗ്യത്തിന്റെ പുഞ്ചിരി 😍 രജിസ്റ്റേർഡ് എൻജിനിയർസ് &  സൂപ്പർവൈസേഴ്സ് ഫെഡറേഷന്റെ നാലാം സ്റ്റേറ്റ് കോൺഫറൻസ് ലയൺസ് ക്ലബ്ബും, നിംസ് മെഡിസിറ്റിയും സംയുക്തമായി ജിമ്മി ജോർജ് സ്റ്റേഡിയത്തിൽ  നടത്തിയ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് ✨️",
      thumb: "assets/img/Pastevents/5119.jpg",
    },
    {
      src: "assets/img/Pastevents/5120.jpg",
      caption:
        "ആരോഗ്യത്തിന്റെ പുഞ്ചിരി 😍 രജിസ്റ്റേർഡ് എൻജിനിയർസ് &  സൂപ്പർവൈസേഴ്സ് ഫെഡറേഷന്റെ നാലാം സ്റ്റേറ്റ് കോൺഫറൻസ് ലയൺസ് ക്ലബ്ബും, നിംസ് മെഡിസിറ്റിയും സംയുക്തമായി ജിമ്മി ജോർജ് സ്റ്റേഡിയത്തിൽ  നടത്തിയ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് ✨️",
      thumb: "assets/img/Pastevents/5120.jpg",
    },
    {
      src: "assets/img/Pastevents/5121.jpg",
      caption:
        "ആരോഗ്യത്തിന്റെ പുഞ്ചിരി 😍 രജിസ്റ്റേർഡ് എൻജിനിയർസ് &  സൂപ്പർവൈസേഴ്സ് ഫെഡറേഷന്റെ നാലാം സ്റ്റേറ്റ് കോൺഫറൻസ് ലയൺസ് ക്ലബ്ബും, നിംസ് മെഡിസിറ്റിയും സംയുക്തമായി ജിമ്മി ജോർജ് സ്റ്റേഡിയത്തിൽ  നടത്തിയ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് ✨️",
      thumb: "assets/img/Pastevents/5121.jpg",
    },
    {
      src: "assets/img/Pastevents/5122.jpg",
      caption:
        "ആരോഗ്യത്തിന്റെ പുഞ്ചിരി 😍 രജിസ്റ്റേർഡ് എൻജിനിയർസ് &  സൂപ്പർവൈസേഴ്സ് ഫെഡറേഷന്റെ നാലാം സ്റ്റേറ്റ് കോൺഫറൻസ് ലയൺസ് ക്ലബ്ബും, നിംസ് മെഡിസിറ്റിയും സംയുക്തമായി ജിമ്മി ജോർജ് സ്റ്റേഡിയത്തിൽ  നടത്തിയ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് ✨️",
      thumb: "assets/img/Pastevents/5122.jpg",
    },
    {
      src: "assets/img/Pastevents/5123.jpg",
      caption:
        "ആരോഗ്യത്തിന്റെ പുഞ്ചിരി 😍 രജിസ്റ്റേർഡ് എൻജിനിയർസ് &  സൂപ്പർവൈസേഴ്സ് ഫെഡറേഷന്റെ നാലാം സ്റ്റേറ്റ് കോൺഫറൻസ് ലയൺസ് ക്ലബ്ബും, നിംസ് മെഡിസിറ്റിയും സംയുക്തമായി ജിമ്മി ജോർജ് സ്റ്റേഡിയത്തിൽ  നടത്തിയ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് ✨️",
      thumb: "assets/img/Pastevents/5123.jpg",
    },
    {
      src: "assets/img/Pastevents/5124.jpg",
      caption:
        "ആരോഗ്യത്തിന്റെ പുഞ്ചിരി 😍 രജിസ്റ്റേർഡ് എൻജിനിയർസ് &  സൂപ്പർവൈസേഴ്സ് ഫെഡറേഷന്റെ നാലാം സ്റ്റേറ്റ് കോൺഫറൻസ് ലയൺസ് ക്ലബ്ബും, നിംസ് മെഡിസിറ്റിയും സംയുക്തമായി ജിമ്മി ജോർജ് സ്റ്റേഡിയത്തിൽ  നടത്തിയ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് ✨️",
      thumb: "assets/img/Pastevents/5124.jpg",
    },
    {
      src: "assets/img/Pastevents/5125.jpg",
      caption:
        "ആരോഗ്യത്തിന്റെ പുഞ്ചിരി 😍 രജിസ്റ്റേർഡ് എൻജിനിയർസ് &  സൂപ്പർവൈസേഴ്സ് ഫെഡറേഷന്റെ നാലാം സ്റ്റേറ്റ് കോൺഫറൻസ് ലയൺസ് ക്ലബ്ബും, നിംസ് മെഡിസിറ്റിയും സംയുക്തമായി ജിമ്മി ജോർജ് സ്റ്റേഡിയത്തിൽ  നടത്തിയ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് ✨️",
      thumb: "assets/img/Pastevents/5125.jpg",
    },
    {
      src: "assets/img/Pastevents/5126.jpg",
      caption:
        "ആരോഗ്യത്തിന്റെ പുഞ്ചിരി 😍 രജിസ്റ്റേർഡ് എൻജിനിയർസ് &  സൂപ്പർവൈസേഴ്സ് ഫെഡറേഷന്റെ നാലാം സ്റ്റേറ്റ് കോൺഫറൻസ് ലയൺസ് ക്ലബ്ബും, നിംസ് മെഡിസിറ്റിയും സംയുക്തമായി ജിമ്മി ജോർജ് സ്റ്റേഡിയത്തിൽ  നടത്തിയ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് ✨️",
      thumb: "assets/img/Pastevents/5126.jpg",
    },
    {
      src: "assets/img/Pastevents/5127.jpg",
      caption:
        "ആരോഗ്യത്തിന്റെ പുഞ്ചിരി 😍 രജിസ്റ്റേർഡ് എൻജിനിയർസ് &  സൂപ്പർവൈസേഴ്സ് ഫെഡറേഷന്റെ നാലാം സ്റ്റേറ്റ് കോൺഫറൻസ് ലയൺസ് ക്ലബ്ബും, നിംസ് മെഡിസിറ്റിയും സംയുക്തമായി ജിമ്മി ജോർജ് സ്റ്റേഡിയത്തിൽ  നടത്തിയ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് ✨️",
      thumb: "assets/img/Pastevents/5127.jpg",
    },
    {
      src: "assets/img/Pastevents/5075.jpg",
      caption:
        "ബാലരാമപുരം വിശുദ്ധ സെബസ്ത്യാനോസിന്റെ തിരുനാളിനോടനുബന്ധിച്ച്  നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ സംഘടിപ്പിച്ച സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് ബാലരാമപുരം വിശുദ്ധ സെബസ്ത്യാനോസ് ഫൊറോനാ തീർത്ഥാടന ദേവാലത്തിൽ വച്ച്  നടന്ന മെഗാ മെഡിക്കൽ ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, റൂമറ്റോളജി, ദന്തൽ,ഓഫ്താൽമോളജി ,ഡയറ്ററി തുടങ്ങിയ വിഭാഗങ്ങളിലെ വിദഗ്ധരായ ഡോക്ടർമാരുടെ സേവനം ഉണ്ടായിരുന്നു.",
      thumb: "assets/img/Pastevents/5075.jpg",
    },
    {
      src: "assets/img/Pastevents/5076.jpg",
      caption:
        "ബാലരാമപുരം വിശുദ്ധ സെബസ്ത്യാനോസിന്റെ തിരുനാളിനോടനുബന്ധിച്ച്  നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ സംഘടിപ്പിച്ച സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് ബാലരാമപുരം വിശുദ്ധ സെബസ്ത്യാനോസ് ഫൊറോനാ തീർത്ഥാടന ദേവാലത്തിൽ വച്ച്  നടന്ന മെഗാ മെഡിക്കൽ ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, റൂമറ്റോളജി, ദന്തൽ,ഓഫ്താൽമോളജി ,ഡയറ്ററി തുടങ്ങിയ വിഭാഗങ്ങളിലെ വിദഗ്ധരായ ഡോക്ടർമാരുടെ സേവനം ഉണ്ടായിരുന്നു.",
      thumb: "assets/img/Pastevents/5076.jpg",
    },
    {
      src: "assets/img/Pastevents/5077.jpg",
      caption:
        "ബാലരാമപുരം വിശുദ്ധ സെബസ്ത്യാനോസിന്റെ തിരുനാളിനോടനുബന്ധിച്ച്  നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ സംഘടിപ്പിച്ച സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് ബാലരാമപുരം വിശുദ്ധ സെബസ്ത്യാനോസ് ഫൊറോനാ തീർത്ഥാടന ദേവാലത്തിൽ വച്ച്  നടന്ന മെഗാ മെഡിക്കൽ ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, റൂമറ്റോളജി, ദന്തൽ,ഓഫ്താൽമോളജി ,ഡയറ്ററി തുടങ്ങിയ വിഭാഗങ്ങളിലെ വിദഗ്ധരായ ഡോക്ടർമാരുടെ സേവനം ഉണ്ടായിരുന്നു.",
      thumb: "assets/img/Pastevents/5077.jpg",
    },
    {
      src: "assets/img/Pastevents/5078.jpg",
      caption:
        "ബാലരാമപുരം വിശുദ്ധ സെബസ്ത്യാനോസിന്റെ തിരുനാളിനോടനുബന്ധിച്ച്  നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ സംഘടിപ്പിച്ച സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് ബാലരാമപുരം വിശുദ്ധ സെബസ്ത്യാനോസ് ഫൊറോനാ തീർത്ഥാടന ദേവാലത്തിൽ വച്ച്  നടന്ന മെഗാ മെഡിക്കൽ ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, റൂമറ്റോളജി, ദന്തൽ,ഓഫ്താൽമോളജി ,ഡയറ്ററി തുടങ്ങിയ വിഭാഗങ്ങളിലെ വിദഗ്ധരായ ഡോക്ടർമാരുടെ സേവനം ഉണ്ടായിരുന്നു.",
      thumb: "assets/img/Pastevents/5078.jpg",
    },
    {
      src: "assets/img/Pastevents/5079.jpg",
      caption:
        "ബാലരാമപുരം വിശുദ്ധ സെബസ്ത്യാനോസിന്റെ തിരുനാളിനോടനുബന്ധിച്ച്  നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ സംഘടിപ്പിച്ച സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് ബാലരാമപുരം വിശുദ്ധ സെബസ്ത്യാനോസ് ഫൊറോനാ തീർത്ഥാടന ദേവാലത്തിൽ വച്ച്  നടന്ന മെഗാ മെഡിക്കൽ ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, റൂമറ്റോളജി, ദന്തൽ,ഓഫ്താൽമോളജി ,ഡയറ്ററി തുടങ്ങിയ വിഭാഗങ്ങളിലെ വിദഗ്ധരായ ഡോക്ടർമാരുടെ സേവനം ഉണ്ടായിരുന്നു.",
      thumb: "assets/img/Pastevents/5079.jpg",
    },
    {
      src: "assets/img/Pastevents/5080.jpg",
      caption:
        "ബാലരാമപുരം വിശുദ്ധ സെബസ്ത്യാനോസിന്റെ തിരുനാളിനോടനുബന്ധിച്ച്  നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ സംഘടിപ്പിച്ച സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് ബാലരാമപുരം വിശുദ്ധ സെബസ്ത്യാനോസ് ഫൊറോനാ തീർത്ഥാടന ദേവാലത്തിൽ വച്ച്  നടന്ന മെഗാ മെഡിക്കൽ ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, റൂമറ്റോളജി, ദന്തൽ,ഓഫ്താൽമോളജി ,ഡയറ്ററി തുടങ്ങിയ വിഭാഗങ്ങളിലെ വിദഗ്ധരായ ഡോക്ടർമാരുടെ സേവനം ഉണ്ടായിരുന്നു.",
      thumb: "assets/img/Pastevents/5080.jpg",
    },
    {
      src: "assets/img/Pastevents/5081.jpg",
      caption:
        "ബാലരാമപുരം വിശുദ്ധ സെബസ്ത്യാനോസിന്റെ തിരുനാളിനോടനുബന്ധിച്ച്  നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ സംഘടിപ്പിച്ച സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് ബാലരാമപുരം വിശുദ്ധ സെബസ്ത്യാനോസ് ഫൊറോനാ തീർത്ഥാടന ദേവാലത്തിൽ വച്ച്  നടന്ന മെഗാ മെഡിക്കൽ ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, റൂമറ്റോളജി, ദന്തൽ,ഓഫ്താൽമോളജി ,ഡയറ്ററി തുടങ്ങിയ വിഭാഗങ്ങളിലെ വിദഗ്ധരായ ഡോക്ടർമാരുടെ സേവനം ഉണ്ടായിരുന്നു.",
      thumb: "assets/img/Pastevents/5081.jpg",
    },
    {
      src: "assets/img/Pastevents/5082.jpg",
      caption:
        "ബാലരാമപുരം വിശുദ്ധ സെബസ്ത്യാനോസിന്റെ തിരുനാളിനോടനുബന്ധിച്ച്  നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ സംഘടിപ്പിച്ച സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് ബാലരാമപുരം വിശുദ്ധ സെബസ്ത്യാനോസ് ഫൊറോനാ തീർത്ഥാടന ദേവാലത്തിൽ വച്ച്  നടന്ന മെഗാ മെഡിക്കൽ ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, റൂമറ്റോളജി, ദന്തൽ,ഓഫ്താൽമോളജി ,ഡയറ്ററി തുടങ്ങിയ വിഭാഗങ്ങളിലെ വിദഗ്ധരായ ഡോക്ടർമാരുടെ സേവനം ഉണ്ടായിരുന്നു.",
      thumb: "assets/img/Pastevents/5082.jpg",
    },
    {
      src: "assets/img/Pastevents/5083.jpg",
      caption:
        "ബാലരാമപുരം വിശുദ്ധ സെബസ്ത്യാനോസിന്റെ തിരുനാളിനോടനുബന്ധിച്ച്  നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ സംഘടിപ്പിച്ച സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് ബാലരാമപുരം വിശുദ്ധ സെബസ്ത്യാനോസ് ഫൊറോനാ തീർത്ഥാടന ദേവാലത്തിൽ വച്ച്  നടന്ന മെഗാ മെഡിക്കൽ ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, റൂമറ്റോളജി, ദന്തൽ,ഓഫ്താൽമോളജി ,ഡയറ്ററി തുടങ്ങിയ വിഭാഗങ്ങളിലെ വിദഗ്ധരായ ഡോക്ടർമാരുടെ സേവനം ഉണ്ടായിരുന്നു.",
      thumb: "assets/img/Pastevents/5083.jpg",
    },
    {
      src: "assets/img/Pastevents/5084.jpg",
      caption:
        "ബാലരാമപുരം വിശുദ്ധ സെബസ്ത്യാനോസിന്റെ തിരുനാളിനോടനുബന്ധിച്ച്  നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ സംഘടിപ്പിച്ച സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് ബാലരാമപുരം വിശുദ്ധ സെബസ്ത്യാനോസ് ഫൊറോനാ തീർത്ഥാടന ദേവാലത്തിൽ വച്ച്  നടന്ന മെഗാ മെഡിക്കൽ ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, റൂമറ്റോളജി, ദന്തൽ,ഓഫ്താൽമോളജി ,ഡയറ്ററി തുടങ്ങിയ വിഭാഗങ്ങളിലെ വിദഗ്ധരായ ഡോക്ടർമാരുടെ സേവനം ഉണ്ടായിരുന്നു.",
      thumb: "assets/img/Pastevents/5084.jpg",
    },
    {
      src: "assets/img/Pastevents/5085.jpg",
      caption:
        "ബാലരാമപുരം വിശുദ്ധ സെബസ്ത്യാനോസിന്റെ തിരുനാളിനോടനുബന്ധിച്ച്  നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ സംഘടിപ്പിച്ച സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് ബാലരാമപുരം വിശുദ്ധ സെബസ്ത്യാനോസ് ഫൊറോനാ തീർത്ഥാടന ദേവാലത്തിൽ വച്ച്  നടന്ന മെഗാ മെഡിക്കൽ ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, റൂമറ്റോളജി, ദന്തൽ,ഓഫ്താൽമോളജി ,ഡയറ്ററി തുടങ്ങിയ വിഭാഗങ്ങളിലെ വിദഗ്ധരായ ഡോക്ടർമാരുടെ സേവനം ഉണ്ടായിരുന്നു.",
      thumb: "assets/img/Pastevents/5085.jpg",
    },
    {
      src: "assets/img/Pastevents/5086.jpg",
      caption:
        "ബാലരാമപുരം വിശുദ്ധ സെബസ്ത്യാനോസിന്റെ തിരുനാളിനോടനുബന്ധിച്ച്  നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ സംഘടിപ്പിച്ച സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് ബാലരാമപുരം വിശുദ്ധ സെബസ്ത്യാനോസ് ഫൊറോനാ തീർത്ഥാടന ദേവാലത്തിൽ വച്ച്  നടന്ന മെഗാ മെഡിക്കൽ ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, റൂമറ്റോളജി, ദന്തൽ,ഓഫ്താൽമോളജി ,ഡയറ്ററി തുടങ്ങിയ വിഭാഗങ്ങളിലെ വിദഗ്ധരായ ഡോക്ടർമാരുടെ സേവനം ഉണ്ടായിരുന്നു.",
      thumb: "assets/img/Pastevents/5086.jpg",
    },
    {
      src: "assets/img/Pastevents/5087.jpg",
      caption:
        "ബാലരാമപുരം വിശുദ്ധ സെബസ്ത്യാനോസിന്റെ തിരുനാളിനോടനുബന്ധിച്ച്  നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ സംഘടിപ്പിച്ച സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് ബാലരാമപുരം വിശുദ്ധ സെബസ്ത്യാനോസ് ഫൊറോനാ തീർത്ഥാടന ദേവാലത്തിൽ വച്ച്  നടന്ന മെഗാ മെഡിക്കൽ ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, റൂമറ്റോളജി, ദന്തൽ,ഓഫ്താൽമോളജി ,ഡയറ്ററി തുടങ്ങിയ വിഭാഗങ്ങളിലെ വിദഗ്ധരായ ഡോക്ടർമാരുടെ സേവനം ഉണ്ടായിരുന്നു.",
      thumb: "assets/img/Pastevents/5087.jpg",
    },
    {
      src: "assets/img/Pastevents/5088.jpg",
      caption:
        "ബാലരാമപുരം വിശുദ്ധ സെബസ്ത്യാനോസിന്റെ തിരുനാളിനോടനുബന്ധിച്ച്  നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ സംഘടിപ്പിച്ച സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് ബാലരാമപുരം വിശുദ്ധ സെബസ്ത്യാനോസ് ഫൊറോനാ തീർത്ഥാടന ദേവാലത്തിൽ വച്ച്  നടന്ന മെഗാ മെഡിക്കൽ ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, റൂമറ്റോളജി, ദന്തൽ,ഓഫ്താൽമോളജി ,ഡയറ്ററി തുടങ്ങിയ വിഭാഗങ്ങളിലെ വിദഗ്ധരായ ഡോക്ടർമാരുടെ സേവനം ഉണ്ടായിരുന്നു.",
      thumb: "assets/img/Pastevents/5088.jpg",
    },
    {
      src: "assets/img/Pastevents/5089.jpg",
      caption:
        "ബാലരാമപുരം വിശുദ്ധ സെബസ്ത്യാനോസിന്റെ തിരുനാളിനോടനുബന്ധിച്ച്  നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ സംഘടിപ്പിച്ച സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് ബാലരാമപുരം വിശുദ്ധ സെബസ്ത്യാനോസ് ഫൊറോനാ തീർത്ഥാടന ദേവാലത്തിൽ വച്ച്  നടന്ന മെഗാ മെഡിക്കൽ ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, റൂമറ്റോളജി, ദന്തൽ,ഓഫ്താൽമോളജി ,ഡയറ്ററി തുടങ്ങിയ വിഭാഗങ്ങളിലെ വിദഗ്ധരായ ഡോക്ടർമാരുടെ സേവനം ഉണ്ടായിരുന്നു.",
      thumb: "assets/img/Pastevents/5089.jpg",
    },
    {
      src: "assets/img/Pastevents/5090.jpg",
      caption:
        "ബാലരാമപുരം വിശുദ്ധ സെബസ്ത്യാനോസിന്റെ തിരുനാളിനോടനുബന്ധിച്ച്  നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ സംഘടിപ്പിച്ച സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് ബാലരാമപുരം വിശുദ്ധ സെബസ്ത്യാനോസ് ഫൊറോനാ തീർത്ഥാടന ദേവാലത്തിൽ വച്ച്  നടന്ന മെഗാ മെഡിക്കൽ ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, റൂമറ്റോളജി, ദന്തൽ,ഓഫ്താൽമോളജി ,ഡയറ്ററി തുടങ്ങിയ വിഭാഗങ്ങളിലെ വിദഗ്ധരായ ഡോക്ടർമാരുടെ സേവനം ഉണ്ടായിരുന്നു.",
      thumb: "assets/img/Pastevents/5090.jpg",
    },
    {
      src: "assets/img/Pastevents/5091.jpg",
      caption:
        "ബാലരാമപുരം വിശുദ്ധ സെബസ്ത്യാനോസിന്റെ തിരുനാളിനോടനുബന്ധിച്ച്  നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ സംഘടിപ്പിച്ച സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് ബാലരാമപുരം വിശുദ്ധ സെബസ്ത്യാനോസ് ഫൊറോനാ തീർത്ഥാടന ദേവാലത്തിൽ വച്ച്  നടന്ന മെഗാ മെഡിക്കൽ ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, റൂമറ്റോളജി, ദന്തൽ,ഓഫ്താൽമോളജി ,ഡയറ്ററി തുടങ്ങിയ വിഭാഗങ്ങളിലെ വിദഗ്ധരായ ഡോക്ടർമാരുടെ സേവനം ഉണ്ടായിരുന്നു.",
      thumb: "assets/img/Pastevents/5091.jpg",
    },
    {
      src: "assets/img/Pastevents/5092.jpg",
      caption:
        "ബാലരാമപുരം വിശുദ്ധ സെബസ്ത്യാനോസിന്റെ തിരുനാളിനോടനുബന്ധിച്ച്  നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ സംഘടിപ്പിച്ച സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് ബാലരാമപുരം വിശുദ്ധ സെബസ്ത്യാനോസ് ഫൊറോനാ തീർത്ഥാടന ദേവാലത്തിൽ വച്ച്  നടന്ന മെഗാ മെഡിക്കൽ ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, റൂമറ്റോളജി, ദന്തൽ,ഓഫ്താൽമോളജി ,ഡയറ്ററി തുടങ്ങിയ വിഭാഗങ്ങളിലെ വിദഗ്ധരായ ഡോക്ടർമാരുടെ സേവനം ഉണ്ടായിരുന്നു.",
      thumb: "assets/img/Pastevents/5092.jpg",
    },
    {
      src: "assets/img/Pastevents/5065.jpg",
      caption:
        "മെഡിക്കൽ ഗാസ്ട്രോ വിഭാഗം സീനിയർ കൺസർട്ടൻറുമാരായ ഡോ. നീഹാർ എം ഷാനവാസ് , ഡോ. ബിൻസി ബി.കെ തുടങ്ങിയവർ ക്യാമ്പിന് നേതൃത്വം നൽകി",
      thumb: "assets/img/Pastevents/5065.jpg",
    },
    {
      src: "assets/img/Pastevents/5066.jpg",
      caption:
        "മെഡിക്കൽ ഗാസ്ട്രോ വിഭാഗം സീനിയർ കൺസർട്ടൻറുമാരായ ഡോ. നീഹാർ എം ഷാനവാസ് , ഡോ. ബിൻസി ബി.കെ തുടങ്ങിയവർ ക്യാമ്പിന് നേതൃത്വം നൽകി",
      thumb: "assets/img/Pastevents/5066.jpg",
    },
    {
      src: "assets/img/Pastevents/5067.jpg",
      caption:
        "മെഡിക്കൽ ഗാസ്ട്രോ വിഭാഗം സീനിയർ കൺസർട്ടൻറുമാരായ ഡോ. നീഹാർ എം ഷാനവാസ് , ഡോ. ബിൻസി ബി.കെ തുടങ്ങിയവർ ക്യാമ്പിന് നേതൃത്വം നൽകി",
      thumb: "assets/img/Pastevents/5067.jpg",
    },
    {
      src: "assets/img/Pastevents/5068.jpg",
      caption:
        "മെഡിക്കൽ ഗാസ്ട്രോ വിഭാഗം സീനിയർ കൺസർട്ടൻറുമാരായ ഡോ. നീഹാർ എം ഷാനവാസ് , ഡോ. ബിൻസി ബി.കെ തുടങ്ങിയവർ ക്യാമ്പിന് നേതൃത്വം നൽകി",
      thumb: "assets/img/Pastevents/5068.jpg",
    },
    {
      src: "assets/img/Pastevents/5069.jpg",
      caption:
        "മെഡിക്കൽ ഗാസ്ട്രോ വിഭാഗം സീനിയർ കൺസർട്ടൻറുമാരായ ഡോ. നീഹാർ എം ഷാനവാസ് , ഡോ. ബിൻസി ബി.കെ തുടങ്ങിയവർ ക്യാമ്പിന് നേതൃത്വം നൽകി",
      thumb: "assets/img/Pastevents/5069.jpg",
    },
    {
      src: "assets/img/Pastevents/5070.jpg",
      caption:
        "മെഡിക്കൽ ഗാസ്ട്രോ വിഭാഗം സീനിയർ കൺസർട്ടൻറുമാരായ ഡോ. നീഹാർ എം ഷാനവാസ് , ഡോ. ബിൻസി ബി.കെ തുടങ്ങിയവർ ക്യാമ്പിന് നേതൃത്വം നൽകി",
      thumb: "assets/img/Pastevents/5070.jpg",
    },
    {
      src: "assets/img/Pastevents/5071.jpg",
      caption:
        "മെഡിക്കൽ ഗാസ്ട്രോ വിഭാഗം സീനിയർ കൺസർട്ടൻറുമാരായ ഡോ. നീഹാർ എം ഷാനവാസ് , ഡോ. ബിൻസി ബി.കെ തുടങ്ങിയവർ ക്യാമ്പിന് നേതൃത്വം നൽകി",
      thumb: "assets/img/Pastevents/5071.jpg",
    },
    {
      src: "assets/img/Pastevents/5072.jpg",
      caption:
        "മെഡിക്കൽ ഗാസ്ട്രോ വിഭാഗം സീനിയർ കൺസർട്ടൻറുമാരായ ഡോ. നീഹാർ എം ഷാനവാസ് , ഡോ. ബിൻസി ബി.കെ തുടങ്ങിയവർ ക്യാമ്പിന് നേതൃത്വം നൽകി",
      thumb: "assets/img/Pastevents/5072.jpg",
    },
    {
      src: "assets/img/Pastevents/5073.jpg",
      caption:
        "മെഡിക്കൽ ഗാസ്ട്രോ വിഭാഗം സീനിയർ കൺസർട്ടൻറുമാരായ ഡോ. നീഹാർ എം ഷാനവാസ് , ഡോ. ബിൻസി ബി.കെ തുടങ്ങിയവർ ക്യാമ്പിന് നേതൃത്വം നൽകി",
      thumb: "assets/img/Pastevents/5073.jpg",
    },
    {
      src: "assets/img/Pastevents/5074.jpg",
      caption:
        "മെഡിക്കൽ ഗാസ്ട്രോ വിഭാഗം സീനിയർ കൺസർട്ടൻറുമാരായ ഡോ. നീഹാർ എം ഷാനവാസ് , ഡോ. ബിൻസി ബി.കെ തുടങ്ങിയവർ ക്യാമ്പിന് നേതൃത്വം നൽകി",
      thumb: "assets/img/Pastevents/5074.jpg",
    },
    {
      src: "assets/img/Pastevents/5050.jpg",
      caption:
        "എമർജൻസി മെഡിക്കൽ കെയർ യൂണിറ്റ് KSRTC ബസ് സ്‌റ്റേഷൻ തിരുവനന്തപുരം നിംസ് ജനകീയാരോഗ്യകേന്ദ്രം 💓",
      thumb: "assets/img/Pastevents/5050.jpg",
    },
    {
      src: "assets/img/Pastevents/5051.jpg",
      caption:
        "എമർജൻസി മെഡിക്കൽ കെയർ യൂണിറ്റ് KSRTC ബസ് സ്‌റ്റേഷൻ തിരുവനന്തപുരം നിംസ് ജനകീയാരോഗ്യകേന്ദ്രം 💓",
      thumb: "assets/img/Pastevents/5051.jpg",
    },
    {
      src: "assets/img/Pastevents/5052.jpg",
      caption:
        "എമർജൻസി മെഡിക്കൽ കെയർ യൂണിറ്റ് KSRTC ബസ് സ്‌റ്റേഷൻ തിരുവനന്തപുരം നിംസ് ജനകീയാരോഗ്യകേന്ദ്രം 💓",
      thumb: "assets/img/Pastevents/5052.jpg",
    },
    {
      src: "assets/img/Pastevents/5053.jpg",
      caption:
        "എമർജൻസി മെഡിക്കൽ കെയർ യൂണിറ്റ് KSRTC ബസ് സ്‌റ്റേഷൻ തിരുവനന്തപുരം നിംസ് ജനകീയാരോഗ്യകേന്ദ്രം 💓",
      thumb: "assets/img/Pastevents/5053.jpg",
    },
    {
      src: "assets/img/Pastevents/5054.jpg",
      caption:
        "എമർജൻസി മെഡിക്കൽ കെയർ യൂണിറ്റ് KSRTC ബസ് സ്‌റ്റേഷൻ തിരുവനന്തപുരം നിംസ് ജനകീയാരോഗ്യകേന്ദ്രം 💓",
      thumb: "assets/img/Pastevents/5054.jpg",
    },
    {
      src: "assets/img/Pastevents/5055.jpg",
      caption:
        "എമർജൻസി മെഡിക്കൽ കെയർ യൂണിറ്റ് KSRTC ബസ് സ്‌റ്റേഷൻ തിരുവനന്തപുരം നിംസ് ജനകീയാരോഗ്യകേന്ദ്രം 💓",
      thumb: "assets/img/Pastevents/5055.jpg",
    },
    {
      src: "assets/img/Pastevents/5056.jpg",
      caption:
        "എമർജൻസി മെഡിക്കൽ കെയർ യൂണിറ്റ് KSRTC ബസ് സ്‌റ്റേഷൻ തിരുവനന്തപുരം നിംസ് ജനകീയാരോഗ്യകേന്ദ്രം 💓",
      thumb: "assets/img/Pastevents/5056.jpg",
    },
    {
      src: "assets/img/Pastevents/5057.jpg",
      caption:
        "എമർജൻസി മെഡിക്കൽ കെയർ യൂണിറ്റ് KSRTC ബസ് സ്‌റ്റേഷൻ തിരുവനന്തപുരം നിംസ് ജനകീയാരോഗ്യകേന്ദ്രം 💓",
      thumb: "assets/img/Pastevents/5057.jpg",
    },
    {
      src: "assets/img/Pastevents/5058.jpg",
      caption:
        "എമർജൻസി മെഡിക്കൽ കെയർ യൂണിറ്റ് KSRTC ബസ് സ്‌റ്റേഷൻ തിരുവനന്തപുരം നിംസ് ജനകീയാരോഗ്യകേന്ദ്രം 💓",
      thumb: "assets/img/Pastevents/5058.jpg",
    },
    {
      src: "assets/img/Pastevents/5059.jpg",
      caption:
        "എമർജൻസി മെഡിക്കൽ കെയർ യൂണിറ്റ് KSRTC ബസ് സ്‌റ്റേഷൻ തിരുവനന്തപുരം നിംസ് ജനകീയാരോഗ്യകേന്ദ്രം 💓",
      thumb: "assets/img/Pastevents/5059.jpg",
    },
    {
      src: "assets/img/Pastevents/5060.jpg",
      caption:
        "എമർജൻസി മെഡിക്കൽ കെയർ യൂണിറ്റ് KSRTC ബസ് സ്‌റ്റേഷൻ തിരുവനന്തപുരം നിംസ് ജനകീയാരോഗ്യകേന്ദ്രം 💓",
      thumb: "assets/img/Pastevents/5060.jpg",
    },
    {
      src: "assets/img/Pastevents/5061.jpg",
      caption:
        "എമർജൻസി മെഡിക്കൽ കെയർ യൂണിറ്റ് KSRTC ബസ് സ്‌റ്റേഷൻ തിരുവനന്തപുരം നിംസ് ജനകീയാരോഗ്യകേന്ദ്രം 💓",
      thumb: "assets/img/Pastevents/5061.jpg",
    },
    {
      src: "assets/img/Pastevents/5062.jpg",
      caption:
        "എമർജൻസി മെഡിക്കൽ കെയർ യൂണിറ്റ് KSRTC ബസ് സ്‌റ്റേഷൻ തിരുവനന്തപുരം നിംസ് ജനകീയാരോഗ്യകേന്ദ്രം 💓",
      thumb: "assets/img/Pastevents/5062.jpg",
    },
    {
      src: "assets/img/Pastevents/5063.jpg",
      caption:
        "എമർജൻസി മെഡിക്കൽ കെയർ യൂണിറ്റ് KSRTC ബസ് സ്‌റ്റേഷൻ തിരുവനന്തപുരം നിംസ് ജനകീയാരോഗ്യകേന്ദ്രം 💓",
      thumb: "assets/img/Pastevents/5063.jpg",
    },
    {
      src: "assets/img/Pastevents/5064.jpg",
      caption:
        "എമർജൻസി മെഡിക്കൽ കെയർ യൂണിറ്റ് KSRTC ബസ് സ്‌റ്റേഷൻ തിരുവനന്തപുരം നിംസ് ജനകീയാരോഗ്യകേന്ദ്രം 💓",
      thumb: "assets/img/Pastevents/5064.jpg",
    },
    {
      src: "assets/img/Pastevents/5028.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ ഗ്രീൻ സിറ്റി ലയൺസ്‌ ക്ലബ്ബിന്റെ ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ശ്രീ. ഐ ബി സതീഷ് എം.എൽ.എ ക്യാമ്പ് ഉദ്ഘാടനകർമ്മം നിർവഹിച്ചു. നിംസ് മെഡിസിറ്റിയുടെ കാർഡിയോളജി,ഡയബറ്റോളജി, ജനറൽ മെഡിസിൻ,ദന്തൽ വിഭാഗങ്ങൾ പി. വി. എൽ. പി സ്കൂളിൽ വച്ച് നടന്ന മെഗാ ക്യാമ്പിൽ പങ്കെടുത്തു",
      thumb: "assets/img/Pastevents/5028.jpg",
    },
    {
      src: "assets/img/Pastevents/5029.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ ഗ്രീൻ സിറ്റി ലയൺസ്‌ ക്ലബ്ബിന്റെ ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ശ്രീ. ഐ ബി സതീഷ് എം.എൽ.എ ക്യാമ്പ് ഉദ്ഘാടനകർമ്മം നിർവഹിച്ചു. നിംസ് മെഡിസിറ്റിയുടെ കാർഡിയോളജി,ഡയബറ്റോളജി, ജനറൽ മെഡിസിൻ,ദന്തൽ വിഭാഗങ്ങൾ പി. വി. എൽ. പി സ്കൂളിൽ വച്ച് നടന്ന മെഗാ ക്യാമ്പിൽ പങ്കെടുത്തു",
      thumb: "assets/img/Pastevents/5029.jpg",
    },
    {
      src: "assets/img/Pastevents/5030.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ ഗ്രീൻ സിറ്റി ലയൺസ്‌ ക്ലബ്ബിന്റെ ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ശ്രീ. ഐ ബി സതീഷ് എം.എൽ.എ ക്യാമ്പ് ഉദ്ഘാടനകർമ്മം നിർവഹിച്ചു. നിംസ് മെഡിസിറ്റിയുടെ കാർഡിയോളജി,ഡയബറ്റോളജി, ജനറൽ മെഡിസിൻ,ദന്തൽ വിഭാഗങ്ങൾ പി. വി. എൽ. പി സ്കൂളിൽ വച്ച് നടന്ന മെഗാ ക്യാമ്പിൽ പങ്കെടുത്തു",
      thumb: "assets/img/Pastevents/5030.jpg",
    },
    {
      src: "assets/img/Pastevents/5031.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ ഗ്രീൻ സിറ്റി ലയൺസ്‌ ക്ലബ്ബിന്റെ ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ശ്രീ. ഐ ബി സതീഷ് എം.എൽ.എ ക്യാമ്പ് ഉദ്ഘാടനകർമ്മം നിർവഹിച്ചു. നിംസ് മെഡിസിറ്റിയുടെ കാർഡിയോളജി,ഡയബറ്റോളജി, ജനറൽ മെഡിസിൻ,ദന്തൽ വിഭാഗങ്ങൾ പി. വി. എൽ. പി സ്കൂളിൽ വച്ച് നടന്ന മെഗാ ക്യാമ്പിൽ പങ്കെടുത്തു",
      thumb: "assets/img/Pastevents/5031.jpg",
    },
    {
      src: "assets/img/Pastevents/5032.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ ഗ്രീൻ സിറ്റി ലയൺസ്‌ ക്ലബ്ബിന്റെ ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ശ്രീ. ഐ ബി സതീഷ് എം.എൽ.എ ക്യാമ്പ് ഉദ്ഘാടനകർമ്മം നിർവഹിച്ചു. നിംസ് മെഡിസിറ്റിയുടെ കാർഡിയോളജി,ഡയബറ്റോളജി, ജനറൽ മെഡിസിൻ,ദന്തൽ വിഭാഗങ്ങൾ പി. വി. എൽ. പി സ്കൂളിൽ വച്ച് നടന്ന മെഗാ ക്യാമ്പിൽ പങ്കെടുത്തു",
      thumb: "assets/img/Pastevents/5032.jpg",
    },
    {
      src: "assets/img/Pastevents/5033.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ ഗ്രീൻ സിറ്റി ലയൺസ്‌ ക്ലബ്ബിന്റെ ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ശ്രീ. ഐ ബി സതീഷ് എം.എൽ.എ ക്യാമ്പ് ഉദ്ഘാടനകർമ്മം നിർവഹിച്ചു. നിംസ് മെഡിസിറ്റിയുടെ കാർഡിയോളജി,ഡയബറ്റോളജി, ജനറൽ മെഡിസിൻ,ദന്തൽ വിഭാഗങ്ങൾ പി. വി. എൽ. പി സ്കൂളിൽ വച്ച് നടന്ന മെഗാ ക്യാമ്പിൽ പങ്കെടുത്തു",
      thumb: "assets/img/Pastevents/5033.jpg",
    },
    {
      src: "assets/img/Pastevents/5034.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ ഗ്രീൻ സിറ്റി ലയൺസ്‌ ക്ലബ്ബിന്റെ ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ശ്രീ. ഐ ബി സതീഷ് എം.എൽ.എ ക്യാമ്പ് ഉദ്ഘാടനകർമ്മം നിർവഹിച്ചു. നിംസ് മെഡിസിറ്റിയുടെ കാർഡിയോളജി,ഡയബറ്റോളജി, ജനറൽ മെഡിസിൻ,ദന്തൽ വിഭാഗങ്ങൾ പി. വി. എൽ. പി സ്കൂളിൽ വച്ച് നടന്ന മെഗാ ക്യാമ്പിൽ പങ്കെടുത്തു",
      thumb: "assets/img/Pastevents/5034.jpg",
    },
    {
      src: "assets/img/Pastevents/5035.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ ഗ്രീൻ സിറ്റി ലയൺസ്‌ ക്ലബ്ബിന്റെ ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ശ്രീ. ഐ ബി സതീഷ് എം.എൽ.എ ക്യാമ്പ് ഉദ്ഘാടനകർമ്മം നിർവഹിച്ചു. നിംസ് മെഡിസിറ്റിയുടെ കാർഡിയോളജി,ഡയബറ്റോളജി, ജനറൽ മെഡിസിൻ,ദന്തൽ വിഭാഗങ്ങൾ പി. വി. എൽ. പി സ്കൂളിൽ വച്ച് നടന്ന മെഗാ ക്യാമ്പിൽ പങ്കെടുത്തു",
      thumb: "assets/img/Pastevents/5035.jpg",
    },
    {
      src: "assets/img/Pastevents/5036.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ ഗ്രീൻ സിറ്റി ലയൺസ്‌ ക്ലബ്ബിന്റെ ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ശ്രീ. ഐ ബി സതീഷ് എം.എൽ.എ ക്യാമ്പ് ഉദ്ഘാടനകർമ്മം നിർവഹിച്ചു. നിംസ് മെഡിസിറ്റിയുടെ കാർഡിയോളജി,ഡയബറ്റോളജി, ജനറൽ മെഡിസിൻ,ദന്തൽ വിഭാഗങ്ങൾ പി. വി. എൽ. പി സ്കൂളിൽ വച്ച് നടന്ന മെഗാ ക്യാമ്പിൽ പങ്കെടുത്തു",
      thumb: "assets/img/Pastevents/5036.jpg",
    },
    {
      src: "assets/img/Pastevents/5037.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ ഗ്രീൻ സിറ്റി ലയൺസ്‌ ക്ലബ്ബിന്റെ ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ശ്രീ. ഐ ബി സതീഷ് എം.എൽ.എ ക്യാമ്പ് ഉദ്ഘാടനകർമ്മം നിർവഹിച്ചു. നിംസ് മെഡിസിറ്റിയുടെ കാർഡിയോളജി,ഡയബറ്റോളജി, ജനറൽ മെഡിസിൻ,ദന്തൽ വിഭാഗങ്ങൾ പി. വി. എൽ. പി സ്കൂളിൽ വച്ച് നടന്ന മെഗാ ക്യാമ്പിൽ പങ്കെടുത്തു",
      thumb: "assets/img/Pastevents/5037.jpg",
    },
    {
      src: "assets/img/Pastevents/5038.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ ഗ്രീൻ സിറ്റി ലയൺസ്‌ ക്ലബ്ബിന്റെ ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ശ്രീ. ഐ ബി സതീഷ് എം.എൽ.എ ക്യാമ്പ് ഉദ്ഘാടനകർമ്മം നിർവഹിച്ചു. നിംസ് മെഡിസിറ്റിയുടെ കാർഡിയോളജി,ഡയബറ്റോളജി, ജനറൽ മെഡിസിൻ,ദന്തൽ വിഭാഗങ്ങൾ പി. വി. എൽ. പി സ്കൂളിൽ വച്ച് നടന്ന മെഗാ ക്യാമ്പിൽ പങ്കെടുത്തു",
      thumb: "assets/img/Pastevents/5038.jpg",
    },
    {
      src: "assets/img/Pastevents/5039.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ ഗ്രീൻ സിറ്റി ലയൺസ്‌ ക്ലബ്ബിന്റെ ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ശ്രീ. ഐ ബി സതീഷ് എം.എൽ.എ ക്യാമ്പ് ഉദ്ഘാടനകർമ്മം നിർവഹിച്ചു. നിംസ് മെഡിസിറ്റിയുടെ കാർഡിയോളജി,ഡയബറ്റോളജി, ജനറൽ മെഡിസിൻ,ദന്തൽ വിഭാഗങ്ങൾ പി. വി. എൽ. പി സ്കൂളിൽ വച്ച് നടന്ന മെഗാ ക്യാമ്പിൽ പങ്കെടുത്തു",
      thumb: "assets/img/Pastevents/5039.jpg",
    },
    {
      src: "assets/img/Pastevents/5040.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ ഗ്രീൻ സിറ്റി ലയൺസ്‌ ക്ലബ്ബിന്റെ ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ശ്രീ. ഐ ബി സതീഷ് എം.എൽ.എ ക്യാമ്പ് ഉദ്ഘാടനകർമ്മം നിർവഹിച്ചു. നിംസ് മെഡിസിറ്റിയുടെ കാർഡിയോളജി,ഡയബറ്റോളജി, ജനറൽ മെഡിസിൻ,ദന്തൽ വിഭാഗങ്ങൾ പി. വി. എൽ. പി സ്കൂളിൽ വച്ച് നടന്ന മെഗാ ക്യാമ്പിൽ പങ്കെടുത്തു",
      thumb: "assets/img/Pastevents/5040.jpg",
    },
    {
      src: "assets/img/Pastevents/5041.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ ഗ്രീൻ സിറ്റി ലയൺസ്‌ ക്ലബ്ബിന്റെ ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ശ്രീ. ഐ ബി സതീഷ് എം.എൽ.എ ക്യാമ്പ് ഉദ്ഘാടനകർമ്മം നിർവഹിച്ചു. നിംസ് മെഡിസിറ്റിയുടെ കാർഡിയോളജി,ഡയബറ്റോളജി, ജനറൽ മെഡിസിൻ,ദന്തൽ വിഭാഗങ്ങൾ പി. വി. എൽ. പി സ്കൂളിൽ വച്ച് നടന്ന മെഗാ ക്യാമ്പിൽ പങ്കെടുത്തു",
      thumb: "assets/img/Pastevents/5041.jpg",
    },
    {
      src: "assets/img/Pastevents/5042.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ ഗ്രീൻ സിറ്റി ലയൺസ്‌ ക്ലബ്ബിന്റെ ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ശ്രീ. ഐ ബി സതീഷ് എം.എൽ.എ ക്യാമ്പ് ഉദ്ഘാടനകർമ്മം നിർവഹിച്ചു. നിംസ് മെഡിസിറ്റിയുടെ കാർഡിയോളജി,ഡയബറ്റോളജി, ജനറൽ മെഡിസിൻ,ദന്തൽ വിഭാഗങ്ങൾ പി. വി. എൽ. പി സ്കൂളിൽ വച്ച് നടന്ന മെഗാ ക്യാമ്പിൽ പങ്കെടുത്തു",
      thumb: "assets/img/Pastevents/5042.jpg",
    },
    {
      src: "assets/img/Pastevents/504.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ ഗ്രീൻ സിറ്റി ലയൺസ്‌ ക്ലബ്ബിന്റെ ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ശ്രീ. ഐ ബി സതീഷ് എം.എൽ.എ ക്യാമ്പ് ഉദ്ഘാടനകർമ്മം നിർവഹിച്ചു. നിംസ് മെഡിസിറ്റിയുടെ കാർഡിയോളജി,ഡയബറ്റോളജി, ജനറൽ മെഡിസിൻ,ദന്തൽ വിഭാഗങ്ങൾ പി. വി. എൽ. പി സ്കൂളിൽ വച്ച് നടന്ന മെഗാ ക്യാമ്പിൽ പങ്കെടുത്തു",
      thumb: "assets/img/Pastevents/504.jpg",
    },
    {
      src: "assets/img/Pastevents/5043.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ ഗ്രീൻ സിറ്റി ലയൺസ്‌ ക്ലബ്ബിന്റെ ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ശ്രീ. ഐ ബി സതീഷ് എം.എൽ.എ ക്യാമ്പ് ഉദ്ഘാടനകർമ്മം നിർവഹിച്ചു. നിംസ് മെഡിസിറ്റിയുടെ കാർഡിയോളജി,ഡയബറ്റോളജി, ജനറൽ മെഡിസിൻ,ദന്തൽ വിഭാഗങ്ങൾ പി. വി. എൽ. പി സ്കൂളിൽ വച്ച് നടന്ന മെഗാ ക്യാമ്പിൽ പങ്കെടുത്തു",
      thumb: "assets/img/Pastevents/5043.jpg",
    },
    {
      src: "assets/img/Pastevents/5044.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ ഗ്രീൻ സിറ്റി ലയൺസ്‌ ക്ലബ്ബിന്റെ ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ശ്രീ. ഐ ബി സതീഷ് എം.എൽ.എ ക്യാമ്പ് ഉദ്ഘാടനകർമ്മം നിർവഹിച്ചു. നിംസ് മെഡിസിറ്റിയുടെ കാർഡിയോളജി,ഡയബറ്റോളജി, ജനറൽ മെഡിസിൻ,ദന്തൽ വിഭാഗങ്ങൾ പി. വി. എൽ. പി സ്കൂളിൽ വച്ച് നടന്ന മെഗാ ക്യാമ്പിൽ പങ്കെടുത്തു",
      thumb: "assets/img/Pastevents/5044.jpg",
    },
    {
      src: "assets/img/Pastevents/5045.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ ഗ്രീൻ സിറ്റി ലയൺസ്‌ ക്ലബ്ബിന്റെ ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ശ്രീ. ഐ ബി സതീഷ് എം.എൽ.എ ക്യാമ്പ് ഉദ്ഘാടനകർമ്മം നിർവഹിച്ചു. നിംസ് മെഡിസിറ്റിയുടെ കാർഡിയോളജി,ഡയബറ്റോളജി, ജനറൽ മെഡിസിൻ,ദന്തൽ വിഭാഗങ്ങൾ പി. വി. എൽ. പി സ്കൂളിൽ വച്ച് നടന്ന മെഗാ ക്യാമ്പിൽ പങ്കെടുത്തു",
      thumb: "assets/img/Pastevents/5045.jpg",
    },
    {
      src: "assets/img/Pastevents/5046.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ ഗ്രീൻ സിറ്റി ലയൺസ്‌ ക്ലബ്ബിന്റെ ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ശ്രീ. ഐ ബി സതീഷ് എം.എൽ.എ ക്യാമ്പ് ഉദ്ഘാടനകർമ്മം നിർവഹിച്ചു. നിംസ് മെഡിസിറ്റിയുടെ കാർഡിയോളജി,ഡയബറ്റോളജി, ജനറൽ മെഡിസിൻ,ദന്തൽ വിഭാഗങ്ങൾ പി. വി. എൽ. പി സ്കൂളിൽ വച്ച് നടന്ന മെഗാ ക്യാമ്പിൽ പങ്കെടുത്തു",
      thumb: "assets/img/Pastevents/5046.jpg",
    },
    {
      src: "assets/img/Pastevents/5047.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ ഗ്രീൻ സിറ്റി ലയൺസ്‌ ക്ലബ്ബിന്റെ ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ശ്രീ. ഐ ബി സതീഷ് എം.എൽ.എ ക്യാമ്പ് ഉദ്ഘാടനകർമ്മം നിർവഹിച്ചു. നിംസ് മെഡിസിറ്റിയുടെ കാർഡിയോളജി,ഡയബറ്റോളജി, ജനറൽ മെഡിസിൻ,ദന്തൽ വിഭാഗങ്ങൾ പി. വി. എൽ. പി സ്കൂളിൽ വച്ച് നടന്ന മെഗാ ക്യാമ്പിൽ പങ്കെടുത്തു",
      thumb: "assets/img/Pastevents/5047.jpg",
    },
    {
      src: "assets/img/Pastevents/5048.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ ഗ്രീൻ സിറ്റി ലയൺസ്‌ ക്ലബ്ബിന്റെ ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ശ്രീ. ഐ ബി സതീഷ് എം.എൽ.എ ക്യാമ്പ് ഉദ്ഘാടനകർമ്മം നിർവഹിച്ചു. നിംസ് മെഡിസിറ്റിയുടെ കാർഡിയോളജി,ഡയബറ്റോളജി, ജനറൽ മെഡിസിൻ,ദന്തൽ വിഭാഗങ്ങൾ പി. വി. എൽ. പി സ്കൂളിൽ വച്ച് നടന്ന മെഗാ ക്യാമ്പിൽ പങ്കെടുത്തു",
      thumb: "assets/img/Pastevents/5048.jpg",
    },
    {
      src: "assets/img/Pastevents/5049.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ ഗ്രീൻ സിറ്റി ലയൺസ്‌ ക്ലബ്ബിന്റെ ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ശ്രീ. ഐ ബി സതീഷ് എം.എൽ.എ ക്യാമ്പ് ഉദ്ഘാടനകർമ്മം നിർവഹിച്ചു. നിംസ് മെഡിസിറ്റിയുടെ കാർഡിയോളജി,ഡയബറ്റോളജി, ജനറൽ മെഡിസിൻ,ദന്തൽ വിഭാഗങ്ങൾ പി. വി. എൽ. പി സ്കൂളിൽ വച്ച് നടന്ന മെഗാ ക്യാമ്പിൽ പങ്കെടുത്തു",
      thumb: "assets/img/Pastevents/5049.jpg",
    },
    {
      src: "assets/img/Pastevents/5020.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ ഗ്ലോബൽ വെൽഫയർ ഫൗണ്ടേഷൻ ഓഫ് ഇന്ത്യ വേൾഡ് ഫോറം, വെള്ളയമ്പലം ടി എം സി ഇൻസ്റ്റിറ്റ്യൂട്ട് എന്നിവയുടെ സംയുക്താഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. വള്ളക്കടവ് മദ്രസ ഹാളിൽ ക്രമീകരിച്ച മെഡിക്കൽ ക്യാമ്പിന്റെ ഉദ്ഘാടനം വാർഡ് കൗൺസിലർ ശ്രീമതി. ഷാജിത നാസർ നിർവഹിച്ചു.ശ്രീ പനച്ചമൂട് ഷാജഹാൻ ആമുഖ പ്രസംഗം നടത്തി. നിംസ് മെഡിസിറ്റിയുടെ കാർഡിയോളജി,ഡയബറ്റോളജി, നേത്രരോഗ വിഭാഗം,ദന്തൽ,ജനറൽ മെഡിസിൻ എന്നീ വിഭാഗങ്ങൾ ഉൾപ്പെടുത്തി നടത്തിയ ക്യാമ്പിൽ അനേകം പേർ പങ്കെടുത്തു",
      thumb: "assets/img/Pastevents/5020.jpg",
    },
    {
      src: "assets/img/Pastevents/5021.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ ഗ്ലോബൽ വെൽഫയർ ഫൗണ്ടേഷൻ ഓഫ് ഇന്ത്യ വേൾഡ് ഫോറം, വെള്ളയമ്പലം ടി എം സി ഇൻസ്റ്റിറ്റ്യൂട്ട് എന്നിവയുടെ സംയുക്താഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. വള്ളക്കടവ് മദ്രസ ഹാളിൽ ക്രമീകരിച്ച മെഡിക്കൽ ക്യാമ്പിന്റെ ഉദ്ഘാടനം വാർഡ് കൗൺസിലർ ശ്രീമതി. ഷാജിത നാസർ നിർവഹിച്ചു.ശ്രീ പനച്ചമൂട് ഷാജഹാൻ ആമുഖ പ്രസംഗം നടത്തി. നിംസ് മെഡിസിറ്റിയുടെ കാർഡിയോളജി,ഡയബറ്റോളജി, നേത്രരോഗ വിഭാഗം,ദന്തൽ,ജനറൽ മെഡിസിൻ എന്നീ വിഭാഗങ്ങൾ ഉൾപ്പെടുത്തി നടത്തിയ ക്യാമ്പിൽ അനേകം പേർ പങ്കെടുത്തു",
      thumb: "assets/img/Pastevents/5021.jpg",
    },
    {
      src: "assets/img/Pastevents/5022.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ ഗ്ലോബൽ വെൽഫയർ ഫൗണ്ടേഷൻ ഓഫ് ഇന്ത്യ വേൾഡ് ഫോറം, വെള്ളയമ്പലം ടി എം സി ഇൻസ്റ്റിറ്റ്യൂട്ട് എന്നിവയുടെ സംയുക്താഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. വള്ളക്കടവ് മദ്രസ ഹാളിൽ ക്രമീകരിച്ച മെഡിക്കൽ ക്യാമ്പിന്റെ ഉദ്ഘാടനം വാർഡ് കൗൺസിലർ ശ്രീമതി. ഷാജിത നാസർ നിർവഹിച്ചു.ശ്രീ പനച്ചമൂട് ഷാജഹാൻ ആമുഖ പ്രസംഗം നടത്തി. നിംസ് മെഡിസിറ്റിയുടെ കാർഡിയോളജി,ഡയബറ്റോളജി, നേത്രരോഗ വിഭാഗം,ദന്തൽ,ജനറൽ മെഡിസിൻ എന്നീ വിഭാഗങ്ങൾ ഉൾപ്പെടുത്തി നടത്തിയ ക്യാമ്പിൽ അനേകം പേർ പങ്കെടുത്തു",
      thumb: "assets/img/Pastevents/5022.jpg",
    },
    {
      src: "assets/img/Pastevents/5023.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ ഗ്ലോബൽ വെൽഫയർ ഫൗണ്ടേഷൻ ഓഫ് ഇന്ത്യ വേൾഡ് ഫോറം, വെള്ളയമ്പലം ടി എം സി ഇൻസ്റ്റിറ്റ്യൂട്ട് എന്നിവയുടെ സംയുക്താഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. വള്ളക്കടവ് മദ്രസ ഹാളിൽ ക്രമീകരിച്ച മെഡിക്കൽ ക്യാമ്പിന്റെ ഉദ്ഘാടനം വാർഡ് കൗൺസിലർ ശ്രീമതി. ഷാജിത നാസർ നിർവഹിച്ചു.ശ്രീ പനച്ചമൂട് ഷാജഹാൻ ആമുഖ പ്രസംഗം നടത്തി. നിംസ് മെഡിസിറ്റിയുടെ കാർഡിയോളജി,ഡയബറ്റോളജി, നേത്രരോഗ വിഭാഗം,ദന്തൽ,ജനറൽ മെഡിസിൻ എന്നീ വിഭാഗങ്ങൾ ഉൾപ്പെടുത്തി നടത്തിയ ക്യാമ്പിൽ അനേകം പേർ പങ്കെടുത്തു",
      thumb: "assets/img/Pastevents/5023.jpg",
    },
    {
      src: "assets/img/Pastevents/5024.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ ഗ്ലോബൽ വെൽഫയർ ഫൗണ്ടേഷൻ ഓഫ് ഇന്ത്യ വേൾഡ് ഫോറം, വെള്ളയമ്പലം ടി എം സി ഇൻസ്റ്റിറ്റ്യൂട്ട് എന്നിവയുടെ സംയുക്താഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. വള്ളക്കടവ് മദ്രസ ഹാളിൽ ക്രമീകരിച്ച മെഡിക്കൽ ക്യാമ്പിന്റെ ഉദ്ഘാടനം വാർഡ് കൗൺസിലർ ശ്രീമതി. ഷാജിത നാസർ നിർവഹിച്ചു.ശ്രീ പനച്ചമൂട് ഷാജഹാൻ ആമുഖ പ്രസംഗം നടത്തി. നിംസ് മെഡിസിറ്റിയുടെ കാർഡിയോളജി,ഡയബറ്റോളജി, നേത്രരോഗ വിഭാഗം,ദന്തൽ,ജനറൽ മെഡിസിൻ എന്നീ വിഭാഗങ്ങൾ ഉൾപ്പെടുത്തി നടത്തിയ ക്യാമ്പിൽ അനേകം പേർ പങ്കെടുത്തു",
      thumb: "assets/img/Pastevents/5024.jpg",
    },
    {
      src: "assets/img/Pastevents/5025.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ ഗ്ലോബൽ വെൽഫയർ ഫൗണ്ടേഷൻ ഓഫ് ഇന്ത്യ വേൾഡ് ഫോറം, വെള്ളയമ്പലം ടി എം സി ഇൻസ്റ്റിറ്റ്യൂട്ട് എന്നിവയുടെ സംയുക്താഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. വള്ളക്കടവ് മദ്രസ ഹാളിൽ ക്രമീകരിച്ച മെഡിക്കൽ ക്യാമ്പിന്റെ ഉദ്ഘാടനം വാർഡ് കൗൺസിലർ ശ്രീമതി. ഷാജിത നാസർ നിർവഹിച്ചു.ശ്രീ പനച്ചമൂട് ഷാജഹാൻ ആമുഖ പ്രസംഗം നടത്തി. നിംസ് മെഡിസിറ്റിയുടെ കാർഡിയോളജി,ഡയബറ്റോളജി, നേത്രരോഗ വിഭാഗം,ദന്തൽ,ജനറൽ മെഡിസിൻ എന്നീ വിഭാഗങ്ങൾ ഉൾപ്പെടുത്തി നടത്തിയ ക്യാമ്പിൽ അനേകം പേർ പങ്കെടുത്തു",
      thumb: "assets/img/Pastevents/5025.jpg",
    },
    {
      src: "assets/img/Pastevents/5026.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ ഗ്ലോബൽ വെൽഫയർ ഫൗണ്ടേഷൻ ഓഫ് ഇന്ത്യ വേൾഡ് ഫോറം, വെള്ളയമ്പലം ടി എം സി ഇൻസ്റ്റിറ്റ്യൂട്ട് എന്നിവയുടെ സംയുക്താഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. വള്ളക്കടവ് മദ്രസ ഹാളിൽ ക്രമീകരിച്ച മെഡിക്കൽ ക്യാമ്പിന്റെ ഉദ്ഘാടനം വാർഡ് കൗൺസിലർ ശ്രീമതി. ഷാജിത നാസർ നിർവഹിച്ചു.ശ്രീ പനച്ചമൂട് ഷാജഹാൻ ആമുഖ പ്രസംഗം നടത്തി. നിംസ് മെഡിസിറ്റിയുടെ കാർഡിയോളജി,ഡയബറ്റോളജി, നേത്രരോഗ വിഭാഗം,ദന്തൽ,ജനറൽ മെഡിസിൻ എന്നീ വിഭാഗങ്ങൾ ഉൾപ്പെടുത്തി നടത്തിയ ക്യാമ്പിൽ അനേകം പേർ പങ്കെടുത്തു",
      thumb: "assets/img/Pastevents/5026.jpg",
    },
    {
      src: "assets/img/Pastevents/5027.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ ഗ്ലോബൽ വെൽഫയർ ഫൗണ്ടേഷൻ ഓഫ് ഇന്ത്യ വേൾഡ് ഫോറം, വെള്ളയമ്പലം ടി എം സി ഇൻസ്റ്റിറ്റ്യൂട്ട് എന്നിവയുടെ സംയുക്താഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. വള്ളക്കടവ് മദ്രസ ഹാളിൽ ക്രമീകരിച്ച മെഡിക്കൽ ക്യാമ്പിന്റെ ഉദ്ഘാടനം വാർഡ് കൗൺസിലർ ശ്രീമതി. ഷാജിത നാസർ നിർവഹിച്ചു.ശ്രീ പനച്ചമൂട് ഷാജഹാൻ ആമുഖ പ്രസംഗം നടത്തി. നിംസ് മെഡിസിറ്റിയുടെ കാർഡിയോളജി,ഡയബറ്റോളജി, നേത്രരോഗ വിഭാഗം,ദന്തൽ,ജനറൽ മെഡിസിൻ എന്നീ വിഭാഗങ്ങൾ ഉൾപ്പെടുത്തി നടത്തിയ ക്യാമ്പിൽ അനേകം പേർ പങ്കെടുത്തു",
      thumb: "assets/img/Pastevents/5027.jpg",
    },
    {
      src: "assets/img/Pastevents/5014.jpg",
      caption:
        "വെട്ടുകാട് മാദ്രെ ദെ ദേവൂസ് ദേവാലയ തിരുനാൾ ആഘോഷത്തോടനുബന്ധിച്ച്  നവംബർ 15 മുതൽ 24 വരെ നിംസ് മെഡിസിറ്റിയുടെ സൗജന്യ വൈദ്യ സഹായ ക്യാമ്പ്",
      thumb: "assets/img/Pastevents/5014.jpg",
    },
    {
      src: "assets/img/Pastevents/5015.jpg",
      caption:
        "വെട്ടുകാട് മാദ്രെ ദെ ദേവൂസ് ദേവാലയ തിരുനാൾ ആഘോഷത്തോടനുബന്ധിച്ച്  നവംബർ 15 മുതൽ 24 വരെ നിംസ് മെഡിസിറ്റിയുടെ സൗജന്യ വൈദ്യ സഹായ ക്യാമ്പ്",
      thumb: "assets/img/Pastevents/5015.jpg",
    },
    {
      src: "assets/img/Pastevents/5016.jpg",
      caption:
        "വെട്ടുകാട് മാദ്രെ ദെ ദേവൂസ് ദേവാലയ തിരുനാൾ ആഘോഷത്തോടനുബന്ധിച്ച്  നവംബർ 15 മുതൽ 24 വരെ നിംസ് മെഡിസിറ്റിയുടെ സൗജന്യ വൈദ്യ സഹായ ക്യാമ്പ്",
      thumb: "assets/img/Pastevents/5016.jpg",
    },
    {
      src: "assets/img/Pastevents/5017.jpg",
      caption:
        "വെട്ടുകാട് മാദ്രെ ദെ ദേവൂസ് ദേവാലയ തിരുനാൾ ആഘോഷത്തോടനുബന്ധിച്ച്  നവംബർ 15 മുതൽ 24 വരെ നിംസ് മെഡിസിറ്റിയുടെ സൗജന്യ വൈദ്യ സഹായ ക്യാമ്പ്",
      thumb: "assets/img/Pastevents/5017.jpg",
    },
    {
      src: "assets/img/Pastevents/5018.jpg",
      caption:
        "വെട്ടുകാട് മാദ്രെ ദെ ദേവൂസ് ദേവാലയ തിരുനാൾ ആഘോഷത്തോടനുബന്ധിച്ച്  നവംബർ 15 മുതൽ 24 വരെ നിംസ് മെഡിസിറ്റിയുടെ സൗജന്യ വൈദ്യ സഹായ ക്യാമ്പ്",
      thumb: "assets/img/Pastevents/5018.jpg",
    },
    {
      src: "assets/img/Pastevents/5019.jpg",
      caption:
        "വെട്ടുകാട് മാദ്രെ ദെ ദേവൂസ് ദേവാലയ തിരുനാൾ ആഘോഷത്തോടനുബന്ധിച്ച്  നവംബർ 15 മുതൽ 24 വരെ നിംസ് മെഡിസിറ്റിയുടെ സൗജന്യ വൈദ്യ സഹായ ക്യാമ്പ്",
      thumb: "assets/img/Pastevents/5019.jpg",
    },
    {
      src: "assets/img/Pastevents/5007.jpg",
      caption:
        "പേയാട് ലയൺസ്‌ ക്ലബിന്റെയും, നിംസ് മെഡിസിറ്റിയുടെയും  സംയുക്താഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു... നിംസ് മെഡിസിറ്റി കാർഡിയോളജി,ഡയബറ്റോളജി, ഒഫ്താൽമോളജി,ദന്തൽ തുടങ്ങി വിഭാഗങ്ങളിലെ വിദഗ്ധരായ ഡോക്ടർമാർ ക്യാമ്പിന് നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/5007.jpg",
    },
    {
      src: "assets/img/Pastevents/5008.jpg",
      caption:
        "പേയാട് ലയൺസ്‌ ക്ലബിന്റെയും, നിംസ് മെഡിസിറ്റിയുടെയും  സംയുക്താഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു... നിംസ് മെഡിസിറ്റി കാർഡിയോളജി,ഡയബറ്റോളജി, ഒഫ്താൽമോളജി,ദന്തൽ തുടങ്ങി വിഭാഗങ്ങളിലെ വിദഗ്ധരായ ഡോക്ടർമാർ ക്യാമ്പിന് നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/5008.jpg",
    },
    {
      src: "assets/img/Pastevents/5009.jpg",
      caption:
        "പേയാട് ലയൺസ്‌ ക്ലബിന്റെയും, നിംസ് മെഡിസിറ്റിയുടെയും  സംയുക്താഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു... നിംസ് മെഡിസിറ്റി കാർഡിയോളജി,ഡയബറ്റോളജി, ഒഫ്താൽമോളജി,ദന്തൽ തുടങ്ങി വിഭാഗങ്ങളിലെ വിദഗ്ധരായ ഡോക്ടർമാർ ക്യാമ്പിന് നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/5009.jpg",
    },
    {
      src: "assets/img/Pastevents/5010.jpg",
      caption:
        "പേയാട് ലയൺസ്‌ ക്ലബിന്റെയും, നിംസ് മെഡിസിറ്റിയുടെയും  സംയുക്താഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു... നിംസ് മെഡിസിറ്റി കാർഡിയോളജി,ഡയബറ്റോളജി, ഒഫ്താൽമോളജി,ദന്തൽ തുടങ്ങി വിഭാഗങ്ങളിലെ വിദഗ്ധരായ ഡോക്ടർമാർ ക്യാമ്പിന് നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/5010.jpg",
    },
    {
      src: "assets/img/Pastevents/5011.jpg",
      caption:
        "പേയാട് ലയൺസ്‌ ക്ലബിന്റെയും, നിംസ് മെഡിസിറ്റിയുടെയും  സംയുക്താഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു... നിംസ് മെഡിസിറ്റി കാർഡിയോളജി,ഡയബറ്റോളജി, ഒഫ്താൽമോളജി,ദന്തൽ തുടങ്ങി വിഭാഗങ്ങളിലെ വിദഗ്ധരായ ഡോക്ടർമാർ ക്യാമ്പിന് നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/5011.jpg",
    },
    {
      src: "assets/img/Pastevents/5012.jpg",
      caption:
        "പേയാട് ലയൺസ്‌ ക്ലബിന്റെയും, നിംസ് മെഡിസിറ്റിയുടെയും  സംയുക്താഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു... നിംസ് മെഡിസിറ്റി കാർഡിയോളജി,ഡയബറ്റോളജി, ഒഫ്താൽമോളജി,ദന്തൽ തുടങ്ങി വിഭാഗങ്ങളിലെ വിദഗ്ധരായ ഡോക്ടർമാർ ക്യാമ്പിന് നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/5012.jpg",
    },
    {
      src: "assets/img/Pastevents/5013.jpg",
      caption:
        "പേയാട് ലയൺസ്‌ ക്ലബിന്റെയും, നിംസ് മെഡിസിറ്റിയുടെയും  സംയുക്താഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു... നിംസ് മെഡിസിറ്റി കാർഡിയോളജി,ഡയബറ്റോളജി, ഒഫ്താൽമോളജി,ദന്തൽ തുടങ്ങി വിഭാഗങ്ങളിലെ വിദഗ്ധരായ ഡോക്ടർമാർ ക്യാമ്പിന് നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/5013.jpg",
    },
    {
      src: "assets/img/Pastevents/5002.jpeg",
      caption:
        "ശിശുദിനാഘോഷത്തോടനുബന്ധിച്ച് വിളപ്പിൽ പഞ്ചായത്തിലെ ഭിന്നശേഷി കുട്ടികൾക്കും നിംസ് മെഡിസിറ്റി പെൻഷൻ പ്ലാൻ ഗുണഭോക്താക്കൾക്കും വയോജനങ്ങൾക്കുമായി നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. വിളപ്പിൽ പഞ്ചായത്ത് പ്രസിഡൻ്റ് ശ്രീമതി.ലില്ലി മോഹൻ ഉദ്ഘാടനം ചെയ്ത പരിപാടിയിൽ ജനറൽ മെഡിസിൻ, ഒഫ്താൽമോളജി, ദന്തൽ, ഓഡിയോളജി എന്നീ വിഭാഗങ്ങളിലെ വിദഗ്ധരായ ഡോക്ടർമാരുടെ സേവനം ഉണ്ടായിരുന്നു.",
      thumb: "assets/img/Pastevents/5002.jpeg",
    },
    {
      src: "assets/img/Pastevents/5003.jpeg",
      caption:
        "ശിശുദിനാഘോഷത്തോടനുബന്ധിച്ച് വിളപ്പിൽ പഞ്ചായത്തിലെ ഭിന്നശേഷി കുട്ടികൾക്കും നിംസ് മെഡിസിറ്റി പെൻഷൻ പ്ലാൻ ഗുണഭോക്താക്കൾക്കും വയോജനങ്ങൾക്കുമായി നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. വിളപ്പിൽ പഞ്ചായത്ത് പ്രസിഡൻ്റ് ശ്രീമതി.ലില്ലി മോഹൻ ഉദ്ഘാടനം ചെയ്ത പരിപാടിയിൽ ജനറൽ മെഡിസിൻ, ഒഫ്താൽമോളജി, ദന്തൽ, ഓഡിയോളജി എന്നീ വിഭാഗങ്ങളിലെ വിദഗ്ധരായ ഡോക്ടർമാരുടെ സേവനം ഉണ്ടായിരുന്നു.",
      thumb: "assets/img/Pastevents/5003.jpeg",
    },
    {
      src: "assets/img/Pastevents/5004.jpeg",
      caption:
        "ശിശുദിനാഘോഷത്തോടനുബന്ധിച്ച് വിളപ്പിൽ പഞ്ചായത്തിലെ ഭിന്നശേഷി കുട്ടികൾക്കും നിംസ് മെഡിസിറ്റി പെൻഷൻ പ്ലാൻ ഗുണഭോക്താക്കൾക്കും വയോജനങ്ങൾക്കുമായി നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. വിളപ്പിൽ പഞ്ചായത്ത് പ്രസിഡൻ്റ് ശ്രീമതി.ലില്ലി മോഹൻ ഉദ്ഘാടനം ചെയ്ത പരിപാടിയിൽ ജനറൽ മെഡിസിൻ, ഒഫ്താൽമോളജി, ദന്തൽ, ഓഡിയോളജി എന്നീ വിഭാഗങ്ങളിലെ വിദഗ്ധരായ ഡോക്ടർമാരുടെ സേവനം ഉണ്ടായിരുന്നു.",
      thumb: "assets/img/Pastevents/5004.jpeg",
    },
    {
      src: "assets/img/Pastevents/5005.jpeg",
      caption:
        "ശിശുദിനാഘോഷത്തോടനുബന്ധിച്ച് വിളപ്പിൽ പഞ്ചായത്തിലെ ഭിന്നശേഷി കുട്ടികൾക്കും നിംസ് മെഡിസിറ്റി പെൻഷൻ പ്ലാൻ ഗുണഭോക്താക്കൾക്കും വയോജനങ്ങൾക്കുമായി നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. വിളപ്പിൽ പഞ്ചായത്ത് പ്രസിഡൻ്റ് ശ്രീമതി.ലില്ലി മോഹൻ ഉദ്ഘാടനം ചെയ്ത പരിപാടിയിൽ ജനറൽ മെഡിസിൻ, ഒഫ്താൽമോളജി, ദന്തൽ, ഓഡിയോളജി എന്നീ വിഭാഗങ്ങളിലെ വിദഗ്ധരായ ഡോക്ടർമാരുടെ സേവനം ഉണ്ടായിരുന്നു.",
      thumb: "assets/img/Pastevents/5005.jpeg",
    },
    {
      src: "assets/img/Pastevents/5006.jpeg",
      caption:
        "ശിശുദിനാഘോഷത്തോടനുബന്ധിച്ച് വിളപ്പിൽ പഞ്ചായത്തിലെ ഭിന്നശേഷി കുട്ടികൾക്കും നിംസ് മെഡിസിറ്റി പെൻഷൻ പ്ലാൻ ഗുണഭോക്താക്കൾക്കും വയോജനങ്ങൾക്കുമായി നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. വിളപ്പിൽ പഞ്ചായത്ത് പ്രസിഡൻ്റ് ശ്രീമതി.ലില്ലി മോഹൻ ഉദ്ഘാടനം ചെയ്ത പരിപാടിയിൽ ജനറൽ മെഡിസിൻ, ഒഫ്താൽമോളജി, ദന്തൽ, ഓഡിയോളജി എന്നീ വിഭാഗങ്ങളിലെ വിദഗ്ധരായ ഡോക്ടർമാരുടെ സേവനം ഉണ്ടായിരുന്നു.",
      thumb: "assets/img/Pastevents/5006.jpeg",
    },
    {
      src: "assets/img/Pastevents/4997.jpeg",
      caption:
        "ശിശുദിനത്തോടനുബന്ധിച്ച് കുട്ടികൾക്കായി സൗജന്യ ദന്തൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. വെങ്ങാനൂർ VPS മലങ്കര ഹയർ സെക്കൻഡറി സ്കൂളിലെ വിദ്യാർത്ഥികൾക്കായി നിംസ് കോളേജ് ഓഫ് ദന്തൽ  സയൻസിന്റെ  ആഭിമുഖ്യത്തിൽ സൗജന്യ ദന്തൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/4997.jpeg",
    },
    {
      src: "assets/img/Pastevents/4998.jpeg",
      caption:
        "ശിശുദിനത്തോടനുബന്ധിച്ച് കുട്ടികൾക്കായി സൗജന്യ ദന്തൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. വെങ്ങാനൂർ VPS മലങ്കര ഹയർ സെക്കൻഡറി സ്കൂളിലെ വിദ്യാർത്ഥികൾക്കായി നിംസ് കോളേജ് ഓഫ് ദന്തൽ  സയൻസിന്റെ  ആഭിമുഖ്യത്തിൽ സൗജന്യ ദന്തൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/4998.jpeg",
    },
    {
      src: "assets/img/Pastevents/4999.jpeg",
      caption:
        "ശിശുദിനത്തോടനുബന്ധിച്ച് കുട്ടികൾക്കായി സൗജന്യ ദന്തൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. വെങ്ങാനൂർ VPS മലങ്കര ഹയർ സെക്കൻഡറി സ്കൂളിലെ വിദ്യാർത്ഥികൾക്കായി നിംസ് കോളേജ് ഓഫ് ദന്തൽ  സയൻസിന്റെ  ആഭിമുഖ്യത്തിൽ സൗജന്യ ദന്തൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/4999.jpeg",
    },
    {
      src: "assets/img/Pastevents/5000.jpeg",
      caption:
        "ശിശുദിനത്തോടനുബന്ധിച്ച് കുട്ടികൾക്കായി സൗജന്യ ദന്തൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. വെങ്ങാനൂർ VPS മലങ്കര ഹയർ സെക്കൻഡറി സ്കൂളിലെ വിദ്യാർത്ഥികൾക്കായി നിംസ് കോളേജ് ഓഫ് ദന്തൽ  സയൻസിന്റെ  ആഭിമുഖ്യത്തിൽ സൗജന്യ ദന്തൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/5000.jpg",
    },
    {
      src: "assets/img/Pastevents/5001.jpg",
      caption:
        "ശിശുദിനത്തോടനുബന്ധിച്ച് കുട്ടികൾക്കായി സൗജന്യ ദന്തൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. വെങ്ങാനൂർ VPS മലങ്കര ഹയർ സെക്കൻഡറി സ്കൂളിലെ വിദ്യാർത്ഥികൾക്കായി നിംസ് കോളേജ് ഓഫ് ദന്തൽ  സയൻസിന്റെ  ആഭിമുഖ്യത്തിൽ സൗജന്യ ദന്തൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/5001.jpeg",
    },
    {
      src: "assets/img/Pastevents/4991.jpeg",
      caption:
        "",
      thumb: "assets/img/Pastevents/4991.jpeg",
    },
    {
      src: "assets/img/Pastevents/4992.jpeg",
      caption:
        "",
      thumb: "assets/img/Pastevents/4992.jpeg",
    },
    {
      src: "assets/img/Pastevents/4993.jpeg",
      caption:
        "",
      thumb: "assets/img/Pastevents/4993.jpeg",
    },
    {
      src: "assets/img/Pastevents/4994.jpeg",
      caption:
        "",
      thumb: "assets/img/Pastevents/4994.jpeg",
    },
    {
      src: "assets/img/Pastevents/4995.jpeg",
      caption:
        "",
      thumb: "assets/img/Pastevents/4995.jpeg",
    },
    {
      src: "assets/img/Pastevents/4996.jpeg",
      caption:
        "",
      thumb: "assets/img/Pastevents/4996.jpeg",
    },
    {
      src: "assets/img/Pastevents/4983.jpg",
      caption:
        "പോത്തൻകോട് നിസാമിയ പബ്ലിക് സ്കൂളിന്റെ വാർഷികാഘോഷത്തോടനുബന്ധിച്ച് കുട്ടികൾക്കും , രക്ഷിതാക്കൾക്കും പൊതുജനങ്ങൾക്കും വേണ്ടി നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽസൗജന്യ മെഡിക്കൽ  ക്യാമ്പ് സംഘടിപ്പിച്ചു . നിംസ് മെഡിസിറ്റിയുടെ വിദഗ്ദ്ധരായ ഡോക്ടർമാരുടെ നേതൃത്വത്തിൽ നടന്ന  ക്യാമ്പിൽ നിരവധി  പേർ പങ്കെടുത്തു",
      thumb: "assets/img/Pastevents/4983.jpg",
    },
    {
      src: "assets/img/Pastevents/4984.jpg",
      caption:
        "പോത്തൻകോട് നിസാമിയ പബ്ലിക് സ്കൂളിന്റെ വാർഷികാഘോഷത്തോടനുബന്ധിച്ച് കുട്ടികൾക്കും , രക്ഷിതാക്കൾക്കും പൊതുജനങ്ങൾക്കും വേണ്ടി നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽസൗജന്യ മെഡിക്കൽ  ക്യാമ്പ് സംഘടിപ്പിച്ചു . നിംസ് മെഡിസിറ്റിയുടെ വിദഗ്ദ്ധരായ ഡോക്ടർമാരുടെ നേതൃത്വത്തിൽ നടന്ന  ക്യാമ്പിൽ നിരവധി  പേർ പങ്കെടുത്തു",
      thumb: "assets/img/Pastevents/4984.jpg",
    },
    {
      src: "assets/img/Pastevents/4985.jpg",
      caption:
        "പോത്തൻകോട് നിസാമിയ പബ്ലിക് സ്കൂളിന്റെ വാർഷികാഘോഷത്തോടനുബന്ധിച്ച് കുട്ടികൾക്കും , രക്ഷിതാക്കൾക്കും പൊതുജനങ്ങൾക്കും വേണ്ടി നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽസൗജന്യ മെഡിക്കൽ  ക്യാമ്പ് സംഘടിപ്പിച്ചു . നിംസ് മെഡിസിറ്റിയുടെ വിദഗ്ദ്ധരായ ഡോക്ടർമാരുടെ നേതൃത്വത്തിൽ നടന്ന  ക്യാമ്പിൽ നിരവധി  പേർ പങ്കെടുത്തു",
      thumb: "assets/img/Pastevents/4985.jpg",
    },
    {
      src: "assets/img/Pastevents/4986.jpg",
      caption:
        "പോത്തൻകോട് നിസാമിയ പബ്ലിക് സ്കൂളിന്റെ വാർഷികാഘോഷത്തോടനുബന്ധിച്ച് കുട്ടികൾക്കും , രക്ഷിതാക്കൾക്കും പൊതുജനങ്ങൾക്കും വേണ്ടി നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽസൗജന്യ മെഡിക്കൽ  ക്യാമ്പ് സംഘടിപ്പിച്ചു . നിംസ് മെഡിസിറ്റിയുടെ വിദഗ്ദ്ധരായ ഡോക്ടർമാരുടെ നേതൃത്വത്തിൽ നടന്ന  ക്യാമ്പിൽ നിരവധി  പേർ പങ്കെടുത്തു",
      thumb: "assets/img/Pastevents/4986.jpg",
    },
    {
      src: "assets/img/Pastevents/4987.jpg",
      caption:
        "പോത്തൻകോട് നിസാമിയ പബ്ലിക് സ്കൂളിന്റെ വാർഷികാഘോഷത്തോടനുബന്ധിച്ച് കുട്ടികൾക്കും , രക്ഷിതാക്കൾക്കും പൊതുജനങ്ങൾക്കും വേണ്ടി നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽസൗജന്യ മെഡിക്കൽ  ക്യാമ്പ് സംഘടിപ്പിച്ചു . നിംസ് മെഡിസിറ്റിയുടെ വിദഗ്ദ്ധരായ ഡോക്ടർമാരുടെ നേതൃത്വത്തിൽ നടന്ന  ക്യാമ്പിൽ നിരവധി  പേർ പങ്കെടുത്തു",
      thumb: "assets/img/Pastevents/4987.jpg",
    },
    {
      src: "assets/img/Pastevents/4988.jpg",
      caption:
        "പോത്തൻകോട് നിസാമിയ പബ്ലിക് സ്കൂളിന്റെ വാർഷികാഘോഷത്തോടനുബന്ധിച്ച് കുട്ടികൾക്കും , രക്ഷിതാക്കൾക്കും പൊതുജനങ്ങൾക്കും വേണ്ടി നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽസൗജന്യ മെഡിക്കൽ  ക്യാമ്പ് സംഘടിപ്പിച്ചു . നിംസ് മെഡിസിറ്റിയുടെ വിദഗ്ദ്ധരായ ഡോക്ടർമാരുടെ നേതൃത്വത്തിൽ നടന്ന  ക്യാമ്പിൽ നിരവധി  പേർ പങ്കെടുത്തു",
      thumb: "assets/img/Pastevents/4988.jpg",
    },
    {
      src: "assets/img/Pastevents/4989.jpg",
      caption:
        "പോത്തൻകോട് നിസാമിയ പബ്ലിക് സ്കൂളിന്റെ വാർഷികാഘോഷത്തോടനുബന്ധിച്ച് കുട്ടികൾക്കും , രക്ഷിതാക്കൾക്കും പൊതുജനങ്ങൾക്കും വേണ്ടി നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽസൗജന്യ മെഡിക്കൽ  ക്യാമ്പ് സംഘടിപ്പിച്ചു . നിംസ് മെഡിസിറ്റിയുടെ വിദഗ്ദ്ധരായ ഡോക്ടർമാരുടെ നേതൃത്വത്തിൽ നടന്ന  ക്യാമ്പിൽ നിരവധി  പേർ പങ്കെടുത്തു",
      thumb: "assets/img/Pastevents/4989.jpg",
    },
    {
      src: "assets/img/Pastevents/4990.jpg",
      caption:
        "പോത്തൻകോട് നിസാമിയ പബ്ലിക് സ്കൂളിന്റെ വാർഷികാഘോഷത്തോടനുബന്ധിച്ച് കുട്ടികൾക്കും , രക്ഷിതാക്കൾക്കും പൊതുജനങ്ങൾക്കും വേണ്ടി നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽസൗജന്യ മെഡിക്കൽ  ക്യാമ്പ് സംഘടിപ്പിച്ചു . നിംസ് മെഡിസിറ്റിയുടെ വിദഗ്ദ്ധരായ ഡോക്ടർമാരുടെ നേതൃത്വത്തിൽ നടന്ന  ക്യാമ്പിൽ നിരവധി  പേർ പങ്കെടുത്തു",
      thumb: "assets/img/Pastevents/4990.jpg",
    },
    {
      src: "assets/img/Pastevents/4974.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ ആറ്റിങ്ങൽ പാലസ് ലയൺസ് ക്ലബിന്റെയും , ശ്രീ ചിത്തിര തിരുനാൾ റസിഡൻസ് അസോസിയേഷന്റെയും  സംയുക്താഭിമുഖ്യത്തിൽ സൗജന്യ പ്രമേഹരോഗനിർണ്ണയവും മെഡിക്കൽ ക്യാമ്പും നടത്തുകയുണ്ടായി",
      thumb: "assets/img/Pastevents/4974.jpg",
    },
    {
      src: "assets/img/Pastevents/4975.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ ആറ്റിങ്ങൽ പാലസ് ലയൺസ് ക്ലബിന്റെയും , ശ്രീ ചിത്തിര തിരുനാൾ റസിഡൻസ് അസോസിയേഷന്റെയും  സംയുക്താഭിമുഖ്യത്തിൽ സൗജന്യ പ്രമേഹരോഗനിർണ്ണയവും മെഡിക്കൽ ക്യാമ്പും നടത്തുകയുണ്ടായി",
      thumb: "assets/img/Pastevents/4975.jpg",
    },
    {
      src: "assets/img/Pastevents/4976.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ ആറ്റിങ്ങൽ പാലസ് ലയൺസ് ക്ലബിന്റെയും , ശ്രീ ചിത്തിര തിരുനാൾ റസിഡൻസ് അസോസിയേഷന്റെയും  സംയുക്താഭിമുഖ്യത്തിൽ സൗജന്യ പ്രമേഹരോഗനിർണ്ണയവും മെഡിക്കൽ ക്യാമ്പും നടത്തുകയുണ്ടായി",
      thumb: "assets/img/Pastevents/4976.jpg",
    },
    {
      src: "assets/img/Pastevents/4977.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ ആറ്റിങ്ങൽ പാലസ് ലയൺസ് ക്ലബിന്റെയും , ശ്രീ ചിത്തിര തിരുനാൾ റസിഡൻസ് അസോസിയേഷന്റെയും  സംയുക്താഭിമുഖ്യത്തിൽ സൗജന്യ പ്രമേഹരോഗനിർണ്ണയവും മെഡിക്കൽ ക്യാമ്പും നടത്തുകയുണ്ടായി",
      thumb: "assets/img/Pastevents/4977.jpg",
    },
    {
      src: "assets/img/Pastevents/4978.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ ആറ്റിങ്ങൽ പാലസ് ലയൺസ് ക്ലബിന്റെയും , ശ്രീ ചിത്തിര തിരുനാൾ റസിഡൻസ് അസോസിയേഷന്റെയും  സംയുക്താഭിമുഖ്യത്തിൽ സൗജന്യ പ്രമേഹരോഗനിർണ്ണയവും മെഡിക്കൽ ക്യാമ്പും നടത്തുകയുണ്ടായി",
      thumb: "assets/img/Pastevents/4978.jpg",
    },
    {
      src: "assets/img/Pastevents/4979.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ ആറ്റിങ്ങൽ പാലസ് ലയൺസ് ക്ലബിന്റെയും , ശ്രീ ചിത്തിര തിരുനാൾ റസിഡൻസ് അസോസിയേഷന്റെയും  സംയുക്താഭിമുഖ്യത്തിൽ സൗജന്യ പ്രമേഹരോഗനിർണ്ണയവും മെഡിക്കൽ ക്യാമ്പും നടത്തുകയുണ്ടായി",
      thumb: "assets/img/Pastevents/4979.jpg",
    },
    {
      src: "assets/img/Pastevents/4980.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ ആറ്റിങ്ങൽ പാലസ് ലയൺസ് ക്ലബിന്റെയും , ശ്രീ ചിത്തിര തിരുനാൾ റസിഡൻസ് അസോസിയേഷന്റെയും  സംയുക്താഭിമുഖ്യത്തിൽ സൗജന്യ പ്രമേഹരോഗനിർണ്ണയവും മെഡിക്കൽ ക്യാമ്പും നടത്തുകയുണ്ടായി",
      thumb: "assets/img/Pastevents/4980.jpg",
    },
    {
      src: "assets/img/Pastevents/4981.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ ആറ്റിങ്ങൽ പാലസ് ലയൺസ് ക്ലബിന്റെയും , ശ്രീ ചിത്തിര തിരുനാൾ റസിഡൻസ് അസോസിയേഷന്റെയും  സംയുക്താഭിമുഖ്യത്തിൽ സൗജന്യ പ്രമേഹരോഗനിർണ്ണയവും മെഡിക്കൽ ക്യാമ്പും നടത്തുകയുണ്ടായി",
      thumb: "assets/img/Pastevents/4981.jpg",
    },
    {
      src: "assets/img/Pastevents/4982.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ ആറ്റിങ്ങൽ പാലസ് ലയൺസ് ക്ലബിന്റെയും , ശ്രീ ചിത്തിര തിരുനാൾ റസിഡൻസ് അസോസിയേഷന്റെയും  സംയുക്താഭിമുഖ്യത്തിൽ സൗജന്യ പ്രമേഹരോഗനിർണ്ണയവും മെഡിക്കൽ ക്യാമ്പും നടത്തുകയുണ്ടായി",
      thumb: "assets/img/Pastevents/4982.jpg",
    },
    {
      src: "assets/img/Pastevents/4967.jpg",
      caption:
        "ഇ എൻ ടി വിഭാഗത്തിലെ വിദഗ്ധ ഡോക്ടർമാരായ ഡോ. നയൻതാര രമേഷ്, ഡോ. ആശ കുമാർ, ഡോ. മുരളീധരൻ, ഡോ. ഐശ്വര്യ എസ് ഗോപൻ, ഡോ. സാനി ബിനു കുട്ടൻ എന്നിവരുടെ നേതൃത്വത്തിലായിരുന്നു ക്യാമ്പ് സംഘടിപ്പിച്ചത്.200 ലധികം പേർ ക്യാമ്പിൽ പങ്കെടുത്തു",
      thumb: "assets/img/Pastevents/4967.jpg",
    },
    {
      src: "assets/img/Pastevents/4968.jpg",
      caption:
        "ഇ എൻ ടി വിഭാഗത്തിലെ വിദഗ്ധ ഡോക്ടർമാരായ ഡോ. നയൻതാര രമേഷ്, ഡോ. ആശ കുമാർ, ഡോ. മുരളീധരൻ, ഡോ. ഐശ്വര്യ എസ് ഗോപൻ, ഡോ. സാനി ബിനു കുട്ടൻ എന്നിവരുടെ നേതൃത്വത്തിലായിരുന്നു ക്യാമ്പ് സംഘടിപ്പിച്ചത്.200 ലധികം പേർ ക്യാമ്പിൽ പങ്കെടുത്തു",
      thumb: "assets/img/Pastevents/4968.jpg",
    },
    {
      src: "assets/img/Pastevents/4969.jpg",
      caption:
        "ഇ എൻ ടി വിഭാഗത്തിലെ വിദഗ്ധ ഡോക്ടർമാരായ ഡോ. നയൻതാര രമേഷ്, ഡോ. ആശ കുമാർ, ഡോ. മുരളീധരൻ, ഡോ. ഐശ്വര്യ എസ് ഗോപൻ, ഡോ. സാനി ബിനു കുട്ടൻ എന്നിവരുടെ നേതൃത്വത്തിലായിരുന്നു ക്യാമ്പ് സംഘടിപ്പിച്ചത്.200 ലധികം പേർ ക്യാമ്പിൽ പങ്കെടുത്തു",
      thumb: "assets/img/Pastevents/4969.jpg",
    },
    {
      src: "assets/img/Pastevents/4970.jpg",
      caption:
        "ഇ എൻ ടി വിഭാഗത്തിലെ വിദഗ്ധ ഡോക്ടർമാരായ ഡോ. നയൻതാര രമേഷ്, ഡോ. ആശ കുമാർ, ഡോ. മുരളീധരൻ, ഡോ. ഐശ്വര്യ എസ് ഗോപൻ, ഡോ. സാനി ബിനു കുട്ടൻ എന്നിവരുടെ നേതൃത്വത്തിലായിരുന്നു ക്യാമ്പ് സംഘടിപ്പിച്ചത്.200 ലധികം പേർ ക്യാമ്പിൽ പങ്കെടുത്തു",
      thumb: "assets/img/Pastevents/4970.jpg",
    },
    {
      src: "assets/img/Pastevents/4971.jpg",
      caption:
        "ഇ എൻ ടി വിഭാഗത്തിലെ വിദഗ്ധ ഡോക്ടർമാരായ ഡോ. നയൻതാര രമേഷ്, ഡോ. ആശ കുമാർ, ഡോ. മുരളീധരൻ, ഡോ. ഐശ്വര്യ എസ് ഗോപൻ, ഡോ. സാനി ബിനു കുട്ടൻ എന്നിവരുടെ നേതൃത്വത്തിലായിരുന്നു ക്യാമ്പ് സംഘടിപ്പിച്ചത്.200 ലധികം പേർ ക്യാമ്പിൽ പങ്കെടുത്തു",
      thumb: "assets/img/Pastevents/4971.jpg",
    },
    {
      src: "assets/img/Pastevents/4972.jpg",
      caption:
        "ഇ എൻ ടി വിഭാഗത്തിലെ വിദഗ്ധ ഡോക്ടർമാരായ ഡോ. നയൻതാര രമേഷ്, ഡോ. ആശ കുമാർ, ഡോ. മുരളീധരൻ, ഡോ. ഐശ്വര്യ എസ് ഗോപൻ, ഡോ. സാനി ബിനു കുട്ടൻ എന്നിവരുടെ നേതൃത്വത്തിലായിരുന്നു ക്യാമ്പ് സംഘടിപ്പിച്ചത്.200 ലധികം പേർ ക്യാമ്പിൽ പങ്കെടുത്തു",
      thumb: "assets/img/Pastevents/4972.jpg",
    },
    {
      src: "assets/img/Pastevents/4973.jpg",
      caption:
        "ഇ എൻ ടി വിഭാഗത്തിലെ വിദഗ്ധ ഡോക്ടർമാരായ ഡോ. നയൻതാര രമേഷ്, ഡോ. ആശ കുമാർ, ഡോ. മുരളീധരൻ, ഡോ. ഐശ്വര്യ എസ് ഗോപൻ, ഡോ. സാനി ബിനു കുട്ടൻ എന്നിവരുടെ നേതൃത്വത്തിലായിരുന്നു ക്യാമ്പ് സംഘടിപ്പിച്ചത്.200 ലധികം പേർ ക്യാമ്പിൽ പങ്കെടുത്തു",
      thumb: "assets/img/Pastevents/4973.jpg",
    },
    {
      src: "assets/img/Pastevents/4958.jpg",
      caption:
        "ശ്രീ ലളിതായനം ട്രസ്റ്റും കൈലാസം ശ്രീശക്തി ഗണപതി ക്ഷേത്ര സമിതിയും നിംസ് മെഡിസിറ്റിയും , നിംസ് മൈക്രോ ഹോസ്പിറ്റൽസ് & വത്സല നഴ്സിംഗ് ഹോമും സംയുക്തമായി നടത്തിയ മെഗാ മെഡിക്കൽ ക്യാമ്പ് കിളിമാനൂർ ഗ്രാമ പഞ്ചായത്ത് പ്രസിഡൻറ് ശ്രീ. ടി. ആർ. മനോജ് ഉദ്ഘാടനം ചെയ്തു.",
      thumb: "assets/img/Pastevents/4958.jpg",
    },
    {
      src: "assets/img/Pastevents/4959.jpg",
      caption:
        "ശ്രീ ലളിതായനം ട്രസ്റ്റും കൈലാസം ശ്രീശക്തി ഗണപതി ക്ഷേത്ര സമിതിയും നിംസ് മെഡിസിറ്റിയും , നിംസ് മൈക്രോ ഹോസ്പിറ്റൽസ് & വത്സല നഴ്സിംഗ് ഹോമും സംയുക്തമായി നടത്തിയ മെഗാ മെഡിക്കൽ ക്യാമ്പ് കിളിമാനൂർ ഗ്രാമ പഞ്ചായത്ത് പ്രസിഡൻറ് ശ്രീ. ടി. ആർ. മനോജ് ഉദ്ഘാടനം ചെയ്തു.",
      thumb: "assets/img/Pastevents/4959.jpg",
    },
    {
      src: "assets/img/Pastevents/4960.jpg",
      caption:
        "ശ്രീ ലളിതായനം ട്രസ്റ്റും കൈലാസം ശ്രീശക്തി ഗണപതി ക്ഷേത്ര സമിതിയും നിംസ് മെഡിസിറ്റിയും , നിംസ് മൈക്രോ ഹോസ്പിറ്റൽസ് & വത്സല നഴ്സിംഗ് ഹോമും സംയുക്തമായി നടത്തിയ മെഗാ മെഡിക്കൽ ക്യാമ്പ് കിളിമാനൂർ ഗ്രാമ പഞ്ചായത്ത് പ്രസിഡൻറ് ശ്രീ. ടി. ആർ. മനോജ് ഉദ്ഘാടനം ചെയ്തു.",
      thumb: "assets/img/Pastevents/4960.jpg",
    },
    {
      src: "assets/img/Pastevents/4961.jpg",
      caption:
        "ശ്രീ ലളിതായനം ട്രസ്റ്റും കൈലാസം ശ്രീശക്തി ഗണപതി ക്ഷേത്ര സമിതിയും നിംസ് മെഡിസിറ്റിയും , നിംസ് മൈക്രോ ഹോസ്പിറ്റൽസ് & വത്സല നഴ്സിംഗ് ഹോമും സംയുക്തമായി നടത്തിയ മെഗാ മെഡിക്കൽ ക്യാമ്പ് കിളിമാനൂർ ഗ്രാമ പഞ്ചായത്ത് പ്രസിഡൻറ് ശ്രീ. ടി. ആർ. മനോജ് ഉദ്ഘാടനം ചെയ്തു.",
      thumb: "assets/img/Pastevents/4961.jpg",
    },
    {
      src: "assets/img/Pastevents/4962.jpg",
      caption:
        "ശ്രീ ലളിതായനം ട്രസ്റ്റും കൈലാസം ശ്രീശക്തി ഗണപതി ക്ഷേത്ര സമിതിയും നിംസ് മെഡിസിറ്റിയും , നിംസ് മൈക്രോ ഹോസ്പിറ്റൽസ് & വത്സല നഴ്സിംഗ് ഹോമും സംയുക്തമായി നടത്തിയ മെഗാ മെഡിക്കൽ ക്യാമ്പ് കിളിമാനൂർ ഗ്രാമ പഞ്ചായത്ത് പ്രസിഡൻറ് ശ്രീ. ടി. ആർ. മനോജ് ഉദ്ഘാടനം ചെയ്തു.",
      thumb: "assets/img/Pastevents/4962.jpg",
    },
    {
      src: "assets/img/Pastevents/4963.jpg",
      caption:
        "ശ്രീ ലളിതായനം ട്രസ്റ്റും കൈലാസം ശ്രീശക്തി ഗണപതി ക്ഷേത്ര സമിതിയും നിംസ് മെഡിസിറ്റിയും , നിംസ് മൈക്രോ ഹോസ്പിറ്റൽസ് & വത്സല നഴ്സിംഗ് ഹോമും സംയുക്തമായി നടത്തിയ മെഗാ മെഡിക്കൽ ക്യാമ്പ് കിളിമാനൂർ ഗ്രാമ പഞ്ചായത്ത് പ്രസിഡൻറ് ശ്രീ. ടി. ആർ. മനോജ് ഉദ്ഘാടനം ചെയ്തു.",
      thumb: "assets/img/Pastevents/4963.jpg",
    },
    {
      src: "assets/img/Pastevents/4964.jpg",
      caption:
        "ശ്രീ ലളിതായനം ട്രസ്റ്റും കൈലാസം ശ്രീശക്തി ഗണപതി ക്ഷേത്ര സമിതിയും നിംസ് മെഡിസിറ്റിയും , നിംസ് മൈക്രോ ഹോസ്പിറ്റൽസ് & വത്സല നഴ്സിംഗ് ഹോമും സംയുക്തമായി നടത്തിയ മെഗാ മെഡിക്കൽ ക്യാമ്പ് കിളിമാനൂർ ഗ്രാമ പഞ്ചായത്ത് പ്രസിഡൻറ് ശ്രീ. ടി. ആർ. മനോജ് ഉദ്ഘാടനം ചെയ്തു.",
      thumb: "assets/img/Pastevents/4964.jpg",
    },
    {
      src: "assets/img/Pastevents/4965.jpg",
      caption:
        "ശ്രീ ലളിതായനം ട്രസ്റ്റും കൈലാസം ശ്രീശക്തി ഗണപതി ക്ഷേത്ര സമിതിയും നിംസ് മെഡിസിറ്റിയും , നിംസ് മൈക്രോ ഹോസ്പിറ്റൽസ് & വത്സല നഴ്സിംഗ് ഹോമും സംയുക്തമായി നടത്തിയ മെഗാ മെഡിക്കൽ ക്യാമ്പ് കിളിമാനൂർ ഗ്രാമ പഞ്ചായത്ത് പ്രസിഡൻറ് ശ്രീ. ടി. ആർ. മനോജ് ഉദ്ഘാടനം ചെയ്തു.",
      thumb: "assets/img/Pastevents/4965.jpg",
    },
    {
      src: "assets/img/Pastevents/4966.jpg",
      caption:
        "ശ്രീ ലളിതായനം ട്രസ്റ്റും കൈലാസം ശ്രീശക്തി ഗണപതി ക്ഷേത്ര സമിതിയും നിംസ് മെഡിസിറ്റിയും , നിംസ് മൈക്രോ ഹോസ്പിറ്റൽസ് & വത്സല നഴ്സിംഗ് ഹോമും സംയുക്തമായി നടത്തിയ മെഗാ മെഡിക്കൽ ക്യാമ്പ് കിളിമാനൂർ ഗ്രാമ പഞ്ചായത്ത് പ്രസിഡൻറ് ശ്രീ. ടി. ആർ. മനോജ് ഉദ്ഘാടനം ചെയ്തു.",
      thumb: "assets/img/Pastevents/4966.jpg",
    },
    {
      src: "assets/img/Pastevents/4947.jpg",
      caption:
        "പനവിള ഫ്രണ്ട്സ്  ആർട്സ് & സ്പോർട്സ് ക്ലബ്ബും, തിരുവനന്തപുരം എലൈറ്റ് ലയൺസ് ക്ലബ്ബും സംയുക്തമായി ചേർന്ന് നിംസ് മെഡിസിറ്റിയുടെ ആഭിമുഖ്യത്തിൽ  സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. കാർഡിയോളജി,ജനറൽ മെഡിസിൻ,ഓഫ്താൽമോളജി,ദന്തൽ എന്നീ വിഭാഗങ്ങളിലെ വിദഗ്ധരായ ഡോക്ടർമാർ നേതൃത്വം നൽകിയ ക്യാമ്പിൻ്റെ ഉദ്ഘാടനം ബഹുമാനപ്പെട്ട തിരുവനന്തപുരം ലയൺസ് ക്ലബ്ബ് സോൺ ചെയർമാൻ ശ്രീ.സനൽ കുമാർ നിർവഹിച്ചു.",
      thumb: "assets/img/Pastevents/4947.jpg",
    },
    {
      src: "assets/img/Pastevents/4948.jpg",
      caption:
        "പനവിള ഫ്രണ്ട്സ്  ആർട്സ് & സ്പോർട്സ് ക്ലബ്ബും, തിരുവനന്തപുരം എലൈറ്റ് ലയൺസ് ക്ലബ്ബും സംയുക്തമായി ചേർന്ന് നിംസ് മെഡിസിറ്റിയുടെ ആഭിമുഖ്യത്തിൽ  സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. കാർഡിയോളജി,ജനറൽ മെഡിസിൻ,ഓഫ്താൽമോളജി,ദന്തൽ എന്നീ വിഭാഗങ്ങളിലെ വിദഗ്ധരായ ഡോക്ടർമാർ നേതൃത്വം നൽകിയ ക്യാമ്പിൻ്റെ ഉദ്ഘാടനം ബഹുമാനപ്പെട്ട തിരുവനന്തപുരം ലയൺസ് ക്ലബ്ബ് സോൺ ചെയർമാൻ ശ്രീ.സനൽ കുമാർ നിർവഹിച്ചു.",
      thumb: "assets/img/Pastevents/4948.jpg",
    },
    {
      src: "assets/img/Pastevents/4949.jpg",
      caption:
        "പനവിള ഫ്രണ്ട്സ്  ആർട്സ് & സ്പോർട്സ് ക്ലബ്ബും, തിരുവനന്തപുരം എലൈറ്റ് ലയൺസ് ക്ലബ്ബും സംയുക്തമായി ചേർന്ന് നിംസ് മെഡിസിറ്റിയുടെ ആഭിമുഖ്യത്തിൽ  സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. കാർഡിയോളജി,ജനറൽ മെഡിസിൻ,ഓഫ്താൽമോളജി,ദന്തൽ എന്നീ വിഭാഗങ്ങളിലെ വിദഗ്ധരായ ഡോക്ടർമാർ നേതൃത്വം നൽകിയ ക്യാമ്പിൻ്റെ ഉദ്ഘാടനം ബഹുമാനപ്പെട്ട തിരുവനന്തപുരം ലയൺസ് ക്ലബ്ബ് സോൺ ചെയർമാൻ ശ്രീ.സനൽ കുമാർ നിർവഹിച്ചു.",
      thumb: "assets/img/Pastevents/4949.jpg",
    },
    {
      src: "assets/img/Pastevents/4950.jpg",
      caption:
        "പനവിള ഫ്രണ്ട്സ്  ആർട്സ് & സ്പോർട്സ് ക്ലബ്ബും, തിരുവനന്തപുരം എലൈറ്റ് ലയൺസ് ക്ലബ്ബും സംയുക്തമായി ചേർന്ന് നിംസ് മെഡിസിറ്റിയുടെ ആഭിമുഖ്യത്തിൽ  സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. കാർഡിയോളജി,ജനറൽ മെഡിസിൻ,ഓഫ്താൽമോളജി,ദന്തൽ എന്നീ വിഭാഗങ്ങളിലെ വിദഗ്ധരായ ഡോക്ടർമാർ നേതൃത്വം നൽകിയ ക്യാമ്പിൻ്റെ ഉദ്ഘാടനം ബഹുമാനപ്പെട്ട തിരുവനന്തപുരം ലയൺസ് ക്ലബ്ബ് സോൺ ചെയർമാൻ ശ്രീ.സനൽ കുമാർ നിർവഹിച്ചു.",
      thumb: "assets/img/Pastevents/4950.jpg",
    },
    {
      src: "assets/img/Pastevents/4951.jpg",
      caption:
        "പനവിള ഫ്രണ്ട്സ്  ആർട്സ് & സ്പോർട്സ് ക്ലബ്ബും, തിരുവനന്തപുരം എലൈറ്റ് ലയൺസ് ക്ലബ്ബും സംയുക്തമായി ചേർന്ന് നിംസ് മെഡിസിറ്റിയുടെ ആഭിമുഖ്യത്തിൽ  സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. കാർഡിയോളജി,ജനറൽ മെഡിസിൻ,ഓഫ്താൽമോളജി,ദന്തൽ എന്നീ വിഭാഗങ്ങളിലെ വിദഗ്ധരായ ഡോക്ടർമാർ നേതൃത്വം നൽകിയ ക്യാമ്പിൻ്റെ ഉദ്ഘാടനം ബഹുമാനപ്പെട്ട തിരുവനന്തപുരം ലയൺസ് ക്ലബ്ബ് സോൺ ചെയർമാൻ ശ്രീ.സനൽ കുമാർ നിർവഹിച്ചു.",
      thumb: "assets/img/Pastevents/4951.jpg",
    },
    {
      src: "assets/img/Pastevents/4952.jpg",
      caption:
        "പനവിള ഫ്രണ്ട്സ്  ആർട്സ് & സ്പോർട്സ് ക്ലബ്ബും, തിരുവനന്തപുരം എലൈറ്റ് ലയൺസ് ക്ലബ്ബും സംയുക്തമായി ചേർന്ന് നിംസ് മെഡിസിറ്റിയുടെ ആഭിമുഖ്യത്തിൽ  സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. കാർഡിയോളജി,ജനറൽ മെഡിസിൻ,ഓഫ്താൽമോളജി,ദന്തൽ എന്നീ വിഭാഗങ്ങളിലെ വിദഗ്ധരായ ഡോക്ടർമാർ നേതൃത്വം നൽകിയ ക്യാമ്പിൻ്റെ ഉദ്ഘാടനം ബഹുമാനപ്പെട്ട തിരുവനന്തപുരം ലയൺസ് ക്ലബ്ബ് സോൺ ചെയർമാൻ ശ്രീ.സനൽ കുമാർ നിർവഹിച്ചു.",
      thumb: "assets/img/Pastevents/4952.jpg",
    },
    {
      src: "assets/img/Pastevents/4953.jpg",
      caption:
        "പനവിള ഫ്രണ്ട്സ്  ആർട്സ് & സ്പോർട്സ് ക്ലബ്ബും, തിരുവനന്തപുരം എലൈറ്റ് ലയൺസ് ക്ലബ്ബും സംയുക്തമായി ചേർന്ന് നിംസ് മെഡിസിറ്റിയുടെ ആഭിമുഖ്യത്തിൽ  സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. കാർഡിയോളജി,ജനറൽ മെഡിസിൻ,ഓഫ്താൽമോളജി,ദന്തൽ എന്നീ വിഭാഗങ്ങളിലെ വിദഗ്ധരായ ഡോക്ടർമാർ നേതൃത്വം നൽകിയ ക്യാമ്പിൻ്റെ ഉദ്ഘാടനം ബഹുമാനപ്പെട്ട തിരുവനന്തപുരം ലയൺസ് ക്ലബ്ബ് സോൺ ചെയർമാൻ ശ്രീ.സനൽ കുമാർ നിർവഹിച്ചു.",
      thumb: "assets/img/Pastevents/4953.jpg",
    },
    {
      src: "assets/img/Pastevents/4954.jpg",
      caption:
        "പനവിള ഫ്രണ്ട്സ്  ആർട്സ് & സ്പോർട്സ് ക്ലബ്ബും, തിരുവനന്തപുരം എലൈറ്റ് ലയൺസ് ക്ലബ്ബും സംയുക്തമായി ചേർന്ന് നിംസ് മെഡിസിറ്റിയുടെ ആഭിമുഖ്യത്തിൽ  സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. കാർഡിയോളജി,ജനറൽ മെഡിസിൻ,ഓഫ്താൽമോളജി,ദന്തൽ എന്നീ വിഭാഗങ്ങളിലെ വിദഗ്ധരായ ഡോക്ടർമാർ നേതൃത്വം നൽകിയ ക്യാമ്പിൻ്റെ ഉദ്ഘാടനം ബഹുമാനപ്പെട്ട തിരുവനന്തപുരം ലയൺസ് ക്ലബ്ബ് സോൺ ചെയർമാൻ ശ്രീ.സനൽ കുമാർ നിർവഹിച്ചു.",
      thumb: "assets/img/Pastevents/4954.jpg",
    },
    {
      src: "assets/img/Pastevents/4955.jpg",
      caption:
        "പനവിള ഫ്രണ്ട്സ്  ആർട്സ് & സ്പോർട്സ് ക്ലബ്ബും, തിരുവനന്തപുരം എലൈറ്റ് ലയൺസ് ക്ലബ്ബും സംയുക്തമായി ചേർന്ന് നിംസ് മെഡിസിറ്റിയുടെ ആഭിമുഖ്യത്തിൽ  സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. കാർഡിയോളജി,ജനറൽ മെഡിസിൻ,ഓഫ്താൽമോളജി,ദന്തൽ എന്നീ വിഭാഗങ്ങളിലെ വിദഗ്ധരായ ഡോക്ടർമാർ നേതൃത്വം നൽകിയ ക്യാമ്പിൻ്റെ ഉദ്ഘാടനം ബഹുമാനപ്പെട്ട തിരുവനന്തപുരം ലയൺസ് ക്ലബ്ബ് സോൺ ചെയർമാൻ ശ്രീ.സനൽ കുമാർ നിർവഹിച്ചു.",
      thumb: "assets/img/Pastevents/4955.jpg",
    },
    {
      src: "assets/img/Pastevents/4956.jpg",
      caption:
        "പനവിള ഫ്രണ്ട്സ്  ആർട്സ് & സ്പോർട്സ് ക്ലബ്ബും, തിരുവനന്തപുരം എലൈറ്റ് ലയൺസ് ക്ലബ്ബും സംയുക്തമായി ചേർന്ന് നിംസ് മെഡിസിറ്റിയുടെ ആഭിമുഖ്യത്തിൽ  സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. കാർഡിയോളജി,ജനറൽ മെഡിസിൻ,ഓഫ്താൽമോളജി,ദന്തൽ എന്നീ വിഭാഗങ്ങളിലെ വിദഗ്ധരായ ഡോക്ടർമാർ നേതൃത്വം നൽകിയ ക്യാമ്പിൻ്റെ ഉദ്ഘാടനം ബഹുമാനപ്പെട്ട തിരുവനന്തപുരം ലയൺസ് ക്ലബ്ബ് സോൺ ചെയർമാൻ ശ്രീ.സനൽ കുമാർ നിർവഹിച്ചു.",
      thumb: "assets/img/Pastevents/4956.jpg",
    },
    {
      src: "assets/img/Pastevents/4957.jpg",
      caption:
        "പനവിള ഫ്രണ്ട്സ്  ആർട്സ് & സ്പോർട്സ് ക്ലബ്ബും, തിരുവനന്തപുരം എലൈറ്റ് ലയൺസ് ക്ലബ്ബും സംയുക്തമായി ചേർന്ന് നിംസ് മെഡിസിറ്റിയുടെ ആഭിമുഖ്യത്തിൽ  സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. കാർഡിയോളജി,ജനറൽ മെഡിസിൻ,ഓഫ്താൽമോളജി,ദന്തൽ എന്നീ വിഭാഗങ്ങളിലെ വിദഗ്ധരായ ഡോക്ടർമാർ നേതൃത്വം നൽകിയ ക്യാമ്പിൻ്റെ ഉദ്ഘാടനം ബഹുമാനപ്പെട്ട തിരുവനന്തപുരം ലയൺസ് ക്ലബ്ബ് സോൺ ചെയർമാൻ ശ്രീ.സനൽ കുമാർ നിർവഹിച്ചു.",
      thumb: "assets/img/Pastevents/4957.jpg",
    },
    {
      src: "assets/img/Pastevents/4937.jpg",
      caption:
        "DYFI സ്ഥാപക ദിനാചരണത്തോടനുബന്ധിച്ച് DYFI കരമന യൂണിറ്റും നിംസ് മെഡിസിറ്റിയും സംയുക്തമായി ചേർന്ന് സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. DYFI തിരുവനന്തപുരം ജില്ലാ സെക്രട്ടറി ശ്രീ.ഷിജു ഖാൻ  ഉദ്ഘാടനകർമ്മം നിർവഹിച്ച ക്യാമ്പിന് ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ദന്തൽ, ഓഫ്താൽമോളജി എന്നീ വിഭാഗങ്ങളിലെ വിദഗ്ധരായ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4937.jpg",
    },
    {
      src: "assets/img/Pastevents/4938.jpg",
      caption:
        "DYFI സ്ഥാപക ദിനാചരണത്തോടനുബന്ധിച്ച് DYFI കരമന യൂണിറ്റും നിംസ് മെഡിസിറ്റിയും സംയുക്തമായി ചേർന്ന് സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. DYFI തിരുവനന്തപുരം ജില്ലാ സെക്രട്ടറി ശ്രീ.ഷിജു ഖാൻ  ഉദ്ഘാടനകർമ്മം നിർവഹിച്ച ക്യാമ്പിന് ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ദന്തൽ, ഓഫ്താൽമോളജി എന്നീ വിഭാഗങ്ങളിലെ വിദഗ്ധരായ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4938.jpg",
    },
    {
      src: "assets/img/Pastevents/4939.jpg",
      caption:
        "DYFI സ്ഥാപക ദിനാചരണത്തോടനുബന്ധിച്ച് DYFI കരമന യൂണിറ്റും നിംസ് മെഡിസിറ്റിയും സംയുക്തമായി ചേർന്ന് സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. DYFI തിരുവനന്തപുരം ജില്ലാ സെക്രട്ടറി ശ്രീ.ഷിജു ഖാൻ  ഉദ്ഘാടനകർമ്മം നിർവഹിച്ച ക്യാമ്പിന് ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ദന്തൽ, ഓഫ്താൽമോളജി എന്നീ വിഭാഗങ്ങളിലെ വിദഗ്ധരായ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4939.jpg",
    },
    {
      src: "assets/img/Pastevents/4940.jpg",
      caption:
        "DYFI സ്ഥാപക ദിനാചരണത്തോടനുബന്ധിച്ച് DYFI കരമന യൂണിറ്റും നിംസ് മെഡിസിറ്റിയും സംയുക്തമായി ചേർന്ന് സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. DYFI തിരുവനന്തപുരം ജില്ലാ സെക്രട്ടറി ശ്രീ.ഷിജു ഖാൻ  ഉദ്ഘാടനകർമ്മം നിർവഹിച്ച ക്യാമ്പിന് ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ദന്തൽ, ഓഫ്താൽമോളജി എന്നീ വിഭാഗങ്ങളിലെ വിദഗ്ധരായ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4940.jpg",
    },
    {
      src: "assets/img/Pastevents/4941.jpg",
      caption:
        "DYFI സ്ഥാപക ദിനാചരണത്തോടനുബന്ധിച്ച് DYFI കരമന യൂണിറ്റും നിംസ് മെഡിസിറ്റിയും സംയുക്തമായി ചേർന്ന് സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. DYFI തിരുവനന്തപുരം ജില്ലാ സെക്രട്ടറി ശ്രീ.ഷിജു ഖാൻ  ഉദ്ഘാടനകർമ്മം നിർവഹിച്ച ക്യാമ്പിന് ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ദന്തൽ, ഓഫ്താൽമോളജി എന്നീ വിഭാഗങ്ങളിലെ വിദഗ്ധരായ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4941.jpg",
    },
    {
      src: "assets/img/Pastevents/4942.jpg",
      caption:
        "DYFI സ്ഥാപക ദിനാചരണത്തോടനുബന്ധിച്ച് DYFI കരമന യൂണിറ്റും നിംസ് മെഡിസിറ്റിയും സംയുക്തമായി ചേർന്ന് സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. DYFI തിരുവനന്തപുരം ജില്ലാ സെക്രട്ടറി ശ്രീ.ഷിജു ഖാൻ  ഉദ്ഘാടനകർമ്മം നിർവഹിച്ച ക്യാമ്പിന് ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ദന്തൽ, ഓഫ്താൽമോളജി എന്നീ വിഭാഗങ്ങളിലെ വിദഗ്ധരായ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4942.jpg",
    },
    {
      src: "assets/img/Pastevents/4943.jpg",
      caption:
        "DYFI സ്ഥാപക ദിനാചരണത്തോടനുബന്ധിച്ച് DYFI കരമന യൂണിറ്റും നിംസ് മെഡിസിറ്റിയും സംയുക്തമായി ചേർന്ന് സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. DYFI തിരുവനന്തപുരം ജില്ലാ സെക്രട്ടറി ശ്രീ.ഷിജു ഖാൻ  ഉദ്ഘാടനകർമ്മം നിർവഹിച്ച ക്യാമ്പിന് ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ദന്തൽ, ഓഫ്താൽമോളജി എന്നീ വിഭാഗങ്ങളിലെ വിദഗ്ധരായ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4943.jpg",
    },
    {
      src: "assets/img/Pastevents/4944.jpg",
      caption:
        "DYFI സ്ഥാപക ദിനാചരണത്തോടനുബന്ധിച്ച് DYFI കരമന യൂണിറ്റും നിംസ് മെഡിസിറ്റിയും സംയുക്തമായി ചേർന്ന് സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. DYFI തിരുവനന്തപുരം ജില്ലാ സെക്രട്ടറി ശ്രീ.ഷിജു ഖാൻ  ഉദ്ഘാടനകർമ്മം നിർവഹിച്ച ക്യാമ്പിന് ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ദന്തൽ, ഓഫ്താൽമോളജി എന്നീ വിഭാഗങ്ങളിലെ വിദഗ്ധരായ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4944.jpg",
    },
    {
      src: "assets/img/Pastevents/4945.jpg",
      caption:
        "DYFI സ്ഥാപക ദിനാചരണത്തോടനുബന്ധിച്ച് DYFI കരമന യൂണിറ്റും നിംസ് മെഡിസിറ്റിയും സംയുക്തമായി ചേർന്ന് സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. DYFI തിരുവനന്തപുരം ജില്ലാ സെക്രട്ടറി ശ്രീ.ഷിജു ഖാൻ  ഉദ്ഘാടനകർമ്മം നിർവഹിച്ച ക്യാമ്പിന് ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ദന്തൽ, ഓഫ്താൽമോളജി എന്നീ വിഭാഗങ്ങളിലെ വിദഗ്ധരായ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4945.jpg",
    },
    {
      src: "assets/img/Pastevents/4946.jpg",
      caption:
        "DYFI സ്ഥാപക ദിനാചരണത്തോടനുബന്ധിച്ച് DYFI കരമന യൂണിറ്റും നിംസ് മെഡിസിറ്റിയും സംയുക്തമായി ചേർന്ന് സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. DYFI തിരുവനന്തപുരം ജില്ലാ സെക്രട്ടറി ശ്രീ.ഷിജു ഖാൻ  ഉദ്ഘാടനകർമ്മം നിർവഹിച്ച ക്യാമ്പിന് ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ദന്തൽ, ഓഫ്താൽമോളജി എന്നീ വിഭാഗങ്ങളിലെ വിദഗ്ധരായ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4946.jpg",
    },
    {
      src: "assets/img/Pastevents/4923.jpg",
      caption:
        "ചാത്തന്നൂർ റോട്ടറി ക്ലബ്ബ് , സൗഹൃദം '86' സംയുക്തമായി നിംസ് മെഡിസിറ്റിയുടെ ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ബഹുമാനപ്പെട്ട എം.എൽ.എ  ശ്രീ. അഡ്വ ജി സ്റ്റീഫൻ ഉദ്ഘാടനകർമ്മം നിർവഹിച്ച ക്യാമ്പിൽ സൗഹൃദം '86' പ്രസിഡന്റ്  ശ്രീ.സുരേഷ് കുമാരനാശാരി അധ്യക്ഷത വഹിച്ചു",
      thumb: "assets/img/Pastevents/4923.jpg",
    },
    {
      src: "assets/img/Pastevents/4924.jpg",
      caption:
        "ചാത്തന്നൂർ റോട്ടറി ക്ലബ്ബ് , സൗഹൃദം '86' സംയുക്തമായി നിംസ് മെഡിസിറ്റിയുടെ ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ബഹുമാനപ്പെട്ട എം.എൽ.എ  ശ്രീ. അഡ്വ ജി സ്റ്റീഫൻ ഉദ്ഘാടനകർമ്മം നിർവഹിച്ച ക്യാമ്പിൽ സൗഹൃദം '86' പ്രസിഡന്റ്  ശ്രീ.സുരേഷ് കുമാരനാശാരി അധ്യക്ഷത വഹിച്ചു",
      thumb: "assets/img/Pastevents/4924.jpg",
    },
    {
      src: "assets/img/Pastevents/4925.jpg",
      caption:
        "ചാത്തന്നൂർ റോട്ടറി ക്ലബ്ബ് , സൗഹൃദം '86' സംയുക്തമായി നിംസ് മെഡിസിറ്റിയുടെ ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ബഹുമാനപ്പെട്ട എം.എൽ.എ  ശ്രീ. അഡ്വ ജി സ്റ്റീഫൻ ഉദ്ഘാടനകർമ്മം നിർവഹിച്ച ക്യാമ്പിൽ സൗഹൃദം '86' പ്രസിഡന്റ്  ശ്രീ.സുരേഷ് കുമാരനാശാരി അധ്യക്ഷത വഹിച്ചു",
      thumb: "assets/img/Pastevents/4925.jpg",
    },
    {
      src: "assets/img/Pastevents/4926.jpg",
      caption:
        "ചാത്തന്നൂർ റോട്ടറി ക്ലബ്ബ് , സൗഹൃദം '86' സംയുക്തമായി നിംസ് മെഡിസിറ്റിയുടെ ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ബഹുമാനപ്പെട്ട എം.എൽ.എ  ശ്രീ. അഡ്വ ജി സ്റ്റീഫൻ ഉദ്ഘാടനകർമ്മം നിർവഹിച്ച ക്യാമ്പിൽ സൗഹൃദം '86' പ്രസിഡന്റ്  ശ്രീ.സുരേഷ് കുമാരനാശാരി അധ്യക്ഷത വഹിച്ചു",
      thumb: "assets/img/Pastevents/4926.jpg",
    },
    {
      src: "assets/img/Pastevents/4927.jpg",
      caption:
        "ചാത്തന്നൂർ റോട്ടറി ക്ലബ്ബ് , സൗഹൃദം '86' സംയുക്തമായി നിംസ് മെഡിസിറ്റിയുടെ ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ബഹുമാനപ്പെട്ട എം.എൽ.എ  ശ്രീ. അഡ്വ ജി സ്റ്റീഫൻ ഉദ്ഘാടനകർമ്മം നിർവഹിച്ച ക്യാമ്പിൽ സൗഹൃദം '86' പ്രസിഡന്റ്  ശ്രീ.സുരേഷ് കുമാരനാശാരി അധ്യക്ഷത വഹിച്ചു",
      thumb: "assets/img/Pastevents/4927.jpg",
    },
    {
      src: "assets/img/Pastevents/4928.jpg",
      caption:
        "ചാത്തന്നൂർ റോട്ടറി ക്ലബ്ബ് , സൗഹൃദം '86' സംയുക്തമായി നിംസ് മെഡിസിറ്റിയുടെ ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ബഹുമാനപ്പെട്ട എം.എൽ.എ  ശ്രീ. അഡ്വ ജി സ്റ്റീഫൻ ഉദ്ഘാടനകർമ്മം നിർവഹിച്ച ക്യാമ്പിൽ സൗഹൃദം '86' പ്രസിഡന്റ്  ശ്രീ.സുരേഷ് കുമാരനാശാരി അധ്യക്ഷത വഹിച്ചു",
      thumb: "assets/img/Pastevents/4928.jpg",
    },
    {
      src: "assets/img/Pastevents/4929.jpg",
      caption:
        "ചാത്തന്നൂർ റോട്ടറി ക്ലബ്ബ് , സൗഹൃദം '86' സംയുക്തമായി നിംസ് മെഡിസിറ്റിയുടെ ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ബഹുമാനപ്പെട്ട എം.എൽ.എ  ശ്രീ. അഡ്വ ജി സ്റ്റീഫൻ ഉദ്ഘാടനകർമ്മം നിർവഹിച്ച ക്യാമ്പിൽ സൗഹൃദം '86' പ്രസിഡന്റ്  ശ്രീ.സുരേഷ് കുമാരനാശാരി അധ്യക്ഷത വഹിച്ചു",
      thumb: "assets/img/Pastevents/4929.jpg",
    },
    {
      src: "assets/img/Pastevents/4930.jpg",
      caption:
        "ചാത്തന്നൂർ റോട്ടറി ക്ലബ്ബ് , സൗഹൃദം '86' സംയുക്തമായി നിംസ് മെഡിസിറ്റിയുടെ ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ബഹുമാനപ്പെട്ട എം.എൽ.എ  ശ്രീ. അഡ്വ ജി സ്റ്റീഫൻ ഉദ്ഘാടനകർമ്മം നിർവഹിച്ച ക്യാമ്പിൽ സൗഹൃദം '86' പ്രസിഡന്റ്  ശ്രീ.സുരേഷ് കുമാരനാശാരി അധ്യക്ഷത വഹിച്ചു",
      thumb: "assets/img/Pastevents/4930.jpg",
    },
    {
      src: "assets/img/Pastevents/4931.jpg",
      caption:
        "ചാത്തന്നൂർ റോട്ടറി ക്ലബ്ബ് , സൗഹൃദം '86' സംയുക്തമായി നിംസ് മെഡിസിറ്റിയുടെ ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ബഹുമാനപ്പെട്ട എം.എൽ.എ  ശ്രീ. അഡ്വ ജി സ്റ്റീഫൻ ഉദ്ഘാടനകർമ്മം നിർവഹിച്ച ക്യാമ്പിൽ സൗഹൃദം '86' പ്രസിഡന്റ്  ശ്രീ.സുരേഷ് കുമാരനാശാരി അധ്യക്ഷത വഹിച്ചു",
      thumb: "assets/img/Pastevents/4931.jpg",
    },
    {
      src: "assets/img/Pastevents/4932.jpg",
      caption:
        "ചാത്തന്നൂർ റോട്ടറി ക്ലബ്ബ് , സൗഹൃദം '86' സംയുക്തമായി നിംസ് മെഡിസിറ്റിയുടെ ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ബഹുമാനപ്പെട്ട എം.എൽ.എ  ശ്രീ. അഡ്വ ജി സ്റ്റീഫൻ ഉദ്ഘാടനകർമ്മം നിർവഹിച്ച ക്യാമ്പിൽ സൗഹൃദം '86' പ്രസിഡന്റ്  ശ്രീ.സുരേഷ് കുമാരനാശാരി അധ്യക്ഷത വഹിച്ചു",
      thumb: "assets/img/Pastevents/4932.jpg",
    },
    {
      src: "assets/img/Pastevents/4933.jpg",
      caption:
        "ചാത്തന്നൂർ റോട്ടറി ക്ലബ്ബ് , സൗഹൃദം '86' സംയുക്തമായി നിംസ് മെഡിസിറ്റിയുടെ ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ബഹുമാനപ്പെട്ട എം.എൽ.എ  ശ്രീ. അഡ്വ ജി സ്റ്റീഫൻ ഉദ്ഘാടനകർമ്മം നിർവഹിച്ച ക്യാമ്പിൽ സൗഹൃദം '86' പ്രസിഡന്റ്  ശ്രീ.സുരേഷ് കുമാരനാശാരി അധ്യക്ഷത വഹിച്ചു",
      thumb: "assets/img/Pastevents/4933.jpg",
    },
    {
      src: "assets/img/Pastevents/4934.jpg",
      caption:
        "ചാത്തന്നൂർ റോട്ടറി ക്ലബ്ബ് , സൗഹൃദം '86' സംയുക്തമായി നിംസ് മെഡിസിറ്റിയുടെ ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ബഹുമാനപ്പെട്ട എം.എൽ.എ  ശ്രീ. അഡ്വ ജി സ്റ്റീഫൻ ഉദ്ഘാടനകർമ്മം നിർവഹിച്ച ക്യാമ്പിൽ സൗഹൃദം '86' പ്രസിഡന്റ്  ശ്രീ.സുരേഷ് കുമാരനാശാരി അധ്യക്ഷത വഹിച്ചു",
      thumb: "assets/img/Pastevents/4934.jpg",
    },
    {
      src: "assets/img/Pastevents/4935.jpg",
      caption:
        "ചാത്തന്നൂർ റോട്ടറി ക്ലബ്ബ് , സൗഹൃദം '86' സംയുക്തമായി നിംസ് മെഡിസിറ്റിയുടെ ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ബഹുമാനപ്പെട്ട എം.എൽ.എ  ശ്രീ. അഡ്വ ജി സ്റ്റീഫൻ ഉദ്ഘാടനകർമ്മം നിർവഹിച്ച ക്യാമ്പിൽ സൗഹൃദം '86' പ്രസിഡന്റ്  ശ്രീ.സുരേഷ് കുമാരനാശാരി അധ്യക്ഷത വഹിച്ചു",
      thumb: "assets/img/Pastevents/4935.jpg",
    },
    {
      src: "assets/img/Pastevents/4936.jpg",
      caption:
        "ചാത്തന്നൂർ റോട്ടറി ക്ലബ്ബ് , സൗഹൃദം '86' സംയുക്തമായി നിംസ് മെഡിസിറ്റിയുടെ ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ബഹുമാനപ്പെട്ട എം.എൽ.എ  ശ്രീ. അഡ്വ ജി സ്റ്റീഫൻ ഉദ്ഘാടനകർമ്മം നിർവഹിച്ച ക്യാമ്പിൽ സൗഹൃദം '86' പ്രസിഡന്റ്  ശ്രീ.സുരേഷ് കുമാരനാശാരി അധ്യക്ഷത വഹിച്ചു",
      thumb: "assets/img/Pastevents/4936.jpg",
    },
    {
      src: "assets/img/Pastevents/4911.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയിൽ കുട്ടികൾക്കും മുതിർന്നവർക്കുമായി സൗജന്യ അലർജിക് ക്യാമ്പ് സംഘടിപ്പിച്ചു. നിംസ് മെഡിസിറ്റിയിലെ പൾമണോളജി വിഭാഗം സീനിയർ കൺസൽട്ടന്റ്  ഡോ. സന്ദീപ്, പീഡിയാട്രിക്‌ & നിയോനറ്റോളജി  വിഭാഗം സീനിയർ കൺസൽട്ടന്റ് ഡോ. സി. ഇ ഷെബിൻ എന്നിവർ ക്യാമ്പിന് നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4911.jpg",
    },
    {
      src: "assets/img/Pastevents/4912.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയിൽ കുട്ടികൾക്കും മുതിർന്നവർക്കുമായി സൗജന്യ അലർജിക് ക്യാമ്പ് സംഘടിപ്പിച്ചു. നിംസ് മെഡിസിറ്റിയിലെ പൾമണോളജി വിഭാഗം സീനിയർ കൺസൽട്ടന്റ്  ഡോ. സന്ദീപ്, പീഡിയാട്രിക്‌ & നിയോനറ്റോളജി  വിഭാഗം സീനിയർ കൺസൽട്ടന്റ് ഡോ. സി. ഇ ഷെബിൻ എന്നിവർ ക്യാമ്പിന് നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4912.jpg",
    },
    {
      src: "assets/img/Pastevents/4913.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയിൽ കുട്ടികൾക്കും മുതിർന്നവർക്കുമായി സൗജന്യ അലർജിക് ക്യാമ്പ് സംഘടിപ്പിച്ചു. നിംസ് മെഡിസിറ്റിയിലെ പൾമണോളജി വിഭാഗം സീനിയർ കൺസൽട്ടന്റ്  ഡോ. സന്ദീപ്, പീഡിയാട്രിക്‌ & നിയോനറ്റോളജി  വിഭാഗം സീനിയർ കൺസൽട്ടന്റ് ഡോ. സി. ഇ ഷെബിൻ എന്നിവർ ക്യാമ്പിന് നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4913.jpg",
    },
    {
      src: "assets/img/Pastevents/4914.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയിൽ കുട്ടികൾക്കും മുതിർന്നവർക്കുമായി സൗജന്യ അലർജിക് ക്യാമ്പ് സംഘടിപ്പിച്ചു. നിംസ് മെഡിസിറ്റിയിലെ പൾമണോളജി വിഭാഗം സീനിയർ കൺസൽട്ടന്റ്  ഡോ. സന്ദീപ്, പീഡിയാട്രിക്‌ & നിയോനറ്റോളജി  വിഭാഗം സീനിയർ കൺസൽട്ടന്റ് ഡോ. സി. ഇ ഷെബിൻ എന്നിവർ ക്യാമ്പിന് നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4914.jpg",
    },
    {
      src: "assets/img/Pastevents/4915.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയിൽ കുട്ടികൾക്കും മുതിർന്നവർക്കുമായി സൗജന്യ അലർജിക് ക്യാമ്പ് സംഘടിപ്പിച്ചു. നിംസ് മെഡിസിറ്റിയിലെ പൾമണോളജി വിഭാഗം സീനിയർ കൺസൽട്ടന്റ്  ഡോ. സന്ദീപ്, പീഡിയാട്രിക്‌ & നിയോനറ്റോളജി  വിഭാഗം സീനിയർ കൺസൽട്ടന്റ് ഡോ. സി. ഇ ഷെബിൻ എന്നിവർ ക്യാമ്പിന് നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4915.jpg",
    },
    {
      src: "assets/img/Pastevents/4916.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയിൽ കുട്ടികൾക്കും മുതിർന്നവർക്കുമായി സൗജന്യ അലർജിക് ക്യാമ്പ് സംഘടിപ്പിച്ചു. നിംസ് മെഡിസിറ്റിയിലെ പൾമണോളജി വിഭാഗം സീനിയർ കൺസൽട്ടന്റ്  ഡോ. സന്ദീപ്, പീഡിയാട്രിക്‌ & നിയോനറ്റോളജി  വിഭാഗം സീനിയർ കൺസൽട്ടന്റ് ഡോ. സി. ഇ ഷെബിൻ എന്നിവർ ക്യാമ്പിന് നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4916.jpg",
    },
    {
      src: "assets/img/Pastevents/4917.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയിൽ കുട്ടികൾക്കും മുതിർന്നവർക്കുമായി സൗജന്യ അലർജിക് ക്യാമ്പ് സംഘടിപ്പിച്ചു. നിംസ് മെഡിസിറ്റിയിലെ പൾമണോളജി വിഭാഗം സീനിയർ കൺസൽട്ടന്റ്  ഡോ. സന്ദീപ്, പീഡിയാട്രിക്‌ & നിയോനറ്റോളജി  വിഭാഗം സീനിയർ കൺസൽട്ടന്റ് ഡോ. സി. ഇ ഷെബിൻ എന്നിവർ ക്യാമ്പിന് നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4917.jpg",
    },
    {
      src: "assets/img/Pastevents/4918.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയിൽ കുട്ടികൾക്കും മുതിർന്നവർക്കുമായി സൗജന്യ അലർജിക് ക്യാമ്പ് സംഘടിപ്പിച്ചു. നിംസ് മെഡിസിറ്റിയിലെ പൾമണോളജി വിഭാഗം സീനിയർ കൺസൽട്ടന്റ്  ഡോ. സന്ദീപ്, പീഡിയാട്രിക്‌ & നിയോനറ്റോളജി  വിഭാഗം സീനിയർ കൺസൽട്ടന്റ് ഡോ. സി. ഇ ഷെബിൻ എന്നിവർ ക്യാമ്പിന് നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4918.jpg",
    },
    {
      src: "assets/img/Pastevents/4919.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയിൽ കുട്ടികൾക്കും മുതിർന്നവർക്കുമായി സൗജന്യ അലർജിക് ക്യാമ്പ് സംഘടിപ്പിച്ചു. നിംസ് മെഡിസിറ്റിയിലെ പൾമണോളജി വിഭാഗം സീനിയർ കൺസൽട്ടന്റ്  ഡോ. സന്ദീപ്, പീഡിയാട്രിക്‌ & നിയോനറ്റോളജി  വിഭാഗം സീനിയർ കൺസൽട്ടന്റ് ഡോ. സി. ഇ ഷെബിൻ എന്നിവർ ക്യാമ്പിന് നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4919.jpg",
    },
    {
      src: "assets/img/Pastevents/4920.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയിൽ കുട്ടികൾക്കും മുതിർന്നവർക്കുമായി സൗജന്യ അലർജിക് ക്യാമ്പ് സംഘടിപ്പിച്ചു. നിംസ് മെഡിസിറ്റിയിലെ പൾമണോളജി വിഭാഗം സീനിയർ കൺസൽട്ടന്റ്  ഡോ. സന്ദീപ്, പീഡിയാട്രിക്‌ & നിയോനറ്റോളജി  വിഭാഗം സീനിയർ കൺസൽട്ടന്റ് ഡോ. സി. ഇ ഷെബിൻ എന്നിവർ ക്യാമ്പിന് നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4920.jpg",
    },
    {
      src: "assets/img/Pastevents/4921.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയിൽ കുട്ടികൾക്കും മുതിർന്നവർക്കുമായി സൗജന്യ അലർജിക് ക്യാമ്പ് സംഘടിപ്പിച്ചു. നിംസ് മെഡിസിറ്റിയിലെ പൾമണോളജി വിഭാഗം സീനിയർ കൺസൽട്ടന്റ്  ഡോ. സന്ദീപ്, പീഡിയാട്രിക്‌ & നിയോനറ്റോളജി  വിഭാഗം സീനിയർ കൺസൽട്ടന്റ് ഡോ. സി. ഇ ഷെബിൻ എന്നിവർ ക്യാമ്പിന് നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4921.jpg",
    },
    {
      src: "assets/img/Pastevents/4922.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയിൽ കുട്ടികൾക്കും മുതിർന്നവർക്കുമായി സൗജന്യ അലർജിക് ക്യാമ്പ് സംഘടിപ്പിച്ചു. നിംസ് മെഡിസിറ്റിയിലെ പൾമണോളജി വിഭാഗം സീനിയർ കൺസൽട്ടന്റ്  ഡോ. സന്ദീപ്, പീഡിയാട്രിക്‌ & നിയോനറ്റോളജി  വിഭാഗം സീനിയർ കൺസൽട്ടന്റ് ഡോ. സി. ഇ ഷെബിൻ എന്നിവർ ക്യാമ്പിന് നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4922.jpg",
    },
    {
      src: "assets/img/Pastevents/4898.jpg",
      caption:
        "ബീമാപള്ളി പൗരസമിതിയും , അനന്തപുരി യുവജനവേദിയും സംയുക്തമായി ചേർന്ന് നിംസ് മെഡിസിറ്റിയുടെ ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ഡിസിസി ജനറൽ സെക്രട്ടറി ശ്രീ.റ്റി.ബഷീർ ഉദ്ഘാടകർമ്മം നിർവഹിച്ച മെഡിക്കൽ ക്യാമ്പിൽ കാർഡിയോളജി, ഡയബറ്റോളജി, ദന്തൽ,ഓഫ്തൽമോളജി എന്നീ വിഭാഗങ്ങളിലെ വിദഗ്ധരായ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4898.jpg",
    },
    {
      src: "assets/img/Pastevents/4899.jpg",
      caption:
        "ബീമാപള്ളി പൗരസമിതിയും , അനന്തപുരി യുവജനവേദിയും സംയുക്തമായി ചേർന്ന് നിംസ് മെഡിസിറ്റിയുടെ ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ഡിസിസി ജനറൽ സെക്രട്ടറി ശ്രീ.റ്റി.ബഷീർ ഉദ്ഘാടകർമ്മം നിർവഹിച്ച മെഡിക്കൽ ക്യാമ്പിൽ കാർഡിയോളജി, ഡയബറ്റോളജി, ദന്തൽ,ഓഫ്തൽമോളജി എന്നീ വിഭാഗങ്ങളിലെ വിദഗ്ധരായ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4899.jpg",
    },
    {
      src: "assets/img/Pastevents/4900.jpg",
      caption:
        "ബീമാപള്ളി പൗരസമിതിയും , അനന്തപുരി യുവജനവേദിയും സംയുക്തമായി ചേർന്ന് നിംസ് മെഡിസിറ്റിയുടെ ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ഡിസിസി ജനറൽ സെക്രട്ടറി ശ്രീ.റ്റി.ബഷീർ ഉദ്ഘാടകർമ്മം നിർവഹിച്ച മെഡിക്കൽ ക്യാമ്പിൽ കാർഡിയോളജി, ഡയബറ്റോളജി, ദന്തൽ,ഓഫ്തൽമോളജി എന്നീ വിഭാഗങ്ങളിലെ വിദഗ്ധരായ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4900.jpg",
    },
    {
      src: "assets/img/Pastevents/4901.jpg",
      caption:
        "ബീമാപള്ളി പൗരസമിതിയും , അനന്തപുരി യുവജനവേദിയും സംയുക്തമായി ചേർന്ന് നിംസ് മെഡിസിറ്റിയുടെ ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ഡിസിസി ജനറൽ സെക്രട്ടറി ശ്രീ.റ്റി.ബഷീർ ഉദ്ഘാടകർമ്മം നിർവഹിച്ച മെഡിക്കൽ ക്യാമ്പിൽ കാർഡിയോളജി, ഡയബറ്റോളജി, ദന്തൽ,ഓഫ്തൽമോളജി എന്നീ വിഭാഗങ്ങളിലെ വിദഗ്ധരായ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4901.jpg",
    },
    {
      src: "assets/img/Pastevents/4902.jpg",
      caption:
        "ബീമാപള്ളി പൗരസമിതിയും , അനന്തപുരി യുവജനവേദിയും സംയുക്തമായി ചേർന്ന് നിംസ് മെഡിസിറ്റിയുടെ ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ഡിസിസി ജനറൽ സെക്രട്ടറി ശ്രീ.റ്റി.ബഷീർ ഉദ്ഘാടകർമ്മം നിർവഹിച്ച മെഡിക്കൽ ക്യാമ്പിൽ കാർഡിയോളജി, ഡയബറ്റോളജി, ദന്തൽ,ഓഫ്തൽമോളജി എന്നീ വിഭാഗങ്ങളിലെ വിദഗ്ധരായ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4902.jpg",
    },
    {
      src: "assets/img/Pastevents/4903.jpg",
      caption:
        "ബീമാപള്ളി പൗരസമിതിയും , അനന്തപുരി യുവജനവേദിയും സംയുക്തമായി ചേർന്ന് നിംസ് മെഡിസിറ്റിയുടെ ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ഡിസിസി ജനറൽ സെക്രട്ടറി ശ്രീ.റ്റി.ബഷീർ ഉദ്ഘാടകർമ്മം നിർവഹിച്ച മെഡിക്കൽ ക്യാമ്പിൽ കാർഡിയോളജി, ഡയബറ്റോളജി, ദന്തൽ,ഓഫ്തൽമോളജി എന്നീ വിഭാഗങ്ങളിലെ വിദഗ്ധരായ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4903.jpg",
    },
    {
      src: "assets/img/Pastevents/4904.jpg",
      caption:
        "ബീമാപള്ളി പൗരസമിതിയും , അനന്തപുരി യുവജനവേദിയും സംയുക്തമായി ചേർന്ന് നിംസ് മെഡിസിറ്റിയുടെ ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ഡിസിസി ജനറൽ സെക്രട്ടറി ശ്രീ.റ്റി.ബഷീർ ഉദ്ഘാടകർമ്മം നിർവഹിച്ച മെഡിക്കൽ ക്യാമ്പിൽ കാർഡിയോളജി, ഡയബറ്റോളജി, ദന്തൽ,ഓഫ്തൽമോളജി എന്നീ വിഭാഗങ്ങളിലെ വിദഗ്ധരായ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4904.jpg",
    },
    {
      src: "assets/img/Pastevents/4905.jpg",
      caption:
        "ബീമാപള്ളി പൗരസമിതിയും , അനന്തപുരി യുവജനവേദിയും സംയുക്തമായി ചേർന്ന് നിംസ് മെഡിസിറ്റിയുടെ ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ഡിസിസി ജനറൽ സെക്രട്ടറി ശ്രീ.റ്റി.ബഷീർ ഉദ്ഘാടകർമ്മം നിർവഹിച്ച മെഡിക്കൽ ക്യാമ്പിൽ കാർഡിയോളജി, ഡയബറ്റോളജി, ദന്തൽ,ഓഫ്തൽമോളജി എന്നീ വിഭാഗങ്ങളിലെ വിദഗ്ധരായ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4905.jpg",
    },
    {
      src: "assets/img/Pastevents/4906.jpg",
      caption:
        "ബീമാപള്ളി പൗരസമിതിയും , അനന്തപുരി യുവജനവേദിയും സംയുക്തമായി ചേർന്ന് നിംസ് മെഡിസിറ്റിയുടെ ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ഡിസിസി ജനറൽ സെക്രട്ടറി ശ്രീ.റ്റി.ബഷീർ ഉദ്ഘാടകർമ്മം നിർവഹിച്ച മെഡിക്കൽ ക്യാമ്പിൽ കാർഡിയോളജി, ഡയബറ്റോളജി, ദന്തൽ,ഓഫ്തൽമോളജി എന്നീ വിഭാഗങ്ങളിലെ വിദഗ്ധരായ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4906.jpg",
    },
    {
      src: "assets/img/Pastevents/4907.jpg",
      caption:
        "ബീമാപള്ളി പൗരസമിതിയും , അനന്തപുരി യുവജനവേദിയും സംയുക്തമായി ചേർന്ന് നിംസ് മെഡിസിറ്റിയുടെ ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ഡിസിസി ജനറൽ സെക്രട്ടറി ശ്രീ.റ്റി.ബഷീർ ഉദ്ഘാടകർമ്മം നിർവഹിച്ച മെഡിക്കൽ ക്യാമ്പിൽ കാർഡിയോളജി, ഡയബറ്റോളജി, ദന്തൽ,ഓഫ്തൽമോളജി എന്നീ വിഭാഗങ്ങളിലെ വിദഗ്ധരായ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4907.jpg",
    },
    {
      src: "assets/img/Pastevents/4908.jpg",
      caption:
        "ബീമാപള്ളി പൗരസമിതിയും , അനന്തപുരി യുവജനവേദിയും സംയുക്തമായി ചേർന്ന് നിംസ് മെഡിസിറ്റിയുടെ ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ഡിസിസി ജനറൽ സെക്രട്ടറി ശ്രീ.റ്റി.ബഷീർ ഉദ്ഘാടകർമ്മം നിർവഹിച്ച മെഡിക്കൽ ക്യാമ്പിൽ കാർഡിയോളജി, ഡയബറ്റോളജി, ദന്തൽ,ഓഫ്തൽമോളജി എന്നീ വിഭാഗങ്ങളിലെ വിദഗ്ധരായ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4908.jpg",
    },
    {
      src: "assets/img/Pastevents/4909.jpg",
      caption:
        "ബീമാപള്ളി പൗരസമിതിയും , അനന്തപുരി യുവജനവേദിയും സംയുക്തമായി ചേർന്ന് നിംസ് മെഡിസിറ്റിയുടെ ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ഡിസിസി ജനറൽ സെക്രട്ടറി ശ്രീ.റ്റി.ബഷീർ ഉദ്ഘാടകർമ്മം നിർവഹിച്ച മെഡിക്കൽ ക്യാമ്പിൽ കാർഡിയോളജി, ഡയബറ്റോളജി, ദന്തൽ,ഓഫ്തൽമോളജി എന്നീ വിഭാഗങ്ങളിലെ വിദഗ്ധരായ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4909.jpg",
    },
    {
      src: "assets/img/Pastevents/4910.jpg",
      caption:
        "ബീമാപള്ളി പൗരസമിതിയും , അനന്തപുരി യുവജനവേദിയും സംയുക്തമായി ചേർന്ന് നിംസ് മെഡിസിറ്റിയുടെ ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ഡിസിസി ജനറൽ സെക്രട്ടറി ശ്രീ.റ്റി.ബഷീർ ഉദ്ഘാടകർമ്മം നിർവഹിച്ച മെഡിക്കൽ ക്യാമ്പിൽ കാർഡിയോളജി, ഡയബറ്റോളജി, ദന്തൽ,ഓഫ്തൽമോളജി എന്നീ വിഭാഗങ്ങളിലെ വിദഗ്ധരായ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4910.jpg",
    },
    {
      src: "assets/img/Pastevents/4892.jpg",
      caption:
        "തിരുവനന്തപുരം,  കമലേശ്വരം എസ്എൻഡിപി യോഗം ശാഖയുടെ ആഭിമുഖ്യത്തിൽ നിംസ് മെഡിസിറ്റി, നിംസ് മൈക്രോ ഹോസ്പിറ്റൽസ് & വത്സല നഴ്സിംഗ് ഹോം നേതൃത്വത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പും ആരോഗ്യ ബോധവൽക്കരണ ക്ലാസും സംഘടിപ്പിച്ചു. കാർഡിയോളജി, ജനറൽ മെഡിസിൻ ഡയബറ്റോളജി, ദന്തൽ, ഓഫ്താൽമോളജി, ആയുർവേദം എന്നീ വിഭാഗങ്ങളിലെ വിദഗ്‌ധരായ ഡോക്ടർമാർ ക്യാമ്പിന് നേതൃത്വം നൽകി. ഡോ. ദേവി കെ ആർ  MBBS,MD (General Medicine ) നേതൃത്വത്തിൽ ആരോഗ്യ ബോധവൽക്കരണവും ക്യാമ്പിൽ നൽകി",
      thumb: "assets/img/Pastevents/4892.jpg",
    },
    {
      src: "assets/img/Pastevents/4893.jpg",
      caption:
        "തിരുവനന്തപുരം,  കമലേശ്വരം എസ്എൻഡിപി യോഗം ശാഖയുടെ ആഭിമുഖ്യത്തിൽ നിംസ് മെഡിസിറ്റി, നിംസ് മൈക്രോ ഹോസ്പിറ്റൽസ് & വത്സല നഴ്സിംഗ് ഹോം നേതൃത്വത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പും ആരോഗ്യ ബോധവൽക്കരണ ക്ലാസും സംഘടിപ്പിച്ചു. കാർഡിയോളജി, ജനറൽ മെഡിസിൻ ഡയബറ്റോളജി, ദന്തൽ, ഓഫ്താൽമോളജി, ആയുർവേദം എന്നീ വിഭാഗങ്ങളിലെ വിദഗ്‌ധരായ ഡോക്ടർമാർ ക്യാമ്പിന് നേതൃത്വം നൽകി. ഡോ. ദേവി കെ ആർ  MBBS,MD (General Medicine ) നേതൃത്വത്തിൽ ആരോഗ്യ ബോധവൽക്കരണവും ക്യാമ്പിൽ നൽകി",
      thumb: "assets/img/Pastevents/4893.jpg",
    },
    {
      src: "assets/img/Pastevents/4894.jpg",
      caption:
        "തിരുവനന്തപുരം,  കമലേശ്വരം എസ്എൻഡിപി യോഗം ശാഖയുടെ ആഭിമുഖ്യത്തിൽ നിംസ് മെഡിസിറ്റി, നിംസ് മൈക്രോ ഹോസ്പിറ്റൽസ് & വത്സല നഴ്സിംഗ് ഹോം നേതൃത്വത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പും ആരോഗ്യ ബോധവൽക്കരണ ക്ലാസും സംഘടിപ്പിച്ചു. കാർഡിയോളജി, ജനറൽ മെഡിസിൻ ഡയബറ്റോളജി, ദന്തൽ, ഓഫ്താൽമോളജി, ആയുർവേദം എന്നീ വിഭാഗങ്ങളിലെ വിദഗ്‌ധരായ ഡോക്ടർമാർ ക്യാമ്പിന് നേതൃത്വം നൽകി. ഡോ. ദേവി കെ ആർ  MBBS,MD (General Medicine ) നേതൃത്വത്തിൽ ആരോഗ്യ ബോധവൽക്കരണവും ക്യാമ്പിൽ നൽകി",
      thumb: "assets/img/Pastevents/4894.jpg",
    },
    {
      src: "assets/img/Pastevents/4895.jpg",
      caption:
        "തിരുവനന്തപുരം,  കമലേശ്വരം എസ്എൻഡിപി യോഗം ശാഖയുടെ ആഭിമുഖ്യത്തിൽ നിംസ് മെഡിസിറ്റി, നിംസ് മൈക്രോ ഹോസ്പിറ്റൽസ് & വത്സല നഴ്സിംഗ് ഹോം നേതൃത്വത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പും ആരോഗ്യ ബോധവൽക്കരണ ക്ലാസും സംഘടിപ്പിച്ചു. കാർഡിയോളജി, ജനറൽ മെഡിസിൻ ഡയബറ്റോളജി, ദന്തൽ, ഓഫ്താൽമോളജി, ആയുർവേദം എന്നീ വിഭാഗങ്ങളിലെ വിദഗ്‌ധരായ ഡോക്ടർമാർ ക്യാമ്പിന് നേതൃത്വം നൽകി. ഡോ. ദേവി കെ ആർ  MBBS,MD (General Medicine ) നേതൃത്വത്തിൽ ആരോഗ്യ ബോധവൽക്കരണവും ക്യാമ്പിൽ നൽകി",
      thumb: "assets/img/Pastevents/4895.jpg",
    },
    {
      src: "assets/img/Pastevents/4896.jpg",
      caption:
        "തിരുവനന്തപുരം,  കമലേശ്വരം എസ്എൻഡിപി യോഗം ശാഖയുടെ ആഭിമുഖ്യത്തിൽ നിംസ് മെഡിസിറ്റി, നിംസ് മൈക്രോ ഹോസ്പിറ്റൽസ് & വത്സല നഴ്സിംഗ് ഹോം നേതൃത്വത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പും ആരോഗ്യ ബോധവൽക്കരണ ക്ലാസും സംഘടിപ്പിച്ചു. കാർഡിയോളജി, ജനറൽ മെഡിസിൻ ഡയബറ്റോളജി, ദന്തൽ, ഓഫ്താൽമോളജി, ആയുർവേദം എന്നീ വിഭാഗങ്ങളിലെ വിദഗ്‌ധരായ ഡോക്ടർമാർ ക്യാമ്പിന് നേതൃത്വം നൽകി. ഡോ. ദേവി കെ ആർ  MBBS,MD (General Medicine ) നേതൃത്വത്തിൽ ആരോഗ്യ ബോധവൽക്കരണവും ക്യാമ്പിൽ നൽകി",
      thumb: "assets/img/Pastevents/4896.jpg",
    },
    {
      src: "assets/img/Pastevents/4897.jpg",
      caption:
        "തിരുവനന്തപുരം,  കമലേശ്വരം എസ്എൻഡിപി യോഗം ശാഖയുടെ ആഭിമുഖ്യത്തിൽ നിംസ് മെഡിസിറ്റി, നിംസ് മൈക്രോ ഹോസ്പിറ്റൽസ് & വത്സല നഴ്സിംഗ് ഹോം നേതൃത്വത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പും ആരോഗ്യ ബോധവൽക്കരണ ക്ലാസും സംഘടിപ്പിച്ചു. കാർഡിയോളജി, ജനറൽ മെഡിസിൻ ഡയബറ്റോളജി, ദന്തൽ, ഓഫ്താൽമോളജി, ആയുർവേദം എന്നീ വിഭാഗങ്ങളിലെ വിദഗ്‌ധരായ ഡോക്ടർമാർ ക്യാമ്പിന് നേതൃത്വം നൽകി. ഡോ. ദേവി കെ ആർ  MBBS,MD (General Medicine ) നേതൃത്വത്തിൽ ആരോഗ്യ ബോധവൽക്കരണവും ക്യാമ്പിൽ നൽകി",
      thumb: "assets/img/Pastevents/4897.jpg",
    },
    {
      src: "assets/img/Pastevents/4885.jpg",
      caption:
        "തിരുവനന്തപുരം മെട്രോപൊളീസ് ലയൺസ് ക്ലബ്ബിന്റെയും  പുതുകുളങ്ങര CSI ചർച്ചിന്റെയും സംയുക്താഭിമുഖ്യത്തിൽ നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. കാർഡിയോളജി, ഡയബറ്റോളജി, ദന്തൽ, ഓഫ്താൽമോളജി എന്നീ വിഭാഗങ്ങളിലെ വിദഗ്‌ധരായ ഡോക്ടർമാർ ക്യാമ്പിന് നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4885.jpg",
    },
    {
      src: "assets/img/Pastevents/4886.jpg",
      caption:
        "തിരുവനന്തപുരം മെട്രോപൊളീസ് ലയൺസ് ക്ലബ്ബിന്റെയും  പുതുകുളങ്ങര CSI ചർച്ചിന്റെയും സംയുക്താഭിമുഖ്യത്തിൽ നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. കാർഡിയോളജി, ഡയബറ്റോളജി, ദന്തൽ, ഓഫ്താൽമോളജി എന്നീ വിഭാഗങ്ങളിലെ വിദഗ്‌ധരായ ഡോക്ടർമാർ ക്യാമ്പിന് നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4886.jpg",
    },
    {
      src: "assets/img/Pastevents/4887.jpg",
      caption:
        "തിരുവനന്തപുരം മെട്രോപൊളീസ് ലയൺസ് ക്ലബ്ബിന്റെയും  പുതുകുളങ്ങര CSI ചർച്ചിന്റെയും സംയുക്താഭിമുഖ്യത്തിൽ നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. കാർഡിയോളജി, ഡയബറ്റോളജി, ദന്തൽ, ഓഫ്താൽമോളജി എന്നീ വിഭാഗങ്ങളിലെ വിദഗ്‌ധരായ ഡോക്ടർമാർ ക്യാമ്പിന് നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4887.jpg",
    },
    {
      src: "assets/img/Pastevents/4888.jpg",
      caption:
        "തിരുവനന്തപുരം മെട്രോപൊളീസ് ലയൺസ് ക്ലബ്ബിന്റെയും  പുതുകുളങ്ങര CSI ചർച്ചിന്റെയും സംയുക്താഭിമുഖ്യത്തിൽ നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. കാർഡിയോളജി, ഡയബറ്റോളജി, ദന്തൽ, ഓഫ്താൽമോളജി എന്നീ വിഭാഗങ്ങളിലെ വിദഗ്‌ധരായ ഡോക്ടർമാർ ക്യാമ്പിന് നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4888.jpg",
    },
    {
      src: "assets/img/Pastevents/4889.jpg",
      caption:
        "തിരുവനന്തപുരം മെട്രോപൊളീസ് ലയൺസ് ക്ലബ്ബിന്റെയും  പുതുകുളങ്ങര CSI ചർച്ചിന്റെയും സംയുക്താഭിമുഖ്യത്തിൽ നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. കാർഡിയോളജി, ഡയബറ്റോളജി, ദന്തൽ, ഓഫ്താൽമോളജി എന്നീ വിഭാഗങ്ങളിലെ വിദഗ്‌ധരായ ഡോക്ടർമാർ ക്യാമ്പിന് നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4889.jpg",
    },
    {
      src: "assets/img/Pastevents/4890.jpg",
      caption:
        "തിരുവനന്തപുരം മെട്രോപൊളീസ് ലയൺസ് ക്ലബ്ബിന്റെയും  പുതുകുളങ്ങര CSI ചർച്ചിന്റെയും സംയുക്താഭിമുഖ്യത്തിൽ നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. കാർഡിയോളജി, ഡയബറ്റോളജി, ദന്തൽ, ഓഫ്താൽമോളജി എന്നീ വിഭാഗങ്ങളിലെ വിദഗ്‌ധരായ ഡോക്ടർമാർ ക്യാമ്പിന് നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4890.jpg",
    },
    {
      src: "assets/img/Pastevents/4891.jpg",
      caption:
        "തിരുവനന്തപുരം മെട്രോപൊളീസ് ലയൺസ് ക്ലബ്ബിന്റെയും  പുതുകുളങ്ങര CSI ചർച്ചിന്റെയും സംയുക്താഭിമുഖ്യത്തിൽ നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. കാർഡിയോളജി, ഡയബറ്റോളജി, ദന്തൽ, ഓഫ്താൽമോളജി എന്നീ വിഭാഗങ്ങളിലെ വിദഗ്‌ധരായ ഡോക്ടർമാർ ക്യാമ്പിന് നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4891.jpg",
    },
    {
      src: "assets/img/Pastevents/4872.jpg",
      caption:
        "കേരള സെൻസസ് റിക്രിയേഷൻ ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്താഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. കേരള സെൻസസ് റിക്രിയേഷൻ ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്താഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/4872.jpg",
    },
    {
      src: "assets/img/Pastevents/4873.jpg",
      caption:
        "കേരള സെൻസസ് റിക്രിയേഷൻ ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്താഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. കേരള സെൻസസ് റിക്രിയേഷൻ ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്താഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/4873.jpg",
    },
    {
      src: "assets/img/Pastevents/4874.jpg",
      caption:
        "കേരള സെൻസസ് റിക്രിയേഷൻ ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്താഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. കേരള സെൻസസ് റിക്രിയേഷൻ ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്താഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/4874.jpg",
    },
    {
      src: "assets/img/Pastevents/4875.jpg",
      caption:
        "കേരള സെൻസസ് റിക്രിയേഷൻ ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്താഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. കേരള സെൻസസ് റിക്രിയേഷൻ ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്താഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/4875.jpg",
    },
    {
      src: "assets/img/Pastevents/4876.jpg",
      caption:
        "കേരള സെൻസസ് റിക്രിയേഷൻ ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്താഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. കേരള സെൻസസ് റിക്രിയേഷൻ ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്താഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/4876.jpg",
    },
    {
      src: "assets/img/Pastevents/4877.jpg",
      caption:
        "കേരള സെൻസസ് റിക്രിയേഷൻ ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്താഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. കേരള സെൻസസ് റിക്രിയേഷൻ ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്താഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/4877.jpg",
    },
     {
      src: "assets/img/Pastevents/4878.jpg",
      caption:
        "കേരള സെൻസസ് റിക്രിയേഷൻ ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്താഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. കേരള സെൻസസ് റിക്രിയേഷൻ ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്താഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/4878.jpg",
    },
    {
      src: "assets/img/Pastevents/4879.jpg",
      caption:
        "കേരള സെൻസസ് റിക്രിയേഷൻ ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്താഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. കേരള സെൻസസ് റിക്രിയേഷൻ ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്താഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/4879.jpg",
    },
    {
      src: "assets/img/Pastevents/4880.jpg",
      caption:
        "കേരള സെൻസസ് റിക്രിയേഷൻ ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്താഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. കേരള സെൻസസ് റിക്രിയേഷൻ ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്താഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/4880.jpg",
    },
    {
      src: "assets/img/Pastevents/4881.jpg",
      caption:
        "കേരള സെൻസസ് റിക്രിയേഷൻ ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്താഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. കേരള സെൻസസ് റിക്രിയേഷൻ ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്താഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/4881.jpg",
    },
    {
      src: "assets/img/Pastevents/4882.jpg",
      caption:
        "കേരള സെൻസസ് റിക്രിയേഷൻ ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്താഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. കേരള സെൻസസ് റിക്രിയേഷൻ ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്താഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/4882.jpg",
    },
    {
      src: "assets/img/Pastevents/4883.jpg",
      caption:
        "കേരള സെൻസസ് റിക്രിയേഷൻ ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്താഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. കേരള സെൻസസ് റിക്രിയേഷൻ ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്താഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/4883.jpg",
    },
    {
      src: "assets/img/Pastevents/4884.jpg",
      caption:
        "കേരള സെൻസസ് റിക്രിയേഷൻ ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്താഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. കേരള സെൻസസ് റിക്രിയേഷൻ ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്താഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/4884.jpg",
    },
    {
      src: "assets/img/Pastevents/4867.jpeg",
      caption:
        "അരുമന മുഴുക്കോട് പൂജാരി സേവാ ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4867.jpeg",
    },
    {
      src: "assets/img/Pastevents/4868.jpeg",
      caption:
        "അരുമന മുഴുക്കോട് പൂജാരി സേവാ ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4868.jpeg",
    },
    {
      src: "assets/img/Pastevents/4869.jpeg",
      caption:
        "അരുമന മുഴുക്കോട് പൂജാരി സേവാ ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4869.jpeg",
    },
    {
      src: "assets/img/Pastevents/4870.jpeg",
      caption:
        "അരുമന മുഴുക്കോട് പൂജാരി സേവാ ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4870.jpeg",
    },
    {
      src: "assets/img/Pastevents/4871.jpeg",
      caption:
        "അരുമന മുഴുക്കോട് പൂജാരി സേവാ ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4871.jpeg",
    },

    {
      src: "assets/img/Pastevents/4862.jpeg",
      caption:
        "മലയിൻകീഴ് തിമിരിച്ചൽ സി എസ് ഐ  ചർച്ചിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.  ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4862.jpeg",
    },
    {
      src: "assets/img/Pastevents/4863.jpeg",
      caption:
        "മലയിൻകീഴ് തിമിരിച്ചൽ സി എസ് ഐ  ചർച്ചിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.  ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4863.jpeg",
    },
    {
      src: "assets/img/Pastevents/4864.jpeg",
      caption:
        "മലയിൻകീഴ് തിമിരിച്ചൽ സി എസ് ഐ  ചർച്ചിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.  ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4864.jpeg",
    },
    {
      src: "assets/img/Pastevents/4865.jpeg",
      caption:
        "മലയിൻകീഴ് തിമിരിച്ചൽ സി എസ് ഐ  ചർച്ചിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.  ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4865.jpeg",
    },
    {
      src: "assets/img/Pastevents/4866.jpeg",
      caption:
        "മലയിൻകീഴ് തിമിരിച്ചൽ സി എസ് ഐ  ചർച്ചിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.  ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4866.jpeg",
    },
    {
      src: "assets/img/Pastevents/4857.jpeg",
      caption:
        "കാരേറ്റ്  ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.  ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4857.jpeg",
    },
    {
      src: "assets/img/Pastevents/4858.jpeg",
      caption:
        "കാരേറ്റ്  ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.  ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4858.jpeg",
    },
    {
      src: "assets/img/Pastevents/4859.jpeg",
      caption:
        "കാരേറ്റ്  ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.  ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4859.jpeg",
    },
    {
      src: "assets/img/Pastevents/4860.jpeg",
      caption:
        "കാരേറ്റ്  ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.  ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4860.jpeg",
    },
    {
      src: "assets/img/Pastevents/4861.jpeg",
      caption:
        "കാരേറ്റ്  ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.  ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4861.jpeg",
    },
    {
      src: "assets/img/Pastevents/4851.jpeg",
      caption:
        "ഇടപഴിഞ്ഞി ട്രിവാൻഡ്രം റോയൽ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4851.jpeg",
    },
    {
      src: "assets/img/Pastevents/4852.jpeg",
      caption:
        "ഇടപഴിഞ്ഞി ട്രിവാൻഡ്രം റോയൽ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4852.jpeg",
    },
    {
      src: "assets/img/Pastevents/4853.jpeg",
      caption:
        "ഇടപഴിഞ്ഞി ട്രിവാൻഡ്രം റോയൽ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4853.jpeg",
    },
    {
      src: "assets/img/Pastevents/4854.jpeg",
      caption:
        "ഇടപഴിഞ്ഞി ട്രിവാൻഡ്രം റോയൽ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4854.jpeg",
    },
    {
      src: "assets/img/Pastevents/4855.jpeg",
      caption:
        "ഇടപഴിഞ്ഞി ട്രിവാൻഡ്രം റോയൽ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4855.jpeg",
    },
    {
      src: "assets/img/Pastevents/4856.jpeg",
      caption:
        "ഇടപഴിഞ്ഞി ട്രിവാൻഡ്രം റോയൽ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4856.jpeg",
    },
    {
      src: "assets/img/Pastevents/4845.jpeg",
      caption:
        "ആലുവിള സി എസ് ഐ ചർച്ച് സി ഈ വൈ എഫ് യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4845.jpeg",
    },
    {
      src: "assets/img/Pastevents/4846.jpeg",
      caption:
        "ആലുവിള സി എസ് ഐ ചർച്ച് സി ഈ വൈ എഫ് യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4846.jpeg",
    },
    {
      src: "assets/img/Pastevents/4847.jpeg",
      caption:
        "ആലുവിള സി എസ് ഐ ചർച്ച് സി ഈ വൈ എഫ് യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4847.jpeg",
    },
    {
      src: "assets/img/Pastevents/4848.jpeg",
      caption:
        "ആലുവിള സി എസ് ഐ ചർച്ച് സി ഈ വൈ എഫ് യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4848.jpeg",
    },
    {
      src: "assets/img/Pastevents/4849.jpeg",
      caption:
        "ആലുവിള സി എസ് ഐ ചർച്ച് സി ഈ വൈ എഫ് യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4849.jpeg",
    },
    {
      src: "assets/img/Pastevents/4850.jpeg",
      caption:
        "ആലുവിള സി എസ് ഐ ചർച്ച് സി ഈ വൈ എഫ് യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4850.jpeg",
    },
    {
      src: "assets/img/Pastevents/4840.jpeg",
      caption:
        "മേലാരന്നൂർ റെഡ്ഢിയാർ അസോസിയേഷൻ, ട്രിവാൻഡ്രം മിഡ്‌ടൗൺ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4840.jpeg",
    },
    {
      src: "assets/img/Pastevents/4841.jpeg",
      caption:
        "മേലാരന്നൂർ റെഡ്ഢിയാർ അസോസിയേഷൻ, ട്രിവാൻഡ്രം മിഡ്‌ടൗൺ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4841.jpeg",
    },
    {
      src: "assets/img/Pastevents/4842.jpeg",
      caption:
        "മേലാരന്നൂർ റെഡ്ഢിയാർ അസോസിയേഷൻ, ട്രിവാൻഡ്രം മിഡ്‌ടൗൺ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4842.jpeg",
    },
    {
      src: "assets/img/Pastevents/4843.jpeg",
      caption:
        "മേലാരന്നൂർ റെഡ്ഢിയാർ അസോസിയേഷൻ, ട്രിവാൻഡ്രം മിഡ്‌ടൗൺ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4843.jpeg",
    },
    {
      src: "assets/img/Pastevents/4844.jpeg",
      caption:
        "മേലാരന്നൂർ റെഡ്ഢിയാർ അസോസിയേഷൻ, ട്രിവാൻഡ്രം മിഡ്‌ടൗൺ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4844.jpeg",
    },
    {
      src: "assets/img/Pastevents/4835.jpeg",
      caption:
        "കല്ലറ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ",
      thumb: "assets/img/Pastevents/4835.jpeg",
    },
    {
      src: "assets/img/Pastevents/4836.jpeg",
      caption:
        "കല്ലറ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ",
      thumb: "assets/img/Pastevents/4836.jpeg",
    },
    {
      src: "assets/img/Pastevents/4837.jpeg",
      caption:
        "കല്ലറ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ",
      thumb: "assets/img/Pastevents/4837.jpeg",
    },
    {
      src: "assets/img/Pastevents/4838.jpeg",
      caption:
        "കല്ലറ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ",
      thumb: "assets/img/Pastevents/4838.jpeg",
    },
    {
      src: "assets/img/Pastevents/4839.jpeg",
      caption:
        "കല്ലറ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ",
      thumb: "assets/img/Pastevents/4839.jpeg",
    },
    {
      src: "assets/img/Pastevents/4830.jpeg",
      caption:
        "ലോക ഹൃദയ ദിനത്തോട് അനുബന്ധിച്ച് അടിമലത്തുറ ഫാത്തിമ മാതാ ദേവാലയത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4830.jpeg",
    },
    {
      src: "assets/img/Pastevents/4831.jpeg",
      caption:
        "ലോക ഹൃദയ ദിനത്തോട് അനുബന്ധിച്ച് അടിമലത്തുറ ഫാത്തിമ മാതാ ദേവാലയത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4831.jpeg",
    },
    {
      src: "assets/img/Pastevents/4832.jpeg",
      caption:
        "ലോക ഹൃദയ ദിനത്തോട് അനുബന്ധിച്ച് അടിമലത്തുറ ഫാത്തിമ മാതാ ദേവാലയത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4832.jpeg",
    },
    {
      src: "assets/img/Pastevents/4833.jpeg",
      caption:
        "ലോക ഹൃദയ ദിനത്തോട് അനുബന്ധിച്ച് അടിമലത്തുറ ഫാത്തിമ മാതാ ദേവാലയത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4833.jpeg",
    },
    {
      src: "assets/img/Pastevents/4834.jpeg",
      caption:
        "ലോക ഹൃദയ ദിനത്തോട് അനുബന്ധിച്ച് അടിമലത്തുറ ഫാത്തിമ മാതാ ദേവാലയത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4834.jpeg",
    },
    {
      src: "assets/img/Pastevents/4823.jpeg",
      caption:
        "റിലയൻസ് ഇൻഡസ്ട്രീസ് ലിമിറ്റേഡിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4823.jpeg",
    },
    {
      src: "assets/img/Pastevents/4824.jpeg",
      caption:
        "റിലയൻസ് ഇൻഡസ്ട്രീസ് ലിമിറ്റേഡിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4824.jpeg",
    },
    {
      src: "assets/img/Pastevents/4825.jpeg",
      caption:
        "റിലയൻസ് ഇൻഡസ്ട്രീസ് ലിമിറ്റേഡിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4825.jpeg",
    },
        {
      src: "assets/img/Pastevents/4826.jpeg",
      caption:
        "റിലയൻസ് ഇൻഡസ്ട്രീസ് ലിമിറ്റേഡിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4826.jpeg",
    },
    {
      src: "assets/img/Pastevents/4827.jpeg",
      caption:
        "റിലയൻസ് ഇൻഡസ്ട്രീസ് ലിമിറ്റേഡിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4827.jpeg",
    },    {
      src: "assets/img/Pastevents/4828.jpeg",
      caption:
        "റിലയൻസ് ഇൻഡസ്ട്രീസ് ലിമിറ്റേഡിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4828.jpeg",
    },
    {
      src: "assets/img/Pastevents/4829.jpeg",
      caption:
        "റിലയൻസ് ഇൻഡസ്ട്രീസ് ലിമിറ്റേഡിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4829.jpeg",
    },
    {
      src: "assets/img/Pastevents/4817.jpeg",
      caption:
        " കോവളം ലീല ഹോട്ടൽ മാനേജ്മെൻ്റും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4817.jpeg",
    },
    {
      src: "assets/img/Pastevents/4818.jpeg",
      caption:
        " കോവളം ലീല ഹോട്ടൽ മാനേജ്മെൻ്റും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4818.jpeg",
    },
    {
      src: "assets/img/Pastevents/4819.jpeg",
      caption:
        " കോവളം ലീല ഹോട്ടൽ മാനേജ്മെൻ്റും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4819.jpeg",
    },
    {
      src: "assets/img/Pastevents/4820.jpeg",
      caption:
        " കോവളം ലീല ഹോട്ടൽ മാനേജ്മെൻ്റും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4820.jpeg",
    },
    {
      src: "assets/img/Pastevents/4821.jpeg",
      caption:
        " കോവളം ലീല ഹോട്ടൽ മാനേജ്മെൻ്റും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4821.jpeg",
    },
    {
      src: "assets/img/Pastevents/4822.jpeg",
      caption:
        " കോവളം ലീല ഹോട്ടൽ മാനേജ്മെൻ്റും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4822.jpeg",
    },
    {
      src: "assets/img/Pastevents/4811.jpeg",
      caption:
        "ആക്കുളം നിഷ് , ട്രിവാൻഡ്രം ഡിസ്‌ട്രിക്ട് ലയൺസ് ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4811.jpeg",
    },
    {
      src: "assets/img/Pastevents/4812.jpeg",
      caption:
        "ആക്കുളം നിഷ് , ട്രിവാൻഡ്രം ഡിസ്‌ട്രിക്ട് ലയൺസ് ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4812.jpeg",
    },
    {
      src: "assets/img/Pastevents/4813.jpeg",
      caption:
        "ആക്കുളം നിഷ് , ട്രിവാൻഡ്രം ഡിസ്‌ട്രിക്ട് ലയൺസ് ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4813.jpeg",
    },
    {
      src: "assets/img/Pastevents/4814.jpeg",
      caption:
        "ആക്കുളം നിഷ് , ട്രിവാൻഡ്രം ഡിസ്‌ട്രിക്ട് ലയൺസ് ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4814.jpeg",
    },
    {
      src: "assets/img/Pastevents/4815.jpeg",
      caption:
        "ആക്കുളം നിഷ് , ട്രിവാൻഡ്രം ഡിസ്‌ട്രിക്ട് ലയൺസ് ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4815.jpeg",
    },
    {
      src: "assets/img/Pastevents/4816.jpeg",
      caption:
        "ആക്കുളം നിഷ് , ട്രിവാൻഡ്രം ഡിസ്‌ട്രിക്ട് ലയൺസ് ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4816.jpeg",
    },
    {
      src: "assets/img/Pastevents/4805.jpeg",
      caption:
        " ഈഞ്ചക്കൽ ശ്രദ്ധാ ചാരിറ്റബിൾ സൊസൈറ്റി, സുഭാഷ് നഗർ വെൽഫെയർ റെസിഡൻഷ്യൽ അസോസിയേഷൻ, ട്രിവാൻഡ്രം റീജൻസി ലയൺസ് ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4805.jpeg",
    },
    {
      src: "assets/img/Pastevents/4806.jpeg",
      caption:
        " ഈഞ്ചക്കൽ ശ്രദ്ധാ ചാരിറ്റബിൾ സൊസൈറ്റി, സുഭാഷ് നഗർ വെൽഫെയർ റെസിഡൻഷ്യൽ അസോസിയേഷൻ, ട്രിവാൻഡ്രം റീജൻസി ലയൺസ് ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4806.jpeg",
    },
    {
      src: "assets/img/Pastevents/4807.jpeg",
      caption:
        " ഈഞ്ചക്കൽ ശ്രദ്ധാ ചാരിറ്റബിൾ സൊസൈറ്റി, സുഭാഷ് നഗർ വെൽഫെയർ റെസിഡൻഷ്യൽ അസോസിയേഷൻ, ട്രിവാൻഡ്രം റീജൻസി ലയൺസ് ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4807.jpeg",
    },
    {
      src: "assets/img/Pastevents/4808.jpeg",
      caption:
        " ഈഞ്ചക്കൽ ശ്രദ്ധാ ചാരിറ്റബിൾ സൊസൈറ്റി, സുഭാഷ് നഗർ വെൽഫെയർ റെസിഡൻഷ്യൽ അസോസിയേഷൻ, ട്രിവാൻഡ്രം റീജൻസി ലയൺസ് ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4808.jpeg",
    },
    {
      src: "assets/img/Pastevents/4809.jpeg",
      caption:
        " ഈഞ്ചക്കൽ ശ്രദ്ധാ ചാരിറ്റബിൾ സൊസൈറ്റി, സുഭാഷ് നഗർ വെൽഫെയർ റെസിഡൻഷ്യൽ അസോസിയേഷൻ, ട്രിവാൻഡ്രം റീജൻസി ലയൺസ് ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4809.jpeg",
    },
    {
      src: "assets/img/Pastevents/4810.jpeg",
      caption:
        " ഈഞ്ചക്കൽ ശ്രദ്ധാ ചാരിറ്റബിൾ സൊസൈറ്റി, സുഭാഷ് നഗർ വെൽഫെയർ റെസിഡൻഷ്യൽ അസോസിയേഷൻ, ട്രിവാൻഡ്രം റീജൻസി ലയൺസ് ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4810.jpeg",
    },
    {
      src: "assets/img/Pastevents/4798.jpeg",
      caption:
        "പേയാട് സെൻറ് സേവ്യേഴ്സ് മെഗാ എക്സ്പോ 2024, ആക്കുളം ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4798.jpeg",
    },
    {
      src: "assets/img/Pastevents/4799.jpeg",
      caption:
        "പേയാട് സെൻറ് സേവ്യേഴ്സ് മെഗാ എക്സ്പോ 2024, ആക്കുളം ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4799.jpeg",
    },
    {
      src: "assets/img/Pastevents/4800.jpeg",
      caption:
        "പേയാട് സെൻറ് സേവ്യേഴ്സ് മെഗാ എക്സ്പോ 2024, ആക്കുളം ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4800.jpeg",
    },
    {
      src: "assets/img/Pastevents/4801.jpeg",
      caption:
        "പേയാട് സെൻറ് സേവ്യേഴ്സ് മെഗാ എക്സ്പോ 2024, ആക്കുളം ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4801.jpeg",
    },
    {
      src: "assets/img/Pastevents/4802.jpeg",
      caption:
        "പേയാട് സെൻറ് സേവ്യേഴ്സ് മെഗാ എക്സ്പോ 2024, ആക്കുളം ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4802.jpeg",
    },
    {
      src: "assets/img/Pastevents/4803.jpeg",
      caption:
        "പേയാട് സെൻറ് സേവ്യേഴ്സ് മെഗാ എക്സ്പോ 2024, ആക്കുളം ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4803.jpeg",
    },
    {
      src: "assets/img/Pastevents/4804.jpeg",
      caption:
        "പേയാട് സെൻറ് സേവ്യേഴ്സ് മെഗാ എക്സ്പോ 2024, ആക്കുളം ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4804.jpeg",
    },
    {
      src: "assets/img/Pastevents/4793.jpeg",
      caption:
        "നെല്ലിമ്മൂട് ഇടത്തേയ്ക്കോണം എസ് എൻ ഗ്രന്ഥശാലയുടെയും  നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4793.jpeg",
    },
    {
      src: "assets/img/Pastevents/4794.jpeg",
      caption:
        "നെല്ലിമ്മൂട് ഇടത്തേയ്ക്കോണം എസ് എൻ ഗ്രന്ഥശാലയുടെയും  നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4794.jpeg",
    },
    {
      src: "assets/img/Pastevents/4795.jpeg",
      caption:
        "നെല്ലിമ്മൂട് ഇടത്തേയ്ക്കോണം എസ് എൻ ഗ്രന്ഥശാലയുടെയും  നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4795.jpeg",
    },
    {
      src: "assets/img/Pastevents/4796.jpeg",
      caption:
        "നെല്ലിമ്മൂട് ഇടത്തേയ്ക്കോണം എസ് എൻ ഗ്രന്ഥശാലയുടെയും  നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4796.jpeg",
    },
    {
      src: "assets/img/Pastevents/4797.jpeg",
      caption:
        "നെല്ലിമ്മൂട് ഇടത്തേയ്ക്കോണം എസ് എൻ ഗ്രന്ഥശാലയുടെയും  നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4797.jpeg",
    },
    {
      src: "assets/img/Pastevents/4787.jpeg",
      caption:
        "പനപ്പാംക്കുന്ന് നവകൈരളി ആർട്ട്സ് ആൻഡ് സ്പോർട്സ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4787.jpeg",
    },
    {
      src: "assets/img/Pastevents/4788.jpeg",
      caption:
        "പനപ്പാംക്കുന്ന് നവകൈരളി ആർട്ട്സ് ആൻഡ് സ്പോർട്സ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4788.jpeg",
    },
    {
      src: "assets/img/Pastevents/4789.jpeg",
      caption:
        "പനപ്പാംക്കുന്ന് നവകൈരളി ആർട്ട്സ് ആൻഡ് സ്പോർട്സ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4789.jpeg",
    },
    {
      src: "assets/img/Pastevents/4790.jpeg",
      caption:
        "പനപ്പാംക്കുന്ന് നവകൈരളി ആർട്ട്സ് ആൻഡ് സ്പോർട്സ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4790.jpeg",
    },
    {
      src: "assets/img/Pastevents/4791.jpeg",
      caption:
        "പനപ്പാംക്കുന്ന് നവകൈരളി ആർട്ട്സ് ആൻഡ് സ്പോർട്സ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4791.jpeg",
    },
    {
      src: "assets/img/Pastevents/4792.jpeg",
      caption:
        "പനപ്പാംക്കുന്ന് നവകൈരളി ആർട്ട്സ് ആൻഡ് സ്പോർട്സ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4792.jpeg",
    },
    {
      src: "assets/img/Pastevents/4780.jpeg",
      caption:
        "പേയാട് സെൻറ് സേവ്യേഴ്സ് മെഗാ എക്സ്പോ 2024, ആക്കുളം ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4780.jpeg",
    },
    {
      src: "assets/img/Pastevents/4781.jpeg",
      caption:
        "പേയാട് സെൻറ് സേവ്യേഴ്സ് മെഗാ എക്സ്പോ 2024, ആക്കുളം ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4781.jpeg",
    },
    {
      src: "assets/img/Pastevents/4782.jpeg",
      caption:
        "പേയാട് സെൻറ് സേവ്യേഴ്സ് മെഗാ എക്സ്പോ 2024, ആക്കുളം ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4782.jpeg",
    },
    {
      src: "assets/img/Pastevents/4783.jpeg",
      caption:
        "പേയാട് സെൻറ് സേവ്യേഴ്സ് മെഗാ എക്സ്പോ 2024, ആക്കുളം ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4783.jpeg",
    },
    {
      src: "assets/img/Pastevents/4784.jpeg",
      caption:
        "പേയാട് സെൻറ് സേവ്യേഴ്സ് മെഗാ എക്സ്പോ 2024, ആക്കുളം ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4784.jpeg",
    },
    {
      src: "assets/img/Pastevents/4785.jpeg",
      caption:
        "പേയാട് സെൻറ് സേവ്യേഴ്സ് മെഗാ എക്സ്പോ 2024, ആക്കുളം ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4785.jpeg",
    },
    {
      src: "assets/img/Pastevents/4786.jpeg",
      caption:
        "പേയാട് സെൻറ് സേവ്യേഴ്സ് മെഗാ എക്സ്പോ 2024, ആക്കുളം ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4786.jpeg",
    },
    {
      src: "assets/img/Pastevents/4774.jpeg",
      caption:
        "തോട്ടുംപ്പുറം ജുമാ മസ്ജിദിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4774.jpeg",
    },
    {
      src: "assets/img/Pastevents/4775.jpeg",
      caption:
        "തോട്ടുംപ്പുറം ജുമാ മസ്ജിദിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4775.jpeg",
    },
    {
      src: "assets/img/Pastevents/4776.jpeg",
      caption:
        "തോട്ടുംപ്പുറം ജുമാ മസ്ജിദിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4776.jpeg",
    },
    {
      src: "assets/img/Pastevents/4777.jpeg",
      caption:
        "തോട്ടുംപ്പുറം ജുമാ മസ്ജിദിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4777.jpeg",
    },
    {
      src: "assets/img/Pastevents/4778.jpeg",
      caption:
        "തോട്ടുംപ്പുറം ജുമാ മസ്ജിദിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4778.jpeg",
    },
    {
      src: "assets/img/Pastevents/4779.jpeg",
      caption:
        "തോട്ടുംപ്പുറം ജുമാ മസ്ജിദിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4779.jpeg",
    },
    {
      src: "assets/img/Pastevents/4768.jpeg",
      caption:
        "തിരുവട്ടാർ പൂജാരി സേവാ ട്രസ്റ്റ്, അരുവിയോടു താളത്രയം കലാ സാംസ്കാരിക വേദിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4768.jpeg",
    },
    {
      src: "assets/img/Pastevents/4769.jpeg",
      caption:
        "തിരുവട്ടാർ പൂജാരി സേവാ ട്രസ്റ്റ്, അരുവിയോടു താളത്രയം കലാ സാംസ്കാരിക വേദിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4769.jpeg",
    },
    {
      src: "assets/img/Pastevents/4770.jpeg",
      caption:
        "തിരുവട്ടാർ പൂജാരി സേവാ ട്രസ്റ്റ്, അരുവിയോടു താളത്രയം കലാ സാംസ്കാരിക വേദിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4770.jpeg",
    },
    {
      src: "assets/img/Pastevents/4771.jpeg",
      caption:
        "തിരുവട്ടാർ പൂജാരി സേവാ ട്രസ്റ്റ്, അരുവിയോടു താളത്രയം കലാ സാംസ്കാരിക വേദിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4771.jpeg",
    },
    {
      src: "assets/img/Pastevents/4772.jpeg",
      caption:
        "തിരുവട്ടാർ പൂജാരി സേവാ ട്രസ്റ്റ്, അരുവിയോടു താളത്രയം കലാ സാംസ്കാരിക വേദിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4772.jpeg",
    },
    {
      src: "assets/img/Pastevents/4773.jpeg",
      caption:
        "തിരുവട്ടാർ പൂജാരി സേവാ ട്രസ്റ്റ്, അരുവിയോടു താളത്രയം കലാ സാംസ്കാരിക വേദിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4773.jpeg",
    },
    {
      src: "assets/img/Pastevents/4760.jpeg",
      caption:
        "കുളത്തൂർ ഗാന്ധി നഗർ റെസിഡൻഷ്യൽ അസോസിയേഷൻ, കേരളാ സീനിയർ സിറ്റിസൺ, ട്രിവാൻഡ്രം സൗത്ത് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.  ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4760.jpeg",
    },
    {
      src: "assets/img/Pastevents/4761.jpeg",
      caption:
        "കുളത്തൂർ ഗാന്ധി നഗർ റെസിഡൻഷ്യൽ അസോസിയേഷൻ, കേരളാ സീനിയർ സിറ്റിസൺ, ട്രിവാൻഡ്രം സൗത്ത് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.  ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4761.jpeg",
    },
    {
      src: "assets/img/Pastevents/4762.jpeg",
      caption:
        "കുളത്തൂർ ഗാന്ധി നഗർ റെസിഡൻഷ്യൽ അസോസിയേഷൻ, കേരളാ സീനിയർ സിറ്റിസൺ, ട്രിവാൻഡ്രം സൗത്ത് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.  ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4762.jpeg",
    },
    {
      src: "assets/img/Pastevents/4763.jpeg",
      caption:
        "കുളത്തൂർ ഗാന്ധി നഗർ റെസിഡൻഷ്യൽ അസോസിയേഷൻ, കേരളാ സീനിയർ സിറ്റിസൺ, ട്രിവാൻഡ്രം സൗത്ത് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.  ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4763.jpeg",
    },
    {
      src: "assets/img/Pastevents/4764.jpeg",
      caption:
        "കുളത്തൂർ ഗാന്ധി നഗർ റെസിഡൻഷ്യൽ അസോസിയേഷൻ, കേരളാ സീനിയർ സിറ്റിസൺ, ട്രിവാൻഡ്രം സൗത്ത് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.  ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4764.jpeg",
    },
    {
      src: "assets/img/Pastevents/4765.jpeg",
      caption:
        "കുളത്തൂർ ഗാന്ധി നഗർ റെസിഡൻഷ്യൽ അസോസിയേഷൻ, കേരളാ സീനിയർ സിറ്റിസൺ, ട്രിവാൻഡ്രം സൗത്ത് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.  ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4765.jpeg",
    },
    {
      src: "assets/img/Pastevents/4766.jpeg",
      caption:
        "കുളത്തൂർ ഗാന്ധി നഗർ റെസിഡൻഷ്യൽ അസോസിയേഷൻ, കേരളാ സീനിയർ സിറ്റിസൺ, ട്രിവാൻഡ്രം സൗത്ത് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.  ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4766.jpeg",
    },
    {
      src: "assets/img/Pastevents/4767.jpeg",
      caption:
        "കുളത്തൂർ ഗാന്ധി നഗർ റെസിഡൻഷ്യൽ അസോസിയേഷൻ, കേരളാ സീനിയർ സിറ്റിസൺ, ട്രിവാൻഡ്രം സൗത്ത് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.  ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4767.jpeg",
    },
    {
      src: "assets/img/Pastevents/4754.jpeg",
      caption:
        "മുടവൻമുഗൽ ട്രിവാൻഡ്രം ഐകൺസിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4754.jpeg",
    },
    {
      src: "assets/img/Pastevents/4755.jpeg",
      caption:
        "മുടവൻമുഗൽ ട്രിവാൻഡ്രം ഐകൺസിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4755.jpeg",
    },
    {
      src: "assets/img/Pastevents/4756.jpeg",
      caption:
        "മുടവൻമുഗൽ ട്രിവാൻഡ്രം ഐകൺസിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4756.jpeg",
    },
    {
      src: "assets/img/Pastevents/4757.jpeg",
      caption:
        "മുടവൻമുഗൽ ട്രിവാൻഡ്രം ഐകൺസിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4757.jpeg",
    },
    {
      src: "assets/img/Pastevents/4758.jpeg",
      caption:
        "മുടവൻമുഗൽ ട്രിവാൻഡ്രം ഐകൺസിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4758.jpeg",
    },
    {
      src: "assets/img/Pastevents/4759.jpeg",
      caption:
        "മുടവൻമുഗൽ ട്രിവാൻഡ്രം ഐകൺസിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4759.jpeg",
    },
    {
      src: "assets/img/Pastevents/4748.jpeg",
      caption:
        "ചപ്പാത്ത് റെസിഡൻഷ്യൽ അസോസിയേഷൻ,വിഴിഞ്ഞം ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4748.jpeg",
    },
    {
      src: "assets/img/Pastevents/4749.jpeg",
      caption:
        "ചപ്പാത്ത് റെസിഡൻഷ്യൽ അസോസിയേഷൻ,വിഴിഞ്ഞം ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4749.jpeg",
    },
    {
      src: "assets/img/Pastevents/4750.jpeg",
      caption:
        "ചപ്പാത്ത് റെസിഡൻഷ്യൽ അസോസിയേഷൻ,വിഴിഞ്ഞം ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4750.jpeg",
    },
    {
      src: "assets/img/Pastevents/4751.jpeg",
      caption:
        "ചപ്പാത്ത് റെസിഡൻഷ്യൽ അസോസിയേഷൻ,വിഴിഞ്ഞം ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4751.jpeg",
    },
    {
      src: "assets/img/Pastevents/4752.jpeg",
      caption:
        "ചപ്പാത്ത് റെസിഡൻഷ്യൽ അസോസിയേഷൻ,വിഴിഞ്ഞം ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4752.jpeg",
    },
    {
      src: "assets/img/Pastevents/4753.jpeg",
      caption:
        "ചപ്പാത്ത് റെസിഡൻഷ്യൽ അസോസിയേഷൻ,വിഴിഞ്ഞം ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4753.jpeg",
    },
    {
      src: "assets/img/Pastevents/4742.jpeg",
      caption:
        "പുന്നക്കാട് മാനുഷം കലാ സാംസ്കാരിക വേദിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4742.jpeg",
    },
    {
      src: "assets/img/Pastevents/4743.jpeg",
      caption:
        "പുന്നക്കാട് മാനുഷം കലാ സാംസ്കാരിക വേദിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4743.jpeg",
    },
    {
      src: "assets/img/Pastevents/4744.jpeg",
      caption:
        "പുന്നക്കാട് മാനുഷം കലാ സാംസ്കാരിക വേദിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4744.jpeg",
    },
    {
      src: "assets/img/Pastevents/4745.jpeg",
      caption:
        "പുന്നക്കാട് മാനുഷം കലാ സാംസ്കാരിക വേദിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4745.jpeg",
    },
    {
      src: "assets/img/Pastevents/4746.jpeg",
      caption:
        "പുന്നക്കാട് മാനുഷം കലാ സാംസ്കാരിക വേദിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4746.jpeg",
    },
    {
      src: "assets/img/Pastevents/4747.jpeg",
      caption:
        "പുന്നക്കാട് മാനുഷം കലാ സാംസ്കാരിക വേദിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4747.jpeg",
    },
    {
      src: "assets/img/Pastevents/4737.jpeg",
      caption:
        "മരിയാപുരം വി എഫ് പി സി കെ യൂണിറ്റ് , ട്രിവാൻഡ്രം നോവാ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4737.jpeg",
    },
    {
      src: "assets/img/Pastevents/4738.jpeg",
      caption:
        "മരിയാപുരം വി എഫ് പി സി കെ യൂണിറ്റ് , ട്രിവാൻഡ്രം നോവാ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4738.jpeg",
    },
    {
      src: "assets/img/Pastevents/4739.jpeg",
      caption:
        "മരിയാപുരം വി എഫ് പി സി കെ യൂണിറ്റ് , ട്രിവാൻഡ്രം നോവാ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4739.jpeg",
    },
    {
      src: "assets/img/Pastevents/4740.jpeg",
      caption:
        "മരിയാപുരം വി എഫ് പി സി കെ യൂണിറ്റ് , ട്രിവാൻഡ്രം നോവാ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4740.jpeg",
    },
    {
      src: "assets/img/Pastevents/4741.jpeg",
      caption:
        "മരിയാപുരം വി എഫ് പി സി കെ യൂണിറ്റ് , ട്രിവാൻഡ്രം നോവാ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4741.jpeg",
    },
    {
      src: "assets/img/Pastevents/4731.jpeg",
      caption:
        "കീഴാരൂർ ശ്രീ സരസ്വതി വിദ്യാലയത്തിൻ്റെയും  നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4731.jpeg",
    },
    {
      src: "assets/img/Pastevents/4732.jpeg",
      caption:
        "കീഴാരൂർ ശ്രീ സരസ്വതി വിദ്യാലയത്തിൻ്റെയും  നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4732.jpeg",
    },
    {
      src: "assets/img/Pastevents/4733.jpeg",
      caption:
        "കീഴാരൂർ ശ്രീ സരസ്വതി വിദ്യാലയത്തിൻ്റെയും  നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4733.jpeg",
    },
    {
      src: "assets/img/Pastevents/4734.jpeg",
      caption:
        "കീഴാരൂർ ശ്രീ സരസ്വതി വിദ്യാലയത്തിൻ്റെയും  നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4734.jpeg",
    },
    {
      src: "assets/img/Pastevents/4735.jpeg",
      caption:
        "കീഴാരൂർ ശ്രീ സരസ്വതി വിദ്യാലയത്തിൻ്റെയും  നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4735.jpeg",
    },
    {
      src: "assets/img/Pastevents/4736.jpeg",
      caption:
        "കീഴാരൂർ ശ്രീ സരസ്വതി വിദ്യാലയത്തിൻ്റെയും  നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4736.jpeg",
    },
    {
      src: "assets/img/Pastevents/4725.jpeg",
      caption:
        "തവരവിള കാരുണ്യ സ്പെഷ്യൽ ഹോമിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4725.jpeg",
    },
    {
      src: "assets/img/Pastevents/4726.jpeg",
      caption:
        "തവരവിള കാരുണ്യ സ്പെഷ്യൽ ഹോമിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4726.jpeg",
    },
    {
      src: "assets/img/Pastevents/4727.jpeg",
      caption:
        "തവരവിള കാരുണ്യ സ്പെഷ്യൽ ഹോമിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4727.jpeg",
    },
    {
      src: "assets/img/Pastevents/4728.jpeg",
      caption:
        "തവരവിള കാരുണ്യ സ്പെഷ്യൽ ഹോമിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4728.jpeg",
    },
    {
      src: "assets/img/Pastevents/4729.jpeg",
      caption:
        "തവരവിള കാരുണ്യ സ്പെഷ്യൽ ഹോമിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4729.jpeg",
    },
    {
      src: "assets/img/Pastevents/4730.jpeg",
      caption:
        "തവരവിള കാരുണ്യ സ്പെഷ്യൽ ഹോമിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4730.jpeg",
    },
    {
      src: "assets/img/Pastevents/4719.jpeg",
      caption:
        "വലിയശാല സതേൺ പീപ്പിൾസ് പ്രൈഡ് പ്രൊഡ്യൂസേഴ്സ് കമ്പനിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4719.jpeg",
    },
    {
      src: "assets/img/Pastevents/4720.jpeg",
      caption:
        "വലിയശാല സതേൺ പീപ്പിൾസ് പ്രൈഡ് പ്രൊഡ്യൂസേഴ്സ് കമ്പനിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4720.jpeg",
    },
    {
      src: "assets/img/Pastevents/4721.jpeg",
      caption:
        "വലിയശാല സതേൺ പീപ്പിൾസ് പ്രൈഡ് പ്രൊഡ്യൂസേഴ്സ് കമ്പനിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4721.jpeg",
    },
    {
      src: "assets/img/Pastevents/4722.jpeg",
      caption:
        "വലിയശാല സതേൺ പീപ്പിൾസ് പ്രൈഡ് പ്രൊഡ്യൂസേഴ്സ് കമ്പനിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4722.jpeg",
    },
    {
      src: "assets/img/Pastevents/4723.jpeg",
      caption:
        "വലിയശാല സതേൺ പീപ്പിൾസ് പ്രൈഡ് പ്രൊഡ്യൂസേഴ്സ് കമ്പനിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4723.jpeg",
    },
    {
      src: "assets/img/Pastevents/4724.jpeg",
      caption:
        "വലിയശാല സതേൺ പീപ്പിൾസ് പ്രൈഡ് പ്രൊഡ്യൂസേഴ്സ് കമ്പനിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4724.jpeg",
    },
    {
      src: "assets/img/Pastevents/4713.jpeg",
      caption:
        "തോന്നയ്ക്കൽ ഭാരത് പെട്രോളിയം ലിമിറ്റെഡിൻ്റെയും  നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4713.jpeg",
    },
    {
      src: "assets/img/Pastevents/4714.jpeg",
      caption:
        "തോന്നയ്ക്കൽ ഭാരത് പെട്രോളിയം ലിമിറ്റെഡിൻ്റെയും  നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4714.jpeg",
    },
      {
      src: "assets/img/Pastevents/4715.jpeg",
      caption:
        "തോന്നയ്ക്കൽ ഭാരത് പെട്രോളിയം ലിമിറ്റെഡിൻ്റെയും  നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4715.jpeg",
    },
      {
      src: "assets/img/Pastevents/4716.jpeg",
      caption:
        "തോന്നയ്ക്കൽ ഭാരത് പെട്രോളിയം ലിമിറ്റെഡിൻ്റെയും  നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4716.jpeg",
    },
    {
      src: "assets/img/Pastevents/4717.jpeg",
      caption:
        "തോന്നയ്ക്കൽ ഭാരത് പെട്രോളിയം ലിമിറ്റെഡിൻ്റെയും  നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4717.jpeg",
    },
    {
      src: "assets/img/Pastevents/4718.jpeg",
      caption:
        "തോന്നയ്ക്കൽ ഭാരത് പെട്രോളിയം ലിമിറ്റെഡിൻ്റെയും  നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4718.jpeg",
    },
    {
      src: "assets/img/Pastevents/4707.jpeg",
      caption:
        "കരിയംകുളം ശ്രീ ഭഗവതി ക്ഷേത്ര ട്രസ്റ്റ്, തിരുവനന്തപുരം സിറ്റി ലയൺസ് ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4707.jpeg",
    },
    {
      src: "assets/img/Pastevents/4708.jpeg",
      caption:
        "കരിയംകുളം ശ്രീ ഭഗവതി ക്ഷേത്ര ട്രസ്റ്റ്, തിരുവനന്തപുരം സിറ്റി ലയൺസ് ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4708.jpeg",
    },
    {
      src: "assets/img/Pastevents/4709.jpeg",
      caption:
        "കരിയംകുളം ശ്രീ ഭഗവതി ക്ഷേത്ര ട്രസ്റ്റ്, തിരുവനന്തപുരം സിറ്റി ലയൺസ് ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4709.jpeg",
    },
    {
      src: "assets/img/Pastevents/4710.jpeg",
      caption:
        "കരിയംകുളം ശ്രീ ഭഗവതി ക്ഷേത്ര ട്രസ്റ്റ്, തിരുവനന്തപുരം സിറ്റി ലയൺസ് ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4710.jpeg",
    },
    {
      src: "assets/img/Pastevents/4711.jpeg",
      caption:
        "കരിയംകുളം ശ്രീ ഭഗവതി ക്ഷേത്ര ട്രസ്റ്റ്, തിരുവനന്തപുരം സിറ്റി ലയൺസ് ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4711.jpeg",
    },
    {
      src: "assets/img/Pastevents/4712.jpeg",
      caption:
        "കരിയംകുളം ശ്രീ ഭഗവതി ക്ഷേത്ര ട്രസ്റ്റ്, തിരുവനന്തപുരം സിറ്റി ലയൺസ് ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4712.jpeg",
    },
    {
      src: "assets/img/Pastevents/4700.jpeg",
      caption:
        " പൂഴിക്കുന്ന് മൈത്രി റെസിഡൻഷ്യൽ അസോസിയേഷൻ,ട്രിവാൻഡ്രം റെയിൻബോ ലയൺസ് ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4700.jpeg",
    },
    {
      src: "assets/img/Pastevents/4701.jpeg",
      caption:
        " പൂഴിക്കുന്ന് മൈത്രി റെസിഡൻഷ്യൽ അസോസിയേഷൻ,ട്രിവാൻഡ്രം റെയിൻബോ ലയൺസ് ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4701.jpeg",
    },
    {
      src: "assets/img/Pastevents/4702.jpeg",
      caption:
        " പൂഴിക്കുന്ന് മൈത്രി റെസിഡൻഷ്യൽ അസോസിയേഷൻ,ട്രിവാൻഡ്രം റെയിൻബോ ലയൺസ് ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4702.jpeg",
    },
    {
      src: "assets/img/Pastevents/4703.jpeg",
      caption:
        " പൂഴിക്കുന്ന് മൈത്രി റെസിഡൻഷ്യൽ അസോസിയേഷൻ,ട്രിവാൻഡ്രം റെയിൻബോ ലയൺസ് ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4703.jpeg",
    },
    {
      src: "assets/img/Pastevents/4704.jpeg",
      caption:
        " പൂഴിക്കുന്ന് മൈത്രി റെസിഡൻഷ്യൽ അസോസിയേഷൻ,ട്രിവാൻഡ്രം റെയിൻബോ ലയൺസ് ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4704.jpeg",
    },
    {
      src: "assets/img/Pastevents/4705.jpeg",
      caption:
        " പൂഴിക്കുന്ന് മൈത്രി റെസിഡൻഷ്യൽ അസോസിയേഷൻ,ട്രിവാൻഡ്രം റെയിൻബോ ലയൺസ് ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4705.jpeg",
    },
    {
      src: "assets/img/Pastevents/4706.jpeg",
      caption:
        " പൂഴിക്കുന്ന് മൈത്രി റെസിഡൻഷ്യൽ അസോസിയേഷൻ,ട്രിവാൻഡ്രം റെയിൻബോ ലയൺസ് ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4706.jpeg",
    },
    {
      src: "assets/img/Pastevents/4694.jpeg",
      caption:
        "കിഴുവിലം ഗ്രാമപഞ്ചായത്ത്, പെരുങ്ങുഴി ലയൺസ് ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4694.jpeg",
    },
    {
      src: "assets/img/Pastevents/4695.jpeg",
      caption:
        "കിഴുവിലം ഗ്രാമപഞ്ചായത്ത്, പെരുങ്ങുഴി ലയൺസ് ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4695.jpeg",
    },
    {
      src: "assets/img/Pastevents/4696.jpeg",
      caption:
        "കിഴുവിലം ഗ്രാമപഞ്ചായത്ത്, പെരുങ്ങുഴി ലയൺസ് ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4696.jpeg",
    },
    {
      src: "assets/img/Pastevents/4697.jpeg",
      caption:
        "കിഴുവിലം ഗ്രാമപഞ്ചായത്ത്, പെരുങ്ങുഴി ലയൺസ് ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4697.jpeg",
    },
    {
      src: "assets/img/Pastevents/4698.jpeg",
      caption:
        "കിഴുവിലം ഗ്രാമപഞ്ചായത്ത്, പെരുങ്ങുഴി ലയൺസ് ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4698.jpeg",
    },
    {
      src: "assets/img/Pastevents/4699.jpeg",
      caption:
        "കിഴുവിലം ഗ്രാമപഞ്ചായത്ത്, പെരുങ്ങുഴി ലയൺസ് ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4699.jpeg",
    },
    {
      src: "assets/img/Pastevents/4688.jpeg",
      caption:
        "അയ്യൻകാളി ജന്മദിനാഘോഷത്തോട് അനുബന്ധിച്ച് പുലയനാർക്കോട്ട കെ പി എം എസ് യൂണിറ്റ്, ആശുപത്രി സംരക്ഷണ സമിതിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4688.jpeg",
    },
    {
      src: "assets/img/Pastevents/4689.jpeg",
      caption:
        "അയ്യൻകാളി ജന്മദിനാഘോഷത്തോട് അനുബന്ധിച്ച് പുലയനാർക്കോട്ട കെ പി എം എസ് യൂണിറ്റ്, ആശുപത്രി സംരക്ഷണ സമിതിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4689.jpeg",
    },
    {
      src: "assets/img/Pastevents/4690.jpeg",
      caption:
        "അയ്യൻകാളി ജന്മദിനാഘോഷത്തോട് അനുബന്ധിച്ച് പുലയനാർക്കോട്ട കെ പി എം എസ് യൂണിറ്റ്, ആശുപത്രി സംരക്ഷണ സമിതിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4690.jpeg",
    },
    {
      src: "assets/img/Pastevents/4691.jpeg",
      caption:
        "അയ്യൻകാളി ജന്മദിനാഘോഷത്തോട് അനുബന്ധിച്ച് പുലയനാർക്കോട്ട കെ പി എം എസ് യൂണിറ്റ്, ആശുപത്രി സംരക്ഷണ സമിതിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4691.jpeg",
    },
    {
      src: "assets/img/Pastevents/4692.jpeg",
      caption:
        "അയ്യൻകാളി ജന്മദിനാഘോഷത്തോട് അനുബന്ധിച്ച് പുലയനാർക്കോട്ട കെ പി എം എസ് യൂണിറ്റ്, ആശുപത്രി സംരക്ഷണ സമിതിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4692.jpeg",
    },
    {
      src: "assets/img/Pastevents/4693.jpeg",
      caption:
        "അയ്യൻകാളി ജന്മദിനാഘോഷത്തോട് അനുബന്ധിച്ച് പുലയനാർക്കോട്ട കെ പി എം എസ് യൂണിറ്റ്, ആശുപത്രി സംരക്ഷണ സമിതിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4693.jpeg",
    },
    {
      src: "assets/img/Pastevents/4681.jpeg",
      caption:
        "പേരൂർക്കട ലയൺസ് ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4681.jpeg",
    },
    {
      src: "assets/img/Pastevents/4682.jpeg",
      caption:
        "പേരൂർക്കട ലയൺസ് ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4682.jpeg",
    },
    {
      src: "assets/img/Pastevents/4683.jpeg",
      caption:
        "പേരൂർക്കട ലയൺസ് ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4683.jpeg",
    },
    {
      src: "assets/img/Pastevents/4684.jpeg",
      caption:
        "പേരൂർക്കട ലയൺസ് ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4684.jpeg",
    },
    {
      src: "assets/img/Pastevents/4685.jpeg",
      caption:
        "പേരൂർക്കട ലയൺസ് ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4685.jpeg",
    },
    {
      src: "assets/img/Pastevents/4686.jpeg",
      caption:
        "പേരൂർക്കട ലയൺസ് ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4686.jpeg",
    },
    {
      src: "assets/img/Pastevents/4687.jpeg",
      caption:
        "പേരൂർക്കട ലയൺസ് ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4687.jpeg",
    },
    {
      src: "assets/img/Pastevents/4673.jpeg",
      caption:
        "കേരളാ കൗമുദി ബോധപൗർണ്ണമി ക്ലബ്, വിൻഡോസ് ഓഫ് കേരളാ മാഗസിൻ, ഗവ.എച്ച് എസ് എസ് കാച്ചാണി നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പും വിദ്യാർഥികൾക്ക് സൗജന്യ ഫലത്തൈ വിതരണവും സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4673.jpeg",
    },
    {
      src: "assets/img/Pastevents/4674.jpeg",
      caption:
        "കേരളാ കൗമുദി ബോധപൗർണ്ണമി ക്ലബ്, വിൻഡോസ് ഓഫ് കേരളാ മാഗസിൻ, ഗവ.എച്ച് എസ് എസ് കാച്ചാണി നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പും വിദ്യാർഥികൾക്ക് സൗജന്യ ഫലത്തൈ വിതരണവും സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4674.jpeg",
    },
    {
      src: "assets/img/Pastevents/4675.jpeg",
      caption:
        "കേരളാ കൗമുദി ബോധപൗർണ്ണമി ക്ലബ്, വിൻഡോസ് ഓഫ് കേരളാ മാഗസിൻ, ഗവ.എച്ച് എസ് എസ് കാച്ചാണി നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പും വിദ്യാർഥികൾക്ക് സൗജന്യ ഫലത്തൈ വിതരണവും സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4675.jpeg",
    },
    {
      src: "assets/img/Pastevents/4676.jpeg",
      caption:
        "കേരളാ കൗമുദി ബോധപൗർണ്ണമി ക്ലബ്, വിൻഡോസ് ഓഫ് കേരളാ മാഗസിൻ, ഗവ.എച്ച് എസ് എസ് കാച്ചാണി നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പും വിദ്യാർഥികൾക്ക് സൗജന്യ ഫലത്തൈ വിതരണവും സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4676.jpeg",
    },
    {
      src: "assets/img/Pastevents/4677.jpeg",
      caption:
        "കേരളാ കൗമുദി ബോധപൗർണ്ണമി ക്ലബ്, വിൻഡോസ് ഓഫ് കേരളാ മാഗസിൻ, ഗവ.എച്ച് എസ് എസ് കാച്ചാണി നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പും വിദ്യാർഥികൾക്ക് സൗജന്യ ഫലത്തൈ വിതരണവും സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4677.jpeg",
    },
    {
      src: "assets/img/Pastevents/4678.jpeg",
      caption:
        "കേരളാ കൗമുദി ബോധപൗർണ്ണമി ക്ലബ്, വിൻഡോസ് ഓഫ് കേരളാ മാഗസിൻ, ഗവ.എച്ച് എസ് എസ് കാച്ചാണി നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പും വിദ്യാർഥികൾക്ക് സൗജന്യ ഫലത്തൈ വിതരണവും സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4678.jpeg",
    },
     {
      src: "assets/img/Pastevents/4679.jpeg",
      caption:
        "കേരളാ കൗമുദി ബോധപൗർണ്ണമി ക്ലബ്, വിൻഡോസ് ഓഫ് കേരളാ മാഗസിൻ, ഗവ.എച്ച് എസ് എസ് കാച്ചാണി നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പും വിദ്യാർഥികൾക്ക് സൗജന്യ ഫലത്തൈ വിതരണവും സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4679.jpeg",
    },
    {
      src: "assets/img/Pastevents/4680.jpeg",
      caption:
        "കേരളാ കൗമുദി ബോധപൗർണ്ണമി ക്ലബ്, വിൻഡോസ് ഓഫ് കേരളാ മാഗസിൻ, ഗവ.എച്ച് എസ് എസ് കാച്ചാണി നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പും വിദ്യാർഥികൾക്ക് സൗജന്യ ഫലത്തൈ വിതരണവും സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4680.jpeg",
    },
    {
      src: "assets/img/Pastevents/4667.jpeg",
      caption:
        "കോവിലുവിള ശ്രീ കൃഷ്ണസ്വാമി ക്ഷേത്ര ട്രസ്റ്റ്,സേവാഭാരതി ആര്യൻങ്കോട് പഞ്ചായത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4667.jpeg",
    },
    {
      src: "assets/img/Pastevents/4668.jpeg",
      caption:
        "കോവിലുവിള ശ്രീ കൃഷ്ണസ്വാമി ക്ഷേത്ര ട്രസ്റ്റ്,സേവാഭാരതി ആര്യൻങ്കോട് പഞ്ചായത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4668.jpeg",
    },
    {
      src: "assets/img/Pastevents/4669.jpeg",
      caption:
        "കോവിലുവിള ശ്രീ കൃഷ്ണസ്വാമി ക്ഷേത്ര ട്രസ്റ്റ്,സേവാഭാരതി ആര്യൻങ്കോട് പഞ്ചായത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4669.jpeg",
    },
    {
      src: "assets/img/Pastevents/4670.jpeg",
      caption:
        "കോവിലുവിള ശ്രീ കൃഷ്ണസ്വാമി ക്ഷേത്ര ട്രസ്റ്റ്,സേവാഭാരതി ആര്യൻങ്കോട് പഞ്ചായത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4670.jpeg",
    },
    {
      src: "assets/img/Pastevents/4671.jpeg",
      caption:
        "കോവിലുവിള ശ്രീ കൃഷ്ണസ്വാമി ക്ഷേത്ര ട്രസ്റ്റ്,സേവാഭാരതി ആര്യൻങ്കോട് പഞ്ചായത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4671.jpeg",
    },
    {
      src: "assets/img/Pastevents/4672.jpeg",
      caption:
        "കോവിലുവിള ശ്രീ കൃഷ്ണസ്വാമി ക്ഷേത്ര ട്രസ്റ്റ്,സേവാഭാരതി ആര്യൻങ്കോട് പഞ്ചായത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4672.jpeg",
    },
    {
      src: "assets/img/Pastevents/4660.jpeg",
      caption:
        "തിരുമല അരയല്ലൂർ - എളളുവിള റെസിഡൻഷ്യൽ അസോസിയേഷൻൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4660.jpeg",
    },
    {
      src: "assets/img/Pastevents/4661.jpeg",
      caption:
        "തിരുമല അരയല്ലൂർ - എളളുവിള റെസിഡൻഷ്യൽ അസോസിയേഷൻൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4661.jpeg",
    },
    {
      src: "assets/img/Pastevents/4662.jpeg",
      caption:
        "തിരുമല അരയല്ലൂർ - എളളുവിള റെസിഡൻഷ്യൽ അസോസിയേഷൻൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4662.jpeg",
    },
    {
      src: "assets/img/Pastevents/4663.jpeg",
      caption:
        "തിരുമല അരയല്ലൂർ - എളളുവിള റെസിഡൻഷ്യൽ അസോസിയേഷൻൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4663.jpeg",
    },
    {
      src: "assets/img/Pastevents/4664.jpeg",
      caption:
        "തിരുമല അരയല്ലൂർ - എളളുവിള റെസിഡൻഷ്യൽ അസോസിയേഷൻൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4664.jpeg",
    },
    {
      src: "assets/img/Pastevents/4665.jpeg",
      caption:
        "തിരുമല അരയല്ലൂർ - എളളുവിള റെസിഡൻഷ്യൽ അസോസിയേഷൻൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4665.jpeg",
    },
    {
      src: "assets/img/Pastevents/4666.jpeg",
      caption:
        "തിരുമല അരയല്ലൂർ - എളളുവിള റെസിഡൻഷ്യൽ അസോസിയേഷൻൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4666.jpeg",
    },
    {
      src: "assets/img/Pastevents/4654.jpeg",
      caption:
        "അഞ്ചൽ ടൗൺ ലയൺസ് ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4654.jpeg",
    },
    {
      src: "assets/img/Pastevents/4655.jpeg",
      caption:
        "അഞ്ചൽ ടൗൺ ലയൺസ് ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4655.jpeg",
    },
    {
      src: "assets/img/Pastevents/4656.jpeg",
      caption:
        "അഞ്ചൽ ടൗൺ ലയൺസ് ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4656.jpeg",
    },
    {
      src: "assets/img/Pastevents/4657.jpeg",
      caption:
        "അഞ്ചൽ ടൗൺ ലയൺസ് ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4657.jpeg",
    },
    {
      src: "assets/img/Pastevents/4658.jpeg",
      caption:
        "അഞ്ചൽ ടൗൺ ലയൺസ് ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4658.jpeg",
    },
    {
      src: "assets/img/Pastevents/4659.jpeg",
      caption:
        "അഞ്ചൽ ടൗൺ ലയൺസ് ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4659.jpeg",
    },
    {
      src: "assets/img/Pastevents/4649.jpeg",
      caption:
        " തിരുവട്ടാർ പൂജാരി സേവാ ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4649.jpeg",
    },
    {
      src: "assets/img/Pastevents/4650.jpeg",
      caption:
        " തിരുവട്ടാർ പൂജാരി സേവാ ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4650.jpeg",
    },
    {
      src: "assets/img/Pastevents/4651.jpeg",
      caption:
        " തിരുവട്ടാർ പൂജാരി സേവാ ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4651.jpeg",
    },
    {
      src: "assets/img/Pastevents/4652.jpeg",
      caption:
        " തിരുവട്ടാർ പൂജാരി സേവാ ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4652.jpeg",
    },
    {
      src: "assets/img/Pastevents/4653.jpeg",
      caption:
        " തിരുവട്ടാർ പൂജാരി സേവാ ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4653.jpeg",
    },
    {
      src: "assets/img/Pastevents/4640.jpeg",
      caption:
        "നേമം ജനമൈത്രി പോലീസ് സ്റ്റേഷൻ, നേമം ജനമൈത്രി സമിതി, ഗവ: മോഡൽ എച്ച് എസ് എസ് എസ് പുന്നമ്മൂട് പി സി യൂണിറ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4640.jpeg",
    },
    {
      src: "assets/img/Pastevents/4641.jpeg",
      caption:
        "നേമം ജനമൈത്രി പോലീസ് സ്റ്റേഷൻ, നേമം ജനമൈത്രി സമിതി, ഗവ: മോഡൽ എച്ച് എസ് എസ് എസ് പുന്നമ്മൂട് പി സി യൂണിറ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4641.jpeg",
    },
    {
      src: "assets/img/Pastevents/4642.jpeg",
      caption:
        "നേമം ജനമൈത്രി പോലീസ് സ്റ്റേഷൻ, നേമം ജനമൈത്രി സമിതി, ഗവ: മോഡൽ എച്ച് എസ് എസ് എസ് പുന്നമ്മൂട് പി സി യൂണിറ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4642.jpeg",
    },
    {
      src: "assets/img/Pastevents/4643.jpeg",
      caption:
        "നേമം ജനമൈത്രി പോലീസ് സ്റ്റേഷൻ, നേമം ജനമൈത്രി സമിതി, ഗവ: മോഡൽ എച്ച് എസ് എസ് എസ് പുന്നമ്മൂട് പി സി യൂണിറ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4643.jpeg",
    },
    {
      src: "assets/img/Pastevents/4644.jpeg",
      caption:
        "നേമം ജനമൈത്രി പോലീസ് സ്റ്റേഷൻ, നേമം ജനമൈത്രി സമിതി, ഗവ: മോഡൽ എച്ച് എസ് എസ് എസ് പുന്നമ്മൂട് പി സി യൂണിറ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4644.jpeg",
    },
    {
      src: "assets/img/Pastevents/4645.jpeg",
      caption:
        "നേമം ജനമൈത്രി പോലീസ് സ്റ്റേഷൻ, നേമം ജനമൈത്രി സമിതി, ഗവ: മോഡൽ എച്ച് എസ് എസ് എസ് പുന്നമ്മൂട് പി സി യൂണിറ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4645.jpeg",
    },
    {
      src: "assets/img/Pastevents/4646.jpeg",
      caption:
        "നേമം ജനമൈത്രി പോലീസ് സ്റ്റേഷൻ, നേമം ജനമൈത്രി സമിതി, ഗവ: മോഡൽ എച്ച് എസ് എസ് എസ് പുന്നമ്മൂട് പി സി യൂണിറ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4646.jpeg",
    },
    {
      src: "assets/img/Pastevents/4647.jpeg",
      caption:
        "നേമം ജനമൈത്രി പോലീസ് സ്റ്റേഷൻ, നേമം ജനമൈത്രി സമിതി, ഗവ: മോഡൽ എച്ച് എസ് എസ് എസ് പുന്നമ്മൂട് പി സി യൂണിറ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4647.jpeg",
    },
    {
      src: "assets/img/Pastevents/4648.jpeg",
      caption:
        "നേമം ജനമൈത്രി പോലീസ് സ്റ്റേഷൻ, നേമം ജനമൈത്രി സമിതി, ഗവ: മോഡൽ എച്ച് എസ് എസ് എസ് പുന്നമ്മൂട് പി സി യൂണിറ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4648.jpeg",
    },
    {
      src: "assets/img/Pastevents/4635.jpeg",
      caption:
        "കട്ടച്ചൽക്കുഴി എസ് എൻ എൻ ഡി പി യോഗം, വിഴിഞ്ഞം ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4635.jpeg",
    },
    {
      src: "assets/img/Pastevents/4636.jpeg",
      caption:
        "കട്ടച്ചൽക്കുഴി എസ് എൻ എൻ ഡി പി യോഗം, വിഴിഞ്ഞം ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4636.jpeg",
    },
    {
      src: "assets/img/Pastevents/4637.jpeg",
      caption:
        "കട്ടച്ചൽക്കുഴി എസ് എൻ എൻ ഡി പി യോഗം, വിഴിഞ്ഞം ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4637.jpeg",
    },
    {
      src: "assets/img/Pastevents/4638.jpeg",
      caption:
        "കട്ടച്ചൽക്കുഴി എസ് എൻ എൻ ഡി പി യോഗം, വിഴിഞ്ഞം ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4638.jpeg",
    },
    {
      src: "assets/img/Pastevents/4639.jpeg",
      caption:
        "കട്ടച്ചൽക്കുഴി എസ് എൻ എൻ ഡി പി യോഗം, വിഴിഞ്ഞം ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4639.jpeg",
    },
    {
      src: "assets/img/Pastevents/4628.jpeg",
      caption:
        "വട്ടിയൂർക്കാവ് ശ്രീ സത്യസായി ക്ഷേത്ര സമിതി, പനയ്ക്കോട് എൻ എസ് എസ് യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4628.jpeg",
    },
    {
      src: "assets/img/Pastevents/4629.jpeg",
      caption:
        "വട്ടിയൂർക്കാവ് ശ്രീ സത്യസായി ക്ഷേത്ര സമിതി, പനയ്ക്കോട് എൻ എസ് എസ് യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4629.jpeg",
    },
    {
      src: "assets/img/Pastevents/4630.jpeg",
      caption:
        "വട്ടിയൂർക്കാവ് ശ്രീ സത്യസായി ക്ഷേത്ര സമിതി, പനയ്ക്കോട് എൻ എസ് എസ് യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4630.jpeg",
    },
    {
      src: "assets/img/Pastevents/4631.jpeg",
      caption:
        "വട്ടിയൂർക്കാവ് ശ്രീ സത്യസായി ക്ഷേത്ര സമിതി, പനയ്ക്കോട് എൻ എസ് എസ് യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4631.jpeg",
    },
    {
      src: "assets/img/Pastevents/4632.jpeg",
      caption:
        "വട്ടിയൂർക്കാവ് ശ്രീ സത്യസായി ക്ഷേത്ര സമിതി, പനയ്ക്കോട് എൻ എസ് എസ് യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4632.jpeg",
    },
    {
      src: "assets/img/Pastevents/4633.jpeg",
      caption:
        "വട്ടിയൂർക്കാവ് ശ്രീ സത്യസായി ക്ഷേത്ര സമിതി, പനയ്ക്കോട് എൻ എസ് എസ് യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4633.jpeg",
    },
    {
      src: "assets/img/Pastevents/4634.jpeg",
      caption:
        "വട്ടിയൂർക്കാവ് ശ്രീ സത്യസായി ക്ഷേത്ര സമിതി, പനയ്ക്കോട് എൻ എസ് എസ് യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4634.jpeg",
    },
  {
      src: "assets/img/Pastevents/4622.jpeg",
      caption:
        "തമിഴ്നാട് ഗവ: ഇൻഷൂറൻസ് സ്കീം, നാഗർകോവിൽ  വി സി കെ യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4622.jpeg",
    },
    {
      src: "assets/img/Pastevents/4623.jpeg",
      caption:
        "തമിഴ്നാട് ഗവ: ഇൻഷൂറൻസ് സ്കീം, നാഗർകോവിൽ  വി സി കെ യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4623.jpeg",
    },
    {
      src: "assets/img/Pastevents/4624.jpeg",
      caption:
        "തമിഴ്നാട് ഗവ: ഇൻഷൂറൻസ് സ്കീം, നാഗർകോവിൽ  വി സി കെ യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4624.jpeg",
    },
    {
      src: "assets/img/Pastevents/4625.jpeg",
      caption:
        "തമിഴ്നാട് ഗവ: ഇൻഷൂറൻസ് സ്കീം, നാഗർകോവിൽ  വി സി കെ യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4625.jpeg",
    },
    {
      src: "assets/img/Pastevents/4626.jpeg",
      caption:
        "തമിഴ്നാട് ഗവ: ഇൻഷൂറൻസ് സ്കീം, നാഗർകോവിൽ  വി സി കെ യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4626.jpeg",
    },
    {
      src: "assets/img/Pastevents/4627.jpeg",
      caption:
        "തമിഴ്നാട് ഗവ: ഇൻഷൂറൻസ് സ്കീം, നാഗർകോവിൽ  വി സി കെ യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4627.jpeg",
    },
    {
      src: "assets/img/Pastevents/4616.jpeg",
      caption:
        "ഈസ്റ്റർ ഫോർട്ട് കെ എസ് ആർ ടി സി സിറ്റി യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4616.jpeg",
    },
    {
      src: "assets/img/Pastevents/4617.jpeg",
      caption:
        "ഈസ്റ്റർ ഫോർട്ട് കെ എസ് ആർ ടി സി സിറ്റി യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4617.jpeg",
    },
    {
      src: "assets/img/Pastevents/4618.jpeg",
      caption:
        "ഈസ്റ്റർ ഫോർട്ട് കെ എസ് ആർ ടി സി സിറ്റി യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4618.jpeg",
    },{
      src: "assets/img/Pastevents/4619.jpeg",
      caption:
        "ഈസ്റ്റർ ഫോർട്ട് കെ എസ് ആർ ടി സി സിറ്റി യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4619.jpeg",
    },
    {
      src: "assets/img/Pastevents/4620.jpeg",
      caption:
        "ഈസ്റ്റർ ഫോർട്ട് കെ എസ് ആർ ടി സി സിറ്റി യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4620.jpeg",
    },
    {
      src: "assets/img/Pastevents/4621.jpeg",
      caption:
        "ഈസ്റ്റർ ഫോർട്ട് കെ എസ് ആർ ടി സി സിറ്റി യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4621.jpeg",
    },
    {
      src: "assets/img/Pastevents/4611.jpeg",
      caption:
        " തിരുവട്ടാർ പൂജാരി സേവാ ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4611.jpeg",
    },
    {
      src: "assets/img/Pastevents/4612.jpeg",
      caption:
        " തിരുവട്ടാർ പൂജാരി സേവാ ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4612.jpeg",
    },
    {
      src: "assets/img/Pastevents/4613.jpeg",
      caption:
        " തിരുവട്ടാർ പൂജാരി സേവാ ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4613.jpeg",
    },
    {
      src: "assets/img/Pastevents/4614.jpeg",
      caption:
        " തിരുവട്ടാർ പൂജാരി സേവാ ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4614.jpeg",
    },

    {
      src: "assets/img/Pastevents/4615.jpeg",
      caption:
        " തിരുവട്ടാർ പൂജാരി സേവാ ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4615.jpeg",
    },
    {
      src: "assets/img/Pastevents/4605.jpeg",
      caption:
        "വെഞ്ഞാറമ്മൂട് ദീപാ നഗർ റെസിഡൻഷ്യൽ അസോസിയേഷൻ്റെയും  നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4605.jpeg",
    },
    {
      src: "assets/img/Pastevents/4606.jpeg",
      caption:
        "വെഞ്ഞാറമ്മൂട് ദീപാ നഗർ റെസിഡൻഷ്യൽ അസോസിയേഷൻ്റെയും  നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4606.jpeg",
    },
    {
      src: "assets/img/Pastevents/4607.jpeg",
      caption:
        "വെഞ്ഞാറമ്മൂട് ദീപാ നഗർ റെസിഡൻഷ്യൽ അസോസിയേഷൻ്റെയും  നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4607.jpeg",
    },
    {
      src: "assets/img/Pastevents/4608.jpeg",
      caption:
        "വെഞ്ഞാറമ്മൂട് ദീപാ നഗർ റെസിഡൻഷ്യൽ അസോസിയേഷൻ്റെയും  നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4608.jpeg",
    },
    {
      src: "assets/img/Pastevents/4609.jpeg",
      caption:
        "വെഞ്ഞാറമ്മൂട് ദീപാ നഗർ റെസിഡൻഷ്യൽ അസോസിയേഷൻ്റെയും  നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4609.jpeg",
    },
    {
      src: "assets/img/Pastevents/4610.jpeg",
      caption:
        "വെഞ്ഞാറമ്മൂട് ദീപാ നഗർ റെസിഡൻഷ്യൽ അസോസിയേഷൻ്റെയും  നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4610.jpeg",
    },
    {
      src: "assets/img/Pastevents/4599.jpeg",
      caption:
        " താന്നിവിള രാജിവ് ഗാന്ധി സാംസ്കാരിക വേദിയുടേയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4599.jpeg",
    },
    {
      src: "assets/img/Pastevents/4600.jpeg",
      caption:
        " താന്നിവിള രാജിവ് ഗാന്ധി സാംസ്കാരിക വേദിയുടേയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4600.jpeg",
    },
    {
      src: "assets/img/Pastevents/4601.jpeg",
      caption:
        " താന്നിവിള രാജിവ് ഗാന്ധി സാംസ്കാരിക വേദിയുടേയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4601.jpeg",
    },
    {
      src: "assets/img/Pastevents/4602.jpeg",
      caption:
        " താന്നിവിള രാജിവ് ഗാന്ധി സാംസ്കാരിക വേദിയുടേയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4602.jpeg",
    },
    {
      src: "assets/img/Pastevents/4603.jpeg",
      caption:
        " താന്നിവിള രാജിവ് ഗാന്ധി സാംസ്കാരിക വേദിയുടേയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4603.jpeg",
    },
    {
      src: "assets/img/Pastevents/4604.jpeg",
      caption:
        " താന്നിവിള രാജിവ് ഗാന്ധി സാംസ്കാരിക വേദിയുടേയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4604.jpeg",
    },
    {
      src: "assets/img/Pastevents/4593.jpeg",
      caption:
        "പുത്തൻചന്ത പൂജാരി സേവാ ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4593.jpeg",
    },
    {
      src: "assets/img/Pastevents/4594.jpeg",
      caption:
        "പുത്തൻചന്ത പൂജാരി സേവാ ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4594.jpeg",
    },
    {
      src: "assets/img/Pastevents/4595.jpeg",
      caption:
        "പുത്തൻചന്ത പൂജാരി സേവാ ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4595.jpeg",
    },
    {
      src: "assets/img/Pastevents/4596.jpeg",
      caption:
        "പുത്തൻചന്ത പൂജാരി സേവാ ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4596.jpeg",
    },
    {
      src: "assets/img/Pastevents/4597.jpeg",
      caption:
        "പുത്തൻചന്ത പൂജാരി സേവാ ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4597.jpeg",
    },
    {
      src: "assets/img/Pastevents/4598.jpeg",
      caption:
        "പുത്തൻചന്ത പൂജാരി സേവാ ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4598.jpeg",
    },
    {
      src: "assets/img/Pastevents/4587.jpeg",
      caption:
        "പട്ടം ഇൻഡസ് മോട്ടോഴ്സിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4587.jpeg",
    },
    {
      src: "assets/img/Pastevents/4588.jpeg",
      caption:
        "പട്ടം ഇൻഡസ് മോട്ടോഴ്സിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4588.jpeg",
    },
    {
      src: "assets/img/Pastevents/4589.jpeg",
      caption:
        "പട്ടം ഇൻഡസ് മോട്ടോഴ്സിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4589.jpeg",
    },{
      src: "assets/img/Pastevents/4590.jpeg",
      caption:
        "പട്ടം ഇൻഡസ് മോട്ടോഴ്സിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4590.jpeg",
    },
    {
      src: "assets/img/Pastevents/4591.jpeg",
      caption:
        "പട്ടം ഇൻഡസ് മോട്ടോഴ്സിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4591.jpeg",
    },
    {
      src: "assets/img/Pastevents/4592.jpeg",
      caption:
        "പട്ടം ഇൻഡസ് മോട്ടോഴ്സിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4592.jpeg",
    },
    {
      src: "assets/img/Pastevents/4581.jpeg",
      caption:
        "അയിര സി എസ് ഐ ചർച്ചിൻ്റെ യുവജന വാരാഘോഷം -2024 ൻ്റെ ഭാഗമായി നിംസ് മെഡിസിറ്റിയുടെ സഹകരണത്തോട്ക്കൂടി സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4581.jpeg",
    },
    {
      src: "assets/img/Pastevents/4582.jpeg",
      caption:
        "അയിര സി എസ് ഐ ചർച്ചിൻ്റെ യുവജന വാരാഘോഷം -2024 ൻ്റെ ഭാഗമായി നിംസ് മെഡിസിറ്റിയുടെ സഹകരണത്തോട്ക്കൂടി സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4582.jpeg",
    },
    {
      src: "assets/img/Pastevents/4583.jpeg",
      caption:
        "അയിര സി എസ് ഐ ചർച്ചിൻ്റെ യുവജന വാരാഘോഷം -2024 ൻ്റെ ഭാഗമായി നിംസ് മെഡിസിറ്റിയുടെ സഹകരണത്തോട്ക്കൂടി സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4583.jpeg",
    },
    {
      src: "assets/img/Pastevents/4584.jpeg",
      caption:
        "അയിര സി എസ് ഐ ചർച്ചിൻ്റെ യുവജന വാരാഘോഷം -2024 ൻ്റെ ഭാഗമായി നിംസ് മെഡിസിറ്റിയുടെ സഹകരണത്തോട്ക്കൂടി സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4584.jpeg",
    },
    {
      src: "assets/img/Pastevents/4585.jpeg",
      caption:
        "അയിര സി എസ് ഐ ചർച്ചിൻ്റെ യുവജന വാരാഘോഷം -2024 ൻ്റെ ഭാഗമായി നിംസ് മെഡിസിറ്റിയുടെ സഹകരണത്തോട്ക്കൂടി സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4585.jpeg",
    },
    {
      src: "assets/img/Pastevents/4586.jpeg",
      caption:
        "അയിര സി എസ് ഐ ചർച്ചിൻ്റെ യുവജന വാരാഘോഷം -2024 ൻ്റെ ഭാഗമായി നിംസ് മെഡിസിറ്റിയുടെ സഹകരണത്തോട്ക്കൂടി സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4586.jpeg",
    },
    {
      src: "assets/img/Pastevents/4574.jpeg",
      caption:
        "  വ്ലാത്താൻകര മരിയൻ തീർത്ഥാടന കേന്ദ്രത്തിന്റെയും  നിംസ് മെഡിസിറ്റിയും സംയുക്തമായി  സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4574.jpeg",
    },
    {
      src: "assets/img/Pastevents/4575.jpeg",
      caption:
        "  വ്ലാത്താൻകര മരിയൻ തീർത്ഥാടന കേന്ദ്രത്തിന്റെയും  നിംസ് മെഡിസിറ്റിയും സംയുക്തമായി  സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4575.jpeg",
    },
    {
      src: "assets/img/Pastevents/4576.jpeg",
      caption:
        "  വ്ലാത്താൻകര മരിയൻ തീർത്ഥാടന കേന്ദ്രത്തിന്റെയും  നിംസ് മെഡിസിറ്റിയും സംയുക്തമായി  സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4576.jpeg",
    },
    {
      src: "assets/img/Pastevents/4577.jpeg",
      caption:
        "  വ്ലാത്താൻകര മരിയൻ തീർത്ഥാടന കേന്ദ്രത്തിന്റെയും  നിംസ് മെഡിസിറ്റിയും സംയുക്തമായി  സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4577.jpeg",
    },
    {
      src: "assets/img/Pastevents/4578.jpeg",
      caption:
        "  വ്ലാത്താൻകര മരിയൻ തീർത്ഥാടന കേന്ദ്രത്തിന്റെയും  നിംസ് മെഡിസിറ്റിയും സംയുക്തമായി  സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4578.jpeg",
    },
    {
      src: "assets/img/Pastevents/4579.jpeg",
      caption:
        "  വ്ലാത്താൻകര മരിയൻ തീർത്ഥാടന കേന്ദ്രത്തിന്റെയും  നിംസ് മെഡിസിറ്റിയും സംയുക്തമായി  സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4579.jpeg",
    },
    {
      src: "assets/img/Pastevents/4580.jpeg",
      caption:
        "  വ്ലാത്താൻകര മരിയൻ തീർത്ഥാടന കേന്ദ്രത്തിന്റെയും  നിംസ് മെഡിസിറ്റിയും സംയുക്തമായി  സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4580.jpeg",
    },
    {
      src: "assets/img/Pastevents/4566.jpeg",
      caption:
        "Perumkadavila",
      thumb: "assets/img/Pastevents/4566.jpeg",
    },
    {
      src: "assets/img/Pastevents/4567.jpeg",
      caption:
        "Perumkadavila",
      thumb: "assets/img/Pastevents/4567.jpeg",
    },
    {
      src: "assets/img/Pastevents/4568.jpeg",
      caption:
        "Perumkadavila",
      thumb: "assets/img/Pastevents/4568.jpeg",
    },
    {
      src: "assets/img/Pastevents/4569.jpeg",
      caption:
        "Perumkadavila",
      thumb: "assets/img/Pastevents/4569.jpeg",
    },
    {
      src: "assets/img/Pastevents/4570.jpeg",
      caption:
        "Perumkadavila",
      thumb: "assets/img/Pastevents/4570.jpeg",
    },
    {
      src: "assets/img/Pastevents/4571.jpeg",
      caption:
        "Perumkadavila",
      thumb: "assets/img/Pastevents/4571.jpeg",
    },
    {
      src: "assets/img/Pastevents/4572.jpeg",
      caption:
        "Perumkadavila",
      thumb: "assets/img/Pastevents/4572.jpeg",
    },
    {
      src: "assets/img/Pastevents/4573.jpeg",
      caption:
        "Perumkadavila",
      thumb: "assets/img/Pastevents/4573.jpeg",
    },
    {
      src: "assets/img/Pastevents/4560.jpeg",
      caption:
        " ഹരിത കേരള മിഷൻ, നഗരൂർ ലയൺസ് ക്ലബ്, നഗരൂർ പൊയ്കയിൽ എസ് എൻ ഡി പി ശാഖയുടെയും നിംസ് മെഡിസിറ്റിയും സംയുക്തമായി  സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4560.jpeg",
    },
    {
      src: "assets/img/Pastevents/4561.jpeg",
      caption:
        " ഹരിത കേരള മിഷൻ, നഗരൂർ ലയൺസ് ക്ലബ്, നഗരൂർ പൊയ്കയിൽ എസ് എൻ ഡി പി ശാഖയുടെയും നിംസ് മെഡിസിറ്റിയും സംയുക്തമായി  സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4561.jpeg",
    },
    {
      src: "assets/img/Pastevents/4562.jpeg",
      caption:
        " ഹരിത കേരള മിഷൻ, നഗരൂർ ലയൺസ് ക്ലബ്, നഗരൂർ പൊയ്കയിൽ എസ് എൻ ഡി പി ശാഖയുടെയും നിംസ് മെഡിസിറ്റിയും സംയുക്തമായി  സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4562.jpeg",
    },
    {
      src: "assets/img/Pastevents/4563.jpeg",
      caption:
        " ഹരിത കേരള മിഷൻ, നഗരൂർ ലയൺസ് ക്ലബ്, നഗരൂർ പൊയ്കയിൽ എസ് എൻ ഡി പി ശാഖയുടെയും നിംസ് മെഡിസിറ്റിയും സംയുക്തമായി  സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4563.jpeg",
    },
    {
      src: "assets/img/Pastevents/4564.jpeg",
      caption:
        " ഹരിത കേരള മിഷൻ, നഗരൂർ ലയൺസ് ക്ലബ്, നഗരൂർ പൊയ്കയിൽ എസ് എൻ ഡി പി ശാഖയുടെയും നിംസ് മെഡിസിറ്റിയും സംയുക്തമായി  സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4564.jpeg",
    },
    {
      src: "assets/img/Pastevents/4565.jpeg",
      caption:
        " ഹരിത കേരള മിഷൻ, നഗരൂർ ലയൺസ് ക്ലബ്, നഗരൂർ പൊയ്കയിൽ എസ് എൻ ഡി പി ശാഖയുടെയും നിംസ് മെഡിസിറ്റിയും സംയുക്തമായി  സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4565.jpeg",
    },
    {
      src: "assets/img/Pastevents/4553.jpeg",
      caption:
        " മീനാങ്കൽ ഗവ: ട്രൈബൽ ഹൈസ്കൂളിൻ്റെയും    നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ  സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി. കുട്ടികളുടെ വളർച്ച- വികാസ പരിശോധന ,കുട്ടികളുടെ പ്രീ - ലേണിംഗ് പരിശോധനയും, അവബോധവും ,കൗമാര പ്രായക്കാർക്ക് മാനസിക-പ്രജനന ആരോഗ്യ പരിശോധനയും, അനുബന്ധ അവബോധവും ക്യാമ്പിൽ സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/4553.jpeg",
    },
    {
      src: "assets/img/Pastevents/4554.jpeg",
      caption:
        " മീനാങ്കൽ ഗവ: ട്രൈബൽ ഹൈസ്കൂളിൻ്റെയും    നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ  സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി. കുട്ടികളുടെ വളർച്ച- വികാസ പരിശോധന ,കുട്ടികളുടെ പ്രീ - ലേണിംഗ് പരിശോധനയും, അവബോധവും ,കൗമാര പ്രായക്കാർക്ക് മാനസിക-പ്രജനന ആരോഗ്യ പരിശോധനയും, അനുബന്ധ അവബോധവും ക്യാമ്പിൽ സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/4554.jpeg",
    },
    {
      src: "assets/img/Pastevents/4555.jpeg",
      caption:
        " മീനാങ്കൽ ഗവ: ട്രൈബൽ ഹൈസ്കൂളിൻ്റെയും    നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ  സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി. കുട്ടികളുടെ വളർച്ച- വികാസ പരിശോധന ,കുട്ടികളുടെ പ്രീ - ലേണിംഗ് പരിശോധനയും, അവബോധവും ,കൗമാര പ്രായക്കാർക്ക് മാനസിക-പ്രജനന ആരോഗ്യ പരിശോധനയും, അനുബന്ധ അവബോധവും ക്യാമ്പിൽ സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/4555.jpeg",
    },
    {
      src: "assets/img/Pastevents/4556.jpeg",
      caption:
        " മീനാങ്കൽ ഗവ: ട്രൈബൽ ഹൈസ്കൂളിൻ്റെയും    നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ  സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി. കുട്ടികളുടെ വളർച്ച- വികാസ പരിശോധന ,കുട്ടികളുടെ പ്രീ - ലേണിംഗ് പരിശോധനയും, അവബോധവും ,കൗമാര പ്രായക്കാർക്ക് മാനസിക-പ്രജനന ആരോഗ്യ പരിശോധനയും, അനുബന്ധ അവബോധവും ക്യാമ്പിൽ സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/4556.jpeg",
    },
    {
      src: "assets/img/Pastevents/4557.jpeg",
      caption:
        " മീനാങ്കൽ ഗവ: ട്രൈബൽ ഹൈസ്കൂളിൻ്റെയും    നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ  സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി. കുട്ടികളുടെ വളർച്ച- വികാസ പരിശോധന ,കുട്ടികളുടെ പ്രീ - ലേണിംഗ് പരിശോധനയും, അവബോധവും ,കൗമാര പ്രായക്കാർക്ക് മാനസിക-പ്രജനന ആരോഗ്യ പരിശോധനയും, അനുബന്ധ അവബോധവും ക്യാമ്പിൽ സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/4557.jpeg",
    },
    {
      src: "assets/img/Pastevents/4558.jpeg",
      caption:
        " മീനാങ്കൽ ഗവ: ട്രൈബൽ ഹൈസ്കൂളിൻ്റെയും    നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ  സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി. കുട്ടികളുടെ വളർച്ച- വികാസ പരിശോധന ,കുട്ടികളുടെ പ്രീ - ലേണിംഗ് പരിശോധനയും, അവബോധവും ,കൗമാര പ്രായക്കാർക്ക് മാനസിക-പ്രജനന ആരോഗ്യ പരിശോധനയും, അനുബന്ധ അവബോധവും ക്യാമ്പിൽ സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/4558.jpeg",
    },
    {
      src: "assets/img/Pastevents/4559.jpeg",
      caption:
        " മീനാങ്കൽ ഗവ: ട്രൈബൽ ഹൈസ്കൂളിൻ്റെയും    നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ  സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി. കുട്ടികളുടെ വളർച്ച- വികാസ പരിശോധന ,കുട്ടികളുടെ പ്രീ - ലേണിംഗ് പരിശോധനയും, അവബോധവും ,കൗമാര പ്രായക്കാർക്ക് മാനസിക-പ്രജനന ആരോഗ്യ പരിശോധനയും, അനുബന്ധ അവബോധവും ക്യാമ്പിൽ സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/4559.jpeg",
    },
    {
      src: "assets/img/Pastevents/4545.jpeg",
      caption:
        "പനവിള വുമൺസ് മുസ്‌ലീം അസോസിയേഷൻ, നിംസ് മൈക്രോ ഹോസ്പിറ്റൽ ആൻഡ് വൽസല നഴ്സിംഗ് ഹോമിൻ്റെയും നിംസ് മെഡിസിറ്റിയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ,  കാർഡിയോളജി, ഗൈനക്കോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം,എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4545.jpeg",
    },
    {
      src: "assets/img/Pastevents/4546.jpeg",
      caption:
        "പനവിള വുമൺസ് മുസ്‌ലീം അസോസിയേഷൻ, നിംസ് മൈക്രോ ഹോസ്പിറ്റൽ ആൻഡ് വൽസല നഴ്സിംഗ് ഹോമിൻ്റെയും നിംസ് മെഡിസിറ്റിയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ,  കാർഡിയോളജി, ഗൈനക്കോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം,എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4546.jpeg",
    },
    {
      src: "assets/img/Pastevents/4547.jpeg",
      caption:
        "പനവിള വുമൺസ് മുസ്‌ലീം അസോസിയേഷൻ, നിംസ് മൈക്രോ ഹോസ്പിറ്റൽ ആൻഡ് വൽസല നഴ്സിംഗ് ഹോമിൻ്റെയും നിംസ് മെഡിസിറ്റിയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ,  കാർഡിയോളജി, ഗൈനക്കോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം,എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4547.jpeg",
    },
    {
      src: "assets/img/Pastevents/4548.jpeg",
      caption:
        "പനവിള വുമൺസ് മുസ്‌ലീം അസോസിയേഷൻ, നിംസ് മൈക്രോ ഹോസ്പിറ്റൽ ആൻഡ് വൽസല നഴ്സിംഗ് ഹോമിൻ്റെയും നിംസ് മെഡിസിറ്റിയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ,  കാർഡിയോളജി, ഗൈനക്കോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം,എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4548.jpeg",
    },
    {
      src: "assets/img/Pastevents/4549.jpeg",
      caption:
        "പനവിള വുമൺസ് മുസ്‌ലീം അസോസിയേഷൻ, നിംസ് മൈക്രോ ഹോസ്പിറ്റൽ ആൻഡ് വൽസല നഴ്സിംഗ് ഹോമിൻ്റെയും നിംസ് മെഡിസിറ്റിയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ,  കാർഡിയോളജി, ഗൈനക്കോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം,എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4549.jpeg",
    },
    {
      src: "assets/img/Pastevents/4550.jpeg",
      caption:
        "പനവിള വുമൺസ് മുസ്‌ലീം അസോസിയേഷൻ, നിംസ് മൈക്രോ ഹോസ്പിറ്റൽ ആൻഡ് വൽസല നഴ്സിംഗ് ഹോമിൻ്റെയും നിംസ് മെഡിസിറ്റിയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ,  കാർഡിയോളജി, ഗൈനക്കോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം,എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4550.jpeg",
    },
    {
      src: "assets/img/Pastevents/4551.jpeg",
      caption:
        "പനവിള വുമൺസ് മുസ്‌ലീം അസോസിയേഷൻ, നിംസ് മൈക്രോ ഹോസ്പിറ്റൽ ആൻഡ് വൽസല നഴ്സിംഗ് ഹോമിൻ്റെയും നിംസ് മെഡിസിറ്റിയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ,  കാർഡിയോളജി, ഗൈനക്കോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം,എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4551.jpeg",
    },
    {
      src: "assets/img/Pastevents/4552.jpeg",
      caption:
        "പനവിള വുമൺസ് മുസ്‌ലീം അസോസിയേഷൻ, നിംസ് മൈക്രോ ഹോസ്പിറ്റൽ ആൻഡ് വൽസല നഴ്സിംഗ് ഹോമിൻ്റെയും നിംസ് മെഡിസിറ്റിയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ,  കാർഡിയോളജി, ഗൈനക്കോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം,എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4552.jpeg",
    },
    {
      src: "assets/img/Pastevents/4540.jpeg",
      caption:
        "ബാലരാമപുരം സൗത്ത് ഇന്ത്യൻ ബാങ്കിൻ്റെയും നിംസ് മെഡിസിറ്റിയും സംയുക്തമായി  സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4540.jpeg",
    },
    {
      src: "assets/img/Pastevents/4541.jpeg",
      caption:
        "ബാലരാമപുരം സൗത്ത് ഇന്ത്യൻ ബാങ്കിൻ്റെയും നിംസ് മെഡിസിറ്റിയും സംയുക്തമായി  സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4541.jpeg",
    },
    {
      src: "assets/img/Pastevents/4542.jpeg",
      caption:
        "ബാലരാമപുരം സൗത്ത് ഇന്ത്യൻ ബാങ്കിൻ്റെയും നിംസ് മെഡിസിറ്റിയും സംയുക്തമായി  സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4542.jpeg",
    },
    {
      src: "assets/img/Pastevents/4543.jpeg",
      caption:
        "ബാലരാമപുരം സൗത്ത് ഇന്ത്യൻ ബാങ്കിൻ്റെയും നിംസ് മെഡിസിറ്റിയും സംയുക്തമായി  സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4543.jpeg",
    },
    {
      src: "assets/img/Pastevents/4544.jpeg",
      caption:
        "ബാലരാമപുരം സൗത്ത് ഇന്ത്യൻ ബാങ്കിൻ്റെയും നിംസ് മെഡിസിറ്റിയും സംയുക്തമായി  സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി,   ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ, ആയൂർവേദം എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4544.jpeg",
    },
    {
      src: "assets/img/Pastevents/4532.jpeg",
      caption:
        " മീനാങ്കൽ ഗവ: ട്രൈബൽ ഹൈസ്കൂളിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ  സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി. കുട്ടികളുടെ വളർച്ച- വികാസ പരിശോധന ,കുട്ടികളുടെ പ്രീ - ലേണിംഗ് പരിശോധനയും, അവബോധവും ,കൗമാര പ്രായക്കാർക്ക് മാനസിക-പ്രജനന ആരോഗ്യ പരിശോധനയും, അനുബന്ധ അവബോധവും ക്യാമ്പിൽ സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/4532.jpeg",
    },
    {
      src: "assets/img/Pastevents/4533.jpeg",
      caption:
        " മീനാങ്കൽ ഗവ: ട്രൈബൽ ഹൈസ്കൂളിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ  സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി. കുട്ടികളുടെ വളർച്ച- വികാസ പരിശോധന ,കുട്ടികളുടെ പ്രീ - ലേണിംഗ് പരിശോധനയും, അവബോധവും ,കൗമാര പ്രായക്കാർക്ക് മാനസിക-പ്രജനന ആരോഗ്യ പരിശോധനയും, അനുബന്ധ അവബോധവും ക്യാമ്പിൽ സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/4533.jpeg",
    },
    {
      src: "assets/img/Pastevents/4534.jpeg",
      caption:
        " മീനാങ്കൽ ഗവ: ട്രൈബൽ ഹൈസ്കൂളിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ  സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി. കുട്ടികളുടെ വളർച്ച- വികാസ പരിശോധന ,കുട്ടികളുടെ പ്രീ - ലേണിംഗ് പരിശോധനയും, അവബോധവും ,കൗമാര പ്രായക്കാർക്ക് മാനസിക-പ്രജനന ആരോഗ്യ പരിശോധനയും, അനുബന്ധ അവബോധവും ക്യാമ്പിൽ സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/4534.jpeg",
    },
    {
      src: "assets/img/Pastevents/4535.jpeg",
      caption:
        " മീനാങ്കൽ ഗവ: ട്രൈബൽ ഹൈസ്കൂളിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ  സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി. കുട്ടികളുടെ വളർച്ച- വികാസ പരിശോധന ,കുട്ടികളുടെ പ്രീ - ലേണിംഗ് പരിശോധനയും, അവബോധവും ,കൗമാര പ്രായക്കാർക്ക് മാനസിക-പ്രജനന ആരോഗ്യ പരിശോധനയും, അനുബന്ധ അവബോധവും ക്യാമ്പിൽ സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/4535.jpeg",
    },
    {
      src: "assets/img/Pastevents/4536.jpeg",
      caption:
        " മീനാങ്കൽ ഗവ: ട്രൈബൽ ഹൈസ്കൂളിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ  സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി. കുട്ടികളുടെ വളർച്ച- വികാസ പരിശോധന ,കുട്ടികളുടെ പ്രീ - ലേണിംഗ് പരിശോധനയും, അവബോധവും ,കൗമാര പ്രായക്കാർക്ക് മാനസിക-പ്രജനന ആരോഗ്യ പരിശോധനയും, അനുബന്ധ അവബോധവും ക്യാമ്പിൽ സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/4536.jpeg",
    },
    {
      src: "assets/img/Pastevents/4537.jpeg",
      caption:
        " മീനാങ്കൽ ഗവ: ട്രൈബൽ ഹൈസ്കൂളിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ  സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി. കുട്ടികളുടെ വളർച്ച- വികാസ പരിശോധന ,കുട്ടികളുടെ പ്രീ - ലേണിംഗ് പരിശോധനയും, അവബോധവും ,കൗമാര പ്രായക്കാർക്ക് മാനസിക-പ്രജനന ആരോഗ്യ പരിശോധനയും, അനുബന്ധ അവബോധവും ക്യാമ്പിൽ സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/4537.jpeg",
    },
    {
      src: "assets/img/Pastevents/4538.jpeg",
      caption:
        " മീനാങ്കൽ ഗവ: ട്രൈബൽ ഹൈസ്കൂളിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ  സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി. കുട്ടികളുടെ വളർച്ച- വികാസ പരിശോധന ,കുട്ടികളുടെ പ്രീ - ലേണിംഗ് പരിശോധനയും, അവബോധവും ,കൗമാര പ്രായക്കാർക്ക് മാനസിക-പ്രജനന ആരോഗ്യ പരിശോധനയും, അനുബന്ധ അവബോധവും ക്യാമ്പിൽ സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/4538.jpeg",
    },
    {
      src: "assets/img/Pastevents/4539.jpeg",
      caption:
        " മീനാങ്കൽ ഗവ: ട്രൈബൽ ഹൈസ്കൂളിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ  സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി. കുട്ടികളുടെ വളർച്ച- വികാസ പരിശോധന ,കുട്ടികളുടെ പ്രീ - ലേണിംഗ് പരിശോധനയും, അവബോധവും ,കൗമാര പ്രായക്കാർക്ക് മാനസിക-പ്രജനന ആരോഗ്യ പരിശോധനയും, അനുബന്ധ അവബോധവും ക്യാമ്പിൽ സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/4539.jpeg",
    },
    {
      src: "assets/img/Pastevents/4526.jpeg",
      caption:
        "സി എസ് ഐ പാറമുക്ക്, ഹെച്ച് എം എസ് മീനാങ്കൽ സഭയുടെയും നിംസ് മെഡിസിറ്റിയും സംയുക്തമായി  സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി,  ഗ്യാസ്‌ട്രോളജി,നെഫ്രാളജി,പൾമിനോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4526.jpeg",
    },
    {
      src: "assets/img/Pastevents/4527.jpeg",
      caption:
        "സി എസ് ഐ പാറമുക്ക്, ഹെച്ച് എം എസ് മീനാങ്കൽ സഭയുടെയും നിംസ് മെഡിസിറ്റിയും സംയുക്തമായി  സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി,  ഗ്യാസ്‌ട്രോളജി,നെഫ്രാളജി,പൾമിനോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4527.jpeg",
    },
    {
      src: "assets/img/Pastevents/4528.jpeg",
      caption:
        "സി എസ് ഐ പാറമുക്ക്, ഹെച്ച് എം എസ് മീനാങ്കൽ സഭയുടെയും നിംസ് മെഡിസിറ്റിയും സംയുക്തമായി  സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി,  ഗ്യാസ്‌ട്രോളജി,നെഫ്രാളജി,പൾമിനോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4528.jpeg",
    },
    {
      src: "assets/img/Pastevents/4529.jpeg",
      caption:
        "സി എസ് ഐ പാറമുക്ക്, ഹെച്ച് എം എസ് മീനാങ്കൽ സഭയുടെയും നിംസ് മെഡിസിറ്റിയും സംയുക്തമായി  സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി,  ഗ്യാസ്‌ട്രോളജി,നെഫ്രാളജി,പൾമിനോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4529.jpeg",
    },
    {
      src: "assets/img/Pastevents/4530.jpeg",
      caption:
        "സി എസ് ഐ പാറമുക്ക്, ഹെച്ച് എം എസ് മീനാങ്കൽ സഭയുടെയും നിംസ് മെഡിസിറ്റിയും സംയുക്തമായി  സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി,  ഗ്യാസ്‌ട്രോളജി,നെഫ്രാളജി,പൾമിനോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4530.jpeg",
    },
    {
      src: "assets/img/Pastevents/4531.jpeg",
      caption:
        "സി എസ് ഐ പാറമുക്ക്, ഹെച്ച് എം എസ് മീനാങ്കൽ സഭയുടെയും നിംസ് മെഡിസിറ്റിയും സംയുക്തമായി  സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി,  ഗ്യാസ്‌ട്രോളജി,നെഫ്രാളജി,പൾമിനോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4531.jpeg",
    },
    {
      src: "assets/img/Pastevents/4521.jpeg",
      caption:
        "പരശുവയ്ക്കൽ തെക്കുംക്കര ശ്രീ മഹാവിഷ്ണു ക്ഷേത്രം,പാറശ്ശാല സേവാഭാരതി യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയും സംയുക്തമായി കർക്കിടക വാവ്ബലി തർപ്പണം നടത്തുന്നവർക്കായി സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി,  ഗ്യാസ്‌ട്രോളജി,നെഫ്രാളജി,പൾമിനോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4521.jpeg",
    },
    {
      src: "assets/img/Pastevents/4522.jpeg",
      caption:
        "പരശുവയ്ക്കൽ തെക്കുംക്കര ശ്രീ മഹാവിഷ്ണു ക്ഷേത്രം,പാറശ്ശാല സേവാഭാരതി യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയും സംയുക്തമായി കർക്കിടക വാവ്ബലി തർപ്പണം നടത്തുന്നവർക്കായി സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി,  ഗ്യാസ്‌ട്രോളജി,നെഫ്രാളജി,പൾമിനോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4522.jpeg",
    },
    {
      src: "assets/img/Pastevents/4523.jpeg",
      caption:
        "പരശുവയ്ക്കൽ തെക്കുംക്കര ശ്രീ മഹാവിഷ്ണു ക്ഷേത്രം,പാറശ്ശാല സേവാഭാരതി യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയും സംയുക്തമായി കർക്കിടക വാവ്ബലി തർപ്പണം നടത്തുന്നവർക്കായി സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി,  ഗ്യാസ്‌ട്രോളജി,നെഫ്രാളജി,പൾമിനോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4523.jpeg",
    },
    {
      src: "assets/img/Pastevents/4524.jpeg",
      caption:
        "പരശുവയ്ക്കൽ തെക്കുംക്കര ശ്രീ മഹാവിഷ്ണു ക്ഷേത്രം,പാറശ്ശാല സേവാഭാരതി യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയും സംയുക്തമായി കർക്കിടക വാവ്ബലി തർപ്പണം നടത്തുന്നവർക്കായി സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി,  ഗ്യാസ്‌ട്രോളജി,നെഫ്രാളജി,പൾമിനോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4524.jpeg",
    },
    {
      src: "assets/img/Pastevents/4525.jpeg",
      caption:
        "പരശുവയ്ക്കൽ തെക്കുംക്കര ശ്രീ മഹാവിഷ്ണു ക്ഷേത്രം,പാറശ്ശാല സേവാഭാരതി യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയും സംയുക്തമായി കർക്കിടക വാവ്ബലി തർപ്പണം നടത്തുന്നവർക്കായി സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി,  ഗ്യാസ്‌ട്രോളജി,നെഫ്രാളജി,പൾമിനോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4525.jpeg",
    },
    {
      src: "assets/img/Pastevents/4516.jpeg",
      caption:
        "തിരുവനന്തപുരം ജില്ലാ വ്യാവസായിക കേന്ദ്രത്തിൻ്റെ നേതൃത്വത്തിൽ നേമം ഹാൻഡ്ലൂം സർക്കിൾ ഓഫീസും  നിംസ് മെഡിസിറ്റിയും സംയുക്തമായി നെയ്ത്ത് തൊഴിലാളികൾക്കായി സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീമതി ദീപിക  യു (ബഹു: നേമം വാർഡ് മെമ്പർ). ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി,  ഗ്യാസ്‌ട്രോളജി,നെഫ്രാളജി,പൾമിനോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4516.jpeg",
    },
    {
      src: "assets/img/Pastevents/4517.jpeg",
      caption:
        "തിരുവനന്തപുരം ജില്ലാ വ്യാവസായിക കേന്ദ്രത്തിൻ്റെ നേതൃത്വത്തിൽ നേമം ഹാൻഡ്ലൂം സർക്കിൾ ഓഫീസും  നിംസ് മെഡിസിറ്റിയും സംയുക്തമായി നെയ്ത്ത് തൊഴിലാളികൾക്കായി സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീമതി ദീപിക  യു (ബഹു: നേമം വാർഡ് മെമ്പർ). ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി,  ഗ്യാസ്‌ട്രോളജി,നെഫ്രാളജി,പൾമിനോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4517.jpeg",
    },
    {
      src: "assets/img/Pastevents/4518.jpeg",
      caption:
        "തിരുവനന്തപുരം ജില്ലാ വ്യാവസായിക കേന്ദ്രത്തിൻ്റെ നേതൃത്വത്തിൽ നേമം ഹാൻഡ്ലൂം സർക്കിൾ ഓഫീസും  നിംസ് മെഡിസിറ്റിയും സംയുക്തമായി നെയ്ത്ത് തൊഴിലാളികൾക്കായി സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീമതി ദീപിക  യു (ബഹു: നേമം വാർഡ് മെമ്പർ). ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി,  ഗ്യാസ്‌ട്രോളജി,നെഫ്രാളജി,പൾമിനോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4518.jpeg",
    },
    {
      src: "assets/img/Pastevents/4519.jpeg",
      caption:
        "തിരുവനന്തപുരം ജില്ലാ വ്യാവസായിക കേന്ദ്രത്തിൻ്റെ നേതൃത്വത്തിൽ നേമം ഹാൻഡ്ലൂം സർക്കിൾ ഓഫീസും  നിംസ് മെഡിസിറ്റിയും സംയുക്തമായി നെയ്ത്ത് തൊഴിലാളികൾക്കായി സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീമതി ദീപിക  യു (ബഹു: നേമം വാർഡ് മെമ്പർ). ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി,  ഗ്യാസ്‌ട്രോളജി,നെഫ്രാളജി,പൾമിനോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4519.jpeg",
    },
    {
      src: "assets/img/Pastevents/4520.jpeg",
      caption:
        "തിരുവനന്തപുരം ജില്ലാ വ്യാവസായിക കേന്ദ്രത്തിൻ്റെ നേതൃത്വത്തിൽ നേമം ഹാൻഡ്ലൂം സർക്കിൾ ഓഫീസും  നിംസ് മെഡിസിറ്റിയും സംയുക്തമായി നെയ്ത്ത് തൊഴിലാളികൾക്കായി സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീമതി ദീപിക  യു (ബഹു: നേമം വാർഡ് മെമ്പർ). ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി,  ഗ്യാസ്‌ട്രോളജി,നെഫ്രാളജി,പൾമിനോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4520.jpeg",
    },
    {
      src: "assets/img/Pastevents/4509.jpeg",
      caption:
        "തിരുവനന്തപുരം ജില്ലാ വ്യാവസായിക കേന്ദ്രത്തിൻ്റെ നേതൃത്വത്തിൽ വെങ്ങാനൂർ ഹാൻഡ്ലൂം സർക്കിൾ ഓഫീസും  നിംസ് മെഡിസിറ്റിയും സംയുക്തമായി നെയ്ത്ത് തൊഴിലാളികൾക്കായി സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ എം സോമശേഖരൻ നായർ (ബഹു: കല്ലിയൂർ ഗ്രാമ പഞ്ചായത്ത് പ്രസിഡണ്ട്). ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി,  ഗ്യാസ്‌ട്രോളജി,നെഫ്രാളജി,പൾമിനോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4509.jpeg",
    },
    {
      src: "assets/img/Pastevents/4510.jpeg",
      caption:
        "തിരുവനന്തപുരം ജില്ലാ വ്യാവസായിക കേന്ദ്രത്തിൻ്റെ നേതൃത്വത്തിൽ വെങ്ങാനൂർ ഹാൻഡ്ലൂം സർക്കിൾ ഓഫീസും  നിംസ് മെഡിസിറ്റിയും സംയുക്തമായി നെയ്ത്ത് തൊഴിലാളികൾക്കായി സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ എം സോമശേഖരൻ നായർ (ബഹു: കല്ലിയൂർ ഗ്രാമ പഞ്ചായത്ത് പ്രസിഡണ്ട്). ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി,  ഗ്യാസ്‌ട്രോളജി,നെഫ്രാളജി,പൾമിനോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4510.jpeg",
    },
    {
      src: "assets/img/Pastevents/4511.jpeg",
      caption:
        "തിരുവനന്തപുരം ജില്ലാ വ്യാവസായിക കേന്ദ്രത്തിൻ്റെ നേതൃത്വത്തിൽ വെങ്ങാനൂർ ഹാൻഡ്ലൂം സർക്കിൾ ഓഫീസും  നിംസ് മെഡിസിറ്റിയും സംയുക്തമായി നെയ്ത്ത് തൊഴിലാളികൾക്കായി സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ എം സോമശേഖരൻ നായർ (ബഹു: കല്ലിയൂർ ഗ്രാമ പഞ്ചായത്ത് പ്രസിഡണ്ട്). ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി,  ഗ്യാസ്‌ട്രോളജി,നെഫ്രാളജി,പൾമിനോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4511.jpeg",
    },
    {
      src: "assets/img/Pastevents/4512.jpeg",
      caption:
        "തിരുവനന്തപുരം ജില്ലാ വ്യാവസായിക കേന്ദ്രത്തിൻ്റെ നേതൃത്വത്തിൽ വെങ്ങാനൂർ ഹാൻഡ്ലൂം സർക്കിൾ ഓഫീസും  നിംസ് മെഡിസിറ്റിയും സംയുക്തമായി നെയ്ത്ത് തൊഴിലാളികൾക്കായി സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ എം സോമശേഖരൻ നായർ (ബഹു: കല്ലിയൂർ ഗ്രാമ പഞ്ചായത്ത് പ്രസിഡണ്ട്). ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി,  ഗ്യാസ്‌ട്രോളജി,നെഫ്രാളജി,പൾമിനോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4512.jpeg",
    },
    {
      src: "assets/img/Pastevents/4513.jpeg",
      caption:
        "തിരുവനന്തപുരം ജില്ലാ വ്യാവസായിക കേന്ദ്രത്തിൻ്റെ നേതൃത്വത്തിൽ വെങ്ങാനൂർ ഹാൻഡ്ലൂം സർക്കിൾ ഓഫീസും  നിംസ് മെഡിസിറ്റിയും സംയുക്തമായി നെയ്ത്ത് തൊഴിലാളികൾക്കായി സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ എം സോമശേഖരൻ നായർ (ബഹു: കല്ലിയൂർ ഗ്രാമ പഞ്ചായത്ത് പ്രസിഡണ്ട്). ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി,  ഗ്യാസ്‌ട്രോളജി,നെഫ്രാളജി,പൾമിനോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4513.jpeg",
    },
    {
      src: "assets/img/Pastevents/4514.jpeg",
      caption:
        "തിരുവനന്തപുരം ജില്ലാ വ്യാവസായിക കേന്ദ്രത്തിൻ്റെ നേതൃത്വത്തിൽ വെങ്ങാനൂർ ഹാൻഡ്ലൂം സർക്കിൾ ഓഫീസും  നിംസ് മെഡിസിറ്റിയും സംയുക്തമായി നെയ്ത്ത് തൊഴിലാളികൾക്കായി സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ എം സോമശേഖരൻ നായർ (ബഹു: കല്ലിയൂർ ഗ്രാമ പഞ്ചായത്ത് പ്രസിഡണ്ട്). ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി,  ഗ്യാസ്‌ട്രോളജി,നെഫ്രാളജി,പൾമിനോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4514.jpeg",
    },
    {
      src: "assets/img/Pastevents/4515.jpeg",
      caption:
        "തിരുവനന്തപുരം ജില്ലാ വ്യാവസായിക കേന്ദ്രത്തിൻ്റെ നേതൃത്വത്തിൽ വെങ്ങാനൂർ ഹാൻഡ്ലൂം സർക്കിൾ ഓഫീസും  നിംസ് മെഡിസിറ്റിയും സംയുക്തമായി നെയ്ത്ത് തൊഴിലാളികൾക്കായി സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ എം സോമശേഖരൻ നായർ (ബഹു: കല്ലിയൂർ ഗ്രാമ പഞ്ചായത്ത് പ്രസിഡണ്ട്). ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി,  ഗ്യാസ്‌ട്രോളജി,നെഫ്രാളജി,പൾമിനോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4515.jpeg",
    },
    {
      src: "assets/img/Pastevents/4503.jpeg",
      caption:
        "തിരുവനന്തപുരം ജില്ലാ വ്യാവസായിക കേന്ദ്രത്തിൻ്റെ നേതൃത്വത്തിൽ അവണാകുഴി ഹാൻഡ്ലൂം സർക്കിൾ ഓഫീസും  നിംസ് മെഡിസിറ്റിയും സംയുക്തമായി നെയ്ത്ത് തൊഴിലാളികൾക്കായി സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ സുനിൽകുമാർ വി പി (ബഹു: അതിയന്നൂർ ഗ്രാമ പഞ്ചായത്ത് പ്രസിഡണ്ട്)ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി,  ഗ്യാസ്‌ട്രോളജി,നെഫ്രാളജി,പൾമിനോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4503.jpeg",
    },
    {
      src: "assets/img/Pastevents/4504.jpeg",
      caption:
        "തിരുവനന്തപുരം ജില്ലാ വ്യാവസായിക കേന്ദ്രത്തിൻ്റെ നേതൃത്വത്തിൽ അവണാകുഴി ഹാൻഡ്ലൂം സർക്കിൾ ഓഫീസും  നിംസ് മെഡിസിറ്റിയും സംയുക്തമായി നെയ്ത്ത് തൊഴിലാളികൾക്കായി സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ സുനിൽകുമാർ വി പി (ബഹു: അതിയന്നൂർ ഗ്രാമ പഞ്ചായത്ത് പ്രസിഡണ്ട്)ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി,  ഗ്യാസ്‌ട്രോളജി,നെഫ്രാളജി,പൾമിനോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4504.jpeg",
    },
    {
      src: "assets/img/Pastevents/4505.jpeg",
      caption:
        "തിരുവനന്തപുരം ജില്ലാ വ്യാവസായിക കേന്ദ്രത്തിൻ്റെ നേതൃത്വത്തിൽ അവണാകുഴി ഹാൻഡ്ലൂം സർക്കിൾ ഓഫീസും  നിംസ് മെഡിസിറ്റിയും സംയുക്തമായി നെയ്ത്ത് തൊഴിലാളികൾക്കായി സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ സുനിൽകുമാർ വി പി (ബഹു: അതിയന്നൂർ ഗ്രാമ പഞ്ചായത്ത് പ്രസിഡണ്ട്)ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി,  ഗ്യാസ്‌ട്രോളജി,നെഫ്രാളജി,പൾമിനോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4505.jpeg",
    },
    {
      src: "assets/img/Pastevents/4506.jpeg",
      caption:
        "തിരുവനന്തപുരം ജില്ലാ വ്യാവസായിക കേന്ദ്രത്തിൻ്റെ നേതൃത്വത്തിൽ അവണാകുഴി ഹാൻഡ്ലൂം സർക്കിൾ ഓഫീസും  നിംസ് മെഡിസിറ്റിയും സംയുക്തമായി നെയ്ത്ത് തൊഴിലാളികൾക്കായി സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ സുനിൽകുമാർ വി പി (ബഹു: അതിയന്നൂർ ഗ്രാമ പഞ്ചായത്ത് പ്രസിഡണ്ട്)ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി,  ഗ്യാസ്‌ട്രോളജി,നെഫ്രാളജി,പൾമിനോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4506.jpeg",
    },
    {
      src: "assets/img/Pastevents/4507.jpeg",
      caption:
        "തിരുവനന്തപുരം ജില്ലാ വ്യാവസായിക കേന്ദ്രത്തിൻ്റെ നേതൃത്വത്തിൽ അവണാകുഴി ഹാൻഡ്ലൂം സർക്കിൾ ഓഫീസും  നിംസ് മെഡിസിറ്റിയും സംയുക്തമായി നെയ്ത്ത് തൊഴിലാളികൾക്കായി സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ സുനിൽകുമാർ വി പി (ബഹു: അതിയന്നൂർ ഗ്രാമ പഞ്ചായത്ത് പ്രസിഡണ്ട്)ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി,  ഗ്യാസ്‌ട്രോളജി,നെഫ്രാളജി,പൾമിനോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4507.jpeg",
    },
    {
      src: "assets/img/Pastevents/4508.jpeg",
      caption:
        "തിരുവനന്തപുരം ജില്ലാ വ്യാവസായിക കേന്ദ്രത്തിൻ്റെ നേതൃത്വത്തിൽ അവണാകുഴി ഹാൻഡ്ലൂം സർക്കിൾ ഓഫീസും  നിംസ് മെഡിസിറ്റിയും സംയുക്തമായി നെയ്ത്ത് തൊഴിലാളികൾക്കായി സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ സുനിൽകുമാർ വി പി (ബഹു: അതിയന്നൂർ ഗ്രാമ പഞ്ചായത്ത് പ്രസിഡണ്ട്)ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി,  ഗ്യാസ്‌ട്രോളജി,നെഫ്രാളജി,പൾമിനോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4508.jpeg",
    },
    {
      src: "assets/img/Pastevents/4497.jpeg",
      caption:
        "മാവിളക്കടവ് വലിയവിള ക്രിസ്തുരാജ ദേവാലയം നിഡ്സ് യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി,  ഗ്യാസ്‌ട്രോളജി,നെഫ്രാളജി,പൾമിനോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4497.jpeg",
    },
    {
      src: "assets/img/Pastevents/4498.jpeg",
      caption:
        "മാവിളക്കടവ് വലിയവിള ക്രിസ്തുരാജ ദേവാലയം നിഡ്സ് യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി,  ഗ്യാസ്‌ട്രോളജി,നെഫ്രാളജി,പൾമിനോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4498.jpeg",
    },
    {
      src: "assets/img/Pastevents/4499.jpeg",
      caption:
        "മാവിളക്കടവ് വലിയവിള ക്രിസ്തുരാജ ദേവാലയം നിഡ്സ് യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി,  ഗ്യാസ്‌ട്രോളജി,നെഫ്രാളജി,പൾമിനോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4499.jpeg",
    },
    {
      src: "assets/img/Pastevents/4500.jpeg",
      caption:
        "മാവിളക്കടവ് വലിയവിള ക്രിസ്തുരാജ ദേവാലയം നിഡ്സ് യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി,  ഗ്യാസ്‌ട്രോളജി,നെഫ്രാളജി,പൾമിനോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4500.jpeg",
    },
    {
      src: "assets/img/Pastevents/4501.jpeg",
      caption:
        "മാവിളക്കടവ് വലിയവിള ക്രിസ്തുരാജ ദേവാലയം നിഡ്സ് യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി,  ഗ്യാസ്‌ട്രോളജി,നെഫ്രാളജി,പൾമിനോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4501.jpeg",
    },
    {
      src: "assets/img/Pastevents/4502.jpeg",
      caption:
        "മാവിളക്കടവ് വലിയവിള ക്രിസ്തുരാജ ദേവാലയം നിഡ്സ് യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി,  ഗ്യാസ്‌ട്രോളജി,നെഫ്രാളജി,പൾമിനോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4502.jpeg",
    },
    {
      src: "assets/img/Pastevents/4492.jpeg",
      caption:
        "മെഡി കെയർ -2024 കോട്ടുകാൽ ഗ്രാമ പഞ്ചായത്തും നിംസ് മെഡിസിറ്റിയും സംയുക്തമായി  സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി,  ഗ്യാസ്‌ട്രോളജി,നെഫ്രാളജി,പൾമിനോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4492.jpeg",
    },
    {
      src: "assets/img/Pastevents/4493.jpeg",
      caption:
        "മെഡി കെയർ -2024 കോട്ടുകാൽ ഗ്രാമ പഞ്ചായത്തും നിംസ് മെഡിസിറ്റിയും സംയുക്തമായി  സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി,  ഗ്യാസ്‌ട്രോളജി,നെഫ്രാളജി,പൾമിനോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4493.jpeg",
    },
    {
      src: "assets/img/Pastevents/4494.jpeg",
      caption:
        "മെഡി കെയർ -2024 കോട്ടുകാൽ ഗ്രാമ പഞ്ചായത്തും നിംസ് മെഡിസിറ്റിയും സംയുക്തമായി  സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി,  ഗ്യാസ്‌ട്രോളജി,നെഫ്രാളജി,പൾമിനോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4494.jpeg",
    },
    {
      src: "assets/img/Pastevents/4495.jpeg",
      caption:
        "മെഡി കെയർ -2024 കോട്ടുകാൽ ഗ്രാമ പഞ്ചായത്തും നിംസ് മെഡിസിറ്റിയും സംയുക്തമായി  സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി,  ഗ്യാസ്‌ട്രോളജി,നെഫ്രാളജി,പൾമിനോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4495.jpeg",
    },
    {
      src: "assets/img/Pastevents/4496.jpeg",
      caption:
        "മെഡി കെയർ -2024 കോട്ടുകാൽ ഗ്രാമ പഞ്ചായത്തും നിംസ് മെഡിസിറ്റിയും സംയുക്തമായി  സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി,  ഗ്യാസ്‌ട്രോളജി,നെഫ്രാളജി,പൾമിനോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4496.jpeg",
    },
    {
      src: "assets/img/Pastevents/4486.jpeg",
      caption:
        "തിരുവനന്തപുരം ജില്ലാ വ്യാവസായിക കേന്ദ്രത്തിൻ്റെ നേതൃത്വത്തിൽ വിഴിഞ്ഞം ഹാൻഡ്ലൂം സർക്കിൾ ഓഫീസും  നിംസ് മെഡിസിറ്റിയും സംയുക്തമായി നെയ്ത്ത് തൊഴിലാളികൾക്കായി സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീമതി ചന്ദ്രലേഖ കെ (ബഹു: കോട്ടുകാൽ ഗ്രാമ പഞ്ചായത്ത് പ്രസിഡന്റ്). ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി,  ഗ്യാസ്‌ട്രോളജി,നെഫ്രാളജി,പൾമിനോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4486.jpeg",
    },
    {
      src: "assets/img/Pastevents/4487.jpeg",
      caption:
        "തിരുവനന്തപുരം ജില്ലാ വ്യാവസായിക കേന്ദ്രത്തിൻ്റെ നേതൃത്വത്തിൽ വിഴിഞ്ഞം ഹാൻഡ്ലൂം സർക്കിൾ ഓഫീസും  നിംസ് മെഡിസിറ്റിയും സംയുക്തമായി നെയ്ത്ത് തൊഴിലാളികൾക്കായി സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീമതി ചന്ദ്രലേഖ കെ (ബഹു: കോട്ടുകാൽ ഗ്രാമ പഞ്ചായത്ത് പ്രസിഡന്റ്). ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി,  ഗ്യാസ്‌ട്രോളജി,നെഫ്രാളജി,പൾമിനോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4487.jpeg",
    },
    {
      src: "assets/img/Pastevents/4488.jpeg",
      caption:
        "തിരുവനന്തപുരം ജില്ലാ വ്യാവസായിക കേന്ദ്രത്തിൻ്റെ നേതൃത്വത്തിൽ വിഴിഞ്ഞം ഹാൻഡ്ലൂം സർക്കിൾ ഓഫീസും  നിംസ് മെഡിസിറ്റിയും സംയുക്തമായി നെയ്ത്ത് തൊഴിലാളികൾക്കായി സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീമതി ചന്ദ്രലേഖ കെ (ബഹു: കോട്ടുകാൽ ഗ്രാമ പഞ്ചായത്ത് പ്രസിഡന്റ്). ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി,  ഗ്യാസ്‌ട്രോളജി,നെഫ്രാളജി,പൾമിനോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4488.jpeg",
    },
    {
      src: "assets/img/Pastevents/4489.jpeg",
      caption:
        "തിരുവനന്തപുരം ജില്ലാ വ്യാവസായിക കേന്ദ്രത്തിൻ്റെ നേതൃത്വത്തിൽ വിഴിഞ്ഞം ഹാൻഡ്ലൂം സർക്കിൾ ഓഫീസും  നിംസ് മെഡിസിറ്റിയും സംയുക്തമായി നെയ്ത്ത് തൊഴിലാളികൾക്കായി സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീമതി ചന്ദ്രലേഖ കെ (ബഹു: കോട്ടുകാൽ ഗ്രാമ പഞ്ചായത്ത് പ്രസിഡന്റ്). ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി,  ഗ്യാസ്‌ട്രോളജി,നെഫ്രാളജി,പൾമിനോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4489.jpeg",
    },
    {
      src: "assets/img/Pastevents/4490.jpeg",
      caption:
        "തിരുവനന്തപുരം ജില്ലാ വ്യാവസായിക കേന്ദ്രത്തിൻ്റെ നേതൃത്വത്തിൽ വിഴിഞ്ഞം ഹാൻഡ്ലൂം സർക്കിൾ ഓഫീസും  നിംസ് മെഡിസിറ്റിയും സംയുക്തമായി നെയ്ത്ത് തൊഴിലാളികൾക്കായി സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീമതി ചന്ദ്രലേഖ കെ (ബഹു: കോട്ടുകാൽ ഗ്രാമ പഞ്ചായത്ത് പ്രസിഡന്റ്). ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി,  ഗ്യാസ്‌ട്രോളജി,നെഫ്രാളജി,പൾമിനോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4490.jpeg",
    },
    {
      src: "assets/img/Pastevents/4491.jpeg",
      caption:
        "തിരുവനന്തപുരം ജില്ലാ വ്യാവസായിക കേന്ദ്രത്തിൻ്റെ നേതൃത്വത്തിൽ വിഴിഞ്ഞം ഹാൻഡ്ലൂം സർക്കിൾ ഓഫീസും  നിംസ് മെഡിസിറ്റിയും സംയുക്തമായി നെയ്ത്ത് തൊഴിലാളികൾക്കായി സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീമതി ചന്ദ്രലേഖ കെ (ബഹു: കോട്ടുകാൽ ഗ്രാമ പഞ്ചായത്ത് പ്രസിഡന്റ്). ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി,  ഗ്യാസ്‌ട്രോളജി,നെഫ്രാളജി,പൾമിനോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4491.jpeg",
    },
    {
      src: "assets/img/Pastevents/4481.jpeg",
      caption:
        "വെള്ളനാട് വെളിയണ്ണൂർ നവഭാരത് ആർട്ട്സ് ആൻഡ് സ്പോർട്സ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4481.jpeg",
    },
    {
      src: "assets/img/Pastevents/4482.jpeg",
      caption:
        "വെള്ളനാട് വെളിയണ്ണൂർ നവഭാരത് ആർട്ട്സ് ആൻഡ് സ്പോർട്സ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4482.jpeg",
    },
    {
      src: "assets/img/Pastevents/4483.jpeg",
      caption:
        "വെള്ളനാട് വെളിയണ്ണൂർ നവഭാരത് ആർട്ട്സ് ആൻഡ് സ്പോർട്സ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4483.jpeg",
    },
    {
      src: "assets/img/Pastevents/4484.jpeg",
      caption:
        "വെള്ളനാട് വെളിയണ്ണൂർ നവഭാരത് ആർട്ട്സ് ആൻഡ് സ്പോർട്സ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4484.jpeg",
    },
    {
      src: "assets/img/Pastevents/4485.jpeg",
      caption:
        "വെള്ളനാട് വെളിയണ്ണൂർ നവഭാരത് ആർട്ട്സ് ആൻഡ് സ്പോർട്സ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4485.jpeg",
    },
    {
      src: "assets/img/Pastevents/4476.jpeg",
      caption:
        "പാപ്പനംകോട് ശ്രീ ചിത്തിര തിരുനാൾ റെസിഡൻഷ്യൽ അസോസിയേഷൻൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4476.jpeg",
    },
    {
      src: "assets/img/Pastevents/4477.jpeg",
      caption:
        "പാപ്പനംകോട് ശ്രീ ചിത്തിര തിരുനാൾ റെസിഡൻഷ്യൽ അസോസിയേഷൻൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4477.jpeg",
    },
    {
      src: "assets/img/Pastevents/4478.jpeg",
      caption:
        "പാപ്പനംകോട് ശ്രീ ചിത്തിര തിരുനാൾ റെസിഡൻഷ്യൽ അസോസിയേഷൻൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4478.jpeg",
    },
    {
      src: "assets/img/Pastevents/4479.jpeg",
      caption:
        "പാപ്പനംകോട് ശ്രീ ചിത്തിര തിരുനാൾ റെസിഡൻഷ്യൽ അസോസിയേഷൻൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4479.jpeg",
    },
    {
      src: "assets/img/Pastevents/4480.jpeg",
      caption:
        "പാപ്പനംകോട് ശ്രീ ചിത്തിര തിരുനാൾ റെസിഡൻഷ്യൽ അസോസിയേഷൻൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4480.jpeg",
    },
    {
      src: "assets/img/Pastevents/4475.jpeg",
      caption:
        "പാപ്പനംകോട് ശ്രീ ചിത്തിര തിരുനാൾ റെസിഡൻഷ്യൽ അസോസിയേഷൻൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4475.jpeg",
    },
    {
      src: "assets/img/Pastevents/4469.jpeg",
      caption:
        "ശ്രീ ഉമ്മൻചാണ്ടി ചരമ വാർഷികത്തോട്   അനുബന്ധിച്ച് കരകുളം ചെക്കകോണം ഇന്ത്യൻ നാഷണൽ കോൺഗ്രസ് വാർഡ് കമ്മിറ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം മുൻ ഡി സി സി പ്രസിഡൻറ് കരകുളം ക്യഷ്ണപിളള. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി,  ഗ്യാസ്‌ട്രോളജി,നെഫ്രാളജി,പൾമിനോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4469.jpeg",
    },
    {
      src: "assets/img/Pastevents/4470.jpeg",
      caption:
        "ശ്രീ ഉമ്മൻചാണ്ടി ചരമ വാർഷികത്തോട്   അനുബന്ധിച്ച് കരകുളം ചെക്കകോണം ഇന്ത്യൻ നാഷണൽ കോൺഗ്രസ് വാർഡ് കമ്മിറ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം മുൻ ഡി സി സി പ്രസിഡൻറ് കരകുളം ക്യഷ്ണപിളള. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി,  ഗ്യാസ്‌ട്രോളജി,നെഫ്രാളജി,പൾമിനോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4470.jpeg",
    },
    {
      src: "assets/img/Pastevents/4471.jpeg",
      caption:
        "ശ്രീ ഉമ്മൻചാണ്ടി ചരമ വാർഷികത്തോട്   അനുബന്ധിച്ച് കരകുളം ചെക്കകോണം ഇന്ത്യൻ നാഷണൽ കോൺഗ്രസ് വാർഡ് കമ്മിറ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം മുൻ ഡി സി സി പ്രസിഡൻറ് കരകുളം ക്യഷ്ണപിളള. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി,  ഗ്യാസ്‌ട്രോളജി,നെഫ്രാളജി,പൾമിനോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4471.jpeg",
    },
    {
      src: "assets/img/Pastevents/4472.jpeg",
      caption:
        "ശ്രീ ഉമ്മൻചാണ്ടി ചരമ വാർഷികത്തോട്   അനുബന്ധിച്ച് കരകുളം ചെക്കകോണം ഇന്ത്യൻ നാഷണൽ കോൺഗ്രസ് വാർഡ് കമ്മിറ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം മുൻ ഡി സി സി പ്രസിഡൻറ് കരകുളം ക്യഷ്ണപിളള. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി,  ഗ്യാസ്‌ട്രോളജി,നെഫ്രാളജി,പൾമിനോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4472.jpeg",
    },
    {
      src: "assets/img/Pastevents/4473.jpeg",
      caption:
        "ശ്രീ ഉമ്മൻചാണ്ടി ചരമ വാർഷികത്തോട്   അനുബന്ധിച്ച് കരകുളം ചെക്കകോണം ഇന്ത്യൻ നാഷണൽ കോൺഗ്രസ് വാർഡ് കമ്മിറ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം മുൻ ഡി സി സി പ്രസിഡൻറ് കരകുളം ക്യഷ്ണപിളള. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി,  ഗ്യാസ്‌ട്രോളജി,നെഫ്രാളജി,പൾമിനോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4473.jpeg",
    },
    {
      src: "assets/img/Pastevents/4474.jpeg",
      caption:
        "ശ്രീ ഉമ്മൻചാണ്ടി ചരമ വാർഷികത്തോട്   അനുബന്ധിച്ച് കരകുളം ചെക്കകോണം ഇന്ത്യൻ നാഷണൽ കോൺഗ്രസ് വാർഡ് കമ്മിറ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം മുൻ ഡി സി സി പ്രസിഡൻറ് കരകുളം ക്യഷ്ണപിളള. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി,  ഗ്യാസ്‌ട്രോളജി,നെഫ്രാളജി,പൾമിനോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4474.jpeg",
    },
    {
      src: "assets/img/Pastevents/4459.jpeg",
      caption:
        "മുൻ മുഖ്യമന്ത്രി ശ്രീ ഉമ്മൻചാണ്ടി സാറിൻ്റെ ചരമ വാർഷികത്തോട്   അനുബന്ധിച്ച് തിരുവനന്തപുരം ഉമ്മൻചാണ്ടി ഫൗണ്ടേഷൻൻ്റെയും  നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ബഹു: എം എൽ എ ശ്രീ ചാണ്ടി ഉമ്മൻ (കോട്ടയം) . ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി,  ഗ്യാസ്‌ട്രോളജി,നെഫ്രാളജി,പൾമിനോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4459.jpeg",
    },
    {
      src: "assets/img/Pastevents/4460.jpeg",
      caption:
        "മുൻ മുഖ്യമന്ത്രി ശ്രീ ഉമ്മൻചാണ്ടി സാറിൻ്റെ ചരമ വാർഷികത്തോട്   അനുബന്ധിച്ച് തിരുവനന്തപുരം ഉമ്മൻചാണ്ടി ഫൗണ്ടേഷൻൻ്റെയും  നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ബഹു: എം എൽ എ ശ്രീ ചാണ്ടി ഉമ്മൻ (കോട്ടയം) . ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി,  ഗ്യാസ്‌ട്രോളജി,നെഫ്രാളജി,പൾമിനോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4460.jpeg",
    },
    {
      src: "assets/img/Pastevents/4461.jpeg",
      caption:
        "മുൻ മുഖ്യമന്ത്രി ശ്രീ ഉമ്മൻചാണ്ടി സാറിൻ്റെ ചരമ വാർഷികത്തോട്   അനുബന്ധിച്ച് തിരുവനന്തപുരം ഉമ്മൻചാണ്ടി ഫൗണ്ടേഷൻൻ്റെയും  നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ബഹു: എം എൽ എ ശ്രീ ചാണ്ടി ഉമ്മൻ (കോട്ടയം) . ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി,  ഗ്യാസ്‌ട്രോളജി,നെഫ്രാളജി,പൾമിനോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4461.jpeg",
    },
    {
      src: "assets/img/Pastevents/4462.jpeg",
      caption:
        "മുൻ മുഖ്യമന്ത്രി ശ്രീ ഉമ്മൻചാണ്ടി സാറിൻ്റെ ചരമ വാർഷികത്തോട്   അനുബന്ധിച്ച് തിരുവനന്തപുരം ഉമ്മൻചാണ്ടി ഫൗണ്ടേഷൻൻ്റെയും  നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ബഹു: എം എൽ എ ശ്രീ ചാണ്ടി ഉമ്മൻ (കോട്ടയം) . ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി,  ഗ്യാസ്‌ട്രോളജി,നെഫ്രാളജി,പൾമിനോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4462.jpeg",
    },
    {
      src: "assets/img/Pastevents/4463.jpeg",
      caption:
        "മുൻ മുഖ്യമന്ത്രി ശ്രീ ഉമ്മൻചാണ്ടി സാറിൻ്റെ ചരമ വാർഷികത്തോട്   അനുബന്ധിച്ച് തിരുവനന്തപുരം ഉമ്മൻചാണ്ടി ഫൗണ്ടേഷൻൻ്റെയും  നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ബഹു: എം എൽ എ ശ്രീ ചാണ്ടി ഉമ്മൻ (കോട്ടയം) . ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി,  ഗ്യാസ്‌ട്രോളജി,നെഫ്രാളജി,പൾമിനോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4463.jpeg",
    },
    {
      src: "assets/img/Pastevents/4464.jpeg",
      caption:
        "മുൻ മുഖ്യമന്ത്രി ശ്രീ ഉമ്മൻചാണ്ടി സാറിൻ്റെ ചരമ വാർഷികത്തോട്   അനുബന്ധിച്ച് തിരുവനന്തപുരം ഉമ്മൻചാണ്ടി ഫൗണ്ടേഷൻൻ്റെയും  നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ബഹു: എം എൽ എ ശ്രീ ചാണ്ടി ഉമ്മൻ (കോട്ടയം) . ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി,  ഗ്യാസ്‌ട്രോളജി,നെഫ്രാളജി,പൾമിനോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4464.jpeg",
    },
    {
      src: "assets/img/Pastevents/4465.jpeg",
      caption:
        "മുൻ മുഖ്യമന്ത്രി ശ്രീ ഉമ്മൻചാണ്ടി സാറിൻ്റെ ചരമ വാർഷികത്തോട്   അനുബന്ധിച്ച് തിരുവനന്തപുരം ഉമ്മൻചാണ്ടി ഫൗണ്ടേഷൻൻ്റെയും  നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ബഹു: എം എൽ എ ശ്രീ ചാണ്ടി ഉമ്മൻ (കോട്ടയം) . ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി,  ഗ്യാസ്‌ട്രോളജി,നെഫ്രാളജി,പൾമിനോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4465.jpeg",
    },
    {
      src: "assets/img/Pastevents/4466.jpeg",
      caption:
        "മുൻ മുഖ്യമന്ത്രി ശ്രീ ഉമ്മൻചാണ്ടി സാറിൻ്റെ ചരമ വാർഷികത്തോട്   അനുബന്ധിച്ച് തിരുവനന്തപുരം ഉമ്മൻചാണ്ടി ഫൗണ്ടേഷൻൻ്റെയും  നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ബഹു: എം എൽ എ ശ്രീ ചാണ്ടി ഉമ്മൻ (കോട്ടയം) . ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി,  ഗ്യാസ്‌ട്രോളജി,നെഫ്രാളജി,പൾമിനോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4466.jpeg",
    },
    {
      src: "assets/img/Pastevents/4467.jpeg",
      caption:
        "മുൻ മുഖ്യമന്ത്രി ശ്രീ ഉമ്മൻചാണ്ടി സാറിൻ്റെ ചരമ വാർഷികത്തോട്   അനുബന്ധിച്ച് തിരുവനന്തപുരം ഉമ്മൻചാണ്ടി ഫൗണ്ടേഷൻൻ്റെയും  നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ബഹു: എം എൽ എ ശ്രീ ചാണ്ടി ഉമ്മൻ (കോട്ടയം) . ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി,  ഗ്യാസ്‌ട്രോളജി,നെഫ്രാളജി,പൾമിനോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4467.jpeg",
    },
    {
      src: "assets/img/Pastevents/4468.jpeg",
      caption:
        "മുൻ മുഖ്യമന്ത്രി ശ്രീ ഉമ്മൻചാണ്ടി സാറിൻ്റെ ചരമ വാർഷികത്തോട്   അനുബന്ധിച്ച് തിരുവനന്തപുരം ഉമ്മൻചാണ്ടി ഫൗണ്ടേഷൻൻ്റെയും  നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ബഹു: എം എൽ എ ശ്രീ ചാണ്ടി ഉമ്മൻ (കോട്ടയം) . ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി,  ഗ്യാസ്‌ട്രോളജി,നെഫ്രാളജി,പൾമിനോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4468.jpeg",
    },
    {
      src: "assets/img/Pastevents/4453.jpeg",
      caption:
        "വിഴിഞ്ഞം ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4453.jpeg",
    },
    {
      src: "assets/img/Pastevents/4454.jpeg",
      caption:
        "വിഴിഞ്ഞം ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4454.jpeg",
    },
    {
      src: "assets/img/Pastevents/4455.jpeg",
      caption:
        "വിഴിഞ്ഞം ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4455.jpeg",
    },
    {
      src: "assets/img/Pastevents/4456.jpeg",
      caption:
        "വിഴിഞ്ഞം ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4456.jpeg",
    },
    {
      src: "assets/img/Pastevents/4457.jpeg",
      caption:
        "വിഴിഞ്ഞം ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4457.jpeg",
    },
    {
      src: "assets/img/Pastevents/4458.jpeg",
      caption:
        "വിഴിഞ്ഞം ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4458.jpeg",
    },
    {
      src: "assets/img/Pastevents/4447.jpeg",
      caption:
        "നിംസ്  @ സ്കൂൾ (🏫2) ഉണ്ടൻങ്കോട് സെൻ്റ് ജോൺസ് ഹയർ സെക്കണ്ടറി സ്കൂൾ സിൽവർ ജൂബിലി ആഘോഷത്തിന്റെ ഭാഗമായി നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ  സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4447.jpeg",
    },
    {
      src: "assets/img/Pastevents/4448.jpeg",
      caption:
        "നിംസ്  @ സ്കൂൾ (🏫2) ഉണ്ടൻങ്കോട് സെൻ്റ് ജോൺസ് ഹയർ സെക്കണ്ടറി സ്കൂൾ സിൽവർ ജൂബിലി ആഘോഷത്തിന്റെ ഭാഗമായി നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ  സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4448.jpeg",
    },
    {
      src: "assets/img/Pastevents/4449.jpeg",
      caption:
        "നിംസ്  @ സ്കൂൾ (🏫2) ഉണ്ടൻങ്കോട് സെൻ്റ് ജോൺസ് ഹയർ സെക്കണ്ടറി സ്കൂൾ സിൽവർ ജൂബിലി ആഘോഷത്തിന്റെ ഭാഗമായി നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ  സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4449.jpeg",
    },
    {
      src: "assets/img/Pastevents/4450.jpeg",
      caption:
        "നിംസ്  @ സ്കൂൾ (🏫2) ഉണ്ടൻങ്കോട് സെൻ്റ് ജോൺസ് ഹയർ സെക്കണ്ടറി സ്കൂൾ സിൽവർ ജൂബിലി ആഘോഷത്തിന്റെ ഭാഗമായി നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ  സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4450.jpeg",
    },
    {
      src: "assets/img/Pastevents/4451.jpeg",
      caption:
        "നിംസ്  @ സ്കൂൾ (🏫2) ഉണ്ടൻങ്കോട് സെൻ്റ് ജോൺസ് ഹയർ സെക്കണ്ടറി സ്കൂൾ സിൽവർ ജൂബിലി ആഘോഷത്തിന്റെ ഭാഗമായി നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ  സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4451.jpeg",
    },
    {
      src: "assets/img/Pastevents/4452.jpeg",
      caption:
        "നിംസ്  @ സ്കൂൾ (🏫2) ഉണ്ടൻങ്കോട് സെൻ്റ് ജോൺസ് ഹയർ സെക്കണ്ടറി സ്കൂൾ സിൽവർ ജൂബിലി ആഘോഷത്തിന്റെ ഭാഗമായി നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ  സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4452.jpeg",
    },
    {
      src: "assets/img/Pastevents/4440.jpeg",
      caption:
        "വട്ടവിള സി പി എം ( ഐ)ബ്രാഞ്ചിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4440.jpeg",
    },
    {
      src: "assets/img/Pastevents/4441.jpeg",
      caption:
        "വട്ടവിള സി പി എം ( ഐ)ബ്രാഞ്ചിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4441.jpeg",
    },
    {
      src: "assets/img/Pastevents/4442.jpeg",
      caption:
        "വട്ടവിള സി പി എം ( ഐ)ബ്രാഞ്ചിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4442.jpeg",
    },
    {
      src: "assets/img/Pastevents/4443.jpeg",
      caption:
        "വട്ടവിള സി പി എം ( ഐ)ബ്രാഞ്ചിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4443.jpeg",
    },
    {
      src: "assets/img/Pastevents/4444.jpeg",
      caption:
        "വട്ടവിള സി പി എം ( ഐ)ബ്രാഞ്ചിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4444.jpeg",
    },
    {
      src: "assets/img/Pastevents/4445.jpeg",
      caption:
        "വട്ടവിള സി പി എം ( ഐ)ബ്രാഞ്ചിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4445.jpeg",
    },
    {
      src: "assets/img/Pastevents/4446.jpeg",
      caption:
        "വട്ടവിള സി പി എം ( ഐ)ബ്രാഞ്ചിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4446.jpeg",
    },
    {
      src: "assets/img/Pastevents/4434.jpeg",
      caption:
        " അംബനാട് എസ്റ്റേറ്റ് സെവൻത് ഡേ അഡ്വെൻ്റിസ്റ് ചർച്ചിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4434.jpeg",
    },
    {
      src: "assets/img/Pastevents/4435.jpeg",
      caption:
        " അംബനാട് എസ്റ്റേറ്റ് സെവൻത് ഡേ അഡ്വെൻ്റിസ്റ് ചർച്ചിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4435.jpeg",
    },
    {
      src: "assets/img/Pastevents/4436.jpeg",
      caption:
        " അംബനാട് എസ്റ്റേറ്റ് സെവൻത് ഡേ അഡ്വെൻ്റിസ്റ് ചർച്ചിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4436.jpeg",
    },
     {
      src: "assets/img/Pastevents/4437.jpeg",
      caption:
        " അംബനാട് എസ്റ്റേറ്റ് സെവൻത് ഡേ അഡ്വെൻ്റിസ്റ് ചർച്ചിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4437.jpeg",
    },
    {
      src: "assets/img/Pastevents/4438.jpeg",
      caption:
        " അംബനാട് എസ്റ്റേറ്റ് സെവൻത് ഡേ അഡ്വെൻ്റിസ്റ് ചർച്ചിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4438.jpeg",
    },
    {
      src: "assets/img/Pastevents/4439.jpeg",
      caption:
        " അംബനാട് എസ്റ്റേറ്റ് സെവൻത് ഡേ അഡ്വെൻ്റിസ്റ് ചർച്ചിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4439.jpeg",
    },
    {
      src: "assets/img/Pastevents/4429.jpeg",
      caption:
        "കാട്ടാക്കട നെയ്യാർ ഡാം ശ്രീ  തുണ്ടുനട തമ്പുരാൻ ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി",
      thumb: "assets/img/Pastevents/4429.jpeg",
    },
    {
      src: "assets/img/Pastevents/4430.jpeg",
      caption:
        "കാട്ടാക്കട നെയ്യാർ ഡാം ശ്രീ  തുണ്ടുനട തമ്പുരാൻ ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി",
      thumb: "assets/img/Pastevents/4430.jpeg",
    },
    {
      src: "assets/img/Pastevents/4431.jpeg",
      caption:
        "കാട്ടാക്കട നെയ്യാർ ഡാം ശ്രീ  തുണ്ടുനട തമ്പുരാൻ ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി",
      thumb: "assets/img/Pastevents/4431.jpeg",
    },
    {
      src: "assets/img/Pastevents/4432.jpeg",
      caption:
        "കാട്ടാക്കട നെയ്യാർ ഡാം ശ്രീ  തുണ്ടുനട തമ്പുരാൻ ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി",
      thumb: "assets/img/Pastevents/4432.jpeg",
    },
    {
      src: "assets/img/Pastevents/4433.jpeg",
      caption:
        "കാട്ടാക്കട നെയ്യാർ ഡാം ശ്രീ  തുണ്ടുനട തമ്പുരാൻ ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി",
      thumb: "assets/img/Pastevents/4433.jpeg",
    },
    {
      src: "assets/img/Pastevents/4421.jpeg",
      caption:
        "അടൂർ ബി ആൻഡ് യു ഫൗണ്ടേഷൻൻ്റെയും  നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ബഹു: എം പി ശ്രീ ആൻ്റോ ആൻ്റണി, സൗജന്യ മരുന്നു വിതരണം ശ്രീമതി ദിവ്യ റെജി മുഹമ്മദ് ( അടൂർ മുനിസിപ്പാലിറ്റി ചെയർപേഴ്സൺ ) സൗജന്യ കണ്ണട വിതരണം ശ്രീ എം അലാവുദ്ദീൻ (വിദ്യാഭ്യാസ സ്റ്റാന്റിംഗ് കമ്മിറ്റി ചെയർമാൻ). ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി, ഓങ്കോളജി, ഗ്യാസ്‌ട്രോളജി,നെഫ്രാളജി,പൾമിനോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4421.jpeg",
    },
    {
      src: "assets/img/Pastevents/4422.jpeg",
      caption:
        "അടൂർ ബി ആൻഡ് യു ഫൗണ്ടേഷൻൻ്റെയും  നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ബഹു: എം പി ശ്രീ ആൻ്റോ ആൻ്റണി, സൗജന്യ മരുന്നു വിതരണം ശ്രീമതി ദിവ്യ റെജി മുഹമ്മദ് ( അടൂർ മുനിസിപ്പാലിറ്റി ചെയർപേഴ്സൺ ) സൗജന്യ കണ്ണട വിതരണം ശ്രീ എം അലാവുദ്ദീൻ (വിദ്യാഭ്യാസ സ്റ്റാന്റിംഗ് കമ്മിറ്റി ചെയർമാൻ). ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി, ഓങ്കോളജി, ഗ്യാസ്‌ട്രോളജി,നെഫ്രാളജി,പൾമിനോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4422.jpeg",
    },
    {
      src: "assets/img/Pastevents/4423.jpeg",
      caption:
        "അടൂർ ബി ആൻഡ് യു ഫൗണ്ടേഷൻൻ്റെയും  നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ബഹു: എം പി ശ്രീ ആൻ്റോ ആൻ്റണി, സൗജന്യ മരുന്നു വിതരണം ശ്രീമതി ദിവ്യ റെജി മുഹമ്മദ് ( അടൂർ മുനിസിപ്പാലിറ്റി ചെയർപേഴ്സൺ ) സൗജന്യ കണ്ണട വിതരണം ശ്രീ എം അലാവുദ്ദീൻ (വിദ്യാഭ്യാസ സ്റ്റാന്റിംഗ് കമ്മിറ്റി ചെയർമാൻ). ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി, ഓങ്കോളജി, ഗ്യാസ്‌ട്രോളജി,നെഫ്രാളജി,പൾമിനോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4423.jpeg",
    },
    {
      src: "assets/img/Pastevents/4424.jpeg",
      caption:
        "അടൂർ ബി ആൻഡ് യു ഫൗണ്ടേഷൻൻ്റെയും  നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ബഹു: എം പി ശ്രീ ആൻ്റോ ആൻ്റണി, സൗജന്യ മരുന്നു വിതരണം ശ്രീമതി ദിവ്യ റെജി മുഹമ്മദ് ( അടൂർ മുനിസിപ്പാലിറ്റി ചെയർപേഴ്സൺ ) സൗജന്യ കണ്ണട വിതരണം ശ്രീ എം അലാവുദ്ദീൻ (വിദ്യാഭ്യാസ സ്റ്റാന്റിംഗ് കമ്മിറ്റി ചെയർമാൻ). ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി, ഓങ്കോളജി, ഗ്യാസ്‌ട്രോളജി,നെഫ്രാളജി,പൾമിനോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4424.jpeg",
    },
    {
      src: "assets/img/Pastevents/4425.jpeg",
      caption:
        "അടൂർ ബി ആൻഡ് യു ഫൗണ്ടേഷൻൻ്റെയും  നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ബഹു: എം പി ശ്രീ ആൻ്റോ ആൻ്റണി, സൗജന്യ മരുന്നു വിതരണം ശ്രീമതി ദിവ്യ റെജി മുഹമ്മദ് ( അടൂർ മുനിസിപ്പാലിറ്റി ചെയർപേഴ്സൺ ) സൗജന്യ കണ്ണട വിതരണം ശ്രീ എം അലാവുദ്ദീൻ (വിദ്യാഭ്യാസ സ്റ്റാന്റിംഗ് കമ്മിറ്റി ചെയർമാൻ). ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി, ഓങ്കോളജി, ഗ്യാസ്‌ട്രോളജി,നെഫ്രാളജി,പൾമിനോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4425.jpeg",
    },
    {
      src: "assets/img/Pastevents/4426.jpeg",
      caption:
        "അടൂർ ബി ആൻഡ് യു ഫൗണ്ടേഷൻൻ്റെയും  നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ബഹു: എം പി ശ്രീ ആൻ്റോ ആൻ്റണി, സൗജന്യ മരുന്നു വിതരണം ശ്രീമതി ദിവ്യ റെജി മുഹമ്മദ് ( അടൂർ മുനിസിപ്പാലിറ്റി ചെയർപേഴ്സൺ ) സൗജന്യ കണ്ണട വിതരണം ശ്രീ എം അലാവുദ്ദീൻ (വിദ്യാഭ്യാസ സ്റ്റാന്റിംഗ് കമ്മിറ്റി ചെയർമാൻ). ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി, ഓങ്കോളജി, ഗ്യാസ്‌ട്രോളജി,നെഫ്രാളജി,പൾമിനോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4426.jpeg",
    },
    {
      src: "assets/img/Pastevents/4427.jpeg",
      caption:
        "അടൂർ ബി ആൻഡ് യു ഫൗണ്ടേഷൻൻ്റെയും  നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ബഹു: എം പി ശ്രീ ആൻ്റോ ആൻ്റണി, സൗജന്യ മരുന്നു വിതരണം ശ്രീമതി ദിവ്യ റെജി മുഹമ്മദ് ( അടൂർ മുനിസിപ്പാലിറ്റി ചെയർപേഴ്സൺ ) സൗജന്യ കണ്ണട വിതരണം ശ്രീ എം അലാവുദ്ദീൻ (വിദ്യാഭ്യാസ സ്റ്റാന്റിംഗ് കമ്മിറ്റി ചെയർമാൻ). ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി, ഓങ്കോളജി, ഗ്യാസ്‌ട്രോളജി,നെഫ്രാളജി,പൾമിനോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4427.jpeg",
    },
    {
      src: "assets/img/Pastevents/4428.jpeg",
      caption:
        "അടൂർ ബി ആൻഡ് യു ഫൗണ്ടേഷൻൻ്റെയും  നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ബഹു: എം പി ശ്രീ ആൻ്റോ ആൻ്റണി, സൗജന്യ മരുന്നു വിതരണം ശ്രീമതി ദിവ്യ റെജി മുഹമ്മദ് ( അടൂർ മുനിസിപ്പാലിറ്റി ചെയർപേഴ്സൺ ) സൗജന്യ കണ്ണട വിതരണം ശ്രീ എം അലാവുദ്ദീൻ (വിദ്യാഭ്യാസ സ്റ്റാന്റിംഗ് കമ്മിറ്റി ചെയർമാൻ). ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി, ഓങ്കോളജി, ഗ്യാസ്‌ട്രോളജി,നെഫ്രാളജി,പൾമിനോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4428.jpeg",
    },
    {
      src: "assets/img/Pastevents/4416.jpeg",
      caption:
        " ലൈറ്റ് ആൻഡ് സൗണ്ട് വെൽഫെയർ അസോസിയേഷൻ ബാലരാമപുരം മേഖലയുടെയും  നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4416.jpeg",
    },
    {
      src: "assets/img/Pastevents/4417.jpeg",
      caption:
        " ലൈറ്റ് ആൻഡ് സൗണ്ട് വെൽഫെയർ അസോസിയേഷൻ ബാലരാമപുരം മേഖലയുടെയും  നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4417.jpeg",
    },
    {
      src: "assets/img/Pastevents/4418.jpeg",
      caption:
        " ലൈറ്റ് ആൻഡ് സൗണ്ട് വെൽഫെയർ അസോസിയേഷൻ ബാലരാമപുരം മേഖലയുടെയും  നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4418.jpeg",
    },
    {
      src: "assets/img/Pastevents/4419.jpeg",
      caption:
        " ലൈറ്റ് ആൻഡ് സൗണ്ട് വെൽഫെയർ അസോസിയേഷൻ ബാലരാമപുരം മേഖലയുടെയും  നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4419.jpeg",
    },
    {
      src: "assets/img/Pastevents/4420.jpeg",
      caption:
        " ലൈറ്റ് ആൻഡ് സൗണ്ട് വെൽഫെയർ അസോസിയേഷൻ ബാലരാമപുരം മേഖലയുടെയും  നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4420.jpeg",
    },
    {
      src: "assets/img/Pastevents/4411.jpeg",
      caption:
        "ഗ്രാമോത്സവം-2024, തിക്കുറിശ്ശി മെമ്മോറിയൽ സാംസ്കാരിക സമിതിയുടെയും  നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4411.jpeg",
    },
    {
      src: "assets/img/Pastevents/4412.jpeg",
      caption:
        "ഗ്രാമോത്സവം-2024, തിക്കുറിശ്ശി മെമ്മോറിയൽ സാംസ്കാരിക സമിതിയുടെയും  നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4412.jpeg",
    },
    {
      src: "assets/img/Pastevents/4413.jpeg",
      caption:
        "ഗ്രാമോത്സവം-2024, തിക്കുറിശ്ശി മെമ്മോറിയൽ സാംസ്കാരിക സമിതിയുടെയും  നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4413.jpeg",
    },
    {
      src: "assets/img/Pastevents/4414.jpeg",
      caption:
        "ഗ്രാമോത്സവം-2024, തിക്കുറിശ്ശി മെമ്മോറിയൽ സാംസ്കാരിക സമിതിയുടെയും  നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4414.jpeg",
    },
    {
      src: "assets/img/Pastevents/4415.jpeg",
      caption:
        "ഗ്രാമോത്സവം-2024, തിക്കുറിശ്ശി മെമ്മോറിയൽ സാംസ്കാരിക സമിതിയുടെയും  നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4415.jpeg",
    },
    {
      src: "assets/img/Pastevents/4406.jpeg",
      caption:
        "റ്റി ബി ജംഗ്ഷൻ സെൻ്റ് ഫിലിപ്പ് സ്ക്കൂളിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4406.jpeg",
    },
    {
      src: "assets/img/Pastevents/4407.jpeg",
      caption:
        "റ്റി ബി ജംഗ്ഷൻ സെൻ്റ് ഫിലിപ്പ് സ്ക്കൂളിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4407.jpeg",
    },
    {
      src: "assets/img/Pastevents/4408.jpeg",
      caption:
        "റ്റി ബി ജംഗ്ഷൻ സെൻ്റ് ഫിലിപ്പ് സ്ക്കൂളിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4408.jpeg",
    },
    {
      src: "assets/img/Pastevents/4409.jpeg",
      caption:
        "റ്റി ബി ജംഗ്ഷൻ സെൻ്റ് ഫിലിപ്പ് സ്ക്കൂളിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4409.jpeg",
    },
    {
      src: "assets/img/Pastevents/4410.jpeg",
      caption:
        "റ്റി ബി ജംഗ്ഷൻ സെൻ്റ് ഫിലിപ്പ് സ്ക്കൂളിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4410.jpeg",
    },
    {
      src: "assets/img/Pastevents/4400.jpeg",
      caption:
        "വഞ്ചിയൂർ വനിതാ സമാജത്തിൻ്റെയും  നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4400.jpeg",
    },
    {
      src: "assets/img/Pastevents/4401.jpeg",
      caption:
        "വഞ്ചിയൂർ വനിതാ സമാജത്തിൻ്റെയും  നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4401.jpeg",
    },
    {
      src: "assets/img/Pastevents/4402.jpeg",
      caption:
        "വഞ്ചിയൂർ വനിതാ സമാജത്തിൻ്റെയും  നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4402.jpeg",
    },
    {
      src: "assets/img/Pastevents/4403.jpeg",
      caption:
        "വഞ്ചിയൂർ വനിതാ സമാജത്തിൻ്റെയും  നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4403.jpeg",
    },
    {
      src: "assets/img/Pastevents/4404.jpeg",
      caption:
        "വഞ്ചിയൂർ വനിതാ സമാജത്തിൻ്റെയും  നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4404.jpeg",
    },
    {
      src: "assets/img/Pastevents/4405.jpeg",
      caption:
        "വഞ്ചിയൂർ വനിതാ സമാജത്തിൻ്റെയും  നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4405.jpeg",
    },
    {
      src: "assets/img/Pastevents/4395.jpeg",
      caption:
        "വിഴിഞ്ഞം ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4395.jpeg",
    },
    {
      src: "assets/img/Pastevents/4396.jpeg",
      caption:
        "വിഴിഞ്ഞം ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4396.jpeg",
    },
    {
      src: "assets/img/Pastevents/4397.jpeg",
      caption:
        "വിഴിഞ്ഞം ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4397.jpeg",
    },
    {
      src: "assets/img/Pastevents/4398.jpeg",
      caption:
        "വിഴിഞ്ഞം ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4398.jpeg",
    },
    {
      src: "assets/img/Pastevents/4399.jpeg",
      caption:
        "വിഴിഞ്ഞം ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4399.jpeg",
    },
    {
      src: "assets/img/Pastevents/4385.jpeg",
      caption:
        "ജൂലൈ-01 ദേശീയ ഡോക്ടേഴ്‌സ് ദിനത്തോട് അനുബന്ധിച്ച് ഊരുട്ടുകാല ജീ ആർ പബ്ലിക്ക് സ്ക്കൂൾ, ബാലരാമപുരം ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4385.jpeg",
    },
    {
      src: "assets/img/Pastevents/4386.jpeg",
      caption:
        "ജൂലൈ-01 ദേശീയ ഡോക്ടേഴ്‌സ് ദിനത്തോട് അനുബന്ധിച്ച് ഊരുട്ടുകാല ജീ ആർ പബ്ലിക്ക് സ്ക്കൂൾ, ബാലരാമപുരം ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4386.jpeg",
    },
    {
      src: "assets/img/Pastevents/4387.jpeg",
      caption:
        "ജൂലൈ-01 ദേശീയ ഡോക്ടേഴ്‌സ് ദിനത്തോട് അനുബന്ധിച്ച് ഊരുട്ടുകാല ജീ ആർ പബ്ലിക്ക് സ്ക്കൂൾ, ബാലരാമപുരം ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4387.jpeg",
    },
    {
      src: "assets/img/Pastevents/4388.jpeg",
      caption:
        "ജൂലൈ-01 ദേശീയ ഡോക്ടേഴ്‌സ് ദിനത്തോട് അനുബന്ധിച്ച് ഊരുട്ടുകാല ജീ ആർ പബ്ലിക്ക് സ്ക്കൂൾ, ബാലരാമപുരം ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4388.jpeg",
    },
    {
      src: "assets/img/Pastevents/4389.jpeg",
      caption:
        "ജൂലൈ-01 ദേശീയ ഡോക്ടേഴ്‌സ് ദിനത്തോട് അനുബന്ധിച്ച് ഊരുട്ടുകാല ജീ ആർ പബ്ലിക്ക് സ്ക്കൂൾ, ബാലരാമപുരം ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4389.jpeg",
    },
    {
      src: "assets/img/Pastevents/4390.jpeg",
      caption:
        "ജൂലൈ-01 ദേശീയ ഡോക്ടേഴ്‌സ് ദിനത്തോട് അനുബന്ധിച്ച് ഊരുട്ടുകാല ജീ ആർ പബ്ലിക്ക് സ്ക്കൂൾ, ബാലരാമപുരം ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4390.jpeg",
    },
    {
      src: "assets/img/Pastevents/4391.jpeg",
      caption:
        "ജൂലൈ-01 ദേശീയ ഡോക്ടേഴ്‌സ് ദിനത്തോട് അനുബന്ധിച്ച് ഊരുട്ടുകാല ജീ ആർ പബ്ലിക്ക് സ്ക്കൂൾ, ബാലരാമപുരം ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4391.jpeg",
    },
    {
      src: "assets/img/Pastevents/4392.jpeg",
      caption:
        "ജൂലൈ-01 ദേശീയ ഡോക്ടേഴ്‌സ് ദിനത്തോട് അനുബന്ധിച്ച് ഊരുട്ടുകാല ജീ ആർ പബ്ലിക്ക് സ്ക്കൂൾ, ബാലരാമപുരം ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4392.jpeg",
    },
    {
      src: "assets/img/Pastevents/4393.jpeg",
      caption:
        "ജൂലൈ-01 ദേശീയ ഡോക്ടേഴ്‌സ് ദിനത്തോട് അനുബന്ധിച്ച് ഊരുട്ടുകാല ജീ ആർ പബ്ലിക്ക് സ്ക്കൂൾ, ബാലരാമപുരം ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4393.jpeg",
    },
    {
      src: "assets/img/Pastevents/4394.jpeg",
      caption:
        "ജൂലൈ-01 ദേശീയ ഡോക്ടേഴ്‌സ് ദിനത്തോട് അനുബന്ധിച്ച് ഊരുട്ടുകാല ജീ ആർ പബ്ലിക്ക് സ്ക്കൂൾ, ബാലരാമപുരം ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4394.jpeg",
    },
    {
      src: "assets/img/Pastevents/4380.jpeg",
      caption:
        "സ്വിഫ്റ്റ് കെ എസ് ആർ ടി സി ആനയറ യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4380.jpeg",
    },
    {
      src: "assets/img/Pastevents/4381.jpeg",
      caption:
        "സ്വിഫ്റ്റ് കെ എസ് ആർ ടി സി ആനയറ യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4381.jpeg",
    },
    {
      src: "assets/img/Pastevents/4382.jpeg",
      caption:
        "സ്വിഫ്റ്റ് കെ എസ് ആർ ടി സി ആനയറ യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4382.jpeg",
    },
    {
      src: "assets/img/Pastevents/4383.jpeg",
      caption:
        "സ്വിഫ്റ്റ് കെ എസ് ആർ ടി സി ആനയറ യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4383.jpeg",
    },
    {
      src: "assets/img/Pastevents/4384.jpeg",
      caption:
        "സ്വിഫ്റ്റ് കെ എസ് ആർ ടി സി ആനയറ യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4384.jpeg",
    },
    {
      src: "assets/img/Pastevents/4375.jpeg",
      caption:
        "റ്റി ബി ജംഗ്ഷൻ സെൻ്റ് ഫിലിപ്പ് സ്ക്കൂളിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4375.jpeg",
    },
    {
      src: "assets/img/Pastevents/4376.jpeg",
      caption:
        "റ്റി ബി ജംഗ്ഷൻ സെൻ്റ് ഫിലിപ്പ് സ്ക്കൂളിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4376.jpeg",
    },
    {
      src: "assets/img/Pastevents/4377.jpeg",
      caption:
        "റ്റി ബി ജംഗ്ഷൻ സെൻ്റ് ഫിലിപ്പ് സ്ക്കൂളിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4377.jpeg",
    },
    {
      src: "assets/img/Pastevents/4378.jpeg",
      caption:
        "റ്റി ബി ജംഗ്ഷൻ സെൻ്റ് ഫിലിപ്പ് സ്ക്കൂളിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4378.jpeg",
    },
    {
      src: "assets/img/Pastevents/4379.jpeg",
      caption:
        "റ്റി ബി ജംഗ്ഷൻ സെൻ്റ് ഫിലിപ്പ് സ്ക്കൂളിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4379.jpeg",
    },
    {
      src: "assets/img/Pastevents/4370.jpeg",
      caption:
        "കോട്ടുകാൽ കവികൾ സാംസ്കാരിക വേദിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4370.jpeg",
    },
    {
      src: "assets/img/Pastevents/4371.jpeg",
      caption:
        "കോട്ടുകാൽ കവികൾ സാംസ്കാരിക വേദിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4371.jpeg",
    },
    {
      src: "assets/img/Pastevents/4372.jpeg",
      caption:
        "കോട്ടുകാൽ കവികൾ സാംസ്കാരിക വേദിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4372.jpeg",
    },
    {
      src: "assets/img/Pastevents/4373.jpeg",
      caption:
        "കോട്ടുകാൽ കവികൾ സാംസ്കാരിക വേദിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4373.jpeg",
    },
    {
      src: "assets/img/Pastevents/4374.jpeg",
      caption:
        "കോട്ടുകാൽ കവികൾ സാംസ്കാരിക വേദിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4374.jpeg",
    },
    {
      src: "assets/img/Pastevents/4364.jpeg",
      caption:
        "കാഞ്ഞിരംകുളം  പഞ്ചായത്ത്,കാഞ്ഞിരംകുളം ബഡ്‌സ് സ്ക്കൂളിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4364.jpeg",
    },
    {
      src: "assets/img/Pastevents/4365.jpeg",
      caption:
        "കാഞ്ഞിരംകുളം  പഞ്ചായത്ത്,കാഞ്ഞിരംകുളം ബഡ്‌സ് സ്ക്കൂളിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4365.jpeg",
    },
    {
      src: "assets/img/Pastevents/4366.jpeg",
      caption:
        "കാഞ്ഞിരംകുളം  പഞ്ചായത്ത്,കാഞ്ഞിരംകുളം ബഡ്‌സ് സ്ക്കൂളിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4366.jpeg",
    },
    {
      src: "assets/img/Pastevents/4367.jpeg",
      caption:
        "കാഞ്ഞിരംകുളം  പഞ്ചായത്ത്,കാഞ്ഞിരംകുളം ബഡ്‌സ് സ്ക്കൂളിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4367.jpeg",
    },
    {
      src: "assets/img/Pastevents/4368.jpeg",
      caption:
        "കാഞ്ഞിരംകുളം  പഞ്ചായത്ത്,കാഞ്ഞിരംകുളം ബഡ്‌സ് സ്ക്കൂളിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4368.jpeg",
    },
    {
      src: "assets/img/Pastevents/4369.jpeg",
      caption:
        "കാഞ്ഞിരംകുളം  പഞ്ചായത്ത്,കാഞ്ഞിരംകുളം ബഡ്‌സ് സ്ക്കൂളിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4369.jpeg",
    },
    {
      src: "assets/img/Pastevents/4359.jpeg",
      caption:
        "തട്ടിനകം ആർട്സ്  സ്പോർട്സ് ആൻ്റ് വെൽഫെയർ ക്ലബ്ബ്, ഗൗരീശപട്ടം ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4359.jpeg",
    },
    {
      src: "assets/img/Pastevents/4360.jpeg",
      caption:
        "തട്ടിനകം ആർട്സ്  സ്പോർട്സ് ആൻ്റ് വെൽഫെയർ ക്ലബ്ബ്, ഗൗരീശപട്ടം ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4360.jpeg",
    },
    {
      src: "assets/img/Pastevents/4361.jpeg",
      caption:
        "തട്ടിനകം ആർട്സ്  സ്പോർട്സ് ആൻ്റ് വെൽഫെയർ ക്ലബ്ബ്, ഗൗരീശപട്ടം ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4361.jpeg",
    },
    {
      src: "assets/img/Pastevents/4362.jpeg",
      caption:
        "തട്ടിനകം ആർട്സ്  സ്പോർട്സ് ആൻ്റ് വെൽഫെയർ ക്ലബ്ബ്, ഗൗരീശപട്ടം ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4362.jpeg",
    },
    {
      src: "assets/img/Pastevents/4363.jpeg",
      caption:
        "തട്ടിനകം ആർട്സ്  സ്പോർട്സ് ആൻ്റ് വെൽഫെയർ ക്ലബ്ബ്, ഗൗരീശപട്ടം ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4363.jpeg",
    },

    {
      src: "assets/img/Pastevents/4353.jpeg",
      caption:
        "തോലടി പൂജാരി സേവാ ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4353.jpeg",
    },
    {
      src: "assets/img/Pastevents/4354.jpeg",
      caption:
        "തോലടി പൂജാരി സേവാ ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4354.jpeg",
    },
    {
      src: "assets/img/Pastevents/4355.jpeg",
      caption:
        "തോലടി പൂജാരി സേവാ ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4355.jpeg",
    },
    {
      src: "assets/img/Pastevents/4356.jpeg",
      caption:
        "തോലടി പൂജാരി സേവാ ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4356.jpeg",
    },
    {
      src: "assets/img/Pastevents/4357.jpeg",
      caption:
        "തോലടി പൂജാരി സേവാ ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4357.jpeg",
    },
    {
      src: "assets/img/Pastevents/4358.jpeg",
      caption:
        "തോലടി പൂജാരി സേവാ ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4358.jpeg",
    },
    {
      src: "assets/img/Pastevents/4345.jpeg",
      caption:
        "തിരുവനന്തപുരം കേരള ഒളിമ്പിക്സ് അസോസിയേഷൻൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത  ആഭിമുഖ്യത്തിൽ  സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4345.jpeg",
    },
    {
      src: "assets/img/Pastevents/4346.jpeg",
      caption:
        "തിരുവനന്തപുരം കേരള ഒളിമ്പിക്സ് അസോസിയേഷൻൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത  ആഭിമുഖ്യത്തിൽ  സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4346.jpeg",
    },
    {
      src: "assets/img/Pastevents/4347.jpeg",
      caption:
        "തിരുവനന്തപുരം കേരള ഒളിമ്പിക്സ് അസോസിയേഷൻൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത  ആഭിമുഖ്യത്തിൽ  സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4347.jpeg",
    },
    {
      src: "assets/img/Pastevents/4348.jpeg",
      caption:
        "തിരുവനന്തപുരം കേരള ഒളിമ്പിക്സ് അസോസിയേഷൻൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത  ആഭിമുഖ്യത്തിൽ  സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4348.jpeg",
    },
    {
      src: "assets/img/Pastevents/4349.jpeg",
      caption:
        "തിരുവനന്തപുരം കേരള ഒളിമ്പിക്സ് അസോസിയേഷൻൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത  ആഭിമുഖ്യത്തിൽ  സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4349.jpeg",
    },
    {
      src: "assets/img/Pastevents/4350.jpeg",
      caption:
        "തിരുവനന്തപുരം കേരള ഒളിമ്പിക്സ് അസോസിയേഷൻൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത  ആഭിമുഖ്യത്തിൽ  സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4350.jpeg",
    },
    {
      src: "assets/img/Pastevents/4351.jpeg",
      caption:
        "തിരുവനന്തപുരം കേരള ഒളിമ്പിക്സ് അസോസിയേഷൻൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത  ആഭിമുഖ്യത്തിൽ  സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4351.jpeg",
    },
    {
      src: "assets/img/Pastevents/4352.jpeg",
      caption:
        "തിരുവനന്തപുരം കേരള ഒളിമ്പിക്സ് അസോസിയേഷൻൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത  ആഭിമുഖ്യത്തിൽ  സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4352.jpeg",
    },
    {
      src: "assets/img/Pastevents/4333.jpeg",
      caption:
        "വേൾഡ് ഓഷ്യൻ ഡേ യുടെ ഭാഗമായി പൊഴിയൂർ വാർഡ് ഗ്രാമസഭ, നിംസ്  കോളേജ്  ഓഫ് നഴ്സിംഗ്  നാച്ചുറൽ ക്ലബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ഉണ് ആഭിമുഖ്യത്തിൽ കടൽത്തീര ശുചീകരണവും സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പും സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4333.jpeg",
    },
    {
      src: "assets/img/Pastevents/4334.jpeg",
      caption:
        "വേൾഡ് ഓഷ്യൻ ഡേ യുടെ ഭാഗമായി പൊഴിയൂർ വാർഡ് ഗ്രാമസഭ, നിംസ്  കോളേജ്  ഓഫ് നഴ്സിംഗ്  നാച്ചുറൽ ക്ലബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ഉണ് ആഭിമുഖ്യത്തിൽ കടൽത്തീര ശുചീകരണവും സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പും സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4334.jpeg",
    },
    {
      src: "assets/img/Pastevents/4335.jpeg",
      caption:
        "വേൾഡ് ഓഷ്യൻ ഡേ യുടെ ഭാഗമായി പൊഴിയൂർ വാർഡ് ഗ്രാമസഭ, നിംസ്  കോളേജ്  ഓഫ് നഴ്സിംഗ്  നാച്ചുറൽ ക്ലബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ഉണ് ആഭിമുഖ്യത്തിൽ കടൽത്തീര ശുചീകരണവും സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പും സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4335.jpeg",
    },
    {
      src: "assets/img/Pastevents/4336.jpeg",
      caption:
        "വേൾഡ് ഓഷ്യൻ ഡേ യുടെ ഭാഗമായി പൊഴിയൂർ വാർഡ് ഗ്രാമസഭ, നിംസ്  കോളേജ്  ഓഫ് നഴ്സിംഗ്  നാച്ചുറൽ ക്ലബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ഉണ് ആഭിമുഖ്യത്തിൽ കടൽത്തീര ശുചീകരണവും സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പും സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4336.jpeg",
    },
    {
      src: "assets/img/Pastevents/4337.jpeg",
      caption:
        "വേൾഡ് ഓഷ്യൻ ഡേ യുടെ ഭാഗമായി പൊഴിയൂർ വാർഡ് ഗ്രാമസഭ, നിംസ്  കോളേജ്  ഓഫ് നഴ്സിംഗ്  നാച്ചുറൽ ക്ലബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ഉണ് ആഭിമുഖ്യത്തിൽ കടൽത്തീര ശുചീകരണവും സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പും സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4337.jpeg",
    },
    {
      src: "assets/img/Pastevents/4338.jpeg",
      caption:
        "വേൾഡ് ഓഷ്യൻ ഡേ യുടെ ഭാഗമായി പൊഴിയൂർ വാർഡ് ഗ്രാമസഭ, നിംസ്  കോളേജ്  ഓഫ് നഴ്സിംഗ്  നാച്ചുറൽ ക്ലബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ഉണ് ആഭിമുഖ്യത്തിൽ കടൽത്തീര ശുചീകരണവും സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പും സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4338.jpeg",
    },
    {
      src: "assets/img/Pastevents/4339.jpeg",
      caption:
        "വേൾഡ് ഓഷ്യൻ ഡേ യുടെ ഭാഗമായി പൊഴിയൂർ വാർഡ് ഗ്രാമസഭ, നിംസ്  കോളേജ്  ഓഫ് നഴ്സിംഗ്  നാച്ചുറൽ ക്ലബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ഉണ് ആഭിമുഖ്യത്തിൽ കടൽത്തീര ശുചീകരണവും സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പും സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4339.jpeg",
    },
    {
      src: "assets/img/Pastevents/4340.jpeg",
      caption:
        "വേൾഡ് ഓഷ്യൻ ഡേ യുടെ ഭാഗമായി പൊഴിയൂർ വാർഡ് ഗ്രാമസഭ, നിംസ്  കോളേജ്  ഓഫ് നഴ്സിംഗ്  നാച്ചുറൽ ക്ലബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ഉണ് ആഭിമുഖ്യത്തിൽ കടൽത്തീര ശുചീകരണവും സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പും സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4340.jpeg",
    },
    {
      src: "assets/img/Pastevents/4341.jpeg",
      caption:
        "വേൾഡ് ഓഷ്യൻ ഡേ യുടെ ഭാഗമായി പൊഴിയൂർ വാർഡ് ഗ്രാമസഭ, നിംസ്  കോളേജ്  ഓഫ് നഴ്സിംഗ്  നാച്ചുറൽ ക്ലബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ഉണ് ആഭിമുഖ്യത്തിൽ കടൽത്തീര ശുചീകരണവും സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പും സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4341.jpeg",
    },
    {
      src: "assets/img/Pastevents/4342.jpeg",
      caption:
        "വേൾഡ് ഓഷ്യൻ ഡേ യുടെ ഭാഗമായി പൊഴിയൂർ വാർഡ് ഗ്രാമസഭ, നിംസ്  കോളേജ്  ഓഫ് നഴ്സിംഗ്  നാച്ചുറൽ ക്ലബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ഉണ് ആഭിമുഖ്യത്തിൽ കടൽത്തീര ശുചീകരണവും സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പും സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4342.jpeg",
    },
    {
      src: "assets/img/Pastevents/4343.jpeg",
      caption:
        "വേൾഡ് ഓഷ്യൻ ഡേ യുടെ ഭാഗമായി പൊഴിയൂർ വാർഡ് ഗ്രാമസഭ, നിംസ്  കോളേജ്  ഓഫ് നഴ്സിംഗ്  നാച്ചുറൽ ക്ലബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ഉണ് ആഭിമുഖ്യത്തിൽ കടൽത്തീര ശുചീകരണവും സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പും സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4343.jpeg",
    },
    {
      src: "assets/img/Pastevents/4344.jpeg",
      caption:
        "വേൾഡ് ഓഷ്യൻ ഡേ യുടെ ഭാഗമായി പൊഴിയൂർ വാർഡ് ഗ്രാമസഭ, നിംസ്  കോളേജ്  ഓഫ് നഴ്സിംഗ്  നാച്ചുറൽ ക്ലബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ഉണ് ആഭിമുഖ്യത്തിൽ കടൽത്തീര ശുചീകരണവും സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പും സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4344.jpeg",
    },
    {
      src: "assets/img/Pastevents/4328.jpeg",
      caption:
        "പ്ലാവിള ജയ് നഗർ റെസിഡൻഷ്യൽ അസോസിയേഷൻൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4328.jpeg",
    },
    {
      src: "assets/img/Pastevents/4329.jpeg",
      caption:
        "പ്ലാവിള ജയ് നഗർ റെസിഡൻഷ്യൽ അസോസിയേഷൻൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4329.jpeg",
    },
    {
      src: "assets/img/Pastevents/4330.jpeg",
      caption:
        "പ്ലാവിള ജയ് നഗർ റെസിഡൻഷ്യൽ അസോസിയേഷൻൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4330.jpeg",
    },
    {
      src: "assets/img/Pastevents/4331.jpeg",
      caption:
        "പ്ലാവിള ജയ് നഗർ റെസിഡൻഷ്യൽ അസോസിയേഷൻൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4331.jpeg",
    },
    {
      src: "assets/img/Pastevents/4332.jpeg",
      caption:
        "പ്ലാവിള ജയ് നഗർ റെസിഡൻഷ്യൽ അസോസിയേഷൻൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4332.jpeg",
    },
    {
      src: "assets/img/Pastevents/4323.jpeg",
      caption:
        "പെരുമ്പഴുതൂർ സ്വാശ്രയ കർഷക സംഘം,ട്രിവാൻഡ്രം നോവാ ലയൺസ് ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4323.jpeg",
    },
    {
      src: "assets/img/Pastevents/4324.jpeg",
      caption:
        "പെരുമ്പഴുതൂർ സ്വാശ്രയ കർഷക സംഘം,ട്രിവാൻഡ്രം നോവാ ലയൺസ് ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4324.jpeg",
    },
    {
      src: "assets/img/Pastevents/4325.jpeg",
      caption:
        "പെരുമ്പഴുതൂർ സ്വാശ്രയ കർഷക സംഘം,ട്രിവാൻഡ്രം നോവാ ലയൺസ് ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4325.jpeg",
    },
    {
      src: "assets/img/Pastevents/4326.jpeg",
      caption:
        "പെരുമ്പഴുതൂർ സ്വാശ്രയ കർഷക സംഘം,ട്രിവാൻഡ്രം നോവാ ലയൺസ് ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4326.jpeg",
    },
    {
      src: "assets/img/Pastevents/4327.jpeg",
      caption:
        "പെരുമ്പഴുതൂർ സ്വാശ്രയ കർഷക സംഘം,ട്രിവാൻഡ്രം നോവാ ലയൺസ് ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4327.jpeg",
    },
    {
      src: "assets/img/Pastevents/4318.jpeg",
      caption:
        "മുളകിൻമൂട് പൂക്കടയ് എൻ ഐ പോളിടെക്നിക്ക് കോളേജിൻ്റെയും  നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4318.jpeg",
    },
    {
      src: "assets/img/Pastevents/4319.jpeg",
      caption:
        "മുളകിൻമൂട് പൂക്കടയ് എൻ ഐ പോളിടെക്നിക്ക് കോളേജിൻ്റെയും  നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4319.jpeg",
    },{
      src: "assets/img/Pastevents/4320.jpeg",
      caption:
        "മുളകിൻമൂട് പൂക്കടയ് എൻ ഐ പോളിടെക്നിക്ക് കോളേജിൻ്റെയും  നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4320.jpeg",
    },
    {
      src: "assets/img/Pastevents/4321.jpeg",
      caption:
        "മുളകിൻമൂട് പൂക്കടയ് എൻ ഐ പോളിടെക്നിക്ക് കോളേജിൻ്റെയും  നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4321.jpeg",
    },
    {
      src: "assets/img/Pastevents/4322.jpeg",
      caption:
        "മുളകിൻമൂട് പൂക്കടയ് എൻ ഐ പോളിടെക്നിക്ക് കോളേജിൻ്റെയും  നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4322.jpeg",
    },
    {
      src: "assets/img/Pastevents/4313.jpeg",
      caption:
        "മാറനല്ലൂർ സ്വാശ്രയ കർഷക സംഘം, ട്രിവാൻഡ്രം നോവാ ലയൺസ് ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4313.jpeg",
    },
    {
      src: "assets/img/Pastevents/4314.jpeg",
      caption:
        "മാറനല്ലൂർ സ്വാശ്രയ കർഷക സംഘം, ട്രിവാൻഡ്രം നോവാ ലയൺസ് ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4314.jpeg",
    },
    {
      src: "assets/img/Pastevents/4315.jpeg",
      caption:
        "മാറനല്ലൂർ സ്വാശ്രയ കർഷക സംഘം, ട്രിവാൻഡ്രം നോവാ ലയൺസ് ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4315.jpeg",
    },
    {
      src: "assets/img/Pastevents/4316.jpeg",
      caption:
        "മാറനല്ലൂർ സ്വാശ്രയ കർഷക സംഘം, ട്രിവാൻഡ്രം നോവാ ലയൺസ് ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4316.jpeg",
    },
    {
      src: "assets/img/Pastevents/4317.jpeg",
      caption:
        "മാറനല്ലൂർ സ്വാശ്രയ കർഷക സംഘം, ട്രിവാൻഡ്രം നോവാ ലയൺസ് ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4317.jpeg",
    },
    {
      src: "assets/img/Pastevents/4305.jpeg",
      caption:
        "പറണ്ടോട് കേരളാ നാടാർ മഹാജനസംഘത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4305.jpeg",
    },
    {
      src: "assets/img/Pastevents/4306.jpeg",
      caption:
        "പറണ്ടോട് കേരളാ നാടാർ മഹാജനസംഘത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4306.jpeg",
    },
    {
      src: "assets/img/Pastevents/4307.jpeg",
      caption:
        "പറണ്ടോട് കേരളാ നാടാർ മഹാജനസംഘത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4307.jpeg",
    },
    {
      src: "assets/img/Pastevents/4308.jpeg",
      caption:
        "പറണ്ടോട് കേരളാ നാടാർ മഹാജനസംഘത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4308.jpeg",
    },
    {
      src: "assets/img/Pastevents/4309.jpeg",
      caption:
        "പറണ്ടോട് കേരളാ നാടാർ മഹാജനസംഘത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4309.jpeg",
    },
    {
      src: "assets/img/Pastevents/4310.jpeg",
      caption:
        "പറണ്ടോട് കേരളാ നാടാർ മഹാജനസംഘത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4310.jpeg",
    },
    {
      src: "assets/img/Pastevents/4311.jpeg",
      caption:
        "പറണ്ടോട് കേരളാ നാടാർ മഹാജനസംഘത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4311.jpeg",
    },
    {
      src: "assets/img/Pastevents/4312.jpeg",
      caption:
        "പറണ്ടോട് കേരളാ നാടാർ മഹാജനസംഘത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4312.jpeg",
    },
    {
      src: "assets/img/Pastevents/4298.jpeg",
      caption:
        "സ്വിഫ്റ്റ് കെ എസ് ആർ ടി സി ആനയറ യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4298.jpeg",
    },
    {
      src: "assets/img/Pastevents/4299.jpeg",
      caption:
        "സ്വിഫ്റ്റ് കെ എസ് ആർ ടി സി ആനയറ യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4299.jpeg",
    },
    {
      src: "assets/img/Pastevents/4300.jpeg",
      caption:
        "സ്വിഫ്റ്റ് കെ എസ് ആർ ടി സി ആനയറ യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4300.jpeg",
    },
    {
      src: "assets/img/Pastevents/4301.jpeg",
      caption:
        "സ്വിഫ്റ്റ് കെ എസ് ആർ ടി സി ആനയറ യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4301.jpeg",
    },
    {
      src: "assets/img/Pastevents/4302.jpeg",
      caption:
        "സ്വിഫ്റ്റ് കെ എസ് ആർ ടി സി ആനയറ യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4302.jpeg",
    },
    {
      src: "assets/img/Pastevents/4303.jpeg",
      caption:
        "സ്വിഫ്റ്റ് കെ എസ് ആർ ടി സി ആനയറ യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4303.jpeg",
    },
    {
      src: "assets/img/Pastevents/4304.jpeg",
      caption:
        "സ്വിഫ്റ്റ് കെ എസ് ആർ ടി സി ആനയറ യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4304.jpeg",
    },
    {
      src: "assets/img/Pastevents/4292.jpeg",
      caption:
        "കല്ലറ സ്വാശ്രയ കർഷക സംഘം, കല്ലറ  ലയൺസ് ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4292.jpeg",
    },
    {
      src: "assets/img/Pastevents/4293.jpeg",
      caption:
        "കല്ലറ സ്വാശ്രയ കർഷക സംഘം, കല്ലറ  ലയൺസ് ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4293.jpeg",
    },
    {
      src: "assets/img/Pastevents/4294.jpeg",
      caption:
        "കല്ലറ സ്വാശ്രയ കർഷക സംഘം, കല്ലറ  ലയൺസ് ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4294.jpeg",
    },
    {
      src: "assets/img/Pastevents/4295.jpeg",
      caption:
        "കല്ലറ സ്വാശ്രയ കർഷക സംഘം, കല്ലറ  ലയൺസ് ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4295.jpeg",
    },
    {
      src: "assets/img/Pastevents/4296.jpeg",
      caption:
        "കല്ലറ സ്വാശ്രയ കർഷക സംഘം, കല്ലറ  ലയൺസ് ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4296.jpeg",
    },
    {
      src: "assets/img/Pastevents/4297.jpeg",
      caption:
        "കല്ലറ സ്വാശ്രയ കർഷക സംഘം, കല്ലറ  ലയൺസ് ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4297.jpeg",
    },
     {
      src: "assets/img/Pastevents/4287.jpeg",
      caption:
        "കുന്നത്തുക്കാൽ സ്വാശ്രയ കർഷക സമിതിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4287.jpeg",
    },
    {
      src: "assets/img/Pastevents/4288.jpeg",
      caption:
        "കുന്നത്തുക്കാൽ സ്വാശ്രയ കർഷക സമിതിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4288.jpeg",
    },
    {
      src: "assets/img/Pastevents/4289.jpeg",
      caption:
        "കുന്നത്തുക്കാൽ സ്വാശ്രയ കർഷക സമിതിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4289.jpeg",
    },
    {
      src: "assets/img/Pastevents/4290.jpeg",
      caption:
        "കുന്നത്തുക്കാൽ സ്വാശ്രയ കർഷക സമിതിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4290.jpeg",
    },
    {
      src: "assets/img/Pastevents/4291.jpeg",
      caption:
        "കുന്നത്തുക്കാൽ സ്വാശ്രയ കർഷക സമിതിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4291.jpeg",
    },
    {
      src: "assets/img/Pastevents/4278.jpeg",
      caption:
        "ലോക പരിസ്ഥിതി ദിനത്തോട് അനുബന്ധിച്ച് തിരുമല വ്യാപാരി വ്യവസായി ഏകോപന സമിതി, തിരുമല ലയൺസ് ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പും വൃക്ഷ തൈ വിതരണവും സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4278.jpeg",
    },
    {
      src: "assets/img/Pastevents/4279.jpeg",
      caption:
        "ലോക പരിസ്ഥിതി ദിനത്തോട് അനുബന്ധിച്ച് തിരുമല വ്യാപാരി വ്യവസായി ഏകോപന സമിതി, തിരുമല ലയൺസ് ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പും വൃക്ഷ തൈ വിതരണവും സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4279.jpeg",
    },
    {
      src: "assets/img/Pastevents/4280.jpeg",
      caption:
        "ലോക പരിസ്ഥിതി ദിനത്തോട് അനുബന്ധിച്ച് തിരുമല വ്യാപാരി വ്യവസായി ഏകോപന സമിതി, തിരുമല ലയൺസ് ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പും വൃക്ഷ തൈ വിതരണവും സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4280.jpeg",
    },
    {
      src: "assets/img/Pastevents/4281.jpeg",
      caption:
        "ലോക പരിസ്ഥിതി ദിനത്തോട് അനുബന്ധിച്ച് തിരുമല വ്യാപാരി വ്യവസായി ഏകോപന സമിതി, തിരുമല ലയൺസ് ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പും വൃക്ഷ തൈ വിതരണവും സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4281.jpeg",
    },
    {
      src: "assets/img/Pastevents/4282.jpeg",
      caption:
        "ലോക പരിസ്ഥിതി ദിനത്തോട് അനുബന്ധിച്ച് തിരുമല വ്യാപാരി വ്യവസായി ഏകോപന സമിതി, തിരുമല ലയൺസ് ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പും വൃക്ഷ തൈ വിതരണവും സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4282.jpeg",
    },
    {
      src: "assets/img/Pastevents/4283.jpeg",
      caption:
        "ലോക പരിസ്ഥിതി ദിനത്തോട് അനുബന്ധിച്ച് തിരുമല വ്യാപാരി വ്യവസായി ഏകോപന സമിതി, തിരുമല ലയൺസ് ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പും വൃക്ഷ തൈ വിതരണവും സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4283.jpeg",
    },
    {
      src: "assets/img/Pastevents/4284.jpeg",
      caption:
        "ലോക പരിസ്ഥിതി ദിനത്തോട് അനുബന്ധിച്ച് തിരുമല വ്യാപാരി വ്യവസായി ഏകോപന സമിതി, തിരുമല ലയൺസ് ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പും വൃക്ഷ തൈ വിതരണവും സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4284.jpeg",
    },
    {
      src: "assets/img/Pastevents/4285.jpeg",
      caption:
        "ലോക പരിസ്ഥിതി ദിനത്തോട് അനുബന്ധിച്ച് തിരുമല വ്യാപാരി വ്യവസായി ഏകോപന സമിതി, തിരുമല ലയൺസ് ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പും വൃക്ഷ തൈ വിതരണവും സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4285.jpeg",
    },
    {
      src: "assets/img/Pastevents/4286.jpeg",
      caption:
        "ലോക പരിസ്ഥിതി ദിനത്തോട് അനുബന്ധിച്ച് തിരുമല വ്യാപാരി വ്യവസായി ഏകോപന സമിതി, തിരുമല ലയൺസ് ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പും വൃക്ഷ തൈ വിതരണവും സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4286.jpeg",
    },
    {
      src: "assets/img/Pastevents/4272.jpeg",
      caption:
        "മേൽപുറം പൂജാരി സേവാ ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4272.jpeg",
    },
    {
      src: "assets/img/Pastevents/4273.jpeg",
      caption:
        "മേൽപുറം പൂജാരി സേവാ ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4273.jpeg",
    },
    {
      src: "assets/img/Pastevents/4274.jpeg",
      caption:
        "മേൽപുറം പൂജാരി സേവാ ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4274.jpeg",
    },
    {
      src: "assets/img/Pastevents/4275.jpeg",
      caption:
        "മേൽപുറം പൂജാരി സേവാ ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4275.jpeg",
    },
    {
      src: "assets/img/Pastevents/4276.jpeg",
      caption:
        "മേൽപുറം പൂജാരി സേവാ ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4276.jpeg",
    },
    {
      src: "assets/img/Pastevents/4277.jpeg",
      caption:
        "മേൽപുറം പൂജാരി സേവാ ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4277.jpeg",
    },
    {
      src: "assets/img/Pastevents/4267.jpeg",
      caption:
        "സ്വിഫ്റ്റ് കെ എസ് ആർ ടി സി ആനയറ യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4267.jpeg",
    },
    {
      src: "assets/img/Pastevents/4268.jpeg",
      caption:
        "സ്വിഫ്റ്റ് കെ എസ് ആർ ടി സി ആനയറ യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4268.jpeg",
    },
    {
      src: "assets/img/Pastevents/4269.jpeg",
      caption:
        "സ്വിഫ്റ്റ് കെ എസ് ആർ ടി സി ആനയറ യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4269.jpeg",
    },
    {
      src: "assets/img/Pastevents/4270.jpeg",
      caption:
        "സ്വിഫ്റ്റ് കെ എസ് ആർ ടി സി ആനയറ യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4270.jpeg",
    },
    {
      src: "assets/img/Pastevents/4271.jpeg",
      caption:
        "സ്വിഫ്റ്റ് കെ എസ് ആർ ടി സി ആനയറ യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4271.jpeg",
    },
    {
      src: "assets/img/Pastevents/4262.jpeg",
      caption:
        "വെഞ്ഞാറമ്മൂട് വയ്യേറ്റ് റെസിഡൻഷ്യൽ അസോസിയേഷൻൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4262.jpeg",
    },
    {
      src: "assets/img/Pastevents/4263.jpeg",
      caption:
        "വെഞ്ഞാറമ്മൂട് വയ്യേറ്റ് റെസിഡൻഷ്യൽ അസോസിയേഷൻൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4263.jpeg",
    },
    {
      src: "assets/img/Pastevents/4264.jpeg",
      caption:
        "വെഞ്ഞാറമ്മൂട് വയ്യേറ്റ് റെസിഡൻഷ്യൽ അസോസിയേഷൻൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4264.jpeg",
    },
    {
      src: "assets/img/Pastevents/4265.jpeg",
      caption:
        "വെഞ്ഞാറമ്മൂട് വയ്യേറ്റ് റെസിഡൻഷ്യൽ അസോസിയേഷൻൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4265.jpeg",
    },
    {
      src: "assets/img/Pastevents/4266.jpeg",
      caption:
        "വെഞ്ഞാറമ്മൂട് വയ്യേറ്റ് റെസിഡൻഷ്യൽ അസോസിയേഷൻൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4266.jpeg",
    },
    {
      src: "assets/img/Pastevents/4256.jpeg",
      caption:
        "കുമാരകോവിൽ നൂറുൽ ഇസ്ലാം യൂണിവേഴ്സിറ്റി ബി എസ് എൽ പി ഡിപ്പാർട്ട്മെന്റിൻ്റെയുംനിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4256.jpeg",
    },
    {
      src: "assets/img/Pastevents/4257.jpeg",
      caption:
        "കുമാരകോവിൽ നൂറുൽ ഇസ്ലാം യൂണിവേഴ്സിറ്റി ബി എസ് എൽ പി ഡിപ്പാർട്ട്മെന്റിൻ്റെയുംനിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4257.jpeg",
    },
    {
      src: "assets/img/Pastevents/4258.jpeg",
      caption:
        "കുമാരകോവിൽ നൂറുൽ ഇസ്ലാം യൂണിവേഴ്സിറ്റി ബി എസ് എൽ പി ഡിപ്പാർട്ട്മെന്റിൻ്റെയുംനിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4258.jpeg",
    },
    {
      src: "assets/img/Pastevents/4259.jpeg",
      caption:
        "കുമാരകോവിൽ നൂറുൽ ഇസ്ലാം യൂണിവേഴ്സിറ്റി ബി എസ് എൽ പി ഡിപ്പാർട്ട്മെന്റിൻ്റെയുംനിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4259.jpeg",
    },
    {
      src: "assets/img/Pastevents/4260.jpeg",
      caption:
        "കുമാരകോവിൽ നൂറുൽ ഇസ്ലാം യൂണിവേഴ്സിറ്റി ബി എസ് എൽ പി ഡിപ്പാർട്ട്മെന്റിൻ്റെയുംനിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4260.jpeg",
    },
    {
      src: "assets/img/Pastevents/4261.jpeg",
      caption:
        "കുമാരകോവിൽ നൂറുൽ ഇസ്ലാം യൂണിവേഴ്സിറ്റി ബി എസ് എൽ പി ഡിപ്പാർട്ട്മെന്റിൻ്റെയുംനിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4261.jpeg",
    },
    {
      src: "assets/img/Pastevents/4250.jpeg",
      caption:
        "തേലിഭാഗം ദേവി വിലാസം എൻ എസ് എസ് കരയോഗം, പൂജപ്പുര ലയൺസ് ക്ലബ്ബിൻ്റെയും  നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4250.jpeg",
    },
    {
      src: "assets/img/Pastevents/4251.jpeg",
      caption:
        "തേലിഭാഗം ദേവി വിലാസം എൻ എസ് എസ് കരയോഗം, പൂജപ്പുര ലയൺസ് ക്ലബ്ബിൻ്റെയും  നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4251.jpeg",
    },
    {
      src: "assets/img/Pastevents/4252.jpeg",
      caption:
        "തേലിഭാഗം ദേവി വിലാസം എൻ എസ് എസ് കരയോഗം, പൂജപ്പുര ലയൺസ് ക്ലബ്ബിൻ്റെയും  നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4252.jpeg",
    },
    {
      src: "assets/img/Pastevents/4253.jpeg",
      caption:
        "തേലിഭാഗം ദേവി വിലാസം എൻ എസ് എസ് കരയോഗം, പൂജപ്പുര ലയൺസ് ക്ലബ്ബിൻ്റെയും  നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4253.jpeg",
    },
    {
      src: "assets/img/Pastevents/4254.jpeg",
      caption:
        "തേലിഭാഗം ദേവി വിലാസം എൻ എസ് എസ് കരയോഗം, പൂജപ്പുര ലയൺസ് ക്ലബ്ബിൻ്റെയും  നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4254.jpeg",
    },
    {
      src: "assets/img/Pastevents/4255.jpeg",
      caption:
        "തേലിഭാഗം ദേവി വിലാസം എൻ എസ് എസ് കരയോഗം, പൂജപ്പുര ലയൺസ് ക്ലബ്ബിൻ്റെയും  നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4255.jpeg",
    },
    {
      src: "assets/img/Pastevents/4242.jpeg",
      caption:
        "കെയർ ആൻഡ് ഷെയർ ചാരിറ്റബിൾ ട്രസ്റ്റ്,വിതുര എം ജി എം പൊൻമുടി വാലി പബ്ലിക്ക് സ്കൂളിൻ്റെയും  നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.മെഡിക്കൽ ക്യാമ്പിൻ്റെ ഉദ്ഘാടനം ബഹു: ശ്രീ ബിജു (സി ഐ വിതുര പോലീസ് സ്റ്റേഷൻ) അധ്യക്ഷൻ ഫാ: തോമസ് കുര്യൻ, ദീപാ എസ് നായർ (എം ജി എം സ്ക്കൂൾ പ്രിൻസിപ്പൽ), അഡ്വ: ബീനാ (എം ജി എം സ്ക്കൂൾ മാനേജർ) എന്നിവർ ആശംസ പ്രസംഗം നടത്തി. ഹൃദ്രോഗ നിർണ്ണയത്തെ കുറിച്ച് Dr കിരൺ ഗോപിനാഥ് (കൺസൾട്ടൻ്റ് കാർഡിയോളജി) ക്യാൻസർ നിർണ്ണയവും അനുബന്ധ ചികിത്സയെ കുറിച്ച് Dr വീണ (കൺസൾട്ടൻ്റ് ഓങ്കോളജി) ക്യാമ്പിൽ അവബോധനം നടത്തി.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി, ഓങ്കോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4242.jpeg",
    },
    {
      src: "assets/img/Pastevents/4243.jpeg",
      caption:
        "കെയർ ആൻഡ് ഷെയർ ചാരിറ്റബിൾ ട്രസ്റ്റ്,വിതുര എം ജി എം പൊൻമുടി വാലി പബ്ലിക്ക് സ്കൂളിൻ്റെയും  നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.മെഡിക്കൽ ക്യാമ്പിൻ്റെ ഉദ്ഘാടനം ബഹു: ശ്രീ ബിജു (സി ഐ വിതുര പോലീസ് സ്റ്റേഷൻ) അധ്യക്ഷൻ ഫാ: തോമസ് കുര്യൻ, ദീപാ എസ് നായർ (എം ജി എം സ്ക്കൂൾ പ്രിൻസിപ്പൽ), അഡ്വ: ബീനാ (എം ജി എം സ്ക്കൂൾ മാനേജർ) എന്നിവർ ആശംസ പ്രസംഗം നടത്തി. ഹൃദ്രോഗ നിർണ്ണയത്തെ കുറിച്ച് Dr കിരൺ ഗോപിനാഥ് (കൺസൾട്ടൻ്റ് കാർഡിയോളജി) ക്യാൻസർ നിർണ്ണയവും അനുബന്ധ ചികിത്സയെ കുറിച്ച് Dr വീണ (കൺസൾട്ടൻ്റ് ഓങ്കോളജി) ക്യാമ്പിൽ അവബോധനം നടത്തി.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി, ഓങ്കോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4243.jpeg",
    },
    {
      src: "assets/img/Pastevents/4244.jpeg",
      caption:
        "കെയർ ആൻഡ് ഷെയർ ചാരിറ്റബിൾ ട്രസ്റ്റ്,വിതുര എം ജി എം പൊൻമുടി വാലി പബ്ലിക്ക് സ്കൂളിൻ്റെയും  നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.മെഡിക്കൽ ക്യാമ്പിൻ്റെ ഉദ്ഘാടനം ബഹു: ശ്രീ ബിജു (സി ഐ വിതുര പോലീസ് സ്റ്റേഷൻ) അധ്യക്ഷൻ ഫാ: തോമസ് കുര്യൻ, ദീപാ എസ് നായർ (എം ജി എം സ്ക്കൂൾ പ്രിൻസിപ്പൽ), അഡ്വ: ബീനാ (എം ജി എം സ്ക്കൂൾ മാനേജർ) എന്നിവർ ആശംസ പ്രസംഗം നടത്തി. ഹൃദ്രോഗ നിർണ്ണയത്തെ കുറിച്ച് Dr കിരൺ ഗോപിനാഥ് (കൺസൾട്ടൻ്റ് കാർഡിയോളജി) ക്യാൻസർ നിർണ്ണയവും അനുബന്ധ ചികിത്സയെ കുറിച്ച് Dr വീണ (കൺസൾട്ടൻ്റ് ഓങ്കോളജി) ക്യാമ്പിൽ അവബോധനം നടത്തി.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി, ഓങ്കോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4244.jpeg",
    },
    {
      src: "assets/img/Pastevents/4245.jpeg",
      caption:
        "കെയർ ആൻഡ് ഷെയർ ചാരിറ്റബിൾ ട്രസ്റ്റ്,വിതുര എം ജി എം പൊൻമുടി വാലി പബ്ലിക്ക് സ്കൂളിൻ്റെയും  നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.മെഡിക്കൽ ക്യാമ്പിൻ്റെ ഉദ്ഘാടനം ബഹു: ശ്രീ ബിജു (സി ഐ വിതുര പോലീസ് സ്റ്റേഷൻ) അധ്യക്ഷൻ ഫാ: തോമസ് കുര്യൻ, ദീപാ എസ് നായർ (എം ജി എം സ്ക്കൂൾ പ്രിൻസിപ്പൽ), അഡ്വ: ബീനാ (എം ജി എം സ്ക്കൂൾ മാനേജർ) എന്നിവർ ആശംസ പ്രസംഗം നടത്തി. ഹൃദ്രോഗ നിർണ്ണയത്തെ കുറിച്ച് Dr കിരൺ ഗോപിനാഥ് (കൺസൾട്ടൻ്റ് കാർഡിയോളജി) ക്യാൻസർ നിർണ്ണയവും അനുബന്ധ ചികിത്സയെ കുറിച്ച് Dr വീണ (കൺസൾട്ടൻ്റ് ഓങ്കോളജി) ക്യാമ്പിൽ അവബോധനം നടത്തി.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി, ഓങ്കോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4245.jpeg",
    },
    {
      src: "assets/img/Pastevents/4246.jpeg",
      caption:
        "കെയർ ആൻഡ് ഷെയർ ചാരിറ്റബിൾ ട്രസ്റ്റ്,വിതുര എം ജി എം പൊൻമുടി വാലി പബ്ലിക്ക് സ്കൂളിൻ്റെയും  നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.മെഡിക്കൽ ക്യാമ്പിൻ്റെ ഉദ്ഘാടനം ബഹു: ശ്രീ ബിജു (സി ഐ വിതുര പോലീസ് സ്റ്റേഷൻ) അധ്യക്ഷൻ ഫാ: തോമസ് കുര്യൻ, ദീപാ എസ് നായർ (എം ജി എം സ്ക്കൂൾ പ്രിൻസിപ്പൽ), അഡ്വ: ബീനാ (എം ജി എം സ്ക്കൂൾ മാനേജർ) എന്നിവർ ആശംസ പ്രസംഗം നടത്തി. ഹൃദ്രോഗ നിർണ്ണയത്തെ കുറിച്ച് Dr കിരൺ ഗോപിനാഥ് (കൺസൾട്ടൻ്റ് കാർഡിയോളജി) ക്യാൻസർ നിർണ്ണയവും അനുബന്ധ ചികിത്സയെ കുറിച്ച് Dr വീണ (കൺസൾട്ടൻ്റ് ഓങ്കോളജി) ക്യാമ്പിൽ അവബോധനം നടത്തി.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി, ഓങ്കോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4246.jpeg",
    },
    {
      src: "assets/img/Pastevents/4247.jpeg",
      caption:
        "കെയർ ആൻഡ് ഷെയർ ചാരിറ്റബിൾ ട്രസ്റ്റ്,വിതുര എം ജി എം പൊൻമുടി വാലി പബ്ലിക്ക് സ്കൂളിൻ്റെയും  നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.മെഡിക്കൽ ക്യാമ്പിൻ്റെ ഉദ്ഘാടനം ബഹു: ശ്രീ ബിജു (സി ഐ വിതുര പോലീസ് സ്റ്റേഷൻ) അധ്യക്ഷൻ ഫാ: തോമസ് കുര്യൻ, ദീപാ എസ് നായർ (എം ജി എം സ്ക്കൂൾ പ്രിൻസിപ്പൽ), അഡ്വ: ബീനാ (എം ജി എം സ്ക്കൂൾ മാനേജർ) എന്നിവർ ആശംസ പ്രസംഗം നടത്തി. ഹൃദ്രോഗ നിർണ്ണയത്തെ കുറിച്ച് Dr കിരൺ ഗോപിനാഥ് (കൺസൾട്ടൻ്റ് കാർഡിയോളജി) ക്യാൻസർ നിർണ്ണയവും അനുബന്ധ ചികിത്സയെ കുറിച്ച് Dr വീണ (കൺസൾട്ടൻ്റ് ഓങ്കോളജി) ക്യാമ്പിൽ അവബോധനം നടത്തി.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി, ഓങ്കോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4247.jpeg",
    },
    {
      src: "assets/img/Pastevents/4248.jpeg",
      caption:
        "കെയർ ആൻഡ് ഷെയർ ചാരിറ്റബിൾ ട്രസ്റ്റ്,വിതുര എം ജി എം പൊൻമുടി വാലി പബ്ലിക്ക് സ്കൂളിൻ്റെയും  നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.മെഡിക്കൽ ക്യാമ്പിൻ്റെ ഉദ്ഘാടനം ബഹു: ശ്രീ ബിജു (സി ഐ വിതുര പോലീസ് സ്റ്റേഷൻ) അധ്യക്ഷൻ ഫാ: തോമസ് കുര്യൻ, ദീപാ എസ് നായർ (എം ജി എം സ്ക്കൂൾ പ്രിൻസിപ്പൽ), അഡ്വ: ബീനാ (എം ജി എം സ്ക്കൂൾ മാനേജർ) എന്നിവർ ആശംസ പ്രസംഗം നടത്തി. ഹൃദ്രോഗ നിർണ്ണയത്തെ കുറിച്ച് Dr കിരൺ ഗോപിനാഥ് (കൺസൾട്ടൻ്റ് കാർഡിയോളജി) ക്യാൻസർ നിർണ്ണയവും അനുബന്ധ ചികിത്സയെ കുറിച്ച് Dr വീണ (കൺസൾട്ടൻ്റ് ഓങ്കോളജി) ക്യാമ്പിൽ അവബോധനം നടത്തി.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി, ഓങ്കോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4248.jpeg",
    },
    {
      src: "assets/img/Pastevents/4249.jpeg",
      caption:
        "കെയർ ആൻഡ് ഷെയർ ചാരിറ്റബിൾ ട്രസ്റ്റ്,വിതുര എം ജി എം പൊൻമുടി വാലി പബ്ലിക്ക് സ്കൂളിൻ്റെയും  നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.മെഡിക്കൽ ക്യാമ്പിൻ്റെ ഉദ്ഘാടനം ബഹു: ശ്രീ ബിജു (സി ഐ വിതുര പോലീസ് സ്റ്റേഷൻ) അധ്യക്ഷൻ ഫാ: തോമസ് കുര്യൻ, ദീപാ എസ് നായർ (എം ജി എം സ്ക്കൂൾ പ്രിൻസിപ്പൽ), അഡ്വ: ബീനാ (എം ജി എം സ്ക്കൂൾ മാനേജർ) എന്നിവർ ആശംസ പ്രസംഗം നടത്തി. ഹൃദ്രോഗ നിർണ്ണയത്തെ കുറിച്ച് Dr കിരൺ ഗോപിനാഥ് (കൺസൾട്ടൻ്റ് കാർഡിയോളജി) ക്യാൻസർ നിർണ്ണയവും അനുബന്ധ ചികിത്സയെ കുറിച്ച് Dr വീണ (കൺസൾട്ടൻ്റ് ഓങ്കോളജി) ക്യാമ്പിൽ അവബോധനം നടത്തി.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി, ഓങ്കോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4249.jpeg",
    },
    {
      src: "assets/img/Pastevents/4237.jpeg",
      caption:
        "കുറ്റിച്ചൽ,തച്ചൻങ്കോട് നവജീവൻ ട്രസ്റ്റിൻ്റെയും ലയൺസ് ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4237.jpeg",
    },
    {
      src: "assets/img/Pastevents/4238.jpeg",
      caption:
        "കുറ്റിച്ചൽ,തച്ചൻങ്കോട് നവജീവൻ ട്രസ്റ്റിൻ്റെയും ലയൺസ് ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4238.jpeg",
    },
    {
      src: "assets/img/Pastevents/4239.jpeg",
      caption:
        "കുറ്റിച്ചൽ,തച്ചൻങ്കോട് നവജീവൻ ട്രസ്റ്റിൻ്റെയും ലയൺസ് ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4239.jpeg",
    },
    {
      src: "assets/img/Pastevents/4240.jpeg",
      caption:
        "കുറ്റിച്ചൽ,തച്ചൻങ്കോട് നവജീവൻ ട്രസ്റ്റിൻ്റെയും ലയൺസ് ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4240.jpeg",
    },
    {
      src: "assets/img/Pastevents/4241.jpeg",
      caption:
        "കുറ്റിച്ചൽ,തച്ചൻങ്കോട് നവജീവൻ ട്രസ്റ്റിൻ്റെയും ലയൺസ് ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4241.jpeg",
    },
    {
      src: "assets/img/Pastevents/4229.jpeg",
      caption:
        " ട്രിവാൻഡ്രം ഫൂട്ട് മാറ്റ് ക്ലസ്റ്റർ, നോർത്ത് ലയൺസ് ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4229.jpeg",
    },
    {
      src: "assets/img/Pastevents/4230.jpeg",
      caption:
        " ട്രിവാൻഡ്രം ഫൂട്ട് മാറ്റ് ക്ലസ്റ്റർ, നോർത്ത് ലയൺസ് ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4230.jpeg",
    },
    {
      src: "assets/img/Pastevents/4231.jpeg",
      caption:
        " ട്രിവാൻഡ്രം ഫൂട്ട് മാറ്റ് ക്ലസ്റ്റർ, നോർത്ത് ലയൺസ് ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4231.jpeg",
    },
    {
      src: "assets/img/Pastevents/4232.jpeg",
      caption:
        " ട്രിവാൻഡ്രം ഫൂട്ട് മാറ്റ് ക്ലസ്റ്റർ, നോർത്ത് ലയൺസ് ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4232.jpeg",
    },
    {
      src: "assets/img/Pastevents/4233.jpeg",
      caption:
        " ട്രിവാൻഡ്രം ഫൂട്ട് മാറ്റ് ക്ലസ്റ്റർ, നോർത്ത് ലയൺസ് ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4233.jpeg",
    },
    {
      src: "assets/img/Pastevents/4234.jpeg",
      caption:
        " ട്രിവാൻഡ്രം ഫൂട്ട് മാറ്റ് ക്ലസ്റ്റർ, നോർത്ത് ലയൺസ് ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4234.jpeg",
    },
    {
      src: "assets/img/Pastevents/4235.jpeg",
      caption:
        " ട്രിവാൻഡ്രം ഫൂട്ട് മാറ്റ് ക്ലസ്റ്റർ, നോർത്ത് ലയൺസ് ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4235.jpeg",
    },
    {
      src: "assets/img/Pastevents/4236.jpeg",
      caption:
        " ട്രിവാൻഡ്രം ഫൂട്ട് മാറ്റ് ക്ലസ്റ്റർ, നോർത്ത് ലയൺസ് ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4236.jpeg",
    },
    {
      src: "assets/img/Pastevents/4224.jpeg",
      caption:
        "തൈക്കാട് കേരളാ ഗാന്ധി സ്മാരക നിധിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4224.jpeg",
    },
    {
      src: "assets/img/Pastevents/4225.jpeg",
      caption:
        "തൈക്കാട് കേരളാ ഗാന്ധി സ്മാരക നിധിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4225.jpeg",
    },
    {
      src: "assets/img/Pastevents/4226.jpeg",
      caption:
        "തൈക്കാട് കേരളാ ഗാന്ധി സ്മാരക നിധിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4226.jpeg",
    },
    {
      src: "assets/img/Pastevents/4227.jpeg",
      caption:
        "തൈക്കാട് കേരളാ ഗാന്ധി സ്മാരക നിധിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4227.jpeg",
    },
    {
      src: "assets/img/Pastevents/4228.jpeg",
      caption:
        "തൈക്കാട് കേരളാ ഗാന്ധി സ്മാരക നിധിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4228.jpeg",
    },
    {
      src: "assets/img/Pastevents/4219.jpeg",
      caption:
        "തിരുവട്ടാർ പൂജാരി സേവാ ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4219.jpeg",
    },
    {
      src: "assets/img/Pastevents/4220.jpeg",
      caption:
        "തിരുവട്ടാർ പൂജാരി സേവാ ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4220.jpeg",
    },
    {
      src: "assets/img/Pastevents/4221.jpeg",
      caption:
        "തിരുവട്ടാർ പൂജാരി സേവാ ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4221.jpeg",
    },
    {
      src: "assets/img/Pastevents/4222.jpeg",
      caption:
        "തിരുവട്ടാർ പൂജാരി സേവാ ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4222.jpeg",
    },
    {
      src: "assets/img/Pastevents/4223.jpeg",
      caption:
        "തിരുവട്ടാർ പൂജാരി സേവാ ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4223.jpeg",
    },
    {
      src: "assets/img/Pastevents/4213.jpeg",
      caption:
        "ചൊവ്വര തെക്കേക്കോണം നാഗർകാവ് ശ്രീ ദുർഗ്ഗാ ഭഗതി ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4213.jpeg",
    },
    {
      src: "assets/img/Pastevents/4214.jpeg",
      caption:
        "ചൊവ്വര തെക്കേക്കോണം നാഗർകാവ് ശ്രീ ദുർഗ്ഗാ ഭഗതി ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4214.jpeg",
    },
    {
      src: "assets/img/Pastevents/4215.jpeg",
      caption:
        "ചൊവ്വര തെക്കേക്കോണം നാഗർകാവ് ശ്രീ ദുർഗ്ഗാ ഭഗതി ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4215.jpeg",
    },
    {
      src: "assets/img/Pastevents/4216.jpeg",
      caption:
        "ചൊവ്വര തെക്കേക്കോണം നാഗർകാവ് ശ്രീ ദുർഗ്ഗാ ഭഗതി ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4216.jpeg",
    },
    {
      src: "assets/img/Pastevents/4217.jpeg",
      caption:
        "ചൊവ്വര തെക്കേക്കോണം നാഗർകാവ് ശ്രീ ദുർഗ്ഗാ ഭഗതി ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4217.jpeg",
    },
    {
      src: "assets/img/Pastevents/4218.jpeg",
      caption:
        "ചൊവ്വര തെക്കേക്കോണം നാഗർകാവ് ശ്രീ ദുർഗ്ഗാ ഭഗതി ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4218.jpeg",
    },
    {
      src: "assets/img/Pastevents/4208.jpeg",
      caption:
        "സീയോൺകുന്ന് സി എസ് ഐ ദക്ഷിണ കേരള ഇടവക സി ഇ വൈ എഫ് യൂണിറ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4208.jpeg",
    },
    {
      src: "assets/img/Pastevents/4209.jpeg",
      caption:
        "സീയോൺകുന്ന് സി എസ് ഐ ദക്ഷിണ കേരള ഇടവക സി ഇ വൈ എഫ് യൂണിറ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4209.jpeg",
    },
    {
      src: "assets/img/Pastevents/4210.jpeg",
      caption:
        "സീയോൺകുന്ന് സി എസ് ഐ ദക്ഷിണ കേരള ഇടവക സി ഇ വൈ എഫ് യൂണിറ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4210.jpeg",
    },
    {
      src: "assets/img/Pastevents/4211.jpeg",
      caption:
        "സീയോൺകുന്ന് സി എസ് ഐ ദക്ഷിണ കേരള ഇടവക സി ഇ വൈ എഫ് യൂണിറ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4211.jpeg",
    },
    {
      src: "assets/img/Pastevents/4212.jpeg",
      caption:
        "സീയോൺകുന്ന് സി എസ് ഐ ദക്ഷിണ കേരള ഇടവക സി ഇ വൈ എഫ് യൂണിറ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4212.jpeg",
    },
    {
      src: "assets/img/Pastevents/4202.jpeg",
      caption:
        "കോട്ടുക്കാൽക്കോണം ശ്രീ മുത്താരമ്മൻ ദേവി ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും  നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4202.jpeg",
    },
    {
      src: "assets/img/Pastevents/4203.jpeg",
      caption:
        "കോട്ടുക്കാൽക്കോണം ശ്രീ മുത്താരമ്മൻ ദേവി ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും  നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4203.jpeg",
    },
    {
      src: "assets/img/Pastevents/4204.jpeg",
      caption:
        "കോട്ടുക്കാൽക്കോണം ശ്രീ മുത്താരമ്മൻ ദേവി ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും  നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4204.jpeg",
    },
    {
      src: "assets/img/Pastevents/4205.jpeg",
      caption:
        "കോട്ടുക്കാൽക്കോണം ശ്രീ മുത്താരമ്മൻ ദേവി ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും  നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4205.jpeg",
    },
    {
      src: "assets/img/Pastevents/4206.jpeg",
      caption:
        "കോട്ടുക്കാൽക്കോണം ശ്രീ മുത്താരമ്മൻ ദേവി ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും  നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4206.jpeg",
    },
    {
      src: "assets/img/Pastevents/4207.jpeg",
      caption:
        "കോട്ടുക്കാൽക്കോണം ശ്രീ മുത്താരമ്മൻ ദേവി ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും  നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4207.jpeg",
    },
    {
      src: "assets/img/Pastevents/4195.jpeg",
      caption:
        "തിരുവട്ടാർ  എക്സൽ സ്ക്കൂൾ എൻ എസ് എസ് യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4195.jpeg",
    },
    {
      src: "assets/img/Pastevents/4196.jpeg",
      caption:
        "തിരുവട്ടാർ  എക്സൽ സ്ക്കൂൾ എൻ എസ് എസ് യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4196.jpeg",
    },
    {
      src: "assets/img/Pastevents/4197.jpeg",
      caption:
        "തിരുവട്ടാർ  എക്സൽ സ്ക്കൂൾ എൻ എസ് എസ് യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4197.jpeg",
    },
    {
      src: "assets/img/Pastevents/4198.jpeg",
      caption:
        "തിരുവട്ടാർ  എക്സൽ സ്ക്കൂൾ എൻ എസ് എസ് യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4198.jpeg",
    },
    {
      src: "assets/img/Pastevents/4199.jpeg",
      caption:
        "തിരുവട്ടാർ  എക്സൽ സ്ക്കൂൾ എൻ എസ് എസ് യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4199.jpeg",
    },
    {
      src: "assets/img/Pastevents/4200.jpeg",
      caption:
        "തിരുവട്ടാർ  എക്സൽ സ്ക്കൂൾ എൻ എസ് എസ് യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4200.jpeg",
    },
    {
      src: "assets/img/Pastevents/4201.jpeg",
      caption:
        "തിരുവട്ടാർ  എക്സൽ സ്ക്കൂൾ എൻ എസ് എസ് യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4201.jpeg",
    },
    {
      src: "assets/img/Pastevents/4189.jpeg",
      caption:
        "ഭരതന്നൂർ സെവൻത് ഡേ അഡ്വൻ്റിസ്റ്റ് ചർച്ചിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4189.jpeg",
    },
    {
      src: "assets/img/Pastevents/4190.jpeg",
      caption:
        "ഭരതന്നൂർ സെവൻത് ഡേ അഡ്വൻ്റിസ്റ്റ് ചർച്ചിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4190.jpeg",
    },
    {
      src: "assets/img/Pastevents/4191.jpeg",
      caption:
        "ഭരതന്നൂർ സെവൻത് ഡേ അഡ്വൻ്റിസ്റ്റ് ചർച്ചിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4191.jpeg",
    },
    {
      src: "assets/img/Pastevents/4192.jpeg",
      caption:
        "ഭരതന്നൂർ സെവൻത് ഡേ അഡ്വൻ്റിസ്റ്റ് ചർച്ചിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4192.jpeg",
    },
    {
      src: "assets/img/Pastevents/4193.jpeg",
      caption:
        "ഭരതന്നൂർ സെവൻത് ഡേ അഡ്വൻ്റിസ്റ്റ് ചർച്ചിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4193.jpeg",
    },
    {
      src: "assets/img/Pastevents/4194.jpeg",
      caption:
        "ഭരതന്നൂർ സെവൻത് ഡേ അഡ്വൻ്റിസ്റ്റ് ചർച്ചിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4194.jpeg",
    },
    {
      src: "assets/img/Pastevents/4179.jpeg",
      caption:
        " തക്കല നൂറുൽ ഇസ്‌ലാം യൂണിവേഴ്‌സിറ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഗൈനക്കോളജി, ജനറൽ സർജറി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4179.jpeg",
    },
    {
      src: "assets/img/Pastevents/4180.jpeg",
      caption:
        " തക്കല നൂറുൽ ഇസ്‌ലാം യൂണിവേഴ്‌സിറ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഗൈനക്കോളജി, ജനറൽ സർജറി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4180.jpeg",
    },
    {
      src: "assets/img/Pastevents/4181.jpeg",
      caption:
        " തക്കല നൂറുൽ ഇസ്‌ലാം യൂണിവേഴ്‌സിറ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഗൈനക്കോളജി, ജനറൽ സർജറി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4181.jpeg",
    },
    {
      src: "assets/img/Pastevents/4182.jpeg",
      caption:
        " തക്കല നൂറുൽ ഇസ്‌ലാം യൂണിവേഴ്‌സിറ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഗൈനക്കോളജി, ജനറൽ സർജറി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4182.jpeg",
    },
    {
      src: "assets/img/Pastevents/4183.jpeg",
      caption:
        " തക്കല നൂറുൽ ഇസ്‌ലാം യൂണിവേഴ്‌സിറ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഗൈനക്കോളജി, ജനറൽ സർജറി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4183.jpeg",
    },
    {
      src: "assets/img/Pastevents/4184.jpeg",
      caption:
        " തക്കല നൂറുൽ ഇസ്‌ലാം യൂണിവേഴ്‌സിറ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഗൈനക്കോളജി, ജനറൽ സർജറി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4184.jpeg",
    },
    {
      src: "assets/img/Pastevents/4185.jpeg",
      caption:
        " തക്കല നൂറുൽ ഇസ്‌ലാം യൂണിവേഴ്‌സിറ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഗൈനക്കോളജി, ജനറൽ സർജറി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4185.jpeg",
    },
    {
      src: "assets/img/Pastevents/4186.jpeg",
      caption:
        " തക്കല നൂറുൽ ഇസ്‌ലാം യൂണിവേഴ്‌സിറ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഗൈനക്കോളജി, ജനറൽ സർജറി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4186.jpeg",
    },
    {
      src: "assets/img/Pastevents/4187.jpeg",
      caption:
        " തക്കല നൂറുൽ ഇസ്‌ലാം യൂണിവേഴ്‌സിറ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഗൈനക്കോളജി, ജനറൽ സർജറി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4187.jpeg",
    },
    {
      src: "assets/img/Pastevents/4188.jpeg",
      caption:
        " തക്കല നൂറുൽ ഇസ്‌ലാം യൂണിവേഴ്‌സിറ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഗൈനക്കോളജി, ജനറൽ സർജറി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4188.jpeg",
    },
    {
      src: "assets/img/Pastevents/4174.jpeg",
      caption:
        "തോലടി പൂജാരി സേവാ ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4174.jpeg",
    },
    {
      src: "assets/img/Pastevents/4175.jpeg",
      caption:
        "തോലടി പൂജാരി സേവാ ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4175.jpeg",
    },
    {
      src: "assets/img/Pastevents/4176.jpeg",
      caption:
        "തോലടി പൂജാരി സേവാ ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4176.jpeg",
    },
    {
      src: "assets/img/Pastevents/4177.jpeg",
      caption:
        "തോലടി പൂജാരി സേവാ ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4177.jpeg",
    },
    {
      src: "assets/img/Pastevents/4178.jpeg",
      caption:
        "തോലടി പൂജാരി സേവാ ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4178.jpeg",
    },
    {
      src: "assets/img/Pastevents/4168.jpeg",
      caption:
        "നെടുംബായിക്കുളം കോട്ടക്കുഴി സെൻറ് ജോർജ്ജ് തീർത്ഥാടന പള്ളി കുണ്ടറ റോയൽ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4168.jpeg",
    },
    {
      src: "assets/img/Pastevents/4169.jpeg",
      caption:
        "നെടുംബായിക്കുളം കോട്ടക്കുഴി സെൻറ് ജോർജ്ജ് തീർത്ഥാടന പള്ളി കുണ്ടറ റോയൽ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4169.jpeg",
    },
    {
      src: "assets/img/Pastevents/4170.jpeg",
      caption:
        "നെടുംബായിക്കുളം കോട്ടക്കുഴി സെൻറ് ജോർജ്ജ് തീർത്ഥാടന പള്ളി കുണ്ടറ റോയൽ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4170.jpeg",
    },
    {
      src: "assets/img/Pastevents/4171.jpeg",
      caption:
        "നെടുംബായിക്കുളം കോട്ടക്കുഴി സെൻറ് ജോർജ്ജ് തീർത്ഥാടന പള്ളി കുണ്ടറ റോയൽ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4171.jpeg",
    },
    {
      src: "assets/img/Pastevents/4172.jpeg",
      caption:
        "നെടുംബായിക്കുളം കോട്ടക്കുഴി സെൻറ് ജോർജ്ജ് തീർത്ഥാടന പള്ളി കുണ്ടറ റോയൽ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4172.jpeg",
    },
    {
      src: "assets/img/Pastevents/4173.jpeg",
      caption:
        "നെടുംബായിക്കുളം കോട്ടക്കുഴി സെൻറ് ജോർജ്ജ് തീർത്ഥാടന പള്ളി കുണ്ടറ റോയൽ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4173.jpeg",
    },
    {
      src: "assets/img/Pastevents/4163.jpeg",
      caption:
        "മാമ്പഴക്കര എസ്.എൻ ഡി പി യൂണിറ്റിൻ്റെയുംനിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4163.jpeg",
    },
    {
      src: "assets/img/Pastevents/4164.jpeg",
      caption:
        "മാമ്പഴക്കര എസ്.എൻ ഡി പി യൂണിറ്റിൻ്റെയുംനിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4164.jpeg",
    },
    {
      src: "assets/img/Pastevents/4165.jpeg",
      caption:
        "മാമ്പഴക്കര എസ്.എൻ ഡി പി യൂണിറ്റിൻ്റെയുംനിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4165.jpeg",
    },
    {
      src: "assets/img/Pastevents/4166.jpeg",
      caption:
        "മാമ്പഴക്കര എസ്.എൻ ഡി പി യൂണിറ്റിൻ്റെയുംനിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4166.jpeg",
    },
    {
      src: "assets/img/Pastevents/4167.jpeg",
      caption:
        "മാമ്പഴക്കര എസ്.എൻ ഡി പി യൂണിറ്റിൻ്റെയുംനിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4167.jpeg",
    },
    {
      src: "assets/img/Pastevents/4157.jpeg",
      caption:
        "മേൽപ്പുറം പന്നിക്കോണം ശ്രീ ധർമ്മ ശാസ്താ ക്ഷേത്ര കമ്മിറ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4157.jpeg",
    },
    {
      src: "assets/img/Pastevents/4158.jpeg",
      caption:
        "മേൽപ്പുറം പന്നിക്കോണം ശ്രീ ധർമ്മ ശാസ്താ ക്ഷേത്ര കമ്മിറ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4158.jpeg",
    },
    {
      src: "assets/img/Pastevents/4159.jpeg",
      caption:
        "മേൽപ്പുറം പന്നിക്കോണം ശ്രീ ധർമ്മ ശാസ്താ ക്ഷേത്ര കമ്മിറ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4159.jpeg",
    },
    {
      src: "assets/img/Pastevents/4160.jpeg",
      caption:
        "മേൽപ്പുറം പന്നിക്കോണം ശ്രീ ധർമ്മ ശാസ്താ ക്ഷേത്ര കമ്മിറ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4160.jpeg",
    },
    {
      src: "assets/img/Pastevents/4161.jpeg",
      caption:
        "മേൽപ്പുറം പന്നിക്കോണം ശ്രീ ധർമ്മ ശാസ്താ ക്ഷേത്ര കമ്മിറ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4161.jpeg",
    },
    {
      src: "assets/img/Pastevents/4162.jpeg",
      caption:
        "മേൽപ്പുറം പന്നിക്കോണം ശ്രീ ധർമ്മ ശാസ്താ ക്ഷേത്ര കമ്മിറ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4162.jpeg",
    },
    {
      src: "assets/img/Pastevents/4151.jpeg",
      caption:
        "ഇരണിയിൽ ആൽവാർകോവിൽ ശ്രീ ഭദ്രേശ്വരി ദേവി ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.  ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4151.jpeg",
    },
    {
      src: "assets/img/Pastevents/4152.jpeg",
      caption:
        "ഇരണിയിൽ ആൽവാർകോവിൽ ശ്രീ ഭദ്രേശ്വരി ദേവി ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.  ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4152.jpeg",
    },
    {
      src: "assets/img/Pastevents/4153.jpeg",
      caption:
        "ഇരണിയിൽ ആൽവാർകോവിൽ ശ്രീ ഭദ്രേശ്വരി ദേവി ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.  ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4153.jpeg",
    },
    {
      src: "assets/img/Pastevents/4154.jpeg",
      caption:
        "ഇരണിയിൽ ആൽവാർകോവിൽ ശ്രീ ഭദ്രേശ്വരി ദേവി ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.  ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4154.jpeg",
    },
    {
      src: "assets/img/Pastevents/4155.jpeg",
      caption:
        "ഇരണിയിൽ ആൽവാർകോവിൽ ശ്രീ ഭദ്രേശ്വരി ദേവി ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.  ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4155.jpeg",
    },
    {
      src: "assets/img/Pastevents/4156.jpeg",
      caption:
        "ഇരണിയിൽ ആൽവാർകോവിൽ ശ്രീ ഭദ്രേശ്വരി ദേവി ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.  ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4156.jpeg",
    },
    {
      src: "assets/img/Pastevents/4145.jpeg",
      caption:
        "പാറശ്ശാല സേവാഭാരതി യൂണിറ്റ് , പരശുവയ്ക്കൽ മേജർ ശ്രീ ഭഗവതി ക്ഷേത്ര കമ്മിറ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4145.jpeg",
    },
    {
      src: "assets/img/Pastevents/4146.jpeg",
      caption:
        "പാറശ്ശാല സേവാഭാരതി യൂണിറ്റ് , പരശുവയ്ക്കൽ മേജർ ശ്രീ ഭഗവതി ക്ഷേത്ര കമ്മിറ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4146.jpeg",
    },
    {
      src: "assets/img/Pastevents/4147.jpeg",
      caption:
        "പാറശ്ശാല സേവാഭാരതി യൂണിറ്റ് , പരശുവയ്ക്കൽ മേജർ ശ്രീ ഭഗവതി ക്ഷേത്ര കമ്മിറ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4147.jpeg",
    },
    {
      src: "assets/img/Pastevents/4148.jpeg",
      caption:
        "പാറശ്ശാല സേവാഭാരതി യൂണിറ്റ് , പരശുവയ്ക്കൽ മേജർ ശ്രീ ഭഗവതി ക്ഷേത്ര കമ്മിറ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4148.jpeg",
    },
    {
      src: "assets/img/Pastevents/4149.jpeg",
      caption:
        "പാറശ്ശാല സേവാഭാരതി യൂണിറ്റ് , പരശുവയ്ക്കൽ മേജർ ശ്രീ ഭഗവതി ക്ഷേത്ര കമ്മിറ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4149.jpeg",
    },
        {
      src: "assets/img/Pastevents/4150.jpeg",
      caption:
        "പാറശ്ശാല സേവാഭാരതി യൂണിറ്റ് , പരശുവയ്ക്കൽ മേജർ ശ്രീ ഭഗവതി ക്ഷേത്ര കമ്മിറ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4150.jpeg",
    },
    {
      src: "assets/img/Pastevents/4139.jpeg",
      caption:
        "നെയ്യാറ്റിൻകര സേവാഭാരതി യൂണിറ്റ് , അരുവിപ്പുറം ആലറ ശ്രീ  ഭദ്രകാളി ക്ഷേത്ര  ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4139.jpeg",
    },
    {
      src: "assets/img/Pastevents/414.jpeg",
      caption:
        "നെയ്യാറ്റിൻകര സേവാഭാരതി യൂണിറ്റ് , അരുവിപ്പുറം ആലറ ശ്രീ  ഭദ്രകാളി ക്ഷേത്ര  ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/414.jpeg",
    },
    {
      src: "assets/img/Pastevents/4141.jpeg",
      caption:
        "നെയ്യാറ്റിൻകര സേവാഭാരതി യൂണിറ്റ് , അരുവിപ്പുറം ആലറ ശ്രീ  ഭദ്രകാളി ക്ഷേത്ര  ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4141.jpeg",
    },
    {
      src: "assets/img/Pastevents/4142.jpeg",
      caption:
        "നെയ്യാറ്റിൻകര സേവാഭാരതി യൂണിറ്റ് , അരുവിപ്പുറം ആലറ ശ്രീ  ഭദ്രകാളി ക്ഷേത്ര  ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4142.jpeg",
    },
    {
      src: "assets/img/Pastevents/4143.jpeg",
      caption:
        "നെയ്യാറ്റിൻകര സേവാഭാരതി യൂണിറ്റ് , അരുവിപ്പുറം ആലറ ശ്രീ  ഭദ്രകാളി ക്ഷേത്ര  ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4143.jpeg",
    },
    {
      src: "assets/img/Pastevents/4144.jpeg",
      caption:
        "നെയ്യാറ്റിൻകര സേവാഭാരതി യൂണിറ്റ് , അരുവിപ്പുറം ആലറ ശ്രീ  ഭദ്രകാളി ക്ഷേത്ര  ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4144.jpeg",
    },
    {
      src: "assets/img/Pastevents/4132.jpeg",
      caption:
        "പെരുംങ്കടവിള ആലത്തൂർ ശ്രീ യക്ഷി അമ്മൻ ദേവി ക്ഷേത്ര  ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4132.jpeg",
    },
    {
      src: "assets/img/Pastevents/4133.jpeg",
      caption:
        "പെരുംങ്കടവിള ആലത്തൂർ ശ്രീ യക്ഷി അമ്മൻ ദേവി ക്ഷേത്ര  ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4133.jpeg",
    },
    {
      src: "assets/img/Pastevents/4134.jpeg",
      caption:
        "പെരുംങ്കടവിള ആലത്തൂർ ശ്രീ യക്ഷി അമ്മൻ ദേവി ക്ഷേത്ര  ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4134.jpeg",
    },
    {
      src: "assets/img/Pastevents/4135.jpeg",
      caption:
        "പെരുംങ്കടവിള ആലത്തൂർ ശ്രീ യക്ഷി അമ്മൻ ദേവി ക്ഷേത്ര  ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4135.jpeg",
    },
    {
      src: "assets/img/Pastevents/4136.jpeg",
      caption:
        "പെരുംങ്കടവിള ആലത്തൂർ ശ്രീ യക്ഷി അമ്മൻ ദേവി ക്ഷേത്ര  ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4136.jpeg",
    },
    {
      src: "assets/img/Pastevents/4137.jpeg",
      caption:
        "പെരുംങ്കടവിള ആലത്തൂർ ശ്രീ യക്ഷി അമ്മൻ ദേവി ക്ഷേത്ര  ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4137.jpeg",
    },
    {
      src: "assets/img/Pastevents/4138.jpeg",
      caption:
        "പെരുംങ്കടവിള ആലത്തൂർ ശ്രീ യക്ഷി അമ്മൻ ദേവി ക്ഷേത്ര  ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4138.jpeg",
    },
    {
      src: "assets/img/Pastevents/4125.jpeg",
      caption:
        "തിരുവനന്തപുരം സേവ് പ്രൊട്ടക്ഷൻ കെയർ ഫോർ ചാരിറ്റബിൾ ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4125.jpeg",
    },
    {
      src: "assets/img/Pastevents/4126.jpeg",
      caption:
        "തിരുവനന്തപുരം സേവ് പ്രൊട്ടക്ഷൻ കെയർ ഫോർ ചാരിറ്റബിൾ ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4126.jpeg",
    },
    {
      src: "assets/img/Pastevents/4127.jpeg",
      caption:
        "തിരുവനന്തപുരം സേവ് പ്രൊട്ടക്ഷൻ കെയർ ഫോർ ചാരിറ്റബിൾ ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4127.jpeg",
    },
    {
      src: "assets/img/Pastevents/4128.jpeg",
      caption:
        "തിരുവനന്തപുരം സേവ് പ്രൊട്ടക്ഷൻ കെയർ ഫോർ ചാരിറ്റബിൾ ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4128.jpeg",
    },
    {
      src: "assets/img/Pastevents/4129.jpeg",
      caption:
        "തിരുവനന്തപുരം സേവ് പ്രൊട്ടക്ഷൻ കെയർ ഫോർ ചാരിറ്റബിൾ ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4129.jpeg",
    },
    {
      src: "assets/img/Pastevents/4130.jpeg",
      caption:
        "തിരുവനന്തപുരം സേവ് പ്രൊട്ടക്ഷൻ കെയർ ഫോർ ചാരിറ്റബിൾ ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4130.jpeg",
    },
    {
      src: "assets/img/Pastevents/4131.jpeg",
      caption:
        "തിരുവനന്തപുരം സേവ് പ്രൊട്ടക്ഷൻ കെയർ ഫോർ ചാരിറ്റബിൾ ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4131.jpeg",
    },
    {
      src: "assets/img/Pastevents/4119.jpeg",
      caption:
        "മണക്കാട് കൊഞ്ചിറവിള റെസിഡൻഷ്യൽ അസോസിയേഷൻ്റയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4119.jpeg",
    },
    {
      src: "assets/img/Pastevents/4120.jpeg",
      caption:
        "മണക്കാട് കൊഞ്ചിറവിള റെസിഡൻഷ്യൽ അസോസിയേഷൻ്റയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4120.jpeg",
    },
    {
      src: "assets/img/Pastevents/4121.jpeg",
      caption:
        "മണക്കാട് കൊഞ്ചിറവിള റെസിഡൻഷ്യൽ അസോസിയേഷൻ്റയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4121.jpeg",
    },
    {
      src: "assets/img/Pastevents/4122.jpeg",
      caption:
        "മണക്കാട് കൊഞ്ചിറവിള റെസിഡൻഷ്യൽ അസോസിയേഷൻ്റയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4122.jpeg",
    },
    {
      src: "assets/img/Pastevents/4123.jpeg",
      caption:
        "മണക്കാട് കൊഞ്ചിറവിള റെസിഡൻഷ്യൽ അസോസിയേഷൻ്റയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4123.jpeg",
    },
    {
      src: "assets/img/Pastevents/4124.jpeg",
      caption:
        "മണക്കാട് കൊഞ്ചിറവിള റെസിഡൻഷ്യൽ അസോസിയേഷൻ്റയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4124.jpeg",
    },
    {
      src: "assets/img/Pastevents/4113.jpeg",
      caption:
        "മംഗലത്തുക്കോണം കാട്ടുനട ശ്രീ ഭദ്രകാളി  ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.  ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4113.jpeg",
    },
    {
      src: "assets/img/Pastevents/4114.jpeg",
      caption:
        "മംഗലത്തുക്കോണം കാട്ടുനട ശ്രീ ഭദ്രകാളി  ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.  ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4114.jpeg",
    },
    {
      src: "assets/img/Pastevents/4115.jpeg",
      caption:
        "മംഗലത്തുക്കോണം കാട്ടുനട ശ്രീ ഭദ്രകാളി  ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.  ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4115.jpeg",
    },
    {
      src: "assets/img/Pastevents/4116.jpeg",
      caption:
        "മംഗലത്തുക്കോണം കാട്ടുനട ശ്രീ ഭദ്രകാളി  ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.  ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4116.jpeg",
    },
    {
      src: "assets/img/Pastevents/4117.jpeg",
      caption:
        "മംഗലത്തുക്കോണം കാട്ടുനട ശ്രീ ഭദ്രകാളി  ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.  ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4117.jpeg",
    },
    {
      src: "assets/img/Pastevents/4117.jpeg",
      caption:
        "മംഗലത്തുക്കോണം കാട്ടുനട ശ്രീ ഭദ്രകാളി  ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.  ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4117.jpeg",
    },
    {
      src: "assets/img/Pastevents/4118.jpeg",
      caption:
        "മംഗലത്തുക്കോണം കാട്ടുനട ശ്രീ ഭദ്രകാളി  ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.  ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4118.jpeg",
    },
    {
      src: "assets/img/Pastevents/4105.jpeg",
      caption:
        "പാലിയോട് വരട്ടയം ശ്രീ ഭദ്രകാളി  ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.  ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4105.jpeg",
    },
    {
      src: "assets/img/Pastevents/4106.jpeg",
      caption:
        "പാലിയോട് വരട്ടയം ശ്രീ ഭദ്രകാളി  ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.  ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4106.jpeg",
    },
    {
      src: "assets/img/Pastevents/4107.jpeg",
      caption:
        "പാലിയോട് വരട്ടയം ശ്രീ ഭദ്രകാളി  ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.  ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4107.jpeg",
    },
    {
      src: "assets/img/Pastevents/4108.jpeg",
      caption:
        "പാലിയോട് വരട്ടയം ശ്രീ ഭദ്രകാളി  ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.  ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4108.jpeg",
    },
    {
      src: "assets/img/Pastevents/4109.jpeg",
      caption:
        "പാലിയോട് വരട്ടയം ശ്രീ ഭദ്രകാളി  ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.  ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4109.jpeg",
    },
    {
      src: "assets/img/Pastevents/4110.jpeg",
      caption:
        "പാലിയോട് വരട്ടയം ശ്രീ ഭദ്രകാളി  ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.  ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4110.jpeg",
    },
    {
      src: "assets/img/Pastevents/4111.jpeg",
      caption:
        "പാലിയോട് വരട്ടയം ശ്രീ ഭദ്രകാളി  ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.  ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4111.jpeg",
    },
    {
      src: "assets/img/Pastevents/4098.jpeg",
      caption:
        "കൊല്ലങ്കോട് തൂക്ക മഹോൽസവത്തോട്അനുബന്ധിച്ച് കൊല്ലംങ്കോട് ശ്രീ ഭദ്രകാളി ദേവസ്വം ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4098.jpeg",
    },
    {
      src: "assets/img/Pastevents/4099.jpeg",
      caption:
        "കൊല്ലങ്കോട് തൂക്ക മഹോൽസവത്തോട്അനുബന്ധിച്ച് കൊല്ലംങ്കോട് ശ്രീ ഭദ്രകാളി ദേവസ്വം ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4099.jpeg",
    },
    {
      src: "assets/img/Pastevents/4100.jpeg",
      caption:
        "കൊല്ലങ്കോട് തൂക്ക മഹോൽസവത്തോട്അനുബന്ധിച്ച് കൊല്ലംങ്കോട് ശ്രീ ഭദ്രകാളി ദേവസ്വം ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4100.jpeg",
    },
    {
      src: "assets/img/Pastevents/4101.jpeg",
      caption:
        "കൊല്ലങ്കോട് തൂക്ക മഹോൽസവത്തോട്അനുബന്ധിച്ച് കൊല്ലംങ്കോട് ശ്രീ ഭദ്രകാളി ദേവസ്വം ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4101.jpeg",
    },
    {
      src: "assets/img/Pastevents/4102.jpeg",
      caption:
        "കൊല്ലങ്കോട് തൂക്ക മഹോൽസവത്തോട്അനുബന്ധിച്ച് കൊല്ലംങ്കോട് ശ്രീ ഭദ്രകാളി ദേവസ്വം ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4102.jpeg",
    },
    {
      src: "assets/img/Pastevents/4103.jpeg",
      caption:
        "കൊല്ലങ്കോട് തൂക്ക മഹോൽസവത്തോട്അനുബന്ധിച്ച് കൊല്ലംങ്കോട് ശ്രീ ഭദ്രകാളി ദേവസ്വം ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4103.jpeg",
    },
    {
      src: "assets/img/Pastevents/4104.jpeg",
      caption:
        "കൊല്ലങ്കോട് തൂക്ക മഹോൽസവത്തോട്അനുബന്ധിച്ച് കൊല്ലംങ്കോട് ശ്രീ ഭദ്രകാളി ദേവസ്വം ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4104.jpeg",
    },
    {
      src: "assets/img/Pastevents/4090.jpeg",
      caption:
        "ആര്യൻങ്കോട് സേവാഭാരതി യൂണിറ്റ്, കുറ്റിയാണിക്കാട് ശ്രീ ഭദ്രകാളി ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4090.jpeg",
    },
    {
      src: "assets/img/Pastevents/4091.jpeg",
      caption:
        "ആര്യൻങ്കോട് സേവാഭാരതി യൂണിറ്റ്, കുറ്റിയാണിക്കാട് ശ്രീ ഭദ്രകാളി ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4091.jpeg",
    },
    {
      src: "assets/img/Pastevents/4092.jpeg",
      caption:
        "ആര്യൻങ്കോട് സേവാഭാരതി യൂണിറ്റ്, കുറ്റിയാണിക്കാട് ശ്രീ ഭദ്രകാളി ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4092.jpeg",
    },
    {
      src: "assets/img/Pastevents/4093.jpeg",
      caption:
        "ആര്യൻങ്കോട് സേവാഭാരതി യൂണിറ്റ്, കുറ്റിയാണിക്കാട് ശ്രീ ഭദ്രകാളി ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4093.jpeg",
    },
    {
      src: "assets/img/Pastevents/4094.jpeg",
      caption:
        "ആര്യൻങ്കോട് സേവാഭാരതി യൂണിറ്റ്, കുറ്റിയാണിക്കാട് ശ്രീ ഭദ്രകാളി ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4094.jpeg",
    },
    {
      src: "assets/img/Pastevents/4095.jpeg",
      caption:
        "ആര്യൻങ്കോട് സേവാഭാരതി യൂണിറ്റ്, കുറ്റിയാണിക്കാട് ശ്രീ ഭദ്രകാളി ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4095.jpeg",
    },
    {
      src: "assets/img/Pastevents/4096.jpeg",
      caption:
        "ആര്യൻങ്കോട് സേവാഭാരതി യൂണിറ്റ്, കുറ്റിയാണിക്കാട് ശ്രീ ഭദ്രകാളി ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4096.jpeg",
    },
    {
      src: "assets/img/Pastevents/4097.jpeg",
      caption:
        "ആര്യൻങ്കോട് സേവാഭാരതി യൂണിറ്റ്, കുറ്റിയാണിക്കാട് ശ്രീ ഭദ്രകാളി ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4097.jpeg",
    },
    {
      src: "assets/img/Pastevents/4084.jpeg",
      caption:
        "തമിഴ്നാട് ഗവണ്മെൻറ് ഹെൽത്ത് ഇൻഷുറൻസ് സ്കീം, മാർത്താണ്ഡം പൂജാരി സേവാ ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4084.jpeg",
    },
    {
      src: "assets/img/Pastevents/4085.jpeg",
      caption:
        "തമിഴ്നാട് ഗവണ്മെൻറ് ഹെൽത്ത് ഇൻഷുറൻസ് സ്കീം, മാർത്താണ്ഡം പൂജാരി സേവാ ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4085.jpeg",
    },
    {
      src: "assets/img/Pastevents/4086.jpeg",
      caption:
        "തമിഴ്നാട് ഗവണ്മെൻറ് ഹെൽത്ത് ഇൻഷുറൻസ് സ്കീം, മാർത്താണ്ഡം പൂജാരി സേവാ ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4086.jpeg",
    },
    {
      src: "assets/img/Pastevents/4087.jpeg",
      caption:
        "തമിഴ്നാട് ഗവണ്മെൻറ് ഹെൽത്ത് ഇൻഷുറൻസ് സ്കീം, മാർത്താണ്ഡം പൂജാരി സേവാ ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4087.jpeg",
    },
    {
      src: "assets/img/Pastevents/4088.jpeg",
      caption:
        "തമിഴ്നാട് ഗവണ്മെൻറ് ഹെൽത്ത് ഇൻഷുറൻസ് സ്കീം, മാർത്താണ്ഡം പൂജാരി സേവാ ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4088.jpeg",
    },
    {
      src: "assets/img/Pastevents/4089.jpeg",
      caption:
        "തമിഴ്നാട് ഗവണ്മെൻറ് ഹെൽത്ത് ഇൻഷുറൻസ് സ്കീം, മാർത്താണ്ഡം പൂജാരി സേവാ ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4089.jpeg",
    },
    {
      src: "assets/img/Pastevents/4079.jpeg",
      caption:
        "മലയിൻകീഴ് കരിപ്പൂർ റെസിഡൻഷ്യൽ അസോസിയേഷൻ,മലയിൻകീഴ്  ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4079.jpeg",
    },
    {
      src: "assets/img/Pastevents/4080.jpeg",
      caption:
        "മലയിൻകീഴ് കരിപ്പൂർ റെസിഡൻഷ്യൽ അസോസിയേഷൻ,മലയിൻകീഴ്  ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4080.jpeg",
    },
    {
      src: "assets/img/Pastevents/4081.jpeg",
      caption:
        "മലയിൻകീഴ് കരിപ്പൂർ റെസിഡൻഷ്യൽ അസോസിയേഷൻ,മലയിൻകീഴ്  ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4081.jpeg",
    },
    {
      src: "assets/img/Pastevents/4082.jpeg",
      caption:
        "മലയിൻകീഴ് കരിപ്പൂർ റെസിഡൻഷ്യൽ അസോസിയേഷൻ,മലയിൻകീഴ്  ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4082.jpeg",
    },
    {
      src: "assets/img/Pastevents/4083.jpeg",
      caption:
        "മലയിൻകീഴ് കരിപ്പൂർ റെസിഡൻഷ്യൽ അസോസിയേഷൻ,മലയിൻകീഴ്  ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4083.jpeg",
    },
    {
      src: "assets/img/Pastevents/4073.jpeg",
      caption:
        "വിളപ്പിൽശാല സേവാഭാരതി യൂണിറ്റ്, പേയാട് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.   ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4073.jpeg",
    },
    {
      src: "assets/img/Pastevents/4074.jpeg",
      caption:
        "വിളപ്പിൽശാല സേവാഭാരതി യൂണിറ്റ്, പേയാട് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.   ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4074.jpeg",
    },
    {
      src: "assets/img/Pastevents/4075.jpeg",
      caption:
        "വിളപ്പിൽശാല സേവാഭാരതി യൂണിറ്റ്, പേയാട് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.   ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4075.jpeg",
    },
    {
      src: "assets/img/Pastevents/4076.jpeg",
      caption:
        "വിളപ്പിൽശാല സേവാഭാരതി യൂണിറ്റ്, പേയാട് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.   ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4076.jpeg",
    },
    {
      src: "assets/img/Pastevents/4077.jpeg",
      caption:
        "വിളപ്പിൽശാല സേവാഭാരതി യൂണിറ്റ്, പേയാട് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.   ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4077.jpeg",
    },
    {
      src: "assets/img/Pastevents/4078.jpeg",
      caption:
        "വിളപ്പിൽശാല സേവാഭാരതി യൂണിറ്റ്, പേയാട് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.   ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4078.jpeg",
    },
    {
      src: "assets/img/Pastevents/4068.jpeg",
      caption:
        "  ആയയിൽ ശ്രീ കരിയില കുളങ്ങര ഭഗവതി ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.   ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4068.jpeg",
    },
    {
      src: "assets/img/Pastevents/4069.jpeg",
      caption:
        "  ആയയിൽ ശ്രീ കരിയില കുളങ്ങര ഭഗവതി ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.   ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4069.jpeg",
    },
    {
      src: "assets/img/Pastevents/4070.jpeg",
      caption:
        "  ആയയിൽ ശ്രീ കരിയില കുളങ്ങര ഭഗവതി ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.   ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4070.jpeg",
    },
    {
      src: "assets/img/Pastevents/4071.jpeg",
      caption:
        "  ആയയിൽ ശ്രീ കരിയില കുളങ്ങര ഭഗവതി ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.   ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4071.jpeg",
    },
    {
      src: "assets/img/Pastevents/4072.jpeg",
      caption:
        "  ആയയിൽ ശ്രീ കരിയില കുളങ്ങര ഭഗവതി ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.   ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4072.jpeg",
    },
    {
      src: "assets/img/Pastevents/4061.jpeg",
      caption:
        "കാട്ടാക്കട ജമ്മു ഫൈനാൻസിയേഴ്സ് ശാഖയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4061.jpeg",
    },
    {
      src: "assets/img/Pastevents/4062.jpeg",
      caption:
        "കാട്ടാക്കട ജമ്മു ഫൈനാൻസിയേഴ്സ് ശാഖയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4062.jpeg",
    },

    {
      src: "assets/img/Pastevents/4063.jpeg",
      caption:
        "കാട്ടാക്കട ജമ്മു ഫൈനാൻസിയേഴ്സ് ശാഖയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4063.jpeg",
    },
    {
      src: "assets/img/Pastevents/4064.jpeg",
      caption:
        "കാട്ടാക്കട ജമ്മു ഫൈനാൻസിയേഴ്സ് ശാഖയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4064.jpeg",
    },
    {
      src: "assets/img/Pastevents/4065.jpeg",
      caption:
        "കാട്ടാക്കട ജമ്മു ഫൈനാൻസിയേഴ്സ് ശാഖയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4065.jpeg",
    },
    {
      src: "assets/img/Pastevents/4066.jpeg",
      caption:
        "കാട്ടാക്കട ജമ്മു ഫൈനാൻസിയേഴ്സ് ശാഖയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4066.jpeg",
    },
    {
      src: "assets/img/Pastevents/4067.jpeg",
      caption:
        "കാട്ടാക്കട ജമ്മു ഫൈനാൻസിയേഴ്സ് ശാഖയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4067.jpeg",
    },
    {
      src: "assets/img/Pastevents/4055.jpeg",
      caption:
        "അന്തിയൂർക്കോണം ശ്രീ സുബ്രമണ്യ സ്വാമി ക്ഷേത്രം, കാട്ടാക്കട സേവാഭാരതി യൂണിറ്റിൻ്റെയും  നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4055.jpeg",
    },
    {
      src: "assets/img/Pastevents/4056.jpeg",
      caption:
        "അന്തിയൂർക്കോണം ശ്രീ സുബ്രമണ്യ സ്വാമി ക്ഷേത്രം, കാട്ടാക്കട സേവാഭാരതി യൂണിറ്റിൻ്റെയും  നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4056.jpeg",
    },
    {
      src: "assets/img/Pastevents/4057.jpeg",
      caption:
        "അന്തിയൂർക്കോണം ശ്രീ സുബ്രമണ്യ സ്വാമി ക്ഷേത്രം, കാട്ടാക്കട സേവാഭാരതി യൂണിറ്റിൻ്റെയും  നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4057.jpeg",
    },
    {
      src: "assets/img/Pastevents/4058.jpeg",
      caption:
        "അന്തിയൂർക്കോണം ശ്രീ സുബ്രമണ്യ സ്വാമി ക്ഷേത്രം, കാട്ടാക്കട സേവാഭാരതി യൂണിറ്റിൻ്റെയും  നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4058.jpeg",
    },
    {
      src: "assets/img/Pastevents/4059.jpeg",
      caption:
        "അന്തിയൂർക്കോണം ശ്രീ സുബ്രമണ്യ സ്വാമി ക്ഷേത്രം, കാട്ടാക്കട സേവാഭാരതി യൂണിറ്റിൻ്റെയും  നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4059.jpeg",
    },
    {
      src: "assets/img/Pastevents/4060.jpeg",
      caption:
        "അന്തിയൂർക്കോണം ശ്രീ സുബ്രമണ്യ സ്വാമി ക്ഷേത്രം, കാട്ടാക്കട സേവാഭാരതി യൂണിറ്റിൻ്റെയും  നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4060.jpeg",
    },
    {
      src: "assets/img/Pastevents/4049.jpeg",
      caption:
        "തിരുമല തോട്ടുനടക്കവ് ട്രസ്റ്റ്, തിരുമല ലയൺസ് ക്ലബ്ബിൻ്റെയും  നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/4049.jpeg",
    },
    {
      src: "assets/img/Pastevents/4050.jpeg",
      caption:
        "തിരുമല തോട്ടുനടക്കവ് ട്രസ്റ്റ്, തിരുമല ലയൺസ് ക്ലബ്ബിൻ്റെയും  നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/4050.jpeg",
    },
    {
      src: "assets/img/Pastevents/4051.jpeg",
      caption:
        "തിരുമല തോട്ടുനടക്കവ് ട്രസ്റ്റ്, തിരുമല ലയൺസ് ക്ലബ്ബിൻ്റെയും  നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/4051.jpeg",
    },
    {
      src: "assets/img/Pastevents/4052.jpeg",
      caption:
        "തിരുമല തോട്ടുനടക്കവ് ട്രസ്റ്റ്, തിരുമല ലയൺസ് ക്ലബ്ബിൻ്റെയും  നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/4052.jpeg",
    },
    {
      src: "assets/img/Pastevents/4053.jpeg",
      caption:
        "തിരുമല തോട്ടുനടക്കവ് ട്രസ്റ്റ്, തിരുമല ലയൺസ് ക്ലബ്ബിൻ്റെയും  നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/4053.jpeg",
    },
    {
      src: "assets/img/Pastevents/4054.jpeg",
      caption:
        "തിരുമല തോട്ടുനടക്കവ് ട്രസ്റ്റ്, തിരുമല ലയൺസ് ക്ലബ്ബിൻ്റെയും  നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/4054.jpeg",
    },
    {
      src: "assets/img/Pastevents/4042.jpeg",
      caption:
        "നെയ്യാറ്റിൻകര റോട്ടറി ക്ലബ്ബ്, അമ്മൻ നഗർ റെസിഡൻഷ്യൽ അസോസിയേഷൻ്റെയും  നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4042.jpeg",
    },
    {
      src: "assets/img/Pastevents/4043.jpeg",
      caption:
        "നെയ്യാറ്റിൻകര റോട്ടറി ക്ലബ്ബ്, അമ്മൻ നഗർ റെസിഡൻഷ്യൽ അസോസിയേഷൻ്റെയും  നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4043.jpeg",
    },
    {
      src: "assets/img/Pastevents/4044.jpeg",
      caption:
        "നെയ്യാറ്റിൻകര റോട്ടറി ക്ലബ്ബ്, അമ്മൻ നഗർ റെസിഡൻഷ്യൽ അസോസിയേഷൻ്റെയും  നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4044.jpeg",
    },
    {
      src: "assets/img/Pastevents/4045.jpeg",
      caption:
        "നെയ്യാറ്റിൻകര റോട്ടറി ക്ലബ്ബ്, അമ്മൻ നഗർ റെസിഡൻഷ്യൽ അസോസിയേഷൻ്റെയും  നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4045.jpeg",
    },
    {
      src: "assets/img/Pastevents/4046.jpeg",
      caption:
        "നെയ്യാറ്റിൻകര റോട്ടറി ക്ലബ്ബ്, അമ്മൻ നഗർ റെസിഡൻഷ്യൽ അസോസിയേഷൻ്റെയും  നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4046.jpeg",
    },
    {
      src: "assets/img/Pastevents/4047.jpeg",
      caption:
        "നെയ്യാറ്റിൻകര റോട്ടറി ക്ലബ്ബ്, അമ്മൻ നഗർ റെസിഡൻഷ്യൽ അസോസിയേഷൻ്റെയും  നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4047.jpeg",
    },
    {
      src: "assets/img/Pastevents/4048.jpeg",
      caption:
        "നെയ്യാറ്റിൻകര റോട്ടറി ക്ലബ്ബ്, അമ്മൻ നഗർ റെസിഡൻഷ്യൽ അസോസിയേഷൻ്റെയും  നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4048.jpeg",
    },
    {
      src: "assets/img/Pastevents/4035.jpeg",
      caption:
        "കാരക്കോണം പുന്നാക്കര ശ്രീ ഈശ്വരകാല ഭൂതത്താൻ ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും  നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4035.jpeg",
    },
    {
      src: "assets/img/Pastevents/4036.jpeg",
      caption:
        "കാരക്കോണം പുന്നാക്കര ശ്രീ ഈശ്വരകാല ഭൂതത്താൻ ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും  നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4036.jpeg",
    },
    {
      src: "assets/img/Pastevents/4037.jpeg",
      caption:
        "കാരക്കോണം പുന്നാക്കര ശ്രീ ഈശ്വരകാല ഭൂതത്താൻ ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും  നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4037.jpeg",
    },
    {
      src: "assets/img/Pastevents/4038.jpeg",
      caption:
        "കാരക്കോണം പുന്നാക്കര ശ്രീ ഈശ്വരകാല ഭൂതത്താൻ ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും  നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4038.jpeg",
    },
    {
      src: "assets/img/Pastevents/4039.jpeg",
      caption:
        "കാരക്കോണം പുന്നാക്കര ശ്രീ ഈശ്വരകാല ഭൂതത്താൻ ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും  നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4039.jpeg",
    },
    {
      src: "assets/img/Pastevents/4040.jpeg",
      caption:
        "കാരക്കോണം പുന്നാക്കര ശ്രീ ഈശ്വരകാല ഭൂതത്താൻ ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും  നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4040.jpeg",
    },
    {
      src: "assets/img/Pastevents/4041.jpeg",
      caption:
        "കാരക്കോണം പുന്നാക്കര ശ്രീ ഈശ്വരകാല ഭൂതത്താൻ ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും  നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4041.jpeg",
    },
    {
      src: "assets/img/Pastevents/4031.jpeg",
      caption:
        "കരിക്കകം ശ്രീ ചാമുണ്ഡേശ്വരി ദേവി ക്ഷേത്ര പൊങ്കാല മഹോത്സവത്തോട് അനുബന്ധിച്ച് ചാക്ക കരിക്കകത്തമ്മ സേവാ സമിതിയുടെയും  നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4031.jpeg",
    },
    {
      src: "assets/img/Pastevents/4032.jpeg",
      caption:
        "കരിക്കകം ശ്രീ ചാമുണ്ഡേശ്വരി ദേവി ക്ഷേത്ര പൊങ്കാല മഹോത്സവത്തോട് അനുബന്ധിച്ച് ചാക്ക കരിക്കകത്തമ്മ സേവാ സമിതിയുടെയും  നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4032.jpeg",
    },
    {
      src: "assets/img/Pastevents/4033.jpeg",
      caption:
        "കരിക്കകം ശ്രീ ചാമുണ്ഡേശ്വരി ദേവി ക്ഷേത്ര പൊങ്കാല മഹോത്സവത്തോട് അനുബന്ധിച്ച് ചാക്ക കരിക്കകത്തമ്മ സേവാ സമിതിയുടെയും  നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4033.jpeg",
    },
    {
      src: "assets/img/Pastevents/4034.jpeg",
      caption:
        "കരിക്കകം ശ്രീ ചാമുണ്ഡേശ്വരി ദേവി ക്ഷേത്ര പൊങ്കാല മഹോത്സവത്തോട് അനുബന്ധിച്ച് ചാക്ക കരിക്കകത്തമ്മ സേവാ സമിതിയുടെയും  നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4034.jpeg",
    },
    {
      src: "assets/img/Pastevents/4023.jpeg",
      caption:
        "തമ്പാനൂർ ദേശാഭിമാനി ന്യൂസ് പേപ്പർ എംപ്ലോയീസ് യൂണിറ്റിൻ്റെയും  നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4023.jpeg",
    },
    {
      src: "assets/img/Pastevents/4024.jpeg",
      caption:
        "തമ്പാനൂർ ദേശാഭിമാനി ന്യൂസ് പേപ്പർ എംപ്ലോയീസ് യൂണിറ്റിൻ്റെയും  നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4024.jpeg",
    },
    {
      src: "assets/img/Pastevents/4025.jpeg",
      caption:
        "തമ്പാനൂർ ദേശാഭിമാനി ന്യൂസ് പേപ്പർ എംപ്ലോയീസ് യൂണിറ്റിൻ്റെയും  നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4025.jpeg",
    },
    {
      src: "assets/img/Pastevents/4026.jpeg",
      caption:
        "തമ്പാനൂർ ദേശാഭിമാനി ന്യൂസ് പേപ്പർ എംപ്ലോയീസ് യൂണിറ്റിൻ്റെയും  നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4026.jpeg",
    },
    {
      src: "assets/img/Pastevents/4027.jpeg",
      caption:
        "തമ്പാനൂർ ദേശാഭിമാനി ന്യൂസ് പേപ്പർ എംപ്ലോയീസ് യൂണിറ്റിൻ്റെയും  നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4027.jpeg",
    },
    {
      src: "assets/img/Pastevents/4028.jpeg",
      caption:
        "തമ്പാനൂർ ദേശാഭിമാനി ന്യൂസ് പേപ്പർ എംപ്ലോയീസ് യൂണിറ്റിൻ്റെയും  നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4028.jpeg",
    },
    {
      src: "assets/img/Pastevents/4029.jpeg",
      caption:
        "തമ്പാനൂർ ദേശാഭിമാനി ന്യൂസ് പേപ്പർ എംപ്ലോയീസ് യൂണിറ്റിൻ്റെയും  നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4029.jpeg",
    },
    {
      src: "assets/img/Pastevents/4030.jpeg",
      caption:
        "തമ്പാനൂർ ദേശാഭിമാനി ന്യൂസ് പേപ്പർ എംപ്ലോയീസ് യൂണിറ്റിൻ്റെയും  നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4030.jpeg",
    },
    {
      src: "assets/img/Pastevents/4014.jpeg",
      caption:
        "വെടിവച്ചാംകോവിൽ ശ്രീ ഭൂതമ്മൻ ദേവി ക്ഷേത്ര ട്രസ്റ്റ്,ബാലരാമപുരം നിംസ് മൈക്രോ ക്ലിനിക്കിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഓർത്തോപീഡിക്കസ് ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4014.jpeg",
    },
    {
      src: "assets/img/Pastevents/4015.jpeg",
      caption:
        "വെടിവച്ചാംകോവിൽ ശ്രീ ഭൂതമ്മൻ ദേവി ക്ഷേത്ര ട്രസ്റ്റ്,ബാലരാമപുരം നിംസ് മൈക്രോ ക്ലിനിക്കിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഓർത്തോപീഡിക്കസ് ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4015.jpeg",
    },
    {
      src: "assets/img/Pastevents/4016.jpeg",
      caption:
        "വെടിവച്ചാംകോവിൽ ശ്രീ ഭൂതമ്മൻ ദേവി ക്ഷേത്ര ട്രസ്റ്റ്,ബാലരാമപുരം നിംസ് മൈക്രോ ക്ലിനിക്കിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഓർത്തോപീഡിക്കസ് ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4016.jpeg",
    },
    {
      src: "assets/img/Pastevents/4017.jpeg",
      caption:
        "വെടിവച്ചാംകോവിൽ ശ്രീ ഭൂതമ്മൻ ദേവി ക്ഷേത്ര ട്രസ്റ്റ്,ബാലരാമപുരം നിംസ് മൈക്രോ ക്ലിനിക്കിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഓർത്തോപീഡിക്കസ് ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4017.jpeg",
    },
    {
      src: "assets/img/Pastevents/4018.jpeg",
      caption:
        "വെടിവച്ചാംകോവിൽ ശ്രീ ഭൂതമ്മൻ ദേവി ക്ഷേത്ര ട്രസ്റ്റ്,ബാലരാമപുരം നിംസ് മൈക്രോ ക്ലിനിക്കിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഓർത്തോപീഡിക്കസ് ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4018.jpeg",
    },
    {
      src: "assets/img/Pastevents/4019.jpeg",
      caption:
        "വെടിവച്ചാംകോവിൽ ശ്രീ ഭൂതമ്മൻ ദേവി ക്ഷേത്ര ട്രസ്റ്റ്,ബാലരാമപുരം നിംസ് മൈക്രോ ക്ലിനിക്കിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഓർത്തോപീഡിക്കസ് ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4019.jpeg",
    },
    {
      src: "assets/img/Pastevents/4020.jpeg",
      caption:
        "വെടിവച്ചാംകോവിൽ ശ്രീ ഭൂതമ്മൻ ദേവി ക്ഷേത്ര ട്രസ്റ്റ്,ബാലരാമപുരം നിംസ് മൈക്രോ ക്ലിനിക്കിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഓർത്തോപീഡിക്കസ് ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4020.jpeg",
    },
    {
      src: "assets/img/Pastevents/4021.jpeg",
      caption:
        "വെടിവച്ചാംകോവിൽ ശ്രീ ഭൂതമ്മൻ ദേവി ക്ഷേത്ര ട്രസ്റ്റ്,ബാലരാമപുരം നിംസ് മൈക്രോ ക്ലിനിക്കിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഓർത്തോപീഡിക്കസ് ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4021.jpeg",
    },
    {
      src: "assets/img/Pastevents/4022.jpeg",
      caption:
        "വെടിവച്ചാംകോവിൽ ശ്രീ ഭൂതമ്മൻ ദേവി ക്ഷേത്ര ട്രസ്റ്റ്,ബാലരാമപുരം നിംസ് മൈക്രോ ക്ലിനിക്കിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഓർത്തോപീഡിക്കസ് ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/4022.jpeg",
    },
    {
      src: "assets/img/Pastevents/4006.jpeg",
      caption:
        "ലോക വനിതാ ദിനാചരണത്തിൻ്റെ ഭാഗമായി വൈ.എം.സി.എ (YMCA) മാര്‍ത്താണ്ഡം ഡേ കെയർ സെൻ്ററും  വൈ.എം.സി.എ  തിരുവരമ്പും കൂടി ചേർന്ന് നിംസ് മെഡിസിറ്റിയുമായി സഹകരിച്ച് കൊണ്ട് മൂന്ന് വയസ്സിന് താഴെയുള്ള കുഞ്ഞുങ്ങൾക്കായി Healthy Baby Contest -2024 സംഘടിപ്പിച്ചു . കുഞ്ഞുങ്ങളുടെ തൂക്കം, ഉയരം, തലയുടെ അളവ്,  , കൂടാതെ TDSC, LEST തുടങ്ങിയ സ്ക്രീനിംഗ് പരിശോധനകളിലൂടെ അതാത് വയസിൽ കുട്ടികൾ കൈവരിക്കേണ്ട ബുദ്ധിവികാസ വളർച്ചാ വ്യതിയാനങ്ങൾ   ദന്താരോഗ്യ പരിശോധന തുടങ്ങിയവ ക്യാമ്പിലൂടെ പരിശോധന നടത്തി. നിംസ് സ്പെക്ട്രം ശിശു വികസന ഗവേഷണ കേന്ദ്രത്തിലെ തെറപ്പിസ്റ്റുകളും നിംസ് മെഡിസിറ്റി മെഡിക്കൽ ക്യാമ്പ് ടീം സംയുക്തമായി പരിശോധനകൾ നടത്തി .",
      thumb: "assets/img/Pastevents/4006.jpeg",
    },
    {
      src: "assets/img/Pastevents/4007.jpeg",
      caption:
        "ലോക വനിതാ ദിനാചരണത്തിൻ്റെ ഭാഗമായി വൈ.എം.സി.എ (YMCA) മാര്‍ത്താണ്ഡം ഡേ കെയർ സെൻ്ററും  വൈ.എം.സി.എ  തിരുവരമ്പും കൂടി ചേർന്ന് നിംസ് മെഡിസിറ്റിയുമായി സഹകരിച്ച് കൊണ്ട് മൂന്ന് വയസ്സിന് താഴെയുള്ള കുഞ്ഞുങ്ങൾക്കായി Healthy Baby Contest -2024 സംഘടിപ്പിച്ചു . കുഞ്ഞുങ്ങളുടെ തൂക്കം, ഉയരം, തലയുടെ അളവ്,  , കൂടാതെ TDSC, LEST തുടങ്ങിയ സ്ക്രീനിംഗ് പരിശോധനകളിലൂടെ അതാത് വയസിൽ കുട്ടികൾ കൈവരിക്കേണ്ട ബുദ്ധിവികാസ വളർച്ചാ വ്യതിയാനങ്ങൾ   ദന്താരോഗ്യ പരിശോധന തുടങ്ങിയവ ക്യാമ്പിലൂടെ പരിശോധന നടത്തി. നിംസ് സ്പെക്ട്രം ശിശു വികസന ഗവേഷണ കേന്ദ്രത്തിലെ തെറപ്പിസ്റ്റുകളും നിംസ് മെഡിസിറ്റി മെഡിക്കൽ ക്യാമ്പ് ടീം സംയുക്തമായി പരിശോധനകൾ നടത്തി .",
      thumb: "assets/img/Pastevents/4007.jpeg",
    },
    {
      src: "assets/img/Pastevents/4008.jpeg",
      caption:
        "ലോക വനിതാ ദിനാചരണത്തിൻ്റെ ഭാഗമായി വൈ.എം.സി.എ (YMCA) മാര്‍ത്താണ്ഡം ഡേ കെയർ സെൻ്ററും  വൈ.എം.സി.എ  തിരുവരമ്പും കൂടി ചേർന്ന് നിംസ് മെഡിസിറ്റിയുമായി സഹകരിച്ച് കൊണ്ട് മൂന്ന് വയസ്സിന് താഴെയുള്ള കുഞ്ഞുങ്ങൾക്കായി Healthy Baby Contest -2024 സംഘടിപ്പിച്ചു . കുഞ്ഞുങ്ങളുടെ തൂക്കം, ഉയരം, തലയുടെ അളവ്,  , കൂടാതെ TDSC, LEST തുടങ്ങിയ സ്ക്രീനിംഗ് പരിശോധനകളിലൂടെ അതാത് വയസിൽ കുട്ടികൾ കൈവരിക്കേണ്ട ബുദ്ധിവികാസ വളർച്ചാ വ്യതിയാനങ്ങൾ   ദന്താരോഗ്യ പരിശോധന തുടങ്ങിയവ ക്യാമ്പിലൂടെ പരിശോധന നടത്തി. നിംസ് സ്പെക്ട്രം ശിശു വികസന ഗവേഷണ കേന്ദ്രത്തിലെ തെറപ്പിസ്റ്റുകളും നിംസ് മെഡിസിറ്റി മെഡിക്കൽ ക്യാമ്പ് ടീം സംയുക്തമായി പരിശോധനകൾ നടത്തി .",
      thumb: "assets/img/Pastevents/4008.jpeg",
    },
    {
      src: "assets/img/Pastevents/4009.jpeg",
      caption:
        "ലോക വനിതാ ദിനാചരണത്തിൻ്റെ ഭാഗമായി വൈ.എം.സി.എ (YMCA) മാര്‍ത്താണ്ഡം ഡേ കെയർ സെൻ്ററും  വൈ.എം.സി.എ  തിരുവരമ്പും കൂടി ചേർന്ന് നിംസ് മെഡിസിറ്റിയുമായി സഹകരിച്ച് കൊണ്ട് മൂന്ന് വയസ്സിന് താഴെയുള്ള കുഞ്ഞുങ്ങൾക്കായി Healthy Baby Contest -2024 സംഘടിപ്പിച്ചു . കുഞ്ഞുങ്ങളുടെ തൂക്കം, ഉയരം, തലയുടെ അളവ്,  , കൂടാതെ TDSC, LEST തുടങ്ങിയ സ്ക്രീനിംഗ് പരിശോധനകളിലൂടെ അതാത് വയസിൽ കുട്ടികൾ കൈവരിക്കേണ്ട ബുദ്ധിവികാസ വളർച്ചാ വ്യതിയാനങ്ങൾ   ദന്താരോഗ്യ പരിശോധന തുടങ്ങിയവ ക്യാമ്പിലൂടെ പരിശോധന നടത്തി. നിംസ് സ്പെക്ട്രം ശിശു വികസന ഗവേഷണ കേന്ദ്രത്തിലെ തെറപ്പിസ്റ്റുകളും നിംസ് മെഡിസിറ്റി മെഡിക്കൽ ക്യാമ്പ് ടീം സംയുക്തമായി പരിശോധനകൾ നടത്തി .",
      thumb: "assets/img/Pastevents/4009.jpeg",
    },
    {
      src: "assets/img/Pastevents/4010.jpeg",
      caption:
        "ലോക വനിതാ ദിനാചരണത്തിൻ്റെ ഭാഗമായി വൈ.എം.സി.എ (YMCA) മാര്‍ത്താണ്ഡം ഡേ കെയർ സെൻ്ററും  വൈ.എം.സി.എ  തിരുവരമ്പും കൂടി ചേർന്ന് നിംസ് മെഡിസിറ്റിയുമായി സഹകരിച്ച് കൊണ്ട് മൂന്ന് വയസ്സിന് താഴെയുള്ള കുഞ്ഞുങ്ങൾക്കായി Healthy Baby Contest -2024 സംഘടിപ്പിച്ചു . കുഞ്ഞുങ്ങളുടെ തൂക്കം, ഉയരം, തലയുടെ അളവ്,  , കൂടാതെ TDSC, LEST തുടങ്ങിയ സ്ക്രീനിംഗ് പരിശോധനകളിലൂടെ അതാത് വയസിൽ കുട്ടികൾ കൈവരിക്കേണ്ട ബുദ്ധിവികാസ വളർച്ചാ വ്യതിയാനങ്ങൾ   ദന്താരോഗ്യ പരിശോധന തുടങ്ങിയവ ക്യാമ്പിലൂടെ പരിശോധന നടത്തി. നിംസ് സ്പെക്ട്രം ശിശു വികസന ഗവേഷണ കേന്ദ്രത്തിലെ തെറപ്പിസ്റ്റുകളും നിംസ് മെഡിസിറ്റി മെഡിക്കൽ ക്യാമ്പ് ടീം സംയുക്തമായി പരിശോധനകൾ നടത്തി .",
      thumb: "assets/img/Pastevents/4010.jpeg",
    },
    {
      src: "assets/img/Pastevents/4011.jpeg",
      caption:
        "ലോക വനിതാ ദിനാചരണത്തിൻ്റെ ഭാഗമായി വൈ.എം.സി.എ (YMCA) മാര്‍ത്താണ്ഡം ഡേ കെയർ സെൻ്ററും  വൈ.എം.സി.എ  തിരുവരമ്പും കൂടി ചേർന്ന് നിംസ് മെഡിസിറ്റിയുമായി സഹകരിച്ച് കൊണ്ട് മൂന്ന് വയസ്സിന് താഴെയുള്ള കുഞ്ഞുങ്ങൾക്കായി Healthy Baby Contest -2024 സംഘടിപ്പിച്ചു . കുഞ്ഞുങ്ങളുടെ തൂക്കം, ഉയരം, തലയുടെ അളവ്,  , കൂടാതെ TDSC, LEST തുടങ്ങിയ സ്ക്രീനിംഗ് പരിശോധനകളിലൂടെ അതാത് വയസിൽ കുട്ടികൾ കൈവരിക്കേണ്ട ബുദ്ധിവികാസ വളർച്ചാ വ്യതിയാനങ്ങൾ   ദന്താരോഗ്യ പരിശോധന തുടങ്ങിയവ ക്യാമ്പിലൂടെ പരിശോധന നടത്തി. നിംസ് സ്പെക്ട്രം ശിശു വികസന ഗവേഷണ കേന്ദ്രത്തിലെ തെറപ്പിസ്റ്റുകളും നിംസ് മെഡിസിറ്റി മെഡിക്കൽ ക്യാമ്പ് ടീം സംയുക്തമായി പരിശോധനകൾ നടത്തി .",
      thumb: "assets/img/Pastevents/4011.jpeg",
    },
    {
      src: "assets/img/Pastevents/4012.jpeg",
      caption:
        "ലോക വനിതാ ദിനാചരണത്തിൻ്റെ ഭാഗമായി വൈ.എം.സി.എ (YMCA) മാര്‍ത്താണ്ഡം ഡേ കെയർ സെൻ്ററും  വൈ.എം.സി.എ  തിരുവരമ്പും കൂടി ചേർന്ന് നിംസ് മെഡിസിറ്റിയുമായി സഹകരിച്ച് കൊണ്ട് മൂന്ന് വയസ്സിന് താഴെയുള്ള കുഞ്ഞുങ്ങൾക്കായി Healthy Baby Contest -2024 സംഘടിപ്പിച്ചു . കുഞ്ഞുങ്ങളുടെ തൂക്കം, ഉയരം, തലയുടെ അളവ്,  , കൂടാതെ TDSC, LEST തുടങ്ങിയ സ്ക്രീനിംഗ് പരിശോധനകളിലൂടെ അതാത് വയസിൽ കുട്ടികൾ കൈവരിക്കേണ്ട ബുദ്ധിവികാസ വളർച്ചാ വ്യതിയാനങ്ങൾ   ദന്താരോഗ്യ പരിശോധന തുടങ്ങിയവ ക്യാമ്പിലൂടെ പരിശോധന നടത്തി. നിംസ് സ്പെക്ട്രം ശിശു വികസന ഗവേഷണ കേന്ദ്രത്തിലെ തെറപ്പിസ്റ്റുകളും നിംസ് മെഡിസിറ്റി മെഡിക്കൽ ക്യാമ്പ് ടീം സംയുക്തമായി പരിശോധനകൾ നടത്തി .",
      thumb: "assets/img/Pastevents/4012.jpeg",
    },
    {
      src: "assets/img/Pastevents/4013.jpeg",
      caption:
        "ലോക വനിതാ ദിനാചരണത്തിൻ്റെ ഭാഗമായി വൈ.എം.സി.എ (YMCA) മാര്‍ത്താണ്ഡം ഡേ കെയർ സെൻ്ററും  വൈ.എം.സി.എ  തിരുവരമ്പും കൂടി ചേർന്ന് നിംസ് മെഡിസിറ്റിയുമായി സഹകരിച്ച് കൊണ്ട് മൂന്ന് വയസ്സിന് താഴെയുള്ള കുഞ്ഞുങ്ങൾക്കായി Healthy Baby Contest -2024 സംഘടിപ്പിച്ചു . കുഞ്ഞുങ്ങളുടെ തൂക്കം, ഉയരം, തലയുടെ അളവ്,  , കൂടാതെ TDSC, LEST തുടങ്ങിയ സ്ക്രീനിംഗ് പരിശോധനകളിലൂടെ അതാത് വയസിൽ കുട്ടികൾ കൈവരിക്കേണ്ട ബുദ്ധിവികാസ വളർച്ചാ വ്യതിയാനങ്ങൾ   ദന്താരോഗ്യ പരിശോധന തുടങ്ങിയവ ക്യാമ്പിലൂടെ പരിശോധന നടത്തി. നിംസ് സ്പെക്ട്രം ശിശു വികസന ഗവേഷണ കേന്ദ്രത്തിലെ തെറപ്പിസ്റ്റുകളും നിംസ് മെഡിസിറ്റി മെഡിക്കൽ ക്യാമ്പ് ടീം സംയുക്തമായി പരിശോധനകൾ നടത്തി .",
      thumb: "assets/img/Pastevents/4013.jpeg",
    },
    {
      src: "assets/img/Pastevents/3998.jpeg",
      caption:
        "വഴിമുക്ക് മുസ്‌ലിം ജമാഅത്ത് ചീഫ് ഇമാം ബഹുമാനപ്പെട്ട മൗലവി മീരാൻ ഫലാഹി അൽബാഖവി ഉദ്ഘാടനം നിർവ്വഹിച്ച മെഡിക്കൽ ക്യാമ്പിൽ ജമാഅത്ത്  പ്രസിഡൻറ്റ് ജനാബ് നസീർ അധ്യക്ഷത വഹിച്ചു . നിംസ് മെഡിസിറ്റിയിലെ ഇൻ്റേണൽ മെഡിസിൻ കൺസൾട്ടൻ്റും ഡയബറ്റോളജിസ്റ്റ്മായ ഡോക്ടർ ശ്രീ ഷഹ്ബാസ് ഷൈലു മെഡിക്കൽ ക്യാമ്പിന് നേതൃത്വം നൽകി .",
      thumb: "assets/img/Pastevents/3998.jpeg",
    },
    {
      src: "assets/img/Pastevents/3999.jpeg",
      caption:
        "വഴിമുക്ക് മുസ്‌ലിം ജമാഅത്ത് ചീഫ് ഇമാം ബഹുമാനപ്പെട്ട മൗലവി മീരാൻ ഫലാഹി അൽബാഖവി ഉദ്ഘാടനം നിർവ്വഹിച്ച മെഡിക്കൽ ക്യാമ്പിൽ ജമാഅത്ത്  പ്രസിഡൻറ്റ് ജനാബ് നസീർ അധ്യക്ഷത വഹിച്ചു . നിംസ് മെഡിസിറ്റിയിലെ ഇൻ്റേണൽ മെഡിസിൻ കൺസൾട്ടൻ്റും ഡയബറ്റോളജിസ്റ്റ്മായ ഡോക്ടർ ശ്രീ ഷഹ്ബാസ് ഷൈലു മെഡിക്കൽ ക്യാമ്പിന് നേതൃത്വം നൽകി .",
      thumb: "assets/img/Pastevents/3999.jpeg",
    },
    {
      src: "assets/img/Pastevents/4000.jpeg",
      caption:
        "വഴിമുക്ക് മുസ്‌ലിം ജമാഅത്ത് ചീഫ് ഇമാം ബഹുമാനപ്പെട്ട മൗലവി മീരാൻ ഫലാഹി അൽബാഖവി ഉദ്ഘാടനം നിർവ്വഹിച്ച മെഡിക്കൽ ക്യാമ്പിൽ ജമാഅത്ത്  പ്രസിഡൻറ്റ് ജനാബ് നസീർ അധ്യക്ഷത വഹിച്ചു . നിംസ് മെഡിസിറ്റിയിലെ ഇൻ്റേണൽ മെഡിസിൻ കൺസൾട്ടൻ്റും ഡയബറ്റോളജിസ്റ്റ്മായ ഡോക്ടർ ശ്രീ ഷഹ്ബാസ് ഷൈലു മെഡിക്കൽ ക്യാമ്പിന് നേതൃത്വം നൽകി .",
      thumb: "assets/img/Pastevents/4000.jpeg",
    },
    {
      src: "assets/img/Pastevents/4001.jpeg",
      caption:
        "വഴിമുക്ക് മുസ്‌ലിം ജമാഅത്ത് ചീഫ് ഇമാം ബഹുമാനപ്പെട്ട മൗലവി മീരാൻ ഫലാഹി അൽബാഖവി ഉദ്ഘാടനം നിർവ്വഹിച്ച മെഡിക്കൽ ക്യാമ്പിൽ ജമാഅത്ത്  പ്രസിഡൻറ്റ് ജനാബ് നസീർ അധ്യക്ഷത വഹിച്ചു . നിംസ് മെഡിസിറ്റിയിലെ ഇൻ്റേണൽ മെഡിസിൻ കൺസൾട്ടൻ്റും ഡയബറ്റോളജിസ്റ്റ്മായ ഡോക്ടർ ശ്രീ ഷഹ്ബാസ് ഷൈലു മെഡിക്കൽ ക്യാമ്പിന് നേതൃത്വം നൽകി .",
      thumb: "assets/img/Pastevents/4001.jpeg",
    },
    {
      src: "assets/img/Pastevents/4002.jpeg",
      caption:
        "വഴിമുക്ക് മുസ്‌ലിം ജമാഅത്ത് ചീഫ് ഇമാം ബഹുമാനപ്പെട്ട മൗലവി മീരാൻ ഫലാഹി അൽബാഖവി ഉദ്ഘാടനം നിർവ്വഹിച്ച മെഡിക്കൽ ക്യാമ്പിൽ ജമാഅത്ത്  പ്രസിഡൻറ്റ് ജനാബ് നസീർ അധ്യക്ഷത വഹിച്ചു . നിംസ് മെഡിസിറ്റിയിലെ ഇൻ്റേണൽ മെഡിസിൻ കൺസൾട്ടൻ്റും ഡയബറ്റോളജിസ്റ്റ്മായ ഡോക്ടർ ശ്രീ ഷഹ്ബാസ് ഷൈലു മെഡിക്കൽ ക്യാമ്പിന് നേതൃത്വം നൽകി .",
      thumb: "assets/img/Pastevents/4002.jpeg",
    },
    {
      src: "assets/img/Pastevents/4003.jpeg",
      caption:
        "വഴിമുക്ക് മുസ്‌ലിം ജമാഅത്ത് ചീഫ് ഇമാം ബഹുമാനപ്പെട്ട മൗലവി മീരാൻ ഫലാഹി അൽബാഖവി ഉദ്ഘാടനം നിർവ്വഹിച്ച മെഡിക്കൽ ക്യാമ്പിൽ ജമാഅത്ത്  പ്രസിഡൻറ്റ് ജനാബ് നസീർ അധ്യക്ഷത വഹിച്ചു . നിംസ് മെഡിസിറ്റിയിലെ ഇൻ്റേണൽ മെഡിസിൻ കൺസൾട്ടൻ്റും ഡയബറ്റോളജിസ്റ്റ്മായ ഡോക്ടർ ശ്രീ ഷഹ്ബാസ് ഷൈലു മെഡിക്കൽ ക്യാമ്പിന് നേതൃത്വം നൽകി .",
      thumb: "assets/img/Pastevents/4003.jpeg",
    },
    {
      src: "assets/img/Pastevents/4004.jpeg",
      caption:
        "വഴിമുക്ക് മുസ്‌ലിം ജമാഅത്ത് ചീഫ് ഇമാം ബഹുമാനപ്പെട്ട മൗലവി മീരാൻ ഫലാഹി അൽബാഖവി ഉദ്ഘാടനം നിർവ്വഹിച്ച മെഡിക്കൽ ക്യാമ്പിൽ ജമാഅത്ത്  പ്രസിഡൻറ്റ് ജനാബ് നസീർ അധ്യക്ഷത വഹിച്ചു . നിംസ് മെഡിസിറ്റിയിലെ ഇൻ്റേണൽ മെഡിസിൻ കൺസൾട്ടൻ്റും ഡയബറ്റോളജിസ്റ്റ്മായ ഡോക്ടർ ശ്രീ ഷഹ്ബാസ് ഷൈലു മെഡിക്കൽ ക്യാമ്പിന് നേതൃത്വം നൽകി .",
      thumb: "assets/img/Pastevents/4004.jpeg",
    },
    {
      src: "assets/img/Pastevents/4005.jpeg",
      caption:
        "വഴിമുക്ക് മുസ്‌ലിം ജമാഅത്ത് ചീഫ് ഇമാം ബഹുമാനപ്പെട്ട മൗലവി മീരാൻ ഫലാഹി അൽബാഖവി ഉദ്ഘാടനം നിർവ്വഹിച്ച മെഡിക്കൽ ക്യാമ്പിൽ ജമാഅത്ത്  പ്രസിഡൻറ്റ് ജനാബ് നസീർ അധ്യക്ഷത വഹിച്ചു . നിംസ് മെഡിസിറ്റിയിലെ ഇൻ്റേണൽ മെഡിസിൻ കൺസൾട്ടൻ്റും ഡയബറ്റോളജിസ്റ്റ്മായ ഡോക്ടർ ശ്രീ ഷഹ്ബാസ് ഷൈലു മെഡിക്കൽ ക്യാമ്പിന് നേതൃത്വം നൽകി .",
      thumb: "assets/img/Pastevents/4005.jpeg",
    },
    {
      src: "assets/img/Pastevents/3991.jpeg",
      caption:
        "മുല്ലൂർ ശ്രീ ചൂണ്ടുവിള തമ്പുരാൻ ദേവി ക്ഷേത്ര  ട്രസ്റ്റിൻ്റെയും ബി അർ കെ സൊസൈറ്റി തിരുവനന്തപുരം നിംസ് മെഡിസിറ്റി സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3991.jpeg",
    },
    {
      src: "assets/img/Pastevents/3992.jpeg",
      caption:
        "മുല്ലൂർ ശ്രീ ചൂണ്ടുവിള തമ്പുരാൻ ദേവി ക്ഷേത്ര  ട്രസ്റ്റിൻ്റെയും ബി അർ കെ സൊസൈറ്റി തിരുവനന്തപുരം നിംസ് മെഡിസിറ്റി സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3992.jpeg",
    },
    {
      src: "assets/img/Pastevents/3993.jpeg",
      caption:
        "മുല്ലൂർ ശ്രീ ചൂണ്ടുവിള തമ്പുരാൻ ദേവി ക്ഷേത്ര  ട്രസ്റ്റിൻ്റെയും ബി അർ കെ സൊസൈറ്റി തിരുവനന്തപുരം നിംസ് മെഡിസിറ്റി സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3993.jpeg",
    },
    {
      src: "assets/img/Pastevents/3994.jpeg",
      caption:
        "മുല്ലൂർ ശ്രീ ചൂണ്ടുവിള തമ്പുരാൻ ദേവി ക്ഷേത്ര  ട്രസ്റ്റിൻ്റെയും ബി അർ കെ സൊസൈറ്റി തിരുവനന്തപുരം നിംസ് മെഡിസിറ്റി സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3994.jpeg",
    },
    {
      src: "assets/img/Pastevents/3995.jpeg",
      caption:
        "മുല്ലൂർ ശ്രീ ചൂണ്ടുവിള തമ്പുരാൻ ദേവി ക്ഷേത്ര  ട്രസ്റ്റിൻ്റെയും ബി അർ കെ സൊസൈറ്റി തിരുവനന്തപുരം നിംസ് മെഡിസിറ്റി സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3995.jpeg",
    },
    {
      src: "assets/img/Pastevents/3996.jpeg",
      caption:
        "മുല്ലൂർ ശ്രീ ചൂണ്ടുവിള തമ്പുരാൻ ദേവി ക്ഷേത്ര  ട്രസ്റ്റിൻ്റെയും ബി അർ കെ സൊസൈറ്റി തിരുവനന്തപുരം നിംസ് മെഡിസിറ്റി സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3996.jpeg",
    },
    {
      src: "assets/img/Pastevents/3997.jpeg",
      caption:
        "മുല്ലൂർ ശ്രീ ചൂണ്ടുവിള തമ്പുരാൻ ദേവി ക്ഷേത്ര  ട്രസ്റ്റിൻ്റെയും ബി അർ കെ സൊസൈറ്റി തിരുവനന്തപുരം നിംസ് മെഡിസിറ്റി സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3997.jpeg",
    },
    {
      src: "assets/img/Pastevents/3985.jpeg",
      caption:
        "തമിഴ്നാട് ഗവൺമെൻ്റ് ഹെൽത്ത് ഇൻഷുറൻസ് സ്കീം,ശ്രീ കണ്ഠൻ ശാസ്താ സേവാ ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3985.jpeg",
    },
    {
      src: "assets/img/Pastevents/3986.jpeg",
      caption:
        "തമിഴ്നാട് ഗവൺമെൻ്റ് ഹെൽത്ത് ഇൻഷുറൻസ് സ്കീം,ശ്രീ കണ്ഠൻ ശാസ്താ സേവാ ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3986.jpeg",
    },
    {
      src: "assets/img/Pastevents/3987.jpeg",
      caption:
        "തമിഴ്നാട് ഗവൺമെൻ്റ് ഹെൽത്ത് ഇൻഷുറൻസ് സ്കീം,ശ്രീ കണ്ഠൻ ശാസ്താ സേവാ ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3987.jpeg",
    },
    {
      src: "assets/img/Pastevents/3988.jpeg",
      caption:
        "തമിഴ്നാട് ഗവൺമെൻ്റ് ഹെൽത്ത് ഇൻഷുറൻസ് സ്കീം,ശ്രീ കണ്ഠൻ ശാസ്താ സേവാ ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3988.jpeg",
    },
    {
      src: "assets/img/Pastevents/3989.jpeg",
      caption:
        "തമിഴ്നാട് ഗവൺമെൻ്റ് ഹെൽത്ത് ഇൻഷുറൻസ് സ്കീം,ശ്രീ കണ്ഠൻ ശാസ്താ സേവാ ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3989.jpeg",
    },
    {
      src: "assets/img/Pastevents/3990.jpeg",
      caption:
        "തമിഴ്നാട് ഗവൺമെൻ്റ് ഹെൽത്ത് ഇൻഷുറൻസ് സ്കീം,ശ്രീ കണ്ഠൻ ശാസ്താ സേവാ ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3990.jpeg",
    },
    {
      src: "assets/img/Pastevents/3977.jpeg",
      caption:
        "റമദാൻ നോമ്പിനു മുന്നോടിയായി വ്രതാനുഷ്ഠാനവുമായി ബന്ധപ്പെട്ട് ശ്രദ്ധിക്കേണ്ട കാര്യങ്ങളിൽ അവബോധം നൽകുന്നതിനും നോമ്പുകാലത്തെ ആരോഗ്യപരിരക്ഷ ഉറപ്പാക്കുന്നതിനുമായി നെയ്യാറ്റിൻകര ഠൗൺ മുസ്‌ലിം ജമാഅത്തും നിംസ് മെഡിസിറ്റിയും സംയുക്തായി സൗജന്യ മെഡിക്കൽ ക്യാമ്പും പരിശോധനകളും സംഘടിപ്പിച്ചു.  ",
      thumb: "assets/img/Pastevents/3977.jpeg",
    },
    {
      src: "assets/img/Pastevents/3978.jpeg",
      caption:
        "റമദാൻ നോമ്പിനു മുന്നോടിയായി വ്രതാനുഷ്ഠാനവുമായി ബന്ധപ്പെട്ട് ശ്രദ്ധിക്കേണ്ട കാര്യങ്ങളിൽ അവബോധം നൽകുന്നതിനും നോമ്പുകാലത്തെ ആരോഗ്യപരിരക്ഷ ഉറപ്പാക്കുന്നതിനുമായി നെയ്യാറ്റിൻകര ഠൗൺ മുസ്‌ലിം ജമാഅത്തും നിംസ് മെഡിസിറ്റിയും സംയുക്തായി സൗജന്യ മെഡിക്കൽ ക്യാമ്പും പരിശോധനകളും സംഘടിപ്പിച്ചു.  ",
      thumb: "assets/img/Pastevents/3978.jpeg",
    },
    {
      src: "assets/img/Pastevents/3979.jpeg",
      caption:
        "റമദാൻ നോമ്പിനു മുന്നോടിയായി വ്രതാനുഷ്ഠാനവുമായി ബന്ധപ്പെട്ട് ശ്രദ്ധിക്കേണ്ട കാര്യങ്ങളിൽ അവബോധം നൽകുന്നതിനും നോമ്പുകാലത്തെ ആരോഗ്യപരിരക്ഷ ഉറപ്പാക്കുന്നതിനുമായി നെയ്യാറ്റിൻകര ഠൗൺ മുസ്‌ലിം ജമാഅത്തും നിംസ് മെഡിസിറ്റിയും സംയുക്തായി സൗജന്യ മെഡിക്കൽ ക്യാമ്പും പരിശോധനകളും സംഘടിപ്പിച്ചു.  ",
      thumb: "assets/img/Pastevents/3979.jpeg",
    },
    {
      src: "assets/img/Pastevents/3980.jpeg",
      caption:
        "റമദാൻ നോമ്പിനു മുന്നോടിയായി വ്രതാനുഷ്ഠാനവുമായി ബന്ധപ്പെട്ട് ശ്രദ്ധിക്കേണ്ട കാര്യങ്ങളിൽ അവബോധം നൽകുന്നതിനും നോമ്പുകാലത്തെ ആരോഗ്യപരിരക്ഷ ഉറപ്പാക്കുന്നതിനുമായി നെയ്യാറ്റിൻകര ഠൗൺ മുസ്‌ലിം ജമാഅത്തും നിംസ് മെഡിസിറ്റിയും സംയുക്തായി സൗജന്യ മെഡിക്കൽ ക്യാമ്പും പരിശോധനകളും സംഘടിപ്പിച്ചു.  ",
      thumb: "assets/img/Pastevents/3980.jpeg",
    },
    {
      src: "assets/img/Pastevents/3981.jpeg",
      caption:
        "റമദാൻ നോമ്പിനു മുന്നോടിയായി വ്രതാനുഷ്ഠാനവുമായി ബന്ധപ്പെട്ട് ശ്രദ്ധിക്കേണ്ട കാര്യങ്ങളിൽ അവബോധം നൽകുന്നതിനും നോമ്പുകാലത്തെ ആരോഗ്യപരിരക്ഷ ഉറപ്പാക്കുന്നതിനുമായി നെയ്യാറ്റിൻകര ഠൗൺ മുസ്‌ലിം ജമാഅത്തും നിംസ് മെഡിസിറ്റിയും സംയുക്തായി സൗജന്യ മെഡിക്കൽ ക്യാമ്പും പരിശോധനകളും സംഘടിപ്പിച്ചു.  ",
      thumb: "assets/img/Pastevents/3981.jpeg",
    },
    {
      src: "assets/img/Pastevents/3982.jpeg",
      caption:
        "റമദാൻ നോമ്പിനു മുന്നോടിയായി വ്രതാനുഷ്ഠാനവുമായി ബന്ധപ്പെട്ട് ശ്രദ്ധിക്കേണ്ട കാര്യങ്ങളിൽ അവബോധം നൽകുന്നതിനും നോമ്പുകാലത്തെ ആരോഗ്യപരിരക്ഷ ഉറപ്പാക്കുന്നതിനുമായി നെയ്യാറ്റിൻകര ഠൗൺ മുസ്‌ലിം ജമാഅത്തും നിംസ് മെഡിസിറ്റിയും സംയുക്തായി സൗജന്യ മെഡിക്കൽ ക്യാമ്പും പരിശോധനകളും സംഘടിപ്പിച്ചു.  ",
      thumb: "assets/img/Pastevents/3982.jpeg",
    },
    {
      src: "assets/img/Pastevents/3983.jpeg",
      caption:
        "റമദാൻ നോമ്പിനു മുന്നോടിയായി വ്രതാനുഷ്ഠാനവുമായി ബന്ധപ്പെട്ട് ശ്രദ്ധിക്കേണ്ട കാര്യങ്ങളിൽ അവബോധം നൽകുന്നതിനും നോമ്പുകാലത്തെ ആരോഗ്യപരിരക്ഷ ഉറപ്പാക്കുന്നതിനുമായി നെയ്യാറ്റിൻകര ഠൗൺ മുസ്‌ലിം ജമാഅത്തും നിംസ് മെഡിസിറ്റിയും സംയുക്തായി സൗജന്യ മെഡിക്കൽ ക്യാമ്പും പരിശോധനകളും സംഘടിപ്പിച്ചു.  ",
      thumb: "assets/img/Pastevents/3983.jpeg",
    },
    {
      src: "assets/img/Pastevents/3984.jpeg",
      caption:
        "റമദാൻ നോമ്പിനു മുന്നോടിയായി വ്രതാനുഷ്ഠാനവുമായി ബന്ധപ്പെട്ട് ശ്രദ്ധിക്കേണ്ട കാര്യങ്ങളിൽ അവബോധം നൽകുന്നതിനും നോമ്പുകാലത്തെ ആരോഗ്യപരിരക്ഷ ഉറപ്പാക്കുന്നതിനുമായി നെയ്യാറ്റിൻകര ഠൗൺ മുസ്‌ലിം ജമാഅത്തും നിംസ് മെഡിസിറ്റിയും സംയുക്തായി സൗജന്യ മെഡിക്കൽ ക്യാമ്പും പരിശോധനകളും സംഘടിപ്പിച്ചു.  ",
      thumb: "assets/img/Pastevents/3984.jpeg",
    },
    {
      src: "assets/img/Pastevents/3971.jpeg",
      caption:
        "ചവറ സൗത്ത് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3971.jpeg",
    },
    {
      src: "assets/img/Pastevents/3972.jpeg",
      caption:
        "ചവറ സൗത്ത് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3972.jpeg",
    },
    {
      src: "assets/img/Pastevents/3973.jpeg",
      caption:
        "ചവറ സൗത്ത് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3973.jpeg",
    },
    {
      src: "assets/img/Pastevents/3974.jpeg",
      caption:
        "ചവറ സൗത്ത് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3974.jpeg",
    },
    {
      src: "assets/img/Pastevents/3975.jpeg",
      caption:
        "ചവറ സൗത്ത് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3975.jpeg",
    },
    {
      src: "assets/img/Pastevents/3976.jpeg",
      caption:
        "ചവറ സൗത്ത് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3976.jpeg",
    },
    {
      src: "assets/img/Pastevents/3965.jpeg",
      caption:
        "വിതുര പബ്ലിക് ക്യാമ്പസ് മിനിസ്ട്രി, മാങ്കല സെവെന്ത് ഡേ അഡ്വന്റിസ്റ്റ് ചർച്ചിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3965.jpeg",
    },
    {
      src: "assets/img/Pastevents/3966.jpeg",
      caption:
        "വിതുര പബ്ലിക് ക്യാമ്പസ് മിനിസ്ട്രി, മാങ്കല സെവെന്ത് ഡേ അഡ്വന്റിസ്റ്റ് ചർച്ചിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3966.jpeg",
    },
    {
      src: "assets/img/Pastevents/3967.jpeg",
      caption:
        "വിതുര പബ്ലിക് ക്യാമ്പസ് മിനിസ്ട്രി, മാങ്കല സെവെന്ത് ഡേ അഡ്വന്റിസ്റ്റ് ചർച്ചിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3967.jpeg",
    },
    {
      src: "assets/img/Pastevents/3968.jpeg",
      caption:
        "വിതുര പബ്ലിക് ക്യാമ്പസ് മിനിസ്ട്രി, മാങ്കല സെവെന്ത് ഡേ അഡ്വന്റിസ്റ്റ് ചർച്ചിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3968.jpeg",
    },
    {
      src: "assets/img/Pastevents/3969.jpeg",
      caption:
        "വിതുര പബ്ലിക് ക്യാമ്പസ് മിനിസ്ട്രി, മാങ്കല സെവെന്ത് ഡേ അഡ്വന്റിസ്റ്റ് ചർച്ചിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3969.jpeg",
    },
    {
      src: "assets/img/Pastevents/3970.jpeg",
      caption:
        "വിതുര പബ്ലിക് ക്യാമ്പസ് മിനിസ്ട്രി, മാങ്കല സെവെന്ത് ഡേ അഡ്വന്റിസ്റ്റ് ചർച്ചിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3970.jpeg",
    },
    {
      src: "assets/img/Pastevents/3960.jpeg",
      caption:
        "വാഴിച്ചൽ ശ്രീ മാരാൻവിള ദേവി ക്ഷേത്ര ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെ സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. സംഘടിപ്പ.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3960.jpeg",
    },
    {
      src: "assets/img/Pastevents/3961.jpeg",
      caption:
        "വാഴിച്ചൽ ശ്രീ മാരാൻവിള ദേവി ക്ഷേത്ര ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെ സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. സംഘടിപ്പ.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3961.jpeg",
    },
    {
      src: "assets/img/Pastevents/3962.jpeg",
      caption:
        "വാഴിച്ചൽ ശ്രീ മാരാൻവിള ദേവി ക്ഷേത്ര ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെ സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. സംഘടിപ്പ.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3962.jpeg",
    },
    {
      src: "assets/img/Pastevents/3963.jpeg",
      caption:
        "വാഴിച്ചൽ ശ്രീ മാരാൻവിള ദേവി ക്ഷേത്ര ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെ സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. സംഘടിപ്പ.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3963.jpeg",
    },
    {
      src: "assets/img/Pastevents/3964.jpeg",
      caption:
        "വാഴിച്ചൽ ശ്രീ മാരാൻവിള ദേവി ക്ഷേത്ര ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെ സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. സംഘടിപ്പ.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3964.jpeg",
    },
    {
      src: "assets/img/Pastevents/3953.jpeg",
      caption:
        "മാരായമുട്ടം ശ്രീ നീലകേശി ക്ഷേത്ര ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെ സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ആതുര സേവന രംഗത്ത് മികച്ച പ്രവർത്തനം കാഴ്ചവയ്ക്കുന്ന നെയ്യാറ്റിൻകര നിംസ് മെഡിസിറ്റിക്ക് മാരായമുട്ടം ശ്രീ നീലകേശി ക്ഷേത്രം ട്രസ്റ്റിന്റെ ആദരവ് ഏറ്റുവാങ്ങി.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3953.jpeg",
    },
    {
      src: "assets/img/Pastevents/3954.jpeg",
      caption:
        "മാരായമുട്ടം ശ്രീ നീലകേശി ക്ഷേത്ര ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെ സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ആതുര സേവന രംഗത്ത് മികച്ച പ്രവർത്തനം കാഴ്ചവയ്ക്കുന്ന നെയ്യാറ്റിൻകര നിംസ് മെഡിസിറ്റിക്ക് മാരായമുട്ടം ശ്രീ നീലകേശി ക്ഷേത്രം ട്രസ്റ്റിന്റെ ആദരവ് ഏറ്റുവാങ്ങി.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3954.jpeg",
    },
    {
      src: "assets/img/Pastevents/3955.jpeg",
      caption:
        "മാരായമുട്ടം ശ്രീ നീലകേശി ക്ഷേത്ര ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെ സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ആതുര സേവന രംഗത്ത് മികച്ച പ്രവർത്തനം കാഴ്ചവയ്ക്കുന്ന നെയ്യാറ്റിൻകര നിംസ് മെഡിസിറ്റിക്ക് മാരായമുട്ടം ശ്രീ നീലകേശി ക്ഷേത്രം ട്രസ്റ്റിന്റെ ആദരവ് ഏറ്റുവാങ്ങി.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3955.jpeg",
    },
    {
      src: "assets/img/Pastevents/3956.jpeg",
      caption:
        "മാരായമുട്ടം ശ്രീ നീലകേശി ക്ഷേത്ര ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെ സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ആതുര സേവന രംഗത്ത് മികച്ച പ്രവർത്തനം കാഴ്ചവയ്ക്കുന്ന നെയ്യാറ്റിൻകര നിംസ് മെഡിസിറ്റിക്ക് മാരായമുട്ടം ശ്രീ നീലകേശി ക്ഷേത്രം ട്രസ്റ്റിന്റെ ആദരവ് ഏറ്റുവാങ്ങി.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3956.jpeg",
    },
    {
      src: "assets/img/Pastevents/3957.jpeg",
      caption:
        "മാരായമുട്ടം ശ്രീ നീലകേശി ക്ഷേത്ര ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെ സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ആതുര സേവന രംഗത്ത് മികച്ച പ്രവർത്തനം കാഴ്ചവയ്ക്കുന്ന നെയ്യാറ്റിൻകര നിംസ് മെഡിസിറ്റിക്ക് മാരായമുട്ടം ശ്രീ നീലകേശി ക്ഷേത്രം ട്രസ്റ്റിന്റെ ആദരവ് ഏറ്റുവാങ്ങി.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3957.jpeg",
    },
    {
      src: "assets/img/Pastevents/3958.jpeg",
      caption:
        "മാരായമുട്ടം ശ്രീ നീലകേശി ക്ഷേത്ര ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെ സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ആതുര സേവന രംഗത്ത് മികച്ച പ്രവർത്തനം കാഴ്ചവയ്ക്കുന്ന നെയ്യാറ്റിൻകര നിംസ് മെഡിസിറ്റിക്ക് മാരായമുട്ടം ശ്രീ നീലകേശി ക്ഷേത്രം ട്രസ്റ്റിന്റെ ആദരവ് ഏറ്റുവാങ്ങി.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3958.jpeg",
    },
    {
      src: "assets/img/Pastevents/3959.jpeg",
      caption:
        "മാരായമുട്ടം ശ്രീ നീലകേശി ക്ഷേത്ര ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെ സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ആതുര സേവന രംഗത്ത് മികച്ച പ്രവർത്തനം കാഴ്ചവയ്ക്കുന്ന നെയ്യാറ്റിൻകര നിംസ് മെഡിസിറ്റിക്ക് മാരായമുട്ടം ശ്രീ നീലകേശി ക്ഷേത്രം ട്രസ്റ്റിന്റെ ആദരവ് ഏറ്റുവാങ്ങി.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3959.jpeg",
    },
    {
      src: "assets/img/Pastevents/3945.jpeg",
      caption:
        "ആറ്റുകാൽ പൊങ്കാല മഹോത്സവത്തോട് അനുബന്ധിച്ച് തലസ്ഥാനത്തിൻ്റെ വിവിധ ഭാഗങ്ങളിൽ പൊങ്കാല ദിവസം നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ സൗജന്യ  ആംബുലൻസ് സർവീസും മെഡിക്കൽ ക്യാമ്പും സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/3945.jpeg",
    },
    {
      src: "assets/img/Pastevents/3946.jpeg",
      caption:
        "ആറ്റുകാൽ പൊങ്കാല മഹോത്സവത്തോട് അനുബന്ധിച്ച് തലസ്ഥാനത്തിൻ്റെ വിവിധ ഭാഗങ്ങളിൽ പൊങ്കാല ദിവസം നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ സൗജന്യ  ആംബുലൻസ് സർവീസും മെഡിക്കൽ ക്യാമ്പും സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/3946.jpeg",
    },
    {
      src: "assets/img/Pastevents/3947.jpeg",
      caption:
        "ആറ്റുകാൽ പൊങ്കാല മഹോത്സവത്തോട് അനുബന്ധിച്ച് തലസ്ഥാനത്തിൻ്റെ വിവിധ ഭാഗങ്ങളിൽ പൊങ്കാല ദിവസം നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ സൗജന്യ  ആംബുലൻസ് സർവീസും മെഡിക്കൽ ക്യാമ്പും സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/3947.jpeg",
    },
    {
      src: "assets/img/Pastevents/3948.jpeg",
      caption:
        "ആറ്റുകാൽ പൊങ്കാല മഹോത്സവത്തോട് അനുബന്ധിച്ച് തലസ്ഥാനത്തിൻ്റെ വിവിധ ഭാഗങ്ങളിൽ പൊങ്കാല ദിവസം നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ സൗജന്യ  ആംബുലൻസ് സർവീസും മെഡിക്കൽ ക്യാമ്പും സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/3948.jpeg",
    },
    {
      src: "assets/img/Pastevents/3949.jpeg",
      caption:
        "ആറ്റുകാൽ പൊങ്കാല മഹോത്സവത്തോട് അനുബന്ധിച്ച് തലസ്ഥാനത്തിൻ്റെ വിവിധ ഭാഗങ്ങളിൽ പൊങ്കാല ദിവസം നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ സൗജന്യ  ആംബുലൻസ് സർവീസും മെഡിക്കൽ ക്യാമ്പും സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/3949.jpeg",
    },
    {
      src: "assets/img/Pastevents/3950.jpeg",
      caption:
        "ആറ്റുകാൽ പൊങ്കാല മഹോത്സവത്തോട് അനുബന്ധിച്ച് തലസ്ഥാനത്തിൻ്റെ വിവിധ ഭാഗങ്ങളിൽ പൊങ്കാല ദിവസം നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ സൗജന്യ  ആംബുലൻസ് സർവീസും മെഡിക്കൽ ക്യാമ്പും സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/3950.jpeg",
    },
    {
      src: "assets/img/Pastevents/3951.jpeg",
      caption:
        "ആറ്റുകാൽ പൊങ്കാല മഹോത്സവത്തോട് അനുബന്ധിച്ച് തലസ്ഥാനത്തിൻ്റെ വിവിധ ഭാഗങ്ങളിൽ പൊങ്കാല ദിവസം നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ സൗജന്യ  ആംബുലൻസ് സർവീസും മെഡിക്കൽ ക്യാമ്പും സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/3951.jpeg",
    },
    {
      src: "assets/img/Pastevents/3952.jpeg",
      caption:
        "ആറ്റുകാൽ പൊങ്കാല മഹോത്സവത്തോട് അനുബന്ധിച്ച് തലസ്ഥാനത്തിൻ്റെ വിവിധ ഭാഗങ്ങളിൽ പൊങ്കാല ദിവസം നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ സൗജന്യ  ആംബുലൻസ് സർവീസും മെഡിക്കൽ ക്യാമ്പും സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/3952.jpeg",
    },
    {
      src: "assets/img/Pastevents/3938.jpeg",
      caption:
        "മൈലച്ചൽ ശ്രീ ഭദ്രകാളി ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെ സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3938.jpeg",
    },
    {
      src: "assets/img/Pastevents/3939.jpeg",
      caption:
        "മൈലച്ചൽ ശ്രീ ഭദ്രകാളി ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെ സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3939.jpeg",
    },
    {
      src: "assets/img/Pastevents/3940.jpeg",
      caption:
        "മൈലച്ചൽ ശ്രീ ഭദ്രകാളി ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെ സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3940.jpeg",
    },
    {
      src: "assets/img/Pastevents/3941.jpeg",
      caption:
        "മൈലച്ചൽ ശ്രീ ഭദ്രകാളി ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെ സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3941.jpeg",
    },
    {
      src: "assets/img/Pastevents/3942.jpeg",
      caption:
        "മൈലച്ചൽ ശ്രീ ഭദ്രകാളി ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെ സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3942.jpeg",
    },
    {
      src: "assets/img/Pastevents/3943.jpeg",
      caption:
        "മൈലച്ചൽ ശ്രീ ഭദ്രകാളി ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെ സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3943.jpeg",
    },
    {
      src: "assets/img/Pastevents/3944.jpeg",
      caption:
        "മൈലച്ചൽ ശ്രീ ഭദ്രകാളി ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെ സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3944.jpeg",
    },
    {
      src: "assets/img/Pastevents/3933.jpeg",
      caption:
        "ഊരുട്ടുക്കാല ശ്രീ ഭദ്രകാളി ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3933.jpeg",
    },
    {
      src: "assets/img/Pastevents/3934.jpeg",
      caption:
        "ഊരുട്ടുക്കാല ശ്രീ ഭദ്രകാളി ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3934.jpeg",
    },
    {
      src: "assets/img/Pastevents/3935.jpeg",
      caption:
        "ഊരുട്ടുക്കാല ശ്രീ ഭദ്രകാളി ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3935.jpeg",
    },
    {
      src: "assets/img/Pastevents/3936.jpeg",
      caption:
        "ഊരുട്ടുക്കാല ശ്രീ ഭദ്രകാളി ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3936.jpeg",
    },
    {
      src: "assets/img/Pastevents/3937.jpeg",
      caption:
        "ഊരുട്ടുക്കാല ശ്രീ ഭദ്രകാളി ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3937.jpeg",
    },
    {
      src: "assets/img/Pastevents/3928.jpeg",
      caption:
        "മുരുക്കുംപുഴ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.മെഡിക്കൽ ക്യാമ്പിൻ്റെ ഉദ്ഘാടനം ബഹുമാനപ്പെട്ട എം പി അടൂർ പ്രകാശ് നിർവഹിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3928.jpeg",
    },
    {
      src: "assets/img/Pastevents/3929.jpeg",
      caption:
        "മുരുക്കുംപുഴ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.മെഡിക്കൽ ക്യാമ്പിൻ്റെ ഉദ്ഘാടനം ബഹുമാനപ്പെട്ട എം പി അടൂർ പ്രകാശ് നിർവഹിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3929.jpeg",
    },
    {
      src: "assets/img/Pastevents/3930.jpeg",
      caption:
        "മുരുക്കുംപുഴ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.മെഡിക്കൽ ക്യാമ്പിൻ്റെ ഉദ്ഘാടനം ബഹുമാനപ്പെട്ട എം പി അടൂർ പ്രകാശ് നിർവഹിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3930.jpeg",
    },
    {
      src: "assets/img/Pastevents/3931.jpeg",
      caption:
        "മുരുക്കുംപുഴ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.മെഡിക്കൽ ക്യാമ്പിൻ്റെ ഉദ്ഘാടനം ബഹുമാനപ്പെട്ട എം പി അടൂർ പ്രകാശ് നിർവഹിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3931.jpeg",
    },
    {
      src: "assets/img/Pastevents/3932.jpeg",
      caption:
        "മുരുക്കുംപുഴ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.മെഡിക്കൽ ക്യാമ്പിൻ്റെ ഉദ്ഘാടനം ബഹുമാനപ്പെട്ട എം പി അടൂർ പ്രകാശ് നിർവഹിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3932.jpeg",
    },
    {
      src: "assets/img/Pastevents/3927.jpeg",
      caption:
        "തച്ചോട്ടുക്കാവ് റെസിഡൻഷ്യൽ അസോസിയേഷൻ, മലയിൻകീഴ് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3927.jpeg",
    },
    {
      src: "assets/img/Pastevents/3923.jpeg",
      caption:
        "തച്ചോട്ടുക്കാവ് റെസിഡൻഷ്യൽ അസോസിയേഷൻ, മലയിൻകീഴ് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3923.jpeg",
    },
    {
      src: "assets/img/Pastevents/3924.jpeg",
      caption:
        "തച്ചോട്ടുക്കാവ് റെസിഡൻഷ്യൽ അസോസിയേഷൻ, മലയിൻകീഴ് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3924.jpeg",
    },
    {
      src: "assets/img/Pastevents/3925.jpeg",
      caption:
        "തച്ചോട്ടുക്കാവ് റെസിഡൻഷ്യൽ അസോസിയേഷൻ, മലയിൻകീഴ് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3925.jpeg",
    },
    {
      src: "assets/img/Pastevents/3926.jpeg",
      caption:
        "തച്ചോട്ടുക്കാവ് റെസിഡൻഷ്യൽ അസോസിയേഷൻ, മലയിൻകീഴ് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3926.jpeg",
    },
    {
      src: "assets/img/Pastevents/3922.jpeg",
      caption:
        "34-ാംസ്വലാത്ത്‌ വാർഷികത്തോട്‌ അനുബന്ധിച്ച് വിതുര മുസ്‌ലിം ജുമാ മസ്ജിദിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3922.jpeg",
    },
    {
      src: "assets/img/Pastevents/3917.jpeg",
      caption:
        "34-ാംസ്വലാത്ത്‌ വാർഷികത്തോട്‌ അനുബന്ധിച്ച് വിതുര മുസ്‌ലിം ജുമാ മസ്ജിദിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3917.jpeg",
    },
    {
      src: "assets/img/Pastevents/3918.jpeg",
      caption:
        "34-ാംസ്വലാത്ത്‌ വാർഷികത്തോട്‌ അനുബന്ധിച്ച് വിതുര മുസ്‌ലിം ജുമാ മസ്ജിദിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3918.jpeg",
    },
    {
      src: "assets/img/Pastevents/3919.jpeg",
      caption:
        "34-ാംസ്വലാത്ത്‌ വാർഷികത്തോട്‌ അനുബന്ധിച്ച് വിതുര മുസ്‌ലിം ജുമാ മസ്ജിദിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3919.jpeg",
    },
    {
      src: "assets/img/Pastevents/3920.jpeg",
      caption:
        "34-ാംസ്വലാത്ത്‌ വാർഷികത്തോട്‌ അനുബന്ധിച്ച് വിതുര മുസ്‌ലിം ജുമാ മസ്ജിദിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3920.jpeg",
    },
    {
      src: "assets/img/Pastevents/3921.jpeg",
      caption:
        "34-ാംസ്വലാത്ത്‌ വാർഷികത്തോട്‌ അനുബന്ധിച്ച് വിതുര മുസ്‌ലിം ജുമാ മസ്ജിദിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3921.jpeg",
    },
    {
      src: "assets/img/Pastevents/3912.jpeg",
      caption:
        "ഉഴമലയ്ക്കൽ ശ്രീ ലക്ഷ്മി മംഗലം ദേവി ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3912.jpeg",
    },
    {
      src: "assets/img/Pastevents/3913.jpeg",
      caption:
        "ഉഴമലയ്ക്കൽ ശ്രീ ലക്ഷ്മി മംഗലം ദേവി ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3913.jpeg",
    },
    {
      src: "assets/img/Pastevents/3914.jpeg",
      caption:
        "ഉഴമലയ്ക്കൽ ശ്രീ ലക്ഷ്മി മംഗലം ദേവി ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3914.jpeg",
    },
    {
      src: "assets/img/Pastevents/3915.jpeg",
      caption:
        "ഉഴമലയ്ക്കൽ ശ്രീ ലക്ഷ്മി മംഗലം ദേവി ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3915.jpeg",
    },
    {
      src: "assets/img/Pastevents/3916.jpeg",
      caption:
        "ഉഴമലയ്ക്കൽ ശ്രീ ലക്ഷ്മി മംഗലം ദേവി ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3916.jpeg",
    },
    {
      src: "assets/img/Pastevents/3907.jpeg",
      caption:
        "കാഞ്ഞിരംകുളം ചാണി ക്രിസ്തു രാജാ ദേവാലയത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3907.jpeg",
    },
    {
      src: "assets/img/Pastevents/3908.jpeg",
      caption:
        "കാഞ്ഞിരംകുളം ചാണി ക്രിസ്തു രാജാ ദേവാലയത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3908.jpeg",
    },
    {
      src: "assets/img/Pastevents/3909.jpeg",
      caption:
        "കാഞ്ഞിരംകുളം ചാണി ക്രിസ്തു രാജാ ദേവാലയത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3909.jpeg",
    },
    {
      src: "assets/img/Pastevents/3910.jpeg",
      caption:
        "കാഞ്ഞിരംകുളം ചാണി ക്രിസ്തു രാജാ ദേവാലയത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3910.jpeg",
    },
    {
      src: "assets/img/Pastevents/3900.jpeg",
      caption:
        "ശാസ്താംകോട്ട ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3900.jpeg",
    },
    {
      src: "assets/img/Pastevents/3901.jpeg",
      caption:
        "ശാസ്താംകോട്ട ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3901.jpeg",
    },
    {
      src: "assets/img/Pastevents/3902.jpeg",
      caption:
        "ശാസ്താംകോട്ട ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3902.jpeg",
    },
    {
      src: "assets/img/Pastevents/3903.jpeg",
      caption:
        "ശാസ്താംകോട്ട ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3903.jpeg",
    },
    {
      src: "assets/img/Pastevents/3904.jpeg",
      caption:
        "ശാസ്താംകോട്ട ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3904.jpeg",
    },
    {
      src: "assets/img/Pastevents/3905.jpeg",
      caption:
        "ശാസ്താംകോട്ട ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3905.jpeg",
    },
    {
      src: "assets/img/Pastevents/3906.jpeg",
      caption:
        "ശാസ്താംകോട്ട ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3906.jpeg",
    },
    {
      src: "assets/img/Pastevents/3894.jpeg",
      caption:
        "ചിറയിൻകീഴ് ആശ്രയ വയോജന കേന്ദ്രം,ചിറയിൻകീഴ് ലയൺസ് ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3894.jpeg",
    },
    {
      src: "assets/img/Pastevents/3895.jpeg",
      caption:
        "ചിറയിൻകീഴ് ആശ്രയ വയോജന കേന്ദ്രം,ചിറയിൻകീഴ് ലയൺസ് ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3895.jpeg",
    },
    {
      src: "assets/img/Pastevents/3896.jpeg",
      caption:
        "ചിറയിൻകീഴ് ആശ്രയ വയോജന കേന്ദ്രം,ചിറയിൻകീഴ് ലയൺസ് ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3896.jpeg",
    },
    {
      src: "assets/img/Pastevents/3897.jpeg",
      caption:
        "ചിറയിൻകീഴ് ആശ്രയ വയോജന കേന്ദ്രം,ചിറയിൻകീഴ് ലയൺസ് ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3897.jpeg",
    },
    {
      src: "assets/img/Pastevents/3898.jpeg",
      caption:
        "ചിറയിൻകീഴ് ആശ്രയ വയോജന കേന്ദ്രം,ചിറയിൻകീഴ് ലയൺസ് ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3898.jpeg",
    },
    {
      src: "assets/img/Pastevents/3899.jpeg",
      caption:
        "ചിറയിൻകീഴ് ആശ്രയ വയോജന കേന്ദ്രം,ചിറയിൻകീഴ് ലയൺസ് ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3899.jpeg",
    },
    {
      src: "assets/img/Pastevents/3888.jpeg",
      caption:
        "തത്തിയൂർ ശ്രീ ശിവ ഭഗവതി ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3888.jpeg",
    },
    {
      src: "assets/img/Pastevents/3889.jpeg",
      caption:
        "തത്തിയൂർ ശ്രീ ശിവ ഭഗവതി ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3889.jpeg",
    },
    {
      src: "assets/img/Pastevents/3890.jpeg",
      caption:
        "തത്തിയൂർ ശ്രീ ശിവ ഭഗവതി ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3890.jpeg",
    },
    {
      src: "assets/img/Pastevents/3891.jpeg",
      caption:
        "തത്തിയൂർ ശ്രീ ശിവ ഭഗവതി ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3891.jpeg",
    },
    {
      src: "assets/img/Pastevents/3892.jpeg",
      caption:
        "തത്തിയൂർ ശ്രീ ശിവ ഭഗവതി ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3892.jpeg",
    },
    {
      src: "assets/img/Pastevents/3893.jpeg",
      caption:
        "തത്തിയൂർ ശ്രീ ശിവ ഭഗവതി ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3893.jpeg",
    },
    {
      src: "assets/img/Pastevents/3883.jpeg",
      caption:
        "ട്രിവാൻഡ്രം സേവ് തി പ്രൊട്ടക്ഷൻ കൗൺസിൽ, തൊഴുവൻക്കോട് ദേവി ക്ഷേത്ര ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3883.jpeg",
    },
    {
      src: "assets/img/Pastevents/3884.jpeg",
      caption:
        "ട്രിവാൻഡ്രം സേവ് തി പ്രൊട്ടക്ഷൻ കൗൺസിൽ, തൊഴുവൻക്കോട് ദേവി ക്ഷേത്ര ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3884.jpeg",
    },
    {
      src: "assets/img/Pastevents/3885.jpeg",
      caption:
        "ട്രിവാൻഡ്രം സേവ് തി പ്രൊട്ടക്ഷൻ കൗൺസിൽ, തൊഴുവൻക്കോട് ദേവി ക്ഷേത്ര ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3885.jpeg",
    },
    {
      src: "assets/img/Pastevents/3886.jpeg",
      caption:
        "ട്രിവാൻഡ്രം സേവ് തി പ്രൊട്ടക്ഷൻ കൗൺസിൽ, തൊഴുവൻക്കോട് ദേവി ക്ഷേത്ര ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3886.jpeg",
    },
    {
      src: "assets/img/Pastevents/3887.jpeg",
      caption:
        "ട്രിവാൻഡ്രം സേവ് തി പ്രൊട്ടക്ഷൻ കൗൺസിൽ, തൊഴുവൻക്കോട് ദേവി ക്ഷേത്ര ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3887.jpeg",
    },
    {
      src: "assets/img/Pastevents/3876.jpeg",
      caption:
        "നെട്ടയം ജൻ ഔഷധി കേന്ദ്രം, ഒക്ടാൽ ലബോറിത്തോറി, വട്ടിയൂർക്കാവ് മോഡൽ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3876.jpeg",
    },
    {
      src: "assets/img/Pastevents/3877.jpeg",
      caption:
        "നെട്ടയം ജൻ ഔഷധി കേന്ദ്രം, ഒക്ടാൽ ലബോറിത്തോറി, വട്ടിയൂർക്കാവ് മോഡൽ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3877.jpeg",
    },
    {
      src: "assets/img/Pastevents/3878.jpeg",
      caption:
        "നെട്ടയം ജൻ ഔഷധി കേന്ദ്രം, ഒക്ടാൽ ലബോറിത്തോറി, വട്ടിയൂർക്കാവ് മോഡൽ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3878.jpeg",
    },
    {
      src: "assets/img/Pastevents/3879.jpeg",
      caption:
        "നെട്ടയം ജൻ ഔഷധി കേന്ദ്രം, ഒക്ടാൽ ലബോറിത്തോറി, വട്ടിയൂർക്കാവ് മോഡൽ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3879.jpeg",
    },
    {
      src: "assets/img/Pastevents/3880.jpeg",
      caption:
        "നെട്ടയം ജൻ ഔഷധി കേന്ദ്രം, ഒക്ടാൽ ലബോറിത്തോറി, വട്ടിയൂർക്കാവ് മോഡൽ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3880.jpeg",
    },
    {
      src: "assets/img/Pastevents/3881.jpeg",
      caption:
        "നെട്ടയം ജൻ ഔഷധി കേന്ദ്രം, ഒക്ടാൽ ലബോറിത്തോറി, വട്ടിയൂർക്കാവ് മോഡൽ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3881.jpeg",
    },
    {
      src: "assets/img/Pastevents/3882.jpeg",
      caption:
        "നെട്ടയം ജൻ ഔഷധി കേന്ദ്രം, ഒക്ടാൽ ലബോറിത്തോറി, വട്ടിയൂർക്കാവ് മോഡൽ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3882.jpeg",
    },
    {
      src: "assets/img/Pastevents/3870.jpeg",
      caption:
        "തമിഴ്നാട് ഹെൽത്ത് ഇൻഷുറൻസ് സ്കീം, കാപ്പിക്കാട് ശ്രീകൃഷ്ണ ശ്രീ ഭദ്രകാളി ക്ഷേത്ര ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3870.jpeg",
    },
    {
      src: "assets/img/Pastevents/3871.jpeg",
      caption:
        "തമിഴ്നാട് ഹെൽത്ത് ഇൻഷുറൻസ് സ്കീം, കാപ്പിക്കാട് ശ്രീകൃഷ്ണ ശ്രീ ഭദ്രകാളി ക്ഷേത്ര ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3871.jpeg",
    },
    {
      src: "assets/img/Pastevents/3872.jpeg",
      caption:
        "തമിഴ്നാട് ഹെൽത്ത് ഇൻഷുറൻസ് സ്കീം, കാപ്പിക്കാട് ശ്രീകൃഷ്ണ ശ്രീ ഭദ്രകാളി ക്ഷേത്ര ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3872.jpeg",
    },
    {
      src: "assets/img/Pastevents/3873.jpeg",
      caption:
        "തമിഴ്നാട് ഹെൽത്ത് ഇൻഷുറൻസ് സ്കീം, കാപ്പിക്കാട് ശ്രീകൃഷ്ണ ശ്രീ ഭദ്രകാളി ക്ഷേത്ര ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3873.jpeg",
    },
    {
      src: "assets/img/Pastevents/3874.jpeg",
      caption:
        "തമിഴ്നാട് ഹെൽത്ത് ഇൻഷുറൻസ് സ്കീം, കാപ്പിക്കാട് ശ്രീകൃഷ്ണ ശ്രീ ഭദ്രകാളി ക്ഷേത്ര ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3874.jpeg",
    },
    {
      src: "assets/img/Pastevents/3875.jpeg",
      caption:
        "തമിഴ്നാട് ഹെൽത്ത് ഇൻഷുറൻസ് സ്കീം, കാപ്പിക്കാട് ശ്രീകൃഷ്ണ ശ്രീ ഭദ്രകാളി ക്ഷേത്ര ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3875.jpeg",
    },
    {
      src: "assets/img/Pastevents/3864.jpeg",
      caption:
        "ഇടത്തേക്കോണം ജനത ക്ലബ്,പയറ്റുവിള ശ്രീ ചാമുണ്ഡി ദേവി ക്ഷേത്ര ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3864.jpeg",
    },
    {
      src: "assets/img/Pastevents/3865.jpeg",
      caption:
        "ഇടത്തേക്കോണം ജനത ക്ലബ്,പയറ്റുവിള ശ്രീ ചാമുണ്ഡി ദേവി ക്ഷേത്ര ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3865.jpeg",
    },
    {
      src: "assets/img/Pastevents/3866.jpeg",
      caption:
        "ഇടത്തേക്കോണം ജനത ക്ലബ്,പയറ്റുവിള ശ്രീ ചാമുണ്ഡി ദേവി ക്ഷേത്ര ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3866.jpeg",
    },
    {
      src: "assets/img/Pastevents/3867.jpeg",
      caption:
        "ഇടത്തേക്കോണം ജനത ക്ലബ്,പയറ്റുവിള ശ്രീ ചാമുണ്ഡി ദേവി ക്ഷേത്ര ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3867.jpeg",
    },
    {
      src: "assets/img/Pastevents/3868.jpeg",
      caption:
        "ഇടത്തേക്കോണം ജനത ക്ലബ്,പയറ്റുവിള ശ്രീ ചാമുണ്ഡി ദേവി ക്ഷേത്ര ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3868.jpeg",
    },
    {
      src: "assets/img/Pastevents/3869.jpeg",
      caption:
        "ഇടത്തേക്കോണം ജനത ക്ലബ്,പയറ്റുവിള ശ്രീ ചാമുണ്ഡി ദേവി ക്ഷേത്ര ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3869.jpeg",
    },
    {
      src: "assets/img/Pastevents/3856.jpeg",
      caption:
        "ക്യാമ്പിൽ സ്പെഷ്യൽ എഡ്യൂക്കേറ്റർ, ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ദന്തൽ,ഓഡിയോജി ഒഫ്താൽമോളജി, കൗൺസിലിംഗ് തുടങ്ങിയ വിഭാഗങ്ങളുടെ സേവനങ്ങൾ ഉണ്ടായിരുന്നു. ചെങ്കൽപഞ്ചായത്ത് പ്രസിഡന്റ് ശ്രീമതി  ഗിരിജ ചടങ്ങ് ഉദ്ഘാടനം ചെയ്തു.ചെങ്കൽ പഞ്ചായത്തിലെ 18 വയസ്സിൽ താഴെ പ്രായമുള്ള എല്ലാ ഭിന്നശേഷി കുട്ടികളേയും  നെയ്യാറ്റിൻകര പെൻഷൻ പ്ളാനിൽ ഉൾപ്പെടുത്തുകയും മറ്റ് ആനുകൂല്യങ്ങൾ നൽകി ഒട്ടനവധി ജീവ കാരുണ്യ പ്രവർത്തനങ്ങൾക്ക് നേതൃത്വം നൽകി നടപ്പിലാക്കി കൊണ്ടിരിക്കുന്ന നിംസ് മെഡിസിറ്റി മാനേജിംഗ് ഡയറക്ടർ ശ്രീ എം എസ് ഫൈസൽ ഖാൻ സാറിന്  നന്ദിയും കടപ്പാടും രേഖപ്പെടുത്തി. വൈസ് പ്രസിഡന്റ് ശ്രീ അജിത്ത് കുമാർ സ്വാഗതം ആശംസിച്ചു.നിംസ് ജറിയാട്രിക് കോഡിനേറ്റർ ശ്രീമതി രേണു.കെ.ആർ. പെൻഷൻ പ്ലാൻ വിശദീകരണവും, വികസന സ്റ്റാൻഡിങ് കമ്മിറ്റി ചെയർപേഴ്സൺ ശ്രീമതി . ത്രേസ്യ സിൽവിസ്റ്റർ, പോളിയോ ഹോം മുൻ കെയർടേക്കർ ശ്രീ ബോബി സർ തുടങ്ങിയവർ ആശംസയും ചെങ്കൽ പഞ്ചായത്ത് ആരോഗ്യ സ്റ്റാൻഡിംഗ് കമ്മിറ്റി ചെയർപേഴ്സൺ ശ്രീമതി പ്രമീള കൃതജ്ഞതയും ആശംസിച്ചു.",
      thumb: "assets/img/Pastevents/3856.jpeg",
    },
    {
      src: "assets/img/Pastevents/3857.jpeg",
      caption:
        "ക്യാമ്പിൽ സ്പെഷ്യൽ എഡ്യൂക്കേറ്റർ, ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ദന്തൽ,ഓഡിയോജി ഒഫ്താൽമോളജി, കൗൺസിലിംഗ് തുടങ്ങിയ വിഭാഗങ്ങളുടെ സേവനങ്ങൾ ഉണ്ടായിരുന്നു. ചെങ്കൽപഞ്ചായത്ത് പ്രസിഡന്റ് ശ്രീമതി  ഗിരിജ ചടങ്ങ് ഉദ്ഘാടനം ചെയ്തു.ചെങ്കൽ പഞ്ചായത്തിലെ 18 വയസ്സിൽ താഴെ പ്രായമുള്ള എല്ലാ ഭിന്നശേഷി കുട്ടികളേയും  നെയ്യാറ്റിൻകര പെൻഷൻ പ്ളാനിൽ ഉൾപ്പെടുത്തുകയും മറ്റ് ആനുകൂല്യങ്ങൾ നൽകി ഒട്ടനവധി ജീവ കാരുണ്യ പ്രവർത്തനങ്ങൾക്ക് നേതൃത്വം നൽകി നടപ്പിലാക്കി കൊണ്ടിരിക്കുന്ന നിംസ് മെഡിസിറ്റി മാനേജിംഗ് ഡയറക്ടർ ശ്രീ എം എസ് ഫൈസൽ ഖാൻ സാറിന്  നന്ദിയും കടപ്പാടും രേഖപ്പെടുത്തി. വൈസ് പ്രസിഡന്റ് ശ്രീ അജിത്ത് കുമാർ സ്വാഗതം ആശംസിച്ചു.നിംസ് ജറിയാട്രിക് കോഡിനേറ്റർ ശ്രീമതി രേണു.കെ.ആർ. പെൻഷൻ പ്ലാൻ വിശദീകരണവും, വികസന സ്റ്റാൻഡിങ് കമ്മിറ്റി ചെയർപേഴ്സൺ ശ്രീമതി . ത്രേസ്യ സിൽവിസ്റ്റർ, പോളിയോ ഹോം മുൻ കെയർടേക്കർ ശ്രീ ബോബി സർ തുടങ്ങിയവർ ആശംസയും ചെങ്കൽ പഞ്ചായത്ത് ആരോഗ്യ സ്റ്റാൻഡിംഗ് കമ്മിറ്റി ചെയർപേഴ്സൺ ശ്രീമതി പ്രമീള കൃതജ്ഞതയും ആശംസിച്ചു.",
      thumb: "assets/img/Pastevents/3857.jpeg",
    },
    {
      src: "assets/img/Pastevents/3858.jpeg",
      caption:
        "ക്യാമ്പിൽ സ്പെഷ്യൽ എഡ്യൂക്കേറ്റർ, ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ദന്തൽ,ഓഡിയോജി ഒഫ്താൽമോളജി, കൗൺസിലിംഗ് തുടങ്ങിയ വിഭാഗങ്ങളുടെ സേവനങ്ങൾ ഉണ്ടായിരുന്നു. ചെങ്കൽപഞ്ചായത്ത് പ്രസിഡന്റ് ശ്രീമതി  ഗിരിജ ചടങ്ങ് ഉദ്ഘാടനം ചെയ്തു.ചെങ്കൽ പഞ്ചായത്തിലെ 18 വയസ്സിൽ താഴെ പ്രായമുള്ള എല്ലാ ഭിന്നശേഷി കുട്ടികളേയും  നെയ്യാറ്റിൻകര പെൻഷൻ പ്ളാനിൽ ഉൾപ്പെടുത്തുകയും മറ്റ് ആനുകൂല്യങ്ങൾ നൽകി ഒട്ടനവധി ജീവ കാരുണ്യ പ്രവർത്തനങ്ങൾക്ക് നേതൃത്വം നൽകി നടപ്പിലാക്കി കൊണ്ടിരിക്കുന്ന നിംസ് മെഡിസിറ്റി മാനേജിംഗ് ഡയറക്ടർ ശ്രീ എം എസ് ഫൈസൽ ഖാൻ സാറിന്  നന്ദിയും കടപ്പാടും രേഖപ്പെടുത്തി. വൈസ് പ്രസിഡന്റ് ശ്രീ അജിത്ത് കുമാർ സ്വാഗതം ആശംസിച്ചു.നിംസ് ജറിയാട്രിക് കോഡിനേറ്റർ ശ്രീമതി രേണു.കെ.ആർ. പെൻഷൻ പ്ലാൻ വിശദീകരണവും, വികസന സ്റ്റാൻഡിങ് കമ്മിറ്റി ചെയർപേഴ്സൺ ശ്രീമതി . ത്രേസ്യ സിൽവിസ്റ്റർ, പോളിയോ ഹോം മുൻ കെയർടേക്കർ ശ്രീ ബോബി സർ തുടങ്ങിയവർ ആശംസയും ചെങ്കൽ പഞ്ചായത്ത് ആരോഗ്യ സ്റ്റാൻഡിംഗ് കമ്മിറ്റി ചെയർപേഴ്സൺ ശ്രീമതി പ്രമീള കൃതജ്ഞതയും ആശംസിച്ചു.",
      thumb: "assets/img/Pastevents/3858.jpeg",
    },
    {
      src: "assets/img/Pastevents/3859.jpeg",
      caption:
        "ക്യാമ്പിൽ സ്പെഷ്യൽ എഡ്യൂക്കേറ്റർ, ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ദന്തൽ,ഓഡിയോജി ഒഫ്താൽമോളജി, കൗൺസിലിംഗ് തുടങ്ങിയ വിഭാഗങ്ങളുടെ സേവനങ്ങൾ ഉണ്ടായിരുന്നു. ചെങ്കൽപഞ്ചായത്ത് പ്രസിഡന്റ് ശ്രീമതി  ഗിരിജ ചടങ്ങ് ഉദ്ഘാടനം ചെയ്തു.ചെങ്കൽ പഞ്ചായത്തിലെ 18 വയസ്സിൽ താഴെ പ്രായമുള്ള എല്ലാ ഭിന്നശേഷി കുട്ടികളേയും  നെയ്യാറ്റിൻകര പെൻഷൻ പ്ളാനിൽ ഉൾപ്പെടുത്തുകയും മറ്റ് ആനുകൂല്യങ്ങൾ നൽകി ഒട്ടനവധി ജീവ കാരുണ്യ പ്രവർത്തനങ്ങൾക്ക് നേതൃത്വം നൽകി നടപ്പിലാക്കി കൊണ്ടിരിക്കുന്ന നിംസ് മെഡിസിറ്റി മാനേജിംഗ് ഡയറക്ടർ ശ്രീ എം എസ് ഫൈസൽ ഖാൻ സാറിന്  നന്ദിയും കടപ്പാടും രേഖപ്പെടുത്തി. വൈസ് പ്രസിഡന്റ് ശ്രീ അജിത്ത് കുമാർ സ്വാഗതം ആശംസിച്ചു.നിംസ് ജറിയാട്രിക് കോഡിനേറ്റർ ശ്രീമതി രേണു.കെ.ആർ. പെൻഷൻ പ്ലാൻ വിശദീകരണവും, വികസന സ്റ്റാൻഡിങ് കമ്മിറ്റി ചെയർപേഴ്സൺ ശ്രീമതി . ത്രേസ്യ സിൽവിസ്റ്റർ, പോളിയോ ഹോം മുൻ കെയർടേക്കർ ശ്രീ ബോബി സർ തുടങ്ങിയവർ ആശംസയും ചെങ്കൽ പഞ്ചായത്ത് ആരോഗ്യ സ്റ്റാൻഡിംഗ് കമ്മിറ്റി ചെയർപേഴ്സൺ ശ്രീമതി പ്രമീള കൃതജ്ഞതയും ആശംസിച്ചു.",
      thumb: "assets/img/Pastevents/3859.jpeg",
    },
    {
      src: "assets/img/Pastevents/3860.jpeg",
      caption:
        "ക്യാമ്പിൽ സ്പെഷ്യൽ എഡ്യൂക്കേറ്റർ, ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ദന്തൽ,ഓഡിയോജി ഒഫ്താൽമോളജി, കൗൺസിലിംഗ് തുടങ്ങിയ വിഭാഗങ്ങളുടെ സേവനങ്ങൾ ഉണ്ടായിരുന്നു. ചെങ്കൽപഞ്ചായത്ത് പ്രസിഡന്റ് ശ്രീമതി  ഗിരിജ ചടങ്ങ് ഉദ്ഘാടനം ചെയ്തു.ചെങ്കൽ പഞ്ചായത്തിലെ 18 വയസ്സിൽ താഴെ പ്രായമുള്ള എല്ലാ ഭിന്നശേഷി കുട്ടികളേയും  നെയ്യാറ്റിൻകര പെൻഷൻ പ്ളാനിൽ ഉൾപ്പെടുത്തുകയും മറ്റ് ആനുകൂല്യങ്ങൾ നൽകി ഒട്ടനവധി ജീവ കാരുണ്യ പ്രവർത്തനങ്ങൾക്ക് നേതൃത്വം നൽകി നടപ്പിലാക്കി കൊണ്ടിരിക്കുന്ന നിംസ് മെഡിസിറ്റി മാനേജിംഗ് ഡയറക്ടർ ശ്രീ എം എസ് ഫൈസൽ ഖാൻ സാറിന്  നന്ദിയും കടപ്പാടും രേഖപ്പെടുത്തി. വൈസ് പ്രസിഡന്റ് ശ്രീ അജിത്ത് കുമാർ സ്വാഗതം ആശംസിച്ചു.നിംസ് ജറിയാട്രിക് കോഡിനേറ്റർ ശ്രീമതി രേണു.കെ.ആർ. പെൻഷൻ പ്ലാൻ വിശദീകരണവും, വികസന സ്റ്റാൻഡിങ് കമ്മിറ്റി ചെയർപേഴ്സൺ ശ്രീമതി . ത്രേസ്യ സിൽവിസ്റ്റർ, പോളിയോ ഹോം മുൻ കെയർടേക്കർ ശ്രീ ബോബി സർ തുടങ്ങിയവർ ആശംസയും ചെങ്കൽ പഞ്ചായത്ത് ആരോഗ്യ സ്റ്റാൻഡിംഗ് കമ്മിറ്റി ചെയർപേഴ്സൺ ശ്രീമതി പ്രമീള കൃതജ്ഞതയും ആശംസിച്ചു.",
      thumb: "assets/img/Pastevents/3860.jpeg",
    },
    {
      src: "assets/img/Pastevents/3861.jpeg",
      caption:
        "ക്യാമ്പിൽ സ്പെഷ്യൽ എഡ്യൂക്കേറ്റർ, ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ദന്തൽ,ഓഡിയോജി ഒഫ്താൽമോളജി, കൗൺസിലിംഗ് തുടങ്ങിയ വിഭാഗങ്ങളുടെ സേവനങ്ങൾ ഉണ്ടായിരുന്നു. ചെങ്കൽപഞ്ചായത്ത് പ്രസിഡന്റ് ശ്രീമതി  ഗിരിജ ചടങ്ങ് ഉദ്ഘാടനം ചെയ്തു.ചെങ്കൽ പഞ്ചായത്തിലെ 18 വയസ്സിൽ താഴെ പ്രായമുള്ള എല്ലാ ഭിന്നശേഷി കുട്ടികളേയും  നെയ്യാറ്റിൻകര പെൻഷൻ പ്ളാനിൽ ഉൾപ്പെടുത്തുകയും മറ്റ് ആനുകൂല്യങ്ങൾ നൽകി ഒട്ടനവധി ജീവ കാരുണ്യ പ്രവർത്തനങ്ങൾക്ക് നേതൃത്വം നൽകി നടപ്പിലാക്കി കൊണ്ടിരിക്കുന്ന നിംസ് മെഡിസിറ്റി മാനേജിംഗ് ഡയറക്ടർ ശ്രീ എം എസ് ഫൈസൽ ഖാൻ സാറിന്  നന്ദിയും കടപ്പാടും രേഖപ്പെടുത്തി. വൈസ് പ്രസിഡന്റ് ശ്രീ അജിത്ത് കുമാർ സ്വാഗതം ആശംസിച്ചു.നിംസ് ജറിയാട്രിക് കോഡിനേറ്റർ ശ്രീമതി രേണു.കെ.ആർ. പെൻഷൻ പ്ലാൻ വിശദീകരണവും, വികസന സ്റ്റാൻഡിങ് കമ്മിറ്റി ചെയർപേഴ്സൺ ശ്രീമതി . ത്രേസ്യ സിൽവിസ്റ്റർ, പോളിയോ ഹോം മുൻ കെയർടേക്കർ ശ്രീ ബോബി സർ തുടങ്ങിയവർ ആശംസയും ചെങ്കൽ പഞ്ചായത്ത് ആരോഗ്യ സ്റ്റാൻഡിംഗ് കമ്മിറ്റി ചെയർപേഴ്സൺ ശ്രീമതി പ്രമീള കൃതജ്ഞതയും ആശംസിച്ചു.",
      thumb: "assets/img/Pastevents/3861.jpeg",
    },
    {
      src: "assets/img/Pastevents/3862.jpeg",
      caption:
        "ക്യാമ്പിൽ സ്പെഷ്യൽ എഡ്യൂക്കേറ്റർ, ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ദന്തൽ,ഓഡിയോജി ഒഫ്താൽമോളജി, കൗൺസിലിംഗ് തുടങ്ങിയ വിഭാഗങ്ങളുടെ സേവനങ്ങൾ ഉണ്ടായിരുന്നു. ചെങ്കൽപഞ്ചായത്ത് പ്രസിഡന്റ് ശ്രീമതി  ഗിരിജ ചടങ്ങ് ഉദ്ഘാടനം ചെയ്തു.ചെങ്കൽ പഞ്ചായത്തിലെ 18 വയസ്സിൽ താഴെ പ്രായമുള്ള എല്ലാ ഭിന്നശേഷി കുട്ടികളേയും  നെയ്യാറ്റിൻകര പെൻഷൻ പ്ളാനിൽ ഉൾപ്പെടുത്തുകയും മറ്റ് ആനുകൂല്യങ്ങൾ നൽകി ഒട്ടനവധി ജീവ കാരുണ്യ പ്രവർത്തനങ്ങൾക്ക് നേതൃത്വം നൽകി നടപ്പിലാക്കി കൊണ്ടിരിക്കുന്ന നിംസ് മെഡിസിറ്റി മാനേജിംഗ് ഡയറക്ടർ ശ്രീ എം എസ് ഫൈസൽ ഖാൻ സാറിന്  നന്ദിയും കടപ്പാടും രേഖപ്പെടുത്തി. വൈസ് പ്രസിഡന്റ് ശ്രീ അജിത്ത് കുമാർ സ്വാഗതം ആശംസിച്ചു.നിംസ് ജറിയാട്രിക് കോഡിനേറ്റർ ശ്രീമതി രേണു.കെ.ആർ. പെൻഷൻ പ്ലാൻ വിശദീകരണവും, വികസന സ്റ്റാൻഡിങ് കമ്മിറ്റി ചെയർപേഴ്സൺ ശ്രീമതി . ത്രേസ്യ സിൽവിസ്റ്റർ, പോളിയോ ഹോം മുൻ കെയർടേക്കർ ശ്രീ ബോബി സർ തുടങ്ങിയവർ ആശംസയും ചെങ്കൽ പഞ്ചായത്ത് ആരോഗ്യ സ്റ്റാൻഡിംഗ് കമ്മിറ്റി ചെയർപേഴ്സൺ ശ്രീമതി പ്രമീള കൃതജ്ഞതയും ആശംസിച്ചു.",
      thumb: "assets/img/Pastevents/3862.jpeg",
    },
    {
      src: "assets/img/Pastevents/3863.jpeg",
      caption:
        "ക്യാമ്പിൽ സ്പെഷ്യൽ എഡ്യൂക്കേറ്റർ, ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ദന്തൽ,ഓഡിയോജി ഒഫ്താൽമോളജി, കൗൺസിലിംഗ് തുടങ്ങിയ വിഭാഗങ്ങളുടെ സേവനങ്ങൾ ഉണ്ടായിരുന്നു. ചെങ്കൽപഞ്ചായത്ത് പ്രസിഡന്റ് ശ്രീമതി  ഗിരിജ ചടങ്ങ് ഉദ്ഘാടനം ചെയ്തു.ചെങ്കൽ പഞ്ചായത്തിലെ 18 വയസ്സിൽ താഴെ പ്രായമുള്ള എല്ലാ ഭിന്നശേഷി കുട്ടികളേയും  നെയ്യാറ്റിൻകര പെൻഷൻ പ്ളാനിൽ ഉൾപ്പെടുത്തുകയും മറ്റ് ആനുകൂല്യങ്ങൾ നൽകി ഒട്ടനവധി ജീവ കാരുണ്യ പ്രവർത്തനങ്ങൾക്ക് നേതൃത്വം നൽകി നടപ്പിലാക്കി കൊണ്ടിരിക്കുന്ന നിംസ് മെഡിസിറ്റി മാനേജിംഗ് ഡയറക്ടർ ശ്രീ എം എസ് ഫൈസൽ ഖാൻ സാറിന്  നന്ദിയും കടപ്പാടും രേഖപ്പെടുത്തി. വൈസ് പ്രസിഡന്റ് ശ്രീ അജിത്ത് കുമാർ സ്വാഗതം ആശംസിച്ചു.നിംസ് ജറിയാട്രിക് കോഡിനേറ്റർ ശ്രീമതി രേണു.കെ.ആർ. പെൻഷൻ പ്ലാൻ വിശദീകരണവും, വികസന സ്റ്റാൻഡിങ് കമ്മിറ്റി ചെയർപേഴ്സൺ ശ്രീമതി . ത്രേസ്യ സിൽവിസ്റ്റർ, പോളിയോ ഹോം മുൻ കെയർടേക്കർ ശ്രീ ബോബി സർ തുടങ്ങിയവർ ആശംസയും ചെങ്കൽ പഞ്ചായത്ത് ആരോഗ്യ സ്റ്റാൻഡിംഗ് കമ്മിറ്റി ചെയർപേഴ്സൺ ശ്രീമതി പ്രമീള കൃതജ്ഞതയും ആശംസിച്ചു.",
      thumb: "assets/img/Pastevents/3863.jpeg",
    },
    {
      src: "assets/img/Pastevents/3849.jpeg",
      caption: "",
      thumb: "assets/img/Pastevents/3849.jpeg",
    },
    {
      src: "assets/img/Pastevents/3850.jpeg",
      caption: "",
      thumb: "assets/img/Pastevents/3850.jpeg",
    },
    {
      src: "assets/img/Pastevents/3851.jpeg",
      caption: "",
      thumb: "assets/img/Pastevents/3851.jpeg",
    },
    {
      src: "assets/img/Pastevents/3852.jpeg",
      caption: "",
      thumb: "assets/img/Pastevents/3852.jpeg",
    },
    {
      src: "assets/img/Pastevents/3853.jpeg",
      caption: "",
      thumb: "assets/img/Pastevents/3853.jpeg",
    },
    {
      src: "assets/img/Pastevents/3854.jpeg",
      caption: "",
      thumb: "assets/img/Pastevents/3854.jpeg",
    },
    {
      src: "assets/img/Pastevents/3855.jpeg",
      caption: "",
      thumb: "assets/img/Pastevents/3855.jpeg",
    },
    {
      src: "assets/img/Pastevents/3842.jpeg",
      caption:
        "പാറശ്ശാല പബ്ലിക് ക്യാമ്പസ് മിനിസ്ട്രി, മുരിയങ്കര സെവെന്ത് ഡേ അഡ്വന്റിസ്റ്റ് ചർച്ചിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3842.jpeg",
    },
    {
      src: "assets/img/Pastevents/3843.jpeg",
      caption:
        "പാറശ്ശാല പബ്ലിക് ക്യാമ്പസ് മിനിസ്ട്രി, മുരിയങ്കര സെവെന്ത് ഡേ അഡ്വന്റിസ്റ്റ് ചർച്ചിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3843.jpeg",
    },
    {
      src: "assets/img/Pastevents/3844.jpeg",
      caption:
        "പാറശ്ശാല പബ്ലിക് ക്യാമ്പസ് മിനിസ്ട്രി, മുരിയങ്കര സെവെന്ത് ഡേ അഡ്വന്റിസ്റ്റ് ചർച്ചിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3844.jpeg",
    },
    {
      src: "assets/img/Pastevents/3845.jpeg",
      caption:
        "പാറശ്ശാല പബ്ലിക് ക്യാമ്പസ് മിനിസ്ട്രി, മുരിയങ്കര സെവെന്ത് ഡേ അഡ്വന്റിസ്റ്റ് ചർച്ചിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3845.jpeg",
    },
    {
      src: "assets/img/Pastevents/3846.jpeg",
      caption:
        "പാറശ്ശാല പബ്ലിക് ക്യാമ്പസ് മിനിസ്ട്രി, മുരിയങ്കര സെവെന്ത് ഡേ അഡ്വന്റിസ്റ്റ് ചർച്ചിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3846.jpeg",
    },
    {
      src: "assets/img/Pastevents/3847.jpeg",
      caption:
        "പാറശ്ശാല പബ്ലിക് ക്യാമ്പസ് മിനിസ്ട്രി, മുരിയങ്കര സെവെന്ത് ഡേ അഡ്വന്റിസ്റ്റ് ചർച്ചിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3847.jpeg",
    },
    {
      src: "assets/img/Pastevents/3848.jpeg",
      caption:
        "പാറശ്ശാല പബ്ലിക് ക്യാമ്പസ് മിനിസ്ട്രി, മുരിയങ്കര സെവെന്ത് ഡേ അഡ്വന്റിസ്റ്റ് ചർച്ചിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3848.jpeg",
    },
    {
      src: "assets/img/Pastevents/3835.jpeg",
      caption:
        "നെടുമങ്ങാട് മുനിസിപ്പാലിറ്റി, വാണ്ട മുഖവുർ വാർഡ് കമ്മിറ്റി, ട്രിവാൻഡ്രം നോർത്ത് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3835.jpeg",
    },
    {
      src: "assets/img/Pastevents/3836.jpeg",
      caption:
        "നെടുമങ്ങാട് മുനിസിപ്പാലിറ്റി, വാണ്ട മുഖവുർ വാർഡ് കമ്മിറ്റി, ട്രിവാൻഡ്രം നോർത്ത് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3836.jpeg",
    },
    {
      src: "assets/img/Pastevents/3837.jpeg",
      caption:
        "നെടുമങ്ങാട് മുനിസിപ്പാലിറ്റി, വാണ്ട മുഖവുർ വാർഡ് കമ്മിറ്റി, ട്രിവാൻഡ്രം നോർത്ത് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3837.jpeg",
    },
    {
      src: "assets/img/Pastevents/3838.jpeg",
      caption:
        "നെടുമങ്ങാട് മുനിസിപ്പാലിറ്റി, വാണ്ട മുഖവുർ വാർഡ് കമ്മിറ്റി, ട്രിവാൻഡ്രം നോർത്ത് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3838.jpeg",
    },
    {
      src: "assets/img/Pastevents/3839.jpeg",
      caption:
        "നെടുമങ്ങാട് മുനിസിപ്പാലിറ്റി, വാണ്ട മുഖവുർ വാർഡ് കമ്മിറ്റി, ട്രിവാൻഡ്രം നോർത്ത് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3839.jpeg",
    },
    {
      src: "assets/img/Pastevents/3840.jpeg",
      caption:
        "നെടുമങ്ങാട് മുനിസിപ്പാലിറ്റി, വാണ്ട മുഖവുർ വാർഡ് കമ്മിറ്റി, ട്രിവാൻഡ്രം നോർത്ത് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3840.jpeg",
    },
    {
      src: "assets/img/Pastevents/3841.jpeg",
      caption:
        "നെടുമങ്ങാട് മുനിസിപ്പാലിറ്റി, വാണ്ട മുഖവുർ വാർഡ് കമ്മിറ്റി, ട്രിവാൻഡ്രം നോർത്ത് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3841.jpeg",
    },
    {
      src: "assets/img/Pastevents/3829.jpeg",
      caption:
        "ട്രിവാൻഡ്രം രാജധാനി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3829.jpeg",
    },
    {
      src: "assets/img/Pastevents/3830.jpeg",
      caption:
        "ട്രിവാൻഡ്രം രാജധാനി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3830.jpeg",
    },
    {
      src: "assets/img/Pastevents/3831.jpeg",
      caption:
        "ട്രിവാൻഡ്രം രാജധാനി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/383.jpeg",
    },
    {
      src: "assets/img/Pastevents/3832.jpeg",
      caption:
        "ട്രിവാൻഡ്രം രാജധാനി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3832.jpeg",
    },
    {
      src: "assets/img/Pastevents/3833.jpeg",
      caption:
        "ട്രിവാൻഡ്രം രാജധാനി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3833.jpeg",
    },
    {
      src: "assets/img/Pastevents/3834.jpeg",
      caption:
        "ട്രിവാൻഡ്രം രാജധാനി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3834.jpeg",
    },
    {
      src: "assets/img/Pastevents/3822.jpeg",
      caption:
        "പെൻഷൻ പ്ലാൻ മെഡികെയർ-2024. വിളപ്പിൽ പഞ്ചായത്തിലെ ഭിന്നശേഷിക്കാർക്കും വയോജനങ്ങൾക്കും പ്രത്യേക പരിഗണന നൽകി കൊണ്ട് വിളപ്പിൽ പഞ്ചായത്തിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പും ബോധവത്കരണവും സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3822.jpeg",
    },
    {
      src: "assets/img/Pastevents/3823.jpeg",
      caption:
        "പെൻഷൻ പ്ലാൻ മെഡികെയർ-2024. വിളപ്പിൽ പഞ്ചായത്തിലെ ഭിന്നശേഷിക്കാർക്കും വയോജനങ്ങൾക്കും പ്രത്യേക പരിഗണന നൽകി കൊണ്ട് വിളപ്പിൽ പഞ്ചായത്തിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പും ബോധവത്കരണവും സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3823.jpeg",
    },
    {
      src: "assets/img/Pastevents/3824.jpeg",
      caption:
        "പെൻഷൻ പ്ലാൻ മെഡികെയർ-2024. വിളപ്പിൽ പഞ്ചായത്തിലെ ഭിന്നശേഷിക്കാർക്കും വയോജനങ്ങൾക്കും പ്രത്യേക പരിഗണന നൽകി കൊണ്ട് വിളപ്പിൽ പഞ്ചായത്തിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പും ബോധവത്കരണവും സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3824.jpeg",
    },
    {
      src: "assets/img/Pastevents/3825.jpeg",
      caption:
        "പെൻഷൻ പ്ലാൻ മെഡികെയർ-2024. വിളപ്പിൽ പഞ്ചായത്തിലെ ഭിന്നശേഷിക്കാർക്കും വയോജനങ്ങൾക്കും പ്രത്യേക പരിഗണന നൽകി കൊണ്ട് വിളപ്പിൽ പഞ്ചായത്തിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പും ബോധവത്കരണവും സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3825.jpeg",
    },
    {
      src: "assets/img/Pastevents/3826.jpeg",
      caption:
        "പെൻഷൻ പ്ലാൻ മെഡികെയർ-2024. വിളപ്പിൽ പഞ്ചായത്തിലെ ഭിന്നശേഷിക്കാർക്കും വയോജനങ്ങൾക്കും പ്രത്യേക പരിഗണന നൽകി കൊണ്ട് വിളപ്പിൽ പഞ്ചായത്തിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പും ബോധവത്കരണവും സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3826.jpeg",
    },
    {
      src: "assets/img/Pastevents/3827.jpeg",
      caption:
        "പെൻഷൻ പ്ലാൻ മെഡികെയർ-2024. വിളപ്പിൽ പഞ്ചായത്തിലെ ഭിന്നശേഷിക്കാർക്കും വയോജനങ്ങൾക്കും പ്രത്യേക പരിഗണന നൽകി കൊണ്ട് വിളപ്പിൽ പഞ്ചായത്തിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പും ബോധവത്കരണവും സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3827.jpeg",
    },
    {
      src: "assets/img/Pastevents/3828.jpeg",
      caption:
        "പെൻഷൻ പ്ലാൻ മെഡികെയർ-2024. വിളപ്പിൽ പഞ്ചായത്തിലെ ഭിന്നശേഷിക്കാർക്കും വയോജനങ്ങൾക്കും പ്രത്യേക പരിഗണന നൽകി കൊണ്ട് വിളപ്പിൽ പഞ്ചായത്തിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പും ബോധവത്കരണവും സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3828.jpeg",
    },
    {
      src: "assets/img/Pastevents/3815.jpeg",
      caption:
        "ജീവദായിനി -2024 കൊല്ലംക്കോണം ശ്രീ യക്ഷി അമ്മൻ ദേവി ക്ഷേത്ര ട്രസ്റ്റ്,കൊല്ലംക്കോണം വിവേകാനന്ദ സാംസ്കാരിക വേദി സംയുക്തമായി നടത്തുന്ന ജീവദായിനിയുടെ ജീവകാരുണ്യ പ്രവർത്തനങ്ങളുടെ 6 - വാർഷികവും സൗജന്യ മെഡിക്കൽ ക്യാമ്പും ചികിത്സാ സഹായ വിതരണവും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ നടന്നു.ജീവദായനിയുടെ ചികിത്സാസഹായ വിതരണം നിംസ് മെഡിസിറ്റി ജനറൽ മാനേജർ Dr സജു നിർവഹിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3815.jpeg",
    },
    {
      src: "assets/img/Pastevents/3816.jpeg",
      caption:
        "ജീവദായിനി -2024 കൊല്ലംക്കോണം ശ്രീ യക്ഷി അമ്മൻ ദേവി ക്ഷേത്ര ട്രസ്റ്റ്,കൊല്ലംക്കോണം വിവേകാനന്ദ സാംസ്കാരിക വേദി സംയുക്തമായി നടത്തുന്ന ജീവദായിനിയുടെ ജീവകാരുണ്യ പ്രവർത്തനങ്ങളുടെ 6 - വാർഷികവും സൗജന്യ മെഡിക്കൽ ക്യാമ്പും ചികിത്സാ സഹായ വിതരണവും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ നടന്നു.ജീവദായനിയുടെ ചികിത്സാസഹായ വിതരണം നിംസ് മെഡിസിറ്റി ജനറൽ മാനേജർ Dr സജു നിർവഹിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3816.jpeg",
    },
    {
      src: "assets/img/Pastevents/3817.jpeg",
      caption:
        "ജീവദായിനി -2024 കൊല്ലംക്കോണം ശ്രീ യക്ഷി അമ്മൻ ദേവി ക്ഷേത്ര ട്രസ്റ്റ്,കൊല്ലംക്കോണം വിവേകാനന്ദ സാംസ്കാരിക വേദി സംയുക്തമായി നടത്തുന്ന ജീവദായിനിയുടെ ജീവകാരുണ്യ പ്രവർത്തനങ്ങളുടെ 6 - വാർഷികവും സൗജന്യ മെഡിക്കൽ ക്യാമ്പും ചികിത്സാ സഹായ വിതരണവും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ നടന്നു.ജീവദായനിയുടെ ചികിത്സാസഹായ വിതരണം നിംസ് മെഡിസിറ്റി ജനറൽ മാനേജർ Dr സജു നിർവഹിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3817.jpeg",
    },
    {
      src: "assets/img/Pastevents/3818.jpeg",
      caption:
        "ജീവദായിനി -2024 കൊല്ലംക്കോണം ശ്രീ യക്ഷി അമ്മൻ ദേവി ക്ഷേത്ര ട്രസ്റ്റ്,കൊല്ലംക്കോണം വിവേകാനന്ദ സാംസ്കാരിക വേദി സംയുക്തമായി നടത്തുന്ന ജീവദായിനിയുടെ ജീവകാരുണ്യ പ്രവർത്തനങ്ങളുടെ 6 - വാർഷികവും സൗജന്യ മെഡിക്കൽ ക്യാമ്പും ചികിത്സാ സഹായ വിതരണവും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ നടന്നു.ജീവദായനിയുടെ ചികിത്സാസഹായ വിതരണം നിംസ് മെഡിസിറ്റി ജനറൽ മാനേജർ Dr സജു നിർവഹിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3818.jpeg",
    },
    {
      src: "assets/img/Pastevents/3819.jpeg",
      caption:
        "ജീവദായിനി -2024 കൊല്ലംക്കോണം ശ്രീ യക്ഷി അമ്മൻ ദേവി ക്ഷേത്ര ട്രസ്റ്റ്,കൊല്ലംക്കോണം വിവേകാനന്ദ സാംസ്കാരിക വേദി സംയുക്തമായി നടത്തുന്ന ജീവദായിനിയുടെ ജീവകാരുണ്യ പ്രവർത്തനങ്ങളുടെ 6 - വാർഷികവും സൗജന്യ മെഡിക്കൽ ക്യാമ്പും ചികിത്സാ സഹായ വിതരണവും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ നടന്നു.ജീവദായനിയുടെ ചികിത്സാസഹായ വിതരണം നിംസ് മെഡിസിറ്റി ജനറൽ മാനേജർ Dr സജു നിർവഹിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3819.jpeg",
    },
    {
      src: "assets/img/Pastevents/3820.jpeg",
      caption:
        "ജീവദായിനി -2024 കൊല്ലംക്കോണം ശ്രീ യക്ഷി അമ്മൻ ദേവി ക്ഷേത്ര ട്രസ്റ്റ്,കൊല്ലംക്കോണം വിവേകാനന്ദ സാംസ്കാരിക വേദി സംയുക്തമായി നടത്തുന്ന ജീവദായിനിയുടെ ജീവകാരുണ്യ പ്രവർത്തനങ്ങളുടെ 6 - വാർഷികവും സൗജന്യ മെഡിക്കൽ ക്യാമ്പും ചികിത്സാ സഹായ വിതരണവും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ നടന്നു.ജീവദായനിയുടെ ചികിത്സാസഹായ വിതരണം നിംസ് മെഡിസിറ്റി ജനറൽ മാനേജർ Dr സജു നിർവഹിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3820.jpeg",
    },
    {
      src: "assets/img/Pastevents/3821.jpeg",
      caption:
        "ജീവദായിനി -2024 കൊല്ലംക്കോണം ശ്രീ യക്ഷി അമ്മൻ ദേവി ക്ഷേത്ര ട്രസ്റ്റ്,കൊല്ലംക്കോണം വിവേകാനന്ദ സാംസ്കാരിക വേദി സംയുക്തമായി നടത്തുന്ന ജീവദായിനിയുടെ ജീവകാരുണ്യ പ്രവർത്തനങ്ങളുടെ 6 - വാർഷികവും സൗജന്യ മെഡിക്കൽ ക്യാമ്പും ചികിത്സാ സഹായ വിതരണവും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ നടന്നു.ജീവദായനിയുടെ ചികിത്സാസഹായ വിതരണം നിംസ് മെഡിസിറ്റി ജനറൽ മാനേജർ Dr സജു നിർവഹിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3821.jpeg",
    },
    {
      src: "assets/img/Pastevents/3809.jpeg",
      caption:
        "തമിഴ്നാട് ഗവൺമെൻ്റ് ഇൻഷുറൻസ് സ്കീം, മരിയഗിരി മലങ്കര കാത്തലിക് കോളേജ് എൻഎസ്എസ് യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3809.jpeg",
    },
    {
      src: "assets/img/Pastevents/3810.jpeg",
      caption:
        "തമിഴ്നാട് ഗവൺമെൻ്റ് ഇൻഷുറൻസ് സ്കീം, മരിയഗിരി മലങ്കര കാത്തലിക് കോളേജ് എൻഎസ്എസ് യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3810.jpeg",
    },
    {
      src: "assets/img/Pastevents/3811.jpeg",
      caption:
        "തമിഴ്നാട് ഗവൺമെൻ്റ് ഇൻഷുറൻസ് സ്കീം, മരിയഗിരി മലങ്കര കാത്തലിക് കോളേജ് എൻഎസ്എസ് യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3811.jpeg",
    },
    {
      src: "assets/img/Pastevents/3812.jpeg",
      caption:
        "തമിഴ്നാട് ഗവൺമെൻ്റ് ഇൻഷുറൻസ് സ്കീം, മരിയഗിരി മലങ്കര കാത്തലിക് കോളേജ് എൻഎസ്എസ് യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3812.jpeg",
    },
    {
      src: "assets/img/Pastevents/3813.jpeg",
      caption:
        "തമിഴ്നാട് ഗവൺമെൻ്റ് ഇൻഷുറൻസ് സ്കീം, മരിയഗിരി മലങ്കര കാത്തലിക് കോളേജ് എൻഎസ്എസ് യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3813.jpeg",
    },
    {
      src: "assets/img/Pastevents/3814.jpeg",
      caption:
        "തമിഴ്നാട് ഗവൺമെൻ്റ് ഇൻഷുറൻസ് സ്കീം, മരിയഗിരി മലങ്കര കാത്തലിക് കോളേജ് എൻഎസ്എസ് യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3814.jpeg",
    },
    {
      src: "assets/img/Pastevents/3804.jpeg",
      caption:
        "കുക്കുറുണി ശ്രീ ശാസ്താ ക്ഷേത്ര ദേവസ്വത്തിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3804.jpeg",
    },
    {
      src: "assets/img/Pastevents/3805.jpeg",
      caption:
        "കുക്കുറുണി ശ്രീ ശാസ്താ ക്ഷേത്ര ദേവസ്വത്തിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3805.jpeg",
    },
    {
      src: "assets/img/Pastevents/3806.jpeg",
      caption:
        "കുക്കുറുണി ശ്രീ ശാസ്താ ക്ഷേത്ര ദേവസ്വത്തിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3806.jpeg",
    },
    {
      src: "assets/img/Pastevents/3807.jpeg",
      caption:
        "കുക്കുറുണി ശ്രീ ശാസ്താ ക്ഷേത്ര ദേവസ്വത്തിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3807.jpeg",
    },
    {
      src: "assets/img/Pastevents/3808.jpeg",
      caption:
        "കുക്കുറുണി ശ്രീ ശാസ്താ ക്ഷേത്ര ദേവസ്വത്തിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3808.jpeg",
    },
    {
      src: "assets/img/Pastevents/3799.jpeg",
      caption:
        "വട്ടിയൂർക്കാവ് മൂന്നാംമ്മൂട് റെസിഡൻഷ്യൽ അസോസിയേഷൻ,ട്രിവാൻഡ്രം പ്ലാറ്റിനം ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3799.jpeg",
    },
    {
      src: "assets/img/Pastevents/3800.jpeg",
      caption:
        "വട്ടിയൂർക്കാവ് മൂന്നാംമ്മൂട് റെസിഡൻഷ്യൽ അസോസിയേഷൻ,ട്രിവാൻഡ്രം പ്ലാറ്റിനം ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3800.jpeg",
    },
    {
      src: "assets/img/Pastevents/3801.jpeg",
      caption:
        "വട്ടിയൂർക്കാവ് മൂന്നാംമ്മൂട് റെസിഡൻഷ്യൽ അസോസിയേഷൻ,ട്രിവാൻഡ്രം പ്ലാറ്റിനം ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3801.jpeg",
    },
    {
      src: "assets/img/Pastevents/3802.jpeg",
      caption:
        "വട്ടിയൂർക്കാവ് മൂന്നാംമ്മൂട് റെസിഡൻഷ്യൽ അസോസിയേഷൻ,ട്രിവാൻഡ്രം പ്ലാറ്റിനം ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3802.jpeg",
    },
    {
      src: "assets/img/Pastevents/3803.jpeg",
      caption:
        "വട്ടിയൂർക്കാവ് മൂന്നാംമ്മൂട് റെസിഡൻഷ്യൽ അസോസിയേഷൻ,ട്രിവാൻഡ്രം പ്ലാറ്റിനം ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3803.jpeg",
    },
    {
      src: "assets/img/Pastevents/3793.jpeg",
      caption:
        "മാറനല്ലൂർ ദൈവയോഗ സംഘം ആശ്രമം,ട്രിവാൻഡ്രം വൈസ്മാൻ ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3793.jpeg",
    },
    {
      src: "assets/img/Pastevents/3794.jpeg",
      caption:
        "മാറനല്ലൂർ ദൈവയോഗ സംഘം ആശ്രമം,ട്രിവാൻഡ്രം വൈസ്മാൻ ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3794.jpeg",
    },
    {
      src: "assets/img/Pastevents/3795.jpeg",
      caption:
        "മാറനല്ലൂർ ദൈവയോഗ സംഘം ആശ്രമം,ട്രിവാൻഡ്രം വൈസ്മാൻ ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3795.jpeg",
    },
    {
      src: "assets/img/Pastevents/3796.jpeg",
      caption:
        "മാറനല്ലൂർ ദൈവയോഗ സംഘം ആശ്രമം,ട്രിവാൻഡ്രം വൈസ്മാൻ ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3796.jpeg",
    },
    {
      src: "assets/img/Pastevents/3797.jpeg",
      caption:
        "മാറനല്ലൂർ ദൈവയോഗ സംഘം ആശ്രമം,ട്രിവാൻഡ്രം വൈസ്മാൻ ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3797.jpeg",
    },
    {
      src: "assets/img/Pastevents/3798.jpeg",
      caption:
        "മാറനല്ലൂർ ദൈവയോഗ സംഘം ആശ്രമം,ട്രിവാൻഡ്രം വൈസ്മാൻ ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3798.jpeg",
    },
    {
      src: "assets/img/Pastevents/3787.jpeg",
      caption:
        "കരമന സത്യ നഗർ റെസിഡൻഷ്യൽ അസോസിയേഷൻ, കരമന ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3787.jpeg",
    },
    {
      src: "assets/img/Pastevents/3788.jpeg",
      caption:
        "കരമന സത്യ നഗർ റെസിഡൻഷ്യൽ അസോസിയേഷൻ, കരമന ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3788.jpeg",
    },
    {
      src: "assets/img/Pastevents/3789.jpeg",
      caption:
        "കരമന സത്യ നഗർ റെസിഡൻഷ്യൽ അസോസിയേഷൻ, കരമന ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3789.jpeg",
    },
    {
      src: "assets/img/Pastevents/3790.jpeg",
      caption:
        "കരമന സത്യ നഗർ റെസിഡൻഷ്യൽ അസോസിയേഷൻ, കരമന ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3790.jpeg",
    },
    {
      src: "assets/img/Pastevents/3791.jpeg",
      caption:
        "കരമന സത്യ നഗർ റെസിഡൻഷ്യൽ അസോസിയേഷൻ, കരമന ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3791.jpeg",
    },
    {
      src: "assets/img/Pastevents/3792.jpeg",
      caption:
        "കരമന സത്യ നഗർ റെസിഡൻഷ്യൽ അസോസിയേഷൻ, കരമന ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3792.jpeg",
    },
    {
      src: "assets/img/Pastevents/3781.jpeg",
      caption:
        "കുളത്തൂപ്പുഴ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3781.jpeg",
    },
    {
      src: "assets/img/Pastevents/3782.jpeg",
      caption:
        "കുളത്തൂപ്പുഴ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3782.jpeg",
    },
    {
      src: "assets/img/Pastevents/3783.jpeg",
      caption:
        "കുളത്തൂപ്പുഴ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3783.jpeg",
    },
    {
      src: "assets/img/Pastevents/3784.jpeg",
      caption:
        "കുളത്തൂപ്പുഴ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3784.jpeg",
    },
    {
      src: "assets/img/Pastevents/3785.jpeg",
      caption:
        "കുളത്തൂപ്പുഴ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3785.jpeg",
    },
    {
      src: "assets/img/Pastevents/3786.jpeg",
      caption:
        "കുളത്തൂപ്പുഴ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3786.jpeg",
    },
    {
      src: "assets/img/Pastevents/3776.jpeg",
      caption:
        "പാലോട് നവോദയ വിദ്യാലയത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3776.jpeg",
    },
    {
      src: "assets/img/Pastevents/3777.jpeg",
      caption:
        "പാലോട് നവോദയ വിദ്യാലയത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3777.jpeg",
    },
    {
      src: "assets/img/Pastevents/3778.jpeg",
      caption:
        "പാലോട് നവോദയ വിദ്യാലയത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3778.jpeg",
    },
    {
      src: "assets/img/Pastevents/3779.jpeg",
      caption:
        "പാലോട് നവോദയ വിദ്യാലയത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3779.jpeg",
    },
    {
      src: "assets/img/Pastevents/3780.jpeg",
      caption:
        "പാലോട് നവോദയ വിദ്യാലയത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3780.jpeg",
    },
    {
      src: "assets/img/Pastevents/3770.jpeg",
      caption:
        "ചിറയിൻകീഴ് കിഴുവലം 4- വാർഡ്,ചിറയിൻകീഴ് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ അടൂർ പ്രകാശ് (എം പി).ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3770.jpeg",
    },
    {
      src: "assets/img/Pastevents/3771.jpeg",
      caption:
        "ചിറയിൻകീഴ് കിഴുവലം 4- വാർഡ്,ചിറയിൻകീഴ് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ അടൂർ പ്രകാശ് (എം പി).ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3771.jpeg",
    },
    {
      src: "assets/img/Pastevents/3772.jpeg",
      caption:
        "ചിറയിൻകീഴ് കിഴുവലം 4- വാർഡ്,ചിറയിൻകീഴ് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ അടൂർ പ്രകാശ് (എം പി).ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3772.jpeg",
    },
    {
      src: "assets/img/Pastevents/3773.jpeg",
      caption:
        "ചിറയിൻകീഴ് കിഴുവലം 4- വാർഡ്,ചിറയിൻകീഴ് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ അടൂർ പ്രകാശ് (എം പി).ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3773.jpeg",
    },
    {
      src: "assets/img/Pastevents/3774.jpeg",
      caption:
        "ചിറയിൻകീഴ് കിഴുവലം 4- വാർഡ്,ചിറയിൻകീഴ് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ അടൂർ പ്രകാശ് (എം പി).ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3774.jpeg",
    },
    {
      src: "assets/img/Pastevents/3775.jpeg",
      caption:
        "ചിറയിൻകീഴ് കിഴുവലം 4- വാർഡ്,ചിറയിൻകീഴ് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ അടൂർ പ്രകാശ് (എം പി).ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3775.jpeg",
    },
    {
      src: "assets/img/Pastevents/3763.jpeg",
      caption:
        "അനന്തപുരി ഹിന്ദു മഹാ സമ്മേളനത്തോടനുബന്ധിച്ച് നിംസ് മെഡിസിറ്റി സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പും ആരോഗ്യ സെമിനാറും സംഘടിപ്പിച്ചു. ആരോഗ്യ സെമിനാറിൽ നിംസ് നേച്ചറോപതി മേധാവി ഡോ ലളിത അപ്പുകുട്ടൻ   ജീവിത  ശൈലീരോഗങ്ങളും ഹോളിസ്റ്റിക് മെഡിസിനും എന്ന വിഷയത്തിൽ സെമിനാർ സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3763.jpeg",
    },
    {
      src: "assets/img/Pastevents/3764.jpeg",
      caption:
        "അനന്തപുരി ഹിന്ദു മഹാ സമ്മേളനത്തോടനുബന്ധിച്ച് നിംസ് മെഡിസിറ്റി സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പും ആരോഗ്യ സെമിനാറും സംഘടിപ്പിച്ചു. ആരോഗ്യ സെമിനാറിൽ നിംസ് നേച്ചറോപതി മേധാവി ഡോ ലളിത അപ്പുകുട്ടൻ   ജീവിത  ശൈലീരോഗങ്ങളും ഹോളിസ്റ്റിക് മെഡിസിനും എന്ന വിഷയത്തിൽ സെമിനാർ സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3764.jpeg",
    },
    {
      src: "assets/img/Pastevents/3765.jpeg",
      caption:
        "അനന്തപുരി ഹിന്ദു മഹാ സമ്മേളനത്തോടനുബന്ധിച്ച് നിംസ് മെഡിസിറ്റി സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പും ആരോഗ്യ സെമിനാറും സംഘടിപ്പിച്ചു. ആരോഗ്യ സെമിനാറിൽ നിംസ് നേച്ചറോപതി മേധാവി ഡോ ലളിത അപ്പുകുട്ടൻ   ജീവിത  ശൈലീരോഗങ്ങളും ഹോളിസ്റ്റിക് മെഡിസിനും എന്ന വിഷയത്തിൽ സെമിനാർ സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3765.jpeg",
    },
    {
      src: "assets/img/Pastevents/3766.jpeg",
      caption:
        "അനന്തപുരി ഹിന്ദു മഹാ സമ്മേളനത്തോടനുബന്ധിച്ച് നിംസ് മെഡിസിറ്റി സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പും ആരോഗ്യ സെമിനാറും സംഘടിപ്പിച്ചു. ആരോഗ്യ സെമിനാറിൽ നിംസ് നേച്ചറോപതി മേധാവി ഡോ ലളിത അപ്പുകുട്ടൻ   ജീവിത  ശൈലീരോഗങ്ങളും ഹോളിസ്റ്റിക് മെഡിസിനും എന്ന വിഷയത്തിൽ സെമിനാർ സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3766.jpeg",
    },
    {
      src: "assets/img/Pastevents/3767.jpeg",
      caption:
        "അനന്തപുരി ഹിന്ദു മഹാ സമ്മേളനത്തോടനുബന്ധിച്ച് നിംസ് മെഡിസിറ്റി സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പും ആരോഗ്യ സെമിനാറും സംഘടിപ്പിച്ചു. ആരോഗ്യ സെമിനാറിൽ നിംസ് നേച്ചറോപതി മേധാവി ഡോ ലളിത അപ്പുകുട്ടൻ   ജീവിത  ശൈലീരോഗങ്ങളും ഹോളിസ്റ്റിക് മെഡിസിനും എന്ന വിഷയത്തിൽ സെമിനാർ സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3767.jpeg",
    },
    {
      src: "assets/img/Pastevents/3768.jpeg",
      caption:
        "അനന്തപുരി ഹിന്ദു മഹാ സമ്മേളനത്തോടനുബന്ധിച്ച് നിംസ് മെഡിസിറ്റി സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പും ആരോഗ്യ സെമിനാറും സംഘടിപ്പിച്ചു. ആരോഗ്യ സെമിനാറിൽ നിംസ് നേച്ചറോപതി മേധാവി ഡോ ലളിത അപ്പുകുട്ടൻ   ജീവിത  ശൈലീരോഗങ്ങളും ഹോളിസ്റ്റിക് മെഡിസിനും എന്ന വിഷയത്തിൽ സെമിനാർ സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3768.jpeg",
    },
    {
      src: "assets/img/Pastevents/3769.jpeg",
      caption:
        "അനന്തപുരി ഹിന്ദു മഹാ സമ്മേളനത്തോടനുബന്ധിച്ച് നിംസ് മെഡിസിറ്റി സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പും ആരോഗ്യ സെമിനാറും സംഘടിപ്പിച്ചു. ആരോഗ്യ സെമിനാറിൽ നിംസ് നേച്ചറോപതി മേധാവി ഡോ ലളിത അപ്പുകുട്ടൻ   ജീവിത  ശൈലീരോഗങ്ങളും ഹോളിസ്റ്റിക് മെഡിസിനും എന്ന വിഷയത്തിൽ സെമിനാർ സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3769.jpeg",
    },
    {
      src: "assets/img/Pastevents/3756.jpeg",
      caption:
        "കഴിവൂർ സി എസ് ഐ ചർച്ചിൻ്റെ 144 മത് സദാദിനാഘോഷത്തോട് അനുബന്ധിച്ച് നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3756.jpeg",
    },
    {
      src: "assets/img/Pastevents/3757.jpeg",
      caption:
        "കഴിവൂർ സി എസ് ഐ ചർച്ചിൻ്റെ 144 മത് സദാദിനാഘോഷത്തോട് അനുബന്ധിച്ച് നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3757.jpeg",
    },
    {
      src: "assets/img/Pastevents/3758.jpeg",
      caption:
        "കഴിവൂർ സി എസ് ഐ ചർച്ചിൻ്റെ 144 മത് സദാദിനാഘോഷത്തോട് അനുബന്ധിച്ച് നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3758.jpeg",
    },
    {
      src: "assets/img/Pastevents/3759.jpeg",
      caption:
        "കഴിവൂർ സി എസ് ഐ ചർച്ചിൻ്റെ 144 മത് സദാദിനാഘോഷത്തോട് അനുബന്ധിച്ച് നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3759.jpeg",
    },
    {
      src: "assets/img/Pastevents/3760.jpeg",
      caption:
        "കഴിവൂർ സി എസ് ഐ ചർച്ചിൻ്റെ 144 മത് സദാദിനാഘോഷത്തോട് അനുബന്ധിച്ച് നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3760.jpeg",
    },
    {
      src: "assets/img/Pastevents/3761.jpeg",
      caption:
        "കഴിവൂർ സി എസ് ഐ ചർച്ചിൻ്റെ 144 മത് സദാദിനാഘോഷത്തോട് അനുബന്ധിച്ച് നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3761.jpeg",
    },
    {
      src: "assets/img/Pastevents/3762.jpeg",
      caption:
        "കഴിവൂർ സി എസ് ഐ ചർച്ചിൻ്റെ 144 മത് സദാദിനാഘോഷത്തോട് അനുബന്ധിച്ച് നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3762.jpeg",
    },
    {
      src: "assets/img/Pastevents/3749.jpeg",
      caption:
        "പച്ച ശ്രീ ധർമ്മ ശാസ്താ റെസിഡൻഷ്യൽ അസോസിയേഷൻ, പാലോട് ജനമൈത്രി പൊലീസ് സ്റ്റേഷൻൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ ഷാജിമോൻ(പാലോട് പോലീസ് ഇൻസ്പെക്ടർ).ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3749.jpeg",
    },
    {
      src: "assets/img/Pastevents/3750.jpeg",
      caption:
        "പച്ച ശ്രീ ധർമ്മ ശാസ്താ റെസിഡൻഷ്യൽ അസോസിയേഷൻ, പാലോട് ജനമൈത്രി പൊലീസ് സ്റ്റേഷൻൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ ഷാജിമോൻ(പാലോട് പോലീസ് ഇൻസ്പെക്ടർ).ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3750.jpeg",
    },
    {
      src: "assets/img/Pastevents/3751.jpeg",
      caption:
        "പച്ച ശ്രീ ധർമ്മ ശാസ്താ റെസിഡൻഷ്യൽ അസോസിയേഷൻ, പാലോട് ജനമൈത്രി പൊലീസ് സ്റ്റേഷൻൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ ഷാജിമോൻ(പാലോട് പോലീസ് ഇൻസ്പെക്ടർ).ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3751.jpeg",
    },
    {
      src: "assets/img/Pastevents/3752.jpeg",
      caption:
        "പച്ച ശ്രീ ധർമ്മ ശാസ്താ റെസിഡൻഷ്യൽ അസോസിയേഷൻ, പാലോട് ജനമൈത്രി പൊലീസ് സ്റ്റേഷൻൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ ഷാജിമോൻ(പാലോട് പോലീസ് ഇൻസ്പെക്ടർ).ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3752.jpeg",
    },
    {
      src: "assets/img/Pastevents/3753.jpeg",
      caption:
        "പച്ച ശ്രീ ധർമ്മ ശാസ്താ റെസിഡൻഷ്യൽ അസോസിയേഷൻ, പാലോട് ജനമൈത്രി പൊലീസ് സ്റ്റേഷൻൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ ഷാജിമോൻ(പാലോട് പോലീസ് ഇൻസ്പെക്ടർ).ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3753.jpeg",
    },
    {
      src: "assets/img/Pastevents/3754.jpeg",
      caption:
        "പച്ച ശ്രീ ധർമ്മ ശാസ്താ റെസിഡൻഷ്യൽ അസോസിയേഷൻ, പാലോട് ജനമൈത്രി പൊലീസ് സ്റ്റേഷൻൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ ഷാജിമോൻ(പാലോട് പോലീസ് ഇൻസ്പെക്ടർ).ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3754.jpeg",
    },
    {
      src: "assets/img/Pastevents/3755.jpeg",
      caption:
        "പച്ച ശ്രീ ധർമ്മ ശാസ്താ റെസിഡൻഷ്യൽ അസോസിയേഷൻ, പാലോട് ജനമൈത്രി പൊലീസ് സ്റ്റേഷൻൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ ഷാജിമോൻ(പാലോട് പോലീസ് ഇൻസ്പെക്ടർ).ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3755.jpeg",
    },
    {
      src: "assets/img/Pastevents/3743.jpeg",
      caption:
        "ആലംകോട് ഹൈസ്കൂൾ പൂർവ വിദ്യാർത്ഥി കൂട്ടായിമയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3743.jpeg",
    },
    {
      src: "assets/img/Pastevents/3744.jpeg",
      caption:
        "ആലംകോട് ഹൈസ്കൂൾ പൂർവ വിദ്യാർത്ഥി കൂട്ടായിമയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3744.jpeg",
    },
    {
      src: "assets/img/Pastevents/3745.jpeg",
      caption:
        "ആലംകോട് ഹൈസ്കൂൾ പൂർവ വിദ്യാർത്ഥി കൂട്ടായിമയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3745.jpeg",
    },
    {
      src: "assets/img/Pastevents/3746.jpeg",
      caption:
        "ആലംകോട് ഹൈസ്കൂൾ പൂർവ വിദ്യാർത്ഥി കൂട്ടായിമയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3746.jpeg",
    },
    {
      src: "assets/img/Pastevents/3747.jpeg",
      caption:
        "ആലംകോട് ഹൈസ്കൂൾ പൂർവ വിദ്യാർത്ഥി കൂട്ടായിമയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3747.jpeg",
    },
    {
      src: "assets/img/Pastevents/3748.jpeg",
      caption:
        "ആലംകോട് ഹൈസ്കൂൾ പൂർവ വിദ്യാർത്ഥി കൂട്ടായിമയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3748.jpeg",
    },

    {
      src: "assets/img/Pastevents/3737.jpeg",
      caption:
        "വിതുര ചായം റെസിഡൻഷ്യൽ അസോസിയേഷൻൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3737.jpeg",
    },
    {
      src: "assets/img/Pastevents/3738.jpeg",
      caption:
        "വിതുര ചായം റെസിഡൻഷ്യൽ അസോസിയേഷൻൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3738.jpeg",
    },
    {
      src: "assets/img/Pastevents/3739.jpeg",
      caption:
        "വിതുര ചായം റെസിഡൻഷ്യൽ അസോസിയേഷൻൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3739.jpeg",
    },
    {
      src: "assets/img/Pastevents/3740.jpeg",
      caption:
        "വിതുര ചായം റെസിഡൻഷ്യൽ അസോസിയേഷൻൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3740.jpeg",
    },
    {
      src: "assets/img/Pastevents/3741.jpeg",
      caption:
        "വിതുര ചായം റെസിഡൻഷ്യൽ അസോസിയേഷൻൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3741.jpeg",
    },
    {
      src: "assets/img/Pastevents/3742.jpeg",
      caption:
        "വിതുര ചായം റെസിഡൻഷ്യൽ അസോസിയേഷൻൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3742.jpeg",
    },
    {
      src: "assets/img/Pastevents/3730.jpeg",
      caption:
        "കോട്ടൂർ വനജോതി പുരുഷ സ്വയംസഹായ സംഘം,ട്രിവാൻഡ്രം റീജൻസി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3730.jpeg",
    },
    {
      src: "assets/img/Pastevents/3731.jpeg",
      caption:
        "കോട്ടൂർ വനജോതി പുരുഷ സ്വയംസഹായ സംഘം,ട്രിവാൻഡ്രം റീജൻസി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3731.jpeg",
    },
    {
      src: "assets/img/Pastevents/3732.jpeg",
      caption:
        "കോട്ടൂർ വനജോതി പുരുഷ സ്വയംസഹായ സംഘം,ട്രിവാൻഡ്രം റീജൻസി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3732.jpeg",
    },
    {
      src: "assets/img/Pastevents/3733.jpeg",
      caption:
        "കോട്ടൂർ വനജോതി പുരുഷ സ്വയംസഹായ സംഘം,ട്രിവാൻഡ്രം റീജൻസി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3733.jpeg",
    },
    {
      src: "assets/img/Pastevents/3734.jpeg",
      caption:
        "കോട്ടൂർ വനജോതി പുരുഷ സ്വയംസഹായ സംഘം,ട്രിവാൻഡ്രം റീജൻസി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3734.jpeg",
    },
    {
      src: "assets/img/Pastevents/3735.jpeg",
      caption:
        "കോട്ടൂർ വനജോതി പുരുഷ സ്വയംസഹായ സംഘം,ട്രിവാൻഡ്രം റീജൻസി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3735.jpeg",
    },
    {
      src: "assets/img/Pastevents/3736.jpeg",
      caption:
        "കോട്ടൂർ വനജോതി പുരുഷ സ്വയംസഹായ സംഘം,ട്രിവാൻഡ്രം റീജൻസി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3736.jpeg",
    },
    {
      src: "assets/img/Pastevents/3725.jpeg",
      caption:
        "ഒറ്റശേഖരമംഗലം ശ്രീ മഹാദേവ ക്ഷേത്രത്തിലെ തിരുവാതിര ഉൽസവത്തോട് അനുബന്ധിച്ച് കെ എൻ എം എസ് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3725.jpeg",
    },
    {
      src: "assets/img/Pastevents/3726.jpeg",
      caption:
        "ഒറ്റശേഖരമംഗലം ശ്രീ മഹാദേവ ക്ഷേത്രത്തിലെ തിരുവാതിര ഉൽസവത്തോട് അനുബന്ധിച്ച് കെ എൻ എം എസ് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3726.jpeg",
    },
    {
      src: "assets/img/Pastevents/3727.jpeg",
      caption:
        "ഒറ്റശേഖരമംഗലം ശ്രീ മഹാദേവ ക്ഷേത്രത്തിലെ തിരുവാതിര ഉൽസവത്തോട് അനുബന്ധിച്ച് കെ എൻ എം എസ് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3727.jpeg",
    },
    {
      src: "assets/img/Pastevents/3728.jpeg",
      caption:
        "ഒറ്റശേഖരമംഗലം ശ്രീ മഹാദേവ ക്ഷേത്രത്തിലെ തിരുവാതിര ഉൽസവത്തോട് അനുബന്ധിച്ച് കെ എൻ എം എസ് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3728.jpeg",
    },
    {
      src: "assets/img/Pastevents/3729.jpeg",
      caption:
        "ഒറ്റശേഖരമംഗലം ശ്രീ മഹാദേവ ക്ഷേത്രത്തിലെ തിരുവാതിര ഉൽസവത്തോട് അനുബന്ധിച്ച് കെ എൻ എം എസ് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3729.jpeg",
    },
    {
      src: "assets/img/Pastevents/3720.jpeg",
      caption:
        "അരങ്ങിൽ ശ്രീ മഹാദേവ ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3720.jpeg",
    },
    {
      src: "assets/img/Pastevents/3721.jpeg",
      caption:
        "അരങ്ങിൽ ശ്രീ മഹാദേവ ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3721.jpeg",
    },
    {
      src: "assets/img/Pastevents/3722.jpeg",
      caption:
        "അരങ്ങിൽ ശ്രീ മഹാദേവ ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3722.jpeg",
    },
    {
      src: "assets/img/Pastevents/3723.jpeg",
      caption:
        "അരങ്ങിൽ ശ്രീ മഹാദേവ ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3723.jpeg",
    },
    {
      src: "assets/img/Pastevents/3724.jpeg",
      caption:
        "അരങ്ങിൽ ശ്രീ മഹാദേവ ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3724.jpeg",
    },
    {
      src: "assets/img/Pastevents/3714.jpeg",
      caption:
        "അരുവിക്കര ഭഗവതി്പുരം ഡി വൈ എഫ് ഐ യൂണിറ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3714.jpeg",
    },
    {
      src: "assets/img/Pastevents/3715.jpeg",
      caption:
        "അരുവിക്കര ഭഗവതി്പുരം ഡി വൈ എഫ് ഐ യൂണിറ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3715.jpeg",
    },
    {
      src: "assets/img/Pastevents/3716.jpeg",
      caption:
        "അരുവിക്കര ഭഗവതി്പുരം ഡി വൈ എഫ് ഐ യൂണിറ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3716.jpeg",
    },
    {
      src: "assets/img/Pastevents/3717.jpeg",
      caption:
        "അരുവിക്കര ഭഗവതി്പുരം ഡി വൈ എഫ് ഐ യൂണിറ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3717.jpeg",
    },
    {
      src: "assets/img/Pastevents/3718.jpeg",
      caption:
        "അരുവിക്കര ഭഗവതി്പുരം ഡി വൈ എഫ് ഐ യൂണിറ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3718.jpeg",
    },
    {
      src: "assets/img/Pastevents/3719.jpeg",
      caption:
        "അരുവിക്കര ഭഗവതി്പുരം ഡി വൈ എഫ് ഐ യൂണിറ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3719.jpeg",
    },
    {
      src: "assets/img/Pastevents/3708.jpeg",
      caption:
        "അരുവിക്കര ഭഗവതി്പുരം ഡി വൈ എഫ് ഐ യൂണിറ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3708.jpeg",
    },
    {
      src: "assets/img/Pastevents/3709.jpeg",
      caption:
        "അരുവിക്കര ഭഗവതി്പുരം ഡി വൈ എഫ് ഐ യൂണിറ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3709.jpeg",
    },
    {
      src: "assets/img/Pastevents/3710.jpeg",
      caption:
        "അരുവിക്കര ഭഗവതി്പുരം ഡി വൈ എഫ് ഐ യൂണിറ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3710.jpeg",
    },
    {
      src: "assets/img/Pastevents/3711.jpeg",
      caption:
        "അരുവിക്കര ഭഗവതി്പുരം ഡി വൈ എഫ് ഐ യൂണിറ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3711.jpeg",
    },
    {
      src: "assets/img/Pastevents/3712.jpeg",
      caption:
        "അരുവിക്കര ഭഗവതി്പുരം ഡി വൈ എഫ് ഐ യൂണിറ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3712.jpeg",
    },
    {
      src: "assets/img/Pastevents/3713.jpeg",
      caption:
        "അരുവിക്കര ഭഗവതി്പുരം ഡി വൈ എഫ് ഐ യൂണിറ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3713.jpeg",
    },
    {
      src: "assets/img/Pastevents/3702.jpeg",
      caption:
        "ഗവ: ഹൈസ്കൂൾ 2000-2001ബാച്ച് മാരായമ്മുട്ടം പൂർവ്വ വിദ്യാർത്ഥി സംഗമത്തോട് അനുബന്ധിച്ച് നിംസ് മെഡിസിറ്റി സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3702.jpeg",
    },
    {
      src: "assets/img/Pastevents/3703.jpeg",
      caption:
        "ഗവ: ഹൈസ്കൂൾ 2000-2001ബാച്ച് മാരായമ്മുട്ടം പൂർവ്വ വിദ്യാർത്ഥി സംഗമത്തോട് അനുബന്ധിച്ച് നിംസ് മെഡിസിറ്റി സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3703.jpeg",
    },
    {
      src: "assets/img/Pastevents/3704.jpeg",
      caption:
        "ഗവ: ഹൈസ്കൂൾ 2000-2001ബാച്ച് മാരായമ്മുട്ടം പൂർവ്വ വിദ്യാർത്ഥി സംഗമത്തോട് അനുബന്ധിച്ച് നിംസ് മെഡിസിറ്റി സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3704.jpeg",
    },
    {
      src: "assets/img/Pastevents/3705.jpeg",
      caption:
        "ഗവ: ഹൈസ്കൂൾ 2000-2001ബാച്ച് മാരായമ്മുട്ടം പൂർവ്വ വിദ്യാർത്ഥി സംഗമത്തോട് അനുബന്ധിച്ച് നിംസ് മെഡിസിറ്റി സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3705.jpeg",
    },
    {
      src: "assets/img/Pastevents/3706.jpeg",
      caption:
        "ഗവ: ഹൈസ്കൂൾ 2000-2001ബാച്ച് മാരായമ്മുട്ടം പൂർവ്വ വിദ്യാർത്ഥി സംഗമത്തോട് അനുബന്ധിച്ച് നിംസ് മെഡിസിറ്റി സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3706.jpeg",
    },
    {
      src: "assets/img/Pastevents/3707.jpeg",
      caption:
        "ഗവ: ഹൈസ്കൂൾ 2000-2001ബാച്ച് മാരായമ്മുട്ടം പൂർവ്വ വിദ്യാർത്ഥി സംഗമത്തോട് അനുബന്ധിച്ച് നിംസ് മെഡിസിറ്റി സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3707.jpeg",
    },
    {
      src: "assets/img/Pastevents/3697.jpeg",
      caption:
        "പൂതക്കോട് എസ് എൻ ഡ് പി യൂണിറ്റ്, ശ്രീ നാരായണ ധർമ്മ പ്രകാശിനി മന്ദിരത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3697.jpeg",
    },
    {
      src: "assets/img/Pastevents/3698.jpeg",
      caption:
        "പൂതക്കോട് എസ് എൻ ഡ് പി യൂണിറ്റ്, ശ്രീ നാരായണ ധർമ്മ പ്രകാശിനി മന്ദിരത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3698.jpeg",
    },
    {
      src: "assets/img/Pastevents/3699.jpeg",
      caption:
        "പൂതക്കോട് എസ് എൻ ഡ് പി യൂണിറ്റ്, ശ്രീ നാരായണ ധർമ്മ പ്രകാശിനി മന്ദിരത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3699.jpeg",
    },
    {
      src: "assets/img/Pastevents/3700.jpeg",
      caption:
        "പൂതക്കോട് എസ് എൻ ഡ് പി യൂണിറ്റ്, ശ്രീ നാരായണ ധർമ്മ പ്രകാശിനി മന്ദിരത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3700.jpeg",
    },
    {
      src: "assets/img/Pastevents/3701.jpeg",
      caption:
        "പൂതക്കോട് എസ് എൻ ഡ് പി യൂണിറ്റ്, ശ്രീ നാരായണ ധർമ്മ പ്രകാശിനി മന്ദിരത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3701.jpeg",
    },
    {
      src: "assets/img/Pastevents/3690.jpeg",
      caption:
        "തമിഴ്നാട്  ഗവൺമെന്റ് ഹെൽത്ത് സ്കീം, കളിയിക്കാവിള ശ്രീകൃഷ്പുരം വൈദ്യശാലയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3690.jpeg",
    },
    {
      src: "assets/img/Pastevents/3691.jpeg",
      caption:
        "തമിഴ്നാട്  ഗവൺമെന്റ് ഹെൽത്ത് സ്കീം, കളിയിക്കാവിള ശ്രീകൃഷ്പുരം വൈദ്യശാലയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3691.jpeg",
    },
    {
      src: "assets/img/Pastevents/3692.jpeg",
      caption:
        "തമിഴ്നാട്  ഗവൺമെന്റ് ഹെൽത്ത് സ്കീം, കളിയിക്കാവിള ശ്രീകൃഷ്പുരം വൈദ്യശാലയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3692.jpeg",
    },
    {
      src: "assets/img/Pastevents/3692.jpeg",
      caption:
        "തമിഴ്നാട്  ഗവൺമെന്റ് ഹെൽത്ത് സ്കീം, കളിയിക്കാവിള ശ്രീകൃഷ്പുരം വൈദ്യശാലയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3693.jpeg",
    },
    {
      src: "assets/img/Pastevents/3694.jpeg",
      caption:
        "തമിഴ്നാട്  ഗവൺമെന്റ് ഹെൽത്ത് സ്കീം, കളിയിക്കാവിള ശ്രീകൃഷ്പുരം വൈദ്യശാലയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3694.jpeg",
    },
    {
      src: "assets/img/Pastevents/3695.jpeg",
      caption:
        "തമിഴ്നാട്  ഗവൺമെന്റ് ഹെൽത്ത് സ്കീം, കളിയിക്കാവിള ശ്രീകൃഷ്പുരം വൈദ്യശാലയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3695.jpeg",
    },
    {
      src: "assets/img/Pastevents/3696.jpeg",
      caption:
        "തമിഴ്നാട്  ഗവൺമെന്റ് ഹെൽത്ത് സ്കീം, കളിയിക്കാവിള ശ്രീകൃഷ്പുരം വൈദ്യശാലയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3696.jpeg",
    },
    {
      src: "assets/img/Pastevents/3682.jpeg",
      caption:
        "നവകേരള സദസ്സിനോടനുമ്പദ്ധിച്ച് മൺണ്ഡ്രോ തുരുത്ത് ജനകീയ കൂട്ടായ്മയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ കോവൂർ കുഞ്ഞുമോൻ (എംഎൽഎ ).ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3682.jpeg",
    },
    {
      src: "assets/img/Pastevents/3683.jpeg",
      caption:
        "നവകേരള സദസ്സിനോടനുമ്പദ്ധിച്ച് മൺണ്ഡ്രോ തുരുത്ത് ജനകീയ കൂട്ടായ്മയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ കോവൂർ കുഞ്ഞുമോൻ (എംഎൽഎ ).ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3683.jpeg",
    },
    {
      src: "assets/img/Pastevents/3684.jpeg",
      caption:
        "നവകേരള സദസ്സിനോടനുമ്പദ്ധിച്ച് മൺണ്ഡ്രോ തുരുത്ത് ജനകീയ കൂട്ടായ്മയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ കോവൂർ കുഞ്ഞുമോൻ (എംഎൽഎ ).ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3684.jpeg",
    },
    {
      src: "assets/img/Pastevents/3685.jpeg",
      caption:
        "നവകേരള സദസ്സിനോടനുമ്പദ്ധിച്ച് മൺണ്ഡ്രോ തുരുത്ത് ജനകീയ കൂട്ടായ്മയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ കോവൂർ കുഞ്ഞുമോൻ (എംഎൽഎ ).ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3685.jpeg",
    },
    {
      src: "assets/img/Pastevents/3686.jpeg",
      caption:
        "നവകേരള സദസ്സിനോടനുമ്പദ്ധിച്ച് മൺണ്ഡ്രോ തുരുത്ത് ജനകീയ കൂട്ടായ്മയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ കോവൂർ കുഞ്ഞുമോൻ (എംഎൽഎ ).ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3686.jpeg",
    },
    {
      src: "assets/img/Pastevents/3687.jpeg",
      caption:
        "നവകേരള സദസ്സിനോടനുമ്പദ്ധിച്ച് മൺണ്ഡ്രോ തുരുത്ത് ജനകീയ കൂട്ടായ്മയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ കോവൂർ കുഞ്ഞുമോൻ (എംഎൽഎ ).ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3687.jpeg",
    },
    {
      src: "assets/img/Pastevents/3688.jpeg",
      caption:
        "നവകേരള സദസ്സിനോടനുമ്പദ്ധിച്ച് മൺണ്ഡ്രോ തുരുത്ത് ജനകീയ കൂട്ടായ്മയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ കോവൂർ കുഞ്ഞുമോൻ (എംഎൽഎ ).ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3688.jpeg",
    },
    {
      src: "assets/img/Pastevents/3689.jpeg",
      caption:
        "നവകേരള സദസ്സിനോടനുമ്പദ്ധിച്ച് മൺണ്ഡ്രോ തുരുത്ത് ജനകീയ കൂട്ടായ്മയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ കോവൂർ കുഞ്ഞുമോൻ (എംഎൽഎ ).ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3689.jpeg",
    },
    {
      src: "assets/img/Pastevents/3676.jpeg",
      caption:
        "കരകുളം ഗ്രാമപഞ്ചായത്ത്, വട്ടപ്പാറ സൗത്ത് വാർഡ് കുടുംബശ്രീ കൂട്ടായിമയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി",
      thumb: "assets/img/Pastevents/3676.jpeg",
    },
    {
      src: "assets/img/Pastevents/3677.jpeg",
      caption:
        "കരകുളം ഗ്രാമപഞ്ചായത്ത്, വട്ടപ്പാറ സൗത്ത് വാർഡ് കുടുംബശ്രീ കൂട്ടായിമയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി",
      thumb: "assets/img/Pastevents/3677.jpeg",
    },
    {
      src: "assets/img/Pastevents/3678.jpeg",
      caption:
        "കരകുളം ഗ്രാമപഞ്ചായത്ത്, വട്ടപ്പാറ സൗത്ത് വാർഡ് കുടുംബശ്രീ കൂട്ടായിമയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി",
      thumb: "assets/img/Pastevents/3678.jpeg",
    },
    {
      src: "assets/img/Pastevents/3679.jpeg",
      caption:
        "കരകുളം ഗ്രാമപഞ്ചായത്ത്, വട്ടപ്പാറ സൗത്ത് വാർഡ് കുടുംബശ്രീ കൂട്ടായിമയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി",
      thumb: "assets/img/Pastevents/3679.jpeg",
    },
    {
      src: "assets/img/Pastevents/3680.jpeg",
      caption:
        "കരകുളം ഗ്രാമപഞ്ചായത്ത്, വട്ടപ്പാറ സൗത്ത് വാർഡ് കുടുംബശ്രീ കൂട്ടായിമയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി",
      thumb: "assets/img/Pastevents/3680.jpeg",
    },
    {
      src: "assets/img/Pastevents/3681.jpeg",
      caption:
        "കരകുളം ഗ്രാമപഞ്ചായത്ത്, വട്ടപ്പാറ സൗത്ത് വാർഡ് കുടുംബശ്രീ കൂട്ടായിമയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി",
      thumb: "assets/img/Pastevents/3681.jpeg",
    },
    {
      src: "assets/img/Pastevents/3670.jpeg",
      caption:
        "കല്ലറ തോട്ടിൻപ്പുറം മുസ്‌ലിം ജുമാ മസ്ജിദിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3670.jpeg",
    },
    {
      src: "assets/img/Pastevents/3671.jpeg",
      caption:
        "കല്ലറ തോട്ടിൻപ്പുറം മുസ്‌ലിം ജുമാ മസ്ജിദിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3671.jpeg",
    },
    {
      src: "assets/img/Pastevents/3672.jpeg",
      caption:
        "കല്ലറ തോട്ടിൻപ്പുറം മുസ്‌ലിം ജുമാ മസ്ജിദിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3672.jpeg",
    },
    {
      src: "assets/img/Pastevents/3673.jpeg",
      caption:
        "കല്ലറ തോട്ടിൻപ്പുറം മുസ്‌ലിം ജുമാ മസ്ജിദിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3673.jpeg",
    },
    {
      src: "assets/img/Pastevents/3674.jpeg",
      caption:
        "കല്ലറ തോട്ടിൻപ്പുറം മുസ്‌ലിം ജുമാ മസ്ജിദിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3674.jpeg",
    },
    {
      src: "assets/img/Pastevents/3675.jpeg",
      caption:
        "കല്ലറ തോട്ടിൻപ്പുറം മുസ്‌ലിം ജുമാ മസ്ജിദിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3675.jpeg",
    },
    {
      src: "assets/img/Pastevents/3665.jpeg",
      caption:
        "വട്ടിയൂർക്കാവ് ജ്വാല വാട്ട്സ്ആപ്പ് കൂട്ടായിമയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3665.jpeg",
    },
    {
      src: "assets/img/Pastevents/3666.jpeg",
      caption:
        "വട്ടിയൂർക്കാവ് ജ്വാല വാട്ട്സ്ആപ്പ് കൂട്ടായിമയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3666.jpeg",
    },
    {
      src: "assets/img/Pastevents/3667.jpeg",
      caption:
        "വട്ടിയൂർക്കാവ് ജ്വാല വാട്ട്സ്ആപ്പ് കൂട്ടായിമയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3667.jpeg",
    },
    {
      src: "assets/img/Pastevents/3668.jpeg",
      caption:
        "വട്ടിയൂർക്കാവ് ജ്വാല വാട്ട്സ്ആപ്പ് കൂട്ടായിമയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3668.jpeg",
    },
    {
      src: "assets/img/Pastevents/3669.jpeg",
      caption:
        "വട്ടിയൂർക്കാവ് ജ്വാല വാട്ട്സ്ആപ്പ് കൂട്ടായിമയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3669.jpeg",
    },
    {
      src: "assets/img/Pastevents/3660.jpeg",
      caption:
        "ഊരുട്ടുക്കാല ദയാ ഇൻഡസ്ട്രിസിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3660.jpeg",
    },
    {
      src: "assets/img/Pastevents/3661.jpeg",
      caption:
        "ഊരുട്ടുക്കാല ദയാ ഇൻഡസ്ട്രിസിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3661.jpeg",
    },
    {
      src: "assets/img/Pastevents/3662.jpeg",
      caption:
        "ഊരുട്ടുക്കാല ദയാ ഇൻഡസ്ട്രിസിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3662.jpeg",
    },
    {
      src: "assets/img/Pastevents/3663.jpeg",
      caption:
        "ഊരുട്ടുക്കാല ദയാ ഇൻഡസ്ട്രിസിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3663.jpeg",
    },
    {
      src: "assets/img/Pastevents/3664.jpeg",
      caption:
        "ഊരുട്ടുക്കാല ദയാ ഇൻഡസ്ട്രിസിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3664.jpeg",
    },
    {
      src: "assets/img/Pastevents/3654.jpeg",
      caption:
        "ട്രിവാൻഡ്രം അനന്തപുരി ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3654.jpeg",
    },
    {
      src: "assets/img/Pastevents/3655.jpeg",
      caption:
        "ട്രിവാൻഡ്രം അനന്തപുരി ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3655.jpeg",
    },
    {
      src: "assets/img/Pastevents/3656.jpeg",
      caption:
        "ട്രിവാൻഡ്രം അനന്തപുരി ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3656.jpeg",
    },
    {
      src: "assets/img/Pastevents/3657.jpeg",
      caption:
        "ട്രിവാൻഡ്രം അനന്തപുരി ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3657.jpeg",
    },
    {
      src: "assets/img/Pastevents/3658.jpeg",
      caption:
        "ട്രിവാൻഡ്രം അനന്തപുരി ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3658.jpeg",
    },
    {
      src: "assets/img/Pastevents/3659.jpeg",
      caption:
        "ട്രിവാൻഡ്രം അനന്തപുരി ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3659.jpeg",
    },
    {
      src: "assets/img/Pastevents/3646.jpeg",
      caption:
        "കണിയാപുരം ചിറക് കൂട്ടായിമ, സഹജീവൻ സ്പെഷ്യൽ സ്കൂളിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3646.jpeg",
    },
    {
      src: "assets/img/Pastevents/3647.jpeg",
      caption:
        "കണിയാപുരം ചിറക് കൂട്ടായിമ, സഹജീവൻ സ്പെഷ്യൽ സ്കൂളിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3647.jpeg",
    },
    {
      src: "assets/img/Pastevents/3648.jpeg",
      caption:
        "കണിയാപുരം ചിറക് കൂട്ടായിമ, സഹജീവൻ സ്പെഷ്യൽ സ്കൂളിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3648.jpeg",
    },
    {
      src: "assets/img/Pastevents/3649.jpeg",
      caption:
        "കണിയാപുരം ചിറക് കൂട്ടായിമ, സഹജീവൻ സ്പെഷ്യൽ സ്കൂളിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3649.jpeg",
    },
    {
      src: "assets/img/Pastevents/3650.jpeg",
      caption:
        "കണിയാപുരം ചിറക് കൂട്ടായിമ, സഹജീവൻ സ്പെഷ്യൽ സ്കൂളിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3650.jpeg",
    },
    {
      src: "assets/img/Pastevents/3651.jpeg",
      caption:
        "കണിയാപുരം ചിറക് കൂട്ടായിമ, സഹജീവൻ സ്പെഷ്യൽ സ്കൂളിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3651.jpeg",
    },
    {
      src: "assets/img/Pastevents/3652.jpeg",
      caption:
        "കണിയാപുരം ചിറക് കൂട്ടായിമ, സഹജീവൻ സ്പെഷ്യൽ സ്കൂളിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3652.jpeg",
    },
    {
      src: "assets/img/Pastevents/3653.jpeg",
      caption:
        "കണിയാപുരം ചിറക് കൂട്ടായിമ, സഹജീവൻ സ്പെഷ്യൽ സ്കൂളിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3653.jpeg",
    },
    {
      src: "assets/img/Pastevents/3640.jpeg",
      caption:
        "ആര്യനാട് കുരിയാത്തി ഐ എൻ റ്റി സി യു യൂണിറ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3640.jpeg",
    },
    {
      src: "assets/img/Pastevents/3641.jpeg",
      caption:
        "ആര്യനാട് കുരിയാത്തി ഐ എൻ റ്റി സി യു യൂണിറ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3641.jpeg",
    },
    {
      src: "assets/img/Pastevents/3642.jpeg",
      caption:
        "ആര്യനാട് കുരിയാത്തി ഐ എൻ റ്റി സി യു യൂണിറ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3642.jpeg",
    },
    {
      src: "assets/img/Pastevents/3643.jpeg",
      caption:
        "ആര്യനാട് കുരിയാത്തി ഐ എൻ റ്റി സി യു യൂണിറ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3643.jpeg",
    },
    {
      src: "assets/img/Pastevents/3644.jpeg",
      caption:
        "ആര്യനാട് കുരിയാത്തി ഐ എൻ റ്റി സി യു യൂണിറ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3644.jpeg",
    },
    {
      src: "assets/img/Pastevents/3645.jpeg",
      caption:
        "ആര്യനാട് കുരിയാത്തി ഐ എൻ റ്റി സി യു യൂണിറ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3645.jpeg",
    },
    {
      src: "assets/img/Pastevents/3639.jpeg",
      caption:
        "ആര്യനാട് കുരിയാത്തി ഐ എൻ റ്റി സി യു യൂണിറ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3639.jpeg",
    },
    {
      src: "assets/img/Pastevents/3634.jpeg",
      caption:
        "നരുവാമൂട് പ്ലാറ്റിനം ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3634.jpeg",
    },
    {
      src: "assets/img/Pastevents/3635.jpeg",
      caption:
        "നരുവാമൂട് പ്ലാറ്റിനം ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3635.jpeg",
    },
    {
      src: "assets/img/Pastevents/3636.jpeg",
      caption:
        "നരുവാമൂട് പ്ലാറ്റിനം ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3636.jpeg",
    },
    {
      src: "assets/img/Pastevents/3637.jpeg",
      caption:
        "നരുവാമൂട് പ്ലാറ്റിനം ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3637.jpeg",
    },
    {
      src: "assets/img/Pastevents/3638.jpeg",
      caption:
        "നരുവാമൂട് പ്ലാറ്റിനം ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3638.jpeg",
    },
    {
      src: "assets/img/Pastevents/3626.jpeg",
      caption:
        "വിഴിഞ്ഞം മാതൃ - പൃതു വേദി ട്രിവാൻഡ്രം ഫൊറോന,ട്രിവാൻഡ്രം റീജൻസി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3626.jpeg",
    },
    {
      src: "assets/img/Pastevents/3627.jpeg",
      caption:
        "വിഴിഞ്ഞം മാതൃ - പൃതു വേദി ട്രിവാൻഡ്രം ഫൊറോന,ട്രിവാൻഡ്രം റീജൻസി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3627.jpeg",
    },
    {
      src: "assets/img/Pastevents/3628.jpeg",
      caption:
        "വിഴിഞ്ഞം മാതൃ - പൃതു വേദി ട്രിവാൻഡ്രം ഫൊറോന,ട്രിവാൻഡ്രം റീജൻസി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3628.jpeg",
    },
    {
      src: "assets/img/Pastevents/3629.jpeg",
      caption:
        "വിഴിഞ്ഞം മാതൃ - പൃതു വേദി ട്രിവാൻഡ്രം ഫൊറോന,ട്രിവാൻഡ്രം റീജൻസി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3629.jpeg",
    },
    {
      src: "assets/img/Pastevents/3630.jpeg",
      caption:
        "വിഴിഞ്ഞം മാതൃ - പൃതു വേദി ട്രിവാൻഡ്രം ഫൊറോന,ട്രിവാൻഡ്രം റീജൻസി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3630.jpeg",
    },
    {
      src: "assets/img/Pastevents/3631.jpeg",
      caption:
        "വിഴിഞ്ഞം മാതൃ - പൃതു വേദി ട്രിവാൻഡ്രം ഫൊറോന,ട്രിവാൻഡ്രം റീജൻസി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3631.jpeg",
    },
    {
      src: "assets/img/Pastevents/3632.jpeg",
      caption:
        "വിഴിഞ്ഞം മാതൃ - പൃതു വേദി ട്രിവാൻഡ്രം ഫൊറോന,ട്രിവാൻഡ്രം റീജൻസി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3632.jpeg",
    },
    {
      src: "assets/img/Pastevents/3633.jpeg",
      caption:
        "വിഴിഞ്ഞം മാതൃ - പൃതു വേദി ട്രിവാൻഡ്രം ഫൊറോന,ട്രിവാൻഡ്രം റീജൻസി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3633.jpeg",
    },
    {
      src: "assets/img/Pastevents/3620.jpeg",
      caption:
        "ട്രിവാൻഡ്രം വഞ്ചിനാട് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3620.jpeg",
    },
    {
      src: "assets/img/Pastevents/3621.jpeg",
      caption:
        "ട്രിവാൻഡ്രം വഞ്ചിനാട് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3621.jpeg",
    },
    {
      src: "assets/img/Pastevents/3622.jpeg",
      caption:
        "ട്രിവാൻഡ്രം വഞ്ചിനാട് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3622.jpeg",
    },
    {
      src: "assets/img/Pastevents/3623.jpeg",
      caption:
        "ട്രിവാൻഡ്രം വഞ്ചിനാട് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3623.jpeg",
    },
    {
      src: "assets/img/Pastevents/3624.jpeg",
      caption:
        "ട്രിവാൻഡ്രം വഞ്ചിനാട് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3624.jpeg",
    },
    {
      src: "assets/img/Pastevents/3625.jpeg",
      caption:
        "ട്രിവാൻഡ്രം വഞ്ചിനാട് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3625.jpeg",
    },
    {
      src: "assets/img/Pastevents/3615.jpeg",
      caption:
        "പെരുംങ്കടവിള അപ്പോളോ ഫാർമസി ഗ്രൂപ്പിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3615.jpeg",
    },
    {
      src: "assets/img/Pastevents/3616.jpeg",
      caption:
        "പെരുംങ്കടവിള അപ്പോളോ ഫാർമസി ഗ്രൂപ്പിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3616.jpeg",
    },
    {
      src: "assets/img/Pastevents/3617.jpeg",
      caption:
        "പെരുംങ്കടവിള അപ്പോളോ ഫാർമസി ഗ്രൂപ്പിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3617.jpeg",
    },
    {
      src: "assets/img/Pastevents/3618.jpeg",
      caption:
        "പെരുംങ്കടവിള അപ്പോളോ ഫാർമസി ഗ്രൂപ്പിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3618.jpeg",
    },
    {
      src: "assets/img/Pastevents/3619.jpeg",
      caption:
        "പെരുംങ്കടവിള അപ്പോളോ ഫാർമസി ഗ്രൂപ്പിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3619.jpeg",
    },
    {
      src: "assets/img/Pastevents/3609.jpeg",
      caption:
        "മേലാരന്നൂർ ഗാന്ധിജി നഗർ റെസിഡൻസ് വെൽഫെയർ അസോസിയേഷൻ, ട്രിവാൻഡ്രം ഈസ്റ്റ് ലിയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഓർത്തോപീഡിക്കസ്, എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3609.jpeg",
    },
    {
      src: "assets/img/Pastevents/3610.jpeg",
      caption:
        "മേലാരന്നൂർ ഗാന്ധിജി നഗർ റെസിഡൻസ് വെൽഫെയർ അസോസിയേഷൻ, ട്രിവാൻഡ്രം ഈസ്റ്റ് ലിയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഓർത്തോപീഡിക്കസ്, എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3610.jpeg",
    },
    {
      src: "assets/img/Pastevents/3611.jpeg",
      caption:
        "മേലാരന്നൂർ ഗാന്ധിജി നഗർ റെസിഡൻസ് വെൽഫെയർ അസോസിയേഷൻ, ട്രിവാൻഡ്രം ഈസ്റ്റ് ലിയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഓർത്തോപീഡിക്കസ്, എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3611.jpeg",
    },
    {
      src: "assets/img/Pastevents/3612.jpeg",
      caption:
        "മേലാരന്നൂർ ഗാന്ധിജി നഗർ റെസിഡൻസ് വെൽഫെയർ അസോസിയേഷൻ, ട്രിവാൻഡ്രം ഈസ്റ്റ് ലിയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഓർത്തോപീഡിക്കസ്, എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3612.jpeg",
    },
    {
      src: "assets/img/Pastevents/3613.jpeg",
      caption:
        "മേലാരന്നൂർ ഗാന്ധിജി നഗർ റെസിഡൻസ് വെൽഫെയർ അസോസിയേഷൻ, ട്രിവാൻഡ്രം ഈസ്റ്റ് ലിയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഓർത്തോപീഡിക്കസ്, എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3613.jpeg",
    },
    {
      src: "assets/img/Pastevents/3614.jpeg",
      caption:
        "മേലാരന്നൂർ ഗാന്ധിജി നഗർ റെസിഡൻസ് വെൽഫെയർ അസോസിയേഷൻ, ട്രിവാൻഡ്രം ഈസ്റ്റ് ലിയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഓർത്തോപീഡിക്കസ്, എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3614.jpeg",
    },
    {
      src: "assets/img/Pastevents/3604.jpeg",
      caption:
        "മംഗലത്തുകോണം സെൻ്റ് അലോഷ്യസ് സ്കൂളിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഓർത്തോപീഡിക്കസ്, എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3604.jpeg",
    },
    {
      src: "assets/img/Pastevents/3605.jpeg",
      caption:
        "മംഗലത്തുകോണം സെൻ്റ് അലോഷ്യസ് സ്കൂളിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഓർത്തോപീഡിക്കസ്, എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3605.jpeg",
    },
    {
      src: "assets/img/Pastevents/3606.jpeg",
      caption:
        "മംഗലത്തുകോണം സെൻ്റ് അലോഷ്യസ് സ്കൂളിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഓർത്തോപീഡിക്കസ്, എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3606.jpeg",
    },
    {
      src: "assets/img/Pastevents/3607.jpeg",
      caption:
        "മംഗലത്തുകോണം സെൻ്റ് അലോഷ്യസ് സ്കൂളിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഓർത്തോപീഡിക്കസ്, എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3607.jpeg",
    },
    {
      src: "assets/img/Pastevents/3608.jpeg",
      caption:
        "മംഗലത്തുകോണം സെൻ്റ് അലോഷ്യസ് സ്കൂളിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഓർത്തോപീഡിക്കസ്, എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3608.jpeg",
    },
    {
      src: "assets/img/Pastevents/3598.jpeg",
      caption:
        "കരോടെ റോട്ടറി ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ അൻസലൻ (എംഎൽഎ ).ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഓർത്തോപീഡിക്കസ്, എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3598.jpeg",
    },
    {
      src: "assets/img/Pastevents/3599.jpeg",
      caption:
        "കരോടെ റോട്ടറി ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ അൻസലൻ (എംഎൽഎ ).ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഓർത്തോപീഡിക്കസ്, എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3599.jpeg",
    },
    {
      src: "assets/img/Pastevents/3600.jpeg",
      caption:
        "കരോടെ റോട്ടറി ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ അൻസലൻ (എംഎൽഎ ).ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഓർത്തോപീഡിക്കസ്, എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3600.jpeg",
    },
    {
      src: "assets/img/Pastevents/3601.jpeg",
      caption:
        "കരോടെ റോട്ടറി ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ അൻസലൻ (എംഎൽഎ ).ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഓർത്തോപീഡിക്കസ്, എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3601.jpeg",
    },
    {
      src: "assets/img/Pastevents/3602.jpeg",
      caption:
        "കരോടെ റോട്ടറി ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ അൻസലൻ (എംഎൽഎ ).ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഓർത്തോപീഡിക്കസ്, എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3602.jpeg",
    },
    {
      src: "assets/img/Pastevents/3603.jpeg",
      caption:
        "കരോടെ റോട്ടറി ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ അൻസലൻ (എംഎൽഎ ).ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഓർത്തോപീഡിക്കസ്, എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3603.jpeg",
    },
    {
      src: "assets/img/Pastevents/3590.jpeg",
      caption:
        "കരോടെ റോട്ടറി ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ അൻസലൻ (എംഎൽഎ ).ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഓർത്തോപീഡിക്കസ്, എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3590.jpeg",
    },
    {
      src: "assets/img/Pastevents/3591.jpeg",
      caption:
        "കരോടെ റോട്ടറി ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ അൻസലൻ (എംഎൽഎ ).ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഓർത്തോപീഡിക്കസ്, എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3591.jpeg",
    },
    {
      src: "assets/img/Pastevents/3592.jpeg",
      caption:
        "കരോടെ റോട്ടറി ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ അൻസലൻ (എംഎൽഎ ).ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഓർത്തോപീഡിക്കസ്, എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3592.jpeg",
    },
    {
      src: "assets/img/Pastevents/3593.jpeg",
      caption:
        "കരോടെ റോട്ടറി ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ അൻസലൻ (എംഎൽഎ ).ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഓർത്തോപീഡിക്കസ്, എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3593.jpeg",
    },
    {
      src: "assets/img/Pastevents/3594.jpeg",
      caption:
        "കരോടെ റോട്ടറി ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ അൻസലൻ (എംഎൽഎ ).ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഓർത്തോപീഡിക്കസ്, എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3594.jpeg",
    },
    {
      src: "assets/img/Pastevents/3595.jpeg",
      caption:
        "കരോടെ റോട്ടറി ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ അൻസലൻ (എംഎൽഎ ).ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഓർത്തോപീഡിക്കസ്, എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3595.jpeg",
    },
    {
      src: "assets/img/Pastevents/3596.jpeg",
      caption:
        "കരോടെ റോട്ടറി ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ അൻസലൻ (എംഎൽഎ ).ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഓർത്തോപീഡിക്കസ്, എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3596.jpeg",
    },
    {
      src: "assets/img/Pastevents/3597.jpeg",
      caption:
        "കരോടെ റോട്ടറി ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ അൻസലൻ (എംഎൽഎ ).ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഓർത്തോപീഡിക്കസ്, എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3597.jpeg",
    },
    {
      src: "assets/img/Pastevents/3585.jpeg",
      caption:
        "ട്രിവാൻഡ്രം പ്ലാറ്റിനം ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3585.jpeg",
    },
    {
      src: "assets/img/Pastevents/3586.jpeg",
      caption:
        "ട്രിവാൻഡ്രം പ്ലാറ്റിനം ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3586.jpeg",
    },
    {
      src: "assets/img/Pastevents/3587.jpeg",
      caption:
        "ട്രിവാൻഡ്രം പ്ലാറ്റിനം ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3587.jpeg",
    },
    {
      src: "assets/img/Pastevents/3588.jpeg",
      caption:
        "ട്രിവാൻഡ്രം പ്ലാറ്റിനം ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3588.jpeg",
    },
    {
      src: "assets/img/Pastevents/3589.jpeg",
      caption:
        "ട്രിവാൻഡ്രം പ്ലാറ്റിനം ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3589.jpeg",
    },
    {
      src: "assets/img/Pastevents/3579.jpeg",
      caption:
        "KSRTC  ആരംഭിച്ച ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 100-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3579.jpeg",
    },
    {
      src: "assets/img/Pastevents/3580.jpeg",
      caption:
        "KSRTC  ആരംഭിച്ച ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 100-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3580.jpeg",
    },
    {
      src: "assets/img/Pastevents/3581.jpeg",
      caption:
        "KSRTC  ആരംഭിച്ച ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 100-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3581.jpeg",
    },
    {
      src: "assets/img/Pastevents/3582.jpeg",
      caption:
        "KSRTC  ആരംഭിച്ച ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 100-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3582.jpeg",
    },
    {
      src: "assets/img/Pastevents/3583.jpeg",
      caption:
        "KSRTC  ആരംഭിച്ച ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 100-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3583.jpeg",
    },
    {
      src: "assets/img/Pastevents/3584.jpeg",
      caption:
        "KSRTC  ആരംഭിച്ച ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 100-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3584.jpeg",
    },
    {
      src: "assets/img/Pastevents/3572.jpeg",
      caption:
        "വലിയവിള ക്രിസ്തുരാജ ദേവാലയം നിഡ്സ് യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3572.jpeg",
    },
    {
      src: "assets/img/Pastevents/3573.jpeg",
      caption:
        "വലിയവിള ക്രിസ്തുരാജ ദേവാലയം നിഡ്സ് യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3573.jpeg",
    },
    {
      src: "assets/img/Pastevents/3574.jpeg",
      caption:
        "വലിയവിള ക്രിസ്തുരാജ ദേവാലയം നിഡ്സ് യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3574.jpeg",
    },
    {
      src: "assets/img/Pastevents/3575.jpeg",
      caption:
        "വലിയവിള ക്രിസ്തുരാജ ദേവാലയം നിഡ്സ് യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3575.jpeg",
    },
    {
      src: "assets/img/Pastevents/3576.jpeg",
      caption:
        "വലിയവിള ക്രിസ്തുരാജ ദേവാലയം നിഡ്സ് യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3576.jpeg",
    },
    {
      src: "assets/img/Pastevents/3577.jpeg",
      caption:
        "വലിയവിള ക്രിസ്തുരാജ ദേവാലയം നിഡ്സ് യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3577.jpeg",
    },
    {
      src: "assets/img/Pastevents/3578.jpeg",
      caption:
        "വലിയവിള ക്രിസ്തുരാജ ദേവാലയം നിഡ്സ് യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3578.jpeg",
    },
    {
      src: "assets/img/Pastevents/3566.jpeg",
      caption:
        "കമലേശ്വരം അപ്പോളോ ഫാർമസി ഗ്രൂപ്പിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3566.jpeg",
    },
    {
      src: "assets/img/Pastevents/3567.jpeg",
      caption:
        "കമലേശ്വരം അപ്പോളോ ഫാർമസി ഗ്രൂപ്പിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3567.jpeg",
    },
    {
      src: "assets/img/Pastevents/3568.jpeg",
      caption:
        "കമലേശ്വരം അപ്പോളോ ഫാർമസി ഗ്രൂപ്പിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3568.jpeg",
    },
    {
      src: "assets/img/Pastevents/3569.jpeg",
      caption:
        "കമലേശ്വരം അപ്പോളോ ഫാർമസി ഗ്രൂപ്പിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3569.jpeg",
    },
    {
      src: "assets/img/Pastevents/3570.jpeg",
      caption:
        "കമലേശ്വരം അപ്പോളോ ഫാർമസി ഗ്രൂപ്പിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3570.jpeg",
    },
    {
      src: "assets/img/Pastevents/3571.jpeg",
      caption:
        "കമലേശ്വരം അപ്പോളോ ഫാർമസി ഗ്രൂപ്പിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3571.jpeg",
    },
    {
      src: "assets/img/Pastevents/3559.jpeg",
      caption:
        "വിഴിഞ്ഞം സെൻ്റ് ഫ്രാൻസിസ് സെയിൽസ് പബ്ലിക് സ്ക്കൂളിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3559.jpeg",
    },
    {
      src: "assets/img/Pastevents/3560.jpeg",
      caption:
        "വിഴിഞ്ഞം സെൻ്റ് ഫ്രാൻസിസ് സെയിൽസ് പബ്ലിക് സ്ക്കൂളിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3560.jpeg",
    },
    {
      src: "assets/img/Pastevents/3561.jpeg",
      caption:
        "വിഴിഞ്ഞം സെൻ്റ് ഫ്രാൻസിസ് സെയിൽസ് പബ്ലിക് സ്ക്കൂളിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3561.jpeg",
    },
    {
      src: "assets/img/Pastevents/3562.jpeg",
      caption:
        "വിഴിഞ്ഞം സെൻ്റ് ഫ്രാൻസിസ് സെയിൽസ് പബ്ലിക് സ്ക്കൂളിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3562.jpeg",
    },
    {
      src: "assets/img/Pastevents/3563.jpeg",
      caption:
        "വിഴിഞ്ഞം സെൻ്റ് ഫ്രാൻസിസ് സെയിൽസ് പബ്ലിക് സ്ക്കൂളിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3563.jpeg",
    },
    {
      src: "assets/img/Pastevents/3564.jpeg",
      caption:
        "വിഴിഞ്ഞം സെൻ്റ് ഫ്രാൻസിസ് സെയിൽസ് പബ്ലിക് സ്ക്കൂളിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3564.jpeg",
    },
    {
      src: "assets/img/Pastevents/3565.jpeg",
      caption:
        "വിഴിഞ്ഞം സെൻ്റ് ഫ്രാൻസിസ് സെയിൽസ് പബ്ലിക് സ്ക്കൂളിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3565.jpeg",
    },
    {
      src: "assets/img/Pastevents/3552.jpeg",
      caption:
        "വിതുര ശിശു സൗഹൃദ ജനമൈത്രി പോലീസ് സ്റ്റേഷൻൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ കിരൺ നാരായൺ IPS (ജില്ലാ പൊലീസ് മേധാവി). ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3552.jpeg",
    },
    {
      src: "assets/img/Pastevents/3553.jpeg",
      caption:
        "വിതുര ശിശു സൗഹൃദ ജനമൈത്രി പോലീസ് സ്റ്റേഷൻൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ കിരൺ നാരായൺ IPS (ജില്ലാ പൊലീസ് മേധാവി). ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3553.jpeg",
    },
    {
      src: "assets/img/Pastevents/3554.jpeg",
      caption:
        "വിതുര ശിശു സൗഹൃദ ജനമൈത്രി പോലീസ് സ്റ്റേഷൻൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ കിരൺ നാരായൺ IPS (ജില്ലാ പൊലീസ് മേധാവി). ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3554.jpeg",
    },
    {
      src: "assets/img/Pastevents/3555.jpeg",
      caption:
        "വിതുര ശിശു സൗഹൃദ ജനമൈത്രി പോലീസ് സ്റ്റേഷൻൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ കിരൺ നാരായൺ IPS (ജില്ലാ പൊലീസ് മേധാവി). ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3555.jpeg",
    },
    {
      src: "assets/img/Pastevents/3556.jpeg",
      caption:
        "വിതുര ശിശു സൗഹൃദ ജനമൈത്രി പോലീസ് സ്റ്റേഷൻൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ കിരൺ നാരായൺ IPS (ജില്ലാ പൊലീസ് മേധാവി). ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3556.jpeg",
    },
    {
      src: "assets/img/Pastevents/3557.jpeg",
      caption:
        "വിതുര ശിശു സൗഹൃദ ജനമൈത്രി പോലീസ് സ്റ്റേഷൻൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ കിരൺ നാരായൺ IPS (ജില്ലാ പൊലീസ് മേധാവി). ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3557.jpeg",
    },
    {
      src: "assets/img/Pastevents/3558.jpeg",
      caption:
        "വിതുര ശിശു സൗഹൃദ ജനമൈത്രി പോലീസ് സ്റ്റേഷൻൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ കിരൺ നാരായൺ IPS (ജില്ലാ പൊലീസ് മേധാവി). ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3558.jpeg",
    },
    {
      src: "assets/img/Pastevents/3544.jpeg",
      caption:
        "ഓലതാന്നി തിരു ഹൃദയ ദേവാലയം, നിഡ്സ് യൂണിറ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3544.jpeg",
    },
    {
      src: "assets/img/Pastevents/3545.jpeg",
      caption:
        "ഓലതാന്നി തിരു ഹൃദയ ദേവാലയം, നിഡ്സ് യൂണിറ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3545.jpeg",
    },
    {
      src: "assets/img/Pastevents/3546.jpeg",
      caption:
        "ഓലതാന്നി തിരു ഹൃദയ ദേവാലയം, നിഡ്സ് യൂണിറ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3546.jpeg",
    },
    {
      src: "assets/img/Pastevents/3547.jpeg",
      caption:
        "ഓലതാന്നി തിരു ഹൃദയ ദേവാലയം, നിഡ്സ് യൂണിറ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3547.jpeg",
    },
    {
      src: "assets/img/Pastevents/3548.jpeg",
      caption:
        "ഓലതാന്നി തിരു ഹൃദയ ദേവാലയം, നിഡ്സ് യൂണിറ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3548.jpeg",
    },
    {
      src: "assets/img/Pastevents/3549.jpeg",
      caption:
        "ഓലതാന്നി തിരു ഹൃദയ ദേവാലയം, നിഡ്സ് യൂണിറ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3549.jpeg",
    },
    {
      src: "assets/img/Pastevents/3550.jpeg",
      caption:
        "ഓലതാന്നി തിരു ഹൃദയ ദേവാലയം, നിഡ്സ് യൂണിറ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3550.jpeg",
    },
    {
      src: "assets/img/Pastevents/3551.jpeg",
      caption:
        "ഓലതാന്നി തിരു ഹൃദയ ദേവാലയം, നിഡ്സ് യൂണിറ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3551.jpeg",
    },
    {
      src: "assets/img/Pastevents/3538.jpeg",
      caption:
        "വേങ്ങൂർ ജി എൽ പി സ്ക്കൂൾ, ഓയൂർ ടൗൺ ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെ സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3538.jpeg",
    },
    {
      src: "assets/img/Pastevents/3539.jpeg",
      caption:
        "വേങ്ങൂർ ജി എൽ പി സ്ക്കൂൾ, ഓയൂർ ടൗൺ ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെ സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3539.jpeg",
    },
    {
      src: "assets/img/Pastevents/3540.jpeg",
      caption:
        "വേങ്ങൂർ ജി എൽ പി സ്ക്കൂൾ, ഓയൂർ ടൗൺ ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെ സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3540.jpeg",
    },
    {
      src: "assets/img/Pastevents/3541.jpeg",
      caption:
        "വേങ്ങൂർ ജി എൽ പി സ്ക്കൂൾ, ഓയൂർ ടൗൺ ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെ സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3541.jpeg",
    },
    {
      src: "assets/img/Pastevents/3542.jpeg",
      caption:
        "വേങ്ങൂർ ജി എൽ പി സ്ക്കൂൾ, ഓയൂർ ടൗൺ ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെ സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3542.jpeg",
    },
    {
      src: "assets/img/Pastevents/3543.jpeg",
      caption:
        "വേങ്ങൂർ ജി എൽ പി സ്ക്കൂൾ, ഓയൂർ ടൗൺ ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെ സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3543.jpeg",
    },
    {
      src: "assets/img/Pastevents/3533.jpeg",
      caption:
        "ഇറയംക്കോട് പു. ക. സ യൂണിറ്റ്,ട്രിവാൻഡ്രം റൈൻബോ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെ സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3533.jpeg",
    },
    {
      src: "assets/img/Pastevents/3534.jpeg",
      caption:
        "ഇറയംക്കോട് പു. ക. സ യൂണിറ്റ്,ട്രിവാൻഡ്രം റൈൻബോ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെ സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3534.jpeg",
    },
    {
      src: "assets/img/Pastevents/3535.jpeg",
      caption:
        "ഇറയംക്കോട് പു. ക. സ യൂണിറ്റ്,ട്രിവാൻഡ്രം റൈൻബോ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെ സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3535.jpeg",
    },
    {
      src: "assets/img/Pastevents/3536.jpeg",
      caption:
        "ഇറയംക്കോട് പു. ക. സ യൂണിറ്റ്,ട്രിവാൻഡ്രം റൈൻബോ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെ സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3536.jpeg",
    },
    {
      src: "assets/img/Pastevents/3537.jpeg",
      caption:
        "ഇറയംക്കോട് പു. ക. സ യൂണിറ്റ്,ട്രിവാൻഡ്രം റൈൻബോ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെ സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3537.jpeg",
    },
    {
      src: "assets/img/Pastevents/3524.jpeg",
      caption:
        "ചെങ്കൽ മഹേശ്വരം ശിവപാർവതി ക്ഷേത്ര മഠാധിപതി ശ്രീ മഹേശ്വരാനന്ദ സരസ്വതിയുടെ സപ്തതി ആഘോഷത്തിൻ്റെ ഭാഗമായി നിംസ് മെഡിസിറ്റിയുടെ ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3524.jpeg",
    },
    {
      src: "assets/img/Pastevents/3525.jpeg",
      caption:
        "ചെങ്കൽ മഹേശ്വരം ശിവപാർവതി ക്ഷേത്ര മഠാധിപതി ശ്രീ മഹേശ്വരാനന്ദ സരസ്വതിയുടെ സപ്തതി ആഘോഷത്തിൻ്റെ ഭാഗമായി നിംസ് മെഡിസിറ്റിയുടെ ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3525.jpeg",
    },
    {
      src: "assets/img/Pastevents/3526.jpeg",
      caption:
        "ചെങ്കൽ മഹേശ്വരം ശിവപാർവതി ക്ഷേത്ര മഠാധിപതി ശ്രീ മഹേശ്വരാനന്ദ സരസ്വതിയുടെ സപ്തതി ആഘോഷത്തിൻ്റെ ഭാഗമായി നിംസ് മെഡിസിറ്റിയുടെ ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3526.jpeg",
    },
    {
      src: "assets/img/Pastevents/3527.jpeg",
      caption:
        "ചെങ്കൽ മഹേശ്വരം ശിവപാർവതി ക്ഷേത്ര മഠാധിപതി ശ്രീ മഹേശ്വരാനന്ദ സരസ്വതിയുടെ സപ്തതി ആഘോഷത്തിൻ്റെ ഭാഗമായി നിംസ് മെഡിസിറ്റിയുടെ ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3527.jpeg",
    },
    {
      src: "assets/img/Pastevents/3528.jpeg",
      caption:
        "ചെങ്കൽ മഹേശ്വരം ശിവപാർവതി ക്ഷേത്ര മഠാധിപതി ശ്രീ മഹേശ്വരാനന്ദ സരസ്വതിയുടെ സപ്തതി ആഘോഷത്തിൻ്റെ ഭാഗമായി നിംസ് മെഡിസിറ്റിയുടെ ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3528.jpeg",
    },
    {
      src: "assets/img/Pastevents/3529.jpeg",
      caption:
        "ചെങ്കൽ മഹേശ്വരം ശിവപാർവതി ക്ഷേത്ര മഠാധിപതി ശ്രീ മഹേശ്വരാനന്ദ സരസ്വതിയുടെ സപ്തതി ആഘോഷത്തിൻ്റെ ഭാഗമായി നിംസ് മെഡിസിറ്റിയുടെ ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3529.jpeg",
    },
    {
      src: "assets/img/Pastevents/3530.jpeg",
      caption:
        "ചെങ്കൽ മഹേശ്വരം ശിവപാർവതി ക്ഷേത്ര മഠാധിപതി ശ്രീ മഹേശ്വരാനന്ദ സരസ്വതിയുടെ സപ്തതി ആഘോഷത്തിൻ്റെ ഭാഗമായി നിംസ് മെഡിസിറ്റിയുടെ ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3530.jpeg",
    },
    {
      src: "assets/img/Pastevents/3531.jpeg",
      caption:
        "ചെങ്കൽ മഹേശ്വരം ശിവപാർവതി ക്ഷേത്ര മഠാധിപതി ശ്രീ മഹേശ്വരാനന്ദ സരസ്വതിയുടെ സപ്തതി ആഘോഷത്തിൻ്റെ ഭാഗമായി നിംസ് മെഡിസിറ്റിയുടെ ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3531.jpeg",
    },
    {
      src: "assets/img/Pastevents/3532.jpeg",
      caption:
        "ചെങ്കൽ മഹേശ്വരം ശിവപാർവതി ക്ഷേത്ര മഠാധിപതി ശ്രീ മഹേശ്വരാനന്ദ സരസ്വതിയുടെ സപ്തതി ആഘോഷത്തിൻ്റെ ഭാഗമായി നിംസ് മെഡിസിറ്റിയുടെ ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3532.jpeg",
    },
    {
      src: "assets/img/Pastevents/3517.jpeg",
      caption:
        "ലോക പ്രമേഹ ദിനത്തോട് അനുബന്ധിച്ച് ഓലത്താന്നി വിക്ടറി കോളേജ് ഓഫ് ടീച്ചേഴ്സ് എജുക്കേഷൻൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3517.jpeg",
    },
    {
      src: "assets/img/Pastevents/3518.jpeg",
      caption:
        "ലോക പ്രമേഹ ദിനത്തോട് അനുബന്ധിച്ച് ഓലത്താന്നി വിക്ടറി കോളേജ് ഓഫ് ടീച്ചേഴ്സ് എജുക്കേഷൻൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3518.jpeg",
    },
    {
      src: "assets/img/Pastevents/3519.jpeg",
      caption:
        "ലോക പ്രമേഹ ദിനത്തോട് അനുബന്ധിച്ച് ഓലത്താന്നി വിക്ടറി കോളേജ് ഓഫ് ടീച്ചേഴ്സ് എജുക്കേഷൻൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3519.jpeg",
    },
    {
      src: "assets/img/Pastevents/3520.jpeg",
      caption:
        "ലോക പ്രമേഹ ദിനത്തോട് അനുബന്ധിച്ച് ഓലത്താന്നി വിക്ടറി കോളേജ് ഓഫ് ടീച്ചേഴ്സ് എജുക്കേഷൻൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3520.jpeg",
    },
    {
      src: "assets/img/Pastevents/3521.jpeg",
      caption:
        "ലോക പ്രമേഹ ദിനത്തോട് അനുബന്ധിച്ച് ഓലത്താന്നി വിക്ടറി കോളേജ് ഓഫ് ടീച്ചേഴ്സ് എജുക്കേഷൻൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3521.jpeg",
    },
    {
      src: "assets/img/Pastevents/3522.jpeg",
      caption:
        "ലോക പ്രമേഹ ദിനത്തോട് അനുബന്ധിച്ച് ഓലത്താന്നി വിക്ടറി കോളേജ് ഓഫ് ടീച്ചേഴ്സ് എജുക്കേഷൻൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3522.jpeg",
    },
    {
      src: "assets/img/Pastevents/3523.jpeg",
      caption:
        "ലോക പ്രമേഹ ദിനത്തോട് അനുബന്ധിച്ച് ഓലത്താന്നി വിക്ടറി കോളേജ് ഓഫ് ടീച്ചേഴ്സ് എജുക്കേഷൻൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3523.jpeg",
    },
    {
      src: "assets/img/Pastevents/3512.jpeg",
      caption:
        "കോലിയക്കോട് കലുങ്ക് ബ്രദേഴ്സ്, ട്രിവാൻഡ്രം സൗത്ത് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3512.jpeg",
    },
    {
      src: "assets/img/Pastevents/3513.jpeg",
      caption:
        "കോലിയക്കോട് കലുങ്ക് ബ്രദേഴ്സ്, ട്രിവാൻഡ്രം സൗത്ത് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3513.jpeg",
    },
    {
      src: "assets/img/Pastevents/3514.jpeg",
      caption:
        "കോലിയക്കോട് കലുങ്ക് ബ്രദേഴ്സ്, ട്രിവാൻഡ്രം സൗത്ത് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3514.jpeg",
    },
    {
      src: "assets/img/Pastevents/3515.jpeg",
      caption:
        "കോലിയക്കോട് കലുങ്ക് ബ്രദേഴ്സ്, ട്രിവാൻഡ്രം സൗത്ത് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3515.jpeg",
    },
    {
      src: "assets/img/Pastevents/3516.jpeg",
      caption:
        "കോലിയക്കോട് കലുങ്ക് ബ്രദേഴ്സ്, ട്രിവാൻഡ്രം സൗത്ത് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3516.jpeg",
    },
    {
      src: "assets/img/Pastevents/3506.jpeg",
      caption:
        "പെരുംങ്കടവിള ഗ്രാമ പഞ്ചായത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3506.jpeg",
    },
    {
      src: "assets/img/Pastevents/3507.jpeg",
      caption:
        "പെരുംങ്കടവിള ഗ്രാമ പഞ്ചായത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3507.jpeg",
    },
    {
      src: "assets/img/Pastevents/3508.jpeg",
      caption:
        "പെരുംങ്കടവിള ഗ്രാമ പഞ്ചായത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3508.jpeg",
    },
    {
      src: "assets/img/Pastevents/3509.jpeg",
      caption:
        "പെരുംങ്കടവിള ഗ്രാമ പഞ്ചായത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3509.jpeg",
    },
    {
      src: "assets/img/Pastevents/3510.jpeg",
      caption:
        "പെരുംങ്കടവിള ഗ്രാമ പഞ്ചായത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3510.jpeg",
    },
    {
      src: "assets/img/Pastevents/3511.jpeg",
      caption:
        "പെരുംങ്കടവിള ഗ്രാമ പഞ്ചായത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3511.jpeg",
    },
    {
      src: "assets/img/Pastevents/3499.jpeg",
      caption:
        "ശാസ്താംകോട്ട വെളിയം ദാമോദർ സ്മാരക ഗ്രന്ഥശാല,ശാസ്താംകോട്ട ഹിൽടോപ് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3499.jpeg",
    },
    {
      src: "assets/img/Pastevents/3500.jpeg",
      caption:
        "ശാസ്താംകോട്ട വെളിയം ദാമോദർ സ്മാരക ഗ്രന്ഥശാല,ശാസ്താംകോട്ട ഹിൽടോപ് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3500.jpeg",
    },
    {
      src: "assets/img/Pastevents/3501.jpeg",
      caption:
        "ശാസ്താംകോട്ട വെളിയം ദാമോദർ സ്മാരക ഗ്രന്ഥശാല,ശാസ്താംകോട്ട ഹിൽടോപ് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3501.jpeg",
    },
    {
      src: "assets/img/Pastevents/3502.jpeg",
      caption:
        "ശാസ്താംകോട്ട വെളിയം ദാമോദർ സ്മാരക ഗ്രന്ഥശാല,ശാസ്താംകോട്ട ഹിൽടോപ് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3502.jpeg",
    },
    {
      src: "assets/img/Pastevents/3503.jpeg",
      caption:
        "ശാസ്താംകോട്ട വെളിയം ദാമോദർ സ്മാരക ഗ്രന്ഥശാല,ശാസ്താംകോട്ട ഹിൽടോപ് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3503.jpeg",
    },
    {
      src: "assets/img/Pastevents/3504.jpeg",
      caption:
        "ശാസ്താംകോട്ട വെളിയം ദാമോദർ സ്മാരക ഗ്രന്ഥശാല,ശാസ്താംകോട്ട ഹിൽടോപ് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3504.jpeg",
    },
    {
      src: "assets/img/Pastevents/3505.jpeg",
      caption:
        "ശാസ്താംകോട്ട വെളിയം ദാമോദർ സ്മാരക ഗ്രന്ഥശാല,ശാസ്താംകോട്ട ഹിൽടോപ് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3505.jpeg",
    },
    {
      src: "assets/img/Pastevents/3490.jpeg",
      caption:
        "വിതുര ശിശു സൗഹൃദ ജനമൈത്രി പോലീസ് സ്റ്റേഷൻ, വിതുര ഫ്രാറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3490.jpeg",
    },
    {
      src: "assets/img/Pastevents/3491.jpeg",
      caption:
        "വിതുര ശിശു സൗഹൃദ ജനമൈത്രി പോലീസ് സ്റ്റേഷൻ, വിതുര ഫ്രാറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3491.jpeg",
    },
    {
      src: "assets/img/Pastevents/3492.jpeg",
      caption:
        "വിതുര ശിശു സൗഹൃദ ജനമൈത്രി പോലീസ് സ്റ്റേഷൻ, വിതുര ഫ്രാറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3492.jpeg",
    },
    {
      src: "assets/img/Pastevents/3493.jpeg",
      caption:
        "വിതുര ശിശു സൗഹൃദ ജനമൈത്രി പോലീസ് സ്റ്റേഷൻ, വിതുര ഫ്രാറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3493.jpeg",
    },
    {
      src: "assets/img/Pastevents/3494.jpeg",
      caption:
        "വിതുര ശിശു സൗഹൃദ ജനമൈത്രി പോലീസ് സ്റ്റേഷൻ, വിതുര ഫ്രാറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3494.jpeg",
    },
    {
      src: "assets/img/Pastevents/3495.jpeg",
      caption:
        "വിതുര ശിശു സൗഹൃദ ജനമൈത്രി പോലീസ് സ്റ്റേഷൻ, വിതുര ഫ്രാറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3495.jpeg",
    },
    {
      src: "assets/img/Pastevents/3496.jpeg",
      caption:
        "വിതുര ശിശു സൗഹൃദ ജനമൈത്രി പോലീസ് സ്റ്റേഷൻ, വിതുര ഫ്രാറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3496.jpeg",
    },
    {
      src: "assets/img/Pastevents/3497.jpeg",
      caption:
        "വിതുര ശിശു സൗഹൃദ ജനമൈത്രി പോലീസ് സ്റ്റേഷൻ, വിതുര ഫ്രാറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3497.jpeg",
    },
    {
      src: "assets/img/Pastevents/3498.jpeg",
      caption:
        "വിതുര ശിശു സൗഹൃദ ജനമൈത്രി പോലീസ് സ്റ്റേഷൻ, വിതുര ഫ്രാറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3498.jpeg",
    },
    {
      src: "assets/img/Pastevents/3483.jpeg",
      caption:
        "പനച്ചമൂട് കല്ലിങ്കൽ ഓട്ടോ മൊബൈൽസ്,ട്രിവാൻഡ്രം പ്രേംനസീർ സുഹൃത്ത് സമിതിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ സി കെ  ഹരീന്ദ്രൻ (എം എൽ എ )ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3483.jpeg",
    },
    {
      src: "assets/img/Pastevents/3484.jpeg",
      caption:
        "പനച്ചമൂട് കല്ലിങ്കൽ ഓട്ടോ മൊബൈൽസ്,ട്രിവാൻഡ്രം പ്രേംനസീർ സുഹൃത്ത് സമിതിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ സി കെ  ഹരീന്ദ്രൻ (എം എൽ എ )ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3484.jpeg",
    },
    {
      src: "assets/img/Pastevents/3485.jpeg",
      caption:
        "പനച്ചമൂട് കല്ലിങ്കൽ ഓട്ടോ മൊബൈൽസ്,ട്രിവാൻഡ്രം പ്രേംനസീർ സുഹൃത്ത് സമിതിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ സി കെ  ഹരീന്ദ്രൻ (എം എൽ എ )ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3485.jpeg",
    },
    {
      src: "assets/img/Pastevents/3486.jpeg",
      caption:
        "പനച്ചമൂട് കല്ലിങ്കൽ ഓട്ടോ മൊബൈൽസ്,ട്രിവാൻഡ്രം പ്രേംനസീർ സുഹൃത്ത് സമിതിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ സി കെ  ഹരീന്ദ്രൻ (എം എൽ എ )ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3486.jpeg",
    },
    {
      src: "assets/img/Pastevents/3487.jpeg",
      caption:
        "പനച്ചമൂട് കല്ലിങ്കൽ ഓട്ടോ മൊബൈൽസ്,ട്രിവാൻഡ്രം പ്രേംനസീർ സുഹൃത്ത് സമിതിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ സി കെ  ഹരീന്ദ്രൻ (എം എൽ എ )ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3487.jpeg",
    },
    {
      src: "assets/img/Pastevents/3488.jpeg",
      caption:
        "പനച്ചമൂട് കല്ലിങ്കൽ ഓട്ടോ മൊബൈൽസ്,ട്രിവാൻഡ്രം പ്രേംനസീർ സുഹൃത്ത് സമിതിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ സി കെ  ഹരീന്ദ്രൻ (എം എൽ എ )ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3488.jpeg",
    },
    {
      src: "assets/img/Pastevents/3489.jpeg",
      caption:
        "പനച്ചമൂട് കല്ലിങ്കൽ ഓട്ടോ മൊബൈൽസ്,ട്രിവാൻഡ്രം പ്രേംനസീർ സുഹൃത്ത് സമിതിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ സി കെ  ഹരീന്ദ്രൻ (എം എൽ എ )ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3489.jpeg",
    },
    {
      src: "assets/img/Pastevents/3478.jpeg",
      caption:
        "KSRTC  ആരംഭിച്ച ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 100-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3478.jpeg",
    },
    {
      src: "assets/img/Pastevents/3479.jpeg",
      caption:
        "KSRTC  ആരംഭിച്ച ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 100-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3479.jpeg",
    },
    {
      src: "assets/img/Pastevents/3480.jpeg",
      caption:
        "KSRTC  ആരംഭിച്ച ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 100-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3480.jpeg",
    },
    {
      src: "assets/img/Pastevents/3481.jpeg",
      caption:
        "KSRTC  ആരംഭിച്ച ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 100-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3481.jpeg",
    },
    {
      src: "assets/img/Pastevents/3482.jpeg",
      caption:
        "KSRTC  ആരംഭിച്ച ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 100-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3482.jpeg",
    },
    {
      src: "assets/img/Pastevents/3473.jpeg",
      caption:
        " കീഴാരൂർ ശ്രീ സരസ്വതി വിദ്യാലയത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3473.jpeg",
    },
    {
      src: "assets/img/Pastevents/3474.jpeg",
      caption:
        " കീഴാരൂർ ശ്രീ സരസ്വതി വിദ്യാലയത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3474.jpeg",
    },
    {
      src: "assets/img/Pastevents/3475.jpeg",
      caption:
        " കീഴാരൂർ ശ്രീ സരസ്വതി വിദ്യാലയത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3475.jpeg",
    },
    {
      src: "assets/img/Pastevents/3476.jpeg",
      caption:
        " കീഴാരൂർ ശ്രീ സരസ്വതി വിദ്യാലയത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3476.jpeg",
    },
    {
      src: "assets/img/Pastevents/3477.jpeg",
      caption:
        " കീഴാരൂർ ശ്രീ സരസ്വതി വിദ്യാലയത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3477.jpeg",
    },
    {
      src: "assets/img/Pastevents/3468.jpeg",
      caption:
        "KSRTC  ആരംഭിച്ച ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 100-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3468.jpeg",
    },
    {
      src: "assets/img/Pastevents/3469.jpeg",
      caption:
        "KSRTC  ആരംഭിച്ച ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 100-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3469.jpeg",
    },
    {
      src: "assets/img/Pastevents/3470.jpeg",
      caption:
        "KSRTC  ആരംഭിച്ച ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 100-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3470.jpeg",
    },
    {
      src: "assets/img/Pastevents/3471.jpeg",
      caption:
        "KSRTC  ആരംഭിച്ച ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 100-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3471.jpeg",
    },
    {
      src: "assets/img/Pastevents/3472.jpeg",
      caption:
        "KSRTC  ആരംഭിച്ച ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 100-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3472.jpeg",
    },
    {
      src: "assets/img/Pastevents/3462.jpeg",
      caption:
        "തമിഴ്നാട് ഗവൺമെൻ്റ് ഇൻഷുറൻസ് സ്കീം ചോളപുരം യൂത്ത് വെൽഫെയർ അസോസിയേഷൻൻ്റെയും നിംസ് മെഡിസിറ്റി യുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3462.jpeg",
    },
    {
      src: "assets/img/Pastevents/3463.jpeg",
      caption:
        "തമിഴ്നാട് ഗവൺമെൻ്റ് ഇൻഷുറൻസ് സ്കീം ചോളപുരം യൂത്ത് വെൽഫെയർ അസോസിയേഷൻൻ്റെയും നിംസ് മെഡിസിറ്റി യുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3463.jpeg",
    },
    {
      src: "assets/img/Pastevents/3464.jpeg",
      caption:
        "തമിഴ്നാട് ഗവൺമെൻ്റ് ഇൻഷുറൻസ് സ്കീം ചോളപുരം യൂത്ത് വെൽഫെയർ അസോസിയേഷൻൻ്റെയും നിംസ് മെഡിസിറ്റി യുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3464.jpeg",
    },
    {
      src: "assets/img/Pastevents/3465.jpeg",
      caption:
        "തമിഴ്നാട് ഗവൺമെൻ്റ് ഇൻഷുറൻസ് സ്കീം ചോളപുരം യൂത്ത് വെൽഫെയർ അസോസിയേഷൻൻ്റെയും നിംസ് മെഡിസിറ്റി യുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3465.jpeg",
    },
    {
      src: "assets/img/Pastevents/3466.jpeg",
      caption:
        "തമിഴ്നാട് ഗവൺമെൻ്റ് ഇൻഷുറൻസ് സ്കീം ചോളപുരം യൂത്ത് വെൽഫെയർ അസോസിയേഷൻൻ്റെയും നിംസ് മെഡിസിറ്റി യുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3466.jpeg",
    },
    {
      src: "assets/img/Pastevents/3467.jpeg",
      caption:
        "തമിഴ്നാട് ഗവൺമെൻ്റ് ഇൻഷുറൻസ് സ്കീം ചോളപുരം യൂത്ത് വെൽഫെയർ അസോസിയേഷൻൻ്റെയും നിംസ് മെഡിസിറ്റി യുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3467.jpeg",
    },
    {
      src: "assets/img/Pastevents/3457.jpeg",
      caption:
        "കിളിമാനൂർ ഫ്രണ്ട്സ് റെസിഡൻഷ്യൽ അസോസിയേഷൻ,കിളിമാനൂർ ഇൻ്റർനാഷണൽ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3457.jpeg",
    },
    {
      src: "assets/img/Pastevents/3458.jpeg",
      caption:
        "കിളിമാനൂർ ഫ്രണ്ട്സ് റെസിഡൻഷ്യൽ അസോസിയേഷൻ,കിളിമാനൂർ ഇൻ്റർനാഷണൽ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3458.jpeg",
    },
    {
      src: "assets/img/Pastevents/3459.jpeg",
      caption:
        "കിളിമാനൂർ ഫ്രണ്ട്സ് റെസിഡൻഷ്യൽ അസോസിയേഷൻ,കിളിമാനൂർ ഇൻ്റർനാഷണൽ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3459.jpeg",
    },
    {
      src: "assets/img/Pastevents/3460.jpeg",
      caption:
        "കിളിമാനൂർ ഫ്രണ്ട്സ് റെസിഡൻഷ്യൽ അസോസിയേഷൻ,കിളിമാനൂർ ഇൻ്റർനാഷണൽ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3460.jpeg",
    },
    {
      src: "assets/img/Pastevents/3461.jpeg",
      caption:
        "കിളിമാനൂർ ഫ്രണ്ട്സ് റെസിഡൻഷ്യൽ അസോസിയേഷൻ,കിളിമാനൂർ ഇൻ്റർനാഷണൽ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3461.jpeg",
    },
    {
      src: "assets/img/Pastevents/3452.jpeg",
      caption:
        "(രണ്ടാം ദിവസം) നീരമൺകര എൻ എസ് എസ് വിമൻസ് കോളേജ് എൻ എസ് എസ് യൂണിറ്റ്, ഫിസിക്കൽ എഡ്യൂക്കേഷൻ ഡിപ്പാർട്ട്മെൻ്റ്, ട്രിവാൻഡ്രം  റെയിൻബോ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3452.jpeg",
    },
    {
      src: "assets/img/Pastevents/3453.jpeg",
      caption:
        "(രണ്ടാം ദിവസം) നീരമൺകര എൻ എസ് എസ് വിമൻസ് കോളേജ് എൻ എസ് എസ് യൂണിറ്റ്, ഫിസിക്കൽ എഡ്യൂക്കേഷൻ ഡിപ്പാർട്ട്മെൻ്റ്, ട്രിവാൻഡ്രം  റെയിൻബോ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3453.jpeg",
    },
    {
      src: "assets/img/Pastevents/3454.jpeg",
      caption:
        "(രണ്ടാം ദിവസം) നീരമൺകര എൻ എസ് എസ് വിമൻസ് കോളേജ് എൻ എസ് എസ് യൂണിറ്റ്, ഫിസിക്കൽ എഡ്യൂക്കേഷൻ ഡിപ്പാർട്ട്മെൻ്റ്, ട്രിവാൻഡ്രം  റെയിൻബോ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3454.jpeg",
    },
    {
      src: "assets/img/Pastevents/3455.jpeg",
      caption:
        "(രണ്ടാം ദിവസം) നീരമൺകര എൻ എസ് എസ് വിമൻസ് കോളേജ് എൻ എസ് എസ് യൂണിറ്റ്, ഫിസിക്കൽ എഡ്യൂക്കേഷൻ ഡിപ്പാർട്ട്മെൻ്റ്, ട്രിവാൻഡ്രം  റെയിൻബോ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3455.jpeg",
    },
    {
      src: "assets/img/Pastevents/3456.jpeg",
      caption:
        "(രണ്ടാം ദിവസം) നീരമൺകര എൻ എസ് എസ് വിമൻസ് കോളേജ് എൻ എസ് എസ് യൂണിറ്റ്, ഫിസിക്കൽ എഡ്യൂക്കേഷൻ ഡിപ്പാർട്ട്മെൻ്റ്, ട്രിവാൻഡ്രം  റെയിൻബോ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3456.jpeg",
    },
    {
      src: "assets/img/Pastevents/3447.jpeg",
      caption:
        "KSRTC  ആരംഭിച്ച ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 100-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3447.jpeg",
    },
    {
      src: "assets/img/Pastevents/3448.jpeg",
      caption:
        "KSRTC  ആരംഭിച്ച ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 100-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3448.jpeg",
    },
    {
      src: "assets/img/Pastevents/3449.jpeg",
      caption:
        "KSRTC  ആരംഭിച്ച ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 100-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3449.jpeg",
    },
    {
      src: "assets/img/Pastevents/3450.jpeg",
      caption:
        "KSRTC  ആരംഭിച്ച ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 100-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3450.jpeg",
    },
    {
      src: "assets/img/Pastevents/3451.jpeg",
      caption:
        "KSRTC  ആരംഭിച്ച ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 100-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3451.jpeg",
    },
    {
      src: "assets/img/Pastevents/3439.jpeg",
      caption:
        "നീരമൺകര എൻ എസ് എസ് വിമൻസ് കോളേജ് എൻ എസ് എസ് യൂണിറ്റ്, ഫിസിക്കൽ എഡ്യൂക്കേഷൻ ഡിപ്പാർട്ട്മെൻ്റ്, ട്രിവാൻഡ്രം  റെയിൻബോ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3439.jpeg",
    },
    {
      src: "assets/img/Pastevents/3440.jpeg",
      caption:
        "നീരമൺകര എൻ എസ് എസ് വിമൻസ് കോളേജ് എൻ എസ് എസ് യൂണിറ്റ്, ഫിസിക്കൽ എഡ്യൂക്കേഷൻ ഡിപ്പാർട്ട്മെൻ്റ്, ട്രിവാൻഡ്രം  റെയിൻബോ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3440.jpeg",
    },
    {
      src: "assets/img/Pastevents/3441.jpeg",
      caption:
        "നീരമൺകര എൻ എസ് എസ് വിമൻസ് കോളേജ് എൻ എസ് എസ് യൂണിറ്റ്, ഫിസിക്കൽ എഡ്യൂക്കേഷൻ ഡിപ്പാർട്ട്മെൻ്റ്, ട്രിവാൻഡ്രം  റെയിൻബോ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3441.jpeg",
    },
    {
      src: "assets/img/Pastevents/3442.jpeg",
      caption:
        "നീരമൺകര എൻ എസ് എസ് വിമൻസ് കോളേജ് എൻ എസ് എസ് യൂണിറ്റ്, ഫിസിക്കൽ എഡ്യൂക്കേഷൻ ഡിപ്പാർട്ട്മെൻ്റ്, ട്രിവാൻഡ്രം  റെയിൻബോ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3442.jpeg",
    },
    {
      src: "assets/img/Pastevents/3443.jpeg",
      caption:
        "നീരമൺകര എൻ എസ് എസ് വിമൻസ് കോളേജ് എൻ എസ് എസ് യൂണിറ്റ്, ഫിസിക്കൽ എഡ്യൂക്കേഷൻ ഡിപ്പാർട്ട്മെൻ്റ്, ട്രിവാൻഡ്രം  റെയിൻബോ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3443.jpeg",
    },
    {
      src: "assets/img/Pastevents/3444.jpeg",
      caption:
        "നീരമൺകര എൻ എസ് എസ് വിമൻസ് കോളേജ് എൻ എസ് എസ് യൂണിറ്റ്, ഫിസിക്കൽ എഡ്യൂക്കേഷൻ ഡിപ്പാർട്ട്മെൻ്റ്, ട്രിവാൻഡ്രം  റെയിൻബോ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3444.jpeg",
    },
    {
      src: "assets/img/Pastevents/3445.jpeg",
      caption:
        "നീരമൺകര എൻ എസ് എസ് വിമൻസ് കോളേജ് എൻ എസ് എസ് യൂണിറ്റ്, ഫിസിക്കൽ എഡ്യൂക്കേഷൻ ഡിപ്പാർട്ട്മെൻ്റ്, ട്രിവാൻഡ്രം  റെയിൻബോ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3445.jpeg",
    },
    {
      src: "assets/img/Pastevents/3434.jpeg",
      caption:
        "പാലോട് പച്ച റെസിഡൻസ് വെൽഫെയർ സൊസൈറ്റി, കേരളാ കൗമുദി ബോധപൗർണമി ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3434.jpeg",
    },
    {
      src: "assets/img/Pastevents/3435.jpeg",
      caption:
        "പാലോട് പച്ച റെസിഡൻസ് വെൽഫെയർ സൊസൈറ്റി, കേരളാ കൗമുദി ബോധപൗർണമി ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3435.jpeg",
    },
    {
      src: "assets/img/Pastevents/3436.jpeg",
      caption:
        "പാലോട് പച്ച റെസിഡൻസ് വെൽഫെയർ സൊസൈറ്റി, കേരളാ കൗമുദി ബോധപൗർണമി ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3436.jpeg",
    },
    {
      src: "assets/img/Pastevents/3437.jpeg",
      caption:
        "പാലോട് പച്ച റെസിഡൻസ് വെൽഫെയർ സൊസൈറ്റി, കേരളാ കൗമുദി ബോധപൗർണമി ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3438.jpeg",
    },
    {
      src: "assets/img/Pastevents/3438.jpeg",
      caption:
        "പാലോട് പച്ച റെസിഡൻസ് വെൽഫെയർ സൊസൈറ്റി, കേരളാ കൗമുദി ബോധപൗർണമി ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3438.jpeg",
    },
    {
      src: "assets/img/Pastevents/3428.jpeg",
      caption:
        "KSRTC  ആരംഭിച്ച ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 100-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3428.jpeg",
    },
    {
      src: "assets/img/Pastevents/3429.jpeg",
      caption:
        "KSRTC  ആരംഭിച്ച ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 100-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3429.jpeg",
    },
    {
      src: "assets/img/Pastevents/3430.jpeg",
      caption:
        "KSRTC  ആരംഭിച്ച ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 100-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3430.jpeg",
    },
    {
      src: "assets/img/Pastevents/3431.jpeg",
      caption:
        "KSRTC  ആരംഭിച്ച ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 100-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3431.jpeg",
    },
    {
      src: "assets/img/Pastevents/3432.jpeg",
      caption:
        "KSRTC  ആരംഭിച്ച ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 100-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3432.jpeg",
    },
    {
      src: "assets/img/Pastevents/3433.jpeg",
      caption:
        "KSRTC  ആരംഭിച്ച ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 100-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3433.jpeg",
    },
    {
      src: "assets/img/Pastevents/3422.jpeg",
      caption:
        "വള്ളംകോട് വിവേകാനന്ദ റെസിഡൻഷ്യൽ അസോസിയേഷൻൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3422.jpeg",
    },
    {
      src: "assets/img/Pastevents/3423.jpeg",
      caption:
        "വള്ളംകോട് വിവേകാനന്ദ റെസിഡൻഷ്യൽ അസോസിയേഷൻൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3423.jpeg",
    },
    {
      src: "assets/img/Pastevents/3424.jpeg",
      caption:
        "വള്ളംകോട് വിവേകാനന്ദ റെസിഡൻഷ്യൽ അസോസിയേഷൻൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3424.jpeg",
    },
    {
      src: "assets/img/Pastevents/3425.jpeg",
      caption:
        "വള്ളംകോട് വിവേകാനന്ദ റെസിഡൻഷ്യൽ അസോസിയേഷൻൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3425.jpeg",
    },
    {
      src: "assets/img/Pastevents/3426.jpeg",
      caption:
        "വള്ളംകോട് വിവേകാനന്ദ റെസിഡൻഷ്യൽ അസോസിയേഷൻൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3426.jpeg",
    },
    {
      src: "assets/img/Pastevents/3427.jpeg",
      caption:
        "വള്ളംകോട് വിവേകാനന്ദ റെസിഡൻഷ്യൽ അസോസിയേഷൻൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3427.jpeg",
    },
    {
      src: "assets/img/Pastevents/3415.jpeg",
      caption:
        "പേയാട് കേരളാ വ്യാപാരി വ്യവസായി ഏകോപന സമിതിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3415.jpeg",
    },
    {
      src: "assets/img/Pastevents/3416.jpeg",
      caption:
        "പേയാട് കേരളാ വ്യാപാരി വ്യവസായി ഏകോപന സമിതിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3416.jpeg",
    },
    {
      src: "assets/img/Pastevents/3417.jpeg",
      caption:
        "പേയാട് കേരളാ വ്യാപാരി വ്യവസായി ഏകോപന സമിതിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3417.jpeg",
    },
    {
      src: "assets/img/Pastevents/3418.jpeg",
      caption:
        "പേയാട് കേരളാ വ്യാപാരി വ്യവസായി ഏകോപന സമിതിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3418.jpeg",
    },
    {
      src: "assets/img/Pastevents/3419.jpeg",
      caption:
        "പേയാട് കേരളാ വ്യാപാരി വ്യവസായി ഏകോപന സമിതിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3419.jpeg",
    },
    {
      src: "assets/img/Pastevents/3420.jpeg",
      caption:
        "പേയാട് കേരളാ വ്യാപാരി വ്യവസായി ഏകോപന സമിതിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3420.jpeg",
    },
    {
      src: "assets/img/Pastevents/3421.jpeg",
      caption:
        "പേയാട് കേരളാ വ്യാപാരി വ്യവസായി ഏകോപന സമിതിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3421.jpeg",
    },
    {
      src: "assets/img/Pastevents/3408.jpeg",
      caption:
        "വട്ടപ്പാറ ജവഹർ റൂറൽ സഹകരണ സംഘം,ട്രിവാൻഡ്രം നോർത്ത് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3408.jpeg",
    },
    {
      src: "assets/img/Pastevents/3409.jpeg",
      caption:
        "വട്ടപ്പാറ ജവഹർ റൂറൽ സഹകരണ സംഘം,ട്രിവാൻഡ്രം നോർത്ത് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3409.jpeg",
    },
    {
      src: "assets/img/Pastevents/3410.jpeg",
      caption:
        "വട്ടപ്പാറ ജവഹർ റൂറൽ സഹകരണ സംഘം,ട്രിവാൻഡ്രം നോർത്ത് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3410.jpeg",
    },
    {
      src: "assets/img/Pastevents/3411.jpeg",
      caption:
        "വട്ടപ്പാറ ജവഹർ റൂറൽ സഹകരണ സംഘം,ട്രിവാൻഡ്രം നോർത്ത് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3411.jpeg",
    },
    {
      src: "assets/img/Pastevents/3412.jpeg",
      caption:
        "വട്ടപ്പാറ ജവഹർ റൂറൽ സഹകരണ സംഘം,ട്രിവാൻഡ്രം നോർത്ത് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3412.jpeg",
    },
    {
      src: "assets/img/Pastevents/3413.jpeg",
      caption:
        "വട്ടപ്പാറ ജവഹർ റൂറൽ സഹകരണ സംഘം,ട്രിവാൻഡ്രം നോർത്ത് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3413.jpeg",
    },
    {
      src: "assets/img/Pastevents/3414.jpeg",
      caption:
        "വട്ടപ്പാറ ജവഹർ റൂറൽ സഹകരണ സംഘം,ട്രിവാൻഡ്രം നോർത്ത് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3414.jpeg",
    },
    {
      src: "assets/img/Pastevents/3402.jpeg",
      caption:
        " KSRTC  ആരംഭിച്ച ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 100-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/34202.jpeg",
    },
    {
      src: "assets/img/Pastevents/3403.jpeg",
      caption:
        " KSRTC  ആരംഭിച്ച ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 100-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3403.jpeg",
    },
    {
      src: "assets/img/Pastevents/3404.jpeg",
      caption:
        " KSRTC  ആരംഭിച്ച ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 100-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3404.jpeg",
    },
    {
      src: "assets/img/Pastevents/3405.jpeg",
      caption:
        " KSRTC  ആരംഭിച്ച ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 100-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3405.jpeg",
    },
    {
      src: "assets/img/Pastevents/3406.jpeg",
      caption:
        " KSRTC  ആരംഭിച്ച ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 100-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3406.jpeg",
    },
    {
      src: "assets/img/Pastevents/3407.jpeg",
      caption:
        " KSRTC  ആരംഭിച്ച ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 100-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3407.jpeg",
    },
    {
      src: "assets/img/Pastevents/3394.jpeg",
      caption:
        "വെങ്കോട് ബെതനി നവജീവൻ ഇൻസ്റ്റിറ്റ്യൂട്ടിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3394.jpeg",
    },
    {
      src: "assets/img/Pastevents/3395.jpeg",
      caption:
        "വെങ്കോട് ബെതനി നവജീവൻ ഇൻസ്റ്റിറ്റ്യൂട്ടിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3395.jpeg",
    },
    {
      src: "assets/img/Pastevents/3396.jpeg",
      caption:
        "വെങ്കോട് ബെതനി നവജീവൻ ഇൻസ്റ്റിറ്റ്യൂട്ടിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3396.jpeg",
    },
    {
      src: "assets/img/Pastevents/3397.jpeg",
      caption:
        "വെങ്കോട് ബെതനി നവജീവൻ ഇൻസ്റ്റിറ്റ്യൂട്ടിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3397.jpeg",
    },
    {
      src: "assets/img/Pastevents/3398.jpeg",
      caption:
        "വെങ്കോട് ബെതനി നവജീവൻ ഇൻസ്റ്റിറ്റ്യൂട്ടിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3398.jpeg",
    },
    {
      src: "assets/img/Pastevents/3399.jpeg",
      caption:
        "വെങ്കോട് ബെതനി നവജീവൻ ഇൻസ്റ്റിറ്റ്യൂട്ടിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3399.jpeg",
    },
    {
      src: "assets/img/Pastevents/3400.jpeg",
      caption:
        "വെങ്കോട് ബെതനി നവജീവൻ ഇൻസ്റ്റിറ്റ്യൂട്ടിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3400.jpeg",
    },
    {
      src: "assets/img/Pastevents/3401.jpeg",
      caption:
        "വെങ്കോട് ബെതനി നവജീവൻ ഇൻസ്റ്റിറ്റ്യൂട്ടിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3401.jpeg",
    },
    {
      src: "assets/img/Pastevents/3388.jpeg",
      caption:
        "തൊളിക്കോട് അൽ - റിഫ പബ്ലിക് സ്കൂളിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3388.jpeg",
    },
    {
      src: "assets/img/Pastevents/3389.jpeg",
      caption:
        "തൊളിക്കോട് അൽ - റിഫ പബ്ലിക് സ്കൂളിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3389.jpeg",
    },
    {
      src: "assets/img/Pastevents/3390.jpeg",
      caption:
        "തൊളിക്കോട് അൽ - റിഫ പബ്ലിക് സ്കൂളിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3390.jpeg",
    },
    {
      src: "assets/img/Pastevents/3391.jpeg",
      caption:
        "തൊളിക്കോട് അൽ - റിഫ പബ്ലിക് സ്കൂളിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3391.jpeg",
    },
    {
      src: "assets/img/Pastevents/3392.jpeg",
      caption:
        "തൊളിക്കോട് അൽ - റിഫ പബ്ലിക് സ്കൂളിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3392.jpeg",
    },
    {
      src: "assets/img/Pastevents/3393.jpeg",
      caption:
        "തൊളിക്കോട് അൽ - റിഫ പബ്ലിക് സ്കൂളിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3393.jpeg",
    },
    {
      src: "assets/img/Pastevents/3383.jpeg",
      caption:
        "പരശുവയ്ക്കൽ കുഴിഞ്ഞാൻവിള സി എസ് ഐ ചർച്ചിൻ്റെയും   നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3383.jpeg",
    },
    {
      src: "assets/img/Pastevents/3384.jpeg",
      caption:
        "പരശുവയ്ക്കൽ കുഴിഞ്ഞാൻവിള സി എസ് ഐ ചർച്ചിൻ്റെയും   നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3384.jpeg",
    },
    {
      src: "assets/img/Pastevents/3385.jpeg",
      caption:
        "പരശുവയ്ക്കൽ കുഴിഞ്ഞാൻവിള സി എസ് ഐ ചർച്ചിൻ്റെയും   നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3385.jpeg",
    },
    {
      src: "assets/img/Pastevents/3386.jpeg",
      caption:
        "പരശുവയ്ക്കൽ കുഴിഞ്ഞാൻവിള സി എസ് ഐ ചർച്ചിൻ്റെയും   നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3386.jpeg",
    },
    {
      src: "assets/img/Pastevents/3387.jpeg",
      caption:
        "പരശുവയ്ക്കൽ കുഴിഞ്ഞാൻവിള സി എസ് ഐ ചർച്ചിൻ്റെയും   നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3387.jpeg",
    },
    {
      src: "assets/img/Pastevents/3376.jpeg",
      caption:
        "KSRTC  ആരംഭിച്ച ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 100-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3376.jpeg",
    },
    {
      src: "assets/img/Pastevents/3377.jpeg",
      caption:
        "KSRTC  ആരംഭിച്ച ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 100-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3377.jpeg",
    },
    {
      src: "assets/img/Pastevents/3378.jpeg",
      caption:
        "KSRTC  ആരംഭിച്ച ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 100-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3378.jpeg",
    },
    {
      src: "assets/img/Pastevents/3379.jpeg",
      caption:
        "KSRTC  ആരംഭിച്ച ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 100-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3379.jpeg",
    },
    {
      src: "assets/img/Pastevents/3380.jpeg",
      caption:
        "KSRTC  ആരംഭിച്ച ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 100-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3380.jpeg",
    },
    {
      src: "assets/img/Pastevents/3381.jpeg",
      caption:
        "KSRTC  ആരംഭിച്ച ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 100-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3381.jpeg",
    },
    {
      src: "assets/img/Pastevents/3382.jpeg",
      caption:
        "KSRTC  ആരംഭിച്ച ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 100-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3382.jpeg",
    },
    {
      src: "assets/img/Pastevents/3369.jpeg",
      caption:
        "ഈസ്റ്റ് ഫോർട്ട് ഫോർട്ട് റെസിഡൻഷ്യൽ അസോസിയേഷൻ സിൽവർ ജൂബിലി ആഘോഷതിൻ്റെയ് ഭാഗമായി ട്രിവാൻഡ്രം ഫ്‌ളവർസ് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3369.jpeg",
    },
    {
      src: "assets/img/Pastevents/3370.jpeg",
      caption:
        "ഈസ്റ്റ് ഫോർട്ട് ഫോർട്ട് റെസിഡൻഷ്യൽ അസോസിയേഷൻ സിൽവർ ജൂബിലി ആഘോഷതിൻ്റെയ് ഭാഗമായി ട്രിവാൻഡ്രം ഫ്‌ളവർസ് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3370.jpeg",
    },
    {
      src: "assets/img/Pastevents/3371.jpeg",
      caption:
        "ഈസ്റ്റ് ഫോർട്ട് ഫോർട്ട് റെസിഡൻഷ്യൽ അസോസിയേഷൻ സിൽവർ ജൂബിലി ആഘോഷതിൻ്റെയ് ഭാഗമായി ട്രിവാൻഡ്രം ഫ്‌ളവർസ് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3371.jpeg",
    },
    {
      src: "assets/img/Pastevents/3372.jpeg",
      caption:
        "ഈസ്റ്റ് ഫോർട്ട് ഫോർട്ട് റെസിഡൻഷ്യൽ അസോസിയേഷൻ സിൽവർ ജൂബിലി ആഘോഷതിൻ്റെയ് ഭാഗമായി ട്രിവാൻഡ്രം ഫ്‌ളവർസ് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3372.jpeg",
    },
    {
      src: "assets/img/Pastevents/3373.jpeg",
      caption:
        "ഈസ്റ്റ് ഫോർട്ട് ഫോർട്ട് റെസിഡൻഷ്യൽ അസോസിയേഷൻ സിൽവർ ജൂബിലി ആഘോഷതിൻ്റെയ് ഭാഗമായി ട്രിവാൻഡ്രം ഫ്‌ളവർസ് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3373.jpeg",
    },
    {
      src: "assets/img/Pastevents/3374.jpeg",
      caption:
        "ഈസ്റ്റ് ഫോർട്ട് ഫോർട്ട് റെസിഡൻഷ്യൽ അസോസിയേഷൻ സിൽവർ ജൂബിലി ആഘോഷതിൻ്റെയ് ഭാഗമായി ട്രിവാൻഡ്രം ഫ്‌ളവർസ് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3374.jpeg",
    },
    {
      src: "assets/img/Pastevents/3375.jpeg",
      caption:
        "ഈസ്റ്റ് ഫോർട്ട് ഫോർട്ട് റെസിഡൻഷ്യൽ അസോസിയേഷൻ സിൽവർ ജൂബിലി ആഘോഷതിൻ്റെയ് ഭാഗമായി ട്രിവാൻഡ്രം ഫ്‌ളവർസ് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3375.jpeg",
    },
    {
      src: "assets/img/Pastevents/3362.jpeg",
      caption:
        "നന്ദാവനം പോലീസ് ലൈബ്രറി യൂണിറ്റ്, വിഴിഞ്ഞം ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3362.jpeg",
    },
    {
      src: "assets/img/Pastevents/3363.jpeg",
      caption:
        "നന്ദാവനം പോലീസ് ലൈബ്രറി യൂണിറ്റ്, വിഴിഞ്ഞം ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3363.jpeg",
    },
    {
      src: "assets/img/Pastevents/3364.jpeg",
      caption:
        "നന്ദാവനം പോലീസ് ലൈബ്രറി യൂണിറ്റ്, വിഴിഞ്ഞം ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3364.jpeg",
    },
    {
      src: "assets/img/Pastevents/3365.jpeg",
      caption:
        "നന്ദാവനം പോലീസ് ലൈബ്രറി യൂണിറ്റ്, വിഴിഞ്ഞം ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3365.jpeg",
    },
    {
      src: "assets/img/Pastevents/3366.jpeg",
      caption:
        "നന്ദാവനം പോലീസ് ലൈബ്രറി യൂണിറ്റ്, വിഴിഞ്ഞം ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3366.jpeg",
    },
    {
      src: "assets/img/Pastevents/3367.jpeg",
      caption:
        "നന്ദാവനം പോലീസ് ലൈബ്രറി യൂണിറ്റ്, വിഴിഞ്ഞം ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3367.jpeg",
    },
    {
      src: "assets/img/Pastevents/3368.jpeg",
      caption:
        "നന്ദാവനം പോലീസ് ലൈബ്രറി യൂണിറ്റ്, വിഴിഞ്ഞം ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3368.jpeg",
    },
    {
      src: "assets/img/Pastevents/3355.jpeg",
      caption:
        "വിഴിഞ്ഞം സെൻ്റ് ഫ്രാൻസിസ് സെയിൽസ് പബ്ലിക് സ്ക്കൂളിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3355.jpeg",
    },
    {
      src: "assets/img/Pastevents/3356.jpeg",
      caption:
        "വിഴിഞ്ഞം സെൻ്റ് ഫ്രാൻസിസ് സെയിൽസ് പബ്ലിക് സ്ക്കൂളിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3356.jpeg",
    },
    {
      src: "assets/img/Pastevents/3357.jpeg",
      caption:
        "വിഴിഞ്ഞം സെൻ്റ് ഫ്രാൻസിസ് സെയിൽസ് പബ്ലിക് സ്ക്കൂളിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3357.jpeg",
    },
    {
      src: "assets/img/Pastevents/3358.jpeg",
      caption:
        "വിഴിഞ്ഞം സെൻ്റ് ഫ്രാൻസിസ് സെയിൽസ് പബ്ലിക് സ്ക്കൂളിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3358.jpeg",
    },
    {
      src: "assets/img/Pastevents/3359.jpeg",
      caption:
        "വിഴിഞ്ഞം സെൻ്റ് ഫ്രാൻസിസ് സെയിൽസ് പബ്ലിക് സ്ക്കൂളിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3359.jpeg",
    },
    {
      src: "assets/img/Pastevents/3360.jpeg",
      caption:
        "വിഴിഞ്ഞം സെൻ്റ് ഫ്രാൻസിസ് സെയിൽസ് പബ്ലിക് സ്ക്കൂളിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3360.jpeg",
    },
    {
      src: "assets/img/Pastevents/3361.jpeg",
      caption:
        "വിഴിഞ്ഞം സെൻ്റ് ഫ്രാൻസിസ് സെയിൽസ് പബ്ലിക് സ്ക്കൂളിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3361.jpeg",
    },
    {
      src: "assets/img/Pastevents/3349.jpeg",
      caption:
        "തൊളിക്കോട് അൽ - റിഫ പബ്ലിക് സ്കൂളിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3349.jpeg",
    },
    {
      src: "assets/img/Pastevents/3350.jpeg",
      caption:
        "തൊളിക്കോട് അൽ - റിഫ പബ്ലിക് സ്കൂളിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3350.jpeg",
    },
    {
      src: "assets/img/Pastevents/3351.jpeg",
      caption:
        "തൊളിക്കോട് അൽ - റിഫ പബ്ലിക് സ്കൂളിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3351.jpeg",
    },
    {
      src: "assets/img/Pastevents/3352.jpeg",
      caption:
        "തൊളിക്കോട് അൽ - റിഫ പബ്ലിക് സ്കൂളിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3352.jpeg",
    },
    {
      src: "assets/img/Pastevents/3353.jpeg",
      caption:
        "തൊളിക്കോട് അൽ - റിഫ പബ്ലിക് സ്കൂളിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3353.jpeg",
    },
    {
      src: "assets/img/Pastevents/3354.jpeg",
      caption:
        "തൊളിക്കോട് അൽ - റിഫ പബ്ലിക് സ്കൂളിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3354.jpeg",
    },
    {
      src: "assets/img/Pastevents/3342.jpeg",
      caption:
        "പയറ്റുവിള സി എസ് ഐ ചർച്ചിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3342.jpeg",
    },
    {
      src: "assets/img/Pastevents/3343.jpeg",
      caption:
        "പയറ്റുവിള സി എസ് ഐ ചർച്ചിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3343.jpeg",
    },
    {
      src: "assets/img/Pastevents/3344.jpeg",
      caption:
        "പയറ്റുവിള സി എസ് ഐ ചർച്ചിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3344.jpeg",
    },
    {
      src: "assets/img/Pastevents/3345.jpeg",
      caption:
        "പയറ്റുവിള സി എസ് ഐ ചർച്ചിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3345.jpeg",
    },
    {
      src: "assets/img/Pastevents/3346.jpeg",
      caption:
        "പയറ്റുവിള സി എസ് ഐ ചർച്ചിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3346.jpeg",
    },
    {
      src: "assets/img/Pastevents/3347.jpeg",
      caption:
        "പയറ്റുവിള സി എസ് ഐ ചർച്ചിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3347.jpeg",
    },
    {
      src: "assets/img/Pastevents/3348.jpeg",
      caption:
        "പയറ്റുവിള സി എസ് ഐ ചർച്ചിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3348.jpeg",
    },
    {
      src: "assets/img/Pastevents/3335.jpeg",
      caption:
        "പെരുങ്ങള്ളൂർ മാർത്തോമ ഇടവക സീനിയർ സിറ്റിസൺ ഫെല്ലോഷിപ്പ്, ആയൂർ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3335.jpeg",
    },
    {
      src: "assets/img/Pastevents/3336.jpeg",
      caption:
        "പെരുങ്ങള്ളൂർ മാർത്തോമ ഇടവക സീനിയർ സിറ്റിസൺ ഫെല്ലോഷിപ്പ്, ആയൂർ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3336.jpeg",
    },
    {
      src: "assets/img/Pastevents/3337.jpeg",
      caption:
        "പെരുങ്ങള്ളൂർ മാർത്തോമ ഇടവക സീനിയർ സിറ്റിസൺ ഫെല്ലോഷിപ്പ്, ആയൂർ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3337.jpeg",
    },
    {
      src: "assets/img/Pastevents/3338.jpeg",
      caption:
        "പെരുങ്ങള്ളൂർ മാർത്തോമ ഇടവക സീനിയർ സിറ്റിസൺ ഫെല്ലോഷിപ്പ്, ആയൂർ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3338.jpeg",
    },
    {
      src: "assets/img/Pastevents/3339.jpeg",
      caption:
        "പെരുങ്ങള്ളൂർ മാർത്തോമ ഇടവക സീനിയർ സിറ്റിസൺ ഫെല്ലോഷിപ്പ്, ആയൂർ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3339.jpeg",
    },
    {
      src: "assets/img/Pastevents/3340.jpeg",
      caption:
        "പെരുങ്ങള്ളൂർ മാർത്തോമ ഇടവക സീനിയർ സിറ്റിസൺ ഫെല്ലോഷിപ്പ്, ആയൂർ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3340.jpeg",
    },
    {
      src: "assets/img/Pastevents/3341.jpeg",
      caption:
        "പെരുങ്ങള്ളൂർ മാർത്തോമ ഇടവക സീനിയർ സിറ്റിസൺ ഫെല്ലോഷിപ്പ്, ആയൂർ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3341.jpeg",
    },
    {
      src: "assets/img/Pastevents/3328.jpeg",
      caption:
        "ചടയമംഗലം ജഡയു ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3328.jpeg",
    },
    {
      src: "assets/img/Pastevents/3329.jpeg",
      caption:
        "ചടയമംഗലം ജഡയു ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3329.jpeg",
    },
    {
      src: "assets/img/Pastevents/3330.jpeg",
      caption:
        "ചടയമംഗലം ജഡയു ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3330.jpeg",
    },
    {
      src: "assets/img/Pastevents/3331.jpeg",
      caption:
        "ചടയമംഗലം ജഡയു ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3331.jpeg",
    },
    {
      src: "assets/img/Pastevents/3332.jpeg",
      caption:
        "ചടയമംഗലം ജഡയു ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3332.jpeg",
    },
    {
      src: "assets/img/Pastevents/3333.jpeg",
      caption:
        "ചടയമംഗലം ജഡയു ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3333.jpeg",
    },
    {
      src: "assets/img/Pastevents/3334.jpeg",
      caption:
        "ചടയമംഗലം ജഡയു ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3334.jpeg",
    },
    {
      src: "assets/img/Pastevents/3320.jpeg",
      caption:
        "ആലംകോട് ദാറുൽ ഇർഷാദ് ഇസ്ലാമിക് അക്കാദമിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3320.jpeg",
    },
    {
      src: "assets/img/Pastevents/3321.jpeg",
      caption:
        "ആലംകോട് ദാറുൽ ഇർഷാദ് ഇസ്ലാമിക് അക്കാദമിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3321.jpeg",
    },
    {
      src: "assets/img/Pastevents/3322.jpeg",
      caption:
        "ആലംകോട് ദാറുൽ ഇർഷാദ് ഇസ്ലാമിക് അക്കാദമിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3322.jpeg",
    },
    {
      src: "assets/img/Pastevents/3323.jpeg",
      caption:
        "ആലംകോട് ദാറുൽ ഇർഷാദ് ഇസ്ലാമിക് അക്കാദമിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3323.jpeg",
    },
    {
      src: "assets/img/Pastevents/3324.jpeg",
      caption:
        "ആലംകോട് ദാറുൽ ഇർഷാദ് ഇസ്ലാമിക് അക്കാദമിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3324.jpeg",
    },
    {
      src: "assets/img/Pastevents/3325.jpeg",
      caption:
        "ആലംകോട് ദാറുൽ ഇർഷാദ് ഇസ്ലാമിക് അക്കാദമിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3325.jpeg",
    },
    {
      src: "assets/img/Pastevents/3326.jpeg",
      caption:
        "ആലംകോട് ദാറുൽ ഇർഷാദ് ഇസ്ലാമിക് അക്കാദമിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3326.jpeg",
    },
    {
      src: "assets/img/Pastevents/3327.jpeg",
      caption:
        "ആലംകോട് ദാറുൽ ഇർഷാദ് ഇസ്ലാമിക് അക്കാദമിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3327.jpeg",
    },
    {
      src: "assets/img/Pastevents/3313.jpeg",
      caption:
        "ഇടപഴഞ്ഞി കൊച്ചാർ റോഡ് റെസിഡൻഷ്യൽ അസോസിയേഷൻ, ട്രിവാൻഡ്രം റോയൽ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3313.jpeg",
    },
    {
      src: "assets/img/Pastevents/3314.jpeg",
      caption:
        "ഇടപഴഞ്ഞി കൊച്ചാർ റോഡ് റെസിഡൻഷ്യൽ അസോസിയേഷൻ, ട്രിവാൻഡ്രം റോയൽ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3314.jpeg",
    },
    {
      src: "assets/img/Pastevents/3315.jpeg",
      caption:
        "ഇടപഴഞ്ഞി കൊച്ചാർ റോഡ് റെസിഡൻഷ്യൽ അസോസിയേഷൻ, ട്രിവാൻഡ്രം റോയൽ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3315.jpeg",
    },
    {
      src: "assets/img/Pastevents/3316.jpeg",
      caption:
        "ഇടപഴഞ്ഞി കൊച്ചാർ റോഡ് റെസിഡൻഷ്യൽ അസോസിയേഷൻ, ട്രിവാൻഡ്രം റോയൽ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3316.jpeg",
    },
    {
      src: "assets/img/Pastevents/3317.jpeg",
      caption:
        "ഇടപഴഞ്ഞി കൊച്ചാർ റോഡ് റെസിഡൻഷ്യൽ അസോസിയേഷൻ, ട്രിവാൻഡ്രം റോയൽ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3317.jpeg",
    },
    {
      src: "assets/img/Pastevents/3318.jpeg",
      caption:
        "ഇടപഴഞ്ഞി കൊച്ചാർ റോഡ് റെസിഡൻഷ്യൽ അസോസിയേഷൻ, ട്രിവാൻഡ്രം റോയൽ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3318.jpeg",
    },
    {
      src: "assets/img/Pastevents/3319.jpeg",
      caption:
        "ഇടപഴഞ്ഞി കൊച്ചാർ റോഡ് റെസിഡൻഷ്യൽ അസോസിയേഷൻ, ട്രിവാൻഡ്രം റോയൽ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3319.jpeg",
    },
    {
      src: "assets/img/Pastevents/3307.jpeg",
      caption:
        "പോത്തൻക്കോട് വൈഗ സാംസ്കാരിക സമിതിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3307.jpeg",
    },
    {
      src: "assets/img/Pastevents/3308.jpeg",
      caption:
        "പോത്തൻക്കോട് വൈഗ സാംസ്കാരിക സമിതിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3308.jpeg",
    },
    {
      src: "assets/img/Pastevents/3309.jpeg",
      caption:
        "പോത്തൻക്കോട് വൈഗ സാംസ്കാരിക സമിതിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3309.jpeg",
    },
    {
      src: "assets/img/Pastevents/3310.jpeg",
      caption:
        "പോത്തൻക്കോട് വൈഗ സാംസ്കാരിക സമിതിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3310.jpeg",
    },
    {
      src: "assets/img/Pastevents/3311.jpeg",
      caption:
        "പോത്തൻക്കോട് വൈഗ സാംസ്കാരിക സമിതിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3311.jpeg",
    },
    {
      src: "assets/img/Pastevents/3312.jpeg",
      caption:
        "പോത്തൻക്കോട് വൈഗ സാംസ്കാരിക സമിതിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3312.jpeg",
    },
    {
      src: "assets/img/Pastevents/3301.jpeg",
      caption:
        "പാപ്പന്നൂർ നാഗരാജ സേവാ സമിതി,ട്രിവാൻഡ്രം പ്ലാറ്റിനം ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3301.jpeg",
    },
    {
      src: "assets/img/Pastevents/3302.jpeg",
      caption:
        "പാപ്പന്നൂർ നാഗരാജ സേവാ സമിതി,ട്രിവാൻഡ്രം പ്ലാറ്റിനം ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3302.jpeg",
    },
    {
      src: "assets/img/Pastevents/3303.jpeg",
      caption:
        "പാപ്പന്നൂർ നാഗരാജ സേവാ സമിതി,ട്രിവാൻഡ്രം പ്ലാറ്റിനം ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3303.jpeg",
    },
    {
      src: "assets/img/Pastevents/3304.jpeg",
      caption:
        "പാപ്പന്നൂർ നാഗരാജ സേവാ സമിതി,ട്രിവാൻഡ്രം പ്ലാറ്റിനം ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3304.jpeg",
    },
    {
      src: "assets/img/Pastevents/3305.jpeg",
      caption:
        "പാപ്പന്നൂർ നാഗരാജ സേവാ സമിതി,ട്രിവാൻഡ്രം പ്ലാറ്റിനം ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3305.jpeg",
    },
    {
      src: "assets/img/Pastevents/3306.jpeg",
      caption:
        "പാപ്പന്നൂർ നാഗരാജ സേവാ സമിതി,ട്രിവാൻഡ്രം പ്ലാറ്റിനം ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3306.jpeg",
    },
    {
      src: "assets/img/Pastevents/3295.jpeg",
      caption:
        "ഇൻ്റർനാഷണൽ പോടിയാട്രിക് ദിനത്തോട് അനുബന്ധിച്ച് പശുകോട്ടുക്കോണം സി എസ് ഐ ചർച്ചിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3295.jpeg",
    },
    {
      src: "assets/img/Pastevents/3296.jpeg",
      caption:
        "ഇൻ്റർനാഷണൽ പോടിയാട്രിക് ദിനത്തോട് അനുബന്ധിച്ച് പശുകോട്ടുക്കോണം സി എസ് ഐ ചർച്ചിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3296.jpeg",
    },
    {
      src: "assets/img/Pastevents/3297.jpeg",
      caption:
        "ഇൻ്റർനാഷണൽ പോടിയാട്രിക് ദിനത്തോട് അനുബന്ധിച്ച് പശുകോട്ടുക്കോണം സി എസ് ഐ ചർച്ചിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3297.jpeg",
    },
    {
      src: "assets/img/Pastevents/3298.jpeg",
      caption:
        "ഇൻ്റർനാഷണൽ പോടിയാട്രിക് ദിനത്തോട് അനുബന്ധിച്ച് പശുകോട്ടുക്കോണം സി എസ് ഐ ചർച്ചിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3298.jpeg",
    },
    {
      src: "assets/img/Pastevents/3299.jpeg",
      caption:
        "ഇൻ്റർനാഷണൽ പോടിയാട്രിക് ദിനത്തോട് അനുബന്ധിച്ച് പശുകോട്ടുക്കോണം സി എസ് ഐ ചർച്ചിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3299.jpeg",
    },
    {
      src: "assets/img/Pastevents/3300.jpeg",
      caption:
        "ഇൻ്റർനാഷണൽ പോടിയാട്രിക് ദിനത്തോട് അനുബന്ധിച്ച് പശുകോട്ടുക്കോണം സി എസ് ഐ ചർച്ചിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3300.jpeg",
    },
    {
      src: "assets/img/Pastevents/3288.jpeg",
      caption:
        "ൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3288.jpeg",
    },
    {
      src: "assets/img/Pastevents/3289.jpeg",
      caption:
        "ൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3289.jpeg",
    },
    {
      src: "assets/img/Pastevents/3290.jpeg",
      caption:
        "ൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3290.jpeg",
    },
    {
      src: "assets/img/Pastevents/3291.jpeg",
      caption:
        "ൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3291.jpeg",
    },
    {
      src: "assets/img/Pastevents/3292.jpeg",
      caption:
        "ൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3292.jpeg",
    },
    {
      src: "assets/img/Pastevents/3293.jpeg",
      caption:
        "ൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3293.jpeg",
    },
    {
      src: "assets/img/Pastevents/3294.jpeg",
      caption:
        "ൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3294.jpeg",
    },
    {
      src: "assets/img/Pastevents/3281.jpeg",
      caption:
        "വഴുതക്കാട് കാർമൽ സ്ക്കൂൾ ഗ്രാൻഡ് പരെൻ്റ്സ് ഡേ ഭാഗമായി നിംസ് മൈക്രോ ക്ലിനിക്ക് ആൻഡ് വത്സലാ നഴ്സിംഗ് ഹോമിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3281.jpeg",
    },
    {
      src: "assets/img/Pastevents/3282.jpeg",
      caption:
        "വഴുതക്കാട് കാർമൽ സ്ക്കൂൾ ഗ്രാൻഡ് പരെൻ്റ്സ് ഡേ ഭാഗമായി നിംസ് മൈക്രോ ക്ലിനിക്ക് ആൻഡ് വത്സലാ നഴ്സിംഗ് ഹോമിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3282.jpeg",
    },
    {
      src: "assets/img/Pastevents/3283.jpeg",
      caption:
        "വഴുതക്കാട് കാർമൽ സ്ക്കൂൾ ഗ്രാൻഡ് പരെൻ്റ്സ് ഡേ ഭാഗമായി നിംസ് മൈക്രോ ക്ലിനിക്ക് ആൻഡ് വത്സലാ നഴ്സിംഗ് ഹോമിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3283.jpeg",
    },
    {
      src: "assets/img/Pastevents/3284.jpeg",
      caption:
        "വഴുതക്കാട് കാർമൽ സ്ക്കൂൾ ഗ്രാൻഡ് പരെൻ്റ്സ് ഡേ ഭാഗമായി നിംസ് മൈക്രോ ക്ലിനിക്ക് ആൻഡ് വത്സലാ നഴ്സിംഗ് ഹോമിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3284.jpeg",
    },
    {
      src: "assets/img/Pastevents/3285.jpeg",
      caption:
        "വഴുതക്കാട് കാർമൽ സ്ക്കൂൾ ഗ്രാൻഡ് പരെൻ്റ്സ് ഡേ ഭാഗമായി നിംസ് മൈക്രോ ക്ലിനിക്ക് ആൻഡ് വത്സലാ നഴ്സിംഗ് ഹോമിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3285.jpeg",
    },
    {
      src: "assets/img/Pastevents/3286.jpeg",
      caption:
        "വഴുതക്കാട് കാർമൽ സ്ക്കൂൾ ഗ്രാൻഡ് പരെൻ്റ്സ് ഡേ ഭാഗമായി നിംസ് മൈക്രോ ക്ലിനിക്ക് ആൻഡ് വത്സലാ നഴ്സിംഗ് ഹോമിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3286.jpeg",
    },
    {
      src: "assets/img/Pastevents/3287.jpeg",
      caption:
        "വഴുതക്കാട് കാർമൽ സ്ക്കൂൾ ഗ്രാൻഡ് പരെൻ്റ്സ് ഡേ ഭാഗമായി നിംസ് മൈക്രോ ക്ലിനിക്ക് ആൻഡ് വത്സലാ നഴ്സിംഗ് ഹോമിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3287.jpeg",
    },
    {
      src: "assets/img/Pastevents/3276.jpeg",
      caption:
        "പുല്ലുവിള വിജയ് ഫാൻസ് അസോസിയേഷൻൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3276.jpeg",
    },
    {
      src: "assets/img/Pastevents/3277.jpeg",
      caption:
        "പുല്ലുവിള വിജയ് ഫാൻസ് അസോസിയേഷൻൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3277.jpeg",
    },
    {
      src: "assets/img/Pastevents/3278.jpeg",
      caption:
        "പുല്ലുവിള വിജയ് ഫാൻസ് അസോസിയേഷൻൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3278.jpeg",
    },
    {
      src: "assets/img/Pastevents/3279.jpeg",
      caption:
        "പുല്ലുവിള വിജയ് ഫാൻസ് അസോസിയേഷൻൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3279.jpeg",
    },
    {
      src: "assets/img/Pastevents/3280.jpeg",
      caption:
        "പുല്ലുവിള വിജയ് ഫാൻസ് അസോസിയേഷൻൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3280.jpeg",
    },
    {
      src: "assets/img/Pastevents/3268.jpeg",
      caption:
        "ചുള്ളാളം കെ എമ്മ് എഫ് വൈ കനിവ് പള്ളിമുക്ക് യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3268.jpeg",
    },
    {
      src: "assets/img/Pastevents/3269.jpeg",
      caption:
        "ചുള്ളാളം കെ എമ്മ് എഫ് വൈ കനിവ് പള്ളിമുക്ക് യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3269.jpeg",
    },
    {
      src: "assets/img/Pastevents/3270.jpeg",
      caption:
        "ചുള്ളാളം കെ എമ്മ് എഫ് വൈ കനിവ് പള്ളിമുക്ക് യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3270.jpeg",
    },
    {
      src: "assets/img/Pastevents/3271.jpeg",
      caption:
        "ചുള്ളാളം കെ എമ്മ് എഫ് വൈ കനിവ് പള്ളിമുക്ക് യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3271.jpeg",
    },
    {
      src: "assets/img/Pastevents/3272.jpeg",
      caption:
        "ചുള്ളാളം കെ എമ്മ് എഫ് വൈ കനിവ് പള്ളിമുക്ക് യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3272.jpeg",
    },
    {
      src: "assets/img/Pastevents/3273.jpeg",
      caption:
        "ചുള്ളാളം കെ എമ്മ് എഫ് വൈ കനിവ് പള്ളിമുക്ക് യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3273.jpeg",
    },
    {
      src: "assets/img/Pastevents/3274.jpeg",
      caption:
        "ചുള്ളാളം കെ എമ്മ് എഫ് വൈ കനിവ് പള്ളിമുക്ക് യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3274.jpeg",
    },
    {
      src: "assets/img/Pastevents/3275.jpeg",
      caption:
        "ചുള്ളാളം കെ എമ്മ് എഫ് വൈ കനിവ് പള്ളിമുക്ക് യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3275.jpeg",
    },
    {
      src: "assets/img/Pastevents/3262.jpeg",
      caption:
        "തെന്നൂർ ഗ്രാമീണ ആർട്ട്സ് ആൻഡ് സ്പോർട്സ് ക്ലബ്ബ്,ട്രിവാൻഡ്രം നോവ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3262.jpeg",
    },
    {
      src: "assets/img/Pastevents/3263.jpeg",
      caption:
        "തെന്നൂർ ഗ്രാമീണ ആർട്ട്സ് ആൻഡ് സ്പോർട്സ് ക്ലബ്ബ്,ട്രിവാൻഡ്രം നോവ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3263.jpeg",
    },
    {
      src: "assets/img/Pastevents/3264.jpeg",
      caption:
        "തെന്നൂർ ഗ്രാമീണ ആർട്ട്സ് ആൻഡ് സ്പോർട്സ് ക്ലബ്ബ്,ട്രിവാൻഡ്രം നോവ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3264.jpeg",
    },
    {
      src: "assets/img/Pastevents/3265.jpeg",
      caption:
        "തെന്നൂർ ഗ്രാമീണ ആർട്ട്സ് ആൻഡ് സ്പോർട്സ് ക്ലബ്ബ്,ട്രിവാൻഡ്രം നോവ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3265.jpeg",
    },
    {
      src: "assets/img/Pastevents/3266.jpeg",
      caption:
        "തെന്നൂർ ഗ്രാമീണ ആർട്ട്സ് ആൻഡ് സ്പോർട്സ് ക്ലബ്ബ്,ട്രിവാൻഡ്രം നോവ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3266.jpeg",
    },
    {
      src: "assets/img/Pastevents/3267.jpeg",
      caption:
        "തെന്നൂർ ഗ്രാമീണ ആർട്ട്സ് ആൻഡ് സ്പോർട്സ് ക്ലബ്ബ്,ട്രിവാൻഡ്രം നോവ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3267.jpeg",
    },
    {
      src: "assets/img/Pastevents/3256.jpeg",
      caption:
        "കരകുളം സ്നേഹ റെസിഡൻഷ്യൽ അസോസിയേഷൻ,ട്രിവാൻഡ്രം എലൈറ്റ് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3256.jpeg",
    },
    {
      src: "assets/img/Pastevents/3257.jpeg",
      caption:
        "കരകുളം സ്നേഹ റെസിഡൻഷ്യൽ അസോസിയേഷൻ,ട്രിവാൻഡ്രം എലൈറ്റ് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3257.jpeg",
    },
    {
      src: "assets/img/Pastevents/3258.jpeg",
      caption:
        "കരകുളം സ്നേഹ റെസിഡൻഷ്യൽ അസോസിയേഷൻ,ട്രിവാൻഡ്രം എലൈറ്റ് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3258.jpeg",
    },
    {
      src: "assets/img/Pastevents/3259.jpeg",
      caption:
        "കരകുളം സ്നേഹ റെസിഡൻഷ്യൽ അസോസിയേഷൻ,ട്രിവാൻഡ്രം എലൈറ്റ് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3259.jpeg",
    },
    {
      src: "assets/img/Pastevents/3260.jpeg",
      caption:
        "കരകുളം സ്നേഹ റെസിഡൻഷ്യൽ അസോസിയേഷൻ,ട്രിവാൻഡ്രം എലൈറ്റ് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3260.jpeg",
    },
    {
      src: "assets/img/Pastevents/3261.jpeg",
      caption:
        "കരകുളം സ്നേഹ റെസിഡൻഷ്യൽ അസോസിയേഷൻ,ട്രിവാൻഡ്രം എലൈറ്റ് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3261.jpeg",
    },
    {
      src: "assets/img/Pastevents/3250.jpeg",
      caption:
        "പള്ളിച്ചൽ ഡിവൈഎഫ്ഐ യൂണിറ്റ്, വിഴിഞ്ഞം സീ പോർട്ട്  ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3250.jpeg",
    },
    {
      src: "assets/img/Pastevents/3251.jpeg",
      caption:
        "പള്ളിച്ചൽ ഡിവൈഎഫ്ഐ യൂണിറ്റ്, വിഴിഞ്ഞം സീ പോർട്ട്  ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3251.jpeg",
    },
    {
      src: "assets/img/Pastevents/3252.jpeg",
      caption:
        "പള്ളിച്ചൽ ഡിവൈഎഫ്ഐ യൂണിറ്റ്, വിഴിഞ്ഞം സീ പോർട്ട്  ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3252.jpeg",
    },
    {
      src: "assets/img/Pastevents/3253.jpeg",
      caption:
        "പള്ളിച്ചൽ ഡിവൈഎഫ്ഐ യൂണിറ്റ്, വിഴിഞ്ഞം സീ പോർട്ട്  ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3253.jpeg",
    },
    {
      src: "assets/img/Pastevents/3254.jpeg",
      caption:
        "പള്ളിച്ചൽ ഡിവൈഎഫ്ഐ യൂണിറ്റ്, വിഴിഞ്ഞം സീ പോർട്ട്  ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3254.jpeg",
    },
    {
      src: "assets/img/Pastevents/3255.jpeg",
      caption:
        "പള്ളിച്ചൽ ഡിവൈഎഫ്ഐ യൂണിറ്റ്, വിഴിഞ്ഞം സീ പോർട്ട്  ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3255.jpeg",
    },
    {
      src: "assets/img/Pastevents/3243.jpeg",
      caption:
        " കവളാക്കുളം ഹാപ്പി ഹോം ഓൾഡേജ് ഹോമിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3243.jpeg",
    },
    {
      src: "assets/img/Pastevents/3244.jpeg",
      caption:
        " കവളാക്കുളം ഹാപ്പി ഹോം ഓൾഡേജ് ഹോമിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3244.jpeg",
    },
    {
      src: "assets/img/Pastevents/3245.jpeg",
      caption:
        " കവളാക്കുളം ഹാപ്പി ഹോം ഓൾഡേജ് ഹോമിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3245.jpeg",
    },
    {
      src: "assets/img/Pastevents/3246.jpeg",
      caption:
        " കവളാക്കുളം ഹാപ്പി ഹോം ഓൾഡേജ് ഹോമിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3246.jpeg",
    },
    {
      src: "assets/img/Pastevents/3247.jpeg",
      caption:
        " കവളാക്കുളം ഹാപ്പി ഹോം ഓൾഡേജ് ഹോമിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3247.jpeg",
    },
    {
      src: "assets/img/Pastevents/3248.jpeg",
      caption:
        " കവളാക്കുളം ഹാപ്പി ഹോം ഓൾഡേജ് ഹോമിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3248.jpeg",
    },
    {
      src: "assets/img/Pastevents/3249.jpeg",
      caption:
        " കവളാക്കുളം ഹാപ്പി ഹോം ഓൾഡേജ് ഹോമിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3249.jpeg",
    },
    {
      src: "assets/img/Pastevents/3236.jpeg",
      caption:
        "നഗരൂർ മുസ്‌ലിം ജുമാ മസ്ജിദ്, കടവിള റെസിഡൻഷ്യൽ അസോസിയേഷൻ, നഗരൂർ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3236.jpeg",
    },
    {
      src: "assets/img/Pastevents/3237.jpeg",
      caption:
        "നഗരൂർ മുസ്‌ലിം ജുമാ മസ്ജിദ്, കടവിള റെസിഡൻഷ്യൽ അസോസിയേഷൻ, നഗരൂർ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3237.jpeg",
    },
    {
      src: "assets/img/Pastevents/3238.jpeg",
      caption:
        "നഗരൂർ മുസ്‌ലിം ജുമാ മസ്ജിദ്, കടവിള റെസിഡൻഷ്യൽ അസോസിയേഷൻ, നഗരൂർ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3238.jpeg",
    },
    {
      src: "assets/img/Pastevents/3239.jpeg",
      caption:
        "നഗരൂർ മുസ്‌ലിം ജുമാ മസ്ജിദ്, കടവിള റെസിഡൻഷ്യൽ അസോസിയേഷൻ, നഗരൂർ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3239.jpeg",
    },
    {
      src: "assets/img/Pastevents/3240.jpeg",
      caption:
        "നഗരൂർ മുസ്‌ലിം ജുമാ മസ്ജിദ്, കടവിള റെസിഡൻഷ്യൽ അസോസിയേഷൻ, നഗരൂർ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3240.jpeg",
    },
    {
      src: "assets/img/Pastevents/3241.jpeg",
      caption:
        "നഗരൂർ മുസ്‌ലിം ജുമാ മസ്ജിദ്, കടവിള റെസിഡൻഷ്യൽ അസോസിയേഷൻ, നഗരൂർ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3241.jpeg",
    },
    {
      src: "assets/img/Pastevents/3242.jpeg",
      caption:
        "നഗരൂർ മുസ്‌ലിം ജുമാ മസ്ജിദ്, കടവിള റെസിഡൻഷ്യൽ അസോസിയേഷൻ, നഗരൂർ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3242.jpeg",
    },
    {
      src: "assets/img/Pastevents/3229.jpeg",
      caption:
        "ബാലരാമപുരം വടക്കേവിള സലാഫി വെൽഫെയർ സെൻ്ററിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3229.jpeg",
    },
    {
      src: "assets/img/Pastevents/3230.jpeg",
      caption:
        "ബാലരാമപുരം വടക്കേവിള സലാഫി വെൽഫെയർ സെൻ്ററിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3230.jpeg",
    },
    {
      src: "assets/img/Pastevents/3231.jpeg",
      caption:
        "ബാലരാമപുരം വടക്കേവിള സലാഫി വെൽഫെയർ സെൻ്ററിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3231.jpeg",
    },
    {
      src: "assets/img/Pastevents/3232.jpeg",
      caption:
        "ബാലരാമപുരം വടക്കേവിള സലാഫി വെൽഫെയർ സെൻ്ററിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3232.jpeg",
    },
    {
      src: "assets/img/Pastevents/3233.jpeg",
      caption:
        "ബാലരാമപുരം വടക്കേവിള സലാഫി വെൽഫെയർ സെൻ്ററിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3233.jpeg",
    },
    {
      src: "assets/img/Pastevents/3234.jpeg",
      caption:
        "ബാലരാമപുരം വടക്കേവിള സലാഫി വെൽഫെയർ സെൻ്ററിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3234.jpeg",
    },
    {
      src: "assets/img/Pastevents/3235.jpeg",
      caption:
        "ബാലരാമപുരം വടക്കേവിള സലാഫി വെൽഫെയർ സെൻ്ററിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3235.jpeg",
    },
    {
      src: "assets/img/Pastevents/3223.jpeg",
      caption:
        "ജഗതി ഈശ്വര വിലാസം റെസിഡൻഷ്യൽ അസോസിയേഷൻ,ട്രിവാൻഡ്രം നോബിൾ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3223.jpeg",
    },
    {
      src: "assets/img/Pastevents/3224.jpeg",
      caption:
        "ജഗതി ഈശ്വര വിലാസം റെസിഡൻഷ്യൽ അസോസിയേഷൻ,ട്രിവാൻഡ്രം നോബിൾ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3224.jpeg",
    },
    {
      src: "assets/img/Pastevents/3225.jpeg",
      caption:
        "ജഗതി ഈശ്വര വിലാസം റെസിഡൻഷ്യൽ അസോസിയേഷൻ,ട്രിവാൻഡ്രം നോബിൾ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3225.jpeg",
    },
    {
      src: "assets/img/Pastevents/3226.jpeg",
      caption:
        "ജഗതി ഈശ്വര വിലാസം റെസിഡൻഷ്യൽ അസോസിയേഷൻ,ട്രിവാൻഡ്രം നോബിൾ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3226.jpeg",
    },
    {
      src: "assets/img/Pastevents/3227.jpeg",
      caption:
        "ജഗതി ഈശ്വര വിലാസം റെസിഡൻഷ്യൽ അസോസിയേഷൻ,ട്രിവാൻഡ്രം നോബിൾ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3227.jpeg",
    },
    {
      src: "assets/img/Pastevents/3228.jpeg",
      caption:
        "ജഗതി ഈശ്വര വിലാസം റെസിഡൻഷ്യൽ അസോസിയേഷൻ,ട്രിവാൻഡ്രം നോബിൾ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3228.jpeg",
    },
    {
      src: "assets/img/Pastevents/3215.jpeg",
      caption:
        "നെയ്യാറ്റിൻകര മുനിസിപ്പാലിറ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ പി കെ രാജ്മോഹൻ (മുൻസിപ്പൽ ചെയർമാൻ). ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3215.jpeg",
    },
    {
      src: "assets/img/Pastevents/3216.jpeg",
      caption:
        "നെയ്യാറ്റിൻകര മുനിസിപ്പാലിറ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ പി കെ രാജ്മോഹൻ (മുൻസിപ്പൽ ചെയർമാൻ). ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3216.jpeg",
    },
    {
      src: "assets/img/Pastevents/3217.jpeg",
      caption:
        "നെയ്യാറ്റിൻകര മുനിസിപ്പാലിറ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ പി കെ രാജ്മോഹൻ (മുൻസിപ്പൽ ചെയർമാൻ). ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3217.jpeg",
    },
    {
      src: "assets/img/Pastevents/3218.jpeg",
      caption:
        "നെയ്യാറ്റിൻകര മുനിസിപ്പാലിറ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ പി കെ രാജ്മോഹൻ (മുൻസിപ്പൽ ചെയർമാൻ). ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3218.jpeg",
    },
    {
      src: "assets/img/Pastevents/3219.jpeg",
      caption:
        "നെയ്യാറ്റിൻകര മുനിസിപ്പാലിറ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ പി കെ രാജ്മോഹൻ (മുൻസിപ്പൽ ചെയർമാൻ). ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3219.jpeg",
    },
    {
      src: "assets/img/Pastevents/3220.jpeg",
      caption:
        "നെയ്യാറ്റിൻകര മുനിസിപ്പാലിറ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ പി കെ രാജ്മോഹൻ (മുൻസിപ്പൽ ചെയർമാൻ). ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3220.jpeg",
    },
    {
      src: "assets/img/Pastevents/3221.jpeg",
      caption:
        "നെയ്യാറ്റിൻകര മുനിസിപ്പാലിറ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ പി കെ രാജ്മോഹൻ (മുൻസിപ്പൽ ചെയർമാൻ). ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3221.jpeg",
    },
    {
      src: "assets/img/Pastevents/3222.jpeg",
      caption:
        "നെയ്യാറ്റിൻകര മുനിസിപ്പാലിറ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ പി കെ രാജ്മോഹൻ (മുൻസിപ്പൽ ചെയർമാൻ). ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3222.jpeg",
    },
    {
      src: "assets/img/Pastevents/3209.jpeg",
      caption:
        "പുനലാൽ ഡേയിൽ വ്യൂ കോളേജ് ഓഫ് ഫാർമസിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3209.jpeg",
    },
    {
      src: "assets/img/Pastevents/3210.jpeg",
      caption:
        "പുനലാൽ ഡേയിൽ വ്യൂ കോളേജ് ഓഫ് ഫാർമസിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3210.jpeg",
    },
    {
      src: "assets/img/Pastevents/3211.jpeg",
      caption:
        "പുനലാൽ ഡേയിൽ വ്യൂ കോളേജ് ഓഫ് ഫാർമസിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3211.jpeg",
    },
    {
      src: "assets/img/Pastevents/3212.jpeg",
      caption:
        "പുനലാൽ ഡേയിൽ വ്യൂ കോളേജ് ഓഫ് ഫാർമസിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3212.jpeg",
    },
    {
      src: "assets/img/Pastevents/3213.jpeg",
      caption:
        "പുനലാൽ ഡേയിൽ വ്യൂ കോളേജ് ഓഫ് ഫാർമസിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3213.jpeg",
    },
    {
      src: "assets/img/Pastevents/3214.jpeg",
      caption:
        "പുനലാൽ ഡേയിൽ വ്യൂ കോളേജ് ഓഫ് ഫാർമസിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3214.jpeg",
    },
    {
      src: "assets/img/Pastevents/3202.jpeg",
      caption:
        "വെള്ളറട സെവൻത് ഡേ അഡ്വൻ്റിസ്റ്റ് ചർച്ച്, പബ്ലിക് ക്യാമ്പസ് മിനിസ്ട്രിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ സി കെ ഹരീന്ദ്രൻ (എം എൽ എ). ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3202.jpeg",
    },
    {
      src: "assets/img/Pastevents/3203.jpeg",
      caption:
        "വെള്ളറട സെവൻത് ഡേ അഡ്വൻ്റിസ്റ്റ് ചർച്ച്, പബ്ലിക് ക്യാമ്പസ് മിനിസ്ട്രിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ സി കെ ഹരീന്ദ്രൻ (എം എൽ എ). ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3203.jpeg",
    },
    {
      src: "assets/img/Pastevents/3204.jpeg",
      caption:
        "വെള്ളറട സെവൻത് ഡേ അഡ്വൻ്റിസ്റ്റ് ചർച്ച്, പബ്ലിക് ക്യാമ്പസ് മിനിസ്ട്രിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ സി കെ ഹരീന്ദ്രൻ (എം എൽ എ). ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3204.jpeg",
    },
    {
      src: "assets/img/Pastevents/3205.jpeg",
      caption:
        "വെള്ളറട സെവൻത് ഡേ അഡ്വൻ്റിസ്റ്റ് ചർച്ച്, പബ്ലിക് ക്യാമ്പസ് മിനിസ്ട്രിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ സി കെ ഹരീന്ദ്രൻ (എം എൽ എ). ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3205.jpeg",
    },
    {
      src: "assets/img/Pastevents/3206.jpeg",
      caption:
        "വെള്ളറട സെവൻത് ഡേ അഡ്വൻ്റിസ്റ്റ് ചർച്ച്, പബ്ലിക് ക്യാമ്പസ് മിനിസ്ട്രിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ സി കെ ഹരീന്ദ്രൻ (എം എൽ എ). ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3206.jpeg",
    },
    {
      src: "assets/img/Pastevents/3207.jpeg",
      caption:
        "വെള്ളറട സെവൻത് ഡേ അഡ്വൻ്റിസ്റ്റ് ചർച്ച്, പബ്ലിക് ക്യാമ്പസ് മിനിസ്ട്രിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ സി കെ ഹരീന്ദ്രൻ (എം എൽ എ). ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3207.jpeg",
    },
    {
      src: "assets/img/Pastevents/3208.jpeg",
      caption:
        "വെള്ളറട സെവൻത് ഡേ അഡ്വൻ്റിസ്റ്റ് ചർച്ച്, പബ്ലിക് ക്യാമ്പസ് മിനിസ്ട്രിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ സി കെ ഹരീന്ദ്രൻ (എം എൽ എ). ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3208.jpeg",
    },
    {
      src: "assets/img/Pastevents/3195.jpeg",
      caption:
        "പാപ്പന്നൂർ നാഗരാജ സേവാ സമിതി,ട്രിവാൻഡ്രം പ്ലാറ്റിനം ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3195.jpeg",
    },
    {
      src: "assets/img/Pastevents/3196.jpeg",
      caption:
        "പാപ്പന്നൂർ നാഗരാജ സേവാ സമിതി,ട്രിവാൻഡ്രം പ്ലാറ്റിനം ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3196.jpeg",
    },
    {
      src: "assets/img/Pastevents/3197.jpeg",
      caption:
        "പാപ്പന്നൂർ നാഗരാജ സേവാ സമിതി,ട്രിവാൻഡ്രം പ്ലാറ്റിനം ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3197.jpeg",
    },
    {
      src: "assets/img/Pastevents/3198.jpeg",
      caption:
        "പാപ്പന്നൂർ നാഗരാജ സേവാ സമിതി,ട്രിവാൻഡ്രം പ്ലാറ്റിനം ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3198.jpeg",
    },
    {
      src: "assets/img/Pastevents/3199.jpeg",
      caption:
        "പാപ്പന്നൂർ നാഗരാജ സേവാ സമിതി,ട്രിവാൻഡ്രം പ്ലാറ്റിനം ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3199.jpeg",
    },
    {
      src: "assets/img/Pastevents/3200.jpeg",
      caption:
        "പാപ്പന്നൂർ നാഗരാജ സേവാ സമിതി,ട്രിവാൻഡ്രം പ്ലാറ്റിനം ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3200.jpeg",
    },
    {
      src: "assets/img/Pastevents/3201.jpeg",
      caption:
        "പാപ്പന്നൂർ നാഗരാജ സേവാ സമിതി,ട്രിവാൻഡ്രം പ്ലാറ്റിനം ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3201.jpeg",
    },
    {
      src: "assets/img/Pastevents/3188.jpeg",
      caption:
        "കുരിയാത്തി ആനന്ദനിലയം,ട്രിവാൻഡ്രം ഇംപാക്ട് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3188.jpeg",
    },
    {
      src: "assets/img/Pastevents/3189.jpeg",
      caption:
        "കുരിയാത്തി ആനന്ദനിലയം,ട്രിവാൻഡ്രം ഇംപാക്ട് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3189.jpeg",
    },
    {
      src: "assets/img/Pastevents/3190.jpeg",
      caption:
        "കുരിയാത്തി ആനന്ദനിലയം,ട്രിവാൻഡ്രം ഇംപാക്ട് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3190.jpeg",
    },
    {
      src: "assets/img/Pastevents/3191.jpeg",
      caption:
        "കുരിയാത്തി ആനന്ദനിലയം,ട്രിവാൻഡ്രം ഇംപാക്ട് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3191.jpeg",
    },
    {
      src: "assets/img/Pastevents/3192.jpeg",
      caption:
        "കുരിയാത്തി ആനന്ദനിലയം,ട്രിവാൻഡ്രം ഇംപാക്ട് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3192.jpeg",
    },
    {
      src: "assets/img/Pastevents/3193.jpeg",
      caption:
        "കുരിയാത്തി ആനന്ദനിലയം,ട്രിവാൻഡ്രം ഇംപാക്ട് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3193.jpeg",
    },
    {
      src: "assets/img/Pastevents/3194.jpeg",
      caption:
        "കുരിയാത്തി ആനന്ദനിലയം,ട്രിവാൻഡ്രം ഇംപാക്ട് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3194.jpeg",
    },
    {
      src: "assets/img/Pastevents/3182.jpeg",
      caption:
        "കാച്ചാണി റെസിഡൻഷ്യൽ അസോസിയേഷൻ,ട്രിവാൻഡ്രം സിറ്റി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3182.jpeg",
    },
    {
      src: "assets/img/Pastevents/3183.jpeg",
      caption:
        "കാച്ചാണി റെസിഡൻഷ്യൽ അസോസിയേഷൻ,ട്രിവാൻഡ്രം സിറ്റി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3183.jpeg",
    },
    {
      src: "assets/img/Pastevents/3184.jpeg",
      caption:
        "കാച്ചാണി റെസിഡൻഷ്യൽ അസോസിയേഷൻ,ട്രിവാൻഡ്രം സിറ്റി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3184.jpeg",
    },
    {
      src: "assets/img/Pastevents/3185.jpeg",
      caption:
        "കാച്ചാണി റെസിഡൻഷ്യൽ അസോസിയേഷൻ,ട്രിവാൻഡ്രം സിറ്റി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3185.jpeg",
    },
    {
      src: "assets/img/Pastevents/3186.jpeg",
      caption:
        "കാച്ചാണി റെസിഡൻഷ്യൽ അസോസിയേഷൻ,ട്രിവാൻഡ്രം സിറ്റി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3186.jpeg",
    },
    {
      src: "assets/img/Pastevents/3187.jpeg",
      caption:
        "കാച്ചാണി റെസിഡൻഷ്യൽ അസോസിയേഷൻ,ട്രിവാൻഡ്രം സിറ്റി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3187.jpeg",
    },
    {
      src: "assets/img/Pastevents/3177.jpeg",
      caption:
        "കാച്ചാണി റെസിഡൻഷ്യൽ അസോസിയേഷൻ,ട്രിവാൻഡ്രം സിറ്റി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3177.jpeg",
    },
    {
      src: "assets/img/Pastevents/3178.jpeg",
      caption:
        "കാച്ചാണി റെസിഡൻഷ്യൽ അസോസിയേഷൻ,ട്രിവാൻഡ്രം സിറ്റി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3178.jpeg",
    },
    {
      src: "assets/img/Pastevents/3179.jpeg",
      caption:
        "കാച്ചാണി റെസിഡൻഷ്യൽ അസോസിയേഷൻ,ട്രിവാൻഡ്രം സിറ്റി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3179.jpeg",
    },
    {
      src: "assets/img/Pastevents/3180.jpeg",
      caption:
        "കാച്ചാണി റെസിഡൻഷ്യൽ അസോസിയേഷൻ,ട്രിവാൻഡ്രം സിറ്റി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3180.jpeg",
    },
    {
      src: "assets/img/Pastevents/3181.jpeg",
      caption:
        "കാച്ചാണി റെസിഡൻഷ്യൽ അസോസിയേഷൻ,ട്രിവാൻഡ്രം സിറ്റി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3181.jpeg",
    },
    {
      src: "assets/img/Pastevents/3171.jpeg",
      caption:
        "അടിമലത്തുറ ഫാത്തിമ മാതാ ചർച്ച്,ട്രിവാൻഡ്രം റോട്ടറി ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3171.jpeg",
    },
    {
      src: "assets/img/Pastevents/3172.jpeg",
      caption:
        "അടിമലത്തുറ ഫാത്തിമ മാതാ ചർച്ച്,ട്രിവാൻഡ്രം റോട്ടറി ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3172.jpeg",
    },
    {
      src: "assets/img/Pastevents/3173.jpeg",
      caption:
        "അടിമലത്തുറ ഫാത്തിമ മാതാ ചർച്ച്,ട്രിവാൻഡ്രം റോട്ടറി ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3173.jpeg",
    },
    {
      src: "assets/img/Pastevents/3174.jpeg",
      caption:
        "അടിമലത്തുറ ഫാത്തിമ മാതാ ചർച്ച്,ട്രിവാൻഡ്രം റോട്ടറി ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3174.jpeg",
    },
    {
      src: "assets/img/Pastevents/3175.jpeg",
      caption:
        "അടിമലത്തുറ ഫാത്തിമ മാതാ ചർച്ച്,ട്രിവാൻഡ്രം റോട്ടറി ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3175.jpeg",
    },
    {
      src: "assets/img/Pastevents/3176.jpeg",
      caption:
        "അടിമലത്തുറ ഫാത്തിമ മാതാ ചർച്ച്,ട്രിവാൻഡ്രം റോട്ടറി ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3176.jpeg",
    },
    {
      src: "assets/img/Pastevents/3166.jpeg",
      caption:
        "സംസ്ഥാന ആരോഗ്യ വകുപ്പ്, പള്ളിച്ചൽ എസ് എൻ ഡ പി യൂണിറ്റ്, വിഴിഞ്ഞം സീ പോർട്ട് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3166.jpeg",
    },
    {
      src: "assets/img/Pastevents/3167.jpeg",
      caption:
        "സംസ്ഥാന ആരോഗ്യ വകുപ്പ്, പള്ളിച്ചൽ എസ് എൻ ഡ പി യൂണിറ്റ്, വിഴിഞ്ഞം സീ പോർട്ട് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3167.jpeg",
    },
    {
      src: "assets/img/Pastevents/3168.jpeg",
      caption:
        "സംസ്ഥാന ആരോഗ്യ വകുപ്പ്, പള്ളിച്ചൽ എസ് എൻ ഡ പി യൂണിറ്റ്, വിഴിഞ്ഞം സീ പോർട്ട് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3168.jpeg",
    },
    {
      src: "assets/img/Pastevents/3169.jpeg",
      caption:
        "സംസ്ഥാന ആരോഗ്യ വകുപ്പ്, പള്ളിച്ചൽ എസ് എൻ ഡ പി യൂണിറ്റ്, വിഴിഞ്ഞം സീ പോർട്ട് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3169.jpeg",
    },
    {
      src: "assets/img/Pastevents/3170.jpeg",
      caption:
        "സംസ്ഥാന ആരോഗ്യ വകുപ്പ്, പള്ളിച്ചൽ എസ് എൻ ഡ പി യൂണിറ്റ്, വിഴിഞ്ഞം സീ പോർട്ട് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3170.jpeg",
    },
    {
      src: "assets/img/Pastevents/3159.jpeg",
      caption:
        "നെയ്യാറ്റിൻകര ഇൻ്റെഗ്രൽ ഡെവലപ്പ് സൊസൈറ്റി മുള്ളുവിള യൂണിറ്റ്,ട്രിവാൻഡ്രം ഗിംഗോ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3159.jpeg",
    },
    {
      src: "assets/img/Pastevents/3160.jpeg",
      caption:
        "നെയ്യാറ്റിൻകര ഇൻ്റെഗ്രൽ ഡെവലപ്പ് സൊസൈറ്റി മുള്ളുവിള യൂണിറ്റ്,ട്രിവാൻഡ്രം ഗിംഗോ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3160.jpeg",
    },
    {
      src: "assets/img/Pastevents/3161.jpeg",
      caption:
        "നെയ്യാറ്റിൻകര ഇൻ്റെഗ്രൽ ഡെവലപ്പ് സൊസൈറ്റി മുള്ളുവിള യൂണിറ്റ്,ട്രിവാൻഡ്രം ഗിംഗോ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3161.jpeg",
    },
    {
      src: "assets/img/Pastevents/3162.jpeg",
      caption:
        "നെയ്യാറ്റിൻകര ഇൻ്റെഗ്രൽ ഡെവലപ്പ് സൊസൈറ്റി മുള്ളുവിള യൂണിറ്റ്,ട്രിവാൻഡ്രം ഗിംഗോ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3162.jpeg",
    },
    {
      src: "assets/img/Pastevents/3163.jpeg",
      caption:
        "നെയ്യാറ്റിൻകര ഇൻ്റെഗ്രൽ ഡെവലപ്പ് സൊസൈറ്റി മുള്ളുവിള യൂണിറ്റ്,ട്രിവാൻഡ്രം ഗിംഗോ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3163.jpeg",
    },
    {
      src: "assets/img/Pastevents/3164.jpeg",
      caption:
        "നെയ്യാറ്റിൻകര ഇൻ്റെഗ്രൽ ഡെവലപ്പ് സൊസൈറ്റി മുള്ളുവിള യൂണിറ്റ്,ട്രിവാൻഡ്രം ഗിംഗോ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3164.jpeg",
    },
    {
      src: "assets/img/Pastevents/3165.jpeg",
      caption:
        "നെയ്യാറ്റിൻകര ഇൻ്റെഗ്രൽ ഡെവലപ്പ് സൊസൈറ്റി മുള്ളുവിള യൂണിറ്റ്,ട്രിവാൻഡ്രം ഗിംഗോ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3165.jpeg",
    },
    {
      src: "assets/img/Pastevents/3152.jpeg",
      caption:
        "തിനവിള തെക്കേതിൽ മാടൻവിള ദേവി ക്ഷേത്ര ട്രസ്റ്റ്, ആറ്റിങ്ങൽ പാലസ് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3152.jpeg",
    },
    {
      src: "assets/img/Pastevents/3153.jpeg",
      caption:
        "തിനവിള തെക്കേതിൽ മാടൻവിള ദേവി ക്ഷേത്ര ട്രസ്റ്റ്, ആറ്റിങ്ങൽ പാലസ് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3153.jpeg",
    },
    {
      src: "assets/img/Pastevents/3154.jpeg",
      caption:
        "തിനവിള തെക്കേതിൽ മാടൻവിള ദേവി ക്ഷേത്ര ട്രസ്റ്റ്, ആറ്റിങ്ങൽ പാലസ് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3154.jpeg",
    },
    {
      src: "assets/img/Pastevents/3155.jpeg",
      caption:
        "തിനവിള തെക്കേതിൽ മാടൻവിള ദേവി ക്ഷേത്ര ട്രസ്റ്റ്, ആറ്റിങ്ങൽ പാലസ് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3155.jpeg",
    },
    {
      src: "assets/img/Pastevents/3156.jpeg",
      caption:
        "തിനവിള തെക്കേതിൽ മാടൻവിള ദേവി ക്ഷേത്ര ട്രസ്റ്റ്, ആറ്റിങ്ങൽ പാലസ് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3156.jpeg",
    },
    {
      src: "assets/img/Pastevents/3157.jpeg",
      caption:
        "തിനവിള തെക്കേതിൽ മാടൻവിള ദേവി ക്ഷേത്ര ട്രസ്റ്റ്, ആറ്റിങ്ങൽ പാലസ് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3157.jpeg",
    },
    {
      src: "assets/img/Pastevents/3158.jpeg",
      caption:
        "തിനവിള തെക്കേതിൽ മാടൻവിള ദേവി ക്ഷേത്ര ട്രസ്റ്റ്, ആറ്റിങ്ങൽ പാലസ് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3158.jpeg",
    },
    {
      src: "assets/img/Pastevents/3146.jpeg",
      caption:
        " KSRTC  ആരംഭിച്ച ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 100-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി",
      thumb: "assets/img/Pastevents/3146.jpeg",
    },
    {
      src: "assets/img/Pastevents/3147.jpeg",
      caption:
        " KSRTC  ആരംഭിച്ച ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 100-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി",
      thumb: "assets/img/Pastevents/3147.jpeg",
    },
    {
      src: "assets/img/Pastevents/3148.jpeg",
      caption:
        " KSRTC  ആരംഭിച്ച ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 100-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി",
      thumb: "assets/img/Pastevents/3148.jpeg",
    },
    {
      src: "assets/img/Pastevents/3149.jpeg",
      caption:
        " KSRTC  ആരംഭിച്ച ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 100-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി",
      thumb: "assets/img/Pastevents/3149.jpeg",
    },
    {
      src: "assets/img/Pastevents/3150.jpeg",
      caption:
        " KSRTC  ആരംഭിച്ച ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 100-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി",
      thumb: "assets/img/Pastevents/3150.jpeg",
    },
    {
      src: "assets/img/Pastevents/3151.jpeg",
      caption:
        " KSRTC  ആരംഭിച്ച ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 100-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി",
      thumb: "assets/img/Pastevents/3151.jpeg",
    },
    {
      src: "assets/img/Pastevents/3139.jpeg",
      caption:
        "ഉപ്പളം റോഡ് റെസിഡൻഷ്യൽ അസോസിയേഷൻ,ട്രിവാൻഡ്രം ഫ്ളവേർസ് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3139.jpeg",
    },
    {
      src: "assets/img/Pastevents/3140.jpeg",
      caption:
        "ഉപ്പളം റോഡ് റെസിഡൻഷ്യൽ അസോസിയേഷൻ,ട്രിവാൻഡ്രം ഫ്ളവേർസ് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3140.jpeg",
    },
    {
      src: "assets/img/Pastevents/3141.jpeg",
      caption:
        "ഉപ്പളം റോഡ് റെസിഡൻഷ്യൽ അസോസിയേഷൻ,ട്രിവാൻഡ്രം ഫ്ളവേർസ് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3141.jpeg",
    },
    {
      src: "assets/img/Pastevents/3142.jpeg",
      caption:
        "ഉപ്പളം റോഡ് റെസിഡൻഷ്യൽ അസോസിയേഷൻ,ട്രിവാൻഡ്രം ഫ്ളവേർസ് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3142.jpeg",
    },
    {
      src: "assets/img/Pastevents/3143.jpeg",
      caption:
        "ഉപ്പളം റോഡ് റെസിഡൻഷ്യൽ അസോസിയേഷൻ,ട്രിവാൻഡ്രം ഫ്ളവേർസ് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3143.jpeg",
    },
    {
      src: "assets/img/Pastevents/3144.jpeg",
      caption:
        "ഉപ്പളം റോഡ് റെസിഡൻഷ്യൽ അസോസിയേഷൻ,ട്രിവാൻഡ്രം ഫ്ളവേർസ് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3144.jpeg",
    },
    {
      src: "assets/img/Pastevents/3145.jpeg",
      caption:
        "ഉപ്പളം റോഡ് റെസിഡൻഷ്യൽ അസോസിയേഷൻ,ട്രിവാൻഡ്രം ഫ്ളവേർസ് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3145.jpeg",
    },
    {
      src: "assets/img/Pastevents/3133.jpeg",
      caption:
        "വിഴിഞ്ഞം ഗവ: ഹാർബർ ഏരിയ സ്കൂൾ, സീ പോർട്ട് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ   സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3133.jpeg",
    },
    {
      src: "assets/img/Pastevents/3134.jpeg",
      caption:
        "വിഴിഞ്ഞം ഗവ: ഹാർബർ ഏരിയ സ്കൂൾ, സീ പോർട്ട് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ   സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3134.jpeg",
    },
    {
      src: "assets/img/Pastevents/3135.jpeg",
      caption:
        "വിഴിഞ്ഞം ഗവ: ഹാർബർ ഏരിയ സ്കൂൾ, സീ പോർട്ട് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ   സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3135.jpeg",
    },
    {
      src: "assets/img/Pastevents/3136.jpeg",
      caption:
        "വിഴിഞ്ഞം ഗവ: ഹാർബർ ഏരിയ സ്കൂൾ, സീ പോർട്ട് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ   സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3136.jpeg",
    },
    {
      src: "assets/img/Pastevents/3137.jpeg",
      caption:
        "വിഴിഞ്ഞം ഗവ: ഹാർബർ ഏരിയ സ്കൂൾ, സീ പോർട്ട് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ   സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3137.jpeg",
    },
    {
      src: "assets/img/Pastevents/3138.jpeg",
      caption:
        "വിഴിഞ്ഞം ഗവ: ഹാർബർ ഏരിയ സ്കൂൾ, സീ പോർട്ട് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ   സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3138.jpeg",
    },
    {
      src: "assets/img/Pastevents/3126.jpeg",
      caption:
        "കരമന എൻ എസ് എസ് കോളേജ് ഫോർ വിമൻസ് നാഷണൽ സർവീസ് സ്കീം, അക്ഷയ നഗർ റെസിഡൻഷ്യൽ അസോസിയേഷൻ,ട്രിവാൻഡ്രം റൈൻബോ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3126.jpeg",
    },
    {
      src: "assets/img/Pastevents/3127.jpeg",
      caption:
        "കരമന എൻ എസ് എസ് കോളേജ് ഫോർ വിമൻസ് നാഷണൽ സർവീസ് സ്കീം, അക്ഷയ നഗർ റെസിഡൻഷ്യൽ അസോസിയേഷൻ,ട്രിവാൻഡ്രം റൈൻബോ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3127.jpeg",
    },
    {
      src: "assets/img/Pastevents/3128.jpeg",
      caption:
        "കരമന എൻ എസ് എസ് കോളേജ് ഫോർ വിമൻസ് നാഷണൽ സർവീസ് സ്കീം, അക്ഷയ നഗർ റെസിഡൻഷ്യൽ അസോസിയേഷൻ,ട്രിവാൻഡ്രം റൈൻബോ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3128.jpeg",
    },
    {
      src: "assets/img/Pastevents/3129.jpeg",
      caption:
        "കരമന എൻ എസ് എസ് കോളേജ് ഫോർ വിമൻസ് നാഷണൽ സർവീസ് സ്കീം, അക്ഷയ നഗർ റെസിഡൻഷ്യൽ അസോസിയേഷൻ,ട്രിവാൻഡ്രം റൈൻബോ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3129.jpeg",
    },
    {
      src: "assets/img/Pastevents/3130.jpeg",
      caption:
        "കരമന എൻ എസ് എസ് കോളേജ് ഫോർ വിമൻസ് നാഷണൽ സർവീസ് സ്കീം, അക്ഷയ നഗർ റെസിഡൻഷ്യൽ അസോസിയേഷൻ,ട്രിവാൻഡ്രം റൈൻബോ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3130.jpeg",
    },
    {
      src: "assets/img/Pastevents/3131.jpeg",
      caption:
        "കരമന എൻ എസ് എസ് കോളേജ് ഫോർ വിമൻസ് നാഷണൽ സർവീസ് സ്കീം, അക്ഷയ നഗർ റെസിഡൻഷ്യൽ അസോസിയേഷൻ,ട്രിവാൻഡ്രം റൈൻബോ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3131.jpeg",
    },
    {
      src: "assets/img/Pastevents/3132.jpeg",
      caption:
        "കരമന എൻ എസ് എസ് കോളേജ് ഫോർ വിമൻസ് നാഷണൽ സർവീസ് സ്കീം, അക്ഷയ നഗർ റെസിഡൻഷ്യൽ അസോസിയേഷൻ,ട്രിവാൻഡ്രം റൈൻബോ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3132.jpeg",
    },
    {
      src: "assets/img/Pastevents/3120.jpeg",
      caption:
        "ആഴിമല ശിവ ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3120.jpeg",
    },
    {
      src: "assets/img/Pastevents/3121.jpeg",
      caption:
        "ആഴിമല ശിവ ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3121.jpeg",
    },
    {
      src: "assets/img/Pastevents/3122.jpeg",
      caption:
        "ആഴിമല ശിവ ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3122.jpeg",
    },
    {
      src: "assets/img/Pastevents/3123.jpeg",
      caption:
        "ആഴിമല ശിവ ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3123.jpeg",
    },
    {
      src: "assets/img/Pastevents/3124.jpeg",
      caption:
        "ആഴിമല ശിവ ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3124.jpeg",
    },
    {
      src: "assets/img/Pastevents/3125.jpeg",
      caption:
        "ആഴിമല ശിവ ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3125.jpeg",
    },
    {
      src: "assets/img/Pastevents/3114.jpeg",
      caption:
        "ട്രിവാൻഡ്രം റീജൻസി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3114.jpeg",
    },
    {
      src: "assets/img/Pastevents/3115.jpeg",
      caption:
        "ട്രിവാൻഡ്രം റീജൻസി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3115.jpeg",
    },
    {
      src: "assets/img/Pastevents/3116.jpeg",
      caption:
        "ട്രിവാൻഡ്രം റീജൻസി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3116.jpeg",
    },
    {
      src: "assets/img/Pastevents/3117.jpeg",
      caption:
        "ട്രിവാൻഡ്രം റീജൻസി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3117.jpeg",
    },
    {
      src: "assets/img/Pastevents/3118.jpeg",
      caption:
        "ട്രിവാൻഡ്രം റീജൻസി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3118.jpeg",
    },
    {
      src: "assets/img/Pastevents/3119.jpeg",
      caption:
        "ട്രിവാൻഡ്രം റീജൻസി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3119.jpeg",
    },
    {
      src: "assets/img/Pastevents/3106.jpeg",
      caption:
        "വിഴിഞ്ഞം പ്രസ്സ് ക്ലബ്, ദി ലീലാ കോവളം രാവിസ് റിസോർട്ട് ഗ്രൂപ്പ്, വിഴിഞ്ഞം സീഫോർട്ട് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3106.jpeg",
    },
    {
      src: "assets/img/Pastevents/3107.jpeg",
      caption:
        "വിഴിഞ്ഞം പ്രസ്സ് ക്ലബ്, ദി ലീലാ കോവളം രാവിസ് റിസോർട്ട് ഗ്രൂപ്പ്, വിഴിഞ്ഞം സീഫോർട്ട് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3107.jpeg",
    },
    {
      src: "assets/img/Pastevents/3108.jpeg",
      caption:
        "വിഴിഞ്ഞം പ്രസ്സ് ക്ലബ്, ദി ലീലാ കോവളം രാവിസ് റിസോർട്ട് ഗ്രൂപ്പ്, വിഴിഞ്ഞം സീഫോർട്ട് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3108.jpeg",
    },
    {
      src: "assets/img/Pastevents/3109.jpeg",
      caption:
        "വിഴിഞ്ഞം പ്രസ്സ് ക്ലബ്, ദി ലീലാ കോവളം രാവിസ് റിസോർട്ട് ഗ്രൂപ്പ്, വിഴിഞ്ഞം സീഫോർട്ട് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3109.jpeg",
    },
    {
      src: "assets/img/Pastevents/3110.jpeg",
      caption:
        "വിഴിഞ്ഞം പ്രസ്സ് ക്ലബ്, ദി ലീലാ കോവളം രാവിസ് റിസോർട്ട് ഗ്രൂപ്പ്, വിഴിഞ്ഞം സീഫോർട്ട് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3110.jpeg",
    },
    {
      src: "assets/img/Pastevents/3111.jpeg",
      caption:
        "വിഴിഞ്ഞം പ്രസ്സ് ക്ലബ്, ദി ലീലാ കോവളം രാവിസ് റിസോർട്ട് ഗ്രൂപ്പ്, വിഴിഞ്ഞം സീഫോർട്ട് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3111.jpeg",
    },
    {
      src: "assets/img/Pastevents/3112.jpeg",
      caption:
        "വിഴിഞ്ഞം പ്രസ്സ് ക്ലബ്, ദി ലീലാ കോവളം രാവിസ് റിസോർട്ട് ഗ്രൂപ്പ്, വിഴിഞ്ഞം സീഫോർട്ട് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3112.jpeg",
    },
    {
      src: "assets/img/Pastevents/3113.jpeg",
      caption:
        "വിഴിഞ്ഞം പ്രസ്സ് ക്ലബ്, ദി ലീലാ കോവളം രാവിസ് റിസോർട്ട് ഗ്രൂപ്പ്, വിഴിഞ്ഞം സീഫോർട്ട് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3113.jpeg",
    },
    {
      src: "assets/img/Pastevents/3100.jpeg",
      caption:
        " ട്രിവാൻഡ്രം നോവ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3100.jpeg",
    },
    {
      src: "assets/img/Pastevents/3101.jpeg",
      caption:
        " ട്രിവാൻഡ്രം നോവ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3101.jpeg",
    },
    {
      src: "assets/img/Pastevents/3102.jpeg",
      caption:
        " ട്രിവാൻഡ്രം നോവ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3102.jpeg",
    },
    {
      src: "assets/img/Pastevents/3103.jpeg",
      caption:
        " ട്രിവാൻഡ്രം നോവ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3103.jpeg",
    },
    {
      src: "assets/img/Pastevents/3104.jpeg",
      caption:
        " ട്രിവാൻഡ്രം നോവ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3104.jpeg",
    },
    {
      src: "assets/img/Pastevents/3105.jpeg",
      caption:
        " ട്രിവാൻഡ്രം നോവ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3105.jpeg",
    },
    {
      src: "assets/img/Pastevents/3094.jpeg",
      caption:
        "വിഴിഞ്ഞം പ്രസ്സ് ക്ലബ്, ഉദയ സമുദ്ര റിസോർട്ട് ഗ്രൂപ്പ്, വിഴിഞ്ഞം സീഫോർട്ട് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3094.jpeg",
    },
    {
      src: "assets/img/Pastevents/3095.jpeg",
      caption:
        "വിഴിഞ്ഞം പ്രസ്സ് ക്ലബ്, ഉദയ സമുദ്ര റിസോർട്ട് ഗ്രൂപ്പ്, വിഴിഞ്ഞം സീഫോർട്ട് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3095.jpeg",
    },
    {
      src: "assets/img/Pastevents/3096.jpeg",
      caption:
        "വിഴിഞ്ഞം പ്രസ്സ് ക്ലബ്, ഉദയ സമുദ്ര റിസോർട്ട് ഗ്രൂപ്പ്, വിഴിഞ്ഞം സീഫോർട്ട് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3096.jpeg",
    },
    {
      src: "assets/img/Pastevents/3097.jpeg",
      caption:
        "വിഴിഞ്ഞം പ്രസ്സ് ക്ലബ്, ഉദയ സമുദ്ര റിസോർട്ട് ഗ്രൂപ്പ്, വിഴിഞ്ഞം സീഫോർട്ട് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3097.jpeg",
    },
    {
      src: "assets/img/Pastevents/3098.jpeg",
      caption:
        "വിഴിഞ്ഞം പ്രസ്സ് ക്ലബ്, ഉദയ സമുദ്ര റിസോർട്ട് ഗ്രൂപ്പ്, വിഴിഞ്ഞം സീഫോർട്ട് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3098.jpeg",
    },
    {
      src: "assets/img/Pastevents/3099.jpeg",
      caption:
        "വിഴിഞ്ഞം പ്രസ്സ് ക്ലബ്, ഉദയ സമുദ്ര റിസോർട്ട് ഗ്രൂപ്പ്, വിഴിഞ്ഞം സീഫോർട്ട് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3099.jpeg",
    },
    {
      src: "assets/img/Pastevents/3087.jpeg",
      caption:
        "വലിയകുളം ഗാന്ധി മിത്ര മണ്ഡലത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3087.jpeg",
    },
    {
      src: "assets/img/Pastevents/3088.jpeg",
      caption:
        "വലിയകുളം ഗാന്ധി മിത്ര മണ്ഡലത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3088.jpeg",
    },
    {
      src: "assets/img/Pastevents/3089.jpeg",
      caption:
        "വലിയകുളം ഗാന്ധി മിത്ര മണ്ഡലത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3089.jpeg",
    },
    {
      src: "assets/img/Pastevents/3090.jpeg",
      caption:
        "വലിയകുളം ഗാന്ധി മിത്ര മണ്ഡലത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3090.jpeg",
    },
    {
      src: "assets/img/Pastevents/3091.jpeg",
      caption:
        "വലിയകുളം ഗാന്ധി മിത്ര മണ്ഡലത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3091.jpeg",
    },
    {
      src: "assets/img/Pastevents/3092.jpeg",
      caption:
        "വലിയകുളം ഗാന്ധി മിത്ര മണ്ഡലത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3092.jpeg",
    },
    {
      src: "assets/img/Pastevents/3093.jpeg",
      caption:
        "വലിയകുളം ഗാന്ധി മിത്ര മണ്ഡലത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3093.jpeg",
    },
    {
      src: "assets/img/Pastevents/3081.jpeg",
      caption:
        "വേങ്കപ്പൊറ്റ എസ് എൻ ഡി പി യൂണിറ്റ് , വിഴിഞ്ഞം ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3081.jpeg",
    },
    {
      src: "assets/img/Pastevents/3082.jpeg",
      caption:
        "വേങ്കപ്പൊറ്റ എസ് എൻ ഡി പി യൂണിറ്റ് , വിഴിഞ്ഞം ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3082.jpeg",
    },
    {
      src: "assets/img/Pastevents/3083.jpeg",
      caption:
        "വേങ്കപ്പൊറ്റ എസ് എൻ ഡി പി യൂണിറ്റ് , വിഴിഞ്ഞം ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3083.jpeg",
    },
    {
      src: "assets/img/Pastevents/3084.jpeg",
      caption:
        "വേങ്കപ്പൊറ്റ എസ് എൻ ഡി പി യൂണിറ്റ് , വിഴിഞ്ഞം ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3084.jpeg",
    },
    {
      src: "assets/img/Pastevents/3085.jpeg",
      caption:
        "വേങ്കപ്പൊറ്റ എസ് എൻ ഡി പി യൂണിറ്റ് , വിഴിഞ്ഞം ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3085.jpeg",
    },
    {
      src: "assets/img/Pastevents/3086.jpeg",
      caption:
        "വേങ്കപ്പൊറ്റ എസ് എൻ ഡി പി യൂണിറ്റ് , വിഴിഞ്ഞം ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3086.jpeg",
    },
    {
      src: "assets/img/Pastevents/3074.jpeg",
      caption:
        "കണ്ണറവിള ബോധി ആർട്ട്സ് ആൻഡ് സ്പോർട്സ് ക്ലബ്ബ്, വിഴിഞ്ഞം ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3074.jpeg",
    },
    {
      src: "assets/img/Pastevents/3075.jpeg",
      caption:
        "കണ്ണറവിള ബോധി ആർട്ട്സ് ആൻഡ് സ്പോർട്സ് ക്ലബ്ബ്, വിഴിഞ്ഞം ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3075.jpeg",
    },
    {
      src: "assets/img/Pastevents/3076.jpeg",
      caption:
        "കണ്ണറവിള ബോധി ആർട്ട്സ് ആൻഡ് സ്പോർട്സ് ക്ലബ്ബ്, വിഴിഞ്ഞം ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3076.jpeg",
    },
    {
      src: "assets/img/Pastevents/3077.jpeg",
      caption:
        "കണ്ണറവിള ബോധി ആർട്ട്സ് ആൻഡ് സ്പോർട്സ് ക്ലബ്ബ്, വിഴിഞ്ഞം ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3077.jpeg",
    },
    {
      src: "assets/img/Pastevents/3078.jpeg",
      caption:
        "കണ്ണറവിള ബോധി ആർട്ട്സ് ആൻഡ് സ്പോർട്സ് ക്ലബ്ബ്, വിഴിഞ്ഞം ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3078.jpeg",
    },
    {
      src: "assets/img/Pastevents/3079.jpeg",
      caption:
        "കണ്ണറവിള ബോധി ആർട്ട്സ് ആൻഡ് സ്പോർട്സ് ക്ലബ്ബ്, വിഴിഞ്ഞം ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3079.jpeg",
    },
    {
      src: "assets/img/Pastevents/3080.jpeg",
      caption:
        "കണ്ണറവിള ബോധി ആർട്ട്സ് ആൻഡ് സ്പോർട്സ് ക്ലബ്ബ്, വിഴിഞ്ഞം ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3080.jpeg",
    },
    {
      src: "assets/img/Pastevents/3069.jpeg",
      caption:
        "പരശുവയ്ക്കൽ ഗൂഗിൾ ആർട്ട്സ് ആൻഡ് സ്പോർട്സ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3069.jpeg",
    },
    {
      src: "assets/img/Pastevents/3070.jpeg",
      caption:
        "പരശുവയ്ക്കൽ ഗൂഗിൾ ആർട്ട്സ് ആൻഡ് സ്പോർട്സ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3070.jpeg",
    },
    {
      src: "assets/img/Pastevents/3071.jpeg",
      caption:
        "പരശുവയ്ക്കൽ ഗൂഗിൾ ആർട്ട്സ് ആൻഡ് സ്പോർട്സ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3071.jpeg",
    },
    {
      src: "assets/img/Pastevents/3072.jpeg",
      caption:
        "പരശുവയ്ക്കൽ ഗൂഗിൾ ആർട്ട്സ് ആൻഡ് സ്പോർട്സ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3072.jpeg",
    },
    {
      src: "assets/img/Pastevents/3073.jpeg",
      caption:
        "പരശുവയ്ക്കൽ ഗൂഗിൾ ആർട്ട്സ് ആൻഡ് സ്പോർട്സ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3073.jpeg",
    },
    {
      src: "assets/img/Pastevents/3062.jpeg",
      caption:
        "സക്ഷമാ കേരളാ യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3062.jpeg",
    },
    {
      src: "assets/img/Pastevents/3063.jpeg",
      caption:
        "സക്ഷമാ കേരളാ യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3063.jpeg",
    },
    {
      src: "assets/img/Pastevents/3064.jpeg",
      caption:
        "സക്ഷമാ കേരളാ യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3064.jpeg",
    },
    {
      src: "assets/img/Pastevents/3065.jpeg",
      caption:
        "സക്ഷമാ കേരളാ യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3065.jpeg",
    },
    {
      src: "assets/img/Pastevents/3066.jpeg",
      caption:
        "സക്ഷമാ കേരളാ യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3066.jpeg",
    },
    {
      src: "assets/img/Pastevents/3067.jpeg",
      caption:
        "സക്ഷമാ കേരളാ യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3067.jpeg",
    },
    {
      src: "assets/img/Pastevents/3068.jpeg",
      caption:
        "സക്ഷമാ കേരളാ യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3068.jpeg",
    },
    {
      src: "assets/img/Pastevents/3057.jpeg",
      caption:
        "മുടവൻമുഗൾ ഉരൂട്ട് റെസിഡൻഷ്യൽ അസോസിയേഷൻ,ട്രിവാൻഡ്രം സ്മാർട്ട് സിറ്റി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3057.jpeg",
    },
    {
      src: "assets/img/Pastevents/3058.jpeg",
      caption:
        "മുടവൻമുഗൾ ഉരൂട്ട് റെസിഡൻഷ്യൽ അസോസിയേഷൻ,ട്രിവാൻഡ്രം സ്മാർട്ട് സിറ്റി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3058.jpeg",
    },
    {
      src: "assets/img/Pastevents/3059.jpeg",
      caption:
        "മുടവൻമുഗൾ ഉരൂട്ട് റെസിഡൻഷ്യൽ അസോസിയേഷൻ,ട്രിവാൻഡ്രം സ്മാർട്ട് സിറ്റി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3059.jpeg",
    },
    {
      src: "assets/img/Pastevents/3060.jpeg",
      caption:
        "മുടവൻമുഗൾ ഉരൂട്ട് റെസിഡൻഷ്യൽ അസോസിയേഷൻ,ട്രിവാൻഡ്രം സ്മാർട്ട് സിറ്റി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3060.jpeg",
    },
    {
      src: "assets/img/Pastevents/3061.jpeg",
      caption:
        "മുടവൻമുഗൾ ഉരൂട്ട് റെസിഡൻഷ്യൽ അസോസിയേഷൻ,ട്രിവാൻഡ്രം സ്മാർട്ട് സിറ്റി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3061.jpeg",
    },
    {
      src: "assets/img/Pastevents/3050.jpeg",
      caption:
        "വട്ടിയൂർക്കാവ് ശ്രീരാമകൃഷ്ണപുരം റെസിഡൻഷ്യൽ അസോസിയേഷൻ,വട്ടിയൂർക്കാവ് മോഡൽ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3050.jpeg",
    },
    {
      src: "assets/img/Pastevents/3051.jpeg",
      caption:
        "വട്ടിയൂർക്കാവ് ശ്രീരാമകൃഷ്ണപുരം റെസിഡൻഷ്യൽ അസോസിയേഷൻ,വട്ടിയൂർക്കാവ് മോഡൽ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3051.jpeg",
    },
    {
      src: "assets/img/Pastevents/3052.jpeg",
      caption:
        "വട്ടിയൂർക്കാവ് ശ്രീരാമകൃഷ്ണപുരം റെസിഡൻഷ്യൽ അസോസിയേഷൻ,വട്ടിയൂർക്കാവ് മോഡൽ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3052.jpeg",
    },
    {
      src: "assets/img/Pastevents/3053.jpeg",
      caption:
        "വട്ടിയൂർക്കാവ് ശ്രീരാമകൃഷ്ണപുരം റെസിഡൻഷ്യൽ അസോസിയേഷൻ,വട്ടിയൂർക്കാവ് മോഡൽ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3053.jpeg",
    },
    {
      src: "assets/img/Pastevents/3054.jpeg",
      caption:
        "വട്ടിയൂർക്കാവ് ശ്രീരാമകൃഷ്ണപുരം റെസിഡൻഷ്യൽ അസോസിയേഷൻ,വട്ടിയൂർക്കാവ് മോഡൽ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3054.jpeg",
    },
    {
      src: "assets/img/Pastevents/3055.jpeg",
      caption:
        "വട്ടിയൂർക്കാവ് ശ്രീരാമകൃഷ്ണപുരം റെസിഡൻഷ്യൽ അസോസിയേഷൻ,വട്ടിയൂർക്കാവ് മോഡൽ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3055.jpeg",
    },
    {
      src: "assets/img/Pastevents/3056.jpeg",
      caption:
        "വട്ടിയൂർക്കാവ് ശ്രീരാമകൃഷ്ണപുരം റെസിഡൻഷ്യൽ അസോസിയേഷൻ,വട്ടിയൂർക്കാവ് മോഡൽ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3056.jpeg",
    },
    {
      src: "assets/img/Pastevents/3044.jpeg",
      caption:
        "ക്രിസ്റ്റ്യൻ മിഷൻ സർവീസ് ചിൽഡ്രൻസ് ഹോം മലച്ചാണി നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3044.jpeg",
    },
    {
      src: "assets/img/Pastevents/3045.jpeg",
      caption:
        "ക്രിസ്റ്റ്യൻ മിഷൻ സർവീസ് ചിൽഡ്രൻസ് ഹോം മലച്ചാണി നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3045.jpeg",
    },
    {
      src: "assets/img/Pastevents/3046.jpeg",
      caption:
        "ക്രിസ്റ്റ്യൻ മിഷൻ സർവീസ് ചിൽഡ്രൻസ് ഹോം മലച്ചാണി നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3046.jpeg",
    },
    {
      src: "assets/img/Pastevents/3047.jpeg",
      caption:
        "ക്രിസ്റ്റ്യൻ മിഷൻ സർവീസ് ചിൽഡ്രൻസ് ഹോം മലച്ചാണി നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3047.jpeg",
    },
    {
      src: "assets/img/Pastevents/3048.jpeg",
      caption:
        "ക്രിസ്റ്റ്യൻ മിഷൻ സർവീസ് ചിൽഡ്രൻസ് ഹോം മലച്ചാണി നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3048.jpeg",
    },
    {
      src: "assets/img/Pastevents/3049.jpeg",
      caption:
        "ക്രിസ്റ്റ്യൻ മിഷൻ സർവീസ് ചിൽഡ്രൻസ് ഹോം മലച്ചാണി നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3049.jpeg",
    },
    {
      src: "assets/img/Pastevents/3038.jpeg",
      caption:
        "ഐ പി സി തിരുവനന്തപുരം വെസ്റ്റ് സെൻ്റർ പി വൈ പി എയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3038.jpeg",
    },
    {
      src: "assets/img/Pastevents/3039.jpeg",
      caption:
        "ഐ പി സി തിരുവനന്തപുരം വെസ്റ്റ് സെൻ്റർ പി വൈ പി എയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3039.jpeg",
    },
    {
      src: "assets/img/Pastevents/3040.jpeg",
      caption:
        "ഐ പി സി തിരുവനന്തപുരം വെസ്റ്റ് സെൻ്റർ പി വൈ പി എയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3040.jpeg",
    },
    {
      src: "assets/img/Pastevents/3041.jpeg",
      caption:
        "ഐ പി സി തിരുവനന്തപുരം വെസ്റ്റ് സെൻ്റർ പി വൈ പി എയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3041.jpeg",
    },
    {
      src: "assets/img/Pastevents/3042.jpeg",
      caption:
        "ഐ പി സി തിരുവനന്തപുരം വെസ്റ്റ് സെൻ്റർ പി വൈ പി എയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3042.jpeg",
    },
    {
      src: "assets/img/Pastevents/3043.jpeg",
      caption:
        "ഐ പി സി തിരുവനന്തപുരം വെസ്റ്റ് സെൻ്റർ പി വൈ പി എയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3043.jpeg",
    },
    {
      src: "assets/img/Pastevents/3032.jpeg",
      caption:
        "KSRTC  ആരംഭിച്ച ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 100-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3032.jpeg",
    },
    {
      src: "assets/img/Pastevents/3033.jpeg",
      caption:
        "KSRTC  ആരംഭിച്ച ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 100-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3033.jpeg",
    },
    {
      src: "assets/img/Pastevents/3034.jpeg",
      caption:
        "KSRTC  ആരംഭിച്ച ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 100-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3034.jpeg",
    },
    {
      src: "assets/img/Pastevents/3035.jpeg",
      caption:
        "KSRTC  ആരംഭിച്ച ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 100-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3035.jpeg",
    },
    {
      src: "assets/img/Pastevents/3036.jpeg",
      caption:
        "KSRTC  ആരംഭിച്ച ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 100-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3036.jpeg",
    },
    {
      src: "assets/img/Pastevents/3037.jpeg",
      caption:
        "KSRTC  ആരംഭിച്ച ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 100-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3037.jpeg",
    },
    {
      src: "assets/img/Pastevents/3027.jpeg",
      caption:
        "നന്ദൻക്കോട് സ്വരാജ് ഭവൻ കലാ സാംസ്കാരിക വേദി,ട്രിവാൻഡ്രം റീജൻസി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3027.jpeg",
    },
    {
      src: "assets/img/Pastevents/3028.jpeg",
      caption:
        "നന്ദൻക്കോട് സ്വരാജ് ഭവൻ കലാ സാംസ്കാരിക വേദി,ട്രിവാൻഡ്രം റീജൻസി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3028.jpeg",
    },
    {
      src: "assets/img/Pastevents/3029.jpeg",
      caption:
        "നന്ദൻക്കോട് സ്വരാജ് ഭവൻ കലാ സാംസ്കാരിക വേദി,ട്രിവാൻഡ്രം റീജൻസി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3029.jpeg",
    },
    {
      src: "assets/img/Pastevents/3030.jpeg",
      caption:
        "നന്ദൻക്കോട് സ്വരാജ് ഭവൻ കലാ സാംസ്കാരിക വേദി,ട്രിവാൻഡ്രം റീജൻസി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3030.jpeg",
    },
    {
      src: "assets/img/Pastevents/3031.jpeg",
      caption:
        "നന്ദൻക്കോട് സ്വരാജ് ഭവൻ കലാ സാംസ്കാരിക വേദി,ട്രിവാൻഡ്രം റീജൻസി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3031.jpeg",
    },
    {
      src: "assets/img/Pastevents/3021.jpeg",
      caption:
        "ലൂതെറിൻ യൂത്ത് ഫെല്ലോഷിപ്പ് ട്രിവാൻഡ്രം സർക്കിളിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3021.jpeg",
    },
    {
      src: "assets/img/Pastevents/3022.jpeg",
      caption:
        "ലൂതെറിൻ യൂത്ത് ഫെല്ലോഷിപ്പ് ട്രിവാൻഡ്രം സർക്കിളിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3022.jpeg",
    },
    {
      src: "assets/img/Pastevents/3023.jpeg",
      caption:
        "ലൂതെറിൻ യൂത്ത് ഫെല്ലോഷിപ്പ് ട്രിവാൻഡ്രം സർക്കിളിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3023.jpeg",
    },
    {
      src: "assets/img/Pastevents/3024.jpeg",
      caption:
        "ലൂതെറിൻ യൂത്ത് ഫെല്ലോഷിപ്പ് ട്രിവാൻഡ്രം സർക്കിളിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3024.jpeg",
    },
    {
      src: "assets/img/Pastevents/3025.jpeg",
      caption:
        "ലൂതെറിൻ യൂത്ത് ഫെല്ലോഷിപ്പ് ട്രിവാൻഡ്രം സർക്കിളിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3025.jpeg",
    },
    {
      src: "assets/img/Pastevents/3026.jpeg",
      caption:
        "ലൂതെറിൻ യൂത്ത് ഫെല്ലോഷിപ്പ് ട്രിവാൻഡ്രം സർക്കിളിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3026.jpeg",
    },
    {
      src: "assets/img/Pastevents/3013.jpeg",
      caption:
        "വിതുര കാസക് ഓട്ടോ കൂട്ടയിമ, എസ് ജ ഹോസ്പിറ്റലിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3013.jpeg",
    },
    {
      src: "assets/img/Pastevents/3014.jpeg",
      caption:
        "വിതുര കാസക് ഓട്ടോ കൂട്ടയിമ, എസ് ജ ഹോസ്പിറ്റലിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3014.jpeg",
    },
    {
      src: "assets/img/Pastevents/3015.jpeg",
      caption:
        "വിതുര കാസക് ഓട്ടോ കൂട്ടയിമ, എസ് ജ ഹോസ്പിറ്റലിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3015.jpeg",
    },
    {
      src: "assets/img/Pastevents/3016.jpeg",
      caption:
        "വിതുര കാസക് ഓട്ടോ കൂട്ടയിമ, എസ് ജ ഹോസ്പിറ്റലിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3016.jpeg",
    },
    {
      src: "assets/img/Pastevents/3017.jpeg",
      caption:
        "വിതുര കാസക് ഓട്ടോ കൂട്ടയിമ, എസ് ജ ഹോസ്പിറ്റലിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3017.jpeg",
    },
    {
      src: "assets/img/Pastevents/3018.jpeg",
      caption:
        "വിതുര കാസക് ഓട്ടോ കൂട്ടയിമ, എസ് ജ ഹോസ്പിറ്റലിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3018.jpeg",
    },
    {
      src: "assets/img/Pastevents/3019.jpeg",
      caption:
        "വിതുര കാസക് ഓട്ടോ കൂട്ടയിമ, എസ് ജ ഹോസ്പിറ്റലിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3019.jpeg",
    },
    {
      src: "assets/img/Pastevents/3020.jpeg",
      caption:
        "വിതുര കാസക് ഓട്ടോ കൂട്ടയിമ, എസ് ജ ഹോസ്പിറ്റലിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3020.jpeg",
    },
    {
      src: "assets/img/Pastevents/3007.jpeg",
      caption:
        "കുടപ്പനക്കുന്ന് സിവിൽ സ്റ്റേഷൻ എംപ്ലോയീസ് അസോസിയേഷൻ,ട്രിവാൻഡ്രം മേജെസ്റ്റി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3007.jpeg",
    },
    {
      src: "assets/img/Pastevents/3008.jpeg",
      caption:
        "കുടപ്പനക്കുന്ന് സിവിൽ സ്റ്റേഷൻ എംപ്ലോയീസ് അസോസിയേഷൻ,ട്രിവാൻഡ്രം മേജെസ്റ്റി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3008.jpeg",
    },
    {
      src: "assets/img/Pastevents/3009.jpeg",
      caption:
        "കുടപ്പനക്കുന്ന് സിവിൽ സ്റ്റേഷൻ എംപ്ലോയീസ് അസോസിയേഷൻ,ട്രിവാൻഡ്രം മേജെസ്റ്റി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3009.jpeg",
    },
    {
      src: "assets/img/Pastevents/3010.jpeg",
      caption:
        "കുടപ്പനക്കുന്ന് സിവിൽ സ്റ്റേഷൻ എംപ്ലോയീസ് അസോസിയേഷൻ,ട്രിവാൻഡ്രം മേജെസ്റ്റി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3010.jpeg",
    },
    {
      src: "assets/img/Pastevents/3011.jpeg",
      caption:
        "കുടപ്പനക്കുന്ന് സിവിൽ സ്റ്റേഷൻ എംപ്ലോയീസ് അസോസിയേഷൻ,ട്രിവാൻഡ്രം മേജെസ്റ്റി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3011.jpeg",
    },
    {
      src: "assets/img/Pastevents/3012.jpeg",
      caption:
        "കുടപ്പനക്കുന്ന് സിവിൽ സ്റ്റേഷൻ എംപ്ലോയീസ് അസോസിയേഷൻ,ട്രിവാൻഡ്രം മേജെസ്റ്റി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3012.jpeg",
    },
    {
      src: "assets/img/Pastevents/3002.jpeg",
      caption:
        "തിരുവനന്തപുരം സംസ്ഥാന ആരോഗ്യ വകുപ്പ്, കോവളം ക്രാഫ്റ്റ് വില്ലേജ് വെൽഫെയർ കമ്മിറ്റി, കോവളം സീ പോർട്ട് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3002.jpeg",
    },
    {
      src: "assets/img/Pastevents/3003.jpeg",
      caption:
        "തിരുവനന്തപുരം സംസ്ഥാന ആരോഗ്യ വകുപ്പ്, കോവളം ക്രാഫ്റ്റ് വില്ലേജ് വെൽഫെയർ കമ്മിറ്റി, കോവളം സീ പോർട്ട് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3003.jpeg",
    },
    {
      src: "assets/img/Pastevents/3004.jpeg",
      caption:
        "തിരുവനന്തപുരം സംസ്ഥാന ആരോഗ്യ വകുപ്പ്, കോവളം ക്രാഫ്റ്റ് വില്ലേജ് വെൽഫെയർ കമ്മിറ്റി, കോവളം സീ പോർട്ട് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3004.jpeg",
    },
    {
      src: "assets/img/Pastevents/3005.jpeg",
      caption:
        "തിരുവനന്തപുരം സംസ്ഥാന ആരോഗ്യ വകുപ്പ്, കോവളം ക്രാഫ്റ്റ് വില്ലേജ് വെൽഫെയർ കമ്മിറ്റി, കോവളം സീ പോർട്ട് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3005.jpeg",
    },
    {
      src: "assets/img/Pastevents/3006.jpeg",
      caption:
        "തിരുവനന്തപുരം സംസ്ഥാന ആരോഗ്യ വകുപ്പ്, കോവളം ക്രാഫ്റ്റ് വില്ലേജ് വെൽഫെയർ കമ്മിറ്റി, കോവളം സീ പോർട്ട് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3006.jpeg",
    },
    {
      src: "assets/img/Pastevents/3007.jpeg",
      caption:
        "തിരുവനന്തപുരം സംസ്ഥാന ആരോഗ്യ വകുപ്പ്, കോവളം ക്രാഫ്റ്റ് വില്ലേജ് വെൽഫെയർ കമ്മിറ്റി, കോവളം സീ പോർട്ട് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3007.jpeg",
    },
    {
      src: "assets/img/Pastevents/2997.jpeg",
      caption:
        " ചിറ്റാക്കോട് ഇന്ദ്രപ്രസ്ഥാ ആർട്ട്സ് ആൻഡ് സ്പോർട്സ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2997.jpeg",
    },
    {
      src: "assets/img/Pastevents/2998.jpeg",
      caption:
        " ചിറ്റാക്കോട് ഇന്ദ്രപ്രസ്ഥാ ആർട്ട്സ് ആൻഡ് സ്പോർട്സ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2998.jpeg",
    },
    {
      src: "assets/img/Pastevents/2999.jpeg",
      caption:
        " ചിറ്റാക്കോട് ഇന്ദ്രപ്രസ്ഥാ ആർട്ട്സ് ആൻഡ് സ്പോർട്സ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2999.jpeg",
    },
    {
      src: "assets/img/Pastevents/3000.jpeg",
      caption:
        " ചിറ്റാക്കോട് ഇന്ദ്രപ്രസ്ഥാ ആർട്ട്സ് ആൻഡ് സ്പോർട്സ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3000.jpeg",
    },
    {
      src: "assets/img/Pastevents/3001.jpeg",
      caption:
        " ചിറ്റാക്കോട് ഇന്ദ്രപ്രസ്ഥാ ആർട്ട്സ് ആൻഡ് സ്പോർട്സ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/3001.jpeg",
    },
    {
      src: "assets/img/Pastevents/2990.jpeg",
      caption:
        " അയണിമൂട് പൗര സമിതിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2990.jpeg",
    },
    {
      src: "assets/img/Pastevents/2991.jpeg",
      caption:
        " അയണിമൂട് പൗര സമിതിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2991.jpeg",
    },
    {
      src: "assets/img/Pastevents/2992.jpeg",
      caption:
        " അയണിമൂട് പൗര സമിതിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2992.jpeg",
    },
    {
      src: "assets/img/Pastevents/2993.jpeg",
      caption:
        " അയണിമൂട് പൗര സമിതിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2993.jpeg",
    },
    {
      src: "assets/img/Pastevents/2994.jpeg",
      caption:
        " അയണിമൂട് പൗര സമിതിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2994.jpeg",
    },
    {
      src: "assets/img/Pastevents/2995.jpeg",
      caption:
        " അയണിമൂട് പൗര സമിതിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2995.jpeg",
    },
    {
      src: "assets/img/Pastevents/2996.jpeg",
      caption:
        " അയണിമൂട് പൗര സമിതിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2996.jpeg",
    },
    {
      src: "assets/img/Pastevents/2985.jpeg",
      caption:
        " കാഞ്ഞമ്പറ സംസ്കൃതി സാംസ്കാരിക വേദിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2985.jpeg",
    },
    {
      src: "assets/img/Pastevents/2986.jpeg",
      caption:
        " കാഞ്ഞമ്പറ സംസ്കൃതി സാംസ്കാരിക വേദിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2986.jpeg",
    },
    {
      src: "assets/img/Pastevents/2987.jpeg",
      caption:
        " കാഞ്ഞമ്പറ സംസ്കൃതി സാംസ്കാരിക വേദിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2987.jpeg",
    },
    {
      src: "assets/img/Pastevents/2988.jpeg",
      caption:
        " കാഞ്ഞമ്പറ സംസ്കൃതി സാംസ്കാരിക വേദിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2988.jpeg",
    },
    {
      src: "assets/img/Pastevents/2989.jpeg",
      caption:
        " കാഞ്ഞമ്പറ സംസ്കൃതി സാംസ്കാരിക വേദിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2989.jpeg",
    },
    {
      src: "assets/img/Pastevents/2978.jpeg",
      caption:
        " ആറ്റിങ്ങൽ അറേബ്യൻ ഫാഷൻ ജൂവലറി, ആറ്റിങ്ങൽ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2978.jpeg",
    },
    {
      src: "assets/img/Pastevents/2979.jpeg",
      caption:
        " ആറ്റിങ്ങൽ അറേബ്യൻ ഫാഷൻ ജൂവലറി, ആറ്റിങ്ങൽ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2979.jpeg",
    },
    {
      src: "assets/img/Pastevents/2980.jpeg",
      caption:
        " ആറ്റിങ്ങൽ അറേബ്യൻ ഫാഷൻ ജൂവലറി, ആറ്റിങ്ങൽ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2980.jpeg",
    },
    {
      src: "assets/img/Pastevents/2981.jpeg",
      caption:
        " ആറ്റിങ്ങൽ അറേബ്യൻ ഫാഷൻ ജൂവലറി, ആറ്റിങ്ങൽ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2981.jpeg",
    },
    {
      src: "assets/img/Pastevents/2982.jpeg",
      caption:
        " ആറ്റിങ്ങൽ അറേബ്യൻ ഫാഷൻ ജൂവലറി, ആറ്റിങ്ങൽ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2982.jpeg",
    },
    {
      src: "assets/img/Pastevents/2983.jpeg",
      caption:
        " ആറ്റിങ്ങൽ അറേബ്യൻ ഫാഷൻ ജൂവലറി, ആറ്റിങ്ങൽ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2983.jpeg",
    },
    {
      src: "assets/img/Pastevents/2984.jpeg",
      caption:
        " ആറ്റിങ്ങൽ അറേബ്യൻ ഫാഷൻ ജൂവലറി, ആറ്റിങ്ങൽ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2984.jpeg",
    },
    {
      src: "assets/img/Pastevents/2972.jpeg",
      caption:
        "മലങ്കര കാത്തോലിക് അസോസിയേഷൻ,ട്രിവാൻഡ്രം കോസ്മോ പോളിറ്റൻ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2972.jpeg",
    },
    {
      src: "assets/img/Pastevents/2973.jpeg",
      caption:
        "മലങ്കര കാത്തോലിക് അസോസിയേഷൻ,ട്രിവാൻഡ്രം കോസ്മോ പോളിറ്റൻ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2973.jpeg",
    },
    {
      src: "assets/img/Pastevents/2974.jpeg",
      caption:
        "മലങ്കര കാത്തോലിക് അസോസിയേഷൻ,ട്രിവാൻഡ്രം കോസ്മോ പോളിറ്റൻ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2974.jpeg",
    },
    {
      src: "assets/img/Pastevents/2975.jpeg",
      caption:
        "മലങ്കര കാത്തോലിക് അസോസിയേഷൻ,ട്രിവാൻഡ്രം കോസ്മോ പോളിറ്റൻ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2975.jpeg",
    },
    {
      src: "assets/img/Pastevents/2976.jpeg",
      caption:
        "മലങ്കര കാത്തോലിക് അസോസിയേഷൻ,ട്രിവാൻഡ്രം കോസ്മോ പോളിറ്റൻ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2976.jpeg",
    },
    {
      src: "assets/img/Pastevents/2977.jpeg",
      caption:
        "മലങ്കര കാത്തോലിക് അസോസിയേഷൻ,ട്രിവാൻഡ്രം കോസ്മോ പോളിറ്റൻ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2977.jpeg",
    },
    {
      src: "assets/img/Pastevents/2967.jpeg",
      caption:
        "KSRTC  ആരംഭിച്ച ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 100-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2967.jpeg",
    },
    {
      src: "assets/img/Pastevents/2968.jpeg",
      caption:
        "KSRTC  ആരംഭിച്ച ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 100-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2968.jpeg",
    },
    {
      src: "assets/img/Pastevents/2969.jpeg",
      caption:
        "KSRTC  ആരംഭിച്ച ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 100-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2969.jpeg",
    },
    {
      src: "assets/img/Pastevents/2970.jpeg",
      caption:
        "KSRTC  ആരംഭിച്ച ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 100-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2970.jpeg",
    },
    {
      src: "assets/img/Pastevents/2971.jpeg",
      caption:
        "KSRTC  ആരംഭിച്ച ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 100-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2971.jpeg",
    },
    {
      src: "assets/img/Pastevents/2961.jpeg",
      caption:
        "തൃപ്പാതം സൈക്കോ സോഷ്യൽ റിഹാബിലിറ്റേഷൻ സെൻ്റർ,തിരുവനന്തപുരം ഐകോൺസ് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2961.jpeg",
    },
    {
      src: "assets/img/Pastevents/2962.jpeg",
      caption:
        "തൃപ്പാതം സൈക്കോ സോഷ്യൽ റിഹാബിലിറ്റേഷൻ സെൻ്റർ,തിരുവനന്തപുരം ഐകോൺസ് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2962.jpeg",
    },
    {
      src: "assets/img/Pastevents/2963.jpeg",
      caption:
        "തൃപ്പാതം സൈക്കോ സോഷ്യൽ റിഹാബിലിറ്റേഷൻ സെൻ്റർ,തിരുവനന്തപുരം ഐകോൺസ് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2963.jpeg",
    },
    {
      src: "assets/img/Pastevents/2964.jpeg",
      caption:
        "തൃപ്പാതം സൈക്കോ സോഷ്യൽ റിഹാബിലിറ്റേഷൻ സെൻ്റർ,തിരുവനന്തപുരം ഐകോൺസ് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2964.jpeg",
    },
    {
      src: "assets/img/Pastevents/2965.jpeg",
      caption:
        "തൃപ്പാതം സൈക്കോ സോഷ്യൽ റിഹാബിലിറ്റേഷൻ സെൻ്റർ,തിരുവനന്തപുരം ഐകോൺസ് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2965.jpeg",
    },
    {
      src: "assets/img/Pastevents/2966.jpeg",
      caption:
        "തൃപ്പാതം സൈക്കോ സോഷ്യൽ റിഹാബിലിറ്റേഷൻ സെൻ്റർ,തിരുവനന്തപുരം ഐകോൺസ് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2966.jpeg",
    },
    {
      src: "assets/img/Pastevents/2955.jpeg",
      caption:
        "തള്ളച്ചിറ റെസിഡൻഷ്യൽ അസോസിയേഷൻ, വിതുര ജനമൈത്രി പോലീസിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2955.jpeg",
    },
    {
      src: "assets/img/Pastevents/2956.jpeg",
      caption:
        "തള്ളച്ചിറ റെസിഡൻഷ്യൽ അസോസിയേഷൻ, വിതുര ജനമൈത്രി പോലീസിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2956.jpeg",
    },
    {
      src: "assets/img/Pastevents/2957.jpeg",
      caption:
        "തള്ളച്ചിറ റെസിഡൻഷ്യൽ അസോസിയേഷൻ, വിതുര ജനമൈത്രി പോലീസിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2957.jpeg",
    },
    {
      src: "assets/img/Pastevents/2958.jpeg",
      caption:
        "തള്ളച്ചിറ റെസിഡൻഷ്യൽ അസോസിയേഷൻ, വിതുര ജനമൈത്രി പോലീസിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2958.jpeg",
    },
    {
      src: "assets/img/Pastevents/2959.jpeg",
      caption:
        "തള്ളച്ചിറ റെസിഡൻഷ്യൽ അസോസിയേഷൻ, വിതുര ജനമൈത്രി പോലീസിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2959.jpeg",
    },
    {
      src: "assets/img/Pastevents/2960.jpeg",
      caption:
        "തള്ളച്ചിറ റെസിഡൻഷ്യൽ അസോസിയേഷൻ, വിതുര ജനമൈത്രി പോലീസിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2960.jpeg",
    },
    {
      src: "assets/img/Pastevents/2948.jpeg",
      caption:
        "വിവേകാനന്ദ നഗർ റെസിഡൻഷ്യൽ അസോസിയേഷൻ, തിരുമല ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2948.jpeg",
    },
    {
      src: "assets/img/Pastevents/2949.jpeg",
      caption:
        "വിവേകാനന്ദ നഗർ റെസിഡൻഷ്യൽ അസോസിയേഷൻ, തിരുമല ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2949.jpeg",
    },
    {
      src: "assets/img/Pastevents/2950.jpeg",
      caption:
        "വിവേകാനന്ദ നഗർ റെസിഡൻഷ്യൽ അസോസിയേഷൻ, തിരുമല ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2950.jpeg",
    },
    {
      src: "assets/img/Pastevents/2951.jpeg",
      caption:
        "വിവേകാനന്ദ നഗർ റെസിഡൻഷ്യൽ അസോസിയേഷൻ, തിരുമല ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2951.jpeg",
    },
    {
      src: "assets/img/Pastevents/2952.jpeg",
      caption:
        "വിവേകാനന്ദ നഗർ റെസിഡൻഷ്യൽ അസോസിയേഷൻ, തിരുമല ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2952.jpeg",
    },
    {
      src: "assets/img/Pastevents/2953.jpeg",
      caption:
        "വിവേകാനന്ദ നഗർ റെസിഡൻഷ്യൽ അസോസിയേഷൻ, തിരുമല ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2953.jpeg",
    },
    {
      src: "assets/img/Pastevents/2954.jpeg",
      caption:
        "വിവേകാനന്ദ നഗർ റെസിഡൻഷ്യൽ അസോസിയേഷൻ, തിരുമല ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2954.jpeg",
    },
    {
      src: "assets/img/Pastevents/2940.jpeg",
      caption:
        "ബോണക്കാട് എസ്റ്റേറ്റ് തൊഴിലാളി ക്ഷേമ സംഘം, ട്രിവാൻഡ്രം എലൈറ്റ് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2940.jpeg",
    },
    {
      src: "assets/img/Pastevents/2941.jpeg",
      caption:
        "ബോണക്കാട് എസ്റ്റേറ്റ് തൊഴിലാളി ക്ഷേമ സംഘം, ട്രിവാൻഡ്രം എലൈറ്റ് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2941.jpeg",
    },
    {
      src: "assets/img/Pastevents/2942.jpeg",
      caption:
        "ബോണക്കാട് എസ്റ്റേറ്റ് തൊഴിലാളി ക്ഷേമ സംഘം, ട്രിവാൻഡ്രം എലൈറ്റ് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2942.jpeg",
    },
    {
      src: "assets/img/Pastevents/2943.jpeg",
      caption:
        "ബോണക്കാട് എസ്റ്റേറ്റ് തൊഴിലാളി ക്ഷേമ സംഘം, ട്രിവാൻഡ്രം എലൈറ്റ് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2943.jpeg",
    },
    {
      src: "assets/img/Pastevents/2944.jpeg",
      caption:
        "ബോണക്കാട് എസ്റ്റേറ്റ് തൊഴിലാളി ക്ഷേമ സംഘം, ട്രിവാൻഡ്രം എലൈറ്റ് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2944.jpeg",
    },
    {
      src: "assets/img/Pastevents/2945.jpeg",
      caption:
        "ബോണക്കാട് എസ്റ്റേറ്റ് തൊഴിലാളി ക്ഷേമ സംഘം, ട്രിവാൻഡ്രം എലൈറ്റ് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2945.jpeg",
    },
    {
      src: "assets/img/Pastevents/2946.jpeg",
      caption:
        "ബോണക്കാട് എസ്റ്റേറ്റ് തൊഴിലാളി ക്ഷേമ സംഘം, ട്രിവാൻഡ്രം എലൈറ്റ് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2946.jpeg",
    },
    {
      src: "assets/img/Pastevents/2947.jpeg",
      caption:
        "ബോണക്കാട് എസ്റ്റേറ്റ് തൊഴിലാളി ക്ഷേമ സംഘം, ട്രിവാൻഡ്രം എലൈറ്റ് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2947.jpeg",
    },
    {
      src: "assets/img/Pastevents/2935.jpeg",
      caption:
        " KSRTC  ആരംഭിച്ച ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 100-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2935.jpeg",
    },
    {
      src: "assets/img/Pastevents/2936.jpeg",
      caption:
        " KSRTC  ആരംഭിച്ച ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 100-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2936.jpeg",
    },
    {
      src: "assets/img/Pastevents/2937.jpeg",
      caption:
        " KSRTC  ആരംഭിച്ച ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 100-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2937.jpeg",
    },
    {
      src: "assets/img/Pastevents/2938.jpeg",
      caption:
        " KSRTC  ആരംഭിച്ച ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 100-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2938.jpeg",
    },
    {
      src: "assets/img/Pastevents/2939.jpeg",
      caption:
        " KSRTC  ആരംഭിച്ച ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 100-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2939.jpeg",
    },
    {
      src: "assets/img/Pastevents/2929.jpeg",
      caption:
        " KSRTC  ആരംഭിച്ച ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 100-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2929.jpeg",
    },
    {
      src: "assets/img/Pastevents/2930.jpeg",
      caption:
        " KSRTC  ആരംഭിച്ച ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 100-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2930.jpeg",
    },
    {
      src: "assets/img/Pastevents/2931.jpeg",
      caption:
        " KSRTC  ആരംഭിച്ച ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 100-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2931.jpeg",
    },
    {
      src: "assets/img/Pastevents/2932.jpeg",
      caption:
        " KSRTC  ആരംഭിച്ച ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 100-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2932.jpeg",
    },
    {
      src: "assets/img/Pastevents/2933.jpeg",
      caption:
        " KSRTC  ആരംഭിച്ച ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 100-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2933.jpeg",
    },
    {
      src: "assets/img/Pastevents/2934.jpeg",
      caption:
        " KSRTC  ആരംഭിച്ച ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 100-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2934.jpeg",
    },
    {
      src: "assets/img/Pastevents/2923.jpeg",
      caption:
        "തിരുവട്ടാർ നോർത്ത് ബ്ലോക്ക് അമ്മ മക്കൾ മുന്നേറ്റ കഴകം, തമിഴ്നാട് ഗവ: ഹെൽത്ത് സ്കീമിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2923.jpeg",
    },
    {
      src: "assets/img/Pastevents/2924.jpeg",
      caption:
        "തിരുവട്ടാർ നോർത്ത് ബ്ലോക്ക് അമ്മ മക്കൾ മുന്നേറ്റ കഴകം, തമിഴ്നാട് ഗവ: ഹെൽത്ത് സ്കീമിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2924.jpeg",
    },
    {
      src: "assets/img/Pastevents/2925.jpeg",
      caption:
        "തിരുവട്ടാർ നോർത്ത് ബ്ലോക്ക് അമ്മ മക്കൾ മുന്നേറ്റ കഴകം, തമിഴ്നാട് ഗവ: ഹെൽത്ത് സ്കീമിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2925.jpeg",
    },
    {
      src: "assets/img/Pastevents/2926.jpeg",
      caption:
        "തിരുവട്ടാർ നോർത്ത് ബ്ലോക്ക് അമ്മ മക്കൾ മുന്നേറ്റ കഴകം, തമിഴ്നാട് ഗവ: ഹെൽത്ത് സ്കീമിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2926.jpeg",
    },
    {
      src: "assets/img/Pastevents/2927.jpeg",
      caption:
        "തിരുവട്ടാർ നോർത്ത് ബ്ലോക്ക് അമ്മ മക്കൾ മുന്നേറ്റ കഴകം, തമിഴ്നാട് ഗവ: ഹെൽത്ത് സ്കീമിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2927.jpeg",
    },
    {
      src: "assets/img/Pastevents/2928.jpeg",
      caption:
        "തിരുവട്ടാർ നോർത്ത് ബ്ലോക്ക് അമ്മ മക്കൾ മുന്നേറ്റ കഴകം, തമിഴ്നാട് ഗവ: ഹെൽത്ത് സ്കീമിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2928.jpeg",
    },
    {
      src: "assets/img/Pastevents/2917.jpeg",
      caption:
        " KSRTC  ആരംഭിച്ച ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 100-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2917.jpeg",
    },
    {
      src: "assets/img/Pastevents/2918.jpeg",
      caption:
        " KSRTC  ആരംഭിച്ച ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 100-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2918.jpeg",
    },
    {
      src: "assets/img/Pastevents/2919.jpeg",
      caption:
        " KSRTC  ആരംഭിച്ച ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 100-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2919.jpeg",
    },
    {
      src: "assets/img/Pastevents/2920.jpeg",
      caption:
        " KSRTC  ആരംഭിച്ച ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 100-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2920.jpeg",
    },
    {
      src: "assets/img/Pastevents/2921.jpeg",
      caption:
        " KSRTC  ആരംഭിച്ച ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 100-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2921.jpeg",
    },
    {
      src: "assets/img/Pastevents/2922.jpeg",
      caption:
        " KSRTC  ആരംഭിച്ച ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 100-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2922.jpeg",
    },
    {
      src: "assets/img/Pastevents/2909.jpeg",
      caption:
        "കെ.എസ്.ആർ ടി സി സെൻട്രൽ യൂണിറ്റ്(17), ഹെച്ച് എൽ എൽ ലൈഫ് കെയർ യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/290.jpeg",
    },
    {
      src: "assets/img/Pastevents/2910.jpeg",
      caption:
        "കെ.എസ്.ആർ ടി സി സെൻട്രൽ യൂണിറ്റ്(17), ഹെച്ച് എൽ എൽ ലൈഫ് കെയർ യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2910.jpeg",
    },
    {
      src: "assets/img/Pastevents/2911.jpeg",
      caption:
        "കെ.എസ്.ആർ ടി സി സെൻട്രൽ യൂണിറ്റ്(17), ഹെച്ച് എൽ എൽ ലൈഫ് കെയർ യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2911.jpeg",
    },
    {
      src: "assets/img/Pastevents/2912.jpeg",
      caption:
        "കെ.എസ്.ആർ ടി സി സെൻട്രൽ യൂണിറ്റ്(17), ഹെച്ച് എൽ എൽ ലൈഫ് കെയർ യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2912.jpeg",
    },
    {
      src: "assets/img/Pastevents/2913.jpeg",
      caption:
        "കെ.എസ്.ആർ ടി സി സെൻട്രൽ യൂണിറ്റ്(17), ഹെച്ച് എൽ എൽ ലൈഫ് കെയർ യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2913.jpeg",
    },
    {
      src: "assets/img/Pastevents/2914.jpeg",
      caption:
        "കെ.എസ്.ആർ ടി സി സെൻട്രൽ യൂണിറ്റ്(17), ഹെച്ച് എൽ എൽ ലൈഫ് കെയർ യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2914.jpeg",
    },
    {
      src: "assets/img/Pastevents/2915.jpeg",
      caption:
        "കെ.എസ്.ആർ ടി സി സെൻട്രൽ യൂണിറ്റ്(17), ഹെച്ച് എൽ എൽ ലൈഫ് കെയർ യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2915.jpeg",
    },
    {
      src: "assets/img/Pastevents/2916.jpeg",
      caption:
        "കെ.എസ്.ആർ ടി സി സെൻട്രൽ യൂണിറ്റ്(17), ഹെച്ച് എൽ എൽ ലൈഫ് കെയർ യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2916.jpeg",
    },
    {
      src: "assets/img/Pastevents/2902.jpeg",
      caption:
        "കെ.എസ്.ആർ ടി സി സെൻട്രൽ യൂണിറ്റ്(16), ഹെച്ച് എൽ എൽ ലൈഫ് കെയർ യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2902.jpeg",
    },
    {
      src: "assets/img/Pastevents/2903.jpeg",
      caption:
        "കെ.എസ്.ആർ ടി സി സെൻട്രൽ യൂണിറ്റ്(16), ഹെച്ച് എൽ എൽ ലൈഫ് കെയർ യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2903.jpeg",
    },
    {
      src: "assets/img/Pastevents/2904.jpeg",
      caption:
        "കെ.എസ്.ആർ ടി സി സെൻട്രൽ യൂണിറ്റ്(16), ഹെച്ച് എൽ എൽ ലൈഫ് കെയർ യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2904.jpeg",
    },
    {
      src: "assets/img/Pastevents/2905.jpeg",
      caption:
        "കെ.എസ്.ആർ ടി സി സെൻട്രൽ യൂണിറ്റ്(16), ഹെച്ച് എൽ എൽ ലൈഫ് കെയർ യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2905.jpeg",
    },
    {
      src: "assets/img/Pastevents/2906.jpeg",
      caption:
        "കെ.എസ്.ആർ ടി സി സെൻട്രൽ യൂണിറ്റ്(16), ഹെച്ച് എൽ എൽ ലൈഫ് കെയർ യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2906.jpeg",
    },
    {
      src: "assets/img/Pastevents/2907.jpeg",
      caption:
        "കെ.എസ്.ആർ ടി സി സെൻട്രൽ യൂണിറ്റ്(16), ഹെച്ച് എൽ എൽ ലൈഫ് കെയർ യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2907.jpeg",
    },
    {
      src: "assets/img/Pastevents/2908.jpeg",
      caption:
        "കെ.എസ്.ആർ ടി സി സെൻട്രൽ യൂണിറ്റ്(16), ഹെച്ച് എൽ എൽ ലൈഫ് കെയർ യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2908.jpeg",
    },
    {
      src: "assets/img/Pastevents/2896.jpeg",
      caption:
        "കെ.എസ്.ആർ ടി സി സെൻട്രൽ യൂണിറ്റ്(15), ഹെച്ച് എൽ എൽ ലൈഫ് കെയർ യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2896.jpeg",
    },
    {
      src: "assets/img/Pastevents/2897.jpeg",
      caption:
        "കെ.എസ്.ആർ ടി സി സെൻട്രൽ യൂണിറ്റ്(15), ഹെച്ച് എൽ എൽ ലൈഫ് കെയർ യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2897.jpeg",
    },
    {
      src: "assets/img/Pastevents/2898.jpeg",
      caption:
        "കെ.എസ്.ആർ ടി സി സെൻട്രൽ യൂണിറ്റ്(15), ഹെച്ച് എൽ എൽ ലൈഫ് കെയർ യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2898.jpeg",
    },
    {
      src: "assets/img/Pastevents/2899.jpeg",
      caption:
        "കെ.എസ്.ആർ ടി സി സെൻട്രൽ യൂണിറ്റ്(15), ഹെച്ച് എൽ എൽ ലൈഫ് കെയർ യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2899.jpeg",
    },
    {
      src: "assets/img/Pastevents/2900.jpeg",
      caption:
        "കെ.എസ്.ആർ ടി സി സെൻട്രൽ യൂണിറ്റ്(15), ഹെച്ച് എൽ എൽ ലൈഫ് കെയർ യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2900.jpeg",
    },
    {
      src: "assets/img/Pastevents/2901.jpeg",
      caption:
        "കെ.എസ്.ആർ ടി സി സെൻട്രൽ യൂണിറ്റ്(15), ഹെച്ച് എൽ എൽ ലൈഫ് കെയർ യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2901.jpeg",
    },
    {
      src: "assets/img/Pastevents/2890.jpeg",
      caption:
        "മുദ്രാ നഗർ റെസിഡൻഷ്യൽ അസോസിയേഷൻ, ട്രിവാൻഡ്രം റീജൻസി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2890.jpeg",
    },
    {
      src: "assets/img/Pastevents/2891.jpeg",
      caption:
        "മുദ്രാ നഗർ റെസിഡൻഷ്യൽ അസോസിയേഷൻ, ട്രിവാൻഡ്രം റീജൻസി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2891.jpeg",
    },
    {
      src: "assets/img/Pastevents/2892.jpeg",
      caption:
        "മുദ്രാ നഗർ റെസിഡൻഷ്യൽ അസോസിയേഷൻ, ട്രിവാൻഡ്രം റീജൻസി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2892.jpeg",
    },

    {
      src: "assets/img/Pastevents/2893.jpeg",
      caption:
        "മുദ്രാ നഗർ റെസിഡൻഷ്യൽ അസോസിയേഷൻ, ട്രിവാൻഡ്രം റീജൻസി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2893.jpeg",
    },
    {
      src: "assets/img/Pastevents/2894.jpeg",
      caption:
        "മുദ്രാ നഗർ റെസിഡൻഷ്യൽ അസോസിയേഷൻ, ട്രിവാൻഡ്രം റീജൻസി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2894.jpeg",
    },
    {
      src: "assets/img/Pastevents/2895.jpeg",
      caption:
        "മുദ്രാ നഗർ റെസിഡൻഷ്യൽ അസോസിയേഷൻ, ട്രിവാൻഡ്രം റീജൻസി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2895.jpeg",
    },
    {
      src: "assets/img/Pastevents/2876.jpeg",
      caption:
        "വട്ടവിള സെന്റ് ജേക്കബ് ഇടവകപള്ളി തിരുനാളിനോടനുബന്ധിച്ച് നിംസ് മെഡിസിറ്റി യുടെ ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ   ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി, ഡയബറ്റോളജി, ഓങ്കോളജി, ഗ്യാസ്ട്രോളജി, ഓർത്തോപീഡിക്സ് , ഇ എൻ റ്റി , ഓഫ്താൻമോളജി, ഡെന്റൽ ,പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2876.jpeg",
    },
    {
      src: "assets/img/Pastevents/2877.jpeg",
      caption:
        "വട്ടവിള സെന്റ് ജേക്കബ് ഇടവകപള്ളി തിരുനാളിനോടനുബന്ധിച്ച് നിംസ് മെഡിസിറ്റി യുടെ ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ   ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി, ഡയബറ്റോളജി, ഓങ്കോളജി, ഗ്യാസ്ട്രോളജി, ഓർത്തോപീഡിക്സ് , ഇ എൻ റ്റി , ഓഫ്താൻമോളജി, ഡെന്റൽ ,പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2877.jpeg",
    },
    {
      src: "assets/img/Pastevents/2878.jpeg",
      caption:
        "വട്ടവിള സെന്റ് ജേക്കബ് ഇടവകപള്ളി തിരുനാളിനോടനുബന്ധിച്ച് നിംസ് മെഡിസിറ്റി യുടെ ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ   ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി, ഡയബറ്റോളജി, ഓങ്കോളജി, ഗ്യാസ്ട്രോളജി, ഓർത്തോപീഡിക്സ് , ഇ എൻ റ്റി , ഓഫ്താൻമോളജി, ഡെന്റൽ ,പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2878.jpeg",
    },
    {
      src: "assets/img/Pastevents/2879.jpeg",
      caption:
        "വട്ടവിള സെന്റ് ജേക്കബ് ഇടവകപള്ളി തിരുനാളിനോടനുബന്ധിച്ച് നിംസ് മെഡിസിറ്റി യുടെ ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ   ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി, ഡയബറ്റോളജി, ഓങ്കോളജി, ഗ്യാസ്ട്രോളജി, ഓർത്തോപീഡിക്സ് , ഇ എൻ റ്റി , ഓഫ്താൻമോളജി, ഡെന്റൽ ,പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2879.jpeg",
    },
    {
      src: "assets/img/Pastevents/2880.jpeg",
      caption:
        "വട്ടവിള സെന്റ് ജേക്കബ് ഇടവകപള്ളി തിരുനാളിനോടനുബന്ധിച്ച് നിംസ് മെഡിസിറ്റി യുടെ ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ   ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി, ഡയബറ്റോളജി, ഓങ്കോളജി, ഗ്യാസ്ട്രോളജി, ഓർത്തോപീഡിക്സ് , ഇ എൻ റ്റി , ഓഫ്താൻമോളജി, ഡെന്റൽ ,പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2880.jpeg",
    },
    {
      src: "assets/img/Pastevents/2881.jpeg",
      caption:
        "വട്ടവിള സെന്റ് ജേക്കബ് ഇടവകപള്ളി തിരുനാളിനോടനുബന്ധിച്ച് നിംസ് മെഡിസിറ്റി യുടെ ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ   ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി, ഡയബറ്റോളജി, ഓങ്കോളജി, ഗ്യാസ്ട്രോളജി, ഓർത്തോപീഡിക്സ് , ഇ എൻ റ്റി , ഓഫ്താൻമോളജി, ഡെന്റൽ ,പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2881.jpeg",
    },
    {
      src: "assets/img/Pastevents/2882.jpeg",
      caption:
        "വട്ടവിള സെന്റ് ജേക്കബ് ഇടവകപള്ളി തിരുനാളിനോടനുബന്ധിച്ച് നിംസ് മെഡിസിറ്റി യുടെ ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ   ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി, ഡയബറ്റോളജി, ഓങ്കോളജി, ഗ്യാസ്ട്രോളജി, ഓർത്തോപീഡിക്സ് , ഇ എൻ റ്റി , ഓഫ്താൻമോളജി, ഡെന്റൽ ,പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2882.jpeg",
    },
    {
      src: "assets/img/Pastevents/2883.jpeg",
      caption:
        "വട്ടവിള സെന്റ് ജേക്കബ് ഇടവകപള്ളി തിരുനാളിനോടനുബന്ധിച്ച് നിംസ് മെഡിസിറ്റി യുടെ ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ   ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി, ഡയബറ്റോളജി, ഓങ്കോളജി, ഗ്യാസ്ട്രോളജി, ഓർത്തോപീഡിക്സ് , ഇ എൻ റ്റി , ഓഫ്താൻമോളജി, ഡെന്റൽ ,പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2883.jpeg",
    },
    {
      src: "assets/img/Pastevents/2884.jpeg",
      caption:
        "വട്ടവിള സെന്റ് ജേക്കബ് ഇടവകപള്ളി തിരുനാളിനോടനുബന്ധിച്ച് നിംസ് മെഡിസിറ്റി യുടെ ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ   ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി, ഡയബറ്റോളജി, ഓങ്കോളജി, ഗ്യാസ്ട്രോളജി, ഓർത്തോപീഡിക്സ് , ഇ എൻ റ്റി , ഓഫ്താൻമോളജി, ഡെന്റൽ ,പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2884.jpeg",
    },
    {
      src: "assets/img/Pastevents/2885.jpeg",
      caption:
        "വട്ടവിള സെന്റ് ജേക്കബ് ഇടവകപള്ളി തിരുനാളിനോടനുബന്ധിച്ച് നിംസ് മെഡിസിറ്റി യുടെ ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ   ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി, ഡയബറ്റോളജി, ഓങ്കോളജി, ഗ്യാസ്ട്രോളജി, ഓർത്തോപീഡിക്സ് , ഇ എൻ റ്റി , ഓഫ്താൻമോളജി, ഡെന്റൽ ,പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2885.jpeg",
    },
    {
      src: "assets/img/Pastevents/2886.jpeg",
      caption:
        "വട്ടവിള സെന്റ് ജേക്കബ് ഇടവകപള്ളി തിരുനാളിനോടനുബന്ധിച്ച് നിംസ് മെഡിസിറ്റി യുടെ ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ   ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി, ഡയബറ്റോളജി, ഓങ്കോളജി, ഗ്യാസ്ട്രോളജി, ഓർത്തോപീഡിക്സ് , ഇ എൻ റ്റി , ഓഫ്താൻമോളജി, ഡെന്റൽ ,പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2886.jpeg",
    },
    {
      src: "assets/img/Pastevents/2887.jpeg",
      caption:
        "വട്ടവിള സെന്റ് ജേക്കബ് ഇടവകപള്ളി തിരുനാളിനോടനുബന്ധിച്ച് നിംസ് മെഡിസിറ്റി യുടെ ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ   ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി, ഡയബറ്റോളജി, ഓങ്കോളജി, ഗ്യാസ്ട്രോളജി, ഓർത്തോപീഡിക്സ് , ഇ എൻ റ്റി , ഓഫ്താൻമോളജി, ഡെന്റൽ ,പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2887.jpeg",
    },
    {
      src: "assets/img/Pastevents/2888.jpeg",
      caption:
        "വട്ടവിള സെന്റ് ജേക്കബ് ഇടവകപള്ളി തിരുനാളിനോടനുബന്ധിച്ച് നിംസ് മെഡിസിറ്റി യുടെ ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ   ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി, ഡയബറ്റോളജി, ഓങ്കോളജി, ഗ്യാസ്ട്രോളജി, ഓർത്തോപീഡിക്സ് , ഇ എൻ റ്റി , ഓഫ്താൻമോളജി, ഡെന്റൽ ,പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2888.jpeg",
    },
    {
      src: "assets/img/Pastevents/2889.jpeg",
      caption:
        "വട്ടവിള സെന്റ് ജേക്കബ് ഇടവകപള്ളി തിരുനാളിനോടനുബന്ധിച്ച് നിംസ് മെഡിസിറ്റി യുടെ ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ   ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി, ഡയബറ്റോളജി, ഓങ്കോളജി, ഗ്യാസ്ട്രോളജി, ഓർത്തോപീഡിക്സ് , ഇ എൻ റ്റി , ഓഫ്താൻമോളജി, ഡെന്റൽ ,പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2889.jpeg",
    },
    {
      src: "assets/img/Pastevents/2869.jpeg",
      caption:
        "കെ.എസ്.ആർ ടി സി സെൻട്രൽ യൂണിറ്റ്(13), ഹെച്ച് എൽ എൽ ലൈഫ് കെയർ യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2869.jpeg",
    },
    {
      src: "assets/img/Pastevents/2870.jpeg",
      caption:
        "കെ.എസ്.ആർ ടി സി സെൻട്രൽ യൂണിറ്റ്(13), ഹെച്ച് എൽ എൽ ലൈഫ് കെയർ യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2870.jpeg",
    },
    {
      src: "assets/img/Pastevents/2871.jpeg",
      caption:
        "കെ.എസ്.ആർ ടി സി സെൻട്രൽ യൂണിറ്റ്(13), ഹെച്ച് എൽ എൽ ലൈഫ് കെയർ യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2871.jpeg",
    },
    {
      src: "assets/img/Pastevents/2872.jpeg",
      caption:
        "കെ.എസ്.ആർ ടി സി സെൻട്രൽ യൂണിറ്റ്(13), ഹെച്ച് എൽ എൽ ലൈഫ് കെയർ യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2872.jpeg",
    },
    {
      src: "assets/img/Pastevents/2873.jpeg",
      caption:
        "കെ.എസ്.ആർ ടി സി സെൻട്രൽ യൂണിറ്റ്(13), ഹെച്ച് എൽ എൽ ലൈഫ് കെയർ യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2873.jpeg",
    },
    {
      src: "assets/img/Pastevents/2874.jpeg",
      caption:
        "കെ.എസ്.ആർ ടി സി സെൻട്രൽ യൂണിറ്റ്(13), ഹെച്ച് എൽ എൽ ലൈഫ് കെയർ യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2874.jpeg",
    },
    {
      src: "assets/img/Pastevents/2875.jpeg",
      caption:
        "കെ.എസ്.ആർ ടി സി സെൻട്രൽ യൂണിറ്റ്(13), ഹെച്ച് എൽ എൽ ലൈഫ് കെയർ യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2875.jpeg",
    },
    {
      src: "assets/img/Pastevents/2862.jpeg",
      caption:
        "കെ.എസ്.ആർ ടി സി സെൻട്രൽ യൂണിറ്റ്(12), ഹെച്ച് എൽ എൽ ലൈഫ് കെയർ യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2862.jpeg",
    },
    {
      src: "assets/img/Pastevents/2863.jpeg",
      caption:
        "കെ.എസ്.ആർ ടി സി സെൻട്രൽ യൂണിറ്റ്(12), ഹെച്ച് എൽ എൽ ലൈഫ് കെയർ യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2863.jpeg",
    },
    {
      src: "assets/img/Pastevents/2864.jpeg",
      caption:
        "കെ.എസ്.ആർ ടി സി സെൻട്രൽ യൂണിറ്റ്(12), ഹെച്ച് എൽ എൽ ലൈഫ് കെയർ യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2864.jpeg",
    },
    {
      src: "assets/img/Pastevents/2865.jpeg",
      caption:
        "കെ.എസ്.ആർ ടി സി സെൻട്രൽ യൂണിറ്റ്(12), ഹെച്ച് എൽ എൽ ലൈഫ് കെയർ യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2865.jpeg",
    },
    {
      src: "assets/img/Pastevents/2866.jpeg",
      caption:
        "കെ.എസ്.ആർ ടി സി സെൻട്രൽ യൂണിറ്റ്(12), ഹെച്ച് എൽ എൽ ലൈഫ് കെയർ യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2866.jpeg",
    },
    {
      src: "assets/img/Pastevents/2867.jpeg",
      caption:
        "കെ.എസ്.ആർ ടി സി സെൻട്രൽ യൂണിറ്റ്(12), ഹെച്ച് എൽ എൽ ലൈഫ് കെയർ യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2867.jpeg",
    },
    {
      src: "assets/img/Pastevents/2868.jpeg",
      caption:
        "കെ.എസ്.ആർ ടി സി സെൻട്രൽ യൂണിറ്റ്(12), ഹെച്ച് എൽ എൽ ലൈഫ് കെയർ യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2868.jpeg",
    },
    {
      src: "assets/img/Pastevents/2854.jpeg",
      caption:
        "കെ.എസ്.ആർ ടി സി സെൻട്രൽ യൂണിറ്റ്(11), ഹെച്ച് എൽ എൽ ലൈഫ് കെയർ യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2854.jpeg",
    },
    {
      src: "assets/img/Pastevents/2855.jpeg",
      caption:
        "കെ.എസ്.ആർ ടി സി സെൻട്രൽ യൂണിറ്റ്(11), ഹെച്ച് എൽ എൽ ലൈഫ് കെയർ യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2855.jpeg",
    },
    {
      src: "assets/img/Pastevents/2856.jpeg",
      caption:
        "കെ.എസ്.ആർ ടി സി സെൻട്രൽ യൂണിറ്റ്(11), ഹെച്ച് എൽ എൽ ലൈഫ് കെയർ യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2856.jpeg",
    },
    {
      src: "assets/img/Pastevents/2857.jpeg",
      caption:
        "കെ.എസ്.ആർ ടി സി സെൻട്രൽ യൂണിറ്റ്(11), ഹെച്ച് എൽ എൽ ലൈഫ് കെയർ യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2857.jpeg",
    },
    {
      src: "assets/img/Pastevents/2858.jpeg",
      caption:
        "കെ.എസ്.ആർ ടി സി സെൻട്രൽ യൂണിറ്റ്(11), ഹെച്ച് എൽ എൽ ലൈഫ് കെയർ യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2858.jpeg",
    },
    {
      src: "assets/img/Pastevents/2859.jpeg",
      caption:
        "കെ.എസ്.ആർ ടി സി സെൻട്രൽ യൂണിറ്റ്(11), ഹെച്ച് എൽ എൽ ലൈഫ് കെയർ യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2859.jpeg",
    },
    {
      src: "assets/img/Pastevents/2860.jpeg",
      caption:
        "കെ.എസ്.ആർ ടി സി സെൻട്രൽ യൂണിറ്റ്(11), ഹെച്ച് എൽ എൽ ലൈഫ് കെയർ യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2860.jpeg",
    },
    {
      src: "assets/img/Pastevents/2861.jpeg",
      caption:
        "കെ.എസ്.ആർ ടി സി സെൻട്രൽ യൂണിറ്റ്(11), ഹെച്ച് എൽ എൽ ലൈഫ് കെയർ യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2861.jpeg",
    },
    {
      src: "assets/img/Pastevents/2839.jpeg",
      caption:
        "പത്തനാപുരം ഗാന്ധിഭവൻൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ കെ ബി ഗണേഷ് കുമാർ (എം എൽ എ).ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി, ഗൈനക്കോളജി, ഓർത്തോപീഡിക്കസ്, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി. നൂറുൽ ഇസ്‌ലാം യൂണിവേഴ്സിറ്റിയിലെ ബാച്ച്ലർ ഇൻ  ഓഡിയോളജി ആൻ്റ് സ്പീച്ച്-ലാംഗ്വേജ് വിദാഗത്തിലെ വിദ്യാർഥികൾക്ക് ഇൻ്റേൺഷിപ്പ് സർട്ടിഫിക്കറ്റ് വിതരണവും നടത്തി. ഡിപ്പാർട്ട്മെൻ്റിലെ ഫൈനൽ ",
      thumb: "assets/img/Pastevents/2839.jpeg",
    },
    {
      src: "assets/img/Pastevents/2840.jpeg",
      caption:
        "പത്തനാപുരം ഗാന്ധിഭവൻൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ കെ ബി ഗണേഷ് കുമാർ (എം എൽ എ).ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി, ഗൈനക്കോളജി, ഓർത്തോപീഡിക്കസ്, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി. നൂറുൽ ഇസ്‌ലാം യൂണിവേഴ്സിറ്റിയിലെ ബാച്ച്ലർ ഇൻ  ഓഡിയോളജി ആൻ്റ് സ്പീച്ച്-ലാംഗ്വേജ് വിദാഗത്തിലെ വിദ്യാർഥികൾക്ക് ഇൻ്റേൺഷിപ്പ് സർട്ടിഫിക്കറ്റ് വിതരണവും നടത്തി. ഡിപ്പാർട്ട്മെൻ്റിലെ ഫൈനൽ ",
      thumb: "assets/img/Pastevents/2840.jpeg",
    },
    {
      src: "assets/img/Pastevents/2841.jpeg",
      caption:
        "പത്തനാപുരം ഗാന്ധിഭവൻൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ കെ ബി ഗണേഷ് കുമാർ (എം എൽ എ).ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി, ഗൈനക്കോളജി, ഓർത്തോപീഡിക്കസ്, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി. നൂറുൽ ഇസ്‌ലാം യൂണിവേഴ്സിറ്റിയിലെ ബാച്ച്ലർ ഇൻ  ഓഡിയോളജി ആൻ്റ് സ്പീച്ച്-ലാംഗ്വേജ് വിദാഗത്തിലെ വിദ്യാർഥികൾക്ക് ഇൻ്റേൺഷിപ്പ് സർട്ടിഫിക്കറ്റ് വിതരണവും നടത്തി. ഡിപ്പാർട്ട്മെൻ്റിലെ ഫൈനൽ ",
      thumb: "assets/img/Pastevents/2841.jpeg",
    },
    {
      src: "assets/img/Pastevents/2842.jpeg",
      caption:
        "പത്തനാപുരം ഗാന്ധിഭവൻൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ കെ ബി ഗണേഷ് കുമാർ (എം എൽ എ).ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി, ഗൈനക്കോളജി, ഓർത്തോപീഡിക്കസ്, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി. നൂറുൽ ഇസ്‌ലാം യൂണിവേഴ്സിറ്റിയിലെ ബാച്ച്ലർ ഇൻ  ഓഡിയോളജി ആൻ്റ് സ്പീച്ച്-ലാംഗ്വേജ് വിദാഗത്തിലെ വിദ്യാർഥികൾക്ക് ഇൻ്റേൺഷിപ്പ് സർട്ടിഫിക്കറ്റ് വിതരണവും നടത്തി. ഡിപ്പാർട്ട്മെൻ്റിലെ ഫൈനൽ ",
      thumb: "assets/img/Pastevents/2842.jpeg",
    },
    {
      src: "assets/img/Pastevents/2843.jpeg",
      caption:
        "പത്തനാപുരം ഗാന്ധിഭവൻൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ കെ ബി ഗണേഷ് കുമാർ (എം എൽ എ).ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി, ഗൈനക്കോളജി, ഓർത്തോപീഡിക്കസ്, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി. നൂറുൽ ഇസ്‌ലാം യൂണിവേഴ്സിറ്റിയിലെ ബാച്ച്ലർ ഇൻ  ഓഡിയോളജി ആൻ്റ് സ്പീച്ച്-ലാംഗ്വേജ് വിദാഗത്തിലെ വിദ്യാർഥികൾക്ക് ഇൻ്റേൺഷിപ്പ് സർട്ടിഫിക്കറ്റ് വിതരണവും നടത്തി. ഡിപ്പാർട്ട്മെൻ്റിലെ ഫൈനൽ ",
      thumb: "assets/img/Pastevents/2843.jpeg",
    },
    {
      src: "assets/img/Pastevents/2844.jpeg",
      caption:
        "പത്തനാപുരം ഗാന്ധിഭവൻൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ കെ ബി ഗണേഷ് കുമാർ (എം എൽ എ).ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി, ഗൈനക്കോളജി, ഓർത്തോപീഡിക്കസ്, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി. നൂറുൽ ഇസ്‌ലാം യൂണിവേഴ്സിറ്റിയിലെ ബാച്ച്ലർ ഇൻ  ഓഡിയോളജി ആൻ്റ് സ്പീച്ച്-ലാംഗ്വേജ് വിദാഗത്തിലെ വിദ്യാർഥികൾക്ക് ഇൻ്റേൺഷിപ്പ് സർട്ടിഫിക്കറ്റ് വിതരണവും നടത്തി. ഡിപ്പാർട്ട്മെൻ്റിലെ ഫൈനൽ ",
      thumb: "assets/img/Pastevents/2844.jpeg",
    },
    {
      src: "assets/img/Pastevents/2845.jpeg",
      caption:
        "പത്തനാപുരം ഗാന്ധിഭവൻൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ കെ ബി ഗണേഷ് കുമാർ (എം എൽ എ).ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി, ഗൈനക്കോളജി, ഓർത്തോപീഡിക്കസ്, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി. നൂറുൽ ഇസ്‌ലാം യൂണിവേഴ്സിറ്റിയിലെ ബാച്ച്ലർ ഇൻ  ഓഡിയോളജി ആൻ്റ് സ്പീച്ച്-ലാംഗ്വേജ് വിദാഗത്തിലെ വിദ്യാർഥികൾക്ക് ഇൻ്റേൺഷിപ്പ് സർട്ടിഫിക്കറ്റ് വിതരണവും നടത്തി. ഡിപ്പാർട്ട്മെൻ്റിലെ ഫൈനൽ ",
      thumb: "assets/img/Pastevents/2845.jpeg",
    },
    {
      src: "assets/img/Pastevents/2846.jpeg",
      caption:
        "പത്തനാപുരം ഗാന്ധിഭവൻൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ കെ ബി ഗണേഷ് കുമാർ (എം എൽ എ).ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി, ഗൈനക്കോളജി, ഓർത്തോപീഡിക്കസ്, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി. നൂറുൽ ഇസ്‌ലാം യൂണിവേഴ്സിറ്റിയിലെ ബാച്ച്ലർ ഇൻ  ഓഡിയോളജി ആൻ്റ് സ്പീച്ച്-ലാംഗ്വേജ് വിദാഗത്തിലെ വിദ്യാർഥികൾക്ക് ഇൻ്റേൺഷിപ്പ് സർട്ടിഫിക്കറ്റ് വിതരണവും നടത്തി. ഡിപ്പാർട്ട്മെൻ്റിലെ ഫൈനൽ ",
      thumb: "assets/img/Pastevents/2846.jpeg",
    },
    {
      src: "assets/img/Pastevents/2847.jpeg",
      caption:
        "പത്തനാപുരം ഗാന്ധിഭവൻൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ കെ ബി ഗണേഷ് കുമാർ (എം എൽ എ).ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി, ഗൈനക്കോളജി, ഓർത്തോപീഡിക്കസ്, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി. നൂറുൽ ഇസ്‌ലാം യൂണിവേഴ്സിറ്റിയിലെ ബാച്ച്ലർ ഇൻ  ഓഡിയോളജി ആൻ്റ് സ്പീച്ച്-ലാംഗ്വേജ് വിദാഗത്തിലെ വിദ്യാർഥികൾക്ക് ഇൻ്റേൺഷിപ്പ് സർട്ടിഫിക്കറ്റ് വിതരണവും നടത്തി. ഡിപ്പാർട്ട്മെൻ്റിലെ ഫൈനൽ ",
      thumb: "assets/img/Pastevents/2847.jpeg",
    },
    {
      src: "assets/img/Pastevents/2848.jpeg",
      caption:
        "പത്തനാപുരം ഗാന്ധിഭവൻൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ കെ ബി ഗണേഷ് കുമാർ (എം എൽ എ).ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി, ഗൈനക്കോളജി, ഓർത്തോപീഡിക്കസ്, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി. നൂറുൽ ഇസ്‌ലാം യൂണിവേഴ്സിറ്റിയിലെ ബാച്ച്ലർ ഇൻ  ഓഡിയോളജി ആൻ്റ് സ്പീച്ച്-ലാംഗ്വേജ് വിദാഗത്തിലെ വിദ്യാർഥികൾക്ക് ഇൻ്റേൺഷിപ്പ് സർട്ടിഫിക്കറ്റ് വിതരണവും നടത്തി. ഡിപ്പാർട്ട്മെൻ്റിലെ ഫൈനൽ ",
      thumb: "assets/img/Pastevents/2848.jpeg",
    },
    {
      src: "assets/img/Pastevents/2849.jpeg",
      caption:
        "പത്തനാപുരം ഗാന്ധിഭവൻൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ കെ ബി ഗണേഷ് കുമാർ (എം എൽ എ).ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി, ഗൈനക്കോളജി, ഓർത്തോപീഡിക്കസ്, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി. നൂറുൽ ഇസ്‌ലാം യൂണിവേഴ്സിറ്റിയിലെ ബാച്ച്ലർ ഇൻ  ഓഡിയോളജി ആൻ്റ് സ്പീച്ച്-ലാംഗ്വേജ് വിദാഗത്തിലെ വിദ്യാർഥികൾക്ക് ഇൻ്റേൺഷിപ്പ് സർട്ടിഫിക്കറ്റ് വിതരണവും നടത്തി. ഡിപ്പാർട്ട്മെൻ്റിലെ ഫൈനൽ ",
      thumb: "assets/img/Pastevents/2849.jpeg",
    },
    {
      src: "assets/img/Pastevents/2850.jpeg",
      caption:
        "പത്തനാപുരം ഗാന്ധിഭവൻൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ കെ ബി ഗണേഷ് കുമാർ (എം എൽ എ).ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി, ഗൈനക്കോളജി, ഓർത്തോപീഡിക്കസ്, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി. നൂറുൽ ഇസ്‌ലാം യൂണിവേഴ്സിറ്റിയിലെ ബാച്ച്ലർ ഇൻ  ഓഡിയോളജി ആൻ്റ് സ്പീച്ച്-ലാംഗ്വേജ് വിദാഗത്തിലെ വിദ്യാർഥികൾക്ക് ഇൻ്റേൺഷിപ്പ് സർട്ടിഫിക്കറ്റ് വിതരണവും നടത്തി. ഡിപ്പാർട്ട്മെൻ്റിലെ ഫൈനൽ ",
      thumb: "assets/img/Pastevents/2850.jpeg",
    },
    {
      src: "assets/img/Pastevents/2851.jpeg",
      caption:
        "പത്തനാപുരം ഗാന്ധിഭവൻൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ കെ ബി ഗണേഷ് കുമാർ (എം എൽ എ).ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി, ഗൈനക്കോളജി, ഓർത്തോപീഡിക്കസ്, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി. നൂറുൽ ഇസ്‌ലാം യൂണിവേഴ്സിറ്റിയിലെ ബാച്ച്ലർ ഇൻ  ഓഡിയോളജി ആൻ്റ് സ്പീച്ച്-ലാംഗ്വേജ് വിദാഗത്തിലെ വിദ്യാർഥികൾക്ക് ഇൻ്റേൺഷിപ്പ് സർട്ടിഫിക്കറ്റ് വിതരണവും നടത്തി. ഡിപ്പാർട്ട്മെൻ്റിലെ ഫൈനൽ ",
      thumb: "assets/img/Pastevents/2851.jpeg",
    },
    {
      src: "assets/img/Pastevents/2852.jpeg",
      caption:
        "പത്തനാപുരം ഗാന്ധിഭവൻൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ കെ ബി ഗണേഷ് കുമാർ (എം എൽ എ).ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി, ഗൈനക്കോളജി, ഓർത്തോപീഡിക്കസ്, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി. നൂറുൽ ഇസ്‌ലാം യൂണിവേഴ്സിറ്റിയിലെ ബാച്ച്ലർ ഇൻ  ഓഡിയോളജി ആൻ്റ് സ്പീച്ച്-ലാംഗ്വേജ് വിദാഗത്തിലെ വിദ്യാർഥികൾക്ക് ഇൻ്റേൺഷിപ്പ് സർട്ടിഫിക്കറ്റ് വിതരണവും നടത്തി. ഡിപ്പാർട്ട്മെൻ്റിലെ ഫൈനൽ ",
      thumb: "assets/img/Pastevents/2852.jpeg",
    },
    {
      src: "assets/img/Pastevents/2853.jpeg",
      caption:
        "പത്തനാപുരം ഗാന്ധിഭവൻൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ കെ ബി ഗണേഷ് കുമാർ (എം എൽ എ).ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി, ഗൈനക്കോളജി, ഓർത്തോപീഡിക്കസ്, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി. നൂറുൽ ഇസ്‌ലാം യൂണിവേഴ്സിറ്റിയിലെ ബാച്ച്ലർ ഇൻ  ഓഡിയോളജി ആൻ്റ് സ്പീച്ച്-ലാംഗ്വേജ് വിദാഗത്തിലെ വിദ്യാർഥികൾക്ക് ഇൻ്റേൺഷിപ്പ് സർട്ടിഫിക്കറ്റ് വിതരണവും നടത്തി. ഡിപ്പാർട്ട്മെൻ്റിലെ ഫൈനൽ ",
      thumb: "assets/img/Pastevents/2853.jpeg",
    },
    {
      src: "assets/img/Pastevents/2832.jpeg",
      caption:
        "വലിയവിള റെസിഡൻഷ്യൽ അസോസിയേഷൻ, പൂജപ്പുര ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2832.jpeg",
    },
    {
      src: "assets/img/Pastevents/2833.jpeg",
      caption:
        "വലിയവിള റെസിഡൻഷ്യൽ അസോസിയേഷൻ, പൂജപ്പുര ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2833.jpeg",
    },
    {
      src: "assets/img/Pastevents/2834.jpeg",
      caption:
        "വലിയവിള റെസിഡൻഷ്യൽ അസോസിയേഷൻ, പൂജപ്പുര ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2834.jpeg",
    },
    {
      src: "assets/img/Pastevents/2835.jpeg",
      caption:
        "വലിയവിള റെസിഡൻഷ്യൽ അസോസിയേഷൻ, പൂജപ്പുര ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2835.jpeg",
    },
    {
      src: "assets/img/Pastevents/2836.jpeg",
      caption:
        "വലിയവിള റെസിഡൻഷ്യൽ അസോസിയേഷൻ, പൂജപ്പുര ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2836.jpeg",
    },
    {
      src: "assets/img/Pastevents/2837.jpeg",
      caption:
        "വലിയവിള റെസിഡൻഷ്യൽ അസോസിയേഷൻ, പൂജപ്പുര ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2837.jpeg",
    },
    {
      src: "assets/img/Pastevents/2838.jpeg",
      caption:
        "വലിയവിള റെസിഡൻഷ്യൽ അസോസിയേഷൻ, പൂജപ്പുര ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2838.jpeg",
    },
    {
      src: "assets/img/Pastevents/2826.jpeg",
      caption:
        "കെ.എസ്.ആർ ടി സി സെൻട്രൽ യൂണിറ്റ്(10), ഹെച്ച് എൽ എൽ ലൈഫ് കെയർ യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2826.jpeg",
    },
    {
      src: "assets/img/Pastevents/2827.jpeg",
      caption:
        "കെ.എസ്.ആർ ടി സി സെൻട്രൽ യൂണിറ്റ്(10), ഹെച്ച് എൽ എൽ ലൈഫ് കെയർ യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2827.jpeg",
    },
    {
      src: "assets/img/Pastevents/2828.jpeg",
      caption:
        "കെ.എസ്.ആർ ടി സി സെൻട്രൽ യൂണിറ്റ്(10), ഹെച്ച് എൽ എൽ ലൈഫ് കെയർ യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2828.jpeg",
    },
    {
      src: "assets/img/Pastevents/2829.jpeg",
      caption:
        "കെ.എസ്.ആർ ടി സി സെൻട്രൽ യൂണിറ്റ്(10), ഹെച്ച് എൽ എൽ ലൈഫ് കെയർ യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2829.jpeg",
    },
    {
      src: "assets/img/Pastevents/2830.jpeg",
      caption:
        "കെ.എസ്.ആർ ടി സി സെൻട്രൽ യൂണിറ്റ്(10), ഹെച്ച് എൽ എൽ ലൈഫ് കെയർ യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2830.jpeg",
    },
    {
      src: "assets/img/Pastevents/2831.jpeg",
      caption:
        "കെ.എസ്.ആർ ടി സി സെൻട്രൽ യൂണിറ്റ്(10), ഹെച്ച് എൽ എൽ ലൈഫ് കെയർ യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2831.jpeg",
    },
    {
      src: "assets/img/Pastevents/2820.jpeg",
      caption:
        "കെ.എസ്.ആർ ടി സി സെൻട്രൽ യൂണിറ്റ്(9), ഹെച്ച് എൽ എൽ ലൈഫ് കെയർ യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2820.jpeg",
    },
    {
      src: "assets/img/Pastevents/2821.jpeg",
      caption:
        "കെ.എസ്.ആർ ടി സി സെൻട്രൽ യൂണിറ്റ്(9), ഹെച്ച് എൽ എൽ ലൈഫ് കെയർ യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2821.jpeg",
    },
    {
      src: "assets/img/Pastevents/2822.jpeg",
      caption:
        "കെ.എസ്.ആർ ടി സി സെൻട്രൽ യൂണിറ്റ്(9), ഹെച്ച് എൽ എൽ ലൈഫ് കെയർ യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2822.jpeg",
    },
    {
      src: "assets/img/Pastevents/2823.jpeg",
      caption:
        "കെ.എസ്.ആർ ടി സി സെൻട്രൽ യൂണിറ്റ്(9), ഹെച്ച് എൽ എൽ ലൈഫ് കെയർ യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2823.jpeg",
    },
    {
      src: "assets/img/Pastevents/2824.jpeg",
      caption:
        "കെ.എസ്.ആർ ടി സി സെൻട്രൽ യൂണിറ്റ്(9), ഹെച്ച് എൽ എൽ ലൈഫ് കെയർ യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2824.jpeg",
    },
    {
      src: "assets/img/Pastevents/2825.jpeg",
      caption:
        "കെ.എസ്.ആർ ടി സി സെൻട്രൽ യൂണിറ്റ്(9), ഹെച്ച് എൽ എൽ ലൈഫ് കെയർ യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2825.jpeg",
    },
    {
      src: "assets/img/Pastevents/2812.jpeg",
      caption:
        "കെ.എസ്.ആർ ടി സി സെൻട്രൽ യൂണിറ്റ്(8), ഹെച്ച് എൽ എൽ ലൈഫ് കെയർ യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2812.jpeg",
    },
    {
      src: "assets/img/Pastevents/2813.jpeg",
      caption:
        "കെ.എസ്.ആർ ടി സി സെൻട്രൽ യൂണിറ്റ്(8), ഹെച്ച് എൽ എൽ ലൈഫ് കെയർ യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2813.jpeg",
    },
    {
      src: "assets/img/Pastevents/2814.jpeg",
      caption:
        "കെ.എസ്.ആർ ടി സി സെൻട്രൽ യൂണിറ്റ്(8), ഹെച്ച് എൽ എൽ ലൈഫ് കെയർ യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2814.jpeg",
    },
    {
      src: "assets/img/Pastevents/2815.jpeg",
      caption:
        "കെ.എസ്.ആർ ടി സി സെൻട്രൽ യൂണിറ്റ്(8), ഹെച്ച് എൽ എൽ ലൈഫ് കെയർ യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2815.jpeg",
    },
    {
      src: "assets/img/Pastevents/2816.jpeg",
      caption:
        "കെ.എസ്.ആർ ടി സി സെൻട്രൽ യൂണിറ്റ്(8), ഹെച്ച് എൽ എൽ ലൈഫ് കെയർ യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2816.jpeg",
    },
    {
      src: "assets/img/Pastevents/2817.jpeg",
      caption:
        "കെ.എസ്.ആർ ടി സി സെൻട്രൽ യൂണിറ്റ്(8), ഹെച്ച് എൽ എൽ ലൈഫ് കെയർ യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2817.jpeg",
    },
    {
      src: "assets/img/Pastevents/2818.jpeg",
      caption:
        "കെ.എസ്.ആർ ടി സി സെൻട്രൽ യൂണിറ്റ്(8), ഹെച്ച് എൽ എൽ ലൈഫ് കെയർ യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2818.jpeg",
    },
    {
      src: "assets/img/Pastevents/2819.jpeg",
      caption:
        "കെ.എസ്.ആർ ടി സി സെൻട്രൽ യൂണിറ്റ്(8), ഹെച്ച് എൽ എൽ ലൈഫ് കെയർ യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2819.jpeg",
    },
    {
      src: "assets/img/Pastevents/2804.jpeg",
      caption:
        "വെടിവച്ചാൻകോവിൽ റെസിഡൻഷ്യൽ അസോസിയേഷൻ,ബാലരാമപുരം ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു .ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2804.jpeg",
    },
    {
      src: "assets/img/Pastevents/2805.jpeg",
      caption:
        "വെടിവച്ചാൻകോവിൽ റെസിഡൻഷ്യൽ അസോസിയേഷൻ,ബാലരാമപുരം ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു .ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2805.jpeg",
    },
    {
      src: "assets/img/Pastevents/2806.jpeg",
      caption:
        "വെടിവച്ചാൻകോവിൽ റെസിഡൻഷ്യൽ അസോസിയേഷൻ,ബാലരാമപുരം ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു .ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2806.jpeg",
    },
    {
      src: "assets/img/Pastevents/2807.jpeg",
      caption:
        "വെടിവച്ചാൻകോവിൽ റെസിഡൻഷ്യൽ അസോസിയേഷൻ,ബാലരാമപുരം ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു .ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2807.jpeg",
    },
    {
      src: "assets/img/Pastevents/2808.jpeg",
      caption:
        "വെടിവച്ചാൻകോവിൽ റെസിഡൻഷ്യൽ അസോസിയേഷൻ,ബാലരാമപുരം ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു .ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2808.jpeg",
    },
    {
      src: "assets/img/Pastevents/2809.jpeg",
      caption:
        "വെടിവച്ചാൻകോവിൽ റെസിഡൻഷ്യൽ അസോസിയേഷൻ,ബാലരാമപുരം ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു .ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2809.jpeg",
    },
    {
      src: "assets/img/Pastevents/2810.jpeg",
      caption:
        "വെടിവച്ചാൻകോവിൽ റെസിഡൻഷ്യൽ അസോസിയേഷൻ,ബാലരാമപുരം ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു .ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2810.jpeg",
    },
    {
      src: "assets/img/Pastevents/2811.jpeg",
      caption:
        "വെടിവച്ചാൻകോവിൽ റെസിഡൻഷ്യൽ അസോസിയേഷൻ,ബാലരാമപുരം ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു .ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2811.jpeg",
    },
    {
      src: "assets/img/Pastevents/2796.jpeg",
      caption:
        ".ഇടയ്ക്കോട് വിവേകാനന്ദാ സേവാ സമിതി, ക്രിസ്റ്റ്ൽ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു..ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2796.jpeg",
    },
    {
      src: "assets/img/Pastevents/2797.jpeg",
      caption:
        ".ഇടയ്ക്കോട് വിവേകാനന്ദാ സേവാ സമിതി, ക്രിസ്റ്റ്ൽ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു..ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2797.jpeg",
    },
    {
      src: "assets/img/Pastevents/2798.jpeg",
      caption:
        ".ഇടയ്ക്കോട് വിവേകാനന്ദാ സേവാ സമിതി, ക്രിസ്റ്റ്ൽ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു..ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2798.jpeg",
    },
    {
      src: "assets/img/Pastevents/2799.jpeg",
      caption:
        ".ഇടയ്ക്കോട് വിവേകാനന്ദാ സേവാ സമിതി, ക്രിസ്റ്റ്ൽ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു..ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2799.jpeg",
    },
    {
      src: "assets/img/Pastevents/2800.jpeg",
      caption:
        ".ഇടയ്ക്കോട് വിവേകാനന്ദാ സേവാ സമിതി, ക്രിസ്റ്റ്ൽ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു..ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2800.jpeg",
    },
    {
      src: "assets/img/Pastevents/2801.jpeg",
      caption:
        ".ഇടയ്ക്കോട് വിവേകാനന്ദാ സേവാ സമിതി, ക്രിസ്റ്റ്ൽ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു..ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2801.jpeg",
    },
    {
      src: "assets/img/Pastevents/2802.jpeg",
      caption:
        ".ഇടയ്ക്കോട് വിവേകാനന്ദാ സേവാ സമിതി, ക്രിസ്റ്റ്ൽ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു..ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2802.jpeg",
    },
    {
      src: "assets/img/Pastevents/2803.jpeg",
      caption:
        ".ഇടയ്ക്കോട് വിവേകാനന്ദാ സേവാ സമിതി, ക്രിസ്റ്റ്ൽ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു..ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2803.jpeg",
    },
    {
      src: "assets/img/Pastevents/2789.jpeg",
      caption:
        "കെ.എസ്.ആർ ടി സി സെൻട്രൽ യൂണിറ്റ്(7), ഹെച്ച് എൽ എൽ ലൈഫ് കെയർ യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2789.jpeg",
    },
    {
      src: "assets/img/Pastevents/2790.jpeg",
      caption:
        "കെ.എസ്.ആർ ടി സി സെൻട്രൽ യൂണിറ്റ്(7), ഹെച്ച് എൽ എൽ ലൈഫ് കെയർ യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2790.jpeg",
    },
    {
      src: "assets/img/Pastevents/2791.jpeg",
      caption:
        "കെ.എസ്.ആർ ടി സി സെൻട്രൽ യൂണിറ്റ്(7), ഹെച്ച് എൽ എൽ ലൈഫ് കെയർ യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2791.jpeg",
    },
    {
      src: "assets/img/Pastevents/2792.jpeg",
      caption:
        "കെ.എസ്.ആർ ടി സി സെൻട്രൽ യൂണിറ്റ്(7), ഹെച്ച് എൽ എൽ ലൈഫ് കെയർ യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2792.jpeg",
    },
    {
      src: "assets/img/Pastevents/2793.jpeg",
      caption:
        "കെ.എസ്.ആർ ടി സി സെൻട്രൽ യൂണിറ്റ്(7), ഹെച്ച് എൽ എൽ ലൈഫ് കെയർ യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2793.jpeg",
    },
    {
      src: "assets/img/Pastevents/2794.jpeg",
      caption:
        "കെ.എസ്.ആർ ടി സി സെൻട്രൽ യൂണിറ്റ്(7), ഹെച്ച് എൽ എൽ ലൈഫ് കെയർ യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2794.jpeg",
    },
    {
      src: "assets/img/Pastevents/2795.jpeg",
      caption:
        "കെ.എസ്.ആർ ടി സി സെൻട്രൽ യൂണിറ്റ്(7), ഹെച്ച് എൽ എൽ ലൈഫ് കെയർ യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2795.jpeg",
    },
    {
      src: "assets/img/Pastevents/2783.jpeg",
      caption:
        "കെ.എസ്.ആർ ടി സി സെൻട്രൽ യൂണിറ്റ്(6), ഹെച്ച് എൽ എൽ ലൈഫ് കെയർ യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2783.jpeg",
    },
    {
      src: "assets/img/Pastevents/2784.jpeg",
      caption:
        "കെ.എസ്.ആർ ടി സി സെൻട്രൽ യൂണിറ്റ്(6), ഹെച്ച് എൽ എൽ ലൈഫ് കെയർ യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2784.jpeg",
    },
    {
      src: "assets/img/Pastevents/2785.jpeg",
      caption:
        "കെ.എസ്.ആർ ടി സി സെൻട്രൽ യൂണിറ്റ്(6), ഹെച്ച് എൽ എൽ ലൈഫ് കെയർ യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2785.jpeg",
    },
    {
      src: "assets/img/Pastevents/2786.jpeg",
      caption:
        "കെ.എസ്.ആർ ടി സി സെൻട്രൽ യൂണിറ്റ്(6), ഹെച്ച് എൽ എൽ ലൈഫ് കെയർ യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2786.jpeg",
    },
    {
      src: "assets/img/Pastevents/2787.jpeg",
      caption:
        "കെ.എസ്.ആർ ടി സി സെൻട്രൽ യൂണിറ്റ്(6), ഹെച്ച് എൽ എൽ ലൈഫ് കെയർ യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2787.jpeg",
    },
    {
      src: "assets/img/Pastevents/2788.jpeg",
      caption:
        "കെ.എസ്.ആർ ടി സി സെൻട്രൽ യൂണിറ്റ്(6), ഹെച്ച് എൽ എൽ ലൈഫ് കെയർ യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2788.jpeg",
    },
    {
      src: "assets/img/Pastevents/2777.jpeg",
      caption:
        "കെ.എസ്.ആർ ടി സി സെൻട്രൽ യൂണിറ്റ്(5), ഹെച്ച് എൽ എൽ ലൈഫ് കെയർ യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2777.jpeg",
    },
    {
      src: "assets/img/Pastevents/2778.jpeg",
      caption:
        "കെ.എസ്.ആർ ടി സി സെൻട്രൽ യൂണിറ്റ്(5), ഹെച്ച് എൽ എൽ ലൈഫ് കെയർ യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2778.jpeg",
    },
    {
      src: "assets/img/Pastevents/2779.jpeg",
      caption:
        "കെ.എസ്.ആർ ടി സി സെൻട്രൽ യൂണിറ്റ്(5), ഹെച്ച് എൽ എൽ ലൈഫ് കെയർ യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2779.jpeg",
    },
    {
      src: "assets/img/Pastevents/2780.jpeg",
      caption:
        "കെ.എസ്.ആർ ടി സി സെൻട്രൽ യൂണിറ്റ്(5), ഹെച്ച് എൽ എൽ ലൈഫ് കെയർ യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2780.jpeg",
    },
    {
      src: "assets/img/Pastevents/2781.jpeg",
      caption:
        "കെ.എസ്.ആർ ടി സി സെൻട്രൽ യൂണിറ്റ്(5), ഹെച്ച് എൽ എൽ ലൈഫ് കെയർ യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2781.jpeg",
    },
    {
      src: "assets/img/Pastevents/2782.jpeg",
      caption:
        "കെ.എസ്.ആർ ടി സി സെൻട്രൽ യൂണിറ്റ്(5), ഹെച്ച് എൽ എൽ ലൈഫ് കെയർ യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2782.jpeg",
    },
    {
      src: "assets/img/Pastevents/2770.jpeg",
      caption:
        "മണലുവിള സി എസ് ഐ ചർച്ചിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2770.jpeg",
    },
    {
      src: "assets/img/Pastevents/2771.jpeg",
      caption:
        "മണലുവിള സി എസ് ഐ ചർച്ചിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2771.jpeg",
    },
    {
      src: "assets/img/Pastevents/2772.jpeg",
      caption:
        "മണലുവിള സി എസ് ഐ ചർച്ചിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2772.jpeg",
    },
    {
      src: "assets/img/Pastevents/2773.jpeg",
      caption:
        "മണലുവിള സി എസ് ഐ ചർച്ചിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2773.jpeg",
    },
    {
      src: "assets/img/Pastevents/2774.jpeg",
      caption:
        "മണലുവിള സി എസ് ഐ ചർച്ചിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2774.jpeg",
    },
    {
      src: "assets/img/Pastevents/2775.jpeg",
      caption:
        "മണലുവിള സി എസ് ഐ ചർച്ചിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2775.jpeg",
    },
    {
      src: "assets/img/Pastevents/2775.jpeg",
      caption:
        "മണലുവിള സി എസ് ഐ ചർച്ചിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2775.jpeg",
    },
    {
      src: "assets/img/Pastevents/2776.jpeg",
      caption:
        "മണലുവിള സി എസ് ഐ ചർച്ചിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2776.jpeg",
    },
    {
      src: "assets/img/Pastevents/2763.jpeg",
      caption:
        "ദേശീയ ്് ഡോക്ടഴ്സ ഡേ  വിഴിഞ്ഞം ലയൺസ് ക്ലബ്ബിന്റെയും ആഴിമല ശിവക്ഷേത്ര ദേവസ്വം ട്രസ്റ്റിന്റെയും വിഴിഞ്ഞം ജനമൈത്രി പോലീസിന്റെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ നെയ്യാറ്റിൻകര നിംസ് മെഡിസിറ്റി എന്നിവരുടെ സഹകരണത്തോടെ ആഴിമല ശിവക്ഷേത്ര ഓഡിറ്റോറിയത്തിൽ മെഗാ മെഡിക്കൽ ക്യാമ്പും, ഡയബെറ്റിസ് ഡീറ്റെക്ഷൻ ക്യാമ്പും, നേത്ര പരിശോധനയും തിമിര ശാസ്ത്രക്രിയ ക്യാമ്പും ആയുർവേദ ക്യാമ്പും സംഘടിപ്പിച്ചു. ലയൺസ് ഇന്റർനാഷണൽ ഡിസ്ട്രിക്ട് തലത്തിലുള്ള മെഡിക്കൽ ക്യാമ്പുകൾ ഡിസ്ട്രിക്ട് ഗവർണർ ലയൺ അജയ്യ കുമാർ ഉൽഘാടനം ചെയ്തു . Ist VDG ലയൺ എം എ വഹാബ് മുഖ്യ പ്രഭാഷണം നടത്തി. ആഴിമല ക്ഷേത്രം പ്രസിഡന്റ്‌ വി രാധ കൃഷ്ണൻ അധ്യക്ഷൻ ആയ യോഗത്തിൽ വിഴിഞ്ഞം ലയൺസ് ക്ലബ് പ്രസിഡന്റ്‌ രതീഷ് സ്വാഗതവും ദേവസ്വം ജനറൽ സെക്രട്ടറി വിജേഷ് നന്ദിയും പറഞ്ഞു. ഡോക്ടർ ഡേ ദിനത്തോടനുബന്ധിച് DR. ഷാജി കുട്ടി,  DR. പ്രജിത്,  DR. നിരഞ്ജന ആനന്ദ്,  DR. പ്രിയേന്തു, ഡോക്ടർ പാർവതി എന്നിവരെ ആദരിച്ചു. ഡിസ്ട്രിക്ട് ക്യാബിനറ്റ് സെക്രട്ടറി വി എം പ്രദീപ്‌, പ്രൊജക്റ്റ്‌ ചീഫ് മധു ഡയബെറ്റിസ് ഡിസ്ട്രിക്ട് ചെയർ പേഴ്സൺ അനിൽ കുമാർ, ഡോക്ടർ ജയലക്ഷ്മി അജയകുമാർ, സുരേഷ്,ഡിസ്ട്രിക്ട് ചെയർ പേഴ്സൺസ് ആയ വിനോദ് കുമാർ, നന്ദകുമാർ, അഭിലാഷ്, വിഴിഞ്ഞം ലയൺസ് ക്ലബ് സെക്രട്ടറി അഡ്വക്കേറ്റ് രാജീവ്, അരുൺ പി എസ്, ആഴിമല ദേവസ്വം സെക്രട്ടറി ഷിബുകുമാർ കമ്മിറ്റി അംഗം കിഷോർ എന്നിവർ സംസാരിച്ചു.",
      thumb: "assets/img/Pastevents/2763.jpeg",
    },
    {
      src: "assets/img/Pastevents/2764.jpeg",
      caption:
        "ദേശീയ ്് ഡോക്ടഴ്സ ഡേ  വിഴിഞ്ഞം ലയൺസ് ക്ലബ്ബിന്റെയും ആഴിമല ശിവക്ഷേത്ര ദേവസ്വം ട്രസ്റ്റിന്റെയും വിഴിഞ്ഞം ജനമൈത്രി പോലീസിന്റെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ നെയ്യാറ്റിൻകര നിംസ് മെഡിസിറ്റി എന്നിവരുടെ സഹകരണത്തോടെ ആഴിമല ശിവക്ഷേത്ര ഓഡിറ്റോറിയത്തിൽ മെഗാ മെഡിക്കൽ ക്യാമ്പും, ഡയബെറ്റിസ് ഡീറ്റെക്ഷൻ ക്യാമ്പും, നേത്ര പരിശോധനയും തിമിര ശാസ്ത്രക്രിയ ക്യാമ്പും ആയുർവേദ ക്യാമ്പും സംഘടിപ്പിച്ചു. ലയൺസ് ഇന്റർനാഷണൽ ഡിസ്ട്രിക്ട് തലത്തിലുള്ള മെഡിക്കൽ ക്യാമ്പുകൾ ഡിസ്ട്രിക്ട് ഗവർണർ ലയൺ അജയ്യ കുമാർ ഉൽഘാടനം ചെയ്തു . Ist VDG ലയൺ എം എ വഹാബ് മുഖ്യ പ്രഭാഷണം നടത്തി. ആഴിമല ക്ഷേത്രം പ്രസിഡന്റ്‌ വി രാധ കൃഷ്ണൻ അധ്യക്ഷൻ ആയ യോഗത്തിൽ വിഴിഞ്ഞം ലയൺസ് ക്ലബ് പ്രസിഡന്റ്‌ രതീഷ് സ്വാഗതവും ദേവസ്വം ജനറൽ സെക്രട്ടറി വിജേഷ് നന്ദിയും പറഞ്ഞു. ഡോക്ടർ ഡേ ദിനത്തോടനുബന്ധിച് DR. ഷാജി കുട്ടി,  DR. പ്രജിത്,  DR. നിരഞ്ജന ആനന്ദ്,  DR. പ്രിയേന്തു, ഡോക്ടർ പാർവതി എന്നിവരെ ആദരിച്ചു. ഡിസ്ട്രിക്ട് ക്യാബിനറ്റ് സെക്രട്ടറി വി എം പ്രദീപ്‌, പ്രൊജക്റ്റ്‌ ചീഫ് മധു ഡയബെറ്റിസ് ഡിസ്ട്രിക്ട് ചെയർ പേഴ്സൺ അനിൽ കുമാർ, ഡോക്ടർ ജയലക്ഷ്മി അജയകുമാർ, സുരേഷ്,ഡിസ്ട്രിക്ട് ചെയർ പേഴ്സൺസ് ആയ വിനോദ് കുമാർ, നന്ദകുമാർ, അഭിലാഷ്, വിഴിഞ്ഞം ലയൺസ് ക്ലബ് സെക്രട്ടറി അഡ്വക്കേറ്റ് രാജീവ്, അരുൺ പി എസ്, ആഴിമല ദേവസ്വം സെക്രട്ടറി ഷിബുകുമാർ കമ്മിറ്റി അംഗം കിഷോർ എന്നിവർ സംസാരിച്ചു.",
      thumb: "assets/img/Pastevents/2764.jpeg",
    },
    {
      src: "assets/img/Pastevents/2765.jpeg",
      caption:
        "ദേശീയ ്് ഡോക്ടഴ്സ ഡേ  വിഴിഞ്ഞം ലയൺസ് ക്ലബ്ബിന്റെയും ആഴിമല ശിവക്ഷേത്ര ദേവസ്വം ട്രസ്റ്റിന്റെയും വിഴിഞ്ഞം ജനമൈത്രി പോലീസിന്റെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ നെയ്യാറ്റിൻകര നിംസ് മെഡിസിറ്റി എന്നിവരുടെ സഹകരണത്തോടെ ആഴിമല ശിവക്ഷേത്ര ഓഡിറ്റോറിയത്തിൽ മെഗാ മെഡിക്കൽ ക്യാമ്പും, ഡയബെറ്റിസ് ഡീറ്റെക്ഷൻ ക്യാമ്പും, നേത്ര പരിശോധനയും തിമിര ശാസ്ത്രക്രിയ ക്യാമ്പും ആയുർവേദ ക്യാമ്പും സംഘടിപ്പിച്ചു. ലയൺസ് ഇന്റർനാഷണൽ ഡിസ്ട്രിക്ട് തലത്തിലുള്ള മെഡിക്കൽ ക്യാമ്പുകൾ ഡിസ്ട്രിക്ട് ഗവർണർ ലയൺ അജയ്യ കുമാർ ഉൽഘാടനം ചെയ്തു . Ist VDG ലയൺ എം എ വഹാബ് മുഖ്യ പ്രഭാഷണം നടത്തി. ആഴിമല ക്ഷേത്രം പ്രസിഡന്റ്‌ വി രാധ കൃഷ്ണൻ അധ്യക്ഷൻ ആയ യോഗത്തിൽ വിഴിഞ്ഞം ലയൺസ് ക്ലബ് പ്രസിഡന്റ്‌ രതീഷ് സ്വാഗതവും ദേവസ്വം ജനറൽ സെക്രട്ടറി വിജേഷ് നന്ദിയും പറഞ്ഞു. ഡോക്ടർ ഡേ ദിനത്തോടനുബന്ധിച് DR. ഷാജി കുട്ടി,  DR. പ്രജിത്,  DR. നിരഞ്ജന ആനന്ദ്,  DR. പ്രിയേന്തു, ഡോക്ടർ പാർവതി എന്നിവരെ ആദരിച്ചു. ഡിസ്ട്രിക്ട് ക്യാബിനറ്റ് സെക്രട്ടറി വി എം പ്രദീപ്‌, പ്രൊജക്റ്റ്‌ ചീഫ് മധു ഡയബെറ്റിസ് ഡിസ്ട്രിക്ട് ചെയർ പേഴ്സൺ അനിൽ കുമാർ, ഡോക്ടർ ജയലക്ഷ്മി അജയകുമാർ, സുരേഷ്,ഡിസ്ട്രിക്ട് ചെയർ പേഴ്സൺസ് ആയ വിനോദ് കുമാർ, നന്ദകുമാർ, അഭിലാഷ്, വിഴിഞ്ഞം ലയൺസ് ക്ലബ് സെക്രട്ടറി അഡ്വക്കേറ്റ് രാജീവ്, അരുൺ പി എസ്, ആഴിമല ദേവസ്വം സെക്രട്ടറി ഷിബുകുമാർ കമ്മിറ്റി അംഗം കിഷോർ എന്നിവർ സംസാരിച്ചു.",
      thumb: "assets/img/Pastevents/2765.jpeg",
    },
    {
      src: "assets/img/Pastevents/2766.jpeg",
      caption:
        "ദേശീയ ്് ഡോക്ടഴ്സ ഡേ  വിഴിഞ്ഞം ലയൺസ് ക്ലബ്ബിന്റെയും ആഴിമല ശിവക്ഷേത്ര ദേവസ്വം ട്രസ്റ്റിന്റെയും വിഴിഞ്ഞം ജനമൈത്രി പോലീസിന്റെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ നെയ്യാറ്റിൻകര നിംസ് മെഡിസിറ്റി എന്നിവരുടെ സഹകരണത്തോടെ ആഴിമല ശിവക്ഷേത്ര ഓഡിറ്റോറിയത്തിൽ മെഗാ മെഡിക്കൽ ക്യാമ്പും, ഡയബെറ്റിസ് ഡീറ്റെക്ഷൻ ക്യാമ്പും, നേത്ര പരിശോധനയും തിമിര ശാസ്ത്രക്രിയ ക്യാമ്പും ആയുർവേദ ക്യാമ്പും സംഘടിപ്പിച്ചു. ലയൺസ് ഇന്റർനാഷണൽ ഡിസ്ട്രിക്ട് തലത്തിലുള്ള മെഡിക്കൽ ക്യാമ്പുകൾ ഡിസ്ട്രിക്ട് ഗവർണർ ലയൺ അജയ്യ കുമാർ ഉൽഘാടനം ചെയ്തു . Ist VDG ലയൺ എം എ വഹാബ് മുഖ്യ പ്രഭാഷണം നടത്തി. ആഴിമല ക്ഷേത്രം പ്രസിഡന്റ്‌ വി രാധ കൃഷ്ണൻ അധ്യക്ഷൻ ആയ യോഗത്തിൽ വിഴിഞ്ഞം ലയൺസ് ക്ലബ് പ്രസിഡന്റ്‌ രതീഷ് സ്വാഗതവും ദേവസ്വം ജനറൽ സെക്രട്ടറി വിജേഷ് നന്ദിയും പറഞ്ഞു. ഡോക്ടർ ഡേ ദിനത്തോടനുബന്ധിച് DR. ഷാജി കുട്ടി,  DR. പ്രജിത്,  DR. നിരഞ്ജന ആനന്ദ്,  DR. പ്രിയേന്തു, ഡോക്ടർ പാർവതി എന്നിവരെ ആദരിച്ചു. ഡിസ്ട്രിക്ട് ക്യാബിനറ്റ് സെക്രട്ടറി വി എം പ്രദീപ്‌, പ്രൊജക്റ്റ്‌ ചീഫ് മധു ഡയബെറ്റിസ് ഡിസ്ട്രിക്ട് ചെയർ പേഴ്സൺ അനിൽ കുമാർ, ഡോക്ടർ ജയലക്ഷ്മി അജയകുമാർ, സുരേഷ്,ഡിസ്ട്രിക്ട് ചെയർ പേഴ്സൺസ് ആയ വിനോദ് കുമാർ, നന്ദകുമാർ, അഭിലാഷ്, വിഴിഞ്ഞം ലയൺസ് ക്ലബ് സെക്രട്ടറി അഡ്വക്കേറ്റ് രാജീവ്, അരുൺ പി എസ്, ആഴിമല ദേവസ്വം സെക്രട്ടറി ഷിബുകുമാർ കമ്മിറ്റി അംഗം കിഷോർ എന്നിവർ സംസാരിച്ചു.",
      thumb: "assets/img/Pastevents/2766.jpeg",
    },
    {
      src: "assets/img/Pastevents/2767.jpeg",
      caption:
        "ദേശീയ ്് ഡോക്ടഴ്സ ഡേ  വിഴിഞ്ഞം ലയൺസ് ക്ലബ്ബിന്റെയും ആഴിമല ശിവക്ഷേത്ര ദേവസ്വം ട്രസ്റ്റിന്റെയും വിഴിഞ്ഞം ജനമൈത്രി പോലീസിന്റെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ നെയ്യാറ്റിൻകര നിംസ് മെഡിസിറ്റി എന്നിവരുടെ സഹകരണത്തോടെ ആഴിമല ശിവക്ഷേത്ര ഓഡിറ്റോറിയത്തിൽ മെഗാ മെഡിക്കൽ ക്യാമ്പും, ഡയബെറ്റിസ് ഡീറ്റെക്ഷൻ ക്യാമ്പും, നേത്ര പരിശോധനയും തിമിര ശാസ്ത്രക്രിയ ക്യാമ്പും ആയുർവേദ ക്യാമ്പും സംഘടിപ്പിച്ചു. ലയൺസ് ഇന്റർനാഷണൽ ഡിസ്ട്രിക്ട് തലത്തിലുള്ള മെഡിക്കൽ ക്യാമ്പുകൾ ഡിസ്ട്രിക്ട് ഗവർണർ ലയൺ അജയ്യ കുമാർ ഉൽഘാടനം ചെയ്തു . Ist VDG ലയൺ എം എ വഹാബ് മുഖ്യ പ്രഭാഷണം നടത്തി. ആഴിമല ക്ഷേത്രം പ്രസിഡന്റ്‌ വി രാധ കൃഷ്ണൻ അധ്യക്ഷൻ ആയ യോഗത്തിൽ വിഴിഞ്ഞം ലയൺസ് ക്ലബ് പ്രസിഡന്റ്‌ രതീഷ് സ്വാഗതവും ദേവസ്വം ജനറൽ സെക്രട്ടറി വിജേഷ് നന്ദിയും പറഞ്ഞു. ഡോക്ടർ ഡേ ദിനത്തോടനുബന്ധിച് DR. ഷാജി കുട്ടി,  DR. പ്രജിത്,  DR. നിരഞ്ജന ആനന്ദ്,  DR. പ്രിയേന്തു, ഡോക്ടർ പാർവതി എന്നിവരെ ആദരിച്ചു. ഡിസ്ട്രിക്ട് ക്യാബിനറ്റ് സെക്രട്ടറി വി എം പ്രദീപ്‌, പ്രൊജക്റ്റ്‌ ചീഫ് മധു ഡയബെറ്റിസ് ഡിസ്ട്രിക്ട് ചെയർ പേഴ്സൺ അനിൽ കുമാർ, ഡോക്ടർ ജയലക്ഷ്മി അജയകുമാർ, സുരേഷ്,ഡിസ്ട്രിക്ട് ചെയർ പേഴ്സൺസ് ആയ വിനോദ് കുമാർ, നന്ദകുമാർ, അഭിലാഷ്, വിഴിഞ്ഞം ലയൺസ് ക്ലബ് സെക്രട്ടറി അഡ്വക്കേറ്റ് രാജീവ്, അരുൺ പി എസ്, ആഴിമല ദേവസ്വം സെക്രട്ടറി ഷിബുകുമാർ കമ്മിറ്റി അംഗം കിഷോർ എന്നിവർ സംസാരിച്ചു.",
      thumb: "assets/img/Pastevents/2767.jpeg",
    },
    {
      src: "assets/img/Pastevents/2768.jpeg",
      caption:
        "ദേശീയ ്് ഡോക്ടഴ്സ ഡേ  വിഴിഞ്ഞം ലയൺസ് ക്ലബ്ബിന്റെയും ആഴിമല ശിവക്ഷേത്ര ദേവസ്വം ട്രസ്റ്റിന്റെയും വിഴിഞ്ഞം ജനമൈത്രി പോലീസിന്റെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ നെയ്യാറ്റിൻകര നിംസ് മെഡിസിറ്റി എന്നിവരുടെ സഹകരണത്തോടെ ആഴിമല ശിവക്ഷേത്ര ഓഡിറ്റോറിയത്തിൽ മെഗാ മെഡിക്കൽ ക്യാമ്പും, ഡയബെറ്റിസ് ഡീറ്റെക്ഷൻ ക്യാമ്പും, നേത്ര പരിശോധനയും തിമിര ശാസ്ത്രക്രിയ ക്യാമ്പും ആയുർവേദ ക്യാമ്പും സംഘടിപ്പിച്ചു. ലയൺസ് ഇന്റർനാഷണൽ ഡിസ്ട്രിക്ട് തലത്തിലുള്ള മെഡിക്കൽ ക്യാമ്പുകൾ ഡിസ്ട്രിക്ട് ഗവർണർ ലയൺ അജയ്യ കുമാർ ഉൽഘാടനം ചെയ്തു . Ist VDG ലയൺ എം എ വഹാബ് മുഖ്യ പ്രഭാഷണം നടത്തി. ആഴിമല ക്ഷേത്രം പ്രസിഡന്റ്‌ വി രാധ കൃഷ്ണൻ അധ്യക്ഷൻ ആയ യോഗത്തിൽ വിഴിഞ്ഞം ലയൺസ് ക്ലബ് പ്രസിഡന്റ്‌ രതീഷ് സ്വാഗതവും ദേവസ്വം ജനറൽ സെക്രട്ടറി വിജേഷ് നന്ദിയും പറഞ്ഞു. ഡോക്ടർ ഡേ ദിനത്തോടനുബന്ധിച് DR. ഷാജി കുട്ടി,  DR. പ്രജിത്,  DR. നിരഞ്ജന ആനന്ദ്,  DR. പ്രിയേന്തു, ഡോക്ടർ പാർവതി എന്നിവരെ ആദരിച്ചു. ഡിസ്ട്രിക്ട് ക്യാബിനറ്റ് സെക്രട്ടറി വി എം പ്രദീപ്‌, പ്രൊജക്റ്റ്‌ ചീഫ് മധു ഡയബെറ്റിസ് ഡിസ്ട്രിക്ട് ചെയർ പേഴ്സൺ അനിൽ കുമാർ, ഡോക്ടർ ജയലക്ഷ്മി അജയകുമാർ, സുരേഷ്,ഡിസ്ട്രിക്ട് ചെയർ പേഴ്സൺസ് ആയ വിനോദ് കുമാർ, നന്ദകുമാർ, അഭിലാഷ്, വിഴിഞ്ഞം ലയൺസ് ക്ലബ് സെക്രട്ടറി അഡ്വക്കേറ്റ് രാജീവ്, അരുൺ പി എസ്, ആഴിമല ദേവസ്വം സെക്രട്ടറി ഷിബുകുമാർ കമ്മിറ്റി അംഗം കിഷോർ എന്നിവർ സംസാരിച്ചു.",
      thumb: "assets/img/Pastevents/2768.jpeg",
    },
    {
      src: "assets/img/Pastevents/2769.jpeg",
      caption:
        "ദേശീയ ്് ഡോക്ടഴ്സ ഡേ  വിഴിഞ്ഞം ലയൺസ് ക്ലബ്ബിന്റെയും ആഴിമല ശിവക്ഷേത്ര ദേവസ്വം ട്രസ്റ്റിന്റെയും വിഴിഞ്ഞം ജനമൈത്രി പോലീസിന്റെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ നെയ്യാറ്റിൻകര നിംസ് മെഡിസിറ്റി എന്നിവരുടെ സഹകരണത്തോടെ ആഴിമല ശിവക്ഷേത്ര ഓഡിറ്റോറിയത്തിൽ മെഗാ മെഡിക്കൽ ക്യാമ്പും, ഡയബെറ്റിസ് ഡീറ്റെക്ഷൻ ക്യാമ്പും, നേത്ര പരിശോധനയും തിമിര ശാസ്ത്രക്രിയ ക്യാമ്പും ആയുർവേദ ക്യാമ്പും സംഘടിപ്പിച്ചു. ലയൺസ് ഇന്റർനാഷണൽ ഡിസ്ട്രിക്ട് തലത്തിലുള്ള മെഡിക്കൽ ക്യാമ്പുകൾ ഡിസ്ട്രിക്ട് ഗവർണർ ലയൺ അജയ്യ കുമാർ ഉൽഘാടനം ചെയ്തു . Ist VDG ലയൺ എം എ വഹാബ് മുഖ്യ പ്രഭാഷണം നടത്തി. ആഴിമല ക്ഷേത്രം പ്രസിഡന്റ്‌ വി രാധ കൃഷ്ണൻ അധ്യക്ഷൻ ആയ യോഗത്തിൽ വിഴിഞ്ഞം ലയൺസ് ക്ലബ് പ്രസിഡന്റ്‌ രതീഷ് സ്വാഗതവും ദേവസ്വം ജനറൽ സെക്രട്ടറി വിജേഷ് നന്ദിയും പറഞ്ഞു. ഡോക്ടർ ഡേ ദിനത്തോടനുബന്ധിച് DR. ഷാജി കുട്ടി,  DR. പ്രജിത്,  DR. നിരഞ്ജന ആനന്ദ്,  DR. പ്രിയേന്തു, ഡോക്ടർ പാർവതി എന്നിവരെ ആദരിച്ചു. ഡിസ്ട്രിക്ട് ക്യാബിനറ്റ് സെക്രട്ടറി വി എം പ്രദീപ്‌, പ്രൊജക്റ്റ്‌ ചീഫ് മധു ഡയബെറ്റിസ് ഡിസ്ട്രിക്ട് ചെയർ പേഴ്സൺ അനിൽ കുമാർ, ഡോക്ടർ ജയലക്ഷ്മി അജയകുമാർ, സുരേഷ്,ഡിസ്ട്രിക്ട് ചെയർ പേഴ്സൺസ് ആയ വിനോദ് കുമാർ, നന്ദകുമാർ, അഭിലാഷ്, വിഴിഞ്ഞം ലയൺസ് ക്ലബ് സെക്രട്ടറി അഡ്വക്കേറ്റ് രാജീവ്, അരുൺ പി എസ്, ആഴിമല ദേവസ്വം സെക്രട്ടറി ഷിബുകുമാർ കമ്മിറ്റി അംഗം കിഷോർ എന്നിവർ സംസാരിച്ചു.",
      thumb: "assets/img/Pastevents/2769.jpeg",
    },
    {
      src: "assets/img/Pastevents/2755.jpeg",
      caption:
        "പേയാട് ശ്രീ ഭജന മഠം റെസിഡൻഷ്യൽ അസോസിയേഷന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2755.jpeg",
    },
    {
      src: "assets/img/Pastevents/2756.jpeg",
      caption:
        "പേയാട് ശ്രീ ഭജന മഠം റെസിഡൻഷ്യൽ അസോസിയേഷന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2756.jpeg",
    },
    {
      src: "assets/img/Pastevents/2757.jpeg",
      caption:
        "പേയാട് ശ്രീ ഭജന മഠം റെസിഡൻഷ്യൽ അസോസിയേഷന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2757.jpeg",
    },
    {
      src: "assets/img/Pastevents/2758.jpeg",
      caption:
        "പേയാട് ശ്രീ ഭജന മഠം റെസിഡൻഷ്യൽ അസോസിയേഷന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2758.jpeg",
    },
    {
      src: "assets/img/Pastevents/2759.jpeg",
      caption:
        "പേയാട് ശ്രീ ഭജന മഠം റെസിഡൻഷ്യൽ അസോസിയേഷന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2759.jpeg",
    },
    {
      src: "assets/img/Pastevents/2760.jpeg",
      caption:
        "പേയാട് ശ്രീ ഭജന മഠം റെസിഡൻഷ്യൽ അസോസിയേഷന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2760.jpeg",
    },
    {
      src: "assets/img/Pastevents/2761.jpeg",
      caption:
        "പേയാട് ശ്രീ ഭജന മഠം റെസിഡൻഷ്യൽ അസോസിയേഷന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2761.jpeg",
    },
    {
      src: "assets/img/Pastevents/2762.jpeg",
      caption:
        "പേയാട് ശ്രീ ഭജന മഠം റെസിഡൻഷ്യൽ അസോസിയേഷന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2762.jpeg",
    },
    {
      src: "assets/img/Pastevents/2748.jpeg",
      caption:
        "വിതുര ജനമൈത്രി പോലീസിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2748.jpeg",
    },
    {
      src: "assets/img/Pastevents/2749.jpeg",
      caption:
        "വിതുര ജനമൈത്രി പോലീസിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2749.jpeg",
    },
    {
      src: "assets/img/Pastevents/2750.jpeg",
      caption:
        "വിതുര ജനമൈത്രി പോലീസിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2750.jpeg",
    },
    {
      src: "assets/img/Pastevents/2751.jpeg",
      caption:
        "വിതുര ജനമൈത്രി പോലീസിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2751.jpeg",
    },
    {
      src: "assets/img/Pastevents/2752.jpeg",
      caption:
        "വിതുര ജനമൈത്രി പോലീസിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2752.jpeg",
    },
    {
      src: "assets/img/Pastevents/2753.jpeg",
      caption:
        "വിതുര ജനമൈത്രി പോലീസിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2753.jpeg",
    },
    {
      src: "assets/img/Pastevents/2754.jpeg",
      caption:
        "വിതുര ജനമൈത്രി പോലീസിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2754.jpeg",
    },
    {
      src: "assets/img/Pastevents/2742.jpeg",
      caption:
        "കെ.എസ്.ആർ ടി സി സെൻട്രൽ യൂണിറ്റ്(4), ഹെച്ച് എൽ എൽ ലൈഫ് കെയർ യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2742.jpeg",
    },
    {
      src: "assets/img/Pastevents/2743.jpeg",
      caption:
        "കെ.എസ്.ആർ ടി സി സെൻട്രൽ യൂണിറ്റ്(4), ഹെച്ച് എൽ എൽ ലൈഫ് കെയർ യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2743.jpeg",
    },
    {
      src: "assets/img/Pastevents/2744.jpeg",
      caption:
        "കെ.എസ്.ആർ ടി സി സെൻട്രൽ യൂണിറ്റ്(4), ഹെച്ച് എൽ എൽ ലൈഫ് കെയർ യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2744.jpeg",
    },
    {
      src: "assets/img/Pastevents/2745.jpeg",
      caption:
        "കെ.എസ്.ആർ ടി സി സെൻട്രൽ യൂണിറ്റ്(4), ഹെച്ച് എൽ എൽ ലൈഫ് കെയർ യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2745.jpeg",
    },
    {
      src: "assets/img/Pastevents/2746.jpeg",
      caption:
        "കെ.എസ്.ആർ ടി സി സെൻട്രൽ യൂണിറ്റ്(4), ഹെച്ച് എൽ എൽ ലൈഫ് കെയർ യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2746.jpeg",
    },
    {
      src: "assets/img/Pastevents/2747.jpeg",
      caption:
        "കെ.എസ്.ആർ ടി സി സെൻട്രൽ യൂണിറ്റ്(4), ഹെച്ച് എൽ എൽ ലൈഫ് കെയർ യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2747.jpeg",
    },
    {
      src: "assets/img/Pastevents/2733.jpeg",
      caption:
        "കോട്ടുകാൽ ഗ്രാമ പഞ്ചായത്ത്, നിംസ് നാനോ ക്ലിനിക്കിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2733.jpeg",
    },
    {
      src: "assets/img/Pastevents/2734.jpeg",
      caption:
        "കോട്ടുകാൽ ഗ്രാമ പഞ്ചായത്ത്, നിംസ് നാനോ ക്ലിനിക്കിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2734.jpeg",
    },
    {
      src: "assets/img/Pastevents/2735.jpeg",
      caption:
        "കോട്ടുകാൽ ഗ്രാമ പഞ്ചായത്ത്, നിംസ് നാനോ ക്ലിനിക്കിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2735.jpeg",
    },
    {
      src: "assets/img/Pastevents/2736.jpeg",
      caption:
        "കോട്ടുകാൽ ഗ്രാമ പഞ്ചായത്ത്, നിംസ് നാനോ ക്ലിനിക്കിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2736.jpeg",
    },
    {
      src: "assets/img/Pastevents/2737.jpeg",
      caption:
        "കോട്ടുകാൽ ഗ്രാമ പഞ്ചായത്ത്, നിംസ് നാനോ ക്ലിനിക്കിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2737.jpeg",
    },
    {
      src: "assets/img/Pastevents/2738.jpeg",
      caption:
        "കോട്ടുകാൽ ഗ്രാമ പഞ്ചായത്ത്, നിംസ് നാനോ ക്ലിനിക്കിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2738.jpeg",
    },
    {
      src: "assets/img/Pastevents/2739.jpeg",
      caption:
        "കോട്ടുകാൽ ഗ്രാമ പഞ്ചായത്ത്, നിംസ് നാനോ ക്ലിനിക്കിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2739.jpeg",
    },
    {
      src: "assets/img/Pastevents/2740.jpeg",
      caption:
        "കോട്ടുകാൽ ഗ്രാമ പഞ്ചായത്ത്, നിംസ് നാനോ ക്ലിനിക്കിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2740.jpeg",
    },
    {
      src: "assets/img/Pastevents/2741.jpeg",
      caption:
        "കോട്ടുകാൽ ഗ്രാമ പഞ്ചായത്ത്, നിംസ് നാനോ ക്ലിനിക്കിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2741.jpeg",
    },
    {
      src: "assets/img/Pastevents/2727.jpeg",
      caption:
        "കെ.എസ്.ആർ ടി സി സെൻട്രൽ യൂണിറ്റ്(3), ഹെച്ച് എൽ എൽ ലൈഫ് കെയർ യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2727.jpeg",
    },
    {
      src: "assets/img/Pastevents/2728.jpeg",
      caption:
        "കെ.എസ്.ആർ ടി സി സെൻട്രൽ യൂണിറ്റ്(3), ഹെച്ച് എൽ എൽ ലൈഫ് കെയർ യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2728.jpeg",
    },
    {
      src: "assets/img/Pastevents/2729.jpeg",
      caption:
        "കെ.എസ്.ആർ ടി സി സെൻട്രൽ യൂണിറ്റ്(3), ഹെച്ച് എൽ എൽ ലൈഫ് കെയർ യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2729.jpeg",
    },
    {
      src: "assets/img/Pastevents/2730.jpeg",
      caption:
        "കെ.എസ്.ആർ ടി സി സെൻട്രൽ യൂണിറ്റ്(3), ഹെച്ച് എൽ എൽ ലൈഫ് കെയർ യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2730.jpeg",
    },
    {
      src: "assets/img/Pastevents/2731.jpeg",
      caption:
        "കെ.എസ്.ആർ ടി സി സെൻട്രൽ യൂണിറ്റ്(3), ഹെച്ച് എൽ എൽ ലൈഫ് കെയർ യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2731.jpeg",
    },
    {
      src: "assets/img/Pastevents/2732.jpeg",
      caption:
        "കെ.എസ്.ആർ ടി സി സെൻട്രൽ യൂണിറ്റ്(3), ഹെച്ച് എൽ എൽ ലൈഫ് കെയർ യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2732.jpeg",
    },
    {
      src: "assets/img/Pastevents/2720.jpeg",
      caption:
        "കരകുളം ഭരത്ത് ഗാർഡൻസ് ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2720.jpeg",
    },
    {
      src: "assets/img/Pastevents/2721.jpeg",
      caption:
        "കരകുളം ഭരത്ത് ഗാർഡൻസ് ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2721.jpeg",
    },
    {
      src: "assets/img/Pastevents/2722.jpeg",
      caption:
        "കരകുളം ഭരത്ത് ഗാർഡൻസ് ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2722.jpeg",
    },
    {
      src: "assets/img/Pastevents/2723.jpeg",
      caption:
        "കരകുളം ഭരത്ത് ഗാർഡൻസ് ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2723.jpeg",
    },
    {
      src: "assets/img/Pastevents/2724.jpeg",
      caption:
        "കരകുളം ഭരത്ത് ഗാർഡൻസ് ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2724.jpeg",
    },
    {
      src: "assets/img/Pastevents/2725.jpeg",
      caption:
        "കരകുളം ഭരത്ത് ഗാർഡൻസ് ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2725.jpeg",
    },
    {
      src: "assets/img/Pastevents/2726.jpeg",
      caption:
        "കരകുളം ഭരത്ത് ഗാർഡൻസ് ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2726.jpeg",
    },
    {
      src: "assets/img/Pastevents/2713.jpeg",
      caption:
        "ഊരുട്ടുക്കാല ജി അർ ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു .ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2713.jpeg",
    },
    {
      src: "assets/img/Pastevents/2714.jpeg",
      caption:
        "ഊരുട്ടുക്കാല ജി അർ ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു .ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2714.jpeg",
    },
    {
      src: "assets/img/Pastevents/2715.jpeg",
      caption:
        "ഊരുട്ടുക്കാല ജി അർ ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു .ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2715.jpeg",
    },
    {
      src: "assets/img/Pastevents/2716.jpeg",
      caption:
        "ഊരുട്ടുക്കാല ജി അർ ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു .ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2716.jpeg",
    },
    {
      src: "assets/img/Pastevents/2717.jpeg",
      caption:
        "ഊരുട്ടുക്കാല ജി അർ ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു .ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2717.jpeg",
    },
    {
      src: "assets/img/Pastevents/2718.jpeg",
      caption:
        "ഊരുട്ടുക്കാല ജി അർ ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു .ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2718.jpeg",
    },
    {
      src: "assets/img/Pastevents/2719.jpeg",
      caption:
        "ഊരുട്ടുക്കാല ജി അർ ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു .ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2719.jpeg",
    },
    {
      src: "assets/img/Pastevents/2704.jpeg",
      caption:
        "സക്ഷമ കേരളം, തിരുപുറം ഗ്രാമ പഞ്ചായത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2704.jpeg",
    },
    {
      src: "assets/img/Pastevents/2705.jpeg",
      caption:
        "സക്ഷമ കേരളം, തിരുപുറം ഗ്രാമ പഞ്ചായത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2705.jpeg",
    },
    {
      src: "assets/img/Pastevents/2706.jpeg",
      caption:
        "സക്ഷമ കേരളം, തിരുപുറം ഗ്രാമ പഞ്ചായത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2706.jpeg",
    },
    {
      src: "assets/img/Pastevents/2707.jpeg",
      caption:
        "സക്ഷമ കേരളം, തിരുപുറം ഗ്രാമ പഞ്ചായത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2707.jpeg",
    },
    {
      src: "assets/img/Pastevents/2708.jpeg",
      caption:
        "സക്ഷമ കേരളം, തിരുപുറം ഗ്രാമ പഞ്ചായത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2708.jpeg",
    },
    {
      src: "assets/img/Pastevents/2709.jpeg",
      caption:
        "സക്ഷമ കേരളം, തിരുപുറം ഗ്രാമ പഞ്ചായത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2709.jpeg",
    },
    {
      src: "assets/img/Pastevents/2710.jpeg",
      caption:
        "സക്ഷമ കേരളം, തിരുപുറം ഗ്രാമ പഞ്ചായത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2710.jpeg",
    },
    {
      src: "assets/img/Pastevents/2711.jpeg",
      caption:
        "സക്ഷമ കേരളം, തിരുപുറം ഗ്രാമ പഞ്ചായത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2711.jpeg",
    },
    {
      src: "assets/img/Pastevents/2712.jpeg",
      caption:
        "സക്ഷമ കേരളം, തിരുപുറം ഗ്രാമ പഞ്ചായത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2712.jpeg",
    },
    {
      src: "assets/img/Pastevents/2696.jpeg",
      caption:
        "കെ.എസ്.ആർ ടി സി സെൻട്രൽ യൂണിറ്റ്(2), ഹെച്ച് എൽ എൽ ലൈഫ് കെയർ യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2696.jpeg",
    },
    {
      src: "assets/img/Pastevents/2697.jpeg",
      caption:
        "കെ.എസ്.ആർ ടി സി സെൻട്രൽ യൂണിറ്റ്(2), ഹെച്ച് എൽ എൽ ലൈഫ് കെയർ യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2697.jpeg",
    },
    {
      src: "assets/img/Pastevents/2698.jpeg",
      caption:
        "കെ.എസ്.ആർ ടി സി സെൻട്രൽ യൂണിറ്റ്(2), ഹെച്ച് എൽ എൽ ലൈഫ് കെയർ യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2698.jpeg",
    },
    {
      src: "assets/img/Pastevents/2699.jpeg",
      caption:
        "കെ.എസ്.ആർ ടി സി സെൻട്രൽ യൂണിറ്റ്(2), ഹെച്ച് എൽ എൽ ലൈഫ് കെയർ യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2699.jpeg",
    },
    {
      src: "assets/img/Pastevents/2700.jpeg",
      caption:
        "കെ.എസ്.ആർ ടി സി സെൻട്രൽ യൂണിറ്റ്(2), ഹെച്ച് എൽ എൽ ലൈഫ് കെയർ യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2700.jpeg",
    },
    {
      src: "assets/img/Pastevents/2701.jpeg",
      caption:
        "കെ.എസ്.ആർ ടി സി സെൻട്രൽ യൂണിറ്റ്(2), ഹെച്ച് എൽ എൽ ലൈഫ് കെയർ യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2701.jpeg",
    },
    {
      src: "assets/img/Pastevents/2702.jpeg",
      caption:
        "കെ.എസ്.ആർ ടി സി സെൻട്രൽ യൂണിറ്റ്(2), ഹെച്ച് എൽ എൽ ലൈഫ് കെയർ യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2702.jpeg",
    },
    {
      src: "assets/img/Pastevents/2703.jpeg",
      caption:
        "കെ.എസ്.ആർ ടി സി സെൻട്രൽ യൂണിറ്റ്(2), ഹെച്ച് എൽ എൽ ലൈഫ് കെയർ യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2703.jpeg",
    },
    {
      src: "assets/img/Pastevents/2689.jpeg",
      caption:
        "പനത്തുറ മുസ്ലീം ജുമാ മസ്ജിദ്, സേവ് പ്രൊട്ടക്ഷൻ കെയർ ഫോർ പബ്ലിക്ക് ചാരിറ്റബിൾ സൊസൈറ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2689.jpeg",
    },
    {
      src: "assets/img/Pastevents/2690.jpeg",
      caption:
        "പനത്തുറ മുസ്ലീം ജുമാ മസ്ജിദ്, സേവ് പ്രൊട്ടക്ഷൻ കെയർ ഫോർ പബ്ലിക്ക് ചാരിറ്റബിൾ സൊസൈറ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2690.jpeg",
    },
    {
      src: "assets/img/Pastevents/2691.jpeg",
      caption:
        "പനത്തുറ മുസ്ലീം ജുമാ മസ്ജിദ്, സേവ് പ്രൊട്ടക്ഷൻ കെയർ ഫോർ പബ്ലിക്ക് ചാരിറ്റബിൾ സൊസൈറ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2691.jpeg",
    },
    {
      src: "assets/img/Pastevents/2692.jpeg",
      caption:
        "പനത്തുറ മുസ്ലീം ജുമാ മസ്ജിദ്, സേവ് പ്രൊട്ടക്ഷൻ കെയർ ഫോർ പബ്ലിക്ക് ചാരിറ്റബിൾ സൊസൈറ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2692.jpeg",
    },
    {
      src: "assets/img/Pastevents/2693.jpeg",
      caption:
        "പനത്തുറ മുസ്ലീം ജുമാ മസ്ജിദ്, സേവ് പ്രൊട്ടക്ഷൻ കെയർ ഫോർ പബ്ലിക്ക് ചാരിറ്റബിൾ സൊസൈറ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2693.jpeg",
    },
    {
      src: "assets/img/Pastevents/2694.jpeg",
      caption:
        "പനത്തുറ മുസ്ലീം ജുമാ മസ്ജിദ്, സേവ് പ്രൊട്ടക്ഷൻ കെയർ ഫോർ പബ്ലിക്ക് ചാരിറ്റബിൾ സൊസൈറ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2694.jpeg",
    },
    {
      src: "assets/img/Pastevents/2695.jpeg",
      caption:
        "പനത്തുറ മുസ്ലീം ജുമാ മസ്ജിദ്, സേവ് പ്രൊട്ടക്ഷൻ കെയർ ഫോർ പബ്ലിക്ക് ചാരിറ്റബിൾ സൊസൈറ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2695.jpeg",
    },
    {
      src: "assets/img/Pastevents/2683.jpeg",
      caption:
        "നൂറുൽ ഇസ്‌ലാം യൂണിവേഴ്സിറ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2683.jpeg",
    },
    {
      src: "assets/img/Pastevents/2684.jpeg",
      caption:
        "നൂറുൽ ഇസ്‌ലാം യൂണിവേഴ്സിറ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2684.jpeg",
    },
    {
      src: "assets/img/Pastevents/2685.jpeg",
      caption:
        "നൂറുൽ ഇസ്‌ലാം യൂണിവേഴ്സിറ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2685.jpeg",
    },
    {
      src: "assets/img/Pastevents/2686.jpeg",
      caption:
        "നൂറുൽ ഇസ്‌ലാം യൂണിവേഴ്സിറ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2686.jpeg",
    },
    {
      src: "assets/img/Pastevents/2687.jpeg",
      caption:
        "നൂറുൽ ഇസ്‌ലാം യൂണിവേഴ്സിറ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2687.jpeg",
    },
    {
      src: "assets/img/Pastevents/2688.jpeg",
      caption:
        "നൂറുൽ ഇസ്‌ലാം യൂണിവേഴ്സിറ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2688.jpeg",
    },
    {
      src: "assets/img/Pastevents/2675.jpeg",
      caption:
        "വട്ടിയൂർക്കാവ് ജുമാ അത്ത് , ഇൻഡക്സ് നെക്സാ മോട്ടേഴ്‌സിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2675.jpeg",
    },
    {
      src: "assets/img/Pastevents/2676.jpeg",
      caption:
        "വട്ടിയൂർക്കാവ് ജുമാ അത്ത് , ഇൻഡക്സ് നെക്സാ മോട്ടേഴ്‌സിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2676.jpeg",
    },
    {
      src: "assets/img/Pastevents/2677.jpeg",
      caption:
        "വട്ടിയൂർക്കാവ് ജുമാ അത്ത് , ഇൻഡക്സ് നെക്സാ മോട്ടേഴ്‌സിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2677.jpeg",
    },
    {
      src: "assets/img/Pastevents/2678.jpeg",
      caption:
        "വട്ടിയൂർക്കാവ് ജുമാ അത്ത് , ഇൻഡക്സ് നെക്സാ മോട്ടേഴ്‌സിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2678.jpeg",
    },
    {
      src: "assets/img/Pastevents/2679.jpeg",
      caption:
        "വട്ടിയൂർക്കാവ് ജുമാ അത്ത് , ഇൻഡക്സ് നെക്സാ മോട്ടേഴ്‌സിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2679.jpeg",
    },
    {
      src: "assets/img/Pastevents/2680.jpeg",
      caption:
        "വട്ടിയൂർക്കാവ് ജുമാ അത്ത് , ഇൻഡക്സ് നെക്സാ മോട്ടേഴ്‌സിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2680.jpeg",
    },
    {
      src: "assets/img/Pastevents/2681.jpeg",
      caption:
        "വട്ടിയൂർക്കാവ് ജുമാ അത്ത് , ഇൻഡക്സ് നെക്സാ മോട്ടേഴ്‌സിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2681.jpeg",
    },
    {
      src: "assets/img/Pastevents/2682.jpeg",
      caption:
        "വട്ടിയൂർക്കാവ് ജുമാ അത്ത് , ഇൻഡക്സ് നെക്സാ മോട്ടേഴ്‌സിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2682.jpeg",
    },
    {
      src: "assets/img/Pastevents/2669.jpeg",
      caption:
        "മുതുവിള റെസിഡൻഷ്യൽ അസോസിയേഷൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പും ക്യാൻസർ ബോധവൽക്കരണവും സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2669.jpeg",
    },
    {
      src: "assets/img/Pastevents/2670.jpeg",
      caption:
        "മുതുവിള റെസിഡൻഷ്യൽ അസോസിയേഷൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പും ക്യാൻസർ ബോധവൽക്കരണവും സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2670.jpeg",
    },
    {
      src: "assets/img/Pastevents/2671.jpeg",
      caption:
        "മുതുവിള റെസിഡൻഷ്യൽ അസോസിയേഷൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പും ക്യാൻസർ ബോധവൽക്കരണവും സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2671.jpeg",
    },
    {
      src: "assets/img/Pastevents/2672.jpeg",
      caption:
        "മുതുവിള റെസിഡൻഷ്യൽ അസോസിയേഷൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പും ക്യാൻസർ ബോധവൽക്കരണവും സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2672.jpeg",
    },
    {
      src: "assets/img/Pastevents/2673.jpeg",
      caption:
        "മുതുവിള റെസിഡൻഷ്യൽ അസോസിയേഷൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പും ക്യാൻസർ ബോധവൽക്കരണവും സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2673.jpeg",
    },
    {
      src: "assets/img/Pastevents/2674.jpeg",
      caption:
        "മുതുവിള റെസിഡൻഷ്യൽ അസോസിയേഷൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പും ക്യാൻസർ ബോധവൽക്കരണവും സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2674.jpeg",
    },
    {
      src: "assets/img/Pastevents/2663.jpeg",
      caption:
        "വൈ എം സി എ തിരുവരമ്പ്, സി എസ് ഐ ചർച്ച് തിരുവരമ്പു യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു..ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2663.jpeg",
    },
    {
      src: "assets/img/Pastevents/2664.jpeg",
      caption:
        "വൈ എം സി എ തിരുവരമ്പ്, സി എസ് ഐ ചർച്ച് തിരുവരമ്പു യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു..ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2664.jpeg",
    },
    {
      src: "assets/img/Pastevents/2665.jpeg",
      caption:
        "വൈ എം സി എ തിരുവരമ്പ്, സി എസ് ഐ ചർച്ച് തിരുവരമ്പു യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു..ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2665.jpeg",
    },
    {
      src: "assets/img/Pastevents/2666.jpeg",
      caption:
        "വൈ എം സി എ തിരുവരമ്പ്, സി എസ് ഐ ചർച്ച് തിരുവരമ്പു യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു..ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2666.jpeg",
    },
    {
      src: "assets/img/Pastevents/2667.jpeg",
      caption:
        "വൈ എം സി എ തിരുവരമ്പ്, സി എസ് ഐ ചർച്ച് തിരുവരമ്പു യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു..ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2667.jpeg",
    },
    {
      src: "assets/img/Pastevents/2668.jpeg",
      caption:
        "വൈ എം സി എ തിരുവരമ്പ്, സി എസ് ഐ ചർച്ച് തിരുവരമ്പു യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു..ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2668.jpeg",
    },
    {
      src: "assets/img/Pastevents/2656.jpeg",
      caption:
        "പേയാട് ശ്രേയസ്സ് ന്യായവില ഫാർമസിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീമതി ലില്ലി മോഹൻ (പ്രസിഡൻ്റ് വിളപ്പിൽശാല ഗ്രാമ പഞ്ചായത്ത്) ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2656.jpeg",
    },
    {
      src: "assets/img/Pastevents/2657.jpeg",
      caption:
        "പേയാട് ശ്രേയസ്സ് ന്യായവില ഫാർമസിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീമതി ലില്ലി മോഹൻ (പ്രസിഡൻ്റ് വിളപ്പിൽശാല ഗ്രാമ പഞ്ചായത്ത്) ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2657.jpeg",
    },
    {
      src: "assets/img/Pastevents/2658.jpeg",
      caption:
        "പേയാട് ശ്രേയസ്സ് ന്യായവില ഫാർമസിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീമതി ലില്ലി മോഹൻ (പ്രസിഡൻ്റ് വിളപ്പിൽശാല ഗ്രാമ പഞ്ചായത്ത്) ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2658.jpeg",
    },
    {
      src: "assets/img/Pastevents/2659.jpeg",
      caption:
        "പേയാട് ശ്രേയസ്സ് ന്യായവില ഫാർമസിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീമതി ലില്ലി മോഹൻ (പ്രസിഡൻ്റ് വിളപ്പിൽശാല ഗ്രാമ പഞ്ചായത്ത്) ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2659.jpeg",
    },
    {
      src: "assets/img/Pastevents/2660.jpeg",
      caption:
        "പേയാട് ശ്രേയസ്സ് ന്യായവില ഫാർമസിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീമതി ലില്ലി മോഹൻ (പ്രസിഡൻ്റ് വിളപ്പിൽശാല ഗ്രാമ പഞ്ചായത്ത്) ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2660.jpeg",
    },
    {
      src: "assets/img/Pastevents/2661.jpeg",
      caption:
        "പേയാട് ശ്രേയസ്സ് ന്യായവില ഫാർമസിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീമതി ലില്ലി മോഹൻ (പ്രസിഡൻ്റ് വിളപ്പിൽശാല ഗ്രാമ പഞ്ചായത്ത്) ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2661.jpeg",
    },
    {
      src: "assets/img/Pastevents/2662.jpeg",
      caption:
        "പേയാട് ശ്രേയസ്സ് ന്യായവില ഫാർമസിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീമതി ലില്ലി മോഹൻ (പ്രസിഡൻ്റ് വിളപ്പിൽശാല ഗ്രാമ പഞ്ചായത്ത്) ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2662.jpeg",
    },
    {
      src: "assets/img/Pastevents/2650.jpeg",
      caption:
        "കനൽ ചാരിറ്റബിൾ സൊസൈറ്റി,മാർ ഡയസ്കോറസ് കോളേജ് ഓഫ് ഫാർമസി എൻ എസ് എസ് യൂണിറ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2650.jpeg",
    },
    {
      src: "assets/img/Pastevents/2651.jpeg",
      caption:
        "കനൽ ചാരിറ്റബിൾ സൊസൈറ്റി,മാർ ഡയസ്കോറസ് കോളേജ് ഓഫ് ഫാർമസി എൻ എസ് എസ് യൂണിറ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2651.jpeg",
    },
    {
      src: "assets/img/Pastevents/2652.jpeg",
      caption:
        "കനൽ ചാരിറ്റബിൾ സൊസൈറ്റി,മാർ ഡയസ്കോറസ് കോളേജ് ഓഫ് ഫാർമസി എൻ എസ് എസ് യൂണിറ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2652.jpeg",
    },
    {
      src: "assets/img/Pastevents/2653.jpeg",
      caption:
        "കനൽ ചാരിറ്റബിൾ സൊസൈറ്റി,മാർ ഡയസ്കോറസ് കോളേജ് ഓഫ് ഫാർമസി എൻ എസ് എസ് യൂണിറ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2653.jpeg",
    },
    {
      src: "assets/img/Pastevents/2654.jpeg",
      caption:
        "കനൽ ചാരിറ്റബിൾ സൊസൈറ്റി,മാർ ഡയസ്കോറസ് കോളേജ് ഓഫ് ഫാർമസി എൻ എസ് എസ് യൂണിറ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2654.jpeg",
    },
    {
      src: "assets/img/Pastevents/2655.jpeg",
      caption:
        "കനൽ ചാരിറ്റബിൾ സൊസൈറ്റി,മാർ ഡയസ്കോറസ് കോളേജ് ഓഫ് ഫാർമസി എൻ എസ് എസ് യൂണിറ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2655.jpeg",
    },
    {
      src: "assets/img/Pastevents/2646.jpeg",
      caption:
        "ഇടനാട്ടുക്കോണം ശ്രീ ധർമ്മ ശാസ്താ ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2646.jpeg",
    },
    {
      src: "assets/img/Pastevents/2647.jpeg",
      caption:
        "ഇടനാട്ടുക്കോണം ശ്രീ ധർമ്മ ശാസ്താ ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2647.jpeg",
    },
    {
      src: "assets/img/Pastevents/2648.jpeg",
      caption:
        "ഇടനാട്ടുക്കോണം ശ്രീ ധർമ്മ ശാസ്താ ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2648.jpeg",
    },
    {
      src: "assets/img/Pastevents/2649.jpeg",
      caption:
        "ഇടനാട്ടുക്കോണം ശ്രീ ധർമ്മ ശാസ്താ ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2649.jpeg",
    },
    {
      src: "assets/img/Pastevents/2639.jpeg",
      caption:
        "ഇടനാട്ടുക്കോണം ശ്രീ ധർമ്മ ശാസ്താ ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2639.jpeg",
    },
    {
      src: "assets/img/Pastevents/2640.jpeg",
      caption:
        "ഇടനാട്ടുക്കോണം ശ്രീ ധർമ്മ ശാസ്താ ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2640.jpeg",
    },
    {
      src: "assets/img/Pastevents/2641.jpeg",
      caption:
        "ഇടനാട്ടുക്കോണം ശ്രീ ധർമ്മ ശാസ്താ ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2641.jpeg",
    },
    {
      src: "assets/img/Pastevents/2642.jpeg",
      caption:
        "ഇടനാട്ടുക്കോണം ശ്രീ ധർമ്മ ശാസ്താ ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2642.jpeg",
    },
    {
      src: "assets/img/Pastevents/2643.jpeg",
      caption:
        "ഇടനാട്ടുക്കോണം ശ്രീ ധർമ്മ ശാസ്താ ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2643.jpeg",
    },
    {
      src: "assets/img/Pastevents/2644.jpeg",
      caption:
        "ഇടനാട്ടുക്കോണം ശ്രീ ധർമ്മ ശാസ്താ ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2644.jpeg",
    },
    {
      src: "assets/img/Pastevents/2645.jpeg",
      caption:
        "ഇടനാട്ടുക്കോണം ശ്രീ ധർമ്മ ശാസ്താ ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2645.jpeg",
    },
    {
      src: "assets/img/Pastevents/2633.jpeg",
      caption:
        "എൽ & റ്റി കൺസ്ട്രക്ഷൻ കമ്പനിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2633.jpeg",
    },
    {
      src: "assets/img/Pastevents/2634.jpeg",
      caption:
        "എൽ & റ്റി കൺസ്ട്രക്ഷൻ കമ്പനിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2634.jpeg",
    },
    {
      src: "assets/img/Pastevents/2635.jpeg",
      caption:
        "എൽ & റ്റി കൺസ്ട്രക്ഷൻ കമ്പനിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2635.jpeg",
    },
    {
      src: "assets/img/Pastevents/2636.jpeg",
      caption:
        "എൽ & റ്റി കൺസ്ട്രക്ഷൻ കമ്പനിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2636.jpeg",
    },
    {
      src: "assets/img/Pastevents/2637.jpeg",
      caption:
        "എൽ & റ്റി കൺസ്ട്രക്ഷൻ കമ്പനിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2637.jpeg",
    },
    {
      src: "assets/img/Pastevents/2638.jpeg",
      caption:
        "എൽ & റ്റി കൺസ്ട്രക്ഷൻ കമ്പനിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2638.jpeg",
    },
    {
      src: "assets/img/Pastevents/2627.jpeg",
      caption:
        "കൊണ്ണിയൂർ ക്രൈസ്റ്റ് അംബാസിഡേർസ് അസംബ്ലിസ് ഓഫ് ഹെബ്രോൻ ചർച്ച്,നെടുമങ്ങാട് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2627.jpeg",
    },
    {
      src: "assets/img/Pastevents/2628.jpeg",
      caption:
        "കൊണ്ണിയൂർ ക്രൈസ്റ്റ് അംബാസിഡേർസ് അസംബ്ലിസ് ഓഫ് ഹെബ്രോൻ ചർച്ച്,നെടുമങ്ങാട് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2628.jpeg",
    },
    {
      src: "assets/img/Pastevents/2629.jpeg",
      caption:
        "കൊണ്ണിയൂർ ക്രൈസ്റ്റ് അംബാസിഡേർസ് അസംബ്ലിസ് ഓഫ് ഹെബ്രോൻ ചർച്ച്,നെടുമങ്ങാട് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2629.jpeg",
    },
    {
      src: "assets/img/Pastevents/2630.jpeg",
      caption:
        "കൊണ്ണിയൂർ ക്രൈസ്റ്റ് അംബാസിഡേർസ് അസംബ്ലിസ് ഓഫ് ഹെബ്രോൻ ചർച്ച്,നെടുമങ്ങാട് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2630.jpeg",
    },
    {
      src: "assets/img/Pastevents/2631.jpeg",
      caption:
        "കൊണ്ണിയൂർ ക്രൈസ്റ്റ് അംബാസിഡേർസ് അസംബ്ലിസ് ഓഫ് ഹെബ്രോൻ ചർച്ച്,നെടുമങ്ങാട് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2631.jpeg",
    },
    {
      src: "assets/img/Pastevents/2632.jpeg",
      caption:
        "കൊണ്ണിയൂർ ക്രൈസ്റ്റ് അംബാസിഡേർസ് അസംബ്ലിസ് ഓഫ് ഹെബ്രോൻ ചർച്ച്,നെടുമങ്ങാട് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2632.jpeg",
    },
    {
      src: "assets/img/Pastevents/2621.jpeg",
      caption:
        "കരമന സോമൻ സ്മാരക ചാരിറ്റബിൾ സൊസൈറ്റി,വൈ.എം സി ട്രിവാൻഡ്രം മെജസ്റ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2621.jpeg",
    },
    {
      src: "assets/img/Pastevents/2622.jpeg",
      caption:
        "കരമന സോമൻ സ്മാരക ചാരിറ്റബിൾ സൊസൈറ്റി,വൈ.എം സി ട്രിവാൻഡ്രം മെജസ്റ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2622.jpeg",
    },
    {
      src: "assets/img/Pastevents/2623.jpeg",
      caption:
        "കരമന സോമൻ സ്മാരക ചാരിറ്റബിൾ സൊസൈറ്റി,വൈ.എം സി ട്രിവാൻഡ്രം മെജസ്റ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2623.jpeg",
    },
    {
      src: "assets/img/Pastevents/2624.jpeg",
      caption:
        "കരമന സോമൻ സ്മാരക ചാരിറ്റബിൾ സൊസൈറ്റി,വൈ.എം സി ട്രിവാൻഡ്രം മെജസ്റ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2624.jpeg",
    },
    {
      src: "assets/img/Pastevents/2625.jpeg",
      caption:
        "കരമന സോമൻ സ്മാരക ചാരിറ്റബിൾ സൊസൈറ്റി,വൈ.എം സി ട്രിവാൻഡ്രം മെജസ്റ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2625.jpeg",
    },
    {
      src: "assets/img/Pastevents/2626.jpeg",
      caption:
        "കരമന സോമൻ സ്മാരക ചാരിറ്റബിൾ സൊസൈറ്റി,വൈ.എം സി ട്രിവാൻഡ്രം മെജസ്റ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2626.jpeg",
    },
    {
      src: "assets/img/Pastevents/2614.jpeg",
      caption:
        "കേരളാ സ്റ്റേറ്റ് ഇലക്ട്രിസിറ്റി ബോർഡ് എംപ്ലോയീസ് അസോസിയേഷൻൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ ആൻ്റണി രാജു (ബഹു ഗതാഗത വകുപ്പ് മന്ത്രി).ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2614.jpeg",
    },
    {
      src: "assets/img/Pastevents/2615.jpeg",
      caption:
        "കേരളാ സ്റ്റേറ്റ് ഇലക്ട്രിസിറ്റി ബോർഡ് എംപ്ലോയീസ് അസോസിയേഷൻൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ ആൻ്റണി രാജു (ബഹു ഗതാഗത വകുപ്പ് മന്ത്രി).ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2615.jpeg",
    },
    {
      src: "assets/img/Pastevents/2616.jpeg",
      caption:
        "കേരളാ സ്റ്റേറ്റ് ഇലക്ട്രിസിറ്റി ബോർഡ് എംപ്ലോയീസ് അസോസിയേഷൻൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ ആൻ്റണി രാജു (ബഹു ഗതാഗത വകുപ്പ് മന്ത്രി).ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2616.jpeg",
    },
    {
      src: "assets/img/Pastevents/2617.jpeg",
      caption:
        "കേരളാ സ്റ്റേറ്റ് ഇലക്ട്രിസിറ്റി ബോർഡ് എംപ്ലോയീസ് അസോസിയേഷൻൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ ആൻ്റണി രാജു (ബഹു ഗതാഗത വകുപ്പ് മന്ത്രി).ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2617.jpeg",
    },
    {
      src: "assets/img/Pastevents/2618.jpeg",
      caption:
        "കേരളാ സ്റ്റേറ്റ് ഇലക്ട്രിസിറ്റി ബോർഡ് എംപ്ലോയീസ് അസോസിയേഷൻൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ ആൻ്റണി രാജു (ബഹു ഗതാഗത വകുപ്പ് മന്ത്രി).ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2618.jpeg",
    },
    {
      src: "assets/img/Pastevents/2619.jpeg",
      caption:
        "കേരളാ സ്റ്റേറ്റ് ഇലക്ട്രിസിറ്റി ബോർഡ് എംപ്ലോയീസ് അസോസിയേഷൻൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ ആൻ്റണി രാജു (ബഹു ഗതാഗത വകുപ്പ് മന്ത്രി).ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2619.jpeg",
    },
    {
      src: "assets/img/Pastevents/2620.jpeg",
      caption:
        "കേരളാ സ്റ്റേറ്റ് ഇലക്ട്രിസിറ്റി ബോർഡ് എംപ്ലോയീസ് അസോസിയേഷൻൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ ആൻ്റണി രാജു (ബഹു ഗതാഗത വകുപ്പ് മന്ത്രി).ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2620.jpeg",
    },

    {
      src: "assets/img/Pastevents/2608.jpeg",
      caption:
        ".തോട്ടിൻപ്പുറം റെസിഡൻഷ്യൽ അസോസിയേഷൻ, ചൈതന്യ റെസിഡൻഷ്യൽ അസോസിയേഷൻ,ട്രിവാൻഡ്രം സീഫോർട് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ എം വിൻസെൻ്റ് (എം എൽ എ കോവളം) ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2608.jpeg",
    },
    {
      src: "assets/img/Pastevents/2609.jpeg",
      caption:
        ".തോട്ടിൻപ്പുറം റെസിഡൻഷ്യൽ അസോസിയേഷൻ, ചൈതന്യ റെസിഡൻഷ്യൽ അസോസിയേഷൻ,ട്രിവാൻഡ്രം സീഫോർട് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ എം വിൻസെൻ്റ് (എം എൽ എ കോവളം) ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2609.jpeg",
    },
    {
      src: "assets/img/Pastevents/2610.jpeg",
      caption:
        ".തോട്ടിൻപ്പുറം റെസിഡൻഷ്യൽ അസോസിയേഷൻ, ചൈതന്യ റെസിഡൻഷ്യൽ അസോസിയേഷൻ,ട്രിവാൻഡ്രം സീഫോർട് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ എം വിൻസെൻ്റ് (എം എൽ എ കോവളം) ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2610.jpeg",
    },
    {
      src: "assets/img/Pastevents/2611.jpeg",
      caption:
        ".തോട്ടിൻപ്പുറം റെസിഡൻഷ്യൽ അസോസിയേഷൻ, ചൈതന്യ റെസിഡൻഷ്യൽ അസോസിയേഷൻ,ട്രിവാൻഡ്രം സീഫോർട് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ എം വിൻസെൻ്റ് (എം എൽ എ കോവളം) ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2611.jpeg",
    },
    {
      src: "assets/img/Pastevents/2612.jpeg",
      caption:
        ".തോട്ടിൻപ്പുറം റെസിഡൻഷ്യൽ അസോസിയേഷൻ, ചൈതന്യ റെസിഡൻഷ്യൽ അസോസിയേഷൻ,ട്രിവാൻഡ്രം സീഫോർട് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ എം വിൻസെൻ്റ് (എം എൽ എ കോവളം) ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2612.jpeg",
    },
    {
      src: "assets/img/Pastevents/2613.jpeg",
      caption:
        ".തോട്ടിൻപ്പുറം റെസിഡൻഷ്യൽ അസോസിയേഷൻ, ചൈതന്യ റെസിഡൻഷ്യൽ അസോസിയേഷൻ,ട്രിവാൻഡ്രം സീഫോർട് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ എം വിൻസെൻ്റ് (എം എൽ എ കോവളം) ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2613.jpeg",
    },
    {
      src: "assets/img/Pastevents/2602.jpeg",
      caption:
        "കെ സി വൈ  എം കണ്ണറവിള യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2602.jpeg",
    },
    {
      src: "assets/img/Pastevents/2603.jpeg",
      caption:
        "കെ സി വൈ  എം കണ്ണറവിള യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2603.jpeg",
    },
    {
      src: "assets/img/Pastevents/2604.jpeg",
      caption:
        "കെ സി വൈ  എം കണ്ണറവിള യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2604.jpeg",
    },
    {
      src: "assets/img/Pastevents/2605.jpeg",
      caption:
        "കെ സി വൈ  എം കണ്ണറവിള യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2605.jpeg",
    },
    {
      src: "assets/img/Pastevents/2606.jpeg",
      caption:
        "കെ സി വൈ  എം കണ്ണറവിള യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2606.jpeg",
    },
    {
      src: "assets/img/Pastevents/2607.jpeg",
      caption:
        "കെ സി വൈ  എം കണ്ണറവിള യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2607.jpeg",
    },
    {
      src: "assets/img/Pastevents/2595.jpeg",
      caption:
        "പാലിയോട് അനുഗ്രഹാ ഗ്രന്ഥശാലയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2595.jpeg",
    },
    {
      src: "assets/img/Pastevents/2596.jpeg",
      caption:
        "പാലിയോട് അനുഗ്രഹാ ഗ്രന്ഥശാലയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2596.jpeg",
    },
    {
      src: "assets/img/Pastevents/2597.jpeg",
      caption:
        "പാലിയോട് അനുഗ്രഹാ ഗ്രന്ഥശാലയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2597.jpeg",
    },
    {
      src: "assets/img/Pastevents/2598.jpeg",
      caption:
        "പാലിയോട് അനുഗ്രഹാ ഗ്രന്ഥശാലയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2598.jpeg",
    },
    {
      src: "assets/img/Pastevents/2599.jpeg",
      caption:
        "പാലിയോട് അനുഗ്രഹാ ഗ്രന്ഥശാലയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2599.jpeg",
    },
    {
      src: "assets/img/Pastevents/2600.jpeg",
      caption:
        "പാലിയോട് അനുഗ്രഹാ ഗ്രന്ഥശാലയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2600.jpeg",
    },
    {
      src: "assets/img/Pastevents/2601.jpeg",
      caption:
        "പാലിയോട് അനുഗ്രഹാ ഗ്രന്ഥശാലയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2601.jpeg",
    },
    {
      src: "assets/img/Pastevents/2589.jpeg",
      caption:
        "പുന്നക്കുളം തെങ്കവിള ഓംകാര സോഷ്യൽ സർവീസ് ഓർഗനൈസേഷൻൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2589.jpeg",
    },
    {
      src: "assets/img/Pastevents/2590.jpeg",
      caption:
        "പുന്നക്കുളം തെങ്കവിള ഓംകാര സോഷ്യൽ സർവീസ് ഓർഗനൈസേഷൻൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2590.jpeg",
    },
    {
      src: "assets/img/Pastevents/2591.jpeg",
      caption:
        "പുന്നക്കുളം തെങ്കവിള ഓംകാര സോഷ്യൽ സർവീസ് ഓർഗനൈസേഷൻൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2591.jpeg",
    },
    {
      src: "assets/img/Pastevents/2592.jpeg",
      caption:
        "പുന്നക്കുളം തെങ്കവിള ഓംകാര സോഷ്യൽ സർവീസ് ഓർഗനൈസേഷൻൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2592.jpeg",
    },
    {
      src: "assets/img/Pastevents/2593.jpeg",
      caption:
        "പുന്നക്കുളം തെങ്കവിള ഓംകാര സോഷ്യൽ സർവീസ് ഓർഗനൈസേഷൻൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2593.jpeg",
    },
    {
      src: "assets/img/Pastevents/2594.jpeg",
      caption:
        "പുന്നക്കുളം തെങ്കവിള ഓംകാര സോഷ്യൽ സർവീസ് ഓർഗനൈസേഷൻൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2594.jpeg",
    },
    {
      src: "assets/img/Pastevents/2579.jpeg",
      caption:
        "മെയ്യ് 10 ബുധൻ രാവിലെ 09 മണിയ്ക്ക് വഴിമുക്ക് വിശ്വനാഥ് ഓഡിറ്റോറിയത്തിൽ  വച്ച് നടന്ന ചടങ്ങിൽ  എന്റെ ഹൃദയം എന്റെ ഗ്രാമം ; സൗജന്യ ഹൃദ്രോഗ നിർണ്ണയ മെഗാ ക്യാമ്പിന്റെയും ബോധവത്ക്കരണത്തിൻ്റെയും ഉദ്ഘാടനം ശ്രീമതി  അഡ്വ: എസ് കെ പ്രീജ(ബ്ലോക്ക് പഞ്ചായത്ത് പ്രസിഡൻ്റ്) നിർവഹിച്ചു. ശ്രി വി മോഹനൻ, ഗ്രാമപഞ്ചായത്ത് പ്രസിഡന്റ് അദ്ധ്യക്ഷത വഹിച്ച യോഗത്തിൽ രാഷ്ട്രീയ, സാമൂഹ്യ സാംസ്കാരിക രംഗത്തെ പ്രമുഖർ, ജനപ്രതിനിധികൾ തുടങ്ങിയവർ പങ്കെടുത്തു.  ക്യാമ്പിൽ 250-പ്പരം പേർ കാർഡിയോളജി  സ്ക്രീനീംഗന്  വിധേയമായി. ക്യാമ്പിൽ ഡയബറ്റോളജി, ജനറൽ മെഡിസിൻ,ഒഫ്ത്താൽമോളജി,ഡെൻറ്റൽ, സൗജന്യ എക്കോ, ഇ. സി. ജി, ബ്ലഡ് ഷുഗർ, ബ്ലഡ് പ്രഷർ, ബി എം ഐ ടെസ്റ്റുകൾ നടത്തി.",
      thumb: "assets/img/Pastevents/2579.jpeg",
    },
    {
      src: "assets/img/Pastevents/2580.jpeg",
      caption:
        "മെയ്യ് 10 ബുധൻ രാവിലെ 09 മണിയ്ക്ക് വഴിമുക്ക് വിശ്വനാഥ് ഓഡിറ്റോറിയത്തിൽ  വച്ച് നടന്ന ചടങ്ങിൽ  എന്റെ ഹൃദയം എന്റെ ഗ്രാമം ; സൗജന്യ ഹൃദ്രോഗ നിർണ്ണയ മെഗാ ക്യാമ്പിന്റെയും ബോധവത്ക്കരണത്തിൻ്റെയും ഉദ്ഘാടനം ശ്രീമതി  അഡ്വ: എസ് കെ പ്രീജ(ബ്ലോക്ക് പഞ്ചായത്ത് പ്രസിഡൻ്റ്) നിർവഹിച്ചു. ശ്രി വി മോഹനൻ, ഗ്രാമപഞ്ചായത്ത് പ്രസിഡന്റ് അദ്ധ്യക്ഷത വഹിച്ച യോഗത്തിൽ രാഷ്ട്രീയ, സാമൂഹ്യ സാംസ്കാരിക രംഗത്തെ പ്രമുഖർ, ജനപ്രതിനിധികൾ തുടങ്ങിയവർ പങ്കെടുത്തു.  ക്യാമ്പിൽ 250-പ്പരം പേർ കാർഡിയോളജി  സ്ക്രീനീംഗന്  വിധേയമായി. ക്യാമ്പിൽ ഡയബറ്റോളജി, ജനറൽ മെഡിസിൻ,ഒഫ്ത്താൽമോളജി,ഡെൻറ്റൽ, സൗജന്യ എക്കോ, ഇ. സി. ജി, ബ്ലഡ് ഷുഗർ, ബ്ലഡ് പ്രഷർ, ബി എം ഐ ടെസ്റ്റുകൾ നടത്തി.",
      thumb: "assets/img/Pastevents/2580.jpeg",
    },
    {
      src: "assets/img/Pastevents/2581.jpeg",
      caption:
        "മെയ്യ് 10 ബുധൻ രാവിലെ 09 മണിയ്ക്ക് വഴിമുക്ക് വിശ്വനാഥ് ഓഡിറ്റോറിയത്തിൽ  വച്ച് നടന്ന ചടങ്ങിൽ  എന്റെ ഹൃദയം എന്റെ ഗ്രാമം ; സൗജന്യ ഹൃദ്രോഗ നിർണ്ണയ മെഗാ ക്യാമ്പിന്റെയും ബോധവത്ക്കരണത്തിൻ്റെയും ഉദ്ഘാടനം ശ്രീമതി  അഡ്വ: എസ് കെ പ്രീജ(ബ്ലോക്ക് പഞ്ചായത്ത് പ്രസിഡൻ്റ്) നിർവഹിച്ചു. ശ്രി വി മോഹനൻ, ഗ്രാമപഞ്ചായത്ത് പ്രസിഡന്റ് അദ്ധ്യക്ഷത വഹിച്ച യോഗത്തിൽ രാഷ്ട്രീയ, സാമൂഹ്യ സാംസ്കാരിക രംഗത്തെ പ്രമുഖർ, ജനപ്രതിനിധികൾ തുടങ്ങിയവർ പങ്കെടുത്തു.  ക്യാമ്പിൽ 250-പ്പരം പേർ കാർഡിയോളജി  സ്ക്രീനീംഗന്  വിധേയമായി. ക്യാമ്പിൽ ഡയബറ്റോളജി, ജനറൽ മെഡിസിൻ,ഒഫ്ത്താൽമോളജി,ഡെൻറ്റൽ, സൗജന്യ എക്കോ, ഇ. സി. ജി, ബ്ലഡ് ഷുഗർ, ബ്ലഡ് പ്രഷർ, ബി എം ഐ ടെസ്റ്റുകൾ നടത്തി.",
      thumb: "assets/img/Pastevents/2581.jpeg",
    },
    {
      src: "assets/img/Pastevents/2582.jpeg",
      caption:
        "മെയ്യ് 10 ബുധൻ രാവിലെ 09 മണിയ്ക്ക് വഴിമുക്ക് വിശ്വനാഥ് ഓഡിറ്റോറിയത്തിൽ  വച്ച് നടന്ന ചടങ്ങിൽ  എന്റെ ഹൃദയം എന്റെ ഗ്രാമം ; സൗജന്യ ഹൃദ്രോഗ നിർണ്ണയ മെഗാ ക്യാമ്പിന്റെയും ബോധവത്ക്കരണത്തിൻ്റെയും ഉദ്ഘാടനം ശ്രീമതി  അഡ്വ: എസ് കെ പ്രീജ(ബ്ലോക്ക് പഞ്ചായത്ത് പ്രസിഡൻ്റ്) നിർവഹിച്ചു. ശ്രി വി മോഹനൻ, ഗ്രാമപഞ്ചായത്ത് പ്രസിഡന്റ് അദ്ധ്യക്ഷത വഹിച്ച യോഗത്തിൽ രാഷ്ട്രീയ, സാമൂഹ്യ സാംസ്കാരിക രംഗത്തെ പ്രമുഖർ, ജനപ്രതിനിധികൾ തുടങ്ങിയവർ പങ്കെടുത്തു.  ക്യാമ്പിൽ 250-പ്പരം പേർ കാർഡിയോളജി  സ്ക്രീനീംഗന്  വിധേയമായി. ക്യാമ്പിൽ ഡയബറ്റോളജി, ജനറൽ മെഡിസിൻ,ഒഫ്ത്താൽമോളജി,ഡെൻറ്റൽ, സൗജന്യ എക്കോ, ഇ. സി. ജി, ബ്ലഡ് ഷുഗർ, ബ്ലഡ് പ്രഷർ, ബി എം ഐ ടെസ്റ്റുകൾ നടത്തി.",
      thumb: "assets/img/Pastevents/2582.jpeg",
    },
    {
      src: "assets/img/Pastevents/2583.jpeg",
      caption:
        "മെയ്യ് 10 ബുധൻ രാവിലെ 09 മണിയ്ക്ക് വഴിമുക്ക് വിശ്വനാഥ് ഓഡിറ്റോറിയത്തിൽ  വച്ച് നടന്ന ചടങ്ങിൽ  എന്റെ ഹൃദയം എന്റെ ഗ്രാമം ; സൗജന്യ ഹൃദ്രോഗ നിർണ്ണയ മെഗാ ക്യാമ്പിന്റെയും ബോധവത്ക്കരണത്തിൻ്റെയും ഉദ്ഘാടനം ശ്രീമതി  അഡ്വ: എസ് കെ പ്രീജ(ബ്ലോക്ക് പഞ്ചായത്ത് പ്രസിഡൻ്റ്) നിർവഹിച്ചു. ശ്രി വി മോഹനൻ, ഗ്രാമപഞ്ചായത്ത് പ്രസിഡന്റ് അദ്ധ്യക്ഷത വഹിച്ച യോഗത്തിൽ രാഷ്ട്രീയ, സാമൂഹ്യ സാംസ്കാരിക രംഗത്തെ പ്രമുഖർ, ജനപ്രതിനിധികൾ തുടങ്ങിയവർ പങ്കെടുത്തു.  ക്യാമ്പിൽ 250-പ്പരം പേർ കാർഡിയോളജി  സ്ക്രീനീംഗന്  വിധേയമായി. ക്യാമ്പിൽ ഡയബറ്റോളജി, ജനറൽ മെഡിസിൻ,ഒഫ്ത്താൽമോളജി,ഡെൻറ്റൽ, സൗജന്യ എക്കോ, ഇ. സി. ജി, ബ്ലഡ് ഷുഗർ, ബ്ലഡ് പ്രഷർ, ബി എം ഐ ടെസ്റ്റുകൾ നടത്തി.",
      thumb: "assets/img/Pastevents/2583.jpeg",
    },
    {
      src: "assets/img/Pastevents/2584.jpeg",
      caption:
        "മെയ്യ് 10 ബുധൻ രാവിലെ 09 മണിയ്ക്ക് വഴിമുക്ക് വിശ്വനാഥ് ഓഡിറ്റോറിയത്തിൽ  വച്ച് നടന്ന ചടങ്ങിൽ  എന്റെ ഹൃദയം എന്റെ ഗ്രാമം ; സൗജന്യ ഹൃദ്രോഗ നിർണ്ണയ മെഗാ ക്യാമ്പിന്റെയും ബോധവത്ക്കരണത്തിൻ്റെയും ഉദ്ഘാടനം ശ്രീമതി  അഡ്വ: എസ് കെ പ്രീജ(ബ്ലോക്ക് പഞ്ചായത്ത് പ്രസിഡൻ്റ്) നിർവഹിച്ചു. ശ്രി വി മോഹനൻ, ഗ്രാമപഞ്ചായത്ത് പ്രസിഡന്റ് അദ്ധ്യക്ഷത വഹിച്ച യോഗത്തിൽ രാഷ്ട്രീയ, സാമൂഹ്യ സാംസ്കാരിക രംഗത്തെ പ്രമുഖർ, ജനപ്രതിനിധികൾ തുടങ്ങിയവർ പങ്കെടുത്തു.  ക്യാമ്പിൽ 250-പ്പരം പേർ കാർഡിയോളജി  സ്ക്രീനീംഗന്  വിധേയമായി. ക്യാമ്പിൽ ഡയബറ്റോളജി, ജനറൽ മെഡിസിൻ,ഒഫ്ത്താൽമോളജി,ഡെൻറ്റൽ, സൗജന്യ എക്കോ, ഇ. സി. ജി, ബ്ലഡ് ഷുഗർ, ബ്ലഡ് പ്രഷർ, ബി എം ഐ ടെസ്റ്റുകൾ നടത്തി.",
      thumb: "assets/img/Pastevents/2584.jpeg",
    },
    {
      src: "assets/img/Pastevents/2585.jpeg",
      caption:
        "മെയ്യ് 10 ബുധൻ രാവിലെ 09 മണിയ്ക്ക് വഴിമുക്ക് വിശ്വനാഥ് ഓഡിറ്റോറിയത്തിൽ  വച്ച് നടന്ന ചടങ്ങിൽ  എന്റെ ഹൃദയം എന്റെ ഗ്രാമം ; സൗജന്യ ഹൃദ്രോഗ നിർണ്ണയ മെഗാ ക്യാമ്പിന്റെയും ബോധവത്ക്കരണത്തിൻ്റെയും ഉദ്ഘാടനം ശ്രീമതി  അഡ്വ: എസ് കെ പ്രീജ(ബ്ലോക്ക് പഞ്ചായത്ത് പ്രസിഡൻ്റ്) നിർവഹിച്ചു. ശ്രി വി മോഹനൻ, ഗ്രാമപഞ്ചായത്ത് പ്രസിഡന്റ് അദ്ധ്യക്ഷത വഹിച്ച യോഗത്തിൽ രാഷ്ട്രീയ, സാമൂഹ്യ സാംസ്കാരിക രംഗത്തെ പ്രമുഖർ, ജനപ്രതിനിധികൾ തുടങ്ങിയവർ പങ്കെടുത്തു.  ക്യാമ്പിൽ 250-പ്പരം പേർ കാർഡിയോളജി  സ്ക്രീനീംഗന്  വിധേയമായി. ക്യാമ്പിൽ ഡയബറ്റോളജി, ജനറൽ മെഡിസിൻ,ഒഫ്ത്താൽമോളജി,ഡെൻറ്റൽ, സൗജന്യ എക്കോ, ഇ. സി. ജി, ബ്ലഡ് ഷുഗർ, ബ്ലഡ് പ്രഷർ, ബി എം ഐ ടെസ്റ്റുകൾ നടത്തി.",
      thumb: "assets/img/Pastevents/2585.jpeg",
    },
    {
      src: "assets/img/Pastevents/2586.jpeg",
      caption:
        "മെയ്യ് 10 ബുധൻ രാവിലെ 09 മണിയ്ക്ക് വഴിമുക്ക് വിശ്വനാഥ് ഓഡിറ്റോറിയത്തിൽ  വച്ച് നടന്ന ചടങ്ങിൽ  എന്റെ ഹൃദയം എന്റെ ഗ്രാമം ; സൗജന്യ ഹൃദ്രോഗ നിർണ്ണയ മെഗാ ക്യാമ്പിന്റെയും ബോധവത്ക്കരണത്തിൻ്റെയും ഉദ്ഘാടനം ശ്രീമതി  അഡ്വ: എസ് കെ പ്രീജ(ബ്ലോക്ക് പഞ്ചായത്ത് പ്രസിഡൻ്റ്) നിർവഹിച്ചു. ശ്രി വി മോഹനൻ, ഗ്രാമപഞ്ചായത്ത് പ്രസിഡന്റ് അദ്ധ്യക്ഷത വഹിച്ച യോഗത്തിൽ രാഷ്ട്രീയ, സാമൂഹ്യ സാംസ്കാരിക രംഗത്തെ പ്രമുഖർ, ജനപ്രതിനിധികൾ തുടങ്ങിയവർ പങ്കെടുത്തു.  ക്യാമ്പിൽ 250-പ്പരം പേർ കാർഡിയോളജി  സ്ക്രീനീംഗന്  വിധേയമായി. ക്യാമ്പിൽ ഡയബറ്റോളജി, ജനറൽ മെഡിസിൻ,ഒഫ്ത്താൽമോളജി,ഡെൻറ്റൽ, സൗജന്യ എക്കോ, ഇ. സി. ജി, ബ്ലഡ് ഷുഗർ, ബ്ലഡ് പ്രഷർ, ബി എം ഐ ടെസ്റ്റുകൾ നടത്തി.",
      thumb: "assets/img/Pastevents/2586.jpeg",
    },
    {
      src: "assets/img/Pastevents/2587.jpeg",
      caption:
        "മെയ്യ് 10 ബുധൻ രാവിലെ 09 മണിയ്ക്ക് വഴിമുക്ക് വിശ്വനാഥ് ഓഡിറ്റോറിയത്തിൽ  വച്ച് നടന്ന ചടങ്ങിൽ  എന്റെ ഹൃദയം എന്റെ ഗ്രാമം ; സൗജന്യ ഹൃദ്രോഗ നിർണ്ണയ മെഗാ ക്യാമ്പിന്റെയും ബോധവത്ക്കരണത്തിൻ്റെയും ഉദ്ഘാടനം ശ്രീമതി  അഡ്വ: എസ് കെ പ്രീജ(ബ്ലോക്ക് പഞ്ചായത്ത് പ്രസിഡൻ്റ്) നിർവഹിച്ചു. ശ്രി വി മോഹനൻ, ഗ്രാമപഞ്ചായത്ത് പ്രസിഡന്റ് അദ്ധ്യക്ഷത വഹിച്ച യോഗത്തിൽ രാഷ്ട്രീയ, സാമൂഹ്യ സാംസ്കാരിക രംഗത്തെ പ്രമുഖർ, ജനപ്രതിനിധികൾ തുടങ്ങിയവർ പങ്കെടുത്തു.  ക്യാമ്പിൽ 250-പ്പരം പേർ കാർഡിയോളജി  സ്ക്രീനീംഗന്  വിധേയമായി. ക്യാമ്പിൽ ഡയബറ്റോളജി, ജനറൽ മെഡിസിൻ,ഒഫ്ത്താൽമോളജി,ഡെൻറ്റൽ, സൗജന്യ എക്കോ, ഇ. സി. ജി, ബ്ലഡ് ഷുഗർ, ബ്ലഡ് പ്രഷർ, ബി എം ഐ ടെസ്റ്റുകൾ നടത്തി.",
      thumb: "assets/img/Pastevents/2587.jpeg",
    },
    {
      src: "assets/img/Pastevents/2588.jpeg",
      caption:
        "മെയ്യ് 10 ബുധൻ രാവിലെ 09 മണിയ്ക്ക് വഴിമുക്ക് വിശ്വനാഥ് ഓഡിറ്റോറിയത്തിൽ  വച്ച് നടന്ന ചടങ്ങിൽ  എന്റെ ഹൃദയം എന്റെ ഗ്രാമം ; സൗജന്യ ഹൃദ്രോഗ നിർണ്ണയ മെഗാ ക്യാമ്പിന്റെയും ബോധവത്ക്കരണത്തിൻ്റെയും ഉദ്ഘാടനം ശ്രീമതി  അഡ്വ: എസ് കെ പ്രീജ(ബ്ലോക്ക് പഞ്ചായത്ത് പ്രസിഡൻ്റ്) നിർവഹിച്ചു. ശ്രി വി മോഹനൻ, ഗ്രാമപഞ്ചായത്ത് പ്രസിഡന്റ് അദ്ധ്യക്ഷത വഹിച്ച യോഗത്തിൽ രാഷ്ട്രീയ, സാമൂഹ്യ സാംസ്കാരിക രംഗത്തെ പ്രമുഖർ, ജനപ്രതിനിധികൾ തുടങ്ങിയവർ പങ്കെടുത്തു.  ക്യാമ്പിൽ 250-പ്പരം പേർ കാർഡിയോളജി  സ്ക്രീനീംഗന്  വിധേയമായി. ക്യാമ്പിൽ ഡയബറ്റോളജി, ജനറൽ മെഡിസിൻ,ഒഫ്ത്താൽമോളജി,ഡെൻറ്റൽ, സൗജന്യ എക്കോ, ഇ. സി. ജി, ബ്ലഡ് ഷുഗർ, ബ്ലഡ് പ്രഷർ, ബി എം ഐ ടെസ്റ്റുകൾ നടത്തി.",
      thumb: "assets/img/Pastevents/2588.jpeg",
    },
    {
      src: "assets/img/Pastevents/2574.jpeg",
      caption:
        "വിതുര ഫെസ്റ്റ് -2023ൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2574.jpeg",
    },
    {
      src: "assets/img/Pastevents/2575.jpeg",
      caption:
        "വിതുര ഫെസ്റ്റ് -2023ൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2575.jpeg",
    },
    {
      src: "assets/img/Pastevents/2576.jpeg",
      caption:
        "വിതുര ഫെസ്റ്റ് -2023ൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2576.jpeg",
    },
    {
      src: "assets/img/Pastevents/2577.jpeg",
      caption:
        "വിതുര ഫെസ്റ്റ് -2023ൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2577.jpeg",
    },
    {
      src: "assets/img/Pastevents/2578.jpeg",
      caption:
        "വിതുര ഫെസ്റ്റ് -2023ൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2578.jpeg",
    },
    {
      src: "assets/img/Pastevents/2567.jpeg",
      caption:
        "വിഴിഞ്ഞം ചിറയിക്കോട് റെസിഡൻഷ്യൽ അസോസിയേഷൻ,റ്റി എം സി കൗടിയാർ, ഡോ: എ പി ജെ പബ്ലിക് സ്കൂളിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2567.jpeg",
    },
    {
      src: "assets/img/Pastevents/2568.jpeg",
      caption:
        "വിഴിഞ്ഞം ചിറയിക്കോട് റെസിഡൻഷ്യൽ അസോസിയേഷൻ,റ്റി എം സി കൗടിയാർ, ഡോ: എ പി ജെ പബ്ലിക് സ്കൂളിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2568.jpeg",
    },
    {
      src: "assets/img/Pastevents/2569.jpeg",
      caption:
        "വിഴിഞ്ഞം ചിറയിക്കോട് റെസിഡൻഷ്യൽ അസോസിയേഷൻ,റ്റി എം സി കൗടിയാർ, ഡോ: എ പി ജെ പബ്ലിക് സ്കൂളിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2569.jpeg",
    },
    {
      src: "assets/img/Pastevents/2570.jpeg",
      caption:
        "വിഴിഞ്ഞം ചിറയിക്കോട് റെസിഡൻഷ്യൽ അസോസിയേഷൻ,റ്റി എം സി കൗടിയാർ, ഡോ: എ പി ജെ പബ്ലിക് സ്കൂളിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2570.jpeg",
    },
    {
      src: "assets/img/Pastevents/2571.jpeg",
      caption:
        "വിഴിഞ്ഞം ചിറയിക്കോട് റെസിഡൻഷ്യൽ അസോസിയേഷൻ,റ്റി എം സി കൗടിയാർ, ഡോ: എ പി ജെ പബ്ലിക് സ്കൂളിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2571.jpeg",
    },
    {
      src: "assets/img/Pastevents/2572.jpeg",
      caption:
        "വിഴിഞ്ഞം ചിറയിക്കോട് റെസിഡൻഷ്യൽ അസോസിയേഷൻ,റ്റി എം സി കൗടിയാർ, ഡോ: എ പി ജെ പബ്ലിക് സ്കൂളിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2572.jpeg",
    },
    {
      src: "assets/img/Pastevents/2573.jpeg",
      caption:
        "വിഴിഞ്ഞം ചിറയിക്കോട് റെസിഡൻഷ്യൽ അസോസിയേഷൻ,റ്റി എം സി കൗടിയാർ, ഡോ: എ പി ജെ പബ്ലിക് സ്കൂളിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2573.jpeg",
    },
    {
      src: "assets/img/Pastevents/2560.jpeg",
      caption:
        "ഇടയ്ക്കോട് കളത്തറക്കോണം കാവിൽ ദേവി ക്ഷേത്ര ട്രസ്റ്റ് , രൈൻബോ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2560.jpeg",
    },
    {
      src: "assets/img/Pastevents/2561.jpeg",
      caption:
        "ഇടയ്ക്കോട് കളത്തറക്കോണം കാവിൽ ദേവി ക്ഷേത്ര ട്രസ്റ്റ് , രൈൻബോ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2561.jpeg",
    },
    {
      src: "assets/img/Pastevents/2562.jpeg",
      caption:
        "ഇടയ്ക്കോട് കളത്തറക്കോണം കാവിൽ ദേവി ക്ഷേത്ര ട്രസ്റ്റ് , രൈൻബോ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2562.jpeg",
    },
    {
      src: "assets/img/Pastevents/2563.jpeg",
      caption:
        "ഇടയ്ക്കോട് കളത്തറക്കോണം കാവിൽ ദേവി ക്ഷേത്ര ട്രസ്റ്റ് , രൈൻബോ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2563.jpeg",
    },
    {
      src: "assets/img/Pastevents/2564.jpeg",
      caption:
        "ഇടയ്ക്കോട് കളത്തറക്കോണം കാവിൽ ദേവി ക്ഷേത്ര ട്രസ്റ്റ് , രൈൻബോ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2564.jpeg",
    },
    {
      src: "assets/img/Pastevents/2565.jpeg",
      caption:
        "ഇടയ്ക്കോട് കളത്തറക്കോണം കാവിൽ ദേവി ക്ഷേത്ര ട്രസ്റ്റ് , രൈൻബോ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2565.jpeg",
    },
    {
      src: "assets/img/Pastevents/2566.jpeg",
      caption:
        "ഇടയ്ക്കോട് കളത്തറക്കോണം കാവിൽ ദേവി ക്ഷേത്ര ട്രസ്റ്റ് , രൈൻബോ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2566.jpeg",
    },
    {
      src: "assets/img/Pastevents/2554.jpeg",
      caption:
        "മാടൻവിള ഫുട്ബോൾ അസോസിയേഷൻ,അനന്തപുരി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2554.jpeg",
    },
    {
      src: "assets/img/Pastevents/2555.jpeg",
      caption:
        "മാടൻവിള ഫുട്ബോൾ അസോസിയേഷൻ,അനന്തപുരി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2555.jpeg",
    },
    {
      src: "assets/img/Pastevents/2556.jpeg",
      caption:
        "മാടൻവിള ഫുട്ബോൾ അസോസിയേഷൻ,അനന്തപുരി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2556.jpeg",
    },
    {
      src: "assets/img/Pastevents/2557.jpeg",
      caption:
        "മാടൻവിള ഫുട്ബോൾ അസോസിയേഷൻ,അനന്തപുരി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2557.jpeg",
    },
    {
      src: "assets/img/Pastevents/2558.jpeg",
      caption:
        "മാടൻവിള ഫുട്ബോൾ അസോസിയേഷൻ,അനന്തപുരി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2558.jpeg",
    },
    {
      src: "assets/img/Pastevents/2559.jpeg",
      caption:
        "മാടൻവിള ഫുട്ബോൾ അസോസിയേഷൻ,അനന്തപുരി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2559.jpeg",
    },
    {
      src: "assets/img/Pastevents/2544.jpeg",
      caption:
        "ചൊവ്വര തേക്കേക്കോണം നാഗർക്കാവ് ദുർഗ്ഗ ദേവി ക്ഷേത്ര ട്രസ്റ്റ്, വിഴിഞ്ഞം ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2544.jpeg",
    },
    {
      src: "assets/img/Pastevents/2545.jpeg",
      caption:
        "ചൊവ്വര തേക്കേക്കോണം നാഗർക്കാവ് ദുർഗ്ഗ ദേവി ക്ഷേത്ര ട്രസ്റ്റ്, വിഴിഞ്ഞം ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2545.jpeg",
    },
    {
      src: "assets/img/Pastevents/2546.jpeg",
      caption:
        "ചൊവ്വര തേക്കേക്കോണം നാഗർക്കാവ് ദുർഗ്ഗ ദേവി ക്ഷേത്ര ട്രസ്റ്റ്, വിഴിഞ്ഞം ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2546.jpeg",
    },
    {
      src: "assets/img/Pastevents/2547.jpeg",
      caption:
        "ചൊവ്വര തേക്കേക്കോണം നാഗർക്കാവ് ദുർഗ്ഗ ദേവി ക്ഷേത്ര ട്രസ്റ്റ്, വിഴിഞ്ഞം ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2547.jpeg",
    },
    {
      src: "assets/img/Pastevents/2548.jpeg",
      caption:
        "ചൊവ്വര തേക്കേക്കോണം നാഗർക്കാവ് ദുർഗ്ഗ ദേവി ക്ഷേത്ര ട്രസ്റ്റ്, വിഴിഞ്ഞം ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2548.jpeg",
    },
    {
      src: "assets/img/Pastevents/2549.jpeg",
      caption:
        "ചൊവ്വര തേക്കേക്കോണം നാഗർക്കാവ് ദുർഗ്ഗ ദേവി ക്ഷേത്ര ട്രസ്റ്റ്, വിഴിഞ്ഞം ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2549.jpeg",
    },
    {
      src: "assets/img/Pastevents/2550.jpeg",
      caption:
        "ചൊവ്വര തേക്കേക്കോണം നാഗർക്കാവ് ദുർഗ്ഗ ദേവി ക്ഷേത്ര ട്രസ്റ്റ്, വിഴിഞ്ഞം ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2550.jpeg",
    },
    {
      src: "assets/img/Pastevents/2551.jpeg",
      caption:
        "ചൊവ്വര തേക്കേക്കോണം നാഗർക്കാവ് ദുർഗ്ഗ ദേവി ക്ഷേത്ര ട്രസ്റ്റ്, വിഴിഞ്ഞം ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2551.jpeg",
    },
    {
      src: "assets/img/Pastevents/2552.jpeg",
      caption:
        "ചൊവ്വര തേക്കേക്കോണം നാഗർക്കാവ് ദുർഗ്ഗ ദേവി ക്ഷേത്ര ട്രസ്റ്റ്, വിഴിഞ്ഞം ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2552.jpeg",
    },
    {
      src: "assets/img/Pastevents/2553.jpeg",
      caption:
        "ചൊവ്വര തേക്കേക്കോണം നാഗർക്കാവ് ദുർഗ്ഗ ദേവി ക്ഷേത്ര ട്രസ്റ്റ്, വിഴിഞ്ഞം ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2553.jpeg",
    },
    {
      src: "assets/img/Pastevents/2537.jpeg",
      caption:
        "മണ്ണടിക്കോണം പീപ്പിൾസ് ലൈബ്രറി, ട്രിവാൻഡ്രം റൈൻബോ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2537.jpeg",
    },
    {
      src: "assets/img/Pastevents/2538.jpeg",
      caption:
        "മണ്ണടിക്കോണം പീപ്പിൾസ് ലൈബ്രറി, ട്രിവാൻഡ്രം റൈൻബോ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2538.jpeg",
    },
    {
      src: "assets/img/Pastevents/2539.jpeg",
      caption:
        "മണ്ണടിക്കോണം പീപ്പിൾസ് ലൈബ്രറി, ട്രിവാൻഡ്രം റൈൻബോ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2539.jpeg",
    },
    {
      src: "assets/img/Pastevents/2540.jpeg",
      caption:
        "മണ്ണടിക്കോണം പീപ്പിൾസ് ലൈബ്രറി, ട്രിവാൻഡ്രം റൈൻബോ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2540.jpeg",
    },
    {
      src: "assets/img/Pastevents/2541.jpeg",
      caption:
        "മണ്ണടിക്കോണം പീപ്പിൾസ് ലൈബ്രറി, ട്രിവാൻഡ്രം റൈൻബോ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2541.jpeg",
    },
    {
      src: "assets/img/Pastevents/2542.jpeg",
      caption:
        "മണ്ണടിക്കോണം പീപ്പിൾസ് ലൈബ്രറി, ട്രിവാൻഡ്രം റൈൻബോ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2542.jpeg",
    },
    {
      src: "assets/img/Pastevents/2543.jpeg",
      caption:
        "മണ്ണടിക്കോണം പീപ്പിൾസ് ലൈബ്രറി, ട്രിവാൻഡ്രം റൈൻബോ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2543.jpeg",
    },
    {
      src: "assets/img/Pastevents/2531.jpeg",
      caption:
        " പളുകൽ ശ്രീ വെട്ടുപാറ മേലാംക്കോട് ദേവി ക്ഷേത്ര ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2531.jpeg",
    },
    {
      src: "assets/img/Pastevents/2532.jpeg",
      caption:
        " പളുകൽ ശ്രീ വെട്ടുപാറ മേലാംക്കോട് ദേവി ക്ഷേത്ര ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2532.jpeg",
    },
    {
      src: "assets/img/Pastevents/2533.jpeg",
      caption:
        " പളുകൽ ശ്രീ വെട്ടുപാറ മേലാംക്കോട് ദേവി ക്ഷേത്ര ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2533.jpeg",
    },
    {
      src: "assets/img/Pastevents/2534.jpeg",
      caption:
        " പളുകൽ ശ്രീ വെട്ടുപാറ മേലാംക്കോട് ദേവി ക്ഷേത്ര ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2534.jpeg",
    },
    {
      src: "assets/img/Pastevents/2535.jpeg",
      caption:
        " പളുകൽ ശ്രീ വെട്ടുപാറ മേലാംക്കോട് ദേവി ക്ഷേത്ര ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2535.jpeg",
    },
    {
      src: "assets/img/Pastevents/2536.jpeg",
      caption:
        " പളുകൽ ശ്രീ വെട്ടുപാറ മേലാംക്കോട് ദേവി ക്ഷേത്ര ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2536.jpeg",
    },
    {
      src: "assets/img/Pastevents/2524.jpeg",
      caption:
        "കമുകിൻകോട് ചങ്ങാതികൂട്ടം 97-  എസ്എസ്എൽസി ബാച്ചിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. മെഡിക്കൽ ക്യാമ്പ് ഉദ്ഘാടനം റവ.ഫാ.സജി തോമസ്. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2524.jpeg",
    },
    {
      src: "assets/img/Pastevents/2525.jpeg",
      caption:
        "കമുകിൻകോട് ചങ്ങാതികൂട്ടം 97-എസ്എസ്എൽസി ബാച്ചിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. മെഡിക്കൽ ക്യാമ്പ് ഉദ്ഘാടനം റവ.ഫാ.സജി തോമസ്. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2525.jpeg",
    },
    {
      src: "assets/img/Pastevents/2526.jpeg",
      caption:
        "കമുകിൻകോട് ചങ്ങാതികൂട്ടം 97-  എസ്എസ്എൽസി ബാച്ചിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. മെഡിക്കൽ ക്യാമ്പ് ഉദ്ഘാടനം റവ.ഫാ.സജി തോമസ്. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2526.jpeg",
    },
    {
      src: "assets/img/Pastevents/2527.jpeg",
      caption:
        "കമുകിൻകോട് ചങ്ങാതികൂട്ടം 97-  എസ്എസ്എൽസി ബാച്ചിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. മെഡിക്കൽ ക്യാമ്പ് ഉദ്ഘാടനം റവ.ഫാ.സജി തോമസ്. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2527.jpeg",
    },
    {
      src: "assets/img/Pastevents/2528.jpeg",
      caption:
        "കമുകിൻകോട് ചങ്ങാതികൂട്ടം 97-  എസ്എസ്എൽസി ബാച്ചിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. മെഡിക്കൽ ക്യാമ്പ് ഉദ്ഘാടനം റവ.ഫാ.സജി തോമസ്. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2528.jpeg",
    },
    {
      src: "assets/img/Pastevents/2529.jpeg",
      caption:
        "കമുകിൻകോട് ചങ്ങാതികൂട്ടം 97-  എസ്എസ്എൽസി ബാച്ചിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. മെഡിക്കൽ ക്യാമ്പ് ഉദ്ഘാടനം റവ.ഫാ.സജി തോമസ്. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2529.jpeg",
    },
    {
      src: "assets/img/Pastevents/2530.jpeg",
      caption:
        "കമുകിൻകോട് ചങ്ങാതികൂട്ടം 97-  എസ്എസ്എൽസി ബാച്ചിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. മെഡിക്കൽ ക്യാമ്പ് ഉദ്ഘാടനം റവ.ഫാ.സജി തോമസ്. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2530.jpeg",
    },
    {
      src: "assets/img/Pastevents/2516.jpeg",
      caption:
        "ആനപ്പാറ ഫോറസ്റ്റ് ഹാളിൽ വച്ച് നടന്ന ചടങ്ങിൽ  എന്റെ ഹൃദയം എന്റെ ഗ്രാമം ; സൗജന്യ ഹൃദ്രോഗ നിർണ്ണയ മെഗാ ക്യാമ്പിന്റെയും ബോധവത്ക്കരണത്തിൻ്റെയും ഉദ്ഘാടനം ശ്രീമതി അൻസജിത റസ്സേൽ (ജില്ലാ p പഞ്ചായത്ത് അംഗം) നിർവഹിച്ചു. ഗ്രാമപഞ്ചായത്ത് പ്രസിഡന്റ് അദ്ധ്യക്ഷത വഹിച്ച യോഗത്തിൽ രാഷ്ട്രീയ, സാമൂഹ്യ സാംസ്കാരിക രംഗത്തെ പ്രമുഖർ, ജനപ്രതിനിധികൾ തുടങ്ങിയവർ പങ്കെടുത്തു.  ക്യാമ്പിൽ 300-പ്പരം പേർ കാർഡിയോളജി  സ്ക്രീനീംഗന്  വിധേയമായി. ക്യാമ്പിൽ സൗജന്യ എക്കോ, ഇ. സി. ജി, ബ്ലഡ് ഷുഗർ, ബ്ലഡ് പ്രഷർ, ബി എം ഐ ടെസ്റ്റുകൾ നടത്തി.",
      thumb: "assets/img/Pastevents/2516.jpeg",
    },
    {
      src: "assets/img/Pastevents/2517.jpeg",
      caption:
        "ആനപ്പാറ ഫോറസ്റ്റ് ഹാളിൽ വച്ച് നടന്ന ചടങ്ങിൽ  എന്റെ ഹൃദയം എന്റെ ഗ്രാമം ; സൗജന്യ ഹൃദ്രോഗ നിർണ്ണയ മെഗാ ക്യാമ്പിന്റെയും ബോധവത്ക്കരണത്തിൻ്റെയും ഉദ്ഘാടനം ശ്രീമതി അൻസജിത റസ്സേൽ (ജില്ലാ p പഞ്ചായത്ത് അംഗം) നിർവഹിച്ചു. ഗ്രാമപഞ്ചായത്ത് പ്രസിഡന്റ് അദ്ധ്യക്ഷത വഹിച്ച യോഗത്തിൽ രാഷ്ട്രീയ, സാമൂഹ്യ സാംസ്കാരിക രംഗത്തെ പ്രമുഖർ, ജനപ്രതിനിധികൾ തുടങ്ങിയവർ പങ്കെടുത്തു.  ക്യാമ്പിൽ 300-പ്പരം പേർ കാർഡിയോളജി  സ്ക്രീനീംഗന്  വിധേയമായി. ക്യാമ്പിൽ സൗജന്യ എക്കോ, ഇ. സി. ജി, ബ്ലഡ് ഷുഗർ, ബ്ലഡ് പ്രഷർ, ബി എം ഐ ടെസ്റ്റുകൾ നടത്തി.",
      thumb: "assets/img/Pastevents/2517.jpeg",
    },
    {
      src: "assets/img/Pastevents/2518.jpeg",
      caption:
        "ആനപ്പാറ ഫോറസ്റ്റ് ഹാളിൽ വച്ച് നടന്ന ചടങ്ങിൽ  എന്റെ ഹൃദയം എന്റെ ഗ്രാമം ; സൗജന്യ ഹൃദ്രോഗ നിർണ്ണയ മെഗാ ക്യാമ്പിന്റെയും ബോധവത്ക്കരണത്തിൻ്റെയും ഉദ്ഘാടനം ശ്രീമതി അൻസജിത റസ്സേൽ (ജില്ലാ p പഞ്ചായത്ത് അംഗം) നിർവഹിച്ചു. ഗ്രാമപഞ്ചായത്ത് പ്രസിഡന്റ് അദ്ധ്യക്ഷത വഹിച്ച യോഗത്തിൽ രാഷ്ട്രീയ, സാമൂഹ്യ സാംസ്കാരിക രംഗത്തെ പ്രമുഖർ, ജനപ്രതിനിധികൾ തുടങ്ങിയവർ പങ്കെടുത്തു.  ക്യാമ്പിൽ 300-പ്പരം പേർ കാർഡിയോളജി  സ്ക്രീനീംഗന്  വിധേയമായി. ക്യാമ്പിൽ സൗജന്യ എക്കോ, ഇ. സി. ജി, ബ്ലഡ് ഷുഗർ, ബ്ലഡ് പ്രഷർ, ബി എം ഐ ടെസ്റ്റുകൾ നടത്തി.",
      thumb: "assets/img/Pastevents/2518.jpeg",
    },
    {
      src: "assets/img/Pastevents/2519.jpeg",
      caption:
        "ആനപ്പാറ ഫോറസ്റ്റ് ഹാളിൽ വച്ച് നടന്ന ചടങ്ങിൽ  എന്റെ ഹൃദയം എന്റെ ഗ്രാമം ; സൗജന്യ ഹൃദ്രോഗ നിർണ്ണയ മെഗാ ക്യാമ്പിന്റെയും ബോധവത്ക്കരണത്തിൻ്റെയും ഉദ്ഘാടനം ശ്രീമതി അൻസജിത റസ്സേൽ (ജില്ലാ p പഞ്ചായത്ത് അംഗം) നിർവഹിച്ചു. ഗ്രാമപഞ്ചായത്ത് പ്രസിഡന്റ് അദ്ധ്യക്ഷത വഹിച്ച യോഗത്തിൽ രാഷ്ട്രീയ, സാമൂഹ്യ സാംസ്കാരിക രംഗത്തെ പ്രമുഖർ, ജനപ്രതിനിധികൾ തുടങ്ങിയവർ പങ്കെടുത്തു.  ക്യാമ്പിൽ 300-പ്പരം പേർ കാർഡിയോളജി  സ്ക്രീനീംഗന്  വിധേയമായി. ക്യാമ്പിൽ സൗജന്യ എക്കോ, ഇ. സി. ജി, ബ്ലഡ് ഷുഗർ, ബ്ലഡ് പ്രഷർ, ബി എം ഐ ടെസ്റ്റുകൾ നടത്തി.",
      thumb: "assets/img/Pastevents/2519.jpeg",
    },
    {
      src: "assets/img/Pastevents/2520.jpeg",
      caption:
        "ആനപ്പാറ ഫോറസ്റ്റ് ഹാളിൽ വച്ച് നടന്ന ചടങ്ങിൽ  എന്റെ ഹൃദയം എന്റെ ഗ്രാമം ; സൗജന്യ ഹൃദ്രോഗ നിർണ്ണയ മെഗാ ക്യാമ്പിന്റെയും ബോധവത്ക്കരണത്തിൻ്റെയും ഉദ്ഘാടനം ശ്രീമതി അൻസജിത റസ്സേൽ (ജില്ലാ p പഞ്ചായത്ത് അംഗം) നിർവഹിച്ചു. ഗ്രാമപഞ്ചായത്ത് പ്രസിഡന്റ് അദ്ധ്യക്ഷത വഹിച്ച യോഗത്തിൽ രാഷ്ട്രീയ, സാമൂഹ്യ സാംസ്കാരിക രംഗത്തെ പ്രമുഖർ, ജനപ്രതിനിധികൾ തുടങ്ങിയവർ പങ്കെടുത്തു.  ക്യാമ്പിൽ 300-പ്പരം പേർ കാർഡിയോളജി  സ്ക്രീനീംഗന്  വിധേയമായി. ക്യാമ്പിൽ സൗജന്യ എക്കോ, ഇ. സി. ജി, ബ്ലഡ് ഷുഗർ, ബ്ലഡ് പ്രഷർ, ബി എം ഐ ടെസ്റ്റുകൾ നടത്തി.",
      thumb: "assets/img/Pastevents/2520.jpeg",
    },
    {
      src: "assets/img/Pastevents/2521.jpeg",
      caption:
        "ആനപ്പാറ ഫോറസ്റ്റ് ഹാളിൽ വച്ച് നടന്ന ചടങ്ങിൽ  എന്റെ ഹൃദയം എന്റെ ഗ്രാമം ; സൗജന്യ ഹൃദ്രോഗ നിർണ്ണയ മെഗാ ക്യാമ്പിന്റെയും ബോധവത്ക്കരണത്തിൻ്റെയും ഉദ്ഘാടനം ശ്രീമതി അൻസജിത റസ്സേൽ (ജില്ലാ p പഞ്ചായത്ത് അംഗം) നിർവഹിച്ചു. ഗ്രാമപഞ്ചായത്ത് പ്രസിഡന്റ് അദ്ധ്യക്ഷത വഹിച്ച യോഗത്തിൽ രാഷ്ട്രീയ, സാമൂഹ്യ സാംസ്കാരിക രംഗത്തെ പ്രമുഖർ, ജനപ്രതിനിധികൾ തുടങ്ങിയവർ പങ്കെടുത്തു.  ക്യാമ്പിൽ 300-പ്പരം പേർ കാർഡിയോളജി  സ്ക്രീനീംഗന്  വിധേയമായി. ക്യാമ്പിൽ സൗജന്യ എക്കോ, ഇ. സി. ജി, ബ്ലഡ് ഷുഗർ, ബ്ലഡ് പ്രഷർ, ബി എം ഐ ടെസ്റ്റുകൾ നടത്തി.",
      thumb: "assets/img/Pastevents/2521.jpeg",
    },
    {
      src: "assets/img/Pastevents/2522.jpeg",
      caption:
        "ആനപ്പാറ ഫോറസ്റ്റ് ഹാളിൽ വച്ച് നടന്ന ചടങ്ങിൽ  എന്റെ ഹൃദയം എന്റെ ഗ്രാമം ; സൗജന്യ ഹൃദ്രോഗ നിർണ്ണയ മെഗാ ക്യാമ്പിന്റെയും ബോധവത്ക്കരണത്തിൻ്റെയും ഉദ്ഘാടനം ശ്രീമതി അൻസജിത റസ്സേൽ (ജില്ലാ p പഞ്ചായത്ത് അംഗം) നിർവഹിച്ചു. ഗ്രാമപഞ്ചായത്ത് പ്രസിഡന്റ് അദ്ധ്യക്ഷത വഹിച്ച യോഗത്തിൽ രാഷ്ട്രീയ, സാമൂഹ്യ സാംസ്കാരിക രംഗത്തെ പ്രമുഖർ, ജനപ്രതിനിധികൾ തുടങ്ങിയവർ പങ്കെടുത്തു.  ക്യാമ്പിൽ 300-പ്പരം പേർ കാർഡിയോളജി  സ്ക്രീനീംഗന്  വിധേയമായി. ക്യാമ്പിൽ സൗജന്യ എക്കോ, ഇ. സി. ജി, ബ്ലഡ് ഷുഗർ, ബ്ലഡ് പ്രഷർ, ബി എം ഐ ടെസ്റ്റുകൾ നടത്തി.",
      thumb: "assets/img/Pastevents/2522.jpeg",
    },
    {
      src: "assets/img/Pastevents/2523.jpeg",
      caption:
        "ആനപ്പാറ ഫോറസ്റ്റ് ഹാളിൽ വച്ച് നടന്ന ചടങ്ങിൽ  എന്റെ ഹൃദയം എന്റെ ഗ്രാമം ; സൗജന്യ ഹൃദ്രോഗ നിർണ്ണയ മെഗാ ക്യാമ്പിന്റെയും ബോധവത്ക്കരണത്തിൻ്റെയും ഉദ്ഘാടനം ശ്രീമതി അൻസജിത റസ്സേൽ (ജില്ലാ p പഞ്ചായത്ത് അംഗം) നിർവഹിച്ചു. ഗ്രാമപഞ്ചായത്ത് പ്രസിഡന്റ് അദ്ധ്യക്ഷത വഹിച്ച യോഗത്തിൽ രാഷ്ട്രീയ, സാമൂഹ്യ സാംസ്കാരിക രംഗത്തെ പ്രമുഖർ, ജനപ്രതിനിധികൾ തുടങ്ങിയവർ പങ്കെടുത്തു.  ക്യാമ്പിൽ 300-പ്പരം പേർ കാർഡിയോളജി  സ്ക്രീനീംഗന്  വിധേയമായി. ക്യാമ്പിൽ സൗജന്യ എക്കോ, ഇ. സി. ജി, ബ്ലഡ് ഷുഗർ, ബ്ലഡ് പ്രഷർ, ബി എം ഐ ടെസ്റ്റുകൾ നടത്തി.",
      thumb: "assets/img/Pastevents/2523.jpeg",
    },
    {
      src: "assets/img/Pastevents/2509.jpeg",
      caption:
        "KSRTC ആരംഭിച്ച ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 100-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2509.jpeg",
    },
    {
      src: "assets/img/Pastevents/2510.jpeg",
      caption:
        "KSRTC ആരംഭിച്ച ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 100-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2510.jpeg",
    },
    {
      src: "assets/img/Pastevents/2511.jpeg",
      caption:
        "KSRTC ആരംഭിച്ച ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 100-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2511.jpeg",
    },
    {
      src: "assets/img/Pastevents/2512.jpeg",
      caption:
        "KSRTC ആരംഭിച്ച ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 100-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2512.jpeg",
    },
    {
      src: "assets/img/Pastevents/2513.jpeg",
      caption:
        "KSRTC ആരംഭിച്ച ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 100-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2513.jpeg",
    },
    {
      src: "assets/img/Pastevents/2514.jpeg",
      caption:
        "KSRTC ആരംഭിച്ച ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 100-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2514.jpeg",
    },
    {
      src: "assets/img/Pastevents/2515.jpeg",
      caption:
        "KSRTC ആരംഭിച്ച ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 100-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2515.jpeg",
    },
    {
      src: "assets/img/Pastevents/2503.jpeg",
      caption:
        "പിരപ്പൻകോട് കാവിയാട് ദിനകര പണിക്കർ സാംസ്കാരിക വേദിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2503.jpeg",
    },
    {
      src: "assets/img/Pastevents/2504.jpeg",
      caption:
        "പിരപ്പൻകോട് കാവിയാട് ദിനകര പണിക്കർ സാംസ്കാരിക വേദിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2504.jpeg",
    },
    {
      src: "assets/img/Pastevents/25055.jpeg",
      caption:
        "പിരപ്പൻകോട് കാവിയാട് ദിനകര പണിക്കർ സാംസ്കാരിക വേദിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2505.jpeg",
    },
    {
      src: "assets/img/Pastevents/2506.jpeg",
      caption:
        "പിരപ്പൻകോട് കാവിയാട് ദിനകര പണിക്കർ സാംസ്കാരിക വേദിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2506.jpeg",
    },
    {
      src: "assets/img/Pastevents/2507.jpeg",
      caption:
        "പിരപ്പൻകോട് കാവിയാട് ദിനകര പണിക്കർ സാംസ്കാരിക വേദിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2507.jpeg",
    },
    {
      src: "assets/img/Pastevents/2508.jpeg",
      caption:
        "പിരപ്പൻകോട് കാവിയാട് ദിനകര പണിക്കർ സാംസ്കാരിക വേദിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2508.jpeg",
    },
    {
      src: "assets/img/Pastevents/2497.jpeg",
      caption:
        "ചാലിയോട് ശ്രീ അയ്യപ്പ സേവാ സംഘം,ശ്രീ മാളോട്ട് ശ്രീ ഭദ്രകാളി ദിക്ക്ബലി മഹോത്സവത്തോട് അനുബന്ധിച്ച് നിംസ് മെഡിസിറ്റിയുടെയും  ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2497.jpeg",
    },
    {
      src: "assets/img/Pastevents/2498.jpeg",
      caption:
        "ചാലിയോട് ശ്രീ അയ്യപ്പ സേവാ സംഘം,ശ്രീ മാളോട്ട് ശ്രീ ഭദ്രകാളി ദിക്ക്ബലി മഹോത്സവത്തോട് അനുബന്ധിച്ച് നിംസ് മെഡിസിറ്റിയുടെയും  ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2498.jpeg",
    },
    {
      src: "assets/img/Pastevents/2499.jpeg",
      caption:
        "ചാലിയോട് ശ്രീ അയ്യപ്പ സേവാ സംഘം,ശ്രീ മാളോട്ട് ശ്രീ ഭദ്രകാളി ദിക്ക്ബലി മഹോത്സവത്തോട് അനുബന്ധിച്ച് നിംസ് മെഡിസിറ്റിയുടെയും  ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2499.jpeg",
    },
    {
      src: "assets/img/Pastevents/2500.jpeg",
      caption:
        "ചാലിയോട് ശ്രീ അയ്യപ്പ സേവാ സംഘം,ശ്രീ മാളോട്ട് ശ്രീ ഭദ്രകാളി ദിക്ക്ബലി മഹോത്സവത്തോട് അനുബന്ധിച്ച് നിംസ് മെഡിസിറ്റിയുടെയും  ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2500.jpeg",
    },
    {
      src: "assets/img/Pastevents/2501.jpeg",
      caption:
        "ചാലിയോട് ശ്രീ അയ്യപ്പ സേവാ സംഘം,ശ്രീ മാളോട്ട് ശ്രീ ഭദ്രകാളി ദിക്ക്ബലി മഹോത്സവത്തോട് അനുബന്ധിച്ച് നിംസ് മെഡിസിറ്റിയുടെയും  ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2501.jpeg",
    },
    {
      src: "assets/img/Pastevents/2502.jpeg",
      caption:
        "ചാലിയോട് ശ്രീ അയ്യപ്പ സേവാ സംഘം,ശ്രീ മാളോട്ട് ശ്രീ ഭദ്രകാളി ദിക്ക്ബലി മഹോത്സവത്തോട് അനുബന്ധിച്ച് നിംസ് മെഡിസിറ്റിയുടെയും  ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2502.jpeg",
    },
    {
      src: "assets/img/Pastevents/2489.jpeg",
      caption:
        "മാങ്കോട്ടുക്കോണം ഗുരു മന്ദിരത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2489.jpeg",
    },
    {
      src: "assets/img/Pastevents/2490.jpeg",
      caption:
        "മാങ്കോട്ടുക്കോണം ഗുരു മന്ദിരത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2490.jpeg",
    },
    {
      src: "assets/img/Pastevents/2491.jpeg",
      caption:
        "മാങ്കോട്ടുക്കോണം ഗുരു മന്ദിരത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2491.jpeg",
    },
    {
      src: "assets/img/Pastevents/2492.jpeg",
      caption:
        "മാങ്കോട്ടുക്കോണം ഗുരു മന്ദിരത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2492.jpeg",
    },
    {
      src: "assets/img/Pastevents/2493.jpeg",
      caption:
        "മാങ്കോട്ടുക്കോണം ഗുരു മന്ദിരത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2493.jpeg",
    },
    {
      src: "assets/img/Pastevents/2494.jpeg",
      caption:
        "മാങ്കോട്ടുക്കോണം ഗുരു മന്ദിരത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2494.jpeg",
    },
    {
      src: "assets/img/Pastevents/2495.jpeg",
      caption:
        "മാങ്കോട്ടുക്കോണം ഗുരു മന്ദിരത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2495.jpeg",
    },
    {
      src: "assets/img/Pastevents/2496.jpeg",
      caption:
        "മാങ്കോട്ടുക്കോണം ഗുരു മന്ദിരത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2496.jpeg",
    },
    {
      src: "assets/img/Pastevents/2482.jpeg",
      caption:
        "കള്ളിക്കാട് ശ്രീ കാലാട്ട് മാടൻ തമ്പുരാൻ ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2482.jpeg",
    },
    {
      src: "assets/img/Pastevents/2483.jpeg",
      caption:
        "കള്ളിക്കാട് ശ്രീ കാലാട്ട് മാടൻ തമ്പുരാൻ ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2483.jpeg",
    },
    {
      src: "assets/img/Pastevents/2484.jpeg",
      caption:
        "കള്ളിക്കാട് ശ്രീ കാലാട്ട് മാടൻ തമ്പുരാൻ ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2484.jpeg",
    },
    {
      src: "assets/img/Pastevents/2485.jpeg",
      caption:
        "കള്ളിക്കാട് ശ്രീ കാലാട്ട് മാടൻ തമ്പുരാൻ ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2485.jpeg",
    },
    {
      src: "assets/img/Pastevents/2486.jpeg",
      caption:
        "കള്ളിക്കാട് ശ്രീ കാലാട്ട് മാടൻ തമ്പുരാൻ ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2486.jpeg",
    },
    {
      src: "assets/img/Pastevents/2487.jpeg",
      caption:
        "കള്ളിക്കാട് ശ്രീ കാലാട്ട് മാടൻ തമ്പുരാൻ ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2487.jpeg",
    },
    {
      src: "assets/img/Pastevents/2488.jpeg",
      caption:
        "കള്ളിക്കാട് ശ്രീ കാലാട്ട് മാടൻ തമ്പുരാൻ ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2488.jpeg",
    },
    {
      src: "assets/img/Pastevents/2475.jpeg",
      caption:
        "ധനുവച്ചപുരം മലങ്കര സിറിയൻ കാത്തോലിക് ചർച്ചിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2475.jpeg",
    },
    {
      src: "assets/img/Pastevents/2476.jpeg",
      caption:
        "ധനുവച്ചപുരം മലങ്കര സിറിയൻ കാത്തോലിക് ചർച്ചിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2476.jpeg",
    },
    {
      src: "assets/img/Pastevents/2477.jpeg",
      caption:
        "ധനുവച്ചപുരം മലങ്കര സിറിയൻ കാത്തോലിക് ചർച്ചിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2477.jpeg",
    },
    {
      src: "assets/img/Pastevents/2478.jpeg",
      caption:
        "ധനുവച്ചപുരം മലങ്കര സിറിയൻ കാത്തോലിക് ചർച്ചിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2478.jpeg",
    },
    {
      src: "assets/img/Pastevents/2479.jpeg",
      caption:
        "ധനുവച്ചപുരം മലങ്കര സിറിയൻ കാത്തോലിക് ചർച്ചിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2479.jpeg",
    },
    {
      src: "assets/img/Pastevents/2480.jpeg",
      caption:
        "ധനുവച്ചപുരം മലങ്കര സിറിയൻ കാത്തോലിക് ചർച്ചിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2480.jpeg",
    },
    {
      src: "assets/img/Pastevents/2481.jpeg",
      caption:
        "ധനുവച്ചപുരം മലങ്കര സിറിയൻ കാത്തോലിക് ചർച്ചിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2481.jpeg",
    },
    {
      src: "assets/img/Pastevents/2468.jpeg",
      caption:
        "ഊരുട്ടമ്പലം മറുകിൽ വാർഡ്, തിരുവനന്തപുരം നോവ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2468.jpeg",
    },
    {
      src: "assets/img/Pastevents/2469.jpeg",
      caption:
        "ഊരുട്ടമ്പലം മറുകിൽ വാർഡ്, തിരുവനന്തപുരം നോവ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2469.jpeg",
    },
    {
      src: "assets/img/Pastevents/2470.jpeg",
      caption:
        "ഊരുട്ടമ്പലം മറുകിൽ വാർഡ്, തിരുവനന്തപുരം നോവ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2470.jpeg",
    },
    {
      src: "assets/img/Pastevents/2471.jpeg",
      caption:
        "ഊരുട്ടമ്പലം മറുകിൽ വാർഡ്, തിരുവനന്തപുരം നോവ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      thumb: "assets/img/Pastevents/247.jpeg",
    },
    {
      src: "assets/img/Pastevents/2472.jpeg",
      caption:
        "ഊരുട്ടമ്പലം മറുകിൽ വാർഡ്, തിരുവനന്തപുരം നോവ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2472.jpeg",
    },
    {
      src: "assets/img/Pastevents/2473.jpeg",
      caption:
        "ഊരുട്ടമ്പലം മറുകിൽ വാർഡ്, തിരുവനന്തപുരം നോവ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2473.jpeg",
    },
    {
      src: "assets/img/Pastevents/2474.jpeg",
      caption:
        "ഊരുട്ടമ്പലം മറുകിൽ വാർഡ്, തിരുവനന്തപുരം നോവ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2474.jpeg",
    },
    {
      src: "assets/img/Pastevents/2462.jpeg",
      caption:
        "മഞ്ഞംകുഴി ശ്രീ ഗണപതി ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2462.jpeg",
    },
    {
      src: "assets/img/Pastevents/2463.jpeg",
      caption:
        "മഞ്ഞംകുഴി ശ്രീ ഗണപതി ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2463.jpeg",
    },
    {
      src: "assets/img/Pastevents/2464.jpeg",
      caption:
        "മഞ്ഞംകുഴി ശ്രീ ഗണപതി ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2464.jpeg",
    },
    {
      src: "assets/img/Pastevents/2465.jpeg",
      caption:
        "മഞ്ഞംകുഴി ശ്രീ ഗണപതി ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2465.jpeg",
    },
    {
      src: "assets/img/Pastevents/2466.jpeg",
      caption:
        "മഞ്ഞംകുഴി ശ്രീ ഗണപതി ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2466.jpeg",
    },
    {
      src: "assets/img/Pastevents/2467.jpeg",
      caption:
        "മഞ്ഞംകുഴി ശ്രീ ഗണപതി ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2467.jpeg",
    },
    {
      src: "assets/img/Pastevents/2454.jpeg",
      caption:
        "മഠത്തുവിളാകം റെസിഡൻഷ്യൽ അസോസിയേഷൻ, പേരൂർക്കട ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2454.jpeg",
    },
    {
      src: "assets/img/Pastevents/2455.jpeg",
      caption:
        "മഠത്തുവിളാകം റെസിഡൻഷ്യൽ അസോസിയേഷൻ, പേരൂർക്കട ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2455.jpeg",
    },
    {
      src: "assets/img/Pastevents/2456.jpeg",
      caption:
        "മഠത്തുവിളാകം റെസിഡൻഷ്യൽ അസോസിയേഷൻ, പേരൂർക്കട ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2456.jpeg",
    },
    {
      src: "assets/img/Pastevents/2457.jpeg",
      caption:
        "മഠത്തുവിളാകം റെസിഡൻഷ്യൽ അസോസിയേഷൻ, പേരൂർക്കട ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2457.jpeg",
    },
    {
      src: "assets/img/Pastevents/2458.jpeg",
      caption:
        "മഠത്തുവിളാകം റെസിഡൻഷ്യൽ അസോസിയേഷൻ, പേരൂർക്കട ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2458.jpeg",
    },
    {
      src: "assets/img/Pastevents/2459.jpeg",
      caption:
        "മഠത്തുവിളാകം റെസിഡൻഷ്യൽ അസോസിയേഷൻ, പേരൂർക്കട ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2459.jpeg",
    },
    {
      src: "assets/img/Pastevents/2460.jpeg",
      caption:
        "മഠത്തുവിളാകം റെസിഡൻഷ്യൽ അസോസിയേഷൻ, പേരൂർക്കട ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2460.jpeg",
    },
    {
      src: "assets/img/Pastevents/2461.jpeg",
      caption:
        "മഠത്തുവിളാകം റെസിഡൻഷ്യൽ അസോസിയേഷൻ, പേരൂർക്കട ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2461.jpeg",
    },
    {
      src: "assets/img/Pastevents/2448.jpeg",
      caption:
        "ആനാവൂർ തൂലിക ഫുട്ബോൾ ക്ലബ്, ആനാവൂർ ശ്രീ ഭദ്രകാളി ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2448.jpeg",
    },
    {
      src: "assets/img/Pastevents/2449.jpeg",
      caption:
        "ആനാവൂർ തൂലിക ഫുട്ബോൾ ക്ലബ്, ആനാവൂർ ശ്രീ ഭദ്രകാളി ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2449.jpeg",
    },
    {
      src: "assets/img/Pastevents/2450.jpeg",
      caption:
        "ആനാവൂർ തൂലിക ഫുട്ബോൾ ക്ലബ്, ആനാവൂർ ശ്രീ ഭദ്രകാളി ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2450.jpeg",
    },
    {
      src: "assets/img/Pastevents/2451.jpeg",
      caption:
        "ആനാവൂർ തൂലിക ഫുട്ബോൾ ക്ലബ്, ആനാവൂർ ശ്രീ ഭദ്രകാളി ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2451.jpeg",
    },
    {
      src: "assets/img/Pastevents/2452.jpeg",
      caption:
        "ആനാവൂർ തൂലിക ഫുട്ബോൾ ക്ലബ്, ആനാവൂർ ശ്രീ ഭദ്രകാളി ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2452.jpeg",
    },
    {
      src: "assets/img/Pastevents/2453.jpeg",
      caption:
        "ആനാവൂർ തൂലിക ഫുട്ബോൾ ക്ലബ്, ആനാവൂർ ശ്രീ ഭദ്രകാളി ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2453.jpeg",
    },

    {
      src: "assets/img/Pastevents/2441.jpeg",
      caption:
        "നീരോട്ടുക്കോണം ശ്രീ സുബ്രമണ്യസ്വാമി ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2441.jpeg",
    },
    {
      src: "assets/img/Pastevents/2442.jpeg",
      caption:
        "നീരോട്ടുക്കോണം ശ്രീ സുബ്രമണ്യസ്വാമി ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2442.jpeg",
    },
    {
      src: "assets/img/Pastevents/2443.jpeg",
      caption:
        "നീരോട്ടുക്കോണം ശ്രീ സുബ്രമണ്യസ്വാമി ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2443.jpeg",
    },
    {
      src: "assets/img/Pastevents/244.jpeg",
      caption:
        "നീരോട്ടുക്കോണം ശ്രീ സുബ്രമണ്യസ്വാമി ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      thumb: "assets/img/Pastevents/244.jpeg",
    },
    {
      src: "assets/img/Pastevents/2444.jpeg",
      caption:
        "നീരോട്ടുക്കോണം ശ്രീ സുബ്രമണ്യസ്വാമി ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2444.jpeg",
    },
    {
      src: "assets/img/Pastevents/2445.jpeg",
      caption:
        "നീരോട്ടുക്കോണം ശ്രീ സുബ്രമണ്യസ്വാമി ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2445.jpeg",
    },
    {
      src: "assets/img/Pastevents/2446.jpeg",
      caption:
        "നീരോട്ടുക്കോണം ശ്രീ സുബ്രമണ്യസ്വാമി ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2446.jpeg",
    },
    {
      src: "assets/img/Pastevents/2447.jpeg",
      caption:
        "നീരോട്ടുക്കോണം ശ്രീ സുബ്രമണ്യസ്വാമി ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2447.jpeg",
    },
    {
      src: "assets/img/Pastevents/2434.jpeg",
      caption:
        "നിലമാമ്മൂട് ശ്രീ ഈശ്വരകാല ഭൂതത്താൻ ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2434.jpeg",
    },
    {
      src: "assets/img/Pastevents/2435.jpeg",
      caption:
        "നിലമാമ്മൂട് ശ്രീ ഈശ്വരകാല ഭൂതത്താൻ ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2435.jpeg",
    },
    {
      src: "assets/img/Pastevents/2436.jpeg",
      caption:
        "നിലമാമ്മൂട് ശ്രീ ഈശ്വരകാല ഭൂതത്താൻ ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2436.jpeg",
    },
    {
      src: "assets/img/Pastevents/2437.jpeg",
      caption:
        "നിലമാമ്മൂട് ശ്രീ ഈശ്വരകാല ഭൂതത്താൻ ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2437.jpeg",
    },
    {
      src: "assets/img/Pastevents/2438.jpeg",
      caption:
        "നിലമാമ്മൂട് ശ്രീ ഈശ്വരകാല ഭൂതത്താൻ ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2438.jpeg",
    },
    {
      src: "assets/img/Pastevents/2439.jpeg",
      caption:
        "നിലമാമ്മൂട് ശ്രീ ഈശ്വരകാല ഭൂതത്താൻ ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2439.jpeg",
    },
    {
      src: "assets/img/Pastevents/2440.jpeg",
      caption:
        "നിലമാമ്മൂട് ശ്രീ ഈശ്വരകാല ഭൂതത്താൻ ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2440.jpeg",
    },
    {
      src: "assets/img/Pastevents/2429.jpeg",
      caption:
        "കരിക്കകം പൊങ്കാല മഹോത്സവത്തോട് അനുബന്ധിച്ച് കരിക്കകത്തമ്മ സേവാ സമിതിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/2429.jpeg",
    },
    {
      src: "assets/img/Pastevents/2430.jpeg",
      caption:
        "കരിക്കകം പൊങ്കാല മഹോത്സവത്തോട് അനുബന്ധിച്ച് കരിക്കകത്തമ്മ സേവാ സമിതിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/2430.jpeg",
    },
    {
      src: "assets/img/Pastevents/2431.jpeg",
      caption:
        "കരിക്കകം പൊങ്കാല മഹോത്സവത്തോട് അനുബന്ധിച്ച് കരിക്കകത്തമ്മ സേവാ സമിതിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/2431.jpeg",
    },
    {
      src: "assets/img/Pastevents/2432.jpeg",
      caption:
        "കരിക്കകം പൊങ്കാല മഹോത്സവത്തോട് അനുബന്ധിച്ച് കരിക്കകത്തമ്മ സേവാ സമിതിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/2432.jpeg",
    },
    {
      src: "assets/img/Pastevents/2433.jpeg",
      caption:
        "കരിക്കകം പൊങ്കാല മഹോത്സവത്തോട് അനുബന്ധിച്ച് കരിക്കകത്തമ്മ സേവാ സമിതിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/2433.jpeg",
    },
    {
      src: "assets/img/Pastevents/2424.jpeg",
      caption:
        "ആലറ ദേവി ക്ഷേത്ര ട്രസ്റ്റ്, സേവാ ഭാരതി നെയ്യാറ്റിൻകര യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/2424.jpeg",
    },
    {
      src: "assets/img/Pastevents/2428.jpeg",
      caption:
        "ആലറ ദേവി ക്ഷേത്ര ട്രസ്റ്റ്, സേവാ ഭാരതി നെയ്യാറ്റിൻകര യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/2428.jpeg",
    },
    {
      src: "assets/img/Pastevents/2427.jpeg",
      caption:
        "ആലറ ദേവി ക്ഷേത്ര ട്രസ്റ്റ്, സേവാ ഭാരതി നെയ്യാറ്റിൻകര യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/2427.jpeg",
    },
    {
      src: "assets/img/Pastevents/2426.jpeg",
      caption:
        "ആലറ ദേവി ക്ഷേത്ര ട്രസ്റ്റ്, സേവാ ഭാരതി നെയ്യാറ്റിൻകര യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/2426.jpeg",
    },
    {
      src: "assets/img/Pastevents/2425.jpeg",
      caption:
        "ആലറ ദേവി ക്ഷേത്ര ട്രസ്റ്റ്, സേവാ ഭാരതി നെയ്യാറ്റിൻകര യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/2425.jpeg",
    },
    {
      src: "assets/img/Pastevents/2418.jpeg",
      caption:
        "ആശുപത്രി സംരക്ഷണ സമിതിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2418.jpeg",
    },
    {
      src: "assets/img/Pastevents/2419.jpeg",
      caption:
        "ആശുപത്രി സംരക്ഷണ സമിതിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2419.jpeg",
    },
    {
      src: "assets/img/Pastevents/2420.jpeg",
      caption:
        "ആശുപത്രി സംരക്ഷണ സമിതിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2420.jpeg",
    },
    {
      src: "assets/img/Pastevents/2421.jpeg",
      caption:
        "ആശുപത്രി സംരക്ഷണ സമിതിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2421.jpeg",
    },
    {
      src: "assets/img/Pastevents/2422.jpeg",
      caption:
        "ആശുപത്രി സംരക്ഷണ സമിതിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2422.jpeg",
    },
    {
      src: "assets/img/Pastevents/2423.jpeg",
      caption:
        "ആശുപത്രി സംരക്ഷണ സമിതിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2423.jpeg",
    },
    {
      src: "assets/img/Pastevents/2413.jpeg",
      caption:
        "കേരളാ കൗമുദി പാലോട് യൂണിറ്റ്,ബോധപൗർണമി ക്ലബ്, പച്ച ശ്രീ ധർമ്മശാസ്താ ക്ഷേത്ര ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2413.jpeg",
    },
    {
      src: "assets/img/Pastevents/2414.jpeg",
      caption:
        "കേരളാ കൗമുദി പാലോട് യൂണിറ്റ്,ബോധപൗർണമി ക്ലബ്, പച്ച ശ്രീ ധർമ്മശാസ്താ ക്ഷേത്ര ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2414.jpeg",
    },
    {
      src: "assets/img/Pastevents/2415.jpeg",
      caption:
        "കേരളാ കൗമുദി പാലോട് യൂണിറ്റ്,ബോധപൗർണമി ക്ലബ്, പച്ച ശ്രീ ധർമ്മശാസ്താ ക്ഷേത്ര ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2415.jpeg",
    },
    {
      src: "assets/img/Pastevents/2416.jpeg",
      caption:
        "കേരളാ കൗമുദി പാലോട് യൂണിറ്റ്,ബോധപൗർണമി ക്ലബ്, പച്ച ശ്രീ ധർമ്മശാസ്താ ക്ഷേത്ര ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2416.jpeg",
    },
    {
      src: "assets/img/Pastevents/2417.jpeg",
      caption:
        "കേരളാ കൗമുദി പാലോട് യൂണിറ്റ്,ബോധപൗർണമി ക്ലബ്, പച്ച ശ്രീ ധർമ്മശാസ്താ ക്ഷേത്ര ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2417.jpeg",
    },
    {
      src: "assets/img/Pastevents/2405.jpeg",
      caption:
        " വയ്യക്കാവ് രുമൈക്സ മെമ്മോറിയൽ യു പി സ്കൂളിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2405.jpeg",
    },
    {
      src: "assets/img/Pastevents/2406.jpeg",
      caption:
        " വയ്യക്കാവ് രുമൈക്സ മെമ്മോറിയൽ യു പി സ്കൂളിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2406.jpeg",
    },
    {
      src: "assets/img/Pastevents/2407.jpeg",
      caption:
        " വയ്യക്കാവ് രുമൈക്സ മെമ്മോറിയൽ യു പി സ്കൂളിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2407.jpeg",
    },
    {
      src: "assets/img/Pastevents/2408.jpeg",
      caption:
        " വയ്യക്കാവ് രുമൈക്സ മെമ്മോറിയൽ യു പി സ്കൂളിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2408.jpeg",
    },
    {
      src: "assets/img/Pastevents/2409.jpeg",
      caption:
        " വയ്യക്കാവ് രുമൈക്സ മെമ്മോറിയൽ യു പി സ്കൂളിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2409.jpeg",
    },
    {
      src: "assets/img/Pastevents/2410.jpeg",
      caption:
        " വയ്യക്കാവ് രുമൈക്സ മെമ്മോറിയൽ യു പി സ്കൂളിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2410.jpeg",
    },
    {
      src: "assets/img/Pastevents/2411.jpeg",
      caption:
        " വയ്യക്കാവ് രുമൈക്സ മെമ്മോറിയൽ യു പി സ്കൂളിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2411.jpeg",
    },
    {
      src: "assets/img/Pastevents/2399.jpeg",
      caption:
        "കീഴാരൂർ സരസ്വതി വിദ്യാലയത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2399.jpeg",
    },
    {
      src: "assets/img/Pastevents/2400.jpeg",
      caption:
        "കീഴാരൂർ സരസ്വതി വിദ്യാലയത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2400.jpeg",
    },
    {
      src: "assets/img/Pastevents/2401.jpeg",
      caption:
        "കീഴാരൂർ സരസ്വതി വിദ്യാലയത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2401.jpeg",
    },
    {
      src: "assets/img/Pastevents/2402.jpeg",
      caption:
        "കീഴാരൂർ സരസ്വതി വിദ്യാലയത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2402.jpeg",
    },
    {
      src: "assets/img/Pastevents/2403.jpeg",
      caption:
        "കീഴാരൂർ സരസ്വതി വിദ്യാലയത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2403.jpeg",
    },
    {
      src: "assets/img/Pastevents/2404.jpeg",
      caption:
        "കീഴാരൂർ സരസ്വതി വിദ്യാലയത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2404.jpeg",
    },
    {
      src: "assets/img/Pastevents/2390.jpeg",
      caption:
        "നെയ്യാറ്റിൻകര ശ്രീകൃഷ്ണ സ്വാമി ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ 18.03.2023 മുതൽ 27.03.2023 വരെ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൻ്റെ ഭാഗമായി ആയിരത്തിൽ പരം പേർക്ക് സൗജന്യ ബി പി, ബ്ലഡ് ഷുഗർ, ഡോക്ടർ കൺസൾട്ടിംഗ്, മരുന്ന് വിതരണം എന്നിവ നടത്തി.",
      thumb: "assets/img/Pastevents/2390.jpeg",
    },
    {
      src: "assets/img/Pastevents/2391.jpeg",
      caption:
        "നെയ്യാറ്റിൻകര ശ്രീകൃഷ്ണ സ്വാമി ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ 18.03.2023 മുതൽ 27.03.2023 വരെ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൻ്റെ ഭാഗമായി ആയിരത്തിൽ പരം പേർക്ക് സൗജന്യ ബി പി, ബ്ലഡ് ഷുഗർ, ഡോക്ടർ കൺസൾട്ടിംഗ്, മരുന്ന് വിതരണം എന്നിവ നടത്തി.",
      thumb: "assets/img/Pastevents/2391.jpeg",
    },
    {
      src: "assets/img/Pastevents/2392.jpeg",
      caption:
        "നെയ്യാറ്റിൻകര ശ്രീകൃഷ്ണ സ്വാമി ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ 18.03.2023 മുതൽ 27.03.2023 വരെ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൻ്റെ ഭാഗമായി ആയിരത്തിൽ പരം പേർക്ക് സൗജന്യ ബി പി, ബ്ലഡ് ഷുഗർ, ഡോക്ടർ കൺസൾട്ടിംഗ്, മരുന്ന് വിതരണം എന്നിവ നടത്തി.",
      thumb: "assets/img/Pastevents/2392.jpeg",
    },
    {
      src: "assets/img/Pastevents/2393.jpeg",
      caption:
        "നെയ്യാറ്റിൻകര ശ്രീകൃഷ്ണ സ്വാമി ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ 18.03.2023 മുതൽ 27.03.2023 വരെ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൻ്റെ ഭാഗമായി ആയിരത്തിൽ പരം പേർക്ക് സൗജന്യ ബി പി, ബ്ലഡ് ഷുഗർ, ഡോക്ടർ കൺസൾട്ടിംഗ്, മരുന്ന് വിതരണം എന്നിവ നടത്തി.",
      thumb: "assets/img/Pastevents/2393.jpeg",
    },
    {
      src: "assets/img/Pastevents/2394.jpeg",
      caption:
        "നെയ്യാറ്റിൻകര ശ്രീകൃഷ്ണ സ്വാമി ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ 18.03.2023 മുതൽ 27.03.2023 വരെ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൻ്റെ ഭാഗമായി ആയിരത്തിൽ പരം പേർക്ക് സൗജന്യ ബി പി, ബ്ലഡ് ഷുഗർ, ഡോക്ടർ കൺസൾട്ടിംഗ്, മരുന്ന് വിതരണം എന്നിവ നടത്തി.",
      thumb: "assets/img/Pastevents/2394.jpeg",
    },
    {
      src: "assets/img/Pastevents/2395.jpeg",
      caption:
        "നെയ്യാറ്റിൻകര ശ്രീകൃഷ്ണ സ്വാമി ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ 18.03.2023 മുതൽ 27.03.2023 വരെ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൻ്റെ ഭാഗമായി ആയിരത്തിൽ പരം പേർക്ക് സൗജന്യ ബി പി, ബ്ലഡ് ഷുഗർ, ഡോക്ടർ കൺസൾട്ടിംഗ്, മരുന്ന് വിതരണം എന്നിവ നടത്തി.",
      thumb: "assets/img/Pastevents/2395.jpeg",
    },
    {
      src: "assets/img/Pastevents/2396.jpeg",
      caption:
        "നെയ്യാറ്റിൻകര ശ്രീകൃഷ്ണ സ്വാമി ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ 18.03.2023 മുതൽ 27.03.2023 വരെ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൻ്റെ ഭാഗമായി ആയിരത്തിൽ പരം പേർക്ക് സൗജന്യ ബി പി, ബ്ലഡ് ഷുഗർ, ഡോക്ടർ കൺസൾട്ടിംഗ്, മരുന്ന് വിതരണം എന്നിവ നടത്തി.",
      thumb: "assets/img/Pastevents/2396.jpeg",
    },
    {
      src: "assets/img/Pastevents/2397.jpeg",
      caption:
        "നെയ്യാറ്റിൻകര ശ്രീകൃഷ്ണ സ്വാമി ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ 18.03.2023 മുതൽ 27.03.2023 വരെ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൻ്റെ ഭാഗമായി ആയിരത്തിൽ പരം പേർക്ക് സൗജന്യ ബി പി, ബ്ലഡ് ഷുഗർ, ഡോക്ടർ കൺസൾട്ടിംഗ്, മരുന്ന് വിതരണം എന്നിവ നടത്തി.",
      thumb: "assets/img/Pastevents/2397.jpeg",
    },
    {
      src: "assets/img/Pastevents/2398.jpeg",
      caption:
        "നെയ്യാറ്റിൻകര ശ്രീകൃഷ്ണ സ്വാമി ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ 18.03.2023 മുതൽ 27.03.2023 വരെ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൻ്റെ ഭാഗമായി ആയിരത്തിൽ പരം പേർക്ക് സൗജന്യ ബി പി, ബ്ലഡ് ഷുഗർ, ഡോക്ടർ കൺസൾട്ടിംഗ്, മരുന്ന് വിതരണം എന്നിവ നടത്തി.",
      thumb: "assets/img/Pastevents/2398.jpeg",
    },
    {
      src: "assets/img/Pastevents/2384.jpg",
      caption:
        "വറട്ടയം ഇലങ്കം ശ്രീ ചാമുണ്ഡേശ്വരി ദേവി ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2384.jpg",
    },
    {
      src: "assets/img/Pastevents/2385.jpg",
      caption:
        "വറട്ടയം ഇലങ്കം ശ്രീ ചാമുണ്ഡേശ്വരി ദേവി ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2385.jpg",
    },
    {
      src: "assets/img/Pastevents/2386.jpg",
      caption:
        "വറട്ടയം ഇലങ്കം ശ്രീ ചാമുണ്ഡേശ്വരി ദേവി ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2386.jpg",
    },
    {
      src: "assets/img/Pastevents/2387.jpg",
      caption:
        "വറട്ടയം ഇലങ്കം ശ്രീ ചാമുണ്ഡേശ്വരി ദേവി ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2387.jpg",
    },
    {
      src: "assets/img/Pastevents/2388.jpg",
      caption:
        "വറട്ടയം ഇലങ്കം ശ്രീ ചാമുണ്ഡേശ്വരി ദേവി ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2388.jpg",
    },
    {
      src: "assets/img/Pastevents/2389.jpg",
      caption:
        "വറട്ടയം ഇലങ്കം ശ്രീ ചാമുണ്ഡേശ്വരി ദേവി ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2389.jpg",
    },

    {
      src: "assets/img/Pastevents/2377.jpg",
      caption:
        "നെല്ലിമൂട് ശ്രീ മുലയൻ താന്നി ദേവി ക്ഷേത്ര ട്രസ്റ്റ്, നെല്ലിമൂട് ബ്ലഡ് ഡൊണേഷ്സ് ഫോറത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ എം വിൻസൻ്റ് (ബഹു:എം എൽ എ കോവളം).ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2377.jpg",
    },
    {
      src: "assets/img/Pastevents/2378.jpg",
      caption:
        "നെല്ലിമൂട് ശ്രീ മുലയൻ താന്നി ദേവി ക്ഷേത്ര ട്രസ്റ്റ്, നെല്ലിമൂട് ബ്ലഡ് ഡൊണേഷ്സ് ഫോറത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ എം വിൻസൻ്റ് (ബഹു:എം എൽ എ കോവളം).ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2378.jpg",
    },
    {
      src: "assets/img/Pastevents/2379.jpg",
      caption:
        "നെല്ലിമൂട് ശ്രീ മുലയൻ താന്നി ദേവി ക്ഷേത്ര ട്രസ്റ്റ്, നെല്ലിമൂട് ബ്ലഡ് ഡൊണേഷ്സ് ഫോറത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ എം വിൻസൻ്റ് (ബഹു:എം എൽ എ കോവളം).ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2379.jpg",
    },
    {
      src: "assets/img/Pastevents/2380.jpg",
      caption:
        "നെല്ലിമൂട് ശ്രീ മുലയൻ താന്നി ദേവി ക്ഷേത്ര ട്രസ്റ്റ്, നെല്ലിമൂട് ബ്ലഡ് ഡൊണേഷ്സ് ഫോറത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ എം വിൻസൻ്റ് (ബഹു:എം എൽ എ കോവളം).ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2380.jpg",
    },
    {
      src: "assets/img/Pastevents/2381.jpg",
      caption:
        "നെല്ലിമൂട് ശ്രീ മുലയൻ താന്നി ദേവി ക്ഷേത്ര ട്രസ്റ്റ്, നെല്ലിമൂട് ബ്ലഡ് ഡൊണേഷ്സ് ഫോറത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ എം വിൻസൻ്റ് (ബഹു:എം എൽ എ കോവളം).ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2381.jpg",
    },
    {
      src: "assets/img/Pastevents/2382.jpg",
      caption:
        "നെല്ലിമൂട് ശ്രീ മുലയൻ താന്നി ദേവി ക്ഷേത്ര ട്രസ്റ്റ്, നെല്ലിമൂട് ബ്ലഡ് ഡൊണേഷ്സ് ഫോറത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ എം വിൻസൻ്റ് (ബഹു:എം എൽ എ കോവളം).ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2382.jpg",
    },
    {
      src: "assets/img/Pastevents/2383.jpg",
      caption:
        "നെല്ലിമൂട് ശ്രീ മുലയൻ താന്നി ദേവി ക്ഷേത്ര ട്രസ്റ്റ്, നെല്ലിമൂട് ബ്ലഡ് ഡൊണേഷ്സ് ഫോറത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ എം വിൻസൻ്റ് (ബഹു:എം എൽ എ കോവളം).ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2383.jpg",
    },

    {
      src: "assets/img/Pastevents/2369.jpg",
      caption:
        "കാവിയാട് ദിനകര പണിക്കർ സാംസ്കാരിക വേദിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2369.jpg",
    },
    {
      src: "assets/img/Pastevents/2370.jpg",
      caption:
        "കാവിയാട് ദിനകര പണിക്കർ സാംസ്കാരിക വേദിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2370.jpg",
    },
    {
      src: "assets/img/Pastevents/2371.jpg",
      caption:
        "കാവിയാട് ദിനകര പണിക്കർ സാംസ്കാരിക വേദിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2371.jpg",
    },
    {
      src: "assets/img/Pastevents/2372.jpg",
      caption:
        "കാവിയാട് ദിനകര പണിക്കർ സാംസ്കാരിക വേദിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2372.jpg",
    },
    {
      src: "assets/img/Pastevents/2373.jpg",
      caption:
        "കാവിയാട് ദിനകര പണിക്കർ സാംസ്കാരിക വേദിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2373.jpg",
    },
    {
      src: "assets/img/Pastevents/2374.jpg",
      caption:
        "കാവിയാട് ദിനകര പണിക്കർ സാംസ്കാരിക വേദിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2374.jpg",
    },
    {
      src: "assets/img/Pastevents/2375.jpg",
      caption:
        "കാവിയാട് ദിനകര പണിക്കർ സാംസ്കാരിക വേദിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2375.jpg",
    },
    {
      src: "assets/img/Pastevents/2376.jpg",
      caption:
        "കാവിയാട് ദിനകര പണിക്കർ സാംസ്കാരിക വേദിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2376.jpg",
    },
    {
      src: "assets/img/Pastevents/2353.jpeg",
      caption:
        "കൂട്ടപ്പന ശ്രീ മഹാദേവ ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2353.jpeg",
    },
    {
      src: "assets/img/Pastevents/2354.jpeg",
      caption:
        "കൂട്ടപ്പന ശ്രീ മഹാദേവ ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2354.jpeg",
    },
    {
      src: "assets/img/Pastevents/2355.jpeg",
      caption:
        "കൂട്ടപ്പന ശ്രീ മഹാദേവ ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2355.jpeg",
    },
    {
      src: "assets/img/Pastevents/2356.jpeg",
      caption:
        "കൂട്ടപ്പന ശ്രീ മഹാദേവ ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2356.jpeg",
    },
    {
      src: "assets/img/Pastevents/2357.jpeg",
      caption:
        "കൂട്ടപ്പന ശ്രീ മഹാദേവ ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2357.jpeg",
    },
    {
      src: "assets/img/Pastevents/2358.jpeg",
      caption:
        "കൂട്ടപ്പന ശ്രീ മഹാദേവ ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2358.jpeg",
    },
    {
      src: "assets/img/Pastevents/2359.jpeg",
      caption:
        "കൂട്ടപ്പന ശ്രീ മഹാദേവ ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2359.jpeg",
    },
    {
      src: "assets/img/Pastevents/2360.jpeg",
      caption:
        "കൂട്ടപ്പന ശ്രീ മഹാദേവ ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2360.jpeg",
    },
    {
      src: "assets/img/Pastevents/2361.jpeg",
      caption:
        "കൂട്ടപ്പന ശ്രീ മഹാദേവ ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2361.jpeg",
    },
    {
      src: "assets/img/Pastevents/2362.jpeg",
      caption:
        "കൂട്ടപ്പന ശ്രീ മഹാദേവ ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2362.jpeg",
    },
    {
      src: "assets/img/Pastevents/2363.jpeg",
      caption:
        "കൂട്ടപ്പന ശ്രീ മഹാദേവ ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2363.jpeg",
    },
    {
      src: "assets/img/Pastevents/2364.jpeg",
      caption:
        "കൂട്ടപ്പന ശ്രീ മഹാദേവ ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2364.jpeg",
    },
    {
      src: "assets/img/Pastevents/2365.jpeg",
      caption:
        "കൂട്ടപ്പന ശ്രീ മഹാദേവ ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2365.jpeg",
    },
    {
      src: "assets/img/Pastevents/2366.jpeg",
      caption:
        "കൂട്ടപ്പന ശ്രീ മഹാദേവ ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2366.jpeg",
    },
    {
      src: "assets/img/Pastevents/2367.jpeg",
      caption:
        "കൂട്ടപ്പന ശ്രീ മഹാദേവ ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2367.jpeg",
    },
    {
      src: "assets/img/Pastevents/2368.jpeg",
      caption:
        "കൂട്ടപ്പന ശ്രീ മഹാദേവ ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2368.jpeg",
    },
    {
      src: "assets/img/Pastevents/2347.jpeg",
      caption:
        "ഡി വൈ എഫ് ഐ പാപ്പനംകോട് യൂണിറ്റ്, അനന്തപുരി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2347.jpeg",
    },
    {
      src: "assets/img/Pastevents/2348.jpeg",
      caption:
        "ഡി വൈ എഫ് ഐ പാപ്പനംകോട് യൂണിറ്റ്, അനന്തപുരി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2348.jpeg",
    },
    {
      src: "assets/img/Pastevents/2349.jpeg",
      caption:
        "ഡി വൈ എഫ് ഐ പാപ്പനംകോട് യൂണിറ്റ്, അനന്തപുരി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2349.jpeg",
    },
    {
      src: "assets/img/Pastevents/2350.jpeg",
      caption:
        "ഡി വൈ എഫ് ഐ പാപ്പനംകോട് യൂണിറ്റ്, അനന്തപുരി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2350.jpeg",
    },
    {
      src: "assets/img/Pastevents/2351.jpeg",
      caption:
        "ഡി വൈ എഫ് ഐ പാപ്പനംകോട് യൂണിറ്റ്, അനന്തപുരി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2351.jpeg",
    },
    {
      src: "assets/img/Pastevents/2352.jpeg",
      caption:
        "ഡി വൈ എഫ് ഐ പാപ്പനംകോട് യൂണിറ്റ്, അനന്തപുരി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2352.jpeg",
    },
    {
      src: "assets/img/Pastevents/2340.jpeg",
      caption:
        "കൊല്ലങ്കോട് ശ്രീ ഭദ്രകാളി ക്ഷേത്ര ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2340.jpeg",
    },
    {
      src: "assets/img/Pastevents/2341.jpeg",
      caption:
        "കൊല്ലങ്കോട് ശ്രീ ഭദ്രകാളി ക്ഷേത്ര ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2341.jpeg",
    },
    {
      src: "assets/img/Pastevents/2342.jpeg",
      caption:
        "കൊല്ലങ്കോട് ശ്രീ ഭദ്രകാളി ക്ഷേത്ര ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2342.jpeg",
    },
    {
      src: "assets/img/Pastevents/2343.jpeg",
      caption:
        "കൊല്ലങ്കോട് ശ്രീ ഭദ്രകാളി ക്ഷേത്ര ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2343.jpeg",
    },
    {
      src: "assets/img/Pastevents/2344.jpeg",
      caption:
        "കൊല്ലങ്കോട് ശ്രീ ഭദ്രകാളി ക്ഷേത്ര ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2344.jpeg",
    },
    {
      src: "assets/img/Pastevents/2345.jpeg",
      caption:
        "കൊല്ലങ്കോട് ശ്രീ ഭദ്രകാളി ക്ഷേത്ര ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2345.jpeg",
    },
    {
      src: "assets/img/Pastevents/2346.jpeg",
      caption:
        "കൊല്ലങ്കോട് ശ്രീ ഭദ്രകാളി ക്ഷേത്ര ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2346.jpeg",
    },
    {
      src: "assets/img/Pastevents/2334.jpeg",
      caption:
        "കൊല്ലങ്കോട് ശ്രീ ഭദ്രകാളി ക്ഷേത്ര ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2334.jpeg",
    },
    {
      src: "assets/img/Pastevents/2335.jpeg",
      caption:
        "കൊല്ലങ്കോട് ശ്രീ ഭദ്രകാളി ക്ഷേത്ര ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2335.jpeg",
    },
    {
      src: "assets/img/Pastevents/2336.jpeg",
      caption:
        "കൊല്ലങ്കോട് ശ്രീ ഭദ്രകാളി ക്ഷേത്ര ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2336.jpeg",
    },
    {
      src: "assets/img/Pastevents/2337.jpeg",
      caption:
        "കൊല്ലങ്കോട് ശ്രീ ഭദ്രകാളി ക്ഷേത്ര ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2337.jpeg",
    },
    {
      src: "assets/img/Pastevents/2338.jpeg",
      caption:
        "കൊല്ലങ്കോട് ശ്രീ ഭദ്രകാളി ക്ഷേത്ര ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2338.jpeg",
    },
    {
      src: "assets/img/Pastevents/2339.jpeg",
      caption:
        "കൊല്ലങ്കോട് ശ്രീ ഭദ്രകാളി ക്ഷേത്ര ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2339.jpeg",
    },
    {
      src: "assets/img/Pastevents/2329.jpeg",
      caption:
        "കൊല്ലങ്കോട് ശ്രീ ഭദ്രകാളി ക്ഷേത്ര ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2329.jpeg",
    },
    {
      src: "assets/img/Pastevents/2330.jpeg",
      caption:
        "കൊല്ലങ്കോട് ശ്രീ ഭദ്രകാളി ക്ഷേത്ര ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2330.jpeg",
    },
    {
      src: "assets/img/Pastevents/2331.jpeg",
      caption:
        "കൊല്ലങ്കോട് ശ്രീ ഭദ്രകാളി ക്ഷേത്ര ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2331.jpeg",
    },
    {
      src: "assets/img/Pastevents/2332.jpeg",
      caption:
        "കൊല്ലങ്കോട് ശ്രീ ഭദ്രകാളി ക്ഷേത്ര ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2332.jpeg",
    },
    {
      src: "assets/img/Pastevents/2333.jpeg",
      caption:
        "കൊല്ലങ്കോട് ശ്രീ ഭദ്രകാളി ക്ഷേത്ര ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2333.jpeg",
    },
    {
      src: "assets/img/Pastevents/2321.jpeg",
      caption:
        "കുന്നത്തുക്കാൽ ഗ്രാമ പഞ്ചായത്തിലെ പാലിയോട് വാർഡിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ ജി ലാൽ കൃഷ്ണാ (പെരുംങ്കടവിള ഗ്രാമ പഞ്ചായത്ത് പ്രസിഡൻ്റ്).ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2321.jpeg",
    },
    {
      src: "assets/img/Pastevents/2322.jpeg",
      caption:
        "കുന്നത്തുക്കാൽ ഗ്രാമ പഞ്ചായത്തിലെ പാലിയോട് വാർഡിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ ജി ലാൽ കൃഷ്ണാ (പെരുംങ്കടവിള ഗ്രാമ പഞ്ചായത്ത് പ്രസിഡൻ്റ്).ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2322.jpeg",
    },
    {
      src: "assets/img/Pastevents/2323.jpeg",
      caption:
        "കുന്നത്തുക്കാൽ ഗ്രാമ പഞ്ചായത്തിലെ പാലിയോട് വാർഡിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ ജി ലാൽ കൃഷ്ണാ (പെരുംങ്കടവിള ഗ്രാമ പഞ്ചായത്ത് പ്രസിഡൻ്റ്).ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2323.jpeg",
    },
    {
      src: "assets/img/Pastevents/2324.jpeg",
      caption:
        "കുന്നത്തുക്കാൽ ഗ്രാമ പഞ്ചായത്തിലെ പാലിയോട് വാർഡിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ ജി ലാൽ കൃഷ്ണാ (പെരുംങ്കടവിള ഗ്രാമ പഞ്ചായത്ത് പ്രസിഡൻ്റ്).ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2324.jpeg",
    },
    {
      src: "assets/img/Pastevents/2325.jpeg",
      caption:
        "കുന്നത്തുക്കാൽ ഗ്രാമ പഞ്ചായത്തിലെ പാലിയോട് വാർഡിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ ജി ലാൽ കൃഷ്ണാ (പെരുംങ്കടവിള ഗ്രാമ പഞ്ചായത്ത് പ്രസിഡൻ്റ്).ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2325.jpeg",
    },
    {
      src: "assets/img/Pastevents/2326.jpeg",
      caption:
        "കുന്നത്തുക്കാൽ ഗ്രാമ പഞ്ചായത്തിലെ പാലിയോട് വാർഡിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ ജി ലാൽ കൃഷ്ണാ (പെരുംങ്കടവിള ഗ്രാമ പഞ്ചായത്ത് പ്രസിഡൻ്റ്).ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2326.jpeg",
    },
    {
      src: "assets/img/Pastevents/2327.jpeg",
      caption:
        "കുന്നത്തുക്കാൽ ഗ്രാമ പഞ്ചായത്തിലെ പാലിയോട് വാർഡിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ ജി ലാൽ കൃഷ്ണാ (പെരുംങ്കടവിള ഗ്രാമ പഞ്ചായത്ത് പ്രസിഡൻ്റ്).ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2327.jpeg",
    },
    {
      src: "assets/img/Pastevents/2328.jpeg",
      caption:
        "കുന്നത്തുക്കാൽ ഗ്രാമ പഞ്ചായത്തിലെ പാലിയോട് വാർഡിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ ജി ലാൽ കൃഷ്ണാ (പെരുംങ്കടവിള ഗ്രാമ പഞ്ചായത്ത് പ്രസിഡൻ്റ്).ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2328.jpeg",
    },
    {
      src: "assets/img/Pastevents/2312.jpeg",
      caption:
        "മാർച്ച് 19 ഞായർ രാവിലെ 09 മണിയ്ക്ക് മാരായമുട്ടം ഗവ: എൽ പി സ്കൂൾ ഹാളിൽ വച്ച് നടന്ന ചടങ്ങിൽ  എന്റെ ഹൃദയം എന്റെ ഗ്രാമം ; സൗജന്യ ഹൃദ്രോഗ നിർണ്ണയ മെഗാ ക്യാമ്പിന്റെയും ബോധവത്ക്കരണത്തിൻ്റെയും ഉദ്ഘാടനം ശ്രീ സുരേന്ദ്രൻ (പെരുംക്കടവിള ഗ്രാമ പഞ്ചായത്ത് പ്രസിഡൻ്റ്) നിർവഹിച്ചു.",
      thumb: "assets/img/Pastevents/2312.jpeg",
    },
    {
      src: "assets/img/Pastevents/2313.jpeg",
      caption:
        "മാർച്ച് 19 ഞായർ രാവിലെ 09 മണിയ്ക്ക് മാരായമുട്ടം ഗവ: എൽ പി സ്കൂൾ ഹാളിൽ വച്ച് നടന്ന ചടങ്ങിൽ  എന്റെ ഹൃദയം എന്റെ ഗ്രാമം ; സൗജന്യ ഹൃദ്രോഗ നിർണ്ണയ മെഗാ ക്യാമ്പിന്റെയും ബോധവത്ക്കരണത്തിൻ്റെയും ഉദ്ഘാടനം ശ്രീ സുരേന്ദ്രൻ (പെരുംക്കടവിള ഗ്രാമ പഞ്ചായത്ത് പ്രസിഡൻ്റ്) നിർവഹിച്ചു.",
      thumb: "assets/img/Pastevents/2313.jpeg",
    },
    {
      src: "assets/img/Pastevents/2314.jpeg",
      caption:
        "മാർച്ച് 19 ഞായർ രാവിലെ 09 മണിയ്ക്ക് മാരായമുട്ടം ഗവ: എൽ പി സ്കൂൾ ഹാളിൽ വച്ച് നടന്ന ചടങ്ങിൽ  എന്റെ ഹൃദയം എന്റെ ഗ്രാമം ; സൗജന്യ ഹൃദ്രോഗ നിർണ്ണയ മെഗാ ക്യാമ്പിന്റെയും ബോധവത്ക്കരണത്തിൻ്റെയും ഉദ്ഘാടനം ശ്രീ സുരേന്ദ്രൻ (പെരുംക്കടവിള ഗ്രാമ പഞ്ചായത്ത് പ്രസിഡൻ്റ്) നിർവഹിച്ചു.",
      thumb: "assets/img/Pastevents/2314.jpeg",
    },
    {
      src: "assets/img/Pastevents/2315.jpeg",
      caption:
        "മാർച്ച് 19 ഞായർ രാവിലെ 09 മണിയ്ക്ക് മാരായമുട്ടം ഗവ: എൽ പി സ്കൂൾ ഹാളിൽ വച്ച് നടന്ന ചടങ്ങിൽ  എന്റെ ഹൃദയം എന്റെ ഗ്രാമം ; സൗജന്യ ഹൃദ്രോഗ നിർണ്ണയ മെഗാ ക്യാമ്പിന്റെയും ബോധവത്ക്കരണത്തിൻ്റെയും ഉദ്ഘാടനം ശ്രീ സുരേന്ദ്രൻ (പെരുംക്കടവിള ഗ്രാമ പഞ്ചായത്ത് പ്രസിഡൻ്റ്) നിർവഹിച്ചു.",
      thumb: "assets/img/Pastevents/2315.jpeg",
    },
    {
      src: "assets/img/Pastevents/2316.jpeg",
      caption:
        "മാർച്ച് 19 ഞായർ രാവിലെ 09 മണിയ്ക്ക് മാരായമുട്ടം ഗവ: എൽ പി സ്കൂൾ ഹാളിൽ വച്ച് നടന്ന ചടങ്ങിൽ  എന്റെ ഹൃദയം എന്റെ ഗ്രാമം ; സൗജന്യ ഹൃദ്രോഗ നിർണ്ണയ മെഗാ ക്യാമ്പിന്റെയും ബോധവത്ക്കരണത്തിൻ്റെയും ഉദ്ഘാടനം ശ്രീ സുരേന്ദ്രൻ (പെരുംക്കടവിള ഗ്രാമ പഞ്ചായത്ത് പ്രസിഡൻ്റ്) നിർവഹിച്ചു.",
      thumb: "assets/img/Pastevents/2316.jpeg",
    },
    {
      src: "assets/img/Pastevents/2317.jpeg",
      caption:
        "മാർച്ച് 19 ഞായർ രാവിലെ 09 മണിയ്ക്ക് മാരായമുട്ടം ഗവ: എൽ പി സ്കൂൾ ഹാളിൽ വച്ച് നടന്ന ചടങ്ങിൽ  എന്റെ ഹൃദയം എന്റെ ഗ്രാമം ; സൗജന്യ ഹൃദ്രോഗ നിർണ്ണയ മെഗാ ക്യാമ്പിന്റെയും ബോധവത്ക്കരണത്തിൻ്റെയും ഉദ്ഘാടനം ശ്രീ സുരേന്ദ്രൻ (പെരുംക്കടവിള ഗ്രാമ പഞ്ചായത്ത് പ്രസിഡൻ്റ്) നിർവഹിച്ചു.",
      thumb: "assets/img/Pastevents/2317.jpeg",
    },
    {
      src: "assets/img/Pastevents/2318.jpeg",
      caption:
        "മാർച്ച് 19 ഞായർ രാവിലെ 09 മണിയ്ക്ക് മാരായമുട്ടം ഗവ: എൽ പി സ്കൂൾ ഹാളിൽ വച്ച് നടന്ന ചടങ്ങിൽ  എന്റെ ഹൃദയം എന്റെ ഗ്രാമം ; സൗജന്യ ഹൃദ്രോഗ നിർണ്ണയ മെഗാ ക്യാമ്പിന്റെയും ബോധവത്ക്കരണത്തിൻ്റെയും ഉദ്ഘാടനം ശ്രീ സുരേന്ദ്രൻ (പെരുംക്കടവിള ഗ്രാമ പഞ്ചായത്ത് പ്രസിഡൻ്റ്) നിർവഹിച്ചു.",
      thumb: "assets/img/Pastevents/2318.jpeg",
    },
    {
      src: "assets/img/Pastevents/2319.jpeg",
      caption:
        "മാർച്ച് 19 ഞായർ രാവിലെ 09 മണിയ്ക്ക് മാരായമുട്ടം ഗവ: എൽ പി സ്കൂൾ ഹാളിൽ വച്ച് നടന്ന ചടങ്ങിൽ  എന്റെ ഹൃദയം എന്റെ ഗ്രാമം ; സൗജന്യ ഹൃദ്രോഗ നിർണ്ണയ മെഗാ ക്യാമ്പിന്റെയും ബോധവത്ക്കരണത്തിൻ്റെയും ഉദ്ഘാടനം ശ്രീ സുരേന്ദ്രൻ (പെരുംക്കടവിള ഗ്രാമ പഞ്ചായത്ത് പ്രസിഡൻ്റ്) നിർവഹിച്ചു.",
      thumb: "assets/img/Pastevents/2319.jpeg",
    },
    {
      src: "assets/img/Pastevents/2320.jpeg",
      caption:
        "മാർച്ച് 19 ഞായർ രാവിലെ 09 മണിയ്ക്ക് മാരായമുട്ടം ഗവ: എൽ പി സ്കൂൾ ഹാളിൽ വച്ച് നടന്ന ചടങ്ങിൽ  എന്റെ ഹൃദയം എന്റെ ഗ്രാമം ; സൗജന്യ ഹൃദ്രോഗ നിർണ്ണയ മെഗാ ക്യാമ്പിന്റെയും ബോധവത്ക്കരണത്തിൻ്റെയും ഉദ്ഘാടനം ശ്രീ സുരേന്ദ്രൻ (പെരുംക്കടവിള ഗ്രാമ പഞ്ചായത്ത് പ്രസിഡൻ്റ്) നിർവഹിച്ചു.",
      thumb: "assets/img/Pastevents/2320.jpeg",
    },
    {
      src: "assets/img/Pastevents/2306.jpeg",
      caption:
        "മങ്കാട് നിലമേൽ മുസ്‌ലിം ജുമാ മസ്ജിദിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2306.jpeg",
    },
    {
      src: "assets/img/Pastevents/2307.jpeg",
      caption:
        "മങ്കാട് നിലമേൽ മുസ്‌ലിം ജുമാ മസ്ജിദിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2307.jpeg",
    },
    {
      src: "assets/img/Pastevents/2308.jpeg",
      caption:
        "മങ്കാട് നിലമേൽ മുസ്‌ലിം ജുമാ മസ്ജിദിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2308.jpeg",
    },
    {
      src: "assets/img/Pastevents/2309.jpeg",
      caption:
        "മങ്കാട് നിലമേൽ മുസ്‌ലിം ജുമാ മസ്ജിദിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2309.jpeg",
    },
    {
      src: "assets/img/Pastevents/2310.jpeg",
      caption:
        "മങ്കാട് നിലമേൽ മുസ്‌ലിം ജുമാ മസ്ജിദിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2310.jpeg",
    },
    {
      src: "assets/img/Pastevents/2311.jpeg",
      caption:
        "മങ്കാട് നിലമേൽ മുസ്‌ലിം ജുമാ മസ്ജിദിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2311.jpeg",
    },
    {
      src: "assets/img/Pastevents/2300.jpeg",
      caption:
        "കരകുളം പി എ അസീസ് കോളേജിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2300.jpeg",
    },
    {
      src: "assets/img/Pastevents/2301.jpeg",
      caption:
        "കരകുളം പി എ അസീസ് കോളേജിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2301.jpeg",
    },
    {
      src: "assets/img/Pastevents/2302.jpeg",
      caption:
        "കരകുളം പി എ അസീസ് കോളേജിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2302.jpeg",
    },
    {
      src: "assets/img/Pastevents/2303.jpeg",
      caption:
        "കരകുളം പി എ അസീസ് കോളേജിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2303.jpeg",
    },
    {
      src: "assets/img/Pastevents/2304.jpeg",
      caption:
        "കരകുളം പി എ അസീസ് കോളേജിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2304.jpeg",
    },
    {
      src: "assets/img/Pastevents/2305.jpeg",
      caption:
        "കരകുളം പി എ അസീസ് കോളേജിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2305.jpeg",
    },
    {
      src: "assets/img/Pastevents/2295.jpeg",
      caption:
        " KSRTC  ആരംഭിച്ച ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 100-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2295.jpeg",
    },
    {
      src: "assets/img/Pastevents/2296.jpeg",
      caption:
        " KSRTC  ആരംഭിച്ച ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 100-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2296.jpeg",
    },
    {
      src: "assets/img/Pastevents/2297.jpeg",
      caption:
        " KSRTC  ആരംഭിച്ച ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 100-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2297.jpeg",
    },
    {
      src: "assets/img/Pastevents/2298.jpeg",
      caption:
        " KSRTC  ആരംഭിച്ച ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 100-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2298.jpeg",
    },
    {
      src: "assets/img/Pastevents/2299.jpeg",
      caption:
        " KSRTC  ആരംഭിച്ച ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 100-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2299.jpeg",
    },
    {
      src: "assets/img/Pastevents/2288.jpeg",
      caption:
        "തിരുവനന്തപുരം നായർ സഹോദര സമാജം, അനന്തപുരി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ സൗജന്യ കാർഡിയോളജി, ഡയബറ്റോളജി, ജനറൽ മെഡിസിൻ,ഡെൻറ്റൽ, എന്നീ വിഭവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ ക്യാമ്പിന് നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2288.jpeg",
    },
    {
      src: "assets/img/Pastevents/2289.jpeg",
      caption:
        "തിരുവനന്തപുരം നായർ സഹോദര സമാജം, അനന്തപുരി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ സൗജന്യ കാർഡിയോളജി, ഡയബറ്റോളജി, ജനറൽ മെഡിസിൻ,ഡെൻറ്റൽ, എന്നീ വിഭവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ ക്യാമ്പിന് നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2289.jpeg",
    },
    {
      src: "assets/img/Pastevents/2290.jpeg",
      caption:
        "തിരുവനന്തപുരം നായർ സഹോദര സമാജം, അനന്തപുരി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ സൗജന്യ കാർഡിയോളജി, ഡയബറ്റോളജി, ജനറൽ മെഡിസിൻ,ഡെൻറ്റൽ, എന്നീ വിഭവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ ക്യാമ്പിന് നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2290.jpeg",
    },
    {
      src: "assets/img/Pastevents/2291.jpeg",
      caption:
        "തിരുവനന്തപുരം നായർ സഹോദര സമാജം, അനന്തപുരി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ സൗജന്യ കാർഡിയോളജി, ഡയബറ്റോളജി, ജനറൽ മെഡിസിൻ,ഡെൻറ്റൽ, എന്നീ വിഭവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ ക്യാമ്പിന് നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2291.jpeg",
    },
    {
      src: "assets/img/Pastevents/2292.jpeg",
      caption:
        "തിരുവനന്തപുരം നായർ സഹോദര സമാജം, അനന്തപുരി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ സൗജന്യ കാർഡിയോളജി, ഡയബറ്റോളജി, ജനറൽ മെഡിസിൻ,ഡെൻറ്റൽ, എന്നീ വിഭവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ ക്യാമ്പിന് നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2292.jpeg",
    },
    {
      src: "assets/img/Pastevents/2293.jpeg",
      caption:
        "തിരുവനന്തപുരം നായർ സഹോദര സമാജം, അനന്തപുരി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ സൗജന്യ കാർഡിയോളജി, ഡയബറ്റോളജി, ജനറൽ മെഡിസിൻ,ഡെൻറ്റൽ, എന്നീ വിഭവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ ക്യാമ്പിന് നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2293.jpeg",
    },
    {
      src: "assets/img/Pastevents/2294.jpeg",
      caption:
        "തിരുവനന്തപുരം നായർ സഹോദര സമാജം, അനന്തപുരി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ സൗജന്യ കാർഡിയോളജി, ഡയബറ്റോളജി, ജനറൽ മെഡിസിൻ,ഡെൻറ്റൽ, എന്നീ വിഭവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ ക്യാമ്പിന് നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2294.jpeg",
    },
    {
      src: "assets/img/Pastevents/2281.jpeg",
      caption:
        "തോട്ടുംപുറം മുസ്‌ലിം ജുമാ മസ്ജിദിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ സൗജന്യ കാർഡിയോളജി, ഡയബറ്റോളജി, ജനറൽ മെഡിസിൻ,ഡെൻറ്റൽ, എന്നീ വിഭവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ ക്യാമ്പിന് നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2281.jpeg",
    },
    {
      src: "assets/img/Pastevents/2282.jpeg",
      caption:
        "തോട്ടുംപുറം മുസ്‌ലിം ജുമാ മസ്ജിദിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ സൗജന്യ കാർഡിയോളജി, ഡയബറ്റോളജി, ജനറൽ മെഡിസിൻ,ഡെൻറ്റൽ, എന്നീ വിഭവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ ക്യാമ്പിന് നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2282.jpeg",
    },
    {
      src: "assets/img/Pastevents/2283.jpeg",
      caption:
        "തോട്ടുംപുറം മുസ്‌ലിം ജുമാ മസ്ജിദിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ സൗജന്യ കാർഡിയോളജി, ഡയബറ്റോളജി, ജനറൽ മെഡിസിൻ,ഡെൻറ്റൽ, എന്നീ വിഭവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ ക്യാമ്പിന് നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2283.jpeg",
    },
    {
      src: "assets/img/Pastevents/2284.jpeg",
      caption:
        "തോട്ടുംപുറം മുസ്‌ലിം ജുമാ മസ്ജിദിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ സൗജന്യ കാർഡിയോളജി, ഡയബറ്റോളജി, ജനറൽ മെഡിസിൻ,ഡെൻറ്റൽ, എന്നീ വിഭവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ ക്യാമ്പിന് നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2284.jpeg",
    },
    {
      src: "assets/img/Pastevents/2285.jpeg",
      caption:
        "തോട്ടുംപുറം മുസ്‌ലിം ജുമാ മസ്ജിദിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ സൗജന്യ കാർഡിയോളജി, ഡയബറ്റോളജി, ജനറൽ മെഡിസിൻ,ഡെൻറ്റൽ, എന്നീ വിഭവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ ക്യാമ്പിന് നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2285.jpeg",
    },
    {
      src: "assets/img/Pastevents/2286.jpeg",
      caption:
        "തോട്ടുംപുറം മുസ്‌ലിം ജുമാ മസ്ജിദിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ സൗജന്യ കാർഡിയോളജി, ഡയബറ്റോളജി, ജനറൽ മെഡിസിൻ,ഡെൻറ്റൽ, എന്നീ വിഭവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ ക്യാമ്പിന് നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2286.jpeg",
    },
    {
      src: "assets/img/Pastevents/2287.jpeg",
      caption:
        "തോട്ടുംപുറം മുസ്‌ലിം ജുമാ മസ്ജിദിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ സൗജന്യ കാർഡിയോളജി, ഡയബറ്റോളജി, ജനറൽ മെഡിസിൻ,ഡെൻറ്റൽ, എന്നീ വിഭവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ ക്യാമ്പിന് നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2287.jpeg",
    },
    {
      src: "assets/img/Pastevents/2275.jpeg",
      caption:
        "പണയം ഗവ: എൽ പി സ്കൂളിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ സൗജന്യ കാർഡിയോളജി, ഡയബറ്റോളജി, ജനറൽ മെഡിസിൻ,ഡെൻറ്റൽ, എന്നീ വിഭവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ ക്യാമ്പിന് നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2275.jpeg",
    },
    {
      src: "assets/img/Pastevents/2276.jpeg",
      caption:
        "പണയം ഗവ: എൽ പി സ്കൂളിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ സൗജന്യ കാർഡിയോളജി, ഡയബറ്റോളജി, ജനറൽ മെഡിസിൻ,ഡെൻറ്റൽ, എന്നീ വിഭവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ ക്യാമ്പിന് നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2276.jpeg",
    },
    {
      src: "assets/img/Pastevents/2277.jpeg",
      caption:
        "പണയം ഗവ: എൽ പി സ്കൂളിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ സൗജന്യ കാർഡിയോളജി, ഡയബറ്റോളജി, ജനറൽ മെഡിസിൻ,ഡെൻറ്റൽ, എന്നീ വിഭവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ ക്യാമ്പിന് നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2277.jpeg",
    },
    {
      src: "assets/img/Pastevents/2278.jpeg",
      caption:
        "പണയം ഗവ: എൽ പി സ്കൂളിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ സൗജന്യ കാർഡിയോളജി, ഡയബറ്റോളജി, ജനറൽ മെഡിസിൻ,ഡെൻറ്റൽ, എന്നീ വിഭവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ ക്യാമ്പിന് നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2278.jpeg",
    },
    {
      src: "assets/img/Pastevents/2279.jpeg",
      caption:
        "പണയം ഗവ: എൽ പി സ്കൂളിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ സൗജന്യ കാർഡിയോളജി, ഡയബറ്റോളജി, ജനറൽ മെഡിസിൻ,ഡെൻറ്റൽ, എന്നീ വിഭവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ ക്യാമ്പിന് നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2279.jpeg",
    },
    {
      src: "assets/img/Pastevents/2280.jpeg",
      caption:
        "പണയം ഗവ: എൽ പി സ്കൂളിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ സൗജന്യ കാർഡിയോളജി, ഡയബറ്റോളജി, ജനറൽ മെഡിസിൻ,ഡെൻറ്റൽ, എന്നീ വിഭവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ ക്യാമ്പിന് നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2280.jpeg",
    },
    {
      src: "assets/img/Pastevents/2269.jpeg",
      caption:
        "ഇരുകുന്നം റെസിഡൻ്റ്സ് വെൽഫെയർ അസോസിയേഷൻ,വട്ടിയൂർക്കാവ് മോഡൽ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ സൗജന്യ കാർഡിയോളജി, ഡയബറ്റോളജി, ജനറൽ മെഡിസിൻ,ഡെൻറ്റൽ, എന്നീ വിഭവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ ക്യാമ്പിന് നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2269.jpeg",
    },
    {
      src: "assets/img/Pastevents/2270.jpeg",
      caption:
        "ഇരുകുന്നം റെസിഡൻ്റ്സ് വെൽഫെയർ അസോസിയേഷൻ,വട്ടിയൂർക്കാവ് മോഡൽ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ സൗജന്യ കാർഡിയോളജി, ഡയബറ്റോളജി, ജനറൽ മെഡിസിൻ,ഡെൻറ്റൽ, എന്നീ വിഭവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ ക്യാമ്പിന് നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2270.jpeg",
    },
    {
      src: "assets/img/Pastevents/2271.jpeg",
      caption:
        "ഇരുകുന്നം റെസിഡൻ്റ്സ് വെൽഫെയർ അസോസിയേഷൻ,വട്ടിയൂർക്കാവ് മോഡൽ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ സൗജന്യ കാർഡിയോളജി, ഡയബറ്റോളജി, ജനറൽ മെഡിസിൻ,ഡെൻറ്റൽ, എന്നീ വിഭവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ ക്യാമ്പിന് നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2271.jpeg",
    },
    {
      src: "assets/img/Pastevents/2272.jpeg",
      caption:
        "ഇരുകുന്നം റെസിഡൻ്റ്സ് വെൽഫെയർ അസോസിയേഷൻ,വട്ടിയൂർക്കാവ് മോഡൽ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ സൗജന്യ കാർഡിയോളജി, ഡയബറ്റോളജി, ജനറൽ മെഡിസിൻ,ഡെൻറ്റൽ, എന്നീ വിഭവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ ക്യാമ്പിന് നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2272.jpeg",
    },
    {
      src: "assets/img/Pastevents/2273.jpeg",
      caption:
        "ഇരുകുന്നം റെസിഡൻ്റ്സ് വെൽഫെയർ അസോസിയേഷൻ,വട്ടിയൂർക്കാവ് മോഡൽ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ സൗജന്യ കാർഡിയോളജി, ഡയബറ്റോളജി, ജനറൽ മെഡിസിൻ,ഡെൻറ്റൽ, എന്നീ വിഭവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ ക്യാമ്പിന് നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2273.jpeg",
    },
    {
      src: "assets/img/Pastevents/2274.jpeg",
      caption:
        "ഇരുകുന്നം റെസിഡൻ്റ്സ് വെൽഫെയർ അസോസിയേഷൻ,വട്ടിയൂർക്കാവ് മോഡൽ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ സൗജന്യ കാർഡിയോളജി, ഡയബറ്റോളജി, ജനറൽ മെഡിസിൻ,ഡെൻറ്റൽ, എന്നീ വിഭവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ ക്യാമ്പിന് നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2274.jpeg",
    },
    {
      src: "assets/img/Pastevents/2262.jpeg",
      caption:
        "ആയയിൽ ശ്രീ കരിയിലക്കുളങ്ങര ദേവി ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ സൗജന്യ കാർഡിയോളജി, ഡയബറ്റോളജി, ജനറൽ മെഡിസിൻ,ഡെൻറ്റൽ, ആയൂർവേദ എന്നീ വിഭവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ ക്യാമ്പിന് നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2262.jpeg",
    },
    {
      src: "assets/img/Pastevents/2263.jpeg",
      caption:
        "ആയയിൽ ശ്രീ കരിയിലക്കുളങ്ങര ദേവി ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ സൗജന്യ കാർഡിയോളജി, ഡയബറ്റോളജി, ജനറൽ മെഡിസിൻ,ഡെൻറ്റൽ, ആയൂർവേദ എന്നീ വിഭവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ ക്യാമ്പിന് നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2263.jpeg",
    },
    {
      src: "assets/img/Pastevents/2264.jpeg",
      caption:
        "ആയയിൽ ശ്രീ കരിയിലക്കുളങ്ങര ദേവി ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ സൗജന്യ കാർഡിയോളജി, ഡയബറ്റോളജി, ജനറൽ മെഡിസിൻ,ഡെൻറ്റൽ, ആയൂർവേദ എന്നീ വിഭവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ ക്യാമ്പിന് നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2264.jpeg",
    },
    {
      src: "assets/img/Pastevents/2265.jpeg",
      caption:
        "ആയയിൽ ശ്രീ കരിയിലക്കുളങ്ങര ദേവി ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ സൗജന്യ കാർഡിയോളജി, ഡയബറ്റോളജി, ജനറൽ മെഡിസിൻ,ഡെൻറ്റൽ, ആയൂർവേദ എന്നീ വിഭവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ ക്യാമ്പിന് നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2265.jpeg",
    },
    {
      src: "assets/img/Pastevents/2266.jpeg",
      caption:
        "ആയയിൽ ശ്രീ കരിയിലക്കുളങ്ങര ദേവി ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ സൗജന്യ കാർഡിയോളജി, ഡയബറ്റോളജി, ജനറൽ മെഡിസിൻ,ഡെൻറ്റൽ, ആയൂർവേദ എന്നീ വിഭവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ ക്യാമ്പിന് നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2266.jpeg",
    },
    {
      src: "assets/img/Pastevents/2267.jpeg",
      caption:
        "ആയയിൽ ശ്രീ കരിയിലക്കുളങ്ങര ദേവി ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ സൗജന്യ കാർഡിയോളജി, ഡയബറ്റോളജി, ജനറൽ മെഡിസിൻ,ഡെൻറ്റൽ, ആയൂർവേദ എന്നീ വിഭവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ ക്യാമ്പിന് നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2267.jpeg",
    },
    {
      src: "assets/img/Pastevents/2268.jpeg",
      caption:
        "ആയയിൽ ശ്രീ കരിയിലക്കുളങ്ങര ദേവി ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ സൗജന്യ കാർഡിയോളജി, ഡയബറ്റോളജി, ജനറൽ മെഡിസിൻ,ഡെൻറ്റൽ, ആയൂർവേദ എന്നീ വിഭവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ ക്യാമ്പിന് നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2268.jpeg",
    },
    {
      src: "assets/img/Pastevents/2255.jpeg",
      caption:
        "കേരളാ പോലീസ് പെൻഷനേഴ്സ് വെൽഫെയർ അസോസിയേഷൻ നെയ്യാറ്റിൻകര താലൂക്ക്  കമ്മറ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ സൗജന്യ കാർഡിയോളജി, ഡയബറ്റോളജി, ജനറൽ മെഡിസിൻ,ഡെൻറ്റൽ എന്നീ വിഭവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ ക്യാമ്പിന് നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2255.jpeg",
    },
    {
      src: "assets/img/Pastevents/2256.jpeg",
      caption:
        "കേരളാ പോലീസ് പെൻഷനേഴ്സ് വെൽഫെയർ അസോസിയേഷൻ നെയ്യാറ്റിൻകര താലൂക്ക്  കമ്മറ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ സൗജന്യ കാർഡിയോളജി, ഡയബറ്റോളജി, ജനറൽ മെഡിസിൻ,ഡെൻറ്റൽ എന്നീ വിഭവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ ക്യാമ്പിന് നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2256.jpeg",
    },
    {
      src: "assets/img/Pastevents/2257.jpeg",
      caption:
        "കേരളാ പോലീസ് പെൻഷനേഴ്സ് വെൽഫെയർ അസോസിയേഷൻ നെയ്യാറ്റിൻകര താലൂക്ക്  കമ്മറ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ സൗജന്യ കാർഡിയോളജി, ഡയബറ്റോളജി, ജനറൽ മെഡിസിൻ,ഡെൻറ്റൽ എന്നീ വിഭവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ ക്യാമ്പിന് നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2257.jpeg",
    },
    {
      src: "assets/img/Pastevents/2258.jpeg",
      caption:
        "കേരളാ പോലീസ് പെൻഷനേഴ്സ് വെൽഫെയർ അസോസിയേഷൻ നെയ്യാറ്റിൻകര താലൂക്ക്  കമ്മറ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ സൗജന്യ കാർഡിയോളജി, ഡയബറ്റോളജി, ജനറൽ മെഡിസിൻ,ഡെൻറ്റൽ എന്നീ വിഭവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ ക്യാമ്പിന് നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2258.jpeg",
    },
    {
      src: "assets/img/Pastevents/2259.jpeg",
      caption:
        "കേരളാ പോലീസ് പെൻഷനേഴ്സ് വെൽഫെയർ അസോസിയേഷൻ നെയ്യാറ്റിൻകര താലൂക്ക്  കമ്മറ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ സൗജന്യ കാർഡിയോളജി, ഡയബറ്റോളജി, ജനറൽ മെഡിസിൻ,ഡെൻറ്റൽ എന്നീ വിഭവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ ക്യാമ്പിന് നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2259.jpeg",
    },
    {
      src: "assets/img/Pastevents/2260.jpeg",
      caption:
        "കേരളാ പോലീസ് പെൻഷനേഴ്സ് വെൽഫെയർ അസോസിയേഷൻ നെയ്യാറ്റിൻകര താലൂക്ക്  കമ്മറ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ സൗജന്യ കാർഡിയോളജി, ഡയബറ്റോളജി, ജനറൽ മെഡിസിൻ,ഡെൻറ്റൽ എന്നീ വിഭവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ ക്യാമ്പിന് നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2260.jpeg",
    },
    {
      src: "assets/img/Pastevents/2261.jpeg",
      caption:
        "കേരളാ പോലീസ് പെൻഷനേഴ്സ് വെൽഫെയർ അസോസിയേഷൻ നെയ്യാറ്റിൻകര താലൂക്ക്  കമ്മറ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ സൗജന്യ കാർഡിയോളജി, ഡയബറ്റോളജി, ജനറൽ മെഡിസിൻ,ഡെൻറ്റൽ എന്നീ വിഭവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ ക്യാമ്പിന് നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2261.jpeg",
    },
    {
      src: "assets/img/Pastevents/2249.jpeg",
      caption:
        "(2-ദിവസം)മാരാവിള ദേവീ ചാരിറ്റബിൾ ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ സൗജന്യ കാർഡിയോളജി, ഡയബറ്റോളജി, ജനറൽ മെഡിസിൻ,ഡെൻറ്റൽ എന്നീ വിഭവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ ക്യാമ്പിന് നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2249.jpeg",
    },
    {
      src: "assets/img/Pastevents/2250.jpeg",
      caption:
        "(2-ദിവസം)മാരാവിള ദേവീ ചാരിറ്റബിൾ ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ സൗജന്യ കാർഡിയോളജി, ഡയബറ്റോളജി, ജനറൽ മെഡിസിൻ,ഡെൻറ്റൽ എന്നീ വിഭവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ ക്യാമ്പിന് നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2250.jpeg",
    },
    {
      src: "assets/img/Pastevents/2251.jpeg",
      caption:
        "(2-ദിവസം)മാരാവിള ദേവീ ചാരിറ്റബിൾ ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ സൗജന്യ കാർഡിയോളജി, ഡയബറ്റോളജി, ജനറൽ മെഡിസിൻ,ഡെൻറ്റൽ എന്നീ വിഭവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ ക്യാമ്പിന് നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2251.jpeg",
    },
    {
      src: "assets/img/Pastevents/2252.jpeg",
      caption:
        "(2-ദിവസം)മാരാവിള ദേവീ ചാരിറ്റബിൾ ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ സൗജന്യ കാർഡിയോളജി, ഡയബറ്റോളജി, ജനറൽ മെഡിസിൻ,ഡെൻറ്റൽ എന്നീ വിഭവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ ക്യാമ്പിന് നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2252.jpeg",
    },
    {
      src: "assets/img/Pastevents/2253.jpeg",
      caption:
        "(2-ദിവസം)മാരാവിള ദേവീ ചാരിറ്റബിൾ ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ സൗജന്യ കാർഡിയോളജി, ഡയബറ്റോളജി, ജനറൽ മെഡിസിൻ,ഡെൻറ്റൽ എന്നീ വിഭവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ ക്യാമ്പിന് നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2253.jpeg",
    },
    {
      src: "assets/img/Pastevents/2254.jpeg",
      caption:
        "(2-ദിവസം)മാരാവിള ദേവീ ചാരിറ്റബിൾ ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ സൗജന്യ കാർഡിയോളജി, ഡയബറ്റോളജി, ജനറൽ മെഡിസിൻ,ഡെൻറ്റൽ എന്നീ വിഭവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ ക്യാമ്പിന് നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2254.jpeg",
    },
    {
      src: "assets/img/Pastevents/2241.jpeg",
      caption:
        "പി എൻ പണിക്കർ ഫൗണ്ടേഷൻൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ സൗജന്യ കാർഡിയോളജി, ഡയബറ്റോളജി, ജനറൽ മെഡിസിൻ,ഡെൻറ്റൽ എന്നീ വിഭവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ ക്യാമ്പിന് നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2241.jpeg",
    },
    {
      src: "assets/img/Pastevents/2242.jpeg",
      caption:
        "പി എൻ പണിക്കർ ഫൗണ്ടേഷൻൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ സൗജന്യ കാർഡിയോളജി, ഡയബറ്റോളജി, ജനറൽ മെഡിസിൻ,ഡെൻറ്റൽ എന്നീ വിഭവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ ക്യാമ്പിന് നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2242.jpeg",
    },
    {
      src: "assets/img/Pastevents/2243.jpeg",
      caption:
        "പി എൻ പണിക്കർ ഫൗണ്ടേഷൻൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ സൗജന്യ കാർഡിയോളജി, ഡയബറ്റോളജി, ജനറൽ മെഡിസിൻ,ഡെൻറ്റൽ എന്നീ വിഭവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ ക്യാമ്പിന് നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2243.jpeg",
    },
    {
      src: "assets/img/Pastevents/2244.jpeg",
      caption:
        "പി എൻ പണിക്കർ ഫൗണ്ടേഷൻൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ സൗജന്യ കാർഡിയോളജി, ഡയബറ്റോളജി, ജനറൽ മെഡിസിൻ,ഡെൻറ്റൽ എന്നീ വിഭവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ ക്യാമ്പിന് നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2244.jpeg",
    },
    {
      src: "assets/img/Pastevents/2245.jpeg",
      caption:
        "പി എൻ പണിക്കർ ഫൗണ്ടേഷൻൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ സൗജന്യ കാർഡിയോളജി, ഡയബറ്റോളജി, ജനറൽ മെഡിസിൻ,ഡെൻറ്റൽ എന്നീ വിഭവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ ക്യാമ്പിന് നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2245.jpeg",
    },
    {
      src: "assets/img/Pastevents/2246.jpeg",
      caption:
        "പി എൻ പണിക്കർ ഫൗണ്ടേഷൻൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ സൗജന്യ കാർഡിയോളജി, ഡയബറ്റോളജി, ജനറൽ മെഡിസിൻ,ഡെൻറ്റൽ എന്നീ വിഭവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ ക്യാമ്പിന് നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2246.jpeg",
    },
    {
      src: "assets/img/Pastevents/2247.jpeg",
      caption:
        "പി എൻ പണിക്കർ ഫൗണ്ടേഷൻൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ സൗജന്യ കാർഡിയോളജി, ഡയബറ്റോളജി, ജനറൽ മെഡിസിൻ,ഡെൻറ്റൽ എന്നീ വിഭവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ ക്യാമ്പിന് നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2247.jpeg",
    },
    {
      src: "assets/img/Pastevents/2248.jpeg",
      caption:
        "പി എൻ പണിക്കർ ഫൗണ്ടേഷൻൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ സൗജന്യ കാർഡിയോളജി, ഡയബറ്റോളജി, ജനറൽ മെഡിസിൻ,ഡെൻറ്റൽ എന്നീ വിഭവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ ക്യാമ്പിന് നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2248.jpeg",
    },
    {
      src: "assets/img/Pastevents/2235.jpeg",
      caption:
        "മാരാവിള ദേവീ ചാരിറ്റബിൾ ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ സൗജന്യ കാർഡിയോളജി, ഡയബറ്റോളജി, ജനറൽ മെഡിസിൻ,ഡെൻറ്റൽ എന്നീ വിഭവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ ക്യാമ്പിന് നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2235.jpeg",
    },
    {
      src: "assets/img/Pastevents/2236.jpeg",
      caption:
        "മാരാവിള ദേവീ ചാരിറ്റബിൾ ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ സൗജന്യ കാർഡിയോളജി, ഡയബറ്റോളജി, ജനറൽ മെഡിസിൻ,ഡെൻറ്റൽ എന്നീ വിഭവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ ക്യാമ്പിന് നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2236.jpeg",
    },
    {
      src: "assets/img/Pastevents/2237.jpeg",
      caption:
        "മാരാവിള ദേവീ ചാരിറ്റബിൾ ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ സൗജന്യ കാർഡിയോളജി, ഡയബറ്റോളജി, ജനറൽ മെഡിസിൻ,ഡെൻറ്റൽ എന്നീ വിഭവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ ക്യാമ്പിന് നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2237.jpeg",
    },
    {
      src: "assets/img/Pastevents/2238.jpeg",
      caption:
        "മാരാവിള ദേവീ ചാരിറ്റബിൾ ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ സൗജന്യ കാർഡിയോളജി, ഡയബറ്റോളജി, ജനറൽ മെഡിസിൻ,ഡെൻറ്റൽ എന്നീ വിഭവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ ക്യാമ്പിന് നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2238.jpeg",
    },
    {
      src: "assets/img/Pastevents/2239.jpeg",
      caption:
        "മാരാവിള ദേവീ ചാരിറ്റബിൾ ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ സൗജന്യ കാർഡിയോളജി, ഡയബറ്റോളജി, ജനറൽ മെഡിസിൻ,ഡെൻറ്റൽ എന്നീ വിഭവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ ക്യാമ്പിന് നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2239.jpeg",
    },
    {
      src: "assets/img/Pastevents/2240.jpeg",
      caption:
        "മാരാവിള ദേവീ ചാരിറ്റബിൾ ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ സൗജന്യ കാർഡിയോളജി, ഡയബറ്റോളജി, ജനറൽ മെഡിസിൻ,ഡെൻറ്റൽ എന്നീ വിഭവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ ക്യാമ്പിന് നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2240.jpeg",
    },

    {
      src: "assets/img/Pastevents/2228.jpeg",
      caption:
        "ചെമ്പൂര് ചിലംബറ ദേവി ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു .ക്യാമ്പിൽ സൗജന്യ കാർഡിയോളജി, ഡയബറ്റോളജി, ജനറൽ മെഡിസിൻ,ഡെൻറ്റൽ എന്നീ വിഭവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ ക്യാമ്പിന് നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2228.jpeg",
    },
    {
      src: "assets/img/Pastevents/2229.jpeg",
      caption:
        "ചെമ്പൂര് ചിലംബറ ദേവി ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു .ക്യാമ്പിൽ സൗജന്യ കാർഡിയോളജി, ഡയബറ്റോളജി, ജനറൽ മെഡിസിൻ,ഡെൻറ്റൽ എന്നീ വിഭവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ ക്യാമ്പിന് നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2229.jpeg",
    },
    {
      src: "assets/img/Pastevents/2230.jpeg",
      caption:
        "ചെമ്പൂര് ചിലംബറ ദേവി ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു .ക്യാമ്പിൽ സൗജന്യ കാർഡിയോളജി, ഡയബറ്റോളജി, ജനറൽ മെഡിസിൻ,ഡെൻറ്റൽ എന്നീ വിഭവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ ക്യാമ്പിന് നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2230.jpeg",
    },
    {
      src: "assets/img/Pastevents/2231.jpeg",
      caption:
        "ചെമ്പൂര് ചിലംബറ ദേവി ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു .ക്യാമ്പിൽ സൗജന്യ കാർഡിയോളജി, ഡയബറ്റോളജി, ജനറൽ മെഡിസിൻ,ഡെൻറ്റൽ എന്നീ വിഭവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ ക്യാമ്പിന് നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2231.jpeg",
    },
    {
      src: "assets/img/Pastevents/2232.jpeg",
      caption:
        "ചെമ്പൂര് ചിലംബറ ദേവി ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു .ക്യാമ്പിൽ സൗജന്യ കാർഡിയോളജി, ഡയബറ്റോളജി, ജനറൽ മെഡിസിൻ,ഡെൻറ്റൽ എന്നീ വിഭവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ ക്യാമ്പിന് നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2232.jpeg",
    },
    {
      src: "assets/img/Pastevents/2233.jpeg",
      caption:
        "ചെമ്പൂര് ചിലംബറ ദേവി ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു .ക്യാമ്പിൽ സൗജന്യ കാർഡിയോളജി, ഡയബറ്റോളജി, ജനറൽ മെഡിസിൻ,ഡെൻറ്റൽ എന്നീ വിഭവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ ക്യാമ്പിന് നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2233.jpeg",
    },
    {
      src: "assets/img/Pastevents/2234.jpeg",
      caption:
        "ചെമ്പൂര് ചിലംബറ ദേവി ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു .ക്യാമ്പിൽ സൗജന്യ കാർഡിയോളജി, ഡയബറ്റോളജി, ജനറൽ മെഡിസിൻ,ഡെൻറ്റൽ എന്നീ വിഭവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ ക്യാമ്പിന് നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2234.jpeg",
    },
    {
      src: "assets/img/Pastevents/2214.jpeg",
      caption:
        "ആറ്റുകാൽ പൊങ്കാല മഹോത്സവത്തോട് അനുബന്ധിച്ച് നിംസ് മെഡിസിറ്റിയുടെ നേത്യത്വത്തിൽ തലസ്ഥാനത്തിൻ്റെ വിവിധ ഭാഗങ്ങളിൽ നടന്ന സൗജന്യ മെഡിക്കൽ  ക്യാമ്പിൽ മൂവായിരത്തോളം  പേർ ചികിത്സക്ക് വിധേയരായി.ഈ ക്യാമ്പ് വലിയ വിജയമാക്കാൻ ഞങ്ങളോട് സഹകരിച്ച വിവിധ സംഘടനകളോടുളള നന്ദിയും കടപ്പാടും അറിയിക്കുന്നു.ക്യാമ്പുകളുടെ സുഗമമായ നടത്തിപ്പിന് നേതൃത്വം നൽകിയ ഡോക്ടർമാരായ ഡേ: ജിജോ മാർട്ടിൻ, ഡേ: ഷഹീൻ, ഡേ: ആനന്ദ്, ഡേ: ദിലീപ്, ഡേ: അഡ്‌ലിൻ മേഴ്സി, ഡേ: അതുല്യ മോഹൻ, ഡേ: അഖിജ, ഡേ: ബ്ലസ്വിൻ, ഡേ: ഹസ്സൻ , ജോസ്ഫിൻ(വൈസ് പ്രിൻസിപ്പൽ നിംസ് നഴ്സിംഗ് കോളേജ്)നിംസ് നഴ്സിംഗ് സൂപ്രണ്ട് ദീപ്തി, നഴ്സിംഗ് ഓഫീസർമാരായായ അനു, സജിതാ, ശാലിനി,സൗമ്യ, അഷ്ലിൻ, ശരണ്യ, സ്റ്റാഫുകളായ ദിവ്യാ, രശ്മി,നിംസ് നഴ്സിംഗ്കോളേജ് വിദ്യാർഥികൾ, അനീഷ്(സന്നദ്ധസേവകൻ) ഡ്രൈവർമരായ ,സനൽ,കുമാർ,അനിൽകുമാർ, സാബു ഏവർക്കും നിംസ് മെഡിസിറ്റിയുടെ നന്ദി.....",
      thumb: "assets/img/Pastevents/2214.jpeg",
    },
    {
      src: "assets/img/Pastevents/2215.jpeg",
      caption:
        "ആറ്റുകാൽ പൊങ്കാല മഹോത്സവത്തോട് അനുബന്ധിച്ച് നിംസ് മെഡിസിറ്റിയുടെ നേത്യത്വത്തിൽ തലസ്ഥാനത്തിൻ്റെ വിവിധ ഭാഗങ്ങളിൽ നടന്ന സൗജന്യ മെഡിക്കൽ  ക്യാമ്പിൽ മൂവായിരത്തോളം  പേർ ചികിത്സക്ക് വിധേയരായി.ഈ ക്യാമ്പ് വലിയ വിജയമാക്കാൻ ഞങ്ങളോട് സഹകരിച്ച വിവിധ സംഘടനകളോടുളള നന്ദിയും കടപ്പാടും അറിയിക്കുന്നു.ക്യാമ്പുകളുടെ സുഗമമായ നടത്തിപ്പിന് നേതൃത്വം നൽകിയ ഡോക്ടർമാരായ ഡേ: ജിജോ മാർട്ടിൻ, ഡേ: ഷഹീൻ, ഡേ: ആനന്ദ്, ഡേ: ദിലീപ്, ഡേ: അഡ്‌ലിൻ മേഴ്സി, ഡേ: അതുല്യ മോഹൻ, ഡേ: അഖിജ, ഡേ: ബ്ലസ്വിൻ, ഡേ: ഹസ്സൻ , ജോസ്ഫിൻ(വൈസ് പ്രിൻസിപ്പൽ നിംസ് നഴ്സിംഗ് കോളേജ്)നിംസ് നഴ്സിംഗ് സൂപ്രണ്ട് ദീപ്തി, നഴ്സിംഗ് ഓഫീസർമാരായായ അനു, സജിതാ, ശാലിനി,സൗമ്യ, അഷ്ലിൻ, ശരണ്യ, സ്റ്റാഫുകളായ ദിവ്യാ, രശ്മി,നിംസ് നഴ്സിംഗ്കോളേജ് വിദ്യാർഥികൾ, അനീഷ്(സന്നദ്ധസേവകൻ) ഡ്രൈവർമരായ ,സനൽ,കുമാർ,അനിൽകുമാർ, സാബു ഏവർക്കും നിംസ് മെഡിസിറ്റിയുടെ നന്ദി.....",
      thumb: "assets/img/Pastevents/2215.jpeg",
    },
    {
      src: "assets/img/Pastevents/2216.jpeg",
      caption:
        "ആറ്റുകാൽ പൊങ്കാല മഹോത്സവത്തോട് അനുബന്ധിച്ച് നിംസ് മെഡിസിറ്റിയുടെ നേത്യത്വത്തിൽ തലസ്ഥാനത്തിൻ്റെ വിവിധ ഭാഗങ്ങളിൽ നടന്ന സൗജന്യ മെഡിക്കൽ  ക്യാമ്പിൽ മൂവായിരത്തോളം  പേർ ചികിത്സക്ക് വിധേയരായി.ഈ ക്യാമ്പ് വലിയ വിജയമാക്കാൻ ഞങ്ങളോട് സഹകരിച്ച വിവിധ സംഘടനകളോടുളള നന്ദിയും കടപ്പാടും അറിയിക്കുന്നു.ക്യാമ്പുകളുടെ സുഗമമായ നടത്തിപ്പിന് നേതൃത്വം നൽകിയ ഡോക്ടർമാരായ ഡേ: ജിജോ മാർട്ടിൻ, ഡേ: ഷഹീൻ, ഡേ: ആനന്ദ്, ഡേ: ദിലീപ്, ഡേ: അഡ്‌ലിൻ മേഴ്സി, ഡേ: അതുല്യ മോഹൻ, ഡേ: അഖിജ, ഡേ: ബ്ലസ്വിൻ, ഡേ: ഹസ്സൻ , ജോസ്ഫിൻ(വൈസ് പ്രിൻസിപ്പൽ നിംസ് നഴ്സിംഗ് കോളേജ്)നിംസ് നഴ്സിംഗ് സൂപ്രണ്ട് ദീപ്തി, നഴ്സിംഗ് ഓഫീസർമാരായായ അനു, സജിതാ, ശാലിനി,സൗമ്യ, അഷ്ലിൻ, ശരണ്യ, സ്റ്റാഫുകളായ ദിവ്യാ, രശ്മി,നിംസ് നഴ്സിംഗ്കോളേജ് വിദ്യാർഥികൾ, അനീഷ്(സന്നദ്ധസേവകൻ) ഡ്രൈവർമരായ ,സനൽ,കുമാർ,അനിൽകുമാർ, സാബു ഏവർക്കും നിംസ് മെഡിസിറ്റിയുടെ നന്ദി.....",
      thumb: "assets/img/Pastevents/2216.jpeg",
    },
    {
      src: "assets/img/Pastevents/2217.jpeg",
      caption:
        "ആറ്റുകാൽ പൊങ്കാല മഹോത്സവത്തോട് അനുബന്ധിച്ച് നിംസ് മെഡിസിറ്റിയുടെ നേത്യത്വത്തിൽ തലസ്ഥാനത്തിൻ്റെ വിവിധ ഭാഗങ്ങളിൽ നടന്ന സൗജന്യ മെഡിക്കൽ  ക്യാമ്പിൽ മൂവായിരത്തോളം  പേർ ചികിത്സക്ക് വിധേയരായി.ഈ ക്യാമ്പ് വലിയ വിജയമാക്കാൻ ഞങ്ങളോട് സഹകരിച്ച വിവിധ സംഘടനകളോടുളള നന്ദിയും കടപ്പാടും അറിയിക്കുന്നു.ക്യാമ്പുകളുടെ സുഗമമായ നടത്തിപ്പിന് നേതൃത്വം നൽകിയ ഡോക്ടർമാരായ ഡേ: ജിജോ മാർട്ടിൻ, ഡേ: ഷഹീൻ, ഡേ: ആനന്ദ്, ഡേ: ദിലീപ്, ഡേ: അഡ്‌ലിൻ മേഴ്സി, ഡേ: അതുല്യ മോഹൻ, ഡേ: അഖിജ, ഡേ: ബ്ലസ്വിൻ, ഡേ: ഹസ്സൻ , ജോസ്ഫിൻ(വൈസ് പ്രിൻസിപ്പൽ നിംസ് നഴ്സിംഗ് കോളേജ്)നിംസ് നഴ്സിംഗ് സൂപ്രണ്ട് ദീപ്തി, നഴ്സിംഗ് ഓഫീസർമാരായായ അനു, സജിതാ, ശാലിനി,സൗമ്യ, അഷ്ലിൻ, ശരണ്യ, സ്റ്റാഫുകളായ ദിവ്യാ, രശ്മി,നിംസ് നഴ്സിംഗ്കോളേജ് വിദ്യാർഥികൾ, അനീഷ്(സന്നദ്ധസേവകൻ) ഡ്രൈവർമരായ ,സനൽ,കുമാർ,അനിൽകുമാർ, സാബു ഏവർക്കും നിംസ് മെഡിസിറ്റിയുടെ നന്ദി.....",
      thumb: "assets/img/Pastevents/2217.jpeg",
    },
    {
      src: "assets/img/Pastevents/2218.jpeg",
      caption:
        "ആറ്റുകാൽ പൊങ്കാല മഹോത്സവത്തോട് അനുബന്ധിച്ച് നിംസ് മെഡിസിറ്റിയുടെ നേത്യത്വത്തിൽ തലസ്ഥാനത്തിൻ്റെ വിവിധ ഭാഗങ്ങളിൽ നടന്ന സൗജന്യ മെഡിക്കൽ  ക്യാമ്പിൽ മൂവായിരത്തോളം  പേർ ചികിത്സക്ക് വിധേയരായി.ഈ ക്യാമ്പ് വലിയ വിജയമാക്കാൻ ഞങ്ങളോട് സഹകരിച്ച വിവിധ സംഘടനകളോടുളള നന്ദിയും കടപ്പാടും അറിയിക്കുന്നു.ക്യാമ്പുകളുടെ സുഗമമായ നടത്തിപ്പിന് നേതൃത്വം നൽകിയ ഡോക്ടർമാരായ ഡേ: ജിജോ മാർട്ടിൻ, ഡേ: ഷഹീൻ, ഡേ: ആനന്ദ്, ഡേ: ദിലീപ്, ഡേ: അഡ്‌ലിൻ മേഴ്സി, ഡേ: അതുല്യ മോഹൻ, ഡേ: അഖിജ, ഡേ: ബ്ലസ്വിൻ, ഡേ: ഹസ്സൻ , ജോസ്ഫിൻ(വൈസ് പ്രിൻസിപ്പൽ നിംസ് നഴ്സിംഗ് കോളേജ്)നിംസ് നഴ്സിംഗ് സൂപ്രണ്ട് ദീപ്തി, നഴ്സിംഗ് ഓഫീസർമാരായായ അനു, സജിതാ, ശാലിനി,സൗമ്യ, അഷ്ലിൻ, ശരണ്യ, സ്റ്റാഫുകളായ ദിവ്യാ, രശ്മി,നിംസ് നഴ്സിംഗ്കോളേജ് വിദ്യാർഥികൾ, അനീഷ്(സന്നദ്ധസേവകൻ) ഡ്രൈവർമരായ ,സനൽ,കുമാർ,അനിൽകുമാർ, സാബു ഏവർക്കും നിംസ് മെഡിസിറ്റിയുടെ നന്ദി.....",
      thumb: "assets/img/Pastevents/2218.jpeg",
    },
    {
      src: "assets/img/Pastevents/2219.jpeg",
      caption:
        "ആറ്റുകാൽ പൊങ്കാല മഹോത്സവത്തോട് അനുബന്ധിച്ച് നിംസ് മെഡിസിറ്റിയുടെ നേത്യത്വത്തിൽ തലസ്ഥാനത്തിൻ്റെ വിവിധ ഭാഗങ്ങളിൽ നടന്ന സൗജന്യ മെഡിക്കൽ  ക്യാമ്പിൽ മൂവായിരത്തോളം  പേർ ചികിത്സക്ക് വിധേയരായി.ഈ ക്യാമ്പ് വലിയ വിജയമാക്കാൻ ഞങ്ങളോട് സഹകരിച്ച വിവിധ സംഘടനകളോടുളള നന്ദിയും കടപ്പാടും അറിയിക്കുന്നു.ക്യാമ്പുകളുടെ സുഗമമായ നടത്തിപ്പിന് നേതൃത്വം നൽകിയ ഡോക്ടർമാരായ ഡേ: ജിജോ മാർട്ടിൻ, ഡേ: ഷഹീൻ, ഡേ: ആനന്ദ്, ഡേ: ദിലീപ്, ഡേ: അഡ്‌ലിൻ മേഴ്സി, ഡേ: അതുല്യ മോഹൻ, ഡേ: അഖിജ, ഡേ: ബ്ലസ്വിൻ, ഡേ: ഹസ്സൻ , ജോസ്ഫിൻ(വൈസ് പ്രിൻസിപ്പൽ നിംസ് നഴ്സിംഗ് കോളേജ്)നിംസ് നഴ്സിംഗ് സൂപ്രണ്ട് ദീപ്തി, നഴ്സിംഗ് ഓഫീസർമാരായായ അനു, സജിതാ, ശാലിനി,സൗമ്യ, അഷ്ലിൻ, ശരണ്യ, സ്റ്റാഫുകളായ ദിവ്യാ, രശ്മി,നിംസ് നഴ്സിംഗ്കോളേജ് വിദ്യാർഥികൾ, അനീഷ്(സന്നദ്ധസേവകൻ) ഡ്രൈവർമരായ ,സനൽ,കുമാർ,അനിൽകുമാർ, സാബു ഏവർക്കും നിംസ് മെഡിസിറ്റിയുടെ നന്ദി.....",
      thumb: "assets/img/Pastevents/2219.jpeg",
    },
    {
      src: "assets/img/Pastevents/2220.jpeg",
      caption:
        "ആറ്റുകാൽ പൊങ്കാല മഹോത്സവത്തോട് അനുബന്ധിച്ച് നിംസ് മെഡിസിറ്റിയുടെ നേത്യത്വത്തിൽ തലസ്ഥാനത്തിൻ്റെ വിവിധ ഭാഗങ്ങളിൽ നടന്ന സൗജന്യ മെഡിക്കൽ  ക്യാമ്പിൽ മൂവായിരത്തോളം  പേർ ചികിത്സക്ക് വിധേയരായി.ഈ ക്യാമ്പ് വലിയ വിജയമാക്കാൻ ഞങ്ങളോട് സഹകരിച്ച വിവിധ സംഘടനകളോടുളള നന്ദിയും കടപ്പാടും അറിയിക്കുന്നു.ക്യാമ്പുകളുടെ സുഗമമായ നടത്തിപ്പിന് നേതൃത്വം നൽകിയ ഡോക്ടർമാരായ ഡേ: ജിജോ മാർട്ടിൻ, ഡേ: ഷഹീൻ, ഡേ: ആനന്ദ്, ഡേ: ദിലീപ്, ഡേ: അഡ്‌ലിൻ മേഴ്സി, ഡേ: അതുല്യ മോഹൻ, ഡേ: അഖിജ, ഡേ: ബ്ലസ്വിൻ, ഡേ: ഹസ്സൻ , ജോസ്ഫിൻ(വൈസ് പ്രിൻസിപ്പൽ നിംസ് നഴ്സിംഗ് കോളേജ്)നിംസ് നഴ്സിംഗ് സൂപ്രണ്ട് ദീപ്തി, നഴ്സിംഗ് ഓഫീസർമാരായായ അനു, സജിതാ, ശാലിനി,സൗമ്യ, അഷ്ലിൻ, ശരണ്യ, സ്റ്റാഫുകളായ ദിവ്യാ, രശ്മി,നിംസ് നഴ്സിംഗ്കോളേജ് വിദ്യാർഥികൾ, അനീഷ്(സന്നദ്ധസേവകൻ) ഡ്രൈവർമരായ ,സനൽ,കുമാർ,അനിൽകുമാർ, സാബു ഏവർക്കും നിംസ് മെഡിസിറ്റിയുടെ നന്ദി.....",
      thumb: "assets/img/Pastevents/2220.jpeg",
    },
    {
      src: "assets/img/Pastevents/2221.jpeg",
      caption:
        "ആറ്റുകാൽ പൊങ്കാല മഹോത്സവത്തോട് അനുബന്ധിച്ച് നിംസ് മെഡിസിറ്റിയുടെ നേത്യത്വത്തിൽ തലസ്ഥാനത്തിൻ്റെ വിവിധ ഭാഗങ്ങളിൽ നടന്ന സൗജന്യ മെഡിക്കൽ  ക്യാമ്പിൽ മൂവായിരത്തോളം  പേർ ചികിത്സക്ക് വിധേയരായി.ഈ ക്യാമ്പ് വലിയ വിജയമാക്കാൻ ഞങ്ങളോട് സഹകരിച്ച വിവിധ സംഘടനകളോടുളള നന്ദിയും കടപ്പാടും അറിയിക്കുന്നു.ക്യാമ്പുകളുടെ സുഗമമായ നടത്തിപ്പിന് നേതൃത്വം നൽകിയ ഡോക്ടർമാരായ ഡേ: ജിജോ മാർട്ടിൻ, ഡേ: ഷഹീൻ, ഡേ: ആനന്ദ്, ഡേ: ദിലീപ്, ഡേ: അഡ്‌ലിൻ മേഴ്സി, ഡേ: അതുല്യ മോഹൻ, ഡേ: അഖിജ, ഡേ: ബ്ലസ്വിൻ, ഡേ: ഹസ്സൻ , ജോസ്ഫിൻ(വൈസ് പ്രിൻസിപ്പൽ നിംസ് നഴ്സിംഗ് കോളേജ്)നിംസ് നഴ്സിംഗ് സൂപ്രണ്ട് ദീപ്തി, നഴ്സിംഗ് ഓഫീസർമാരായായ അനു, സജിതാ, ശാലിനി,സൗമ്യ, അഷ്ലിൻ, ശരണ്യ, സ്റ്റാഫുകളായ ദിവ്യാ, രശ്മി,നിംസ് നഴ്സിംഗ്കോളേജ് വിദ്യാർഥികൾ, അനീഷ്(സന്നദ്ധസേവകൻ) ഡ്രൈവർമരായ ,സനൽ,കുമാർ,അനിൽകുമാർ, സാബു ഏവർക്കും നിംസ് മെഡിസിറ്റിയുടെ നന്ദി.....",
      thumb: "assets/img/Pastevents/2221.jpeg",
    },
    {
      src: "assets/img/Pastevents/2222.jpeg",
      caption:
        "ആറ്റുകാൽ പൊങ്കാല മഹോത്സവത്തോട് അനുബന്ധിച്ച് നിംസ് മെഡിസിറ്റിയുടെ നേത്യത്വത്തിൽ തലസ്ഥാനത്തിൻ്റെ വിവിധ ഭാഗങ്ങളിൽ നടന്ന സൗജന്യ മെഡിക്കൽ  ക്യാമ്പിൽ മൂവായിരത്തോളം  പേർ ചികിത്സക്ക് വിധേയരായി.ഈ ക്യാമ്പ് വലിയ വിജയമാക്കാൻ ഞങ്ങളോട് സഹകരിച്ച വിവിധ സംഘടനകളോടുളള നന്ദിയും കടപ്പാടും അറിയിക്കുന്നു.ക്യാമ്പുകളുടെ സുഗമമായ നടത്തിപ്പിന് നേതൃത്വം നൽകിയ ഡോക്ടർമാരായ ഡേ: ജിജോ മാർട്ടിൻ, ഡേ: ഷഹീൻ, ഡേ: ആനന്ദ്, ഡേ: ദിലീപ്, ഡേ: അഡ്‌ലിൻ മേഴ്സി, ഡേ: അതുല്യ മോഹൻ, ഡേ: അഖിജ, ഡേ: ബ്ലസ്വിൻ, ഡേ: ഹസ്സൻ , ജോസ്ഫിൻ(വൈസ് പ്രിൻസിപ്പൽ നിംസ് നഴ്സിംഗ് കോളേജ്)നിംസ് നഴ്സിംഗ് സൂപ്രണ്ട് ദീപ്തി, നഴ്സിംഗ് ഓഫീസർമാരായായ അനു, സജിതാ, ശാലിനി,സൗമ്യ, അഷ്ലിൻ, ശരണ്യ, സ്റ്റാഫുകളായ ദിവ്യാ, രശ്മി,നിംസ് നഴ്സിംഗ്കോളേജ് വിദ്യാർഥികൾ, അനീഷ്(സന്നദ്ധസേവകൻ) ഡ്രൈവർമരായ ,സനൽ,കുമാർ,അനിൽകുമാർ, സാബു ഏവർക്കും നിംസ് മെഡിസിറ്റിയുടെ നന്ദി.....",
      thumb: "assets/img/Pastevents/2222.jpeg",
    },
    {
      src: "assets/img/Pastevents/2223.jpeg",
      caption:
        "ആറ്റുകാൽ പൊങ്കാല മഹോത്സവത്തോട് അനുബന്ധിച്ച് നിംസ് മെഡിസിറ്റിയുടെ നേത്യത്വത്തിൽ തലസ്ഥാനത്തിൻ്റെ വിവിധ ഭാഗങ്ങളിൽ നടന്ന സൗജന്യ മെഡിക്കൽ  ക്യാമ്പിൽ മൂവായിരത്തോളം  പേർ ചികിത്സക്ക് വിധേയരായി.ഈ ക്യാമ്പ് വലിയ വിജയമാക്കാൻ ഞങ്ങളോട് സഹകരിച്ച വിവിധ സംഘടനകളോടുളള നന്ദിയും കടപ്പാടും അറിയിക്കുന്നു.ക്യാമ്പുകളുടെ സുഗമമായ നടത്തിപ്പിന് നേതൃത്വം നൽകിയ ഡോക്ടർമാരായ ഡേ: ജിജോ മാർട്ടിൻ, ഡേ: ഷഹീൻ, ഡേ: ആനന്ദ്, ഡേ: ദിലീപ്, ഡേ: അഡ്‌ലിൻ മേഴ്സി, ഡേ: അതുല്യ മോഹൻ, ഡേ: അഖിജ, ഡേ: ബ്ലസ്വിൻ, ഡേ: ഹസ്സൻ , ജോസ്ഫിൻ(വൈസ് പ്രിൻസിപ്പൽ നിംസ് നഴ്സിംഗ് കോളേജ്)നിംസ് നഴ്സിംഗ് സൂപ്രണ്ട് ദീപ്തി, നഴ്സിംഗ് ഓഫീസർമാരായായ അനു, സജിതാ, ശാലിനി,സൗമ്യ, അഷ്ലിൻ, ശരണ്യ, സ്റ്റാഫുകളായ ദിവ്യാ, രശ്മി,നിംസ് നഴ്സിംഗ്കോളേജ് വിദ്യാർഥികൾ, അനീഷ്(സന്നദ്ധസേവകൻ) ഡ്രൈവർമരായ ,സനൽ,കുമാർ,അനിൽകുമാർ, സാബു ഏവർക്കും നിംസ് മെഡിസിറ്റിയുടെ നന്ദി.....",
      thumb: "assets/img/Pastevents/2223.jpeg",
    },
    {
      src: "assets/img/Pastevents/2224.jpeg",
      caption:
        "ആറ്റുകാൽ പൊങ്കാല മഹോത്സവത്തോട് അനുബന്ധിച്ച് നിംസ് മെഡിസിറ്റിയുടെ നേത്യത്വത്തിൽ തലസ്ഥാനത്തിൻ്റെ വിവിധ ഭാഗങ്ങളിൽ നടന്ന സൗജന്യ മെഡിക്കൽ  ക്യാമ്പിൽ മൂവായിരത്തോളം  പേർ ചികിത്സക്ക് വിധേയരായി.ഈ ക്യാമ്പ് വലിയ വിജയമാക്കാൻ ഞങ്ങളോട് സഹകരിച്ച വിവിധ സംഘടനകളോടുളള നന്ദിയും കടപ്പാടും അറിയിക്കുന്നു.ക്യാമ്പുകളുടെ സുഗമമായ നടത്തിപ്പിന് നേതൃത്വം നൽകിയ ഡോക്ടർമാരായ ഡേ: ജിജോ മാർട്ടിൻ, ഡേ: ഷഹീൻ, ഡേ: ആനന്ദ്, ഡേ: ദിലീപ്, ഡേ: അഡ്‌ലിൻ മേഴ്സി, ഡേ: അതുല്യ മോഹൻ, ഡേ: അഖിജ, ഡേ: ബ്ലസ്വിൻ, ഡേ: ഹസ്സൻ , ജോസ്ഫിൻ(വൈസ് പ്രിൻസിപ്പൽ നിംസ് നഴ്സിംഗ് കോളേജ്)നിംസ് നഴ്സിംഗ് സൂപ്രണ്ട് ദീപ്തി, നഴ്സിംഗ് ഓഫീസർമാരായായ അനു, സജിതാ, ശാലിനി,സൗമ്യ, അഷ്ലിൻ, ശരണ്യ, സ്റ്റാഫുകളായ ദിവ്യാ, രശ്മി,നിംസ് നഴ്സിംഗ്കോളേജ് വിദ്യാർഥികൾ, അനീഷ്(സന്നദ്ധസേവകൻ) ഡ്രൈവർമരായ ,സനൽ,കുമാർ,അനിൽകുമാർ, സാബു ഏവർക്കും നിംസ് മെഡിസിറ്റിയുടെ നന്ദി.....",
      thumb: "assets/img/Pastevents/2224.jpeg",
    },
    {
      src: "assets/img/Pastevents/2225.jpeg",
      caption:
        "ആറ്റുകാൽ പൊങ്കാല മഹോത്സവത്തോട് അനുബന്ധിച്ച് നിംസ് മെഡിസിറ്റിയുടെ നേത്യത്വത്തിൽ തലസ്ഥാനത്തിൻ്റെ വിവിധ ഭാഗങ്ങളിൽ നടന്ന സൗജന്യ മെഡിക്കൽ  ക്യാമ്പിൽ മൂവായിരത്തോളം  പേർ ചികിത്സക്ക് വിധേയരായി.ഈ ക്യാമ്പ് വലിയ വിജയമാക്കാൻ ഞങ്ങളോട് സഹകരിച്ച വിവിധ സംഘടനകളോടുളള നന്ദിയും കടപ്പാടും അറിയിക്കുന്നു.ക്യാമ്പുകളുടെ സുഗമമായ നടത്തിപ്പിന് നേതൃത്വം നൽകിയ ഡോക്ടർമാരായ ഡേ: ജിജോ മാർട്ടിൻ, ഡേ: ഷഹീൻ, ഡേ: ആനന്ദ്, ഡേ: ദിലീപ്, ഡേ: അഡ്‌ലിൻ മേഴ്സി, ഡേ: അതുല്യ മോഹൻ, ഡേ: അഖിജ, ഡേ: ബ്ലസ്വിൻ, ഡേ: ഹസ്സൻ , ജോസ്ഫിൻ(വൈസ് പ്രിൻസിപ്പൽ നിംസ് നഴ്സിംഗ് കോളേജ്)നിംസ് നഴ്സിംഗ് സൂപ്രണ്ട് ദീപ്തി, നഴ്സിംഗ് ഓഫീസർമാരായായ അനു, സജിതാ, ശാലിനി,സൗമ്യ, അഷ്ലിൻ, ശരണ്യ, സ്റ്റാഫുകളായ ദിവ്യാ, രശ്മി,നിംസ് നഴ്സിംഗ്കോളേജ് വിദ്യാർഥികൾ, അനീഷ്(സന്നദ്ധസേവകൻ) ഡ്രൈവർമരായ ,സനൽ,കുമാർ,അനിൽകുമാർ, സാബു ഏവർക്കും നിംസ് മെഡിസിറ്റിയുടെ നന്ദി.....",
      thumb: "assets/img/Pastevents/2225.jpeg",
    },
    {
      src: "assets/img/Pastevents/2226.jpeg",
      caption:
        "ആറ്റുകാൽ പൊങ്കാല മഹോത്സവത്തോട് അനുബന്ധിച്ച് നിംസ് മെഡിസിറ്റിയുടെ നേത്യത്വത്തിൽ തലസ്ഥാനത്തിൻ്റെ വിവിധ ഭാഗങ്ങളിൽ നടന്ന സൗജന്യ മെഡിക്കൽ  ക്യാമ്പിൽ മൂവായിരത്തോളം  പേർ ചികിത്സക്ക് വിധേയരായി.ഈ ക്യാമ്പ് വലിയ വിജയമാക്കാൻ ഞങ്ങളോട് സഹകരിച്ച വിവിധ സംഘടനകളോടുളള നന്ദിയും കടപ്പാടും അറിയിക്കുന്നു.ക്യാമ്പുകളുടെ സുഗമമായ നടത്തിപ്പിന് നേതൃത്വം നൽകിയ ഡോക്ടർമാരായ ഡേ: ജിജോ മാർട്ടിൻ, ഡേ: ഷഹീൻ, ഡേ: ആനന്ദ്, ഡേ: ദിലീപ്, ഡേ: അഡ്‌ലിൻ മേഴ്സി, ഡേ: അതുല്യ മോഹൻ, ഡേ: അഖിജ, ഡേ: ബ്ലസ്വിൻ, ഡേ: ഹസ്സൻ , ജോസ്ഫിൻ(വൈസ് പ്രിൻസിപ്പൽ നിംസ് നഴ്സിംഗ് കോളേജ്)നിംസ് നഴ്സിംഗ് സൂപ്രണ്ട് ദീപ്തി, നഴ്സിംഗ് ഓഫീസർമാരായായ അനു, സജിതാ, ശാലിനി,സൗമ്യ, അഷ്ലിൻ, ശരണ്യ, സ്റ്റാഫുകളായ ദിവ്യാ, രശ്മി,നിംസ് നഴ്സിംഗ്കോളേജ് വിദ്യാർഥികൾ, അനീഷ്(സന്നദ്ധസേവകൻ) ഡ്രൈവർമരായ ,സനൽ,കുമാർ,അനിൽകുമാർ, സാബു ഏവർക്കും നിംസ് മെഡിസിറ്റിയുടെ നന്ദി.....",
      thumb: "assets/img/Pastevents/2226.jpeg",
    },
    {
      src: "assets/img/Pastevents/2227.jpeg",
      caption:
        "ആറ്റുകാൽ പൊങ്കാല മഹോത്സവത്തോട് അനുബന്ധിച്ച് നിംസ് മെഡിസിറ്റിയുടെ നേത്യത്വത്തിൽ തലസ്ഥാനത്തിൻ്റെ വിവിധ ഭാഗങ്ങളിൽ നടന്ന സൗജന്യ മെഡിക്കൽ  ക്യാമ്പിൽ മൂവായിരത്തോളം  പേർ ചികിത്സക്ക് വിധേയരായി.ഈ ക്യാമ്പ് വലിയ വിജയമാക്കാൻ ഞങ്ങളോട് സഹകരിച്ച വിവിധ സംഘടനകളോടുളള നന്ദിയും കടപ്പാടും അറിയിക്കുന്നു.ക്യാമ്പുകളുടെ സുഗമമായ നടത്തിപ്പിന് നേതൃത്വം നൽകിയ ഡോക്ടർമാരായ ഡേ: ജിജോ മാർട്ടിൻ, ഡേ: ഷഹീൻ, ഡേ: ആനന്ദ്, ഡേ: ദിലീപ്, ഡേ: അഡ്‌ലിൻ മേഴ്സി, ഡേ: അതുല്യ മോഹൻ, ഡേ: അഖിജ, ഡേ: ബ്ലസ്വിൻ, ഡേ: ഹസ്സൻ , ജോസ്ഫിൻ(വൈസ് പ്രിൻസിപ്പൽ നിംസ് നഴ്സിംഗ് കോളേജ്)നിംസ് നഴ്സിംഗ് സൂപ്രണ്ട് ദീപ്തി, നഴ്സിംഗ് ഓഫീസർമാരായായ അനു, സജിതാ, ശാലിനി,സൗമ്യ, അഷ്ലിൻ, ശരണ്യ, സ്റ്റാഫുകളായ ദിവ്യാ, രശ്മി,നിംസ് നഴ്സിംഗ്കോളേജ് വിദ്യാർഥികൾ, അനീഷ്(സന്നദ്ധസേവകൻ) ഡ്രൈവർമരായ ,സനൽ,കുമാർ,അനിൽകുമാർ, സാബു ഏവർക്കും നിംസ് മെഡിസിറ്റിയുടെ നന്ദി.....",
      thumb: "assets/img/Pastevents/2227.jpeg",
    },
    {
      src: "assets/img/Pastevents/2206.jpeg",
      caption:
        "ബാപ്പുജി നഗർ മേരി നിലയം സീനിയർ സെക്കൻഡറി സ്കൂൾ , തിരുവനന്തപുരം  ക്യാപിറ്റൽ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ സൗജന്യ കാർഡിയോളജി, ഡയബറ്റോളജി, ജനറൽ മെഡിസിൻ,ഡെൻറ്റൽ എന്നീ വിഭവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ ക്യാമ്പിന് നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2206.jpeg",
    },
    {
      src: "assets/img/Pastevents/2207.jpeg",
      caption:
        "ബാപ്പുജി നഗർ മേരി നിലയം സീനിയർ സെക്കൻഡറി സ്കൂൾ , തിരുവനന്തപുരം  ക്യാപിറ്റൽ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ സൗജന്യ കാർഡിയോളജി, ഡയബറ്റോളജി, ജനറൽ മെഡിസിൻ,ഡെൻറ്റൽ എന്നീ വിഭവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ ക്യാമ്പിന് നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2207.jpeg",
    },
    {
      src: "assets/img/Pastevents/2208.jpeg",
      caption:
        "ബാപ്പുജി നഗർ മേരി നിലയം സീനിയർ സെക്കൻഡറി സ്കൂൾ , തിരുവനന്തപുരം  ക്യാപിറ്റൽ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ സൗജന്യ കാർഡിയോളജി, ഡയബറ്റോളജി, ജനറൽ മെഡിസിൻ,ഡെൻറ്റൽ എന്നീ വിഭവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ ക്യാമ്പിന് നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2208.jpeg",
    },
    {
      src: "assets/img/Pastevents/2209.jpeg",
      caption:
        "ബാപ്പുജി നഗർ മേരി നിലയം സീനിയർ സെക്കൻഡറി സ്കൂൾ , തിരുവനന്തപുരം  ക്യാപിറ്റൽ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ സൗജന്യ കാർഡിയോളജി, ഡയബറ്റോളജി, ജനറൽ മെഡിസിൻ,ഡെൻറ്റൽ എന്നീ വിഭവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ ക്യാമ്പിന് നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2209.jpeg",
    },
    {
      src: "assets/img/Pastevents/2210.jpeg",
      caption:
        "ബാപ്പുജി നഗർ മേരി നിലയം സീനിയർ സെക്കൻഡറി സ്കൂൾ , തിരുവനന്തപുരം  ക്യാപിറ്റൽ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ സൗജന്യ കാർഡിയോളജി, ഡയബറ്റോളജി, ജനറൽ മെഡിസിൻ,ഡെൻറ്റൽ എന്നീ വിഭവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ ക്യാമ്പിന് നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2210.jpeg",
    },
    {
      src: "assets/img/Pastevents/2211.jpeg",
      caption:
        "ബാപ്പുജി നഗർ മേരി നിലയം സീനിയർ സെക്കൻഡറി സ്കൂൾ , തിരുവനന്തപുരം  ക്യാപിറ്റൽ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ സൗജന്യ കാർഡിയോളജി, ഡയബറ്റോളജി, ജനറൽ മെഡിസിൻ,ഡെൻറ്റൽ എന്നീ വിഭവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ ക്യാമ്പിന് നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2211.jpeg",
    },
    {
      src: "assets/img/Pastevents/2212.jpeg",
      caption:
        "ബാപ്പുജി നഗർ മേരി നിലയം സീനിയർ സെക്കൻഡറി സ്കൂൾ , തിരുവനന്തപുരം  ക്യാപിറ്റൽ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ സൗജന്യ കാർഡിയോളജി, ഡയബറ്റോളജി, ജനറൽ മെഡിസിൻ,ഡെൻറ്റൽ എന്നീ വിഭവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ ക്യാമ്പിന് നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2212.jpeg",
    },
    {
      src: "assets/img/Pastevents/2213.jpeg",
      caption:
        "ബാപ്പുജി നഗർ മേരി നിലയം സീനിയർ സെക്കൻഡറി സ്കൂൾ , തിരുവനന്തപുരം  ക്യാപിറ്റൽ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ സൗജന്യ കാർഡിയോളജി, ഡയബറ്റോളജി, ജനറൽ മെഡിസിൻ,ഡെൻറ്റൽ എന്നീ വിഭവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ ക്യാമ്പിന് നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2213.jpeg",
    },
    {
      src: "assets/img/Pastevents/2200.jpeg",
      caption:
        "പനവൂർ മുഹിധിയീൻ മുസ്ലിം ജുമാ മസ്ജിദിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ സൗജന്യ കാർഡിയോളജി, ഡയബറ്റോളജി, ജനറൽ മെഡിസിൻ,ഡെൻറ്റൽ എന്നീ വിഭവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ ക്യാമ്പിന് നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2200.jpeg",
    },
    {
      src: "assets/img/Pastevents/2201.jpeg",
      caption:
        "പനവൂർ മുഹിധിയീൻ മുസ്ലിം ജുമാ മസ്ജിദിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ സൗജന്യ കാർഡിയോളജി, ഡയബറ്റോളജി, ജനറൽ മെഡിസിൻ,ഡെൻറ്റൽ എന്നീ വിഭവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ ക്യാമ്പിന് നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2201.jpeg",
    },
    {
      src: "assets/img/Pastevents/2202.jpeg",
      caption:
        "പനവൂർ മുഹിധിയീൻ മുസ്ലിം ജുമാ മസ്ജിദിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ സൗജന്യ കാർഡിയോളജി, ഡയബറ്റോളജി, ജനറൽ മെഡിസിൻ,ഡെൻറ്റൽ എന്നീ വിഭവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ ക്യാമ്പിന് നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2202.jpeg",
    },
    {
      src: "assets/img/Pastevents/2203.jpeg",
      caption:
        "പനവൂർ മുഹിധിയീൻ മുസ്ലിം ജുമാ മസ്ജിദിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ സൗജന്യ കാർഡിയോളജി, ഡയബറ്റോളജി, ജനറൽ മെഡിസിൻ,ഡെൻറ്റൽ എന്നീ വിഭവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ ക്യാമ്പിന് നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2203.jpeg",
    },
    {
      src: "assets/img/Pastevents/2204.jpeg",
      caption:
        "പനവൂർ മുഹിധിയീൻ മുസ്ലിം ജുമാ മസ്ജിദിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ സൗജന്യ കാർഡിയോളജി, ഡയബറ്റോളജി, ജനറൽ മെഡിസിൻ,ഡെൻറ്റൽ എന്നീ വിഭവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ ക്യാമ്പിന് നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2204.jpeg",
    },
    {
      src: "assets/img/Pastevents/2205.jpeg",
      caption:
        "പനവൂർ മുഹിധിയീൻ മുസ്ലിം ജുമാ മസ്ജിദിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ സൗജന്യ കാർഡിയോളജി, ഡയബറ്റോളജി, ജനറൽ മെഡിസിൻ,ഡെൻറ്റൽ എന്നീ വിഭവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ ക്യാമ്പിന് നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2205.jpeg",
    },

    {
      src: "assets/img/Pastevents/2194.jpeg",
      caption:
        "പാളയം യൂണിവേഴ്സിറ്റി കോളേജ് യൂണിയൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ സൗജന്യ കാർഡിയോളജി, ഡയബറ്റോളജി, ജനറൽ മെഡിസിൻ,ഡെൻറ്റൽ എന്നീ വിഭവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ ക്യാമ്പിന് നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2194.jpeg",
    },
    {
      src: "assets/img/Pastevents/2195.jpeg",
      caption:
        "പാളയം യൂണിവേഴ്സിറ്റി കോളേജ് യൂണിയൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ സൗജന്യ കാർഡിയോളജി, ഡയബറ്റോളജി, ജനറൽ മെഡിസിൻ,ഡെൻറ്റൽ എന്നീ വിഭവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ ക്യാമ്പിന് നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2195.jpeg",
    },
    {
      src: "assets/img/Pastevents/2196.jpeg",
      caption:
        "പാളയം യൂണിവേഴ്സിറ്റി കോളേജ് യൂണിയൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ സൗജന്യ കാർഡിയോളജി, ഡയബറ്റോളജി, ജനറൽ മെഡിസിൻ,ഡെൻറ്റൽ എന്നീ വിഭവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ ക്യാമ്പിന് നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2196.jpeg",
    },
    {
      src: "assets/img/Pastevents/2197.jpeg",
      caption:
        "പാളയം യൂണിവേഴ്സിറ്റി കോളേജ് യൂണിയൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ സൗജന്യ കാർഡിയോളജി, ഡയബറ്റോളജി, ജനറൽ മെഡിസിൻ,ഡെൻറ്റൽ എന്നീ വിഭവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ ക്യാമ്പിന് നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2197.jpeg",
    },
    {
      src: "assets/img/Pastevents/2198.jpeg",
      caption:
        "പാളയം യൂണിവേഴ്സിറ്റി കോളേജ് യൂണിയൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ സൗജന്യ കാർഡിയോളജി, ഡയബറ്റോളജി, ജനറൽ മെഡിസിൻ,ഡെൻറ്റൽ എന്നീ വിഭവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ ക്യാമ്പിന് നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2198.jpeg",
    },
    {
      src: "assets/img/Pastevents/2199.jpeg",
      caption:
        "പാളയം യൂണിവേഴ്സിറ്റി കോളേജ് യൂണിയൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ സൗജന്യ കാർഡിയോളജി, ഡയബറ്റോളജി, ജനറൽ മെഡിസിൻ,ഡെൻറ്റൽ എന്നീ വിഭവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ ക്യാമ്പിന് നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2199.jpeg",
    },
    {
      src: "assets/img/Pastevents/2187.jpeg",
      caption:
        "KSRTC  ആരംഭിച്ച ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 100-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2187.jpeg",
    },
    {
      src: "assets/img/Pastevents/2188.jpeg",
      caption:
        "KSRTC  ആരംഭിച്ച ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 100-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2188.jpeg",
    },
    {
      src: "assets/img/Pastevents/2189.jpeg",
      caption:
        "KSRTC  ആരംഭിച്ച ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 100-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2189.jpeg",
    },
    {
      src: "assets/img/Pastevents/2190.jpeg",
      caption:
        "KSRTC  ആരംഭിച്ച ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 100-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2190.jpeg",
    },
    {
      src: "assets/img/Pastevents/2191jpeg",
      caption:
        "KSRTC  ആരംഭിച്ച ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 100-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2191.jpeg",
    },
    {
      src: "assets/img/Pastevents/2192.jpeg",
      caption:
        "KSRTC  ആരംഭിച്ച ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 100-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2192.jpeg",
    },
    {
      src: "assets/img/Pastevents/2193.jpeg",
      caption:
        "KSRTC  ആരംഭിച്ച ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 100-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2193.jpeg",
    },
    {
      src: "assets/img/Pastevents/2180.jpeg",
      caption:
        "(രണ്ടാം ദിവസം) തമ്പാനൂർ മലയാള മനോരമയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.150-തിൽപ്പരംമലയാള മനോരമ ജീവനക്കാരും ഏജൻ്റ്മാരും ക്യാമ്പിൻ്റെ ഭാഗമായി.ക്യാമ്പിൽ സൗജന്യ കാർഡിയോളജി, ഡയബറ്റോളജി, ജനറൽ മെഡിസിൻ,ഡെൻറ്റൽ എന്നീ വിഭവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ ക്യാമ്പിന് നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2180.jpeg",
    },
    {
      src: "assets/img/Pastevents/2181.jpeg",
      caption:
        "(രണ്ടാം ദിവസം) തമ്പാനൂർ മലയാള മനോരമയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.150-തിൽപ്പരംമലയാള മനോരമ ജീവനക്കാരും ഏജൻ്റ്മാരും ക്യാമ്പിൻ്റെ ഭാഗമായി.ക്യാമ്പിൽ സൗജന്യ കാർഡിയോളജി, ഡയബറ്റോളജി, ജനറൽ മെഡിസിൻ,ഡെൻറ്റൽ എന്നീ വിഭവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ ക്യാമ്പിന് നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2181.jpeg",
    },
    {
      src: "assets/img/Pastevents/2182.jpeg",
      caption:
        "(രണ്ടാം ദിവസം) തമ്പാനൂർ മലയാള മനോരമയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.150-തിൽപ്പരംമലയാള മനോരമ ജീവനക്കാരും ഏജൻ്റ്മാരും ക്യാമ്പിൻ്റെ ഭാഗമായി.ക്യാമ്പിൽ സൗജന്യ കാർഡിയോളജി, ഡയബറ്റോളജി, ജനറൽ മെഡിസിൻ,ഡെൻറ്റൽ എന്നീ വിഭവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ ക്യാമ്പിന് നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2182.jpeg",
    },
    {
      src: "assets/img/Pastevents/2183.jpeg",
      caption:
        "(രണ്ടാം ദിവസം) തമ്പാനൂർ മലയാള മനോരമയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.150-തിൽപ്പരംമലയാള മനോരമ ജീവനക്കാരും ഏജൻ്റ്മാരും ക്യാമ്പിൻ്റെ ഭാഗമായി.ക്യാമ്പിൽ സൗജന്യ കാർഡിയോളജി, ഡയബറ്റോളജി, ജനറൽ മെഡിസിൻ,ഡെൻറ്റൽ എന്നീ വിഭവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ ക്യാമ്പിന് നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2183.jpeg",
    },
    {
      src: "assets/img/Pastevents/2184.jpeg",
      caption:
        "(രണ്ടാം ദിവസം) തമ്പാനൂർ മലയാള മനോരമയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.150-തിൽപ്പരംമലയാള മനോരമ ജീവനക്കാരും ഏജൻ്റ്മാരും ക്യാമ്പിൻ്റെ ഭാഗമായി.ക്യാമ്പിൽ സൗജന്യ കാർഡിയോളജി, ഡയബറ്റോളജി, ജനറൽ മെഡിസിൻ,ഡെൻറ്റൽ എന്നീ വിഭവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ ക്യാമ്പിന് നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2184.jpeg",
    },
    {
      src: "assets/img/Pastevents/2185.jpeg",
      caption:
        "(രണ്ടാം ദിവസം) തമ്പാനൂർ മലയാള മനോരമയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.150-തിൽപ്പരംമലയാള മനോരമ ജീവനക്കാരും ഏജൻ്റ്മാരും ക്യാമ്പിൻ്റെ ഭാഗമായി.ക്യാമ്പിൽ സൗജന്യ കാർഡിയോളജി, ഡയബറ്റോളജി, ജനറൽ മെഡിസിൻ,ഡെൻറ്റൽ എന്നീ വിഭവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ ക്യാമ്പിന് നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2185.jpeg",
    },
    {
      src: "assets/img/Pastevents/2186.jpeg",
      caption:
        "(രണ്ടാം ദിവസം) തമ്പാനൂർ മലയാള മനോരമയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.150-തിൽപ്പരംമലയാള മനോരമ ജീവനക്കാരും ഏജൻ്റ്മാരും ക്യാമ്പിൻ്റെ ഭാഗമായി.ക്യാമ്പിൽ സൗജന്യ കാർഡിയോളജി, ഡയബറ്റോളജി, ജനറൽ മെഡിസിൻ,ഡെൻറ്റൽ എന്നീ വിഭവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ ക്യാമ്പിന് നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2186.jpeg",
    },
    {
      src: "assets/img/Pastevents/2173.jpeg",
      caption:
        "തമ്പാനൂർ മലയാള മനോരമയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.150-തിൽപ്പരംമലയാള മനോരമ ജീവനക്കാരും ഏജൻ്റ്മാരും ക്യാമ്പിൻ്റെ ഭാഗമായി.ക്യാമ്പിൽ സൗജന്യ കാർഡിയോളജി, ഡയബറ്റോളജി, ജനറൽ മെഡിസിൻ,ഡെൻറ്റൽ എന്നീ വിഭവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ ക്യാമ്പിന് നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2173.jpeg",
    },
    {
      src: "assets/img/Pastevents/2174.jpeg",
      caption:
        "തമ്പാനൂർ മലയാള മനോരമയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.150-തിൽപ്പരംമലയാള മനോരമ ജീവനക്കാരും ഏജൻ്റ്മാരും ക്യാമ്പിൻ്റെ ഭാഗമായി.ക്യാമ്പിൽ സൗജന്യ കാർഡിയോളജി, ഡയബറ്റോളജി, ജനറൽ മെഡിസിൻ,ഡെൻറ്റൽ എന്നീ വിഭവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ ക്യാമ്പിന് നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2174.jpeg",
    },
    {
      src: "assets/img/Pastevents/2175.jpeg",
      caption:
        "തമ്പാനൂർ മലയാള മനോരമയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.150-തിൽപ്പരംമലയാള മനോരമ ജീവനക്കാരും ഏജൻ്റ്മാരും ക്യാമ്പിൻ്റെ ഭാഗമായി.ക്യാമ്പിൽ സൗജന്യ കാർഡിയോളജി, ഡയബറ്റോളജി, ജനറൽ മെഡിസിൻ,ഡെൻറ്റൽ എന്നീ വിഭവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ ക്യാമ്പിന് നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2175.jpeg",
    },
    {
      src: "assets/img/Pastevents/2176.jpeg",
      caption:
        "തമ്പാനൂർ മലയാള മനോരമയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.150-തിൽപ്പരംമലയാള മനോരമ ജീവനക്കാരും ഏജൻ്റ്മാരും ക്യാമ്പിൻ്റെ ഭാഗമായി.ക്യാമ്പിൽ സൗജന്യ കാർഡിയോളജി, ഡയബറ്റോളജി, ജനറൽ മെഡിസിൻ,ഡെൻറ്റൽ എന്നീ വിഭവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ ക്യാമ്പിന് നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2176.jpeg",
    },
    {
      src: "assets/img/Pastevents/2177.jpeg",
      caption:
        "തമ്പാനൂർ മലയാള മനോരമയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.150-തിൽപ്പരംമലയാള മനോരമ ജീവനക്കാരും ഏജൻ്റ്മാരും ക്യാമ്പിൻ്റെ ഭാഗമായി.ക്യാമ്പിൽ സൗജന്യ കാർഡിയോളജി, ഡയബറ്റോളജി, ജനറൽ മെഡിസിൻ,ഡെൻറ്റൽ എന്നീ വിഭവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ ക്യാമ്പിന് നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2177.jpeg",
    },
    {
      src: "assets/img/Pastevents/2178.jpeg",
      caption:
        "തമ്പാനൂർ മലയാള മനോരമയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.150-തിൽപ്പരംമലയാള മനോരമ ജീവനക്കാരും ഏജൻ്റ്മാരും ക്യാമ്പിൻ്റെ ഭാഗമായി.ക്യാമ്പിൽ സൗജന്യ കാർഡിയോളജി, ഡയബറ്റോളജി, ജനറൽ മെഡിസിൻ,ഡെൻറ്റൽ എന്നീ വിഭവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ ക്യാമ്പിന് നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2178.jpeg",
    },
    {
      src: "assets/img/Pastevents/2179.jpeg",
      caption:
        "തമ്പാനൂർ മലയാള മനോരമയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.150-തിൽപ്പരംമലയാള മനോരമ ജീവനക്കാരും ഏജൻ്റ്മാരും ക്യാമ്പിൻ്റെ ഭാഗമായി.ക്യാമ്പിൽ സൗജന്യ കാർഡിയോളജി, ഡയബറ്റോളജി, ജനറൽ മെഡിസിൻ,ഡെൻറ്റൽ എന്നീ വിഭവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ ക്യാമ്പിന് നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2179.jpeg",
    },
    {
      src: "assets/img/Pastevents/2167.jpeg",
      caption:
        "പാങ്ങോട് സേവാ ഭാരതി, ശ്രീരാമ സേവാ സമിതി ജവഹർ കോളനി , ലയൺസ് ക്ലബ് ട്രിവാൻഡ്രം മെജസ്റ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2167.jpeg",
    },
    {
      src: "assets/img/Pastevents/2168.jpeg",
      caption:
        "പാങ്ങോട് സേവാ ഭാരതി, ശ്രീരാമ സേവാ സമിതി ജവഹർ കോളനി , ലയൺസ് ക്ലബ് ട്രിവാൻഡ്രം മെജസ്റ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2168.jpeg",
    },
    {
      src: "assets/img/Pastevents/2169.jpeg",
      caption:
        "പാങ്ങോട് സേവാ ഭാരതി, ശ്രീരാമ സേവാ സമിതി ജവഹർ കോളനി , ലയൺസ് ക്ലബ് ട്രിവാൻഡ്രം മെജസ്റ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2169.jpeg",
    },
    {
      src: "assets/img/Pastevents/2170.jpeg",
      caption:
        "പാങ്ങോട് സേവാ ഭാരതി, ശ്രീരാമ സേവാ സമിതി ജവഹർ കോളനി , ലയൺസ് ക്ലബ് ട്രിവാൻഡ്രം മെജസ്റ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2170.jpeg",
    },
    {
      src: "assets/img/Pastevents/2171.jpeg",
      caption:
        "പാങ്ങോട് സേവാ ഭാരതി, ശ്രീരാമ സേവാ സമിതി ജവഹർ കോളനി , ലയൺസ് ക്ലബ് ട്രിവാൻഡ്രം മെജസ്റ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2171.jpeg",
    },
    {
      src: "assets/img/Pastevents/2172.jpeg",
      caption:
        "പാങ്ങോട് സേവാ ഭാരതി, ശ്രീരാമ സേവാ സമിതി ജവഹർ കോളനി , ലയൺസ് ക്ലബ് ട്രിവാൻഡ്രം മെജസ്റ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2172.jpeg",
    },
    {
      src: "assets/img/Pastevents/2161.jpeg",
      caption:
        "മലയിൻകീഴ് കോൺഫിഡൻ്റ് പി എസ് സി കോച്ചിംഗ് സെൻ്ററിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2161.jpeg",
    },
    {
      src: "assets/img/Pastevents/2162.jpeg",
      caption:
        "മലയിൻകീഴ് കോൺഫിഡൻ്റ് പി എസ് സി കോച്ചിംഗ് സെൻ്ററിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2162.jpeg",
    },
    {
      src: "assets/img/Pastevents/2163.jpeg",
      caption:
        "മലയിൻകീഴ് കോൺഫിഡൻ്റ് പി എസ് സി കോച്ചിംഗ് സെൻ്ററിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2163.jpeg",
    },
    {
      src: "assets/img/Pastevents/2164.jpeg",
      caption:
        "മലയിൻകീഴ് കോൺഫിഡൻ്റ് പി എസ് സി കോച്ചിംഗ് സെൻ്ററിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2164.jpeg",
    },
    {
      src: "assets/img/Pastevents/2165.jpeg",
      caption:
        "മലയിൻകീഴ് കോൺഫിഡൻ്റ് പി എസ് സി കോച്ചിംഗ് സെൻ്ററിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2165.jpeg",
    },
    {
      src: "assets/img/Pastevents/2166.jpeg",
      caption:
        "മലയിൻകീഴ് കോൺഫിഡൻ്റ് പി എസ് സി കോച്ചിംഗ് സെൻ്ററിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2166.jpeg",
    },
    {
      src: "assets/img/Pastevents/2151.jpeg",
      caption:
        " വിതുര ശിശു സൗഹൃദ ജനമൈത്രി പൊലീസ് സ്റ്റേഷൻൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു . ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2151.jpeg",
    },
    {
      src: "assets/img/Pastevents/2152.jpeg",
      caption:
        " വിതുര ശിശു സൗഹൃദ ജനമൈത്രി പൊലീസ് സ്റ്റേഷൻൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു . ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2152.jpeg",
    },
    {
      src: "assets/img/Pastevents/2153.jpeg",
      caption:
        " വിതുര ശിശു സൗഹൃദ ജനമൈത്രി പൊലീസ് സ്റ്റേഷൻൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു . ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി. ക്യാമ്പ് ഉദ്ഘാടനം: ശ്രീ സ്റ്റുവർട്ട് കീലർ (ഡിവൈഎസ്പി നെടുമങ്ങാട് )",
      thumb: "assets/img/Pastevents/2153.jpeg",
    },
    {
      src: "assets/img/Pastevents/2154.jpeg",
      caption:
        " വിതുര ശിശു സൗഹൃദ ജനമൈത്രി പൊലീസ് സ്റ്റേഷൻൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു . ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2154.jpeg",
    },
    {
      src: "assets/img/Pastevents/2155.jpeg",
      caption:
        " വിതുര ശിശു സൗഹൃദ ജനമൈത്രി പൊലീസ് സ്റ്റേഷൻൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു . ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2155.jpeg",
    },
    {
      src: "assets/img/Pastevents/2156.jpeg",
      caption:
        " വിതുര ശിശു സൗഹൃദ ജനമൈത്രി പൊലീസ് സ്റ്റേഷൻൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു . ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2156.jpeg",
    },
    {
      src: "assets/img/Pastevents/2157.jpeg",
      caption:
        " വിതുര ശിശു സൗഹൃദ ജനമൈത്രി പൊലീസ് സ്റ്റേഷൻൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു . ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2157.jpeg",
    },
    {
      src: "assets/img/Pastevents/2158.jpeg",
      caption:
        " വിതുര ശിശു സൗഹൃദ ജനമൈത്രി പൊലീസ് സ്റ്റേഷൻൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു . ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2158.jpeg",
    },
    {
      src: "assets/img/Pastevents/2159.jpeg",
      caption:
        " വിതുര ശിശു സൗഹൃദ ജനമൈത്രി പൊലീസ് സ്റ്റേഷൻൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു . ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2159.jpeg",
    },
    {
      src: "assets/img/Pastevents/2160.jpeg",
      caption:
        " വിതുര ശിശു സൗഹൃദ ജനമൈത്രി പൊലീസ് സ്റ്റേഷൻൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു . ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2160.jpeg",
    },
    {
      src: "assets/img/Pastevents/2145.jpeg",
      caption:
        "ആനാക്കോട് ശ്രീ ഭദ്രകാളി ക്ഷേത്ര ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2145.jpeg",
    },
    {
      src: "assets/img/Pastevents/2146.jpeg",
      caption:
        "ആനാക്കോട് ശ്രീ ഭദ്രകാളി ക്ഷേത്ര ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2146.jpeg",
    },
    {
      src: "assets/img/Pastevents/2147.jpeg",
      caption:
        "ആനാക്കോട് ശ്രീ ഭദ്രകാളി ക്ഷേത്ര ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2147.jpeg",
    },
    {
      src: "assets/img/Pastevents/2148.jpeg",
      caption:
        "ആനാക്കോട് ശ്രീ ഭദ്രകാളി ക്ഷേത്ര ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2148.jpeg",
    },
    {
      src: "assets/img/Pastevents/2149.jpeg",
      caption:
        "ആനാക്കോട് ശ്രീ ഭദ്രകാളി ക്ഷേത്ര ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2149.jpeg",
    },
    {
      src: "assets/img/Pastevents/2150.jpeg",
      caption:
        "ആനാക്കോട് ശ്രീ ഭദ്രകാളി ക്ഷേത്ര ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2150.jpeg",
    },
    {
      src: "assets/img/Pastevents/2138.jpeg",
      caption:
        "KSRTC  ആരംഭിച്ച ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 100-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2138.jpeg",
    },
    {
      src: "assets/img/Pastevents/2139.jpeg",
      caption:
        "KSRTC  ആരംഭിച്ച ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 100-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2139.jpeg",
    },
    {
      src: "assets/img/Pastevents/2140.jpeg",
      caption:
        "KSRTC  ആരംഭിച്ച ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 100-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2140.jpeg",
    },
    {
      src: "assets/img/Pastevents/2141.jpeg",
      caption:
        "KSRTC  ആരംഭിച്ച ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 100-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2141.jpeg",
    },
    {
      src: "assets/img/Pastevents/2142.jpeg",
      caption:
        "KSRTC  ആരംഭിച്ച ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 100-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2142.jpeg",
    },
    {
      src: "assets/img/Pastevents/2143.jpeg",
      caption:
        "KSRTC  ആരംഭിച്ച ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 100-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2143.jpeg",
    },
    {
      src: "assets/img/Pastevents/2144.jpeg",
      caption:
        "KSRTC  ആരംഭിച്ച ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 100-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2144.jpeg",
    },
    {
      src: "assets/img/Pastevents/2131.jpeg",
      caption:
        "അണ്ടുകോട് ശ്രീ മുരുഗൻ കാവടി സംഘത്തിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2131.jpeg",
    },
    {
      src: "assets/img/Pastevents/2132.jpeg",
      caption:
        "അണ്ടുകോട് ശ്രീ മുരുഗൻ കാവടി സംഘത്തിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2132.jpeg",
    },
    {
      src: "assets/img/Pastevents/2133.jpeg",
      caption:
        "അണ്ടുകോട് ശ്രീ മുരുഗൻ കാവടി സംഘത്തിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2133.jpeg",
    },
    {
      src: "assets/img/Pastevents/2134.jpeg",
      caption:
        "അണ്ടുകോട് ശ്രീ മുരുഗൻ കാവടി സംഘത്തിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2134.jpeg",
    },
    {
      src: "assets/img/Pastevents/2135.jpeg",
      caption:
        "അണ്ടുകോട് ശ്രീ മുരുഗൻ കാവടി സംഘത്തിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2135.jpeg",
    },
    {
      src: "assets/img/Pastevents/2136.jpeg",
      caption:
        "അണ്ടുകോട് ശ്രീ മുരുഗൻ കാവടി സംഘത്തിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2136.jpeg",
    },
    {
      src: "assets/img/Pastevents/2137.jpeg",
      caption:
        "അണ്ടുകോട് ശ്രീ മുരുഗൻ കാവടി സംഘത്തിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2137.jpeg",
    },
    {
      src: "assets/img/Pastevents/2126.jpeg",
      caption:
        "കുളത്തൂർ ശ്രീ ഭദ്രകാളി ക്ഷേത്ര ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2126.jpeg",
    },
    {
      src: "assets/img/Pastevents/2127.jpeg",
      caption:
        "കുളത്തൂർ ശ്രീ ഭദ്രകാളി ക്ഷേത്ര ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2127.jpeg",
    },
    {
      src: "assets/img/Pastevents/2128.jpeg",
      caption:
        "കുളത്തൂർ ശ്രീ ഭദ്രകാളി ക്ഷേത്ര ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2128.jpeg",
    },
    {
      src: "assets/img/Pastevents/2129.jpeg",
      caption:
        "കുളത്തൂർ ശ്രീ ഭദ്രകാളി ക്ഷേത്ര ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2129.jpeg",
    },
    {
      src: "assets/img/Pastevents/2130.jpeg",
      caption:
        "കുളത്തൂർ ശ്രീ ഭദ്രകാളി ക്ഷേത്ര ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2130.jpeg",
    },
    {
      src: "assets/img/Pastevents/2121.jpeg",
      caption:
        "വിതുര ശ്രീ മഹാദേവ ക്ഷേത്ര ട്രസ്റ്റ്, പാലോട് കേരളാ കൗമുദി യൂണിറ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2121.jpeg",
    },
    {
      src: "assets/img/Pastevents/2122.jpeg",
      caption:
        "വിതുര ശ്രീ മഹാദേവ ക്ഷേത്ര ട്രസ്റ്റ്, പാലോട് കേരളാ കൗമുദി യൂണിറ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2122.jpeg",
    },
    {
      src: "assets/img/Pastevents/2123.jpeg",
      caption:
        "വിതുര ശ്രീ മഹാദേവ ക്ഷേത്ര ട്രസ്റ്റ്, പാലോട് കേരളാ കൗമുദി യൂണിറ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2123.jpeg",
    },
    {
      src: "assets/img/Pastevents/2124.jpeg",
      caption:
        "വിതുര ശ്രീ മഹാദേവ ക്ഷേത്ര ട്രസ്റ്റ്, പാലോട് കേരളാ കൗമുദി യൂണിറ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2124.jpeg",
    },

    {
      src: "assets/img/Pastevents/2125.jpeg",
      caption:
        "വിതുര ശ്രീ മഹാദേവ ക്ഷേത്ര ട്രസ്റ്റ്, പാലോട് കേരളാ കൗമുദി യൂണിറ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2125.jpeg",
    },
    {
      src: "assets/img/Pastevents/2116.jpeg",
      caption:
        "തമിഴ്നാട് ഗവൺമെൻ്റ് ഹെൽത്ത് ഇൻഷുറൻസ് സ്കീം, അഴകിയമണ്ടപം ക്രിസ്റ്റൽ ലാബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2116.jpeg",
    },
    {
      src: "assets/img/Pastevents/2117.jpeg",
      caption:
        "തമിഴ്നാട് ഗവൺമെൻ്റ് ഹെൽത്ത് ഇൻഷുറൻസ് സ്കീം, അഴകിയമണ്ടപം ക്രിസ്റ്റൽ ലാബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2117.jpeg",
    },
    {
      src: "assets/img/Pastevents/2118.jpeg",
      caption:
        "തമിഴ്നാട് ഗവൺമെൻ്റ് ഹെൽത്ത് ഇൻഷുറൻസ് സ്കീം, അഴകിയമണ്ടപം ക്രിസ്റ്റൽ ലാബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2118.jpeg",
    },
    {
      src: "assets/img/Pastevents/2119.jpeg",
      caption:
        "തമിഴ്നാട് ഗവൺമെൻ്റ് ഹെൽത്ത് ഇൻഷുറൻസ് സ്കീം, അഴകിയമണ്ടപം ക്രിസ്റ്റൽ ലാബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2119.jpeg",
    },
    {
      src: "assets/img/Pastevents/2120.jpeg",
      caption:
        "തമിഴ്നാട് ഗവൺമെൻ്റ് ഹെൽത്ത് ഇൻഷുറൻസ് സ്കീം, അഴകിയമണ്ടപം ക്രിസ്റ്റൽ ലാബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2120.jpeg",
    },
    {
      src: "assets/img/Pastevents/2109.jpeg",
      caption:
        "പാങ്ങോട് സേവാ ഭാരതി, ശ്രീരാമ സേവാ സമിതി ജവഹർ കോളനി , ലയൺസ് ക്ലബ് ട്രിവാൻഡ്രം മെജസ്റ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2109.jpeg",
    },
    {
      src: "assets/img/Pastevents/2110.jpeg",
      caption:
        "പാങ്ങോട് സേവാ ഭാരതി, ശ്രീരാമ സേവാ സമിതി ജവഹർ കോളനി , ലയൺസ് ക്ലബ് ട്രിവാൻഡ്രം മെജസ്റ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2110.jpeg",
    },
    {
      src: "assets/img/Pastevents/2111.jpeg",
      caption:
        "പാങ്ങോട് സേവാ ഭാരതി, ശ്രീരാമ സേവാ സമിതി ജവഹർ കോളനി , ലയൺസ് ക്ലബ് ട്രിവാൻഡ്രം മെജസ്റ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2111.jpeg",
    },
    {
      src: "assets/img/Pastevents/2112.jpeg",
      caption:
        "പാങ്ങോട് സേവാ ഭാരതി, ശ്രീരാമ സേവാ സമിതി ജവഹർ കോളനി , ലയൺസ് ക്ലബ് ട്രിവാൻഡ്രം മെജസ്റ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2112.jpeg",
    },
    {
      src: "assets/img/Pastevents/2113.jpeg",
      caption:
        "പാങ്ങോട് സേവാ ഭാരതി, ശ്രീരാമ സേവാ സമിതി ജവഹർ കോളനി , ലയൺസ് ക്ലബ് ട്രിവാൻഡ്രം മെജസ്റ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2113.jpeg",
    },
    {
      src: "assets/img/Pastevents/2114.jpeg",
      caption:
        "പാങ്ങോട് സേവാ ഭാരതി, ശ്രീരാമ സേവാ സമിതി ജവഹർ കോളനി , ലയൺസ് ക്ലബ് ട്രിവാൻഡ്രം മെജസ്റ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2114.jpeg",
    },
    {
      src: "assets/img/Pastevents/2115.jpeg",
      caption:
        "പാങ്ങോട് സേവാ ഭാരതി, ശ്രീരാമ സേവാ സമിതി ജവഹർ കോളനി , ലയൺസ് ക്ലബ് ട്രിവാൻഡ്രം മെജസ്റ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2115.jpeg",
    },
    {
      src: "assets/img/Pastevents/2096.jpeg",
      caption:
        "ആരോഗ്യമേള-2023. കമുകിൻകോട് സെൻ്റ് ആൻ്റണിസ് ചർച്ചിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ ആരോഗ്യമേള സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി,ഗ്യാസ്ട്രാളജി,ഓർത്തോപീഡിക്കസ്, ഇ എൻ റ്റി, ഒഫ്ത്താൽമോളജി, ഡെൻ്റൽ, ആയുർവേദം എന്നി വിഭാവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.സൗ ജന്യ എക്കോ, ഇ സി ജി, പി എഫ് റ്റി,ഓട്ടിസം സ്ക്രീനിംഗ്, കുട്ടികളിലെ പഠനവൈകല്യം, കേൾവി പരിശോധന, ബ്ലഡ് ഷുഗർ, ബി പി, ബി എം ഐ ടെസ്റ്റുകൾ നടത്തി.",
      thumb: "assets/img/Pastevents/2096.jpeg",
    },
    {
      src: "assets/img/Pastevents/2097.jpeg",
      caption:
        "ആരോഗ്യമേള-2023. കമുകിൻകോട് സെൻ്റ് ആൻ്റണിസ് ചർച്ചിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ ആരോഗ്യമേള സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി,ഗ്യാസ്ട്രാളജി,ഓർത്തോപീഡിക്കസ്, ഇ എൻ റ്റി, ഒഫ്ത്താൽമോളജി, ഡെൻ്റൽ, ആയുർവേദം എന്നി വിഭാവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.സൗ ജന്യ എക്കോ, ഇ സി ജി, പി എഫ് റ്റി,ഓട്ടിസം സ്ക്രീനിംഗ്, കുട്ടികളിലെ പഠനവൈകല്യം, കേൾവി പരിശോധന, ബ്ലഡ് ഷുഗർ, ബി പി, ബി എം ഐ ടെസ്റ്റുകൾ നടത്തി.",
      thumb: "assets/img/Pastevents/2097.jpeg",
    },
    {
      src: "assets/img/Pastevents/2098.jpeg",
      caption:
        "ആരോഗ്യമേള-2023. കമുകിൻകോട് സെൻ്റ് ആൻ്റണിസ് ചർച്ചിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ ആരോഗ്യമേള സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി,ഗ്യാസ്ട്രാളജി,ഓർത്തോപീഡിക്കസ്, ഇ എൻ റ്റി, ഒഫ്ത്താൽമോളജി, ഡെൻ്റൽ, ആയുർവേദം എന്നി വിഭാവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.സൗ ജന്യ എക്കോ, ഇ സി ജി, പി എഫ് റ്റി,ഓട്ടിസം സ്ക്രീനിംഗ്, കുട്ടികളിലെ പഠനവൈകല്യം, കേൾവി പരിശോധന, ബ്ലഡ് ഷുഗർ, ബി പി, ബി എം ഐ ടെസ്റ്റുകൾ നടത്തി.",
      thumb: "assets/img/Pastevents/2098.jpeg",
    },
    {
      src: "assets/img/Pastevents/2099.jpeg",
      caption:
        "ആരോഗ്യമേള-2023. കമുകിൻകോട് സെൻ്റ് ആൻ്റണിസ് ചർച്ചിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ ആരോഗ്യമേള സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി,ഗ്യാസ്ട്രാളജി,ഓർത്തോപീഡിക്കസ്, ഇ എൻ റ്റി, ഒഫ്ത്താൽമോളജി, ഡെൻ്റൽ, ആയുർവേദം എന്നി വിഭാവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.സൗ ജന്യ എക്കോ, ഇ സി ജി, പി എഫ് റ്റി,ഓട്ടിസം സ്ക്രീനിംഗ്, കുട്ടികളിലെ പഠനവൈകല്യം, കേൾവി പരിശോധന, ബ്ലഡ് ഷുഗർ, ബി പി, ബി എം ഐ ടെസ്റ്റുകൾ നടത്തി.",
      thumb: "assets/img/Pastevents/2099.jpeg",
    },
    {
      src: "assets/img/Pastevents/2100.jpeg",
      caption:
        "ആരോഗ്യമേള-2023. കമുകിൻകോട് സെൻ്റ് ആൻ്റണിസ് ചർച്ചിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ ആരോഗ്യമേള സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി,ഗ്യാസ്ട്രാളജി,ഓർത്തോപീഡിക്കസ്, ഇ എൻ റ്റി, ഒഫ്ത്താൽമോളജി, ഡെൻ്റൽ, ആയുർവേദം എന്നി വിഭാവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.സൗ ജന്യ എക്കോ, ഇ സി ജി, പി എഫ് റ്റി,ഓട്ടിസം സ്ക്രീനിംഗ്, കുട്ടികളിലെ പഠനവൈകല്യം, കേൾവി പരിശോധന, ബ്ലഡ് ഷുഗർ, ബി പി, ബി എം ഐ ടെസ്റ്റുകൾ നടത്തി.",
      thumb: "assets/img/Pastevents/2100.jpeg",
    },
    {
      src: "assets/img/Pastevents/2101.jpeg",
      caption:
        "ആരോഗ്യമേള-2023. കമുകിൻകോട് സെൻ്റ് ആൻ്റണിസ് ചർച്ചിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ ആരോഗ്യമേള സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി,ഗ്യാസ്ട്രാളജി,ഓർത്തോപീഡിക്കസ്, ഇ എൻ റ്റി, ഒഫ്ത്താൽമോളജി, ഡെൻ്റൽ, ആയുർവേദം എന്നി വിഭാവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.സൗ ജന്യ എക്കോ, ഇ സി ജി, പി എഫ് റ്റി,ഓട്ടിസം സ്ക്രീനിംഗ്, കുട്ടികളിലെ പഠനവൈകല്യം, കേൾവി പരിശോധന, ബ്ലഡ് ഷുഗർ, ബി പി, ബി എം ഐ ടെസ്റ്റുകൾ നടത്തി.",
      thumb: "assets/img/Pastevents/2101.jpeg",
    },
    {
      src: "assets/img/Pastevents/2102.jpeg",
      caption:
        "ആരോഗ്യമേള-2023. കമുകിൻകോട് സെൻ്റ് ആൻ്റണിസ് ചർച്ചിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ ആരോഗ്യമേള സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി,ഗ്യാസ്ട്രാളജി,ഓർത്തോപീഡിക്കസ്, ഇ എൻ റ്റി, ഒഫ്ത്താൽമോളജി, ഡെൻ്റൽ, ആയുർവേദം എന്നി വിഭാവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.സൗ ജന്യ എക്കോ, ഇ സി ജി, പി എഫ് റ്റി,ഓട്ടിസം സ്ക്രീനിംഗ്, കുട്ടികളിലെ പഠനവൈകല്യം, കേൾവി പരിശോധന, ബ്ലഡ് ഷുഗർ, ബി പി, ബി എം ഐ ടെസ്റ്റുകൾ നടത്തി.",
      thumb: "assets/img/Pastevents/2102.jpeg",
    },
    {
      src: "assets/img/Pastevents/2103.jpeg",
      caption:
        "ആരോഗ്യമേള-2023. കമുകിൻകോട് സെൻ്റ് ആൻ്റണിസ് ചർച്ചിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ ആരോഗ്യമേള സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി,ഗ്യാസ്ട്രാളജി,ഓർത്തോപീഡിക്കസ്, ഇ എൻ റ്റി, ഒഫ്ത്താൽമോളജി, ഡെൻ്റൽ, ആയുർവേദം എന്നി വിഭാവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.സൗ ജന്യ എക്കോ, ഇ സി ജി, പി എഫ് റ്റി,ഓട്ടിസം സ്ക്രീനിംഗ്, കുട്ടികളിലെ പഠനവൈകല്യം, കേൾവി പരിശോധന, ബ്ലഡ് ഷുഗർ, ബി പി, ബി എം ഐ ടെസ്റ്റുകൾ നടത്തി.",
      thumb: "assets/img/Pastevents/2103.jpeg",
    },
    {
      src: "assets/img/Pastevents/2104.jpeg",
      caption:
        "ആരോഗ്യമേള-2023. കമുകിൻകോട് സെൻ്റ് ആൻ്റണിസ് ചർച്ചിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ ആരോഗ്യമേള സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി,ഗ്യാസ്ട്രാളജി,ഓർത്തോപീഡിക്കസ്, ഇ എൻ റ്റി, ഒഫ്ത്താൽമോളജി, ഡെൻ്റൽ, ആയുർവേദം എന്നി വിഭാവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.സൗ ജന്യ എക്കോ, ഇ സി ജി, പി എഫ് റ്റി,ഓട്ടിസം സ്ക്രീനിംഗ്, കുട്ടികളിലെ പഠനവൈകല്യം, കേൾവി പരിശോധന, ബ്ലഡ് ഷുഗർ, ബി പി, ബി എം ഐ ടെസ്റ്റുകൾ നടത്തി.",
      thumb: "assets/img/Pastevents/2104.jpeg",
    },
    {
      src: "assets/img/Pastevents/2105.jpeg",
      caption:
        "ആരോഗ്യമേള-2023. കമുകിൻകോട് സെൻ്റ് ആൻ്റണിസ് ചർച്ചിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ ആരോഗ്യമേള സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി,ഗ്യാസ്ട്രാളജി,ഓർത്തോപീഡിക്കസ്, ഇ എൻ റ്റി, ഒഫ്ത്താൽമോളജി, ഡെൻ്റൽ, ആയുർവേദം എന്നി വിഭാവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.സൗ ജന്യ എക്കോ, ഇ സി ജി, പി എഫ് റ്റി,ഓട്ടിസം സ്ക്രീനിംഗ്, കുട്ടികളിലെ പഠനവൈകല്യം, കേൾവി പരിശോധന, ബ്ലഡ് ഷുഗർ, ബി പി, ബി എം ഐ ടെസ്റ്റുകൾ നടത്തി.",
      thumb: "assets/img/Pastevents/2105.jpeg",
    },
    {
      src: "assets/img/Pastevents/2106.jpeg",
      caption:
        "ആരോഗ്യമേള-2023. കമുകിൻകോട് സെൻ്റ് ആൻ്റണിസ് ചർച്ചിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ ആരോഗ്യമേള സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി,ഗ്യാസ്ട്രാളജി,ഓർത്തോപീഡിക്കസ്, ഇ എൻ റ്റി, ഒഫ്ത്താൽമോളജി, ഡെൻ്റൽ, ആയുർവേദം എന്നി വിഭാവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.സൗ ജന്യ എക്കോ, ഇ സി ജി, പി എഫ് റ്റി,ഓട്ടിസം സ്ക്രീനിംഗ്, കുട്ടികളിലെ പഠനവൈകല്യം, കേൾവി പരിശോധന, ബ്ലഡ് ഷുഗർ, ബി പി, ബി എം ഐ ടെസ്റ്റുകൾ നടത്തി.",
      thumb: "assets/img/Pastevents/2106.jpeg",
    },
    {
      src: "assets/img/Pastevents/2107.jpeg",
      caption:
        "ആരോഗ്യമേള-2023. കമുകിൻകോട് സെൻ്റ് ആൻ്റണിസ് ചർച്ചിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ ആരോഗ്യമേള സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി,ഗ്യാസ്ട്രാളജി,ഓർത്തോപീഡിക്കസ്, ഇ എൻ റ്റി, ഒഫ്ത്താൽമോളജി, ഡെൻ്റൽ, ആയുർവേദം എന്നി വിഭാവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.സൗ ജന്യ എക്കോ, ഇ സി ജി, പി എഫ് റ്റി,ഓട്ടിസം സ്ക്രീനിംഗ്, കുട്ടികളിലെ പഠനവൈകല്യം, കേൾവി പരിശോധന, ബ്ലഡ് ഷുഗർ, ബി പി, ബി എം ഐ ടെസ്റ്റുകൾ നടത്തി.",
      thumb: "assets/img/Pastevents/2107.jpeg",
    },
    {
      src: "assets/img/Pastevents/2108.jpeg",
      caption:
        "ആരോഗ്യമേള-2023. കമുകിൻകോട് സെൻ്റ് ആൻ്റണിസ് ചർച്ചിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ ആരോഗ്യമേള സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി,ഗ്യാസ്ട്രാളജി,ഓർത്തോപീഡിക്കസ്, ഇ എൻ റ്റി, ഒഫ്ത്താൽമോളജി, ഡെൻ്റൽ, ആയുർവേദം എന്നി വിഭാവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.സൗ ജന്യ എക്കോ, ഇ സി ജി, പി എഫ് റ്റി,ഓട്ടിസം സ്ക്രീനിംഗ്, കുട്ടികളിലെ പഠനവൈകല്യം, കേൾവി പരിശോധന, ബ്ലഡ് ഷുഗർ, ബി പി, ബി എം ഐ ടെസ്റ്റുകൾ നടത്തി.",
      thumb: "assets/img/Pastevents/2108.jpeg",
    },
    {
      src: "assets/img/Pastevents/2084.jpeg",
      caption:
        "നെയ്യാറ്റിൻകര ഇൻറ്റെഗ്രൽ ഡെവലപ്പ്മെൻ്റ് സൊസൈറ്റി - നിഡ്സോത്സവ്-2023 നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി, ഒഫ്ത്താൽമോളജി, ഡെൻ്റൽ, ആയുർവേദം എന്നി വിഭാവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.സൗ ജന്യ എക്കോ, ഇ സി ജി, പി എഫ് റ്റി,ഓട്ടിസം സ്ക്രീനിംഗ്, കുട്ടികളിലെ പഠനവൈകല്യം, കേൾവി പരിശോധന, ബ്ലഡ് ഷുഗർ, ബി പി, ബി എം ഐ ടെസ്റ്റുകൾ നടത്തി.",
      thumb: "assets/img/Pastevents/2084.jpeg",
    },
    {
      src: "assets/img/Pastevents/2085.jpeg",
      caption:
        "നെയ്യാറ്റിൻകര ഇൻറ്റെഗ്രൽ ഡെവലപ്പ്മെൻ്റ് സൊസൈറ്റി - നിഡ്സോത്സവ്-2023 നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി, ഒഫ്ത്താൽമോളജി, ഡെൻ്റൽ, ആയുർവേദം എന്നി വിഭാവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.സൗ ജന്യ എക്കോ, ഇ സി ജി, പി എഫ് റ്റി,ഓട്ടിസം സ്ക്രീനിംഗ്, കുട്ടികളിലെ പഠനവൈകല്യം, കേൾവി പരിശോധന, ബ്ലഡ് ഷുഗർ, ബി പി, ബി എം ഐ ടെസ്റ്റുകൾ നടത്തി.",
      thumb: "assets/img/Pastevents/2085.jpeg",
    },
    {
      src: "assets/img/Pastevents/2086.jpeg",
      caption:
        "നെയ്യാറ്റിൻകര ഇൻറ്റെഗ്രൽ ഡെവലപ്പ്മെൻ്റ് സൊസൈറ്റി - നിഡ്സോത്സവ്-2023 നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി, ഒഫ്ത്താൽമോളജി, ഡെൻ്റൽ, ആയുർവേദം എന്നി വിഭാവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.സൗ ജന്യ എക്കോ, ഇ സി ജി, പി എഫ് റ്റി,ഓട്ടിസം സ്ക്രീനിംഗ്, കുട്ടികളിലെ പഠനവൈകല്യം, കേൾവി പരിശോധന, ബ്ലഡ് ഷുഗർ, ബി പി, ബി എം ഐ ടെസ്റ്റുകൾ നടത്തി.",
      thumb: "assets/img/Pastevents/2086.jpeg",
    },
    {
      src: "assets/img/Pastevents/2087.jpeg",
      caption:
        "നെയ്യാറ്റിൻകര ഇൻറ്റെഗ്രൽ ഡെവലപ്പ്മെൻ്റ് സൊസൈറ്റി - നിഡ്സോത്സവ്-2023 നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി, ഒഫ്ത്താൽമോളജി, ഡെൻ്റൽ, ആയുർവേദം എന്നി വിഭാവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.സൗ ജന്യ എക്കോ, ഇ സി ജി, പി എഫ് റ്റി,ഓട്ടിസം സ്ക്രീനിംഗ്, കുട്ടികളിലെ പഠനവൈകല്യം, കേൾവി പരിശോധന, ബ്ലഡ് ഷുഗർ, ബി പി, ബി എം ഐ ടെസ്റ്റുകൾ നടത്തി.",
      thumb: "assets/img/Pastevents/2087.jpeg",
    },
    {
      src: "assets/img/Pastevents/2088.jpeg",
      caption:
        "നെയ്യാറ്റിൻകര ഇൻറ്റെഗ്രൽ ഡെവലപ്പ്മെൻ്റ് സൊസൈറ്റി - നിഡ്സോത്സവ്-2023 നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി, ഒഫ്ത്താൽമോളജി, ഡെൻ്റൽ, ആയുർവേദം എന്നി വിഭാവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.സൗ ജന്യ എക്കോ, ഇ സി ജി, പി എഫ് റ്റി,ഓട്ടിസം സ്ക്രീനിംഗ്, കുട്ടികളിലെ പഠനവൈകല്യം, കേൾവി പരിശോധന, ബ്ലഡ് ഷുഗർ, ബി പി, ബി എം ഐ ടെസ്റ്റുകൾ നടത്തി.",
      thumb: "assets/img/Pastevents/2088.jpeg",
    },
    {
      src: "assets/img/Pastevents/2089.jpeg",
      caption:
        "നെയ്യാറ്റിൻകര ഇൻറ്റെഗ്രൽ ഡെവലപ്പ്മെൻ്റ് സൊസൈറ്റി - നിഡ്സോത്സവ്-2023 നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി, ഒഫ്ത്താൽമോളജി, ഡെൻ്റൽ, ആയുർവേദം എന്നി വിഭാവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.സൗ ജന്യ എക്കോ, ഇ സി ജി, പി എഫ് റ്റി,ഓട്ടിസം സ്ക്രീനിംഗ്, കുട്ടികളിലെ പഠനവൈകല്യം, കേൾവി പരിശോധന, ബ്ലഡ് ഷുഗർ, ബി പി, ബി എം ഐ ടെസ്റ്റുകൾ നടത്തി.",
      thumb: "assets/img/Pastevents/2089.jpeg",
    },
    {
      src: "assets/img/Pastevents/2090.jpeg",
      caption:
        "നെയ്യാറ്റിൻകര ഇൻറ്റെഗ്രൽ ഡെവലപ്പ്മെൻ്റ് സൊസൈറ്റി - നിഡ്സോത്സവ്-2023 നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി, ഒഫ്ത്താൽമോളജി, ഡെൻ്റൽ, ആയുർവേദം എന്നി വിഭാവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.സൗ ജന്യ എക്കോ, ഇ സി ജി, പി എഫ് റ്റി,ഓട്ടിസം സ്ക്രീനിംഗ്, കുട്ടികളിലെ പഠനവൈകല്യം, കേൾവി പരിശോധന, ബ്ലഡ് ഷുഗർ, ബി പി, ബി എം ഐ ടെസ്റ്റുകൾ നടത്തി.",
      thumb: "assets/img/Pastevents/2090.jpeg",
    },
    {
      src: "assets/img/Pastevents/2091.jpeg",
      caption:
        "നെയ്യാറ്റിൻകര ഇൻറ്റെഗ്രൽ ഡെവലപ്പ്മെൻ്റ് സൊസൈറ്റി - നിഡ്സോത്സവ്-2023 നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി, ഒഫ്ത്താൽമോളജി, ഡെൻ്റൽ, ആയുർവേദം എന്നി വിഭാവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.സൗ ജന്യ എക്കോ, ഇ സി ജി, പി എഫ് റ്റി,ഓട്ടിസം സ്ക്രീനിംഗ്, കുട്ടികളിലെ പഠനവൈകല്യം, കേൾവി പരിശോധന, ബ്ലഡ് ഷുഗർ, ബി പി, ബി എം ഐ ടെസ്റ്റുകൾ നടത്തി.",
      thumb: "assets/img/Pastevents/2091.jpeg",
    },
    {
      src: "assets/img/Pastevents/2092.jpeg",
      caption:
        "നെയ്യാറ്റിൻകര ഇൻറ്റെഗ്രൽ ഡെവലപ്പ്മെൻ്റ് സൊസൈറ്റി - നിഡ്സോത്സവ്-2023 നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി, ഒഫ്ത്താൽമോളജി, ഡെൻ്റൽ, ആയുർവേദം എന്നി വിഭാവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.സൗ ജന്യ എക്കോ, ഇ സി ജി, പി എഫ് റ്റി,ഓട്ടിസം സ്ക്രീനിംഗ്, കുട്ടികളിലെ പഠനവൈകല്യം, കേൾവി പരിശോധന, ബ്ലഡ് ഷുഗർ, ബി പി, ബി എം ഐ ടെസ്റ്റുകൾ നടത്തി.",
      thumb: "assets/img/Pastevents/2092.jpeg",
    },
    {
      src: "assets/img/Pastevents/2093.jpeg",
      caption:
        "നെയ്യാറ്റിൻകര ഇൻറ്റെഗ്രൽ ഡെവലപ്പ്മെൻ്റ് സൊസൈറ്റി - നിഡ്സോത്സവ്-2023 നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി, ഒഫ്ത്താൽമോളജി, ഡെൻ്റൽ, ആയുർവേദം എന്നി വിഭാവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.സൗ ജന്യ എക്കോ, ഇ സി ജി, പി എഫ് റ്റി,ഓട്ടിസം സ്ക്രീനിംഗ്, കുട്ടികളിലെ പഠനവൈകല്യം, കേൾവി പരിശോധന, ബ്ലഡ് ഷുഗർ, ബി പി, ബി എം ഐ ടെസ്റ്റുകൾ നടത്തി.",
      thumb: "assets/img/Pastevents/2093.jpeg",
    },
    {
      src: "assets/img/Pastevents/2094.jpeg",
      caption:
        "നെയ്യാറ്റിൻകര ഇൻറ്റെഗ്രൽ ഡെവലപ്പ്മെൻ്റ് സൊസൈറ്റി - നിഡ്സോത്സവ്-2023 നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി, ഒഫ്ത്താൽമോളജി, ഡെൻ്റൽ, ആയുർവേദം എന്നി വിഭാവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.സൗ ജന്യ എക്കോ, ഇ സി ജി, പി എഫ് റ്റി,ഓട്ടിസം സ്ക്രീനിംഗ്, കുട്ടികളിലെ പഠനവൈകല്യം, കേൾവി പരിശോധന, ബ്ലഡ് ഷുഗർ, ബി പി, ബി എം ഐ ടെസ്റ്റുകൾ നടത്തി.",
      thumb: "assets/img/Pastevents/2094.jpeg",
    },
    {
      src: "assets/img/Pastevents/2095.jpeg",
      caption:
        "നെയ്യാറ്റിൻകര ഇൻറ്റെഗ്രൽ ഡെവലപ്പ്മെൻ്റ് സൊസൈറ്റി - നിഡ്സോത്സവ്-2023 നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി, ഒഫ്ത്താൽമോളജി, ഡെൻ്റൽ, ആയുർവേദം എന്നി വിഭാവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.സൗ ജന്യ എക്കോ, ഇ സി ജി, പി എഫ് റ്റി,ഓട്ടിസം സ്ക്രീനിംഗ്, കുട്ടികളിലെ പഠനവൈകല്യം, കേൾവി പരിശോധന, ബ്ലഡ് ഷുഗർ, ബി പി, ബി എം ഐ ടെസ്റ്റുകൾ നടത്തി.",
      thumb: "assets/img/Pastevents/2095.jpeg",
    },
    {
      src: "assets/img/Pastevents/2076.jpeg",
      caption:
        "തത്തിയൂർ ശ്രീ ശിവ ഭഗവതി ക്ഷേത്ര ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ ഡോ: ശ്രീജിത്ത് ( കാർഡിയോളജിസറ്റ് നിംസ് മെഡിസിറ്റി) .. ക്യാമ്പിൽ  ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2076.jpeg",
    },
    {
      src: "assets/img/Pastevents/2077.jpeg",
      caption:
        "തത്തിയൂർ ശ്രീ ശിവ ഭഗവതി ക്ഷേത്ര ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ ഡോ: ശ്രീജിത്ത് ( കാർഡിയോളജിസറ്റ് നിംസ് മെഡിസിറ്റി) .. ക്യാമ്പിൽ  ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2077.jpeg",
    },
    {
      src: "assets/img/Pastevents/2078.jpeg",
      caption:
        "തത്തിയൂർ ശ്രീ ശിവ ഭഗവതി ക്ഷേത്ര ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ ഡോ: ശ്രീജിത്ത് ( കാർഡിയോളജിസറ്റ് നിംസ് മെഡിസിറ്റി) .. ക്യാമ്പിൽ  ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2078.jpeg",
    },
    {
      src: "assets/img/Pastevents/2079.jpeg",
      caption:
        "തത്തിയൂർ ശ്രീ ശിവ ഭഗവതി ക്ഷേത്ര ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ ഡോ: ശ്രീജിത്ത് ( കാർഡിയോളജിസറ്റ് നിംസ് മെഡിസിറ്റി) .. ക്യാമ്പിൽ  ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2079.jpeg",
    },
    {
      src: "assets/img/Pastevents/2080.jpeg",
      caption:
        "തത്തിയൂർ ശ്രീ ശിവ ഭഗവതി ക്ഷേത്ര ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ ഡോ: ശ്രീജിത്ത് ( കാർഡിയോളജിസറ്റ് നിംസ് മെഡിസിറ്റി) .. ക്യാമ്പിൽ  ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2080.jpeg",
    },
    {
      src: "assets/img/Pastevents/2081.jpeg",
      caption:
        "തത്തിയൂർ ശ്രീ ശിവ ഭഗവതി ക്ഷേത്ര ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ ഡോ: ശ്രീജിത്ത് ( കാർഡിയോളജിസറ്റ് നിംസ് മെഡിസിറ്റി) .. ക്യാമ്പിൽ  ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2081.jpeg",
    },
    {
      src: "assets/img/Pastevents/2082.jpeg",
      caption:
        "തത്തിയൂർ ശ്രീ ശിവ ഭഗവതി ക്ഷേത്ര ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ ഡോ: ശ്രീജിത്ത് ( കാർഡിയോളജിസറ്റ് നിംസ് മെഡിസിറ്റി) .. ക്യാമ്പിൽ  ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2082.jpeg",
    },
    {
      src: "assets/img/Pastevents/2083.jpeg",
      caption:
        "തത്തിയൂർ ശ്രീ ശിവ ഭഗവതി ക്ഷേത്ര ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ ഡോ: ശ്രീജിത്ത് ( കാർഡിയോളജിസറ്റ് നിംസ് മെഡിസിറ്റി) .. ക്യാമ്പിൽ  ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2083.jpeg",
    },
    {
      src: "assets/img/Pastevents/2069.jpeg",
      caption:
        " 'മിഠായി' (5) ലോക പ്രമേഹ ദിനത്തോട് അനുബന്ധിച്ച് സ്ക്കൂൾ വിദ്യാർഥികളിലൂടെ പ്രമേഹ അവബോധം കുടുംബത്തിലേയ്ക്കും സമൂഹത്തിലേയ്ക്കും.തിരുവനന്തപുരം ജില്ലയിലെ തിരെഞ്ഞെടുത്ത വിദ്യാലയങ്ങളിൽ സംഘടിപ്പിക്കുന്ന പ്രമേഹ ബോധവൽക്കരണ പദ്ധതിയുടെ ഭാഗമായി തോന്നയ്ക്കൽ ഇ വി യൂപി സ്കൂൾ നിംസ് മെഡിസിറ്റിയ ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/2069.jpeg",
    },
    {
      src: "assets/img/Pastevents/2070.jpeg",
      caption:
        " 'മിഠായി' (5) ലോക പ്രമേഹ ദിനത്തോട് അനുബന്ധിച്ച് സ്ക്കൂൾ വിദ്യാർഥികളിലൂടെ പ്രമേഹ അവബോധം കുടുംബത്തിലേയ്ക്കും സമൂഹത്തിലേയ്ക്കും.തിരുവനന്തപുരം ജില്ലയിലെ തിരെഞ്ഞെടുത്ത വിദ്യാലയങ്ങളിൽ സംഘടിപ്പിക്കുന്ന പ്രമേഹ ബോധവൽക്കരണ പദ്ധതിയുടെ ഭാഗമായി തോന്നയ്ക്കൽ ഇ വി യൂപി സ്കൂൾ നിംസ് മെഡിസിറ്റിയ ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/2070.jpeg",
    },
    {
      src: "assets/img/Pastevents/2071.jpeg",
      caption:
        " 'മിഠായി' (5) ലോക പ്രമേഹ ദിനത്തോട് അനുബന്ധിച്ച് സ്ക്കൂൾ വിദ്യാർഥികളിലൂടെ പ്രമേഹ അവബോധം കുടുംബത്തിലേയ്ക്കും സമൂഹത്തിലേയ്ക്കും.തിരുവനന്തപുരം ജില്ലയിലെ തിരെഞ്ഞെടുത്ത വിദ്യാലയങ്ങളിൽ സംഘടിപ്പിക്കുന്ന പ്രമേഹ ബോധവൽക്കരണ പദ്ധതിയുടെ ഭാഗമായി തോന്നയ്ക്കൽ ഇ വി യൂപി സ്കൂൾ നിംസ് മെഡിസിറ്റിയ ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/2071.jpeg",
    },
    {
      src: "assets/img/Pastevents/2072.jpeg",
      caption:
        " 'മിഠായി' (5) ലോക പ്രമേഹ ദിനത്തോട് അനുബന്ധിച്ച് സ്ക്കൂൾ വിദ്യാർഥികളിലൂടെ പ്രമേഹ അവബോധം കുടുംബത്തിലേയ്ക്കും സമൂഹത്തിലേയ്ക്കും.തിരുവനന്തപുരം ജില്ലയിലെ തിരെഞ്ഞെടുത്ത വിദ്യാലയങ്ങളിൽ സംഘടിപ്പിക്കുന്ന പ്രമേഹ ബോധവൽക്കരണ പദ്ധതിയുടെ ഭാഗമായി തോന്നയ്ക്കൽ ഇ വി യൂപി സ്കൂൾ നിംസ് മെഡിസിറ്റിയ ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/2072.jpeg",
    },
    {
      src: "assets/img/Pastevents/2073.jpeg",
      caption:
        " 'മിഠായി' (5) ലോക പ്രമേഹ ദിനത്തോട് അനുബന്ധിച്ച് സ്ക്കൂൾ വിദ്യാർഥികളിലൂടെ പ്രമേഹ അവബോധം കുടുംബത്തിലേയ്ക്കും സമൂഹത്തിലേയ്ക്കും.തിരുവനന്തപുരം ജില്ലയിലെ തിരെഞ്ഞെടുത്ത വിദ്യാലയങ്ങളിൽ സംഘടിപ്പിക്കുന്ന പ്രമേഹ ബോധവൽക്കരണ പദ്ധതിയുടെ ഭാഗമായി തോന്നയ്ക്കൽ ഇ വി യൂപി സ്കൂൾ നിംസ് മെഡിസിറ്റിയ ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/2073.jpeg",
    },
    {
      src: "assets/img/Pastevents/2074.jpeg",
      caption:
        " 'മിഠായി' (5) ലോക പ്രമേഹ ദിനത്തോട് അനുബന്ധിച്ച് സ്ക്കൂൾ വിദ്യാർഥികളിലൂടെ പ്രമേഹ അവബോധം കുടുംബത്തിലേയ്ക്കും സമൂഹത്തിലേയ്ക്കും.തിരുവനന്തപുരം ജില്ലയിലെ തിരെഞ്ഞെടുത്ത വിദ്യാലയങ്ങളിൽ സംഘടിപ്പിക്കുന്ന പ്രമേഹ ബോധവൽക്കരണ പദ്ധതിയുടെ ഭാഗമായി തോന്നയ്ക്കൽ ഇ വി യൂപി സ്കൂൾ നിംസ് മെഡിസിറ്റിയ ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/2074.jpeg",
    },
    {
      src: "assets/img/Pastevents/2075.jpeg",
      caption:
        " 'മിഠായി' (5) ലോക പ്രമേഹ ദിനത്തോട് അനുബന്ധിച്ച് സ്ക്കൂൾ വിദ്യാർഥികളിലൂടെ പ്രമേഹ അവബോധം കുടുംബത്തിലേയ്ക്കും സമൂഹത്തിലേയ്ക്കും.തിരുവനന്തപുരം ജില്ലയിലെ തിരെഞ്ഞെടുത്ത വിദ്യാലയങ്ങളിൽ സംഘടിപ്പിക്കുന്ന പ്രമേഹ ബോധവൽക്കരണ പദ്ധതിയുടെ ഭാഗമായി തോന്നയ്ക്കൽ ഇ വി യൂപി സ്കൂൾ നിംസ് മെഡിസിറ്റിയ ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/2075.jpeg",
    },
    {
      src: "assets/img/Pastevents/2063.jpeg",
      caption:
        "എസ് എൻ ഡി പി യൂണിറ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ  ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2063.jpeg",
    },
    {
      src: "assets/img/Pastevents/2064.jpeg",
      caption:
        "എസ് എൻ ഡി പി യൂണിറ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ  ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2064.jpeg",
    },
    {
      src: "assets/img/Pastevents/2065.jpeg",
      caption:
        "എസ് എൻ ഡി പി യൂണിറ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ  ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2065.jpeg",
    },
    {
      src: "assets/img/Pastevents/2066.jpeg",
      caption:
        "എസ് എൻ ഡി പി യൂണിറ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ  ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2066.jpeg",
    },
    {
      src: "assets/img/Pastevents/2067.jpeg",
      caption:
        "എസ് എൻ ഡി പി യൂണിറ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ  ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2067.jpeg",
    },
    {
      src: "assets/img/Pastevents/2068.jpeg",
      caption:
        "എസ് എൻ ഡി പി യൂണിറ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ  ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2068.jpeg",
    },
    {
      src: "assets/img/Pastevents/2055.jpeg",
      caption:
        "ലോക അർബുദ ദിനാചരണത്തിൻ്റെ ഭാഗമായി നവോത്ഥാൻ ക്യാൻസർ ഫൗണ്ടേഷൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ക്യാൻസർ സ്ക്രീനിംഗ്, ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2055.jpeg",
    },
    {
      src: "assets/img/Pastevents/2056.jpeg",
      caption:
        "ലോക അർബുദ ദിനാചരണത്തിൻ്റെ ഭാഗമായി നവോത്ഥാൻ ക്യാൻസർ ഫൗണ്ടേഷൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ക്യാൻസർ സ്ക്രീനിംഗ്, ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2056.jpeg",
    },
    {
      src: "assets/img/Pastevents/2057.jpeg",
      caption:
        "ലോക അർബുദ ദിനാചരണത്തിൻ്റെ ഭാഗമായി നവോത്ഥാൻ ക്യാൻസർ ഫൗണ്ടേഷൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ക്യാൻസർ സ്ക്രീനിംഗ്, ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2057.jpeg",
    },
    {
      src: "assets/img/Pastevents/2058.jpeg",
      caption:
        "ലോക അർബുദ ദിനാചരണത്തിൻ്റെ ഭാഗമായി നവോത്ഥാൻ ക്യാൻസർ ഫൗണ്ടേഷൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ക്യാൻസർ സ്ക്രീനിംഗ്, ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2058.jpeg",
    },
    {
      src: "assets/img/Pastevents/2059.jpeg",
      caption:
        "ലോക അർബുദ ദിനാചരണത്തിൻ്റെ ഭാഗമായി നവോത്ഥാൻ ക്യാൻസർ ഫൗണ്ടേഷൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ക്യാൻസർ സ്ക്രീനിംഗ്, ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2059.jpeg",
    },
    {
      src: "assets/img/Pastevents/2060.jpeg",
      caption:
        "ലോക അർബുദ ദിനാചരണത്തിൻ്റെ ഭാഗമായി നവോത്ഥാൻ ക്യാൻസർ ഫൗണ്ടേഷൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ക്യാൻസർ സ്ക്രീനിംഗ്, ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2060.jpeg",
    },
    {
      src: "assets/img/Pastevents/2061.jpeg",
      caption:
        "ലോക അർബുദ ദിനാചരണത്തിൻ്റെ ഭാഗമായി നവോത്ഥാൻ ക്യാൻസർ ഫൗണ്ടേഷൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ക്യാൻസർ സ്ക്രീനിംഗ്, ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2061.jpeg",
    },
    {
      src: "assets/img/Pastevents/2062.jpeg",
      caption:
        "ലോക അർബുദ ദിനാചരണത്തിൻ്റെ ഭാഗമായി നവോത്ഥാൻ ക്യാൻസർ ഫൗണ്ടേഷൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ക്യാൻസർ സ്ക്രീനിംഗ്, ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2062.jpeg",
    },
    {
      src: "assets/img/Pastevents/2047.jpeg",
      caption:
        "പനവൂർ അൽ ഇഹിസാൻ സാംസ്കാരിക വേദിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ  ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2047.jpeg",
    },
    {
      src: "assets/img/Pastevents/2048.jpeg",
      caption:
        "പനവൂർ അൽ ഇഹിസാൻ സാംസ്കാരിക വേദിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ  ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2048.jpeg",
    },
    {
      src: "assets/img/Pastevents/2049.jpeg",
      caption:
        "പനവൂർ അൽ ഇഹിസാൻ സാംസ്കാരിക വേദിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ  ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2049.jpeg",
    },
    {
      src: "assets/img/Pastevents/2050.jpeg",
      caption:
        "പനവൂർ അൽ ഇഹിസാൻ സാംസ്കാരിക വേദിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ  ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2050.jpeg",
    },
    {
      src: "assets/img/Pastevents/2051.jpeg",
      caption:
        "പനവൂർ അൽ ഇഹിസാൻ സാംസ്കാരിക വേദിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ  ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2051.jpeg",
    },
    {
      src: "assets/img/Pastevents/2052.jpeg",
      caption:
        "പനവൂർ അൽ ഇഹിസാൻ സാംസ്കാരിക വേദിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ  ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2052.jpeg",
    },
    {
      src: "assets/img/Pastevents/2053.jpeg",
      caption:
        "പനവൂർ അൽ ഇഹിസാൻ സാംസ്കാരിക വേദിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ  ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2053.jpeg",
    },
    {
      src: "assets/img/Pastevents/2054.jpeg",
      caption:
        "പനവൂർ അൽ ഇഹിസാൻ സാംസ്കാരിക വേദിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ  ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2054.jpeg",
    },
    {
      src: "assets/img/Pastevents/2041.jpeg",
      caption:
        "വേൾഡ് ക്യാൻസർ ദിനത്തോട് അനുബന്ധിച്ച് പുനലാൽ ഡെയ്ൽ വ്യൂ കോളേജ്, കോട്ടൂർ ഗീതാഞ്ജലി ഗ്രന്ഥശാലയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ക്യാൻസർ സ്ക്രീനിംഗ്, ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2041.jpeg",
    },
    {
      src: "assets/img/Pastevents/2042.jpeg",
      caption:
        "വേൾഡ് ക്യാൻസർ ദിനത്തോട് അനുബന്ധിച്ച് പുനലാൽ ഡെയ്ൽ വ്യൂ കോളേജ്, കോട്ടൂർ ഗീതാഞ്ജലി ഗ്രന്ഥശാലയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ക്യാൻസർ സ്ക്രീനിംഗ്, ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2042.jpeg",
    },
    {
      src: "assets/img/Pastevents/2043.jpeg",
      caption:
        "വേൾഡ് ക്യാൻസർ ദിനത്തോട് അനുബന്ധിച്ച് പുനലാൽ ഡെയ്ൽ വ്യൂ കോളേജ്, കോട്ടൂർ ഗീതാഞ്ജലി ഗ്രന്ഥശാലയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ക്യാൻസർ സ്ക്രീനിംഗ്, ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2043.jpeg",
    },
    {
      src: "assets/img/Pastevents/2044.jpeg",
      caption:
        "വേൾഡ് ക്യാൻസർ ദിനത്തോട് അനുബന്ധിച്ച് പുനലാൽ ഡെയ്ൽ വ്യൂ കോളേജ്, കോട്ടൂർ ഗീതാഞ്ജലി ഗ്രന്ഥശാലയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ക്യാൻസർ സ്ക്രീനിംഗ്, ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2044.jpeg",
    },
    {
      src: "assets/img/Pastevents/2045.jpeg",
      caption:
        "വേൾഡ് ക്യാൻസർ ദിനത്തോട് അനുബന്ധിച്ച് പുനലാൽ ഡെയ്ൽ വ്യൂ കോളേജ്, കോട്ടൂർ ഗീതാഞ്ജലി ഗ്രന്ഥശാലയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ക്യാൻസർ സ്ക്രീനിംഗ്, ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2045.jpeg",
    },
    {
      src: "assets/img/Pastevents/2046.jpeg",
      caption:
        "വേൾഡ് ക്യാൻസർ ദിനത്തോട് അനുബന്ധിച്ച് പുനലാൽ ഡെയ്ൽ വ്യൂ കോളേജ്, കോട്ടൂർ ഗീതാഞ്ജലി ഗ്രന്ഥശാലയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ക്യാൻസർ സ്ക്രീനിംഗ്, ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2046.jpeg",
    },
    {
      src: "assets/img/Pastevents/2034.jpeg",
      caption:
        "നിസാമിയ ഫെസ്റ്റ് -2023, ഗ്രാൻഡ് പാരെൻ്റ്സ് ഡേ  ആഘോഷത്തിൻ്റെ ഭാഗമായി നിസാമിയാ പബ്ലിക് സ്കൂളിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2034.jpeg",
    },
    {
      src: "assets/img/Pastevents/2035.jpeg",
      caption:
        "നിസാമിയ ഫെസ്റ്റ് -2023, ഗ്രാൻഡ് പാരെൻ്റ്സ് ഡേ  ആഘോഷത്തിൻ്റെ ഭാഗമായി നിസാമിയാ പബ്ലിക് സ്കൂളിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2035.jpeg",
    },
    {
      src: "assets/img/Pastevents/2036.jpeg",
      caption:
        "നിസാമിയ ഫെസ്റ്റ് -2023, ഗ്രാൻഡ് പാരെൻ്റ്സ് ഡേ  ആഘോഷത്തിൻ്റെ ഭാഗമായി നിസാമിയാ പബ്ലിക് സ്കൂളിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2036.jpeg",
    },
    {
      src: "assets/img/Pastevents/2037.jpeg",
      caption:
        "നിസാമിയ ഫെസ്റ്റ് -2023, ഗ്രാൻഡ് പാരെൻ്റ്സ് ഡേ  ആഘോഷത്തിൻ്റെ ഭാഗമായി നിസാമിയാ പബ്ലിക് സ്കൂളിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2037.jpeg",
    },
    {
      src: "assets/img/Pastevents/2038.jpeg",
      caption:
        "നിസാമിയ ഫെസ്റ്റ് -2023, ഗ്രാൻഡ് പാരെൻ്റ്സ് ഡേ  ആഘോഷത്തിൻ്റെ ഭാഗമായി നിസാമിയാ പബ്ലിക് സ്കൂളിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2038.jpeg",
    },
    {
      src: "assets/img/Pastevents/2039.jpeg",
      caption:
        "നിസാമിയ ഫെസ്റ്റ് -2023, ഗ്രാൻഡ് പാരെൻ്റ്സ് ഡേ  ആഘോഷത്തിൻ്റെ ഭാഗമായി നിസാമിയാ പബ്ലിക് സ്കൂളിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2039.jpeg",
    },
    {
      src: "assets/img/Pastevents/2040.jpeg",
      caption:
        "നിസാമിയ ഫെസ്റ്റ് -2023, ഗ്രാൻഡ് പാരെൻ്റ്സ് ഡേ  ആഘോഷത്തിൻ്റെ ഭാഗമായി നിസാമിയാ പബ്ലിക് സ്കൂളിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2040.jpeg",
    },
    {
      src: "assets/img/Pastevents/2027.jpeg",
      caption:
        "ഇടത്തെയ്ക്കോണം ജനതാ ക്ലബ്, പയറ്റുവിള ശ്രീ ചാമുണ്ഡി ദേവി ക്ഷേത്ര ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും /സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2027.jpeg",
    },
    {
      src: "assets/img/Pastevents/2028.jpeg",
      caption:
        "ഇടത്തെയ്ക്കോണം ജനതാ ക്ലബ്, പയറ്റുവിള ശ്രീ ചാമുണ്ഡി ദേവി ക്ഷേത്ര ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും /സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2028.jpeg",
    },
    {
      src: "assets/img/Pastevents/2029.jpeg",
      caption:
        "ഇടത്തെയ്ക്കോണം ജനതാ ക്ലബ്, പയറ്റുവിള ശ്രീ ചാമുണ്ഡി ദേവി ക്ഷേത്ര ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും /സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2029.jpeg",
    },
    {
      src: "assets/img/Pastevents/2030.jpeg",
      caption:
        "ഇടത്തെയ്ക്കോണം ജനതാ ക്ലബ്, പയറ്റുവിള ശ്രീ ചാമുണ്ഡി ദേവി ക്ഷേത്ര ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും /സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2030.jpeg",
    },
    {
      src: "assets/img/Pastevents/2031.jpeg",
      caption:
        "ഇടത്തെയ്ക്കോണം ജനതാ ക്ലബ്, പയറ്റുവിള ശ്രീ ചാമുണ്ഡി ദേവി ക്ഷേത്ര ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും /സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2031.jpeg",
    },
    {
      src: "assets/img/Pastevents/2032.jpeg",
      caption:
        "ഇടത്തെയ്ക്കോണം ജനതാ ക്ലബ്, പയറ്റുവിള ശ്രീ ചാമുണ്ഡി ദേവി ക്ഷേത്ര ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും /സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2032.jpeg",
    },
    {
      src: "assets/img/Pastevents/2033.jpeg",
      caption:
        "ഇടത്തെയ്ക്കോണം ജനതാ ക്ലബ്, പയറ്റുവിള ശ്രീ ചാമുണ്ഡി ദേവി ക്ഷേത്ര ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും /സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2033.jpeg",
    },
    {
      src: "assets/img/Pastevents/2022.jpeg",
      caption:
        "പ്രശാന്ത വിസ്മയം -2023 ഇവെൻ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2022.jpeg",
    },
    {
      src: "assets/img/Pastevents/2023.jpeg",
      caption:
        "പ്രശാന്ത വിസ്മയം -2023 ഇവെൻ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2023.jpeg",
    },
    {
      src: "assets/img/Pastevents/2024.jpeg",
      caption:
        "പ്രശാന്ത വിസ്മയം -2023 ഇവെൻ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2024.jpeg",
    },
    {
      src: "assets/img/Pastevents/2025.jpeg",
      caption:
        "പ്രശാന്ത വിസ്മയം -2023 ഇവെൻ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2025.jpeg",
    },
    {
      src: "assets/img/Pastevents/2026.jpeg",
      caption:
        "പ്രശാന്ത വിസ്മയം -2023 ഇവെൻ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2026.jpeg",
    },
    {
      src: "assets/img/Pastevents/2015.jpeg",
      caption:
        "പ്രശാന്ത വിസ്മയം -2023 ഇവെൻ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2015.jpeg",
    },
    {
      src: "assets/img/Pastevents/2016.jpeg",
      caption:
        "പ്രശാന്ത വിസ്മയം -2023 ഇവെൻ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2016.jpeg",
    },
    {
      src: "assets/img/Pastevents/2017.jpeg",
      caption:
        "പ്രശാന്ത വിസ്മയം -2023 ഇവെൻ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2017.jpeg",
    },
    {
      src: "assets/img/Pastevents/2018.jpeg",
      caption:
        "പ്രശാന്ത വിസ്മയം -2023 ഇവെൻ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2018.jpeg",
    },
    {
      src: "assets/img/Pastevents/2019jpeg",
      caption:
        "പ്രശാന്ത വിസ്മയം -2023 ഇവെൻ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2019.jpeg",
    },
    {
      src: "assets/img/Pastevents/2020.jpeg",
      caption:
        "പ്രശാന്ത വിസ്മയം -2023 ഇവെൻ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2020.jpeg",
    },
    {
      src: "assets/img/Pastevents/2021.jpeg",
      caption:
        "പ്രശാന്ത വിസ്മയം -2023 ഇവെൻ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2021.jpeg",
    },
    {
      src: "assets/img/Pastevents/2008.jpeg",
      caption:
        "മൊട്ടമൂട് ഫ്രണ്ട്സ് യോഗ സെൻ്ററിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2008.jpeg",
    },
    {
      src: "assets/img/Pastevents/2009.jpeg",
      caption:
        "മൊട്ടമൂട് ഫ്രണ്ട്സ് യോഗ സെൻ്ററിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2009.jpeg",
    },
    {
      src: "assets/img/Pastevents/2010.jpeg",
      caption:
        "മൊട്ടമൂട് ഫ്രണ്ട്സ് യോഗ സെൻ്ററിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2010.jpeg",
    },
    {
      src: "assets/img/Pastevents/2011.jpeg",
      caption:
        "മൊട്ടമൂട് ഫ്രണ്ട്സ് യോഗ സെൻ്ററിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2011.jpeg",
    },
    {
      src: "assets/img/Pastevents/2012.jpeg",
      caption:
        "മൊട്ടമൂട് ഫ്രണ്ട്സ് യോഗ സെൻ്ററിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2012.jpeg",
    },
    {
      src: "assets/img/Pastevents/2013.jpeg",
      caption:
        "മൊട്ടമൂട് ഫ്രണ്ട്സ് യോഗ സെൻ്ററിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2013.jpeg",
    },
    {
      src: "assets/img/Pastevents/2014.jpeg",
      caption:
        "മൊട്ടമൂട് ഫ്രണ്ട്സ് യോഗ സെൻ്ററിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/2014.jpeg",
    },

    {
      src: "assets/img/Pastevents/1997.jpeg",
      caption:
        "ചന്തവിള സേവാ ഭാരതി യൂണിറ്റ്, ട്രിവാൻഡ്രം ലയൺസ് ക്ലബ് ഓഫ് മെജസ്റ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1997.jpeg",
    },
    {
      src: "assets/img/Pastevents/1998.jpeg",
      caption:
        "ചന്തവിള സേവാ ഭാരതി യൂണിറ്റ്, ട്രിവാൻഡ്രം ലയൺസ് ക്ലബ് ഓഫ് മെജസ്റ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1998.jpeg",
    },
    {
      src: "assets/img/Pastevents/1999.jpeg",
      caption:
        "ചന്തവിള സേവാ ഭാരതി യൂണിറ്റ്, ട്രിവാൻഡ്രം ലയൺസ് ക്ലബ് ഓഫ് മെജസ്റ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1999.jpeg",
    },
    {
      src: "assets/img/Pastevents/2000.jpeg",
      caption:
        "ചന്തവിള സേവാ ഭാരതി യൂണിറ്റ്, ട്രിവാൻഡ്രം ലയൺസ് ക്ലബ് ഓഫ് മെജസ്റ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/2000.jpeg",
    },
    {
      src: "assets/img/Pastevents/2001.jpeg",
      caption:
        "ചന്തവിള സേവാ ഭാരതി യൂണിറ്റ്, ട്രിവാൻഡ്രം ലയൺസ് ക്ലബ് ഓഫ് മെജസ്റ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/2001.jpeg",
    },
    {
      src: "assets/img/Pastevents/2002.jpeg",
      caption:
        "ചന്തവിള സേവാ ഭാരതി യൂണിറ്റ്, ട്രിവാൻഡ്രം ലയൺസ് ക്ലബ് ഓഫ് മെജസ്റ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/2002.jpeg",
    },
    {
      src: "assets/img/Pastevents/2003.jpeg",
      caption:
        "ചന്തവിള സേവാ ഭാരതി യൂണിറ്റ്, ട്രിവാൻഡ്രം ലയൺസ് ക്ലബ് ഓഫ് മെജസ്റ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/2003.jpeg",
    },
    {
      src: "assets/img/Pastevents/2004.jpeg",
      caption:
        "ചന്തവിള സേവാ ഭാരതി യൂണിറ്റ്, ട്രിവാൻഡ്രം ലയൺസ് ക്ലബ് ഓഫ് മെജസ്റ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/2004.jpeg",
    },
    {
      src: "assets/img/Pastevents/2005.jpeg",
      caption:
        "ചന്തവിള സേവാ ഭാരതി യൂണിറ്റ്, ട്രിവാൻഡ്രം ലയൺസ് ക്ലബ് ഓഫ് മെജസ്റ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/2005.jpeg",
    },
    {
      src: "assets/img/Pastevents/2006.jpeg",
      caption:
        "ചന്തവിള സേവാ ഭാരതി യൂണിറ്റ്, ട്രിവാൻഡ്രം ലയൺസ് ക്ലബ് ഓഫ് മെജസ്റ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/2006.jpeg",
    },
    {
      src: "assets/img/Pastevents/2007.jpeg",
      caption:
        "ചന്തവിള സേവാ ഭാരതി യൂണിറ്റ്, ട്രിവാൻഡ്രം ലയൺസ് ക്ലബ് ഓഫ് മെജസ്റ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/2007.jpeg",
    },

    {
      src: "assets/img/Pastevents/1992.jpeg",
      caption:
        "കല്ലിയൂർ, ഊക്കോട് NSS ഹാളിൽ വച്ച് നടന്ന ചടങ്ങിൽ  എന്റെ ഹൃദയം എന്റെ ഗ്രാമം ; സൗജന്യ ഹൃദ്രോഗ നിർണ്ണയ മെഗാ ക്യാമ്പിന്റെയും ബോധവത്ക്കരണത്തിന്റെയും ഉത്ഘാടനം പ്രശസ്ത സിനിമ - സീരിയൽ താരം ശ്രീ. കൃഷ്ണകുമാർ നിർവഹിച്ചു.ഭിന്നശേഷി കുട്ടികൾക്ക് നിംസ് മെഡിസിറ്റി  നൽകി വരുന്ന പെൻഷൻ പദ്ധതിയായ നെയ്യാറ്റിൻകര പെൻഷൻ പ്ലാൻ ; കല്ലിയൂർ പഞ്ചായത്തിൽ നടപ്പിലാക്കുന്നതിന്റെ ഔപചാരിക ഉത്ഘാടനം നിംസ് മെഡിസിറ്റി എം.ഡി. ശ്രീ. എം.എസ് ഫൈസൽ ഖാൻ നിർവഹിച്ചു.",
      thumb: "assets/img/Pastevents/1992.jpeg",
    },
    {
      src: "assets/img/Pastevents/1993.jpeg",
      caption:
        "കല്ലിയൂർ, ഊക്കോട് NSS ഹാളിൽ വച്ച് നടന്ന ചടങ്ങിൽ  എന്റെ ഹൃദയം എന്റെ ഗ്രാമം ; സൗജന്യ ഹൃദ്രോഗ നിർണ്ണയ മെഗാ ക്യാമ്പിന്റെയും ബോധവത്ക്കരണത്തിന്റെയും ഉത്ഘാടനം പ്രശസ്ത സിനിമ - സീരിയൽ താരം ശ്രീ. കൃഷ്ണകുമാർ നിർവഹിച്ചു.ഭിന്നശേഷി കുട്ടികൾക്ക് നിംസ് മെഡിസിറ്റി  നൽകി വരുന്ന പെൻഷൻ പദ്ധതിയായ നെയ്യാറ്റിൻകര പെൻഷൻ പ്ലാൻ ; കല്ലിയൂർ പഞ്ചായത്തിൽ നടപ്പിലാക്കുന്നതിന്റെ ഔപചാരിക ഉത്ഘാടനം നിംസ് മെഡിസിറ്റി എം.ഡി. ശ്രീ. എം.എസ് ഫൈസൽ ഖാൻ നിർവഹിച്ചു.",
      thumb: "assets/img/Pastevents/1993.jpeg",
    },
    {
      src: "assets/img/Pastevents/1994.jpeg",
      caption:
        "കല്ലിയൂർ, ഊക്കോട് NSS ഹാളിൽ വച്ച് നടന്ന ചടങ്ങിൽ  എന്റെ ഹൃദയം എന്റെ ഗ്രാമം ; സൗജന്യ ഹൃദ്രോഗ നിർണ്ണയ മെഗാ ക്യാമ്പിന്റെയും ബോധവത്ക്കരണത്തിന്റെയും ഉത്ഘാടനം പ്രശസ്ത സിനിമ - സീരിയൽ താരം ശ്രീ. കൃഷ്ണകുമാർ നിർവഹിച്ചു.ഭിന്നശേഷി കുട്ടികൾക്ക് നിംസ് മെഡിസിറ്റി  നൽകി വരുന്ന പെൻഷൻ പദ്ധതിയായ നെയ്യാറ്റിൻകര പെൻഷൻ പ്ലാൻ ; കല്ലിയൂർ പഞ്ചായത്തിൽ നടപ്പിലാക്കുന്നതിന്റെ ഔപചാരിക ഉത്ഘാടനം നിംസ് മെഡിസിറ്റി എം.ഡി. ശ്രീ. എം.എസ് ഫൈസൽ ഖാൻ നിർവഹിച്ചു.",
      thumb: "assets/img/Pastevents/1994.jpeg",
    },
    {
      src: "assets/img/Pastevents/1995.jpeg",
      caption:
        "കല്ലിയൂർ, ഊക്കോട് NSS ഹാളിൽ വച്ച് നടന്ന ചടങ്ങിൽ  എന്റെ ഹൃദയം എന്റെ ഗ്രാമം ; സൗജന്യ ഹൃദ്രോഗ നിർണ്ണയ മെഗാ ക്യാമ്പിന്റെയും ബോധവത്ക്കരണത്തിന്റെയും ഉത്ഘാടനം പ്രശസ്ത സിനിമ - സീരിയൽ താരം ശ്രീ. കൃഷ്ണകുമാർ നിർവഹിച്ചു.ഭിന്നശേഷി കുട്ടികൾക്ക് നിംസ് മെഡിസിറ്റി  നൽകി വരുന്ന പെൻഷൻ പദ്ധതിയായ നെയ്യാറ്റിൻകര പെൻഷൻ പ്ലാൻ ; കല്ലിയൂർ പഞ്ചായത്തിൽ നടപ്പിലാക്കുന്നതിന്റെ ഔപചാരിക ഉത്ഘാടനം നിംസ് മെഡിസിറ്റി എം.ഡി. ശ്രീ. എം.എസ് ഫൈസൽ ഖാൻ നിർവഹിച്ചു.",
      thumb: "assets/img/Pastevents/1995.jpeg",
    },
    {
      src: "assets/img/Pastevents/1996.jpeg",
      caption:
        "കല്ലിയൂർ, ഊക്കോട് NSS ഹാളിൽ വച്ച് നടന്ന ചടങ്ങിൽ  എന്റെ ഹൃദയം എന്റെ ഗ്രാമം ; സൗജന്യ ഹൃദ്രോഗ നിർണ്ണയ മെഗാ ക്യാമ്പിന്റെയും ബോധവത്ക്കരണത്തിന്റെയും ഉത്ഘാടനം പ്രശസ്ത സിനിമ - സീരിയൽ താരം ശ്രീ. കൃഷ്ണകുമാർ നിർവഹിച്ചു.ഭിന്നശേഷി കുട്ടികൾക്ക് നിംസ് മെഡിസിറ്റി  നൽകി വരുന്ന പെൻഷൻ പദ്ധതിയായ നെയ്യാറ്റിൻകര പെൻഷൻ പ്ലാൻ ; കല്ലിയൂർ പഞ്ചായത്തിൽ നടപ്പിലാക്കുന്നതിന്റെ ഔപചാരിക ഉത്ഘാടനം നിംസ് മെഡിസിറ്റി എം.ഡി. ശ്രീ. എം.എസ് ഫൈസൽ ഖാൻ നിർവഹിച്ചു.",
      thumb: "assets/img/Pastevents/1996.jpeg",
    },
    {
      src: "assets/img/Pastevents/1984.jpeg",
      caption:
        "കൊല്ലയിൽ പഞ്ചായത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ ഭിന്നശേഷി  വിഭാഗത്തിൽപ്പെട്ടവർക്കും , വയോജനങ്ങൾക്കുമുള്ള സൗജന്യ മെഡിക്കൽ ചെക്കപ്പും, ബോധവൽക്കരണ ക്ലാസ്സും സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1984.jpeg",
    },
    {
      src: "assets/img/Pastevents/1985.jpeg",
      caption:
        "കൊല്ലയിൽ പഞ്ചായത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ ഭിന്നശേഷി  വിഭാഗത്തിൽപ്പെട്ടവർക്കും , വയോജനങ്ങൾക്കുമുള്ള സൗജന്യ മെഡിക്കൽ ചെക്കപ്പും, ബോധവൽക്കരണ ക്ലാസ്സും സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1985.jpeg",
    },
    {
      src: "assets/img/Pastevents/1986.jpeg",
      caption:
        "കൊല്ലയിൽ പഞ്ചായത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ ഭിന്നശേഷി  വിഭാഗത്തിൽപ്പെട്ടവർക്കും , വയോജനങ്ങൾക്കുമുള്ള സൗജന്യ മെഡിക്കൽ ചെക്കപ്പും, ബോധവൽക്കരണ ക്ലാസ്സും സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1986.jpeg",
    },
    {
      src: "assets/img/Pastevents/1987.jpeg",
      caption:
        "കൊല്ലയിൽ പഞ്ചായത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ ഭിന്നശേഷി  വിഭാഗത്തിൽപ്പെട്ടവർക്കും , വയോജനങ്ങൾക്കുമുള്ള സൗജന്യ മെഡിക്കൽ ചെക്കപ്പും, ബോധവൽക്കരണ ക്ലാസ്സും സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1987.jpeg",
    },
    {
      src: "assets/img/Pastevents/1988.jpeg",
      caption:
        "കൊല്ലയിൽ പഞ്ചായത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ ഭിന്നശേഷി  വിഭാഗത്തിൽപ്പെട്ടവർക്കും , വയോജനങ്ങൾക്കുമുള്ള സൗജന്യ മെഡിക്കൽ ചെക്കപ്പും, ബോധവൽക്കരണ ക്ലാസ്സും സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1988.jpeg",
    },
    {
      src: "assets/img/Pastevents/1989.jpeg",
      caption:
        "കൊല്ലയിൽ പഞ്ചായത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ ഭിന്നശേഷി  വിഭാഗത്തിൽപ്പെട്ടവർക്കും , വയോജനങ്ങൾക്കുമുള്ള സൗജന്യ മെഡിക്കൽ ചെക്കപ്പും, ബോധവൽക്കരണ ക്ലാസ്സും സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1989.jpeg",
    },
    {
      src: "assets/img/Pastevents/1990.jpeg",
      caption:
        "കൊല്ലയിൽ പഞ്ചായത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ ഭിന്നശേഷി  വിഭാഗത്തിൽപ്പെട്ടവർക്കും , വയോജനങ്ങൾക്കുമുള്ള സൗജന്യ മെഡിക്കൽ ചെക്കപ്പും, ബോധവൽക്കരണ ക്ലാസ്സും സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1990.jpeg",
    },
    {
      src: "assets/img/Pastevents/1991.jpeg",
      caption:
        "കൊല്ലയിൽ പഞ്ചായത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ ഭിന്നശേഷി  വിഭാഗത്തിൽപ്പെട്ടവർക്കും , വയോജനങ്ങൾക്കുമുള്ള സൗജന്യ മെഡിക്കൽ ചെക്കപ്പും, ബോധവൽക്കരണ ക്ലാസ്സും സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1991.jpeg",
    },
    {
      src: "assets/img/Pastevents/1977.jpeg",
      caption:
        "ജീവദായിനി 2023'ശ്രീ വിവേകാനന്ദ സാംസ്കാരിക സമിതി , കൊല്ലയ്ക്കോണം ശ്രീയക്ഷിയമ്മാ ദേവി ക്ഷേത്ര ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ ഫൈസൽ ഖാൻ (പ്രോ ചാൻസിലർ നൂറുൽ ഇസ്‌ലാം യൂണിവേഴ്സിറ്റി & എംഡി നിംസ് മെഡിസിറ്റി)",
      thumb: "assets/img/Pastevents/1977.jpeg",
    },
    {
      src: "assets/img/Pastevents/1978.jpeg",
      caption:
        "ജീവദായിനി 2023'ശ്രീ വിവേകാനന്ദ സാംസ്കാരിക സമിതി , കൊല്ലയ്ക്കോണം ശ്രീയക്ഷിയമ്മാ ദേവി ക്ഷേത്ര ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1978.jpeg",
    },
    {
      src: "assets/img/Pastevents/1979.jpeg",
      caption:
        "ജീവദായിനി 2023'ശ്രീ വിവേകാനന്ദ സാംസ്കാരിക സമിതി , കൊല്ലയ്ക്കോണം ശ്രീയക്ഷിയമ്മാ ദേവി ക്ഷേത്ര ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1979.jpeg",
    },
    {
      src: "assets/img/Pastevents/1980.jpeg",
      caption:
        "ജീവദായിനി 2023'ശ്രീ വിവേകാനന്ദ സാംസ്കാരിക സമിതി , കൊല്ലയ്ക്കോണം ശ്രീയക്ഷിയമ്മാ ദേവി ക്ഷേത്ര ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1980.jpeg",
    },
    {
      src: "assets/img/Pastevents/1981.jpeg",
      caption:
        "ജീവദായിനി 2023'ശ്രീ വിവേകാനന്ദ സാംസ്കാരിക സമിതി , കൊല്ലയ്ക്കോണം ശ്രീയക്ഷിയമ്മാ ദേവി ക്ഷേത്ര ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1981.jpeg",
    },
    {
      src: "assets/img/Pastevents/1982.jpeg",
      caption:
        "ജീവദായിനി 2023'ശ്രീ വിവേകാനന്ദ സാംസ്കാരിക സമിതി , കൊല്ലയ്ക്കോണം ശ്രീയക്ഷിയമ്മാ ദേവി ക്ഷേത്ര ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1982.jpeg",
    },
    {
      src: "assets/img/Pastevents/1983.jpeg",
      caption:
        "ജീവദായിനി 2023'ശ്രീ വിവേകാനന്ദ സാംസ്കാരിക സമിതി , കൊല്ലയ്ക്കോണം ശ്രീയക്ഷിയമ്മാ ദേവി ക്ഷേത്ര ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1983.jpeg",
    },
    {
      src: "assets/img/Pastevents/1971.jpeg",
      caption:
        "പെരുംക്കാവ് റെസിഡൻഷ്യൽ അസോസിയേഷൻ,തിരുമല ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1971.jpeg",
    },
    {
      src: "assets/img/Pastevents/1972.jpeg",
      caption:
        "പെരുംക്കാവ് റെസിഡൻഷ്യൽ അസോസിയേഷൻ,തിരുമല ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1972.jpeg",
    },
    {
      src: "assets/img/Pastevents/1973.jpeg",
      caption:
        "പെരുംക്കാവ് റെസിഡൻഷ്യൽ അസോസിയേഷൻ,തിരുമല ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1973.jpeg",
    },
    {
      src: "assets/img/Pastevents/1974.jpeg",
      caption:
        "പെരുംക്കാവ് റെസിഡൻഷ്യൽ അസോസിയേഷൻ,തിരുമല ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1974.jpeg",
    },
    {
      src: "assets/img/Pastevents/1975.jpeg",
      caption:
        "പെരുംക്കാവ് റെസിഡൻഷ്യൽ അസോസിയേഷൻ,തിരുമല ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1975.jpeg",
    },
    {
      src: "assets/img/Pastevents/1976.jpeg",
      caption:
        "പെരുംക്കാവ് റെസിഡൻഷ്യൽ അസോസിയേഷൻ,തിരുമല ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1976.jpeg",
    },
    {
      src: "assets/img/Pastevents/1962.jpeg",
      caption:
        "നൂറുൽ ഇസ്‌ലാം യൂണിവേഴ്സിറ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1962.jpeg",
    },
    {
      src: "assets/img/Pastevents/1963.jpeg",
      caption:
        "നൂറുൽ ഇസ്‌ലാം യൂണിവേഴ്സിറ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1963.jpeg",
    },
    {
      src: "assets/img/Pastevents/1964.jpeg",
      caption:
        "നൂറുൽ ഇസ്‌ലാം യൂണിവേഴ്സിറ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1964.jpeg",
    },
    {
      src: "assets/img/Pastevents/1965.jpeg",
      caption:
        "നൂറുൽ ഇസ്‌ലാം യൂണിവേഴ്സിറ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1965.jpeg",
    },
    {
      src: "assets/img/Pastevents/1966.jpeg",
      caption:
        "നൂറുൽ ഇസ്‌ലാം യൂണിവേഴ്സിറ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1966.jpeg",
    },
    {
      src: "assets/img/Pastevents/1967.jpeg",
      caption:
        "നൂറുൽ ഇസ്‌ലാം യൂണിവേഴ്സിറ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1967.jpeg",
    },
    {
      src: "assets/img/Pastevents/1968.jpeg",
      caption:
        "നൂറുൽ ഇസ്‌ലാം യൂണിവേഴ്സിറ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1968.jpeg",
    },
    {
      src: "assets/img/Pastevents/1969.jpeg",
      caption:
        "നൂറുൽ ഇസ്‌ലാം യൂണിവേഴ്സിറ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1969.jpeg",
    },
    {
      src: "assets/img/Pastevents/1970.jpeg",
      caption:
        "നൂറുൽ ഇസ്‌ലാം യൂണിവേഴ്സിറ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1970.jpeg",
    },
    {
      src: "assets/img/Pastevents/1956.jpeg",
      caption:
        "ലോക പ്രമേഹ ദിനത്തോട് അനുബന്ധിച്ച് സ്ക്കൂൾ വിദ്യാർഥികളിലൂടെ പ്രമേഹ അവബോധം കുടുംബത്തിലേയ്ക്കും സമൂഹത്തിലേയ്ക്കും.തിരുവനന്തപുരം ജില്ലയിലെ തിരെഞ്ഞെടുത്ത വിദ്യാലയങ്ങളിൽ സംഘടിപ്പിക്കുന്ന പ്രമേഹ ബോധവൽക്കരണ പദ്ധതിയുടെ ഭാഗമായി തൈക്കാട് ഗവ: മോഡൽ ഹൈസ്കൂൾ , റോട്ടറി ഇൻ്റർനാഷണൽ ട്രിവാൻഡ്രത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1956.jpeg",
    },
    {
      src: "assets/img/Pastevents/1957.jpeg",
      caption:
        "ലോക പ്രമേഹ ദിനത്തോട് അനുബന്ധിച്ച് സ്ക്കൂൾ വിദ്യാർഥികളിലൂടെ പ്രമേഹ അവബോധം കുടുംബത്തിലേയ്ക്കും സമൂഹത്തിലേയ്ക്കും.തിരുവനന്തപുരം ജില്ലയിലെ തിരെഞ്ഞെടുത്ത വിദ്യാലയങ്ങളിൽ സംഘടിപ്പിക്കുന്ന പ്രമേഹ ബോധവൽക്കരണ പദ്ധതിയുടെ ഭാഗമായി തൈക്കാട് ഗവ: മോഡൽ ഹൈസ്കൂൾ , റോട്ടറി ഇൻ്റർനാഷണൽ ട്രിവാൻഡ്രത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1957.jpeg",
    },
    {
      src: "assets/img/Pastevents/1958.jpeg",
      caption:
        "ലോക പ്രമേഹ ദിനത്തോട് അനുബന്ധിച്ച് സ്ക്കൂൾ വിദ്യാർഥികളിലൂടെ പ്രമേഹ അവബോധം കുടുംബത്തിലേയ്ക്കും സമൂഹത്തിലേയ്ക്കും.തിരുവനന്തപുരം ജില്ലയിലെ തിരെഞ്ഞെടുത്ത വിദ്യാലയങ്ങളിൽ സംഘടിപ്പിക്കുന്ന പ്രമേഹ ബോധവൽക്കരണ പദ്ധതിയുടെ ഭാഗമായി തൈക്കാട് ഗവ: മോഡൽ ഹൈസ്കൂൾ , റോട്ടറി ഇൻ്റർനാഷണൽ ട്രിവാൻഡ്രത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1958.jpeg",
    },
    {
      src: "assets/img/Pastevents/1959.jpeg",
      caption:
        "ലോക പ്രമേഹ ദിനത്തോട് അനുബന്ധിച്ച് സ്ക്കൂൾ വിദ്യാർഥികളിലൂടെ പ്രമേഹ അവബോധം കുടുംബത്തിലേയ്ക്കും സമൂഹത്തിലേയ്ക്കും.തിരുവനന്തപുരം ജില്ലയിലെ തിരെഞ്ഞെടുത്ത വിദ്യാലയങ്ങളിൽ സംഘടിപ്പിക്കുന്ന പ്രമേഹ ബോധവൽക്കരണ പദ്ധതിയുടെ ഭാഗമായി തൈക്കാട് ഗവ: മോഡൽ ഹൈസ്കൂൾ , റോട്ടറി ഇൻ്റർനാഷണൽ ട്രിവാൻഡ്രത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1959.jpeg",
    },
    {
      src: "assets/img/Pastevents/1960.jpeg",
      caption:
        "ലോക പ്രമേഹ ദിനത്തോട് അനുബന്ധിച്ച് സ്ക്കൂൾ വിദ്യാർഥികളിലൂടെ പ്രമേഹ അവബോധം കുടുംബത്തിലേയ്ക്കും സമൂഹത്തിലേയ്ക്കും.തിരുവനന്തപുരം ജില്ലയിലെ തിരെഞ്ഞെടുത്ത വിദ്യാലയങ്ങളിൽ സംഘടിപ്പിക്കുന്ന പ്രമേഹ ബോധവൽക്കരണ പദ്ധതിയുടെ ഭാഗമായി തൈക്കാട് ഗവ: മോഡൽ ഹൈസ്കൂൾ , റോട്ടറി ഇൻ്റർനാഷണൽ ട്രിവാൻഡ്രത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1960.jpeg",
    },
    {
      src: "assets/img/Pastevents/1961.jpeg",
      caption:
        "ലോക പ്രമേഹ ദിനത്തോട് അനുബന്ധിച്ച് സ്ക്കൂൾ വിദ്യാർഥികളിലൂടെ പ്രമേഹ അവബോധം കുടുംബത്തിലേയ്ക്കും സമൂഹത്തിലേയ്ക്കും.തിരുവനന്തപുരം ജില്ലയിലെ തിരെഞ്ഞെടുത്ത വിദ്യാലയങ്ങളിൽ സംഘടിപ്പിക്കുന്ന പ്രമേഹ ബോധവൽക്കരണ പദ്ധതിയുടെ ഭാഗമായി തൈക്കാട് ഗവ: മോഡൽ ഹൈസ്കൂൾ , റോട്ടറി ഇൻ്റർനാഷണൽ ട്രിവാൻഡ്രത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1961.jpeg",
    },
    {
      src: "assets/img/Pastevents/1950.jpeg",
      caption:
        "ഗവ: മോഡൽ ഹൈസ്കൂൾ, ട്രിവാൻഡ്രം റോട്ടറി ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1950.jpeg",
    },
    {
      src: "assets/img/Pastevents/1951.jpeg",
      caption:
        "ഗവ: മോഡൽ ഹൈസ്കൂൾ, ട്രിവാൻഡ്രം റോട്ടറി ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1951.jpeg",
    },
    {
      src: "assets/img/Pastevents/1952.jpeg",
      caption:
        "ഗവ: മോഡൽ ഹൈസ്കൂൾ, ട്രിവാൻഡ്രം റോട്ടറി ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1952.jpeg",
    },
    {
      src: "assets/img/Pastevents/1953.jpeg",
      caption:
        "ഗവ: മോഡൽ ഹൈസ്കൂൾ, ട്രിവാൻഡ്രം റോട്ടറി ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1953.jpeg",
    },
    {
      src: "assets/img/Pastevents/1954.jpeg",
      caption:
        "ഗവ: മോഡൽ ഹൈസ്കൂൾ, ട്രിവാൻഡ്രം റോട്ടറി ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1954.jpeg",
    },
    {
      src: "assets/img/Pastevents/1955.jpeg",
      caption:
        "ഗവ: മോഡൽ ഹൈസ്കൂൾ, ട്രിവാൻഡ്രം റോട്ടറി ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1955.jpeg",
    },
    {
      src: "assets/img/Pastevents/1945.jpeg",
      caption:
        "കാവിയാട് ദിനകര പണിക്കർ സാംസ്കാരിക വേദിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      thumb: "assets/img/Pastevents/1945.jpeg",
    },
    {
      src: "assets/img/Pastevents/1946.jpeg",
      caption:
        "കാവിയാട് ദിനകര പണിക്കർ സാംസ്കാരിക വേദിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      thumb: "assets/img/Pastevents/1946.jpeg",
    },
    {
      src: "assets/img/Pastevents/1947.jpeg",
      caption:
        "കാവിയാട് ദിനകര പണിക്കർ സാംസ്കാരിക വേദിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      thumb: "assets/img/Pastevents/1947.jpeg",
    },
    {
      src: "assets/img/Pastevents/1948.jpeg",
      caption:
        "കാവിയാട് ദിനകര പണിക്കർ സാംസ്കാരിക വേദിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      thumb: "assets/img/Pastevents/1948.jpeg",
    },
    {
      src: "assets/img/Pastevents/1949.jpeg",
      caption:
        "കാവിയാട് ദിനകര പണിക്കർ സാംസ്കാരിക വേദിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      thumb: "assets/img/Pastevents/1949.jpeg",
    },
    {
      src: "assets/img/Pastevents/1937.jpeg",
      caption:
        "ആഴിമല ശിവക്ഷേത്ര ട്രസ്റ്റും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      thumb: "assets/img/Pastevents/1937.jpeg",
    },
    {
      src: "assets/img/Pastevents/1938.jpeg",
      caption:
        "ആഴിമല ശിവക്ഷേത്ര ട്രസ്റ്റും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      thumb: "assets/img/Pastevents/1938.jpeg",
    },
    {
      src: "assets/img/Pastevents/1939.jpeg",
      caption:
        "ആഴിമല ശിവക്ഷേത്ര ട്രസ്റ്റും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      thumb: "assets/img/Pastevents/1939.jpeg",
    },
    {
      src: "assets/img/Pastevents/1940.jpeg",
      caption:
        "ആഴിമല ശിവക്ഷേത്ര ട്രസ്റ്റും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      thumb: "assets/img/Pastevents/1940.jpeg",
    },
    {
      src: "assets/img/Pastevents/1941.jpeg",
      caption:
        "ആഴിമല ശിവക്ഷേത്ര ട്രസ്റ്റും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      thumb: "assets/img/Pastevents/1941.jpeg",
    },
    {
      src: "assets/img/Pastevents/1942.jpeg",
      caption:
        "ആഴിമല ശിവക്ഷേത്ര ട്രസ്റ്റും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      thumb: "assets/img/Pastevents/1942.jpeg",
    },
    {
      src: "assets/img/Pastevents/1943.jpeg",
      caption:
        "ആഴിമല ശിവക്ഷേത്ര ട്രസ്റ്റും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      thumb: "assets/img/Pastevents/1943.jpeg",
    },
    {
      src: "assets/img/Pastevents/1944.jpeg",
      caption:
        "ആഴിമല ശിവക്ഷേത്ര ട്രസ്റ്റും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      thumb: "assets/img/Pastevents/1944.jpeg",
    },
    {
      src: "assets/img/Pastevents/1930.jpeg",
      caption:
        "പിരായിമൂട് എൽ & റ്റി കൺസ്ട്രക്ഷൻ കമ്പനിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1930.jpeg",
    },
    {
      src: "assets/img/Pastevents/1931.jpeg",
      caption:
        "പിരായിമൂട് എൽ & റ്റി കൺസ്ട്രക്ഷൻ കമ്പനിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1931.jpeg",
    },
    {
      src: "assets/img/Pastevents/1932.jpeg",
      caption:
        "പിരായിമൂട് എൽ & റ്റി കൺസ്ട്രക്ഷൻ കമ്പനിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1932.jpeg",
    },
    {
      src: "assets/img/Pastevents/1933.jpeg",
      caption:
        "പിരായിമൂട് എൽ & റ്റി കൺസ്ട്രക്ഷൻ കമ്പനിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1933.jpeg",
    },
    {
      src: "assets/img/Pastevents/1934.jpeg",
      caption:
        "പിരായിമൂട് എൽ & റ്റി കൺസ്ട്രക്ഷൻ കമ്പനിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1934.jpeg",
    },
    {
      src: "assets/img/Pastevents/1935.jpeg",
      caption:
        "പിരായിമൂട് എൽ & റ്റി കൺസ്ട്രക്ഷൻ കമ്പനിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1935.jpeg",
    },
    {
      src: "assets/img/Pastevents/1936.jpeg",
      caption:
        "പിരായിമൂട് എൽ & റ്റി കൺസ്ട്രക്ഷൻ കമ്പനിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1936.jpeg",
    },

    {
      src: "assets/img/Pastevents/1923.jpeg",
      caption:
        "പേരൂർക്കട ഗവൺമെൻ്റ് ഗേൾസ് ഹയർ സെക്കൻഡറി സ്കൂൾ പി റ്റി എ, പേരൂർക്കട മോഡൽ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീമതി ജമീല ശ്രീധരൻ ( ആരോഗ്യ സ്റ്റാന്റിംഗ് കമ്മിറ്റി ചെയർ പേഴ്സൺ, തിരു. നഗരസഭ )",
      thumb: "assets/img/Pastevents/1923.jpeg",
    },
    {
      src: "assets/img/Pastevents/1924.jpeg",
      caption:
        "പേരൂർക്കട ഗവൺമെൻ്റ് ഗേൾസ് ഹയർ സെക്കൻഡറി സ്കൂൾ പി റ്റി എ, പേരൂർക്കട മോഡൽ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീമതി ജമീല ശ്രീധരൻ ( ആരോഗ്യ സ്റ്റാന്റിംഗ് കമ്മിറ്റി ചെയർ പേഴ്സൺ, തിരു. നഗരസഭ )",
      thumb: "assets/img/Pastevents/1924.jpeg",
    },
    {
      src: "assets/img/Pastevents/1925.jpeg",
      caption:
        "പേരൂർക്കട ഗവൺമെൻ്റ് ഗേൾസ് ഹയർ സെക്കൻഡറി സ്കൂൾ പി റ്റി എ, പേരൂർക്കട മോഡൽ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീമതി ജമീല ശ്രീധരൻ ( ആരോഗ്യ സ്റ്റാന്റിംഗ് കമ്മിറ്റി ചെയർ പേഴ്സൺ, തിരു. നഗരസഭ )",
      thumb: "assets/img/Pastevents/1925.jpeg",
    },
    {
      src: "assets/img/Pastevents/1926.jpeg",
      caption:
        "പേരൂർക്കട ഗവൺമെൻ്റ് ഗേൾസ് ഹയർ സെക്കൻഡറി സ്കൂൾ പി റ്റി എ, പേരൂർക്കട മോഡൽ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീമതി ജമീല ശ്രീധരൻ ( ആരോഗ്യ സ്റ്റാന്റിംഗ് കമ്മിറ്റി ചെയർ പേഴ്സൺ, തിരു. നഗരസഭ )",
      thumb: "assets/img/Pastevents/1926.jpeg",
    },
    {
      src: "assets/img/Pastevents/1927.jpeg",
      caption:
        "പേരൂർക്കട ഗവൺമെൻ്റ് ഗേൾസ് ഹയർ സെക്കൻഡറി സ്കൂൾ പി റ്റി എ, പേരൂർക്കട മോഡൽ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീമതി ജമീല ശ്രീധരൻ ( ആരോഗ്യ സ്റ്റാന്റിംഗ് കമ്മിറ്റി ചെയർ പേഴ്സൺ, തിരു. നഗരസഭ )",
      thumb: "assets/img/Pastevents/1927.jpeg",
    },
    {
      src: "assets/img/Pastevents/1928.jpeg",
      caption:
        "പേരൂർക്കട ഗവൺമെൻ്റ് ഗേൾസ് ഹയർ സെക്കൻഡറി സ്കൂൾ പി റ്റി എ, പേരൂർക്കട മോഡൽ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീമതി ജമീല ശ്രീധരൻ ( ആരോഗ്യ സ്റ്റാന്റിംഗ് കമ്മിറ്റി ചെയർ പേഴ്സൺ, തിരു. നഗരസഭ )",
      thumb: "assets/img/Pastevents/1928.jpeg",
    },
    {
      src: "assets/img/Pastevents/1929.jpeg",
      caption:
        "പേരൂർക്കട ഗവൺമെൻ്റ് ഗേൾസ് ഹയർ സെക്കൻഡറി സ്കൂൾ പി റ്റി എ, പേരൂർക്കട മോഡൽ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീമതി ജമീല ശ്രീധരൻ ( ആരോഗ്യ സ്റ്റാന്റിംഗ് കമ്മിറ്റി ചെയർ പേഴ്സൺ, തിരു. നഗരസഭ )",
      thumb: "assets/img/Pastevents/1929.jpeg",
    },
    {
      src: "assets/img/Pastevents/1915.jpeg",
      caption:
        "തമിഴ്നാട് ഗവൺമെന്റ് ഹെൽത്ത് ഇൻഷുറൻസ് സ്കീം, മരിയഗിരി മലങ്കര കാത്തോലിക് കോളേജിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1915.jpeg",
    },
    {
      src: "assets/img/Pastevents/1916.jpeg",
      caption:
        "തമിഴ്നാട് ഗവൺമെന്റ് ഹെൽത്ത് ഇൻഷുറൻസ് സ്കീം, മരിയഗിരി മലങ്കര കാത്തോലിക് കോളേജിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1916.jpeg",
    },
    {
      src: "assets/img/Pastevents/1917.jpeg",
      caption:
        "തമിഴ്നാട് ഗവൺമെന്റ് ഹെൽത്ത് ഇൻഷുറൻസ് സ്കീം, മരിയഗിരി മലങ്കര കാത്തോലിക് കോളേജിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1917.jpeg",
    },
    {
      src: "assets/img/Pastevents/1918.jpeg",
      caption:
        "തമിഴ്നാട് ഗവൺമെന്റ് ഹെൽത്ത് ഇൻഷുറൻസ് സ്കീം, മരിയഗിരി മലങ്കര കാത്തോലിക് കോളേജിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1918.jpeg",
    },
    {
      src: "assets/img/Pastevents/1919.jpeg",
      caption:
        "തമിഴ്നാട് ഗവൺമെന്റ് ഹെൽത്ത് ഇൻഷുറൻസ് സ്കീം, മരിയഗിരി മലങ്കര കാത്തോലിക് കോളേജിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1919.jpeg",
    },
    {
      src: "assets/img/Pastevents/1920.jpeg",
      caption:
        "തമിഴ്നാട് ഗവൺമെന്റ് ഹെൽത്ത് ഇൻഷുറൻസ് സ്കീം, മരിയഗിരി മലങ്കര കാത്തോലിക് കോളേജിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1920.jpeg",
    },
    {
      src: "assets/img/Pastevents/1921.jpeg",
      caption:
        "തമിഴ്നാട് ഗവൺമെന്റ് ഹെൽത്ത് ഇൻഷുറൻസ് സ്കീം, മരിയഗിരി മലങ്കര കാത്തോലിക് കോളേജിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1921.jpeg",
    },
    {
      src: "assets/img/Pastevents/1922.jpeg",
      caption:
        "തമിഴ്നാട് ഗവൺമെന്റ് ഹെൽത്ത് ഇൻഷുറൻസ് സ്കീം, മരിയഗിരി മലങ്കര കാത്തോലിക് കോളേജിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1922.jpeg",
    },
    {
      src: "assets/img/Pastevents/1908.jpeg",
      caption:
        "വട്ടിയൂർക്കാവ് ശ്രീ ചിത്തിര ആർട്സ് ആൻ്റ് സ്പോർട്സ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ ജനറൽ സർജറി, കാർഡിയോളജി,ഡയബറ്റോളജി, ഡെൻ്റൽ എന്നീ വിഭാവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ ക്യാമ്പിന് നേതൃത്വം നൽകി.സൗജന്യ എക്കോ,ഇ സി ജി, ബ്ലഡ് ഷുഗർ, ബ്ലഡ് പ്രഷർ, ബി എം ഐ ടെസ്റ്റുകൾ നടത്തി.",
      thumb: "assets/img/Pastevents/1908.jpeg",
    },
    {
      src: "assets/img/Pastevents/1909.jpeg",
      caption:
        "വട്ടിയൂർക്കാവ് ശ്രീ ചിത്തിര ആർട്സ് ആൻ്റ് സ്പോർട്സ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ ജനറൽ സർജറി, കാർഡിയോളജി,ഡയബറ്റോളജി, ഡെൻ്റൽ എന്നീ വിഭാവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ ക്യാമ്പിന് നേതൃത്വം നൽകി.സൗജന്യ എക്കോ,ഇ സി ജി, ബ്ലഡ് ഷുഗർ, ബ്ലഡ് പ്രഷർ, ബി എം ഐ ടെസ്റ്റുകൾ നടത്തി.",
      thumb: "assets/img/Pastevents/1909.jpeg",
    },
    {
      src: "assets/img/Pastevents/1910.jpeg",
      caption:
        "വട്ടിയൂർക്കാവ് ശ്രീ ചിത്തിര ആർട്സ് ആൻ്റ് സ്പോർട്സ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ ജനറൽ സർജറി, കാർഡിയോളജി,ഡയബറ്റോളജി, ഡെൻ്റൽ എന്നീ വിഭാവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ ക്യാമ്പിന് നേതൃത്വം നൽകി.സൗജന്യ എക്കോ,ഇ സി ജി, ബ്ലഡ് ഷുഗർ, ബ്ലഡ് പ്രഷർ, ബി എം ഐ ടെസ്റ്റുകൾ നടത്തി.",
      thumb: "assets/img/Pastevents/1910.jpeg",
    },
    {
      src: "assets/img/Pastevents/1911.jpeg",
      caption:
        "വട്ടിയൂർക്കാവ് ശ്രീ ചിത്തിര ആർട്സ് ആൻ്റ് സ്പോർട്സ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ ജനറൽ സർജറി, കാർഡിയോളജി,ഡയബറ്റോളജി, ഡെൻ്റൽ എന്നീ വിഭാവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ ക്യാമ്പിന് നേതൃത്വം നൽകി.സൗജന്യ എക്കോ,ഇ സി ജി, ബ്ലഡ് ഷുഗർ, ബ്ലഡ് പ്രഷർ, ബി എം ഐ ടെസ്റ്റുകൾ നടത്തി.",
      thumb: "assets/img/Pastevents/1911.jpeg",
    },
    {
      src: "assets/img/Pastevents/1912.jpeg",
      caption:
        "വട്ടിയൂർക്കാവ് ശ്രീ ചിത്തിര ആർട്സ് ആൻ്റ് സ്പോർട്സ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ ജനറൽ സർജറി, കാർഡിയോളജി,ഡയബറ്റോളജി, ഡെൻ്റൽ എന്നീ വിഭാവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ ക്യാമ്പിന് നേതൃത്വം നൽകി.സൗജന്യ എക്കോ,ഇ സി ജി, ബ്ലഡ് ഷുഗർ, ബ്ലഡ് പ്രഷർ, ബി എം ഐ ടെസ്റ്റുകൾ നടത്തി.",
      thumb: "assets/img/Pastevents/1912.jpeg",
    },
    {
      src: "assets/img/Pastevents/1913.jpeg",
      caption:
        "വട്ടിയൂർക്കാവ് ശ്രീ ചിത്തിര ആർട്സ് ആൻ്റ് സ്പോർട്സ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ ജനറൽ സർജറി, കാർഡിയോളജി,ഡയബറ്റോളജി, ഡെൻ്റൽ എന്നീ വിഭാവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ ക്യാമ്പിന് നേതൃത്വം നൽകി.സൗജന്യ എക്കോ,ഇ സി ജി, ബ്ലഡ് ഷുഗർ, ബ്ലഡ് പ്രഷർ, ബി എം ഐ ടെസ്റ്റുകൾ നടത്തി.",
      thumb: "assets/img/Pastevents/1913.jpeg",
    },
    {
      src: "assets/img/Pastevents/1914.jpeg",
      caption:
        "വട്ടിയൂർക്കാവ് ശ്രീ ചിത്തിര ആർട്സ് ആൻ്റ് സ്പോർട്സ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ ജനറൽ സർജറി, കാർഡിയോളജി,ഡയബറ്റോളജി, ഡെൻ്റൽ എന്നീ വിഭാവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ ക്യാമ്പിന് നേതൃത്വം നൽകി.സൗജന്യ എക്കോ,ഇ സി ജി, ബ്ലഡ് ഷുഗർ, ബ്ലഡ് പ്രഷർ, ബി എം ഐ ടെസ്റ്റുകൾ നടത്തി.",
      thumb: "assets/img/Pastevents/1914.jpeg",
    },
    {
      src: "assets/img/Pastevents/1907.jpeg",
      caption:
        "ആരോഗ്യമേള -2023. അരുമാളൂർ തൊട്ടിക്കര ശ്രീ ഭദ്രകാളി ക്ഷേത്ര ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ ആരോഗ്യമേള സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീമതി Dr മഞ്ജു തമ്പി (ചീഫ് നെഫ്രോളജിസ്റ്റ് & മെഡിക്കൽ സൂപ്രണ്ട്, നിംസ് മെഡിസിറ്റി )ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി, ഓർത്തോപീഡിക്കസ്,പൾമിനോളജി,ഇ എൻ റ്റി,ഒഫ്ത്താൽമോളജി, ഡെൻ്റൽ, ആയുർവേദം എന്നി വിഭാവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.സൗ ജന്യ എക്കോ, ഇ സി ജി, പി എഫ് റ്റി,ഓട്ടിസം സ്ക്രീനിംഗ്, കുട്ടികളിലെ പഠനവൈകല്യം, കേൾവി പരിശോധന, ബ്ലഡ് ഷുഗർ, ബി പി, ബി എം ഐ ടെസ്റ്റുകൾ നടത്തി.",
      thumb: "assets/img/Pastevents/1907.jpeg",
    },
    {
      src: "assets/img/Pastevents/1895.jpeg",
      caption:
        "ആരോഗ്യമേള -2023. അരുമാളൂർ തൊട്ടിക്കര ശ്രീ ഭദ്രകാളി ക്ഷേത്ര ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ ആരോഗ്യമേള സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീമതി Dr മഞ്ജു തമ്പി (ചീഫ് നെഫ്രോളജിസ്റ്റ് & മെഡിക്കൽ സൂപ്രണ്ട്, നിംസ് മെഡിസിറ്റി )ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി, ഓർത്തോപീഡിക്കസ്,പൾമിനോളജി,ഇ എൻ റ്റി,ഒഫ്ത്താൽമോളജി, ഡെൻ്റൽ, ആയുർവേദം എന്നി വിഭാവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.സൗ ജന്യ എക്കോ, ഇ സി ജി, പി എഫ് റ്റി,ഓട്ടിസം സ്ക്രീനിംഗ്, കുട്ടികളിലെ പഠനവൈകല്യം, കേൾവി പരിശോധന, ബ്ലഡ് ഷുഗർ, ബി പി, ബി എം ഐ ടെസ്റ്റുകൾ നടത്തി.",
      thumb: "assets/img/Pastevents/1895.jpeg",
    },
    {
      src: "assets/img/Pastevents/1896.jpeg",
      caption:
        "ആരോഗ്യമേള -2023. അരുമാളൂർ തൊട്ടിക്കര ശ്രീ ഭദ്രകാളി ക്ഷേത്ര ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ ആരോഗ്യമേള സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീമതി Dr മഞ്ജു തമ്പി (ചീഫ് നെഫ്രോളജിസ്റ്റ് & മെഡിക്കൽ സൂപ്രണ്ട്, നിംസ് മെഡിസിറ്റി )ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി, ഓർത്തോപീഡിക്കസ്,പൾമിനോളജി,ഇ എൻ റ്റി,ഒഫ്ത്താൽമോളജി, ഡെൻ്റൽ, ആയുർവേദം എന്നി വിഭാവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.സൗ ജന്യ എക്കോ, ഇ സി ജി, പി എഫ് റ്റി,ഓട്ടിസം സ്ക്രീനിംഗ്, കുട്ടികളിലെ പഠനവൈകല്യം, കേൾവി പരിശോധന, ബ്ലഡ് ഷുഗർ, ബി പി, ബി എം ഐ ടെസ്റ്റുകൾ നടത്തി.",
      thumb: "assets/img/Pastevents/1896.jpeg",
    },
    {
      src: "assets/img/Pastevents/1897.jpeg",
      caption:
        "ആരോഗ്യമേള -2023. അരുമാളൂർ തൊട്ടിക്കര ശ്രീ ഭദ്രകാളി ക്ഷേത്ര ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ ആരോഗ്യമേള സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീമതി Dr മഞ്ജു തമ്പി (ചീഫ് നെഫ്രോളജിസ്റ്റ് & മെഡിക്കൽ സൂപ്രണ്ട്, നിംസ് മെഡിസിറ്റി )ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി, ഓർത്തോപീഡിക്കസ്,പൾമിനോളജി,ഇ എൻ റ്റി,ഒഫ്ത്താൽമോളജി, ഡെൻ്റൽ, ആയുർവേദം എന്നി വിഭാവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.സൗ ജന്യ എക്കോ, ഇ സി ജി, പി എഫ് റ്റി,ഓട്ടിസം സ്ക്രീനിംഗ്, കുട്ടികളിലെ പഠനവൈകല്യം, കേൾവി പരിശോധന, ബ്ലഡ് ഷുഗർ, ബി പി, ബി എം ഐ ടെസ്റ്റുകൾ നടത്തി.",
      thumb: "assets/img/Pastevents/1897.jpeg",
    },
    {
      src: "assets/img/Pastevents/1898.jpeg",
      caption:
        "ആരോഗ്യമേള -2023. അരുമാളൂർ തൊട്ടിക്കര ശ്രീ ഭദ്രകാളി ക്ഷേത്ര ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ ആരോഗ്യമേള സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീമതി Dr മഞ്ജു തമ്പി (ചീഫ് നെഫ്രോളജിസ്റ്റ് & മെഡിക്കൽ സൂപ്രണ്ട്, നിംസ് മെഡിസിറ്റി )ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി, ഓർത്തോപീഡിക്കസ്,പൾമിനോളജി,ഇ എൻ റ്റി,ഒഫ്ത്താൽമോളജി, ഡെൻ്റൽ, ആയുർവേദം എന്നി വിഭാവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.സൗ ജന്യ എക്കോ, ഇ സി ജി, പി എഫ് റ്റി,ഓട്ടിസം സ്ക്രീനിംഗ്, കുട്ടികളിലെ പഠനവൈകല്യം, കേൾവി പരിശോധന, ബ്ലഡ് ഷുഗർ, ബി പി, ബി എം ഐ ടെസ്റ്റുകൾ നടത്തി.",
      thumb: "assets/img/Pastevents/1898.jpeg",
    },
    {
      src: "assets/img/Pastevents/1899.jpeg",
      caption:
        "ആരോഗ്യമേള -2023. അരുമാളൂർ തൊട്ടിക്കര ശ്രീ ഭദ്രകാളി ക്ഷേത്ര ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ ആരോഗ്യമേള സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീമതി Dr മഞ്ജു തമ്പി (ചീഫ് നെഫ്രോളജിസ്റ്റ് & മെഡിക്കൽ സൂപ്രണ്ട്, നിംസ് മെഡിസിറ്റി )ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി, ഓർത്തോപീഡിക്കസ്,പൾമിനോളജി,ഇ എൻ റ്റി,ഒഫ്ത്താൽമോളജി, ഡെൻ്റൽ, ആയുർവേദം എന്നി വിഭാവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.സൗ ജന്യ എക്കോ, ഇ സി ജി, പി എഫ് റ്റി,ഓട്ടിസം സ്ക്രീനിംഗ്, കുട്ടികളിലെ പഠനവൈകല്യം, കേൾവി പരിശോധന, ബ്ലഡ് ഷുഗർ, ബി പി, ബി എം ഐ ടെസ്റ്റുകൾ നടത്തി.",
      thumb: "assets/img/Pastevents/1899.jpeg",
    },
    {
      src: "assets/img/Pastevents/1900.jpeg",
      caption:
        "ആരോഗ്യമേള -2023. അരുമാളൂർ തൊട്ടിക്കര ശ്രീ ഭദ്രകാളി ക്ഷേത്ര ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ ആരോഗ്യമേള സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീമതി Dr മഞ്ജു തമ്പി (ചീഫ് നെഫ്രോളജിസ്റ്റ് & മെഡിക്കൽ സൂപ്രണ്ട്, നിംസ് മെഡിസിറ്റി )ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി, ഓർത്തോപീഡിക്കസ്,പൾമിനോളജി,ഇ എൻ റ്റി,ഒഫ്ത്താൽമോളജി, ഡെൻ്റൽ, ആയുർവേദം എന്നി വിഭാവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.സൗ ജന്യ എക്കോ, ഇ സി ജി, പി എഫ് റ്റി,ഓട്ടിസം സ്ക്രീനിംഗ്, കുട്ടികളിലെ പഠനവൈകല്യം, കേൾവി പരിശോധന, ബ്ലഡ് ഷുഗർ, ബി പി, ബി എം ഐ ടെസ്റ്റുകൾ നടത്തി.",
      thumb: "assets/img/Pastevents/1900.jpeg",
    },
    {
      src: "assets/img/Pastevents/1901.jpeg",
      caption:
        "ആരോഗ്യമേള -2023. അരുമാളൂർ തൊട്ടിക്കര ശ്രീ ഭദ്രകാളി ക്ഷേത്ര ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ ആരോഗ്യമേള സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീമതി Dr മഞ്ജു തമ്പി (ചീഫ് നെഫ്രോളജിസ്റ്റ് & മെഡിക്കൽ സൂപ്രണ്ട്, നിംസ് മെഡിസിറ്റി )ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി, ഓർത്തോപീഡിക്കസ്,പൾമിനോളജി,ഇ എൻ റ്റി,ഒഫ്ത്താൽമോളജി, ഡെൻ്റൽ, ആയുർവേദം എന്നി വിഭാവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.സൗ ജന്യ എക്കോ, ഇ സി ജി, പി എഫ് റ്റി,ഓട്ടിസം സ്ക്രീനിംഗ്, കുട്ടികളിലെ പഠനവൈകല്യം, കേൾവി പരിശോധന, ബ്ലഡ് ഷുഗർ, ബി പി, ബി എം ഐ ടെസ്റ്റുകൾ നടത്തി.",
      thumb: "assets/img/Pastevents/1901.jpeg",
    },
    {
      src: "assets/img/Pastevents/1902.jpeg",
      caption:
        "ആരോഗ്യമേള -2023. അരുമാളൂർ തൊട്ടിക്കര ശ്രീ ഭദ്രകാളി ക്ഷേത്ര ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ ആരോഗ്യമേള സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീമതി Dr മഞ്ജു തമ്പി (ചീഫ് നെഫ്രോളജിസ്റ്റ് & മെഡിക്കൽ സൂപ്രണ്ട്, നിംസ് മെഡിസിറ്റി )ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി, ഓർത്തോപീഡിക്കസ്,പൾമിനോളജി,ഇ എൻ റ്റി,ഒഫ്ത്താൽമോളജി, ഡെൻ്റൽ, ആയുർവേദം എന്നി വിഭാവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.സൗ ജന്യ എക്കോ, ഇ സി ജി, പി എഫ് റ്റി,ഓട്ടിസം സ്ക്രീനിംഗ്, കുട്ടികളിലെ പഠനവൈകല്യം, കേൾവി പരിശോധന, ബ്ലഡ് ഷുഗർ, ബി പി, ബി എം ഐ ടെസ്റ്റുകൾ നടത്തി.",
      thumb: "assets/img/Pastevents/1902.jpeg",
    },
    {
      src: "assets/img/Pastevents/1903.jpeg",
      caption:
        "ആരോഗ്യമേള -2023. അരുമാളൂർ തൊട്ടിക്കര ശ്രീ ഭദ്രകാളി ക്ഷേത്ര ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ ആരോഗ്യമേള സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീമതി Dr മഞ്ജു തമ്പി (ചീഫ് നെഫ്രോളജിസ്റ്റ് & മെഡിക്കൽ സൂപ്രണ്ട്, നിംസ് മെഡിസിറ്റി )ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി, ഓർത്തോപീഡിക്കസ്,പൾമിനോളജി,ഇ എൻ റ്റി,ഒഫ്ത്താൽമോളജി, ഡെൻ്റൽ, ആയുർവേദം എന്നി വിഭാവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.സൗ ജന്യ എക്കോ, ഇ സി ജി, പി എഫ് റ്റി,ഓട്ടിസം സ്ക്രീനിംഗ്, കുട്ടികളിലെ പഠനവൈകല്യം, കേൾവി പരിശോധന, ബ്ലഡ് ഷുഗർ, ബി പി, ബി എം ഐ ടെസ്റ്റുകൾ നടത്തി.",
      thumb: "assets/img/Pastevents/1903.jpeg",
    },
    {
      src: "assets/img/Pastevents/1904.jpeg",
      caption:
        "ആരോഗ്യമേള -2023. അരുമാളൂർ തൊട്ടിക്കര ശ്രീ ഭദ്രകാളി ക്ഷേത്ര ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ ആരോഗ്യമേള സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീമതി Dr മഞ്ജു തമ്പി (ചീഫ് നെഫ്രോളജിസ്റ്റ് & മെഡിക്കൽ സൂപ്രണ്ട്, നിംസ് മെഡിസിറ്റി )ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി, ഓർത്തോപീഡിക്കസ്,പൾമിനോളജി,ഇ എൻ റ്റി,ഒഫ്ത്താൽമോളജി, ഡെൻ്റൽ, ആയുർവേദം എന്നി വിഭാവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.സൗ ജന്യ എക്കോ, ഇ സി ജി, പി എഫ് റ്റി,ഓട്ടിസം സ്ക്രീനിംഗ്, കുട്ടികളിലെ പഠനവൈകല്യം, കേൾവി പരിശോധന, ബ്ലഡ് ഷുഗർ, ബി പി, ബി എം ഐ ടെസ്റ്റുകൾ നടത്തി.",
      thumb: "assets/img/Pastevents/1904.jpeg",
    },
    {
      src: "assets/img/Pastevents/1905.jpeg",
      caption:
        "ആരോഗ്യമേള -2023. അരുമാളൂർ തൊട്ടിക്കര ശ്രീ ഭദ്രകാളി ക്ഷേത്ര ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ ആരോഗ്യമേള സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീമതി Dr മഞ്ജു തമ്പി (ചീഫ് നെഫ്രോളജിസ്റ്റ് & മെഡിക്കൽ സൂപ്രണ്ട്, നിംസ് മെഡിസിറ്റി )ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി, ഓർത്തോപീഡിക്കസ്,പൾമിനോളജി,ഇ എൻ റ്റി,ഒഫ്ത്താൽമോളജി, ഡെൻ്റൽ, ആയുർവേദം എന്നി വിഭാവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.സൗ ജന്യ എക്കോ, ഇ സി ജി, പി എഫ് റ്റി,ഓട്ടിസം സ്ക്രീനിംഗ്, കുട്ടികളിലെ പഠനവൈകല്യം, കേൾവി പരിശോധന, ബ്ലഡ് ഷുഗർ, ബി പി, ബി എം ഐ ടെസ്റ്റുകൾ നടത്തി.",
      thumb: "assets/img/Pastevents/1905.jpeg",
    },
    {
      src: "assets/img/Pastevents/1906.jpeg",
      caption:
        "ആരോഗ്യമേള -2023. അരുമാളൂർ തൊട്ടിക്കര ശ്രീ ഭദ്രകാളി ക്ഷേത്ര ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ ആരോഗ്യമേള സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീമതി Dr മഞ്ജു തമ്പി (ചീഫ് നെഫ്രോളജിസ്റ്റ് & മെഡിക്കൽ സൂപ്രണ്ട്, നിംസ് മെഡിസിറ്റി )ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി, ഓർത്തോപീഡിക്കസ്,പൾമിനോളജി,ഇ എൻ റ്റി,ഒഫ്ത്താൽമോളജി, ഡെൻ്റൽ, ആയുർവേദം എന്നി വിഭാവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.സൗ ജന്യ എക്കോ, ഇ സി ജി, പി എഫ് റ്റി,ഓട്ടിസം സ്ക്രീനിംഗ്, കുട്ടികളിലെ പഠനവൈകല്യം, കേൾവി പരിശോധന, ബ്ലഡ് ഷുഗർ, ബി പി, ബി എം ഐ ടെസ്റ്റുകൾ നടത്തി.",
      thumb: "assets/img/Pastevents/1906.jpeg",
    },
    {
      src: "assets/img/Pastevents/1.jpeg",
      caption:
        "ആരോഗ്യമേള -2023. അരുമാളൂർ തൊട്ടിക്കര ശ്രീ ഭദ്രകാളി ക്ഷേത്ര ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ ആരോഗ്യമേള സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീമതി Dr മഞ്ജു തമ്പി (ചീഫ് നെഫ്രോളജിസ്റ്റ് & മെഡിക്കൽ സൂപ്രണ്ട്, നിംസ് മെഡിസിറ്റി )ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി, ഓർത്തോപീഡിക്കസ്,പൾമിനോളജി,ഇ എൻ റ്റി,ഒഫ്ത്താൽമോളജി, ഡെൻ്റൽ, ആയുർവേദം എന്നി വിഭാവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.സൗ ജന്യ എക്കോ, ഇ സി ജി, പി എഫ് റ്റി,ഓട്ടിസം സ്ക്രീനിംഗ്, കുട്ടികളിലെ പഠനവൈകല്യം, കേൾവി പരിശോധന, ബ്ലഡ് ഷുഗർ, ബി പി, ബി എം ഐ ടെസ്റ്റുകൾ നടത്തി.",
      thumb: "assets/img/Pastevents/1.jpeg",
    },
    {
      src: "assets/img/Pastevents/1890.jpeg",
      caption:
        "നാഷനൽ സർവീസ് സ്കീം UIT കുറവൻക്കോണം, ട്രിവാൻഡ്രം റെയിൻബോ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1890.jpeg",
    },
    {
      src: "assets/img/Pastevents/1891.jpeg",
      caption:
        "നാഷനൽ സർവീസ് സ്കീം UIT കുറവൻക്കോണം, ട്രിവാൻഡ്രം റെയിൻബോ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1891.jpeg",
    },
    {
      src: "assets/img/Pastevents/1892.jpeg",
      caption:
        "നാഷനൽ സർവീസ് സ്കീം UIT കുറവൻക്കോണം, ട്രിവാൻഡ്രം റെയിൻബോ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1892.jpeg",
    },
    {
      src: "assets/img/Pastevents/1893.jpeg",
      caption:
        "നാഷനൽ സർവീസ് സ്കീം UIT കുറവൻക്കോണം, ട്രിവാൻഡ്രം റെയിൻബോ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1893.jpeg",
    },
    {
      src: "assets/img/Pastevents/1894.jpeg",
      caption:
        "നാഷനൽ സർവീസ് സ്കീം UIT കുറവൻക്കോണം, ട്രിവാൻഡ്രം റെയിൻബോ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1894.jpeg",
    },
    {
      src: "assets/img/Pastevents/1884.jpeg",
      caption:
        "എൻ്റെ ഗ്രാമം എൻ്റെ ഹൃദയം❤️ പദ്ധതിയുടെ ഭാഗമായി അതിയന്നൂർ ഗ്രാമ പഞ്ചായത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ കാർഡിയോളജി മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ പി വി സുനിൽകുമാർ( ഗ്രാമ പഞ്ചായത്ത് പ്രസിഡൻ്റ്) മഹനീയ സാന്നിധ്യം ശ്രീ കൊടങ്ങാവിള വിജയകുമാർ(ആരോഗ്യ- വിദ്യാഭ്യാസ സ്റ്റാൻഡിങ് കമ്മിറ്റി ചെയർമാൻ) ക്യാമ്പിൽ 200-പ്പരം പേർ കാർഡിയോളജി  സ്ക്രീനീംഗന്  വിധേയമായി. ക്യാമ്പിൽ സൗജന്യ എക്കോ, ഇ. സി. ജി, ബ്ലഡ് ഷുഗർ, ബ്ലഡ് പ്രഷർ, ബി എം ഐ ടെസ്റ്റുകൾ നടത്തി.",
      thumb: "assets/img/Pastevents/1884.jpeg",
    },
    {
      src: "assets/img/Pastevents/1885.jpeg",
      caption:
        "എൻ്റെ ഗ്രാമം എൻ്റെ ഹൃദയം❤️ പദ്ധതിയുടെ ഭാഗമായി അതിയന്നൂർ ഗ്രാമ പഞ്ചായത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ കാർഡിയോളജി മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ പി വി സുനിൽകുമാർ( ഗ്രാമ പഞ്ചായത്ത് പ്രസിഡൻ്റ്) മഹനീയ സാന്നിധ്യം ശ്രീ കൊടങ്ങാവിള വിജയകുമാർ(ആരോഗ്യ- വിദ്യാഭ്യാസ സ്റ്റാൻഡിങ് കമ്മിറ്റി ചെയർമാൻ) ക്യാമ്പിൽ 200-പ്പരം പേർ കാർഡിയോളജി  സ്ക്രീനീംഗന്  വിധേയമായി. ക്യാമ്പിൽ സൗജന്യ എക്കോ, ഇ. സി. ജി, ബ്ലഡ് ഷുഗർ, ബ്ലഡ് പ്രഷർ, ബി എം ഐ ടെസ്റ്റുകൾ നടത്തി.",
      thumb: "assets/img/Pastevents/1885.jpeg",
    },
    {
      src: "assets/img/Pastevents/1886.jpeg",
      caption:
        "എൻ്റെ ഗ്രാമം എൻ്റെ ഹൃദയം❤️ പദ്ധതിയുടെ ഭാഗമായി അതിയന്നൂർ ഗ്രാമ പഞ്ചായത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ കാർഡിയോളജി മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ പി വി സുനിൽകുമാർ( ഗ്രാമ പഞ്ചായത്ത് പ്രസിഡൻ്റ്) മഹനീയ സാന്നിധ്യം ശ്രീ കൊടങ്ങാവിള വിജയകുമാർ(ആരോഗ്യ- വിദ്യാഭ്യാസ സ്റ്റാൻഡിങ് കമ്മിറ്റി ചെയർമാൻ) ക്യാമ്പിൽ 200-പ്പരം പേർ കാർഡിയോളജി  സ്ക്രീനീംഗന്  വിധേയമായി. ക്യാമ്പിൽ സൗജന്യ എക്കോ, ഇ. സി. ജി, ബ്ലഡ് ഷുഗർ, ബ്ലഡ് പ്രഷർ, ബി എം ഐ ടെസ്റ്റുകൾ നടത്തി.",
      thumb: "assets/img/Pastevents/1886.jpeg",
    },
    {
      src: "assets/img/Pastevents/1887.jpeg",
      caption:
        "എൻ്റെ ഗ്രാമം എൻ്റെ ഹൃദയം❤️ പദ്ധതിയുടെ ഭാഗമായി അതിയന്നൂർ ഗ്രാമ പഞ്ചായത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ കാർഡിയോളജി മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ പി വി സുനിൽകുമാർ( ഗ്രാമ പഞ്ചായത്ത് പ്രസിഡൻ്റ്) മഹനീയ സാന്നിധ്യം ശ്രീ കൊടങ്ങാവിള വിജയകുമാർ(ആരോഗ്യ- വിദ്യാഭ്യാസ സ്റ്റാൻഡിങ് കമ്മിറ്റി ചെയർമാൻ) ക്യാമ്പിൽ 200-പ്പരം പേർ കാർഡിയോളജി  സ്ക്രീനീംഗന്  വിധേയമായി. ക്യാമ്പിൽ സൗജന്യ എക്കോ, ഇ. സി. ജി, ബ്ലഡ് ഷുഗർ, ബ്ലഡ് പ്രഷർ, ബി എം ഐ ടെസ്റ്റുകൾ നടത്തി.",
      thumb: "assets/img/Pastevents/1887.jpeg",
    },
    {
      src: "assets/img/Pastevents/1888.jpeg",
      caption:
        "എൻ്റെ ഗ്രാമം എൻ്റെ ഹൃദയം❤️ പദ്ധതിയുടെ ഭാഗമായി അതിയന്നൂർ ഗ്രാമ പഞ്ചായത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ കാർഡിയോളജി മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ പി വി സുനിൽകുമാർ( ഗ്രാമ പഞ്ചായത്ത് പ്രസിഡൻ്റ്) മഹനീയ സാന്നിധ്യം ശ്രീ കൊടങ്ങാവിള വിജയകുമാർ(ആരോഗ്യ- വിദ്യാഭ്യാസ സ്റ്റാൻഡിങ് കമ്മിറ്റി ചെയർമാൻ) ക്യാമ്പിൽ 200-പ്പരം പേർ കാർഡിയോളജി  സ്ക്രീനീംഗന്  വിധേയമായി. ക്യാമ്പിൽ സൗജന്യ എക്കോ, ഇ. സി. ജി, ബ്ലഡ് ഷുഗർ, ബ്ലഡ് പ്രഷർ, ബി എം ഐ ടെസ്റ്റുകൾ നടത്തി.",
      thumb: "assets/img/Pastevents/1888.jpeg",
    },
    {
      src: "assets/img/Pastevents/1889.jpeg",
      caption:
        "എൻ്റെ ഗ്രാമം എൻ്റെ ഹൃദയം❤️ പദ്ധതിയുടെ ഭാഗമായി അതിയന്നൂർ ഗ്രാമ പഞ്ചായത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ കാർഡിയോളജി മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ പി വി സുനിൽകുമാർ( ഗ്രാമ പഞ്ചായത്ത് പ്രസിഡൻ്റ്) മഹനീയ സാന്നിധ്യം ശ്രീ കൊടങ്ങാവിള വിജയകുമാർ(ആരോഗ്യ- വിദ്യാഭ്യാസ സ്റ്റാൻഡിങ് കമ്മിറ്റി ചെയർമാൻ) ക്യാമ്പിൽ 200-പ്പരം പേർ കാർഡിയോളജി  സ്ക്രീനീംഗന്  വിധേയമായി. ക്യാമ്പിൽ സൗജന്യ എക്കോ, ഇ. സി. ജി, ബ്ലഡ് ഷുഗർ, ബ്ലഡ് പ്രഷർ, ബി എം ഐ ടെസ്റ്റുകൾ നടത്തി.",
      thumb: "assets/img/Pastevents/1889.jpeg",
    },

    {
      src: "assets/img/Pastevents/1879.jpeg",
      caption:
        "കോട്ടൂർ ഗീതാഞ്ജലി ഗ്രന്ഥശാല, നെടുമങ്ങാട് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം:ശ്രീ മണികണ്ഠൻ (ഗ്രാമ പഞ്ചായത്ത് പ്രസിഡൻ്റ്,കുറ്റിച്ചൽ.",
      thumb: "assets/img/Pastevents/1879.jpeg",
    },
    {
      src: "assets/img/Pastevents/1880.jpeg",
      caption:
        "കോട്ടൂർ ഗീതാഞ്ജലി ഗ്രന്ഥശാല, നെടുമങ്ങാട് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1880.jpeg",
    },
    {
      src: "assets/img/Pastevents/1881.jpeg",
      caption:
        "കോട്ടൂർ ഗീതാഞ്ജലി ഗ്രന്ഥശാല, നെടുമങ്ങാട് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1881.jpeg",
    },
    {
      src: "assets/img/Pastevents/1882.jpeg",
      caption:
        "കോട്ടൂർ ഗീതാഞ്ജലി ഗ്രന്ഥശാല, നെടുമങ്ങാട് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1882.jpeg",
    },
    {
      src: "assets/img/Pastevents/1883.jpeg",
      caption:
        "കോട്ടൂർ ഗീതാഞ്ജലി ഗ്രന്ഥശാല, നെടുമങ്ങാട് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1883.jpeg",
    },
    {
      src: "assets/img/Pastevents/1872.jpeg",
      caption:
        "പൊന്നുമംഗലം എൻ എസ് എസ് കരയോഗം,തിരുവനന്തപുരം ക്രിസ്റ്റ്ൽ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1872.jpeg",
    },
    {
      src: "assets/img/Pastevents/1873.jpeg",
      caption:
        "പൊന്നുമംഗലം എൻ എസ് എസ് കരയോഗം,തിരുവനന്തപുരം ക്രിസ്റ്റ്ൽ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1873.jpeg",
    },
    {
      src: "assets/img/Pastevents/1874.jpeg",
      caption:
        "പൊന്നുമംഗലം എൻ എസ് എസ് കരയോഗം,തിരുവനന്തപുരം ക്രിസ്റ്റ്ൽ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1874.jpeg",
    },
    {
      src: "assets/img/Pastevents/1875.jpeg",
      caption:
        "പൊന്നുമംഗലം എൻ എസ് എസ് കരയോഗം,തിരുവനന്തപുരം ക്രിസ്റ്റ്ൽ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1875.jpeg",
    },
    {
      src: "assets/img/Pastevents/1876.jpeg",
      caption:
        "പൊന്നുമംഗലം എൻ എസ് എസ് കരയോഗം,തിരുവനന്തപുരം ക്രിസ്റ്റ്ൽ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1876.jpeg",
    },
    {
      src: "assets/img/Pastevents/1877.jpeg",
      caption:
        "പൊന്നുമംഗലം എൻ എസ് എസ് കരയോഗം,തിരുവനന്തപുരം ക്രിസ്റ്റ്ൽ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1877.jpeg",
    },
    {
      src: "assets/img/Pastevents/1878.jpeg",
      caption:
        "പൊന്നുമംഗലം എൻ എസ് എസ് കരയോഗം,തിരുവനന്തപുരം ക്രിസ്റ്റ്ൽ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1878.jpeg",
    },
    {
      src: "assets/img/Pastevents/1866.jpeg",
      caption:
        " ഒറ്റശേഖരമംഗലം ശ്രീ മഹാദേവ ക്ഷേത്ര ട്രസ്റ്റ്, ആശുപത്രി സംരക്ഷണ സമിതിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1866.jpeg",
    },
    {
      src: "assets/img/Pastevents/1867.jpeg",
      caption:
        " ഒറ്റശേഖരമംഗലം ശ്രീ മഹാദേവ ക്ഷേത്ര ട്രസ്റ്റ്, ആശുപത്രി സംരക്ഷണ സമിതിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1867.jpeg",
    },
    {
      src: "assets/img/Pastevents/1868.jpeg",
      caption:
        " ഒറ്റശേഖരമംഗലം ശ്രീ മഹാദേവ ക്ഷേത്ര ട്രസ്റ്റ്, ആശുപത്രി സംരക്ഷണ സമിതിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1868.jpeg",
    },
    {
      src: "assets/img/Pastevents/1869.jpeg",
      caption:
        " ഒറ്റശേഖരമംഗലം ശ്രീ മഹാദേവ ക്ഷേത്ര ട്രസ്റ്റ്, ആശുപത്രി സംരക്ഷണ സമിതിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1869.jpeg",
    },
    {
      src: "assets/img/Pastevents/1870.jpeg",
      caption:
        " ഒറ്റശേഖരമംഗലം ശ്രീ മഹാദേവ ക്ഷേത്ര ട്രസ്റ്റ്, ആശുപത്രി സംരക്ഷണ സമിതിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1870.jpeg",
    },
    {
      src: "assets/img/Pastevents/1871.jpeg",
      caption:
        " ഒറ്റശേഖരമംഗലം ശ്രീ മഹാദേവ ക്ഷേത്ര ട്രസ്റ്റ്, ആശുപത്രി സംരക്ഷണ സമിതിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1871.jpeg",
    },
    {
      src: "assets/img/Pastevents/1861.jpeg",
      caption:
        "തിരുവനന്തപുരം സീപോർട്ട് ലയൺസ് ക്ലബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെ സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ",
      thumb: "assets/img/Pastevents/1861.jpeg",
    },
    {
      src: "assets/img/Pastevents/1862.jpeg",
      caption:
        "തിരുവനന്തപുരം സീപോർട്ട് ലയൺസ് ക്ലബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെ സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ",
      thumb: "assets/img/Pastevents/1862.jpeg",
    },
    {
      src: "assets/img/Pastevents/1863.jpeg",
      caption:
        "തിരുവനന്തപുരം സീപോർട്ട് ലയൺസ് ക്ലബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെ സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ",
      thumb: "assets/img/Pastevents/1863.jpeg",
    },
    {
      src: "assets/img/Pastevents/1864.jpeg",
      caption:
        "തിരുവനന്തപുരം സീപോർട്ട് ലയൺസ് ക്ലബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെ സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ",
      thumb: "assets/img/Pastevents/1864.jpeg",
    },
    {
      src: "assets/img/Pastevents/1865.jpeg",
      caption:
        "തിരുവനന്തപുരം സീപോർട്ട് ലയൺസ് ക്ലബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെ സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ",
      thumb: "assets/img/Pastevents/1865.jpeg",
    },
    {
      src: "assets/img/Pastevents/1856.jpeg",
      caption:
        "വെങ്ങാനൂർ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1856.jpeg",
    },
    {
      src: "assets/img/Pastevents/1857.jpeg",
      caption:
        "വെങ്ങാനൂർ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1857.jpeg",
    },
    {
      src: "assets/img/Pastevents/1858.jpeg",
      caption:
        "വെങ്ങാനൂർ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1858.jpeg",
    },
    {
      src: "assets/img/Pastevents/1859.jpeg",
      caption:
        "വെങ്ങാനൂർ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1859.jpeg",
    },
    {
      src: "assets/img/Pastevents/1860.jpeg",
      caption:
        "വെങ്ങാനൂർ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1860.jpeg",
    },
    {
      src: "assets/img/Pastevents/1850.jpeg",
      caption:
        "കണിയാപുരം സഹജീവൻ സ്പെഷ്യൽ സ്കൂൾ, നാഷണൽ കോളേജ് സോഷ്യോളജി ഡിപ്പാർട്ട്മെന്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1850.jpeg",
    },
    {
      src: "assets/img/Pastevents/1851.jpeg",
      caption:
        "കണിയാപുരം സഹജീവൻ സ്പെഷ്യൽ സ്കൂൾ, നാഷണൽ കോളേജ് സോഷ്യോളജി ഡിപ്പാർട്ട്മെന്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1851.jpeg",
    },
    {
      src: "assets/img/Pastevents/1852.jpeg",
      caption:
        "കണിയാപുരം സഹജീവൻ സ്പെഷ്യൽ സ്കൂൾ, നാഷണൽ കോളേജ് സോഷ്യോളജി ഡിപ്പാർട്ട്മെന്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1852.jpeg",
    },
    {
      src: "assets/img/Pastevents/1853.jpeg",
      caption:
        "കണിയാപുരം സഹജീവൻ സ്പെഷ്യൽ സ്കൂൾ, നാഷണൽ കോളേജ് സോഷ്യോളജി ഡിപ്പാർട്ട്മെന്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1853.jpeg",
    },
    {
      src: "assets/img/Pastevents/1854.jpeg",
      caption:
        "കണിയാപുരം സഹജീവൻ സ്പെഷ്യൽ സ്കൂൾ, നാഷണൽ കോളേജ് സോഷ്യോളജി ഡിപ്പാർട്ട്മെന്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1854.jpeg",
    },
    {
      src: "assets/img/Pastevents/1855.jpeg",
      caption:
        "കണിയാപുരം സഹജീവൻ സ്പെഷ്യൽ സ്കൂൾ, നാഷണൽ കോളേജ് സോഷ്യോളജി ഡിപ്പാർട്ട്മെന്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1855.jpeg",
    },
    {
      src: "assets/img/Pastevents/1844.jpeg",
      caption:
        "കിളിമാനൂർ മണ്ഡലം ഇന്ത്യൻ നാഷണൽ കോൺഗ്രസ്    തോപ്പിൽ യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1844.jpeg",
    },
    {
      src: "assets/img/Pastevents/1845.jpeg",
      caption:
        "കിളിമാനൂർ മണ്ഡലം ഇന്ത്യൻ നാഷണൽ കോൺഗ്രസ്    തോപ്പിൽ യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1845.jpeg",
    },
    {
      src: "assets/img/Pastevents/1846.jpeg",
      caption:
        "കിളിമാനൂർ മണ്ഡലം ഇന്ത്യൻ നാഷണൽ കോൺഗ്രസ്    തോപ്പിൽ യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1846.jpeg",
    },
    {
      src: "assets/img/Pastevents/1847.jpeg",
      caption:
        "കിളിമാനൂർ മണ്ഡലം ഇന്ത്യൻ നാഷണൽ കോൺഗ്രസ്    തോപ്പിൽ യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1847.jpeg",
    },
    {
      src: "assets/img/Pastevents/1848.jpeg",
      caption:
        "കിളിമാനൂർ മണ്ഡലം ഇന്ത്യൻ നാഷണൽ കോൺഗ്രസ്    തോപ്പിൽ യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1848.jpeg",
    },
    {
      src: "assets/img/Pastevents/1849.jpeg",
      caption:
        "കിളിമാനൂർ മണ്ഡലം ഇന്ത്യൻ നാഷണൽ കോൺഗ്രസ്    തോപ്പിൽ യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1849.jpeg",
    },

    {
      src: "assets/img/Pastevents/1838.jpeg",
      caption:
        "പുന്നംകോണം ശ്രീ ഭഗവതി ക്ഷേത്ര ട്രസ്റ്റ്, വട്ടിയൂർക്കാവ് സേവാഭാരതി യൂണിറ്റ്,തിരുവനന്തപുരം മോഡൽ ലയൺസ് ക്ലബ്ബ് മെജസ്റ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1838.jpeg",
    },
    {
      src: "assets/img/Pastevents/1839.jpeg",
      caption:
        "പുന്നംകോണം ശ്രീ ഭഗവതി ക്ഷേത്ര ട്രസ്റ്റ്, വട്ടിയൂർക്കാവ് സേവാഭാരതി യൂണിറ്റ്,തിരുവനന്തപുരം മോഡൽ ലയൺസ് ക്ലബ്ബ് മെജസ്റ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1839.jpeg",
    },
    {
      src: "assets/img/Pastevents/1840.jpeg",
      caption:
        "പുന്നംകോണം ശ്രീ ഭഗവതി ക്ഷേത്ര ട്രസ്റ്റ്, വട്ടിയൂർക്കാവ് സേവാഭാരതി യൂണിറ്റ്,തിരുവനന്തപുരം മോഡൽ ലയൺസ് ക്ലബ്ബ് മെജസ്റ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1840.jpeg",
    },
    {
      src: "assets/img/Pastevents/1841.jpeg",
      caption:
        "പുന്നംകോണം ശ്രീ ഭഗവതി ക്ഷേത്ര ട്രസ്റ്റ്, വട്ടിയൂർക്കാവ് സേവാഭാരതി യൂണിറ്റ്,തിരുവനന്തപുരം മോഡൽ ലയൺസ് ക്ലബ്ബ് മെജസ്റ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1841.jpeg",
    },
    {
      src: "assets/img/Pastevents/1842.jpeg",
      caption:
        "പുന്നംകോണം ശ്രീ ഭഗവതി ക്ഷേത്ര ട്രസ്റ്റ്, വട്ടിയൂർക്കാവ് സേവാഭാരതി യൂണിറ്റ്,തിരുവനന്തപുരം മോഡൽ ലയൺസ് ക്ലബ്ബ് മെജസ്റ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1842.jpeg",
    },
    {
      src: "assets/img/Pastevents/1843.jpeg",
      caption:
        "പുന്നംകോണം ശ്രീ ഭഗവതി ക്ഷേത്ര ട്രസ്റ്റ്, വട്ടിയൂർക്കാവ് സേവാഭാരതി യൂണിറ്റ്,തിരുവനന്തപുരം മോഡൽ ലയൺസ് ക്ലബ്ബ് മെജസ്റ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1843.jpeg",
    },
    {
      src: "assets/img/Pastevents/1831.jpeg",
      caption:
        "ലൈഫ് @98 (1998 ബാച്ച് V&HSS SSLC കൂട്ടായിമ)വട്ടിയൂർക്കാവ് മോഡൽ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1831.jpeg",
    },
    {
      src: "assets/img/Pastevents/1832.jpeg",
      caption:
        "ലൈഫ് @98 (1998 ബാച്ച് V&HSS SSLC കൂട്ടായിമ)വട്ടിയൂർക്കാവ് മോഡൽ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1832.jpeg",
    },
    {
      src: "assets/img/Pastevents/1833.jpeg",
      caption:
        "ലൈഫ് @98 (1998 ബാച്ച് V&HSS SSLC കൂട്ടായിമ)വട്ടിയൂർക്കാവ് മോഡൽ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1833.jpeg",
    },
    {
      src: "assets/img/Pastevents/1834.jpeg",
      caption:
        "ലൈഫ് @98 (1998 ബാച്ച് V&HSS SSLC കൂട്ടായിമ)വട്ടിയൂർക്കാവ് മോഡൽ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1834.jpeg",
    },
    {
      src: "assets/img/Pastevents/1835.jpeg",
      caption:
        "ലൈഫ് @98 (1998 ബാച്ച് V&HSS SSLC കൂട്ടായിമ)വട്ടിയൂർക്കാവ് മോഡൽ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1835.jpeg",
    },
    {
      src: "assets/img/Pastevents/1836.jpeg",
      caption:
        "ലൈഫ് @98 (1998 ബാച്ച് V&HSS SSLC കൂട്ടായിമ)വട്ടിയൂർക്കാവ് മോഡൽ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1836.jpeg",
    },
    {
      src: "assets/img/Pastevents/1837.jpeg",
      caption:
        "ലൈഫ് @98 (1998 ബാച്ച് V&HSS SSLC കൂട്ടായിമ)വട്ടിയൂർക്കാവ് മോഡൽ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1837.jpeg",
    },
    {
      src: "assets/img/Pastevents/1823.jpeg",
      caption:
        "കരകുളം സഹകരണ ബാങ്ക്, പേരൂർക്കട ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1823.jpeg",
    },
    {
      src: "assets/img/Pastevents/1824.jpeg",
      caption:
        "കരകുളം സഹകരണ ബാങ്ക്, പേരൂർക്കട ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1824.jpeg",
    },
    {
      src: "assets/img/Pastevents/1825.jpeg",
      caption:
        "കരകുളം സഹകരണ ബാങ്ക്, പേരൂർക്കട ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1825.jpeg",
    },
    {
      src: "assets/img/Pastevents/1826.jpeg",
      caption:
        "കരകുളം സഹകരണ ബാങ്ക്, പേരൂർക്കട ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1826.jpeg",
    },
    {
      src: "assets/img/Pastevents/1827.jpeg",
      caption:
        "കരകുളം സഹകരണ ബാങ്ക്, പേരൂർക്കട ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1827.jpeg",
    },
    {
      src: "assets/img/Pastevents/1828.jpeg",
      caption:
        "കരകുളം സഹകരണ ബാങ്ക്, പേരൂർക്കട ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1828.jpeg",
    },
    {
      src: "assets/img/Pastevents/1829.jpeg",
      caption:
        "കരകുളം സഹകരണ ബാങ്ക്, പേരൂർക്കട ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1829.jpeg",
    },
    {
      src: "assets/img/Pastevents/1830.jpeg",
      caption:
        "കരകുളം സഹകരണ ബാങ്ക്, പേരൂർക്കട ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1830.jpeg",
    },
    {
      src: "assets/img/Pastevents/1817.jpeg",
      caption:
        "കരകുളം സഹകരണ ബാങ്ക്, പേരൂർക്കട ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1817.jpeg",
    },
    {
      src: "assets/img/Pastevents/1818.jpeg",
      caption:
        "കരകുളം സഹകരണ ബാങ്ക്, പേരൂർക്കട ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1818.jpeg",
    },
    {
      src: "assets/img/Pastevents/1819.jpeg",
      caption:
        "കരകുളം സഹകരണ ബാങ്ക്, പേരൂർക്കട ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1819.jpeg",
    },
    {
      src: "assets/img/Pastevents/1820.jpeg",
      caption:
        "കരകുളം സഹകരണ ബാങ്ക്, പേരൂർക്കട ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1820.jpeg",
    },
    {
      src: "assets/img/Pastevents/1821.jpeg",
      caption:
        "കരകുളം സഹകരണ ബാങ്ക്, പേരൂർക്കട ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1821.jpeg",
    },
    {
      src: "assets/img/Pastevents/1822.jpeg",
      caption:
        "കരകുളം സഹകരണ ബാങ്ക്, പേരൂർക്കട ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1822.jpeg",
    },
    {
      src: "assets/img/Pastevents/1810.jpeg",
      caption:
        "തിരുവനന്തപുരം തമിഴ് സംഘം,തിരുവനന്തപുരം സെൻട്രൽ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1810.jpeg",
    },
    {
      src: "assets/img/Pastevents/1811.jpeg",
      caption:
        "തിരുവനന്തപുരം തമിഴ് സംഘം,തിരുവനന്തപുരം സെൻട്രൽ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1811.jpeg",
    },
    {
      src: "assets/img/Pastevents/1812.jpeg",
      caption:
        "തിരുവനന്തപുരം തമിഴ് സംഘം,തിരുവനന്തപുരം സെൻട്രൽ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1812.jpeg",
    },
    {
      src: "assets/img/Pastevents/1813.jpeg",
      caption:
        "തിരുവനന്തപുരം തമിഴ് സംഘം,തിരുവനന്തപുരം സെൻട്രൽ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1813.jpeg",
    },
    {
      src: "assets/img/Pastevents/1814.jpeg",
      caption:
        "തിരുവനന്തപുരം തമിഴ് സംഘം,തിരുവനന്തപുരം സെൻട്രൽ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1814.jpeg",
    },
    {
      src: "assets/img/Pastevents/1815.jpeg",
      caption:
        "തിരുവനന്തപുരം തമിഴ് സംഘം,തിരുവനന്തപുരം സെൻട്രൽ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1815.jpeg",
    },
    {
      src: "assets/img/Pastevents/1816.jpeg",
      caption:
        "തിരുവനന്തപുരം തമിഴ് സംഘം,തിരുവനന്തപുരം സെൻട്രൽ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1816.jpeg",
    },
    {
      src: "assets/img/Pastevents/1801.jpeg",
      caption:
        "എൻ്റെ ഗ്രാമം എൻ്റെ ഹൃദയം❤️ പദ്ധതിയുടെ ഭാഗമായി പള്ളിച്ചൽ ഗ്രാമ പഞ്ചായത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ കാർഡിയോളജി മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ ഡേ: ഐ ബി സതീഷ് (എംഎൽഎ കാട്ടാക്കട). മഹനീയ സാന്നിധ്യം ശ്രീമതി ടി മല്ലികാ ( പള്ളിച്ചൽ ഗ്രാമ പഞ്ചായത്ത്  പ്രസിഡൻ്റ്)  ക്യാമ്പിൽ 250-പ്പരം പേർ കാർഡിയോളജി  സ്ക്രീനീംഗന്  വിധേയമായി. ക്യാമ്പിൽ സൗജന്യ എക്കോ, ഇ. സി. ജി, ബ്ലഡ് ഷുഗർ, ബ്ലഡ് പ്രഷർ, ബി എം ഐ ടെസ്റ്റുകൾ നടത്തി.",
      thumb: "assets/img/Pastevents/1801.jpeg",
    },
    {
      src: "assets/img/Pastevents/1802.jpeg",
      caption:
        "എൻ്റെ ഗ്രാമം എൻ്റെ ഹൃദയം❤️ പദ്ധതിയുടെ ഭാഗമായി പള്ളിച്ചൽ ഗ്രാമ പഞ്ചായത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ കാർഡിയോളജി മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ ഡേ: ഐ ബി സതീഷ് (എംഎൽഎ കാട്ടാക്കട). മഹനീയ സാന്നിധ്യം ശ്രീമതി ടി മല്ലികാ ( പള്ളിച്ചൽ ഗ്രാമ പഞ്ചായത്ത്  പ്രസിഡൻ്റ്)  ക്യാമ്പിൽ 250-പ്പരം പേർ കാർഡിയോളജി  സ്ക്രീനീംഗന്  വിധേയമായി. ക്യാമ്പിൽ സൗജന്യ എക്കോ, ഇ. സി. ജി, ബ്ലഡ് ഷുഗർ, ബ്ലഡ് പ്രഷർ, ബി എം ഐ ടെസ്റ്റുകൾ നടത്തി.",
      thumb: "assets/img/Pastevents/1802.jpeg",
    },
    {
      src: "assets/img/Pastevents/1803.jpeg",
      caption:
        "എൻ്റെ ഗ്രാമം എൻ്റെ ഹൃദയം❤️ പദ്ധതിയുടെ ഭാഗമായി പള്ളിച്ചൽ ഗ്രാമ പഞ്ചായത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ കാർഡിയോളജി മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ ഡേ: ഐ ബി സതീഷ് (എംഎൽഎ കാട്ടാക്കട). മഹനീയ സാന്നിധ്യം ശ്രീമതി ടി മല്ലികാ ( പള്ളിച്ചൽ ഗ്രാമ പഞ്ചായത്ത്  പ്രസിഡൻ്റ്)  ക്യാമ്പിൽ 250-പ്പരം പേർ കാർഡിയോളജി  സ്ക്രീനീംഗന്  വിധേയമായി. ക്യാമ്പിൽ സൗജന്യ എക്കോ, ഇ. സി. ജി, ബ്ലഡ് ഷുഗർ, ബ്ലഡ് പ്രഷർ, ബി എം ഐ ടെസ്റ്റുകൾ നടത്തി.",
      thumb: "assets/img/Pastevents/1803.jpeg",
    },
    {
      src: "assets/img/Pastevents/1804.jpeg",
      caption:
        "എൻ്റെ ഗ്രാമം എൻ്റെ ഹൃദയം❤️ പദ്ധതിയുടെ ഭാഗമായി പള്ളിച്ചൽ ഗ്രാമ പഞ്ചായത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ കാർഡിയോളജി മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ ഡേ: ഐ ബി സതീഷ് (എംഎൽഎ കാട്ടാക്കട). മഹനീയ സാന്നിധ്യം ശ്രീമതി ടി മല്ലികാ ( പള്ളിച്ചൽ ഗ്രാമ പഞ്ചായത്ത്  പ്രസിഡൻ്റ്)  ക്യാമ്പിൽ 250-പ്പരം പേർ കാർഡിയോളജി  സ്ക്രീനീംഗന്  വിധേയമായി. ക്യാമ്പിൽ സൗജന്യ എക്കോ, ഇ. സി. ജി, ബ്ലഡ് ഷുഗർ, ബ്ലഡ് പ്രഷർ, ബി എം ഐ ടെസ്റ്റുകൾ നടത്തി.",
      thumb: "assets/img/Pastevents/1804.jpeg",
    },
    {
      src: "assets/img/Pastevents/1805.jpeg",
      caption:
        "എൻ്റെ ഗ്രാമം എൻ്റെ ഹൃദയം❤️ പദ്ധതിയുടെ ഭാഗമായി പള്ളിച്ചൽ ഗ്രാമ പഞ്ചായത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ കാർഡിയോളജി മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ ഡേ: ഐ ബി സതീഷ് (എംഎൽഎ കാട്ടാക്കട). മഹനീയ സാന്നിധ്യം ശ്രീമതി ടി മല്ലികാ ( പള്ളിച്ചൽ ഗ്രാമ പഞ്ചായത്ത്  പ്രസിഡൻ്റ്)  ക്യാമ്പിൽ 250-പ്പരം പേർ കാർഡിയോളജി  സ്ക്രീനീംഗന്  വിധേയമായി. ക്യാമ്പിൽ സൗജന്യ എക്കോ, ഇ. സി. ജി, ബ്ലഡ് ഷുഗർ, ബ്ലഡ് പ്രഷർ, ബി എം ഐ ടെസ്റ്റുകൾ നടത്തി.",
      thumb: "assets/img/Pastevents/1805.jpeg",
    },
    {
      src: "assets/img/Pastevents/1806.jpeg",
      caption:
        "എൻ്റെ ഗ്രാമം എൻ്റെ ഹൃദയം❤️ പദ്ധതിയുടെ ഭാഗമായി പള്ളിച്ചൽ ഗ്രാമ പഞ്ചായത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ കാർഡിയോളജി മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ ഡേ: ഐ ബി സതീഷ് (എംഎൽഎ കാട്ടാക്കട). മഹനീയ സാന്നിധ്യം ശ്രീമതി ടി മല്ലികാ ( പള്ളിച്ചൽ ഗ്രാമ പഞ്ചായത്ത്  പ്രസിഡൻ്റ്)  ക്യാമ്പിൽ 250-പ്പരം പേർ കാർഡിയോളജി  സ്ക്രീനീംഗന്  വിധേയമായി. ക്യാമ്പിൽ സൗജന്യ എക്കോ, ഇ. സി. ജി, ബ്ലഡ് ഷുഗർ, ബ്ലഡ് പ്രഷർ, ബി എം ഐ ടെസ്റ്റുകൾ നടത്തി.",
      thumb: "assets/img/Pastevents/1806.jpeg",
    },
    {
      src: "assets/img/Pastevents/1807.jpeg",
      caption:
        "എൻ്റെ ഗ്രാമം എൻ്റെ ഹൃദയം❤️ പദ്ധതിയുടെ ഭാഗമായി പള്ളിച്ചൽ ഗ്രാമ പഞ്ചായത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ കാർഡിയോളജി മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ ഡേ: ഐ ബി സതീഷ് (എംഎൽഎ കാട്ടാക്കട). മഹനീയ സാന്നിധ്യം ശ്രീമതി ടി മല്ലികാ ( പള്ളിച്ചൽ ഗ്രാമ പഞ്ചായത്ത്  പ്രസിഡൻ്റ്)  ക്യാമ്പിൽ 250-പ്പരം പേർ കാർഡിയോളജി  സ്ക്രീനീംഗന്  വിധേയമായി. ക്യാമ്പിൽ സൗജന്യ എക്കോ, ഇ. സി. ജി, ബ്ലഡ് ഷുഗർ, ബ്ലഡ് പ്രഷർ, ബി എം ഐ ടെസ്റ്റുകൾ നടത്തി.",
      thumb: "assets/img/Pastevents/1807.jpeg",
    },
    {
      src: "assets/img/Pastevents/1808.jpeg",
      caption:
        "എൻ്റെ ഗ്രാമം എൻ്റെ ഹൃദയം❤️ പദ്ധതിയുടെ ഭാഗമായി പള്ളിച്ചൽ ഗ്രാമ പഞ്ചായത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ കാർഡിയോളജി മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ ഡേ: ഐ ബി സതീഷ് (എംഎൽഎ കാട്ടാക്കട). മഹനീയ സാന്നിധ്യം ശ്രീമതി ടി മല്ലികാ ( പള്ളിച്ചൽ ഗ്രാമ പഞ്ചായത്ത്  പ്രസിഡൻ്റ്)  ക്യാമ്പിൽ 250-പ്പരം പേർ കാർഡിയോളജി  സ്ക്രീനീംഗന്  വിധേയമായി. ക്യാമ്പിൽ സൗജന്യ എക്കോ, ഇ. സി. ജി, ബ്ലഡ് ഷുഗർ, ബ്ലഡ് പ്രഷർ, ബി എം ഐ ടെസ്റ്റുകൾ നടത്തി.",
      thumb: "assets/img/Pastevents/1808.jpeg",
    },
    {
      src: "assets/img/Pastevents/1809.jpeg",
      caption:
        "എൻ്റെ ഗ്രാമം എൻ്റെ ഹൃദയം❤️ പദ്ധതിയുടെ ഭാഗമായി പള്ളിച്ചൽ ഗ്രാമ പഞ്ചായത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ കാർഡിയോളജി മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ ഡേ: ഐ ബി സതീഷ് (എംഎൽഎ കാട്ടാക്കട). മഹനീയ സാന്നിധ്യം ശ്രീമതി ടി മല്ലികാ ( പള്ളിച്ചൽ ഗ്രാമ പഞ്ചായത്ത്  പ്രസിഡൻ്റ്)  ക്യാമ്പിൽ 250-പ്പരം പേർ കാർഡിയോളജി  സ്ക്രീനീംഗന്  വിധേയമായി. ക്യാമ്പിൽ സൗജന്യ എക്കോ, ഇ. സി. ജി, ബ്ലഡ് ഷുഗർ, ബ്ലഡ് പ്രഷർ, ബി എം ഐ ടെസ്റ്റുകൾ നടത്തി.",
      thumb: "assets/img/Pastevents/1809.jpeg",
    },
    {
      src: "assets/img/Pastevents/1794.jpeg",
      caption:
        "നാഷണൽ സർവീസ് സ്കീം(സർഗ്ഗം-2022) നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1794.jpeg",
    },
    {
      src: "assets/img/Pastevents/1795.jpeg",
      caption:
        "നാഷണൽ സർവീസ് സ്കീം(സർഗ്ഗം-2022) നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1795.jpeg",
    },
    {
      src: "assets/img/Pastevents/1796.jpeg",
      caption:
        "നാഷണൽ സർവീസ് സ്കീം(സർഗ്ഗം-2022) നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1796.jpeg",
    },
    {
      src: "assets/img/Pastevents/1797.jpeg",
      caption:
        "നാഷണൽ സർവീസ് സ്കീം(സർഗ്ഗം-2022) നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1797.jpeg",
    },
    {
      src: "assets/img/Pastevents/1798.jpeg",
      caption:
        "നാഷണൽ സർവീസ് സ്കീം(സർഗ്ഗം-2022) നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1798.jpeg",
    },
    {
      src: "assets/img/Pastevents/1799.jpeg",
      caption:
        "നാഷണൽ സർവീസ് സ്കീം(സർഗ്ഗം-2022) നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1799.jpeg",
    },
    {
      src: "assets/img/Pastevents/1800.jpeg",
      caption:
        "നാഷണൽ സർവീസ് സ്കീം(സർഗ്ഗം-2022) നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1800.jpeg",
    },
    {
      src: "assets/img/Pastevents/1787.jpeg",
      caption:
        "കാവിയാട് ദിനകര പണിക്കർ സാംസ്കാരിക വേദിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1787.jpeg",
    },
    {
      src: "assets/img/Pastevents/1788.jpeg",
      caption:
        "കാവിയാട് ദിനകര പണിക്കർ സാംസ്കാരിക വേദിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1788.jpeg",
    },
    {
      src: "assets/img/Pastevents/1789.jpeg",
      caption:
        "കാവിയാട് ദിനകര പണിക്കർ സാംസ്കാരിക വേദിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1789.jpeg",
    },
    {
      src: "assets/img/Pastevents/1790.jpeg",
      caption:
        "കാവിയാട് ദിനകര പണിക്കർ സാംസ്കാരിക വേദിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1790.jpeg",
    },
    {
      src: "assets/img/Pastevents/1791.jpeg",
      caption:
        "കാവിയാട് ദിനകര പണിക്കർ സാംസ്കാരിക വേദിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1791.jpeg",
    },
    {
      src: "assets/img/Pastevents/1792.jpeg",
      caption:
        "കാവിയാട് ദിനകര പണിക്കർ സാംസ്കാരിക വേദിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1792.jpeg",
    },
    {
      src: "assets/img/Pastevents/1793.jpeg",
      caption:
        "കാവിയാട് ദിനകര പണിക്കർ സാംസ്കാരിക വേദിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1793.jpeg",
    },
    {
      src: "assets/img/Pastevents/1781.jpeg",
      caption:
        "ചാല ഡി വൈ എഫ് ഐ മേഖല കമ്മിറ്റി, ട്രിവാൻഡ്രം നാഷണൽ ക്ലബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1781.jpeg",
    },
    {
      src: "assets/img/Pastevents/1782.jpeg",
      caption:
        "ചാല ഡി വൈ എഫ് ഐ മേഖല കമ്മിറ്റി, ട്രിവാൻഡ്രം നാഷണൽ ക്ലബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1782.jpeg",
    },
    {
      src: "assets/img/Pastevents/1783.jpeg",
      caption:
        "ചാല ഡി വൈ എഫ് ഐ മേഖല കമ്മിറ്റി, ട്രിവാൻഡ്രം നാഷണൽ ക്ലബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1783.jpeg",
    },
    {
      src: "assets/img/Pastevents/1784.jpeg",
      caption:
        "ചാല ഡി വൈ എഫ് ഐ മേഖല കമ്മിറ്റി, ട്രിവാൻഡ്രം നാഷണൽ ക്ലബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1784.jpeg",
    },
    {
      src: "assets/img/Pastevents/1785.jpeg",
      caption:
        "ചാല ഡി വൈ എഫ് ഐ മേഖല കമ്മിറ്റി, ട്രിവാൻഡ്രം നാഷണൽ ക്ലബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1785.jpeg",
    },
    {
      src: "assets/img/Pastevents/1786.jpeg",
      caption:
        "ചാല ഡി വൈ എഫ് ഐ മേഖല കമ്മിറ്റി, ട്രിവാൻഡ്രം നാഷണൽ ക്ലബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1786.jpeg",
    },
    {
      src: "assets/img/Pastevents/1775.jpeg",
      caption:
        "കണ്ണേറ്റുമുക്ക് പീപ്പിൾസ്  റീഡിംഗ് റൂം  ആർട്സ് ആൻ്റ് സ്പോർട്സ് ക്ലബ്ബ്,ട്രിവാൻഡ്രം ഗ്രീൻ സിറ്റി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം: ശ്രീ ആൻ്റണി രാജു (ബഹു ട്രാൻസ്പോർട്ട് മന്ത്രി)",
      thumb: "assets/img/Pastevents/1775.jpeg",
    },
    {
      src: "assets/img/Pastevents/1776.jpeg",
      caption:
        "കണ്ണേറ്റുമുക്ക് പീപ്പിൾസ്  റീഡിംഗ് റൂം  ആർട്സ് ആൻ്റ് സ്പോർട്സ് ക്ലബ്ബ്,ട്രിവാൻഡ്രം ഗ്രീൻ സിറ്റി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം: ശ്രീ ആൻ്റണി രാജു (ബഹു ട്രാൻസ്പോർട്ട് മന്ത്രി)",
      thumb: "assets/img/Pastevents/1776.jpeg",
    },
    {
      src: "assets/img/Pastevents/1777.jpeg",
      caption:
        "കണ്ണേറ്റുമുക്ക് പീപ്പിൾസ്  റീഡിംഗ് റൂം  ആർട്സ് ആൻ്റ് സ്പോർട്സ് ക്ലബ്ബ്,ട്രിവാൻഡ്രം ഗ്രീൻ സിറ്റി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം: ശ്രീ ആൻ്റണി രാജു (ബഹു ട്രാൻസ്പോർട്ട് മന്ത്രി)",
      thumb: "assets/img/Pastevents/1777.jpeg",
    },
    {
      src: "assets/img/Pastevents/1778.jpeg",
      caption:
        "കണ്ണേറ്റുമുക്ക് പീപ്പിൾസ്  റീഡിംഗ് റൂം  ആർട്സ് ആൻ്റ് സ്പോർട്സ് ക്ലബ്ബ്,ട്രിവാൻഡ്രം ഗ്രീൻ സിറ്റി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം: ശ്രീ ആൻ്റണി രാജു (ബഹു ട്രാൻസ്പോർട്ട് മന്ത്രി)",
      thumb: "assets/img/Pastevents/1778.jpeg",
    },
    {
      src: "assets/img/Pastevents/1779.jpeg",
      caption:
        "കണ്ണേറ്റുമുക്ക് പീപ്പിൾസ്  റീഡിംഗ് റൂം  ആർട്സ് ആൻ്റ് സ്പോർട്സ് ക്ലബ്ബ്,ട്രിവാൻഡ്രം ഗ്രീൻ സിറ്റി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം: ശ്രീ ആൻ്റണി രാജു (ബഹു ട്രാൻസ്പോർട്ട് മന്ത്രി)",
      thumb: "assets/img/Pastevents/1779.jpeg",
    },
    {
      src: "assets/img/Pastevents/1780.jpeg",
      caption:
        "കണ്ണേറ്റുമുക്ക് പീപ്പിൾസ്  റീഡിംഗ് റൂം  ആർട്സ് ആൻ്റ് സ്പോർട്സ് ക്ലബ്ബ്,ട്രിവാൻഡ്രം ഗ്രീൻ സിറ്റി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം: ശ്രീ ആൻ്റണി രാജു (ബഹു ട്രാൻസ്പോർട്ട് മന്ത്രി)",
      thumb: "assets/img/Pastevents/1780.jpeg",
    },
    {
      src: "assets/img/Pastevents/1768.jpeg",
      caption:
        "വിഴിഞ്ഞം കോസ്റ്റൽ പോലീസ് സ്റ്റേഷൻൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ഉദ്ഘാടനം: ശ്രീ ജീ. സ്പർശൻ കുമാർ IPS (കമ്മീഷണർ ഓഫ് പോലീസ്,ട്രിവാൻഡ്രം സിറ്റി).",
      thumb: "assets/img/Pastevents/1768.jpeg",
    },
    {
      src: "assets/img/Pastevents/1769.jpeg",
      caption:
        "വിഴിഞ്ഞം കോസ്റ്റൽ പോലീസ് സ്റ്റേഷൻൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ഉദ്ഘാടനം: ശ്രീ ജീ. സ്പർശൻ കുമാർ IPS (കമ്മീഷണർ ഓഫ് പോലീസ്,ട്രിവാൻഡ്രം സിറ്റി).",
      thumb: "assets/img/Pastevents/1769.jpeg",
    },
    {
      src: "assets/img/Pastevents/1770.jpeg",
      caption:
        "വിഴിഞ്ഞം കോസ്റ്റൽ പോലീസ് സ്റ്റേഷൻൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ഉദ്ഘാടനം: ശ്രീ ജീ. സ്പർശൻ കുമാർ IPS (കമ്മീഷണർ ഓഫ് പോലീസ്,ട്രിവാൻഡ്രം സിറ്റി).",
      thumb: "assets/img/Pastevents/1770.jpeg",
    },
    {
      src: "assets/img/Pastevents/1771.jpeg",
      caption:
        "വിഴിഞ്ഞം കോസ്റ്റൽ പോലീസ് സ്റ്റേഷൻൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ഉദ്ഘാടനം: ശ്രീ ജീ. സ്പർശൻ കുമാർ IPS (കമ്മീഷണർ ഓഫ് പോലീസ്,ട്രിവാൻഡ്രം സിറ്റി).",
      thumb: "assets/img/Pastevents/1771.jpeg",
    },
    {
      src: "assets/img/Pastevents/1772.jpeg",
      caption:
        "വിഴിഞ്ഞം കോസ്റ്റൽ പോലീസ് സ്റ്റേഷൻൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ഉദ്ഘാടനം: ശ്രീ ജീ. സ്പർശൻ കുമാർ IPS (കമ്മീഷണർ ഓഫ് പോലീസ്,ട്രിവാൻഡ്രം സിറ്റി).",
      thumb: "assets/img/Pastevents/1772.jpeg",
    },
    {
      src: "assets/img/Pastevents/1773.jpeg",
      caption:
        "വിഴിഞ്ഞം കോസ്റ്റൽ പോലീസ് സ്റ്റേഷൻൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ഉദ്ഘാടനം: ശ്രീ ജീ. സ്പർശൻ കുമാർ IPS (കമ്മീഷണർ ഓഫ് പോലീസ്,ട്രിവാൻഡ്രം സിറ്റി).",
      thumb: "assets/img/Pastevents/1773.jpeg",
    },
    {
      src: "assets/img/Pastevents/1774.jpeg",
      caption:
        "വിഴിഞ്ഞം കോസ്റ്റൽ പോലീസ് സ്റ്റേഷൻൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ഉദ്ഘാടനം: ശ്രീ ജീ. സ്പർശൻ കുമാർ IPS (കമ്മീഷണർ ഓഫ് പോലീസ്,ട്രിവാൻഡ്രം സിറ്റി).",
      thumb: "assets/img/Pastevents/1774.jpeg",
    },
    {
      src: "assets/img/Pastevents/1762.jpeg",
      caption:
        "തമിഴ്നാട് ഗവൺമെൻ്റ് ഹെൽത്ത് ഇൻഷുറൻസ് സ്കീം, നാഗർകോവിൽ റോട്ടറി ക്ലബ്ബ് ഓഫ് ഗോൾഡൺ സിറ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1762.jpeg",
    },
    {
      src: "assets/img/Pastevents/1763.jpeg",
      caption:
        "തമിഴ്നാട് ഗവൺമെൻ്റ് ഹെൽത്ത് ഇൻഷുറൻസ് സ്കീം, നാഗർകോവിൽ റോട്ടറി ക്ലബ്ബ് ഓഫ് ഗോൾഡൺ സിറ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1763.jpeg",
    },
    {
      src: "assets/img/Pastevents/1764.jpeg",
      caption:
        "തമിഴ്നാട് ഗവൺമെൻ്റ് ഹെൽത്ത് ഇൻഷുറൻസ് സ്കീം, നാഗർകോവിൽ റോട്ടറി ക്ലബ്ബ് ഓഫ് ഗോൾഡൺ സിറ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1764.jpeg",
    },
    {
      src: "assets/img/Pastevents/1765.jpeg",
      caption:
        "തമിഴ്നാട് ഗവൺമെൻ്റ് ഹെൽത്ത് ഇൻഷുറൻസ് സ്കീം, നാഗർകോവിൽ റോട്ടറി ക്ലബ്ബ് ഓഫ് ഗോൾഡൺ സിറ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1765.jpeg",
    },
    {
      src: "assets/img/Pastevents/1766.jpeg",
      caption:
        "തമിഴ്നാട് ഗവൺമെൻ്റ് ഹെൽത്ത് ഇൻഷുറൻസ് സ്കീം, നാഗർകോവിൽ റോട്ടറി ക്ലബ്ബ് ഓഫ് ഗോൾഡൺ സിറ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1766.jpeg",
    },
    {
      src: "assets/img/Pastevents/1767.jpeg",
      caption:
        "തമിഴ്നാട് ഗവൺമെൻ്റ് ഹെൽത്ത് ഇൻഷുറൻസ് സ്കീം, നാഗർകോവിൽ റോട്ടറി ക്ലബ്ബ് ഓഫ് ഗോൾഡൺ സിറ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1767.jpeg",
    },
    {
      src: "assets/img/Pastevents/1753.jpeg",
      caption:
        "സി എസ് ഐ ചർച്ച് കാട്ടാക്കട,ജെയ്ഹോക്കർ ഇൻഷുറൻസ് കമ്പനിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1753.jpeg",
    },
    {
      src: "assets/img/Pastevents/1754.jpeg",
      caption:
        "സി എസ് ഐ ചർച്ച് കാട്ടാക്കട,ജെയ്ഹോക്കർ ഇൻഷുറൻസ് കമ്പനിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1754.jpeg",
    },
    {
      src: "assets/img/Pastevents/1755.jpeg",
      caption:
        "സി എസ് ഐ ചർച്ച് കാട്ടാക്കട,ജെയ്ഹോക്കർ ഇൻഷുറൻസ് കമ്പനിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1755.jpeg",
    },
    {
      src: "assets/img/Pastevents/1756.jpeg",
      caption:
        "സി എസ് ഐ ചർച്ച് കാട്ടാക്കട,ജെയ്ഹോക്കർ ഇൻഷുറൻസ് കമ്പനിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1756.jpeg",
    },
    {
      src: "assets/img/Pastevents/1757.jpeg",
      caption:
        "സി എസ് ഐ ചർച്ച് കാട്ടാക്കട,ജെയ്ഹോക്കർ ഇൻഷുറൻസ് കമ്പനിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1757.jpeg",
    },
    {
      src: "assets/img/Pastevents/1758.jpeg",
      caption:
        "സി എസ് ഐ ചർച്ച് കാട്ടാക്കട,ജെയ്ഹോക്കർ ഇൻഷുറൻസ് കമ്പനിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1758.jpeg",
    },
    {
      src: "assets/img/Pastevents/1759.jpeg",
      caption:
        "സി എസ് ഐ ചർച്ച് കാട്ടാക്കട,ജെയ്ഹോക്കർ ഇൻഷുറൻസ് കമ്പനിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1759.jpeg",
    },
    {
      src: "assets/img/Pastevents/1760.jpeg",
      caption:
        "സി എസ് ഐ ചർച്ച് കാട്ടാക്കട,ജെയ്ഹോക്കർ ഇൻഷുറൻസ് കമ്പനിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1760.jpeg",
    },
    {
      src: "assets/img/Pastevents/1761.jpeg",
      caption:
        "സി എസ് ഐ ചർച്ച് കാട്ടാക്കട,ജെയ്ഹോക്കർ ഇൻഷുറൻസ് കമ്പനിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1761.jpeg",
    },
    {
      src: "assets/img/Pastevents/1747.jpeg",
      caption:
        "അൾ കേരളാ ടെയിലേഴസ് അസോസിയേഷൻ, ട്രിവാൻഡ്രം ജെംസ് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1747.jpeg",
    },
    {
      src: "assets/img/Pastevents/1748.jpeg",
      caption:
        "അൾ കേരളാ ടെയിലേഴസ് അസോസിയേഷൻ, ട്രിവാൻഡ്രം ജെംസ് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1748.jpeg",
    },
    {
      src: "assets/img/Pastevents/1749.jpeg",
      caption:
        "അൾ കേരളാ ടെയിലേഴസ് അസോസിയേഷൻ, ട്രിവാൻഡ്രം ജെംസ് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1749.jpeg",
    },
    {
      src: "assets/img/Pastevents/1750.jpeg",
      caption:
        "അൾ കേരളാ ടെയിലേഴസ് അസോസിയേഷൻ, ട്രിവാൻഡ്രം ജെംസ് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1750.jpeg",
    },
    {
      src: "assets/img/Pastevents/1751.jpeg",
      caption:
        "അൾ കേരളാ ടെയിലേഴസ് അസോസിയേഷൻ, ട്രിവാൻഡ്രം ജെംസ് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1751.jpeg",
    },
    {
      src: "assets/img/Pastevents/1752.jpeg",
      caption:
        "അൾ കേരളാ ടെയിലേഴസ് അസോസിയേഷൻ, ട്രിവാൻഡ്രം ജെംസ് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1752.jpeg",
    },
    {
      src: "assets/img/Pastevents/1741.jpeg",
      caption:
        "നെടുമങ്ങാട് താന്നിമൂട് പര. അമലത്ഭോമാതാ ദേവാലയത്തിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1741.jpeg",
    },
    {
      src: "assets/img/Pastevents/1742.jpeg",
      caption:
        "നെടുമങ്ങാട് താന്നിമൂട് പര. അമലത്ഭോമാതാ ദേവാലയത്തിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1742.jpeg",
    },
    {
      src: "assets/img/Pastevents/1743.jpeg",
      caption:
        "നെടുമങ്ങാട് താന്നിമൂട് പര. അമലത്ഭോമാതാ ദേവാലയത്തിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1743.jpeg",
    },
    {
      src: "assets/img/Pastevents/1744.jpeg",
      caption:
        "നെടുമങ്ങാട് താന്നിമൂട് പര. അമലത്ഭോമാതാ ദേവാലയത്തിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1744.jpeg",
    },
    {
      src: "assets/img/Pastevents/1745.jpeg",
      caption:
        "നെടുമങ്ങാട് താന്നിമൂട് പര. അമലത്ഭോമാതാ ദേവാലയത്തിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1745.jpeg",
    },
    {
      src: "assets/img/Pastevents/1746.jpeg",
      caption:
        "നെടുമങ്ങാട് താന്നിമൂട് പര. അമലത്ഭോമാതാ ദേവാലയത്തിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1746.jpeg",
    },

    {
      src: "assets/img/Pastevents/1736.jpeg",
      caption:
        "പള്ളിച്ചൽ പഞ്ചായത്ത് പാമാംകോട് 1-വാർഡ്, ട്രിവാൻഡ്രം റെയിൻബോ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1736.jpeg",
    },
    {
      src: "assets/img/Pastevents/1737.jpeg",
      caption:
        "പള്ളിച്ചൽ പഞ്ചായത്ത് പാമാംകോട് 1-വാർഡ്, ട്രിവാൻഡ്രം റെയിൻബോ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1737.jpeg",
    },
    {
      src: "assets/img/Pastevents/1735.jpeg",
      caption:
        "പള്ളിച്ചൽ പഞ്ചായത്ത് പാമാംകോട് 1-വാർഡ്, ട്രിവാൻഡ്രം റെയിൻബോ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1735.jpeg",
    },
    {
      src: "assets/img/Pastevents/1738.jpeg",
      caption:
        "പള്ളിച്ചൽ പഞ്ചായത്ത് പാമാംകോട് 1-വാർഡ്, ട്രിവാൻഡ്രം റെയിൻബോ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1738.jpeg",
    },
    {
      src: "assets/img/Pastevents/1739.jpeg",
      caption:
        "പള്ളിച്ചൽ പഞ്ചായത്ത് പാമാംകോട് 1-വാർഡ്, ട്രിവാൻഡ്രം റെയിൻബോ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1739.jpeg",
    },
    {
      src: "assets/img/Pastevents/1740.jpeg",
      caption:
        "പള്ളിച്ചൽ പഞ്ചായത്ത് പാമാംകോട് 1-വാർഡ്, ട്രിവാൻഡ്രം റെയിൻബോ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1740.jpeg",
    },
    {
      src: "assets/img/Pastevents/1729.jpeg",
      caption:
        "കരമന ടാക്‌സ് ടവർ ജീവനക്കാരുടെ കൂട്ടായ്മയായ സമതയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1729.jpeg",
    },
    {
      src: "assets/img/Pastevents/1730.jpeg",
      caption:
        "കരമന ടാക്‌സ് ടവർ ജീവനക്കാരുടെ കൂട്ടായ്മയായ സമതയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1730.jpeg",
    },
    {
      src: "assets/img/Pastevents/1731.jpeg",
      caption:
        "കരമന ടാക്‌സ് ടവർ ജീവനക്കാരുടെ കൂട്ടായ്മയായ സമതയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1731.jpeg",
    },
    {
      src: "assets/img/Pastevents/1732.jpeg",
      caption:
        "കരമന ടാക്‌സ് ടവർ ജീവനക്കാരുടെ കൂട്ടായ്മയായ സമതയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1732.jpeg",
    },
    {
      src: "assets/img/Pastevents/1733.jpeg",
      caption:
        "കരമന ടാക്‌സ് ടവർ ജീവനക്കാരുടെ കൂട്ടായ്മയായ സമതയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1733.jpeg",
    },
    {
      src: "assets/img/Pastevents/1734.jpeg",
      caption:
        "കരമന ടാക്‌സ് ടവർ ജീവനക്കാരുടെ കൂട്ടായ്മയായ സമതയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1734.jpeg",
    },

    {
      src: "assets/img/Pastevents/1724.jpeg",
      caption:
        "ഊരുട്ടുകാല ദയാ ഇൻഡസ്ട്രിയലിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1724.jpeg",
    },
    {
      src: "assets/img/Pastevents/1725.jpeg",
      caption:
        "ഊരുട്ടുകാല ദയാ ഇൻഡസ്ട്രിയലിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1725.jpeg",
    },
    {
      src: "assets/img/Pastevents/1726.jpeg",
      caption:
        "ഊരുട്ടുകാല ദയാ ഇൻഡസ്ട്രിയലിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1726.jpeg",
    },
    {
      src: "assets/img/Pastevents/1727.jpeg",
      caption:
        "ഊരുട്ടുകാല ദയാ ഇൻഡസ്ട്രിയലിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1727.jpeg",
    },
    {
      src: "assets/img/Pastevents/1728.jpeg",
      caption:
        "ഊരുട്ടുകാല ദയാ ഇൻഡസ്ട്രിയലിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1728.jpeg",
    },
    {
      src: "assets/img/Pastevents/1718.jpeg",
      caption:
        "വെള്ളയമ്പലം വാട്ടർ അതോറിറ്റി എംപ്ലോയീസ് അസോസിയേഷൻ, പട്ടം ഇൻഡസ് മോട്ടേഴ്സിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1718.jpeg",
    },
    {
      src: "assets/img/Pastevents/1719.jpeg",
      caption:
        "വെള്ളയമ്പലം വാട്ടർ അതോറിറ്റി എംപ്ലോയീസ് അസോസിയേഷൻ, പട്ടം ഇൻഡസ് മോട്ടേഴ്സിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1719.jpeg",
    },
    {
      src: "assets/img/Pastevents/1720.jpeg",
      caption:
        "വെള്ളയമ്പലം വാട്ടർ അതോറിറ്റി എംപ്ലോയീസ് അസോസിയേഷൻ, പട്ടം ഇൻഡസ് മോട്ടേഴ്സിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1720.jpeg",
    },
    {
      src: "assets/img/Pastevents/1721.jpeg",
      caption:
        "വെള്ളയമ്പലം വാട്ടർ അതോറിറ്റി എംപ്ലോയീസ് അസോസിയേഷൻ, പട്ടം ഇൻഡസ് മോട്ടേഴ്സിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1721.jpeg",
    },
    {
      src: "assets/img/Pastevents/1722.jpeg",
      caption:
        "വെള്ളയമ്പലം വാട്ടർ അതോറിറ്റി എംപ്ലോയീസ് അസോസിയേഷൻ, പട്ടം ഇൻഡസ് മോട്ടേഴ്സിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1722.jpeg",
    },
    {
      src: "assets/img/Pastevents/1723.jpeg",
      caption:
        "വെള്ളയമ്പലം വാട്ടർ അതോറിറ്റി എംപ്ലോയീസ് അസോസിയേഷൻ, പട്ടം ഇൻഡസ് മോട്ടേഴ്സിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1723.jpeg",
    },
    {
      src: "assets/img/Pastevents/1711.jpeg",
      caption:
        "വികാസ് ഭവൻ എംപ്ലോയീസ് അസോസിയേഷൻ, പട്ടം ഇൻഡസ് മോട്ടേഴ്സിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1711.jpeg",
    },
    {
      src: "assets/img/Pastevents/1712.jpeg",
      caption:
        "വികാസ് ഭവൻ എംപ്ലോയീസ് അസോസിയേഷൻ, പട്ടം ഇൻഡസ് മോട്ടേഴ്സിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1712.jpeg",
    },
    {
      src: "assets/img/Pastevents/1713.jpeg",
      caption:
        "വികാസ് ഭവൻ എംപ്ലോയീസ് അസോസിയേഷൻ, പട്ടം ഇൻഡസ് മോട്ടേഴ്സിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1713.jpeg",
    },
    {
      src: "assets/img/Pastevents/1714.jpeg",
      caption:
        "വികാസ് ഭവൻ എംപ്ലോയീസ് അസോസിയേഷൻ, പട്ടം ഇൻഡസ് മോട്ടേഴ്സിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1714.jpeg",
    },
    {
      src: "assets/img/Pastevents/1715.jpeg",
      caption:
        "വികാസ് ഭവൻ എംപ്ലോയീസ് അസോസിയേഷൻ, പട്ടം ഇൻഡസ് മോട്ടേഴ്സിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1715.jpeg",
    },
    {
      src: "assets/img/Pastevents/1716.jpeg",
      caption:
        "വികാസ് ഭവൻ എംപ്ലോയീസ് അസോസിയേഷൻ, പട്ടം ഇൻഡസ് മോട്ടേഴ്സിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1716.jpeg",
    },
    {
      src: "assets/img/Pastevents/1717.jpeg",
      caption:
        "വികാസ് ഭവൻ എംപ്ലോയീസ് അസോസിയേഷൻ, പട്ടം ഇൻഡസ് മോട്ടേഴ്സിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1717.jpeg",
    },

    {
      src: "assets/img/Pastevents/1705.jpeg",
      caption:
        "വെണ്ണിയൂർ ഡി എം കോൺവെന്റ് - നിർമ്മലാ പ്രോവിൻസിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1705.jpeg",
    },
    {
      src: "assets/img/Pastevents/1706.jpeg",
      caption:
        "വെണ്ണിയൂർ ഡി എം കോൺവെന്റ് - നിർമ്മലാ പ്രോവിൻസിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1706.jpeg",
    },
    {
      src: "assets/img/Pastevents/1707.jpeg",
      caption:
        "വെണ്ണിയൂർ ഡി എം കോൺവെന്റ് - നിർമ്മലാ പ്രോവിൻസിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1707.jpeg",
    },
    {
      src: "assets/img/Pastevents/1708.jpeg",
      caption:
        "വെണ്ണിയൂർ ഡി എം കോൺവെന്റ് - നിർമ്മലാ പ്രോവിൻസിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1708.jpeg",
    },
    {
      src: "assets/img/Pastevents/1709.jpeg",
      caption:
        "വെണ്ണിയൂർ ഡി എം കോൺവെന്റ് - നിർമ്മലാ പ്രോവിൻസിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1709.jpeg",
    },
    {
      src: "assets/img/Pastevents/1710.jpeg",
      caption:
        "വെണ്ണിയൂർ ഡി എം കോൺവെന്റ് - നിർമ്മലാ പ്രോവിൻസിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1710.jpeg",
    },
    {
      src: "assets/img/Pastevents/1696.jpeg",
      caption:
        "എൻ്റെ ഗ്രാമം എൻ്റെ ഹൃദയം*❤️ പദ്ധതിയുടെ ഭാഗമായി കൊല്ലയിൽ ഗ്രാമ പഞ്ചായത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ കാർഡിയോളജി മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ സി കെ ഹരീന്ദ്രൻ (എംഎൽഎ പാറശ്ശാല). മഹനീയ സാന്നിധ്യം ശ്രീ നവനീത് കുമാർ എൻ എസ് (കൊല്ലയിൽ ഗ്രാമ പഞ്ചായത്ത്  പ്രസിഡൻ്റ്)  ക്യാമ്പിൽ 300-പ്പരം പേർ കാർഡിയോളജി  സ്ക്രീനീംഗന്  വിധേയമായി. ക്യാമ്പിൽ സൗജന്യ എക്കോ, ഇ. സി. ജി, ബ്ലഡ് ഷുഗർ, ബ്ലഡ് പ്രഷർ, ബി എം ഐ ടെസ്റ്റുകൾ നടത്തി.",
      thumb: "assets/img/Pastevents/1696.jpeg",
    },
    {
      src: "assets/img/Pastevents/1697.jpeg",
      caption:
        "എൻ്റെ ഗ്രാമം എൻ്റെ ഹൃദയം*❤️ പദ്ധതിയുടെ ഭാഗമായി കൊല്ലയിൽ ഗ്രാമ പഞ്ചായത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ കാർഡിയോളജി മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ സി കെ ഹരീന്ദ്രൻ (എംഎൽഎ പാറശ്ശാല). മഹനീയ സാന്നിധ്യം ശ്രീ നവനീത് കുമാർ എൻ എസ് (കൊല്ലയിൽ ഗ്രാമ പഞ്ചായത്ത്  പ്രസിഡൻ്റ്)  ക്യാമ്പിൽ 300-പ്പരം പേർ കാർഡിയോളജി  സ്ക്രീനീംഗന്  വിധേയമായി. ക്യാമ്പിൽ സൗജന്യ എക്കോ, ഇ. സി. ജി, ബ്ലഡ് ഷുഗർ, ബ്ലഡ് പ്രഷർ, ബി എം ഐ ടെസ്റ്റുകൾ നടത്തി.",
      thumb: "assets/img/Pastevents/1697.jpeg",
    },
    {
      src: "assets/img/Pastevents/1698.jpeg",
      caption:
        "എൻ്റെ ഗ്രാമം എൻ്റെ ഹൃദയം*❤️ പദ്ധതിയുടെ ഭാഗമായി കൊല്ലയിൽ ഗ്രാമ പഞ്ചായത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ കാർഡിയോളജി മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ സി കെ ഹരീന്ദ്രൻ (എംഎൽഎ പാറശ്ശാല). മഹനീയ സാന്നിധ്യം ശ്രീ നവനീത് കുമാർ എൻ എസ് (കൊല്ലയിൽ ഗ്രാമ പഞ്ചായത്ത്  പ്രസിഡൻ്റ്)  ക്യാമ്പിൽ 300-പ്പരം പേർ കാർഡിയോളജി  സ്ക്രീനീംഗന്  വിധേയമായി. ക്യാമ്പിൽ സൗജന്യ എക്കോ, ഇ. സി. ജി, ബ്ലഡ് ഷുഗർ, ബ്ലഡ് പ്രഷർ, ബി എം ഐ ടെസ്റ്റുകൾ നടത്തി.",
      thumb: "assets/img/Pastevents/1698.jpeg",
    },
    {
      src: "assets/img/Pastevents/1699.jpeg",
      caption:
        "എൻ്റെ ഗ്രാമം എൻ്റെ ഹൃദയം*❤️ പദ്ധതിയുടെ ഭാഗമായി കൊല്ലയിൽ ഗ്രാമ പഞ്ചായത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ കാർഡിയോളജി മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ സി കെ ഹരീന്ദ്രൻ (എംഎൽഎ പാറശ്ശാല). മഹനീയ സാന്നിധ്യം ശ്രീ നവനീത് കുമാർ എൻ എസ് (കൊല്ലയിൽ ഗ്രാമ പഞ്ചായത്ത്  പ്രസിഡൻ്റ്)  ക്യാമ്പിൽ 300-പ്പരം പേർ കാർഡിയോളജി  സ്ക്രീനീംഗന്  വിധേയമായി. ക്യാമ്പിൽ സൗജന്യ എക്കോ, ഇ. സി. ജി, ബ്ലഡ് ഷുഗർ, ബ്ലഡ് പ്രഷർ, ബി എം ഐ ടെസ്റ്റുകൾ നടത്തി.",
      thumb: "assets/img/Pastevents/1699.jpeg",
    },
    {
      src: "assets/img/Pastevents/1700.jpeg",
      caption:
        "എൻ്റെ ഗ്രാമം എൻ്റെ ഹൃദയം*❤️ പദ്ധതിയുടെ ഭാഗമായി കൊല്ലയിൽ ഗ്രാമ പഞ്ചായത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ കാർഡിയോളജി മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ സി കെ ഹരീന്ദ്രൻ (എംഎൽഎ പാറശ്ശാല). മഹനീയ സാന്നിധ്യം ശ്രീ നവനീത് കുമാർ എൻ എസ് (കൊല്ലയിൽ ഗ്രാമ പഞ്ചായത്ത്  പ്രസിഡൻ്റ്)  ക്യാമ്പിൽ 300-പ്പരം പേർ കാർഡിയോളജി  സ്ക്രീനീംഗന്  വിധേയമായി. ക്യാമ്പിൽ സൗജന്യ എക്കോ, ഇ. സി. ജി, ബ്ലഡ് ഷുഗർ, ബ്ലഡ് പ്രഷർ, ബി എം ഐ ടെസ്റ്റുകൾ നടത്തി.",
      thumb: "assets/img/Pastevents/1700.jpeg",
    },
    {
      src: "assets/img/Pastevents/1701.jpeg",
      caption:
        "എൻ്റെ ഗ്രാമം എൻ്റെ ഹൃദയം*❤️ പദ്ധതിയുടെ ഭാഗമായി കൊല്ലയിൽ ഗ്രാമ പഞ്ചായത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ കാർഡിയോളജി മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ സി കെ ഹരീന്ദ്രൻ (എംഎൽഎ പാറശ്ശാല). മഹനീയ സാന്നിധ്യം ശ്രീ നവനീത് കുമാർ എൻ എസ് (കൊല്ലയിൽ ഗ്രാമ പഞ്ചായത്ത്  പ്രസിഡൻ്റ്)  ക്യാമ്പിൽ 300-പ്പരം പേർ കാർഡിയോളജി  സ്ക്രീനീംഗന്  വിധേയമായി. ക്യാമ്പിൽ സൗജന്യ എക്കോ, ഇ. സി. ജി, ബ്ലഡ് ഷുഗർ, ബ്ലഡ് പ്രഷർ, ബി എം ഐ ടെസ്റ്റുകൾ നടത്തി.",
      thumb: "assets/img/Pastevents/1701.jpeg",
    },
    {
      src: "assets/img/Pastevents/1702.jpeg",
      caption:
        "എൻ്റെ ഗ്രാമം എൻ്റെ ഹൃദയം*❤️ പദ്ധതിയുടെ ഭാഗമായി കൊല്ലയിൽ ഗ്രാമ പഞ്ചായത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ കാർഡിയോളജി മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ സി കെ ഹരീന്ദ്രൻ (എംഎൽഎ പാറശ്ശാല). മഹനീയ സാന്നിധ്യം ശ്രീ നവനീത് കുമാർ എൻ എസ് (കൊല്ലയിൽ ഗ്രാമ പഞ്ചായത്ത്  പ്രസിഡൻ്റ്)  ക്യാമ്പിൽ 300-പ്പരം പേർ കാർഡിയോളജി  സ്ക്രീനീംഗന്  വിധേയമായി. ക്യാമ്പിൽ സൗജന്യ എക്കോ, ഇ. സി. ജി, ബ്ലഡ് ഷുഗർ, ബ്ലഡ് പ്രഷർ, ബി എം ഐ ടെസ്റ്റുകൾ നടത്തി.",
      thumb: "assets/img/Pastevents/1702.jpeg",
    },
    {
      src: "assets/img/Pastevents/1703.jpeg",
      caption:
        "എൻ്റെ ഗ്രാമം എൻ്റെ ഹൃദയം*❤️ പദ്ധതിയുടെ ഭാഗമായി കൊല്ലയിൽ ഗ്രാമ പഞ്ചായത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ കാർഡിയോളജി മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ സി കെ ഹരീന്ദ്രൻ (എംഎൽഎ പാറശ്ശാല). മഹനീയ സാന്നിധ്യം ശ്രീ നവനീത് കുമാർ എൻ എസ് (കൊല്ലയിൽ ഗ്രാമ പഞ്ചായത്ത്  പ്രസിഡൻ്റ്)  ക്യാമ്പിൽ 300-പ്പരം പേർ കാർഡിയോളജി  സ്ക്രീനീംഗന്  വിധേയമായി. ക്യാമ്പിൽ സൗജന്യ എക്കോ, ഇ. സി. ജി, ബ്ലഡ് ഷുഗർ, ബ്ലഡ് പ്രഷർ, ബി എം ഐ ടെസ്റ്റുകൾ നടത്തി.",
      thumb: "assets/img/Pastevents/1703.jpeg",
    },
    {
      src: "assets/img/Pastevents/1704.jpeg",
      caption:
        "എൻ്റെ ഗ്രാമം എൻ്റെ ഹൃദയം*❤️ പദ്ധതിയുടെ ഭാഗമായി കൊല്ലയിൽ ഗ്രാമ പഞ്ചായത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ കാർഡിയോളജി മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ സി കെ ഹരീന്ദ്രൻ (എംഎൽഎ പാറശ്ശാല). മഹനീയ സാന്നിധ്യം ശ്രീ നവനീത് കുമാർ എൻ എസ് (കൊല്ലയിൽ ഗ്രാമ പഞ്ചായത്ത്  പ്രസിഡൻ്റ്)  ക്യാമ്പിൽ 300-പ്പരം പേർ കാർഡിയോളജി  സ്ക്രീനീംഗന്  വിധേയമായി. ക്യാമ്പിൽ സൗജന്യ എക്കോ, ഇ. സി. ജി, ബ്ലഡ് ഷുഗർ, ബ്ലഡ് പ്രഷർ, ബി എം ഐ ടെസ്റ്റുകൾ നടത്തി.",
      thumb: "assets/img/Pastevents/1704.jpeg",
    },

    {
      src: "assets/img/Pastevents/1689.jpeg",
      caption:
        "വെള്ളറട ഗ്രാമപഞ്ചായത്തും തിരുവനന്തപുരം പ്രേം നസീർ സുഹൃത്ത് സമിതിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1689.jpeg",
    },
    {
      src: "assets/img/Pastevents/1690.jpeg",
      caption:
        "വെള്ളറട ഗ്രാമപഞ്ചായത്തും തിരുവനന്തപുരം പ്രേം നസീർ സുഹൃത്ത് സമിതിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1690.jpeg",
    },
    {
      src: "assets/img/Pastevents/1691.jpeg",
      caption:
        "വെള്ളറട ഗ്രാമപഞ്ചായത്തും തിരുവനന്തപുരം പ്രേം നസീർ സുഹൃത്ത് സമിതിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1691.jpeg",
    },
    {
      src: "assets/img/Pastevents/1692.jpeg",
      caption:
        "വെള്ളറട ഗ്രാമപഞ്ചായത്തും തിരുവനന്തപുരം പ്രേം നസീർ സുഹൃത്ത് സമിതിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1692.jpeg",
    },
    {
      src: "assets/img/Pastevents/1693.jpeg",
      caption:
        "വെള്ളറട ഗ്രാമപഞ്ചായത്തും തിരുവനന്തപുരം പ്രേം നസീർ സുഹൃത്ത് സമിതിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1693.jpeg",
    },
    {
      src: "assets/img/Pastevents/1694.jpeg",
      caption:
        "വെള്ളറട ഗ്രാമപഞ്ചായത്തും തിരുവനന്തപുരം പ്രേം നസീർ സുഹൃത്ത് സമിതിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1694.jpeg",
    },
    {
      src: "assets/img/Pastevents/1695.jpeg",
      caption:
        "വെള്ളറട ഗ്രാമപഞ്ചായത്തും തിരുവനന്തപുരം പ്രേം നസീർ സുഹൃത്ത് സമിതിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1695.jpeg",
    },
    {
      src: "assets/img/Pastevents/1682.jpeg",
      caption:
        "പാപ്പനംകോട് അരകത്ത് റെസിഡൻഷ്യൽ അസോസിയേഷൻ,ട്രിവാൻഡ്രം സ്മാർട്ട് സിറ്റി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1682.jpeg",
    },
    {
      src: "assets/img/Pastevents/1683.jpeg",
      caption:
        "പാപ്പനംകോട് അരകത്ത് റെസിഡൻഷ്യൽ അസോസിയേഷൻ,ട്രിവാൻഡ്രം സ്മാർട്ട് സിറ്റി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1683.jpeg",
    },
    {
      src: "assets/img/Pastevents/1684.jpeg",
      caption:
        "പാപ്പനംകോട് അരകത്ത് റെസിഡൻഷ്യൽ അസോസിയേഷൻ,ട്രിവാൻഡ്രം സ്മാർട്ട് സിറ്റി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1684.jpeg",
    },
    {
      src: "assets/img/Pastevents/1685.jpeg",
      caption:
        "പാപ്പനംകോട് അരകത്ത് റെസിഡൻഷ്യൽ അസോസിയേഷൻ,ട്രിവാൻഡ്രം സ്മാർട്ട് സിറ്റി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1685.jpeg",
    },
    {
      src: "assets/img/Pastevents/1686.jpeg",
      caption:
        "പാപ്പനംകോട് അരകത്ത് റെസിഡൻഷ്യൽ അസോസിയേഷൻ,ട്രിവാൻഡ്രം സ്മാർട്ട് സിറ്റി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1686.jpeg",
    },
    {
      src: "assets/img/Pastevents/1687.jpeg",
      caption:
        "പാപ്പനംകോട് അരകത്ത് റെസിഡൻഷ്യൽ അസോസിയേഷൻ,ട്രിവാൻഡ്രം സ്മാർട്ട് സിറ്റി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1687.jpeg",
    },
    {
      src: "assets/img/Pastevents/1688.jpeg",
      caption:
        "പാപ്പനംകോട് അരകത്ത് റെസിഡൻഷ്യൽ അസോസിയേഷൻ,ട്രിവാൻഡ്രം സ്മാർട്ട് സിറ്റി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1688.jpeg",
    },
    {
      src: "assets/img/Pastevents/1675.jpeg",
      caption:
        "സേവാ ഭാരതി അഴൂർ പഞ്ചായത്ത് സമിതി, ലയൺസ് ക്ലബ് ഓഫ് ട്രിവാൻഡ്രം മജസറ്റിക്കിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1675.jpeg",
    },
    {
      src: "assets/img/Pastevents/1676.jpeg",
      caption:
        "സേവാ ഭാരതി അഴൂർ പഞ്ചായത്ത് സമിതി, ലയൺസ് ക്ലബ് ഓഫ് ട്രിവാൻഡ്രം മജസറ്റിക്കിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1676.jpeg",
    },
    {
      src: "assets/img/Pastevents/1677.jpeg",
      caption:
        "സേവാ ഭാരതി അഴൂർ പഞ്ചായത്ത് സമിതി, ലയൺസ് ക്ലബ് ഓഫ് ട്രിവാൻഡ്രം മജസറ്റിക്കിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1677.jpeg",
    },
    {
      src: "assets/img/Pastevents/1678.jpeg",
      caption:
        "സേവാ ഭാരതി അഴൂർ പഞ്ചായത്ത് സമിതി, ലയൺസ് ക്ലബ് ഓഫ് ട്രിവാൻഡ്രം മജസറ്റിക്കിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1678.jpeg",
    },
    {
      src: "assets/img/Pastevents/1679.jpeg",
      caption:
        "സേവാ ഭാരതി അഴൂർ പഞ്ചായത്ത് സമിതി, ലയൺസ് ക്ലബ് ഓഫ് ട്രിവാൻഡ്രം മജസറ്റിക്കിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1679.jpeg",
    },
    {
      src: "assets/img/Pastevents/1680.jpeg",
      caption:
        "സേവാ ഭാരതി അഴൂർ പഞ്ചായത്ത് സമിതി, ലയൺസ് ക്ലബ് ഓഫ് ട്രിവാൻഡ്രം മജസറ്റിക്കിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1680.jpeg",
    },
    {
      src: "assets/img/Pastevents/1681.jpeg",
      caption:
        "സേവാ ഭാരതി അഴൂർ പഞ്ചായത്ത് സമിതി, ലയൺസ് ക്ലബ് ഓഫ് ട്രിവാൻഡ്രം മജസറ്റിക്കിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1681.jpeg",
    },
    {
      src: "assets/img/Pastevents/1670.jpeg",
      caption:
        "ഡിവൈഎഫ്ഐ വട്ടപച്ച ഏരിയാ കമ്മിറ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1670.jpeg",
    },
    {
      src: "assets/img/Pastevents/1671.jpeg",
      caption:
        "ഡിവൈഎഫ്ഐ വട്ടപച്ച ഏരിയാ കമ്മിറ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1671.jpeg",
    },
    {
      src: "assets/img/Pastevents/1672.jpeg",
      caption:
        "ഡിവൈഎഫ്ഐ വട്ടപച്ച ഏരിയാ കമ്മിറ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1672.jpeg",
    },
    {
      src: "assets/img/Pastevents/1673.jpeg",
      caption:
        "ഡിവൈഎഫ്ഐ വട്ടപച്ച ഏരിയാ കമ്മിറ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1673.jpeg",
    },
    {
      src: "assets/img/Pastevents/1674.jpeg",
      caption:
        "ഡിവൈഎഫ്ഐ വട്ടപച്ച ഏരിയാ കമ്മിറ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1674.jpeg",
    },
    {
      src: "assets/img/Pastevents/1665.jpeg",
      caption:
        "ആക്കുളം എയർ ഫോഴ്സ് അസോസിയേഷൻ, ട്രിവാൻഡ്രം കോസ്മോപോളിടൻ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1665.jpeg",
    },
    {
      src: "assets/img/Pastevents/1666.jpeg",
      caption:
        "ആക്കുളം എയർ ഫോഴ്സ് അസോസിയേഷൻ, ട്രിവാൻഡ്രം കോസ്മോപോളിടൻ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1666.jpeg",
    },
    {
      src: "assets/img/Pastevents/1667.jpeg",
      caption:
        "ആക്കുളം എയർ ഫോഴ്സ് അസോസിയേഷൻ, ട്രിവാൻഡ്രം കോസ്മോപോളിടൻ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1667.jpeg",
    },
    {
      src: "assets/img/Pastevents/1668.jpeg",
      caption:
        "ആക്കുളം എയർ ഫോഴ്സ് അസോസിയേഷൻ, ട്രിവാൻഡ്രം കോസ്മോപോളിടൻ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1668.jpeg",
    },
    {
      src: "assets/img/Pastevents/1669.jpeg",
      caption:
        "ആക്കുളം എയർ ഫോഴ്സ് അസോസിയേഷൻ, ട്രിവാൻഡ്രം കോസ്മോപോളിടൻ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1669.jpeg",
    },
    {
      src: "assets/img/Pastevents/1659.jpeg",
      caption:
        "പൂന്തുറ നഗരസഭാ വാർഡ് ,തിരുവനന്തപുരം ഇന്നേർ വീൽ ക്ലബ്,തിരുവനന്തപുരം ഇംപാക്ട് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1659.jpeg",
    },
    {
      src: "assets/img/Pastevents/1660.jpeg",
      caption:
        "പൂന്തുറ നഗരസഭാ വാർഡ് ,തിരുവനന്തപുരം ഇന്നേർ വീൽ ക്ലബ്,തിരുവനന്തപുരം ഇംപാക്ട് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1660.jpeg",
    },
    {
      src: "assets/img/Pastevents/1661.jpeg",
      caption:
        "പൂന്തുറ നഗരസഭാ വാർഡ് ,തിരുവനന്തപുരം ഇന്നേർ വീൽ ക്ലബ്,തിരുവനന്തപുരം ഇംപാക്ട് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1661.jpeg",
    },
    {
      src: "assets/img/Pastevents/1662.jpeg",
      caption:
        "പൂന്തുറ നഗരസഭാ വാർഡ് ,തിരുവനന്തപുരം ഇന്നേർ വീൽ ക്ലബ്,തിരുവനന്തപുരം ഇംപാക്ട് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1662.jpeg",
    },
    {
      src: "assets/img/Pastevents/1663.jpeg",
      caption:
        "പൂന്തുറ നഗരസഭാ വാർഡ് ,തിരുവനന്തപുരം ഇന്നേർ വീൽ ക്ലബ്,തിരുവനന്തപുരം ഇംപാക്ട് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1663.jpeg",
    },
    {
      src: "assets/img/Pastevents/1664.jpeg",
      caption:
        "പൂന്തുറ നഗരസഭാ വാർഡ് ,തിരുവനന്തപുരം ഇന്നേർ വീൽ ക്ലബ്,തിരുവനന്തപുരം ഇംപാക്ട് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1664.jpeg",
    },
    {
      src: "assets/img/Pastevents/1652.jpeg",
      caption:
        "ഏണിക്കര- തുടയൻകോട് റെസിഡൻഷ്യൽ അസോസിയേഷൻ,ട്രിവാൻഡ്രം സ്മാർട്ട് സിറ്റി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1652.jpeg",
    },
    {
      src: "assets/img/Pastevents/1653.jpeg",
      caption:
        "ഏണിക്കര- തുടയൻകോട് റെസിഡൻഷ്യൽ അസോസിയേഷൻ,ട്രിവാൻഡ്രം സ്മാർട്ട് സിറ്റി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1653.jpeg",
    },
    {
      src: "assets/img/Pastevents/1654.jpeg",
      caption:
        "ഏണിക്കര- തുടയൻകോട് റെസിഡൻഷ്യൽ അസോസിയേഷൻ,ട്രിവാൻഡ്രം സ്മാർട്ട് സിറ്റി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1654.jpeg",
    },
    {
      src: "assets/img/Pastevents/1655.jpeg",
      caption:
        "ഏണിക്കര- തുടയൻകോട് റെസിഡൻഷ്യൽ അസോസിയേഷൻ,ട്രിവാൻഡ്രം സ്മാർട്ട് സിറ്റി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1655.jpeg",
    },
    {
      src: "assets/img/Pastevents/1656.jpeg",
      caption:
        "ഏണിക്കര- തുടയൻകോട് റെസിഡൻഷ്യൽ അസോസിയേഷൻ,ട്രിവാൻഡ്രം സ്മാർട്ട് സിറ്റി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1656.jpeg",
    },
    {
      src: "assets/img/Pastevents/1657.jpeg",
      caption:
        "ഏണിക്കര- തുടയൻകോട് റെസിഡൻഷ്യൽ അസോസിയേഷൻ,ട്രിവാൻഡ്രം സ്മാർട്ട് സിറ്റി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1657.jpeg",
    },
    {
      src: "assets/img/Pastevents/1658.jpeg",
      caption:
        "ഏണിക്കര- തുടയൻകോട് റെസിഡൻഷ്യൽ അസോസിയേഷൻ,ട്രിവാൻഡ്രം സ്മാർട്ട് സിറ്റി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1658.jpeg",
    },

    {
      src: "assets/img/Pastevents/1647.jpeg",
      caption:
        "ചെമ്മരുതി സേവാ ഭാരതി യൂണിറ്റ്, ലയൺസ് ക്ലബ് ഓഫ് ട്രിവാൻഡ്രം മെജസ്റ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1647.jpeg",
    },
    {
      src: "assets/img/Pastevents/1648.jpeg",
      caption:
        "ചെമ്മരുതി സേവാ ഭാരതി യൂണിറ്റ്, ലയൺസ് ക്ലബ് ഓഫ് ട്രിവാൻഡ്രം മെജസ്റ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1648.jpeg",
    },
    {
      src: "assets/img/Pastevents/1649.jpeg",
      caption:
        "ചെമ്മരുതി സേവാ ഭാരതി യൂണിറ്റ്, ലയൺസ് ക്ലബ് ഓഫ് ട്രിവാൻഡ്രം മെജസ്റ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1649.jpeg",
    },
    {
      src: "assets/img/Pastevents/1650.jpeg",
      caption:
        "ചെമ്മരുതി സേവാ ഭാരതി യൂണിറ്റ്, ലയൺസ് ക്ലബ് ഓഫ് ട്രിവാൻഡ്രം മെജസ്റ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1650.jpeg",
    },
    {
      src: "assets/img/Pastevents/1651.jpeg",
      caption:
        "ചെമ്മരുതി സേവാ ഭാരതി യൂണിറ്റ്, ലയൺസ് ക്ലബ് ഓഫ് ട്രിവാൻഡ്രം മെജസ്റ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1651.jpeg",
    },

    {
      src: "assets/img/Pastevents/1642.jpeg",
      caption:
        "KSRTC  ആരംഭിച്ച ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 100-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1642.jpeg",
    },
    {
      src: "assets/img/Pastevents/1643.jpeg",
      caption:
        "KSRTC  ആരംഭിച്ച ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 100-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1643.jpeg",
    },
    {
      src: "assets/img/Pastevents/1644.jpeg",
      caption:
        "KSRTC  ആരംഭിച്ച ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 100-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1644.jpeg",
    },
    {
      src: "assets/img/Pastevents/1645.jpeg",
      caption:
        "KSRTC  ആരംഭിച്ച ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 100-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1645.jpeg",
    },
    {
      src: "assets/img/Pastevents/1646.jpeg",
      caption:
        "KSRTC  ആരംഭിച്ച ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 100-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1646.jpeg",
    },
    {
      src: "assets/img/Pastevents/1634.jpeg",
      caption:
        "ധനുവച്ചപുരം എൻഎസ്എസ്  യൂണിറ്റിൻ്റെയു നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1634.jpeg",
    },
    {
      src: "assets/img/Pastevents/1635.jpeg",
      caption:
        "ധനുവച്ചപുരം എൻഎസ്എസ്  യൂണിറ്റിൻ്റെയു നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1635.jpeg",
    },
    {
      src: "assets/img/Pastevents/1636.jpeg",
      caption:
        "ധനുവച്ചപുരം എൻഎസ്എസ്  യൂണിറ്റിൻ്റെയു നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1636.jpeg",
    },
    {
      src: "assets/img/Pastevents/1637.jpeg",
      caption:
        "ധനുവച്ചപുരം എൻഎസ്എസ്  യൂണിറ്റിൻ്റെയു നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1637.jpeg",
    },
    {
      src: "assets/img/Pastevents/1638.jpeg",
      caption:
        "ധനുവച്ചപുരം എൻഎസ്എസ്  യൂണിറ്റിൻ്റെയു നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1638.jpeg",
    },
    {
      src: "assets/img/Pastevents/1639.jpeg",
      caption:
        "ധനുവച്ചപുരം എൻഎസ്എസ്  യൂണിറ്റിൻ്റെയു നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1639.jpeg",
    },
    {
      src: "assets/img/Pastevents/1640.jpeg",
      caption:
        "ധനുവച്ചപുരം എൻഎസ്എസ്  യൂണിറ്റിൻ്റെയു നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1640.jpeg",
    },
    {
      src: "assets/img/Pastevents/1641.jpeg",
      caption:
        "ധനുവച്ചപുരം എൻഎസ്എസ്  യൂണിറ്റിൻ്റെയു നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1641.jpeg",
    },
    {
      src: "assets/img/Pastevents/1626.jpeg",
      caption:
        "കേരളാ സ്റ്റേറ്റ് എക്സൈസ് ഡിപ്പാർട്ട്മെൻ്റ്, രാജാജി നഗർ വിങ്സ് ഓഫ് വിമൻസ്, ലയൺസ് ക്ലബ് ഓഫ് ഗൗരീശപട്ടത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1626.jpeg",
    },
    {
      src: "assets/img/Pastevents/1627.jpeg",
      caption:
        "കേരളാ സ്റ്റേറ്റ് എക്സൈസ് ഡിപ്പാർട്ട്മെൻ്റ്, രാജാജി നഗർ വിങ്സ് ഓഫ് വിമൻസ്, ലയൺസ് ക്ലബ് ഓഫ് ഗൗരീശപട്ടത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1627.jpeg",
    },
    {
      src: "assets/img/Pastevents/1628.jpeg",
      caption:
        "കേരളാ സ്റ്റേറ്റ് എക്സൈസ് ഡിപ്പാർട്ട്മെൻ്റ്, രാജാജി നഗർ വിങ്സ് ഓഫ് വിമൻസ്, ലയൺസ് ക്ലബ് ഓഫ് ഗൗരീശപട്ടത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1628.jpeg",
    },
    {
      src: "assets/img/Pastevents/1629.jpeg",
      caption:
        "കേരളാ സ്റ്റേറ്റ് എക്സൈസ് ഡിപ്പാർട്ട്മെൻ്റ്, രാജാജി നഗർ വിങ്സ് ഓഫ് വിമൻസ്, ലയൺസ് ക്ലബ് ഓഫ് ഗൗരീശപട്ടത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1629.jpeg",
    },
    {
      src: "assets/img/Pastevents/1630.jpeg",
      caption:
        "കേരളാ സ്റ്റേറ്റ് എക്സൈസ് ഡിപ്പാർട്ട്മെൻ്റ്, രാജാജി നഗർ വിങ്സ് ഓഫ് വിമൻസ്, ലയൺസ് ക്ലബ് ഓഫ് ഗൗരീശപട്ടത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1630.jpeg",
    },
    {
      src: "assets/img/Pastevents/1631.jpeg",
      caption:
        "കേരളാ സ്റ്റേറ്റ് എക്സൈസ് ഡിപ്പാർട്ട്മെൻ്റ്, രാജാജി നഗർ വിങ്സ് ഓഫ് വിമൻസ്, ലയൺസ് ക്ലബ് ഓഫ് ഗൗരീശപട്ടത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1631.jpeg",
    },
    {
      src: "assets/img/Pastevents/1632.jpeg",
      caption:
        "കേരളാ സ്റ്റേറ്റ് എക്സൈസ് ഡിപ്പാർട്ട്മെൻ്റ്, രാജാജി നഗർ വിങ്സ് ഓഫ് വിമൻസ്, ലയൺസ് ക്ലബ് ഓഫ് ഗൗരീശപട്ടത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1632.jpeg",
    },
    {
      src: "assets/img/Pastevents/1633.jpeg",
      caption:
        "കേരളാ സ്റ്റേറ്റ് എക്സൈസ് ഡിപ്പാർട്ട്മെൻ്റ്, രാജാജി നഗർ വിങ്സ് ഓഫ് വിമൻസ്, ലയൺസ് ക്ലബ് ഓഫ് ഗൗരീശപട്ടത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1633.jpeg",
    },
    {
      src: "assets/img/Pastevents/1621.jpeg",
      caption:
        "(2- ദിവസം)കല്ലമ്പലം ബാഫക്കി തങ്ങൾ എജുക്കേഷൻ ചാരിറ്റബിൾ ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1621.jpeg",
    },
    {
      src: "assets/img/Pastevents/1622.jpeg",
      caption:
        "(2- ദിവസം)കല്ലമ്പലം ബാഫക്കി തങ്ങൾ എജുക്കേഷൻ ചാരിറ്റബിൾ ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1622.jpeg",
    },
    {
      src: "assets/img/Pastevents/1623.jpeg",
      caption:
        "(2- ദിവസം)കല്ലമ്പലം ബാഫക്കി തങ്ങൾ എജുക്കേഷൻ ചാരിറ്റബിൾ ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1623.jpeg",
    },
    {
      src: "assets/img/Pastevents/1624.jpeg",
      caption:
        "(2- ദിവസം)കല്ലമ്പലം ബാഫക്കി തങ്ങൾ എജുക്കേഷൻ ചാരിറ്റബിൾ ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1624.jpeg",
    },
    {
      src: "assets/img/Pastevents/1625.jpeg",
      caption:
        "(2- ദിവസം)കല്ലമ്പലം ബാഫക്കി തങ്ങൾ എജുക്കേഷൻ ചാരിറ്റബിൾ ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1625.jpeg",
    },
    {
      src: "assets/img/Pastevents/1616.jpeg",
      caption:
        "കല്ലമ്പലം ബാഫക്കി തങ്ങൾ എജുക്കേഷൻ ചാരിറ്റബിൾ ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1616.jpeg",
    },
    {
      src: "assets/img/Pastevents/1617.jpeg",
      caption:
        "കല്ലമ്പലം ബാഫക്കി തങ്ങൾ എജുക്കേഷൻ ചാരിറ്റബിൾ ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1617.jpeg",
    },
    {
      src: "assets/img/Pastevents/1618.jpeg",
      caption:
        "കല്ലമ്പലം ബാഫക്കി തങ്ങൾ എജുക്കേഷൻ ചാരിറ്റബിൾ ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1618.jpeg",
    },
    {
      src: "assets/img/Pastevents/1619.jpeg",
      caption:
        "കല്ലമ്പലം ബാഫക്കി തങ്ങൾ എജുക്കേഷൻ ചാരിറ്റബിൾ ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1619.jpeg",
    },
    {
      src: "assets/img/Pastevents/1620.jpeg",
      caption:
        "കല്ലമ്പലം ബാഫക്കി തങ്ങൾ എജുക്കേഷൻ ചാരിറ്റബിൾ ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1620.jpeg",
    },
    {
      src: "assets/img/Pastevents/1609.jpeg",
      caption:
        "പേയാട് ലയൺസ് ക്ലബ്, ലിയോ ക്ലബ് പേയാടിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1609.jpeg",
    },
    {
      src: "assets/img/Pastevents/1610.jpeg",
      caption:
        "പേയാട് ലയൺസ് ക്ലബ്, ലിയോ ക്ലബ് പേയാടിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1610.jpeg",
    },
    {
      src: "assets/img/Pastevents/1611.jpeg",
      caption:
        "പേയാട് ലയൺസ് ക്ലബ്, ലിയോ ക്ലബ് പേയാടിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1611.jpeg",
    },
    {
      src: "assets/img/Pastevents/1612.jpeg",
      caption:
        "പേയാട് ലയൺസ് ക്ലബ്, ലിയോ ക്ലബ് പേയാടിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1612.jpeg",
    },
    {
      src: "assets/img/Pastevents/1613.jpeg",
      caption:
        "പേയാട് ലയൺസ് ക്ലബ്, ലിയോ ക്ലബ് പേയാടിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1613.jpeg",
    },
    {
      src: "assets/img/Pastevents/1614.jpeg",
      caption:
        "പേയാട് ലയൺസ് ക്ലബ്, ലിയോ ക്ലബ് പേയാടിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1614.jpeg",
    },
    {
      src: "assets/img/Pastevents/1615.jpeg",
      caption:
        "പേയാട് ലയൺസ് ക്ലബ്, ലിയോ ക്ലബ് പേയാടിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1615.jpeg",
    },
    {
      src: "assets/img/Pastevents/1601.jpeg",
      caption:
        "വെള്ളറട ഗ്രാമപഞ്ചായത്തും തിരുവനന്തപുരം പ്രേം നസീർ സുഹൃത്ത് സമിതിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീമതി അൻസജിത റസ്സേൽ ( ജില്ലാ പഞ്ചായത്ത് മെമ്പർ )",
      thumb: "assets/img/Pastevents/1601.jpeg",
    },
    {
      src: "assets/img/Pastevents/1602.jpeg",
      caption:
        "വെള്ളറട ഗ്രാമപഞ്ചായത്തും തിരുവനന്തപുരം പ്രേം നസീർ സുഹൃത്ത് സമിതിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീമതി അൻസജിത റസ്സേൽ ( ജില്ലാ പഞ്ചായത്ത് മെമ്പർ )",
      thumb: "assets/img/Pastevents/1602.jpeg",
    },
    {
      src: "assets/img/Pastevents/1603.jpeg",
      caption:
        "വെള്ളറട ഗ്രാമപഞ്ചായത്തും തിരുവനന്തപുരം പ്രേം നസീർ സുഹൃത്ത് സമിതിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീമതി അൻസജിത റസ്സേൽ ( ജില്ലാ പഞ്ചായത്ത് മെമ്പർ )",
      thumb: "assets/img/Pastevents/1603.jpeg",
    },
    {
      src: "assets/img/Pastevents/1604.jpeg",
      caption:
        "വെള്ളറട ഗ്രാമപഞ്ചായത്തും തിരുവനന്തപുരം പ്രേം നസീർ സുഹൃത്ത് സമിതിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീമതി അൻസജിത റസ്സേൽ ( ജില്ലാ പഞ്ചായത്ത് മെമ്പർ )",
      thumb: "assets/img/Pastevents/1604.jpeg",
    },
    {
      src: "assets/img/Pastevents/1605.jpeg",
      caption:
        "വെള്ളറട ഗ്രാമപഞ്ചായത്തും തിരുവനന്തപുരം പ്രേം നസീർ സുഹൃത്ത് സമിതിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീമതി അൻസജിത റസ്സേൽ ( ജില്ലാ പഞ്ചായത്ത് മെമ്പർ )",
      thumb: "assets/img/Pastevents/1605.jpeg",
    },
    {
      src: "assets/img/Pastevents/1606.jpeg",
      caption:
        "വെള്ളറട ഗ്രാമപഞ്ചായത്തും തിരുവനന്തപുരം പ്രേം നസീർ സുഹൃത്ത് സമിതിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീമതി അൻസജിത റസ്സേൽ ( ജില്ലാ പഞ്ചായത്ത് മെമ്പർ )",
      thumb: "assets/img/Pastevents/1606.jpeg",
    },
    {
      src: "assets/img/Pastevents/1607.jpeg",
      caption:
        "വെള്ളറട ഗ്രാമപഞ്ചായത്തും തിരുവനന്തപുരം പ്രേം നസീർ സുഹൃത്ത് സമിതിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീമതി അൻസജിത റസ്സേൽ ( ജില്ലാ പഞ്ചായത്ത് മെമ്പർ )",
      thumb: "assets/img/Pastevents/1607.jpeg",
    },
    {
      src: "assets/img/Pastevents/1608.jpeg",
      caption:
        "വെള്ളറട ഗ്രാമപഞ്ചായത്തും തിരുവനന്തപുരം പ്രേം നസീർ സുഹൃത്ത് സമിതിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീമതി അൻസജിത റസ്സേൽ ( ജില്ലാ പഞ്ചായത്ത് മെമ്പർ )",
      thumb: "assets/img/Pastevents/1608.jpeg",
    },
    {
      src: "assets/img/Pastevents/1596.jpeg",
      caption:
        "ലയൺസ് ക്ലബ് ഇൻ്റർനാഷണൽ തിരുവല്ലം ബ്രാഞ്ചിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ പ്രമേഹരോഗ നിർണ്ണയവും ബോധവൽക്കരണ ക്യാമ്പും സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1596.jpeg",
    },
    {
      src: "assets/img/Pastevents/1597.jpeg",
      caption:
        "ലയൺസ് ക്ലബ് ഇൻ്റർനാഷണൽ തിരുവല്ലം ബ്രാഞ്ചിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ പ്രമേഹരോഗ നിർണ്ണയവും ബോധവൽക്കരണ ക്യാമ്പും സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1597.jpeg",
    },
    {
      src: "assets/img/Pastevents/1598.jpeg",
      caption:
        "ലയൺസ് ക്ലബ് ഇൻ്റർനാഷണൽ തിരുവല്ലം ബ്രാഞ്ചിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ പ്രമേഹരോഗ നിർണ്ണയവും ബോധവൽക്കരണ ക്യാമ്പും സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1598.jpeg",
    },
    {
      src: "assets/img/Pastevents/1599.jpeg",
      caption:
        "ലയൺസ് ക്ലബ് ഇൻ്റർനാഷണൽ തിരുവല്ലം ബ്രാഞ്ചിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ പ്രമേഹരോഗ നിർണ്ണയവും ബോധവൽക്കരണ ക്യാമ്പും സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1599.jpeg",
    },
    {
      src: "assets/img/Pastevents/1600.jpeg",
      caption:
        "ലയൺസ് ക്ലബ് ഇൻ്റർനാഷണൽ തിരുവല്ലം ബ്രാഞ്ചിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ പ്രമേഹരോഗ നിർണ്ണയവും ബോധവൽക്കരണ ക്യാമ്പും സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1600.jpeg",
    },
    {
      src: "assets/img/Pastevents/1591.jpeg",
      caption:
        "തമിഴ്നാട് ഗവൺമെന്റ് ഹെൽത്ത് ഇൻഷുറൻസ് സ്കീം,ചോഴപുരം യൂത്ത് വെൽഫെയർ അസോസിയേഷന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1591.jpeg",
    },
    {
      src: "assets/img/Pastevents/1592.jpeg",
      caption:
        "തമിഴ്നാട് ഗവൺമെന്റ് ഹെൽത്ത് ഇൻഷുറൻസ് സ്കീം,ചോഴപുരം യൂത്ത് വെൽഫെയർ അസോസിയേഷന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1592.jpeg",
    },
    {
      src: "assets/img/Pastevents/1593.jpeg",
      caption:
        "തമിഴ്നാട് ഗവൺമെന്റ് ഹെൽത്ത് ഇൻഷുറൻസ് സ്കീം,ചോഴപുരം യൂത്ത് വെൽഫെയർ അസോസിയേഷന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1593.jpeg",
    },
    {
      src: "assets/img/Pastevents/1594.jpeg",
      caption:
        "തമിഴ്നാട് ഗവൺമെന്റ് ഹെൽത്ത് ഇൻഷുറൻസ് സ്കീം,ചോഴപുരം യൂത്ത് വെൽഫെയർ അസോസിയേഷന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1594.jpeg",
    },
    {
      src: "assets/img/Pastevents/1595.jpeg",
      caption:
        "തമിഴ്നാട് ഗവൺമെന്റ് ഹെൽത്ത് ഇൻഷുറൻസ് സ്കീം,ചോഴപുരം യൂത്ത് വെൽഫെയർ അസോസിയേഷന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1595.jpeg",
    },
    {
      src: "assets/img/Pastevents/1582.jpeg",
      caption:
        "എൻ്റെ ഗ്രാമം എൻ്റെ ഹൃദയം❤️ പദ്ധതിയുടെ ഭാഗമായി പാറശ്ശാല ഗ്രാമ പഞ്ചായത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ കാർഡിയോളജി മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ സുരേഷ് കുമാർ (ജില്ലാ പഞ്ചായത്ത് പ്രസിഡൻ്റ്,തിരുവനന്തപുരം). മഹനീയ സാന്നിധ്യം ശ്രീ ബെന്യാമിൻ ( പ്രശസ്ത കഥാകൃത്ത്, നോവലിസറ്റ്) ശ്രീമതി നീനാ കുറുപ്പ് (സിനിമാ - സീരിയൽ താരം ) ശ്രി ബെൻ ഡാർവിൻ (ബഹു പാറശ്ശാല ബ്ലോക്ക് പഞ്ചായത്ത് പ്രസിഡൻ്റ്) ശ്രിമതി എൽ മഞ്ജു സ്മിതാ (ബഹു പാറശ്ശാല ഗ്രാമ പഞ്ചായത്ത് പ്രസിഡൻ്റ്) ക്യാമ്പിൽ 350-പ്പരം പേർ കാർഡിയോളജി  സ്ക്രീനീംഗന്  വിധേയമായി. ക്യാമ്പിൽ സൗജന്യ എക്കോ, ഇ. സി. ജി, ബ്ലഡ് ഷുഗർ, ബ്ലഡ് പ്രഷർ, ബി എം ഐ ടെസ്റ്റുകൾ നടത്തി.",
      thumb: "assets/img/Pastevents/1582.jpeg",
    },
    {
      src: "assets/img/Pastevents/1583.jpeg",
      caption:
        "എൻ്റെ ഗ്രാമം എൻ്റെ ഹൃദയം❤️ പദ്ധതിയുടെ ഭാഗമായി പാറശ്ശാല ഗ്രാമ പഞ്ചായത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ കാർഡിയോളജി മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ സുരേഷ് കുമാർ (ജില്ലാ പഞ്ചായത്ത് പ്രസിഡൻ്റ്,തിരുവനന്തപുരം). മഹനീയ സാന്നിധ്യം ശ്രീ ബെന്യാമിൻ ( പ്രശസ്ത കഥാകൃത്ത്, നോവലിസറ്റ്) ശ്രീമതി നീനാ കുറുപ്പ് (സിനിമാ - സീരിയൽ താരം ) ശ്രി ബെൻ ഡാർവിൻ (ബഹു പാറശ്ശാല ബ്ലോക്ക് പഞ്ചായത്ത് പ്രസിഡൻ്റ്) ശ്രിമതി എൽ മഞ്ജു സ്മിതാ (ബഹു പാറശ്ശാല ഗ്രാമ പഞ്ചായത്ത് പ്രസിഡൻ്റ്) ക്യാമ്പിൽ 350-പ്പരം പേർ കാർഡിയോളജി  സ്ക്രീനീംഗന്  വിധേയമായി. ക്യാമ്പിൽ സൗജന്യ എക്കോ, ഇ. സി. ജി, ബ്ലഡ് ഷുഗർ, ബ്ലഡ് പ്രഷർ, ബി എം ഐ ടെസ്റ്റുകൾ നടത്തി.",
      thumb: "assets/img/Pastevents/1583.jpeg",
    },
    {
      src: "assets/img/Pastevents/1584.jpeg",
      caption:
        "എൻ്റെ ഗ്രാമം എൻ്റെ ഹൃദയം❤️ പദ്ധതിയുടെ ഭാഗമായി പാറശ്ശാല ഗ്രാമ പഞ്ചായത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ കാർഡിയോളജി മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ സുരേഷ് കുമാർ (ജില്ലാ പഞ്ചായത്ത് പ്രസിഡൻ്റ്,തിരുവനന്തപുരം). മഹനീയ സാന്നിധ്യം ശ്രീ ബെന്യാമിൻ ( പ്രശസ്ത കഥാകൃത്ത്, നോവലിസറ്റ്) ശ്രീമതി നീനാ കുറുപ്പ് (സിനിമാ - സീരിയൽ താരം ) ശ്രി ബെൻ ഡാർവിൻ (ബഹു പാറശ്ശാല ബ്ലോക്ക് പഞ്ചായത്ത് പ്രസിഡൻ്റ്) ശ്രിമതി എൽ മഞ്ജു സ്മിതാ (ബഹു പാറശ്ശാല ഗ്രാമ പഞ്ചായത്ത് പ്രസിഡൻ്റ്) ക്യാമ്പിൽ 350-പ്പരം പേർ കാർഡിയോളജി  സ്ക്രീനീംഗന്  വിധേയമായി. ക്യാമ്പിൽ സൗജന്യ എക്കോ, ഇ. സി. ജി, ബ്ലഡ് ഷുഗർ, ബ്ലഡ് പ്രഷർ, ബി എം ഐ ടെസ്റ്റുകൾ നടത്തി.",
      thumb: "assets/img/Pastevents/1584.jpeg",
    },
    {
      src: "assets/img/Pastevents/1585.jpeg",
      caption:
        "എൻ്റെ ഗ്രാമം എൻ്റെ ഹൃദയം❤️ പദ്ധതിയുടെ ഭാഗമായി പാറശ്ശാല ഗ്രാമ പഞ്ചായത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ കാർഡിയോളജി മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ സുരേഷ് കുമാർ (ജില്ലാ പഞ്ചായത്ത് പ്രസിഡൻ്റ്,തിരുവനന്തപുരം). മഹനീയ സാന്നിധ്യം ശ്രീ ബെന്യാമിൻ ( പ്രശസ്ത കഥാകൃത്ത്, നോവലിസറ്റ്) ശ്രീമതി നീനാ കുറുപ്പ് (സിനിമാ - സീരിയൽ താരം ) ശ്രി ബെൻ ഡാർവിൻ (ബഹു പാറശ്ശാല ബ്ലോക്ക് പഞ്ചായത്ത് പ്രസിഡൻ്റ്) ശ്രിമതി എൽ മഞ്ജു സ്മിതാ (ബഹു പാറശ്ശാല ഗ്രാമ പഞ്ചായത്ത് പ്രസിഡൻ്റ്) ക്യാമ്പിൽ 350-പ്പരം പേർ കാർഡിയോളജി  സ്ക്രീനീംഗന്  വിധേയമായി. ക്യാമ്പിൽ സൗജന്യ എക്കോ, ഇ. സി. ജി, ബ്ലഡ് ഷുഗർ, ബ്ലഡ് പ്രഷർ, ബി എം ഐ ടെസ്റ്റുകൾ നടത്തി.",
      thumb: "assets/img/Pastevents/1585.jpeg",
    },
    {
      src: "assets/img/Pastevents/1586.jpeg",
      caption:
        "എൻ്റെ ഗ്രാമം എൻ്റെ ഹൃദയം❤️ പദ്ധതിയുടെ ഭാഗമായി പാറശ്ശാല ഗ്രാമ പഞ്ചായത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ കാർഡിയോളജി മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ സുരേഷ് കുമാർ (ജില്ലാ പഞ്ചായത്ത് പ്രസിഡൻ്റ്,തിരുവനന്തപുരം). മഹനീയ സാന്നിധ്യം ശ്രീ ബെന്യാമിൻ ( പ്രശസ്ത കഥാകൃത്ത്, നോവലിസറ്റ്) ശ്രീമതി നീനാ കുറുപ്പ് (സിനിമാ - സീരിയൽ താരം ) ശ്രി ബെൻ ഡാർവിൻ (ബഹു പാറശ്ശാല ബ്ലോക്ക് പഞ്ചായത്ത് പ്രസിഡൻ്റ്) ശ്രിമതി എൽ മഞ്ജു സ്മിതാ (ബഹു പാറശ്ശാല ഗ്രാമ പഞ്ചായത്ത് പ്രസിഡൻ്റ്) ക്യാമ്പിൽ 350-പ്പരം പേർ കാർഡിയോളജി  സ്ക്രീനീംഗന്  വിധേയമായി. ക്യാമ്പിൽ സൗജന്യ എക്കോ, ഇ. സി. ജി, ബ്ലഡ് ഷുഗർ, ബ്ലഡ് പ്രഷർ, ബി എം ഐ ടെസ്റ്റുകൾ നടത്തി.",
      thumb: "assets/img/Pastevents/1586.jpeg",
    },
    {
      src: "assets/img/Pastevents/1587.jpeg",
      caption:
        "എൻ്റെ ഗ്രാമം എൻ്റെ ഹൃദയം❤️ പദ്ധതിയുടെ ഭാഗമായി പാറശ്ശാല ഗ്രാമ പഞ്ചായത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ കാർഡിയോളജി മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ സുരേഷ് കുമാർ (ജില്ലാ പഞ്ചായത്ത് പ്രസിഡൻ്റ്,തിരുവനന്തപുരം). മഹനീയ സാന്നിധ്യം ശ്രീ ബെന്യാമിൻ ( പ്രശസ്ത കഥാകൃത്ത്, നോവലിസറ്റ്) ശ്രീമതി നീനാ കുറുപ്പ് (സിനിമാ - സീരിയൽ താരം ) ശ്രി ബെൻ ഡാർവിൻ (ബഹു പാറശ്ശാല ബ്ലോക്ക് പഞ്ചായത്ത് പ്രസിഡൻ്റ്) ശ്രിമതി എൽ മഞ്ജു സ്മിതാ (ബഹു പാറശ്ശാല ഗ്രാമ പഞ്ചായത്ത് പ്രസിഡൻ്റ്) ക്യാമ്പിൽ 350-പ്പരം പേർ കാർഡിയോളജി  സ്ക്രീനീംഗന്  വിധേയമായി. ക്യാമ്പിൽ സൗജന്യ എക്കോ, ഇ. സി. ജി, ബ്ലഡ് ഷുഗർ, ബ്ലഡ് പ്രഷർ, ബി എം ഐ ടെസ്റ്റുകൾ നടത്തി.",
      thumb: "assets/img/Pastevents/1587.jpeg",
    },
    {
      src: "assets/img/Pastevents/1588.jpeg",
      caption:
        "എൻ്റെ ഗ്രാമം എൻ്റെ ഹൃദയം❤️ പദ്ധതിയുടെ ഭാഗമായി പാറശ്ശാല ഗ്രാമ പഞ്ചായത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ കാർഡിയോളജി മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ സുരേഷ് കുമാർ (ജില്ലാ പഞ്ചായത്ത് പ്രസിഡൻ്റ്,തിരുവനന്തപുരം). മഹനീയ സാന്നിധ്യം ശ്രീ ബെന്യാമിൻ ( പ്രശസ്ത കഥാകൃത്ത്, നോവലിസറ്റ്) ശ്രീമതി നീനാ കുറുപ്പ് (സിനിമാ - സീരിയൽ താരം ) ശ്രി ബെൻ ഡാർവിൻ (ബഹു പാറശ്ശാല ബ്ലോക്ക് പഞ്ചായത്ത് പ്രസിഡൻ്റ്) ശ്രിമതി എൽ മഞ്ജു സ്മിതാ (ബഹു പാറശ്ശാല ഗ്രാമ പഞ്ചായത്ത് പ്രസിഡൻ്റ്) ക്യാമ്പിൽ 350-പ്പരം പേർ കാർഡിയോളജി  സ്ക്രീനീംഗന്  വിധേയമായി. ക്യാമ്പിൽ സൗജന്യ എക്കോ, ഇ. സി. ജി, ബ്ലഡ് ഷുഗർ, ബ്ലഡ് പ്രഷർ, ബി എം ഐ ടെസ്റ്റുകൾ നടത്തി.",
      thumb: "assets/img/Pastevents/1588.jpeg",
    },
    {
      src: "assets/img/Pastevents/1589.jpeg",
      caption:
        "എൻ്റെ ഗ്രാമം എൻ്റെ ഹൃദയം❤️ പദ്ധതിയുടെ ഭാഗമായി പാറശ്ശാല ഗ്രാമ പഞ്ചായത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ കാർഡിയോളജി മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ സുരേഷ് കുമാർ (ജില്ലാ പഞ്ചായത്ത് പ്രസിഡൻ്റ്,തിരുവനന്തപുരം). മഹനീയ സാന്നിധ്യം ശ്രീ ബെന്യാമിൻ ( പ്രശസ്ത കഥാകൃത്ത്, നോവലിസറ്റ്) ശ്രീമതി നീനാ കുറുപ്പ് (സിനിമാ - സീരിയൽ താരം ) ശ്രി ബെൻ ഡാർവിൻ (ബഹു പാറശ്ശാല ബ്ലോക്ക് പഞ്ചായത്ത് പ്രസിഡൻ്റ്) ശ്രിമതി എൽ മഞ്ജു സ്മിതാ (ബഹു പാറശ്ശാല ഗ്രാമ പഞ്ചായത്ത് പ്രസിഡൻ്റ്) ക്യാമ്പിൽ 350-പ്പരം പേർ കാർഡിയോളജി  സ്ക്രീനീംഗന്  വിധേയമായി. ക്യാമ്പിൽ സൗജന്യ എക്കോ, ഇ. സി. ജി, ബ്ലഡ് ഷുഗർ, ബ്ലഡ് പ്രഷർ, ബി എം ഐ ടെസ്റ്റുകൾ നടത്തി.",
      thumb: "assets/img/Pastevents/1589.jpeg",
    },
    {
      src: "assets/img/Pastevents/1590.jpeg",
      caption:
        "എൻ്റെ ഗ്രാമം എൻ്റെ ഹൃദയം❤️ പദ്ധതിയുടെ ഭാഗമായി പാറശ്ശാല ഗ്രാമ പഞ്ചായത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ കാർഡിയോളജി മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ സുരേഷ് കുമാർ (ജില്ലാ പഞ്ചായത്ത് പ്രസിഡൻ്റ്,തിരുവനന്തപുരം). മഹനീയ സാന്നിധ്യം ശ്രീ ബെന്യാമിൻ ( പ്രശസ്ത കഥാകൃത്ത്, നോവലിസറ്റ്) ശ്രീമതി നീനാ കുറുപ്പ് (സിനിമാ - സീരിയൽ താരം ) ശ്രി ബെൻ ഡാർവിൻ (ബഹു പാറശ്ശാല ബ്ലോക്ക് പഞ്ചായത്ത് പ്രസിഡൻ്റ്) ശ്രിമതി എൽ മഞ്ജു സ്മിതാ (ബഹു പാറശ്ശാല ഗ്രാമ പഞ്ചായത്ത് പ്രസിഡൻ്റ്) ക്യാമ്പിൽ 350-പ്പരം പേർ കാർഡിയോളജി  സ്ക്രീനീംഗന്  വിധേയമായി. ക്യാമ്പിൽ സൗജന്യ എക്കോ, ഇ. സി. ജി, ബ്ലഡ് ഷുഗർ, ബ്ലഡ് പ്രഷർ, ബി എം ഐ ടെസ്റ്റുകൾ നടത്തി.",
      thumb: "assets/img/Pastevents/1590.jpeg",
    },
    {
      src: "assets/img/Pastevents/1576.jpeg",
      caption:
        "മുടവൻമുഗൽ പൗരസമിതി,ട്രിവാൻഡ്രം റെയിൻബോ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1576.jpeg",
    },
    {
      src: "assets/img/Pastevents/1577.jpeg",
      caption:
        "മുടവൻമുഗൽ പൗരസമിതി,ട്രിവാൻഡ്രം റെയിൻബോ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1577.jpeg",
    },
    {
      src: "assets/img/Pastevents/1578.jpeg",
      caption:
        "മുടവൻമുഗൽ പൗരസമിതി,ട്രിവാൻഡ്രം റെയിൻബോ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1578.jpeg",
    },
    {
      src: "assets/img/Pastevents/1579.jpeg",
      caption:
        "മുടവൻമുഗൽ പൗരസമിതി,ട്രിവാൻഡ്രം റെയിൻബോ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1579.jpeg",
    },
    {
      src: "assets/img/Pastevents/1580.jpeg",
      caption:
        "മുടവൻമുഗൽ പൗരസമിതി,ട്രിവാൻഡ്രം റെയിൻബോ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1580.jpeg",
    },
    {
      src: "assets/img/Pastevents/1581.jpeg",
      caption:
        "മുടവൻമുഗൽ പൗരസമിതി,ട്രിവാൻഡ്രം റെയിൻബോ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1581.jpeg",
    },

    {
      src: "assets/img/Pastevents/1569.jpeg",
      caption:
        "'മിഠായി ' (3) ലോക പ്രമേഹ ദിനത്തോട് അനുബന്ധിച്ച് സ്ക്കൂൾ വിദ്യാർഥികളിലൂടെ പ്രമേഹ അവബോധം കുടുംബത്തിലേയ്ക്കും സമൂഹത്തിലേയ്ക്കും.തിരുവനന്തപുരം ജില്ലയിലെ തിരെഞ്ഞെടുത്ത വിദ്യാലയങ്ങളിൽ സംഘടിപ്പിക്കുന്ന പ്രമേഹ ബോധവൽക്കരണ പദ്ധതിയുടെ ഭാഗമായി പാൽകുളങ്ങര എൻ എസ് എസ് ഹയർ സെക്കൻഡറി സ്കൂൾ, റോട്ടറി ഇൻ്റർനാഷണൽ ട്രിവാൻഡ്രത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1569.jpeg",
    },
    {
      src: "assets/img/Pastevents/1570.jpeg",
      caption:
        "'മിഠായി ' (3) ലോക പ്രമേഹ ദിനത്തോട് അനുബന്ധിച്ച് സ്ക്കൂൾ വിദ്യാർഥികളിലൂടെ പ്രമേഹ അവബോധം കുടുംബത്തിലേയ്ക്കും സമൂഹത്തിലേയ്ക്കും.തിരുവനന്തപുരം ജില്ലയിലെ തിരെഞ്ഞെടുത്ത വിദ്യാലയങ്ങളിൽ സംഘടിപ്പിക്കുന്ന പ്രമേഹ ബോധവൽക്കരണ പദ്ധതിയുടെ ഭാഗമായി പാൽകുളങ്ങര എൻ എസ് എസ് ഹയർ സെക്കൻഡറി സ്കൂൾ, റോട്ടറി ഇൻ്റർനാഷണൽ ട്രിവാൻഡ്രത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1570.jpeg",
    },
    {
      src: "assets/img/Pastevents/1571.jpeg",
      caption:
        "'മിഠായി ' (3) ലോക പ്രമേഹ ദിനത്തോട് അനുബന്ധിച്ച് സ്ക്കൂൾ വിദ്യാർഥികളിലൂടെ പ്രമേഹ അവബോധം കുടുംബത്തിലേയ്ക്കും സമൂഹത്തിലേയ്ക്കും.തിരുവനന്തപുരം ജില്ലയിലെ തിരെഞ്ഞെടുത്ത വിദ്യാലയങ്ങളിൽ സംഘടിപ്പിക്കുന്ന പ്രമേഹ ബോധവൽക്കരണ പദ്ധതിയുടെ ഭാഗമായി പാൽകുളങ്ങര എൻ എസ് എസ് ഹയർ സെക്കൻഡറി സ്കൂൾ, റോട്ടറി ഇൻ്റർനാഷണൽ ട്രിവാൻഡ്രത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1571.jpeg",
    },
    {
      src: "assets/img/Pastevents/1572.jpeg",
      caption:
        "'മിഠായി ' (3) ലോക പ്രമേഹ ദിനത്തോട് അനുബന്ധിച്ച് സ്ക്കൂൾ വിദ്യാർഥികളിലൂടെ പ്രമേഹ അവബോധം കുടുംബത്തിലേയ്ക്കും സമൂഹത്തിലേയ്ക്കും.തിരുവനന്തപുരം ജില്ലയിലെ തിരെഞ്ഞെടുത്ത വിദ്യാലയങ്ങളിൽ സംഘടിപ്പിക്കുന്ന പ്രമേഹ ബോധവൽക്കരണ പദ്ധതിയുടെ ഭാഗമായി പാൽകുളങ്ങര എൻ എസ് എസ് ഹയർ സെക്കൻഡറി സ്കൂൾ, റോട്ടറി ഇൻ്റർനാഷണൽ ട്രിവാൻഡ്രത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1572.jpeg",
    },
    {
      src: "assets/img/Pastevents/1573.jpeg",
      caption:
        "'മിഠായി ' (3) ലോക പ്രമേഹ ദിനത്തോട് അനുബന്ധിച്ച് സ്ക്കൂൾ വിദ്യാർഥികളിലൂടെ പ്രമേഹ അവബോധം കുടുംബത്തിലേയ്ക്കും സമൂഹത്തിലേയ്ക്കും.തിരുവനന്തപുരം ജില്ലയിലെ തിരെഞ്ഞെടുത്ത വിദ്യാലയങ്ങളിൽ സംഘടിപ്പിക്കുന്ന പ്രമേഹ ബോധവൽക്കരണ പദ്ധതിയുടെ ഭാഗമായി പാൽകുളങ്ങര എൻ എസ് എസ് ഹയർ സെക്കൻഡറി സ്കൂൾ, റോട്ടറി ഇൻ്റർനാഷണൽ ട്രിവാൻഡ്രത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1573.jpeg",
    },
    {
      src: "assets/img/Pastevents/1574.jpeg",
      caption:
        "'മിഠായി ' (3) ലോക പ്രമേഹ ദിനത്തോട് അനുബന്ധിച്ച് സ്ക്കൂൾ വിദ്യാർഥികളിലൂടെ പ്രമേഹ അവബോധം കുടുംബത്തിലേയ്ക്കും സമൂഹത്തിലേയ്ക്കും.തിരുവനന്തപുരം ജില്ലയിലെ തിരെഞ്ഞെടുത്ത വിദ്യാലയങ്ങളിൽ സംഘടിപ്പിക്കുന്ന പ്രമേഹ ബോധവൽക്കരണ പദ്ധതിയുടെ ഭാഗമായി പാൽകുളങ്ങര എൻ എസ് എസ് ഹയർ സെക്കൻഡറി സ്കൂൾ, റോട്ടറി ഇൻ്റർനാഷണൽ ട്രിവാൻഡ്രത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1574.jpeg",
    },
    {
      src: "assets/img/Pastevents/1575.jpeg",
      caption:
        "'മിഠായി ' (3) ലോക പ്രമേഹ ദിനത്തോട് അനുബന്ധിച്ച് സ്ക്കൂൾ വിദ്യാർഥികളിലൂടെ പ്രമേഹ അവബോധം കുടുംബത്തിലേയ്ക്കും സമൂഹത്തിലേയ്ക്കും.തിരുവനന്തപുരം ജില്ലയിലെ തിരെഞ്ഞെടുത്ത വിദ്യാലയങ്ങളിൽ സംഘടിപ്പിക്കുന്ന പ്രമേഹ ബോധവൽക്കരണ പദ്ധതിയുടെ ഭാഗമായി പാൽകുളങ്ങര എൻ എസ് എസ് ഹയർ സെക്കൻഡറി സ്കൂൾ, റോട്ടറി ഇൻ്റർനാഷണൽ ട്രിവാൻഡ്രത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1575.jpeg",
    },
    {
      src: "assets/img/Pastevents/1564.jpeg",
      caption:
        "'മിഠായി ' (2) ലോക പ്രമേഹ ദിനത്തോട് അനുബന്ധിച്ച് സ്ക്കൂൾ വിദ്യാർഥികളിലൂടെ പ്രമേഹ അവബോധം കുടുംബത്തിലേയ്ക്കും സമൂഹത്തിലേയ്ക്കും.തിരുവനന്തപുരം ജില്ലയിലെ തിരെഞ്ഞെടുത്ത വിദ്യാലയങ്ങളിൽ സംഘടിപ്പിക്കുന്ന പ്രമേഹ ബോധവൽക്കരണ പദ്ധതിയുടെ ഭാഗമായി ഗവ: യു പി എസ് സ്ക്കൂൾ അമ്പലത്തറ, റോട്ടറി ഇൻ്റർനാഷണൽ ട്രിവാൻഡ്രത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1564.jpeg",
    },
    {
      src: "assets/img/Pastevents/1565.jpeg",
      caption:
        "'മിഠായി ' (2) ലോക പ്രമേഹ ദിനത്തോട് അനുബന്ധിച്ച് സ്ക്കൂൾ വിദ്യാർഥികളിലൂടെ പ്രമേഹ അവബോധം കുടുംബത്തിലേയ്ക്കും സമൂഹത്തിലേയ്ക്കും.തിരുവനന്തപുരം ജില്ലയിലെ തിരെഞ്ഞെടുത്ത വിദ്യാലയങ്ങളിൽ സംഘടിപ്പിക്കുന്ന പ്രമേഹ ബോധവൽക്കരണ പദ്ധതിയുടെ ഭാഗമായി ഗവ: യു പി എസ് സ്ക്കൂൾ അമ്പലത്തറ, റോട്ടറി ഇൻ്റർനാഷണൽ ട്രിവാൻഡ്രത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1565.jpeg",
    },
    {
      src: "assets/img/Pastevents/1566.jpeg",
      caption:
        "'മിഠായി ' (2) ലോക പ്രമേഹ ദിനത്തോട് അനുബന്ധിച്ച് സ്ക്കൂൾ വിദ്യാർഥികളിലൂടെ പ്രമേഹ അവബോധം കുടുംബത്തിലേയ്ക്കും സമൂഹത്തിലേയ്ക്കും.തിരുവനന്തപുരം ജില്ലയിലെ തിരെഞ്ഞെടുത്ത വിദ്യാലയങ്ങളിൽ സംഘടിപ്പിക്കുന്ന പ്രമേഹ ബോധവൽക്കരണ പദ്ധതിയുടെ ഭാഗമായി ഗവ: യു പി എസ് സ്ക്കൂൾ അമ്പലത്തറ, റോട്ടറി ഇൻ്റർനാഷണൽ ട്രിവാൻഡ്രത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1566.jpeg",
    },
    {
      src: "assets/img/Pastevents/1567.jpeg",
      caption:
        "'മിഠായി ' (2) ലോക പ്രമേഹ ദിനത്തോട് അനുബന്ധിച്ച് സ്ക്കൂൾ വിദ്യാർഥികളിലൂടെ പ്രമേഹ അവബോധം കുടുംബത്തിലേയ്ക്കും സമൂഹത്തിലേയ്ക്കും.തിരുവനന്തപുരം ജില്ലയിലെ തിരെഞ്ഞെടുത്ത വിദ്യാലയങ്ങളിൽ സംഘടിപ്പിക്കുന്ന പ്രമേഹ ബോധവൽക്കരണ പദ്ധതിയുടെ ഭാഗമായി ഗവ: യു പി എസ് സ്ക്കൂൾ അമ്പലത്തറ, റോട്ടറി ഇൻ്റർനാഷണൽ ട്രിവാൻഡ്രത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1567.jpeg",
    },
    {
      src: "assets/img/Pastevents/1568.jpeg",
      caption:
        "'മിഠായി ' (2) ലോക പ്രമേഹ ദിനത്തോട് അനുബന്ധിച്ച് സ്ക്കൂൾ വിദ്യാർഥികളിലൂടെ പ്രമേഹ അവബോധം കുടുംബത്തിലേയ്ക്കും സമൂഹത്തിലേയ്ക്കും.തിരുവനന്തപുരം ജില്ലയിലെ തിരെഞ്ഞെടുത്ത വിദ്യാലയങ്ങളിൽ സംഘടിപ്പിക്കുന്ന പ്രമേഹ ബോധവൽക്കരണ പദ്ധതിയുടെ ഭാഗമായി ഗവ: യു പി എസ് സ്ക്കൂൾ അമ്പലത്തറ, റോട്ടറി ഇൻ്റർനാഷണൽ ട്രിവാൻഡ്രത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1568.jpeg",
    },
    {
      src: "assets/img/Pastevents/1559.jpeg",
      caption:
        "ട്രിവാൻഡ്രം റീജണൽ ട്രാൻസ്പോർട്ട് ഓഫീസ്, ഇൻഡസ് മോട്ടോഴ്സ് ലിമിറ്റഡിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1559.jpeg",
    },
    {
      src: "assets/img/Pastevents/1560.jpeg",
      caption:
        "ട്രിവാൻഡ്രം റീജണൽ ട്രാൻസ്പോർട്ട് ഓഫീസ്, ഇൻഡസ് മോട്ടോഴ്സ് ലിമിറ്റഡിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1560.jpeg",
    },
    {
      src: "assets/img/Pastevents/1561.jpeg",
      caption:
        "ട്രിവാൻഡ്രം റീജണൽ ട്രാൻസ്പോർട്ട് ഓഫീസ്, ഇൻഡസ് മോട്ടോഴ്സ് ലിമിറ്റഡിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1561.jpeg",
    },
    {
      src: "assets/img/Pastevents/1562.jpeg",
      caption:
        "ട്രിവാൻഡ്രം റീജണൽ ട്രാൻസ്പോർട്ട് ഓഫീസ്, ഇൻഡസ് മോട്ടോഴ്സ് ലിമിറ്റഡിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1562.jpeg",
    },
    {
      src: "assets/img/Pastevents/1563.jpeg",
      caption:
        "ട്രിവാൻഡ്രം റീജണൽ ട്രാൻസ്പോർട്ട് ഓഫീസ്, ഇൻഡസ് മോട്ടോഴ്സ് ലിമിറ്റഡിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1563.jpeg",
    },
    {
      src: "assets/img/Pastevents/1548.jpeg",
      caption:
        "ലോക പ്രമേഹ ദിനത്തോട് അനുബന്ധിച്ച് വെള്ളറട ഗ്രാമപഞ്ചായത്തും,തിരുവനന്തപുരം പ്രേം നസീർ ഫൗണ്ടേഷന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ ലാൽ കൃഷ്ണൻ (ബ്ലോക്ക് പഞ്ചായത്ത് പ്രസിഡൻ്റ്)",
      thumb: "assets/img/Pastevents/1548.jpeg",
    },
    {
      src: "assets/img/Pastevents/1549.jpeg",
      caption:
        "ലോക പ്രമേഹ ദിനത്തോട് അനുബന്ധിച്ച് വെള്ളറട ഗ്രാമപഞ്ചായത്തും,തിരുവനന്തപുരം പ്രേം നസീർ ഫൗണ്ടേഷന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ ലാൽ കൃഷ്ണൻ (ബ്ലോക്ക് പഞ്ചായത്ത് പ്രസിഡൻ്റ്)",
      thumb: "assets/img/Pastevents/1549.jpeg",
    },
    {
      src: "assets/img/Pastevents/1550.jpeg",
      caption:
        "ലോക പ്രമേഹ ദിനത്തോട് അനുബന്ധിച്ച് വെള്ളറട ഗ്രാമപഞ്ചായത്തും,തിരുവനന്തപുരം പ്രേം നസീർ ഫൗണ്ടേഷന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ ലാൽ കൃഷ്ണൻ (ബ്ലോക്ക് പഞ്ചായത്ത് പ്രസിഡൻ്റ്)",
      thumb: "assets/img/Pastevents/1550.jpeg",
    },
    {
      src: "assets/img/Pastevents/1551.jpeg",
      caption:
        "ലോക പ്രമേഹ ദിനത്തോട് അനുബന്ധിച്ച് വെള്ളറട ഗ്രാമപഞ്ചായത്തും,തിരുവനന്തപുരം പ്രേം നസീർ ഫൗണ്ടേഷന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ ലാൽ കൃഷ്ണൻ (ബ്ലോക്ക് പഞ്ചായത്ത് പ്രസിഡൻ്റ്)",
      thumb: "assets/img/Pastevents/1551.jpeg",
    },
    {
      src: "assets/img/Pastevents/1552.jpeg",
      caption:
        "ലോക പ്രമേഹ ദിനത്തോട് അനുബന്ധിച്ച് വെള്ളറട ഗ്രാമപഞ്ചായത്തും,തിരുവനന്തപുരം പ്രേം നസീർ ഫൗണ്ടേഷന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ ലാൽ കൃഷ്ണൻ (ബ്ലോക്ക് പഞ്ചായത്ത് പ്രസിഡൻ്റ്)",
      thumb: "assets/img/Pastevents/1552.jpeg",
    },
    {
      src: "assets/img/Pastevents/1553.jpeg",
      caption:
        "ലോക പ്രമേഹ ദിനത്തോട് അനുബന്ധിച്ച് വെള്ളറട ഗ്രാമപഞ്ചായത്തും,തിരുവനന്തപുരം പ്രേം നസീർ ഫൗണ്ടേഷന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ ലാൽ കൃഷ്ണൻ (ബ്ലോക്ക് പഞ്ചായത്ത് പ്രസിഡൻ്റ്)",
      thumb: "assets/img/Pastevents/1553.jpeg",
    },
    {
      src: "assets/img/Pastevents/1554.jpeg",
      caption:
        "ലോക പ്രമേഹ ദിനത്തോട് അനുബന്ധിച്ച് വെള്ളറട ഗ്രാമപഞ്ചായത്തും,തിരുവനന്തപുരം പ്രേം നസീർ ഫൗണ്ടേഷന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ ലാൽ കൃഷ്ണൻ (ബ്ലോക്ക് പഞ്ചായത്ത് പ്രസിഡൻ്റ്)",
      thumb: "assets/img/Pastevents/1554.jpeg",
    },
    {
      src: "assets/img/Pastevents/1555.jpeg",
      caption:
        "ലോക പ്രമേഹ ദിനത്തോട് അനുബന്ധിച്ച് വെള്ളറട ഗ്രാമപഞ്ചായത്തും,തിരുവനന്തപുരം പ്രേം നസീർ ഫൗണ്ടേഷന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ ലാൽ കൃഷ്ണൻ (ബ്ലോക്ക് പഞ്ചായത്ത് പ്രസിഡൻ്റ്)",
      thumb: "assets/img/Pastevents/1555.jpeg",
    },
    {
      src: "assets/img/Pastevents/1556.jpeg",
      caption:
        "ലോക പ്രമേഹ ദിനത്തോട് അനുബന്ധിച്ച് വെള്ളറട ഗ്രാമപഞ്ചായത്തും,തിരുവനന്തപുരം പ്രേം നസീർ ഫൗണ്ടേഷന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ ലാൽ കൃഷ്ണൻ (ബ്ലോക്ക് പഞ്ചായത്ത് പ്രസിഡൻ്റ്)",
      thumb: "assets/img/Pastevents/1556.jpeg",
    },
    {
      src: "assets/img/Pastevents/1557.jpeg",
      caption:
        "ലോക പ്രമേഹ ദിനത്തോട് അനുബന്ധിച്ച് വെള്ളറട ഗ്രാമപഞ്ചായത്തും,തിരുവനന്തപുരം പ്രേം നസീർ ഫൗണ്ടേഷന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ ലാൽ കൃഷ്ണൻ (ബ്ലോക്ക് പഞ്ചായത്ത് പ്രസിഡൻ്റ്)",
      thumb: "assets/img/Pastevents/1557.jpeg",
    },
    {
      src: "assets/img/Pastevents/1558.jpeg",
      caption:
        "ലോക പ്രമേഹ ദിനത്തോട് അനുബന്ധിച്ച് വെള്ളറട ഗ്രാമപഞ്ചായത്തും,തിരുവനന്തപുരം പ്രേം നസീർ ഫൗണ്ടേഷന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ ലാൽ കൃഷ്ണൻ (ബ്ലോക്ക് പഞ്ചായത്ത് പ്രസിഡൻ്റ്)",
      thumb: "assets/img/Pastevents/1558.jpeg",
    },
    {
      src: "assets/img/Pastevents/1539.jpeg",
      caption:
        "'മിഠായി ' ലോക പ്രമേഹ ദിനത്തോട് അനുബന്ധിച്ച് സ്ക്കൂൾ വിദ്യാർഥികളിലൂടെ പ്രമേഹ അവബോധം കുടുംബത്തിലേയ്ക്കും സമൂഹത്തിലേയ്ക്കും.തിരുവനന്തപുരം ജില്ലയിലെ തിരെഞ്ഞെടുത്ത വിദ്യാലയങ്ങളിൽ സംഘടിപ്പിക്കുന്ന പ്രമേഹ ബോധവൽക്കരണ പദ്ധതിയുടെ ഭാഗമായി ഗവ: യു പി എസ് സ്ക്കൂൾ അമ്പലത്തറ, റോട്ടറി ഇൻ്റർനാഷണൽ ട്രിവാൻഡ്രത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1539.jpeg",
    },
    {
      src: "assets/img/Pastevents/1540.jpeg",
      caption:
        "'മിഠായി ' ലോക പ്രമേഹ ദിനത്തോട് അനുബന്ധിച്ച് സ്ക്കൂൾ വിദ്യാർഥികളിലൂടെ പ്രമേഹ അവബോധം കുടുംബത്തിലേയ്ക്കും സമൂഹത്തിലേയ്ക്കും.തിരുവനന്തപുരം ജില്ലയിലെ തിരെഞ്ഞെടുത്ത വിദ്യാലയങ്ങളിൽ സംഘടിപ്പിക്കുന്ന പ്രമേഹ ബോധവൽക്കരണ പദ്ധതിയുടെ ഭാഗമായി ഗവ: യു പി എസ് സ്ക്കൂൾ അമ്പലത്തറ, റോട്ടറി ഇൻ്റർനാഷണൽ ട്രിവാൻഡ്രത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1540.jpeg",
    },
    {
      src: "assets/img/Pastevents/1541.jpeg",
      caption:
        "'മിഠായി ' ലോക പ്രമേഹ ദിനത്തോട് അനുബന്ധിച്ച് സ്ക്കൂൾ വിദ്യാർഥികളിലൂടെ പ്രമേഹ അവബോധം കുടുംബത്തിലേയ്ക്കും സമൂഹത്തിലേയ്ക്കും.തിരുവനന്തപുരം ജില്ലയിലെ തിരെഞ്ഞെടുത്ത വിദ്യാലയങ്ങളിൽ സംഘടിപ്പിക്കുന്ന പ്രമേഹ ബോധവൽക്കരണ പദ്ധതിയുടെ ഭാഗമായി ഗവ: യു പി എസ് സ്ക്കൂൾ അമ്പലത്തറ, റോട്ടറി ഇൻ്റർനാഷണൽ ട്രിവാൻഡ്രത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1541.jpeg",
    },
    {
      src: "assets/img/Pastevents/1542.jpeg",
      caption:
        "'മിഠായി ' ലോക പ്രമേഹ ദിനത്തോട് അനുബന്ധിച്ച് സ്ക്കൂൾ വിദ്യാർഥികളിലൂടെ പ്രമേഹ അവബോധം കുടുംബത്തിലേയ്ക്കും സമൂഹത്തിലേയ്ക്കും.തിരുവനന്തപുരം ജില്ലയിലെ തിരെഞ്ഞെടുത്ത വിദ്യാലയങ്ങളിൽ സംഘടിപ്പിക്കുന്ന പ്രമേഹ ബോധവൽക്കരണ പദ്ധതിയുടെ ഭാഗമായി ഗവ: യു പി എസ് സ്ക്കൂൾ അമ്പലത്തറ, റോട്ടറി ഇൻ്റർനാഷണൽ ട്രിവാൻഡ്രത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1542.jpeg",
    },
    {
      src: "assets/img/Pastevents/1543.jpeg",
      caption:
        "'മിഠായി ' ലോക പ്രമേഹ ദിനത്തോട് അനുബന്ധിച്ച് സ്ക്കൂൾ വിദ്യാർഥികളിലൂടെ പ്രമേഹ അവബോധം കുടുംബത്തിലേയ്ക്കും സമൂഹത്തിലേയ്ക്കും.തിരുവനന്തപുരം ജില്ലയിലെ തിരെഞ്ഞെടുത്ത വിദ്യാലയങ്ങളിൽ സംഘടിപ്പിക്കുന്ന പ്രമേഹ ബോധവൽക്കരണ പദ്ധതിയുടെ ഭാഗമായി ഗവ: യു പി എസ് സ്ക്കൂൾ അമ്പലത്തറ, റോട്ടറി ഇൻ്റർനാഷണൽ ട്രിവാൻഡ്രത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1543.jpeg",
    },
    {
      src: "assets/img/Pastevents/1544.jpeg",
      caption:
        "'മിഠായി ' ലോക പ്രമേഹ ദിനത്തോട് അനുബന്ധിച്ച് സ്ക്കൂൾ വിദ്യാർഥികളിലൂടെ പ്രമേഹ അവബോധം കുടുംബത്തിലേയ്ക്കും സമൂഹത്തിലേയ്ക്കും.തിരുവനന്തപുരം ജില്ലയിലെ തിരെഞ്ഞെടുത്ത വിദ്യാലയങ്ങളിൽ സംഘടിപ്പിക്കുന്ന പ്രമേഹ ബോധവൽക്കരണ പദ്ധതിയുടെ ഭാഗമായി ഗവ: യു പി എസ് സ്ക്കൂൾ അമ്പലത്തറ, റോട്ടറി ഇൻ്റർനാഷണൽ ട്രിവാൻഡ്രത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1544.jpeg",
    },
    {
      src: "assets/img/Pastevents/1545.jpeg",
      caption:
        "'മിഠായി ' ലോക പ്രമേഹ ദിനത്തോട് അനുബന്ധിച്ച് സ്ക്കൂൾ വിദ്യാർഥികളിലൂടെ പ്രമേഹ അവബോധം കുടുംബത്തിലേയ്ക്കും സമൂഹത്തിലേയ്ക്കും.തിരുവനന്തപുരം ജില്ലയിലെ തിരെഞ്ഞെടുത്ത വിദ്യാലയങ്ങളിൽ സംഘടിപ്പിക്കുന്ന പ്രമേഹ ബോധവൽക്കരണ പദ്ധതിയുടെ ഭാഗമായി ഗവ: യു പി എസ് സ്ക്കൂൾ അമ്പലത്തറ, റോട്ടറി ഇൻ്റർനാഷണൽ ട്രിവാൻഡ്രത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1545.jpeg",
    },
    {
      src: "assets/img/Pastevents/1546.jpeg",
      caption:
        "'മിഠായി ' ലോക പ്രമേഹ ദിനത്തോട് അനുബന്ധിച്ച് സ്ക്കൂൾ വിദ്യാർഥികളിലൂടെ പ്രമേഹ അവബോധം കുടുംബത്തിലേയ്ക്കും സമൂഹത്തിലേയ്ക്കും.തിരുവനന്തപുരം ജില്ലയിലെ തിരെഞ്ഞെടുത്ത വിദ്യാലയങ്ങളിൽ സംഘടിപ്പിക്കുന്ന പ്രമേഹ ബോധവൽക്കരണ പദ്ധതിയുടെ ഭാഗമായി ഗവ: യു പി എസ് സ്ക്കൂൾ അമ്പലത്തറ, റോട്ടറി ഇൻ്റർനാഷണൽ ട്രിവാൻഡ്രത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1546.jpeg",
    },
    {
      src: "assets/img/Pastevents/1547.jpeg",
      caption:
        "'മിഠായി ' ലോക പ്രമേഹ ദിനത്തോട് അനുബന്ധിച്ച് സ്ക്കൂൾ വിദ്യാർഥികളിലൂടെ പ്രമേഹ അവബോധം കുടുംബത്തിലേയ്ക്കും സമൂഹത്തിലേയ്ക്കും.തിരുവനന്തപുരം ജില്ലയിലെ തിരെഞ്ഞെടുത്ത വിദ്യാലയങ്ങളിൽ സംഘടിപ്പിക്കുന്ന പ്രമേഹ ബോധവൽക്കരണ പദ്ധതിയുടെ ഭാഗമായി ഗവ: യു പി എസ് സ്ക്കൂൾ അമ്പലത്തറ, റോട്ടറി ഇൻ്റർനാഷണൽ ട്രിവാൻഡ്രത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1547.jpeg",
    },

    {
      src: "assets/img/Pastevents/1524.jpeg",
      caption:
        "കാഞ്ഞിരംപാറ വി കെ പി റെസിഡൻഷ്യൽ അസോസിയേഷൻ,ട്രിവാൻഡ്രം നാഷണൽ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1524.jpeg",
    },
    {
      src: "assets/img/Pastevents/1525.jpeg",
      caption:
        "കാഞ്ഞിരംപാറ വി കെ പി റെസിഡൻഷ്യൽ അസോസിയേഷൻ,ട്രിവാൻഡ്രം നാഷണൽ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1525.jpeg",
    },
    {
      src: "assets/img/Pastevents/1526.jpeg",
      caption:
        "കാഞ്ഞിരംപാറ വി കെ പി റെസിഡൻഷ്യൽ അസോസിയേഷൻ,ട്രിവാൻഡ്രം നാഷണൽ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1526.jpeg",
    },
    {
      src: "assets/img/Pastevents/1527.jpeg",
      caption:
        "കാഞ്ഞിരംപാറ വി കെ പി റെസിഡൻഷ്യൽ അസോസിയേഷൻ,ട്രിവാൻഡ്രം നാഷണൽ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1527.jpeg",
    },
    {
      src: "assets/img/Pastevents/1528.jpeg",
      caption:
        "കാഞ്ഞിരംപാറ വി കെ പി റെസിഡൻഷ്യൽ അസോസിയേഷൻ,ട്രിവാൻഡ്രം നാഷണൽ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1528.jpeg",
    },
    {
      src: "assets/img/Pastevents/1529.jpeg",
      caption:
        "കാഞ്ഞിരംപാറ വി കെ പി റെസിഡൻഷ്യൽ അസോസിയേഷൻ,ട്രിവാൻഡ്രം നാഷണൽ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1529.jpeg",
    },
    {
      src: "assets/img/Pastevents/1530.jpeg",
      caption:
        "ആഴിമല ശിവക്ഷേത്ര ട്രസ്റ്റും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      thumb: "assets/img/Pastevents/1530.jpeg",
    },
    {
      src: "assets/img/Pastevents/1531.jpeg",
      caption:
        "ആഴിമല ശിവക്ഷേത്ര ട്രസ്റ്റും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      thumb: "assets/img/Pastevents/1531.jpeg",
    },
    {
      src: "assets/img/Pastevents/1532.jpeg",
      caption:
        "ആഴിമല ശിവക്ഷേത്ര ട്രസ്റ്റും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      thumb: "assets/img/Pastevents/1532.jpeg",
    },
    {
      src: "assets/img/Pastevents/1533.jpeg",
      caption:
        "ആഴിമല ശിവക്ഷേത്ര ട്രസ്റ്റും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      thumb: "assets/img/Pastevents/1533.jpeg",
    },
    {
      src: "assets/img/Pastevents/1534.jpeg",
      caption:
        "ആഴിമല ശിവക്ഷേത്ര ട്രസ്റ്റും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      thumb: "assets/img/Pastevents/1534.jpeg",
    },
    {
      src: "assets/img/Pastevents/1535.jpeg",
      caption:
        "ആഴിമല ശിവക്ഷേത്ര ട്രസ്റ്റും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      thumb: "assets/img/Pastevents/1535.jpeg",
    },
    {
      src: "assets/img/Pastevents/1536.jpeg",
      caption:
        "ആഴിമല ശിവക്ഷേത്ര ട്രസ്റ്റും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      thumb: "assets/img/Pastevents/1536.jpeg",
    },
    {
      src: "assets/img/Pastevents/1537.jpeg",
      caption:
        "ആഴിമല ശിവക്ഷേത്ര ട്രസ്റ്റും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      thumb: "assets/img/Pastevents/1537.jpeg",
    },
    {
      src: "assets/img/Pastevents/1538.jpeg",
      caption:
        "ആഴിമല ശിവക്ഷേത്ര ട്രസ്റ്റും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      thumb: "assets/img/Pastevents/1538.jpeg",
    },

    {
      src: "assets/img/Pastevents/1518.jpeg",
      caption:
        "വെണ്ണിയൂർ സി എസ് ഐ ചർച്ച്, വെങ്ങാനൂർ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1518.jpeg",
    },
    {
      src: "assets/img/Pastevents/1519.jpeg",
      caption:
        "വെണ്ണിയൂർ സി എസ് ഐ ചർച്ച്, വെങ്ങാനൂർ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1519.jpeg",
    },
    {
      src: "assets/img/Pastevents/1520.jpeg",
      caption:
        "വെണ്ണിയൂർ സി എസ് ഐ ചർച്ച്, വെങ്ങാനൂർ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1520.jpeg",
    },
    {
      src: "assets/img/Pastevents/1521.jpeg",
      caption:
        "വെണ്ണിയൂർ സി എസ് ഐ ചർച്ച്, വെങ്ങാനൂർ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1521.jpeg",
    },
    {
      src: "assets/img/Pastevents/1522.jpeg",
      caption:
        "വെണ്ണിയൂർ സി എസ് ഐ ചർച്ച്, വെങ്ങാനൂർ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1522.jpeg",
    },
    {
      src: "assets/img/Pastevents/1523.jpeg",
      caption:
        "വെണ്ണിയൂർ സി എസ് ഐ ചർച്ച്, വെങ്ങാനൂർ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1523.jpeg",
    },

    {
      src: "assets/img/Pastevents/1513.jpeg",
      caption:
        "വെണ്ണിയൂർ ജുവജെൻ ടെൽകാസ് ചിൽഡ്രൻസ് വില്ലേജിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1513.jpeg",
    },
    {
      src: "assets/img/Pastevents/1514.jpeg",
      caption:
        "വെണ്ണിയൂർ ജുവജെൻ ടെൽകാസ് ചിൽഡ്രൻസ് വില്ലേജിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1514.jpeg",
    },
    {
      src: "assets/img/Pastevents/1515.jpeg",
      caption:
        "വെണ്ണിയൂർ ജുവജെൻ ടെൽകാസ് ചിൽഡ്രൻസ് വില്ലേജിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1515.jpeg",
    },
    {
      src: "assets/img/Pastevents/1516.jpeg",
      caption:
        "വെണ്ണിയൂർ ജുവജെൻ ടെൽകാസ് ചിൽഡ്രൻസ് വില്ലേജിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1516.jpeg",
    },
    {
      src: "assets/img/Pastevents/1517.jpeg",
      caption:
        "വെണ്ണിയൂർ ജുവജെൻ ടെൽകാസ് ചിൽഡ്രൻസ് വില്ലേജിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1517.jpeg",
    },

    {
      src: "assets/img/Pastevents/1499.jpeg",
      caption:
        "തിരുവനന്തപുരം ലുലു മാൾ,ട്രിവാൻഡ്രം മജസറ്റിക് ലയൺസ് ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1499.jpeg",
    },
    {
      src: "assets/img/Pastevents/1500.jpeg",
      caption:
        "തിരുവനന്തപുരം ലുലു മാൾ,ട്രിവാൻഡ്രം മജസറ്റിക് ലയൺസ് ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1500.jpeg",
    },
    {
      src: "assets/img/Pastevents/1501.jpeg",
      caption:
        "തിരുവനന്തപുരം ലുലു മാൾ,ട്രിവാൻഡ്രം മജസറ്റിക് ലയൺസ് ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1501.jpeg",
    },
    {
      src: "assets/img/Pastevents/1502.jpeg",
      caption:
        "തിരുവനന്തപുരം ലുലു മാൾ,ട്രിവാൻഡ്രം മജസറ്റിക് ലയൺസ് ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1502.jpeg",
    },
    {
      src: "assets/img/Pastevents/1503.jpeg",
      caption:
        "തിരുവനന്തപുരം ലുലു മാൾ,ട്രിവാൻഡ്രം മജസറ്റിക് ലയൺസ് ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1503.jpeg",
    },
    {
      src: "assets/img/Pastevents/1504.jpeg",
      caption:
        "തിരുവനന്തപുരം ലുലു മാൾ,ട്രിവാൻഡ്രം മജസറ്റിക് ലയൺസ് ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1504.jpeg",
    },
    {
      src: "assets/img/Pastevents/1505.jpeg",
      caption:
        "തിരുവനന്തപുരം ലുലു മാൾ,ട്രിവാൻഡ്രം മജസറ്റിക് ലയൺസ് ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1505.jpeg",
    },
    {
      src: "assets/img/Pastevents/1506.jpeg",
      caption:
        "തിരുവനന്തപുരം ഗവ:സംസ്കൃത കോളേജ്, ഗാർഡൻ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1506.jpeg",
    },
    {
      src: "assets/img/Pastevents/1507.jpeg",
      caption:
        "തിരുവനന്തപുരം ഗവ:സംസ്കൃത കോളേജ്, ഗാർഡൻ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1507.jpeg",
    },
    {
      src: "assets/img/Pastevents/1508.jpeg",
      caption:
        "തിരുവനന്തപുരം ഗവ:സംസ്കൃത കോളേജ്, ഗാർഡൻ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1508.jpeg",
    },
    {
      src: "assets/img/Pastevents/1509.jpeg",
      caption:
        "തിരുവനന്തപുരം ഗവ:സംസ്കൃത കോളേജ്, ഗാർഡൻ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1509.jpeg",
    },
    {
      src: "assets/img/Pastevents/1510.jpeg",
      caption:
        "തിരുവനന്തപുരം ഗവ:സംസ്കൃത കോളേജ്, ഗാർഡൻ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1510.jpeg",
    },
    {
      src: "assets/img/Pastevents/1511.jpeg",
      caption:
        "തിരുവനന്തപുരം ഗവ:സംസ്കൃത കോളേജ്, ഗാർഡൻ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1511.jpeg",
    },
    {
      src: "assets/img/Pastevents/1512.jpeg",
      caption:
        "തിരുവനന്തപുരം ഗവ:സംസ്കൃത കോളേജ്, ഗാർഡൻ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1512.jpeg",
    },

    {
      src: "assets/img/Pastevents/1480.jpeg",
      caption:
        "ദാറുൽ ഇർഷാദ് ഇസ്ലാമിക് അക്കാദമിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1480.jpeg",
    },
    {
      src: "assets/img/Pastevents/1481.jpeg",
      caption:
        "ദാറുൽ ഇർഷാദ് ഇസ്ലാമിക് അക്കാദമിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1481.jpeg",
    },
    {
      src: "assets/img/Pastevents/1482.jpeg",
      caption:
        "ദാറുൽ ഇർഷാദ് ഇസ്ലാമിക് അക്കാദമിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1482.jpeg",
    },
    {
      src: "assets/img/Pastevents/1483.jpeg",
      caption:
        "ദാറുൽ ഇർഷാദ് ഇസ്ലാമിക് അക്കാദമിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1483.jpeg",
    },
    {
      src: "assets/img/Pastevents/1484.jpeg",
      caption:
        "ദാറുൽ ഇർഷാദ് ഇസ്ലാമിക് അക്കാദമിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1484.jpeg",
    },
    {
      src: "assets/img/Pastevents/1485.jpeg",
      caption:
        "ദാറുൽ ഇർഷാദ് ഇസ്ലാമിക് അക്കാദമിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1485.jpeg",
    },
    {
      src: "assets/img/Pastevents/1486.jpeg",
      caption:
        "ശ്രീ നാരായണ ചാരിറ്റബിൾ ട്രസ്റ്റ്,ട്രിവാൻഡ്രം മെട്രോ പോളിസ് യൂണിറ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1486.jpeg",
    },
    {
      src: "assets/img/Pastevents/1487.jpeg",
      caption:
        "ശ്രീ നാരായണ ചാരിറ്റബിൾ ട്രസ്റ്റ്,ട്രിവാൻഡ്രം മെട്രോ പോളിസ് യൂണിറ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1487.jpeg",
    },
    {
      src: "assets/img/Pastevents/1488.jpeg",
      caption:
        "ശ്രീ നാരായണ ചാരിറ്റബിൾ ട്രസ്റ്റ്,ട്രിവാൻഡ്രം മെട്രോ പോളിസ് യൂണിറ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1488.jpeg",
    },
    {
      src: "assets/img/Pastevents/1489.jpeg",
      caption:
        "ശ്രീ നാരായണ ചാരിറ്റബിൾ ട്രസ്റ്റ്,ട്രിവാൻഡ്രം മെട്രോ പോളിസ് യൂണിറ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1489.jpeg",
    },
    {
      src: "assets/img/Pastevents/1490.jpeg",
      caption:
        "ശ്രീ നാരായണ ചാരിറ്റബിൾ ട്രസ്റ്റ്,ട്രിവാൻഡ്രം മെട്രോ പോളിസ് യൂണിറ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1490.jpeg",
    },
    {
      src: "assets/img/Pastevents/1491.jpeg",
      caption:
        "മംഗലത്ത്ക്കോണം ബഡ് സ്കൂൾ, വെങ്ങാനൂർ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1491.jpeg",
    },
    {
      src: "assets/img/Pastevents/1492.jpeg",
      caption:
        "മംഗലത്ത്ക്കോണം ബഡ് സ്കൂൾ, വെങ്ങാനൂർ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1492.jpeg",
    },
    {
      src: "assets/img/Pastevents/1493.jpeg",
      caption:
        "മംഗലത്ത്ക്കോണം ബഡ് സ്കൂൾ, വെങ്ങാനൂർ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1493.jpeg",
    },
    {
      src: "assets/img/Pastevents/1494.jpeg",
      caption:
        "മംഗലത്ത്ക്കോണം ബഡ് സ്കൂൾ, വെങ്ങാനൂർ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1494.jpeg",
    },
    {
      src: "assets/img/Pastevents/1495.jpeg",
      caption:
        "മംഗലത്ത്ക്കോണം ബഡ് സ്കൂൾ, വെങ്ങാനൂർ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1495.jpeg",
    },
    {
      src: "assets/img/Pastevents/1496.jpeg",
      caption:
        "മംഗലത്ത്ക്കോണം ബഡ് സ്കൂൾ, വെങ്ങാനൂർ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1496.jpeg",
    },
    {
      src: "assets/img/Pastevents/1497.jpeg",
      caption:
        "മംഗലത്ത്ക്കോണം ബഡ് സ്കൂൾ, വെങ്ങാനൂർ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1497.jpeg",
    },
    {
      src: "assets/img/Pastevents/1498.jpeg",
      caption:
        "മംഗലത്ത്ക്കോണം ബഡ് സ്കൂൾ, വെങ്ങാനൂർ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1498.jpeg",
    },

    {
      src: "assets/img/Pastevents/1457.jpeg",
      caption:
        "ശ്രീ നാരായണ ചാരിറ്റബിൾ ട്രസ്റ്റ്,ട്രിവാൻഡ്രം മെട്രോ പോളിസ് യൂണിറ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1457.jpeg",
    },
    {
      src: "assets/img/Pastevents/1458.jpeg",
      caption:
        "ശ്രീ നാരായണ ചാരിറ്റബിൾ ട്രസ്റ്റ്,ട്രിവാൻഡ്രം മെട്രോ പോളിസ് യൂണിറ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1458.jpeg",
    },
    {
      src: "assets/img/Pastevents/1459.jpeg",
      caption:
        "ശ്രീ നാരായണ ചാരിറ്റബിൾ ട്രസ്റ്റ്,ട്രിവാൻഡ്രം മെട്രോ പോളിസ് യൂണിറ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1459.jpeg",
    },
    {
      src: "assets/img/Pastevents/1460.jpeg",
      caption:
        "ശ്രീ നാരായണ ചാരിറ്റബിൾ ട്രസ്റ്റ്,ട്രിവാൻഡ്രം മെട്രോ പോളിസ് യൂണിറ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1460.jpeg",
    },
    {
      src: "assets/img/Pastevents/1461.jpeg",
      caption:
        "ശ്രീ നാരായണ ചാരിറ്റബിൾ ട്രസ്റ്റ്,ട്രിവാൻഡ്രം മെട്രോ പോളിസ് യൂണിറ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1461.jpeg",
    },
    {
      src: "assets/img/Pastevents/1462.jpeg",
      caption:
        "ശ്രീ നാരായണ ചാരിറ്റബിൾ ട്രസ്റ്റ്,ട്രിവാൻഡ്രം മെട്രോ പോളിസ് യൂണിറ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1462.jpeg",
    },
    {
      src: "assets/img/Pastevents/1463.jpeg",
      caption:
        "ശ്രീ നാരായണ ചാരിറ്റബിൾ ട്രസ്റ്റ്,ട്രിവാൻഡ്രം മെട്രോ പോളിസ് യൂണിറ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1463.jpeg",
    },
    {
      src: "assets/img/Pastevents/1464.jpeg",
      caption:
        "ശ്രീ നാരായണ ചാരിറ്റബിൾ ട്രസ്റ്റ്,ട്രിവാൻഡ്രം മെട്രോ പോളിസ് യൂണിറ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1464.jpeg",
    },
    {
      src: "assets/img/Pastevents/1465.jpeg",
      caption:
        "ഗുഡ് ഷെപ്പേർഡ് മിഷൻ, വെങ്ങാനൂർ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1465.jpeg",
    },
    {
      src: "assets/img/Pastevents/1466.jpeg",
      caption:
        "ഗുഡ് ഷെപ്പേർഡ് മിഷൻ, വെങ്ങാനൂർ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1466.jpeg",
    },
    {
      src: "assets/img/Pastevents/1467.jpeg",
      caption:
        "ഗുഡ് ഷെപ്പേർഡ് മിഷൻ, വെങ്ങാനൂർ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1467.jpeg",
    },
    {
      src: "assets/img/Pastevents/1468.jpeg",
      caption:
        "ഗുഡ് ഷെപ്പേർഡ് മിഷൻ, വെങ്ങാനൂർ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1468.jpeg",
    },
    {
      src: "assets/img/Pastevents/1469.jpeg",
      caption:
        "ഗുഡ് ഷെപ്പേർഡ് മിഷൻ, വെങ്ങാനൂർ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1469.jpeg",
    },
    {
      src: "assets/img/Pastevents/1470.jpeg",
      caption:
        "ഗുഡ് ഷെപ്പേർഡ് മിഷൻ, വെങ്ങാനൂർ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1470.jpeg",
    },
    {
      src: "assets/img/Pastevents/1471.jpeg",
      caption:
        "കുളത്തൂർ മുസ്ലിം ജുമാ മസ്ജിദ് ചാരിറ്റബിൾ ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1471.jpeg",
    },
    {
      src: "assets/img/Pastevents/1472.jpeg",
      caption:
        "കുളത്തൂർ മുസ്ലിം ജുമാ മസ്ജിദ് ചാരിറ്റബിൾ ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1472.jpeg",
    },
    {
      src: "assets/img/Pastevents/1473.jpeg",
      caption:
        "കുളത്തൂർ മുസ്ലിം ജുമാ മസ്ജിദ് ചാരിറ്റബിൾ ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1473.jpeg",
    },
    {
      src: "assets/img/Pastevents/1474.jpeg",
      caption:
        "കുളത്തൂർ മുസ്ലിം ജുമാ മസ്ജിദ് ചാരിറ്റബിൾ ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1474.jpeg",
    },
    {
      src: "assets/img/Pastevents/1475.jpeg",
      caption:
        "കുളത്തൂർ മുസ്ലിം ജുമാ മസ്ജിദ് ചാരിറ്റബിൾ ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1475.jpeg",
    },
    {
      src: "assets/img/Pastevents/1476.jpeg",
      caption:
        "കുളത്തൂർ മുസ്ലിം ജുമാ മസ്ജിദ് ചാരിറ്റബിൾ ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1476.jpeg",
    },
    {
      src: "assets/img/Pastevents/1477.jpeg",
      caption:
        "കുളത്തൂർ മുസ്ലിം ജുമാ മസ്ജിദ് ചാരിറ്റബിൾ ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1477.jpeg",
    },
    {
      src: "assets/img/Pastevents/1478.jpeg",
      caption:
        "കുളത്തൂർ മുസ്ലിം ജുമാ മസ്ജിദ് ചാരിറ്റബിൾ ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1478.jpeg",
    },
    {
      src: "assets/img/Pastevents/1479.jpeg",
      caption:
        "കുളത്തൂർ മുസ്ലിം ജുമാ മസ്ജിദ് ചാരിറ്റബിൾ ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1479.jpeg",
    },

    {
      src: "assets/img/Pastevents/1450.jpeg",
      caption:
        "സീ പോർട്സ് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1450.jpeg",
    },
    {
      src: "assets/img/Pastevents/1451.jpeg",
      caption:
        "സീ പോർട്സ് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1451.jpeg",
    },
    {
      src: "assets/img/Pastevents/1452.jpeg",
      caption:
        "സീ പോർട്സ് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1452.jpeg",
    },
    {
      src: "assets/img/Pastevents/1453.jpeg",
      caption:
        "സീ പോർട്സ് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1453.jpeg",
    },
    {
      src: "assets/img/Pastevents/1454.jpeg",
      caption:
        "സീ പോർട്സ് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1454.jpeg",
    },
    {
      src: "assets/img/Pastevents/1455.jpeg",
      caption:
        "സീ പോർട്സ് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1455.jpeg",
    },
    {
      src: "assets/img/Pastevents/1456.jpeg",
      caption:
        "സീ പോർട്സ് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1456.jpeg",
    },
    {
      src: "assets/img/Pastevents/1420.jpeg",
      caption:
        "അരുവിയോട് താളത്രേയം കലാ സാംസ്കാരിക വേദി, ട്രിവാൻഡ്രം റെയിൻബോ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1420.jpeg",
    },
    {
      src: "assets/img/Pastevents/1421.jpeg",
      caption:
        "അരുവിയോട് താളത്രേയം കലാ സാംസ്കാരിക വേദി, ട്രിവാൻഡ്രം റെയിൻബോ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1421.jpeg",
    },
    {
      src: "assets/img/Pastevents/1422.jpeg",
      caption:
        "അരുവിയോട് താളത്രേയം കലാ സാംസ്കാരിക വേദി, ട്രിവാൻഡ്രം റെയിൻബോ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1422.jpeg",
    },
    {
      src: "assets/img/Pastevents/1423.jpeg",
      caption:
        "അരുവിയോട് താളത്രേയം കലാ സാംസ്കാരിക വേദി, ട്രിവാൻഡ്രം റെയിൻബോ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1423.jpeg",
    },
    {
      src: "assets/img/Pastevents/1424.jpeg",
      caption:
        "അരുവിയോട് താളത്രേയം കലാ സാംസ്കാരിക വേദി, ട്രിവാൻഡ്രം റെയിൻബോ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1424.jpeg",
    },
    {
      src: "assets/img/Pastevents/1425.jpeg",
      caption:
        "അരുവിയോട് താളത്രേയം കലാ സാംസ്കാരിക വേദി, ട്രിവാൻഡ്രം റെയിൻബോ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1425.jpeg",
    },
    {
      src: "assets/img/Pastevents/1426.jpeg",
      caption:
        "ട്രിവാൻഡ്രം രാജധാനി ലയൺസ് ക്ലബ്, ഒയാസിസ് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1426.jpeg",
    },
    {
      src: "assets/img/Pastevents/1427.jpeg",
      caption:
        "ട്രിവാൻഡ്രം രാജധാനി ലയൺസ് ക്ലബ്, ഒയാസിസ് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1427.jpeg",
    },
    {
      src: "assets/img/Pastevents/1428.jpeg",
      caption:
        "ട്രിവാൻഡ്രം രാജധാനി ലയൺസ് ക്ലബ്, ഒയാസിസ് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1428.jpeg",
    },
    {
      src: "assets/img/Pastevents/1429.jpeg",
      caption:
        "ട്രിവാൻഡ്രം രാജധാനി ലയൺസ് ക്ലബ്, ഒയാസിസ് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1429.jpeg",
    },
    {
      src: "assets/img/Pastevents/1430.jpeg",
      caption:
        "ട്രിവാൻഡ്രം രാജധാനി ലയൺസ് ക്ലബ്, ഒയാസിസ് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1430.jpeg",
    },
    {
      src: "assets/img/Pastevents/1431.jpeg",
      caption:
        "സ്വാമിയാർമഠം ഇന്ത്യൻ നാഷണൽ യൂത്ത് കോൺഗ്രസിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1431.jpeg",
    },
    {
      src: "assets/img/Pastevents/1432.jpeg",
      caption:
        "സ്വാമിയാർമഠം ഇന്ത്യൻ നാഷണൽ യൂത്ത് കോൺഗ്രസിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1432.jpeg",
    },
    {
      src: "assets/img/Pastevents/1433.jpeg",
      caption:
        "സ്വാമിയാർമഠം ഇന്ത്യൻ നാഷണൽ യൂത്ത് കോൺഗ്രസിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1433.jpeg",
    },
    {
      src: "assets/img/Pastevents/1434.jpeg",
      caption:
        "സ്വാമിയാർമഠം ഇന്ത്യൻ നാഷണൽ യൂത്ത് കോൺഗ്രസിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1434.jpeg",
    },
    {
      src: "assets/img/Pastevents/1435.jpeg",
      caption:
        "സ്വാമിയാർമഠം ഇന്ത്യൻ നാഷണൽ യൂത്ത് കോൺഗ്രസിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1435.jpeg",
    },
    {
      src: "assets/img/Pastevents/1436.jpeg",
      caption:
        "പേട്ട ഗവ: ഹയർ സെക്കൻഡറി സ്കൂൾ, റോട്ടറി  ട്രിവാൻഡ്രം ക്ലബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ  മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1436.jpeg",
    },
    {
      src: "assets/img/Pastevents/1437.jpeg",
      caption:
        "പേട്ട ഗവ: ഹയർ സെക്കൻഡറി സ്കൂൾ, റോട്ടറി  ട്രിവാൻഡ്രം ക്ലബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ  മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1437.jpeg",
    },
    {
      src: "assets/img/Pastevents/1438.jpeg",
      caption:
        "പേട്ട ഗവ: ഹയർ സെക്കൻഡറി സ്കൂൾ, റോട്ടറി  ട്രിവാൻഡ്രം ക്ലബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ  മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1438.jpeg",
    },
    {
      src: "assets/img/Pastevents/1439.jpeg",
      caption:
        "പേട്ട ഗവ: ഹയർ സെക്കൻഡറി സ്കൂൾ, റോട്ടറി  ട്രിവാൻഡ്രം ക്ലബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ  മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1439.jpeg",
    },
    {
      src: "assets/img/Pastevents/1440.jpeg",
      caption:
        "പേട്ട ഗവ: ഹയർ സെക്കൻഡറി സ്കൂൾ, റോട്ടറി  ട്രിവാൻഡ്രം ക്ലബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ  മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1440.jpeg",
    },
    {
      src: "assets/img/Pastevents/1441.jpeg",
      caption:
        "പേട്ട ഗവ: ഹയർ സെക്കൻഡറി സ്കൂൾ, റോട്ടറി  ട്രിവാൻഡ്രം ക്ലബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ  മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1441.jpeg",
    },
    {
      src: "assets/img/Pastevents/1442.jpeg",
      caption:
        "പേട്ട ഗവ: ഹയർ സെക്കൻഡറി സ്കൂൾ, റോട്ടറി  ട്രിവാൻഡ്രം ക്ലബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ  മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1442.jpeg",
    },
    {
      src: "assets/img/Pastevents/1443.jpeg",
      caption:
        "കന്യായകുമാരി സൃദ്ധി ശ്രീ സായി ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1443.jpeg",
    },
    {
      src: "assets/img/Pastevents/1444.jpeg",
      caption:
        "കന്യായകുമാരി സൃദ്ധി ശ്രീ സായി ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1444.jpeg",
    },
    {
      src: "assets/img/Pastevents/1445.jpeg",
      caption:
        "കന്യായകുമാരി സൃദ്ധി ശ്രീ സായി ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1445.jpeg",
    },
    {
      src: "assets/img/Pastevents/1446.jpeg",
      caption:
        "കന്യായകുമാരി സൃദ്ധി ശ്രീ സായി ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1446.jpeg",
    },
    {
      src: "assets/img/Pastevents/1447.jpeg",
      caption:
        "കന്യായകുമാരി സൃദ്ധി ശ്രീ സായി ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1447.jpeg",
    },
    {
      src: "assets/img/Pastevents/1448.jpeg",
      caption:
        "കന്യായകുമാരി സൃദ്ധി ശ്രീ സായി ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1448.jpeg",
    },
    {
      src: "assets/img/Pastevents/1449.jpeg",
      caption:
        "കന്യായകുമാരി സൃദ്ധി ശ്രീ സായി ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1449.jpeg",
    },

    {
      src: "assets/img/Pastevents/1415.jpeg",
      caption:
        "നെട്ടയം ARR സ്കൂൾ,വട്ടിയൂർക്കാവ് മോഡൽ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1415.jpeg",
    },
    {
      src: "assets/img/Pastevents/1416.jpeg",
      caption:
        "നെട്ടയം ARR സ്കൂൾ,വട്ടിയൂർക്കാവ് മോഡൽ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1416.jpeg",
    },
    {
      src: "assets/img/Pastevents/1417.jpeg",
      caption:
        "നെട്ടയം ARR സ്കൂൾ,വട്ടിയൂർക്കാവ് മോഡൽ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1417.jpeg",
    },
    {
      src: "assets/img/Pastevents/1418.jpeg",
      caption:
        "നെട്ടയം ARR സ്കൂൾ,വട്ടിയൂർക്കാവ് മോഡൽ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1418.jpeg",
    },
    {
      src: "assets/img/Pastevents/1419.jpeg",
      caption:
        "നെട്ടയം ARR സ്കൂൾ,വട്ടിയൂർക്കാവ് മോഡൽ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1419.jpeg",
    },
    {
      src: "assets/img/Pastevents/1410.jpeg",
      caption:
        "ഖബറടി മുസ്ലിം ജുമാ അത്ത് പാലിയേറ്റിവ് ഫൗണ്ടേഷനും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ഉദ്ഘാടനം: ശ്രീ സജീഷ് (SHO മംഗലപുരം)",
      thumb: "assets/img/Pastevents/1410.jpeg",
    },
    {
      src: "assets/img/Pastevents/1411.jpeg",
      caption:
        "ഖബറടി മുസ്ലിം ജുമാ അത്ത് പാലിയേറ്റിവ് ഫൗണ്ടേഷനും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ",
      thumb: "assets/img/Pastevents/1411.jpeg",
    },
    {
      src: "assets/img/Pastevents/1412.jpeg",
      caption:
        "ഖബറടി മുസ്ലിം ജുമാ അത്ത് പാലിയേറ്റിവ് ഫൗണ്ടേഷനും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ",
      thumb: "assets/img/Pastevents/1412.jpeg",
    },
    {
      src: "assets/img/Pastevents/1413.jpeg",
      caption:
        "ഖബറടി മുസ്ലിം ജുമാ അത്ത് പാലിയേറ്റിവ് ഫൗണ്ടേഷനും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ",
      thumb: "assets/img/Pastevents/1413.jpeg",
    },
    {
      src: "assets/img/Pastevents/1414.jpeg",
      caption:
        "ഖബറടി മുസ്ലിം ജുമാ അത്ത് പാലിയേറ്റിവ് ഫൗണ്ടേഷനും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ",
      thumb: "assets/img/Pastevents/1414.jpeg",
    },
    {
      src: "assets/img/Pastevents/1405.jpeg",
      caption:
        "മലയം എൻഎസ്എസ് കരയോഗം യുണിറ്റ്,ട്രിവാൻഡ്രം ജെംസ് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1405.jpeg",
    },
    {
      src: "assets/img/Pastevents/1406.jpeg",
      caption:
        "മലയം എൻഎസ്എസ് കരയോഗം യുണിറ്റ്,ട്രിവാൻഡ്രം ജെംസ് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1406.jpeg",
    },
    {
      src: "assets/img/Pastevents/1407.jpeg",
      caption:
        "മലയം എൻഎസ്എസ് കരയോഗം യുണിറ്റ്,ട്രിവാൻഡ്രം ജെംസ് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1407.jpeg",
    },
    {
      src: "assets/img/Pastevents/1408.jpeg",
      caption:
        "മലയം എൻഎസ്എസ് കരയോഗം യുണിറ്റ്,ട്രിവാൻഡ്രം ജെംസ് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1408.jpeg",
    },
    {
      src: "assets/img/Pastevents/1409.jpeg",
      caption:
        "മലയം എൻഎസ്എസ് കരയോഗം യുണിറ്റ്,ട്രിവാൻഡ്രം ജെംസ് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1409.jpeg",
    },
    {
      src: "assets/img/Pastevents/1399.jpeg",
      caption:
        "ലയൺസ് ഇൻ്റർനാഷണൽ ട്രിവാൻഡ്രം ക്ലബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1399.jpeg",
    },
    {
      src: "assets/img/Pastevents/1400.jpeg",
      caption:
        "ലയൺസ് ഇൻ്റർനാഷണൽ ട്രിവാൻഡ്രം ക്ലബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1400.jpeg",
    },
    {
      src: "assets/img/Pastevents/1401.jpeg",
      caption:
        "ലയൺസ് ഇൻ്റർനാഷണൽ ട്രിവാൻഡ്രം ക്ലബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1401.jpeg",
    },
    {
      src: "assets/img/Pastevents/1402.jpeg",
      caption:
        "ലയൺസ് ഇൻ്റർനാഷണൽ ട്രിവാൻഡ്രം ക്ലബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1402.jpeg",
    },
    {
      src: "assets/img/Pastevents/1403.jpeg",
      caption:
        "ലയൺസ് ഇൻ്റർനാഷണൽ ട്രിവാൻഡ്രം ക്ലബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1403.jpeg",
    },
    {
      src: "assets/img/Pastevents/1404.jpeg",
      caption:
        "ലയൺസ് ഇൻ്റർനാഷണൽ ട്രിവാൻഡ്രം ക്ലബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1404.jpeg",
    },
    {
      src: "assets/img/Pastevents/1391.jpeg",
      caption:
        "നാട്ടൊരുമ പനവൂർ ഏരിയാ കമ്മിറ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1391.jpeg",
    },
    {
      src: "assets/img/Pastevents/1392.jpeg",
      caption:
        "നാട്ടൊരുമ പനവൂർ ഏരിയാ കമ്മിറ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1392.jpeg",
    },
    {
      src: "assets/img/Pastevents/1393.jpeg",
      caption:
        "നാട്ടൊരുമ പനവൂർ ഏരിയാ കമ്മിറ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1393.jpeg",
    },
    {
      src: "assets/img/Pastevents/1394.jpeg",
      caption:
        "നാട്ടൊരുമ പനവൂർ ഏരിയാ കമ്മിറ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1394.jpeg",
    },
    {
      src: "assets/img/Pastevents/1395.jpeg",
      caption:
        "നാട്ടൊരുമ പനവൂർ ഏരിയാ കമ്മിറ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1395.jpeg",
    },
    {
      src: "assets/img/Pastevents/1396.jpeg",
      caption:
        "നാട്ടൊരുമ പനവൂർ ഏരിയാ കമ്മിറ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1396.jpeg",
    },
    {
      src: "assets/img/Pastevents/1397.jpeg",
      caption:
        "നാട്ടൊരുമ പനവൂർ ഏരിയാ കമ്മിറ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1397.jpeg",
    },
    {
      src: "assets/img/Pastevents/1398.jpeg",
      caption:
        "നാട്ടൊരുമ പനവൂർ ഏരിയാ കമ്മിറ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1398.jpeg",
    },
    {
      src: "assets/img/Pastevents/1383.jpeg",
      caption:
        "ഇടയ്ക്കോട് വിവേകാനന്ദ സേവാസമിതി, ക്രിസ്റ്റൽ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1383.jpeg",
    },
    {
      src: "assets/img/Pastevents/1384.jpeg",
      caption:
        "ഇടയ്ക്കോട് വിവേകാനന്ദ സേവാസമിതി, ക്രിസ്റ്റൽ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1384.jpeg",
    },
    {
      src: "assets/img/Pastevents/1385.jpeg",
      caption:
        "ഇടയ്ക്കോട് വിവേകാനന്ദ സേവാസമിതി, ക്രിസ്റ്റൽ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1385.jpeg",
    },
    {
      src: "assets/img/Pastevents/1386.jpeg",
      caption:
        "ഇടയ്ക്കോട് വിവേകാനന്ദ സേവാസമിതി, ക്രിസ്റ്റൽ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1386.jpeg",
    },
    {
      src: "assets/img/Pastevents/1387.jpeg",
      caption:
        "ഇടയ്ക്കോട് വിവേകാനന്ദ സേവാസമിതി, ക്രിസ്റ്റൽ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1387.jpeg",
    },
    {
      src: "assets/img/Pastevents/1388.jpeg",
      caption:
        "ഇടയ്ക്കോട് വിവേകാനന്ദ സേവാസമിതി, ക്രിസ്റ്റൽ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1388.jpeg",
    },
    {
      src: "assets/img/Pastevents/1389.jpeg",
      caption:
        "ഇടയ്ക്കോട് വിവേകാനന്ദ സേവാസമിതി, ക്രിസ്റ്റൽ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1389.jpeg",
    },
    {
      src: "assets/img/Pastevents/1390.jpeg",
      caption:
        "ഇടയ്ക്കോട് വിവേകാനന്ദ സേവാസമിതി, ക്രിസ്റ്റൽ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1390.jpeg",
    },
    {
      src: "assets/img/Pastevents/1365.jpeg",
      caption:
        "ഐഡിഎഫ്‌സി ഫസ്റ്റ് ഭാരത് ബാങ്ക് നെടുമങ്ങാട് ബ്രാഞ്ചിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1365.jpeg",
    },
    {
      src: "assets/img/Pastevents/1366.jpeg",
      caption:
        "ഐഡിഎഫ്‌സി ഫസ്റ്റ് ഭാരത് ബാങ്ക് നെടുമങ്ങാട് ബ്രാഞ്ചിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1366.jpeg",
    },
    {
      src: "assets/img/Pastevents/1367.jpeg",
      caption:
        "ഐഡിഎഫ്‌സി ഫസ്റ്റ് ഭാരത് ബാങ്ക് നെടുമങ്ങാട് ബ്രാഞ്ചിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1367.jpeg",
    },
    {
      src: "assets/img/Pastevents/1368.jpeg",
      caption:
        "ഐഡിഎഫ്‌സി ഫസ്റ്റ് ഭാരത് ബാങ്ക് നെടുമങ്ങാട് ബ്രാഞ്ചിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1368.jpeg",
    },
    {
      src: "assets/img/Pastevents/1369.jpeg",
      caption:
        "ഐഡിഎഫ്‌സി ഫസ്റ്റ് ഭാരത് ബാങ്ക് നെടുമങ്ങാട് ബ്രാഞ്ചിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1369.jpeg",
    },
    {
      src: "assets/img/Pastevents/1370.jpeg",
      caption:
        "ഐഡിഎഫ്‌സി ഫസ്റ്റ് ഭാരത് ബാങ്ക് നെടുമങ്ങാട് ബ്രാഞ്ചിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1370.jpeg",
    },
    {
      src: "assets/img/Pastevents/1371.jpeg",
      caption:
        "കല്ലുവെട്ടാൻകുഴി പുലരി റെസിഡൻഷ്യൽ അസോസിയേഷൻ, വെങ്ങാനൂർ ലയൺസ് ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1371.jpeg",
    },
    {
      src: "assets/img/Pastevents/1372.jpeg",
      caption:
        "കല്ലുവെട്ടാൻകുഴി പുലരി റെസിഡൻഷ്യൽ അസോസിയേഷൻ, വെങ്ങാനൂർ ലയൺസ് ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1372.jpeg",
    },
    {
      src: "assets/img/Pastevents/1373.jpeg",
      caption:
        "കല്ലുവെട്ടാൻകുഴി പുലരി റെസിഡൻഷ്യൽ അസോസിയേഷൻ, വെങ്ങാനൂർ ലയൺസ് ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1373.jpeg",
    },
    {
      src: "assets/img/Pastevents/1374.jpeg",
      caption:
        "കല്ലുവെട്ടാൻകുഴി പുലരി റെസിഡൻഷ്യൽ അസോസിയേഷൻ, വെങ്ങാനൂർ ലയൺസ് ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1374.jpeg",
    },
    {
      src: "assets/img/Pastevents/1375.jpeg",
      caption:
        "കല്ലുവെട്ടാൻകുഴി പുലരി റെസിഡൻഷ്യൽ അസോസിയേഷൻ, വെങ്ങാനൂർ ലയൺസ് ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1375.jpeg",
    },
    {
      src: "assets/img/Pastevents/1376.jpeg",
      caption:
        "കല്ലുവെട്ടാൻകുഴി പുലരി റെസിഡൻഷ്യൽ അസോസിയേഷൻ, വെങ്ങാനൂർ ലയൺസ് ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1376.jpeg",
    },
    {
      src: "assets/img/Pastevents/1377.jpeg",
      caption:
        "എസ് എൻ ഡീ പി യൂണിറ്റ് മുട്ടയ്ക്കാട്, ലയൺസ് ക്ലബ് വെങ്ങാനൂർ യൂണിറ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1377.jpeg",
    },
    {
      src: "assets/img/Pastevents/1378.jpeg",
      caption:
        "എസ് എൻ ഡീ പി യൂണിറ്റ് മുട്ടയ്ക്കാട്, ലയൺസ് ക്ലബ് വെങ്ങാനൂർ യൂണിറ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1378.jpeg",
    },
    {
      src: "assets/img/Pastevents/1379.jpeg",
      caption:
        "എസ് എൻ ഡീ പി യൂണിറ്റ് മുട്ടയ്ക്കാട്, ലയൺസ് ക്ലബ് വെങ്ങാനൂർ യൂണിറ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1379.jpeg",
    },
    {
      src: "assets/img/Pastevents/1380.jpeg",
      caption:
        "എസ് എൻ ഡീ പി യൂണിറ്റ് മുട്ടയ്ക്കാട്, ലയൺസ് ക്ലബ് വെങ്ങാനൂർ യൂണിറ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1380.jpeg",
    },
    {
      src: "assets/img/Pastevents/1381.jpeg",
      caption:
        "എസ് എൻ ഡീ പി യൂണിറ്റ് മുട്ടയ്ക്കാട്, ലയൺസ് ക്ലബ് വെങ്ങാനൂർ യൂണിറ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1381.jpeg",
    },
    {
      src: "assets/img/Pastevents/1382.jpeg",
      caption:
        "എസ് എൻ ഡീ പി യൂണിറ്റ് മുട്ടയ്ക്കാട്, ലയൺസ് ക്ലബ് വെങ്ങാനൂർ യൂണിറ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1382.jpeg",
    },

    {
      src: "assets/img/Pastevents/1354.jpeg",
      caption:
        "മലങ്കര കാത്തോലിക് അസോസിയേഷൻ്റയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ആരോഗ്യ - മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി, ഗ്യാസ്ട്രാ, ഗൈനെക്, ഓർത്തോ, ഇ എൻ റ്റി, ഡയബറ്റിക്, ഒപ്താൽ, ഡെൻ്റൽ എന്നീ വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി. ",
      thumb: "assets/img/Pastevents/1354.jpeg",
    },
    {
      src: "assets/img/Pastevents/1355.jpeg",
      caption:
        "മലങ്കര കാത്തോലിക് അസോസിയേഷൻ്റയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ആരോഗ്യ - മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി, ഗ്യാസ്ട്രാ, ഗൈനെക്, ഓർത്തോ, ഇ എൻ റ്റി, ഡയബറ്റിക്, ഒപ്താൽ, ഡെൻ്റൽ എന്നീ വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി. ",
      thumb: "assets/img/Pastevents/1355.jpeg",
    },
    {
      src: "assets/img/Pastevents/1356.jpeg",
      caption:
        "മലങ്കര കാത്തോലിക് അസോസിയേഷൻ്റയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ആരോഗ്യ - മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി, ഗ്യാസ്ട്രാ, ഗൈനെക്, ഓർത്തോ, ഇ എൻ റ്റി, ഡയബറ്റിക്, ഒപ്താൽ, ഡെൻ്റൽ എന്നീ വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി. ",
      thumb: "assets/img/Pastevents/1356.jpeg",
    },
    {
      src: "assets/img/Pastevents/1357.jpeg",
      caption:
        "മലങ്കര കാത്തോലിക് അസോസിയേഷൻ്റയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ആരോഗ്യ - മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി, ഗ്യാസ്ട്രാ, ഗൈനെക്, ഓർത്തോ, ഇ എൻ റ്റി, ഡയബറ്റിക്, ഒപ്താൽ, ഡെൻ്റൽ എന്നീ വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി. ",
      thumb: "assets/img/Pastevents/1357.jpeg",
    },
    {
      src: "assets/img/Pastevents/1358.jpeg",
      caption:
        "മലങ്കര കാത്തോലിക് അസോസിയേഷൻ്റയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ആരോഗ്യ - മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി, ഗ്യാസ്ട്രാ, ഗൈനെക്, ഓർത്തോ, ഇ എൻ റ്റി, ഡയബറ്റിക്, ഒപ്താൽ, ഡെൻ്റൽ എന്നീ വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി. ",
      thumb: "assets/img/Pastevents/1358.jpeg",
    },
    {
      src: "assets/img/Pastevents/1359.jpeg",
      caption:
        "മലങ്കര കാത്തോലിക് അസോസിയേഷൻ്റയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ആരോഗ്യ - മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി, ഗ്യാസ്ട്രാ, ഗൈനെക്, ഓർത്തോ, ഇ എൻ റ്റി, ഡയബറ്റിക്, ഒപ്താൽ, ഡെൻ്റൽ എന്നീ വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി. ",
      thumb: "assets/img/Pastevents/1359.jpeg",
    },
    {
      src: "assets/img/Pastevents/1360.jpeg",
      caption:
        "മലങ്കര കാത്തോലിക് അസോസിയേഷൻ്റയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ആരോഗ്യ - മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി, ഗ്യാസ്ട്രാ, ഗൈനെക്, ഓർത്തോ, ഇ എൻ റ്റി, ഡയബറ്റിക്, ഒപ്താൽ, ഡെൻ്റൽ എന്നീ വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി. ",
      thumb: "assets/img/Pastevents/1360.jpeg",
    },
    {
      src: "assets/img/Pastevents/1361.jpeg",
      caption:
        "മലങ്കര കാത്തോലിക് അസോസിയേഷൻ്റയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ആരോഗ്യ - മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി, ഗ്യാസ്ട്രാ, ഗൈനെക്, ഓർത്തോ, ഇ എൻ റ്റി, ഡയബറ്റിക്, ഒപ്താൽ, ഡെൻ്റൽ എന്നീ വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി. ",
      thumb: "assets/img/Pastevents/1361.jpeg",
    },
    {
      src: "assets/img/Pastevents/1362.jpeg",
      caption:
        "മലങ്കര കാത്തോലിക് അസോസിയേഷൻ്റയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ആരോഗ്യ - മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി, ഗ്യാസ്ട്രാ, ഗൈനെക്, ഓർത്തോ, ഇ എൻ റ്റി, ഡയബറ്റിക്, ഒപ്താൽ, ഡെൻ്റൽ എന്നീ വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി. ",
      thumb: "assets/img/Pastevents/1362.jpeg",
    },
    {
      src: "assets/img/Pastevents/1363.jpeg",
      caption:
        "മലങ്കര കാത്തോലിക് അസോസിയേഷൻ്റയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ആരോഗ്യ - മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി, ഗ്യാസ്ട്രാ, ഗൈനെക്, ഓർത്തോ, ഇ എൻ റ്റി, ഡയബറ്റിക്, ഒപ്താൽ, ഡെൻ്റൽ എന്നീ വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി. ",
      thumb: "assets/img/Pastevents/1363.jpeg",
    },
    {
      src: "assets/img/Pastevents/1364.jpeg",
      caption:
        "മലങ്കര കാത്തോലിക് അസോസിയേഷൻ്റയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ആരോഗ്യ - മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി, ഗ്യാസ്ട്രാ, ഗൈനെക്, ഓർത്തോ, ഇ എൻ റ്റി, ഡയബറ്റിക്, ഒപ്താൽ, ഡെൻ്റൽ എന്നീ വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി. ",
      thumb: "assets/img/Pastevents/1364.jpeg",
    },
    {
      src: "assets/img/Pastevents/1347.jpeg",
      caption:
        "KSRTC പുതുതായി ആരംഭിച്ച ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 100-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1347.jpeg",
    },
    {
      src: "assets/img/Pastevents/1348.jpeg",
      caption:
        "KSRTC പുതുതായി ആരംഭിച്ച ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 100-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1348.jpeg",
    },
    {
      src: "assets/img/Pastevents/1349.jpeg",
      caption:
        "KSRTC പുതുതായി ആരംഭിച്ച ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 100-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1349.jpeg",
    },
    {
      src: "assets/img/Pastevents/1350.jpeg",
      caption:
        "KSRTC പുതുതായി ആരംഭിച്ച ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 100-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1350.jpeg",
    },
    {
      src: "assets/img/Pastevents/1351.jpeg",
      caption:
        "KSRTC പുതുതായി ആരംഭിച്ച ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 100-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1351.jpeg",
    },
    {
      src: "assets/img/Pastevents/1352.jpeg",
      caption:
        "KSRTC പുതുതായി ആരംഭിച്ച ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 100-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1352.jpeg",
    },
    {
      src: "assets/img/Pastevents/1353.jpeg",
      caption:
        "KSRTC പുതുതായി ആരംഭിച്ച ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 100-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1353.jpeg",
    },
    {
      src: "assets/img/Pastevents/1335.jpeg",
      caption:
        "ശ്രീ ദുർഗ്ഗാ ദേവി ക്ഷേത്ര ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1335.jpeg",
    },
    {
      src: "assets/img/Pastevents/1336.jpeg",
      caption:
        "ശ്രീ ദുർഗ്ഗാ ദേവി ക്ഷേത്ര ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1336.jpeg",
    },
    {
      src: "assets/img/Pastevents/1337.jpeg",
      caption:
        "ശ്രീ ദുർഗ്ഗാ ദേവി ക്ഷേത്ര ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1337.jpeg",
    },
    {
      src: "assets/img/Pastevents/1338.jpeg",
      caption:
        "ശ്രീ ദുർഗ്ഗാ ദേവി ക്ഷേത്ര ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1338.jpeg",
    },
    {
      src: "assets/img/Pastevents/1339.jpeg",
      caption:
        "ശ്രീ ദുർഗ്ഗാ ദേവി ക്ഷേത്ര ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1339.jpeg",
    },
    {
      src: "assets/img/Pastevents/1340.jpeg",
      caption:
        "ശ്രീ ദുർഗ്ഗാ ദേവി ക്ഷേത്ര ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1340.jpeg",
    },
    {
      src: "assets/img/Pastevents/1341.jpeg",
      caption:
        "(രണ്ടാം ദിനം) ഗവ: എച്ച് എസ് ഉത്തരംക്കോട് ട്രൈബൽ സ്കൂളിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.തുടർച്ചയായ ഓൺലൈൻ പഠനത്തിന്റെ ഭാഗമായി കുട്ടികൾക്ക് ഉണ്ടായെക്കാവുന്ന കാഴ്ച, കേൾവി തകരാറുകൾ തുടക്കത്തിലേ കണ്ടെത്തുന്നതിൻ്റെ ഭാഗമായി ജനറൽ സ്ക്രീനിംഗ്, കാഴ്ച, കേൾവി , ഡെൻ്റൽ പരിശോധന നടത്തി.",
      thumb: "assets/img/Pastevents/1341.jpeg",
    },
    {
      src: "assets/img/Pastevents/1342.jpeg",
      caption:
        "(രണ്ടാം ദിനം) ഗവ: എച്ച് എസ് ഉത്തരംക്കോട് ട്രൈബൽ സ്കൂളിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.തുടർച്ചയായ ഓൺലൈൻ പഠനത്തിന്റെ ഭാഗമായി കുട്ടികൾക്ക് ഉണ്ടായെക്കാവുന്ന കാഴ്ച, കേൾവി തകരാറുകൾ തുടക്കത്തിലേ കണ്ടെത്തുന്നതിൻ്റെ ഭാഗമായി ജനറൽ സ്ക്രീനിംഗ്, കാഴ്ച, കേൾവി , ഡെൻ്റൽ പരിശോധന നടത്തി.",
      thumb: "assets/img/Pastevents/1342.jpeg",
    },
    {
      src: "assets/img/Pastevents/1343.jpeg",
      caption:
        "(രണ്ടാം ദിനം) ഗവ: എച്ച് എസ് ഉത്തരംക്കോട് ട്രൈബൽ സ്കൂളിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.തുടർച്ചയായ ഓൺലൈൻ പഠനത്തിന്റെ ഭാഗമായി കുട്ടികൾക്ക് ഉണ്ടായെക്കാവുന്ന കാഴ്ച, കേൾവി തകരാറുകൾ തുടക്കത്തിലേ കണ്ടെത്തുന്നതിൻ്റെ ഭാഗമായി ജനറൽ സ്ക്രീനിംഗ്, കാഴ്ച, കേൾവി , ഡെൻ്റൽ പരിശോധന നടത്തി.",
      thumb: "assets/img/Pastevents/1343.jpeg",
    },
    {
      src: "assets/img/Pastevents/1344.jpeg",
      caption:
        "(രണ്ടാം ദിനം) ഗവ: എച്ച് എസ് ഉത്തരംക്കോട് ട്രൈബൽ സ്കൂളിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.തുടർച്ചയായ ഓൺലൈൻ പഠനത്തിന്റെ ഭാഗമായി കുട്ടികൾക്ക് ഉണ്ടായെക്കാവുന്ന കാഴ്ച, കേൾവി തകരാറുകൾ തുടക്കത്തിലേ കണ്ടെത്തുന്നതിൻ്റെ ഭാഗമായി ജനറൽ സ്ക്രീനിംഗ്, കാഴ്ച, കേൾവി , ഡെൻ്റൽ പരിശോധന നടത്തി.",
      thumb: "assets/img/Pastevents/1344.jpeg",
    },
    {
      src: "assets/img/Pastevents/1345.jpeg",
      caption:
        "(രണ്ടാം ദിനം) ഗവ: എച്ച് എസ് ഉത്തരംക്കോട് ട്രൈബൽ സ്കൂളിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.തുടർച്ചയായ ഓൺലൈൻ പഠനത്തിന്റെ ഭാഗമായി കുട്ടികൾക്ക് ഉണ്ടായെക്കാവുന്ന കാഴ്ച, കേൾവി തകരാറുകൾ തുടക്കത്തിലേ കണ്ടെത്തുന്നതിൻ്റെ ഭാഗമായി ജനറൽ സ്ക്രീനിംഗ്, കാഴ്ച, കേൾവി , ഡെൻ്റൽ പരിശോധന നടത്തി.",
      thumb: "assets/img/Pastevents/1345.jpeg",
    },
    {
      src: "assets/img/Pastevents/1346.jpeg",
      caption:
        "(രണ്ടാം ദിനം) ഗവ: എച്ച് എസ് ഉത്തരംക്കോട് ട്രൈബൽ സ്കൂളിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.തുടർച്ചയായ ഓൺലൈൻ പഠനത്തിന്റെ ഭാഗമായി കുട്ടികൾക്ക് ഉണ്ടായെക്കാവുന്ന കാഴ്ച, കേൾവി തകരാറുകൾ തുടക്കത്തിലേ കണ്ടെത്തുന്നതിൻ്റെ ഭാഗമായി ജനറൽ സ്ക്രീനിംഗ്, കാഴ്ച, കേൾവി , ഡെൻ്റൽ പരിശോധന നടത്തി.",
      thumb: "assets/img/Pastevents/1346.jpeg",
    },
    {
      src: "assets/img/Pastevents/1328.jpeg",
      caption:
        "ഏലിയാപുരം  കർമലമാത ചർച്ചിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ അഡ്വ ജി സ്റ്റീഫൻ(എം എൽ എ)",
      thumb: "assets/img/Pastevents/1328.jpeg",
    },
    {
      src: "assets/img/Pastevents/1329.jpeg",
      caption:
        "ഏലിയാപുരം  കർമലമാത ചർച്ചിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1329.jpeg",
    },
    {
      src: "assets/img/Pastevents/1330.jpeg",
      caption:
        "ഏലിയാപുരം  കർമലമാത ചർച്ചിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1330.jpeg",
    },
    {
      src: "assets/img/Pastevents/1331.jpeg",
      caption:
        "ഏലിയാപുരം  കർമലമാത ചർച്ചിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1331.jpeg",
    },
    {
      src: "assets/img/Pastevents/1332.jpeg",
      caption:
        "ഏലിയാപുരം  കർമലമാത ചർച്ചിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1332.jpeg",
    },
    {
      src: "assets/img/Pastevents/1333.jpeg",
      caption:
        "ഏലിയാപുരം  കർമലമാത ചർച്ചിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1333.jpeg",
    },
    {
      src: "assets/img/Pastevents/1334.jpeg",
      caption:
        "ഏലിയാപുരം  കർമലമാത ചർച്ചിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1334.jpeg",
    },
    {
      src: "assets/img/Pastevents/1322.jpeg",
      caption:
        "ശ്രീ കൊട്ടരത്ത് ദേവി ക്ഷേത്ര ട്രുസ്റ്റും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ അഡ്വ: ജി സ്റ്റീഫൻ (MLA)",
      thumb: "assets/img/Pastevents/1322.jpeg",
    },
    {
      src: "assets/img/Pastevents/1323.jpeg",
      caption:
        "ശ്രീ കൊട്ടരത്ത് ദേവി ക്ഷേത്ര ട്രുസ്റ്റും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ അഡ്വ: ജി സ്റ്റീഫൻ (MLA)",
      thumb: "assets/img/Pastevents/1323.jpeg",
    },
    {
      src: "assets/img/Pastevents/1324.jpeg",
      caption:
        "ശ്രീ കൊട്ടരത്ത് ദേവി ക്ഷേത്ര ട്രുസ്റ്റും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ അഡ്വ: ജി സ്റ്റീഫൻ (MLA)",
      thumb: "assets/img/Pastevents/1324.jpeg",
    },
    {
      src: "assets/img/Pastevents/1325.jpeg",
      caption:
        "ശ്രീ കൊട്ടരത്ത് ദേവി ക്ഷേത്ര ട്രുസ്റ്റും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ അഡ്വ: ജി സ്റ്റീഫൻ (MLA)",
      thumb: "assets/img/Pastevents/1325.jpeg",
    },
    {
      src: "assets/img/Pastevents/1326.jpeg",
      caption:
        "ശ്രീ കൊട്ടരത്ത് ദേവി ക്ഷേത്ര ട്രുസ്റ്റും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ അഡ്വ: ജി സ്റ്റീഫൻ (MLA)",
      thumb: "assets/img/Pastevents/1326.jpeg",
    },
    {
      src: "assets/img/Pastevents/1327.jpeg",
      caption:
        "ശ്രീ കൊട്ടരത്ത് ദേവി ക്ഷേത്ര ട്രുസ്റ്റും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ അഡ്വ: ജി സ്റ്റീഫൻ (MLA)",
      thumb: "assets/img/Pastevents/1327.jpeg",
    },
    {
      src: "assets/img/Pastevents/1316.jpeg",
      caption:
        "കേരളാ കൗമുദി  ബോധ പൗർണമി പാലോട് യൂണിറ്റ്, ആയിരവല്ലി ക്ഷേത്ര ട്രസ്റ്റും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1316.jpeg",
    },
    {
      src: "assets/img/Pastevents/1317.jpeg",
      caption:
        "കേരളാ കൗമുദി  ബോധ പൗർണമി പാലോട് യൂണിറ്റ്, ആയിരവല്ലി ക്ഷേത്ര ട്രസ്റ്റും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1317.jpeg",
    },
    {
      src: "assets/img/Pastevents/1318.jpeg",
      caption:
        "കേരളാ കൗമുദി  ബോധ പൗർണമി പാലോട് യൂണിറ്റ്, ആയിരവല്ലി ക്ഷേത്ര ട്രസ്റ്റും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1318.jpeg",
    },
    {
      src: "assets/img/Pastevents/1319.jpeg",
      caption:
        "കേരളാ കൗമുദി  ബോധ പൗർണമി പാലോട് യൂണിറ്റ്, ആയിരവല്ലി ക്ഷേത്ര ട്രസ്റ്റും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1319.jpeg",
    },
    {
      src: "assets/img/Pastevents/1320.jpeg",
      caption:
        "കേരളാ കൗമുദി  ബോധ പൗർണമി പാലോട് യൂണിറ്റ്, ആയിരവല്ലി ക്ഷേത്ര ട്രസ്റ്റും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1320.jpeg",
    },
    {
      src: "assets/img/Pastevents/1321.jpeg",
      caption:
        "കേരളാ കൗമുദി  ബോധ പൗർണമി പാലോട് യൂണിറ്റ്, ആയിരവല്ലി ക്ഷേത്ര ട്രസ്റ്റും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1321.jpeg",
    },
    {
      src: "assets/img/Pastevents/1311.jpeg",
      caption:
        "റോട്ടറി ക്ലബ്ബ് തിരുവനന്തപുരം, ഫോർട്ട് ഗേൾസ് മിഷൻ സ്കൂളിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.തുടർച്ചയായ ഓൺലൈൻ പഠനത്തിന്റെ ഭാഗമായി കുട്ടികൾക്ക് ഉണ്ടായെക്കാവുന്ന കാഴ്ച, കേൾവി തകരാറുകൾ തുടക്കത്തിലേ കണ്ടെത്തുന്നതിൻ്റെ ഭാഗമായി ജനറൽ സ്ക്രീനിംഗ്, കാഴ്ച, കേൾവി , ഡെൻ്റൽ പരിശോധന നടത്തി.",
      thumb: "assets/img/Pastevents/1311.jpeg",
    },
    {
      src: "assets/img/Pastevents/1312.jpeg",
      caption:
        "റോട്ടറി ക്ലബ്ബ് തിരുവനന്തപുരം, ഫോർട്ട് ഗേൾസ് മിഷൻ സ്കൂളിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.തുടർച്ചയായ ഓൺലൈൻ പഠനത്തിന്റെ ഭാഗമായി കുട്ടികൾക്ക് ഉണ്ടായെക്കാവുന്ന കാഴ്ച, കേൾവി തകരാറുകൾ തുടക്കത്തിലേ കണ്ടെത്തുന്നതിൻ്റെ ഭാഗമായി ജനറൽ സ്ക്രീനിംഗ്, കാഴ്ച, കേൾവി , ഡെൻ്റൽ പരിശോധന നടത്തി.",
      thumb: "assets/img/Pastevents/1312.jpeg",
    },
    {
      src: "assets/img/Pastevents/1313.jpeg",
      caption:
        "റോട്ടറി ക്ലബ്ബ് തിരുവനന്തപുരം, ഫോർട്ട് ഗേൾസ് മിഷൻ സ്കൂളിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.തുടർച്ചയായ ഓൺലൈൻ പഠനത്തിന്റെ ഭാഗമായി കുട്ടികൾക്ക് ഉണ്ടായെക്കാവുന്ന കാഴ്ച, കേൾവി തകരാറുകൾ തുടക്കത്തിലേ കണ്ടെത്തുന്നതിൻ്റെ ഭാഗമായി ജനറൽ സ്ക്രീനിംഗ്, കാഴ്ച, കേൾവി , ഡെൻ്റൽ പരിശോധന നടത്തി.",
      thumb: "assets/img/Pastevents/1313.jpeg",
    },
    {
      src: "assets/img/Pastevents/1314.jpeg",
      caption:
        "റോട്ടറി ക്ലബ്ബ് തിരുവനന്തപുരം, ഫോർട്ട് ഗേൾസ് മിഷൻ സ്കൂളിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.തുടർച്ചയായ ഓൺലൈൻ പഠനത്തിന്റെ ഭാഗമായി കുട്ടികൾക്ക് ഉണ്ടായെക്കാവുന്ന കാഴ്ച, കേൾവി തകരാറുകൾ തുടക്കത്തിലേ കണ്ടെത്തുന്നതിൻ്റെ ഭാഗമായി ജനറൽ സ്ക്രീനിംഗ്, കാഴ്ച, കേൾവി , ഡെൻ്റൽ പരിശോധന നടത്തി.",
      thumb: "assets/img/Pastevents/1314.jpeg",
    },
    {
      src: "assets/img/Pastevents/1315.jpeg",
      caption:
        "റോട്ടറി ക്ലബ്ബ് തിരുവനന്തപുരം, ഫോർട്ട് ഗേൾസ് മിഷൻ സ്കൂളിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.തുടർച്ചയായ ഓൺലൈൻ പഠനത്തിന്റെ ഭാഗമായി കുട്ടികൾക്ക് ഉണ്ടായെക്കാവുന്ന കാഴ്ച, കേൾവി തകരാറുകൾ തുടക്കത്തിലേ കണ്ടെത്തുന്നതിൻ്റെ ഭാഗമായി ജനറൽ സ്ക്രീനിംഗ്, കാഴ്ച, കേൾവി , ഡെൻ്റൽ പരിശോധന നടത്തി.",
      thumb: "assets/img/Pastevents/1315.jpeg",
    },
    {
      src: "assets/img/Pastevents/1305.jpeg",
      caption:
        "റോട്ടറി ക്ലബ്ബ് തിരുവനന്തപുരം, ഫോർട്ട് ഗേൾസ് മിഷൻ സ്കൂളിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.തുടർച്ചയായ ഓൺലൈൻ പഠനത്തിന്റെ ഭാഗമായി കുട്ടികൾക്ക് ഉണ്ടായെക്കാവുന്ന കാഴ്ച, കേൾവി തകരാറുകൾ തുടക്കത്തിലേ കണ്ടെത്തുന്നതിൻ്റെ ഭാഗമായി ജനറൽ സ്ക്രീനിംഗ്, കാഴ്ച, കേൾവി , ഡെൻ്റൽ പരിശോധന നടത്തി.",
      thumb: "assets/img/Pastevents/1305.jpeg",
    },
    {
      src: "assets/img/Pastevents/1306.jpeg",
      caption:
        "റോട്ടറി ക്ലബ്ബ് തിരുവനന്തപുരം, ഫോർട്ട് ഗേൾസ് മിഷൻ സ്കൂളിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.തുടർച്ചയായ ഓൺലൈൻ പഠനത്തിന്റെ ഭാഗമായി കുട്ടികൾക്ക് ഉണ്ടായെക്കാവുന്ന കാഴ്ച, കേൾവി തകരാറുകൾ തുടക്കത്തിലേ കണ്ടെത്തുന്നതിൻ്റെ ഭാഗമായി ജനറൽ സ്ക്രീനിംഗ്, കാഴ്ച, കേൾവി , ഡെൻ്റൽ പരിശോധന നടത്തി.",
      thumb: "assets/img/Pastevents/1306.jpeg",
    },
    {
      src: "assets/img/Pastevents/1307.jpeg",
      caption:
        "റോട്ടറി ക്ലബ്ബ് തിരുവനന്തപുരം, ഫോർട്ട് ഗേൾസ് മിഷൻ സ്കൂളിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.തുടർച്ചയായ ഓൺലൈൻ പഠനത്തിന്റെ ഭാഗമായി കുട്ടികൾക്ക് ഉണ്ടായെക്കാവുന്ന കാഴ്ച, കേൾവി തകരാറുകൾ തുടക്കത്തിലേ കണ്ടെത്തുന്നതിൻ്റെ ഭാഗമായി ജനറൽ സ്ക്രീനിംഗ്, കാഴ്ച, കേൾവി , ഡെൻ്റൽ പരിശോധന നടത്തി.",
      thumb: "assets/img/Pastevents/1307.jpeg",
    },
    {
      src: "assets/img/Pastevents/1308.jpeg",
      caption:
        "റോട്ടറി ക്ലബ്ബ് തിരുവനന്തപുരം, ഫോർട്ട് ഗേൾസ് മിഷൻ സ്കൂളിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.തുടർച്ചയായ ഓൺലൈൻ പഠനത്തിന്റെ ഭാഗമായി കുട്ടികൾക്ക് ഉണ്ടായെക്കാവുന്ന കാഴ്ച, കേൾവി തകരാറുകൾ തുടക്കത്തിലേ കണ്ടെത്തുന്നതിൻ്റെ ഭാഗമായി ജനറൽ സ്ക്രീനിംഗ്, കാഴ്ച, കേൾവി , ഡെൻ്റൽ പരിശോധന നടത്തി.",
      thumb: "assets/img/Pastevents/1308.jpeg",
    },
    {
      src: "assets/img/Pastevents/1309.jpeg",
      caption:
        "റോട്ടറി ക്ലബ്ബ് തിരുവനന്തപുരം, ഫോർട്ട് ഗേൾസ് മിഷൻ സ്കൂളിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.തുടർച്ചയായ ഓൺലൈൻ പഠനത്തിന്റെ ഭാഗമായി കുട്ടികൾക്ക് ഉണ്ടായെക്കാവുന്ന കാഴ്ച, കേൾവി തകരാറുകൾ തുടക്കത്തിലേ കണ്ടെത്തുന്നതിൻ്റെ ഭാഗമായി ജനറൽ സ്ക്രീനിംഗ്, കാഴ്ച, കേൾവി , ഡെൻ്റൽ പരിശോധന നടത്തി.",
      thumb: "assets/img/Pastevents/1309.jpeg",
    },
    {
      src: "assets/img/Pastevents/1310.jpeg",
      caption:
        "റോട്ടറി ക്ലബ്ബ് തിരുവനന്തപുരം, ഫോർട്ട് ഗേൾസ് മിഷൻ സ്കൂളിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.തുടർച്ചയായ ഓൺലൈൻ പഠനത്തിന്റെ ഭാഗമായി കുട്ടികൾക്ക് ഉണ്ടായെക്കാവുന്ന കാഴ്ച, കേൾവി തകരാറുകൾ തുടക്കത്തിലേ കണ്ടെത്തുന്നതിൻ്റെ ഭാഗമായി ജനറൽ സ്ക്രീനിംഗ്, കാഴ്ച, കേൾവി , ഡെൻ്റൽ പരിശോധന നടത്തി.",
      thumb: "assets/img/Pastevents/1310.jpeg",
    },
    {
      src: "assets/img/Pastevents/1299.jpeg",
      caption:
        "റോട്ടറി ക്ലബ്ബ് തിരുവനന്തപുരം, ഫോർട്ട് ഗേൾസ് മിഷൻ സ്കൂളിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.തുടർച്ചയായ ഓൺലൈൻ പഠനത്തിന്റെ ഭാഗമായി കുട്ടികൾക്ക് ഉണ്ടായെക്കാവുന്ന കാഴ്ച, കേൾവി തകരാറുകൾ തുടക്കത്തിലേ കണ്ടെത്തുന്നതിൻ്റെ ഭാഗമായി ജനറൽ സ്ക്രീനിംഗ്, കാഴ്ച, കേൾവി , ഡെൻ്റൽ പരിശോധന നടത്തി.",
      thumb: "assets/img/Pastevents/1299.jpeg",
    },
    {
      src: "assets/img/Pastevents/1300.jpeg",
      caption:
        "റോട്ടറി ക്ലബ്ബ് തിരുവനന്തപുരം, ഫോർട്ട് ഗേൾസ് മിഷൻ സ്കൂളിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.തുടർച്ചയായ ഓൺലൈൻ പഠനത്തിന്റെ ഭാഗമായി കുട്ടികൾക്ക് ഉണ്ടായെക്കാവുന്ന കാഴ്ച, കേൾവി തകരാറുകൾ തുടക്കത്തിലേ കണ്ടെത്തുന്നതിൻ്റെ ഭാഗമായി ജനറൽ സ്ക്രീനിംഗ്, കാഴ്ച, കേൾവി , ഡെൻ്റൽ പരിശോധന നടത്തി.",
      thumb: "assets/img/Pastevents/1300.jpeg",
    },
    {
      src: "assets/img/Pastevents/1301.jpeg",
      caption:
        "റോട്ടറി ക്ലബ്ബ് തിരുവനന്തപുരം, ഫോർട്ട് ഗേൾസ് മിഷൻ സ്കൂളിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.തുടർച്ചയായ ഓൺലൈൻ പഠനത്തിന്റെ ഭാഗമായി കുട്ടികൾക്ക് ഉണ്ടായെക്കാവുന്ന കാഴ്ച, കേൾവി തകരാറുകൾ തുടക്കത്തിലേ കണ്ടെത്തുന്നതിൻ്റെ ഭാഗമായി ജനറൽ സ്ക്രീനിംഗ്, കാഴ്ച, കേൾവി , ഡെൻ്റൽ പരിശോധന നടത്തി.",
      thumb: "assets/img/Pastevents/1301.jpeg",
    },
    {
      src: "assets/img/Pastevents/1302.jpeg",
      caption:
        "റോട്ടറി ക്ലബ്ബ് തിരുവനന്തപുരം, ഫോർട്ട് ഗേൾസ് മിഷൻ സ്കൂളിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.തുടർച്ചയായ ഓൺലൈൻ പഠനത്തിന്റെ ഭാഗമായി കുട്ടികൾക്ക് ഉണ്ടായെക്കാവുന്ന കാഴ്ച, കേൾവി തകരാറുകൾ തുടക്കത്തിലേ കണ്ടെത്തുന്നതിൻ്റെ ഭാഗമായി ജനറൽ സ്ക്രീനിംഗ്, കാഴ്ച, കേൾവി , ഡെൻ്റൽ പരിശോധന നടത്തി.",
      thumb: "assets/img/Pastevents/1302.jpeg",
    },
    {
      src: "assets/img/Pastevents/1303.jpeg",
      caption:
        "റോട്ടറി ക്ലബ്ബ് തിരുവനന്തപുരം, ഫോർട്ട് ഗേൾസ് മിഷൻ സ്കൂളിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.തുടർച്ചയായ ഓൺലൈൻ പഠനത്തിന്റെ ഭാഗമായി കുട്ടികൾക്ക് ഉണ്ടായെക്കാവുന്ന കാഴ്ച, കേൾവി തകരാറുകൾ തുടക്കത്തിലേ കണ്ടെത്തുന്നതിൻ്റെ ഭാഗമായി ജനറൽ സ്ക്രീനിംഗ്, കാഴ്ച, കേൾവി , ഡെൻ്റൽ പരിശോധന നടത്തി.",
      thumb: "assets/img/Pastevents/1303.jpeg",
    },
    {
      src: "assets/img/Pastevents/1304.jpeg",
      caption:
        "റോട്ടറി ക്ലബ്ബ് തിരുവനന്തപുരം, ഫോർട്ട് ഗേൾസ് മിഷൻ സ്കൂളിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.തുടർച്ചയായ ഓൺലൈൻ പഠനത്തിന്റെ ഭാഗമായി കുട്ടികൾക്ക് ഉണ്ടായെക്കാവുന്ന കാഴ്ച, കേൾവി തകരാറുകൾ തുടക്കത്തിലേ കണ്ടെത്തുന്നതിൻ്റെ ഭാഗമായി ജനറൽ സ്ക്രീനിംഗ്, കാഴ്ച, കേൾവി , ഡെൻ്റൽ പരിശോധന നടത്തി.",
      thumb: "assets/img/Pastevents/1304.jpeg",
    },
    {
      src: "assets/img/Pastevents/1293.jpeg",
      caption:
        "വിൻഡോ ഓഫ് കേരളാ മാഗസീൻ, ശ്രീ ശാസ്താ എൻ എസ് എസ് കരയോഗം  ഞാലിക്കോണം, നേത്ര ചാരിറ്റബിൾ സൊസൈറ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ അഡ്വ കൃഷ്ണകുമാർ(എൻ എസ് എസ് താലൂക്ക്).",
      thumb: "assets/img/Pastevents/1293.jpeg",
    },
    {
      src: "assets/img/Pastevents/1294.jpeg",
      caption:
        "വിൻഡോ ഓഫ് കേരളാ മാഗസീൻ, ശ്രീ ശാസ്താ എൻ എസ് എസ് കരയോഗം  ഞാലിക്കോണം, നേത്ര ചാരിറ്റബിൾ സൊസൈറ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ അഡ്വ കൃഷ്ണകുമാർ(എൻ എസ് എസ് താലൂക്ക്).",
      thumb: "assets/img/Pastevents/1294.jpeg",
    },
    {
      src: "assets/img/Pastevents/1295.jpeg",
      caption:
        "വിൻഡോ ഓഫ് കേരളാ മാഗസീൻ, ശ്രീ ശാസ്താ എൻ എസ് എസ് കരയോഗം  ഞാലിക്കോണം, നേത്ര ചാരിറ്റബിൾ സൊസൈറ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ അഡ്വ കൃഷ്ണകുമാർ(എൻ എസ് എസ് താലൂക്ക്).",
      thumb: "assets/img/Pastevents/1295.jpeg",
    },
    {
      src: "assets/img/Pastevents/1296.jpeg",
      caption:
        "വിൻഡോ ഓഫ് കേരളാ മാഗസീൻ, ശ്രീ ശാസ്താ എൻ എസ് എസ് കരയോഗം  ഞാലിക്കോണം, നേത്ര ചാരിറ്റബിൾ സൊസൈറ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ അഡ്വ കൃഷ്ണകുമാർ(എൻ എസ് എസ് താലൂക്ക്).",
      thumb: "assets/img/Pastevents/1296.jpeg",
    },
    {
      src: "assets/img/Pastevents/1297.jpeg",
      caption:
        "വിൻഡോ ഓഫ് കേരളാ മാഗസീൻ, ശ്രീ ശാസ്താ എൻ എസ് എസ് കരയോഗം  ഞാലിക്കോണം, നേത്ര ചാരിറ്റബിൾ സൊസൈറ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ അഡ്വ കൃഷ്ണകുമാർ(എൻ എസ് എസ് താലൂക്ക്).",
      thumb: "assets/img/Pastevents/1297.jpeg",
    },
    {
      src: "assets/img/Pastevents/1298.jpeg",
      caption:
        "വിൻഡോ ഓഫ് കേരളാ മാഗസീൻ, ശ്രീ ശാസ്താ എൻ എസ് എസ് കരയോഗം  ഞാലിക്കോണം, നേത്ര ചാരിറ്റബിൾ സൊസൈറ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ അഡ്വ കൃഷ്ണകുമാർ(എൻ എസ് എസ് താലൂക്ക്).",
      thumb: "assets/img/Pastevents/1298.jpeg",
    },
    {
      src: "assets/img/Pastevents/1288.jpeg",
      caption:
        "വിഴിഞ്ഞം കോസ്‌റ്റൽ പോലീസ് സ്റ്റേഷൻ, വിഴിഞ്ഞം ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ ഷാജി എസ് (അസി. കമ്മിഷണർ ഓഫ് പോലീസ്, ഫോർട്ട് ഡിവിഷൻ).",
      thumb: "assets/img/Pastevents/1288.jpeg",
    },
    {
      src: "assets/img/Pastevents/1289.jpeg",
      caption:
        "വിഴിഞ്ഞം കോസ്‌റ്റൽ പോലീസ് സ്റ്റേഷൻ, വിഴിഞ്ഞം ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1289.jpeg",
    },
    {
      src: "assets/img/Pastevents/1290.jpeg",
      caption:
        "വിഴിഞ്ഞം കോസ്‌റ്റൽ പോലീസ് സ്റ്റേഷൻ, വിഴിഞ്ഞം ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1290.jpeg",
    },
    {
      src: "assets/img/Pastevents/1291.jpeg",
      caption:
        "വിഴിഞ്ഞം കോസ്‌റ്റൽ പോലീസ് സ്റ്റേഷൻ, വിഴിഞ്ഞം ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1291.jpeg",
    },
    {
      src: "assets/img/Pastevents/1292.jpeg",
      caption:
        "വിഴിഞ്ഞം കോസ്‌റ്റൽ പോലീസ് സ്റ്റേഷൻ, വിഴിഞ്ഞം ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1292.jpeg",
    },
    {
      src: "assets/img/Pastevents/1283.jpeg",
      caption:
        "ലയൺസ് ഇൻ്റർനാഷണൽ ട്രിവാൻഡ്രം, സ്നേഹതീരം ചാരിറ്റബിൾ ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ സുനേഷ്(SHO പാലോട് P S)",
      thumb: "assets/img/Pastevents/1283.jpeg",
    },
    {
      src: "assets/img/Pastevents/1284.jpeg",
      caption:
        "ലയൺസ് ഇൻ്റർനാഷണൽ ട്രിവാൻഡ്രം, സ്നേഹതീരം ചാരിറ്റബിൾ ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1284.jpeg",
    },
    {
      src: "assets/img/Pastevents/1285.jpeg",
      caption:
        "ലയൺസ് ഇൻ്റർനാഷണൽ ട്രിവാൻഡ്രം, സ്നേഹതീരം ചാരിറ്റബിൾ ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1285.jpeg",
    },
    {
      src: "assets/img/Pastevents/1286.jpeg",
      caption:
        "ലയൺസ് ഇൻ്റർനാഷണൽ ട്രിവാൻഡ്രം, സ്നേഹതീരം ചാരിറ്റബിൾ ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1286.jpeg",
    },
    {
      src: "assets/img/Pastevents/1287.jpeg",
      caption:
        "ലയൺസ് ഇൻ്റർനാഷണൽ ട്രിവാൻഡ്രം, സ്നേഹതീരം ചാരിറ്റബിൾ ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1287.jpeg",
    },
    {
      src: "assets/img/Pastevents/1277.jpeg",
      caption:
        "മൈ ഫാമിലി ക്ലിനിക് കാട്ടാക്കട, ഐ ഡി എഫ്‌ സി ബാങ്ക് കാട്ടാക്കട ബ്രാഞ്ചിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1277.jpeg",
    },
    {
      src: "assets/img/Pastevents/1278.jpeg",
      caption:
        "മൈ ഫാമിലി ക്ലിനിക് കാട്ടാക്കട, ഐ ഡി എഫ്‌ സി ബാങ്ക് കാട്ടാക്കട ബ്രാഞ്ചിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1278.jpeg",
    },
    {
      src: "assets/img/Pastevents/1279.jpeg",
      caption:
        "മൈ ഫാമിലി ക്ലിനിക് കാട്ടാക്കട, ഐ ഡി എഫ്‌ സി ബാങ്ക് കാട്ടാക്കട ബ്രാഞ്ചിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1279.jpeg",
    },
    {
      src: "assets/img/Pastevents/1280.jpeg",
      caption:
        "മൈ ഫാമിലി ക്ലിനിക് കാട്ടാക്കട, ഐ ഡി എഫ്‌ സി ബാങ്ക് കാട്ടാക്കട ബ്രാഞ്ചിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1280.jpeg",
    },
    {
      src: "assets/img/Pastevents/1281.jpeg",
      caption:
        "മൈ ഫാമിലി ക്ലിനിക് കാട്ടാക്കട, ഐ ഡി എഫ്‌ സി ബാങ്ക് കാട്ടാക്കട ബ്രാഞ്ചിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1281.jpeg",
    },
    {
      src: "assets/img/Pastevents/1282.jpeg",
      caption:
        "മൈ ഫാമിലി ക്ലിനിക് കാട്ടാക്കട, ഐ ഡി എഫ്‌ സി ബാങ്ക് കാട്ടാക്കട ബ്രാഞ്ചിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1282.jpeg",
    },
    {
      src: "assets/img/Pastevents/1270.jpeg",
      caption:
        "ഡി വൈ എഫ് ഐ നന്നാംകുഴി യൂണിറ്റ്,ആശ്വാസ് കമ്മ്യൂണിറ്റി ഫാർമസിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ വി അനൂപ് (തിരുവനന്തപുരം ജില്ലാ പ്രസിഡൻ്റ്  ഡി വൈ എഫ് ഐ)",
      thumb: "assets/img/Pastevents/1270.jpeg",
    },
    {
      src: "assets/img/Pastevents/1271.jpeg",
      caption:
        "ഡി വൈ എഫ് ഐ നന്നാംകുഴി യൂണിറ്റ്,ആശ്വാസ് കമ്മ്യൂണിറ്റി ഫാർമസിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1271.jpeg",
    },
    {
      src: "assets/img/Pastevents/1272.jpeg",
      caption:
        "ഡി വൈ എഫ് ഐ നന്നാംകുഴി യൂണിറ്റ്,ആശ്വാസ് കമ്മ്യൂണിറ്റി ഫാർമസിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1272.jpeg",
    },
    {
      src: "assets/img/Pastevents/1273.jpeg",
      caption:
        "ഡി വൈ എഫ് ഐ നന്നാംകുഴി യൂണിറ്റ്,ആശ്വാസ് കമ്മ്യൂണിറ്റി ഫാർമസിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1273.jpeg",
    },
    {
      src: "assets/img/Pastevents/1274.jpeg",
      caption:
        "ഡി വൈ എഫ് ഐ നന്നാംകുഴി യൂണിറ്റ്,ആശ്വാസ് കമ്മ്യൂണിറ്റി ഫാർമസിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1274.jpeg",
    },
    {
      src: "assets/img/Pastevents/1275.jpeg",
      caption:
        "ഡി വൈ എഫ് ഐ നന്നാംകുഴി യൂണിറ്റ്,ആശ്വാസ് കമ്മ്യൂണിറ്റി ഫാർമസിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1275.jpeg",
    },
    {
      src: "assets/img/Pastevents/1276.jpeg",
      caption:
        "ഡി വൈ എഫ് ഐ നന്നാംകുഴി യൂണിറ്റ്,ആശ്വാസ് കമ്മ്യൂണിറ്റി ഫാർമസിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1276.jpeg",
    },
    {
      src: "assets/img/Pastevents/1264.jpeg",
      caption:
        "എൻ്റെ നാട് ഉഴമലയ്ക്കൽ ചാരിറ്റബിൾ ഓർഗനൈസേഷനും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1264.jpeg",
    },
    {
      src: "assets/img/Pastevents/1265.jpeg",
      caption:
        "എൻ്റെ നാട് ഉഴമലയ്ക്കൽ ചാരിറ്റബിൾ ഓർഗനൈസേഷനും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1265.jpeg",
    },
    {
      src: "assets/img/Pastevents/1266.jpeg",
      caption:
        "എൻ്റെ നാട് ഉഴമലയ്ക്കൽ ചാരിറ്റബിൾ ഓർഗനൈസേഷനും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1266.jpeg",
    },
    {
      src: "assets/img/Pastevents/1267.jpeg",
      caption:
        "എൻ്റെ നാട് ഉഴമലയ്ക്കൽ ചാരിറ്റബിൾ ഓർഗനൈസേഷനും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1267.jpeg",
    },
    {
      src: "assets/img/Pastevents/1268.jpeg",
      caption:
        "എൻ്റെ നാട് ഉഴമലയ്ക്കൽ ചാരിറ്റബിൾ ഓർഗനൈസേഷനും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1268.jpeg",
    },
    {
      src: "assets/img/Pastevents/1269.jpeg",
      caption:
        "എൻ്റെ നാട് ഉഴമലയ്ക്കൽ ചാരിറ്റബിൾ ഓർഗനൈസേഷനും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1269.jpeg",
    },
    {
      src: "assets/img/Pastevents/1251.jpeg",
      caption:
        "അരുവിപ്പുറം എസ്.എൻ‍.ഡി.പി ട്രസ്റ്റ് , എസ്.എൻ‍.ഡി.പി എൽ പീ സ്കൂളിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ സ്പെഷ്യാലിറ്റി മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു . ക്യാമ്പ് ഉദ്ഘാടനം   ശിവഗിരി മഠം മുൻ ജനറൽ സെക്രട്ടറിയും അരുവിപ്പുറം മഠം സെക്രട്ടറിയുമായ സ്വാമി സാന്ദ്രാനന്ദ.",
      thumb: "assets/img/Pastevents/1251.jpeg",
    },
    {
      src: "assets/img/Pastevents/1252.jpeg",
      caption:
        "അരുവിപ്പുറം എസ്.എൻ‍.ഡി.പി ട്രസ്റ്റ് , എസ്.എൻ‍.ഡി.പി എൽ പീ സ്കൂളിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ സ്പെഷ്യാലിറ്റി മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു .",
      thumb: "assets/img/Pastevents/1252.jpeg",
    },
    {
      src: "assets/img/Pastevents/1253.jpeg",
      caption:
        "അരുവിപ്പുറം എസ്.എൻ‍.ഡി.പി ട്രസ്റ്റ് , എസ്.എൻ‍.ഡി.പി എൽ പീ സ്കൂളിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ സ്പെഷ്യാലിറ്റി മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു .",
      thumb: "assets/img/Pastevents/1253.jpeg",
    },
    {
      src: "assets/img/Pastevents/1254.jpeg",
      caption:
        "അരുവിപ്പുറം എസ്.എൻ‍.ഡി.പി ട്രസ്റ്റ് , എസ്.എൻ‍.ഡി.പി എൽ പീ സ്കൂളിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ സ്പെഷ്യാലിറ്റി മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു .",
      thumb: "assets/img/Pastevents/1254.jpeg",
    },
    {
      src: "assets/img/Pastevents/1255.jpeg",
      caption:
        "അരുവിപ്പുറം എസ്.എൻ‍.ഡി.പി ട്രസ്റ്റ് , എസ്.എൻ‍.ഡി.പി എൽ പീ സ്കൂളിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ സ്പെഷ്യാലിറ്റി മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു .",
      thumb: "assets/img/Pastevents/1255.jpeg",
    },
    {
      src: "assets/img/Pastevents/1256.jpeg",
      caption:
        "അരുവിപ്പുറം എസ്.എൻ‍.ഡി.പി ട്രസ്റ്റ് , എസ്.എൻ‍.ഡി.പി എൽ പീ സ്കൂളിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ സ്പെഷ്യാലിറ്റി മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു .",
      thumb: "assets/img/Pastevents/1256.jpeg",
    },
    {
      src: "assets/img/Pastevents/1257.jpeg",
      caption:
        "അരുവിപ്പുറം എസ്.എൻ‍.ഡി.പി ട്രസ്റ്റ് , എസ്.എൻ‍.ഡി.പി എൽ പീ സ്കൂളിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ സ്പെഷ്യാലിറ്റി മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു .",
      thumb: "assets/img/Pastevents/1257.jpeg",
    },
    {
      src: "assets/img/Pastevents/1258.jpeg",
      caption:
        "കേരളാ വ്യാപാരി വ്യവസായി ഏകോപന സമിതിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ വി ശിവൻകുട്ടി എംഎൽഎ (ബഹു: പൊതു വിദ്യാഭ്യാസം തൊഴിൽ വകുപ്പ് മന്ത്രി).",
      thumb: "assets/img/Pastevents/1258.jpeg",
    },
    {
      src: "assets/img/Pastevents/1259.jpeg",
      caption:
        "കേരളാ വ്യാപാരി വ്യവസായി ഏകോപന സമിതിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1259.jpeg",
    },
    {
      src: "assets/img/Pastevents/1260.jpeg",
      caption:
        "കേരളാ വ്യാപാരി വ്യവസായി ഏകോപന സമിതിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1260.jpeg",
    },
    {
      src: "assets/img/Pastevents/1261.jpeg",
      caption:
        "കേരളാ വ്യാപാരി വ്യവസായി ഏകോപന സമിതിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1261.jpeg",
    },
    {
      src: "assets/img/Pastevents/1262.jpeg",
      caption:
        "കേരളാ വ്യാപാരി വ്യവസായി ഏകോപന സമിതിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1262.jpeg",
    },
    {
      src: "assets/img/Pastevents/1263.jpeg",
      caption:
        "കേരളാ വ്യാപാരി വ്യവസായി ഏകോപന സമിതിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1263.jpeg",
    },

    {
      src: "assets/img/Pastevents/1238.jpeg",
      caption:
        "കാവിയാട് ദിനകരപണിക്കർ സാംസ്കാരിക വേദിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1238.jpeg",
    },
    {
      src: "assets/img/Pastevents/1239.jpeg",
      caption:
        "കാവിയാട് ദിനകരപണിക്കർ സാംസ്കാരിക വേദിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1239.jpeg",
    },
    {
      src: "assets/img/Pastevents/1240.jpeg",
      caption:
        "കാവിയാട് ദിനകരപണിക്കർ സാംസ്കാരിക വേദിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1240.jpeg",
    },
    {
      src: "assets/img/Pastevents/1241.jpeg",
      caption:
        "കാവിയാട് ദിനകരപണിക്കർ സാംസ്കാരിക വേദിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1241.jpeg",
    },
    {
      src: "assets/img/Pastevents/1242.jpeg",
      caption:
        "കാവിയാട് ദിനകരപണിക്കർ സാംസ്കാരിക വേദിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1242.jpeg",
    },
    {
      src: "assets/img/Pastevents/1243.jpeg",
      caption:
        "കാവിയാട് ദിനകരപണിക്കർ സാംസ്കാരിക വേദിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1243.jpeg",
    },
    {
      src: "assets/img/Pastevents/1244.jpeg",
      caption:
        "കരുർ വെൽഫെയർ റെസിഡൻഷ്യൽ അസോസിയേഷൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1244.jpeg",
    },
    {
      src: "assets/img/Pastevents/1245.jpeg",
      caption:
        "കരുർ വെൽഫെയർ റെസിഡൻഷ്യൽ അസോസിയേഷൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1245.jpeg",
    },
    {
      src: "assets/img/Pastevents/1246.jpeg",
      caption:
        "കരുർ വെൽഫെയർ റെസിഡൻഷ്യൽ അസോസിയേഷൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1246.jpeg",
    },
    {
      src: "assets/img/Pastevents/1247.jpeg",
      caption:
        "കരുർ വെൽഫെയർ റെസിഡൻഷ്യൽ അസോസിയേഷൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1247.jpeg",
    },
    {
      src: "assets/img/Pastevents/1248.jpeg",
      caption:
        "കരുർ വെൽഫെയർ റെസിഡൻഷ്യൽ അസോസിയേഷൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1248.jpeg",
    },
    {
      src: "assets/img/Pastevents/1249.jpeg",
      caption:
        "കരുർ വെൽഫെയർ റെസിഡൻഷ്യൽ അസോസിയേഷൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1249.jpeg",
    },
    {
      src: "assets/img/Pastevents/1250.jpeg",
      caption:
        "കരുർ വെൽഫെയർ റെസിഡൻഷ്യൽ അസോസിയേഷൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1250.jpeg",
    },

    {
      src: "assets/img/Pastevents/1231.jpeg",
      caption:
        "അമരവിള സെൻ്റ് ആൻ്റണീസ് ദേവാലയത്തിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1231.jpeg",
    },
    {
      src: "assets/img/Pastevents/1232.jpeg",
      caption:
        "അമരവിള സെൻ്റ് ആൻ്റണീസ് ദേവാലയത്തിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1232.jpeg",
    },
    {
      src: "assets/img/Pastevents/1233.jpeg",
      caption:
        "അമരവിള സെൻ്റ് ആൻ്റണീസ് ദേവാലയത്തിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1233.jpeg",
    },
    {
      src: "assets/img/Pastevents/1234.jpeg",
      caption:
        "അമരവിള സെൻ്റ് ആൻ്റണീസ് ദേവാലയത്തിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1234.jpeg",
    },
    {
      src: "assets/img/Pastevents/1235.jpeg",
      caption:
        "അമരവിള സെൻ്റ് ആൻ്റണീസ് ദേവാലയത്തിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1235.jpeg",
    },
    {
      src: "assets/img/Pastevents/1236.jpeg",
      caption:
        "അമരവിള സെൻ്റ് ആൻ്റണീസ് ദേവാലയത്തിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1236.jpeg",
    },
    {
      src: "assets/img/Pastevents/1237.jpeg",
      caption:
        "അമരവിള സെൻ്റ് ആൻ്റണീസ് ദേവാലയത്തിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1237.jpeg",
    },
    {
      src: "assets/img/Pastevents/1225.jpeg",
      caption:
        " ലോക ബ്ലഡ് ഡൊണേഴ്സ് ദിനത്തോട് അനുബന്ധിച്ച് പുനലാൽ ഡെയിൽ വ്യൂ കോളേജിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ ബ്ലഡ് ഡൊണെഷൻ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1225.jpeg",
    },
    {
      src: "assets/img/Pastevents/1226.jpeg",
      caption:
        " ലോക ബ്ലഡ് ഡൊണേഴ്സ് ദിനത്തോട് അനുബന്ധിച്ച് പുനലാൽ ഡെയിൽ വ്യൂ കോളേജിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ ബ്ലഡ് ഡൊണെഷൻ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1226.jpeg",
    },
    {
      src: "assets/img/Pastevents/1227.jpeg",
      caption:
        " ലോക ബ്ലഡ് ഡൊണേഴ്സ് ദിനത്തോട് അനുബന്ധിച്ച് പുനലാൽ ഡെയിൽ വ്യൂ കോളേജിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ ബ്ലഡ് ഡൊണെഷൻ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1227.jpeg",
    },
    {
      src: "assets/img/Pastevents/1228.jpeg",
      caption:
        " ലോക ബ്ലഡ് ഡൊണേഴ്സ് ദിനത്തോട് അനുബന്ധിച്ച് പുനലാൽ ഡെയിൽ വ്യൂ കോളേജിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ ബ്ലഡ് ഡൊണെഷൻ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1228.jpeg",
    },
    {
      src: "assets/img/Pastevents/1229.jpeg",
      caption:
        " ലോക ബ്ലഡ് ഡൊണേഴ്സ് ദിനത്തോട് അനുബന്ധിച്ച് പുനലാൽ ഡെയിൽ വ്യൂ കോളേജിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ ബ്ലഡ് ഡൊണെഷൻ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1229.jpeg",
    },
    {
      src: "assets/img/Pastevents/1230.jpeg",
      caption:
        " ലോക ബ്ലഡ് ഡൊണേഴ്സ് ദിനത്തോട് അനുബന്ധിച്ച് പുനലാൽ ഡെയിൽ വ്യൂ കോളേജിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ ബ്ലഡ് ഡൊണെഷൻ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1230.jpeg",
    },
    {
      src: "assets/img/Pastevents/1219.jpeg",
      caption:
        "കാവിയാട് സാംസ്കാരിക വേദിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1219.jpeg",
    },
    {
      src: "assets/img/Pastevents/1220.jpeg",
      caption:
        "കാവിയാട് സാംസ്കാരിക വേദിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1220.jpeg",
    },
    {
      src: "assets/img/Pastevents/1221.jpeg",
      caption:
        "കാവിയാട് സാംസ്കാരിക വേദിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1221.jpeg",
    },
    {
      src: "assets/img/Pastevents/1222.jpeg",
      caption:
        "കാവിയാട് സാംസ്കാരിക വേദിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1222.jpeg",
    },
    {
      src: "assets/img/Pastevents/1223.jpeg",
      caption:
        "കാവിയാട് സാംസ്കാരിക വേദിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1223.jpeg",
    },
    {
      src: "assets/img/Pastevents/1224.jpeg",
      caption:
        "കാവിയാട് സാംസ്കാരിക വേദിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1224.jpeg",
    },
    {
      src: "assets/img/Pastevents/1211.jpeg",
      caption:
        "കല്ലറ പഴയചന്ത റെസിഡൻഷ്യൽ അസോസിയേഷനും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ അഡ്വ: ഡി കെ മുരളി (എംഎൽഎ)",
      thumb: "assets/img/Pastevents/1211.jpeg",
    },
    {
      src: "assets/img/Pastevents/1212.jpeg",
      caption:
        "കല്ലറ പഴയചന്ത റെസിഡൻഷ്യൽ അസോസിയേഷനും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1212.jpeg",
    },
    {
      src: "assets/img/Pastevents/1213.jpeg",
      caption:
        "കല്ലറ പഴയചന്ത റെസിഡൻഷ്യൽ അസോസിയേഷനും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1213.jpeg",
    },
    {
      src: "assets/img/Pastevents/1214.jpeg",
      caption:
        "കല്ലറ പഴയചന്ത റെസിഡൻഷ്യൽ അസോസിയേഷനും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1214.jpeg",
    },
    {
      src: "assets/img/Pastevents/1215.jpeg",
      caption:
        "കല്ലറ പഴയചന്ത റെസിഡൻഷ്യൽ അസോസിയേഷനും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1215.jpeg",
    },
    {
      src: "assets/img/Pastevents/1216.jpeg",
      caption:
        "കല്ലറ പഴയചന്ത റെസിഡൻഷ്യൽ അസോസിയേഷനും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1216.jpeg",
    },
    {
      src: "assets/img/Pastevents/1217.jpeg",
      caption:
        "കല്ലറ പഴയചന്ത റെസിഡൻഷ്യൽ അസോസിയേഷനും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1217.jpeg",
    },
    {
      src: "assets/img/Pastevents/1218.jpeg",
      caption:
        "കല്ലറ പഴയചന്ത റെസിഡൻഷ്യൽ അസോസിയേഷനും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1218.jpeg",
    },
    {
      src: "assets/img/Pastevents/1203.jpeg",
      caption:
        "കരോട്- കളിയിക്കവിള ബൈപാസ് റോഡ് നിർമ്മാണ തൊഴിലാളികൾക്കായി എൽ ആൻഡ് റ്റി കൺസ്ട്രക്ഷൻ കമ്പനിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1203.jpeg",
    },
    {
      src: "assets/img/Pastevents/1204.jpeg",
      caption:
        "കരോട്- കളിയിക്കവിള ബൈപാസ് റോഡ് നിർമ്മാണ തൊഴിലാളികൾക്കായി എൽ ആൻഡ് റ്റി കൺസ്ട്രക്ഷൻ കമ്പനിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1204.jpeg",
    },
    {
      src: "assets/img/Pastevents/1205.jpeg",
      caption:
        "കരോട്- കളിയിക്കവിള ബൈപാസ് റോഡ് നിർമ്മാണ തൊഴിലാളികൾക്കായി എൽ ആൻഡ് റ്റി കൺസ്ട്രക്ഷൻ കമ്പനിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1205.jpeg",
    },
    {
      src: "assets/img/Pastevents/1206.jpeg",
      caption:
        "കരോട്- കളിയിക്കവിള ബൈപാസ് റോഡ് നിർമ്മാണ തൊഴിലാളികൾക്കായി എൽ ആൻഡ് റ്റി കൺസ്ട്രക്ഷൻ കമ്പനിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1206.jpeg",
    },
    {
      src: "assets/img/Pastevents/1207.jpeg",
      caption:
        "കരോട്- കളിയിക്കവിള ബൈപാസ് റോഡ് നിർമ്മാണ തൊഴിലാളികൾക്കായി എൽ ആൻഡ് റ്റി കൺസ്ട്രക്ഷൻ കമ്പനിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1207.jpeg",
    },
    {
      src: "assets/img/Pastevents/1208.jpeg",
      caption:
        "കരോട്- കളിയിക്കവിള ബൈപാസ് റോഡ് നിർമ്മാണ തൊഴിലാളികൾക്കായി എൽ ആൻഡ് റ്റി കൺസ്ട്രക്ഷൻ കമ്പനിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1208.jpeg",
    },
    {
      src: "assets/img/Pastevents/1209.jpeg",
      caption:
        "കരോട്- കളിയിക്കവിള ബൈപാസ് റോഡ് നിർമ്മാണ തൊഴിലാളികൾക്കായി എൽ ആൻഡ് റ്റി കൺസ്ട്രക്ഷൻ കമ്പനിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1209.jpeg",
    },
    {
      src: "assets/img/Pastevents/1210.jpeg",
      caption:
        "കരോട്- കളിയിക്കവിള ബൈപാസ് റോഡ് നിർമ്മാണ തൊഴിലാളികൾക്കായി എൽ ആൻഡ് റ്റി കൺസ്ട്രക്ഷൻ കമ്പനിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1210.jpeg",
    },

    {
      src: "assets/img/Pastevents/1197.jpeg",
      caption:
        "KSRTC പുതുതായി ആരംഭിച്ച ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 100-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ്( 5) നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1197.jpeg",
    },
    {
      src: "assets/img/Pastevents/1198.jpeg",
      caption:
        "KSRTC പുതുതായി ആരംഭിച്ച ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 100-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ്( 5) നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1198.jpeg",
    },
    {
      src: "assets/img/Pastevents/1199.jpeg",
      caption:
        "KSRTC പുതുതായി ആരംഭിച്ച ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 100-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ്( 5) നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1199.jpeg",
    },
    {
      src: "assets/img/Pastevents/1200.jpeg",
      caption:
        "KSRTC പുതുതായി ആരംഭിച്ച ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 100-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ്( 5) നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1200.jpeg",
    },
    {
      src: "assets/img/Pastevents/1201.jpeg",
      caption:
        "KSRTC പുതുതായി ആരംഭിച്ച ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 100-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ്( 5) നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1201.jpeg",
    },
    {
      src: "assets/img/Pastevents/1202.jpeg",
      caption:
        "KSRTC പുതുതായി ആരംഭിച്ച ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 100-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ്( 5) നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1202.jpeg",
    },

    {
      src: "assets/img/Pastevents/1176.jpeg",
      caption:
        "സമന്വയ ചാരിറ്റബിൾ ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പും, ആംബുലൻസ് സർവീസ് പദ്ധതിയും പരിസ്ഥിതി ദിനാചരണം സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ സി ജയചന്ദ്രൻ (ഹെൽത്ത് ഇൻസ്പെക്ടർ സി ഹെച്ച് സി വിഴിഞ്ഞം)",
      thumb: "assets/img/Pastevents/1176.jpeg",
    },
    {
      src: "assets/img/Pastevents/1177.jpeg",
      caption:
        "സമന്വയ ചാരിറ്റബിൾ ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പും, ആംബുലൻസ് സർവീസ് പദ്ധതിയും പരിസ്ഥിതി ദിനാചരണം സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ സി ജയചന്ദ്രൻ (ഹെൽത്ത് ഇൻസ്പെക്ടർ സി ഹെച്ച് സി വിഴിഞ്ഞം)",
      thumb: "assets/img/Pastevents/1177.jpeg",
    },
    {
      src: "assets/img/Pastevents/1178.jpeg",
      caption:
        "സമന്വയ ചാരിറ്റബിൾ ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പും, ആംബുലൻസ് സർവീസ് പദ്ധതിയും പരിസ്ഥിതി ദിനാചരണം സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1178.jpeg",
    },
    {
      src: "assets/img/Pastevents/1179.jpeg",
      caption:
        "സമന്വയ ചാരിറ്റബിൾ ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പും, ആംബുലൻസ് സർവീസ് പദ്ധതിയും പരിസ്ഥിതി ദിനാചരണം സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1179.jpeg",
    },
    {
      src: "assets/img/Pastevents/1180.jpeg",
      caption:
        "സമന്വയ ചാരിറ്റബിൾ ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പും, ആംബുലൻസ് സർവീസ് പദ്ധതിയും പരിസ്ഥിതി ദിനാചരണം സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1180.jpeg",
    },
    {
      src: "assets/img/Pastevents/1181.jpeg",
      caption:
        "സമന്വയ ചാരിറ്റബിൾ ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പും, ആംബുലൻസ് സർവീസ് പദ്ധതിയും പരിസ്ഥിതി ദിനാചരണം സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1181.jpeg",
    },
    {
      src: "assets/img/Pastevents/1182.jpeg",
      caption:
        "സമന്വയ ചാരിറ്റബിൾ ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പും, ആംബുലൻസ് സർവീസ് പദ്ധതിയും പരിസ്ഥിതി ദിനാചരണം സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1182.jpeg",
    },
    {
      src: "assets/img/Pastevents/1183.jpeg",
      caption:
        "സമന്വയ ചാരിറ്റബിൾ ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പും, ആംബുലൻസ് സർവീസ് പദ്ധതിയും പരിസ്ഥിതി ദിനാചരണം സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1183.jpeg",
    },
    {
      src: "assets/img/Pastevents/1184.jpeg",
      caption:
        " നവജോതി ചാരിറ്റബിൾ ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം : ഫാ: റിച്ചാർഡ് സക്കറിയാസ്(സെൻ്റ് ജൂഡ് ചർച്ച്, വള്ളവിള).",
      thumb: "assets/img/Pastevents/1184.jpeg",
    },
    {
      src: "assets/img/Pastevents/1185.jpeg",
      caption:
        " നവജോതി ചാരിറ്റബിൾ ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1185.jpeg",
    },
    {
      src: "assets/img/Pastevents/1186.jpeg",
      caption:
        " നവജോതി ചാരിറ്റബിൾ ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1186.jpeg",
    },
    {
      src: "assets/img/Pastevents/1187.jpeg",
      caption:
        " നവജോതി ചാരിറ്റബിൾ ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1187.jpeg",
    },
    {
      src: "assets/img/Pastevents/1188.jpeg",
      caption:
        " നവജോതി ചാരിറ്റബിൾ ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1188.jpeg",
    },
    {
      src: "assets/img/Pastevents/1189.jpeg",
      caption:
        " നവജോതി ചാരിറ്റബിൾ ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1189.jpeg",
    },
    {
      src: "assets/img/Pastevents/1190.jpeg",
      caption:
        " നവജോതി ചാരിറ്റബിൾ ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1190.jpeg",
    },
    {
      src: "assets/img/Pastevents/1191.jpeg",
      caption:
        "യൂത്ത് കോൺഗ്രസ് മാത്തൂർ, തിരുവട്ടാർ ബ്രാഞ്ച് കമ്മിറ്റിയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ കാർഡിയോളജി & സ്പെഷ്യാലിറ്റി മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1191.jpeg",
    },
    {
      src: "assets/img/Pastevents/1192.jpeg",
      caption:
        "യൂത്ത് കോൺഗ്രസ് മാത്തൂർ, തിരുവട്ടാർ ബ്രാഞ്ച് കമ്മിറ്റിയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ കാർഡിയോളജി & സ്പെഷ്യാലിറ്റി മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1192.jpeg",
    },
    {
      src: "assets/img/Pastevents/1193.jpeg",
      caption:
        "യൂത്ത് കോൺഗ്രസ് മാത്തൂർ, തിരുവട്ടാർ ബ്രാഞ്ച് കമ്മിറ്റിയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ കാർഡിയോളജി & സ്പെഷ്യാലിറ്റി മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1193.jpeg",
    },
    {
      src: "assets/img/Pastevents/1194.jpeg",
      caption:
        "യൂത്ത് കോൺഗ്രസ് മാത്തൂർ, തിരുവട്ടാർ ബ്രാഞ്ച് കമ്മിറ്റിയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ കാർഡിയോളജി & സ്പെഷ്യാലിറ്റി മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1194.jpeg",
    },
    {
      src: "assets/img/Pastevents/1195.jpeg",
      caption:
        "യൂത്ത് കോൺഗ്രസ് മാത്തൂർ, തിരുവട്ടാർ ബ്രാഞ്ച് കമ്മിറ്റിയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ കാർഡിയോളജി & സ്പെഷ്യാലിറ്റി മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1195.jpeg",
    },
    {
      src: "assets/img/Pastevents/1196.jpeg",
      caption:
        "യൂത്ത് കോൺഗ്രസ് മാത്തൂർ, തിരുവട്ടാർ ബ്രാഞ്ച് കമ്മിറ്റിയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ കാർഡിയോളജി & സ്പെഷ്യാലിറ്റി മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1196.jpeg",
    },
    {
      src: "assets/img/Pastevents/1170.jpeg",
      caption:
        "യൂത്ത് കോൺഗ്രസ് പള്ളിച്ചൽ വാർഡ് കമ്മറ്റിയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1170.jpeg",
    },
    {
      src: "assets/img/Pastevents/1171.jpeg",
      caption:
        "യൂത്ത് കോൺഗ്രസ് പള്ളിച്ചൽ വാർഡ് കമ്മറ്റിയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1171.jpeg",
    },
    {
      src: "assets/img/Pastevents/1172.jpeg",
      caption:
        "യൂത്ത് കോൺഗ്രസ് പള്ളിച്ചൽ വാർഡ് കമ്മറ്റിയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1172.jpeg",
    },
    {
      src: "assets/img/Pastevents/1173.jpeg",
      caption:
        "യൂത്ത് കോൺഗ്രസ് പള്ളിച്ചൽ വാർഡ് കമ്മറ്റിയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1173.jpeg",
    },
    {
      src: "assets/img/Pastevents/1174.jpeg",
      caption:
        "യൂത്ത് കോൺഗ്രസ് പള്ളിച്ചൽ വാർഡ് കമ്മറ്റിയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1174.jpeg",
    },
    {
      src: "assets/img/Pastevents/1175.jpeg",
      caption:
        "യൂത്ത് കോൺഗ്രസ് പള്ളിച്ചൽ വാർഡ് കമ്മറ്റിയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1175.jpeg",
    },
    {
      src: "assets/img/Pastevents/1165.jpeg",
      caption:
        'പെരുങ്കടവിള പഞ്ചായത്തും നിംസ് മെഡിസിറ്റിയും സംയുക്തമായി പഞ്ചായത്തിലെ "നെയ്യാറ്റിൻകര പെൻഷൻ പ്ലാൻ "  ഉപഭോക്താക്കൾക്ക് വേണ്ടി സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ആശുപത്രിയിൽ എത്തി ചികിത്സ തേടാൻ സാധിക്കാത്ത സാഹചര്യത്തിലുള്ള പെരുങ്കടവിള പഞ്ചായത്ത് പരിധിയിലുള്ള മുഴുവൻ ഭിന്നശേഷിക്കാരായവർക്ക് പ്രായ വ്യത്യാസമില്ലാതെ സൗജന്യ വൈദ്യപരിശോധനയും മരുന്ന് വിതരണവും  പെരുംങ്കടവിള പഞ്ചായത്ത് ഹാളിൽ നടന്നു.  ',
      thumb: "assets/img/Pastevents/1165.jpeg",
    },
    {
      src: "assets/img/Pastevents/1166.jpeg",
      caption:
        'പെരുങ്കടവിള പഞ്ചായത്തും നിംസ് മെഡിസിറ്റിയും സംയുക്തമായി പഞ്ചായത്തിലെ "നെയ്യാറ്റിൻകര പെൻഷൻ പ്ലാൻ "  ഉപഭോക്താക്കൾക്ക് വേണ്ടി സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ആശുപത്രിയിൽ എത്തി ചികിത്സ തേടാൻ സാധിക്കാത്ത സാഹചര്യത്തിലുള്ള പെരുങ്കടവിള പഞ്ചായത്ത് പരിധിയിലുള്ള മുഴുവൻ ഭിന്നശേഷിക്കാരായവർക്ക് പ്രായ വ്യത്യാസമില്ലാതെ സൗജന്യ വൈദ്യപരിശോധനയും മരുന്ന് വിതരണവും  പെരുംങ്കടവിള പഞ്ചായത്ത് ഹാളിൽ നടന്നു.  ',
      thumb: "assets/img/Pastevents/1166.jpeg",
    },
    {
      src: "assets/img/Pastevents/1167.jpeg",
      caption:
        'പെരുങ്കടവിള പഞ്ചായത്തും നിംസ് മെഡിസിറ്റിയും സംയുക്തമായി പഞ്ചായത്തിലെ "നെയ്യാറ്റിൻകര പെൻഷൻ പ്ലാൻ "  ഉപഭോക്താക്കൾക്ക് വേണ്ടി സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ആശുപത്രിയിൽ എത്തി ചികിത്സ തേടാൻ സാധിക്കാത്ത സാഹചര്യത്തിലുള്ള പെരുങ്കടവിള പഞ്ചായത്ത് പരിധിയിലുള്ള മുഴുവൻ ഭിന്നശേഷിക്കാരായവർക്ക് പ്രായ വ്യത്യാസമില്ലാതെ സൗജന്യ വൈദ്യപരിശോധനയും മരുന്ന് വിതരണവും  പെരുംങ്കടവിള പഞ്ചായത്ത് ഹാളിൽ നടന്നു.  ',
      thumb: "assets/img/Pastevents/1167.jpeg",
    },
    {
      src: "assets/img/Pastevents/1168.jpeg",
      caption:
        'പെരുങ്കടവിള പഞ്ചായത്തും നിംസ് മെഡിസിറ്റിയും സംയുക്തമായി പഞ്ചായത്തിലെ "നെയ്യാറ്റിൻകര പെൻഷൻ പ്ലാൻ "  ഉപഭോക്താക്കൾക്ക് വേണ്ടി സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ആശുപത്രിയിൽ എത്തി ചികിത്സ തേടാൻ സാധിക്കാത്ത സാഹചര്യത്തിലുള്ള പെരുങ്കടവിള പഞ്ചായത്ത് പരിധിയിലുള്ള മുഴുവൻ ഭിന്നശേഷിക്കാരായവർക്ക് പ്രായ വ്യത്യാസമില്ലാതെ സൗജന്യ വൈദ്യപരിശോധനയും മരുന്ന് വിതരണവും  പെരുംങ്കടവിള പഞ്ചായത്ത് ഹാളിൽ നടന്നു.  ',
      thumb: "assets/img/Pastevents/1168.jpeg",
    },
    {
      src: "assets/img/Pastevents/1169.jpeg",
      caption:
        'പെരുങ്കടവിള പഞ്ചായത്തും നിംസ് മെഡിസിറ്റിയും സംയുക്തമായി പഞ്ചായത്തിലെ "നെയ്യാറ്റിൻകര പെൻഷൻ പ്ലാൻ "  ഉപഭോക്താക്കൾക്ക് വേണ്ടി സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ആശുപത്രിയിൽ എത്തി ചികിത്സ തേടാൻ സാധിക്കാത്ത സാഹചര്യത്തിലുള്ള പെരുങ്കടവിള പഞ്ചായത്ത് പരിധിയിലുള്ള മുഴുവൻ ഭിന്നശേഷിക്കാരായവർക്ക് പ്രായ വ്യത്യാസമില്ലാതെ സൗജന്യ വൈദ്യപരിശോധനയും മരുന്ന് വിതരണവും  പെരുംങ്കടവിള പഞ്ചായത്ത് ഹാളിൽ നടന്നു.  ',
      thumb: "assets/img/Pastevents/1169.jpeg",
    },

    {
      src: "assets/img/Pastevents/1129.jpeg",
      caption:
        "വി കെ ശ്രീകുമാർ 1-ാം അനുസ്മരണ യോഗവും നിംസ് മെഡിസിറ്റി സൗജന്യ മെഡിക്കൽ ക്യാമ്പും. ക്യാമ്പ് ഉദ്ഘാടനം- ശ്രീ കെ അജിത്ത് കുമാർ (വൈസ് പ്രസിഡൻ്റ് ചെങ്കൽ ഗ്രാമ പഞ്ചായത്ത്)",
      thumb: "assets/img/Pastevents/1129.jpeg",
    },
    {
      src: "assets/img/Pastevents/1130.jpeg",
      caption:
        "വി കെ ശ്രീകുമാർ 1-ാം അനുസ്മരണ യോഗവും നിംസ് മെഡിസിറ്റി സൗജന്യ മെഡിക്കൽ ക്യാമ്പും",
      thumb: "assets/img/Pastevents/1130.jpeg",
    },
    {
      src: "assets/img/Pastevents/1131.jpeg",
      caption:
        "വി കെ ശ്രീകുമാർ 1-ാം അനുസ്മരണ യോഗവും നിംസ് മെഡിസിറ്റി സൗജന്യ മെഡിക്കൽ ക്യാമ്പും",
      thumb: "assets/img/Pastevents/1131.jpeg",
    },
    {
      src: "assets/img/Pastevents/1132.jpeg",
      caption:
        "വി കെ ശ്രീകുമാർ 1-ാം അനുസ്മരണ യോഗവും നിംസ് മെഡിസിറ്റി സൗജന്യ മെഡിക്കൽ ക്യാമ്പും",
      thumb: "assets/img/Pastevents/1132.jpeg",
    },
    {
      src: "assets/img/Pastevents/1133.jpeg",
      caption:
        "വി കെ ശ്രീകുമാർ 1-ാം അനുസ്മരണ യോഗവും നിംസ് മെഡിസിറ്റി സൗജന്യ മെഡിക്കൽ ക്യാമ്പും",
      thumb: "assets/img/Pastevents/1133.jpeg",
    },
    {
      src: "assets/img/Pastevents/1134.jpeg",
      caption:
        "വി കെ ശ്രീകുമാർ 1-ാം അനുസ്മരണ യോഗവും നിംസ് മെഡിസിറ്റി സൗജന്യ മെഡിക്കൽ ക്യാമ്പും",
      thumb: "assets/img/Pastevents/1134.jpeg",
    },
    {
      src: "assets/img/Pastevents/1135.jpeg",
      caption:
        "പെരിങ്ങമ്മല ഗ്രാമ പഞ്ചായത്ത് പാലോട് വാർഡ് തിരുവനന്തപുരം എലൈറ്റ് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ ഷിനു മടത്തറ (പ്രസിഡൻറ് പെരിങ്ങമ്മല ഗ്രാമ പഞ്ചായത്ത്)",
      thumb: "assets/img/Pastevents/1135.jpeg",
    },
    {
      src: "assets/img/Pastevents/1136.jpeg",
      caption:
        "പെരിങ്ങമ്മല ഗ്രാമ പഞ്ചായത്ത് പാലോട് വാർഡ് തിരുവനന്തപുരം എലൈറ്റ് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ ഷിനു മടത്തറ (പ്രസിഡൻറ് പെരിങ്ങമ്മല ഗ്രാമ പഞ്ചായത്ത്)",
      thumb: "assets/img/Pastevents/1136.jpeg",
    },
    {
      src: "assets/img/Pastevents/1137.jpeg",
      caption:
        "പെരിങ്ങമ്മല ഗ്രാമ പഞ്ചായത്ത് പാലോട് വാർഡ് തിരുവനന്തപുരം എലൈറ്റ് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ ഷിനു മടത്തറ (പ്രസിഡൻറ് പെരിങ്ങമ്മല ഗ്രാമ പഞ്ചായത്ത്)",
      thumb: "assets/img/Pastevents/1137.jpeg",
    },
    {
      src: "assets/img/Pastevents/1138.jpeg",
      caption:
        "പെരിങ്ങമ്മല ഗ്രാമ പഞ്ചായത്ത് പാലോട് വാർഡ് തിരുവനന്തപുരം എലൈറ്റ് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1138.jpeg",
    },
    {
      src: "assets/img/Pastevents/1139.jpeg",
      caption:
        "പെരിങ്ങമ്മല ഗ്രാമ പഞ്ചായത്ത് പാലോട് വാർഡ് തിരുവനന്തപുരം എലൈറ്റ് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1139.jpeg",
    },
    {
      src: "assets/img/Pastevents/1140.jpeg",
      caption:
        "പെരിങ്ങമ്മല ഗ്രാമ പഞ്ചായത്ത് പാലോട് വാർഡ് തിരുവനന്തപുരം എലൈറ്റ് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1140.jpeg",
    },
    {
      src: "assets/img/Pastevents/1141.jpeg",
      caption:
        "പെരിങ്ങമ്മല ഗ്രാമ പഞ്ചായത്ത് പാലോട് വാർഡ് തിരുവനന്തപുരം എലൈറ്റ് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1141.jpeg",
    },
    {
      src: "assets/img/Pastevents/1142.jpeg",
      caption:
        "തിരുവനന്തപുരം വൈഎംസിഎ,തിരുവനന്തപുരം സിറ്റി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം: ശ്രീമതി ബീന ജയൻ (പ്രസിഡൻറ് വെമ്പായം ഗ്രാമ പഞ്ചായത്ത്)",
      thumb: "assets/img/Pastevents/1142.jpeg",
    },
    {
      src: "assets/img/Pastevents/1143.jpeg",
      caption:
        "തിരുവനന്തപുരം വൈഎംസിഎ,തിരുവനന്തപുരം സിറ്റി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം: ശ്രീമതി ബീന ജയൻ (പ്രസിഡൻറ് വെമ്പായം ഗ്രാമ പഞ്ചായത്ത്)",
      thumb: "assets/img/Pastevents/1143.jpeg",
    },
    {
      src: "assets/img/Pastevents/1144.jpeg",
      caption:
        "തിരുവനന്തപുരം വൈഎംസിഎ,തിരുവനന്തപുരം സിറ്റി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1144.jpeg",
    },
    {
      src: "assets/img/Pastevents/1145.jpeg",
      caption:
        "തിരുവനന്തപുരം വൈഎംസിഎ,തിരുവനന്തപുരം സിറ്റി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1145.jpeg",
    },
    {
      src: "assets/img/Pastevents/1146.jpeg",
      caption:
        "തിരുവനന്തപുരം വൈഎംസിഎ,തിരുവനന്തപുരം സിറ്റി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1146.jpeg",
    },
    {
      src: "assets/img/Pastevents/1147.jpeg",
      caption:
        "തിരുവനന്തപുരം വൈഎംസിഎ,തിരുവനന്തപുരം സിറ്റി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1147.jpeg",
    },
    {
      src: "assets/img/Pastevents/1148.jpeg",
      caption:
        "തിരുവനന്തപുരം വൈഎംസിഎ,തിരുവനന്തപുരം സിറ്റി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1148.jpeg",
    },
    {
      src: "assets/img/Pastevents/1149.jpeg",
      caption:
        "തിരുവനന്തപുരം വൈഎംസിഎ,തിരുവനന്തപുരം സിറ്റി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1149.jpeg",
    },
    {
      src: "assets/img/Pastevents/1150.jpeg",
      caption:
        "തിരുവനന്തപുരം വൈഎംസിഎ,തിരുവനന്തപുരം സിറ്റി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1150.jpeg",
    },
    {
      src: "assets/img/Pastevents/1151.jpeg",
      caption:
        "2ാംമത്  ശ്രീ M P വീരേന്ദ്ര കുമാർ അനുസ്മരണവും സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ്. വയലാർ രാമവർമ്മ സാംസ്കാരിക വേദിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ അഡ്വ: ജി അർ അനിൽ (ബഹു: ഭക്ഷ്യ പൊതുവിതരണ ഉപദോക്തൃകാര്യ ലീഗൽ   മെട്രോളജി വകുപ്പ് മന്ത്രി)",
      thumb: "assets/img/Pastevents/1151.jpeg",
    },
    {
      src: "assets/img/Pastevents/1152.jpeg",
      caption:
        "2ാംമത്  ശ്രീ M P വീരേന്ദ്ര കുമാർ അനുസ്മരണവും സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ്. വയലാർ രാമവർമ്മ സാംസ്കാരിക വേദിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ.",
      thumb: "assets/img/Pastevents/1152.jpeg",
    },
    {
      src: "assets/img/Pastevents/1153.jpeg",
      caption:
        "2ാംമത്  ശ്രീ M P വീരേന്ദ്ര കുമാർ അനുസ്മരണവും സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ്. വയലാർ രാമവർമ്മ സാംസ്കാരിക വേദിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ.",
      thumb: "assets/img/Pastevents/1153.jpeg",
    },
    {
      src: "assets/img/Pastevents/1154.jpeg",
      caption:
        "2ാംമത്  ശ്രീ M P വീരേന്ദ്ര കുമാർ അനുസ്മരണവും സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ്. വയലാർ രാമവർമ്മ സാംസ്കാരിക വേദിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ.",
      thumb: "assets/img/Pastevents/1154.jpeg",
    },
    {
      src: "assets/img/Pastevents/1155.jpeg",
      caption:
        "2ാംമത്  ശ്രീ M P വീരേന്ദ്ര കുമാർ അനുസ്മരണവും സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ്. വയലാർ രാമവർമ്മ സാംസ്കാരിക വേദിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ.",
      thumb: "assets/img/Pastevents/1155.jpeg",
    },
    {
      src: "assets/img/Pastevents/1156.jpeg",
      caption:
        "2ാംമത്  ശ്രീ M P വീരേന്ദ്ര കുമാർ അനുസ്മരണവും സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ്. വയലാർ രാമവർമ്മ സാംസ്കാരിക വേദിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ.",
      thumb: "assets/img/Pastevents/1156.jpeg",
    },
    {
      src: "assets/img/Pastevents/1157.jpeg",
      caption:
        "2ാംമത്  ശ്രീ M P വീരേന്ദ്ര കുമാർ അനുസ്മരണവും സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ്. വയലാർ രാമവർമ്മ സാംസ്കാരിക വേദിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ.",
      thumb: "assets/img/Pastevents/1157.jpeg",
    },
    {
      src: "assets/img/Pastevents/1158.jpeg",
      caption:
        "KSRTC പുതുതായി ആരംഭിക്കുന്ന ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 150-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ്(നാലാം ദിനം) നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1158.jpeg",
    },
    {
      src: "assets/img/Pastevents/1159.jpeg",
      caption:
        "KSRTC പുതുതായി ആരംഭിക്കുന്ന ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 150-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ്(നാലാം ദിനം) നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1159.jpeg",
    },
    {
      src: "assets/img/Pastevents/1160.jpeg",
      caption:
        "KSRTC പുതുതായി ആരംഭിക്കുന്ന ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 150-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ്(നാലാം ദിനം) നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1160.jpeg",
    },
    {
      src: "assets/img/Pastevents/1161.jpeg",
      caption:
        "KSRTC പുതുതായി ആരംഭിക്കുന്ന ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 150-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ്(നാലാം ദിനം) നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1161.jpeg",
    },
    {
      src: "assets/img/Pastevents/1162.jpeg",
      caption:
        "KSRTC പുതുതായി ആരംഭിക്കുന്ന ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 150-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ്(നാലാം ദിനം) നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1162.jpeg",
    },
    {
      src: "assets/img/Pastevents/1163.jpeg",
      caption:
        "KSRTC പുതുതായി ആരംഭിക്കുന്ന ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 150-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ്(നാലാം ദിനം) നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1163.jpeg",
    },
    {
      src: "assets/img/Pastevents/1164.jpeg",
      caption:
        "KSRTC പുതുതായി ആരംഭിക്കുന്ന ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 150-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ്(നാലാം ദിനം) നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1164.jpeg",
    },

    {
      src: "assets/img/Pastevents/1112.jpeg",
      caption:
        "സി എസ് ഐ ആലംപാറ CEYF യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1112.jpeg",
    },
    {
      src: "assets/img/Pastevents/1113.jpeg",
      caption:
        "സി എസ് ഐ ആലംപാറ CEYF യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1113.jpeg",
    },
    {
      src: "assets/img/Pastevents/1114.jpeg",
      caption:
        "സി എസ് ഐ ആലംപാറ CEYF യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1114.jpeg",
    },
    {
      src: "assets/img/Pastevents/1115.jpeg",
      caption:
        "സി എസ് ഐ ആലംപാറ CEYF യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1115.jpeg",
    },
    {
      src: "assets/img/Pastevents/1116.jpeg",
      caption:
        "സി എസ് ഐ ആലംപാറ CEYF യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1116.jpeg",
    },
    {
      src: "assets/img/Pastevents/1117.jpeg",
      caption:
        "വട്ടപ്പാറ മിഷൻ ചാരിറ്റബിൾ സൊസൈറ്റി,തിരുവനന്തപുരം നോർത്ത് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1117.jpeg",
    },
    {
      src: "assets/img/Pastevents/1118.jpeg",
      caption:
        "വട്ടപ്പാറ മിഷൻ ചാരിറ്റബിൾ സൊസൈറ്റി,തിരുവനന്തപുരം നോർത്ത് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1118.jpeg",
    },
    {
      src: "assets/img/Pastevents/1119.jpeg",
      caption:
        "വട്ടപ്പാറ മിഷൻ ചാരിറ്റബിൾ സൊസൈറ്റി,തിരുവനന്തപുരം നോർത്ത് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1119.jpeg",
    },
    {
      src: "assets/img/Pastevents/1120.jpeg",
      caption:
        "വട്ടപ്പാറ മിഷൻ ചാരിറ്റബിൾ സൊസൈറ്റി,തിരുവനന്തപുരം നോർത്ത് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1120.jpeg",
    },
    {
      src: "assets/img/Pastevents/1121.jpeg",
      caption:
        "വട്ടപ്പാറ മിഷൻ ചാരിറ്റബിൾ സൊസൈറ്റി,തിരുവനന്തപുരം നോർത്ത് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1121.jpeg",
    },
    {
      src: "assets/img/Pastevents/1122.jpeg",
      caption:
        "വട്ടപ്പാറ മിഷൻ ചാരിറ്റബിൾ സൊസൈറ്റി,തിരുവനന്തപുരം നോർത്ത് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1122.jpeg",
    },
    {
      src: "assets/img/Pastevents/1123.jpeg",
      caption:
        "ചായം റസിഡൻസ് അസോസിയേഷനും നെയ്യാറ്റിൻകര നിംസ് മെഡിസിറ്റിയും മലയാള മനോരമയും സംയുക്തമായി സംഘടിപ്പിച്ച ഹൃദയപൂർവ്വം സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് വിതുര സർക്കിൾ ഇൻസ്പെക്ടർ ശ്രീ S.ശ്രീജിത്ത് ഉദ്ഘാടനം ചെയ്തു. റസിഡൻസ് അസോസിയേഷൻ പ്രസിഡന്റ്  S. സതീഷ് ചന്ദ്രൻ നായരുടെ അധ്യക്ഷതയിൽ ചേർന്ന യോഗത്തിൽ   ശ്രീമതി K. തങ്കമണി, മണ്ണറ വിജയൻ , പൂതം കുഴി  ചന്ദ്രൻ, G. ജയപ്രകാശ്, S. രാധാകൃഷ്ണൻ, P. രാധാകൃഷ്ണൻ നായർ, P. കേശവൻ നായർ തുടങ്ങിയവർ ആശംസകളർപ്പിച്ചു. ക്യാമ്പിൽ  നൂറ്റിയൻപതിൽപ്പരം ആളുകൾ പങ്കെടുക്കുകയും, ജനറൽ മെഡിസിൻ, ഡയബറ്റിക്, കാർഡിയോളജി, ഇ- എൻ റ്റി(കേൾവി പരിശോധന)കണ്ണ് പരിശോധന, ദന്ത പരിശോധനയും ഉണ്ടായിരുന്നു. ക്യാമ്പിനോട് അനുബന്ധിച്ച് മലയാള മനോരോമ പത്രവും മാഗസിനുകളും സൗജന്യമായി വിതരണം ചെയുകയുണ്ടായി...",
      thumb: "assets/img/Pastevents/1123.jpeg",
    },
    {
      src: "assets/img/Pastevents/1124.jpeg",
      caption:
        "ചായം റസിഡൻസ് അസോസിയേഷനും നെയ്യാറ്റിൻകര നിംസ് മെഡിസിറ്റിയും മലയാള മനോരമയും സംയുക്തമായി സംഘടിപ്പിച്ച ഹൃദയപൂർവ്വം സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് വിതുര സർക്കിൾ ഇൻസ്പെക്ടർ ശ്രീ S.ശ്രീജിത്ത് ഉദ്ഘാടനം ചെയ്തു.",
      thumb: "assets/img/Pastevents/1124.jpeg",
    },
    {
      src: "assets/img/Pastevents/1125.jpeg",
      caption:
        "ചായം റസിഡൻസ് അസോസിയേഷനും നെയ്യാറ്റിൻകര നിംസ് മെഡിസിറ്റിയും മലയാള മനോരമയും സംയുക്തമായി സംഘടിപ്പിച്ച ഹൃദയപൂർവ്വം സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് വിതുര സർക്കിൾ ഇൻസ്പെക്ടർ ശ്രീ S.ശ്രീജിത്ത് ഉദ്ഘാടനം ചെയ്തു.",
      thumb: "assets/img/Pastevents/1125.jpeg",
    },
    {
      src: "assets/img/Pastevents/1126.jpeg",
      caption:
        "ചായം റസിഡൻസ് അസോസിയേഷനും നെയ്യാറ്റിൻകര നിംസ് മെഡിസിറ്റിയും മലയാള മനോരമയും സംയുക്തമായി സംഘടിപ്പിച്ച ഹൃദയപൂർവ്വം സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് വിതുര സർക്കിൾ ഇൻസ്പെക്ടർ ശ്രീ S.ശ്രീജിത്ത് ഉദ്ഘാടനം ചെയ്തു.",
      thumb: "assets/img/Pastevents/1126.jpeg",
    },
    {
      src: "assets/img/Pastevents/1127.jpeg",
      caption:
        "ചായം റസിഡൻസ് അസോസിയേഷനും നെയ്യാറ്റിൻകര നിംസ് മെഡിസിറ്റിയും മലയാള മനോരമയും സംയുക്തമായി സംഘടിപ്പിച്ച ഹൃദയപൂർവ്വം സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് വിതുര സർക്കിൾ ഇൻസ്പെക്ടർ ശ്രീ S.ശ്രീജിത്ത് ഉദ്ഘാടനം ചെയ്തു.",
      thumb: "assets/img/Pastevents/1127.jpeg",
    },
    {
      src: "assets/img/Pastevents/1128.jpeg",
      caption:
        "ചായം റസിഡൻസ് അസോസിയേഷനും നെയ്യാറ്റിൻകര നിംസ് മെഡിസിറ്റിയും മലയാള മനോരമയും സംയുക്തമായി സംഘടിപ്പിച്ച ഹൃദയപൂർവ്വം സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് വിതുര സർക്കിൾ ഇൻസ്പെക്ടർ ശ്രീ S.ശ്രീജിത്ത് ഉദ്ഘാടനം ചെയ്തു.",
      thumb: "assets/img/Pastevents/1128.jpeg",
    },

    {
      src: "assets/img/Pastevents/1106.jpeg",
      caption:
        "കോസ്റ്റൽ പോലീസ് പൂവാർ സ്റ്റേഷൻറ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1106.jpeg",
    },
    {
      src: "assets/img/Pastevents/1107.jpeg",
      caption:
        "കോസ്റ്റൽ പോലീസ് പൂവാർ സ്റ്റേഷൻറ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1107.jpeg",
    },
    {
      src: "assets/img/Pastevents/1108.jpeg",
      caption:
        "കോസ്റ്റൽ പോലീസ് പൂവാർ സ്റ്റേഷൻറ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1108.jpeg",
    },
    {
      src: "assets/img/Pastevents/1109.jpeg",
      caption:
        "കോസ്റ്റൽ പോലീസ് പൂവാർ സ്റ്റേഷൻറ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1109.jpeg",
    },
    {
      src: "assets/img/Pastevents/1110.jpeg",
      caption:
        "കോസ്റ്റൽ പോലീസ് പൂവാർ സ്റ്റേഷൻറ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1110.jpeg",
    },
    {
      src: "assets/img/Pastevents/1111.jpeg",
      caption:
        "കോസ്റ്റൽ പോലീസ് പൂവാർ സ്റ്റേഷൻറ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1111.jpeg",
    },
    {
      src: "assets/img/Pastevents/1102.jpeg",
      caption:
        "കേരളാ കൗമുദി ഉദയൻകുളങ്ങര യൂണിറ്റ്, ബോധ പൗർണമി ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1102.jpeg",
    },
    {
      src: "assets/img/Pastevents/1103.jpeg",
      caption:
        "കേരളാ കൗമുദി ഉദയൻകുളങ്ങര യൂണിറ്റ്, ബോധ പൗർണമി ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1103.jpeg",
    },
    {
      src: "assets/img/Pastevents/1104.jpeg",
      caption:
        "കേരളാ കൗമുദി ഉദയൻകുളങ്ങര യൂണിറ്റ്, ബോധ പൗർണമി ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1104.jpeg",
    },
    {
      src: "assets/img/Pastevents/1105.jpeg",
      caption:
        "കേരളാ കൗമുദി ഉദയൻകുളങ്ങര യൂണിറ്റ്, ബോധ പൗർണമി ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1105.jpeg",
    },
    {
      src: "assets/img/Pastevents/1095.jpeg",
      caption:
        "നേത്ര ചാരിറ്റബിൾ സൊസൈറ്റി, കേരളാ വ്യാപാരി വ്യവസായി ഏകോപന സമിതി കാച്ചാണി യൂണിറ്റിന്റെ യുഗം നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം: ശ്രീമതി പി രമാ  (കാച്ചാണി വാർഡ് കൗൺസിലർ).",
      thumb: "assets/img/Pastevents/1095.jpeg",
    },
    {
      src: "assets/img/Pastevents/1096.jpeg",
      caption:
        "നേത്ര ചാരിറ്റബിൾ സൊസൈറ്റി, കേരളാ വ്യാപാരി വ്യവസായി ഏകോപന സമിതി കാച്ചാണി യൂണിറ്റിന്റെ യുഗം നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1096.jpeg",
    },
    {
      src: "assets/img/Pastevents/1097.jpeg",
      caption:
        "നേത്ര ചാരിറ്റബിൾ സൊസൈറ്റി, കേരളാ വ്യാപാരി വ്യവസായി ഏകോപന സമിതി കാച്ചാണി യൂണിറ്റിന്റെ യുഗം നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1097.jpeg",
    },
    {
      src: "assets/img/Pastevents/1098.jpeg",
      caption:
        "നേത്ര ചാരിറ്റബിൾ സൊസൈറ്റി, കേരളാ വ്യാപാരി വ്യവസായി ഏകോപന സമിതി കാച്ചാണി യൂണിറ്റിന്റെ യുഗം നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1098.jpeg",
    },
    {
      src: "assets/img/Pastevents/1099.jpeg",
      caption:
        "നേത്ര ചാരിറ്റബിൾ സൊസൈറ്റി, കേരളാ വ്യാപാരി വ്യവസായി ഏകോപന സമിതി കാച്ചാണി യൂണിറ്റിന്റെ യുഗം നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1099.jpeg",
    },
    {
      src: "assets/img/Pastevents/1100.jpeg",
      caption:
        "നേത്ര ചാരിറ്റബിൾ സൊസൈറ്റി, കേരളാ വ്യാപാരി വ്യവസായി ഏകോപന സമിതി കാച്ചാണി യൂണിറ്റിന്റെ യുഗം നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1100.jpeg",
    },
    {
      src: "assets/img/Pastevents/1101.jpeg",
      caption:
        "നേത്ര ചാരിറ്റബിൾ സൊസൈറ്റി, കേരളാ വ്യാപാരി വ്യവസായി ഏകോപന സമിതി കാച്ചാണി യൂണിറ്റിന്റെ യുഗം നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1101.jpeg",
    },

    {
      src: "assets/img/Pastevents/1090.jpeg",
      caption:
        "മില്ലേനിയം സ്റ്റാർസ് അസോസിയേഷൻ റീയൂണിയൻ -2001 ബാച്ചിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1090.jpeg",
    },
    {
      src: "assets/img/Pastevents/1091.jpeg",
      caption:
        "മില്ലേനിയം സ്റ്റാർസ് അസോസിയേഷൻ റീയൂണിയൻ -2001 ബാച്ചിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1091.jpeg",
    },
    {
      src: "assets/img/Pastevents/1092.jpeg",
      caption:
        "മില്ലേനിയം സ്റ്റാർസ് അസോസിയേഷൻ റീയൂണിയൻ -2001 ബാച്ചിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1092.jpeg",
    },
    {
      src: "assets/img/Pastevents/1093.jpeg",
      caption:
        "മില്ലേനിയം സ്റ്റാർസ് അസോസിയേഷൻ റീയൂണിയൻ -2001 ബാച്ചിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1093.jpeg",
    },
    {
      src: "assets/img/Pastevents/1094.jpeg",
      caption:
        "മില്ലേനിയം സ്റ്റാർസ് അസോസിയേഷൻ റീയൂണിയൻ -2001 ബാച്ചിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1094.jpeg",
    },

    {
      src: "assets/img/Pastevents/1078.jpg",
      caption:
        "കേരളാ പ്രവാസി സംഘവും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ സി കെ ഹരീന്ദ്രൻ (എംഎൽഎ പാറശ്ശാല)",
      thumb: "assets/img/Pastevents/1078.jpg",
    },
    {
      src: "assets/img/Pastevents/1079.jpg",
      caption:
        "കേരളാ പ്രവാസി സംഘവും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ സി കെ ഹരീന്ദ്രൻ (എംഎൽഎ പാറശ്ശാല)",
      thumb: "assets/img/Pastevents/1079.jpg",
    },
    {
      src: "assets/img/Pastevents/1080.jpg",
      caption:
        "കേരളാ പ്രവാസി സംഘവും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ സി കെ ഹരീന്ദ്രൻ (എംഎൽഎ പാറശ്ശാല)",
      thumb: "assets/img/Pastevents/1080.jpg",
    },
    {
      src: "assets/img/Pastevents/1081.jpg",
      caption:
        "കേരളാ പ്രവാസി സംഘവും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ സി കെ ഹരീന്ദ്രൻ (എംഎൽഎ പാറശ്ശാല)",
      thumb: "assets/img/Pastevents/1081.jpg",
    },
    {
      src: "assets/img/Pastevents/1082.jpg",
      caption:
        "കേരളാ പ്രവാസി സംഘവും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ സി കെ ഹരീന്ദ്രൻ (എംഎൽഎ പാറശ്ശാല)",
      thumb: "assets/img/Pastevents/1082.jpg",
    },
    {
      src: "assets/img/Pastevents/1083.jpg",
      caption:
        "കേരളാ പ്രവാസി സംഘവും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ സി കെ ഹരീന്ദ്രൻ (എംഎൽഎ പാറശ്ശാല)",
      thumb: "assets/img/Pastevents/1083.jpg",
    },
    {
      src: "assets/img/Pastevents/1084.jpg",
      caption:
        "കേരളാ പ്രവാസി സംഘവും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ സി കെ ഹരീന്ദ്രൻ (എംഎൽഎ പാറശ്ശാല)",
      thumb: "assets/img/Pastevents/1084.jpg",
    },
    {
      src: "assets/img/Pastevents/1085.jpg",
      caption:
        "കേരളാ പ്രവാസി സംഘവും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ സി കെ ഹരീന്ദ്രൻ (എംഎൽഎ പാറശ്ശാല)",
      thumb: "assets/img/Pastevents/1085.jpg",
    },
    {
      src: "assets/img/Pastevents/1086.jpg",
      caption:
        "കേരളാ പ്രവാസി സംഘവും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ സി കെ ഹരീന്ദ്രൻ (എംഎൽഎ പാറശ്ശാല)",
      thumb: "assets/img/Pastevents/1086.jpg",
    },
    {
      src: "assets/img/Pastevents/1087.jpg",
      caption:
        "കേരളാ പ്രവാസി സംഘവും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ സി കെ ഹരീന്ദ്രൻ (എംഎൽഎ പാറശ്ശാല)",
      thumb: "assets/img/Pastevents/1087.jpg",
    },
    {
      src: "assets/img/Pastevents/1088.jpg",
      caption:
        "കേരളാ പ്രവാസി സംഘവും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ സി കെ ഹരീന്ദ്രൻ (എംഎൽഎ പാറശ്ശാല)",
      thumb: "assets/img/Pastevents/1088.jpg",
    },
    {
      src: "assets/img/Pastevents/1089.jpg",
      caption:
        "കേരളാ പ്രവാസി സംഘവും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ സി കെ ഹരീന്ദ്രൻ (എംഎൽഎ പാറശ്ശാല)",
      thumb: "assets/img/Pastevents/1089.jpg",
    },
    {
      src: "assets/img/Pastevents/1063.jpg",
      caption:
        "സാന്ദീപനി സേവാ ട്രസ്റ്റും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം: ശ്രീ M S ഫൈസൽ ഖാൻ എംഡി നിംസ് മെഡിസിറ്റി.ജനറൽ സർജറി മേധാവി Dr ഇന്ദിരാ അമ്മ നേതൃത്വത്തിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി,ഇ എൻ റ്റി, ഓർത്തോ, കാർഡിയോളജി, ഒഫ്താൽമോളജി, ഡെൻ്റൽ എന്നി ഡിപ്പാർട്ട്മെൻ്റുകൾ പങ്കെടുത്തു.",
      thumb: "assets/img/Pastevents/1063.jpg",
    },
    {
      src: "assets/img/Pastevents/1064.jpg",
      caption:
        "സാന്ദീപനി സേവാ ട്രസ്റ്റും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം: ശ്രീ M S ഫൈസൽ ഖാൻ എംഡി നിംസ് മെഡിസിറ്റി.",
      thumb: "assets/img/Pastevents/1064.jpg",
    },
    {
      src: "assets/img/Pastevents/1065.jpg",
      caption:
        "സാന്ദീപനി സേവാ ട്രസ്റ്റും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1065.jpg",
    },
    {
      src: "assets/img/Pastevents/1066.jpg",
      caption:
        "സാന്ദീപനി സേവാ ട്രസ്റ്റും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1066.jpg",
    },
    {
      src: "assets/img/Pastevents/1067.jpg",
      caption:
        "സാന്ദീപനി സേവാ ട്രസ്റ്റും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1067.jpg",
    },
    {
      src: "assets/img/Pastevents/1068.jpg",
      caption:
        "സാന്ദീപനി സേവാ ട്രസ്റ്റും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1068.jpg",
    },
    {
      src: "assets/img/Pastevents/1069.jpg",
      caption:
        "സാന്ദീപനി സേവാ ട്രസ്റ്റും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1069.jpg",
    },
    {
      src: "assets/img/Pastevents/1070.jpg",
      caption:
        "സാന്ദീപനി സേവാ ട്രസ്റ്റും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1070.jpg",
    },
    {
      src: "assets/img/Pastevents/1071.jpg",
      caption:
        "സാന്ദീപനി സേവാ ട്രസ്റ്റും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1071.jpg",
    },
    {
      src: "assets/img/Pastevents/1072.jpg",
      caption:
        "സാന്ദീപനി സേവാ ട്രസ്റ്റും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1072.jpg",
    },
    {
      src: "assets/img/Pastevents/1073.jpg",
      caption:
        "സാന്ദീപനി സേവാ ട്രസ്റ്റും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1073.jpg",
    },
    {
      src: "assets/img/Pastevents/1074.jpg",
      caption:
        "സാന്ദീപനി സേവാ ട്രസ്റ്റും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1074.jpg",
    },
    {
      src: "assets/img/Pastevents/1075.jpg",
      caption:
        "സാന്ദീപനി സേവാ ട്രസ്റ്റും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1075.jpg",
    },
    {
      src: "assets/img/Pastevents/1076.jpg",
      caption:
        "സാന്ദീപനി സേവാ ട്രസ്റ്റും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1076.jpg",
    },
    {
      src: "assets/img/Pastevents/1077.jpg",
      caption:
        "സാന്ദീപനി സേവാ ട്രസ്റ്റും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1077.jpg",
    },
    {
      src: "assets/img/Pastevents/1056.jpg",
      caption:
        "യുവമോർച്ച ശ്രീകാര്യം യൂണിറ്റ്,ട്രിവാൻഡ്രം സൂര്യ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ ചെമ്പഴന്തി ഉദയൻ (ശ്രീകാര്യം വാർഡ്).",
      thumb: "assets/img/Pastevents/1056.jpg",
    },
    {
      src: "assets/img/Pastevents/1057.jpg",
      caption:
        "യുവമോർച്ച ശ്രീകാര്യം യൂണിറ്റ്,ട്രിവാൻഡ്രം സൂര്യ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1057.jpg",
    },
    {
      src: "assets/img/Pastevents/1058.jpg",
      caption:
        "യുവമോർച്ച ശ്രീകാര്യം യൂണിറ്റ്,ട്രിവാൻഡ്രം സൂര്യ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1058.jpg",
    },
    {
      src: "assets/img/Pastevents/1059.jpg",
      caption:
        "യുവമോർച്ച ശ്രീകാര്യം യൂണിറ്റ്,ട്രിവാൻഡ്രം സൂര്യ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1059.jpg",
    },
    {
      src: "assets/img/Pastevents/1060.jpg",
      caption:
        "യുവമോർച്ച ശ്രീകാര്യം യൂണിറ്റ്,ട്രിവാൻഡ്രം സൂര്യ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1060.jpg",
    },
    {
      src: "assets/img/Pastevents/1061.jpg",
      caption:
        "യുവമോർച്ച ശ്രീകാര്യം യൂണിറ്റ്,ട്രിവാൻഡ്രം സൂര്യ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1061.jpg",
    },
    {
      src: "assets/img/Pastevents/1062.jpg",
      caption:
        "യുവമോർച്ച ശ്രീകാര്യം യൂണിറ്റ്,ട്രിവാൻഡ്രം സൂര്യ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1062.jpg",
    },
    {
      src: "assets/img/Pastevents/1049.jpg",
      caption:
        "KSRTC പുതുതായി ആരംഭിക്കുന്ന ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 300-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ്(മൂന്നാം ദിനം) നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1049.jpg",
    },
    {
      src: "assets/img/Pastevents/1050.jpg",
      caption:
        "KSRTC പുതുതായി ആരംഭിക്കുന്ന ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 300-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ്(മൂന്നാം ദിനം) നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1050.jpg",
    },
    {
      src: "assets/img/Pastevents/1051.jpg",
      caption:
        "KSRTC പുതുതായി ആരംഭിക്കുന്ന ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 300-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ്(മൂന്നാം ദിനം) നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1051.jpg",
    },
    {
      src: "assets/img/Pastevents/1052.jpg",
      caption:
        "KSRTC പുതുതായി ആരംഭിക്കുന്ന ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 300-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ്(മൂന്നാം ദിനം) നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1052.jpg",
    },
    {
      src: "assets/img/Pastevents/1053.jpg",
      caption:
        "KSRTC പുതുതായി ആരംഭിക്കുന്ന ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 300-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ്(മൂന്നാം ദിനം) നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1053.jpg",
    },
    {
      src: "assets/img/Pastevents/1054.jpg",
      caption:
        "KSRTC പുതുതായി ആരംഭിക്കുന്ന ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 300-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ്(മൂന്നാം ദിനം) നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1054.jpg",
    },
    {
      src: "assets/img/Pastevents/1055.jpg",
      caption:
        "KSRTC പുതുതായി ആരംഭിക്കുന്ന ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 300-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ്(മൂന്നാം ദിനം) നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1055.jpg",
    },
    {
      src: "assets/img/Pastevents/1040.jpg",
      caption:
        "പോത്തൻകോട് ഗ്രാമ പഞ്ചായത്ത്, പോത്തൻകോട് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം: ശ്രീ റ്റി ആർ അനിൽ (പ്രസിഡൻറ് പോത്തൻകോട് ഗ്രാമ പഞ്ചായത്ത്).",
      thumb: "assets/img/Pastevents/1040.jpg",
    },
    {
      src: "assets/img/Pastevents/1041.jpg",
      caption:
        "പോത്തൻകോട് ഗ്രാമ പഞ്ചായത്ത്, പോത്തൻകോട് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1041.jpg",
    },
    {
      src: "assets/img/Pastevents/1042.jpg",
      caption:
        "പോത്തൻകോട് ഗ്രാമ പഞ്ചായത്ത്, പോത്തൻകോട് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1042.jpg",
    },
    {
      src: "assets/img/Pastevents/1043.jpg",
      caption:
        "പോത്തൻകോട് ഗ്രാമ പഞ്ചായത്ത്, പോത്തൻകോട് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1043.jpg",
    },
    {
      src: "assets/img/Pastevents/1044.jpg",
      caption:
        "പോത്തൻകോട് ഗ്രാമ പഞ്ചായത്ത്, പോത്തൻകോട് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1044.jpg",
    },
    {
      src: "assets/img/Pastevents/1045.jpg",
      caption:
        "പോത്തൻകോട് ഗ്രാമ പഞ്ചായത്ത്, പോത്തൻകോട് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1045.jpg",
    },
    {
      src: "assets/img/Pastevents/1046.jpg",
      caption:
        "പോത്തൻകോട് ഗ്രാമ പഞ്ചായത്ത്, പോത്തൻകോട് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1046.jpg",
    },
    {
      src: "assets/img/Pastevents/1047.jpg",
      caption:
        "പോത്തൻകോട് ഗ്രാമ പഞ്ചായത്ത്, പോത്തൻകോട് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1047.jpg",
    },
    {
      src: "assets/img/Pastevents/1048.jpg",
      caption:
        "പോത്തൻകോട് ഗ്രാമ പഞ്ചായത്ത്, പോത്തൻകോട് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1048.jpg",
    },

    {
      src: "assets/img/Pastevents/1033.jpg",
      caption:
        "ധർമ്മസേവിനി ഗ്രന്ഥശാല ഭഗവതിനടയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ ഭഗത് റൂഫസ് (ജില്ലാ പഞ്ചായത്ത് മെമ്പർ).",
      thumb: "assets/img/Pastevents/1033.jpg",
    },
    {
      src: "assets/img/Pastevents/1034.jpg",
      caption:
        "ധർമ്മസേവിനി ഗ്രന്ഥശാല ഭഗവതിനടയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1034.jpg",
    },
    {
      src: "assets/img/Pastevents/1035.jpg",
      caption:
        "ധർമ്മസേവിനി ഗ്രന്ഥശാല ഭഗവതിനടയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1035.jpg",
    },
    {
      src: "assets/img/Pastevents/1036.jpg",
      caption:
        "ധർമ്മസേവിനി ഗ്രന്ഥശാല ഭഗവതിനടയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1036.jpg",
    },
    {
      src: "assets/img/Pastevents/1037.jpg",
      caption:
        "ധർമ്മസേവിനി ഗ്രന്ഥശാല ഭഗവതിനടയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1037.jpg",
    },
    {
      src: "assets/img/Pastevents/1038.jpg",
      caption:
        "ധർമ്മസേവിനി ഗ്രന്ഥശാല ഭഗവതിനടയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1038.jpg",
    },
    {
      src: "assets/img/Pastevents/1039.jpg",
      caption:
        "ധർമ്മസേവിനി ഗ്രന്ഥശാല ഭഗവതിനടയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1039.jpg",
    },

    {
      src: "assets/img/Pastevents/1024.jpg",
      caption:
        "തിരുവനന്തപുരം വൈഎംസിഎ,തിരുവനന്തപുരം സിറ്റി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പ് ഉദ്ഘാടനം:ശ്രീ കളത്തറ മധു ,( പ്രസിഡൻറ് ഗ്രാമ പഞ്ചായത്ത്, അരുവിക്കര.",
      thumb: "assets/img/Pastevents/1024.jpg",
    },
    {
      src: "assets/img/Pastevents/1025.jpg",
      caption:
        "തിരുവനന്തപുരം വൈഎംസിഎ,തിരുവനന്തപുരം സിറ്റി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1025.jpg",
    },
    {
      src: "assets/img/Pastevents/1026.jpg",
      caption:
        "തിരുവനന്തപുരം വൈഎംസിഎ,തിരുവനന്തപുരം സിറ്റി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1026.jpg",
    },
    {
      src: "assets/img/Pastevents/1027.jpg",
      caption:
        "തിരുവനന്തപുരം വൈഎംസിഎ,തിരുവനന്തപുരം സിറ്റി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1027.jpg",
    },
    {
      src: "assets/img/Pastevents/1028.jpg",
      caption:
        "തിരുവനന്തപുരം വൈഎംസിഎ,തിരുവനന്തപുരം സിറ്റി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1028.jpg",
    },
    {
      src: "assets/img/Pastevents/1029.jpg",
      caption:
        "തിരുവനന്തപുരം വൈഎംസിഎ,തിരുവനന്തപുരം സിറ്റി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1029.jpg",
    },
    {
      src: "assets/img/Pastevents/1030.jpg",
      caption:
        "തിരുവനന്തപുരം വൈഎംസിഎ,തിരുവനന്തപുരം സിറ്റി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1030.jpg",
    },
    {
      src: "assets/img/Pastevents/1031.jpg",
      caption:
        "തിരുവനന്തപുരം വൈഎംസിഎ,തിരുവനന്തപുരം സിറ്റി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1031.jpg",
    },
    {
      src: "assets/img/Pastevents/1032.jpg",
      caption:
        "തിരുവനന്തപുരം വൈഎംസിഎ,തിരുവനന്തപുരം സിറ്റി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1032.jpg",
    },

    {
      src: "assets/img/Pastevents/1016.jpg",
      caption:
        "കേരളാ വ്യാപാരി വ്യവസായി ഏകോപന സമിതിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം: ശ്രീ പെരിങ്ങമ്മല രാമചന്ദ്രൻ ( കേരളാ വ്യാപാരി വ്യവസായി ഏകോപന സമിതി തിരുവനന്തപുരം ജില്ലാ പ്രസിഡൻ്റ് ).",
      thumb: "assets/img/Pastevents/1016.jpg",
    },
    {
      src: "assets/img/Pastevents/1017.jpg",
      caption:
        "കേരളാ വ്യാപാരി വ്യവസായി ഏകോപന സമിതിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1017.jpg",
    },
    {
      src: "assets/img/Pastevents/1018.jpg",
      caption:
        "കേരളാ വ്യാപാരി വ്യവസായി ഏകോപന സമിതിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1018.jpg",
    },
    {
      src: "assets/img/Pastevents/1019.jpg",
      caption:
        "കേരളാ വ്യാപാരി വ്യവസായി ഏകോപന സമിതിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1019.jpg",
    },
    {
      src: "assets/img/Pastevents/1020.jpg",
      caption:
        "കേരളാ വ്യാപാരി വ്യവസായി ഏകോപന സമിതിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1020.jpg",
    },
    {
      src: "assets/img/Pastevents/1021.jpg",
      caption:
        "കേരളാ വ്യാപാരി വ്യവസായി ഏകോപന സമിതിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1021.jpg",
    },
    {
      src: "assets/img/Pastevents/1022.jpg",
      caption:
        "കേരളാ വ്യാപാരി വ്യവസായി ഏകോപന സമിതിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1022.jpg",
    },
    {
      src: "assets/img/Pastevents/1023.jpg",
      caption:
        "കേരളാ വ്യാപാരി വ്യവസായി ഏകോപന സമിതിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1023.jpg",
    },

    {
      src: "assets/img/Pastevents/1008.jpg",
      caption:
        "സ്വാമി വിവേകാനന്ദ സേവാ സംഘം, ട്രിവാൻഡ്രം ക്രിസ്റ്റൽ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1008.jpg",
    },
    {
      src: "assets/img/Pastevents/1009.jpg",
      caption:
        "സ്വാമി വിവേകാനന്ദ സേവാ സംഘം, ട്രിവാൻഡ്രം ക്രിസ്റ്റൽ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1009.jpg",
    },
    {
      src: "assets/img/Pastevents/1010.jpg",
      caption:
        "സ്വാമി വിവേകാനന്ദ സേവാ സംഘം, ട്രിവാൻഡ്രം ക്രിസ്റ്റൽ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1010.jpg",
    },
    {
      src: "assets/img/Pastevents/1011.jpg",
      caption:
        "സ്വാമി വിവേകാനന്ദ സേവാ സംഘം, ട്രിവാൻഡ്രം ക്രിസ്റ്റൽ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1011.jpg",
    },
    {
      src: "assets/img/Pastevents/1012.jpg",
      caption:
        "സ്വാമി വിവേകാനന്ദ സേവാ സംഘം, ട്രിവാൻഡ്രം ക്രിസ്റ്റൽ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1012.jpg",
    },
    {
      src: "assets/img/Pastevents/1013.jpg",
      caption:
        "സ്വാമി വിവേകാനന്ദ സേവാ സംഘം, ട്രിവാൻഡ്രം ക്രിസ്റ്റൽ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1013.jpg",
    },
    {
      src: "assets/img/Pastevents/1014.jpg",
      caption:
        "സ്വാമി വിവേകാനന്ദ സേവാ സംഘം, ട്രിവാൻഡ്രം ക്രിസ്റ്റൽ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1014.jpg",
    },
    {
      src: "assets/img/Pastevents/1015.jpg",
      caption:
        "സ്വാമി വിവേകാനന്ദ സേവാ സംഘം, ട്രിവാൻഡ്രം ക്രിസ്റ്റൽ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/1015.jpg",
    },

    {
      src: "assets/img/Pastevents/1000.jpg",
      caption:
        "കല്ലിയൂർ സൗത്ത് റെസിഡൻഷ്യൽ അസോസിയേഷനും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു",
      thumb: "assets/img/Pastevents/1000.jpg",
    },
    {
      src: "assets/img/Pastevents/1001.jpg",
      caption:
        "കല്ലിയൂർ സൗത്ത് റെസിഡൻഷ്യൽ അസോസിയേഷനും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു",
      thumb: "assets/img/Pastevents/1001.jpg",
    },
    {
      src: "assets/img/Pastevents/1002.jpg",
      caption:
        "കല്ലിയൂർ സൗത്ത് റെസിഡൻഷ്യൽ അസോസിയേഷനും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു",
      thumb: "assets/img/Pastevents/1002.jpg",
    },
    {
      src: "assets/img/Pastevents/1003.jpg",
      caption:
        "കല്ലിയൂർ സൗത്ത് റെസിഡൻഷ്യൽ അസോസിയേഷനും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു",
      thumb: "assets/img/Pastevents/1003.jpg",
    },
    {
      src: "assets/img/Pastevents/1004.jpg",
      caption:
        "കല്ലിയൂർ സൗത്ത് റെസിഡൻഷ്യൽ അസോസിയേഷനും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു",
      thumb: "assets/img/Pastevents/1004.jpg",
    },
    {
      src: "assets/img/Pastevents/1005.jpg",
      caption:
        "കല്ലിയൂർ സൗത്ത് റെസിഡൻഷ്യൽ അസോസിയേഷനും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു",
      thumb: "assets/img/Pastevents/1005.jpg",
    },
    {
      src: "assets/img/Pastevents/1006.jpg",
      caption:
        "കല്ലിയൂർ സൗത്ത് റെസിഡൻഷ്യൽ അസോസിയേഷനും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു",
      thumb: "assets/img/Pastevents/1006.jpg",
    },
    {
      src: "assets/img/Pastevents/1007.jpg",
      caption:
        "കല്ലിയൂർ സൗത്ത് റെസിഡൻഷ്യൽ അസോസിയേഷനും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു",
      thumb: "assets/img/Pastevents/1007.jpg",
    },

    {
      src: "assets/img/Pastevents/992.jpg",
      caption:
        "തമിഴ്നാട് ഗവൺമെന്റ് ഹെൽത്ത് സ്കീം, നൂറുൽ ഇസ്‌ലാം ആർട്ട്സ് ആൻഡ് സയൻസ് കോളേജ്, കുമാരകോവിൽ നാഷണൽ സർവീസ് സ്കീം നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/992.jpg",
    },
    {
      src: "assets/img/Pastevents/993.jpg",
      caption:
        "തമിഴ്നാട് ഗവൺമെന്റ് ഹെൽത്ത് സ്കീം, നൂറുൽ ഇസ്‌ലാം ആർട്ട്സ് ആൻഡ് സയൻസ് കോളേജ്, കുമാരകോവിൽ നാഷണൽ സർവീസ് സ്കീം നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/993.jpg",
    },
    {
      src: "assets/img/Pastevents/994.jpg",
      caption:
        "തമിഴ്നാട് ഗവൺമെന്റ് ഹെൽത്ത് സ്കീം, നൂറുൽ ഇസ്‌ലാം ആർട്ട്സ് ആൻഡ് സയൻസ് കോളേജ്, കുമാരകോവിൽ നാഷണൽ സർവീസ് സ്കീം നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/994.jpg",
    },
    {
      src: "assets/img/Pastevents/995.jpg",
      caption:
        "തമിഴ്നാട് ഗവൺമെന്റ് ഹെൽത്ത് സ്കീം, നൂറുൽ ഇസ്‌ലാം ആർട്ട്സ് ആൻഡ് സയൻസ് കോളേജ്, കുമാരകോവിൽ നാഷണൽ സർവീസ് സ്കീം നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/995.jpg",
    },
    {
      src: "assets/img/Pastevents/996.jpg",
      caption:
        "തമിഴ്നാട് ഗവൺമെന്റ് ഹെൽത്ത് സ്കീം, നൂറുൽ ഇസ്‌ലാം ആർട്ട്സ് ആൻഡ് സയൻസ് കോളേജ്, കുമാരകോവിൽ നാഷണൽ സർവീസ് സ്കീം നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/996.jpg",
    },
    {
      src: "assets/img/Pastevents/997.jpg",
      caption:
        "തമിഴ്നാട് ഗവൺമെന്റ് ഹെൽത്ത് സ്കീം, നൂറുൽ ഇസ്‌ലാം ആർട്ട്സ് ആൻഡ് സയൻസ് കോളേജ്, കുമാരകോവിൽ നാഷണൽ സർവീസ് സ്കീം നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/997.jpg",
    },
    {
      src: "assets/img/Pastevents/998.jpg",
      caption:
        "തമിഴ്നാട് ഗവൺമെന്റ് ഹെൽത്ത് സ്കീം, നൂറുൽ ഇസ്‌ലാം ആർട്ട്സ് ആൻഡ് സയൻസ് കോളേജ്, കുമാരകോവിൽ നാഷണൽ സർവീസ് സ്കീം നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/998.jpg",
    },
    {
      src: "assets/img/Pastevents/999.jpg",
      caption:
        "തമിഴ്നാട് ഗവൺമെന്റ് ഹെൽത്ത് സ്കീം, നൂറുൽ ഇസ്‌ലാം ആർട്ട്സ് ആൻഡ് സയൻസ് കോളേജ്, കുമാരകോവിൽ നാഷണൽ സർവീസ് സ്കീം നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/999.jpg",
    },

    {
      src: "assets/img/Pastevents/981.jpg",
      caption:
        "മണക്കാട് പുത്തൻ റോഡ് റെസിഡൻഷ്യൽ അസോസിയേഷൻ, ട്രിവാൻഡ്രം കിങ്ങ്സിറ്റി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/981.jpg",
    },
    {
      src: "assets/img/Pastevents/982.jpg",
      caption:
        "മണക്കാട് പുത്തൻ റോഡ് റെസിഡൻഷ്യൽ അസോസിയേഷൻ, ട്രിവാൻഡ്രം കിങ്ങ്സിറ്റി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/982.jpg",
    },
    {
      src: "assets/img/Pastevents/983.jpg",
      caption:
        "മണക്കാട് പുത്തൻ റോഡ് റെസിഡൻഷ്യൽ അസോസിയേഷൻ, ട്രിവാൻഡ്രം കിങ്ങ്സിറ്റി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/983.jpg",
    },
    {
      src: "assets/img/Pastevents/984.jpg",
      caption:
        "മണക്കാട് പുത്തൻ റോഡ് റെസിഡൻഷ്യൽ അസോസിയേഷൻ, ട്രിവാൻഡ്രം കിങ്ങ്സിറ്റി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/984.jpg",
    },
    {
      src: "assets/img/Pastevents/985.jpg",
      caption:
        "മണക്കാട് പുത്തൻ റോഡ് റെസിഡൻഷ്യൽ അസോസിയേഷൻ, ട്രിവാൻഡ്രം കിങ്ങ്സിറ്റി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/985.jpg",
    },
    {
      src: "assets/img/Pastevents/986.jpg",
      caption:
        "മണക്കാട് പുത്തൻ റോഡ് റെസിഡൻഷ്യൽ അസോസിയേഷൻ, ട്രിവാൻഡ്രം കിങ്ങ്സിറ്റി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/986.jpg",
    },
    {
      src: "assets/img/Pastevents/987.jpg",
      caption:
        "മണക്കാട് പുത്തൻ റോഡ് റെസിഡൻഷ്യൽ അസോസിയേഷൻ, ട്രിവാൻഡ്രം കിങ്ങ്സിറ്റി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/987.jpg",
    },
    {
      src: "assets/img/Pastevents/988.jpg",
      caption:
        "മണക്കാട് പുത്തൻ റോഡ് റെസിഡൻഷ്യൽ അസോസിയേഷൻ, ട്രിവാൻഡ്രം കിങ്ങ്സിറ്റി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/988.jpg",
    },
    {
      src: "assets/img/Pastevents/989.jpg",
      caption:
        "മണക്കാട് പുത്തൻ റോഡ് റെസിഡൻഷ്യൽ അസോസിയേഷൻ, ട്രിവാൻഡ്രം കിങ്ങ്സിറ്റി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/989.jpg",
    },
    {
      src: "assets/img/Pastevents/990.jpg",
      caption:
        "മണക്കാട് പുത്തൻ റോഡ് റെസിഡൻഷ്യൽ അസോസിയേഷൻ, ട്രിവാൻഡ്രം കിങ്ങ്സിറ്റി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/990.jpg",
    },
    {
      src: "assets/img/Pastevents/991.jpg",
      caption:
        "മണക്കാട് പുത്തൻ റോഡ് റെസിഡൻഷ്യൽ അസോസിയേഷൻ, ട്രിവാൻഡ്രം കിങ്ങ്സിറ്റി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/991.jpg",
    },

    {
      src: "assets/img/Pastevents/974.jpg",
      caption:
        "ഫെഡറേഷൻ ഓഫ് റെസിഡൻഷ്യൽ അസോസിയേഷൻ വട്ടിയൂർക്കാവ്,വട്ടിയൂർക്കാവ് മോഡൽ ലയൺസ് ക്ലബ്,പുന്നാക്കോണം റെസിഡൻഷ്യൽ അസോസിയേഷനും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീമതി പി രമ ( വാർഡ് കൗൺസിലർ കാച്ചാണി)",
      thumb: "assets/img/Pastevents/974.jpg",
    },
    {
      src: "assets/img/Pastevents/975.jpg",
      caption:
        "ഫെഡറേഷൻ ഓഫ് റെസിഡൻഷ്യൽ അസോസിയേഷൻ വട്ടിയൂർക്കാവ്,വട്ടിയൂർക്കാവ് മോഡൽ ലയൺസ് ക്ലബ്,പുന്നാക്കോണം റെസിഡൻഷ്യൽ അസോസിയേഷനും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/975.jpg",
    },
    {
      src: "assets/img/Pastevents/976.jpg",
      caption:
        "ഫെഡറേഷൻ ഓഫ് റെസിഡൻഷ്യൽ അസോസിയേഷൻ വട്ടിയൂർക്കാവ്,വട്ടിയൂർക്കാവ് മോഡൽ ലയൺസ് ക്ലബ്,പുന്നാക്കോണം റെസിഡൻഷ്യൽ അസോസിയേഷനും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/976.jpg",
    },
    {
      src: "assets/img/Pastevents/977.jpg",
      caption:
        "ഫെഡറേഷൻ ഓഫ് റെസിഡൻഷ്യൽ അസോസിയേഷൻ വട്ടിയൂർക്കാവ്,വട്ടിയൂർക്കാവ് മോഡൽ ലയൺസ് ക്ലബ്,പുന്നാക്കോണം റെസിഡൻഷ്യൽ അസോസിയേഷനും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/977.jpg",
    },
    {
      src: "assets/img/Pastevents/978.jpg",
      caption:
        "ഫെഡറേഷൻ ഓഫ് റെസിഡൻഷ്യൽ അസോസിയേഷൻ വട്ടിയൂർക്കാവ്,വട്ടിയൂർക്കാവ് മോഡൽ ലയൺസ് ക്ലബ്,പുന്നാക്കോണം റെസിഡൻഷ്യൽ അസോസിയേഷനും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/978.jpg",
    },
    {
      src: "assets/img/Pastevents/979.jpg",
      caption:
        "ഫെഡറേഷൻ ഓഫ് റെസിഡൻഷ്യൽ അസോസിയേഷൻ വട്ടിയൂർക്കാവ്,വട്ടിയൂർക്കാവ് മോഡൽ ലയൺസ് ക്ലബ്,പുന്നാക്കോണം റെസിഡൻഷ്യൽ അസോസിയേഷനും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/979.jpg",
    },
    {
      src: "assets/img/Pastevents/980.jpg",
      caption:
        "ഫെഡറേഷൻ ഓഫ് റെസിഡൻഷ്യൽ അസോസിയേഷൻ വട്ടിയൂർക്കാവ്,വട്ടിയൂർക്കാവ് മോഡൽ ലയൺസ് ക്ലബ്,പുന്നാക്കോണം റെസിഡൻഷ്യൽ അസോസിയേഷനും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/980.jpg",
    },

    {
      src: "assets/img/Pastevents/964.jpg",
      caption:
        "കാവിയാട് ദിനകര പണിക്കർ സാംസ്കാരിക വേദിയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/964.jpg",
    },
    {
      src: "assets/img/Pastevents/965.jpg",
      caption:
        "കാവിയാട് ദിനകര പണിക്കർ സാംസ്കാരിക വേദിയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/965.jpg",
    },
    {
      src: "assets/img/Pastevents/966.jpg",
      caption:
        "കാവിയാട് ദിനകര പണിക്കർ സാംസ്കാരിക വേദിയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/966.jpg",
    },
    {
      src: "assets/img/Pastevents/967.jpg",
      caption:
        "കാവിയാട് ദിനകര പണിക്കർ സാംസ്കാരിക വേദിയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/967.jpg",
    },
    {
      src: "assets/img/Pastevents/968.jpg",
      caption:
        "കാവിയാട് ദിനകര പണിക്കർ സാംസ്കാരിക വേദിയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/968.jpg",
    },
    {
      src: "assets/img/Pastevents/969.jpg",
      caption:
        "കാവിയാട് ദിനകര പണിക്കർ സാംസ്കാരിക വേദിയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/969.jpg",
    },
    {
      src: "assets/img/Pastevents/970.jpg",
      caption:
        "കാവിയാട് ദിനകര പണിക്കർ സാംസ്കാരിക വേദിയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/970.jpg",
    },
    {
      src: "assets/img/Pastevents/971.jpg",
      caption:
        "കാവിയാട് ദിനകര പണിക്കർ സാംസ്കാരിക വേദിയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/971.jpg",
    },
    {
      src: "assets/img/Pastevents/972.jpg",
      caption:
        "കാവിയാട് ദിനകര പണിക്കർ സാംസ്കാരിക വേദിയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/972.jpg",
    },
    {
      src: "assets/img/Pastevents/973.jpg",
      caption:
        "കാവിയാട് ദിനകര പണിക്കർ സാംസ്കാരിക വേദിയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/973.jpg",
    },

    {
      src: "assets/img/Pastevents/958.jpg",
      caption:
        "പഞ്ചതാരകം സാംസ്കാരിക കേന്ദ്രവും അയ്യൻകോയിക്കൽ റെസിഡൻഷ്യൽ അസോസിയേഷനും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പ് ഉദ്ഘാടനം: ശ്രീ ജെ എസ് പ്രവീൺ (SHO സൈബർ സിറ്റി , കഴക്കൂട്ടം",
      thumb: "assets/img/Pastevents/958.jpg",
    },
    {
      src: "assets/img/Pastevents/959.jpg",
      caption:
        "പഞ്ചതാരകം സാംസ്കാരിക കേന്ദ്രവും അയ്യൻകോയിക്കൽ റെസിഡൻഷ്യൽ അസോസിയേഷനും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/959.jpg",
    },
    {
      src: "assets/img/Pastevents/960.jpg",
      caption:
        "പഞ്ചതാരകം സാംസ്കാരിക കേന്ദ്രവും അയ്യൻകോയിക്കൽ റെസിഡൻഷ്യൽ അസോസിയേഷനും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/960.jpg",
    },
    {
      src: "assets/img/Pastevents/961.jpg",
      caption:
        "പഞ്ചതാരകം സാംസ്കാരിക കേന്ദ്രവും അയ്യൻകോയിക്കൽ റെസിഡൻഷ്യൽ അസോസിയേഷനും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/961.jpg",
    },
    {
      src: "assets/img/Pastevents/962.jpg",
      caption:
        "പഞ്ചതാരകം സാംസ്കാരിക കേന്ദ്രവും അയ്യൻകോയിക്കൽ റെസിഡൻഷ്യൽ അസോസിയേഷനും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/962.jpg",
    },
    {
      src: "assets/img/Pastevents/963.jpg",
      caption:
        "പഞ്ചതാരകം സാംസ്കാരിക കേന്ദ്രവും അയ്യൻകോയിക്കൽ റെസിഡൻഷ്യൽ അസോസിയേഷനും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/963.jpg",
    },

    {
      src: "assets/img/Pastevents/950.jpg",
      caption:
        "കടയൽമുടുബ് ദേവി ക്ഷേത്ര ട്രസ്റ്റും റീജൻസി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/950.jpg",
    },
    {
      src: "assets/img/Pastevents/951.jpg",
      caption:
        "കടയൽമുടുബ് ദേവി ക്ഷേത്ര ട്രസ്റ്റും റീജൻസി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/951.jpg",
    },
    {
      src: "assets/img/Pastevents/952.jpg",
      caption:
        "കടയൽമുടുബ് ദേവി ക്ഷേത്ര ട്രസ്റ്റും റീജൻസി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/952.jpg",
    },
    {
      src: "assets/img/Pastevents/953.jpg",
      caption:
        "കടയൽമുടുബ് ദേവി ക്ഷേത്ര ട്രസ്റ്റും റീജൻസി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/953.jpg",
    },
    {
      src: "assets/img/Pastevents/954.jpg",
      caption:
        "കടയൽമുടുബ് ദേവി ക്ഷേത്ര ട്രസ്റ്റും റീജൻസി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/954.jpg",
    },
    {
      src: "assets/img/Pastevents/955.jpg",
      caption:
        "കടയൽമുടുബ് ദേവി ക്ഷേത്ര ട്രസ്റ്റും റീജൻസി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/955.jpg",
    },
    {
      src: "assets/img/Pastevents/956.jpg",
      caption:
        "കടയൽമുടുബ് ദേവി ക്ഷേത്ര ട്രസ്റ്റും റീജൻസി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/956.jpg",
    },
    {
      src: "assets/img/Pastevents/957.jpg",
      caption:
        "കടയൽമുടുബ് ദേവി ക്ഷേത്ര ട്രസ്റ്റും റീജൻസി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/957.jpg",
    },

    {
      src: "assets/img/Pastevents/940.jpg",
      caption:
        "പാലുവള്ളി ബ്രദേഴ്സ് റെസിഡൻസ് വെൽഫെയർ അസോസിയേഷ്നും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പ് ഉദ്ഘാടനം:ശ്രീ തെന്നൂർ ശിഹാബ് (ഫ്രാറ്റ് വിതുര മേഖല സെക്രട്ടറി)",
      thumb: "assets/img/Pastevents/940.jpg",
    },
    {
      src: "assets/img/Pastevents/941.jpg",
      caption:
        "പാലുവള്ളി ബ്രദേഴ്സ് റെസിഡൻസ് വെൽഫെയർ അസോസിയേഷ്നും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/941.jpg",
    },
    {
      src: "assets/img/Pastevents/942.jpg",
      caption:
        "പാലുവള്ളി ബ്രദേഴ്സ് റെസിഡൻസ് വെൽഫെയർ അസോസിയേഷ്നും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/942.jpg",
    },
    {
      src: "assets/img/Pastevents/943.jpg",
      caption:
        "പാലുവള്ളി ബ്രദേഴ്സ് റെസിഡൻസ് വെൽഫെയർ അസോസിയേഷ്നും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/943.jpg",
    },
    {
      src: "assets/img/Pastevents/944.jpg",
      caption:
        "പാലുവള്ളി ബ്രദേഴ്സ് റെസിഡൻസ് വെൽഫെയർ അസോസിയേഷ്നും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/944.jpg",
    },
    {
      src: "assets/img/Pastevents/945.jpg",
      caption:
        "പാലുവള്ളി ബ്രദേഴ്സ് റെസിഡൻസ് വെൽഫെയർ അസോസിയേഷ്നും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/945.jpg",
    },
    {
      src: "assets/img/Pastevents/946.jpg",
      caption:
        "പാലുവള്ളി ബ്രദേഴ്സ് റെസിഡൻസ് വെൽഫെയർ അസോസിയേഷ്നും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/946.jpg",
    },
    {
      src: "assets/img/Pastevents/947.jpg",
      caption:
        "പാലുവള്ളി ബ്രദേഴ്സ് റെസിഡൻസ് വെൽഫെയർ അസോസിയേഷ്നും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/947.jpg",
    },
    {
      src: "assets/img/Pastevents/948.jpg",
      caption:
        "പാലുവള്ളി ബ്രദേഴ്സ് റെസിഡൻസ് വെൽഫെയർ അസോസിയേഷ്നും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/948.jpg",
    },
    {
      src: "assets/img/Pastevents/949.jpg",
      caption:
        "പാലുവള്ളി ബ്രദേഴ്സ് റെസിഡൻസ് വെൽഫെയർ അസോസിയേഷ്നും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/949.jpg",
    },

    {
      src: "assets/img/Pastevents/927.jpg",
      caption:
        "KSRTC പുതുതായി ആരംഭിക്കുന്ന ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 300-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ്(രണ്ടാം ദിനം) നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/927.jpg",
    },
    {
      src: "assets/img/Pastevents/928.jpg",
      caption:
        "KSRTC പുതുതായി ആരംഭിക്കുന്ന ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 300-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ്(രണ്ടാം ദിനം) നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/928.jpg",
    },
    {
      src: "assets/img/Pastevents/929.jpg",
      caption:
        "KSRTC പുതുതായി ആരംഭിക്കുന്ന ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 300-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ്(രണ്ടാം ദിനം) നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/929.jpg",
    },
    {
      src: "assets/img/Pastevents/930.jpg",
      caption:
        "KSRTC പുതുതായി ആരംഭിക്കുന്ന ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 300-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ്(രണ്ടാം ദിനം) നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/930.jpg",
    },
    {
      src: "assets/img/Pastevents/931.jpg",
      caption:
        "KSRTC പുതുതായി ആരംഭിക്കുന്ന ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 300-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ്(രണ്ടാം ദിനം) നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/931.jpg",
    },
    {
      src: "assets/img/Pastevents/932.jpg",
      caption:
        "KSRTC പുതുതായി ആരംഭിക്കുന്ന ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 300-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ്(രണ്ടാം ദിനം) നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/932.jpg",
    },
    {
      src: "assets/img/Pastevents/933.jpg",
      caption:
        "KSRTC പുതുതായി ആരംഭിക്കുന്ന ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 300-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ്(രണ്ടാം ദിനം) നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/933.jpg",
    },
    {
      src: "assets/img/Pastevents/934.jpg",
      caption:
        "KSRTC പുതുതായി ആരംഭിക്കുന്ന ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 300-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ്(രണ്ടാം ദിനം) നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/934.jpg",
    },
    {
      src: "assets/img/Pastevents/935.jpg",
      caption:
        "KSRTC പുതുതായി ആരംഭിക്കുന്ന ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 300-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ്(രണ്ടാം ദിനം) നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/935.jpg",
    },
    {
      src: "assets/img/Pastevents/936.jpg",
      caption:
        "KSRTC പുതുതായി ആരംഭിക്കുന്ന ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 300-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ്(രണ്ടാം ദിനം) നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/936.jpg",
    },
    {
      src: "assets/img/Pastevents/937.jpg",
      caption:
        "KSRTC പുതുതായി ആരംഭിക്കുന്ന ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 300-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ്(രണ്ടാം ദിനം) നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/937.jpg",
    },
    {
      src: "assets/img/Pastevents/938.jpg",
      caption:
        "KSRTC പുതുതായി ആരംഭിക്കുന്ന ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 300-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ്(രണ്ടാം ദിനം) നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/938.jpg",
    },
    {
      src: "assets/img/Pastevents/939.jpg",
      caption:
        "KSRTC പുതുതായി ആരംഭിക്കുന്ന ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 300-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ്(രണ്ടാം ദിനം) നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/939.jpg",
    },

    {
      src: "assets/img/Pastevents/915.jpg",
      caption:
        "KSRTC പുതുതായി ആരംഭിക്കുന്ന ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 300-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ്(ഒന്നാം ദിനം) നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/915.jpg",
    },
    {
      src: "assets/img/Pastevents/916.jpg",
      caption:
        "KSRTC പുതുതായി ആരംഭിക്കുന്ന ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 300-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ്(ഒന്നാം ദിനം) നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/916.jpg",
    },
    {
      src: "assets/img/Pastevents/917.jpg",
      caption:
        "KSRTC പുതുതായി ആരംഭിക്കുന്ന ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 300-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ്(ഒന്നാം ദിനം) നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/917.jpg",
    },
    {
      src: "assets/img/Pastevents/918.jpg",
      caption:
        "KSRTC പുതുതായി ആരംഭിക്കുന്ന ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 300-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ്(ഒന്നാം ദിനം) നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/918.jpg",
    },
    {
      src: "assets/img/Pastevents/919.jpg",
      caption:
        "KSRTC പുതുതായി ആരംഭിക്കുന്ന ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 300-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ്(ഒന്നാം ദിനം) നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/919.jpg",
    },
    {
      src: "assets/img/Pastevents/920.jpg",
      caption:
        "KSRTC പുതുതായി ആരംഭിക്കുന്ന ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 300-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ്(ഒന്നാം ദിനം) നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/920.jpg",
    },
    {
      src: "assets/img/Pastevents/921.jpg",
      caption:
        "KSRTC പുതുതായി ആരംഭിക്കുന്ന ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 300-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ്(ഒന്നാം ദിനം) നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/921.jpg",
    },
    {
      src: "assets/img/Pastevents/922.jpg",
      caption:
        "KSRTC പുതുതായി ആരംഭിക്കുന്ന ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 300-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ്(ഒന്നാം ദിനം) നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/922.jpg",
    },
    {
      src: "assets/img/Pastevents/923.jpg",
      caption:
        "KSRTC പുതുതായി ആരംഭിക്കുന്ന ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 300-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ്(ഒന്നാം ദിനം) നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/923.jpg",
    },
    {
      src: "assets/img/Pastevents/924.jpg",
      caption:
        "KSRTC പുതുതായി ആരംഭിക്കുന്ന ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 300-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ്(ഒന്നാം ദിനം) നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/924.jpg",
    },
    {
      src: "assets/img/Pastevents/925.jpg",
      caption:
        "KSRTC പുതുതായി ആരംഭിക്കുന്ന ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 300-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ്(ഒന്നാം ദിനം) നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/925.jpg",
    },
    {
      src: "assets/img/Pastevents/926.jpg",
      caption:
        "KSRTC പുതുതായി ആരംഭിക്കുന്ന ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 300-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ്(ഒന്നാം ദിനം) നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/926.jpg",
    },

    {
      src: "assets/img/Pastevents/904.jpg",
      caption:
        "ലോക ആരോഗ്യ ദിനത്തോട് അനുബന്ധിച്ച് ദി ഡെയിൽവൄൂ കോളേജ് & റിസേർച്ച് സെൻ്ററിൻ്റെയും നിംസ് മെഡിസിറ്റി യുടെ സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/904.jpg",
    },
    {
      src: "assets/img/Pastevents/905.jpg",
      caption:
        "ലോക ആരോഗ്യ ദിനത്തോട് അനുബന്ധിച്ച് ദി ഡെയിൽവൄൂ കോളേജ് & റിസേർച്ച് സെൻ്ററിൻ്റെയും നിംസ് മെഡിസിറ്റി യുടെ സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/905.jpg",
    },
    {
      src: "assets/img/Pastevents/906.jpg",
      caption:
        "ലോക ആരോഗ്യ ദിനത്തോട് അനുബന്ധിച്ച് ദി ഡെയിൽവൄൂ കോളേജ് & റിസേർച്ച് സെൻ്ററിൻ്റെയും നിംസ് മെഡിസിറ്റി യുടെ സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/906.jpg",
    },
    {
      src: "assets/img/Pastevents/907.jpg",
      caption:
        "ലോക ആരോഗ്യ ദിനത്തോട് അനുബന്ധിച്ച് ദി ഡെയിൽവൄൂ കോളേജ് & റിസേർച്ച് സെൻ്ററിൻ്റെയും നിംസ് മെഡിസിറ്റി യുടെ സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/907.jpg",
    },
    {
      src: "assets/img/Pastevents/908.jpg",
      caption:
        "ലോക ആരോഗ്യ ദിനത്തോട് അനുബന്ധിച്ച് ദി ഡെയിൽവൄൂ കോളേജ് & റിസേർച്ച് സെൻ്ററിൻ്റെയും നിംസ് മെഡിസിറ്റി യുടെ സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/908.jpg",
    },
    {
      src: "assets/img/Pastevents/909.jpg",
      caption:
        "ലോക ആരോഗ്യ ദിനത്തോട് അനുബന്ധിച്ച് ദി ഡെയിൽവൄൂ കോളേജ് & റിസേർച്ച് സെൻ്ററിൻ്റെയും നിംസ് മെഡിസിറ്റി യുടെ സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/909.jpg",
    },
    {
      src: "assets/img/Pastevents/910.jpg",
      caption:
        "ലോക ആരോഗ്യ ദിനത്തോട് അനുബന്ധിച്ച് ദി ഡെയിൽവൄൂ കോളേജ് & റിസേർച്ച് സെൻ്ററിൻ്റെയും നിംസ് മെഡിസിറ്റി യുടെ സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/910.jpg",
    },
    {
      src: "assets/img/Pastevents/911.jpg",
      caption:
        "ലോക ആരോഗ്യ ദിനത്തോട് അനുബന്ധിച്ച് ദി ഡെയിൽവൄൂ കോളേജ് & റിസേർച്ച് സെൻ്ററിൻ്റെയും നിംസ് മെഡിസിറ്റി യുടെ സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/911.jpg",
    },
    {
      src: "assets/img/Pastevents/912.jpg",
      caption:
        "ലോക ആരോഗ്യ ദിനത്തോട് അനുബന്ധിച്ച് ദി ഡെയിൽവൄൂ കോളേജ് & റിസേർച്ച് സെൻ്ററിൻ്റെയും നിംസ് മെഡിസിറ്റി യുടെ സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/912.jpg",
    },
    {
      src: "assets/img/Pastevents/913.jpg",
      caption:
        "ലോക ആരോഗ്യ ദിനത്തോട് അനുബന്ധിച്ച് ദി ഡെയിൽവൄൂ കോളേജ് & റിസേർച്ച് സെൻ്ററിൻ്റെയും നിംസ് മെഡിസിറ്റി യുടെ സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/913.jpg",
    },
    {
      src: "assets/img/Pastevents/914.jpg",
      caption:
        "ലോക ആരോഗ്യ ദിനത്തോട് അനുബന്ധിച്ച് ദി ഡെയിൽവൄൂ കോളേജ് & റിസേർച്ച് സെൻ്ററിൻ്റെയും നിംസ് മെഡിസിറ്റി യുടെ സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/914.jpg",
    },

    {
      src: "assets/img/Pastevents/895.jpg",
      caption:
        "നെല്ലിമൂട് മുലയൻതാന്നി ദേവി ക്ഷേത്ര ട്രസ്റ്റ് ബ്ലഡ് ഡൊണേഷസ് അസോസിയേഷനും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ & ബ്ലഡ് ഡൊണേഷൻ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/895.jpg",
    },
    {
      src: "assets/img/Pastevents/896.jpg",
      caption:
        "നെല്ലിമൂട് മുലയൻതാന്നി ദേവി ക്ഷേത്ര ട്രസ്റ്റ് ബ്ലഡ് ഡൊണേഷസ് അസോസിയേഷനും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ & ബ്ലഡ് ഡൊണേഷൻ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/896.jpg",
    },
    {
      src: "assets/img/Pastevents/897.jpg",
      caption:
        "നെല്ലിമൂട് മുലയൻതാന്നി ദേവി ക്ഷേത്ര ട്രസ്റ്റ് ബ്ലഡ് ഡൊണേഷസ് അസോസിയേഷനും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ & ബ്ലഡ് ഡൊണേഷൻ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/897.jpg",
    },
    {
      src: "assets/img/Pastevents/898.jpg",
      caption:
        "നെല്ലിമൂട് മുലയൻതാന്നി ദേവി ക്ഷേത്ര ട്രസ്റ്റ് ബ്ലഡ് ഡൊണേഷസ് അസോസിയേഷനും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ & ബ്ലഡ് ഡൊണേഷൻ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/898.jpg",
    },
    {
      src: "assets/img/Pastevents/899.jpg",
      caption:
        "നെല്ലിമൂട് മുലയൻതാന്നി ദേവി ക്ഷേത്ര ട്രസ്റ്റ് ബ്ലഡ് ഡൊണേഷസ് അസോസിയേഷനും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ & ബ്ലഡ് ഡൊണേഷൻ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/899.jpg",
    },
    {
      src: "assets/img/Pastevents/900.jpg",
      caption:
        "നെല്ലിമൂട് മുലയൻതാന്നി ദേവി ക്ഷേത്ര ട്രസ്റ്റ് ബ്ലഡ് ഡൊണേഷസ് അസോസിയേഷനും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ & ബ്ലഡ് ഡൊണേഷൻ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/900.jpg",
    },
    {
      src: "assets/img/Pastevents/901.jpg",
      caption:
        "നെല്ലിമൂട് മുലയൻതാന്നി ദേവി ക്ഷേത്ര ട്രസ്റ്റ് ബ്ലഡ് ഡൊണേഷസ് അസോസിയേഷനും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ & ബ്ലഡ് ഡൊണേഷൻ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/901.jpg",
    },
    {
      src: "assets/img/Pastevents/902.jpg",
      caption:
        "നെല്ലിമൂട് മുലയൻതാന്നി ദേവി ക്ഷേത്ര ട്രസ്റ്റ് ബ്ലഡ് ഡൊണേഷസ് അസോസിയേഷനും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ & ബ്ലഡ് ഡൊണേഷൻ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/902.jpg",
    },
    {
      src: "assets/img/Pastevents/903.jpg",
      caption:
        "നെല്ലിമൂട് മുലയൻതാന്നി ദേവി ക്ഷേത്ര ട്രസ്റ്റ് ബ്ലഡ് ഡൊണേഷസ് അസോസിയേഷനും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ & ബ്ലഡ് ഡൊണേഷൻ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/903.jpg",
    },
    {
      src: "assets/img/Pastevents/904.jpg",
      caption:
        "നെല്ലിമൂട് മുലയൻതാന്നി ദേവി ക്ഷേത്ര ട്രസ്റ്റ് ബ്ലഡ് ഡൊണേഷസ് അസോസിയേഷനും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ & ബ്ലഡ് ഡൊണേഷൻ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/904.jpg",
    },

    {
      src: "assets/img/Pastevents/885.jpeg",
      caption:
        "കൊല്ലങ്കോട് തൂക്ക മഹോത്സവത്തിൻ്റെ ഭാഗമായി 11പതിനൊന്നാം വർഷവും നിംസ് മെഡിസിറ്റി യുടെ ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.(4-ദിവസം)",
      thumb: "assets/img/Pastevents/885.jpeg",
    },
    {
      src: "assets/img/Pastevents/886.jpeg",
      caption:
        "കൊല്ലങ്കോട് തൂക്ക മഹോത്സവത്തിൻ്റെ ഭാഗമായി 11പതിനൊന്നാം വർഷവും നിംസ് മെഡിസിറ്റി യുടെ ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.(4-ദിവസം)",
      thumb: "assets/img/Pastevents/886.jpeg",
    },
    {
      src: "assets/img/Pastevents/887.jpeg",
      caption:
        "കൊല്ലങ്കോട് തൂക്ക മഹോത്സവത്തിൻ്റെ ഭാഗമായി 11പതിനൊന്നാം വർഷവും നിംസ് മെഡിസിറ്റി യുടെ ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.(4-ദിവസം)",
      thumb: "assets/img/Pastevents/887.jpeg",
    },
    {
      src: "assets/img/Pastevents/888.jpeg",
      caption:
        "കൊല്ലങ്കോട് തൂക്ക മഹോത്സവത്തിൻ്റെ ഭാഗമായി 11പതിനൊന്നാം വർഷവും നിംസ് മെഡിസിറ്റി യുടെ ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.(4-ദിവസം)",
      thumb: "assets/img/Pastevents/888.jpeg",
    },
    {
      src: "assets/img/Pastevents/889.jpeg",
      caption:
        "കൊല്ലങ്കോട് തൂക്ക മഹോത്സവത്തിൻ്റെ ഭാഗമായി 11പതിനൊന്നാം വർഷവും നിംസ് മെഡിസിറ്റി യുടെ ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.(4-ദിവസം)",
      thumb: "assets/img/Pastevents/889.jpeg",
    },
    {
      src: "assets/img/Pastevents/890.jpeg",
      caption:
        "കൊല്ലങ്കോട് തൂക്ക മഹോത്സവത്തിൻ്റെ ഭാഗമായി 11പതിനൊന്നാം വർഷവും നിംസ് മെഡിസിറ്റി യുടെ ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.(2-ദിവസം)",
      thumb: "assets/img/Pastevents/890.jpeg",
    },
    {
      src: "assets/img/Pastevents/891.jpeg",
      caption:
        "കൊല്ലങ്കോട് തൂക്ക മഹോത്സവത്തിൻ്റെ ഭാഗമായി 11പതിനൊന്നാം വർഷവും നിംസ് മെഡിസിറ്റി യുടെ ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.(2-ദിവസം)",
      thumb: "assets/img/Pastevents/891.jpeg",
    },
    {
      src: "assets/img/Pastevents/892.jpeg",
      caption:
        "കൊല്ലങ്കോട് തൂക്ക മഹോത്സവത്തിൻ്റെ ഭാഗമായി 11പതിനൊന്നാം വർഷവും നിംസ് മെഡിസിറ്റി യുടെ ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.(2-ദിവസം)",
      thumb: "assets/img/Pastevents/892.jpeg",
    },
    {
      src: "assets/img/Pastevents/893.jpeg",
      caption:
        "കൊല്ലങ്കോട് തൂക്ക മഹോത്സവത്തിൻ്റെ ഭാഗമായി 11പതിനൊന്നാം വർഷവും നിംസ് മെഡിസിറ്റി യുടെ ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.(2-ദിവസം)",
      thumb: "assets/img/Pastevents/893.jpeg",
    },
    {
      src: "assets/img/Pastevents/894.jpeg",
      caption:
        "കൊല്ലങ്കോട് തൂക്ക മഹോത്സവത്തിൻ്റെ ഭാഗമായി 11പതിനൊന്നാം വർഷവും നിംസ് മെഡിസിറ്റി യുടെ ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.(2-ദിവസം)",
      thumb: "assets/img/Pastevents/894.jpeg",
    },

    {
      src: "assets/img/Pastevents/879.jpeg",
      caption:
        "കൊല്ലങ്കോട് തൂക്ക മഹോത്സവത്തിൻ്റെ ഭാഗമായി 11പതിനൊന്നാം വർഷവും നിംസ് മെഡിസിറ്റി യുടെ ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.(2-ദിവസം)",
      thumb: "assets/img/Pastevents/879.jpeg",
    },
    {
      src: "assets/img/Pastevents/880.jpeg",
      caption:
        "കൊല്ലങ്കോട് തൂക്ക മഹോത്സവത്തിൻ്റെ ഭാഗമായി 11പതിനൊന്നാം വർഷവും നിംസ് മെഡിസിറ്റി യുടെ ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.(2-ദിവസം)",
      thumb: "assets/img/Pastevents/880.jpeg",
    },
    {
      src: "assets/img/Pastevents/881.jpeg",
      caption:
        "കൊല്ലങ്കോട് തൂക്ക മഹോത്സവത്തിൻ്റെ ഭാഗമായി 11പതിനൊന്നാം വർഷവും നിംസ് മെഡിസിറ്റി യുടെ ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.(2-ദിവസം)",
      thumb: "assets/img/Pastevents/881.jpeg",
    },
    {
      src: "assets/img/Pastevents/882.jpeg",
      caption:
        "കൊല്ലങ്കോട് തൂക്ക മഹോത്സവത്തിൻ്റെ ഭാഗമായി 11പതിനൊന്നാം വർഷവും നിംസ് മെഡിസിറ്റി യുടെ ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.(2-ദിവസം)",
      thumb: "assets/img/Pastevents/882.jpeg",
    },
    {
      src: "assets/img/Pastevents/883.jpeg",
      caption:
        "കൊല്ലങ്കോട് തൂക്ക മഹോത്സവത്തിൻ്റെ ഭാഗമായി 11പതിനൊന്നാം വർഷവും നിംസ് മെഡിസിറ്റി യുടെ ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.(2-ദിവസം)",
      thumb: "assets/img/Pastevents/883.jpeg",
    },
    {
      src: "assets/img/Pastevents/884.jpeg",
      caption:
        "കൊല്ലങ്കോട് തൂക്ക മഹോത്സവത്തിൻ്റെ ഭാഗമായി 11പതിനൊന്നാം വർഷവും നിംസ് മെഡിസിറ്റി യുടെ ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.(2-ദിവസം)",
      thumb: "assets/img/Pastevents/884.jpeg",
    },

    {
      src: "assets/img/Pastevents/870.jpeg",
      caption:
        "കൊല്ലങ്കോട് തൂക്ക മഹോത്സവത്തിൻ്റെ ഭാഗമായി 11പതിനൊന്നാം വർഷവും നിംസ് മെഡിസിറ്റി യുടെ ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം : ശ്രീമതി ആശ നാഥ് (യുവമോർച്ച സംസ്ഥാന സെക്രട്ടറി)",
      thumb: "assets/img/Pastevents/870.jpeg",
    },
    {
      src: "assets/img/Pastevents/871.jpeg",
      caption:
        "കൊല്ലങ്കോട് തൂക്ക മഹോത്സവത്തിൻ്റെ ഭാഗമായി 11പതിനൊന്നാം വർഷവും നിംസ് മെഡിസിറ്റി യുടെ ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം : ശ്രീമതി ആശ നാഥ് (യുവമോർച്ച സംസ്ഥാന സെക്രട്ടറി)",
      thumb: "assets/img/Pastevents/871.jpeg",
    },
    {
      src: "assets/img/Pastevents/872.jpeg",
      caption:
        "കൊല്ലങ്കോട് തൂക്ക മഹോത്സവത്തിൻ്റെ ഭാഗമായി 11പതിനൊന്നാം വർഷവും നിംസ് മെഡിസിറ്റി യുടെ ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം : ശ്രീമതി ആശ നാഥ് (യുവമോർച്ച സംസ്ഥാന സെക്രട്ടറി)",
      thumb: "assets/img/Pastevents/872.jpeg",
    },
    {
      src: "assets/img/Pastevents/873.jpeg",
      caption:
        "കൊല്ലങ്കോട് തൂക്ക മഹോത്സവത്തിൻ്റെ ഭാഗമായി 11പതിനൊന്നാം വർഷവും നിംസ് മെഡിസിറ്റി യുടെ ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം : ശ്രീമതി ആശ നാഥ് (യുവമോർച്ച സംസ്ഥാന സെക്രട്ടറി)",
      thumb: "assets/img/Pastevents/873.jpeg",
    },
    {
      src: "assets/img/Pastevents/874.jpeg",
      caption:
        "കൊല്ലങ്കോട് തൂക്ക മഹോത്സവത്തിൻ്റെ ഭാഗമായി 11പതിനൊന്നാം വർഷവും നിംസ് മെഡിസിറ്റി യുടെ ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം : ശ്രീമതി ആശ നാഥ് (യുവമോർച്ച സംസ്ഥാന സെക്രട്ടറി)",
      thumb: "assets/img/Pastevents/874.jpeg",
    },
    {
      src: "assets/img/Pastevents/875.jpeg",
      caption:
        "കൊല്ലങ്കോട് തൂക്ക മഹോത്സവത്തിൻ്റെ ഭാഗമായി 11പതിനൊന്നാം വർഷവും നിംസ് മെഡിസിറ്റി യുടെ ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം : ശ്രീമതി ആശ നാഥ് (യുവമോർച്ച സംസ്ഥാന സെക്രട്ടറി)",
      thumb: "assets/img/Pastevents/875.jpeg",
    },
    {
      src: "assets/img/Pastevents/876.jpeg",
      caption:
        "കൊല്ലങ്കോട് തൂക്ക മഹോത്സവത്തിൻ്റെ ഭാഗമായി 11പതിനൊന്നാം വർഷവും നിംസ് മെഡിസിറ്റി യുടെ ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം : ശ്രീമതി ആശ നാഥ് (യുവമോർച്ച സംസ്ഥാന സെക്രട്ടറി)",
      thumb: "assets/img/Pastevents/876.jpeg",
    },
    {
      src: "assets/img/Pastevents/877.jpeg",
      caption:
        "കൊല്ലങ്കോട് തൂക്ക മഹോത്സവത്തിൻ്റെ ഭാഗമായി 11പതിനൊന്നാം വർഷവും നിംസ് മെഡിസിറ്റി യുടെ ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം : ശ്രീമതി ആശ നാഥ് (യുവമോർച്ച സംസ്ഥാന സെക്രട്ടറി)",
      thumb: "assets/img/Pastevents/877.jpeg",
    },
    {
      src: "assets/img/Pastevents/878.jpeg",
      caption:
        "കൊല്ലങ്കോട് തൂക്ക മഹോത്സവത്തിൻ്റെ ഭാഗമായി 11പതിനൊന്നാം വർഷവും നിംസ് മെഡിസിറ്റി യുടെ ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം : ശ്രീമതി ആശ നാഥ് (യുവമോർച്ച സംസ്ഥാന സെക്രട്ടറി)",
      thumb: "assets/img/Pastevents/878.jpeg",
    },
    {
      src: "assets/img/Pastevents/865.jpeg",
      caption:
        "നെയ്യാറ്റിൻകര ശ്രീകൃഷ്ണ സ്വാമി ക്ഷേത്ര ഉത്സവ കമ്മറ്റിയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ  മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/865.jpeg",
    },
    {
      src: "assets/img/Pastevents/866.jpeg",
      caption:
        "നെയ്യാറ്റിൻകര ശ്രീകൃഷ്ണ സ്വാമി ക്ഷേത്ര ഉത്സവ കമ്മറ്റിയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ  മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/866.jpeg",
    },
    {
      src: "assets/img/Pastevents/867.jpeg",
      caption:
        "നെയ്യാറ്റിൻകര ശ്രീകൃഷ്ണ സ്വാമി ക്ഷേത്ര ഉത്സവ കമ്മറ്റിയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ  മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/867.jpeg",
    },
    {
      src: "assets/img/Pastevents/868.jpeg",
      caption:
        "നെയ്യാറ്റിൻകര ശ്രീകൃഷ്ണ സ്വാമി ക്ഷേത്ര ഉത്സവ കമ്മറ്റിയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ  മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/868.jpeg",
    },
    {
      src: "assets/img/Pastevents/869.jpeg",
      caption:
        "നെയ്യാറ്റിൻകര ശ്രീകൃഷ്ണ സ്വാമി ക്ഷേത്ര ഉത്സവ കമ്മറ്റിയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ  മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/869.jpeg",
    },

    {
      src: "assets/img/Pastevents/858.jpeg",
      caption:
        "SNDP യൂത്ത് മൂവ്മെൻ്റ് വേങപ്പൊറ്റ യൂണിറ്റ്, വിഴിഞ്ഞം ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/858.jpeg",
    },
    {
      src: "assets/img/Pastevents/859.jpeg",
      caption:
        "SNDP യൂത്ത് മൂവ്മെൻ്റ് വേങപ്പൊറ്റ യൂണിറ്റ്, വിഴിഞ്ഞം ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/859.jpeg",
    },
    {
      src: "assets/img/Pastevents/860.jpeg",
      caption:
        "SNDP യൂത്ത് മൂവ്മെൻ്റ് വേങപ്പൊറ്റ യൂണിറ്റ്, വിഴിഞ്ഞം ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/860.jpeg",
    },
    {
      src: "assets/img/Pastevents/861.jpeg",
      caption:
        "SNDP യൂത്ത് മൂവ്മെൻ്റ് വേങപ്പൊറ്റ യൂണിറ്റ്, വിഴിഞ്ഞം ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/861.jpeg",
    },
    {
      src: "assets/img/Pastevents/862.jpeg",
      caption:
        "SNDP യൂത്ത് മൂവ്മെൻ്റ് വേങപ്പൊറ്റ യൂണിറ്റ്, വിഴിഞ്ഞം ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/862.jpeg",
    },
    {
      src: "assets/img/Pastevents/863.jpeg",
      caption:
        "SNDP യൂത്ത് മൂവ്മെൻ്റ് വേങപ്പൊറ്റ യൂണിറ്റ്, വിഴിഞ്ഞം ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/863.jpeg",
    },
    {
      src: "assets/img/Pastevents/864.jpeg",
      caption:
        "SNDP യൂത്ത് മൂവ്മെൻ്റ് വേങപ്പൊറ്റ യൂണിറ്റ്, വിഴിഞ്ഞം ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/864.jpeg",
    },

    {
      src: "assets/img/Pastevents/853.jpeg",
      caption:
        "കരിങ്കൽ ശ്രീ ഭദ്രകാളി ക്ഷേത്ര ട്രസ്റ്റ് , അരുമാളൂർ VMASC , ട്രിവാൻഡ്രം റെയിൻബോ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ഉദ്ഘാടനം: ശ്രീ സുരേഷ് കുമാർ (ഗ്രാമ പഞ്ചായത്ത് പ്രസിഡൻറ്, മാറനല്ലൂർ)",
      thumb: "assets/img/Pastevents/853.jpeg",
    },
    {
      src: "assets/img/Pastevents/854.jpeg",
      caption:
        "കരിങ്കൽ ശ്രീ ഭദ്രകാളി ക്ഷേത്ര ട്രസ്റ്റ് , അരുമാളൂർ VMASC , ട്രിവാൻഡ്രം റെയിൻബോ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ഉദ്ഘാടനം: ശ്രീ സുരേഷ് കുമാർ (ഗ്രാമ പഞ്ചായത്ത് പ്രസിഡൻറ്, മാറനല്ലൂർ)",
      thumb: "assets/img/Pastevents/854.jpeg",
    },
    {
      src: "assets/img/Pastevents/855.jpeg",
      caption:
        "കരിങ്കൽ ശ്രീ ഭദ്രകാളി ക്ഷേത്ര ട്രസ്റ്റ് , അരുമാളൂർ VMASC , ട്രിവാൻഡ്രം റെയിൻബോ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ഉദ്ഘാടനം: ശ്രീ സുരേഷ് കുമാർ (ഗ്രാമ പഞ്ചായത്ത് പ്രസിഡൻറ്, മാറനല്ലൂർ)",
      thumb: "assets/img/Pastevents/855.jpeg",
    },
    {
      src: "assets/img/Pastevents/856.jpeg",
      caption:
        "കരിങ്കൽ ശ്രീ ഭദ്രകാളി ക്ഷേത്ര ട്രസ്റ്റ് , അരുമാളൂർ VMASC , ട്രിവാൻഡ്രം റെയിൻബോ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ഉദ്ഘാടനം: ശ്രീ സുരേഷ് കുമാർ (ഗ്രാമ പഞ്ചായത്ത് പ്രസിഡൻറ്, മാറനല്ലൂർ)",
      thumb: "assets/img/Pastevents/856.jpeg",
    },
    {
      src: "assets/img/Pastevents/857.jpeg",
      caption:
        "കരിങ്കൽ ശ്രീ ഭദ്രകാളി ക്ഷേത്ര ട്രസ്റ്റ് , അരുമാളൂർ VMASC , ട്രിവാൻഡ്രം റെയിൻബോ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ഉദ്ഘാടനം: ശ്രീ സുരേഷ് കുമാർ (ഗ്രാമ പഞ്ചായത്ത് പ്രസിഡൻറ്, മാറനല്ലൂർ)",
      thumb: "assets/img/Pastevents/857.jpeg",
    },
    {
      src: "assets/img/Pastevents/847.jpeg",
      caption:
        "ഭാരതീയം ട്രസ്റ്റും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ ഫൈസൽ ഖാൻ (എം.ഡി നിംസ് മെഡിസിറ്റി).",
      thumb: "assets/img/Pastevents/847.jpeg",
    },
    {
      src: "assets/img/Pastevents/848.jpeg",
      caption:
        "ഭാരതീയം ട്രസ്റ്റും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ ഫൈസൽ ഖാൻ (എം.ഡി നിംസ് മെഡിസിറ്റി).",
      thumb: "assets/img/Pastevents/848.jpeg",
    },
    {
      src: "assets/img/Pastevents/849.jpeg",
      caption:
        "ഭാരതീയം ട്രസ്റ്റും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ ഫൈസൽ ഖാൻ (എം.ഡി നിംസ് മെഡിസിറ്റി).",
      thumb: "assets/img/Pastevents/849.jpeg",
    },
    {
      src: "assets/img/Pastevents/850.jpeg",
      caption:
        "ഭാരതീയം ട്രസ്റ്റും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ ഫൈസൽ ഖാൻ (എം.ഡി നിംസ് മെഡിസിറ്റി).",
      thumb: "assets/img/Pastevents/850.jpeg",
    },
    {
      src: "assets/img/Pastevents/851.jpeg",
      caption:
        "ഭാരതീയം ട്രസ്റ്റും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ ഫൈസൽ ഖാൻ (എം.ഡി നിംസ് മെഡിസിറ്റി).",
      thumb: "assets/img/Pastevents/851.jpeg",
    },
    {
      src: "assets/img/Pastevents/852.jpeg",
      caption:
        "ഭാരതീയം ട്രസ്റ്റും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ ഫൈസൽ ഖാൻ (എം.ഡി നിംസ് മെഡിസിറ്റി).",
      thumb: "assets/img/Pastevents/852.jpeg",
    },

    {
      src: "assets/img/Pastevents/841.jpeg",
      caption:
        "വി കെ പി നഗർ റെസിഡൻഷ്യൽ അസോസിയേഷൻ കാഞ്ഞിരംപാറ, ട്രിവാൻഡ്രം ഡിസ്ട്രിക് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/841.jpeg",
    },
    {
      src: "assets/img/Pastevents/842.jpeg",
      caption:
        "വി കെ പി നഗർ റെസിഡൻഷ്യൽ അസോസിയേഷൻ കാഞ്ഞിരംപാറ, ട്രിവാൻഡ്രം ഡിസ്ട്രിക് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/842.jpeg",
    },
    {
      src: "assets/img/Pastevents/843.jpeg",
      caption:
        "വി കെ പി നഗർ റെസിഡൻഷ്യൽ അസോസിയേഷൻ കാഞ്ഞിരംപാറ, ട്രിവാൻഡ്രം ഡിസ്ട്രിക് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/843.jpeg",
    },
    {
      src: "assets/img/Pastevents/844.jpeg",
      caption:
        "വി കെ പി നഗർ റെസിഡൻഷ്യൽ അസോസിയേഷൻ കാഞ്ഞിരംപാറ, ട്രിവാൻഡ്രം ഡിസ്ട്രിക് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/844.jpeg",
    },
    {
      src: "assets/img/Pastevents/845.jpeg",
      caption:
        "വി കെ പി നഗർ റെസിഡൻഷ്യൽ അസോസിയേഷൻ കാഞ്ഞിരംപാറ, ട്രിവാൻഡ്രം ഡിസ്ട്രിക് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/845.jpeg",
    },
    {
      src: "assets/img/Pastevents/846.jpeg",
      caption:
        "വി കെ പി നഗർ റെസിഡൻഷ്യൽ അസോസിയേഷൻ കാഞ്ഞിരംപാറ, ട്രിവാൻഡ്രം ഡിസ്ട്രിക് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/846.jpeg",
    },

    {
      src: "assets/img/Pastevents/835.jpeg",
      caption:
        "ദയ ഇൻഡസ്ട്രിയൽ ലിമിറ്റഡും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/835.jpeg",
    },
    {
      src: "assets/img/Pastevents/836.jpeg",
      caption:
        "ദയ ഇൻഡസ്ട്രിയൽ ലിമിറ്റഡും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/836.jpeg",
    },
    {
      src: "assets/img/Pastevents/837.jpeg",
      caption:
        "ദയ ഇൻഡസ്ട്രിയൽ ലിമിറ്റഡും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/837.jpeg",
    },
    {
      src: "assets/img/Pastevents/838.jpeg",
      caption:
        "ദയ ഇൻഡസ്ട്രിയൽ ലിമിറ്റഡും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/838.jpeg",
    },
    {
      src: "assets/img/Pastevents/839.jpeg",
      caption:
        "ദയ ഇൻഡസ്ട്രിയൽ ലിമിറ്റഡും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/839.jpeg",
    },
    {
      src: "assets/img/Pastevents/840.jpeg",
      caption:
        "ദയ ഇൻഡസ്ട്രിയൽ ലിമിറ്റഡും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/840.jpeg",
    },

    {
      src: "assets/img/Pastevents/829.jpeg",
      caption:
        "മരിയഗിരി,മലങ്കര കാത്തോലിക് കോളേജ് നാഷണൽ സർവീസ് സ്കീം നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/829.jpeg",
    },
    {
      src: "assets/img/Pastevents/830.jpeg",
      caption:
        "മരിയഗിരി,മലങ്കര കാത്തോലിക് കോളേജ് നാഷണൽ സർവീസ് സ്കീം നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/830.jpeg",
    },
    {
      src: "assets/img/Pastevents/831.jpeg",
      caption:
        "മരിയഗിരി,മലങ്കര കാത്തോലിക് കോളേജ് നാഷണൽ സർവീസ് സ്കീം നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/831.jpeg",
    },
    {
      src: "assets/img/Pastevents/832.jpeg",
      caption:
        "മരിയഗിരി,മലങ്കര കാത്തോലിക് കോളേജ് നാഷണൽ സർവീസ് സ്കീം നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/832.jpeg",
    },
    {
      src: "assets/img/Pastevents/833.jpeg",
      caption:
        "മരിയഗിരി,മലങ്കര കാത്തോലിക് കോളേജ് നാഷണൽ സർവീസ് സ്കീം നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/833.jpeg",
    },
    {
      src: "assets/img/Pastevents/834.jpeg",
      caption:
        "മരിയഗിരി,മലങ്കര കാത്തോലിക് കോളേജ് നാഷണൽ സർവീസ് സ്കീം നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/834.jpeg",
    },

    {
      src: "assets/img/Pastevents/817.jpeg",
      caption:
        "പരുത്തികുഴി ജുമാ മസ്ജിദ് കമ്മറ്റിയും ട്രിവാൻഡ്രം റീജൻസി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/817.jpeg",
    },

    {
      src: "assets/img/Pastevents/818.jpeg",
      caption:
        "പരുത്തികുഴി ജുമാ മസ്ജിദ് കമ്മറ്റിയും ട്രിവാൻഡ്രം റീജൻസി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/818.jpeg",
    },
    {
      src: "assets/img/Pastevents/819.jpeg",
      caption:
        "പരുത്തികുഴി ജുമാ മസ്ജിദ് കമ്മറ്റിയും ട്രിവാൻഡ്രം റീജൻസി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/819.jpeg",
    },
    {
      src: "assets/img/Pastevents/820.jpeg",
      caption:
        "പരുത്തികുഴി ജുമാ മസ്ജിദ് കമ്മറ്റിയും ട്രിവാൻഡ്രം റീജൻസി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/820.jpeg",
    },
    {
      src: "assets/img/Pastevents/821.jpeg",
      caption:
        "പരുത്തികുഴി ജുമാ മസ്ജിദ് കമ്മറ്റിയും ട്രിവാൻഡ്രം റീജൻസി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/821.jpeg",
    },
    {
      src: "assets/img/Pastevents/822.jpeg",
      caption:
        "പരുത്തികുഴി ജുമാ മസ്ജിദ് കമ്മറ്റിയും ട്രിവാൻഡ്രം റീജൻസി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/822.jpeg",
    },
    {
      src: "assets/img/Pastevents/823.jpeg",
      caption:
        "പരുത്തികുഴി ജുമാ മസ്ജിദ് കമ്മറ്റിയും ട്രിവാൻഡ്രം റീജൻസി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/823.jpeg",
    },
    {
      src: "assets/img/Pastevents/824.jpeg",
      caption:
        "പരുത്തികുഴി ജുമാ മസ്ജിദ് കമ്മറ്റിയും ട്രിവാൻഡ്രം റീജൻസി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/824.jpeg",
    },
    {
      src: "assets/img/Pastevents/825.jpeg",
      caption:
        "പരുത്തികുഴി ജുമാ മസ്ജിദ് കമ്മറ്റിയും ട്രിവാൻഡ്രം റീജൻസി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/825.jpeg",
    },
    {
      src: "assets/img/Pastevents/825.jpeg",
      caption:
        "പരുത്തികുഴി ജുമാ മസ്ജിദ് കമ്മറ്റിയും ട്രിവാൻഡ്രം റീജൻസി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/825.jpeg",
    },
    {
      src: "assets/img/Pastevents/826.jpeg",
      caption:
        "പരുത്തികുഴി ജുമാ മസ്ജിദ് കമ്മറ്റിയും ട്രിവാൻഡ്രം റീജൻസി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/826.jpeg",
    },
    {
      src: "assets/img/Pastevents/827.jpeg",
      caption:
        "പരുത്തികുഴി ജുമാ മസ്ജിദ് കമ്മറ്റിയും ട്രിവാൻഡ്രം റീജൻസി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/827.jpeg",
    },
    {
      src: "assets/img/Pastevents/828.jpeg",
      caption:
        "പരുത്തികുഴി ജുമാ മസ്ജിദ് കമ്മറ്റിയും ട്രിവാൻഡ്രം റീജൻസി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/828.jpeg",
    },
    {
      src: "assets/img/Pastevents/816.jpeg",
      caption:
        "സി പി എം (ഐ) പറണ്ടോട് ലോക്കൽ കമ്മിറ്റിയും ലയൺസ് ക്ലബ് ഇൻ്റർനാഷണൽ ട്രിവാൻഡ്രവും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ  മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/816.jpeg",
    },
    {
      src: "assets/img/Pastevents/817.jpeg",
      caption:
        "സി പി എം (ഐ) പറണ്ടോട് ലോക്കൽ കമ്മിറ്റിയും ലയൺസ് ക്ലബ് ഇൻ്റർനാഷണൽ ട്രിവാൻഡ്രവും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ  മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/817.jpeg",
    },
    {
      src: "assets/img/Pastevents/818.jpeg",
      caption:
        "സി പി എം (ഐ) പറണ്ടോട് ലോക്കൽ കമ്മിറ്റിയും ലയൺസ് ക്ലബ് ഇൻ്റർനാഷണൽ ട്രിവാൻഡ്രവും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ  മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/818.jpeg",
    },
    {
      src: "assets/img/Pastevents/819.jpeg",
      caption:
        "സി പി എം (ഐ) പറണ്ടോട് ലോക്കൽ കമ്മിറ്റിയും ലയൺസ് ക്ലബ് ഇൻ്റർനാഷണൽ ട്രിവാൻഡ്രവും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ  മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/819.jpeg",
    },
    {
      src: "assets/img/Pastevents/820.jpeg",
      caption:
        "സി പി എം (ഐ) പറണ്ടോട് ലോക്കൽ കമ്മിറ്റിയും ലയൺസ് ക്ലബ് ഇൻ്റർനാഷണൽ ട്രിവാൻഡ്രവും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ  മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/820.jpeg",
    },
    {
      src: "assets/img/Pastevents/821.jpeg",
      caption:
        "സി പി എം (ഐ) പറണ്ടോട് ലോക്കൽ കമ്മിറ്റിയും ലയൺസ് ക്ലബ് ഇൻ്റർനാഷണൽ ട്രിവാൻഡ്രവും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ  മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/821.jpeg",
    },
    {
      src: "assets/img/Pastevents/809.jpeg",
      caption:
        "അഞ്ചൽ ടൗൺ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/809.jpeg",
    },
    {
      src: "assets/img/Pastevents/810.jpeg",
      caption:
        "അഞ്ചൽ ടൗൺ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/810.jpeg",
    },
    {
      src: "assets/img/Pastevents/811.jpeg",
      caption:
        "അഞ്ചൽ ടൗൺ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/811.jpeg",
    },
    {
      src: "assets/img/Pastevents/812.jpeg",
      caption:
        "അഞ്ചൽ ടൗൺ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/812.jpeg",
    },
    {
      src: "assets/img/Pastevents/813.jpeg",
      caption:
        "അഞ്ചൽ ടൗൺ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/813.jpeg",
    },
    {
      src: "assets/img/Pastevents/814.jpeg",
      caption:
        "അഞ്ചൽ ടൗൺ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/814.jpeg",
    },
    {
      src: "assets/img/Pastevents/815.jpeg",
      caption:
        "അഞ്ചൽ ടൗൺ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/815.jpeg",
    },

    {
      src: "assets/img/Pastevents/803.jpeg",
      caption:
        "ഇന്ത്യൻ നാഷണൽ കോൺഗ്രസ് വാർഡ് കമ്മിറ്റി പുന്നക്കുളം നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ അഡ്വ. എം വിൻസെൻ്റ് (എംഎൽഎ കോവളം).",
      thumb: "assets/img/Pastevents/803.jpeg",
    },
    {
      src: "assets/img/Pastevents/804.jpeg",
      caption:
        "ഇന്ത്യൻ നാഷണൽ കോൺഗ്രസ് വാർഡ് കമ്മിറ്റി പുന്നക്കുളം നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ അഡ്വ. എം വിൻസെൻ്റ് (എംഎൽഎ കോവളം).",
      thumb: "assets/img/Pastevents/804.jpeg",
    },
    {
      src: "assets/img/Pastevents/805.jpeg",
      caption:
        "ഇന്ത്യൻ നാഷണൽ കോൺഗ്രസ് വാർഡ് കമ്മിറ്റി പുന്നക്കുളം നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ അഡ്വ. എം വിൻസെൻ്റ് (എംഎൽഎ കോവളം).",
      thumb: "assets/img/Pastevents/805.jpeg",
    },
    {
      src: "assets/img/Pastevents/806.jpeg",
      caption:
        "ഇന്ത്യൻ നാഷണൽ കോൺഗ്രസ് വാർഡ് കമ്മിറ്റി പുന്നക്കുളം നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ അഡ്വ. എം വിൻസെൻ്റ് (എംഎൽഎ കോവളം).",
      thumb: "assets/img/Pastevents/806.jpeg",
    },
    {
      src: "assets/img/Pastevents/807.jpeg",
      caption:
        "ഇന്ത്യൻ നാഷണൽ കോൺഗ്രസ് വാർഡ് കമ്മിറ്റി പുന്നക്കുളം നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ അഡ്വ. എം വിൻസെൻ്റ് (എംഎൽഎ കോവളം).",
      thumb: "assets/img/Pastevents/807.jpeg",
    },
    {
      src: "assets/img/Pastevents/808.jpeg",
      caption:
        "ഇന്ത്യൻ നാഷണൽ കോൺഗ്രസ് വാർഡ് കമ്മിറ്റി പുന്നക്കുളം നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ അഡ്വ. എം വിൻസെൻ്റ് (എംഎൽഎ കോവളം).",
      thumb: "assets/img/Pastevents/808.jpeg",
    },
    {
      src: "assets/img/Pastevents/798.jpeg",
      caption:
        "ശ്രീ ഭദ്രകാളി ക്ഷേത്രം ഊരുട്ടുക്കാലയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ പൊങ്കാല മഹോത്സവത്തിനോട് അനുബന്ധിച്ച് നടന്ന സൗജന്യ മെഡിക്കൽ ക്യാമ്പ്.",
      thumb: "assets/img/Pastevents/798.jpeg",
    },
    {
      src: "assets/img/Pastevents/799.jpeg",
      caption:
        "ശ്രീ ഭദ്രകാളി ക്ഷേത്രം ഊരുട്ടുക്കാലയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ പൊങ്കാല മഹോത്സവത്തിനോട് അനുബന്ധിച്ച് നടന്ന സൗജന്യ മെഡിക്കൽ ക്യാമ്പ്.",
      thumb: "assets/img/Pastevents/799.jpeg",
    },
    {
      src: "assets/img/Pastevents/800.jpeg",
      caption:
        "ശ്രീ ഭദ്രകാളി ക്ഷേത്രം ഊരുട്ടുക്കാലയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ പൊങ്കാല മഹോത്സവത്തിനോട് അനുബന്ധിച്ച് നടന്ന സൗജന്യ മെഡിക്കൽ ക്യാമ്പ്.",
      thumb: "assets/img/Pastevents/800.jpeg",
    },
    {
      src: "assets/img/Pastevents/801.jpeg",
      caption:
        "ശ്രീ ഭദ്രകാളി ക്ഷേത്രം ഊരുട്ടുക്കാലയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ പൊങ്കാല മഹോത്സവത്തിനോട് അനുബന്ധിച്ച് നടന്ന സൗജന്യ മെഡിക്കൽ ക്യാമ്പ്.",
      thumb: "assets/img/Pastevents/801.jpeg",
    },
    {
      src: "assets/img/Pastevents/802.jpeg",
      caption:
        "ശ്രീ ഭദ്രകാളി ക്ഷേത്രം ഊരുട്ടുക്കാലയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ പൊങ്കാല മഹോത്സവത്തിനോട് അനുബന്ധിച്ച് നടന്ന സൗജന്യ മെഡിക്കൽ ക്യാമ്പ്.",
      thumb: "assets/img/Pastevents/802.jpeg",
    },
    {
      src: "assets/img/Pastevents/792.jpeg",
      caption:
        "മുഹിയുദദീൻ മുസ്‌ലിം ജുമാ അത്ത് പനയമുട്ടത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/792.jpeg",
    },
    {
      src: "assets/img/Pastevents/793.jpeg",
      caption:
        "മുഹിയുദദീൻ മുസ്‌ലിം ജുമാ അത്ത് പനയമുട്ടത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/793.jpeg",
    },
    {
      src: "assets/img/Pastevents/794.jpeg",
      caption:
        "മുഹിയുദദീൻ മുസ്‌ലിം ജുമാ അത്ത് പനയമുട്ടത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/794.jpeg",
    },
    {
      src: "assets/img/Pastevents/795.jpeg",
      caption:
        "മുഹിയുദദീൻ മുസ്‌ലിം ജുമാ അത്ത് പനയമുട്ടത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/795.jpeg",
    },
    {
      src: "assets/img/Pastevents/796.jpeg",
      caption:
        "മുഹിയുദദീൻ മുസ്‌ലിം ജുമാ അത്ത് പനയമുട്ടത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/796.jpeg",
    },
    {
      src: "assets/img/Pastevents/797.jpeg",
      caption:
        "മുഹിയുദദീൻ മുസ്‌ലിം ജുമാ അത്ത് പനയമുട്ടത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/797.jpeg",
    },
    {
      src: "assets/img/Pastevents/786.jpeg",
      caption:
        "ശ്രീ ധർമ്മശാസ്താ ക്ഷേത്രം പച്ച , പാലോട് കേരള കൗമുദി പാലോട് യൂണിറ്റും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/786.jpeg",
    },
    {
      src: "assets/img/Pastevents/787.jpeg",
      caption:
        "ശ്രീ ധർമ്മശാസ്താ ക്ഷേത്രം പച്ച , പാലോട് കേരള കൗമുദി പാലോട് യൂണിറ്റും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/787.jpeg",
    },
    {
      src: "assets/img/Pastevents/788.jpeg",
      caption:
        "ശ്രീ ധർമ്മശാസ്താ ക്ഷേത്രം പച്ച , പാലോട് കേരള കൗമുദി പാലോട് യൂണിറ്റും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/788.jpeg",
    },
    {
      src: "assets/img/Pastevents/789.jpeg",
      caption:
        "ശ്രീ ധർമ്മശാസ്താ ക്ഷേത്രം പച്ച , പാലോട് കേരള കൗമുദി പാലോട് യൂണിറ്റും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/789.jpeg",
    },
    {
      src: "assets/img/Pastevents/790.jpeg",
      caption:
        "ശ്രീ ധർമ്മശാസ്താ ക്ഷേത്രം പച്ച , പാലോട് കേരള കൗമുദി പാലോട് യൂണിറ്റും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/790.jpeg",
    },
    {
      src: "assets/img/Pastevents/791.jpeg",
      caption:
        "ശ്രീ ധർമ്മശാസ്താ ക്ഷേത്രം പച്ച , പാലോട് കേരള കൗമുദി പാലോട് യൂണിറ്റും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/791.jpeg",
    },
    {
      src: "assets/img/Pastevents/773.jpg",
      caption:
        "നെയ്യാറ്റിൻകര:ലോക വൃക്കദിനത്തോടനുബന്ധിച്ച്  നിംസ് മെഡിസിറ്റിയിൽ പ്രശസ്ത നെഫ്റോളജിസ്റ്റ് ഡോ. മഞ്ജു തമ്പിയുടെ നേതൃത്വത്തിൽ  സംഘടിപ്പിച്ച  സൗജന്യ വൃക്ക രോഗ നിർണയ ക്യാമ്പ്  നെയ്യാറ്റിൻകര നഗരസഭ കൗൺസിലർ ഗ്രാമം പ്രവീൺ ഉദ്ഘാടനം ചെയ്തു.  ക്യാമ്പിലെത്തിയ  ആദ്യത്തെ നൂറു പേർക്ക് ക്രിയാറ്റിൻ, ഷുഗർ, ബി പി, എന്നീ ടെസ്റ്റുകൾ സൗജന്യമായി ചെയ്തു നൽകി. കോവിഡ് രൂക്ഷമായ കാലത്തും  വൃക്ക മാറ്റിവെക്കൽ ശസ്ത്രക്രിയ വിജയകരമായി പൂർത്തീകരിച്ച നിംസ്  മെഡിക്കൽ സൂപ്രണ്ടും നെഫ്രോളജി വിഭാഗം മേധാവിയുമായ ഡോ. മഞ്ജു തമ്പിയെ നെയ്യാറ്റിൻകര ഡയോസ്‌കോസ്‌  ഫൈനാൻസ് ഓഫീസർ ഫാദർ   സാബു  വർഗീസ്, ബാലരാമപുരം റെസിഡന്റ്‌സ് അസോസിയേഷൻ ജനറൽ സെക്രട്ടറി ശ്രി.ബാലരാമപുരം അൽഫോൻസ്,  ബാലരാമപുരം യുണിറ്റ്   വ്യാപാരി വ്യവസായി അസോസിയേഷൻ  പ്രസിഡന്റ് ഇ. ബി. ബഷീർ, വി.എച്. പി. ജില്ലാ പ്രസിഡന്റ് ഡോക്ടർ നാരായണൻറാവുഎന്നിവർ ആദരിച്ചു.  വര്ഷങ്ങളായി ഡയാലിസിസ് ചെയ്തുവരുന്ന വൃക്ക രോഗികൾക്ക് സ്നേഹോപഹാരം സമർപ്പിച്ചു.   ക്യാമ്പിലെത്തിയ  വൃക്ക മാറ്റിവെക്കൽ ശാസ്ത്രക്രിയക്ക് കാത്തിരിക്കുന്ന സാമ്പത്തിക ബുദ്ധിമുട്ടുള്ള രോഗികൾക്ക് 2.75ലക്ഷം രൂപക്ക് ശാസ്ത്രക്രിയ ചെയ്തു കൊടുക്കുന്നതായിരിക്കും. ഡോ. മഞ്ജു തമ്പി, നിംസ് ജനറൽ മാനേജർ ഡോ. കെ എ സജു, തുടങ്ങിയവർ സംബന്ധിച്ചു.",
      thumb: "assets/img/Pastevents/773.jpg",
    },
    {
      src: "assets/img/Pastevents/774.jpg",
      caption:
        "നെയ്യാറ്റിൻകര:ലോക വൃക്കദിനത്തോടനുബന്ധിച്ച്  നിംസ് മെഡിസിറ്റിയിൽ പ്രശസ്ത നെഫ്റോളജിസ്റ്റ് ഡോ. മഞ്ജു തമ്പിയുടെ നേതൃത്വത്തിൽ  സംഘടിപ്പിച്ച  സൗജന്യ വൃക്ക രോഗ നിർണയ ക്യാമ്പ്  നെയ്യാറ്റിൻകര നഗരസഭ കൗൺസിലർ ഗ്രാമം പ്രവീൺ ഉദ്ഘാടനം ചെയ്തു.  ക്യാമ്പിലെത്തിയ  ആദ്യത്തെ നൂറു പേർക്ക് ക്രിയാറ്റിൻ, ഷുഗർ, ബി പി, എന്നീ ടെസ്റ്റുകൾ സൗജന്യമായി ചെയ്തു നൽകി. കോവിഡ് രൂക്ഷമായ കാലത്തും  വൃക്ക മാറ്റിവെക്കൽ ശസ്ത്രക്രിയ വിജയകരമായി പൂർത്തീകരിച്ച നിംസ്  മെഡിക്കൽ സൂപ്രണ്ടും നെഫ്രോളജി വിഭാഗം മേധാവിയുമായ ഡോ. മഞ്ജു തമ്പിയെ നെയ്യാറ്റിൻകര ഡയോസ്‌കോസ്‌  ഫൈനാൻസ് ഓഫീസർ ഫാദർ   സാബു  വർഗീസ്, ബാലരാമപുരം റെസിഡന്റ്‌സ് അസോസിയേഷൻ ജനറൽ സെക്രട്ടറി ശ്രി.ബാലരാമപുരം അൽഫോൻസ്,  ബാലരാമപുരം യുണിറ്റ്   വ്യാപാരി വ്യവസായി അസോസിയേഷൻ  പ്രസിഡന്റ് ഇ. ബി. ബഷീർ, വി.എച്. പി. ജില്ലാ പ്രസിഡന്റ് ഡോക്ടർ നാരായണൻറാവുഎന്നിവർ ആദരിച്ചു.  വര്ഷങ്ങളായി ഡയാലിസിസ് ചെയ്തുവരുന്ന വൃക്ക രോഗികൾക്ക് സ്നേഹോപഹാരം സമർപ്പിച്ചു.   ക്യാമ്പിലെത്തിയ  വൃക്ക മാറ്റിവെക്കൽ ശാസ്ത്രക്രിയക്ക് കാത്തിരിക്കുന്ന സാമ്പത്തിക ബുദ്ധിമുട്ടുള്ള രോഗികൾക്ക് 2.75ലക്ഷം രൂപക്ക് ശാസ്ത്രക്രിയ ചെയ്തു കൊടുക്കുന്നതായിരിക്കും. ഡോ. മഞ്ജു തമ്പി, നിംസ് ജനറൽ മാനേജർ ഡോ. കെ എ സജു, തുടങ്ങിയവർ സംബന്ധിച്ചു.",
      thumb: "assets/img/Pastevents/774.jpg",
    },
    {
      src: "assets/img/Pastevents/775.jpg",
      caption:
        "നെയ്യാറ്റിൻകര:ലോക വൃക്കദിനത്തോടനുബന്ധിച്ച്  നിംസ് മെഡിസിറ്റിയിൽ പ്രശസ്ത നെഫ്റോളജിസ്റ്റ് ഡോ. മഞ്ജു തമ്പിയുടെ നേതൃത്വത്തിൽ  സംഘടിപ്പിച്ച  സൗജന്യ വൃക്ക രോഗ നിർണയ ക്യാമ്പ്  നെയ്യാറ്റിൻകര നഗരസഭ കൗൺസിലർ ഗ്രാമം പ്രവീൺ ഉദ്ഘാടനം ചെയ്തു.  ക്യാമ്പിലെത്തിയ  ആദ്യത്തെ നൂറു പേർക്ക് ക്രിയാറ്റിൻ, ഷുഗർ, ബി പി, എന്നീ ടെസ്റ്റുകൾ സൗജന്യമായി ചെയ്തു നൽകി. കോവിഡ് രൂക്ഷമായ കാലത്തും  വൃക്ക മാറ്റിവെക്കൽ ശസ്ത്രക്രിയ വിജയകരമായി പൂർത്തീകരിച്ച നിംസ്  മെഡിക്കൽ സൂപ്രണ്ടും നെഫ്രോളജി വിഭാഗം മേധാവിയുമായ ഡോ. മഞ്ജു തമ്പിയെ നെയ്യാറ്റിൻകര ഡയോസ്‌കോസ്‌  ഫൈനാൻസ് ഓഫീസർ ഫാദർ   സാബു  വർഗീസ്, ബാലരാമപുരം റെസിഡന്റ്‌സ് അസോസിയേഷൻ ജനറൽ സെക്രട്ടറി ശ്രി.ബാലരാമപുരം അൽഫോൻസ്,  ബാലരാമപുരം യുണിറ്റ്   വ്യാപാരി വ്യവസായി അസോസിയേഷൻ  പ്രസിഡന്റ് ഇ. ബി. ബഷീർ, വി.എച്. പി. ജില്ലാ പ്രസിഡന്റ് ഡോക്ടർ നാരായണൻറാവുഎന്നിവർ ആദരിച്ചു.  വര്ഷങ്ങളായി ഡയാലിസിസ് ചെയ്തുവരുന്ന വൃക്ക രോഗികൾക്ക് സ്നേഹോപഹാരം സമർപ്പിച്ചു.   ക്യാമ്പിലെത്തിയ  വൃക്ക മാറ്റിവെക്കൽ ശാസ്ത്രക്രിയക്ക് കാത്തിരിക്കുന്ന സാമ്പത്തിക ബുദ്ധിമുട്ടുള്ള രോഗികൾക്ക് 2.75ലക്ഷം രൂപക്ക് ശാസ്ത്രക്രിയ ചെയ്തു കൊടുക്കുന്നതായിരിക്കും. ഡോ. മഞ്ജു തമ്പി, നിംസ് ജനറൽ മാനേജർ ഡോ. കെ എ സജു, തുടങ്ങിയവർ സംബന്ധിച്ചു.",
      thumb: "assets/img/Pastevents/775.jpg",
    },
    {
      src: "assets/img/Pastevents/776.jpg",
      caption:
        "നെയ്യാറ്റിൻകര:ലോക വൃക്കദിനത്തോടനുബന്ധിച്ച്  നിംസ് മെഡിസിറ്റിയിൽ പ്രശസ്ത നെഫ്റോളജിസ്റ്റ് ഡോ. മഞ്ജു തമ്പിയുടെ നേതൃത്വത്തിൽ  സംഘടിപ്പിച്ച  സൗജന്യ വൃക്ക രോഗ നിർണയ ക്യാമ്പ്  നെയ്യാറ്റിൻകര നഗരസഭ കൗൺസിലർ ഗ്രാമം പ്രവീൺ ഉദ്ഘാടനം ചെയ്തു.  ക്യാമ്പിലെത്തിയ  ആദ്യത്തെ നൂറു പേർക്ക് ക്രിയാറ്റിൻ, ഷുഗർ, ബി പി, എന്നീ ടെസ്റ്റുകൾ സൗജന്യമായി ചെയ്തു നൽകി. കോവിഡ് രൂക്ഷമായ കാലത്തും  വൃക്ക മാറ്റിവെക്കൽ ശസ്ത്രക്രിയ വിജയകരമായി പൂർത്തീകരിച്ച നിംസ്  മെഡിക്കൽ സൂപ്രണ്ടും നെഫ്രോളജി വിഭാഗം മേധാവിയുമായ ഡോ. മഞ്ജു തമ്പിയെ നെയ്യാറ്റിൻകര ഡയോസ്‌കോസ്‌  ഫൈനാൻസ് ഓഫീസർ ഫാദർ   സാബു  വർഗീസ്, ബാലരാമപുരം റെസിഡന്റ്‌സ് അസോസിയേഷൻ ജനറൽ സെക്രട്ടറി ശ്രി.ബാലരാമപുരം അൽഫോൻസ്,  ബാലരാമപുരം യുണിറ്റ്   വ്യാപാരി വ്യവസായി അസോസിയേഷൻ  പ്രസിഡന്റ് ഇ. ബി. ബഷീർ, വി.എച്. പി. ജില്ലാ പ്രസിഡന്റ് ഡോക്ടർ നാരായണൻറാവുഎന്നിവർ ആദരിച്ചു.  വര്ഷങ്ങളായി ഡയാലിസിസ് ചെയ്തുവരുന്ന വൃക്ക രോഗികൾക്ക് സ്നേഹോപഹാരം സമർപ്പിച്ചു.   ക്യാമ്പിലെത്തിയ  വൃക്ക മാറ്റിവെക്കൽ ശാസ്ത്രക്രിയക്ക് കാത്തിരിക്കുന്ന സാമ്പത്തിക ബുദ്ധിമുട്ടുള്ള രോഗികൾക്ക് 2.75ലക്ഷം രൂപക്ക് ശാസ്ത്രക്രിയ ചെയ്തു കൊടുക്കുന്നതായിരിക്കും. ഡോ. മഞ്ജു തമ്പി, നിംസ് ജനറൽ മാനേജർ ഡോ. കെ എ സജു, തുടങ്ങിയവർ സംബന്ധിച്ചു.",
      thumb: "assets/img/Pastevents/776.jpg",
    },
    {
      src: "assets/img/Pastevents/777.jpg",
      caption:
        "നെയ്യാറ്റിൻകര:ലോക വൃക്കദിനത്തോടനുബന്ധിച്ച്  നിംസ് മെഡിസിറ്റിയിൽ പ്രശസ്ത നെഫ്റോളജിസ്റ്റ് ഡോ. മഞ്ജു തമ്പിയുടെ നേതൃത്വത്തിൽ  സംഘടിപ്പിച്ച  സൗജന്യ വൃക്ക രോഗ നിർണയ ക്യാമ്പ്  നെയ്യാറ്റിൻകര നഗരസഭ കൗൺസിലർ ഗ്രാമം പ്രവീൺ ഉദ്ഘാടനം ചെയ്തു.  ക്യാമ്പിലെത്തിയ  ആദ്യത്തെ നൂറു പേർക്ക് ക്രിയാറ്റിൻ, ഷുഗർ, ബി പി, എന്നീ ടെസ്റ്റുകൾ സൗജന്യമായി ചെയ്തു നൽകി. കോവിഡ് രൂക്ഷമായ കാലത്തും  വൃക്ക മാറ്റിവെക്കൽ ശസ്ത്രക്രിയ വിജയകരമായി പൂർത്തീകരിച്ച നിംസ്  മെഡിക്കൽ സൂപ്രണ്ടും നെഫ്രോളജി വിഭാഗം മേധാവിയുമായ ഡോ. മഞ്ജു തമ്പിയെ നെയ്യാറ്റിൻകര ഡയോസ്‌കോസ്‌  ഫൈനാൻസ് ഓഫീസർ ഫാദർ   സാബു  വർഗീസ്, ബാലരാമപുരം റെസിഡന്റ്‌സ് അസോസിയേഷൻ ജനറൽ സെക്രട്ടറി ശ്രി.ബാലരാമപുരം അൽഫോൻസ്,  ബാലരാമപുരം യുണിറ്റ്   വ്യാപാരി വ്യവസായി അസോസിയേഷൻ  പ്രസിഡന്റ് ഇ. ബി. ബഷീർ, വി.എച്. പി. ജില്ലാ പ്രസിഡന്റ് ഡോക്ടർ നാരായണൻറാവുഎന്നിവർ ആദരിച്ചു.  വര്ഷങ്ങളായി ഡയാലിസിസ് ചെയ്തുവരുന്ന വൃക്ക രോഗികൾക്ക് സ്നേഹോപഹാരം സമർപ്പിച്ചു.   ക്യാമ്പിലെത്തിയ  വൃക്ക മാറ്റിവെക്കൽ ശാസ്ത്രക്രിയക്ക് കാത്തിരിക്കുന്ന സാമ്പത്തിക ബുദ്ധിമുട്ടുള്ള രോഗികൾക്ക് 2.75ലക്ഷം രൂപക്ക് ശാസ്ത്രക്രിയ ചെയ്തു കൊടുക്കുന്നതായിരിക്കും. ഡോ. മഞ്ജു തമ്പി, നിംസ് ജനറൽ മാനേജർ ഡോ. കെ എ സജു, തുടങ്ങിയവർ സംബന്ധിച്ചു.",
      thumb: "assets/img/Pastevents/777.jpg",
    },
    {
      src: "assets/img/Pastevents/778.jpg",
      caption:
        "നെയ്യാറ്റിൻകര:ലോക വൃക്കദിനത്തോടനുബന്ധിച്ച്  നിംസ് മെഡിസിറ്റിയിൽ പ്രശസ്ത നെഫ്റോളജിസ്റ്റ് ഡോ. മഞ്ജു തമ്പിയുടെ നേതൃത്വത്തിൽ  സംഘടിപ്പിച്ച  സൗജന്യ വൃക്ക രോഗ നിർണയ ക്യാമ്പ്  നെയ്യാറ്റിൻകര നഗരസഭ കൗൺസിലർ ഗ്രാമം പ്രവീൺ ഉദ്ഘാടനം ചെയ്തു.  ക്യാമ്പിലെത്തിയ  ആദ്യത്തെ നൂറു പേർക്ക് ക്രിയാറ്റിൻ, ഷുഗർ, ബി പി, എന്നീ ടെസ്റ്റുകൾ സൗജന്യമായി ചെയ്തു നൽകി. കോവിഡ് രൂക്ഷമായ കാലത്തും  വൃക്ക മാറ്റിവെക്കൽ ശസ്ത്രക്രിയ വിജയകരമായി പൂർത്തീകരിച്ച നിംസ്  മെഡിക്കൽ സൂപ്രണ്ടും നെഫ്രോളജി വിഭാഗം മേധാവിയുമായ ഡോ. മഞ്ജു തമ്പിയെ നെയ്യാറ്റിൻകര ഡയോസ്‌കോസ്‌  ഫൈനാൻസ് ഓഫീസർ ഫാദർ   സാബു  വർഗീസ്, ബാലരാമപുരം റെസിഡന്റ്‌സ് അസോസിയേഷൻ ജനറൽ സെക്രട്ടറി ശ്രി.ബാലരാമപുരം അൽഫോൻസ്,  ബാലരാമപുരം യുണിറ്റ്   വ്യാപാരി വ്യവസായി അസോസിയേഷൻ  പ്രസിഡന്റ് ഇ. ബി. ബഷീർ, വി.എച്. പി. ജില്ലാ പ്രസിഡന്റ് ഡോക്ടർ നാരായണൻറാവുഎന്നിവർ ആദരിച്ചു.  വര്ഷങ്ങളായി ഡയാലിസിസ് ചെയ്തുവരുന്ന വൃക്ക രോഗികൾക്ക് സ്നേഹോപഹാരം സമർപ്പിച്ചു.   ക്യാമ്പിലെത്തിയ  വൃക്ക മാറ്റിവെക്കൽ ശാസ്ത്രക്രിയക്ക് കാത്തിരിക്കുന്ന സാമ്പത്തിക ബുദ്ധിമുട്ടുള്ള രോഗികൾക്ക് 2.75ലക്ഷം രൂപക്ക് ശാസ്ത്രക്രിയ ചെയ്തു കൊടുക്കുന്നതായിരിക്കും. ഡോ. മഞ്ജു തമ്പി, നിംസ് ജനറൽ മാനേജർ ഡോ. കെ എ സജു, തുടങ്ങിയവർ സംബന്ധിച്ചു.",
      thumb: "assets/img/Pastevents/778.jpg",
    },
    {
      src: "assets/img/Pastevents/779.jpg",
      caption:
        "നെയ്യാറ്റിൻകര:ലോക വൃക്കദിനത്തോടനുബന്ധിച്ച്  നിംസ് മെഡിസിറ്റിയിൽ പ്രശസ്ത നെഫ്റോളജിസ്റ്റ് ഡോ. മഞ്ജു തമ്പിയുടെ നേതൃത്വത്തിൽ  സംഘടിപ്പിച്ച  സൗജന്യ വൃക്ക രോഗ നിർണയ ക്യാമ്പ്  നെയ്യാറ്റിൻകര നഗരസഭ കൗൺസിലർ ഗ്രാമം പ്രവീൺ ഉദ്ഘാടനം ചെയ്തു.  ക്യാമ്പിലെത്തിയ  ആദ്യത്തെ നൂറു പേർക്ക് ക്രിയാറ്റിൻ, ഷുഗർ, ബി പി, എന്നീ ടെസ്റ്റുകൾ സൗജന്യമായി ചെയ്തു നൽകി. കോവിഡ് രൂക്ഷമായ കാലത്തും  വൃക്ക മാറ്റിവെക്കൽ ശസ്ത്രക്രിയ വിജയകരമായി പൂർത്തീകരിച്ച നിംസ്  മെഡിക്കൽ സൂപ്രണ്ടും നെഫ്രോളജി വിഭാഗം മേധാവിയുമായ ഡോ. മഞ്ജു തമ്പിയെ നെയ്യാറ്റിൻകര ഡയോസ്‌കോസ്‌  ഫൈനാൻസ് ഓഫീസർ ഫാദർ   സാബു  വർഗീസ്, ബാലരാമപുരം റെസിഡന്റ്‌സ് അസോസിയേഷൻ ജനറൽ സെക്രട്ടറി ശ്രി.ബാലരാമപുരം അൽഫോൻസ്,  ബാലരാമപുരം യുണിറ്റ്   വ്യാപാരി വ്യവസായി അസോസിയേഷൻ  പ്രസിഡന്റ് ഇ. ബി. ബഷീർ, വി.എച്. പി. ജില്ലാ പ്രസിഡന്റ് ഡോക്ടർ നാരായണൻറാവുഎന്നിവർ ആദരിച്ചു.  വര്ഷങ്ങളായി ഡയാലിസിസ് ചെയ്തുവരുന്ന വൃക്ക രോഗികൾക്ക് സ്നേഹോപഹാരം സമർപ്പിച്ചു.   ക്യാമ്പിലെത്തിയ  വൃക്ക മാറ്റിവെക്കൽ ശാസ്ത്രക്രിയക്ക് കാത്തിരിക്കുന്ന സാമ്പത്തിക ബുദ്ധിമുട്ടുള്ള രോഗികൾക്ക് 2.75ലക്ഷം രൂപക്ക് ശാസ്ത്രക്രിയ ചെയ്തു കൊടുക്കുന്നതായിരിക്കും. ഡോ. മഞ്ജു തമ്പി, നിംസ് ജനറൽ മാനേജർ ഡോ. കെ എ സജു, തുടങ്ങിയവർ സംബന്ധിച്ചു.",
      thumb: "assets/img/Pastevents/779.jpg",
    },
    {
      src: "assets/img/Pastevents/780.jpg",
      caption:
        "നെയ്യാറ്റിൻകര:ലോക വൃക്കദിനത്തോടനുബന്ധിച്ച്  നിംസ് മെഡിസിറ്റിയിൽ പ്രശസ്ത നെഫ്റോളജിസ്റ്റ് ഡോ. മഞ്ജു തമ്പിയുടെ നേതൃത്വത്തിൽ  സംഘടിപ്പിച്ച  സൗജന്യ വൃക്ക രോഗ നിർണയ ക്യാമ്പ്  നെയ്യാറ്റിൻകര നഗരസഭ കൗൺസിലർ ഗ്രാമം പ്രവീൺ ഉദ്ഘാടനം ചെയ്തു.  ക്യാമ്പിലെത്തിയ  ആദ്യത്തെ നൂറു പേർക്ക് ക്രിയാറ്റിൻ, ഷുഗർ, ബി പി, എന്നീ ടെസ്റ്റുകൾ സൗജന്യമായി ചെയ്തു നൽകി. കോവിഡ് രൂക്ഷമായ കാലത്തും  വൃക്ക മാറ്റിവെക്കൽ ശസ്ത്രക്രിയ വിജയകരമായി പൂർത്തീകരിച്ച നിംസ്  മെഡിക്കൽ സൂപ്രണ്ടും നെഫ്രോളജി വിഭാഗം മേധാവിയുമായ ഡോ. മഞ്ജു തമ്പിയെ നെയ്യാറ്റിൻകര ഡയോസ്‌കോസ്‌  ഫൈനാൻസ് ഓഫീസർ ഫാദർ   സാബു  വർഗീസ്, ബാലരാമപുരം റെസിഡന്റ്‌സ് അസോസിയേഷൻ ജനറൽ സെക്രട്ടറി ശ്രി.ബാലരാമപുരം അൽഫോൻസ്,  ബാലരാമപുരം യുണിറ്റ്   വ്യാപാരി വ്യവസായി അസോസിയേഷൻ  പ്രസിഡന്റ് ഇ. ബി. ബഷീർ, വി.എച്. പി. ജില്ലാ പ്രസിഡന്റ് ഡോക്ടർ നാരായണൻറാവുഎന്നിവർ ആദരിച്ചു.  വര്ഷങ്ങളായി ഡയാലിസിസ് ചെയ്തുവരുന്ന വൃക്ക രോഗികൾക്ക് സ്നേഹോപഹാരം സമർപ്പിച്ചു.   ക്യാമ്പിലെത്തിയ  വൃക്ക മാറ്റിവെക്കൽ ശാസ്ത്രക്രിയക്ക് കാത്തിരിക്കുന്ന സാമ്പത്തിക ബുദ്ധിമുട്ടുള്ള രോഗികൾക്ക് 2.75ലക്ഷം രൂപക്ക് ശാസ്ത്രക്രിയ ചെയ്തു കൊടുക്കുന്നതായിരിക്കും. ഡോ. മഞ്ജു തമ്പി, നിംസ് ജനറൽ മാനേജർ ഡോ. കെ എ സജു, തുടങ്ങിയവർ സംബന്ധിച്ചു.",
      thumb: "assets/img/Pastevents/780.jpg",
    },
    {
      src: "assets/img/Pastevents/781.jpg",
      caption:
        "നെയ്യാറ്റിൻകര:ലോക വൃക്കദിനത്തോടനുബന്ധിച്ച്  നിംസ് മെഡിസിറ്റിയിൽ പ്രശസ്ത നെഫ്റോളജിസ്റ്റ് ഡോ. മഞ്ജു തമ്പിയുടെ നേതൃത്വത്തിൽ  സംഘടിപ്പിച്ച  സൗജന്യ വൃക്ക രോഗ നിർണയ ക്യാമ്പ്  നെയ്യാറ്റിൻകര നഗരസഭ കൗൺസിലർ ഗ്രാമം പ്രവീൺ ഉദ്ഘാടനം ചെയ്തു.  ക്യാമ്പിലെത്തിയ  ആദ്യത്തെ നൂറു പേർക്ക് ക്രിയാറ്റിൻ, ഷുഗർ, ബി പി, എന്നീ ടെസ്റ്റുകൾ സൗജന്യമായി ചെയ്തു നൽകി. കോവിഡ് രൂക്ഷമായ കാലത്തും  വൃക്ക മാറ്റിവെക്കൽ ശസ്ത്രക്രിയ വിജയകരമായി പൂർത്തീകരിച്ച നിംസ്  മെഡിക്കൽ സൂപ്രണ്ടും നെഫ്രോളജി വിഭാഗം മേധാവിയുമായ ഡോ. മഞ്ജു തമ്പിയെ നെയ്യാറ്റിൻകര ഡയോസ്‌കോസ്‌  ഫൈനാൻസ് ഓഫീസർ ഫാദർ   സാബു  വർഗീസ്, ബാലരാമപുരം റെസിഡന്റ്‌സ് അസോസിയേഷൻ ജനറൽ സെക്രട്ടറി ശ്രി.ബാലരാമപുരം അൽഫോൻസ്,  ബാലരാമപുരം യുണിറ്റ്   വ്യാപാരി വ്യവസായി അസോസിയേഷൻ  പ്രസിഡന്റ് ഇ. ബി. ബഷീർ, വി.എച്. പി. ജില്ലാ പ്രസിഡന്റ് ഡോക്ടർ നാരായണൻറാവുഎന്നിവർ ആദരിച്ചു.  വര്ഷങ്ങളായി ഡയാലിസിസ് ചെയ്തുവരുന്ന വൃക്ക രോഗികൾക്ക് സ്നേഹോപഹാരം സമർപ്പിച്ചു.   ക്യാമ്പിലെത്തിയ  വൃക്ക മാറ്റിവെക്കൽ ശാസ്ത്രക്രിയക്ക് കാത്തിരിക്കുന്ന സാമ്പത്തിക ബുദ്ധിമുട്ടുള്ള രോഗികൾക്ക് 2.75ലക്ഷം രൂപക്ക് ശാസ്ത്രക്രിയ ചെയ്തു കൊടുക്കുന്നതായിരിക്കും. ഡോ. മഞ്ജു തമ്പി, നിംസ് ജനറൽ മാനേജർ ഡോ. കെ എ സജു, തുടങ്ങിയവർ സംബന്ധിച്ചു.",
      thumb: "assets/img/Pastevents/782.jpg",
    },
    {
      src: "assets/img/Pastevents/783.jpg",
      caption:
        "നെയ്യാറ്റിൻകര:ലോക വൃക്കദിനത്തോടനുബന്ധിച്ച്  നിംസ് മെഡിസിറ്റിയിൽ പ്രശസ്ത നെഫ്റോളജിസ്റ്റ് ഡോ. മഞ്ജു തമ്പിയുടെ നേതൃത്വത്തിൽ  സംഘടിപ്പിച്ച  സൗജന്യ വൃക്ക രോഗ നിർണയ ക്യാമ്പ്  നെയ്യാറ്റിൻകര നഗരസഭ കൗൺസിലർ ഗ്രാമം പ്രവീൺ ഉദ്ഘാടനം ചെയ്തു.  ക്യാമ്പിലെത്തിയ  ആദ്യത്തെ നൂറു പേർക്ക് ക്രിയാറ്റിൻ, ഷുഗർ, ബി പി, എന്നീ ടെസ്റ്റുകൾ സൗജന്യമായി ചെയ്തു നൽകി. കോവിഡ് രൂക്ഷമായ കാലത്തും  വൃക്ക മാറ്റിവെക്കൽ ശസ്ത്രക്രിയ വിജയകരമായി പൂർത്തീകരിച്ച നിംസ്  മെഡിക്കൽ സൂപ്രണ്ടും നെഫ്രോളജി വിഭാഗം മേധാവിയുമായ ഡോ. മഞ്ജു തമ്പിയെ നെയ്യാറ്റിൻകര ഡയോസ്‌കോസ്‌  ഫൈനാൻസ് ഓഫീസർ ഫാദർ   സാബു  വർഗീസ്, ബാലരാമപുരം റെസിഡന്റ്‌സ് അസോസിയേഷൻ ജനറൽ സെക്രട്ടറി ശ്രി.ബാലരാമപുരം അൽഫോൻസ്,  ബാലരാമപുരം യുണിറ്റ്   വ്യാപാരി വ്യവസായി അസോസിയേഷൻ  പ്രസിഡന്റ് ഇ. ബി. ബഷീർ, വി.എച്. പി. ജില്ലാ പ്രസിഡന്റ് ഡോക്ടർ നാരായണൻറാവുഎന്നിവർ ആദരിച്ചു.  വര്ഷങ്ങളായി ഡയാലിസിസ് ചെയ്തുവരുന്ന വൃക്ക രോഗികൾക്ക് സ്നേഹോപഹാരം സമർപ്പിച്ചു.   ക്യാമ്പിലെത്തിയ  വൃക്ക മാറ്റിവെക്കൽ ശാസ്ത്രക്രിയക്ക് കാത്തിരിക്കുന്ന സാമ്പത്തിക ബുദ്ധിമുട്ടുള്ള രോഗികൾക്ക് 2.75ലക്ഷം രൂപക്ക് ശാസ്ത്രക്രിയ ചെയ്തു കൊടുക്കുന്നതായിരിക്കും. ഡോ. മഞ്ജു തമ്പി, നിംസ് ജനറൽ മാനേജർ ഡോ. കെ എ സജു, തുടങ്ങിയവർ സംബന്ധിച്ചു.",
      thumb: "assets/img/Pastevents/783.jpg",
    },
    {
      src: "assets/img/Pastevents/784.jpg",
      caption:
        "നെയ്യാറ്റിൻകര:ലോക വൃക്കദിനത്തോടനുബന്ധിച്ച്  നിംസ് മെഡിസിറ്റിയിൽ പ്രശസ്ത നെഫ്റോളജിസ്റ്റ് ഡോ. മഞ്ജു തമ്പിയുടെ നേതൃത്വത്തിൽ  സംഘടിപ്പിച്ച  സൗജന്യ വൃക്ക രോഗ നിർണയ ക്യാമ്പ്  നെയ്യാറ്റിൻകര നഗരസഭ കൗൺസിലർ ഗ്രാമം പ്രവീൺ ഉദ്ഘാടനം ചെയ്തു.  ക്യാമ്പിലെത്തിയ  ആദ്യത്തെ നൂറു പേർക്ക് ക്രിയാറ്റിൻ, ഷുഗർ, ബി പി, എന്നീ ടെസ്റ്റുകൾ സൗജന്യമായി ചെയ്തു നൽകി. കോവിഡ് രൂക്ഷമായ കാലത്തും  വൃക്ക മാറ്റിവെക്കൽ ശസ്ത്രക്രിയ വിജയകരമായി പൂർത്തീകരിച്ച നിംസ്  മെഡിക്കൽ സൂപ്രണ്ടും നെഫ്രോളജി വിഭാഗം മേധാവിയുമായ ഡോ. മഞ്ജു തമ്പിയെ നെയ്യാറ്റിൻകര ഡയോസ്‌കോസ്‌  ഫൈനാൻസ് ഓഫീസർ ഫാദർ   സാബു  വർഗീസ്, ബാലരാമപുരം റെസിഡന്റ്‌സ് അസോസിയേഷൻ ജനറൽ സെക്രട്ടറി ശ്രി.ബാലരാമപുരം അൽഫോൻസ്,  ബാലരാമപുരം യുണിറ്റ്   വ്യാപാരി വ്യവസായി അസോസിയേഷൻ  പ്രസിഡന്റ് ഇ. ബി. ബഷീർ, വി.എച്. പി. ജില്ലാ പ്രസിഡന്റ് ഡോക്ടർ നാരായണൻറാവുഎന്നിവർ ആദരിച്ചു.  വര്ഷങ്ങളായി ഡയാലിസിസ് ചെയ്തുവരുന്ന വൃക്ക രോഗികൾക്ക് സ്നേഹോപഹാരം സമർപ്പിച്ചു.   ക്യാമ്പിലെത്തിയ  വൃക്ക മാറ്റിവെക്കൽ ശാസ്ത്രക്രിയക്ക് കാത്തിരിക്കുന്ന സാമ്പത്തിക ബുദ്ധിമുട്ടുള്ള രോഗികൾക്ക് 2.75ലക്ഷം രൂപക്ക് ശാസ്ത്രക്രിയ ചെയ്തു കൊടുക്കുന്നതായിരിക്കും. ഡോ. മഞ്ജു തമ്പി, നിംസ് ജനറൽ മാനേജർ ഡോ. കെ എ സജു, തുടങ്ങിയവർ സംബന്ധിച്ചു.",
      thumb: "assets/img/Pastevents/784.jpg",
    },
    {
      src: "assets/img/Pastevents/785.jpg",
      caption:
        "നെയ്യാറ്റിൻകര:ലോക വൃക്കദിനത്തോടനുബന്ധിച്ച്  നിംസ് മെഡിസിറ്റിയിൽ പ്രശസ്ത നെഫ്റോളജിസ്റ്റ് ഡോ. മഞ്ജു തമ്പിയുടെ നേതൃത്വത്തിൽ  സംഘടിപ്പിച്ച  സൗജന്യ വൃക്ക രോഗ നിർണയ ക്യാമ്പ്  നെയ്യാറ്റിൻകര നഗരസഭ കൗൺസിലർ ഗ്രാമം പ്രവീൺ ഉദ്ഘാടനം ചെയ്തു.  ക്യാമ്പിലെത്തിയ  ആദ്യത്തെ നൂറു പേർക്ക് ക്രിയാറ്റിൻ, ഷുഗർ, ബി പി, എന്നീ ടെസ്റ്റുകൾ സൗജന്യമായി ചെയ്തു നൽകി. കോവിഡ് രൂക്ഷമായ കാലത്തും  വൃക്ക മാറ്റിവെക്കൽ ശസ്ത്രക്രിയ വിജയകരമായി പൂർത്തീകരിച്ച നിംസ്  മെഡിക്കൽ സൂപ്രണ്ടും നെഫ്രോളജി വിഭാഗം മേധാവിയുമായ ഡോ. മഞ്ജു തമ്പിയെ നെയ്യാറ്റിൻകര ഡയോസ്‌കോസ്‌  ഫൈനാൻസ് ഓഫീസർ ഫാദർ   സാബു  വർഗീസ്, ബാലരാമപുരം റെസിഡന്റ്‌സ് അസോസിയേഷൻ ജനറൽ സെക്രട്ടറി ശ്രി.ബാലരാമപുരം അൽഫോൻസ്,  ബാലരാമപുരം യുണിറ്റ്   വ്യാപാരി വ്യവസായി അസോസിയേഷൻ  പ്രസിഡന്റ് ഇ. ബി. ബഷീർ, വി.എച്. പി. ജില്ലാ പ്രസിഡന്റ് ഡോക്ടർ നാരായണൻറാവുഎന്നിവർ ആദരിച്ചു.  വര്ഷങ്ങളായി ഡയാലിസിസ് ചെയ്തുവരുന്ന വൃക്ക രോഗികൾക്ക് സ്നേഹോപഹാരം സമർപ്പിച്ചു.   ക്യാമ്പിലെത്തിയ  വൃക്ക മാറ്റിവെക്കൽ ശാസ്ത്രക്രിയക്ക് കാത്തിരിക്കുന്ന സാമ്പത്തിക ബുദ്ധിമുട്ടുള്ള രോഗികൾക്ക് 2.75ലക്ഷം രൂപക്ക് ശാസ്ത്രക്രിയ ചെയ്തു കൊടുക്കുന്നതായിരിക്കും. ഡോ. മഞ്ജു തമ്പി, നിംസ് ജനറൽ മാനേജർ ഡോ. കെ എ സജു, തുടങ്ങിയവർ സംബന്ധിച്ചു.",
      thumb: "assets/img/Pastevents/785.jpg",
    },
    {
      src: "assets/img/Pastevents/761.jpg",
      caption:
        "ലോക  വനിതാ ദിനത്തോടനുബന്ധിച്ച് വനിതകൾക്കായി  നെയ്യാറ്റിൻകര നിംസ്  മെഡിസിറ്റിയിൽ റിട്ട. ഗവണ്മെന്റ് സീനിയർ ജനറൽ സർജൻ  ഡോ. ഇന്ദിരാമ്മയുടെ  നേതൃത്വത്തിൽ   വനിതാ ഡോക്ടർമാർ  സൗജന്യ  സൂപർ സ്പെഷ്യാലിറ്റി   മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.  സംസ്ഥാനത്തെ   മികച്ച തഹസിൽദാറിനുള്ള അവാർഡ് ലഭിച്ച  നെയ്യാറ്റിൻകര  താലൂക് തഹസിൽദാർ ശ്രിമതി ശോഭ സതീഷ് ക്യാമ്പ് ഉദ്‌ഘാടനം ചെയ്തു. ക്യാംപിലെത്തിയ 421 പേർക്കും  രക്തം, കൊളസ്‌ട്രോൾ, ഷുഗർ, തൈറോയ്ഡ്,  ഇ. സി. ജി. എന്നിവ   സൗജന്യമായി  പരിശോധന നടത്തി.  തുടര്ചികിത്സകൾ ഡിസ്‌കൗണ്ടോടു കൂടി നൽകുന്നതായിരിക്കും. സർജറി ആവശ്യമുള്ളവർക്ക് പാക്കേജുകളോടെ സർജറി ചെയ്തുകൊടുക്കുന്നതായിരിക്കും. ചടങ്ങിൽ നിംസ് മെഡിസിറ്റി ജനറൽ മാനേജർ ഡോ. കെ എ സജു, ഡോ.നയൻ താര, ഡോ.മായ, എസ്. എസ്. സോനു, തുടങ്ങിയവർ പ്രസംഗിച്ചു.",
      thumb: "assets/img/Pastevents/761.jpg",
    },
    {
      src: "assets/img/Pastevents/762.jpg",
      caption:
        "ലോക  വനിതാ ദിനത്തോടനുബന്ധിച്ച് വനിതകൾക്കായി  നെയ്യാറ്റിൻകര നിംസ്  മെഡിസിറ്റിയിൽ റിട്ട. ഗവണ്മെന്റ് സീനിയർ ജനറൽ സർജൻ  ഡോ. ഇന്ദിരാമ്മയുടെ  നേതൃത്വത്തിൽ   വനിതാ ഡോക്ടർമാർ  സൗജന്യ  സൂപർ സ്പെഷ്യാലിറ്റി   മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.  സംസ്ഥാനത്തെ   മികച്ച തഹസിൽദാറിനുള്ള അവാർഡ് ലഭിച്ച  നെയ്യാറ്റിൻകര  താലൂക് തഹസിൽദാർ ശ്രിമതി ശോഭ സതീഷ് ക്യാമ്പ് ഉദ്‌ഘാടനം ചെയ്തു. ക്യാംപിലെത്തിയ 421 പേർക്കും  രക്തം, കൊളസ്‌ട്രോൾ, ഷുഗർ, തൈറോയ്ഡ്,  ഇ. സി. ജി. എന്നിവ   സൗജന്യമായി  പരിശോധന നടത്തി.  തുടര്ചികിത്സകൾ ഡിസ്‌കൗണ്ടോടു കൂടി നൽകുന്നതായിരിക്കും. സർജറി ആവശ്യമുള്ളവർക്ക് പാക്കേജുകളോടെ സർജറി ചെയ്തുകൊടുക്കുന്നതായിരിക്കും. ചടങ്ങിൽ നിംസ് മെഡിസിറ്റി ജനറൽ മാനേജർ ഡോ. കെ എ സജു, ഡോ.നയൻ താര, ഡോ.മായ, എസ്. എസ്. സോനു, തുടങ്ങിയവർ പ്രസംഗിച്ചു.",
      thumb: "assets/img/Pastevents/762.jpg",
    },
    {
      src: "assets/img/Pastevents/763.jpg",
      caption:
        "ലോക  വനിതാ ദിനത്തോടനുബന്ധിച്ച് വനിതകൾക്കായി  നെയ്യാറ്റിൻകര നിംസ്  മെഡിസിറ്റിയിൽ റിട്ട. ഗവണ്മെന്റ് സീനിയർ ജനറൽ സർജൻ  ഡോ. ഇന്ദിരാമ്മയുടെ  നേതൃത്വത്തിൽ   വനിതാ ഡോക്ടർമാർ  സൗജന്യ  സൂപർ സ്പെഷ്യാലിറ്റി   മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.  സംസ്ഥാനത്തെ   മികച്ച തഹസിൽദാറിനുള്ള അവാർഡ് ലഭിച്ച  നെയ്യാറ്റിൻകര  താലൂക് തഹസിൽദാർ ശ്രിമതി ശോഭ സതീഷ് ക്യാമ്പ് ഉദ്‌ഘാടനം ചെയ്തു. ക്യാംപിലെത്തിയ 421 പേർക്കും  രക്തം, കൊളസ്‌ട്രോൾ, ഷുഗർ, തൈറോയ്ഡ്,  ഇ. സി. ജി. എന്നിവ   സൗജന്യമായി  പരിശോധന നടത്തി.  തുടര്ചികിത്സകൾ ഡിസ്‌കൗണ്ടോടു കൂടി നൽകുന്നതായിരിക്കും. സർജറി ആവശ്യമുള്ളവർക്ക് പാക്കേജുകളോടെ സർജറി ചെയ്തുകൊടുക്കുന്നതായിരിക്കും. ചടങ്ങിൽ നിംസ് മെഡിസിറ്റി ജനറൽ മാനേജർ ഡോ. കെ എ സജു, ഡോ.നയൻ താര, ഡോ.മായ, എസ്. എസ്. സോനു, തുടങ്ങിയവർ പ്രസംഗിച്ചു.",
      thumb: "assets/img/Pastevents/763.jpg",
    },
    {
      src: "assets/img/Pastevents/764.jpg",
      caption:
        "ലോക  വനിതാ ദിനത്തോടനുബന്ധിച്ച് വനിതകൾക്കായി  നെയ്യാറ്റിൻകര നിംസ്  മെഡിസിറ്റിയിൽ റിട്ട. ഗവണ്മെന്റ് സീനിയർ ജനറൽ സർജൻ  ഡോ. ഇന്ദിരാമ്മയുടെ  നേതൃത്വത്തിൽ   വനിതാ ഡോക്ടർമാർ  സൗജന്യ  സൂപർ സ്പെഷ്യാലിറ്റി   മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.  സംസ്ഥാനത്തെ   മികച്ച തഹസിൽദാറിനുള്ള അവാർഡ് ലഭിച്ച  നെയ്യാറ്റിൻകര  താലൂക് തഹസിൽദാർ ശ്രിമതി ശോഭ സതീഷ് ക്യാമ്പ് ഉദ്‌ഘാടനം ചെയ്തു. ക്യാംപിലെത്തിയ 421 പേർക്കും  രക്തം, കൊളസ്‌ട്രോൾ, ഷുഗർ, തൈറോയ്ഡ്,  ഇ. സി. ജി. എന്നിവ   സൗജന്യമായി  പരിശോധന നടത്തി.  തുടര്ചികിത്സകൾ ഡിസ്‌കൗണ്ടോടു കൂടി നൽകുന്നതായിരിക്കും. സർജറി ആവശ്യമുള്ളവർക്ക് പാക്കേജുകളോടെ സർജറി ചെയ്തുകൊടുക്കുന്നതായിരിക്കും. ചടങ്ങിൽ നിംസ് മെഡിസിറ്റി ജനറൽ മാനേജർ ഡോ. കെ എ സജു, ഡോ.നയൻ താര, ഡോ.മായ, എസ്. എസ്. സോനു, തുടങ്ങിയവർ പ്രസംഗിച്ചു.",
      thumb: "assets/img/Pastevents/764.jpg",
    },
    {
      src: "assets/img/Pastevents/765.jpg",
      caption:
        "ലോക  വനിതാ ദിനത്തോടനുബന്ധിച്ച് വനിതകൾക്കായി  നെയ്യാറ്റിൻകര നിംസ്  മെഡിസിറ്റിയിൽ റിട്ട. ഗവണ്മെന്റ് സീനിയർ ജനറൽ സർജൻ  ഡോ. ഇന്ദിരാമ്മയുടെ  നേതൃത്വത്തിൽ   വനിതാ ഡോക്ടർമാർ  സൗജന്യ  സൂപർ സ്പെഷ്യാലിറ്റി   മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.  സംസ്ഥാനത്തെ   മികച്ച തഹസിൽദാറിനുള്ള അവാർഡ് ലഭിച്ച  നെയ്യാറ്റിൻകര  താലൂക് തഹസിൽദാർ ശ്രിമതി ശോഭ സതീഷ് ക്യാമ്പ് ഉദ്‌ഘാടനം ചെയ്തു. ക്യാംപിലെത്തിയ 421 പേർക്കും  രക്തം, കൊളസ്‌ട്രോൾ, ഷുഗർ, തൈറോയ്ഡ്,  ഇ. സി. ജി. എന്നിവ   സൗജന്യമായി  പരിശോധന നടത്തി.  തുടര്ചികിത്സകൾ ഡിസ്‌കൗണ്ടോടു കൂടി നൽകുന്നതായിരിക്കും. സർജറി ആവശ്യമുള്ളവർക്ക് പാക്കേജുകളോടെ സർജറി ചെയ്തുകൊടുക്കുന്നതായിരിക്കും. ചടങ്ങിൽ നിംസ് മെഡിസിറ്റി ജനറൽ മാനേജർ ഡോ. കെ എ സജു, ഡോ.നയൻ താര, ഡോ.മായ, എസ്. എസ്. സോനു, തുടങ്ങിയവർ പ്രസംഗിച്ചു.",
      thumb: "assets/img/Pastevents/765.jpg",
    },
    {
      src: "assets/img/Pastevents/766.jpg",
      caption:
        "ലോക  വനിതാ ദിനത്തോടനുബന്ധിച്ച് വനിതകൾക്കായി  നെയ്യാറ്റിൻകര നിംസ്  മെഡിസിറ്റിയിൽ റിട്ട. ഗവണ്മെന്റ് സീനിയർ ജനറൽ സർജൻ  ഡോ. ഇന്ദിരാമ്മയുടെ  നേതൃത്വത്തിൽ   വനിതാ ഡോക്ടർമാർ  സൗജന്യ  സൂപർ സ്പെഷ്യാലിറ്റി   മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.  സംസ്ഥാനത്തെ   മികച്ച തഹസിൽദാറിനുള്ള അവാർഡ് ലഭിച്ച  നെയ്യാറ്റിൻകര  താലൂക് തഹസിൽദാർ ശ്രിമതി ശോഭ സതീഷ് ക്യാമ്പ് ഉദ്‌ഘാടനം ചെയ്തു. ക്യാംപിലെത്തിയ 421 പേർക്കും  രക്തം, കൊളസ്‌ട്രോൾ, ഷുഗർ, തൈറോയ്ഡ്,  ഇ. സി. ജി. എന്നിവ   സൗജന്യമായി  പരിശോധന നടത്തി.  തുടര്ചികിത്സകൾ ഡിസ്‌കൗണ്ടോടു കൂടി നൽകുന്നതായിരിക്കും. സർജറി ആവശ്യമുള്ളവർക്ക് പാക്കേജുകളോടെ സർജറി ചെയ്തുകൊടുക്കുന്നതായിരിക്കും. ചടങ്ങിൽ നിംസ് മെഡിസിറ്റി ജനറൽ മാനേജർ ഡോ. കെ എ സജു, ഡോ.നയൻ താര, ഡോ.മായ, എസ്. എസ്. സോനു, തുടങ്ങിയവർ പ്രസംഗിച്ചു.",
      thumb: "assets/img/Pastevents/766.jpg",
    },
    {
      src: "assets/img/Pastevents/767.jpg",
      caption:
        "ലോക  വനിതാ ദിനത്തോടനുബന്ധിച്ച് വനിതകൾക്കായി  നെയ്യാറ്റിൻകര നിംസ്  മെഡിസിറ്റിയിൽ റിട്ട. ഗവണ്മെന്റ് സീനിയർ ജനറൽ സർജൻ  ഡോ. ഇന്ദിരാമ്മയുടെ  നേതൃത്വത്തിൽ   വനിതാ ഡോക്ടർമാർ  സൗജന്യ  സൂപർ സ്പെഷ്യാലിറ്റി   മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.  സംസ്ഥാനത്തെ   മികച്ച തഹസിൽദാറിനുള്ള അവാർഡ് ലഭിച്ച  നെയ്യാറ്റിൻകര  താലൂക് തഹസിൽദാർ ശ്രിമതി ശോഭ സതീഷ് ക്യാമ്പ് ഉദ്‌ഘാടനം ചെയ്തു. ക്യാംപിലെത്തിയ 421 പേർക്കും  രക്തം, കൊളസ്‌ട്രോൾ, ഷുഗർ, തൈറോയ്ഡ്,  ഇ. സി. ജി. എന്നിവ   സൗജന്യമായി  പരിശോധന നടത്തി.  തുടര്ചികിത്സകൾ ഡിസ്‌കൗണ്ടോടു കൂടി നൽകുന്നതായിരിക്കും. സർജറി ആവശ്യമുള്ളവർക്ക് പാക്കേജുകളോടെ സർജറി ചെയ്തുകൊടുക്കുന്നതായിരിക്കും. ചടങ്ങിൽ നിംസ് മെഡിസിറ്റി ജനറൽ മാനേജർ ഡോ. കെ എ സജു, ഡോ.നയൻ താര, ഡോ.മായ, എസ്. എസ്. സോനു, തുടങ്ങിയവർ പ്രസംഗിച്ചു.",
      thumb: "assets/img/Pastevents/767.jpg",
    },
    {
      src: "assets/img/Pastevents/768.jpg",
      caption:
        "ലോക  വനിതാ ദിനത്തോടനുബന്ധിച്ച് വനിതകൾക്കായി  നെയ്യാറ്റിൻകര നിംസ്  മെഡിസിറ്റിയിൽ റിട്ട. ഗവണ്മെന്റ് സീനിയർ ജനറൽ സർജൻ  ഡോ. ഇന്ദിരാമ്മയുടെ  നേതൃത്വത്തിൽ   വനിതാ ഡോക്ടർമാർ  സൗജന്യ  സൂപർ സ്പെഷ്യാലിറ്റി   മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.  സംസ്ഥാനത്തെ   മികച്ച തഹസിൽദാറിനുള്ള അവാർഡ് ലഭിച്ച  നെയ്യാറ്റിൻകര  താലൂക് തഹസിൽദാർ ശ്രിമതി ശോഭ സതീഷ് ക്യാമ്പ് ഉദ്‌ഘാടനം ചെയ്തു. ക്യാംപിലെത്തിയ 421 പേർക്കും  രക്തം, കൊളസ്‌ട്രോൾ, ഷുഗർ, തൈറോയ്ഡ്,  ഇ. സി. ജി. എന്നിവ   സൗജന്യമായി  പരിശോധന നടത്തി.  തുടര്ചികിത്സകൾ ഡിസ്‌കൗണ്ടോടു കൂടി നൽകുന്നതായിരിക്കും. സർജറി ആവശ്യമുള്ളവർക്ക് പാക്കേജുകളോടെ സർജറി ചെയ്തുകൊടുക്കുന്നതായിരിക്കും. ചടങ്ങിൽ നിംസ് മെഡിസിറ്റി ജനറൽ മാനേജർ ഡോ. കെ എ സജു, ഡോ.നയൻ താര, ഡോ.മായ, എസ്. എസ്. സോനു, തുടങ്ങിയവർ പ്രസംഗിച്ചു.",
      thumb: "assets/img/Pastevents/768.jpg",
    },
    {
      src: "assets/img/Pastevents/769.jpg",
      caption:
        "ലോക  വനിതാ ദിനത്തോടനുബന്ധിച്ച് വനിതകൾക്കായി  നെയ്യാറ്റിൻകര നിംസ്  മെഡിസിറ്റിയിൽ റിട്ട. ഗവണ്മെന്റ് സീനിയർ ജനറൽ സർജൻ  ഡോ. ഇന്ദിരാമ്മയുടെ  നേതൃത്വത്തിൽ   വനിതാ ഡോക്ടർമാർ  സൗജന്യ  സൂപർ സ്പെഷ്യാലിറ്റി   മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.  സംസ്ഥാനത്തെ   മികച്ച തഹസിൽദാറിനുള്ള അവാർഡ് ലഭിച്ച  നെയ്യാറ്റിൻകര  താലൂക് തഹസിൽദാർ ശ്രിമതി ശോഭ സതീഷ് ക്യാമ്പ് ഉദ്‌ഘാടനം ചെയ്തു. ക്യാംപിലെത്തിയ 421 പേർക്കും  രക്തം, കൊളസ്‌ട്രോൾ, ഷുഗർ, തൈറോയ്ഡ്,  ഇ. സി. ജി. എന്നിവ   സൗജന്യമായി  പരിശോധന നടത്തി.  തുടര്ചികിത്സകൾ ഡിസ്‌കൗണ്ടോടു കൂടി നൽകുന്നതായിരിക്കും. സർജറി ആവശ്യമുള്ളവർക്ക് പാക്കേജുകളോടെ സർജറി ചെയ്തുകൊടുക്കുന്നതായിരിക്കും. ചടങ്ങിൽ നിംസ് മെഡിസിറ്റി ജനറൽ മാനേജർ ഡോ. കെ എ സജു, ഡോ.നയൻ താര, ഡോ.മായ, എസ്. എസ്. സോനു, തുടങ്ങിയവർ പ്രസംഗിച്ചു.",
      thumb: "assets/img/Pastevents/769.jpg",
    },
    {
      src: "assets/img/Pastevents/770.jpg",
      caption:
        "ലോക  വനിതാ ദിനത്തോടനുബന്ധിച്ച് വനിതകൾക്കായി  നെയ്യാറ്റിൻകര നിംസ്  മെഡിസിറ്റിയിൽ റിട്ട. ഗവണ്മെന്റ് സീനിയർ ജനറൽ സർജൻ  ഡോ. ഇന്ദിരാമ്മയുടെ  നേതൃത്വത്തിൽ   വനിതാ ഡോക്ടർമാർ  സൗജന്യ  സൂപർ സ്പെഷ്യാലിറ്റി   മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.  സംസ്ഥാനത്തെ   മികച്ച തഹസിൽദാറിനുള്ള അവാർഡ് ലഭിച്ച  നെയ്യാറ്റിൻകര  താലൂക് തഹസിൽദാർ ശ്രിമതി ശോഭ സതീഷ് ക്യാമ്പ് ഉദ്‌ഘാടനം ചെയ്തു. ക്യാംപിലെത്തിയ 421 പേർക്കും  രക്തം, കൊളസ്‌ട്രോൾ, ഷുഗർ, തൈറോയ്ഡ്,  ഇ. സി. ജി. എന്നിവ   സൗജന്യമായി  പരിശോധന നടത്തി.  തുടര്ചികിത്സകൾ ഡിസ്‌കൗണ്ടോടു കൂടി നൽകുന്നതായിരിക്കും. സർജറി ആവശ്യമുള്ളവർക്ക് പാക്കേജുകളോടെ സർജറി ചെയ്തുകൊടുക്കുന്നതായിരിക്കും. ചടങ്ങിൽ നിംസ് മെഡിസിറ്റി ജനറൽ മാനേജർ ഡോ. കെ എ സജു, ഡോ.നയൻ താര, ഡോ.മായ, എസ്. എസ്. സോനു, തുടങ്ങിയവർ പ്രസംഗിച്ചു.",
      thumb: "assets/img/Pastevents/770.jpg",
    },
    {
      src: "assets/img/Pastevents/771.jpg",
      caption:
        "ലോക  വനിതാ ദിനത്തോടനുബന്ധിച്ച് വനിതകൾക്കായി  നെയ്യാറ്റിൻകര നിംസ്  മെഡിസിറ്റിയിൽ റിട്ട. ഗവണ്മെന്റ് സീനിയർ ജനറൽ സർജൻ  ഡോ. ഇന്ദിരാമ്മയുടെ  നേതൃത്വത്തിൽ   വനിതാ ഡോക്ടർമാർ  സൗജന്യ  സൂപർ സ്പെഷ്യാലിറ്റി   മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.  സംസ്ഥാനത്തെ   മികച്ച തഹസിൽദാറിനുള്ള അവാർഡ് ലഭിച്ച  നെയ്യാറ്റിൻകര  താലൂക് തഹസിൽദാർ ശ്രിമതി ശോഭ സതീഷ് ക്യാമ്പ് ഉദ്‌ഘാടനം ചെയ്തു. ക്യാംപിലെത്തിയ 421 പേർക്കും  രക്തം, കൊളസ്‌ട്രോൾ, ഷുഗർ, തൈറോയ്ഡ്,  ഇ. സി. ജി. എന്നിവ   സൗജന്യമായി  പരിശോധന നടത്തി.  തുടര്ചികിത്സകൾ ഡിസ്‌കൗണ്ടോടു കൂടി നൽകുന്നതായിരിക്കും. സർജറി ആവശ്യമുള്ളവർക്ക് പാക്കേജുകളോടെ സർജറി ചെയ്തുകൊടുക്കുന്നതായിരിക്കും. ചടങ്ങിൽ നിംസ് മെഡിസിറ്റി ജനറൽ മാനേജർ ഡോ. കെ എ സജു, ഡോ.നയൻ താര, ഡോ.മായ, എസ്. എസ്. സോനു, തുടങ്ങിയവർ പ്രസംഗിച്ചു.",
      thumb: "assets/img/Pastevents/771.jpg",
    },
    {
      src: "assets/img/Pastevents/772.jpg",
      caption:
        "ലോക  വനിതാ ദിനത്തോടനുബന്ധിച്ച് വനിതകൾക്കായി  നെയ്യാറ്റിൻകര നിംസ്  മെഡിസിറ്റിയിൽ റിട്ട. ഗവണ്മെന്റ് സീനിയർ ജനറൽ സർജൻ  ഡോ. ഇന്ദിരാമ്മയുടെ  നേതൃത്വത്തിൽ   വനിതാ ഡോക്ടർമാർ  സൗജന്യ  സൂപർ സ്പെഷ്യാലിറ്റി   മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.  സംസ്ഥാനത്തെ   മികച്ച തഹസിൽദാറിനുള്ള അവാർഡ് ലഭിച്ച  നെയ്യാറ്റിൻകര  താലൂക് തഹസിൽദാർ ശ്രിമതി ശോഭ സതീഷ് ക്യാമ്പ് ഉദ്‌ഘാടനം ചെയ്തു. ക്യാംപിലെത്തിയ 421 പേർക്കും  രക്തം, കൊളസ്‌ട്രോൾ, ഷുഗർ, തൈറോയ്ഡ്,  ഇ. സി. ജി. എന്നിവ   സൗജന്യമായി  പരിശോധന നടത്തി.  തുടര്ചികിത്സകൾ ഡിസ്‌കൗണ്ടോടു കൂടി നൽകുന്നതായിരിക്കും. സർജറി ആവശ്യമുള്ളവർക്ക് പാക്കേജുകളോടെ സർജറി ചെയ്തുകൊടുക്കുന്നതായിരിക്കും. ചടങ്ങിൽ നിംസ് മെഡിസിറ്റി ജനറൽ മാനേജർ ഡോ. കെ എ സജു, ഡോ.നയൻ താര, ഡോ.മായ, എസ്. എസ്. സോനു, തുടങ്ങിയവർ പ്രസംഗിച്ചു.",
      thumb: "assets/img/Pastevents/772.jpg",
    },
    {
      src: "assets/img/Pastevents/754.jpeg",
      caption:
        "ശ്രീ യക്ഷിയമ്മൻ ക്ഷേത്ര ട്രസ്റ്റും തത്തീയൂരും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ ഫൈസൽ ഖാൻ (എംഡി നിംസ് മെഡിസിറ്റി)",
      thumb: "assets/img/Pastevents/754.jpeg",
    },
    {
      src: "assets/img/Pastevents/755.jpeg",
      caption:
        "ശ്രീ യക്ഷിയമ്മൻ ക്ഷേത്ര ട്രസ്റ്റും തത്തീയൂരും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ ഫൈസൽ ഖാൻ (എംഡി നിംസ് മെഡിസിറ്റി)",
      thumb: "assets/img/Pastevents/755.jpeg",
    },
    {
      src: "assets/img/Pastevents/756.jpeg",
      caption:
        "ശ്രീ യക്ഷിയമ്മൻ ക്ഷേത്ര ട്രസ്റ്റും തത്തീയൂരും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ ഫൈസൽ ഖാൻ (എംഡി നിംസ് മെഡിസിറ്റി)",
      thumb: "assets/img/Pastevents/756.jpeg",
    },
    {
      src: "assets/img/Pastevents/757.jpeg",
      caption:
        "ശ്രീ യക്ഷിയമ്മൻ ക്ഷേത്ര ട്രസ്റ്റും തത്തീയൂരും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ ഫൈസൽ ഖാൻ (എംഡി നിംസ് മെഡിസിറ്റി)",
      thumb: "assets/img/Pastevents/757.jpeg",
    },
    {
      src: "assets/img/Pastevents/758.jpeg",
      caption:
        "ശ്രീ യക്ഷിയമ്മൻ ക്ഷേത്ര ട്രസ്റ്റും തത്തീയൂരും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ ഫൈസൽ ഖാൻ (എംഡി നിംസ് മെഡിസിറ്റി)",
      thumb: "assets/img/Pastevents/758.jpeg",
    },
    {
      src: "assets/img/Pastevents/759.jpeg",
      caption:
        "ശ്രീ യക്ഷിയമ്മൻ ക്ഷേത്ര ട്രസ്റ്റും തത്തീയൂരും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ ഫൈസൽ ഖാൻ (എംഡി നിംസ് മെഡിസിറ്റി)",
      thumb: "assets/img/Pastevents/759.jpeg",
    },
    {
      src: "assets/img/Pastevents/760.jpeg",
      caption:
        "ശ്രീ യക്ഷിയമ്മൻ ക്ഷേത്ര ട്രസ്റ്റും തത്തീയൂരും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ ഫൈസൽ ഖാൻ (എംഡി നിംസ് മെഡിസിറ്റി)",
      thumb: "assets/img/Pastevents/760.jpeg",
    },
    {
      src: "assets/img/Pastevents/749.jpeg",
      caption:
        "ശ്രീ ഭദ്രകാളി ക്ഷേത്ര ട്രസ്റ്റ് കുളത്തൂർ നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/749.jpeg",
    },

    {
      src: "assets/img/Pastevents/750.jpeg",
      caption:
        "ശ്രീ ഭദ്രകാളി ക്ഷേത്ര ട്രസ്റ്റ് കുളത്തൂർ നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/750.jpeg",
    },
    {
      src: "assets/img/Pastevents/751.jpeg",
      caption:
        "ശ്രീ ഭദ്രകാളി ക്ഷേത്ര ട്രസ്റ്റ് കുളത്തൂർ നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/751.jpeg",
    },
    {
      src: "assets/img/Pastevents/752.jpeg",
      caption:
        " ശ്രീ ഭദ്രകാളി ക്ഷേത്ര ട്രസ്റ്റ് കുളത്തൂർ നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/752.jpeg",
    },
    {
      src: "assets/img/Pastevents/753.jpeg",
      caption:
        " ശ്രീ ഭദ്രകാളി ക്ഷേത്ര ട്രസ്റ്റ് കുളത്തൂർ നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/753.jpeg",
    },
    {
      src: "assets/img/Pastevents/743.jpeg",
      caption:
        "കാവിയാട് ദിവാകര പണിക്കർ സാംസ്കാരിക കേന്ദ്രവും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ",
      thumb: "assets/img/Pastevents/743.jpeg",
    },
    {
      src: "assets/img/Pastevents/744.jpeg",
      caption:
        "കാവിയാട് ദിവാകര പണിക്കർ സാംസ്കാരിക കേന്ദ്രവും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ",
      thumb: "assets/img/Pastevents/744.jpeg",
    },
    {
      src: "assets/img/Pastevents/745.jpeg",
      caption:
        "കാവിയാട് ദിവാകര പണിക്കർ സാംസ്കാരിക കേന്ദ്രവും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ",
      thumb: "assets/img/Pastevents/745.jpeg",
    },
    {
      src: "assets/img/Pastevents/746.jpeg",
      caption:
        "കാവിയാട് ദിവാകര പണിക്കർ സാംസ്കാരിക കേന്ദ്രവും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ",
      thumb: "assets/img/Pastevents/746.jpeg",
    },
    {
      src: "assets/img/Pastevents/747.jpeg",
      caption:
        "കാവിയാട് ദിവാകര പണിക്കർ സാംസ്കാരിക കേന്ദ്രവും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ",
      thumb: "assets/img/Pastevents/747.jpeg",
    },
    {
      src: "assets/img/Pastevents/748.jpeg",
      caption:
        "കാവിയാട് ദിവാകര പണിക്കർ സാംസ്കാരിക കേന്ദ്രവും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ",
      thumb: "assets/img/Pastevents/748.jpeg",
    },
    {
      src: "assets/img/Pastevents/736.jpeg",
      caption:
        "നിംസ് സ്പെക്ട്രം ശിശു വികസന ഗവേഷണ കേന്ദ്രത്തിലെ ഗുണഭോക്താക്കൾക്ക് സൗജന്യ മെഡിക്കൽ ചെക്കപ്പും ഫലവൃക്ഷത്തൈ വിതരണവും ",
      thumb: "assets/img/Pastevents/736.jpeg",
    },
    {
      src: "assets/img/Pastevents/737.jpeg",
      caption:
        "കോവിഡ് 19 ൻ്റെ സാഹചര്യത്തിൽ പതിനെട്ട് വയസ്സിന് താഴെ പ്രായമുള്ള ഭിന്നശേഷിക്കാരായ കുട്ടികൾക്ക്‌    വേണ്ടി നിംസ് മെഡിസിറ്റി തുടങ്ങിയ പെൻഷൻ പ്ലാനിൻ്റെ ഗുണഭോക്താക്കക്ക് വേണ്ടിയുളള സൗജന്യ വൈദ്യപരിശോധനയും തുടർ ചികിൽസയും നിംസ് മെഡിസിറ്റിയിൽ നടന്ന് കൊണ്ടിരിക്കുന്നു. ",
      thumb: "assets/img/Pastevents/737.jpeg",
    },
    {
      src: "assets/img/Pastevents/738.jpeg",
      caption:
        "നെയ്യാറ്റിൻകര മുനിസിപ്പാലിറ്റി, അതിയന്നൂർ  പഞ്ചായത്ത്, ബാലരാമപുരം, കോട്ടുകാൽ, പെരുങ്കടവിള, കൊല്ലയിൽ എന്നീ പഞ്ചായത്ത് പരിധിയിലുള്ളവരാണ്  ഗുണഭോക്താക്കൾ.",
      thumb: "assets/img/Pastevents/738.jpeg",
    },
    {
      src: "assets/img/Pastevents/739.jpeg",
      caption:
        "പെരുങ്കടവിള പഞ്ചായത്തിലെ ഗുണഭോക്താക്കൾക്ക് നടത്തിയ ക്യാമ്പ് ഇന്ന് സമാപിച്ചു. മറ്റ് പഞ്ചായത്തിലേ ഗുണഭോക്താക്കൾക്ക് വേണ്ടിയുള്ള മെഡിക്കൽ ക്യാമ്പിന്റെ തിയതി അറിയിക്കും. ",
      thumb: "assets/img/Pastevents/739.jpeg",
    },
    {
      src: "assets/img/Pastevents/740.jpeg",
      caption:
        "നിംസ് സ്പെക്ട്രം ഡയറക്ടറും   മുൻ ആരോഗ്യ സർവ്വകലാശാല വൈസ് ചാൻസലറുമായ പ്രൊഫ.ഡോ: എം കെ സി നായർ  ക്യാമ്പിന്റെ മാർഗ്ഗ നിർദേശങ്ങൾ നൽകി.",
      thumb: "assets/img/Pastevents/740.jpeg",
    },
    {
      src: "assets/img/Pastevents/741.jpeg",
      caption:
        "ക്യാമ്പിന്റെ പരിസമാപ്തിയിൽ നിംസ്  ഹരിതകം പദ്ധതിയുടെ ഭാഗമായുള്ള  ഫലവൃക്ഷത്തൈ  വിതരണം നടന്നു. ",
      thumb: "assets/img/Pastevents/741.jpeg",
    },
    {
      src: "assets/img/Pastevents/742.jpeg",
      caption:
        "നിംസ് ക്ലിനിക്കൽ സൈക്കോളജിസ്റ്റ് ഡോ.വിമൽ കുമാർ,  ഡോ.ദീപ ബിനോദ് ഡോ.ശൈലജ,  രേണു കെ.ആർ, ഡവലപ്മെൻറ്റ് തെറാപിസ്റ്റുകളായ ശ്രീ  സ്വപ്‍ന, അശ്വതി,  എന്നിവർ മെഡിക്കൽ ക്യാമ്പിന് നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/742.jpeg",
    },
    {
      src: "assets/img/Pastevents/729.jpeg",
      caption:
        "KSRTEA (CITU) യൂണിറ്റ് വെള്ളനാട്, ലയൺസ് ക്ലബ് ഇന്റർനാഷണലിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ സി കെ ഹരികൃഷ്ണൻ (സംസ്ഥാന ജനറസെക്രട്ടറി KSRTEA).",
      thumb: "assets/img/Pastevents/729.jpeg",
    },
    {
      src: "assets/img/Pastevents/730.jpeg",
      caption:
        "KSRTEA (CITU) യൂണിറ്റ് വെള്ളനാട്, ലയൺസ് ക്ലബ് ഇന്റർനാഷണലിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ സി കെ ഹരികൃഷ്ണൻ (സംസ്ഥാന ജനറസെക്രട്ടറി KSRTEA).",
      thumb: "assets/img/Pastevents/730.jpeg",
    },
    {
      src: "assets/img/Pastevents/731.jpeg",
      caption:
        "KSRTEA (CITU) യൂണിറ്റ് വെള്ളനാട്, ലയൺസ് ക്ലബ് ഇന്റർനാഷണലിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ സി കെ ഹരികൃഷ്ണൻ (സംസ്ഥാന ജനറസെക്രട്ടറി KSRTEA).",
      thumb: "assets/img/Pastevents/731.jpeg",
    },
    {
      src: "assets/img/Pastevents/732.jpeg",
      caption:
        "KSRTEA (CITU) യൂണിറ്റ് വെള്ളനാട്, ലയൺസ് ക്ലബ് ഇന്റർനാഷണലിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ സി കെ ഹരികൃഷ്ണൻ (സംസ്ഥാന ജനറസെക്രട്ടറി KSRTEA).",
      thumb: "assets/img/Pastevents/732.jpeg",
    },
    {
      src: "assets/img/Pastevents/733.jpeg",
      caption:
        "KSRTEA (CITU) യൂണിറ്റ് വെള്ളനാട്, ലയൺസ് ക്ലബ് ഇന്റർനാഷണലിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ സി കെ ഹരികൃഷ്ണൻ (സംസ്ഥാന ജനറസെക്രട്ടറി KSRTEA).",
      thumb: "assets/img/Pastevents/733.jpeg",
    },
    {
      src: "assets/img/Pastevents/734.jpeg",
      caption:
        "KSRTEA (CITU) യൂണിറ്റ് വെള്ളനാട്, ലയൺസ് ക്ലബ് ഇന്റർനാഷണലിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ സി കെ ഹരികൃഷ്ണൻ (സംസ്ഥാന ജനറസെക്രട്ടറി KSRTEA).",
      thumb: "assets/img/Pastevents/734.jpeg",
    },
    {
      src: "assets/img/Pastevents/735.jpeg",
      caption:
        "KSRTEA (CITU) യൂണിറ്റ് വെള്ളനാട്, ലയൺസ് ക്ലബ് ഇന്റർനാഷണലിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ സി കെ ഹരികൃഷ്ണൻ (സംസ്ഥാന ജനറസെക്രട്ടറി KSRTEA).",
      thumb: "assets/img/Pastevents/735.jpeg",
    },
    {
      src: "assets/img/Pastevents/722.jpeg",
      caption:
        "എൻ എസ് എസ് വനിത കോളേജ്, നാഷണൽ സർവീസ് സ്കീം ഫിസിക്കൽ എഡ്യൂക്കേഷൻ ഡിപ്പാർട്ട്മെൻ്റ്, ട്രിവാൻഡ്രം റെയിൻബോ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/722.jpeg",
    },
    {
      src: "assets/img/Pastevents/723.jpeg",
      caption:
        "എൻ എസ് എസ് വനിത കോളേജ്, നാഷണൽ സർവീസ് സ്കീം ഫിസിക്കൽ എഡ്യൂക്കേഷൻ ഡിപ്പാർട്ട്മെൻ്റ്, ട്രിവാൻഡ്രം റെയിൻബോ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/723.jpeg",
    },
    {
      src: "assets/img/Pastevents/724.jpeg",
      caption:
        "എൻ എസ് എസ് വനിത കോളേജ്, നാഷണൽ സർവീസ് സ്കീം ഫിസിക്കൽ എഡ്യൂക്കേഷൻ ഡിപ്പാർട്ട്മെൻ്റ്, ട്രിവാൻഡ്രം റെയിൻബോ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/724.jpeg",
    },
    {
      src: "assets/img/Pastevents/725.jpeg",
      caption:
        "എൻ എസ് എസ് വനിത കോളേജ്, നാഷണൽ സർവീസ് സ്കീം ഫിസിക്കൽ എഡ്യൂക്കേഷൻ ഡിപ്പാർട്ട്മെൻ്റ്, ട്രിവാൻഡ്രം റെയിൻബോ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/725.jpeg",
    },
    {
      src: "assets/img/Pastevents/726.jpeg",
      caption:
        "എൻ എസ് എസ് വനിത കോളേജ്, നാഷണൽ സർവീസ് സ്കീം ഫിസിക്കൽ എഡ്യൂക്കേഷൻ ഡിപ്പാർട്ട്മെൻ്റ്, ട്രിവാൻഡ്രം റെയിൻബോ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/726.jpeg",
    },
    {
      src: "assets/img/Pastevents/727.jpeg",
      caption:
        "എൻ എസ് എസ് വനിത കോളേജ്, നാഷണൽ സർവീസ് സ്കീം ഫിസിക്കൽ എഡ്യൂക്കേഷൻ ഡിപ്പാർട്ട്മെൻ്റ്, ട്രിവാൻഡ്രം റെയിൻബോ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/727.jpeg",
    },
    {
      src: "assets/img/Pastevents/728.jpeg",
      caption:
        "എൻ എസ് എസ് വനിത കോളേജ്, നാഷണൽ സർവീസ് സ്കീം ഫിസിക്കൽ എഡ്യൂക്കേഷൻ ഡിപ്പാർട്ട്മെൻ്റ്, ട്രിവാൻഡ്രം റെയിൻബോ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/728.jpeg",
    },
    {
      src: "assets/img/Pastevents/715.jpeg",
      caption:
        "എൻ എസ് എസ് വനിത കോളേജ്, നാഷണൽ സർവീസ് സ്കീം ഫിസിക്കൽ എഡ്യൂക്കേഷൻ ഡിപ്പാർട്ട്മെൻ്റ്, ട്രിവാൻഡ്രം റെയിൻബോ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/715.jpeg",
    },
    {
      src: "assets/img/Pastevents/716.jpeg",
      caption:
        "എൻ എസ് എസ് വനിത കോളേജ്, നാഷണൽ സർവീസ് സ്കീം ഫിസിക്കൽ എഡ്യൂക്കേഷൻ ഡിപ്പാർട്ട്മെൻ്റ്, ട്രിവാൻഡ്രം റെയിൻബോ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/716.jpeg",
    },
    {
      src: "assets/img/Pastevents/717.jpeg",
      caption:
        "എൻ എസ് എസ് വനിത കോളേജ്, നാഷണൽ സർവീസ് സ്കീം ഫിസിക്കൽ എഡ്യൂക്കേഷൻ ഡിപ്പാർട്ട്മെൻ്റ്, ട്രിവാൻഡ്രം റെയിൻബോ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/717.jpeg",
    },
    {
      src: "assets/img/Pastevents/718.jpeg",
      caption:
        "എൻ എസ് എസ് വനിത കോളേജ്, നാഷണൽ സർവീസ് സ്കീം ഫിസിക്കൽ എഡ്യൂക്കേഷൻ ഡിപ്പാർട്ട്മെൻ്റ്, ട്രിവാൻഡ്രം റെയിൻബോ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/718.jpeg",
    },
    {
      src: "assets/img/Pastevents/719.jpeg",
      caption:
        "എൻ എസ് എസ് വനിത കോളേജ്, നാഷണൽ സർവീസ് സ്കീം ഫിസിക്കൽ എഡ്യൂക്കേഷൻ ഡിപ്പാർട്ട്മെൻ്റ്, ട്രിവാൻഡ്രം റെയിൻബോ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/719.jpeg",
    },
    {
      src: "assets/img/Pastevents/720.jpeg",
      caption:
        "എൻ എസ് എസ് വനിത കോളേജ്, നാഷണൽ സർവീസ് സ്കീം ഫിസിക്കൽ എഡ്യൂക്കേഷൻ ഡിപ്പാർട്ട്മെൻ്റ്, ട്രിവാൻഡ്രം റെയിൻബോ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/720.jpeg",
    },
    {
      src: "assets/img/Pastevents/721.jpeg",
      caption:
        "എൻ എസ് എസ് വനിത കോളേജ്, നാഷണൽ സർവീസ് സ്കീം ഫിസിക്കൽ എഡ്യൂക്കേഷൻ ഡിപ്പാർട്ട്മെൻ്റ്, ട്രിവാൻഡ്രം റെയിൻബോ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/721.jpeg",
    },
    {
      src: "assets/img/Pastevents/708.jpeg",
      caption:
        "കേരള ടെക്സൈറ്റൽസ് & ഗാർമെൻ്റ്സ് ഡീലേഴ്സ് വെൽഫെയർ അസോസിയേഷൻ നെയ്യാറ്റിൻകര ബ്രാഞ്ച്, വിഴിഞ്ഞം ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/708.jpeg",
    },
    {
      src: "assets/img/Pastevents/709.jpeg",
      caption:
        "കേരള ടെക്സൈറ്റൽസ് & ഗാർമെൻ്റ്സ് ഡീലേഴ്സ് വെൽഫെയർ അസോസിയേഷൻ നെയ്യാറ്റിൻകര ബ്രാഞ്ച്, വിഴിഞ്ഞം ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/709.jpeg",
    },
    {
      src: "assets/img/Pastevents/710.jpeg",
      caption:
        "കേരള ടെക്സൈറ്റൽസ് & ഗാർമെൻ്റ്സ് ഡീലേഴ്സ് വെൽഫെയർ അസോസിയേഷൻ നെയ്യാറ്റിൻകര ബ്രാഞ്ച്, വിഴിഞ്ഞം ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/710.jpeg",
    },
    {
      src: "assets/img/Pastevents/711.jpeg",
      caption:
        "കേരള ടെക്സൈറ്റൽസ് & ഗാർമെൻ്റ്സ് ഡീലേഴ്സ് വെൽഫെയർ അസോസിയേഷൻ നെയ്യാറ്റിൻകര ബ്രാഞ്ച്, വിഴിഞ്ഞം ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/711.jpeg",
    },
    {
      src: "assets/img/Pastevents/712.jpeg",
      caption:
        "കേരള ടെക്സൈറ്റൽസ് & ഗാർമെൻ്റ്സ് ഡീലേഴ്സ് വെൽഫെയർ അസോസിയേഷൻ നെയ്യാറ്റിൻകര ബ്രാഞ്ച്, വിഴിഞ്ഞം ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/712.jpeg",
    },
    {
      src: "assets/img/Pastevents/713.jpeg",
      caption:
        "കേരള ടെക്സൈറ്റൽസ് & ഗാർമെൻ്റ്സ് ഡീലേഴ്സ് വെൽഫെയർ അസോസിയേഷൻ നെയ്യാറ്റിൻകര ബ്രാഞ്ച്, വിഴിഞ്ഞം ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/713.jpeg",
    },
    {
      src: "assets/img/Pastevents/714.jpeg",
      caption:
        "കേരള ടെക്സൈറ്റൽസ് & ഗാർമെൻ്റ്സ് ഡീലേഴ്സ് വെൽഫെയർ അസോസിയേഷൻ നെയ്യാറ്റിൻകര ബ്രാഞ്ച്, വിഴിഞ്ഞം ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/714.jpeg",
    },
    {
      src: "assets/img/Pastevents/694.jpeg",
      caption:
        "ഊട്ടുപർണി റെസിഡൻഷ്യൽ അസോസിയേഷൻ, ട്രിവാൻഡ്രം റീജൻസി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/694.jpeg",
    },
    {
      src: "assets/img/Pastevents/695.jpeg",
      caption:
        "ഊട്ടുപർണി റെസിഡൻഷ്യൽ അസോസിയേഷൻ, ട്രിവാൻഡ്രം റീജൻസി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/695.jpeg",
    },
    {
      src: "assets/img/Pastevents/696.jpeg",
      caption:
        "ഊട്ടുപർണി റെസിഡൻഷ്യൽ അസോസിയേഷൻ, ട്രിവാൻഡ്രം റീജൻസി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/696.jpeg",
    },
    {
      src: "assets/img/Pastevents/697.jpeg",
      caption:
        "ഊട്ടുപർണി റെസിഡൻഷ്യൽ അസോസിയേഷൻ, ട്രിവാൻഡ്രം റീജൻസി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/697.jpeg",
    },
    {
      src: "assets/img/Pastevents/698.jpeg",
      caption:
        "ഊട്ടുപർണി റെസിഡൻഷ്യൽ അസോസിയേഷൻ, ട്രിവാൻഡ്രം റീജൻസി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/698.jpeg",
    },
    {
      src: "assets/img/Pastevents/699.jpeg",
      caption:
        "നിംസ് സ്പെക്ട്രം ശിശു വികസന ഗവേഷണ കേന്ദ്രത്തിലെ ഗുണഭോക്താക്കൾക്ക് സൗജന്യ മെഡിക്കൽ ചെക്കപ്പ് . ",
      thumb: "assets/img/Pastevents/699.jpeg",
    },
    {
      src: "assets/img/Pastevents/700.jpeg",
      caption:
        "നിംസ് സ്പെക്ട്രം ശിശു വികസന ഗവേഷണ കേന്ദ്രത്തിലെ ഗുണഭോക്താക്കൾക്ക് സൗജന്യ മെഡിക്കൽ ചെക്കപ്പ് .",
      thumb: "assets/img/Pastevents/700.jpeg",
    },
    {
      src: "assets/img/Pastevents/700.jpeg",
      caption:
        "നിംസ് സ്പെക്ട്രം ശിശു വികസന ഗവേഷണ കേന്ദ്രത്തിലെ ഗുണഭോക്താക്കൾക്ക് സൗജന്യ മെഡിക്കൽ ചെക്കപ്പ് .",
      thumb: "assets/img/Pastevents/700.jpeg",
    },
    {
      src: "assets/img/Pastevents/701.jpeg",
      caption:
        "നിംസ്  സ്പെക്ട്രം ശിശു വികസന കേന്ദ്രത്തിലെ ഗുണഭോക്താക്കൾക്ക്  സൗജന്യ മെഡിക്കൽ ചെക്കപ്പ് നടത്തി. നിംസ്  സ്പെക്ട്രം ഡയറക്ടറും മുൻ ആരോഗ്യ സർവ്വകലാശാല വൈസ് ചാൻസലറുമായ പ്രൊഫ:ഡോ.എം കെ സി നായർ ക്യാമ്പിന് മാർഗ്ഗ നിർദ്ദേശങ്ങൾ നൽകി.",
      thumb: "assets/img/Pastevents/701.jpeg",
    },
    {
      src: "assets/img/Pastevents/702.jpeg",
      caption:
        "18  വയസ്സിനു താഴെയുള്ള  കുട്ടികൾക്ക് വേണ്ടിയാണു സൗജന്യ മെഡിക്കൽ ചെക്കപ്പ് നടത്തിയത്. ശാരീരികവും മാനസികവുമായി വിവിധ വെല്ലുവിളികൾ നേരിടുന്ന സ്‌പെഷ്യലി എബിൽഡ് കുട്ടികൾക്കായ് മാസംതോറും നിംസ് മെഡിസിറ്റിയുടെ പേരിൽ  പെൻഷൻ നൽകിവരുന്നു. നെയ്യാറ്റിൻകര മുനിസിപ്പാലിറ്റി, അതിയന്നൂർ  പഞ്ചായത്ത്, ബാലരാമപുരം, കോട്ടുകാൽ, പെരുങ്കടവിള, കൊല്ലയിൽ എന്നീ പഞ്ചായത്ത് പരിധിയിലുള്ളവരാണ്  ഗുണഭോക്താക്കൾ.",
      thumb: "assets/img/Pastevents/702.jpeg",
    },
    {
      src: "assets/img/Pastevents/703.jpeg",
      caption:
        "കോവിഡ്  രോഗ ഭീതിയുള്ള പശ്ചാത്തലത്തിൽ ക്യാമ്പ് നടത്താനാവാത്തതിനാൽ എല്ലാ ശനിയാഴ്ചയും ഭിന്നശേഷിക്കാർക്കു വേണ്ടി സ്പെഷ്യൽ ക്ലിനിക്കായി നടത്തി വരികയാണ്. ഇത്തവണ പെരുങ്കടവിള പഞ്ചായത്തിലെ ഗുണഭോക്താക്കൾക്കു വേണ്ടിയായിരുന്നു ക്യാമ്പ്. ",
      thumb: "assets/img/Pastevents/703.jpeg",
    },
    {
      src: "assets/img/Pastevents/704.jpeg",
      caption:
        "നിംസ് സ്പെക്ട്രം ശിശു വികസന ഗവേഷണ കേന്ദ്രത്തിലെ ഗുണഭോക്താക്കൾക്ക് സൗജന്യ മെഡിക്കൽ ചെക്കപ്പ് .",
      thumb: "assets/img/Pastevents/704.jpeg",
    },
    {
      src: "assets/img/Pastevents/705.jpeg",
      caption:
        "നിംസ് സ്പെക്ട്രം ശിശു വികസന ഗവേഷണ കേന്ദ്രത്തിലെ ഗുണഭോക്താക്കൾക്ക് സൗജന്യ മെഡിക്കൽ ചെക്കപ്പ് .",
      thumb: "assets/img/Pastevents/705.jpeg",
    },
    {
      src: "assets/img/Pastevents/706.jpeg",
      caption:
        "നിംസ് സ്പെക്ട്രം ശിശു വികസന ഗവേഷണ കേന്ദ്രത്തിലെ ഗുണഭോക്താക്കൾക്ക് സൗജന്യ മെഡിക്കൽ ചെക്കപ്പ് .",
      thumb: "assets/img/Pastevents/706.jpeg",
    },
    {
      src: "assets/img/Pastevents/707.jpeg",
      caption:
        "നിംസ് സ്പെക്ട്രം ഡയറക്ടർ പ്രൊഫ: ഡോ. എം കെ സി നായർ നേതൃത്വം നൽകിയ ക്യാമ്പിൽ ഡോ.ദീപ ബിനോദ്, ഡോ.ശൈലജ, ഡോ.വിമൽ കുമാർ,  തെറാപിസ്റ്റുകളായ ശ്രീമതി രേണുക,  സ്വപ്‍ന, അശ്വതി  തുടങ്ങിയവർ  പരിശോധനകൾക്ക്  നേതൃത്വം നൽകി.",
      thumb: "assets/img/Pastevents/707.jpeg",
    },
    {
      src: "assets/img/Pastevents/688.jpeg",
      caption:
        "ശ്രീ ചാമുണ്ഡേശ്വരി ദേവി ക്ഷേത്രം, ഇടത്തെയ്ക്കോണം ജനത ക്ലബ് പയറ്റുവിളയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/688.jpeg",
    },
    {
      src: "assets/img/Pastevents/689.jpeg",
      caption:
        "ശ്രീ ചാമുണ്ഡേശ്വരി ദേവി ക്ഷേത്രം, ഇടത്തെയ്ക്കോണം ജനത ക്ലബ് പയറ്റുവിളയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/689.jpeg",
    },
    {
      src: "assets/img/Pastevents/690.jpeg",
      caption:
        "ശ്രീ ചാമുണ്ഡേശ്വരി ദേവി ക്ഷേത്രം, ഇടത്തെയ്ക്കോണം ജനത ക്ലബ് പയറ്റുവിളയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/690.jpeg",
    },
    {
      src: "assets/img/Pastevents/691.jpeg",
      caption:
        "ശ്രീ ചാമുണ്ഡേശ്വരി ദേവി ക്ഷേത്രം, ഇടത്തെയ്ക്കോണം ജനത ക്ലബ് പയറ്റുവിളയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/691.jpeg",
    },
    {
      src: "assets/img/Pastevents/692.jpeg",
      caption:
        "ശ്രീ ചാമുണ്ഡേശ്വരി ദേവി ക്ഷേത്രം, ഇടത്തെയ്ക്കോണം ജനത ക്ലബ് പയറ്റുവിളയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/692.jpeg",
    },
    {
      src: "assets/img/Pastevents/693.jpeg",
      caption:
        "ശ്രീ ചാമുണ്ഡേശ്വരി ദേവി ക്ഷേത്രം, ഇടത്തെയ്ക്കോണം ജനത ക്ലബ് പയറ്റുവിളയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/693.jpeg",
    },
    {
      src: "assets/img/Pastevents/681.jpeg",
      caption:
        "എസ് ബി മാർജിൻഫ്രീ ഷോപ്പും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/681.jpeg",
    },
    {
      src: "assets/img/Pastevents/682.jpeg",
      caption:
        "എസ് ബി മാർജിൻഫ്രീ ഷോപ്പും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/682.jpeg",
    },
    {
      src: "assets/img/Pastevents/683.jpeg",
      caption:
        "എസ് ബി മാർജിൻഫ്രീ ഷോപ്പും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/683.jpeg",
    },
    {
      src: "assets/img/Pastevents/684.jpeg",
      caption:
        "എസ് ബി മാർജിൻഫ്രീ ഷോപ്പും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/684.jpeg",
    },
    {
      src: "assets/img/Pastevents/685.jpeg",
      caption:
        "എസ് ബി മാർജിൻഫ്രീ ഷോപ്പും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/685.jpeg",
    },
    {
      src: "assets/img/Pastevents/686.jpeg",
      caption:
        "എസ് ബി മാർജിൻഫ്രീ ഷോപ്പും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/686.jpeg",
    },
    {
      src: "assets/img/Pastevents/687.jpeg",
      caption:
        "എസ് ബി മാർജിൻഫ്രീ ഷോപ്പും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/687.jpeg",
    },
    {
      src: "assets/img/Pastevents/672.jpeg",
      caption:
        "ചിതറ ഗ്രാമപഞ്ചായത്തും ലയൺസ് റീജണൽ സോൺ നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ എം എസ് മുരളി (ബഹു. പഞ്ചായത്ത് പ്രസിഡൻ്റ് ചിതറ)",
      thumb: "assets/img/Pastevents/672.jpeg",
    },
    {
      src: "assets/img/Pastevents/673.jpeg",
      caption:
        "ചിതറ ഗ്രാമപഞ്ചായത്തും ലയൺസ് റീജണൽ സോൺ നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ എം എസ് മുരളി (ബഹു. പഞ്ചായത്ത് പ്രസിഡൻ്റ് ചിതറ)",
      thumb: "assets/img/Pastevents/673.jpeg",
    },
    {
      src: "assets/img/Pastevents/674.jpeg",
      caption:
        "ചിതറ ഗ്രാമപഞ്ചായത്തും ലയൺസ് റീജണൽ സോൺ നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ എം എസ് മുരളി (ബഹു. പഞ്ചായത്ത് പ്രസിഡൻ്റ് ചിതറ)",
      thumb: "assets/img/Pastevents/674.jpeg",
    },
    {
      src: "assets/img/Pastevents/675.jpeg",
      caption:
        "ചിതറ ഗ്രാമപഞ്ചായത്തും ലയൺസ് റീജണൽ സോൺ നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ എം എസ് മുരളി (ബഹു. പഞ്ചായത്ത് പ്രസിഡൻ്റ് ചിതറ)",
      thumb: "assets/img/Pastevents/675.jpeg",
    },
    {
      src: "assets/img/Pastevents/676.jpeg",
      caption:
        "ചിതറ ഗ്രാമപഞ്ചായത്തും ലയൺസ് റീജണൽ സോൺ നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ എം എസ് മുരളി (ബഹു. പഞ്ചായത്ത് പ്രസിഡൻ്റ് ചിതറ)",
      thumb: "assets/img/Pastevents/676.jpeg",
    },
    {
      src: "assets/img/Pastevents/677.jpeg",
      caption:
        "ചിതറ ഗ്രാമപഞ്ചായത്തും ലയൺസ് റീജണൽ സോൺ നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ എം എസ് മുരളി (ബഹു. പഞ്ചായത്ത് പ്രസിഡൻ്റ് ചിതറ)",
      thumb: "assets/img/Pastevents/677.jpeg",
    },
    {
      src: "assets/img/Pastevents/678.jpeg",
      caption:
        "ചിതറ ഗ്രാമപഞ്ചായത്തും ലയൺസ് റീജണൽ സോൺ നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ എം എസ് മുരളി (ബഹു. പഞ്ചായത്ത് പ്രസിഡൻ്റ് ചിതറ)",
      thumb: "assets/img/Pastevents/678.jpeg",
    },
    {
      src: "assets/img/Pastevents/679.jpeg",
      caption:
        "ചിതറ ഗ്രാമപഞ്ചായത്തും ലയൺസ് റീജണൽ സോൺ നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ എം എസ് മുരളി (ബഹു. പഞ്ചായത്ത് പ്രസിഡൻ്റ് ചിതറ)",
      thumb: "assets/img/Pastevents/679.jpeg",
    },
    {
      src: "assets/img/Pastevents/680.jpeg",
      caption:
        "ചിതറ ഗ്രാമപഞ്ചായത്തും ലയൺസ് റീജണൽ സോൺ നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ എം എസ് മുരളി (ബഹു. പഞ്ചായത്ത് പ്രസിഡൻ്റ് ചിതറ)",
      thumb: "assets/img/Pastevents/680.jpeg",
    },
    {
      src: "assets/img/Pastevents/665.jpeg",
      caption:
        "ട്രിവാൻഡ്രം റീഗൻസി ലയൺസ് ക്ലബ്, കൊഞ്ചിറവിള ഭഗവതി വിലാസം എൻഎസ്എസ് കരയോഗത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/665.jpeg",
    },
    {
      src: "assets/img/Pastevents/666.jpeg",
      caption:
        "ട്രിവാൻഡ്രം റീഗൻസി ലയൺസ് ക്ലബ്, കൊഞ്ചിറവിള ഭഗവതി വിലാസം എൻഎസ്എസ് കരയോഗത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/666.jpeg",
    },
    {
      src: "assets/img/Pastevents/667.jpeg",
      caption:
        "ട്രിവാൻഡ്രം റീഗൻസി ലയൺസ് ക്ലബ്, കൊഞ്ചിറവിള ഭഗവതി വിലാസം എൻഎസ്എസ് കരയോഗത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/667.jpeg",
    },
    {
      src: "assets/img/Pastevents/668.jpeg",
      caption:
        "ട്രിവാൻഡ്രം റീഗൻസി ലയൺസ് ക്ലബ്, കൊഞ്ചിറവിള ഭഗവതി വിലാസം എൻഎസ്എസ് കരയോഗത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/668.jpeg",
    },
    {
      src: "assets/img/Pastevents/669.jpeg",
      caption:
        "ട്രിവാൻഡ്രം റീഗൻസി ലയൺസ് ക്ലബ്, കൊഞ്ചിറവിള ഭഗവതി വിലാസം എൻഎസ്എസ് കരയോഗത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/669.jpeg",
    },
    {
      src: "assets/img/Pastevents/670.jpeg",
      caption:
        "ട്രിവാൻഡ്രം റീഗൻസി ലയൺസ് ക്ലബ്, കൊഞ്ചിറവിള ഭഗവതി വിലാസം എൻഎസ്എസ് കരയോഗത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/670.jpeg",
    },
    {
      src: "assets/img/Pastevents/671.jpeg",
      caption:
        "ട്രിവാൻഡ്രം റീഗൻസി ലയൺസ് ക്ലബ്, കൊഞ്ചിറവിള ഭഗവതി വിലാസം എൻഎസ്എസ് കരയോഗത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/671.jpeg",
    },
    {
      src: "assets/img/Pastevents/657.jpeg",
      caption:
        "ഓയൂർ ടൗൺ ലയൺസ് ക്ലബ് , ചെറിയവെളിനല്ലൂർ K P M ഹയർസെക്കൻഡറി സ്കൂളും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/657.jpeg",
    },
    {
      src: "assets/img/Pastevents/658.jpeg",
      caption:
        "ഓയൂർ ടൗൺ ലയൺസ് ക്ലബ് , ചെറിയവെളിനല്ലൂർ K P M ഹയർസെക്കൻഡറി സ്കൂളും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/658.jpeg",
    },
    {
      src: "assets/img/Pastevents/659.jpeg",
      caption:
        "ഓയൂർ ടൗൺ ലയൺസ് ക്ലബ് , ചെറിയവെളിനല്ലൂർ K P M ഹയർസെക്കൻഡറി സ്കൂളും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/659.jpeg",
    },
    {
      src: "assets/img/Pastevents/660.jpeg",
      caption:
        "ഓയൂർ ടൗൺ ലയൺസ് ക്ലബ് , ചെറിയവെളിനല്ലൂർ K P M ഹയർസെക്കൻഡറി സ്കൂളും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/660.jpeg",
    },
    {
      src: "assets/img/Pastevents/661.jpeg",
      caption:
        "ഓയൂർ ടൗൺ ലയൺസ് ക്ലബ് , ചെറിയവെളിനല്ലൂർ K P M ഹയർസെക്കൻഡറി സ്കൂളും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/661.jpeg",
    },
    {
      src: "assets/img/Pastevents/662.jpeg",
      caption:
        "ഓയൂർ ടൗൺ ലയൺസ് ക്ലബ് , ചെറിയവെളിനല്ലൂർ K P M ഹയർസെക്കൻഡറി സ്കൂളും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/662.jpeg",
    },
    {
      src: "assets/img/Pastevents/663.jpeg",
      caption:
        "ഓയൂർ ടൗൺ ലയൺസ് ക്ലബ് , ചെറിയവെളിനല്ലൂർ K P M ഹയർസെക്കൻഡറി സ്കൂളും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/663.jpeg",
    },
    {
      src: "assets/img/Pastevents/664.jpeg",
      caption:
        "ഓയൂർ ടൗൺ ലയൺസ് ക്ലബ് , ചെറിയവെളിനല്ലൂർ K P M ഹയർസെക്കൻഡറി സ്കൂളും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/664.jpeg",
    },
    {
      src: "assets/img/Pastevents/652.jpeg",
      caption:
        "കേരള കൗമുദി പാലോട് യൂണിറ്റും ജ്യോതിർഗമയ ഫെസ്റ്റ് 2022 നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/652.jpeg",
    },
    {
      src: "assets/img/Pastevents/653.jpeg",
      caption:
        "കേരള കൗമുദി പാലോട് യൂണിറ്റും ജ്യോതിർഗമയ ഫെസ്റ്റ് 2022 നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/653.jpeg",
    },
    {
      src: "assets/img/Pastevents/654.jpeg",
      caption:
        "കേരള കൗമുദി പാലോട് യൂണിറ്റും ജ്യോതിർഗമയ ഫെസ്റ്റ് 2022 നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/654.jpeg",
    },
    {
      src: "assets/img/Pastevents/655.jpeg",
      caption:
        "കേരള കൗമുദി പാലോട് യൂണിറ്റും ജ്യോതിർഗമയ ഫെസ്റ്റ് 2022 നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/655.jpeg",
    },
    {
      src: "assets/img/Pastevents/656.jpeg",
      caption:
        "കേരള കൗമുദി പാലോട് യൂണിറ്റും ജ്യോതിർഗമയ ഫെസ്റ്റ് 2022 നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/656.jpeg",
    },

    {
      src: "assets/img/Pastevents/644.jpeg",
      caption:
        "കുളത്തൂർ ഗാന്ധി നഗർ റെസിഡൻഷ്യൽ അസോസിയേഷൻ, തിരുവനന്തപുരം സൗത്ത് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ k ആൻസലൻ ( ബഹു. എം എൽ എ നെയ്യാറ്റിൻകര).",
      thumb: "assets/img/Pastevents/644.jpeg",
    },
    {
      src: "assets/img/Pastevents/645.jpeg",
      caption:
        "കുളത്തൂർ ഗാന്ധി നഗർ റെസിഡൻഷ്യൽ അസോസിയേഷൻ, തിരുവനന്തപുരം സൗത്ത് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ k ആൻസലൻ ( ബഹു. എം എൽ എ നെയ്യാറ്റിൻകര).",
      thumb: "assets/img/Pastevents/645.jpeg",
    },
    {
      src: "assets/img/Pastevents/646.jpeg",
      caption:
        "കുളത്തൂർ ഗാന്ധി നഗർ റെസിഡൻഷ്യൽ അസോസിയേഷൻ, തിരുവനന്തപുരം സൗത്ത് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ k ആൻസലൻ ( ബഹു. എം എൽ എ നെയ്യാറ്റിൻകര).",
      thumb: "assets/img/Pastevents/646.jpeg",
    },
    {
      src: "assets/img/Pastevents/647.jpeg",
      caption:
        "കുളത്തൂർ ഗാന്ധി നഗർ റെസിഡൻഷ്യൽ അസോസിയേഷൻ, തിരുവനന്തപുരം സൗത്ത് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ k ആൻസലൻ ( ബഹു. എം എൽ എ നെയ്യാറ്റിൻകര).",
      thumb: "assets/img/Pastevents/647.jpeg",
    },
    {
      src: "assets/img/Pastevents/648.jpeg",
      caption:
        "കുളത്തൂർ ഗാന്ധി നഗർ റെസിഡൻഷ്യൽ അസോസിയേഷൻ, തിരുവനന്തപുരം സൗത്ത് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ k ആൻസലൻ ( ബഹു. എം എൽ എ നെയ്യാറ്റിൻകര).",
      thumb: "assets/img/Pastevents/648.jpeg",
    },
    {
      src: "assets/img/Pastevents/649.jpeg",
      caption:
        "കുളത്തൂർ ഗാന്ധി നഗർ റെസിഡൻഷ്യൽ അസോസിയേഷൻ, തിരുവനന്തപുരം സൗത്ത് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ k ആൻസലൻ ( ബഹു. എം എൽ എ നെയ്യാറ്റിൻകര).",
      thumb: "assets/img/Pastevents/649.jpeg",
    },
    {
      src: "assets/img/Pastevents/650.jpeg",
      caption:
        "കുളത്തൂർ ഗാന്ധി നഗർ റെസിഡൻഷ്യൽ അസോസിയേഷൻ, തിരുവനന്തപുരം സൗത്ത് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ k ആൻസലൻ ( ബഹു. എം എൽ എ നെയ്യാറ്റിൻകര).",
      thumb: "assets/img/Pastevents/650.jpeg",
    },
    {
      src: "assets/img/Pastevents/651.jpeg",
      caption:
        "കുളത്തൂർ ഗാന്ധി നഗർ റെസിഡൻഷ്യൽ അസോസിയേഷൻ, തിരുവനന്തപുരം സൗത്ത് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ k ആൻസലൻ ( ബഹു. എം എൽ എ നെയ്യാറ്റിൻകര).",
      thumb: "assets/img/Pastevents/651.jpeg",
    },
    {
      src: "assets/img/Pastevents/638.jpeg",
      caption:
        "ആറ്റിങ്ങൽ പാലസ് ലയൺസ് ക്ലബ്, മുടപുരം ശിവകൃഷ്ണപുരം ക്ഷേത്ര ട്രസ്റ്റും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/638.jpeg",
    },
    {
      src: "assets/img/Pastevents/639.jpeg",
      caption:
        "ആറ്റിങ്ങൽ പാലസ് ലയൺസ് ക്ലബ്, മുടപുരം ശിവകൃഷ്ണപുരം ക്ഷേത്ര ട്രസ്റ്റും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/639.jpeg",
    },
    {
      src: "assets/img/Pastevents/640.jpeg",
      caption:
        "ആറ്റിങ്ങൽ പാലസ് ലയൺസ് ക്ലബ്, മുടപുരം ശിവകൃഷ്ണപുരം ക്ഷേത്ര ട്രസ്റ്റും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/640.jpeg",
    },
    {
      src: "assets/img/Pastevents/641.jpeg",
      caption:
        "ആറ്റിങ്ങൽ പാലസ് ലയൺസ് ക്ലബ്, മുടപുരം ശിവകൃഷ്ണപുരം ക്ഷേത്ര ട്രസ്റ്റും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/641.jpeg",
    },
    {
      src: "assets/img/Pastevents/642.jpeg",
      caption:
        "ആറ്റിങ്ങൽ പാലസ് ലയൺസ് ക്ലബ്, മുടപുരം ശിവകൃഷ്ണപുരം ക്ഷേത്ര ട്രസ്റ്റും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/642.jpeg",
    },
    {
      src: "assets/img/Pastevents/643.jpeg",
      caption:
        "ആറ്റിങ്ങൽ പാലസ് ലയൺസ് ക്ലബ്, മുടപുരം ശിവകൃഷ്ണപുരം ക്ഷേത്ര ട്രസ്റ്റും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/643.jpeg",
    },
    {
      src: "assets/img/Pastevents/633.jpeg",
      caption:
        "നവശകതി ലൈബ്രറി , പൂജപ്പുര ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/633.jpeg",
    },
    {
      src: "assets/img/Pastevents/634.jpeg",
      caption:
        "നവശകതി ലൈബ്രറി , പൂജപ്പുര ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/634.jpeg",
    },
    {
      src: "assets/img/Pastevents/635.jpeg",
      caption:
        "നവശകതി ലൈബ്രറി , പൂജപ്പുര ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/635.jpeg",
    },
    {
      src: "assets/img/Pastevents/636.jpeg",
      caption:
        "നവശകതി ലൈബ്രറി , പൂജപ്പുര ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/636.jpeg",
    },
    {
      src: "assets/img/Pastevents/637.jpeg",
      caption:
        "നവശകതി ലൈബ്രറി , പൂജപ്പുര ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/637.jpeg",
    },
    {
      src: "assets/img/Pastevents/626.jpeg",
      caption:
        "കാവിയാട് ദിവാകര പണിക്കർ സാംസ്കാരിക കേന്ദ്രവും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/626.jpeg",
    },
    {
      src: "assets/img/Pastevents/627.jpeg",
      caption:
        "കാവിയാട് ദിവാകര പണിക്കർ സാംസ്കാരിക കേന്ദ്രവും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/627.jpeg",
    },
    {
      src: "assets/img/Pastevents/628.jpeg",
      caption:
        "കാവിയാട് ദിവാകര പണിക്കർ സാംസ്കാരിക കേന്ദ്രവും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/628.jpeg",
    },
    {
      src: "assets/img/Pastevents/629.jpeg",
      caption:
        "കാവിയാട് ദിവാകര പണിക്കർ സാംസ്കാരിക കേന്ദ്രവും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/629.jpeg",
    },
    {
      src: "assets/img/Pastevents/630.jpeg",
      caption:
        "കാവിയാട് ദിവാകര പണിക്കർ സാംസ്കാരിക കേന്ദ്രവും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/630.jpeg",
    },
    {
      src: "assets/img/Pastevents/631.jpeg",
      caption:
        "കാവിയാട് ദിവാകര പണിക്കർ സാംസ്കാരിക കേന്ദ്രവും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/631.jpeg",
    },
    {
      src: "assets/img/Pastevents/632.jpeg",
      caption:
        "കാവിയാട് ദിവാകര പണിക്കർ സാംസ്കാരിക കേന്ദ്രവും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/632.jpeg",
    },
    {
      src: "assets/img/Pastevents/618.jpeg",
      caption:
        "സിപിഐ (എം) വഴിമുക്ക് ബ്രാഞ്ചും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം സഖാവ് ശ്രീ റ്റി ശ്രീകുമാർ(സിപിഐ (എം) നെയ്യാറ്റിൻകര ഏരിയാ സെക്രട്ടറി)",
      thumb: "assets/img/Pastevents/618.jpeg",
    },
    {
      src: "assets/img/Pastevents/619.jpeg",
      caption:
        "സിപിഐ (എം) വഴിമുക്ക് ബ്രാഞ്ചും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം സഖാവ് ശ്രീ റ്റി ശ്രീകുമാർ(സിപിഐ (എം) നെയ്യാറ്റിൻകര ഏരിയാ സെക്രട്ടറി)",
      thumb: "assets/img/Pastevents/619.jpeg",
    },
    {
      src: "assets/img/Pastevents/620.jpeg",
      caption:
        "സിപിഐ (എം) വഴിമുക്ക് ബ്രാഞ്ചും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം സഖാവ് ശ്രീ റ്റി ശ്രീകുമാർ(സിപിഐ (എം) നെയ്യാറ്റിൻകര ഏരിയാ സെക്രട്ടറി)",
      thumb: "assets/img/Pastevents/620.jpeg",
    },
    {
      src: "assets/img/Pastevents/621.jpeg",
      caption:
        "സിപിഐ (എം) വഴിമുക്ക് ബ്രാഞ്ചും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം സഖാവ് ശ്രീ റ്റി ശ്രീകുമാർ(സിപിഐ (എം) നെയ്യാറ്റിൻകര ഏരിയാ സെക്രട്ടറി)",
      thumb: "assets/img/Pastevents/621.jpeg",
    },
    {
      src: "assets/img/Pastevents/622.jpeg",
      caption:
        "സിപിഐ (എം) വഴിമുക്ക് ബ്രാഞ്ചും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം സഖാവ് ശ്രീ റ്റി ശ്രീകുമാർ(സിപിഐ (എം) നെയ്യാറ്റിൻകര ഏരിയാ സെക്രട്ടറി)",
      thumb: "assets/img/Pastevents/622.jpeg",
    },
    {
      src: "assets/img/Pastevents/623.jpeg",
      caption:
        "സിപിഐ (എം) വഴിമുക്ക് ബ്രാഞ്ചും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം സഖാവ് ശ്രീ റ്റി ശ്രീകുമാർ(സിപിഐ (എം) നെയ്യാറ്റിൻകര ഏരിയാ സെക്രട്ടറി)",
      thumb: "assets/img/Pastevents/623.jpeg",
    },
    {
      src: "assets/img/Pastevents/624.jpeg",
      caption:
        "സിപിഐ (എം) വഴിമുക്ക് ബ്രാഞ്ചും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം സഖാവ് ശ്രീ റ്റി ശ്രീകുമാർ(സിപിഐ (എം) നെയ്യാറ്റിൻകര ഏരിയാ സെക്രട്ടറി)",
      thumb: "assets/img/Pastevents/624.jpeg",
    },
    {
      src: "assets/img/Pastevents/625.jpeg",
      caption:
        "സിപിഐ (എം) വഴിമുക്ക് ബ്രാഞ്ചും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം സഖാവ് ശ്രീ റ്റി ശ്രീകുമാർ(സിപിഐ (എം) നെയ്യാറ്റിൻകര ഏരിയാ സെക്രട്ടറി)",
      thumb: "assets/img/Pastevents/625.jpeg",
    },
    {
      src: "assets/img/Pastevents/610.jpeg",
      caption:
        "NIMS College of Nursing and NIMS MEDICITY Organised and Conducted Free Medical Camp at Community Health Centre, Poonthura on 22/12/2021.Many thanks to our MD Mr.M.S Faizal Khan , Doctors,Dental Surgeons,Camp Cordinator, Staffs ,Faculty and Fourth Year Bsc Nursing Students for their support and efforts.",
      thumb: "assets/img/Pastevents/610.jpeg",
    },
    {
      src: "assets/img/Pastevents/611.jpeg",
      caption:
        "NIMS College of Nursing and NIMS MEDICITY Organised and Conducted Free Medical Camp at Community Health Centre, Poonthura on 22/12/2021.Many thanks to our MD Mr.M.S Faizal Khan , Doctors,Dental Surgeons,Camp Cordinator, Staffs ,Faculty and Fourth Year Bsc Nursing Students for their support and efforts.",
      thumb: "assets/img/Pastevents/611.jpeg",
    },
    {
      src: "assets/img/Pastevents/612.jpeg",
      caption:
        "NIMS College of Nursing and NIMS MEDICITY Organised and Conducted Free Medical Camp at Community Health Centre, Poonthura on 22/12/2021.Many thanks to our MD Mr.M.S Faizal Khan , Doctors,Dental Surgeons,Camp Cordinator, Staffs ,Faculty and Fourth Year Bsc Nursing Students for their support and efforts.",
      thumb: "assets/img/Pastevents/612.jpeg",
    },
    {
      src: "assets/img/Pastevents/613.jpeg",
      caption:
        "NIMS College of Nursing and NIMS MEDICITY Organised and Conducted Free Medical Camp at Community Health Centre, Poonthura on 22/12/2021.Many thanks to our MD Mr.M.S Faizal Khan , Doctors,Dental Surgeons,Camp Cordinator, Staffs ,Faculty and Fourth Year Bsc Nursing Students for their support and efforts.",
      thumb: "assets/img/Pastevents/613.jpeg",
    },
    {
      src: "assets/img/Pastevents/614.jpeg",
      caption:
        "NIMS College of Nursing and NIMS MEDICITY Organised and Conducted Free Medical Camp at Community Health Centre, Poonthura on 22/12/2021.Many thanks to our MD Mr.M.S Faizal Khan , Doctors,Dental Surgeons,Camp Cordinator, Staffs ,Faculty and Fourth Year Bsc Nursing Students for their support and efforts.",
      thumb: "assets/img/Pastevents/614.jpeg",
    },
    {
      src: "assets/img/Pastevents/615.jpeg",
      caption:
        "NIMS College of Nursing and NIMS MEDICITY Organised and Conducted Free Medical Camp at Community Health Centre, Poonthura on 22/12/2021.Many thanks to our MD Mr.M.S Faizal Khan , Doctors,Dental Surgeons,Camp Cordinator, Staffs ,Faculty and Fourth Year Bsc Nursing Students for their support and efforts.",
      thumb: "assets/img/Pastevents/615.jpeg",
    },
    {
      src: "assets/img/Pastevents/616.jpeg",
      caption:
        "NIMS College of Nursing and NIMS MEDICITY Organised and Conducted Free Medical Camp at Community Health Centre, Poonthura on 22/12/2021.Many thanks to our MD Mr.M.S Faizal Khan , Doctors,Dental Surgeons,Camp Cordinator, Staffs ,Faculty and Fourth Year Bsc Nursing Students for their support and efforts.",
      thumb: "assets/img/Pastevents/616.jpeg",
    },
    {
      src: "assets/img/Pastevents/617.jpeg",
      caption:
        "NIMS College of Nursing and NIMS MEDICITY Organised and Conducted Free Medical Camp at Community Health Centre, Poonthura on 22/12/2021.Many thanks to our MD Mr.M.S Faizal Khan , Doctors,Dental Surgeons,Camp Cordinator, Staffs ,Faculty and Fourth Year Bsc Nursing Students for their support and efforts.",
      thumb: "assets/img/Pastevents/617.jpeg",
    },
    {
      src: "assets/img/Pastevents/605.jpeg",
      caption:
        "കേരള കൗമുദി പാലോട് യൂണിറ്റും ബോധ പൗർണമി ക്ലബും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ ശൈലജ രാജീവൻ ( പ്രസിഡൻ്റ് നന്ദിയോട് ഗ്രാമപഞ്ചായത്ത് )",
      thumb: "assets/img/Pastevents/605.jpeg",
    },
    {
      src: "assets/img/Pastevents/606.jpeg",
      caption:
        "കേരള കൗമുദി പാലോട് യൂണിറ്റും ബോധ പൗർണമി ക്ലബും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ ശൈലജ രാജീവൻ ( പ്രസിഡൻ്റ് നന്ദിയോട് ഗ്രാമപഞ്ചായത്ത് )",
      thumb: "assets/img/Pastevents/606.jpeg",
    },
    {
      src: "assets/img/Pastevents/607.jpeg",
      caption:
        "കേരള കൗമുദി പാലോട് യൂണിറ്റും ബോധ പൗർണമി ക്ലബും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ ശൈലജ രാജീവൻ ( പ്രസിഡൻ്റ് നന്ദിയോട് ഗ്രാമപഞ്ചായത്ത് )",
      thumb: "assets/img/Pastevents/607.jpeg",
    },
    {
      src: "assets/img/Pastevents/608.jpeg",
      caption:
        "കേരള കൗമുദി പാലോട് യൂണിറ്റും ബോധ പൗർണമി ക്ലബും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ ശൈലജ രാജീവൻ ( പ്രസിഡൻ്റ് നന്ദിയോട് ഗ്രാമപഞ്ചായത്ത് )",
      thumb: "assets/img/Pastevents/608.jpeg",
    },
    {
      src: "assets/img/Pastevents/609.jpeg",
      caption:
        "കേരള കൗമുദി പാലോട് യൂണിറ്റും ബോധ പൗർണമി ക്ലബും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ ശൈലജ രാജീവൻ ( പ്രസിഡൻ്റ് നന്ദിയോട് ഗ്രാമപഞ്ചായത്ത് )",
      thumb: "assets/img/Pastevents/609.jpeg",
    },
    {
      src: "assets/img/Pastevents/597.jpeg",
      caption:
        "ട്രിവാൻഡ്രം കോസ്മോപോളിറ്റൻ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ. ജോൺസൺ ജോസഫ് (കൗൺസിലർ നാലാഞ്ചിറ വാർഡ്)",
      thumb: "assets/img/Pastevents/597.jpeg",
    },
    {
      src: "assets/img/Pastevents/598.jpeg",
      caption:
        "ട്രിവാൻഡ്രം കോസ്മോപോളിറ്റൻ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ. ജോൺസൺ ജോസഫ് (കൗൺസിലർ നാലാഞ്ചിറ വാർഡ്)",
      thumb: "assets/img/Pastevents/598.jpeg",
    },
    {
      src: "assets/img/Pastevents/599.jpeg",
      caption:
        "ട്രിവാൻഡ്രം കോസ്മോപോളിറ്റൻ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ. ജോൺസൺ ജോസഫ് (കൗൺസിലർ നാലാഞ്ചിറ വാർഡ്)",
      thumb: "assets/img/Pastevents/599.jpeg",
    },
    {
      src: "assets/img/Pastevents/600.jpeg",
      caption:
        "ട്രിവാൻഡ്രം കോസ്മോപോളിറ്റൻ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ. ജോൺസൺ ജോസഫ് (കൗൺസിലർ നാലാഞ്ചിറ വാർഡ്)",
      thumb: "assets/img/Pastevents/600.jpeg",
    },
    {
      src: "assets/img/Pastevents/601.jpeg",
      caption:
        "ട്രിവാൻഡ്രം കോസ്മോപോളിറ്റൻ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ. ജോൺസൺ ജോസഫ് (കൗൺസിലർ നാലാഞ്ചിറ വാർഡ്)",
      thumb: "assets/img/Pastevents/601.jpeg",
    },
    {
      src: "assets/img/Pastevents/602.jpeg",
      caption:
        "ട്രിവാൻഡ്രം കോസ്മോപോളിറ്റൻ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ. ജോൺസൺ ജോസഫ് (കൗൺസിലർ നാലാഞ്ചിറ വാർഡ്)",
      thumb: "assets/img/Pastevents/602.jpeg",
    },
    {
      src: "assets/img/Pastevents/603.jpeg",
      caption:
        "ട്രിവാൻഡ്രം കോസ്മോപോളിറ്റൻ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ. ജോൺസൺ ജോസഫ് (കൗൺസിലർ നാലാഞ്ചിറ വാർഡ്)",
      thumb: "assets/img/Pastevents/603.jpeg",
    },
    {
      src: "assets/img/Pastevents/604.jpeg",
      caption:
        "ട്രിവാൻഡ്രം കോസ്മോപോളിറ്റൻ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ. ജോൺസൺ ജോസഫ് (കൗൺസിലർ നാലാഞ്ചിറ വാർഡ്)",
      thumb: "assets/img/Pastevents/604.jpeg",
    },
    {
      src: "assets/img/Pastevents/585.jpg",
      caption:
        "കേരള കൗമുദി പാലോട് യൂണിറ്റും ബോധ പൗർണമി ക്ലബും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ സുധാകരൻ.",
      thumb: "assets/img/Pastevents/585.jpg",
    },
    {
      src: "assets/img/Pastevents/586.jpg",
      caption:
        "കേരള കൗമുദി പാലോട് യൂണിറ്റും ബോധ പൗർണമി ക്ലബും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ സുധാകരൻ.",
      thumb: "assets/img/Pastevents/586.jpg",
    },
    {
      src: "assets/img/Pastevents/587.jpg",
      caption:
        "കേരള കൗമുദി പാലോട് യൂണിറ്റും ബോധ പൗർണമി ക്ലബും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ സുധാകരൻ.",
      thumb: "assets/img/Pastevents/587.jpg",
    },
    {
      src: "assets/img/Pastevents/588.jpg",
      caption:
        "കേരള കൗമുദി പാലോട് യൂണിറ്റും ബോധ പൗർണമി ക്ലബും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ സുധാകരൻ.",
      thumb: "assets/img/Pastevents/588.jpg",
    },
    {
      src: "assets/img/Pastevents/589.jpg",
      caption:
        "കേരള കൗമുദി പാലോട് യൂണിറ്റും ബോധ പൗർണമി ക്ലബും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ സുധാകരൻ.",
      thumb: "assets/img/Pastevents/589.jpg",
    },
    {
      src: "assets/img/Pastevents/590.jpg",
      caption:
        "കേരള കൗമുദി പാലോട് യൂണിറ്റും ബോധ പൗർണമി ക്ലബും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ സുധാകരൻ.",
      thumb: "assets/img/Pastevents/590.jpg",
    },
    {
      src: "assets/img/Pastevents/591.jpg",
      caption:
        "കേരള കൗമുദി പാലോട് യൂണിറ്റും ബോധ പൗർണമി ക്ലബും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ സുധാകരൻ.",
      thumb: "assets/img/Pastevents/591.jpg",
    },
    {
      src: "assets/img/Pastevents/592.jpg",
      caption:
        "കേരള കൗമുദി പാലോട് യൂണിറ്റും ബോധ പൗർണമി ക്ലബും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ സുധാകരൻ.",
      thumb: "assets/img/Pastevents/592.jpg",
    },
    {
      src: "assets/img/Pastevents/593.jpg",
      caption:
        "കേരള കൗമുദി പാലോട് യൂണിറ്റും ബോധ പൗർണമി ക്ലബും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ സുധാകരൻ.",
      thumb: "assets/img/Pastevents/593.jpg",
    },
    {
      src: "assets/img/Pastevents/594.jpg",
      caption:
        "കേരള കൗമുദി പാലോട് യൂണിറ്റും ബോധ പൗർണമി ക്ലബും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ സുധാകരൻ.",
      thumb: "assets/img/Pastevents/594.jpg",
    },
    {
      src: "assets/img/Pastevents/595.jpg",
      caption:
        "കേരള കൗമുദി പാലോട് യൂണിറ്റും ബോധ പൗർണമി ക്ലബും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ സുധാകരൻ.",
      thumb: "assets/img/Pastevents/595.jpg",
    },
    {
      src: "assets/img/Pastevents/596.jpg",
      caption:
        "കേരള കൗമുദി പാലോട് യൂണിറ്റും ബോധ പൗർണമി ക്ലബും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ സുധാകരൻ.",
      thumb: "assets/img/Pastevents/596.jpg",
    },
    {
      src: "assets/img/Pastevents/573.jpg",
      caption:
        "തിരു. മേട്രോപ്പോളിസ് ലയൺസ് ക്ലബ്ബിൻ്റെയും സി പി ഐ (എം) ആറ്റിപ്ര ലോക്കൽകമ്മിറ്റി മൺവിള ബ്രാഞ്ചിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ Dr.രാജേന്ദ്രൻ (PDG)",
      thumb: "assets/img/Pastevents/573.jpg",
    },
    {
      src: "assets/img/Pastevents/574.jpg",
      caption:
        "തിരു. മേട്രോപ്പോളിസ് ലയൺസ് ക്ലബ്ബിൻ്റെയും സി പി ഐ (എം) ആറ്റിപ്ര ലോക്കൽകമ്മിറ്റി മൺവിള ബ്രാഞ്ചിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ Dr.രാജേന്ദ്രൻ (PDG)",
      thumb: "assets/img/Pastevents/574.jpg",
    },
    {
      src: "assets/img/Pastevents/575.jpg",
      caption:
        "തിരു. മേട്രോപ്പോളിസ് ലയൺസ് ക്ലബ്ബിൻ്റെയും സി പി ഐ (എം) ആറ്റിപ്ര ലോക്കൽകമ്മിറ്റി മൺവിള ബ്രാഞ്ചിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ Dr.രാജേന്ദ്രൻ (PDG)",
      thumb: "assets/img/Pastevents/575.jpg",
    },
    {
      src: "assets/img/Pastevents/576.jpg",
      caption:
        "തിരു. മേട്രോപ്പോളിസ് ലയൺസ് ക്ലബ്ബിൻ്റെയും സി പി ഐ (എം) ആറ്റിപ്ര ലോക്കൽകമ്മിറ്റി മൺവിള ബ്രാഞ്ചിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ Dr.രാജേന്ദ്രൻ (PDG)",
      thumb: "assets/img/Pastevents/576.jpg",
    },
    {
      src: "assets/img/Pastevents/577.jpg",
      caption:
        "തിരു. മേട്രോപ്പോളിസ് ലയൺസ് ക്ലബ്ബിൻ്റെയും സി പി ഐ (എം) ആറ്റിപ്ര ലോക്കൽകമ്മിറ്റി മൺവിള ബ്രാഞ്ചിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ Dr.രാജേന്ദ്രൻ (PDG)",
      thumb: "assets/img/Pastevents/577.jpg",
    },
    {
      src: "assets/img/Pastevents/578.jpg",
      caption:
        "തിരു. മേട്രോപ്പോളിസ് ലയൺസ് ക്ലബ്ബിൻ്റെയും സി പി ഐ (എം) ആറ്റിപ്ര ലോക്കൽകമ്മിറ്റി മൺവിള ബ്രാഞ്ചിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ Dr.രാജേന്ദ്രൻ (PDG)",
      thumb: "assets/img/Pastevents/578.jpg",
    },
    {
      src: "assets/img/Pastevents/579.jpg",
      caption:
        "തിരു. മേട്രോപ്പോളിസ് ലയൺസ് ക്ലബ്ബിൻ്റെയും സി പി ഐ (എം) ആറ്റിപ്ര ലോക്കൽകമ്മിറ്റി മൺവിള ബ്രാഞ്ചിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ Dr.രാജേന്ദ്രൻ (PDG)",
      thumb: "assets/img/Pastevents/579.jpg",
    },
    {
      src: "assets/img/Pastevents/580.jpg",
      caption:
        "തിരു. മേട്രോപ്പോളിസ് ലയൺസ് ക്ലബ്ബിൻ്റെയും സി പി ഐ (എം) ആറ്റിപ്ര ലോക്കൽകമ്മിറ്റി മൺവിള ബ്രാഞ്ചിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ Dr.രാജേന്ദ്രൻ (PDG)",
      thumb: "assets/img/Pastevents/580.jpg",
    },
    {
      src: "assets/img/Pastevents/581.jpg",
      caption:
        "തിരു. മേട്രോപ്പോളിസ് ലയൺസ് ക്ലബ്ബിൻ്റെയും സി പി ഐ (എം) ആറ്റിപ്ര ലോക്കൽകമ്മിറ്റി മൺവിള ബ്രാഞ്ചിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ Dr.രാജേന്ദ്രൻ (PDG)",
      thumb: "assets/img/Pastevents/581.jpg",
    },
    {
      src: "assets/img/Pastevents/582.jpg",
      caption:
        "തിരു. മേട്രോപ്പോളിസ് ലയൺസ് ക്ലബ്ബിൻ്റെയും സി പി ഐ (എം) ആറ്റിപ്ര ലോക്കൽകമ്മിറ്റി മൺവിള ബ്രാഞ്ചിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ Dr.രാജേന്ദ്രൻ (PDG)",
      thumb: "assets/img/Pastevents/582.jpg",
    },
    {
      src: "assets/img/Pastevents/583.jpg",
      caption:
        "തിരു. മേട്രോപ്പോളിസ് ലയൺസ് ക്ലബ്ബിൻ്റെയും സി പി ഐ (എം) ആറ്റിപ്ര ലോക്കൽകമ്മിറ്റി മൺവിള ബ്രാഞ്ചിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ Dr.രാജേന്ദ്രൻ (PDG)",
      thumb: "assets/img/Pastevents/583.jpg",
    },
    {
      src: "assets/img/Pastevents/584.jpg",
      caption:
        "തിരു. മേട്രോപ്പോളിസ് ലയൺസ് ക്ലബ്ബിൻ്റെയും സി പി ഐ (എം) ആറ്റിപ്ര ലോക്കൽകമ്മിറ്റി മൺവിള ബ്രാഞ്ചിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ Dr.രാജേന്ദ്രൻ (PDG)",
      thumb: "assets/img/Pastevents/584.jpg",
    },
    {
      src: "assets/img/Pastevents/560.jpg",
      caption:
        "ഒളിമ്പിക്സ് വേവും നിംസ് മെഡിസിറ്റിയും സംയുക്ത ആഭിമുഖ്യത്തിൽ മ്യൂസിയം വളപ്പിൽ പ്രഭാത വ്യായാമങ്ങൾക്കായി എത്തുന്നവർക്കായി സൗജന്യ കാർഡിയോ, ജനറൽ, ഫിസിയോതെറാപ്പി ക്യാമ്പ് സംഘടിപ്പിച്ചു.120-ൽപ്പരം ആളുകൾ ക്യാമ്പ് ആനുകൂല്യം പ്രയോജനപ്പെടുത്തി.",
      thumb: "assets/img/Pastevents/560.jpg",
    },
    {
      src: "assets/img/Pastevents/561.jpg",
      caption:
        "ഒളിമ്പിക്സ് വേവും നിംസ് മെഡിസിറ്റിയും സംയുക്ത ആഭിമുഖ്യത്തിൽ മ്യൂസിയം വളപ്പിൽ പ്രഭാത വ്യായാമങ്ങൾക്കായി എത്തുന്നവർക്കായി സൗജന്യ കാർഡിയോ, ജനറൽ, ഫിസിയോതെറാപ്പി ക്യാമ്പ് സംഘടിപ്പിച്ചു.120-ൽപ്പരം ആളുകൾ ക്യാമ്പ് ആനുകൂല്യം പ്രയോജനപ്പെടുത്തി.",
      thumb: "assets/img/Pastevents/561.jpg",
    },
    {
      src: "assets/img/Pastevents/562.jpg",
      caption:
        "ഒളിമ്പിക്സ് വേവും നിംസ് മെഡിസിറ്റിയും സംയുക്ത ആഭിമുഖ്യത്തിൽ മ്യൂസിയം വളപ്പിൽ പ്രഭാത വ്യായാമങ്ങൾക്കായി എത്തുന്നവർക്കായി സൗജന്യ കാർഡിയോ, ജനറൽ, ഫിസിയോതെറാപ്പി ക്യാമ്പ് സംഘടിപ്പിച്ചു.120-ൽപ്പരം ആളുകൾ ക്യാമ്പ് ആനുകൂല്യം പ്രയോജനപ്പെടുത്തി.",
      thumb: "assets/img/Pastevents/562.jpg",
    },
    {
      src: "assets/img/Pastevents/563.jpg",
      caption:
        "ഒളിമ്പിക്സ് വേവും നിംസ് മെഡിസിറ്റിയും സംയുക്ത ആഭിമുഖ്യത്തിൽ മ്യൂസിയം വളപ്പിൽ പ്രഭാത വ്യായാമങ്ങൾക്കായി എത്തുന്നവർക്കായി സൗജന്യ കാർഡിയോ, ജനറൽ, ഫിസിയോതെറാപ്പി ക്യാമ്പ് സംഘടിപ്പിച്ചു.120-ൽപ്പരം ആളുകൾ ക്യാമ്പ് ആനുകൂല്യം പ്രയോജനപ്പെടുത്തി.",
      thumb: "assets/img/Pastevents/563.jpg",
    },
    {
      src: "assets/img/Pastevents/564.jpg",
      caption:
        "ഒളിമ്പിക്സ് വേവും നിംസ് മെഡിസിറ്റിയും സംയുക്ത ആഭിമുഖ്യത്തിൽ മ്യൂസിയം വളപ്പിൽ പ്രഭാത വ്യായാമങ്ങൾക്കായി എത്തുന്നവർക്കായി സൗജന്യ കാർഡിയോ, ജനറൽ, ഫിസിയോതെറാപ്പി ക്യാമ്പ് സംഘടിപ്പിച്ചു.120-ൽപ്പരം ആളുകൾ ക്യാമ്പ് ആനുകൂല്യം പ്രയോജനപ്പെടുത്തി.",
      thumb: "assets/img/Pastevents/564.jpg",
    },
    {
      src: "assets/img/Pastevents/565.jpg",
      caption:
        "ഒളിമ്പിക്സ് വേവും നിംസ് മെഡിസിറ്റിയും സംയുക്ത ആഭിമുഖ്യത്തിൽ മ്യൂസിയം വളപ്പിൽ പ്രഭാത വ്യായാമങ്ങൾക്കായി എത്തുന്നവർക്കായി സൗജന്യ കാർഡിയോ, ജനറൽ, ഫിസിയോതെറാപ്പി ക്യാമ്പ് സംഘടിപ്പിച്ചു.120-ൽപ്പരം ആളുകൾ ക്യാമ്പ് ആനുകൂല്യം പ്രയോജനപ്പെടുത്തി.",
      thumb: "assets/img/Pastevents/565.jpg",
    },
    {
      src: "assets/img/Pastevents/566.jpg",
      caption:
        "ഒളിമ്പിക്സ് വേവും നിംസ് മെഡിസിറ്റിയും സംയുക്ത ആഭിമുഖ്യത്തിൽ മ്യൂസിയം വളപ്പിൽ പ്രഭാത വ്യായാമങ്ങൾക്കായി എത്തുന്നവർക്കായി സൗജന്യ കാർഡിയോ, ജനറൽ, ഫിസിയോതെറാപ്പി ക്യാമ്പ് സംഘടിപ്പിച്ചു.120-ൽപ്പരം ആളുകൾ ക്യാമ്പ് ആനുകൂല്യം പ്രയോജനപ്പെടുത്തി.",
      thumb: "assets/img/Pastevents/566.jpg",
    },
    {
      src: "assets/img/Pastevents/567.jpg",
      caption:
        "ഒളിമ്പിക്സ് വേവും നിംസ് മെഡിസിറ്റിയും സംയുക്ത ആഭിമുഖ്യത്തിൽ മ്യൂസിയം വളപ്പിൽ പ്രഭാത വ്യായാമങ്ങൾക്കായി എത്തുന്നവർക്കായി സൗജന്യ കാർഡിയോ, ജനറൽ, ഫിസിയോതെറാപ്പി ക്യാമ്പ് സംഘടിപ്പിച്ചു.120-ൽപ്പരം ആളുകൾ ക്യാമ്പ് ആനുകൂല്യം പ്രയോജനപ്പെടുത്തി.",
      thumb: "assets/img/Pastevents/567.jpg",
    },
    {
      src: "assets/img/Pastevents/568.jpg",
      caption:
        "ഒളിമ്പിക്സ് വേവും നിംസ് മെഡിസിറ്റിയും സംയുക്ത ആഭിമുഖ്യത്തിൽ മ്യൂസിയം വളപ്പിൽ പ്രഭാത വ്യായാമങ്ങൾക്കായി എത്തുന്നവർക്കായി സൗജന്യ കാർഡിയോ, ജനറൽ, ഫിസിയോതെറാപ്പി ക്യാമ്പ് സംഘടിപ്പിച്ചു.120-ൽപ്പരം ആളുകൾ ക്യാമ്പ് ആനുകൂല്യം പ്രയോജനപ്പെടുത്തി.",
      thumb: "assets/img/Pastevents/568.jpg",
    },
    {
      src: "assets/img/Pastevents/569.jpg",
      caption:
        "ഒളിമ്പിക്സ് വേവും നിംസ് മെഡിസിറ്റിയും സംയുക്ത ആഭിമുഖ്യത്തിൽ മ്യൂസിയം വളപ്പിൽ പ്രഭാത വ്യായാമങ്ങൾക്കായി എത്തുന്നവർക്കായി സൗജന്യ കാർഡിയോ, ജനറൽ, ഫിസിയോതെറാപ്പി ക്യാമ്പ് സംഘടിപ്പിച്ചു.120-ൽപ്പരം ആളുകൾ ക്യാമ്പ് ആനുകൂല്യം പ്രയോജനപ്പെടുത്തി.",
      thumb: "assets/img/Pastevents/569.jpg",
    },
    {
      src: "assets/img/Pastevents/571.jpg",
      caption:
        "ഒളിമ്പിക്സ് വേവും നിംസ് മെഡിസിറ്റിയും സംയുക്ത ആഭിമുഖ്യത്തിൽ മ്യൂസിയം വളപ്പിൽ പ്രഭാത വ്യായാമങ്ങൾക്കായി എത്തുന്നവർക്കായി സൗജന്യ കാർഡിയോ, ജനറൽ, ഫിസിയോതെറാപ്പി ക്യാമ്പ് സംഘടിപ്പിച്ചു.120-ൽപ്പരം ആളുകൾ ക്യാമ്പ് ആനുകൂല്യം പ്രയോജനപ്പെടുത്തി.",
      thumb: "assets/img/Pastevents/571.jpg",
    },
    {
      src: "assets/img/Pastevents/572.jpg",
      caption:
        "ഒളിമ്പിക്സ് വേവും നിംസ് മെഡിസിറ്റിയും സംയുക്ത ആഭിമുഖ്യത്തിൽ മ്യൂസിയം വളപ്പിൽ പ്രഭാത വ്യായാമങ്ങൾക്കായി എത്തുന്നവർക്കായി സൗജന്യ കാർഡിയോ, ജനറൽ, ഫിസിയോതെറാപ്പി ക്യാമ്പ് സംഘടിപ്പിച്ചു.120-ൽപ്പരം ആളുകൾ ക്യാമ്പ് ആനുകൂല്യം പ്രയോജനപ്പെടുത്തി.",
      thumb: "assets/img/Pastevents/572.jpg",
    },
    {
      src: "assets/img/Pastevents/552.jpg",
      caption:
        "സി പി ഐ (എം) കൈപ്പാടി ബ്രാഞ്ചും, തിരു. സിറ്റി വെസ്റ്റ് ലയൺസ് ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ സ: റ്റി സുനിൽ കുമാർ(ബഹു. കരകുളം പഞ്ചായത്ത് വൈസ് പ്രസിഡൻ്റ്).",
      thumb: "assets/img/Pastevents/552.jpg",
    },
    {
      src: "assets/img/Pastevents/553.jpg",
      caption:
        "സി പി ഐ (എം) കൈപ്പാടി ബ്രാഞ്ചും, തിരു. സിറ്റി വെസ്റ്റ് ലയൺസ് ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ സ: റ്റി സുനിൽ കുമാർ(ബഹു. കരകുളം പഞ്ചായത്ത് വൈസ് പ്രസിഡൻ്റ്).",
      thumb: "assets/img/Pastevents/553.jpg",
    },
    {
      src: "assets/img/Pastevents/554.jpg",
      caption:
        "സി പി ഐ (എം) കൈപ്പാടി ബ്രാഞ്ചും, തിരു. സിറ്റി വെസ്റ്റ് ലയൺസ് ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ സ: റ്റി സുനിൽ കുമാർ(ബഹു. കരകുളം പഞ്ചായത്ത് വൈസ് പ്രസിഡൻ്റ്).",
      thumb: "assets/img/Pastevents/554.jpg",
    },
    {
      src: "assets/img/Pastevents/555.jpg",
      caption:
        "സി പി ഐ (എം) കൈപ്പാടി ബ്രാഞ്ചും, തിരു. സിറ്റി വെസ്റ്റ് ലയൺസ് ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ സ: റ്റി സുനിൽ കുമാർ(ബഹു. കരകുളം പഞ്ചായത്ത് വൈസ് പ്രസിഡൻ്റ്).",
      thumb: "assets/img/Pastevents/555.jpg",
    },
    {
      src: "assets/img/Pastevents/556.jpg",
      caption:
        "സി പി ഐ (എം) കൈപ്പാടി ബ്രാഞ്ചും, തിരു. സിറ്റി വെസ്റ്റ് ലയൺസ് ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ സ: റ്റി സുനിൽ കുമാർ(ബഹു. കരകുളം പഞ്ചായത്ത് വൈസ് പ്രസിഡൻ്റ്).",
      thumb: "assets/img/Pastevents/556.jpg",
    },
    {
      src: "assets/img/Pastevents/557.jpg",
      caption:
        "സി പി ഐ (എം) കൈപ്പാടി ബ്രാഞ്ചും, തിരു. സിറ്റി വെസ്റ്റ് ലയൺസ് ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ സ: റ്റി സുനിൽ കുമാർ(ബഹു. കരകുളം പഞ്ചായത്ത് വൈസ് പ്രസിഡൻ്റ്).",
      thumb: "assets/img/Pastevents/557.jpg",
    },
    {
      src: "assets/img/Pastevents/558.jpg",
      caption:
        "സി പി ഐ (എം) കൈപ്പാടി ബ്രാഞ്ചും, തിരു. സിറ്റി വെസ്റ്റ് ലയൺസ് ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ സ: റ്റി സുനിൽ കുമാർ(ബഹു. കരകുളം പഞ്ചായത്ത് വൈസ് പ്രസിഡൻ്റ്).",
      thumb: "assets/img/Pastevents/558.jpg",
    },
    {
      src: "assets/img/Pastevents/559.jpg",
      caption:
        "സി പി ഐ (എം) കൈപ്പാടി ബ്രാഞ്ചും, തിരു. സിറ്റി വെസ്റ്റ് ലയൺസ് ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ സ: റ്റി സുനിൽ കുമാർ(ബഹു. കരകുളം പഞ്ചായത്ത് വൈസ് പ്രസിഡൻ്റ്).",
      thumb: "assets/img/Pastevents/559.jpg",
    },
    {
      src: "assets/img/Pastevents/541.jpg",
      caption:
        "സിപിഐ (എം) മൊട്ടമ്മൂട് ബ്രാഞ്ചും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ അഡ്വ: ഡി സുരേഷ്കുമാർ (പ്രസിഡൻ്റ് തിരു. ജില്ലാ പഞ്ചായത്ത്)",
      thumb: "assets/img/Pastevents/541.jpg",
    },
    {
      src: "assets/img/Pastevents/542.jpg",
      caption:
        "സിപിഐ (എം) മൊട്ടമ്മൂട് ബ്രാഞ്ചും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ അഡ്വ: ഡി സുരേഷ്കുമാർ (പ്രസിഡൻ്റ് തിരു. ജില്ലാ പഞ്ചായത്ത്)",
      thumb: "assets/img/Pastevents/542.jpg",
    },
    {
      src: "assets/img/Pastevents/543.jpg",
      caption:
        "സിപിഐ (എം) മൊട്ടമ്മൂട് ബ്രാഞ്ചും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ അഡ്വ: ഡി സുരേഷ്കുമാർ (പ്രസിഡൻ്റ് തിരു. ജില്ലാ പഞ്ചായത്ത്)",
      thumb: "assets/img/Pastevents/543.jpg",
    },
    {
      src: "assets/img/Pastevents/544.jpg",
      caption:
        "സിപിഐ (എം) മൊട്ടമ്മൂട് ബ്രാഞ്ചും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ അഡ്വ: ഡി സുരേഷ്കുമാർ (പ്രസിഡൻ്റ് തിരു. ജില്ലാ പഞ്ചായത്ത്)",
      thumb: "assets/img/Pastevents/544.jpg",
    },
    {
      src: "assets/img/Pastevents/545.jpg",
      caption:
        "സിപിഐ (എം) മൊട്ടമ്മൂട് ബ്രാഞ്ചും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ അഡ്വ: ഡി സുരേഷ്കുമാർ (പ്രസിഡൻ്റ് തിരു. ജില്ലാ പഞ്ചായത്ത്)",
      thumb: "assets/img/Pastevents/545.jpg",
    },
    {
      src: "assets/img/Pastevents/546.jpg",
      caption:
        "സിപിഐ (എം) മൊട്ടമ്മൂട് ബ്രാഞ്ചും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ അഡ്വ: ഡി സുരേഷ്കുമാർ (പ്രസിഡൻ്റ് തിരു. ജില്ലാ പഞ്ചായത്ത്)",
      thumb: "assets/img/Pastevents/546.jpg",
    },
    {
      src: "assets/img/Pastevents/547.jpg",
      caption:
        "സിപിഐ (എം) മൊട്ടമ്മൂട് ബ്രാഞ്ചും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ അഡ്വ: ഡി സുരേഷ്കുമാർ (പ്രസിഡൻ്റ് തിരു. ജില്ലാ പഞ്ചായത്ത്)",
      thumb: "assets/img/Pastevents/547.jpg",
    },
    {
      src: "assets/img/Pastevents/548.jpg",
      caption:
        "സിപിഐ (എം) മൊട്ടമ്മൂട് ബ്രാഞ്ചും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ അഡ്വ: ഡി സുരേഷ്കുമാർ (പ്രസിഡൻ്റ് തിരു. ജില്ലാ പഞ്ചായത്ത്)",
      thumb: "assets/img/Pastevents/548.jpg",
    },
    {
      src: "assets/img/Pastevents/549.jpg",
      caption:
        "സിപിഐ (എം) മൊട്ടമ്മൂട് ബ്രാഞ്ചും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ അഡ്വ: ഡി സുരേഷ്കുമാർ (പ്രസിഡൻ്റ് തിരു. ജില്ലാ പഞ്ചായത്ത്)",
      thumb: "assets/img/Pastevents/549.jpg",
    },
    {
      src: "assets/img/Pastevents/550.jpg",
      caption:
        "സിപിഐ (എം) മൊട്ടമ്മൂട് ബ്രാഞ്ചും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ അഡ്വ: ഡി സുരേഷ്കുമാർ (പ്രസിഡൻ്റ് തിരു. ജില്ലാ പഞ്ചായത്ത്)",
      thumb: "assets/img/Pastevents/550.jpg",
    },
    {
      src: "assets/img/Pastevents/551.jpg",
      caption:
        "സിപിഐ (എം) മൊട്ടമ്മൂട് ബ്രാഞ്ചും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ അഡ്വ: ഡി സുരേഷ്കുമാർ (പ്രസിഡൻ്റ് തിരു. ജില്ലാ പഞ്ചായത്ത്)",
      thumb: "assets/img/Pastevents/551.jpg",
    },
    {
      src: "assets/img/Pastevents/530.jpg",
      caption:
        "കേരള കൗമുദി പാലോട് യൂണിറ്റും ബോധ പൗർണമി ക്ലബും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ ജി സുരേന്ദ്രൻ നായർ (വിതുര ഗ്രാമപഞ്ചായത്ത്)",
      thumb: "assets/img/Pastevents/530.jpg",
    },
    {
      src: "assets/img/Pastevents/531.jpg",
      caption:
        "കേരള കൗമുദി പാലോട് യൂണിറ്റും ബോധ പൗർണമി ക്ലബും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ ജി സുരേന്ദ്രൻ നായർ (വിതുര ഗ്രാമപഞ്ചായത്ത്)",
      thumb: "assets/img/Pastevents/531.jpg",
    },
    {
      src: "assets/img/Pastevents/532.jpg",
      caption:
        "കേരള കൗമുദി പാലോട് യൂണിറ്റും ബോധ പൗർണമി ക്ലബും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ ജി സുരേന്ദ്രൻ നായർ (വിതുര ഗ്രാമപഞ്ചായത്ത്)",
      thumb: "assets/img/Pastevents/532.jpg",
    },
    {
      src: "assets/img/Pastevents/533.jpg",
      caption:
        "കേരള കൗമുദി പാലോട് യൂണിറ്റും ബോധ പൗർണമി ക്ലബും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ ജി സുരേന്ദ്രൻ നായർ (വിതുര ഗ്രാമപഞ്ചായത്ത്)",
      thumb: "assets/img/Pastevents/533.jpg",
    },
    {
      src: "assets/img/Pastevents/534.jpg",
      caption:
        "കേരള കൗമുദി പാലോട് യൂണിറ്റും ബോധ പൗർണമി ക്ലബും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ ജി സുരേന്ദ്രൻ നായർ (വിതുര ഗ്രാമപഞ്ചായത്ത്)",
      thumb: "assets/img/Pastevents/534.jpg",
    },
    {
      src: "assets/img/Pastevents/535.jpg",
      caption:
        "കേരള കൗമുദി പാലോട് യൂണിറ്റും ബോധ പൗർണമി ക്ലബും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ ജി സുരേന്ദ്രൻ നായർ (വിതുര ഗ്രാമപഞ്ചായത്ത്)",
      thumb: "assets/img/Pastevents/535.jpg",
    },
    {
      src: "assets/img/Pastevents/536.jpg",
      caption:
        "കേരള കൗമുദി പാലോട് യൂണിറ്റും ബോധ പൗർണമി ക്ലബും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ ജി സുരേന്ദ്രൻ നായർ (വിതുര ഗ്രാമപഞ്ചായത്ത്)",
      thumb: "assets/img/Pastevents/536.jpg",
    },
    {
      src: "assets/img/Pastevents/537.jpg",
      caption:
        "കേരള കൗമുദി പാലോട് യൂണിറ്റും ബോധ പൗർണമി ക്ലബും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ ജി സുരേന്ദ്രൻ നായർ (വിതുര ഗ്രാമപഞ്ചായത്ത്)",
      thumb: "assets/img/Pastevents/537.jpg",
    },
    {
      src: "assets/img/Pastevents/538.jpg",
      caption:
        "കേരള കൗമുദി പാലോട് യൂണിറ്റും ബോധ പൗർണമി ക്ലബും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ ജി സുരേന്ദ്രൻ നായർ (വിതുര ഗ്രാമപഞ്ചായത്ത്)",
      thumb: "assets/img/Pastevents/538.jpg",
    },
    {
      src: "assets/img/Pastevents/539.jpg",
      caption:
        "കേരള കൗമുദി പാലോട് യൂണിറ്റും ബോധ പൗർണമി ക്ലബും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ ജി സുരേന്ദ്രൻ നായർ (വിതുര ഗ്രാമപഞ്ചായത്ത്)",
      thumb: "assets/img/Pastevents/539.jpg",
    },
    {
      src: "assets/img/Pastevents/540.jpg",
      caption:
        "കേരള കൗമുദി പാലോട് യൂണിറ്റും ബോധ പൗർണമി ക്ലബും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ ജി സുരേന്ദ്രൻ നായർ (വിതുര ഗ്രാമപഞ്ചായത്ത്)",
      thumb: "assets/img/Pastevents/540.jpg",
    },
    {
      src: "assets/img/Pastevents/521.jpg",
      caption:
        "കേരള വനം വകുപ്പ് പരുത്തിപള്ളി റെയിഞ്ച് നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു",
      thumb: "assets/img/Pastevents/521.jpg",
    },
    {
      src: "assets/img/Pastevents/522.jpg",
      caption:
        "കേരള വനം വകുപ്പ് പരുത്തിപള്ളി റെയിഞ്ച് നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു",
      thumb: "assets/img/Pastevents/522.jpg",
    },
    {
      src: "assets/img/Pastevents/523.jpg",
      caption:
        "കേരള വനം വകുപ്പ് പരുത്തിപള്ളി റെയിഞ്ച് നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു",
      thumb: "assets/img/Pastevents/523.jpg",
    },
    {
      src: "assets/img/Pastevents/524.jpg",
      caption:
        "കേരള വനം വകുപ്പ് പരുത്തിപള്ളി റെയിഞ്ച് നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു",
      thumb: "assets/img/Pastevents/524.jpg",
    },
    {
      src: "assets/img/Pastevents/525.jpg",
      caption:
        "കേരള വനം വകുപ്പ് പരുത്തിപള്ളി റെയിഞ്ച് നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു",
      thumb: "assets/img/Pastevents/525.jpg",
    },
    {
      src: "assets/img/Pastevents/526.jpg",
      caption:
        "കേരള വനം വകുപ്പ് പരുത്തിപള്ളി റെയിഞ്ച് നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു",
      thumb: "assets/img/Pastevents/526.jpg",
    },
    {
      src: "assets/img/Pastevents/527.jpg",
      caption:
        "കേരള വനം വകുപ്പ് പരുത്തിപള്ളി റെയിഞ്ച് നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു",
      thumb: "assets/img/Pastevents/527.jpg",
    },
    {
      src: "assets/img/Pastevents/528.jpg",
      caption:
        "കേരള വനം വകുപ്പ് പരുത്തിപള്ളി റെയിഞ്ച് നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു",
      thumb: "assets/img/Pastevents/528.jpg",
    },
    {
      src: "assets/img/Pastevents/529.jpg",
      caption:
        "കേരള വനം വകുപ്പ് പരുത്തിപള്ളി റെയിഞ്ച് നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു",
      thumb: "assets/img/Pastevents/529.jpg",
    },
    {
      src: "assets/img/Pastevents/505.jpg",
      caption:
        "ഡിവൈഎഫ്ഐ പാറമുക്ക് യൂണിറ്റും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ ഐ ബി സതീഷ്(എം എൽ എ).",
      thumb: "assets/img/Pastevents/505.jpg",
    },
    {
      src: "assets/img/Pastevents/506.jpg",
      caption:
        "ഡിവൈഎഫ്ഐ പാറമുക്ക് യൂണിറ്റും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ ഐ ബി സതീഷ്(എം എൽ എ).",
      thumb: "assets/img/Pastevents/506.jpg",
    },
    {
      src: "assets/img/Pastevents/507.jpg",
      caption:
        "ഡിവൈഎഫ്ഐ പാറമുക്ക് യൂണിറ്റും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ ഐ ബി സതീഷ്(എം എൽ എ).",
      thumb: "assets/img/Pastevents/507.jpg",
    },
    {
      src: "assets/img/Pastevents/508.jpg",
      caption:
        "ഡിവൈഎഫ്ഐ പാറമുക്ക് യൂണിറ്റും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ ഐ ബി സതീഷ്(എം എൽ എ).",
      thumb: "assets/img/Pastevents/508.jpg",
    },
    {
      src: "assets/img/Pastevents/509.jpg",
      caption:
        "ഡിവൈഎഫ്ഐ പാറമുക്ക് യൂണിറ്റും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ ഐ ബി സതീഷ്(എം എൽ എ).",
      thumb: "assets/img/Pastevents/509.jpg",
    },
    {
      src: "assets/img/Pastevents/510.jpg",
      caption:
        "ഡിവൈഎഫ്ഐ പാറമുക്ക് യൂണിറ്റും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ ഐ ബി സതീഷ്(എം എൽ എ).",
      thumb: "assets/img/Pastevents/510.jpg",
    },
    {
      src: "assets/img/Pastevents/511.jpg",
      caption:
        "ഡിവൈഎഫ്ഐ പാറമുക്ക് യൂണിറ്റും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ ഐ ബി സതീഷ്(എം എൽ എ).",
      thumb: "assets/img/Pastevents/511.jpg",
    },
    {
      src: "assets/img/Pastevents/512.jpg",
      caption:
        "ഡിവൈഎഫ്ഐ പാറമുക്ക് യൂണിറ്റും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ ഐ ബി സതീഷ്(എം എൽ എ).",
      thumb: "assets/img/Pastevents/512.jpg",
    },
    {
      src: "assets/img/Pastevents/513.jpg",
      caption:
        "ഡിവൈഎഫ്ഐ പാറമുക്ക് യൂണിറ്റും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ ഐ ബി സതീഷ്(എം എൽ എ).",
      thumb: "assets/img/Pastevents/513.jpg",
    },
    {
      src: "assets/img/Pastevents/514.jpg",
      caption:
        "ഡിവൈഎഫ്ഐ പാറമുക്ക് യൂണിറ്റും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ ഐ ബി സതീഷ്(എം എൽ എ).",
      thumb: "assets/img/Pastevents/514.jpg",
    },
    {
      src: "assets/img/Pastevents/515.jpg",
      caption:
        "ഡിവൈഎഫ്ഐ പാറമുക്ക് യൂണിറ്റും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ ഐ ബി സതീഷ്(എം എൽ എ).",
      thumb: "assets/img/Pastevents/515.jpg",
    },
    {
      src: "assets/img/Pastevents/516.jpg",
      caption:
        "ഡിവൈഎഫ്ഐ പാറമുക്ക് യൂണിറ്റും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ ഐ ബി സതീഷ്(എം എൽ എ).",
      thumb: "assets/img/Pastevents/516.jpg",
    },
    {
      src: "assets/img/Pastevents/517.jpg",
      caption:
        "ഡിവൈഎഫ്ഐ പാറമുക്ക് യൂണിറ്റും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ ഐ ബി സതീഷ്(എം എൽ എ).",
      thumb: "assets/img/Pastevents/517.jpg",
    },
    {
      src: "assets/img/Pastevents/518.jpg",
      caption:
        "ഡിവൈഎഫ്ഐ പാറമുക്ക് യൂണിറ്റും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ ഐ ബി സതീഷ്(എം എൽ എ).",
      thumb: "assets/img/Pastevents/518.jpg",
    },
    {
      src: "assets/img/Pastevents/519.jpg",
      caption:
        "ഡിവൈഎഫ്ഐ പാറമുക്ക് യൂണിറ്റും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ ഐ ബി സതീഷ്(എം എൽ എ).",
      thumb: "assets/img/Pastevents/519.jpg",
    },
    {
      src: "assets/img/Pastevents/520.jpg",
      caption:
        "ഡിവൈഎഫ്ഐ പാറമുക്ക് യൂണിറ്റും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ ഐ ബി സതീഷ്(എം എൽ എ).",
      thumb: "assets/img/Pastevents/520.jpg",
    },
    {
      src: "assets/img/Pastevents/493.jpg",
      caption:
        "കേരള കൗമുദി പാലോട് യൂണിറ്റും ബോധ പൗർണമി ക്ലബും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീമതി ജീ കോമളം ( വാമനപുരം ബ്ലോക്ക് പഞ്ചായത്ത് പ്രസിഡൻ്റ്)",
      thumb: "assets/img/Pastevents/493.jpg",
    },
    {
      src: "assets/img/Pastevents/494.jpg",
      caption:
        "കേരള കൗമുദി പാലോട് യൂണിറ്റും ബോധ പൗർണമി ക്ലബും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീമതി ജീ കോമളം ( വാമനപുരം ബ്ലോക്ക് പഞ്ചായത്ത് പ്രസിഡൻ്റ്)",
      thumb: "assets/img/Pastevents/494.jpg",
    },
    {
      src: "assets/img/Pastevents/495.jpg",
      caption:
        "കേരള കൗമുദി പാലോട് യൂണിറ്റും ബോധ പൗർണമി ക്ലബും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീമതി ജീ കോമളം ( വാമനപുരം ബ്ലോക്ക് പഞ്ചായത്ത് പ്രസിഡൻ്റ്)",
      thumb: "assets/img/Pastevents/495.jpg",
    },
    {
      src: "assets/img/Pastevents/496.jpg",
      caption:
        "കേരള കൗമുദി പാലോട് യൂണിറ്റും ബോധ പൗർണമി ക്ലബും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീമതി ജീ കോമളം ( വാമനപുരം ബ്ലോക്ക് പഞ്ചായത്ത് പ്രസിഡൻ്റ്)",
      thumb: "assets/img/Pastevents/496.jpg",
    },
    {
      src: "assets/img/Pastevents/497.jpg",
      caption:
        "കേരള കൗമുദി പാലോട് യൂണിറ്റും ബോധ പൗർണമി ക്ലബും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീമതി ജീ കോമളം ( വാമനപുരം ബ്ലോക്ക് പഞ്ചായത്ത് പ്രസിഡൻ്റ്)",
      thumb: "assets/img/Pastevents/497.jpg",
    },
    {
      src: "assets/img/Pastevents/498.jpg",
      caption:
        "കേരള കൗമുദി പാലോട് യൂണിറ്റും ബോധ പൗർണമി ക്ലബും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീമതി ജീ കോമളം ( വാമനപുരം ബ്ലോക്ക് പഞ്ചായത്ത് പ്രസിഡൻ്റ്)",
      thumb: "assets/img/Pastevents/498.jpg",
    },
    {
      src: "assets/img/Pastevents/499.jpg",
      caption:
        "കേരള കൗമുദി പാലോട് യൂണിറ്റും ബോധ പൗർണമി ക്ലബും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീമതി ജീ കോമളം ( വാമനപുരം ബ്ലോക്ക് പഞ്ചായത്ത് പ്രസിഡൻ്റ്)",
      thumb: "assets/img/Pastevents/499.jpg",
    },
    {
      src: "assets/img/Pastevents/500.jpg",
      caption:
        "കേരള കൗമുദി പാലോട് യൂണിറ്റും ബോധ പൗർണമി ക്ലബും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീമതി ജീ കോമളം ( വാമനപുരം ബ്ലോക്ക് പഞ്ചായത്ത് പ്രസിഡൻ്റ്)",
      thumb: "assets/img/Pastevents/500.jpg",
    },
    {
      src: "assets/img/Pastevents/501.jpg",
      caption:
        "കേരള കൗമുദി പാലോട് യൂണിറ്റും ബോധ പൗർണമി ക്ലബും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീമതി ജീ കോമളം ( വാമനപുരം ബ്ലോക്ക് പഞ്ചായത്ത് പ്രസിഡൻ്റ്)",
      thumb: "assets/img/Pastevents/501.jpg",
    },
    {
      src: "assets/img/Pastevents/502.jpg",
      caption:
        "കേരള കൗമുദി പാലോട് യൂണിറ്റും ബോധ പൗർണമി ക്ലബും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീമതി ജീ കോമളം ( വാമനപുരം ബ്ലോക്ക് പഞ്ചായത്ത് പ്രസിഡൻ്റ്)",
      thumb: "assets/img/Pastevents/502.jpg",
    },
    {
      src: "assets/img/Pastevents/503.jpg",
      caption:
        "കേരള കൗമുദി പാലോട് യൂണിറ്റും ബോധ പൗർണമി ക്ലബും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീമതി ജീ കോമളം ( വാമനപുരം ബ്ലോക്ക് പഞ്ചായത്ത് പ്രസിഡൻ്റ്)",
      thumb: "assets/img/Pastevents/503.jpg",
    },
    {
      src: "assets/img/Pastevents/504.jpg",
      caption:
        "കേരള കൗമുദി പാലോട് യൂണിറ്റും ബോധ പൗർണമി ക്ലബും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീമതി ജീ കോമളം ( വാമനപുരം ബ്ലോക്ക് പഞ്ചായത്ത് പ്രസിഡൻ്റ്)",
      thumb: "assets/img/Pastevents/504.jpg",
    },
    {
      src: "assets/img/Pastevents/483.jpg",
      caption:
        "പേരൂർക്കട ലയൺസ് ക്ലബ്ബും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ PMJF Lion ശിവകുമാർ.",
      thumb: "assets/img/Pastevents/483.jpg",
    },
    {
      src: "assets/img/Pastevents/484.jpg",
      caption:
        "പേരൂർക്കട ലയൺസ് ക്ലബ്ബും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ PMJF Lion ശിവകുമാർ.",
      thumb: "assets/img/Pastevents/484.jpg",
    },
    {
      src: "assets/img/Pastevents/485.jpg",
      caption:
        "പേരൂർക്കട ലയൺസ് ക്ലബ്ബും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ PMJF Lion ശിവകുമാർ.",
      thumb: "assets/img/Pastevents/485.jpg",
    },
    {
      src: "assets/img/Pastevents/486.jpg",
      caption:
        "പേരൂർക്കട ലയൺസ് ക്ലബ്ബും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ PMJF Lion ശിവകുമാർ.",
      thumb: "assets/img/Pastevents/486.jpg",
    },
    {
      src: "assets/img/Pastevents/487.jpg",
      caption:
        "പേരൂർക്കട ലയൺസ് ക്ലബ്ബും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ PMJF Lion ശിവകുമാർ.",
      thumb: "assets/img/Pastevents/487.jpg",
    },
    {
      src: "assets/img/Pastevents/488.jpg",
      caption:
        "പേരൂർക്കട ലയൺസ് ക്ലബ്ബും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ PMJF Lion ശിവകുമാർ.",
      thumb: "assets/img/Pastevents/488.jpg",
    },
    {
      src: "assets/img/Pastevents/489.jpg",
      caption:
        "പേരൂർക്കട ലയൺസ് ക്ലബ്ബും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ PMJF Lion ശിവകുമാർ.",
      thumb: "assets/img/Pastevents/489.jpg",
    },
    {
      src: "assets/img/Pastevents/490.jpg",
      caption:
        "പേരൂർക്കട ലയൺസ് ക്ലബ്ബും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ PMJF Lion ശിവകുമാർ.",
      thumb: "assets/img/Pastevents/490.jpg",
    },
    {
      src: "assets/img/Pastevents/491.jpg",
      caption:
        "പേരൂർക്കട ലയൺസ് ക്ലബ്ബും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ PMJF Lion ശിവകുമാർ.",
      thumb: "assets/img/Pastevents/491.jpg",
    },
    {
      src: "assets/img/Pastevents/492.jpg",
      caption:
        "പേരൂർക്കട ലയൺസ് ക്ലബ്ബും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ PMJF Lion ശിവകുമാർ.",
      thumb: "assets/img/Pastevents/492.jpg",
    },
    {
      src: "assets/img/Pastevents/471.jpg",
      caption:
        "ലോക പ്രമേഹ ദിനത്തോടനുബന്ധിച്ച്  നെയ്യാറ്റിൻകര നിംസ് മെഡിസിറ്റിയിൽ  സൗജന്യ പ്രമേഹ രോഗ നിർണ്ണയ ക്യാമ്പ് സംഘടിപ്പിച്ചു. പ്രശസ്ത എന്റോ ക്രൈനോളജിസ്റ്റ് ഡോക്ടർ വി.ശശികുമാറിന്റെ നേതൃത്വത്തിൽ നടന്ന  ക്യാമ്പിൽ 380ഓളം പേർ  പങ്കെടുത്തു.  ക്യാമ്പിൽ പങ്കെടുത്തവർക്ക് എച്ച് ബി എ വൺ സി  ,  സി ജി എം ( കണ്ടിന്യുയസ്  ഗ്ലൂക്കോസ്  മോനിറ്ററിങ് സിസ്റ്റം ),  വി പി ടി, യൂറിക്കാസിഡ് തുടങ്ങിയ ടെസ്റ്റുകൾ സൗജന്യമായിരുന്നു. തുടർ ചികിത്സ വേണ്ടവർക്ക്‌ എല്ലാ  ടെസ്റ്റുകൾക്കും  മുപ്പത് ശതമാനം ഡിസ്‌കൗണ്ട് ലഭ്യമാണ്.",
      thumb: "assets/img/Pastevents/471.jpg",
    },
    {
      src: "assets/img/Pastevents/472.jpg",
      caption:
        "ലോക പ്രമേഹ ദിനത്തോടനുബന്ധിച്ച്  നെയ്യാറ്റിൻകര നിംസ് മെഡിസിറ്റിയിൽ  സൗജന്യ പ്രമേഹ രോഗ നിർണ്ണയ ക്യാമ്പ് സംഘടിപ്പിച്ചു. പ്രശസ്ത എന്റോ ക്രൈനോളജിസ്റ്റ് ഡോക്ടർ വി.ശശികുമാറിന്റെ നേതൃത്വത്തിൽ നടന്ന  ക്യാമ്പിൽ 380ഓളം പേർ  പങ്കെടുത്തു.  ക്യാമ്പിൽ പങ്കെടുത്തവർക്ക് എച്ച് ബി എ വൺ സി  ,  സി ജി എം ( കണ്ടിന്യുയസ്  ഗ്ലൂക്കോസ്  മോനിറ്ററിങ് സിസ്റ്റം ),  വി പി ടി, യൂറിക്കാസിഡ് തുടങ്ങിയ ടെസ്റ്റുകൾ സൗജന്യമായിരുന്നു. തുടർ ചികിത്സ വേണ്ടവർക്ക്‌ എല്ലാ  ടെസ്റ്റുകൾക്കും  മുപ്പത് ശതമാനം ഡിസ്‌കൗണ്ട് ലഭ്യമാണ്.",
      thumb: "assets/img/Pastevents/472.jpg",
    },
    {
      src: "assets/img/Pastevents/473.jpg",
      caption:
        "ലോക പ്രമേഹ ദിനത്തോടനുബന്ധിച്ച്  നെയ്യാറ്റിൻകര നിംസ് മെഡിസിറ്റിയിൽ  സൗജന്യ പ്രമേഹ രോഗ നിർണ്ണയ ക്യാമ്പ് സംഘടിപ്പിച്ചു. പ്രശസ്ത എന്റോ ക്രൈനോളജിസ്റ്റ് ഡോക്ടർ വി.ശശികുമാറിന്റെ നേതൃത്വത്തിൽ നടന്ന  ക്യാമ്പിൽ 380ഓളം പേർ  പങ്കെടുത്തു.  ക്യാമ്പിൽ പങ്കെടുത്തവർക്ക് എച്ച് ബി എ വൺ സി  ,  സി ജി എം ( കണ്ടിന്യുയസ്  ഗ്ലൂക്കോസ്  മോനിറ്ററിങ് സിസ്റ്റം ),  വി പി ടി, യൂറിക്കാസിഡ് തുടങ്ങിയ ടെസ്റ്റുകൾ സൗജന്യമായിരുന്നു. തുടർ ചികിത്സ വേണ്ടവർക്ക്‌ എല്ലാ  ടെസ്റ്റുകൾക്കും  മുപ്പത് ശതമാനം ഡിസ്‌കൗണ്ട് ലഭ്യമാണ്.",
      thumb: "assets/img/Pastevents/473.jpg",
    },
    {
      src: "assets/img/Pastevents/474.jpg",
      caption:
        "ലോക പ്രമേഹ ദിനത്തോടനുബന്ധിച്ച്  നെയ്യാറ്റിൻകര നിംസ് മെഡിസിറ്റിയിൽ  സൗജന്യ പ്രമേഹ രോഗ നിർണ്ണയ ക്യാമ്പ് സംഘടിപ്പിച്ചു. പ്രശസ്ത എന്റോ ക്രൈനോളജിസ്റ്റ് ഡോക്ടർ വി.ശശികുമാറിന്റെ നേതൃത്വത്തിൽ നടന്ന  ക്യാമ്പിൽ 380ഓളം പേർ  പങ്കെടുത്തു.  ക്യാമ്പിൽ പങ്കെടുത്തവർക്ക് എച്ച് ബി എ വൺ സി  ,  സി ജി എം ( കണ്ടിന്യുയസ്  ഗ്ലൂക്കോസ്  മോനിറ്ററിങ് സിസ്റ്റം ),  വി പി ടി, യൂറിക്കാസിഡ് തുടങ്ങിയ ടെസ്റ്റുകൾ സൗജന്യമായിരുന്നു. തുടർ ചികിത്സ വേണ്ടവർക്ക്‌ എല്ലാ  ടെസ്റ്റുകൾക്കും  മുപ്പത് ശതമാനം ഡിസ്‌കൗണ്ട് ലഭ്യമാണ്.",
      thumb: "assets/img/Pastevents/474.jpg",
    },
    {
      src: "assets/img/Pastevents/475.jpg",
      caption:
        "ലോക പ്രമേഹ ദിനത്തോടനുബന്ധിച്ച്  നെയ്യാറ്റിൻകര നിംസ് മെഡിസിറ്റിയിൽ  സൗജന്യ പ്രമേഹ രോഗ നിർണ്ണയ ക്യാമ്പ് സംഘടിപ്പിച്ചു. പ്രശസ്ത എന്റോ ക്രൈനോളജിസ്റ്റ് ഡോക്ടർ വി.ശശികുമാറിന്റെ നേതൃത്വത്തിൽ നടന്ന  ക്യാമ്പിൽ 380ഓളം പേർ  പങ്കെടുത്തു.  ക്യാമ്പിൽ പങ്കെടുത്തവർക്ക് എച്ച് ബി എ വൺ സി  ,  സി ജി എം ( കണ്ടിന്യുയസ്  ഗ്ലൂക്കോസ്  മോനിറ്ററിങ് സിസ്റ്റം ),  വി പി ടി, യൂറിക്കാസിഡ് തുടങ്ങിയ ടെസ്റ്റുകൾ സൗജന്യമായിരുന്നു. തുടർ ചികിത്സ വേണ്ടവർക്ക്‌ എല്ലാ  ടെസ്റ്റുകൾക്കും  മുപ്പത് ശതമാനം ഡിസ്‌കൗണ്ട് ലഭ്യമാണ്.",
      thumb: "assets/img/Pastevents/475.jpg",
    },
    {
      src: "assets/img/Pastevents/476.jpg",
      caption:
        "ലോക പ്രമേഹ ദിനത്തോടനുബന്ധിച്ച്  നെയ്യാറ്റിൻകര നിംസ് മെഡിസിറ്റിയിൽ  സൗജന്യ പ്രമേഹ രോഗ നിർണ്ണയ ക്യാമ്പ് സംഘടിപ്പിച്ചു. പ്രശസ്ത എന്റോ ക്രൈനോളജിസ്റ്റ് ഡോക്ടർ വി.ശശികുമാറിന്റെ നേതൃത്വത്തിൽ നടന്ന  ക്യാമ്പിൽ 380ഓളം പേർ  പങ്കെടുത്തു.  ക്യാമ്പിൽ പങ്കെടുത്തവർക്ക് എച്ച് ബി എ വൺ സി  ,  സി ജി എം ( കണ്ടിന്യുയസ്  ഗ്ലൂക്കോസ്  മോനിറ്ററിങ് സിസ്റ്റം ),  വി പി ടി, യൂറിക്കാസിഡ് തുടങ്ങിയ ടെസ്റ്റുകൾ സൗജന്യമായിരുന്നു. തുടർ ചികിത്സ വേണ്ടവർക്ക്‌ എല്ലാ  ടെസ്റ്റുകൾക്കും  മുപ്പത് ശതമാനം ഡിസ്‌കൗണ്ട് ലഭ്യമാണ്.",
      thumb: "assets/img/Pastevents/476.jpg",
    },
    {
      src: "assets/img/Pastevents/477.jpg",
      caption:
        "ലോക പ്രമേഹ ദിനത്തോടനുബന്ധിച്ച്  നെയ്യാറ്റിൻകര നിംസ് മെഡിസിറ്റിയിൽ  സൗജന്യ പ്രമേഹ രോഗ നിർണ്ണയ ക്യാമ്പ് സംഘടിപ്പിച്ചു. പ്രശസ്ത എന്റോ ക്രൈനോളജിസ്റ്റ് ഡോക്ടർ വി.ശശികുമാറിന്റെ നേതൃത്വത്തിൽ നടന്ന  ക്യാമ്പിൽ 380ഓളം പേർ  പങ്കെടുത്തു.  ക്യാമ്പിൽ പങ്കെടുത്തവർക്ക് എച്ച് ബി എ വൺ സി  ,  സി ജി എം ( കണ്ടിന്യുയസ്  ഗ്ലൂക്കോസ്  മോനിറ്ററിങ് സിസ്റ്റം ),  വി പി ടി, യൂറിക്കാസിഡ് തുടങ്ങിയ ടെസ്റ്റുകൾ സൗജന്യമായിരുന്നു. തുടർ ചികിത്സ വേണ്ടവർക്ക്‌ എല്ലാ  ടെസ്റ്റുകൾക്കും  മുപ്പത് ശതമാനം ഡിസ്‌കൗണ്ട് ലഭ്യമാണ്.",
      thumb: "assets/img/Pastevents/477.jpg",
    },
    {
      src: "assets/img/Pastevents/478.jpg",
      caption:
        "ലോക പ്രമേഹ ദിനത്തോടനുബന്ധിച്ച്  നെയ്യാറ്റിൻകര നിംസ് മെഡിസിറ്റിയിൽ  സൗജന്യ പ്രമേഹ രോഗ നിർണ്ണയ ക്യാമ്പ് സംഘടിപ്പിച്ചു. പ്രശസ്ത എന്റോ ക്രൈനോളജിസ്റ്റ് ഡോക്ടർ വി.ശശികുമാറിന്റെ നേതൃത്വത്തിൽ നടന്ന  ക്യാമ്പിൽ 380ഓളം പേർ  പങ്കെടുത്തു.  ക്യാമ്പിൽ പങ്കെടുത്തവർക്ക് എച്ച് ബി എ വൺ സി  ,  സി ജി എം ( കണ്ടിന്യുയസ്  ഗ്ലൂക്കോസ്  മോനിറ്ററിങ് സിസ്റ്റം ),  വി പി ടി, യൂറിക്കാസിഡ് തുടങ്ങിയ ടെസ്റ്റുകൾ സൗജന്യമായിരുന്നു. തുടർ ചികിത്സ വേണ്ടവർക്ക്‌ എല്ലാ  ടെസ്റ്റുകൾക്കും  മുപ്പത് ശതമാനം ഡിസ്‌കൗണ്ട് ലഭ്യമാണ്.",
      thumb: "assets/img/Pastevents/478.jpg",
    },
    {
      src: "assets/img/Pastevents/479.jpg",
      caption:
        "ലോക പ്രമേഹ ദിനത്തോടനുബന്ധിച്ച്  നെയ്യാറ്റിൻകര നിംസ് മെഡിസിറ്റിയിൽ  സൗജന്യ പ്രമേഹ രോഗ നിർണ്ണയ ക്യാമ്പ് സംഘടിപ്പിച്ചു. പ്രശസ്ത എന്റോ ക്രൈനോളജിസ്റ്റ് ഡോക്ടർ വി.ശശികുമാറിന്റെ നേതൃത്വത്തിൽ നടന്ന  ക്യാമ്പിൽ 380ഓളം പേർ  പങ്കെടുത്തു.  ക്യാമ്പിൽ പങ്കെടുത്തവർക്ക് എച്ച് ബി എ വൺ സി  ,  സി ജി എം ( കണ്ടിന്യുയസ്  ഗ്ലൂക്കോസ്  മോനിറ്ററിങ് സിസ്റ്റം ),  വി പി ടി, യൂറിക്കാസിഡ് തുടങ്ങിയ ടെസ്റ്റുകൾ സൗജന്യമായിരുന്നു. തുടർ ചികിത്സ വേണ്ടവർക്ക്‌ എല്ലാ  ടെസ്റ്റുകൾക്കും  മുപ്പത് ശതമാനം ഡിസ്‌കൗണ്ട് ലഭ്യമാണ്.",
      thumb: "assets/img/Pastevents/479.jpg",
    },
    {
      src: "assets/img/Pastevents/480.jpg",
      caption:
        "ലോക പ്രമേഹ ദിനത്തോടനുബന്ധിച്ച്  നെയ്യാറ്റിൻകര നിംസ് മെഡിസിറ്റിയിൽ  സൗജന്യ പ്രമേഹ രോഗ നിർണ്ണയ ക്യാമ്പ് സംഘടിപ്പിച്ചു. പ്രശസ്ത എന്റോ ക്രൈനോളജിസ്റ്റ് ഡോക്ടർ വി.ശശികുമാറിന്റെ നേതൃത്വത്തിൽ നടന്ന  ക്യാമ്പിൽ 380ഓളം പേർ  പങ്കെടുത്തു.  ക്യാമ്പിൽ പങ്കെടുത്തവർക്ക് എച്ച് ബി എ വൺ സി  ,  സി ജി എം ( കണ്ടിന്യുയസ്  ഗ്ലൂക്കോസ്  മോനിറ്ററിങ് സിസ്റ്റം ),  വി പി ടി, യൂറിക്കാസിഡ് തുടങ്ങിയ ടെസ്റ്റുകൾ സൗജന്യമായിരുന്നു. തുടർ ചികിത്സ വേണ്ടവർക്ക്‌ എല്ലാ  ടെസ്റ്റുകൾക്കും  മുപ്പത് ശതമാനം ഡിസ്‌കൗണ്ട് ലഭ്യമാണ്.",
      thumb: "assets/img/Pastevents/480.jpg",
    },
    {
      src: "assets/img/Pastevents/481.jpg",
      caption:
        "ലോക പ്രമേഹ ദിനത്തോടനുബന്ധിച്ച്  നെയ്യാറ്റിൻകര നിംസ് മെഡിസിറ്റിയിൽ  സൗജന്യ പ്രമേഹ രോഗ നിർണ്ണയ ക്യാമ്പ് സംഘടിപ്പിച്ചു. പ്രശസ്ത എന്റോ ക്രൈനോളജിസ്റ്റ് ഡോക്ടർ വി.ശശികുമാറിന്റെ നേതൃത്വത്തിൽ നടന്ന  ക്യാമ്പിൽ 380ഓളം പേർ  പങ്കെടുത്തു.  ക്യാമ്പിൽ പങ്കെടുത്തവർക്ക് എച്ച് ബി എ വൺ സി  ,  സി ജി എം ( കണ്ടിന്യുയസ്  ഗ്ലൂക്കോസ്  മോനിറ്ററിങ് സിസ്റ്റം ),  വി പി ടി, യൂറിക്കാസിഡ് തുടങ്ങിയ ടെസ്റ്റുകൾ സൗജന്യമായിരുന്നു. തുടർ ചികിത്സ വേണ്ടവർക്ക്‌ എല്ലാ  ടെസ്റ്റുകൾക്കും  മുപ്പത് ശതമാനം ഡിസ്‌കൗണ്ട് ലഭ്യമാണ്.",
      thumb: "assets/img/Pastevents/481.jpg",
    },

    {
      src: "assets/img/Pastevents/482.jpg",
      caption:
        "ലോക പ്രമേഹ ദിനത്തോടനുബന്ധിച്ച്  നെയ്യാറ്റിൻകര നിംസ് മെഡിസിറ്റിയിൽ  സൗജന്യ പ്രമേഹ രോഗ നിർണ്ണയ ക്യാമ്പ് സംഘടിപ്പിച്ചു. പ്രശസ്ത എന്റോ ക്രൈനോളജിസ്റ്റ് ഡോക്ടർ വി.ശശികുമാറിന്റെ നേതൃത്വത്തിൽ നടന്ന  ക്യാമ്പിൽ 380ഓളം പേർ  പങ്കെടുത്തു.  ക്യാമ്പിൽ പങ്കെടുത്തവർക്ക് എച്ച് ബി എ വൺ സി  ,  സി ജി എം ( കണ്ടിന്യുയസ്  ഗ്ലൂക്കോസ്  മോനിറ്ററിങ് സിസ്റ്റം ),  വി പി ടി, യൂറിക്കാസിഡ് തുടങ്ങിയ ടെസ്റ്റുകൾ സൗജന്യമായിരുന്നു. തുടർ ചികിത്സ വേണ്ടവർക്ക്‌ എല്ലാ  ടെസ്റ്റുകൾക്കും  മുപ്പത് ശതമാനം ഡിസ്‌കൗണ്ട് ലഭ്യമാണ്.",
      thumb: "assets/img/Pastevents/482.jpg",
    },
    {
      src: "assets/img/Pastevents/458.jpg",
      caption:
        "ലോക പ്രമേഹ ദിനത്തോനനുബന്ധിച്ചു തിരു. ഇമ്പാക്ട് ലയൺസ് ക്ലബും വെള്ളനാട് യൂണിറ്റിന്റെയും KSRTC വെള്ളനാട് ഡിപ്പോ KSRTEA(CITU) നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ പ്രമേഹ നിർണയ ക്യാമ്പ് സംഘടിപ്പിച്ചു.അധ്യക്ഷൻ : ലയൺ എം. സുരേഷ്കുമാർ ( പ്രസിഡന്റ്‌ തിരു. ഇമ്പാക്ട് LC) സ്വാഗതം : ശ്രീ. G. R. പ്രഭു (KSRTEA) ഉദ്ഘാടനം : ശ്രീ. സുജിത് സോമൻ ( സംസ്ഥാന സെക്രട്ടറി - KSRTEA) ആശംസകൾ : ശ്രീ. S. ജിനു കുമാർ - KSRTEA പ്രമേഹ ദിന സന്ദേശം : DR. സ്റ്റീഫൻ ( നിംസ് മെഡിസിറ്റി )",
      thumb: "assets/img/Pastevents/458.jpg",
    },
    {
      src: "assets/img/Pastevents/459.jpg",
      caption:
        "ലോക പ്രമേഹ ദിനത്തോനനുബന്ധിച്ചു തിരു. ഇമ്പാക്ട് ലയൺസ് ക്ലബും വെള്ളനാട് യൂണിറ്റിന്റെയും KSRTC വെള്ളനാട് ഡിപ്പോ KSRTEA(CITU) നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ പ്രമേഹ നിർണയ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/459.jpg",
    },
    {
      src: "assets/img/Pastevents/460.jpg",
      caption:
        "ലോക പ്രമേഹ ദിനത്തോനനുബന്ധിച്ചു തിരു. ഇമ്പാക്ട് ലയൺസ് ക്ലബും വെള്ളനാട് യൂണിറ്റിന്റെയും KSRTC വെള്ളനാട് ഡിപ്പോ KSRTEA(CITU) നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ പ്രമേഹ നിർണയ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/460.jpg",
    },
    {
      src: "assets/img/Pastevents/461.jpg",
      caption:
        "ലോക പ്രമേഹ ദിനത്തോനനുബന്ധിച്ചു തിരു. ഇമ്പാക്ട് ലയൺസ് ക്ലബും വെള്ളനാട് യൂണിറ്റിന്റെയും KSRTC വെള്ളനാട് ഡിപ്പോ KSRTEA(CITU) നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ പ്രമേഹ നിർണയ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/461.jpg",
    },
    {
      src: "assets/img/Pastevents/462.jpg",
      caption:
        "ലോക പ്രമേഹ ദിനത്തോനനുബന്ധിച്ചു തിരു. ഇമ്പാക്ട് ലയൺസ് ക്ലബും വെള്ളനാട് യൂണിറ്റിന്റെയും KSRTC വെള്ളനാട് ഡിപ്പോ KSRTEA(CITU) നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ പ്രമേഹ നിർണയ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/462.jpg",
    },
    {
      src: "assets/img/Pastevents/463.jpg",
      caption:
        "ലോക പ്രമേഹ ദിനത്തോനനുബന്ധിച്ചു തിരു. ഇമ്പാക്ട് ലയൺസ് ക്ലബും വെള്ളനാട് യൂണിറ്റിന്റെയും KSRTC വെള്ളനാട് ഡിപ്പോ KSRTEA(CITU) നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ പ്രമേഹ നിർണയ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/463.jpg",
    },
    {
      src: "assets/img/Pastevents/464.jpg",
      caption:
        "ലോക പ്രമേഹ ദിനത്തോനനുബന്ധിച്ചു തിരു. ഇമ്പാക്ട് ലയൺസ് ക്ലബും വെള്ളനാട് യൂണിറ്റിന്റെയും KSRTC വെള്ളനാട് ഡിപ്പോ KSRTEA(CITU) നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ പ്രമേഹ നിർണയ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/464.jpg",
    },
    {
      src: "assets/img/Pastevents/465.jpg",
      caption:
        "ലോക പ്രമേഹ ദിനത്തോനനുബന്ധിച്ചു തിരു. ഇമ്പാക്ട് ലയൺസ് ക്ലബും വെള്ളനാട് യൂണിറ്റിന്റെയും KSRTC വെള്ളനാട് ഡിപ്പോ KSRTEA(CITU) നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ പ്രമേഹ നിർണയ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/465.jpg",
    },
    {
      src: "assets/img/Pastevents/466.jpg",
      caption:
        "ലോക പ്രമേഹ ദിനത്തോനനുബന്ധിച്ചു തിരു. ഇമ്പാക്ട് ലയൺസ് ക്ലബും വെള്ളനാട് യൂണിറ്റിന്റെയും KSRTC വെള്ളനാട് ഡിപ്പോ KSRTEA(CITU) നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ പ്രമേഹ നിർണയ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/466.jpg",
    },
    {
      src: "assets/img/Pastevents/467.jpg",
      caption:
        "ലോക പ്രമേഹ ദിനത്തോനനുബന്ധിച്ചു തിരു. ഇമ്പാക്ട് ലയൺസ് ക്ലബും വെള്ളനാട് യൂണിറ്റിന്റെയും KSRTC വെള്ളനാട് ഡിപ്പോ KSRTEA(CITU) നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ പ്രമേഹ നിർണയ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/467.jpg",
    },
    {
      src: "assets/img/Pastevents/468.jpg",
      caption:
        "ലോക പ്രമേഹ ദിനത്തോനനുബന്ധിച്ചു തിരു. ഇമ്പാക്ട് ലയൺസ് ക്ലബും വെള്ളനാട് യൂണിറ്റിന്റെയും KSRTC വെള്ളനാട് ഡിപ്പോ KSRTEA(CITU) നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ പ്രമേഹ നിർണയ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/468.jpg",
    },
    {
      src: "assets/img/Pastevents/469.jpg",
      caption:
        "ലോക പ്രമേഹ ദിനത്തോനനുബന്ധിച്ചു തിരു. ഇമ്പാക്ട് ലയൺസ് ക്ലബും വെള്ളനാട് യൂണിറ്റിന്റെയും KSRTC വെള്ളനാട് ഡിപ്പോ KSRTEA(CITU) നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ പ്രമേഹ നിർണയ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/469.jpg",
    },
    {
      src: "assets/img/Pastevents/470.jpg",
      caption:
        "ലോക പ്രമേഹ ദിനത്തോനനുബന്ധിച്ചു തിരു. ഇമ്പാക്ട് ലയൺസ് ക്ലബും വെള്ളനാട് യൂണിറ്റിന്റെയും KSRTC വെള്ളനാട് ഡിപ്പോ KSRTEA(CITU) നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ പ്രമേഹ നിർണയ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/470.jpg",
    },
    {
      src: "assets/img/Pastevents/443.jpg",
      caption:
        "കേരള കൗമുദി പാലോട് യൂണിറ്റും ബോധ പൗർണമി ക്ലബും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീമതി ശൈലജ രാജീവൻ (പ്രസിഡൻ്റ് നന്ദിയോട് ഗ്രാമപഞ്ചായത്ത്)",
      thumb: "assets/img/Pastevents/443.jpg",
    },
    {
      src: "assets/img/Pastevents/444.jpg",
      caption:
        "കേരള കൗമുദി പാലോട് യൂണിറ്റും ബോധ പൗർണമി ക്ലബും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീമതി ശൈലജ രാജീവൻ (പ്രസിഡൻ്റ് നന്ദിയോട് ഗ്രാമപഞ്ചായത്ത്)",
      thumb: "assets/img/Pastevents/444.jpg",
    },
    {
      src: "assets/img/Pastevents/445.jpg",
      caption:
        "കേരള കൗമുദി പാലോട് യൂണിറ്റും ബോധ പൗർണമി ക്ലബും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീമതി ശൈലജ രാജീവൻ (പ്രസിഡൻ്റ് നന്ദിയോട് ഗ്രാമപഞ്ചായത്ത്)",
      thumb: "assets/img/Pastevents/445.jpg",
    },
    {
      src: "assets/img/Pastevents/446.jpg",
      caption:
        "കേരള കൗമുദി പാലോട് യൂണിറ്റും ബോധ പൗർണമി ക്ലബും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീമതി ശൈലജ രാജീവൻ (പ്രസിഡൻ്റ് നന്ദിയോട് ഗ്രാമപഞ്ചായത്ത്)",
      thumb: "assets/img/Pastevents/446.jpg",
    },
    {
      src: "assets/img/Pastevents/447.jpg",
      caption:
        "കേരള കൗമുദി പാലോട് യൂണിറ്റും ബോധ പൗർണമി ക്ലബും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീമതി ശൈലജ രാജീവൻ (പ്രസിഡൻ്റ് നന്ദിയോട് ഗ്രാമപഞ്ചായത്ത്)",
      thumb: "assets/img/Pastevents/447.jpg",
    },
    {
      src: "assets/img/Pastevents/448.jpg",
      caption:
        "കേരള കൗമുദി പാലോട് യൂണിറ്റും ബോധ പൗർണമി ക്ലബും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീമതി ശൈലജ രാജീവൻ (പ്രസിഡൻ്റ് നന്ദിയോട് ഗ്രാമപഞ്ചായത്ത്)",
      thumb: "assets/img/Pastevents/448.jpg",
    },
    {
      src: "assets/img/Pastevents/449.jpg",
      caption:
        "കേരള കൗമുദി പാലോട് യൂണിറ്റും ബോധ പൗർണമി ക്ലബും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീമതി ശൈലജ രാജീവൻ (പ്രസിഡൻ്റ് നന്ദിയോട് ഗ്രാമപഞ്ചായത്ത്)",
      thumb: "assets/img/Pastevents/449.jpg",
    },
    {
      src: "assets/img/Pastevents/450.jpg",
      caption:
        "കേരള കൗമുദി പാലോട് യൂണിറ്റും ബോധ പൗർണമി ക്ലബും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീമതി ശൈലജ രാജീവൻ (പ്രസിഡൻ്റ് നന്ദിയോട് ഗ്രാമപഞ്ചായത്ത്)",
      thumb: "assets/img/Pastevents/450.jpg",
    },
    {
      src: "assets/img/Pastevents/451.jpg",
      caption:
        "കേരള കൗമുദി പാലോട് യൂണിറ്റും ബോധ പൗർണമി ക്ലബും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീമതി ശൈലജ രാജീവൻ (പ്രസിഡൻ്റ് നന്ദിയോട് ഗ്രാമപഞ്ചായത്ത്)",
      thumb: "assets/img/Pastevents/451.jpg",
    },
    {
      src: "assets/img/Pastevents/452.jpg",
      caption:
        "കേരള കൗമുദി പാലോട് യൂണിറ്റും ബോധ പൗർണമി ക്ലബും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീമതി ശൈലജ രാജീവൻ (പ്രസിഡൻ്റ് നന്ദിയോട് ഗ്രാമപഞ്ചായത്ത്)",
      thumb: "assets/img/Pastevents/452.jpg",
    },
    {
      src: "assets/img/Pastevents/453.jpg",
      caption:
        "കേരള കൗമുദി പാലോട് യൂണിറ്റും ബോധ പൗർണമി ക്ലബും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീമതി ശൈലജ രാജീവൻ (പ്രസിഡൻ്റ് നന്ദിയോട് ഗ്രാമപഞ്ചായത്ത്)",
      thumb: "assets/img/Pastevents/453.jpg",
    },
    {
      src: "assets/img/Pastevents/454.jpg",
      caption:
        "കേരള കൗമുദി പാലോട് യൂണിറ്റും ബോധ പൗർണമി ക്ലബും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീമതി ശൈലജ രാജീവൻ (പ്രസിഡൻ്റ് നന്ദിയോട് ഗ്രാമപഞ്ചായത്ത്)",
      thumb: "assets/img/Pastevents/454.jpg",
    },
    {
      src: "assets/img/Pastevents/455.jpg",
      caption:
        "കേരള കൗമുദി പാലോട് യൂണിറ്റും ബോധ പൗർണമി ക്ലബും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീമതി ശൈലജ രാജീവൻ (പ്രസിഡൻ്റ് നന്ദിയോട് ഗ്രാമപഞ്ചായത്ത്)",
      thumb: "assets/img/Pastevents/455.jpg",
    },
    {
      src: "assets/img/Pastevents/456.jpg",
      caption:
        "കേരള കൗമുദി പാലോട് യൂണിറ്റും ബോധ പൗർണമി ക്ലബും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീമതി ശൈലജ രാജീവൻ (പ്രസിഡൻ്റ് നന്ദിയോട് ഗ്രാമപഞ്ചായത്ത്)",
      thumb: "assets/img/Pastevents/456.jpg",
    },
    {
      src: "assets/img/Pastevents/457.jpg",
      caption:
        "കേരള കൗമുദി പാലോട് യൂണിറ്റും ബോധ പൗർണമി ക്ലബും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീമതി ശൈലജ രാജീവൻ (പ്രസിഡൻ്റ് നന്ദിയോട് ഗ്രാമപഞ്ചായത്ത്)",
      thumb: "assets/img/Pastevents/457.jpg",
    },
    {
      src: "assets/img/Pastevents/432.jpg",
      caption:
        "കേരള കൗമുദി പാലോട് യൂണിറ്റും ബോധ പൗർണമി ക്ലബും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ ഷിനു മടത്തറ (പ്രസിഡന്റ് പെരിങ്ങമ്മല ഗ്രാമപഞ്ചായത്ത്).",
      thumb: "assets/img/Pastevents/432.jpg",
    },
    {
      src: "assets/img/Pastevents/433.jpg",
      caption:
        "കേരള കൗമുദി പാലോട് യൂണിറ്റും ബോധ പൗർണമി ക്ലബും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ ഷിനു മടത്തറ (പ്രസിഡന്റ് പെരിങ്ങമ്മല ഗ്രാമപഞ്ചായത്ത്).",
      thumb: "assets/img/Pastevents/433.jpg",
    },
    {
      src: "assets/img/Pastevents/434.jpg",
      caption:
        "കേരള കൗമുദി പാലോട് യൂണിറ്റും ബോധ പൗർണമി ക്ലബും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ ഷിനു മടത്തറ (പ്രസിഡന്റ് പെരിങ്ങമ്മല ഗ്രാമപഞ്ചായത്ത്).",
      thumb: "assets/img/Pastevents/434.jpg",
    },
    {
      src: "assets/img/Pastevents/435.jpg",
      caption:
        "കേരള കൗമുദി പാലോട് യൂണിറ്റും ബോധ പൗർണമി ക്ലബും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ ഷിനു മടത്തറ (പ്രസിഡന്റ് പെരിങ്ങമ്മല ഗ്രാമപഞ്ചായത്ത്).",
      thumb: "assets/img/Pastevents/435.jpg",
    },
    {
      src: "assets/img/Pastevents/436.jpg",
      caption:
        "കേരള കൗമുദി പാലോട് യൂണിറ്റും ബോധ പൗർണമി ക്ലബും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ ഷിനു മടത്തറ (പ്രസിഡന്റ് പെരിങ്ങമ്മല ഗ്രാമപഞ്ചായത്ത്).",
      thumb: "assets/img/Pastevents/436.jpg",
    },
    {
      src: "assets/img/Pastevents/437.jpg",
      caption:
        "കേരള കൗമുദി പാലോട് യൂണിറ്റും ബോധ പൗർണമി ക്ലബും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ ഷിനു മടത്തറ (പ്രസിഡന്റ് പെരിങ്ങമ്മല ഗ്രാമപഞ്ചായത്ത്).",
      thumb: "assets/img/Pastevents/437.jpg",
    },
    {
      src: "assets/img/Pastevents/438.jpg",
      caption:
        "കേരള കൗമുദി പാലോട് യൂണിറ്റും ബോധ പൗർണമി ക്ലബും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ ഷിനു മടത്തറ (പ്രസിഡന്റ് പെരിങ്ങമ്മല ഗ്രാമപഞ്ചായത്ത്).",
      thumb: "assets/img/Pastevents/438.jpg",
    },
    {
      src: "assets/img/Pastevents/439.jpg",
      caption:
        "കേരള കൗമുദി പാലോട് യൂണിറ്റും ബോധ പൗർണമി ക്ലബും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ ഷിനു മടത്തറ (പ്രസിഡന്റ് പെരിങ്ങമ്മല ഗ്രാമപഞ്ചായത്ത്).",
      thumb: "assets/img/Pastevents/439.jpg",
    },
    {
      src: "assets/img/Pastevents/440.jpg",
      caption:
        "കേരള കൗമുദി പാലോട് യൂണിറ്റും ബോധ പൗർണമി ക്ലബും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ ഷിനു മടത്തറ (പ്രസിഡന്റ് പെരിങ്ങമ്മല ഗ്രാമപഞ്ചായത്ത്).",
      thumb: "assets/img/Pastevents/440.jpg",
    },
    {
      src: "assets/img/Pastevents/441.jpg",
      caption:
        "കേരള കൗമുദി പാലോട് യൂണിറ്റും ബോധ പൗർണമി ക്ലബും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ ഷിനു മടത്തറ (പ്രസിഡന്റ് പെരിങ്ങമ്മല ഗ്രാമപഞ്ചായത്ത്).",
      thumb: "assets/img/Pastevents/441.jpg",
    },
    {
      src: "assets/img/Pastevents/442.jpg",
      caption:
        "കേരള കൗമുദി പാലോട് യൂണിറ്റും ബോധ പൗർണമി ക്ലബും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ ഷിനു മടത്തറ (പ്രസിഡന്റ് പെരിങ്ങമ്മല ഗ്രാമപഞ്ചായത്ത്).",
      thumb: "assets/img/Pastevents/442.jpg",
    },

    {
      src: "assets/img/Pastevents/424.jpg",
      caption:
        " ദിയ ഇൻഡസ്ട്രിസ് ലിമിറ്റഡിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു",
      thumb: "assets/img/Pastevents/424.jpg",
    },
    {
      src: "assets/img/Pastevents/425.jpg",
      caption:
        " ദിയ ഇൻഡസ്ട്രിസ് ലിമിറ്റഡിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു",
      thumb: "assets/img/Pastevents/425.jpg",
    },
    {
      src: "assets/img/Pastevents/426.jpg",
      caption:
        " ദിയ ഇൻഡസ്ട്രിസ് ലിമിറ്റഡിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു",
      thumb: "assets/img/Pastevents/426.jpg",
    },
    {
      src: "assets/img/Pastevents/427.jpg",
      caption:
        " ദിയ ഇൻഡസ്ട്രിസ് ലിമിറ്റഡിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു",
      thumb: "assets/img/Pastevents/427.jpg",
    },
    {
      src: "assets/img/Pastevents/428.jpg",
      caption:
        " ദിയ ഇൻഡസ്ട്രിസ് ലിമിറ്റഡിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു",
      thumb: "assets/img/Pastevents/428.jpg",
    },
    {
      src: "assets/img/Pastevents/429.jpg",
      caption:
        " ദിയ ഇൻഡസ്ട്രിസ് ലിമിറ്റഡിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു",
      thumb: "assets/img/Pastevents/429.jpg",
    },
    {
      src: "assets/img/Pastevents/430.jpg",
      caption:
        " ദിയ ഇൻഡസ്ട്രിസ് ലിമിറ്റഡിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു",
      thumb: "assets/img/Pastevents/430.jpg",
    },
    {
      src: "assets/img/Pastevents/431.jpg",
      caption:
        " ദിയ ഇൻഡസ്ട്രിസ് ലിമിറ്റഡിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു",
      thumb: "assets/img/Pastevents/431.jpg",
    },
    {
      src: "assets/img/Pastevents/413.jpg",
      caption:
        "തിരുവനന്തപുരം മിഡ്ഠൗൺ ലയൺസ് ക്ലബ്ബും ചിറ്റാഴ റസിഡന്റ് അസോസിയേഷനും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീമതി ലേഖറാണി(കരകുളം ഗ്രാമപഞ്ചായത്ത് പ്രസിഡൻ്റ്).",
      thumb: "assets/img/Pastevents/413.jpg",
    },
    {
      src: "assets/img/Pastevents/414.jpg",
      caption:
        "തിരുവനന്തപുരം മിഡ്ഠൗൺ ലയൺസ് ക്ലബ്ബും ചിറ്റാഴ റസിഡന്റ് അസോസിയേഷനും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീമതി ലേഖറാണി(കരകുളം ഗ്രാമപഞ്ചായത്ത് പ്രസിഡൻ്റ്).",
      thumb: "assets/img/Pastevents/414.jpg",
    },
    {
      src: "assets/img/Pastevents/415.jpg",
      caption:
        "തിരുവനന്തപുരം മിഡ്ഠൗൺ ലയൺസ് ക്ലബ്ബും ചിറ്റാഴ റസിഡന്റ് അസോസിയേഷനും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീമതി ലേഖറാണി(കരകുളം ഗ്രാമപഞ്ചായത്ത് പ്രസിഡൻ്റ്).",
      thumb: "assets/img/Pastevents/415.jpg",
    },
    {
      src: "assets/img/Pastevents/416.jpg",
      caption:
        "തിരുവനന്തപുരം മിഡ്ഠൗൺ ലയൺസ് ക്ലബ്ബും ചിറ്റാഴ റസിഡന്റ് അസോസിയേഷനും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീമതി ലേഖറാണി(കരകുളം ഗ്രാമപഞ്ചായത്ത് പ്രസിഡൻ്റ്).",
      thumb: "assets/img/Pastevents/416.jpg",
    },
    {
      src: "assets/img/Pastevents/417.jpg",
      caption:
        "തിരുവനന്തപുരം മിഡ്ഠൗൺ ലയൺസ് ക്ലബ്ബും ചിറ്റാഴ റസിഡന്റ് അസോസിയേഷനും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീമതി ലേഖറാണി(കരകുളം ഗ്രാമപഞ്ചായത്ത് പ്രസിഡൻ്റ്).",
      thumb: "assets/img/Pastevents/417.jpg",
    },
    {
      src: "assets/img/Pastevents/418.jpg",
      caption:
        "തിരുവനന്തപുരം മിഡ്ഠൗൺ ലയൺസ് ക്ലബ്ബും ചിറ്റാഴ റസിഡന്റ് അസോസിയേഷനും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീമതി ലേഖറാണി(കരകുളം ഗ്രാമപഞ്ചായത്ത് പ്രസിഡൻ്റ്).",
      thumb: "assets/img/Pastevents/418.jpg",
    },
    {
      src: "assets/img/Pastevents/419.jpg",
      caption:
        "തിരുവനന്തപുരം മിഡ്ഠൗൺ ലയൺസ് ക്ലബ്ബും ചിറ്റാഴ റസിഡന്റ് അസോസിയേഷനും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീമതി ലേഖറാണി(കരകുളം ഗ്രാമപഞ്ചായത്ത് പ്രസിഡൻ്റ്).",
      thumb: "assets/img/Pastevents/419.jpg",
    },
    {
      src: "assets/img/Pastevents/420.jpg",
      caption:
        "തിരുവനന്തപുരം മിഡ്ഠൗൺ ലയൺസ് ക്ലബ്ബും ചിറ്റാഴ റസിഡന്റ് അസോസിയേഷനും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീമതി ലേഖറാണി(കരകുളം ഗ്രാമപഞ്ചായത്ത് പ്രസിഡൻ്റ്).",
      thumb: "assets/img/Pastevents/420.jpg",
    },
    {
      src: "assets/img/Pastevents/421.jpg",
      caption:
        "തിരുവനന്തപുരം മിഡ്ഠൗൺ ലയൺസ് ക്ലബ്ബും ചിറ്റാഴ റസിഡന്റ് അസോസിയേഷനും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീമതി ലേഖറാണി(കരകുളം ഗ്രാമപഞ്ചായത്ത് പ്രസിഡൻ്റ്).",
      thumb: "assets/img/Pastevents/421.jpg",
    },
    {
      src: "assets/img/Pastevents/422.jpg",
      caption:
        "തിരുവനന്തപുരം മിഡ്ഠൗൺ ലയൺസ് ക്ലബ്ബും ചിറ്റാഴ റസിഡന്റ് അസോസിയേഷനും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീമതി ലേഖറാണി(കരകുളം ഗ്രാമപഞ്ചായത്ത് പ്രസിഡൻ്റ്).",
      thumb: "assets/img/Pastevents/422.jpg",
    },
    {
      src: "assets/img/Pastevents/423.jpg",
      caption:
        "തിരുവനന്തപുരം മിഡ്ഠൗൺ ലയൺസ് ക്ലബ്ബും ചിറ്റാഴ റസിഡന്റ് അസോസിയേഷനും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീമതി ലേഖറാണി(കരകുളം ഗ്രാമപഞ്ചായത്ത് പ്രസിഡൻ്റ്).",
      thumb: "assets/img/Pastevents/423.jpg",
    },
    {
      src: "assets/img/Pastevents/404.jpg",
      caption:
        "കേരള കൗമുദി പാലോട് യൂണിറ്റും, ബോധ പൗർണമി ക്ലബും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ സി കെ മനോജ് (SHO പാലോട്)",
      thumb: "assets/img/Pastevents/404.jpg",
    },
    {
      src: "assets/img/Pastevents/405.jpg",
      caption:
        "കേരള കൗമുദി പാലോട് യൂണിറ്റും, ബോധ പൗർണമി ക്ലബും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ സി കെ മനോജ് (SHO പാലോട്)",
      thumb: "assets/img/Pastevents/405.jpg",
    },
    {
      src: "assets/img/Pastevents/406.jpg",
      caption:
        "കേരള കൗമുദി പാലോട് യൂണിറ്റും, ബോധ പൗർണമി ക്ലബും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ സി കെ മനോജ് (SHO പാലോട്)",
      thumb: "assets/img/Pastevents/406.jpg",
    },
    {
      src: "assets/img/Pastevents/407.jpg",
      caption:
        "കേരള കൗമുദി പാലോട് യൂണിറ്റും, ബോധ പൗർണമി ക്ലബും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ സി കെ മനോജ് (SHO പാലോട്)",
      thumb: "assets/img/Pastevents/407.jpg",
    },
    {
      src: "assets/img/Pastevents/408.jpg",
      caption:
        "കേരള കൗമുദി പാലോട് യൂണിറ്റും, ബോധ പൗർണമി ക്ലബും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ സി കെ മനോജ് (SHO പാലോട്)",
      thumb: "assets/img/Pastevents/408.jpg",
    },
    {
      src: "assets/img/Pastevents/409.jpg",
      caption:
        "കേരള കൗമുദി പാലോട് യൂണിറ്റും, ബോധ പൗർണമി ക്ലബും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ സി കെ മനോജ് (SHO പാലോട്)",
      thumb: "assets/img/Pastevents/409.jpg",
    },
    {
      src: "assets/img/Pastevents/410.jpg",
      caption:
        "കേരള കൗമുദി പാലോട് യൂണിറ്റും, ബോധ പൗർണമി ക്ലബും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ സി കെ മനോജ് (SHO പാലോട്)",
      thumb: "assets/img/Pastevents/410.jpg",
    },
    {
      src: "assets/img/Pastevents/411.jpg",
      caption:
        "കേരള കൗമുദി പാലോട് യൂണിറ്റും, ബോധ പൗർണമി ക്ലബും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ സി കെ മനോജ് (SHO പാലോട്)",
      thumb: "assets/img/Pastevents/411.jpg",
    },
    {
      src: "assets/img/Pastevents/412.jpg",
      caption:
        "കേരള കൗമുദി പാലോട് യൂണിറ്റും, ബോധ പൗർണമി ക്ലബും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ സി കെ മനോജ് (SHO പാലോട്)",
      thumb: "assets/img/Pastevents/412.jpg",
    },

    {
      src: "assets/img/Pastevents/403.jpg",
      caption:
        "YMCA തിരുവനന്തപുരം, അരുവിക്കര വൈഎംസിഎ ഗ്രാമ വികസന കേന്ദ്രവും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ അഡ്വ: അടൂർ പ്രകാശ് M P. അധ്യക്ഷൻ ശ്രീ കോശി എം ജോർജ് (പ്രസിഡൻ്റ് വൈഎംസിഎ തിരുവനന്തപുരം).ആശംസ ശ്രീ വെള്ളനാട് ശശി (ജില്ലാ ഗ്രാമപഞ്ചായത്ത്)",
      thumb: "assets/img/Pastevents/403.jpg",
    },
    {
      src: "assets/img/Pastevents/390.jpg",
      caption:
        "YMCA തിരുവനന്തപുരം, അരുവിക്കര വൈഎംസിഎ ഗ്രാമ വികസന കേന്ദ്രവും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ അഡ്വ: അടൂർ പ്രകാശ് M P. അധ്യക്ഷൻ ശ്രീ കോശി എം ജോർജ് (പ്രസിഡൻ്റ് വൈഎംസിഎ തിരുവനന്തപുരം).ആശംസ ശ്രീ വെള്ളനാട് ശശി (ജില്ലാ ഗ്രാമപഞ്ചായത്ത്)",
      thumb: "assets/img/Pastevents/390.jpg",
    },
    {
      src: "assets/img/Pastevents/391.jpg",
      caption:
        "YMCA തിരുവനന്തപുരം, അരുവിക്കര വൈഎംസിഎ ഗ്രാമ വികസന കേന്ദ്രവും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ അഡ്വ: അടൂർ പ്രകാശ് M P. അധ്യക്ഷൻ ശ്രീ കോശി എം ജോർജ് (പ്രസിഡൻ്റ് വൈഎംസിഎ തിരുവനന്തപുരം).ആശംസ ശ്രീ വെള്ളനാട് ശശി (ജില്ലാ ഗ്രാമപഞ്ചായത്ത്)",
      thumb: "assets/img/Pastevents/391.jpg",
    },
    {
      src: "assets/img/Pastevents/392.jpg",
      caption:
        "YMCA തിരുവനന്തപുരം, അരുവിക്കര വൈഎംസിഎ ഗ്രാമ വികസന കേന്ദ്രവും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ അഡ്വ: അടൂർ പ്രകാശ് M P. അധ്യക്ഷൻ ശ്രീ കോശി എം ജോർജ് (പ്രസിഡൻ്റ് വൈഎംസിഎ തിരുവനന്തപുരം).ആശംസ ശ്രീ വെള്ളനാട് ശശി (ജില്ലാ ഗ്രാമപഞ്ചായത്ത്)",
      thumb: "assets/img/Pastevents/392.jpg",
    },
    {
      src: "assets/img/Pastevents/393.jpg",
      caption:
        "YMCA തിരുവനന്തപുരം, അരുവിക്കര വൈഎംസിഎ ഗ്രാമ വികസന കേന്ദ്രവും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ അഡ്വ: അടൂർ പ്രകാശ് M P. അധ്യക്ഷൻ ശ്രീ കോശി എം ജോർജ് (പ്രസിഡൻ്റ് വൈഎംസിഎ തിരുവനന്തപുരം).ആശംസ ശ്രീ വെള്ളനാട് ശശി (ജില്ലാ ഗ്രാമപഞ്ചായത്ത്)",
      thumb: "assets/img/Pastevents/393.jpg",
    },
    {
      src: "assets/img/Pastevents/394.jpg",
      caption:
        "YMCA തിരുവനന്തപുരം, അരുവിക്കര വൈഎംസിഎ ഗ്രാമ വികസന കേന്ദ്രവും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ അഡ്വ: അടൂർ പ്രകാശ് M P. അധ്യക്ഷൻ ശ്രീ കോശി എം ജോർജ് (പ്രസിഡൻ്റ് വൈഎംസിഎ തിരുവനന്തപുരം).ആശംസ ശ്രീ വെള്ളനാട് ശശി (ജില്ലാ ഗ്രാമപഞ്ചായത്ത്)",
      thumb: "assets/img/Pastevents/394.jpg",
    },
    {
      src: "assets/img/Pastevents/395.jpg",
      caption:
        "YMCA തിരുവനന്തപുരം, അരുവിക്കര വൈഎംസിഎ ഗ്രാമ വികസന കേന്ദ്രവും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ അഡ്വ: അടൂർ പ്രകാശ് M P. അധ്യക്ഷൻ ശ്രീ കോശി എം ജോർജ് (പ്രസിഡൻ്റ് വൈഎംസിഎ തിരുവനന്തപുരം).ആശംസ ശ്രീ വെള്ളനാട് ശശി (ജില്ലാ ഗ്രാമപഞ്ചായത്ത്)",
      thumb: "assets/img/Pastevents/395.jpg",
    },
    {
      src: "assets/img/Pastevents/396.jpg",
      caption:
        "YMCA തിരുവനന്തപുരം, അരുവിക്കര വൈഎംസിഎ ഗ്രാമ വികസന കേന്ദ്രവും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ അഡ്വ: അടൂർ പ്രകാശ് M P. അധ്യക്ഷൻ ശ്രീ കോശി എം ജോർജ് (പ്രസിഡൻ്റ് വൈഎംസിഎ തിരുവനന്തപുരം).ആശംസ ശ്രീ വെള്ളനാട് ശശി (ജില്ലാ ഗ്രാമപഞ്ചായത്ത്)",
      thumb: "assets/img/Pastevents/396.jpg",
    },
    {
      src: "assets/img/Pastevents/397.jpg",
      caption:
        "YMCA തിരുവനന്തപുരം, അരുവിക്കര വൈഎംസിഎ ഗ്രാമ വികസന കേന്ദ്രവും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ അഡ്വ: അടൂർ പ്രകാശ് M P. അധ്യക്ഷൻ ശ്രീ കോശി എം ജോർജ് (പ്രസിഡൻ്റ് വൈഎംസിഎ തിരുവനന്തപുരം).ആശംസ ശ്രീ വെള്ളനാട് ശശി (ജില്ലാ ഗ്രാമപഞ്ചായത്ത്)",
      thumb: "assets/img/Pastevents/397.jpg",
    },
    {
      src: "assets/img/Pastevents/398.jpg",
      caption:
        "YMCA തിരുവനന്തപുരം, അരുവിക്കര വൈഎംസിഎ ഗ്രാമ വികസന കേന്ദ്രവും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ അഡ്വ: അടൂർ പ്രകാശ് M P. അധ്യക്ഷൻ ശ്രീ കോശി എം ജോർജ് (പ്രസിഡൻ്റ് വൈഎംസിഎ തിരുവനന്തപുരം).ആശംസ ശ്രീ വെള്ളനാട് ശശി (ജില്ലാ ഗ്രാമപഞ്ചായത്ത്)",
      thumb: "assets/img/Pastevents/398.jpg",
    },
    {
      src: "assets/img/Pastevents/399.jpg",
      caption:
        "YMCA തിരുവനന്തപുരം, അരുവിക്കര വൈഎംസിഎ ഗ്രാമ വികസന കേന്ദ്രവും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ അഡ്വ: അടൂർ പ്രകാശ് M P. അധ്യക്ഷൻ ശ്രീ കോശി എം ജോർജ് (പ്രസിഡൻ്റ് വൈഎംസിഎ തിരുവനന്തപുരം).ആശംസ ശ്രീ വെള്ളനാട് ശശി (ജില്ലാ ഗ്രാമപഞ്ചായത്ത്)",
      thumb: "assets/img/Pastevents/399.jpg",
    },
    {
      src: "assets/img/Pastevents/400.jpg",
      caption:
        "YMCA തിരുവനന്തപുരം, അരുവിക്കര വൈഎംസിഎ ഗ്രാമ വികസന കേന്ദ്രവും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ അഡ്വ: അടൂർ പ്രകാശ് M P. അധ്യക്ഷൻ ശ്രീ കോശി എം ജോർജ് (പ്രസിഡൻ്റ് വൈഎംസിഎ തിരുവനന്തപുരം).ആശംസ ശ്രീ വെള്ളനാട് ശശി (ജില്ലാ ഗ്രാമപഞ്ചായത്ത്)",
      thumb: "assets/img/Pastevents/400.jpg",
    },
    {
      src: "assets/img/Pastevents/401.jpg",
      caption:
        "YMCA തിരുവനന്തപുരം, അരുവിക്കര വൈഎംസിഎ ഗ്രാമ വികസന കേന്ദ്രവും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ അഡ്വ: അടൂർ പ്രകാശ് M P. അധ്യക്ഷൻ ശ്രീ കോശി എം ജോർജ് (പ്രസിഡൻ്റ് വൈഎംസിഎ തിരുവനന്തപുരം).ആശംസ ശ്രീ വെള്ളനാട് ശശി (ജില്ലാ ഗ്രാമപഞ്ചായത്ത്)",
      thumb: "assets/img/Pastevents/401.jpg",
    },
    {
      src: "assets/img/Pastevents/402.jpg",
      caption:
        "YMCA തിരുവനന്തപുരം, അരുവിക്കര വൈഎംസിഎ ഗ്രാമ വികസന കേന്ദ്രവും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ അഡ്വ: അടൂർ പ്രകാശ് M P. അധ്യക്ഷൻ ശ്രീ കോശി എം ജോർജ് (പ്രസിഡൻ്റ് വൈഎംസിഎ തിരുവനന്തപുരം).ആശംസ ശ്രീ വെള്ളനാട് ശശി (ജില്ലാ ഗ്രാമപഞ്ചായത്ത്)",
      thumb: "assets/img/Pastevents/402.jpg",
    },

    {
      src: "assets/img/Pastevents/381.jpg",
      caption:
        "വട്ടിയൂർക്കാവ് മോഡൽ ലയൺസ് ക്ലബ്ബും വട്ടിയൂർക്കാവ് വാർഡ് കമ്മിറ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/381.jpg",
    },
    {
      src: "assets/img/Pastevents/382.jpg",
      caption:
        "വട്ടിയൂർക്കാവ് മോഡൽ ലയൺസ് ക്ലബ്ബും വട്ടിയൂർക്കാവ് വാർഡ് കമ്മിറ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/382.jpg",
    },
    {
      src: "assets/img/Pastevents/383.jpg",
      caption:
        "വട്ടിയൂർക്കാവ് മോഡൽ ലയൺസ് ക്ലബ്ബും വട്ടിയൂർക്കാവ് വാർഡ് കമ്മിറ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/383.jpg",
    },
    {
      src: "assets/img/Pastevents/384.jpg",
      caption:
        "വട്ടിയൂർക്കാവ് മോഡൽ ലയൺസ് ക്ലബ്ബും വട്ടിയൂർക്കാവ് വാർഡ് കമ്മിറ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/384.jpg",
    },
    {
      src: "assets/img/Pastevents/385.jpg",
      caption:
        "വട്ടിയൂർക്കാവ് മോഡൽ ലയൺസ് ക്ലബ്ബും വട്ടിയൂർക്കാവ് വാർഡ് കമ്മിറ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/385.jpg",
    },
    {
      src: "assets/img/Pastevents/386.jpg",
      caption:
        "വട്ടിയൂർക്കാവ് മോഡൽ ലയൺസ് ക്ലബ്ബും വട്ടിയൂർക്കാവ് വാർഡ് കമ്മിറ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/386.jpg",
    },
    {
      src: "assets/img/Pastevents/387.jpg",
      caption:
        "വട്ടിയൂർക്കാവ് മോഡൽ ലയൺസ് ക്ലബ്ബും വട്ടിയൂർക്കാവ് വാർഡ് കമ്മിറ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/387.jpg",
    },
    {
      src: "assets/img/Pastevents/388.jpg",
      caption:
        "വട്ടിയൂർക്കാവ് മോഡൽ ലയൺസ് ക്ലബ്ബും വട്ടിയൂർക്കാവ് വാർഡ് കമ്മിറ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/388.jpg",
    },
    {
      src: "assets/img/Pastevents/389.jpg",
      caption:
        "വട്ടിയൂർക്കാവ് മോഡൽ ലയൺസ് ക്ലബ്ബും വട്ടിയൂർക്കാവ് വാർഡ് കമ്മിറ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/389.jpg",
    },
    {
      src: "assets/img/Pastevents/368.jpg",
      caption:
        "കുറുപുഴ റെസിഡൻഷ്യൽ അസോസിയേഷൻ,കേരള കൗമുദി പാലോട് യൂണിറ്റും ബോധ പൗർണമി ക്ലബും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ ശശികുമാർ (കുറുപുഴ റെസിഡൻഷ്യൽ അസോസിയേഷൻ പ്രസിഡൻ്റ്)",
      thumb: "assets/img/Pastevents/368.jpg",
    },
    {
      src: "assets/img/Pastevents/369.jpg",
      caption:
        "കുറുപുഴ റെസിഡൻഷ്യൽ അസോസിയേഷൻ,കേരള കൗമുദി പാലോട് യൂണിറ്റും ബോധ പൗർണമി ക്ലബും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ ശശികുമാർ (കുറുപുഴ റെസിഡൻഷ്യൽ അസോസിയേഷൻ പ്രസിഡൻ്റ്)",
      thumb: "assets/img/Pastevents/369.jpg",
    },
    {
      src: "assets/img/Pastevents/370.jpg",
      caption:
        "കുറുപുഴ റെസിഡൻഷ്യൽ അസോസിയേഷൻ,കേരള കൗമുദി പാലോട് യൂണിറ്റും ബോധ പൗർണമി ക്ലബും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ ശശികുമാർ (കുറുപുഴ റെസിഡൻഷ്യൽ അസോസിയേഷൻ പ്രസിഡൻ്റ്)",
      thumb: "assets/img/Pastevents/370.jpg",
    },
    {
      src: "assets/img/Pastevents/371.jpg",
      caption:
        "കുറുപുഴ റെസിഡൻഷ്യൽ അസോസിയേഷൻ,കേരള കൗമുദി പാലോട് യൂണിറ്റും ബോധ പൗർണമി ക്ലബും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ ശശികുമാർ (കുറുപുഴ റെസിഡൻഷ്യൽ അസോസിയേഷൻ പ്രസിഡൻ്റ്)",
      thumb: "assets/img/Pastevents/371.jpg",
    },
    {
      src: "assets/img/Pastevents/372.jpg",
      caption:
        "കുറുപുഴ റെസിഡൻഷ്യൽ അസോസിയേഷൻ,കേരള കൗമുദി പാലോട് യൂണിറ്റും ബോധ പൗർണമി ക്ലബും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ ശശികുമാർ (കുറുപുഴ റെസിഡൻഷ്യൽ അസോസിയേഷൻ പ്രസിഡൻ്റ്)",
      thumb: "assets/img/Pastevents/372.jpg",
    },
    {
      src: "assets/img/Pastevents/373.jpg",
      caption:
        "കുറുപുഴ റെസിഡൻഷ്യൽ അസോസിയേഷൻ,കേരള കൗമുദി പാലോട് യൂണിറ്റും ബോധ പൗർണമി ക്ലബും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ ശശികുമാർ (കുറുപുഴ റെസിഡൻഷ്യൽ അസോസിയേഷൻ പ്രസിഡൻ്റ്)",
      thumb: "assets/img/Pastevents/373.jpg",
    },
    {
      src: "assets/img/Pastevents/374.jpg",
      caption:
        "കുറുപുഴ റെസിഡൻഷ്യൽ അസോസിയേഷൻ,കേരള കൗമുദി പാലോട് യൂണിറ്റും ബോധ പൗർണമി ക്ലബും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ ശശികുമാർ (കുറുപുഴ റെസിഡൻഷ്യൽ അസോസിയേഷൻ പ്രസിഡൻ്റ്)",
      thumb: "assets/img/Pastevents/374.jpg",
    },
    {
      src: "assets/img/Pastevents/375.jpg",
      caption:
        "കുറുപുഴ റെസിഡൻഷ്യൽ അസോസിയേഷൻ,കേരള കൗമുദി പാലോട് യൂണിറ്റും ബോധ പൗർണമി ക്ലബും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ ശശികുമാർ (കുറുപുഴ റെസിഡൻഷ്യൽ അസോസിയേഷൻ പ്രസിഡൻ്റ്)",
      thumb: "assets/img/Pastevents/375.jpg",
    },
    {
      src: "assets/img/Pastevents/376.jpg",
      caption:
        "കുറുപുഴ റെസിഡൻഷ്യൽ അസോസിയേഷൻ,കേരള കൗമുദി പാലോട് യൂണിറ്റും ബോധ പൗർണമി ക്ലബും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ ശശികുമാർ (കുറുപുഴ റെസിഡൻഷ്യൽ അസോസിയേഷൻ പ്രസിഡൻ്റ്)",
      thumb: "assets/img/Pastevents/376.jpg",
    },
    {
      src: "assets/img/Pastevents/377.jpg",
      caption:
        "കുറുപുഴ റെസിഡൻഷ്യൽ അസോസിയേഷൻ,കേരള കൗമുദി പാലോട് യൂണിറ്റും ബോധ പൗർണമി ക്ലബും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ ശശികുമാർ (കുറുപുഴ റെസിഡൻഷ്യൽ അസോസിയേഷൻ പ്രസിഡൻ്റ്)",
      thumb: "assets/img/Pastevents/377.jpg",
    },
    {
      src: "assets/img/Pastevents/378.jpg",
      caption:
        "കുറുപുഴ റെസിഡൻഷ്യൽ അസോസിയേഷൻ,കേരള കൗമുദി പാലോട് യൂണിറ്റും ബോധ പൗർണമി ക്ലബും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ ശശികുമാർ (കുറുപുഴ റെസിഡൻഷ്യൽ അസോസിയേഷൻ പ്രസിഡൻ്റ്)",
      thumb: "assets/img/Pastevents/378.jpg",
    },
    {
      src: "assets/img/Pastevents/379.jpg",
      caption:
        "കുറുപുഴ റെസിഡൻഷ്യൽ അസോസിയേഷൻ,കേരള കൗമുദി പാലോട് യൂണിറ്റും ബോധ പൗർണമി ക്ലബും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ ശശികുമാർ (കുറുപുഴ റെസിഡൻഷ്യൽ അസോസിയേഷൻ പ്രസിഡൻ്റ്)",
      thumb: "assets/img/Pastevents/379.jpg",
    },
    {
      src: "assets/img/Pastevents/380.jpg",
      caption:
        "കുറുപുഴ റെസിഡൻഷ്യൽ അസോസിയേഷൻ,കേരള കൗമുദി പാലോട് യൂണിറ്റും ബോധ പൗർണമി ക്ലബും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ ശശികുമാർ (കുറുപുഴ റെസിഡൻഷ്യൽ അസോസിയേഷൻ പ്രസിഡൻ്റ്)",
      thumb: "assets/img/Pastevents/380.jpg",
    },
    {
      src: "assets/img/Pastevents/358.jpg",
      caption:
        " കേരള കൗമുദി പാലോട് യൂണിറ്റും, ബോധപൗർണമി ക്ലബ്ബും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീമതി വിനീത ഷിബു (പാലോട് ഗ്രാമപഞ്ചായത്ത്).",
      thumb: "assets/img/Pastevents/358.jpg",
    },
    {
      src: "assets/img/Pastevents/359.jpg",
      caption:
        " കേരള കൗമുദി പാലോട് യൂണിറ്റും, ബോധപൗർണമി ക്ലബ്ബും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീമതി വിനീത ഷിബു (പാലോട് ഗ്രാമപഞ്ചായത്ത്).",
      thumb: "assets/img/Pastevents/359.jpg",
    },
    {
      src: "assets/img/Pastevents/360.jpg",
      caption:
        " കേരള കൗമുദി പാലോട് യൂണിറ്റും, ബോധപൗർണമി ക്ലബ്ബും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീമതി വിനീത ഷിബു (പാലോട് ഗ്രാമപഞ്ചായത്ത്).",
      thumb: "assets/img/Pastevents/360.jpg",
    },
    {
      src: "assets/img/Pastevents/361.jpg",
      caption:
        " കേരള കൗമുദി പാലോട് യൂണിറ്റും, ബോധപൗർണമി ക്ലബ്ബും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീമതി വിനീത ഷിബു (പാലോട് ഗ്രാമപഞ്ചായത്ത്).",
      thumb: "assets/img/Pastevents/361.jpg",
    },
    {
      src: "assets/img/Pastevents/362.jpg",
      caption:
        " കേരള കൗമുദി പാലോട് യൂണിറ്റും, ബോധപൗർണമി ക്ലബ്ബും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീമതി വിനീത ഷിബു (പാലോട് ഗ്രാമപഞ്ചായത്ത്).",
      thumb: "assets/img/Pastevents/362.jpg",
    },
    {
      src: "assets/img/Pastevents/363.jpg",
      caption:
        " കേരള കൗമുദി പാലോട് യൂണിറ്റും, ബോധപൗർണമി ക്ലബ്ബും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീമതി വിനീത ഷിബു (പാലോട് ഗ്രാമപഞ്ചായത്ത്).",
      thumb: "assets/img/Pastevents/363.jpg",
    },
    {
      src: "assets/img/Pastevents/364.jpg",
      caption:
        " കേരള കൗമുദി പാലോട് യൂണിറ്റും, ബോധപൗർണമി ക്ലബ്ബും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീമതി വിനീത ഷിബു (പാലോട് ഗ്രാമപഞ്ചായത്ത്).",
      thumb: "assets/img/Pastevents/364.jpg",
    },
    {
      src: "assets/img/Pastevents/365.jpg",
      caption:
        " കേരള കൗമുദി പാലോട് യൂണിറ്റും, ബോധപൗർണമി ക്ലബ്ബും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീമതി വിനീത ഷിബു (പാലോട് ഗ്രാമപഞ്ചായത്ത്).",
      thumb: "assets/img/Pastevents/365.jpg",
    },
    {
      src: "assets/img/Pastevents/366.jpg",
      caption:
        " കേരള കൗമുദി പാലോട് യൂണിറ്റും, ബോധപൗർണമി ക്ലബ്ബും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീമതി വിനീത ഷിബു (പാലോട് ഗ്രാമപഞ്ചായത്ത്).",
      thumb: "assets/img/Pastevents/366.jpg",
    },
    {
      src: "assets/img/Pastevents/367.jpg",
      caption:
        " കേരള കൗമുദി പാലോട് യൂണിറ്റും, ബോധപൗർണമി ക്ലബ്ബും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീമതി വിനീത ഷിബു (പാലോട് ഗ്രാമപഞ്ചായത്ത്).",
      thumb: "assets/img/Pastevents/367.jpg",
    },
    {
      src: "assets/img/Pastevents/339.jpg",
      caption:
        "സുബൈർ കുഞ്ഞു ഫൗണ്ടേഷനും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ ആരോഗ്യമേള സംഘടിപ്പിച്ചു.ആരോഗ്യമേളയിൽ സൂപ്പർ സ്പെഷ്യാലിറ്റി വിഭാഗങളായ കാർഡിയോളജി, ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, ഗ്യാസ്ട്രാളജി, ഓർത്തോ, ഇ എൻ റ്റി, ഗൈനക്കോളജി, ഡയബറ്റോളജി ഒഫ്ത്താൽമോളജീ,ഡൻറ്റൽ. അൾട്രാസൗണ്ട് സ്കാനിംഗ്,എക്കോ കാർഡിയോ ഗ്രാം,ഇ സി ജീ,ഓഡിയോമെട്രിക്എസ് ജീ ഒ റ്റീ,ഏസ് ജീ പീ റ്റീ, ബ്ലഡ് പ്രഷർ, ബ്ലഡ് ഷുഗർ, ബി എം ഐ എന്നീ ടെസ്റ്റ് കളും നടത്തി. ക്യാമ്പിൽ പങ്കെടുത്ത 250 ൽപ്പരം രോഗികൾക്ക് സൂപ്പർ സ്പെഷ്യാലിറ്റി വിഭാഗങ്ങളും പരിശോധനകളും പ്രയോജനപ്പെടുത്തി.",
      thumb: "assets/img/Pastevents/339.jpg",
    },
    {
      src: "assets/img/Pastevents/340.jpg",
      caption:
        "സുബൈർ കുഞ്ഞു ഫൗണ്ടേഷനും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ ആരോഗ്യമേള സംഘടിപ്പിച്ചു.ആരോഗ്യമേളയിൽ സൂപ്പർ സ്പെഷ്യാലിറ്റി വിഭാഗങളായ കാർഡിയോളജി, ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, ഗ്യാസ്ട്രാളജി, ഓർത്തോ, ഇ എൻ റ്റി, ഗൈനക്കോളജി, ഡയബറ്റോളജി ഒഫ്ത്താൽമോളജീ,ഡൻറ്റൽ. അൾട്രാസൗണ്ട് സ്കാനിംഗ്,എക്കോ കാർഡിയോ ഗ്രാം,ഇ സി ജീ,ഓഡിയോമെട്രിക്എസ് ജീ ഒ റ്റീ,ഏസ് ജീ പീ റ്റീ, ബ്ലഡ് പ്രഷർ, ബ്ലഡ് ഷുഗർ, ബി എം ഐ എന്നീ ടെസ്റ്റ് കളും നടത്തി. ക്യാമ്പിൽ പങ്കെടുത്ത 250 ൽപ്പരം രോഗികൾക്ക് സൂപ്പർ സ്പെഷ്യാലിറ്റി വിഭാഗങ്ങളും പരിശോധനകളും പ്രയോജനപ്പെടുത്തി.",

      thumb: "assets/img/Pastevents/340.jpg",
    },
    {
      src: "assets/img/Pastevents/341.jpg",
      caption:
        "സുബൈർ കുഞ്ഞു ഫൗണ്ടേഷനും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ ആരോഗ്യമേള സംഘടിപ്പിച്ചു.ആരോഗ്യമേളയിൽ സൂപ്പർ സ്പെഷ്യാലിറ്റി വിഭാഗങളായ കാർഡിയോളജി, ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, ഗ്യാസ്ട്രാളജി, ഓർത്തോ, ഇ എൻ റ്റി, ഗൈനക്കോളജി, ഡയബറ്റോളജി ഒഫ്ത്താൽമോളജീ,ഡൻറ്റൽ. അൾട്രാസൗണ്ട് സ്കാനിംഗ്,എക്കോ കാർഡിയോ ഗ്രാം,ഇ സി ജീ,ഓഡിയോമെട്രിക്എസ് ജീ ഒ റ്റീ,ഏസ് ജീ പീ റ്റീ, ബ്ലഡ് പ്രഷർ, ബ്ലഡ് ഷുഗർ, ബി എം ഐ എന്നീ ടെസ്റ്റ് കളും നടത്തി. ക്യാമ്പിൽ പങ്കെടുത്ത 250 ൽപ്പരം രോഗികൾക്ക് സൂപ്പർ സ്പെഷ്യാലിറ്റി വിഭാഗങ്ങളും പരിശോധനകളും പ്രയോജനപ്പെടുത്തി.",

      thumb: "assets/img/Pastevents/341.jpg",
    },
    {
      src: "assets/img/Pastevents/342.jpg",
      caption:
        "സുബൈർ കുഞ്ഞു ഫൗണ്ടേഷനും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ ആരോഗ്യമേള സംഘടിപ്പിച്ചു.ആരോഗ്യമേളയിൽ സൂപ്പർ സ്പെഷ്യാലിറ്റി വിഭാഗങളായ കാർഡിയോളജി, ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, ഗ്യാസ്ട്രാളജി, ഓർത്തോ, ഇ എൻ റ്റി, ഗൈനക്കോളജി, ഡയബറ്റോളജി ഒഫ്ത്താൽമോളജീ,ഡൻറ്റൽ. അൾട്രാസൗണ്ട് സ്കാനിംഗ്,എക്കോ കാർഡിയോ ഗ്രാം,ഇ സി ജീ,ഓഡിയോമെട്രിക്എസ് ജീ ഒ റ്റീ,ഏസ് ജീ പീ റ്റീ, ബ്ലഡ് പ്രഷർ, ബ്ലഡ് ഷുഗർ, ബി എം ഐ എന്നീ ടെസ്റ്റ് കളും നടത്തി. ക്യാമ്പിൽ പങ്കെടുത്ത 250 ൽപ്പരം രോഗികൾക്ക് സൂപ്പർ സ്പെഷ്യാലിറ്റി വിഭാഗങ്ങളും പരിശോധനകളും പ്രയോജനപ്പെടുത്തി.",

      thumb: "assets/img/Pastevents/342.jpg",
    },
    {
      src: "assets/img/Pastevents/343.jpg",
      caption:
        "സുബൈർ കുഞ്ഞു ഫൗണ്ടേഷനും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ ആരോഗ്യമേള സംഘടിപ്പിച്ചു.ആരോഗ്യമേളയിൽ സൂപ്പർ സ്പെഷ്യാലിറ്റി വിഭാഗങളായ കാർഡിയോളജി, ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, ഗ്യാസ്ട്രാളജി, ഓർത്തോ, ഇ എൻ റ്റി, ഗൈനക്കോളജി, ഡയബറ്റോളജി ഒഫ്ത്താൽമോളജീ,ഡൻറ്റൽ. അൾട്രാസൗണ്ട് സ്കാനിംഗ്,എക്കോ കാർഡിയോ ഗ്രാം,ഇ സി ജീ,ഓഡിയോമെട്രിക്എസ് ജീ ഒ റ്റീ,ഏസ് ജീ പീ റ്റീ, ബ്ലഡ് പ്രഷർ, ബ്ലഡ് ഷുഗർ, ബി എം ഐ എന്നീ ടെസ്റ്റ് കളും നടത്തി. ക്യാമ്പിൽ പങ്കെടുത്ത 250 ൽപ്പരം രോഗികൾക്ക് സൂപ്പർ സ്പെഷ്യാലിറ്റി വിഭാഗങ്ങളും പരിശോധനകളും പ്രയോജനപ്പെടുത്തി.",

      thumb: "assets/img/Pastevents/343.jpg",
    },
    {
      src: "assets/img/Pastevents/344.jpg",
      caption:
        "സുബൈർ കുഞ്ഞു ഫൗണ്ടേഷനും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ ആരോഗ്യമേള സംഘടിപ്പിച്ചു.ആരോഗ്യമേളയിൽ സൂപ്പർ സ്പെഷ്യാലിറ്റി വിഭാഗങളായ കാർഡിയോളജി, ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, ഗ്യാസ്ട്രാളജി, ഓർത്തോ, ഇ എൻ റ്റി, ഗൈനക്കോളജി, ഡയബറ്റോളജി ഒഫ്ത്താൽമോളജീ,ഡൻറ്റൽ. അൾട്രാസൗണ്ട് സ്കാനിംഗ്,എക്കോ കാർഡിയോ ഗ്രാം,ഇ സി ജീ,ഓഡിയോമെട്രിക്എസ് ജീ ഒ റ്റീ,ഏസ് ജീ പീ റ്റീ, ബ്ലഡ് പ്രഷർ, ബ്ലഡ് ഷുഗർ, ബി എം ഐ എന്നീ ടെസ്റ്റ് കളും നടത്തി. ക്യാമ്പിൽ പങ്കെടുത്ത 250 ൽപ്പരം രോഗികൾക്ക് സൂപ്പർ സ്പെഷ്യാലിറ്റി വിഭാഗങ്ങളും പരിശോധനകളും പ്രയോജനപ്പെടുത്തി.",

      thumb: "assets/img/Pastevents/344.jpg",
    },
    {
      src: "assets/img/Pastevents/345.jpg",
      caption:
        "സുബൈർ കുഞ്ഞു ഫൗണ്ടേഷനും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ ആരോഗ്യമേള സംഘടിപ്പിച്ചു.ആരോഗ്യമേളയിൽ സൂപ്പർ സ്പെഷ്യാലിറ്റി വിഭാഗങളായ കാർഡിയോളജി, ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, ഗ്യാസ്ട്രാളജി, ഓർത്തോ, ഇ എൻ റ്റി, ഗൈനക്കോളജി, ഡയബറ്റോളജി ഒഫ്ത്താൽമോളജീ,ഡൻറ്റൽ. അൾട്രാസൗണ്ട് സ്കാനിംഗ്,എക്കോ കാർഡിയോ ഗ്രാം,ഇ സി ജീ,ഓഡിയോമെട്രിക്എസ് ജീ ഒ റ്റീ,ഏസ് ജീ പീ റ്റീ, ബ്ലഡ് പ്രഷർ, ബ്ലഡ് ഷുഗർ, ബി എം ഐ എന്നീ ടെസ്റ്റ് കളും നടത്തി. ക്യാമ്പിൽ പങ്കെടുത്ത 250 ൽപ്പരം രോഗികൾക്ക് സൂപ്പർ സ്പെഷ്യാലിറ്റി വിഭാഗങ്ങളും പരിശോധനകളും പ്രയോജനപ്പെടുത്തി.",

      thumb: "assets/img/Pastevents/345.jpg",
    },
    {
      src: "assets/img/Pastevents/346.jpg",
      caption:
        "സുബൈർ കുഞ്ഞു ഫൗണ്ടേഷനും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ ആരോഗ്യമേള സംഘടിപ്പിച്ചു.ആരോഗ്യമേളയിൽ സൂപ്പർ സ്പെഷ്യാലിറ്റി വിഭാഗങളായ കാർഡിയോളജി, ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, ഗ്യാസ്ട്രാളജി, ഓർത്തോ, ഇ എൻ റ്റി, ഗൈനക്കോളജി, ഡയബറ്റോളജി ഒഫ്ത്താൽമോളജീ,ഡൻറ്റൽ. അൾട്രാസൗണ്ട് സ്കാനിംഗ്,എക്കോ കാർഡിയോ ഗ്രാം,ഇ സി ജീ,ഓഡിയോമെട്രിക്എസ് ജീ ഒ റ്റീ,ഏസ് ജീ പീ റ്റീ, ബ്ലഡ് പ്രഷർ, ബ്ലഡ് ഷുഗർ, ബി എം ഐ എന്നീ ടെസ്റ്റ് കളും നടത്തി. ക്യാമ്പിൽ പങ്കെടുത്ത 250 ൽപ്പരം രോഗികൾക്ക് സൂപ്പർ സ്പെഷ്യാലിറ്റി വിഭാഗങ്ങളും പരിശോധനകളും പ്രയോജനപ്പെടുത്തി.",

      thumb: "assets/img/Pastevents/346.jpg",
    },
    {
      src: "assets/img/Pastevents/347.jpg",
      caption:
        "സുബൈർ കുഞ്ഞു ഫൗണ്ടേഷനും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ ആരോഗ്യമേള സംഘടിപ്പിച്ചു.ആരോഗ്യമേളയിൽ സൂപ്പർ സ്പെഷ്യാലിറ്റി വിഭാഗങളായ കാർഡിയോളജി, ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, ഗ്യാസ്ട്രാളജി, ഓർത്തോ, ഇ എൻ റ്റി, ഗൈനക്കോളജി, ഡയബറ്റോളജി ഒഫ്ത്താൽമോളജീ,ഡൻറ്റൽ. അൾട്രാസൗണ്ട് സ്കാനിംഗ്,എക്കോ കാർഡിയോ ഗ്രാം,ഇ സി ജീ,ഓഡിയോമെട്രിക്എസ് ജീ ഒ റ്റീ,ഏസ് ജീ പീ റ്റീ, ബ്ലഡ് പ്രഷർ, ബ്ലഡ് ഷുഗർ, ബി എം ഐ എന്നീ ടെസ്റ്റ് കളും നടത്തി. ക്യാമ്പിൽ പങ്കെടുത്ത 250 ൽപ്പരം രോഗികൾക്ക് സൂപ്പർ സ്പെഷ്യാലിറ്റി വിഭാഗങ്ങളും പരിശോധനകളും പ്രയോജനപ്പെടുത്തി.",

      thumb: "assets/img/Pastevents/347.jpg",
    },
    {
      src: "assets/img/Pastevents/348.jpg",
      caption:
        "സുബൈർ കുഞ്ഞു ഫൗണ്ടേഷനും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ ആരോഗ്യമേള സംഘടിപ്പിച്ചു.ആരോഗ്യമേളയിൽ സൂപ്പർ സ്പെഷ്യാലിറ്റി വിഭാഗങളായ കാർഡിയോളജി, ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, ഗ്യാസ്ട്രാളജി, ഓർത്തോ, ഇ എൻ റ്റി, ഗൈനക്കോളജി, ഡയബറ്റോളജി ഒഫ്ത്താൽമോളജീ,ഡൻറ്റൽ. അൾട്രാസൗണ്ട് സ്കാനിംഗ്,എക്കോ കാർഡിയോ ഗ്രാം,ഇ സി ജീ,ഓഡിയോമെട്രിക്എസ് ജീ ഒ റ്റീ,ഏസ് ജീ പീ റ്റീ, ബ്ലഡ് പ്രഷർ, ബ്ലഡ് ഷുഗർ, ബി എം ഐ എന്നീ ടെസ്റ്റ് കളും നടത്തി. ക്യാമ്പിൽ പങ്കെടുത്ത 250 ൽപ്പരം രോഗികൾക്ക് സൂപ്പർ സ്പെഷ്യാലിറ്റി വിഭാഗങ്ങളും പരിശോധനകളും പ്രയോജനപ്പെടുത്തി.",

      thumb: "assets/img/Pastevents/348.jpg",
    },
    {
      src: "assets/img/Pastevents/349.jpg",
      caption: "",
      thumb: "assets/img/Pastevents/349.jpg",
    },
    {
      src: "assets/img/Pastevents/350.jpg",
      caption:
        "സുബൈർ കുഞ്ഞു ഫൗണ്ടേഷനും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ ആരോഗ്യമേള സംഘടിപ്പിച്ചു.ആരോഗ്യമേളയിൽ സൂപ്പർ സ്പെഷ്യാലിറ്റി വിഭാഗങളായ കാർഡിയോളജി, ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, ഗ്യാസ്ട്രാളജി, ഓർത്തോ, ഇ എൻ റ്റി, ഗൈനക്കോളജി, ഡയബറ്റോളജി ഒഫ്ത്താൽമോളജീ,ഡൻറ്റൽ. അൾട്രാസൗണ്ട് സ്കാനിംഗ്,എക്കോ കാർഡിയോ ഗ്രാം,ഇ സി ജീ,ഓഡിയോമെട്രിക്എസ് ജീ ഒ റ്റീ,ഏസ് ജീ പീ റ്റീ, ബ്ലഡ് പ്രഷർ, ബ്ലഡ് ഷുഗർ, ബി എം ഐ എന്നീ ടെസ്റ്റ് കളും നടത്തി. ക്യാമ്പിൽ പങ്കെടുത്ത 250 ൽപ്പരം രോഗികൾക്ക് സൂപ്പർ സ്പെഷ്യാലിറ്റി വിഭാഗങ്ങളും പരിശോധനകളും പ്രയോജനപ്പെടുത്തി.",
      thumb: "assets/img/Pastevents/350.jpg",
    },
    {
      src: "assets/img/Pastevents/351.jpg",
      caption:
        "സുബൈർ കുഞ്ഞു ഫൗണ്ടേഷനും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ ആരോഗ്യമേള സംഘടിപ്പിച്ചു.ആരോഗ്യമേളയിൽ സൂപ്പർ സ്പെഷ്യാലിറ്റി വിഭാഗങളായ കാർഡിയോളജി, ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, ഗ്യാസ്ട്രാളജി, ഓർത്തോ, ഇ എൻ റ്റി, ഗൈനക്കോളജി, ഡയബറ്റോളജി ഒഫ്ത്താൽമോളജീ,ഡൻറ്റൽ. അൾട്രാസൗണ്ട് സ്കാനിംഗ്,എക്കോ കാർഡിയോ ഗ്രാം,ഇ സി ജീ,ഓഡിയോമെട്രിക്എസ് ജീ ഒ റ്റീ,ഏസ് ജീ പീ റ്റീ, ബ്ലഡ് പ്രഷർ, ബ്ലഡ് ഷുഗർ, ബി എം ഐ എന്നീ ടെസ്റ്റ് കളും നടത്തി. ക്യാമ്പിൽ പങ്കെടുത്ത 250 ൽപ്പരം രോഗികൾക്ക് സൂപ്പർ സ്പെഷ്യാലിറ്റി വിഭാഗങ്ങളും പരിശോധനകളും പ്രയോജനപ്പെടുത്തി.",

      thumb: "assets/img/Pastevents/351.jpg",
    },
    {
      src: "assets/img/Pastevents/352.jpg",
      caption:
        "സുബൈർ കുഞ്ഞു ഫൗണ്ടേഷനും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ ആരോഗ്യമേള സംഘടിപ്പിച്ചു.ആരോഗ്യമേളയിൽ സൂപ്പർ സ്പെഷ്യാലിറ്റി വിഭാഗങളായ കാർഡിയോളജി, ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, ഗ്യാസ്ട്രാളജി, ഓർത്തോ, ഇ എൻ റ്റി, ഗൈനക്കോളജി, ഡയബറ്റോളജി ഒഫ്ത്താൽമോളജീ,ഡൻറ്റൽ. അൾട്രാസൗണ്ട് സ്കാനിംഗ്,എക്കോ കാർഡിയോ ഗ്രാം,ഇ സി ജീ,ഓഡിയോമെട്രിക്എസ് ജീ ഒ റ്റീ,ഏസ് ജീ പീ റ്റീ, ബ്ലഡ് പ്രഷർ, ബ്ലഡ് ഷുഗർ, ബി എം ഐ എന്നീ ടെസ്റ്റ് കളും നടത്തി. ക്യാമ്പിൽ പങ്കെടുത്ത 250 ൽപ്പരം രോഗികൾക്ക് സൂപ്പർ സ്പെഷ്യാലിറ്റി വിഭാഗങ്ങളും പരിശോധനകളും പ്രയോജനപ്പെടുത്തി.",

      thumb: "assets/img/Pastevents/352.jpg",
    },
    {
      src: "assets/img/Pastevents/353.jpg",
      caption: "",
      thumb: "assets/img/Pastevents/353.jpg",
    },
    {
      src: "assets/img/Pastevents/354.jpg",
      caption:
        "സുബൈർ കുഞ്ഞു ഫൗണ്ടേഷനും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ ആരോഗ്യമേള സംഘടിപ്പിച്ചു.ആരോഗ്യമേളയിൽ സൂപ്പർ സ്പെഷ്യാലിറ്റി വിഭാഗങളായ കാർഡിയോളജി, ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, ഗ്യാസ്ട്രാളജി, ഓർത്തോ, ഇ എൻ റ്റി, ഗൈനക്കോളജി, ഡയബറ്റോളജി ഒഫ്ത്താൽമോളജീ,ഡൻറ്റൽ. അൾട്രാസൗണ്ട് സ്കാനിംഗ്,എക്കോ കാർഡിയോ ഗ്രാം,ഇ സി ജീ,ഓഡിയോമെട്രിക്എസ് ജീ ഒ റ്റീ,ഏസ് ജീ പീ റ്റീ, ബ്ലഡ് പ്രഷർ, ബ്ലഡ് ഷുഗർ, ബി എം ഐ എന്നീ ടെസ്റ്റ് കളും നടത്തി. ക്യാമ്പിൽ പങ്കെടുത്ത 250 ൽപ്പരം രോഗികൾക്ക് സൂപ്പർ സ്പെഷ്യാലിറ്റി വിഭാഗങ്ങളും പരിശോധനകളും പ്രയോജനപ്പെടുത്തി.",

      thumb: "assets/img/Pastevents/354.jpg",
    },
    {
      src: "assets/img/Pastevents/355.jpg",
      caption:
        "സുബൈർ കുഞ്ഞു ഫൗണ്ടേഷനും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ ആരോഗ്യമേള സംഘടിപ്പിച്ചു.ആരോഗ്യമേളയിൽ സൂപ്പർ സ്പെഷ്യാലിറ്റി വിഭാഗങളായ കാർഡിയോളജി, ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, ഗ്യാസ്ട്രാളജി, ഓർത്തോ, ഇ എൻ റ്റി, ഗൈനക്കോളജി, ഡയബറ്റോളജി ഒഫ്ത്താൽമോളജീ,ഡൻറ്റൽ. അൾട്രാസൗണ്ട് സ്കാനിംഗ്,എക്കോ കാർഡിയോ ഗ്രാം,ഇ സി ജീ,ഓഡിയോമെട്രിക്എസ് ജീ ഒ റ്റീ,ഏസ് ജീ പീ റ്റീ, ബ്ലഡ് പ്രഷർ, ബ്ലഡ് ഷുഗർ, ബി എം ഐ എന്നീ ടെസ്റ്റ് കളും നടത്തി. ക്യാമ്പിൽ പങ്കെടുത്ത 250 ൽപ്പരം രോഗികൾക്ക് സൂപ്പർ സ്പെഷ്യാലിറ്റി വിഭാഗങ്ങളും പരിശോധനകളും പ്രയോജനപ്പെടുത്തി.",

      thumb: "assets/img/Pastevents/355.jpg",
    },
    {
      src: "assets/img/Pastevents/356.jpg",
      caption:
        "സുബൈർ കുഞ്ഞു ഫൗണ്ടേഷനും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ ആരോഗ്യമേള സംഘടിപ്പിച്ചു.ആരോഗ്യമേളയിൽ സൂപ്പർ സ്പെഷ്യാലിറ്റി വിഭാഗങളായ കാർഡിയോളജി, ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, ഗ്യാസ്ട്രാളജി, ഓർത്തോ, ഇ എൻ റ്റി, ഗൈനക്കോളജി, ഡയബറ്റോളജി ഒഫ്ത്താൽമോളജീ,ഡൻറ്റൽ. അൾട്രാസൗണ്ട് സ്കാനിംഗ്,എക്കോ കാർഡിയോ ഗ്രാം,ഇ സി ജീ,ഓഡിയോമെട്രിക്എസ് ജീ ഒ റ്റീ,ഏസ് ജീ പീ റ്റീ, ബ്ലഡ് പ്രഷർ, ബ്ലഡ് ഷുഗർ, ബി എം ഐ എന്നീ ടെസ്റ്റ് കളും നടത്തി. ക്യാമ്പിൽ പങ്കെടുത്ത 250 ൽപ്പരം രോഗികൾക്ക് സൂപ്പർ സ്പെഷ്യാലിറ്റി വിഭാഗങ്ങളും പരിശോധനകളും പ്രയോജനപ്പെടുത്തി.",

      thumb: "assets/img/Pastevents/356.jpg",
    },
    {
      src: "assets/img/Pastevents/357.jpg",
      caption:
        "സുബൈർ കുഞ്ഞു ഫൗണ്ടേഷനും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ ആരോഗ്യമേള സംഘടിപ്പിച്ചു.ആരോഗ്യമേളയിൽ സൂപ്പർ സ്പെഷ്യാലിറ്റി വിഭാഗങളായ കാർഡിയോളജി, ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, ഗ്യാസ്ട്രാളജി, ഓർത്തോ, ഇ എൻ റ്റി, ഗൈനക്കോളജി, ഡയബറ്റോളജി ഒഫ്ത്താൽമോളജീ,ഡൻറ്റൽ. അൾട്രാസൗണ്ട് സ്കാനിംഗ്,എക്കോ കാർഡിയോ ഗ്രാം,ഇ സി ജീ,ഓഡിയോമെട്രിക്എസ് ജീ ഒ റ്റീ,ഏസ് ജീ പീ റ്റീ, ബ്ലഡ് പ്രഷർ, ബ്ലഡ് ഷുഗർ, ബി എം ഐ എന്നീ ടെസ്റ്റ് കളും നടത്തി. ക്യാമ്പിൽ പങ്കെടുത്ത 250 ൽപ്പരം രോഗികൾക്ക് സൂപ്പർ സ്പെഷ്യാലിറ്റി വിഭാഗങ്ങളും പരിശോധനകളും പ്രയോജനപ്പെടുത്തി.",
      thumb: "assets/img/Pastevents/357.jpg",
    },
    {
      src: "assets/img/Pastevents/331.jpg",
      caption:
        "കേരളാ കൗമുദി പാലോട് യൂണിറ്റ്, ബോധ പൗർണമി ക്ലബും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ ഏകദിന  മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീമതി നീതു സജീഷ് (ഗ്രാമപഞ്ചായത്ത് വട്ടപ്പൻക്കാട്)",
      thumb: "assets/img/Pastevents/331.jpg",
    },
    {
      src: "assets/img/Pastevents/332.jpg",
      caption:
        "കേരളാ കൗമുദി പാലോട് യൂണിറ്റ്, ബോധ പൗർണമി ക്ലബും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ ഏകദിന  മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീമതി നീതു സജീഷ് (ഗ്രാമപഞ്ചായത്ത് വട്ടപ്പൻക്കാട്)",
      thumb: "assets/img/Pastevents/332.jpg",
    },
    {
      src: "assets/img/Pastevents/333.jpg",
      caption:
        "കേരളാ കൗമുദി പാലോട് യൂണിറ്റ്, ബോധ പൗർണമി ക്ലബും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ ഏകദിന  മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീമതി നീതു സജീഷ് (ഗ്രാമപഞ്ചായത്ത് വട്ടപ്പൻക്കാട്)",
      thumb: "assets/img/Pastevents/333.jpg",
    },
    {
      src: "assets/img/Pastevents/334.jpg",
      caption:
        "കേരളാ കൗമുദി പാലോട് യൂണിറ്റ്, ബോധ പൗർണമി ക്ലബും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ ഏകദിന  മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീമതി നീതു സജീഷ് (ഗ്രാമപഞ്ചായത്ത് വട്ടപ്പൻക്കാട്)",
      thumb: "assets/img/Pastevents/334.jpg",
    },
    {
      src: "assets/img/Pastevents/335.jpg",
      caption:
        "കേരളാ കൗമുദി പാലോട് യൂണിറ്റ്, ബോധ പൗർണമി ക്ലബും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ ഏകദിന  മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീമതി നീതു സജീഷ് (ഗ്രാമപഞ്ചായത്ത് വട്ടപ്പൻക്കാട്)",
      thumb: "assets/img/Pastevents/335.jpg",
    },
    {
      src: "assets/img/Pastevents/336.jpg",
      caption:
        "കേരളാ കൗമുദി പാലോട് യൂണിറ്റ്, ബോധ പൗർണമി ക്ലബും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ ഏകദിന  മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീമതി നീതു സജീഷ് (ഗ്രാമപഞ്ചായത്ത് വട്ടപ്പൻക്കാട്)",
      thumb: "assets/img/Pastevents/336.jpg",
    },
    {
      src: "assets/img/Pastevents/337.jpg",
      caption:
        "കേരളാ കൗമുദി പാലോട് യൂണിറ്റ്, ബോധ പൗർണമി ക്ലബും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ ഏകദിന  മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീമതി നീതു സജീഷ് (ഗ്രാമപഞ്ചായത്ത് വട്ടപ്പൻക്കാട്)",
      thumb: "assets/img/Pastevents/337.jpg",
    },
    {
      src: "assets/img/Pastevents/338.jpg",
      caption:
        "കേരളാ കൗമുദി പാലോട് യൂണിറ്റ്, ബോധ പൗർണമി ക്ലബും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ ഏകദിന  മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീമതി നീതു സജീഷ് (ഗ്രാമപഞ്ചായത്ത് വട്ടപ്പൻക്കാട്)",
      thumb: "assets/img/Pastevents/338.jpg",
    },
    {
      src: "assets/img/Pastevents/328.jpg",
      caption:
        "കേരളാ കൗമുദി പാലോട് യൂണിറ്റ്, ബോധ പൗർണമി ക്ലബും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ ഏകദിന  മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീമതി നീതു സജീഷ് (ഗ്രാമപഞ്ചായത്ത് വട്ടപ്പൻക്കാട്)",
      thumb: "assets/img/Pastevents/328.jpg",
    },
    {
      src: "assets/img/Pastevents/329.jpg",
      caption:
        "കേരളാ കൗമുദി പാലോട് യൂണിറ്റ്, ബോധ പൗർണമി ക്ലബും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ ഏകദിന  മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീമതി നീതു സജീഷ് (ഗ്രാമപഞ്ചായത്ത് വട്ടപ്പൻക്കാട്)",
      thumb: "assets/img/Pastevents/329.jpg",
    },
    {
      src: "assets/img/Pastevents/330.jpg",
      caption:
        "കേരളാ കൗമുദി പാലോട് യൂണിറ്റ്, ബോധ പൗർണമി ക്ലബും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ ഏകദിന  മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീമതി നീതു സജീഷ് (ഗ്രാമപഞ്ചായത്ത് വട്ടപ്പൻക്കാട്)",
      thumb: "assets/img/Pastevents/330.jpg",
    },
    {
      src: "assets/img/Pastevents/316.jpg",
      caption:
        "സിഎസ്ഐ ചർച്ച് കുട്ടനിന്നതിൽ, തിരുപുറവും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീമതി ഷീന എസ് ദാസ് ( തിരുപുറം ഗ്രാമപഞ്ചായത്ത് പ്രസിഡൻ്റ്).",
      thumb: "assets/img/Pastevents/316.jpg",
    },
    {
      src: "assets/img/Pastevents/317.jpg",
      caption:
        "സിഎസ്ഐ ചർച്ച് കുട്ടനിന്നതിൽ, തിരുപുറവും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീമതി ഷീന എസ് ദാസ് ( തിരുപുറം ഗ്രാമപഞ്ചായത്ത് പ്രസിഡൻ്റ്).",
      thumb: "assets/img/Pastevents/317.jpg",
    },
    {
      src: "assets/img/Pastevents/318.jpg",
      caption:
        "സിഎസ്ഐ ചർച്ച് കുട്ടനിന്നതിൽ, തിരുപുറവും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീമതി ഷീന എസ് ദാസ് ( തിരുപുറം ഗ്രാമപഞ്ചായത്ത് പ്രസിഡൻ്റ്).",
      thumb: "assets/img/Pastevents/318.jpg",
    },
    {
      src: "assets/img/Pastevents/319.jpg",
      caption:
        "സിഎസ്ഐ ചർച്ച് കുട്ടനിന്നതിൽ, തിരുപുറവും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീമതി ഷീന എസ് ദാസ് ( തിരുപുറം ഗ്രാമപഞ്ചായത്ത് പ്രസിഡൻ്റ്).",
      thumb: "assets/img/Pastevents/319.jpg",
    },
    {
      src: "assets/img/Pastevents/320.jpg",
      caption:
        "സിഎസ്ഐ ചർച്ച് കുട്ടനിന്നതിൽ, തിരുപുറവും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീമതി ഷീന എസ് ദാസ് ( തിരുപുറം ഗ്രാമപഞ്ചായത്ത് പ്രസിഡൻ്റ്).",
      thumb: "assets/img/Pastevents/320.jpg",
    },
    {
      src: "assets/img/Pastevents/321.jpg",
      caption:
        "സിഎസ്ഐ ചർച്ച് കുട്ടനിന്നതിൽ, തിരുപുറവും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീമതി ഷീന എസ് ദാസ് ( തിരുപുറം ഗ്രാമപഞ്ചായത്ത് പ്രസിഡൻ്റ്).",
      thumb: "assets/img/Pastevents/321.jpg",
    },
    {
      src: "assets/img/Pastevents/322.jpg",
      caption:
        "സിഎസ്ഐ ചർച്ച് കുട്ടനിന്നതിൽ, തിരുപുറവും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീമതി ഷീന എസ് ദാസ് ( തിരുപുറം ഗ്രാമപഞ്ചായത്ത് പ്രസിഡൻ്റ്).",
      thumb: "assets/img/Pastevents/322.jpg",
    },
    {
      src: "assets/img/Pastevents/323.jpg",
      caption:
        "സിഎസ്ഐ ചർച്ച് കുട്ടനിന്നതിൽ, തിരുപുറവും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീമതി ഷീന എസ് ദാസ് ( തിരുപുറം ഗ്രാമപഞ്ചായത്ത് പ്രസിഡൻ്റ്).",
      thumb: "assets/img/Pastevents/323.jpg",
    },
    {
      src: "assets/img/Pastevents/324.jpg",
      caption:
        "സിഎസ്ഐ ചർച്ച് കുട്ടനിന്നതിൽ, തിരുപുറവും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീമതി ഷീന എസ് ദാസ് ( തിരുപുറം ഗ്രാമപഞ്ചായത്ത് പ്രസിഡൻ്റ്).",
      thumb: "assets/img/Pastevents/324.jpg",
    },
    {
      src: "assets/img/Pastevents/325.jpg",
      caption:
        "സിഎസ്ഐ ചർച്ച് കുട്ടനിന്നതിൽ, തിരുപുറവും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീമതി ഷീന എസ് ദാസ് ( തിരുപുറം ഗ്രാമപഞ്ചായത്ത് പ്രസിഡൻ്റ്).",
      thumb: "assets/img/Pastevents/325.jpg",
    },
    {
      src: "assets/img/Pastevents/326.jpg",
      caption:
        "സിഎസ്ഐ ചർച്ച് കുട്ടനിന്നതിൽ, തിരുപുറവും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീമതി ഷീന എസ് ദാസ് ( തിരുപുറം ഗ്രാമപഞ്ചായത്ത് പ്രസിഡൻ്റ്).",
      thumb: "assets/img/Pastevents/326.jpg",
    },
    {
      src: "assets/img/Pastevents/327.jpg",
      caption:
        "സിഎസ്ഐ ചർച്ച് കുട്ടനിന്നതിൽ, തിരുപുറവും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീമതി ഷീന എസ് ദാസ് ( തിരുപുറം ഗ്രാമപഞ്ചായത്ത് പ്രസിഡൻ്റ്).",
      thumb: "assets/img/Pastevents/327.jpg",
    },
    {
      src: "assets/img/Pastevents/302.jpg",
      caption:
        "Kerala Kaumudi-Bodha Pournami Club and Nims Medicity jointly organized a free medical camp. Camp Inauguration Shri SV Vikraman (Kerala Kaumudi Chief) Chief Guest: Shailaja Rajeevan (Nandiyodu Grama Panchayat President)",
      thumb: "assets/img/Pastevents/302.jpg",
    },
    {
      src: "assets/img/Pastevents/303.jpg",
      caption:
        "Kerala Kaumudi-Bodha Pournami Club and Nims Medicity jointly organized a free medical camp. Camp Inauguration Shri SV Vikraman (Kerala Kaumudi Chief) Chief Guest: Shailaja Rajeevan (Nandiyodu Grama Panchayat President)",
      thumb: "assets/img/Pastevents/303.jpg",
    },
    {
      src: "assets/img/Pastevents/304.jpg",
      caption:
        "Kerala Kaumudi-Bodha Pournami Club and Nims Medicity jointly organized a free medical camp. Camp Inauguration Shri SV Vikraman (Kerala Kaumudi Chief) Chief Guest: Shailaja Rajeevan (Nandiyodu Grama Panchayat President)",
      thumb: "assets/img/Pastevents/304.jpg",
    },
    {
      src: "assets/img/Pastevents/305.jpg",
      caption:
        "Kerala Kaumudi-Bodha Pournami Club and Nims Medicity jointly organized a free medical camp. Camp Inauguration Shri SV Vikraman (Kerala Kaumudi Chief) Chief Guest: Shailaja Rajeevan (Nandiyodu Grama Panchayat President)",
      thumb: "assets/img/Pastevents/305.jpg",
    },
    {
      src: "assets/img/Pastevents/306.jpg",
      caption:
        "Kerala Kaumudi-Bodha Pournami Club and Nims Medicity jointly organized a free medical camp. Camp Inauguration Shri SV Vikraman (Kerala Kaumudi Chief) Chief Guest: Shailaja Rajeevan (Nandiyodu Grama Panchayat President)",
      thumb: "assets/img/Pastevents/306.jpg",
    },
    {
      src: "assets/img/Pastevents/307.jpg",
      caption:
        "Kerala Kaumudi-Bodha Pournami Club and Nims Medicity jointly organized a free medical camp. Camp Inauguration Shri SV Vikraman (Kerala Kaumudi Chief) Chief Guest: Shailaja Rajeevan (Nandiyodu Grama Panchayat President)",
      thumb: "assets/img/Pastevents/307.jpg",
    },
    {
      src: "assets/img/Pastevents/308.jpg",
      caption:
        "Kerala Kaumudi-Bodha Pournami Club and Nims Medicity jointly organized a free medical camp. Camp Inauguration Shri SV Vikraman (Kerala Kaumudi Chief) Chief Guest: Shailaja Rajeevan (Nandiyodu Grama Panchayat President)",
      thumb: "assets/img/Pastevents/308.jpg",
    },
    {
      src: "assets/img/Pastevents/309.jpg",
      caption:
        "Kerala Kaumudi-Bodha Pournami Club and Nims Medicity jointly organized a free medical camp. Camp Inauguration Shri SV Vikraman (Kerala Kaumudi Chief) Chief Guest: Shailaja Rajeevan (Nandiyodu Grama Panchayat President)",
      thumb: "assets/img/Pastevents/309.jpg",
    },
    {
      src: "assets/img/Pastevents/310.jpg",
      caption:
        "Kerala Kaumudi-Bodha Pournami Club and Nims Medicity jointly organized a free medical camp. Camp Inauguration Shri SV Vikraman (Kerala Kaumudi Chief) Chief Guest: Shailaja Rajeevan (Nandiyodu Grama Panchayat President)",
      thumb: "assets/img/Pastevents/130.jpg",
    },
    {
      src: "assets/img/Pastevents/311.jpg",
      caption:
        "Kerala Kaumudi-Bodha Pournami Club and Nims Medicity jointly organized a free medical camp. Camp Inauguration Shri SV Vikraman (Kerala Kaumudi Chief) Chief Guest: Shailaja Rajeevan (Nandiyodu Grama Panchayat President)",
      thumb: "assets/img/Pastevents/311.jpg",
    },
    {
      src: "assets/img/Pastevents/312.jpg",
      caption:
        "Kerala Kaumudi-Bodha Pournami Club and Nims Medicity jointly organized a free medical camp. Camp Inauguration Shri SV Vikraman (Kerala Kaumudi Chief) Chief Guest: Shailaja Rajeevan (Nandiyodu Grama Panchayat President)",
      thumb: "assets/img/Pastevents/312.jpg",
    },
    {
      src: "assets/img/Pastevents/313.jpg",
      caption:
        "Kerala Kaumudi-Bodha Pournami Club and Nims Medicity jointly organized a free medical camp. Camp Inauguration Shri SV Vikraman (Kerala Kaumudi Chief) Chief Guest: Shailaja Rajeevan (Nandiyodu Grama Panchayat President)",
      thumb: "assets/img/Pastevents/313.jpg",
    },
    {
      src: "assets/img/Pastevents/314.jpg",
      caption:
        "Kerala Kaumudi-Bodha Pournami Club and Nims Medicity jointly organized a free medical camp. Camp Inauguration Shri SV Vikraman (Kerala Kaumudi Chief) Chief Guest: Shailaja Rajeevan (Nandiyodu Grama Panchayat President)",
      thumb: "assets/img/Pastevents/313.jpg",
    },
    {
      src: "assets/img/Pastevents/315.jpg",
      caption:
        "Kerala Kaumudi-Bodha Pournami Club and Nims Medicity jointly organized a free medical camp. Camp Inauguration Shri SV Vikraman (Kerala Kaumudi Chief) Chief Guest: Shailaja Rajeevan (Nandiyodu Grama Panchayat President)",
      thumb: "assets/img/Pastevents/313.jpg",
    },
    {
      src: "assets/img/Pastevents/292.jpg",
      caption:
        "Vattiyoorkavu Model Lions Club, Arasummoodu East Residential Association and NIMS Medicity jointly organized a one day mega medical camp. Camp Inauguration Smt. Sridevi (Attipra Ward Councilor)",
      thumb: "assets/img/Pastevents/292.jpg",
    },
    {
      src: "assets/img/Pastevents/293.jpg",
      caption:
        "Vattiyoorkavu Model Lions Club, Arasummoodu East Residential Association and NIMS Medicity jointly organized a one day mega medical camp. Camp Inauguration Smt. Sridevi (Attipra Ward Councilor)",
      thumb: "assets/img/Pastevents/293.jpg",
    },
    {
      src: "assets/img/Pastevents/294.jpg",
      caption:
        "Vattiyoorkavu Model Lions Club, Arasummoodu East Residential Association and NIMS Medicity jointly organized a one day mega medical camp. Camp Inauguration Smt. Sridevi (Attipra Ward Councilor)",
      thumb: "assets/img/Pastevents/294.jpg",
    },
    {
      src: "assets/img/Pastevents/295.jpg",
      caption:
        "Vattiyoorkavu Model Lions Club, Arasummoodu East Residential Association and NIMS Medicity jointly organized a one day mega medical camp. Camp Inauguration Smt. Sridevi (Attipra Ward Councilor)",
      thumb: "assets/img/Pastevents/295.jpg",
    },
    {
      src: "assets/img/Pastevents/296.jpg",
      caption:
        "1Vattiyoorkavu Model Lions Club, Arasummoodu East Residential Association and NIMS Medicity jointly organized a one day mega medical camp. Camp Inauguration Smt. Sridevi (Attipra Ward Councilor)6",
      thumb: "assets/img/Pastevents/296.jpg",
    },
    {
      src: "assets/img/Pastevents/297.jpg",
      caption:
        "Vattiyoorkavu Model Lions Club, Arasummoodu East Residential Association and NIMS Medicity jointly organized a one day mega medical camp. Camp Inauguration Smt. Sridevi (Attipra Ward Councilor)",
      thumb: "assets/img/Pastevents/297.jpg",
    },
    {
      src: "assets/img/Pastevents/298.jpg",
      caption:
        "Vattiyoorkavu Model Lions Club, Arasummoodu East Residential Association and NIMS Medicity jointly organized a one day mega medical camp. Camp Inauguration Smt. Sridevi (Attipra Ward Councilor)",
      thumb: "assets/img/Pastevents/298.jpg",
    },
    {
      src: "assets/img/Pastevents/299.jpg",
      caption:
        "Vattiyoorkavu Model Lions Club, Arasummoodu East Residential Association and NIMS Medicity jointly organized a one day mega medical camp. Camp Inauguration Smt. Sridevi (Attipra Ward Councilor)",
      thumb: "assets/img/Pastevents/299.jpg",
    },
    {
      src: "assets/img/Pastevents/300.jpg",
      caption:
        "Vattiyoorkavu Model Lions Club, Arasummoodu East Residential Association and NIMS Medicity jointly organized a one day mega medical camp. Camp Inauguration Smt. Sridevi (Attipra Ward Councilor)",
      thumb: "assets/img/Pastevents/300.jpg",
    },
    {
      src: "assets/img/Pastevents/301.jpg",
      caption:
        "Vattiyoorkavu Model Lions Club, Arasummoodu East Residential Association and NIMS Medicity jointly organized a one day mega medical camp. Camp Inauguration Smt. Sridevi (Attipra Ward Councilor)",
      thumb: "assets/img/Pastevents/301.jpg",
    },
    {
      src: "assets/img/Pastevents/283.jpg",
      caption:
        "ട്രിവാൻഡ്രം ഇംപാക്ട് ലയൺസ് ക്ലബ്, സിപിഎം കരയാളത്തുക്കോണം വാർഡ് കമ്മറ്റിയും നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം സ. ബി ബിജു (സിപിഎം പേരൂർക്കട ബ്രാഞ്ച്)",
      thumb: "assets/img/Pastevents/283.jpg",
    },
    {
      src: "assets/img/Pastevents/284.jpg",
      caption:
        "ട്രിവാൻഡ്രം ഇംപാക്ട് ലയൺസ് ക്ലബ്, സിപിഎം കരയാളത്തുക്കോണം വാർഡ് കമ്മറ്റിയും നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം സ. ബി ബിജു (സിപിഎം പേരൂർക്കട ബ്രാഞ്ച്)",
      thumb: "assets/img/Pastevents/284.jpg",
    },
    {
      src: "assets/img/Pastevents/285.jpg",
      caption:
        "ട്രിവാൻഡ്രം ഇംപാക്ട് ലയൺസ് ക്ലബ്, സിപിഎം കരയാളത്തുക്കോണം വാർഡ് കമ്മറ്റിയും നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം സ. ബി ബിജു (സിപിഎം പേരൂർക്കട ബ്രാഞ്ച്)",
      thumb: "assets/img/Pastevents/285.jpg",
    },
    {
      src: "assets/img/Pastevents/286.jpg",
      caption:
        "ട്രിവാൻഡ്രം ഇംപാക്ട് ലയൺസ് ക്ലബ്, സിപിഎം കരയാളത്തുക്കോണം വാർഡ് കമ്മറ്റിയും നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം സ. ബി ബിജു (സിപിഎം പേരൂർക്കട ബ്രാഞ്ച്)",
      thumb: "assets/img/Pastevents/286.jpg",
    },
    {
      src: "assets/img/Pastevents/287.jpg",
      caption:
        "ട്രിവാൻഡ്രം ഇംപാക്ട് ലയൺസ് ക്ലബ്, സിപിഎം കരയാളത്തുക്കോണം വാർഡ് കമ്മറ്റിയും നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം സ. ബി ബിജു (സിപിഎം പേരൂർക്കട ബ്രാഞ്ച്)",
      thumb: "assets/img/Pastevents/287.jpg",
    },
    {
      src: "assets/img/Pastevents/288.jpg",
      caption:
        "ട്രിവാൻഡ്രം ഇംപാക്ട് ലയൺസ് ക്ലബ്, സിപിഎം കരയാളത്തുക്കോണം വാർഡ് കമ്മറ്റിയും നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം സ. ബി ബിജു (സിപിഎം പേരൂർക്കട ബ്രാഞ്ച്)",
      thumb: "assets/img/Pastevents/288.jpg",
    },
    {
      src: "assets/img/Pastevents/289.jpg",
      caption:
        "ട്രിവാൻഡ്രം ഇംപാക്ട് ലയൺസ് ക്ലബ്, സിപിഎം കരയാളത്തുക്കോണം വാർഡ് കമ്മറ്റിയും നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം സ. ബി ബിജു (സിപിഎം പേരൂർക്കട ബ്രാഞ്ച്)",
      thumb: "assets/img/Pastevents/289.jpg",
    },
    {
      src: "assets/img/Pastevents/290.jpg",
      caption:
        "ട്രിവാൻഡ്രം ഇംപാക്ട് ലയൺസ് ക്ലബ്, സിപിഎം കരയാളത്തുക്കോണം വാർഡ് കമ്മറ്റിയും നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം സ. ബി ബിജു (സിപിഎം പേരൂർക്കട ബ്രാഞ്ച്)",
      thumb: "assets/img/Pastevents/290.jpg",
    },
    {
      src: "assets/img/Pastevents/291.jpg",
      caption:
        "ട്രിവാൻഡ്രം ഇംപാക്ട് ലയൺസ് ക്ലബ്, സിപിഎം കരയാളത്തുക്കോണം വാർഡ് കമ്മറ്റിയും നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം സ. ബി ബിജു (സിപിഎം പേരൂർക്കട ബ്രാഞ്ച്)",
      thumb: "assets/img/Pastevents/291.jpg",
    },
    {
      src: "assets/img/Pastevents/273.jpg",
      caption:
        "ട്രിവാൻഡ്രം ഹോസ്റ്റ് ലയൺസ് ക്ലബ്ബ്, സിപിഎം വാർഡ് കിഴക്കേലയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീമതി .U ലേഖ റാണി (പ്രസിഡൻ്റ് കരകുളം ",
      thumb: "assets/img/Pastevents/273.jpg",
    },
    {
      src: "assets/img/Pastevents/274.jpg",
      caption:
        "ട്രിവാൻഡ്രം ഹോസ്റ്റ് ലയൺസ് ക്ലബ്ബ്, സിപിഎം വാർഡ് കിഴക്കേലയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/274.jpg",
    },
    {
      src: "assets/img/Pastevents/275.jpg",
      caption:
        "ട്രിവാൻഡ്രം ഹോസ്റ്റ് ലയൺസ് ക്ലബ്ബ്, സിപിഎം വാർഡ് കിഴക്കേലയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/275.jpg",
    },
    {
      src: "assets/img/Pastevents/276.jpg",
      caption:
        "ട്രിവാൻഡ്രം ഹോസ്റ്റ് ലയൺസ് ക്ലബ്ബ്, സിപിഎം വാർഡ് കിഴക്കേലയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/276.jpg",
    },
    {
      src: "assets/img/Pastevents/277.jpg",
      caption:
        "ട്രിവാൻഡ്രം ഹോസ്റ്റ് ലയൺസ് ക്ലബ്ബ്, സിപിഎം വാർഡ് കിഴക്കേലയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/277.jpg",
    },
    {
      src: "assets/img/Pastevents/278.jpg",
      caption:
        "ട്രിവാൻഡ്രം ഹോസ്റ്റ് ലയൺസ് ക്ലബ്ബ്, സിപിഎം വാർഡ് കിഴക്കേലയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/278.jpg",
    },
    {
      src: "assets/img/Pastevents/279.jpg",
      caption:
        "ട്രിവാൻഡ്രം ഹോസ്റ്റ് ലയൺസ് ക്ലബ്ബ്, സിപിഎം വാർഡ് കിഴക്കേലയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/279.jpg",
    },
    {
      src: "assets/img/Pastevents/280.jpg",
      caption:
        "ട്രിവാൻഡ്രം ഹോസ്റ്റ് ലയൺസ് ക്ലബ്ബ്, സിപിഎം വാർഡ് കിഴക്കേലയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/280.jpg",
    },
    {
      src: "assets/img/Pastevents/281.jpg",
      caption:
        "ട്രിവാൻഡ്രം ഹോസ്റ്റ് ലയൺസ് ക്ലബ്ബ്, സിപിഎം വാർഡ് കിഴക്കേലയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/281.jpg",
    },
    {
      src: "assets/img/Pastevents/282.jpg",
      caption:
        "ട്രിവാൻഡ്രം ഹോസ്റ്റ് ലയൺസ് ക്ലബ്ബ്, സിപിഎം വാർഡ് കിഴക്കേലയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/282.jpg",
    },
    {
      src: "assets/img/Pastevents/229.jpg",
      caption:
        "The Kerala State Excise Department jointly organized a mega medical camp on World Heart Day under the joint auspices of Drug Eradication Mission Vimukthi, Nedumangad Government College NSS Unit and Nims Medicity. Camp Inauguration: Peringammala Grama Panchayat President Shri Shinu Madathara",
      thumb: "assets/img/Pastevents/229.jpg",
    },
    {
      src: "assets/img/Pastevents/230.jpg",
      caption:
        "The Kerala State Excise Department jointly organized a mega medical camp on World Heart Day under the joint auspices of Drug Eradication Mission Vimukthi, Nedumangad Government College NSS Unit and Nims Medicity.",
      thumb: "assets/img/Pastevents/230.jpg",
    },
    {
      src: "assets/img/Pastevents/231.jpg",
      caption:
        "The Kerala State Excise Department jointly organized a mega medical camp on World Heart Day under the joint auspices of Drug Eradication Mission Vimukthi, Nedumangad Government College NSS Unit and Nims Medicity.",
      thumb: "assets/img/Pastevents/231.jpg",
    },
    {
      src: "assets/img/Pastevents/232.jpg",
      caption:
        "The Kerala State Excise Department jointly organized a mega medical camp on World Heart Day under the joint auspices of Drug Eradication Mission Vimukthi, Nedumangad Government College NSS Unit and Nims Medicity.",
      thumb: "assets/img/Pastevents/232.jpg",
    },
    {
      src: "assets/img/Pastevents/233.jpg",
      caption:
        "The Kerala State Excise Department jointly organized a mega medical camp on World Heart Day under the joint auspices of Drug Eradication Mission Vimukthi, Nedumangad Government College NSS Unit and Nims Medicity.",
      thumb: "assets/img/Pastevents/233.jpg",
    },
    {
      src: "assets/img/Pastevents/234.jpg",
      caption:
        "The Kerala State Excise Department jointly organized a mega medical camp on World Heart Day under the joint auspices of Drug Eradication Mission Vimukthi, Nedumangad Government College NSS Unit and Nims Medicity.",
      thumb: "assets/img/Pastevents/234.jpg",
    },
    {
      src: "assets/img/Pastevents/235.jpg",
      caption:
        "The Kerala State Excise Department jointly organized a mega medical camp on World Heart Day under the joint auspices of Drug Eradication Mission Vimukthi, Nedumangad Government College NSS Unit and Nims Medicity.",
      thumb: "assets/img/Pastevents/235.jpg",
    },
    {
      src: "assets/img/Pastevents/236.jpg",
      caption:
        "The Kerala State Excise Department jointly organized a mega medical camp on World Heart Day under the joint auspices of Drug Eradication Mission Vimukthi, Nedumangad Government College NSS Unit and Nims Medicity.",
      thumb: "assets/img/Pastevents/236.jpg",
    },
    {
      src: "assets/img/Pastevents/238.jpg",
      caption:
        "The Kerala State Excise Department jointly organized a mega medical camp on World Heart Day under the joint auspices of Drug Eradication Mission Vimukthi, Nedumangad Government College NSS Unit and Nims Medicity.",
      thumb: "assets/img/Pastevents/238.jpg",
    },
    {
      src: "assets/img/Pastevents/239.jpg",
      caption:
        "The Kerala State Excise Department jointly organized a mega medical camp on World Heart Day under the joint auspices of Drug Eradication Mission Vimukthi, Nedumangad Government College NSS Unit and Nims Medicity.",
      thumb: "assets/img/Pastevents/239.jpg",
    },
    {
      src: "assets/img/Pastevents/240.jpg",
      caption:
        "The Kerala State Excise Department jointly organized a mega medical camp on World Heart Day under the joint auspices of Drug Eradication Mission Vimukthi, Nedumangad Government College NSS Unit and Nims Medicity.",
      thumb: "assets/img/Pastevents/240.jpg",
    },
    {
      src: "assets/img/Pastevents/241.jpg",
      caption:
        "The Kerala State Excise Department jointly organized a mega medical camp on World Heart Day under the joint auspices of Drug Eradication Mission Vimukthi, Nedumangad Government College NSS Unit and Nims Medicity.",
      thumb: "assets/img/Pastevents/241.jpg",
    },
    {
      src: "assets/img/Pastevents/242.jpg",
      caption:
        "The Kerala State Excise Department jointly organized a mega medical camp on World Heart Day under the joint auspices of Drug Eradication Mission Vimukthi, Nedumangad Government College NSS Unit and Nims Medicity.",
      thumb: "assets/img/Pastevents/242.jpg",
    },
    {
      src: "assets/img/Pastevents/243.jpg",
      caption:
        "The Kerala State Excise Department jointly organized a mega medical camp on World Heart Day under the joint auspices of Drug Eradication Mission Vimukthi, Nedumangad Government College NSS Unit and Nims Medicity.",
      thumb: "assets/img/Pastevents/243.jpg",
    },
    {
      src: "assets/img/Pastevents/244.jpg",
      caption:
        "The Kerala State Excise Department jointly organized a mega medical camp on World Heart Day under the joint auspices of Drug Eradication Mission Vimukthi, Nedumangad Government College NSS Unit and Nims Medicity.",
      thumb: "assets/img/Pastevents/244.jpg",
    },
    {
      src: "assets/img/Pastevents/245.jpg",
      caption:
        "കോവിഡ് കാലത്ത് ഏഴായിരത്തിലധികം രോഗികളെ ചികിൽസിച്ചു ഭേദമാക്കാനായെന്നും കേരളത്തിലെ  സൗജന്യ ഹൃദയ ശസ്ത്രക്രിയ ക്യാമ്പ്  ജനകീയമാക്കുന്നതിൽ  നിംസ് ഹാർട്ട് ഫൗണ്ടേഷന് നിർണ്ണായക പങ്കുണ്ടെന്നു  പറയുന്നതിൽ അഭിമാനമുണ്ടെന്നും എം.എസ്  ഫൈസൽ ഖാൻ  പ്രസ്താവിച്ചു.",
      thumb: "assets/img/Pastevents/245.jpg",
    },
    {
      src: "assets/img/Pastevents/246.jpg",
      caption:
        "ആരോഗ്യ മേഖലയിൽ നൈതികതയും ജീവകാരുണ്യവും സംഗമിച്ച അപൂർവ്വം ആതുരാലയങ്ങളിലൊന്നാണ് നെയ്യാറ്റിൻകര നിംസ് മെഡിസിറ്റിയെന്ന് പി.കെ. ബഷീർ എം.എൽ.എ.പ്രസ്താവിച്ചു.",
      thumb: "assets/img/Pastevents/246.jpg",
    },
    {
      src: "assets/img/Pastevents/247.jpg",
      caption:
        "നിംസ് റൈൻവാട്ടർ ഹാർവെസ്റ്റിംഗ് ഫോർ ഡയാലിസിസ് പദ്ധതി ലോഗോ എം.എസ് ഫൈസൽ ഖാനു നൽകി കൊണ്ട് പി.കെ. ബഷീർ എം.എൽ.എ. പ്രകാശനം ചെയ്തു. ",
      thumb: "assets/img/Pastevents/247.jpg",
    },
    {
      src: "assets/img/Pastevents/248.jpg",
      caption:
        "A two-day free heart diagnosis camp is being held in NIMS Hospital on the occasion of World Heart Day. P.K Basheer MLA inaugurated the function",
      thumb: "assets/img/Pastevents/248.jpg",
    },
    {
      src: "assets/img/Pastevents/249.jpg",
      caption:
        "A two-day free heart diagnosis camp is being held in NIMS Hospital on the occasion of World Heart Day. P.K Basheer MLA inaugurated the function",
      thumb: "assets/img/Pastevents/249.jpg",
    },
    {
      src: "assets/img/Pastevents/250.jpg",
      caption:
        "A two-day free heart diagnosis camp is being held in NIMS Hospital on the occasion of World Heart Day. P.K Basheer MLA inaugurated the function",
      thumb: "assets/img/Pastevents/250.jpg",
    },
    {
      src: "assets/img/Pastevents/251.jpg",
      caption:
        "A two-day free heart diagnosis camp is being held in NIMS Hospital on the occasion of World Heart Day. P.K Basheer MLA inaugurated the function",
      thumb: "assets/img/Pastevents/251.jpg",
    },
    {
      src: "assets/img/Pastevents/252.jpg",
      caption:
        "കോവിഡ് രോഗ  വേളയിൽ മികച്ച സേവനം കാഴ്ച്ചവെച്ച നിംസിലെ ഡോക്ടർ അനീഷിന്റെ നേതൃത്വത്തിലുള്ള ടീമംഗങ്ങൾക്കുള്ള ഉപഹാരവും പി.കെ. ബഷീർ നിർവ്വഹിച്ചു. ",
      thumb: "assets/img/Pastevents/252.jpg",
    },
    {
      src: "assets/img/Pastevents/253.jpg",
      caption:
        "കോവിഡ് രോഗ  വേളയിൽ മികച്ച സേവനം കാഴ്ച്ചവെച്ച നിംസിലെ ഡോക്ടർ അനീഷിന്റെ നേതൃത്വത്തിലുള്ള ടീമംഗങ്ങൾക്കുള്ള ഉപഹാരവും പി.കെ. ബഷീർ നിർവ്വഹിച്ചു. ",
      thumb: "assets/img/Pastevents/253.jpg",
    },
    {
      src: "assets/img/Pastevents/254.jpg",
      caption:
        "കോവിഡ് രോഗ  വേളയിൽ മികച്ച സേവനം കാഴ്ച്ചവെച്ച നിംസിലെ ഡോക്ടർ അനീഷിന്റെ നേതൃത്വത്തിലുള്ള ടീമംഗങ്ങൾക്കുള്ള ഉപഹാരവും പി.കെ. ബഷീർ നിർവ്വഹിച്ചു. ",
      thumb: "assets/img/Pastevents/254.jpg",
    },
    {
      src: "assets/img/Pastevents/255.jpg",
      caption: "",
      thumb: "assets/img/Pastevents/255.jpg",
    },
    {
      src: "assets/img/Pastevents/256.jpg",
      caption: "",
      thumb: "assets/img/Pastevents/256.jpg",
    },
    {
      src: "assets/img/Pastevents/257.jpg",
      caption: "",
      thumb: "assets/img/Pastevents/257.jpg",
    },
    {
      src: "assets/img/Pastevents/258.jpg",
      caption: "",
      thumb: "assets/img/Pastevents/258.jpg",
    },
    {
      src: "assets/img/Pastevents/259.jpg",
      caption:
        "ലോക ഹൃദയദിനത്തോടനുബന്ധിച്ച്‌ നിംസ്  ഹാർട്ട് ഫൗണ്ടേഷന്റെ ആഭിമുഖ്യത്തിൽ സൗജന്യ ഹൃദയാരോഗ്യമേള നിംസിൽ  വിദ്യാഭ്യാസ  വകുപ്പ് മന്ത്രി ശ്രി. വി. ശിവൻകുട്ടി  ഉദ്‌ഘാടനം ചെയ്തു.",
      thumb: "assets/img/Pastevents/259.jpg",
    },
    {
      src: "assets/img/Pastevents/260.jpg",
      caption: "",
      thumb: "assets/img/Pastevents/260.jpg",
    },
    {
      src: "assets/img/Pastevents/261.jpg",
      caption: "",
      thumb: "assets/img/Pastevents/261.jpg",
    },
    {
      src: "assets/img/Pastevents/262.jpg",
      caption: "",
      thumb: "assets/img/Pastevents/262.jpg",
    },
    {
      src: "assets/img/Pastevents/263.jpg",
      caption:
        "മമ്മുട്ടിയുമായി  കൈകോർത്തു നിംസ് തുടങ്ങിയ നിംസ് ഹാർട്ട് ഫൗണ്ടേഷന്റെ ഹൃദയാരോഗ്യമേളകൾ  മറ്റു സ്വകാര്യ  ആശുപത്രികൾക്കും വഴികാട്ടട്ടെ എന്ന് പ്രത്യാശിക്കുന്നതായി വിദ്യാഭ്യാസ  വകുപ്പ് മന്ത്രി ശ്രി. വി. ശിവൻകുട്ടി അഭിപ്രായപ്പെട്ടു. ",
      thumb: "assets/img/Pastevents/263.jpg",
    },
    {
      src: "assets/img/Pastevents/264.jpg",
      caption:
        "ചികിത്സ ചെലവുകൾ രോഗികൾക്ക് ബാധ്യതയാവാത്തവിധം നിംസ് ചെയ്തുവരുന്ന വിവിധ സേവനങ്ങൾ  പ്രശംസനീയമാണെന്നും  മന്ത്രി ശ്രി. വി. ശിവൻകുട്ടി പറഞ്ഞു.",
      thumb: "assets/img/Pastevents/264.jpg",
    },
    {
      src: "assets/img/Pastevents/265.jpg",
      caption:
        "പതിറ്റാണ്ടുകളായി കേരളത്തിൽ പൊതു ആരോഗ്യമേഖലയും സ്വകാര്യമേഖലയും  കൈകോർത്തു മുന്നേറുകയാണ്. കോവിഡ് കാലത്തെ മരണ സംഘ്യകളിൽ ഏറെയും ഹൃദ്രോഗികളുടേതായിരുന്നു. അതുകൊണ്ടുതന്നെ ഹൃദയാരോഗ്യം ഉറപ്പാക്കേണ്ടത് നാമോരോരുത്തരുടെയും കടമയാണ്, വിദ്യാഭ്യാസ  വകുപ്പ് മന്ത്രി ശ്രി. വി. ശിവൻകുട്ടി  കൂട്ടിച്ചേർത്തു.",
      thumb: "assets/img/Pastevents/265.jpg",
    },
    {
      src: "assets/img/Pastevents/266.jpg",
      caption:
        "വിവിധ മേഖലകളിൽ കഴിവ് തെളിയിച്ച പ്രതിഭകൾക്കുള്ള നിംസ് ഉപഹാരസമർപ്പണവും മന്ത്രി ശ്രി.ശിവൻകുട്ടി നിർവ്വഹിച്ചു. ശ്രി.കെ.വി. ഷാജി( മികച്ച അധ്യാപകൻ )",
      thumb: "assets/img/Pastevents/266.jpg",
    },
    {
      src: "assets/img/Pastevents/267.jpg",
      caption:
        "വിവിധ മേഖലകളിൽ കഴിവ് തെളിയിച്ച പ്രതിഭകൾക്കുള്ള നിംസ് ഉപഹാരസമർപ്പണവും മന്ത്രി ശ്രി.ശിവൻകുട്ടി നിർവ്വഹിച്ചു. കെ. പി.ദീപ ( കെ എസ് ആർ ടി സി ഉദ്യോഗസ്ഥ,  കവിത രചന, സാമൂഹ്യ പ്രവർത്തനം)",
      thumb: "assets/img/Pastevents/267.jpg",
    },
    {
      src: "assets/img/Pastevents/268.jpg",
      caption:
        "വിവിധ മേഖലകളിൽ കഴിവ് തെളിയിച്ച പ്രതിഭകൾക്കുള്ള നിംസ് ഉപഹാരസമർപ്പണവും മന്ത്രി ശ്രി.ശിവൻകുട്ടി നിർവ്വഹിച്ചു. ഡോക്ടർ ജെ.എസ്. ഭാഗ്യ ശ്രീ (ആയുർവേദ ഓർത്തോ പെടിക്സ് സര്ജറി ഒന്നാം റാങ്ക്)",
      thumb: "assets/img/Pastevents/268.jpg",
    },
    {
      src: "assets/img/Pastevents/269.jpg",
      caption: "",
      thumb: "assets/img/Pastevents/269.jpg",
    },
    {
      src: "assets/img/Pastevents/270.jpg",
      caption:
        "മഹാരോഗ  വേളയിൽ   ആതുര  സേവനങ്ങളിൽ  മുഴുകിയ എല്ലാ കോവിഡ് പോരാളികൾക്കും നിംസ് നഴ്സിങ് വിദ്യാർത്ഥികളുടെ സ്നേഹാദരങ്ങളോട് കൂടിയുള്ള അനുഭവങ്ങൾ പങ്കുവെക്കുന്ന വീഡിയോ പ്രകാശന കർമ്മവും  മന്ത്രി ശ്രി.ശിവൻകുട്ടി നിർവ്വഹിച്ചു.",
      thumb: "assets/img/Pastevents/270.jpg",
    },
    {
      src: "assets/img/Pastevents/271.jpg",
      caption:
        "കേരളത്തിന്റെ ജനസാന്ദ്രതയെ മുന്നിൽ കണ്ടു സംസ്ഥാന ആരോഗ്യ വകുപ്പ്  കൈക്കൊണ്ട നിയന്ത്രണങ്ങളും മാനദണ്ഡങ്ങളും ശരിവെക്കുന്നതാണ് പുതിയ റിപ്പോർട്ടുകളെന്നു ചടങ്ങിൽ അധ്യക്ഷത വഹിച്ച നിംസ്  മെഡിസിറ്റി മാനേജിങ് ഡയറക്ടർ ശ്രീ.എം എസ് ഫൈസൽ ഖാൻ അഭിപ്രായപ്പെട്ടു. സൗജന്യം എന്ന പദം  ആതുരാലയ  മേഖലകളിൽ  കടന്നു വന്നത് നിംസിന്റെ പ്രവർത്തനങ്ങളിലൂടെയാണെന്നും  കോവിഡ് രോഗകാലത്ത് എല്ലാം ത്യജിച്ചും  ഈമേഖലയിൽ സേവന നിരതരായആരോഗ്യ പ്രവർത്തകരാണ് യഥാർത്ഥ പോരാളികളെന്നും അദ്ദേഹം പറഞ്ഞു.",
      thumb: "assets/img/Pastevents/271.jpg",
    },
    {
      src: "assets/img/Pastevents/272.jpg",
      caption: "",
      thumb: "assets/img/Pastevents/272.jpg",
    },
    {
      src: "assets/img/Pastevents/220.jpg",
      caption:
        "വിഴിഞ്ഞം ലയൺസ് ക്ലബ്, അട്ടക്കുളങ്ങര CPi (M) ബ്രാഞ്ചിൻ്റെ ആഭിമുഖ്യത്തിൽ നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ എസ് എ സുന്ദർ (CPi (M) ചാല ഏരിയ സെക്രട്ടറി) മുഖ്യാഥിതി ശ്രീ Lion K ഗോപകുമാർ മേനോൻ.",
      thumb: "assets/img/Pastevents/220.jpg",
    },
    {
      src: "assets/img/Pastevents/221.jpg",
      caption:
        "വിഴിഞ്ഞം ലയൺസ് ക്ലബ്, അട്ടക്കുളങ്ങര CPi (M) ബ്രാഞ്ചിൻ്റെ ആഭിമുഖ്യത്തിൽ നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ എസ് എ സുന്ദർ (CPi (M) ചാല ഏരിയ സെക്രട്ടറി) മുഖ്യാഥിതി ശ്രീ Lion K ഗോപകുമാർ മേനോൻ.",
      thumb: "assets/img/Pastevents/221.jpg",
    },
    {
      src: "assets/img/Pastevents/222.jpg",
      caption:
        "വിഴിഞ്ഞം ലയൺസ് ക്ലബ്, അട്ടക്കുളങ്ങര CPi (M) ബ്രാഞ്ചിൻ്റെ ആഭിമുഖ്യത്തിൽ നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ എസ് എ സുന്ദർ (CPi (M) ചാല ഏരിയ സെക്രട്ടറി) മുഖ്യാഥിതി ശ്രീ Lion K ഗോപകുമാർ മേനോൻ.",
      thumb: "assets/img/Pastevents/222.jpg",
    },
    {
      src: "assets/img/Pastevents/223.jpg",
      caption:
        "വിഴിഞ്ഞം ലയൺസ് ക്ലബ്, അട്ടക്കുളങ്ങര CPi (M) ബ്രാഞ്ചിൻ്റെ ആഭിമുഖ്യത്തിൽ നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ എസ് എ സുന്ദർ (CPi (M) ചാല ഏരിയ സെക്രട്ടറി) മുഖ്യാഥിതി ശ്രീ Lion K ഗോപകുമാർ മേനോൻ.",
      thumb: "assets/img/Pastevents/223.jpg",
    },
    {
      src: "assets/img/Pastevents/224.jpg",
      caption:
        "വിഴിഞ്ഞം ലയൺസ് ക്ലബ്, അട്ടക്കുളങ്ങര CPi (M) ബ്രാഞ്ചിൻ്റെ ആഭിമുഖ്യത്തിൽ നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ എസ് എ സുന്ദർ (CPi (M) ചാല ഏരിയ സെക്രട്ടറി) മുഖ്യാഥിതി ശ്രീ Lion K ഗോപകുമാർ മേനോൻ.",
      thumb: "assets/img/Pastevents/224.jpg",
    },
    {
      src: "assets/img/Pastevents/225.jpg",
      caption:
        "വിഴിഞ്ഞം ലയൺസ് ക്ലബ്, അട്ടക്കുളങ്ങര CPi (M) ബ്രാഞ്ചിൻ്റെ ആഭിമുഖ്യത്തിൽ നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ എസ് എ സുന്ദർ (CPi (M) ചാല ഏരിയ സെക്രട്ടറി) മുഖ്യാഥിതി ശ്രീ Lion K ഗോപകുമാർ മേനോൻ.",
      thumb: "assets/img/Pastevents/225.jpg",
    },
    {
      src: "assets/img/Pastevents/226.jpg",
      caption:
        "വിഴിഞ്ഞം ലയൺസ് ക്ലബ്, അട്ടക്കുളങ്ങര CPi (M) ബ്രാഞ്ചിൻ്റെ ആഭിമുഖ്യത്തിൽ നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ എസ് എ സുന്ദർ (CPi (M) ചാല ഏരിയ സെക്രട്ടറി) മുഖ്യാഥിതി ശ്രീ Lion K ഗോപകുമാർ മേനോൻ.",
      thumb: "assets/img/Pastevents/226.jpg",
    },
    {
      src: "assets/img/Pastevents/227.jpg",
      caption:
        "വിഴിഞ്ഞം ലയൺസ് ക്ലബ്, അട്ടക്കുളങ്ങര CPi (M) ബ്രാഞ്ചിൻ്റെ ആഭിമുഖ്യത്തിൽ നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ എസ് എ സുന്ദർ (CPi (M) ചാല ഏരിയ സെക്രട്ടറി) മുഖ്യാഥിതി ശ്രീ Lion K ഗോപകുമാർ മേനോൻ.",
      thumb: "assets/img/Pastevents/227.jpg",
    },
    {
      src: "assets/img/Pastevents/228.jpg",
      caption:
        "വിഴിഞ്ഞം ലയൺസ് ക്ലബ്, അട്ടക്കുളങ്ങര CPi (M) ബ്രാഞ്ചിൻ്റെ ആഭിമുഖ്യത്തിൽ നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ എസ് എ സുന്ദർ (CPi (M) ചാല ഏരിയ സെക്രട്ടറി) മുഖ്യാഥിതി ശ്രീ Lion K ഗോപകുമാർ മേനോൻ.",
      thumb: "assets/img/Pastevents/228.jpg",
    },
    {
      src: "assets/img/Pastevents/210.jpg",
      caption:
        "Free Mega Medical Camp organized in collaboration with Poojappura Lions Club, Thiruvananthapuram and Chowalloor Ward, Vilapil Panchayat in association with Nimsmedicity",
      thumb: "assets/img/Pastevents/210.jpg",
    },
    {
      src: "assets/img/Pastevents/211.jpg",
      caption:
        "Free Mega Medical Camp organized in collaboration with Poojappura Lions Club, Thiruvananthapuram and Chowalloor Ward, Vilapil Panchayat in association with Nimsmedicity",
      thumb: "assets/img/Pastevents/211.jpg",
    },
    {
      src: "assets/img/Pastevents/212.jpg",
      caption:
        "Free Mega Medical Camp organized in collaboration with Poojappura Lions Club, Thiruvananthapuram and Chowalloor Ward, Vilapil Panchayat in association with Nimsmedicity",
      thumb: "assets/img/Pastevents/212.jpg",
    },
    {
      src: "assets/img/Pastevents/213.jpg",
      caption:
        "Free Mega Medical Camp organized in collaboration with Poojappura Lions Club, Thiruvananthapuram and Chowalloor Ward, Vilapil Panchayat in association with Nimsmedicity",
      thumb: "assets/img/Pastevents/213.jpg",
    },
    {
      src: "assets/img/Pastevents/214.jpg",
      caption:
        "Free Mega Medical Camp organized in collaboration with Poojappura Lions Club, Thiruvananthapuram and Chowalloor Ward, Vilapil Panchayat in association with Nimsmedicity",
      thumb: "assets/img/Pastevents/214.jpg",
    },
    {
      src: "assets/img/Pastevents/215.jpg",
      caption:
        "Free Mega Medical Camp organized in collaboration with Poojappura Lions Club, Thiruvananthapuram and Chowalloor Ward, Vilapil Panchayat in association with Nimsmedicity",
      thumb: "assets/img/Pastevents/215.jpg",
    },
    {
      src: "assets/img/Pastevents/216.jpg",
      caption:
        "Free Mega Medical Camp organized in collaboration with Poojappura Lions Club, Thiruvananthapuram and Chowalloor Ward, Vilapil Panchayat in association with Nimsmedicity",
      thumb: "assets/img/Pastevents/216.jpg",
    },
    {
      src: "assets/img/Pastevents/217.jpg",
      caption:
        "Free Mega Medical Camp organized in collaboration with Poojappura Lions Club, Thiruvananthapuram and Chowalloor Ward, Vilapil Panchayat in association with Nimsmedicity",
      thumb: "assets/img/Pastevents/217.jpg",
    },
    {
      src: "assets/img/Pastevents/218.jpg",
      caption:
        "Free Mega Medical Camp organized in collaboration with Poojappura Lions Club, Thiruvananthapuram and Chowalloor Ward, Vilapil Panchayat in association with Nimsmedicity",
      thumb: "assets/img/Pastevents/218.jpg",
    },
    {
      src: "assets/img/Pastevents/219.jpg",
      caption:
        "Free Mega Medical Camp organized in collaboration with Poojappura Lions Club, Thiruvananthapuram and Chowalloor Ward, Vilapil Panchayat in association with Nimsmedicity",
      thumb: "assets/img/Pastevents/219.jpg",
    },
    {
      src: "assets/img/Pastevents/09-14-2021.jpg",
      caption:
        "വിഴിഞ്ഞം ലയൺസ് ക്ലബ്ബും കോവളം ജനമൈത്രി പോലീസ് സ്റ്റേഷനും സംയുക്തമായി നിംസ് മെഡിസിറ്റി യുടെ സഹകരണത്തോടെ കോവളം പോലീസ് സ്റ്റേഷൻ ഹാളിൽ ജീവിത ശൈലി രോഗനിർണയ ക്യാമ്പും ഡയബെറ്റിസ് അവെർനെസ് സെമിനാറും സംഘടിപ്പിച്ചു. വിഴിഞ്ഞം ലയൺസ് ക്ലബ്ബ് ടസെക്രട്ടറി വിനോദ് കുമാർ അധ്യക്ഷനായ യോഗം കോവളം SHO പ്രൈജു ഉൽഘാടനം ചെയ്തു.   സബ് ഇൻസ്‌പെക്ടർ അനീഷ് മുഖ്യ പ്രഭാഷണവും   ഡോക്ടർ ജിജോ ഡയബറ്റിക് സെമിനാറും നടത്തി. കോവളം CRO ബിജു സ്വാഗതവും വിഴിഞ്ഞം ലയൺസ് ക്ലബ്ബ് പ്രൊജക്റ്റ്‌ കോർഡിനേറ്റർ നന്ദു നന്ദിയും പറഞ്ഞു. എല്ലാ മാസവും രണ്ടാമത്തെ ചൊവ്വാഴ്ച കോവളം സ്റ്റേഷനിലെ ഉദ്യോഗസ്ഥർക്കും അവരുടെ കുടുംബാംഗങ്ങൾക്കും ഈ ക്യാമ്പ് വിഴിഞ്ഞം ലയൺസ് ക്ലബ്ബിന്റെയും കോവളം ജനമൈത്രി പോലീസ് സ്റ്റേഷന്റെ യും നിംസ്  മെഡിസിറ്റി നേതൃത്വത്തിൽ നടന്നു വരുന്നു.",
      thumb: "assets/img/Pastevents/09-14-2021.jpg",
    },
    {
      src: "assets/img/Pastevents/195.jpg",
      caption:
        "വിഴിഞ്ഞം ലയൺസ് ക്ലബ്ബും കോവളം ജനമൈത്രി പോലീസ് സ്റ്റേഷനും സംയുക്തമായി നിംസ് മെഡിസിറ്റി യുടെ സഹകരണത്തോടെ കോവളം പോലീസ് സ്റ്റേഷൻ ഹാളിൽ ജീവിത ശൈലി രോഗനിർണയ ക്യാമ്പും ഡയബെറ്റിസ് അവെർനെസ് സെമിനാറും സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/195.jpg",
    },
    {
      src: "assets/img/Pastevents/196.jpg",
      caption:
        "വിഴിഞ്ഞം ലയൺസ് ക്ലബ്ബും കോവളം ജനമൈത്രി പോലീസ് സ്റ്റേഷനും സംയുക്തമായി നിംസ് മെഡിസിറ്റി യുടെ സഹകരണത്തോടെ കോവളം പോലീസ് സ്റ്റേഷൻ ഹാളിൽ ജീവിത ശൈലി രോഗനിർണയ ക്യാമ്പും ഡയബെറ്റിസ് അവെർനെസ് സെമിനാറും സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/196.jpg",
    },
    {
      src: "assets/img/Pastevents/197.jpg",
      caption:
        "വിഴിഞ്ഞം ലയൺസ് ക്ലബ്ബും കോവളം ജനമൈത്രി പോലീസ് സ്റ്റേഷനും സംയുക്തമായി നിംസ് മെഡിസിറ്റി യുടെ സഹകരണത്തോടെ കോവളം പോലീസ് സ്റ്റേഷൻ ഹാളിൽ ജീവിത ശൈലി രോഗനിർണയ ക്യാമ്പും ഡയബെറ്റിസ് അവെർനെസ് സെമിനാറും സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/197.jpg",
    },
    {
      src: "assets/img/Pastevents/198.jpg",
      caption:
        "വിഴിഞ്ഞം ലയൺസ് ക്ലബ്ബും കോവളം ജനമൈത്രി പോലീസ് സ്റ്റേഷനും സംയുക്തമായി നിംസ് മെഡിസിറ്റി യുടെ സഹകരണത്തോടെ കോവളം പോലീസ് സ്റ്റേഷൻ ഹാളിൽ ജീവിത ശൈലി രോഗനിർണയ ക്യാമ്പും ഡയബെറ്റിസ് അവെർനെസ് സെമിനാറും സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/198.jpg",
    },
    {
      src: "assets/img/Pastevents/199.jpg",
      caption:
        "വിഴിഞ്ഞം ലയൺസ് ക്ലബ്ബും കോവളം ജനമൈത്രി പോലീസ് സ്റ്റേഷനും സംയുക്തമായി നിംസ് മെഡിസിറ്റി യുടെ സഹകരണത്തോടെ കോവളം പോലീസ് സ്റ്റേഷൻ ഹാളിൽ ജീവിത ശൈലി രോഗനിർണയ ക്യാമ്പും ഡയബെറ്റിസ് അവെർനെസ് സെമിനാറും സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/199.jpg",
    },
    {
      src: "assets/img/Pastevents/200.jpg",
      caption:
        "വിഴിഞ്ഞം ലയൺസ് ക്ലബ്ബും കോവളം ജനമൈത്രി പോലീസ് സ്റ്റേഷനും സംയുക്തമായി നിംസ് മെഡിസിറ്റി യുടെ സഹകരണത്തോടെ കോവളം പോലീസ് സ്റ്റേഷൻ ഹാളിൽ ജീവിത ശൈലി രോഗനിർണയ ക്യാമ്പും ഡയബെറ്റിസ് അവെർനെസ് സെമിനാറും സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/200.jpg",
    },
    {
      src: "assets/img/Pastevents/201.jpg",
      caption:
        "വിഴിഞ്ഞം ലയൺസ് ക്ലബ്ബും കോവളം ജനമൈത്രി പോലീസ് സ്റ്റേഷനും സംയുക്തമായി നിംസ് മെഡിസിറ്റി യുടെ സഹകരണത്തോടെ കോവളം പോലീസ് സ്റ്റേഷൻ ഹാളിൽ ജീവിത ശൈലി രോഗനിർണയ ക്യാമ്പും ഡയബെറ്റിസ് അവെർനെസ് സെമിനാറും സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/201.jpg",
    },
    {
      src: "assets/img/Pastevents/202.jpg",
      caption:
        "വിഴിഞ്ഞം ലയൺസ് ക്ലബ്ബും കോവളം ജനമൈത്രി പോലീസ് സ്റ്റേഷനും സംയുക്തമായി നിംസ് മെഡിസിറ്റി യുടെ സഹകരണത്തോടെ കോവളം പോലീസ് സ്റ്റേഷൻ ഹാളിൽ ജീവിത ശൈലി രോഗനിർണയ ക്യാമ്പും ഡയബെറ്റിസ് അവെർനെസ് സെമിനാറും സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/202.jpg",
    },
    {
      src: "assets/img/Pastevents/203.jpg",
      caption:
        "വിഴിഞ്ഞം ലയൺസ് ക്ലബ്ബും കോവളം ജനമൈത്രി പോലീസ് സ്റ്റേഷനും സംയുക്തമായി നിംസ് മെഡിസിറ്റി യുടെ സഹകരണത്തോടെ കോവളം പോലീസ് സ്റ്റേഷൻ ഹാളിൽ ജീവിത ശൈലി രോഗനിർണയ ക്യാമ്പും ഡയബെറ്റിസ് അവെർനെസ് സെമിനാറും സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/203.jpg",
    },
    {
      src: "assets/img/Pastevents/204.jpg",
      caption:
        "വിഴിഞ്ഞം ലയൺസ് ക്ലബ്ബും കോവളം ജനമൈത്രി പോലീസ് സ്റ്റേഷനും സംയുക്തമായി നിംസ് മെഡിസിറ്റി യുടെ സഹകരണത്തോടെ കോവളം പോലീസ് സ്റ്റേഷൻ ഹാളിൽ ജീവിത ശൈലി രോഗനിർണയ ക്യാമ്പും ഡയബെറ്റിസ് അവെർനെസ് സെമിനാറും സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/204.jpg",
    },
    {
      src: "assets/img/Pastevents/205.jpg",
      caption:
        "വിഴിഞ്ഞം ലയൺസ് ക്ലബ്ബും കോവളം ജനമൈത്രി പോലീസ് സ്റ്റേഷനും സംയുക്തമായി നിംസ് മെഡിസിറ്റി യുടെ സഹകരണത്തോടെ കോവളം പോലീസ് സ്റ്റേഷൻ ഹാളിൽ ജീവിത ശൈലി രോഗനിർണയ ക്യാമ്പും ഡയബെറ്റിസ് അവെർനെസ് സെമിനാറും സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/205.jpg",
    },
    {
      src: "assets/img/Pastevents/206.jpg",
      caption:
        "വിഴിഞ്ഞം ലയൺസ് ക്ലബ്ബും കോവളം ജനമൈത്രി പോലീസ് സ്റ്റേഷനും സംയുക്തമായി നിംസ് മെഡിസിറ്റി യുടെ സഹകരണത്തോടെ കോവളം പോലീസ് സ്റ്റേഷൻ ഹാളിൽ ജീവിത ശൈലി രോഗനിർണയ ക്യാമ്പും ഡയബെറ്റിസ് അവെർനെസ് സെമിനാറും സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/206.jpg",
    },
    {
      src: "assets/img/Pastevents/207.jpg",
      caption:
        "വിഴിഞ്ഞം ലയൺസ് ക്ലബ്ബും കോവളം ജനമൈത്രി പോലീസ് സ്റ്റേഷനും സംയുക്തമായി നിംസ് മെഡിസിറ്റി യുടെ സഹകരണത്തോടെ കോവളം പോലീസ് സ്റ്റേഷൻ ഹാളിൽ ജീവിത ശൈലി രോഗനിർണയ ക്യാമ്പും ഡയബെറ്റിസ് അവെർനെസ് സെമിനാറും സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/207.jpg",
    },
    {
      src: "assets/img/Pastevents/208.jpg",
      caption:
        "വിഴിഞ്ഞം ലയൺസ് ക്ലബ്ബും കോവളം ജനമൈത്രി പോലീസ് സ്റ്റേഷനും സംയുക്തമായി നിംസ് മെഡിസിറ്റി യുടെ സഹകരണത്തോടെ കോവളം പോലീസ് സ്റ്റേഷൻ ഹാളിൽ ജീവിത ശൈലി രോഗനിർണയ ക്യാമ്പും ഡയബെറ്റിസ് അവെർനെസ് സെമിനാറും സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/208.jpg",
    },
    {
      src: "assets/img/Pastevents/193.jpg",
      caption:
        "വിഴിഞ്ഞം ലയൺസ് ക്ലബ്ബും കോവളം ജനമൈത്രി പോലീസ് സ്റ്റേഷനും സംയുക്തമായി നിംസ് മെഡിസിറ്റി യുടെ സഹകരണത്തോടെ കോവളം പോലീസ് സ്റ്റേഷൻ ഹാളിൽ ജീവിത ശൈലി രോഗനിർണയ ക്യാമ്പും ഡയബെറ്റിസ് അവെർനെസ് സെമിനാറും സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/193.jpg",
    },
    {
      src: "assets/img/Pastevents/176.jpg",
      caption:
        "Free Mega Medical Camp @ Tribal Settlement Colony Puravimala, Associated with Jyothirgameya Project Under KUITSU . Camp was inaugurated by Sri Sivankutty (Education Minister). Felicitated by Sri C K Hareendran (MLA,Parassala), Dr Asher Ennis Nayagam (Cardiovascular & VATS Surgeon, Nims Medicity).",
      thumb: "assets/img/Pastevents/176.jpg",
    },
    {
      src: "assets/img/Pastevents/177.jpg",
      caption:
        "Free Mega Medical Camp @ Tribal Settlement Colony Puravimala, Associated with Jyothirgameya Project Under KUITSU . Camp was inaugurated by Sri Sivankutty (Education Minister). Felicitated by Sri C K Hareendran (MLA,Parassala), Dr Asher Ennis Nayagam (Cardiovascular & VATS Surgeon, Nims Medicity).",
      thumb: "assets/img/Pastevents/177.jpg",
    },
    {
      src: "assets/img/Pastevents/178.jpg",
      caption:
        "Free Mega Medical Camp @ Tribal Settlement Colony Puravimala, Associated with Jyothirgameya Project Under KUITSU . Camp was inaugurated by Sri Sivankutty (Education Minister). Felicitated by Sri C K Hareendran (MLA,Parassala), Dr Asher Ennis Nayagam (Cardiovascular & VATS Surgeon, Nims Medicity).",
      thumb: "assets/img/Pastevents/178.jpg",
    },
    {
      src: "assets/img/Pastevents/179.jpg",
      caption:
        "Free Mega Medical Camp @ Tribal Settlement Colony Puravimala, Associated with Jyothirgameya Project Under KUITSU . Camp was inaugurated by Sri Sivankutty (Education Minister). Felicitated by Sri C K Hareendran (MLA,Parassala), Dr Asher Ennis Nayagam (Cardiovascular & VATS Surgeon, Nims Medicity).",
      thumb: "assets/img/Pastevents/179.jpg",
    },
    {
      src: "assets/img/Pastevents/180.jpg",
      caption:
        "Free Mega Medical Camp @ Tribal Settlement Colony Puravimala, Associated with Jyothirgameya Project Under KUITSU . Camp was inaugurated by Sri Sivankutty (Education Minister). Felicitated by Sri C K Hareendran (MLA,Parassala), Dr Asher Ennis Nayagam (Cardiovascular & VATS Surgeon, Nims Medicity).",
      thumb: "assets/img/Pastevents/180.jpg",
    },
    {
      src: "assets/img/Pastevents/181.jpg",
      caption:
        "Free Mega Medical Camp @ Tribal Settlement Colony Puravimala, Associated with Jyothirgameya Project Under KUITSU . Camp was inaugurated by Sri Sivankutty (Education Minister). Felicitated by Sri C K Hareendran (MLA,Parassala), Dr Asher Ennis Nayagam (Cardiovascular & VATS Surgeon, Nims Medicity).",
      thumb: "assets/img/Pastevents/181.jpg",
    },
    {
      src: "assets/img/Pastevents/182.jpg",
      caption:
        "Free Mega Medical Camp @ Tribal Settlement Colony Puravimala, Associated with Jyothirgameya Project Under KUITSU . Camp was inaugurated by Sri Sivankutty (Education Minister). Felicitated by Sri C K Hareendran (MLA,Parassala), Dr Asher Ennis Nayagam (Cardiovascular & VATS Surgeon, Nims Medicity).",
      thumb: "assets/img/Pastevents/182.jpg",
    },
    {
      src: "assets/img/Pastevents/183.jpg",
      caption:
        "Free Mega Medical Camp @ Tribal Settlement Colony Puravimala, Associated with Jyothirgameya Project Under KUITSU . Camp was inaugurated by Sri Sivankutty (Education Minister). Felicitated by Sri C K Hareendran (MLA,Parassala), Dr Asher Ennis Nayagam (Cardiovascular & VATS Surgeon, Nims Medicity).",
      thumb: "assets/img/Pastevents/183.jpg",
    },
    {
      src: "assets/img/Pastevents/184.jpg",
      caption:
        "Free Mega Medical Camp @ Tribal Settlement Colony Puravimala, Associated with Jyothirgameya Project Under KUITSU . Camp was inaugurated by Sri Sivankutty (Education Minister). Felicitated by Sri C K Hareendran (MLA,Parassala), Dr Asher Ennis Nayagam (Cardiovascular & VATS Surgeon, Nims Medicity).",
      thumb: "assets/img/Pastevents/184.jpg",
    },
    {
      src: "assets/img/Pastevents/185.jpg",
      caption:
        "Free Mega Medical Camp @ Tribal Settlement Colony Puravimala, Associated with Jyothirgameya Project Under KUITSU . Camp was inaugurated by Sri Sivankutty (Education Minister). Felicitated by Sri C K Hareendran (MLA,Parassala), Dr Asher Ennis Nayagam (Cardiovascular & VATS Surgeon, Nims Medicity).",
      thumb: "assets/img/Pastevents/185.jpg",
    },
    {
      src: "assets/img/Pastevents/186.jpg",
      caption:
        "Free Mega Medical Camp @ Tribal Settlement Colony Puravimala, Associated with Jyothirgameya Project Under KUITSU . Camp was inaugurated by Sri Sivankutty (Education Minister). Felicitated by Sri C K Hareendran (MLA,Parassala), Dr Asher Ennis Nayagam (Cardiovascular & VATS Surgeon, Nims Medicity).",
      thumb: "assets/img/Pastevents/186.jpg",
    },
    {
      src: "assets/img/Pastevents/187.jpg",
      caption:
        "Free Mega Medical Camp @ Tribal Settlement Colony Puravimala, Associated with Jyothirgameya Project Under KUITSU . Camp was inaugurated by Sri Sivankutty (Education Minister). Felicitated by Sri C K Hareendran (MLA,Parassala), Dr Asher Ennis Nayagam (Cardiovascular & VATS Surgeon, Nims Medicity).",
      thumb: "assets/img/Pastevents/187.jpg",
    },
    {
      src: "assets/img/Pastevents/188.jpg",
      caption:
        "Free Mega Medical Camp @ Tribal Settlement Colony Puravimala, Associated with Jyothirgameya Project Under KUITSU . Camp was inaugurated by Sri Sivankutty (Education Minister). Felicitated by Sri C K Hareendran (MLA,Parassala), Dr Asher Ennis Nayagam (Cardiovascular & VATS Surgeon, Nims Medicity).",
      thumb: "assets/img/Pastevents/188.jpg",
    },
    {
      src: "assets/img/Pastevents/189.jpg",
      caption:
        "Free Mega Medical Camp @ Tribal Settlement Colony Puravimala, Associated with Jyothirgameya Project Under KUITSU . Camp was inaugurated by Sri Sivankutty (Education Minister). Felicitated by Sri C K Hareendran (MLA,Parassala), Dr Asher Ennis Nayagam (Cardiovascular & VATS Surgeon, Nims Medicity).",
      thumb: "assets/img/Pastevents/189.jpg",
    },
    {
      src: "assets/img/Pastevents/190.jpg",
      caption:
        "Free Mega Medical Camp @ Tribal Settlement Colony Puravimala, Associated with Jyothirgameya Project Under KUITSU . Camp was inaugurated by Sri Sivankutty (Education Minister). Felicitated by Sri C K Hareendran (MLA,Parassala), Dr Asher Ennis Nayagam (Cardiovascular & VATS Surgeon, Nims Medicity).",
      thumb: "assets/img/Pastevents/190.jpg",
    },
    {
      src: "assets/img/Pastevents/191.jpg",
      caption:
        "Free Mega Medical Camp @ Tribal Settlement Colony Puravimala, Associated with Jyothirgameya Project Under KUITSU . Camp was inaugurated by Sri Sivankutty (Education Minister). Felicitated by Sri C K Hareendran (MLA,Parassala), Dr Asher Ennis Nayagam (Cardiovascular & VATS Surgeon, Nims Medicity).",
      thumb: "assets/img/Pastevents/191.jpg",
    },
    {
      src: "assets/img/Pastevents/192.jpg",
      caption:
        "Free Mega Medical Camp @ Tribal Settlement Colony Puravimala, Associated with Jyothirgameya Project Under KUITSU . Camp was inaugurated by Sri Sivankutty (Education Minister). Felicitated by Sri C K Hareendran (MLA,Parassala), Dr Asher Ennis Nayagam (Cardiovascular & VATS Surgeon, Nims Medicity).",
      thumb: "assets/img/Pastevents/192.jpg",
    },
    {
      src: "assets/img/Pastevents/168.jpg",
      caption:
        "Free Medical Camp & 75th Independence Day Celebration at Kunnapuzha in Association with Swapnakkoodu Old-Age Home and NIMS MEDICITY",
      thumb: "assets/img/Pastevents/168.jpg",
    },
    {
      src: "assets/img/Pastevents/169.jpg",
      caption:
        "Free Medical Camp & 75th Independence Day Celebration at Kunnapuzha in Association with Swapnakkoodu Old-Age Home and NIMS MEDICITY",
      thumb: "assets/img/Pastevents/169.jpg",
    },
    {
      src: "assets/img/Pastevents/172.jpg",
      caption:
        "Free Medical Camp & 75th Independence Day Celebration at Kunnapuzha in Association with Swapnakkoodu Old-Age Home and NIMS MEDICITY",
      thumb: "assets/img/Pastevents/172.jpg",
    },
    {
      src: "assets/img/Pastevents/174.jpg",
      caption:
        "Free Medical Camp & 75th Independence Day Celebration at Kunnapuzha in Association with Swapnakkoodu Old-Age Home and NIMS MEDICITY",
      thumb: "assets/img/Pastevents/174.jpg",
    },
    {
      src: "assets/img/Pastevents/175.jpg",
      caption:
        "Free Medical Camp & 75th Independence Day Celebration at Kunnapuzha in Association with Swapnakkoodu Old-Age Home and NIMS MEDICITY",
      thumb: "assets/img/Pastevents/175.jpg",
    },
    {
      src: "assets/img/Pastevents/167.jpg",
      caption:
        "Free Medical Camp @ Muttaikkadu, Kovalam. Associated with S Challenge Memorial Charitable Trust , Kovalam Jenamytri Police & Venganoor Lions Club.",
      thumb: "assets/img/Pastevents/167.jpg",
    },
    {
      src: "assets/img/Pastevents/159.jpg",
      caption:
        "Free Medical Camp @ Muttaikkadu, Kovalam. Associated with S Challenge Memorial Charitable Trust , Kovalam Jenamytri Police & Venganoor Lions Club.",
      thumb: "assets/img/Pastevents/159.jpg",
    },
    {
      src: "assets/img/Pastevents/160.jpg",
      caption:
        "Free Medical Camp @ Muttaikkadu, Kovalam. Associated with S Challenge Memorial Charitable Trust , Kovalam Jenamytri Police & Venganoor Lions Club.",
      thumb: "assets/img/Pastevents/160.jpg",
    },
    {
      src: "assets/img/Pastevents/161.jpg",
      caption:
        "Free Medical Camp @ Muttaikkadu, Kovalam. Associated with S Challenge Memorial Charitable Trust , Kovalam Jenamytri Police & Venganoor Lions Club.",
      thumb: "assets/img/Pastevents/161.jpg",
    },
    {
      src: "assets/img/Pastevents/162.jpg",
      caption:
        "Free Medical Camp @ Muttaikkadu, Kovalam. Associated with S Challenge Memorial Charitable Trust , Kovalam Jenamytri Police & Venganoor Lions Club.",
      thumb: "assets/img/Pastevents/162.jpg",
    },
    {
      src: "assets/img/Pastevents/163.jpg",
      caption:
        "Free Medical Camp @ Muttaikkadu, Kovalam. Associated with S Challenge Memorial Charitable Trust , Kovalam Jenamytri Police & Venganoor Lions Club.",
      thumb: "assets/img/Pastevents/163.jpg",
    },
    {
      src: "assets/img/Pastevents/164.jpg",
      caption:
        "Free Medical Camp @ Muttaikkadu, Kovalam. Associated with S Challenge Memorial Charitable Trust , Kovalam Jenamytri Police & Venganoor Lions Club.",
      thumb: "assets/img/Pastevents/164.jpg",
    },
    {
      src: "assets/img/Pastevents/165.jpg",
      caption:
        "Free Medical Camp @ Muttaikkadu, Kovalam. Associated with S Challenge Memorial Charitable Trust , Kovalam Jenamytri Police & Venganoor Lions Club.",
      thumb: "assets/img/Pastevents/165.jpg",
    },
    {
      src: "assets/img/Pastevents/166.jpg",
      caption:
        "Free Medical Camp @ Muttaikkadu, Kovalam. Associated with S Challenge Memorial Charitable Trust , Kovalam Jenamytri Police & Venganoor Lions Club.",
      thumb: "assets/img/Pastevents/166.jpg",
    },
    {
      src: "assets/img/Pastevents/151.jpg",
      caption:
        "Free Medical Camp @ Aazhimala. Associated with Aazhimala Siva Temple Trust & Lions Club Vizhinjam.",
      thumb: "assets/img/Pastevents/151.jpg",
    },
    {
      src: "assets/img/Pastevents/146.jpg",
      caption:
        "Free Medical Camp @ Aazhimala. Associated with Aazhimala Siva Temple Trust & Lions Club Vizhinjam.",
      thumb: "assets/img/Pastevents/146.jpg",
    },
    {
      src: "assets/img/Pastevents/147.jpg",
      caption:
        "Free Medical Camp @ Aazhimala. Associated with Aazhimala Siva Temple Trust & Lions Club Vizhinjam.",
      thumb: "assets/img/Pastevents/147.jpg",
    },
    {
      src: "assets/img/Pastevents/148.jpg",
      caption:
        "Free Medical Camp @ Aazhimala. Associated with Aazhimala Siva Temple Trust & Lions Club Vizhinjam.",
      thumb: "assets/img/Pastevents/148.jpg",
    },
    {
      src: "assets/img/Pastevents/149.jpg",
      caption:
        "Free Medical Camp @ Aazhimala. Associated with Aazhimala Siva Temple Trust & Lions Club Vizhinjam.",
      thumb: "assets/img/Pastevents/149.jpg",
    },
    {
      src: "assets/img/Pastevents/150.jpg",
      caption:
        "Free Medical Camp @ Aazhimala. Associated with Aazhimala Siva Temple Trust & Lions Club Vizhinjam.",
      thumb: "assets/img/Pastevents/150.jpg",
    },
    {
      src: "assets/img/Pastevents/152.jpg",
      caption:
        "Free Medical Camp @ Aazhimala. Associated with Aazhimala Siva Temple Trust & Lions Club Vizhinjam.",
      thumb: "assets/img/Pastevents/152.jpg",
    },
    {
      src: "assets/img/Pastevents/153.jpg",
      caption:
        "Free Medical Camp @ Aazhimala. Associated with Aazhimala Siva Temple Trust & Lions Club Vizhinjam.",
      thumb: "assets/img/Pastevents/153.jpg",
    },
    {
      src: "assets/img/Pastevents/154.jpg",
      caption:
        "Free Medical Camp @ Aazhimala. Associated with Aazhimala Siva Temple Trust & Lions Club Vizhinjam.",
      thumb: "assets/img/Pastevents/154.jpg",
    },
    {
      src: "assets/img/Pastevents/155.jpg",
      caption:
        "Free Medical Camp @ Aazhimala. Associated with Aazhimala Siva Temple Trust & Lions Club Vizhinjam.",
      thumb: "assets/img/Pastevents/155.jpg",
    },
    {
      src: "assets/img/Pastevents/156.jpg",
      caption:
        "Free Medical Camp @ Aazhimala. Associated with Aazhimala Siva Temple Trust & Lions Club Vizhinjam.",
      thumb: "assets/img/Pastevents/156.jpg",
    },
    {
      src: "assets/img/Pastevents/157.jpg",
      caption:
        "Free Medical Camp @ Aazhimala. Associated with Aazhimala Siva Temple Trust & Lions Club Vizhinjam.",
      thumb: "assets/img/Pastevents/157.jpg",
    },
    {
      src: "assets/img/Pastevents/158.jpg",
      caption:
        "Free Medical Camp @ Aazhimala. Associated with Aazhimala Siva Temple Trust & Lions Club Vizhinjam.",
      thumb: "assets/img/Pastevents/158.jpg",
    },
    {
      src: "assets/img/Pastevents/121.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയും പുതിയതുറ കരിംകുളം വാർഡ് യൂത്ത് കോൺഗ്രസ് സമിതിയും സംയുക്തമായി കോവിഡ്‌ മഹാമാരിയിൽ ദുരിതമനുഭവിക്കുന്ന പുതിയതുറ കരിംകുളം വാർഡിലെ ഇരുനൂറ്റിയമ്പതോളം  കുടുംബങ്ങൾക്കായി സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/121.jpg",
    },
    {
      src: "assets/img/Pastevents/122.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയും പുതിയതുറ കരിംകുളം വാർഡ് യൂത്ത് കോൺഗ്രസ് സമിതിയും സംയുക്തമായി കോവിഡ്‌ മഹാമാരിയിൽ ദുരിതമനുഭവിക്കുന്ന പുതിയതുറ കരിംകുളം വാർഡിലെ ഇരുനൂറ്റിയമ്പതോളം  കുടുംബങ്ങൾക്കായി സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/122.jpg",
    },
    {
      src: "assets/img/Pastevents/123.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയും പുതിയതുറ കരിംകുളം വാർഡ് യൂത്ത് കോൺഗ്രസ് സമിതിയും സംയുക്തമായി കോവിഡ്‌ മഹാമാരിയിൽ ദുരിതമനുഭവിക്കുന്ന പുതിയതുറ കരിംകുളം വാർഡിലെ ഇരുനൂറ്റിയമ്പതോളം  കുടുംബങ്ങൾക്കായി സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/123.jpg",
    },
    {
      src: "assets/img/Pastevents/124.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയും പുതിയതുറ കരിംകുളം വാർഡ് യൂത്ത് കോൺഗ്രസ് സമിതിയും സംയുക്തമായി കോവിഡ്‌ മഹാമാരിയിൽ ദുരിതമനുഭവിക്കുന്ന പുതിയതുറ കരിംകുളം വാർഡിലെ ഇരുനൂറ്റിയമ്പതോളം  കുടുംബങ്ങൾക്കായി സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/124.jpg",
    },
    {
      src: "assets/img/Pastevents/125.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയും പുതിയതുറ കരിംകുളം വാർഡ് യൂത്ത് കോൺഗ്രസ് സമിതിയും സംയുക്തമായി കോവിഡ്‌ മഹാമാരിയിൽ ദുരിതമനുഭവിക്കുന്ന പുതിയതുറ കരിംകുളം വാർഡിലെ ഇരുനൂറ്റിയമ്പതോളം  കുടുംബങ്ങൾക്കായി സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/125.jpg",
    },
    {
      src: "assets/img/Pastevents/126.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയും പുതിയതുറ കരിംകുളം വാർഡ് യൂത്ത് കോൺഗ്രസ് സമിതിയും സംയുക്തമായി കോവിഡ്‌ മഹാമാരിയിൽ ദുരിതമനുഭവിക്കുന്ന പുതിയതുറ കരിംകുളം വാർഡിലെ ഇരുനൂറ്റിയമ്പതോളം  കുടുംബങ്ങൾക്കായി സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/126.jpg",
    },
    {
      src: "assets/img/Pastevents/127.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയും പുതിയതുറ കരിംകുളം വാർഡ് യൂത്ത് കോൺഗ്രസ് സമിതിയും സംയുക്തമായി കോവിഡ്‌ മഹാമാരിയിൽ ദുരിതമനുഭവിക്കുന്ന പുതിയതുറ കരിംകുളം വാർഡിലെ ഇരുനൂറ്റിയമ്പതോളം  കുടുംബങ്ങൾക്കായി സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/127.jpg",
    },
    {
      src: "assets/img/Pastevents/128.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയും പുതിയതുറ കരിംകുളം വാർഡ് യൂത്ത് കോൺഗ്രസ് സമിതിയും സംയുക്തമായി കോവിഡ്‌ മഹാമാരിയിൽ ദുരിതമനുഭവിക്കുന്ന പുതിയതുറ കരിംകുളം വാർഡിലെ ഇരുനൂറ്റിയമ്പതോളം  കുടുംബങ്ങൾക്കായി സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/128.jpg",
    },
    {
      src: "assets/img/Pastevents/129.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയും പുതിയതുറ കരിംകുളം വാർഡ് യൂത്ത് കോൺഗ്രസ് സമിതിയും സംയുക്തമായി കോവിഡ്‌ മഹാമാരിയിൽ ദുരിതമനുഭവിക്കുന്ന പുതിയതുറ കരിംകുളം വാർഡിലെ ഇരുനൂറ്റിയമ്പതോളം  കുടുംബങ്ങൾക്കായി സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/129.jpg",
    },
    {
      src: "assets/img/Pastevents/130.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയും പുതിയതുറ കരിംകുളം വാർഡ് യൂത്ത് കോൺഗ്രസ് സമിതിയും സംയുക്തമായി കോവിഡ്‌ മഹാമാരിയിൽ ദുരിതമനുഭവിക്കുന്ന പുതിയതുറ കരിംകുളം വാർഡിലെ ഇരുനൂറ്റിയമ്പതോളം  കുടുംബങ്ങൾക്കായി സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/130.jpg",
    },
    {
      src: "assets/img/Pastevents/131.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയും പുതിയതുറ കരിംകുളം വാർഡ് യൂത്ത് കോൺഗ്രസ് സമിതിയും സംയുക്തമായി കോവിഡ്‌ മഹാമാരിയിൽ ദുരിതമനുഭവിക്കുന്ന പുതിയതുറ കരിംകുളം വാർഡിലെ ഇരുനൂറ്റിയമ്പതോളം  കുടുംബങ്ങൾക്കായി സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/131.jpg",
    },
    {
      src: "assets/img/Pastevents/132.jpg",
      caption:
        '"ഡോക്ടർസ് ഡേ "..... കൊറോണ മഹാമാരിയുടെ കാലത്ത് വിശ്രമമില്ലാതെ തുടരുന്ന അവരുടെ  സേവനത്തെ നന്ദിയോടെ ആദരിക്കാൻ ആവട്ടെ ഈ വർഷത്തെ ഡോക്ടർമാരുടെ ദിനം...  പുതിയതുറ കരിംകുളം വാർഡിലെ മെഡിക്കൽ ക്യാമ്പ്',
      thumb: "assets/img/Pastevents/132.jpg",
    },
    {
      src: "assets/img/Pastevents/133.jpg",
      caption:
        '"ഡോക്ടർസ് ഡേ "..... കൊറോണ മഹാമാരിയുടെ കാലത്ത് വിശ്രമമില്ലാതെ തുടരുന്ന അവരുടെ  സേവനത്തെ നന്ദിയോടെ ആദരിക്കാൻ ആവട്ടെ ഈ വർഷത്തെ ഡോക്ടർമാരുടെ ദിനം...  പുതിയതുറ കരിംകുളം വാർഡിലെ മെഡിക്കൽ ക്യാമ്പ്',
      thumb: "assets/img/Pastevents/133.jpg",
    },
    {
      src: "assets/img/Pastevents/134.jpg",
      caption:
        '"ഡോക്ടർസ് ഡേ "..... കൊറോണ മഹാമാരിയുടെ കാലത്ത് വിശ്രമമില്ലാതെ തുടരുന്ന അവരുടെ  സേവനത്തെ നന്ദിയോടെ ആദരിക്കാൻ ആവട്ടെ ഈ വർഷത്തെ ഡോക്ടർമാരുടെ ദിനം...  പുതിയതുറ കരിംകുളം വാർഡിലെ മെഡിക്കൽ ക്യാമ്പ്',
      thumb: "assets/img/Pastevents/134.jpg",
    },
    {
      src: "assets/img/Pastevents/135.jpg",
      caption:
        '"ഡോക്ടർസ് ഡേ "..... കൊറോണ മഹാമാരിയുടെ കാലത്ത് വിശ്രമമില്ലാതെ തുടരുന്ന അവരുടെ  സേവനത്തെ നന്ദിയോടെ ആദരിക്കാൻ ആവട്ടെ ഈ വർഷത്തെ ഡോക്ടർമാരുടെ ദിനം...  പുതിയതുറ കരിംകുളം വാർഡിലെ മെഡിക്കൽ ക്യാമ്പ്',
      thumb: "assets/img/Pastevents/135.jpg",
    },
    {
      src: "assets/img/Pastevents/136.jpg",
      caption:
        '"ഡോക്ടർസ് ഡേ "..... കൊറോണ മഹാമാരിയുടെ കാലത്ത് വിശ്രമമില്ലാതെ തുടരുന്ന അവരുടെ  സേവനത്തെ നന്ദിയോടെ ആദരിക്കാൻ ആവട്ടെ ഈ വർഷത്തെ ഡോക്ടർമാരുടെ ദിനം...  പുതിയതുറ കരിംകുളം വാർഡിലെ മെഡിക്കൽ ക്യാമ്പ്',
      thumb: "assets/img/Pastevents/136.jpg",
    },
    {
      src: "assets/img/Pastevents/137.jpg",
      caption:
        '"ഡോക്ടർസ് ഡേ "..... കൊറോണ മഹാമാരിയുടെ കാലത്ത് വിശ്രമമില്ലാതെ തുടരുന്ന അവരുടെ  സേവനത്തെ നന്ദിയോടെ ആദരിക്കാൻ ആവട്ടെ ഈ വർഷത്തെ ഡോക്ടർമാരുടെ ദിനം...  പുതിയതുറ കരിംകുളം വാർഡിലെ മെഡിക്കൽ ക്യാമ്പ്',
      thumb: "assets/img/Pastevents/137.jpg",
    },
    {
      src: "assets/img/Pastevents/138.jpg",
      caption:
        '"ഡോക്ടർസ് ഡേ "..... കൊറോണ മഹാമാരിയുടെ കാലത്ത് വിശ്രമമില്ലാതെ തുടരുന്ന അവരുടെ  സേവനത്തെ നന്ദിയോടെ ആദരിക്കാൻ ആവട്ടെ ഈ വർഷത്തെ ഡോക്ടർമാരുടെ ദിനം...  പുതിയതുറ കരിംകുളം വാർഡിലെ മെഡിക്കൽ ക്യാമ്പ്',
      thumb: "assets/img/Pastevents/138.jpg",
    },
    {
      src: "assets/img/Pastevents/139.jpg",
      caption:
        '"ഡോക്ടർസ് ഡേ "..... കൊറോണ മഹാമാരിയുടെ കാലത്ത് വിശ്രമമില്ലാതെ തുടരുന്ന അവരുടെ  സേവനത്തെ നന്ദിയോടെ ആദരിക്കാൻ ആവട്ടെ ഈ വർഷത്തെ ഡോക്ടർമാരുടെ ദിനം...  പുതിയതുറ കരിംകുളം വാർഡിലെ മെഡിക്കൽ ക്യാമ്പ്',
      thumb: "assets/img/Pastevents/139.jpg",
    },
    {
      src: "assets/img/Pastevents/140.jpg",
      caption:
        '"ഡോക്ടർസ് ഡേ "..... കൊറോണ മഹാമാരിയുടെ കാലത്ത് വിശ്രമമില്ലാതെ തുടരുന്ന അവരുടെ  സേവനത്തെ നന്ദിയോടെ ആദരിക്കാൻ ആവട്ടെ ഈ വർഷത്തെ ഡോക്ടർമാരുടെ ദിനം...  പുതിയതുറ കരിംകുളം വാർഡിലെ മെഡിക്കൽ ക്യാമ്പ്',
      thumb: "assets/img/Pastevents/140.jpg",
    },
    {
      src: "assets/img/Pastevents/141.jpg",
      caption:
        '"ഡോക്ടർസ് ഡേ "..... കൊറോണ മഹാമാരിയുടെ കാലത്ത് വിശ്രമമില്ലാതെ തുടരുന്ന അവരുടെ  സേവനത്തെ നന്ദിയോടെ ആദരിക്കാൻ ആവട്ടെ ഈ വർഷത്തെ ഡോക്ടർമാരുടെ ദിനം...  പുതിയതുറ കരിംകുളം വാർഡിലെ മെഡിക്കൽ ക്യാമ്പ്',
      thumb: "assets/img/Pastevents/141.jpg",
    },
    {
      src: "assets/img/Pastevents/142.jpg",
      caption:
        '"ഡോക്ടർസ് ഡേ "..... കൊറോണ മഹാമാരിയുടെ കാലത്ത് വിശ്രമമില്ലാതെ തുടരുന്ന അവരുടെ  സേവനത്തെ നന്ദിയോടെ ആദരിക്കാൻ ആവട്ടെ ഈ വർഷത്തെ ഡോക്ടർമാരുടെ ദിനം...  പുതിയതുറ കരിംകുളം വാർഡിലെ മെഡിക്കൽ ക്യാമ്പ്',
      thumb: "assets/img/Pastevents/142.jpg",
    },
    {
      src: "assets/img/Pastevents/143.jpg",
      caption:
        '"ഡോക്ടർസ് ഡേ "..... കൊറോണ മഹാമാരിയുടെ കാലത്ത് വിശ്രമമില്ലാതെ തുടരുന്ന അവരുടെ  സേവനത്തെ നന്ദിയോടെ ആദരിക്കാൻ ആവട്ടെ ഈ വർഷത്തെ ഡോക്ടർമാരുടെ ദിനം...  പുതിയതുറ കരിംകുളം വാർഡിലെ മെഡിക്കൽ ക്യാമ്പ്',
      thumb: "assets/img/Pastevents/143.jpg",
    },
    {
      src: "assets/img/Pastevents/144.jpg",
      caption:
        '"ഡോക്ടർസ് ഡേ "..... കൊറോണ മഹാമാരിയുടെ കാലത്ത് വിശ്രമമില്ലാതെ തുടരുന്ന അവരുടെ  സേവനത്തെ നന്ദിയോടെ ആദരിക്കാൻ ആവട്ടെ ഈ വർഷത്തെ ഡോക്ടർമാരുടെ ദിനം...  പുതിയതുറ കരിംകുളം വാർഡിലെ മെഡിക്കൽ ക്യാമ്പ്',
      thumb: "assets/img/Pastevents/144.jpg",
    },
    {
      src: "assets/img/Pastevents/145.jpg",
      caption:
        '"ഡോക്ടർസ് ഡേ "..... കൊറോണ മഹാമാരിയുടെ കാലത്ത് വിശ്രമമില്ലാതെ തുടരുന്ന അവരുടെ  സേവനത്തെ നന്ദിയോടെ ആദരിക്കാൻ ആവട്ടെ ഈ വർഷത്തെ ഡോക്ടർമാരുടെ ദിനം...  പുതിയതുറ കരിംകുളം വാർഡിലെ മെഡിക്കൽ ക്യാമ്പ്',
      thumb: "assets/img/Pastevents/145.jpg",
    },
    {
      src: "assets/img/Pastevents/118.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയും പൊഴിയൂർ ബീച്ച് വാർഡ് വികസന സമിതിയും സംയുക്തമായി കോവിഡ്‌ മഹാമാരിയിലും മഴക്കെടുതിയിലും ദുരിതമനുഭവിക്കുന്ന പൊഴിയൂർ ബീച്ച്‌ വാർഡിലെ നാനൂറ്റി അമ്പതോളം കുടുംബങ്ങൾക്കായി സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/118.jpg",
    },
    {
      src: "assets/img/Pastevents/119.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയും പൊഴിയൂർ ബീച്ച് വാർഡ് വികസന സമിതിയും സംയുക്തമായി കോവിഡ്‌ മഹാമാരിയിലും മഴക്കെടുതിയിലും ദുരിതമനുഭവിക്കുന്ന പൊഴിയൂർ ബീച്ച്‌ വാർഡിലെ നാനൂറ്റി അമ്പതോളം കുടുംബങ്ങൾക്കായി സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/119.jpg",
    },
    {
      src: "assets/img/Pastevents/120.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയും പൊഴിയൂർ ബീച്ച് വാർഡ് വികസന സമിതിയും സംയുക്തമായി കോവിഡ്‌ മഹാമാരിയിലും മഴക്കെടുതിയിലും ദുരിതമനുഭവിക്കുന്ന പൊഴിയൂർ ബീച്ച്‌ വാർഡിലെ നാനൂറ്റി അമ്പതോളം കുടുംബങ്ങൾക്കായി സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/120.jpg",
    },
    {
      src: "assets/img/Pastevents/114.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയും പൊഴിയൂർ ബീച്ച് വാർഡ് വികസന സമിതിയും സംയുക്തമായി കോവിഡ്‌ മഹാമാരിയിലും മഴക്കെടുതിയിലും ദുരിതമനുഭവിക്കുന്ന പൊഴിയൂർ ബീച്ച്‌ വാർഡിലെ നാനൂറ്റി അമ്പതോളം കുടുംബങ്ങൾക്കായി സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/114.jpg",
    },
    {
      src: "assets/img/Pastevents/115.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയും പൊഴിയൂർ ബീച്ച് വാർഡ് വികസന സമിതിയും സംയുക്തമായി കോവിഡ്‌ മഹാമാരിയിലും മഴക്കെടുതിയിലും ദുരിതമനുഭവിക്കുന്ന പൊഴിയൂർ ബീച്ച്‌ വാർഡിലെ നാനൂറ്റി അമ്പതോളം കുടുംബങ്ങൾക്കായി സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/115.jpg",
    },
    {
      src: "assets/img/Pastevents/116.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയും പൊഴിയൂർ ബീച്ച് വാർഡ് വികസന സമിതിയും സംയുക്തമായി കോവിഡ്‌ മഹാമാരിയിലും മഴക്കെടുതിയിലും ദുരിതമനുഭവിക്കുന്ന പൊഴിയൂർ ബീച്ച്‌ വാർഡിലെ നാനൂറ്റി അമ്പതോളം കുടുംബങ്ങൾക്കായി സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/116.jpg",
    },
    {
      src: "assets/img/Pastevents/117.jpg",
      caption:
        "നിംസ് മെഡിസിറ്റിയും പൊഴിയൂർ ബീച്ച് വാർഡ് വികസന സമിതിയും സംയുക്തമായി കോവിഡ്‌ മഹാമാരിയിലും മഴക്കെടുതിയിലും ദുരിതമനുഭവിക്കുന്ന പൊഴിയൂർ ബീച്ച്‌ വാർഡിലെ നാനൂറ്റി അമ്പതോളം കുടുംബങ്ങൾക്കായി സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      thumb: "assets/img/Pastevents/117.jpg",
    },
    {
      src: "assets/img/Pastevents/100.jpeg",
      caption: "100",
      thumb: "assets/img/Pastevents/100.jpeg",
    },
    {
      src: "assets/img/Pastevents/101.jpeg",
      caption: "101",
      thumb: "assets/img/Pastevents/101.jpeg",
    },
    {
      src: "assets/img/Pastevents/102.jpeg",
      caption: "102",
      thumb: "assets/img/Pastevents/102.jpeg",
    },
    {
      src: "assets/img/Pastevents/103.jpeg",
      caption: "103",
      thumb: "assets/img/Pastevents/103.jpeg",
    },
    {
      src: "assets/img/Pastevents/104.jpeg",
      caption: "104",
      thumb: "assets/img/Pastevents/104.jpeg",
    },
    {
      src: "assets/img/Pastevents/105.jpeg",
      caption: "105",
      thumb: "assets/img/Pastevents/105.jpeg",
    },
    {
      src: "assets/img/Pastevents/106.jpeg",
      caption: "106",
      thumb: "assets/img/Pastevents/106.jpeg",
    },
    {
      src: "assets/img/Pastevents/107.jpeg",
      caption: "107",
      thumb: "assets/img/Pastevents/107.jpeg",
    },
    {
      src: "assets/img/Pastevents/108.jpeg",
      caption: "108",
      thumb: "assets/img/Pastevents/108.jpeg",
    },
    {
      src: "assets/img/Pastevents/109.jpeg",
      caption: "109",
      thumb: "assets/img/Pastevents/109.jpeg",
    },
    {
      src: "assets/img/Pastevents/110.jpeg",
      caption: "110",
      thumb: "assets/img/Pastevents/110.jpeg",
    },
    {
      src: "assets/img/Pastevents/111.jpeg",
      caption: "111",
      thumb: "assets/img/Pastevents/111.jpeg",
    },
    {
      src: "assets/img/Pastevents/112.jpeg",
      caption: "112",
      thumb: "assets/img/Pastevents/112.jpeg",
    },
    {
      src: "assets/img/Pastevents/113.jpeg",
      caption: "113",
      thumb: "assets/img/Pastevents/113.jpeg",
    },
    {
      src: "assets/img/Pastevents/94.jpeg",
      caption: "94",
      thumb: "assets/img/Pastevents/94.jpeg",
    },
    {
      src: "assets/img/Pastevents/95.jpeg",
      caption: "95",
      thumb: "assets/img/Pastevents/95.jpeg",
    },
    {
      src: "assets/img/Pastevents/96.jpeg",
      caption: "96",
      thumb: "assets/img/Pastevents/96.jpeg",
    },
    {
      src: "assets/img/Pastevents/97.jpeg",
      caption: "97",
      thumb: "assets/img/Pastevents/97.jpeg",
    },
    {
      src: "assets/img/Pastevents/98.jpeg",
      caption: "98",
      thumb: "assets/img/Pastevents/98.jpeg",
    },
    {
      src: "assets/img/Pastevents/99.jpeg",
      caption: "99",
      thumb: "assets/img/Pastevents/99.jpeg",
    },
    {
      src: "assets/img/Pastevents/88.jpeg",
      caption: "88",
      thumb: "assets/img/Pastevents/88.jpeg",
    },
    {
      src: "assets/img/Pastevents/89.jpeg",
      caption: "89",
      thumb: "assets/img/Pastevents/89.jpeg",
    },
    {
      src: "assets/img/Pastevents/90.jpeg",
      caption: "90",
      thumb: "assets/img/Pastevents/90.jpeg",
    },
    {
      src: "assets/img/Pastevents/91.jpeg",
      caption: "91",
      thumb: "assets/img/Pastevents/91.jpeg",
    },
    {
      src: "assets/img/Pastevents/92.jpeg",
      caption: "92",
      thumb: "assets/img/Pastevents/92.jpeg",
    },
    {
      src: "assets/img/Pastevents/93.jpeg",
      caption: "93",
      thumb: "assets/img/Pastevents/93.jpeg",
    },
    {
      src: "assets/img/Pastevents/82.jpeg",
      caption: "82",
      thumb: "assets/img/Pastevents/82.jpeg",
    },
    {
      src: "assets/img/Pastevents/83.jpeg",
      caption: "83",
      thumb: "assets/img/Pastevents/83.jpeg",
    },
    {
      src: "assets/img/Pastevents/84.jpeg",
      caption: "84",
      thumb: "assets/img/Pastevents/84.jpeg",
    },
    {
      src: "assets/img/Pastevents/85.jpeg",
      caption: "85",
      thumb: "assets/img/Pastevents/85.jpeg",
    },
    {
      src: "assets/img/Pastevents/86.jpeg",
      caption: "86",
      thumb: "assets/img/Pastevents/86.jpeg",
    },
    {
      src: "assets/img/Pastevents/87.jpeg",
      caption: "87",
      thumb: "assets/img/Pastevents/87.jpeg",
    },
    {
      src: "assets/img/Pastevents/77.jpeg",
      caption: "77",
      thumb: "assets/img/Pastevents/77.jpeg",
    },
    {
      src: "assets/img/Pastevents/78.jpeg",
      caption: "78",
      thumb: "assets/img/Pastevents/78.jpeg",
    },
    {
      src: "assets/img/Pastevents/79.jpeg",
      caption: "79",
      thumb: "assets/img/Pastevents/79.jpeg",
    },
    {
      src: "assets/img/Pastevents/80.jpeg",
      caption: "80",
      thumb: "assets/img/Pastevents/80.jpeg",
    },
    {
      src: "assets/img/Pastevents/81.jpeg",
      caption: "81",
      thumb: "assets/img/Pastevents/81.jpeg",
    },
    {
      src: "assets/img/Pastevents/71.jpeg",
      caption: "71",
      thumb: "assets/img/Pastevents/71.jpeg",
    },
    {
      src: "assets/img/Pastevents/72.jpeg",
      caption: "72",
      thumb: "assets/img/Pastevents/72.jpeg",
    },
    {
      src: "assets/img/Pastevents/73.jpeg",
      caption: "73",
      thumb: "assets/img/Pastevents/73.jpeg",
    },
    {
      src: "assets/img/Pastevents/74.jpeg",
      caption: "74",
      thumb: "assets/img/Pastevents/74.jpeg",
    },
    {
      src: "assets/img/Pastevents/75.jpeg",
      caption: "75",
      thumb: "assets/img/Pastevents/75.jpeg",
    },
    {
      src: "assets/img/Pastevents/76.jpeg",
      caption: "76",
      thumb: "assets/img/Pastevents/76.jpeg",
    },
    {
      src: "assets/img/Pastevents/66.jpeg",
      caption: "66",
      thumb: "assets/img/Pastevents/66.jpeg",
    },
    {
      src: "assets/img/Pastevents/67.jpeg",
      caption: "67",
      thumb: "assets/img/Pastevents/67.jpeg",
    },
    {
      src: "assets/img/Pastevents/68.jpeg",
      caption: "68",
      thumb: "assets/img/Pastevents/68.jpeg",
    },
    {
      src: "assets/img/Pastevents/69.jpeg",
      caption: "69",
      thumb: "assets/img/Pastevents/69.jpeg",
    },
    {
      src: "assets/img/Pastevents/70.jpeg",
      caption: "70",
      thumb: "assets/img/Pastevents/70.jpeg",
    },
    {
      src: "assets/img/Pastevents/57.jpg",
      caption: "57",
      thumb: "assets/img/Pastevents/57.jpg",
    },
    {
      src: "assets/img/Pastevents/58.jpg",
      caption: "58",
      thumb: "assets/img/Pastevents/58.jpg",
    },
    {
      src: "assets/img/Pastevents/59.jpg",
      caption: "59",
      thumb: "assets/img/Pastevents/59.jpg",
    },
    {
      src: "assets/img/Pastevents/60.jpg",
      caption: "60",
      thumb: "assets/img/Pastevents/60.jpg",
    },
    {
      src: "assets/img/Pastevents/61.jpg",
      caption: "61",
      thumb: "assets/img/Pastevents/61.jpg",
    },
    {
      src: "assets/img/Pastevents/62.jpg",
      caption: "62",
      thumb: "assets/img/Pastevents/62.jpg",
    },
    {
      src: "assets/img/Pastevents/63.jpg",
      caption: "63",
      thumb: "assets/img/Pastevents/63.jpg",
    },
    {
      src: "assets/img/Pastevents/64.jpg",
      caption: "64",
      thumb: "assets/img/Pastevents/64.jpg",
    },
    {
      src: "assets/img/Pastevents/65.jpg",
      caption: "65",
      thumb: "assets/img/Pastevents/65.jpg",
    },
    {
      src: "assets/img/Pastevents/47.jpeg",
      caption: "47",
      thumb: "assets/img/Pastevents/47.jpeg",
    },
    {
      src: "assets/img/Pastevents/48.jpeg",
      caption: "48",
      thumb: "assets/img/Pastevents/48.jpeg",
    },
    {
      src: "assets/img/Pastevents/49.jpeg",
      caption: "49",
      thumb: "assets/img/Pastevents/49.jpeg",
    },
    {
      src: "assets/img/Pastevents/50.jpeg",
      caption: "50",
      thumb: "assets/img/Pastevents/50.jpeg",
    },
    {
      src: "assets/img/Pastevents/51.jpeg",
      caption: "51",
      thumb: "assets/img/Pastevents/51.jpeg",
    },
    {
      src: "assets/img/Pastevents/52.jpeg",
      caption: "52",
      thumb: "assets/img/Pastevents/52.jpeg",
    },
    {
      src: "assets/img/Pastevents/53.jpeg",
      caption: "53",
      thumb: "assets/img/Pastevents/53.jpeg",
    },
    {
      src: "assets/img/Pastevents/54.jpeg",
      caption: "54",
      thumb: "assets/img/Pastevents/54.jpeg",
    },
    {
      src: "assets/img/Pastevents/55.jpeg",
      caption: "55",
      thumb: "assets/img/Pastevents/55.jpeg",
    },
    {
      src: "assets/img/Pastevents/56.jpeg",
      caption: "56",
      thumb: "assets/img/Pastevents/56.jpeg",
    },
    {
      src: "assets/img/Pastevents/42.jpeg",
      caption: "42",
      thumb: "assets/img/Pastevents/42.jpeg",
    },
    {
      src: "assets/img/Pastevents/43.jpeg",
      caption: "43",
      thumb: "assets/img/Pastevents/43.jpeg",
    },
    {
      src: "assets/img/Pastevents/44.jpeg",
      caption: "44",
      thumb: "assets/img/Pastevents/44.jpeg",
    },
    {
      src: "assets/img/Pastevents/45.jpeg",
      caption: "45",
      thumb: "assets/img/Pastevents/45.jpeg",
    },
    {
      src: "assets/img/Pastevents/46.jpeg",
      caption: "46",
      thumb: "assets/img/Pastevents/46.jpeg",
    },
    {
      src: "assets/img/Pastevents/36.jpeg",
      caption: "36",
      thumb: "assets/img/Pastevents/36.jpeg",
    },
    {
      src: "assets/img/Pastevents/38.jpeg",
      caption: "38",
      thumb: "assets/img/Pastevents/38.jpeg",
    },
    {
      src: "assets/img/Pastevents/39.jpeg",
      caption: "39",
      thumb: "assets/img/Pastevents/39.jpeg",
    },
    {
      src: "assets/img/Pastevents/40.jpeg",
      caption: "40",
      thumb: "assets/img/Pastevents/40.jpeg",
    },
    {
      src: "assets/img/Pastevents/41.jpeg",
      caption: "41",
      thumb: "assets/img/Pastevents/41.jpeg",
    },
    {
      src: "assets/img/Pastevents/31.jpeg",
      caption: "31",
      thumb: "assets/img/Pastevents/31.jpeg",
    },
    {
      src: "assets/img/Pastevents/32.jpeg",
      caption: "32",
      thumb: "assets/img/Pastevents/32.jpeg",
    },
    {
      src: "assets/img/Pastevents/33.jpeg",
      caption: "33",
      thumb: "assets/img/Pastevents/33.jpeg",
    },
    {
      src: "assets/img/Pastevents/34.jpeg",
      caption: "34",
      thumb: "assets/img/Pastevents/34.jpeg",
    },
    {
      src: "assets/img/Pastevents/35.jpeg",
      caption: "35",
      thumb: "assets/img/Pastevents/35.jpeg",
    },
    {
      src: "assets/img/Pastevents/26-01-2020.jpg",
      caption: "1",
      thumb: "assets/img/Pastevents/26-01-2020.jpg",
    },
    {
      src: "assets/img/Pastevents/10-03-2019.jpg",
      caption: "2",
      thumb: "assets/img/Pastevents/10-03-2019.jpg",
    },
    {
      src: "assets/img/Pastevents/19-12-2019.jpg",
      caption: "3",
      thumb: "assets/img/Pastevents/19-12-2019.jpg",
    },
    {
      src: "assets/img/Pastevents/06-11-2019.jpg",
      caption: "4",
      thumb: "assets/img/Pastevents/06-11-2019.jpg",
    },
    {
      src: "assets/img/Pastevents/17-11-2019.jpg",
      caption: "5",
      thumb: "assets/img/Pastevents/17-11-2019.jpg",
    },
    {
      src: "assets/img/Pastevents/22-12-2019.jpg",
      caption: "6",
      thumb: "assets/img/Pastevents/22-12-2019.jpg",
    },
    {
      src: "assets/img/Pastevents/01-12-2019.jpg",
      caption: "7",
      thumb: "assets/img/Pastevents/01-12-2019.jpg",
    },
    {
      src: "assets/img/Pastevents/14-12-2019.jpg",
      caption: "8",
      thumb: "assets/img/Pastevents/14-12-2019.jpg",
    },
    {
      src: "assets/img/Pastevents/29-10-2019.jpg",
      caption: "9",
      thumb: "assets/img/Pastevents/29-10-2019.jpg",
    },
    {
      src: "assets/img/Pastevents/18-06-2019.jpg",
      caption: "10",
      thumb: "assets/img/Pastevents/18-06-2019.jpg",
    },
    {
      src: "assets/img/Pastevents/11.jpg",
      caption: "11",
      thumb: "assets/img/Pastevents/11.jpg",
    },
    {
      src: "assets/img/Pastevents/12.jpg",
      caption: "12",
      thumb: "assets/img/Pastevents/12.jpg",
    },
    {
      src: "assets/img/Pastevents/13.jpg",
      caption: "13",
      thumb: "assets/img/Pastevents/13.jpg",
    },
    {
      src: "assets/img/Pastevents/14.jpg",
      caption: "14",
      thumb: "assets/img/Pastevents/14.jpg",
    },
    {
      src: "assets/img/Pastevents/15.jpg",
      caption: "15",
      thumb: "assets/img/Pastevents/15.jpg",
    },
    {
      src: "assets/img/Pastevents/16.jpg",
      caption: "16",
      thumb: "assets/img/Pastevents/16.jpg",
    },
    {
      src: "assets/img/Pastevents/17.jpg",
      caption: "17",
      thumb: "assets/img/Pastevents/17.jpg",
    },
    {
      src: "assets/img/Pastevents/18.jpg",
      caption: "18",
      thumb: "assets/img/Pastevents/18.jpg",
    },
    {
      src: "assets/img/Pastevents/19.jpg",
      caption: "19",
      thumb: "assets/img/Pastevents/19.jpg",
    },
    {
      src: "assets/img/Pastevents/20.jpg",
      caption: "20",
      thumb: "assets/img/Pastevents/20.jpg",
    },
    {
      src: "assets/img/Pastevents/21.jpg",
      caption: "21",
      thumb: "assets/img/Pastevents/21.jpg",
    },
    {
      src: "assets/img/Pastevents/22.jpg",
      caption: "22",
      thumb: "assets/img/Pastevents/22.jpg",
    },
    {
      src: "assets/img/Pastevents/23.jpg",
      caption: "23",
      thumb: "assets/img/Pastevents/23.jpg",
    },
    {
      src: "assets/img/Pastevents/24.jpg",
      caption: "24",
      thumb: "assets/img/Pastevents/24.jpg",
    },
    {
      src: "assets/img/Pastevents/25.jpg",
      caption: "25",
      thumb: "assets/img/Pastevents/25.jpg",
    },
    {
      src: "assets/img/Pastevents/26.jpg",
      caption: "26",
      thumb: "assets/img/Pastevents/26.jpg",
    },
    {
      src: "assets/img/Pastevents/27.jpg",
      caption: "27",
      thumb: "assets/img/Pastevents/27.jpg",
    },
    {
      src: "assets/img/Pastevents/28.jpg",
      caption: "28",
      thumb: "assets/img/Pastevents/28.jpg",
    },
    {
      src: "assets/img/Pastevents/29.jpg",
      caption: "29",
      thumb: "assets/img/Pastevents/29.jpg",
    },
    {
      src: "assets/img/Pastevents/30.jpg",
      caption: "30",
      thumb: "assets/img/Pastevents/30.jpg",
    },
  ];

  PADANOLSAVAM_GALLERY: Array<{ src: string; caption: string; thumb: string }> =
    [
      {
        src: "assets/img/padanolsavam/94.jpeg",
        caption:
          "Nims Medicity donated mobile phones to Mr.Shafi Parambil to support student for online classes",
        thumb: "assets/img/padanolsavam/94.jpeg",
      },
      {
        src: "assets/img/padanolsavam/95.jpeg",
        caption:
          "Nims Medicity donated Mobile phones to Mr.Chandy Oomen for his Mobile challenge campaign to support student for online classes",
        thumb: "assets/img/padanolsavam/95.jpeg",
      },
      {
        src: "assets/img/edu/1.jpeg",
        caption:
          "സൗജന്യ online പഠനസഹായ പദ്ധതിയുടെ ഭാഗമായി നിംസ് മെഡിസിറ്റി എം ടി ശ്രീ എം എസ് ഫൈസൽ ഖാൻ പട്ടം St മേരീസ്‌ സ്കൂളിലെ നിർധനരായ വിദ്യാർഥികൾക്കുള്ള മൊബൈൽ ഫോൺ സ്കൂൾ പ്രിൻസിപ്പൽ ശ്രീ ഫാദർ ജോൺ അവർകൾക്ക് നൽകുകയുണ്ടായി.പ്രസ്‌തുത ചടങ്ങിൽ ശ്രീ ഗുരുരെത്നം ജ്ഞാനതപസി (ശാന്തിഗിരി), സ്കൂൾ ഹെഡ് മാസ്റ്റർ ശ്രീ ബിജോയ്‌, PTA പ്രസിഡന്റ്‌ ശ്രീ ഷാജി കുരിയാത്തി തുടങ്ങിയവർ സന്നിഹിതരായിരുന്നു..",
        thumb: "assets/img/edu/1.jpeg",
      },
      {
        src: "assets/img/padanolsavam/1.jpg",
        caption: "1",
        thumb: "assets/img/padanolsavam/1.jpg",
      },
      {
        src: "assets/img/padanolsavam/2.jpg",
        caption: "2",
        thumb: "assets/img/padanolsavam/2.jpg",
      },
      {
        src: "assets/img/padanolsavam/3.jpg",
        caption: "3",
        thumb: "assets/img/padanolsavam/3.jpg",
      },
      //{src:'assets/img/padanolsavam/4.jpg',caption: '4',thumb:'assets/img/padanolsavam/4.jpg'},
      {
        src: "assets/img/padanolsavam/5.jpg",
        caption: "5",
        thumb: "assets/img/padanolsavam/5.jpg",
      },
      {
        src: "assets/img/padanolsavam/6.jpg",
        caption: "6",
        thumb: "assets/img/padanolsavam/6.jpg",
      },
      //{src:'assets/img/padanolsavam/7.jpg',caption: '7',thumb:'assets/img/padanolsavam/7.jpg'},
      {
        src: "assets/img/padanolsavam/8.jpg",
        caption: "8",
        thumb: "assets/img/padanolsavam/8.jpg",
      },
      {
        src: "assets/img/padanolsavam/9.jpg",
        caption: "9",
        thumb: "assets/img/padanolsavam/9.jpg",
      },
      //{src:'assets/img/padanolsavam/10.jpg',caption:'10',thumb:'assets/img/padanolsavam/10.jpg'},
      {
        src: "assets/img/padanolsavam/11.jpg",
        caption: "11",
        thumb: "assets/img/padanolsavam/11.jpg",
      },
      {
        src: "assets/img/padanolsavam/12.jpg",
        caption: "12",
        thumb: "assets/img/padanolsavam/12.jpg",
      },
      {
        src: "assets/img/padanolsavam/13.jpg",
        caption: "13",
        thumb: "assets/img/padanolsavam/13.jpg",
      },
      {
        src: "assets/img/padanolsavam/14.jpg",
        caption: "14",
        thumb: "assets/img/padanolsavam/14.jpg",
      },
      {
        src: "assets/img/padanolsavam/15.jpg",
        caption: "15",
        thumb: "assets/img/padanolsavam/15.jpg",
      },
      {
        src: "assets/img/padanolsavam/16.jpg",
        caption: "16",
        thumb: "assets/img/padanolsavam/16.jpg",
      },
      {
        src: "assets/img/padanolsavam/17.jpg",
        caption: "17",
        thumb: "assets/img/padanolsavam/17.jpg",
      },
      {
        src: "assets/img/padanolsavam/18.jpg",
        caption: "18",
        thumb: "assets/img/padanolsavam/18.jpg",
      },
      {
        src: "assets/img/padanolsavam/19.jpg",
        caption: "19",
        thumb: "assets/img/padanolsavam/19.jpg",
      },
      {
        src: "assets/img/padanolsavam/20.jpg",
        caption: "20",
        thumb: "assets/img/padanolsavam/20.jpg",
      },
      {
        src: "assets/img/padanolsavam/21.jpg",
        caption: "21",
        thumb: "assets/img/padanolsavam/21.jpg",
      },
      {
        src: "assets/img/padanolsavam/22.jpg",
        caption: "22",
        thumb: "assets/img/padanolsavam/22.jpg",
      },
      {
        src: "assets/img/padanolsavam/23.jpg",
        caption: "23",
        thumb: "assets/img/padanolsavam/23.jpg",
      },
      {
        src: "assets/img/padanolsavam/24.jpg",
        caption: "24",
        thumb: "assets/img/padanolsavam/24.jpg",
      },
      {
        src: "assets/img/padanolsavam/25.jpg",
        caption: "25",
        thumb: "assets/img/padanolsavam/25.jpg",
      },
      {
        src: "assets/img/padanolsavam/26.jpg",
        caption: "26",
        thumb: "assets/img/padanolsavam/26.jpg",
      },
      {
        src: "assets/img/padanolsavam/27.jpg",
        caption: "27",
        thumb: "assets/img/padanolsavam/27.jpg",
      },
      {
        src: "assets/img/padanolsavam/28.jpg",
        caption: "28",
        thumb: "assets/img/padanolsavam/28.jpg",
      },
      {
        src: "assets/img/padanolsavam/29.jpg",
        caption: "29",
        thumb: "assets/img/padanolsavam/29.jpg",
      },
      {
        src: "assets/img/padanolsavam/30.jpg",
        caption: "30",
        thumb: "assets/img/padanolsavam/30.jpg",
      },
      {
        src: "assets/img/padanolsavam/31.jpg",
        caption: "31",
        thumb: "assets/img/padanolsavam/31.jpg",
      },
      {
        src: "assets/img/padanolsavam/32.jpg",
        caption: "32",
        thumb: "assets/img/padanolsavam/32.jpg",
      },
      {
        src: "assets/img/padanolsavam/33.jpg",
        caption: "33",
        thumb: "assets/img/padanolsavam/33.jpg",
      },
      {
        src: "assets/img/padanolsavam/34.jpg",
        caption: "34",
        thumb: "assets/img/padanolsavam/34.jpg",
      },
      {
        src: "assets/img/padanolsavam/35.jpg",
        caption: "35",
        thumb: "assets/img/padanolsavam/35.jpg",
      },
      {
        src: "assets/img/padanolsavam/36.jpg",
        caption: "36",
        thumb: "assets/img/padanolsavam/36.jpg",
      },
      {
        src: "assets/img/padanolsavam/37.jpg",
        caption: "37",
        thumb: "assets/img/padanolsavam/37.jpg",
      },
      {
        src: "assets/img/padanolsavam/38.jpg",
        caption: "38",
        thumb: "assets/img/padanolsavam/38.jpg",
      },
      {
        src: "assets/img/padanolsavam/39.jpg",
        caption: "39",
        thumb: "assets/img/padanolsavam/39.jpg",
      },
      {
        src: "assets/img/padanolsavam/40.jpg",
        caption: "40",
        thumb: "assets/img/padanolsavam/40.jpg",
      },
      {
        src: "assets/img/padanolsavam/41.jpg",
        caption: "41",
        thumb: "assets/img/padanolsavam/41.jpg",
      },
      {
        src: "assets/img/padanolsavam/42.jpg",
        caption: "42",
        thumb: "assets/img/padanolsavam/42.jpg",
      },
      {
        src: "assets/img/padanolsavam/43.jpg",
        caption: "43",
        thumb: "assets/img/padanolsavam/43.jpg",
      },
      {
        src: "assets/img/padanolsavam/44.jpg",
        caption: "44",
        thumb: "assets/img/padanolsavam/44.jpg",
      },
      {
        src: "assets/img/padanolsavam/45.jpg",
        caption: "45",
        thumb: "assets/img/padanolsavam/45.jpg",
      },
      {
        src: "assets/img/padanolsavam/46.jpg",
        caption: "46",
        thumb: "assets/img/padanolsavam/46.jpg",
      },
      {
        src: "assets/img/padanolsavam/47.jpg",
        caption: "47",
        thumb: "assets/img/padanolsavam/47.jpg",
      },
      {
        src: "assets/img/padanolsavam/48.jpg",
        caption: "48",
        thumb: "assets/img/padanolsavam/48.jpg",
      },
      {
        src: "assets/img/padanolsavam/49.jpg",
        caption: "49",
        thumb: "assets/img/padanolsavam/49.jpg",
      },
      {
        src: "assets/img/padanolsavam/50.jpg",
        caption: "50",
        thumb: "assets/img/padanolsavam/50.jpg",
      },
      {
        src: "assets/img/padanolsavam/51.jpg",
        caption: "51",
        thumb: "assets/img/padanolsavam/51.jpg",
      },
      {
        src: "assets/img/padanolsavam/52.jpg",
        caption: "52",
        thumb: "assets/img/padanolsavam/52.jpg",
      },
      {
        src: "assets/img/padanolsavam/53.jpg",
        caption: "53",
        thumb: "assets/img/padanolsavam/53.jpg",
      },
      {
        src: "assets/img/padanolsavam/54.jpg",
        caption: "54",
        thumb: "assets/img/padanolsavam/54.jpg",
      },
      {
        src: "assets/img/padanolsavam/55.jpg",
        caption: "55",
        thumb: "assets/img/padanolsavam/55.jpg",
      },
      {
        src: "assets/img/padanolsavam/56.jpg",
        caption: "56",
        thumb: "assets/img/padanolsavam/56.jpg",
      },
      {
        src: "assets/img/padanolsavam/57.jpg",
        caption: "57",
        thumb: "assets/img/padanolsavam/57.jpg",
      },
      {
        src: "assets/img/padanolsavam/58.jpg",
        caption: "58",
        thumb: "assets/img/padanolsavam/58.jpg",
      },
      {
        src: "assets/img/padanolsavam/59.jpg",
        caption: "59",
        thumb: "assets/img/padanolsavam/59.jpg",
      },
      {
        src: "assets/img/padanolsavam/60.jpg",
        caption: "60",
        thumb: "assets/img/padanolsavam/60.jpg",
      },
      {
        src: "assets/img/padanolsavam/61.jpg",
        caption: "61",
        thumb: "assets/img/padanolsavam/61.jpg",
      },
      {
        src: "assets/img/padanolsavam/62.jpg",
        caption: "62",
        thumb: "assets/img/padanolsavam/62.jpg",
      },
      {
        src: "assets/img/padanolsavam/63.jpg",
        caption: "63",
        thumb: "assets/img/padanolsavam/63.jpg",
      },
      {
        src: "assets/img/padanolsavam/64.jpg",
        caption: "64",
        thumb: "assets/img/padanolsavam/64.jpg",
      },
      {
        src: "assets/img/padanolsavam/65.jpg",
        caption: "65",
        thumb: "assets/img/padanolsavam/65.jpg",
      },
      {
        src: "assets/img/padanolsavam/66.jpg",
        caption: "66",
        thumb: "assets/img/padanolsavam/66.jpg",
      },
      {
        src: "assets/img/padanolsavam/67.jpg",
        caption: "67",
        thumb: "assets/img/padanolsavam/67.jpg",
      },
      {
        src: "assets/img/padanolsavam/68.jpg",
        caption: "68",
        thumb: "assets/img/padanolsavam/68.jpg",
      },
      {
        src: "assets/img/padanolsavam/69.jpg",
        caption: "69",
        thumb: "assets/img/padanolsavam/69.jpg",
      },
      {
        src: "assets/img/padanolsavam/70.jpg",
        caption: "70",
        thumb: "assets/img/padanolsavam/70.jpg",
      },
      {
        src: "assets/img/padanolsavam/71.jpg",
        caption: "71",
        thumb: "assets/img/padanolsavam/71.jpg",
      },
      {
        src: "assets/img/padanolsavam/72.jpg",
        caption: "72",
        thumb: "assets/img/padanolsavam/72.jpg",
      },
      {
        src: "assets/img/padanolsavam/73.jpg",
        caption: "73",
        thumb: "assets/img/padanolsavam/73.jpg",
      },
      {
        src: "assets/img/padanolsavam/74.jpg",
        caption: "74",
        thumb: "assets/img/padanolsavam/74.jpg",
      },
      {
        src: "assets/img/padanolsavam/75.jpg",
        caption: "75",
        thumb: "assets/img/padanolsavam/75.jpg",
      },
      {
        src: "assets/img/padanolsavam/76.jpg",
        caption: "76",
        thumb: "assets/img/padanolsavam/76.jpg",
      },
      {
        src: "assets/img/padanolsavam/77.jpg",
        caption: "77",
        thumb: "assets/img/padanolsavam/77.jpg",
      },
      {
        src: "assets/img/padanolsavam/78.jpg",
        caption: "78",
        thumb: "assets/img/padanolsavam/78.jpg",
      },
      {
        src: "assets/img/padanolsavam/79.jpg",
        caption: "79",
        thumb: "assets/img/padanolsavam/79.jpg",
      },
      {
        src: "assets/img/padanolsavam/80.jpg",
        caption: "80",
        thumb: "assets/img/padanolsavam/80.jpg",
      },
      {
        src: "assets/img/padanolsavam/81.jpg",
        caption: "81",
        thumb: "assets/img/padanolsavam/81.jpg",
      },
      {
        src: "assets/img/padanolsavam/82.jpg",
        caption: "82",
        thumb: "assets/img/padanolsavam/82.jpg",
      },
      {
        src: "assets/img/padanolsavam/83.jpg",
        caption: "83",
        thumb: "assets/img/padanolsavam/83.jpg",
      },
      {
        src: "assets/img/padanolsavam/84.jpg",
        caption: "84",
        thumb: "assets/img/padanolsavam/84.jpg",
      },
      {
        src: "assets/img/padanolsavam/85.jpg",
        caption: "85",
        thumb: "assets/img/padanolsavam/85.jpg",
      },
      {
        src: "assets/img/padanolsavam/86.jpg",
        caption: "86",
        thumb: "assets/img/padanolsavam/86.jpg",
      },
      {
        src: "assets/img/padanolsavam/87.jpg",
        caption: "87",
        thumb: "assets/img/padanolsavam/87.jpg",
      },
      {
        src: "assets/img/padanolsavam/88.jpg",
        caption: "88",
        thumb: "assets/img/padanolsavam/88.jpg",
      },
      {
        src: "assets/img/padanolsavam/89.jpg",
        caption: "89",
        thumb: "assets/img/padanolsavam/89.jpg",
      },
      {
        src: "assets/img/padanolsavam/90.jpg",
        caption: "90",
        thumb: "assets/img/padanolsavam/90.jpg",
      },
      {
        src: "assets/img/padanolsavam/91.jpg",
        caption: "91",
        thumb: "assets/img/padanolsavam/91.jpg",
      },
      {
        src: "assets/img/padanolsavam/92.jpg",
        caption: "92",
        thumb: "assets/img/padanolsavam/92.jpg",
      },
      {
        src: "assets/img/padanolsavam/93.jpg",
        caption: "93",
        thumb: "assets/img/padanolsavam/93.jpg",
      },
    ];

  NANO_GALLERY: Array<{ src: string; caption: string; thumb: string }> = [
    //{src:'assets/img/NANO/1.jpg',caption: '1',thumb:'assets/img/NANO/1.jpg'},
    {
      src: "assets/img/NANO/2.jpg",
      caption: "2",
      thumb: "assets/img/NANO/2.jpg",
    },
    {
      src: "assets/img/NANO/3.jpg",
      caption: "3",
      thumb: "assets/img/NANO/3.jpg",
    },
    {
      src: "assets/img/NANO/4.jpg",
      caption: "4",
      thumb: "assets/img/NANO/4.jpg",
    },
    {
      src: "assets/img/NANO/5.jpg",
      caption: "5",
      thumb: "assets/img/NANO/5.jpg",
    },
    {
      src: "assets/img/NANO/6.jpg",
      caption: "6",
      thumb: "assets/img/NANO/6.jpg",
    },
    {
      src: "assets/img/NANO/7.jpg",
      caption: "7",
      thumb: "assets/img/NANO/7.jpg",
    },
    {
      src: "assets/img/NANO/8.jpg",
      caption: "8",
      thumb: "assets/img/NANO/8.jpg",
    },
    {
      src: "assets/img/NANO/9.jpg",
      caption: "9",
      thumb: "assets/img/NANO/9.jpg",
    },
    {
      src: "assets/img/NANO/10.jpg",
      caption: "10",
      thumb: "assets/img/NANO/10.jpg",
    },
    {
      src: "assets/img/NANO/11.jpg",
      caption: "11",
      thumb: "assets/img/NANO/11.jpg",
    },
    {
      src: "assets/img/NANO/12.jpg",
      caption: "12",
      thumb: "assets/img/NANO/12.jpg",
    },
  ];

  NUTRI_GALLERY: Array<{ src: string; caption: string; thumb: string }> = [
    {
      src: "assets/img/Nutrients/1.jpeg",
      caption:
        "Distribution of Covid Relief Kit by NIMS Medicity.Distribution of Kovid Relief Kit by Nimes Medicity.",
      thumb: "assets/img/Nutrients/1.jpeg",
    },
    {
      src: "assets/img/Nutrients/2.jpeg",
      caption:
        "Distribution of Kovid Relief Kit by Nimes Medicity.. Near Sajinlal, Avanendra Kumar, NIMS Managing Director M.S.Faisal Khan, Aruvipuram Sreekumar, N.R.C.Nair, N.K.Sasi, and Rajesh",
      thumb: "assets/img/Nutrients/2.jpeg",
    },
  ];

  UPCOMMING_EVENT_GALLERY: Array<{
    cardImage: string;
    header: string;
    location: string;
    date: string;
    discription: string;
    shortNote: string;
    imageCollection: [];
  }> = [
    // {
    //   cardImage:'assets/img/Pastevents/28-02-2021.jpg',
    //   header: 'NIMS Medicity free Mega Medical Camp at Karaikamandapam',
    //   location: 'St. Antony\'s School, Karaikamandapam' ,
    //   date: '28/02/2021',
    //   discription: 'NIMS medicity Free Medical Camp@ St. Antony\'s School, Karaikamandapam.',
    //   shortNote:'',
    //   imageCollection:[]
    // },
    // {
    //   cardImage:'assets/img/Pastevents/21-02-2021.jpg',
    //   header: 'NIMS Medicity free Mega Medical Camp at Thampanoor',
    //   location: 'S.M.V Higher Secondary School, Thampanoor',
    //   date: '21/02/2021',
    //   discription: 'NIMS medicity Free Medical Camp@ S.M.V Higher Secondary School,Thampanoor.',
    //   shortNote:'',
    //   imageCollection:[]
    // },
  ];

  PAST_EVENT_GALLERY: Array<{
    cardImage: string;
    header: string;
    location: string;
    date: string;
    discription: string;
    shortNote: string;
    imageCollection: [];
  }> = [
  {
      cardImage: "assets/img/Pastevents/05-24-2025.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ കുടപ്പനക്കുന്ന് തീർത്ഥ ഓഡിറ്റോറിയം",
      location: "കുടപ്പനക്കുന്ന് തീർത്ഥ ഓഡിറ്റോറിയം ",
      date: "05-24-2025",
      discription:
        "സേവാശക്തി ഫൗണ്ടേഷനും,നിംസ് മെഡിസിറ്റിയും ഇരപ്പുകുഴി കൂട്ടായ്മയും സംയുക്തമായി സംഘടിപ്പിക്കുന്ന സൗജന്യ സൂപ്പർ സ്പെഷ്യാലിറ്റി മെഗാ മെഡിക്കൽ ക്യാമ്പ് തിരുവനന്തപുരം കുടപ്പനക്കുന്ന് തീർത്ഥ ഓഡിറ്റോറിയത്തിൽ വച്ച് പ്രമുഖ സിനിമ സീരിയൽ നടൻ ശ്രീ. ദിനേശ് പണിക്കർ ഉദ്ഘാടനം ചെയ്തു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/04-27-2025.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ കരുമം",
      location: "കരുമം ",
      date: "04-27-2025",
      discription:
        "കരുമം ശ്രീ മഹാവിഷ്ണു ഗ്രാമസേവാ സമിതിയുടെയും, നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്താഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
  {
      cardImage: "assets/img/Pastevents/04-11-2025.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ നല്ലയണി",
      location: "നല്ലയണി ",
      date: "04-11-2025",
      discription:
        "നിംസ് മെഡിസിറ്റിയും ,നല്ലയണി ശ്രീ ധർമ ശാസ്താക്ഷേത്രയോഗം ട്രസ്റ്റിന്റെയും ആഭിമുഖ്യത്തിൽ സംയുക്തമായി സംഘടിപ്പിച്ച സൗജന്യ മെഡിക്കൽ ക്യാമ്പ്.",
      shortNote: "",
      imageCollection: [],
    },
  {
      cardImage: "assets/img/Pastevents/04-05-2025.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ കുരിശുമല",
      location: "കുരിശുമല ",
      date: "04-05-2025",
      discription:
        "കുരിശുമല തീർത്ഥാടനത്തിന്റെ ഭാഗമായി സൗജന്യ മെഡിക്കൽ സഹായവും ആംബുലൻസ് സർവീസും എല്ലാ ദിവസവും രാത്രി 12 മണി വരെ തീർത്ഥാടകർക്ക് പ്രയോജനപ്പെടുത്താവുന്നതാണ്",
      shortNote: "",
      imageCollection: [],
    },
  {
      cardImage: "assets/img/Pastevents/04-03-2025.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ ചന്ദ്രശേഖരൻ നായർ സ്റ്റേഡിയം",
      location: "ചന്ദ്രശേഖരൻ നായർ സ്റ്റേഡിയം ",
      date: "04-03-2025",
      discription:
        "മീഡിയ ഫുട്ബോൾ ലീഗ് 💖 തിരുവനന്തപുരം പ്രസ് ക്ലബിന്റെ ‌ ആഭിമുഖ്യത്തിൽ ചന്ദ്രശേഖരൻ നായർ സ്റ്റേഡിയത്തിൽ വച്ച് നിംസ് സംഘടിപ്പിച്ച വൈദ്യ സഹായ ക്യാമ്പ്..",
      shortNote: "",
      imageCollection: [],
    },
  {
      cardImage: "assets/img/Pastevents/03-30-20252.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ വ്ളാത്താങ്കര",
      location: "വ്ളാത്താങ്കര ",
      date: "03-30-2025",
      discription:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ സ്വർഗ്ഗാരോപിത മാതാ ഫൊറോന ദൈവാലയം, മരിയൻ തീർത്ഥാടന കേന്ദ്രം , വ്ളാത്താങ്കര  നിഡ്സ് യൂണിറ്റ് സംയുക്തമായി വ്ളാത്താങ്കര ദൈവാലയം അങ്കണത്തിൽ വച്ച് നടന്ന സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് ....",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/03-30-20251.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ യോഗാസന  സ്പോർട്സ് ചാമ്പ്യൻഷിപ്പിൽ ",
      location: "യോഗാസന  സ്പോർട്സ് ചാമ്പ്യൻഷിപ്പിൽ  ",
      date: "03-30-2025",
      discription:
        "അഞ്ചാമത്  നാഷണൽ യോഗാസന  സ്പോർട്സ് ചാമ്പ്യൻഷിപ്പിൽ നിംസ് വൈദ്യ സഹായ ക്യാമ്പ്.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/03-30-2025.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ ഉദയ പാലസ് കൺവെൻഷൻ സെന്റർ",
      location: "ഉദയ പാലസ് കൺവെൻഷൻ സെന്റർ ",
      date: "03-30-2025",
      discription:
        "ഉദയ പാലസ് കൺവെൻഷൻ സെന്ററിൽ വച്ചു ട്രിവാൻഡ്രം സെന്റർ ഫോർ പെർഫോമിംഗ്  ആർട്സ് സംഘടിപ്പിച്ച നൃത്താവിഷ്ക്കാര സന്ധ്യയിൽ  നിംസ് അടിയന്തിര വൈദ്യ സഹായ  ക്യാമ്പ്.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/03-21-2025.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ മഞ്ഞാലുമൂട്",
      location: "മഞ്ഞാലുമൂട് ",
      date: "03-21-2025",
      discription:
        "നിംസ് മെഡിസിറ്റിയും , സ്നേഹതീരം ഡേ കെയർ സെന്ററും  സംയുക്തമായി നടത്തിയ സൗജന്യ മെഡിക്കൽ ‌ക്യാമ്പ്.....",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/03-20-20252.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ കരുമം",
      location: "കരുമം",
      date: "03-20-2025",
      discription:
        "തിരുവനന്തപുരം കരുമം ശ്രീ ആയിരവല്ലി തമ്പുരാൻ ക്ഷേത്രം  തെയ്യം മഹോത്സവത്തോടനുബന്ധിച്ച് നിംസ്  മെഡിസിറ്റിയുടെയും നിംസ് മൈക്രോ ഹോസ്പിറ്റൽസിന്റെയും ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/03-20-20251.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ മഞ്ചവിളാകം",
      location: "മഞ്ചവിളാകം",
      date: "03-20-2025",
      discription:
        "നിംസ് മെഡിസിറ്റിയും അനന്തപുരി സോൾജിയേഴ്‌സ് വെൽഫെയർ & ചാരിറ്റി ഓർഗനൈസേഷനും സംയുക്തമായി നടത്തിയ സൗജന്യ മെഡിക്കൽ ‌ &  ബ്ലഡ്‌ ഡൊണേഷൻ  ക്യാമ്പ്",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/03-20-2025.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ ആറ്റൂർ  ",
      location: "ആറ്റൂർ  ",
      date: "03-20-2025",
      discription:
        "കാൻസർ സേഫ് കേരള രണ്ടാം ഘട്ടം പദ്ധതിയുടെ ഭാഗമായി കേരള സർക്കാർ \"ആരോഗ്യം-ആനന്ദം അകറ്റാം അർബുദം\" കാൻസർ പ്രതിരോധത്തിനായുള്ള സംസ്ഥാനതല ക്യാമ്പയിന്റെ ഭാഗമായി നിംസ് മെഡിസിറ്റി, സ്വസ്തി ഫൗണ്ടേഷൻ, സിറ്റിസൺസ് ഇന്ത്യ ഫൗണ്ടേഷൻ, തക്കല ആലയം ട്രസ്റ്റ് സംയുക്തമായി ആറ്റൂർ NVKS സീനിയർ സെക്കൻഡറി സ്കൂളിൽ വച്ച്  സൗജന്യ കാൻസർ നിർണ്ണയ മെഗാ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
   {
      cardImage: "assets/img/Pastevents/03-16-2025.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ തൊലിക്കോട് ",
      location: "തൊലിക്കോട് ",
      date: "03-16-2025",
      discription:
        "നിംസ് മെഡിസിറ്റിയും വട്ടിയൂർക്കാവ് ശ്രീ  സത്യസായി ക്ഷേത്ര ട്രസ്റ്റും സംയുക്തമായി തൊലിക്കോട് , കുടമൻകോട് ക്ഷേത്രത്തിൽ നടത്തിയ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ്‌....",
      shortNote: "",
      imageCollection: [],
    },
     {
      cardImage: "assets/img/Pastevents/03-14-2025.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ കപ്പിയാറ",
      location: "കപ്പിയാറ",
      date: "03-14-2025",
      discription:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ കപ്പിയാറ ശ്രീ ഭദ്രകാളി ക്ഷേത്രത്തിൽ വച്ച്  നടന്ന സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
  {
      cardImage: "assets/img/Pastevents/03-12-20251.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ വെള്ളറട",
      location: "വെള്ളറട",
      date: "03-12-2025",
      discription:
        "വെള്ളറട നിംസ് ടെലി മെഡിസിൻ ക്ലിനിക്കിൽ വച്ച് നടന്ന  സൗജന്യ മെഡിക്കൽ ക്യാമ്പ്... ",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/03-12-2025.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ ഊരുട്ടുകല",
      location: "ഊരുട്ടുകല",
      date: "03-12-2025",
      discription:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ ഊരുട്ടുകല ശ്രീ ഭദ്രകാളി ദേവീ ക്ഷേത്രത്തിൽ സമൂഹ പൊങ്കാലയോടനുബന്ധിച്ച്  നടന്ന സൗജന്യ മെഡിക്കൽ ക്യാമ്പ്...",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/03-09-20251.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ CSI St LUKE's Church",
      location: "CSI St LUKE's Church",
      date: "03-09-2025",
      discription:
        "നിംസ് മെഡിസിറ്റി, സ്വസ്തി ഫൗണ്ടേഷൻ,സിറ്റിസൺസ് ഇന്ത്യ ഫൗണ്ടേഷനും സംയുക്തമായി ചേർന്ന് ചാണി മാനവ നഗർ  CSI സെന്റ് ലൂക്ക്സ് ചർച്ചിൽ വച്ച് സൗജന്യ കാൻസർ നിർണ്ണയ മെഗാ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/03-09-2025.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ അതുല്യ കോളേജ് ",
      location: "അതുല്യ കോളേജ് ",
      date: "03-09-2025",
      discription:
        "നിംസ് മെഡിസിറ്റിയും, മഹാത്മാ സാംസ്‌കാരിക വേദിയും സംയുക്തമായി നടത്തിയ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ്...",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/02-23-2025.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ പിറയിൽ",
      location: "പിറയിൽ",
      date: "02-23-2025",
      discription:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ  നോർത്ത് ഏരിയ പിറയിൽ റസിഡൻസ് അസോസിയേഷൻ സംയുക്തമായി നടത്തിയ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ്.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/02-21-2025.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ കരമന",
      location: "കരമന",
      date: "02-21-2025",
      discription:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ  കരമന മുസ്‌ലീം ജമാ അത്ത് പരിപാലന സമിതി സംഘടിപ്പിച്ച  സൗജന്യ മെഡിക്കൽ ക്യാമ്പ്",
      shortNote: "",
      imageCollection: [],
    },
  {
      cardImage: "assets/img/Pastevents/02-12-2025.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ ട്രിവാൻഡ്രം ടെന്നിസ് ക്ലബ് ",
      location: "ട്രിവാൻഡ്രം ടെന്നിസ് ക്ലബ്",
      date: "02-12-2025",
      discription:
        "ട്രിവാൻഡ്രം ടെന്നിസ് ക്ലബ് (TTC) ലെ ഇന്റർനാഷണൽ മാസ്റ്റേഴ്‌സ് ടെന്നിസ് ടൂർണമെന്റിലാണ് നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ അടിയന്തിര വൈദ്യ സഹായ  ക്യാമ്പ് സംഘടിപ്പിച്ചു  ",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/02-11-2025.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @  ട്രിവാൻഡ്രം ടെന്നിസ് ക്ലബ്",
      location: "ട്രിവാൻഡ്രം ടെന്നിസ് ക്ലബ്",
      date: "02-11-2025",
      discription:
        "ട്രിവാൻഡ്രം ടെന്നിസ് ക്ലബ് (TTC) ലെ ഇന്റർനാഷണൽ മാസ്റ്റേഴ്‌സ് ടെന്നിസ് ടൂർണമെന്റിലാണ് നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ അടിയന്തിര വൈദ്യ സഹായ  ക്യാമ്പ് സംഘടിപ്പിച്ചു  ",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/02-11-20251.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ ഫോർട്ട്‌ പോലീസ് സ്റ്റേഷൻ ",
      location: "ഫോർട്ട്‌ പോലീസ് സ്റ്റേഷൻ ",
      date: "02-11-2025",
      discription:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ ഫോർട്ട്‌ പോലീസ്  സ്റ്റേഷനിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു ",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/02-01-2025.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ മലയടി ശ്രീധർമ ശാസ്താ ക്ഷേത്രം ",
      location: "മലയടി ശ്രീധർമ ശാസ്താ ക്ഷേത്രം",
      date: "02-01-2025",
      discription:
        " ആഘോഷങ്ങൾക്ക് ആരവമുയർത്തി നിംസ് മെഡിസിറ്റി മലയടി ശ്രീധർമ ശാസ്താ ക്ഷേത്രത്തിൽ നടത്തിയ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ്...",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/01-29-2025.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ TVM ",
      location: "TVM",
      date: "01-29-2025",
      discription:
        "ആരോഗ്യത്തിന്റെ പുഞ്ചിരി 😍 രജിസ്റ്റേർഡ് എൻജിനിയർസ് &  സൂപ്പർവൈസേഴ്സ് ഫെഡറേഷന്റെ നാലാം സ്റ്റേറ്റ് കോൺഫറൻസ് ലയൺസ് ക്ലബ്ബും, നിംസ് മെഡിസിറ്റിയും സംയുക്തമായി ജിമ്മി ജോർജ് സ്റ്റേഡിയത്തിൽ  നടത്തിയ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് ✨️",
      shortNote: "",
      imageCollection: [],
    },
  {
      cardImage: "assets/img/Pastevents/01-25-2025.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ ബാലരാമപുരം ",
      location: "ബാലരാമപുരം",
      date: "01-25-2025",
      discription:
        "ബാലരാമപുരം വിശുദ്ധ സെബസ്ത്യാനോസിന്റെ തിരുനാളിനോടനുബന്ധിച്ച്  നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ സംഘടിപ്പിച്ച സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ്.",
      shortNote: "",
      imageCollection: [],
    },
  {
      cardImage: "assets/img/Pastevents/01-17-2025.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ NIMS ",
      location: "നെയ്യാറ്റിൻകര",
      date: "01-17-2025",
      discription:
        "മെഡിക്കൽ ഗാസ്ട്രോ വിഭാഗം സീനിയർ കൺസർട്ടൻറുമാരായ ഡോ. നീഹാർ എം ഷാനവാസ് , ഡോ. ബിൻസി ബി.കെ തുടങ്ങിയവർ ക്യാമ്പിന് നേതൃത്വം നൽകി",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/11-17-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ വെട്ടുകാട് ",
      location: "വെട്ടുകാട്",
      date: "11-17-2024",
      discription:
        "വെട്ടുകാട് മാദ്രെ ദെ ദേവൂസ് ദേവാലയ തിരുനാൾ ആഘോഷത്തോടനുബന്ധിച്ച്  നവംബർ 15 മുതൽ 24 വരെ നിംസ് മെഡിസിറ്റിയുടെ സൗജന്യ വൈദ്യ സഹായ ക്യാമ്പ്",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/11-17-20241.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ പേയാട്",
      location: "പേയാട്",
      date: "11-17-2024",
      discription:
        "പേയാട് ലയൺസ്‌ ക്ലബിന്റെയും, നിംസ് മെഡിസിറ്റിയുടെയും  സംയുക്താഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു...",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/11-14-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ വിളപ്പിൽ",
      location: "വിളപ്പിൽ",
      date: "11-14-2024",
      discription:
        "ശിശുദിനാഘോഷത്തോടനുബന്ധിച്ച് വിളപ്പിൽ പഞ്ചായത്തിലെ ഭിന്നശേഷി കുട്ടികൾക്കും നിംസ് മെഡിസിറ്റി പെൻഷൻ പ്ലാൻ ഗുണഭോക്താക്കൾക്കും വയോജനങ്ങൾക്കുമായി നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/11-14-20241.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ വെങ്ങാനൂർ",
      location: "വെങ്ങാനൂർ",
      date: "11-14-2024",
      discription:
        "ശിശുദിനത്തോടനുബന്ധിച്ച് കുട്ടികൾക്കായി സൗജന്യ ദന്തൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/11-09-20242.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ പോത്തൻകോട്",
      location: "പോത്തൻകോട്",
      date: "11-09-2024",
      discription:
        "പോത്തൻകോട് നിസാമിയ പബ്ലിക് സ്കൂളിന്റെ വാർഷികാഘോഷത്തോടനുബന്ധിച്ച് കുട്ടികൾക്കും , രക്ഷിതാക്കൾക്കും പൊതുജനങ്ങൾക്കും വേണ്ടി നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽസൗജന്യ മെഡിക്കൽ  ക്യാമ്പ് സംഘടിപ്പിച്ചു .",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/11-09-20241.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ ആറ്റിങ്ങൽ",
      location: "ആറ്റിങ്ങൽ",
      date: "11-09-2024",
      discription:
        "നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ ആറ്റിങ്ങൽ പാലസ് ലയൺസ് ക്ലബിന്റെയും , ശ്രീ ചിത്തിര തിരുനാൾ റസിഡൻസ് അസോസിയേഷന്റെയും  സംയുക്താഭിമുഖ്യത്തിൽ സൗജന്യ പ്രമേഹരോഗനിർണ്ണയവും മെഡിക്കൽ ക്യാമ്പും നടത്തുകയുണ്ടായി",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/11-09-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ നിംസ് മെഡിസിറ്റി ",
      location: "നിംസ് മെഡിസിറ്റി ",
      date: "11-09-2024",
      discription:
        "ഇ എൻ ടി വിഭാഗത്തിലെ വിദഗ്ധ ഡോക്ടർമാരായ ഡോ. നയൻതാര രമേഷ്, ഡോ. ആശ കുമാർ, ഡോ. മുരളീധരൻ, ഡോ. ഐശ്വര്യ എസ് ഗോപൻ, ഡോ. സാനി ബിനു കുട്ടൻ എന്നിവരുടെ നേതൃത്വത്തിലായിരുന്നു ക്യാമ്പ് സംഘടിപ്പിച്ചത്.200 ലധികം പേർ ക്യാമ്പിൽ പങ്കെടുത്തു",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/11-03-20242.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ കിളിമാനൂർ",
      location: "കിളിമാനൂർ",
      date: "11-03-2024",
      discription:
        "ശ്രീ ലളിതായനം ട്രസ്റ്റും കൈലാസം ശ്രീശക്തി ഗണപതി ക്ഷേത്ര സമിതിയും നിംസ് മെഡിസിറ്റിയും , നിംസ് മൈക്രോ ഹോസ്പിറ്റൽസ് & വത്സല നഴ്സിംഗ് ഹോമും സംയുക്തമായി നടത്തിയ മെഗാ മെഡിക്കൽ ക്യാമ്പ് കിളിമാനൂർ ഗ്രാമ പഞ്ചായത്ത് പ്രസിഡൻറ് ശ്രീ. ടി. ആർ. മനോജ് ഉദ്ഘാടനം ചെയ്തു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/11-03-20241.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ പനവിള",
      location: "പനവിള",
      date: "11-03-2024",
      discription:
        "പനവിള ഫ്രണ്ട്സ്  ആർട്സ് & സ്പോർട്സ് ക്ലബ്ബും, തിരുവനന്തപുരം എലൈറ്റ് ലയൺസ് ക്ലബ്ബും സംയുക്തമായി ചേർന്ന് നിംസ് മെഡിസിറ്റിയുടെ ആഭിമുഖ്യത്തിൽ  സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/11-03-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ കരമന",
      location: "കരമന",
      date: "11-03-2024",
      discription:
        "DYFI സ്ഥാപക ദിനാചരണത്തോടനുബന്ധിച്ച് DYFI കരമന യൂണിറ്റും നിംസ് മെഡിസിറ്റിയും സംയുക്തമായി ചേർന്ന് സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.*",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/10-28-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ പൂവച്ചൽ",
      location: "പൂവച്ചൽ",
      date: "10-28-2024",
      discription:
        "ചാത്തന്നൂർ റോട്ടറി ക്ലബ്ബ് , സൗഹൃദം '86' സംയുക്തമായി നിംസ് മെഡിസിറ്റിയുടെ ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/10-26-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ നിംസ് മെഡിസിറ്റി ",
      location: "നിംസ് മെഡിസിറ്റി ",
      date: "10-26-2024",
      discription:
        "നിംസ് മെഡിസിറ്റിയിൽ കുട്ടികൾക്കും മുതിർന്നവർക്കുമായി സൗജന്യ അലർജിക് ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/10-25-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ ബീമാപള്ളി",
      location: "ബീമാപള്ളി",
      date: "10-25-2024",
      discription:
        "ബീമാപള്ളി പൗരസമിതിയും , അനന്തപുരി യുവജനവേദിയും സംയുക്തമായി ചേർന്ന് നിംസ് മെഡിസിറ്റിയുടെ ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/10-21-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ കമലേശ്വരം",
      location: "കമലേശ്വരം",
      date: "10-21-2024",
      discription:
        "തിരുവനന്തപുരം,  കമലേശ്വരം എസ്എൻഡിപി യോഗം ശാഖയുടെ ആഭിമുഖ്യത്തിൽ നിംസ് മെഡിസിറ്റി, നിംസ് മൈക്രോ ഹോസ്പിറ്റൽസ് & വത്സല നഴ്സിംഗ് ഹോം നേതൃത്വത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പും ആരോഗ്യ ബോധവൽക്കരണ ക്ലാസും സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/10-19-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ തിരുവനന്തപുരം",
      location: "തിരുവനന്തപുരം",
      date: "10-19-2024",
      discription:
        "തിരുവനന്തപുരം മെട്രോപൊളീസ് ലയൺസ് ക്ലബ്ബിന്റെയും  പുതുകുളങ്ങര CSI ചർച്ചിന്റെയും സംയുക്താഭിമുഖ്യത്തിൽ നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/10-18-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ തിരുവനന്തപുരം",
      location: "തിരുവനന്തപുരം",
      date: "10-18-2024",
      discription:
        "കേരള സെൻസസ് റിക്രിയേഷൻ ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്താഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/10-15-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ അരുമന",
      location: "തണ്ണീർപത്തായം മത് പാഠശാല,അരുമന.",
      date: "10-15-2024",
      discription:
        "അരുമന മുഴുക്കോട് പൂജാരി സേവാ ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/10-14-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ മലയിൻകീഴ്",
      location: "സി എസ് ഐ ചർച്ച്, തിമിരിച്ചൽ, മലയിൻകീഴ്.",
      date: "10-14-2024",
      discription:
        "മലയിൻകീഴ് തിമിരിച്ചൽ സി എസ് ഐ  ചർച്ചിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/10-12-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ കാരേറ്റ്",
      location: "ദേവി സ്കാൻസ് സെൻ്റർ,കാരേറ്റ്.",
      date: "10-12-2024",
      discription:
        "കാരേറ്റ്  ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/10-08-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ ഇടപഴിഞ്ഞി",
      location: "ശ്രീ ബാലസുബ്രഹ്മണ്യം ഓഡിറ്റോറിയം, ഇടപഴിഞ്ഞി .",
      date: "10-08-2024",
      discription:
        "ഇടപഴിഞ്ഞി ട്രിവാൻഡ്രം റോയൽ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/10-07-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ ആലുവിള",
      location: "സി എസ് ഐ ചർച്ച്, ആലുവിള.",
      date: "10-07-2024",
      discription:
        "ആലുവിള സി എസ് ഐ ചർച്ച് സി ഈ വൈ എഫ് യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/10-05-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ മേലാരന്നൂർ",
      location: "റെഡ്ഡിയാർ അസോസിയേഷൻ, മേലാരന്നൂർ.",
      date: "10-05-2024",
      discription:
        "മേലാരന്നൂർ റെഡ്ഢിയാർ അസോസിയേഷൻ, ട്രിവാൻഡ്രം മിഡ്‌ടൗൺ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/10-04-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ കല്ലറ",
      location: "എസ് എൻ വി എൽ പി സ്കൂൾ, കല്ലറ.",
      date: "10-04-2024",
      discription:
        "കല്ലറ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/09-30-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ അടിമലത്തുറ",
      location: "അനിമേഷൻ സെൻ്റർ, അടിമലത്തുറ.",
      date: "09-30-2024",
      discription:
        "ലോക ഹൃദയ ദിനത്തോട് അനുബന്ധിച്ച് അടിമലത്തുറ ഫാത്തിമ മാതാ ദേവാലയത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
  {
      cardImage: "assets/img/Pastevents/09-27-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ ഈസ്റ്ഫോർട്ട്",
      location: "റിലയൻസ് സ്മാർട്ട് ബസാർ,പഴവങ്ങാടി, ഈസ്റ്ഫോർട്ട്.",
      date: "09-27-2024",
      discription:
        "റിലയൻസ് ഇൻഡസ്ട്രീസ് ലിമിറ്റേഡിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/09-26-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ കോവളം",
      location: "ലീല ഹോട്ടൽ, കോവളം ",
      date: "09-26-2024",
      discription:
        "കോവളം ലീല ഹോട്ടൽ മാനേജ്മെൻ്റും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/09-25-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ ആക്കുളം",
      location: "നിഷ് ക്യാമ്പസ്, ആക്കുളം",
      date: "09-25-2024",
      discription:
        "ആക്കുളം നിഷ് , ട്രിവാൻഡ്രം ഡിസ്‌ട്രിക്ട് ലയൺസ് ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/09-24-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ ഈഞ്ചക്കൽ",
      location: "ശ്രദ്ധ വൊക്കേഷണൽ ട്രെയിനിംഗ് സെൻ്റർ,ഈഞ്ചക്കൽ.",
      date: "09-24-2024",
      discription:
        " ഈഞ്ചക്കൽ ശ്രദ്ധാ ചാരിറ്റബിൾ സൊസൈറ്റി, സുഭാഷ് നഗർ വെൽഫെയർ റെസിഡൻഷ്യൽ അസോസിയേഷൻ, ട്രിവാൻഡ്രം റീജൻസി ലയൺസ് ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
   {
      cardImage: "assets/img/Pastevents/09-23-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ പേയാട്",
      location: "സെന്റ് സേവ്യേഴ്സ് സ്കൂൾ,പേയാട്.",
      date: "09-23-2024",
      discription:
        "പേയാട് സെൻറ് സേവ്യേഴ്സ് മെഗാ എക്സ്പോ 2024, ആക്കുളം ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/09-22-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ നെല്ലിമ്മൂട്",
      location: "ഗുരുപ്രസാദം ഹാൾ, ഇടത്തേയ്ക്കോണം,നെല്ലിമ്മൂട്.",
      date: "09-22-2024",
      discription:
        "നെല്ലിമ്മൂട് ഇടത്തേയ്ക്കോണം എസ് എൻ ഗ്രന്ഥശാലയുടെയും  നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/09-21-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ പനപ്പാംക്കുന്ന്",
      location: "ഗവ: എൽ പി എസ് ജംഗ്ഷൻ,പനപ്പാംക്കുന്ന്",
      date: "09-21-2024",
      discription:
        "പനപ്പാംക്കുന്ന് നവകൈരളി ആർട്ട്സ് ആൻഡ് സ്പോർട്സ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/09-20-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ പേയാട്",
      location: "സെന്റ് സേവ്യേഴ്സ് സ്കൂൾ,പേയാട്.",
      date: "09-20-2024",
      discription:
        "പേയാട് സെൻറ് സേവ്യേഴ്സ് മെഗാ എക്സ്പോ 2024, ആക്കുളം ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/09-18-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ കാരേറ്റ്",
      location: "തോട്ടുംപ്പുറം മുസ്ലിം ജമാഅത്ത് ഹാൾ,കാരേറ്റ്.",
      date: "09-18-2024",
      discription:
        "തോട്ടുംപ്പുറം ജുമാ മസ്ജിദിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
  {
      cardImage: "assets/img/Pastevents/09-13-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ കുന്നത്തുക്കാൽ",
      location: "താളത്രയം കലാ സാംസ്കാരിക വേദി ഗ്രന്ഥശാല, അരുവിയോട്, കുന്നത്തുക്കാൽ.",
      date: "09-13-2024",
      discription:
        "തിരുവട്ടാർ പൂജാരി സേവാ ട്രസ്റ്റ്, അരുവിയോടു താളത്രയം കലാ സാംസ്കാരിക വേദിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/09-12-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ കുളത്തൂർ",
      location: "എൻ എസ് എസ് ഓഡിറ്റോറിയം, കുളത്തൂർ.",
      date: "09-12-2024",
      discription:
        "കുളത്തൂർ ഗാന്ധി നഗർ റെസിഡൻഷ്യൽ അസോസിയേഷൻ, കേരളാ സീനിയർ സിറ്റിസൺ, ട്രിവാൻഡ്രം സൗത്ത് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/09-11-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ മുടവൻമുഗൽ",
      location: "ഗവ: ഹൈസ്കൂൾ മുടവൻമുഗൽ",
      date: "09-11-2024",
      discription:
        "മുടവൻമുഗൽ ട്രിവാൻഡ്രം ഐകൺസിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/09-08-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ ചപ്പാത്ത്",
      location: "മാധവ വിലാസം യു പി സ്കൂൾ, ചപ്പാത്ത്.",
      date: "09-08-2024",
      discription:
        "ചപ്പാത്ത് റെസിഡൻഷ്യൽ അസോസിയേഷൻ,വിഴിഞ്ഞം ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/09-07-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ പുന്നയ്ക്കാട്",
      location: "എ കെ ജി സാംസ്കാരിക നിലയം,പുന്നയ്ക്കാട്.",
      date: "09-07-2024",
      discription:
        "പുന്നക്കാട് മാനുഷം കലാ സാംസ്കാരിക വേദിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/09-06-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ മരിയാപുരം",
      location: "വി എഫ് പി സി കെ ഓഫീസ്,മരിയാപുരം.",
      date: "09-06-2024",
      discription:
        "മരിയാപുരം വി എഫ് പി സി കെ യൂണിറ്റ് , ട്രിവാൻഡ്രം നോവാ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/09-05-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ കീഴാരൂർ",
      location: "കീഴാരൂർ ശ്രീ സരസ്വതി വിദ്യാലയം.",
      date: "09-05-2024",
      discription:
        "കീഴാരൂർ ശ്രീ സരസ്വതി വിദ്യാലയത്തിൻ്റെയും  നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/09-04-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ തവരവിള",
      location: "കാരുണ്യ സ്പെഷ്യൽ ഹോം, തവരവിള.",
      date: "09-04-2024",
      discription:
        "തവരവിള കാരുണ്യ സ്പെഷ്യൽ ഹോമിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/09-03-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ വലിയശാല",
      location: "സതേൺ പീപ്പിൾസ് പ്രൈഡ് ഓഫീസ്, വലിയശാല. ",
      date: "09-03-2024",
      discription:
        "വലിയശാല സതേൺ പീപ്പിൾസ് പ്രൈഡ് പ്രൊഡ്യൂസേഴ്സ് കമ്പനിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/09-02-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ തോന്നക്കൽ",
      location: "ബി പി സി കമ്പനി ഓഫീസ്,തോന്നക്കൽ.",
      date: "09-02-2024",
      discription:
        "തോന്നയ്ക്കൽ ഭാരത് പെട്രോളിയം ലിമിറ്റെഡിൻ്റെയും  നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/09-01-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ വിളപ്പിൽശാല",
      location: "കടമ്പനാട് എൽ പി എസ്, വിളപ്പിൽശാല.",
      date: "09-01-2024",
      discription:
        "കരിയംകുളം ശ്രീ ഭഗവതി ക്ഷേത്ര ട്രസ്റ്റ്, തിരുവനന്തപുരം സിറ്റി ലയൺസ് ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/08-31-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ പൂഴിക്കുന്ന്",
      location: "മൈത്രി ഹാൾ,പൂഴിക്കുന്ന്.",
      date: "08-31-2024",
      discription:
        "പൂഴിക്കുന്ന് മൈത്രി റെസിഡൻഷ്യൽ അസോസിയേഷൻ,ട്രിവാൻഡ്രം റെയിൻബോ ലയൺസ് ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
  {
      cardImage: "assets/img/Pastevents/08-30-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ കിഴുവിലം",
      location: "കിഴുവിലം ഗ്രാമപഞ്ചായത്ത് ഓഫീസ്.",
      date: "08-30-2024",
      discription:
        "കിഴുവിലം ഗ്രാമപഞ്ചായത്ത്, പെരുങ്ങുഴി ലയൺസ് ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/08-29-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ പുലയനാർക്കോട്ട",
      location: "ശിശു മന്ദിരം പുലയനാർക്കോട്ട.",
      date: "08-29-2024",
      discription:
        "അയ്യൻകാളി ജന്മദിനാഘോഷത്തോട് അനുബന്ധിച്ച് പുലയനാർക്കോട്ട കെ പി എം എസ് യൂണിറ്റ്, ആശുപത്രി സംരക്ഷണ സമിതിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/08-28-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ നെട്ടയം",
      location: "എം ആർ സി എ, മാമ്പഴക്കുന്ന്, നെട്ടയം.",
      date: "08-28-2024",
      discription:
        "പേരൂർക്കട ലയൺസ് ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
  {
      cardImage: "assets/img/Pastevents/08-27-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ കാച്ചാണി",
      location: " ഗവ: ഹൈസ്കൂൾ,കാച്ചാണി.",
      date: "08-27-2024",
      discription:
        "കേരളാ കൗമുദി ബോധപൗർണ്ണമി ക്ലബ്, വിൻഡോസ് ഓഫ് കേരളാ മാഗസിൻ, ഗവ.എച്ച് എസ് എസ് കാച്ചാണി  നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പും വിദ്യാർഥികൾക്ക് സൗജന്യ ഫലത്തൈ വിതരണവും സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
  {
      cardImage: "assets/img/Pastevents/08-26-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ കോവിലുവിള",
      location: " ശ്രീ കൃഷ്ണ സ്വാമി ക്ഷേത്ര ഓഡിറ്റോറിയം, കോവിലുവിള. ",
      date: "08-26-2024",
      discription:
        "കോവിലുവിള ശ്രീ കൃഷ്ണസ്വാമി ക്ഷേത്ര ട്രസ്റ്റ്,സേവാഭാരതി ആര്യൻങ്കോട് പഞ്ചായത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/08-25-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ തിരുമല",
      location: "എ ഇ അവർ എ ഓഫീസ്, തിരുമല.",
      date: "08-25-2024",
      discription:
        "തിരുമല അരയല്ലൂർ - എളളുവിള റെസിഡൻഷ്യൽ അസോസിയേഷൻൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/08-24-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ അഞ്ചൽ",
      location: "ഗവ: ക്യാഷൂ ഫാക്ടറി,പനച്ചവിള, അഞ്ചൽ.",
      date: "08-24-2024",
      discription:
        "അഞ്ചൽ ടൗൺ ലയൺസ് ക്ലബ്ബിന്റെയും  നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/08-23-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ തോലടി",
      location: "കാരുണ്യ ഓൾഡേജ് ഹോം, തോലടി.",
      date: "08-23-2024",
      discription:
        "തിരുവട്ടാർ പൂജാരി സേവാ ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/08-22-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ പുന്നമ്മൂട്",
      location: "ഗവ: മോഡൽ എച്ച് എസ് എസ് പുന്നമ്മൂട്.",
      date: "08-22-2024",
      discription:
        "നേമം ജനമൈത്രി പോലീസ് സ്റ്റേഷൻ, നേമം ജനമൈത്രി സമിതി, ഗവ: മോഡൽ എച്ച് എസ് എസ് എസ് പുന്നമ്മൂട് പി സി യൂണിറ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/08-21-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ പനയ്ക്കോട്",
      location: "എസ് എൻ ഡി പി ഹാൾ,കട്ടച്ചൽക്കുഴി പനയ്ക്കോട് ",
      date: "08-21-2024",
      discription:
        "കട്ടച്ചൽക്കുഴി എസ് എൻ എൻ ഡി പി യോഗം, വിഴിഞ്ഞം ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/08-20-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ പനയ്ക്കോട്",
      location: "എൻ എസ് എസ് കരയോഗം ഹാൾ, പനയ്ക്കോട് ",
      date: "08-20-2024",
      discription:
        " വട്ടിയൂർക്കാവ് ശ്രീ സത്യസായി ക്ഷേത്ര സമിതി, പനയ്ക്കോട് എൻ എസ് എസ് യൂണിറ്റിൻ്റെയും  നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
  {
      cardImage: "assets/img/Pastevents/08-18-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ ഈസ്റ്റ് ഫോർട്ട്",
      location: "സിറ്റി ഡിപ്പോ കോംപ്ലക്സ്, ഈസ്റ്റ് ഫോർട്ട്.",
      date: "08-18-2024",
      discription:
        "ഈസ്റ്റർ ഫോർട്ട് കെ എസ് ആർ ടി സി സിറ്റി യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/08-17-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ കുലശേഖരം",
      location: "വായൻക്കാത്താഴയ് അമ്മൻ കോവിൽ ഓഡിറ്റോറിയം, മാത്തൂർ, കുലശേഖരം.",
      date: "08-17-2024",
      discription:
        "തിരുവട്ടാർ പൂജാരി സേവാ ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
  {
      cardImage: "assets/img/Pastevents/08-16-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ വെഞ്ഞാറമ്മൂട്",
      location: "ദീപാ നഗർ റെസിഡൻഷ്യൽ അസോസിയേഷൻ, വെഞ്ഞാറമ്മൂട്.",
      date: "08-16-2024",
      discription:
        " വെഞ്ഞാറമ്മൂട് ദീപാ നഗർ റെസിഡൻഷ്യൽ അസോസിയേഷൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
  {
      cardImage: "assets/img/Pastevents/08-15-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ താന്നിവിള",
      location: "ശ്രീ ഉമ്മൻചാണ്ടി നഗർ, താന്നിവിള.",
      date: "08-15-2024",
      discription:
        "താന്നിവിള രാജിവ് ഗാന്ധി സാംസ്കാരിക വേദിയുടേയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
  {
      cardImage: "assets/img/Pastevents/08-14-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ പുത്തൻചന്ത",
      location: "ശ്രീ ഭദ്ര ഓഡിറ്റോറിയം, പുത്തൻചന്ത.",
      date: "08-14-2024",
      discription:
        "പുത്തൻചന്ത പൂജാരി സേവാ ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/08-13-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ കുടപ്പനക്കുന്ന്",
      location: "സിവിൽ സ്റ്റേഷൻ,കുടപ്പനക്കുന്ന്.",
      date: "08-13-2024",
      discription:
        "പട്ടം ഇൻഡസ് മോട്ടോഴ്സിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/08-12-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ അയിര",
      location: "സി എസ് ഐ ചർച്ച്, അയിര.",
      date: "08-12-2024",
      discription:
        "അയിര സി എസ് ഐ ചർച്ചിൻ്റെ യുവജന വാരാഘോഷം -2024 ൻ്റെ ഭാഗമായി നിംസ് മെഡിസിറ്റിയുടെ സഹകരണത്തോട്ക്കൂടി സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/08-11-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ വ്ലാത്താൻകര",
      location: "മരിയൻ തീർത്ഥാടന കേന്ദ്രം, വ്ലാത്താൻകര.",
      date: "08-11-2024",
      discription:
        " വ്ലാത്താൻകര മരിയൻ തീർത്ഥാടന കേന്ദ്രത്തിന്റെയും നിംസ് മെഡിസിറ്റിയും സംയുക്തമായി  സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/08-10-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ Perumkadavila",
      location: "Perumkadavila",
      date: "08-10-2024",
      discription:
        " Perumkadavila ",
      shortNote: "",
      imageCollection: [],
    },
  {
      cardImage: "assets/img/Pastevents/08-09-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ നഗരൂർ",
      location: "എസ് എൻ ഡി പി ശാഖ, നെയ്ത്ത് ശാല, നഗരൂർ.",
      date: "08-09-2024",
      discription:
        "ഹരിത കേരള മിഷൻ, നഗരൂർ ലയൺസ് ക്ലബ്, നഗരൂർ പൊയ്കയിൽ എസ് എൻ ഡി പി ശാഖയുടെയും നിംസ് മെഡിസിറ്റിയും സംയുക്തമായി  സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/08-08-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ മീനാങ്കൽ",
      location: "ഗവ: ട്രൈബൽ ഹൈസ്കൂൾ, മീനാങ്കൽ.",
      date: "08-08-2024",
      discription:
        " മീനാങ്കൽ ഗവ: ട്രൈബൽ ഹൈസ്കൂളിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ  സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/08-07-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ പനവിള",
      location: "വുമൺസ് മുസ്‌ലീം അസോസിയേഷൻ ഹാൾ, പനവിള.",
      date: "08-07-2024",
      discription:
        "പനവിള വുമൺസ് മുസ്‌ലീം അസോസിയേഷൻ, നിംസ് മൈക്രോ ഹോസ്പിറ്റൽ ആൻഡ് വൽസല നഴ്സിംഗ് ഹോമിൻ്റെയും നിംസ് മെഡിസിറ്റിയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/08-06-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ ബാലരാമപുരം",
      location: "സൗത്ത് ഇന്ത്യൻ ബാങ്ക്, ബാലരാമപുരം.",
      date: "08-06-2024",
      discription:
        "ബാലരാമപുരം സൗത്ത് ഇന്ത്യൻ ബാങ്കിൻ്റെയും നിംസ് മെഡിസിറ്റിയും സംയുക്തമായി  സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/08-05-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ മീനാങ്കൽ",
      location: "ഗവ: ട്രൈബൽ ഹൈസ്കൂൾ, മീനാങ്കൽ.",
      date: "08-05-2024",
      discription:
        " മീനാങ്കൽ ഗവ: ട്രൈബൽ ഹൈസ്കൂളിൻ്റെയും    നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ  സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
  {
      cardImage: "assets/img/Pastevents/08-04-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ മീനാങ്കൽ",
      location: "വെട്ട നാഷണൽ ലൈബ്രറി , മീനാങ്കൽ.",
      date: "08-04-2024",
      discription:
        "സി എസ് ഐ പാറമുക്ക്, ഹെച്ച് എം എസ് മീനാങ്കൽ സഭയുടെയും നിംസ് മെഡിസിറ്റിയും സംയുക്തമായി  സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/08-03-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ പരശ്ശുവയ്ക്കൽ",
      location: "ശ്രീ മഹാവിഷണു ക്ഷേത്രം, പരശ്ശുവയ്ക്കൽ.",
      date: "08-03-2024",
      discription:
        "പരശുവയ്ക്കൽ തെക്കുംക്കര ശ്രീ മഹാവിഷ്ണു ക്ഷേത്രം,പാറശ്ശാല സേവാഭാരതി യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയും സംയുക്തമായി കർക്കിടക വാവ്ബലി തർപ്പണം നടത്തുന്നവർക്കായി സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/08-02-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ പെരിങ്ങമ്മല",
      location: "സീറ ഓഡിറ്റോറിയം, നേമം. സംഘം,പെരിങ്ങമ്മല.",
      date: "08-02-2024",
      discription:
        "തിരുവനന്തപുരം ജില്ലാ വ്യാവസായിക കേന്ദ്രത്തിൻ്റെ നേതൃത്വത്തിൽ നേമം ഹാൻഡ്ലൂം സർക്കിൾ ഓഫീസും  നിംസ് മെഡിസിറ്റിയും സംയുക്തമായി നെയ്ത്ത് തൊഴിലാളികൾക്കായി സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീമതി ദീപിക  യു (ബഹു: നേമം വാർഡ് മെമ്പർ)",
      shortNote: "",
      imageCollection: [],
    },
  {
      cardImage: "assets/img/Pastevents/08-01-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ പെരിങ്ങമ്മല",
      location: "ശ്രീ വെള്ളയാണി കൈത്തറി സംഘം, പെരിങ്ങമ്മല.",
      date: "08-01-2024",
      discription:
        "തിരുവനന്തപുരം ജില്ലാ വ്യാവസായിക കേന്ദ്രത്തിൻ്റെ നേതൃത്വത്തിൽ വെങ്ങാനൂർ ഹാൻഡ്ലൂം സർക്കിൾ ഓഫീസും  നിംസ് മെഡിസിറ്റിയും സംയുക്തമായി നെയ്ത്ത് തൊഴിലാളികൾക്കായി സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ എം സോമശേഖരൻ നായർ (ബഹു: കല്ലിയൂർ ഗ്രാമ പഞ്ചായത്ത് പ്രസിഡണ്ട്)",
      shortNote: "",
      imageCollection: [],
    },
  {
      cardImage: "assets/img/Pastevents/07-30-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ കമുകിൻകോട്",
      location: "കൊച്ചുപള്ളി ഹാൾ, കമുകിൻകോട്.",
      date: "07-30-2024",
      discription:
        "തിരുവനന്തപുരം ജില്ലാ വ്യാവസായിക കേന്ദ്രത്തിൻ്റെ നേതൃത്വത്തിൽ അവണാകുഴി ഹാൻഡ്ലൂം സർക്കിൾ ഓഫീസും  നിംസ് മെഡിസിറ്റിയും സംയുക്തമായി നെയ്ത്ത് തൊഴിലാളികൾക്കായി സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ സുനിൽകുമാർ വി പി (ബഹു: അതിയന്നൂർ ഗ്രാമ പഞ്ചായത്ത് പ്രസിഡണ്ട്)",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/07-29-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ മാവിളക്കടവ്",
      location: "വി ജോൺ മരിയ വിയാനി ദേവാലയം, മാവിളക്കടവ്.",
      date: "07-29-2024",
      discription:
        " മാവിളക്കടവ് വലിയവിള ക്രിസ്തുരാജ ദേവാലയം നിഡ്സ് യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/07-28-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ ചെങ്കൽ",
      location: "കാരിയോട് ക്ഷേത്ര ഓഡിറ്റോറിയം, ചെങ്കൽ.",
      date: "07-28-2024",
      discription:
        "കാരിയോട് പച്ചക്കറി ക്ലസ്‌റ്റർ യൂണിറ്റിന്റെയും നിംസ് മെഡിസിറ്റിയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/07-27-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ വിവേകാനന്ദ നഗർ.",
      location: "കൈമനം എൻ എസ് എസ് കരയോഗം ഹാൾ, വിവേകാനന്ദ നഗർ.",
      date: "07-27-2024",
      discription:
        "കൈമനം എൻ എസ് എസ് കരയോഗം, ട്രിവാൻഡ്രം റെയിൻബോ ലയൺസ് ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/07-26-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ പുന്നക്കുളം",
      location: "ബഡ്‌സ് സ്ക്കൂൾ, പുന്നക്കുളം",
      date: "07-26-2024",
      discription:
        "പുന്നക്കുളം ബഡ്സ് സ്കൂളിൻ്റെയും നിംസ് മെഡിസിറ്റിയും സംയുക്തമായി  സൗജന്യ  മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/07-25-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ ഊരുട്ടമ്പലം",
      location: "സർവ്വീസ് സഹകരണ ബാങ്ക് ഓഡിറ്റോറിയം, ഊരുട്ടമ്പലം.",
      date: "07-25-2024",
      discription:
        "തിരുവനന്തപുരം ജില്ലാ വ്യാവസായിക കേന്ദ്രത്തിൻ്റെ നേതൃത്വത്തിൽ ഊരുട്ടമ്പലം ഹാൻഡ്ലൂം സർക്കിൾ ഓഫീസും  നിംസ് മെഡിസിറ്റിയും സംയുക്തമായി നെയ്ത്ത് തൊഴിലാളികൾക്കായി സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ കെ എസ് അനിൽകുമാർ (ബഹു: കൈത്തറി ആൻഡ് ടെക്സ്റ്റൈൽസ് ഡയറക്ടർ)",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/07-24-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ കോട്ടുകാൽ",
      location: "ബഡ്‌സ് സ്ക്കൂൾ, കോട്ടുകാൽ. ",
      date: "07-24-2024",
      discription:
        "മെഡി കെയർ -2024 കോട്ടുകാൽ ഗ്രാമ പഞ്ചായത്തും നിംസ് മെഡിസിറ്റിയും സംയുക്തമായി  സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
   {
      cardImage: "assets/img/Pastevents/07-22-20242.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ ഉച്ചക്കട",
      location: "സി എസ് ഐ സഭാ ഓഡിറ്റോറിയം, ഉച്ചക്കട. ",
      date: "07-22-2024",
      discription:
        "തിരുവനന്തപുരം ജില്ലാ വ്യാവസായിക കേന്ദ്രത്തിൻ്റെ നേതൃത്വത്തിൽ വിഴിഞ്ഞം ഹാൻഡ്ലൂം സർക്കിൾ ഓഫീസും  നിംസ് മെഡിസിറ്റിയും സംയുക്തമായി നെയ്ത്ത് തൊഴിലാളികൾക്കായി സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീമതി ചന്ദ്രലേഖ കെ (ബഹു: കോട്ടുകാൽ ഗ്രാമ പഞ്ചായത്ത് പ്രസിഡന്റ്)",
      shortNote: "",
      imageCollection: [],
    },
     {
      cardImage: "assets/img/Pastevents/07-22-20241.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ വെള്ളനാട്",
      location: "നവഭാരത് ആർട്ട്സ് ആൻഡ് സ്പോർട്സ് ക്ലബ്ബ്, വെളിയന്നൂർ, വെള്ളനാട്.",
      date: "07-22-2024",
      discription:
        "വെള്ളനാട് വെളിയണ്ണൂർ നവഭാരത് ആർട്ട്സ് ആൻഡ് സ്പോർട്സ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
     {
      cardImage: "assets/img/Pastevents/07-22-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ പാപ്പനംക്കോട്",
      location: "ശ്രീ വിനായക ഓഡിറ്റോറിയം, പാപ്പനംക്കോട് .",
      date: "07-22-2024",
      discription:
        "പാപ്പനംകോട് ശ്രീ ചിത്തിര തിരുനാൾ റെസിഡൻഷ്യൽ അസോസിയേഷൻൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
  {
      cardImage: "assets/img/Pastevents/07-21-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ മുളമുക്ക്",
      location: "ചേനാംകോട് എൽ പി എസ്,മുളമുക്ക്.",
      date: "07-21-2024",
      discription:
        "ശ്രീ ഉമ്മൻചാണ്ടി ചരമ വാർഷികത്തോട്   അനുബന്ധിച്ച് കരകുളം ചെക്കകോണം ഇന്ത്യൻ നാഷണൽ കോൺഗ്രസ് വാർഡ് കമ്മിറ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/07-20-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ വള്ളക്കടവ്",
      location: "പ്രിയദർശിനി നഗർ പാർക്,വള്ളക്കടവ്.",
      date: "07-20-2024",
      discription:
        "മുൻ മുഖ്യമന്ത്രി ശ്രീ ഉമ്മൻചാണ്ടി സാറിൻ്റെ ചരമ വാർഷികത്തോട്   അനുബന്ധിച്ച് തിരുവനന്തപുരം ഉമ്മൻചാണ്ടി ഫൗണ്ടേഷൻൻ്റെയും  നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/07-18-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ ആഴിമല",
      location: "സൺ താര റിസോർട്സ്, ആഴിമല.",
      date: "07-18-2024",
      discription:
        "  വിഴിഞ്ഞം ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
   {
      cardImage: "assets/img/Pastevents/07-17-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ ഉണ്ടൻങ്കോട്",
      location: "സെൻ്റ് ജോൺസ് ഹയർ സെക്കണ്ടറി സ്കൂൾ, ഉണ്ടൻങ്കോട്.",
      date: "07-17-2024",
      discription:
        " നിംസ്  @ സ്കൂൾ (🏫2) ഉണ്ടൻങ്കോട് സെൻ്റ് ജോൺസ് ഹയർ സെക്കണ്ടറി സ്കൂൾ സിൽവർ ജൂബിലി ആഘോഷത്തിന്റെ ഭാഗമായി നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ  സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
     {
      cardImage: "assets/img/Pastevents/07-16-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ വട്ടവിള",
      location: "നൈർമല്യ മാർത്തോമാ ഹാൾ, വട്ടവിള.",
      date: "07-16-2024",
      discription:
        "വട്ടവിള സി പി എം ( ഐ)ബ്രാഞ്ചിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
  {
      cardImage: "assets/img/Pastevents/07-15-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ അംബനാട്",
      location: "സെവൻത് ഡേ അഡ്വൻഡിസ്റ് ചർച്ച്, അംബനാട്.",
      date: "07-15-2024",
      discription:
        " അംബനാട് എസ്റ്റേറ്റ് സെവൻത് ഡേ അഡ്വെൻ്റിസ്റ് ചർച്ചിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു",
      shortNote: "",
      imageCollection: [],
    },
  {
      cardImage: "assets/img/Pastevents/07-14-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ അടൂർ",
      location: "ഗവ: യൂ പി സ്ക്കൂൾ, അടൂർ.",
      date: "07-14-2024",
      discription:
        "കാട്ടാക്കട നെയ്യാർ ഡാം ശ്രീ  തുണ്ടുനട തമ്പുരാൻ ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/07-13-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ അടൂർ",
      location: "ഗവ: യൂ പി സ്ക്കൂൾ, അടൂർ.",
      date: "07-13-2024",
      discription:
        "അടൂർ ബി ആൻഡ് യു ഫൗണ്ടേഷൻൻ്റെയും  നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
  {
      cardImage: "assets/img/Pastevents/07-12-20241.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ കണ്ടല",
      location: "കണ്ടല സ്റ്റേഡിയം.",
      date: "07-12-2024",
      discription:
        "ലൈറ്റ് ആൻഡ് സൗണ്ട് വെൽഫെയർ അസോസിയേഷൻ ബാലരാമപുരം മേഖലയുടെയും  നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/07-12-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ ചെറിയ കൊണ്ണി",
      location: "രത്നം ഓഡിറ്റോറിയം, ചെറിയ കൊണ്ണി.",
      date: "07-12-2024",
      discription:
        "ഗ്രാമോത്സവം-2024, തിക്കുറിശ്ശി മെമ്മോറിയൽ സാംസ്കാരിക സമിതിയുടെയും  നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/07-09-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ റ്റി ബി ജംഗ്ഷൻ",
      location: " സെൻ്റ് ഫിലിപ്പ് സ്ക്കൂൾ,റ്റി ബി ജംഗ്ഷൻ.",
      date: "07-09-2024",
      discription:
        " റ്റി ബി ജംഗ്ഷൻ സെൻ്റ് ഫിലിപ്പ് സ്ക്കൂളിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/07-06-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ വഞ്ചിയൂർ",
      location: "എൻ എസ് എസ് കരയോഗം ഹാൾ, വഞ്ചിയൂർ.",
      date: "07-06-2024",
      discription:
        " വഞ്ചിയൂർ വനിതാ സമാജത്തിൻ്റെയും  നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/07-02-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ ആഴിമല",
      location: "ആഴിമല ക്ഷേത്ര ഓഡിറ്റോറിയം.",
      date: "07-02-2024",
      discription:
        "വിഴിഞ്ഞം ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/07-01-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ ഊരൂട്ടുക്കാല",
      location: "ജീ ആർ പബ്ലിക് സ്കൂൾ ഓഡിറ്റോറിയം,ഊരൂട്ടുക്കാല.",
      date: "07-01-2024",
      discription:
        "ജൂലൈ-01 ദേശീയ ഡോക്ടേഴ്‌സ് ദിനത്തോട് അനുബന്ധിച്ച് ഊരുട്ടുകാല ജീ ആർ പബ്ലിക്ക് സ്ക്കൂൾ, ബാലരാമപുരം ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
  {
      cardImage: "assets/img/Pastevents/06-30-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ ആനയറ",
      location: "കെ എസ് ആർ ടി സി സ്വിഫ്റ്റ് ഓഫീസ് ,ആനയറ.",
      date: "06-30-2024",
      discription:
        "സ്വിഫ്റ്റ് കെ എസ് ആർ ടി സി ആനയറ യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
   {
      cardImage: "assets/img/Pastevents/06-29-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ റ്റി ബി ജംഗ്ഷൻ",
      location: "സെൻ്റ് ഫിലിപ്പ് സ്ക്കൂൾ,റ്റി ബി ജംഗ്ഷൻ.",
      date: "06-29-2024",
      discription:
        "റ്റി ബി ജംഗ്ഷൻ സെൻ്റ് ഫിലിപ്പ് സ്ക്കൂളിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
     {
      cardImage: "assets/img/Pastevents/06-27-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ പുളിക്കുടി",
      location: "വിവേകാനന്ദ ഐ റ്റി ഐ പുളിക്കുടി.",
      date: "06-27-2024",
      discription:
        "കോട്ടുകാൽ കവികൾ സാംസ്കാരിക വേദിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
  {
      cardImage: "assets/img/Pastevents/06-25-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ കാഞ്ഞിരംകുളം",
      location: "ബഡ്സ് ഹാൾ,കാഞ്ഞിരംകുളം.",
      date: "06-25-2024",
      discription:
        "കാഞ്ഞിരംകുളം  പഞ്ചായത്ത്,കാഞ്ഞിരംകുളം ബഡ്‌സ് സ്ക്കൂളിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/06-24-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ മാവർത്തലക്കോണം",
      location: "തട്ടിനകം എൻ എസ് എസ് ഹാൾ, മാവർത്തലക്കോണം.",
      date: "06-24-2024",
      discription:
        "തട്ടിനകം ആർട്സ്  സ്പോർട്സ് ആൻ്റ് വെൽഫെയർ ക്ലബ്ബ്, ഗൗരീശപട്ടം ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/06-23-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ തോലടി",
      location: "കാരുണ്യ റിഹാബിലിറ്റേഷൻ സെൻ്റർ, രാമവർമൻചിറ, തോലടി.",
      date: "06-23-2024",
      discription:
        "തോലടി പൂജാരി സേവാ ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/06-22-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ വെള്ളയമ്പലം",
      location: "ജിമ്മി ജോർജ്ജ് സ്റ്റേഡിയം, വെള്ളയമ്പലം. ",
      date: "06-22-2024",
      discription:
        "തിരുവനന്തപുരം കേരള ഒളിമ്പിക്സ് അസോസിയേഷൻൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത  ആഭിമുഖ്യത്തിൽ  സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
  {
      cardImage: "assets/img/Pastevents/06-19-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ പൊഴിയൂർ",
      location: "ബീച്ച് അംഗൻവാടി, പൊഴിയൂർ.",
      date: "06-19-2024",
      discription:
        "വേൾഡ് ഓഷ്യൻ ഡേ യുടെ ഭാഗമായി പൊഴിയൂർ വാർഡ് ഗ്രാമസഭ, നിംസ്  കോളേജ്  ഓഫ് നഴ്സിംഗ്  നാച്ചുറൽ ക്ലബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ഉണ് ആഭിമുഖ്യത്തിൽ കടൽത്തീര ശുചീകരണവും സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പും സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
  {
      cardImage: "assets/img/Pastevents/06-18-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ പേയാട്",
      location: "പ്ലാവിള ജയ് നഗർ റെസിഡൻഷ്യൽ അസോസിയേഷൻ, ഹാൾ,പേയാട്.",
      date: "06-18-2024",
      discription:
        "പ്ലാവിള ജയ് നഗർ റെസിഡൻഷ്യൽ അസോസിയേഷൻൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/06-15-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ പെരുമ്പഴുതൂർ",
      location: "സ്വാശ്രയ കർഷക സംഘം ഓഫീസ്,പെരുമ്പഴുതൂർ. ",
      date: "06-15-2024",
      discription:
        "പെരുമ്പഴുതൂർ സ്വാശ്രയ കർഷക സംഘം, ട്രിവാൻഡ്രം നോവാ ലയൺസ് ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/06-14-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ മുളകിൻമ്മുട്",
      location: "എൻ ഐ പോളിടെക്നിക് കോളേജ്, പൂക്കടയ്,മുളകിൻമ്മുട്.",
      date: "06-14-2024",
      discription:
        "മുളകിൻമൂട് പൂക്കടയ് എൻ ഐ പോളിടെക്നിക്ക് കോളേജിൻ്റെയും  നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/06-13-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ ഊരുട്ടമ്പലം",
      location: "സ്വാശ്രയ കർഷക സംഘം ഓഫീസ്, മാറനല്ലൂർ,ഊരുട്ടമ്പലം.",
      date: "06-13-2024",
      discription:
        "മാറനല്ലൂർ സ്വാശ്രയ കർഷക സംഘം, ട്രിവാൻഡ്രം നോവാ ലയൺസ് ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
  {
      cardImage: "assets/img/Pastevents/06-11-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ പറണ്ടോട്",
      location: "സി എസ് ഐ ഹാൾ, പറണ്ടോട്.",
      date: "06-11-2024",
      discription:
        "പറണ്ടോട് കേരളാ നാടാർ മഹാജനസംഘത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
  {
      cardImage: "assets/img/Pastevents/06-10-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ ആനയറ",
      location: "കെ എസ് ആർ ടി സി സ്വിഫ്റ്റ് ഓഫീസ് ,ആനയറ.",
      date: "06-10-2024",
      discription:
        "സ്വിഫ്റ്റ് കെ എസ് ആർ ടി സി ആനയറ യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
  {
      cardImage: "assets/img/Pastevents/06-08-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ കല്ലറ",
      location: "സ്വാശ്രയ കർഷക സംഘം,കാരേറ്റ്,കല്ലറ.",
      date: "06-08-2024",
      discription:
        "കല്ലറ സ്വാശ്രയ കർഷക സംഘം, കല്ലറ  ലയൺസ് ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/06-07-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ കുന്നത്തുക്കാൽ",
      location: "സ്വാശ്രയ കർഷക സമിതി ഹാൾ,കുന്നത്തുക്കാൽ.",
      date: "06-07-2024",
      discription:
        "കുന്നത്തുക്കാൽ സ്വാശ്രയ കർഷക സമിതിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു",
      shortNote: "",
      imageCollection: [],
    },
  {
      cardImage: "assets/img/Pastevents/06-06-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ തിരുമല",
      location: "ബാലകൃഷ്ണ കല്യാണ മണ്ഡപം,തിരുമല.",
      date: "06-06-2024",
      discription:
        "ലോക പരിസ്ഥിതി ദിനത്തോട് അനുബന്ധിച്ച് തിരുമല വ്യാപാരി വ്യവസായി ഏകോപന സമിതി, തിരുമല ലയൺസ് ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പും വൃക്ഷ തൈ വിതരണവും സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
     {
      cardImage: "assets/img/Pastevents/06-05-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ മേൽപുറം",
      location: "ശ്രീ കൃഷ്ണൻ കോവിൽ ഹാൾ, ആലുവിള, മേൽപുറം.",
      date: "06-05-2024",
      discription:
        "മേൽപുറം പൂജാരി സേവാ ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
  {
      cardImage: "assets/img/Pastevents/06-04-20241.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ ആനയറ",
      location: " കെ എസ് ആർ ടി സി സ്വിഫ്റ്റ് ഓഫീസ് ,ആനയറ.",
      date: "06-04-2024",
      discription:
        "സ്വിഫ്റ്റ് കെ എസ് ആർ ടി സി ആനയറ യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/06-04-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ വെഞ്ഞാറമ്മൂട്",
      location: "വയ്യേറ്റ് പ്ലാവര ടവർ, വെഞ്ഞാറമ്മൂട്.",
      date: "06-04-2024",
      discription:
        "വെഞ്ഞാറമ്മൂട് വയ്യേറ്റ് റെസിഡൻഷ്യൽ അസോസിയേഷൻൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
  {
      cardImage: "assets/img/Pastevents/06-01-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ തക്കല",
      location: "നൂറൽ ഇസ്ലാം യൂണിവേഴ്സിറ്റി ക്യാമ്പസ്, കുമാരകോവിൽ , തക്കല.",
      date: "06-01-2024",
      discription:
        "കുമാരകോവിൽ നൂറുൽ ഇസ്ലാം യൂണിവേഴ്സിറ്റി ബി എസ് എൽ പി ഡിപ്പാർട്ട്മെന്റിൻ്റെയുംനിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/05-30-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ പൂജപ്പുര",
      location: "എൻ എസ് എസ് കരയോഗം ഹാൾ,  പൂജപ്പുര.",
      date: "05-30-2024",
      discription:
        "തേലിഭാഗം ദേവി വിലാസം എൻ എസ് എസ് കരയോഗം, പൂജപ്പുര ലയൺസ് ക്ലബ്ബിൻ്റെയും  നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/05-29-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ പൊൻമുടി",
      location: "എം ജി എം വാലി പബ്ലിക്ക് സ്ക്കൂൾ, പൊൻമുടി.",
      date: "05-29-2024",
      discription:
        "കെയർ ആൻഡ് ഷെയർ ചാരിറ്റബിൾ ട്രസ്റ്റ്,വിതുര എം ജി എം പൊൻമുടി വാലി പബ്ലിക്ക് സ്കൂളിൻ്റെയും  നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
  {
      cardImage: "assets/img/Pastevents/05-26-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ കുറ്റിച്ചൽ",
      location: "തച്ചൻങ്കോട് നവജീവൻ ഹാൾ, കുറ്റിച്ചൽ.",
      date: "05-26-2024",
      discription:
        "കുറ്റിച്ചൽ,തച്ചൻങ്കോട് നവജീവൻ ട്രസ്റ്റിൻ്റെയും ലയൺസ് ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/05-25-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ വാമനപുരം",
      location: " ട്രിവാൻഡ്രം ഫൂട്ട് മാറ്റ് ക്ലസ്റ്റർ മിതൃമല, വാമനപുരം.",
      date: "05-25-2024",
      discription:
        " ട്രിവാൻഡ്രം ഫൂട്ട് മാറ്റ് ക്ലസ്റ്റർ, നോർത്ത് ലയൺസ് ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
   {
      cardImage: "assets/img/Pastevents/05-24-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ തൈക്കാട്",
      location: "കേരളാ ഗാന്ധി സ്മാരക നിധി, തൈക്കാട്.",
      date: "05-24-2024",
      discription:
        " തൈക്കാട് കേരളാ ഗാന്ധി സ്മാരക നിധിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
     {
      cardImage: "assets/img/Pastevents/05-22-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ തിരുവട്ടാർ",
      location: "എൻ എസ് എസ് ഹാൾ, തിരുവട്ടാർ.",
      date: "05-22-2024",
      discription:
        "തിരുവട്ടാർ പൂജാരി സേവാ ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/05-17-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ സിയോൺകുന്ന്",
      location: "സി എസ് ഐ ചർച്ച് സിയോൺകുന്ന്.",
      date: "05-17-2024",
      discription:
        "സീയോൺകുന്ന് സി എസ് ഐ ദക്ഷിണ കേരള ഇടവക സി ഇ വൈ എഫ് യൂണിറ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/05-16-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ ചൊവ്വര",
      location: "തെക്കേക്കോണം നാഗർകാവ് ശ്രീ ദുർഗ്ഗാ ഭഗതി ക്ഷേത്രം, ചൊവ്വര.",
      date: "05-16-2024",
      discription:
        "ചൊവ്വര തെക്കേക്കോണം നാഗർകാവ് ശ്രീ ദുർഗ്ഗാ ഭഗതി ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
  {
      cardImage: "assets/img/Pastevents/05-14-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ കോട്ടുക്കാൽക്കോണം",
      location: "ശ്രീ മുത്താരമ്മൻ ദേവി ക്ഷേത്ര ഓഡിറ്റോറിയം, കോട്ടുക്കാൽക്കോണം.",
      date: "05-14-2024",
      discription:
        "കോട്ടുക്കാൽക്കോണം ശ്രീ മുത്താരമ്മൻ ദേവി ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും  നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/05-10-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ തിരുവട്ടാർ",
      location: "എക്സൽ സ്ക്കൂൾ, തിരുവട്ടാർ.",
      date: "05-10-2024",
      discription:
        "തിരുവട്ടാർ  എക്സൽ സ്ക്കൂൾ എൻ എസ് എസ് യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/05-09-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ ഭരതന്നൂർ",
      location: "സെവൻത് ഡേ അഡ്വൻ്റിസ്റ്റ് ചർച്ച്, തേബാമൂട്, ഭരതന്നൂർ.",
      date: "05-09-2024",
      discription:
        "  ഭരതന്നൂർ സെവൻത് ഡേ അഡ്വൻ്റിസ്റ്റ് ചർച്ചിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/05-08-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ തൂത്തുക്കുടി",
      location: "എൽ കെ ഹയർ സെക്കണ്ടറി സ്കൂൾ,കായൽപ്പട്ടണം, തൂത്തുക്കുടി.",
      date: "05-08-2024",
      discription:
        "തക്കല നൂറുൽ ഇസ്‌ലാം യൂണിവേഴ്‌സിറ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/05-07-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ തോലടി",
      location: "കാരുണ്യ റിഹാബിലിറ്റേഷൻ സെൻ്റർ, രാമവർമൻചിറ, തോലടി.",
      date: "05-07-2024",
      discription:
        "തോലടി പൂജാരി സേവാ ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.  ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
  {
      cardImage: "assets/img/Pastevents/05-05-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ കുണ്ടറ",
      location: "നെടുംബയിക്കുളം കോട്ടക്കുഴി സെൻറ് ജോർജ്ജ് തീർത്ഥാടന പള്ളി, കുണ്ടറ.",
      date: "05-03-2024",
      discription:
        "നെടുംബായിക്കുളം കോട്ടക്കുഴി സെൻറ് ജോർജ്ജ് തീർത്ഥാടന പള്ളി കുണ്ടറ റോയൽ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/05-03-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ മാമ്പഴക്കര",
      location: "എസ് എൽ നഗർ, മാമ്പഴക്കര.",
      date: "05-03-2024",
      discription:
        "മാമ്പഴക്കര എസ്.എൻ ഡി പി യൂണിറ്റിൻ്റെയുംനിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
     {
      cardImage: "assets/img/Pastevents/04-29-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ പൗഡിക്കോണം",
      location: "സി എസ് ഐ സഭ ഹാൾ,പുതുക്കുന്ന്, പൗഡിക്കോണം .",
      date: "04-29-2024",
      discription:
        " പൗഡിക്കോണം പുതുക്കുന്ന് സി എസ് ഐ ചർച്ചിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
     {
      cardImage: "assets/img/Pastevents/04-28-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ മലയിൻകീഴ്",
      location: "ദ്വാരക ഓഡിറ്റോറിയം,മലയിൻകീഴ്.",
      date: "04-28-2024",
      discription:
        "മലയിൻകീഴ് കേരളാ വ്യാപാരി വ്യവസായി ഏകോപന സമിതിയുടെയും  നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
  {
      cardImage: "assets/img/Pastevents/04-27-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ നെല്ലിമൂട്",
      location: "സെൻ്റ് ജോർജ് മലങ്കര കത്തോലിക്ക ദേവാലയം, കണ്ണറവിള, നെല്ലിമൂട്.",
      date: "04-27-2024",
      discription:
        "നെല്ലിമ്മൂട് കണ്ണറവിള  എം സി വൈ എം യൂണിറ്റ്, സേവ് പ്രൊട്ടക്ഷൻ കെയർ ഫോർ പബ്ലിക്ക് ചാരിറ്റബിൾ സൊസൈറ്റിയുടെയും  നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/04-24-20241.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ പ്ലാമൂട്ടുക്കട",
      location: "ആൾവാർകോവിൽ ശ്രീ ശിവശക്തി മഹാഗണപതി ക്ഷേത്രം, കീഴമ്മാകം,പ്ലാമൂട്ടുക്കട.",
      date: "04-24-2024",
      discription:
        "പ്ലാംമൂട്ടുക്കട കീഴമ്മാകം ശ്രീ ശിവശക്തി മഹാഗണപതി ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
     {
      cardImage: "assets/img/Pastevents/04-24-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ ഇരണിയിൽ",
      location: "ആൾവാർകോവിൽ ശ്രീ ഭദ്രേശ്വരി  ക്ഷേത്രം, ഇരണിയിൽ.",
      date: "04-24-2024",
      discription:
        "ഇരണിയിൽ ആൽവാർകോവിൽ ശ്രീ ഭദ്രേശ്വരി ദേവി ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/04-20-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ മേൽപ്പുറം",
      location: "പന്നിക്കോണം ശ്രീ ധർമ്മ ശാസ്താ ക്ഷേത്രം, മേൽപ്പുറം.",
      date: "04-20-2024",
      discription:
        "മേൽപ്പുറം പന്നിക്കോണം ശ്രീ ധർമ്മ ശാസ്താ ക്ഷേത്ര കമ്മിറ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/04-19-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ പരശ്ശുവയ്ക്കൽ",
      location: "മേജർ ശ്രീ ഭഗവതി ക്ഷേത്രം,പരശ്ശുവയ്ക്കൽ.",
      date: "04-19-2024",
      discription:
        "പാറശ്ശാല സേവാഭാരതി യൂണിറ്റ് , പരശുവയ്ക്കൽ മേജർ ശ്രീ ഭഗവതി ക്ഷേത്ര കമ്മിറ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/04-19-20241.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ അരുവിപ്പുറം",
      location: "ആലറ ശ്രീ ഭദ്രകാളി ക്ഷേത്രം,അരുവിപ്പുറം.",
      date: "04-19-2024",
      discription:
        "നെയ്യാറ്റിൻകര സേവാഭാരതി യൂണിറ്റ് ,അരുവിപ്പുറം ആലറ ശ്രീ  ഭദ്രകാളി ക്ഷേത്ര  ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/04-18-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ പെരുംങ്കടവിള",
      location: "ശ്രീ യക്ഷി അമ്മൻ ക്ഷേത്രം, ആലത്തൂർ,പെരുംങ്കടവിള.",
      date: "04-18-2024",
      discription:
        "പെരുംങ്കടവിള ആലത്തൂർ ശ്രീ യക്ഷി അമ്മൻ ദേവി ക്ഷേത്ര  ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/04-17-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ പത്തനാപുരം",
      location: "ഇടത്തറ മുസ്ലിം ജുമാ മസ്ജിദ്,പത്തനാപുരം.",
      date: "04-17-2024",
      discription:
        "തിരുവനന്തപുരം സേവ് പ്രൊട്ടക്ഷൻ കെയർ ഫോർ ചാരിറ്റബിൾ ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/04-14-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ മണക്കാട്",
      location: "കൊഞ്ചിറവിള എൻ എസ് എസ് ഹാൾ, മണക്കാട്.",
      date: "04-14-2024",
      discription:
        "മണക്കാട് കൊഞ്ചിറവിള റെസിഡൻഷ്യൽ അസോസിയേഷൻ്റയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/04-13-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ മംഗലത്തുക്കോണം",
      location: " കാട്ടുനട ശ്രീ ഭദ്രകാളി ക്ഷേത്ര ഓഡിറ്റോറിയം, മംഗലത്തുക്കോണം .",
      date: "04-13-2024",
      discription:
        "മംഗലത്തുക്കോണം കാട്ടുനട ശ്രീ ഭദ്രകാളി  ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/04-12-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ പാലിയോട്",
      location: "ശ്രീ ഭദ്രകാളി ക്ഷേത്ര ഓഡിറ്റോറിയം, വരട്ടയം,പാലിയോട്.",
      date: "04-12-2024",
      discription:
        "പാലിയോട് വരട്ടയം ശ്രീ ഭദ്രകാളി  ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/04-11-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ കൊല്ലംങ്കോട്",
      location: "ശ്രീ ഭദ്രകാളി ക്ഷേത്ര ഓഡിറ്റോറിയം, കൊല്ലംങ്കോട് ",
      date: "04-11-2024",
      discription:
        "കൊല്ലങ്കോട് തൂക്ക മഹോൽസവത്തോട്അനുബന്ധിച്ച് കൊല്ലംങ്കോട് ശ്രീ ഭദ്രകാളി ദേവസ്വം ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/04-10-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ ആര്യൻങ്കോട്",
      location: " ശ്രീ ഭദ്രകാളി ക്ഷേത്ര ഓഡിറ്റോറിയം, ആര്യൻങ്കോട്.",
      date: "04-10-2024",
      discription:
        "ആര്യൻങ്കോട് സേവാഭാരതി യൂണിറ്റ്, കുറ്റിയാണിക്കാട് ശ്രീ ഭദ്രകാളി ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
  {
      cardImage: "assets/img/Pastevents/04-07-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ കന്യാകുമാരി",
      location: "ശ്രീ ശുഭനന്ദാ ജ്യോതി ആശ്രമം, കന്യാകുമാരി.",
      date: "04-07-2024",
      discription:
        "  തമിഴ്നാട് ഗവണ്മെൻറ് ഹെൽത്ത് ഇൻഷുറൻസ് സ്കീം, മാർത്താണ്ഡം പൂജാരി സേവാ ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/04-02-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ മലയിൻകീഴ്",
      location: "കരിപ്പൂർ റെസിഡൻഷ്യൽ ഹാൾ, മലയിൻകീഴ്. ",
      date: "04-02-2024",
      discription:
        "മലയിൻകീഴ് കരിപ്പൂർ റെസിഡൻഷ്യൽ അസോസിയേഷൻ,മലയിൻകീഴ്  ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/03-29-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ പേയാട്",
      location: "എസ്. പി തീയേറ്റർ, പേയാട്. ",
      date: "03-29-2024",
      discription:
        "വിളപ്പിൽശാല സേവാഭാരതി യൂണിറ്റ്, പേയാട് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/03-28-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ അരുവിപ്പുറം",
      location: "ശ്രീ കരിയില കുളങ്ങര ക്ഷേത്രം,ആയയിൽ, അരുവിപ്പുറം.",
      date: "03-28-2024",
      discription:
        "ആയയിൽ ശ്രീ കരിയില കുളങ്ങര ഭഗവതി ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/03-28-2024-1.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ കാട്ടാക്കട",
      location: "ജമ്മു ഫൈനാൻസ്,കാട്ടാക്കട .",
      date: "03-28-2024",
      discription:
        "കാട്ടാക്കട ജമ്മു ഫൈനാൻസിയേഴ്സ് ശാഖയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/03-27-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ കാട്ടാക്കട",
      location: "ശ്രീ സുബ്രഹ്മണ്യ സ്വാമി ക്ഷേത്രം, അന്തിയൂർക്കോണം, കാട്ടാക്കട ",
      date: "03-27-2024",
      discription:
        "അന്തിയൂർക്കോണം ശ്രീ സുബ്രമണ്യ സ്വാമി ക്ഷേത്രം, കാട്ടാക്കട സേവാഭാരതി യൂണിറ്റിൻ്റെയും  നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/03-24-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ തിരുമല",
      location: "തമ്പുരാൻ ദേവി ക്ഷേത്രം,കൊല്ലംക്കോണം,തിരുമല ",
      date: "03-24-2024",
      discription:
        "തിരുമല തോട്ടുനടക്കവ് ട്രസ്റ്റ്, തിരുമല ലയൺസ് ക്ലബ്ബിൻ്റെയും  നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/03-24-2024-1.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ നെയ്യാറ്റിൻകര",
      location: "അമ്മൻ നഗർ റെസിഡൻഷ്യൽ അസോസിയേഷൻ, നെയ്യാറ്റിൻകര.",
      date: "03-24-2024",
      discription:
        "നെയ്യാറ്റിൻകര റോട്ടറി ക്ലബ്ബ്, അമ്മൻ നഗർ റെസിഡൻഷ്യൽ അസോസിയേഷൻ്റെയും  നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/03-23-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ കാരക്കോണം",
      location:
        "പുന്നാക്കര ശ്രീ ഈശ്വരകാല ഭൂതത്താൻ ക്ഷേത്ര ഓഡിറ്റോറിയം,കാരക്കോണം.",
      date: "03-23-2024",
      discription:
        " കാരക്കോണം പുന്നാക്കര ശ്രീ ഈശ്വരകാല ഭൂതത്താൻ ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും  നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/03-22-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ കരിക്കകം",
      location: "കരിക്കകം ക്ഷേത്രം",
      date: "03-22-2024",
      discription:
        "കരിക്കകം ശ്രീ ചാമുണ്ഡേശ്വരി ദേവി ക്ഷേത്ര പൊങ്കാല മഹോത്സവത്തോട് അനുബന്ധിച്ച് ചാക്ക കരിക്കകത്തമ്മ സേവാ സമിതിയുടെയും  നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/03-21-2024-1.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ തമ്പാനൂർ",
      location: "ദേശാഭിമാനി കോൺഫറൻസ് ഹാൾ, തമ്പാനൂർ.",
      date: "03-21-2024",
      discription:
        "തമ്പാനൂർ ദേശാഭിമാനി ന്യൂസ് പേപ്പർ എംപ്ലോയീസ് യൂണിറ്റിൻ്റെയും  നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/03-21-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ പൂഴിക്കുന്ന്",
      location: "ശ്രീ ശങ്കരാ പബ്ലിക് സ്കൂൾ, പൂഴിക്കുന്ന്.",
      date: "03-21-2024",
      discription:
        "പാറശ്ശാല ശ്രീകൃഷ്ണ ഫാർമസി കോളേജ് എൻ എസ് എസ് യൂണിറ്റിൻ്റെയും  നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/03-17-2024-1.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ ആറ്റിങ്ങൽ",
      location: "വലിയവിള ദേശം റെസിഡൻഷ്യൽ ഹാൾ,മണലയം, ആറ്റിങ്ങൽ.",
      date: "03-17-2024",
      discription:
        "ആറ്റിങ്ങൽ വലിയവിള ദേശം റെസിഡൻഷ്യൽ അസോസിയേഷൻ, നഗരൂർ ലയൺസ് ക്ലബ്ബിൻ്റെയും  നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/03-17-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ മൊട്ടമ്മൂട്",
      location: "ശ്രീകൃഷ്ണ പന്തൽസ്, മൊട്ടമ്മൂട്.",
      date: "03-17-2024",
      discription:
        "മൊട്ടമ്മൂട് സി.പി ഐ(എം) യൂണിറ്റ്, ഡി വൈ എഫ് ഐ പറമ്പുക്കോണം യൂണിറ്റിൻ്റെയും  നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/03-16-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ മഞ്ഞാലുംമൂട്",
      location: "അരുണോധയം വിദ്യാലയം, മഞ്ഞാലുംമൂട്, അരുമന. ഓഡിറ്റോറിയം.",
      date: "03-16-2024",
      discription:
        "തമിഴ്നാട് ഗവൺമെൻ്റ് ഹെൽത്ത് ഇൻഷുറൻസ് സ്കീം, മഞ്ഞാലുംമ്മൂട് അരുണോധയം വിദ്യാലയത്തിൻ്റെയും  നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/03-08-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ മുക്കോല",
      location:
        "ശ്രീ ചൂണ്ടുവിള തമ്പുരാൻ ദേവി ക്ഷേത്ര ഓഡിറ്റോറിയം, മുല്ലൂർ, മുക്കോല.",
      date: "03-08-2024",
      discription:
        "മുല്ലൂർ ശ്രീ ചൂണ്ടുവിള തമ്പുരാൻ ദേവി ക്ഷേത്ര  ട്രസ്റ്റിൻ്റെയും ബി അർ കെ സൊസൈറ്റി തിരുവനന്തപുരം നിംസ് മെഡിസിറ്റി സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/03-04-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ കുലശേഖരം",
      location: "ഫോറസ്റ്റ് ഡിവിഷൻ ഓഫീസ്, കാക്കച്ചൽ, കുലശേഖരം",
      date: "03-04-2024",
      discription:
        "തമിഴ്നാട് ഗവൺമെൻ്റ് ഹെൽത്ത് ഇൻഷുറൻസ് സ്കീം,ശ്രീ കണ്ഠൻ ശാസ്താ സേവാ ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/03-02-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ ആലുംമൂട്",
      location: "മുസ്ലീം ജുമാ മസ്ജിദ് മദ്രസ്സ ഹാൾ,ആലുംമൂട്.",
      date: "03-02-2024",
      discription:
        "റമദാൻ നോമ്പിനു മുന്നോടിയായി വ്രതാനുഷ്ഠാനവുമായി ബന്ധപ്പെട്ട് ശ്രദ്ധിക്കേണ്ട കാര്യങ്ങളിൽ അവബോധം നൽകുന്നതിനും നോമ്പുകാലത്തെ ആരോഗ്യപരിരക്ഷ ഉറപ്പാക്കുന്നതിനുമായി നെയ്യാറ്റിൻകര ഠൗൺ മുസ്‌ലിം ജമാഅത്തും നിംസ് മെഡിസിറ്റിയും സംയുക്തായി സൗജന്യ മെഡിക്കൽ ക്യാമ്പും പരിശോധനകളും സംഘടിപ്പിച്ചു. വ്രതശുദ്ധിയുടെ വിശുദ്ധ മാസമായ റമദാനെ പ്രതീക്ഷിച്ചിരിക്കുന്ന വിശ്വാസികൾക്ക്  ആരോഗ്യ പരിചരണത്തിനും നിലവിൽ മരുന്നുകൾ കഴിക്കുന്നവർക്ക് നോമ്പെടുക്കുമ്പോള്‍ ശ്രദ്ധിക്കേണ്ട കാര്യങ്ങളെ കുറിച്ച് സംശയ നിവാരണത്തിനും ഈ മെഡിക്കൽ ക്യാമ്പിലൂടെ സാധിച്ചു. നെയ്യാറ്റിൻകര ഠൗൺ ജുമാ മസ്ജിദ് ചീഫ് ഇമാം  ബഹുമാനപ്പെട്ട ഫൈസൽ മൗലവി ഉദ്ഘാടനം നിർവ്വഹിച്ച മെഡിക്കൽ ക്യാമ്പിന് നിംസ് മെഡിസിറ്റിയിലെ ഇൻ്റേണൽ മെഡിസിൻ കൺസൾട്ടൻ്റും ഡയബറ്റോളജിസ്റ്റ്മായ ഡോക്ടർ ശ്രീ ഷഹ്ബാസ് ഷൈലു നേതൃത്വം നൽകി. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി. നെയ്യാറ്റിൻകര ഠൗൺ മുസ്‌ലിം ജമാഅത്ത് കമ്മിറ്റി അംഗം ജനാബ് ബാദുഷ അവർകൾ സ്വാഗതം പറഞ്ഞ ചടങ്ങിൽ ജമാഅത്ത് പ്രസിഡൻ്റ് ശ്രീ. അബ്ദുൽ റസാഖ്  ,സെക്രട്ടറി ഹാജി അബ്ദുൽ ജബ്ബാർ , മദ്രസ കോഡിനേറ്റർമാറായ ശ്രീ തൗഫീഖ് , സുഹൈൽ തുടങ്ങിയവർ സന്നിഹിതരായിരുന്നു .",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/03-01-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ കൊല്ലം",
      location: "നടയ്ക്കാവ് മാർക്കറ്റ് ജംഗ്ഷൻ,ചവറ, കൊല്ലം.",
      date: "03-01-2024",
      discription:
        "ചവറ സൗത്ത് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/02-29-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ ചായം",
      location: "സെവൻത് ഡേ അഡ്വൻ്റിസ്റ്റ് ചർച്ച്,മാങ്കല, ചായം.",
      date: "02-29-2024",
      discription:
        "വിതുര പബ്ലിക് ക്യാമ്പസ് മിനിസ്ട്രി, മാങ്കല സെവെന്ത് ഡേ അഡ്വന്റിസ്റ്റ് ചർച്ചിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/02-28-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ വാഴിച്ചൽ",
      location: "ശ്രീ മാരാൻവിള ദേവി ക്ഷേത്ര ഓഡിറ്റോറിയം, വാഴിച്ചൽ.",
      date: "02-28-2024",
      discription:
        "വാഴിച്ചൽ ശ്രീ മാരാൻവിള ദേവി ക്ഷേത്ര ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെ സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. സംഘടിപ്പ.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/02-27-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ മാരായമുട്ടം",
      location: "ശ്രീ നീലകേശി ക്ഷേത്ര ഓഡിറ്റോറിയം, മാരായമുട്ടം.",
      date: "02-27-2024",
      discription:
        "മാരായമുട്ടം ശ്രീ നീലകേശി ക്ഷേത്ര ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെ സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ആതുര സേവന രംഗത്ത് മികച്ച പ്രവർത്തനം കാഴ്ചവയ്ക്കുന്ന നെയ്യാറ്റിൻകര നിംസ് മെഡിസിറ്റിക്ക് മാരായമുട്ടം ശ്രീ നീലകേശി ക്ഷേത്രം ട്രസ്റ്റിന്റെ ആദരവ് ഏറ്റുവാങ്ങി.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/02-25-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ ആറ്റുകാൽ",
      location:
        "ആറ്റുകാൽ, ഐരാണിമുട്ടം, കാലടി, വെള്ളയമ്പലം, ഈസ്റ്റ് ഫോർട്ട്,തമ്പാനൂർ ,പി എം ജി.",
      date: "02-25-2024",
      discription:
        "ആറ്റുകാൽ പൊങ്കാല മഹോത്സവത്തോട് അനുബന്ധിച്ച് തലസ്ഥാനത്തിൻ്റെ വിവിധ ഭാഗങ്ങളിൽ പൊങ്കാല ദിവസം നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ സൗജന്യ  ആംബുലൻസ് സർവീസും മെഡിക്കൽ ക്യാമ്പും സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/02-24-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ മൈലച്ചൽ",
      location: "ശ്രീ ഭദ്രകാളി ക്ഷേത്ര ഓഡിറ്റോറിയം,മൈലച്ചൽ.",
      date: "02-24-2024",
      discription:
        "മൈലച്ചൽ ശ്രീ ഭദ്രകാളി ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെ സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/02-23-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ ഊരുട്ടൂക്കാല",
      location: "ശ്രീ ഭദ്രകാളി ക്ഷേത്രം,ഊരുട്ടൂക്കാല.",
      date: "02-23-2024",
      discription:
        "ഊരുട്ടുക്കാല ശ്രീ ഭദ്രകാളി ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/02-21-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ മംഗലപുരം",
      location: "മംഗലപുരം ഗ്രാമ പഞ്ചായത്ത് കമ്മ്യൂണിറ്റി ഹാൾ.",
      date: "02-21-2024",
      discription:
        "മുരുക്കുംപുഴ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.മെഡിക്കൽ ക്യാമ്പിൻ്റെ ഉദ്ഘാടനം ബഹുമാനപ്പെട്ട എം പി അടൂർ പ്രകാശ് നിർവഹിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/02-18-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ തച്ചോട്ടുക്കാവ്",
      location: "തച്ചോട്ടുക്കാവ് റെസിഡൻഷ്യൽ അസോസിയേഷൻ ഹാൽ, തച്ചോട്ടുക്കാവ്.",
      date: "02-18-2024",
      discription:
        "തച്ചോട്ടുക്കാവ് റെസിഡൻഷ്യൽ അസോസിയേഷൻ, മലയിൻകീഴ് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/02-16-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ വിതുര",
      location: "മുസ്ലീം ജുമാ മസ്ജിദ് ഹാൾ,വിതുര.",
      date: "02-16-2024",
      discription:
        "34-ാംസ്വലാത്ത്‌ വാർഷികത്തോട്‌ അനുബന്ധിച്ച് വിതുര മുസ്‌ലിം ജുമാ മസ്ജിദിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/02-10-2024-1.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ ഉച്ചക്കട",
      location:
        "നെല്ലിക്കോണം ശ്രീ ദുർഗ്ഗ ശ്രീ ശാസ്താ ക്ഷേത്ര ഓഡിറ്റോറിയം, ഉച്ചക്കട.",
      date: "02-10-2024",
      discription:
        " ഉച്ചക്കട ചങ്ങാതികൂട്ടം വായനശാല & കലാ സാംസ്കാരിക വേദിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/02-10-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ കുളത്തൂർ",
      location: "ശ്രീ ഭദ്രകാളി ക്ഷേത്ര ഓഡിറ്റോറിയം, കുളത്തൂർ.",
      date: "02-10-2024",
      discription:
        "കുളത്തൂർ ശ്രീ ഭദ്രകാളി ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/02-08-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ പട്ടം",
      location: " കേന്ദ്രീയ വിദ്യാലയ ഓഡിറ്റോറിയം, പട്ടം.",
      date: "02-08-2024",
      discription:
        "പട്ടം പി എം ശ്രീ കേന്ദ്രീയ വിദ്യാലയത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/02-07-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ പട്ടം",
      location: " കേന്ദ്രീയ വിദ്യാലയ ഓഡിറ്റോറിയം, പട്ടം.",
      date: "02-07-2024",
      discription:
        "പട്ടം പി എം ശ്രീ കേന്ദ്രീയ വിദ്യാലയത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/02-03-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ ശാസ്താംകോട്ട",
      location: "അമ്മ മെമ്മോറിയൽ എൽ പി സ്ക്കൂൾ, മനക്കര, ശാസ്താംകോട്ട.",
      date: "02-03-2024",
      discription:
        "ശാസ്താംകോട്ട ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/02-01-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ ചിറയിൻകീഴ്",
      location: "ആശ്രയ വയോജന കേന്ദ്രം, ചിറയിൻകീഴ്.",
      date: "02-01-2024",
      discription:
        "ചിറയിൻകീഴ് ആശ്രയ വയോജന കേന്ദ്രം,ചിറയിൻകീഴ് ലയൺസ് ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/01-30-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ തത്തിയൂർ",
      location: "ശ്രീ ശിവ ഭഗവതി ക്ഷേത്ര ഓഡിറ്റോറിയം, തത്തിയൂർ.",
      date: "01-30-2024",
      discription:
        "തത്തിയൂർ ശ്രീ ശിവ ഭഗവതി ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/01-29-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ തൊഴുവൻക്കോട്",
      location: "തൊഴുവൻക്കോട് ദേവി ക്ഷേത്രം.",
      date: "01-29-2024",
      discription:
        "ട്രിവാൻഡ്രം സേവ് തി പ്രൊട്ടക്ഷൻ കൗൺസിൽ, തൊഴുവൻക്കോട് ദേവി ക്ഷേത്ര ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/01-26-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ നെട്ടയം",
      location: "ജൻ ഔഷധി കേന്ദ്രം, നെട്ടയം.",
      date: "01-26-2024",
      discription:
        "നെട്ടയം ജൻ ഔഷധി കേന്ദ്രം, ഒക്ടാൽ ലബോറിത്തോറി, വട്ടിയൂർക്കാവ് മോഡൽ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/01-25-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ കാപ്പിക്കാട്",
      location:
        "ശ്രീകൃഷ്ണ, ശ്രീ ഭദ്രകാളി ക്ഷേത്ര ഓഡിറ്റോറിയം, കള്ളിതട്ട് ,കാപ്പിക്കാട്.",
      date: "01-25-2024",
      discription:
        "തമിഴ്നാട് ഹെൽത്ത് ഇൻഷുറൻസ് സ്കീം, കാപ്പിക്കാട് ശ്രീകൃഷ്ണ ശ്രീ ഭദ്രകാളി ക്ഷേത്ര ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/01-24-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ നെല്ലിമൂട്",
      location: "ശ്രീ ചാമുണ്ഡി ദേവി ക്ഷേത്ര ഓഡിറ്റോറിയം, പയറ്റുവിള,നെല്ലിമൂട്.",
      date: "01-24-2024",
      discription:
        "ഇടത്തേക്കോണം ജനത ക്ലബ്,പയറ്റുവിള ശ്രീ ചാമുണ്ഡി ദേവി ക്ഷേത്ര ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/01-23-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ ചെങ്കൽ",
      location: "ചെങ്കൽ പഞ്ചായത്ത് വനിത കോൺഫറൻസ് ഹാൾ,ചെങ്കൽ.",
      date: "01-23-2024",
      discription:
        "ക്യാമ്പിൽ സ്പെഷ്യൽ എഡ്യൂക്കേറ്റർ, ജനറൽ മെഡിസിൻ, കാർഡിയോളജി, ദന്തൽ,ഓഡിയോജി ഒഫ്താൽമോളജി, കൗൺസിലിംഗ് തുടങ്ങിയ വിഭാഗങ്ങളുടെ സേവനങ്ങൾ ഉണ്ടായിരുന്നു. ചെങ്കൽപഞ്ചായത്ത് പ്രസിഡന്റ് ശ്രീമതി  ഗിരിജ ചടങ്ങ് ഉദ്ഘാടനം ചെയ്തു.ചെങ്കൽ പഞ്ചായത്തിലെ 18 വയസ്സിൽ താഴെ പ്രായമുള്ള എല്ലാ ഭിന്നശേഷി കുട്ടികളേയും  നെയ്യാറ്റിൻകര പെൻഷൻ പ്ളാനിൽ ഉൾപ്പെടുത്തുകയും മറ്റ് ആനുകൂല്യങ്ങൾ നൽകി ഒട്ടനവധി ജീവ കാരുണ്യ പ്രവർത്തനങ്ങൾക്ക് നേതൃത്വം നൽകി നടപ്പിലാക്കി കൊണ്ടിരിക്കുന്ന നിംസ് മെഡിസിറ്റി മാനേജിംഗ് ഡയറക്ടർ ശ്രീ എം എസ് ഫൈസൽ ഖാൻ സാറിന്  നന്ദിയും കടപ്പാടും രേഖപ്പെടുത്തി. വൈസ് പ്രസിഡന്റ് ശ്രീ അജിത്ത് കുമാർ സ്വാഗതം ആശംസിച്ചു.നിംസ് ജറിയാട്രിക് കോഡിനേറ്റർ ശ്രീമതി രേണു.കെ.ആർ. പെൻഷൻ പ്ലാൻ വിശദീകരണവും, വികസന സ്റ്റാൻഡിങ് കമ്മിറ്റി ചെയർപേഴ്സൺ ശ്രീമതി . ത്രേസ്യ സിൽവിസ്റ്റർ, പോളിയോ ഹോം മുൻ കെയർടേക്കർ ശ്രീ ബോബി സർ തുടങ്ങിയവർ ആശംസയും ചെങ്കൽ പഞ്ചായത്ത് ആരോഗ്യ സ്റ്റാൻഡിംഗ് കമ്മിറ്റി ചെയർപേഴ്സൺ ശ്രീമതി പ്രമീള കൃതജ്ഞതയും ആശംസിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/01-21-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ പാറശ്ശാല",
      location: "സെവൻത് ഡേ അഡ്വൻ്റിസ്റ്റ് ചർച്ച്,മുരിയൻങ്കര, പാറശ്ശാല.",
      date: "01-21-2024",
      discription:
        "പാറശ്ശാല പബ്ലിക് ക്യാമ്പസ് മിനിസ്ട്രി, മുരിയങ്കര സെവെന്ത് ഡേ അഡ്വന്റിസ്റ്റ് ചർച്ചിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/01-20-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ നെടുമങ്ങാട്",
      location: "എൻ എസ് എസ് കരയോഗം ഹാൾ, കരിപ്പൂർ, നെടുമങ്ങാട്.",
      date: "01-20-2024",
      discription:
        " നെടുമങ്ങാട് മുനിസിപ്പാലിറ്റി, വാണ്ട മുഖവുർ വാർഡ് കമ്മിറ്റി, ട്രിവാൻഡ്രം നോർത്ത് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/01-19-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ പൂജപ്പുര",
      location: "ആശ്രയ ഹാൾ,മുടവൻമുഗൽ, പൂജപ്പുര.",
      date: "01-19-2024",
      discription:
        "ട്രിവാൻഡ്രം രാജധാനി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/01-18-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ വിളപ്പിൽശാല",
      location: "പടവൻക്കോട് ജുമാ മസ്ജിദ് ഹാൾ, വിളപ്പിൽശാല.",
      date: "01-18-2024",
      discription:
        "പെൻഷൻ പ്ലാൻ മെഡികെയർ-2024. വിളപ്പിൽ പഞ്ചായത്തിലെ ഭിന്നശേഷിക്കാർക്കും വയോജനങ്ങൾക്കും പ്രത്യേക പരിഗണന നൽകി കൊണ്ട് വിളപ്പിൽ പഞ്ചായത്തിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പും ബോധവത്കരണവും സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/01-17-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ നെല്ലിമൂട്",
      location: "ശ്രീ യക്ഷി അമ്മൻ ക്ഷേത്ര അഗണം, കൊല്ലംക്കോണം, നെല്ലിമൂട്.",
      date: "01-17-2024",
      discription:
        "ജീവദായിനി -2024 കൊല്ലംക്കോണം ശ്രീ യക്ഷി അമ്മൻ ദേവി ക്ഷേത്ര ട്രസ്റ്റ്,കൊല്ലംക്കോണം വിവേകാനന്ദ സാംസ്കാരിക വേദി സംയുക്തമായി നടത്തുന്ന ജീവദായിനിയുടെ ജീവകാരുണ്യ പ്രവർത്തനങ്ങളുടെ 6 - വാർഷികവും സൗജന്യ മെഡിക്കൽ ക്യാമ്പും ചികിത്സാ സഹായ വിതരണവും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ നടന്നു.ജീവദായനിയുടെ ചികിത്സാസഹായ വിതരണം നിംസ് മെഡിസിറ്റി ജനറൽ മാനേജർ Dr സജു നിർവഹിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/01-16-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ കരുങ്കൽ",
      location: "സെൻ്റ് ജോൺ കമ്മ്യൂണിറ്റി ഹാൾ,കൊല്ലംക്കോണം,കരുങ്കൽ.",
      date: "01-16-2024",
      discription:
        " തമിഴ്നാട് ഗവൺമെൻ്റ് ഇൻഷുറൻസ് സ്കീം, മരിയഗിരി മലങ്കര കാത്തലിക് കോളേജ് എൻഎസ്എസ് യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/01-14-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ പെരുമ്പഴുതൂർ",
      location: "കുക്കുറുണി ശ്രീ ശാസ്താ ക്ഷേത്രം, പെരുമ്പഴുതൂർ.",
      date: "01-14-2024",
      discription:
        "കുക്കുറുണി ശ്രീ ശാസ്താ ക്ഷേത്ര ദേവസ്വത്തിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/01-13-2024-2.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ വട്ടിയൂർക്കാവ്",
      location:
        "വട്ടിയൂർക്കാവ് സർവീസ് സഹകരണ ബാങ്ക്, മൂന്നാംമ്മൂട് ബ്രാഞ്ച്, വട്ടിയൂർക്കാവ്.",
      date: "01-13-2024",
      discription:
        "വട്ടിയൂർക്കാവ് മൂന്നാംമ്മൂട് റെസിഡൻഷ്യൽ അസോസിയേഷൻ,ട്രിവാൻഡ്രം പ്ലാറ്റിനം ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/01-13-2024-1.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ കരമന",
      location: "സത്യ നഗർ റെസിഡൻഷ്യൽ ഹാൾ,കരമന.",
      date: "01-13-2024",
      discription:
        "കരമന സത്യ നഗർ റെസിഡൻഷ്യൽ അസോസിയേഷൻ, കരമന ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/01-13-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ കാട്ടാക്കട",
      location: "ദൈവയോഗ സംഘം ആശ്രമം, മാറനല്ലൂർ, കാട്ടാക്കട.",
      date: "01-13-2024",
      discription:
        "മാറനല്ലൂർ ദൈവയോഗ സംഘം ആശ്രമം,ട്രിവാൻഡ്രം വൈസ്മാൻ ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/01-12-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ കുളത്തൂപ്പുഴ",
      location: "50ഏകർ പടനട ഹാൾ, കുളത്തൂപ്പുഴ.",
      date: "01-12-2024",
      discription:
        "കുളത്തൂപ്പുഴ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/01-11-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ പാലോട്",
      location: "നവോദയ വിദ്യാലയം, പാലോട്.",
      date: "01-11-2024",
      discription:
        "പാലോട് നവോദയ വിദ്യാലയത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/01-07-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ ചിറയിൻകീഴ്",
      location: "75- നമ്പർ അംഗൻവാടി,കടുവയിൽ, ചിറയിൻകീഴ്.",
      date: "01-07-2024",
      discription:
        "ചിറയിൻകീഴ് കിഴുവലം 4- വാർഡ്,ചിറയിൻകീഴ് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ അടൂർ പ്രകാശ് (എം പി).ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/01-07-2024-1.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ ഈസ്റ്റ് ഫോർട്ട്",
      location: "പുത്തരിക്കണ്ടം മൈതാനം, ഈസ്റ്റ് ഫോർട്ട്.",
      date: "01-07-2024",
      discription:
        "അനന്തപുരി ഹിന്ദു മഹാ സമ്മേളനത്തോടനുബന്ധിച്ച് നിംസ് മെഡിസിറ്റി സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പും ആരോഗ്യ സെമിനാറും സംഘടിപ്പിച്ചു. ആരോഗ്യ സെമിനാറിൽ നിംസ് നേച്ചറോപതി മേധാവി ഡോ ലളിത അപ്പുകുട്ടൻ   ജീവിത  ശൈലീരോഗങ്ങളും ഹോളിസ്റ്റിക് മെഡിസിനും എന്ന വിഷയത്തിൽ സെമിനാർ സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/01-06-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ നെല്ലിമൂട്",
      location: "സി എസ് ഐ ചർച്ച് ഹാൾ, കഴിവൂർ, നെല്ലിമൂട്.",
      date: "01-06-2024",
      discription:
        "കഴിവൂർ സി എസ് ഐ ചർച്ചിൻ്റെ 144 മത് സദാദിനാഘോഷത്തോട് അനുബന്ധിച്ച് നിംസ് മെഡിസിറ്റിയുടെ നേതൃത്വത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/01-05-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ പാലോട്",
      location: "ഫൈറ്റേഴസ് സാംസ്കാരിക നിലയം, പച്ച, പാലോട്.",
      date: "01-05-2024",
      discription:
        "പച്ച ശ്രീ ധർമ്മ ശാസ്താ റെസിഡൻഷ്യൽ അസോസിയേഷൻ, പാലോട് ജനമൈത്രി പൊലീസ് സ്റ്റേഷൻൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ ഷാജിമോൻ(പാലോട് പോലീസ് ഇൻസ്പെക്ടർ).ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/01-02-2024.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ ആലംക്കോട്",
      location: "ഹൈറുണിസ പ്ലാസ, ആലംക്കോട്, ആറ്റിങ്ങൽ.",
      date: "01-02-2024",
      discription:
        "ആലംകോട് ഹൈസ്കൂൾ പൂർവ വിദ്യാർത്ഥി കൂട്ടായിമയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/12-31-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ വിതുര",
      location: "വിജയകൃഷ്ണ ഓഡിറ്റോറിയം, ചായം,വിതുര.",
      date: "12/31/2023",
      discription:
        "വിതുര ചായം റെസിഡൻഷ്യൽ അസോസിയേഷൻൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/12-30-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ കോട്ടൂർ",
      location: "ഗവ: ട്രൈബൽ സ്ക്കൂൾ, വ്ലാവരട്ടി, കോട്ടൂർ.",
      date: "12/30/2023",
      discription:
        "കോട്ടൂർ വനജോതി പുരുഷ സ്വയംസഹായ സംഘം,ട്രിവാൻഡ്രം റീജൻസി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/12-27-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ ഒറ്റശേഖരമംഗലം",
      location: "വിനായക സർവീസ് സ്റ്റേഷനു സമീപം,ഒറ്റശേഖരമംഗലം.",
      date: "12/27/2023",
      discription:
        "ഒറ്റശേഖരമംഗലം ശ്രീ മഹാദേവ ക്ഷേത്രത്തിലെ തിരുവാതിര ഉൽസവത്തോട് അനുബന്ധിച്ച് കെ എൻ എം എസ് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/12-27-2023-1.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ ഓലത്താന്നി",
      location: "ശ്രീ മഹാദേവ ക്ഷേത്ര ഓഡി്റ്റോറിയം, അരങ്ങിൽ, ഓലത്താന്നി .",
      date: "12/27/2023",
      discription:
        "അരങ്ങിൽ ശ്രീ മഹാദേവ ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/12-27-2023-2.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ ബാലരാമപുരം",
      location: "തണ്ണിക്കുഴി ശ്രീ അയ്യപ്പാ സ്വാമി ക്ഷേത്ര ഹാൾ, ബാലരാമപുരം",
      date: "12/27/2023",
      discription:
        "തണ്ണികുഴി ശ്രീ സ്വാമി അയ്യപ്പൻ ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/12-25-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ അരുവിക്കര",
      location: "ഭഗവതി്പുരം ജംഗ്ഷൻ, അരുവിക്കര.",
      date: "12/25/2023",
      discription:
        " അരുവിക്കര ഭഗവതി്പുരം ഡി വൈ എഫ് ഐ യൂണിറ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/12-24-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ മാരായമ്മുട്ടം",
      location: "ഗവ: ഹൈസ്കൂൾ മാരായമ്മുട്ടം.",
      date: "12/24/2023",
      discription:
        "ഗവ: ഹൈസ്കൂൾ 2000-2001ബാച്ച് മാരായമ്മുട്ടം പൂർവ്വ വിദ്യാർത്ഥി സംഗമത്തോട് അനുബന്ധിച്ച് നിംസ് മെഡിസിറ്റി സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/12-21-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ നെല്ലിമൂട്",
      location: "ശ്രീ നാരായണ ധർമ്മപ്രകാശിനി ഹാൾ,പൂതക്കോട്,നെല്ലിമൂട്.",
      date: "12/21/2023",
      discription:
        "പൂതക്കോട് എസ് എൻ ഡ് പി യൂണിറ്റ്, ശ്രീ നാരായണ ധർമ്മ പ്രകാശിനി മന്ദിരത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/12-20-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ കളിയികാവിള",
      location: "ശ്രീകൃഷണ വൈദ്യശാല,കളിയികാവിള.",
      date: "12/20/2023",
      discription:
        "തമിഴ്നാട്  ഗവൺമെന്റ് ഹെൽത്ത് സ്കീം, കളിയിക്കാവിള ശ്രീകൃഷ്പുരം വൈദ്യശാലയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/12-16-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ കൊല്ലം",
      location: "വി എസ് യൂ പി സ്ക്കൂൾ ,ചക്കുവളളി,കൊല്ലം.",
      date: "12/16/2023",
      discription:
        "നവകേരള സദസ്സിനോടനുമ്പദ്ധിച്ച് മൺണ്ഡ്രോ തുരുത്ത് ജനകീയ കൂട്ടായ്മയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ കോവൂർ കുഞ്ഞുമോൻ (എംഎൽഎ ).ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/12-14-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ അമ്പലം നഗർ",
      location: "എൻ എസ് എസ് ഹാൾ, അമ്പലം നഗർ.",
      date: "12/14/2023",
      discription:
        "കരകുളം ഗ്രാമപഞ്ചായത്ത്, വട്ടപ്പാറ സൗത്ത് വാർഡ് കുടുംബശ്രീ കൂട്ടായിമയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/12-13-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ കല്ലറ",
      location: "തഓട്ടഇൻപ്പഉറം മുസ്ലിം ജുമാ മസ്ജിദ് ഹാൾ,കല്ലറ.",
      date: "12/13/2023",
      discription:
        "കല്ലറ തോട്ടിൻപ്പുറം മുസ്‌ലിം ജുമാ മസ്ജിദിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/12-10-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ വട്ടിയൂർക്കാവ്",
      location: "പുതുർക്കോണം ജംഗ്ഷൻ, വട്ടിയൂർക്കാവ്.",
      date: "12/10/2023",
      discription:
        "വട്ടിയൂർക്കാവ് ജ്വാല വാട്ട്സ്ആപ്പ് കൂട്ടായിമയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/12-09-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ ഊരൂട്ടുക്കാല",
      location: "ജി ആർ ഓഡിറ്റോറിയം, ഊരൂട്ടുക്കാല.",
      date: "12/09/2023",
      discription:
        "ഊരുട്ടുക്കാല ദയാ ഇൻഡസ്ട്രിസിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/12-08-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ കഴക്കൂട്ടം",
      location: "സെൻ്റ് സെബാസ്റ്റ്യൻ ചർച്ച്,വെട്ടുതുറ. കഴക്കൂട്ടം.",
      date: "12/08/2023",
      discription:
        "ട്രിവാൻഡ്രം അനന്തപുരി ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/12-06-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ കണിയാപുരം",
      location: "സഹജീവൻ സ്പെഷ്യൽ സ്കൂൾ,കണിയാപുരം.",
      date: "12/06/2023",
      discription:
        "കണിയാപുരം ചിറക് കൂട്ടായിമ, സഹജീവൻ സ്പെഷ്യൽ സ്കൂളിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/12-03-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ കുരിയാത്തി",
      location: "മാർത്തോമ്മാ ചർച്ച് ഹാൾ, കുരിയാത്തി.കുളപ്പട.",
      date: "12/03/2023",
      discription:
        "ആര്യനാട് കുരിയാത്തി ഐ എൻ റ്റി സി യു യൂണിറ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/12-02-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ നരുവാമൂട്",
      location: "എസ്ക്കേ പബ്ലിക് സ്കൂൾ,നരുവാമൂട്.",
      date: "12/02/2023",
      discription:
        "നരുവാമൂട് പ്ലാറ്റിനം ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/12-02-2023-1.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ വിഴിഞ്ഞം",
      location: "സെൻ്റ് പീറ്റേഴ്സ് ചർച്ച് അങ്കണം, വിഴിഞ്ഞം.",
      date: "12/02/2023",
      discription:
        "വിഴിഞ്ഞം മാതൃ - പൃതു വേദി ട്രിവാൻഡ്രം ഫൊറോന,ട്രിവാൻഡ്രം റീജൻസി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/12-01-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ ബാലരാമപുരം",
      location: "ശ്രീലില്ലി ദേവൻ പയറ്റുവിള, ബാലരാമപുരം.",
      date: "12/01/2023",
      discription:
        "ട്രിവാൻഡ്രം വഞ്ചിനാട് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/11-30-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ പെരുംങ്കടവിള",
      location: "അപ്പോളോ ഫാർമസി, പെരുംങ്കടവിള.",
      date: "11/30/2023",
      discription:
        "പെരുംങ്കടവിള അപ്പോളോ ഫാർമസി ഗ്രൂപ്പിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/11-29-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ കരമന",
      location: "ജി എൻ അർ എ ഹാൾ, മേലാരന്നൂർ,കരമന.",
      date: "11/29/2023",
      discription:
        "മേലാരന്നൂർ ഗാന്ധിജി നഗർ റെസിഡൻസ് വെൽഫെയർ അസോസിയേഷൻ, ട്രിവാൻഡ്രം ഈസ്റ്റ് ലിയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഓർത്തോപീഡിക്കസ്, എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/11-28-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ മംഗലത്തുക്കോണം",
      location: "സെൻ്റ് അലോഷ്യസ് സ്കൂൾ, മംഗലത്തുക്കോണം.",
      date: "11/28/2023",
      discription:
        "മംഗലത്തുകോണം സെൻ്റ് അലോഷ്യസ് സ്കൂളിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഓർത്തോപീഡിക്കസ്, എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/11-25-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ ബാർട്ടൻഹിൽ",
      location: "ബാർട്ടൻഹിൽ അംഗൻവാടി ഹാൾ.",
      date: "11/25/2023",
      discription:
        "കുന്നുകുഴി വാർഡ് കുടുംബശ്രീ എ ഡി എസ് യൂണിറ്റ്, ഗൗരീശപട്ടം ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഓർത്തോപീഡിക്കസ്, എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/11-25-2023-1.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ ഉച്ചക്കട",
      location: "അഞ്ചു ഓഡിറ്റോറിയം, ഉച്ചക്കട.",
      date: "11/25/2023",
      discription:
        "കരോടെ റോട്ടറി ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ അൻസലൻ (എംഎൽഎ ).ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഓർത്തോപീഡിക്കസ്, എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/11-24-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ പള്ളിച്ചൽ",
      location: "വെന്നിയൂർ മാർക്കറ്റിനു സമീപം, പള്ളിച്ചൽ.",
      date: "11/24/2023",
      discription:
        "ട്രിവാൻഡ്രം പ്ലാറ്റിനം ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/11-23-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ ആനയറ",
      location: "സ്വിഫ്റ്റ് ഓഫീസ് ആനയറ.",
      date: "11/23/2023",
      discription:
        " KSRTC  ആരംഭിച്ച ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 100-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/11-23-2023-1.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ വലിയവിള",
      location: "പാരിഷ് ഹാൾ,വലിയവിള.",
      date: "11/23/2023",
      discription:
        "വലിയവിള ക്രിസ്തുരാജ ദേവാലയം നിഡ്സ് യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/11-22-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ കമലേശ്വരം",
      location: " അപ്പോളോ ഫാർമസി, കമലേശ്വരം",
      date: "11/22/2023",
      discription:
        "കമലേശ്വരം അപ്പോളോ ഫാർമസി ഗ്രൂപ്പിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/11-21-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ വിഴിഞ്ഞം",
      location: " സെയിന്റ് ഫ്രാൻസിസ് സെയിൽസ് സ്ക്കൂൾ, വിഴിഞ്ഞം.",
      date: "11/21/2023",
      discription:
        "വിഴിഞ്ഞം സെൻ്റ് ഫ്രാൻസിസ് സെയിൽസ് പബ്ലിക് സ്ക്കൂളിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/11-20-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ വിതുര",
      location: "ട്രൈബൽ സ്ക്കൂൾ, തലത്തുക്കാവ്,വിതുര.",
      date: "11/20/2023",
      discription:
        "വിതുര ശിശു സൗഹൃദ ജനമൈത്രി പോലീസ് സ്റ്റേഷൻൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ കിരൺ നാരായൺ IPS (ജില്ലാ പൊലീസ് മേധാവി). ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/11-19-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ ഓലതാന്നി",
      location: "തിരു ഹൃദയ ദേവാലയം, ഓലതാന്നി.",
      date: "11/19/2023",
      discription:
        "ഓലതാന്നി തിരു ഹൃദയ ദേവാലയം, നിഡ്സ് യൂണിറ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/11-19-2023-1.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ ഓയൂർ",
      location: "ജി എൽ പി സ്ക്കൂൾ, വേങ്ങൂർ, ഓയൂർ.",
      date: "11/19/2023",
      discription:
        "വേങ്ങൂർ ജി എൽ പി സ്ക്കൂൾ, ഓയൂർ ടൗൺ ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെ സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/11-19-2023-2.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ ഇറയംക്കോട്",
      location: "ഐ റ്റി സി ഹാൾ, ഇറയംക്കോട്.",
      date: "11/19/2023",
      discription:
        "ഇറയംക്കോട് പു. ക. സ യൂണിറ്റ്,ട്രിവാൻഡ്രം റൈൻബോ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെ സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/11-16-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ ചെങ്കൽ",
      location: "ശിവപാർവതി ക്ഷേത്ര ഓഡിറ്റോറിയം, ചെങ്കൽ.",
      date: "11/16/2023",
      discription:
        "ചെങ്കൽ മഹേശ്വരം ശിവപാർവതി ക്ഷേത്ര മഠാധിപതി ശ്രീ മഹേശ്വരാനന്ദ സരസ്വതിയുടെ സപ്തതി ആഘോഷത്തിൻ്റെ ഭാഗമായി നിംസ് മെഡിസിറ്റിയുടെ ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/11-15-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ ഓലത്താന്നി",
      location: "വിക്ടറി ടീച്ചേഴ്സ് എജുക്കേഷൻ  സെൻറ്റർ, ഓലത്താന്നി",
      date: "11/15/2023",
      discription:
        "ലോക പ്രമേഹ ദിനത്തോട് അനുബന്ധിച്ച് ഓലത്താന്നി വിക്ടറി കോളേജ് ഓഫ് ടീച്ചേഴ്സ് എജുക്കേഷൻൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/11-15-2023-1.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ കോലിയക്കോട്",
      location: "സൊസൈറ്റി ഹാൾ,കോലിയക്കോട്.",
      date: "11/15/2023",
      discription:
        "കോലിയക്കോട് കലുങ്ക് ബ്രദേഴ്സ്, ട്രിവാൻഡ്രം സൗത്ത് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/11-14-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ പെരുംങ്കടവിള",
      location: "പഞ്ചായത്ത് ഓഡിറ്റോറിയം,പെരുംങ്കടവിള.",
      date: "11/14/2023",
      discription:
        " പെരുംങ്കടവിള ഗ്രാമ പഞ്ചായത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/11-12-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ ശാസ്താംകോട്ട,കൊല്ലം",
      location: "വെളിയം ദാമോദർ സ്മാരക ഗ്രന്ഥശാല ഹാൾ, ശാസ്താംകോട്ട,കൊല്ലം.",
      date: "11/12/2023",
      discription:
        "ശാസ്താംകോട്ട വെളിയം ദാമോദർ സ്മാരക ഗ്രന്ഥശാല,ശാസ്താംകോട്ട ഹിൽടോപ് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/11-10-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ വിതുര",
      location: "ഗവ: ഹയർ സെക്കൻഡറി സ്കൂൾ,വിതുര.",
      date: "11/10/2023",
      discription:
        "വിതുര ശിശു സൗഹൃദ ജനമൈത്രി പോലീസ് സ്റ്റേഷൻ, വിതുര ഫ്രാറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/11-09-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ പനച്ചമൂട്",
      location: "കല്ലിങ്കൽ ഓട്ടോ മൊബൈൽസ്, താന്നിമൂട്, പനച്ചമൂട്",
      date: "11/09/2023",
      discription:
        "പനച്ചമൂട് കല്ലിങ്കൽ ഓട്ടോ മൊബൈൽസ്,ട്രിവാൻഡ്രം പ്രേംനസീർ സുഹൃത്ത് സമിതിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ സി കെ  ഹരീന്ദ്രൻ (എം എൽ എ )ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/11-08-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ ആനയറ",
      location: "സ്വിഫ്റ്റ് ഓഫീസ് ആനയറ.",
      date: "11/08/2023",
      discription:
        "KSRTC  ആരംഭിച്ച ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 100-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/11-06-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ കീഴാരൂർ",
      location: "ശ്രീ സരസ്വതി വിദ്യാലയ ഓഡിറ്റോറിയം, കീഴാരൂർ ",
      date: "11/06/2023",
      discription:
        "കീഴാരൂർ ശ്രീ സരസ്വതി വിദ്യാലയത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/11-05-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ ആനയറ",
      location: "സ്വിഫ്റ്റ് ഓഫീസ് ആനയറ.",
      date: "11/05/2023",
      discription:
        "KSRTC  ആരംഭിച്ച ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 100-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/11-05-2023-1.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ തോവാള",
      location: "ചോളപുരം ഓഡിറ്റോറിയം,തോവാള, നാഗർകോവിൽ.",
      date: "11/05/2023",
      discription:
        "തമിഴ്നാട് ഗവൺമെൻ്റ് ഇൻഷുറൻസ് സ്കീം ചോളപുരം യൂത്ത് വെൽഫെയർ അസോസിയേഷൻൻ്റെയും നിംസ് മെഡിസിറ്റി യുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/11-04-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ കിളിമാനൂർ",
      location: " ഫ്രണ്ട്സ് റെസിഡൻഷ്യൽ അസോസിയേഷൻ ഹാൾ, ആലത്തുകാവ്, കിളിമാനൂർ.",
      date: "11/04/2023",
      discription:
        "കിളിമാനൂർ ഫ്രണ്ട്സ് റെസിഡൻഷ്യൽ അസോസിയേഷൻ,കിളിമാനൂർ ഇൻ്റർനാഷണൽ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/11-04-2023-1.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ നീറമൺകര",
      location: " എൻ എസ് എസ് വുമൺസ് കോളേജ് ഓഡിറ്റോറിയം,നീറമൺകര.",
      date: "11/04/2023",
      discription:
        "(രണ്ടാം ദിവസം) നീരമൺകര എൻ എസ് എസ് വിമൻസ് കോളേജ് എൻ എസ് എസ് യൂണിറ്റ്, ഫിസിക്കൽ എഡ്യൂക്കേഷൻ ഡിപ്പാർട്ട്മെൻ്റ്, ട്രിവാൻഡ്രം  റെയിൻബോ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/11-03-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ ആനയറ",
      location: "സ്വിഫ്റ്റ് ഓഫീസ് ആനയറ.",
      date: "11/03/2023",
      discription:
        "KSRTC  ആരംഭിച്ച ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 100-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/11-02-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ നീറമൺകര",
      location: "എൻ എസ് എസ് വുമൺസ് കോളേജ് ഓഡിറ്റോറിയം,നീറമൺകര",
      date: "11/02/2023",
      discription:
        " നീരമൺകര എൻ എസ് എസ് വിമൻസ് കോളേജ് എൻ എസ് എസ് യൂണിറ്റ്, ഫിസിക്കൽ എഡ്യൂക്കേഷൻ ഡിപ്പാർട്ട്മെൻ്റ്, ട്രിവാൻഡ്രം  റെയിൻബോ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/11-01-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ പാലോട്",
      location: "പച്ച റെസിഡൻസ് വെൽഫെയർ സൊസൈറ്റി ഹാൾ, പാലോട്.",
      date: "11/01/2023",
      discription:
        "പാലോട് പച്ച റെസിഡൻസ് വെൽഫെയർ സൊസൈറ്റി, കേരളാ കൗമുദി ബോധപൗർണമി ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/10-31-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ ആനയറ",
      location: "സ്വിഫ്റ്റ് ഓഫീസ് ആനയറ.",
      date: "10/31/2023",
      discription:
        "KSRTC  ആരംഭിച്ച ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 100-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/10-29-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ കല്ലിയൂർ",
      location: "ഡോ:ഹെഡ്ഗേവാർ സ്മാരക ഹാൾ,വളളംകോട്,കല്ലിയൂർ.",
      date: "10/29/2023",
      discription:
        "വള്ളംകോട് വിവേകാനന്ദ റെസിഡൻഷ്യൽ അസോസിയേഷൻൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/10-29-2023-1.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ പേയാട്",
      location: "എൽ പി എസ് സ്ക്കൂൾ, പേയാട്",
      date: "10/29/2023",
      discription:
        " പേയാട് കേരളാ വ്യാപാരി വ്യവസായി ഏകോപന സമിതിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/10-28-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ വട്ടപ്പാറ",
      location: "എൻ എസ് എസ് ഹാൾ, അമ്പലം നഗർ, വട്ടപ്പാറ.",
      date: "10/28/2023",
      discription:
        "വട്ടപ്പാറ ജവഹർ റൂറൽ സഹകരണ സംഘം,ട്രിവാൻഡ്രം നോർത്ത് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/10-27-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ ആനയറ",
      location: "സ്വിഫ്റ്റ് ഓഫീസ് ആനയറ.",
      date: "10/27/2023",
      discription:
        "KSRTC  ആരംഭിച്ച ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 100-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/10-26-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ മാർത്താണ്ഡം",
      location: "ബെതനി നവജീവൻ ഇൻസ്റ്റിറ്റ്യൂട്ട്,പുതുക്കട, മാർത്താണ്ഡം.",
      date: "10/26/2023",
      discription:
        "വെങ്കോട് ബെതനി നവജീവൻ ഇൻസ്റ്റിറ്റ്യൂട്ടിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/10-25-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ തൊളിക്കോട്",
      location: "അൽ - റിഫ പബ്ലിക് സ്കൂൾ ഓഡിറ്റോറിയം, തൊളിക്കോട്.",
      date: "10/25/2023",
      discription:
        "തൊളിക്കോട് അൽ - റിഫ പബ്ലിക് സ്കൂളിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/10-24-2023-1.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ പരശുവയ്ക്കൽ",
      location: "കുഴിഞ്ഞാൻവിള സി എസ് ഐ ചർച്ച് ഹാൾ, പരശുവയ്ക്കൽ.",
      date: "10/24/2023",
      discription:
        "പരശുവയ്ക്കൽ കുഴിഞ്ഞാൻവിള സി എസ് ഐ ചർച്ചിൻ്റെയും   നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/10-24-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ ആനയറ",
      location: "സ്വിഫ്റ്റ് ഓഫീസ് ആനയറ.",
      date: "10/24/2023",
      discription:
        "KSRTC  ആരംഭിച്ച ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 100-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/10-21-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ ഈസ്റ്റ് ഫോർട്ട്",
      location: "വിരകുപുരകോട്ട സ്കൂൾ, തകരപറമ്പ്. ഈസ്റ്റ് ഫോർട്ട്.",
      date: "10/21/2023",
      discription:
        "ഈസ്റ്റ് ഫോർട്ട് ഫോർട്ട് റെസിഡൻഷ്യൽ അസോസിയേഷൻ സിൽവർ ജൂബിലി ആഘോഷതിൻ്റെയ് ഭാഗമായി ട്രിവാൻഡ്രം ഫ്‌ളവർസ് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/10-20-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ നന്ദാവനം",
      location: " ഡി.എച്ച്.ക്യു ക്യാമ്പ്, നന്ദാവനം ",
      date: "10/20/2023",
      discription:
        "നന്ദാവനം പോലീസ് ലൈബ്രറി യൂണിറ്റ്, വിഴിഞ്ഞം ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/10-19-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ വിഴിഞ്ഞം",
      location: "സെയിന്റ് ഫ്രാൻസിസ് സെയിൽസ് സ്ക്കൂൾ, വിഴിഞ്ഞം.",
      date: "10/19/2023",
      discription:
        "വിഴിഞ്ഞം സെൻ്റ് ഫ്രാൻസിസ് സെയിൽസ് പബ്ലിക് സ്ക്കൂളിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/10-17-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ തൊളിക്കോട്",
      location: "അൽ - റിഫ പബ്ലിക് സ്കൂൾ ഓഡിറ്റോറിയം, തൊളിക്കോട്.",
      date: "10/17/2023",
      discription:
        "തൊളിക്കോട് അൽ - റിഫ പബ്ലിക് സ്കൂളിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/10-15-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ പയറ്റുവിള",
      location: "സി എസ് ഐ ചർച്ച് ഹാൾ,പയറ്റുവിള",
      date: "10/15/2023",
      discription:
        "പയറ്റുവിള സി എസ് ഐ ചർച്ചിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/10-14-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ ആയൂർ",
      location: "പെരിങ്ങളളൂർ ഗവ: യൂ.പി സ്ക്കൂൾ,ആയൂർ.",
      date: "10/14/2023",
      discription:
        " പെരുങ്ങള്ളൂർ മാർത്തോമ ഇടവക സീനിയർ സിറ്റിസൺ ഫെല്ലോഷിപ്പ്, ആയൂർ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/10-13-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ ചടയമംഗലം",
      location: "ഹരിശ്രീ ഹോസ്പിറ്റൽ,ചടയമംഗലം.",
      date: "10/13/2023",
      discription:
        "ചടയമംഗലം ജഡയു ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/10-12-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ ആലക്കോട്, ആറ്റിങ്ങൽ",
      location: "ദാറുൽ ഇർഷാദ് ഇസ്ലാമിക് അക്കാദമി, ആലക്കോട്, ആറ്റിങ്ങൽ.",
      date: "10/12/2023",
      discription:
        "ആലംകോട് ദാറുൽ ഇർഷാദ് ഇസ്ലാമിക് അക്കാദമിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/10-11-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ ഇടപഴിഞ്ഞി",
      location: "ശ്രീ ബാലസുബ്രഹ്മണ്യ ക്ഷേത്ര ഓഡിറ്റോറിയം,ഇടപഴിഞ്ഞി. ",
      date: "10/11/2023",
      discription:
        "ഇടപഴഞ്ഞി കൊച്ചാർ റോഡ് റെസിഡൻഷ്യൽ അസോസിയേഷൻ, ട്രിവാൻഡ്രം റോയൽ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/10-10-2023-1.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ പോത്തൻക്കോട്",
      location: "കീഴാവൂർ സംസ്കാരിക നിലയം, പോത്തൻക്കോട്. ",
      date: "10/10/2023",
      discription:
        "പോത്തൻക്കോട് വൈഗ സാംസ്കാരിക സമിതിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/10-10-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ പ്രാവിച്ചമ്പലം",
      location: "സ്വാതി നഗർ, മൊട്ടമ്മൂട്, പ്രാവിച്ചമ്പലം",
      date: "10/10/2023",
      discription:
        "പാപ്പന്നൂർ നാഗരാജ സേവാ സമിതി,ട്രിവാൻഡ്രം പ്ലാറ്റിനം ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/10-08-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ പശുകോട്ടുക്കോണം",
      location: "സി എസ് ഐ ചർച്ച് ഓഡിറ്റോറിയം, പശുകോട്ടുക്കോണം ",
      date: "10/08/2023",
      discription:
        "കരകുളം സ്നേഹ റെസിഡൻഷ്യൽ അസോസിയേഷൻ,ട്രിവാൻഡ്രം എലൈറ്റ് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/10-08-2023-1.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ ചെറുവാളം",
      location: " സെവൻത് ഡേ അഡ്വൻ്റിസ്റ്റ് ചർച്ച്, ചെറുവാളം.",
      date: "10/08/2023",
      discription:
        "പബ്ലിക്ക് ക്യാമ്പസ് മിനിസ്ട്രി, ചെറുവളം  സെവൻത് ഡേ അഡ്വൻ്റിസ്റ്റ് സ്കൂളിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/10-07-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ വഴുതക്കാട്",
      location: "കാർമൽ സ്കൂൾ ഓഡിറ്റോറിയം, വഴുതക്കാട്.",
      date: "10/07/2023",
      discription:
        "വഴുതക്കാട് കാർമൽ സ്ക്കൂൾ ഗ്രാൻഡ് പരെൻ്റ്സ് ഡേ ഭാഗമായി നിംസ് മൈക്രോ ക്ലിനിക്ക് ആൻഡ് വത്സലാ നഴ്സിംഗ് ഹോമിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/10-06-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ പുല്ലുവിള",
      location: "ബീച്ച് ഗ്രൗണ്ട്, പുല്ലുവിള. ",
      date: "10/06/2023",
      discription:
        "പുല്ലുവിള വിജയ് ഫാൻസ് അസോസിയേഷൻൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/10-05-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ നെടുമങ്ങാട്",
      location: "ചുളളാളം പളളിമുക്ക് ഹാൾ, നെടുമങ്ങാട്.",
      date: "10/05/2023",
      discription:
        "ചുള്ളാളം കെ എമ്മ് എഫ് വൈ കനിവ് പള്ളിമുക്ക് യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/10-04-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ പാലോട്",
      location: "നജരൻ ഹാൾ,തെന്നൂർ, പാലോട്.",
      date: "10/04/2023",
      discription:
        "തെന്നൂർ ഗ്രാമീണ ആർട്ട്സ് ആൻഡ് സ്പോർട്സ് ക്ലബ്ബ്,ട്രിവാൻഡ്രം നോവ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/10-02-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ കരകുളം",
      location: "അയണിക്കാട് ശ്രീ ഭദ്രകാളി ക്ഷേത്ര ഓഡിറ്റോറിയം, കരകുളം.",
      date: "10/02/2023",
      discription:
        "കരകുളം സ്നേഹ റെസിഡൻഷ്യൽ അസോസിയേഷൻ,ട്രിവാൻഡ്രം എലൈറ്റ് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/10-01-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ പള്ളിച്ചൽ",
      location: "ധനലക്ഷ്മി ഓഡിറ്റോറിയം, പള്ളിച്ചൽ.",
      date: "10/01/2023",
      discription:
        "പള്ളിച്ചൽ ഡിവൈഎഫ്ഐ യൂണിറ്റ്, വിഴിഞ്ഞം സീ പോർട്ട്  ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/09-30-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ നെയ്യാറ്റിൻകര",
      location: " ഹാപ്പി ഹോം ഓൾഡേജ് ഹോം, കവളാക്കുളം, നെയ്യാറ്റിൻകര.",
      date: "09/30/2023",
      discription:
        "കവളാക്കുളം ഹാപ്പി ഹോം ഓൾഡേജ് ഹോമിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/09-30-2023-1.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ ആറ്റിങ്ങൽ",
      location: " ജുമാ മസ്ജിദ് ഹാൾ, നഗരൂർ, ആറ്റിങ്ങൽ.",
      date: "09/30/2023",
      discription:
        "നഗരൂർ മുസ്‌ലിം ജുമാ മസ്ജിദ്, കടവിള റെസിഡൻഷ്യൽ അസോസിയേഷൻ, നഗരൂർ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/09-28-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ ബാലരാമപുരം",
      location: "സലാഫി വെൽഫെയർ സെൻ്റർ,വടക്കെവിള,ബാലരാമപുരം.",
      date: "09/28/2023",
      discription:
        "ബാലരാമപുരം വടക്കേവിള സലാഫി വെൽഫെയർ സെൻ്ററിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/09-27-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ ജഗതി",
      location: "ഗവ: ഹൈസ്കൂൾ, ജഗതി.",
      date: "09/27/2023",
      discription:
        " ജഗതി ഈശ്വര വിലാസം റെസിഡൻഷ്യൽ അസോസിയേഷൻ,ട്രിവാൻഡ്രം നോബിൾ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/09-26-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ നെയ്യാറ്റിൻകര",
      location: " മുനിസിപ്പൽ കോംപ്ലക്സ് അനെക്സ്, നെയ്യാറ്റിൻകര",
      date: "09/26/2023",
      discription:
        "നെയ്യാറ്റിൻകര മുനിസിപ്പാലിറ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ പി കെ രാജ്മോഹൻ (മുൻസിപ്പൽ ചെയർമാൻ). ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/09-25-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ കാട്ടാക്കട",
      location: "ഡേയിൽ വ്യൂ കോളേജ് ഓഫ് ഫാർമസി,പുനലാൽ,കാട്ടാക്കട.",
      date: "09/25/2023",
      discription:
        "പുനലാൽ ഡേയിൽ വ്യൂ കോളേജ് ഓഫ് ഫാർമസിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/09-24-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ വെള്ളറട",
      location: "സെവൻത് ഡേ അഡ്വൻ്റിസ്റ്റ് സ്കൂൾ,വെള്ളറട.",
      date: "09/24/2023",
      discription:
        "വെള്ളറട സെവൻത് ഡേ അഡ്വൻ്റിസ്റ്റ് ചർച്ച്, പബ്ലിക് ക്യാമ്പസ് മിനിസ്ട്രിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ സി കെ ഹരീന്ദ്രൻ (എം എൽ എ). ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/09-23-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ പ്രാവിച്ചമ്പലം",
      location: "സുജാ ഭവൻ, മൊട്ടമ്മൂട്, പ്രാവിച്ചമ്പലം ",
      date: "09/23/2023",
      discription:
        "പാപ്പന്നൂർ നാഗരാജ സേവാ സമിതി,ട്രിവാൻഡ്രം പ്ലാറ്റിനം ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/09-22-2023-1.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ മണക്കാട്",
      location: "ആനന്ദനിലയം,കുരിയാത്തി, മണക്കാട്.",
      date: "09/22/2023",
      discription:
        "കുരിയാത്തി ആനന്ദനിലയം,ട്രിവാൻഡ്രം ഇംപാക്ട് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/09-22-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ പോത്തൻകോട്",
      location: "സി എസ് ഐ സഭ ഹാൾ, പോത്തൻകോട്.",
      date: "09/22/2023",
      discription:
        "പോത്തൻകോട് സി എസ് ഐ ടൗൺ ചർച്ചിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/09-21-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ കാച്ചാണി",
      location: "എൻ എസ് എസ് മന്ദിരം,കാച്ചാണി",
      date: "09/21/2023",
      discription:
        "കാച്ചാണി റെസിഡൻഷ്യൽ അസോസിയേഷൻ,ട്രിവാൻഡ്രം സിറ്റി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/09-20-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ അടിമലത്തുറ",
      location: "ഫാത്തിമ മാതാ ചർച്ച്  ഹാൾ, അടിമലത്തുറ.",
      date: "09/20/2023",
      discription:
        "അടിമലത്തുറ ഫാത്തിമ മാതാ ചർച്ച്,ട്രിവാൻഡ്രം റോട്ടറി ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/09-18-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ പള്ളിച്ചൽ",
      location: "ഗുരുതീർഥം ഹാൾ, പള്ളിച്ചൽ.",
      date: "09/18/2023",
      discription:
        "സംസ്ഥാന ആരോഗ്യ വകുപ്പ്, പള്ളിച്ചൽ എസ് എൻ ഡ പി യൂണിറ്റ്, വിഴിഞ്ഞം സീ പോർട്ട് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/09-17-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ മുള്ളുവിള",
      location: " ക്രിസ്തുജയന്ദി പാരിഷ് ഹാൾ, മുള്ളുവിള",
      date: "09/17/2023",
      discription:
        "നെയ്യാറ്റിൻകര ഇൻ്റെഗ്രൽ ഡെവലപ്പ് സൊസൈറ്റി മുള്ളുവിള യൂണിറ്റ്,ട്രിവാൻഡ്രം ഗിംഗോ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/09-16-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ ആറ്റിങ്ങൽ",
      location: "തിനവിള തെക്കേതിൽ മാടൻവിള ദേവി ക്ഷേത്ര ഓഡിറ്റോറിയം, ആറ്റിങ്ങൽ.",
      date: "09/16/2023",
      discription:
        "തിനവിള തെക്കേതിൽ മാടൻവിള ദേവി ക്ഷേത്ര ട്രസ്റ്റ്, ആറ്റിങ്ങൽ പാലസ് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/09-14-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ ആനയറ",
      location: "സ്വിഫ്റ്റ് ഓഫീസ് ആനയറ.",
      date: "09/14/2023",
      discription:
        "KSRTC  ആരംഭിച്ച ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 100-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/09-11-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ കരമന",
      location: "അക്ഷയ നഗർ റെസിഡൻഷ്യൽ അസോസിയേഷൻ, കരമന.",
      date: "09/11/2023",
      discription:
        "കരമന എൻ എസ് എസ് കോളേജ് ഫോർ വിമൻസ് നാഷണൽ സർവീസ് സ്കീം, അക്ഷയ നഗർ റെസിഡൻഷ്യൽ അസോസിയേഷൻ,ട്രിവാൻഡ്രം റൈൻബോ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/09-09-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ പുളുങ്കുടി",
      location: "ആഴിമല ക്ഷേത്ര ഓഡിറ്റോറിയം, പുളുങ്കുടി.",
      date: "09/09/2023",
      discription:
        "ആഴിമല ശിവ ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/09-07-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ ആനയറ",
      location: "വേൾഡ് മാർക്കറ്റ്, ആനയറ.",
      date: "09/07/2023",
      discription:
        "ട്രിവാൻഡ്രം റീജൻസി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/09-06-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ കോവളം",
      location: "ദി ലീലാ കോവളം രാവിസ് റിസോർട്ട്, കോവളം ",
      date: "09/06/2023",
      discription:
        "വിഴിഞ്ഞം പ്രസ്സ് ക്ലബ്, ദി ലീലാ കോവളം രാവിസ് റിസോർട്ട് ഗ്രൂപ്പ്, വിഴിഞ്ഞം സീഫോർട്ട് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/09-05-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ നെടുമങ്ങാട്",
      location: "എൽ ഐ സി ഓഫീസ്, നെടുമങ്ങാട്.",
      date: "09/05/2023",
      discription:
        "ട്രിവാൻഡ്രം നോവ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/09-04-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ കോവളം",
      location: "ഉദയ സമുദ്ര റിസോർട്ട്,കോവളം.",
      date: "09/04/2023",
      discription:
        "വിഴിഞ്ഞം പ്രസ്സ് ക്ലബ്, ഉദയ സമുദ്ര റിസോർട്ട് ഗ്രൂപ്പ്, വിഴിഞ്ഞം സീഫോർട്ട് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/09-01-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ ചെങ്കൽ",
      location: "ഗാന്ധി മിത്ര മണ്ഡലം ഓഫീസ്, വലിയകുളം, ചെങ്കൽ.",
      date: "09/01/2023",
      discription:
        "വലിയകുളം ഗാന്ധി മിത്ര മണ്ഡലത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/08-31-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ നെല്ലിമ്മൂട്",
      location: "എസ് എൻ ഡി പി ഹാൾ,വേങ്ങപ്പൊറ്റ,നെല്ലിമ്മൂട്.",
      date: "08/31/2023",
      discription:
        "വേങ്കപ്പൊറ്റ എസ് എൻ ഡി പി യൂണിറ്റ് , വിഴിഞ്ഞം ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/08-30-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ നെല്ലിമ്മൂട്",
      location:
        "ബോധി ആർട്ട്സ് ആൻഡ് സ്പോർട്സ് ക്ലബ്ബ് ഓഫീസ്, കന്നറവിള, നെല്ലിമ്മൂട്.",
      date: "08/30/2023",
      discription:
        "കണ്ണറവിള ബോധി ആർട്ട്സ് ആൻഡ് സ്പോർട്സ് ക്ലബ്ബ്, വിഴിഞ്ഞം ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/08-28-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ പരശുവയ്ക്കൽ",
      location: "ഗൂഗിൾ ആർട്ട്സ് ഹാൾ, പരശുവയ്ക്കൽ.",
      date: "08/28/2023",
      discription:
        "പരശുവയ്ക്കൽ ഗൂഗിൾ ആർട്ട്സ് ആൻഡ് സ്പോർട്സ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/08-25-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ തത്തിയൂർ",
      location: "മാത പബ്ലിക് എൽ പി സ്കൂൾ, തത്തിയൂർ.",
      date: "08/25/2023",
      discription:
        "സക്ഷമാ കേരളാ യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/08-22-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ മുടവന്മുഗൽ",
      location: "ഉരൂട്ട് ,റെസിഡൻഷ്യൽ അസോസിയേഷൻ ഓഫീസ്, മുടവന്മുഗൽ.",
      date: "08/22/2023",
      discription:
        "മുടവൻമുഗൾ ഉരൂട്ട് റെസിഡൻഷ്യൽ അസോസിയേഷൻ,ട്രിവാൻഡ്രം സ്മാർട്ട് സിറ്റി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/08-20-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ വട്ടിയൂർക്കാവ്",
      location: "ശ്രീരാമകൃഷ്ണപുരം റെസിഡൻഷ്യൽ അസോസിയേഷൻ ഹാൾ, വട്ടിയൂർക്കാവ്.",
      date: "08/20/2023",
      discription:
        "വട്ടിയൂർക്കാവ് ശ്രീരാമകൃഷ്ണപുരം റെസിഡൻഷ്യൽ അസോസിയേഷൻ,വട്ടിയൂർക്കാവ് മോഡൽ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/08-19-2023(1).jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ മലച്ചാണി",
      location: "ചിൽഡ്രൻസ് ഹോം മലച്ചാണി",
      date: "08/19/2023",
      discription:
        "ക്രിസ്റ്റ്യൻ മിഷൻ സർവീസ് ചിൽഡ്രൻസ് ഹോം മലച്ചാണി നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/08-19-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ പഴയ ഉച്ചക്കട",
      location: "ശിശു മന്ദിരം, പാവറ ,പഴയ ഉച്ചക്കട.",
      date: "08/19/2023",
      discription:
        "ഐ പി സി തിരുവനന്തപുരം വെസ്റ്റ് സെൻ്റർ പി വൈ പി എയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/08-18-2023(1).jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ ആനയറ",
      location: "സ്വിഫ്റ്റ് ഓഫീസ് ആനയറ.",
      date: "08/18/2023",
      discription:
        " KSRTC  ആരംഭിച്ച ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 100-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/08-18-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ നന്ദൻക്കോട്",
      location: " സ്വരാജ് ഭവൻ, നന്ദൻക്കോട്.",
      date: "08/18/2023",
      discription:
        "നന്ദൻക്കോട് സ്വരാജ് ഭവൻ കലാ സാംസ്കാരിക വേദി,ട്രിവാൻഡ്രം റീജൻസി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/08-17-2023(1).jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ പേരൂർക്കട",
      location: "കോൺകോർഡിലിയ മിനി ഹാൾ, മന്നംമ്മൂല, പേരൂർക്കട.",
      date: "08/17/2023",
      discription:
        "ലൂതെറിൻ യൂത്ത് ഫെല്ലോഷിപ്പ് ട്രിവാൻഡ്രം സർക്കിളിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/08-17-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ വിതുര",
      location: "എസ് ജെ ആശുപത്രി, വിതുര.",
      date: "08/17/2023",
      discription:
        "വിതുര കാസക് ഓട്ടോ കൂട്ടയിമ, എസ് ജ ഹോസ്പിറ്റലിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/08-16-2023(1).jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ പേരൂർക്കട",
      location: "മിനി സിവിൽ സ്റ്റേഷൻ, കുടപ്പനക്കുന്ന്, പേരൂർക്കട.",
      date: "08/16/2023",
      discription:
        "കുടപ്പനക്കുന്ന് സിവിൽ സ്റ്റേഷൻ എംപ്ലോയീസ് അസോസിയേഷൻ,ട്രിവാൻഡ്രം മേജെസ്റ്റി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/08-16-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ കോവളം",
      location: "ക്രാഫ്റ്റ് വില്ലേജ്, കോവളം.",
      date: "08/16/2023",
      discription:
        "തിരുവനന്തപുരം സംസ്ഥാന ആരോഗ്യ വകുപ്പ്, കോവളം ക്രാഫ്റ്റ് വില്ലേജ് വെൽഫെയർ കമ്മിറ്റി, കോവളം സീ പോർട്ട് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/08-15-2023(1).jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ പിരായിമ്മൂട്",
      location: "ഇന്ദ്രപ്രസ്ഥാ ആർട്ട്സ് ആൻഡ് സ്പോർട്സ് ക്ലബ്,പിരായിമ്മൂട്.",
      date: "08/15/2023",
      discription:
        "ചിറ്റാക്കോട് ഇന്ദ്രപ്രസ്ഥാ ആർട്ട്സ് ആൻഡ് സ്പോർട്സ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/08-15-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ പൊറ്റയിൽ",
      location: "അരങ്ങിൽ വായനശാല,പൊറ്റയിൽ.",
      date: "08/15/2023",
      discription:
        "അയണിമൂട് പൗര സമിതിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/08-14-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ പോത്തൻക്കോട്",
      location:
        "സംസ്കൃതി സാംസ്കാരിക വേദി ലൈബ്രറി വാൾ,കാഞ്ഞിരംപാറ,പോത്തൻക്കോട്.",
      date: "08/14/2023",
      discription:
        "കാഞ്ഞമ്പറ സംസ്കൃതി സാംസ്കാരിക വേദിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/08-13-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ ആലംക്കോട്",
      location: " ഗവ:യൂ പി എസ് , ആലംക്കോട്.",
      date: "08/13/2023",
      discription:
        "ആറ്റിങ്ങൽ അറേബ്യൻ ഫാഷൻ ജൂവലറി, ആറ്റിങ്ങൽ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/08-12-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ വട്ടിയൂർക്കാവ്",
      location:
        "സെൻ്റ് ആൻ്റണിസ് മലങ്കര കത്തോലിക്കാ ചർച്ച്,മണലയം, വട്ടിയൂർക്കാവ്.",
      date: "08/12/2023",
      discription:
        "മലങ്കര കാത്തോലിക് അസോസിയേഷൻ,ട്രിവാൻഡ്രം കോസ്മോ പോളിറ്റൻ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/08-11-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ ആനയറ",
      location: "സ്വിഫ്റ്റ് ഓഫീസ് ആനയറ.",
      date: "08/11/2023",
      discription:
        " KSRTC  ആരംഭിച്ച ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 100-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/08-09-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ നെടുമങ്ങാട്",
      location:
        " തൃപ്പാതം സൈക്കോ സോഷ്യൽ റിഹാബിലിറ്റേഷൻ സെൻ്റർ,പഴകുറ്റി, നെടുമങ്ങാട്.",
      date: "08/09/2023",
      discription:
        "തൃപ്പാതം സൈക്കോ സോഷ്യൽ റിഹാബിലിറ്റേഷൻ സെൻ്റർ,തിരുവനന്തപുരം ഐകോൺസ് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/08-08-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ വിതുര",
      location: "തള്ളച്ചിറ റെസിഡൻഷ്യൽ ഹാൾ, വിതുര.",
      date: "08/08/2023",
      discription:
        "തള്ളച്ചിറ റെസിഡൻഷ്യൽ അസോസിയേഷൻ, വിതുര ജനമൈത്രി പോലീസിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/08-06-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ പേയാട്",
      location: "വിവേകാനന്ദ നഗർ റെസിഡൻഷ്യൽ അസോസിയേഷൻ ഹാൾ,പേയാട്.",
      date: "08/06/2023",
      discription:
        "വിവേകാനന്ദ നഗർ റെസിഡൻഷ്യൽ അസോസിയേഷൻ, തിരുമല ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/08-05-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ വിതുര",
      location: "ബോണക്കാട് എസ്റ്റേറ്റ് കമ്മ്യൂണിറ്റി ഹാൾ,വിതുര.",
      date: "08/05/2023",
      discription:
        "ബോണക്കാട് എസ്റ്റേറ്റ് തൊഴിലാളി ക്ഷേമ സംഘം, ട്രിവാൻഡ്രം എലൈറ്റ് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/08-04-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ ആനയറ",
      location: "സ്വിഫ്റ്റ് ഓഫീസ് ആനയറ.",
      date: "08/04/2023",
      discription:
        "KSRTC  ആരംഭിച്ച ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 100-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/08-02-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ ആനയറ",
      location: "സ്വിഫ്റ്റ് ഓഫീസ് ആനയറ.",
      date: "08/02/2023",
      discription:
        "KSRTC  ആരംഭിച്ച ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 100-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/07-30-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ കുലശേഖരം",
      location: "ഇൻഫൻ്റ് ജീസസ് കമ്മ്യൂണിറ്റി ഹാൾ,കോട്ടൂർക്കോണം, കുലശേഖരം",
      date: "07/30/2023",
      discription:
        "തിരുവട്ടാർ നോർത്ത് ബ്ലോക്ക് അമ്മ മക്കൾ മുന്നേറ്റ കഴകം, തമിഴ്നാട് ഗവ: ഹെൽത്ത് സ്കീമിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/07-29-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ ആനയറ",
      location: "സ്വിഫ്റ്റ് ഓഫീസ് ആനയറ.",
      date: "07/29/2023",
      discription:
        " KSRTC  ആരംഭിച്ച ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 100-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/07-27-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ അട്ടക്കുളങ്ങര",
      location: "കെ.എസ്.ആർ ടി സി സ്റ്റാഫ് ട്രയിനിംഗ്  സെൻ്റർ, അട്ടക്കുളങ്ങര.",
      date: "07/27/2023",
      discription:
        "കെ.എസ്.ആർ ടി സി സെൻട്രൽ യൂണിറ്റ്(17), ഹെച്ച് എൽ എൽ ലൈഫ് കെയർ യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/07-26-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ അട്ടക്കുളങ്ങര",
      location: "കെ.എസ്.ആർ ടി സി സ്റ്റാഫ് ട്രയിനിംഗ്  സെൻ്റർ, അട്ടക്കുളങ്ങര.",
      date: "07/26/2023",
      discription:
        "കെ.എസ്.ആർ ടി സി സെൻട്രൽ യൂണിറ്റ്(16), ഹെച്ച് എൽ എൽ ലൈഫ് കെയർ യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/07-25-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ അട്ടക്കുളങ്ങര",
      location: "കെ.എസ്.ആർ ടി സി സ്റ്റാഫ് ട്രയിനിംഗ്  സെൻ്റർ, അട്ടക്കുളങ്ങര.",
      date: "07/25/2023",
      discription:
        "കെ.എസ്.ആർ ടി സി സെൻട്രൽ യൂണിറ്റ്(15), ഹെച്ച് എൽ എൽ ലൈഫ് കെയർ യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/07-23-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ കരമന",
      location: "മുദ്ര റെസിഡൻഷ്യൽ അസോസിയേഷൻ ഹാൾ, കരമന ",
      date: "07/23/2023",
      discription:
        "മുദ്രാ നഗർ റെസിഡൻഷ്യൽ അസോസിയേഷൻ, ട്രിവാൻഡ്രം റീജൻസി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/07-22-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ വട്ടവിള",
      location: "സെൻ്റ് ജേക്കബ് ചർച്ച്,വട്ടവിള.",
      date: "07/22/2023",
      discription:
        "വട്ടവിള സെന്റ് ജേക്കബ് ഇടവകപള്ളി തിരുനാളിനോടനുബന്ധിച്ച് നിംസ് മെഡിസിറ്റി യുടെ ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ   ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി, ഡയബറ്റോളജി, ഓങ്കോളജി, ഗ്യാസ്ട്രോളജി, ഓർത്തോപീഡിക്സ് , ഇ എൻ റ്റി , ഓഫ്താൻമോളജി, ഡെന്റൽ ,പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/07-20-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ അട്ടക്കുളങ്ങര",
      location: "കെ.എസ്.ആർ ടി സി സ്റ്റാഫ് ട്രയിനിംഗ്  സെൻ്റർ, അട്ടക്കുളങ്ങര.",
      date: "07/20/2023",
      discription:
        "കെ.എസ്.ആർ ടി സി സെൻട്രൽ യൂണിറ്റ്(13), ഹെച്ച് എൽ എൽ ലൈഫ് കെയർ യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/07-19-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ അട്ടക്കുളങ്ങര",
      location: "കെ.എസ്.ആർ ടി സി സ്റ്റാഫ് ട്രയിനിംഗ്  സെൻ്റർ, അട്ടക്കുളങ്ങര.",
      date: "07/19/2023",
      discription:
        "കെ.എസ്.ആർ ടി സി സെൻട്രൽ യൂണിറ്റ്(12), ഹെച്ച് എൽ എൽ ലൈഫ് കെയർ യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/07-18-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ അട്ടക്കുളങ്ങര",
      location: "കെ.എസ്.ആർ ടി സി സ്റ്റാഫ് ട്രയിനിംഗ്  സെൻ്റർ, അട്ടക്കുളങ്ങര.",
      date: "07/18/2023",
      discription:
        "കെ.എസ്.ആർ ടി സി സെൻട്രൽ യൂണിറ്റ്(11), ഹെച്ച് എൽ എൽ ലൈഫ് കെയർ യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/07-13-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ അട്ടക്കുളങ്ങര",
      location: "കെ.എസ്.ആർ ടി സി സ്റ്റാഫ് ട്രയിനിംഗ്  സെൻ്റർ, അട്ടക്കുളങ്ങര.",
      date: "07/13/2023",
      discription:
        "കെ.എസ്.ആർ ടി സി സെൻട്രൽ യൂണിറ്റ്(10), ഹെച്ച് എൽ എൽ ലൈഫ് കെയർ യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/07-12-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ അട്ടക്കുളങ്ങര",
      location: "കെ.എസ്.ആർ ടി സി സ്റ്റാഫ് ട്രയിനിംഗ്  സെൻ്റർ, അട്ടക്കുളങ്ങര.",
      date: "07/12/2023",
      discription:
        "കെ.എസ്.ആർ ടി സി സെൻട്രൽ യൂണിറ്റ്(9), ഹെച്ച് എൽ എൽ ലൈഫ് കെയർ യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/07-11-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ അട്ടക്കുളങ്ങര",
      location: "കെ.എസ്.ആർ ടി സി സ്റ്റാഫ് ട്രയിനിംഗ്  സെൻ്റർ, അട്ടക്കുളങ്ങര.",
      date: "07/11/2023",
      discription:
        "കെ.എസ്.ആർ ടി സി സെൻട്രൽ യൂണിറ്റ്(8), ഹെച്ച് എൽ എൽ ലൈഫ് കെയർ യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/07-09-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ വെടിവച്ചാൻകോവിൽ",
      location: "വെടിവച്ചാൻകോവിൽ ഭൂതമ്മൻ ക്ഷേത്ര ഓഡിറ്റോറിയം",
      date: "07/09/2023",
      discription:
        "വെടിവച്ചാൻകോവിൽ റെസിഡൻഷ്യൽ അസോസിയേഷൻ,ബാലരാമപുരം ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു .ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/07-08-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ ഇടയ്ക്കോട്",
      location: "ഇടയ്ക്കോട് എൻ എസ് എസ് ഹാൾ",
      date: "07/08/2023",
      discription:
        "ഇടയ്ക്കോട് വിവേകാനന്ദാ സേവാ സമിതി, ക്രിസ്റ്റ്ൽ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു..ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/07-06-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ അട്ടക്കുളങ്ങര",
      location: "കെ.എസ്.ആർ ടി സി സ്റ്റാഫ് ട്രയിനിംഗ്  സെൻ്റർ, അട്ടക്കുളങ്ങര.",
      date: "07/06/2023",
      discription:
        "കെ.എസ്.ആർ ടി സി സെൻട്രൽ യൂണിറ്റ്(7), ഹെച്ച് എൽ എൽ ലൈഫ് കെയർ യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/07-05-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ അട്ടക്കുളങ്ങര",
      location: "കെ.എസ്.ആർ ടി സി സ്റ്റാഫ് ട്രയിനിംഗ്  സെൻ്റർ, അട്ടക്കുളങ്ങര.",
      date: "07/05/2023",
      discription:
        "കെ.എസ്.ആർ ടി സി സെൻട്രൽ യൂണിറ്റ്(6), ഹെച്ച് എൽ എൽ ലൈഫ് കെയർ യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/07-04-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ അട്ടക്കുളങ്ങര",
      location: "കെ.എസ്.ആർ ടി സി സ്റ്റാഫ് ട്രയിനിംഗ്  സെൻ്റർ, അട്ടക്കുളങ്ങര.",
      date: "07/04/2023",
      discription:
        "കെ.എസ്.ആർ ടി സി സെൻട്രൽ യൂണിറ്റ്(5), ഹെച്ച് എൽ എൽ ലൈഫ് കെയർ യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/07-01-2023(1).jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @  പാലിയോട്",
      location: " സി എസ് ഐ ചർച്ച് ഹാൾ,മണലുവിള,പാലിയോട്.",
      date: "07/01/2023",
      discription:
        "മണലുവിള സി എസ് ഐ ചർച്ചിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/07-01-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ ആഴിമല",
      location: "ആഴിമല ശിവക്ഷേത്ര ഓഡിറ്റോറിയം",
      date: "07/01/2023",
      discription:
        "ദേശീയ ്് ഡോക്ടഴ്സ ഡേ  വിഴിഞ്ഞം ലയൺസ് ക്ലബ്ബിന്റെയും ആഴിമല ശിവക്ഷേത്ര ദേവസ്വം ട്രസ്റ്റിന്റെയും വിഴിഞ്ഞം ജനമൈത്രി പോലീസിന്റെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ നെയ്യാറ്റിൻകര നിംസ് മെഡിസിറ്റി എന്നിവരുടെ സഹകരണത്തോടെ ആഴിമല ശിവക്ഷേത്ര ഓഡിറ്റോറിയത്തിൽ മെഗാ മെഡിക്കൽ ക്യാമ്പും, ഡയബെറ്റിസ് ഡീറ്റെക്ഷൻ ക്യാമ്പും, നേത്ര പരിശോധനയും തിമിര ശാസ്ത്രക്രിയ ക്യാമ്പും ആയുർവേദ ക്യാമ്പും സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/06-30-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @  പേയാട്",
      location: "ശ്രീ ഭജന മഠം റെസിഡൻഷ്യൽ അസോസിയേഷൻ, പേയാട് ",
      date: "06/30/2023",
      discription:
        "പേയാട് ശ്രീ ഭജന മഠം റെസിഡൻഷ്യൽ അസോസിയേഷന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/06-29-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @  വിതുര",
      location: "എം ആർ എ റെസിഡൻഷ്യൽ ഹാൾ,മേമ്മല, വിതുര.",
      date: "06/29/2023",
      discription:
        "വിതുര ജനമൈത്രി പോലീസിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/06-28-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @  അട്ടക്കുളങ്ങര",
      location: "കെ.എസ്.ആർ ടി സി സ്റ്റാഫ് ട്രയിനിംഗ്  സെൻ്റർ, അട്ടക്കുളങ്ങര.",
      date: "06/28/2023",
      discription:
        "കെ.എസ്.ആർ ടി സി സെൻട്രൽ യൂണിറ്റ്(4), ഹെച്ച് എൽ എൽ ലൈഫ് കെയർ യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/06-24-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @  പുന്നക്കുളം",
      location: "ചിന്നംവിള കമ്മ്യൂണിറ്റി ഹാൾ, പുന്നക്കുളം.",
      date: "06/24/2023",
      discription:
        "കോട്ടുകാൽ ഗ്രാമ പഞ്ചായത്ത്, നിംസ് നാനോ ക്ലിനിക്കിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/06-23-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @  അട്ടക്കുളങ്ങര",
      location: "കെ.എസ്.ആർ ടി സി സ്റ്റാഫ് ട്രയിനിംഗ്  സെൻ്റർ, അട്ടക്കുളങ്ങര.",
      date: "06/23/2023",
      discription:
        "കെ.എസ്.ആർ ടി സി സെൻട്രൽ യൂണിറ്റ്(3), ഹെച്ച് എൽ എൽ ലൈഫ് കെയർ യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/06-21-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @  പേരൂർക്കട",
      location: "ഭാരത് ഗാർഡൻസ് ബിൽഡിംഗ്, കരകുളം, പേരൂർക്കട.",
      date: "06/21/2023",
      discription:
        " കരകുളം ഭരത്ത് ഗാർഡൻസ് ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/06-19-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @  ഊരുട്ടുക്കാല",
      location: "ജി ആർ ഓഡിറ്റോറിയം, ഊരുട്ടുക്കാല.",
      date: "06/19/2023",
      discription:
        "ഊരുട്ടുക്കാല ജി അർ ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു .ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/06-18-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @  തിരുപുറം",
      location: "ശോഭാ ഓഡിറ്റോറിയം, തിരുപുറം .",
      date: "06/18/2023",
      discription:
        "സക്ഷമ കേരളം, തിരുപുറം ഗ്രാമ പഞ്ചായത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/06-17-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @  അട്ടക്കുളങ്ങര",
      location: "കെ.എസ്.ആർ ടി സി സ്റ്റാഫ് ട്രയിനിംഗ്  സെൻ്റർ, അട്ടക്കുളങ്ങര.",
      date: "06/17/2023",
      discription:
        "കെ.എസ്.ആർ ടി സി സെൻട്രൽ യൂണിറ്റ്(2), ഹെച്ച് എൽ എൽ ലൈഫ് കെയർ യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/06-15-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @  കോവളം",
      location: "പനത്തുറ മുസ്ലീം ജുമാ മസ്ജിദ് മദ്രസ ഹാൾ, കോവളം.",
      date: "06/15/2023",
      discription:
        "പനത്തുറ മുസ്ലീം ജുമാ മസ്ജിദ്, സേവ് പ്രൊട്ടക്ഷൻ കെയർ ഫോർ പബ്ലിക്ക് ചാരിറ്റബിൾ സൊസൈറ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/06-14-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @  തക്കല",
      location: "ഗവ: പ്രൈമറി സ്കൂൾ,കാരവിളൈയ്,തക്കല.",
      date: "06/14/2023",
      discription:
        "നൂറുൽ ഇസ്‌ലാം യൂണിവേഴ്സിറ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/06-11-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @  വട്ടിയൂർക്കാവ്",
      location: "പഴയ ജുമാമസ്ജിദ് ഹാൾ, വട്ടിയൂർക്കാവ്.",
      date: "06/11/2023",
      discription:
        "വട്ടിയൂർക്കാവ് ജുമാ അത്ത് , ഇൻഡക്സ് നെക്സാ മോട്ടേഴ്‌സിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/06-10-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @  നെടുമങ്ങാട്",
      location: "എസ് കെ വി യൂ  പി എസ്, മുതുവിള, നെടുമങ്ങാട്.",
      date: "06/10/2023",
      discription:
        "മുതുവിള റെസിഡൻഷ്യൽ അസോസിയേഷൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പും ക്യാൻസർ ബോധവൽക്കരണവും സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/06-04-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @  തിരുവട്ടാർ",
      location: "സി എസ് ഐ ചർച്ച് ഹാൾ, തിരുവരമ്പ്, തിരുവട്ടാർ.",
      date: "06/04/2023",
      discription:
        "വൈ എം സി എ തിരുവരമ്പ്, സി എസ് ഐ ചർച്ച് തിരുവരമ്പു യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു..ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന,എക്കോ, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/05-31-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @  പേയാട്",
      location: "ബ്രദേഴ്സ് ആർക്കെയിഡ്,കാട്ടുവിള,പേയാട്.",
      date: "05/31/2023",
      discription:
        "പേയാട് ശ്രേയസ്സ് ന്യായവില ഫാർമസിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീമതി ലില്ലി മോഹൻ (പ്രസിഡൻ്റ് വിളപ്പിൽശാല ഗ്രാമ പഞ്ചായത്ത്) ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },

    {
      cardImage: "assets/img/Pastevents/05-28-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @  ശംഖുമുഖം",
      location: "തോപ്പ് സെൻ്റ് റോക്ക്സ് ഹൈസ്കൂൾ,ശംഖുമുഖം.",
      date: "05/28/2023",
      discription:
        "കനൽ ചാരിറ്റബിൾ സൊസൈറ്റി,മാർ ഡയസ്കോറസ് കോളേജ് ഓഫ് ഫാർമസി എൻ എസ് എസ് യൂണിറ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },

    {
      cardImage: "assets/img/Pastevents/05-27-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @  മരുതംക്കോട്",
      location: "വാർഡ് കമ്മിറ്റി ഓഫീസ്,മരുതംക്കോട്.",
      date: "05/27/2023",
      discription:
        "മരുതംക്കോട് യൂത്ത് കോൺഗ്രസ് വാർഡ് കമ്മിറ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/05-25-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @  പരശുവയ്ക്കൽ",
      location:
        "ഇടനാട്ടുക്കോണം ശ്രീ ധർമ്മ ശാസ്താ ക്ഷേത്ര ഓഡിറ്റോറിയം, പരശുവയ്ക്കൽ.",
      date: "05/25/2023",
      discription:
        "ഇടനാട്ടുക്കോണം ശ്രീ ധർമ്മ ശാസ്താ ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/05-24-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @  പിരായിമ്മൂട്",
      location: "എൽ & റ്റി കൺസ്ട്രക്ഷൻ ഓഫീസ്,പിരായിമ്മൂട്.",
      date: "05/24/2023",
      discription:
        "എൽ & റ്റി കൺസ്ട്രക്ഷൻ കമ്പനിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/05-20-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @  കൊണ്ണിയൂർ",
      location:
        "ക്രൈസ്റ്റ് അംബാസിഡേർസ് അസംബ്ലിസ് ഓഫ് ഹെബ്രോൻ ചർച്ച്,കൊണ്ണിയൂർ.",
      date: "05/20/2023",
      discription:
        "കൊണ്ണിയൂർ ക്രൈസ്റ്റ് അംബാസിഡേർസ് അസംബ്ലിസ് ഓഫ് ഹെബ്രോൻ ചർച്ച്,നെടുമങ്ങാട് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/05-19-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @  കരമന ",
      location: "നാടാർ സമാജം ഹാൾ,നെടുങ്കാട്,കരമന.",
      date: "05/19/2023",
      discription:
        "കരമന സോമൻ സ്മാരക ചാരിറ്റബിൾ സൊസൈറ്റി,വൈ.എം സി ട്രിവാൻഡ്രം മെജസ്റ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/05-18-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @  ഈസ്റ്റ് ഫോർട്ട് ",
      location: " പവർ ഹൗസ് ഓഫീസ്, ഈസ്റ്റ് ഫോർട്ട്.",
      date: "05/18/2023",
      discription:
        "കേരളാ സ്റ്റേറ്റ് ഇലക്ട്രിസിറ്റി ബോർഡ് എംപ്ലോയീസ് അസോസിയേഷൻൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ ആൻ്റണി രാജു (ബഹു ഗതാഗത വകുപ്പ് മന്ത്രി).ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/05-16-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ വിഴിഞ്ഞം ",
      location: " പഴയ അംബികാ തീയറ്റർ,തെന്നൂർക്കോണം, വിഴിഞ്ഞം.",
      date: "05/16/2023",
      discription:
        "തോട്ടിൻപ്പുറം റെസിഡൻഷ്യൽ അസോസിയേഷൻ, ചൈതന്യ റെസിഡൻഷ്യൽ അസോസിയേഷൻ,ട്രിവാൻഡ്രം സീഫോർട് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ എം വിൻസെൻ്റ് (എം എൽ എ കോവളം) ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/05-14-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ കണ്ണറവിള ",
      location: " കെ സി വൈ  എം ഹാൾ,കണ്ണറവിള.",
      date: "05/14/2023",
      discription:
        "കെ സി വൈ  എം കണ്ണറവിള യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/05-13-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ പാലിയോട് ",
      location: " കോരണംകോട് അനുഗ്രഹ ഗ്രന്ഥശാല ഹാൾ, പാലിയോട്.",
      date: "05/13/2023",
      discription:
        "പാലിയോട് അനുഗ്രഹാ ഗ്രന്ഥശാലയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, പ്രമേഹ പാദ   പരിശോധന, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/05-12-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ പുന്നക്കുളം  ",
      location: " തെങ്കവിള ദേവി ക്ഷേത്ര ഓഡിറ്റോറിയം.",
      date: "05/12/2023",
      discription:
        "പുന്നക്കുളം തെങ്കവിള ഓംകാര സോഷ്യൽ സർവീസ് ഓർഗനൈസേഷൻൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി,ഇ.എൻ റ്റി(കേൾവി പരിശോധന) ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/05-10-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ ബാലരാമപുരം ",
      location: " വിശ്വനാഥ് ഓഡിറ്റോറിയം,വഴിമുക്ക്, ബാലരാമപുരം.",
      date: "05/10/2023",
      discription:
        "മെയ്യ് 10 ബുധൻ രാവിലെ 09 മണിയ്ക്ക് വഴിമുക്ക് വിശ്വനാഥ് ഓഡിറ്റോറിയത്തിൽ  വച്ച് നടന്ന ചടങ്ങിൽ  എന്റെ ഹൃദയം എന്റെ ഗ്രാമം ; സൗജന്യ ഹൃദ്രോഗ നിർണ്ണയ മെഗാ ക്യാമ്പിന്റെയും ബോധവത്ക്കരണത്തിൻ്റെയും ഉദ്ഘാടനം ശ്രീമതി  അഡ്വ: എസ് കെ പ്രീജ(ബ്ലോക്ക് പഞ്ചായത്ത് പ്രസിഡൻ്റ്) നിർവഹിച്ചു. ശ്രി വി മോഹനൻ, ഗ്രാമപഞ്ചായത്ത് പ്രസിഡന്റ് അദ്ധ്യക്ഷത വഹിച്ച യോഗത്തിൽ രാഷ്ട്രീയ, സാമൂഹ്യ സാംസ്കാരിക രംഗത്തെ പ്രമുഖർ, ജനപ്രതിനിധികൾ തുടങ്ങിയവർ പങ്കെടുത്തു.  ക്യാമ്പിൽ 250-പ്പരം പേർ കാർഡിയോളജി  സ്ക്രീനീംഗന്  വിധേയമായി. ക്യാമ്പിൽ ഡയബറ്റോളജി, ജനറൽ മെഡിസിൻ,ഒഫ്ത്താൽമോളജി,ഡെൻറ്റൽ, സൗജന്യ എക്കോ, ഇ. സി. ജി, ബ്ലഡ് ഷുഗർ, ബ്ലഡ് പ്രഷർ, ബി എം ഐ ടെസ്റ്റുകൾ നടത്തി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/05-08-2023(1).jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ വിതുര ",
      location: "വിതുര ഫെസ്റ്റ്, വിതുര.",
      date: "05/08/2023",
      discription:
        "വിതുര ഫെസ്റ്റ് -2023ൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/05-08-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @  കുടപ്പനക്കുന്ന്",
      location: "ദേവി ക്ഷേത്ര ഓഡിറ്റോറിയം,കുടപ്പനക്കുന്ന്.",
      date: "05/08/2023",
      discription:
        "കുടപ്പനക്കുന്ന് , തിരുവനന്തപുരം നഗരസഭ സി ഡി സി -2 കുടുംബശ്രീ യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/05-07-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @  ചുളളിമാനൂർ",
      location: "സി എസ് ഐ ഇടവക അങ്കണം, ആട്ടുക്കാൽ,  ചുളളിമാനൂർ.",
      date: "05/07/2023",
      discription:
        "ചുള്ളിമാനൂർ ആട്ടുക്കാൽ സി എസ് ഐ ചർച്ചിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/05-05-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ ചിറയിൻകീഴ്",
      location: "മുസ്‌ലിയാർ കോളേജ് ഓഫ് എൻജിനീയറിങ്ങ്, ചിറയിൻകീഴ്.",
      date: "05/05/2023",
      discription:
        "ചിറയിൻകീഴ് മുസ്‌ലിയാർ കോളേജ് ഓഫ് എൻജിനീയറിങ്ങിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/05-02-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ വിഴിഞ്ഞം ",
      location: "ഡോ: എ പി ജെ പബ്ലിക് സ്കൂൾ,വിഴിഞ്ഞം.",
      date: "05/02/2023",
      discription:
        "വിഴിഞ്ഞം ചിറയിക്കോട് റെസിഡൻഷ്യൽ അസോസിയേഷൻ,റ്റി എം സി കൗടിയാർ, ഡോ: എ പി ജെ പബ്ലിക് സ്കൂളിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/05-01-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ പ്രാവിച്ചമ്പലം ",
      location: "ഇടയ്ക്കോട് കളത്തറക്കോണം കാവിൽ ദേവി ക്ഷേത്രം, പ്രാവിച്ചമ്പലം ",
      date: "05/01/2023",
      discription:
        " ഇടയ്ക്കോട് കളത്തറക്കോണം കാവിൽ ദേവി ക്ഷേത്ര ട്രസ്റ്റ് , രൈൻബോ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/04-30-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ പെരുമാതുറ ",
      location: "ഷംസുൽ ഇസ്ലാം  യു പി സ്കൂൾ,പെരുമാതുറ.",
      date: "04/30/2023",
      discription:
        " മാടൻവിള ഫുട്ബോൾ അസോസിയേഷൻ,അനന്തപുരി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/04-29-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ ചൊവ്വര ",
      location:
        "ചൊവ്വര തേക്കേക്കോണം നാഗർക്കാവ് ദുർഗ്ഗ ദേവി ക്ഷേത്ര ഓഡിറ്റോറിയം.",
      date: "04/29/2023",
      discription:
        "ചൊവ്വര തേക്കേക്കോണം നാഗർക്കാവ് ദുർഗ്ഗ ദേവി ക്ഷേത്ര ട്രസ്റ്റ്, വിഴിഞ്ഞം ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/04-28-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ മണ്ണടിക്കോണം ",
      location: "പീപ്പിൾസ് ലൈബ്രറി ഹാൾ,മണ്ണടിക്കോണം.",
      date: "04/28/2023",
      discription:
        " മണ്ണടിക്കോണം പീപ്പിൾസ് ലൈബ്രറി, ട്രിവാൻഡ്രം റൈൻബോ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/04-26-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ പളുകൽ ",
      location: "ശ്രീ വെട്ടുപാറ മേലാംക്കോട് ദേവി ക്ഷേത്ര ഓഡിറ്റോറിയം,പളുകൽ.",
      date: "04/26/2023",
      discription:
        " പളുകൽ ശ്രീ വെട്ടുപാറ മേലാംക്കോട് ദേവി ക്ഷേത്ര ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/04-23-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ കമുകിൻക്കോട് ",
      location: "സെൻ്റ് മേരീസ് എച്ച് എസ് എസ്,കമുകിൻക്കോട്",
      date: "04/23/2023",
      discription:
        "കമുകിൻകോട് ചങ്ങാതികൂട്ടം 97- എസ്എസ്എൽസി ബാച്ചിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. മെഡിക്കൽ ക്യാമ്പ് ഉദ്ഘാടനം റവ.ഫാ.സജി തോമസ്. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/04-21-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ വെള്ളറട ",
      location: "ആനപ്പാറ ഫോറസ്റ്റ് ഹാൾ,വെള്ളറട.",
      date: "04/21/2023",
      discription:
        "ആനപ്പാറ ഫോറസ്റ്റ് ഹാളിൽ വച്ച് നടന്ന ചടങ്ങിൽ  എന്റെ ഹൃദയം എന്റെ ഗ്രാമം ; സൗജന്യ ഹൃദ്രോഗ നിർണ്ണയ മെഗാ ക്യാമ്പിന്റെയും ബോധവത്ക്കരണത്തിൻ്റെയും ഉദ്ഘാടനം ശ്രീമതി അൻസജിത റസ്സേൽ (ജില്ലാ p പഞ്ചായത്ത് അംഗം) നിർവഹിച്ചു. ഗ്രാമപഞ്ചായത്ത് പ്രസിഡന്റ് അദ്ധ്യക്ഷത വഹിച്ച യോഗത്തിൽ രാഷ്ട്രീയ, സാമൂഹ്യ സാംസ്കാരിക രംഗത്തെ പ്രമുഖർ, ജനപ്രതിനിധികൾ തുടങ്ങിയവർ പങ്കെടുത്തു.  ക്യാമ്പിൽ 300-പ്പരം പേർ കാർഡിയോളജി  സ്ക്രീനീംഗന്  വിധേയമായി. ക്യാമ്പിൽ സൗജന്യ എക്കോ, ഇ. സി. ജി, ബ്ലഡ് ഷുഗർ, ബ്ലഡ് പ്രഷർ, ബി എം ഐ ടെസ്റ്റുകൾ നടത്തി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/04-17-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ ആനയറ ",
      location: "സ്വിഫ്റ്റ് ഓഫീസ് ആനയറ.",
      date: "04/17/2023",
      discription:
        "KSRTC  ആരംഭിച്ച ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 100-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/04-16-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ പ്ലാവറ ",
      location: "വേങ്കവിള എൻ എസ് എസ് ഹാൾ,പ്ലാവറ.",
      date: "04/16/2023",
      discription:
        "പിരപ്പൻകോട് കാവിയാട് ദിനകര പണിക്കർ സാംസ്കാരിക വേദിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/04-15-2023(1).jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ ആറാലുമ്മൂട് ",
      location: " ഐ സി ഡി അംഗൻവാടി, തലയിൽ, ആറാലുമ്മൂട്. ",
      date: "04/15/2023",
      discription:
        "ചാലിയോട് ശ്രീ അയ്യപ്പ സേവാ സംഘം,ശ്രീ മാളോട്ട് ശ്രീ ഭദ്രകാളി ദിക്ക്ബലി മഹോത്സവത്തോട് അനുബന്ധിച്ച് നിംസ് മെഡിസിറ്റിയുടെയും  ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/04-15-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ മാമ്പഴക്കര ",
      location: "എസ് എൻ നഗർ മാമ്പഴക്കര.",
      date: "04/15/2023",
      discription:
        "മാങ്കോട്ടുക്കോണം ഗുരു മന്ദിരത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/04-14-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ കള്ളിക്കാട് ",
      location: "ശ്രീ കാലാട്ട് മാടൻ തമ്പുരാൻ ക്ഷേത്ര ഓഡിറ്റോറിയം, കള്ളിക്കാട്.",
      date: "04/14/2023",
      discription:
        "കള്ളിക്കാട് ശ്രീ കാലാട്ട് മാടൻ തമ്പുരാൻ ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/04-12-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ ധനുവച്ചപുരം ",
      location: "മലങ്കര സിറിയൻ കാത്തോലിക് ചർച്ച്, ധനുവച്ചപുരം.",
      date: "04/12/2023",
      discription:
        "ധനുവച്ചപുരം മലങ്കര സിറിയൻ കാത്തോലിക് ചർച്ചിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/04-08-2023(1).jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ ഊരുട്ടമ്പലം ",
      location: "ഗോവിന്ദമംഗലം  സാംസ്കാരിക കേന്ദ്രം, ഊരുട്ടമ്പലം.",
      date: "04/08/2023",
      discription:
        "ഊരുട്ടമ്പലം മറുകിൽ വാർഡ്, തിരുവനന്തപുരം നോവ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/04-08-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ അമരവിള ",
      location: " ശ്രീ ഗണപതി ക്ഷേത്രം, മഞ്ഞാങ്കുഴി, അമരവിള.",
      date: "04/08/2023",
      discription:
        "മഞ്ഞംകുഴി ശ്രീ ഗണപതി ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/04-07-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ മഠത്തുവിളാകം ",
      location: "മഠത്തുവിളാകം റെസിഡൻഷ്യൽ അസോസിയേഷൻ MVRA -26.",
      date: "04/07/2023",
      discription:
        "മഠത്തുവിളാകം റെസിഡൻഷ്യൽ അസോസിയേഷൻ, പേരൂർക്കട ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/04-06-2023(1).jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ ആനാവൂർ ",
      location: "ആനാവൂർ ശ്രീ ഭദ്രകാളി ക്ഷേത്ര ഓഡിറ്റോറിയം.",
      date: "04/06/2023",
      discription:
        "ആനാവൂർ തൂലിക ഫുട്ബോൾ ക്ലബ്, ആനാവൂർ ശ്രീ ഭദ്രകാളി ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/04-06-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ മലയിൻകീഴ് ",
      location:
        "നീരോട്ടുക്കോണം ശ്രീ സുബ്രമണ്യസ്വാമി ക്ഷേത്ര ഓഡിറ്റോറിയം, അന്തിയൂർക്കോണം, മലയിൻകീഴ്.",
      date: "04/06/2023",
      discription:
        "നീരോട്ടുക്കോണം ശ്രീ സുബ്രമണ്യസ്വാമി ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/04-03-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ നിലമാമ്മൂട് ",
      location: "ഈശ്വരകാല ഭൂതത്താൻ ക്ഷേത്ര ഓഡിറ്റോറിയം, നിലമാമ്മൂട്",
      date: "04/03/2023",
      discription:
        "ആലറ ദേവി ക്ഷേത്ര ട്രസ്റ്റ്, സേവാ ഭാരതി നെയ്യാറ്റിൻകര യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/04-02-2023(1).jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ കരിക്കകം ",
      location: "കരിക്കകം ദേവി ക്ഷേത്രം.",
      date: "04/02/2023",
      discription:
        "കരിക്കകം പൊങ്കാല മഹോത്സവത്തോട് അനുബന്ധിച്ച് കരിക്കകത്തമ്മ സേവാ സമിതിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/04-02-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ ആലറ ",
      location: "ആലറ ദേവി ക്ഷേത്രം.",
      date: "04/02/2023",
      discription:
        "ആലറ ദേവി ക്ഷേത്ര ട്രസ്റ്റ്, സേവാ ഭാരതി നെയ്യാറ്റിൻകര യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/04-01-2023(1).jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ ഒറ്റശേഖരമംഗലം ",
      location: "ഗവ: എൽ പി സ്കൂൾ ഒറ്റശേഖരമംഗലം.",
      date: "04/01/2023",
      discription:
        "ആശുപത്രി സംരക്ഷണ സമിതിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/04-01-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ നന്ദിയോട് ",
      location: "പച്ച ശ്രീ ധർമ്മശാസ്താ ക്ഷേത്ര ഓഡിറ്റോറിയം, നന്ദിയോട്.",
      date: "04/01/2023",
      discription:
        "കേരളാ കൗമുദി പാലോട് യൂണിറ്റ്,ബോധപൗർണമി ക്ലബ്, പച്ച ശ്രീ ധർമ്മശാസ്താ ക്ഷേത്ര ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/03-31-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ വയ്യാക്കാവ് , നെടുമങ്ങാട്. ",
      location: "രുമൈക്സ മെമ്മോറിയൽ യു പി സ്കൂൾ, വയ്യാക്കാവ് , നെടുമങ്ങാട്.",
      date: "03/31/2023",
      discription:
        " വയ്യക്കാവ് രുമൈക്സ മെമ്മോറിയൽ യു പി സ്കൂളിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/03-28-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ കീഴാരൂർ ",
      location: "സരസ്വതി വിദ്യാലയം, കീഴാരൂർ. ",
      date: "03/28/2023",
      discription:
        "കീഴാരൂർ സരസ്വതി വിദ്യാലയത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/03-27-2023(2).jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ നെയ്യാറ്റിൻകര ",
      location: "നെയ്യാറ്റിൻകര ശ്രീകൃഷ്ണ സ്വാമി ക്ഷേത്രം",
      date: "03/27/2023",
      discription:
        "നെയ്യാറ്റിൻകര ശ്രീകൃഷ്ണ സ്വാമി ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ 18.03.2023 മുതൽ 27.03.2023 വരെ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൻ്റെ ഭാഗമായി ആയിരത്തിൽ പരം പേർക്ക് സൗജന്യ ബി പി, ബ്ലഡ് ഷുഗർ, ഡോക്ടർ കൺസൾട്ടിംഗ്, മരുന്ന് വിതരണം എന്നിവ നടത്തി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/03-27-2023(1).jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ കുന്നത്തുകാൽ ",
      location:
        "വറട്ടയം ഇലങ്കം ശ്രീ ചാമുണ്ഡേശ്വരി ദേവി ക്ഷേത്രം വറട്ടയം, കുന്നത്തുകാൽ. ",
      date: "03/27/2023",
      discription:
        "വറട്ടയം ഇലങ്കം ശ്രീ ചാമുണ്ഡേശ്വരി ദേവി ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/03-27-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ നെല്ലിമൂട് ",
      location: " ശ്രീ മുലയൻ താന്നി ദേവി ക്ഷേത്രം,നെല്ലിമൂട്.",
      date: "03/27/2023",
      discription:
        "നെല്ലിമൂട് ശ്രീ മുലയൻ താന്നി ദേവി ക്ഷേത്ര ട്രസ്റ്റ്, നെല്ലിമൂട് ബ്ലഡ് ഡൊണേഷ്സ് ഫോറത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ എം വിൻസൻ്റ് (ബഹു:എം എൽ എ കോവളം).ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/03-26-2023(1).jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ പോത്തൻകോട് ",
      location: "പിച്ചിമംഗലം ജംഗ്ഷൻ  പോത്തൻകോട്.",
      date: "03/26/2023",
      discription:
        "കാവിയാട് ദിനകര പണിക്കർ സാംസ്കാരിക വേദിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/03-26-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ കൂട്ടപ്പന ",
      location: "  ശ്രീ മഹാദേവ ക്ഷേത്ര ഓഡിറ്റോറിയം, കൂട്ടപ്പന. ",
      date: "03/26/2023",
      discription:
        " കൂട്ടപ്പന ശ്രീ മഹാദേവ ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/03-25-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ കരുമം ",
      location: "വിനായക ഓഡിറ്റോറിയം,കരുമം.",
      date: "03/25/2023",
      discription:
        "ഡി വൈ എഫ് ഐ പാപ്പനംകോട് യൂണിറ്റ്, അനന്തപുരി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/03-23-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ കൊല്ലങ്കോട് ",
      location: " ശ്രീ ഭദ്രകാളി ക്ഷേത്ര ഓഡിറ്റോറിയം,കൊല്ലങ്കോട്.",
      date: "03/20/2023",
      discription:
        "(മൂന്നാം ദിവസം) കൊല്ലങ്കോട് ശ്രീ ഭദ്രകാളി ക്ഷേത്ര ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/03-22-2023(1).jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ കൊല്ലങ്കോട് ",
      location: " ശ്രീ ഭദ്രകാളി ക്ഷേത്ര ഓഡിറ്റോറിയം,കൊല്ലങ്കോട്.",
      date: "03/22/2023",
      discription:
        "(രണ്ടാം ദിവസം) കൊല്ലങ്കോട് ശ്രീ ഭദ്രകാളി ക്ഷേത്ര ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/03-22-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ തോന്നയ്ക്കൽ ",
      location: "ഓട്ടോബൻ ട്രക്കിങ് കോർപറേഷൻ, തോന്നയ്ക്കൽ.",
      date: "03/22/2023",
      discription:
        "ഓട്ടോബൻ ട്രക്കിങ് കോർപറേഷൻ ലിമിറ്റഡിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/03-21-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ കൊല്ലങ്കോട് ",
      location: " ശ്രീ ഭദ്രകാളി ക്ഷേത്ര ഓഡിറ്റോറിയം,കൊല്ലങ്കോട്.",
      date: "03/21/2023",
      discription:
        "കൊല്ലങ്കോട് ശ്രീ ഭദ്രകാളി ക്ഷേത്ര ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ വെങ്ങാനൂർ സതീഷ് ( ജനറൽ സെക്രട്ടറി) മഹനീയ സാന്നിധ്യം ശ്രീ പപ്പൻ (കൊല്ലങ്കോട് വാർഡ് കൗൺസിലർ) ശ്രീമതി ജൂലിയറ്റ് (സർക്കിൾ ഇൻസ്പെക്ടർ നിദ്രവിള), ശ്രീ ശിവകുമാർ (ബിജെപി കുളത്തൂർ മണ്ഡലം പ്രസിഡണ്ട്) ശ്രീ എൻ കെ ശശി(ബിജെപി നെയ്യാറ്റിൻകര മണ്ഡലം പ്രസിഡണ്ട്).ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/03-20-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ പാലിയോട് ",
      location: "പാരിഷ് ഹാൾ,പാലിയോട്.",
      date: "03/20/2023",
      discription:
        "കുന്നത്തുക്കാൽ ഗ്രാമ പഞ്ചായത്തിലെ പാലിയോട് വാർഡിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ ജി ലാൽ കൃഷ്ണാ (പെരുംങ്കടവിള ഗ്രാമ പഞ്ചായത്ത് പ്രസിഡൻ്റ്).ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/03-19-2023.jpg",
      header: "സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് @ മാരായമുട്ടം ",
      location: "ഗവ: എൽ പി സ്കൂൾ,മാരായമുട്ടം.",
      date: "03/19/2023",
      discription:
        "ഗവ: എൽ പി സ്കൂൾ ഹാളിൽ വച്ച് നടന്ന ചടങ്ങിൽ  എന്റെ ഹൃദയം എന്റെ ഗ്രാമം ; സൗജന്യ ഹൃദ്രോഗ നിർണ്ണയ മെഗാ ക്യാമ്പിന്റെയും ബോധവത്ക്കരണത്തിൻ്റെയും ഉദ്ഘാടനം ശ്രീ സുരേന്ദ്രൻ (പെരുംക്കടവിള ഗ്രാമ പഞ്ചായത്ത് പ്രസിഡൻ്റ്) നിർവഹിച്ചു. ഗ്രാമപഞ്ചായത്ത് പ്രസിഡന്റ് അദ്ധ്യക്ഷത വഹിച്ച യോഗത്തിൽ രാഷ്ട്രീയ, സാമൂഹ്യ സാംസ്കാരിക രംഗത്തെ പ്രമുഖർ, ജനപ്രതിനിധികൾ തുടങ്ങിയവർ പങ്കെടുത്തു.  ക്യാമ്പിൽ 300-പ്പരം പേർ കാർഡിയോളജി  സ്ക്രീനീംഗന്  വിധേയമായി. ക്യാമ്പിൽ സൗജന്യ എക്കോ, ഇ. സി. ജി, ബ്ലഡ് ഷുഗർ, ബ്ലഡ് പ്രഷർ, ബി എം ഐ ടെസ്റ്റുകൾ നടത്തി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/03-17-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ കടയ്ക്കൽ ",
      location: "മങ്കാട് നിലമേൽ മുസ്‌ലിം ജുമാ മസ്ജിദ് അങ്കണം, കടയ്ക്കൽ.",
      date: "03/17/2023",
      discription:
        "മങ്കാട് നിലമേൽ മുസ്‌ലിം ജുമാ മസ്ജിദിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/03-16-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ കരകുളം ",
      location: "പി എ അസീസ് കോളേജ്, കരകുളം.",
      date: "03/16/2023",
      discription:
        "കരകുളം പി എ അസീസ് കോളേജിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/03-15-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ ആനയറ ",
      location: "സ്വിഫ്റ്റ് ഓഫീസ് ആനയറ.",
      date: "03/15/2023",
      discription:
        " KSRTC  ആരംഭിച്ച ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 100-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/03-14-2023(1).jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ പേട്ട ",
      location: "തിരുവനന്തപുരം നായർ സഹോദര സമാജം ഹാൾ, പേട്ട.",
      date: "03/14/2023",
      discription:
        "തിരുവനന്തപുരം നായർ സഹോദര സമാജം, അനന്തപുരി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ സൗജന്യ കാർഡിയോളജി, ഡയബറ്റോളജി, ജനറൽ മെഡിസിൻ,ഡെൻറ്റൽ, എന്നീ വിഭവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ ക്യാമ്പിന് നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/03-14-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ കല്ലറ ",
      location: "തോട്ടുംപുറം മുസ്‌ലിം ജുമാ മസ്ജിദ്,കല്ലറ.",
      date: "03/14/2023",
      discription:
        "തോട്ടുംപുറം മുസ്‌ലിം ജുമാ മസ്ജിദിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ സൗജന്യ കാർഡിയോളജി, ഡയബറ്റോളജി, ജനറൽ മെഡിസിൻ,ഡെൻറ്റൽ, എന്നീ വിഭവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ ക്യാമ്പിന് നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/03-13-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ നെടുമങ്ങാട് ",
      location: "പണയം ഗവ: എൽ പി സ്കൂൾ,പനവൂർ, നെടുമങ്ങാട്.",
      date: "03/13/2023",
      discription:
        "പണയം ഗവ: എൽ പി സ്കൂളിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ സൗജന്യ കാർഡിയോളജി, ഡയബറ്റോളജി, ജനറൽ മെഡിസിൻ,ഡെൻറ്റൽ, എന്നീ വിഭവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ ക്യാമ്പിന് നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/03-12-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ ഇരുകുന്നം ",
      location: "ഇരുകുന്നം റെസിഡൻ്റ്സ് വെൽഫെയർ അസോസിയേഷൻ ഹാൾ.",
      date: "03/12/2023",
      discription:
        "ഇരുകുന്നം റെസിഡൻ്റ്സ് വെൽഫെയർ അസോസിയേഷൻ,വട്ടിയൂർക്കാവ് മോഡൽ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ സൗജന്യ കാർഡിയോളജി, ഡയബറ്റോളജി, ജനറൽ മെഡിസിൻ,ഡെൻറ്റൽ, എന്നീ വിഭവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ ക്യാമ്പിന് നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/03-11-2023(1).jpg",
      header: "സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് @ മാരായമുട്ടം ",
      location: "ശ്രീ കരിയിലക്കുളങ്ങര ദേവി ക്ഷേത്ര ഓഡിറ്റോറിയം,മാരായമുട്ടം.",
      date: "03/11/2023",
      discription:
        "ആയയിൽ ശ്രീ കരിയിലക്കുളങ്ങര ദേവി ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ സൗജന്യ കാർഡിയോളജി, ഡയബറ്റോളജി, ജനറൽ മെഡിസിൻ,ഡെൻറ്റൽ, ആയൂർവേദ എന്നീ വിഭവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ ക്യാമ്പിന് നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/03-11-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ നെയ്യാറ്റിൻകര ",
      location: "അതുല്യ കോളേജ്, നെയ്യാറ്റിൻകര.",
      date: "03/11/2023",
      discription:
        "കേരളാ പോലീസ് പെൻഷനേഴ്സ് വെൽഫെയർ അസോസിയേഷൻ നെയ്യാറ്റിൻകര താലൂക്ക്  കമ്മറ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ സൗജന്യ കാർഡിയോളജി, ഡയബറ്റോളജി, ജനറൽ മെഡിസിൻ,ഡെൻറ്റൽ എന്നീ വിഭവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ ക്യാമ്പിന് നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/03-10-2023(1).jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ വാഴിച്ചൽ ",
      location: "മാരാവിള ദേവി ക്ഷേത്ര ഓഡിറ്റോറിയം,വാഴിച്ചൽ.",
      date: "03/10/2023",
      discription:
        "(2-ദിവസം)മാരാവിള ദേവീ ചാരിറ്റബിൾ ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ സൗജന്യ കാർഡിയോളജി, ഡയബറ്റോളജി, ജനറൽ മെഡിസിൻ,ഡെൻറ്റൽ എന്നീ വിഭവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ ക്യാമ്പിന് നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/03-10-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ തൈക്കാട് ",
      location: "പി എൻ പണിക്കർ ഫൗണ്ടേഷൻ ഹാൾ, തൈക്കാട്.",
      date: "03/10/2023",
      discription:
        "പി എൻ പണിക്കർ ഫൗണ്ടേഷൻൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ സൗജന്യ കാർഡിയോളജി, ഡയബറ്റോളജി, ജനറൽ മെഡിസിൻ,ഡെൻറ്റൽ എന്നീ വിഭവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ ക്യാമ്പിന് നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/03-09-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ വാഴിച്ചൽ ",
      location: "മാരാവിള ദേവി ക്ഷേത്ര ഓഡിറ്റോറിയം,വാഴിച്ചൽ.",
      date: "03/09/2023",
      discription:
        "മാരാവിള ദേവീ ചാരിറ്റബിൾ ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ സൗജന്യ കാർഡിയോളജി, ഡയബറ്റോളജി, ജനറൽ മെഡിസിൻ,ഡെൻറ്റൽ എന്നീ വിഭവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ ക്യാമ്പിന് നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/03-08-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ ചെമ്പൂര് ",
      location: "ചിലംബറ ദേവി ക്ഷേത്ര ഓഡിറ്റോറിയം, ചെമ്പൂര്.",
      date: "03/08/2023",
      discription:
        "ചെമ്പൂര് ചിലംബറ ദേവി ക്ഷേത്ര ട്രസ്റ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു .ക്യാമ്പിൽ സൗജന്യ കാർഡിയോളജി, ഡയബറ്റോളജി, ജനറൽ മെഡിസിൻ,ഡെൻറ്റൽ എന്നീ വിഭവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ ക്യാമ്പിന് നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/03-07-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ ആറ്റുകാൽ ",
      location: "ആറ്റുകാൽ",
      date: "03/07/2023",
      discription:
        "ആറ്റുകാൽ പൊങ്കാല മഹോത്സവത്തോട് അനുബന്ധിച്ച് നിംസ് മെഡിസിറ്റിയുടെ നേത്യത്വത്തിൽ തലസ്ഥാനത്തിൻ്റെ വിവിധ ഭാഗങ്ങളിൽ നടന്ന സൗജന്യ മെഡിക്കൽ  ക്യാമ്പിൽ മൂവായിരത്തോളം  പേർ ചികിത്സക്ക് വിധേയരായി.ഈ ക്യാമ്പ് വലിയ വിജയമാക്കാൻ ഞങ്ങളോട് സഹകരിച്ച വിവിധ സംഘടനകളോടുളള നന്ദിയും കടപ്പാടും അറിയിക്കുന്നു.ക്യാമ്പുകളുടെ സുഗമമായ നടത്തിപ്പിന് നേതൃത്വം നൽകിയ ഡോക്ടർമാരായ ഡേ: ജിജോ മാർട്ടിൻ, ഡേ: ഷഹീൻ, ഡേ: ആനന്ദ്, ഡേ: ദിലീപ്, ഡേ: അഡ്‌ലിൻ മേഴ്സി, ഡേ: അതുല്യ മോഹൻ, ഡേ: അഖിജ, ഡേ: ബ്ലസ്വിൻ, ഡേ: ഹസ്സൻ , ജോസ്ഫിൻ(വൈസ് പ്രിൻസിപ്പൽ നിംസ് നഴ്സിംഗ് കോളേജ്)നിംസ് നഴ്സിംഗ് സൂപ്രണ്ട് ദീപ്തി, നഴ്സിംഗ് ഓഫീസർമാരായായ അനു, സജിതാ, ശാലിനി,സൗമ്യ, അഷ്ലിൻ, ശരണ്യ, സ്റ്റാഫുകളായ ദിവ്യാ, രശ്മി,നിംസ് നഴ്സിംഗ്കോളേജ് വിദ്യാർഥികൾ, അനീഷ്(സന്നദ്ധസേവകൻ) ഡ്രൈവർമരായ ,സനൽ,കുമാർ,അനിൽകുമാർ, സാബു ഏവർക്കും നിംസ് മെഡിസിറ്റിയുടെ നന്ദി....",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/03-05-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ വിതുര ",
      location: "ദൈവപരിപാലന ദേവാലയം, വിതുര.",
      date: "03/05/2023",
      discription:
        "വിതുര ദൈവപരിപാലന ദേവാലയത്തിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു .ക്യാമ്പിൽ സൗജന്യ കാർഡിയോളജി, ഡയബറ്റോളജി, ജനറൽ മെഡിസിൻ,ഡെൻറ്റൽ എന്നീ വിഭവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ ക്യാമ്പിന് നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/03-05-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ ഉച്ചക്കട ",
      location: "വിശുദ്ധ അമ്മ ത്രേസ്യ ദേവാലയം,ഉച്ചക്കട.",
      date: "03/05/2023",
      discription:
        "ഇൻ്റെഗ്രൽ ഡെവലപ്പ്മെൻ്റ് സൊസൈറ്റി ഉച്ചക്കട യൂണിറ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ സൗജന്യ കാർഡിയോളജി, ഡയബറ്റോളജി, ജനറൽ മെഡിസിൻ,ഡെൻറ്റൽ എന്നീ വിഭവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ ക്യാമ്പിന് നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },

    {
      cardImage: "assets/img/Pastevents/03-04-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ നെയ്യാറ്റിൻകര ",
      location: "നെയ്യാറ്റിൻകര സർവ്വീസ് സഹകരണ ബാങ്ക് ആഡിറ്റോറിയം",
      date: "03/04/2023",
      discription:
        "ഭാരതീയ ജൻ ഔഷധി ദിനാചരണത്തോടനുബന്ധിച്ച് നെയ്യാറ്റിൻകര സർവ്വീസ് സഹകരണ ബാങ്കും നിംസ് മെഡിസിറ്റിയും സംയുക്തമായി സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ബാങ്ക് ആഡിറ്റോറിയത്തിൽ പ്രസിഡൻ്റ് ആർ നടരാജൻ്റെ അദ്ധ്യക്ഷതയിൽ നഗരസഭാ സ്ഥിരം സമിതി അദ്ധ്യക്ഷൻ കെ കെ ഷിബു ക്യാമ്പ് ഉൽഘാടനം ചെയ്തു. നഗരസഭാ കൗൺസിലർമാരായ മഞ്ചത്തല സുരേഷ്, ഗ്രാമം പ്രവീൺ, കല ടീച്ചർ, ബാങ്ക് ഭരണസമിതിയംഗങ്ങളായ എസ്. രാമചന്ദ്രൻ, ഡി അനിൽകുമാർ, സി ഗോപകുമാർ, എ ശ്രീകുമാരിയമ്മ, ടി ആർ ഗോപീകൃഷ്ണൻ,  ജലജകുമാരി, അംബി, സെക്രട്ടറി ആർ രാജേന്ദ്രൻ, അഡ്വ കൃഷ്ണദാസ്, ജി ഗോപീകൃഷ്ണൻ നായർ,  തുടങ്ങിയവർ സംസാരിച്ചു. സൗജന്യ മരുന്നുവിതരണവും വിവിധ പരിശോധനകളും നടന്ന ക്യാമ്പിൽ നിംസ് മെഡിസിറ്റിയിലെ ഡോക്ടർമാരും ജീവനക്കാരും നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/03-04-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ വേർക്കളബി ",
      location: "പഞ്ചായത്ത്  പ്രസിഡൻ്റ് ഓഫീസ്, കല്ലൻക്കുഴി,വേർക്കളബി.",
      date: "03/04/2023",
      discription:
        "തമിഴ്നാട് ഗവൺമെന്റ് മെഡിക്കൽ ഇൻഷുറൻസ് സ്കീം,ആറ്റൂർ യൂത്ത് കോൺഗ്രസ്സിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ സൗജന്യ കാർഡിയോളജി, ഡയബറ്റോളജി, ജനറൽ മെഡിസിൻ,ഡെൻറ്റൽ എന്നീ വിഭവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ ക്യാമ്പിന് നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/03-03-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ പോങ്ങിൻമൂട് ",
      location: "ബാപ്പുജി നഗർ മേരി നിലയം സീനിയർ സെക്കൻഡറി സ്കൂൾ,പോങ്ങിൻമൂട്.",
      date: "03/03/2023",
      discription:
        "ബാപ്പുജി നഗർ മേരി നിലയം സീനിയർ സെക്കൻഡറി സ്കൂൾ , തിരുവനന്തപുരം  ക്യാപിറ്റൽ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ സൗജന്യ കാർഡിയോളജി, ഡയബറ്റോളജി, ജനറൽ മെഡിസിൻ,ഡെൻറ്റൽ എന്നീ വിഭവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ ക്യാമ്പിന് നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/03-02-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ നെടുമങ്ങാട് ",
      location: "മുഹധിയീൻ ജുമാ മസ്ജിദ്, പനവൂർ നെടുമങ്ങാട്.",
      date: "03/02/2023",
      discription:
        "പനവൂർ മുഹിധിയീൻ മുസ്ലിം ജുമാ മസ്ജിദിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ സൗജന്യ കാർഡിയോളജി, ഡയബറ്റോളജി, ജനറൽ മെഡിസിൻ,ഡെൻറ്റൽ എന്നീ വിഭവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ ക്യാമ്പിന് നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/03-01-2023(1).jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ പാളയം ",
      location: "യൂണിവേഴ്സിറ്റി കോളേജ് ഓഡിറ്റോറിയം, പാളയം.",
      date: "03/01/2023",
      discription:
        "പാളയം യൂണിവേഴ്സിറ്റി കോളേജ് യൂണിയൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ സൗജന്യ കാർഡിയോളജി, ഡയബറ്റോളജി, ജനറൽ മെഡിസിൻ,ഡെൻറ്റൽ എന്നീ വിഭവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ ക്യാമ്പിന് നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/03-01-2023.jpg",
      header: "സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് @ ആനയറ ",
      location: "സ്വിഫ്റ്റ് ഓഫീസ് ആനയറ.",
      date: "03/01/2023",
      discription:
        "KSRTC  ആരംഭിച്ച ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 100-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/02-28-2023.jpg",
      header: "സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് @ തമ്പാനൂർ ",
      location: "മലയാള മനോരമ ഓഫീസ്,തമ്പാനൂർ.",
      date: "02/28/2023",
      discription:
        "(രണ്ടാം ദിവസം) തമ്പാനൂർ മലയാള മനോരമയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.150-തിൽപ്പരംമലയാള മനോരമ ജീവനക്കാരും ഏജൻ്റ്മാരും ക്യാമ്പിൻ്റെ ഭാഗമായി.ക്യാമ്പിൽ സൗജന്യ കാർഡിയോളജി, ഡയബറ്റോളജി, ജനറൽ മെഡിസിൻ,ഡെൻറ്റൽ എന്നീ വിഭവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ ക്യാമ്പിന് നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/02-27-2023(1).jpg",
      header: "സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് @ തമ്പാനൂർ ",
      location: "മലയാള മനോരമ ഓഫീസ്,തമ്പാനൂർ.",
      date: "02/27/2023",
      discription:
        "തമ്പാനൂർ മലയാള മനോരമയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.150-തിൽപ്പരംമലയാള മനോരമ ജീവനക്കാരും ഏജൻ്റ്മാരും ക്യാമ്പിൻ്റെ ഭാഗമായി.ക്യാമ്പിൽ സൗജന്യ കാർഡിയോളജി, ഡയബറ്റോളജി, ജനറൽ മെഡിസിൻ,ഡെൻറ്റൽ എന്നീ വിഭവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ ക്യാമ്പിന് നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/02-27-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ കുന്നിൽ ",
      location: "കുന്നിൽ ശ്രീ മേലാംക്കോട് ദേവി ക്ഷേത്രം .",
      date: "02/27/2023",
      discription:
        "പാങ്ങോട് സേവാ ഭാരതി, ശ്രീരാമ സേവാ സമിതി ജവഹർ കോളനി , ലയൺസ് ക്ലബ് ട്രിവാൻഡ്രം മെജസ്റ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/02-26-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ മലയിൻകീഴ് ",
      location: "കോൺഫിഡൻ്റ് പി എസ് സി കോച്ചിംഗ് സെൻ്റർ,മലയിൻകീഴ്.",
      date: "02/26/2023",
      discription:
        "മലയിൻകീഴ് കോൺഫിഡൻ്റ് പി എസ് സി കോച്ചിംഗ് സെൻ്ററിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/02-25-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ വിതുര ",
      location: "പൊടിയക്കാല സെറ്റിൽമെന്റ് കോളനി സാംസ്കാരിക നിലയം, വിതുര.",
      date: "02/25/2023",
      discription:
        "വിതുര ശിശു സൗഹൃദ ജനമൈത്രി പൊലീസ് സ്റ്റേഷൻൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു . ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/02-24-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ കാട്ടാക്കട ",
      location:
        "ആനാക്കോട് ശ്രീ ഭദ്രകാളി ക്ഷേത്ര ഓഡിറ്റോറിയം, വീരണകാവ്, കാട്ടാക്കട.",
      date: "02/24/2023",
      discription:
        "ആനാക്കോട് ശ്രീ ഭദ്രകാളി ക്ഷേത്ര ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/02-23-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ ആനയറ ",
      location: "സ്വിഫ്റ്റ് ഓഫീസ് ആനയറ.",
      date: "02/23/2023",
      discription:
        "KSRTC  ആരംഭിച്ച ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 100-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/02-22-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ മേൽപുറം ",
      location: "ഭജന മഠം അണ്ടുകോട്, മേൽപുറം ",
      date: "02/22/2023",
      discription:
        "അണ്ടുകോട്  ശ്രീ മുരുഗൻ കാവടി സംഘത്തിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/02-20-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ കുളത്തൂർ ",
      location: "ശ്രീ ഭദ്രകാളി ക്ഷേത്ര ഓഡിറ്റോറിയം,കുളത്തൂർ.",
      date: "02/20/2023",
      discription:
        "കുളത്തൂർ ശ്രീ ഭദ്രകാളി ക്ഷേത്ര ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/02-19-2023(1).jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ വിതുര ",
      location: "ശ്രീ മഹാദേവ ക്ഷേത്ര ഓഡിറ്റോറിയം,വിതുര.",
      date: "02/19/2023",
      discription:
        "വിതുര ശ്രീ മഹാദേവ ക്ഷേത്ര ട്രസ്റ്റ്, പാലോട് കേരളാ കൗമുദി യൂണിറ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/02-19-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ അഴകിയമണ്ഡപം ",
      location: "സെൻ്റ് മേരീസ് ചർച്ച്,കല്ലങ്കുഴി, അഴകിയമണ്ഡപം.",
      date: "02/19/2023",
      discription:
        "തമിഴ്നാട് ഗവൺമെൻ്റ് ഹെൽത്ത് ഇൻഷുറൻസ് സ്കീം, അഴകിയമണ്ടപം ക്രിസ്റ്റൽ ലാബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/02-18-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ ഭരതന്നൂർ ",
      location: "ശ്രീ മഹാദേവ ക്ഷേത്ര ഓഡിറ്റോറിയം,ഭരതന്നൂർ.",
      date: "02/18/2023",
      discription:
        "പാങ്ങോട് സേവാ ഭാരതി, ശ്രീരാമ സേവാ സമിതി ജവഹർ കോളനി , ലയൺസ് ക്ലബ് ട്രിവാൻഡ്രം മെജസ്റ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/02-17-2023.jpg",
      header: "സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് @ കമുകിൻക്കോട് ",
      location: "സെൻ്റ് ആൻ്റണിസ് ചർച്ച്,കമുകിൻക്കോട്.",
      date: "02/17/2023",
      discription:
        "ആരോഗ്യമേള-2023. കമുകിൻകോട് സെൻ്റ് ആൻ്റണിസ് ചർച്ചിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ ആരോഗ്യമേള സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി,ഗ്യാസ്ട്രാളജി,ഓർത്തോപീഡിക്കസ്, ഇ എൻ റ്റി, ഒഫ്ത്താൽമോളജി, ഡെൻ്റൽ, ആയുർവേദം എന്നി വിഭാവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.സൗ ജന്യ എക്കോ, ഇ സി ജി, പി എഫ് റ്റി,ഓട്ടിസം സ്ക്രീനിംഗ്, കുട്ടികളിലെ പഠനവൈകല്യം, കേൾവി പരിശോധന, ബ്ലഡ് ഷുഗർ, ബി പി, ബി എം ഐ ടെസ്റ്റുകൾ നടത്തി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/02-16-2023.jpg",
      header: "സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് @ നെയ്യാറ്റിൻകര ",
      location: "ലോഗോസ് പാസ്റ്ററൽ സെൻ്റർ,വ്ലാങാമുറി,നെയ്യാറ്റിൻകര.",
      date: "02/16/2023",
      discription:
        "നെയ്യാറ്റിൻകര ഇൻറ്റെഗ്രൽ ഡെവലപ്പ്മെൻ്റ് സൊസൈറ്റി - നിഡ്സോത്സവ്-2023 നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി, ഒഫ്ത്താൽമോളജി, ഡെൻ്റൽ, ആയുർവേദം എന്നി വിഭാവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.സൗ ജന്യ എക്കോ, ഇ സി ജി, പി എഫ് റ്റി,ഓട്ടിസം സ്ക്രീനിംഗ്, കുട്ടികളിലെ പഠനവൈകല്യം, കേൾവി പരിശോധന, ബ്ലഡ് ഷുഗർ, ബി പി, ബി എം ഐ ടെസ്റ്റുകൾ നടത്തി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/02-11-2023.jpg",
      header: "സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് @ തത്തിയൂർ ",
      location: "ശ്രീ ശിവ ഭഗവതി ക്ഷേത്ര ഓഡിറ്റോറിയം, തത്തിയൂർ.",
      date: "02/11/2023",
      discription:
        "തത്തിയൂർ ശ്രീ ശിവ ഭഗവതി ക്ഷേത്ര ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ ഡോ: ശ്രീജിത്ത് ( കാർഡിയോളജിസറ്റ് നിംസ് മെഡിസിറ്റി). ക്യാമ്പിൽ  ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/02-08-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ തോന്നയ്ക്കൽ ",
      location: "ഇ വി യൂപി സ്കൂൾ, തോന്നയ്ക്കൽ.",
      date: "02/08/2023",
      discription:
        "'മിഠായി' (5) ലോക പ്രമേഹ ദിനത്തോട് അനുബന്ധിച്ച് സ്ക്കൂൾ വിദ്യാർഥികളിലൂടെ പ്രമേഹ അവബോധം കുടുംബത്തിലേയ്ക്കും സമൂഹത്തിലേയ്ക്കും.തിരുവനന്തപുരം ജില്ലയിലെ തിരെഞ്ഞെടുത്ത വിദ്യാലയങ്ങളിൽ സംഘടിപ്പിക്കുന്ന പ്രമേഹ ബോധവൽക്കരണ പദ്ധതിയുടെ ഭാഗമായി തോന്നയ്ക്കൽ ഇ വി യൂപി സ്കൂൾ നിംസ് മെഡിസിറ്റിയ ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/02-05-2023(1).jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ ആറയൂർ ",
      location: "കൊടിത്തറക്കുഴി എസ് എൻ ഡി പി ഹാൾ,ആറയൂർ.",
      date: "02/05/2023",
      discription:
        "എസ് എൻ ഡി പി യൂണിറ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ  ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/02-05-2023.jpg",
      header: "സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് @ വഴുതക്കാട് ",
      location: "കാർമൽ സ്കൂൾ ഓഡിറ്റോറിയം,വഴുതക്കാട്.",
      date: "02/05/2023",
      discription:
        "ലോക അർബുദ ദിനാചരണത്തിൻ്റെ ഭാഗമായി നവോത്ഥാൻ ക്യാൻസർ ഫൗണ്ടേഷൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ക്യാൻസർ സ്ക്രീനിംഗ്, ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/02-04-2023(1).jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ പനവൂർ ",
      location: "എൻഎസ്എസ് ഹാൾ,കരിക്കുഴി,പനവൂർ",
      date: "02/04/2023",
      discription:
        "പനവൂർ അൽ ഇഹിസാൻ സാംസ്കാരിക വേദിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ  ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/02-04-2023.jpg",
      header: "സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് @ കോട്ടൂർ ",
      location: "ഗീതാഞ്ജലി ഗ്രന്ഥശാല കോട്ടൂർ.",
      date: "02/04/2023",
      discription:
        "വേൾഡ് ക്യാൻസർ ദിനത്തോട് അനുബന്ധിച്ച് പുനലാൽ ഡെയ്ൽ വ്യൂ കോളേജ്, കോട്ടൂർ ഗീതാഞ്ജലി ഗ്രന്ഥശാലയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ക്യാൻസർ സ്ക്രീനിംഗ്, ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/02-03-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ പോത്തൻകോട് ",
      location: "നിസമിയ പബ്ലിക് സ്കൂൾ, പോത്തൻകോട്.",
      date: "02/03/2023",
      discription:
        "നിസാമിയ ഫെസ്റ്റ് -2023, ഗ്രാൻഡ് പാരെൻ്റ്സ് ഡേ  ആഘോഷത്തിൻ്റെ ഭാഗമായി നിസാമിയാ പബ്ലിക് സ്കൂളിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/02-02-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ പയറ്റുവിള ",
      location: "ശ്രീ ചാമുണ്ഡി ദേവി ക്ഷേത്ര ഓഡിറ്റോറിയം",
      date: "02/02/2023",
      discription:
        "ഇടത്തെയ്ക്കോണം ജനതാ ക്ലബ്, പയറ്റുവിള ശ്രീ ചാമുണ്ഡി ദേവി ക്ഷേത്ര ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും /സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/01-31-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ വിതുര ",
      location: " ശ്രീ ഭദ്രകാളി ക്ഷേത്ര ഓഡിറ്റോറിയം, ചായം, വിതുര.",
      date: "01/31/2023",
      discription:
        "ചായം ശ്രീ ഭദ്രകാളി ക്ഷേത്ര ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/01-30-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ വഴുതക്കാട് ",
      location: " ശ്രീമൂലം ക്ലബ് ഓഡിറ്റോറിയം,വഴുതക്കാട്.",
      date: "01/30/2023",
      discription:
        "പ്രശാന്ത വിസ്മയം -2023 ഇവെൻ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/01-29-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ മൊട്ടമൂട് ",
      location: " ഫ്രണ്ട്സ് യോഗ സെൻ്റർ,മൊട്ടമൂട്.",
      date: "01/29/2023",
      discription:
        "മൊട്ടമൂട് ഫ്രണ്ട്സ് യോഗ സെൻ്ററിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/01-28-2023(1).jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ കഴക്കൂട്ടം ",
      location: "ചന്തവിള യു.പി.എസ് സ്കൂൾ, കഴക്കൂട്ടം.",
      date: "01/28/2023",
      discription:
        "ചന്തവിള സേവാ ഭാരതി യൂണിറ്റ്, ട്രിവാൻഡ്രം ലയൺസ് ക്ലബ് ഓഫ് മെജസ്റ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/01-28-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ ഊക്കോട് ",
      location: "ഊക്കോട് NSS ഹാൾ",
      date: "01/28/2023",
      discription:
        "ജനുവരി 28 ശനി രാവിലെ 10 മണിയ്ക്ക് കല്ലിയൂർ, ഊക്കോട് NSS ഹാളിൽ വച്ച് നടന്ന ചടങ്ങിൽ  എന്റെ ഹൃദയം എന്റെ ഗ്രാമം ; സൗജന്യ ഹൃദ്രോഗ നിർണ്ണയ മെഗാ ക്യാമ്പിന്റെയും ബോധവത്ക്കരണത്തിന്റെയും ഉത്ഘാടനം പ്രശസ്ത സിനിമ - സീരിയൽ താരം ശ്രീ. കൃഷ്ണകുമാർ നിർവഹിച്ചു.ഭിന്നശേഷി കുട്ടികൾക്ക് നിംസ് മെഡിസിറ്റി  നൽകി വരുന്ന പെൻഷൻ പദ്ധതിയായ നെയ്യാറ്റിൻകര പെൻഷൻ പ്ലാൻ ; കല്ലിയൂർ പഞ്ചായത്തിൽ നടപ്പിലാക്കുന്നതിന്റെ ഔപചാരിക ഉത്ഘാടനം നിംസ് മെഡിസിറ്റി എം.ഡി. ശ്രീ. എം.എസ് ഫൈസൽ ഖാൻ നിർവഹിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/01-27-2023(1).jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ ധനുവച്ചപുരം ",
      location: "ധനുവച്ചപുരം ധനശ്രീ ആഡിറ്റോറിയം",
      date: "01/27/2023",
      discription:
        "കൊല്ലയിൽ പഞ്ചായത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ ഭിന്നശേഷി വിഭാഗത്തിൽപ്പെട്ടവർക്കും , വയോജനങ്ങൾക്കുമുള്ള സൗജന്യ മെഡിക്കൽ ചെക്കപ്പും, ബോധവൽക്കരണ ക്ലാസ്സും സംഘടിപ്പിച്ചു. 2023 ജനുവരി 27 , ധനുവച്ചപുരം ധനശ്രീ ആഡിറ്റോറിയത്തിൽ വച്ച് നടന്ന ചടങ്ങിൽ കൊല്ലയിൽ പഞ്ചായത്ത് പ്രസിഡന്റ് ശ്രീ. എൻ.എസ്. നവനീത് കുമാർ അദ്ധ്യക്ഷത വഹിച്ചു. പദ്ധതികളുടെ ഉത്ഘാടനം നിംസ് മെഡിസിറ്റി മാനേജിംഗ് ഡയറക്ടർ ശ്രീ. എം.എസ്. ഫൈസൽ ഖാൻ നിർവഹിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/01-27-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ പയറ്റുവിള ",
      location: "ശ്രീ കൊല്ലയ്ക്കോണം ദേവി ക്ഷേത്ര ഹാൾ,പയറ്റുവിള.",
      date: "01/27/2023",
      discription:
        "ജീവദായിനി 2023'ശ്രീ വിവേകാനന്ദ സാംസ്കാരിക സമിതി , കൊല്ലയ്ക്കോണം ശ്രീയക്ഷിയമ്മാ ദേവി ക്ഷേത്ര ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/01-26-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ പെരുംക്കാവ് ",
      location: "പെരുകാവ് റെസിഡൻഷ്യൽ അസോസിയേഷൻ ഹാൾ.",
      date: "01/26/2023",
      discription:
        "പെരുംക്കാവ് റെസിഡൻഷ്യൽ അസോസിയേഷൻ,തിരുമല ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/01-26-2023(1).jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ തക്കല",
      location: "ഗവ: മിഡിൽ സ്കൂൾ,തക്കല, കന്യാകുമാരി ജില്ല.",
      date: "01/26/2023",
      discription:
        "നൂറുൽ ഇസ്‌ലാം യൂണിവേഴ്സിറ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ ഡോ: കെ വിജയകുമാർ എംഡി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/01-25-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ തൈക്കാട്",
      location: "ഗവ മോഡൽ ഹൈസ്കൂൾ ഓഡിറ്റോറിയം, തൈക്കാട്.",
      date: "01/25/2023",
      discription:
        "(രണ്ടാം ദിവസം) 'മിഠായി' (4) ലോക പ്രമേഹ ദിനത്തോട് അനുബന്ധിച്ച് സ്ക്കൂൾ വിദ്യാർഥികളിലൂടെ പ്രമേഹ അവബോധം കുടുംബത്തിലേയ്ക്കും സമൂഹത്തിലേയ്ക്കും.തിരുവനന്തപുരം ജില്ലയിലെ തിരെഞ്ഞെടുത്ത വിദ്യാലയങ്ങളിൽ സംഘടിപ്പിക്കുന്ന പ്രമേഹ ബോധവൽക്കരണ പദ്ധതിയുടെ ഭാഗമായി തൈക്കാട് ഗവ: മോഡൽ ഹൈസ്കൂൾ , റോട്ടറി ഇൻ്റർനാഷണൽ ട്രിവാൻഡ്രത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/01-24-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ തൈക്കാട്",
      location: "ഗവ മോഡൽ ഹൈസ്കൂൾ ഓഡിറ്റോറിയം, തൈക്കാട്.",
      date: "01/24/2023",
      discription:
        "ഗവ: മോഡൽ ഹൈസ്കൂൾ, ട്രിവാൻഡ്രം റോട്ടറി ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/01-22-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ പിരപ്പൻകോട്",
      location: "എൻഎസ്എസ് ഹാൾ,ചിറ്റാർ, പിരപ്പൻകോട്.",
      date: "01/22/2023",
      discription:
        "കാവിയാട് ദിനകര പണിക്കർ സാംസ്കാരിക വേദിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/01-21-2023.jpg",
      header: "സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് @ ആഴിമല",
      location: "ആഴിമല ശിവക്ഷേത്ര ഓഡിറ്റോറിയം.",
      date: "01/21/2023",
      discription:
        "ആഴിമല ശിവക്ഷേത്ര ട്രസ്റ്റും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/01-18-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ പിരായിമൂട്",
      location: "എൽ & റ്റി കൺസ്ട്രക്ഷൻ ഓഫീസ്,പിരായിമൂട്.",
      date: "01/18/2023",
      discription:
        "പിരായിമൂട് എൽ & റ്റി കൺസ്ട്രക്ഷൻ കമ്പനിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/01-17-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ പേരൂർക്കട",
      location: "ഗവ: ഗേൾസ് ഹയർ സെക്കൻഡറി സ്കൂൾ, പേരൂർക്കട.",
      date: "01/17/2023",
      discription:
        "പേരൂർക്കട ഗവൺമെൻ്റ് ഗേൾസ് ഹയർ സെക്കൻഡറി സ്കൂൾ പി റ്റി എ, പേരൂർക്കട മോഡൽ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീമതി ജമീല ശ്രീധരൻ ( ആരോഗ്യ സ്റ്റാന്റിംഗ് കമ്മിറ്റി ചെയർ പേഴ്സൺ, തിരു. നഗരസഭ )",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/01-16-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ സൂര്യക്കോട്",
      location: "മാർ എഫ്രേം ഹയർ സെക്കൻഡറി സ്കൂൾ,സൂര്യക്കോട്.",
      date: "01/16/2023",
      discription:
        "തമിഴ്നാട് ഗവൺമെന്റ് ഹെൽത്ത് ഇൻഷുറൻസ് സ്കീം, മരിയഗിരി മലങ്കര കാത്തോലിക് കോളേജിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/01-15-2023.jpg",
      header: "സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് @ വട്ടിയൂർക്കാവ്",
      location: "കുരുവിക്കാട് കലാലയ പബ്ലിക് സ്കൂൾ,വട്ടിയൂർക്കാവ്.",
      date: "01/15/2023",
      discription:
        "വട്ടിയൂർക്കാവ് ശ്രീ ചിത്തിര ആർട്സ് ആൻ്റ് സ്പോർട്സ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ ജനറൽ സർജറി, കാർഡിയോളജി,ഡയബറ്റോളജി, ഡെൻ്റൽ എന്നീ വിഭാവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ ക്യാമ്പിന് നേതൃത്വം നൽകി.സൗജന്യ എക്കോ,ഇ സി ജി, ബ്ലഡ് ഷുഗർ, ബ്ലഡ് പ്രഷർ, ബി എം ഐ ടെസ്റ്റുകൾ നടത്തി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/01-14-2023.jpg",
      header: "സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് @ തൊട്ടിക്കര",
      location: "തൊട്ടിക്കര ശ്രീ ഭദ്രകാളി ക്ഷേത്ര ട്രസ്റ്റ്.",
      date: "01/14/2023",
      discription:
        "ആരോഗ്യമേള -2023. അരുമാളൂർ തൊട്ടിക്കര ശ്രീ ഭദ്രകാളി ക്ഷേത്ര ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ ആരോഗ്യമേള സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീമതി Dr മഞ്ജു തമ്പി (ചീഫ് നെഫ്രോളജിസ്റ്റ് & മെഡിക്കൽ സൂപ്രണ്ട്, നിംസ് മെഡിസിറ്റി )ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി, ഓർത്തോപീഡിക്കസ്,പൾമിനോളജി,ഇ എൻ റ്റി,ഒഫ്ത്താൽമോളജി, ഡെൻ്റൽ, ആയുർവേദം എന്നി വിഭാവങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേതൃത്വം നൽകി.സൗ ജന്യ എക്കോ, ഇ സി ജി, പി എഫ് റ്റി,ഓട്ടിസം സ്ക്രീനിംഗ്, കുട്ടികളിലെ പഠനവൈകല്യം, കേൾവി പരിശോധന, ബ്ലഡ് ഷുഗർ, ബി പി, ബി എം ഐ ടെസ്റ്റുകൾ നടത്തി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/01-13-2023(1).jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ കുറവൻക്കോണം",
      location: "UIT ക്യാമ്പസ് കുറവൻക്കോണം.",
      date: "01/13/2023",
      discription:
        "നാഷനൽ സർവീസ് സ്കീം UIT കുറവൻക്കോണം, ട്രിവാൻഡ്രം റെയിൻബോ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/01-13-2023.jpg",
      header: "സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് @ അതിയന്നൂർ",
      location: "അതിയന്നൂർ ഗ്രാമ പഞ്ചായത്ത് കമ്മ്യൂണിറ്റി ഹാൾ.",
      date: "01/13/2023",
      discription:
        "എൻ്റെ ഗ്രാമം എൻ്റെ ഹൃദയം❤️ പദ്ധതിയുടെ ഭാഗമായി അതിയന്നൂർ ഗ്രാമ പഞ്ചായത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ കാർഡിയോളജി മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ പി വി സുനിൽകുമാർ( ഗ്രാമ പഞ്ചായത്ത് പ്രസിഡൻ്റ്) മഹനീയ സാന്നിധ്യം ശ്രീ കൊടങ്ങാവിള വിജയകുമാർ(ആരോഗ്യ- വിദ്യാഭ്യാസ സ്റ്റാൻഡിങ് കമ്മിറ്റി ചെയർമാൻ) ക്യാമ്പിൽ 200-പ്പരം പേർ കാർഡിയോളജി  സ്ക്രീനീംഗന്  വിധേയമായി. ക്യാമ്പിൽ സൗജന്യ എക്കോ, ഇ. സി. ജി, ബ്ലഡ് ഷുഗർ, ബ്ലഡ് പ്രഷർ, ബി എം ഐ ടെസ്റ്റുകൾ നടത്തി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/01-08-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ കോട്ടൂർ",
      location: "ഗവ: യൂ പി എസ് സ്കൂൾ, കോട്ടൂർ.",
      date: "01/08/2023",
      discription:
        "കോട്ടൂർ ഗീതാഞ്ജലി ഗ്രന്ഥശാല, നെടുമങ്ങാട് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം:ശ്രീ മണികണ്ഠൻ (ഗ്രാമ പഞ്ചായത്ത് പ്രസിഡൻ്റ്,കുറ്റിച്ചൽ.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/01-07-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ ശാന്തിവിള",
      location: "സെൻ്റ് തോമസ് ചർച്ച് സ്കൂൾ, ശാന്തിവിള.",
      date: "01/07/2023",
      discription:
        "പൊന്നുമംഗലം എൻ എസ് എസ് കരയോഗം,തിരുവനന്തപുരം ക്രിസ്റ്റ്ൽ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/01-06-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ ഒറ്റശേഖരമംഗലം",
      location: "ചൈതന്യ ലൈബ്രറി ഹാൾ,ഒറ്റശേഖരമംഗലം.",
      date: "01/06/2023",
      discription:
        " ഒറ്റശേഖരമംഗലം ശ്രീ മഹാദേവ ക്ഷേത്ര ട്രസ്റ്റ്, ആശുപത്രി സംരക്ഷണ സമിതിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/01-05-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ വെങ്ങാനൂർ",
      location: "വെങ്ങാനൂർ സി. എസ്. ഐ. ചർച്ച്.",
      date: "01/05/2023",
      discription:
        "തിരുവനന്തപുരം സീപോർട്ട് ലയൺസ് ക്ലബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെ സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/01-04-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ വെങ്ങാനൂർ",
      location: "വവ്വാമൂല അംഗൻവാടി ഹാൾ, നെല്ലിവിള, വെങ്ങാനൂർ.",
      date: "01/04/2023",
      discription:
        "വെങ്ങാനൂർ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/01-03-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ കണിയാപുരം",
      location: "സഹജീവൻ സ്പെഷ്യൽ സ്കൂൾ, കണിയാപുരം.",
      date: "01/03/2023",
      discription:
        "കണിയാപുരം സഹജീവൻ സ്പെഷ്യൽ സ്കൂൾ, നാഷണൽ കോളേജ് സോഷ്യോളജി ഡിപ്പാർട്ട്മെന്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/01-02-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ കിളിമാനൂർ",
      location: "തോപ്പിൽ പാർട്ടി ഓഫീസ്,കിളിമാനൂർ.",
      date: "01/02/2023",
      discription:
        "കിളിമാനൂർ മണ്ഡലം ഇന്ത്യൻ നാഷണൽ കോൺഗ്രസ്    തോപ്പിൽ യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/01-01-2023.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ വെള്ളനാട്",
      location: "വെള്ളനാട് സഹകരണ ബാങ്ക് ഹാൾ.",
      date: "01/01/2023",
      discription:
        "പുന്നംകോണം ശ്രീ ഭഗവതി ക്ഷേത്ര ട്രസ്റ്റ്, വട്ടിയൂർക്കാവ് സേവാഭാരതി യൂണിറ്റ്,തിരുവനന്തപുരം മോഡൽ ലയൺസ് ക്ലബ്ബ് മെജസ്റ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/12-31-2022.jpg",
      header: "സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് @ വെള്ളനാട്",
      location: "വെള്ളനാട് സഹകരണ ബാങ്ക് ഹാൾ.",
      date: "12/31/2022",
      discription:
        "ലൈഫ് @98 (1998 ബാച്ച് V&HSS SSLC കൂട്ടായിമ)വട്ടിയൂർക്കാവ് മോഡൽ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/12-29-2022.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ ആര്യയനാട്",
      location: "സേവാ ഭാരതി ഓഫീസ്, കുളപ്പട,ആര്യയനാട്.",
      date: "12/29/2022",
      discription:
        "ഉഴമലയ്ക്കൽ സേവാ ഭാരതി യൂണിറ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/12-28-2022.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ കരകുളം",
      location: "കരകുളം സഹകരണ ബാങ്ക് .",
      date: "12/28/2022",
      discription:
        "കരകുളം സഹകരണ ബാങ്ക്, പേരൂർക്കട ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/12-27-2022-1.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ കിള്ളിപ്പാലം",
      location: "തമിഴ് സംഘം പി ആർ എസ് ഹാൾ, കിള്ളിപ്പാലം.",
      date: "12/27/2022",
      discription:
        "തിരുവനന്തപുരം തമിഴ് സംഘം,തിരുവനന്തപുരം സെൻട്രൽ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/12-27-2022.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ കുഴിവിള",
      location: " പി വി എസ് പി സ്കൂൾ, കുഴിവിള.",
      date: "12/27/2022",
      discription:
        "എൻ്റെ ഗ്രാമം എൻ്റെ ഹൃദയം❤️ പദ്ധതിയുടെ ഭാഗമായി പള്ളിച്ചൽ ഗ്രാമ പഞ്ചായത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ കാർഡിയോളജി മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ ഡേ: ഐ ബി സതീഷ് (എംഎൽഎ കാട്ടാക്കട). മഹനീയ സാന്നിധ്യം ശ്രീമതി ടി മല്ലികാ ( പള്ളിച്ചൽ ഗ്രാമ പഞ്ചായത്ത്  പ്രസിഡൻ്റ്)  ക്യാമ്പിൽ 250-പ്പരം പേർ കാർഡിയോളജി  സ്ക്രീനീംഗന്  വിധേയമായി. ക്യാമ്പിൽ സൗജന്യ എക്കോ, ഇ. സി. ജി, ബ്ലഡ് ഷുഗർ, ബ്ലഡ് പ്രഷർ, ബി എം ഐ ടെസ്റ്റുകൾ നടത്തി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/12-26-2022.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ നെല്ലിമൂട്",
      location: "ഉഗവ:: ഹൈസ്കൂൾ, കഴിവൂർ, നെല്ലിമൂട്.",
      date: "12/26/2022",
      discription:
        "നാഷണൽ സർവീസ് സ്കീം(സർഗ്ഗം-2022) നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/12-25-2022.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ പിരപ്പൻക്കോട്",
      location: "ഉല്ലാസ് നഗർ, പിരപ്പൻക്കോട്.",
      date: "12/25/2022",
      discription:
        "കാവിയാട് ദിനകര പണിക്കർ സാംസ്കാരിക വേദിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/12-24-2022.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ കിള്ളിപ്പാലം",
      location: "സി എസ് ഐ ഹാൾ, കിള്ളിപ്പാലം.",
      date: "12/24/2022",
      discription:
        "ചാല ഡി വൈ എഫ് ഐ മേഖല കമ്മിറ്റി, ട്രിവാൻഡ്രം നാഷണൽ ക്ലബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/12-22-2022.jpg",
      header: "സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് @ കണ്ണേറ്റുമുക്ക്",
      location: "പീപ്പിൾസ് ഹാൾ കണ്ണേറ്റുമുക്ക്.",
      date: "12/22/2022",
      discription:
        "കണ്ണേറ്റുമുക്ക് പീപ്പിൾസ്  റീഡിംഗ് റൂം  ആർട്സ് ആൻ്റ് സ്പോർട്സ് ക്ലബ്ബ്,ട്രിവാൻഡ്രം ഗ്രീൻ സിറ്റി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം: ശ്രീ ആൻ്റണി രാജു (ബഹു ട്രാൻസ്പോർട്ട് മന്ത്രി)",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/12-19-2022.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ വിഴിഞ്ഞം",
      location: "കോസ്റ്റൽ പോലീസ് സ്റ്റേഷൻ, വിഴിഞ്ഞം.",
      date: "12/19/2022",
      discription:
        "വിഴിഞ്ഞം കോസ്റ്റൽ പോലീസ് സ്റ്റേഷൻൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ഉദ്ഘാടനം: ശ്രീ ജീ. സ്പർശൻ കുമാർ IPS (കമ്മീഷണർ ഓഫ് പോലീസ്,ട്രിവാൻഡ്രം സിറ്റി).",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/12-18-2022.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ ആരൽവായ്മൊഴി",
      location: "ദേവസഹായം ചർച്ച് ക്യാമ്പസ്, ആരൽവായ്മൊഴി.",
      date: "12/18/2022",
      discription:
        "തമിഴ്നാട് ഗവൺമെൻ്റ് ഹെൽത്ത് ഇൻഷുറൻസ് സ്കീം, നാഗർകോവിൽ റോട്ടറി ക്ലബ്ബ് ഓഫ് ഗോൾഡൺ സിറ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/12-17-2022.jpg",
      header: "സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് @ കാട്ടാക്കട",
      location: "സി എസ് ഐ ചർച്ച് പാരിഷ് ഹാൾ, കാട്ടാക്കട.",
      date: "12/17/2022",
      discription:
        "സി എസ് ഐ ചർച്ച് കാട്ടാക്കട,ജെയ്ഹോക്കർ ഇൻഷുറൻസ് കമ്പനിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/12-13-2022.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ മാഞ്ഞാലിക്കുളം",
      location: "AKTA ഭവൻ, മാഞ്ഞാലിക്കുളം, തമ്പാനൂർ .",
      date: "12/13/2022",
      discription:
        "അൾ കേരളാ ടെയിലേഴസ് അസോസിയേഷൻ, ട്രിവാൻഡ്രം ജെംസ് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/12-11-2022.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ നെടുമങ്ങാട്",
      location: "പാരിഷ് ഹാൾ, അമലത്ഭോമാതാ ദേവാലയം,താന്നിമൂട്, നെടുമങ്ങാട്.",
      date: "12/11/2022",
      discription:
        "നെടുമങ്ങാട് താന്നിമൂട് പര. അമലത്ഭോമാതാ ദേവാലയത്തിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/12-10-2022.jpg",
      header: "സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് @ പേയാട്",
      location: "എം എസ് സി എൽ പി സ്കൂൾ പാമംകോട്,പേയാട്.",
      date: "12/10/2022",
      discription:
        "പള്ളിച്ചൽ പഞ്ചായത്ത് പാമാംകോട് 1-വാർഡ്, ട്രിവാൻഡ്രം റെയിൻബോ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/12-08-2022.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ കരമന",
      location: "ടാക്സ് ടവർ, കരമന.",
      date: "12/08/2022",
      discription:
        "കരമന ടാക്‌സ് ടവർ ജീവനക്കാരുടെ കൂട്ടായ്മയായ സമതയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/12-07-2022.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ ഊരുട്ട്കാല",
      location: "ജീ ആർ ഓഡിറ്റോറിയം,ഊരുട്ട്കാല.",
      date: "12/07/2022",
      discription:
        "ഊരുട്ടുകാല ദയാ ഇൻഡസ്ട്രിയലിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/12-06-2022.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ വെള്ളയമ്പലം",
      location: "വാട്ടർ അതോറിറ്റി ഓഫീസ്, വെള്ളയമ്പലം.",
      date: "12/06/2022",
      discription:
        "വെള്ളയമ്പലം വാട്ടർ അതോറിറ്റി എംപ്ലോയീസ് അസോസിയേഷൻ, പട്ടം ഇൻഡസ് മോട്ടേഴ്സിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/12-05-2022.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ പി എം ജീ",
      location: "വികാസ് ഭവൻ ഓഫീസ്, പി എം ജീ.",
      date: "12/05/2022",
      discription:
        "വികാസ് ഭവൻ എംപ്ലോയീസ് അസോസിയേഷൻ, പട്ടം ഇൻഡസ് മോട്ടേഴ്സിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/12-04-2022.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ വെണ്ണിയൂർ",
      location: "സെൻ്റ് ജോസഫ് യു പി സ്കൂൾ, വെണ്ണിയൂർ.",
      date: "12/04/2022",
      discription:
        "വെണ്ണിയൂർ ഡി എം കോൺവെന്റ് - നിർമ്മലാ പ്രോവിൻസിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/12-03-2022.jpg",
      header: "സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് @ ധനുവച്ചപുരം",
      location: "N K M GHSS ധനുവച്ചപുരം.",
      date: "12/03/2022",
      discription:
        "എൻ്റെ ഗ്രാമം എൻ്റെ ഹൃദയം*❤️ പദ്ധതിയുടെ ഭാഗമായി കൊല്ലയിൽ ഗ്രാമ പഞ്ചായത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ കാർഡിയോളജി മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ സി കെ ഹരീന്ദ്രൻ (എംഎൽഎ പാറശ്ശാല). മഹനീയ സാന്നിധ്യം ശ്രീ നവനീത് കുമാർ എൻ എസ് (കൊല്ലയിൽ ഗ്രാമ പഞ്ചായത്ത്  പ്രസിഡൻ്റ്)  ക്യാമ്പിൽ 300-പ്പരം പേർ കാർഡിയോളജി  സ്ക്രീനീംഗന്  വിധേയമായി. ക്യാമ്പിൽ സൗജന്യ എക്കോ, ഇ. സി. ജി, ബ്ലഡ് ഷുഗർ, ബ്ലഡ് പ്രഷർ, ബി എം ഐ ടെസ്റ്റുകൾ നടത്തി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/12-01-2022.jpg",
      header: "സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് @ പനച്ചമൂട്",
      location: "കന്യാ ഓഡിറ്റോറിയം, പനച്ചമൂട്.",
      date: "12/01/2022",
      discription:
        "വെള്ളറട ഗ്രാമപഞ്ചായത്തും തിരുവനന്തപുരം പ്രേം നസീർ സുഹൃത്ത് സമിതിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/12-01-2022.jpg",
      header: "സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് @ പാപ്പനംകോട്",
      location: "അരകത്ത് റെസിഡൻഷ്യൽ അസോസിയേഷൻ ഹാൾ, പാപ്പനംകോട്.",
      date: "30/11/2022",
      discription:
        "പാപ്പനംകോട് അരകത്ത് റെസിഡൻഷ്യൽ അസോസിയേഷൻ,ട്രിവാൻഡ്രം സ്മാർട്ട് സിറ്റി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/11-29-2022.jpg",
      header: "സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് @ ചിറയിൻകീഴ്",
      location: "അഴൂർ ഗ്രാമ പഞ്ചായത്ത് കമ്മ്യൂണിറ്റി ഹാൾ, ചിറയിൻകീഴ്",
      date: "29/11/2022",
      discription:
        "സേവാ ഭാരതി അഴൂർ പഞ്ചായത്ത് സമിതി, ലയൺസ് ക്ലബ് ഓഫ് ട്രിവാൻഡ്രം മജസറ്റിക്കിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/11-27-2022.jpg",
      header: "സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് @ കിളിമാനൂർ",
      location: "വട്ടപച്ച കമ്മിറ്റി ഓഫീസ്,കിളിമാനൂർ.",
      date: "27/11/2022",
      discription:
        "ഡിവൈഎഫ്ഐ വട്ടപച്ച ഏരിയാ കമ്മിറ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ. സ. വി അനൂപ് (ജില്ലാ പ്രസിഡൻ്റ്)..",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/11-26-2022.jpg",
      header: "സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് @ ആക്കുളം",
      location: "കമ്മ്യൂണിറ്റി ഹാൾ വായു വിഹാർ എയർ ഫോഴ്സ്, ആക്കുളം",
      date: "26/11/2022",
      discription:
        "ആക്കുളം എയർ ഫോഴ്സ് അസോസിയേഷൻ, ട്രിവാൻഡ്രം കോസ്മോപോളിടൻ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/11-24-2022.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ പൂന്തുറ",
      location: "സെൻ്റ് ജോസ് ചർച്ച്, പൂന്തുറ.",
      date: "24/11/2022",
      discription:
        "പൂന്തുറ നഗരസഭാ വാർഡ് ,തിരുവനന്തപുരം ഇന്നേർ വീൽ ക്ലബ്,തിരുവനന്തപുരം ഇംപാക്ട് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/11-23-2022.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ ഏണിക്കര",
      location: "എൻഎസ്എസ് കരയോഗം ഹാൾ,ഏണിക്കര.",
      date: "23/11/2022",
      discription:
        "ഏണിക്കര- തുടയൻകോട് റെസിഡൻഷ്യൽ അസോസിയേഷൻ,ട്രിവാൻഡ്രം സ്മാർട്ട് സിറ്റി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/11-22-2022.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ പനയറ",
      location: "തൃപ്പോരിട്ടക്കാവ് ക്ഷേത്ര ഓഡിറ്റോറിയം, പനയറ.",
      date: "22/11/2022",
      discription:
        "ചെമ്മരുതി സേവാ ഭാരതി യൂണിറ്റ്, ലയൺസ് ക്ലബ് ഓഫ് ട്രിവാൻഡ്രം മെജസ്റ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/11-21-2022.jpg",
      header: "സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് @ ആനയറ",
      location: "സ്വിഫ്റ്റ് ഓഫീസ് ആനയറ.",
      date: "21/11/2022",
      discription:
        "KSRTC  ആരംഭിച്ച ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 100-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/11-20-2022.jpg",
      header: "സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് @ ധനുവച്ചപുരം",
      location: "എൻഎസ്എസ് ബിൽഡിംഗ്, ധനുവച്ചപുരം.",
      date: "20/11/2022",
      discription:
        "ധനുവച്ചപുരം എൻഎസ്എസ്  യൂണിറ്റിൻ്റെയു നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/11-19-2022.jpg",
      header: "സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് @ തിരുവനന്തപുരം",
      location: "രാജാജി നഗർ,തിരുവനന്തപുരം.",
      date: "19/11/2022",
      discription:
        "കേരളാ സ്റ്റേറ്റ് എക്സൈസ് ഡിപ്പാർട്ട്മെൻ്റ്, രാജാജി നഗർ വിങ്സ് ഓഫ് വിമൻസ്, ലയൺസ് ക്ലബ് ഓഫ് ഗൗരീശപട്ടത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/11-18-2022.jpg",
      header: "സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് @ കല്ലമ്പലം",
      location: "ഇന്ത്യൻ ഐ. റ്റി.ഇ, പേരൂർ, കല്ലമ്പലം.",
      date: "18/11/2022",
      discription:
        "(2- ദിവസം)കല്ലമ്പലം ബാഫക്കി തങ്ങൾ എജുക്കേഷൻ ചാരിറ്റബിൾ ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/11-17-2022.jpg",
      header: "സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് @ കല്ലമ്പലം",
      location: "ഇന്ത്യൻ ഐ. റ്റി.ഇ, പേരൂർ, കല്ലമ്പലം.",
      date: "17/11/2022",
      discription:
        "കല്ലമ്പലം ബാഫക്കി തങ്ങൾ എജുക്കേഷൻ ചാരിറ്റബിൾ ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/11-16-2022.jpg",
      header: "സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് @ പേയാട്",
      location: "ആൽഫാ കോളേജ്, പേയാട്.",
      date: "16/11/2022",
      discription:
        "പേയാട് ലയൺസ് ക്ലബ്, ലിയോ ക്ലബ് പേയാടിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/11-15-2022.jpg",
      header: "സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് @ വെള്ളറട",
      location: "കെ.പി.എം ഓഡിറ്റോറിയം,വെള്ളറട.",
      date: "15/11/2022",
      discription:
        "വെള്ളറട ഗ്രാമപഞ്ചായത്തും തിരുവനന്തപുരം പ്രേം നസീർ സുഹൃത്ത് സമിതിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീമതി അൻസജിത റസ്സേൽ ( ജില്ലാ പഞ്ചായത്ത് മെമ്പർ )",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/11-14-2022.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ തിരുവല്ലം",
      location: "ലയൺസ് ഭവൻ, തിരുവല്ലം",
      date: "14/11/2022",
      discription:
        "ലയൺസ് ക്ലബ് ഇൻ്റർനാഷണൽ തിരുവല്ലം ബ്രാഞ്ചിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ പ്രമേഹരോഗ നിർണ്ണയവും ബോധവൽക്കരണ ക്യാമ്പും സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/11-13-2022(1).jpg",
      header: "സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് @ തോവാള",
      location: "ചോഴപുരം ഇൻഡോർ ഓഡിറ്റോറിയം, തോവാള, കന്യാകുമാരി.",
      date: "13/11/2022",
      discription:
        "തമിഴ്നാട് ഗവൺമെന്റ് ഹെൽത്ത് ഇൻഷുറൻസ് സ്കീം,ചോഴപുരം യൂത്ത് വെൽഫെയർ അസോസിയേഷന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/11-13-2022.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ പാറശ്ശാല",
      location: "ഇ. എം എസ് ഓഡിറ്റോറിയം, പുത്തൻകട, പാറശ്ശാല",
      date: "13/11/2022",
      discription:
        "എൻ്റെ ഗ്രാമം എൻ്റെ ഹൃദയം❤️ പദ്ധതിയുടെ ഭാഗമായി പാറശ്ശാല ഗ്രാമ പഞ്ചായത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ കാർഡിയോളജി മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ സുരേഷ് കുമാർ (ജില്ലാ പഞ്ചായത്ത് പ്രസിഡൻ്റ്,തിരുവനന്തപുരം). മഹനീയ സാന്നിധ്യം ശ്രീ ബെന്യാമിൻ ( പ്രശസ്ത കഥാകൃത്ത്, നോവലിസറ്റ്) ശ്രീമതി നീനാ കുറുപ്പ് (സിനിമാ - സീരിയൽ താരം ) ശ്രി ബെൻ ഡാർവിൻ (ബഹു പാറശ്ശാല ബ്ലോക്ക് പഞ്ചായത്ത് പ്രസിഡൻ്റ്) ശ്രിമതി എൽ മഞ്ജു സ്മിതാ (ബഹു പാറശ്ശാല ഗ്രാമ പഞ്ചായത്ത് പ്രസിഡൻ്റ്) ക്യാമ്പിൽ 350-പ്പരം പേർ കാർഡിയോളജി  സ്ക്രീനീംഗന്  വിധേയമായി. ക്യാമ്പിൽ സൗജന്യ എക്കോ, ഇ. സി. ജി, ബ്ലഡ് ഷുഗർ, ബ്ലഡ് പ്രഷർ, ബി എം ഐ ടെസ്റ്റുകൾ നടത്തി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/11-12-2022.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ മുടവൻമുഗൾ",
      location: "പൗരസമിതി ഓഫീസ് മുടവൻമുഗൾ.",
      date: "12/11/2022",
      discription:
        "മുടവൻമുഗൽ പൗരസമിതി,ട്രിവാൻഡ്രം റെയിൻബോ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/11-09-2022.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ പാൽകുളങ്ങര",
      location: "എൻ എസ് എസ് ഹയർ സെക്കൻഡറി സ്കൂൾ,പാൽകുളങ്ങര.",
      date: "09/11/2022",
      discription:
        " 'മിഠായി ' (3) ലോക പ്രമേഹ ദിനത്തോട് അനുബന്ധിച്ച് സ്ക്കൂൾ വിദ്യാർഥികളിലൂടെ പ്രമേഹ അവബോധം കുടുംബത്തിലേയ്ക്കും സമൂഹത്തിലേയ്ക്കും.തിരുവനന്തപുരം ജില്ലയിലെ തിരെഞ്ഞെടുത്ത വിദ്യാലയങ്ങളിൽ സംഘടിപ്പിക്കുന്ന പ്രമേഹ ബോധവൽക്കരണ പദ്ധതിയുടെ ഭാഗമായി പാൽകുളങ്ങര എൻ എസ് എസ് ഹയർ സെക്കൻഡറി സ്കൂൾ, റോട്ടറി ഇൻ്റർനാഷണൽ ട്രിവാൻഡ്രത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/11-08-2022.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ അമ്പലത്തറ",
      location: "ഗവ:യു പി എസ്, അമ്പലത്തറ.",
      date: "08/11/2022",
      discription:
        " 'മിഠായി ' (2) ലോക പ്രമേഹ ദിനത്തോട് അനുബന്ധിച്ച് സ്ക്കൂൾ വിദ്യാർഥികളിലൂടെ പ്രമേഹ അവബോധം കുടുംബത്തിലേയ്ക്കും സമൂഹത്തിലേയ്ക്കും.തിരുവനന്തപുരം ജില്ലയിലെ തിരെഞ്ഞെടുത്ത വിദ്യാലയങ്ങളിൽ സംഘടിപ്പിക്കുന്ന പ്രമേഹ ബോധവൽക്കരണ പദ്ധതിയുടെ ഭാഗമായി ഗവ: യു പി എസ് സ്ക്കൂൾ അമ്പലത്തറ, റോട്ടറി ഇൻ്റർനാഷണൽ ട്രിവാൻഡ്രത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/11-03-2022.jpg",
      header: "സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് @ വെള്ളറട",
      location: "ആനപ്പാറ ഫോറസ്റ്റ് ഓഡിറ്റോറിയം.",
      date: "11/03/2022",
      discription:
        "ലോക പ്രമേഹ ദിനത്തോട് അനുബന്ധിച്ച് വെള്ളറട ഗ്രാമപഞ്ചായത്തും,തിരുവനന്തപുരം പ്രേം നസീർ ഫൗണ്ടേഷന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ ലാൽ കൃഷ്ണൻ (ബ്ലോക്ക് പഞ്ചായത്ത് പ്രസിഡൻ്റ്)",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/02-11-2022.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ അമ്പലത്തറ",
      location: "ഗവ:യു പി എസ്, അമ്പലത്തറ.",
      date: "02/11/2022",
      discription:
        "'മിഠായി ' ലോക പ്രമേഹ ദിനത്തോട് അനുബന്ധിച്ച് സ്ക്കൂൾ വിദ്യാർഥികളിലൂടെ പ്രമേഹ അവബോധം കുടുംബത്തിലേയ്ക്കും സമൂഹത്തിലേയ്ക്കും.തിരുവനന്തപുരം ജില്ലയിലെ തിരെഞ്ഞെടുത്ത വിദ്യാലയങ്ങളിൽ സംഘടിപ്പിക്കുന്ന പ്രമേഹ ബോധവൽക്കരണ പദ്ധതിയുടെ ഭാഗമായി ഗവ: യു പി എസ് സ്ക്കൂൾ അമ്പലത്തറ, റോട്ടറി ഇൻ്റർനാഷണൽ ട്രിവാൻഡ്രത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/10-30-2022.jpg",
      header: "സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് @ ആഴിമല",
      location: "ആഴിമല ശിവക്ഷേത്ര ഓഡിറ്റോറിയം.",
      date: "10/30/2022",
      discription:
        "ആഴിമല ശിവക്ഷേത്ര ട്രസ്റ്റും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, കാർഡിയോളജി,ഡയ്ബറ്റോളജി, ഒഫ്താൽമോളജി, ഡെൻറ്റൽ എന്നി വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/10-29-2022.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ കാഞ്ഞിരംപാറ",
      location: "ഇ എം എസ് കമ്മ്യൂണിറ്റി ഹാൾ, കാഞ്ഞിരംപാറ",
      date: "10/29/2022",
      discription:
        "കാഞ്ഞിരംപാറ വി കെ പി റെസിഡൻഷ്യൽ അസോസിയേഷൻ,ട്രിവാൻഡ്രം നാഷണൽ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/10-25-2022.jpg",
      header: "സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് @ വെണ്ണിയൂർ",
      location: "വെണ്ണിയൂർ സി എസ് ഐ ചർച്ച്.",
      date: "10/25/2022",
      discription:
        "വെണ്ണിയൂർ സി എസ് ഐ ചർച്ച്, വെങ്ങാനൂർ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/10-24-2022.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ വെണ്ണിയൂർ",
      location: "ജുവജെൻ ടെൽകാസ് ചിൽഡ്രൻസ് , വെണ്ണിയൂർ.",
      date: "10/24/2022",
      discription:
        "വെണ്ണിയൂർ ജുവജെൻ ടെൽകാസ് ചിൽഡ്രൻസ് വില്ലേജിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/10-23-2022.jpg",
      header: "സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് @ തിരുവനന്തപുരം",
      location: "ഗവ:സംസ്കൃത കോളേജ്,തിരുവനന്തപുരം.",
      date: "10/23/2022",
      discription:
        "തിരുവനന്തപുരം ഗവ:സംസ്കൃത കോളേജ്, ഗാർഡൻ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/10-22-2022.jpg",
      header: "സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് @ ആക്കൂളം",
      location: "ലുലു മാൾ, ആക്കൂളം.",
      date: "10/22/2022",
      discription:
        "തിരുവനന്തപുരം ലുലു മാൾ,ട്രിവാൻഡ്രം മജസറ്റിക് ലയൺസ് ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/10-21-2022.jpg",
      header: "സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് @ ആറ്റിങ്ങൽ",
      location: "ദാറുൽ ഇർഷാദ് ഇസ്ലാമിക് അക്കാദമി ക്യാമ്പസ്,ആറ്റിങ്ങൽ.",
      date: "10/21/2022",
      discription:
        "ദാറുൽ ഇർഷാദ് ഇസ്ലാമിക് അക്കാദമിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/10-19-2022.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ ചെങ്കൊട്ടുക്കോണം",
      location: "ശ്രീ നാരായണ പബ്ലിക് സ്കൂൾ, ചെങ്കൊട്ടുക്കോണം, പോത്തൻകോട്.",
      date: "10/19/2022",
      discription:
        "ശ്രീ നാരായണ ചാരിറ്റബിൾ ട്രസ്റ്റ്,ട്രിവാൻഡ്രം മെട്രോ പോളിസ് യൂണിറ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/10-18-2022.jpg",
      header: "സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് @ മംഗലത്ത്ക്കോണം",
      location: "ബഡ് സ്ക്കൂൾ, മംഗലത്ത്ക്കോണം.",
      date: "10/18/2022",
      discription:
        "മംഗലത്ത്ക്കോണം ബഡ് സ്കൂൾ, വെങ്ങാനൂർ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/10-12-2022.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ ചെങ്കൊട്ടുക്കോണം",
      location: "ശ്രീ നാരായണ പബ്ലിക് സ്കൂൾ, ചെങ്കൊട്ടുക്കോണം, പോത്തൻകോട്.",
      date: "10/12/2022",
      discription:
        "ശ്രീ നാരായണ ചാരിറ്റബിൾ ട്രസ്റ്റ്,ട്രിവാൻഡ്രം മെട്രോ പോളിസ് യൂണിറ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/10-11-2022.jpg",
      header: "സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് @ കോട്ടപ്പുറം",
      location: "വിഴിഞ്ഞം പാരിഷ് ഹാൾ, കോട്ടപ്പുറം.",
      date: "10/11/2022",
      discription:
        "ഗുഡ് ഷെപ്പേർഡ് മിഷൻ, വെങ്ങാനൂർ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/10-10-2022.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ ചാരോട്ടുക്കോണം",
      location: "ചാരോട്ടുക്കോണം മസ്ജിദ് ഹാൾ.",
      date: "10/11/2022",
      discription:
        "കുളത്തൂർ മുസ്ലിം ജുമാ മസ്ജിദ് ചാരിറ്റബിൾ ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/09-22-2022.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ വെങ്ങാനൂർ",
      location: "Dr അംബേദ്കർ കമ്മ്യൂണിറ്റി ഹാൾ വെങ്ങാനൂർ .",
      date: "09/22/2022",
      discription:
        "സീ പോർട്സ് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/09-21-2022.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ അരുവിയോട്",
      location: "താളത്രേയം കലാ സാംസ്കാരിക വേദി, അരുവിയോട്.",
      date: "09/21/2022",
      discription:
        "അരുവിയോട് താളത്രേയം കലാ സാംസ്കാരിക വേദി, ട്രിവാൻഡ്രം റെയിൻബോ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/09-21-2022(1).jpg",
      header: "സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് @ ജവഹർനഗർ",
      location: "എൻ എസ് എസ്  കരയോഗം ഹാൾ ജവഹർനഗർ.",
      date: "09/21/2022",
      discription:
        "ട്രിവാൻഡ്രം രാജധാനി ലയൺസ് ക്ലബ്, ഒയാസിസ് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/09-18-2022.jpg",
      header: "സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് @ സ്വാമിയാർമഠം",
      location: "ഗവ: ഹൈ സ്കൂൾ വീയന്നൂർ, സ്വാമിയാർമഠം.",
      date: "09/18/2022",
      discription:
        "സ്വാമിയാർമഠം ഇന്ത്യൻ നാഷണൽ യൂത്ത് കോൺഗ്രസിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/09-16-2022.jpg",
      header: "സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് @ പേട്ട",
      location: "ഗവ: ഹയർ സെക്കൻഡറി സ്കൂൾ പേട്ട.",
      date: "09/16/2022",
      discription:
        "പേട്ട ഗവ: ഹയർ സെക്കൻഡറി സ്കൂൾ, റോട്ടറി  ട്രിവാൻഡ്രം ക്ലബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ  മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/09-15-2022.jpg",
      header: "സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് @ തക്കല",
      location: "സൃദ്ധി ശ്രീ സായി   ക്ഷേത്രം, ഇരണിയൽ, തക്കല",
      date: "09/15/2022",
      discription:
        "കന്യായകുമാരി സൃദ്ധി ശ്രീ സായി ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/09-14-2022.jpg",
      header: "സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് @ മംഗലത്തുക്കോണം",
      location: "എസ് എൻ ക്ലബ് ഹാൾ, മംഗലത്തുക്കോണം.",
      date: "09/14/2022",
      discription:
        "മംഗലത്ത്ക്കോണം  എസ് എൻ ക്ലബ്, വെങ്ങാനൂർ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/09-13-2022.jpg",
      header: "സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് @ കീഴാറ്റിങ്ങൽ",
      location: "തെക്കേടത്ത് ദേവി ക്ഷേത്ര ഓഡിറ്റോറിയം,കീഴാറ്റിങ്ങൽ.",
      date: "09/13/2022",
      discription:
        "ആറ്റിങ്ങൽ പാലസ് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/09-11-2022.jpg",
      header: "സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് @ മാതാപുരം",
      location: "മാതാ പാരിഷ് ഹാൾ, മാതാപുരം.",
      date: "09/11/2022",
      discription:
        "കെ എൽ സി എ,നിഡ്സ് മാതാപുരം നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/09-10-2022.jpg",
      header: "സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് @ പൂവാർ",
      location: "സെൻ്റ് ആൻ്റണീസ് മലങ്കര കത്തോലിക്ക ചർച്ച് പൂവാർ കല്ലിംഗവിളാകം.",
      date: "09/10/2022",
      discription:
        "പൂവാർ കല്ലിംഗവിളാകം സെൻ്റ് ആൻ്റണീസ് മലങ്കര കത്തോലിക്ക ചർച്ചിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ റവ.ഫാ.ജോൺ പോൾ(ജില്ലാ ഡയറക്ടർ)",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/09-09-2022.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ കുന്നത്തുകാൽ",
      location: "എസ് എൻ ഡീ പി ഹാൾ കുന്നത്തുകാൽ.",
      date: "09/09/2022",
      discription:
        "കുന്നത്തുകാൽ എസ് എൻ ഡീ പി യൂണിറ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/09-07-2022.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ കരമന",
      location: "സ്റ്റാർ ഓഡിറ്റോറിയം, കരമന.",
      date: "09/07/2022",
      discription:
        "കരമന ഏരിയാ നാട്ടൊരുമ ഗ്രാമസഭ സ്വാഗതസംഘം കമ്മിറ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/09-05-2022.jpg",
      header: "സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് @ പെരുങ്കടവിള",
      location: "ആശ്വാസ് കമ്മ്യൂണിറ്റി ഫാർമസി, പെരുങ്കടവിള.",
      date: "09/05/2022",
      discription:
        "ആശ്വാസ് കമ്മ്യൂണിറ്റി ഫാർമസിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ എസ് സുരേന്ദ്രൻ (പ്രസിഡൻ്റ്, പെരുങ്കടവിള ഗ്രാമ പഞ്ചായത്ത്)",
      shortNote: "",
      imageCollection: [],
    },
    // {
    //   cardImage: "assets/img/Pastevents/09-16-2022.jpg",
    //   header: "സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് @ ",
    //   location: "",
    //   date: "09/16/2022",
    //   discription: "",
    //   shortNote: "",
    //   imageCollection: [],
    // },
    {
      cardImage: "assets/img/Pastevents/08-17-2022.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ നെട്ടയം",
      location: "ARR പബ്ലിക്ക് സ്കൂൾ നെട്ടയം",
      date: "08/17/2022",
      discription:
        "നെട്ടയം ARR സ്കൂൾ,വട്ടിയൂർക്കാവ് മോഡൽ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/08-16-2022(1).jpg",
      header: "സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് @ മുട്ടയ്ക്കാട് & ആഴാക്കുളം.",
      location: "കൃപാതീരം ഓൾഡേജ് ഹോം മുട്ടയ്ക്കാട് & ആഴാക്കുളം.",
      date: "08/16/2022",
      discription:
        "ലയൺസ് ക്ലബ് വെങ്ങാനൂർ യുണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/08-16-2022.jpg",
      header: "സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് @ തൈയ്യ്ക്കാട്",
      location: "പോലീസ് ട്രെയിനിംഗ് കോളേജ് തൈയ്യ്ക്കാട്",
      date: "08/16/2022",
      discription:
        "കേരള പോലീസ് അസോസിയേഷൻ തിരുവനന്തപുരം സിറ്റി ജില്ല കമ്മിറ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ആരോഗ്യ ജീവിതം പരിപാടി സംഘടിപ്പിച്ചു.ഈ പരിപാടിയിൽ സ്പെഷ്യാലിറ്റി കാർഡിയോളജി ക്യാമ്പ്, ട്രോമകെയർ പരിശീലനം, ആരോഗ്യ ബോധവൽക്കരണ സെമിനാർ എന്നിവ സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ എ യു സുനിൽകുമാർ(S P ട്രാഫിക് സൗത്ത് സോൺ). കാർഡിയോളജി ക്യാമ്പ് ഡോ:കിരൺ ഗോപിനാഥ്, ട്രോമാകെയർ പരിശീലനം ഡോ: പ്രസൂൺ (ഓർത്തോ വിഭാഗം) ആരോഗ്യ ബോധവൽക്കരണ സെമിനാർ ഡോ: ലളിതാ അപ്പുകുട്ടൻ(നാച്ചറോപതി വിഭാഗം) നേതൃത്വം നൽകി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/08-15-2022.jpg",
      header: "സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് @ ആലംക്കോട്",
      location: "ബ്രഹ്മാലയം ആലംക്കോട് പാങ്ങപ്പാറ .",
      date: "08/15/2022",
      discription:
        "ആലംകോട് റെസിഡൻഷ്യൽ അസോസിയേഷന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/08-14-2022(1).jpg",
      header: "സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് @ നെല്ലിമൂട്",
      location: "ന്യൂ ഹയർ സെക്കൻഡറി സ്കൂൾ നെല്ലിമൂട്.",
      date: "08/14/2022",
      discription:
        "അതിയന്നൂർ ഗ്രാമ പഞ്ചായത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ ആരോഗ്യ മേള സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ വി ശിവൻകുട്ടി എംഎൽഎ ബഹു വിദ്യാഭ്യാസം തൊഴിൽ വകുപ്പ് മന്ത്രി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/08-14-2022.jpg",
      header: "സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് @ മരപ്പാലം",
      location: "മരപ്പാലം, ചിദംബര ജംഗ്ഷൻ ",
      date: "08/14/2022",
      discription:
        "സ്വതന്ത്ര ഇന്ത്യയുടെ 75 ആം വാർഷിക ആഘോഷങ്ങളുടെ ഭാഗമായി വിഴിഞ്ഞം ലയൺസ് ക്ലബ്ബും ഊറ്ററ ശിവഗംഗ സാംസ്‌കാരിക സമിതിയും സംയുക്തമായി നിംസ് മെഡിസിറ്റി യുടെയും സഹകരണത്തോടെ ഞായറാഴ്ച രാവിലെ 9 മണിക്ക് മരപ്പാലം, ചിദംബര ജംഗ്ഷൻ ൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പും, നേത്ര പരിശോധന യും തിമിര ശാസ്ത്ര ക്രിയ ക്യാമ്പും നടത്തുന്നു. ലയൺസ് ഇന്റർനാഷണൽ മുൻ ഡിസ്ട്രിക്ട് ഗവർണർ അലക്സ്‌ കുര്യാക്കോസ് ഉൽഘാടനം നിർവ്വഹിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/08-13-2022.jpg",
      header: "സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് @ കുന്നത്തുക്കാൽ",
      location: "ബി എഫ് എം ചർച്ച് വാൾ വേങ്ങക്കാല,കുന്നത്തുക്കാൽ.",
      date: "08/13/2022",
      discription:
        "വേങ്ങക്കാല ബൈബിൾ ഫെയ്ത്ത് മിഷൻ ചർച്ചിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/08-11-2022.jpg",
      header: "സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് @ വെള്ളാംക്കോട്.കന്യാകുമാരി ജില്ല",
      location: "ഗവ: ഹൈസ്കൂൾ വെള്ളാംക്കോട്.കന്യാകുമാരി ജില്ല.",
      date: "08/11/2022",
      discription:
        "ജൂനിയർ റെഡ് ക്രോസ് യൂണിറ്റ്, ഗവ: ഹൈസ്കൂൾ വെള്ളാംക്കോടും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/08-07-2022(1).jpg",
      header: "സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് @ തോന്നയ്ക്കൽ",
      location: "ജമാ അത്ത് അങ്കണം, മോഹനപുരം , തോന്നയ്ക്കൽ.",
      date: "08/07/2022",
      discription:
        "ഖബറടി മുസ്ലിം ജുമാ അത്ത് പാലിയേറ്റിവ് ഫൗണ്ടേഷനും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ഉദ്ഘാടനം: ശ്രീ സജീഷ് (SHO മംഗലപുരം)",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/07-31-2022.jpg",
      header: "സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് @ മലയം",
      location: "ലിറ്റിൽ ബഡ്സ് & പ്രീസ്കൂൾ മലയം.",
      date: "07/31/2022",
      discription:
        "മലയം എൻഎസ്എസ് കരയോഗം യുണിറ്റ്,ട്രിവാൻഡ്രം ജെംസ് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/07-30-2022.jpg",
      header: "സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് @ വലിയതുറ",
      location: "ബെയിസ് ക്യാമ്പ് വലിയതുറ.",
      date: "07/30/2022",
      discription:
        " ലയൺസ് ഇൻ്റർനാഷണൽ ട്രിവാൻഡ്രം ക്ലബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/07-29-2022.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ നെടുമങ്ങാട്",
      location: "പുത്തൻപള്ളി ഓഡിറ്റോറിയം പനവൂർ, നെടുമങ്ങാട്.",
      date: "07/29/2022",
      discription:
        "നാട്ടൊരുമ പനവൂർ ഏരിയാ കമ്മിറ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/07-23-2022.jpg",
      header: "സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് @ ഇടയ്ക്കോട്",
      location: "എൻഎസ്എസ് കരയോഗം ഹാൾ ഇടയ്ക്കോട്.",
      date: "07/23/2022",
      discription:
        "ഇടയ്ക്കോട് വിവേകാനന്ദ സേവാസമിതി, ക്രിസ്റ്റൽ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/07-21-2022.jpg",
      header: "സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് @ നെടുമങ്ങാട്",
      location: "എൻഎസ്എസ് കരയോഗം ഹാൾ ഇരഞ്ചിയം, നെടുമങ്ങാട്.",
      date: "07/21/2022",
      discription:
        "ഐഡിഎഫ്‌സി ഫസ്റ്റ് ഭാരത് ബാങ്ക് നെടുമങ്ങാട് ബ്രാഞ്ചിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/07-20-2022.jpg",
      header: "സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് @ കല്ലുവെട്ടാൻകുഴി",
      location: "പുലരി റെസിഡൻഷ്യൽ അസോസിയേഷൻ ഓഫീസ്,കല്ലുവെട്ടാൻകുഴി.",
      date: "07/20/2022",
      discription:
        "കല്ലുവെട്ടാൻകുഴി പുലരി റെസിഡൻഷ്യൽ അസോസിയേഷൻ, വെങ്ങാനൂർ ലയൺസ് ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/07-19-2022.jpg",
      header: "സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് @ മുട്ടയ്ക്കാട്",
      location: "എസ് എൻ ഡീ പി ഹാൾ മുട്ടയ്ക്കാട്.",
      date: "07/19/2022",
      discription:
        "എസ് എൻ ഡീ പി യൂണിറ്റ് മുട്ടയ്ക്കാട്, ലയൺസ് ക്ലബ് വെങ്ങാനൂർ യൂണിറ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/07-17-2022.jpg",
      header: "സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് @ ഊരമ്പ്",
      location:
        "സെൻ്റ് മേരീസ് മലങ്കര കാത്തോലിക് ദേവാലയ അങ്കണം കുഴിഞ്ഞാൻവിള , ഊരമ്പ്",
      date: "07/17/2022",
      discription:
        "മലങ്കര കാത്തോലിക് അസോസിയേഷൻ്റയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ആരോഗ്യ - മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, കാർഡിയോളജി, ഗ്യാസ്ട്രാ, ഗൈനെക്, ഓർത്തോ, ഇ എൻ റ്റി, ഡയബറ്റിക്, ഒപ്താൽ, ഡെൻ്റൽ എന്നീ വിഭാഗങ്ങളിലെ വിദഗ്ധ ഡോക്ടർമാർ നേത്യത്വം നൽകി. ",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/07-16-2022.jpg",
      header: "സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് @ ആനയറ",
      location: "സ്വിഫ്റ്റ് ഓഫീസ് ആനയറ",
      date: "07/16/2022",
      discription:
        "KSRTC പുതുതായി ആരംഭിച്ച ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 100-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ് നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/07-13-2022.jpg",
      header: "സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് @ നെയ്യാറ്റിൻകര",
      location: "ശ്രീ ദുർഗ്ഗാ ദേവി ക്ഷേത്ര ഹാൾ ",
      date: "07/13/2022",
      discription:
        "ശ്രീ ദുർഗ്ഗാ ദേവി ക്ഷേത്ര ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/07-13-2022(1).jpg",
      header: "സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് @ ഉത്തരംക്കോട്",
      location: "ഗവ: എച്ച് എസ് സ്ക്കൂൾ ഉത്തരംക്കോട്.",
      date: "07/13/2022",
      discription:
        "(രണ്ടാം ദിനം) ഗവ: എച്ച് എസ് ഉത്തരംക്കോട് ട്രൈബൽ സ്കൂളിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.തുടർച്ചയായ ഓൺലൈൻ പഠനത്തിന്റെ ഭാഗമായി കുട്ടികൾക്ക് ഉണ്ടായെക്കാവുന്ന കാഴ്ച, കേൾവി തകരാറുകൾ തുടക്കത്തിലേ കണ്ടെത്തുന്നതിൻ്റെ ഭാഗമായി ജനറൽ സ്ക്രീനിംഗ്, കാഴ്ച, കേൾവി, ഡെൻ്റൽ പരിശോധന നടത്തി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/07-10-2022.jpg",
      header: "സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് @ ഏലിയാപുരം",
      location: "കർമലമാത ചർച്ച്, ഏലിയാപുരം.",
      date: "07/10/2022",
      discription:
        "ഏലിയാപുരം  കർമലമാത ചർച്ചിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ അഡ്വ ജി സ്റ്റീഫൻ(എം എൽ എ)",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/07-09-2022.jpg",
      header: "സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് @ നെയ്യാർ ഡാം",
      location: "ശ്രീ കൊട്ടരത്ത് ദേവി ക്ഷേത്ര ഹാൾ, നെയ്യാർ ഡാം.",
      date: "07/09/2022",
      discription:
        "ശ്രീ കൊട്ടരത്ത് ദേവി ക്ഷേത്ര ട്രുസ്റ്റും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ അഡ്വ: ജി സ്റ്റീഫൻ (MLA)",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/07-08-2022.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ പാലോട്",
      location: "ആയിരവല്ലി ക്ഷേത്ര ഓഡിറ്റോറിയം പേരയം, പാലോട്",
      date: "07/08/2022",
      discription:
        "കേരളാ കൗമുദി  ബോധ പൗർണമി പാലോട് യൂണിറ്റ്, ആയിരവല്ലി ക്ഷേത്ര ട്രസ്റ്റും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/07-07-2022.jpg",
      header: "സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് (മൂന്നാം ദിവസം) @ തിരുവനന്തപുരം",
      location: "ഫോർട്ട് ഗേൾസ് മിഷൻ സ്കൂൾ.",
      date: "07/07/2022",
      discription:
        "(മൂന്നാം ദിവസം) റോട്ടറി ക്ലബ്ബ് തിരുവനന്തപുരം, ഫോർട്ട് ഗേൾസ് മിഷൻ സ്കൂളിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.തുടർച്ചയായ ഓൺലൈൻ പഠനത്തിന്റെ ഭാഗമായി കുട്ടികൾക്ക് ഉണ്ടായെക്കാവുന്ന കാഴ്ച, കേൾവി തകരാറുകൾ തുടക്കത്തിലേ കണ്ടെത്തുന്നതിൻ്റെ ഭാഗമായി ജനറൽ സ്ക്രീനിംഗ്, കാഴ്ച, കേൾവി , ഡെൻ്റൽ പരിശോധന നടത്തി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/07-06-2022.jpg",
      header: "സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് (രണ്ടാം ദിവസം) @ തിരുവനന്തപുരം",
      location: "ഫോർട്ട് ഗേൾസ് മിഷൻ സ്കൂൾ.",
      date: "07/06/2022",
      discription:
        "(രണ്ടാം ദിവസം) റോട്ടറി ക്ലബ്ബ് തിരുവനന്തപുരം, ഫോർട്ട് ഗേൾസ് മിഷൻ സ്കൂളിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.തുടർച്ചയായ ഓൺലൈൻ പഠനത്തിന്റെ ഭാഗമായി കുട്ടികൾക്ക് ഉണ്ടായെക്കാവുന്ന കാഴ്ച, കേൾവി തകരാറുകൾ തുടക്കത്തിലേ കണ്ടെത്തുന്നതിൻ്റെ ഭാഗമായി ജനറൽ സ്ക്രീനിംഗ്, കാഴ്ച, കേൾവി , ഡെൻ്റൽ പരിശോധന നടത്തി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/07-05-2022.jpg",
      header: "സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് @ തിരുവനന്തപുരം",
      location: "ഫോർട്ട് ഗേൾസ് മിഷൻ സ്കൂൾ.",
      date: "07/05/2022",
      discription:
        "റോട്ടറി ക്ലബ്ബ് തിരുവനന്തപുരം, ഫോർട്ട് ഗേൾസ് മിഷൻ സ്കൂളിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.തുടർച്ചയായ ഓൺലൈൻ പഠനത്തിന്റെ ഭാഗമായി കുട്ടികൾക്ക് ഉണ്ടായെക്കാവുന്ന കാഴ്ച, കേൾവി തകരാറുകൾ തുടക്കത്തിലേ കണ്ടെത്തുന്നതിൻ്റെ ഭാഗമായി ജനറൽ സ്ക്രീനിംഗ്, കാഴ്ച, കേൾവി , ഡെൻ്റൽ പരിശോധന നടത്തി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/07-02-2022.jpg",
      header: "സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് @ ഞാലിക്കോണം",
      location: "ത്രിപ്പാദം ഓഡിറ്റോറിയം ഞാലിക്കോണം.",
      date: "07/02/2022",
      discription:
        "വിൻഡോ ഓഫ് കേരളാ മാഗസീൻ, ശ്രീ ശാസ്താ എൻ എസ് എസ് കരയോഗം  ഞാലിക്കോണം, നേത്ര ചാരിറ്റബിൾ സൊസൈറ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ അഡ്വ കൃഷ്ണകുമാർ(എൻ എസ് എസ് താലൂക്ക്).",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/07-01-2022.jpg",
      header: "സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് @ വിഴിഞ്ഞം",
      location: "കോസ്‌റ്റൽ പോലീസ് സ്റ്റേഷൻ, വിഴിഞ്ഞം",
      date: "07/01/2022",
      discription:
        "വിഴിഞ്ഞം കോസ്‌റ്റൽ പോലീസ് സ്റ്റേഷൻ, വിഴിഞ്ഞം ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ ഷാജി എസ് (അസി. കമ്മിഷണർ ഓഫ് പോലീസ്, ഫോർട്ട് ഡിവിഷൻ).",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/07-01-2022(1).jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ മുതുവിള",
      location: "സ്നേഹതീരം മുതുവിള.",
      date: "07/01/2022",
      discription:
        "ലയൺസ് ഇൻ്റർനാഷണൽ ട്രിവാൻഡ്രം, സ്നേഹതീരം ചാരിറ്റബിൾ ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ സുനേഷ്(SHO പാലോട് P S)",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/06-29-2022.jpg",
      header: "സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് @ കാട്ടാക്കട",
      location: "മൈ ഫാമിലി ക്ലിനിക് കാട്ടാക്കട.",
      date: "06/29/2022",
      discription:
        "മൈ ഫാമിലി ക്ലിനിക് കാട്ടാക്കട, ഐ ഡി എഫ്‌ സി ബാങ്ക് കാട്ടാക്കട ബ്രാഞ്ചിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/06-26-2022.jpg",
      header: "സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് @ നന്നാംകുഴി",
      location: "നന്നാംകുഴി ജംഗ്ഷൻ",
      date: "06/26/2022",
      discription:
        "ഡി വൈ എഫ് ഐ നന്നാംകുഴി യൂണിറ്റ്,ആശ്വാസ് കമ്മ്യൂണിറ്റി ഫാർമസിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ വി അനൂപ് (തിരുവനന്തപുരം ജില്ലാ പ്രസിഡൻ്റ്  ഡി വൈ എഫ് ഐ)",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/06-25-2022.jpg",
      header: "സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് @ ഉഴമലയ്ക്കൽ",
      location: "നെടിയവെങ്കോട് തൊഴിൽ പരിശീലന കേന്ദ്രം,ഉഴമലയ്ക്കൽ",
      date: "06/25/2022",
      discription:
        "എൻ്റെ നാട് ഉഴമലയ്ക്കൽ ചാരിറ്റബിൾ ഓർഗനൈസേഷനും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/06-22-2022.jpg",
      header: "സൗജന്യ സ്പെഷ്യാലിറ്റി മെഡിക്കൽ ക്യാമ്പ് @ അരുവിപ്പുറം",
      location: "എസ്.എൻ‍.ഡി.പി എൽ പീ സ്കൂൾ അരുവിപ്പുറം.",
      date: "06/22/2022",
      discription:
        "അരുവിപ്പുറം എസ്.എൻ‍.ഡി.പി ട്രസ്റ്റ് , എസ്.എൻ‍.ഡി.പി എൽ പീ സ്കൂളിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ സ്പെഷ്യാലിറ്റി മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം   ശിവഗിരി മഠം മുൻ ജനറൽ സെക്രട്ടറിയും അരുവിപ്പുറം മഠം സെക്രട്ടറിയുമായ സ്വാമി സാന്ദ്രാനന്ദ.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/06-22-2022(1).jpg",
      header: "സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് @ ബാലരാമപുരം",
      location: "കൽപഠിയിൽ ഹാൾ, ബാലരാമപുരം.",
      date: "06/22/2022",
      discription:
        "കേരളാ വ്യാപാരി വ്യവസായി ഏകോപന സമിതിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ വി ശിവൻകുട്ടി എംഎൽഎ (ബഹു: പൊതു വിദ്യാഭ്യാസം തൊഴിൽ വകുപ്പ് മന്ത്രി).",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/06-19-2022.jpg",
      header: "സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് @ പിരപ്പൻകോട്",
      location: "അണ്ണൽ, പിരപ്പൻകോട്.",
      date: "06/19/2022",
      discription:
        "കാവിയാട് ദിനകരപണിക്കർ സാംസ്കാരിക വേദിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/06-18-2022.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ പോത്തൻക്കോട്",
      location: "കരുർ റെസിഡൻഷ്യൽ അസോസിയേഷൻ ഹാൾ, പോത്തൻക്കോട്.",
      date: "06/18/2022",
      discription:
        "കരുർ വെൽഫെയർ റെസിഡൻഷ്യൽ അസോസിയേഷൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/06-17-2022.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ അമരവിള",
      location: "സെൻ്റ് ആൻ്റണീസ് ദേവാലയ ഹാൾ, അമരവിള.",
      date: "06/17/2022",
      discription:
        "അമരവിള സെൻ്റ് ആൻ്റണീസ് ദേവാലയത്തിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/06-14-2022.jpg",
      header: "ബ്ലഡ് ഡൊണെഷൻ ക്യാമ്പ് @ പുനലാൽ",
      location: "ഡെയിൽ വ്യൂ കോളേജ്, പുനലാൽ.",
      date: "06/14/2022",
      discription:
        "ലോക ബ്ലഡ് ഡൊണേഴ്സ് ദിനത്തോട് അനുബന്ധിച്ച് പുനലാൽ ഡെയിൽ വ്യൂ കോളേജിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ ബ്ലഡ് ഡൊണെഷൻ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/06-12-2022.jpg",
      header: "സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് @ പിരപ്പൻകോട്",
      location: "പേരയത്തുമുകൾ ജുമാ മസ്ജിദ് ഹാൾ, പിരപ്പൻകോട്.",
      date: "06/12/2022",
      discription:
        "കാവിയാട് സാംസ്കാരിക വേദിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/06-11-2022.jpg",
      header: "സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് @ കല്ലറ",
      location: "എ ആർ ഓഡിറ്റോറിയം, പഴയചന്ത, കല്ലറ.",
      date: "06/11/2022",
      discription:
        "കല്ലറ പഴയചന്ത റെസിഡൻഷ്യൽ അസോസിയേഷനും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ അഡ്വ: ഡി കെ മുരളി (എംഎൽഎ)",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/06-09-2022.jpg",
      header: "സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് @ പിരായിമ്മൂട്",
      location: "എൽ ആൻഡ് റ്റി കൺസ്ട്രക്ഷൻ ഓഫീസ് പിരായിമ്മൂട്.",
      date: "06/09/2022",
      discription:
        "കരോട്- കളിയിക്കവിള ബൈപാസ് റോഡ് നിർമ്മാണ തൊഴിലാളികൾക്കായി എൽ ആൻഡ് റ്റി കൺസ്ട്രക്ഷൻ കമ്പനിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/06-07-2022.jpg",
      header: "സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് @ ആനയറ",
      location: "സ്വിഫ്റ്റ് ഓഫീസ് ആനയറ",
      date: "06/07/2022",
      discription:
        "KSRTC പുതുതായി ആരംഭിച്ച ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 100-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ്( 5) നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/06-05-2022.jpg",
      header: "സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് @ കോവളം",
      location: "എൻ എസ് എസ് ഹാൾ മുട്ടയ്ക്കാട്,കോവളം.",
      date: "06/05/2022",
      discription:
        "സമന്വയ ചാരിറ്റബിൾ ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പും, ആംബുലൻസ് സർവീസ് പദ്ധതിയും പരിസ്ഥിതി ദിനാചരണം സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ സി ജയചന്ദ്രൻ (ഹെൽത്ത് ഇൻസ്പെക്ടർ സി ഹെച്ച് സി വിഴിഞ്ഞം).",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/06-04-2022.jpg",
      header: "സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് @ കാഞ്ഞാംപ്പുറം",
      location: "സെൻ്റ് ജൂഡ് ചർച്ച് , വളളവിള,കാഞ്ഞാംപ്പുറം.",
      date: "06/04/2022",
      discription:
        "നവജോതി ചാരിറ്റബിൾ ട്രസ്റ്റിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം: ഫാ: റിച്ചാർഡ് സക്കറിയാസ്(സെൻ്റ് ജൂഡ് ചർച്ച്, വള്ളവിള).",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/06-03-2022.jpg",
      header:
        "സൗജന്യ മെഗാ കാർഡിയോളജി & സ്പെഷ്യാലിറ്റി മെഡിക്കൽ ക്യാമ്പ്  @ തിരുവട്ടാർ",
      location: "സെൻ്റ് മേരീസ് വൃദ്ധസദനം, മാത്തൂർ, തിരുവട്ടാർ",
      date: "06/03/2022",
      discription:
        "യൂത്ത് കോൺഗ്രസ് മാത്തൂർ, തിരുവട്ടാർ ബ്രാഞ്ച് കമ്മിറ്റിയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ കാർഡിയോളജി & സ്പെഷ്യാലിറ്റി മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/06-02-2022.jpg",
      header: "സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് @ പ്രാവിച്ചമ്പലം",
      location: "വികാസ് ട്യൂഷൻ സെൻ്റർ, ഒലുപ്പുനട,പ്രാവിച്ചമ്പലം.",
      date: "06/02/2022",
      discription:
        "യൂത്ത് കോൺഗ്രസ് പള്ളിച്ചൽ വാർഡ് കമ്മറ്റിയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/05-31-2022.jpg",
      header: "സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ്  @ പെരുംങ്കടവിള",
      location: "പെരുംങ്കടവിള പഞ്ചായത്ത് ഹാൾ.",
      date: "05/31/2022",
      discription:
        'പെരുങ്കടവിള പഞ്ചായത്തും നിംസ് മെഡിസിറ്റിയും സംയുക്തമായി പഞ്ചായത്തിലെ "നെയ്യാറ്റിൻകര പെൻഷൻ പ്ലാൻ "  ഉപഭോക്താക്കൾക്ക് വേണ്ടി സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു ',
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/05-30-2022.jpg",
      header: "സൗജന്യ മെഡിക്കൽ ക്യാമ്പ്  @ ചെങ്കൽ",
      location: "സ്വാതന്ത്ര്യദിന സ്മാരക ഗ്രന്ഥശാല ഹാൾ, ചെങ്കൽ.",
      date: "05/30/2022",
      discription:
        "വി കെ ശ്രീകുമാർ 1-ാം അനുസ്മരണ യോഗവും നിംസ് മെഡിസിറ്റി സൗജന്യ മെഡിക്കൽ ക്യാമ്പും. ക്യാമ്പ് ഉദ്ഘാടനം- ശ്രീ കെ അജിത്ത് കുമാർ (വൈസ് പ്രസിഡൻ്റ് ചെങ്കൽ ഗ്രാമ പഞ്ചായത്ത്)",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/05-29-2022.jpg",
      header: "സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ്  @ പാലോട്",
      location: "AA ഓഡിറ്റോറിയം പാലോട്.",
      date: "05/29/2022",
      discription:
        "പെരിങ്ങമ്മല ഗ്രാമ പഞ്ചായത്ത് പാലോട് വാർഡ് തിരുവനന്തപുരം എലൈറ്റ് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ ഷിനു മടത്തറ (പ്രസിഡൻറ് പെരിങ്ങമ്മല ഗ്രാമ പഞ്ചായത്ത്)",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/05-28-2022.jpg",
      header: "സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ്  @ വേറ്റിനാട്",
      location: "വൈഎംസിഎ വേറ്റിനാട്.",
      date: "05/28/2022",
      discription:
        "തിരുവനന്തപുരം വൈഎംസിഎ,തിരുവനന്തപുരം സിറ്റി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം: ശ്രീമതി ബീന ജയൻ (പ്രസിഡൻറ് വെമ്പായം ഗ്രാമ പഞ്ചായത്ത്)",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/05-27-2022.jpg",
      header: "സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ്  @ മണക്കാട്",
      location: "എൻ എസ് എസ് കരയോഗം ഹാൾ മണക്കാട്.",
      date: "05/27/2022",
      discription:
        "2ാംമത്  ശ്രീ M P വീരേന്ദ്ര കുമാർ അനുസ്മരണവും സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ്. വയലാർ രാമവർമ്മ സാംസ്കാരിക വേദിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ അഡ്വ: ജി അർ അനിൽ (ബഹു: ഭക്ഷ്യ പൊതുവിതരണ ഉപദോക്തൃകാര്യ ലീഗൽ മെട്രോളജി വകുപ്പ് മന്ത്രി)",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/05-26-2022.jpg",
      header: "സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ്  @ ആനയറ",
      location: "സ്വിഫ്റ്റ് ഓഫീസ് ആനയറ.",
      date: "05/26/2022",
      discription:
        "KSRTC പുതുതായി ആരംഭിക്കുന്ന ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 150-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ്(നാലാം ദിനം) നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/05-22-2022.jpg",
      header: "സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ്  @ പാറശ്ശാല",
      location: "സി എസ് ഐ പാരിഷ് ഹാൾ, ആലംപാറ, പാറശ്ശാല",
      date: "05/22/2022",
      discription:
        "സി എസ് ഐ ആലംപാറ CEYF യൂണിറ്റിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/05-21-2022.jpg",
      header: "സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ്  @ വട്ടപ്പാറ",
      location: "ജവഹർ റൂറൽ കോ-ഓപ്പറേറ്റിവ് സൊസൈറ്റി, അമ്പലനഗർ, വട്ടപ്പാറ.",
      date: "05/21/2022",
      discription:
        "വട്ടപ്പാറ മിഷൻ ചാരിറ്റബിൾ സൊസൈറ്റി,തിരുവനന്തപുരം നോർത്ത് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/05-20-2022.jpg",
      header: "സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ്  @ വിതുര",
      location: "ചായം റസിഡൻസ്, വിതുര  ",
      date: "05/20/2022",
      discription:
        "ചായം റസിഡൻസ് അസോസിയേഷനും നെയ്യാറ്റിൻകര നിംസ് മെഡിസിറ്റിയും മലയാള മനോരമയും സംയുക്തമായി സംഘടിപ്പിച്ച ഹൃദയപൂർവ്വം സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് വിതുര സർക്കിൾ ഇൻസ്പെക്ടർ ശ്രീ S.ശ്രീജിത്ത് ഉദ്ഘാടനം ചെയ്തു. ",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/05-18-2022.jpg",
      header: "സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ്  @ കരിക്കുളം",
      location: " ശാലോം ചാരിറ്റബിൾ ട്രസ്റ്റ് ഹാൾ, വലിയതോപ്പ്, കരിക്കുളം ",
      date: "05/18/2022",
      discription:
        "കോസ്റ്റൽ പോലീസ് പൂവാർ സ്റ്റേഷൻറ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/05-17-2022.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ്  @ ഉദയൻകുളങ്ങര",
      location: "ചെങ്കൽ ഗ്രാമ പഞ്ചായത്ത് ഹാൾ, ഉദയൻകുളങ്ങര",
      date: "05/17/2022",
      discription:
        "കേരളാ കൗമുദി ഉദയൻകുളങ്ങര യൂണിറ്റ്, ബോധ പൗർണമി ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/05-16-2022.jpg",
      header: "സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ്  @ കാച്ചാണി",
      location: "ഗവ: ഹൈസ്കൂൾ കാച്ചാണി",
      date: "05/16/2022",
      discription:
        "നേത്ര ചാരിറ്റബിൾ സൊസൈറ്റി, കേരളാ വ്യാപാരി വ്യവസായി ഏകോപന സമിതി കാച്ചാണി യൂണിറ്റിന്റെ യുഗം നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം: ശ്രീമതി പി രമാ  (കാച്ചാണി വാർഡ് കൗൺസിലർ).",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/05-14-2022.jpg",
      header: "സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ്  @ കാട്ടാക്കട",
      location: " ക്രിസ്റ്റ്യൻ കോളേജ് കാട്ടാക്കട.",
      date: "05/14/2022",
      discription:
        " മില്ലേനിയം സ്റ്റാർസ് അസോസിയേഷൻ റീയൂണിയൻ -2001 ബാച്ചിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/05-13-2022.jpg",
      header: "സൗജന്യ മെഗാ മെഡിക്കൽ & രക്ത ദാന ക്യാമ്പ്  @ മൈലക്കര",
      location: "ഗവ:യൂ പി എസ് മൈലക്കര",
      date: "05/13/2022",
      discription:
        "യുവധാര സാംസ്കാരിക സമിതിയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ & രക്ത ദാന ക്യാമ്പ് നടത്തി. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ ലാൽ കൃഷ്ണാ (പ്രസിഡൻറ് പെരുക്കടവിള ഗ്രാമ പഞ്ചായത്ത്) ",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/05-12-2022.jpg",
      header: "സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് @ കാരക്കോണം",
      location: "ഇലഞ്ഞിക്കൽ ഭഗവതി ക്ഷേത്ര ഓഡിറ്റോറിയം,കാരക്കോണം",
      date: "05/12/2022",
      discription:
        "പുരവൂർ ഇലഞ്ഞിക്കൽ ഭഗവതി ക്ഷേത്ര ട്രസ്റ്റ്, ട്രിവാൻഡ്രം റെയിൻബോ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീമതി ബി ലീലാ (പളുകൽ പഞ്ചായത്ത്)",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/05-10-2022.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ സ്വാമിയാർ മഠം",
      location:
        "ശ്രീ ചാമുണ്ഡേശ്വരി ക്ഷേത്ര ഓഡിറ്റോറിയം, മണലിക്കര, സ്വാമിയാർ മഠം, കനൄാകുമാരി ജില്ല.",
      date: "05/10/2022",
      discription:
        "ശ്രീ ചാമുണ്ഡേശ്വരി അമ്മൻ ക്ഷേത്ര ട്രസ്റ്റും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/05-09-2022.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ വഴിമുക്ക്",
      location: "റഷീദ് ഓഡിറ്റോറിയം വഴിമുക്ക്.",
      date: "05/09/2022",
      discription:
        "കേരളാ പ്രവാസി സംഘവും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ സി കെ ഹരീന്ദ്രൻ (എംഎൽഎ പാറശ്ശാല)",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/05-08-2022.jpg",
      header: "സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് @ കൈമനം",
      location: "സാന്ദീപനി സേവാമന്ദിരം, കൈമനം",
      date: "05/08/2022",
      discription:
        "സാന്ദീപനി സേവാ ട്രസ്റ്റും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം: ശ്രീ M S ഫൈസൽ ഖാൻ എംഡി നിംസ് മെഡിസിറ്റി. ജനറൽ സർജറി മേധാവി Dr ഇന്ദിരാ അമ്മ നേതൃത്വത്തിൽ ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി,ഇ എൻ റ്റി, ഓർത്തോ, കാർഡിയോളജി, ഒഫ്താൽമോളജി, ഡെൻ്റൽ എന്നി ഡിപ്പാർട്ട്മെൻ്റുകൾ പങ്കെടുത്തു. ഓട്ടിസം സ്ക്രീനിംഗ്, കേൾവി പരിശോധന, കുട്ടികളിലെ വളർച്ചാ വൈകല്യം, അൾട്രാ സൗണ്ട് സ്കാൻ, ഇ സി ജി അനുബന്ധ പരിശോധനകളും നടത്തി. ക്യാമ്പിൽ 327 ൽപ്പരം പേർ പങ്കെടുത്തു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/05-07-2022.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ ഗാന്ധിപുരം",
      location: "ഗാന്ധിപുരം ഗണപതി ക്ഷേത്ര ഭജനമഠം.",
      date: "05/07/2022",
      discription:
        "യുവമോർച്ച ശ്രീകാര്യം യൂണിറ്റ്,ട്രിവാൻഡ്രം സൂര്യ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ ചെമ്പഴന്തി ഉദയൻ (ശ്രീകാര്യം വാർഡ്).",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/05-06-2022.jpg",
      header: "മെഡിക്കൽ ക്യാമ്പ്(മൂന്നാം ദിനം) @ ആനയറ",
      location: "സ്വിഫ്റ്റ് ഓഫീസ് ആനയറ.",
      date: "05/06/2022",
      discription:
        "KSRTC പുതുതായി ആരംഭിക്കുന്ന ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 300-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ്(മൂന്നാം ദിനം) നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/05-05-2022.jpg",
      header: "സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് @ പോത്തൻകോട്",
      location: "ക്രസൻ്റ് ഓഡിറ്റോറിയം പോത്തൻകോട്",
      date: "05/05/2022",
      discription:
        "പോത്തൻകോട് ഗ്രാമ പഞ്ചായത്ത്, പോത്തൻകോട് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം: ശ്രീ റ്റി ആർ അനിൽ (പ്രസിഡൻറ് പോത്തൻകോട് ഗ്രാമ പഞ്ചായത്ത്).",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/05-02-2022.jpg",
      header: "സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് @ Pallichal",
      location: "ധർമ്മസേവിനി ഗ്രന്ഥശാല ഭഗവതിനട.",
      date: "05/02/2022",
      discription:
        "ധർമ്മസേവിനി ഗ്രന്ഥശാല ഭഗവതിനടയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ ഭഗത് റൂഫസ് (ജില്ലാ പഞ്ചായത്ത് മെമ്പർ).",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/04-30-2022.jpg",
      header: "സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് @ അരുവിക്കര",
      location: "വൈഎംസിഎ ഹാൾ അരുവിക്കര.",
      date: "04/30/2022",
      discription:
        "തിരുവനന്തപുരം വൈഎംസിഎ,തിരുവനന്തപുരം സിറ്റി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം:ശ്രീ കളത്തറ മധു ,( പ്രസിഡൻറ് ഗ്രാമ പഞ്ചായത്ത്, അരുവിക്കര.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/04-26-2022.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ മലയിൻകീഴ്",
      location: "ദ്വാരക ഓഡിറ്റോറിയം മലയിൻകീഴ്.",
      date: "04/26/2022",
      discription:
        "കേരളാ വ്യാപാരി വ്യവസായി ഏകോപന സമിതിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം: ശ്രീ പെരിങ്ങമ്മല രാമചന്ദ്രൻ ( കേരളാ വ്യാപാരി വ്യവസായി ഏകോപന സമിതി തിരുവനന്തപുരം ജില്ലാ പ്രസിഡൻ്റ് ).",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/04-23-2022.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ വെള്ളായണി",
      location: "വിവേകാനന്ദ നഗർ അംഗൻവാടി ,മുകളൂർമൂല, വെള്ളായണി.",
      date: "04/23/2022",
      discription:
        "സ്വാമി വിവേകാനന്ദ  സേവാ സംഘം, ട്രിവാൻഡ്രം ക്രിസ്റ്റൽ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം:Dr കണ്ണൻ (വൈസ് ഡിസ്ട്രിക് ഗവർണർ ലയൺസ് ക്ലബ് ഇൻ്റർനാഷണൽ)",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/04-22-2022.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ കല്ലിയൂർ",
      location: "കല്ലിയൂർ ഗ്രാമ പഞ്ചായത്ത് സ്റ്റേഡിയം.",
      date: "04/22/2022",
      discription:
        "കല്ലിയൂർ സൗത്ത് റെസിഡൻഷ്യൽ അസോസിയേഷനും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ഉദ്ഘാടനം: ശ്രീ സോമശേഖരൻ നായർ (കല്ലിയൂർ ഗ്രാമ പഞ്ചായത്ത്)",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/04-20-2022.jpg",
      header: "സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് @ പുലിയൂർകുറുച്ചി",
      location: "ഗവ: യു പി സ്കൂൾ പുലിയൂർകുറുച്ചി.",
      date: "04/20/2022",
      discription:
        "തമിഴ്നാട് ഗവൺമെന്റ് ഹെൽത്ത് സ്കീം, നൂറുൽ ഇസ്‌ലാം ആർട്ട്സ് ആൻഡ് സയൻസ് കോളേജ്, കുമാരകോവിൽ നാഷണൽ സർവീസ് സ്കീം നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/04-17-2022.jpg",
      header: "സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് @ മണക്കാട്",
      location: "പുത്തൻ റോഡ് റെസിഡൻഷ്യൽ അസോസിയേഷൻ ഹാൾ , മണക്കാട്.",
      date: "04/17/2022",
      discription:
        "മണക്കാട് പുത്തൻ റോഡ് റെസിഡൻഷ്യൽ അസോസിയേഷൻ, ട്രിവാൻഡ്രം കിങ്ങ്സിറ്റി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/04-16-2022.jpg",
      header: "സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് @ കാച്ചാണി",
      location: "ഗവ: ഹൈസ്കൂൾ കാച്ചാണി.",
      date: "04/16/2022",
      discription:
        "ഫെഡറേഷൻ ഓഫ് റെസിഡൻഷ്യൽ അസോസിയേഷൻ വട്ടിയൂർക്കാവ്,വട്ടിയൂർക്കാവ് മോഡൽ ലയൺസ് ക്ലബ്,പുന്നാക്കോണം റെസിഡൻഷ്യൽ അസോസിയേഷനും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീമതി പി രമ ( വാർഡ് കൗൺസിലർ കാച്ചാണി)",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/04-15-2022.jpg",
      header: "സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് @ വെഞ്ഞാറമൂട്",
      location: "എൻ എസ് എസ് വാൾ , പാറയ്ക്കൽ , വെഞ്ഞാറമൂട്.",
      date: "04/15/2022",
      discription:
        "കാവിയാട് ദിനകര പണിക്കർ സാംസ്കാരിക വേദിയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/04-14-2022.jpg",
      header: "സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് @ ശ്രീകാര്യം",
      location: "പഞ്ചതാരകം സാംസ്കാരിക കേന്ദ്രം ശ്രീകാര്യം.",
      date: "04/14/2022",
      discription:
        "പഞ്ചതാരകം സാംസ്കാരിക കേന്ദ്രവും അയ്യൻകോയിക്കൽ റെസിഡൻഷ്യൽ അസോസിയേഷനും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം: ശ്രീ ജെ എസ് പ്രവീൺ (SHO സൈബർ സിറ്റി , കഴക്കൂട്ടം.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/04-13-2022.jpg",
      header: "സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് @ വട്ടിയൂർക്കാവ്",
      location: "കടയൽമുടുബ് ദേവി ക്ഷേത്ര ഹാൾ , വട്ടിയൂർക്കാവ്.",
      date: "04/13/2022",
      discription:
        "കടയൽമുടുബ് ദേവി ക്ഷേത്ര ട്രസ്റ്റും റീജൻസി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/04-11-2022.jpg",
      header: "സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് @ പാലോട്",
      location: "പാലുവള്ളി റെസിഡൻസ് ഹാൾ , പച്ച, പാലോട്",
      date: "04/10/2022",
      discription:
        "പാലുവള്ളി ബ്രദേഴ്സ് റെസിഡൻസ് വെൽഫെയർ അസോസിയേഷ്നും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം:ശ്രീ തെന്നൂർ ശിഹാബ് (ഫ്രാറ്റ് വിതുര മേഖല സെക്രട്ടറി)",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/04-10-2022.jpg",
      header: "മെഡിക്കൽ ക്യാമ്പ്(രണ്ടാം ദിനം) @ ആനയറ",
      location: "സ്വിഫ്റ്റ് ഓഫീസ് ആനയറ.",
      date: "04/10/2022",
      discription:
        "KSRTC പുതുതായി ആരംഭിക്കുന്ന ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 300-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ്(രണ്ടാം ദിനം) നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/04-09-2022.jpg",
      header: "മെഡിക്കൽ ക്യാമ്പ്(ഒന്നാം ദിനം)  @ ആനയറ",
      location: "ഇ- ബസ് ടെർമിനൽ സ്വിഫ്റ്റ് ഓഫീസ് ആനയറ.",
      date: "04/09/2022",
      discription:
        "KSRTC പുതുതായി ആരംഭിക്കുന്ന ദീർഘദൂര സർവീസ് പദ്ധതിയായ ' സ്വിഫ്റ്റ് ' ഭാഗമായി തിരുവനന്തപുരം മുതൽ കാസർകോട് വരെ ഡ്യൂട്ടിക്ക് നിയമിതരായ 300-പേർക്കുളള മെഡിക്കൽ ക്യാമ്പ്(ഒന്നാം ദിനം) നിംസ് മെഡിസിറ്റിയുടെയും ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/04-07-2022.jpg",
      header: "സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ്  @ പുനലാൽ, കാട്ടാക്കട",
      location: "ഡെയിൽവൄൂ കോളേജ്, പുനലാൽ, കാട്ടാക്കട.",
      date: "04/07/2022",
      discription:
        "ലോക ആരോഗ്യ ദിനത്തോട് അനുബന്ധിച്ച് ദി ഡെയിൽവൄൂ കോളേജ് & റിസേർച്ച് സെൻ്ററിൻ്റെയും നിംസ് മെഡിസിറ്റി യുടെ സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പ് ഉദ്ഘാടനം:Dr ദിവ്യാ സദാശിവൻ (ഡിസ്ട്രിക് RCH ഓഫീസർ,തിരുവനന്തപുരം).",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/04-06-2022.jpg",
      header: "സൗജന്യ മെഗാ മെഡിക്കൽ & ബ്ലഡ് ഡൊണേഷൻ ക്യാമ്പ്  @ നെല്ലിമൂട്",
      location: "ശ്രീ മുലയൻതാന്നി ദേവി ക്ഷേത്ര ഓഡിറ്റോറിയം,നെല്ലിമൂട്.",
      date: "04/06/2022",
      discription:
        "നെല്ലിമൂട് മുലയൻതാന്നി ദേവി ക്ഷേത്ര ട്രസ്റ്റ് ബ്ലഡ് ഡൊണേഷസ് അസോസിയേഷനും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ & ബ്ലഡ് ഡൊണേഷൻ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/04-04-2022.jpg",
      header: "സൗജന്യ മെഡിക്കൽ ക്യാമ്പ്  @ കൊല്ലങ്കോട്",
      location: "കൊല്ലങ്കോട് ക്ഷേത്ര ഓഡിറ്റോറിയം.",
      date: "04/04/2022",
      discription:
        "കൊല്ലങ്കോട് തൂക്ക മഹോത്സവത്തിൻ്റെ ഭാഗമായി 11പതിനൊന്നാം വർഷവും നിംസ് മെഡിസിറ്റി യുടെ ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/04-03-2022.jpg",
      header: "സൗജന്യ മെഡിക്കൽ ക്യാമ്പ്  @ കൊല്ലങ്കോട്",
      location: "കൊല്ലങ്കോട് ക്ഷേത്ര ഓഡിറ്റോറിയം.",
      date: "04/03/2022",
      discription:
        "കൊല്ലങ്കോട് തൂക്ക മഹോത്സവത്തിൻ്റെ ഭാഗമായി 11പതിനൊന്നാം വർഷവും നിംസ് മെഡിസിറ്റി യുടെ ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/04-02-2022.jpg",
      header: "സൗജന്യ മെഡിക്കൽ ക്യാമ്പ്  @ കൊല്ലങ്കോട്",
      location: "കൊല്ലങ്കോട് ക്ഷേത്ര ഓഡിറ്റോറിയം.",
      date: "04/02/2022",
      discription:
        "കൊല്ലങ്കോട് തൂക്ക മഹോത്സവത്തിൻ്റെ ഭാഗമായി 11പതിനൊന്നാം വർഷവും നിംസ് മെഡിസിറ്റി യുടെ ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/04-01-2022.jpg",
      header: "സൗജന്യ മെഡിക്കൽ ക്യാമ്പ്  @ കൊല്ലങ്കോട്",
      location: "കൊല്ലങ്കോട് ക്ഷേത്ര ഓഡിറ്റോറിയം.",
      date: "04/01/2022",
      discription:
        "കൊല്ലങ്കോട് തൂക്ക മഹോത്സവത്തിൻ്റെ ഭാഗമായി 11പതിനൊന്നാം വർഷവും നിംസ് മെഡിസിറ്റി യുടെ ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/03-31-2022.jpg",
      header: "സൗജന്യ മെഡിക്കൽ ക്യാമ്പ്  @ നെയ്യാറ്റിൻകര",
      location: "ശ്രീകൃഷ്ണ സ്വാമി ക്ഷേത്ര സ്റ്റാൾ ,നെയ്യാറ്റിൻകര",
      date: "03/31/2022",
      discription:
        "നെയ്യാറ്റിൻകര ശ്രീകൃഷ്ണ സ്വാമി ക്ഷേത്ര ഉത്സവ കമ്മറ്റിയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ  മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/03-30-2022.jpg",
      header: "സൗജന്യ ഏകദിന  മെഡിക്കൽ ക്യാമ്പ്  @ മരപ്പാലം",
      location: "SNDP വാൾ വേങപ്പൊറ്റ,മരപ്പാലം.",
      date: "03/30/2022",
      discription:
        "SNDP യൂത്ത് മൂവ്മെൻ്റ് വേങപ്പൊറ്റ യൂണിറ്റ്, വിഴിഞ്ഞം ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/03-28-2022.jpg",
      header: "സൗജന്യ ഏകദിന  മെഡിക്കൽ ക്യാമ്പ്  @ അരുമാളൂർ",
      location:
        " കരിങ്കൽ ശ്രീ ഭദ്രകാളി ക്ഷേത്ര ട്രസ്റ്റ് ഓഡിറ്റോറിയം, അരുമാളൂർ.",
      date: "03/28/2022",
      discription:
        "കരിങ്കൽ ശ്രീ ഭദ്രകാളി ക്ഷേത്ര ട്രസ്റ്റ് , അരുമാളൂർ VMASC , ട്രിവാൻഡ്രം റെയിൻബോ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ഉദ്ഘാടനം: ശ്രീ സുരേഷ് കുമാർ (ഗ്രാമ പഞ്ചായത്ത് പ്രസിഡൻറ്, മാറനല്ലൂർ)",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/03-27-2022.jpg",
      header: "സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ്  @ മുട്ടത്തറ",
      location: " ശ്രീ പൊന്നറ ശ്രീധരൻ മെമ്മോറിയൽ സ്കൂൾ മുട്ടത്തറ.",
      date: "03/27/2022",
      discription:
        "ഭാരതീയം ട്രസ്റ്റും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ ഫൈസൽ ഖാൻ (എംഡി നിംസ് മെഡിസിറ്റി).",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/03-26-2022.jpg",
      header: "സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ്  @ കാഞ്ഞിരംപാറ",
      location: "ഇ എം എസ് കമ്മ്യൂണിറ്റി ഹാൾ, കാഞ്ഞിരംപാറ",
      date: "03/26/2022",
      discription:
        "വി കെ പി നഗർ റെസിഡൻഷ്യൽ അസോസിയേഷൻ കാഞ്ഞിരംപാറ, ട്രിവാൻഡ്രം ഡിസ്ട്രിക് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/03-25-2022.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ്  @ ഊരുട്ടുക്കാല",
      location: "G R ഓഡിറ്റോറിയം , ഊരുട്ടുക്കാല",
      date: "03/25/2022",
      discription:
        "ദയ ഇൻഡസ്ട്രിയൽ ലിമിറ്റഡും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/03-23-2022.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ്  @ കരിങ്കൽ",
      location: "st ജോർജ്  കമ്മ്യൂണിറ്റി ഹാൾ, കപ്പിയറൈ , കരിങ്കൽ(kk Dist).",
      date: "03/23/2022",
      discription:
        "മരിയഗിരി,മലങ്കര കാത്തോലിക് കോളേജ് നാഷണൽ സർവീസ് സ്കീം നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/03-20-2022.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ്  @ പരുത്തികുഴി",
      location: "PMJ കമ്മ്യൂണിറ്റി ഹാൾ , പരുത്തികുഴി",
      date: "03/20/2022",
      discription:
        "പരുത്തികുഴി ജുമാ മസ്ജിദ് കമ്മറ്റിയും ട്രിവാൻഡ്രം റീജൻസി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/03-19-2022.jpg",
      header: "സൗജന്യ മെഡിക്കൽ ക്യാമ്പ്  @ ആരൃനാട്",
      location: "കീഴ്പാലൂർ കമ്മ്യൂണിറ്റി ഹാൾ , ആരൃനാട്",
      date: "03/19/2022",
      discription:
        "സി പി എം (ഐ) പറണ്ടോട് ലോക്കൽ കമ്മിറ്റിയും ലയൺസ് ക്ലബ് ഇൻ്റർനാഷണൽ ട്രിവാൻഡ്രവും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ  മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/03-17-2022.jpg",
      header: "സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ്  @ അഞ്ചൽ",
      location: "പി ഗോപലൻ സ്മാരക ഓഡിറ്റോറിയം , അഞ്ചൽ",
      date: "03/17/2022",
      discription:
        "അഞ്ചൽ ടൗൺ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/03-16-2022.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ്  @ പുന്നക്കുളം",
      location: "ചിന്നംവിള കമ്മ്യൂണിറ്റി ഹാൾ.",
      date: "03/16/2022",
      discription:
        "ഇന്ത്യൻ നാഷണൽ കോൺഗ്രസ് വാർഡ് കമ്മിറ്റി പുന്നക്കുളം നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/03-15-2022.jpg",
      header: "സൗജന്യ മെഡിക്കൽ ക്യാമ്പ്  @ ഊരുട്ടുക്കാല",
      location: "ശ്രീ ഭദ്രകാളി ക്ഷേത്ര ഓഡിറ്റോറിയം",
      date: "03/15/2022",
      discription:
        "ശ്രീ ഭദ്രകാളി ക്ഷേത്രം ഊരുട്ടുക്കാലയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ പൊങ്കാല മഹോത്സവത്തിനോട് അനുബന്ധിച്ച് നടന്ന സൗജന്യ മെഡിക്കൽ ക്യാമ്പ്.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/03-13-2022.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ്  @ നെടുമങ്ങാട്  .",
      location: "മദ്രസ്സ ഹാൾ പനയമുട്ടം, നെടുമങ്ങാട്.",
      date: "03/13/2022",
      discription:
        "മുഹിയുദദീൻ മുസ്‌ലിം ജുമാ അത്ത് പനയമുട്ടത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/03-12-2022.jpg",
      header: "സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ്  @ പാലോട്  .",
      location: " ശ്രീ ധർമ്മ ശാസ്താ ക്ഷേത്ര ഹാൾ, പച്ച,പാലോട്.",
      date: "03/12/2022",
      discription:
        "ശ്രീ ധർമ്മശാസ്താ ക്ഷേത്രം പച്ച , പാലോട് കേരള കൗമുദി പാലോട് യൂണിറ്റും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/03-10-2022.jpg",
      header: " സൗജന്യ വൃക്ക രോഗ നിർണയ ക്യാമ്പ്  @ നെയ്യാറ്റിൻകര  .",
      location: "നിംസ്  മെഡിസിറ്റി, നെയ്യാറ്റിൻകര",
      date: "03/10/2022",
      discription:
        "ലോക വൃക്കദിനത്തോടനുബന്ധിച്ച്  നിംസ് മെഡിസിറ്റിയിൽ പ്രശസ്ത നെഫ്റോളജിസ്റ്റ് ഡോ. മഞ്ജു തമ്പിയുടെ നേതൃത്വത്തിൽ  സൗജന്യ വൃക്ക രോഗ നിർണയ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/03-08-2022.jpg",
      header:
        "സൗജന്യ  സൂപർ സ്പെഷ്യാലിറ്റി മെഡിക്കൽ ക്യാമ്പ്  @ നെയ്യാറ്റിൻകര  .",
      location: "നിംസ്  മെഡിസിറ്റി, നെയ്യാറ്റിൻകര",
      date: "03/08/2022",
      discription:
        "ലോക  വനിതാ ദിനത്തോടനുബന്ധിച്ച് വനിതകൾക്കായി  നെയ്യാറ്റിൻകര നിംസ്  മെഡിസിറ്റിയിൽ റിട്ട. ഗവണ്മെന്റ് സീനിയർ ജനറൽ സർജൻ  ഡോ. ഇന്ദിരാമ്മയുടെ  നേതൃത്വത്തിൽ   വനിതാ ഡോക്ടർമാർ  സൗജന്യ  സൂപർ സ്പെഷ്യാലിറ്റി   മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/03-03-2022.jpg",
      header: "സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ്  @ തത്തീയൂർ  .",
      location: "ശ്രീ യക്ഷിയമ്മൻ ക്ഷേത്ര ഹാൾ, തത്തീയൂർ",
      date: "03/03/2022",
      discription:
        " ശ്രീ യക്ഷിയമ്മൻ ക്ഷേത്ര ട്രസ്റ്റും തത്തീയൂരും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ ഫൈസൽ ഖാൻ (എംഡി നിംസ് മെഡിസിറ്റി)",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/03-02-2022.jpg",
      header: "സൗജന്യ ഏകദിന  മെഡിക്കൽ ക്യാമ്പ്  @ കുളത്തൂർ  .",
      location: "ക്ഷേത്ര കമ്മറ്റി ഓഫീസ് കുളത്തൂർ.",
      date: "03/02/2022",
      discription:
        " ശ്രീ ഭദ്രകാളി ക്ഷേത്ര ട്രസ്റ്റ് കുളത്തൂർ നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/02-27-2022.jpg",
      header: "സൗജന്യ ഏകദിന  മെഡിക്കൽ ക്യാമ്പ്  @ കുതിരകുളം  .",
      location: "കുതിരകുളം ശ്രീ മഹാദേവ ഭദ്രകാളി ക്ഷേത്ര ഓഡിറ്റോറിയം",
      date: "02/27/2022",
      discription:
        "കാവിയാട് ദിവാകര പണിക്കർ സാംസ്കാരിക കേന്ദ്രവും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/02-26-2022.jpg",
      header: "സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ്  @ വെള്ളനാട്  .",
      location: " KSRTC ഡിപ്പോ വെള്ളനാട്",
      date: "02/26/2022",
      discription:
        "KSRTEA (CITU) യൂണിറ്റ് വെള്ളനാട്, ലയൺസ് ക്ലബ് ഇന്റർനാഷണലിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ സി കെ ഹരികൃഷ്ണൻ (സംസ്ഥാന ജനറസെക്രട്ടറി KSRTEA).",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/02-25-2022.jpg",
      header: "സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ്  @ നീറമൺക്കര  .",
      location: " എൻ എസ് എസ് വനിത കോളേജ് ഓഡിറ്റോറിയം, നീറമൺക്കര.",
      date: "02/25/2022",
      discription:
        "(Day-02) എൻ എസ് എസ് വനിത കോളേജ്, നാഷണൽ സർവീസ് സ്കീം ഫിസിക്കൽ എഡ്യൂക്കേഷൻ ഡിപ്പാർട്ട്മെൻ്റ്, ട്രിവാൻഡ്രം റെയിൻബോ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/02-24-2022.jpg",
      header: "സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ്  @ നീറമൺക്കര  .",
      location: " എൻ എസ് എസ് വനിത കോളേജ് ഓഡിറ്റോറിയം, നീറമൺക്കര.",
      date: "02/24/2022",
      discription:
        "എൻ എസ് എസ് വനിത കോളേജ്, നാഷണൽ സർവീസ് സ്കീം ഫിസിക്കൽ എഡ്യൂക്കേഷൻ ഡിപ്പാർട്ട്മെൻ്റ്, ട്രിവാൻഡ്രം റെയിൻബോ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/02-23-2022.jpg",
      header: "സൗജന്യ മെഗാ   മെഡിക്കൽ ക്യാമ്പ്  @ വഴിമുക്ക്  .",
      location: "വിശ്വനാഥ് ഓഡിറ്റോറിയം വഴിമുക്ക്",
      date: "02/23/2022",
      discription:
        " കേരള ടെക്സൈറ്റൽസ് & ഗാർമെൻ്റ്സ് ഡീലേഴ്സ് വെൽഫെയർ അസോസിയേഷൻ നെയ്യാറ്റിൻകര ബ്രാഞ്ച്, വിഴിഞ്ഞം ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/02-20-2022.jpg",
      header: "സൗജന്യ മെഗാ   മെഡിക്കൽ ക്യാമ്പ്  @ കവലോട്ടുക്കോണം  .",
      location: " ORA ഓഫീസ് കവലോട്ടുക്കോണം",
      date: "02/20/2022",
      discription:
        "ഊട്ടുപർണി റെസിഡൻഷ്യൽ അസോസിയേഷൻ, ട്രിവാൻഡ്രം റീജൻസി ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/02-13-2022.jpg",
      header: "സൗജന്യ ഏകദിന  മെഡിക്കൽ ക്യാമ്പ്  @ പയറ്റുവിള  .",
      location: " ശ്രീ ചാമുണ്ഡേശ്വരി ദേവി ക്ഷേത്ര ഹാൾ, പയറ്റുവിള.",
      date: "02/13/2022",
      discription:
        "ശ്രീ ചാമുണ്ഡേശ്വരി ദേവി ക്ഷേത്രം, ഇടത്തെയ്ക്കോണം ജനത ക്ലബ് പയറ്റുവിളയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/01-26-2022.jpg",
      header: "സൗജന്യ ഏകദിന  മെഡിക്കൽ ക്യാമ്പ്  @ ചാവടിനട  .",
      location: "എസ് ബി മാർജിൻ ഫ്രീ ചാവടിനട.",
      date: "01/26/2022",
      discription:
        "എസ് ബി മാർജിൻഫ്രീ ഷോപ്പും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/01-19-2022.jpg",
      header: "സൗജന്യ ഏകദിന  മെഡിക്കൽ ക്യാമ്പ്  @ ചിതറ  .",
      location: "ഗ്രാമപഞ്ചായത്ത് കമ്യൂണിറ്റി ഹാൾ, ചിതറ, കാരെറ്റ്.",
      date: "01/19/2022",
      discription:
        "ചിതറ ഗ്രാമപഞ്ചായത്തും ലയൺസ് റീജണൽ സോൺ നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ എം എസ് മുരളി (ബഹു. പഞ്ചായത്ത് പ്രസിഡൻ്റ് ചിതറ)",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/01-16-2022.jpg",
      header: "സൗജന്യ ഏകദിന  മെഡിക്കൽ ക്യാമ്പ്  @ കൊഞ്ചിറവിള  .",
      location: "ഭഗവതി വിലാസം എൻഎസ്എസ് കരയോഗം ഹാൾ",
      date: "01/16/2022",
      discription:
        "ട്രിവാൻഡ്രം റീഗൻസി ലയൺസ് ക്ലബ്, കൊഞ്ചിറവിള ഭഗവതി വിലാസം എൻഎസ്എസ് കരയോഗത്തിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/01-09-2022.jpg",
      header: "സൗജന്യ ഏകദിന  മെഡിക്കൽ ക്യാമ്പ്  @ ചെറിയവെളിനല്ലൂർ .",
      location: "K P M HSS ചെറിയവെളിനല്ലൂർ.",
      date: "01/09/2022",
      discription:
        "ഓയൂർ ടൗൺ ലയൺസ് ക്ലബ് , ചെറിയവെളിനല്ലൂർ K P M ഹയർസെക്കൻഡറി സ്കൂളും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/01-08-2022.jpg",
      header: "സൗജന്യ ഏകദിന  മെഡിക്കൽ ക്യാമ്പ്  @ പാലോട് .",
      location: "വൃന്ദാവനം കൺവെൻഷൻ സെൻ്റർ, പാലോട്.",
      date: "01/08/2022",
      discription:
        "കേരള കൗമുദി പാലോട് യൂണിറ്റും ജ്യോതിർഗമയ ഫെസ്റ്റ് 2022 നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/01-02-2022.jpg",
      header: "സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ്  @ കുളത്തൂർ .",
      location: "കുളത്തൂർ എൻഎസ്എസ് കരയോഗ മന്ദിരം",
      date: "01/02/2022",
      discription:
        "കുളത്തൂർ ഗാന്ധി നഗർ റെസിഡൻഷ്യൽ അസോസിയേഷൻ, തിരുവനന്തപുരം സൗത്ത് ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ k ആൻസലൻ ( ബഹു. എം എൽ എ നെയ്യാറ്റിൻകര).",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/12-31-2021.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ്  @ മുടപുരം .",
      location: "മുടപുരം ശിവകൃഷ്ണപുരം ക്ഷേത്ര ഓഡിറ്റോറിയം",
      date: "12/31/2021",
      discription:
        "ആറ്റിങ്ങൽ പാലസ് ലയൺസ് ക്ലബ്, മുടപുരം ശിവകൃഷ്ണപുരം ക്ഷേത്ര ട്രസ്റ്റും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/12-28-2021.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ്  @ മുടവന്മുകൾ.",
      location: "നവശകതി ലൈബ്രറി & റീഡിംഗ് റൂം പുന്നക്കാമുകൾ,മുടവന്മുകൾ",
      date: "12/28/2021",
      discription:
        "നവശകതി ലൈബ്രറി , പൂജപ്പുര ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/12-26-2021.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ്  @ പിരപ്പൻകോട്.",
      location: "വേളാവൂർ, പിരപ്പൻകോട്",
      date: "12/26/2021",
      discription:
        "കാവിയാട് ദിവാകര പണിക്കർ സാംസ്കാരിക കേന്ദ്രവും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/12-23-2021.jpg",
      header: "സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ്  @ വഴിമുക്ക്.",
      location: "മണവാട്ടി ഓഡിറ്റോറിയം വഴിമുക്ക്",
      date: "12/23/2021",
      discription:
        "സിപിഐ (എം) വഴിമുക്ക് ബ്രാഞ്ചും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം സഖാവ് ശ്രീ റ്റി ശ്രീകുമാർ(സിപിഐ (എം) നെയ്യാറ്റിൻകര ഏരിയാ സെക്രട്ടറി)",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/12-22-2021.jpg",
      header: "Free Medical Camp  @ Poonthura.",
      location: "Community Health Centre, Poonthura",
      date: "12/22/2021",
      discription:
        "NIMS College of Nursing and NIMS MEDICITY Organised and Conducted Free Medical Camp at Community Health Centre, Poonthura on 22/12/2021.Many thanks to our MD Mr.M.S Faizal Khan , Doctors,Dental Surgeons,Camp Cordinator, Staffs ,Faculty and Fourth Year Bsc Nursing Students for their support and efforts.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/12-19-2021.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ്  @ നന്ദിയോട്.",
      location: "ഗവ എൽ പി സ്കൂൾ നന്ദിയോട്.",
      date: "12/19/2021",
      discription:
        "കേരള കൗമുദി പാലോട് യൂണിറ്റും ബോധ പൗർണമി ക്ലബും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ ശൈലജ രാജീവൻ ( പ്രസിഡൻ്റ് നന്ദിയോട് ഗ്രാമപഞ്ചായത്ത് )",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/12-18-2021.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ്  @ നാലാഞ്ചിറ.",
      location: "ഗവ: ഹൈസ്കൂൾ പാറോട്ടുക്കോണം, നാലാഞ്ചിറ",
      date: "12/18/2021",
      discription:
        "ട്രിവാൻഡ്രം കോസ്മോപോളിറ്റൻ ലയൺസ് ക്ലബ്ബിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ. ജോൺസൺ ജോസഫ് (കൗൺസിലർ നാലാഞ്ചിറ വാർഡ്)",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/12-12-2021.jpg",
      header: "സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ്  @ പാലുവള്ളി.",
      location: "പാലുവള്ളി ഗുരുമന്ധിരം jn",
      date: "12/12/2021",
      discription:
        "കേരള കൗമുദി പാലോട് യൂണിറ്റും ബോധ പൗർണമി ക്ലബും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ സുധാകരൻ.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/12-11-2021.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ്  @ കഴക്കൂട്ടം.",
      location: "Govt UPS മൺവിള, കഴക്കൂട്ടം",
      date: "12/11/2021",
      discription:
        "തിരു. മേട്രോപ്പോളിസ് ലയൺസ് ക്ലബ്ബിൻ്റെയും സി പി ഐ (എം) ആറ്റിപ്ര ലോക്കൽകമ്മിറ്റി മൺവിള ബ്രാഞ്ചിൻ്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ Dr.രാജേന്ദ്രൻ (PDG)",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/12-07-2021.jpg",
      header: "സൗജന്യ കാർഡിയോ, ജനറൽ, ഫിസിയോതെറാപ്പി ക്യാമ്പ്  @ മ്യൂസിയം.",
      location: "മ്യൂസിയം ",
      date: "12/07/2021",
      discription:
        "ഒളിമ്പിക്സ് വേവും നിംസ് മെഡിസിറ്റിയും സംയുക്ത ആഭിമുഖ്യത്തിൽ മ്യൂസിയം വളപ്പിൽ പ്രഭാത വ്യായാമങ്ങൾക്കായി എത്തുന്നവർക്കായി സൗജന്യ കാർഡിയോ, ജനറൽ, ഫിസിയോതെറാപ്പി ക്യാമ്പ് സംഘടിപ്പിച്ചു.120-ൽപ്പരം ആളുകൾ ക്യാമ്പ് ആനുകൂല്യം പ്രയോജനപ്പെടുത്തി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/12-04-2021.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ്  @ കരകുളം.",
      location: "കൈപ്പാടി ജംഗ്ഷൻ, കരകുളം",
      date: "12/04/2021",
      discription:
        "സി പി ഐ (എം) കൈപ്പാടി ബ്രാഞ്ചും, തിരു. സിറ്റി വെസ്റ്റ് ലയൺസ് ക്ലബ്ബിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ സ: റ്റി സുനിൽ കുമാർ(ബഹു. കരകുളം പഞ്ചായത്ത് വൈസ് പ്രസിഡൻ്റ്).",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/11-28-2021.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ്  @ പറമ്പിക്കോണം.",
      location: "പറമ്പിക്കോണം ബ്രാഞ്ച് ഹാൾ",
      date: "11/28/2021",
      discription:
        "സിപിഐ (എം) മൊട്ടമ്മൂട് ബ്രാഞ്ചും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ അഡ്വ: ഡി സുരേഷ്കുമാർ (പ്രസിഡൻ്റ് തിരു. ജില്ലാ പഞ്ചായത്ത്)",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/11-27-2021.jpg",
      header: "സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ്  @ പാലോട്.",
      location: "പ്രിയദർശിനി മെമ്മോറിയൽ ചാരിറ്റബിൾ ഹാൾ, ചെറ്റച്ചൽ, പാലോട്",
      date: "11/27/2021",
      discription:
        "കേരള കൗമുദി പാലോട് യൂണിറ്റും ബോധ പൗർണമി ക്ലബും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ ജി സുരേന്ദ്രൻ നായർ (വിതുര ഗ്രാമപഞ്ചായത്ത്)",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/11-26-2021.jpg",
      header: "സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ്  @ ചൂളിയാമല.",
      location: "ചൂളിയാമല ഫോറസ്റ്റ് സെക്ഷൻ ഓഫീസ്",
      date: "11/26/2021",
      discription:
        "കേരള വനം വകുപ്പ് പരുത്തിപള്ളി റെയിഞ്ച് നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/11-21-2021.jpg",
      header: "സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ്  @ പുളിയറക്കോണം.",
      location: "പുളിയറക്കോണം ബാങ്ക് ഹാൾ",
      date: "11/21/2021",
      discription:
        "ഡിവൈഎഫ്ഐ പാറമുക്ക് യൂണിറ്റും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ ഐ ബി സതീഷ്(എം എൽ എ).",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/11-20-2021.jpg",
      header: "സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ്  @ നന്ദിയോട്.",
      location: "ചൂടൽ എൻ എം സി ഗ്രന്ഥശാല, നന്ദിയോട്.",
      date: "11/20/2021",
      discription:
        "കേരള കൗമുദി പാലോട് യൂണിറ്റും ബോധ പൗർണമി ക്ലബും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീമതി ജീ കോമളം ( വാമനപുരം ബ്ലോക്ക് പഞ്ചായത്ത് പ്രസിഡൻ്റ്)",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/11-19-2021.jpg",
      header: "സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ്  @ പേരൂർക്കട.",
      location: "ബാപ്പുജി ഗ്രന്ഥശാല ഹാൾ പേരൂർക്കട.",
      date: "11/19/2021",
      discription:
        "പേരൂർക്കട ലയൺസ് ക്ലബ്ബും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ PMJF Lion ശിവകുമാർ.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/11-15-2021.jpg",
      header: "സൗജന്യ പ്രമേഹ രോഗ നിർണ്ണയ ക്യാമ്പ്  @ നെയ്യാറ്റിൻകര.",
      location: "നെയ്യാറ്റിൻകര നിംസ് മെഡിസിറ്റി",
      date: "11/15/2021",
      discription:
        "ലോക പ്രമേഹ ദിനത്തോടനുബന്ധിച്ച്  നെയ്യാറ്റിൻകര നിംസ് മെഡിസിറ്റിയിൽ  സൗജന്യ പ്രമേഹ രോഗ നിർണ്ണയ ക്യാമ്പ് സംഘടിപ്പിച്ചു. പ്രശസ്ത എന്റോ ക്രൈനോളജിസ്റ്റ് ഡോക്ടർ വി.ശശികുമാറിന്റെ നേതൃത്വത്തിൽ നടന്ന  ക്യാമ്പിൽ 380ഓളം പേർ  പങ്കെടുത്തു.  ക്യാമ്പിൽ പങ്കെടുത്തവർക്ക് എച്ച് ബി എ വൺ സി  ,  സി ജി എം ( കണ്ടിന്യുയസ്  ഗ്ലൂക്കോസ്  മോനിറ്ററിങ് സിസ്റ്റം ),  വി പി ടി, യൂറിക്കാസിഡ് തുടങ്ങിയ ടെസ്റ്റുകൾ സൗജന്യമായിരുന്നു. തുടർ ചികിത്സ വേണ്ടവർക്ക്‌ എല്ലാ  ടെസ്റ്റുകൾക്കും  മുപ്പത് ശതമാനം ഡിസ്‌കൗണ്ട് ലഭ്യമാണ്.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/11-14-2021.jpg",
      header: "സൗജന്യ പ്രമേഹ നിർണയ ക്യാമ്പ്  @ വെള്ളനാട്.",
      location: "KSRTC ബസ് സ്റ്റേഷൻ - വെള്ളനാട്",
      date: "11/14/2021",
      discription:
        "ലോക പ്രമേഹ ദിനത്തോനനുബന്ധിച്ചു തിരു. ഇമ്പാക്ട് ലയൺസ് ക്ലബും വെള്ളനാട് യൂണിറ്റിന്റെയും KSRTC വെള്ളനാട് ഡിപ്പോ KSRTEA(CITU) നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ പ്രമേഹ നിർണയ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ഉദ്ഘാടനം : ശ്രീ. സുജിത് സോമൻ ( സംസ്ഥാന സെക്രട്ടറി - KSRTEA), അധ്യക്ഷൻ : ലയൺ എം. സുരേഷ്കുമാർ ( പ്രസിഡന്റ്‌ തിരു. ഇമ്പാക്ട് LC),  സ്വാഗതം : ശ്രീ. G. R. പ്രഭു (KSRTEA),ആശംസകൾ : ശ്രീ. S. ജിനു കുമാർ - KSRTEA, പ്രമേഹ ദിന സന്ദേശം : DR. സ്റ്റീഫൻ ( നിംസ് മെഡിസിറ്റി )",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/11-13-2021.jpg",
      header: "സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ്  @ നന്ദിയോട്.",
      location: "നന്ദിയോട് ഫൈറ്റെർസ് ഗ്രന്ഥശാല ഹാൾ..",
      date: "11/13/2021",
      discription:
        " കേരള കൗമുദി പാലോട് യൂണിറ്റും ബോധ പൗർണമി ക്ലബും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീമതി ശൈലജ രാജീവൻ (പ്രസിഡൻ്റ് നന്ദിയോട് ഗ്രാമപഞ്ചായത്ത്)",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/11-12-2021.jpg",
      header: "സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ്  @ ഈയ്യക്കോട്.",
      location: "ഊരുകുട്ട ഹാൾ ഈയ്യക്കോട്.",
      date: "11/12/2021",
      discription:
        " കേരള കൗമുദി പാലോട് യൂണിറ്റും ബോധ പൗർണമി ക്ലബും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ ഷിനു മടത്തറ (പ്രസിഡന്റ് പെരിങ്ങമ്മല ഗ്രാമപഞ്ചായത്ത്).",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/11-09-2021.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ ഊരൂട്ടൂക്കാല",
      location: "ജി. ആർ കമ്മ്യൂണിറ്റി ആഡിറ്റോറിയം ഊരൂട്ടൂക്കാല.",
      date: "11/09/2021",
      discription:
        " ദിയ ഇൻഡസ്ട്രിസ് ലിമിറ്റഡിന്റെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/11-07-2021.jpg",
      header: "സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ ചിറ്റാഴ",
      location: "ചിറ്റാഴ LP സ്കൂൾ.",
      date: "11/07/2021",
      discription:
        "തിരുവനന്തപുരം മിഡ്ഠൗൺ ലയൺസ് ക്ലബ്ബും ചിറ്റാഴ റസിഡന്റ് അസോസിയേഷനും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീമതി ലേഖറാണി(കരകുളം ഗ്രാമപഞ്ചായത്ത് പ്രസിഡൻ്റ്).",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/11-06-2021.jpg",
      header: "സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് @ പാലോട്",
      location: "ജവഹർ കോളനി പാലോട്.",
      date: "11/06/2021",
      discription:
        "കേരള കൗമുദി പാലോട് യൂണിറ്റും, ബോധ പൗർണമി ക്ലബും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ സി കെ മനോജ് (SHO പാലോട്)",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/11-04-2021.jpg",
      header: "സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് @ മൈലം ",
      location: "YMCA ഹാൾ മൈലം",
      date: "11/04/2021",
      discription:
        "വട്ടിയൂർക്കാവ് മോഡൽ ലയൺസ് ക്ലബ്ബും വട്ടിയൂർക്കാവ് വാർഡ് കമ്മിറ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/10-31-2021.jpg",
      header: "സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് @ വാഴോട്ടുക്കോണം, വട്ടിയൂർക്കാവ് ",
      location: "കമ്മ്യൂണിറ്റി ഹാൾ വാഴോട്ടുക്കോണം",
      date: "10/31/2021",
      discription:
        "വട്ടിയൂർക്കാവ് മോഡൽ ലയൺസ് ക്ലബ്ബും വട്ടിയൂർക്കാവ് വാർഡ് കമ്മിറ്റിയുടെയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/10-30-2021.jpg",
      header: "ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ കുറുപുഴ ",
      location: "കുറുപുഴ സംസ്കാരവർദ്ധിനി ഗ്രന്ഥശാല ആഡിറ്റോറിയം.",
      date: "10/30/2021",
      discription:
        " കുറുപുഴ റെസിഡൻഷ്യൽ അസോസിയേഷൻ,കേരള കൗമുദി പാലോട് യൂണിറ്റും ബോധ പൗർണമി ക്ലബും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ ശശികുമാർ (കുറുപുഴ റെസിഡൻഷ്യൽ അസോസിയേഷൻ പ്രസിഡൻ്റ്)",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/10-23-2021.jpg",
      header: "ഏകദിന മെഡിക്കൽ ക്യാമ്പ് @ പാലോട് ",
      location: "പൗവ്വത്തൂർ റെസിഡൻ്റ്സ് അസോസിയേഷൻ ഹാൾ.",
      date: "10/23/2021",
      discription:
        " കേരള കൗമുദി പാലോട് യൂണിറ്റും, ബോധപൗർണമി ക്ലബ്ബും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീമതി വിനീത ഷിബു (പാലോട് ഗ്രാമപഞ്ചായത്ത്).",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/10-19-2021.jpg",
      header: "സൗജന്യ മെഗാ ആരോഗ്യമേള @ പത്താംകല്ല്, നെടുമങ്ങാട്",
      location: "SKS Hall, SKS Jn, Pathamkallu, Nedumangad",
      date: "10/19/2021",
      discription:
        "സുബൈർ കുഞ്ഞു ഫൗണ്ടേഷനും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ ആരോഗ്യമേള സംഘടിപ്പിച്ചു.ആരോഗ്യമേളയിൽ സൂപ്പർ സ്പെഷ്യാലിറ്റി വിഭാഗങളായ കാർഡിയോളജി, ജനറൽ മെഡിസിൻ, ജനറൽ സർജറി, ഗ്യാസ്ട്രാളജി, ഓർത്തോ, ഇ എൻ റ്റി, ഗൈനക്കോളജി, ഡയബറ്റോളജി ഒഫ്ത്താൽമോളജീ,ഡൻറ്റൽ. അൾട്രാസൗണ്ട് സ്കാനിംഗ്,എക്കോ കാർഡിയോ ഗ്രാം,ഇ സി ജീ,ഓഡിയോമെട്രിക്എസ് ജീ ഒ റ്റീ,ഏസ് ജീ പീ റ്റീ, ബ്ലഡ് പ്രഷർ, ബ്ലഡ് ഷുഗർ, ബി എം ഐ എന്നീ ടെസ്റ്റ് കളും നടത്തി. ക്യാമ്പിൽ പങ്കെടുത്ത 250 ൽപ്പരം രോഗികൾക്ക് സൂപ്പർ സ്പെഷ്യാലിറ്റി വിഭാഗങ്ങളും പരിശോധനകളും പ്രയോജനപ്പെടുത്തി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/10-16-2021.jpg",
      header: "ഏകദിന മെഡിക്കൽ ക്യാമ്പ്   @ വട്ടപ്പൻക്കാട്",
      location: "വി വി അജിത് സ്മാരക ഗ്രന്ഥശാല വട്ടപ്പൻക്കാട്",
      date: "10/16/2021",
      discription:
        "കേരളാ കൗമുദി പാലോട് യൂണിറ്റ്, ബോധ പൗർണമി ക്ലബും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ ഏകദിന  മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീമതി നീതു സജീഷ് (ഗ്രാമപഞ്ചായത്ത് വട്ടപ്പൻക്കാട്)",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/10-15-2021.jpg",
      header: "ഏകദിന മെഡിക്കൽ ക്യാമ്പ്   @ കുട്ടനിന്നത്",
      location: "സിഎസ്ഐ ഹാൾ കുട്ടനിന്നത്",
      date: "10/15/2021",
      discription:
        "സിഎസ്ഐ ചർച്ച് കുട്ടനിന്നതിൽ, തിരുപുറവും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ ഏകദിന മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീമതി ഷീന എസ് ദാസ് ( തിരുപുറം ഗ്രാമപഞ്ചായത്ത് പ്രസിഡൻ്റ്).",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/10-10-2021-1.jpg",
      header: "Free  Medical Camp  @ Vembil Mahadeva Temple",
      location: "Vembil Mahadeva Temple Auditorium.",
      date: "10/10/2021",
      discription:
        "കേരള കൗമുദി -ബോധ പൗർണമി ക്ലബും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീ എസ് വി വിക്രമൻ (കേരള കൗമുദി ചീഫ്) മുഖ്യാഥിതി: ശൈലജ രാജീവൻ (നന്ദിയോട് ഗ്രാമപഞ്ചായത്ത് പ്രസിഡൻ്റ്)",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/10-10-2021.jpg",
      header: "Free  Medical Camp  @ കുളത്തൂർ",
      location: "സ്നേഹതീരം അരശുംമ്മൂട്, കുളത്തൂർ.",
      date: "10/09/2021",
      discription:
        "വട്ടിയൂർക്കാവ് മോഡൽ ലയൺസ് ക്ലബും അരശുംമൂട് കിഴക്കുംക്കര റെസിഡൻഷ്യൽ അസോസിയേഷനും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ ഏകദിന മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീമതി ശ്രീദേവി (ആറ്റിപ്ര വാർഡ് കൗൺസിലർ)",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/10-03-2021.jpg",
      header: "Free  Medical Camp  @ KURAVANKONAM",
      location: "Aji Bhavan, KURAVANKONAM",
      date: "10/03/2021",
      discription:
        " The Trivandrum Impact Lions Club, CPM Karayalathukonam Ward Committee organized a free mega medical camp under the leadership of NIMS Medicity.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/10-02-2021.jpg",
      header: "Free Mega Medical Camp  @ Karakulam",
      location: "പൊയ്പ്പാറ ദേവി ക്ഷേത്ര ഹാൾ, കരകുളം.",
      date: "10/02/2021",
      discription:
        "ട്രിവാൻഡ്രം ഹോസ്റ്റ് ലയൺസ് ക്ലബ്ബ്, സിപിഎം വാർഡ് കിഴക്കേലയും നിംസ് മെഡിസിറ്റിയുടെയും സംയുക്ത ആഭിമുഖ്യത്തിൽ സൗജന്യ മെഗാ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു. ക്യാമ്പ് ഉദ്ഘാടനം ശ്രീമതി .U ലേഖ റാണി (പ്രസിഡൻ്റ് കരകുളം.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/09-29-2021.jpg",
      header: "Mega Medical Camp on World Heart Day @ ഇലഞ്ജിയം",
      location: "ആലുമ്മുട് സാംസ്കാരിക നിലയം ഇലഞ്ജിയം",
      date: "09/29/2021",
      discription:
        "The Kerala State Excise Department jointly organized a mega medical camp on World Heart Day under the joint auspices of Drug Eradication Mission Vimukthi, Nedumangad Government College NSS Unit and NIMS Medicity.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/09-29-2021(1).jpg",
      header: "Free Cardiac Diagnosis Camp at NIMS,Neyanttinkara",
      location: "NIMS Hospital, Neyanttinkara",
      date: "09/29/2021",
      discription:
        "On the occasion of World Heart Day - Free Heart Health Fair organized by NIMS Heart Foundation. Education Minister V. Shivankutty inaugurated the function.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/09-28-2021.jpg",
      header: "Free Cardiac Diagnosis Camp at NIMS,Neyanttinkara",
      location: "NIMS Hospital, Neyanttinkara",
      date: "09/28/2021",
      discription:
        "A two-day free heart diagnosis camp is being held in NIMS Hospital on the occasion of World Heart Day. P.K Basheer MLA inaugurated the function",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/09-26-2021.jpg",
      header: "Free Mega Medical Camp @ Attakkulangara Bismi Nagar.",
      location: "Attakkulangara Bismi Nagar",
      date: "09/26/2021",
      discription:
        "Vizhinjam Lions Club, Attakkulangara CPI(M) Branch organized a free mega medical camp under the auspices of NIMS Medicity. The camp was inaugurated by Shri S A Sunder (CPI(M) Chala Area Secretary) and Chief Guest Shri Lion K Gopakumar Menon.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/209.png",
      header: "Free Medical Camp @ vilappil",
      location: "Kadambanad CSL Church Community Hall, Nedumkuzhi, Vilapilsala",
      date: "09/25/2021",
      discription:
        "Free Mega Medical Camp organized in collaboration with Poojappura Lions Club, Thiruvananthapuram and Chowalloor Ward, Vilapil Panchayat in association with NIMS MEDICITY",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/09-14-2021.jpg",
      header: "Free Medical Camp @ Kovalam",
      location: "Kovalam Police Station Hall",
      date: "09/14/2021",
      discription:
        "വിഴിഞ്ഞം ലയൺസ് ക്ലബ്ബും കോവളം ജനമൈത്രി പോലീസ് സ്റ്റേഷനും സംയുക്തമായി നിംസ് മെഡിസിറ്റി യുടെ സഹകരണത്തോടെ കോവളം പോലീസ് സ്റ്റേഷൻ ഹാളിൽ ജീവിത ശൈലി രോഗനിർണയ ക്യാമ്പും ഡയബെറ്റിസ് അവെർനെസ് സെമിനാറും സംഘടിപ്പിച്ചു. വിഴിഞ്ഞം ലയൺസ് ക്ലബ്ബ് ടസെക്രട്ടറി വിനോദ് കുമാർ അധ്യക്ഷനായ യോഗം കോവളം SHO പ്രൈജു ഉൽഘാടനം ചെയ്തു.   സബ് ഇൻസ്‌പെക്ടർ അനീഷ് മുഖ്യ പ്രഭാഷണവും   ഡോക്ടർ ജിജോ ഡയബറ്റിക് സെമിനാറും നടത്തി. കോവളം CRO ബിജു സ്വാഗതവും വിഴിഞ്ഞം ലയൺസ് ക്ലബ്ബ് പ്രൊജക്റ്റ്‌ കോർഡിനേറ്റർ നന്ദു നന്ദിയും പറഞ്ഞു. എല്ലാ മാസവും രണ്ടാമത്തെ ചൊവ്വാഴ്ച കോവളം സ്റ്റേഷനിലെ ഉദ്യോഗസ്ഥർക്കും അവരുടെ കുടുംബാംഗങ്ങൾക്കും ഈ ക്യാമ്പ് വിഴിഞ്ഞം ലയൺസ് ക്ലബ്ബിന്റെയും കോവളം ജനമൈത്രി പോലീസ് സ്റ്റേഷന്റെ യും നിംസ്  മെഡിസിറ്റി നേതൃത്വത്തിൽ നടന്നു വരുന്നു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/09-11-2021.png",
      header: "Free Medical Camp @ Puravimala, Amboori",
      location: "Govt. Tribal L.P. School,Puravimala",
      date: "09/11/2021",
      discription:
        "Free Mega Medical Camp @ Tribal Settlement Colony Puravimala, Associated with Jyothirgameya Project Under KUITSU . Camp was inaugurated by Sri Sivankutty (Education Minister). Felicitated by Sri C K Hareendran (MLA,Parassala), Dr Asher Ennis Nayagam (Cardiovascular & VATS Surgeon, Nims Medicity).",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/170.jpg",
      header:
        "Free Medical Camp & 75th Independence Day Celebration @ Kunnapuzha",
      location: "Swapnakkoodu Old-Age Home, Kunnapuzha",
      date: "08/15/2021",
      discription:
        "Free Medical Camp @ Muttaikkadu, Kovalam. Associated with S Challenge Memorial Charitable Trust , Kovalam Jenamytri Police & Venganoor Lions Club.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/08-12-2021.jpg",
      header:
        "Free Free Dental,Eye, General Medicine Medical Camp @ Muttaikkadu,Kovalam",
      location: "Muttaikkadu NSS Hall (Challenge Memorial Hall)",
      date: "08/13/2021",
      discription:
        "Free Medical Camp @ Muttaikkadu, Kovalam. Associated with S Challenge Memorial Charitable Trust , Kovalam Jenamytri Police & Venganoor Lions Club.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/08-07-2021.png",
      header: "Free Medical Camp @ Aazhimala",
      location: "Aazhimala Shiva Temple",
      date: "08/07/2021",
      discription:
        "NIMS Medicity Free Medical Camp @ Aazhimala. Associated with Aazhimala Siva Temple Trust & Lions Club Vizhinjam.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/07-01-2021.jpg",
      header: "Doctor's Day Medical Camp @ Puthiyathura",
      location: "Puthiyathura Karimkulam Ward",
      date: "07/01/2021",
      discription:
        "This year's Doctors Day is a time to thank them for their tireless service during the Corona epidemic ... Congratulations to all the doctors who stand up for the country in the field of healthcare in adverse conditions ... Tributes are paid to all the doctors who died due to Covid ...",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/06-31-2021.jpg",
      header: "NIMS Free Medical Camp @ Puthiyathura ",
      location: "Puthiyathura Karimkulam Ward",
      date: "06/31/2021",
      discription:
        "നിംസ് മെഡിസിറ്റിയും പുതിയതുറ കരിംകുളം വാർഡ് യൂത്ത് കോൺഗ്രസ് സമിതിയും സംയുക്തമായി കോവിഡ്‌ മഹാമാരിയിൽ ദുരിതമനുഭവിക്കുന്ന പുതിയതുറ കരിംകുളം വാർഡിലെ ഇരുനൂറ്റിയമ്പതോളം  കുടുംബങ്ങൾക്കായി ഡോ. ആനന്ദ് രാജ്, ഡോ. ഗ്രീഷ്മ എന്നിവരുടെ നേതൃത്വത്തിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പ് സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/spectrum/46.jpg",
      header: "NIMS Spectrum Covid Relief Pension Project ",
      location: "Neyyattinkara Municipality",
      date: "06/10/2021",
      discription:
        "NIMS MEDICITY CovidAid has decided to provide financial assistance to about 250 differently abled children in Neyyattinkara Municipality, Athiyannur, Kollayil, Kottukal Panchayats and Balaramapuram Division. The first installment of the project was handed over to Chairman, Neyyattinkara Municipality, Mr. Rajmohan by NIMS MEDICITY Managing Director Mr. M.S Faisal Khan,  on 10/06/2021 at 11 am and the project was handed over to the Panchayat Representatives.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/07-06-2021.jpg",
      header: "NIMS Free Medical Camp @ Pozhiyoor ",
      location: "Pozhiyoor Beach Ward",
      date: "06/07/2021",
      discription:
        "A medical team comprising of nurses led by Doctors of NIMS Medicity- Dr. Jijo Martin & Dr. Pradeep organized a free medical camp for around 450 families in Pozhiyoor Beach ward.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/spectrum/43.jpg",
      header: "NIMS Spectrum Event @ Venganoor",
      location: "Buds Special School, Venganoor",
      date: "06/05/2021",
      discription:
        "NIMS and PADS have always been working together to provide food kits to over 100 families of children with disabilities on the occasion of World Environment Day at Buds Special School, venganoor.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/spectrum/33.jpg",
      header: "NIMS Spectrum Events @ Panathura.",
      location: "Panathura",
      date: "06/05/2021",
      discription:
        "NIMS and PADS have always been working together to provide food kits to over 100 families of children with disabilities and families of cancer patients on the occasion of World Environment Day at Panathura.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/camp/36.jpg",
      header: "NIMS Harithakam Events @ Vizhinjam ",
      location: " Vizhinjam Janamaithri Police Station, Vizhinjam",
      date: "06/05/2021",
      discription:
        "NIMS Medicity and Vizhinjam Lions Club jointly planted saplings at Vizhinjam Janamaithri Police Station on the occasion of World Environment Day.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/24-04-2021.jpg",
      header: "NIMS Medicity free Medical Camp at Kalladimugham",
      location: "Nannaramoola, Kalladimugham",
      date: "24/04/2021",
      discription:
        "NIMS Medicity Free Medical Camp @ Kalladimugham  associated with Breze Land Residence Association,Kalladimugham.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/19-04-2021.jpg",
      header: "NIMS Medicity free Medical Camp at Sreevaraham",
      location: "Sree Pattom Thanupillai Memorial UPS Sreevaraham",
      date: "19/04/2021",
      discription:
        "NIMS Medicity Free Medical Camp @ Sree Pattom Thanupillai Memorial UPS Sreevaraham associated with Trivandrum National Lions Club & DYFI Peruthanni Area Committee.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/30-03-2021.jpg",
      header: "NIMS Medicity free Medical Camp at Kaliyakkavilai",
      location: "C.K Building,Panankalai, Kaliyakkavilai",
      date: "30/03/2021",
      discription:
        "NIMS Medicity Free Medical Camp @ C.K Building,Panankalai, Kaliyakkavilai  associated with Navajyothi Charitable Society.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/29-03-2021.jpg",
      header: "NIMS Medicity free Medical Camp at Kanjiramkulam",
      location: "Kanjiramkulam",
      date: "29/03/2021",
      discription:
        "NIMS Medicity Free Medical Camp @ Kanjiramkulam associated with Kanjiramkulam Govt. College NSS Unit.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/28-03-2021.jpg",
      header: "NIMS Medicity free Medical Camp at Nanniyode",
      location: "Nanniyode",
      date: "28/03/2021",
      discription:
        "NIMS Medicity Free Speciality Medical Camp @ Nanniyode associated with Pacha Nedumparamb SreeDharmaSastha Temple, Nanniyode.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/21-03-2021.jpg",
      header: "NIMS Medicity free Medical Camp at Panayamuttom",
      location: "Panayamuttom Masjid Nagar",
      date: "21/03/2021",
      discription:
        "NIMS Medicity Free Medical Camp @ Panayamuttom Masjid Nagar associated with Panayamuttom Muhidheen Muslim Jamaath and KMYF Chullalam unit ",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/20-03-2021.jpg",
      header: "NIMS Medicity free Speciality Medical Camp at Thirumala",
      location: "Govt. L P School, Thirumala",
      date: "20/03/2021",
      discription:
        "NIMS medicity Free Speciality Medical Camp @ Govt. L P School, Thirumala associated with Trivandrum Host Lions Club ",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/14-03-2021.jpg",
      header:
        "NIMS Medicity free Mega Medical Camp at Valiyathanimoodu Residence Association",
      location: "Gramasree Hall, Valiyathanimoodu",
      date: "14/03/2021",
      discription:
        "NIMS medicity Free Medical Camp@ Valiyathanimoodu, Thenmala Rd, Elavattom, Kerala.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/11-03-2021.jpg",
      header: "Free Checkup and Seminar in NIMS Medicity",
      location: "Neyyattinkara",
      date: "11/03/2021",
      discription:
        "നിംസ് മെഡിസിറ്റിയിൽ ലോക വൃക്ക ദിനം ആചരിച്ചു.ലോക വൃക്ക ദിനത്തോടനുബന്ധിച്ച് നിംസ് മെഡിസിറ്റിയിൽ സൗജന്യ മെഡിക്കൽ ക്യാമ്പും സെമിനാറും സംഘടിപ്പിച്ചു.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/03-03-2021.jpg",
      header: "NIMS Medicity conducted a medical camp",
      location: "Happy Home",
      date: "03/03/2021",
      discription:
        "സംസാരശേഷിയിൽ അപാകതയോ ശ്രവണ വൈകല്യമോയുള്ളവരെ ആശയവിനിമയത്തിന് സജ്ജരാക്കാൻ അത്യാധുനിക ഉപകരണങ്ങളും അതിൽ വിദഗ്ദ്ധ പരിശീലനം ലഭിച്ചിട്ടുള്ള ഓഡിയോളജിസ്റ്റ്ന്റെ സേവനവും ലഭ്യമായിട്ടുള്ള നിംസ് സ്‌പെക്ട്രത്തിലെ ഓഡിയോളജി & സ്പീച്ച് ലാംഗ്വേജ് വിഭാഗം ഹാപ്പി ഹോം അദ്ദേവാസികൾക്കായി ലോക ശ്രവണ ദിനാചാരണത്തിന്റെ ഭാഗമായി സൗജന്യ കേൾവി പരിശോധന നടത്തി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/02-03-2021.jpg",
      header: "NIMS medicity Free Speciality Medical Camp at Ooruttambalam",
      location: "Ooruttambalam",
      date: "02/03/2021",
      discription:
        "NIMS medicity Free Medical Camp@ Saraswathy Vidyalayam,Ooruttambalam in associated with Namo Seva kendra.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/01-03-2021.jpg",
      header: "NIMS Medicity conducted a medical camp at Koodamnada",
      location: "Koodamnada",
      date: "01/03/2021",
      discription:
        "NIMS Medicity conducted a medical camp (01/03/2021) at Mulayanthanni Madan Thampuran Temple, Koodamnada in association with Blood Relation Charitable Society.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/28-02-2021.jpg",
      header: "NIMS Medicity free Mega Medical Camp at Karaikamandapam",
      location: "St. Antony's School, Karaikamandapam",
      date: "28/02/2021",
      discription:
        "NIMS medicity Free Medical Camp@ St. Antony's School, Karaikamandapam.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/21-02-2021.jpg",
      header: "NIMS Medicity free Mega Medical Camp at Thampanoor",
      location: "S.M.V Higher Secondary School, Thampanoor",
      date: "21/02/2021",
      discription:
        "NIMS medicity Free Medical Camp@ S.M.V Higher Secondary School,Thampanoor.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/14-02-2021.jpg",
      header: "സൂപ്പർ സ്പെഷ്യലിറ്റി മെഗാ  ആരോഗ്യമേള... ",
      location: "Vilapilsala UP School, Vilapilsala",
      date: "14/02/2021",
      discription:
        "BJP മുൻ ദേശീയ സെക്രട്ടറി  പി. കെ. കൃഷ്ണദാസും( ചെയർമാൻ  നാമോസേവാകേന്ദ്രം )കാട്ടാക്കട നാമോസേവാകേന്ദ്രവും നിംസ് മെഡിസിറ്റിയും സംയുക്തമായി സംഘടിപ്പിച്ച സൂപ്പർ സ്പെഷ്യലിറ്റി മെഗാ ആരോഗ്യ മേള  ഇന്ന് വിളപ്പിൽശാല UP സ്കൂളിൽ വെച്ചു നടത്തുകയുണ്ടായി.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/26-01-2020.jpg",
      header: "NIMS Medicity free Mega Medical Camp",
      location: "Peroorkada",
      date: "26/01/2020",
      discription:
        "NIMS Medicity conducted a medical camp (25/01/2020) at KSRTC Bus Complex, Peroorkada in association with NIMS medicity KSRTEA Employees Federation and Haritha Kerala mission Shri.V.K.Prashanth Honourable Member of Legislative assembly, Vattiyoorkkavu inaugurated camp in presence of Lions Club president M.J.F S.Sanagan ,KSRTEA Secretary V.S.Harilal KSRTC Assistant Transport Officer Shri.V. Sadhu kumar and other dignitaries.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/23-01-2020.jpg",
      header: "NIMS Medicity free Mega Medical Camp",
      location: "Kuriyathi,Karamana",
      date: "23/01/2020",
      discription:
        "NIMS medicity Free Medical Camp@ Kuriyathi,Karamana. Associated with Aanandhanilayam Old-age home Kuriyathi & Impact Lions Club Thiruvananthapuram.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/19-01-2020.jpg",
      header: "NIMS Medicity free Mega Medical Camp",
      location: "Kallippara,Palode",
      date: "19/01/2020",
      discription:
        "NIMS medicity Free Medical Camp@ Kallippara,Palode.Associated with Kallippara Residential association,Palode.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/17-01-2020.jpg",
      header: "NIMS Medicity free Mega Medical Camp",
      location: "",
      date: "17/01/2020",
      discription:
        'NIMS Medicity conducted a medical camp today (16-01-2020) at "Rotary Institute for Children in Special care " in association with Prem Nazir Foundation on behalf of 31st death anniversary of Evergreen Malayalam film actor Padma Bhushan PremNazir. Shri.K.Sreekumar, Honourable Mayor, Thiruvananthapuram corporation inaugurated the camp in presence of Shri.Suresh kumar, President ,Prem Nazir foundation, Rotarian MC Jacob ,Vice president , Rotary club , Thiruvananthapuram and other diginitories.',
      shortNote: "Vazhuthacaud, Thiruvananthapuram",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/11-01-2020.jpg",
      header: "NIMS Medicity free Mega Medical Camp",
      location: "Olathanni",
      date: "11/01/2020",
      discription:
        "NIMS medicity Free Mega Medical Camp@ Olathanni.Associated with NIDS Neyyattinkara Ferona Committee.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/07-01-2020.jpg",
      header: "NIMS Medicity free Mega Medical Camp",
      location: "Jawahar colony ,Palode",
      date: "07/01/2020",
      discription:
        "NIMS medicity Free Medical Camp@ Jawahar colony ,Palode.Associated with Govt HS Jawahar colony Palode & Thiruvananthapuram Impact Lions Club.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/04-01-2020.jpg",
      header: "NIMS Medicity free Mega Medical Camp",
      location: "Vizhinjam",
      date: "04/01/2020",
      discription:
        "NIMS medicity Free Medical Camp @ Vizhinjam.Associated with Adani Foundation, Adani Port Pvt Ltd.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/03-01-2020.jpg",
      header: "NIMS Medicity free Mega Medical Camp",
      location: "Pachamala,Parandode",
      date: "03/01/2020",
      discription:
        "NIMS medicity Free Medical Camp @ Pachamala,Parandode.Associated with Impact Lions Club Thiruvananthapuram",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/30-12-2019.jpg",
      header: "NIMS Medicity free Mega Medical Camp",
      location: "Aralummoodu",
      date: "30/12/2019",
      discription:
        "NIMS medicity free medical @ Puthanambalam,Aralummoodu. Associated with SNDP Yogam Puthanambalam Branch.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/27-12-2019.jpg",
      header: "NIMS Medicity free Mega Medical Camp",
      location: "Pothencode",
      date: "27/12/2019",
      discription:
        "NIMS medicity free medical camp@ koythoorkkonam, Pothencode.Associated with winners koythoorkkonam & Blood Donor's Kerala",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/22-12-2019.jpg",
      header: "NIMS Medicity free Mega Medical Camp",
      location: "Kuttikkadu, Kaimanam ",
      date: "22/12/2019",
      discription:
        "NIMS medicity free medical Camp@ Kuttikkadu, Kaimanam . Associated with Kaimanam Kuttikkadu Residential association.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/19-12-2019.jpg",
      header: "NIMS Medicity free Mega Medical Camp",
      location: "Karigal, Thoogapara",
      date: "19/12/2019",
      discription:
        "NIMS medicity free medical Camp@ Karigal, Thoogapara. Associated with Thomas Evan jalikkal Church of India Kattakada.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/14-12-2019.jpg",
      header: "NIMS Medicity free Mega Medical Camp",
      location: "Karamana",
      date: "14/12/2019",
      discription:
        "NIMS Medicity free Mega Medical Camp@ Karamana. Associated with Kerala Brahmin Sabha, Karamana.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/11-12-2019.jpg",
      header: "NIMS Medicity free Mega Medical Camp",
      location: "Uppalam Road, Statue",
      date: "11/12/2019",
      discription:
        "NIMS medicity free medical Camp@ Uppalam Road, Statue. Associated with Uppalam Road Residential Association & Lions Club Of Trivandrum Heavens.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/08-12-2019.jpg",
      header: "NIMS Medicity free Mega Medical Camp",
      location: "vizhinjam",
      date: "08/12/2019",
      discription:
        "NIMS medicity free medical Camp@ vizhinjam. Associated with Jenamytri Police Vizhinjam & Kadalora Jagradha Samithi.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/nophoto.jpg",
      header: "NIMS Medicity free Mega Medical Camp",
      location: "Perigammala, Palode",
      date: "05/12/2019",
      discription:
        "NIMS medicity free Mega Medical Camp@ Perigammala, Palode. Associated with Thanal Mission For Charity, Perigammala.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/01-12-2019.jpg",
      header: "NIMS Medicity free Mega Medical Camp",
      location: "Pulluvila",
      date: "01/12/2019",
      discription:
        "NIMS medicity free medical Camp@ Chembakaraman Thurai, Pulluvila. Associated with Kanjiramkkulam Police Station & kadalora Jagradha SAMITHI.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/29-11-2019.jpg",
      header: "NIMS Medicity free Mega Medical Camp",
      location: "Nedumangad",
      date: "29/11/2019",
      discription:
        "NIMS medicity Super Speciality Medical Camp @ KSRTC Bus stand, Nedumangad. Associated with KSRTEA Nedumangad Unit and Lions Club Trivandrum",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/23-11-2019.jpg",
      header: "NIMS Medicity free Mega Medical Camp",
      location: "Nagercoil",
      date: "23/11/2019",
      discription:
        "NIMS medicity free Mega Medical Camp @Nagercoil. Associated with Lions Club Nagercoil, IS IT school Nagercoil & Tamilnadu Govt Chief Ministers Comprehensive Health Insurance Scheme.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/17-11-2019.jpg",
      header: "NIMS Medicity free Mega Medical Camp",
      location: "Chappath",
      date: "17/11/2019",
      discription:
        "NIMS medicity free Mega Medical Camp @ Chappath. Associated With Jenamytri Police Station Vizhinjam, Kottukal Ghss 1990 Batch & Lions Club Vizhinjam.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/14-11-2019.jpg",
      header: "NIMS Medicity free Mega Medical Camp",
      location: "",
      date: "14/11/2019",
      discription:
        "NIMS Medicity and NICER (NIMS Centre of Endocrinology and Research Centre) are jointly organizing a series of medical camps extending over a period of one month in connection with World Diabetics Day.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/10-11-2019.jpg",
      header: "NIMS Medicity free Mega Medical Camp",
      location: "",
      date: "10/11/2019",
      discription:
        "NIMS Medicity and NICER (NIMS Centre of Endocrinology and Research Centre) are jointly organizing a series of medical camps extending over a period of one month in connection with World Diabetics Day.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/06-11-2019.jpg",
      header: "NIMS Medicity free Mega Medical Camp",
      location: "",
      date: "06/11/2019",
      discription:
        "NIMS Medicity and NICER (NIMS Centre of Endocrinology and Research Centre) are jointly organizing a series of medical camps extending over a period of one month in connection with World Diabetics Day.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/04-11-2019.jpg",
      header: "NIMS Medicity free Mega Medical Camp",
      location: "",
      date: "04/11/2019",
      discription:
        "NIMS Medicity and NICER (NIMS Centre of Endocrinology and Research Centre) are jointly organizing a series of medical camps extending over a period of one month in connection with World Diabetics Day.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/02-11-2019.jpg",
      header: "NIMS Medicity free Mega Medical Camp",
      location: "Aralumoodu.",
      date: "02/11/2019",
      discription:
        "NIMS Medicity and NICER (NIMS Centre of Endocrinology and Research Centre) are jointly organizing a series of medical camps extending over a period of one month in connection with World Diabetics Day. The first medical camp of this series was conducted at Sri Vivekananda Memorial Public School, Aralumoodu.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/nophoto.jpg",
      header: "NIMS Medicity free Mega Medical Camp",
      location: "Chullimanoor",
      date: "03/10/2019",
      discription:
        "NIMS medicity free medical Camp @ Chullimanoor. Associated with Sri K Karunakaran Charitable Foundation.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/29-10-2019.jpg",
      header: "NIMS Medicity free Mega Medical Camp",
      location: "Nanthancode",
      date: "29/10/2019",
      discription:
        "NIMS medicity free medical Camp @ Nanthancode. Associated with Weeny Whiz Elementary School Nanthancode.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/25-10-2019.jpg",
      header: "NIMS Medicity free Mega Medical Camp",
      location: "Neeramankara",
      date: "25/10/2019",
      discription:
        "NIMS medicity Super Speciality Medical Camp @ Neeramankara. Associated with T V Sundharam Iyangar & Sons Limited.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/21-10-2019.jpg",
      header: "NIMS Medicity free Mega Medical Camp",
      location: " Karichara, Kaniyapuram",
      date: "21/10/2019",
      discription:
        "NIMS medicity free medical Camp P @ Karichara, Kaniyapuram. Associated with Karichara Residential Association Kaniyapuram.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/19-10-2019.jpg",
      header: "NIMS Medicity free Mega Medical Camp",
      location: "Colachel",
      date: "19/10/2019",
      discription:
        "NIMS medicity free medical Camp @ Colachel. Associated with Tamilnadu Muslim Munnetra Kazhakam & Colachel Muslim Muhallam.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/14-10-2019.jpg",
      header: "NIMS Medicity free Mega Medical Camp",
      location: "Pallichal",
      date: "14/10/2019",
      discription:
        "NIMS medicity free medical Camp @ Pallichal. Associated with Pallichal Grama Panchayath & Lions Club Thiruvananthapuram.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/09-10-2019.jpg",
      header: "NIMS Medicity free Mega Medical Camp",
      location: "Pallichal",
      date: "09/10/2019",
      discription:
        "NIMS medicity free medical Camp @ Pallichal. Associated with Pallichal Grama Panchayath & Lions Club Thiruvananthapuram.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/02-10-2019.jpg",
      header: "NIMS Medicity free Mega Medical Camp",
      location: "Vellayambalam",
      date: "02/10/2019",
      discription:
        "NIMS medicity free medical Camp & Run For Health @ Vellayambalam. Associated with Senior Citizen's Association Thiruvananthapuram.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/01-12-2019.jpg",
      header: "NIMS Medicity free Mega Medical Camp",
      location: "Venganoor",
      date: "02/10/2019",
      discription:
        "NIMS medicity free medical Camp @ Venganoor. Associated with Govt Ghss Venganoor.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/28-09-2019.jpg",
      header: "NIMS Medicity free Mega Medical Camp",
      location: "Pattoor",
      date: "28/09/2019",
      discription:
        "NIMS Medicity Mega Medical Camp@ Pattoor. Associated With As Pharma Care, Pattoor.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/02-09-2019.jpg",
      header: "NIMS Medicity free Mega Medical Camp",
      location: "Chenkodi, Kulasekharam",
      date: "02/09/2019",
      discription:
        "NIMS Medicity Free Mega Medical Camp @ Chenkodi, Kulasekharam. Associated With Youth Congress Committee, Chenkodi.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/01-09-2019.jpg",
      header: "NIMS Medicity free Mega Medical Camp",
      location: "Karikkulam, Pulluvila",
      date: "01/09/2019",
      discription:
        "NIMS Medicity Free Medical Camp & Awareness Programme @ Karikkulam, Pulluvila. Associated With Excise Range Office Thirupuram & Vimukthi.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/15-09-2019.jpg",
      header: "NIMS Medicity free Mega Medical Camp",
      location: "Nemom",
      date: "15/09/2019",
      discription:
        "NIMS Medicity Free Medical Camp @ Nemom. Associated With Naduvathvila Ayilyamkavu Temple Trust & Jems Lions Club Thiruvananthapuram.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/30-09-2019.jpg",
      header: "NIMS Medicity free Mega Medical Camp",
      location: "vizhinjam",
      date: "30/09/2019",
      discription:
        "NIMS Medicity Free Medical Camp @vizhinjam. Associated With Lions Club International Kovalam Unit And Ima Thiruvananthapuram.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/04-08-2019.jpg",
      header: "NIMS Medicity free Mega Medical Camp",
      location: "Anchuthengu, Kadaikkavoor",
      date: "04/08/2019",
      discription:
        "NIMS Medicity Free Medical Camp @ Anchuthengu, Kadaikkavoor. Associated With Idfc Bharath Financial Enterprises Ltd.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/09-08-2019.jpg",
      header: "NIMS Medicity free Mega Medical Camp",
      location: "Pulluvila",
      date: "09/08/2019",
      discription:
        "NIMS Medicity Mega Medical Camp@ Pulluvila. Associated With Tsss Ferona & Carmel School Vazhuthacadu.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/12-09-2019.jpg",
      header: "NIMS Medicity free Mega Medical Camp",
      location: "Pulluvila",
      date: "12/09/2019",
      discription:
        "NIMS Medicity Free Medical Camp @ Pulluvila. Associated With Swanthanam Charitable Society & Thanalmaram Group.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/13-08-2019.jpg",
      header: "NIMS Medicity free Mega Medical Camp",
      location: "Pallichal",
      date: "13/08/2019",
      discription:
        "NIMS Medicity Free Medical Camp @ Pallichal. Associated With Nova Lions Club Thiruvananthapuram, Sangamytri Karshikolpanna Vipanana Kendram & Ima Trivandrum.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/16-08-2019.jpg",
      header: "NIMS Medicity free Mega Medical Camp",
      location: "Chuttayil Kilimanoor",
      date: "16/08/2019",
      discription:
        "NIMS Medicity Free Medical Camp @ Chuttayil Kilimanoor. Associated With Juma-ath Chuttayil, Kilimanoor.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/20-08-2019.jpg",
      header: "NIMS Medicity free Mega Medical Camp",
      location: "Palayam",
      date: "20/08/2019",
      discription:
        "Noorul Islam Centre For Higher Education & Nims Medicity Successfully Completed Two Days Audiology Evaluation Camp For Children With Special Needs @ Crd Special School, Lms Compound, Palayam. It Gives Good Learning Experience For Baslp Students. It Also Provides Orientation Class, Hands Of Training, Group Discussion Etc.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/25-08-2019.jpg",
      header: "NIMS Medicity free Mega Medical Camp",
      location: "Eranchiyam, Aanad",
      date: "25/08/2019",
      discription:
        "NIMS Medicity Free Medical Camp @ Eranchiyam, Aanad. Associated With K Karunakaran Charitable Foundation & Intuc Eranchiyam Unit.",
      shortNote: "",
      imageCollection: [],
    },

    {
      cardImage: "assets/img/Pastevents/29-08-2019.jpg",
      header: "NIMS Medicity free Mega Medical Camp",
      location: "Valppara",
      date: "29/08/2019",
      discription:
        "NIMS Medicity Free Medical Camp @ Valppara(Tribal Settlement) Kottoor. Associated With Kerala Section Of Seventh Day Youth Ministry.",
      shortNote: "",
      imageCollection: [],
    },

    {
      cardImage: "assets/img/Pastevents/22-07-2019.jpg",
      header: "NIMS Medicity free Mega Medical Camp",
      location: "Malayinkavu, Vellarada",
      date: "22/07/2019",
      discription:
        "NIMS Medicity Free Oncology Screening & Speciality Medical Camp@ Malayinkavu, Vellarada. Associated With Csi Church Bedhelpuram, Malayinkavu.",
      shortNote: "",
      imageCollection: [],
    },

    {
      cardImage: "assets/img/Pastevents/20-07-2019.jpg",
      header: "NIMS Medicity free Mega Medical Camp",
      location: "Vizhinjam",
      date: "20/07/2019",
      discription:
        "NIMS Medicity Free Medical Camp @ Vizhinjam. Associated With Vizhinjam Jenamytri Police Station & Lions Club Vizhinjam.",
      shortNote: "",
      imageCollection: [],
    },

    {
      cardImage: "assets/img/Pastevents/15-07-2019.jpg",
      header: "NIMS Medicity free Mega Medical Camp",
      location: "Mukkola",
      date: "15/07/2019",
      discription:
        "NIMS Medicity Free Medical Camp @ Mukkola. Associated With Muthoot Fincorp Limited, Mukkola.",
      shortNote: "",
      imageCollection: [],
    },

    {
      cardImage: "assets/img/Pastevents/12-07-2019.jpg",
      header: "NIMS Medicity free Mega Medical Camp",
      location: "Balaramapuram",
      date: "12/07/2019",
      discription:
        "NIMS Medicity Free Medical Camp @ Balaramapuram. Associated With Muthoot Fincorp Limited, Balaramapuram.",
      shortNote: "",
      imageCollection: [],
    },

    {
      cardImage: "assets/img/Pastevents/08-07-2019.jpg",
      header: "NIMS Medicity free Mega Medical Camp",
      location: "Statue,TVM",
      date: "08/07/2019",
      discription:
        "NIMS Medicity Free Medical Camp @ Statue. Associated With Thiruvananthapuram Corporation & Indus Moters Pvt, Pattom.",
      shortNote: "",
      imageCollection: [],
    },

    {
      cardImage: "assets/img/Pastevents/03-07-2019.jpg",
      header: "NIMS Medicity free Mega Medical Camp",
      location: "Venganoor",
      date: "03/07/2019",
      discription:
        "NIMS Medicity Free Medical Camp @ Venganoor. Associated With Noble Lions Club Thiruvananthapuram & Bhss Venganoor 1986-87 Ssc Batch.",
      shortNote: "",
      imageCollection: [],
    },

    {
      cardImage: "assets/img/Pastevents/25-06-2019.jpg",
      header: "NIMS Medicity free Mega Medical Camp",
      location: "Vencodu, Karakulam",
      date: "25/06/2019",
      discription:
        "NIMS Medicity Free Medical Camp @ Vencodu, Karakulam. Associated With Bharath Garden, Plathara.",
      shortNote: "",
      imageCollection: [],
    },

    {
      cardImage: "assets/img/Pastevents/22-07-20191.jpg",
      header: "NIMS Medicity free Mega Medical Camp",
      location: "Kovalam",
      date: "22/07/2019",
      discription:
        "NIMS Medicity Free Medical Camp @ Kovalam. Associated With Muthoot Fincorp Limited Kovalam Branch.",
      shortNote: "",
      imageCollection: [],
    },

    {
      cardImage: "assets/img/Pastevents/20-06-2019.jpg",
      header: "NIMS Medicity free Mega Medical Camp",
      location: "Sreekariyam",
      date: "20/06/2019",
      discription:
        "NIMS Medicity Free Medical Camp @ Sreekariyam. Associated With Idfc Bharath Financial Enterprises Ltd.",
      shortNote: "",
      imageCollection: [],
    },

    {
      cardImage: "assets/img/Pastevents/18-06-2019.jpg",
      header: "NIMS Medicity free Mega Medical Camp",
      location: "Perigammala",
      date: "18/06/2019",
      discription:
        "NIMS Medicity Free Medical Camp @ Perigammala. Associated With Sndp Yogam Kovalam Unit & Lions Club Kovalam Unit.",
      shortNote: "",
      imageCollection: [],
    },

    {
      cardImage: "assets/img/Pastevents/15-06-2019.jpg",
      header: "NIMS Medicity free Mega Medical Camp",
      location: "Kuttichal",
      date: "15/06/2019",
      discription:
        "NIMS Medicity Free Medical Camp @ Kuttichal. Associated With Pachakkadu Sree Chamundeswari Temple Trust Kuttichal.",
      shortNote: "",
      imageCollection: [],
    },

    {
      cardImage: "assets/img/Pastevents/13-06-2019.jpg",
      header: "NIMS Medicity free Mega Medical Camp",
      location: "Ganapathipuram, Amaravila.",
      date: "13/06/2019",
      discription:
        "NIMS Medicity Free Medical Camp @ Ganapathipuram, Amaravila. Associated With St Anthony's Church Amaravila.",
      shortNote: "",
      imageCollection: [],
    },

    {
      cardImage: "assets/img/Pastevents/09-06-2019.jpg",
      header: "NIMS Medicity free Mega Medical Camp",
      location: "Erumbil,neyyattinkara.",
      date: "09/06/2019",
      discription:
        "NIMS Medicity Free Mega Medical Camp @ Erumbil,neyyattinkara. Associated With Csi Church Erumbil.",
      shortNote: "",
      imageCollection: [],
    },

    {
      cardImage: "assets/img/Pastevents/nophoto.jpg",
      header: "NIMS Medicity free Mega Medical Camp",
      location: "Elankam, Udayankulangara",
      date: "06/06/2019",
      discription:
        "NIMS Medicity Free Medical Camp @ Elankam, Udayankulangara. Associated With L&t Construction And Road Ways.",
      shortNote: "",
      imageCollection: [],
    },

    {
      cardImage: "assets/img/Pastevents/04-06-2019.jpg",
      header: "NIMS Medicity free Mega Medical Camp",
      location: "Pazhayakkada",
      date: "04/06/2019",
      discription:
        "NIMS Medicity Free Medical Camp @ Pazhayakkada. Associated With Muthoot Fincorp Limited Pazhayakkada Branch.",
      shortNote: "",
      imageCollection: [],
    },

    {
      cardImage: "assets/img/Pastevents/30-05-2019.jpg",
      header: "NIMS Medicity free Mega Medical Camp",
      location: "Edapazhinji",
      date: "30/05/2019",
      discription:
        "NIMS Medicity Free Medical Camp @ Edapazhinji. Associated With Muthoot Fincorp Limited, Edapazhinji Branch.",
      shortNote: "",
      imageCollection: [],
    },

    {
      cardImage: "assets/img/Pastevents/28-05-2019.jpg",
      header: "NIMS Medicity free Mega Medical Camp",
      location: "Parithikkuzhi, Aryanadu",
      date: "28/05/2019",
      discription:
        "Nims Medicity Free Medical Camp @ Parithikkuzhi, Aryanadu. Associated With Kerala Arts Youth & Rural Development Centre, Parithikkuzhi.",
      shortNote: "",
      imageCollection: [],
    },

    {
      cardImage: "assets/img/Pastevents/25-05-2019.jpg",
      header: "NIMS Medicity free Mega Medical Camp",
      location: "Poojappura",
      date: "25/05/2019",
      discription:
        "NIMS Medicity Free Medical Camp @ Poojappura. Associated With Muthoot Fincorp Limited, Poojappura.",
      shortNote: "",
      imageCollection: [],
    },

    {
      cardImage: "assets/img/Pastevents/09-05-2019.jpg",
      header: "NIMS Medicity free Mega Medical Camp",
      location: "Kuriyanvila, Kaliyikkavilai.",
      date: "09/05/2019",
      discription:
        "NIMS Medicity Free Medical Camp @ Kuriyanvila, Kaliyikkavilai. Associated with Sree Bbhadrakali Temple Trust, Kuriyanvila.",
      shortNote: "",
      imageCollection: [],
    },

    {
      cardImage: "assets/img/Pastevents/12-05-2019.jpg",
      header: "NIMS Medicity free Mega Medical Camp",
      location: "Palayam",
      date: "12/05/2019",
      discription:
        "NIMS Medicity Free Medical Camp @ Palayam. Associated with Mathru Srishti 2019 Medi Expo.",
      shortNote: "",
      imageCollection: [],
    },

    {
      cardImage: "assets/img/Pastevents/14-05-2019.jpg",
      header: "NIMS Medicity free Mega Medical Camp",
      location: "Marayamutam",
      date: "14/05/2019",
      discription:
        "NIMS Medicity Free Medical Camp @ Marayamutam. Associated with Muthoot Fincorp Limited, Marayamutam",
      shortNote: "",
      imageCollection: [],
    },

    {
      cardImage: "assets/img/Pastevents/18-05-2019.jpg",
      header: "NIMS Medicity free Mega Medical Camp",
      location: "Mambhazhakkara",
      date: "18/05/2019",
      discription:
        "NIMS Medicity Free Medical Camp @ Mambhazhakkara. Associated with VSDP Mambhazhakkara Samathwa Samajam.",
      shortNote: "",
      imageCollection: [],
    },

    {
      cardImage: "assets/img/Pastevents/07-05-2019.jpg",
      header: "NIMS Medicity free Mega Medical Camp",
      location: "Attinppuram, Ariyanadu",
      date: "07/05/2019",
      discription:
        "NIMS Medicity Free Medical Camp @ Attinppuram, Ariyanadu. Associated With Jawahar Balajena Vethi & Entey Nadu Uzhamalaikkal.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/05-05-2019.jpg",
      header: "NIMS Medicity free Mega Medical Camp",
      location: "Meenakshipuram, Ooruttambalam",
      date: "05/05/2019",
      discription:
        "NIMS Medicity Free Medical Camp @ Meenakshipuram, Ooruttambalam. Associated With Sree Moorthi Bhagavathi Temple Trust Meenakshipuram.",
      shortNote: "",
      imageCollection: [],
    },

    {
      cardImage: "assets/img/Pastevents/03-05-2019.jpg",
      header: "NIMS Medicity free Mega Medical Camp",
      location: "Kanjiramkkulam",
      date: "03/05/2019",
      discription:
        "NIMS Medicity Free Medical Camp @ Kanjiramkkulam. Associated With Student Police Cadet, Thiruvananthapuram Rural Training Camp.",
      shortNote: "",
      imageCollection: [],
    },

    {
      cardImage: "assets/img/Pastevents/29-04-2019.jpg",
      header: "NIMS Medicity free Mega Medical Camp",
      location: "Pallisserey, Bharanikkavu",
      date: "29/04/2019",
      discription:
        "NIMS Medicity Mega Medical Camp@ Pallisserey, Bharanikkavu, Kollam. Associated With Pallisserikkal Muslim Juma-ath.",
      shortNote: "",
      imageCollection: [],
    },

    {
      cardImage: "assets/img/Pastevents/26-04-2019.jpg",
      header: "NIMS Medicity free Mega Medical Camp",
      location: "Chullalam, Pallimukku",
      date: "26/04/2019",
      discription:
        "NIMS Medicity Free Medical Camp @ Chullalam, Pallimukku. Associated With Palakkonam Muheeyudheen Masjid & Kmyf Kaniv Unit.",
      shortNote: "",
      imageCollection: [],
    },

    {
      cardImage: "assets/img/Pastevents/21-04-2019.jpg",
      header: "NIMS Medicity free Mega Medical Camp",
      location: "Keezhammakam, Poozhikunnu",
      date: "21/04/2019",
      discription:
        "NIMS Medicity Free Medical Camp @ Keezhammakam, Poozhikunnu. Associated With Sree Sivashakthi Maha Ganapathi Temple Trust Keezhammakam.",
      shortNote: "",
      imageCollection: [],
    },

    {
      cardImage: "assets/img/Pastevents/16-04-2019.jpg",
      header: "NIMS Medicity free Mega Medical Camp",
      location: "Choozhattukotta",
      date: "16/04/2019",
      discription:
        "Nims Medicity Free Medical Camp @ Choozhattukotta. Associated With Sree Durga Devi Temple Trust Choozhattukotta.",
      shortNote: "",
      imageCollection: [],
    },

    {
      cardImage: "assets/img/Pastevents/12-04-2019.jpg",
      header: "NIMS Medicity free Mega Medical Camp",
      location: "Kattunada, Mangalathukonam.",
      date: "12/04/2019",
      discription:
        "NIMS Medicity Free Medical Camp @ Kattunada, Mangalathukonam. Associated With Mangalathukonam Kattunada Sree Bhadrakali Temple Trust.",
      shortNote: "",
      imageCollection: [],
    },

    {
      cardImage: "assets/img/Pastevents/07-04-2019.jpg",
      header: "NIMS Medicity free Mega Medical Camp",
      location: "Nalam Kallu, Pachalloor",
      date: "07/04/2019",
      discription:
        "NIMS Medicity Free Mega Medical Camp @ Nalam Kallu, Pachalloor. Associated With Swanthanam Charitable Society Pachalloor.",
      shortNote: "",
      imageCollection: [],
    },

    {
      cardImage: "assets/img/Pastevents/05-04-2019.jpg",
      header: "NIMS Medicity free Mega Medical Camp",
      location: "Kollamcode",
      date: "05/04/2019",
      discription:
        "NIMS Medicity Free Medical Camp @ Kollamcode. Associated With Sree Bhadrakali Temple Trust Kollamcode",
      shortNote: "",
      imageCollection: [],
    },

    {
      cardImage: "assets/img/Pastevents/01-04-2019.jpg",
      header: "NIMS Medicity free Mega Medical Camp",
      location: "Mariyagiri, Kaliyakkavilai",
      date: "01/04/2019",
      discription:
        "NIMS Medicity Free Medical Camp @ Mariyagiri, Kaliyakkavilai. Associated With Malakkara Catholic College Kaliyakkavilai.",
      shortNote: "",
      imageCollection: [],
    },

    {
      cardImage: "assets/img/Pastevents/29-03-2019.jpg",
      header: "NIMS Medicity free Mega Medical Camp",
      location: "Kollam",
      date: "29/03/2019",
      discription:
        "NIMS Medicity Free Medical Camp @ Kollam. Associated With Idfc Bharath Financial Enterprises Ltd, Kollam Town Branch.",
      shortNote: "",
      imageCollection: [],
    },

    {
      cardImage: "assets/img/Pastevents/23-03-2019.jpg",
      header: "NIMS Medicity free Mega Medical Camp",
      location: "Kariyara, Punalur",
      date: "23/03/2019",
      discription:
        "NIMS Medicity Free Mega Medical Camp @ Kariyara, Punalur. Associated With Govt Lps Kariyara, Old Students Association & Pta.",
      shortNote: "",
      imageCollection: [],
    },

    {
      cardImage: "assets/img/Pastevents/20-03-2019.jpg",
      header: "NIMS Medicity free Mega Medical Camp",
      location: "Karikkakam, Chakka",
      date: "20/03/2019",
      discription:
        "NIMS Medicity Free Medical Camp @ Karikkakam, Chakka. Associated With Sree Karikkakathamma Seva Samithi, Karikkakam.",
      shortNote: "",
      imageCollection: [],
    },

    {
      cardImage: "assets/img/Pastevents/18-03-2019.jpg",
      header: "NIMS Medicity free Mega Medical Camp",
      location: "Pacha, Palode",
      date: "18/03/2019",
      discription:
        "Nims Medicity Free Medical Camp @ Pacha, Palode. Associated With Sree Dharma Sastha Temple Trust Pacha, Palode.",
      shortNote: "",
      imageCollection: [],
    },

    {
      cardImage: "assets/img/Pastevents/14-03-2019.jpg",
      header: "NIMS Medicity free Mega Medical Camp",
      location: "Perumpazhuthoor",
      date: "14/03/2019",
      discription:
        "Nims Medicity Free Medical Camp @ Perumpazhuthoor. Associated With Malakkara Catholic Association Neyyattinkara.",
      shortNote: "",
      imageCollection: [],
    },

    {
      cardImage: "assets/img/Pastevents/10-03-2019.jpg",
      header: "NIMS Medicity free Mega Medical Camp",
      location: "Poozhanadu",
      date: "10/03/2019",
      discription:
        "Nims Medicity Free Medical Camp @ Poozhanadu. Associated With Senior Citizens Association Tvm, Sree Ramakrishna Mission & Vivekananda Study Circle Kadambra.",
      shortNote: "",
      imageCollection: [],
    },

    {
      cardImage: "assets/img/Pastevents/05-03-2019.jpg",
      header: "NIMS Medicity free Mega Medical Camp",
      location: "Panavoor",
      date: "05/03/2019",
      discription:
        "Nims Medicity Free Medical Camp @ Panavoor. Associated With Muslim Association College Of Arts And Science, Panavoor.",
      shortNote: "",
      imageCollection: [],
    },

    {
      cardImage: "assets/img/Pastevents/01-03-2019.jpg",
      header: "NIMS Medicity free Mega Medical Camp",
      location: "",
      date: "01/03/2019",
      discription:
        "Nethra Charitable society, Neyyattinkara in association with NIMS Medicity organized Mega medical camp and distribution of free treatment fund to the needy patients of Neyyattinkara on 28-02-2019. The medical camp was inaugurated by Dr. Shashi Tharoor, MP of Thiruvananthapuram and Mr M.S. Faizal Khan, Managing Director of NIMS Medicity inaugurated the distribution of the free treatment fund. Mr K. Ansalan, MLA of Neyyattinkara presided over the function.",
      shortNote: "",
      imageCollection: [],
    },

    {
      cardImage: "assets/img/Pastevents/27-02-2019.jpg",
      header: "NIMS Medicity free Mega Medical Camp",
      location: "Chenkal",
      date: "27/02/2019",
      discription:
        "Nims Medicity Free Medical Camp @ Chenkal. Associated With Sree Sivaparvathy Temple Trust Chenkal",
      shortNote: "",
      imageCollection: [],
    },

    {
      cardImage: "assets/img/Pastevents/25-02-2019.jpg",
      header: "NIMS Medicity free Mega Medical Camp",
      location: "Kanjirampara",
      date: "25/02/2019",
      discription:
        "Nims Medicity Free Medical Camp @ Kanjirampara. Associated With Koottayima Purusha Swayam Sangam, Kanjirampara.",
      shortNote: "",
      imageCollection: [],
    },

    {
      cardImage: "assets/img/Pastevents/20-02-2019.jpg",
      header: "NIMS Medicity free Mega Medical Camp",
      location: "Attukal Pongala Festival 2019",
      date: "20/02/2019",
      discription:
        "NIMS Medicity Mega Medical Camp @ Attukal Pongala Festival 2019. Associated With Eastfort Pourasamithi & Venpalavattom Sree Bhagavathi Temple Trust",
      shortNote: "",
      imageCollection: [],
    },

    {
      cardImage: "assets/img/Pastevents/14-02-2019.jpg",
      header: "NIMS Medicity free Mega Medical Camp",
      location: "Kannanthura, Shanghumukham",
      date: "14/02/2019",
      discription:
        "NIMS Medicity Free Medical Camp @ Kannanthura, Shanghumukham. Associated With Kannanthura Pravasi Welfare Association & Congress Kannanthura Forum.",
      shortNote: "",
      imageCollection: [],
    },

    {
      cardImage: "assets/img/Pastevents/10-02-2019.jpg",
      header: "NIMS Medicity free Mega Medical Camp",
      location: "Payattuvila",
      date: "10/02/2019",
      discription:
        "NIMS Medicity Free Medical Camp @ Payattuvila. Associated With Vivekananda Samskarika Vethi & Jeevadhayini 2019.",
      shortNote: "",
      imageCollection: [],
    },

    {
      cardImage: "assets/img/Pastevents/08-02-2019.jpg",
      header: "NIMS Medicity free Mega Medical Camp",
      location: "Njaraneeli Tribal Village",
      date: "08/02/2019",
      discription:
        "NIMS Medicity Free Medical Camp @ Njaraneeli Tribal Village. Associated With National Service Scheme, Govt College Nedumangad",
      shortNote: "",
      imageCollection: [],
    },

    {
      cardImage: "assets/img/Pastevents/04-02-2019.jpg",
      header: "NIMS Medicity free Mega Medical Camp",
      location: "Keezheychenkal",
      date: "04/02/2019",
      discription:
        "NIMS Medicity free Medical Camp @ Keezheychenkal Associated with Anjaneya Grama Seva Samithi Chenkal.",
      shortNote: "",
      imageCollection: [],
    },

    {
      cardImage: "assets/img/Pastevents/02-02-2019.jpg",
      header: "NIMS Medicity free Mega Medical Camp",
      location: "Kodagavila",
      date: "02/02/2019",
      discription:
        "NIMS Medicity free Medical Camp @ Kodagavila. Associated with Sarada Nivas Grandhasala, Kodagavila.",
      shortNote: "",
      imageCollection: [],
    },

    {
      cardImage: "assets/img/Pastevents/26-01-2019.jpg",
      header: "NIMS Medicity free Mega Medical Camp",
      location: "Pazhayakada",
      date: "26/01/2019",
      discription:
        "NIMS Medicity in Association with Chathinar Sree Durga Devi Temple Trust Pazhayakada organized a blood donation camp today (26th January 2019). This is the first time the nims blood bank team is organizing the camp at a site outside nims campus. Managing director of NIMS Medicity MR. M S Faizal khan was honored by MR K Ansalan, the MLA of Neyyattinkara during the occasion.",
      shortNote: "",
      imageCollection: [],
    },

    {
      cardImage: "assets/img/Pastevents/23-01-2019.jpg",
      header: "NIMS Medicity free Mega Medical Camp",
      location: "Vallukkottukkonam",
      date: "23/01/2019",
      discription:
        "NIMS Medicity Free Medical camp @ Vallukkottukkonam, Udayankulangara. Associated with Elankam Sree Bhagavathi Temple Trust.",
      shortNote: "",
      imageCollection: [],
    },
    {
      cardImage: "assets/img/Pastevents/20-01-2019.jpg",
      header: "NIMS Medicity free Mega Medical Camp",
      location: "Paripally",
      date: "20/01/2019",
      discription:
        "NIMS Medicity Free Medical Camp @ Paripally, Kollam. Associated With Idfc Bharath Financial Enterprises Ltd.",
      shortNote: "",
      imageCollection: [],
    },

    {
      cardImage: "assets/img/Pastevents/14-01-2019.jpg",
      header: "NIMS Medicity free Mega Medical Camp",
      location: "Nochiyoor, Chenkal",
      date: "14/01/2019",
      discription:
        "NIMS Medicity Free Medical Camp @ Nochiyoor, Chenkal. Associated With Sree Pulikottukandan Sastha Temple Trust Chenkal.",
      shortNote: "",
      imageCollection: [],
    },

    {
      cardImage: "assets/img/Pastevents/11-01-2019.jpg",
      header: "NIMS Medicity free Mega Medical Camp",
      location: "Kulappara, Panachamoodu",
      date: "11/01/2019",
      discription:
        "NIMS Medicity Free Medical Camp @ Kulappara, Panachamoodu. Associated With St Joseph M S C Middle School Kulappara.",
      shortNote: "",
      imageCollection: [],
    },

    {
      cardImage: "assets/img/Pastevents/07-01-2019.jpg",
      header: "NIMS Medicity free Mega Medical Camp",
      location: "Peyathumpara, Vithura",
      date: "07/01/2019",
      discription:
        "NIMS Medicity Free Medical Camp @ Peyathumpara, Vithura. Associated With Peyathumpara Residential Association Vithura.",
      shortNote: "",
      imageCollection: [],
    },

    {
      cardImage: "assets/img/Pastevents/01-01-2019.jpg",
      header: "NIMS Medicity free Mega Medical Camp",
      location: "Nemom",
      date: "01/01/2019",
      discription:
        "NIMS Medicity Free Medical Camp @ Nemom. Associated With Prasad Nagar Residential Association Nemom.",
      shortNote: "",
      imageCollection: [],
    },

    {
      cardImage: "assets/img/Pastevents/nophoto.jpg",
      header: "NIMS Medicity free Mega Medical Camp",
      location: "vizhinjam",
      date: "30/09/2019",
      discription:
        "NIMS Medicity Free Medical Camp @vizhinjam. Associated With Lions Club International Kovalam Unit And Ima Thiruvananthapuram.",
      shortNote: "",
      imageCollection: [],
    },

    {
      cardImage: "assets/img/Pastevents/nophoto.jpg",
      header: "NIMS Medicity free Mega Medical Camp",
      location: "Pattoor",
      date: "28/09/2019",
      discription:
        "NIMS Medicity Mega Medical Camp@ Pattoor. Associated With As Pharma Care, Pattoor.",
      shortNote: "",
      imageCollection: [],
    },
  ];
}
